(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ss/mtd-vue"), require("@mcfe/tools"), require("@vue/composition-api"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@ss/mtd-vue", "@mcfe/tools", "@vue/composition-api", "vue"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@ss/mtd-vue"), require("@mcfe/tools"), require("@vue/composition-api"), require("vue")) : factory(root["@ss/mtd-vue"], root["@mcfe/tools"], root["@vue/composition-api"], root["vue"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__6a79__, __WEBPACK_EXTERNAL_MODULE__7196__, __WEBPACK_EXTERNAL_MODULE__8165__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "41f5");
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0061":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3e6c"),
    isLength = __webpack_require__("f68e"),
    isObjectLike = __webpack_require__("b5d6");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "00dc":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__("58a2")
var primes = __webpack_require__("c24d")

var DH = __webpack_require__("561d")

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "010e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ "0145":
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ "014b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("e53d");
var has = __webpack_require__("07e3");
var DESCRIPTORS = __webpack_require__("8e60");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var META = __webpack_require__("ebfd").KEY;
var $fails = __webpack_require__("294c");
var shared = __webpack_require__("dbdb");
var setToStringTag = __webpack_require__("45f2");
var uid = __webpack_require__("62a0");
var wks = __webpack_require__("5168");
var wksExt = __webpack_require__("ccb9");
var wksDefine = __webpack_require__("6718");
var enumKeys = __webpack_require__("47ee");
var isArray = __webpack_require__("9003");
var anObject = __webpack_require__("e4ae");
var isObject = __webpack_require__("f772");
var toObject = __webpack_require__("241e");
var toIObject = __webpack_require__("36c3");
var toPrimitive = __webpack_require__("1bc3");
var createDesc = __webpack_require__("aebd");
var _create = __webpack_require__("a159");
var gOPNExt = __webpack_require__("0395");
var $GOPD = __webpack_require__("bf0b");
var $GOPS = __webpack_require__("9aa9");
var $DP = __webpack_require__("d9f6");
var $keys = __webpack_require__("c3a1");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("6abf").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("355d").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("b8e3")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("35e8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "014d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("fa49");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),

/***/ "0184":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("da3e");

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ "0196":
/***/ (function(module, exports, __webpack_require__) {

const encodeUtf8 = __webpack_require__("58b4")
const Mode = __webpack_require__("bbf0")

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    data = encodeUtf8(data)
  }
  this.data = new Uint8Array(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),

/***/ "0197":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("05d5"),
    mapCacheDelete = __webpack_require__("f07f"),
    mapCacheGet = __webpack_require__("7ded"),
    mapCacheHas = __webpack_require__("6ae2"),
    mapCacheSet = __webpack_require__("ad15");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "0211":
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__("8b71");


/***/ }),

/***/ "0293":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("241e");
var $getPrototypeOf = __webpack_require__("53e2");

__webpack_require__("ce7e")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "02fb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0395":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("36c3");
var gOPN = __webpack_require__("6abf").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "03ec":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ "0425":
/***/ (function(module, exports) {

const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),

/***/ "04a2":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "0558":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ "05d5":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("6e77"),
    ListCache = __webpack_require__("ff45"),
    Map = __webpack_require__("54d8");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "061b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("fa99");

/***/ }),

/***/ "0706":
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),

/***/ "0721":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ "0783":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-categoryselect/mc-categoryselect.vue?vue&type=template&id=731709d6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mc-tree-select',_vm._g(_vm._b({ref:"treeSelectRef",staticClass:"mc-categoryselect",attrs:{"data":_vm.showData,"disabled":_vm.disabled,"readonly":_vm.readonly,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"only-leaf":_vm.leafOnly,"editable-method":_vm.isSelectLevel},on:{"change":_vm.handleChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-tree-select',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-categoryselect/mc-categoryselect.vue?vue&type=template&id=731709d6&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__("a8db");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-categoryselect/mc-categoryselect.vue?vue&type=script&lang=js&












function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_categoryselectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McCategoryselect',
  props: {
    value: {
      type: [Number, String, Array],
      default: function _default() {
        return [];
      }
    },
    // 默认后台品类
    useBgCategory: {
      type: Boolean,
      default: true
    },
    // 是否是多选模式
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 设置禁止选择的项的 id 数组
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择商品品类'
    },
    // 最多显示的层级
    maxLevel: {
      type: Number,
      default: Infinity
    },
    // 可以选中的层级
    selectLevel: {
      type: [Number, String, Array],
      default: function _default() {
        return [];
      }
    },
    // 是否展示品类id
    showCategoryId: {
      type: Boolean,
      default: false
    },
    // 品类数据是否带权限，管理品类和后台品类都适用
    usePermission: {
      type: Boolean,
      default: true
    },
    // 是否只允许选择叶子节点
    leafOnly: {
      type: Boolean,
      default: false
    },
    // 区分经营商品还是物资（管理和后台品类都适用）
    categoryType: {
      type: Number,
      default: 0 // 0全部/1经营品/2物资

    },
    // 系统来源 jiemo | vss | lps ...
    source: {
      type: String,
      default: 'jiemo'
    },
    // 额外请求品类接口的参数
    extraParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 返回值处理
    responseProcessor: {
      type: Function,
      default: null
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var treeSelectRef = Object(composition_api_["ref"])(null);

    var getReqInfo = function getReqInfo() {
      var useBgCategory = props.useBgCategory,
          categoryType = props.categoryType,
          usePermission = props.usePermission,
          extraParams = props.extraParams;
      var cateType = useBgCategory ? 'bgCate' : 'mgCate';
      var reqMap = {
        jiemo: {
          mgCate: {
            url: '/shepherd/product/category/queryWithPermission',
            body: {
              categoryType: categoryType,
              usePermission: usePermission
            }
          },
          bgCate: {
            url: usePermission ? '/shepherd/product/bgcategory/queryWithPermission' : '/shepherd/product/bgcategory/query',
            body: {
              categoryType: categoryType
            }
          }
        },
        vss: {
          mgCate: {
            url: '/api/vss/shepherd/product/queryCapableCategoryList',
            body: _objectSpread({
              categoryType: categoryType
            }, extraParams)
          },
          bgCate: {
            url: '/api/vss/shepherd/product/bgcategory/query',
            body: {
              categoryType: categoryType
            }
          }
        }
      };
      var _reqMap$props$source$ = reqMap[props.source][cateType],
          url = _reqMap$props$source$.url,
          body = _reqMap$props$source$.body;
      return {
        url: url,
        body: body
      };
    };

    var judgeItemDisabled = function judgeItemDisabled(item) {
      var isDisabled = false;

      if (props.disabledIds && props.disabledIds.includes(item.id)) {
        isDisabled = true;
      }

      return isDisabled;
    }; // 控制层级是否可以选择


    var isSelectLevel = function isSelectLevel(node) {
      var selectLevel = props.selectLevel;
      var level = Number(node.level);

      if (!selectLevel || !selectLevel.length) {
        return true;
      }

      if (Array.isArray(selectLevel)) {
        return selectLevel.indexOf(level) > -1;
      }

      if (typeof selectLevel === 'number' || typeof selectLevel === 'string') {
        return Number(selectLevel) === level;
      }

      return true;
    };

    var data = Object(composition_api_["reactive"])({
      innerValue: Object(composition_api_["computed"])({
        get: function get() {
          return props.value;
        },
        set: function set(val) {
          emit('input', val);
        }
      }),
      categoryData: [],
      showData: Object(composition_api_["computed"])(function () {
        return data.categoryData.filter(function (item) {
          return !props.maxLevel || item.level <= props.maxLevel;
        }).map(function (item) {
          // 设置禁用
          item.disabled = judgeItemDisabled(item);
          return item;
        });
      })
    });
    var listeners = Object(composition_api_["computed"])(function () {
      var _proxy$$listeners = proxy.$listeners,
          change = _proxy$$listeners.change,
          others = Object(objectWithoutProperties["a" /* default */])(_proxy$$listeners, ["change"]);

      return others;
    });

    var handleChange = function handleChange(val, item) {
      emit('change', val, item);
    };

    var handleData = function handleData(res) {
      var innerData = res.map(function (item) {
        var id = item.id || item.categoryId;
        var prefix = props.showCategoryId ? "".concat(id, "-") : '';
        var name = "".concat(prefix).concat(item.categoryName || item.name);
        return _objectSpread({}, item, {
          id: id,
          name: name,
          description: item.categoryDescription,
          parentId: item.parentId
        });
      });
      data.categoryData = innerData;
      emit('loaded', innerData);
    };

    var getAllCategoryList =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _getReqInfo, url, body, res, resData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getReqInfo = getReqInfo(), url = _getReqInfo.url, body = _getReqInfo.body;
                _context.next = 3;
                return proxy.$hPost(url, body, {
                  cache: true
                }).catch(function () {
                  return [];
                });

              case 3:
                res = _context.sent;
                resData = res;

                if (!(props.responseProcessor && typeof props.responseProcessor === 'function')) {
                  _context.next = 12;
                  break;
                }

                _context.next = 8;
                return props.responseProcessor(res);

              case 8:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.t0 = [];

              case 11:
                resData = _context.t0;

              case 12:
                handleData(resData);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getAllCategoryList() {
        return _ref2.apply(this, arguments);
      };
    }();

    getAllCategoryList();
    Object(composition_api_["watch"])(function () {
      return props.categoryType;
    }, function () {
      getAllCategoryList();
    }); // 对外 清空方法

    var clearValue = function clearValue() {
      treeSelectRef.value.clearValue();
    }; // 对外 全选方法


    var selectAll = function selectAll() {
      treeSelectRef.value.selectAll();
    }; // 对外 获取已选择tag


    var getSelectedTags = function getSelectedTags() {
      treeSelectRef.value.getSelectedTags();
    }; // 对外 获取已选择value


    var getSelectedValue = function getSelectedValue() {
      treeSelectRef.value.getSelectedTags();
    };

    return _objectSpread({}, Object(composition_api_["toRefs"])(data), {
      treeSelectRef: treeSelectRef,
      listeners: listeners,
      handleChange: handleChange,
      isSelectLevel: isSelectLevel,
      clearValue: clearValue,
      selectAll: selectAll,
      getSelectedTags: getSelectedTags,
      getSelectedValue: getSelectedValue
    });
  }
}));
// CONCATENATED MODULE: ./components/mc-categoryselect/mc-categoryselect.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_categoryselect_mc_categoryselectvue_type_script_lang_js_ = (mc_categoryselectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-categoryselect/mc-categoryselect.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_categoryselect_mc_categoryselectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_categoryselect = (component.exports);
// CONCATENATED MODULE: ./components/mc-categoryselect/index.js


/* istanbul ignore next */

mc_categoryselect.install = function (Vue) {
  Vue.component(mc_categoryselect.name, mc_categoryselect);
};

/* harmony default export */ var components_mc_categoryselect = __webpack_exports__["default"] = (mc_categoryselect);

/***/ }),

/***/ "079e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ "07df":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ITF2 = __webpack_require__("3c7c");

var _ITF3 = _interopRequireDefault(_ITF2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Calculate the checksum digit
var checksum = function checksum(data) {
	var res = data.substr(0, 13).split('').map(function (num) {
		return parseInt(num, 10);
	}).reduce(function (sum, n, idx) {
		return sum + n * (3 - idx % 2 * 2);
	}, 0);

	return Math.ceil(res / 10) * 10 - res;
};

var ITF14 = function (_ITF) {
	_inherits(ITF14, _ITF);

	function ITF14(data, options) {
		_classCallCheck(this, ITF14);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{13}$/) !== -1) {
			data += checksum(data);
		}
		return _possibleConstructorReturn(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
	}

	_createClass(ITF14, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
		}
	}]);

	return ITF14;
}(_ITF3.default);

exports.default = ITF14;

/***/ }),

/***/ "07e3":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "07f2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var SHA256 = __webpack_require__("6eed");

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ "0829":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "087f":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__("3fb5")
var Hash = __webpack_require__("b672")
var Buffer = __webpack_require__("8707").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ "0917":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-progress/mc-progress.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_progressvue_type_script_lang_js_ = ({
  name: 'McProgress',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-progress', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-progress/mc-progress.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_progress_mc_progressvue_type_script_lang_js_ = (mc_progressvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-progress/mc-progress.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_progress_mc_progressvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_progress = (component.exports);
// CONCATENATED MODULE: ./components/mc-progress/index.js


/* istanbul ignore next */

mc_progress.install = function (Vue) {
  Vue.component(mc_progress.name, mc_progress);
};

/* harmony default export */ var components_mc_progress = __webpack_exports__["default"] = (mc_progress);

/***/ }),

/***/ "0940":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-notification/mc-notification.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_notificationvue_type_script_lang_js_ = ({
  name: 'McNotification',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-notification', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-notification/mc-notification.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_notification_mc_notificationvue_type_script_lang_js_ = (mc_notificationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-notification/mc-notification.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_notification_mc_notificationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_notification = (component.exports);
// CONCATENATED MODULE: ./components/mc-notification/index.js


/* istanbul ignore next */

mc_notification.install = function (Vue) {
  Vue.component(mc_notification.name, mc_notification);
};

/* harmony default export */ var components_mc_notification = __webpack_exports__["default"] = (mc_notification);

/***/ }),

/***/ "0960":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("b19a");


/***/ }),

/***/ "097d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var speciesConstructor = __webpack_require__("ebd6");
var promiseResolve = __webpack_require__("bcaa");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "09bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7f7f");
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mc_image_preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1062");


/* istanbul ignore next */

_mc_image_preview__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].install = function (Vue) {
  Vue.component(_mc_image_preview__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].name, _mc_image_preview__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_mc_image_preview__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

/***/ }),

/***/ "09eb":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "09f5":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("39f5")
var Buffer = __webpack_require__("8707").Buffer
var Transform = __webpack_require__("6430")
var inherits = __webpack_require__("3fb5")

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ "0a3c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ "0a49":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("9b43");
var IObject = __webpack_require__("626a");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var asc = __webpack_require__("cd1c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "0a84":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ "0ad2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-user-select/mc-user-select.vue?vue&type=template&id=5bf5a5f4&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-user--select"},[_c('mc-select',_vm._b({ref:"seletRef",attrs:{"source":_vm.source,"size":_vm.size,"filterable":true,"multiple":_vm.multiple,"clearable":_vm.clearable,"reserve-keyword":_vm.reserveKeyword,"placeholder":_vm.placeholder,"readonly":_vm.readonly},on:{"change":_vm.changeUser},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-select',_vm.$attrs,false),[(_vm.slots.empty)?_c('template',{slot:"empty"},[_vm._t("empty")],2):_vm._e(),(_vm.slots.loading)?_c('template',{slot:"loading"},[_vm._t("loading")],2):_vm._e()],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-user-select/mc-user-select.vue?vue&type=template&id=5bf5a5f4&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-user-select/mc-user-select.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_user_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McUserSelect',
  props: {
    value: {
      type: [Number, String, Array],
      default: ''
    },
    // 员工类型 1(内部员工)、2（门店员工）
    userType: {
      Number: Number
    },
    // 组织id
    orgId: {
      type: Number,
      default: -1
    },
    limit: {
      type: Number,
      default: 100
    },
    multiple: {
      type: Boolean,
      default: false
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入mis号或姓名'
    },
    responseProcessor: Function
  },
  setup: function setup(props, ctx) {
    var seletRef = Object(composition_api_["ref"])(null);
    var innerValue = Object(composition_api_["ref"])(props.value);

    var buildParams = function buildParams(params, extendsParams) {
      if (extendsParams.query) {
        params.keyword = extendsParams.query;
      } else if (props.value) {
        if (typeof props.value === 'string') {
          params.keyword = props.value;
        } else if (Array.isArray(props.value) && props.value.length) {
          params.keyword = props.value.join(',');
        }
      }

      if (props.userType) {
        params.type = props.userType;
      }

      return params;
    };

    var responseProcessor = function responseProcessor(res) {
      var _ref = res || {},
          data = _ref.data;

      if (props.responseProcessor && typeof props.responseProcessor === 'function') {
        data = props.responseProcessor(data);
      }

      var users = (data || []).map(function (item) {
        return _objectSpread({}, item, {
          name: item.name,
          mis: item.enNameCn,
          id: item.uid,
          type: item.type === 'INSIDE' ? 1 : 2,
          isHT: item.tenantId !== 1,
          value: item.enNameCn,
          label: "".concat(item.name, "(").concat(item.enNameCn, ")")
        });
      });
      ctx.emit('loaded', users);
      return users;
    };

    var source = Object(composition_api_["reactive"])({
      ajax: {
        type: 'hPost',
        url: '/api/auth/tEmp/listEmp',
        params: {
          keyword: '',
          // 模糊搜索关键字，支持中文和拼音
          status: 1,
          // 员工状态 1（在职)、2（离职）
          orgId: props.orgId,
          // 组织id
          posId: -1,
          // 所在岗位ID，-1：所有岗位
          offset: 0,
          // 分页参数
          limit: props.limit // 分页参数

        },
        options: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
          }
        }
      },
      responseProcessor: responseProcessor,
      buildParams: buildParams
    });

    var changeUser = function changeUser(userIds, item) {
      ctx.emit('input', userIds);
      ctx.emit('change', userIds, item);
    };

    var reset = function reset() {
      seletRef.value.reset();
    };

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val;
    }, {
      immediate: true
    });
    return {
      seletRef: seletRef,
      innerValue: innerValue,
      source: source,
      changeUser: changeUser,
      reset: reset,
      slots: ctx.slots
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-user-select/mc-user-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_user_select_mc_user_selectvue_type_script_lang_js_ = (mc_user_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-user-select/mc-user-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_user_select_mc_user_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_user_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-user-select/index.js


/* istanbul ignore next */

mc_user_select.install = function (Vue) {
  Vue.component(mc_user_select.name, mc_user_select);
};

/* harmony default export */ var components_mc_user_select = __webpack_exports__["default"] = (mc_user_select);

/***/ }),

/***/ "0be8":
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0caa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ "0cbb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__("7d92");
var curve = __webpack_require__("4136");
var utils = __webpack_require__("f3a3");

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__("409b");
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),

/***/ "0ce7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-main/mc-main.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_mainvue_type_script_lang_js_ = ({
  name: 'McMain',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-main', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-main/mc-main.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_main_mc_mainvue_type_script_lang_js_ = (mc_mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-main/mc-main.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_main_mc_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_main = (component.exports);
// CONCATENATED MODULE: ./components/mc-main/index.js


/* istanbul ignore next */

mc_main.install = function (Vue) {
  Vue.component(mc_main.name, mc_main);
};

/* harmony default export */ var components_mc_main = __webpack_exports__["default"] = (mc_main);

/***/ }),

/***/ "0d00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key), content = self.content.slice();
    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key);
    if (found == -1) return this
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this;
    map = OrderedMap.from(map);
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i]);
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
};

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content)
};

/* harmony default export */ __webpack_exports__["default"] = (OrderedMap);


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "0d6d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("d3f4");
var meta = __webpack_require__("67ab").onFreeze;

__webpack_require__("5eda")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "0da4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("da3e");
var inherits = __webpack_require__("3fb5");

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ "0de1":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("ff45"),
    stackClear = __webpack_require__("70db"),
    stackDelete = __webpack_require__("3da8"),
    stackGet = __webpack_require__("6fde"),
    stackHas = __webpack_require__("b822"),
    stackSet = __webpack_require__("791b");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "0e49":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ "0e6b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ "0e81":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ "0e8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tab-drop/mc-tab-drop.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_tab_dropvue_type_script_lang_js_ = ({
  name: 'McTabDrop',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-tab-drop', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-tab-drop/mc-tab-drop.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tab_drop_mc_tab_dropvue_type_script_lang_js_ = (mc_tab_dropvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tab-drop/mc-tab-drop.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tab_drop_mc_tab_dropvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tab_drop = (component.exports);
// CONCATENATED MODULE: ./components/mc-tab-drop/index.js


/* istanbul ignore next */

mc_tab_drop.install = function (Vue) {
  Vue.component(mc_tab_drop.name, mc_tab_drop);
};

/* harmony default export */ var components_mc_tab_drop = __webpack_exports__["default"] = (mc_tab_drop);

/***/ }),

/***/ "0eb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-header/mc-header.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_headervue_type_script_lang_js_ = ({
  name: 'McHeader',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-header', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-header/mc-header.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_header_mc_headervue_type_script_lang_js_ = (mc_headervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-header/mc-header.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_header_mc_headervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_header = (component.exports);
// CONCATENATED MODULE: ./components/mc-header/index.js


/* istanbul ignore next */

mc_header.install = function (Vue) {
  Vue.component(mc_header.name, mc_header);
};

/* harmony default export */ var components_mc_header = __webpack_exports__["default"] = (mc_header);

/***/ }),

/***/ "0eef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-print-template/mc-print-template.vue?vue&type=template&id=03caad3b&
var mc_print_templatevue_type_template_id_03caad3b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-print-template"},[_c('div',{ref:"printContent",staticClass:"mc-print-template-content xx-print-content"},[_vm._t("prepend"),_vm._t("default",function(){return [_c('table',_vm._b({staticClass:"mc-print-template-content-table"},'table',_vm.$attrs,false),_vm._l((_vm.tableConfig),function(bodyItem,index){return _c('tbody',{key:index},[_vm._l((bodyItem.headerConfig),function(item,_index){return _c('tr',{key:(index + "#" + _index)},_vm._l((item),function(v,__index){return _c('th',_vm._b({key:(index + "#" + _index + "#" + __index)},'th',_vm.removeProperties(v, _vm.tdProperties.concat(['id', 'options'])),false),[_c('cell',{ref:"cell",refInFor:true,attrs:{"data":_vm.reserveProperties(v, _vm.tdProperties),"td-data":v,"detail-info":_vm.detailInfo,"slots":_vm.$slots}})],1)}),0)}),_vm._l((bodyItem.bodyConfig),function(item,_index){return _c('tr',{key:(index + "&" + _index)},_vm._l((item),function(v,__index){return _c('td',_vm._b({key:(index + "&" + _index + "&" + __index)},'td',_vm.removeProperties(v, _vm.tdProperties.concat(['id', 'options'])),false),[_c('cell',{ref:"cell",refInFor:true,attrs:{"data":_vm.reserveProperties(v, _vm.tdProperties),"td-data":v,"detail-info":_vm.detailInfo,"slots":_vm.$slots}})],1)}),0)})],2)}),0)]}),_vm._t("append")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-print-template/mc-print-template.vue?vue&type=template&id=03caad3b&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("768b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__("ffc1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.freeze.js
var es6_object_freeze = __webpack_require__("0d6d");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/jsbarcode/bin/JsBarcode.js
var JsBarcode = __webpack_require__("62c5");
var JsBarcode_default = /*#__PURE__*/__webpack_require__.n(JsBarcode);

// EXTERNAL MODULE: ./node_modules/qrcode/lib/browser.js
var browser = __webpack_require__("d055");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-print-template/components/Cell.vue?vue&type=script&lang=js&









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var getPropByPath = function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');
  var keyArr = path.split('.');
  var i = 0;

  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];

    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('请确保传入的属性路径是正确的!');
      }

      break;
    }
  }

  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

/* harmony default export */ var Cellvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'Cell',
  props: {
    data: {
      type: Object,
      required: true
    },
    tdData: {
      type: Object,
      required: true
    },
    detailInfo: {
      type: Object,
      required: true
    },
    slots: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup() {
    var barcode = Object(composition_api_["ref"])(null);
    var qrcode = Object(composition_api_["ref"])(null);

    var createBarcode = function createBarcode() {
      var el = barcode.value;

      try {
        if (Array.isArray(el)) {
          el.forEach(function (item) {
            JsBarcode_default()("#".concat(item.getAttribute('id')), item.getAttribute('code'), JSON.parse(item.getAttribute('options') || {}));
          });
        } else if (el) {
          JsBarcode_default()("#".concat(el.getAttribute('id')), el.getAttribute('code'), JSON.parse(el.getAttribute('options') || {}));
        }
      } catch (e) {
        console.error(e);
      }
    };

    var createQrCode = function createQrCode() {
      var el = qrcode.value;

      try {
        if (Array.isArray(el)) {
          el.forEach(function (item) {
            browser_default.a.toCanvas(item, item.getAttribute('code'), JSON.parse(item.getAttribute('options') || {}));
          });
        } else if (el) {
          browser_default.a.toCanvas(el, el.getAttribute('code'), JSON.parse(el.getAttribute('options') || {}));
        }
      } catch (e) {
        console.error(e);
      }
    };

    var createCode = function createCode() {
      createBarcode();
      createQrCode();
    };

    return {
      createCode: createCode,
      barcode: barcode,
      qrcode: qrcode
    };
  },
  render: function render(h) {
    var _this = this;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        $set = _getCurrentInstance.proxy.$set;

    var dataArr = Object.entries(this.data);
    return h("div", [dataArr.map(function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (key === 'slot' && _this.slots[value]) {
        return _this.slots[value];
      }

      if (key === 'text') {
        return h("span", [value]);
      }

      if (key === 'code') {
        var type = _this.tdData.type || 'qr';

        if (type === 'qr') {
          return h("canvas", {
            "ref": "qrcode",
            "attrs": {
              "id": _this.tdData.id,
              "width": _this.tdData.width || '100%',
              "height": _this.tdData.height || '100%',
              "options": JSON.stringify(_this.tdData.options || {}),
              "code": value
            }
          });
        }

        if (type === 'bar') {
          return h("svg", {
            "ref": "barcode",
            "attrs": {
              "id": _this.tdData.id,
              "width": _this.tdData.width || '100%',
              "height": _this.tdData.height || '100%',
              "options": JSON.stringify(_this.tdData.options || {}),
              "code": value
            }
          });
        }
      }

      if (key === 'path') {
        return h("img", {
          "attrs": {
            "width": _this.tdData.width || '100%',
            "height": _this.tdData.height || '100%',
            "src": value
          }
        });
      }

      if (key === 'template') {
        var tpl = value.tpl,
            attrs = value.attrs,
            events = value.events,
            config = value.config;
        var propValue = getPropByPath(_this.detailInfo, _this.data.prop || '');
        $set(propValue.o, propValue.k, propValue.v);

        if (tpl) {
          return h(tpl, _objectSpread({
            props: {
              value: propValue.o[propValue.k]
            },
            attrs: _objectSpread({}, attrs),
            on: _objectSpread({}, events, {
              input: function input(val) {
                propValue.o[propValue.k] = val;

                if (events && events.input && typeof events.input === 'function') {
                  events.input(val);
                }
              }
            })
          }, config));
        }
      } // prop必须在没有template的情况下才会生效


      if (key === 'prop' && !_this.data.template) {
        var _propValue = getPropByPath(_this.detailInfo, value || '');

        return h("span", [_propValue.v]);
      }

      return '';
    })]);
  }
}));
// CONCATENATED MODULE: ./components/mc-print-template/components/Cell.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Cellvue_type_script_lang_js_ = (Cellvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-print-template/components/Cell.vue
var Cell_render, Cell_staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_Cellvue_type_script_lang_js_,
  Cell_render,
  Cell_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Cell = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-print-template/mc-print-template.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var isPromise = function isPromise(P) {
  return P && P.then && typeof P.then === 'function';
};

/* harmony default export */ var mc_print_templatevue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McPrintTemplate',
  components: {
    Cell: Cell
  },
  props: {
    /**
     * @Desc: tableConfig中类型为prop的单元格内容取值的对象
     * @type {object} detailInfo
     */
    detailInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * @Desc: cellConfig
     * @typedef {object} cellConfig
     * @property {String} text
     * @property {String} prop
     * @property {String} path
     * @property {String} slot
     */

    /**
     * @Desc: tbodyConfig
     * @typedef {object} tbodyConfig
     * @property {cellConfig[]} headerConfig
     * @property {cellConfig[]} bodyConfig
     */

    /**
     * @Desc: 使用表格配置时的表格配置
     * @type {tbodyConfig[]} tableConfig
     */
    tableConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * @Desc: 打印前的回调函数，用于做一些隐藏的打印元素被渲染之后的操作，当返回值为false时会中止打印
     * @type {function} beforePrint
     * @return {(boolean | undefined | promise)} 返回值为false时会中止打印，异步回调需要返回promise
     */
    beforePrint: {
      type: Function,
      default: null
    },

    /**
     * @Desc: 打印后的回调函数
     * @type {function} afterPrint
     */
    afterPrint: {
      type: Function,
      default: null
    },

    /**
     * @Desc: 是否隐藏要打印的元素
     * @type {boolean} hidePrintInfo
     */
    hidePrintInfo: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy; // data数据


    var tdProperties = Object.freeze(['text', 'prop', 'path', 'slot', 'code', 'template']);
    var printContent = Object(composition_api_["ref"])(null);
    var cell = Object(composition_api_["ref"])(null); // 函数数据

    var createCode = function createCode() {
      (cell.value || []).forEach(function (item) {
        return item.createCode();
      });
    };

    var handleAfterPrint = function handleAfterPrint(nextNode, parentNode) {
      var _printContent = printContent.value;
      var _innerHidePrintInfo = props.hidePrintInfo;

      if (_innerHidePrintInfo) {
        _printContent.style.display = '';
      } else {
        document.body.removeChild(_printContent);

        if (nextNode) {
          parentNode.insertBefore(_printContent, nextNode);
        } else {
          parentNode.appendChild(_printContent);
        }
      }

      props.afterPrint && props.afterPrint();
    };

    var innerPrint = function innerPrint() {
      window.print();
    };

    var showElement = function showElement() {
      var _printContent = printContent.value;
      var _innerHidePrintInfo = props.hidePrintInfo;

      if (!_innerHidePrintInfo) {
        document.body.appendChild(_printContent);
      }

      _printContent.style.display = 'block';
    };

    var print = function print() {
      Object(composition_api_["nextTick"])(function () {
        var _printContent = printContent.value; // 获取父节点和下面的节点

        var parentNode = _printContent.parentNode;
        var nextNode = _printContent.nextElementSibling;
        showElement(); // 可以在这里中止打印，返回false

        if (typeof props.beforePrint === 'function') {
          var handleResult = props.beforePrint();
          var handleResultPromise = isPromise(handleResult) ? handleResult : Promise[handleResult !== false ? 'resolve' : 'reject']();
          handleResultPromise.then(function () {
            createCode();
            innerPrint();
          }).catch(function (error) {
            if (error && error.message) {
              proxy.$mtd.message.error(e.message);
            }
          }).finally(function () {
            handleAfterPrint(nextNode, parentNode);
          });
        } else {
          createCode();
          innerPrint();
          handleAfterPrint(nextNode, parentNode);
        }
      });
    };

    var removeProperties = function removeProperties(obj, keys) {
      var result = {};
      Object.entries(obj).forEach(function (_ref) {
        var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (!keys.includes(key)) {
          result[key] = value;
        }
      });
      return result;
    };

    var reserveProperties = function reserveProperties(obj, keys) {
      var result = {};
      Object.entries(obj).forEach(function (_ref3) {
        var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        if (keys.includes(key)) {
          result[key] = value;
        }
      });
      return result;
    }; // 生命周期函数


    Object(composition_api_["onMounted"])(function () {
      var _printContent = printContent.value;
      var _innerHidePrintInfo = props.hidePrintInfo;

      if (!_innerHidePrintInfo) {
        _printContent.style.display = 'block';
        createCode();
      } else {
        document.body.appendChild(_printContent);
      }
    });
    return {
      tdProperties: tdProperties,
      printContent: printContent,
      cell: cell,
      print: print,
      removeProperties: removeProperties,
      reserveProperties: reserveProperties
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-print-template/mc-print-template.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_print_template_mc_print_templatevue_type_script_lang_js_ = (mc_print_templatevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-print-template/mc-print-template.vue





/* normalize component */

var mc_print_template_component = Object(componentNormalizer["a" /* default */])(
  mc_print_template_mc_print_templatevue_type_script_lang_js_,
  mc_print_templatevue_type_template_id_03caad3b_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_print_template = (mc_print_template_component.exports);
// CONCATENATED MODULE: ./components/mc-print-template/index.js


/* istanbul ignore next */

mc_print_template.install = function (Vue) {
  Vue.component(mc_print_template.name, mc_print_template);
};

/* harmony default export */ var components_mc_print_template = __webpack_exports__["default"] = (mc_print_template);

/***/ }),

/***/ "0efb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_vue_cli_plugin_typescript_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4106");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_vue_cli_plugin_typescript_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_vue_cli_plugin_typescript_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_vue_cli_plugin_typescript_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Preview_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0f14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ "0f2c":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("2aee")
var mgf = __webpack_require__("f460")
var xor = __webpack_require__("83d5")
var BN = __webpack_require__("399f")
var crt = __webpack_require__("a958")
var createHash = __webpack_require__("98e6")
var withPublic = __webpack_require__("5291")
var Buffer = __webpack_require__("8707").Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ "0f38":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ "0fc9":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "0ff2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ "0ff9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-config-provider/mc-config-provider.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_config_providervue_type_script_lang_js_ = ({
  name: 'McConfigProvider',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-config-provider', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-config-provider/mc-config-provider.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_config_provider_mc_config_providervue_type_script_lang_js_ = (mc_config_providervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-config-provider/mc-config-provider.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_config_provider_mc_config_providervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_config_provider = (component.exports);
// CONCATENATED MODULE: ./components/mc-config-provider/index.js


/* istanbul ignore next */

mc_config_provider.install = function (Vue) {
  Vue.component(mc_config_provider.name, mc_config_provider);
};

/* harmony default export */ var components_mc_config_provider = __webpack_exports__["default"] = (mc_config_provider);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1053":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("de85");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "1062":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-image-preview/mc-image-preview.vue?vue&type=template&id=245b1288&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],ref:"el",staticClass:"mc-image-preview"},[_c('transition',{attrs:{"name":"mc-image-preview-fade"}},[_c('div',{ref:"wrapper",staticClass:"mc-image-preview-wrapper",style:({ 'z-index': _vm.zIndex }),attrs:{"tabindex":"-1"}},[_c('div',{staticClass:"mc-image-preview-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleMaskClick.apply(null, arguments)}}}),_c('span',{staticClass:"mc-image-preview-btn mc-image-preview-close",on:{"click":_vm.hide}},[_c('mtd-icon-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"secondary","icon":"mtdicon mtdicon-close"}})],1),(_vm.showArrow)?[_c('span',{staticClass:"mc-image-preview-btn mc-image-preview-prev",class:{ 'is-disabled': !_vm.infinite && _vm.isFirst },on:{"click":_vm.prev}},[_c('mtd-icon-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"secondary","icon":"mtdicon mtdicon-left"}})],1),_c('span',{staticClass:"mc-image-preview-btn mc-image-preview-next",class:{ 'is-disabled': !_vm.infinite && _vm.isLast },on:{"click":_vm.next}},[_c('mtd-icon-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"secondary","icon":"mtdicon mtdicon-right"}})],1)]:_vm._e(),(_vm.showToolbar)?_c('div',{staticClass:"mc-image-preview-btn mc-image-preview-actions"},[_c('div',{staticClass:"mc-image-preview-actions-inner"},[_c('mtd-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"text","icon":"mtdicon-enlarge"},on:{"click":function($event){return _vm.handleActions('zoomIn')}}},[_vm._v("\n                        放大\n                    ")]),_c('mtd-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"text","icon":"mtdicon-micrify"},on:{"click":function($event){return _vm.handleActions('zoomOut')}}},[_vm._v("\n                        缩小\n                    ")]),_c('mtd-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"text","icon":"mtdicon-rotate"},on:{"click":function($event){return _vm.handleActions('clocelise')}}},[_vm._v("\n                        旋转\n                    ")]),_c('mtd-button',{staticClass:"mc-image-preview-actions-btn",attrs:{"type":"text","icon":"mtdicon-download-o","loading":_vm.downloadLoading},on:{"click":function($event){return _vm.handleActions('download')}}},[_vm._v("\n                        下载\n                    ")])],1)]):_vm._e(),_c('div',{staticClass:"mc-image-preview-canvas"},_vm._l((_vm.data),function(url,index){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.startIndex),expression:"index === startIndex"}],key:index,ref:"img",refInFor:true,staticClass:"mc-image-preview-img",style:(_vm.imgStyle),attrs:{"src":_vm.currentImg},on:{"load":_vm.handleImgLoad,"error":_vm.handleImgError,"mousedown":_vm.handleMouseDown,"touchstart":_vm.handleTouchStart,"touchmove":_vm.handleTouchMove}})}),0)],2)])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-image-preview/mc-image-preview.vue?vue&type=template&id=245b1288&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/@ss/mtd-vue/src/utils/dom.js


const isServer = external_vue_default.a.prototype.$isServer;
const defaultOptions = {
  capture: false,
  passive: false,
};

function noop () {}

/* istanbul ignore next */
const off = (function () {
  if (!isServer && document.removeEventListener) {
    return function (node, event, handler) {
      // 判断 node 为 vnode
      const element = node && node.$el ? node.$el : node;
      if (element && event) {
        element.removeEventListener(event, handler, defaultOptions);
      }
    };
  } else {
    return function (node, event, handler) {
      const element = node && node.$el ? node.$el : node;
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
const on = (function () {
  if (!isServer && document.addEventListener) {
    return function (node, event, handler) {
      // 判断 node 为 vnode
      const element = node && node.$el ? node.$el : node;
      if (element && event && handler) {
        element.addEventListener(event, handler, defaultOptions);
        return () => off(element, event, handler);
      }
      return noop;
    };
  } else {
    return function (node, event, handler) {
      const element = node && node.$el ? node.$el : node;
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
        return () => off(element, event, handler);
      }
      return noop;
    };
  }
})();

function hasClass (el, className) {
  if (!el || !className) {
    return false;
  }
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1;
  }
}

function addClass (el, className) {
  if (!el) return;
  let curClass = el.className;
  const classes = (className || '').split(' ');

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

function removeClass (el, className) {
  if (!el || !className) return;
  const classes = className.split(' ');
  let curClass = ' ' + el.className + ' ';

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = curClass.trim();
  }
}

function getStyle (el, styleName) {
  if (isServer) return;
  if (!el) {
    return {};
  }
  try {
    const style = window.getComputedStyle(el, null);
    return style.getPropertyValue(styleName);
  } catch (e) {
    return el.style[styleName];
  }
}

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__("bf4b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__("4917");

// CONCATENATED MODULE: ./components/mc-image-preview/util.js


function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function () {
      fn.apply(_this, args);
      locked = false;
    });
  };
}
var util_isFirefox = function isFirefox() {
  return !external_vue_default.a.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
}; // error占位图

var errorImg = 'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/error.png';
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-image-preview/mc-image-preview.vue?vue&type=script&lang=js&






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mc_image_previewvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McImagePreview',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentIndex: {
      type: Number,
      default: 0 // 默认打开第一张图片预览

    },
    visible: {
      type: Boolean,
      default: false // 默认关闭

    },
    // 设置图片预览的z-index，el-dialog 和 mc-modal 的 z-index 初始值一般是 2000
    zIndex: {
      type: Number,
      default: constants["a" /* IMAGE_PREVIEW_Z_INDEX */]
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    showToolbar: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var infinite = Object(composition_api_["ref"])(true);
    var loading = Object(composition_api_["ref"])(false);
    var startIndex = Object(composition_api_["ref"])(0);
    var transform = Object(composition_api_["reactive"])({
      scale: 1,
      deg: 0,
      offsetX: 0,
      offsetY: 0,
      enableTransition: false
    });
    var downloadLoading = Object(composition_api_["ref"])(false);
    var img = Object(composition_api_["ref"])();
    var wrapper = Object(composition_api_["ref"])();
    var el = Object(composition_api_["ref"])(); // 在iframe中, 需要全屏蒙层

    var isIframe = window.parent !== window; // dialog唯一标识

    var __IframeUiModalId = Object(tools_["getUuid"])();

    var isShow = Object(composition_api_["computed"])(function () {
      return props.visible;
    });
    var isSingle = Object(composition_api_["computed"])(function () {
      return props.data.length && props.data.length <= 1;
    });
    var showArrow = Object(composition_api_["computed"])(function () {
      return props.data.length > 1;
    });
    var isFirst = Object(composition_api_["computed"])(function () {
      return startIndex.value === 0;
    });
    var isLast = Object(composition_api_["computed"])(function () {
      return startIndex.value === props.data.length - 1;
    });
    var currentImg = Object(composition_api_["computed"])(function () {
      return props.data[startIndex.value];
    });
    var imgStyle = Object(composition_api_["computed"])(function () {
      var scale = transform.scale,
          deg = transform.deg,
          offsetX = transform.offsetX,
          offsetY = transform.offsetY,
          enableTransition = transform.enableTransition;
      var style = {
        transform: "scale(".concat(scale, ") rotate(").concat(deg, "deg)"),
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': "".concat(offsetX, "px"),
        'margin-top': "".concat(offsetY, "px"),
        'max-height': '100%',
        'max-width': '100%'
      };
      return style;
    });
    var _keyDownHandler = null;
    var _mouseWheelHandler = null;

    var handleImgLoad = function handleImgLoad() {
      loading.value = false;
    };

    var handleImgError = function handleImgError(e) {
      loading.value = false;

      if (e.target.src !== errorImg) {
        e.target.src = errorImg;
      }
    };

    var handleMouseDown = function handleMouseDown(e) {
      if (loading.value || e.button !== 0) return;
      var offsetX = transform.offsetX,
          offsetY = transform.offsetY;
      var startX = e.pageX;
      var startY = e.pageY;

      var _dragHandler = rafThrottle(function (ev) {
        transform.offsetX = offsetX + ev.pageX - startX;
        transform.offsetY = offsetY + ev.pageY - startY;
      });

      on(document, 'mousemove', _dragHandler);
      on(document, 'mouseup', function () {
        off(document, 'mousemove', _dragHandler);
      });
      e.preventDefault();
    };

    var startX = 0;
    var startY = 0;

    var handleTouchStart = function handleTouchStart(e) {
      if (e.touches.length === 1) {
        var _e$touches$ = e.touches[0],
            clientX = _e$touches$.clientX,
            clientY = _e$touches$.clientY;
        startX = clientX;
        startY = clientY;
      }

      e.preventDefault();
    };

    var handleTouchMove = function handleTouchMove(e) {
      if (e.touches.length !== 1) return;
      var _e$touches$2 = e.touches[0],
          clientX = _e$touches$2.clientX,
          clientY = _e$touches$2.clientY;
      var offsetX = clientX - startX;
      var offsetY = clientY - startY;
      startX = clientX;
      startY = clientY;
      transform.offsetX += offsetX;
      transform.offsetY += offsetY;
      e.preventDefault();
    };
    /** 字符过长的图片在新页面打开；正常长度图片url在当前页下载 */


    var downloadImg = function downloadImg() {
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = currentImg.value;

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL('image/png');

        if (url.length < 1000000) {
          Object(tools_["download"])(url);
        } else {
          Object(tools_["download"])(currentImg.value);
        }

        downloadLoading.value = false;
      };
    };

    var handleActions = function handleActions(action) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (loading.value) return;

      var _zoomRate$rotateDeg$e = _objectSpread({
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true
      }, options),
          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
          enableTransition = _zoomRate$rotateDeg$e.enableTransition;

      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }

          break;

        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;

        case 'clocelise':
          transform.deg += rotateDeg;
          break;

        case 'download':
          downloadLoading.value = true;
          var debounceDownload = Object(tools_["debounce"])(downloadImg, 1000);
          debounceDownload();
          break;

        default:
          break;
      }

      transform.enableTransition = enableTransition;
    };

    var mousewheelEventName = util_isFirefox() ? 'DOMMouseScroll' : 'mousewheel';

    var prev = function prev() {
      if (isFirst.value && !infinite.value) return;
      var len = props.data.length;
      startIndex.value = (startIndex.value - 1 + len) % len;
    };

    var next = function next() {
      if (isLast.value && !infinite.value) return;
      var len = props.data.length;
      startIndex.value = (startIndex.value + 1) % len;
    };

    var deviceSupportUninstall = function deviceSupportUninstall() {
      off(document, 'keydown', _keyDownHandler);
      off(document, mousewheelEventName, _mouseWheelHandler);
      _keyDownHandler = null;
      _mouseWheelHandler = null;
    };

    var hide = function hide() {
      deviceSupportUninstall();
      emit('close');
    };

    var deviceSupportInstall = function deviceSupportInstall() {
      _keyDownHandler = function _keyDownHandler(e) {
        e.stopPropagation();
        var keyCode = e.keyCode;

        switch (keyCode) {
          // ESC
          case 27:
            hide();
            break;
          // LEFT_ARROW

          case 37:
            prev();
            break;
          // UP_ARROW

          case 38:
            handleActions('zoomIn');
            break;
          // RIGHT_ARROW

          case 39:
            next();
            break;
          // DOWN_ARROW

          case 40:
            handleActions('zoomOut');
            break;

          default:
            break;
        }
      };

      _mouseWheelHandler = rafThrottle(function (e) {
        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;

        if (delta > 0) {
          handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(document, 'keydown', _keyDownHandler);
      on(document, mousewheelEventName, _mouseWheelHandler);
    };

    var handleMaskClick = function handleMaskClick() {
      hide();
    };

    var reset = function reset() {
      transform.scale = 1;
      transform.deg = 0;
      transform.offsetX = 0;
      transform.offsetY = 0;
      transform.enableTransition = false;
    };

    Object(composition_api_["watch"])(function () {
      return props.currentIndex;
    }, function (val) {
      startIndex.value = props.data.length > 0 && val > props.data.length - 1 || val < 0 ? 0 : val;
    });
    Object(composition_api_["watch"])(startIndex, function () {
      reset();
    });
    Object(composition_api_["watch"])(isShow, function (val) {
      reset();
      Object(composition_api_["nextTick"])(function () {
        if (val) {
          deviceSupportInstall();
        }

        startIndex.value = props.data.length > 0 && props.currentIndex > props.data.length - 1 || props.currentIndex < 0 ? 0 : props.currentIndex; // 处理内外壳通信

        if (isIframe) {
          proxy.$me.emit('ui-modal', 'parent', {
            id: __IframeUiModalId,
            show: val,
            v: 1
          });
        }
      });
    });
    Object(composition_api_["watch"])(currentImg, function () {
      Object(composition_api_["nextTick"])(function () {
        var firstImage = img.value[0];

        if (!firstImage.complete) {
          loading.value = true;
        }
      });
    });
    Object(composition_api_["onMounted"])(function () {
      if (el.value && props.appendToBody) {
        document.body.appendChild(el.value);
      }

      wrapper.value.focus();
    });
    Object(composition_api_["onUnmounted"])(function () {
      if (props.appendToBody && el.value && el.value.parentNode) {
        deviceSupportUninstall();
        el.value.parentNode.removeChild(el.value);
      }
    });
    return {
      startIndex: startIndex,
      isShow: isShow,
      infinite: infinite,
      loading: loading,
      transform: transform,
      isSingle: isSingle,
      isFirst: isFirst,
      isLast: isLast,
      currentImg: currentImg,
      imgStyle: imgStyle,
      img: img,
      wrapper: wrapper,
      el: el,
      downloadLoading: downloadLoading,
      showArrow: showArrow,
      handleMaskClick: handleMaskClick,
      handleActions: handleActions,
      handleImgLoad: handleImgLoad,
      handleImgError: handleImgError,
      handleMouseDown: handleMouseDown,
      hide: hide,
      prev: prev,
      next: next,
      handleTouchStart: handleTouchStart,
      handleTouchMove: handleTouchMove
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-image-preview/mc-image-preview.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_image_preview_mc_image_previewvue_type_script_lang_js_ = (mc_image_previewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-image-preview/mc-image-preview.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_image_preview_mc_image_previewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_image_preview = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1098":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("4a9d");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "1098b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("17ed");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("f893");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "10a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-configform/mc-configform.vue?vue&type=template&id=740be768&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-configform"},[_c('mtd-form',{ref:"mtdForm",attrs:{"model":_vm.formData,"rules":_vm.rules,"inline":_vm.inline,"disabled":_vm.disabled,"label-position":_vm.labelPosition,"label-width":_vm.labelWidth,"show-message":_vm.showMessage,"label-suffix":_vm.labelSuffix,"first-fields":false,"scroll-to-first-error":_vm.scrollToFirstError}},[_c('mtd-row',[_c('config-form-render',{attrs:{"form-data":_vm.formData,"fields":_vm.fields,"column-count":_vm.columnCount},scopedSlots:_vm._u([_vm._l((_vm.slotsArray),function(slotName){return {key:slotName,fn:function(scope){return [_vm._t(slotName,null,null,scope)]}}})],null,true)})],1),(_vm.showOperateBtn)?_c('div',{class:_vm.operationsClass},[(!!_vm.submit)?_c('mtd-button',_vm._b({staticClass:"mc-operate-btn",attrs:{"loading":_vm.loading},on:{"click":_vm.onSubmit}},'mtd-button',_vm.submitButtonProps,false),[_vm._v("\n                "+_vm._s(_vm.submitText)+"\n            ")]):_vm._e(),(!!_vm.cancel)?_c('mtd-button',_vm._b({staticClass:"mc-operate-btn",attrs:{"loading":_vm.cancelBtnLoading},on:{"click":_vm.onCancel}},'mtd-button',_vm.submitter.cancelButtonProps,false),[_vm._v("\n                "+_vm._s(_vm.cancelText)+"\n            ")]):_vm._e(),(!!_vm.reset)?_c('mtd-button',_vm._b({staticClass:"mc-operate-btn",on:{"click":_vm.onReset}},'mtd-button',_vm.submitter.resetButtonProps,false),[_vm._v("\n                重置\n            ")]):_vm._e(),_c('div',{staticClass:"mc-extra-operate-btn"},[_vm._t("submitterSlot")],2)],1):_vm._e()],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-configform/mc-configform.vue?vue&type=template&id=740be768&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js
var helper = __webpack_require__("2638");
var helper_default = /*#__PURE__*/__webpack_require__.n(helper);

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-configform/components/RenderTips.vue?vue&type=script&lang=js&
/* harmony default export */ var RenderTipsvue_type_script_lang_js_ = ({
  functional: true,
  render: function render(h, ctx) {
    var tips = ctx.props.tips;
    var content = Array.isArray(tips) ? tips : [tips];
    return h("mtd-tooltip", {
      "attrs": {
        "placement": "top"
      }
    }, [h("i", {
      "class": "mtdicon mtdicon-info-circle demo-icon demo-icon-label"
    }), h("div", {
      "slot": "content"
    }, [content.map(function (text) {
      return h("div", [text]);
    })])]);
  }
});
// CONCATENATED MODULE: ./components/mc-configform/components/RenderTips.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RenderTipsvue_type_script_lang_js_ = (RenderTipsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-configform/components/RenderTips.vue
var RenderTips_render, RenderTips_staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_RenderTipsvue_type_script_lang_js_,
  RenderTips_render,
  RenderTips_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RenderTips = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-configform/components/FormItem.vue?vue&type=script&lang=js&





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var FormItemvue_type_script_lang_js_ = ({
  functional: true,
  render: function render(h, ctx) {
    var _ctx$props = ctx.props,
        field = _ctx$props.field,
        formData = _ctx$props.formData,
        propKey = _ctx$props.propKey,
        propValue = _ctx$props.propValue,
        readonly = _ctx$props.readonly,
        disabled = _ctx$props.disabled,
        children = ctx.children;
    var template = field.template,
        slot = field.slot;

    if (template) {
      var attrs = template.attrs,
          events = template.events,
          component = template.component;

      if (component && typeof component === 'function') {
        return component.call({
          $createElement: h
        }, propKey, propValue, field, formData);
      }

      return h(component, {
        props: _objectSpread({}, attrs, {
          value: formData[propKey],
          readonly: readonly,
          disabled: disabled
        }),
        attrs: _objectSpread({}, attrs, {
          value: formData[propKey],
          readonly: readonly,
          disabled: disabled
        }),
        on: _objectSpread({}, events, {
          input: function input(val) {
            formData[propKey] = val;
          }
        })
      });
    }

    if (slot) {
      return children;
    }

    return h("mc-input", {
      "attrs": {
        "value": formData[field.prop],
        "readonly": readonly,
        "disabled": disabled,
        "placeholder": "\u8BF7\u8F93\u5165".concat(field.label)
      },
      "on": {
        "input": function input(val) {
          formData[field.prop] = val;
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./components/mc-configform/components/FormItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FormItemvue_type_script_lang_js_ = (FormItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-configform/components/FormItem.vue
var FormItem_render, FormItem_staticRenderFns




/* normalize component */

var FormItem_component = Object(componentNormalizer["a" /* default */])(
  components_FormItemvue_type_script_lang_js_,
  FormItem_render,
  FormItem_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormItem = (FormItem_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-configform/components/ConfigFormRender.vue?vue&type=script&lang=js&







function ConfigFormRendervue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ConfigFormRendervue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ConfigFormRendervue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ConfigFormRendervue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var DefColSpan = 24;

function getFormFieldItemProps(field) {
  var labelWidth = field.labelWidth,
      labelPosition = field.labelPosition,
      labelFor = field.labelFor,
      rules = field.rules,
      _field$required = field.required,
      required = _field$required === void 0 ? false : _field$required,
      error = field.error,
      _field$showMessage = field.showMessage,
      showMessage = _field$showMessage === void 0 ? true : _field$showMessage,
      helper = field.helper,
      helperPlacement = field.helperPlacement,
      validatePlacement = field.validatePlacement,
      _field$useHtmlMessage = field.useHtmlMessage,
      useHtmlMessage = _field$useHtmlMessage === void 0 ? false : _field$useHtmlMessage;
  return {
    labelWidth: labelWidth,
    labelPosition: labelPosition,
    labelFor: labelFor,
    rules: rules,
    required: required,
    error: error,
    showMessage: showMessage,
    helper: helper,
    helperPlacement: helperPlacement,
    validatePlacement: validatePlacement,
    useHtmlMessage: useHtmlMessage
  };
}

function getGroupProp(field) {
  var label = field.label,
      labelWidth = field.labelWidth,
      labelPosition = field.labelPosition,
      labelSuffix = field.labelSuffix,
      required = field.required;
  return {
    label: label,
    labelWidth: labelWidth,
    labelPosition: labelPosition,
    labelSuffix: labelSuffix,
    required: required
  };
}

function renderFormFieldItem(props, h, context) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    isGroup: false,
    defaultColSpan: DefColSpan
  };
  var field = props.field,
      formData = props.formData,
      columnCount = props.columnCount;
  var prop = field.prop,
      label = field.label,
      tips = field.tips,
      colSpan = field.colSpan,
      readonly = field.readonly,
      disabled = field.disabled,
      labelSuffix = field.labelSuffix,
      _field$type = field.type,
      type = _field$type === void 0 ? 'default' : _field$type,
      title = field.title; // 兼容vue2.5/2.6版本

  var innerScopedSlots = context.scopedSlots || context.data.scopedSlots;
  var spanValue;

  if (options.isGroup) {
    spanValue = colSpan || options.defaultColSpan;
  } else {
    spanValue = colSpan || Math.floor(DefColSpan / columnCount);
  } // 顶层form属性和field item属性合并，优先使用field item


  var innerReadonly = !readonly && readonly !== false ? context.injections.configForm.props.readonly : readonly;
  var innerDisabled = !disabled && disabled !== false ? context.injections.configForm.props.disabled : disabled;
  var innerLabelSuffix = !labelSuffix && labelSuffix !== '' ? context.injections.configForm.props.labelSuffix : labelSuffix;
  var titleFieldComponent = h("mc-title", {
    "attrs": {
      "title": title
    }
  });
  var defaultFieldComponent = h("mtd-form-item", helper_default()([{
    "attrs": {
      "prop": prop,
      "label": label
    }
  }, {
    "attrs": getFormFieldItemProps(field)
  }]), [h("span", {
    "slot": "label"
  }, [label, tips && tips.length > 0 && h(RenderTips, {
    "attrs": {
      "tips": tips
    }
  }), (!tips || !tips.length) && innerLabelSuffix]), h(FormItem, {
    "attrs": {
      "field": field,
      "propKey": prop,
      "propValue": formData[prop],
      "formData": formData,
      "readonly": innerReadonly,
      "disabled": innerDisabled
    }
  }, [field.slot && innerScopedSlots[field.slot]({
    readonly: innerReadonly,
    disabled: innerDisabled
  })])]);
  var fieldTypeRenderMap = {
    title: titleFieldComponent,
    default: defaultFieldComponent
  };
  return h("mtd-col", {
    "attrs": {
      "span": spanValue
    }
  }, [fieldTypeRenderMap[type]]);
}

function renderFormFieldList(props, h, context) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var fields = props.fields,
      formData = props.formData,
      columnCount = props.columnCount;
  var vnodeRenderArr = [];
  fields.forEach(function (field) {
    var _field$visible = field.visible,
        visible = _field$visible === void 0 ? true : _field$visible;
    if (typeof visible === 'function') visible = visible(formData, context);
    if (visible === false) return; // eslint-disable-next-line no-use-before-define

    var formFieldVnode = genFormFieldVNode({
      field: field,
      formData: formData,
      columnCount: columnCount
    }, h, context, options);
    vnodeRenderArr.push(formFieldVnode);
  });
  return vnodeRenderArr;
}

function renderFormGroup(props, h, context) {
  var field = props.field;
  var _field$group = field.group,
      group = _field$group === void 0 ? [] : _field$group;
  var defaultColSpan = DefColSpan;

  if (group) {
    defaultColSpan = Math.floor(DefColSpan / group.length);
  }

  return h("mc-form-group", helper_default()([{}, {
    "attrs": getGroupProp(field)
  }]), [h("mtd-row", [renderFormFieldList(ConfigFormRendervue_type_script_lang_js_objectSpread({}, props, {
    fields: group
  }), h, context, {
    isGroup: true,
    defaultColSpan: defaultColSpan
  })])]);
}

function genFormFieldVNode(props, h, context, options) {
  var field = props.field; // group组件

  if (field.group) {
    return renderFormGroup(props, h, context);
  }

  return renderFormFieldItem(props, h, context, options);
}

/* harmony default export */ var ConfigFormRendervue_type_script_lang_js_ = ({
  functional: true,
  inject: ['configForm'],
  render: function render(h, context) {
    return renderFormFieldList(context.props, h, context);
  }
});
// CONCATENATED MODULE: ./components/mc-configform/components/ConfigFormRender.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ConfigFormRendervue_type_script_lang_js_ = (ConfigFormRendervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-configform/components/ConfigFormRender.vue
var ConfigFormRender_render, ConfigFormRender_staticRenderFns




/* normalize component */

var ConfigFormRender_component = Object(componentNormalizer["a" /* default */])(
  components_ConfigFormRendervue_type_script_lang_js_,
  ConfigFormRender_render,
  ConfigFormRender_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConfigFormRender = (ConfigFormRender_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-configform/mc-configform.vue?vue&type=script&lang=js&








function mc_configformvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mc_configformvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mc_configformvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mc_configformvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var mc_configformvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McConfigform',
  components: {
    ConfigFormRender: ConfigFormRender
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 列数，默认1列
    columnCount: {
      type: Number,
      default: 1
    },
    submit: {
      type: Function,
      default: null
    },
    submitText: {
      type: String,
      default: '确定'
    },
    cancel: {
      type: Function,
      default: null
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    reset: {
      type: Boolean,
      default: false
    },
    validateFn: {
      type: Function,
      default: null
    },
    submitter: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // mtd-form属性
    inline: {
      type: Boolean
    },
    labelPosition: {
      type: String
    },
    labelWidth: {
      type: Number
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    labelSuffix: {
      type: String,
      default: ''
    },
    scrollToFirstError: {
      type: Boolean
    }
  },
  setup: function setup(props, ctx) {
    Object(composition_api_["provide"])('configForm', {
      props: props
    });
    var emit = ctx.emit;
    var mtdForm = Object(composition_api_["ref"])(null);
    var loading = Object(composition_api_["ref"])(false);
    var cancelBtnLoading = Object(composition_api_["ref"])(false);
    var formData = Object(composition_api_["reactive"])(props.value);
    var slotsArray = Object(composition_api_["computed"])(function () {
      return Object.keys(ctx.slots);
    });
    var showOperateBtn = Object(composition_api_["computed"])(function () {
      if (props.submit || props.cancel || props.reset) return true;
      return false;
    });
    var submitButtonProps = Object(composition_api_["computed"])(function () {
      return mc_configformvue_type_script_lang_js_objectSpread({
        type: 'primary'
      }, !Object(tools_["isEmpty"])(props.submitter) ? props.submitter.submitButtonProps : {});
    });
    var operationsClass = Object(composition_api_["computed"])(function () {
      return props.submitter.position ? "mc-operate-wrapper mc-operate-wrapper-".concat(props.submitter.position) : 'mc-operate-wrapper';
    }); // mtdForm.value => this.$refs.mtdForm
    // 由于mtd validate resolve后返回undefined，故重新赋值true方便后续处理

    var validate = function validate(cb) {
      return mtdForm.value.validate(cb).then(function () {
        return true;
      });
    };

    var validateField = function validateField(prop, cb) {
      return mtdForm.value.validateField(prop, cb);
    };

    var validateFields = function validateFields(prop, cb) {
      return mtdForm.value.validateFields(prop, cb);
    };

    var resetFields = function resetFields(ps) {
      return mtdForm.value.resetFields(ps);
    };

    var clearValidate = function clearValidate(ps) {
      return mtdForm.value.clearValidate(ps);
    };

    var onSubmit =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var validateFn, isValid, promise;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                validateFn = props.validateFn || validate;
                _context.next = 4;
                return validateFn().catch(function () {
                  loading.value = false;
                  return false;
                });

              case 4:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                promise = props.submit();

                if (promise instanceof Promise) {
                  promise.then(function () {
                    emit('success');
                  }).catch(function (error) {
                    emit('fail', error);
                  }).finally(function () {
                    loading.value = false;
                  });
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function onSubmit() {
        return _ref.apply(this, arguments);
      };
    }();

    var onCancel = function onCancel() {
      var funcRes = props.cancel();

      if (funcRes instanceof Promise) {
        cancelBtnLoading.value = true;
        funcRes.finally(function () {
          cancelBtnLoading.value = false;
        });
      }
    };

    var onReset = function onReset() {
      resetFields();
    };

    Object(composition_api_["watch"])(function () {
      return formData;
    }, function (val) {
      emit('input', val);
      emit('change', val);
    }, {
      deep: true
    });
    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      Object.assign(formData, val);
    }, {
      deep: true
    });
    return {
      mtdForm: mtdForm,
      formData: formData,
      slotsArray: slotsArray,
      submitButtonProps: submitButtonProps,
      operationsClass: operationsClass,
      loading: loading,
      cancelBtnLoading: cancelBtnLoading,
      onSubmit: onSubmit,
      onCancel: onCancel,
      onReset: onReset,
      validate: validate,
      validateField: validateField,
      validateFields: validateFields,
      resetFields: resetFields,
      clearValidate: clearValidate,
      showOperateBtn: showOperateBtn
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-configform/mc-configform.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_configform_mc_configformvue_type_script_lang_js_ = (mc_configformvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-configform/mc-configform.vue





/* normalize component */

var mc_configform_component = Object(componentNormalizer["a" /* default */])(
  mc_configform_mc_configformvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_configform = (mc_configform_component.exports);
// CONCATENATED MODULE: ./components/mc-configform/index.js


/* istanbul ignore next */

mc_configform.install = function (Vue) {
  Vue.component(mc_configform.name, mc_configform);
};

/* harmony default export */ var components_mc_configform = __webpack_exports__["default"] = (mc_configform);

/***/ }),

/***/ "10b0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),

/***/ "10e8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ "1169":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("2d95");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "116d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("b4e8")


/***/ }),

/***/ "1173":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "11ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-image/mc-image.vue?vue&type=template&id=6d91284b&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"mc-image"},[(_vm.loading)?_vm._t("placeholder",function(){return [_c('div',{staticClass:"mc-image-placeholder"})]}):(_vm.error)?_vm._t("error",function(){return [_c('div',{staticClass:"mc-image-error"},[_vm._v("\n            加载失败\n        ")])]}):_c('img',_vm._g(_vm._b({staticClass:"mc-image-inner",class:{ 'mc-image-inner-center': _vm.alignCenter, 'mc-image-preview': _vm.preview },style:(_vm.imageStyle),attrs:{"src":_vm.innerSrc},on:{"click":_vm.clickHandler}},'img',_vm.$attrs,false),_vm.$listeners)),(_vm.preview)?[_c('mc-image-preview',{attrs:{"data":_vm.previewUrlList,"visible":_vm.showPreview,"z-index":_vm.previewZIndex,"current-index":_vm.previewFirstIndex},on:{"close":_vm.closePreview}})]:_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-image/mc-image.vue?vue&type=template&id=6d91284b&

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./components/mc-image-preview/mc-image-preview.vue + 6 modules
var mc_image_preview = __webpack_require__("1062");

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__("bf4b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__("4917");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// CONCATENATED MODULE: ./components/mc-image/utils.js




function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}
function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}
var isScroll = function isScroll(el) {
  if (!el) return null;
  var computed = window.getComputedStyle(el);
  var overflow = el.style['overflow'] || computed ? computed['overflow'] : null;
  return overflow.match(/(scroll|auto|overlay)/);
};
var getScrollContainer = function getScrollContainer(el) {
  var parent = el;

  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }

    if (isScroll(parent)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return parent;
};
var isSupportWebp = function isSupportWebp() {
  window.mc_webpChecked = true;
  var WebP = new Image();
  WebP.src = 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==';

  WebP.onload = function () {
    if (WebP.height > 0 && WebP.width > 0) {
      window.mc_supportWebp = 1;
    }
  };

  WebP.onerror = function () {
    window.mc_supportWebp = 0;
  };
};
var addWebpUrl = function addWebpUrl(src) {
  var imgTypeReg = /\.(png|jpe?g)(\?.*)?$/;

  var imgUrlTest = function imgUrlTest(src) {
    return /(p[\d]|img)\.meituan\.net/.test(src) || /(p[\d])\.inf\.test\.sankuai\.com/.test(src);
  };

  if (src && window.mc_supportWebp && imgTypeReg.test(src) && imgUrlTest(src)) {
    src = src + '.webp';
  }

  return src;
};
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-image/mc-image.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





if (!window.mc_webpChecked) {
  isSupportWebp();
}

/* harmony default export */ var mc_imagevue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McImage',
  components: {
    mcImagePreview: mc_image_preview["a" /* default */]
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    },
    scrollContainer: {},
    previewUrlList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 设置图片预览的z-index，el-dialog 和 mc-modal 的 z-index 初始值一般是 2000
    previewZIndex: {
      type: Number,
      default: constants["a" /* IMAGE_PREVIEW_Z_INDEX */]
    },
    previewFirstIndex: {
      type: Number,
      default: 0
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var loading = Object(composition_api_["ref"])(true);
    var error = Object(composition_api_["ref"])(false);
    var show = Object(composition_api_["ref"])(!props.lazy);
    var showPreview = Object(composition_api_["ref"])(false);
    var el = Object(composition_api_["ref"])(null);
    var ObjectFit = {
      NONE: 'none',
      CONTAIN: 'contain',
      COVER: 'cover',
      FILL: 'fill',
      SCALE_DOWN: 'scale-down'
    };
    var imageStyle = Object(composition_api_["computed"])(function () {
      return props.fit ? {
        'object-fit': props.fit
      } : {};
    });
    var alignCenter = Object(composition_api_["computed"])(function () {
      return props.fit !== ObjectFit.FILL;
    });
    var preview = Object(composition_api_["computed"])(function () {
      return Array.isArray(props.previewUrlList) && props.previewUrlList.length > 0;
    });

    var handleLoad = function handleLoad(e, img) {
      loading.value = false;
      error.value = false;
      img = null;
      emit('load', e);
    };

    var handleError = function handleError(e) {
      loading.value = false;
      error.value = true;
      emit('error', e);
    };

    var innerSrc = Object(composition_api_["computed"])(function () {
      return addWebpUrl(props.src);
    });

    var loadImage = function loadImage() {
      loading.value = true;
      error.value = false;
      var img = new Image();

      img.onload = function (e) {
        return handleLoad(e, img);
      };

      img.onerror = function (e) {
        return handleError(e);
      };

      img.src = props.src;
    };

    Object(composition_api_["watch"])(function () {
      return props.src;
    }, function (val) {
      if (val && show.value) loadImage();
    });
    Object(composition_api_["watch"])(show, function (val) {
      if (val) loadImage();
    });
    var prevOverflow = '';

    var clickHandler = function clickHandler() {
      if (!preview.value) return; // prevent body scroll

      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      showPreview.value = true;
    };

    var closePreview = function closePreview() {
      document.body.style.overflow = prevOverflow;
      showPreview.value = false;
    };

    Object(composition_api_["onMounted"])(function () {
      // 是否在移动端
      var isPhone = /Mobi|Android|iPhone/i.test(window.navigator.userAgent);
      if (isPhone) show.value = false;

      if (props.lazy || isPhone) {
        var scrollContainer = props.scrollContainer;
        var _scrollContainer = null;

        if (isHtmlElement(scrollContainer)) {
          _scrollContainer = scrollContainer;
        } else if (isString(scrollContainer)) {
          _scrollContainer = document.querySelector(scrollContainer);
        } else {
          _scrollContainer = getScrollContainer(el.value);
        }

        var options = {
          root: _scrollContainer,
          rootMargin: '0px',
          threshold: 0.25
        };
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              show.value = true;
              observer.unobserve(entry.target);
            }
          });
        }, options);
        observer.observe(el.value);
      } else {
        loadImage();
      }
    });
    return {
      innerSrc: innerSrc,
      loading: loading,
      error: error,
      show: show,
      showPreview: showPreview,
      alignCenter: alignCenter,
      preview: preview,
      imageStyle: imageStyle,
      el: el,
      clickHandler: clickHandler,
      closePreview: closePreview
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-image/mc-image.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_image_mc_imagevue_type_script_lang_js_ = (mc_imagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-image/mc-image.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_image_mc_imagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_image = (component.exports);
// CONCATENATED MODULE: ./components/mc-image/index.js


/* istanbul ignore next */

mc_image.install = function (Vue) {
  Vue.component(mc_image.name, mc_image);
};

/* harmony default export */ var components_mc_image = __webpack_exports__["default"] = (mc_image);

/***/ }),

/***/ "11dc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__("8707").Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("f28c")))

/***/ }),

/***/ "11e9":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("52a7");
var createDesc = __webpack_require__("4630");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var has = __webpack_require__("69a8");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "123a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),

/***/ "124f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup

var MSI = function (_Barcode) {
	_inherits(MSI, _Barcode);

	function MSI(data, options) {
		_classCallCheck(this, MSI);

		return _possibleConstructorReturn(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
	}

	_createClass(MSI, [{
		key: "encode",
		value: function encode() {
			// Start bits
			var ret = "110";

			for (var i = 0; i < this.data.length; i++) {
				// Convert the character to binary (always 4 binary digits)
				var digit = parseInt(this.data[i]);
				var bin = digit.toString(2);
				bin = addZeroes(bin, 4 - bin.length);

				// Add 100 for every zero and 110 for every 1
				for (var b = 0; b < bin.length; b++) {
					ret += bin[b] == "0" ? "100" : "110";
				}
			}

			// End bits
			ret += "1001";

			return {
				data: ret,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]+$/) !== -1;
		}
	}]);

	return MSI;
}(_Barcode3.default);

function addZeroes(number, n) {
	for (var i = 0; i < n; i++) {
		number = "0" + number;
	}
	return number;
}

exports.default = MSI;

/***/ }),

/***/ "12d4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("fa49");

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),

/***/ "13d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tabs/mc-tabs.vue?vue&type=template&id=494b3200&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-tabs"},[_c('mtd-tabs',{attrs:{"type":_vm.tabsType},on:{"input":_vm.handleInput,"tab-click":_vm.handleTabClick},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},_vm._l((_vm.tabConfigList),function(tab){return _c('mtd-tab-pane',{key:tab.value,attrs:{"value":tab.value,"name":tab.name,"disabled":tab.disabled}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[(_vm.$slots[((tab.name) + "-label")])?_c('div',[_vm._t(((tab.name) + "-label"))],2):_c('div',[_vm._v("\n                    "+_vm._s(tab.label)+"\n                ")])]),_vm._t(tab.name)],2)}),1),(_vm.tabConfigList.length!==0)?_c('div',[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-tabs/mc-tabs.vue?vue&type=template&id=494b3200&

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tabs/mc-tabs.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_tabsvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McTabs',
  props: {
    tabConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Number, String]
    },
    type: {
      type: String,
      default: 'card'
    },
    accountSystem: {
      type: String,
      default: 'sso',
      validator: function validator(val) {
        return ['sso', 'passport', 'noauth'].includes(val);
      }
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        $hPost = _getCurrentInstance.proxy.$hPost;

    var innerValue = Object(composition_api_["ref"])(props.value);
    var tabConfigList = Object(composition_api_["ref"])(props.tabConfig);
    var tabsType = Object(composition_api_["computed"])(function () {
      return props.type === 'card' ? props.type : '';
    });
    var currentTab = Object(composition_api_["ref"])({});

    var getCurrentTab = function getCurrentTab(val, cogfigList) {
      return cogfigList.find(function (v) {
        return v.value === val;
      });
    };

    var handleInput = function handleInput(val) {
      innerValue.value = val;
      currentTab.value = getCurrentTab(val, tabConfigList.value);
      ctx.emit('input', val);
      ctx.emit('change', val, currentTab.value);

      if (currentTab.value && currentTab.value.linkTo && currentTab.value.linkTo.url) {
        var url = currentTab.value.linkTo.url;
        var params = currentTab.value.linkTo.params || {};
        var options = currentTab.value.linkTo.options || {};
        Object(tools_["linkTo"])(Object(tools_["delUrlAlias"])(Object(tools_["getFullUrl"])(url)), params, options);
      }
    };

    var handleTabClick = function handleTabClick(event) {
      ctx.emit('tabClick', event, currentTab.value);
    };

    var isPassport = Object(composition_api_["computed"])(function () {
      return props.accountSystem === 'passport';
    });
    var isWithOutAuth = Object(composition_api_["computed"])(function () {
      var authCodes = tabConfigList.value.map(function (item) {
        return item.code;
      }).filter(function (item) {
        return item !== '' && item !== undefined && item !== null;
      });
      return props.accountSystem === 'noauth' || authCodes.length === 0;
    });

    var fetchData =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var list, params, apiURL, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                list = [];
                console.log('%c%s', 'color: #994d75', isWithOutAuth.value);

                if (isWithOutAuth.value) {
                  _context.next = 11;
                  break;
                }

                params = {
                  authCodeList: tabConfigList.value.map(function (item) {
                    return item.code;
                  }),
                  systemSource: 0
                };
                apiURL = isPassport.value ? '/api/auth/check/codePermissionForClient' : '/api/auth/check/codePermission';
                _context.next = 8;
                return $hPost(apiURL, params, {
                  cache: true
                });

              case 8:
                data = _context.sent;
                ctx.emit('loaded', data);
                list = data.authList || [];

              case 11:
                tabConfigList.value = tabConfigList.value.filter(function (item) {
                  if (!item.code || isWithOutAuth.value) {
                    return true;
                  }

                  var permission = list.find(function (subItem) {
                    return subItem.authCode === item.code;
                  });
                  return permission && permission.res;
                }); // 没有任何权限抛noPermission事件

                if (!tabConfigList.value.length) {
                  ctx.emit('noPermission');
                } // 不存在对应打开页面的tab权限，直接重定向到用户拥有的第一个tab权限的tab标签页面


                if (!getCurrentTab(innerValue.value, tabConfigList.value) && tabConfigList.value[0]) {
                  handleInput(tabConfigList.value[0].value);
                }

                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 16]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    var init =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchData();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function init() {
        return _ref2.apply(this, arguments);
      };
    }();

    init();
    Object(composition_api_["watch"])(function () {
      return props.tabConfig;
    }, function (val) {
      tabConfigList.value = val || [];
      init();
    });
    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val || '';
      init();
    });
    return {
      innerValue: innerValue,
      tabConfigList: tabConfigList,
      tabsType: tabsType,
      handleInput: handleInput,
      handleTabClick: handleTabClick
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-tabs/mc-tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tabs_mc_tabsvue_type_script_lang_js_ = (mc_tabsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tabs/mc-tabs.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tabs_mc_tabsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tabs = (component.exports);
// CONCATENATED MODULE: ./components/mc-tabs/index.js


/* istanbul ignore next */

mc_tabs.install = function (Vue) {
  Vue.component(mc_tabs.name, mc_tabs);
};

/* harmony default export */ var components_mc_tabs = __webpack_exports__["default"] = (mc_tabs);

/***/ }),

/***/ "13e2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var common = __webpack_require__("edc9");
var shaCommon = __webpack_require__("aa56");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "13e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ "140b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-popconfirm/mc-popconfirm.vue?vue&type=script&lang=js&




/* harmony default export */ var mc_popconfirmvue_type_script_lang_js_ = ({
  name: 'McPopconfirm',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return this.$attrs;
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-popconfirm', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  },
  methods: {
    updatePopper: function updatePopper() {
      var _this$$refs$selfRef;

      if (this.$refs.selfRef) return (_this$$refs$selfRef = this.$refs.selfRef).updatePopper.apply(_this$$refs$selfRef, arguments);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-popconfirm/mc-popconfirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_popconfirm_mc_popconfirmvue_type_script_lang_js_ = (mc_popconfirmvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-popconfirm/mc-popconfirm.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_popconfirm_mc_popconfirmvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_popconfirm = (component.exports);
// CONCATENATED MODULE: ./components/mc-popconfirm/index.js


/* istanbul ignore next */

mc_popconfirm.install = function (Vue) {
  Vue.component(mc_popconfirm.name, mc_popconfirm);
};

/* harmony default export */ var components_mc_popconfirm = __webpack_exports__["default"] = (mc_popconfirm);

/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "14dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-anchor/mc-anchor.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_anchorvue_type_script_lang_js_ = ({
  name: 'McAnchor',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-anchor', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-anchor/mc-anchor.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_anchor_mc_anchorvue_type_script_lang_js_ = (mc_anchorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-anchor/mc-anchor.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_anchor_mc_anchorvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_anchor = (component.exports);
// CONCATENATED MODULE: ./components/mc-anchor/index.js


/* istanbul ignore next */

mc_anchor.install = function (Vue) {
  Vue.component(mc_anchor.name, mc_anchor);
};

/* harmony default export */ var components_mc_anchor = __webpack_exports__["default"] = (mc_anchor);

/***/ }),

/***/ "14ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-card/mc-card.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_cardvue_type_script_lang_js_ = ({
  name: 'McCard',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-card', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-card/mc-card.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_card_mc_cardvue_type_script_lang_js_ = (mc_cardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-card/mc-card.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_card_mc_cardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_card = (component.exports);
// CONCATENATED MODULE: ./components/mc-card/index.js


/* istanbul ignore next */

mc_card.install = function (Vue) {
  Vue.component(mc_card.name, mc_card);
};

/* harmony default export */ var components_mc_card = __webpack_exports__["default"] = (mc_card);

/***/ }),

/***/ "1545":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__("5ee7");
exports.Cipher = __webpack_require__("0184");
exports.DES = __webpack_require__("4e2b");
exports.CBC = __webpack_require__("0da4");
exports.EDE = __webpack_require__("1fec");


/***/ }),

/***/ "15da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isTest; });
/* unused harmony export env */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return s3Domain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return s3Bucket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return s3TokenUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return s3UploadAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return s3TenantId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFileName; });
/* unused harmony export getNameByUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProcessedFileName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fileUpload; });
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("96cf");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3b8d");
/* harmony import */ var _opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("75fc");
/* harmony import */ var _opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("768b");
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7f7f");
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("28a5");
/* harmony import */ var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _vue_composition_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8165");
/* harmony import */ var _vue_composition_api__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_vue_composition_api__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _mcfe_tools__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7196");
/* harmony import */ var _mcfe_tools__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_mcfe_tools__WEBPACK_IMPORTED_MODULE_7__);








var isDev = /localhost/.test(window.location.host);
var isTest = /test/.test(window.location.host);
var env = isDev ? 'dev' : isTest ? 'test' : 'pro';
var s3Domain = env === 'pro' ? 'https://s3plus.meituan.net' : 'https://msstest.sankuai.com';
var s3Bucket = 'mall-fe-files';
var s3TokenUrl = '/api/mcfe/upload/token';
var s3UploadAction = env === 'dev' ? "/mss-upload/".concat(s3Bucket) : env === 'test' ? "//msstest.sankuai.com/".concat(s3Bucket, "/") : "//s3plus.sankuai.com/".concat(s3Bucket, "/");
var s3TenantId = env === 'pro' ? '915cfe67c99b4651b81ca210670f9302' : '156341e12eb248878e532dd820706c40';

var splitFileName = function splitFileName(fileName) {
  var arr = fileName.split('.');
  var name = '',
      ext = '';

  if (arr.length === 1 || !arr[0] && arr.length === 2 || !arr[arr.length - 1]) {
    // abcd, .abcd, abcd.a..
    name = fileName;
    ext = '';
  } else {
    ext = arr.pop();
    name = arr.join('.');
  }

  return [name, ext];
};

var getFileName = function getFileName(file) {
  var fileName = file.name;

  var _splitFileName = splitFileName(fileName),
      _splitFileName2 = Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_splitFileName, 2),
      name = _splitFileName2[0],
      ext = _splitFileName2[1];

  return "".concat(name, ".").concat(Object(_mcfe_tools__WEBPACK_IMPORTED_MODULE_7__["formatDateToString"])(new Date(), 'YYYYMMDDHHmmss')).concat(ext ? '.' : '').concat(ext);
};
var getNameByUrl = function getNameByUrl(url) {
  var arr = url.split('/');
  return arr[arr.length - 1] || url;
}; // 默认生成venus处理后图片名

var getProcessedFileName = function getProcessedFileName(url) {
  var parts = url.split('.');
  parts.splice(-1, 0, 'processed');
  return parts.join('.');
};
function useUpload(_ref) {
  var uiProps = _ref.uiProps,
      uploader = _ref.uploader,
      props = _ref.props,
      ctx = _ref.ctx,
      proxy = _ref.proxy;

  var emitValue = function emitValue(fileList) {
    var list = fileList.filter(function (file) {
      return file.status === 'success';
    });
    var inputList = list.map(function (file) {
      if (!file.raw) return file.url;
      return file.raw.$url;
    });
    var inputValue = props.multiple ? inputList : inputList[0] || '';
    var changeList = list.map(function (file) {
      if (!file.raw) return file;
      return {
        url: file.raw.$url,
        name: file.raw.$fileName
      };
    });
    var changeValue = props.multiple ? changeList : changeList[0] || {};
    ctx.emit('input', inputValue);
    ctx.emit('change', changeValue);
  };

  var handleAfterSuccess = function handleAfterSuccess(res, url, file, fileList) {
    file.raw.$url = url;
    file.name = file.raw.$fileName;
    uiProps.fileList = props.multiple ? fileList : [file];
    if (props.onSuccess) props.onSuccess(res, file, fileList);
    emitValue(uiProps.fileList);
  };

  var handleError = function handleError(errMsg) {
    uiProps.fileList = Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(uiProps.fileList); // 去掉文件列表中刚刚添加的文件

    proxy.$mtd.message.error(errMsg);
  };

  var handleValueChange = function handleValueChange(value) {
    var successFileList = [];

    if (value && value.length) {
      var list = typeof value === 'string' ? [value] : value;
      successFileList = list.map(function (url) {
        return {
          url: url,
          name: getNameByUrl(url)
        };
      });
    }

    var pendingFileList = uiProps.fileList.filter(function (file) {
      return file && file.status !== 'success';
    });
    uiProps.fileList = successFileList.concat(pendingFileList);
  }; // 对外暴露清空方法


  var clearFiles = function clearFiles() {
    uploader.value.clearFiles();
    emitValue([]);
  };

  var innerOnExceed = function innerOnExceed(files, fileList) {
    if (props.onExceed) props.onExceed(files, fileList);
    proxy.$mtd.message.error("\u4E0A\u4F20\u6700\u5927\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7 ".concat(props.limit, " \u4E2A"));
  };

  var innerOnProgress = function innerOnProgress(event, file, fileList) {
    if (props.onProgress) props.onProgress(event, file, fileList);
  };

  var innerOnFileSelect = function innerOnFileSelect(fileList) {
    if (props.onFileSelect) return props.onFileSelect(fileList);
    return true;
  };

  var innerOnChange = function innerOnChange(file, fileList) {
    // uiProps.isInitState = false;
    if (props.onChange) props.onChange(file, fileList);
  };

  var innerOnError = function innerOnError(err, file, fileList) {
    if (props.onError) props.onError(err, file, fileList);
    proxy.$mtd.message.error('上传失败');
  };

  var innerBeforeRemove = function innerBeforeRemove(file, fileList) {
    var beforeRemove = props.beforeRemove(file, fileList);
    return beforeRemove;
  };

  var innerOnRemove = function innerOnRemove(file, fileList) {
    if (props.onRemove) props.onRemove(file, fileList);
    emitValue(fileList);
  }; // 同步更新fileList


  handleValueChange(props.value);
  Object(_vue_composition_api__WEBPACK_IMPORTED_MODULE_6__["watch"])(function () {
    return props.value;
  }, function (value) {
    handleValueChange(value);
  });
  return {
    handleAfterSuccess: handleAfterSuccess,
    handleError: handleError,
    clearFiles: clearFiles,
    innerOnExceed: innerOnExceed,
    innerOnProgress: innerOnProgress,
    innerOnFileSelect: innerOnFileSelect,
    innerOnChange: innerOnChange,
    innerOnError: innerOnError,
    innerBeforeRemove: innerBeforeRemove,
    innerOnRemove: innerOnRemove
  };
}
function fileUpload(_x) {
  return _fileUpload.apply(this, arguments);
}

function _fileUpload() {
  _fileUpload = Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(file) {
    var fileName, token, AWSAccessKeyId, policy, signature, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileName = getFileName(file); // hGet, requestPost, hPost

            _context.next = 3;
            return Object(_mcfe_tools__WEBPACK_IMPORTED_MODULE_7__["hGet"])(s3TokenUrl, {
              bucket: s3Bucket
            }).catch(function () {
              return null;
            });

          case 3:
            token = _context.sent;

            if (token) {
              _context.next = 6;
              break;
            }

            throw new Error('初始化失败');

          case 6:
            AWSAccessKeyId = token.AWSAccessKeyId, policy = token.policy, signature = token.signature;
            _context.next = 9;
            return Object(_mcfe_tools__WEBPACK_IMPORTED_MODULE_7__["requestPost"])(s3UploadAction, {
              awsAccessKeyId: AWSAccessKeyId,
              policy: policy,
              signature: signature,
              key: fileName,
              file: file
            }, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Accept: '*/*'
              }
            }).catch(function () {
              return 'error';
            });

          case 9:
            res = _context.sent;

            if (!(res === 'error')) {
              _context.next = 12;
              break;
            }

            throw new Error('上传失败');

          case 12:
            return _context.abrupt("return", "".concat(s3Domain, "/v1/mss_").concat(s3TenantId, "/").concat(s3Bucket, "/").concat(fileName));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fileUpload.apply(this, arguments);
}

/***/ }),

/***/ "1654":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("71c1")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("30f1")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "167b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ "1691":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "1727":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("469f"), __esModule: true };

/***/ }),

/***/ "177f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-divider/mc-divider.vue?vue&type=template&id=2460e76d&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"mc-divider"})}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-divider/mc-divider.vue?vue&type=template&id=2460e76d&functional=true&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-divider/mc-divider.vue?vue&type=script&lang=js&
//
//
//
/* harmony default export */ var mc_dividervue_type_script_lang_js_ = ({
  name: 'McDivider'
});
// CONCATENATED MODULE: ./components/mc-divider/mc-divider.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_divider_mc_dividervue_type_script_lang_js_ = (mc_dividervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-divider/mc-divider.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_divider_mc_dividervue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_divider = (component.exports);
// CONCATENATED MODULE: ./components/mc-divider/index.js


/* istanbul ignore next */

mc_divider.install = function (Vue) {
  Vue.component(mc_divider.name, mc_divider);
};

/* harmony default export */ var components_mc_divider = __webpack_exports__["default"] = (mc_divider);

/***/ }),

/***/ "17c1":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("66a5"),
    arraySome = __webpack_require__("8cf0"),
    cacheHas = __webpack_require__("55f7");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "17ed":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("d8d6"), __esModule: true };

/***/ }),

/***/ "17fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tab-pane/mc-tab-pane.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_tab_panevue_type_script_lang_js_ = ({
  name: 'McTabPane',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-tab-pane', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-tab-pane/mc-tab-pane.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tab_pane_mc_tab_panevue_type_script_lang_js_ = (mc_tab_panevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tab-pane/mc-tab-pane.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tab_pane_mc_tab_panevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tab_pane = (component.exports);
// CONCATENATED MODULE: ./components/mc-tab-pane/index.js


/* istanbul ignore next */

mc_tab_pane.install = function (Vue) {
  Vue.component(mc_tab_pane.name, mc_tab_pane);
};

/* harmony default export */ var components_mc_tab_pane = __webpack_exports__["default"] = (mc_tab_pane);

/***/ }),

/***/ "188e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tooltip/mc-tooltip.vue?vue&type=template&id=2da7f03a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-tooltip',_vm._b({ref:"selfRef",attrs:{"trigger":_vm.trigger,"title":_vm.title,"content":_vm.content,"placement":_vm.placement,"size":_vm.size,"append-to-container":_vm.appendToContainer},on:{"clickoutside":_vm.clickoutside}},'mtd-tooltip',_vm.$attrs,false),[(_vm.$slots.default)?[_vm._t("default",null,{"slot":"default"})]:_vm._e(),(_vm.$slots.content)?[_vm._t("content",null,{"slot":"content"})]:_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-tooltip/mc-tooltip.vue?vue&type=template&id=2da7f03a&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tooltip/mc-tooltip.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var mc_tooltipvue_type_script_lang_js_ = ({
  name: 'McTooltip',
  props: {
    title: String,
    content: String,
    size: String,
    trigger: {
      type: String,
      default: 'hover'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    appendToContainer: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    updatePopper: function updatePopper() {
      this.$refs.selfRef && this.$refs.selfRef.updatePopper();
    },
    clickoutside: function clickoutside(e) {
      this.$emit('clickoutside', e);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-tooltip/mc-tooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tooltip_mc_tooltipvue_type_script_lang_js_ = (mc_tooltipvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tooltip/mc-tooltip.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tooltip_mc_tooltipvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tooltip = (component.exports);
// CONCATENATED MODULE: ./components/mc-tooltip/index.js


/* istanbul ignore next */

mc_tooltip.install = function (Vue) {
  Vue.component(mc_tooltip.name, mc_tooltip);
};

/* harmony default export */ var components_mc_tooltip = __webpack_exports__["default"] = (mc_tooltip);

/***/ }),

/***/ "1907":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("8aae"), __esModule: true };

/***/ }),

/***/ "1991":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var invoke = __webpack_require__("31f4");
var html = __webpack_require__("fab2");
var cel = __webpack_require__("230e");
var global = __webpack_require__("7726");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("2d95")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "1996":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("fa49");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),

/***/ "19f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("41b2");

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__("1098b");

var _typeof3 = _interopRequireDefault(_typeof2);

exports.getFirstComponentChild = getFirstComponentChild;
exports.isVNode = isVNode;
exports.isSame = isSame;
exports.filterEmptyNode = filterEmptyNode;
exports.getProps = getProps;
exports.applyProps = applyProps;
exports.hasProps = hasProps;
exports.findVNodesDownward = findVNodesDownward;
exports.findVNodesFromSlot = findVNodesFromSlot;

var _util = __webpack_require__("db8d");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFirstComponentChild(children) {
  return children && children.find(function (c) {
    return c && c.tag;
  });
};

function isVNode(vnode) {
  return vnode !== null && (typeof vnode === 'undefined' ? 'undefined' : (0, _typeof3.default)(vnode)) === 'object' && (0, _util.hasOwn)(vnode, 'componentOptions');
};

function isSame(a, b) {
  return a === b || a && b && a.context === b.context;
}

function filterEmptyNode(vnodes) {
  return vnodes.filter(function (vnode) {
    return vnode.tag || vnode.text.trim();
  });
}

function getProps(vnode) {
  return vnode.componentOptions ? vnode.componentOptions.propsData : {};
}

function applyProps(vnode, props) {
  return (0, _extends3.default)({}, vnode, {
    componentOptions: (0, _extends3.default)({}, vnode.componentOptions, {
      propsData: (0, _extends3.default)({}, vnode.componentOptions.propsData, props)
    })
  });
}

function hasProps(vm, props) {
  if (vm && vm.$options) {
    return props in vm.$options.propsData;
  }
  return false;
}

function getComponentName(vn) {
  return (0, _util.getValueByPath)(vn, 'componentOptions.Ctor.options.name');
}
// 与 util 中不同，这里是在 vnode 侧进行查找
function findVNodesDownward(vnode, componentName) {
  var child = (vnode.componentOptions ? vnode.componentOptions.children : vnode.children) || [];
  if (child && !!child.reduce) {
    return child.reduce(function (array, vn) {
      var name = getComponentName(vn);
      if (name === componentName) array.push(vn);
      return array.concat(findVNodesDownward(vn, componentName));
    }, []);
  }
  return [];
}

function findVNodesFromSlot(slot, componentName) {
  return (slot || []).reduce(function (array, vnode) {
    if (getComponentName(vnode) === componentName) array.push(vnode);
    return array.concat(findVNodesDownward(vnode, componentName));
  }, []);
}

/***/ }),

/***/ "1a2a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("3fb5")
var Legacy = __webpack_require__("d424")
var Base = __webpack_require__("6430")
var Buffer = __webpack_require__("8707").Buffer
var md5 = __webpack_require__("5a76")
var RIPEMD160 = __webpack_require__("b5ca")

var sha = __webpack_require__("69f2")

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ "1af6":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("63b6");

$export($export.S, 'Array', { isArray: __webpack_require__("9003") });


/***/ }),

/***/ "1afe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__("975a");

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__("014d");

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__("a043");

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__("97c3");

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__("1996");

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__("9a85");

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),

/***/ "1b2b":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "1b45":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ "1ba5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EAN2 = __webpack_require__("bdfe");

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// http://www.barcodeisland.com/ean8.phtml

// Calculate the checksum digit
var checksum = function checksum(number) {
	var res = number.substr(0, 7).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a : sum + a * 3;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN8 = function (_EAN) {
	_inherits(EAN8, _EAN);

	function EAN8(data, options) {
		_classCallCheck(this, EAN8);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{7}$/) !== -1) {
			data += checksum(data);
		}

		return _possibleConstructorReturn(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
	}

	_createClass(EAN8, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(0, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(4, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
		}
	}]);

	return EAN8;
}(_EAN3.default);

exports.default = EAN8;

/***/ }),

/***/ "1bc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-affix/mc-affix.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_affixvue_type_script_lang_js_ = ({
  name: 'McAffix',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-affix', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-affix/mc-affix.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_affix_mc_affixvue_type_script_lang_js_ = (mc_affixvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-affix/mc-affix.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_affix_mc_affixvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_affix = (component.exports);
// CONCATENATED MODULE: ./components/mc-affix/index.js


/* istanbul ignore next */

mc_affix.install = function (Vue) {
  Vue.component(mc_affix.name, mc_affix);
};

/* harmony default export */ var components_mc_affix = __webpack_exports__["default"] = (mc_affix);

/***/ }),

/***/ "1bc3":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("f772");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "1c35":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("7007")
var ieee754 = __webpack_require__("823d")
var isArray = __webpack_require__("e3db")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "1c46":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__("11dc")
exports.createHash = exports.Hash = __webpack_require__("98e6")
exports.createHmac = exports.Hmac = __webpack_require__("1a2a")

var algos = __webpack_require__("116d")
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__("a099")
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__("956a")

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__("00dc")

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__("b692")

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__("e1d30")

var publicEncrypt = __webpack_require__("6442")

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__("75cc")

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),

/***/ "1c4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("9b43");
var $export = __webpack_require__("5ca1");
var toObject = __webpack_require__("4bf8");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var toLength = __webpack_require__("9def");
var createProperty = __webpack_require__("f1ae");
var getIterFn = __webpack_require__("27ee");

$export($export.S + $export.F * !__webpack_require__("5cc5")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "1ce5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),

/***/ "1cfd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ "1df8":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("63b6");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("ead6").set });


/***/ }),

/***/ "1e3c":
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__("6430")
var des = __webpack_require__("1545")
var inherits = __webpack_require__("3fb5")
var Buffer = __webpack_require__("8707").Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ "1e5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-drawer/mc-drawer.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_drawervue_type_script_lang_js_ = ({
  name: 'McDrawer',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-drawer', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-drawer/mc-drawer.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_drawer_mc_drawervue_type_script_lang_js_ = (mc_drawervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-drawer/mc-drawer.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_drawer_mc_drawervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_drawer = (component.exports);
// CONCATENATED MODULE: ./components/mc-drawer/index.js


/* istanbul ignore next */

mc_drawer.install = function (Vue) {
  Vue.component(mc_drawer.name, mc_drawer);
};

/* harmony default export */ var components_mc_drawer = __webpack_exports__["default"] = (mc_drawer);

/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
var document = __webpack_require__("e53d").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "1f2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-form/mc-form.vue?vue&type=script&lang=js&









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_formvue_type_script_lang_js_ = ({
  name: 'McForm',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-form相关组件已经弃用，请使用mc-configform组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/vRcN__7YaijKxm5F9bAQJ', 'McComponentAbandonedError');
  },
  methods: {
    validate: function () {
      var _validate = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this$$refs$selfRef;

        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.$refs.selfRef) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return (_this$$refs$selfRef = this.$refs.selfRef).validate.apply(_this$$refs$selfRef, _args);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }(),
    clearValidate: function clearValidate() {
      var _this$$refs$selfRef2;

      if (this.$refs.selfRef) return (_this$$refs$selfRef2 = this.$refs.selfRef).clearValidate.apply(_this$$refs$selfRef2, arguments);
    },
    resetFields: function resetFields() {
      var _this$$refs$selfRef3;

      if (this.$refs.selfRef) return (_this$$refs$selfRef3 = this.$refs.selfRef).resetFields.apply(_this$$refs$selfRef3, arguments);
    },
    validateField: function validateField() {
      var _this$$refs$selfRef4;

      if (this.$refs.selfRef) return (_this$$refs$selfRef4 = this.$refs.selfRef).validateField.apply(_this$$refs$selfRef4, arguments);
    },
    validateFields: function validateFields() {
      var _this$$refs$selfRef5;

      if (this.$refs.selfRef) return (_this$$refs$selfRef5 = this.$refs.selfRef).validateFields.apply(_this$$refs$selfRef5, arguments);
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-form', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-form/mc-form.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_form_mc_formvue_type_script_lang_js_ = (mc_formvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-form/mc-form.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_form_mc_formvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_form = (component.exports);
// CONCATENATED MODULE: ./components/mc-form/index.js


/* istanbul ignore next */

mc_form.install = function (Vue) {
  Vue.component(mc_form.name, mc_form);
};

/* harmony default export */ var components_mc_form = __webpack_exports__["default"] = (mc_form);

/***/ }),

/***/ "1fa8":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("cb7c");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "1fc1":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ "1fec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("da3e");
var inherits = __webpack_require__("3fb5");

var des = __webpack_require__("1545");
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2015":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-picker/mc-picker.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_pickervue_type_script_lang_js_ = ({
  name: 'McPicker',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-picker', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-picker/mc-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_picker_mc_pickervue_type_script_lang_js_ = (mc_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-picker/mc-picker.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_picker_mc_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_picker = (component.exports);
// CONCATENATED MODULE: ./components/mc-picker/index.js


/* istanbul ignore next */

mc_picker.install = function (Vue) {
  Vue.component(mc_picker.name, mc_picker);
};

/* harmony default export */ var components_mc_picker = __webpack_exports__["default"] = (mc_picker);

/***/ }),

/***/ "201b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ "206d":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__("7d2a")
var defaultEncoding = __webpack_require__("9f9d")
var sync = __webpack_require__("e07b")
var Buffer = __webpack_require__("8707").Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("f28c")))

/***/ }),

/***/ "208a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-permission/mc-permission.vue?vue&type=template&id=155a6277&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-permission",style:({ display: _vm.inline ? 'inline-block' : 'block' })},[(_vm.slots.custom)?_vm._t("custom",null,{"hasPermission":_vm.visible}):(_vm.visible)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-permission/mc-permission.vue?vue&type=template&id=155a6277&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-permission/mc-permission.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_permissionvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McPermission',
  props: {
    // 线上权限code
    code: {
      type: [String, Number, Array],
      default: ''
    },
    // 线下权限code
    devCode: {
      type: [String, Number, Array],
      default: ''
    },
    // 容器是否是行内元素
    inline: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      validator: function validator(value) {
        return ['every', 'some'].includes(value);
      },
      default: 'every'
    },
    // 区分权限接口
    accountSystem: {
      type: String,
      default: 'sso',
      validator: function validator(val) {
        return ['sso', 'passport'].includes(val);
      }
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        _getCurrentInstance$p = _getCurrentInstance.proxy,
        $hPost = _getCurrentInstance$p.$hPost,
        isProd = _getCurrentInstance$p.isProd;

    var visible = Object(composition_api_["ref"])(false);
    var devCode = props.devCode,
        code = props.code,
        type = props.type;
    var innerCode = isProd ? code : devCode || code;
    var flattenCode = Object(tools_["flatten"])([innerCode]);
    var isPassport = Object(composition_api_["computed"])(function () {
      return props.accountSystem === 'passport';
    });
    var apiURL = isPassport.value ? '/api/auth/check/codePermissionForClient' : '/api/auth/check/codePermission';
    $hPost(apiURL, {
      authCodeList: flattenCode,
      systemSource: 0 // 0-前端，1-八角，2-朝天椒

    }, {
      cache: true
    }).then(function (res) {
      res = res.authList;
      visible.value = Array.prototype[type].call(res || [], function (item) {
        return item.res;
      });
    });
    return {
      visible: visible,
      slots: ctx.slots
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-permission/mc-permission.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_permission_mc_permissionvue_type_script_lang_js_ = (mc_permissionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-permission/mc-permission.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_permission_mc_permissionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_permission = (component.exports);
// CONCATENATED MODULE: ./components/mc-permission/index.js


/* istanbul ignore next */

mc_permission.install = function (Vue) {
  Vue.component(mc_permission.name, mc_permission);
};

/* harmony default export */ var components_mc_permission = __webpack_exports__["default"] = (mc_permission);

/***/ }),

/***/ "20d6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("5ca1");
var $find = __webpack_require__("0a49")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("9c6c")(KEY);


/***/ }),

/***/ "20f6":
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__("cfbd");
decoders.pem = __webpack_require__("8df7");


/***/ }),

/***/ "20fd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("d9f6");
var createDesc = __webpack_require__("aebd");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "2137":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var assert = __webpack_require__("da3e");

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "22f8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "241e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "241ea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPCE = exports.UPC = exports.EAN2 = exports.EAN5 = exports.EAN8 = exports.EAN13 = undefined;

var _EAN = __webpack_require__("89a2");

var _EAN2 = _interopRequireDefault(_EAN);

var _EAN3 = __webpack_require__("1ba5");

var _EAN4 = _interopRequireDefault(_EAN3);

var _EAN5 = __webpack_require__("583f");

var _EAN6 = _interopRequireDefault(_EAN5);

var _EAN7 = __webpack_require__("a5d2");

var _EAN8 = _interopRequireDefault(_EAN7);

var _UPC = __webpack_require__("e8b2");

var _UPC2 = _interopRequireDefault(_UPC);

var _UPCE = __webpack_require__("be98");

var _UPCE2 = _interopRequireDefault(_UPCE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EAN13 = _EAN2.default;
exports.EAN8 = _EAN4.default;
exports.EAN5 = _EAN6.default;
exports.EAN2 = _EAN8.default;
exports.UPC = _UPC2.default;
exports.UPCE = _UPCE2.default;

/***/ }),

/***/ "2421":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ "24c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("b8e3");
var global = __webpack_require__("e53d");
var ctx = __webpack_require__("d864");
var classof = __webpack_require__("40c3");
var $export = __webpack_require__("63b6");
var isObject = __webpack_require__("f772");
var aFunction = __webpack_require__("79aa");
var anInstance = __webpack_require__("1173");
var forOf = __webpack_require__("a22a");
var speciesConstructor = __webpack_require__("f201");
var task = __webpack_require__("4178").set;
var microtask = __webpack_require__("aba2")();
var newPromiseCapabilityModule = __webpack_require__("656e");
var perform = __webpack_require__("4439");
var userAgent = __webpack_require__("bc13");
var promiseResolve = __webpack_require__("cd78");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("5168")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("5c95")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("45f2")($Promise, PROMISE);
__webpack_require__("4c95")(PROMISE);
Wrapper = __webpack_require__("584a")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("4ee1")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "2554":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ "255a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-navbar-search/mc-navbar-search.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_navbar_searchvue_type_script_lang_js_ = ({
  name: 'McNavbarSearch',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-navbar-search', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-navbar-search/mc-navbar-search.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_navbar_search_mc_navbar_searchvue_type_script_lang_js_ = (mc_navbar_searchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-navbar-search/mc-navbar-search.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_navbar_search_mc_navbar_searchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_navbar_search = (component.exports);
// CONCATENATED MODULE: ./components/mc-navbar-search/index.js


/* istanbul ignore next */

mc_navbar_search.install = function (Vue) {
  Vue.component(mc_navbar_search.name, mc_navbar_search);
};

/* harmony default export */ var components_mc_navbar_search = __webpack_exports__["default"] = (mc_navbar_search);

/***/ }),

/***/ "2568":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7f7f");
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);


var dispatch = function dispatch(proxy, componentName, eventName, params) {
  var parent = proxy.$parent || proxy.$root;
  var name = parent.$options.name || parent.$options.componentName;

  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;

    if (parent) {
      name = parent.$options.name || parent.$options.componentName;
    }
  }

  if (parent) {
    // eslint-disable-next-line prefer-spread
    parent.$emit.apply(parent, [eventName].concat(params));
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dispatch);

/***/ }),

/***/ "25b0":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1df8");
module.exports = __webpack_require__("584a").Object.setPrototypeOf;


/***/ }),

/***/ "25eb":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2638":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _extends(){return _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_extends.apply(this,arguments)}var normalMerge=["attrs","props","domProps"],toArrayMerge=["class","style","directives"],functionalMerge=["on","nativeOn"],mergeJsxProps=function(a){return a.reduce(function(c,a){for(var b in a)if(!c[b])c[b]=a[b];else if(-1!==normalMerge.indexOf(b))c[b]=_extends({},c[b],a[b]);else if(-1!==toArrayMerge.indexOf(b)){var d=c[b]instanceof Array?c[b]:[c[b]],e=a[b]instanceof Array?a[b]:[a[b]];c[b]=d.concat(e)}else if(-1!==functionalMerge.indexOf(b)){for(var f in a[b])if(c[b][f]){var g=c[b][f]instanceof Array?c[b][f]:[c[b][f]],h=a[b][f]instanceof Array?a[b][f]:[a[b][f]];c[b][f]=g.concat(h)}else c[b][f]=a[b][f];}else if("hook"==b)for(var i in a[b])c[b][i]=c[b][i]?mergeFn(c[b][i],a[b][i]):a[b][i];else c[b]=a[b];return c},{})},mergeFn=function(a,b){return function(){a&&a.apply(this,arguments),b&&b.apply(this,arguments)}};module.exports=mergeJsxProps;


/***/ }),

/***/ "26f9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ "2732":
/***/ (function(module, exports, __webpack_require__) {

const GF = __webpack_require__("699e")

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}


/***/ }),

/***/ "27a3":
/***/ (function(module, exports) {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),

/***/ "27bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("b19a");

/*<replacement>*/
var util = __webpack_require__("3a7c");
util.inherits = __webpack_require__("3fb5");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "27ee":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("23c6");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var Iterators = __webpack_require__("84f2");
module.exports = __webpack_require__("8378").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "2801":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.5.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"jscs\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"jshint\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"lint\":\"npm run jscs && npm run jshint\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^1.4.3\",\"coveralls\":\"^3.0.4\",\"grunt\":\"^1.0.4\",\"grunt-browserify\":\"^5.0.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-connect\":\"^1.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^1.0.1\",\"grunt-mocha-istanbul\":\"^3.0.1\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.2\",\"jscs\":\"^3.0.7\",\"jshint\":\"^2.6.0\",\"mocha\":\"^6.1.4\"},\"dependencies\":{\"bn.js\":\"^4.4.0\",\"brorand\":\"^1.0.1\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.0\",\"inherits\":\"^2.0.1\",\"minimalistic-assert\":\"^1.0.0\",\"minimalistic-crypto-utils\":\"^1.0.0\"}}");

/***/ }),

/***/ "2828":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-row/mc-row.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_rowvue_type_script_lang_js_ = ({
  name: 'McRow',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-row', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-row/mc-row.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_row_mc_rowvue_type_script_lang_js_ = (mc_rowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-row/mc-row.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_row_mc_rowvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_row = (component.exports);
// CONCATENATED MODULE: ./components/mc-row/index.js


/* istanbul ignore next */

mc_row.install = function (Vue) {
  Vue.component(mc_row.name, mc_row);
};

/* harmony default export */ var components_mc_row = __webpack_exports__["default"] = (mc_row);

/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "28a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("aae3");
var anObject = __webpack_require__("cb7c");
var speciesConstructor = __webpack_require__("ebd6");
var advanceStringIndex = __webpack_require__("0390");
var toLength = __webpack_require__("9def");
var callRegExpExec = __webpack_require__("5f1b");
var regexpExec = __webpack_require__("520a");
var fails = __webpack_require__("79e5");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("214f")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "2921":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ "293c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ "294c":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "29b8":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "2a4a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var START_BIN = exports.START_BIN = '1010';
var END_BIN = exports.END_BIN = '11101';

var BINARIES = exports.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];

/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2aee":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__("4111")
var aesid = __webpack_require__("d70e")
var fixProc = __webpack_require__("4dd0")
var ciphers = __webpack_require__("fda6")
var compat = __webpack_require__("a099")
var Buffer = __webpack_require__("8707").Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2bfb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ "2c63":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dc14");


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-guide/mc-guide.vue?vue&type=template&id=428bf5da&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-guide"})}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-guide/mc-guide.vue?vue&type=template&id=428bf5da&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/driver.js/dist/driver.min.js
var driver_min = __webpack_require__("c24c");
var driver_min_default = /*#__PURE__*/__webpack_require__.n(driver_min);

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-guide/mc-guide.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//



/* harmony default export */ var mc_guidevue_type_script_lang_js_ = ({
  name: 'McGuide',
  props: {
    storeKeySuffix: {
      type: String,
      default: ''
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    showOverlay: {
      type: Boolean,
      default: true
    },
    allowClose: {
      type: Boolean,
      default: false
    },
    guideConfigs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoGuide: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var innerIframeUiModalId = Object(tools_["getUuid"])();
    var opacity = props.showOverlay ? 0.75 : 0;
    var defaultButtonTextMap = {
      closeBtnText: '关闭',
      nextBtnText: '下一项',
      prevBtnText: '上一项',
      doneBtnText: '完成'
    };
    var guideInstance = Object(composition_api_["reactive"])({
      driverRef: null,
      storageKey: Object(composition_api_["computed"])(function () {
        return "[mc-guide]".concat(window.location.pathname, "-").concat(props.storeKeySuffix);
      }),
      innerGuideConfigs: [],
      // 开始引导
      startDrive: function startDrive() {
        var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (guideInstance.driverRef) {
          if (startIndex >= 0 && startIndex <= (props.guideConfigs || []).length - 1) {
            guideInstance.driverRef.start(startIndex);
          } else {
            console.error('[mc-guide]startIndex over range');
          }
        }
      },
      // 跳到下一步引导
      moveNext: function moveNext() {
        if (guideInstance.driverRef) {
          if (guideInstance.driverRef.hasNextStep()) {
            guideInstance.driverRef.moveNext();
          }
        }
      },
      // 跳到上一步引导
      movePrevious: function movePrevious() {
        if (guideInstance.driverRef) {
          guideInstance.driverRef.movePrevious();
        }
      },
      emitBytype: function emitBytype(emitType, guideConfigItem) {
        if (['next-step', 'done'].includes(emitType)) {
          guideInstance.setDone(guideInstance.storageKey);
        }

        ctx.emit(emitType, guideConfigItem);
      },
      setDone: function setDone(localKey) {
        Object(tools_["setStorage"])(localKey, true);
      }
    });

    var formatButtonText = function formatButtonText(item, textProps) {
      return (textProps || []).reduce(function (prev, next) {
        prev[next] = item[next] || defaultButtonTextMap[next];
        return prev;
      }, {});
    };

    var formatGuides = function formatGuides(configs) {
      return (configs || []).map(function (v, index) {
        return {
          element: "".concat(v.element),
          isLastOne: index,
          onHighlighted: function onHighlighted() {
            var _proxy$$me;

            proxy === null || proxy === void 0 ? void 0 : (_proxy$$me = proxy.$me) === null || _proxy$$me === void 0 ? void 0 : _proxy$$me.emit('ui-modal', 'parent', {
              id: innerIframeUiModalId,
              show: true,
              v: 1
            });
          },
          onNext: function onNext() {
            if (v.isLastOne) {
              var _proxy$$me2;

              proxy === null || proxy === void 0 ? void 0 : (_proxy$$me2 = proxy.$me) === null || _proxy$$me2 === void 0 ? void 0 : _proxy$$me2.emit('ui-modal', 'parent', {
                id: innerIframeUiModalId,
                show: false,
                v: 1
              });
              guideInstance.emitBytype('done', v);
            } else {
              guideInstance.emitBytype('next-step', v);
            }
          },
          onPrevious: function onPrevious() {
            guideInstance.emitBytype('prev-step', v);
          },
          popover: _objectSpread({
            title: v.title || ' ',
            className: 'mc-guide-driver-popover',
            description: v.description || ' ',
            showButtons: props.showButtons,
            closeBtnText: "".concat(index + 1, "/").concat(configs.length)
          }, formatButtonText(v, ['doneBtnText', 'nextBtnText', 'prevBtnText']))
        };
      });
    };

    var initDiverConfig = function initDiverConfig() {
      var driver = new driver_min_default.a({
        className: 'mc-guide-wrapper',
        allowClose: props.allowClose,
        opacity: opacity
      });
      driver.defineSteps(formatGuides(props.guideConfigs.map(function (v, index) {
        return _objectSpread({}, v, {
          isLastOne: index === props.guideConfigs.length - 1
        });
      })));
      return driver;
    };

    Object(composition_api_["onMounted"])(function () {
      try {
        var hasShow = Object(tools_["getStorage"])(guideInstance.storageKey);

        if (!guideInstance.driverRef) {
          guideInstance.driverRef = initDiverConfig();
        }

        if (hasShow !== 'true' && props.autoGuide) {
          guideInstance.startDrive();
        }
      } catch (e) {
        console.error("[mc-guide]".concat(e));
      }
    });
    Object(composition_api_["onBeforeUnmount"])(function () {
      guideInstance.driverRef = null;
    });
    var guideRefs = Object(composition_api_["toRefs"])(guideInstance);
    return _objectSpread({}, guideRefs);
  }
});
// CONCATENATED MODULE: ./components/mc-guide/mc-guide.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_guide_mc_guidevue_type_script_lang_js_ = (mc_guidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-guide/mc-guide.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_guide_mc_guidevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_guide = (component.exports);
// CONCATENATED MODULE: ./components/mc-guide/index.js


/* istanbul ignore next */

mc_guide.install = function (Vue) {
  Vue.component(mc_guide.name, mc_guide);
};

/* harmony default export */ var components_mc_guide = __webpack_exports__["default"] = (mc_guide);

/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2d9b":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("ccb4"),
    getValue = __webpack_require__("c9d8");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "2e8c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ "2f21":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("79e5");

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ "2f3a":
/***/ (function(module, exports, __webpack_require__) {

const Mode = __webpack_require__("bbf0")
const Utils = __webpack_require__("7bf0")

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),

/***/ "2f6c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3024":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "30f1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("b8e3");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var $iterCreate = __webpack_require__("8f60");
var setToStringTag = __webpack_require__("45f2");
var getPrototypeOf = __webpack_require__("53e2");
var ITERATOR = __webpack_require__("5168")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "3168":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-step/mc-step.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_stepvue_type_script_lang_js_ = ({
  name: 'McStep',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        children.push(h('template', {
          slot: name
        }, [slotVnode]));
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-step', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-step/mc-step.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_step_mc_stepvue_type_script_lang_js_ = (mc_stepvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-step/mc-step.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_step_mc_stepvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_step = (component.exports);
// CONCATENATED MODULE: ./components/mc-step/index.js


/* istanbul ignore next */

mc_step.install = function (Vue) {
  Vue.component(mc_step.name, mc_step);
};

/* harmony default export */ var components_mc_step = __webpack_exports__["default"] = (mc_step);

/***/ }),

/***/ "31f4":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "320c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "321a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var RopeSequence = _interopDefault(__webpack_require__("c21e"));
var prosemirrorTransform = __webpack_require__("b923");
var prosemirrorState = __webpack_require__("6ffb");

// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)

// Used to schedule history compression
var max_empty_items = 500;

var Branch = function Branch(items, eventCount) {
  this.items = items;
  this.eventCount = eventCount;
};

// : (EditorState, bool) → ?{transform: Transform, selection: ?SelectionBookmark, remaining: Branch}
// Pop the latest event off the branch's history and apply it
// to a document transform.
Branch.prototype.popEvent = function popEvent (state, preserveItems) {
    var this$1 = this;

  if (this.eventCount == 0) { return null }

  var end = this.items.length;
  for (;; end--) {
    var next = this$1.items.get(end - 1);
    if (next.selection) { --end; break }
  }

  var remap, mapFrom;
  if (preserveItems) {
    remap = this.remapping(end, this.items.length);
    mapFrom = remap.maps.length;
  }
  var transform = state.tr;
  var selection, remaining;
  var addAfter = [], addBefore = [];

  this.items.forEach(function (item, i) {
    if (!item.step) {
      if (!remap) {
        remap = this$1.remapping(end, i + 1);
        mapFrom = remap.maps.length;
      }
      mapFrom--;
      addBefore.push(item);
      return
    }

    if (remap) {
      addBefore.push(new Item(item.map));
      var step = item.step.map(remap.slice(mapFrom)), map;

      if (step && transform.maybeStep(step).doc) {
        map = transform.mapping.maps[transform.mapping.maps.length - 1];
        addAfter.push(new Item(map, null, null, addAfter.length + addBefore.length));
      }
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
    } else {
      transform.maybeStep(item.step);
    }

    if (item.selection) {
      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
      remaining = new Branch(this$1.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this$1.eventCount - 1);
      return false
    }
  }, this.items.length, 0);

  return {remaining: remaining, transform: transform, selection: selection}
};

// : (Transform, ?SelectionBookmark, Object) → Branch
// Create a new branch with the given transform added.
Branch.prototype.addTransform = function addTransform (transform, selection, histOptions, preserveItems) {
  var newItems = [], eventCount = this.eventCount;
  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;

  for (var i = 0; i < transform.steps.length; i++) {
    var step = transform.steps[i].invert(transform.docs[i]);
    var item = new Item(transform.mapping.maps[i], step, selection), merged = (void 0);
    if (merged = lastItem && lastItem.merge(item)) {
      item = merged;
      if (i) { newItems.pop(); }
      else { oldItems = oldItems.slice(0, oldItems.length - 1); }
    }
    newItems.push(item);
    if (selection) {
      eventCount++;
      selection = null;
    }
    if (!preserveItems) { lastItem = item; }
  }
  var overflow = eventCount - histOptions.depth;
  if (overflow > DEPTH_OVERFLOW) {
    oldItems = cutOffEvents(oldItems, overflow);
    eventCount -= overflow;
  }
  return new Branch(oldItems.append(newItems), eventCount)
};

Branch.prototype.remapping = function remapping (from, to) {
  var maps = new prosemirrorTransform.Mapping;
  this.items.forEach(function (item, i) {
    var mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
        ? mirrorPos = maps.maps.length - item.mirrorOffset : null;
    maps.appendMap(item.map, mirrorPos);
  }, from, to);
  return maps
};

Branch.prototype.addMaps = function addMaps (array) {
  if (this.eventCount == 0) { return this }
  return new Branch(this.items.append(array.map(function (map) { return new Item(map); })), this.eventCount)
};

// : (Transform, number)
// When the collab module receives remote changes, the history has
// to know about those, so that it can adjust the steps that were
// rebased on top of the remote changes, and include the position
// maps for the remote changes in its array of items.
Branch.prototype.rebased = function rebased (rebasedTransform, rebasedCount) {
  if (!this.eventCount) { return this }

  var rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);

  var mapping = rebasedTransform.mapping;
  var newUntil = rebasedTransform.steps.length;
  var eventCount = this.eventCount;
  this.items.forEach(function (item) { if (item.selection) { eventCount--; } }, start);

  var iRebased = rebasedCount;
  this.items.forEach(function (item) {
    var pos = mapping.getMirror(--iRebased);
    if (pos == null) { return }
    newUntil = Math.min(newUntil, pos);
    var map = mapping.maps[pos];
    if (item.step) {
      var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
      var selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
      if (selection) { eventCount++; }
      rebasedItems.push(new Item(map, step, selection));
    } else {
      rebasedItems.push(new Item(map));
    }
  }, start);

  var newMaps = [];
  for (var i = rebasedCount; i < newUntil; i++)
    { newMaps.push(new Item(mapping.maps[i])); }
  var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
  var branch = new Branch(items, eventCount);

  if (branch.emptyItemCount() > max_empty_items)
    { branch = branch.compress(this.items.length - rebasedItems.length); }
  return branch
};

Branch.prototype.emptyItemCount = function emptyItemCount () {
  var count = 0;
  this.items.forEach(function (item) { if (!item.step) { count++; } });
  return count
};

// Compressing a branch means rewriting it to push the air (map-only
// items) out. During collaboration, these naturally accumulate
// because each remote change adds one. The `upto` argument is used
// to ensure that only the items below a given level are compressed,
// because `rebased` relies on a clean, untouched set of items in
// order to associate old items with rebased steps.
Branch.prototype.compress = function compress (upto) {
    if ( upto === void 0 ) upto = this.items.length;

  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
  var items = [], events = 0;
  this.items.forEach(function (item, i) {
    if (i >= upto) {
      items.push(item);
      if (item.selection) { events++; }
    } else if (item.step) {
      var step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
      if (step) {
        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
        if (selection) { events++; }
        var newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
        if (merged = items.length && items[last].merge(newItem))
          { items[last] = merged; }
        else
          { items.push(newItem); }
      }
    } else if (item.map) {
      mapFrom--;
    }
  }, this.items.length, 0);
  return new Branch(RopeSequence.from(items.reverse()), events)
};

Branch.empty = new Branch(RopeSequence.empty, 0);

function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function (item, i) {
    if (item.selection && (n-- == 0)) {
      cutPoint = i;
      return false
    }
  });
  return items.slice(cutPoint)
}

var Item = function Item(map, step, selection, mirrorOffset) {
  this.map = map;
  this.step = step;
  this.selection = selection;
  this.mirrorOffset = mirrorOffset;
};

Item.prototype.merge = function merge (other) {
  if (this.step && other.step && !other.selection) {
    var step = other.step.merge(this.step);
    if (step) { return new Item(step.getMap().invert(), step, this.selection) }
  }
};

// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
var HistoryState = function HistoryState(done, undone, prevRanges, prevTime) {
  this.done = done;
  this.undone = undone;
  this.prevRanges = prevRanges;
  this.prevTime = prevTime;
};

var DEPTH_OVERFLOW = 20;

// : (HistoryState, EditorState, Transaction, Object)
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
  var historyTr = tr.getMeta(historyKey), rebased;
  if (historyTr) { return historyTr.historyState }

  if (tr.getMeta(closeHistoryKey)) { history = new HistoryState(history.done, history.undone, null, 0); }

  var appended = tr.getMeta("appendedTransaction");

  if (tr.steps.length == 0) {
    return history
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo)
      { return new HistoryState(history.done.addTransform(tr, null, options, mustPreserveItems(state)),
                              history.undone, rangesFor(tr.mapping.maps[tr.steps.length - 1]), history.prevTime) }
    else
      { return new HistoryState(history.done, history.undone.addTransform(tr, null, options, mustPreserveItems(state)),
                              null, history.prevTime) }
  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    // Group transforms that occur in quick succession into one event.
    var newGroup = history.prevTime < (tr.time || 0) - options.newGroupDelay ||
        !appended && !isAdjacentTo(tr, history.prevRanges);
    var prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps[tr.steps.length - 1]);
    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null,
                                                      options, mustPreserveItems(state)),
                            Branch.empty, prevRanges, tr.time)
  } else if (rebased = tr.getMeta("rebased")) {
    // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new HistoryState(history.done.rebased(tr, rebased),
                            history.undone.rebased(tr, rebased),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  } else {
    return new HistoryState(history.done.addMaps(tr.mapping.maps),
                            history.undone.addMaps(tr.mapping.maps),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  }
}

function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges) { return false }
  if (!transform.docChanged) { return true }
  var adjacent = false;
  transform.mapping.maps[0].forEach(function (start, end) {
    for (var i = 0; i < prevRanges.length; i += 2)
      { if (start <= prevRanges[i + 1] && end >= prevRanges[i])
        { adjacent = true; } }
  });
  return adjacent
}

function rangesFor(map) {
  var result = [];
  map.forEach(function (_from, _to, from, to) { return result.push(from, to); });
  return result
}

function mapRanges(ranges, mapping) {
  if (!ranges) { return null }
  var result = [];
  for (var i = 0; i < ranges.length; i += 2) {
    var from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
    if (from <= to) { result.push(from, to); }
  }
  return result
}

// : (HistoryState, EditorState, (tr: Transaction), bool)
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function histTransaction(history, state, dispatch, redo) {
  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
  if (!pop) { return }

  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(),
                                                                  histOptions, preserveItems);

  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0);
  dispatch(pop.transform.setSelection(selection).setMeta(historyKey, {redo: redo, historyState: newHist}).scrollIntoView());
}

var cachedPreserveItems = false;
var cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i = 0; i < plugins.length; i++) { if (plugins[i].spec.historyPreserveItems) {
      cachedPreserveItems = true;
      break
    } }
  }
  return cachedPreserveItems
}

// :: (Transaction) → Transaction
// Set a flag on the given transaction that will prevent further steps
// from being appended to an existing history event (so that they
// require a separate undo command to undo).
function closeHistory(tr) {
  return tr.setMeta(closeHistoryKey, true)
}

var historyKey = new prosemirrorState.PluginKey("history");
var closeHistoryKey = new prosemirrorState.PluginKey("closeHistory");

// :: (?Object) → Plugin
// Returns a plugin that enables the undo history for an editor. The
// plugin will track undo and redo stacks, which can be used with the
// [`undo`](#history.undo) and [`redo`](#history.redo) commands.
//
// You can set an `"addToHistory"` [metadata
// property](#state.Transaction.setMeta) of `false` on a transaction
// to prevent it from being rolled back by undo.
//
//   config::-
//   Supports the following configuration options:
//
//     depth:: ?number
//     The amount of history events that are collected before the
//     oldest events are discarded. Defaults to 100.
//
//     newGroupDelay:: ?number
//     The delay between changes after which a new group should be
//     started. Defaults to 500 (milliseconds). Note that when changes
//     aren't adjacent, a new group is always started.
function history(config) {
  config = {depth: config && config.depth || 100,
            newGroupDelay: config && config.newGroupDelay || 500};
  return new prosemirrorState.Plugin({
    key: historyKey,

    state: {
      init: function init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0)
      },
      apply: function apply(tr, hist, state) {
        return applyTransaction(hist, state, tr, config)
      }
    },

    config: config
  })
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that undoes the last change, if any.
function undo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.done.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, false); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that redoes the last undone change, if any.
function redo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.undone.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, true); }
  return true
}

// :: (EditorState) → number
// The amount of undoable events available in a given state.
function undoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.done.eventCount : 0
}

// :: (EditorState) → number
// The amount of redoable events available in a given editor state.
function redoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.undone.eventCount : 0
}

exports.HistoryState = HistoryState;
exports.closeHistory = closeHistory;
exports.history = history;
exports.undo = undo;
exports.redo = redo;
exports.undoDepth = undoDepth;
exports.redoDepth = redoDepth;
//# sourceMappingURL=history.js.map


/***/ }),

/***/ "32a6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("241e");
var $keys = __webpack_require__("c3a1");

__webpack_require__("ce7e")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "32fc":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("e53d").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "3300":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("f3a3");
var BN = __webpack_require__("399f");
var inherits = __webpack_require__("3fb5");
var Base = __webpack_require__("ea53");

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ "3337":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__("2801").version;
elliptic.utils = __webpack_require__("f3a3");
elliptic.rand = __webpack_require__("fdac");
elliptic.curve = __webpack_require__("4136");
elliptic.curves = __webpack_require__("0cbb");

// Protocols
elliptic.ec = __webpack_require__("b9a8");
elliptic.eddsa = __webpack_require__("945d");


/***/ }),

/***/ "335c":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("6b4c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "3364":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-date-time-picker/mc-date-time-picker.vue?vue&type=template&id=76a48372&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTimePrefix)?_c('mtd-time-picker',_vm._g(_vm._b({},'mtd-time-picker',_vm.timeProps,false),_vm.innerTimeEvents)):_c('mtd-date-picker',_vm._g(_vm._b({},'mtd-date-picker',_vm.dateProps,false),_vm.innerDateEvents),[_c('template',{slot:"shortcuts"},[_vm._t("shortcutsSlot")],2)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-date-time-picker/mc-date-time-picker.vue?vue&type=template&id=76a48372&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("768b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__("ffc1");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-date-time-picker/mc-date-time-picker.vue?vue&type=script&lang=js&










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var getDefaultFormat = function getDefaultFormat(type, format) {
  var isValueFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (format) {
    return format;
  }

  var week = 'yyyy-WW';
  var weekrange = 'yyyy-WW';
  var quarter = 'yyyy-Q'; // 当 type 是 week 时，只有 format 是 yyyy-WW，valueFormat 要是 timestamp
  // 因为使用者对于这是第几周的定义可能与组件的定义不同

  if (isValueFormat) {
    week = 'timestamp';
    weekrange = 'timestamp';
    quarter = 'timestamp';
  }

  var obj = {
    quarter: quarter,
    weekrange: weekrange,
    week: week,
    daterange: 'yyyy-MM-dd',
    date: 'yyyy-MM-dd',
    dates: 'yyyy-MM-dd',
    datetime: 'yyyy-MM-dd HH:mm:ss',
    datetimerange: 'yyyy-MM-dd HH:mm:ss',
    year: 'yyyy',
    monthrange: 'yyyy-MM',
    month: 'yyyy-MM',
    timerange: 'HH:mm:ss',
    time: 'HH:mm:ss'
  };
  return obj[type];
};

var mc_date_time_pickervue_type_script_lang_js_getKeysObj = function getKeysObj(obj, list) {
  return Object.entries(obj).reduce(function (acc, cur) {
    var _cur = Object(slicedToArray["a" /* default */])(cur, 2),
        key = _cur[0],
        value = _cur[1];

    if (list.includes(key)) {
      return _objectSpread({}, acc, Object(defineProperty["a" /* default */])({}, key, value));
    }

    return acc;
  }, {});
};

/* harmony default export */ var mc_date_time_pickervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McDateTimePicker',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Array, Date]
    },
    type: {
      validator: function validator(value) {
        return ['quarter', 'weekrange', 'week', 'daterange', 'date', 'dates', 'datetime', 'datetimerange', 'year', 'monthrange', 'month', 'timerange', 'time'].includes(value);
      },
      default: 'date'
    },
    format: {
      type: String,
      default: undefined
    },
    valueFormat: {
      type: String,
      default: undefined
    },
    dateOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    timeOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    timeEvents: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    modelKey: {
      type: Array,
      default: function _default() {
        return ['fromDate', 'toDate'];
      }
    },
    modelValue: {
      type: Object,
      default: undefined
    }
  },
  setup: function setup(props, ctx) {
    var type = props.type,
        format = props.format,
        valueFormat = props.valueFormat,
        dateOptions = props.dateOptions,
        timeOptions = props.timeOptions,
        timeEvents = props.timeEvents,
        modelKey = props.modelKey,
        modelValue = props.modelValue;
    var original = Object(composition_api_["reactive"])({
      extraDateOptions: {}
    });
    var isModelKey = Object(composition_api_["computed"])(function () {
      return modelValue !== undefined && /range$/.test(type);
    });
    var innerFormat = Object(composition_api_["computed"])(function () {
      return getDefaultFormat(type, format);
    });
    var innerValueFormat = Object(composition_api_["computed"])(function () {
      return getDefaultFormat(type, valueFormat, true);
    });
    var innerAttrs = Object(composition_api_["computed"])(function () {
      // 可接受的 props 列表
      var propsList = ['editable', 'defaultTime', 'open', 'weekStart', 'splitPanels', 'readonly', 'disabled', 'clearable', 'placeholder', 'popperClass', 'showBtnNow'];
      return mc_date_time_pickervue_type_script_lang_js_getKeysObj(ctx.attrs, propsList);
    });
    var dateProps = Object(composition_api_["computed"])(function () {
      var extraObj = {
        type: type,
        // 默认不展示「此刻」按钮
        showBtnNow: false,
        multiple: false
      };

      if (type === 'dates') {
        extraObj.type = 'date';
        extraObj.multiple = true;
      }

      if (isModelKey.value) {
        extraObj.value = [modelValue[modelKey[0]], modelValue[modelKey[1]]];
      }

      return _objectSpread({
        options: _objectSpread({}, dateOptions, {}, original.extraDateOptions),
        timePickerOptions: timeOptions,
        format: innerFormat.value,
        valueFormat: innerValueFormat.value,
        value: props.value
      }, extraObj, {}, innerAttrs.value);
    });
    var timeProps = Object(composition_api_["computed"])(function () {
      var extraObj = {};

      if (isModelKey.value) {
        extraObj.value = [modelValue[modelKey[0]], modelValue[modelKey[1]]];
      }

      return _objectSpread({
        type: type,
        format: innerFormat.value,
        valueFormat: innerValueFormat.value,
        value: props.value
      }, extraObj, {}, innerAttrs.value, {}, timeOptions);
    });
    var innerInput = Object(composition_api_["computed"])(function () {
      if (isModelKey.value) {
        return function (val) {
          var _objectSpread3;

          ctx.emit('update:modelValue', _objectSpread({}, modelValue, (_objectSpread3 = {}, Object(defineProperty["a" /* default */])(_objectSpread3, modelKey[0], val[0]), Object(defineProperty["a" /* default */])(_objectSpread3, modelKey[1], val[1]), _objectSpread3)));
        };
      }

      return function (val) {
        return ctx.emit('input', val);
      };
    });
    var innerTimeEvents = Object(composition_api_["computed"])(function () {
      return _objectSpread({
        input: innerInput.value
      }, timeEvents);
    });

    var pickRange = function pickRange(_ref) {
      var from = _ref.from,
          selecting = _ref.selecting;

      if (typeof dateOptions.limitDays !== 'number') {
        return;
      }

      var dateFn = typeof dateOptions.disabledDate === 'function' ? dateOptions.disabledDate : function () {
        return false;
      };

      var limitDateFn = function limitDateFn(date) {
        var dayNum = 1000 * 60 * 60 * 24 * (dateOptions.limitDays - 1);
        return date.getTime() > from.getTime() + dayNum || date.getTime() < from.getTime() - dayNum;
      };

      if (!selecting) {
        original.extraDateOptions = {
          disabledDate: dateFn
        };
      } else {
        original.extraDateOptions = {
          // 结合 limitDays 和 disabledDate 生成
          disabledDate: function disabledDate(date) {
            return limitDateFn(date) || dateFn(date);
          }
        };
      }
    };

    var innerDateEvents = Object(composition_api_["computed"])(function () {
      return _objectSpread({
        input: innerInput.value,
        'pick-range': pickRange
      }, ctx.listeners);
    });
    var isTimePrefix = Object(composition_api_["computed"])(function () {
      return /^time/.test(type);
    });
    return {
      innerTimeEvents: innerTimeEvents,
      innerDateEvents: innerDateEvents,
      timeProps: timeProps,
      dateProps: dateProps,
      isTimePrefix: isTimePrefix
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-date-time-picker/mc-date-time-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_date_time_picker_mc_date_time_pickervue_type_script_lang_js_ = (mc_date_time_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-date-time-picker/mc-date-time-picker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_date_time_picker_mc_date_time_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_date_time_picker = (component.exports);
// CONCATENATED MODULE: ./components/mc-date-time-picker/index.js


/* istanbul ignore next */

mc_date_time_picker.install = function (Vue) {
  Vue.component(mc_date_time_picker.name, mc_date_time_picker);
};

/* harmony default export */ var components_mc_date_time_picker = __webpack_exports__["default"] = (mc_date_time_picker);

/***/ }),

/***/ "33a4":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("84f2");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "343e":
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__("3768");
encoders.pem = __webpack_require__("85b3");


/***/ }),

/***/ "349c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CODE39 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_39#Encoding

var CODE39 = function (_Barcode) {
	_inherits(CODE39, _Barcode);

	function CODE39(data, options) {
		_classCallCheck(this, CODE39);

		data = data.toUpperCase();

		// Calculate mod43 checksum if enabled
		if (options.mod43) {
			data += getCharacter(mod43checksum(data));
		}

		return _possibleConstructorReturn(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
	}

	_createClass(CODE39, [{
		key: "encode",
		value: function encode() {
			// First character is always a *
			var result = getEncoding("*");

			// Take every character and add the binary representation to the result
			for (var i = 0; i < this.data.length; i++) {
				result += getEncoding(this.data[i]) + "0";
			}

			// Last character is always a *
			result += getEncoding("*");

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
		}
	}]);

	return CODE39;
}(_Barcode3.default);

// All characters. The position in the array is the (checksum) value


var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];

// The decimal representation of the characters, is converted to the
// corresponding binary with the getEncoding function
var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];

// Get the binary representation of a character by converting the encodings
// from decimal to binary
function getEncoding(character) {
	return getBinary(characterValue(character));
}

function getBinary(characterValue) {
	return encodings[characterValue].toString(2);
}

function getCharacter(characterValue) {
	return characters[characterValue];
}

function characterValue(character) {
	return characters.indexOf(character);
}

function mod43checksum(data) {
	var checksum = 0;
	for (var i = 0; i < data.length; i++) {
		checksum += characterValue(data[i]);
	}

	checksum = checksum % 43;
	return checksum;
}

exports.CODE39 = CODE39;

/***/ }),

/***/ "34e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-option/mc-option.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_optionvue_type_script_lang_js_ = ({
  name: 'McOption',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-option', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-option/mc-option.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_option_mc_optionvue_type_script_lang_js_ = (mc_optionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-option/mc-option.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_option_mc_optionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_option = (component.exports);
// CONCATENATED MODULE: ./components/mc-option/index.js


/* istanbul ignore next */

mc_option.install = function (Vue) {
  Vue.component(mc_option.name, mc_option);
};

/* harmony default export */ var components_mc_option = __webpack_exports__["default"] = (mc_option);

/***/ }),

/***/ "34fc":
/***/ (function(module, exports, __webpack_require__) {

const ECLevel = __webpack_require__("7a43")

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),

/***/ "3505":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer
var xor = __webpack_require__("8c8a")

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ "355d":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "35e8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var createDesc = __webpack_require__("aebd");
module.exports = __webpack_require__("8e60") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "3673":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-enum-text/mc-enum-text.vue?vue&type=template&id=55d90f42&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mc-enum-text"},[_vm._v(_vm._s(_vm.getLabelByValue(_vm.value, _vm.enumList)))])}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-enum-text/mc-enum-text.vue?vue&type=template&id=55d90f42&

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("75fc");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./composables/enum.js







var enum_processEnumData = function processEnumData(data, dictCode, allValue) {
  if (Object(esm_typeof["a" /* default */])(data) !== 'object') {
    throw new Error('枚举接口返回数据结构有误');
  }

  if (!data[dictCode]) {
    throw new Error("\u679A\u4E3E\u63A5\u53E3\u8FD4\u56DE\u6570\u636E\u4E0D\u5305\u542B".concat(dictCode));
  }

  data = data[dictCode].dictionaryValueList.map(function (item) {
    return {
      label: item.name,
      value: item.key
    };
  });
  if (allValue || allValue === 0) data.unshift({
    label: '全部',
    value: allValue
  });
  return data;
};

var genDicRemoteConfig = function genDicRemoteConfig(dictCode) {
  return {
    type: 'hPost',
    url: '/api/m/tms/mapi/dictionary/batchGetDictionaryAndValue',
    params: {
      dicCodes: [dictCode]
    },
    options: {
      cache: true
    }
  };
};

function getEnumList(_x, _x2) {
  return _getEnumList.apply(this, arguments);
}

function _getEnumList() {
  _getEnumList = Object(asyncToGenerator["a" /* default */])(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(source, allValue) {
    var remoteConfig, dictCode, _remoteConfig, _remoteConfig$type, type, _remoteConfig$url, url, _remoteConfig$params, params, _remoteConfig$options, options, res;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!Array.isArray(source)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Object(tools_["cloneDeep"])(source));

          case 2:
            // source 为 dictCode
            remoteConfig = {};
            dictCode = '';

            if (!(typeof source === 'string' && source)) {
              _context.next = 9;
              break;
            }

            dictCode = source;
            remoteConfig = genDicRemoteConfig(source);
            _context.next = 10;
            break;

          case 9:
            return _context.abrupt("return", []);

          case 10:
            _remoteConfig = remoteConfig, _remoteConfig$type = _remoteConfig.type, type = _remoteConfig$type === void 0 ? 'post' : _remoteConfig$type, _remoteConfig$url = _remoteConfig.url, url = _remoteConfig$url === void 0 ? '' : _remoteConfig$url, _remoteConfig$params = _remoteConfig.params, params = _remoteConfig$params === void 0 ? {} : _remoteConfig$params, _remoteConfig$options = _remoteConfig.options, options = _remoteConfig$options === void 0 ? {} : _remoteConfig$options;
            _context.next = 13;
            return external_vue_default.a.prototype["$".concat(type)](url, params, options);

          case 13:
            res = _context.sent;
            return _context.abrupt("return", enum_processEnumData(res, dictCode, allValue));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getEnumList.apply(this, arguments);
}
// EXTERNAL MODULE: ./composables/useRemote.js
var useRemote = __webpack_require__("9ea3");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-enum-text/mc-enum-text.vue?vue&type=script&lang=js&





//
//
//




/* harmony default export */ var mc_enum_textvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McEnumText',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    source: {
      type: [String, Array, Object],
      default: function _default() {
        return '';
      }
    },
    allValue: {
      type: [String, Number],
      default: ''
    }
  },
  setup: function setup(props, ctx) {
    var enumList = Object(composition_api_["ref"])([]);
    var isRemote = Object(composition_api_["computed"])(function () {
      return props.source && Object(esm_typeof["a" /* default */])(props.source) === 'object' && Object(esm_typeof["a" /* default */])(props.source.ajax) === 'object';
    });

    var initData =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _useRemote, fetchData, remoteEnumList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isRemote.value) {
                  _context.next = 9;
                  break;
                }

                _useRemote = Object(useRemote["a" /* default */])(props.source, ctx), fetchData = _useRemote.fetchData;
                _context.next = 4;
                return fetchData();

              case 4:
                remoteEnumList = _context.sent;

                if (props.allValue || props.allValue === 0) {
                  remoteEnumList.unshift({
                    label: '全部',
                    value: props.allValue
                  });
                }

                enumList.value = Object(toConsumableArray["a" /* default */])(remoteEnumList);
                _context.next = 10;
                break;

              case 9:
                getEnumList(props.source, props.allValue).then(function (res) {
                  enumList.value = res;
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();

    initData();
    Object(composition_api_["watch"])(function () {
      return props.source;
    }, function () {
      return initData();
    });
    return {
      getLabelByValue: tools_["getLabelByValue"],
      enumList: enumList
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-enum-text/mc-enum-text.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_enum_text_mc_enum_textvue_type_script_lang_js_ = (mc_enum_textvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-enum-text/mc-enum-text.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_enum_text_mc_enum_textvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_enum_text = (component.exports);
// CONCATENATED MODULE: ./components/mc-enum-text/index.js


/* istanbul ignore next */

mc_enum_text.install = function (Vue) {
  Vue.component(mc_enum_text.name, mc_enum_text);
};

/* harmony default export */ var components_mc_enum_text = __webpack_exports__["default"] = (mc_enum_text);

/***/ }),

/***/ "36c3":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("335c");
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "3702":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("481b");
var ITERATOR = __webpack_require__("5168")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "3768":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5");
var Buffer = __webpack_require__("1c35").Buffer;

var asn1 = __webpack_require__("7f7a");
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),

/***/ "37a5":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "37c8":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("2b4c");


/***/ }),

/***/ "380f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("f3a3");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ "3846":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("9e1e") && /./g.flags != 'g') __webpack_require__("86cc").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("0bfb")
});


/***/ }),

/***/ "386b":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("5ca1");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),

/***/ "3886":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "399f":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(2).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "39a6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ "39bd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ "39f5":
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__("8707").Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ "3a38":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "3a39":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ "3a6c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ "3a72":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var LIBRARY = __webpack_require__("2d00");
var wksExt = __webpack_require__("37c8");
var defineProperty = __webpack_require__("86cc").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "3a7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "3b1b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                '_'
            ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ "3b2b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var inheritIfRequired = __webpack_require__("5dbc");
var dP = __webpack_require__("86cc").f;
var gOPN = __webpack_require__("9093").f;
var isRegExp = __webpack_require__("aae3");
var $flags = __webpack_require__("0bfb");
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__("9e1e") && (!CORRECT_NEW || __webpack_require__("79e5")(function () {
  re2[__webpack_require__("2b4c")('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__("2aba")(global, 'RegExp', $RegExp);
}

__webpack_require__("7a56")('RegExp');


/***/ }),

/***/ "3b8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
/* harmony import */ var _core_js_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("795b");
/* harmony import */ var _core_js_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_core_js_promise__WEBPACK_IMPORTED_MODULE_0__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    _core_js_promise__WEBPACK_IMPORTED_MODULE_0___default.a.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new _core_js_promise__WEBPACK_IMPORTED_MODULE_0___default.a(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "3c0d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ "3c11":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("63b6");
var core = __webpack_require__("584a");
var global = __webpack_require__("e53d");
var speciesConstructor = __webpack_require__("f201");
var promiseResolve = __webpack_require__("cd78");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "3c35":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(this, {}))

/***/ }),

/***/ "3c7c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("2a4a");

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITF = function (_Barcode) {
	_inherits(ITF, _Barcode);

	function ITF() {
		_classCallCheck(this, ITF);

		return _possibleConstructorReturn(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
	}

	_createClass(ITF, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^([0-9]{2})+$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var _this2 = this;

			// Calculate all the digit pairs
			var encoded = this.data.match(/.{2}/g).map(function (pair) {
				return _this2.encodePair(pair);
			}).join('');

			return {
				data: _constants.START_BIN + encoded + _constants.END_BIN,
				text: this.text
			};
		}

		// Calculate the data of a number pair

	}, {
		key: 'encodePair',
		value: function encodePair(pair) {
			var second = _constants.BINARIES[pair[1]];

			return _constants.BINARIES[pair[0]].split('').map(function (first, idx) {
				return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
			}).join('');
		}
	}]);

	return ITF;
}(_Barcode3.default);

exports.default = ITF;

/***/ }),

/***/ "3c7d":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "3da8":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "3daf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("f3a3");
var BN = __webpack_require__("399f");
var inherits = __webpack_require__("3fb5");
var Base = __webpack_require__("ea53");

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ "3dbb":
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'

var pako = require('pako/lib/inflate.js')

module.exports = function (data) {
  return pako.inflateRaw(data, { to: 'string' })
}

},{"pako/lib/inflate.js":4}],2:[function(require,module,exports){
'use strict'

// Reverse of
// http://plantuml.sourceforge.net/codejavascript2.html

// It is described as being "a transformation close to base64"
// The code has been slightly modified to pass linters

function decode6bit (cc) {
  var c = cc.charCodeAt(0)
  if (cc === '_') return 63
  if (cc === '-') return 62
  if (c >= 97) return c - 61 // - 97 + 26 + 10
  if (c >= 65) return c - 55 // - 65 + 10
  if (c >= 48) return c - 48
  return '?'
}

function extract3bytes (data) {
  var c1 = decode6bit(data[0])
  var c2 = decode6bit(data[1])
  var c3 = decode6bit(data[2])
  var c4 = decode6bit(data[3])
  var b1 = c1 << 2 | (c2 >> 4) & 0x3F
  var b2 = (c2 << 4) & 0xF0 | (c3 >> 2) & 0xF
  var b3 = (c3 << 6) & 0xC0 | c4 & 0x3F

  return [b1, b2, b3]
}

module.exports = function (data) {
  var r = ''
  var i = 0
  for (i = 0; i < data.length; i += 4) {
    var t = extract3bytes(data.substring(i, i + 4))
    r = r + String.fromCharCode(t[0])
    r = r + String.fromCharCode(t[1])
    r = r + String.fromCharCode(t[2])
  }
  return r
}

},{}],3:[function(require,module,exports){
'use strict'

var inflate = require('./inflate')
var decode64 = require('./decode64')

module.exports.decode = function (encoded) {
  var deflated = decode64(encoded)
  return inflate(deflated)
}

},{"./decode64":2,"./inflate":1}],4:[function(require,module,exports){
'use strict';


var zlib_inflate = require('./zlib/inflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var c            = require('./zlib/constants');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');
var GZheader     = require('./zlib/gzheader');

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":5,"./utils/strings":6,"./zlib/constants":8,"./zlib/gzheader":10,"./zlib/inflate":12,"./zlib/messages":14,"./zlib/zstream":15}],5:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],6:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":5}],7:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],8:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],9:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],10:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;

},{}],11:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],12:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":5,"./adler32":7,"./crc32":9,"./inffast":11,"./inftrees":13}],13:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":5}],14:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],15:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}]},{},[3])(3)
});


/***/ }),

/***/ "3de5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ "3e6c":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("6a9b"),
    getRawTag = __webpack_require__("b868"),
    objectToString = __webpack_require__("c110");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "3e92":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ "3ef4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-navbar-icon-item/mc-navbar-icon-item.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_navbar_icon_itemvue_type_script_lang_js_ = ({
  name: 'McNavbarIconItem',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-navbar-icon-item', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-navbar-icon-item/mc-navbar-icon-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_navbar_icon_item_mc_navbar_icon_itemvue_type_script_lang_js_ = (mc_navbar_icon_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-navbar-icon-item/mc-navbar-icon-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_navbar_icon_item_mc_navbar_icon_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_navbar_icon_item = (component.exports);
// CONCATENATED MODULE: ./components/mc-navbar-icon-item/index.js


/* istanbul ignore next */

mc_navbar_icon_item.install = function (Vue) {
  Vue.component(mc_navbar_icon_item.name, mc_navbar_icon_item);
};

/* harmony default export */ var components_mc_navbar_icon_item = __webpack_exports__["default"] = (mc_navbar_icon_item);

/***/ }),

/***/ "3f02":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("cc09");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "3f62":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ "3f63":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("0de1"),
    equalArrays = __webpack_require__("17c1"),
    equalByTag = __webpack_require__("6da3"),
    equalObjects = __webpack_require__("da65"),
    getTag = __webpack_require__("b471"),
    isArray = __webpack_require__("e987"),
    isBuffer = __webpack_require__("92a9"),
    isTypedArray = __webpack_require__("593d");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "3f6b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("51b6"), __esModule: true };

/***/ }),

/***/ "3fb5":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "3fc6":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "4006":
/***/ (function(module, exports, __webpack_require__) {

const Utils = __webpack_require__("45be")

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),

/***/ "4029":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("fb07");
} else {}


/***/ }),

/***/ "406d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table/mc-table.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_tablevue_type_script_lang_js_ = ({
  name: 'McTable',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-table相关组件已经弃用，请使用mc-table-pro组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/WerpN4aDBhcJN_fOD2dFh', 'McComponentAbandonedError');
  },
  methods: {
    doReflow: function doReflow() {
      var _this$$refs$selfRef;

      if (this.$refs.selfRef) return (_this$$refs$selfRef = this.$refs.selfRef).doReflow.apply(_this$$refs$selfRef, arguments);
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-table', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-table/mc-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_table_mc_tablevue_type_script_lang_js_ = (mc_tablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-table/mc-table.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_table_mc_tablevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_table = (component.exports);
// CONCATENATED MODULE: ./components/mc-table/index.js


/* istanbul ignore next */

mc_table.install = function (Vue) {
  Vue.component(mc_table.name, mc_table);
};

/* harmony default export */ var components_mc_table = __webpack_exports__["default"] = (mc_table);

/***/ }),

/***/ "4079":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/mc-poi-view.vue?vue&type=template&id=134fef07&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-poi-view"},[(_vm.mode === 'all')?_c('span',[_vm._v("全部")]):(_vm.mode === 'poi')?_c('poi-view',_vm._b({},'poi-view',_vm.bindData,false)):(_vm.mode === 'city')?_c('city-view',_vm._b({},'city-view',_vm.bindData,false)):(_vm.mode === 'stationCluster')?_c('cluster-view',_vm._b({},'cluster-view',_vm.bindData,false)):_c('span',[_vm._v("--")])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-poi-view/mc-poi-view.vue?vue&type=template&id=134fef07&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.symbol.async-iterator.js
var es7_symbol_async_iterator = __webpack_require__("ac4d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__("8a81");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/components/PoiView.vue?vue&type=template&id=9c41c9b6&
var PoiViewvue_type_template_id_9c41c9b6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:{ horizontal: _vm.isHorizontal }},[_vm._l((_vm.formatPoiMap),function(poiDataList,cityId){return [(+cityId)?_c('div',{key:cityId,staticClass:"city-item"},[_c('mtd-popover',{key:cityId,attrs:{"placement":"right","trigger":"hover"}},[_c('div',{staticClass:"trigger"},[_c('span',[_vm._v(_vm._s(poiDataList[0].cityName))]),_c('mc-button',{attrs:{"type":"text"}},[_vm._v("\n                        ("+_vm._s(poiDataList.length)+"门店)\n                    ")])],1),_c('mtd-table',{attrs:{"slot":"content","max-height":"500","data":poiDataList},slot:"content"},[_c('mtd-table-column',{attrs:{"prop":"poiId","label":"ID","width":"60"}}),_c('mtd-table-column',{attrs:{"prop":"poiName","label":"门店名称","width":"240"}})],1)],1)],1):_vm._e()]}),(_vm.formatPoiMap[0])?_c('mtd-tooltip',{attrs:{"content":_vm.formatPoiMap[0].map(function (item) { return item.poiId; }).join('、'),"placement":"top"}},[_c('div',{staticClass:"error-tips"},[_vm._v("\n            异常门店\n        ")])]):_vm._e()],2)}
var PoiViewvue_type_template_id_9c41c9b6_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-poi-view/components/PoiView.vue?vue&type=template&id=9c41c9b6&

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("d225");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js
var createClass = __webpack_require__("b0b4");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./components/mc-poi-view/composable/poiSharer.js







var TEN_MIN = 10 * 60 * 1000;
var loadTime = 0;

var poiSharer_PoiSharer =
/*#__PURE__*/
function () {
  function PoiSharer() {
    Object(classCallCheck["a" /* default */])(this, PoiSharer);

    this.poiMap = {};
    this.regionMap = {};
    this.cityMap = {};
    this.clusterMap = {};
  }

  Object(createClass["a" /* default */])(PoiSharer, [{
    key: "initPoiMap",
    value: function () {
      var _initPoiMap = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var isForce,
            nowTime,
            _ref,
            list,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isForce = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                nowTime = new Date().valueOf();

                if (!(!isForce && nowTime - loadTime < TEN_MIN)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                loadTime = nowTime;
                _context.next = 7;
                return external_vue_default.a.prototype.$hPost('/api/poi/city/aggregation/stationCluster/list/search', {
                  includeTestPoi: true,
                  needEmptyPoiResult: true
                }).catch(function (e) {
                  _this.$message({
                    type: 'error',
                    message: e.data && e.data.msg || '获取全量门店数据失败'
                  });

                  loadTime = 0;
                  return [];
                });

              case 7:
                _ref = _context.sent;
                list = _ref.list;
                list.forEach(function (poiData) {
                  external_vue_default.a.set(_this.poiMap, poiData.poiId, poiData);

                  if (!_this.regionMap[poiData.regionOrgId]) {
                    external_vue_default.a.set(_this.regionMap, poiData.regionId, {
                      regionName: poiData.regionName
                    });
                  }

                  if (!_this.cityMap[poiData.cityId]) {
                    external_vue_default.a.set(_this.cityMap, poiData.cityId, {
                      cityName: poiData.cityName
                    });
                  }

                  var stationClusterId = poiData.stationClusterId,
                      managementCityId = poiData.managementCityId,
                      managementCityName = poiData.managementCityName,
                      stationClusterName = poiData.stationClusterName;

                  if (!_this.clusterMap[stationClusterId]) {
                    external_vue_default.a.set(_this.clusterMap, stationClusterId, {
                      managementCityId: managementCityId,
                      managementCityName: managementCityName,
                      stationClusterId: stationClusterId,
                      stationClusterName: stationClusterName,
                      clusterName: "".concat(managementCityName, "-").concat(stationClusterName)
                    });
                  }
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initPoiMap() {
        return _initPoiMap.apply(this, arguments);
      }

      return initPoiMap;
    }()
  }]);

  return PoiSharer;
}();

/* harmony default export */ var poiSharer = (new poiSharer_PoiSharer());
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/components/PoiView.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var PoiViewvue_type_script_lang_js_ = ({
  name: 'PoiView',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sharer: poiSharer
    };
  },
  computed: {
    formatPoiMap: function formatPoiMap() {
      var poiMap = this.sharer.poiMap;
      if (Object(tools_["isEmpty"])(poiMap)) return {};
      return this.value.reduce(function (result, poiId) {
        var selectData = poiMap[poiId] || {
          poiId: poiId,
          cityId: 0
        };
        var cityId = selectData.cityId;
        if (!result[cityId]) result[cityId] = [];
        result[cityId].push(selectData);
        return result;
      }, {});
    }
  },
  watch: {},
  mounted: function mounted() {
    this.sharer.initPoiMap();
  },
  methods: {}
});
// CONCATENATED MODULE: ./components/mc-poi-view/components/PoiView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PoiViewvue_type_script_lang_js_ = (PoiViewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-poi-view/components/PoiView.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_PoiViewvue_type_script_lang_js_,
  PoiViewvue_type_template_id_9c41c9b6_render,
  PoiViewvue_type_template_id_9c41c9b6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PoiView = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/components/CityView.vue?vue&type=template&id=6ecdb65f&
var CityViewvue_type_template_id_6ecdb65f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.cityNameStr))])}
var CityViewvue_type_template_id_6ecdb65f_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-poi-view/components/CityView.vue?vue&type=template&id=6ecdb65f&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/components/CityView.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//


/* harmony default export */ var CityViewvue_type_script_lang_js_ = ({
  name: 'CityView',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      sharer: poiSharer
    };
  },
  computed: {
    cityNameStr: function cityNameStr() {
      var cityMap = this.sharer.cityMap;
      if (Object(tools_["isEmpty"])(cityMap)) return {};
      var cityNameArr = this.value.reduce(function (result, cityId) {
        var cityName = cityMap[cityId] ? cityMap[cityId].cityName : '';
        if (cityName) result[cityName] = '';
        return result;
      }, {});
      return Object.keys(cityNameArr).join('、');
    }
  },
  watch: {},
  mounted: function mounted() {
    this.sharer.initPoiMap();
  },
  methods: {}
});
// CONCATENATED MODULE: ./components/mc-poi-view/components/CityView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CityViewvue_type_script_lang_js_ = (CityViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-poi-view/components/CityView.vue





/* normalize component */

var CityView_component = Object(componentNormalizer["a" /* default */])(
  components_CityViewvue_type_script_lang_js_,
  CityViewvue_type_template_id_6ecdb65f_render,
  CityViewvue_type_template_id_6ecdb65f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CityView = (CityView_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/components/ClusterView.vue?vue&type=template&id=6d7a19f8&
var ClusterViewvue_type_template_id_6d7a19f8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:{ horizontal: _vm.isHorizontal }},_vm._l((_vm.formatClusterMap),function(poiDataList,cityId){return _c('div',{key:cityId,staticClass:"city-item"},[_c('mtd-popover',{key:cityId,staticStyle:{"display":"block"},attrs:{"placement":"right","trigger":"hover"}},[_c('div',{staticClass:"trigger"},[_c('span',[_vm._v(_vm._s(poiDataList[0].managementCityName))]),_c('mc-button',{attrs:{"type":"text"}},[_vm._v("\n                    ("+_vm._s(poiDataList.length)+"站群)\n                ")])],1),_c('mtd-table',{attrs:{"slot":"content","max-height":"500","data":poiDataList},slot:"content"},[_c('mtd-table-column',{attrs:{"prop":"stationClusterId","label":"ID","width":"60"}}),_c('mtd-table-column',{attrs:{"prop":"stationClusterName","label":"站群名称","width":"240"}})],1)],1)],1)}),0)}
var ClusterViewvue_type_template_id_6d7a19f8_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-poi-view/components/ClusterView.vue?vue&type=template&id=6d7a19f8&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/components/ClusterView.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ClusterViewvue_type_script_lang_js_ = ({
  name: 'ClusterView',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sharer: poiSharer
    };
  },
  computed: {
    formatClusterMap: function formatClusterMap() {
      var clusterMap = this.sharer.clusterMap;
      if (Object(tools_["isEmpty"])(clusterMap)) return {};
      return this.value.reduce(function (result, poiId) {
        var selectData = clusterMap[poiId];

        if (selectData) {
          if (!result[selectData.managementCityId]) result[selectData.managementCityId] = [];
          result[selectData.managementCityId].push(selectData);
        }

        return result;
      }, {});
    }
  },
  watch: {},
  mounted: function mounted() {
    this.sharer.initPoiMap();
  },
  methods: {}
});
// CONCATENATED MODULE: ./components/mc-poi-view/components/ClusterView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ClusterViewvue_type_script_lang_js_ = (ClusterViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-poi-view/components/ClusterView.vue





/* normalize component */

var ClusterView_component = Object(componentNormalizer["a" /* default */])(
  components_ClusterViewvue_type_script_lang_js_,
  ClusterViewvue_type_template_id_6d7a19f8_render,
  ClusterViewvue_type_template_id_6d7a19f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ClusterView = (ClusterView_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-view/mc-poi-view.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mc_poi_viewvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McPoiView',
  components: {
    PoiView: PoiView,
    CityView: CityView,
    ClusterView: ClusterView
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mode: {
      type: String,
      default: 'poi'
    },
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var bindData = Object(composition_api_["computed"])(function () {
      return {
        key: Symbol(),
        value: props.value,
        isHorizontal: props.isHorizontal
      };
    });
    return {
      bindData: bindData
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-poi-view/mc-poi-view.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_poi_view_mc_poi_viewvue_type_script_lang_js_ = (mc_poi_viewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-poi-view/mc-poi-view.vue





/* normalize component */

var mc_poi_view_component = Object(componentNormalizer["a" /* default */])(
  mc_poi_view_mc_poi_viewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_poi_view = (mc_poi_view_component.exports);
// CONCATENATED MODULE: ./components/mc-poi-view/index.js


/* istanbul ignore next */

mc_poi_view.install = function (Vue) {
  Vue.component(mc_poi_view.name, mc_poi_view);
};

/* harmony default export */ var components_mc_poi_view = __webpack_exports__["default"] = (mc_poi_view);

/***/ }),

/***/ "407a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js
var helper = __webpack_require__("2638");
var helper_default = /*#__PURE__*/__webpack_require__.n(helper);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-searchform/components/FormItem.vue?vue&type=script&lang=js&





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var FormItemvue_type_script_lang_js_ = ({
  name: 'McFormItem',
  props: {
    field: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render(h) {
    var field = this.field,
        formData = this.formData,
        $slots = this.$slots;
    var template = field.template,
        slot = field.slot;

    if (template) {
      var attrs = template.attrs,
          events = template.events,
          component = template.component;

      if (component && typeof component === 'function') {
        return component.call({
          $createElement: h
        }, field, formData);
      }

      return h(component, {
        props: _objectSpread({}, attrs, {
          value: formData[field.prop]
        }),
        attrs: _objectSpread({}, attrs, {
          value: formData[field.prop]
        }),
        on: _objectSpread({}, events, {
          input: function input(val) {
            formData[field.prop] = val;
          }
        })
      });
    } else if (slot) {
      return h("div", [$slots.default]);
    } else {
      return h("mtd-input", {
        "attrs": {
          "value": formData[field.prop],
          "placeholder": "\u8BF7\u8F93\u5165".concat(field.label)
        },
        "on": {
          "input": function input(val) {
            formData[field.prop] = val;
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./components/mc-searchform/components/FormItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FormItemvue_type_script_lang_js_ = (FormItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-searchform/components/FormItem.vue
var FormItem_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_FormItemvue_type_script_lang_js_,
  FormItem_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormItem = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-searchform/components/RenderTips.vue?vue&type=script&lang=js&
/* harmony default export */ var RenderTipsvue_type_script_lang_js_ = ({
  functional: true,
  render: function render(h, ctx) {
    var tips = ctx.props.tips;
    var content = Array.isArray(tips) ? tips : [tips];
    return h("mtd-tooltip", {
      "attrs": {
        "placement": "top"
      }
    }, [h("i", {
      "class": "mtdicon mtdicon-info-circle-o demo-icon demo-icon-label"
    }), h("div", {
      "slot": "content"
    }, [content.map(function (text) {
      return h("div", [text]);
    })])]);
  }
});
// CONCATENATED MODULE: ./components/mc-searchform/components/RenderTips.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RenderTipsvue_type_script_lang_js_ = (RenderTipsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-searchform/components/RenderTips.vue
var RenderTips_render, RenderTips_staticRenderFns




/* normalize component */

var RenderTips_component = Object(componentNormalizer["a" /* default */])(
  components_RenderTipsvue_type_script_lang_js_,
  RenderTips_render,
  RenderTips_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RenderTips = (RenderTips_component.exports);
// EXTERNAL MODULE: ./components/mc-divider/index.js + 5 modules
var mc_divider = __webpack_require__("177f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-searchform/mc-searchform.vue?vue&type=script&lang=js&






/* harmony default export */ var mc_searchformvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McSearchform',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showSubmit: {
      type: Boolean,
      default: true
    },
    showReset: {
      type: Boolean,
      default: true
    },
    maxShowNum: {
      type: Number,
      default: 8
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: Number,
      default: 100
    }
  },
  setup: function setup(props, ctx) {
    var searchFormRef = Object(composition_api_["ref"])(null);
    var formData = Object(composition_api_["reactive"])(props.value);
    var showAll = Object(composition_api_["ref"])(props.fields.length < props.maxShowNum);
    var innerFields = Object(composition_api_["computed"])(function () {
      return props.fields.filter(function (field) {
        var _field$visible = field.visible,
            visible = _field$visible === void 0 ? true : _field$visible;
        if (typeof visible === 'function') visible = visible(formData);
        return visible !== false;
      }).map(function (field) {
        if (field.template) {
          if (field.template.attrs) {
            if (!field.template.attrs.placeholder) {
              field.template.attrs.placeholder = "\u8BF7\u9009\u62E9".concat(field.label);
            }
          } else {
            field.template.attrs = {
              placeholder: "\u8BF7\u9009\u62E9".concat(field.label)
            };
          }
        } else if (!field.placeholder) {
          field.placeholder = "\u8BF7\u8F93\u5165".concat(field.label);
        }

        return field;
      });
    });
    var hasMore = Object(composition_api_["computed"])(function () {
      return innerFields.value.length > props.maxShowNum;
    });

    var onSubmit = function onSubmit(event) {
      event.preventDefault();
      ctx.emit('submit');
    };

    var onReset = function onReset(event) {
      event.preventDefault();
      ctx.emit('reset');
    };

    var validate = function validate() {
      return searchFormRef.value.validate();
    };

    var clearValidate = function clearValidate() {
      return searchFormRef.value.clearValidate();
    };

    Object(composition_api_["watch"])(function () {
      return formData;
    }, function (val) {
      ctx.emit('input', val);
    }, {
      deep: true
    });
    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      Object.assign(formData, val);
    }, {
      deep: true
    });
    return {
      searchFormRef: searchFormRef,
      formData: formData,
      innerFields: innerFields,
      showAll: showAll,
      hasMore: hasMore,
      onSubmit: onSubmit,
      onReset: onReset,
      validate: validate,
      clearValidate: clearValidate
    };
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];

    var _this = this;

    return h("div", {
      "class": "mc-searchform"
    }, [h("mtd-loading", {
      "attrs": {
        "loading": this.loading
      }
    }, [h("mtd-form", helper_default()([{
      "ref": "searchFormRef"
    }, {
      "props": {
        model: this.formData
      }
    }, {
      "attrs": {
        "rules": this.rules,
        "inline": true,
        "size": "small",
        "disabled": this.disabled,
        "labelWidth": this.labelWidth
      }
    }, {
      "nativeOn": {
        submit: function submit(event) {
          _this.onSubmit(event);
        },
        reset: function reset(event) {
          _this.onReset(event);
        }
      }
    }, {
      "style": {
        marginBottom: '15px'
      }
    }]), [h("div", {
      "style": {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }, [this.innerFields.map(function (field, idx) {
      return h("mtd-form-item", {
        "key": field.prop,
        "attrs": {
          "prop": field.prop,
          "labelWidth": field.labelWidth
        },
        "style": {
          display: idx + 1 > _this2.maxShowNum && !_this2.showAll ? 'none' : 'inline-block'
        }
      }, [h("span", {
        "slot": "label"
      }, [field.label, field.tips && field.tips.length > 0 && h(RenderTips, {
        "attrs": {
          "tips": field.tips
        }
      })]), h(FormItem, {
        "attrs": {
          "field": field,
          "formData": _this2.formData
        }
      }, [field.slot && _this2.$slots[field.slot]])]);
    })]), h("div", {
      "class": "operations-container"
    }, [this.hasMore && h("mtd-button", {
      "attrs": {
        "type": "text-primary"
      },
      "on": {
        "click": function click() {
          _this2.showAll = !_this2.showAll;
        }
      },
      "style": {
        marginRight: '10px'
      }
    }, [this.showAll ? h("span", ["\u6536\u8D77", h("i", {
      "class": "mtdicon mtdicon-up"
    })]) : h("span", ["\u5C55\u5F00", h("i", {
      "class": "mtdicon mtdicon-down"
    })])]), this.showSubmit && h("mtd-button", {
      "attrs": {
        "type": "primary",
        "html-type": "submit"
      },
      "style": {
        marginRight: '10px'
      }
    }, ["\u67E5\u8BE2"]), this.showReset && h("mtd-button", {
      "attrs": {
        "html-type": "reset"
      },
      "style": {
        marginRight: '10px'
      }
    }, ["\u91CD\u7F6E"]), this.$scopedSlots && this.$scopedSlots.customBtnSlot && this.$scopedSlots.customBtnSlot({// loading: this.loading,
    }) || this.$slots && this.$slots.customBtnSlot])])]), h(mc_divider["default"])]);
  }
}));
// CONCATENATED MODULE: ./components/mc-searchform/mc-searchform.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_searchform_mc_searchformvue_type_script_lang_js_ = (mc_searchformvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-searchform/mc-searchform.vue
var mc_searchform_render, mc_searchform_staticRenderFns




/* normalize component */

var mc_searchform_component = Object(componentNormalizer["a" /* default */])(
  mc_searchform_mc_searchformvue_type_script_lang_js_,
  mc_searchform_render,
  mc_searchform_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_searchform = (mc_searchform_component.exports);
// CONCATENATED MODULE: ./components/mc-searchform/index.js


/* istanbul ignore next */

mc_searchform.install = function (Vue) {
  Vue.component(mc_searchform.name, mc_searchform);
};

/* harmony default export */ var components_mc_searchform = __webpack_exports__["default"] = (mc_searchform);

/***/ }),

/***/ "409b":
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),

/***/ "40b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "40c3":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("6b4c");
var TAG = __webpack_require__("5168")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "40c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-ellipsis/mc-ellipsis.vue?vue&type=template&id=6a1f6380&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-ellipsis"},[_vm._t("prefix"),(_vm.computedReady)?[_c('mtd-tooltip',{attrs:{"content":_vm.value,"disabled":!_vm.toolTipEnable||!_vm.oversize,"placement":_vm.tooltipPlacement,"open-delay":500}},[_c('div',[_c('div',{staticClass:"mc-ellipsis-text"},[_c('span',{ref:"text"},[_vm._v("\n                        "+_vm._s(_vm.value || '--')+"\n                    ")]),(_vm.showEllipsis && _vm.oversize && !_vm.isExpand)?_c('span',[_vm._v("...")]):_vm._e(),(_vm.value && _vm.enableCopy && _vm.showAtEllipsisEnd)?_c('mtd-icon-button',{staticClass:"mc-detail-info-copy-icon",attrs:{"icon":_vm.isCopySuccess ? 'mtdicon mtdicon-check' : 'mtdicon mtdicon-copy-o',"size":"small"},on:{"click":_vm.onCopy}}):_vm._e()],1),(_vm.value)?_c('div',{staticStyle:{"text-align":"center"}},[(_vm.showExpandButton)?_c('span',{staticClass:"mc-ellipsis-showAll",on:{"click":_vm.handleShowAll}},[_vm._v(" "+_vm._s(_vm.isExpand ? '折叠' : '展开'))]):_vm._e(),(_vm.enableCopy && _vm.showAtExpand)?_c('mtd-icon-button',{staticClass:"mc-detail-info-copy-icon",attrs:{"icon":_vm.isCopySuccess ? 'mtdicon mtdicon-check' : 'mtdicon mtdicon-copy-o',"size":"small"},on:{"click":_vm.onCopy}}):_vm._e()],1):_vm._e()])])]:_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-ellipsis/mc-ellipsis.vue?vue&type=template&id=6a1f6380&

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// CONCATENATED MODULE: ./components/mc-ellipsis/utils.js


var isClient = typeof window !== 'undefined';
var SPECIAL_CHARS_REGEXP = /([:-]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;

function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
}

function getStyle(element, styleName) {
  if (!isClient) return null;

  if (!element || !styleName) {
    return null;
  }

  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'cssFloat';
  }

  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || (computed ? computed[styleName] : null);
  } catch (e) {
    return element.style[styleName];
  }
}
var getStrFullLength = function getStrFullLength() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.split('').reduce(function (pre, cur) {
    var charCode = cur.charCodeAt(0);

    if (charCode >= 0 && charCode <= 128) {
      return pre + 1;
    }

    return pre + 2;
  }, 0);
};
var cutStrByFullLength = function cutStrByFullLength() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLength = arguments.length > 1 ? arguments[1] : undefined;
  var showLength = 0;
  return str.split('').reduce(function (pre, cur) {
    var charCode = cur.charCodeAt(0);

    if (charCode >= 0 && charCode <= 128) {
      showLength += 1;
    } else {
      showLength += 2;
    }

    if (showLength <= maxLength) {
      return pre + cur;
    }

    return pre;
  }, '');
};
/* harmony default export */ var utils = ({});
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-ellipsis/mc-ellipsis.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_ellipsisvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McEllipsis',
  props: {
    value: {
      type: String,
      default: ''
    },
    // 限制高度
    height: {
      type: Number
    },
    // 限制行数，将换算为 height。如果设置了 height，则直接使用 height 计算
    lines: {
      type: Number,
      validator: function validator(value) {
        return value >= 1;
      }
    },
    // 按照指定长度截取
    length: {
      type: Number
    },
    // toolTip 是否禁用
    toolTipEnable: {
      type: Boolean,
      default: true
    },
    // toolTip 的位置
    tooltipPlacement: {
      type: String,
      default: 'top'
    },
    // 是否开启复制
    enableCopy: {
      type: Boolean,
      default: false
    },
    // 是否显示展开按钮
    showExpandButton: {
      type: Boolean,
      default: false
    },
    // 是否显示省略号
    showEllipsis: {
      type: Boolean,
      default: true
    },
    showAtEllipsisEnd: {
      type: Boolean,
      default: false
    },
    showAtExpand: {
      type: Boolean,
      default: false
    },
    // 是否将全角字符的长度视为2来计算字符串长度，适用于 length
    fullWidthRecognition: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var isCopySuccess = Object(composition_api_["ref"])(false);
    var subText = Object(composition_api_["ref"])('');
    var isExpand = Object(composition_api_["ref"])(false);
    var oversize = Object(composition_api_["ref"])(false);
    var computedReady = Object(composition_api_["ref"])(false); // 先隐形计算，计算好后，再根据配置显示

    var computedText = Object(composition_api_["ref"])('');
    var text = Object(composition_api_["ref"])(null);

    var calculateText =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var $el, showText, height, lineHeight, textLength;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                oversize.value = false;
                computedReady.value = false;
                _context.next = 4;
                return Object(composition_api_["nextTick"])();

              case 4:
                $el = proxy.$el;
                showText = props.value;
                height = props.height;

                if (!height && props.lines && props.lines >= 1) {
                  lineHeight = parseInt(getStyle($el, 'lineHeight'), 10);
                  height = lineHeight * props.lines;
                }

                if (!text.value) {
                  _context.next = 23;
                  break;
                }

                if (!props.length) {
                  _context.next = 14;
                  break;
                }

                textLength = props.fullWidthRecognition ? getStrFullLength(props.value) : props.value.length;

                if (textLength > props.length) {
                  oversize.value = true;
                  showText = props.fullWidthRecognition ? cutStrByFullLength(props.value, props.length) : props.value.slice(0, props.length);
                  text.value.innerText = showText;
                }

                _context.next = 23;
                break;

              case 14:
                if (!($el.offsetHeight > height)) {
                  _context.next = 23;
                  break;
                }

                oversize.value = true;

              case 16:
                if (!($el.offsetHeight > height)) {
                  _context.next = 23;
                  break;
                }

                showText = showText.slice(0, -1);
                text.value.innerText = showText;
                _context.next = 21;
                return Object(composition_api_["nextTick"])();

              case 21:
                _context.next = 16;
                break;

              case 23:
                subText.value = showText;
                computedText.value = showText;

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function calculateText() {
        return _ref.apply(this, arguments);
      };
    }();

    var showSuccess = function showSuccess() {
      isCopySuccess.value = true;
      setTimeout(function () {
        isCopySuccess.value = false;
      }, 1500);
    };

    var onCopy = function onCopy() {
      var content = props.value;

      if (content) {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          navigator.clipboard.writeText(content).then(function () {
            showSuccess();
          }).catch(function () {
            isCopySuccess.value = false;
          });
        } else {
          var copyInput = document.createElement('input');
          copyInput.value = content;
          document.body.appendChild(copyInput);
          copyInput.select();
          document.execCommand('Copy');
          copyInput.remove();
          showSuccess();
        }
      }
    };

    var limitShow =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                computedReady.value = true;

                if (!text.value) {
                  _context2.next = 5;
                  break;
                }

                text.value.innerText = computedText.value;
                _context2.next = 5;
                return Object(composition_api_["nextTick"])();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function limitShow() {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleShowAll = function handleShowAll() {
      // navigator.clipboard.writeText(props.value);
      if (isExpand.value) {
        text.value.innerText = subText.value;
        ctx.emit('fold');
      } else {
        text.value.innerText = props.value;
        ctx.emit('expand');
      }

      isExpand.value = !isExpand.value;
    };

    var init = function init() {
      calculateText();
      limitShow();

      if (!oversize.value && text.value) {
        text.value.innerText = props.value;
      }
    };

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function () {
      init();
    });
    Object(composition_api_["watch"])(function () {
      return props.height;
    }, function () {
      init();
    });
    Object(composition_api_["watch"])(function () {
      return props.lines;
    }, function () {
      init();
    });
    Object(composition_api_["onMounted"])(function () {
      init();
    });
    return {
      onCopy: onCopy,
      isCopySuccess: isCopySuccess,
      isExpand: isExpand,
      handleShowAll: handleShowAll,
      oversize: oversize,
      computedReady: computedReady,
      computedText: computedText,
      calculateText: calculateText,
      text: text,
      limitShow: limitShow
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-ellipsis/mc-ellipsis.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_ellipsis_mc_ellipsisvue_type_script_lang_js_ = (mc_ellipsisvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-ellipsis/mc-ellipsis.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_ellipsis_mc_ellipsisvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_ellipsis = (component.exports);
// CONCATENATED MODULE: ./components/mc-ellipsis/index.js


/* istanbul ignore next */

mc_ellipsis.install = function (Vue) {
  Vue.component(mc_ellipsis.name, mc_ellipsis);
};

/* harmony default export */ var components_mc_ellipsis = __webpack_exports__["default"] = (mc_ellipsis);

/***/ }),

/***/ "40e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-dropdown/mc-dropdown.vue?vue&type=template&id=855b1dd0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-dropdown"},[_c('mtd-dropdown',_vm._g(_vm._b({attrs:{"trigger":_vm.trigger,"show-arrow":_vm.showArrow,"disabled":_vm.disabled},on:{"input":_vm.handleInput},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mtd-dropdown',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.trigger)?_vm._t("trigger"):_c('mc-button',_vm._b({},'mc-button',_vm.dropdownButtonProps,false),[_vm._v("\n            "+_vm._s(_vm.dropdownText)+"\n            "),_c('i',{staticClass:"mtdicon mtdicon-down"})]),_c('mtd-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_vm._t("dropdown"),_vm._l((_vm.options),function(item){return _c('mtd-dropdown-menu-item',{key:((item.name) + "_" + (item.value)),on:{"click":function($event){return _vm.handleDropdownClick(item)}}},[_vm._v("\n                "+_vm._s(item.label)+"\n            ")])})],2)],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-dropdown/mc-dropdown.vue?vue&type=template&id=855b1dd0&

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-dropdown/mc-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_dropdownvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McDropdown',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: 'click'
    },
    showArrow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dropdownText: {
      type: String,
      default: ''
    },
    dropdownButtonProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props, ctx) {
    var innerValue = Object(composition_api_["ref"])(false);

    var handleDropdownClick = function handleDropdownClick(item) {
      ctx.emit('dropdownClick', item.value, item);
    };

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val;
    });

    var handleInput = function handleInput(val) {
      ctx.emit('input', val);
    };

    return {
      handleInput: handleInput,
      innerValue: innerValue,
      handleDropdownClick: handleDropdownClick
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-dropdown/mc-dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_dropdown_mc_dropdownvue_type_script_lang_js_ = (mc_dropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-dropdown/mc-dropdown.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_dropdown_mc_dropdownvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_dropdown = (component.exports);
// CONCATENATED MODULE: ./components/mc-dropdown/index.js


/* istanbul ignore next */

mc_dropdown.install = function (Vue) {
  Vue.component(mc_dropdown.name, mc_dropdown);
};

/* harmony default export */ var components_mc_dropdown = __webpack_exports__["default"] = (mc_dropdown);

/***/ }),

/***/ "4106":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4111":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__("7f7a")

exports.certificate = __webpack_require__("56b5")

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),

/***/ "4136":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__("ea53");
curve.short = __webpack_require__("3300");
curve.mont = __webpack_require__("676f");
curve.edwards = __webpack_require__("3daf");


/***/ }),

/***/ "4146":
/***/ (function(module, exports, __webpack_require__) {

const Utils = __webpack_require__("45be")

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),

/***/ "4178":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("d864");
var invoke = __webpack_require__("3024");
var html = __webpack_require__("32fc");
var cel = __webpack_require__("1ec9");
var global = __webpack_require__("e53d");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("6b4c")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "41b2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("3f6b");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "41bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-radio-button/mc-radio-button.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_radio_buttonvue_type_script_lang_js_ = ({
  name: 'McRadioButton',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-radio-button组件已经弃用，请使用mc-choice组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/aWRcgaz4faYOZ7ubzF_33', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-radio-button', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-radio-button/mc-radio-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_radio_button_mc_radio_buttonvue_type_script_lang_js_ = (mc_radio_buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-radio-button/mc-radio-button.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_radio_button_mc_radio_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_radio_button = (component.exports);
// CONCATENATED MODULE: ./components/mc-radio-button/index.js


/* istanbul ignore next */

mc_radio_button.install = function (Vue) {
  Vue.component(mc_radio_button.name, mc_radio_button);
};

/* harmony default export */ var components_mc_radio_button = __webpack_exports__["default"] = (mc_radio_button);

/***/ }),

/***/ "41df":
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__("d1c8").Reporter;
base.DecoderBuffer = __webpack_require__("6283").DecoderBuffer;
base.EncoderBuffer = __webpack_require__("6283").EncoderBuffer;
base.Node = __webpack_require__("8360");


/***/ }),

/***/ "41f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("551c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.promise.finally.js
var es7_promise_finally = __webpack_require__("097d");

// EXTERNAL MODULE: external "@ss/mtd-vue"
var mtd_vue_ = __webpack_require__("6a79");

// EXTERNAL MODULE: ./components/mc-panel/index.js + 5 modules
var mc_panel = __webpack_require__("a7ab");

// EXTERNAL MODULE: ./components/mc-link/index.js + 5 modules
var mc_link = __webpack_require__("e18d");

// EXTERNAL MODULE: ./components/mc-select/index.js + 5 modules
var mc_select = __webpack_require__("7bbc9");

// EXTERNAL MODULE: ./components/mc-detail-info/index.js + 16 modules
var mc_detail_info = __webpack_require__("b084");

// EXTERNAL MODULE: ./components/mc-title/index.js + 3 modules
var mc_title = __webpack_require__("55b7");

// EXTERNAL MODULE: ./components/mc-sensitive-info/index.js + 5 modules
var mc_sensitive_info = __webpack_require__("4436");

// EXTERNAL MODULE: ./components/mc-level-select/index.js + 59 modules
var mc_level_select = __webpack_require__("54b9");

// EXTERNAL MODULE: ./components/mc-poi-select/index.js + 7 modules
var mc_poi_select = __webpack_require__("a86e");

// EXTERNAL MODULE: ./components/mc-table-pro/index.js + 46 modules
var mc_table_pro = __webpack_require__("83c2");

// EXTERNAL MODULE: ./components/mc-enum-text/index.js + 6 modules
var mc_enum_text = __webpack_require__("3673");

// EXTERNAL MODULE: ./components/mc-permission/index.js + 5 modules
var mc_permission = __webpack_require__("208a");

// EXTERNAL MODULE: ./components/mc-searchform/index.js + 9 modules
var mc_searchform = __webpack_require__("407a");

// EXTERNAL MODULE: ./components/mc-divider/index.js + 5 modules
var mc_divider = __webpack_require__("177f");

// EXTERNAL MODULE: ./components/mc-configform/index.js + 14 modules
var mc_configform = __webpack_require__("10a3");

// EXTERNAL MODULE: ./components/mc-input/index.js + 6 modules
var mc_input = __webpack_require__("8a5f");

// EXTERNAL MODULE: ./components/mc-form-group/index.js + 5 modules
var mc_form_group = __webpack_require__("6cd7");

// EXTERNAL MODULE: ./components/mc-city-select/index.js + 6 modules
var mc_city_select = __webpack_require__("f90b");

// EXTERNAL MODULE: ./components/mc-date-time-picker/index.js + 5 modules
var mc_date_time_picker = __webpack_require__("3364");

// EXTERNAL MODULE: ./components/mc-breadcrumb/index.js + 5 modules
var mc_breadcrumb = __webpack_require__("7163");

// EXTERNAL MODULE: ./components/mc-tabs/index.js + 5 modules
var mc_tabs = __webpack_require__("13d9");

// EXTERNAL MODULE: ./components/mc-image-preview/index.js
var mc_image_preview = __webpack_require__("09bb");

// EXTERNAL MODULE: ./components/mc-user-select/index.js + 5 modules
var mc_user_select = __webpack_require__("0ad2");

// EXTERNAL MODULE: ./components/mc-tree-select/index.js + 22 modules
var mc_tree_select = __webpack_require__("97d9");

// EXTERNAL MODULE: ./components/mc-button/index.js + 11 modules
var mc_button = __webpack_require__("f483");

// EXTERNAL MODULE: ./components/mc-guide/index.js + 5 modules
var mc_guide = __webpack_require__("2d1a");

// EXTERNAL MODULE: ./components/mc-image/index.js + 6 modules
var mc_image = __webpack_require__("11ad");

// EXTERNAL MODULE: ./components/mc-print-template/index.js + 8 modules
var mc_print_template = __webpack_require__("0eef");

// EXTERNAL MODULE: ./components/mc-upload/index.js + 8 modules
var mc_upload = __webpack_require__("f8d1");

// EXTERNAL MODULE: ./components/mc-rich-text-editor/index.js + 221 modules
var mc_rich_text_editor = __webpack_require__("5b14c");

// EXTERNAL MODULE: ./components/mc-categoryselect/index.js + 5 modules
var mc_categoryselect = __webpack_require__("0783");

// EXTERNAL MODULE: ./components/mc-option-buttons/index.js + 11 modules
var mc_option_buttons = __webpack_require__("c487");

// EXTERNAL MODULE: ./components/mc-poi-view/index.js + 21 modules
var mc_poi_view = __webpack_require__("4079");

// EXTERNAL MODULE: ./components/mc-edit-table/index.js + 4 modules
var mc_edit_table = __webpack_require__("ca9e");

// EXTERNAL MODULE: ./components/mc-button-group/index.js + 3 modules
var mc_button_group = __webpack_require__("4957");

// EXTERNAL MODULE: ./components/mc-icon/index.js + 3 modules
var mc_icon = __webpack_require__("b262");

// EXTERNAL MODULE: ./components/mc-icon-button/index.js + 3 modules
var mc_icon_button = __webpack_require__("f620");

// EXTERNAL MODULE: ./components/mc-navbar/index.js + 3 modules
var mc_navbar = __webpack_require__("da9e");

// EXTERNAL MODULE: ./components/mc-navbar-search/index.js + 3 modules
var mc_navbar_search = __webpack_require__("255a");

// EXTERNAL MODULE: ./components/mc-navbar-icon-item/index.js + 3 modules
var mc_navbar_icon_item = __webpack_require__("3ef4");

// EXTERNAL MODULE: ./components/mc-navbar-item/index.js + 3 modules
var mc_navbar_item = __webpack_require__("bd67");

// EXTERNAL MODULE: ./components/mc-tab-pane/index.js + 3 modules
var mc_tab_pane = __webpack_require__("17fc");

// EXTERNAL MODULE: ./components/mc-tab-drop/index.js + 3 modules
var mc_tab_drop = __webpack_require__("0e8d");

// EXTERNAL MODULE: ./components/mc-pagination/index.js + 3 modules
var mc_pagination = __webpack_require__("8b5d");

// EXTERNAL MODULE: ./components/mc-badge/index.js + 3 modules
var mc_badge = __webpack_require__("b9ab");

// EXTERNAL MODULE: ./components/mc-radio/index.js + 3 modules
var mc_radio = __webpack_require__("a226");

// EXTERNAL MODULE: ./components/mc-radio-button/index.js + 3 modules
var mc_radio_button = __webpack_require__("41bd");

// EXTERNAL MODULE: ./components/mc-radio-group/index.js + 3 modules
var mc_radio_group = __webpack_require__("47c9");

// EXTERNAL MODULE: ./components/mc-switch/index.js + 3 modules
var mc_switch = __webpack_require__("b978");

// EXTERNAL MODULE: ./components/mc-steps/index.js + 3 modules
var mc_steps = __webpack_require__("ae1a");

// EXTERNAL MODULE: ./components/mc-step/index.js + 3 modules
var mc_step = __webpack_require__("3168");

// EXTERNAL MODULE: ./components/mc-textarea/index.js + 3 modules
var mc_textarea = __webpack_require__("c6b0");

// EXTERNAL MODULE: ./components/mc-checkbox/index.js + 3 modules
var mc_checkbox = __webpack_require__("b325");

// EXTERNAL MODULE: ./components/mc-checkbox-group/index.js + 3 modules
var mc_checkbox_group = __webpack_require__("69cf");

// EXTERNAL MODULE: ./components/mc-collapse-item/index.js + 3 modules
var mc_collapse_item = __webpack_require__("bf0d");

// EXTERNAL MODULE: ./components/mc-collapse/index.js + 3 modules
var mc_collapse = __webpack_require__("5b59");

// EXTERNAL MODULE: ./components/mc-progress/index.js + 3 modules
var mc_progress = __webpack_require__("0917");

// EXTERNAL MODULE: ./components/mc-announcement/index.js + 3 modules
var mc_announcement = __webpack_require__("68ec");

// EXTERNAL MODULE: ./components/mc-tooltip/index.js + 5 modules
var mc_tooltip = __webpack_require__("188e");

// EXTERNAL MODULE: ./components/mc-tag/index.js + 3 modules
var mc_tag = __webpack_require__("5259");

// EXTERNAL MODULE: ./components/mc-breadcrumb-item/index.js + 3 modules
var mc_breadcrumb_item = __webpack_require__("d21f");

// EXTERNAL MODULE: ./components/mc-modal/index.js + 5 modules
var mc_modal = __webpack_require__("4a2a");

// EXTERNAL MODULE: ./components/mc-option/index.js + 3 modules
var mc_option = __webpack_require__("34e6");

// EXTERNAL MODULE: ./components/mc-option-group/index.js + 3 modules
var mc_option_group = __webpack_require__("70eb");

// EXTERNAL MODULE: ./components/mc-slider/index.js + 3 modules
var mc_slider = __webpack_require__("fa31");

// EXTERNAL MODULE: ./components/mc-form-item/index.js + 3 modules
var mc_form_item = __webpack_require__("efec");

// EXTERNAL MODULE: ./components/mc-form/index.js + 3 modules
var mc_form = __webpack_require__("1f2b");

// EXTERNAL MODULE: ./components/mc-tree/index.js + 3 modules
var mc_tree = __webpack_require__("dc08");

// EXTERNAL MODULE: ./components/mc-tree-node/index.js + 3 modules
var mc_tree_node = __webpack_require__("fd75");

// EXTERNAL MODULE: ./components/mc-list/index.js + 3 modules
var mc_list = __webpack_require__("881f");

// EXTERNAL MODULE: ./components/mc-list-item/index.js + 3 modules
var mc_list_item = __webpack_require__("5dd8");

// EXTERNAL MODULE: ./components/mc-list-item-group/index.js + 3 modules
var mc_list_item_group = __webpack_require__("6ed7");

// EXTERNAL MODULE: ./components/mc-transfer/index.js + 3 modules
var mc_transfer = __webpack_require__("cea4");

// EXTERNAL MODULE: ./components/mc-transfer-panel/index.js + 3 modules
var mc_transfer_panel = __webpack_require__("a399");

// EXTERNAL MODULE: ./components/mc-sidebar/index.js + 3 modules
var mc_sidebar = __webpack_require__("5740");

// EXTERNAL MODULE: ./components/mc-loading/index.js + 3 modules
var mc_loading = __webpack_require__("71b1");

// EXTERNAL MODULE: ./components/mc-autocomplete/index.js + 3 modules
var mc_autocomplete = __webpack_require__("a2f7");

// EXTERNAL MODULE: ./components/mc-header/index.js + 3 modules
var mc_header = __webpack_require__("0eb9");

// EXTERNAL MODULE: ./components/mc-aside/index.js + 3 modules
var mc_aside = __webpack_require__("54f2");

// EXTERNAL MODULE: ./components/mc-main/index.js + 3 modules
var mc_main = __webpack_require__("0ce7");

// EXTERNAL MODULE: ./components/mc-footer/index.js + 3 modules
var mc_footer = __webpack_require__("9ab1");

// EXTERNAL MODULE: ./components/mc-container/index.js + 3 modules
var mc_container = __webpack_require__("d71a");

// EXTERNAL MODULE: ./components/mc-row/index.js + 3 modules
var mc_row = __webpack_require__("2828");

// EXTERNAL MODULE: ./components/mc-rate/index.js + 3 modules
var mc_rate = __webpack_require__("5b3c");

// EXTERNAL MODULE: ./components/mc-color-picker/index.js + 3 modules
var mc_color_picker = __webpack_require__("4c73");

// EXTERNAL MODULE: ./components/mc-card/index.js + 3 modules
var mc_card = __webpack_require__("14ff");

// EXTERNAL MODULE: ./components/mc-input-number/index.js + 3 modules
var mc_input_number = __webpack_require__("50d0");

// EXTERNAL MODULE: ./components/mc-cascader/index.js + 3 modules
var mc_cascader = __webpack_require__("e9e6");

// EXTERNAL MODULE: ./components/mc-affix/index.js + 3 modules
var mc_affix = __webpack_require__("1bc0");

// EXTERNAL MODULE: ./components/mc-anchor/index.js + 3 modules
var mc_anchor = __webpack_require__("14dd");

// EXTERNAL MODULE: ./components/mc-anchor-link/index.js + 3 modules
var mc_anchor_link = __webpack_require__("7600");

// EXTERNAL MODULE: ./components/mc-drawer/index.js + 3 modules
var mc_drawer = __webpack_require__("1e5b");

// EXTERNAL MODULE: ./components/mc-input-group/index.js + 3 modules
var mc_input_group = __webpack_require__("7f18");

// EXTERNAL MODULE: ./components/mc-picker/index.js + 3 modules
var mc_picker = __webpack_require__("2015");

// EXTERNAL MODULE: ./components/mc-popconfirm/index.js + 3 modules
var mc_popconfirm = __webpack_require__("140b");

// EXTERNAL MODULE: ./components/mc-config-provider/index.js + 3 modules
var mc_config_provider = __webpack_require__("0ff9");

// EXTERNAL MODULE: ./components/mc-notification/index.js + 3 modules
var mc_notification = __webpack_require__("0940");

// EXTERNAL MODULE: ./components/mc-message/index.js + 3 modules
var mc_message = __webpack_require__("d8ae");

// EXTERNAL MODULE: ./components/mc-confirm/index.js + 3 modules
var mc_confirm = __webpack_require__("bf9c");

// EXTERNAL MODULE: ./components/mc-table-column/index.js + 3 modules
var mc_table_column = __webpack_require__("aca4");

// EXTERNAL MODULE: ./components/mc-table/index.js + 3 modules
var mc_table = __webpack_require__("406d");

// EXTERNAL MODULE: ./components/mc-date-picker/index.js + 3 modules
var mc_date_picker = __webpack_require__("b25a");

// EXTERNAL MODULE: ./components/mc-time-picker/index.js + 3 modules
var mc_time_picker = __webpack_require__("5634");

// EXTERNAL MODULE: ./components/mc-col/index.js + 3 modules
var mc_col = __webpack_require__("d5ed");

// EXTERNAL MODULE: ./components/mc-popover/index.js + 5 modules
var mc_popover = __webpack_require__("a926");

// EXTERNAL MODULE: ./components/mc-sku-select/index.js + 5 modules
var mc_sku_select = __webpack_require__("cce0");

// EXTERNAL MODULE: ./components/mc-supply-rule-select/index.js + 5 modules
var mc_supply_rule_select = __webpack_require__("6eeb");

// EXTERNAL MODULE: ./components/mc-supplier-select/index.js + 5 modules
var mc_supplier_select = __webpack_require__("84f8");

// EXTERNAL MODULE: ./components/mc-ellipsis/index.js + 6 modules
var mc_ellipsis = __webpack_require__("40c9");

// EXTERNAL MODULE: ./components/mc-purchase-org-select/index.js + 5 modules
var mc_purchase_org_select = __webpack_require__("7ec6");

// EXTERNAL MODULE: ./components/mc-dropdown/index.js + 5 modules
var mc_dropdown = __webpack_require__("40e1");

// EXTERNAL MODULE: ./components/mc-choice/index.js + 5 modules
var mc_choice = __webpack_require__("89d7");

// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__("9224");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("75fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./directives/permission.js








/* harmony default export */ var permission = ({
  name: 'mc-permission',

  /**
   * 分二种使用场景 一种是隐藏元素，一种是传入optionList，返回用户有权限的optionList
   * 隐藏元素的用以下这些属性 scope='element'
   * | code    | 线上的权限 code | String, Number, Array | -                                                                                                                                                                                 | ''     | 否       |
   * | devCode | 线下的权限 code | String, Number, Array | -
   * | type    | 多权限code权限校验逻辑,every 用户拥有所有code的权限时候，代表该用户拥有权限,some 用户只要有权限code中的一个权限，就代表该用户有权限| every some | every
   * 传入optionList的是这种 scope='list'
   * listName 传入的是list的名，能从this上获取到的
  */
  inserted: function () {
    var _inserted = Object(asyncToGenerator["a" /* default */])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(el, binding, vNode) {
      var value, devCode, code, listName, _value$type, type, _value$scope, scope, _value$accountSystem, accountSystem, vm, isProd, innerCode, apiURL, authParams, result, authResult, getCode, permissionCodes, _result;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = binding.value;
              devCode = value.devCode, code = value.code, listName = value.listName, _value$type = value.type, type = _value$type === void 0 ? 'every' : _value$type, _value$scope = value.scope, scope = _value$scope === void 0 ? 'element' : _value$scope, _value$accountSystem = value.accountSystem, accountSystem = _value$accountSystem === void 0 ? 'sso' : _value$accountSystem;

              if (code) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              vm = vNode.context;
              isProd = ['staging', 'production'].includes("production");
              innerCode = isProd ? code : devCode || code;
              _context.prev = 7;
              apiURL = accountSystem === 'passport' ? '/api/auth/check/codePermissionForClient' : '/api/auth/check/codePermission';

              if (!(scope === 'element')) {
                _context.next = 17;
                break;
              }

              authParams = Object(tools_["flatten"])([innerCode]);
              _context.next = 13;
              return external_vue_default.a.prototype.$hPost(apiURL, {
                authCodeList: Object(toConsumableArray["a" /* default */])(authParams),
                systemSource: 0
              }, {
                cache: true
              });

            case 13:
              result = _context.sent;
              result = result.authList;
              authResult = Array.prototype[type].call(result || [], function (item) {
                return item.res;
              });

              if (!authResult) {
                el.parentNode && el.parentNode.removeChild(el);
              }

            case 17:
              if (!(scope === 'list')) {
                _context.next = 25;
                break;
              }

              getCode = function getCode(item) {
                return isProd ? item.code : item.devCode;
              };

              permissionCodes = Object(tools_["uniq"])(vm[listName].map(function (v) {
                return getCode(v);
              })).filter(Boolean);
              _context.next = 22;
              return external_vue_default.a.prototype.$hPost(apiURL, {
                authCodeList: Object(toConsumableArray["a" /* default */])(permissionCodes),
                systemSource: 0
              }, {
                cache: true
              });

            case 22:
              _result = _context.sent;
              _result = _result.authList;
              vm[listName] = vm[listName].filter(function (item) {
                var permissionCode = getCode(item);

                if (permissionCode) {
                  var authItem = _result.find(function (v) {
                    return v.authCode === permissionCode;
                  }) || {};
                  return authItem.res;
                }

                return true;
              });

            case 25:
              _context.next = 30;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](7);
              console.log(_context.t0);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 27]]);
    }));

    function inserted(_x, _x2, _x3) {
      return _inserted.apply(this, arguments);
    }

    return inserted;
  }()
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// CONCATENATED MODULE: ./directives/scroll.js

/* harmony default export */ var directives_scroll = ({
  name: 'mc-scroll',
  bind: function bind(el, binding) {
    // 获取滚动页面DOM
    var scrollDom;
    var bindParams = binding.value;

    if (!bindParams) {
      return;
    }

    if (bindParams.el && bindParams.el.nodeType === 1) {
      // 参数是HTML ELEMENT
      scrollDom = bindParams.el;
    } else if (bindParams.el) {
      // 参数是其他
      scrollDom = el.querySelector(bindParams.el.toString());
    } else {
      // 没有这个参数，使用绑定元素本身
      scrollDom = el;
    } // 设置了handleBind，触发handleBind


    typeof bindParams.handleBind === 'function' && bindParams.handleBind(el); // handleScroll校验

    if (!bindParams.handleScroll) {
      console.error('TypeError: v-mc-scroll expected a "handleScroll" param in binding!');
      return;
    } else if (typeof bindParams.handleScroll !== 'function') {
      console.error('TypeError: "handleScroll" should be a function!');
      return;
    } // beginPosition记录滚动的元素的当前scrollTop，并作为参数传入handleScroll，可用于判断滚动方向


    var beginPosition = scrollDom.scrollTop;
    scrollDom.addEventListener('scroll', function () {
      bindParams.handleScroll(scrollDom, beginPosition);
      beginPosition = this.scrollTop;
    });
  },
  inserted: function inserted(el, binding) {
    var _ref = binding.value || {},
        handleInserted = _ref.handleInserted;

    if (!handleInserted) {
      return;
    }

    if (typeof handleInserted !== 'function') {
      console.error('TypeError: "handleInserted" should be a function!');
      return;
    }

    handleInserted(el);
  }
});
// CONCATENATED MODULE: ./directives/copy.js



/**
 * MCopilot - 复制指令
 * @name mc-copy
 * @description 该指令用于实现点击复制功能，支持异步操作和剪贴板API
 * @param {HTMLElement} el - 指令所绑定的元素
 * @param {Object} binding - 指令的绑定值对象
 * @param {VueComponent} vNode - 指令所在的Vue组件实例
 */
/* harmony default export */ var copy = ({
  name: 'mc-copy',
  inserted: function () {
    var _inserted = Object(asyncToGenerator["a" /* default */])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(el, value, vNode) {
      var vm, messageModel, copyIcon;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              el.$value = el.getAttribute('mc-copy-text');

              try {
                vm = vNode.context; // 获取Vue组件实例

                messageModel = vm.$message ? 'app' : vm.$mtd ? 'mtd' : null; // 判断消息提示模块，优先使用app模块，其次使用mtd模块，如果都不存在则为null

                copyIcon = document.createElement('i'); // 创建一个<i>元素作为复制图标

                copyIcon.setAttribute('class', 'mtdicon mtdicon-copy-o'); // 设置复制图标的样式类

                copyIcon.setAttribute('style', 'cursor: pointer;color: #00b85c;font-size: 16px;'); // 设置复制图标的鼠标样式为手型

                el.append(copyIcon); // 将复制图标添加到指令所绑定的元素中

                copyIcon.addEventListener('click', function () {
                  // 给复制图标添加点击事件
                  var content = el.$value || el.innerText; // 获取要复制的内容，如果指令有绑定值则使用绑定值，否则使用父元素的文本内容

                  var messageSuccess = '复制成功'; // 复制成功的提示消息

                  var messageFail = "\u590D\u5236\u5931\u8D25".concat(content ? "\uFF0C\u8BF7\u624B\u52A8\u590D\u5236\u5185\u5BB9\uFF1A".concat(content) : ''); // 复制失败的提示消息，如果有内容则显示内容

                  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                    // 使用剪贴板API进行复制
                    navigator.clipboard.writeText(content) // 将内容写入剪贴板
                    .then(function () {
                      if (messageModel === 'app') {
                        vm.$message.success(messageSuccess); // 在app模块中显示复制成功的消息
                      } else if (messageModel) {
                        vm.$mtd.message({
                          type: 'success',
                          message: messageSuccess
                        }); // 在mtd模块中显示复制成功的消息
                      }
                    }).catch(function () {
                      if (messageModel === 'app') {
                        vm.$message.warning(messageFail); // 在app模块中显示复制失败的消息
                      } else if (messageModel) {
                        vm.$mtd.message({
                          type: 'warning',
                          message: messageFail
                        }); // 在mtd模块中显示复制失败的消息
                      }
                    });
                  } else {
                    // 使用execCommand进行复制
                    var copyInput = document.createElement('input'); // 创建一个<input>元素

                    copyInput.value = content; // 设置<input>元素的值为要复制的内容

                    document.body.appendChild(copyInput); // 将<input>元素添加到body中

                    copyInput.select(); // 选中<input>元素中的内容

                    document.execCommand('Copy'); // 执行复制操作

                    copyInput.remove(); // 移除<input>元素

                    if (messageModel === 'app') {
                      vm.$message.success(messageSuccess); // 在app模块中显示复制成功的消息
                    } else if (messageModel) {
                      vm.$mtd.message({
                        type: 'success',
                        message: messageSuccess
                      }); // 在mtd模块中显示复制成功的消息
                    }
                  }
                });
              } catch (e) {
                console.log(e); // 捕获异常并打印错误信息
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function inserted(_x, _x2, _x3) {
      return _inserted.apply(this, arguments);
    }

    return inserted;
  }(),
  // 监听vnode变化后重新获取value
  componentUpdated: function componentUpdated(el) {
    el.$value = el.getAttribute('mc-copy-text');
  }
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@ss/mtd-vue/lib/utils/popper/index.js
var popper = __webpack_require__("cd5c");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./directives/loading.vue?vue&type=template&id=4178c6e2&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"mc-loading-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"mc-loading-mask",class:[_vm.customClass, { 'is-fullscreen': _vm.fullscreen }],style:({ backgroundColor: _vm.background || '' })},[_c('div',{staticClass:"mc-loading-spinner"},[(!_vm.spinner)?_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})]):_c('i',{class:("mtdicon " + _vm.spinner)}),(_vm.text)?_c('p',{staticClass:"mc-loading-text"},[_vm._v("\n                "+_vm._s(_vm.text)+"\n            ")]):_vm._e()])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./directives/loading.vue?vue&type=template&id=4178c6e2&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./directives/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
  name: 'MarkLoading',
  data: function data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },
  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  }
});
// CONCATENATED MODULE: ./directives/loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var directives_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./directives/loading.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  directives_loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var loading = (component.exports);
// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./directives/loading.js






var Mask = external_vue_default.a.extend(loading);

var loading_insertDom = function insertDom(parent, el, binding) {
  if (!el.domVisible && Object(utils["d" /* getStyle */])(el, 'display') !== 'none' && Object(utils["d" /* getStyle */])(el, 'visibility') !== 'hidden') {
    Object.keys(el.maskStyle).forEach(function (property) {
      el.mask.style[property] = el.maskStyle[property];
    });
    Object(utils["a" /* addClass */])(parent, 'mc-loading-parent');

    if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
      Object(utils["a" /* addClass */])(parent, 'mc-loading-parent--relative');
    }

    if (binding.modifiers.fullscreen && binding.modifiers.lock) {
      Object(utils["a" /* addClass */])(parent, 'mc-loading-parent--hidden');
    }

    el.domVisible = true;
    parent.appendChild(el.mask);
    external_vue_default.a.nextTick(function () {
      if (el.instance.hiding) {
        el.instance.$emit('after-leave');
      } else {
        el.instance.visible = true;
      }
    });
    el.domInserted = true;
  }
};

var loading_toggleLoading = function toggleLoading(el, binding) {
  if (binding.value) {
    external_vue_default.a.nextTick(function () {
      if (binding.modifiers.fullscreen) {
        el.originalPosition = Object(utils["d" /* getStyle */])(document.body, 'position');
        el.originalOverflow = Object(utils["d" /* getStyle */])(document.body, 'overflow');
        el.maskStyle.zIndex = popper["PopupManage"].nextZIndex();
        Object(utils["a" /* addClass */])(el.mask, 'is-fullscreen');
        loading_insertDom(document.body, el, binding);
      } else {
        Object(utils["e" /* removeClass */])(el.mask, 'is-fullscreen');

        if (binding.modifiers.body) {
          el.originalPosition = Object(utils["d" /* getStyle */])(document.body, 'position');
          ['top', 'left'].forEach(function (property) {
            var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
            el.maskStyle[property] = "".concat(el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(utils["d" /* getStyle */])(document.body, "margin-".concat(property)), 10), "px");
          });
          ['height', 'width'].forEach(function (property) {
            el.maskStyle[property] = "".concat(el.getBoundingClientRect()[property], "px");
          });
          loading_insertDom(document.body, el, binding);
        } else {
          el.originalPosition = Object(utils["d" /* getStyle */])(el, 'position');
          loading_insertDom(el, el, binding);
        }
      }
    });
  } else {
    Object(utils["b" /* afterLeave */])(el.instance, function () {
      el.domVisible = false;
      var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
      Object(utils["e" /* removeClass */])(target, 'mc-loading-parent--relative');
      Object(utils["e" /* removeClass */])(target, 'mc-loading-parent--hidden');
      el.instance.hiding = false;
    }, 300, true);
    el.instance.visible = false;
    el.instance.hiding = true;
  }
};

/* harmony default export */ var directives_loading = ({
  name: 'mc-loading',
  bind: function bind(el, binding, vnode) {
    var textExr = el.getAttribute('mc-loading-text');
    var spinnerExr = el.getAttribute('mc-loading-spinner');
    var backgroundExr = el.getAttribute('mc-loading-background');
    var customClassExr = el.getAttribute('mc-loading-custom-class');
    var vm = vnode.context;
    var mask = new Mask({
      el: document.createElement('div'),
      data: {
        text: vm && vm[textExr] || textExr,
        spinner: vm && vm[spinnerExr] || spinnerExr,
        background: vm && vm[backgroundExr] || backgroundExr,
        customClass: vm && vm[customClassExr] || customClassExr,
        fullscreen: !!binding.modifiers.fullscreen
      }
    });
    el.instance = mask;
    el.mask = mask.$el;
    el.maskStyle = {};
    binding.value && loading_toggleLoading(el, binding);
  },
  update: function update(el, binding) {
    el.instance.setText(el.getAttribute('mc-loading-text'));

    if (binding.oldValue !== binding.value) {
      loading_toggleLoading(el, binding);
    }
  },
  unbind: function unbind(el, binding) {
    if (el.domInserted) {
      el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
      loading_toggleLoading(el, {
        value: false,
        modifiers: binding.modifiers
      });
    }
  }
});
// CONCATENATED MODULE: ./directives/index.js




/* harmony default export */ var directives = ([permission, directives_scroll, copy, directives_loading]);
// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* concated harmony reexport McPanel */__webpack_require__.d(__webpack_exports__, "McPanel", function() { return mc_panel["default"]; });
/* concated harmony reexport McLink */__webpack_require__.d(__webpack_exports__, "McLink", function() { return mc_link["default"]; });
/* concated harmony reexport McSelect */__webpack_require__.d(__webpack_exports__, "McSelect", function() { return mc_select["default"]; });
/* concated harmony reexport McDetailInfo */__webpack_require__.d(__webpack_exports__, "McDetailInfo", function() { return mc_detail_info["default"]; });
/* concated harmony reexport McTitle */__webpack_require__.d(__webpack_exports__, "McTitle", function() { return mc_title["default"]; });
/* concated harmony reexport McSensitiveInfo */__webpack_require__.d(__webpack_exports__, "McSensitiveInfo", function() { return mc_sensitive_info["default"]; });
/* concated harmony reexport McLevelSelect */__webpack_require__.d(__webpack_exports__, "McLevelSelect", function() { return mc_level_select["default"]; });
/* concated harmony reexport McPoiSelect */__webpack_require__.d(__webpack_exports__, "McPoiSelect", function() { return mc_poi_select["default"]; });
/* concated harmony reexport McTablePro */__webpack_require__.d(__webpack_exports__, "McTablePro", function() { return mc_table_pro["default"]; });
/* concated harmony reexport McEnumText */__webpack_require__.d(__webpack_exports__, "McEnumText", function() { return mc_enum_text["default"]; });
/* concated harmony reexport McPermission */__webpack_require__.d(__webpack_exports__, "McPermission", function() { return mc_permission["default"]; });
/* concated harmony reexport McSearchform */__webpack_require__.d(__webpack_exports__, "McSearchform", function() { return mc_searchform["default"]; });
/* concated harmony reexport McDivider */__webpack_require__.d(__webpack_exports__, "McDivider", function() { return mc_divider["default"]; });
/* concated harmony reexport McConfigform */__webpack_require__.d(__webpack_exports__, "McConfigform", function() { return mc_configform["default"]; });
/* concated harmony reexport McInput */__webpack_require__.d(__webpack_exports__, "McInput", function() { return mc_input["default"]; });
/* concated harmony reexport McFormGroup */__webpack_require__.d(__webpack_exports__, "McFormGroup", function() { return mc_form_group["default"]; });
/* concated harmony reexport McCitySelect */__webpack_require__.d(__webpack_exports__, "McCitySelect", function() { return mc_city_select["default"]; });
/* concated harmony reexport McDateTimePicker */__webpack_require__.d(__webpack_exports__, "McDateTimePicker", function() { return mc_date_time_picker["default"]; });
/* concated harmony reexport McBreadcrumb */__webpack_require__.d(__webpack_exports__, "McBreadcrumb", function() { return mc_breadcrumb["default"]; });
/* concated harmony reexport McTabs */__webpack_require__.d(__webpack_exports__, "McTabs", function() { return mc_tabs["default"]; });
/* concated harmony reexport McImagePreview */__webpack_require__.d(__webpack_exports__, "McImagePreview", function() { return mc_image_preview["default"]; });
/* concated harmony reexport McUserSelect */__webpack_require__.d(__webpack_exports__, "McUserSelect", function() { return mc_user_select["default"]; });
/* concated harmony reexport McTreeSelect */__webpack_require__.d(__webpack_exports__, "McTreeSelect", function() { return mc_tree_select["default"]; });
/* concated harmony reexport McButton */__webpack_require__.d(__webpack_exports__, "McButton", function() { return mc_button["default"]; });
/* concated harmony reexport McGuide */__webpack_require__.d(__webpack_exports__, "McGuide", function() { return mc_guide["default"]; });
/* concated harmony reexport McImage */__webpack_require__.d(__webpack_exports__, "McImage", function() { return mc_image["default"]; });
/* concated harmony reexport McPrintTemplate */__webpack_require__.d(__webpack_exports__, "McPrintTemplate", function() { return mc_print_template["default"]; });
/* concated harmony reexport McUpload */__webpack_require__.d(__webpack_exports__, "McUpload", function() { return mc_upload["default"]; });
/* concated harmony reexport McRichTextEditor */__webpack_require__.d(__webpack_exports__, "McRichTextEditor", function() { return mc_rich_text_editor["default"]; });
/* concated harmony reexport McCategoryselect */__webpack_require__.d(__webpack_exports__, "McCategoryselect", function() { return mc_categoryselect["default"]; });
/* concated harmony reexport McOptionButtons */__webpack_require__.d(__webpack_exports__, "McOptionButtons", function() { return mc_option_buttons["default"]; });
/* concated harmony reexport McPoiView */__webpack_require__.d(__webpack_exports__, "McPoiView", function() { return mc_poi_view["default"]; });
/* concated harmony reexport McEditTable */__webpack_require__.d(__webpack_exports__, "McEditTable", function() { return mc_edit_table["default"]; });
/* concated harmony reexport McButtonGroup */__webpack_require__.d(__webpack_exports__, "McButtonGroup", function() { return mc_button_group["default"]; });
/* concated harmony reexport McIcon */__webpack_require__.d(__webpack_exports__, "McIcon", function() { return mc_icon["default"]; });
/* concated harmony reexport McIconButton */__webpack_require__.d(__webpack_exports__, "McIconButton", function() { return mc_icon_button["default"]; });
/* concated harmony reexport McNavbar */__webpack_require__.d(__webpack_exports__, "McNavbar", function() { return mc_navbar["default"]; });
/* concated harmony reexport McNavbarSearch */__webpack_require__.d(__webpack_exports__, "McNavbarSearch", function() { return mc_navbar_search["default"]; });
/* concated harmony reexport McNavbarIconItem */__webpack_require__.d(__webpack_exports__, "McNavbarIconItem", function() { return mc_navbar_icon_item["default"]; });
/* concated harmony reexport McNavbarItem */__webpack_require__.d(__webpack_exports__, "McNavbarItem", function() { return mc_navbar_item["default"]; });
/* concated harmony reexport McTabPane */__webpack_require__.d(__webpack_exports__, "McTabPane", function() { return mc_tab_pane["default"]; });
/* concated harmony reexport McTabDrop */__webpack_require__.d(__webpack_exports__, "McTabDrop", function() { return mc_tab_drop["default"]; });
/* concated harmony reexport McPagination */__webpack_require__.d(__webpack_exports__, "McPagination", function() { return mc_pagination["default"]; });
/* concated harmony reexport McBadge */__webpack_require__.d(__webpack_exports__, "McBadge", function() { return mc_badge["default"]; });
/* concated harmony reexport McRadio */__webpack_require__.d(__webpack_exports__, "McRadio", function() { return mc_radio["default"]; });
/* concated harmony reexport McRadioButton */__webpack_require__.d(__webpack_exports__, "McRadioButton", function() { return mc_radio_button["default"]; });
/* concated harmony reexport McRadioGroup */__webpack_require__.d(__webpack_exports__, "McRadioGroup", function() { return mc_radio_group["default"]; });
/* concated harmony reexport McSwitch */__webpack_require__.d(__webpack_exports__, "McSwitch", function() { return mc_switch["default"]; });
/* concated harmony reexport McSteps */__webpack_require__.d(__webpack_exports__, "McSteps", function() { return mc_steps["default"]; });
/* concated harmony reexport McStep */__webpack_require__.d(__webpack_exports__, "McStep", function() { return mc_step["default"]; });
/* concated harmony reexport McTextarea */__webpack_require__.d(__webpack_exports__, "McTextarea", function() { return mc_textarea["default"]; });
/* concated harmony reexport McCheckbox */__webpack_require__.d(__webpack_exports__, "McCheckbox", function() { return mc_checkbox["default"]; });
/* concated harmony reexport McCheckboxGroup */__webpack_require__.d(__webpack_exports__, "McCheckboxGroup", function() { return mc_checkbox_group["default"]; });
/* concated harmony reexport McCollapseItem */__webpack_require__.d(__webpack_exports__, "McCollapseItem", function() { return mc_collapse_item["default"]; });
/* concated harmony reexport McCollapse */__webpack_require__.d(__webpack_exports__, "McCollapse", function() { return mc_collapse["default"]; });
/* concated harmony reexport McProgress */__webpack_require__.d(__webpack_exports__, "McProgress", function() { return mc_progress["default"]; });
/* concated harmony reexport McAnnouncement */__webpack_require__.d(__webpack_exports__, "McAnnouncement", function() { return mc_announcement["default"]; });
/* concated harmony reexport McTooltip */__webpack_require__.d(__webpack_exports__, "McTooltip", function() { return mc_tooltip["default"]; });
/* concated harmony reexport McTag */__webpack_require__.d(__webpack_exports__, "McTag", function() { return mc_tag["default"]; });
/* concated harmony reexport McBreadcrumbItem */__webpack_require__.d(__webpack_exports__, "McBreadcrumbItem", function() { return mc_breadcrumb_item["default"]; });
/* concated harmony reexport McModal */__webpack_require__.d(__webpack_exports__, "McModal", function() { return mc_modal["default"]; });
/* concated harmony reexport McOption */__webpack_require__.d(__webpack_exports__, "McOption", function() { return mc_option["default"]; });
/* concated harmony reexport McOptionGroup */__webpack_require__.d(__webpack_exports__, "McOptionGroup", function() { return mc_option_group["default"]; });
/* concated harmony reexport McSlider */__webpack_require__.d(__webpack_exports__, "McSlider", function() { return mc_slider["default"]; });
/* concated harmony reexport McFormItem */__webpack_require__.d(__webpack_exports__, "McFormItem", function() { return mc_form_item["default"]; });
/* concated harmony reexport McForm */__webpack_require__.d(__webpack_exports__, "McForm", function() { return mc_form["default"]; });
/* concated harmony reexport McTree */__webpack_require__.d(__webpack_exports__, "McTree", function() { return mc_tree["default"]; });
/* concated harmony reexport McTreeNode */__webpack_require__.d(__webpack_exports__, "McTreeNode", function() { return mc_tree_node["default"]; });
/* concated harmony reexport McList */__webpack_require__.d(__webpack_exports__, "McList", function() { return mc_list["default"]; });
/* concated harmony reexport McListItem */__webpack_require__.d(__webpack_exports__, "McListItem", function() { return mc_list_item["default"]; });
/* concated harmony reexport McListItemGroup */__webpack_require__.d(__webpack_exports__, "McListItemGroup", function() { return mc_list_item_group["default"]; });
/* concated harmony reexport McTransfer */__webpack_require__.d(__webpack_exports__, "McTransfer", function() { return mc_transfer["default"]; });
/* concated harmony reexport McTransferPanel */__webpack_require__.d(__webpack_exports__, "McTransferPanel", function() { return mc_transfer_panel["default"]; });
/* concated harmony reexport McSidebar */__webpack_require__.d(__webpack_exports__, "McSidebar", function() { return mc_sidebar["default"]; });
/* concated harmony reexport McLoading */__webpack_require__.d(__webpack_exports__, "McLoading", function() { return mc_loading["default"]; });
/* concated harmony reexport McAutocomplete */__webpack_require__.d(__webpack_exports__, "McAutocomplete", function() { return mc_autocomplete["default"]; });
/* concated harmony reexport McHeader */__webpack_require__.d(__webpack_exports__, "McHeader", function() { return mc_header["default"]; });
/* concated harmony reexport McAside */__webpack_require__.d(__webpack_exports__, "McAside", function() { return mc_aside["default"]; });
/* concated harmony reexport McMain */__webpack_require__.d(__webpack_exports__, "McMain", function() { return mc_main["default"]; });
/* concated harmony reexport McFooter */__webpack_require__.d(__webpack_exports__, "McFooter", function() { return mc_footer["default"]; });
/* concated harmony reexport McContainer */__webpack_require__.d(__webpack_exports__, "McContainer", function() { return mc_container["default"]; });
/* concated harmony reexport McRow */__webpack_require__.d(__webpack_exports__, "McRow", function() { return mc_row["default"]; });
/* concated harmony reexport McRate */__webpack_require__.d(__webpack_exports__, "McRate", function() { return mc_rate["default"]; });
/* concated harmony reexport McColorPicker */__webpack_require__.d(__webpack_exports__, "McColorPicker", function() { return mc_color_picker["default"]; });
/* concated harmony reexport McCard */__webpack_require__.d(__webpack_exports__, "McCard", function() { return mc_card["default"]; });
/* concated harmony reexport McInputNumber */__webpack_require__.d(__webpack_exports__, "McInputNumber", function() { return mc_input_number["default"]; });
/* concated harmony reexport McCascader */__webpack_require__.d(__webpack_exports__, "McCascader", function() { return mc_cascader["default"]; });
/* concated harmony reexport McAffix */__webpack_require__.d(__webpack_exports__, "McAffix", function() { return mc_affix["default"]; });
/* concated harmony reexport McAnchor */__webpack_require__.d(__webpack_exports__, "McAnchor", function() { return mc_anchor["default"]; });
/* concated harmony reexport McAnchorLink */__webpack_require__.d(__webpack_exports__, "McAnchorLink", function() { return mc_anchor_link["default"]; });
/* concated harmony reexport McDrawer */__webpack_require__.d(__webpack_exports__, "McDrawer", function() { return mc_drawer["default"]; });
/* concated harmony reexport McInputGroup */__webpack_require__.d(__webpack_exports__, "McInputGroup", function() { return mc_input_group["default"]; });
/* concated harmony reexport McPicker */__webpack_require__.d(__webpack_exports__, "McPicker", function() { return mc_picker["default"]; });
/* concated harmony reexport McPopconfirm */__webpack_require__.d(__webpack_exports__, "McPopconfirm", function() { return mc_popconfirm["default"]; });
/* concated harmony reexport McConfigProvider */__webpack_require__.d(__webpack_exports__, "McConfigProvider", function() { return mc_config_provider["default"]; });
/* concated harmony reexport McNotification */__webpack_require__.d(__webpack_exports__, "McNotification", function() { return mc_notification["default"]; });
/* concated harmony reexport McMessage */__webpack_require__.d(__webpack_exports__, "McMessage", function() { return mc_message["default"]; });
/* concated harmony reexport McConfirm */__webpack_require__.d(__webpack_exports__, "McConfirm", function() { return mc_confirm["default"]; });
/* concated harmony reexport McTableColumn */__webpack_require__.d(__webpack_exports__, "McTableColumn", function() { return mc_table_column["default"]; });
/* concated harmony reexport McTable */__webpack_require__.d(__webpack_exports__, "McTable", function() { return mc_table["default"]; });
/* concated harmony reexport McDatePicker */__webpack_require__.d(__webpack_exports__, "McDatePicker", function() { return mc_date_picker["default"]; });
/* concated harmony reexport McTimePicker */__webpack_require__.d(__webpack_exports__, "McTimePicker", function() { return mc_time_picker["default"]; });
/* concated harmony reexport McCol */__webpack_require__.d(__webpack_exports__, "McCol", function() { return mc_col["default"]; });
/* concated harmony reexport McPopover */__webpack_require__.d(__webpack_exports__, "McPopover", function() { return mc_popover["default"]; });
/* concated harmony reexport McSkuSelect */__webpack_require__.d(__webpack_exports__, "McSkuSelect", function() { return mc_sku_select["default"]; });
/* concated harmony reexport McSupplyRuleSelect */__webpack_require__.d(__webpack_exports__, "McSupplyRuleSelect", function() { return mc_supply_rule_select["default"]; });
/* concated harmony reexport McSupplierSelect */__webpack_require__.d(__webpack_exports__, "McSupplierSelect", function() { return mc_supplier_select["default"]; });
/* concated harmony reexport McEllipsis */__webpack_require__.d(__webpack_exports__, "McEllipsis", function() { return mc_ellipsis["default"]; });
/* concated harmony reexport McPurchaseOrgSelect */__webpack_require__.d(__webpack_exports__, "McPurchaseOrgSelect", function() { return mc_purchase_org_select["default"]; });
/* concated harmony reexport McDropdown */__webpack_require__.d(__webpack_exports__, "McDropdown", function() { return mc_dropdown["default"]; });
/* concated harmony reexport McChoice */__webpack_require__.d(__webpack_exports__, "McChoice", function() { return mc_choice["default"]; });







/* Automatically generated by cm tool */


















































































































var components = [mc_panel["default"], mc_link["default"], mc_select["default"], mc_detail_info["default"], mc_title["default"], mc_sensitive_info["default"], mc_level_select["default"], mc_poi_select["default"], mc_table_pro["default"], mc_enum_text["default"], mc_permission["default"], mc_searchform["default"], mc_divider["default"], mc_configform["default"], mc_input["default"], mc_form_group["default"], mc_city_select["default"], mc_date_time_picker["default"], mc_breadcrumb["default"], mc_tabs["default"], mc_image_preview["default"], mc_user_select["default"], mc_tree_select["default"], mc_button["default"], mc_guide["default"], mc_image["default"], mc_print_template["default"], mc_upload["default"], mc_rich_text_editor["default"], mc_categoryselect["default"], mc_option_buttons["default"], mc_poi_view["default"], mc_edit_table["default"], mc_button_group["default"], mc_icon["default"], mc_icon_button["default"], mc_navbar["default"], mc_navbar_search["default"], mc_navbar_icon_item["default"], mc_navbar_item["default"], mc_tab_pane["default"], mc_tab_drop["default"], mc_pagination["default"], mc_badge["default"], mc_radio["default"], mc_radio_button["default"], mc_radio_group["default"], mc_switch["default"], mc_steps["default"], mc_step["default"], mc_textarea["default"], mc_checkbox["default"], mc_checkbox_group["default"], mc_collapse_item["default"], mc_collapse["default"], mc_progress["default"], mc_announcement["default"], mc_tooltip["default"], mc_tag["default"], mc_breadcrumb_item["default"], mc_modal["default"], mc_option["default"], mc_option_group["default"], mc_slider["default"], mc_form_item["default"], mc_form["default"], mc_tree["default"], mc_tree_node["default"], mc_list["default"], mc_list_item["default"], mc_list_item_group["default"], mc_transfer["default"], mc_transfer_panel["default"], mc_sidebar["default"], mc_loading["default"], mc_autocomplete["default"], mc_header["default"], mc_aside["default"], mc_main["default"], mc_footer["default"], mc_container["default"], mc_row["default"], mc_rate["default"], mc_color_picker["default"], mc_card["default"], mc_input_number["default"], mc_cascader["default"], mc_affix["default"], mc_anchor["default"], mc_anchor_link["default"], mc_drawer["default"], mc_input_group["default"], mc_picker["default"], mc_popconfirm["default"], mc_config_provider["default"], mc_notification["default"], mc_message["default"], mc_confirm["default"], mc_table_column["default"], mc_table["default"], mc_date_picker["default"], mc_time_picker["default"], mc_col["default"], mc_popover["default"], mc_sku_select["default"], mc_supply_rule_select["default"], mc_supplier_select["default"], mc_ellipsis["default"], mc_purchase_org_select["default"], mc_dropdown["default"], mc_choice["default"]];
function install(Vue) {
  components.map(function (component) {
    Vue.component(component.name, component);
  });
  directives.forEach(function (directive) {
    Vue.directive(directive.name, directive);
  });
  var $mc = {
    confirm: mtd_vue_["Confirm"],
    notify: mtd_vue_["Notification"],
    message: mtd_vue_["Message"]
  };
  Vue.prototype.$mc = $mc;
}
/* istanbul ignore if */

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}


/* harmony default export */ var index = __webpack_exports__["default"] = ({
  version: package_0["a" /* version */],
  install: install
});

/***/ }),

/***/ "4228":
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__("82f0")
var Buffer = __webpack_require__("8707").Buffer
var MODES = __webpack_require__("bac2")
var StreamCipher = __webpack_require__("09f5")
var Transform = __webpack_require__("6430")
var aes = __webpack_require__("39f5")
var ebtk = __webpack_require__("ae84")
var inherits = __webpack_require__("3fb5")

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ "423e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ "429b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("7e25").EventEmitter;


/***/ }),

/***/ "43fc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("63b6");
var newPromiseCapability = __webpack_require__("656e");
var perform = __webpack_require__("4439");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "440c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ "4436":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-sensitive-info/mc-sensitive-info.vue?vue&type=template&id=9dc78fd2&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-sensitive-info"},[(!_vm.readonly)?_c('mtd-input',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.handleInput}}):_c('span',{staticClass:"mc-sensitive-info-text"},[_vm._v(_vm._s(_vm.value))]),(_vm.showRevealBtn)?_c('div',{staticClass:"mc-sensitive-info-btn"},[_c('span',{directives:[{name:"mc-permission",rawName:"v-mc-permission",value:({ code: _vm.permissionCode, accountSystem: _vm.accountSystem }),expression:"{ code: permissionCode, accountSystem: accountSystem }"}],class:("mc-sensitive-info-btn-show " + (_vm.showBtnBoard ? 'mc-sensitive-info-btn-show-board': '')),on:{"click":_vm.handleShowInfo}},[_c('i',{class:_vm.iClass})])]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-sensitive-info/mc-sensitive-info.vue?vue&type=template&id=9dc78fd2&

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-sensitive-info/mc-sensitive-info.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_sensitive_infovue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McSensitiveInfo',
  props: {
    value: {
      type: String,
      require: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showRevealBtn: {
      type: Boolean,
      default: true
    },
    showBtnBoard: {
      type: Boolean,
      default: true
    },
    // 真实数据源，string 为本地 object 为远程请求
    source: {
      type: [String, Object],
      default: '',
      require: true
    },
    // permission权限
    permissionCode: {
      type: [String, Array],
      default: ''
    },
    accountSystem: {
      type: String,
      default: 'sso',
      validator: function validator(val) {
        return ['sso', 'passport'].includes(val);
      }
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var iClass = Object(composition_api_["ref"])('mtdicon-visibility-on-o');
    var sourceType = Object(composition_api_["computed"])(function () {
      return Object(esm_typeof["a" /* default */])(props.source);
    });

    var handleShowInfo =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _props$source, url, params, type, _props$source$options, options, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                emit('reveal', props);

                if (!(sourceType.value !== 'object')) {
                  _context.next = 5;
                  break;
                }

                iClass.value = 'mtdicon-success-o';
                emit('input', props.source);
                return _context.abrupt("return");

              case 5:
                _context.prev = 5;

                if (!(props.source && props.source.url && props.source.params && props.source.type)) {
                  _context.next = 14;
                  break;
                }

                _props$source = props.source, url = _props$source.url, params = _props$source.params, type = _props$source.type, _props$source$options = _props$source.options, options = _props$source$options === void 0 ? {} : _props$source$options;
                _context.next = 10;
                return proxy["$".concat(type)](url, params, options);

              case 10:
                data = _context.sent;

                if (data) {
                  iClass.value = 'mtdicon-success-o';
                  emit('input', data);
                }

                _context.next = 15;
                break;

              case 14:
                proxy.$mtd.message.error('自定义请求配置错误');

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](5);
                proxy.$mtd.message.error('获取明文出错');

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 17]]);
      }));

      return function handleShowInfo() {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleInput = function handleInput(val) {
      emit('input', val);
    };

    return {
      iClass: iClass,
      handleShowInfo: handleShowInfo,
      handleInput: handleInput
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-sensitive-info/mc-sensitive-info.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_sensitive_info_mc_sensitive_infovue_type_script_lang_js_ = (mc_sensitive_infovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-sensitive-info/mc-sensitive-info.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_sensitive_info_mc_sensitive_infovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_sensitive_info = (component.exports);
// CONCATENATED MODULE: ./components/mc-sensitive-info/index.js


/* istanbul ignore next */

mc_sensitive_info.install = function (Vue) {
  Vue.component(mc_sensitive_info.name, mc_sensitive_info);
};

/* harmony default export */ var components_mc_sensitive_info = __webpack_exports__["default"] = (mc_sensitive_info);

/***/ }),

/***/ "4439":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "4461":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("124f");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("6e53");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI11 = function (_MSI) {
	_inherits(MSI11, _MSI);

	function MSI11(data, options) {
		_classCallCheck(this, MSI11);

		return _possibleConstructorReturn(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums.mod11)(data), options));
	}

	return MSI11;
}(_MSI3.default);

exports.default = MSI11;

/***/ }),

/***/ "44a3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("399f");
var utils = __webpack_require__("f3a3");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ "454f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("46a7");
var $Object = __webpack_require__("584a").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "45be":
/***/ (function(module, exports) {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),

/***/ "45f2":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("d9f6").f;
var has = __webpack_require__("07e3");
var TAG = __webpack_require__("5168")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4678":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "2bfb",
	"./af.js": "2bfb",
	"./ar": "8e73",
	"./ar-dz": "a356",
	"./ar-dz.js": "a356",
	"./ar-kw": "423e",
	"./ar-kw.js": "423e",
	"./ar-ly": "1cfd",
	"./ar-ly.js": "1cfd",
	"./ar-ma": "0a84",
	"./ar-ma.js": "0a84",
	"./ar-sa": "8230",
	"./ar-sa.js": "8230",
	"./ar-tn": "6d83",
	"./ar-tn.js": "6d83",
	"./ar.js": "8e73",
	"./az": "485c",
	"./az.js": "485c",
	"./be": "1fc1",
	"./be.js": "1fc1",
	"./bg": "84aa",
	"./bg.js": "84aa",
	"./bm": "a7fa",
	"./bm.js": "a7fa",
	"./bn": "9043",
	"./bn-bd": "9686",
	"./bn-bd.js": "9686",
	"./bn.js": "9043",
	"./bo": "d26a",
	"./bo.js": "d26a",
	"./br": "6887",
	"./br.js": "6887",
	"./bs": "2554",
	"./bs.js": "2554",
	"./ca": "d716",
	"./ca.js": "d716",
	"./cs": "3c0d",
	"./cs.js": "3c0d",
	"./cv": "03ec",
	"./cv.js": "03ec",
	"./cy": "9797",
	"./cy.js": "9797",
	"./da": "0f14",
	"./da.js": "0f14",
	"./de": "b469",
	"./de-at": "b3eb",
	"./de-at.js": "b3eb",
	"./de-ch": "bb71",
	"./de-ch.js": "bb71",
	"./de.js": "b469",
	"./dv": "598a",
	"./dv.js": "598a",
	"./el": "8d47",
	"./el.js": "8d47",
	"./en-au": "0e6b",
	"./en-au.js": "0e6b",
	"./en-ca": "3886",
	"./en-ca.js": "3886",
	"./en-gb": "39a6",
	"./en-gb.js": "39a6",
	"./en-ie": "e1d3",
	"./en-ie.js": "e1d3",
	"./en-il": "7333",
	"./en-il.js": "7333",
	"./en-in": "ec2e",
	"./en-in.js": "ec2e",
	"./en-nz": "6f50",
	"./en-nz.js": "6f50",
	"./en-sg": "b7e9",
	"./en-sg.js": "b7e9",
	"./eo": "65db",
	"./eo.js": "65db",
	"./es": "898b",
	"./es-do": "0a3c",
	"./es-do.js": "0a3c",
	"./es-mx": "b5b7",
	"./es-mx.js": "b5b7",
	"./es-us": "55c9",
	"./es-us.js": "55c9",
	"./es.js": "898b",
	"./et": "ec18",
	"./et.js": "ec18",
	"./eu": "0ff2",
	"./eu.js": "0ff2",
	"./fa": "8df4",
	"./fa.js": "8df4",
	"./fi": "81e9",
	"./fi.js": "81e9",
	"./fil": "d69a",
	"./fil.js": "d69a",
	"./fo": "0721",
	"./fo.js": "0721",
	"./fr": "9f26",
	"./fr-ca": "d9f8",
	"./fr-ca.js": "d9f8",
	"./fr-ch": "0e49",
	"./fr-ch.js": "0e49",
	"./fr.js": "9f26",
	"./fy": "7118",
	"./fy.js": "7118",
	"./ga": "5120",
	"./ga.js": "5120",
	"./gd": "f6b4",
	"./gd.js": "f6b4",
	"./gl": "8840",
	"./gl.js": "8840",
	"./gom-deva": "aaf2",
	"./gom-deva.js": "aaf2",
	"./gom-latn": "0caa",
	"./gom-latn.js": "0caa",
	"./gu": "e0c5",
	"./gu.js": "e0c5",
	"./he": "c7aa",
	"./he.js": "c7aa",
	"./hi": "dc4d",
	"./hi.js": "dc4d",
	"./hr": "4ba9",
	"./hr.js": "4ba9",
	"./hu": "5b14",
	"./hu.js": "5b14",
	"./hy-am": "d6b6",
	"./hy-am.js": "d6b6",
	"./id": "5038",
	"./id.js": "5038",
	"./is": "0558",
	"./is.js": "0558",
	"./it": "6e98",
	"./it-ch": "6f12",
	"./it-ch.js": "6f12",
	"./it.js": "6e98",
	"./ja": "079e",
	"./ja.js": "079e",
	"./jv": "b540",
	"./jv.js": "b540",
	"./ka": "201b",
	"./ka.js": "201b",
	"./kk": "6d79",
	"./kk.js": "6d79",
	"./km": "e81d",
	"./km.js": "e81d",
	"./kn": "3e92",
	"./kn.js": "3e92",
	"./ko": "22f8",
	"./ko.js": "22f8",
	"./ku": "2421",
	"./ku.js": "2421",
	"./ky": "9609",
	"./ky.js": "9609",
	"./lb": "440c",
	"./lb.js": "440c",
	"./lo": "b29d",
	"./lo.js": "b29d",
	"./lt": "26f9",
	"./lt.js": "26f9",
	"./lv": "b97c",
	"./lv.js": "b97c",
	"./me": "293c",
	"./me.js": "293c",
	"./mi": "688b",
	"./mi.js": "688b",
	"./mk": "6909",
	"./mk.js": "6909",
	"./ml": "02fb",
	"./ml.js": "02fb",
	"./mn": "958b",
	"./mn.js": "958b",
	"./mr": "39bd",
	"./mr.js": "39bd",
	"./ms": "ebe4",
	"./ms-my": "6403",
	"./ms-my.js": "6403",
	"./ms.js": "ebe4",
	"./mt": "1b45",
	"./mt.js": "1b45",
	"./my": "8689",
	"./my.js": "8689",
	"./nb": "6ce3",
	"./nb.js": "6ce3",
	"./ne": "3a39",
	"./ne.js": "3a39",
	"./nl": "facd",
	"./nl-be": "db29",
	"./nl-be.js": "db29",
	"./nl.js": "facd",
	"./nn": "b84c",
	"./nn.js": "b84c",
	"./oc-lnc": "167b",
	"./oc-lnc.js": "167b",
	"./pa-in": "f3ff",
	"./pa-in.js": "f3ff",
	"./pl": "8d57",
	"./pl.js": "8d57",
	"./pt": "f260",
	"./pt-br": "d2d4",
	"./pt-br.js": "d2d4",
	"./pt.js": "f260",
	"./ro": "972c",
	"./ro.js": "972c",
	"./ru": "957c",
	"./ru.js": "957c",
	"./sd": "6784",
	"./sd.js": "6784",
	"./se": "ffff",
	"./se.js": "ffff",
	"./si": "eda5",
	"./si.js": "eda5",
	"./sk": "7be6",
	"./sk.js": "7be6",
	"./sl": "8155",
	"./sl.js": "8155",
	"./sq": "c8f3",
	"./sq.js": "c8f3",
	"./sr": "cf1e",
	"./sr-cyrl": "13e9",
	"./sr-cyrl.js": "13e9",
	"./sr.js": "cf1e",
	"./ss": "52bd",
	"./ss.js": "52bd",
	"./sv": "5fbd",
	"./sv.js": "5fbd",
	"./sw": "74dc",
	"./sw.js": "74dc",
	"./ta": "3de5",
	"./ta.js": "3de5",
	"./te": "5cbb",
	"./te.js": "5cbb",
	"./tet": "576c",
	"./tet.js": "576c",
	"./tg": "3b1b",
	"./tg.js": "3b1b",
	"./th": "10e8",
	"./th.js": "10e8",
	"./tk": "5aff",
	"./tk.js": "5aff",
	"./tl-ph": "0f38",
	"./tl-ph.js": "0f38",
	"./tlh": "cf75",
	"./tlh.js": "cf75",
	"./tr": "0e81",
	"./tr.js": "0e81",
	"./tzl": "cf51",
	"./tzl.js": "cf51",
	"./tzm": "c109",
	"./tzm-latn": "b53d",
	"./tzm-latn.js": "b53d",
	"./tzm.js": "c109",
	"./ug-cn": "6117",
	"./ug-cn.js": "6117",
	"./uk": "ada2",
	"./uk.js": "ada2",
	"./ur": "5294",
	"./ur.js": "5294",
	"./uz": "2e8c",
	"./uz-latn": "010e",
	"./uz-latn.js": "010e",
	"./uz.js": "2e8c",
	"./vi": "2921",
	"./vi.js": "2921",
	"./x-pseudo": "fd7e",
	"./x-pseudo.js": "fd7e",
	"./yo": "7f33",
	"./yo.js": "7f33",
	"./zh-cn": "5c3a",
	"./zh-cn.js": "5c3a",
	"./zh-hk": "49ab",
	"./zh-hk.js": "49ab",
	"./zh-mo": "3a6c",
	"./zh-mo.js": "3a6c",
	"./zh-tw": "90ea",
	"./zh-tw.js": "90ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4678";

/***/ }),

/***/ "4681":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__("966d");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "469f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6c1c");
__webpack_require__("1654");
module.exports = __webpack_require__("7d7b");


/***/ }),

/***/ "46a7":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("63b6");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("8e60"), 'Object', { defineProperty: __webpack_require__("d9f6").f });


/***/ }),

/***/ "4727":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("124f");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("6e53");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI10 = function (_MSI) {
	_inherits(MSI10, _MSI);

	function MSI10(data, options) {
		_classCallCheck(this, MSI10);

		return _possibleConstructorReturn(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums.mod10)(data), options));
	}

	return MSI10;
}(_MSI3.default);

exports.default = MSI10;

/***/ }),

/***/ "47c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-radio-group/mc-radio-group.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_radio_groupvue_type_script_lang_js_ = ({
  name: 'McRadioGroup',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-radio-bgroup组件已经弃用，请使用mc-choice组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/aWRcgaz4faYOZ7ubzF_33', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-radio-group', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-radio-group/mc-radio-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_radio_group_mc_radio_groupvue_type_script_lang_js_ = (mc_radio_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-radio-group/mc-radio-group.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_radio_group_mc_radio_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_radio_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-radio-group/index.js


/* istanbul ignore next */

mc_radio_group.install = function (Vue) {
  Vue.component(mc_radio_group.name, mc_radio_group);
};

/* harmony default export */ var components_mc_radio_group = __webpack_exports__["default"] = (mc_radio_group);

/***/ }),

/***/ "47ee":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("c3a1");
var gOPS = __webpack_require__("9aa9");
var pIE = __webpack_require__("355d");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "481b":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "485c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ "4917":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");

// @@match logic
__webpack_require__("214f")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4957":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-button-group/mc-button-group.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_button_groupvue_type_script_lang_js_ = ({
  name: 'McButtonGroup',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-button-group', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-button-group/mc-button-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_button_group_mc_button_groupvue_type_script_lang_js_ = (mc_button_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-button-group/mc-button-group.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_button_group_mc_button_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_button_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-button-group/index.js


/* istanbul ignore next */

mc_button_group.install = function (Vue) {
  Vue.component(mc_button_group.name, mc_button_group);
};

/* harmony default export */ var components_mc_button_group = __webpack_exports__["default"] = (mc_button_group);

/***/ }),

/***/ "49ab":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ "4a2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-modal/mc-modal.vue?vue&type=template&id=1813af53&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-modal',_vm._b({ref:"selfRef",on:{"input":_vm.input,"open":_vm.open,"close":_vm.close,"closed":_vm.closed}},'mtd-modal',_vm.innerProps,false),[(_vm.$slots.title)?_vm._t("title",null,{"slot":"title"}):_vm._e(),_vm._t("default"),(_vm.$slots.footer)?_vm._t("footer",null,{"slot":"footer"}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-modal/mc-modal.vue?vue&type=template&id=1813af53&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-modal/mc-modal.vue?vue&type=script&lang=js&






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_modalvue_type_script_lang_js_ = ({
  name: 'McModal',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  data: function data() {
    return {
      innerIframeUiModalId: undefined
    };
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  watch: {
    'innerProps.visible': {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        if (!this.innerIframeUiModalId) {
          this.innerIframeUiModalId = Object(tools_["getUuid"])();
        }

        if (val) {
          var _this$$me;

          this === null || this === void 0 ? void 0 : (_this$$me = this.$me) === null || _this$$me === void 0 ? void 0 : _this$$me.emit('ui-modal', 'parent', {
            id: this.innerIframeUiModalId,
            show: val,
            v: 1
          });
        } else {
          setTimeout(function () {
            var _this$$me2;

            _this === null || _this === void 0 ? void 0 : (_this$$me2 = _this.$me) === null || _this$$me2 === void 0 ? void 0 : _this$$me2.emit('ui-modal', 'parent', {
              id: _this.innerIframeUiModalId,
              show: val,
              v: 1
            });
          }, 300);
        }
      }
    }
  },
  created: function created() {
    if (!this.innerIframeUiModalId) {
      this.innerIframeUiModalId = Object(tools_["getUuid"])();
    }
  },
  destroyed: function destroyed() {
    if (this.innerProps.visible) {
      var _this$$me3;

      this === null || this === void 0 ? void 0 : (_this$$me3 = this.$me) === null || _this$$me3 === void 0 ? void 0 : _this$$me3.emit('ui-modal', 'parent', {
        id: this.innerIframeUiModalId,
        show: false,
        hook: 'destroyed',
        v: 1
      });
    }
  },
  methods: {
    input: function input() {
      this.$listeners.input && this.$listeners.input();
    },
    open: function open() {
      this.$listeners.open && this.$listeners.open();
    },
    close: function close() {
      this.$listeners.close && this.$listeners.close();
    },
    closed: function closed() {
      this.$listeners.closed && this.$listeners.closed();
    }
  }
});
// CONCATENATED MODULE: ./components/mc-modal/mc-modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_modal_mc_modalvue_type_script_lang_js_ = (mc_modalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-modal/mc-modal.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_modal_mc_modalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_modal = (component.exports);
// CONCATENATED MODULE: ./components/mc-modal/index.js


/* istanbul ignore next */

mc_modal.install = function (Vue) {
  Vue.component(mc_modal.name, mc_modal);
};

/* harmony default export */ var components_mc_modal = __webpack_exports__["default"] = (mc_modal);

/***/ }),

/***/ "4a59":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var getIterFn = __webpack_require__("27ee");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "4a9d":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("ed78");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "4aa6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dc62");

/***/ }),

/***/ "4b23":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _constants = __webpack_require__("f08e");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is the master class,
// it does require the start code to be included in the string
var CODE128 = function (_Barcode) {
	_inherits(CODE128, _Barcode);

	function CODE128(data, options) {
		_classCallCheck(this, CODE128);

		// Get array of ascii codes from data
		var _this = _possibleConstructorReturn(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));

		_this.bytes = data.split('').map(function (char) {
			return char.charCodeAt(0);
		});
		return _this;
	}

	_createClass(CODE128, [{
		key: 'valid',
		value: function valid() {
			// ASCII value ranges 0-127, 200-211
			return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
			);
		}

		// The public encoding function

	}, {
		key: 'encode',
		value: function encode() {
			var bytes = this.bytes;
			// Remove the start code from the bytes and set its index
			var startIndex = bytes.shift() - 105;
			// Get start set by index
			var startSet = _constants.SET_BY_CODE[startIndex];

			if (startSet === undefined) {
				throw new RangeError('The encoding does not start with a start character.');
			}

			if (this.shouldEncodeAsEan128() === true) {
				bytes.unshift(_constants.FNC1);
			}

			// Start encode with the right type
			var encodingResult = CODE128.next(bytes, 1, startSet);

			return {
				text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
				data:
				// Add the start bits
				CODE128.getBar(startIndex) +
				// Add the encoded bits
				encodingResult.result +
				// Add the checksum
				CODE128.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) +
				// Add the end bits
				CODE128.getBar(_constants.STOP)
			};
		}

		// GS1-128/EAN-128

	}, {
		key: 'shouldEncodeAsEan128',
		value: function shouldEncodeAsEan128() {
			var isEAN128 = this.options.ean128 || false;
			if (typeof isEAN128 === 'string') {
				isEAN128 = isEAN128.toLowerCase() === 'true';
			}
			return isEAN128;
		}

		// Get a bar symbol by index

	}], [{
		key: 'getBar',
		value: function getBar(index) {
			return _constants.BARS[index] ? _constants.BARS[index].toString() : '';
		}

		// Correct an index by a set and shift it from the bytes array

	}, {
		key: 'correctIndex',
		value: function correctIndex(bytes, set) {
			if (set === _constants.SET_A) {
				var charCode = bytes.shift();
				return charCode < 32 ? charCode + 64 : charCode - 32;
			} else if (set === _constants.SET_B) {
				return bytes.shift() - 32;
			} else {
				return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
			}
		}
	}, {
		key: 'next',
		value: function next(bytes, pos, set) {
			if (!bytes.length) {
				return { result: '', checksum: 0 };
			}

			var nextCode = void 0,
			    index = void 0;

			// Special characters
			if (bytes[0] >= 200) {
				index = bytes.shift() - 105;
				var nextSet = _constants.SWAP[index];

				// Swap to other set
				if (nextSet !== undefined) {
					nextCode = CODE128.next(bytes, pos + 1, nextSet);
				}
				// Continue on current set but encode a special character
				else {
						// Shift
						if ((set === _constants.SET_A || set === _constants.SET_B) && index === _constants.SHIFT) {
							// Convert the next character so that is encoded correctly
							bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
						}
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
			}
			// Continue encoding
			else {
					index = CODE128.correctIndex(bytes, set);
					nextCode = CODE128.next(bytes, pos + 1, set);
				}

			// Get the correct binary encoding and calculate the weight
			var enc = CODE128.getBar(index);
			var weight = index * pos;

			return {
				result: enc + nextCode.result,
				checksum: weight + nextCode.checksum
			};
		}
	}]);

	return CODE128;
}(_Barcode3.default);

exports.default = CODE128;

/***/ }),

/***/ "4ba9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4c73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-color-picker/mc-color-picker.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_color_pickervue_type_script_lang_js_ = ({
  name: 'McColorPicker',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-color-picker', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-color-picker/mc-color-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_color_picker_mc_color_pickervue_type_script_lang_js_ = (mc_color_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-color-picker/mc-color-picker.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_color_picker_mc_color_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_color_picker = (component.exports);
// CONCATENATED MODULE: ./components/mc-color-picker/index.js


/* istanbul ignore next */

mc_color_picker.install = function (Vue) {
  Vue.component(mc_color_picker.name, mc_color_picker);
};

/* harmony default export */ var components_mc_color_picker = __webpack_exports__["default"] = (mc_color_picker);

/***/ }),

/***/ "4c95":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var dP = __webpack_require__("d9f6");
var DESCRIPTORS = __webpack_require__("8e60");
var SPECIES = __webpack_require__("5168")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "4ca5":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("ce3e"),
    isObjectLike = __webpack_require__("b5d6");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "4cec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("a93d");
} else {}


/***/ }),

/***/ "4ced":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectRenderer = function () {
	function ObjectRenderer(object, encodings, options) {
		_classCallCheck(this, ObjectRenderer);

		this.object = object;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(ObjectRenderer, [{
		key: "render",
		value: function render() {
			this.object.encodings = this.encodings;
		}
	}]);

	return ObjectRenderer;
}();

exports.default = ObjectRenderer;

/***/ }),

/***/ "4d16":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("25b0");

/***/ }),

/***/ "4d26":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "4dc9":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("5737");
module.exports = __webpack_require__("584a").Number.isNaN;


/***/ }),

/***/ "4dd0":
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__("ae84")
var ciphers = __webpack_require__("fda6")
var Buffer = __webpack_require__("8707").Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),

/***/ "4e2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("da3e");
var inherits = __webpack_require__("3fb5");

var des = __webpack_require__("1545");
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ "4ee1":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("5168")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "4f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("c26b");
var validate = __webpack_require__("b39a");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("e0b8")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "4fd1":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5")
var Hash = __webpack_require__("b672")
var Buffer = __webpack_require__("8707").Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ "5038":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ "504c":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("9e1e");
var getKeys = __webpack_require__("0d58");
var toIObject = __webpack_require__("6821");
var isEnum = __webpack_require__("52a7").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "50c1":
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'

var pako = require('pako/lib/deflate.js')

module.exports = function (data) {
  return pako.deflateRaw(data, { level: 9, to: 'string' })
}

},{"pako/lib/deflate.js":4}],2:[function(require,module,exports){
'use strict'

// Encode code taken from the PlantUML website:
// http://plantuml.sourceforge.net/codejavascript2.html

// It is described as being "a transformation close to base64"
// The code has been slightly modified to pass linters

function encode6bit (b) {
  if (b < 10) {
    return String.fromCharCode(48 + b)
  }
  b -= 10
  if (b < 26) {
    return String.fromCharCode(65 + b)
  }
  b -= 26
  if (b < 26) {
    return String.fromCharCode(97 + b)
  }
  b -= 26
  if (b === 0) {
    return '-'
  }
  if (b === 1) {
    return '_'
  }
  return '?'
}

function append3bytes (b1, b2, b3) {
  var c1 = b1 >> 2
  var c2 = ((b1 & 0x3) << 4) | (b2 >> 4)
  var c3 = ((b2 & 0xF) << 2) | (b3 >> 6)
  var c4 = b3 & 0x3F
  var r = ''
  r += encode6bit(c1 & 0x3F)
  r += encode6bit(c2 & 0x3F)
  r += encode6bit(c3 & 0x3F)
  r += encode6bit(c4 & 0x3F)
  return r
}

module.exports = function (data) {
  var r = ''
  for (var i = 0; i < data.length; i += 3) {
    if (i + 2 === data.length) {
      r += append3bytes(data.charCodeAt(i), data.charCodeAt(i + 1), 0)
    } else if (i + 1 === data.length) {
      r += append3bytes(data.charCodeAt(i), 0, 0)
    } else {
      r += append3bytes(data.charCodeAt(i),
        data.charCodeAt(i + 1),
        data.charCodeAt(i + 2))
    }
  }
  return r
}

},{}],3:[function(require,module,exports){
'use strict'

var deflate = require('./deflate')
var encode64 = require('./encode64')

module.exports.encode = function (puml) {
  var deflated = deflate(puml)
  return encode64(deflated)
}

},{"./deflate":1,"./encode64":2}],4:[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":5,"./utils/strings":6,"./zlib/deflate":9,"./zlib/messages":10,"./zlib/zstream":12}],5:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],6:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":5}],7:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],8:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],9:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":5,"./adler32":7,"./crc32":8,"./messages":10,"./trees":11}],10:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],11:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":5}],12:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}]},{},[3])(3)
});


/***/ }),

/***/ "50d0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-input-number/mc-input-number.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_input_numbervue_type_script_lang_js_ = ({
  name: 'McInputNumber',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-input-number组件已经弃用，请使用mc-input组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/8jQEoCWVoLDRp7wj0MgC0', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-input-number', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-input-number/mc-input-number.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_input_number_mc_input_numbervue_type_script_lang_js_ = (mc_input_numbervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-input-number/mc-input-number.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_input_number_mc_input_numbervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_input_number = (component.exports);
// CONCATENATED MODULE: ./components/mc-input-number/index.js


/* istanbul ignore next */

mc_input_number.install = function (Vue) {
  Vue.component(mc_input_number.name, mc_input_number);
};

/* harmony default export */ var components_mc_input_number = __webpack_exports__["default"] = (mc_input_number);

/***/ }),

/***/ "50ed":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "5120":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ "512a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONFIG_PROVIDER = undefined;

var _assign = __webpack_require__("3f6b");

var _assign2 = _interopRequireDefault(_assign);

exports.getConfig = getConfig;
exports.getPrefix = getPrefix;
exports.getIconPrefix = getIconPrefix;
exports.getPrefixCls = getPrefixCls;
exports.getIconCls = getIconCls;
exports.getSize = getSize;
exports.config = config;

var _vnode = __webpack_require__("19f6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG_PROVIDER = exports.CONFIG_PROVIDER = 'MTDConfig';

var zIndex = 2000;
var stack = [];

var DEFAULT_CONFIG = {
  prefixCls: 'mtd',
  iconPrefixCls: 'mtdicon',
  componentSize: '',

  getPopupContainer: function getPopupContainer() {
    return document.body;
  },

  getNextZIndex: function getNextZIndex() {
    return zIndex++;
  },
  addPopup: function addPopup(instance) {
    if (stack.indexOf(instance) === -1) {
      stack.push(instance);
    }
  },
  removePopup: function removePopup(instance) {
    var index = stack.lastIndexOf(instance);
    if (index > -1) {
      stack.splice(index, 1);
    }
  },
  getLastPopup: function getLastPopup() {
    if (stack.length > 0) {
      return stack[stack.length - 1];
    }
  }
};

function getConfig() {
  return DEFAULT_CONFIG;
}

function getPrefix() {
  return DEFAULT_CONFIG.prefixCls;
}

function getIconPrefix() {
  return DEFAULT_CONFIG.iconPrefixCls;
}

function getPrefixCls(suffixCls, customizePrefixCls) {
  return customizePrefixCls || DEFAULT_CONFIG.prefixCls + '-' + suffixCls;
}

function getIconCls(suffixCls, customizePrefixCls) {
  var iconPrefixCls = DEFAULT_CONFIG.iconPrefixCls;

  return customizePrefixCls || iconPrefixCls + ' ' + iconPrefixCls + '-' + (suffixCls || '');
}

function getSize(comp) {
  if (!comp) return DEFAULT_CONFIG.componentSize;
  return (0, _vnode.hasProps)(comp, 'size') ? comp.size : DEFAULT_CONFIG.componentSize || comp.size;
}

function config(options) {
  return (0, _assign2.default)(DEFAULT_CONFIG, options);
}

/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "5165":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__("8c8a")

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "5168":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("dbdb")('wks');
var uid = __webpack_require__("62a0");
var Symbol = __webpack_require__("e53d").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "51b6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("a3c3");
module.exports = __webpack_require__("584a").Object.assign;


/***/ }),

/***/ "51eb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "5239":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "5259":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tag/mc-tag.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_tagvue_type_script_lang_js_ = ({
  name: 'McTag',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'checked': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-tag', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-tag/mc-tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tag_mc_tagvue_type_script_lang_js_ = (mc_tagvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tag/mc-tag.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tag_mc_tagvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tag = (component.exports);
// CONCATENATED MODULE: ./components/mc-tag/index.js


/* istanbul ignore next */

mc_tag.install = function (Vue) {
  Vue.component(mc_tag.name, mc_tag);
};

/* harmony default export */ var components_mc_tag = __webpack_exports__["default"] = (mc_tag);

/***/ }),

/***/ "5261":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = optionsFromStrings;

// Convert string to integers/booleans where it should be

function optionsFromStrings(options) {
	var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];

	for (var intOption in intOptions) {
		if (intOptions.hasOwnProperty(intOption)) {
			intOption = intOptions[intOption];
			if (typeof options[intOption] === "string") {
				options[intOption] = parseInt(options[intOption], 10);
			}
		}
	}

	if (typeof options["displayValue"] === "string") {
		options["displayValue"] = options["displayValue"] != "false";
	}

	return options;
}

/***/ }),

/***/ "5291":
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__("399f")
var Buffer = __webpack_require__("8707").Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ "5294":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "52bd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ "53e2":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("07e3");
var toObject = __webpack_require__("241e");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "549b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("d864");
var $export = __webpack_require__("63b6");
var toObject = __webpack_require__("241e");
var call = __webpack_require__("b0dc");
var isArrayIter = __webpack_require__("3702");
var toLength = __webpack_require__("b447");
var createProperty = __webpack_require__("20fd");
var getIterFn = __webpack_require__("7cd6");

$export($export.S + $export.F * !__webpack_require__("4ee1")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "54a1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6c1c");
__webpack_require__("1654");
module.exports = __webpack_require__("95d5");


/***/ }),

/***/ "54b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/mc-level-select.vue?vue&type=template&id=7dba2fe8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"mc-level-select"},[_c('mtd-popover',_vm._g(_vm._b({attrs:{"visible":_vm.visible,"popper-class":("mc-level-select-popper " + _vm.popperClass),"placement":"bottom-start","trigger":"click"}},'mtd-popover',_vm.$attrs,false),_vm.popperListeners),[_c('div',{ref:"popover",attrs:{"slot":"content"},slot:"content"},[(_vm.canShowSelect)?_c('select-wrapper',{attrs:{"multiple":_vm.multiple,"data":_vm.data}}):_c('view-wrapper'),(_vm.multiple && !_vm.innerDisabled && _vm.data.length)?_c('div',{staticClass:"footer"},[_c('mtd-button',{class:("footer-button " + (!_vm.canShowSelect ? 'pull-right' : '')),attrs:{"size":"small","type":"text-primary"},on:{"click":_vm.switchShowSelect}},[_vm._v("\n                    "+_vm._s(_vm.canShowSelect ? "查看已选" : "返回")+"\n                ")])],1):_vm._e()],1),_c('selected-view',{attrs:{"visible":_vm.visible,"multiple":_vm.multiple}})],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/mc-level-select.vue?vue&type=template&id=7dba2fe8&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("20d6");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__("8615");

// EXTERNAL MODULE: ./composables/useDispatch.js
var useDispatch = __webpack_require__("2568");

// CONCATENATED MODULE: ./components/mc-level-select/utils/index.js


var utils_formatToSelectOptions = function formatToSelectOptions(data, setFirst) {
  var result = [];
  result[0] = data;
  var temp = data[0];

  while (setFirst && temp.children && temp.children[0]) {
    result.push(temp.children);
    temp = temp.children[0];
  }

  return result;
};
var removeItem = function removeItem() {
  var dataArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = arguments.length > 1 ? arguments[1] : undefined;
  var index = dataArr.findIndex(function (item) {
    return item.id === data.id;
  });

  if (index !== -1) {
    dataArr.splice(index, 1);
  }
};
var findInTree = function findInTree(data, value) {
  var valueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  if (!value) return;

  for (var i = 0; i < data.length; i++) {
    if (data[i][valueKey] === value) {
      // eslint-disable-next-line consistent-return
      return data[i];
    }

    if (data[i].children) {
      var temp = findInTree(data[i].children, value, valueKey);

      if (temp) {
        // eslint-disable-next-line consistent-return
        return temp;
      }
    }
  }
};
var findPathInTree = function findPathInTree(data, value, path, level) {
  var finded = data.some(function (item) {
    path[level] = item;

    if (item.id === value.id) {
      // 把后面的清除掉
      path.splice(level + 1);
      return true;
    }

    if (!item.children) {
      return false;
    }

    return findPathInTree(item.children, value, path, level + 1);
  }); // 如果没找到，要把当前层级后面的删掉

  if (!finded) {
    path.splice(level);
  }

  return finded;
};
var getLeafData = function getLeafData(data) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  data.forEach(function (item) {
    if (item._isSelectLevel) {
      result.push(item);
      return;
    }

    getLeafData(item.children, result);
  });
  return result;
};
// CONCATENATED MODULE: ./components/mc-level-select/composable/useSelect.js









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var useSelect_useSelect = function useSelect(props, handleClosePopover, _ref) {
  var emit = _ref.emit;

  var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
      proxy = _getCurrentInstance.proxy,
      $set = _getCurrentInstance.proxy.$set;

  var selectedValue = Object(composition_api_["ref"])([]); // 选中的item集合 包含该item的所有数据

  var selectedValueMap = Object(composition_api_["ref"])({}); // 选中的itemMap 对象的key为所选item的valueKey的值  value为对应所选的item

  var tabsData = Object(composition_api_["ref"])([]); // 当前tab下的data

  var optData = Object(composition_api_["ref"])([]); //  添加parentId和count属性的data

  var storeValue = Object(composition_api_["ref"])(props.value); // 存储的value 用于比较prop.value

  var filterOptionsData = Object(composition_api_["ref"])([]); // 将data转化为 第一层——第二层 + children的形式 用于搜索展示与查看已选
  // 计算事件抛出的数据

  var getEmitValue = function getEmitValue() {
    var valueKey = props.valueKey,
        multiple = props.multiple;
    var data = Object.values(selectedValueMap.value || {});
    var value;
    var items;

    if (multiple) {
      items = Object(tools_["cloneDeep"])(data);
      value = items.map(function (item) {
        return item[valueKey];
      });
    } else {
      items = data[0] && Object(tools_["cloneDeep"])(data[0]);
      value = items && items[valueKey] || '';
    }

    return {
      value: value,
      items: items
    };
  }; // 提交值变化 更新value


  var emitChange = function emitChange() {
    var _getEmitValue = getEmitValue(),
        value = _getEmitValue.value,
        items = _getEmitValue.items;

    storeValue.value = Object(tools_["cloneDeep"])(value);
    emit('input', value);
    emit('change', value, items);
    Object(useDispatch["a" /* default */])(proxy, 'MtdFormItem', 'formChange', value);
  }; // 设置选中的个数


  var setSelectedCount = function setSelectedCount(params) {
    var data = params || tabsData.value;
    var result = data.reduce(function (prev, item) {
      if (item._isSelectLevel && selectedValueMap.value[item.id]) {
        // 叶子节点，直接处理数据变更
        if (item.disabled) {
          prev._disabledSelectedCount += 1;
        }

        prev._selectedCount += 1;
      }

      if (item.children && !item._isSelectLevel) {
        var _selectedData = setSelectedCount(item.children);

        item._selectedCount = _selectedData._selectedCount;
        item._disabledSelectedCount = _selectedData._disabledSelectedCount;
        prev._selectedCount += _selectedData._selectedCount;
        prev._disabledSelectedCount += _selectedData._disabledSelectedCount;
      }

      return prev;
    }, {
      _selectedCount: 0,
      _disabledSelectedCount: 0
    });
    return result;
  }; // 处理多选时，点击checkbox 子选项直接选择， 父选项递归选中所有子集


  var handleCheck = function handleCheck(checked, data) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var isTop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (checked && data._isSelectLevel && !data.disabled) {
      // 处理选中
      $set(selectedValueMap.value, data.id, data);
    }

    if (!checked && data._isSelectLevel) {
      // 取消选中
      selectedValueMap.value[data.id] = null;
      delete selectedValueMap.value[data.id];
    } // 如果是中间节点，需要对子节点进行处理


    if (deep && data.children && !data._isSelectLevel && !data._isView) {
      data.children.forEach(function (item) {
        // 如果可以选择并且是不选中或者已选中值没有该值，处理选中
        if (!item.disabled && (!checked || !selectedValueMap.value[item.id])) {
          handleCheck(checked, item, deep, false);
        }
      });
    } // 如果是不存在的值 直接删除


    if (!checked && !data.children && !data._isSelectLevel) {
      selectedValueMap.value[data.id || data.label] = null;
      delete selectedValueMap.value[data.id || data.label];
    }

    if (isTop) {
      setSelectedCount();
    }
  }; // 全选


  var handleSelectAll = function handleSelectAll() {
    optData.value.forEach(function (item) {
      handleCheck(true, item);
    });
    emitChange();
  }; // 点击clear


  var handleClickClear = function handleClickClear() {
    if (!props.multiple) {
      // 单选
      selectedValueMap.value = {};
    } else {
      selectedValue.value.filter(function (item) {
        return !item.disabled;
      }).map(function (item) {
        return item;
      }).forEach(function (item) {
        handleCheck(false, item, true, false);
      });
      setSelectedCount();
    }

    emitChange();
  }; // 提交check事件


  var emitCheck = function emitCheck(val, item) {
    emit('check', val, item);
  }; // 提交切换tab事件


  var emitTabChange = function emitTabChange(item) {
    emit('tab-change', item);
  }; // 获取选择值的item


  var getSelectedValue = function getSelectedValue() {
    var _getEmitValue2 = getEmitValue(),
        value = _getEmitValue2.value,
        items = _getEmitValue2.items;

    return {
      value: value,
      data: Object(tools_["cloneDeep"])(items)
    };
  }; // 初始值设置selectedValueMap


  var setSelectedValueMap = function setSelectedValueMap() {
    if (props.multiple) {
      // 多选
      selectedValueMap.value = (props.value || []).reduce(function (prev, cur) {
        var temp = findInTree(optData.value, cur, props.valueKey) || Object(defineProperty["a" /* default */])({
          id: cur,
          label: cur
        }, props.valueKey, cur);

        prev[temp.id] = temp;
        return prev;
      }, {});
    } else {
      // 单选
      if (props.value) {
        var _ref3;

        var temp = findInTree(optData.value, props.value, props.valueKey) || (_ref3 = {
          id: props.value
        }, Object(defineProperty["a" /* default */])(_ref3, props.valueKey, props.value), Object(defineProperty["a" /* default */])(_ref3, "label", props.value), _ref3);
        selectedValueMap.value = Object(defineProperty["a" /* default */])({}, temp.id, temp);
      } else {
        selectedValueMap.value = {};
      }
    }
  }; // 设置selectedValue


  var setSelectedValue = function setSelectedValue() {
    selectedValue.value = Object.values(selectedValueMap.value || {}).filter(function (item) {
      return item;
    });
  }; // 处理单选


  var handleSelected = function handleSelected(data) {
    // 禁用状态，不进行选择
    if (data.disabled) {
      return;
    }

    selectedValueMap.value = Object(defineProperty["a" /* default */])({}, data.id, data);

    if (props.closePopperAfterSelected) {
      handleClosePopover();
    }
  };

  var setValue = function setValue() {
    if (props.multiple) {
      // 多选
      selectedValueMap.value = (props.value || []).reduce(function (prev, cur) {
        var temp = findInTree(optData.value, cur, props.valueKey) || Object(defineProperty["a" /* default */])({
          id: cur,
          label: cur
        }, props.valueKey, cur);

        prev[temp.id] = temp;
        return prev;
      }, {});
    } else {
      // 单选
      if (props.value) {
        var _ref5;

        var temp = findInTree(optData.value, props.value, props.valueKey) || (_ref5 = {
          id: props.value
        }, Object(defineProperty["a" /* default */])(_ref5, props.valueKey, props.value), Object(defineProperty["a" /* default */])(_ref5, "label", props.value), _ref5);
        selectedValueMap.value = Object(defineProperty["a" /* default */])({}, temp.id, temp);
      } else {
        selectedValueMap.value = {};
      }
    }
  }; // 处理ViewData用于查看


  var getViewData = function getViewData() {
    var _getEmitValue3 = getEmitValue(),
        value = _getEmitValue3.value;

    var result = [];
    var data = filterOptionsData.value;
    data.forEach(function (item) {
      // 如果只配置了一层，item.children没有值
      var children = (item.children || []).filter(function (item2) {
        var index = value.findIndex(function (item3) {
          return item2[props.valueKey] === item3;
        });

        if (index !== -1) {
          value.splice(index, 1);
          return true;
        }

        return false;
      });

      if (children && children.length) {
        result.push(_objectSpread({}, item, {
          children: children
        }));
      }
    }); // 有剩余，说明该值不在选项中

    if (value.length) {
      result.push({
        label: '其他选中项',
        children: value.map(function (item) {
          return Object(defineProperty["a" /* default */])({
            label: item
          }, props.valueKey, item);
        })
      });
    }

    return result;
  };

  var getPathLabel = function getPathLabel() {
    var _selectedValue$value$ = selectedValue.value[0],
        id = _selectedValue$value$.id,
        label = _selectedValue$value$.label;
    var target = filterOptionsData.value.find(function (level) {
      return level.children.some(function (child) {
        return child.id === id;
      });
    });
    var pathLabel = "".concat(target.label.replace(/-/g, '/'), "/").concat(label);
    return pathLabel;
  };

  var getSelectedPathTag = function getSelectedPathTag() {
    var cloneValue = Object(tools_["cloneDeep"])(selectedValue.value);
    var selectedPathTag = cloneValue.map(function (item) {
      var target = filterOptionsData.value.find(function (level) {
        return level.children.some(function (child) {
          return child.id === item.id;
        });
      });
      var pathLabel = "".concat(target.label.replace(/-/g, '/'), "/").concat(item.label);
      return _objectSpread({}, item, {
        label: pathLabel
      });
    });
    return selectedPathTag;
  };

  Object(composition_api_["watch"])(selectedValueMap, function () {
    setSelectedValue();
  }, {
    deep: true
  });
  return {
    selectedValue: selectedValue,
    selectedValueMap: selectedValueMap,
    optData: optData,
    tabsData: tabsData,
    filterOptionsData: filterOptionsData,
    storeValue: storeValue,
    getEmitValue: getEmitValue,
    emitChange: emitChange,
    handleCheck: handleCheck,
    setSelectedCount: setSelectedCount,
    handleClickClear: handleClickClear,
    handleSelectAll: handleSelectAll,
    handleSelected: handleSelected,
    emitCheck: emitCheck,
    emitTabChange: emitTabChange,
    setSelectedValueMap: setSelectedValueMap,
    setSelectedValue: setSelectedValue,
    getSelectedValue: getSelectedValue,
    getPathLabel: getPathLabel,
    getSelectedPathTag: getSelectedPathTag,
    setValue: setValue,
    getViewData: getViewData
  };
};

/* harmony default export */ var composable_useSelect = (useSelect_useSelect);
// CONCATENATED MODULE: ./components/mc-level-select/composable/useVisible.js


var useVisible_useVisible = function useVisible(props, proxy) {
  var visible = Object(composition_api_["ref"])(false);
  var showSelect = Object(composition_api_["ref"])(true);
  var container = Object(composition_api_["ref"])(null);
  var popover = Object(composition_api_["ref"])(null);
  var startClickElement = Object(composition_api_["ref"])([]);
  var innerDisabled = Object(composition_api_["computed"])(function () {
    return props.disabled;
  });
  var canShowSelect = Object(composition_api_["computed"])(function () {
    return !props.multiple || !props.disabled && showSelect.value;
  });
  var popperListeners = Object(composition_api_["computed"])(function () {
    var listeners = ['show', 'hide'];
    var result = {};
    listeners.forEach(function (item) {
      if (proxy.$listeners[item]) {
        result[item] = proxy.$listeners[item];
      }
    });
    return result;
  });

  var switchShowSelect = function switchShowSelect() {
    showSelect.value = !showSelect.value;
  };

  var handleClosePopover = function handleClosePopover() {
    visible.value = false;
  };

  var handleOpenPopover = function handleOpenPopover() {
    visible.value = true;
  };

  var handleBeforeClick = function handleBeforeClick(e) {
    startClickElement.value = e;
  };

  var triggerClick = function triggerClick(e) {
    if (!visible.value && !innerDisabled.value) {
      return;
    }

    if (container.value && popover.value && container.value.contains && popover.value.contains && !container.value.contains(startClickElement.value.target) && !popover.value.contains(startClickElement.value.target) && !container.value.contains(e.target) && !popover.value.contains(e.target)) {
      handleClosePopover();
    }
  };

  Object(composition_api_["onMounted"])(function () {
    // 事件监听，点击关闭下拉框
    window.addEventListener('mousedown', handleBeforeClick);
    window.addEventListener('mouseup', triggerClick);
  });
  Object(composition_api_["onBeforeUnmount"])(function () {
    window.removeEventListener('mousedown', handleBeforeClick);
    window.removeEventListener('mouseup', triggerClick);
  });
  return {
    visible: visible,
    container: container,
    popover: popover,
    innerDisabled: innerDisabled,
    showSelect: showSelect,
    canShowSelect: canShowSelect,
    popperListeners: popperListeners,
    switchShowSelect: switchShowSelect,
    handleClosePopover: handleClosePopover,
    handleOpenPopover: handleOpenPopover
  };
};

/* harmony default export */ var composable_useVisible = (useVisible_useVisible);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./components/mc-level-select/composable/useInit.js










function useInit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function useInit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useInit_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useInit_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var useInit_useInit = function useInit(props, params, _ref) {
  var emit = _ref.emit;

  var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
      $set = _getCurrentInstance.proxy.$set;

  var initialData = Object(composition_api_["ref"])([]); // 保存初始data

  var levelLength = Object(composition_api_["ref"])(0); // 层级数

  var activeTab = Object(composition_api_["ref"])({}); // 当前选中tab

  var optionsData = Object(composition_api_["ref"])([]); // 当前浮层所展示的每个层级的数据

  var activeOptions = Object(composition_api_["ref"])([]); // 当前浮层所聚焦的这一行数据

  var initLevelLength = function initLevelLength() {
    var level = 0;
    var item = params.optData.value[0];

    while (item) {
      level += 1;
      item = item.children && item.children[0];
    }

    levelLength.value = level;
  };

  var initProperty = function initProperty(data, parentId) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    data.forEach(function (item) {
      item._parentId = parentId; // 设置监听属性，选中值和禁用选中值

      $set(item, '_selectedCount', 0);
      $set(item, '_disabledSelectedCount', 0);
      $set(item, '_level', level);
      $set(item, '_isView', props.maxLevel < level);
      $set(item, '_isSelectLevel', props.maxLevel === level || props.maxLevel > level && level === levelLength.value);

      if (item.children) {
        initProperty(item.children, item.id, level + 1);
      }
    });
  };

  var setActiveTab = function setActiveTab(item) {
    activeTab.value = item || {};
  };

  var initActiveName = function initActiveName() {
    var _activeTab;

    if (!props.multiple && props.value && props.value.length) {
      // 单选并且有值
      var selectedValue = Object.values(params.selectedValueMap || {});
      _activeTab = props.tabConfig.find(function (item) {
        return item.filter(selectedValue[0]);
      });
    }

    if (!_activeTab) {
      _activeTab = props.tabConfig[0];
    }

    setActiveTab(_activeTab);
  }; // 设置筛选数据


  var formatToFilterOptions = function formatToFilterOptions(data, prevLabel, prevId) {
    var label = "".concat(prevLabel ? "".concat(prevLabel, "-") : '').concat(data.label);
    var id = "".concat(prevId ? "".concat(prevId, "-") : '').concat(data.id);
    var levelCount = Math.min(props.maxLevel, levelLength.value);

    if (data._level === levelCount - 1) {
      var temp = {
        label: label,
        id: id,
        children: data.children
      };
      params.filterOptionsData.value.push(temp);
      return;
    }

    data.children.forEach(function (item) {
      return formatToFilterOptions(item, label, id);
    });
  };

  var handleFilterOptions = function handleFilterOptions() {
    // 如果只有一层，直接使用数据
    if (levelLength.value === 1 || props.maxLevel === 1) {
      params.filterOptionsData.value.push({
        label: '数据',
        id: -1,
        children: params.optData.value
      });
      return;
    }

    params.optData.value.forEach(function (item) {
      return formatToFilterOptions(item);
    });
  };

  var emitInit = function emitInit() {
    Object(composition_api_["nextTick"])(function () {
      var _params$getEmitValue = params.getEmitValue(),
          value = _params$getEmitValue.value,
          items = _params$getEmitValue.items;

      emit('data-update', value, items, Object(tools_["cloneDeep"])(initialData.value));
    });
  };

  var setTabsData = function setTabsData(data) {
    var result = [];
    data.forEach(function (item) {
      if (!item.children && (!props.tabConfig || !props.tabConfig.length || activeTab.value.filter(item))) {
        // 如果是叶子节点并且该节点符合tab的筛选条件，加入
        // 如果是叶子节点并且没有配置tabConfig，加入
        result.push(item);
      }

      if (item.children) {
        // 如果不是叶子节点，判断子节点中是否有存在的，存在，则加入
        var children = setTabsData(item.children);

        if (children.length) {
          result.push(useInit_objectSpread({}, item, {
            children: children
          }));
        }
      }
    });
    return result;
  };

  var handleFilter = function handleFilter(keyword) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var result = [];
    var filterData = params.filterOptionsData.value; // 在tab下筛选

    if (!props.filterInAll && props.tabConfig) {
      filterData = [];
      params.filterOptionsData.value.forEach(function (item) {
        var children = item.children.filter(function (v) {
          return activeTab.value.filter(v);
        });

        if (children && children.length) {
          filterData.push(useInit_objectSpread({}, item, {
            children: children
          }));
        }
      });
    }

    filterData.forEach(function (item, index) {
      if (index > maxLength) {
        return;
      }

      if (item.label.includes(keyword)) {
        result.push(useInit_objectSpread({}, item, {
          children: (item.children || []).slice(0, maxLength) // 只展示前200条，防止数据过多性能问题

        }));
        return;
      }

      var children = item.children.filter(function (v) {
        return v.label.includes(keyword);
      });

      if (children.length) {
        result.push(useInit_objectSpread({}, item, {
          children: children.slice(0, maxLength) // 只展示前200条，防止数据过多性能问题

        }));
      }
    });
    return result;
  };

  var inputTabsData = function inputTabsData(data) {
    params.tabsData.value = data;
  }; // 处理选择数据


  var formatToSelectOptions = function formatToSelectOptions(data, setFirst, path) {
    // 没有数据直接返回空
    if (!data || !data.length) {
      return [];
    }

    var result = []; // 当前层设置为传入的数据

    result[0] = data; // 处理后面的层级数据

    var temp;

    if (setFirst) {
      temp = data[0];
    } else {
      // 如果没有找到数据，还是设置为data[0]
      temp = path.shift() || data[0];
    }

    while (temp.children && temp.children.length) {
      result.push(temp.children);

      if (setFirst) {
        temp = temp.children[0];
      } else {
        // 如果没有找到数据，还是设置为data[0]
        temp = path.shift() || temp.children[0];
      }
    }

    return result;
  };

  var initOptionsData = function initOptionsData() {
    var selectedValue = Object.values(params.selectedValueMap.value || {});
    var value = selectedValue[0];
    var path = [];
    var finded = false; // 多选和没有value时是不用查找路径的，可以直接设置层级数据

    if (!props.multiple && value) {
      finded = findPathInTree(params.tabsData.value, value, path, 0);
    } // 如果找到了值，说明是单选并且有初始值，这是应该展示选中项所在的数据列


    optionsData.value = formatToSelectOptions(params.tabsData.value, !finded, path.map(function (item) {
      return item;
    })); // 用于渲染作为选项的数据
    // 设置活跃标签

    if (path && path.length) {
      activeOptions.value = path;
    } else {
      activeOptions.value = optionsData.value.map(function (item) {
        return item[0];
      }); // 当前活跃选项路径
    }
  }; // 处理活跃选项


  var handleChangeActiveOpt = function handleChangeActiveOpt(item, level) {
    if (activeOptions.value.findIndex(function (v) {
      return v.id === item.id;
    }) !== -1) {
      return;
    }

    var selectOption = formatToSelectOptions(item.children, true);
    optionsData.value = optionsData.value.slice(0, level + 1).concat(selectOption);
    activeOptions.value[level] = item;
    activeOptions.value = activeOptions.value.slice(0, level + 1).concat(optionsData.value.slice(level + 1).map(function (v) {
      return v[0];
    }));
  }; // 设置数据私有属性


  var setDataInfo = function setDataInfo(data, levelCount) {
    var sumCount = 0;
    var disabledCount = 0;
    data.forEach(function (item) {
      // 设置每条data下总共有几个可选项数量和禁用项数量
      if (item._level >= levelCount - 1) {
        item._count = (item.children || []).length;
        item._disabledCount = (item.children || []).filter(function (v) {
          return v.disabled;
        }).length;
        sumCount += item._count;
        disabledCount += item._disabledCount;
        return;
      }

      var _setDataInfo = setDataInfo(item.children, levelCount);

      item._count = _setDataInfo.sumCount;
      item._disabledCount = _setDataInfo.disabledCount;
      sumCount += item._count;
      disabledCount += item._disabledCount;
    });
    return {
      sumCount: sumCount,
      disabledCount: disabledCount
    };
  };

  var initCount = function initCount() {
    // 设置总个数和禁用个数
    var levelCount = Math.min(props.maxLevel, levelLength.value);
    setDataInfo(params.tabsData.value, levelCount); // 设置节点的选中个数

    params.setSelectedCount();
  };

  var init = function init(data) {
    // 保存一份初始data
    initialData.value = data;
    params.optData.value = Object(tools_["cloneDeep"])(data);
    activeTab.value = {};
    params.selectedValue.value = [];
    params.selectedValueMap.value = {};
    params.filterOptionsData.value = [];
    initLevelLength(); // 计算层级数

    initProperty(params.optData.value); // 添加parentId属性

    params.setValue(); // 设置初始值

    params.setSelectedValueMap(); // 初始化tab的选择

    if (props.tabConfig && props.tabConfig.length) {
      initActiveName(); // // 如果有tab配置，用于渲染的数据需要根据tab配置进行筛选
    }

    inputTabsData(setTabsData(params.optData.value));
    initOptionsData(); // 初始化用于渲染的数据

    initCount(); // 设置选项个数和选中个数
    // 初始化用于进行筛选的数据

    handleFilterOptions();
    emitInit();
  };

  init(props.data);
  return {
    activeTab: activeTab,
    levelLength: levelLength,
    optionsData: optionsData,
    activeOptions: activeOptions,
    setTabsData: setTabsData,
    inputTabsData: inputTabsData,
    init: init,
    initOptionsData: initOptionsData,
    initCount: initCount,
    setActiveTab: setActiveTab,
    handleFilter: handleFilter,
    handleChangeActiveOpt: handleChangeActiveOpt
  };
};

/* harmony default export */ var composable_useInit = (useInit_useInit);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/main.vue?vue&type=template&id=546d01d9&
var mainvue_type_template_id_546d01d9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-level-select-selected-view",on:{"mouseenter":function($event){return _vm.changeShowClose(true)},"mouseleave":function($event){return _vm.changeShowClose(false)}}},[(_vm.readonly)?_c('read-view'):(_vm.showSingleView)?_c('single-view',{attrs:{"icon":_vm.iconType},on:{"clear":_vm.handleClear}}):_c('multiple-view',{attrs:{"icon":_vm.iconType},on:{"clear":_vm.handleClear}})],1)}
var mainvue_type_template_id_546d01d9_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/main.vue?vue&type=template&id=546d01d9&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/SingleView.vue?vue&type=template&id=fec4762e&
var SingleViewvue_type_template_id_fec4762e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-input',{class:{'is-focus': _vm.visible && _vm.disabled, 'is-disabled': _vm.disabled},attrs:{"value":_vm.label,"validate-event":false,"size":_vm.size,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":"","clearable":_vm.clearable},on:{"focus":_vm.handleFocus},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_c('i',{staticClass:"icon",class:_vm.icon,attrs:{"slot":"suffix"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClear.apply(null, arguments)}},slot:"suffix"})])}
var SingleViewvue_type_template_id_fec4762e_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/SingleView.vue?vue&type=template&id=fec4762e&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/SingleView.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SingleViewvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'SingleView',
  props: {
    icon: {
      type: String,
      default: ''
    }
  },
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var size = dataMap.size,
        showPath = dataMap.showPath,
        placeholder = dataMap.placeholder,
        clearable = dataMap.clearable,
        handleOpenPopover = dataMap.handleOpenPopover;
    var handleClear = Object(composition_api_["inject"])('handleClear');

    var getLabel = function getLabel() {
      var value = dataMap.selectedValue;

      if (!value || !value.length) {
        return '';
      }

      if (value.length === 1) {
        return showPath ? dataMap.getPathLabel(value) : value[0].label;
      }

      return "\u5DF2\u9009\u62E9".concat(value.length, "\u4E2A");
    };

    var label = Object(composition_api_["computed"])(function () {
      return getLabel();
    });
    var disabled = Object(composition_api_["computed"])(function () {
      return dataMap.innerDisabled;
    });
    var visible = Object(composition_api_["computed"])(function () {
      return dataMap.visible;
    });

    var handleFocus = function handleFocus() {
      if (disabled.value && dataMap.selectedValue.length <= 1) {
        // 如果disabled并且选中数量小于1
        return;
      }

      handleOpenPopover();
    }; // 多选禁用展示已选


    var handleClick = function handleClick() {
      if (!disabled.value || dataMap.selectedValue.length <= 1) {
        return;
      }

      handleOpenPopover();
    };

    return {
      label: label,
      size: size,
      visible: visible,
      disabled: disabled,
      placeholder: placeholder,
      clearable: clearable,
      handleFocus: handleFocus,
      handleClick: handleClick,
      handleClear: handleClear
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/SingleView.vue?vue&type=script&lang=js&
 /* harmony default export */ var SelectedView_SingleViewvue_type_script_lang_js_ = (SingleViewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/SingleView.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  SelectedView_SingleViewvue_type_script_lang_js_,
  SingleViewvue_type_template_id_fec4762e_render,
  SingleViewvue_type_template_id_fec4762e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SingleView = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/MultipleView.vue?vue&type=template&id=876ee234&
var MultipleViewvue_type_template_id_876ee234_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tagWrapper",class:((_vm.disabled ? 'is-disabled' : '') + " " + (_vm.visible && !_vm.disabled ? 'is-focus' : '') + " mc-level-select-tag-wrapper mtd-input mtd-input--" + _vm.size),on:{"click":_vm.handleClick}},[_c('span',{staticClass:"mtd-input__inner"},[_c('span',{staticClass:"tag-wrapper__inner"},[_vm._l((_vm.selectedTags.slice(0, _vm.tagsCount)),function(item){return _c('mtd-tag',{key:item.id,attrs:{"size":"small","closable":!_vm.disabled},on:{"close":function($event){return _vm.deleteOneData(item)}}},[_vm._v(_vm._s(item.label))])}),(_vm.selectedTags.length > _vm.tagsCount)?_c('mtd-tag',{key:"extend",attrs:{"size":"small"}},[_vm._v("+"+_vm._s(+ (_vm.selectedTags.length - _vm.tagsCount)))]):_vm._e()],2),_c('i',{class:("icon-wrapper " + _vm.icon),on:{"click":function($event){$event.stopPropagation();return _vm.handleClear.apply(null, arguments)}}})])])}
var MultipleViewvue_type_template_id_876ee234_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/MultipleView.vue?vue&type=template&id=876ee234&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/MultipleView.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MultipleViewvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'MultipleView',
  props: {
    icon: {
      type: String,
      default: ''
    }
  },
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var showPath = dataMap.showPath,
        showTags = dataMap.showTags,
        handleOpenPopover = dataMap.handleOpenPopover,
        size = dataMap.size,
        emitChange = dataMap.emitChange,
        emitCheck = dataMap.emitCheck,
        handleCheck = dataMap.handleCheck;
    var handleClear = Object(composition_api_["inject"])('handleClear');
    var tagsCount = Object(composition_api_["computed"])(function () {
      if (typeof showTags === 'number') {
        return showTags;
      }

      return 5;
    });
    var disabled = Object(composition_api_["computed"])(function () {
      return dataMap.innerDisabled;
    });
    var visible = Object(composition_api_["computed"])(function () {
      return dataMap.visible;
    });
    var selectedValue = Object(composition_api_["computed"])(function () {
      return dataMap.selectedValue;
    });
    var selectedTags = Object(composition_api_["computed"])(function () {
      return showPath ? dataMap.getSelectedPathTag() : selectedValue.value;
    });

    var deleteOneData = function deleteOneData(item) {
      handleCheck(false, item, false);
      emitChange();
      emitCheck(false, Object(tools_["cloneDeep"])(item));
    };

    var handleClick = function handleClick() {
      if (disabled.value && selectedValue.value.length <= tagsCount) {
        // 如果disabled并且选中数量小于1
        return;
      }

      handleOpenPopover();
    };

    return {
      visible: visible,
      disabled: disabled,
      selectedTags: selectedTags,
      size: size,
      tagsCount: tagsCount,
      deleteOneData: deleteOneData,
      handleClick: handleClick,
      handleClear: handleClear
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/MultipleView.vue?vue&type=script&lang=js&
 /* harmony default export */ var SelectedView_MultipleViewvue_type_script_lang_js_ = (MultipleViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/MultipleView.vue





/* normalize component */

var MultipleView_component = Object(componentNormalizer["a" /* default */])(
  SelectedView_MultipleViewvue_type_script_lang_js_,
  MultipleViewvue_type_template_id_876ee234_render,
  MultipleViewvue_type_template_id_876ee234_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MultipleView = (MultipleView_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/ReadView.vue?vue&type=template&id=0bda7b0e&
var ReadViewvue_type_template_id_0bda7b0e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-level-select-readonly-text"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])}
var ReadViewvue_type_template_id_0bda7b0e_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/ReadView.vue?vue&type=template&id=0bda7b0e&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/ReadView.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var ReadViewvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var showPath = dataMap.showPath;

    var getLabel = function getLabel() {
      var value = dataMap.selectedValue;

      if (!value || !value.length) {
        return '';
      } else if (value.length === 1) {
        return showPath ? dataMap.getPathLabel() : value[0].label;
      } else {
        var selectedTags = showPath ? dataMap.getSelectedPathTag() : value;
        return selectedTags.map(function (item) {
          return item.label;
        }).join(',');
      }
    };

    var label = Object(composition_api_["computed"])(function () {
      return getLabel();
    });
    return {
      label: label
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/ReadView.vue?vue&type=script&lang=js&
 /* harmony default export */ var SelectedView_ReadViewvue_type_script_lang_js_ = (ReadViewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/ReadView.vue





/* normalize component */

var ReadView_component = Object(componentNormalizer["a" /* default */])(
  SelectedView_ReadViewvue_type_script_lang_js_,
  ReadViewvue_type_template_id_0bda7b0e_render,
  ReadViewvue_type_template_id_0bda7b0e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReadView = (ReadView_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectedView/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mainvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'SelectedView',
  components: {
    SingleView: SingleView,
    MultipleView: MultipleView,
    ReadView: ReadView
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var showTags = dataMap.showTags,
        handleClickClear = dataMap.handleClickClear;
    var showClose = Object(composition_api_["ref"])(false);
    var readonly = Object(composition_api_["computed"])(function () {
      return dataMap.readonly;
    });
    var closeVisible = Object(composition_api_["computed"])(function () {
      return dataMap.clearable && !dataMap.innerDisabled && showClose.value && dataMap.selectedValue.some(function (item) {
        return !item.disabled;
      });
    }); // 展示单选项还是多个选项

    var showSingleView = Object(composition_api_["computed"])(function () {
      if (!props.multiple || !showTags) return true;
      return dataMap.selectedValue.length <= 1;
    });
    var iconType = Object(composition_api_["computed"])(function () {
      if (closeVisible.value) {
        return 'mtdicon-error-circle';
      }

      return props.visible ? 'mtdicon-up' : 'mtdicon-down';
    });

    var handleClear = function handleClear() {
      if (closeVisible.value) {
        handleClickClear();
      }
    };

    var changeShowClose = function changeShowClose(val) {
      showClose.value = val;
    };

    Object(composition_api_["provide"])('handleClear', handleClear);
    return {
      readonly: readonly,
      iconType: iconType,
      showSingleView: showSingleView,
      handleClear: handleClear,
      changeShowClose: changeShowClose
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var SelectedView_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectedView/main.vue





/* normalize component */

var main_component = Object(componentNormalizer["a" /* default */])(
  SelectedView_mainvue_type_script_lang_js_,
  mainvue_type_template_id_546d01d9_render,
  mainvue_type_template_id_546d01d9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var main = (main_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectWrapper.vue?vue&type=template&id=e1c598a2&
var SelectWrappervue_type_template_id_e1c598a2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mc-level-select-header"},[(_vm.filterInAll)?_c('mtd-input',{staticClass:"mb5 filterInput",attrs:{"size":"small","placeholder":_vm.filterPlaceholder,"validate-event":false,"clearable":""},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}}):_vm._e(),(_vm.multiple && _vm.showSelectAll && _vm.data.length)?_c('div',{staticClass:"select-all"},[_c('mtd-checkbox',{attrs:{"checked":_vm.isSelectAll,"indeterminate":!!_vm.selectedLength && _vm.selectedLength !== _vm.allLeafData.length},on:{"input":_vm.handleCheckAll}}),_c('span',{staticClass:"seletc-all-text"},[_vm._v("全选")]),_c('span',[_vm._v("("+_vm._s(_vm.selectedLength)+"/"+_vm._s(_vm.allLeafData.length)+")")])],1):_vm._e(),((!_vm.keyword || !_vm.filterInAll) && _vm.tabConfig.length)?_c('filter-tabs',{on:{"change":_vm.handleChangeTab}}):_vm._e(),(!_vm.filterInAll)?_c('mtd-input',{staticClass:"mt5 filterInput",attrs:{"size":"small","placeholder":_vm.filterPlaceholder,"validate-event":false,"clearable":""},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}}):_vm._e()],1),_c('div',{staticClass:"select-body"},[(!_vm.keyword)?_c('options-wrapper',{ref:"optionsWrapper"}):_c('filter-options-wrapper',{ref:"filterOptionsWrapper"})],1)])}
var SelectWrappervue_type_template_id_e1c598a2_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/SelectWrapper.vue?vue&type=template&id=e1c598a2&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("4f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__("1c4c");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/OptionsWrapper.vue?vue&type=template&id=180c6a7a&
var OptionsWrappervue_type_template_id_180c6a7a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-level-select-options-wrapper"},[_vm._l((_vm.innerData),function(levelData,index){return _c('ul',{key:index,staticClass:"level-wrapper"},[(_vm.multiple && _vm.showSelectTabAll && index === 0 && _vm.tabConfig.length)?_c('li',{staticClass:"option",class:{'is-selected': _vm.allCount[0] && _vm.allCount[0] === _vm.allCount[1]}},[_c('mtd-checkbox',{attrs:{"checked":_vm.allCount[0] === _vm.allCount[1],"indeterminate":!!_vm.allCount[0] && _vm.allCount[0] !== _vm.allCount[1]},on:{"input":_vm.handleCheckAll}}),_c('span',{staticClass:"label"},[_vm._v("全选")]),(_vm.multiple && _vm.showCount)?_c('span',{staticClass:"count"},[_c('span',[_vm._v("(")]),(_vm.allCount[0])?_c('span',[_vm._v(_vm._s(_vm.allCount[0])+"/")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.allCount[1])+")")])]):_vm._e()],1):_vm._e(),_vm._l((levelData),function(item){return _c('li',{key:item.id,staticClass:"option",class:{
                'is-active': index !== _vm.levelLength - 1 && _vm.activeItems.includes(item.id),
                'is-selected': _vm.isSelectedClass(item),
                'is-disabled': _vm.isDisabledClass(item)
            },on:{"click":function($event){return _vm.handleClickOption(item, index)}}},[(_vm.multiple && _vm.maxLevel >= index + 1)?_c('mtd-checkbox',{key:item.id,attrs:{"checked":_vm.judgeSelected(item),"indeterminate":!!item._selectedCount && !_vm.judgeSelected(item),"disabled":_vm.isDisabledClass(item)},on:{"input":function (val) { return _vm.handleCheckClick(val, item); }}}):_c('i',{staticClass:"checked",class:{'mtdicon-check': item.checked }}),_c('level-label',{attrs:{"data":item,"is-view":_vm.judgeSelected(item)}}),(_vm.multiple && _vm.showCount && index !== _vm.innerData.length - 1 && _vm.maxLevel > index + 1 )?_c('span',{staticClass:"count"},[_c('span',[_vm._v("(")]),(item._selectedCount && _vm.multiple)?_c('span',[_vm._v(_vm._s(item._selectedCount)+"/")]):_vm._e(),_c('span',[_vm._v(_vm._s(item._count)+")")])]):_vm._e()],1)})],2)}),(!_vm.innerData.length)?_c('div',{staticClass:"nodata"},[_vm._v("\n        "+_vm._s(_vm.emptyText || '暂无数据')+"\n    ")]):_vm._e()],2)}
var OptionsWrappervue_type_template_id_180c6a7a_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/OptionsWrapper.vue?vue&type=template&id=180c6a7a&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/LevelLabel.vue?vue&type=template&id=cccccefa&
var LevelLabelvue_type_template_id_cccccefa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.content))])}
var LevelLabelvue_type_template_id_cccccefa_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/LevelLabel.vue?vue&type=template&id=cccccefa&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/LevelLabel.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var LevelLabelvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'LevelLabel',
  props: {
    data: {
      type: Object,
      required: true
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var renderViewNode = dataMap.renderViewNode,
        renderNode = dataMap.renderNode;
    var content = Object(composition_api_["computed"])(function () {
      if (props.isView && renderViewNode) return renderViewNode(props.data);
      if (renderNode) return renderNode(props.data);
      return props.data.label;
    });
    return {
      content: content,
      renderViewNode: renderViewNode,
      renderNode: renderNode
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/LevelLabel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_LevelLabelvue_type_script_lang_js_ = (LevelLabelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/LevelLabel.vue





/* normalize component */

var LevelLabel_component = Object(componentNormalizer["a" /* default */])(
  components_LevelLabelvue_type_script_lang_js_,
  LevelLabelvue_type_template_id_cccccefa_render,
  LevelLabelvue_type_template_id_cccccefa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LevelLabel = (LevelLabel_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/OptionsWrapper.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var OptionsWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'OptionsWrapper',
  components: {
    LevelLabel: LevelLabel
  },
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var multiple = dataMap.multiple,
        maxLevel = dataMap.maxLevel,
        showSelectTabAll = dataMap.showSelectTabAll,
        showCount = dataMap.showCount,
        maxSelectedCount = dataMap.maxSelectedCount,
        $mtd = dataMap.$mtd,
        handleCheck = dataMap.handleCheck,
        handleSelected = dataMap.handleSelected,
        emitChange = dataMap.emitChange,
        emitCheck = dataMap.emitCheck,
        handleChangeActiveOpt = dataMap.handleChangeActiveOpt,
        emptyText = dataMap.emptyText;
    var allCount = Object(composition_api_["ref"])([0, 0]);
    var innerData = Object(composition_api_["computed"])(function () {
      var data = dataMap.optionsData;

      if (!data || !data.length) {
        return [];
      }

      return data;
    });
    var tabConfig = Object(composition_api_["computed"])(function () {
      return dataMap.tabConfig;
    });
    var activeItems = Object(composition_api_["computed"])(function () {
      return dataMap.activeOptions.map(function (item) {
        return item.id;
      });
    });
    var selectedPath = Object(composition_api_["computed"])(function () {
      var selectedValues = Object.values(dataMap.selectedValueMap);
      var value = selectedValues[0]; // 多选和没有value时是不用的

      if (multiple || !value || dataMap.activeTab && dataMap.activeTab.filter && !dataMap.activeTab.filter(value)) {
        return [];
      }

      var path = [value.id];

      while (value && value._parentId) {
        value = findInTree(dataMap.optData, value._parentId);

        if (value) {
          path.unshift(value.id);
        }
      }

      return path;
    });
    var isDisabledClass = Object(composition_api_["computed"])(function () {
      return function (data) {
        if (data.disabled || data._isView || data.children && data._count && data._disabledCount && data._count === data._disabledCount) {
          return true;
        }

        return false;
      };
    });
    var isSelectedClass = Object(composition_api_["computed"])(function () {
      return function (data) {
        if (data._isView) return false;

        if (data._isSelectLevel) {
          return !!dataMap.selectedValueMap[data.id];
        }

        if (multiple) {
          return data._selectedCount && data._selectedCount !== 0;
        }

        return selectedPath.value.includes(data.id);
      };
    });
    var judgeSelected = Object(composition_api_["computed"])(function () {
      return function (data) {
        if (data._isSelectLevel) {
          return !!dataMap.selectedValueMap[data.id];
        }

        return data._selectedCount - (data._disabledSelectedCount || 0) === data._count - data._disabledCount;
      };
    });
    var levelLength = Object(composition_api_["computed"])(function () {
      return dataMap.levelLength;
    });

    var handleClickOption = function handleClickOption(item, index) {
      // 切换父级菜单
      if (index < levelLength.value - 1) handleChangeActiveOpt(item, index);

      if (item._isSelectLevel) {
        // 选择门店
        if (multiple) {
          return;
        }

        handleSelected(item);
        emitChange();
      }
    };

    var handleCheckClick = function handleCheckClick(val, item) {
      var emit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (val && (item._isSelectLevel && dataMap.selectedValue.length >= maxSelectedCount || !item._isSelectLevel && item.children && dataMap.selectedValue.length + item._count - (item._selectedCount || 0) > maxSelectedCount)) {
        $mtd.message.warning("\u9009\u62E9\u5931\u8D25\uFF0C\u8D85\u51FA\u9009\u62E9\u6570\u91CF\u4E0A\u9650\uFF1A".concat(maxSelectedCount));
        return;
      } // emit控制是否抛出事件


      handleCheck(val, item);

      if (emit) {
        emitChange();
        emitCheck(val, Object(tools_["cloneDeep"])(item));
      }
    };

    var handleCheckAll = function handleCheckAll(val) {
      if (val && allCount.value[1] > maxSelectedCount) {
        $mtd.message.warning("\u9009\u62E9\u5931\u8D25\uFF0C\u8D85\u51FA\u9009\u62E9\u6570\u91CF\u4E0A\u9650\uFF1A".concat(maxSelectedCount));
        return;
      } // 执行对第一层的选中


      innerData.value[0].forEach(function (item) {
        handleCheckClick(val, item, false);
      });
      emitChange();
      emitCheck(val, Object(tools_["cloneDeep"])(innerData.value[0]));
    };

    var getAllCount = function getAllCount(val) {
      if (dataMap.optionsData && dataMap.optionsData.length === 1) {
        // 一维的
        allCount.value = [dataMap.selectedValue.length, val.length];
        return;
      } // [全部选中数量, 选项数量]


      allCount.value = val.reduce(function (prev, cur) {
        return [prev[0] + (cur._selectedCount || 0), prev[1] + (cur._count || 0)];
      }, [0, 0]);
    };

    var init = function init() {
      if (multiple && showSelectTabAll) {
        getAllCount(dataMap.optionsData[0] || []);
      }
    };

    init();
    Object(composition_api_["watch"])(function () {
      return dataMap.selectedValue;
    }, function () {
      if (multiple && showSelectTabAll && dataMap.optionsData && dataMap.optionsData.length === 1) {
        // 一维数据监听
        getAllCount(dataMap.optionsData[0]);
      }
    });
    Object(composition_api_["watch"])(function () {
      return innerData.value[0];
    }, function (val) {
      if (multiple && showSelectTabAll) {
        getAllCount(val || []);
      }
    }, {
      deep: true
    });
    return {
      multiple: multiple,
      maxLevel: maxLevel,
      showCount: showCount,
      allCount: allCount,
      innerData: innerData,
      tabConfig: tabConfig,
      activeItems: activeItems,
      levelLength: levelLength,
      showSelectTabAll: showSelectTabAll,
      isDisabledClass: isDisabledClass,
      judgeSelected: judgeSelected,
      isSelectedClass: isSelectedClass,
      emptyText: emptyText,
      handleClickOption: handleClickOption,
      handleCheckAll: handleCheckAll,
      handleCheckClick: handleCheckClick
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/OptionsWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_OptionsWrappervue_type_script_lang_js_ = (OptionsWrappervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/OptionsWrapper.vue





/* normalize component */

var OptionsWrapper_component = Object(componentNormalizer["a" /* default */])(
  components_OptionsWrappervue_type_script_lang_js_,
  OptionsWrappervue_type_template_id_180c6a7a_render,
  OptionsWrappervue_type_template_id_180c6a7a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OptionsWrapper = (OptionsWrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/FilterOptionsWrapper.vue?vue&type=template&id=05145b1c&
var FilterOptionsWrappervue_type_template_id_05145b1c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-level-select-filter-options-wrapper"},[_vm._l((_vm.list),function(areaData){return _c('ul',{key:areaData.label,staticClass:"area-wrapper"},[_c('div',{staticClass:"area-name"},[_vm._v("\n            "+_vm._s(areaData.label)+"\n        ")]),_vm._l((areaData.children),function(item){return _c('li',{key:item.id,staticClass:"option",class:{'is-selected': _vm.isSelectedClass(item),'is-disabled': item.disabled},on:{"click":function($event){return _vm.handleClickOption(item)}}},[(_vm.multiple)?_c('mtd-checkbox',{key:item.id,attrs:{"checked":_vm.judgeSelected(item)},on:{"input":function (val) { return _vm.beforeHandleCheck(val, item); }}}):_c('i',{staticClass:"checked",class:{'mtd-icon-check': item.checked }}),_c('level-label',{attrs:{"data":item}})],1)})],2)}),(!_vm.list.length)?_c('div',{staticClass:"placeholder"},[_vm._v("\n        无匹配数据\n    ")]):_vm._e()],2)}
var FilterOptionsWrappervue_type_template_id_05145b1c_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/FilterOptionsWrapper.vue?vue&type=template&id=05145b1c&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/FilterOptionsWrapper.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FilterOptionsWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'FilterOptionsWrapper',
  components: {
    LevelLabel: LevelLabel
  },
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var multiple = dataMap.multiple,
        maxLevel = dataMap.maxLevel,
        maxSelectedCount = dataMap.maxSelectedCount,
        maxFilterLength = dataMap.maxFilterLength,
        handleSelected = dataMap.handleSelected,
        handleFilter = dataMap.handleFilter,
        emitChange = dataMap.emitChange,
        emitCheck = dataMap.emitCheck,
        handleChangeActiveOpt = dataMap.handleChangeActiveOpt,
        handleCheck = dataMap.handleCheck,
        $mtd = dataMap.$mtd;
    var list = Object(composition_api_["ref"])([]);

    var isSelectedClass = function isSelectedClass(data) {
      if (data._isSelectLevel) {
        return !!dataMap.selectedValueMap[data.id];
      }

      return data._selectedCount && data._selectedCount !== 0;
    };

    var judgeSelected = function judgeSelected(data) {
      if (data._isSelectLevel) {
        return !!dataMap.selectedValueMap[data.id];
      }

      return data._selectedCount === data._count;
    };

    var handleClickOption = function handleClickOption(item) {
      // 选择门店
      if (multiple) {
        return;
      }

      handleSelected(item);
      emitChange(); // // 切换父级菜单

      var levelCount = Math.min(maxLevel, dataMap.levelLength);
      handleChangeActiveOpt(item, levelCount - 1, true);
    };

    var beforeHandleCheck = function beforeHandleCheck(val, item) {
      if (val && dataMap.selectedValue.length >= maxSelectedCount) {
        // 选择数量限制
        $mtd.message.warning("\u9009\u62E9\u5931\u8D25\uFF0C\u8D85\u51FA\u9009\u62E9\u6570\u91CF\u4E0A\u9650\uFF1A".concat(maxSelectedCount));
        return;
      }

      handleCheck(val, item);
      emitChange();
      emitCheck(val, Object(tools_["cloneDeep"])(item));
    };

    var filter = function filter(val) {
      list.value = handleFilter(val, maxFilterLength || 100);
    };

    return {
      multiple: multiple,
      list: list,
      isSelectedClass: isSelectedClass,
      judgeSelected: judgeSelected,
      handleClickOption: handleClickOption,
      beforeHandleCheck: beforeHandleCheck,
      filter: filter
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/FilterOptionsWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FilterOptionsWrappervue_type_script_lang_js_ = (FilterOptionsWrappervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/FilterOptionsWrapper.vue





/* normalize component */

var FilterOptionsWrapper_component = Object(componentNormalizer["a" /* default */])(
  components_FilterOptionsWrappervue_type_script_lang_js_,
  FilterOptionsWrappervue_type_template_id_05145b1c_render,
  FilterOptionsWrappervue_type_template_id_05145b1c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilterOptionsWrapper = (FilterOptionsWrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/FilterTabs.vue?vue&type=template&id=a4bcbde8&
var FilterTabsvue_type_template_id_a4bcbde8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-level-select-filter-tabs"},_vm._l((_vm.tabConfig),function(item){return _c('div',{key:item.label,class:("tab-wrapper " + (_vm.activeName === item.label ? 'is-active': '')),on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v("\n        "+_vm._s(item.render ? item.render(_vm.activeTab) : item.label)+"\n    ")])}),0)}
var FilterTabsvue_type_template_id_a4bcbde8_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/FilterTabs.vue?vue&type=template&id=a4bcbde8&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/FilterTabs.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FilterTabsvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'FilterTabs',
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var initOptionsData = dataMap.initOptionsData,
        initCount = dataMap.initCount,
        inputTabsData = dataMap.inputTabsData,
        setTabsData = dataMap.setTabsData,
        emitTabChange = dataMap.emitTabChange,
        setActiveTab = dataMap.setActiveTab;
    var activeTab = Object(composition_api_["computed"])(function () {
      return dataMap.activeTab;
    });
    var activeName = Object(composition_api_["computed"])(function () {
      return dataMap.activeTab.label;
    });
    var tabConfig = Object(composition_api_["computed"])(function () {
      return dataMap.tabConfig;
    });

    var handleClick = function handleClick(item) {
      setActiveTab(item);
      Object(composition_api_["nextTick"])(function () {
        emit('change', item);
        emitTabChange(item);
      });
    };

    Object(composition_api_["watch"])(activeName, function () {
      Object(composition_api_["nextTick"])(function () {
        inputTabsData(setTabsData(dataMap.optData));
        initOptionsData();
        initCount();
      });
    });
    return {
      activeTab: activeTab,
      activeName: activeName,
      tabConfig: tabConfig,
      handleClick: handleClick
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/FilterTabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FilterTabsvue_type_script_lang_js_ = (FilterTabsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/FilterTabs.vue





/* normalize component */

var FilterTabs_component = Object(componentNormalizer["a" /* default */])(
  components_FilterTabsvue_type_script_lang_js_,
  FilterTabsvue_type_template_id_a4bcbde8_render,
  FilterTabsvue_type_template_id_a4bcbde8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilterTabs = (FilterTabs_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/SelectWrapper.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var SelectWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'SelectWrapper',
  components: {
    FilterTabs: FilterTabs,
    OptionsWrapper: OptionsWrapper,
    FilterOptionsWrapper: FilterOptionsWrapper
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var showSelectAll = dataMap.showSelectAll,
        valueKey = dataMap.valueKey,
        filterInAll = dataMap.filterInAll,
        filterPlaceholder = dataMap.filterPlaceholder,
        maxSelectedCount = dataMap.maxSelectedCount,
        $mtd = dataMap.$mtd,
        getEmitValue = dataMap.getEmitValue,
        handleSelectAll = dataMap.handleSelectAll,
        handleClickClear = dataMap.handleClickClear;
    var keyword = Object(composition_api_["ref"])('');
    var timeout = Object(composition_api_["ref"])(null);
    var filterOptionsWrapper = Object(composition_api_["ref"])(null);
    var selectedLength = Object(composition_api_["computed"])(function () {
      return dataMap.selectedValue.length;
    });
    var tabConfig = Object(composition_api_["computed"])(function () {
      return dataMap.tabConfig;
    });
    var allLeafData = Object(composition_api_["computed"])(function () {
      return getLeafData(dataMap.optData).filter(function (item) {
        return !item.disabled;
      });
    });
    var isSelectAll = Object(composition_api_["computed"])(function () {
      var _getEmitValue = getEmitValue(),
          value = _getEmitValue.value;

      var allLeafValue = allLeafData.value.map(function (item) {
        return item[valueKey];
      });
      var concatData = Array.from(new Set(value.concat(allLeafValue))); // 如果全部的叶子节点值都在已选择的数据内，则全选

      return concatData.length === value.length;
    });

    var handleChangeTab = function handleChangeTab() {
      if (keyword.value) filterOptionsWrapper.value.filter(keyword.value);
    };

    var handleCheckAll = function handleCheckAll(val) {
      if (val && allLeafData.value.length > maxSelectedCount) {
        // 选择数量限制
        $mtd.message.warning("\u9009\u62E9\u5931\u8D25\uFF0C\u8D85\u51FA\u9009\u62E9\u6570\u91CF\u4E0A\u9650\uFF1A".concat(maxSelectedCount));
        return;
      }

      if (val) {
        // 全选
        handleSelectAll();
        return;
      } // 清空选择


      handleClickClear();
    };

    Object(composition_api_["watch"])(keyword, function (val) {
      clearTimeout(timeout.value);
      if (!val) return;
      timeout.value = setTimeout(function () {
        filterOptionsWrapper.value.filter(val);
      }, 300);
    });
    Object(composition_api_["watch"])(function () {
      return dataMap.visible;
    }, function () {
      keyword.value = '';
    });
    Object(composition_api_["onBeforeUnmount"])(function () {
      clearTimeout(timeout.value);
    });
    return {
      showSelectAll: showSelectAll,
      keyword: keyword,
      tabConfig: tabConfig,
      filterInAll: filterInAll,
      filterPlaceholder: filterPlaceholder,
      selectedLength: selectedLength,
      isSelectAll: isSelectAll,
      allLeafData: allLeafData,
      filterOptionsWrapper: filterOptionsWrapper,
      handleCheckAll: handleCheckAll,
      handleChangeTab: handleChangeTab
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SelectWrappervue_type_script_lang_js_ = (SelectWrappervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/SelectWrapper.vue





/* normalize component */

var SelectWrapper_component = Object(componentNormalizer["a" /* default */])(
  components_SelectWrappervue_type_script_lang_js_,
  SelectWrappervue_type_template_id_e1c598a2_render,
  SelectWrappervue_type_template_id_e1c598a2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SelectWrapper = (SelectWrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/ViewWrapper.vue?vue&type=template&id=580e5470&
var ViewWrappervue_type_template_id_580e5470_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"mc-scroll",rawName:"v-mc-scroll",value:(_vm.scrollParams),expression:"scrollParams"}],staticClass:"mc-level-select-view-wrapper"},[_vm._l((_vm.showData),function(areaData){return _c('ul',{key:areaData.label,staticClass:"area-wrapper"},[_c('div',{staticClass:"area-name"},[_vm._v("\n            "+_vm._s(areaData.label)+"\n        ")]),_vm._l((areaData.children),function(item){return _c('mtd-tag',{key:item.id,attrs:{"effect":"plain","closable":!_vm.disabled && !item.disabled},on:{"close":function($event){return _vm.handleClose(item)}}},[_c('level-label',{attrs:{"data":item,"is-view":""}})],1)})],2)}),(!_vm.viewData.length)?_c('div',{staticClass:"placeholder"},[_vm._v("\n        无选择数据\n    ")]):_vm._e()],2)}
var ViewWrappervue_type_template_id_580e5470_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-level-select/components/ViewWrapper.vue?vue&type=template&id=580e5470&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/components/ViewWrapper.vue?vue&type=script&lang=js&





function ViewWrappervue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ViewWrappervue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ViewWrappervue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ViewWrappervue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ViewWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'ViewWrapper',
  components: {
    LevelLabel: LevelLabel
  },
  setup: function setup() {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var getViewData = dataMap.getViewData,
        handleCheck = dataMap.handleCheck,
        emitChange = dataMap.emitChange,
        emitCheck = dataMap.emitCheck;
    var viewData = Object(composition_api_["computed"])(function () {
      return getViewData();
    });
    var disabled = Object(composition_api_["computed"])(function () {
      return dataMap.innerDisabled;
    });
    var scrollParams = Object(composition_api_["reactive"])({
      // el: '.option',
      element: null,
      handleScroll: null,
      limit: 20,
      end: 20
    });
    var showData = Object(composition_api_["computed"])(function () {
      var end = scrollParams.end;
      var result = [];
      var modeData; // i 记录整体个数  y 记录外部个数

      for (var i = 0, y = 0; y < viewData.value.length; y++) {
        modeData = viewData.value[y].children;

        if (i + modeData.length <= scrollParams.end) {
          result.push(viewData.value[y]);
          i += modeData.length;
        } else {
          result.push(ViewWrappervue_type_script_lang_js_objectSpread({}, viewData.value[y], {
            children: modeData.slice(0, end - i)
          }));
          return result;
        }
      }

      return result;
    });

    var handleScroll = function handleScroll(el, position) {
      scrollParams.element = el;
      var limmitDistance = 50; // 设置距离边缘的距离

      var scrollTo = el.scrollTop - position < 0 ? 'up' : 'down';

      if (scrollTo === 'down') {
        if (el.scrollTop + el.clientHeight + limmitDistance >= el.scrollHeight) {
          scrollParams.end += scrollParams.limit;
        }
      }
    };

    var handleClose = function handleClose(item) {
      handleCheck(false, item, false);
      emitChange();
      emitCheck(false, Object(tools_["cloneDeep"])(item));
    };

    scrollParams.handleScroll = handleScroll;
    return {
      scrollParams: scrollParams,
      showData: showData,
      viewData: viewData,
      disabled: disabled,
      handleScroll: handleScroll,
      handleClose: handleClose
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/components/ViewWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ViewWrappervue_type_script_lang_js_ = (ViewWrappervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/components/ViewWrapper.vue





/* normalize component */

var ViewWrapper_component = Object(componentNormalizer["a" /* default */])(
  components_ViewWrappervue_type_script_lang_js_,
  ViewWrappervue_type_template_id_580e5470_render,
  ViewWrappervue_type_template_id_580e5470_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ViewWrapper = (ViewWrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-level-select/mc-level-select.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var mc_level_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McLevelSelect',
  components: {
    SelectedView: main,
    SelectWrapper: SelectWrapper,
    ViewWrapper: ViewWrapper
  },
  props: {
    value: {
      type: [String, Number, Array],
      required: true,
      default: ''
    },
    data: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    popperClass: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showCount: {
      type: Boolean,
      default: true
    },
    maxSelectedCount: {
      type: Number,
      default: Infinity
    },
    showSelectTabAll: {
      type: Boolean,
      default: true
    },
    showSelectAll: {
      type: Boolean,
      default: true
    },
    showTags: {
      type: [Boolean, Number],
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    filterPlaceholder: {
      type: String,
      default: '请搜索'
    },
    tabConfig: {
      type: [Array, Boolean],
      default: function _default() {
        return [];
      }
    },
    filterInAll: {
      type: Boolean,
      default: true
    },
    maxFilterLength: {
      type: Number,
      default: 100
    },
    closePopperAfterSelected: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/require-default-prop
    renderNode: {
      type: Function
    },
    // eslint-disable-next-line vue/require-default-prop
    renderViewNode: {
      type: Function
    },
    showPath: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxLevel: {
      type: Number,
      default: Infinity
    },
    emptyText: {
      type: String,
      default: ''
    },
    allValue: {
      type: [String, Number, Object],
      default: ''
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var _useVisible = composable_useVisible(props, proxy),
        visible = _useVisible.visible,
        innerDisabled = _useVisible.innerDisabled,
        container = _useVisible.container,
        popover = _useVisible.popover,
        showSelect = _useVisible.showSelect,
        canShowSelect = _useVisible.canShowSelect,
        popperListeners = _useVisible.popperListeners,
        handleClosePopover = _useVisible.handleClosePopover,
        handleOpenPopover = _useVisible.handleOpenPopover,
        switchShowSelect = _useVisible.switchShowSelect;

    var _useSelect = composable_useSelect(props, handleClosePopover, ctx),
        selectedValue = _useSelect.selectedValue,
        selectedValueMap = _useSelect.selectedValueMap,
        optData = _useSelect.optData,
        tabsData = _useSelect.tabsData,
        filterOptionsData = _useSelect.filterOptionsData,
        storeValue = _useSelect.storeValue,
        handleClickClear = _useSelect.handleClickClear,
        handleSelectAll = _useSelect.handleSelectAll,
        handleCheck = _useSelect.handleCheck,
        handleSelected = _useSelect.handleSelected,
        emitChange = _useSelect.emitChange,
        emitCheck = _useSelect.emitCheck,
        emitTabChange = _useSelect.emitTabChange,
        getSelectedValue = _useSelect.getSelectedValue,
        getEmitValue = _useSelect.getEmitValue,
        setSelectedValueMap = _useSelect.setSelectedValueMap,
        setSelectedValue = _useSelect.setSelectedValue,
        setSelectedCount = _useSelect.setSelectedCount,
        getPathLabel = _useSelect.getPathLabel,
        getSelectedPathTag = _useSelect.getSelectedPathTag,
        setValue = _useSelect.setValue,
        getViewData = _useSelect.getViewData;

    var _useInit = composable_useInit(props, {
      optData: optData,
      tabsData: tabsData,
      filterOptionsData: filterOptionsData,
      selectedValue: selectedValue,
      selectedValueMap: selectedValueMap,
      getEmitValue: getEmitValue,
      setSelectedCount: setSelectedCount,
      setSelectedValueMap: setSelectedValueMap,
      setValue: setValue
    }, ctx),
        activeTab = _useInit.activeTab,
        levelLength = _useInit.levelLength,
        optionsData = _useInit.optionsData,
        activeOptions = _useInit.activeOptions,
        setActiveTab = _useInit.setActiveTab,
        inputTabsData = _useInit.inputTabsData,
        setTabsData = _useInit.setTabsData,
        handleFilter = _useInit.handleFilter,
        handleChangeActiveOpt = _useInit.handleChangeActiveOpt,
        initCount = _useInit.initCount,
        initOptionsData = _useInit.initOptionsData,
        init = _useInit.init;

    Object(composition_api_["watch"])(function () {
      return props.data;
    }, function (val) {
      init(val);
    }, {
      deep: true
    }); // 针对前端主动给value赋值的情况 更新选项状态

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      var value = props.multiple ? val : [val];

      if (!Object(tools_["isEqual"])(value, storeValue.value)) {
        // 先将数据清空
        storeValue.value = Object(tools_["cloneDeep"])(val); // 重新设置数据并计算选中数量

        setValue();
        initCount(); // 设置选项个数和选中个数
      }
    });
    Object(composition_api_["provide"])('dataMap', proxy);
    return {
      visible: visible,
      innerDisabled: innerDisabled,
      selectedValue: selectedValue,
      selectedValueMap: selectedValueMap,
      optData: optData,
      storeValue: storeValue,
      container: container,
      popover: popover,
      showSelect: showSelect,
      canShowSelect: canShowSelect,
      popperListeners: popperListeners,
      activeTab: activeTab,
      tabsData: tabsData,
      levelLength: levelLength,
      optionsData: optionsData,
      activeOptions: activeOptions,
      filterOptionsData: filterOptionsData,
      init: init,
      handleClosePopover: handleClosePopover,
      handleOpenPopover: handleOpenPopover,
      switchShowSelect: switchShowSelect,
      handleClickClear: handleClickClear,
      handleSelectAll: handleSelectAll,
      handleCheck: handleCheck,
      handleSelected: handleSelected,
      emitChange: emitChange,
      emitTabChange: emitTabChange,
      emitCheck: emitCheck,
      setSelectedValueMap: setSelectedValueMap,
      setSelectedValue: setSelectedValue,
      setSelectedCount: setSelectedCount,
      getSelectedValue: getSelectedValue,
      getEmitValue: getEmitValue,
      getViewData: getViewData,
      setActiveTab: setActiveTab,
      setTabsData: setTabsData,
      getPathLabel: getPathLabel,
      getSelectedPathTag: getSelectedPathTag,
      handleChangeActiveOpt: handleChangeActiveOpt,
      inputTabsData: inputTabsData,
      initOptionsData: initOptionsData,
      initCount: initCount,
      handleFilter: handleFilter
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-level-select/mc-level-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_level_select_mc_level_selectvue_type_script_lang_js_ = (mc_level_selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-level-select/mc-level-select.vue





/* normalize component */

var mc_level_select_component = Object(componentNormalizer["a" /* default */])(
  mc_level_select_mc_level_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_level_select = (mc_level_select_component.exports);
// CONCATENATED MODULE: ./components/mc-level-select/index.js


/* istanbul ignore next */

mc_level_select.install = function (Vue) {
  Vue.component(mc_level_select.name, mc_level_select);
};

/* harmony default export */ var components_mc_level_select = __webpack_exports__["default"] = (mc_level_select);

/***/ }),

/***/ "54d8":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("2d9b"),
    root = __webpack_require__("6884");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "54f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-aside/mc-aside.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_asidevue_type_script_lang_js_ = ({
  name: 'McAside',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-aside', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-aside/mc-aside.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_aside_mc_asidevue_type_script_lang_js_ = (mc_asidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-aside/mc-aside.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_aside_mc_asidevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_aside = (component.exports);
// CONCATENATED MODULE: ./components/mc-aside/index.js


/* istanbul ignore next */

mc_aside.install = function (Vue) {
  Vue.component(mc_aside.name, mc_aside);
};

/* harmony default export */ var components_mc_aside = __webpack_exports__["default"] = (mc_aside);

/***/ }),

/***/ "551c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var global = __webpack_require__("7726");
var ctx = __webpack_require__("9b43");
var classof = __webpack_require__("23c6");
var $export = __webpack_require__("5ca1");
var isObject = __webpack_require__("d3f4");
var aFunction = __webpack_require__("d8e8");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var speciesConstructor = __webpack_require__("ebd6");
var task = __webpack_require__("1991").set;
var microtask = __webpack_require__("8079")();
var newPromiseCapabilityModule = __webpack_require__("a5b8");
var perform = __webpack_require__("9c80");
var userAgent = __webpack_require__("a25f");
var promiseResolve = __webpack_require__("bcaa");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("2b4c")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("dcbc")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("7f20")($Promise, PROMISE);
__webpack_require__("7a56")(PROMISE);
Wrapper = __webpack_require__("8378")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("5cc5")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5559":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("dbdb")('keys');
var uid = __webpack_require__("62a0");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "55b7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-title/mc-title.vue?vue&type=script&lang=js&



/* harmony default export */ var mc_titlevue_type_script_lang_js_ = ({
  name: 'McTitle',
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    level: {
      type: [String, Number],
      default: 1,
      validator: function validator(value) {
        return [1, 2, 3].includes(+value);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var title = this.title,
        level = this.level,
        $slots = this.$slots;
    return h("div", {
      "class": "mc-title-wrapper"
    }, [h("div", {
      "class": ['mc-title', "mc-title-level-".concat(level)]
    }, [$slots.title ? $slots.title : title]), h("div", [$slots.operation ? $slots.operation : $slots.default])]);
  }
});
// CONCATENATED MODULE: ./components/mc-title/mc-title.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_title_mc_titlevue_type_script_lang_js_ = (mc_titlevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-title/mc-title.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_title_mc_titlevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_title = (component.exports);
// CONCATENATED MODULE: ./components/mc-title/index.js


/* istanbul ignore next */

mc_title.install = function (Vue) {
  Vue.component(mc_title.name, mc_title);
};

/* harmony default export */ var components_mc_title = __webpack_exports__["default"] = (mc_title);

/***/ }),

/***/ "55c9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ "55dd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("5ca1");
var aFunction = __webpack_require__("d8e8");
var toObject = __webpack_require__("4bf8");
var fails = __webpack_require__("79e5");
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__("2f21")($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ "55f7":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "561d":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__("399f");
var MillerRabin = __webpack_require__("7a10");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__("58a2");
var randomBytes = __webpack_require__("11dc");
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "5634":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-time-picker/mc-time-picker.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_time_pickervue_type_script_lang_js_ = ({
  name: 'McTimePicker',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-time-picker相关组件已经弃用，请使用mc-date-time-picker组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/I4FgWtIHMxF_CkM41RqdE', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-time-picker', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-time-picker/mc-time-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_time_picker_mc_time_pickervue_type_script_lang_js_ = (mc_time_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-time-picker/mc-time-picker.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_time_picker_mc_time_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_time_picker = (component.exports);
// CONCATENATED MODULE: ./components/mc-time-picker/index.js


/* istanbul ignore next */

mc_time_picker.install = function (Vue) {
  Vue.component(mc_time_picker.name, mc_time_picker);
};

/* harmony default export */ var components_mc_time_picker = __webpack_exports__["default"] = (mc_time_picker);

/***/ }),

/***/ "56b3":
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
}(this, (function () { 'use strict';

  // Kludges for bugs and behavior differences that can't be feature
  // detected are enabled based on userAgent etc sniffing.
  var userAgent = navigator.userAgent;
  var platform = navigator.platform;

  var gecko = /gecko\/\d/i.test(userAgent);
  var ie_upto10 = /MSIE \d/.test(userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
  var edge = /Edge\/(\d+)/.exec(userAgent);
  var ie = ie_upto10 || ie_11up || edge;
  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
  var webkit = !edge && /WebKit\//.test(userAgent);
  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
  var chrome = !edge && /Chrome\//.test(userAgent);
  var presto = /Opera\//.test(userAgent);
  var safari = /Apple Computer/.test(navigator.vendor);
  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
  var phantom = /PhantomJS/.test(userAgent);

  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
  var android = /Android/.test(userAgent);
  // This is woefully incomplete. Suggestions for alternative methods welcome.
  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
  var mac = ios || /Mac/.test(platform);
  var chromeOS = /\bCrOS\b/.test(userAgent);
  var windows = /win/i.test(platform);

  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
  if (presto_version) { presto_version = Number(presto_version[1]); }
  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
  var captureRightClick = gecko || (ie && ie_version >= 9);

  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

  var rmClass = function(node, cls) {
    var current = node.className;
    var match = classTest(cls).exec(current);
    if (match) {
      var after = current.slice(match.index + match[0].length);
      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
    }
  };

  function removeChildren(e) {
    for (var count = e.childNodes.length; count > 0; --count)
      { e.removeChild(e.firstChild); }
    return e
  }

  function removeChildrenAndAdd(parent, e) {
    return removeChildren(parent).appendChild(e)
  }

  function elt(tag, content, className, style) {
    var e = document.createElement(tag);
    if (className) { e.className = className; }
    if (style) { e.style.cssText = style; }
    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
    return e
  }
  // wrapper for elt, which removes the elt from the accessibility tree
  function eltP(tag, content, className, style) {
    var e = elt(tag, content, className, style);
    e.setAttribute("role", "presentation");
    return e
  }

  var range;
  if (document.createRange) { range = function(node, start, end, endNode) {
    var r = document.createRange();
    r.setEnd(endNode || node, end);
    r.setStart(node, start);
    return r
  }; }
  else { range = function(node, start, end) {
    var r = document.body.createTextRange();
    try { r.moveToElementText(node.parentNode); }
    catch(e) { return r }
    r.collapse(true);
    r.moveEnd("character", end);
    r.moveStart("character", start);
    return r
  }; }

  function contains(parent, child) {
    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
      { child = child.parentNode; }
    if (parent.contains)
      { return parent.contains(child) }
    do {
      if (child.nodeType == 11) { child = child.host; }
      if (child == parent) { return true }
    } while (child = child.parentNode)
  }

  function activeElt() {
    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
    // IE < 10 will throw when accessed while the page is loading or in an iframe.
    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
    var activeElement;
    try {
      activeElement = document.activeElement;
    } catch(e) {
      activeElement = document.body || null;
    }
    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
      { activeElement = activeElement.shadowRoot.activeElement; }
    return activeElement
  }

  function addClass(node, cls) {
    var current = node.className;
    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
  }
  function joinClasses(a, b) {
    var as = a.split(" ");
    for (var i = 0; i < as.length; i++)
      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
    return b
  }

  var selectInput = function(node) { node.select(); };
  if (ios) // Mobile Safari apparently has a bug where select() is broken.
    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
  else if (ie) // Suppress mysterious IE10 errors
    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

  function bind(f) {
    var args = Array.prototype.slice.call(arguments, 1);
    return function(){return f.apply(null, args)}
  }

  function copyObj(obj, target, overwrite) {
    if (!target) { target = {}; }
    for (var prop in obj)
      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
        { target[prop] = obj[prop]; } }
    return target
  }

  // Counts the column offset in a string, taking tabs into account.
  // Used mostly to find indentation.
  function countColumn(string, end, tabSize, startIndex, startValue) {
    if (end == null) {
      end = string.search(/[^\s\u00a0]/);
      if (end == -1) { end = string.length; }
    }
    for (var i = startIndex || 0, n = startValue || 0;;) {
      var nextTab = string.indexOf("\t", i);
      if (nextTab < 0 || nextTab >= end)
        { return n + (end - i) }
      n += nextTab - i;
      n += tabSize - (n % tabSize);
      i = nextTab + 1;
    }
  }

  var Delayed = function() {
    this.id = null;
    this.f = null;
    this.time = 0;
    this.handler = bind(this.onTimeout, this);
  };
  Delayed.prototype.onTimeout = function (self) {
    self.id = 0;
    if (self.time <= +new Date) {
      self.f();
    } else {
      setTimeout(self.handler, self.time - +new Date);
    }
  };
  Delayed.prototype.set = function (ms, f) {
    this.f = f;
    var time = +new Date + ms;
    if (!this.id || time < this.time) {
      clearTimeout(this.id);
      this.id = setTimeout(this.handler, ms);
      this.time = time;
    }
  };

  function indexOf(array, elt) {
    for (var i = 0; i < array.length; ++i)
      { if (array[i] == elt) { return i } }
    return -1
  }

  // Number of pixels added to scroller and sizer to hide scrollbar
  var scrollerGap = 50;

  // Returned or thrown by various protocols to signal 'I'm not
  // handling this'.
  var Pass = {toString: function(){return "CodeMirror.Pass"}};

  // Reused option objects for setSelection & friends
  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};

  // The inverse of countColumn -- find the offset that corresponds to
  // a particular column.
  function findColumn(string, goal, tabSize) {
    for (var pos = 0, col = 0;;) {
      var nextTab = string.indexOf("\t", pos);
      if (nextTab == -1) { nextTab = string.length; }
      var skipped = nextTab - pos;
      if (nextTab == string.length || col + skipped >= goal)
        { return pos + Math.min(skipped, goal - col) }
      col += nextTab - pos;
      col += tabSize - (col % tabSize);
      pos = nextTab + 1;
      if (col >= goal) { return pos }
    }
  }

  var spaceStrs = [""];
  function spaceStr(n) {
    while (spaceStrs.length <= n)
      { spaceStrs.push(lst(spaceStrs) + " "); }
    return spaceStrs[n]
  }

  function lst(arr) { return arr[arr.length-1] }

  function map(array, f) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
    return out
  }

  function insertSorted(array, value, score) {
    var pos = 0, priority = score(value);
    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
    array.splice(pos, 0, value);
  }

  function nothing() {}

  function createObj(base, props) {
    var inst;
    if (Object.create) {
      inst = Object.create(base);
    } else {
      nothing.prototype = base;
      inst = new nothing();
    }
    if (props) { copyObj(props, inst); }
    return inst
  }

  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
  function isWordCharBasic(ch) {
    return /\w/.test(ch) || ch > "\x80" &&
      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
  }
  function isWordChar(ch, helper) {
    if (!helper) { return isWordCharBasic(ch) }
    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
    return helper.test(ch)
  }

  function isEmpty(obj) {
    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
    return true
  }

  // Extending unicode characters. A series of a non-extending char +
  // any number of extending chars is treated as a single unit as far
  // as editing and measuring is concerned. This is not fully correct,
  // since some scripts/fonts/browsers also treat other configurations
  // of code points as a group.
  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
  function skipExtendingChars(str, pos, dir) {
    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
    return pos
  }

  // Returns the value from the range [`from`; `to`] that satisfies
  // `pred` and is closest to `from`. Assumes that at least `to`
  // satisfies `pred`. Supports `from` being greater than `to`.
  function findFirst(pred, from, to) {
    // At any point we are certain `to` satisfies `pred`, don't know
    // whether `from` does.
    var dir = from > to ? -1 : 1;
    for (;;) {
      if (from == to) { return from }
      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
      if (mid == from) { return pred(mid) ? from : to }
      if (pred(mid)) { to = mid; }
      else { from = mid + dir; }
    }
  }

  // BIDI HELPERS

  function iterateBidiSections(order, from, to, f) {
    if (!order) { return f(from, to, "ltr", 0) }
    var found = false;
    for (var i = 0; i < order.length; ++i) {
      var part = order[i];
      if (part.from < to && part.to > from || from == to && part.to == from) {
        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
        found = true;
      }
    }
    if (!found) { f(from, to, "ltr"); }
  }

  var bidiOther = null;
  function getBidiPartAt(order, ch, sticky) {
    var found;
    bidiOther = null;
    for (var i = 0; i < order.length; ++i) {
      var cur = order[i];
      if (cur.from < ch && cur.to > ch) { return i }
      if (cur.to == ch) {
        if (cur.from != cur.to && sticky == "before") { found = i; }
        else { bidiOther = i; }
      }
      if (cur.from == ch) {
        if (cur.from != cur.to && sticky != "before") { found = i; }
        else { bidiOther = i; }
      }
    }
    return found != null ? found : bidiOther
  }

  // Bidirectional ordering algorithm
  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
  // that this (partially) implements.

  // One-char codes used for character types:
  // L (L):   Left-to-Right
  // R (R):   Right-to-Left
  // r (AL):  Right-to-Left Arabic
  // 1 (EN):  European Number
  // + (ES):  European Number Separator
  // % (ET):  European Number Terminator
  // n (AN):  Arabic Number
  // , (CS):  Common Number Separator
  // m (NSM): Non-Spacing Mark
  // b (BN):  Boundary Neutral
  // s (B):   Paragraph Separator
  // t (S):   Segment Separator
  // w (WS):  Whitespace
  // N (ON):  Other Neutrals

  // Returns null if characters are ordered as they appear
  // (left-to-right), or an array of sections ({from, to, level}
  // objects) in the order in which they occur visually.
  var bidiOrdering = (function() {
    // Character types for codepoints 0 to 0xff
    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
    // Character types for codepoints 0x600 to 0x6f9
    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
    function charType(code) {
      if (code <= 0xf7) { return lowTypes.charAt(code) }
      else if (0x590 <= code && code <= 0x5f4) { return "R" }
      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
      else if (0x2000 <= code && code <= 0x200b) { return "w" }
      else if (code == 0x200c) { return "b" }
      else { return "L" }
    }

    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

    function BidiSpan(level, from, to) {
      this.level = level;
      this.from = from; this.to = to;
    }

    return function(str, direction) {
      var outerType = direction == "ltr" ? "L" : "R";

      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
      var len = str.length, types = [];
      for (var i = 0; i < len; ++i)
        { types.push(charType(str.charCodeAt(i))); }

      // W1. Examine each non-spacing mark (NSM) in the level run, and
      // change the type of the NSM to the type of the previous
      // character. If the NSM is at the start of the level run, it will
      // get the type of sor.
      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
        var type = types[i$1];
        if (type == "m") { types[i$1] = prev; }
        else { prev = type; }
      }

      // W2. Search backwards from each instance of a European number
      // until the first strong type (R, L, AL, or sor) is found. If an
      // AL is found, change the type of the European number to Arabic
      // number.
      // W3. Change all ALs to R.
      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
        var type$1 = types[i$2];
        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
      }

      // W4. A single European separator between two European numbers
      // changes to a European number. A single common separator between
      // two numbers of the same type changes to that type.
      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
        var type$2 = types[i$3];
        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
        else if (type$2 == "," && prev$1 == types[i$3+1] &&
                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
        prev$1 = type$2;
      }

      // W5. A sequence of European terminators adjacent to European
      // numbers changes to all European numbers.
      // W6. Otherwise, separators and terminators change to Other
      // Neutral.
      for (var i$4 = 0; i$4 < len; ++i$4) {
        var type$3 = types[i$4];
        if (type$3 == ",") { types[i$4] = "N"; }
        else if (type$3 == "%") {
          var end = (void 0);
          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
          for (var j = i$4; j < end; ++j) { types[j] = replace; }
          i$4 = end - 1;
        }
      }

      // W7. Search backwards from each instance of a European number
      // until the first strong type (R, L, or sor) is found. If an L is
      // found, then change the type of the European number to L.
      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
        var type$4 = types[i$5];
        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
        else if (isStrong.test(type$4)) { cur$1 = type$4; }
      }

      // N1. A sequence of neutrals takes the direction of the
      // surrounding strong text if the text on both sides has the same
      // direction. European and Arabic numbers act as if they were R in
      // terms of their influence on neutrals. Start-of-level-run (sor)
      // and end-of-level-run (eor) are used at level run boundaries.
      // N2. Any remaining neutrals take the embedding direction.
      for (var i$6 = 0; i$6 < len; ++i$6) {
        if (isNeutral.test(types[i$6])) {
          var end$1 = (void 0);
          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
          var before = (i$6 ? types[i$6-1] : outerType) == "L";
          var after = (end$1 < len ? types[end$1] : outerType) == "L";
          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
          i$6 = end$1 - 1;
        }
      }

      // Here we depart from the documented algorithm, in order to avoid
      // building up an actual levels array. Since there are only three
      // levels (0, 1, 2) in an implementation that doesn't take
      // explicit embedding into account, we can build up the order on
      // the fly, without following the level-based algorithm.
      var order = [], m;
      for (var i$7 = 0; i$7 < len;) {
        if (countsAsLeft.test(types[i$7])) {
          var start = i$7;
          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
          order.push(new BidiSpan(0, start, i$7));
        } else {
          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
          for (var j$2 = pos; j$2 < i$7;) {
            if (countsAsNum.test(types[j$2])) {
              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
              var nstart = j$2;
              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
              at += isRTL;
              pos = j$2;
            } else { ++j$2; }
          }
          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
        }
      }
      if (direction == "ltr") {
        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
          order[0].from = m[0].length;
          order.unshift(new BidiSpan(0, 0, m[0].length));
        }
        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
          lst(order).to -= m[0].length;
          order.push(new BidiSpan(0, len - m[0].length, len));
        }
      }

      return direction == "rtl" ? order.reverse() : order
    }
  })();

  // Get the bidi ordering for the given line (and cache it). Returns
  // false for lines that are fully left-to-right, and an array of
  // BidiSpan objects otherwise.
  function getOrder(line, direction) {
    var order = line.order;
    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
    return order
  }

  // EVENT HANDLING

  // Lightweight event framework. on/off also work on DOM nodes,
  // registering native DOM handlers.

  var noHandlers = [];

  var on = function(emitter, type, f) {
    if (emitter.addEventListener) {
      emitter.addEventListener(type, f, false);
    } else if (emitter.attachEvent) {
      emitter.attachEvent("on" + type, f);
    } else {
      var map = emitter._handlers || (emitter._handlers = {});
      map[type] = (map[type] || noHandlers).concat(f);
    }
  };

  function getHandlers(emitter, type) {
    return emitter._handlers && emitter._handlers[type] || noHandlers
  }

  function off(emitter, type, f) {
    if (emitter.removeEventListener) {
      emitter.removeEventListener(type, f, false);
    } else if (emitter.detachEvent) {
      emitter.detachEvent("on" + type, f);
    } else {
      var map = emitter._handlers, arr = map && map[type];
      if (arr) {
        var index = indexOf(arr, f);
        if (index > -1)
          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
      }
    }
  }

  function signal(emitter, type /*, values...*/) {
    var handlers = getHandlers(emitter, type);
    if (!handlers.length) { return }
    var args = Array.prototype.slice.call(arguments, 2);
    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
  }

  // The DOM events that CodeMirror handles can be overridden by
  // registering a (non-DOM) handler on the editor for the event name,
  // and preventDefault-ing the event in that handler.
  function signalDOMEvent(cm, e, override) {
    if (typeof e == "string")
      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
    signal(cm, override || e.type, cm, e);
    return e_defaultPrevented(e) || e.codemirrorIgnore
  }

  function signalCursorActivity(cm) {
    var arr = cm._handlers && cm._handlers.cursorActivity;
    if (!arr) { return }
    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
      { set.push(arr[i]); } }
  }

  function hasHandler(emitter, type) {
    return getHandlers(emitter, type).length > 0
  }

  // Add on and off methods to a constructor's prototype, to make
  // registering events on such objects more convenient.
  function eventMixin(ctor) {
    ctor.prototype.on = function(type, f) {on(this, type, f);};
    ctor.prototype.off = function(type, f) {off(this, type, f);};
  }

  // Due to the fact that we still support jurassic IE versions, some
  // compatibility wrappers are needed.

  function e_preventDefault(e) {
    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
  }
  function e_stopPropagation(e) {
    if (e.stopPropagation) { e.stopPropagation(); }
    else { e.cancelBubble = true; }
  }
  function e_defaultPrevented(e) {
    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
  }
  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

  function e_target(e) {return e.target || e.srcElement}
  function e_button(e) {
    var b = e.which;
    if (b == null) {
      if (e.button & 1) { b = 1; }
      else if (e.button & 2) { b = 3; }
      else if (e.button & 4) { b = 2; }
    }
    if (mac && e.ctrlKey && b == 1) { b = 3; }
    return b
  }

  // Detect drag-and-drop
  var dragAndDrop = function() {
    // There is *some* kind of drag-and-drop support in IE6-8, but I
    // couldn't get it to work yet.
    if (ie && ie_version < 9) { return false }
    var div = elt('div');
    return "draggable" in div || "dragDrop" in div
  }();

  var zwspSupported;
  function zeroWidthElement(measure) {
    if (zwspSupported == null) {
      var test = elt("span", "\u200b");
      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
      if (measure.firstChild.offsetHeight != 0)
        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
    }
    var node = zwspSupported ? elt("span", "\u200b") :
      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
    node.setAttribute("cm-text", "");
    return node
  }

  // Feature-detect IE's crummy client rect reporting for bidi text
  var badBidiRects;
  function hasBadBidiRects(measure) {
    if (badBidiRects != null) { return badBidiRects }
    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
    var r0 = range(txt, 0, 1).getBoundingClientRect();
    var r1 = range(txt, 1, 2).getBoundingClientRect();
    removeChildren(measure);
    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
    return badBidiRects = (r1.right - r0.right < 3)
  }

  // See if "".split is the broken IE version, if so, provide an
  // alternative way to split lines.
  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
    var pos = 0, result = [], l = string.length;
    while (pos <= l) {
      var nl = string.indexOf("\n", pos);
      if (nl == -1) { nl = string.length; }
      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
      var rt = line.indexOf("\r");
      if (rt != -1) {
        result.push(line.slice(0, rt));
        pos += rt + 1;
      } else {
        result.push(line);
        pos = nl + 1;
      }
    }
    return result
  } : function (string) { return string.split(/\r\n?|\n/); };

  var hasSelection = window.getSelection ? function (te) {
    try { return te.selectionStart != te.selectionEnd }
    catch(e) { return false }
  } : function (te) {
    var range;
    try {range = te.ownerDocument.selection.createRange();}
    catch(e) {}
    if (!range || range.parentElement() != te) { return false }
    return range.compareEndPoints("StartToEnd", range) != 0
  };

  var hasCopyEvent = (function () {
    var e = elt("div");
    if ("oncopy" in e) { return true }
    e.setAttribute("oncopy", "return;");
    return typeof e.oncopy == "function"
  })();

  var badZoomedRects = null;
  function hasBadZoomedRects(measure) {
    if (badZoomedRects != null) { return badZoomedRects }
    var node = removeChildrenAndAdd(measure, elt("span", "x"));
    var normal = node.getBoundingClientRect();
    var fromRange = range(node, 0, 1).getBoundingClientRect();
    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
  }

  // Known modes, by name and by MIME
  var modes = {}, mimeModes = {};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  function defineMode(name, mode) {
    if (arguments.length > 2)
      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
    modes[name] = mode;
  }

  function defineMIME(mime, spec) {
    mimeModes[mime] = spec;
  }

  // Given a MIME type, a {name, ...options} config object, or a name
  // string, return a mode config object.
  function resolveMode(spec) {
    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
      spec = mimeModes[spec];
    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
      var found = mimeModes[spec.name];
      if (typeof found == "string") { found = {name: found}; }
      spec = createObj(found, spec);
      spec.name = found.name;
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
      return resolveMode("application/xml")
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
      return resolveMode("application/json")
    }
    if (typeof spec == "string") { return {name: spec} }
    else { return spec || {name: "null"} }
  }

  // Given a mode spec (anything that resolveMode accepts), find and
  // initialize an actual mode object.
  function getMode(options, spec) {
    spec = resolveMode(spec);
    var mfactory = modes[spec.name];
    if (!mfactory) { return getMode(options, "text/plain") }
    var modeObj = mfactory(options, spec);
    if (modeExtensions.hasOwnProperty(spec.name)) {
      var exts = modeExtensions[spec.name];
      for (var prop in exts) {
        if (!exts.hasOwnProperty(prop)) { continue }
        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
        modeObj[prop] = exts[prop];
      }
    }
    modeObj.name = spec.name;
    if (spec.helperType) { modeObj.helperType = spec.helperType; }
    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
      { modeObj[prop$1] = spec.modeProps[prop$1]; } }

    return modeObj
  }

  // This can be used to attach properties to mode objects from
  // outside the actual mode definition.
  var modeExtensions = {};
  function extendMode(mode, properties) {
    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
    copyObj(properties, exts);
  }

  function copyState(mode, state) {
    if (state === true) { return state }
    if (mode.copyState) { return mode.copyState(state) }
    var nstate = {};
    for (var n in state) {
      var val = state[n];
      if (val instanceof Array) { val = val.concat([]); }
      nstate[n] = val;
    }
    return nstate
  }

  // Given a mode and a state (for that mode), find the inner mode and
  // state at the position that the state refers to.
  function innerMode(mode, state) {
    var info;
    while (mode.innerMode) {
      info = mode.innerMode(state);
      if (!info || info.mode == mode) { break }
      state = info.state;
      mode = info.mode;
    }
    return info || {mode: mode, state: state}
  }

  function startState(mode, a1, a2) {
    return mode.startState ? mode.startState(a1, a2) : true
  }

  // STRING STREAM

  // Fed to the mode parsers, provides helper functions to make
  // parsers more succinct.

  var StringStream = function(string, tabSize, lineOracle) {
    this.pos = this.start = 0;
    this.string = string;
    this.tabSize = tabSize || 8;
    this.lastColumnPos = this.lastColumnValue = 0;
    this.lineStart = 0;
    this.lineOracle = lineOracle;
  };

  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
  StringStream.prototype.next = function () {
    if (this.pos < this.string.length)
      { return this.string.charAt(this.pos++) }
  };
  StringStream.prototype.eat = function (match) {
    var ch = this.string.charAt(this.pos);
    var ok;
    if (typeof match == "string") { ok = ch == match; }
    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
    if (ok) {++this.pos; return ch}
  };
  StringStream.prototype.eatWhile = function (match) {
    var start = this.pos;
    while (this.eat(match)){}
    return this.pos > start
  };
  StringStream.prototype.eatSpace = function () {
    var start = this.pos;
    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
    return this.pos > start
  };
  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
  StringStream.prototype.skipTo = function (ch) {
    var found = this.string.indexOf(ch, this.pos);
    if (found > -1) {this.pos = found; return true}
  };
  StringStream.prototype.backUp = function (n) {this.pos -= n;};
  StringStream.prototype.column = function () {
    if (this.lastColumnPos < this.start) {
      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
      this.lastColumnPos = this.start;
    }
    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.indentation = function () {
    return countColumn(this.string, null, this.tabSize) -
      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
    if (typeof pattern == "string") {
      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
      var substr = this.string.substr(this.pos, pattern.length);
      if (cased(substr) == cased(pattern)) {
        if (consume !== false) { this.pos += pattern.length; }
        return true
      }
    } else {
      var match = this.string.slice(this.pos).match(pattern);
      if (match && match.index > 0) { return null }
      if (match && consume !== false) { this.pos += match[0].length; }
      return match
    }
  };
  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
  StringStream.prototype.hideFirstChars = function (n, inner) {
    this.lineStart += n;
    try { return inner() }
    finally { this.lineStart -= n; }
  };
  StringStream.prototype.lookAhead = function (n) {
    var oracle = this.lineOracle;
    return oracle && oracle.lookAhead(n)
  };
  StringStream.prototype.baseToken = function () {
    var oracle = this.lineOracle;
    return oracle && oracle.baseToken(this.pos)
  };

  // Find the line object corresponding to the given line number.
  function getLine(doc, n) {
    n -= doc.first;
    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
    var chunk = doc;
    while (!chunk.lines) {
      for (var i = 0;; ++i) {
        var child = chunk.children[i], sz = child.chunkSize();
        if (n < sz) { chunk = child; break }
        n -= sz;
      }
    }
    return chunk.lines[n]
  }

  // Get the part of a document between two positions, as an array of
  // strings.
  function getBetween(doc, start, end) {
    var out = [], n = start.line;
    doc.iter(start.line, end.line + 1, function (line) {
      var text = line.text;
      if (n == end.line) { text = text.slice(0, end.ch); }
      if (n == start.line) { text = text.slice(start.ch); }
      out.push(text);
      ++n;
    });
    return out
  }
  // Get the lines between from and to, as array of strings.
  function getLines(doc, from, to) {
    var out = [];
    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
    return out
  }

  // Update the height of a line, propagating the height change
  // upwards to parent nodes.
  function updateLineHeight(line, height) {
    var diff = height - line.height;
    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
  }

  // Given a line object, find its line number by walking up through
  // its parent links.
  function lineNo(line) {
    if (line.parent == null) { return null }
    var cur = line.parent, no = indexOf(cur.lines, line);
    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
      for (var i = 0;; ++i) {
        if (chunk.children[i] == cur) { break }
        no += chunk.children[i].chunkSize();
      }
    }
    return no + cur.first
  }

  // Find the line at the given vertical position, using the height
  // information in the document tree.
  function lineAtHeight(chunk, h) {
    var n = chunk.first;
    outer: do {
      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
        var child = chunk.children[i$1], ch = child.height;
        if (h < ch) { chunk = child; continue outer }
        h -= ch;
        n += child.chunkSize();
      }
      return n
    } while (!chunk.lines)
    var i = 0;
    for (; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i], lh = line.height;
      if (h < lh) { break }
      h -= lh;
    }
    return n + i
  }

  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

  function lineNumberFor(options, i) {
    return String(options.lineNumberFormatter(i + options.firstLineNumber))
  }

  // A Pos instance represents a position within the text.
  function Pos(line, ch, sticky) {
    if ( sticky === void 0 ) sticky = null;

    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
    this.line = line;
    this.ch = ch;
    this.sticky = sticky;
  }

  // Compare two positions, return 0 if they are the same, a negative
  // number when a is less, and a positive number otherwise.
  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

  function copyPos(x) {return Pos(x.line, x.ch)}
  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

  // Most of the external API clips given positions to make sure they
  // actually exist within the document.
  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
  function clipPos(doc, pos) {
    if (pos.line < doc.first) { return Pos(doc.first, 0) }
    var last = doc.first + doc.size - 1;
    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
    return clipToLen(pos, getLine(doc, pos.line).text.length)
  }
  function clipToLen(pos, linelen) {
    var ch = pos.ch;
    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
    else if (ch < 0) { return Pos(pos.line, 0) }
    else { return pos }
  }
  function clipPosArray(doc, array) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
    return out
  }

  var SavedContext = function(state, lookAhead) {
    this.state = state;
    this.lookAhead = lookAhead;
  };

  var Context = function(doc, state, line, lookAhead) {
    this.state = state;
    this.doc = doc;
    this.line = line;
    this.maxLookAhead = lookAhead || 0;
    this.baseTokens = null;
    this.baseTokenPos = 1;
  };

  Context.prototype.lookAhead = function (n) {
    var line = this.doc.getLine(this.line + n);
    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
    return line
  };

  Context.prototype.baseToken = function (n) {
    if (!this.baseTokens) { return null }
    while (this.baseTokens[this.baseTokenPos] <= n)
      { this.baseTokenPos += 2; }
    var type = this.baseTokens[this.baseTokenPos + 1];
    return {type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n}
  };

  Context.prototype.nextLine = function () {
    this.line++;
    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
  };

  Context.fromSaved = function (doc, saved, line) {
    if (saved instanceof SavedContext)
      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
    else
      { return new Context(doc, copyState(doc.mode, saved), line) }
  };

  Context.prototype.save = function (copy) {
    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
  };


  // Compute a style array (an array starting with a mode generation
  // -- for invalidation -- followed by pairs of end positions and
  // style strings), which is used to highlight the tokens on the
  // line.
  function highlightLine(cm, line, context, forceToEnd) {
    // A styles array always starts with a number identifying the
    // mode/overlays that it is based on (for easy invalidation).
    var st = [cm.state.modeGen], lineClasses = {};
    // Compute the base array of styles
    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
            lineClasses, forceToEnd);
    var state = context.state;

    // Run overlays, adjust style array.
    var loop = function ( o ) {
      context.baseTokens = st;
      var overlay = cm.state.overlays[o], i = 1, at = 0;
      context.state = true;
      runMode(cm, line.text, overlay.mode, context, function (end, style) {
        var start = i;
        // Ensure there's a token end at the current position, and that i points at it
        while (at < end) {
          var i_end = st[i];
          if (i_end > end)
            { st.splice(i, 1, end, st[i+1], i_end); }
          i += 2;
          at = Math.min(end, i_end);
        }
        if (!style) { return }
        if (overlay.opaque) {
          st.splice(start, i - start, end, "overlay " + style);
          i = start + 2;
        } else {
          for (; start < i; start += 2) {
            var cur = st[start+1];
            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
          }
        }
      }, lineClasses);
      context.state = state;
      context.baseTokens = null;
      context.baseTokenPos = 1;
    };

    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
  }

  function getLineStyles(cm, line, updateFrontier) {
    if (!line.styles || line.styles[0] != cm.state.modeGen) {
      var context = getContextBefore(cm, lineNo(line));
      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
      var result = highlightLine(cm, line, context);
      if (resetState) { context.state = resetState; }
      line.stateAfter = context.save(!resetState);
      line.styles = result.styles;
      if (result.classes) { line.styleClasses = result.classes; }
      else if (line.styleClasses) { line.styleClasses = null; }
      if (updateFrontier === cm.doc.highlightFrontier)
        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
    }
    return line.styles
  }

  function getContextBefore(cm, n, precise) {
    var doc = cm.doc, display = cm.display;
    if (!doc.mode.startState) { return new Context(doc, true, n) }
    var start = findStartLine(cm, n, precise);
    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

    doc.iter(start, n, function (line) {
      processLine(cm, line.text, context);
      var pos = context.line;
      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
      context.nextLine();
    });
    if (precise) { doc.modeFrontier = context.line; }
    return context
  }

  // Lightweight form of highlight -- proceed over this line and
  // update state, but don't save a style array. Used for lines that
  // aren't currently visible.
  function processLine(cm, text, context, startAt) {
    var mode = cm.doc.mode;
    var stream = new StringStream(text, cm.options.tabSize, context);
    stream.start = stream.pos = startAt || 0;
    if (text == "") { callBlankLine(mode, context.state); }
    while (!stream.eol()) {
      readToken(mode, stream, context.state);
      stream.start = stream.pos;
    }
  }

  function callBlankLine(mode, state) {
    if (mode.blankLine) { return mode.blankLine(state) }
    if (!mode.innerMode) { return }
    var inner = innerMode(mode, state);
    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
  }

  function readToken(mode, stream, state, inner) {
    for (var i = 0; i < 10; i++) {
      if (inner) { inner[0] = innerMode(mode, state).mode; }
      var style = mode.token(stream, state);
      if (stream.pos > stream.start) { return style }
    }
    throw new Error("Mode " + mode.name + " failed to advance stream.")
  }

  var Token = function(stream, type, state) {
    this.start = stream.start; this.end = stream.pos;
    this.string = stream.current();
    this.type = type || null;
    this.state = state;
  };

  // Utility for getTokenAt and getLineTokens
  function takeToken(cm, pos, precise, asArray) {
    var doc = cm.doc, mode = doc.mode, style;
    pos = clipPos(doc, pos);
    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
    if (asArray) { tokens = []; }
    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
      stream.start = stream.pos;
      style = readToken(mode, stream, context.state);
      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
    }
    return asArray ? tokens : new Token(stream, style, context.state)
  }

  function extractLineClasses(type, output) {
    if (type) { for (;;) {
      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
      if (!lineClass) { break }
      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
      var prop = lineClass[1] ? "bgClass" : "textClass";
      if (output[prop] == null)
        { output[prop] = lineClass[2]; }
      else if (!(new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)")).test(output[prop]))
        { output[prop] += " " + lineClass[2]; }
    } }
    return type
  }

  // Run the given mode's parser over a line, calling f for each token.
  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
    var flattenSpans = mode.flattenSpans;
    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
    var curStart = 0, curStyle = null;
    var stream = new StringStream(text, cm.options.tabSize, context), style;
    var inner = cm.options.addModeClass && [null];
    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
    while (!stream.eol()) {
      if (stream.pos > cm.options.maxHighlightLength) {
        flattenSpans = false;
        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
        stream.pos = text.length;
        style = null;
      } else {
        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
      }
      if (inner) {
        var mName = inner[0].name;
        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
      }
      if (!flattenSpans || curStyle != style) {
        while (curStart < stream.start) {
          curStart = Math.min(stream.start, curStart + 5000);
          f(curStart, curStyle);
        }
        curStyle = style;
      }
      stream.start = stream.pos;
    }
    while (curStart < stream.pos) {
      // Webkit seems to refuse to render text nodes longer than 57444
      // characters, and returns inaccurate measurements in nodes
      // starting around 5000 chars.
      var pos = Math.min(stream.pos, curStart + 5000);
      f(pos, curStyle);
      curStart = pos;
    }
  }

  // Finds the line to start with when starting a parse. Tries to
  // find a line with a stateAfter, so that it can start with a
  // valid state. If that fails, it returns the line with the
  // smallest indentation, which tends to need the least context to
  // parse correctly.
  function findStartLine(cm, n, precise) {
    var minindent, minline, doc = cm.doc;
    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
    for (var search = n; search > lim; --search) {
      if (search <= doc.first) { return doc.first }
      var line = getLine(doc, search - 1), after = line.stateAfter;
      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
        { return search }
      var indented = countColumn(line.text, null, cm.options.tabSize);
      if (minline == null || minindent > indented) {
        minline = search - 1;
        minindent = indented;
      }
    }
    return minline
  }

  function retreatFrontier(doc, n) {
    doc.modeFrontier = Math.min(doc.modeFrontier, n);
    if (doc.highlightFrontier < n - 10) { return }
    var start = doc.first;
    for (var line = n - 1; line > start; line--) {
      var saved = getLine(doc, line).stateAfter;
      // change is on 3
      // state on line 1 looked ahead 2 -- so saw 3
      // test 1 + 2 < 3 should cover this
      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
        start = line + 1;
        break
      }
    }
    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
  }

  // Optimize some code when these features are not used.
  var sawReadOnlySpans = false, sawCollapsedSpans = false;

  function seeReadOnlySpans() {
    sawReadOnlySpans = true;
  }

  function seeCollapsedSpans() {
    sawCollapsedSpans = true;
  }

  // TEXTMARKER SPANS

  function MarkedSpan(marker, from, to) {
    this.marker = marker;
    this.from = from; this.to = to;
  }

  // Search an array of spans for a span matching the given marker.
  function getMarkedSpanFor(spans, marker) {
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.marker == marker) { return span }
    } }
  }

  // Remove a span from an array, returning undefined if no spans are
  // left (we don't store arrays for lines without spans).
  function removeMarkedSpan(spans, span) {
    var r;
    for (var i = 0; i < spans.length; ++i)
      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
    return r
  }

  // Add a span to a line.
  function addMarkedSpan(line, span, op) {
    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
    if (inThisOp && inThisOp.has(line.markedSpans)) {
      line.markedSpans.push(span);
    } else {
      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
      if (inThisOp) { inThisOp.add(line.markedSpans); }
    }
    span.marker.attachLine(line);
  }

  // Used for the algorithm that adjusts markers for a change in the
  // document. These functions cut an array of spans at a given
  // character position, returning an array of remaining chunks (or
  // undefined if nothing remains).
  function markedSpansBefore(old, startCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
      }
    } }
    return nw
  }
  function markedSpansAfter(old, endCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                              span.to == null ? null : span.to - endCh));
      }
    } }
    return nw
  }

  // Given a change object, compute the new set of marker spans that
  // cover the line in which the change took place. Removes spans
  // entirely within the change, reconnects spans belonging to the
  // same marker that appear on both sides of the change, and cuts off
  // spans partially within the change. Returns an array of span
  // arrays with one element for each line in (after) the change.
  function stretchSpansOverChange(doc, change) {
    if (change.full) { return null }
    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
    if (!oldFirst && !oldLast) { return null }

    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
    // Get the spans that 'stick out' on both sides
    var first = markedSpansBefore(oldFirst, startCh, isInsert);
    var last = markedSpansAfter(oldLast, endCh, isInsert);

    // Next, merge those two ends
    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
    if (first) {
      // Fix up .to properties of first
      for (var i = 0; i < first.length; ++i) {
        var span = first[i];
        if (span.to == null) {
          var found = getMarkedSpanFor(last, span.marker);
          if (!found) { span.to = startCh; }
          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
        }
      }
    }
    if (last) {
      // Fix up .from in last (or move them into first in case of sameLine)
      for (var i$1 = 0; i$1 < last.length; ++i$1) {
        var span$1 = last[i$1];
        if (span$1.to != null) { span$1.to += offset; }
        if (span$1.from == null) {
          var found$1 = getMarkedSpanFor(first, span$1.marker);
          if (!found$1) {
            span$1.from = offset;
            if (sameLine) { (first || (first = [])).push(span$1); }
          }
        } else {
          span$1.from += offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      }
    }
    // Make sure we didn't create any zero-length spans
    if (first) { first = clearEmptySpans(first); }
    if (last && last != first) { last = clearEmptySpans(last); }

    var newMarkers = [first];
    if (!sameLine) {
      // Fill gap with whole-line-spans
      var gap = change.text.length - 2, gapMarkers;
      if (gap > 0 && first)
        { for (var i$2 = 0; i$2 < first.length; ++i$2)
          { if (first[i$2].to == null)
            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
      for (var i$3 = 0; i$3 < gap; ++i$3)
        { newMarkers.push(gapMarkers); }
      newMarkers.push(last);
    }
    return newMarkers
  }

  // Remove spans that are empty and don't have a clearWhenEmpty
  // option of false.
  function clearEmptySpans(spans) {
    for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
        { spans.splice(i--, 1); }
    }
    if (!spans.length) { return null }
    return spans
  }

  // Used to 'clip' out readOnly ranges when making a change.
  function removeReadOnlyRanges(doc, from, to) {
    var markers = null;
    doc.iter(from.line, to.line + 1, function (line) {
      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
        var mark = line.markedSpans[i].marker;
        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
          { (markers || (markers = [])).push(mark); }
      } }
    });
    if (!markers) { return null }
    var parts = [{from: from, to: to}];
    for (var i = 0; i < markers.length; ++i) {
      var mk = markers[i], m = mk.find(0);
      for (var j = 0; j < parts.length; ++j) {
        var p = parts[j];
        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
          { newParts.push({from: p.from, to: m.from}); }
        if (dto > 0 || !mk.inclusiveRight && !dto)
          { newParts.push({from: m.to, to: p.to}); }
        parts.splice.apply(parts, newParts);
        j += newParts.length - 3;
      }
    }
    return parts
  }

  // Connect or disconnect spans from a line.
  function detachMarkedSpans(line) {
    var spans = line.markedSpans;
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.detachLine(line); }
    line.markedSpans = null;
  }
  function attachMarkedSpans(line, spans) {
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.attachLine(line); }
    line.markedSpans = spans;
  }

  // Helpers used when computing which overlapping collapsed span
  // counts as the larger one.
  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

  // Returns a number indicating which of two overlapping collapsed
  // spans is larger (and thus includes the other). Falls back to
  // comparing ids when the spans cover exactly the same range.
  function compareCollapsedMarkers(a, b) {
    var lenDiff = a.lines.length - b.lines.length;
    if (lenDiff != 0) { return lenDiff }
    var aPos = a.find(), bPos = b.find();
    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
    if (fromCmp) { return -fromCmp }
    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
    if (toCmp) { return toCmp }
    return b.id - a.id
  }

  // Find out whether a line ends or starts in a collapsed span. If
  // so, return the marker for that span.
  function collapsedSpanAtSide(line, start) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
        { found = sp.marker; }
    } }
    return found
  }
  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

  function collapsedSpanAround(line, ch) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
    } }
    return found
  }

  // Test whether there exists a collapsed span that partially
  // overlaps (covers the start or end, but not both) of a new span.
  // Such overlap is not allowed.
  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
    var line = getLine(doc, lineNo);
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      var found = sp.marker.find(0);
      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
        { return true }
    } }
  }

  // A visual line is a line as drawn on the screen. Folding, for
  // example, can cause multiple logical lines to appear on the same
  // visual line. This finds the start of the visual line that the
  // given line is part of (usually that is the line itself).
  function visualLine(line) {
    var merged;
    while (merged = collapsedSpanAtStart(line))
      { line = merged.find(-1, true).line; }
    return line
  }

  function visualLineEnd(line) {
    var merged;
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return line
  }

  // Returns an array of logical lines that continue the visual line
  // started by the argument, or undefined if there are no such lines.
  function visualLineContinued(line) {
    var merged, lines;
    while (merged = collapsedSpanAtEnd(line)) {
      line = merged.find(1, true).line
      ;(lines || (lines = [])).push(line);
    }
    return lines
  }

  // Get the line number of the start of the visual line that the
  // given line number is part of.
  function visualLineNo(doc, lineN) {
    var line = getLine(doc, lineN), vis = visualLine(line);
    if (line == vis) { return lineN }
    return lineNo(vis)
  }

  // Get the line number of the start of the next visual line after
  // the given line.
  function visualLineEndNo(doc, lineN) {
    if (lineN > doc.lastLine()) { return lineN }
    var line = getLine(doc, lineN), merged;
    if (!lineIsHidden(doc, line)) { return lineN }
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return lineNo(line) + 1
  }

  // Compute whether a line is hidden. Lines count as hidden when they
  // are part of a visual line that starts with another line, or when
  // they are entirely covered by collapsed, non-widget span.
  function lineIsHidden(doc, line) {
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      if (sp.from == null) { return true }
      if (sp.marker.widgetNode) { continue }
      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
        { return true }
    } }
  }
  function lineIsHiddenInner(doc, line, span) {
    if (span.to == null) {
      var end = span.marker.find(1, true);
      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
    }
    if (span.marker.inclusiveRight && span.to == line.text.length)
      { return true }
    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
      sp = line.markedSpans[i];
      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
          (sp.to == null || sp.to != span.from) &&
          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
          lineIsHiddenInner(doc, line, sp)) { return true }
    }
  }

  // Find the height above the given line.
  function heightAtLine(lineObj) {
    lineObj = visualLine(lineObj);

    var h = 0, chunk = lineObj.parent;
    for (var i = 0; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i];
      if (line == lineObj) { break }
      else { h += line.height; }
    }
    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
        var cur = p.children[i$1];
        if (cur == chunk) { break }
        else { h += cur.height; }
      }
    }
    return h
  }

  // Compute the character length of a line, taking into account
  // collapsed ranges (see markText) that might hide parts, and join
  // other lines onto it.
  function lineLength(line) {
    if (line.height == 0) { return 0 }
    var len = line.text.length, merged, cur = line;
    while (merged = collapsedSpanAtStart(cur)) {
      var found = merged.find(0, true);
      cur = found.from.line;
      len += found.from.ch - found.to.ch;
    }
    cur = line;
    while (merged = collapsedSpanAtEnd(cur)) {
      var found$1 = merged.find(0, true);
      len -= cur.text.length - found$1.from.ch;
      cur = found$1.to.line;
      len += cur.text.length - found$1.to.ch;
    }
    return len
  }

  // Find the longest line in the document.
  function findMaxLine(cm) {
    var d = cm.display, doc = cm.doc;
    d.maxLine = getLine(doc, doc.first);
    d.maxLineLength = lineLength(d.maxLine);
    d.maxLineChanged = true;
    doc.iter(function (line) {
      var len = lineLength(line);
      if (len > d.maxLineLength) {
        d.maxLineLength = len;
        d.maxLine = line;
      }
    });
  }

  // LINE DATA STRUCTURE

  // Line objects. These hold state related to a line, including
  // highlighting info (the styles array).
  var Line = function(text, markedSpans, estimateHeight) {
    this.text = text;
    attachMarkedSpans(this, markedSpans);
    this.height = estimateHeight ? estimateHeight(this) : 1;
  };

  Line.prototype.lineNo = function () { return lineNo(this) };
  eventMixin(Line);

  // Change the content (text, markers) of a line. Automatically
  // invalidates cached information and tries to re-estimate the
  // line's height.
  function updateLine(line, text, markedSpans, estimateHeight) {
    line.text = text;
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
    if (line.order != null) { line.order = null; }
    detachMarkedSpans(line);
    attachMarkedSpans(line, markedSpans);
    var estHeight = estimateHeight ? estimateHeight(line) : 1;
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  }

  // Detach a line from the document tree and its markers.
  function cleanUpLine(line) {
    line.parent = null;
    detachMarkedSpans(line);
  }

  // Convert a style as returned by a mode (either null, or a string
  // containing one or more styles) to a CSS style. This is cached,
  // and also looks for line-wide styles.
  var styleToClassCache = {}, styleToClassCacheWithMode = {};
  function interpretTokenStyle(style, options) {
    if (!style || /^\s*$/.test(style)) { return null }
    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
    return cache[style] ||
      (cache[style] = style.replace(/\S+/g, "cm-$&"))
  }

  // Render the DOM representation of the text of a line. Also builds
  // up a 'line map', which points at the DOM nodes that represent
  // specific stretches of text, and is used by the measuring code.
  // The returned object contains the DOM node, this map, and
  // information about line-wide styles that were set by the mode.
  function buildLineContent(cm, lineView) {
    // The padding-right forces the element to have a 'border', which
    // is needed on Webkit to be able to get line-level bounding
    // rectangles for it (in measureChar).
    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                   col: 0, pos: 0, cm: cm,
                   trailingSpace: false,
                   splitSpaces: cm.getOption("lineWrapping")};
    lineView.measure = {};

    // Iterate over the logical lines that make up this visual line.
    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
      builder.pos = 0;
      builder.addToken = buildToken;
      // Optionally wire in some hacks into the token-rendering
      // algorithm, to deal with browser quirks.
      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
      builder.map = [];
      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
      if (line.styleClasses) {
        if (line.styleClasses.bgClass)
          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
        if (line.styleClasses.textClass)
          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
      }

      // Ensure at least a single node is present, for measuring.
      if (builder.map.length == 0)
        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

      // Store the map and a cache object for the current logical line
      if (i == 0) {
        lineView.measure.map = builder.map;
        lineView.measure.cache = {};
      } else {
  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
      }
    }

    // See issue #2901
    if (webkit) {
      var last = builder.content.lastChild;
      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
        { builder.content.className = "cm-tab-wrap-hack"; }
    }

    signal(cm, "renderLine", cm, lineView.line, builder.pre);
    if (builder.pre.className)
      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

    return builder
  }

  function defaultSpecialCharPlaceholder(ch) {
    var token = elt("span", "\u2022", "cm-invalidchar");
    token.title = "\\u" + ch.charCodeAt(0).toString(16);
    token.setAttribute("aria-label", token.title);
    return token
  }

  // Build up the DOM representation for a single token, and add it to
  // the line map. Takes care to render special characters separately.
  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
    if (!text) { return }
    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
    var special = builder.cm.state.specialChars, mustWrap = false;
    var content;
    if (!special.test(text)) {
      builder.col += text.length;
      content = document.createTextNode(displayText);
      builder.map.push(builder.pos, builder.pos + text.length, content);
      if (ie && ie_version < 9) { mustWrap = true; }
      builder.pos += text.length;
    } else {
      content = document.createDocumentFragment();
      var pos = 0;
      while (true) {
        special.lastIndex = pos;
        var m = special.exec(text);
        var skipped = m ? m.index - pos : text.length - pos;
        if (skipped) {
          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
          else { content.appendChild(txt); }
          builder.map.push(builder.pos, builder.pos + skipped, txt);
          builder.col += skipped;
          builder.pos += skipped;
        }
        if (!m) { break }
        pos += skipped + 1;
        var txt$1 = (void 0);
        if (m[0] == "\t") {
          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
          txt$1.setAttribute("role", "presentation");
          txt$1.setAttribute("cm-text", "\t");
          builder.col += tabWidth;
        } else if (m[0] == "\r" || m[0] == "\n") {
          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
          txt$1.setAttribute("cm-text", m[0]);
          builder.col += 1;
        } else {
          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
          txt$1.setAttribute("cm-text", m[0]);
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
          else { content.appendChild(txt$1); }
          builder.col += 1;
        }
        builder.map.push(builder.pos, builder.pos + 1, txt$1);
        builder.pos++;
      }
    }
    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
    if (style || startStyle || endStyle || mustWrap || css || attributes) {
      var fullStyle = style || "";
      if (startStyle) { fullStyle += startStyle; }
      if (endStyle) { fullStyle += endStyle; }
      var token = elt("span", [content], fullStyle, css);
      if (attributes) {
        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
          { token.setAttribute(attr, attributes[attr]); } }
      }
      return builder.content.appendChild(token)
    }
    builder.content.appendChild(content);
  }

  // Change some spaces to NBSP to prevent the browser from collapsing
  // trailing spaces at the end of a line when rendering text (issue #1362).
  function splitSpaces(text, trailingBefore) {
    if (text.length > 1 && !/  /.test(text)) { return text }
    var spaceBefore = trailingBefore, result = "";
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
        { ch = "\u00a0"; }
      result += ch;
      spaceBefore = ch == " ";
    }
    return result
  }

  // Work around nonsense dimensions being reported for stretches of
  // right-to-left text.
  function buildTokenBadBidi(inner, order) {
    return function (builder, text, style, startStyle, endStyle, css, attributes) {
      style = style ? style + " cm-force-border" : "cm-force-border";
      var start = builder.pos, end = start + text.length;
      for (;;) {
        // Find the part that overlaps with the start of this text
        var part = (void 0);
        for (var i = 0; i < order.length; i++) {
          part = order[i];
          if (part.to > start && part.from <= start) { break }
        }
        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
        startStyle = null;
        text = text.slice(part.to - start);
        start = part.to;
      }
    }
  }

  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
    var widget = !ignoreWidget && marker.widgetNode;
    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
      if (!widget)
        { widget = builder.content.appendChild(document.createElement("span")); }
      widget.setAttribute("cm-marker", marker.id);
    }
    if (widget) {
      builder.cm.display.input.setUneditable(widget);
      builder.content.appendChild(widget);
    }
    builder.pos += size;
    builder.trailingSpace = false;
  }

  // Outputs a number of spans to make up a line, taking highlighting
  // and marked text into account.
  function insertLineContent(line, builder, styles) {
    var spans = line.markedSpans, allText = line.text, at = 0;
    if (!spans) {
      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
      return
    }

    var len = allText.length, pos = 0, i = 1, text = "", style, css;
    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
    for (;;) {
      if (nextChange == pos) { // Update current marker set
        spanStyle = spanEndStyle = spanStartStyle = css = "";
        attributes = null;
        collapsed = null; nextChange = Infinity;
        var foundBookmarks = [], endStyles = (void 0);
        for (var j = 0; j < spans.length; ++j) {
          var sp = spans[j], m = sp.marker;
          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
            foundBookmarks.push(m);
          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
              nextChange = sp.to;
              spanEndStyle = "";
            }
            if (m.className) { spanStyle += " " + m.className; }
            if (m.css) { css = (css ? css + ";" : "") + m.css; }
            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
            // support for the old title property
            // https://github.com/codemirror/CodeMirror/pull/5673
            if (m.title) { (attributes || (attributes = {})).title = m.title; }
            if (m.attributes) {
              for (var attr in m.attributes)
                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
            }
            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
              { collapsed = sp; }
          } else if (sp.from > pos && nextChange > sp.from) {
            nextChange = sp.from;
          }
        }
        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
        if (collapsed && (collapsed.from || 0) == pos) {
          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                             collapsed.marker, collapsed.from == null);
          if (collapsed.to == null) { return }
          if (collapsed.to == pos) { collapsed = false; }
        }
      }
      if (pos >= len) { break }

      var upto = Math.min(len, nextChange);
      while (true) {
        if (text) {
          var end = pos + text.length;
          if (!collapsed) {
            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
          }
          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
          pos = end;
          spanStartStyle = "";
        }
        text = allText.slice(at, at = styles[i++]);
        style = interpretTokenStyle(styles[i++], builder.cm.options);
      }
    }
  }


  // These objects are used to represent the visible (currently drawn)
  // part of the document. A LineView may correspond to multiple
  // logical lines, if those are connected by collapsed ranges.
  function LineView(doc, line, lineN) {
    // The starting line
    this.line = line;
    // Continuing lines, if any
    this.rest = visualLineContinued(line);
    // Number of logical lines in this visual line
    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
    this.node = this.text = null;
    this.hidden = lineIsHidden(doc, line);
  }

  // Create a range of LineView objects for the given lines.
  function buildViewArray(cm, from, to) {
    var array = [], nextPos;
    for (var pos = from; pos < to; pos = nextPos) {
      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
      nextPos = pos + view.size;
      array.push(view);
    }
    return array
  }

  var operationGroup = null;

  function pushOperation(op) {
    if (operationGroup) {
      operationGroup.ops.push(op);
    } else {
      op.ownsGroup = operationGroup = {
        ops: [op],
        delayedCallbacks: []
      };
    }
  }

  function fireCallbacksForOps(group) {
    // Calls delayed callbacks and cursorActivity handlers until no
    // new ones appear
    var callbacks = group.delayedCallbacks, i = 0;
    do {
      for (; i < callbacks.length; i++)
        { callbacks[i].call(null); }
      for (var j = 0; j < group.ops.length; j++) {
        var op = group.ops[j];
        if (op.cursorActivityHandlers)
          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
      }
    } while (i < callbacks.length)
  }

  function finishOperation(op, endCb) {
    var group = op.ownsGroup;
    if (!group) { return }

    try { fireCallbacksForOps(group); }
    finally {
      operationGroup = null;
      endCb(group);
    }
  }

  var orphanDelayedCallbacks = null;

  // Often, we want to signal events at a point where we are in the
  // middle of some work, but don't want the handler to start calling
  // other methods on the editor, which might be in an inconsistent
  // state or simply not expect any other events to happen.
  // signalLater looks whether there are any handlers, and schedules
  // them to be executed when the last operation ends, or, if no
  // operation is active, when a timeout fires.
  function signalLater(emitter, type /*, values...*/) {
    var arr = getHandlers(emitter, type);
    if (!arr.length) { return }
    var args = Array.prototype.slice.call(arguments, 2), list;
    if (operationGroup) {
      list = operationGroup.delayedCallbacks;
    } else if (orphanDelayedCallbacks) {
      list = orphanDelayedCallbacks;
    } else {
      list = orphanDelayedCallbacks = [];
      setTimeout(fireOrphanDelayed, 0);
    }
    var loop = function ( i ) {
      list.push(function () { return arr[i].apply(null, args); });
    };

    for (var i = 0; i < arr.length; ++i)
      loop( i );
  }

  function fireOrphanDelayed() {
    var delayed = orphanDelayedCallbacks;
    orphanDelayedCallbacks = null;
    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
  }

  // When an aspect of a line changes, a string is added to
  // lineView.changes. This updates the relevant part of the line's
  // DOM structure.
  function updateLineForChanges(cm, lineView, lineN, dims) {
    for (var j = 0; j < lineView.changes.length; j++) {
      var type = lineView.changes[j];
      if (type == "text") { updateLineText(cm, lineView); }
      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
      else if (type == "class") { updateLineClasses(cm, lineView); }
      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
    }
    lineView.changes = null;
  }

  // Lines with gutter elements, widgets or a background class need to
  // be wrapped, and have the extra elements added to the wrapper div
  function ensureLineWrapped(lineView) {
    if (lineView.node == lineView.text) {
      lineView.node = elt("div", null, null, "position: relative");
      if (lineView.text.parentNode)
        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
      lineView.node.appendChild(lineView.text);
      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
    }
    return lineView.node
  }

  function updateLineBackground(cm, lineView) {
    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
    if (cls) { cls += " CodeMirror-linebackground"; }
    if (lineView.background) {
      if (cls) { lineView.background.className = cls; }
      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
    } else if (cls) {
      var wrap = ensureLineWrapped(lineView);
      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
      cm.display.input.setUneditable(lineView.background);
    }
  }

  // Wrapper around buildLineContent which will reuse the structure
  // in display.externalMeasured when possible.
  function getLineContent(cm, lineView) {
    var ext = cm.display.externalMeasured;
    if (ext && ext.line == lineView.line) {
      cm.display.externalMeasured = null;
      lineView.measure = ext.measure;
      return ext.built
    }
    return buildLineContent(cm, lineView)
  }

  // Redraw the line's text. Interacts with the background and text
  // classes because the mode may output tokens that influence these
  // classes.
  function updateLineText(cm, lineView) {
    var cls = lineView.text.className;
    var built = getLineContent(cm, lineView);
    if (lineView.text == lineView.node) { lineView.node = built.pre; }
    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
    lineView.text = built.pre;
    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
      lineView.bgClass = built.bgClass;
      lineView.textClass = built.textClass;
      updateLineClasses(cm, lineView);
    } else if (cls) {
      lineView.text.className = cls;
    }
  }

  function updateLineClasses(cm, lineView) {
    updateLineBackground(cm, lineView);
    if (lineView.line.wrapClass)
      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
    else if (lineView.node != lineView.text)
      { lineView.node.className = ""; }
    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
    lineView.text.className = textClass || "";
  }

  function updateLineGutter(cm, lineView, lineN, dims) {
    if (lineView.gutter) {
      lineView.node.removeChild(lineView.gutter);
      lineView.gutter = null;
    }
    if (lineView.gutterBackground) {
      lineView.node.removeChild(lineView.gutterBackground);
      lineView.gutterBackground = null;
    }
    if (lineView.line.gutterClass) {
      var wrap = ensureLineWrapped(lineView);
      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(lineView.gutterBackground);
      wrap.insertBefore(lineView.gutterBackground, lineView.text);
    }
    var markers = lineView.line.gutterMarkers;
    if (cm.options.lineNumbers || markers) {
      var wrap$1 = ensureLineWrapped(lineView);
      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
      gutterWrap.setAttribute("aria-hidden", "true");
      cm.display.input.setUneditable(gutterWrap);
      wrap$1.insertBefore(gutterWrap, lineView.text);
      if (lineView.line.gutterClass)
        { gutterWrap.className += " " + lineView.line.gutterClass; }
      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
        { lineView.lineNumber = gutterWrap.appendChild(
          elt("div", lineNumberFor(cm.options, lineN),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
        if (found)
          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
      } }
    }
  }

  function updateLineWidgets(cm, lineView, dims) {
    if (lineView.alignable) { lineView.alignable = null; }
    var isWidget = classTest("CodeMirror-linewidget");
    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
      next = node.nextSibling;
      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
    }
    insertLineWidgets(cm, lineView, dims);
  }

  // Build a line's DOM representation from scratch
  function buildLineElement(cm, lineView, lineN, dims) {
    var built = getLineContent(cm, lineView);
    lineView.text = lineView.node = built.pre;
    if (built.bgClass) { lineView.bgClass = built.bgClass; }
    if (built.textClass) { lineView.textClass = built.textClass; }

    updateLineClasses(cm, lineView);
    updateLineGutter(cm, lineView, lineN, dims);
    insertLineWidgets(cm, lineView, dims);
    return lineView.node
  }

  // A lineView may contain multiple logical lines (when merged by
  // collapsed spans). The widgets for all of them need to be drawn.
  function insertLineWidgets(cm, lineView, dims) {
    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
  }

  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
    if (!line.widgets) { return }
    var wrap = ensureLineWrapped(lineView);
    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
      positionLineWidget(widget, node, lineView, dims);
      cm.display.input.setUneditable(node);
      if (allowAbove && widget.above)
        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
      else
        { wrap.appendChild(node); }
      signalLater(widget, "redraw");
    }
  }

  function positionLineWidget(widget, node, lineView, dims) {
    if (widget.noHScroll) {
  (lineView.alignable || (lineView.alignable = [])).push(node);
      var width = dims.wrapperWidth;
      node.style.left = dims.fixedPos + "px";
      if (!widget.coverGutter) {
        width -= dims.gutterTotalWidth;
        node.style.paddingLeft = dims.gutterTotalWidth + "px";
      }
      node.style.width = width + "px";
    }
    if (widget.coverGutter) {
      node.style.zIndex = 5;
      node.style.position = "relative";
      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
    }
  }

  function widgetHeight(widget) {
    if (widget.height != null) { return widget.height }
    var cm = widget.doc.cm;
    if (!cm) { return 0 }
    if (!contains(document.body, widget.node)) {
      var parentStyle = "position: relative;";
      if (widget.coverGutter)
        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
      if (widget.noHScroll)
        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
    }
    return widget.height = widget.node.parentNode.offsetHeight
  }

  // Return true when the given mouse event happened in a widget
  function eventInWidget(display, e) {
    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
          (n.parentNode == display.sizer && n != display.mover))
        { return true }
    }
  }

  // POSITION MEASUREMENT

  function paddingTop(display) {return display.lineSpace.offsetTop}
  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
  function paddingH(display) {
    if (display.cachedPaddingH) { return display.cachedPaddingH }
    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
    return data
  }

  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
  function displayWidth(cm) {
    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
  }
  function displayHeight(cm) {
    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
  }

  // Ensure the lineView.wrapping.heights array is populated. This is
  // an array of bottom offsets for the lines that make up a drawn
  // line. When lineWrapping is on, there might be more than one
  // height.
  function ensureLineHeights(cm, lineView, rect) {
    var wrapping = cm.options.lineWrapping;
    var curWidth = wrapping && displayWidth(cm);
    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
      var heights = lineView.measure.heights = [];
      if (wrapping) {
        lineView.measure.width = curWidth;
        var rects = lineView.text.firstChild.getClientRects();
        for (var i = 0; i < rects.length - 1; i++) {
          var cur = rects[i], next = rects[i + 1];
          if (Math.abs(cur.bottom - next.bottom) > 2)
            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
        }
      }
      heights.push(rect.bottom - rect.top);
    }
  }

  // Find a line map (mapping character offsets to text nodes) and a
  // measurement cache for the given line number. (A line view might
  // contain multiple lines when collapsed ranges are present.)
  function mapFromLineView(lineView, line, lineN) {
    if (lineView.line == line)
      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
    if (lineView.rest) {
      for (var i = 0; i < lineView.rest.length; i++)
        { if (lineView.rest[i] == line)
          { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
      for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
        { if (lineNo(lineView.rest[i$1]) > lineN)
          { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
    }
  }

  // Render a line into the hidden node display.externalMeasured. Used
  // when measurement is needed for a line that's not in the viewport.
  function updateExternalMeasurement(cm, line) {
    line = visualLine(line);
    var lineN = lineNo(line);
    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
    view.lineN = lineN;
    var built = view.built = buildLineContent(cm, view);
    view.text = built.pre;
    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
    return view
  }

  // Get a {top, bottom, left, right} box (in line-local coordinates)
  // for a given character.
  function measureChar(cm, line, ch, bias) {
    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
  }

  // Find a line view that corresponds to the given line number.
  function findViewForLine(cm, lineN) {
    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
      { return cm.display.view[findViewIndex(cm, lineN)] }
    var ext = cm.display.externalMeasured;
    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
      { return ext }
  }

  // Measurement can be split in two steps, the set-up work that
  // applies to the whole line, and the measurement of the actual
  // character. Functions like coordsChar, that need to do a lot of
  // measurements in a row, can thus ensure that the set-up work is
  // only done once.
  function prepareMeasureForLine(cm, line) {
    var lineN = lineNo(line);
    var view = findViewForLine(cm, lineN);
    if (view && !view.text) {
      view = null;
    } else if (view && view.changes) {
      updateLineForChanges(cm, view, lineN, getDimensions(cm));
      cm.curOp.forceUpdate = true;
    }
    if (!view)
      { view = updateExternalMeasurement(cm, line); }

    var info = mapFromLineView(view, line, lineN);
    return {
      line: line, view: view, rect: null,
      map: info.map, cache: info.cache, before: info.before,
      hasHeights: false
    }
  }

  // Given a prepared measurement object, measures the position of an
  // actual character (or fetches it from the cache).
  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
    if (prepared.before) { ch = -1; }
    var key = ch + (bias || ""), found;
    if (prepared.cache.hasOwnProperty(key)) {
      found = prepared.cache[key];
    } else {
      if (!prepared.rect)
        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
      if (!prepared.hasHeights) {
        ensureLineHeights(cm, prepared.view, prepared.rect);
        prepared.hasHeights = true;
      }
      found = measureCharInner(cm, prepared, ch, bias);
      if (!found.bogus) { prepared.cache[key] = found; }
    }
    return {left: found.left, right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom}
  }

  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

  function nodeAndOffsetInLineMap(map, ch, bias) {
    var node, start, end, collapse, mStart, mEnd;
    // First, search the line map for the text node corresponding to,
    // or closest to, the target character.
    for (var i = 0; i < map.length; i += 3) {
      mStart = map[i];
      mEnd = map[i + 1];
      if (ch < mStart) {
        start = 0; end = 1;
        collapse = "left";
      } else if (ch < mEnd) {
        start = ch - mStart;
        end = start + 1;
      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
        end = mEnd - mStart;
        start = end - 1;
        if (ch >= mEnd) { collapse = "right"; }
      }
      if (start != null) {
        node = map[i + 2];
        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
          { collapse = bias; }
        if (bias == "left" && start == 0)
          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
            node = map[(i -= 3) + 2];
            collapse = "left";
          } }
        if (bias == "right" && start == mEnd - mStart)
          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
            node = map[(i += 3) + 2];
            collapse = "right";
          } }
        break
      }
    }
    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
  }

  function getUsefulRect(rects, bias) {
    var rect = nullRect;
    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
      if ((rect = rects[i]).left != rect.right) { break }
    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
      if ((rect = rects[i$1]).left != rect.right) { break }
    } }
    return rect
  }

  function measureCharInner(cm, prepared, ch, bias) {
    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

    var rect;
    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
          { rect = node.parentNode.getBoundingClientRect(); }
        else
          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
        if (rect.left || rect.right || start == 0) { break }
        end = start;
        start = start - 1;
        collapse = "right";
      }
      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
    } else { // If it is a widget, simply get the box for the whole widget.
      if (start > 0) { collapse = bias = "right"; }
      var rects;
      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
      else
        { rect = node.getBoundingClientRect(); }
    }
    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
      var rSpan = node.parentNode.getClientRects()[0];
      if (rSpan)
        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
      else
        { rect = nullRect; }
    }

    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
    var mid = (rtop + rbot) / 2;
    var heights = prepared.view.measure.heights;
    var i = 0;
    for (; i < heights.length - 1; i++)
      { if (mid < heights[i]) { break } }
    var top = i ? heights[i - 1] : 0, bot = heights[i];
    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                  top: top, bottom: bot};
    if (!rect.left && !rect.right) { result.bogus = true; }
    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

    return result
  }

  // Work around problem with bounding client rects on ranges being
  // returned incorrectly when zoomed on IE10 and below.
  function maybeUpdateRectForZooming(measure, rect) {
    if (!window.screen || screen.logicalXDPI == null ||
        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
      { return rect }
    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
    return {left: rect.left * scaleX, right: rect.right * scaleX,
            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
  }

  function clearLineMeasurementCacheFor(lineView) {
    if (lineView.measure) {
      lineView.measure.cache = {};
      lineView.measure.heights = null;
      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
        { lineView.measure.caches[i] = {}; } }
    }
  }

  function clearLineMeasurementCache(cm) {
    cm.display.externalMeasure = null;
    removeChildren(cm.display.lineMeasure);
    for (var i = 0; i < cm.display.view.length; i++)
      { clearLineMeasurementCacheFor(cm.display.view[i]); }
  }

  function clearCaches(cm) {
    clearLineMeasurementCache(cm);
    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
    cm.display.lineNumChars = null;
  }

  function pageScrollX() {
    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
    // which causes page_Offset and bounding client rects to use
    // different reference viewports and invalidate our calculations.
    if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
    return window.pageXOffset || (document.documentElement || document.body).scrollLeft
  }
  function pageScrollY() {
    if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
    return window.pageYOffset || (document.documentElement || document.body).scrollTop
  }

  function widgetTopHeight(lineObj) {
    var height = 0;
    if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
      { height += widgetHeight(lineObj.widgets[i]); } } }
    return height
  }

  // Converts a {top, bottom, left, right} box from line-local
  // coordinates into another coordinate system. Context may be one of
  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
  // or "page".
  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
    if (!includeWidgets) {
      var height = widgetTopHeight(lineObj);
      rect.top += height; rect.bottom += height;
    }
    if (context == "line") { return rect }
    if (!context) { context = "local"; }
    var yOff = heightAtLine(lineObj);
    if (context == "local") { yOff += paddingTop(cm.display); }
    else { yOff -= cm.display.viewOffset; }
    if (context == "page" || context == "window") {
      var lOff = cm.display.lineSpace.getBoundingClientRect();
      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
      rect.left += xOff; rect.right += xOff;
    }
    rect.top += yOff; rect.bottom += yOff;
    return rect
  }

  // Coverts a box from "div" coords to another coordinate system.
  // Context may be "window", "page", "div", or "local"./null.
  function fromCoordSystem(cm, coords, context) {
    if (context == "div") { return coords }
    var left = coords.left, top = coords.top;
    // First move into "page" coordinate system
    if (context == "page") {
      left -= pageScrollX();
      top -= pageScrollY();
    } else if (context == "local" || !context) {
      var localBox = cm.display.sizer.getBoundingClientRect();
      left += localBox.left;
      top += localBox.top;
    }

    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
  }

  function charCoords(cm, pos, context, lineObj, bias) {
    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
  }

  // Returns a box for a given cursor position, which may have an
  // 'other' property containing the position of the secondary cursor
  // on a bidi boundary.
  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
  // and after `char - 1` in writing order of `char - 1`
  // A cursor Pos(line, char, "after") is on the same visual line as `char`
  // and before `char` in writing order of `char`
  // Examples (upper-case letters are RTL, lower-case are LTR):
  //     Pos(0, 1, ...)
  //     before   after
  // ab     a|b     a|b
  // aB     a|B     aB|
  // Ab     |Ab     A|b
  // AB     B|A     B|A
  // Every position after the last character on a line is considered to stick
  // to the last character on the line.
  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
    lineObj = lineObj || getLine(cm.doc, pos.line);
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    function get(ch, right) {
      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
      if (right) { m.left = m.right; } else { m.right = m.left; }
      return intoCoordSystem(cm, lineObj, m, context)
    }
    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
    if (ch >= lineObj.text.length) {
      ch = lineObj.text.length;
      sticky = "before";
    } else if (ch <= 0) {
      ch = 0;
      sticky = "after";
    }
    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

    function getBidi(ch, partPos, invert) {
      var part = order[partPos], right = part.level == 1;
      return get(invert ? ch - 1 : ch, right != invert)
    }
    var partPos = getBidiPartAt(order, ch, sticky);
    var other = bidiOther;
    var val = getBidi(ch, partPos, sticky == "before");
    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
    return val
  }

  // Used to cheaply estimate the coordinates for a position. Used for
  // intermediate scroll updates.
  function estimateCoords(cm, pos) {
    var left = 0;
    pos = clipPos(cm.doc, pos);
    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
    var lineObj = getLine(cm.doc, pos.line);
    var top = heightAtLine(lineObj) + paddingTop(cm.display);
    return {left: left, right: left, top: top, bottom: top + lineObj.height}
  }

  // Positions returned by coordsChar contain some extra information.
  // xRel is the relative x position of the input coordinates compared
  // to the found position (so xRel > 0 means the coordinates are to
  // the right of the character position, for example). When outside
  // is true, that means the coordinates lie outside the line's
  // vertical range.
  function PosWithInfo(line, ch, sticky, outside, xRel) {
    var pos = Pos(line, ch, sticky);
    pos.xRel = xRel;
    if (outside) { pos.outside = outside; }
    return pos
  }

  // Compute the character position closest to the given coordinates.
  // Input must be lineSpace-local ("div" coordinate system).
  function coordsChar(cm, x, y) {
    var doc = cm.doc;
    y += cm.display.viewOffset;
    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
    if (lineN > last)
      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
    if (x < 0) { x = 0; }

    var lineObj = getLine(doc, lineN);
    for (;;) {
      var found = coordsCharInner(cm, lineObj, lineN, x, y);
      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
      if (!collapsed) { return found }
      var rangeEnd = collapsed.find(1);
      if (rangeEnd.line == lineN) { return rangeEnd }
      lineObj = getLine(doc, lineN = rangeEnd.line);
    }
  }

  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
    y -= widgetTopHeight(lineObj);
    var end = lineObj.text.length;
    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
    return {begin: begin, end: end}
  }

  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
  }

  // Returns true if the given side of a box is after the given
  // coordinates, in top-to-bottom, left-to-right order.
  function boxIsAfter(box, x, y, left) {
    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
  }

  function coordsCharInner(cm, lineObj, lineNo, x, y) {
    // Move y into line-local coordinate space
    y -= heightAtLine(lineObj);
    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
    // When directly calling `measureCharPrepared`, we have to adjust
    // for the widgets at this line.
    var widgetHeight = widgetTopHeight(lineObj);
    var begin = 0, end = lineObj.text.length, ltr = true;

    var order = getOrder(lineObj, cm.doc.direction);
    // If the line isn't plain left-to-right text, first figure out
    // which bidi section the coordinates fall into.
    if (order) {
      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
      ltr = part.level != 1;
      // The awkward -1 offsets are needed because findFirst (called
      // on these below) will treat its first bound as inclusive,
      // second as exclusive, but we want to actually address the
      // characters in the part's range
      begin = ltr ? part.from : part.to - 1;
      end = ltr ? part.to : part.from - 1;
    }

    // A binary search to find the first character whose bounding box
    // starts after the coordinates. If we run across any whose box wrap
    // the coordinates, store that.
    var chAround = null, boxAround = null;
    var ch = findFirst(function (ch) {
      var box = measureCharPrepared(cm, preparedMeasure, ch);
      box.top += widgetHeight; box.bottom += widgetHeight;
      if (!boxIsAfter(box, x, y, false)) { return false }
      if (box.top <= y && box.left <= x) {
        chAround = ch;
        boxAround = box;
      }
      return true
    }, begin, end);

    var baseX, sticky, outside = false;
    // If a box around the coordinates was found, use that
    if (boxAround) {
      // Distinguish coordinates nearer to the left or right side of the box
      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
      ch = chAround + (atStart ? 0 : 1);
      sticky = atStart ? "after" : "before";
      baseX = atLeft ? boxAround.left : boxAround.right;
    } else {
      // (Adjust for extended bound, if necessary.)
      if (!ltr && (ch == end || ch == begin)) { ch++; }
      // To determine which side to associate with, get the box to the
      // left of the character and compare it's vertical position to the
      // coordinates
      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
        "after" : "before";
      // Now get accurate coordinates for this place, in order to get a
      // base X position
      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
      baseX = coords.left;
      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
    }

    ch = skipExtendingChars(lineObj.text, ch, 1);
    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
  }

  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
    // situation, we can take this ordering to correspond to the visual
    // ordering. This finds the first part whose end is after the given
    // coordinates.
    var index = findFirst(function (i) {
      var part = order[i], ltr = part.level != 1;
      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                     "line", lineObj, preparedMeasure), x, y, true)
    }, 0, order.length - 1);
    var part = order[index];
    // If this isn't the first part, the part's start is also after
    // the coordinates, and the coordinates aren't on the same line as
    // that start, move one part back.
    if (index > 0) {
      var ltr = part.level != 1;
      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
                               "line", lineObj, preparedMeasure);
      if (boxIsAfter(start, x, y, true) && start.top > y)
        { part = order[index - 1]; }
    }
    return part
  }

  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
    // In a wrapped line, rtl text on wrapping boundaries can do things
    // that don't correspond to the ordering in our `order` array at
    // all, so a binary search doesn't work, and we want to return a
    // part that only spans one line so that the binary search in
    // coordsCharInner is safe. As such, we first find the extent of the
    // wrapped line, and then do a flat search in which we discard any
    // spans that aren't on the line.
    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
    var begin = ref.begin;
    var end = ref.end;
    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
    var part = null, closestDist = null;
    for (var i = 0; i < order.length; i++) {
      var p = order[i];
      if (p.from >= end || p.to <= begin) { continue }
      var ltr = p.level != 1;
      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
      // Weigh against spans ending before this, so that they are only
      // picked if nothing ends after
      var dist = endX < x ? x - endX + 1e9 : endX - x;
      if (!part || closestDist > dist) {
        part = p;
        closestDist = dist;
      }
    }
    if (!part) { part = order[order.length - 1]; }
    // Clip the part to the wrapped line.
    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
    return part
  }

  var measureText;
  // Compute the default text height.
  function textHeight(display) {
    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
    if (measureText == null) {
      measureText = elt("pre", null, "CodeMirror-line-like");
      // Measure a bunch of lines, for browsers that compute
      // fractional heights.
      for (var i = 0; i < 49; ++i) {
        measureText.appendChild(document.createTextNode("x"));
        measureText.appendChild(elt("br"));
      }
      measureText.appendChild(document.createTextNode("x"));
    }
    removeChildrenAndAdd(display.measure, measureText);
    var height = measureText.offsetHeight / 50;
    if (height > 3) { display.cachedTextHeight = height; }
    removeChildren(display.measure);
    return height || 1
  }

  // Compute the default character width.
  function charWidth(display) {
    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
    var anchor = elt("span", "xxxxxxxxxx");
    var pre = elt("pre", [anchor], "CodeMirror-line-like");
    removeChildrenAndAdd(display.measure, pre);
    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
    if (width > 2) { display.cachedCharWidth = width; }
    return width || 10
  }

  // Do a bulk-read of the DOM positions and sizes needed to draw the
  // view, so that we don't interleave reading and writing to the DOM.
  function getDimensions(cm) {
    var d = cm.display, left = {}, width = {};
    var gutterLeft = d.gutters.clientLeft;
    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
      var id = cm.display.gutterSpecs[i].className;
      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
      width[id] = n.clientWidth;
    }
    return {fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth}
  }

  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
  // but using getBoundingClientRect to get a sub-pixel-accurate
  // result.
  function compensateForHScroll(display) {
    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
  }

  // Returns a function that estimates the height of a line, to use as
  // first approximation until the line becomes visible (and is thus
  // properly measurable).
  function estimateHeight(cm) {
    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
    return function (line) {
      if (lineIsHidden(cm.doc, line)) { return 0 }

      var widgetsHeight = 0;
      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
      } }

      if (wrapping)
        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
      else
        { return widgetsHeight + th }
    }
  }

  function estimateLineHeights(cm) {
    var doc = cm.doc, est = estimateHeight(cm);
    doc.iter(function (line) {
      var estHeight = est(line);
      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
    });
  }

  // Given a mouse event, find the corresponding position. If liberal
  // is false, it checks whether a gutter or scrollbar was clicked,
  // and returns null if it was. forRect is used by rectangular
  // selections, and tries to estimate a character position even for
  // coordinates beyond the right of the text.
  function posFromMouse(cm, e, liberal, forRect) {
    var display = cm.display;
    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

    var x, y, space = display.lineSpace.getBoundingClientRect();
    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
    try { x = e.clientX - space.left; y = e.clientY - space.top; }
    catch (e$1) { return null }
    var coords = coordsChar(cm, x, y), line;
    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
    }
    return coords
  }

  // Find the view element corresponding to a given line. Return null
  // when the line isn't visible.
  function findViewIndex(cm, n) {
    if (n >= cm.display.viewTo) { return null }
    n -= cm.display.viewFrom;
    if (n < 0) { return null }
    var view = cm.display.view;
    for (var i = 0; i < view.length; i++) {
      n -= view[i].size;
      if (n < 0) { return i }
    }
  }

  // Updates the display.view data structure for a given change to the
  // document. From and to are in pre-change coordinates. Lendiff is
  // the amount of lines added or subtracted by the change. This is
  // used for changes that span multiple lines, or change the way
  // lines are divided into visual lines. regLineChange (below)
  // registers single-line changes.
  function regChange(cm, from, to, lendiff) {
    if (from == null) { from = cm.doc.first; }
    if (to == null) { to = cm.doc.first + cm.doc.size; }
    if (!lendiff) { lendiff = 0; }

    var display = cm.display;
    if (lendiff && to < display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers > from))
      { display.updateLineNumbers = from; }

    cm.curOp.viewChanged = true;

    if (from >= display.viewTo) { // Change after
      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
        { resetView(cm); }
    } else if (to <= display.viewFrom) { // Change before
      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
        resetView(cm);
      } else {
        display.viewFrom += lendiff;
        display.viewTo += lendiff;
      }
    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
      resetView(cm);
    } else if (from <= display.viewFrom) { // Top overlap
      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cut) {
        display.view = display.view.slice(cut.index);
        display.viewFrom = cut.lineN;
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    } else if (to >= display.viewTo) { // Bottom overlap
      var cut$1 = viewCuttingPoint(cm, from, from, -1);
      if (cut$1) {
        display.view = display.view.slice(0, cut$1.index);
        display.viewTo = cut$1.lineN;
      } else {
        resetView(cm);
      }
    } else { // Gap in the middle
      var cutTop = viewCuttingPoint(cm, from, from, -1);
      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cutTop && cutBot) {
        display.view = display.view.slice(0, cutTop.index)
          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
          .concat(display.view.slice(cutBot.index));
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    }

    var ext = display.externalMeasured;
    if (ext) {
      if (to < ext.lineN)
        { ext.lineN += lendiff; }
      else if (from < ext.lineN + ext.size)
        { display.externalMeasured = null; }
    }
  }

  // Register a change to a single line. Type must be one of "text",
  // "gutter", "class", "widget"
  function regLineChange(cm, line, type) {
    cm.curOp.viewChanged = true;
    var display = cm.display, ext = cm.display.externalMeasured;
    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
      { display.externalMeasured = null; }

    if (line < display.viewFrom || line >= display.viewTo) { return }
    var lineView = display.view[findViewIndex(cm, line)];
    if (lineView.node == null) { return }
    var arr = lineView.changes || (lineView.changes = []);
    if (indexOf(arr, type) == -1) { arr.push(type); }
  }

  // Clear the view.
  function resetView(cm) {
    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
    cm.display.view = [];
    cm.display.viewOffset = 0;
  }

  function viewCuttingPoint(cm, oldN, newN, dir) {
    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
      { return {index: index, lineN: newN} }
    var n = cm.display.viewFrom;
    for (var i = 0; i < index; i++)
      { n += view[i].size; }
    if (n != oldN) {
      if (dir > 0) {
        if (index == view.length - 1) { return null }
        diff = (n + view[index].size) - oldN;
        index++;
      } else {
        diff = n - oldN;
      }
      oldN += diff; newN += diff;
    }
    while (visualLineNo(cm.doc, newN) != newN) {
      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
      index += dir;
    }
    return {index: index, lineN: newN}
  }

  // Force the view to cover a given range, adding empty view element
  // or clipping off existing ones as needed.
  function adjustView(cm, from, to) {
    var display = cm.display, view = display.view;
    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
      display.view = buildViewArray(cm, from, to);
      display.viewFrom = from;
    } else {
      if (display.viewFrom > from)
        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
      else if (display.viewFrom < from)
        { display.view = display.view.slice(findViewIndex(cm, from)); }
      display.viewFrom = from;
      if (display.viewTo < to)
        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
      else if (display.viewTo > to)
        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
    }
    display.viewTo = to;
  }

  // Count the number of lines in the view whose DOM representation is
  // out of date (or nonexistent).
  function countDirtyView(cm) {
    var view = cm.display.view, dirty = 0;
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
    }
    return dirty
  }

  function updateSelection(cm) {
    cm.display.input.showSelection(cm.display.input.prepareSelection());
  }

  function prepareSelection(cm, primary) {
    if ( primary === void 0 ) primary = true;

    var doc = cm.doc, result = {};
    var curFragment = result.cursors = document.createDocumentFragment();
    var selFragment = result.selection = document.createDocumentFragment();

    var customCursor = cm.options.$customCursor;
    if (customCursor) { primary = true; }
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      if (!primary && i == doc.sel.primIndex) { continue }
      var range = doc.sel.ranges[i];
      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
      var collapsed = range.empty();
      if (customCursor) {
        var head = customCursor(cm, range);
        if (head) { drawSelectionCursor(cm, head, curFragment); }
      } else if (collapsed || cm.options.showCursorWhenSelecting) {
        drawSelectionCursor(cm, range.head, curFragment);
      }
      if (!collapsed)
        { drawSelectionRange(cm, range, selFragment); }
    }
    return result
  }

  // Draws a cursor for the given range
  function drawSelectionCursor(cm, head, output) {
    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
    cursor.style.left = pos.left + "px";
    cursor.style.top = pos.top + "px";
    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

    if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
      var charPos = charCoords(cm, head, "div", null, null);
      var width = charPos.right - charPos.left;
      cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
    }

    if (pos.other) {
      // Secondary cursor, shown when on a 'jump' in bi-directional text
      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
      otherCursor.style.display = "";
      otherCursor.style.left = pos.other.left + "px";
      otherCursor.style.top = pos.other.top + "px";
      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
    }
  }

  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

  // Draws the given range as a highlighted selection
  function drawSelectionRange(cm, range, output) {
    var display = cm.display, doc = cm.doc;
    var fragment = document.createDocumentFragment();
    var padding = paddingH(cm.display), leftSide = padding.left;
    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
    var docLTR = doc.direction == "ltr";

    function add(left, top, width, bottom) {
      if (top < 0) { top = 0; }
      top = Math.round(top);
      bottom = Math.round(bottom);
      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
    }

    function drawForLine(line, fromArg, toArg) {
      var lineObj = getLine(doc, line);
      var lineLen = lineObj.text.length;
      var start, end;
      function coords(ch, bias) {
        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
      }

      function wrapX(pos, dir, side) {
        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
        return coords(ch, prop)[prop]
      }

      var order = getOrder(lineObj, doc.direction);
      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
        var ltr = dir == "ltr";
        var fromPos = coords(from, ltr ? "left" : "right");
        var toPos = coords(to - 1, ltr ? "right" : "left");

        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
        var first = i == 0, last = !order || i == order.length - 1;
        if (toPos.top - fromPos.top <= 3) { // Single line
          var openLeft = (docLTR ? openStart : openEnd) && first;
          var openRight = (docLTR ? openEnd : openStart) && last;
          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
          add(left, fromPos.top, right - left, fromPos.bottom);
        } else { // Multiple lines
          var topLeft, topRight, botLeft, botRight;
          if (ltr) {
            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
          } else {
            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
          }
          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
        }

        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
        if (cmpCoords(toPos, start) < 0) { start = toPos; }
        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
        if (cmpCoords(toPos, end) < 0) { end = toPos; }
      });
      return {start: start, end: end}
    }

    var sFrom = range.from(), sTo = range.to();
    if (sFrom.line == sTo.line) {
      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
    } else {
      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
      var singleVLine = visualLine(fromLine) == visualLine(toLine);
      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
      if (singleVLine) {
        if (leftEnd.top < rightStart.top - 2) {
          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
        } else {
          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
        }
      }
      if (leftEnd.bottom < rightStart.top)
        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
    }

    output.appendChild(fragment);
  }

  // Cursor-blinking
  function restartBlink(cm) {
    if (!cm.state.focused) { return }
    var display = cm.display;
    clearInterval(display.blinker);
    var on = true;
    display.cursorDiv.style.visibility = "";
    if (cm.options.cursorBlinkRate > 0)
      { display.blinker = setInterval(function () {
        if (!cm.hasFocus()) { onBlur(cm); }
        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
      }, cm.options.cursorBlinkRate); }
    else if (cm.options.cursorBlinkRate < 0)
      { display.cursorDiv.style.visibility = "hidden"; }
  }

  function ensureFocus(cm) {
    if (!cm.hasFocus()) {
      cm.display.input.focus();
      if (!cm.state.focused) { onFocus(cm); }
    }
  }

  function delayBlurEvent(cm) {
    cm.state.delayingBlurEvent = true;
    setTimeout(function () { if (cm.state.delayingBlurEvent) {
      cm.state.delayingBlurEvent = false;
      if (cm.state.focused) { onBlur(cm); }
    } }, 100);
  }

  function onFocus(cm, e) {
    if (cm.state.delayingBlurEvent && !cm.state.draggingText) { cm.state.delayingBlurEvent = false; }

    if (cm.options.readOnly == "nocursor") { return }
    if (!cm.state.focused) {
      signal(cm, "focus", cm, e);
      cm.state.focused = true;
      addClass(cm.display.wrapper, "CodeMirror-focused");
      // This test prevents this from firing when a context
      // menu is closed (since the input reset would kill the
      // select-all detection hack)
      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
        cm.display.input.reset();
        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
      }
      cm.display.input.receivedFocus();
    }
    restartBlink(cm);
  }
  function onBlur(cm, e) {
    if (cm.state.delayingBlurEvent) { return }

    if (cm.state.focused) {
      signal(cm, "blur", cm, e);
      cm.state.focused = false;
      rmClass(cm.display.wrapper, "CodeMirror-focused");
    }
    clearInterval(cm.display.blinker);
    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
  }

  // Read the actual heights of the rendered lines, and update their
  // stored heights to match.
  function updateHeightsInViewport(cm) {
    var display = cm.display;
    var prevBottom = display.lineDiv.offsetTop;
    var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
    var oldHeight = display.lineDiv.getBoundingClientRect().top;
    var mustScroll = 0;
    for (var i = 0; i < display.view.length; i++) {
      var cur = display.view[i], wrapping = cm.options.lineWrapping;
      var height = (void 0), width = 0;
      if (cur.hidden) { continue }
      oldHeight += cur.line.height;
      if (ie && ie_version < 8) {
        var bot = cur.node.offsetTop + cur.node.offsetHeight;
        height = bot - prevBottom;
        prevBottom = bot;
      } else {
        var box = cur.node.getBoundingClientRect();
        height = box.bottom - box.top;
        // Check that lines don't extend past the right of the current
        // editor width
        if (!wrapping && cur.text.firstChild)
          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
      }
      var diff = cur.line.height - height;
      if (diff > .005 || diff < -.005) {
        if (oldHeight < viewTop) { mustScroll -= diff; }
        updateLineHeight(cur.line, height);
        updateWidgetHeight(cur.line);
        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
          { updateWidgetHeight(cur.rest[j]); } }
      }
      if (width > cm.display.sizerWidth) {
        var chWidth = Math.ceil(width / charWidth(cm.display));
        if (chWidth > cm.display.maxLineLength) {
          cm.display.maxLineLength = chWidth;
          cm.display.maxLine = cur.line;
          cm.display.maxLineChanged = true;
        }
      }
    }
    if (Math.abs(mustScroll) > 2) { display.scroller.scrollTop += mustScroll; }
  }

  // Read and store the height of line widgets associated with the
  // given line.
  function updateWidgetHeight(line) {
    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
      var w = line.widgets[i], parent = w.node.parentNode;
      if (parent) { w.height = parent.offsetHeight; }
    } }
  }

  // Compute the lines that are visible in a given viewport (defaults
  // the the current scroll position). viewport may contain top,
  // height, and ensure (see op.scrollToPos) properties.
  function visibleLines(display, doc, viewport) {
    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
    top = Math.floor(top - paddingTop(display));
    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
    // forces those lines into the viewport (if possible).
    if (viewport && viewport.ensure) {
      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
      if (ensureFrom < from) {
        from = ensureFrom;
        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
        to = ensureTo;
      }
    }
    return {from: from, to: Math.max(to, from + 1)}
  }

  // SCROLLING THINGS INTO VIEW

  // If an editor sits on the top or bottom of the window, partially
  // scrolled out of view, this ensures that the cursor is visible.
  function maybeScrollWindow(cm, rect) {
    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
    if (rect.top + box.top < 0) { doScroll = true; }
    else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
    if (doScroll != null && !phantom) {
      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
      cm.display.lineSpace.appendChild(scrollNode);
      scrollNode.scrollIntoView(doScroll);
      cm.display.lineSpace.removeChild(scrollNode);
    }
  }

  // Scroll a given position into view (immediately), verifying that
  // it actually became visible (as line heights are accurately
  // measured, the position of something may 'drift' during drawing).
  function scrollPosIntoView(cm, pos, end, margin) {
    if (margin == null) { margin = 0; }
    var rect;
    if (!cm.options.lineWrapping && pos == end) {
      // Set pos and end to the cursor positions around the character pos sticks to
      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
      // If pos == Pos(_, 0, "before"), pos and end are unchanged
      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
    }
    for (var limit = 0; limit < 5; limit++) {
      var changed = false;
      var coords = cursorCoords(cm, pos);
      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
      rect = {left: Math.min(coords.left, endCoords.left),
              top: Math.min(coords.top, endCoords.top) - margin,
              right: Math.max(coords.left, endCoords.left),
              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
      var scrollPos = calculateScrollPos(cm, rect);
      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
      if (scrollPos.scrollTop != null) {
        updateScrollTop(cm, scrollPos.scrollTop);
        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
      }
      if (scrollPos.scrollLeft != null) {
        setScrollLeft(cm, scrollPos.scrollLeft);
        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
      }
      if (!changed) { break }
    }
    return rect
  }

  // Scroll a given set of coordinates into view (immediately).
  function scrollIntoView(cm, rect) {
    var scrollPos = calculateScrollPos(cm, rect);
    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
  }

  // Calculate a new scroll position needed to scroll the given
  // rectangle into view. Returns an object with scrollTop and
  // scrollLeft properties. When these are undefined, the
  // vertical/horizontal position does not need to be adjusted.
  function calculateScrollPos(cm, rect) {
    var display = cm.display, snapMargin = textHeight(cm.display);
    if (rect.top < 0) { rect.top = 0; }
    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
    var screen = displayHeight(cm), result = {};
    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
    var docBottom = cm.doc.height + paddingVert(display);
    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
    if (rect.top < screentop) {
      result.scrollTop = atTop ? 0 : rect.top;
    } else if (rect.bottom > screentop + screen) {
      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
      if (newTop != screentop) { result.scrollTop = newTop; }
    }

    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
    var tooWide = rect.right - rect.left > screenw;
    if (tooWide) { rect.right = rect.left + screenw; }
    if (rect.left < 10)
      { result.scrollLeft = 0; }
    else if (rect.left < screenleft)
      { result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10)); }
    else if (rect.right > screenw + screenleft - 3)
      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
    return result
  }

  // Store a relative adjustment to the scroll position in the current
  // operation (to be applied when the operation finishes).
  function addToScrollTop(cm, top) {
    if (top == null) { return }
    resolveScrollToPos(cm);
    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
  }

  // Make sure that at the end of the operation the current cursor is
  // shown.
  function ensureCursorVisible(cm) {
    resolveScrollToPos(cm);
    var cur = cm.getCursor();
    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
  }

  function scrollToCoords(cm, x, y) {
    if (x != null || y != null) { resolveScrollToPos(cm); }
    if (x != null) { cm.curOp.scrollLeft = x; }
    if (y != null) { cm.curOp.scrollTop = y; }
  }

  function scrollToRange(cm, range) {
    resolveScrollToPos(cm);
    cm.curOp.scrollToPos = range;
  }

  // When an operation has its scrollToPos property set, and another
  // scroll action is applied before the end of the operation, this
  // 'simulates' scrolling that position into view in a cheap way, so
  // that the effect of intermediate scroll commands is not ignored.
  function resolveScrollToPos(cm) {
    var range = cm.curOp.scrollToPos;
    if (range) {
      cm.curOp.scrollToPos = null;
      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
      scrollToCoordsRange(cm, from, to, range.margin);
    }
  }

  function scrollToCoordsRange(cm, from, to, margin) {
    var sPos = calculateScrollPos(cm, {
      left: Math.min(from.left, to.left),
      top: Math.min(from.top, to.top) - margin,
      right: Math.max(from.right, to.right),
      bottom: Math.max(from.bottom, to.bottom) + margin
    });
    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
  }

  // Sync the scrollable area and scrollbars, ensure the viewport
  // covers the visible area.
  function updateScrollTop(cm, val) {
    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
    setScrollTop(cm, val, true);
    if (gecko) { updateDisplaySimple(cm); }
    startWorker(cm, 100);
  }

  function setScrollTop(cm, val, forceScroll) {
    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
    cm.doc.scrollTop = val;
    cm.display.scrollbars.setScrollTop(val);
    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
  }

  // Sync scroller and scrollbar, ensure the gutter elements are
  // aligned.
  function setScrollLeft(cm, val, isScroller, forceScroll) {
    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
    cm.doc.scrollLeft = val;
    alignHorizontally(cm);
    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
    cm.display.scrollbars.setScrollLeft(val);
  }

  // SCROLLBARS

  // Prepare DOM reads needed to update the scrollbars. Done in one
  // shot to minimize update/measure roundtrips.
  function measureForScrollbars(cm) {
    var d = cm.display, gutterW = d.gutters.offsetWidth;
    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
    return {
      clientHeight: d.scroller.clientHeight,
      viewHeight: d.wrapper.clientHeight,
      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
      viewWidth: d.wrapper.clientWidth,
      barLeft: cm.options.fixedGutter ? gutterW : 0,
      docHeight: docH,
      scrollHeight: docH + scrollGap(cm) + d.barHeight,
      nativeBarWidth: d.nativeBarWidth,
      gutterWidth: gutterW
    }
  }

  var NativeScrollbars = function(place, scroll, cm) {
    this.cm = cm;
    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
    vert.tabIndex = horiz.tabIndex = -1;
    place(vert); place(horiz);

    on(vert, "scroll", function () {
      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
    });
    on(horiz, "scroll", function () {
      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
    });

    this.checkedZeroWidth = false;
    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
  };

  NativeScrollbars.prototype.update = function (measure) {
    var needsH = measure.scrollWidth > measure.clientWidth + 1;
    var needsV = measure.scrollHeight > measure.clientHeight + 1;
    var sWidth = measure.nativeBarWidth;

    if (needsV) {
      this.vert.style.display = "block";
      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
      // A bug in IE8 can cause this value to be negative, so guard it.
      this.vert.firstChild.style.height =
        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
    } else {
      this.vert.scrollTop = 0;
      this.vert.style.display = "";
      this.vert.firstChild.style.height = "0";
    }

    if (needsH) {
      this.horiz.style.display = "block";
      this.horiz.style.right = needsV ? sWidth + "px" : "0";
      this.horiz.style.left = measure.barLeft + "px";
      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
      this.horiz.firstChild.style.width =
        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
    } else {
      this.horiz.style.display = "";
      this.horiz.firstChild.style.width = "0";
    }

    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
      if (sWidth == 0) { this.zeroWidthHack(); }
      this.checkedZeroWidth = true;
    }

    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
  };

  NativeScrollbars.prototype.setScrollLeft = function (pos) {
    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
  };

  NativeScrollbars.prototype.setScrollTop = function (pos) {
    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
  };

  NativeScrollbars.prototype.zeroWidthHack = function () {
    var w = mac && !mac_geMountainLion ? "12px" : "18px";
    this.horiz.style.height = this.vert.style.width = w;
    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
    this.disableHoriz = new Delayed;
    this.disableVert = new Delayed;
  };

  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
    bar.style.pointerEvents = "auto";
    function maybeDisable() {
      // To find out whether the scrollbar is still visible, we
      // check whether the element under the pixel in the bottom
      // right corner of the scrollbar box is the scrollbar box
      // itself (when the bar is still visible) or its filler child
      // (when the bar is hidden). If it is still visible, we keep
      // it enabled, if it's hidden, we disable pointer events.
      var box = bar.getBoundingClientRect();
      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
      if (elt != bar) { bar.style.pointerEvents = "none"; }
      else { delay.set(1000, maybeDisable); }
    }
    delay.set(1000, maybeDisable);
  };

  NativeScrollbars.prototype.clear = function () {
    var parent = this.horiz.parentNode;
    parent.removeChild(this.horiz);
    parent.removeChild(this.vert);
  };

  var NullScrollbars = function () {};

  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
  NullScrollbars.prototype.setScrollLeft = function () {};
  NullScrollbars.prototype.setScrollTop = function () {};
  NullScrollbars.prototype.clear = function () {};

  function updateScrollbars(cm, measure) {
    if (!measure) { measure = measureForScrollbars(cm); }
    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
    updateScrollbarsInner(cm, measure);
    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
        { updateHeightsInViewport(cm); }
      updateScrollbarsInner(cm, measureForScrollbars(cm));
      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
    }
  }

  // Re-synchronize the fake scrollbars with the actual size of the
  // content.
  function updateScrollbarsInner(cm, measure) {
    var d = cm.display;
    var sizes = d.scrollbars.update(measure);

    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

    if (sizes.right && sizes.bottom) {
      d.scrollbarFiller.style.display = "block";
      d.scrollbarFiller.style.height = sizes.bottom + "px";
      d.scrollbarFiller.style.width = sizes.right + "px";
    } else { d.scrollbarFiller.style.display = ""; }
    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
      d.gutterFiller.style.display = "block";
      d.gutterFiller.style.height = sizes.bottom + "px";
      d.gutterFiller.style.width = measure.gutterWidth + "px";
    } else { d.gutterFiller.style.display = ""; }
  }

  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

  function initScrollbars(cm) {
    if (cm.display.scrollbars) {
      cm.display.scrollbars.clear();
      if (cm.display.scrollbars.addClass)
        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
    }

    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
      // Prevent clicks in the scrollbars from killing focus
      on(node, "mousedown", function () {
        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
      });
      node.setAttribute("cm-not-content", "true");
    }, function (pos, axis) {
      if (axis == "horizontal") { setScrollLeft(cm, pos); }
      else { updateScrollTop(cm, pos); }
    }, cm);
    if (cm.display.scrollbars.addClass)
      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  // Operations are used to wrap a series of changes to the editor
  // state in such a way that each change won't have to update the
  // cursor and display (which would be awkward, slow, and
  // error-prone). Instead, display updates are batched and then all
  // combined and executed at once.

  var nextOpId = 0;
  // Start a new operation.
  function startOperation(cm) {
    cm.curOp = {
      cm: cm,
      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
      startHeight: cm.doc.height, // Used to detect need to update scrollbar
      forceUpdate: false,      // Used to force a redraw
      updateInput: 0,       // Whether to reset the input textarea
      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
      changeObjs: null,        // Accumulated changes, for firing change events
      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
      selectionChanged: false, // Whether the selection needs to be redrawn
      updateMaxLine: false,    // Set when the widest line needs to be determined anew
      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
      scrollToPos: null,       // Used to scroll to a specific position
      focus: false,
      id: ++nextOpId,          // Unique ID
      markArrays: null         // Used by addMarkedSpan
    };
    pushOperation(cm.curOp);
  }

  // Finish an operation, updating the display and signalling delayed events
  function endOperation(cm) {
    var op = cm.curOp;
    if (op) { finishOperation(op, function (group) {
      for (var i = 0; i < group.ops.length; i++)
        { group.ops[i].cm.curOp = null; }
      endOperations(group);
    }); }
  }

  // The DOM updates done when an operation finishes are batched so
  // that the minimum number of relayouts are required.
  function endOperations(group) {
    var ops = group.ops;
    for (var i = 0; i < ops.length; i++) // Read DOM
      { endOperation_R1(ops[i]); }
    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
      { endOperation_W1(ops[i$1]); }
    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
      { endOperation_R2(ops[i$2]); }
    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
      { endOperation_W2(ops[i$3]); }
    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
      { endOperation_finish(ops[i$4]); }
  }

  function endOperation_R1(op) {
    var cm = op.cm, display = cm.display;
    maybeClipScrollbars(cm);
    if (op.updateMaxLine) { findMaxLine(cm); }

    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                         op.scrollToPos.to.line >= display.viewTo) ||
      display.maxLineChanged && cm.options.lineWrapping;
    op.update = op.mustUpdate &&
      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
  }

  function endOperation_W1(op) {
    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
  }

  function endOperation_R2(op) {
    var cm = op.cm, display = cm.display;
    if (op.updatedDisplay) { updateHeightsInViewport(cm); }

    op.barMeasure = measureForScrollbars(cm);

    // If the max line changed since it was last measured, measure it,
    // and ensure the document's width matches it.
    // updateDisplay_W2 will use these properties to do the actual resizing
    if (display.maxLineChanged && !cm.options.lineWrapping) {
      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
      cm.display.sizerWidth = op.adjustWidthTo;
      op.barMeasure.scrollWidth =
        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
    }

    if (op.updatedDisplay || op.selectionChanged)
      { op.preparedSelection = display.input.prepareSelection(); }
  }

  function endOperation_W2(op) {
    var cm = op.cm;

    if (op.adjustWidthTo != null) {
      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
      if (op.maxScrollLeft < cm.doc.scrollLeft)
        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
      cm.display.maxLineChanged = false;
    }

    var takeFocus = op.focus && op.focus == activeElt();
    if (op.preparedSelection)
      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
    if (op.updatedDisplay || op.startHeight != cm.doc.height)
      { updateScrollbars(cm, op.barMeasure); }
    if (op.updatedDisplay)
      { setDocumentHeight(cm, op.barMeasure); }

    if (op.selectionChanged) { restartBlink(cm); }

    if (cm.state.focused && op.updateInput)
      { cm.display.input.reset(op.typing); }
    if (takeFocus) { ensureFocus(op.cm); }
  }

  function endOperation_finish(op) {
    var cm = op.cm, display = cm.display, doc = cm.doc;

    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

    // Abort mouse wheel delta measurement, when scrolling explicitly
    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
      { display.wheelStartX = display.wheelStartY = null; }

    // Propagate the scroll position to the actual DOM scroller
    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
    // If we need to scroll a specific position into view, do so.
    if (op.scrollToPos) {
      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
      maybeScrollWindow(cm, rect);
    }

    // Fire events for markers that are hidden/unidden by editing or
    // undoing
    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
    if (hidden) { for (var i = 0; i < hidden.length; ++i)
      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

    if (display.wrapper.offsetHeight)
      { doc.scrollTop = cm.display.scroller.scrollTop; }

    // Fire change events, and delayed event handlers
    if (op.changeObjs)
      { signal(cm, "changes", cm, op.changeObjs); }
    if (op.update)
      { op.update.finish(); }
  }

  // Run the given function in an operation
  function runInOp(cm, f) {
    if (cm.curOp) { return f() }
    startOperation(cm);
    try { return f() }
    finally { endOperation(cm); }
  }
  // Wraps a function in an operation. Returns the wrapped function.
  function operation(cm, f) {
    return function() {
      if (cm.curOp) { return f.apply(cm, arguments) }
      startOperation(cm);
      try { return f.apply(cm, arguments) }
      finally { endOperation(cm); }
    }
  }
  // Used to add methods to editor and doc instances, wrapping them in
  // operations.
  function methodOp(f) {
    return function() {
      if (this.curOp) { return f.apply(this, arguments) }
      startOperation(this);
      try { return f.apply(this, arguments) }
      finally { endOperation(this); }
    }
  }
  function docMethodOp(f) {
    return function() {
      var cm = this.cm;
      if (!cm || cm.curOp) { return f.apply(this, arguments) }
      startOperation(cm);
      try { return f.apply(this, arguments) }
      finally { endOperation(cm); }
    }
  }

  // HIGHLIGHT WORKER

  function startWorker(cm, time) {
    if (cm.doc.highlightFrontier < cm.display.viewTo)
      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
  }

  function highlightWorker(cm) {
    var doc = cm.doc;
    if (doc.highlightFrontier >= cm.display.viewTo) { return }
    var end = +new Date + cm.options.workTime;
    var context = getContextBefore(cm, doc.highlightFrontier);
    var changedLines = [];

    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
      if (context.line >= cm.display.viewFrom) { // Visible
        var oldStyles = line.styles;
        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
        var highlighted = highlightLine(cm, line, context, true);
        if (resetState) { context.state = resetState; }
        line.styles = highlighted.styles;
        var oldCls = line.styleClasses, newCls = highlighted.classes;
        if (newCls) { line.styleClasses = newCls; }
        else if (oldCls) { line.styleClasses = null; }
        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
        if (ischange) { changedLines.push(context.line); }
        line.stateAfter = context.save();
        context.nextLine();
      } else {
        if (line.text.length <= cm.options.maxHighlightLength)
          { processLine(cm, line.text, context); }
        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
        context.nextLine();
      }
      if (+new Date > end) {
        startWorker(cm, cm.options.workDelay);
        return true
      }
    });
    doc.highlightFrontier = context.line;
    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
    if (changedLines.length) { runInOp(cm, function () {
      for (var i = 0; i < changedLines.length; i++)
        { regLineChange(cm, changedLines[i], "text"); }
    }); }
  }

  // DISPLAY DRAWING

  var DisplayUpdate = function(cm, viewport, force) {
    var display = cm.display;

    this.viewport = viewport;
    // Store some values that we'll need later (but don't want to force a relayout for)
    this.visible = visibleLines(display, cm.doc, viewport);
    this.editorIsHidden = !display.wrapper.offsetWidth;
    this.wrapperHeight = display.wrapper.clientHeight;
    this.wrapperWidth = display.wrapper.clientWidth;
    this.oldDisplayWidth = displayWidth(cm);
    this.force = force;
    this.dims = getDimensions(cm);
    this.events = [];
  };

  DisplayUpdate.prototype.signal = function (emitter, type) {
    if (hasHandler(emitter, type))
      { this.events.push(arguments); }
  };
  DisplayUpdate.prototype.finish = function () {
    for (var i = 0; i < this.events.length; i++)
      { signal.apply(null, this.events[i]); }
  };

  function maybeClipScrollbars(cm) {
    var display = cm.display;
    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
      display.heightForcer.style.height = scrollGap(cm) + "px";
      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
      display.scrollbarsClipped = true;
    }
  }

  function selectionSnapshot(cm) {
    if (cm.hasFocus()) { return null }
    var active = activeElt();
    if (!active || !contains(cm.display.lineDiv, active)) { return null }
    var result = {activeElt: active};
    if (window.getSelection) {
      var sel = window.getSelection();
      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
        result.anchorNode = sel.anchorNode;
        result.anchorOffset = sel.anchorOffset;
        result.focusNode = sel.focusNode;
        result.focusOffset = sel.focusOffset;
      }
    }
    return result
  }

  function restoreSelection(snapshot) {
    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
    snapshot.activeElt.focus();
    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) &&
        snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
      var sel = window.getSelection(), range = document.createRange();
      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
      sel.extend(snapshot.focusNode, snapshot.focusOffset);
    }
  }

  // Does the actual updating of the line display. Bails out
  // (returning false) when there is nothing to be done and forced is
  // false.
  function updateDisplayIfNeeded(cm, update) {
    var display = cm.display, doc = cm.doc;

    if (update.editorIsHidden) {
      resetView(cm);
      return false
    }

    // Bail out if the visible area is already rendered and nothing changed.
    if (!update.force &&
        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
        display.renderedView == display.view && countDirtyView(cm) == 0)
      { return false }

    if (maybeUpdateLineNumberWidth(cm)) {
      resetView(cm);
      update.dims = getDimensions(cm);
    }

    // Compute a suitable new viewport (from & to)
    var end = doc.first + doc.size;
    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
    if (sawCollapsedSpans) {
      from = visualLineNo(cm.doc, from);
      to = visualLineEndNo(cm.doc, to);
    }

    var different = from != display.viewFrom || to != display.viewTo ||
      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
    adjustView(cm, from, to);

    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
    // Position the mover div to align with the current scroll position
    cm.display.mover.style.top = display.viewOffset + "px";

    var toUpdate = countDirtyView(cm);
    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
      { return false }

    // For big changes, we hide the enclosing element during the
    // update, since that speeds up the operations on most browsers.
    var selSnapshot = selectionSnapshot(cm);
    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
    patchDisplay(cm, display.updateLineNumbers, update.dims);
    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
    display.renderedView = display.view;
    // There might have been a widget with a focused element that got
    // hidden or updated, if so re-focus it.
    restoreSelection(selSnapshot);

    // Prevent selection and cursors from interfering with the scroll
    // width and height.
    removeChildren(display.cursorDiv);
    removeChildren(display.selectionDiv);
    display.gutters.style.height = display.sizer.style.minHeight = 0;

    if (different) {
      display.lastWrapHeight = update.wrapperHeight;
      display.lastWrapWidth = update.wrapperWidth;
      startWorker(cm, 400);
    }

    display.updateLineNumbers = null;

    return true
  }

  function postUpdateDisplay(cm, update) {
    var viewport = update.viewport;

    for (var first = true;; first = false) {
      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
        // Clip forced viewport to actual scrollable area.
        if (viewport && viewport.top != null)
          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
        // Updated line heights might result in the drawn area not
        // actually covering the viewport. Keep looping until it does.
        update.visible = visibleLines(cm.display, cm.doc, viewport);
        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
          { break }
      } else if (first) {
        update.visible = visibleLines(cm.display, cm.doc, viewport);
      }
      if (!updateDisplayIfNeeded(cm, update)) { break }
      updateHeightsInViewport(cm);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.force = false;
    }

    update.signal(cm, "update", cm);
    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
    }
  }

  function updateDisplaySimple(cm, viewport) {
    var update = new DisplayUpdate(cm, viewport);
    if (updateDisplayIfNeeded(cm, update)) {
      updateHeightsInViewport(cm);
      postUpdateDisplay(cm, update);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.finish();
    }
  }

  // Sync the actual display DOM structure with display.view, removing
  // nodes for lines that are no longer in view, and creating the ones
  // that are not there yet, and updating the ones that are out of
  // date.
  function patchDisplay(cm, updateNumbersFrom, dims) {
    var display = cm.display, lineNumbers = cm.options.lineNumbers;
    var container = display.lineDiv, cur = container.firstChild;

    function rm(node) {
      var next = node.nextSibling;
      // Works around a throw-scroll bug in OS X Webkit
      if (webkit && mac && cm.display.currentWheelTarget == node)
        { node.style.display = "none"; }
      else
        { node.parentNode.removeChild(node); }
      return next
    }

    var view = display.view, lineN = display.viewFrom;
    // Loop over the elements in the view, syncing cur (the DOM nodes
    // in display.lineDiv) with the view as we go.
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
        var node = buildLineElement(cm, lineView, lineN, dims);
        container.insertBefore(node, cur);
      } else { // Already drawn
        while (cur != lineView.node) { cur = rm(cur); }
        var updateNumber = lineNumbers && updateNumbersFrom != null &&
          updateNumbersFrom <= lineN && lineView.lineNumber;
        if (lineView.changes) {
          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
          updateLineForChanges(cm, lineView, lineN, dims);
        }
        if (updateNumber) {
          removeChildren(lineView.lineNumber);
          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
        }
        cur = lineView.node.nextSibling;
      }
      lineN += lineView.size;
    }
    while (cur) { cur = rm(cur); }
  }

  function updateGutterSpace(display) {
    var width = display.gutters.offsetWidth;
    display.sizer.style.marginLeft = width + "px";
    // Send an event to consumers responding to changes in gutter width.
    signalLater(display, "gutterChanged", display);
  }

  function setDocumentHeight(cm, measure) {
    cm.display.sizer.style.minHeight = measure.docHeight + "px";
    cm.display.heightForcer.style.top = measure.docHeight + "px";
    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
  }

  // Re-align line numbers and gutter marks to compensate for
  // horizontal scrolling.
  function alignHorizontally(cm) {
    var display = cm.display, view = display.view;
    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
    var gutterW = display.gutters.offsetWidth, left = comp + "px";
    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
      if (cm.options.fixedGutter) {
        if (view[i].gutter)
          { view[i].gutter.style.left = left; }
        if (view[i].gutterBackground)
          { view[i].gutterBackground.style.left = left; }
      }
      var align = view[i].alignable;
      if (align) { for (var j = 0; j < align.length; j++)
        { align[j].style.left = left; } }
    } }
    if (cm.options.fixedGutter)
      { display.gutters.style.left = (comp + gutterW) + "px"; }
  }

  // Used to ensure that the line number gutter is still the right
  // size for the current document size. Returns true when an update
  // is needed.
  function maybeUpdateLineNumberWidth(cm) {
    if (!cm.options.lineNumbers) { return false }
    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
    if (last.length != display.lineNumChars) {
      var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
      display.lineGutter.style.width = "";
      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
      display.lineNumWidth = display.lineNumInnerWidth + padding;
      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
      display.lineGutter.style.width = display.lineNumWidth + "px";
      updateGutterSpace(cm.display);
      return true
    }
    return false
  }

  function getGutters(gutters, lineNumbers) {
    var result = [], sawLineNumbers = false;
    for (var i = 0; i < gutters.length; i++) {
      var name = gutters[i], style = null;
      if (typeof name != "string") { style = name.style; name = name.className; }
      if (name == "CodeMirror-linenumbers") {
        if (!lineNumbers) { continue }
        else { sawLineNumbers = true; }
      }
      result.push({className: name, style: style});
    }
    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
    return result
  }

  // Rebuild the gutter elements, ensure the margin to the left of the
  // code matches their width.
  function renderGutters(display) {
    var gutters = display.gutters, specs = display.gutterSpecs;
    removeChildren(gutters);
    display.lineGutter = null;
    for (var i = 0; i < specs.length; ++i) {
      var ref = specs[i];
      var className = ref.className;
      var style = ref.style;
      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
      if (style) { gElt.style.cssText = style; }
      if (className == "CodeMirror-linenumbers") {
        display.lineGutter = gElt;
        gElt.style.width = (display.lineNumWidth || 1) + "px";
      }
    }
    gutters.style.display = specs.length ? "" : "none";
    updateGutterSpace(display);
  }

  function updateGutters(cm) {
    renderGutters(cm.display);
    regChange(cm);
    alignHorizontally(cm);
  }

  // The display handles the DOM integration, both for input reading
  // and content drawing. It holds references to DOM nodes and
  // display-related state.

  function Display(place, doc, input, options) {
    var d = this;
    this.input = input;

    // Covers bottom-right square when both scrollbars are present.
    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
    d.scrollbarFiller.setAttribute("cm-not-content", "true");
    // Covers bottom of gutter when coverGutterNextToScrollbar is on
    // and h scrollbar is present.
    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
    d.gutterFiller.setAttribute("cm-not-content", "true");
    // Will contain the actual code, positioned to cover the viewport.
    d.lineDiv = eltP("div", null, "CodeMirror-code");
    // Elements are added to these to represent selection and cursors.
    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
    // A visibility: hidden element used to find the size of things.
    d.measure = elt("div", null, "CodeMirror-measure");
    // When lines outside of the viewport are measured, they are drawn in this.
    d.lineMeasure = elt("div", null, "CodeMirror-measure");
    // Wraps everything that needs to exist inside the vertically-padded coordinate system
    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                      null, "position: relative; outline: none");
    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
    // Moved around its parent to cover visible view.
    d.mover = elt("div", [lines], null, "position: relative");
    // Set to the height of the document, allowing scrolling.
    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
    d.sizerWidth = null;
    // Behavior of elts with overflow: auto and padding is
    // inconsistent across browsers. This is used to ensure the
    // scrollable area is big enough.
    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
    // Will contain the gutters, if any.
    d.gutters = elt("div", null, "CodeMirror-gutters");
    d.lineGutter = null;
    // Actual scrollable element.
    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
    d.scroller.setAttribute("tabIndex", "-1");
    // The element in which the editor lives.
    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

    // This attribute is respected by automatic translation systems such as Google Translate,
    // and may also be respected by tools used by human translators.
    d.wrapper.setAttribute('translate', 'no');

    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

    if (place) {
      if (place.appendChild) { place.appendChild(d.wrapper); }
      else { place(d.wrapper); }
    }

    // Current rendered range (may be bigger than the view window).
    d.viewFrom = d.viewTo = doc.first;
    d.reportedViewFrom = d.reportedViewTo = doc.first;
    // Information about the rendered lines.
    d.view = [];
    d.renderedView = null;
    // Holds info about a single rendered line when it was rendered
    // for measurement, while not in view.
    d.externalMeasured = null;
    // Empty space (in pixels) above the view
    d.viewOffset = 0;
    d.lastWrapHeight = d.lastWrapWidth = 0;
    d.updateLineNumbers = null;

    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
    d.scrollbarsClipped = false;

    // Used to only resize the line number gutter when necessary (when
    // the amount of lines crosses a boundary that makes its width change)
    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
    // Set to true when a non-horizontal-scrolling line widget is
    // added. As an optimization, line widget aligning is skipped when
    // this is false.
    d.alignWidgets = false;

    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

    // Tracks the maximum line length so that the horizontal scrollbar
    // can be kept static when scrolling.
    d.maxLine = null;
    d.maxLineLength = 0;
    d.maxLineChanged = false;

    // Used for measuring wheel scrolling granularity
    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

    // True when shift is held down.
    d.shift = false;

    // Used to track whether anything happened since the context menu
    // was opened.
    d.selForContextMenu = null;

    d.activeTouch = null;

    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
    renderGutters(d);

    input.init(d);
  }

  // Since the delta values reported on mouse wheel events are
  // unstandardized between browsers and even browser versions, and
  // generally horribly unpredictable, this code starts by measuring
  // the scroll effect that the first few mouse wheel events have,
  // and, from that, detects the way it can convert deltas to pixel
  // offsets afterwards.
  //
  // The reason we want to know the amount a wheel event will scroll
  // is that it gives us a chance to update the display before the
  // actual scrolling happens, reducing flickering.

  var wheelSamples = 0, wheelPixelsPerUnit = null;
  // Fill in a browser-detected starting value on browsers where we
  // know one. These don't have to be accurate -- the result of them
  // being wrong would just be a slight flicker on the first wheel
  // scroll (if it is large enough).
  if (ie) { wheelPixelsPerUnit = -.53; }
  else if (gecko) { wheelPixelsPerUnit = 15; }
  else if (chrome) { wheelPixelsPerUnit = -.7; }
  else if (safari) { wheelPixelsPerUnit = -1/3; }

  function wheelEventDelta(e) {
    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
    else if (dy == null) { dy = e.wheelDelta; }
    return {x: dx, y: dy}
  }
  function wheelEventPixels(e) {
    var delta = wheelEventDelta(e);
    delta.x *= wheelPixelsPerUnit;
    delta.y *= wheelPixelsPerUnit;
    return delta
  }

  function onScrollWheel(cm, e) {
    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
    var pixelsPerUnit = wheelPixelsPerUnit;
    if (e.deltaMode === 0) {
      dx = e.deltaX;
      dy = e.deltaY;
      pixelsPerUnit = 1;
    }

    var display = cm.display, scroll = display.scroller;
    // Quit if there's nothing to scroll here
    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
    if (!(dx && canScrollX || dy && canScrollY)) { return }

    // Webkit browsers on OS X abort momentum scrolls when the target
    // of the scroll event is removed from the scrollable element.
    // This hack (see related code in patchDisplay) makes sure the
    // element is kept around.
    if (dy && mac && webkit) {
      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
        for (var i = 0; i < view.length; i++) {
          if (view[i].node == cur) {
            cm.display.currentWheelTarget = cur;
            break outer
          }
        }
      }
    }

    // On some browsers, horizontal scrolling will cause redraws to
    // happen before the gutter has been realigned, causing it to
    // wriggle around in a most unseemly way. When we have an
    // estimated pixels/delta value, we just handle horizontal
    // scrolling entirely here. It'll be slightly off from native, but
    // better than glitching out.
    if (dx && !gecko && !presto && pixelsPerUnit != null) {
      if (dy && canScrollY)
        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit)); }
      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
      // Only prevent default scrolling if vertical scrolling is
      // actually possible. Otherwise, it causes vertical scroll
      // jitter on OSX trackpads when deltaX is small and deltaY
      // is large (issue #3579)
      if (!dy || (dy && canScrollY))
        { e_preventDefault(e); }
      display.wheelStartX = null; // Abort measurement, if in progress
      return
    }

    // 'Project' the visible viewport to cover the area that is being
    // scrolled into view (if we know enough to estimate it).
    if (dy && pixelsPerUnit != null) {
      var pixels = dy * pixelsPerUnit;
      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
      updateDisplaySimple(cm, {top: top, bottom: bot});
    }

    if (wheelSamples < 20 && e.deltaMode !== 0) {
      if (display.wheelStartX == null) {
        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
        display.wheelDX = dx; display.wheelDY = dy;
        setTimeout(function () {
          if (display.wheelStartX == null) { return }
          var movedX = scroll.scrollLeft - display.wheelStartX;
          var movedY = scroll.scrollTop - display.wheelStartY;
          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
            (movedX && display.wheelDX && movedX / display.wheelDX);
          display.wheelStartX = display.wheelStartY = null;
          if (!sample) { return }
          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
          ++wheelSamples;
        }, 200);
      } else {
        display.wheelDX += dx; display.wheelDY += dy;
      }
    }
  }

  // Selection objects are immutable. A new one is created every time
  // the selection changes. A selection is one or more non-overlapping
  // (and non-touching) ranges, sorted, and an integer that indicates
  // which one is the primary selection (the one that's scrolled into
  // view, that getCursor returns, etc).
  var Selection = function(ranges, primIndex) {
    this.ranges = ranges;
    this.primIndex = primIndex;
  };

  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

  Selection.prototype.equals = function (other) {
    if (other == this) { return true }
    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
    for (var i = 0; i < this.ranges.length; i++) {
      var here = this.ranges[i], there = other.ranges[i];
      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
    }
    return true
  };

  Selection.prototype.deepCopy = function () {
    var out = [];
    for (var i = 0; i < this.ranges.length; i++)
      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
    return new Selection(out, this.primIndex)
  };

  Selection.prototype.somethingSelected = function () {
    for (var i = 0; i < this.ranges.length; i++)
      { if (!this.ranges[i].empty()) { return true } }
    return false
  };

  Selection.prototype.contains = function (pos, end) {
    if (!end) { end = pos; }
    for (var i = 0; i < this.ranges.length; i++) {
      var range = this.ranges[i];
      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
        { return i }
    }
    return -1
  };

  var Range = function(anchor, head) {
    this.anchor = anchor; this.head = head;
  };

  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

  // Take an unsorted, potentially overlapping set of ranges, and
  // build a selection out of it. 'Consumes' ranges array (modifying
  // it).
  function normalizeSelection(cm, ranges, primIndex) {
    var mayTouch = cm && cm.options.selectionsMayTouch;
    var prim = ranges[primIndex];
    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
    primIndex = indexOf(ranges, prim);
    for (var i = 1; i < ranges.length; i++) {
      var cur = ranges[i], prev = ranges[i - 1];
      var diff = cmp(prev.to(), cur.from());
      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
        if (i <= primIndex) { --primIndex; }
        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
      }
    }
    return new Selection(ranges, primIndex)
  }

  function simpleSelection(anchor, head) {
    return new Selection([new Range(anchor, head || anchor)], 0)
  }

  // Compute the position of the end of a change (its 'to' property
  // refers to the pre-change end).
  function changeEnd(change) {
    if (!change.text) { return change.to }
    return Pos(change.from.line + change.text.length - 1,
               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
  }

  // Adjust a position to refer to the post-change position of the
  // same text, or the end of the change if the change covers it.
  function adjustForChange(pos, change) {
    if (cmp(pos, change.from) < 0) { return pos }
    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
    return Pos(line, ch)
  }

  function computeSelAfterChange(doc, change) {
    var out = [];
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      var range = doc.sel.ranges[i];
      out.push(new Range(adjustForChange(range.anchor, change),
                         adjustForChange(range.head, change)));
    }
    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
  }

  function offsetPos(pos, old, nw) {
    if (pos.line == old.line)
      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
    else
      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
  }

  // Used by replaceSelections to allow moving the selection to the
  // start or around the replaced test. Hint may be "start" or "around".
  function computeReplacedSel(doc, changes, hint) {
    var out = [];
    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
    for (var i = 0; i < changes.length; i++) {
      var change = changes[i];
      var from = offsetPos(change.from, oldPrev, newPrev);
      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
      oldPrev = change.to;
      newPrev = to;
      if (hint == "around") {
        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
        out[i] = new Range(inv ? to : from, inv ? from : to);
      } else {
        out[i] = new Range(from, from);
      }
    }
    return new Selection(out, doc.sel.primIndex)
  }

  // Used to get the editor into a consistent state again when options change.

  function loadMode(cm) {
    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
    resetModeState(cm);
  }

  function resetModeState(cm) {
    cm.doc.iter(function (line) {
      if (line.stateAfter) { line.stateAfter = null; }
      if (line.styles) { line.styles = null; }
    });
    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
    startWorker(cm, 100);
    cm.state.modeGen++;
    if (cm.curOp) { regChange(cm); }
  }

  // DOCUMENT DATA STRUCTURE

  // By default, updates that start and end at the beginning of a line
  // are treated specially, in order to make the association of line
  // widgets and marker elements with the text behave more intuitive.
  function isWholeLineUpdate(doc, change) {
    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
  }

  // Perform a change on the document data structure.
  function updateDoc(doc, change, markedSpans, estimateHeight) {
    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
    function update(line, text, spans) {
      updateLine(line, text, spans, estimateHeight);
      signalLater(line, "change", line, change);
    }
    function linesFor(start, end) {
      var result = [];
      for (var i = start; i < end; ++i)
        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
      return result
    }

    var from = change.from, to = change.to, text = change.text;
    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

    // Adjust the line structure
    if (change.full) {
      doc.insert(0, linesFor(0, text.length));
      doc.remove(text.length, doc.size - text.length);
    } else if (isWholeLineUpdate(doc, change)) {
      // This is a whole-line replace. Treated specially to make
      // sure line objects move the way they are supposed to.
      var added = linesFor(0, text.length - 1);
      update(lastLine, lastLine.text, lastSpans);
      if (nlines) { doc.remove(from.line, nlines); }
      if (added.length) { doc.insert(from.line, added); }
    } else if (firstLine == lastLine) {
      if (text.length == 1) {
        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
      } else {
        var added$1 = linesFor(1, text.length - 1);
        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
        doc.insert(from.line + 1, added$1);
      }
    } else if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
      doc.remove(from.line + 1, nlines);
    } else {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
      var added$2 = linesFor(1, text.length - 1);
      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
      doc.insert(from.line + 1, added$2);
    }

    signalLater(doc, "change", doc, change);
  }

  // Call f for all linked documents.
  function linkedDocs(doc, f, sharedHistOnly) {
    function propagate(doc, skip, sharedHist) {
      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
        var rel = doc.linked[i];
        if (rel.doc == skip) { continue }
        var shared = sharedHist && rel.sharedHist;
        if (sharedHistOnly && !shared) { continue }
        f(rel.doc, shared);
        propagate(rel.doc, doc, shared);
      } }
    }
    propagate(doc, null, true);
  }

  // Attach a document to an editor.
  function attachDoc(cm, doc) {
    if (doc.cm) { throw new Error("This document is already in use.") }
    cm.doc = doc;
    doc.cm = cm;
    estimateLineHeights(cm);
    loadMode(cm);
    setDirectionClass(cm);
    cm.options.direction = doc.direction;
    if (!cm.options.lineWrapping) { findMaxLine(cm); }
    cm.options.mode = doc.modeOption;
    regChange(cm);
  }

  function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
  }

  function directionChanged(cm) {
    runInOp(cm, function () {
      setDirectionClass(cm);
      regChange(cm);
    });
  }

  function History(prev) {
    // Arrays of change events and selections. Doing something adds an
    // event to done and clears undo. Undoing moves events from done
    // to undone, redoing moves them in the other direction.
    this.done = []; this.undone = [];
    this.undoDepth = prev ? prev.undoDepth : Infinity;
    // Used to track when changes can be merged into a single undo
    // event
    this.lastModTime = this.lastSelTime = 0;
    this.lastOp = this.lastSelOp = null;
    this.lastOrigin = this.lastSelOrigin = null;
    // Used by the isClean() method
    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
  }

  // Create a history change event from an updateDoc-style change
  // object.
  function historyChangeFromChange(doc, change) {
    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
    return histChange
  }

  // Pop all selection events off the end of a history array. Stop at
  // a change event.
  function clearSelectionEvents(array) {
    while (array.length) {
      var last = lst(array);
      if (last.ranges) { array.pop(); }
      else { break }
    }
  }

  // Find the top change event in the history. Pop off selection
  // events that are in the way.
  function lastChangeEvent(hist, force) {
    if (force) {
      clearSelectionEvents(hist.done);
      return lst(hist.done)
    } else if (hist.done.length && !lst(hist.done).ranges) {
      return lst(hist.done)
    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
      hist.done.pop();
      return lst(hist.done)
    }
  }

  // Register a change in the history. Merges changes that are within
  // a single operation, or are close together with an origin that
  // allows merging (starting with "+") into a single event.
  function addChangeToHistory(doc, change, selAfter, opId) {
    var hist = doc.history;
    hist.undone.length = 0;
    var time = +new Date, cur;
    var last;

    if ((hist.lastOp == opId ||
         hist.lastOrigin == change.origin && change.origin &&
         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
          change.origin.charAt(0) == "*")) &&
        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
      // Merge this change into the last event
      last = lst(cur.changes);
      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
        // Optimized case for simple insertion -- don't want to add
        // new changesets for every character typed
        last.to = changeEnd(change);
      } else {
        // Add new sub-event
        cur.changes.push(historyChangeFromChange(doc, change));
      }
    } else {
      // Can not be merged, start a new event.
      var before = lst(hist.done);
      if (!before || !before.ranges)
        { pushSelectionToHistory(doc.sel, hist.done); }
      cur = {changes: [historyChangeFromChange(doc, change)],
             generation: hist.generation};
      hist.done.push(cur);
      while (hist.done.length > hist.undoDepth) {
        hist.done.shift();
        if (!hist.done[0].ranges) { hist.done.shift(); }
      }
    }
    hist.done.push(selAfter);
    hist.generation = ++hist.maxGeneration;
    hist.lastModTime = hist.lastSelTime = time;
    hist.lastOp = hist.lastSelOp = opId;
    hist.lastOrigin = hist.lastSelOrigin = change.origin;

    if (!last) { signal(doc, "historyAdded"); }
  }

  function selectionEventCanBeMerged(doc, origin, prev, sel) {
    var ch = origin.charAt(0);
    return ch == "*" ||
      ch == "+" &&
      prev.ranges.length == sel.ranges.length &&
      prev.somethingSelected() == sel.somethingSelected() &&
      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
  }

  // Called whenever the selection changes, sets the new selection as
  // the pending selection in the history, and pushes the old pending
  // selection into the 'done' array when it was significantly
  // different (in number of selected ranges, emptiness, or time).
  function addSelectionToHistory(doc, sel, opId, options) {
    var hist = doc.history, origin = options && options.origin;

    // A new event is started when the previous origin does not match
    // the current, or the origins don't allow matching. Origins
    // starting with * are always merged, those starting with + are
    // merged when similar and close together in time.
    if (opId == hist.lastSelOp ||
        (origin && hist.lastSelOrigin == origin &&
         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
      { hist.done[hist.done.length - 1] = sel; }
    else
      { pushSelectionToHistory(sel, hist.done); }

    hist.lastSelTime = +new Date;
    hist.lastSelOrigin = origin;
    hist.lastSelOp = opId;
    if (options && options.clearRedo !== false)
      { clearSelectionEvents(hist.undone); }
  }

  function pushSelectionToHistory(sel, dest) {
    var top = lst(dest);
    if (!(top && top.ranges && top.equals(sel)))
      { dest.push(sel); }
  }

  // Used to store marked span information in the history.
  function attachLocalSpans(doc, change, from, to) {
    var existing = change["spans_" + doc.id], n = 0;
    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
      if (line.markedSpans)
        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
      ++n;
    });
  }

  // When un/re-doing restores text containing marked spans, those
  // that have been explicitly cleared should not be restored.
  function removeClearedSpans(spans) {
    if (!spans) { return null }
    var out;
    for (var i = 0; i < spans.length; ++i) {
      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
      else if (out) { out.push(spans[i]); }
    }
    return !out ? spans : out.length ? out : null
  }

  // Retrieve and filter the old marked spans stored in a change event.
  function getOldSpans(doc, change) {
    var found = change["spans_" + doc.id];
    if (!found) { return null }
    var nw = [];
    for (var i = 0; i < change.text.length; ++i)
      { nw.push(removeClearedSpans(found[i])); }
    return nw
  }

  // Used for un/re-doing changes from the history. Combines the
  // result of computing the existing spans with the set of spans that
  // existed in the history (so that deleting around a span and then
  // undoing brings back the span).
  function mergeOldSpans(doc, change) {
    var old = getOldSpans(doc, change);
    var stretched = stretchSpansOverChange(doc, change);
    if (!old) { return stretched }
    if (!stretched) { return old }

    for (var i = 0; i < old.length; ++i) {
      var oldCur = old[i], stretchCur = stretched[i];
      if (oldCur && stretchCur) {
        spans: for (var j = 0; j < stretchCur.length; ++j) {
          var span = stretchCur[j];
          for (var k = 0; k < oldCur.length; ++k)
            { if (oldCur[k].marker == span.marker) { continue spans } }
          oldCur.push(span);
        }
      } else if (stretchCur) {
        old[i] = stretchCur;
      }
    }
    return old
  }

  // Used both to provide a JSON-safe object in .getHistory, and, when
  // detaching a document, to split the history in two
  function copyHistoryArray(events, newGroup, instantiateSel) {
    var copy = [];
    for (var i = 0; i < events.length; ++i) {
      var event = events[i];
      if (event.ranges) {
        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
        continue
      }
      var changes = event.changes, newChanges = [];
      copy.push({changes: newChanges});
      for (var j = 0; j < changes.length; ++j) {
        var change = changes[j], m = (void 0);
        newChanges.push({from: change.from, to: change.to, text: change.text});
        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
          if (indexOf(newGroup, Number(m[1])) > -1) {
            lst(newChanges)[prop] = change[prop];
            delete change[prop];
          }
        } } }
      }
    }
    return copy
  }

  // The 'scroll' parameter given to many of these indicated whether
  // the new cursor position should be scrolled into view after
  // modifying the selection.

  // If shift is held or the extend flag is set, extends a range to
  // include a given position (and optionally a second position).
  // Otherwise, simply returns the range between the given positions.
  // Used for cursor motion and such.
  function extendRange(range, head, other, extend) {
    if (extend) {
      var anchor = range.anchor;
      if (other) {
        var posBefore = cmp(head, anchor) < 0;
        if (posBefore != (cmp(other, anchor) < 0)) {
          anchor = head;
          head = other;
        } else if (posBefore != (cmp(head, other) < 0)) {
          head = other;
        }
      }
      return new Range(anchor, head)
    } else {
      return new Range(other || head, head)
    }
  }

  // Extend the primary selection range, discard the rest.
  function extendSelection(doc, head, other, options, extend) {
    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
  }

  // Extend all selections (pos is an array of selections with length
  // equal the number of selections)
  function extendSelections(doc, heads, options) {
    var out = [];
    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
    for (var i = 0; i < doc.sel.ranges.length; i++)
      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
    setSelection(doc, newSel, options);
  }

  // Updates a single range in the selection.
  function replaceOneSelection(doc, i, range, options) {
    var ranges = doc.sel.ranges.slice(0);
    ranges[i] = range;
    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
  }

  // Reset the selection to a single range.
  function setSimpleSelection(doc, anchor, head, options) {
    setSelection(doc, simpleSelection(anchor, head), options);
  }

  // Give beforeSelectionChange handlers a change to influence a
  // selection update.
  function filterSelectionChange(doc, sel, options) {
    var obj = {
      ranges: sel.ranges,
      update: function(ranges) {
        this.ranges = [];
        for (var i = 0; i < ranges.length; i++)
          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                     clipPos(doc, ranges[i].head)); }
      },
      origin: options && options.origin
    };
    signal(doc, "beforeSelectionChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
    else { return sel }
  }

  function setSelectionReplaceHistory(doc, sel, options) {
    var done = doc.history.done, last = lst(done);
    if (last && last.ranges) {
      done[done.length - 1] = sel;
      setSelectionNoUndo(doc, sel, options);
    } else {
      setSelection(doc, sel, options);
    }
  }

  // Set a new selection.
  function setSelection(doc, sel, options) {
    setSelectionNoUndo(doc, sel, options);
    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
  }

  function setSelectionNoUndo(doc, sel, options) {
    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
      { sel = filterSelectionChange(doc, sel, options); }

    var bias = options && options.bias ||
      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor")
      { ensureCursorVisible(doc.cm); }
  }

  function setSelectionInner(doc, sel) {
    if (sel.equals(doc.sel)) { return }

    doc.sel = sel;

    if (doc.cm) {
      doc.cm.curOp.updateInput = 1;
      doc.cm.curOp.selectionChanged = true;
      signalCursorActivity(doc.cm);
    }
    signalLater(doc, "cursorActivity", doc);
  }

  // Verify that the selection does not partially select any atomic
  // marked ranges.
  function reCheckSelection(doc) {
    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
  }

  // Return a selection that does not partially select any atomic
  // ranges.
  function skipAtomicInSelection(doc, sel, bias, mayClear) {
    var out;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range = sel.ranges[i];
      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
      if (out || newAnchor != range.anchor || newHead != range.head) {
        if (!out) { out = sel.ranges.slice(0, i); }
        out[i] = new Range(newAnchor, newHead);
      }
    }
    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
  }

  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
    var line = getLine(doc, pos.line);
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var sp = line.markedSpans[i], m = sp.marker;

      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
      // is with selectLeft/Right
      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;

      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
        if (mayClear) {
          signal(m, "beforeCursorEnter");
          if (m.explicitlyCleared) {
            if (!line.markedSpans) { break }
            else {--i; continue}
          }
        }
        if (!m.atomic) { continue }

        if (oldPos) {
          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
          if (dir < 0 ? preventCursorRight : preventCursorLeft)
            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
        }

        var far = m.find(dir < 0 ? -1 : 1);
        if (dir < 0 ? preventCursorLeft : preventCursorRight)
          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
      }
    } }
    return pos
  }

  // Ensure a given position is not inside an atomic range.
  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
    var dir = bias || 1;
    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
    if (!found) {
      doc.cantEdit = true;
      return Pos(doc.first, 0)
    }
    return found
  }

  function movePos(doc, pos, dir, line) {
    if (dir < 0 && pos.ch == 0) {
      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
      else { return null }
    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
      else { return null }
    } else {
      return new Pos(pos.line, pos.ch + dir)
    }
  }

  function selectAll(cm) {
    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
  }

  // UPDATING

  // Allow "beforeChange" event handlers to influence a change
  function filterChange(doc, change, update) {
    var obj = {
      canceled: false,
      from: change.from,
      to: change.to,
      text: change.text,
      origin: change.origin,
      cancel: function () { return obj.canceled = true; }
    };
    if (update) { obj.update = function (from, to, text, origin) {
      if (from) { obj.from = clipPos(doc, from); }
      if (to) { obj.to = clipPos(doc, to); }
      if (text) { obj.text = text; }
      if (origin !== undefined) { obj.origin = origin; }
    }; }
    signal(doc, "beforeChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

    if (obj.canceled) {
      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
      return null
    }
    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
  }

  // Apply a change to a document, and add it to the document's
  // history, and propagating it to all linked documents.
  function makeChange(doc, change, ignoreReadOnly) {
    if (doc.cm) {
      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
      if (doc.cm.state.suppressEdits) { return }
    }

    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
      change = filterChange(doc, change, true);
      if (!change) { return }
    }

    // Possibly split or suppress the update based on the presence
    // of read-only spans in its range.
    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
    if (split) {
      for (var i = split.length - 1; i >= 0; --i)
        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
    } else {
      makeChangeInner(doc, change);
    }
  }

  function makeChangeInner(doc, change) {
    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
    var selAfter = computeSelAfterChange(doc, change);
    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
    var rebased = [];

    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
    });
  }

  // Revert a change stored in a document's history.
  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
    var suppress = doc.cm && doc.cm.state.suppressEdits;
    if (suppress && !allowSelectionOnly) { return }

    var hist = doc.history, event, selAfter = doc.sel;
    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

    // Verify that there is a useable event (so that ctrl-z won't
    // needlessly clear selection events)
    var i = 0;
    for (; i < source.length; i++) {
      event = source[i];
      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
        { break }
    }
    if (i == source.length) { return }
    hist.lastOrigin = hist.lastSelOrigin = null;

    for (;;) {
      event = source.pop();
      if (event.ranges) {
        pushSelectionToHistory(event, dest);
        if (allowSelectionOnly && !event.equals(doc.sel)) {
          setSelection(doc, event, {clearRedo: false});
          return
        }
        selAfter = event;
      } else if (suppress) {
        source.push(event);
        return
      } else { break }
    }

    // Build up a reverse change object to add to the opposite history
    // stack (redo when undoing, and vice versa).
    var antiChanges = [];
    pushSelectionToHistory(selAfter, dest);
    dest.push({changes: antiChanges, generation: hist.generation});
    hist.generation = event.generation || ++hist.maxGeneration;

    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

    var loop = function ( i ) {
      var change = event.changes[i];
      change.origin = type;
      if (filter && !filterChange(doc, change, false)) {
        source.length = 0;
        return {}
      }

      antiChanges.push(historyChangeFromChange(doc, change));

      var after = i ? computeSelAfterChange(doc, change) : lst(source);
      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
      var rebased = [];

      // Propagate to the linked documents
      linkedDocs(doc, function (doc, sharedHist) {
        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
          rebaseHist(doc.history, change);
          rebased.push(doc.history);
        }
        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
      });
    };

    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
      var returned = loop( i$1 );

      if ( returned ) return returned.v;
    }
  }

  // Sub-views need their line numbers shifted when text is added
  // above or below them in the parent document.
  function shiftDoc(doc, distance) {
    if (distance == 0) { return }
    doc.first += distance;
    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
      Pos(range.anchor.line + distance, range.anchor.ch),
      Pos(range.head.line + distance, range.head.ch)
    ); }), doc.sel.primIndex);
    if (doc.cm) {
      regChange(doc.cm, doc.first, doc.first - distance, distance);
      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
        { regLineChange(doc.cm, l, "gutter"); }
    }
  }

  // More lower-level change function, handling only a single document
  // (not linked ones).
  function makeChangeSingleDoc(doc, change, selAfter, spans) {
    if (doc.cm && !doc.cm.curOp)
      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

    if (change.to.line < doc.first) {
      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
      return
    }
    if (change.from.line > doc.lastLine()) { return }

    // Clip the change to the size of this doc
    if (change.from.line < doc.first) {
      var shift = change.text.length - 1 - (doc.first - change.from.line);
      shiftDoc(doc, shift);
      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
                text: [lst(change.text)], origin: change.origin};
    }
    var last = doc.lastLine();
    if (change.to.line > last) {
      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
                text: [change.text[0]], origin: change.origin};
    }

    change.removed = getBetween(doc, change.from, change.to);

    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
    else { updateDoc(doc, change, spans); }
    setSelectionNoUndo(doc, selAfter, sel_dontScroll);

    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
      { doc.cantEdit = false; }
  }

  // Handle the interaction of a change to a document with the editor
  // that this document is part of.
  function makeChangeSingleDocInEditor(cm, change, spans) {
    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

    var recomputeMaxLength = false, checkWidthStart = from.line;
    if (!cm.options.lineWrapping) {
      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
      doc.iter(checkWidthStart, to.line + 1, function (line) {
        if (line == display.maxLine) {
          recomputeMaxLength = true;
          return true
        }
      });
    }

    if (doc.sel.contains(change.from, change.to) > -1)
      { signalCursorActivity(cm); }

    updateDoc(doc, change, spans, estimateHeight(cm));

    if (!cm.options.lineWrapping) {
      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
        var len = lineLength(line);
        if (len > display.maxLineLength) {
          display.maxLine = line;
          display.maxLineLength = len;
          display.maxLineChanged = true;
          recomputeMaxLength = false;
        }
      });
      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
    }

    retreatFrontier(doc, from.line);
    startWorker(cm, 400);

    var lendiff = change.text.length - (to.line - from.line) - 1;
    // Remember that these lines changed, for updating the display
    if (change.full)
      { regChange(cm); }
    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
      { regLineChange(cm, from.line, "text"); }
    else
      { regChange(cm, from.line, to.line + 1, lendiff); }

    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
    if (changeHandler || changesHandler) {
      var obj = {
        from: from, to: to,
        text: change.text,
        removed: change.removed,
        origin: change.origin
      };
      if (changeHandler) { signalLater(cm, "change", cm, obj); }
      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
    }
    cm.display.selForContextMenu = null;
  }

  function replaceRange(doc, code, from, to, origin) {
    var assign;

    if (!to) { to = from; }
    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
    if (typeof code == "string") { code = doc.splitLines(code); }
    makeChange(doc, {from: from, to: to, text: code, origin: origin});
  }

  // Rebasing/resetting history to deal with externally-sourced changes

  function rebaseHistSelSingle(pos, from, to, diff) {
    if (to < pos.line) {
      pos.line += diff;
    } else if (from < pos.line) {
      pos.line = from;
      pos.ch = 0;
    }
  }

  // Tries to rebase an array of history events given a change in the
  // document. If the change touches the same lines as the event, the
  // event, and everything 'behind' it, is discarded. If the change is
  // before the event, the event's positions are updated. Uses a
  // copy-on-write scheme for the positions, to avoid having to
  // reallocate them all on every rebase, but also avoid problems with
  // shared position objects being unsafely updated.
  function rebaseHistArray(array, from, to, diff) {
    for (var i = 0; i < array.length; ++i) {
      var sub = array[i], ok = true;
      if (sub.ranges) {
        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
        for (var j = 0; j < sub.ranges.length; j++) {
          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
        }
        continue
      }
      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
        var cur = sub.changes[j$1];
        if (to < cur.from.line) {
          cur.from = Pos(cur.from.line + diff, cur.from.ch);
          cur.to = Pos(cur.to.line + diff, cur.to.ch);
        } else if (from <= cur.to.line) {
          ok = false;
          break
        }
      }
      if (!ok) {
        array.splice(0, i + 1);
        i = 0;
      }
    }
  }

  function rebaseHist(hist, change) {
    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
    rebaseHistArray(hist.done, from, to, diff);
    rebaseHistArray(hist.undone, from, to, diff);
  }

  // Utility for applying a change to a line by handle or number,
  // returning the number and optionally registering the line as
  // changed.
  function changeLine(doc, handle, changeType, op) {
    var no = handle, line = handle;
    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
    else { no = lineNo(handle); }
    if (no == null) { return null }
    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
    return line
  }

  // The document is represented as a BTree consisting of leaves, with
  // chunk of lines in them, and branches, with up to ten leaves or
  // other branch nodes below them. The top node is always a branch
  // node, and is the document object itself (meaning it has
  // additional methods and properties).
  //
  // All nodes have parent links. The tree is used both to go from
  // line numbers to line objects, and to go from objects to numbers.
  // It also indexes by height, and is used to convert between height
  // and line object, and to find the total height of the document.
  //
  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

  function LeafChunk(lines) {
    this.lines = lines;
    this.parent = null;
    var height = 0;
    for (var i = 0; i < lines.length; ++i) {
      lines[i].parent = this;
      height += lines[i].height;
    }
    this.height = height;
  }

  LeafChunk.prototype = {
    chunkSize: function() { return this.lines.length },

    // Remove the n lines at offset 'at'.
    removeInner: function(at, n) {
      for (var i = at, e = at + n; i < e; ++i) {
        var line = this.lines[i];
        this.height -= line.height;
        cleanUpLine(line);
        signalLater(line, "delete");
      }
      this.lines.splice(at, n);
    },

    // Helper used to collapse a small branch into a single leaf.
    collapse: function(lines) {
      lines.push.apply(lines, this.lines);
    },

    // Insert the given array of lines at offset 'at', count them as
    // having the given height.
    insertInner: function(at, lines, height) {
      this.height += height;
      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
    },

    // Used to iterate over a part of the tree.
    iterN: function(at, n, op) {
      for (var e = at + n; at < e; ++at)
        { if (op(this.lines[at])) { return true } }
    }
  };

  function BranchChunk(children) {
    this.children = children;
    var size = 0, height = 0;
    for (var i = 0; i < children.length; ++i) {
      var ch = children[i];
      size += ch.chunkSize(); height += ch.height;
      ch.parent = this;
    }
    this.size = size;
    this.height = height;
    this.parent = null;
  }

  BranchChunk.prototype = {
    chunkSize: function() { return this.size },

    removeInner: function(at, n) {
      this.size -= n;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var rm = Math.min(n, sz - at), oldHeight = child.height;
          child.removeInner(at, rm);
          this.height -= oldHeight - child.height;
          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
          if ((n -= rm) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
      // If the result is smaller than 25 lines, ensure that it is a
      // single leaf node.
      if (this.size - n < 25 &&
          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
        var lines = [];
        this.collapse(lines);
        this.children = [new LeafChunk(lines)];
        this.children[0].parent = this;
      }
    },

    collapse: function(lines) {
      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
    },

    insertInner: function(at, lines, height) {
      this.size += lines.length;
      this.height += height;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at <= sz) {
          child.insertInner(at, lines, height);
          if (child.lines && child.lines.length > 50) {
            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
            var remaining = child.lines.length % 25 + 25;
            for (var pos = remaining; pos < child.lines.length;) {
              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
              child.height -= leaf.height;
              this.children.splice(++i, 0, leaf);
              leaf.parent = this;
            }
            child.lines = child.lines.slice(0, remaining);
            this.maybeSpill();
          }
          break
        }
        at -= sz;
      }
    },

    // When a node has grown, check whether it should be split.
    maybeSpill: function() {
      if (this.children.length <= 10) { return }
      var me = this;
      do {
        var spilled = me.children.splice(me.children.length - 5, 5);
        var sibling = new BranchChunk(spilled);
        if (!me.parent) { // Become the parent node
          var copy = new BranchChunk(me.children);
          copy.parent = me;
          me.children = [copy, sibling];
          me = copy;
       } else {
          me.size -= sibling.size;
          me.height -= sibling.height;
          var myIndex = indexOf(me.parent.children, me);
          me.parent.children.splice(myIndex + 1, 0, sibling);
        }
        sibling.parent = me.parent;
      } while (me.children.length > 10)
      me.parent.maybeSpill();
    },

    iterN: function(at, n, op) {
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var used = Math.min(n, sz - at);
          if (child.iterN(at, used, op)) { return true }
          if ((n -= used) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
    }
  };

  // Line widgets are block elements displayed above or below a line.

  var LineWidget = function(doc, node, options) {
    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
      { this[opt] = options[opt]; } } }
    this.doc = doc;
    this.node = node;
  };

  LineWidget.prototype.clear = function () {
    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
    if (no == null || !ws) { return }
    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
    if (!ws.length) { line.widgets = null; }
    var height = widgetHeight(this);
    updateLineHeight(line, Math.max(0, line.height - height));
    if (cm) {
      runInOp(cm, function () {
        adjustScrollWhenAboveVisible(cm, line, -height);
        regLineChange(cm, no, "widget");
      });
      signalLater(cm, "lineWidgetCleared", cm, this, no);
    }
  };

  LineWidget.prototype.changed = function () {
      var this$1 = this;

    var oldH = this.height, cm = this.doc.cm, line = this.line;
    this.height = null;
    var diff = widgetHeight(this) - oldH;
    if (!diff) { return }
    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
    if (cm) {
      runInOp(cm, function () {
        cm.curOp.forceUpdate = true;
        adjustScrollWhenAboveVisible(cm, line, diff);
        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
      });
    }
  };
  eventMixin(LineWidget);

  function adjustScrollWhenAboveVisible(cm, line, diff) {
    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
      { addToScrollTop(cm, diff); }
  }

  function addLineWidget(doc, handle, node, options) {
    var widget = new LineWidget(doc, node, options);
    var cm = doc.cm;
    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
    changeLine(doc, handle, "widget", function (line) {
      var widgets = line.widgets || (line.widgets = []);
      if (widget.insertAt == null) { widgets.push(widget); }
      else { widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget); }
      widget.line = line;
      if (cm && !lineIsHidden(doc, line)) {
        var aboveVisible = heightAtLine(line) < doc.scrollTop;
        updateLineHeight(line, line.height + widgetHeight(widget));
        if (aboveVisible) { addToScrollTop(cm, widget.height); }
        cm.curOp.forceUpdate = true;
      }
      return true
    });
    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
    return widget
  }

  // TEXTMARKERS

  // Created with markText and setBookmark methods. A TextMarker is a
  // handle that can be used to clear or find a marked position in the
  // document. Line objects hold arrays (markedSpans) containing
  // {from, to, marker} object pointing to such marker objects, and
  // indicating that such a marker is present on that line. Multiple
  // lines may point to the same marker when it spans across lines.
  // The spans will have null for their from/to properties when the
  // marker continues beyond the start/end of the line. Markers have
  // links back to the lines they currently touch.

  // Collapsed markers have unique ids, in order to be able to order
  // them, which is needed for uniquely determining an outer marker
  // when they overlap (they may nest, but not partially overlap).
  var nextMarkerId = 0;

  var TextMarker = function(doc, type) {
    this.lines = [];
    this.type = type;
    this.doc = doc;
    this.id = ++nextMarkerId;
  };

  // Clear the marker.
  TextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    var cm = this.doc.cm, withOp = cm && !cm.curOp;
    if (withOp) { startOperation(cm); }
    if (hasHandler(this, "clear")) {
      var found = this.find();
      if (found) { signalLater(this, "clear", found.from, found.to); }
    }
    var min = null, max = null;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
      else if (cm) {
        if (span.to != null) { max = lineNo(line); }
        if (span.from != null) { min = lineNo(line); }
      }
      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
        { updateLineHeight(line, textHeight(cm.display)); }
    }
    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
      if (len > cm.display.maxLineLength) {
        cm.display.maxLine = visual;
        cm.display.maxLineLength = len;
        cm.display.maxLineChanged = true;
      }
    } }

    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
    this.lines.length = 0;
    this.explicitlyCleared = true;
    if (this.atomic && this.doc.cantEdit) {
      this.doc.cantEdit = false;
      if (cm) { reCheckSelection(cm.doc); }
    }
    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
    if (withOp) { endOperation(cm); }
    if (this.parent) { this.parent.clear(); }
  };

  // Find the position of the marker in the document. Returns a {from,
  // to} object by default. Side can be passed to get a specific side
  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
  // Pos objects returned contain a line object, rather than a line
  // number (used to prevent looking up the same line twice).
  TextMarker.prototype.find = function (side, lineObj) {
    if (side == null && this.type == "bookmark") { side = 1; }
    var from, to;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (span.from != null) {
        from = Pos(lineObj ? line : lineNo(line), span.from);
        if (side == -1) { return from }
      }
      if (span.to != null) {
        to = Pos(lineObj ? line : lineNo(line), span.to);
        if (side == 1) { return to }
      }
    }
    return from && {from: from, to: to}
  };

  // Signals that the marker's widget changed, and surrounding layout
  // should be recomputed.
  TextMarker.prototype.changed = function () {
      var this$1 = this;

    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
    if (!pos || !cm) { return }
    runInOp(cm, function () {
      var line = pos.line, lineN = lineNo(pos.line);
      var view = findViewForLine(cm, lineN);
      if (view) {
        clearLineMeasurementCacheFor(view);
        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
      }
      cm.curOp.updateMaxLine = true;
      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
        var oldHeight = widget.height;
        widget.height = null;
        var dHeight = widgetHeight(widget) - oldHeight;
        if (dHeight)
          { updateLineHeight(line, line.height + dHeight); }
      }
      signalLater(cm, "markerChanged", cm, this$1);
    });
  };

  TextMarker.prototype.attachLine = function (line) {
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp;
      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
    }
    this.lines.push(line);
  };

  TextMarker.prototype.detachLine = function (line) {
    this.lines.splice(indexOf(this.lines, line), 1);
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp
      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
    }
  };
  eventMixin(TextMarker);

  // Create a marker, wire it up to the right lines, and
  function markText(doc, from, to, options, type) {
    // Shared markers (across linked documents) are handled separately
    // (markTextShared will call out to this again, once per
    // document).
    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
    // Ensure we are in an operation.
    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

    var marker = new TextMarker(doc, type), diff = cmp(from, to);
    if (options) { copyObj(options, marker, false); }
    // Don't connect empty markers unless clearWhenEmpty is false
    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
      { return marker }
    if (marker.replacedWith) {
      // Showing up as a widget implies collapsed (widget replaces text)
      marker.collapsed = true;
      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
    }
    if (marker.collapsed) {
      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
      seeCollapsedSpans();
    }

    if (marker.addToHistory)
      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

    var curLine = from.line, cm = doc.cm, updateMaxLine;
    doc.iter(curLine, to.line + 1, function (line) {
      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
        { updateMaxLine = true; }
      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
      addMarkedSpan(line, new MarkedSpan(marker,
                                         curLine == from.line ? from.ch : null,
                                         curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
      ++curLine;
    });
    // lineIsHidden depends on the presence of the spans, so needs a second pass
    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
    }); }

    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

    if (marker.readOnly) {
      seeReadOnlySpans();
      if (doc.history.done.length || doc.history.undone.length)
        { doc.clearHistory(); }
    }
    if (marker.collapsed) {
      marker.id = ++nextMarkerId;
      marker.atomic = true;
    }
    if (cm) {
      // Sync editor state
      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
      if (marker.collapsed)
        { regChange(cm, from.line, to.line + 1); }
      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
               marker.attributes || marker.title)
        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
      if (marker.atomic) { reCheckSelection(cm.doc); }
      signalLater(cm, "markerAdded", cm, marker);
    }
    return marker
  }

  // SHARED TEXTMARKERS

  // A shared marker spans multiple linked documents. It is
  // implemented as a meta-marker-object controlling multiple normal
  // markers.
  var SharedTextMarker = function(markers, primary) {
    this.markers = markers;
    this.primary = primary;
    for (var i = 0; i < markers.length; ++i)
      { markers[i].parent = this; }
  };

  SharedTextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    this.explicitlyCleared = true;
    for (var i = 0; i < this.markers.length; ++i)
      { this.markers[i].clear(); }
    signalLater(this, "clear");
  };

  SharedTextMarker.prototype.find = function (side, lineObj) {
    return this.primary.find(side, lineObj)
  };
  eventMixin(SharedTextMarker);

  function markTextShared(doc, from, to, options, type) {
    options = copyObj(options);
    options.shared = false;
    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
    var widget = options.widgetNode;
    linkedDocs(doc, function (doc) {
      if (widget) { options.widgetNode = widget.cloneNode(true); }
      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
      for (var i = 0; i < doc.linked.length; ++i)
        { if (doc.linked[i].isParent) { return } }
      primary = lst(markers);
    });
    return new SharedTextMarker(markers, primary)
  }

  function findSharedMarkers(doc) {
    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
  }

  function copySharedMarkers(doc, markers) {
    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i], pos = marker.find();
      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
      if (cmp(mFrom, mTo)) {
        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
        marker.markers.push(subMark);
        subMark.parent = marker;
      }
    }
  }

  function detachSharedMarkers(markers) {
    var loop = function ( i ) {
      var marker = markers[i], linked = [marker.primary.doc];
      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
      for (var j = 0; j < marker.markers.length; j++) {
        var subMarker = marker.markers[j];
        if (indexOf(linked, subMarker.doc) == -1) {
          subMarker.parent = null;
          marker.markers.splice(j--, 1);
        }
      }
    };

    for (var i = 0; i < markers.length; i++) loop( i );
  }

  var nextDocId = 0;
  var Doc = function(text, mode, firstLine, lineSep, direction) {
    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
    if (firstLine == null) { firstLine = 0; }

    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
    this.first = firstLine;
    this.scrollTop = this.scrollLeft = 0;
    this.cantEdit = false;
    this.cleanGeneration = 1;
    this.modeFrontier = this.highlightFrontier = firstLine;
    var start = Pos(firstLine, 0);
    this.sel = simpleSelection(start);
    this.history = new History(null);
    this.id = ++nextDocId;
    this.modeOption = mode;
    this.lineSep = lineSep;
    this.direction = (direction == "rtl") ? "rtl" : "ltr";
    this.extend = false;

    if (typeof text == "string") { text = this.splitLines(text); }
    updateDoc(this, {from: start, to: start, text: text});
    setSelection(this, simpleSelection(start), sel_dontScroll);
  };

  Doc.prototype = createObj(BranchChunk.prototype, {
    constructor: Doc,
    // Iterate over the document. Supports two forms -- with only one
    // argument, it calls that for each line in the document. With
    // three, it iterates over the range given by the first two (with
    // the second being non-inclusive).
    iter: function(from, to, op) {
      if (op) { this.iterN(from - this.first, to - from, op); }
      else { this.iterN(this.first, this.first + this.size, from); }
    },

    // Non-public interface for adding and removing lines.
    insert: function(at, lines) {
      var height = 0;
      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
      this.insertInner(at - this.first, lines, height);
    },
    remove: function(at, n) { this.removeInner(at - this.first, n); },

    // From here, the methods are part of the public interface. Most
    // are also available from CodeMirror (editor) instances.

    getValue: function(lineSep) {
      var lines = getLines(this, this.first, this.first + this.size);
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },
    setValue: docMethodOp(function(code) {
      var top = Pos(this.first, 0), last = this.first + this.size - 1;
      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                        text: this.splitLines(code), origin: "setValue", full: true}, true);
      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
      setSelection(this, simpleSelection(top), sel_dontScroll);
    }),
    replaceRange: function(code, from, to, origin) {
      from = clipPos(this, from);
      to = to ? clipPos(this, to) : from;
      replaceRange(this, code, from, to, origin);
    },
    getRange: function(from, to, lineSep) {
      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
      if (lineSep === false) { return lines }
      if (lineSep === '') { return lines.join('') }
      return lines.join(lineSep || this.lineSeparator())
    },

    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
    getLineNumber: function(line) {return lineNo(line)},

    getLineHandleVisualStart: function(line) {
      if (typeof line == "number") { line = getLine(this, line); }
      return visualLine(line)
    },

    lineCount: function() {return this.size},
    firstLine: function() {return this.first},
    lastLine: function() {return this.first + this.size - 1},

    clipPos: function(pos) {return clipPos(this, pos)},

    getCursor: function(start) {
      var range = this.sel.primary(), pos;
      if (start == null || start == "head") { pos = range.head; }
      else if (start == "anchor") { pos = range.anchor; }
      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
      else { pos = range.from(); }
      return pos
    },
    listSelections: function() { return this.sel.ranges },
    somethingSelected: function() {return this.sel.somethingSelected()},

    setCursor: docMethodOp(function(line, ch, options) {
      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
    }),
    setSelection: docMethodOp(function(anchor, head, options) {
      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
    }),
    extendSelection: docMethodOp(function(head, other, options) {
      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
    }),
    extendSelections: docMethodOp(function(heads, options) {
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    extendSelectionsBy: docMethodOp(function(f, options) {
      var heads = map(this.sel.ranges, f);
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    setSelections: docMethodOp(function(ranges, primary, options) {
      if (!ranges.length) { return }
      var out = [];
      for (var i = 0; i < ranges.length; i++)
        { out[i] = new Range(clipPos(this, ranges[i].anchor),
                           clipPos(this, ranges[i].head || ranges[i].anchor)); }
      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
      setSelection(this, normalizeSelection(this.cm, out, primary), options);
    }),
    addSelection: docMethodOp(function(anchor, head, options) {
      var ranges = this.sel.ranges.slice(0);
      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
    }),

    getSelection: function(lineSep) {
      var ranges = this.sel.ranges, lines;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        lines = lines ? lines.concat(sel) : sel;
      }
      if (lineSep === false) { return lines }
      else { return lines.join(lineSep || this.lineSeparator()) }
    },
    getSelections: function(lineSep) {
      var parts = [], ranges = this.sel.ranges;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
        parts[i] = sel;
      }
      return parts
    },
    replaceSelection: function(code, collapse, origin) {
      var dup = [];
      for (var i = 0; i < this.sel.ranges.length; i++)
        { dup[i] = code; }
      this.replaceSelections(dup, collapse, origin || "+input");
    },
    replaceSelections: docMethodOp(function(code, collapse, origin) {
      var changes = [], sel = this.sel;
      for (var i = 0; i < sel.ranges.length; i++) {
        var range = sel.ranges[i];
        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
      }
      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
        { makeChange(this, changes[i$1]); }
      if (newSel) { setSelectionReplaceHistory(this, newSel); }
      else if (this.cm) { ensureCursorVisible(this.cm); }
    }),
    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

    setExtending: function(val) {this.extend = val;},
    getExtending: function() {return this.extend},

    historySize: function() {
      var hist = this.history, done = 0, undone = 0;
      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
      return {undo: done, redo: undone}
    },
    clearHistory: function() {
      var this$1 = this;

      this.history = new History(this.history);
      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
    },

    markClean: function() {
      this.cleanGeneration = this.changeGeneration(true);
    },
    changeGeneration: function(forceSplit) {
      if (forceSplit)
        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
      return this.history.generation
    },
    isClean: function (gen) {
      return this.history.generation == (gen || this.cleanGeneration)
    },

    getHistory: function() {
      return {done: copyHistoryArray(this.history.done),
              undone: copyHistoryArray(this.history.undone)}
    },
    setHistory: function(histData) {
      var hist = this.history = new History(this.history);
      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
    },

    setGutterMarker: docMethodOp(function(line, gutterID, value) {
      return changeLine(this, line, "gutter", function (line) {
        var markers = line.gutterMarkers || (line.gutterMarkers = {});
        markers[gutterID] = value;
        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
        return true
      })
    }),

    clearGutter: docMethodOp(function(gutterID) {
      var this$1 = this;

      this.iter(function (line) {
        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
          changeLine(this$1, line, "gutter", function () {
            line.gutterMarkers[gutterID] = null;
            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
            return true
          });
        }
      });
    }),

    lineInfo: function(line) {
      var n;
      if (typeof line == "number") {
        if (!isLine(this, line)) { return null }
        n = line;
        line = getLine(this, line);
        if (!line) { return null }
      } else {
        n = lineNo(line);
        if (n == null) { return null }
      }
      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
              widgets: line.widgets}
    },

    addLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        if (!line[prop]) { line[prop] = cls; }
        else if (classTest(cls).test(line[prop])) { return false }
        else { line[prop] += " " + cls; }
        return true
      })
    }),
    removeLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        var cur = line[prop];
        if (!cur) { return false }
        else if (cls == null) { line[prop] = null; }
        else {
          var found = cur.match(classTest(cls));
          if (!found) { return false }
          var end = found.index + found[0].length;
          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
        }
        return true
      })
    }),

    addLineWidget: docMethodOp(function(handle, node, options) {
      return addLineWidget(this, handle, node, options)
    }),
    removeLineWidget: function(widget) { widget.clear(); },

    markText: function(from, to, options) {
      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
    },
    setBookmark: function(pos, options) {
      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                      insertLeft: options && options.insertLeft,
                      clearWhenEmpty: false, shared: options && options.shared,
                      handleMouseEvents: options && options.handleMouseEvents};
      pos = clipPos(this, pos);
      return markText(this, pos, pos, realOpts, "bookmark")
    },
    findMarksAt: function(pos) {
      pos = clipPos(this, pos);
      var markers = [], spans = getLine(this, pos.line).markedSpans;
      if (spans) { for (var i = 0; i < spans.length; ++i) {
        var span = spans[i];
        if ((span.from == null || span.from <= pos.ch) &&
            (span.to == null || span.to >= pos.ch))
          { markers.push(span.marker.parent || span.marker); }
      } }
      return markers
    },
    findMarks: function(from, to, filter) {
      from = clipPos(this, from); to = clipPos(this, to);
      var found = [], lineNo = from.line;
      this.iter(from.line, to.line + 1, function (line) {
        var spans = line.markedSpans;
        if (spans) { for (var i = 0; i < spans.length; i++) {
          var span = spans[i];
          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
                span.from == null && lineNo != from.line ||
                span.from != null && lineNo == to.line && span.from >= to.ch) &&
              (!filter || filter(span.marker)))
            { found.push(span.marker.parent || span.marker); }
        } }
        ++lineNo;
      });
      return found
    },
    getAllMarks: function() {
      var markers = [];
      this.iter(function (line) {
        var sps = line.markedSpans;
        if (sps) { for (var i = 0; i < sps.length; ++i)
          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
      });
      return markers
    },

    posFromIndex: function(off) {
      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
      this.iter(function (line) {
        var sz = line.text.length + sepSize;
        if (sz > off) { ch = off; return true }
        off -= sz;
        ++lineNo;
      });
      return clipPos(this, Pos(lineNo, ch))
    },
    indexFromPos: function (coords) {
      coords = clipPos(this, coords);
      var index = coords.ch;
      if (coords.line < this.first || coords.ch < 0) { return 0 }
      var sepSize = this.lineSeparator().length;
      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
        index += line.text.length + sepSize;
      });
      return index
    },

    copy: function(copyHistory) {
      var doc = new Doc(getLines(this, this.first, this.first + this.size),
                        this.modeOption, this.first, this.lineSep, this.direction);
      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
      doc.sel = this.sel;
      doc.extend = false;
      if (copyHistory) {
        doc.history.undoDepth = this.history.undoDepth;
        doc.setHistory(this.getHistory());
      }
      return doc
    },

    linkedDoc: function(options) {
      if (!options) { options = {}; }
      var from = this.first, to = this.first + this.size;
      if (options.from != null && options.from > from) { from = options.from; }
      if (options.to != null && options.to < to) { to = options.to; }
      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
      if (options.sharedHist) { copy.history = this.history
      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
      copySharedMarkers(copy, findSharedMarkers(this));
      return copy
    },
    unlinkDoc: function(other) {
      if (other instanceof CodeMirror) { other = other.doc; }
      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
        var link = this.linked[i];
        if (link.doc != other) { continue }
        this.linked.splice(i, 1);
        other.unlinkDoc(this);
        detachSharedMarkers(findSharedMarkers(this));
        break
      } }
      // If the histories were shared, split them again
      if (other.history == this.history) {
        var splitIds = [other.id];
        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
        other.history = new History(null);
        other.history.done = copyHistoryArray(this.history.done, splitIds);
        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
      }
    },
    iterLinkedDocs: function(f) {linkedDocs(this, f);},

    getMode: function() {return this.mode},
    getEditor: function() {return this.cm},

    splitLines: function(str) {
      if (this.lineSep) { return str.split(this.lineSep) }
      return splitLinesAuto(str)
    },
    lineSeparator: function() { return this.lineSep || "\n" },

    setDirection: docMethodOp(function (dir) {
      if (dir != "rtl") { dir = "ltr"; }
      if (dir == this.direction) { return }
      this.direction = dir;
      this.iter(function (line) { return line.order = null; });
      if (this.cm) { directionChanged(this.cm); }
    })
  });

  // Public alias.
  Doc.prototype.eachLine = Doc.prototype.iter;

  // Kludge to work around strange IE behavior where it'll sometimes
  // re-fire a series of drag-related events right after the drop (#1551)
  var lastDrop = 0;

  function onDrop(e) {
    var cm = this;
    clearDragCursor(cm);
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
      { return }
    e_preventDefault(e);
    if (ie) { lastDrop = +new Date; }
    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
    if (!pos || cm.isReadOnly()) { return }
    // Might be a file drop, in which case we simply extract the text
    // and insert it.
    if (files && files.length && window.FileReader && window.File) {
      var n = files.length, text = Array(n), read = 0;
      var markAsReadAndPasteIfAllFilesAreRead = function () {
        if (++read == n) {
          operation(cm, function () {
            pos = clipPos(cm.doc, pos);
            var change = {from: pos, to: pos,
                          text: cm.doc.splitLines(
                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
                          origin: "paste"};
            makeChange(cm.doc, change);
            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
          })();
        }
      };
      var readTextFromFile = function (file, i) {
        if (cm.options.allowDropFileTypes &&
            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
          markAsReadAndPasteIfAllFilesAreRead();
          return
        }
        var reader = new FileReader;
        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
        reader.onload = function () {
          var content = reader.result;
          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
            markAsReadAndPasteIfAllFilesAreRead();
            return
          }
          text[i] = content;
          markAsReadAndPasteIfAllFilesAreRead();
        };
        reader.readAsText(file);
      };
      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
    } else { // Normal drop
      // Don't do a replace if the drop happened inside of the selected text.
      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
        cm.state.draggingText(e);
        // Ensure the editor is re-focused
        setTimeout(function () { return cm.display.input.focus(); }, 20);
        return
      }
      try {
        var text$1 = e.dataTransfer.getData("Text");
        if (text$1) {
          var selected;
          if (cm.state.draggingText && !cm.state.draggingText.copy)
            { selected = cm.listSelections(); }
          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
          cm.replaceSelection(text$1, "around", "paste");
          cm.display.input.focus();
        }
      }
      catch(e$1){}
    }
  }

  function onDragStart(cm, e) {
    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

    e.dataTransfer.setData("Text", cm.getSelection());
    e.dataTransfer.effectAllowed = "copyMove";

    // Use dummy image instead of default browsers image.
    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
    if (e.dataTransfer.setDragImage && !safari) {
      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      if (presto) {
        img.width = img.height = 1;
        cm.display.wrapper.appendChild(img);
        // Force a relayout, or Opera won't use our image for some obscure reason
        img._top = img.offsetTop;
      }
      e.dataTransfer.setDragImage(img, 0, 0);
      if (presto) { img.parentNode.removeChild(img); }
    }
  }

  function onDragOver(cm, e) {
    var pos = posFromMouse(cm, e);
    if (!pos) { return }
    var frag = document.createDocumentFragment();
    drawSelectionCursor(cm, pos, frag);
    if (!cm.display.dragCursor) {
      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
    }
    removeChildrenAndAdd(cm.display.dragCursor, frag);
  }

  function clearDragCursor(cm) {
    if (cm.display.dragCursor) {
      cm.display.lineSpace.removeChild(cm.display.dragCursor);
      cm.display.dragCursor = null;
    }
  }

  // These must be handled carefully, because naively registering a
  // handler for each editor will cause the editors to never be
  // garbage collected.

  function forEachCodeMirror(f) {
    if (!document.getElementsByClassName) { return }
    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
    for (var i = 0; i < byClass.length; i++) {
      var cm = byClass[i].CodeMirror;
      if (cm) { editors.push(cm); }
    }
    if (editors.length) { editors[0].operation(function () {
      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
    }); }
  }

  var globalsRegistered = false;
  function ensureGlobalHandlers() {
    if (globalsRegistered) { return }
    registerGlobalHandlers();
    globalsRegistered = true;
  }
  function registerGlobalHandlers() {
    // When the window resizes, we need to refresh active editors.
    var resizeTimer;
    on(window, "resize", function () {
      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
        resizeTimer = null;
        forEachCodeMirror(onResize);
      }, 100); }
    });
    // When the window loses focus, we want to show the editor as blurred
    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
  }
  // Called when the window resizes
  function onResize(cm) {
    var d = cm.display;
    // Might be a text scaling operation, clear size caches.
    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
    d.scrollbarsClipped = false;
    cm.setSize();
  }

  var keyNames = {
    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
  };

  // Number keys
  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
  // Alphabetic keys
  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
  // Function keys
  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

  var keyMap = {};

  keyMap.basic = {
    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
    "Esc": "singleSelection"
  };
  // Note that the save and find-related commands aren't defined by
  // default. User code or addons can define them. Unknown commands
  // are simply ignored.
  keyMap.pcDefault = {
    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
    "fallthrough": "basic"
  };
  // Very basic readline/emacs-style bindings, which are standard on Mac.
  keyMap.emacsy = {
    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
  };
  keyMap.macDefault = {
    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
    "fallthrough": ["basic", "emacsy"]
  };
  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

  // KEYMAP DISPATCH

  function normalizeKeyName(name) {
    var parts = name.split(/-(?!$)/);
    name = parts[parts.length - 1];
    var alt, ctrl, shift, cmd;
    for (var i = 0; i < parts.length - 1; i++) {
      var mod = parts[i];
      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
      else { throw new Error("Unrecognized modifier name: " + mod) }
    }
    if (alt) { name = "Alt-" + name; }
    if (ctrl) { name = "Ctrl-" + name; }
    if (cmd) { name = "Cmd-" + name; }
    if (shift) { name = "Shift-" + name; }
    return name
  }

  // This is a kludge to keep keymaps mostly working as raw objects
  // (backwards compatibility) while at the same time support features
  // like normalization and multi-stroke key bindings. It compiles a
  // new normalized keymap, and then updates the old object to reflect
  // this.
  function normalizeKeyMap(keymap) {
    var copy = {};
    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
      var value = keymap[keyname];
      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
      if (value == "...") { delete keymap[keyname]; continue }

      var keys = map(keyname.split(" "), normalizeKeyName);
      for (var i = 0; i < keys.length; i++) {
        var val = (void 0), name = (void 0);
        if (i == keys.length - 1) {
          name = keys.join(" ");
          val = value;
        } else {
          name = keys.slice(0, i + 1).join(" ");
          val = "...";
        }
        var prev = copy[name];
        if (!prev) { copy[name] = val; }
        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
      }
      delete keymap[keyname];
    } }
    for (var prop in copy) { keymap[prop] = copy[prop]; }
    return keymap
  }

  function lookupKey(key, map, handle, context) {
    map = getKeyMap(map);
    var found = map.call ? map.call(key, context) : map[key];
    if (found === false) { return "nothing" }
    if (found === "...") { return "multi" }
    if (found != null && handle(found)) { return "handled" }

    if (map.fallthrough) {
      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
        { return lookupKey(key, map.fallthrough, handle, context) }
      for (var i = 0; i < map.fallthrough.length; i++) {
        var result = lookupKey(key, map.fallthrough[i], handle, context);
        if (result) { return result }
      }
    }
  }

  // Modifier key presses don't count as 'real' key presses for the
  // purpose of keymap fallthrough.
  function isModifierKey(value) {
    var name = typeof value == "string" ? value : keyNames[value.keyCode];
    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
  }

  function addModifierNames(name, event, noShift) {
    var base = name;
    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") { name = "Cmd-" + name; }
    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
    return name
  }

  // Look up the name of a key as indicated by an event object.
  function keyName(event, noShift) {
    if (presto && event.keyCode == 34 && event["char"]) { return false }
    var name = keyNames[event.keyCode];
    if (name == null || event.altGraphKey) { return false }
    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
    if (event.keyCode == 3 && event.code) { name = event.code; }
    return addModifierNames(name, event, noShift)
  }

  function getKeyMap(val) {
    return typeof val == "string" ? keyMap[val] : val
  }

  // Helper for deleting text near the selection(s), used to implement
  // backspace, delete, and similar functionality.
  function deleteNearSelection(cm, compute) {
    var ranges = cm.doc.sel.ranges, kill = [];
    // Build up a set of ranges to kill first, merging overlapping
    // ranges.
    for (var i = 0; i < ranges.length; i++) {
      var toKill = compute(ranges[i]);
      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
        var replaced = kill.pop();
        if (cmp(replaced.from, toKill.from) < 0) {
          toKill.from = replaced.from;
          break
        }
      }
      kill.push(toKill);
    }
    // Next, remove those actual ranges.
    runInOp(cm, function () {
      for (var i = kill.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
      ensureCursorVisible(cm);
    });
  }

  function moveCharLogically(line, ch, dir) {
    var target = skipExtendingChars(line.text, ch + dir, dir);
    return target < 0 || target > line.text.length ? null : target
  }

  function moveLogically(line, start, dir) {
    var ch = moveCharLogically(line, start.ch, dir);
    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
  }

  function endOfLine(visually, cm, lineObj, lineNo, dir) {
    if (visually) {
      if (cm.doc.direction == "rtl") { dir = -dir; }
      var order = getOrder(lineObj, cm.doc.direction);
      if (order) {
        var part = dir < 0 ? lst(order) : order[0];
        var moveInStorageOrder = (dir < 0) == (part.level == 1);
        var sticky = moveInStorageOrder ? "after" : "before";
        var ch;
        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
        // it could be that the last bidi part is not on the last visual line,
        // since visual lines contain content order-consecutive chunks.
        // Thus, in rtl, we are looking for the first (content-order) character
        // in the rtl chunk that is on the last line (that is, the same line
        // as the last (content-order) character).
        if (part.level > 0 || cm.doc.direction == "rtl") {
          var prep = prepareMeasureForLine(cm, lineObj);
          ch = dir < 0 ? lineObj.text.length - 1 : 0;
          var targetTop = measureCharPrepared(cm, prep, ch).top;
          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
        } else { ch = dir < 0 ? part.to : part.from; }
        return new Pos(lineNo, ch, sticky)
      }
    }
    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
  }

  function moveVisually(cm, line, start, dir) {
    var bidi = getOrder(line, cm.doc.direction);
    if (!bidi) { return moveLogically(line, start, dir) }
    if (start.ch >= line.text.length) {
      start.ch = line.text.length;
      start.sticky = "before";
    } else if (start.ch <= 0) {
      start.ch = 0;
      start.sticky = "after";
    }
    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
      // nothing interesting happens.
      return moveLogically(line, start, dir)
    }

    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
    var prep;
    var getWrappedLineExtent = function (ch) {
      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
      prep = prep || prepareMeasureForLine(cm, line);
      return wrappedLineExtentChar(cm, line, prep, ch)
    };
    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

    if (cm.doc.direction == "rtl" || part.level == 1) {
      var moveInStorageOrder = (part.level == 1) == (dir < 0);
      var ch = mv(start, moveInStorageOrder ? 1 : -1);
      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
        var sticky = moveInStorageOrder ? "before" : "after";
        return new Pos(start.line, ch, sticky)
      }
    }

    // Case 3: Could not move within this bidi part in this visual line, so leave
    // the current bidi part

    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
        ? new Pos(start.line, mv(ch, 1), "before")
        : new Pos(start.line, ch, "after"); };

      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
        var part = bidi[partPos];
        var moveInStorageOrder = (dir > 0) == (part.level != 1);
        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
      }
    };

    // Case 3a: Look for other bidi parts on the same visual line
    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
    if (res) { return res }

    // Case 3b: Look for other bidi parts on the next visual line
    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
      if (res) { return res }
    }

    // Case 4: Nowhere to move
    return null
  }

  // Commands are parameter-less actions that can be performed on an
  // editor, mostly used for keybindings.
  var commands = {
    selectAll: selectAll,
    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
      if (range.empty()) {
        var len = getLine(cm.doc, range.head.line).text.length;
        if (range.head.ch == len && range.head.line < cm.lastLine())
          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
        else
          { return {from: range.head, to: Pos(range.head.line, len)} }
      } else {
        return {from: range.from(), to: range.to()}
      }
    }); },
    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0),
      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
    }); }); },
    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0), to: range.from()
    }); }); },
    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
      return {from: leftPos, to: range.from()}
    }); },
    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
      return {from: range.from(), to: rightPos }
    }); },
    undo: function (cm) { return cm.undo(); },
    redo: function (cm) { return cm.redo(); },
    undoSelection: function (cm) { return cm.undoSelection(); },
    redoSelection: function (cm) { return cm.redoSelection(); },
    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
      {origin: "+move", bias: 1}
    ); },
    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
      {origin: "+move", bias: 1}
    ); },
    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
      {origin: "+move", bias: -1}
    ); },
    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
    }, sel_move); },
    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: 0, top: top}, "div")
    }, sel_move); },
    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      var pos = cm.coordsChar({left: 0, top: top}, "div");
      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
      return pos
    }, sel_move); },
    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
    goLineDown: function (cm) { return cm.moveV(1, "line"); },
    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
    goPageDown: function (cm) { return cm.moveV(1, "page"); },
    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
    goCharRight: function (cm) { return cm.moveH(1, "char"); },
    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
    goWordRight: function (cm) { return cm.moveH(1, "word"); },
    delCharBefore: function (cm) { return cm.deleteH(-1, "codepoint"); },
    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
    indentAuto: function (cm) { return cm.indentSelection("smart"); },
    indentMore: function (cm) { return cm.indentSelection("add"); },
    indentLess: function (cm) { return cm.indentSelection("subtract"); },
    insertTab: function (cm) { return cm.replaceSelection("\t"); },
    insertSoftTab: function (cm) {
      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
      for (var i = 0; i < ranges.length; i++) {
        var pos = ranges[i].from();
        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
        spaces.push(spaceStr(tabSize - col % tabSize));
      }
      cm.replaceSelections(spaces);
    },
    defaultTab: function (cm) {
      if (cm.somethingSelected()) { cm.indentSelection("add"); }
      else { cm.execCommand("insertTab"); }
    },
    // Swap the two chars left and right of each selection's head.
    // Move cursor behind the two swapped characters afterwards.
    //
    // Doesn't consider line feeds a character.
    // Doesn't scan more than one line above to find a character.
    // Doesn't do anything on an empty line.
    // Doesn't do anything with non-empty selections.
    transposeChars: function (cm) { return runInOp(cm, function () {
      var ranges = cm.listSelections(), newSel = [];
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty()) { continue }
        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
        if (line) {
          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
          if (cur.ch > 0) {
            cur = new Pos(cur.line, cur.ch + 1);
            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
          } else if (cur.line > cm.doc.first) {
            var prev = getLine(cm.doc, cur.line - 1).text;
            if (prev) {
              cur = new Pos(cur.line, 1);
              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                              prev.charAt(prev.length - 1),
                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
            }
          }
        }
        newSel.push(new Range(cur, cur));
      }
      cm.setSelections(newSel);
    }); },
    newlineAndIndent: function (cm) { return runInOp(cm, function () {
      var sels = cm.listSelections();
      for (var i = sels.length - 1; i >= 0; i--)
        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
      sels = cm.listSelections();
      for (var i$1 = 0; i$1 < sels.length; i$1++)
        { cm.indentLine(sels[i$1].from().line, null, true); }
      ensureCursorVisible(cm);
    }); },
    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
  };


  function lineStart(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLine(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, visual, lineN, 1)
  }
  function lineEnd(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLineEnd(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, line, lineN, -1)
  }
  function lineStartSmart(cm, pos) {
    var start = lineStart(cm, pos.line);
    var line = getLine(cm.doc, start.line);
    var order = getOrder(line, cm.doc.direction);
    if (!order || order[0].level == 0) {
      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
    }
    return start
  }

  // Run a handler that was bound to a key.
  function doHandleBinding(cm, bound, dropShift) {
    if (typeof bound == "string") {
      bound = commands[bound];
      if (!bound) { return false }
    }
    // Ensure previous input has been read, so that the handler sees a
    // consistent view of the document
    cm.display.input.ensurePolled();
    var prevShift = cm.display.shift, done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      if (dropShift) { cm.display.shift = false; }
      done = bound(cm) != Pass;
    } finally {
      cm.display.shift = prevShift;
      cm.state.suppressEdits = false;
    }
    return done
  }

  function lookupKeyForEditor(cm, name, handle) {
    for (var i = 0; i < cm.state.keyMaps.length; i++) {
      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
      if (result) { return result }
    }
    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
      || lookupKey(name, cm.options.keyMap, handle, cm)
  }

  // Note that, despite the name, this function is also used to check
  // for bound mouse clicks.

  var stopSeq = new Delayed;

  function dispatchKey(cm, name, e, handle) {
    var seq = cm.state.keySeq;
    if (seq) {
      if (isModifierKey(name)) { return "handled" }
      if (/\'$/.test(name))
        { cm.state.keySeq = null; }
      else
        { stopSeq.set(50, function () {
          if (cm.state.keySeq == seq) {
            cm.state.keySeq = null;
            cm.display.input.reset();
          }
        }); }
      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
    }
    return dispatchKeyInner(cm, name, e, handle)
  }

  function dispatchKeyInner(cm, name, e, handle) {
    var result = lookupKeyForEditor(cm, name, handle);

    if (result == "multi")
      { cm.state.keySeq = name; }
    if (result == "handled")
      { signalLater(cm, "keyHandled", cm, name, e); }

    if (result == "handled" || result == "multi") {
      e_preventDefault(e);
      restartBlink(cm);
    }

    return !!result
  }

  // Handle a key from the keydown event.
  function handleKeyBinding(cm, e) {
    var name = keyName(e, true);
    if (!name) { return false }

    if (e.shiftKey && !cm.state.keySeq) {
      // First try to resolve full name (including 'Shift-'). Failing
      // that, see if there is a cursor-motion command (starting with
      // 'go') bound to the keyname without 'Shift-'.
      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
          || dispatchKey(cm, name, e, function (b) {
               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
                 { return doHandleBinding(cm, b) }
             })
    } else {
      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
    }
  }

  // Handle a key from the keypress event
  function handleCharBinding(cm, e, ch) {
    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
  }

  var lastStoppedKey = null;
  function onKeyDown(e) {
    var cm = this;
    if (e.target && e.target != cm.display.input.getField()) { return }
    cm.curOp.focus = activeElt();
    if (signalDOMEvent(cm, e)) { return }
    // IE does strange things with escape.
    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
    var code = e.keyCode;
    cm.display.shift = code == 16 || e.shiftKey;
    var handled = handleKeyBinding(cm, e);
    if (presto) {
      lastStoppedKey = handled ? code : null;
      // Opera has no cut event... we try to at least catch the key combo
      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
        { cm.replaceSelection("", null, "cut"); }
    }
    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
      { document.execCommand("cut"); }

    // Turn mouse into crosshair when Alt is held on Mac.
    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
      { showCrossHair(cm); }
  }

  function showCrossHair(cm) {
    var lineDiv = cm.display.lineDiv;
    addClass(lineDiv, "CodeMirror-crosshair");

    function up(e) {
      if (e.keyCode == 18 || !e.altKey) {
        rmClass(lineDiv, "CodeMirror-crosshair");
        off(document, "keyup", up);
        off(document, "mouseover", up);
      }
    }
    on(document, "keyup", up);
    on(document, "mouseover", up);
  }

  function onKeyUp(e) {
    if (e.keyCode == 16) { this.doc.sel.shift = false; }
    signalDOMEvent(this, e);
  }

  function onKeyPress(e) {
    var cm = this;
    if (e.target && e.target != cm.display.input.getField()) { return }
    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
    var keyCode = e.keyCode, charCode = e.charCode;
    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
    // Some browsers fire keypress events for backspace
    if (ch == "\x08") { return }
    if (handleCharBinding(cm, e, ch)) { return }
    cm.display.input.onKeyPress(e);
  }

  var DOUBLECLICK_DELAY = 400;

  var PastClick = function(time, pos, button) {
    this.time = time;
    this.pos = pos;
    this.button = button;
  };

  PastClick.prototype.compare = function (time, pos, button) {
    return this.time + DOUBLECLICK_DELAY > time &&
      cmp(pos, this.pos) == 0 && button == this.button
  };

  var lastClick, lastDoubleClick;
  function clickRepeat(pos, button) {
    var now = +new Date;
    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
      lastClick = lastDoubleClick = null;
      return "triple"
    } else if (lastClick && lastClick.compare(now, pos, button)) {
      lastDoubleClick = new PastClick(now, pos, button);
      lastClick = null;
      return "double"
    } else {
      lastClick = new PastClick(now, pos, button);
      lastDoubleClick = null;
      return "single"
    }
  }

  // A mouse down can be a single click, double click, triple click,
  // start of selection drag, start of text drag, new cursor
  // (ctrl-click), rectangle drag (alt-drag), or xwin
  // middle-click-paste. Or it might be a click on something we should
  // not interfere with, such as a scrollbar or widget.
  function onMouseDown(e) {
    var cm = this, display = cm.display;
    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
    display.input.ensurePolled();
    display.shift = e.shiftKey;

    if (eventInWidget(display, e)) {
      if (!webkit) {
        // Briefly turn off draggability, to allow widgets to do
        // normal dragging things.
        display.scroller.draggable = false;
        setTimeout(function () { return display.scroller.draggable = true; }, 100);
      }
      return
    }
    if (clickInGutter(cm, e)) { return }
    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
    window.focus();

    // #3261: make sure, that we're not starting a second selection
    if (button == 1 && cm.state.selectingText)
      { cm.state.selectingText(e); }

    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

    if (button == 1) {
      if (pos) { leftButtonDown(cm, pos, repeat, e); }
      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
    } else if (button == 2) {
      if (pos) { extendSelection(cm.doc, pos); }
      setTimeout(function () { return display.input.focus(); }, 20);
    } else if (button == 3) {
      if (captureRightClick) { cm.display.input.onContextMenu(e); }
      else { delayBlurEvent(cm); }
    }
  }

  function handleMappedButton(cm, button, pos, repeat, event) {
    var name = "Click";
    if (repeat == "double") { name = "Double" + name; }
    else if (repeat == "triple") { name = "Triple" + name; }
    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
      if (typeof bound == "string") { bound = commands[bound]; }
      if (!bound) { return false }
      var done = false;
      try {
        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
        done = bound(cm, pos) != Pass;
      } finally {
        cm.state.suppressEdits = false;
      }
      return done
    })
  }

  function configureMouse(cm, repeat, event) {
    var option = cm.getOption("configureMouse");
    var value = option ? option(cm, repeat, event) : {};
    if (value.unit == null) {
      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
    }
    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
    return value
  }

  function leftButtonDown(cm, pos, repeat, event) {
    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
    else { cm.curOp.focus = activeElt(); }

    var behavior = configureMouse(cm, repeat, event);

    var sel = cm.doc.sel, contained;
    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
      { leftButtonStartDrag(cm, event, pos, behavior); }
    else
      { leftButtonSelect(cm, event, pos, behavior); }
  }

  // Start a text drag. When it ends, see if any dragging actually
  // happen, and treat as a click if it didn't.
  function leftButtonStartDrag(cm, event, pos, behavior) {
    var display = cm.display, moved = false;
    var dragEnd = operation(cm, function (e) {
      if (webkit) { display.scroller.draggable = false; }
      cm.state.draggingText = false;
      if (cm.state.delayingBlurEvent) {
        if (cm.hasFocus()) { cm.state.delayingBlurEvent = false; }
        else { delayBlurEvent(cm); }
      }
      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
      off(display.scroller, "dragstart", dragStart);
      off(display.scroller, "drop", dragEnd);
      if (!moved) {
        e_preventDefault(e);
        if (!behavior.addNew)
          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
        if ((webkit && !safari) || ie && ie_version == 9)
          { setTimeout(function () {display.wrapper.ownerDocument.body.focus({preventScroll: true}); display.input.focus();}, 20); }
        else
          { display.input.focus(); }
      }
    });
    var mouseMove = function(e2) {
      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
    };
    var dragStart = function () { return moved = true; };
    // Let the drag handler handle this.
    if (webkit) { display.scroller.draggable = true; }
    cm.state.draggingText = dragEnd;
    dragEnd.copy = !behavior.moveOnDrag;
    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
    on(display.scroller, "dragstart", dragStart);
    on(display.scroller, "drop", dragEnd);

    cm.state.delayingBlurEvent = true;
    setTimeout(function () { return display.input.focus(); }, 20);
    // IE's approach to draggable
    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
  }

  function rangeForUnit(cm, pos, unit) {
    if (unit == "char") { return new Range(pos, pos) }
    if (unit == "word") { return cm.findWordAt(pos) }
    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
    var result = unit(cm, pos);
    return new Range(result.from, result.to)
  }

  // Normal selection, as opposed to text dragging.
  function leftButtonSelect(cm, event, start, behavior) {
    if (ie) { delayBlurEvent(cm); }
    var display = cm.display, doc = cm.doc;
    e_preventDefault(event);

    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
    if (behavior.addNew && !behavior.extend) {
      ourIndex = doc.sel.contains(start);
      if (ourIndex > -1)
        { ourRange = ranges[ourIndex]; }
      else
        { ourRange = new Range(start, start); }
    } else {
      ourRange = doc.sel.primary();
      ourIndex = doc.sel.primIndex;
    }

    if (behavior.unit == "rectangle") {
      if (!behavior.addNew) { ourRange = new Range(start, start); }
      start = posFromMouse(cm, event, true, true);
      ourIndex = -1;
    } else {
      var range = rangeForUnit(cm, start, behavior.unit);
      if (behavior.extend)
        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
      else
        { ourRange = range; }
    }

    if (!behavior.addNew) {
      ourIndex = 0;
      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
      startSel = doc.sel;
    } else if (ourIndex == -1) {
      ourIndex = ranges.length;
      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
                   {scroll: false, origin: "*mouse"});
    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                   {scroll: false, origin: "*mouse"});
      startSel = doc.sel;
    } else {
      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
    }

    var lastPos = start;
    function extendTo(pos) {
      if (cmp(lastPos, pos) == 0) { return }
      lastPos = pos;

      if (behavior.unit == "rectangle") {
        var ranges = [], tabSize = cm.options.tabSize;
        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
             line <= end; line++) {
          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
          if (left == right)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
          else if (text.length > leftPos)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
        }
        if (!ranges.length) { ranges.push(new Range(start, start)); }
        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                     {origin: "*mouse", scroll: false});
        cm.scrollIntoView(pos);
      } else {
        var oldRange = ourRange;
        var range = rangeForUnit(cm, pos, behavior.unit);
        var anchor = oldRange.anchor, head;
        if (cmp(range.anchor, anchor) > 0) {
          head = range.head;
          anchor = minPos(oldRange.from(), range.anchor);
        } else {
          head = range.anchor;
          anchor = maxPos(oldRange.to(), range.head);
        }
        var ranges$1 = startSel.ranges.slice(0);
        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
      }
    }

    var editorSize = display.wrapper.getBoundingClientRect();
    // Used to ensure timeout re-tries don't fire when another extend
    // happened in the meantime (clearTimeout isn't reliable -- at
    // least on Chrome, the timeouts still happen even when cleared,
    // if the clear happens after their scheduled firing time).
    var counter = 0;

    function extend(e) {
      var curCount = ++counter;
      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
      if (!cur) { return }
      if (cmp(cur, lastPos) != 0) {
        cm.curOp.focus = activeElt();
        extendTo(cur);
        var visible = visibleLines(display, doc);
        if (cur.line >= visible.to || cur.line < visible.from)
          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
      } else {
        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
        if (outside) { setTimeout(operation(cm, function () {
          if (counter != curCount) { return }
          display.scroller.scrollTop += outside;
          extend(e);
        }), 50); }
      }
    }

    function done(e) {
      cm.state.selectingText = false;
      counter = Infinity;
      // If e is null or undefined we interpret this as someone trying
      // to explicitly cancel the selection rather than the user
      // letting go of the mouse button.
      if (e) {
        e_preventDefault(e);
        display.input.focus();
      }
      off(display.wrapper.ownerDocument, "mousemove", move);
      off(display.wrapper.ownerDocument, "mouseup", up);
      doc.history.lastSelOrigin = null;
    }

    var move = operation(cm, function (e) {
      if (e.buttons === 0 || !e_button(e)) { done(e); }
      else { extend(e); }
    });
    var up = operation(cm, done);
    cm.state.selectingText = up;
    on(display.wrapper.ownerDocument, "mousemove", move);
    on(display.wrapper.ownerDocument, "mouseup", up);
  }

  // Used when mouse-selecting to adjust the anchor to the proper side
  // of a bidi jump depending on the visual position of the head.
  function bidiSimplify(cm, range) {
    var anchor = range.anchor;
    var head = range.head;
    var anchorLine = getLine(cm.doc, anchor.line);
    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
    var order = getOrder(anchorLine);
    if (!order) { return range }
    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
    if (boundary == 0 || boundary == order.length) { return range }

    // Compute the relative visual position of the head compared to the
    // anchor (<0 is to the left, >0 to the right)
    var leftSide;
    if (head.line != anchor.line) {
      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
    } else {
      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
      if (headIndex == boundary - 1 || headIndex == boundary)
        { leftSide = dir < 0; }
      else
        { leftSide = dir > 0; }
    }

    var usePart = order[boundary + (leftSide ? -1 : 0)];
    var from = leftSide == (usePart.level == 1);
    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
  }


  // Determines whether an event happened in the gutter, and fires the
  // handlers for the corresponding event.
  function gutterEvent(cm, e, type, prevent) {
    var mX, mY;
    if (e.touches) {
      mX = e.touches[0].clientX;
      mY = e.touches[0].clientY;
    } else {
      try { mX = e.clientX; mY = e.clientY; }
      catch(e$1) { return false }
    }
    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
    if (prevent) { e_preventDefault(e); }

    var display = cm.display;
    var lineBox = display.lineDiv.getBoundingClientRect();

    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
    mY -= lineBox.top - display.viewOffset;

    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
      var g = display.gutters.childNodes[i];
      if (g && g.getBoundingClientRect().right >= mX) {
        var line = lineAtHeight(cm.doc, mY);
        var gutter = cm.display.gutterSpecs[i];
        signal(cm, type, cm, line, gutter.className, e);
        return e_defaultPrevented(e)
      }
    }
  }

  function clickInGutter(cm, e) {
    return gutterEvent(cm, e, "gutterClick", true)
  }

  // CONTEXT MENU HANDLING

  // To make the context menu work, we need to briefly unhide the
  // textarea (making it as unobtrusive as possible) to let the
  // right-click take effect on it.
  function onContextMenu(cm, e) {
    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
    if (signalDOMEvent(cm, e, "contextmenu")) { return }
    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
  }

  function contextMenuInGutter(cm, e) {
    if (!hasHandler(cm, "gutterContextMenu")) { return false }
    return gutterEvent(cm, e, "gutterContextMenu", false)
  }

  function themeChanged(cm) {
    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
    clearCaches(cm);
  }

  var Init = {toString: function(){return "CodeMirror.Init"}};

  var defaults = {};
  var optionHandlers = {};

  function defineOptions(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    function option(name, deflt, handle, notOnInit) {
      CodeMirror.defaults[name] = deflt;
      if (handle) { optionHandlers[name] =
        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
    }

    CodeMirror.defineOption = option;

    // Passed to option handlers when there is no old value.
    CodeMirror.Init = Init;

    // These two are, on init, called from the constructor because they
    // have to be initialized before the editor can start at all.
    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
    option("mode", null, function (cm, val) {
      cm.doc.modeOption = val;
      loadMode(cm);
    }, true);

    option("indentUnit", 2, loadMode, true);
    option("indentWithTabs", false);
    option("smartIndent", true);
    option("tabSize", 4, function (cm) {
      resetModeState(cm);
      clearCaches(cm);
      regChange(cm);
    }, true);

    option("lineSeparator", null, function (cm, val) {
      cm.doc.lineSep = val;
      if (!val) { return }
      var newBreaks = [], lineNo = cm.doc.first;
      cm.doc.iter(function (line) {
        for (var pos = 0;;) {
          var found = line.text.indexOf(val, pos);
          if (found == -1) { break }
          pos = found + val.length;
          newBreaks.push(Pos(lineNo, found));
        }
        lineNo++;
      });
      for (var i = newBreaks.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
    });
    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
      if (old != Init) { cm.refresh(); }
    });
    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
    option("electricChars", true);
    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
    }, true);
    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
    option("rtlMoveVisually", !windows);
    option("wholeLineUpdateBefore", true);

    option("theme", "default", function (cm) {
      themeChanged(cm);
      updateGutters(cm);
    }, true);
    option("keyMap", "default", function (cm, val, old) {
      var next = getKeyMap(val);
      var prev = old != Init && getKeyMap(old);
      if (prev && prev.detach) { prev.detach(cm, next); }
      if (next.attach) { next.attach(cm, prev || null); }
    });
    option("extraKeys", null);
    option("configureMouse", null);

    option("lineWrapping", false, wrappingChanged, true);
    option("gutters", [], function (cm, val) {
      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
      updateGutters(cm);
    }, true);
    option("fixedGutter", true, function (cm, val) {
      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
      cm.refresh();
    }, true);
    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
    option("scrollbarStyle", "native", function (cm) {
      initScrollbars(cm);
      updateScrollbars(cm);
      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
    }, true);
    option("lineNumbers", false, function (cm, val) {
      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
      updateGutters(cm);
    }, true);
    option("firstLineNumber", 1, updateGutters, true);
    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
    option("showCursorWhenSelecting", false, updateSelection, true);

    option("resetSelectionOnContextMenu", true);
    option("lineWiseCopyCut", true);
    option("pasteLinesPerSelection", true);
    option("selectionsMayTouch", false);

    option("readOnly", false, function (cm, val) {
      if (val == "nocursor") {
        onBlur(cm);
        cm.display.input.blur();
      }
      cm.display.input.readOnlyChanged(val);
    });

    option("screenReaderLabel", null, function (cm, val) {
      val = (val === '') ? null : val;
      cm.display.input.screenReaderLabelChanged(val);
    });

    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
    option("dragDrop", true, dragDropChanged);
    option("allowDropFileTypes", null);

    option("cursorBlinkRate", 530);
    option("cursorScrollMargin", 0);
    option("cursorHeight", 1, updateSelection, true);
    option("singleCursorHeightPerLine", true, updateSelection, true);
    option("workTime", 100);
    option("workDelay", 100);
    option("flattenSpans", true, resetModeState, true);
    option("addModeClass", false, resetModeState, true);
    option("pollInterval", 100);
    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
    option("historyEventDelay", 1250);
    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
    option("maxHighlightLength", 10000, resetModeState, true);
    option("moveInputWithCursor", true, function (cm, val) {
      if (!val) { cm.display.input.resetPosition(); }
    });

    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
    option("autofocus", null);
    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
    option("phrases", null);
  }

  function dragDropChanged(cm, value, old) {
    var wasOn = old && old != Init;
    if (!value != !wasOn) {
      var funcs = cm.display.dragFunctions;
      var toggle = value ? on : off;
      toggle(cm.display.scroller, "dragstart", funcs.start);
      toggle(cm.display.scroller, "dragenter", funcs.enter);
      toggle(cm.display.scroller, "dragover", funcs.over);
      toggle(cm.display.scroller, "dragleave", funcs.leave);
      toggle(cm.display.scroller, "drop", funcs.drop);
    }
  }

  function wrappingChanged(cm) {
    if (cm.options.lineWrapping) {
      addClass(cm.display.wrapper, "CodeMirror-wrap");
      cm.display.sizer.style.minWidth = "";
      cm.display.sizerWidth = null;
    } else {
      rmClass(cm.display.wrapper, "CodeMirror-wrap");
      findMaxLine(cm);
    }
    estimateLineHeights(cm);
    regChange(cm);
    clearCaches(cm);
    setTimeout(function () { return updateScrollbars(cm); }, 100);
  }

  // A CodeMirror instance represents an editor. This is the object
  // that user code is usually dealing with.

  function CodeMirror(place, options) {
    var this$1 = this;

    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }

    this.options = options = options ? copyObj(options) : {};
    // Determine effective options based on given values and defaults.
    copyObj(defaults, options, false);

    var doc = options.value;
    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
    else if (options.mode) { doc.modeOption = options.mode; }
    this.doc = doc;

    var input = new CodeMirror.inputStyles[options.inputStyle](this);
    var display = this.display = new Display(place, doc, input, options);
    display.wrapper.CodeMirror = this;
    themeChanged(this);
    if (options.lineWrapping)
      { this.display.wrapper.className += " CodeMirror-wrap"; }
    initScrollbars(this);

    this.state = {
      keyMaps: [],  // stores maps added by addKeyMap
      overlays: [], // highlighting overlays, as added by addOverlay
      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
      overwrite: false,
      delayingBlurEvent: false,
      focused: false,
      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
      selectingText: false,
      draggingText: false,
      highlight: new Delayed(), // stores highlight worker timeout
      keySeq: null,  // Unfinished key sequence
      specialChars: null
    };

    if (options.autofocus && !mobile) { display.input.focus(); }

    // Override magic textarea content restore that IE sometimes does
    // on our hidden textarea on reload
    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

    registerEventHandlers(this);
    ensureGlobalHandlers();

    startOperation(this);
    this.curOp.forceUpdate = true;
    attachDoc(this, doc);

    if ((options.autofocus && !mobile) || this.hasFocus())
      { setTimeout(function () {
        if (this$1.hasFocus() && !this$1.state.focused) { onFocus(this$1); }
      }, 20); }
    else
      { onBlur(this); }

    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
      { optionHandlers[opt](this, options[opt], Init); } }
    maybeUpdateLineNumberWidth(this);
    if (options.finishInit) { options.finishInit(this); }
    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
    endOperation(this);
    // Suppress optimizelegibility in Webkit, since it breaks text
    // measuring on line wrapping boundaries.
    if (webkit && options.lineWrapping &&
        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
      { display.lineDiv.style.textRendering = "auto"; }
  }

  // The default configuration options.
  CodeMirror.defaults = defaults;
  // Functions to run when options are changed.
  CodeMirror.optionHandlers = optionHandlers;

  // Attach the necessary event handlers when initializing the editor
  function registerEventHandlers(cm) {
    var d = cm.display;
    on(d.scroller, "mousedown", operation(cm, onMouseDown));
    // Older IE's will not fire a second mousedown for a double click
    if (ie && ie_version < 11)
      { on(d.scroller, "dblclick", operation(cm, function (e) {
        if (signalDOMEvent(cm, e)) { return }
        var pos = posFromMouse(cm, e);
        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
        e_preventDefault(e);
        var word = cm.findWordAt(pos);
        extendSelection(cm.doc, word.anchor, word.head);
      })); }
    else
      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
    // Some browsers fire contextmenu *after* opening the menu, at
    // which point we can't mess with it anymore. Context menu is
    // handled in onMouseDown for these browsers.
    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
    on(d.input.getField(), "contextmenu", function (e) {
      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
    });

    // Used to suppress mouse event handling when a touch happens
    var touchFinished, prevTouch = {end: 0};
    function finishTouch() {
      if (d.activeTouch) {
        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
        prevTouch = d.activeTouch;
        prevTouch.end = +new Date;
      }
    }
    function isMouseLikeTouchEvent(e) {
      if (e.touches.length != 1) { return false }
      var touch = e.touches[0];
      return touch.radiusX <= 1 && touch.radiusY <= 1
    }
    function farAway(touch, other) {
      if (other.left == null) { return true }
      var dx = other.left - touch.left, dy = other.top - touch.top;
      return dx * dx + dy * dy > 20 * 20
    }
    on(d.scroller, "touchstart", function (e) {
      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
        d.input.ensurePolled();
        clearTimeout(touchFinished);
        var now = +new Date;
        d.activeTouch = {start: now, moved: false,
                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
        if (e.touches.length == 1) {
          d.activeTouch.left = e.touches[0].pageX;
          d.activeTouch.top = e.touches[0].pageY;
        }
      }
    });
    on(d.scroller, "touchmove", function () {
      if (d.activeTouch) { d.activeTouch.moved = true; }
    });
    on(d.scroller, "touchend", function (e) {
      var touch = d.activeTouch;
      if (touch && !eventInWidget(d, e) && touch.left != null &&
          !touch.moved && new Date - touch.start < 300) {
        var pos = cm.coordsChar(d.activeTouch, "page"), range;
        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
          { range = new Range(pos, pos); }
        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
          { range = cm.findWordAt(pos); }
        else // Triple tap
          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
        cm.setSelection(range.anchor, range.head);
        cm.focus();
        e_preventDefault(e);
      }
      finishTouch();
    });
    on(d.scroller, "touchcancel", finishTouch);

    // Sync scrolling between fake scrollbars and real scrollable
    // area, ensure viewport is updated when scrolling.
    on(d.scroller, "scroll", function () {
      if (d.scroller.clientHeight) {
        updateScrollTop(cm, d.scroller.scrollTop);
        setScrollLeft(cm, d.scroller.scrollLeft, true);
        signal(cm, "scroll", cm);
      }
    });

    // Listen to wheel events in order to try and update the viewport on time.
    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

    // Prevent wrapper from ever scrolling
    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

    d.dragFunctions = {
      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
      start: function (e) { return onDragStart(cm, e); },
      drop: operation(cm, onDrop),
      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
    };

    var inp = d.input.getField();
    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
    on(inp, "keydown", operation(cm, onKeyDown));
    on(inp, "keypress", operation(cm, onKeyPress));
    on(inp, "focus", function (e) { return onFocus(cm, e); });
    on(inp, "blur", function (e) { return onBlur(cm, e); });
  }

  var initHooks = [];
  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };

  // Indent the given line. The how parameter can be "smart",
  // "add"/null, "subtract", or "prev". When aggressive is false
  // (typically set to true for forced single-line indents), empty
  // lines are not indented, and places where the mode returns Pass
  // are left alone.
  function indentLine(cm, n, how, aggressive) {
    var doc = cm.doc, state;
    if (how == null) { how = "add"; }
    if (how == "smart") {
      // Fall back to "prev" when the mode doesn't have an indentation
      // method.
      if (!doc.mode.indent) { how = "prev"; }
      else { state = getContextBefore(cm, n).state; }
    }

    var tabSize = cm.options.tabSize;
    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
    if (line.stateAfter) { line.stateAfter = null; }
    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
    if (!aggressive && !/\S/.test(line.text)) {
      indentation = 0;
      how = "not";
    } else if (how == "smart") {
      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
      if (indentation == Pass || indentation > 150) {
        if (!aggressive) { return }
        how = "prev";
      }
    }
    if (how == "prev") {
      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
      else { indentation = 0; }
    } else if (how == "add") {
      indentation = curSpace + cm.options.indentUnit;
    } else if (how == "subtract") {
      indentation = curSpace - cm.options.indentUnit;
    } else if (typeof how == "number") {
      indentation = curSpace + how;
    }
    indentation = Math.max(0, indentation);

    var indentString = "", pos = 0;
    if (cm.options.indentWithTabs)
      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
    if (pos < indentation) { indentString += spaceStr(indentation - pos); }

    if (indentString != curSpaceString) {
      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
      line.stateAfter = null;
      return true
    } else {
      // Ensure that, if the cursor was in the whitespace at the start
      // of the line, it is moved to the end of that space.
      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
        var range = doc.sel.ranges[i$1];
        if (range.head.line == n && range.head.ch < curSpaceString.length) {
          var pos$1 = Pos(n, curSpaceString.length);
          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
          break
        }
      }
    }
  }

  // This will be set to a {lineWise: bool, text: [string]} object, so
  // that, when pasting, we know what kind of selections the copied
  // text was made out of.
  var lastCopied = null;

  function setLastCopied(newLastCopied) {
    lastCopied = newLastCopied;
  }

  function applyTextInput(cm, inserted, deleted, sel, origin) {
    var doc = cm.doc;
    cm.display.shift = false;
    if (!sel) { sel = doc.sel; }

    var recent = +new Date - 200;
    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
    var textLines = splitLinesAuto(inserted), multiPaste = null;
    // When pasting N lines into N selections, insert one line per selection
    if (paste && sel.ranges.length > 1) {
      if (lastCopied && lastCopied.text.join("\n") == inserted) {
        if (sel.ranges.length % lastCopied.text.length == 0) {
          multiPaste = [];
          for (var i = 0; i < lastCopied.text.length; i++)
            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
        }
      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
        multiPaste = map(textLines, function (l) { return [l]; });
      }
    }

    var updateInput = cm.curOp.updateInput;
    // Normal behavior is to insert the new text into every selection
    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
      var range = sel.ranges[i$1];
      var from = range.from(), to = range.to();
      if (range.empty()) {
        if (deleted && deleted > 0) // Handle deletion
          { from = Pos(from.line, from.ch - deleted); }
        else if (cm.state.overwrite && !paste) // Handle overwrite
          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n"))
          { from = to = Pos(from.line, 0); }
      }
      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
      makeChange(cm.doc, changeEvent);
      signalLater(cm, "inputRead", cm, changeEvent);
    }
    if (inserted && !paste)
      { triggerElectric(cm, inserted); }

    ensureCursorVisible(cm);
    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
    cm.curOp.typing = true;
    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
  }

  function handlePaste(e, cm) {
    var pasted = e.clipboardData && e.clipboardData.getData("Text");
    if (pasted) {
      e.preventDefault();
      if (!cm.isReadOnly() && !cm.options.disableInput)
        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
      return true
    }
  }

  function triggerElectric(cm, inserted) {
    // When an 'electric' character is inserted, immediately trigger a reindent
    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
    var sel = cm.doc.sel;

    for (var i = sel.ranges.length - 1; i >= 0; i--) {
      var range = sel.ranges[i];
      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
      var mode = cm.getModeAt(range.head);
      var indented = false;
      if (mode.electricChars) {
        for (var j = 0; j < mode.electricChars.length; j++)
          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
            indented = indentLine(cm, range.head.line, "smart");
            break
          } }
      } else if (mode.electricInput) {
        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
          { indented = indentLine(cm, range.head.line, "smart"); }
      }
      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
    }
  }

  function copyableRanges(cm) {
    var text = [], ranges = [];
    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
      var line = cm.doc.sel.ranges[i].head.line;
      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
      ranges.push(lineRange);
      text.push(cm.getRange(lineRange.anchor, lineRange.head));
    }
    return {text: text, ranges: ranges}
  }

  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
    field.setAttribute("autocorrect", autocorrect ? "" : "off");
    field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
    field.setAttribute("spellcheck", !!spellcheck);
  }

  function hiddenTextarea() {
    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
    // The textarea is kept positioned near the cursor to prevent the
    // fact that it'll be scrolled into view on input from scrolling
    // our fake cursor out of view. On webkit, when wrap=off, paste is
    // very slow. So make the area wide instead.
    if (webkit) { te.style.width = "1000px"; }
    else { te.setAttribute("wrap", "off"); }
    // If border: 0; -- iOS fails to open keyboard (issue #1287)
    if (ios) { te.style.border = "1px solid black"; }
    disableBrowserMagic(te);
    return div
  }

  // The publicly visible API. Note that methodOp(f) means
  // 'wrap f in an operation, performed on its `this` parameter'.

  // This is not the complete set of editor methods. Most of the
  // methods defined on the Doc type are also injected into
  // CodeMirror.prototype, for backwards compatibility and
  // convenience.

  function addEditorMethods(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    var helpers = CodeMirror.helpers = {};

    CodeMirror.prototype = {
      constructor: CodeMirror,
      focus: function(){window.focus(); this.display.input.focus();},

      setOption: function(option, value) {
        var options = this.options, old = options[option];
        if (options[option] == value && option != "mode") { return }
        options[option] = value;
        if (optionHandlers.hasOwnProperty(option))
          { operation(this, optionHandlers[option])(this, value, old); }
        signal(this, "optionChange", this, option);
      },

      getOption: function(option) {return this.options[option]},
      getDoc: function() {return this.doc},

      addKeyMap: function(map, bottom) {
        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
      },
      removeKeyMap: function(map) {
        var maps = this.state.keyMaps;
        for (var i = 0; i < maps.length; ++i)
          { if (maps[i] == map || maps[i].name == map) {
            maps.splice(i, 1);
            return true
          } }
      },

      addOverlay: methodOp(function(spec, options) {
        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
        insertSorted(this.state.overlays,
                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                      priority: (options && options.priority) || 0},
                     function (overlay) { return overlay.priority; });
        this.state.modeGen++;
        regChange(this);
      }),
      removeOverlay: methodOp(function(spec) {
        var overlays = this.state.overlays;
        for (var i = 0; i < overlays.length; ++i) {
          var cur = overlays[i].modeSpec;
          if (cur == spec || typeof spec == "string" && cur.name == spec) {
            overlays.splice(i, 1);
            this.state.modeGen++;
            regChange(this);
            return
          }
        }
      }),

      indentLine: methodOp(function(n, dir, aggressive) {
        if (typeof dir != "string" && typeof dir != "number") {
          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
          else { dir = dir ? "add" : "subtract"; }
        }
        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
      }),
      indentSelection: methodOp(function(how) {
        var ranges = this.doc.sel.ranges, end = -1;
        for (var i = 0; i < ranges.length; i++) {
          var range = ranges[i];
          if (!range.empty()) {
            var from = range.from(), to = range.to();
            var start = Math.max(end, from.line);
            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
            for (var j = start; j < end; ++j)
              { indentLine(this, j, how); }
            var newRanges = this.doc.sel.ranges;
            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
          } else if (range.head.line > end) {
            indentLine(this, range.head.line, how, true);
            end = range.head.line;
            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
          }
        }
      }),

      // Fetch the parser token for a given character. Useful for hacks
      // that want to inspect the mode state (say, for completion).
      getTokenAt: function(pos, precise) {
        return takeToken(this, pos, precise)
      },

      getLineTokens: function(line, precise) {
        return takeToken(this, Pos(line), precise, true)
      },

      getTokenTypeAt: function(pos) {
        pos = clipPos(this.doc, pos);
        var styles = getLineStyles(this, getLine(this.doc, pos.line));
        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
        var type;
        if (ch == 0) { type = styles[2]; }
        else { for (;;) {
          var mid = (before + after) >> 1;
          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
          else { type = styles[mid * 2 + 2]; break }
        } }
        var cut = type ? type.indexOf("overlay ") : -1;
        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
      },

      getModeAt: function(pos) {
        var mode = this.doc.mode;
        if (!mode.innerMode) { return mode }
        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
      },

      getHelper: function(pos, type) {
        return this.getHelpers(pos, type)[0]
      },

      getHelpers: function(pos, type) {
        var found = [];
        if (!helpers.hasOwnProperty(type)) { return found }
        var help = helpers[type], mode = this.getModeAt(pos);
        if (typeof mode[type] == "string") {
          if (help[mode[type]]) { found.push(help[mode[type]]); }
        } else if (mode[type]) {
          for (var i = 0; i < mode[type].length; i++) {
            var val = help[mode[type][i]];
            if (val) { found.push(val); }
          }
        } else if (mode.helperType && help[mode.helperType]) {
          found.push(help[mode.helperType]);
        } else if (help[mode.name]) {
          found.push(help[mode.name]);
        }
        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
          var cur = help._global[i$1];
          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
            { found.push(cur.val); }
        }
        return found
      },

      getStateAfter: function(line, precise) {
        var doc = this.doc;
        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
        return getContextBefore(this, line + 1, precise).state
      },

      cursorCoords: function(start, mode) {
        var pos, range = this.doc.sel.primary();
        if (start == null) { pos = range.head; }
        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
        else { pos = start ? range.from() : range.to(); }
        return cursorCoords(this, pos, mode || "page")
      },

      charCoords: function(pos, mode) {
        return charCoords(this, clipPos(this.doc, pos), mode || "page")
      },

      coordsChar: function(coords, mode) {
        coords = fromCoordSystem(this, coords, mode || "page");
        return coordsChar(this, coords.left, coords.top)
      },

      lineAtHeight: function(height, mode) {
        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
        return lineAtHeight(this.doc, height + this.display.viewOffset)
      },
      heightAtLine: function(line, mode, includeWidgets) {
        var end = false, lineObj;
        if (typeof line == "number") {
          var last = this.doc.first + this.doc.size - 1;
          if (line < this.doc.first) { line = this.doc.first; }
          else if (line > last) { line = last; end = true; }
          lineObj = getLine(this.doc, line);
        } else {
          lineObj = line;
        }
        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
          (end ? this.doc.height - heightAtLine(lineObj) : 0)
      },

      defaultTextHeight: function() { return textHeight(this.display) },
      defaultCharWidth: function() { return charWidth(this.display) },

      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

      addWidget: function(pos, node, scroll, vert, horiz) {
        var display = this.display;
        pos = cursorCoords(this, clipPos(this.doc, pos));
        var top = pos.bottom, left = pos.left;
        node.style.position = "absolute";
        node.setAttribute("cm-ignore-events", "true");
        this.display.input.setUneditable(node);
        display.sizer.appendChild(node);
        if (vert == "over") {
          top = pos.top;
        } else if (vert == "above" || vert == "near") {
          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
          // Default to positioning above (if specified and possible); otherwise default to positioning below
          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
            { top = pos.top - node.offsetHeight; }
          else if (pos.bottom + node.offsetHeight <= vspace)
            { top = pos.bottom; }
          if (left + node.offsetWidth > hspace)
            { left = hspace - node.offsetWidth; }
        }
        node.style.top = top + "px";
        node.style.left = node.style.right = "";
        if (horiz == "right") {
          left = display.sizer.clientWidth - node.offsetWidth;
          node.style.right = "0px";
        } else {
          if (horiz == "left") { left = 0; }
          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
          node.style.left = left + "px";
        }
        if (scroll)
          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
      },

      triggerOnKeyDown: methodOp(onKeyDown),
      triggerOnKeyPress: methodOp(onKeyPress),
      triggerOnKeyUp: onKeyUp,
      triggerOnMouseDown: methodOp(onMouseDown),

      execCommand: function(cmd) {
        if (commands.hasOwnProperty(cmd))
          { return commands[cmd].call(null, this) }
      },

      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

      findPosH: function(from, amount, unit, visually) {
        var dir = 1;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          cur = findPosH(this.doc, cur, dir, unit, visually);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveH: methodOp(function(dir, unit) {
        var this$1 = this;

        this.extendSelectionsBy(function (range) {
          if (this$1.display.shift || this$1.doc.extend || range.empty())
            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
          else
            { return dir < 0 ? range.from() : range.to() }
        }, sel_move);
      }),

      deleteH: methodOp(function(dir, unit) {
        var sel = this.doc.sel, doc = this.doc;
        if (sel.somethingSelected())
          { doc.replaceSelection("", null, "+delete"); }
        else
          { deleteNearSelection(this, function (range) {
            var other = findPosH(doc, range.head, dir, unit, false);
            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
          }); }
      }),

      findPosV: function(from, amount, unit, goalColumn) {
        var dir = 1, x = goalColumn;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          var coords = cursorCoords(this, cur, "div");
          if (x == null) { x = coords.left; }
          else { coords.left = x; }
          cur = findPosV(this, coords, dir, unit);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveV: methodOp(function(dir, unit) {
        var this$1 = this;

        var doc = this.doc, goals = [];
        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
        doc.extendSelectionsBy(function (range) {
          if (collapse)
            { return dir < 0 ? range.from() : range.to() }
          var headPos = cursorCoords(this$1, range.head, "div");
          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
          goals.push(headPos.left);
          var pos = findPosV(this$1, headPos, dir, unit);
          if (unit == "page" && range == doc.sel.primary())
            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
          return pos
        }, sel_move);
        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
          { doc.sel.ranges[i].goalColumn = goals[i]; } }
      }),

      // Find the word at the given position (as returned by coordsChar).
      findWordAt: function(pos) {
        var doc = this.doc, line = getLine(doc, pos.line).text;
        var start = pos.ch, end = pos.ch;
        if (line) {
          var helper = this.getHelper(pos, "wordChars");
          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
          var startChar = line.charAt(start);
          var check = isWordChar(startChar, helper)
            ? function (ch) { return isWordChar(ch, helper); }
            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
          while (start > 0 && check(line.charAt(start - 1))) { --start; }
          while (end < line.length && check(line.charAt(end))) { ++end; }
        }
        return new Range(Pos(pos.line, start), Pos(pos.line, end))
      },

      toggleOverwrite: function(value) {
        if (value != null && value == this.state.overwrite) { return }
        if (this.state.overwrite = !this.state.overwrite)
          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
        else
          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

        signal(this, "overwriteToggle", this, this.state.overwrite);
      },
      hasFocus: function() { return this.display.input.getField() == activeElt() },
      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
      getScrollInfo: function() {
        var scroller = this.display.scroller;
        return {left: scroller.scrollLeft, top: scroller.scrollTop,
                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
      },

      scrollIntoView: methodOp(function(range, margin) {
        if (range == null) {
          range = {from: this.doc.sel.primary().head, to: null};
          if (margin == null) { margin = this.options.cursorScrollMargin; }
        } else if (typeof range == "number") {
          range = {from: Pos(range, 0), to: null};
        } else if (range.from == null) {
          range = {from: range, to: null};
        }
        if (!range.to) { range.to = range.from; }
        range.margin = margin || 0;

        if (range.from.line != null) {
          scrollToRange(this, range);
        } else {
          scrollToCoordsRange(this, range.from, range.to, range.margin);
        }
      }),

      setSize: methodOp(function(width, height) {
        var this$1 = this;

        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
        if (width != null) { this.display.wrapper.style.width = interpret(width); }
        if (height != null) { this.display.wrapper.style.height = interpret(height); }
        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
        var lineNo = this.display.viewFrom;
        this.doc.iter(lineNo, this.display.viewTo, function (line) {
          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
          ++lineNo;
        });
        this.curOp.forceUpdate = true;
        signal(this, "refresh", this);
      }),

      operation: function(f){return runInOp(this, f)},
      startOperation: function(){return startOperation(this)},
      endOperation: function(){return endOperation(this)},

      refresh: methodOp(function() {
        var oldHeight = this.display.cachedTextHeight;
        regChange(this);
        this.curOp.forceUpdate = true;
        clearCaches(this);
        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
        updateGutterSpace(this.display);
        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping)
          { estimateLineHeights(this); }
        signal(this, "refresh", this);
      }),

      swapDoc: methodOp(function(doc) {
        var old = this.doc;
        old.cm = null;
        // Cancel the current text selection if any (#5821)
        if (this.state.selectingText) { this.state.selectingText(); }
        attachDoc(this, doc);
        clearCaches(this);
        this.display.input.reset();
        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
        this.curOp.forceScroll = true;
        signalLater(this, "swapDoc", this, old);
        return old
      }),

      phrase: function(phraseText) {
        var phrases = this.options.phrases;
        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
      },

      getInputField: function(){return this.display.input.getField()},
      getWrapperElement: function(){return this.display.wrapper},
      getScrollerElement: function(){return this.display.scroller},
      getGutterElement: function(){return this.display.gutters}
    };
    eventMixin(CodeMirror);

    CodeMirror.registerHelper = function(type, name, value) {
      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
      helpers[type][name] = value;
    };
    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
      CodeMirror.registerHelper(type, name, value);
      helpers[type]._global.push({pred: predicate, val: value});
    };
  }

  // Used for horizontal relative motion. Dir is -1 or 1 (left or
  // right), unit can be "codepoint", "char", "column" (like char, but
  // doesn't cross line boundaries), "word" (across next word), or
  // "group" (to the start of next group of word or
  // non-word-non-whitespace chars). The visually param controls
  // whether, in right-to-left text, direction 1 means to move towards
  // the next index in the string, or towards the character to the right
  // of the current position. The resulting position will have a
  // hitSide=true property if it reached the end of the document.
  function findPosH(doc, pos, dir, unit, visually) {
    var oldPos = pos;
    var origDir = dir;
    var lineObj = getLine(doc, pos.line);
    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
    function findNextLine() {
      var l = pos.line + lineDir;
      if (l < doc.first || l >= doc.first + doc.size) { return false }
      pos = new Pos(l, pos.ch, pos.sticky);
      return lineObj = getLine(doc, l)
    }
    function moveOnce(boundToLine) {
      var next;
      if (unit == "codepoint") {
        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
        if (isNaN(ch)) {
          next = null;
        } else {
          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
        }
      } else if (visually) {
        next = moveVisually(doc.cm, lineObj, pos, dir);
      } else {
        next = moveLogically(lineObj, pos, dir);
      }
      if (next == null) {
        if (!boundToLine && findNextLine())
          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
        else
          { return false }
      } else {
        pos = next;
      }
      return true
    }

    if (unit == "char" || unit == "codepoint") {
      moveOnce();
    } else if (unit == "column") {
      moveOnce(true);
    } else if (unit == "word" || unit == "group") {
      var sawType = null, group = unit == "group";
      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
      for (var first = true;; first = false) {
        if (dir < 0 && !moveOnce(!first)) { break }
        var cur = lineObj.text.charAt(pos.ch) || "\n";
        var type = isWordChar(cur, helper) ? "w"
          : group && cur == "\n" ? "n"
          : !group || /\s/.test(cur) ? null
          : "p";
        if (group && !first && !type) { type = "s"; }
        if (sawType && sawType != type) {
          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
          break
        }

        if (type) { sawType = type; }
        if (dir > 0 && !moveOnce(!first)) { break }
      }
    }
    var result = skipAtomic(doc, pos, oldPos, origDir, true);
    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
    return result
  }

  // For relative vertical movement. Dir may be -1 or 1. Unit can be
  // "page" or "line". The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosV(cm, pos, dir, unit) {
    var doc = cm.doc, x = pos.left, y;
    if (unit == "page") {
      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

    } else if (unit == "line") {
      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
    }
    var target;
    for (;;) {
      target = coordsChar(cm, x, y);
      if (!target.outside) { break }
      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
      y += dir * 5;
    }
    return target
  }

  // CONTENTEDITABLE INPUT STYLE

  var ContentEditableInput = function(cm) {
    this.cm = cm;
    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
    this.polling = new Delayed();
    this.composing = null;
    this.gracePeriod = false;
    this.readDOMTimeout = null;
  };

  ContentEditableInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = input.cm;
    var div = input.div = display.lineDiv;
    div.contentEditable = true;
    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);

    function belongsToInput(e) {
      for (var t = e.target; t; t = t.parentNode) {
        if (t == div) { return true }
        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) { break }
      }
      return false
    }

    on(div, "paste", function (e) {
      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
    });

    on(div, "compositionstart", function (e) {
      this$1.composing = {data: e.data, done: false};
    });
    on(div, "compositionupdate", function (e) {
      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
    });
    on(div, "compositionend", function (e) {
      if (this$1.composing) {
        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
        this$1.composing.done = true;
      }
    });

    on(div, "touchstart", function () { return input.forceCompositionEnd(); });

    on(div, "input", function () {
      if (!this$1.composing) { this$1.readFromDOMSoon(); }
    });

    function onCopyCut(e) {
      if (!belongsToInput(e) || signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.operation(function () {
            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
            cm.replaceSelection("", null, "cut");
          });
        }
      }
      if (e.clipboardData) {
        e.clipboardData.clearData();
        var content = lastCopied.text.join("\n");
        // iOS exposes the clipboard API, but seems to discard content inserted into it
        e.clipboardData.setData("Text", content);
        if (e.clipboardData.getData("Text") == content) {
          e.preventDefault();
          return
        }
      }
      // Old-fashioned briefly-focus-a-textarea hack
      var kludge = hiddenTextarea(), te = kludge.firstChild;
      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
      te.value = lastCopied.text.join("\n");
      var hadFocus = activeElt();
      selectInput(te);
      setTimeout(function () {
        cm.display.lineSpace.removeChild(kludge);
        hadFocus.focus();
        if (hadFocus == div) { input.showPrimarySelection(); }
      }, 50);
    }
    on(div, "copy", onCopyCut);
    on(div, "cut", onCopyCut);
  };

  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
    // Label for screenreaders, accessibility
    if(label) {
      this.div.setAttribute('aria-label', label);
    } else {
      this.div.removeAttribute('aria-label');
    }
  };

  ContentEditableInput.prototype.prepareSelection = function () {
    var result = prepareSelection(this.cm, false);
    result.focus = activeElt() == this.div;
    return result
  };

  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
    if (!info || !this.cm.display.view.length) { return }
    if (info.focus || takeFocus) { this.showPrimarySelection(); }
    this.showMultipleSelections(info);
  };

  ContentEditableInput.prototype.getSelection = function () {
    return this.cm.display.wrapper.ownerDocument.getSelection()
  };

  ContentEditableInput.prototype.showPrimarySelection = function () {
    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
    var from = prim.from(), to = prim.to();

    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
      sel.removeAllRanges();
      return
    }

    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
        cmp(minPos(curAnchor, curFocus), from) == 0 &&
        cmp(maxPos(curAnchor, curFocus), to) == 0)
      { return }

    var view = cm.display.view;
    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
        {node: view[0].measure.map[2], offset: 0};
    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
    if (!end) {
      var measure = view[view.length - 1].measure;
      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
    }

    if (!start || !end) {
      sel.removeAllRanges();
      return
    }

    var old = sel.rangeCount && sel.getRangeAt(0), rng;
    try { rng = range(start.node, start.offset, end.offset, end.node); }
    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
    if (rng) {
      if (!gecko && cm.state.focused) {
        sel.collapse(start.node, start.offset);
        if (!rng.collapsed) {
          sel.removeAllRanges();
          sel.addRange(rng);
        }
      } else {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
      if (old && sel.anchorNode == null) { sel.addRange(old); }
      else if (gecko) { this.startGracePeriod(); }
    }
    this.rememberSelection();
  };

  ContentEditableInput.prototype.startGracePeriod = function () {
      var this$1 = this;

    clearTimeout(this.gracePeriod);
    this.gracePeriod = setTimeout(function () {
      this$1.gracePeriod = false;
      if (this$1.selectionChanged())
        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
    }, 20);
  };

  ContentEditableInput.prototype.showMultipleSelections = function (info) {
    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
  };

  ContentEditableInput.prototype.rememberSelection = function () {
    var sel = this.getSelection();
    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
  };

  ContentEditableInput.prototype.selectionInEditor = function () {
    var sel = this.getSelection();
    if (!sel.rangeCount) { return false }
    var node = sel.getRangeAt(0).commonAncestorContainer;
    return contains(this.div, node)
  };

  ContentEditableInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor") {
      if (!this.selectionInEditor() || activeElt() != this.div)
        { this.showSelection(this.prepareSelection(), true); }
      this.div.focus();
    }
  };
  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
  ContentEditableInput.prototype.getField = function () { return this.div };

  ContentEditableInput.prototype.supportsTouch = function () { return true };

  ContentEditableInput.prototype.receivedFocus = function () {
      var this$1 = this;

    var input = this;
    if (this.selectionInEditor())
      { setTimeout(function () { return this$1.pollSelection(); }, 20); }
    else
      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

    function poll() {
      if (input.cm.state.focused) {
        input.pollSelection();
        input.polling.set(input.cm.options.pollInterval, poll);
      }
    }
    this.polling.set(this.cm.options.pollInterval, poll);
  };

  ContentEditableInput.prototype.selectionChanged = function () {
    var sel = this.getSelection();
    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
  };

  ContentEditableInput.prototype.pollSelection = function () {
    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
    var sel = this.getSelection(), cm = this.cm;
    // On Android Chrome (version 56, at least), backspacing into an
    // uneditable block element will put the cursor in that element,
    // and then, because it's not editable, hide the virtual keyboard.
    // Because Android doesn't allow us to actually detect backspace
    // presses in a sane way, this code checks for when that happens
    // and simulates a backspace press in this case.
    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
      this.blur();
      this.focus();
      return
    }
    if (this.composing) { return }
    this.rememberSelection();
    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (anchor && head) { runInOp(cm, function () {
      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
    }); }
  };

  ContentEditableInput.prototype.pollContent = function () {
    if (this.readDOMTimeout != null) {
      clearTimeout(this.readDOMTimeout);
      this.readDOMTimeout = null;
    }

    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
    var from = sel.from(), to = sel.to();
    if (from.ch == 0 && from.line > cm.firstLine())
      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
      { to = Pos(to.line + 1, 0); }
    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

    var fromIndex, fromLine, fromNode;
    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
      fromLine = lineNo(display.view[0].line);
      fromNode = display.view[0].node;
    } else {
      fromLine = lineNo(display.view[fromIndex].line);
      fromNode = display.view[fromIndex - 1].node.nextSibling;
    }
    var toIndex = findViewIndex(cm, to.line);
    var toLine, toNode;
    if (toIndex == display.view.length - 1) {
      toLine = display.viewTo - 1;
      toNode = display.lineDiv.lastChild;
    } else {
      toLine = lineNo(display.view[toIndex + 1].line) - 1;
      toNode = display.view[toIndex + 1].node.previousSibling;
    }

    if (!fromNode) { return false }
    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
    while (newText.length > 1 && oldText.length > 1) {
      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
      else { break }
    }

    var cutFront = 0, cutEnd = 0;
    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
      { ++cutFront; }
    var newBot = lst(newText), oldBot = lst(oldText);
    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
    while (cutEnd < maxCutEnd &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
      { ++cutEnd; }
    // Try to move start of change to start of selection if ambiguous
    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
      while (cutFront && cutFront > from.ch &&
             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
        cutFront--;
        cutEnd++;
      }
    }

    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

    var chFrom = Pos(fromLine, cutFront);
    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
      return true
    }
  };

  ContentEditableInput.prototype.ensurePolled = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.reset = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.forceCompositionEnd = function () {
    if (!this.composing) { return }
    clearTimeout(this.readDOMTimeout);
    this.composing = null;
    this.updateFromDOM();
    this.div.blur();
    this.div.focus();
  };
  ContentEditableInput.prototype.readFromDOMSoon = function () {
      var this$1 = this;

    if (this.readDOMTimeout != null) { return }
    this.readDOMTimeout = setTimeout(function () {
      this$1.readDOMTimeout = null;
      if (this$1.composing) {
        if (this$1.composing.done) { this$1.composing = null; }
        else { return }
      }
      this$1.updateFromDOM();
    }, 80);
  };

  ContentEditableInput.prototype.updateFromDOM = function () {
      var this$1 = this;

    if (this.cm.isReadOnly() || !this.pollContent())
      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
  };

  ContentEditableInput.prototype.setUneditable = function (node) {
    node.contentEditable = "false";
  };

  ContentEditableInput.prototype.onKeyPress = function (e) {
    if (e.charCode == 0 || this.composing) { return }
    e.preventDefault();
    if (!this.cm.isReadOnly())
      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
  };

  ContentEditableInput.prototype.readOnlyChanged = function (val) {
    this.div.contentEditable = String(val != "nocursor");
  };

  ContentEditableInput.prototype.onContextMenu = function () {};
  ContentEditableInput.prototype.resetPosition = function () {};

  ContentEditableInput.prototype.needsContentAttribute = true;

  function posToDOM(cm, pos) {
    var view = findViewForLine(cm, pos.line);
    if (!view || view.hidden) { return null }
    var line = getLine(cm.doc, pos.line);
    var info = mapFromLineView(view, line, pos.line);

    var order = getOrder(line, cm.doc.direction), side = "left";
    if (order) {
      var partPos = getBidiPartAt(order, pos.ch);
      side = partPos % 2 ? "right" : "left";
    }
    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
    result.offset = result.collapse == "right" ? result.end : result.start;
    return result
  }

  function isInGutter(node) {
    for (var scan = node; scan; scan = scan.parentNode)
      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
    return false
  }

  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

  function domTextBetween(cm, from, to, fromLine, toLine) {
    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
    function close() {
      if (closing) {
        text += lineSep;
        if (extraLinebreak) { text += lineSep; }
        closing = extraLinebreak = false;
      }
    }
    function addText(str) {
      if (str) {
        close();
        text += str;
      }
    }
    function walk(node) {
      if (node.nodeType == 1) {
        var cmText = node.getAttribute("cm-text");
        if (cmText) {
          addText(cmText);
          return
        }
        var markerID = node.getAttribute("cm-marker"), range;
        if (markerID) {
          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
          if (found.length && (range = found[0].find(0)))
            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
          return
        }
        if (node.getAttribute("contenteditable") == "false") { return }
        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }

        if (isBlock) { close(); }
        for (var i = 0; i < node.childNodes.length; i++)
          { walk(node.childNodes[i]); }

        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
        if (isBlock) { closing = true; }
      } else if (node.nodeType == 3) {
        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
      }
    }
    for (;;) {
      walk(from);
      if (from == to) { break }
      from = from.nextSibling;
      extraLinebreak = false;
    }
    return text
  }

  function domToPos(cm, node, offset) {
    var lineNode;
    if (node == cm.display.lineDiv) {
      lineNode = cm.display.lineDiv.childNodes[offset];
      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
      node = null; offset = 0;
    } else {
      for (lineNode = node;; lineNode = lineNode.parentNode) {
        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
      }
    }
    for (var i = 0; i < cm.display.view.length; i++) {
      var lineView = cm.display.view[i];
      if (lineView.node == lineNode)
        { return locateNodeInLineView(lineView, node, offset) }
    }
  }

  function locateNodeInLineView(lineView, node, offset) {
    var wrapper = lineView.text.firstChild, bad = false;
    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
    if (node == wrapper) {
      bad = true;
      node = wrapper.childNodes[offset];
      offset = 0;
      if (!node) {
        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
        return badPos(Pos(lineNo(line), line.text.length), bad)
      }
    }

    var textNode = node.nodeType == 3 ? node : null, topNode = node;
    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
      textNode = node.firstChild;
      if (offset) { offset = textNode.nodeValue.length; }
    }
    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
    var measure = lineView.measure, maps = measure.maps;

    function find(textNode, topNode, offset) {
      for (var i = -1; i < (maps ? maps.length : 0); i++) {
        var map = i < 0 ? measure.map : maps[i];
        for (var j = 0; j < map.length; j += 3) {
          var curNode = map[j + 2];
          if (curNode == textNode || curNode == topNode) {
            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
            var ch = map[j] + offset;
            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
            return Pos(line, ch)
          }
        }
      }
    }
    var found = find(textNode, topNode, offset);
    if (found) { return badPos(found, bad) }

    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
      found = find(after, after.firstChild, 0);
      if (found)
        { return badPos(Pos(found.line, found.ch - dist), bad) }
      else
        { dist += after.textContent.length; }
    }
    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
      found = find(before, before.firstChild, -1);
      if (found)
        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
      else
        { dist$1 += before.textContent.length; }
    }
  }

  // TEXTAREA INPUT STYLE

  var TextareaInput = function(cm) {
    this.cm = cm;
    // See input.poll and input.reset
    this.prevInput = "";

    // Flag that indicates whether we expect input to appear real soon
    // now (after some event like 'keypress' or 'input') and are
    // polling intensively.
    this.pollingFast = false;
    // Self-resetting timeout for the poller
    this.polling = new Delayed();
    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
    this.hasSelection = false;
    this.composing = null;
  };

  TextareaInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = this.cm;
    this.createField(display);
    var te = this.textarea;

    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
    if (ios) { te.style.width = "0px"; }

    on(te, "input", function () {
      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
      input.poll();
    });

    on(te, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

      cm.state.pasteIncoming = +new Date;
      input.fastPoll();
    });

    function prepareCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.setSelections(ranges.ranges, null, sel_dontScroll);
        } else {
          input.prevInput = "";
          te.value = ranges.text.join("\n");
          selectInput(te);
        }
      }
      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
    }
    on(te, "cut", prepareCopyCut);
    on(te, "copy", prepareCopyCut);

    on(display.scroller, "paste", function (e) {
      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
      if (!te.dispatchEvent) {
        cm.state.pasteIncoming = +new Date;
        input.focus();
        return
      }

      // Pass the `paste` event to the textarea so it's handled by its event listener.
      var event = new Event("paste");
      event.clipboardData = e.clipboardData;
      te.dispatchEvent(event);
    });

    // Prevent normal selection in the editor (we handle our own)
    on(display.lineSpace, "selectstart", function (e) {
      if (!eventInWidget(display, e)) { e_preventDefault(e); }
    });

    on(te, "compositionstart", function () {
      var start = cm.getCursor("from");
      if (input.composing) { input.composing.range.clear(); }
      input.composing = {
        start: start,
        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
      };
    });
    on(te, "compositionend", function () {
      if (input.composing) {
        input.poll();
        input.composing.range.clear();
        input.composing = null;
      }
    });
  };

  TextareaInput.prototype.createField = function (_display) {
    // Wraps and hides input textarea
    this.wrapper = hiddenTextarea();
    // The semihidden textarea that is focused when the editor is
    // focused, and receives input.
    this.textarea = this.wrapper.firstChild;
  };

  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
    // Label for screenreaders, accessibility
    if(label) {
      this.textarea.setAttribute('aria-label', label);
    } else {
      this.textarea.removeAttribute('aria-label');
    }
  };

  TextareaInput.prototype.prepareSelection = function () {
    // Redraw the selection and/or cursor
    var cm = this.cm, display = cm.display, doc = cm.doc;
    var result = prepareSelection(cm);

    // Move the hidden textarea near the cursor to prevent scrolling artifacts
    if (cm.options.moveInputWithCursor) {
      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                          headPos.top + lineOff.top - wrapOff.top));
      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                           headPos.left + lineOff.left - wrapOff.left));
    }

    return result
  };

  TextareaInput.prototype.showSelection = function (drawn) {
    var cm = this.cm, display = cm.display;
    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
    if (drawn.teTop != null) {
      this.wrapper.style.top = drawn.teTop + "px";
      this.wrapper.style.left = drawn.teLeft + "px";
    }
  };

  // Reset the input to correspond to the selection (or to be empty,
  // when not typing and nothing is selected)
  TextareaInput.prototype.reset = function (typing) {
    if (this.contextMenuPending || this.composing) { return }
    var cm = this.cm;
    if (cm.somethingSelected()) {
      this.prevInput = "";
      var content = cm.getSelection();
      this.textarea.value = content;
      if (cm.state.focused) { selectInput(this.textarea); }
      if (ie && ie_version >= 9) { this.hasSelection = content; }
    } else if (!typing) {
      this.prevInput = this.textarea.value = "";
      if (ie && ie_version >= 9) { this.hasSelection = null; }
    }
  };

  TextareaInput.prototype.getField = function () { return this.textarea };

  TextareaInput.prototype.supportsTouch = function () { return false };

  TextareaInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
      try { this.textarea.focus(); }
      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    }
  };

  TextareaInput.prototype.blur = function () { this.textarea.blur(); };

  TextareaInput.prototype.resetPosition = function () {
    this.wrapper.style.top = this.wrapper.style.left = 0;
  };

  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

  // Poll for input changes, using the normal rate of polling. This
  // runs as long as the editor is focused.
  TextareaInput.prototype.slowPoll = function () {
      var this$1 = this;

    if (this.pollingFast) { return }
    this.polling.set(this.cm.options.pollInterval, function () {
      this$1.poll();
      if (this$1.cm.state.focused) { this$1.slowPoll(); }
    });
  };

  // When an event has just come in that is likely to add or change
  // something in the input textarea, we poll faster, to ensure that
  // the change appears on the screen quickly.
  TextareaInput.prototype.fastPoll = function () {
    var missed = false, input = this;
    input.pollingFast = true;
    function p() {
      var changed = input.poll();
      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
      else {input.pollingFast = false; input.slowPoll();}
    }
    input.polling.set(20, p);
  };

  // Read input from the textarea, and update the document to match.
  // When something is selected, it is present in the textarea, and
  // selected (unless it is huge, in which case a placeholder is
  // used). When nothing is selected, the cursor sits after previously
  // seen text (can be empty), which is stored in prevInput (we must
  // not reset the textarea when typing, because that breaks IME).
  TextareaInput.prototype.poll = function () {
      var this$1 = this;

    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
    // Since this is called a *lot*, try to bail out as cheaply as
    // possible when it is clear that nothing happened. hasSelection
    // will be the case when there is a lot of text in the textarea,
    // in which case reading its value would be expensive.
    if (this.contextMenuPending || !cm.state.focused ||
        (hasSelection(input) && !prevInput && !this.composing) ||
        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
      { return false }

    var text = input.value;
    // If nothing changed, bail.
    if (text == prevInput && !cm.somethingSelected()) { return false }
    // Work around nonsensical selection resetting in IE9/10, and
    // inexplicable appearance of private area unicode characters on
    // some key combos in Mac (#2689).
    if (ie && ie_version >= 9 && this.hasSelection === text ||
        mac && /[\uf700-\uf7ff]/.test(text)) {
      cm.display.input.reset();
      return false
    }

    if (cm.doc.sel == cm.display.selForContextMenu) {
      var first = text.charCodeAt(0);
      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
    }
    // Find the part of the input that is actually new
    var same = 0, l = Math.min(prevInput.length, text.length);
    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

    runInOp(cm, function () {
      applyTextInput(cm, text.slice(same), prevInput.length - same,
                     null, this$1.composing ? "*compose" : null);

      // Don't leave long text in the textarea, since it makes further polling slow
      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
      else { this$1.prevInput = text; }

      if (this$1.composing) {
        this$1.composing.range.clear();
        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                           {className: "CodeMirror-composing"});
      }
    });
    return true
  };

  TextareaInput.prototype.ensurePolled = function () {
    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
  };

  TextareaInput.prototype.onKeyPress = function () {
    if (ie && ie_version >= 9) { this.hasSelection = null; }
    this.fastPoll();
  };

  TextareaInput.prototype.onContextMenu = function (e) {
    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
    if (input.contextMenuPending) { input.contextMenuPending(); }
    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
    if (!pos || presto) { return } // Opera is difficult.

    // Reset the current text selection only if the click is done outside of the selection
    // and 'resetSelectionOnContextMenu' option is true.
    var reset = cm.options.resetSelectionOnContextMenu;
    if (reset && cm.doc.sel.contains(pos) == -1)
      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
    input.wrapper.style.cssText = "position: static";
    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
    var oldScrollY;
    if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
    display.input.focus();
    if (webkit) { window.scrollTo(null, oldScrollY); }
    display.input.reset();
    // Adds "Select all" to context menu in FF
    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
    input.contextMenuPending = rehide;
    display.selForContextMenu = cm.doc.sel;
    clearTimeout(display.detectingSelectAll);

    // Select-all will be greyed out if there's nothing to select, so
    // this adds a zero-width space so that we can later check whether
    // it got selected.
    function prepareSelectAllHack() {
      if (te.selectionStart != null) {
        var selected = cm.somethingSelected();
        var extval = "\u200b" + (selected ? te.value : "");
        te.value = "\u21da"; // Used to catch context-menu undo
        te.value = extval;
        input.prevInput = selected ? "" : "\u200b";
        te.selectionStart = 1; te.selectionEnd = extval.length;
        // Re-set this, in case some other handler touched the
        // selection in the meantime.
        display.selForContextMenu = cm.doc.sel;
      }
    }
    function rehide() {
      if (input.contextMenuPending != rehide) { return }
      input.contextMenuPending = false;
      input.wrapper.style.cssText = oldWrapperCSS;
      te.style.cssText = oldCSS;
      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

      // Try to detect the user choosing select-all
      if (te.selectionStart != null) {
        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
        var i = 0, poll = function () {
          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
              te.selectionEnd > 0 && input.prevInput == "\u200b") {
            operation(cm, selectAll)(cm);
          } else if (i++ < 10) {
            display.detectingSelectAll = setTimeout(poll, 500);
          } else {
            display.selForContextMenu = null;
            display.input.reset();
          }
        };
        display.detectingSelectAll = setTimeout(poll, 200);
      }
    }

    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
    if (captureRightClick) {
      e_stop(e);
      var mouseup = function () {
        off(window, "mouseup", mouseup);
        setTimeout(rehide, 20);
      };
      on(window, "mouseup", mouseup);
    } else {
      setTimeout(rehide, 50);
    }
  };

  TextareaInput.prototype.readOnlyChanged = function (val) {
    if (!val) { this.reset(); }
    this.textarea.disabled = val == "nocursor";
    this.textarea.readOnly = !!val;
  };

  TextareaInput.prototype.setUneditable = function () {};

  TextareaInput.prototype.needsContentAttribute = false;

  function fromTextArea(textarea, options) {
    options = options ? copyObj(options) : {};
    options.value = textarea.value;
    if (!options.tabindex && textarea.tabIndex)
      { options.tabindex = textarea.tabIndex; }
    if (!options.placeholder && textarea.placeholder)
      { options.placeholder = textarea.placeholder; }
    // Set autofocus to true if this textarea is focused, or if it has
    // autofocus and no other element is focused.
    if (options.autofocus == null) {
      var hasFocus = activeElt();
      options.autofocus = hasFocus == textarea ||
        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
    }

    function save() {textarea.value = cm.getValue();}

    var realSubmit;
    if (textarea.form) {
      on(textarea.form, "submit", save);
      // Deplorable hack to make the submit method do the right thing.
      if (!options.leaveSubmitMethodAlone) {
        var form = textarea.form;
        realSubmit = form.submit;
        try {
          var wrappedSubmit = form.submit = function () {
            save();
            form.submit = realSubmit;
            form.submit();
            form.submit = wrappedSubmit;
          };
        } catch(e) {}
      }
    }

    options.finishInit = function (cm) {
      cm.save = save;
      cm.getTextArea = function () { return textarea; };
      cm.toTextArea = function () {
        cm.toTextArea = isNaN; // Prevent this from being ran twice
        save();
        textarea.parentNode.removeChild(cm.getWrapperElement());
        textarea.style.display = "";
        if (textarea.form) {
          off(textarea.form, "submit", save);
          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
            { textarea.form.submit = realSubmit; }
        }
      };
    };

    textarea.style.display = "none";
    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
      options);
    return cm
  }

  function addLegacyProps(CodeMirror) {
    CodeMirror.off = off;
    CodeMirror.on = on;
    CodeMirror.wheelEventPixels = wheelEventPixels;
    CodeMirror.Doc = Doc;
    CodeMirror.splitLines = splitLinesAuto;
    CodeMirror.countColumn = countColumn;
    CodeMirror.findColumn = findColumn;
    CodeMirror.isWordChar = isWordCharBasic;
    CodeMirror.Pass = Pass;
    CodeMirror.signal = signal;
    CodeMirror.Line = Line;
    CodeMirror.changeEnd = changeEnd;
    CodeMirror.scrollbarModel = scrollbarModel;
    CodeMirror.Pos = Pos;
    CodeMirror.cmpPos = cmp;
    CodeMirror.modes = modes;
    CodeMirror.mimeModes = mimeModes;
    CodeMirror.resolveMode = resolveMode;
    CodeMirror.getMode = getMode;
    CodeMirror.modeExtensions = modeExtensions;
    CodeMirror.extendMode = extendMode;
    CodeMirror.copyState = copyState;
    CodeMirror.startState = startState;
    CodeMirror.innerMode = innerMode;
    CodeMirror.commands = commands;
    CodeMirror.keyMap = keyMap;
    CodeMirror.keyName = keyName;
    CodeMirror.isModifierKey = isModifierKey;
    CodeMirror.lookupKey = lookupKey;
    CodeMirror.normalizeKeyMap = normalizeKeyMap;
    CodeMirror.StringStream = StringStream;
    CodeMirror.SharedTextMarker = SharedTextMarker;
    CodeMirror.TextMarker = TextMarker;
    CodeMirror.LineWidget = LineWidget;
    CodeMirror.e_preventDefault = e_preventDefault;
    CodeMirror.e_stopPropagation = e_stopPropagation;
    CodeMirror.e_stop = e_stop;
    CodeMirror.addClass = addClass;
    CodeMirror.contains = contains;
    CodeMirror.rmClass = rmClass;
    CodeMirror.keyNames = keyNames;
  }

  // EDITOR CONSTRUCTOR

  defineOptions(CodeMirror);

  addEditorMethods(CodeMirror);

  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
    { CodeMirror.prototype[prop] = (function(method) {
      return function() {return method.apply(this.doc, arguments)}
    })(Doc.prototype[prop]); } }

  eventMixin(Doc);
  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  CodeMirror.defineMode = function(name/*, mode, …*/) {
    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
    defineMode.apply(this, arguments);
  };

  CodeMirror.defineMIME = defineMIME;

  // Minimal default mode.
  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
  CodeMirror.defineMIME("text/plain", "null");

  // EXTENSIONS

  CodeMirror.defineExtension = function (name, func) {
    CodeMirror.prototype[name] = func;
  };
  CodeMirror.defineDocExtension = function (name, func) {
    Doc.prototype[name] = func;
  };

  CodeMirror.fromTextArea = fromTextArea;

  addLegacyProps(CodeMirror);

  CodeMirror.version = "5.64.0";

  return CodeMirror;

})));


/***/ }),

/***/ "56b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__("7f7a")

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),

/***/ "56ea":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "5726":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = __webpack_require__("c243");

// Encode data string
var encode = function encode(data, structure, separator) {
	var encoded = data.split('').map(function (val, idx) {
		return _constants.BINARIES[structure[idx]];
	}).map(function (val, idx) {
		return val ? val[data[idx]] : '';
	});

	if (separator) {
		var last = data.length - 1;
		encoded = encoded.map(function (val, idx) {
			return idx < last ? val + separator : val;
		});
	}

	return encoded.join('');
};

exports.default = encode;

/***/ }),

/***/ "5737":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("63b6");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "573f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GapCursorExtension; });
/* unused harmony export getGapCursorTargetDOM */
/* unused harmony export handleClick */
/* unused harmony export handleClickOn */
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f7fe");
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6ffb");
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prosemirror_state__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prosemirror_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("576a");
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("80a6");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6f27");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prosemirror_model__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7378");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__["d"]; });

/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fbea");
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prosemirror_commands__WEBPACK_IMPORTED_MODULE_6__);










/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var domAtPos = function(view, pos, side) {
    var res = view.domAtPos(pos, side);
    if (res === null) {
        return null;
    }
    var node = res.node;
    var offset = res.offset;
    while(node && node.childNodes[offset]){
        var _dom_classList;
        var dom = node.childNodes[offset];
        if ((_dom_classList = dom.classList) === null || _dom_classList === void 0 ? void 0 : _dom_classList.contains("ProseMirror-widget")) {
            offset++;
            continue;
        }
        return dom;
    }
    return null;
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ProseMirror-gapcursor{display:none;pointer-events:none;position:absolute;z-index:2}.ProseMirror-gapcursor:after{content:"";display:inline-block;height:100%;vertical-align:baseline;position:absolute;bottom:0;border-left:1px solid #000;-webkit-animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite;animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite}.ProseMirror-focused .ProseMirror-gapcursor{display:inline-block}.fake-cursor{position:absolute;left:0;width:1px;height:1px;outline:none;background:transparent;z-index:55555}@-webkit-keyframes ProseMirror-cursor-blink{to{visibility:hidden}}@keyframes ProseMirror-cursor-blink{to{visibility:hidden}}';
styleInject(css_248z);

/**
 * TODO: 节点类型是支持gapcursor的，由于目前部分gapcursor定义存在问题，在不保证修改schema的情况下做一层胶水
 * 后续如果schema统一治理，需要将这段代码考虑优化
 */ var allowGapCursor = function(node) {
    if (!node) {
        return false;
    }
    var allow = node.type.spec.allowGapCursor;
    if (allow) {
        return true;
    }
    var textType = [
        "catalog"
    ];
    return textType.includes(node.type.name);
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// prosemirror-gapcursor 1.1.5
var reactNodeClass = classNamePrefix("node-view-dom");
var PM_GAP_CURSOR_CLASS_NAME = "ProseMirror-gapcursor";
var GAP_CURSOR_MIN_HEIGHT = 14;
var getGapCursorTargetDOM = function(state, getView) {
    var _$from_nodeBefore, _dom_classList;
    var selection = state.selection;
    if (!_instanceof(selection, _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"])) {
        return null;
    }
    var gapCursorType = selection.gapCursorType, $from = selection.$from;
    var isGapCursorBeforeNode = gapCursorType === _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].beforeInlineNode || gapCursorType === _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].beforeNode;
    var _$from_nodeBefore_nodeSize;
    var dom = isGapCursorBeforeNode ? getView().nodeDOM($from.pos) : getView().nodeDOM($from.pos - ((_$from_nodeBefore_nodeSize = (_$from_nodeBefore = $from.nodeBefore) === null || _$from_nodeBefore === void 0 ? void 0 : _$from_nodeBefore.nodeSize) !== null && _$from_nodeBefore_nodeSize !== void 0 ? _$from_nodeBefore_nodeSize : 0));
    var targetNode = (dom === null || dom === void 0 ? void 0 : (_dom_classList = dom.classList) === null || _dom_classList === void 0 ? void 0 : _dom_classList.contains(reactNodeClass)) ? dom.firstElementChild : dom;
    // targetDom 必须具有 Element.getBoundingClientRect 方法
    // (https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect)
    // SVGElement 和 HTMLElement 都直接继承自 Element
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // https://developer.mozilla.org/en-US/docs/Web/API/SVGElement
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement
    var targetDom = _instanceof(targetNode, Element) ? targetNode : null;
    return targetDom;
};
// 需要异步更新 GapCursor 的样式，详见：https://km.sankuai.com/page/1216226222
var updateGapCursorStyle = function(gapCursorDOM, state, getView) {
    var gapCursorType = state.selection.gapCursorType;
    var targetDOM = getGapCursorTargetDOM(state, getView);
    var isTableContainer = false;
    if (!targetDOM) {
        return;
    }
    var dom = targetDOM.parentElement;
    while(dom && window.getComputedStyle(dom).position !== "relative"){
        dom = dom.parentElement;
    }
    if (!dom) {
        dom = getView().dom;
    }
    var _dom_getBoundingClientRect = dom.getBoundingClientRect(), editorTop = _dom_getBoundingClientRect.top, editorLeft = _dom_getBoundingClientRect.left;
    // MARK: 特判2.0文档表格新dom结构 铁峰后续可梳理给出更合适的写法
    if (targetDOM.classList.contains("table-container")) {
        targetDOM = targetDOM.querySelector("table");
        isTableContainer = true;
    }
    var _targetDOM_getBoundingClientRect = targetDOM.getBoundingClientRect(), targetTop = _targetDOM_getBoundingClientRect.top, targetLeft = _targetDOM_getBoundingClientRect.left, targetWidth = _targetDOM_getBoundingClientRect.width, targetHeight = _targetDOM_getBoundingClientRect.height;
    var top = targetTop - editorTop;
    var left = targetLeft - editorLeft;
    if (targetHeight < GAP_CURSOR_MIN_HEIGHT) {
        gapCursorDOM.style.height = "".concat(GAP_CURSOR_MIN_HEIGHT, "px");
        gapCursorDOM.style.top = "".concat(top - GAP_CURSOR_MIN_HEIGHT / 2, "px");
    } else {
        gapCursorDOM.style.height = "".concat(targetHeight, "px");
        gapCursorDOM.style.top = "".concat(top, "px");
    }
    if (gapCursorType === _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].afterInlineNode) {
        gapCursorDOM.style.left = "".concat(left + targetWidth, "px");
    } else if (gapCursorType === _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].afterNode) {
        // 主要考虑可以横向滚动的表格
        if (targetDOM === null || targetDOM === void 0 ? void 0 : targetDOM.parentElement) {
            var offsetLeft = !isTableContainer ? targetDOM.parentElement.offsetLeft : targetDOM.parentElement.parentElement.offsetLeft;
            gapCursorDOM.style.left = "".concat(targetDOM.parentElement.clientWidth < targetWidth ? targetDOM.parentElement.clientWidth + offsetLeft : left + targetWidth, "px");
        }
    } else {
        gapCursorDOM.style.left = "".concat(left, "px");
    }
};
var createGapCursorNode = function(state, getView) {
    var node = document.createElement("div");
    node.className = PM_GAP_CURSOR_CLASS_NAME;
    setTimeout(function() {
        var view = getView();
        if (!view.docView) {
            return;
        }
        updateGapCursorStyle(node, state, getView);
    });
    return node;
};
function getDrawGapCursor(state, getView) {
    if (_instanceof(state.selection, _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"]) || _instanceof(state.selection, prosemirror_state__WEBPACK_IMPORTED_MODULE_1__["NodeSelection"]) || state.selection.forEachCell) {
        var isNeedGapCursor = _instanceof(state.selection, _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"]);
        var gapWidget = prosemirror_view__WEBPACK_IMPORTED_MODULE_2__[/* Decoration */ "a"].widget(state.selection.head, createGapCursorNode(state, getView), {
            key: "".concat(Math.random())
        });
        return prosemirror_view__WEBPACK_IMPORTED_MODULE_2__[/* DecorationSet */ "b"].create(state.doc, _toConsumableArray(isNeedGapCursor ? [
            gapWidget
        ] : []));
    }
    return null;
}
function handleClickOn(view, pos, node, nodePos, event) {
    if (Math.abs(view.lastClick.x - event.clientX) > 4 || Math.abs(view.lastClick.y - event.clientY) > 4) {
        // 拖动行为不触发点击
        return false;
    }
    var target = event.target;
    if (target.classList.contains(reactNodeClass)) {
        var state = view.state;
        var _target_firstElementChild_getBoundingClientRect = target.firstElementChild.getBoundingClientRect(), left = _target_firstElementChild_getBoundingClientRect.left, right = _target_firstElementChild_getBoundingClientRect.right;
        if (event.clientX < left || event.clientX > right) {
            var isBefore = event.clientX < left;
            view.dispatch(state.tr.setSelection(new _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"](state.doc.resolve(nodePos + (isBefore ? 0 : node.nodeSize)), isBefore ? _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].beforeNode : _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].afterNode)));
            return true;
        }
    }
    return false;
}
function handleClick(view, pos, event) {
    var _$adjustedPos_nodeAfter;
    if (!view.editable) return false;
    var $pos = view.state.doc.resolve(pos);
    var target = domAtPos(view, pos);
    // 点击到元素上默认选中，不绘制gapcursor
    if (target && target.contains(event.target)) {
        return false;
    }
    var targetInfo = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!targetInfo) {
        return false;
    }
    var inside = targetInfo.inside, nearPos = targetInfo.pos;
    var $adjustedPos = $pos;
    var bias = 0;
    if (inside === -1) {
        // 此前判断点击左边界的条件存在缺陷，在学城里存在目录树会导致offsetLeft和预期不一致 ONES 63937624
        var leftOfFirstNode = view.nodeDOM(0).getBoundingClientRect() ? view.nodeDOM(0).getBoundingClientRect().left : view.nodeDOM(0).offsetLeft;
        // 点击左边边界
        if (event.clientX < leftOfFirstNode) {
            var _$pos_nodeAfter, _$pos_nodeAfter1;
            // 涉及到位置相关信息，nodeDOM方法不好覆盖，暂时没有添加单测
            bias = 1;
            if ([
                "paragraph",
                "heading",
                "list_item",
                "task_item"
            ].includes((_$pos_nodeAfter = $pos.nodeAfter) === null || _$pos_nodeAfter === void 0 ? void 0 : _$pos_nodeAfter.type.name)) {
                $adjustedPos = view.state.doc.resolve(pos + 1);
            }
            if ([
                "ordered_list",
                "task_list",
                "bullet_list"
            ].includes((_$pos_nodeAfter1 = $pos.nodeAfter) === null || _$pos_nodeAfter1 === void 0 ? void 0 : _$pos_nodeAfter1.type.name)) {
                $adjustedPos = view.state.doc.resolve(pos + 2);
            }
        } else {
            var _$pos_nodeBefore;
            bias = -1;
            if ([
                "paragraph",
                "heading"
            ].includes((_$pos_nodeBefore = $pos.nodeBefore) === null || _$pos_nodeBefore === void 0 ? void 0 : _$pos_nodeBefore.type.name)) {
                // 点击右边边界
                $adjustedPos = view.state.doc.resolve(pos - 1);
            }
        }
    }
    // TODO：这块逻辑需要统一治理
    if ([
        "list_item",
        "task_item"
    ].includes((_$adjustedPos_nodeAfter = $adjustedPos.nodeAfter) === null || _$adjustedPos_nodeAfter === void 0 ? void 0 : _$adjustedPos_nodeAfter.type.name)) {
        $adjustedPos = view.state.doc.resolve(pos + 1);
    }
    // 点击到单元格内的空白处，矫正位置
    var parent = $adjustedPos.node($adjustedPos.depth);
    if ([
        "cell",
        "header_cell"
    ].includes(parent.type.spec.tableRole) && $adjustedPos.nodeBefore === parent.lastChild && !allowGapCursor(parent.lastChild)) {
        $adjustedPos = prosemirror_state__WEBPACK_IMPORTED_MODULE_1__["Selection"].near($pos, -1).$head;
    }
    if (!_citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"].valid($adjustedPos)) {
        return false;
    }
    if (inside && inside > -1 && inside + 1 === nearPos) {
        if ($adjustedPos.nodeBefore && $adjustedPos.nodeBefore.nodeSize === 1) {
            return false;
        }
    }
    var gapCursorType = _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"].getType($adjustedPos, bias);
    if (gapCursorType) {
        // 设置 GapCursor 之前确保 view 是聚焦状态，解决无法点击到代码块前面的问题
        // @see https://km.sankuai.com/page/1227428924
        if (!view.hasFocus()) {
            view.dom.focus();
        }
        view.dispatch(view.state.tr.setSelection(new _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"]($adjustedPos, gapCursorType)));
        return true;
    }
    if (inside > -1 && prosemirror_state__WEBPACK_IMPORTED_MODULE_1__["NodeSelection"].isSelectable(view.state.doc.nodeAt(inside))) {
        return false;
    }
    view.dispatch(view.state.tr.setSelection(prosemirror_state__WEBPACK_IMPORTED_MODULE_1__["TextSelection"].near($pos)));
    return true;
}
var handleKeyUp = function(view) {
    var _view_state = view.state, $from = _view_state.selection.$from, selection = _view_state.selection;
    if (!selection.empty) {
        return false;
    }
    var nodeBefore = $from.nodeBefore, nodeAfter = $from.nodeAfter;
    if (nodeBefore && !nodeBefore.isText && nodeBefore.isInline && allowGapCursor(nodeBefore) && nodeBefore.type.name !== "hard_break") {
        view.dispatch(view.state.tr.setSelection(new _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"]($from, _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].afterInlineNode)));
        return true;
    }
    if (nodeAfter && !nodeAfter.isText && nodeAfter.isInline && nodeAfter.type.spec.allowGapCursor && nodeAfter.type.name !== "hard_break" && !(nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.isText)) {
        view.dispatch(view.state.tr.setSelection(new _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* GapCursor */ "a"]($from, _citadel_kit_GapcursorSelection_index_js__WEBPACK_IMPORTED_MODULE_5__[/* gapCursorSituation */ "d"].beforeInlineNode)));
        return true;
    }
    return false;
};
var pluginKey = new prosemirror_state__WEBPACK_IMPORTED_MODULE_1__["PluginKey"]("gap_cursor");
var GapCursorExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(GapCursorExtension, CommonExtension);
    var _super = _createSuper(GapCursorExtension);
    function GapCursorExtension() {
        _classCallCheck(this, GapCursorExtension);
        return _super.apply(this, arguments);
    }
    var _proto = GapCursorExtension.prototype;
    _proto.plugin = function plugin(param) {
        var getView = param.getView;
        return new prosemirror_state__WEBPACK_IMPORTED_MODULE_1__["Plugin"]({
            key: pluginKey,
            props: {
                decorations: function decorations(state) {
                    return this.getState(state);
                },
                handleClickOn: handleClickOn,
                handleClick: handleClick,
                handleDOMEvents: {
                    keyup: handleKeyUp
                }
            },
            state: {
                init: function init() {
                    return prosemirror_view__WEBPACK_IMPORTED_MODULE_2__[/* DecorationSet */ "b"].empty;
                },
                apply: function apply(tr, value, oldState, newState) {
                    return getDrawGapCursor(newState, getView);
                }
            },
            view: function view(editorView) {
                var resizeHandler = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function() {
                    var gapCursorDOM = editorView.dom.querySelector(".".concat(PM_GAP_CURSOR_CLASS_NAME));
                    if (gapCursorDOM) {
                        updateGapCursorStyle(gapCursorDOM, editorView.state, function() {
                            return editorView;
                        });
                    }
                }, 500);
                window.addEventListener("resize", resizeHandler);
                return {
                    destroy: function destroy() {
                        window.removeEventListener("resize", resizeHandler);
                    }
                };
            }
        });
    };
    _createClass(GapCursorExtension, [
        {
            key: "name",
            get: function get() {
                return "gap_cursor";
            }
        }
    ]);
    return GapCursorExtension;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_3__[/* CommonExtension */ "a"]);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ "5740":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-sidebar/mc-sidebar.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_sidebarvue_type_script_lang_js_ = ({
  name: 'McSidebar',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'activeKey': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-sidebar', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-sidebar/mc-sidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_sidebar_mc_sidebarvue_type_script_lang_js_ = (mc_sidebarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-sidebar/mc-sidebar.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_sidebar_mc_sidebarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_sidebar = (component.exports);
// CONCATENATED MODULE: ./components/mc-sidebar/index.js


/* istanbul ignore next */

mc_sidebar.install = function (Vue) {
  Vue.component(mc_sidebar.name, mc_sidebar);
};

/* harmony default export */ var components_mc_sidebar = __webpack_exports__["default"] = (mc_sidebar);

/***/ }),

/***/ "576a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Decoration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DecorationSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditorView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return endComposition; });
/* unused harmony export __parseFromClipboard */
/* unused harmony export __serializeForClipboard */
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ffb");
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6f27");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prosemirror_model__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prosemirror_transform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b923");
/* harmony import */ var prosemirror_transform__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prosemirror_transform__WEBPACK_IMPORTED_MODULE_2__);




var result = {};

if (typeof navigator != "undefined" && typeof document != "undefined") {
  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

  result.mac = /Mac/.test(navigator.platform);
  var ie = result.ie = !!(ie_upto10 || ie_11up || ie_edge);
  result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
  result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
  result.gecko_version = result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
  result.chrome = !!chrome;
  result.chrome_version = chrome && +chrome[1];
  result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
  result.android = /Android \d/.test(navigator.userAgent);
  result.webkit = "webkitFontSmoothing" in document.documentElement.style;
  result.safari = /Apple Computer/.test(navigator.vendor);
  result.webkit_version = result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}

var domIndex = function(node) {
  for (var index = 0;; index++) {
    node = node.previousSibling;
    if (!node) { return index }
  }
};

var parentNode = function(node) {
  var parent = node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent
};

var textRange = function(node, from, to) {
  var range = document.createRange();
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range
};

// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
                        scanFor(node, off, targetNode, targetOff, 1))
};

var atomElements = /^(img|br|input|textarea|hr)$/i;

function scanFor(node, off, targetNode, targetOff, dir) {
  for (;;) {
    if (node == targetNode && off == targetOff) { return true }
    if (off == (dir < 0 ? 0 : nodeSize(node))) {
      var parent = node.parentNode;
      if (parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false")
        { return false }
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
      if (node.contentEditable == "false") { return false }
      off = dir < 0 ? nodeSize(node) : 0;
    } else {
      return false
    }
  }
}

function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isOnEdge(node, offset, parent) {
  for (var atStart = offset == 0, atEnd = offset == nodeSize(node); atStart || atEnd;) {
    if (node == parent) { return true }
    var index = domIndex(node);
    node = node.parentNode;
    if (!node) { return false }
    atStart = atStart && index == 0;
    atEnd = atEnd && index == nodeSize(node);
  }
}

function hasBlockDesc(dom) {
  var desc;
  for (var cur = dom; cur; cur = cur.parentNode) { if (desc = cur.pmViewDesc) { break } }
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom)
}

// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
var selectionCollapsed = function(domSel) {
  var collapsed = domSel.isCollapsed;
  if (collapsed && result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed)
    { collapsed = false; }
  return collapsed
};

function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event
}

function windowRect(doc) {
  return {left: 0, right: doc.documentElement.clientWidth,
          top: 0, bottom: doc.documentElement.clientHeight}
}

function getSide(value, side) {
  return typeof value == "number" ? value : value[side]
}

function clientRect(node) {
  var rect = node.getBoundingClientRect();
  // Make sure scrollbar width isn't included in the rectangle
  return {left: rect.left, right: rect.left + node.clientWidth,
          top: rect.top, bottom: rect.top + node.clientHeight}
}

function scrollRectIntoView(view, rect, startDOM) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  var doc = view.dom.ownerDocument;
  for (var parent = startDOM || view.dom;; parent = parentNode(parent)) {
    if (!parent) { break }
    if (parent.nodeType != 1) { continue }
    var atTop = parent == doc.body || parent.nodeType != 1;
    var bounding = atTop ? windowRect(doc) : clientRect(parent);
    var moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
      { moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top")); }
    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
      { moveY = rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom"); }
    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
      { moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left")); }
    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
      { moveX = rect.right - bounding.right + getSide(scrollMargin, "right"); }
    if (moveX || moveY) {
      if (atTop) {
        doc.defaultView.scrollBy(moveX, moveY);
      } else {
        var startX = parent.scrollLeft, startY = parent.scrollTop;
        if (moveY) { parent.scrollTop += moveY; }
        if (moveX) { parent.scrollLeft += moveX; }
        var dX = parent.scrollLeft - startX, dY = parent.scrollTop - startY;
        rect = {left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY};
      }
    }
    if (atTop) { break }
  }
}

// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  var refDOM, refTop;
  for (var x = (rect.left + rect.right) / 2, y = startY + 1;
       y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x, y);
    if (dom == view.dom || !view.dom.contains(dom)) { continue }
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break
    }
  }
  return {refDOM: refDOM, refTop: refTop, stack: scrollStack(view.dom)}
}

function scrollStack(dom) {
  var stack = [], doc = dom.ownerDocument;
  for (; dom; dom = parentNode(dom)) {
    stack.push({dom: dom, top: dom.scrollTop, left: dom.scrollLeft});
    if (dom == doc) { break }
  }
  return stack
}

// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos(ref) {
  var refDOM = ref.refDOM;
  var refTop = ref.refTop;
  var stack = ref.stack;

  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}

function restoreScrollStack(stack, dTop) {
  for (var i = 0; i < stack.length; i++) {
    var ref = stack[i];
    var dom = ref.dom;
    var top = ref.top;
    var left = ref.left;
    if (dom.scrollTop != top + dTop) { dom.scrollTop = top + dTop; }
    if (dom.scrollLeft != left) { dom.scrollLeft = left; }
  }
}

var preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function focusPreventScroll(dom) {
  if (dom.setActive) { return dom.setActive() } // in IE
  if (preventScrollSupported) { return dom.focus(preventScrollSupported) }

  var stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = {preventScroll: true};
      return true
    }
  } : undefined);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}

function findOffsetInNode(node, coords) {
  var closest, dxClosest = 2e8, coordsClosest, offset = 0;
  var rowBot = coords.top, rowTop = coords.top;
  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    var rects = (void 0);
    if (child.nodeType == 1) { rects = child.getClientRects(); }
    else if (child.nodeType == 3) { rects = textRange(child).getClientRects(); }
    else { continue }

    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left
            : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {left: rect.right < coords.left ? rect.right : rect.left, top: coords.top} : coords;
          if (child.nodeType == 1 && dx)
            { offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0); }
          continue
        }
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                       coords.left >= rect.left && coords.top >= rect.bottom))
        { offset = childIndex + 1; }
    }
  }
  if (closest && closest.nodeType == 3) { return findOffsetInText(closest, coordsClosest) }
  if (!closest || (dxClosest && closest.nodeType == 1)) { return {node: node, offset: offset} }
  return findOffsetInNode(closest, coordsClosest)
}

function findOffsetInText(node, coords) {
  var len = node.nodeValue.length;
  var range = document.createRange();
  for (var i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    var rect = singleRect(range, 1);
    if (rect.top == rect.bottom) { continue }
    if (inRect(coords, rect))
      { return {node: node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)} }
  }
  return {node: node, offset: 0}
}

function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1&&
    coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1
}

function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
    { return parent }
  return dom
}

function posFromElement(view, elt, coords) {
  var ref = findOffsetInNode(elt, coords);
  var node = ref.node;
  var offset = ref.offset;
  var bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    var rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset, bias)
}

function posFromCaret(view, node, offset, coords) {
  // Browser (in caretPosition/RangeFromPoint) will agressively
  // normalize towards nearby inline nodes. Since we are interested in
  // positions between block nodes too, we first walk up the hierarchy
  // of nodes to see if there are block nodes that the coordinates
  // fall outside of. If so, we take the position before/after that
  // block. If not, we call `posFromDOM` on the raw node/offset.
  var outside = -1;
  for (var cur = node;;) {
    if (cur == view.dom) { break }
    var desc = view.docView.nearestDesc(cur, true);
    if (!desc) { return null }
    if (desc.node.isBlock && desc.parent) {
      var rect = desc.dom.getBoundingClientRect();
      if (rect.left > coords.left || rect.top > coords.top) { outside = desc.posBefore; }
      else if (rect.right < coords.left || rect.bottom < coords.top) { outside = desc.posAfter; }
      else { break }
    }
    cur = desc.dom.parentNode;
  }
  return outside > -1 ? outside : view.docView.posFromDOM(node, offset)
}

function elementFromPoint(element, coords, box) {
  var len = element.childNodes.length;
  if (len && box.top < box.bottom) {
    for (var startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;) {
      var child = element.childNodes[i];
      if (child.nodeType == 1) {
        var rects = child.getClientRects();
        for (var j = 0; j < rects.length; j++) {
          var rect = rects[j];
          if (inRect(coords, rect)) { return elementFromPoint(child, coords, rect) }
        }
      }
      if ((i = (i + 1) % len) == startI) { break }
    }
  }
  return element
}

// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
  var assign, assign$1;

  var root = view.root, node, offset;
  if (root.caretPositionFromPoint) {
    try { // Firefox throws for this call in hard-to-predict circumstances (#994)
      var pos$1 = root.caretPositionFromPoint(coords.left, coords.top);
      if (pos$1) { ((assign = pos$1, node = assign.offsetNode, offset = assign.offset)); }
    } catch (_) {}
  }
  if (!node && root.caretRangeFromPoint) {
    var range = root.caretRangeFromPoint(coords.left, coords.top);
    if (range) { ((assign$1 = range, node = assign$1.startContainer, offset = assign$1.startOffset)); }
  }

  var elt = root.elementFromPoint(coords.left, coords.top + 1), pos;
  // Safari's caretRangeFromPoint returns nonsense when on a draggable element
  if (result.safari && elt.draggable) { node = offset = null; }
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    var box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box)) { return null }
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt) { return null }
  }
  elt = targetKludge(elt, coords);
  if (node) {
    if (result.gecko && node.nodeType == 1) {
      // Firefox will sometimes return offsets into <input> nodes, which
      // have no actual children, from caretPositionFromPoint (#953)
      offset = Math.min(offset, node.childNodes.length);
      // It'll also move the returned position before image nodes,
      // even if those are behind it.
      if (offset < node.childNodes.length) {
        var next = node.childNodes[offset], box$1;
        if (next.nodeName == "IMG" && (box$1 = next.getBoundingClientRect()).right <= coords.left &&
            box$1.bottom > coords.top)
          { offset++; }
      }
    }
    // Suspiciously specific kludge to work around caret*FromPoint
    // never returning a position at the end of the document
    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
        coords.top > node.lastChild.getBoundingClientRect().bottom)
      { pos = view.state.doc.content.size; }
    // Ignore positions directly after a BR, since caret*FromPoint
    // 'round up' positions that would be more accurately placed
    // before the BR node.
    else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
      { pos = posFromCaret(view, node, offset, coords); }
  }
  if (pos == null) { pos = posFromElement(view, elt, coords); }

  var desc = view.docView.nearestDesc(elt, true);
  return {pos: pos, inside: desc ? desc.posAtStart - desc.border : -1}
}

function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
}

// : (EditorView, number) → {left: number, top: number, right: number, bottom: number}
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;

  // These browsers support querying empty text ranges
  if (node.nodeType == 3 && (result.webkit || result.gecko)) {
    var rect = singleRect(textRange(node, offset, offset), 0);
    // Firefox returns bad results (the position before the space)
    // when querying a position directly after line-broken
    // whitespace. Detect this situation and and kludge around it
    if (result.gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
      var rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
      if (rectBefore.top == rect.top) {
        var rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
        if (rectAfter.top != rect.top)
          { return flattenV(rectAfter, rectAfter.left < rectBefore.left) }
      }
    }
    return rect
  }

  if (node.nodeType == 1 && !view.state.doc.resolve(pos).parent.inlineContent) {
    // Return a horizontal line in block context
    var top = true, rect$1;
    if (offset < node.childNodes.length) {
      var after = node.childNodes[offset];
      if (after.nodeType == 1) { rect$1 = after.getBoundingClientRect(); }
    }
    if (!rect$1 && offset) {
      var before = node.childNodes[offset - 1];
      if (before.nodeType == 1) { rect$1 = before.getBoundingClientRect(); top = false; }
    }
    return flattenH(rect$1 || node.getBoundingClientRect(), top)
  }

  // Not Firefox/Chrome, or not in a text node, so we have to use
  // actual element/character rectangles to get a solution (this part
  // is not very bidi-safe)
  //
  // Try the left side first, fall back to the right one if that
  // doesn't work.
  for (var dir = -1; dir < 2; dir += 2) {
    if (dir < 0 && offset) {
      var prev = (void 0), target = node.nodeType == 3 ? textRange(node, offset - 1, offset)
          : (prev = node.childNodes[offset - 1]).nodeType == 3 ? textRange(prev)
          : prev.nodeType == 1 && prev.nodeName != "BR" ? prev : null; // BR nodes tend to only return the rectangle before them
      if (target) {
        var rect$2 = singleRect(target, 1);
        if (rect$2.top < rect$2.bottom) { return flattenV(rect$2, false) }
      }
    } else if (dir > 0 && offset < nodeSize(node)) {
      var next = (void 0), target$1 = node.nodeType == 3 ? textRange(node, offset, offset + 1)
          : (next = node.childNodes[offset]).nodeType == 3 ? textRange(next)
          : next.nodeType == 1 ? next : null;
      if (target$1) {
        var rect$3 = singleRect(target$1, -1);
        if (rect$3.top < rect$3.bottom) { return flattenV(rect$3, true) }
      }
    }
  }
  // All else failed, just try to get a rectangle for the target node
  return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, 0), false)
}

function flattenV(rect, left) {
  if (rect.width == 0) { return rect }
  var x = left ? rect.left : rect.right;
  return {top: rect.top, bottom: rect.bottom, left: x, right: x}
}

function flattenH(rect, top) {
  if (rect.height == 0) { return rect }
  var y = top ? rect.top : rect.bottom;
  return {top: y, bottom: y, left: rect.left, right: rect.right}
}

function withFlushedState(view, state, f) {
  var viewState = view.state, active = view.root.activeElement;
  if (viewState != state) { view.updateState(state); }
  if (active != view.dom) { view.focus(); }
  try {
    return f()
  } finally {
    if (viewState != state) { view.updateState(viewState); }
    if (active != view.dom) { active.focus(); }
  }
}

// : (EditorView, number, number)
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$anchor.min(sel.$head) : sel.$anchor.max(sel.$head);
  return withFlushedState(view, state, function () {
    var ref = view.docView.domFromPos($pos.pos);
    var dom = ref.node;
    for (;;) {
      var nearest = view.docView.nearestDesc(dom, true);
      if (!nearest) { break }
      if (nearest.node.isBlock) { dom = nearest.dom; break }
      dom = nearest.dom.parentNode;
    }
    var coords = coordsAtPos(view, $pos.pos);
    for (var child = dom.firstChild; child; child = child.nextSibling) {
      var boxes = (void 0);
      if (child.nodeType == 1) { boxes = child.getClientRects(); }
      else if (child.nodeType == 3) { boxes = textRange(child, 0, child.nodeValue.length).getClientRects(); }
      else { continue }
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        if (box.bottom > box.top && (dir == "up" ? box.bottom < coords.top + 1 : box.top > coords.bottom - 1))
          { return false }
      }
    }
    return true
  })
}

var maybeRTL = /[\u0590-\u08ac]/;

function endOfTextblockHorizontal(view, state, dir) {
  var ref = state.selection;
  var $head = ref.$head;
  if (!$head.parent.isTextblock) { return false }
  var offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
  var sel = getSelection();
  // If the textblock is all LTR, or the browser doesn't support
  // Selection.modify (Edge), fall back to a primitive approach
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    { return dir == "left" || dir == "backward" ? atStart : atEnd }

  return withFlushedState(view, state, function () {
    // This is a huge hack, but appears to be the best we can
    // currently do: use `Selection.modify` to move the selection by
    // one character, and see if that moves the cursor out of the
    // textblock (or doesn't move it at all, when at the start/end of
    // the document).
    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
    var oldBidiLevel = sel.caretBidiLevel; // Only for Firefox
    sel.modify("move", dir, "character");
    var parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    var result = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) ||
        (oldNode == sel.focusNode && oldOff == sel.focusOffset);
    // Restore the previous selection
    sel.removeAllRanges();
    sel.addRange(oldRange);
    if (oldBidiLevel != null) { sel.caretBidiLevel = oldBidiLevel; }
    return result
  })
}

var cachedState = null, cachedDir = null, cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) { return cachedResult }
  cachedState = state; cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down"
    ? endOfTextblockVertical(view, state, dir)
    : endOfTextblockHorizontal(view, state, dir)
}

// NodeView:: interface
//
// By default, document nodes are rendered using the result of the
// [`toDOM`](#model.NodeSpec.toDOM) method of their spec, and managed
// entirely by the editor. For some use cases, such as embedded
// node-specific editing interfaces, you want more control over
// the behavior of a node's in-editor representation, and need to
// [define](#view.EditorProps.nodeViews) a custom node view.
//
// Mark views only support `dom` and `contentDOM`, and don't support
// any of the node view methods.
//
// Objects returned as node views must conform to this interface.
//
//   dom:: ?dom.Node
//   The outer DOM node that represents the document node. When not
//   given, the default strategy is used to create a DOM node.
//
//   contentDOM:: ?dom.Node
//   The DOM node that should hold the node's content. Only meaningful
//   if the node view also defines a `dom` property and if its node
//   type is not a leaf node type. When this is present, ProseMirror
//   will take care of rendering the node's children into it. When it
//   is not present, the node view itself is responsible for rendering
//   (or deciding not to render) its child nodes.
//
//   update:: ?(node: Node, decorations: [Decoration]) → bool
//   When given, this will be called when the view is updating itself.
//   It will be given a node (possibly of a different type), and an
//   array of active decorations (which are automatically drawn, and
//   the node view may ignore if it isn't interested in them), and
//   should return true if it was able to update to that node, and
//   false otherwise. If the node view has a `contentDOM` property (or
//   no `dom` property), updating its child nodes will be handled by
//   ProseMirror.
//
//   selectNode:: ?()
//   Can be used to override the way the node's selected status (as a
//   node selection) is displayed.
//
//   deselectNode:: ?()
//   When defining a `selectNode` method, you should also provide a
//   `deselectNode` method to remove the effect again.
//
//   setSelection:: ?(anchor: number, head: number, root: dom.Document)
//   This will be called to handle setting the selection inside the
//   node. The `anchor` and `head` positions are relative to the start
//   of the node. By default, a DOM selection will be created between
//   the DOM positions corresponding to those positions, but if you
//   override it you can do something else.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to prevent the editor view from trying to handle some
//   or all DOM events that bubble up from the node view. Events for
//   which this returns true are not handled by the editor.
//
//   ignoreMutation:: ?(dom.MutationRecord) → bool
//   Called when a DOM
//   [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver)
//   or a selection change happens within the view. When the change is
//   a selection change, the record will have a `type` property of
//   `"selection"` (which doesn't occur for native mutation records).
//   Return false if the editor should re-read the selection or
//   re-parse the range around the mutation, true if it can safely be
//   ignored.
//
//   destroy:: ?()
//   Called when the node view is removed from the editor or the whole
//   editor is destroyed.

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.

var NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;

// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
var ViewDesc = function ViewDesc(parent, children, dom, contentDOM) {
  this.parent = parent;
  this.children = children;
  this.dom = dom;
  // An expando property on the DOM node provides a link back to its
  // description.
  dom.pmViewDesc = this;
  // This is the node that holds the child views. It may be null for
  // descs that don't have children.
  this.contentDOM = contentDOM;
  this.dirty = NOT_DIRTY;
};

var prototypeAccessors = { beforePosition: { configurable: true },size: { configurable: true },border: { configurable: true },posBefore: { configurable: true },posAtStart: { configurable: true },posAfter: { configurable: true },posAtEnd: { configurable: true },contentLost: { configurable: true } };

// Used to check whether a given description corresponds to a
// widget/mark/node.
ViewDesc.prototype.matchesWidget = function matchesWidget () { return false };
ViewDesc.prototype.matchesMark = function matchesMark () { return false };
ViewDesc.prototype.matchesNode = function matchesNode () { return false };
ViewDesc.prototype.matchesHack = function matchesHack () { return false };

prototypeAccessors.beforePosition.get = function () { return false };

// : () → ?ParseRule
// When parsing in-editor content (in domchange.js), we allow
// descriptions to determine the parse rules that should be used to
// parse them.
ViewDesc.prototype.parseRule = function parseRule () { return null };

// : (dom.Event) → bool
// Used by the editor's event handler to ignore events that come
// from certain descs.
ViewDesc.prototype.stopEvent = function stopEvent () { return false };

// The size of the content represented by this desc.
prototypeAccessors.size.get = function () {
  var size = 0;
  for (var i = 0; i < this.children.length; i++) { size += this.children[i].size; }
  return size
};

// For block nodes, this represents the space taken up by their
// start/end tokens.
prototypeAccessors.border.get = function () { return 0 };

ViewDesc.prototype.destroy = function destroy () {
  this.parent = null;
  if (this.dom.pmViewDesc == this) { this.dom.pmViewDesc = null; }
  for (var i = 0; i < this.children.length; i++)
    { this.children[i].destroy(); }
};

ViewDesc.prototype.posBeforeChild = function posBeforeChild (child) {
  for (var i = 0, pos = this.posAtStart; i < this.children.length; i++) {
    var cur = this.children[i];
    if (cur == child) { return pos }
    pos += cur.size;
  }
};

prototypeAccessors.posBefore.get = function () {
  return this.parent.posBeforeChild(this)
};

prototypeAccessors.posAtStart.get = function () {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0
};

prototypeAccessors.posAfter.get = function () {
  return this.posBefore + this.size
};

prototypeAccessors.posAtEnd.get = function () {
  return this.posAtStart + this.size - 2 * this.border
};

// : (dom.Node, number, ?number) → number
ViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
  // If the DOM position is in the content, use the child desc after
  // it to figure out a position.
  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
    if (bias < 0) {
      var domBefore, desc;
      if (dom == this.contentDOM) {
        domBefore = dom.childNodes[offset - 1];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domBefore = dom.previousSibling;
      }
      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) { domBefore = domBefore.previousSibling; }
      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart
    } else {
      var domAfter, desc$1;
      if (dom == this.contentDOM) {
        domAfter = dom.childNodes[offset];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domAfter = dom.nextSibling;
      }
      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) { domAfter = domAfter.nextSibling; }
      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd
    }
  }
  // Otherwise, use various heuristics, falling back on the bias
  // parameter, to determine whether to return the position at the
  // start or at the end of this view desc.
  var atEnd;
  if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
    atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
  } else if (this.dom.firstChild) {
    if (offset == 0) { for (var search = dom;; search = search.parentNode) {
      if (search == this.dom) { atEnd = false; break }
      if (search.parentNode.firstChild != search) { break }
    } }
    if (atEnd == null && offset == dom.childNodes.length) { for (var search$1 = dom;; search$1 = search$1.parentNode) {
      if (search$1 == this.dom) { atEnd = true; break }
      if (search$1.parentNode.lastChild != search$1) { break }
    } }
  }
  return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart
};

// Scan up the dom finding the first desc that is a descendant of
// this one.
ViewDesc.prototype.nearestDesc = function nearestDesc (dom, onlyNodes) {
  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
    var desc = this.getDesc(cur);
    if (desc && (!onlyNodes || desc.node)) {
      // If dom is outside of this desc's nodeDOM, don't count it.
      if (first && desc.nodeDOM &&
          !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : desc.nodeDOM == dom))
        { first = false; }
      else
        { return desc }
    }
  }
};

ViewDesc.prototype.getDesc = function getDesc (dom) {
  var desc = dom.pmViewDesc;
  for (var cur = desc; cur; cur = cur.parent) { if (cur == this) { return desc } }
};

ViewDesc.prototype.posFromDOM = function posFromDOM (dom, offset, bias) {
  for (var scan = dom;; scan = scan.parentNode) {
    var desc = this.getDesc(scan);
    if (desc) { return desc.localPosFromDOM(dom, offset, bias) }
  }
};

// : (number) → ?NodeViewDesc
// Find the desc for the node after the given pos, if any. (When a
// parent node overrode rendering, there might not be one.)
ViewDesc.prototype.descAt = function descAt (pos) {
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (offset == pos && end != offset) {
      while (!child.border && child.children.length) { child = child.children[0]; }
      return child
    }
    if (pos < end) { return child.descAt(pos - offset - child.border) }
    offset = end;
  }
};

// : (number) → {node: dom.Node, offset: number}
ViewDesc.prototype.domFromPos = function domFromPos (pos) {
  if (!this.contentDOM) { return {node: this.dom, offset: 0} }
  for (var offset = 0, i = 0;; i++) {
    if (offset == pos) {
      while (i < this.children.length && (this.children[i].beforePosition || this.children[i].dom.parentNode != this.contentDOM)) { i++; }
      return {node: this.contentDOM,
              offset: i == this.children.length ? this.contentDOM.childNodes.length : domIndex(this.children[i].dom)}
    }
    if (i == this.children.length) { throw new Error("Invalid position " + pos) }
    var child = this.children[i], end = offset + child.size;
    if (pos < end) { return child.domFromPos(pos - offset - child.border) }
    offset = end;
  }
};

// Used to find a DOM range in a single parent for a given changed
// range.
ViewDesc.prototype.parseRange = function parseRange (from, to, base) {
    if ( base === void 0 ) base = 0;

  if (this.children.length == 0)
    { return {node: this.contentDOM, from: from, to: to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length} }

  var fromOffset = -1, toOffset = -1;
  for (var offset = base, i = 0;; i++) {
    var child = this.children[i], end = offset + child.size;
    if (fromOffset == -1 && from <= end) {
      var childBase = offset + child.border;
      // FIXME maybe descend mark views to parse a narrower range?
      if (from >= childBase && to <= end - child.border && child.node &&
          child.contentDOM && this.contentDOM.contains(child.contentDOM))
        { return child.parseRange(from, to, childBase) }

      from = offset;
      for (var j = i; j > 0; j--) {
        var prev = this.children[j - 1];
        if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
          fromOffset = domIndex(prev.dom) + 1;
          break
        }
        from -= prev.size;
      }
      if (fromOffset == -1) { fromOffset = 0; }
    }
    if (fromOffset > -1 && to <= end) {
      to = end;
      for (var j$1 = i + 1; j$1 < this.children.length; j$1++) {
        var next = this.children[j$1];
        if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
          toOffset = domIndex(next.dom);
          break
        }
        to += next.size;
      }
      if (toOffset == -1) { toOffset = this.contentDOM.childNodes.length; }
      break
    }
    offset = end;
  }
  return {node: this.contentDOM, from: from, to: to, fromOffset: fromOffset, toOffset: toOffset}
};

ViewDesc.prototype.emptyChildAt = function emptyChildAt (side) {
  if (this.border || !this.contentDOM || !this.children.length) { return false }
  var child = this.children[side < 0 ? 0 : this.children.length - 1];
  return child.size == 0 || child.emptyChildAt(side)
};

// : (number) → dom.Node
ViewDesc.prototype.domAfterPos = function domAfterPos (pos) {
  var ref = this.domFromPos(pos);
    var node = ref.node;
    var offset = ref.offset;
  if (node.nodeType != 1 || offset == node.childNodes.length)
    { throw new RangeError("No node after pos " + pos) }
  return node.childNodes[offset]
};

// : (number, number, dom.Document)
// View descs are responsible for setting any selection that falls
// entirely inside of them, so that custom implementations can do
// custom things with the selection. Note that this falls apart when
// a selection starts in such a node and ends in another, in which
// case we just use whatever domFromPos produces as a best effort.
ViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
  // If the selection falls entirely in a child, give it to that child
  var from = Math.min(anchor, head), to = Math.max(anchor, head);
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (from > offset && to < end)
      { return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force) }
    offset = end;
  }

  var anchorDOM = this.domFromPos(anchor), headDOM = this.domFromPos(head);
  var domSel = root.getSelection();

  if (!force &&
      isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) &&
      isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset))
    { return }

  // Selection.extend can be used to create an 'inverted' selection
  // (one where the focus is before the anchor), but not all
  // browsers support it yet.
  var domSelExtended = false;
  if (domSel.extend || anchor == head) {
    domSel.collapse(anchorDOM.node, anchorDOM.offset);
    try {
      if (anchor != head) { domSel.extend(headDOM.node, headDOM.offset); }
      domSelExtended = true;
    } catch (err) {
      // In some cases with Chrome the selection is empty after calling
      // collapse, even when it should be valid. This appears to be a bug, but
      // it is difficult to isolate. If this happens fallback to the old path
      // without using extend.
      if (!(err instanceof DOMException)) { throw err }
    }
  }
  if (!domSelExtended) {
    if (anchor > head) { var tmp = anchorDOM; anchorDOM = headDOM; headDOM = tmp; }
    var range = document.createRange();
    range.setEnd(headDOM.node, headDOM.offset);
    range.setStart(anchorDOM.node, anchorDOM.offset);
    domSel.removeAllRanges();
    domSel.addRange(range);
  }
};

// : (dom.MutationRecord) → bool
ViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
  return !this.contentDOM && mutation.type != "selection"
};

prototypeAccessors.contentLost.get = function () {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM)
};

// Remove a subtree of the element tree that has been touched
// by a DOM change, so that the next update will redraw it.
ViewDesc.prototype.markDirty = function markDirty (from, to) {
  for (var offset = 0, i = 0; i < this.children.length; i++) {
    var child = this.children[i], end = offset + child.size;
    if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
      var startInside = offset + child.border, endInside = end - child.border;
      if (from >= startInside && to <= endInside) {
        this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
        if (from == startInside && to == endInside &&
            (child.contentLost || child.dom.parentNode != this.contentDOM)) { child.dirty = NODE_DIRTY; }
        else { child.markDirty(from - startInside, to - startInside); }
        return
      } else {
        child.dirty = NODE_DIRTY;
      }
    }
    offset = end;
  }
  this.dirty = CONTENT_DIRTY;
};

ViewDesc.prototype.markParentsDirty = function markParentsDirty () {
  var level = 1;
  for (var node = this.parent; node; node = node.parent, level++) {
    var dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
    if (node.dirty < dirty) { node.dirty = dirty; }
  }
};

Object.defineProperties( ViewDesc.prototype, prototypeAccessors );

// Reused array to avoid allocating fresh arrays for things that will
// stay empty anyway.
var nothing = [];

// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
var WidgetViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function WidgetViewDesc(parent, widget, view, pos) {
    var self, dom = widget.type.toDOM;
    if (typeof dom == "function") { dom = dom(view, function () {
      if (!self) { return pos }
      if (self.parent) { return self.parent.posBeforeChild(self) }
    }); }
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = false;
      dom.classList.add("ProseMirror-widget");
    }
    ViewDesc.call(this, parent, nothing, dom, null);
    this.widget = widget;
    self = this;
  }

  if ( ViewDesc ) WidgetViewDesc.__proto__ = ViewDesc;
  WidgetViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  WidgetViewDesc.prototype.constructor = WidgetViewDesc;

  var prototypeAccessors$1 = { beforePosition: { configurable: true } };

  prototypeAccessors$1.beforePosition.get = function () {
    return this.widget.type.side < 0
  };

  WidgetViewDesc.prototype.matchesWidget = function matchesWidget (widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type)
  };

  WidgetViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };

  WidgetViewDesc.prototype.stopEvent = function stopEvent (event) {
    var stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false
  };

  WidgetViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "selection" || this.widget.spec.ignoreSelection
  };

  Object.defineProperties( WidgetViewDesc.prototype, prototypeAccessors$1 );

  return WidgetViewDesc;
}(ViewDesc));

var CompositionViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function CompositionViewDesc(parent, dom, textDOM, text) {
    ViewDesc.call(this, parent, nothing, dom, null);
    this.textDOM = textDOM;
    this.text = text;
  }

  if ( ViewDesc ) CompositionViewDesc.__proto__ = ViewDesc;
  CompositionViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  CompositionViewDesc.prototype.constructor = CompositionViewDesc;

  var prototypeAccessors$2 = { size: { configurable: true } };

  prototypeAccessors$2.size.get = function () { return this.text.length };

  CompositionViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset) {
    if (dom != this.textDOM) { return this.posAtStart + (offset ? this.size : 0) }
    return this.posAtStart + offset
  };

  CompositionViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.textDOM, offset: pos}
  };

  CompositionViewDesc.prototype.ignoreMutation = function ignoreMutation (mut) {
    return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue
   };

  Object.defineProperties( CompositionViewDesc.prototype, prototypeAccessors$2 );

  return CompositionViewDesc;
}(ViewDesc));

// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
var MarkViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function MarkViewDesc(parent, mark, dom, contentDOM) {
    ViewDesc.call(this, parent, [], dom, contentDOM);
    this.mark = mark;
  }

  if ( ViewDesc ) MarkViewDesc.__proto__ = ViewDesc;
  MarkViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  MarkViewDesc.prototype.constructor = MarkViewDesc;

  MarkViewDesc.create = function create (parent, mark, inline, view) {
    var custom = view.nodeViews[mark.type.name];
    var spec = custom && custom(mark, view, inline);
    if (!spec || !spec.dom)
      { spec = prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["DOMSerializer"].renderSpec(document, mark.type.spec.toDOM(mark, inline)); }
    return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom)
  };

  MarkViewDesc.prototype.parseRule = function parseRule () { return {mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM} };

  MarkViewDesc.prototype.matchesMark = function matchesMark (mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark) };

  MarkViewDesc.prototype.markDirty = function markDirty (from, to) {
    ViewDesc.prototype.markDirty.call(this, from, to);
    // Move dirty info to nearest node view
    if (this.dirty != NOT_DIRTY) {
      var parent = this.parent;
      while (!parent.node) { parent = parent.parent; }
      if (parent.dirty < this.dirty) { parent.dirty = this.dirty; }
      this.dirty = NOT_DIRTY;
    }
  };

  MarkViewDesc.prototype.slice = function slice (from, to, view) {
    var copy = MarkViewDesc.create(this.parent, this.mark, true, view);
    var nodes = this.children, size = this.size;
    if (to < size) { nodes = replaceNodes(nodes, to, size, view); }
    if (from > 0) { nodes = replaceNodes(nodes, 0, from, view); }
    for (var i = 0; i < nodes.length; i++) { nodes[i].parent = copy; }
    copy.children = nodes;
    return copy
  };

  return MarkViewDesc;
}(ViewDesc));

// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
var NodeViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    ViewDesc.call(this, parent, node.isLeaf ? nothing : [], dom, contentDOM);
    this.nodeDOM = nodeDOM;
    this.node = node;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    if (contentDOM) { this.updateChildren(view, pos); }
  }

  if ( ViewDesc ) NodeViewDesc.__proto__ = ViewDesc;
  NodeViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  NodeViewDesc.prototype.constructor = NodeViewDesc;

  var prototypeAccessors$3 = { size: { configurable: true },border: { configurable: true } };

  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finnicky
  // implementation details to the user code that they probably will
  // never need.)
  NodeViewDesc.create = function create (parent, node, outerDeco, innerDeco, view, pos) {
    var assign;

    var custom = view.nodeViews[node.type.name], descObj;
    var spec = custom && custom(node, view, function () {
      // (This is a function that allows the custom view to find its
      // own position)
      if (!descObj) { return pos }
      if (descObj.parent) { return descObj.parent.posBeforeChild(descObj) }
    }, outerDeco);

    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node.isText) {
      if (!dom) { dom = document.createTextNode(node.text); }
      else if (dom.nodeType != 3) { throw new RangeError("Text must be rendered as a DOM text node") }
    } else if (!dom) {
((assign = prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["DOMSerializer"].renderSpec(document, node.type.spec.toDOM(node)), dom = assign.dom, contentDOM = assign.contentDOM));
    }
    if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
      if (!dom.hasAttribute("contenteditable")) { dom.contentEditable = false; }
      if (node.type.spec.draggable) { dom.draggable = true; }
    }

    var nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node);

    if (spec)
      { return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM,
                                              spec, view, pos + 1) }
    else if (node.isText)
      { return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) }
    else
      { return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos + 1) }
  };

  NodeViewDesc.prototype.parseRule = function parseRule () {
    var this$1 = this;

    // Experimental kludge to allow opt-in re-parsing of nodes
    if (this.node.type.spec.reparseInView) { return null }
    // FIXME the assumption that this can always return the current
    // attrs means that if the user somehow manages to change the
    // attrs in the dom, that won't be picked up. Not entirely sure
    // whether this is a problem
    var rule = {node: this.node.type.name, attrs: this.node.attrs};
    if (this.node.type.spec.code) { rule.preserveWhitespace = "full"; }
    if (this.contentDOM && !this.contentLost) { rule.contentElement = this.contentDOM; }
    else { rule.getContent = function () { return this$1.contentDOM ? prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].empty : this$1.node.content; }; }
    return rule
  };

  NodeViewDesc.prototype.matchesNode = function matchesNode (node, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node.eq(this.node) &&
      sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco)
  };

  prototypeAccessors$3.size.get = function () { return this.node.nodeSize };

  prototypeAccessors$3.border.get = function () { return this.node.isLeaf ? 0 : 1 };

  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  NodeViewDesc.prototype.updateChildren = function updateChildren (view, pos) {
    var this$1 = this;

    var inline = this.node.inlineContent, off = pos;
    var composition = inline && view.composing && this.localCompositionNode(view, pos);
    var updater = new ViewTreeUpdater(this, composition && composition.node);
    iterDeco(this.node, this.innerDeco, function (widget, i, insideNode) {
      if (widget.spec.marks)
        { updater.syncToMarks(widget.spec.marks, inline, view); }
      else if (widget.type.side >= 0 && !insideNode)
        { updater.syncToMarks(i == this$1.node.childCount ? prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Mark"].none : this$1.node.child(i).marks, inline, view); }
      // If the next node is a desc matching this widget, reuse it,
      // otherwise insert the widget as a new view desc.
      updater.placeWidget(widget, view, off);
    }, function (child, outerDeco, innerDeco, i) {
      // Make sure the wrapping mark descs match the node's marks.
      updater.syncToMarks(child.marks, inline, view);
      // Either find an existing desc that exactly matches this node,
      // and drop the descs before it.
      updater.findNodeMatch(child, outerDeco, innerDeco, i) ||
        // Or try updating the next desc to reflect this node.
        updater.updateNextNode(child, outerDeco, innerDeco, view, i) ||
        // Or just add it as a new desc.
        updater.addNode(child, outerDeco, innerDeco, view, off);
      off += child.nodeSize;
    });
    // Drop all remaining descs after the current position.
    updater.syncToMarks(nothing, inline, view);
    if (this.node.isTextblock) { updater.addTextblockHacks(); }
    updater.destroyRest();

    // Sync the DOM if anything changed
    if (updater.changed || this.dirty == CONTENT_DIRTY) {
      // May have to protect focused DOM from being changed if a composition is active
      if (composition) { this.protectLocalComposition(view, composition); }
      this.renderChildren();
    }
  };

  NodeViewDesc.prototype.renderChildren = function renderChildren () {
    renderDescs(this.contentDOM, this.children);
    if (result.ios) { iosHacks(this.dom); }
  };

  NodeViewDesc.prototype.localCompositionNode = function localCompositionNode (view, pos) {
    // Only do something if both the selection and a focused text node
    // are inside of this node, and the node isn't already part of a
    // view that's a child of this view
    var ref = view.state.selection;
    var from = ref.from;
    var to = ref.to;
    if (!(view.state.selection instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"]) || from < pos || to > pos + this.node.content.size) { return }
    var sel = view.root.getSelection();
    var textNode = nearbyTextNode(sel.focusNode, sel.focusOffset);
    if (!textNode || !this.dom.contains(textNode.parentNode)) { return }

    // Find the text in the focused node in the node, stop if it's not
    // there (may have been modified through other means, in which
    // case it should overwritten)
    var text = textNode.nodeValue;
    var textPos = findTextInFragment(this.node.content, text, from - pos, to - pos);

    return textPos < 0 ? null : {node: textNode, pos: textPos, text: text}
  };

  NodeViewDesc.prototype.protectLocalComposition = function protectLocalComposition (view, ref) {
    var node = ref.node;
    var pos = ref.pos;
    var text = ref.text;

    // The node is already part of a local view desc, leave it there
    if (this.getDesc(node)) { return }

    // Create a composition view for the orphaned nodes
    var topNode = node;
    for (;; topNode = topNode.parentNode) {
      if (topNode.parentNode == this.contentDOM) { break }
      while (topNode.previousSibling) { topNode.parentNode.removeChild(topNode.previousSibling); }
      while (topNode.nextSibling) { topNode.parentNode.removeChild(topNode.nextSibling); }
      if (topNode.pmViewDesc) { topNode.pmViewDesc = null; }
    }
    var desc = new CompositionViewDesc(this, topNode, node, text);
    view.compositionNodes.push(desc);

    // Patch up this.children to contain the composition view
    this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
  };

  // : (Node, [Decoration], DecorationSet, EditorView) → bool
  // If this desc be updated to match the given node decoration,
  // do so and return true.
  NodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY ||
        !node.sameMarkup(this.node)) { return false }
    this.updateInner(node, outerDeco, innerDeco, view);
    return true
  };

  NodeViewDesc.prototype.updateInner = function updateInner (node, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node;
    this.innerDeco = innerDeco;
    if (this.contentDOM) { this.updateChildren(view, this.posAtStart); }
    this.dirty = NOT_DIRTY;
  };

  NodeViewDesc.prototype.updateOuterDeco = function updateOuterDeco (outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco)) { return }
    var needsWrap = this.nodeDOM.nodeType != 1;
    var oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM,
                              computeOuterDeco(this.outerDeco, this.node, needsWrap),
                              computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = null;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  };

  // Mark this node as being the selected node.
  NodeViewDesc.prototype.selectNode = function selectNode () {
    this.nodeDOM.classList.add("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.draggable = true; }
  };

  // Remove selected node marking from this node.
  NodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.nodeDOM.classList.remove("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.removeAttribute("draggable"); }
  };

  Object.defineProperties( NodeViewDesc.prototype, prototypeAccessors$3 );

  return NodeViewDesc;
}(ViewDesc));

// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc);
  return new NodeViewDesc(null, doc, outerDeco, innerDeco, dom, dom, dom, view, 0)
}

var TextViewDesc = /*@__PURE__*/(function (NodeViewDesc) {
  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view);
  }

  if ( NodeViewDesc ) TextViewDesc.__proto__ = NodeViewDesc;
  TextViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  TextViewDesc.prototype.constructor = TextViewDesc;

  TextViewDesc.prototype.parseRule = function parseRule () {
    return {skip: this.nodeDOM.parentNode || true}
  };

  TextViewDesc.prototype.update = function update (node, outerDeco) {
    if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
        !node.sameMarkup(this.node)) { return false }
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue)
      { this.nodeDOM.nodeValue = node.text; }
    this.node = node;
    this.dirty = NOT_DIRTY;
    return true
  };

  TextViewDesc.prototype.inParent = function inParent () {
    var parentDOM = this.parent.contentDOM;
    for (var n = this.nodeDOM; n; n = n.parentNode) { if (n == parentDOM) { return true } }
    return false
  };

  TextViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.nodeDOM, offset: pos}
  };

  TextViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    if (dom == this.nodeDOM) { return this.posAtStart + Math.min(offset, this.node.text.length) }
    return NodeViewDesc.prototype.localPosFromDOM.call(this, dom, offset, bias)
  };

  TextViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "characterData" && mutation.type != "selection"
  };

  TextViewDesc.prototype.slice = function slice (from, to, view) {
    var node = this.node.cut(from, to), dom = document.createTextNode(node.text);
    return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view)
  };

  return TextViewDesc;
}(NodeViewDesc));

// A dummy desc used to tag trailing BR or span nodes created to work
// around contentEditable terribleness.
var BRHackViewDesc = /*@__PURE__*/(function (ViewDesc) {
  function BRHackViewDesc () {
    ViewDesc.apply(this, arguments);
  }

  if ( ViewDesc ) BRHackViewDesc.__proto__ = ViewDesc;
  BRHackViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  BRHackViewDesc.prototype.constructor = BRHackViewDesc;

  BRHackViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
  BRHackViewDesc.prototype.matchesHack = function matchesHack () { return this.dirty == NOT_DIRTY };

  return BRHackViewDesc;
}(ViewDesc));

// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
var CustomNodeViewDesc = /*@__PURE__*/(function (NodeViewDesc) {
  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    this.spec = spec;
  }

  if ( NodeViewDesc ) CustomNodeViewDesc.__proto__ = NodeViewDesc;
  CustomNodeViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  CustomNodeViewDesc.prototype.constructor = CustomNodeViewDesc;

  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  CustomNodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY) { return false }
    if (this.spec.update) {
      var result = this.spec.update(node, outerDeco);
      if (result) { this.updateInner(node, outerDeco, innerDeco, view); }
      return result
    } else if (!this.contentDOM && !node.isLeaf) {
      return false
    } else {
      return NodeViewDesc.prototype.update.call(this, node, outerDeco, innerDeco, view)
    }
  };

  CustomNodeViewDesc.prototype.selectNode = function selectNode () {
    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc.prototype.selectNode.call(this);
  };

  CustomNodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc.prototype.deselectNode.call(this);
  };

  CustomNodeViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, root)
      : NodeViewDesc.prototype.setSelection.call(this, anchor, head, root, force);
  };

  CustomNodeViewDesc.prototype.destroy = function destroy () {
    if (this.spec.destroy) { this.spec.destroy(); }
    NodeViewDesc.prototype.destroy.call(this);
  };

  CustomNodeViewDesc.prototype.stopEvent = function stopEvent (event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false
  };

  CustomNodeViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc.prototype.ignoreMutation.call(this, mutation)
  };

  return CustomNodeViewDesc;
}(NodeViewDesc));

// : (dom.Node, [ViewDesc])
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs) {
  var dom = parentDOM.firstChild;
  for (var i = 0; i < descs.length; i++) {
    var desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) { dom = rm(dom); }
      dom = dom.nextSibling;
    } else {
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) { dom = rm(dom); }
}

function OuterDecoLevel(nodeName) {
  if (nodeName) { this.nodeName = nodeName; }
}
OuterDecoLevel.prototype = Object.create(null);

var noDeco = [new OuterDecoLevel];

function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0) { return noDeco }

  var top = needsWrap ? noDeco[0] : new OuterDecoLevel, result = [top];

  for (var i = 0; i < outerDeco.length; i++) {
    var attrs = outerDeco[i].type.attrs, cur = top;
    if (!attrs) { continue }
    if (attrs.nodeName)
      { result.push(cur = new OuterDecoLevel(attrs.nodeName)); }

    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) { continue }
      if (needsWrap && result.length == 1)
        { result.push(cur = top = new OuterDecoLevel(node.isInline ? "span" : "div")); }
      if (name == "class") { cur.class = (cur.class ? cur.class + " " : "") + val; }
      else if (name == "style") { cur.style = (cur.style ? cur.style + ";" : "") + val; }
      else if (name != "nodeName") { cur[name] = val; }
    }
  }

  return result
}

function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  // Shortcut for trivial case
  if (prevComputed == noDeco && curComputed == noDeco) { return nodeDOM }

  var curDOM = nodeDOM;
  for (var i = 0; i < curComputed.length; i++) {
    var deco = curComputed[i], prev = prevComputed[i];
    if (i) {
      var parent = (void 0);
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
          (parent = curDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.appendChild(curDOM);
        prev = noDeco[0];
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM
}

function patchAttributes(dom, prev, cur) {
  for (var name in prev)
    { if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
      { dom.removeAttribute(name); } }
  for (var name$1 in cur)
    { if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1])
      { dom.setAttribute(name$1, cur[name$1]); } }
  if (prev.class != cur.class) {
    var prevList = prev.class ? prev.class.split(" ") : nothing;
    var curList = cur.class ? cur.class.split(" ") : nothing;
    for (var i = 0; i < prevList.length; i++) { if (curList.indexOf(prevList[i]) == -1)
      { dom.classList.remove(prevList[i]); } }
    for (var i$1 = 0; i$1 < curList.length; i$1++) { if (prevList.indexOf(curList[i$1]) == -1)
      { dom.classList.add(curList[i$1]); } }
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style))
        { dom.style.removeProperty(m[1]); }
    }
    if (cur.style)
      { dom.style.cssText += cur.style; }
  }
}

function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1))
}

// : ([Decoration], [Decoration]) → bool
function sameOuterDeco(a, b) {
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++) { if (!a[i].type.eq(b[i].type)) { return false } }
  return true
}

// Remove a DOM node and return its next sibling.
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next
}

// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
var ViewTreeUpdater = function ViewTreeUpdater(top, lockedNode) {
  this.top = top;
  this.lock = lockedNode;
  // Index into `this.top`'s child array, represents the current
  // update position.
  this.index = 0;
  // When entering a mark, the current top and index are pushed
  // onto this.
  this.stack = [];
  // Tracks whether anything was changed
  this.changed = false;

  var pre = preMatch(top.node.content, top.children);
  this.preMatched = pre.nodes;
  this.preMatchOffset = pre.offset;
};

ViewTreeUpdater.prototype.getPreMatch = function getPreMatch (index) {
  return index >= this.preMatchOffset ? this.preMatched[index - this.preMatchOffset] : null
};

// Destroy and remove the children between the given indices in
// `this.top`.
ViewTreeUpdater.prototype.destroyBetween = function destroyBetween (start, end) {
  if (start == end) { return }
  for (var i = start; i < end; i++) { this.top.children[i].destroy(); }
  this.top.children.splice(start, end - start);
  this.changed = true;
};

// Destroy all remaining children in `this.top`.
ViewTreeUpdater.prototype.destroyRest = function destroyRest () {
  this.destroyBetween(this.index, this.top.children.length);
};

// : ([Mark], EditorView)
// Sync the current stack of mark descs with the given array of
// marks, reusing existing mark descs when possible.
ViewTreeUpdater.prototype.syncToMarks = function syncToMarks (marks, inline, view) {
  var keep = 0, depth = this.stack.length >> 1;
  var maxKeep = Math.min(depth, marks.length);
  while (keep < maxKeep &&
         (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
    { keep++; }

  while (keep < depth) {
    this.destroyRest();
    this.top.dirty = NOT_DIRTY;
    this.index = this.stack.pop();
    this.top = this.stack.pop();
    depth--;
  }
  while (depth < marks.length) {
    this.stack.push(this.top, this.index + 1);
    var found = -1;
    for (var i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
      if (this.top.children[i].matchesMark(marks[depth])) { found = i; break }
    }
    if (found > -1) {
      if (found > this.index) {
        this.changed = true;
        this.destroyBetween(this.index, found);
      }
      this.top = this.top.children[this.index];
    } else {
      var markDesc = MarkViewDesc.create(this.top, marks[depth], inline, view);
      this.top.children.splice(this.index, 0, markDesc);
      this.top = markDesc;
      this.changed = true;
    }
    this.index = 0;
    depth++;
  }
};

// : (Node, [Decoration], DecorationSet) → bool
// Try to find a node desc matching the given data. Skip over it and
// return true when successful.
ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch (node, outerDeco, innerDeco, index) {
  var found = -1, preMatch = index < 0 ? undefined : this.getPreMatch(index), children = this.top.children;
  if (preMatch && preMatch.matchesNode(node, outerDeco, innerDeco)) {
    found = children.indexOf(preMatch);
  } else {
    for (var i = this.index, e = Math.min(children.length, i + 5); i < e; i++) {
      var child = children[i];
      if (child.matchesNode(node, outerDeco, innerDeco) && this.preMatched.indexOf(child) < 0) {
        found = i;
        break
      }
    }
  }
  if (found < 0) { return false }
  this.destroyBetween(this.index, found);
  this.index++;
  return true
};

// : (Node, [Decoration], DecorationSet, EditorView, Fragment, number) → bool
// Try to update the next node, if any, to the given data. Checks
// pre-matches to avoid overwriting nodes that could still be used.
ViewTreeUpdater.prototype.updateNextNode = function updateNextNode (node, outerDeco, innerDeco, view, index) {
  for (var i = this.index; i < this.top.children.length; i++) {
    var next = this.top.children[i];
    if (next instanceof NodeViewDesc) {
      var preMatch = this.preMatched.indexOf(next);
      if (preMatch > -1 && preMatch + this.preMatchOffset != index) { return false }
      var nextDOM = next.dom;

      // Can't update if nextDOM is or contains this.lock, except if
      // it's a text node whose content already matches the new text
      // and whose decorations match the new ones.
      var locked = this.lock && (nextDOM == this.lock || nextDOM.nodeType == 1 && nextDOM.contains(this.lock.parentNode)) &&
          !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text &&
            next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
      if (!locked && next.update(node, outerDeco, innerDeco, view)) {
        this.destroyBetween(this.index, i);
        if (next.dom != nextDOM) { this.changed = true; }
        this.index++;
        return true
      }
      break
    }
  }
  return false
};

// : (Node, [Decoration], DecorationSet, EditorView)
// Insert the node as a newly created node desc.
ViewTreeUpdater.prototype.addNode = function addNode (node, outerDeco, innerDeco, view, pos) {
  this.top.children.splice(this.index++, 0, NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos));
  this.changed = true;
};

ViewTreeUpdater.prototype.placeWidget = function placeWidget (widget, view, pos) {
  if (this.index < this.top.children.length && this.top.children[this.index].matchesWidget(widget)) {
    this.index++;
  } else {
    var desc = new WidgetViewDesc(this.top, widget, view, pos);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
};

// Make sure a textblock looks and behaves correctly in
// contentEditable.
ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks () {
  var lastChild = this.top.children[this.index - 1];
  while (lastChild instanceof MarkViewDesc) { lastChild = lastChild.children[lastChild.children.length - 1]; }

  if (!lastChild || // Empty textblock
      !(lastChild instanceof TextViewDesc) ||
      /\n$/.test(lastChild.node.text)) {
    if (this.index < this.top.children.length && this.top.children[this.index].matchesHack()) {
      this.index++;
    } else {
      var dom = document.createElement("br");
      this.top.children.splice(this.index++, 0, new BRHackViewDesc(this.top, nothing, dom, null));
      this.changed = true;
    }
  }
};

// : (Fragment, [ViewDesc]) → [ViewDesc]
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing
// those for other nodes. Returns an array whose positions correspond
// to node positions in the fragment, and whose elements are either
// descs matched to the child at that index, or empty.
function preMatch(frag, descs) {
  var result = [], end = frag.childCount;
  for (var i = descs.length - 1; end > 0 && i >= 0; i--) {
    var desc = descs[i], node = desc.node;
    if (!node) { continue }
    if (node != frag.child(end - 1)) { break }
    result.push(desc);
    --end;
  }
  return {nodes: result.reverse(), offset: end}
}

function compareSide(a, b) { return a.type.side - b.type.side }

// : (ViewDesc, DecorationSet, (Decoration, number), (Node, [Decoration], DecorationSet, number))
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
  var locals = deco.locals(parent), offset = 0;
  // Simple, cheap variant for when there are no local decorations
  if (locals.length == 0) {
    for (var i = 0; i < parent.childCount; i++) {
      var child = parent.child(i);
      onNode(child, locals, deco.forChild(offset, child), i);
      offset += child.nodeSize;
    }
    return
  }

  var decoIndex = 0, active = [], restNode = null;
  for (var parentIndex = 0;;) {
    if (decoIndex < locals.length && locals[decoIndex].to == offset) {
      var widget = locals[decoIndex++], widgets = (void 0);
      while (decoIndex < locals.length && locals[decoIndex].to == offset)
        { (widgets || (widgets = [widget])).push(locals[decoIndex++]); }
      if (widgets) {
        widgets.sort(compareSide);
        for (var i$1 = 0; i$1 < widgets.length; i$1++) { onWidget(widgets[i$1], parentIndex, !!restNode); }
      } else {
        onWidget(widget, parentIndex, !!restNode);
      }
    }

    var child$1 = (void 0), index = (void 0);
    if (restNode) {
      index = -1;
      child$1 = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      index = parentIndex;
      child$1 = parent.child(parentIndex++);
    } else {
      break
    }

    for (var i$2 = 0; i$2 < active.length; i$2++) { if (active[i$2].to <= offset) { active.splice(i$2--, 1); } }
    while (decoIndex < locals.length && locals[decoIndex].from == offset) { active.push(locals[decoIndex++]); }

    var end = offset + child$1.nodeSize;
    if (child$1.isText) {
      var cutAt = end;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) { cutAt = locals[decoIndex].from; }
      for (var i$3 = 0; i$3 < active.length; i$3++) { if (active[i$3].to < cutAt) { cutAt = active[i$3].to; } }
      if (cutAt < end) {
        restNode = child$1.cut(cutAt - offset);
        child$1 = child$1.cut(0, cutAt - offset);
        end = cutAt;
        index = -1;
      }
    }

    onNode(child$1, active.length ? active.slice() : nothing, deco.forChild(offset, child$1), index);
    offset = end;
  }
}

// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}

function nearbyTextNode(node, offset) {
  for (;;) {
    if (node.nodeType == 3) { return node }
    if (node.nodeType == 1 && offset > 0) {
      if (node.childNodes.length > offset && node.childNodes[offset].nodeType == 3)
        { return node.childNodes[offset] }
      node = node.childNodes[offset - 1];
      offset = nodeSize(node);
    } else if (node.nodeType == 1 && offset < node.childNodes.length) {
      node = node.childNodes[offset];
      offset = 0;
    } else {
      return null
    }
  }
}

// Find a piece of text in an inline fragment, overlapping from-to
function findTextInFragment(frag, text, from, to) {
  for (var i = 0, pos = 0; i < frag.childCount && pos <= to;) {
    var child = frag.child(i++), childStart = pos;
    pos += child.nodeSize;
    if (!child.isText) { continue }
    var str = child.text;
    while (i < frag.childCount) {
      var next = frag.child(i++);
      pos += next.nodeSize;
      if (!next.isText) { break }
      str += next.text;
    }
    if (pos >= from) {
      var found = str.lastIndexOf(text, to - childStart);
      if (found >= 0 && found + text.length + childStart >= from)
        { return childStart + found }
    }
  }
  return -1
}

// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function replaceNodes(nodes, from, to, view, replacement) {
  var result = [];
  for (var i = 0, off = 0; i < nodes.length; i++) {
    var child = nodes[i], start = off, end = off += child.size;
    if (start >= to || end <= from) {
      result.push(child);
    } else {
      if (start < from) { result.push(child.slice(0, from - start, view)); }
      if (replacement) {
        result.push(replacement);
        replacement = null;
      }
      if (end > to) { result.push(child.slice(to - start, child.size, view)); }
    }
  }
  return result
}

function moveSelectionBlock(state, dir) {
  var ref = state.selection;
  var $anchor = ref.$anchor;
  var $head = ref.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].findFrom($start, dir)
}

function apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true
}

function selectHorizontally(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"]) {
    if (!sel.empty || mods.indexOf("s") > -1) {
      return false
    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && (next instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"])) { return apply(view, next) }
      return false
    } else {
      var $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (!node || node.isText) { return false }
      var nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
      if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) { return false }
      if (prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(node)) {
        return apply(view, new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"](dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head))
      } else if (result.webkit) {
        // Chrome and Safari will introduce extra pointless cursor
        // positions around inline uneditable nodes, so we have to
        // take over and move the cursor past them (#937)
        return apply(view, new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"](view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)))
      } else {
        return false
      }
    }
  } else if (sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"] && sel.node.isInline) {
    return apply(view, new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"](dir > 0 ? sel.$to : sel.$from))
  } else {
    var next$1 = moveSelectionBlock(view.state, dir);
    if (next$1) { return apply(view, next$1) }
    return false
  }
}

function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isIgnorable(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR")
}

// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesLeft(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var moveNode, moveOffset, force = false;
  // Gecko will do odd things when the selection is directly in front
  // of a non-editable node, so in that case, move it into the next
  // node if possible. Issue prosemirror/prosemirror#832.
  if (result.gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset])) { force = true; }
  for (;;) {
    if (offset > 0) {
      if (node.nodeType != 1) {
        break
      } else {
        var before = node.childNodes[offset - 1];
        if (isIgnorable(before)) {
          moveNode = node;
          moveOffset = --offset;
        } else if (before.nodeType == 3) {
          node = before;
          offset = node.nodeValue.length;
        } else { break }
      }
    } else if (isBlockNode(node)) {
      break
    } else {
      var prev = node.previousSibling;
      while (prev && isIgnorable(prev)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = 0;
      } else {
        node = prev;
        offset = nodeLen(node);
      }
    }
  }
  if (force) { setSelFocus(view, sel, node, offset); }
  else if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesRight(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var len = nodeLen(node);
  var moveNode, moveOffset;
  for (;;) {
    if (offset < len) {
      if (node.nodeType != 1) { break }
      var after = node.childNodes[offset];
      if (isIgnorable(after)) {
        moveNode = node;
        moveOffset = ++offset;
      }
      else { break }
    } else if (isBlockNode(node)) {
      break
    } else {
      var next = node.nextSibling;
      while (next && isIgnorable(next)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = len = 0;
      } else {
        node = next;
        offset = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

function setSelFocus(view, sel, node, offset) {
  if (selectionCollapsed(sel)) {
    var range = document.createRange();
    range.setEnd(node, offset);
    range.setStart(node, offset);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset);
  }
  view.domObserver.setCurSelection();
}

// : (EditorState, number)
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir, mods) {
  var sel = view.state.selection;
  if (sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"] && !sel.empty || mods.indexOf("s") > -1) { return false }
  var $from = sel.$from;
  var $to = sel.$to;

  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && (next instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"]))
      { return apply(view, next) }
  }
  if (!$from.parent.inlineContent) {
    var beyond = prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].findFrom(dir < 0 ? $from : $to, dir);
    return beyond ? apply(view, beyond) : true
  }
  return false
}

function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"])) { return true }
  var ref = view.state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var empty = ref.empty;
  if (!$head.sameParent($anchor)) { return true }
  if (!empty) { return false }
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) { return true }
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) { tr.delete($head.pos - nextNode.nodeSize, $head.pos); }
    else { tr.delete($head.pos, $head.pos + nextNode.nodeSize); }
    view.dispatch(tr);
    return true
  }
  return false
}

function switchEditable(view, node, state) {
  view.domObserver.stop();
  node.contentEditable = state;
  view.domObserver.start();
}

// Issue #867 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Chrome does really wrong things when the down arrow is
// pressed when the cursor is directly at the start of a textblock and
// has an uneditable node after it
function chromeDownArrowBug(view) {
  if (!result.chrome || view.state.selection.$head.parentOffset > 0) { return }
  var ref = view.root.getSelection();
  var focusNode = ref.focusNode;
  var focusOffset = ref.focusOffset;
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
      focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    var child = focusNode.firstChild;
    switchEditable(view, child, true);
    setTimeout(function () { return switchEditable(view, child, false); }, 20);
  }
}

// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.

function getMods(event) {
  var result = "";
  if (event.ctrlKey) { result += "c"; }
  if (event.metaKey) { result += "m"; }
  if (event.altKey) { result += "a"; }
  if (event.shiftKey) { result += "s"; }
  return result
}

function captureKeyDown(view, event) {
  var code = event.keyCode, mods = getMods(event);
  if (code == 8 || (result.mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 46 || (result.mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 13 || code == 27) { // Enter, Esc
    return true
  } else if (code == 37) { // Left arrow
    return selectHorizontally(view, -1, mods) || skipIgnoredNodesLeft(view)
  } else if (code == 39) { // Right arrow
    return selectHorizontally(view, 1, mods) || skipIgnoredNodesRight(view)
  } else if (code == 38) { // Up arrow
    return selectVertically(view, -1, mods) || skipIgnoredNodesLeft(view)
  } else if (code == 40) { // Down arrow
    return chromeDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodesRight(view)
  } else if (mods == (result.mac ? "m" : "c") &&
             (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
    return true
  }
  return false
}

function selectionFromDOM(view, origin) {
  var domSel = view.root.getSelection(), doc = view.state.doc;
  var nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
  var head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
  var $head = doc.resolve(head), $anchor, selection;
  if (selectionCollapsed(domSel)) {
    $anchor = $head;
    while (nearestDesc && !nearestDesc.node) { nearestDesc = nearestDesc.parent; }
    if (nearestDesc && nearestDesc.node.isAtom && prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(nearestDesc.node) && nearestDesc.parent
        && !(nearestDesc.node.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
      var pos = nearestDesc.posBefore;
      selection = new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"](head == pos ? $head : doc.resolve(pos));
    }
  } else {
    $anchor = doc.resolve(view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset));
  }

  if (!selection) {
    var bias = origin == "pointer" || (view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection
}

function selectionToDOM(view, force) {
  var sel = view.state.selection;
  syncNodeSelection(view, sel);

  if (view.editable ? !view.hasFocus() : !(hasSelection(view) && document.activeElement.contains(view.dom))) { return }

  view.domObserver.disconnectSelection();

  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor;
    var head = sel.head;
    var resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"])) {
      if (!sel.$from.parent.inlineContent)
        { resetEditableFrom = temporarilyEditableNear(view, sel.from); }
      if (!sel.empty && !sel.$from.parent.inlineContent)
        { resetEditableTo = temporarilyEditableNear(view, sel.to); }
    }
    view.docView.setSelection(anchor, head, view.root, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) { resetEditable(resetEditableFrom); }
      if (resetEditableTo) { resetEditable(resetEditableTo); }
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) { removeClassOnSelectionChange(view); }
    }
  }

  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}

// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.

var brokenSelectBetweenUneditable = result.safari || result.chrome && result.chrome_version < 63;

function temporarilyEditableNear(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;
  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
  var before = offset ? node.childNodes[offset - 1] : null;
  if (result.safari && after && after.contentEditable == "false") { return setEditable(after) }
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after) { return setEditable(after) }
    else if (before) { return setEditable(before) }
  }
}

function setEditable(element) {
  element.contentEditable = "true";
  if (result.safari && element.draggable) { element.draggable = false; element.wasDraggable = true; }
  return element
}

function resetEditable(element) {
  element.contentEditable = "false";
  if (element.wasDraggable) { element.draggable = true; element.wasDraggable = null; }
}

function removeClassOnSelectionChange(view) {
  var doc = view.dom.ownerDocument;
  doc.removeEventListener("selectionchange", view.hideSelectionGuard);
  var domSel = view.root.getSelection();
  var node = domSel.anchorNode, offset = domSel.anchorOffset;
  doc.addEventListener("selectionchange", view.hideSelectionGuard = function () {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
      doc.removeEventListener("selectionchange", view.hideSelectionGuard);
      view.dom.classList.remove("ProseMirror-hideselection");
    }
  });
}

function selectCursorWrapper(view) {
  var domSel = view.root.getSelection(), range = document.createRange();
  var node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
  if (img) { range.setEnd(node.parentNode, domIndex(node) + 1); }
  else { range.setEnd(node, 0); }
  range.collapse(false);
  domSel.removeAllRanges();
  domSel.addRange(range);
  // Kludge to kill 'control selection' in IE11 when selecting an
  // invisible cursor wrapper, since that would result in those weird
  // resize handles and a selection that considers the absolutely
  // positioned wrapper, rather than the root editable node, the
  // focused element.
  if (!img && !view.state.selection.visible && result.ie && result.ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}

function syncNodeSelection(view, sel) {
  if (sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"]) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) { desc.selectNode(); }
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}

// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent)
      { view.lastSelectedViewDesc.deselectNode(); }
    view.lastSelectedViewDesc = null;
  }
}

function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function (f) { return f(view, $anchor, $head); })
    || prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"].between($anchor, $head, bias)
}

function hasFocusAndSelection(view) {
  if (view.editable && view.root.activeElement != view.dom) { return false }
  return hasSelection(view)
}

function hasSelection(view) {
  var sel = view.root.getSelection();
  if (!sel.anchorNode) { return false }
  try {
    // Firefox will raise 'permission denied' errors when accessing
    // properties of `sel.anchorNode` when it's in a generated CSS
    // element.
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
      (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode))
  } catch(_) {
    return false
  }
}

function anchorInRightPlace(view) {
  var anchorDOM = view.docView.domFromPos(view.state.selection.anchor);
  var domSel = view.root.getSelection();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset)
}

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.

function parseBetween(view, from_, to_) {
  var ref = view.docView.parseRange(from_, to_);
  var parent = ref.node;
  var fromOffset = ref.fromOffset;
  var toOffset = ref.toOffset;
  var from = ref.from;
  var to = ref.to;

  var domSel = view.root.getSelection(), find = null, anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find = [{node: anchor, offset: domSel.anchorOffset}];
    if (!selectionCollapsed(domSel))
      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}); }
  }
  // Work around issue in Chrome where backspacing sometimes replaces
  // the deleted content with a random BR node (issues #799, #831)
  if (result.chrome && view.lastKeyCode === 8) {
    for (var off = toOffset; off > fromOffset; off--) {
      var node = parent.childNodes[off - 1], desc = node.pmViewDesc;
      if (node.nodeType == "BR" && !desc) { toOffset = off; break }
      if (!desc || desc.size) { break }
    }
  }
  var startDoc = view.state.doc;
  var parser = view.someProp("domParser") || prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["DOMParser"].fromSchema(view.state.schema);
  var $from = startDoc.resolve(from);

  var sel = null, doc = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.spec.code ? "full" : true,
    editableContent: true,
    findPositions: find,
    ruleFromNode: ruleFromNode,
    context: $from
  });
  if (find && find[0].pos != null) {
    var anchor$1 = find[0].pos, head = find[1] && find[1].pos;
    if (head == null) { head = anchor$1; }
    sel = {anchor: anchor$1 + from, head: head + from};
  }
  return {doc: doc, sel: sel, from: from, to: to}
}

function ruleFromNode(dom) {
  var desc = dom.pmViewDesc;
  if (desc) {
    return desc.parseRule()
  } else if (dom.nodeName == "BR" && dom.parentNode) {
    // Safari replaces the list item or table cell with a BR
    // directly in the list node (?!) if you delete the last
    // character in a list item or table cell (#708, #862)
    if (result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
      var skip = document.createElement("div");
      skip.appendChild(document.createElement("li"));
      return {skip: skip}
    } else if (dom.parentNode.lastChild == dom || result.safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
      return {ignore: true}
    }
  } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
    return {ignore: true}
  }
}

function readDOMChange(view, from, to, typeOver, addedNodes) {
  if (from < 0) {
    var origin = view.lastSelectionTime > Date.now() - 50 ? view.lastSelectionOrigin : null;
    var newSel = selectionFromDOM(view, origin);
    if (!view.state.selection.eq(newSel)) {
      var tr$1 = view.state.tr.setSelection(newSel);
      if (origin == "pointer") { tr$1.setMeta("pointer", true); }
      else if (origin == "key") { tr$1.scrollIntoView(); }
      view.dispatch(tr$1);
    }
    return
  }

  var $before = view.state.doc.resolve(from);
  var shared = $before.sharedDepth(to);
  from = $before.before(shared + 1);
  to = view.state.doc.resolve(to).after(shared + 1);

  var sel = view.state.selection;
  var parse = parseBetween(view, from, to);

  var doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
  var preferredPos, preferredSide;
  // Prefer anchoring to end when Backspace is pressed
  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.lastKeyCode = null;

  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
  if (!change) {
    if (typeOver && sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"] && !sel.empty && sel.$head.sameParent(sel.$anchor) &&
        !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) {
      change = {start: sel.from, endA: sel.to, endB: sel.to};
    } else {
      if (parse.sel) {
        var sel$1 = resolveSelection(view, view.state.doc, parse.sel);
        if (sel$1 && !sel$1.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel$1)); }
      }
      return
    }
  }
  view.domChangeCount++;
  // Handle the case where overwriting a selection by typing matches
  // the start or end of the selected content, creating a change
  // that's smaller than what was actually overwritten.
  if (view.state.selection.from < view.state.selection.to &&
      change.start == change.endB &&
      view.state.selection instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"]) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2) {
      change.endB += (view.state.selection.to - change.endA);
      change.endA = view.state.selection.to;
    }
  }

  // IE11 will insert a non-breaking space _ahead_ of the space after
  // the cursor space when adding a space before another space. When
  // that happened, adjust the change to cover the space instead.
  if (result.ie && result.ie_version <= 11 && change.endB == change.start + 1 &&
      change.endA == change.start && change.start > parse.from &&
      parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
    change.start--;
    change.endA--;
    change.endB--;
  }

  var $from = parse.doc.resolveNoCache(change.start - parse.from);
  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
  var inlineChange = $from.sameParent($to) && $from.parent.inlineContent;
  var nextSel;
  // If this looks like the effect of pressing Enter (or was recorded
  // as being an iOS enter press), just dispatch an Enter key instead.
  if (((result.ios && view.lastIOSEnter > Date.now() - 100 &&
        (!inlineChange || addedNodes.some(function (n) { return n.nodeName == "DIV" || n.nodeName == "P"; }))) ||
       (!inlineChange && $from.pos < parse.doc.content.size &&
        (nextSel = prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
        nextSel.head == $to.pos)) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); })) {
    view.lastIOSEnter = 0;
    return
  }
  // Same for backspace
  if (view.state.selection.anchor > change.start &&
      looksLikeJoin(doc, change.start, change.endA, $from, $to) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) {
    if (result.android && result.chrome) { view.domObserver.suppressSelectionUpdates(); } // #820
    return
  }

  var chFrom = change.start, chTo = change.endA;

  var tr, storedMarks, markChange, $from1;
  if (inlineChange) {
    if ($from.pos == $to.pos) { // Deletion
      // IE11 sometimes weirdly moves the DOM selection around after
      // backspacing out the first element in a textblock
      if (result.ie && result.ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(function () { return selectionToDOM(view); }, 20);
      }
      tr = view.state.tr.delete(chFrom, chTo);
      storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
    } else if ( // Adding or removing a mark
      change.endA == change.endB && ($from1 = doc.resolve(change.start)) &&
      (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset),
                                 $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))
    ) {
      tr = view.state.tr;
      if (markChange.type == "add") { tr.addMark(chFrom, chTo, markChange.mark); }
      else { tr.removeMark(chFrom, chTo, markChange.mark); }
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      // Both positions in the same text node -- simply insert text
      var text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      if (view.someProp("handleTextInput", function (f) { return f(view, chFrom, chTo, text); })) { return }
      tr = view.state.tr.insertText(text, chFrom, chTo);
    }
  }

  if (!tr)
    { tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from)); }
  if (parse.sel) {
    var sel$2 = resolveSelection(view, tr.doc, parse.sel);
    // Chrome Android will sometimes, during composition, report the
    // selection in the wrong place. If it looks like that is
    // happening, don't update the selection.
    // Edge just doesn't move the cursor forward when you start typing
    // in an empty block or between br nodes.
    if (sel$2 && !(result.chrome && result.android && view.composing && sel$2.empty &&
                   (sel$2.head == chFrom || sel$2.head == tr.mapping.map(chTo) - 1) ||
                 result.ie && sel$2.empty && sel$2.head == chFrom))
      { tr.setSelection(sel$2); }
  }
  if (storedMarks) { tr.ensureMarks(storedMarks); }
  view.dispatch(tr.scrollIntoView());
}

function resolveSelection(view, doc, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) { return null }
  return selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head))
}

// : (Fragment, Fragment) → ?{mark: Mark, type: string}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  var added = curMarks, removed = prevMarks, type, mark, update;
  for (var i = 0; i < prevMarks.length; i++) { added = prevMarks[i].removeFromSet(added); }
  for (var i$1 = 0; i$1 < curMarks.length; i$1++) { removed = curMarks[i$1].removeFromSet(removed); }
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = function (node) { return node.mark(mark.addToSet(node.marks)); };
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = function (node) { return node.mark(mark.removeFromSet(node.marks)); };
  } else {
    return null
  }
  var updated = [];
  for (var i$2 = 0; i$2 < prev.childCount; i$2++) { updated.push(update(prev.child(i$2))); }
  if (prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].from(updated).eq(cur)) { return {mark: mark, type: type} }
}

function looksLikeJoin(old, start, end, $newStart, $newEnd) {
  if (!$newStart.parent.isTextblock ||
      // The content must have shrunk
      end - start <= $newEnd.pos - $newStart.pos ||
      // newEnd must point directly at or after the end of the block that newStart points into
      skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
    { return false }

  var $start = old.resolve(start);
  // Start must be at the end of a block
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    { return false }
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  // The next textblock must start before end and end near it
  if (!$next.parent.isTextblock || $next.pos > end ||
      skipClosingAndOpening($next, true, false) < end)
    { return false }

  // The fragments after the join point must match
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content)
}

function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end++;
    }
  }
  return end
}

function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start = a.findDiffStart(b, pos);
  if (start == null) { return null }
  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref.a;
  var endB = ref.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start - Math.min(endA, endB));
    preferredPos -= endA + adjust - start;
  }
  if (endA < start && a.size < b.size) {
    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
    start -= move;
    endB = start + (endB - endA);
    endA = start;
  } else if (endB < start) {
    var move$1 = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
    start -= move$1;
    endA = start + (endA - endB);
    endB = start;
  }
  return {start: start, endA: endA, endB: endB}
}

function serializeForClipboard(view, slice) {
  var context = [];
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node = content.firstChild;
    context.push(node.type.name, node.type.hasRequiredAttrs() ? node.attrs : null);
    content = node.content;
  }

  var serializer = view.someProp("clipboardSerializer") || prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["DOMSerializer"].fromSchema(view.state.schema);
  var doc = detachedDoc(), wrap = doc.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content, {document: doc}));

  var firstChild = wrap.firstChild, needsWrap;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i = needsWrap.length - 1; i >= 0; i--) {
      var wrapper = doc.createElement(needsWrap[i]);
      while (wrap.firstChild) { wrapper.appendChild(wrap.firstChild); }
      wrap.appendChild(wrapper);
    }
    firstChild = wrap.firstChild;
  }

  if (firstChild && firstChild.nodeType == 1)
    { firstChild.setAttribute("data-pm-slice", (openStart + " " + openEnd + " " + (JSON.stringify(context)))); }

  var text = view.someProp("clipboardTextSerializer", function (f) { return f(slice); }) ||
      slice.content.textBetween(0, slice.content.size, "\n\n");

  return {dom: wrap, text: text}
}

// : (EditorView, string, string, ?bool, ResolvedPos) → ?Slice
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
  var dom, inCode = $context.parent.type.spec.code, slice;
  if (!html && !text) { return null }
  var asText = text && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", function (f) { text = f(text); });
    if (inCode) { return new prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"](prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].from(view.state.schema.text(text)), 0, 0) }
    var parsed = view.someProp("clipboardTextParser", function (f) { return f(text, $context); });
    if (parsed) {
      slice = parsed;
    } else {
      dom = document.createElement("div");
      text.trim().split(/(?:\r\n?|\n)+/).forEach(function (block) {
        dom.appendChild(document.createElement("p")).textContent = block;
      });
    }
  } else {
    view.someProp("transformPastedHTML", function (f) { html = f(html); });
    dom = readHTML(html);
  }

  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
  if (!slice) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["DOMParser"].fromSchema(view.state.schema);
    slice = parser.parseSlice(dom, {preserveWhitespace: !!(asText || sliceData), context: $context});
  }
  if (sliceData)
    { slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[3]); }
  else // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
    { slice = prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"].maxOpen(normalizeSiblings(slice.content, $context), false); }

  view.someProp("transformPasted", function (f) { slice = f(slice); });
  return slice
}

// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) { return fragment }
  var loop = function ( d ) {
    var parent = $context.node(d);
    var match = parent.contentMatchAt($context.index(d));
    var lastWrap = (void 0), result = [];
    fragment.forEach(function (node) {
      if (!result) { return }
      var wrap = match.findWrapping(node.type), inLast;
      if (!wrap) { return result = null }
      if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length) { result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length); }
        var wrapped = withWrappers(node, wrap);
        result.push(wrapped);
        match = match.matchType(wrapped.type, wrapped.attrs);
        lastWrap = wrap;
      }
    });
    if (result) { return { v: prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].from(result) } }
  };

  for (var d = $context.depth; d >= 0; d--) {
    var returned = loop( d );

    if ( returned ) return returned.v;
  }
  return fragment
}

function withWrappers(node, wrap, from) {
  if ( from === void 0 ) from = 0;

  for (var i = wrap.length - 1; i >= from; i--)
    { node = wrap[i].create(null, prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].from(node)); }
  return node
}

// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner) { return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner)) }
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
      { return sibling.copy(sibling.content.append(prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].from(withWrappers(node, wrap, depth + 1)))) }
  }
}

function closeRight(node, depth) {
  if (depth == 0) { return node }
  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].empty, true);
  return node.copy(fragment.append(fill))
}

function closeRange(fragment, side, from, to, depth, openEnd) {
  var node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
  if (depth < to - 1) { inner = closeRange(inner, side, from, to, depth + 1, openEnd); }
  if (depth >= from)
    { inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, fragment.childCount > 1 || openEnd <= depth).append(inner)
      : inner.append(node.contentMatchAt(node.childCount).fillBefore(prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].empty, true)); }
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner))
}

function closeSlice(slice, openStart, openEnd) {
  if (openStart < slice.openStart)
    { slice = new prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"](closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd); }
  if (openEnd < slice.openEnd)
    { slice = new prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"](closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd); }
  return slice
}

// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
var wrapMap = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};

var _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"))
}

function readHTML(html) {
  var metas = /(\s*<meta [^>]*>)*/.exec(html);
  if (metas) { html = html.slice(metas[0].length); }
  var elt = detachedDoc().createElement("div");
  var firstTag = /(?:<meta [^>]*>)*<([a-z][^>\s]+)/i.exec(html), wrap, depth = 0;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) {
    html = wrap.map(function (n) { return "<" + n + ">"; }).join("") + html + wrap.map(function (n) { return "</" + n + ">"; }).reverse().join("");
    depth = wrap.length;
  }
  elt.innerHTML = html;
  for (var i = 0; i < depth; i++) { elt = elt.firstChild; }
  return elt
}

function addContext(slice, context) {
  if (!slice.size) { return slice }
  var schema = slice.content.firstChild.type.schema, array;
  try { array = JSON.parse(context); }
  catch(e) { return slice }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  for (var i = array.length - 2; i >= 0; i -= 2) {
    var type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs()) { break }
    content = prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Fragment"].from(type.create(array[i + 1], content));
    openStart++; openEnd++;
  }
  return new prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"](content, openStart, openEnd)
}

var observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
var useCharData = result.ie && result.ie_version <= 11;

var SelectionState = function SelectionState() {
  this.anchorNode = this.anchorOffset = this.focusNode = this.focusOffset = null;
};

SelectionState.prototype.set = function set (sel) {
  this.anchorNode = sel.anchorNode; this.anchorOffset = sel.anchorOffset;
  this.focusNode = sel.focusNode; this.focusOffset = sel.focusOffset;
};

SelectionState.prototype.eq = function eq (sel) {
  return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset &&
    sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset
};

var DOMObserver = function DOMObserver(view, handleDOMChange) {
  var this$1 = this;

  this.view = view;
  this.handleDOMChange = handleDOMChange;
  this.queue = [];
  this.flushingSoon = -1;
  this.observer = window.MutationObserver &&
    new window.MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) { this$1.queue.push(mutations[i]); }
      // IE11 will sometimes (on backspacing out a single character
      // text node after a BR node) call the observer callback
      // before actually updating the DOM, which will cause
      // ProseMirror to miss the change (see #930)
      if (result.ie && result.ie_version <= 11 && mutations.some(
        function (m) { return m.type == "childList" && m.removedNodes.length ||
             m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length; }))
        { this$1.flushSoon(); }
      else
        { this$1.flush(); }
    });
  this.currentSelection = new SelectionState;
  if (useCharData) {
    this.onCharData = function (e) {
      this$1.queue.push({target: e.target, type: "characterData", oldValue: e.prevValue});
      this$1.flushSoon();
    };
  }
  this.onSelectionChange = this.onSelectionChange.bind(this);
  this.suppressingSelectionUpdates = false;
};

DOMObserver.prototype.flushSoon = function flushSoon () {
    var this$1 = this;

  if (this.flushingSoon < 0)
    { this.flushingSoon = window.setTimeout(function () { this$1.flushingSoon = -1; this$1.flush(); }, 20); }
};

DOMObserver.prototype.forceFlush = function forceFlush () {
  if (this.flushingSoon > -1) {
    window.clearTimeout(this.flushingSoon);
    this.flushingSoon = -1;
    this.flush();
  }
};

DOMObserver.prototype.start = function start () {
  if (this.observer)
    { this.observer.observe(this.view.dom, observeOptions); }
  if (useCharData)
    { this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData); }
  this.connectSelection();
};

DOMObserver.prototype.stop = function stop () {
    var this$1 = this;

  if (this.observer) {
    var take = this.observer.takeRecords();
    if (take.length) {
      for (var i = 0; i < take.length; i++) { this.queue.push(take[i]); }
      window.setTimeout(function () { return this$1.flush(); }, 20);
    }
    this.observer.disconnect();
  }
  if (useCharData) { this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData); }
  this.disconnectSelection();
};

DOMObserver.prototype.connectSelection = function connectSelection () {
  this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
};

DOMObserver.prototype.disconnectSelection = function disconnectSelection () {
  this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
};

DOMObserver.prototype.suppressSelectionUpdates = function suppressSelectionUpdates () {
    var this$1 = this;

  this.suppressingSelectionUpdates = true;
  setTimeout(function () { return this$1.suppressingSelectionUpdates = false; }, 50);
};

DOMObserver.prototype.onSelectionChange = function onSelectionChange () {
  if (!hasFocusAndSelection(this.view)) { return }
  if (this.suppressingSelectionUpdates) { return selectionToDOM(this.view) }
  // Deletions on IE11 fire their events in the wrong order, giving
  // us a selection change event before the DOM changes are
  // reported.
  if (result.ie && result.ie_version <= 11 && !this.view.state.selection.empty) {
    var sel = this.view.root.getSelection();
    // Selection.isCollapsed isn't reliable on IE
    if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
      { return this.flushSoon() }
  }
  this.flush();
};

DOMObserver.prototype.setCurSelection = function setCurSelection () {
  this.currentSelection.set(this.view.root.getSelection());
};

DOMObserver.prototype.ignoreSelectionChange = function ignoreSelectionChange (sel) {
  if (sel.rangeCount == 0) { return true }
  var container = sel.getRangeAt(0).commonAncestorContainer;
  var desc = this.view.docView.nearestDesc(container);
  if (desc && desc.ignoreMutation({type: "selection", target: container.nodeType == 3 ? container.parentNode : container})) {
    this.setCurSelection();
    return true
  }
};

DOMObserver.prototype.flush = function flush () {
  if (!this.view.docView || this.flushingSoon > -1) { return }
  var mutations = this.observer ? this.observer.takeRecords() : [];
  if (this.queue.length) {
    mutations = this.queue.concat(mutations);
    this.queue.length = 0;
  }

  var sel = this.view.root.getSelection();
  var newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasSelection(this.view) && !this.ignoreSelectionChange(sel);

  var from = -1, to = -1, typeOver = false, added = [];
  if (this.view.editable) {
    for (var i = 0; i < mutations.length; i++) {
      var result$1 = this.registerMutation(mutations[i], added);
      if (result$1) {
        from = from < 0 ? result$1.from : Math.min(result$1.from, from);
        to = to < 0 ? result$1.to : Math.max(result$1.to, to);
        if (result$1.typeOver) { typeOver = true; }
      }
    }
  }

  if (result.gecko && added.length > 1) {
    var brs = added.filter(function (n) { return n.nodeName == "BR"; });
    if (brs.length == 2) {
      var a = brs[0];
        var b = brs[1];
      if (a.parentNode && a.parentNode.parentNode == b.parentNode) { b.remove(); }
      else { a.remove(); }
    }
  }

  if (from > -1 || newSel) {
    if (from > -1) {
      this.view.docView.markDirty(from, to);
      checkCSS(this.view);
    }
    this.handleDOMChange(from, to, typeOver, added);
    if (this.view.docView.dirty) { this.view.updateState(this.view.state); }
    else if (!this.currentSelection.eq(sel)) { selectionToDOM(this.view); }
  }
};

DOMObserver.prototype.registerMutation = function registerMutation (mut, added) {
  // Ignore mutations inside nodes that were already noted as inserted
  if (added.indexOf(mut.target) > -1) { return null }
  var desc = this.view.docView.nearestDesc(mut.target);
  if (mut.type == "attributes" &&
      (desc == this.view.docView || mut.attributeName == "contenteditable" ||
       // Firefox sometimes fires spurious events for null/empty styles
       (mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))))
    { return null }
  if (!desc || desc.ignoreMutation(mut)) { return null }

  if (mut.type == "childList") {
    var prev = mut.previousSibling, next = mut.nextSibling;
    if (result.ie && result.ie_version <= 11 && mut.addedNodes.length) {
      // IE11 gives us incorrect next/prev siblings for some
      // insertions, so if there are added nodes, recompute those
      for (var i = 0; i < mut.addedNodes.length; i++) {
        var ref = mut.addedNodes[i];
          var previousSibling = ref.previousSibling;
          var nextSibling = ref.nextSibling;
        if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) { prev = previousSibling; }
        if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) { next = nextSibling; }
      }
    }
    var fromOffset = prev && prev.parentNode == mut.target
        ? domIndex(prev) + 1 : 0;
    var from = desc.localPosFromDOM(mut.target, fromOffset, -1);
    var toOffset = next && next.parentNode == mut.target
        ? domIndex(next) : mut.target.childNodes.length;
    for (var i$1 = 0; i$1 < mut.addedNodes.length; i$1++) { added.push(mut.addedNodes[i$1]); }
    var to = desc.localPosFromDOM(mut.target, toOffset, 1);
    return {from: from, to: to}
  } else if (mut.type == "attributes") {
    return {from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border}
  } else { // "characterData"
    return {
      from: desc.posAtStart,
      to: desc.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: mut.target.nodeValue == mut.oldValue
    }
  }
};

var cssChecked = false;

function checkCSS(view) {
  if (cssChecked) { return }
  cssChecked = true;
  if (getComputedStyle(view.dom).whiteSpace == "normal")
    { console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."); }
}

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
var handlers = {}, editHandlers = {};

function initInput(view) {
  view.shiftKey = false;
  view.mouseDown = null;
  view.lastKeyCode = null;
  view.lastKeyCodeTime = 0;
  view.lastClick = {time: 0, x: 0, y: 0, type: ""};
  view.lastSelectionOrigin = null;
  view.lastSelectionTime = 0;

  view.lastIOSEnter = 0;

  view.composing = false;
  view.composingTimeout = null;
  view.compositionNodes = [];
  view.compositionEndedAt = -2e8;

  view.domObserver = new DOMObserver(view, function (from, to, typeOver, added) { return readDOMChange(view, from, to, typeOver, added); });
  view.domObserver.start();
  // Used by hacks like the beforeinput handler to check whether anything happened in the DOM
  view.domChangeCount = 0;

  view.eventHandlers = Object.create(null);
  var loop = function ( event ) {
    var handler = handlers[event];
    view.dom.addEventListener(event, view.eventHandlers[event] = function (event) {
      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
          (view.editable || !(event.type in editHandlers)))
        { handler(view, event); }
    });
  };

  for (var event in handlers) loop( event );
  // On Safari, for reasons beyond my understanding, adding an input
  // event handler makes an issue where the composition vanishes when
  // you press enter go away.
  if (result.safari) { view.dom.addEventListener("input", function () { return null; }); }

  ensureListeners(view);
}

function setSelectionOrigin(view, origin) {
  view.lastSelectionOrigin = origin;
  view.lastSelectionTime = Date.now();
}

function destroyInput(view) {
  view.domObserver.stop();
  for (var type in view.eventHandlers)
    { view.dom.removeEventListener(type, view.eventHandlers[type]); }
  clearTimeout(view.composingTimeout);
}

function ensureListeners(view) {
  view.someProp("handleDOMEvents", function (currentHandlers) {
    for (var type in currentHandlers) { if (!view.eventHandlers[type])
      { view.dom.addEventListener(type, view.eventHandlers[type] = function (event) { return runCustomHandler(view, event); }); } }
  });
}

function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function (handlers) {
    var handler = handlers[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false
  })
}

function eventBelongsToView(view, event) {
  if (!event.bubbles) { return true }
  if (event.defaultPrevented) { return false }
  for (var node = event.target; node != view.dom; node = node.parentNode)
    { if (!node || node.nodeType == 11 ||
        (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
      { return false } }
  return true
}

function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] &&
      (view.editable || !(event.type in editHandlers)))
    { handlers[event.type](view, event); }
}

editHandlers.keydown = function (view, event) {
  view.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event)) { return }
  view.domObserver.forceFlush();
  view.lastKeyCode = event.keyCode;
  view.lastKeyCodeTime = Date.now();
  // On iOS, if we preventDefault enter key presses, the virtual
  // keyboard gets confused. So the hack here is to set a flag that
  // makes the DOM change code recognize that what just happens should
  // be replaced by whatever the Enter key handlers do.
  if (result.ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
    var now = Date.now();
    view.lastIOSEnter = now;
    setTimeout(function () {
      if (view.lastIOSEnter == now) {
        view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); });
        view.lastIOSEnter = 0;
      }
    }, 50);
  } else if (view.someProp("handleKeyDown", function (f) { return f(view, event); }) || captureKeyDown(view, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "key");
  }
};

editHandlers.keyup = function (view, e) {
  if (e.keyCode == 16) { view.shiftKey = false; }
};

editHandlers.keypress = function (view, event) {
  if (inOrNearComposition(view, event) || !event.charCode ||
      event.ctrlKey && !event.altKey || result.mac && event.metaKey) { return }

  if (view.someProp("handleKeyPress", function (f) { return f(view, event); })) {
    event.preventDefault();
    return
  }

  var sel = view.state.selection;
  if (!(sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"]) || !sel.$from.sameParent(sel.$to)) {
    var text = String.fromCharCode(event.charCode);
    if (!view.someProp("handleTextInput", function (f) { return f(view, sel.$from.pos, sel.$to.pos, text); }))
      { view.dispatch(view.state.tr.insertText(text).scrollIntoView()); }
    event.preventDefault();
  }
};

function eventCoords(event) { return {left: event.clientX, top: event.clientY} }

function isNear(event, click) {
  var dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100
}

function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside);
  var loop = function ( i ) {
    if (view.someProp(propName, function (f) { return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
                                                    : f(view, pos, $pos.node(i), $pos.before(i), event, false); }))
      { return { v: true } }
  };

  for (var i = $pos.depth + 1; i > 0; i--) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

function updateSelection(view, selection, origin) {
  if (!view.focused) { view.focus(); }
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") { tr.setMeta("pointer", true); }
  view.dispatch(tr);
}

function selectClickedLeaf(view, inside) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
  if (node && node.isAtom && prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(node)) {
    updateSelection(view, new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"]($pos), "pointer");
    return true
  }
  return false
}

function selectClickedNode(view, inside) {
  if (inside == -1) { return false }
  var sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"]) { selectedNode = sel.node; }

  var $pos = view.state.doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 &&
          i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        { selectAt = $pos.before(sel.$from.depth); }
      else
        { selectAt = $pos.before(i); }
      break
    }
  }

  if (selectAt != null) {
    updateSelection(view, prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].create(view.state.doc, selectAt), "pointer");
    return true
  } else {
    return false
  }
}

function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
    view.someProp("handleClick", function (f) { return f(view, pos, event); }) ||
    (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside))
}

function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
    view.someProp("handleDoubleClick", function (f) { return f(view, pos, event); })
}

function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
    view.someProp("handleTripleClick", function (f) { return f(view, pos, event); }) ||
    defaultTripleClick(view, inside)
}

function defaultTripleClick(view, inside) {
  var doc = view.state.doc;
  if (inside == -1) {
    if (doc.inlineContent) {
      updateSelection(view, prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"].create(doc, 0, doc.content.size), "pointer");
      return true
    }
    return false
  }

  var $pos = doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    var nodePos = $pos.before(i);
    if (node.inlineContent)
      { updateSelection(view, prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"].create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer"); }
    else if (prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(node))
      { updateSelection(view, prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].create(doc, nodePos), "pointer"); }
    else
      { continue }
    return true
  }
}

function forceDOMFlush(view) {
  return endComposition(view)
}

var selectNodeModifier = result.mac ? "metaKey" : "ctrlKey";

handlers.mousedown = function (view, event) {
  view.shiftKey = event.shiftKey;
  var flushed = forceDOMFlush(view);
  var now = Date.now(), type = "singleClick";
  if (now - view.lastClick.time < 500 && isNear(event, view.lastClick) && !event[selectNodeModifier]) {
    if (view.lastClick.type == "singleClick") { type = "doubleClick"; }
    else if (view.lastClick.type == "doubleClick") { type = "tripleClick"; }
  }
  view.lastClick = {time: now, x: event.clientX, y: event.clientY, type: type};

  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) { return }

  if (type == "singleClick")
    { view.mouseDown = new MouseDown(view, pos, event, flushed); }
  else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event))
    { event.preventDefault(); }
  else
    { setSelectionOrigin(view, "pointer"); }
};

var MouseDown = function MouseDown(view, pos, event, flushed) {
  var this$1 = this;

  this.view = view;
  this.startDoc = view.state.doc;
  this.pos = pos;
  this.event = event;
  this.flushed = flushed;
  this.selectNode = event[selectNodeModifier];
  this.allowDefault = event.shiftKey;

  var targetNode, targetPos;
  if (pos.inside > -1) {
    targetNode = view.state.doc.nodeAt(pos.inside);
    targetPos = pos.inside;
  } else {
    var $pos = view.state.doc.resolve(pos.pos);
    targetNode = $pos.parent;
    targetPos = $pos.depth ? $pos.before() : 0;
  }

  this.mightDrag = null;

  var target = flushed ? null : event.target;
  var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
  this.target = targetDesc ? targetDesc.dom : null;

  if (targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
      view.state.selection instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"] && targetPos == view.state.selection.from)
    { this.mightDrag = {node: targetNode,
                      pos: targetPos,
                      addAttr: this.target && !this.target.draggable,
                      setUneditable: this.target && result.gecko && !this.target.hasAttribute("contentEditable")}; }

  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = true; }
    if (this.mightDrag.setUneditable)
      { setTimeout(function () { return this$1.target.setAttribute("contentEditable", "false"); }, 20); }
    this.view.domObserver.start();
  }

  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
  setSelectionOrigin(view, "pointer");
};

MouseDown.prototype.done = function done () {
  this.view.root.removeEventListener("mouseup", this.up);
  this.view.root.removeEventListener("mousemove", this.move);
  if (this.mightDrag && this.target) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.removeAttribute("draggable"); }
    if (this.mightDrag.setUneditable) { this.target.removeAttribute("contentEditable"); }
    this.view.domObserver.start();
  }
  this.view.mouseDown = null;
};

MouseDown.prototype.up = function up (event) {
  this.done();

  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target))
    { return }

  var pos = this.pos;
  if (this.view.state.doc != this.startDoc) { pos = this.view.posAtCoords(eventCoords(event)); }

  if (this.allowDefault || !pos) {
    setSelectionOrigin(this.view, "pointer");
  } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
    event.preventDefault();
  } else if (this.flushed ||
             // Safari ignores clicks on draggable elements
             (result.safari && this.mightDrag && !this.mightDrag.node.isAtom) ||
             // Chrome will sometimes treat a node selection as a
             // cursor, but still report that the node is selected
             // when asked through getSelection. You'll then get a
             // situation where clicking at the point where that
             // (hidden) cursor is doesn't change the selection, and
             // thus doesn't get a reaction from ProseMirror. This
             // works around that.
             (result.chrome && !(this.view.state.selection instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"]) &&
              (pos.pos == this.view.state.selection.from || pos.pos == this.view.state.selection.to))) {
    updateSelection(this.view, prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].near(this.view.state.doc.resolve(pos.pos)), "pointer");
    event.preventDefault();
  } else {
    setSelectionOrigin(this.view, "pointer");
  }
};

MouseDown.prototype.move = function move (event) {
  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
                             Math.abs(this.event.y - event.clientY) > 4))
    { this.allowDefault = true; }
  setSelectionOrigin(this.view, "pointer");
};

handlers.touchdown = function (view) {
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};

handlers.contextmenu = function (view) { return forceDOMFlush(view); };

function inOrNearComposition(view, event) {
  if (view.composing) { return true }
  // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
  // On Japanese input method editors (IMEs), the Enter key is used to confirm character
  // selection. On Safari, when Enter is pressed, compositionend and keydown events are
  // emitted. The keydown event triggers newline insertion, which we don't want.
  // This method returns true if the keydown event should be ignored.
  // We only ignore it once, as pressing Enter a second time *should* insert a newline.
  // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
  // This guards against the case where compositionend is triggered without the keyboard
  // (e.g. character confirmation may be done with the mouse), and keydown is triggered
  // afterwards- we wouldn't want to ignore the keydown event in this case.
  if (result.safari && Math.abs(event.timeStamp - view.compositionEndedAt) < 500) {
    view.compositionEndedAt = -2e8;
    return true
  }
  return false
}

// Drop active composition after 5 seconds of inactivity on Android
var timeoutComposition = result.android ? 5000 : -1;

editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
  if (!view.composing) {
    view.domObserver.flush();
    var state = view.state;
    var $pos = state.selection.$from;
    if (state.selection.empty &&
        (state.storedMarks || (!$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(function (m) { return m.type.spec.inclusive === false; })))) {
      // Need to wrap the cursor in mark nodes different from the ones in the DOM context
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view);
      // In firefox, if the cursor is after but outside a marked node,
      // the inserted text won't inherit the marks. So this moves it
      // inside if necessary.
      if (result.gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        var sel = view.root.getSelection();
        for (var node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
          var before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
          if (!before) { break }
          if (before.nodeType == 3) {
            sel.collapse(before, before.nodeValue.length);
            break
          } else {
            node = before;
            offset = -1;
          }
        }
      }
    }
    view.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};

editHandlers.compositionend = function (view, event) {
  if (view.composing) {
    view.composing = false;
    view.compositionEndedAt = event.timeStamp;
    scheduleComposeEnd(view, 20);
  }
};

function scheduleComposeEnd(view, delay) {
  clearTimeout(view.composingTimeout);
  if (delay > -1) { view.composingTimeout = setTimeout(function () { return endComposition(view); }, delay); }
}

function endComposition(view, forceUpdate) {
  view.domObserver.forceFlush();
  view.composing = false;
  while (view.compositionNodes.length > 0) { view.compositionNodes.pop().markParentsDirty(); }
  if (forceUpdate || view.docView.dirty) {
    var sel = selectionFromDOM(view);
    if (!sel.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel)); }
    else { view.updateState(view.state); }
    return true
  }
  return false
}

function captureCopy(view, dom) {
  // The extra wrapper is somehow necessary on IE/Edge to prevent the
  // content from being mangled when it is put onto the clipboard
  var doc = view.dom.ownerDocument;
  var wrap = doc.body.appendChild(doc.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(), range = doc.createRange();
  range.selectNodeContents(dom);
  // Done because IE will fire a selectionchange moving the selection
  // to its start when removeAllRanges is called and the editor still
  // has focus (which will mess up the editor's selection state).
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(function () {
    doc.body.removeChild(wrap);
    view.focus();
  }, 50);
}

// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
var brokenClipboardAPI = (result.ie && result.ie_version < 15) ||
      (result.ios && result.webkit_version < 604);

handlers.copy = editHandlers.cut = function (view, e) {
  var sel = view.state.selection, cut = e.type == "cut";
  if (sel.empty) { return }

  // IE and Edge's clipboard interface is completely broken
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var slice = sel.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  if (data) {
    e.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut) { view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut")); }
};

function sliceSingleNode(slice) {
  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null
}

function capturePaste(view, e) {
  var doc = view.dom.ownerDocument;
  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = doc.body.appendChild(doc.createElement(plainText ? "textarea" : "div"));
  if (!plainText) { target.contentEditable = "true"; }
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(function () {
    view.focus();
    doc.body.removeChild(target);
    if (plainText) { doPaste(view, target.value, null, e); }
    else { doPaste(view, target.textContent, target.innerHTML, e); }
  }, 50);
}

function doPaste(view, text, html, e) {
  var slice = parseFromClipboard(view, text, html, view.shiftKey, view.state.selection.$from);
  if (view.someProp("handlePaste", function (f) { return f(view, e, slice || prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"].empty); }) || !slice) { return }

  var singleNode = sliceSingleNode(slice);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
}

editHandlers.paste = function (view, e) {
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var html = data && data.getData("text/html"), text = data && data.getData("text/plain");
  if (data && (html || text || data.files.length)) {
    doPaste(view, text, html, e);
    e.preventDefault();
  } else {
    capturePaste(view, e);
  }
};

var Dragging = function Dragging(slice, move) {
  this.slice = slice;
  this.move = move;
};

var dragCopyModifier = result.mac ? "altKey" : "ctrlKey";

handlers.dragstart = function (view, e) {
  var mouseDown = view.mouseDown;
  if (mouseDown) { mouseDown.done(); }
  if (!e.dataTransfer) { return }

  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"] ? sel.to - 1: sel.to)) ; else if (mouseDown && mouseDown.mightDrag) {
    view.dispatch(view.state.tr.setSelection(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].create(view.state.doc, mouseDown.mightDrag.pos)));
  } else if (e.target && e.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(e.target, true);
    if (!desc || !desc.node.type.spec.draggable || desc == view.docView) { return }
    view.dispatch(view.state.tr.setSelection(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].create(view.state.doc, desc.posBefore)));
  }
  var slice = view.state.selection.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  e.dataTransfer.clearData();
  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  if (!brokenClipboardAPI) { e.dataTransfer.setData("text/plain", text); }
  view.dragging = new Dragging(slice, !e[dragCopyModifier]);
};

handlers.dragend = function (view) {
  window.setTimeout(function () { return view.dragging = null; }, 50);
};

editHandlers.dragover = editHandlers.dragenter = function (_, e) { return e.preventDefault(); };

editHandlers.drop = function (view, e) {
  var dragging = view.dragging;
  view.dragging = null;

  if (!e.dataTransfer) { return }

  var eventPos = view.posAtCoords(eventCoords(e));
  if (!eventPos) { return }
  var $mouse = view.state.doc.resolve(eventPos.pos);
  if (!$mouse) { return }
  var slice = dragging && dragging.slice ||
      parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"),
                         brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
  if (view.someProp("handleDrop", function (f) { return f(view, e, slice || prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"].empty, dragging && dragging.move); })) {
    e.preventDefault();
    return
  }
  if (!slice) { return }

  e.preventDefault();
  var insertPos = slice ? Object(prosemirror_transform__WEBPACK_IMPORTED_MODULE_2__["dropPoint"])(view.state.doc, $mouse.pos, slice) : $mouse.pos;
  if (insertPos == null) { insertPos = $mouse.pos; }

  var tr = view.state.tr;
  if (dragging && dragging.move) { tr.deleteSelection(); }

  var pos = tr.mapping.map(insertPos);
  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode)
    { tr.replaceRangeWith(pos, pos, slice.content.firstChild); }
  else
    { tr.replaceRange(pos, pos, slice); }
  if (tr.doc.eq(beforeInsert)) { return }

  var $pos = tr.doc.resolve(pos);
  if (isNode && prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(slice.content.firstChild) &&
      $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild))
    { tr.setSelection(new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"]($pos)); }
  else
    { tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(tr.mapping.map(insertPos)))); }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};

handlers.focus = function (view) {
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
    setTimeout(function () {
      if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.root.getSelection()))
        { selectionToDOM(view); }
    }, 20);
  }
};

handlers.blur = function (view) {
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    view.domObserver.currentSelection.set({});
    view.focused = false;
  }
};

handlers.beforeinput = function (view, event) {
  // We should probably do more with beforeinput events, but support
  // is so spotty that I'm still waiting to see where they are going.

  // Very specific hack to deal with backspace sometimes failing on
  // Chrome Android when after an uneditable node.
  if (result.chrome && result.android && event.inputType == "deleteContentBackward") {
    var domChangeCount = view.domChangeCount;
    setTimeout(function () {
      if (view.domChangeCount != domChangeCount) { return } // Event already had some effect
      // This bug tends to close the virtual keyboard, so we refocus
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) { return }
      var ref = view.state.selection;
      var $cursor = ref.$cursor;
      // Crude approximation of backspace behavior when no command handled it
      if ($cursor && $cursor.pos > 0) { view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView()); }
    }, 50);
  }
};

// Make sure all handlers get registered
for (var prop in editHandlers) { handlers[prop] = editHandlers[prop]; }

function compareObjs(a, b) {
  if (a == b) { return true }
  for (var p in a) { if (a[p] !== b[p]) { return false } }
  for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  return true
}

var WidgetType = function WidgetType(toDOM, spec) {
  this.spec = spec || noSpec;
  this.side = this.spec.side || 0;
  this.toDOM = toDOM;
};

WidgetType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var ref = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    var pos = ref.pos;
    var deleted = ref.deleted;
  return deleted ? null : new Decoration(pos - offset, pos - offset, this)
};

WidgetType.prototype.valid = function valid () { return true };

WidgetType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof WidgetType &&
     (this.spec.key && this.spec.key == other.spec.key ||
      this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)))
};

var InlineType = function InlineType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

InlineType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
  var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
  return from >= to ? null : new Decoration(from, to, this)
};

InlineType.prototype.valid = function valid (_, span) { return span.from < span.to };

InlineType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

InlineType.is = function is (span) { return span.type instanceof InlineType };

var NodeType = function NodeType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

NodeType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.mapResult(span.from + oldOffset, 1);
  if (from.deleted) { return null }
  var to = mapping.mapResult(span.to + oldOffset, -1);
  if (to.deleted || to.pos <= from.pos) { return null }
  return new Decoration(from.pos - offset, to.pos - offset, this)
};

NodeType.prototype.valid = function valid (node, span) {
  var ref = node.content.findIndex(span.from);
    var index = ref.index;
    var offset = ref.offset;
  return offset == span.from && offset + node.child(index).nodeSize == span.to
};

NodeType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof NodeType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

// ::- Decoration objects can be provided to the view through the
// [`decorations` prop](#view.EditorProps.decorations). They come in
// several variants—see the static members of this class for details.
var Decoration = function Decoration(from, to, type) {
  // :: number
  // The start position of the decoration.
  this.from = from;
  // :: number
  // The end position. Will be the same as `from` for [widget
  // decorations](#view.Decoration^widget).
  this.to = to;
  this.type = type;
};

var prototypeAccessors$1 = { spec: { configurable: true } };

Decoration.prototype.copy = function copy (from, to) {
  return new Decoration(from, to, this.type)
};

Decoration.prototype.eq = function eq (other, offset) {
    if ( offset === void 0 ) offset = 0;

  return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to
};

Decoration.prototype.map = function map (mapping, offset, oldOffset) {
  return this.type.map(mapping, this, offset, oldOffset)
};

// :: (number, union<(view: EditorView, getPos: () → number) → dom.Node, dom.Node>, ?Object) → Decoration
// Creates a widget decoration, which is a DOM node that's shown in
// the document at the given position. It is recommended that you
// delay rendering the widget by passing a function that will be
// called when the widget is actually drawn in a view, but you can
// also directly pass a DOM node. `getPos` can be used to find the
// widget's current document position.
//
// spec::- These options are supported:
//
//   side:: ?number
//   Controls which side of the document position this widget is
//   associated with. When negative, it is drawn before a cursor
//   at its position, and content inserted at that position ends
//   up after the widget. When zero (the default) or positive, the
//   widget is drawn after the cursor and content inserted there
//   ends up before the widget.
//
//   When there are multiple widgets at a given position, their
//   `side` values determine the order in which they appear. Those
//   with lower values appear first. The ordering of widgets with
//   the same `side` value is unspecified.
//
//   When `marks` is null, `side` also determines the marks that
//   the widget is wrapped in—those of the node before when
//   negative, those of the node after when positive.
//
//   marks:: ?[Mark]
//   The precise set of marks to draw around the widget.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to control which DOM events, when they bubble out
//   of this widget, the editor view should ignore.
//
//   ignoreSelection:: ?bool
//   When set (defaults to false), selection changes inside the
//   widget are ignored, and don't cause ProseMirror to try and
//   re-sync the selection with its selection state.
//
//   key:: ?string
//   When comparing decorations of this type (in order to decide
//   whether it needs to be redrawn), ProseMirror will by default
//   compare the widget DOM node by identity. If you pass a key,
//   that key will be compared instead, which can be useful when
//   you generate decorations on the fly and don't want to store
//   and reuse DOM nodes. Make sure that any widgets with the same
//   key are interchangeable—if widgets differ in, for example,
//   the behavior of some event handler, they should get
//   different keys.
Decoration.widget = function widget (pos, toDOM, spec) {
  return new Decoration(pos, pos, new WidgetType(toDOM, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates an inline decoration, which adds the given attributes to
// each inline node between `from` and `to`.
//
// spec::- These options are recognized:
//
//   inclusiveStart:: ?bool
//   Determines how the left side of the decoration is
//   [mapped](#transform.Position_Mapping) when content is
//   inserted directly at that position. By default, the decoration
//   won't include the new content, but you can set this to `true`
//   to make it inclusive.
//
//   inclusiveEnd:: ?bool
//   Determines how the right side of the decoration is mapped.
//   See
//   [`inclusiveStart`](#view.Decoration^inline^spec.inclusiveStart).
Decoration.inline = function inline (from, to, attrs, spec) {
  return new Decoration(from, to, new InlineType(attrs, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates a node decoration. `from` and `to` should point precisely
// before and after a node in the document. That node, and only that
// node, will receive the given attributes.
//
// spec::-
//
// Optional information to store with the decoration. It
// is also used when comparing decorators for equality.
Decoration.node = function node (from, to, attrs, spec) {
  return new Decoration(from, to, new NodeType(attrs, spec))
};

// :: Object
// The spec provided when creating this decoration. Can be useful
// if you've stored extra information in that object.
prototypeAccessors$1.spec.get = function () { return this.type.spec };

Object.defineProperties( Decoration.prototype, prototypeAccessors$1 );

// DecorationAttrs:: interface
// A set of attributes to add to a decorated node. Most properties
// simply directly correspond to DOM attributes of the same name,
// which will be set to the property's value. These are exceptions:
//
//   class:: ?string
//   A CSS class name or a space-separated set of class names to be
//   _added_ to the classes that the node already had.
//
//   style:: ?string
//   A string of CSS to be _added_ to the node's existing `style` property.
//
//   nodeName:: ?string
//   When non-null, the target node is wrapped in a DOM element of
//   this type (and the other attributes are applied to this element).

var none = [], noSpec = {};

// ::- A collection of [decorations](#view.Decoration), organized in
// such a way that the drawing algorithm can efficiently use and
// compare them. This is a persistent data structure—it is not
// modified, updates create a new value.
var DecorationSet = function DecorationSet(local, children) {
  this.local = local && local.length ? local : none;
  this.children = children && children.length ? children : none;
};

// :: (Node, [Decoration]) → DecorationSet
// Create a set of decorations, using the structure of the given
// document.
DecorationSet.create = function create (doc, decorations) {
  return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty
};

// :: (?number, ?number, ?(spec: Object) → bool) → [Decoration]
// Find all decorations in this set which touch the given range
// (including decorations that start or end directly at the
// boundaries) and match the given predicate on their spec. When
// `start` and `end` are omitted, all decorations in the set are
// considered. When `predicate` isn't given, all decorations are
// assumed to match.
DecorationSet.prototype.find = function find (start, end, predicate) {
  var result = [];
  this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
  return result
};

DecorationSet.prototype.findInner = function findInner (start, end, result, offset, predicate) {
  for (var i = 0; i < this.local.length; i++) {
    var span = this.local[i];
    if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
      { result.push(span.copy(span.from + offset, span.to + offset)); }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this.children[i$1] < end && this.children[i$1 + 1] > start) {
      var childOff = this.children[i$1] + 1;
      this.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
    }
  }
};

// :: (Mapping, Node, ?Object) → DecorationSet
// Map the set of decorations in response to a change in the
// document.
//
// options::- An optional set of options.
//
//   onRemove:: ?(decorationSpec: Object)
//   When given, this function will be called for each decoration
//   that gets dropped as a result of the mapping, passing the
//   spec of that decoration.
DecorationSet.prototype.map = function map (mapping, doc, options) {
  if (this == empty || mapping.maps.length == 0) { return this }
  return this.mapInner(mapping, doc, 0, 0, options || noSpec)
};

DecorationSet.prototype.mapInner = function mapInner (mapping, node, offset, oldOffset, options) {
  var newLocal;
  for (var i = 0; i < this.local.length; i++) {
    var mapped = this.local[i].map(mapping, offset, oldOffset);
    if (mapped && mapped.type.valid(node, mapped)) { (newLocal || (newLocal = [])).push(mapped); }
    else if (options.onRemove) { options.onRemove(this.local[i].spec); }
  }

  if (this.children.length)
    { return mapChildren(this.children, newLocal, mapping, node, offset, oldOffset, options) }
  else
    { return newLocal ? new DecorationSet(newLocal.sort(byPos)) : empty }
};

// :: (Node, [Decoration]) → DecorationSet
// Add the given array of decorations to the ones in the set,
// producing a new set. Needs access to the current document to
// create the appropriate tree structure.
DecorationSet.prototype.add = function add (doc, decorations) {
  if (!decorations.length) { return this }
  if (this == empty) { return DecorationSet.create(doc, decorations) }
  return this.addInner(doc, decorations, 0)
};

DecorationSet.prototype.addInner = function addInner (doc, decorations, offset) {
    var this$1 = this;

  var children, childIndex = 0;
  doc.forEach(function (childNode, childOffset) {
    var baseOffset = childOffset + offset, found;
    if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) { return }

    if (!children) { children = this$1.children.slice(); }
    while (childIndex < children.length && children[childIndex] < childOffset) { childIndex += 3; }
    if (children[childIndex] == childOffset)
      { children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1); }
    else
      { children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec)); }
    childIndex += 3;
  });

  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local,
                           children || this.children)
};

// :: ([Decoration]) → DecorationSet
// Create a new set that contains the decorations in this set, minus
// the ones in the given array.
DecorationSet.prototype.remove = function remove (decorations) {
  if (decorations.length == 0 || this == empty) { return this }
  return this.removeInner(decorations, 0)
};

DecorationSet.prototype.removeInner = function removeInner (decorations, offset) {
  var children = this.children, local = this.local;
  for (var i = 0; i < children.length; i += 3) {
    var found = (void 0), from = children[i] + offset, to = children[i + 1] + offset;
    for (var j = 0, span = (void 0); j < decorations.length; j++) { if (span = decorations[j]) {
      if (span.from > from && span.to < to) {
        decorations[j] = null
        ;(found || (found = [])).push(span);
      }
    } }
    if (!found) { continue }
    if (children == this.children) { children = this.children.slice(); }
    var removed = children[i + 2].removeInner(found, from + 1);
    if (removed != empty) {
      children[i + 2] = removed;
    } else {
      children.splice(i, 3);
      i -= 3;
    }
  }
  if (local.length) { for (var i$1 = 0, span$1 = (void 0); i$1 < decorations.length; i$1++) { if (span$1 = decorations[i$1]) {
    for (var j$1 = 0; j$1 < local.length; j$1++) { if (local[j$1].eq(span$1, offset)) {
      if (local == this.local) { local = this.local.slice(); }
      local.splice(j$1--, 1);
    } }
  } } }
  if (children == this.children && local == this.local) { return this }
  return local.length || children.length ? new DecorationSet(local, children) : empty
};

DecorationSet.prototype.forChild = function forChild (offset, node) {
  if (this == empty) { return this }
  if (node.isLeaf) { return DecorationSet.empty }

  var child, local;
  for (var i = 0; i < this.children.length; i += 3) { if (this.children[i] >= offset) {
    if (this.children[i] == offset) { child = this.children[i + 2]; }
    break
  } }
  var start = offset + 1, end = start + node.content.size;
  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
    var dec = this.local[i$1];
    if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
      var from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
      if (from < to) { (local || (local = [])).push(dec.copy(from, to)); }
    }
  }
  if (local) {
    var localSet = new DecorationSet(local.sort(byPos));
    return child ? new DecorationGroup([localSet, child]) : localSet
  }
  return child || empty
};

DecorationSet.prototype.eq = function eq (other) {
  if (this == other) { return true }
  if (!(other instanceof DecorationSet) ||
      this.local.length != other.local.length ||
      this.children.length != other.children.length) { return false }
  for (var i = 0; i < this.local.length; i++)
    { if (!this.local[i].eq(other.local[i])) { return false } }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3)
    { if (this.children[i$1] != other.children[i$1] ||
        this.children[i$1 + 1] != other.children[i$1 + 1] ||
        !this.children[i$1 + 2].eq(other.children[i$1 + 2])) { return false } }
  return true
};

DecorationSet.prototype.locals = function locals (node) {
  return removeOverlap(this.localsInner(node))
};

DecorationSet.prototype.localsInner = function localsInner (node) {
  if (this == empty) { return none }
  if (node.inlineContent || !this.local.some(InlineType.is)) { return this.local }
  var result = [];
  for (var i = 0; i < this.local.length; i++) {
    if (!(this.local[i].type instanceof InlineType))
      { result.push(this.local[i]); }
  }
  return result
};

var empty = new DecorationSet();

// :: DecorationSet
// The empty set of decorations.
DecorationSet.empty = empty;

DecorationSet.removeOverlap = removeOverlap;

// :- An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
var DecorationGroup = function DecorationGroup(members) {
  this.members = members;
};

DecorationGroup.prototype.forChild = function forChild (offset, child) {
  if (child.isLeaf) { return DecorationSet.empty }
  var found = [];
  for (var i = 0; i < this.members.length; i++) {
    var result = this.members[i].forChild(offset, child);
    if (result == empty) { continue }
    if (result instanceof DecorationGroup) { found = found.concat(result.members); }
    else { found.push(result); }
  }
  return DecorationGroup.from(found)
};

DecorationGroup.prototype.eq = function eq (other) {
  if (!(other instanceof DecorationGroup) ||
      other.members.length != this.members.length) { return false }
  for (var i = 0; i < this.members.length; i++)
    { if (!this.members[i].eq(other.members[i])) { return false } }
  return true
};

DecorationGroup.prototype.locals = function locals (node) {
  var result, sorted = true;
  for (var i = 0; i < this.members.length; i++) {
    var locals = this.members[i].localsInner(node);
    if (!locals.length) { continue }
    if (!result) {
      result = locals;
    } else {
      if (sorted) {
        result = result.slice();
        sorted = false;
      }
      for (var j = 0; j < locals.length; j++) { result.push(locals[j]); }
    }
  }
  return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none
};

// : ([DecorationSet]) → union<DecorationSet, DecorationGroup>
// Create a group for the given array of decoration sets, or return
// a single set when possible.
DecorationGroup.from = function from (members) {
  switch (members.length) {
    case 0: return empty
    case 1: return members[0]
    default: return new DecorationGroup(members)
  }
};

function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
  var children = oldChildren.slice();

  // Mark the children that are directly touched by changes, and
  // move those that are after the changes.
  var shift = function (oldStart, oldEnd, newStart, newEnd) {
    for (var i = 0; i < children.length; i += 3) {
      var end = children[i + 1], dSize = (void 0);
      if (end == -1 || oldStart > end + oldOffset) { continue }
      if (oldEnd >= children[i] + oldOffset) {
        children[i + 1] = -1;
      } else if (newStart >= offset && (dSize = (newEnd - newStart) - (oldEnd - oldStart))) {
        children[i] += dSize;
        children[i + 1] += dSize;
      }
    }
  };
  for (var i = 0; i < mapping.maps.length; i++) { mapping.maps[i].forEach(shift); }

  // Find the child nodes that still correspond to a single node,
  // recursively call mapInner on them and update their positions.
  var mustRebuild = false;
  for (var i$1 = 0; i$1 < children.length; i$1 += 3) { if (children[i$1 + 1] == -1) { // Touched nodes
    var from = mapping.map(children[i$1] + oldOffset), fromLocal = from - offset;
    if (fromLocal < 0 || fromLocal >= node.content.size) {
      mustRebuild = true;
      continue
    }
    // Must read oldChildren because children was tagged with -1
    var to = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to - offset;
    var ref = node.content.findIndex(fromLocal);
    var index = ref.index;
    var childOffset = ref.offset;
    var childNode = node.maybeChild(index);
    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
      var mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, children[i$1] + oldOffset + 1, options);
      if (mapped != empty) {
        children[i$1] = fromLocal;
        children[i$1 + 1] = toLocal;
        children[i$1 + 2] = mapped;
      } else {
        children[i$1 + 1] = -2;
        mustRebuild = true;
      }
    } else {
      mustRebuild = true;
    }
  } }

  // Remaining children must be collected and rebuilt into the appropriate structure
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal || [], mapping,
                                                       offset, oldOffset, options);
    var built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (var i$2 = 0; i$2 < children.length; i$2 += 3) { if (children[i$2 + 1] < 0) {
      children.splice(i$2, 3);
      i$2 -= 3;
    } }
    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
      var from$1 = built.children[i$3];
      while (j < children.length && children[j] < from$1) { j += 3; }
      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
    }
  }

  return new DecorationSet(newLocal && newLocal.sort(byPos), children)
}

function moveSpans(spans, offset) {
  if (!offset || !spans.length) { return spans }
  var result = [];
  for (var i = 0; i < spans.length; i++) {
    var span = spans[i];
    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
  }
  return result
}

function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
  // Gather all decorations from the remaining marked children
  function gather(set, oldOffset) {
    for (var i = 0; i < set.local.length; i++) {
      var mapped = set.local[i].map(mapping, offset, oldOffset);
      if (mapped) { decorations.push(mapped); }
      else if (options.onRemove) { options.onRemove(set.local[i].spec); }
    }
    for (var i$1 = 0; i$1 < set.children.length; i$1 += 3)
      { gather(set.children[i$1 + 2], set.children[i$1] + oldOffset + 1); }
  }
  for (var i = 0; i < children.length; i += 3) { if (children[i + 1] == -1)
    { gather(children[i + 2], oldChildren[i] + oldOffset + 1); } }

  return decorations
}

function takeSpansForNode(spans, node, offset) {
  if (node.isLeaf) { return null }
  var end = offset + node.nodeSize, found = null;
  for (var i = 0, span = (void 0); i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset && span.to < end) {
(found || (found = [])).push(span);
      spans[i] = null;
    }
  }
  return found
}

function withoutNulls(array) {
  var result = [];
  for (var i = 0; i < array.length; i++)
    { if (array[i] != null) { result.push(array[i]); } }
  return result
}

// : ([Decoration], Node, number) → DecorationSet
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtractet from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
  var children = [], hasNulls = false;
  node.forEach(function (childNode, localStart) {
    var found = takeSpansForNode(spans, childNode, localStart + offset);
    if (found) {
      hasNulls = true;
      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
      if (subtree != empty)
        { children.push(localStart, localStart + childNode.nodeSize, subtree); }
    }
  });
  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
  for (var i = 0; i < locals.length; i++) { if (!locals[i].type.valid(node, locals[i])) {
    if (options.onRemove) { options.onRemove(locals[i].spec); }
    locals.splice(i--, 1);
  } }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty
}

// : (Decoration, Decoration) → number
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
  return a.from - b.from || a.to - b.to
}

// : ([Decoration]) → [Decoration]
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
  var working = spans;
  for (var i = 0; i < working.length - 1; i++) {
    var span = working[i];
    if (span.from != span.to) { for (var j = i + 1; j < working.length; j++) {
      var next = working[j];
      if (next.from == span.from) {
        if (next.to != span.to) {
          if (working == spans) { working = spans.slice(); }
          // Followed by a partially overlapping larger span. Split that
          // span.
          working[j] = next.copy(next.from, span.to);
          insertAhead(working, j + 1, next.copy(span.to, next.to));
        }
        continue
      } else {
        if (next.from < span.to) {
          if (working == spans) { working = spans.slice(); }
          // The end of this one overlaps with a subsequent span. Split
          // this one.
          working[i] = span.copy(span.from, next.from);
          insertAhead(working, j, span.copy(next.from, span.to));
        }
        break
      }
    } }
  }
  return working
}

function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0) { i++; }
  array.splice(i, 0, deco);
}

// : (EditorView) → union<DecorationSet, DecorationGroup>
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
  var found = [];
  view.someProp("decorations", function (f) {
    var result = f(view.state);
    if (result && result != empty) { found.push(result); }
  });
  if (view.cursorWrapper)
    { found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco])); }
  return DecorationGroup.from(found)
}

// ::- An editor view manages the DOM structure that represents an
// editable document. Its state and behavior are determined by its
// [props](#view.DirectEditorProps).
var EditorView = function EditorView(place, props) {
  this._props = props;
  // :: EditorState
  // The view's current [state](#state.EditorState).
  this.state = props.state;

  this.dispatch = this.dispatch.bind(this);

  this._root = null;
  this.focused = false;

  // :: dom.Element
  // An editable DOM node containing the document. (You probably
  // should not directly interfere with its content.)
  this.dom = (place && place.mount) || document.createElement("div");
  if (place) {
    if (place.appendChild) { place.appendChild(this.dom); }
    else if (place.apply) { place(this.dom); }
    else if (place.mount) { this.mounted = true; }
  }

  // :: bool
  // Indicates whether the editor is currently [editable](#view.EditorProps.editable).
  this.editable = getEditable(this);
  this.markCursor = null;
  this.cursorWrapper = null;
  updateCursorWrapper(this);
  this.nodeViews = buildNodeViews(this);
  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);

  this.lastSelectedViewDesc = null;
  // :: ?{slice: Slice, move: bool}
  // When editor content is being dragged, this object contains
  // information about the dragged slice and whether it is being
  // copied or moved. At any other time, it is null.
  this.dragging = null;

  initInput(this);

  this.pluginViews = [];
  this.updatePluginViews();
};

var prototypeAccessors$2 = { props: { configurable: true },root: { configurable: true } };

// composing:: boolean
// Holds `true` when a
// [composition](https://developer.mozilla.org/en-US/docs/Mozilla/IME_handling_guide)
// is active.

// :: DirectEditorProps
// The view's current [props](#view.EditorProps).
prototypeAccessors$2.props.get = function () {
  if (this._props.state != this.state) {
    var prev = this._props;
    this._props = {};
    for (var name in prev) { this._props[name] = prev[name]; }
    this._props.state = this.state;
  }
  return this._props
};

// :: (DirectEditorProps)
// Update the view's props. Will immediately cause an update to
// the DOM.
EditorView.prototype.update = function update (props) {
  if (props.handleDOMEvents != this._props.handleDOMEvents) { ensureListeners(this); }
  this._props = props;
  this.updateStateInner(props.state, true);
};

// :: (DirectEditorProps)
// Update the view by updating existing props object with the object
// given as argument. Equivalent to `view.update(Object.assign({},
// view.props, props))`.
EditorView.prototype.setProps = function setProps (props) {
  var updated = {};
  for (var name in this._props) { updated[name] = this._props[name]; }
  updated.state = this.state;
  for (var name$1 in props) { updated[name$1] = props[name$1]; }
  this.update(updated);
};

// :: (EditorState)
// Update the editor's `state` prop, without touching any of the
// other props.
EditorView.prototype.updateState = function updateState (state) {
  this.updateStateInner(state, this.state.plugins != state.plugins);
};

EditorView.prototype.updateStateInner = function updateStateInner (state, reconfigured) {
    var this$1 = this;

  var prev = this.state, redraw = false;
  this.state = state;
  if (reconfigured) {
    var nodeViews = buildNodeViews(this);
    if (changedNodeViews(nodeViews, this.nodeViews)) {
      this.nodeViews = nodeViews;
      redraw = true;
    }
    ensureListeners(this);
  }

  this.editable = getEditable(this);
  updateCursorWrapper(this);
  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);

  var scroll = reconfigured ? "reset"
      : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
  var updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
  var updateSel = updateDoc || !state.selection.eq(prev.selection);
  var oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);

  if (updateSel) {
    this.domObserver.stop();
    // Work around an issue in Chrome, IE, and Edge where changing
    // the DOM around an active selection puts it into a broken
    // state where the thing the user sees differs from the
    // selection reported by the Selection object (#710, #973,
    // #1011, #1013, #1035).
    var forceSelUpdate = updateDoc && (result.ie || result.chrome) && !this.composing &&
        !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
    if (updateDoc) {
      var selContext = result.chrome && selectionContext(this.root);
      if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
        this.docView.updateOuterDeco([]);
        this.docView.destroy();
        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
      }
      if (selContext && needChromeSelectionReset(selContext, this.root)) { forceSelUpdate = true; }
    }
    // Work around for an issue where an update arriving right between
    // a DOM selection change and the "selectionchange" event for it
    // can cause a spurious DOM selection update, disrupting mouse
    // drag selection.
    if (forceSelUpdate ||
        !(this.mouseDown && this.domObserver.currentSelection.eq(this.root.getSelection()) && anchorInRightPlace(this))) {
      selectionToDOM(this, forceSelUpdate);
    } else {
      syncNodeSelection(this, state.selection);
      this.domObserver.setCurSelection();
    }
    this.domObserver.start();
  }

  this.updatePluginViews(prev);

  if (scroll == "reset") {
    this.dom.scrollTop = 0;
  } else if (scroll == "to selection") {
    var startDOM = this.root.getSelection().focusNode;
    if (this.someProp("handleScrollToSelection", function (f) { return f(this$1); }))
      ; // Handled
    else if (state.selection instanceof prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"])
      { scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect(), startDOM); }
    else
      { scrollRectIntoView(this, this.coordsAtPos(state.selection.head), startDOM); }
  } else if (oldScrollPos) {
    resetScrollPos(oldScrollPos);
  }
};

EditorView.prototype.destroyPluginViews = function destroyPluginViews () {
  var view;
  while (view = this.pluginViews.pop()) { if (view.destroy) { view.destroy(); } }
};

EditorView.prototype.updatePluginViews = function updatePluginViews (prevState) {
  if (!prevState || prevState.plugins != this.state.plugins) {
    this.destroyPluginViews();
    for (var i = 0; i < this.state.plugins.length; i++) {
      var plugin = this.state.plugins[i];
      if (plugin.spec.view) { this.pluginViews.push(plugin.spec.view(this)); }
    }
  } else {
    for (var i$1 = 0; i$1 < this.pluginViews.length; i$1++) {
      var pluginView = this.pluginViews[i$1];
      if (pluginView.update) { pluginView.update(this, prevState); }
    }
  }
};

// :: (string, ?(prop: *) → *) → *
// Goes over the values of a prop, first those provided directly,
// then those from plugins (in order), and calls `f` every time a
// non-undefined value is found. When `f` returns a truthy value,
// that is immediately returned. When `f` isn't provided, it is
// treated as the identity function (the prop value is returned
// directly).
EditorView.prototype.someProp = function someProp (propName, f) {
  var prop = this._props && this._props[propName], value;
  if (prop != null && (value = f ? f(prop) : prop)) { return value }
  var plugins = this.state.plugins;
  if (plugins) { for (var i = 0; i < plugins.length; i++) {
    var prop$1 = plugins[i].props[propName];
    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) { return value }
  } }
};

// :: () → bool
// Query whether the view has focus.
EditorView.prototype.hasFocus = function hasFocus () {
  return this.root.activeElement == this.dom
};

// :: ()
// Focus the editor.
EditorView.prototype.focus = function focus () {
  this.domObserver.stop();
  if (this.editable) { focusPreventScroll(this.dom); }
  selectionToDOM(this);
  this.domObserver.start();
};

// :: union<dom.Document, dom.DocumentFragment>
// Get the document root in which the editor exists. This will
// usually be the top-level `document`, but might be a [shadow
// DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
// root if the editor is inside one.
prototypeAccessors$2.root.get = function () {
  var cached = this._root;
  if (cached == null) { for (var search = this.dom.parentNode; search; search = search.parentNode) {
    if (search.nodeType == 9 || (search.nodeType == 11 && search.host)) {
      if (!search.getSelection) { Object.getPrototypeOf(search).getSelection = function () { return document.getSelection(); }; }
      return this._root = search
    }
  } }
  return cached || document
};

// :: ({left: number, top: number}) → ?{pos: number, inside: number}
// Given a pair of viewport coordinates, return the document
// position that corresponds to them. May return null if the given
// coordinates aren't inside of the editor. When an object is
// returned, its `pos` property is the position nearest to the
// coordinates, and its `inside` property holds the position of the
// inner node that the position falls inside of, or -1 if it is at
// the top level, not in any node.
EditorView.prototype.posAtCoords = function posAtCoords$1 (coords) {
  return posAtCoords(this, coords)
};

// :: (number) → {left: number, right: number, top: number, bottom: number}
// Returns the viewport rectangle at a given document position. `left`
// and `right` will be the same number, as this returns a flat
// cursor-ish rectangle.
EditorView.prototype.coordsAtPos = function coordsAtPos$1 (pos) {
  return coordsAtPos(this, pos)
};

// :: (number) → {node: dom.Node, offset: number}
// Find the DOM position that corresponds to the given document
// position. Note that you should **not** mutate the editor's
// internal DOM, only inspect it (and even that is usually not
// necessary).
EditorView.prototype.domAtPos = function domAtPos (pos) {
  return this.docView.domFromPos(pos)
};

// :: (number) → ?dom.Node
// Find the DOM node that represents the document node after the
// given position. May return `null` when the position doesn't point
// in front of a node or if the node is inside an opaque node view.
//
// This is intended to be able to call things like
// `getBoundingClientRect` on that DOM node. Do **not** mutate the
// editor DOM directly, or add styling this way, since that will be
// immediately overriden by the editor as it redraws the node.
EditorView.prototype.nodeDOM = function nodeDOM (pos) {
  var desc = this.docView.descAt(pos);
  return desc ? desc.nodeDOM : null
};

// :: (dom.Node, number, ?number) → number
// Find the document position that corresponds to a given DOM
// position. (Whenever possible, it is preferable to inspect the
// document structure directly, rather than poking around in the
// DOM, but sometimes—for example when interpreting an event
// target—you don't have a choice.)
//
// The `bias` parameter can be used to influence which side of a DOM
// node to use when the position is inside a leaf node.
EditorView.prototype.posAtDOM = function posAtDOM (node, offset, bias) {
    if ( bias === void 0 ) bias = -1;

  var pos = this.docView.posFromDOM(node, offset, bias);
  if (pos == null) { throw new RangeError("DOM position not inside the editor") }
  return pos
};

// :: (union<"up", "down", "left", "right", "forward", "backward">, ?EditorState) → bool
// Find out whether the selection is at the end of a textblock when
// moving in a given direction. When, for example, given `"left"`,
// it will return true if moving left from the current cursor
// position would leave that position's parent textblock. Will apply
// to the view's current state by default, but it is possible to
// pass a different state.
EditorView.prototype.endOfTextblock = function endOfTextblock$1 (dir, state) {
  return endOfTextblock(this, state || this.state, dir)
};

// :: ()
// Removes the editor from the DOM and destroys all [node
// views](#view.NodeView).
EditorView.prototype.destroy = function destroy () {
  if (!this.docView) { return }
  destroyInput(this);
  this.destroyPluginViews();
  if (this.mounted) {
    this.docView.update(this.state.doc, [], viewDecorations(this), this);
    this.dom.textContent = "";
  } else if (this.dom.parentNode) {
    this.dom.parentNode.removeChild(this.dom);
  }
  this.docView.destroy();
  this.docView = null;
};

// Used for testing.
EditorView.prototype.dispatchEvent = function dispatchEvent$1 (event) {
  return dispatchEvent(this, event)
};

// :: (Transaction)
// Dispatch a transaction. Will call
// [`dispatchTransaction`](#view.DirectEditorProps.dispatchTransaction)
// when given, and otherwise defaults to applying the transaction to
// the current state and calling
// [`updateState`](#view.EditorView.updateState) with the result.
// This method is bound to the view instance, so that it can be
// easily passed around.
EditorView.prototype.dispatch = function dispatch (tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) { dispatchTransaction.call(this, tr); }
  else { this.updateState(this.state.apply(tr)); }
};

Object.defineProperties( EditorView.prototype, prototypeAccessors$2 );

function computeDocDeco(view) {
  var attrs = Object.create(null);
  attrs.class = "ProseMirror";
  attrs.contenteditable = String(view.editable);

  view.someProp("attributes", function (value) {
    if (typeof value == "function") { value = value(view.state); }
    if (value) { for (var attr in value) {
      if (attr == "class")
        { attrs.class += " " + value[attr]; }
      else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
        { attrs[attr] = String(value[attr]); }
    } }
  });

  return [Decoration.node(0, view.state.doc.content.size, attrs)]
}

function updateCursorWrapper(view) {
  if (view.markCursor) {
    var dom = document.createElement("img");
    dom.setAttribute("mark-placeholder", "true");
    view.cursorWrapper = {dom: dom, deco: Decoration.widget(view.state.selection.head, dom, {raw: true, marks: view.markCursor})};
  } else {
    view.cursorWrapper = null;
  }
}

function getEditable(view) {
  return !view.someProp("editable", function (value) { return value(view.state) === false; })
}

function selectionContextChanged(sel1, sel2) {
  var depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
  return sel1.$anchor.start(depth) != sel2.$anchor.start(depth)
}

function buildNodeViews(view) {
  var result = {};
  view.someProp("nodeViews", function (obj) {
    for (var prop in obj) { if (!Object.prototype.hasOwnProperty.call(result, prop))
      { result[prop] = obj[prop]; } }
  });
  return result
}

function changedNodeViews(a, b) {
  var nA = 0, nB = 0;
  for (var prop in a) {
    if (a[prop] != b[prop]) { return true }
    nA++;
  }
  for (var _ in b) { nB++; }
  return nA != nB
}

function selectionContext(root) {
  var ref = root.getSelection();
  var offset = ref.focusOffset;
  var node = ref.focusNode;
  return node && node.nodeType == 1 ? [node, offset, node.childNodes[offset - 1], node.childNodes[offset]] : null
}

function needChromeSelectionReset(context, root) {
  var newContext = selectionContext(root);
  if (!newContext || newContext[0].nodeType == 3) { return false }
  for (var i = 0; i < context.length; i++) { if (newContext[i] != context[i]) { return true } }
  return false
}

// EditorProps:: interface
//
// Props are configuration values that can be passed to an editor view
// or included in a plugin. This interface lists the supported props.
//
// The various event-handling functions may all return `true` to
// indicate that they handled the given event. The view will then take
// care to call `preventDefault` on the event, except with
// `handleDOMEvents`, where the handler itself is responsible for that.
//
// How a prop is resolved depends on the prop. Handler functions are
// called one at a time, starting with the base props and then
// searching through the plugins (in order of appearance) until one of
// them returns true. For some props, the first plugin that yields a
// value gets precedence.
//
//   handleDOMEvents:: ?Object<(view: EditorView, event: dom.Event) → bool>
//   Can be an object mapping DOM event type names to functions that
//   handle them. Such functions will be called before any handling
//   ProseMirror does of events fired on the editable DOM element.
//   Contrary to the other event handling props, when returning true
//   from such a function, you are responsible for calling
//   `preventDefault` yourself (or not, if you want to allow the
//   default behavior).
//
//   handleKeyDown:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Called when the editor receives a `keydown` event.
//
//   handleKeyPress:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Handler for `keypress` events.
//
//   handleTextInput:: ?(view: EditorView, from: number, to: number, text: string) → bool
//   Whenever the user directly input text, this handler is called
//   before the input is applied. If it returns `true`, the default
//   behavior of actually inserting the text is suppressed.
//
//   handleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a click, from the inside out. The
//   `direct` flag will be true for the inner node.
//
//   handleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is clicked, after `handleClickOn` handlers
//   have been called.
//
//   handleDoubleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a double click.
//
//   handleDoubleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is double-clicked, after `handleDoubleClickOn`.
//
//   handleTripleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a triple click.
//
//   handleTripleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is triple-clicked, after `handleTripleClickOn`.
//
//   handlePaste:: ?(view: EditorView, event: dom.ClipboardEvent, slice: Slice) → bool
//   Can be used to override the behavior of pasting. `slice` is the
//   pasted content parsed by the editor, but you can directly access
//   the event to get at the raw content.
//
//   handleDrop:: ?(view: EditorView, event: dom.Event, slice: Slice, moved: bool) → bool
//   Called when something is dropped on the editor. `moved` will be
//   true if this drop moves from the current selection (which should
//   thus be deleted).
//
//   handleScrollToSelection:: ?(view: EditorView) → bool
//   Called when the view, after updating its state, tries to scroll
//   the selection into view. A handler function may return false to
//   indicate that it did not handle the scrolling and further
//   handlers or the default behavior should be tried.
//
//   createSelectionBetween:: ?(view: EditorView, anchor: ResolvedPos, head: ResolvedPos) → ?Selection
//   Can be used to override the way a selection is created when
//   reading a DOM selection between the given anchor and head.
//
//   domParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading editor changes
//   from the DOM. Defaults to calling
//   [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) on the
//   editor's schema.
//
//   transformPastedHTML:: ?(html: string) → string
//   Can be used to transform pasted HTML text, _before_ it is parsed,
//   for example to clean it up.
//
//   clipboardParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading content from
//   the clipboard. When not given, the value of the
//   [`domParser`](#view.EditorProps.domParser) prop is used.
//
//   transformPastedText:: ?(text: string) → string
//   Transform pasted plain text.
//
//   clipboardTextParser:: ?(text: string, $context: ResolvedPos) → Slice
//   A function to parse text from the clipboard into a document
//   slice. Called after
//   [`transformPastedText`](#view.EditorProps.transformPastedText).
//   The default behavior is to split the text into lines, wrap them
//   in `<p>` tags, and call
//   [`clipboardParser`](#view.EditorProps.clipboardParser) on it.
//
//   transformPasted:: ?(Slice) → Slice
//   Can be used to transform pasted content before it is applied to
//   the document.
//
//   nodeViews:: ?Object<(node: Node, view: EditorView, getPos: () → number, decorations: [Decoration]) → NodeView>
//   Allows you to pass custom rendering and behavior logic for nodes
//   and marks. Should map node and mark names to constructor
//   functions that produce a [`NodeView`](#view.NodeView) object
//   implementing the node's display behavior. For nodes, the third
//   argument `getPos` is a function that can be called to get the
//   node's current position, which can be useful when creating
//   transactions to update it. For marks, the third argument is a
//   boolean that indicates whether the mark's content is inline.
//
//   `decorations` is an array of node or inline decorations that are
//   active around the node. They are automatically drawn in the
//   normal way, and you will usually just want to ignore this, but
//   they can also be used as a way to provide context information to
//   the node view without adding it to the document itself.
//
//   clipboardSerializer:: ?DOMSerializer
//   The DOM serializer to use when putting content onto the
//   clipboard. If not given, the result of
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)
//   will be used.
//
//   clipboardTextSerializer:: ?(Slice) → string
//   A function that will be called to get the text for the current
//   selection when copying text to the clipboard. By default, the
//   editor will use [`textBetween`](#model.Node.textBetween) on the
//   selected range.
//
//   decorations:: ?(state: EditorState) → ?DecorationSet
//   A set of [document decorations](#view.Decoration) to show in the
//   view.
//
//   editable:: ?(state: EditorState) → bool
//   When this returns false, the content of the view is not directly
//   editable.
//
//   attributes:: ?union<Object<string>, (EditorState) → ?Object<string>>
//   Control the DOM attributes of the editable element. May be either
//   an object or a function going from an editor state to an object.
//   By default, the element will get a class `"ProseMirror"`, and
//   will have its `contentEditable` attribute determined by the
//   [`editable` prop](#view.EditorProps.editable). Additional classes
//   provided here will be added to the class. For other attributes,
//   the value provided first (as in
//   [`someProp`](#view.EditorView.someProp)) will be used.
//
//   scrollThreshold:: ?union<number, {top: number, right: number, bottom: number, left: number}>
//   Determines the distance (in pixels) between the cursor and the
//   end of the visible viewport at which point, when scrolling the
//   cursor into view, scrolling takes place. Defaults to 0.
//
//   scrollMargin:: ?union<number, {top: number, right: number, bottom: number, left: number}>
//   Determines the extra space (in pixels) that is left above or
//   below the cursor when it is scrolled into view. Defaults to 5.

// DirectEditorProps:: interface extends EditorProps
//
// The props object given directly to the editor view supports two
// fields that can't be used in plugins:
//
//   state:: EditorState
//   The current state of the editor.
//
//   dispatchTransaction:: ?(tr: Transaction)
//   The callback over which to send transactions (state updates)
//   produced by the view. If you specify this, you probably want to
//   make sure this ends up calling the view's
//   [`updateState`](#view.EditorView.updateState) method with a new
//   state that has the transaction
//   [applied](#state.EditorState.apply). The callback will be bound to have
//   the view instance as its `this` binding.


//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ "576c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ "577e":
/***/ (function(module, exports) {

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),

/***/ "5801":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("2d9b");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "583f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("c243");

var _encoder = __webpack_require__("5726");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_5#Encoding

var checksum = function checksum(data) {
	var result = data.split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 9 : sum + a * 3;
	}, 0);
	return result % 10;
};

var EAN5 = function (_Barcode) {
	_inherits(EAN5, _Barcode);

	function EAN5(data, options) {
		_classCallCheck(this, EAN5);

		return _possibleConstructorReturn(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
	}

	_createClass(EAN5, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{5}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
			return {
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN5;
}(_Barcode3.default);

exports.default = EAN5;

/***/ }),

/***/ "584a":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "58a2":
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__("11dc");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__("399f");
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__("7a10");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ "58b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function encodeUtf8 (input) {
  var result = []
  var size = input.length

  for (var index = 0; index < size; index++) {
    var point = input.charCodeAt(index)

    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
      var second = input.charCodeAt(index + 1)

      if (second >= 0xDC00 && second <= 0xDFFF) {
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000
        index += 1
      }
    }

    // US-ASCII
    if (point < 0x80) {
      result.push(point)
      continue
    }

    // 2-byte UTF-8
    if (point < 0x800) {
      result.push((point >> 6) | 192)
      result.push((point & 63) | 128)
      continue
    }

    // 3-byte UTF-8
    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
      result.push((point >> 12) | 224)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // 4-byte UTF-8
    if (point >= 0x10000 && point <= 0x10FFFF) {
      result.push((point >> 18) | 240)
      result.push(((point >> 12) & 63) | 128)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // Invalid character
    result.push(0xEF, 0xBF, 0xBD)
  }

  return new Uint8Array(result).buffer
}


/***/ }),

/***/ "5919":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__("13e2");
exports.sha224 = __webpack_require__("07f2");
exports.sha256 = __webpack_require__("6eed");
exports.sha384 = __webpack_require__("8b95");
exports.sha512 = __webpack_require__("b525");


/***/ }),

/***/ "593d":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("0061"),
    baseUnary = __webpack_require__("09eb"),
    nodeUtil = __webpack_require__("a99d");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "598a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ "5a76":
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__("f576")

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ "5aff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ "5b14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ "5b14c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rich-text-editor/mc-rich-text-editor.vue?vue&type=template&id=93495448&
var mc_rich_text_editorvue_type_template_id_93495448_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-rich--text--editor",class:{ 'mc-rich--text--editor--border': !_vm.readonly, 'mtd-input-disabled': _vm.editorDisabled }},[(_vm.editorDisabled || _vm.readonly)?_c('preview',_vm._g(_vm._b({ref:"previewRef"},'preview',_vm.$props,false),_vm.$listeners)):_c('editor',_vm._g(_vm._b({ref:"editorRef",attrs:{"menubar":_vm.menubar}},'editor',_vm.$props,false),_vm.$listeners))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-rich-text-editor/mc-rich-text-editor.vue?vue&type=template&id=93495448&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rich-text-editor/components/Editor.vue?vue&type=template&id=2c819d8e&
var Editorvue_type_template_id_2c819d8e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"},[_c('div',{ref:"menubarRef"}),_c('div',{ref:"editorRef",staticClass:"editor"})])}
var Editorvue_type_template_id_2c819d8e_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-rich-text-editor/components/Editor.vue?vue&type=template&id=2c819d8e&

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("4f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__("1c4c");

// EXTERNAL MODULE: ./node_modules/prosemirror-model/dist/index.js
var dist = __webpack_require__("6f27");

// EXTERNAL MODULE: ./node_modules/@it/parker/es/core/index.js
var core = __webpack_require__("80a6");

// CONCATENATED MODULE: ./node_modules/@it/parker/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
// CONCATENATED MODULE: ./node_modules/@it/parker/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
// CONCATENATED MODULE: ./node_modules/@it/parker/node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
// CONCATENATED MODULE: ./node_modules/@it/parker/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var stringify_i = 0; stringify_i < 256; ++stringify_i) {
  byteToHex.push((stringify_i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
// CONCATENATED MODULE: ./node_modules/@it/parker/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/prosemirror-state/dist/index.js
var prosemirror_state_dist = __webpack_require__("6ffb");

// EXTERNAL MODULE: ./node_modules/prosemirror-commands/dist/commands.js
var dist_commands = __webpack_require__("fbea");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/schema/citadel-schema/index.js






var citadel_schema_doc = {
    content: "block+"
};

var citadel_schema_text = {
    group: "inline"
};

/**
 * 将父元素的textAlign 属性下移到子元素上
 * 主要场景为外部复制进来的数据源textAlign使用不规范，在node的getAttrs做清洗
 * @param el DOMNode
 * @return textAlign<String>
 */ var getAlign = function(el) {
    if (!el) return "";
    if (el.style && el.style.textAlign) {
        return el.style.textAlign;
    }
    return getAlign(el.parentNode);
};
/**
 * 计算 indent 值, 单级缩进值为 20
 * @param el DOMNode
 * @return number
 */ var getIndent = function(el) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var indent = 0;
    if (el && el.style && el.style.marginLeft) {
        // 只能返回整数
        indent = Math.round(parseInt(el.style.marginLeft, 10) / unit);
        // 计算出错就返回 0
        if (typeof indent !== "number" || Number.isNaN(indent) || indent < 0) {
            indent = 0;
        }
    }
    return indent;
};

var getParagraphAttrs = function(node) {
    var align = getAlign(node);
    var indent = getIndent(node);
    var dataDiffId = node.getAttribute("data-diff-id");
    var attrs = {
        id: esm_browser_v4(),
        indent: indent,
        // 过滤可能的 justify
        align: align === "justify" ? "left" : align,
        dataDiffId: dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
    };
    return attrs;
};
var citadel_schema_paragraph = {
    attrs: {
        indent: {
            default: 0
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    content: "inline*",
    group: "block",
    textContentBlock: true,
    alignBlock: true,
    parseDOM: [
        {
            tag: "p",
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return getParagraphAttrs(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, align = _node_attrs.align, indent = _node_attrs.indent, dataDiffId = _node_attrs.dataDiffId;
        var attrs = {};
        var style = "";
        if (align && align !== "left") {
            style += "text-align: ".concat(align, ";");
        }
        if (indent) {
            style += "margin-left: ".concat(Math.max(indent, 0) * 20, "px;");
        }
        if (style) {
            attrs.style = style;
        }
        attrs["data-diff-id"] = dataDiffId || "ct-diff-id-".concat(esm_browser_v4());
        return [
            "p",
            attrs,
            0
        ];
    }
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getHeadingAttrs = function(node, level) {
    var align = getAlign(node);
    var indent = getIndent(node);
    var dataDiffId = node.getAttribute("data-diff-id");
    var attrs = {
        id: esm_browser_v4(),
        indent: indent,
        // 过滤可能的 justify
        align: align === "justify" ? "left" : align,
        dataDiffId: dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
    };
    return _objectSpread({
        level: level
    }, attrs);
};
var getHeading = function() {
    var levels = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        1,
        2,
        3,
        4,
        5,
        6
    ];
    var heading = {
        attrs: {
            id: {
                default: ""
            },
            level: {
                default: 1
            },
            indent: {
                default: 0
            },
            align: {
                default: "left"
            },
            dataDiffId: {
                default: null
            }
        },
        content: "inline*",
        textContentBlock: true,
        group: "block",
        defining: true,
        alignBlock: true,
        parseDOM: levels.map(function(level) {
            return {
                tag: "h".concat(level),
                preserveWhitespace: "full",
                getAttrs: function(dom) {
                    return getHeadingAttrs(dom, level);
                }
            };
        }),
        toDOM: function toDOM(node) {
            var _node_attrs = node.attrs, level = _node_attrs.level, align = _node_attrs.align, indent = _node_attrs.indent, id = _node_attrs.id, dataDiffId = _node_attrs.dataDiffId;
            var attrs = {};
            attrs.id = id || esm_browser_v4();
            var style = "";
            if (align && align !== "left") {
                style += "text-align: ".concat(align, ";");
            }
            if (indent) {
                style += "margin-left: ".concat(Math.max(indent, 0) * 20, "px;");
            }
            if (style) {
                attrs.style = style;
            }
            attrs.class = "ct-heading";
            attrs["data-diff-id"] = dataDiffId || "ct-diff-id-".concat(esm_browser_v4());
            return [
                "h".concat(level),
                attrs,
                0
            ];
        }
    };
    return heading;
};

var hard_break = {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [
        {
            tag: "br"
        }
    ],
    toDOM: function toDOM() {
        return [
            "br"
        ];
    }
};

var mention = {
    group: "inline",
    inline: true,
    // content: "inline*",
    // 修改原因: 将mention视为原子节点，里面不应该再包含其他任何节点。同时可以解决粘贴单个mention时，因为过滤了data-pm-slice属性之后而变成两个TextNode而不是mention Node #42274270
    atom: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 90,
    attrs: {
        name: {
            default: ""
        },
        uid: {
            default: ""
        },
        anchor: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'a[class*="ct-mention"]',
            getAttrs: function getAttrs(dom) {
                var nameDom = dom.querySelector("b");
                return {
                    name: nameDom ? nameDom.textContent : "",
                    uid: dom.getAttribute("data-uid"),
                    anchor: dom.getAttribute("data-anchor") || esm_browser_v4()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, name = _node_attrs.name, uid = _node_attrs.uid, anchor = _node_attrs.anchor;
        var attrs = {
            class: "ct-mention",
            "data-type": "ct-mention",
            "data-uid": uid,
            "data-anchor": anchor || esm_browser_v4()
        };
        return [
            "a",
            attrs,
            "@",
            [
                "b",
                name
            ]
        ];
    }
};

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var getListNodeAttrs = function(node) {
    var extraAttrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _node_attrs = node.attrs, indent = _node_attrs.indent, dataDiffId = _node_attrs.dataDiffId;
    var attrs = {
        "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
    };
    var style = "";
    if (indent) style += "margin-left: ".concat(indent * 20, "px;");
    if (style) attrs.style = style;
    return _objectSpread$1({}, attrs, extraAttrs);
};
var getItemNodeAttrs = function(node, extraAttrs) {
    var dataListItemDiffId = node.attrs.dataListItemDiffId;
    var attrs = {};
    attrs["data-list-item-diff-id"] = dataListItemDiffId || "ct-list-item-diff-id-".concat(esm_browser_v4());
    var firstChild = node.firstChild;
    if (firstChild && firstChild.type.name === "heading") {
        if (extraAttrs.class) {
            extraAttrs.class += " ct-item-level-".concat(firstChild.attrs.level);
        } else {
            attrs.class = "ct-item-level-".concat(firstChild.attrs.level);
        }
    }
    return _objectSpread$1({}, attrs, extraAttrs);
};

var citadel_schema_task_list = {
    attrs: {
        indent: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    content: "(task_item | list_item)+",
    group: "block",
    defining: true,
    listRole: true,
    parseDOM: [
        {
            tag: 'ul[class="ct-task-list"]',
            getAttrs: function(dom) {
                var dataDiffId = dom.getAttribute("data-diff-id");
                var indent = getIndent(dom);
                return {
                    indent: indent,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getListNodeAttrs(node, {
            class: "ct-task-list"
        });
        return [
            "ul",
            attrs,
            0
        ];
    }
};

var citadel_schema_task_item = {
    attrs: {
        checked: {
            default: false
        },
        level: {
            default: 0
        },
        dataListItemDiffId: {
            default: null
        }
    },
    content: "(paragraph | block)+",
    defining: true,
    parseDOM: [
        {
            tag: 'li[data-type="task_item"]',
            getAttrs: function getAttrs(dom) {
                var dataListItemDiffId = dom.getAttribute("data-list-item-diff-id");
                return {
                    checked: dom.classList.contains("ct-task-li-checked"),
                    dataListItemDiffId: dataListItemDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getItemNodeAttrs(node, {
            "data-type": "task_item",
            class: node.attrs.checked ? "ct-task-li-checked" : "ct-task-li"
        });
        return [
            "li",
            attrs,
            0
        ];
    }
};

var citadel_schema_ordered_list = {
    attrs: {
        indent: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    content: "(list_item | task_item)+",
    group: "block",
    defining: true,
    listRole: true,
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function(dom) {
                var indent = getIndent(dom);
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    indent: indent,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getListNodeAttrs(node);
        return [
            "ol",
            attrs,
            0
        ];
    }
};

var citadel_schema_bullet_list = {
    attrs: {
        indent: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    content: "(list_item | task_item)+",
    group: "block",
    defining: true,
    listRole: true,
    parseDOM: [
        {
            tag: 'ul:not([class="ct-task-list"])',
            getAttrs: function(dom) {
                var indent = getIndent(dom);
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    indent: indent,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getListNodeAttrs(node);
        return [
            "ul",
            attrs,
            0
        ];
    }
};

var citadel_schema_list_item = {
    attrs: {
        level: {
            default: 0
        },
        hidden: {
            default: false
        },
        dataListItemDiffId: {
            default: null
        }
    },
    content: "(paragraph | block)+",
    defining: true,
    parseDOM: [
        {
            tag: 'li:not([data-type="task_item"])',
            getAttrs: function getAttrs(dom) {
                var dataListItemDiffId = dom.getAttribute("data-list-item-diff-id");
                var hidden = dom.classList.contains("ct-hidden-item");
                return {
                    hidden: hidden,
                    dataListItemDiffId: dataListItemDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = getItemNodeAttrs(node, node.attrs.hidden ? {
            class: "ct-hidden-item"
        } : {});
        return [
            "li",
            attrs,
            0
        ];
    }
};

var citadel_schema_link = {
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        href: {
            default: ""
        },
        title: {
            default: ""
        },
        autoUpdate: {
            default: ""
        }
    },
    group: "inline",
    content: "text*",
    defining: true,
    allowGapCursor: true,
    parseDOM: [
        {
            tag: "a[href]",
            getAttrs: function getAttrs(dom) {
                return {
                    id: esm_browser_v4(),
                    href: dom.getAttribute("href"),
                    title: dom.innerText,
                    autoUpdate: dom.getAttribute("data-auto_update") === "1"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, href = _node_attrs.href, autoUpdate = _node_attrs.autoUpdate;
        var attrs = {
            class: "ct-link",
            href: href,
            "data-auto_update": autoUpdate ? "1" : "0"
        };
        return [
            "a",
            attrs,
            0
        ];
    }
};

var citadel_schema_time = {
    group: "inline",
    inline: true,
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 180,
    attrs: {
        isShowTime: {
            default: false
        },
        date: {
            default: ""
        },
        selectKey: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "time",
            getAttrs: function getAttrs(dom) {
                // 此处由原来的一个isShowTime变量（同时可以是string和boolean类型的值）更改为isShowTime和dataIsShowTime用于区分，
                var isShowTime;
                var dataIsShowTime = dom.getAttribute("data-isshowtime");
                if (dataIsShowTime === null) isShowTime = false;
                else if (dataIsShowTime === "true") isShowTime = true;
                else isShowTime = false;
                return {
                    date: dom.getAttribute("datetime"),
                    isShowTime: isShowTime,
                    selectKey: parseInt(dom.getAttribute("data-selectkey"), 10)
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, isShowTime = _node_attrs.isShowTime, date = _node_attrs.date, selectKey = _node_attrs.selectKey;
        var attrs = {
            class: "ct-time",
            datetime: "".concat(date),
            "data-isshowtime": "".concat(isShowTime),
            "data-selectkey": "".concat(selectKey)
        };
        return [
            "time",
            attrs,
            0
        ];
    }
};

var horizontal_rule = {
    group: "block",
    allowGapCursor: true,
    insertBlock: true,
    attrs: {
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "hr",
            getAttrs: function(dom) {
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(dom) {
        var dataDiffId = dom.attrs.dataDiffId;
        var attrs = {
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "hr",
            attrs
        ];
    }
};

var latex_inline = {
    group: "inline",
    content: "text*",
    inline: true,
    atom: true,
    allowGapCursor: true,
    braceWidth: 10,
    attrs: {
        content: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[class="ct-latex"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    dataDiffId: dom.getAttribute("data-diff-id"),
                    content: (dom.getAttribute("data-content") || dom.textContent || "").replace(/<br \/>/g, "\n")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-latex",
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "span",
            nodeAttrs,
            [
                "code",
                0
            ]
        ];
    }
};

var latex_block = {
    group: "block",
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 200,
    attrs: {
        content: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-latex"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    dataDiffId: dom.getAttribute("data-diff-id"),
                    content: (dom.getAttribute("data-content") || dom.textContent || "").replace(/<br \/>/g, "\n")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, source = _node_attrs.source, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-latex",
            "data-source": source,
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            nodeAttrs,
            [
                "pre",
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var citadel_schema_image = {
    atom: true,
    group: "inline",
    inline: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        src: {
            default: ""
        },
        small: {
            default: ""
        },
        origin: {
            default: ""
        },
        mss: {
            default: ""
        },
        name: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        link: {
            default: null
        },
        border: {
            default: false
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-image"]',
            getAttrs: function getAttrs(dom) {
                var img = dom.querySelector("img");
                if (!img) {
                    return undefined;
                }
                var src = img.getAttribute("data-src");
                return {
                    src: src,
                    small: img.getAttribute("data-small") || src,
                    origin: img.getAttribute("data-origin") || src,
                    mss: img.getAttribute("data-mss") || "",
                    name: img.getAttribute("alt") || "",
                    width: parseInt(img.getAttribute("data-width"), 10) || 0,
                    height: parseInt(img.getAttribute("data-height"), 10) || 0,
                    link: img.getAttribute("data-link") || null,
                    border: dom.classList.contains("ct-image-border")
                };
            }
        },
        {
            tag: "img",
            getAttrs: function getAttrs(dom) {
                var src = dom.getAttribute("src");
                return {
                    name: dom.getAttribute("alt") || "",
                    origin: src,
                    small: src,
                    src: src,
                    width: dom.getAttribute("data-width") || dom.getAttribute("width") || 0,
                    height: dom.getAttribute("data-height") || dom.getAttribute("height") || 0
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, mss = _node_attrs.mss, name = _node_attrs.name, width = _node_attrs.width, height = _node_attrs.height, link = _node_attrs.link, border = _node_attrs.border;
        var _node_attrs1 = node.attrs, small = _node_attrs1.small, src = _node_attrs1.src, origin = _node_attrs1.origin;
        var attrs = {
            class: "ct-image".concat(border ? " ct-image-border" : "")
        };
        var imgAttrs = {
            alt: name.length > 100 ? "".concat(name.substr(0, 100), "...") : name,
            "data-origin": origin,
            "data-small": small,
            "data-src": src
        };
        if (width && width !== "0") {
            attrs.style = "width: ".concat(width, "px");
            imgAttrs["data-width"] = width;
            imgAttrs["data-height"] = height;
        }
        if (mss) {
            imgAttrs["data-mss"] = mss;
        }
        if (link) {
            imgAttrs["data-link"] = link;
        }
        return [
            "span",
            attrs,
            [
                "img",
                imgAttrs
            ]
        ];
    }
};

var citadel_schema_colors = [
    "#ccc",
    "#f5222d",
    "#fadb14",
    "#52c41a",
    "#1890ff"
];
var colorsMap = {
    gray: "#ccc",
    red: "#f5222d",
    yellow: "#fadb14",
    green: "#52c41a",
    blue: "#1890ff"
};

var formatOldValue = function(color) {
    if (colorsMap[color]) {
        return colorsMap[color];
    }
    return color || "";
};
var citadel_schema_status = {
    group: "inline",
    content: "text*",
    inline: true,
    defining: true,
    allowGapCursor: true,
    braceWidth: 90,
    attrs: {
        pattern: {
            default: "fill"
        },
        color: {
            default: "#ccc"
        },
        expand: {
            default: false
        },
        input: {
            default: false
        },
        selectedkey: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-status"]',
            getAttrs: function(dom) {
                var color = formatOldValue(dom.getAttribute("data-color"));
                return {
                    color: color,
                    pattern: dom.getAttribute("data-pattern"),
                    expand: !citadel_schema_colors.includes(color)
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, pattern = _node_attrs.pattern, color = _node_attrs.color;
        var nodeAttrs = {
            class: "ct-status",
            "data-pattern": pattern,
            "data-color": color
        };
        return [
            "span",
            nodeAttrs,
            0
        ];
    }
};

var audio = {
    group: "block",
    atom: true,
    draggable: true,
    dragBlock: true,
    insertBlock: true,
    alignBlock: true,
    allowGapCursor: true,
    braceWidth: 540,
    attrs: {
        url: {
            default: ""
        },
        size: {
            default: ""
        },
        name: {
            default: ""
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-audio"]',
            getAttrs: function getAttrs(dom) {
                var align = "left";
                if (dom.className.includes("center")) {
                    align = "center";
                } else if (dom.className.includes("right")) {
                    align = "right";
                }
                return {
                    url: dom.getAttribute("data-url"),
                    name: dom.getAttribute("data-name"),
                    size: dom.getAttribute("data-size"),
                    align: align,
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, url = _node_attrs.url, name = _node_attrs.name, size = _node_attrs.size, align = _node_attrs.align, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-audio",
            "data-url": url,
            "data-name": name,
            "data-size": size,
            contenteditable: "false",
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        if (align === "center") {
            nodeAttrs.class += " align-center";
        } else if (align === "right") {
            nodeAttrs.class += " align-right";
        }
        var audioAttrs = {
            controls: "false",
            preload: "meta"
        };
        return [
            "div",
            nodeAttrs,
            [
                "audio",
                audioAttrs,
                "本浏览器不支持 HTML5 audio 标签"
            ]
        ];
    }
};

var video = {
    group: "block",
    atom: true,
    draggable: true,
    dragBlock: true,
    insertBlock: true,
    alignBlock: true,
    allowGapCursor: true,
    braceWidth: 540,
    attrs: {
        url: {
            default: ""
        },
        size: {
            default: ""
        },
        name: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-video"]',
            getAttrs: function getAttrs(dom) {
                var align = "left";
                if (dom.className.includes("center")) {
                    align = "center";
                } else if (dom.className.includes("right")) {
                    align = "right";
                }
                return {
                    url: dom.getAttribute("data-url"),
                    name: dom.getAttribute("data-name"),
                    size: dom.getAttribute("data-size"),
                    width: dom.getAttribute("data-width") || 0,
                    height: dom.getAttribute("data-height") || 0,
                    align: align,
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, url = _node_attrs.url, name = _node_attrs.name, size = _node_attrs.size, width = _node_attrs.width, height = _node_attrs.height, align = _node_attrs.align, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-video",
            "data-url": url,
            "data-name": name,
            "data-size": size,
            "data-width": width,
            "data-height": height,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        if (align === "center") {
            nodeAttrs.class += " align-center";
        } else if (align === "right") {
            nodeAttrs.class += " align-right";
        }
        var videoAttrs = {
            controls: "false",
            preload: "meta"
        };
        return [
            "div",
            nodeAttrs,
            [
                "video",
                videoAttrs,
                "本浏览器不支持 HTML5 video 标签"
            ]
        ];
    }
};

var formatSize = function(size) {
    if (!size) {
        size = "0KB";
    }
    var count = -1;
    for(var i = size.length - 1; i >= 0; i--){
        if (size[i].toUpperCase() !== "B") break;
        count += 1;
    }
    return size.slice(0, size.length - count);
};
var citadel_schema_attachment = {
    group: "block",
    atom: true,
    draggable: true,
    insertBlock: true,
    alignBlock: true,
    allowGapCursor: true,
    braceWidth: 340,
    attrs: {
        src: {
            default: ""
        },
        size: {
            default: ""
        },
        name: {
            default: ""
        },
        align: {
            default: "left"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'a[class~="ct-attachment"]',
            getAttrs: function getAttrs(dom) {
                var align = "left";
                if (dom.className.includes("center")) {
                    align = "center";
                } else if (dom.className.includes("right")) {
                    align = "right";
                }
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    src: dom.getAttribute("data-src"),
                    size: dom.querySelector(".size").innerText,
                    name: dom.querySelector(".name").innerText,
                    align: align,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, name = _node_attrs.name, size = _node_attrs.size, src = _node_attrs.src, align = _node_attrs.align, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-attachment",
            spellcheck: "false",
            "data-src": src,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        if (align === "center") {
            nodeAttrs.class += " align-center";
        } else if (align === "right") {
            nodeAttrs.class += " align-right";
        }
        return [
            "a",
            nodeAttrs,
            [
                "div",
                {
                    class: "large-icon"
                }
            ],
            [
                "div",
                {
                    class: "right"
                },
                [
                    "div",
                    {
                        class: "name",
                        title: name
                    },
                    name
                ],
                [
                    "div",
                    {
                        class: "size"
                    },
                    formatSize(size)
                ],
                [
                    "div",
                    {
                        class: "copy"
                    },
                    [
                        "div",
                        {
                            class: "btn-copy"
                        }
                    ]
                ],
                [
                    "div",
                    {
                        class: "download"
                    },
                    [
                        "div",
                        {
                            class: "btn-download"
                        }
                    ]
                ]
            ]
        ];
    }
};

var DEFAULT_LANGUAGE = "Plain Text";
var DEFAULT_THEME = "xq-light";
var DEFAULT_TITLE = "代码块";
var code_block = {
    group: "block",
    content: "text*",
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    marks: "",
    attrs: {
        language: {
            default: DEFAULT_LANGUAGE
        },
        theme: {
            default: DEFAULT_THEME
        },
        title: {
            default: DEFAULT_TITLE
        },
        isExpand: {
            default: true
        },
        isCreate: {
            default: false
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-code"]',
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                var titleDOM = dom.querySelector(".title");
                var languageDOM = dom.querySelector(".language");
                var dataDiffId = dom.getAttribute("data-diff-id");
                var _dom_dataset = dom.dataset, _dom_dataset_language = _dom_dataset.language, language = _dom_dataset_language === void 0 ? languageDOM ? languageDOM.getAttribute("data-language") || DEFAULT_LANGUAGE : DEFAULT_LANGUAGE : _dom_dataset_language, _dom_dataset_theme = _dom_dataset.theme, theme = _dom_dataset_theme === void 0 ? DEFAULT_THEME : _dom_dataset_theme, _dom_dataset_title = _dom_dataset.title, title = _dom_dataset_title === void 0 ? titleDOM ? titleDOM.getAttribute("data-title") || DEFAULT_TITLE : DEFAULT_TITLE : _dom_dataset_title;
                var isExpand;
                if (dom.querySelector(".isNotExpand")) {
                    isExpand = false;
                } else {
                    isExpand = dom.getAttribute("data-expand") !== "false";
                }
                return {
                    language: language,
                    theme: theme,
                    title: title,
                    isExpand: isExpand,
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, language = _node_attrs.language, theme = _node_attrs.theme, title = _node_attrs.title, isExpand = _node_attrs.isExpand, dataDiffId = _node_attrs.dataDiffId;
        var attrs = {
            class: "ct-code",
            spellcheck: "false",
            "data-language": language,
            "data-theme": theme,
            "data-title": title,
            "data-expand": isExpand,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            attrs,
            [
                "pre",
                {},
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var citadel_schema_catalog = {
    group: "block",
    atom: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 420,
    attrs: {
        style: {
            default: "none"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-edit-catalog"]',
            getAttrs: function(dom) {
                if (typeof dom === "object" && dom.getAttribute("data-style")) {
                    var dataDiffId = dom.getAttribute("data-diff-id");
                    return {
                        style: dom.getAttribute("data-style"),
                        dataDiffId: dataDiffId
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, style = _node_attrs.style, dataDiffId = _node_attrs.dataDiffId;
        var catalogAttrs = {
            class: "ct-edit-catalog",
            "data-style": style,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            catalogAttrs,
            "目录"
        ];
    }
};

var citadel_schema_note = {
    group: "block",
    content: "note_title note_content",
    isolating: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 300,
    attrs: {
        type: {
            default: "note"
        },
        hiddenTitle: {
            default: true
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-note"]',
            getAttrs: function(dom) {
                return {
                    type: dom.getAttribute("data-type"),
                    hiddenTitle: dom.classList.contains("hidden-title"),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, type = _node_attrs.type, hiddenTitle = _node_attrs.hiddenTitle, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-note".concat(hiddenTitle ? " hidden-title" : ""),
            "data-type": type,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var citadel_schema_note_title = {
    content: "text*",
    alignBlock: true,
    attrs: {
        align: {
            default: "left"
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-note-title"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    align: dom.style.textAlign
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var align = node.attrs.align;
        var attrs = {
            class: "ct-note-title"
        };
        if (align && align !== "left") {
            attrs.style = "text-align: ".concat(align, ";");
        }
        return [
            "div",
            attrs,
            [
                "span",
                {
                    class: "ct-note-title-text"
                },
                0
            ]
        ];
    }
};

var citadel_schema_note_content = {
    content: "block+",
    attrs: {},
    parseDOM: [
        {
            tag: 'div[class~="ct-note-content"]'
        }
    ],
    toDOM: function toDOM() {
        var nodeAttrs = {
            class: "ct-note-content"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var blockquote = {
    content: "block+",
    group: "block",
    defining: true,
    allowGapCursor: true,
    attrs: {
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "blockquote",
            getAttrs: function getAttrs(dom) {
                var dataDiffId = dom.getAttribute("data-diff-id");
                return {
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(dom) {
        var dataDiffId = dom.attrs.dataDiffId;
        return [
            "blockquote",
            {
                class: "ct-blockquote",
                "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
            },
            0
        ];
    }
};

var spaceupdate = {
    group: "block",
    content: "text*",
    atom: true,
    insertBlock: true,
    dragBlock: true,
    draggable: true,
    braceWidth: 200,
    attrs: {
        spaceId: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-space-update"]',
            getAttrs: function(dom) {
                return {
                    spaceId: dom.getAttribute("data-space-id") || ""
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var spaceId = node.attrs.spaceId;
        var nodeAttrs = {
            class: "ct-space-update",
            "data-space-id": spaceId,
            contenteditable: "false"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

// 默认不限深度
var DEFAULT_MAX_DEPTH = 0;
var page_tree = {
    group: "block",
    content: "text*",
    atom: true,
    insertBlock: true,
    dragBlock: true,
    draggable: true,
    braceWidth: 200,
    attrs: {
        spaceId: {
            default: ""
        },
        pageId: {
            default: ""
        },
        maxDepth: {
            default: DEFAULT_MAX_DEPTH
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-page-tree"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    spaceId: dom.getAttribute("data-space-id") || "",
                    pageId: dom.getAttribute("data-page-id") || "",
                    maxDepth: dom.getAttribute("data-max-depth") || DEFAULT_MAX_DEPTH
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, spaceId = _node_attrs.spaceId, pageId = _node_attrs.pageId, maxDepth = _node_attrs.maxDepth;
        var nodeAttrs = {
            class: "ct-page-tree",
            "data-space-id": spaceId,
            "data-page-id": pageId,
            "data-max-depth": maxDepth,
            contenteditable: "false"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var citadel_schema_table = {
    content: "table_row+",
    tableRole: "table",
    isolating: true,
    allowGapCursor: true,
    insertBlock: true,
    group: "block",
    attrs: {
        indent: {
            default: 0
        },
        responsive: {
            default: false
        },
        borderStyle: {
            default: "solid"
        },
        borderWidth: {
            default: 1
        },
        borderColor: {
            default: "#dddddd"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "table",
            getAttrs: function getAttrs(dom) {
                var borderWidth = parseInt(dom.getAttribute("data-borderwidth"), 10);
                return {
                    indent: getIndent(dom),
                    responsive: dom.classList.contains("responsive"),
                    borderStyle: dom.getAttribute("data-borderstyle") || "solid",
                    borderWidth: Number.isNaN(borderWidth) ? 1 : borderWidth,
                    borderColor: dom.getAttribute("data-bordercolor") || "#dddddd",
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, indent = _node_attrs.indent, responsive = _node_attrs.responsive, borderStyle = _node_attrs.borderStyle, borderWidth = _node_attrs.borderWidth, borderColor = _node_attrs.borderColor, dataDiffId = _node_attrs.dataDiffId;
        var attrs = {};
        if (indent > 0) attrs.style = "margin-left: ".concat(indent * 20, "px;");
        if (responsive) attrs.class = "responsive";
        // TODO: 需要云皓之后有空补充说明一下当时加这三个if条件判断的原因
        if (borderStyle !== "solid") attrs["data-borderstyle"] = borderStyle;
        if (borderWidth !== "1") attrs["data-borderwidth"] = borderWidth;
        if (borderColor !== "#dddddd") attrs["data-bordercolor"] = borderColor;
        attrs["data-diff-id"] = dataDiffId || "ct-diff-id-".concat(esm_browser_v4());
        return [
            "table",
            attrs,
            [
                "tbody",
                0
            ]
        ];
    }
};

var citadel_schema_table_row = {
    content: "(table_cell | table_header)*",
    tableRole: "row",
    attrs: {
        dataRowDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "tr",
            getAttrs: function getAttrs(dom) {
                var dataRowDiffId = dom.getAttribute("data-row-diff-id");
                return {
                    dataRowDiffId: dataRowDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var dataRowDiffId = node.attrs.dataRowDiffId;
        var attrs = {
            "data-row-diff-id": dataRowDiffId || "ct-tr-diff-id-".concat(esm_browser_v4())
        };
        return [
            "tr",
            attrs,
            0
        ];
    }
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_COL_WIDTH = 68;
var MIN_COL_WIDTH = 50;
var cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: [
            DEFAULT_COL_WIDTH
        ]
    },
    textAlign: {
        default: null
    },
    verticalAlign: {
        default: null
    },
    bgColor: {
        default: null
    },
    color: {
        default: null
    },
    numCell: {
        default: null
    },
    dataCellDiffId: {
        default: null
    }
};
// dpi=1.25时，表格宽度需要为 4 的整数倍
var formatWidth = function(width) {
    // width = Math.round(width);
    // width = Math.round(width / 4) * 4;
    return width;
};
var getWidthNumber = function(width, tableWidth) {
    if (typeof width === "string") {
        // 兼容百分比宽度
        if (width.includes("%")) {
            return parseFloat(width) * 0.01 * tableWidth;
        }
        return parseInt(width, 10);
    }
    return width;
};
var checkBraceWidthChild = function(node) {
    var textBlockNames = [
        "paragraph",
        "heading"
    ];
    var hasBraceWidthChild = false;
    node.content.forEach(function(child) {
        if (child.type.spec.braceWidth) {
            hasBraceWidthChild = true;
        } else if (textBlockNames.includes(child.type.name)) {
            child.content.forEach(function(inlineChild) {
                if (inlineChild.type.spec.braceWidth) {
                    hasBraceWidthChild = true;
                }
            });
        }
    });
    return hasBraceWidthChild;
};
function getCellAttrs(dom) {
    var pmDOM = document.querySelector(".ProseMirror");
    var widthAttr = dom.getAttribute("data-colwidth");
    var tableWidth = pmDOM ? pmDOM.clientWidth : 0;
    var tableEl = dom.parentNode.parentNode.parentNode;
    var colgroupEl = tableEl.children[0];
    var index = Array.from(dom.parentNode.children).findIndex(function(el) {
        return el === dom;
    });
    var col = colgroupEl.children[index];
    var colspan = parseFloat(dom.getAttribute("colspan")) || 1;
    var rowspan = parseFloat(dom.getAttribute("rowspan")) || 1;
    if (!widthAttr) {
        widthAttr = dom.width || dom.style.width || col && (col.width || col.style.width);
        tableWidth = getWidthNumber(tableEl.style.width, tableWidth);
    }
    var widths;
    /**
   * 很早以前的数据可能出现 widthAttr 的数量大于 colspan，
   * 后来修改逻辑之后 widthAttr 的数量一定等于 colspan。
   * 为了避免异常对于这样的数据，将所有 width 求和成一个 col 的 width，其余的 col 填充最小宽度
   */ if (widthAttr && widthAttr.split(",").length > colspan) {
        widths = [
            widthAttr.split(",").map(function(p) {
                return parseInt(p, 10);
            }).reduce(function(prev, cur) {
                return prev + cur;
            })
        ];
    } else {
        // 如果没有 widthAttr 则将第一个 col 设为表格总宽度除以列数，其余的 col 填充最小宽度
        widths = widthAttr ? widthAttr.split(",").map(function(w) {
            return getWidthNumber(w, tableWidth);
        }) : [
            tableWidth / (colgroupEl.children[0] ? colgroupEl.children[0].children.length : 1)
        ];
        widths = widths.map(function(num) {
            return num < MIN_COL_WIDTH ? MIN_COL_WIDTH : ~~num;
        });
    }
    var widthsLen = widths.length;
    if (widthsLen < colspan) {
        var fillArr = new Array(colspan - widthsLen);
        fillArr.fill(MIN_COL_WIDTH);
        widths = _toConsumableArray(widths).concat(_toConsumableArray(fillArr));
    }
    if (window.devicePixelRatio === 1.25) {
        widths = widths.map(formatWidth);
    }
    var dataCellDiffId = dom.getAttribute("data-cell-diff-id");
    var result = {
        dataCellDiffId: dataCellDiffId,
        colspan: colspan,
        rowspan: rowspan,
        colwidth: widthsLen <= colspan ? widths : [
            MIN_COL_WIDTH
        ],
        bgColor: dom.style.backgroundColor,
        // table_cell 上不应该存在textAlign属性。避免改schema，姑且在这里设空
        // 相关ones #6816509 #64513785
        textAlign: "",
        verticalAlign: dom.style.verticalAlign,
        color: dom.style.color,
        numCell: dom.classList.contains("num-cell")
    };
    return result;
}
function setCellAttrs(node) {
    var attrs = {};
    var nodeAttrs = node.attrs;
    // 未知原因 span 的值可能出现负数，此时使用默认值 1
    nodeAttrs.colspan = Math.max(nodeAttrs.colspan, 1);
    nodeAttrs.rowspan = Math.max(nodeAttrs.rowspan, 1);
    if (nodeAttrs.colspan !== 1) {
        attrs.colspan = nodeAttrs.colspan;
    }
    if (nodeAttrs.rowspan !== 1) {
        attrs.rowspan = nodeAttrs.rowspan;
    }
    if (nodeAttrs.colwidth) {
        attrs["data-colwidth"] = nodeAttrs.colwidth.join(",");
    } else {
        attrs["data-colwidth"] = "".concat(DEFAULT_COL_WIDTH);
    }
    attrs.width = attrs["data-colwidth"];
    // 检查单元格内是否有会溢出内容
    if (checkBraceWidthChild(node)) attrs.class = "overflow";
    var style = "";
    if (nodeAttrs.bgColor) style += "background-color: ".concat(nodeAttrs.bgColor, ";");
    if (nodeAttrs.color) style += "color: ".concat(nodeAttrs.color, ";");
    if (nodeAttrs.verticalAlign) {
        style += "vertical-align:".concat(nodeAttrs.verticalAlign, ";");
    }
    if (style) attrs.style = style;
    if (nodeAttrs.numCell) {
        attrs.contenteditable = true;
        attrs.style = "caret-color: transparent";
        attrs.class = attrs.class ? "".concat(attrs.class, " num-cell") : "num-cell";
    }
    attrs["data-cell-diff-id"] = nodeAttrs.dataCellDiffId || "ct-cell-diff-id-".concat(esm_browser_v4());
    return attrs;
}

var citadel_schema_table_cell = {
    content: "block+",
    attrs: cellAttrs,
    tableRole: "cell",
    isolating: true,
    parseDOM: [
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return getCellAttrs(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            setCellAttrs(node),
            0
        ];
    }
};

var citadel_schema_table_header = {
    content: "block+",
    attrs: cellAttrs,
    tableRole: "header_cell",
    isolating: true,
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return getCellAttrs(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            setCellAttrs(node),
            0
        ];
    }
};

var markdown = {
    group: "block",
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 200,
    attrs: {
        content: {
            default: ""
        },
        source: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-markdown"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    source: dom.getAttribute("data-source") || "",
                    content: (dom.getAttribute("data-content") || dom.textContent || "").replace(/<br \/>/g, "\n"),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, source = _node_attrs.source, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-markdown",
            "data-source": source,
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            nodeAttrs,
            [
                "pre",
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var citadel_schema_html = {
    group: "block",
    content: "inline*",
    atom: true,
    draggable: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 200,
    attrs: {
        content: {
            default: ""
        },
        source: {
            default: ""
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class="ct-html"]',
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    source: dom.getAttribute("data-source") || "",
                    content: dom.getAttribute("data-content") || dom.textContent || "",
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, source = _node_attrs.source, content = _node_attrs.content, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-html",
            "data-source": source,
            "data-content": content,
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            nodeAttrs,
            [
                "pre",
                [
                    "code",
                    0
                ]
            ]
        ];
    }
};

var gantt = {
    group: "block",
    content: "inline*",
    atom: true,
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    attrs: {
        id: {
            default: ""
        },
        height: {
            default: "0"
        },
        version: {
            default: "0"
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-gantt"]',
            getAttrs: function(dom) {
                return {
                    id: dom.getAttribute("data-id"),
                    height: parseInt(dom.getAttribute("data-height"), 10),
                    version: parseInt(dom.getAttribute("data-version"), 10),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, id = _node_attrs.id, height = _node_attrs.height, version = _node_attrs.version, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-gantt",
            "data-id": "".concat(id),
            "data-height": "".concat(height),
            "data-version": "".concat(version),
            style: "{height: ".concat(height, "px}"),
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            nodeAttrs
        ];
    }
};

var data2chart = {
    group: "inline",
    inline: true,
    atom: true,
    allowGapCursor: true,
    dragBlock: true,
    attrs: {
        id: {
            default: ""
        },
        config: {
            default: ""
        },
        chartData: {
            default: ""
        },
        pageId: {
            default: ""
        },
        chartId: {
            default: ""
        },
        height: {
            default: 400
        },
        width: {
            default: 600
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-data2chart"]',
            getAttrs: function(dom) {
                return {
                    id: dom.getAttribute("data-data2chart-id"),
                    pageId: dom.getAttribute("data-data2chart-page-id"),
                    config: dom.getAttribute("data-config"),
                    chartData: dom.getAttribute("data-chartData"),
                    chartId: dom.getAttribute("data-data2chart-chartId"),
                    height: dom.getAttribute("data-height"),
                    width: dom.getAttribute("data-width")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, id = _node_attrs.id, pageId = _node_attrs.pageId, chartId = _node_attrs.chartId, height = _node_attrs.height, width = _node_attrs.width;
        var nodeAttrs = {
            class: "ct-data2chart",
            "data-data2chart-id": "".concat(id),
            "data-data2chart-page-id": "".concat(pageId),
            "data-data2chart-chartId": chartId ? "".concat(chartId) : "",
            "data-height": height,
            "data-width": width
        };
        return [
            "span",
            nodeAttrs
        ];
    }
};

var calendar = {
    group: "block",
    allowGapCursor: true,
    insertBlock: true,
    dragBlock: true,
    braceWidth: 900,
    draggable: false,
    selectable: false,
    atom: true,
    attrs: {
        id: {
            default: 0
        },
        view: {
            default: "month"
        },
        docId: {
            default: 0
        },
        paste: {
            default: 0
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'div[class~="ct-calendar"]',
            getAttrs: function(dom) {
                return {
                    id: parseInt(dom.getAttribute("data-id"), 10),
                    docId: parseInt(dom.getAttribute("data-doc-id"), 10),
                    paste: parseInt(dom.getAttribute("data-paste"), 10),
                    view: dom.getAttribute("data-view"),
                    dataDiffId: dom.getAttribute("data-diff-id")
                };
            }
        }
    ],
    toDOM: function(node) {
        var _node_attrs = node.attrs, id = _node_attrs.id, docId = _node_attrs.docId, paste = _node_attrs.paste, view = _node_attrs.view, dataDiffId = _node_attrs.dataDiffId;
        var v = view;
        if (view !== "month" && view !== "week") {
            v = "month";
        }
        var attrs = {
            class: "ct-calendar",
            "data-id": "".concat(id),
            "data-view": "".concat(v),
            "data-doc-id": "".concat(docId),
            "data-paste": "".concat(paste),
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            attrs
        ];
    }
};

var plantuml = {
    atom: true,
    group: "inline",
    inline: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        content: {
            default: ""
        },
        width: {
            default: 64
        },
        height: {
            default: 64
        },
        border: {
            default: false
        },
        resize: {
            default: true
        }
    },
    parseDOM: [
        {
            tag: 'span[class~="ct-plantuml"]',
            getAttrs: function getAttrs(dom) {
                return {
                    content: decodeURI(dom.getAttribute("data-content") || ""),
                    width: parseInt(dom.getAttribute("data-width") || "0", 10),
                    height: parseInt(dom.getAttribute("data-height") || "0", 10),
                    border: dom.getAttribute("data-border") || false,
                    resize: true
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, width = _node_attrs.width, content = _node_attrs.content, border = _node_attrs.border, height = _node_attrs.height;
        var attrs = {
            class: "ct-plantuml",
            "data-content": encodeURI(content),
            "data-width": "".concat(width),
            "data-height": "".concat(height),
            "data-border": "".concat(border ? 1 : "")
        };
        return [
            "span",
            attrs
        ];
    }
};

var drawio = {
    group: "inline",
    inline: true,
    atom: true,
    draggable: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        src: {
            default: ""
        },
        xml: {
            default: ""
        },
        mss: {
            default: ""
        },
        mssXml: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        border: {
            default: true
        },
        hadResize: {
            default: false
        }
    },
    parseDOM: [
        {
            priority: 60,
            tag: 'span[class~="ct-drawio"]',
            getAttrs: function getAttrs(dom) {
                var img = dom.querySelector("img") || dom;
                return {
                    src: img.getAttribute("data-src"),
                    "data-src": img.getAttribute("data-src"),
                    mss: img.getAttribute("data-mss") || "",
                    xml: img.getAttribute("data-xml"),
                    mssXml: img.getAttribute("data-mssxml") || "",
                    width: img.getAttribute("data-width") || 0,
                    height: img.getAttribute("data-height") || 0,
                    border: dom.classList.contains("ct-image-border"),
                    hadResize: dom.getAttribute("data-hadresize")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, src = _node_attrs.src, xml = _node_attrs.xml, mss = _node_attrs.mss, mssXml = _node_attrs.mssXml, width = _node_attrs.width, height = _node_attrs.height, border = _node_attrs.border, hadResize = _node_attrs.hadResize;
        var attrs = {
            class: "ct-drawio".concat(border ? " ct-image-border" : ""),
            style: ""
        };
        var imgAttrs = {
            alt: "draw.io",
            "data-src": src,
            "data-type": "drawio"
        };
        if (xml) {
            imgAttrs["data-xml"] = xml;
        }
        if (width) {
            attrs.style = "width: ".concat(width, "px");
            imgAttrs["data-width"] = width;
            imgAttrs["data-height"] = height;
        }
        if (mss) {
            imgAttrs["data-mss"] = mss;
            if (mssXml) {
                imgAttrs["data-mssxml"] = mssXml;
            }
        }
        if (hadResize) {
            attrs["data-hadresize"] = hadResize;
        }
        return [
            "span",
            attrs,
            [
                "img",
                imgAttrs
            ]
        ];
    }
};

var minder = {
    atom: true,
    draggable: true,
    group: "inline",
    inline: true,
    allowGapCursor: true,
    braceWidth: 82,
    attrs: {
        src: {
            default: ""
        },
        width: {
            default: 0
        },
        height: {
            default: 0
        },
        border: {
            default: true
        },
        hadResize: {
            default: false
        }
    },
    parseDOM: [
        {
            priority: 60,
            tag: 'span[class~="ct-minder"]',
            getAttrs: function getAttrs(dom) {
                var img = dom.querySelector("img") || dom;
                return {
                    src: img.getAttribute("data-src"),
                    "data-src": img.getAttribute("data-src"),
                    width: img.getAttribute("data-width") || 0,
                    height: img.getAttribute("data-height") || 0,
                    border: dom.classList.contains("ct-image-border"),
                    hadResize: dom.getAttribute("data-hadresize")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, src = _node_attrs.src, width = _node_attrs.width, height = _node_attrs.height, border = _node_attrs.border, hadResize = _node_attrs.hadResize;
        var attrs = {
            class: "ct-minder".concat(border ? " ct-image-border" : ""),
            style: ""
        };
        var imgAttrs = {
            alt: "minder",
            "data-src": src,
            "data-type": "minder"
        };
        if (width || height) {
            attrs.style = "width: ".concat(width, "px; height: ").concat(height, "px");
            imgAttrs["data-width"] = width;
            imgAttrs["data-height"] = height;
        }
        if (hadResize) {
            attrs["data-hadresize"] = hadResize;
        }
        return [
            "span",
            attrs,
            [
                "img",
                imgAttrs
            ]
        ];
    }
};

var citadel_schema_collapse = {
    group: "block",
    content: "collapse_title collapse_content",
    isolating: true,
    allowGapCursor: true,
    dragBlock: true,
    insertBlock: true,
    braceWidth: 300,
    attrs: {
        active: {
            default: true
        },
        dataDiffId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "div[class~='ct-collapse']",
            getAttrs: function getAttrs(dom) {
                var ele = dom;
                var dataDiffId = ele.getAttribute("data-diff-id");
                return {
                    active: ele.classList.contains("active"),
                    dataDiffId: dataDiffId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node_attrs = node.attrs, active = _node_attrs.active, dataDiffId = _node_attrs.dataDiffId;
        var nodeAttrs = {
            class: "ct-collapse".concat(active ? " active" : ""),
            "data-diff-id": dataDiffId || "ct-diff-id-".concat(esm_browser_v4())
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};
var citadel_schema_collapse_title = {
    content: "text*",
    draggable: false,
    isolating: true,
    alignBlock: true,
    attrs: {
        align: {
            default: "left"
        }
    },
    parseDOM: [
        {
            tag: "div[class~='ct-collapse-title']",
            preserveWhitespace: "full",
            getAttrs: function(dom) {
                return {
                    align: dom.style.textAlign
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var align = node.attrs.align;
        var attrs = {
            class: "ct-collapse-title"
        };
        if (align && align !== "left") {
            attrs.style = "text-align: ".concat(align, ";");
        }
        return [
            "div",
            attrs,
            [
                "span",
                {
                    class: "ct-collapse-title-text",
                    spellCheck: false
                },
                0
            ]
        ];
    }
};
var citadel_schema_collapse_content = {
    content: "block+",
    isolating: true,
    attrs: {},
    parseDOM: [
        {
            tag: "div[class~='ct-collapse-content']"
        }
    ],
    toDOM: function toDOM() {
        var nodeAttrs = {
            class: "ct-collapse-content"
        };
        return [
            "div",
            nodeAttrs,
            0
        ];
    }
};

var em = {
    parseDOM: [
        {
            tag: "i"
        },
        {
            tag: "em"
        },
        {
            style: "font-style=italic"
        }
    ],
    toDOM: function() {
        return [
            "em"
        ];
    }
};

var strikethrough = {
    parseDOM: [
        {
            tag: "del"
        },
        {
            style: "text-decoration=line-through"
        }
    ],
    toDOM: function toDOM() {
        return [
            "del"
        ];
    }
};

var strong = {
    parseDOM: [
        {
            tag: "strong"
        },
        {
            tag: "b",
            getAttrs: function(dom) {
                return dom.style.fontWeight !== "normal" && null;
            }
        },
        {
            style: "font-weight",
            getAttrs: function(value) {
                return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "strong"
        ];
    }
};

var underline = {
    parseDOM: [
        {
            tag: "u"
        },
        {
            style: "text-decoration=underline"
        }
    ],
    toDOM: function toDOM() {
        return [
            "u"
        ];
    }
};

var citadel_schema_font = {
    attrs: {
        dataSize: {
            default: 14
        }
    },
    parseDOM: [
        {
            tag: "font",
            getAttrs: function(dom) {
                var size = parseInt(dom.getAttribute("data-size"), 10) || 14;
                return {
                    dataSize: size
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var lineHeight = node.attrs.dataSize + 8;
        var style = {
            style: "font-size:".concat(node.attrs.dataSize, "px;line-height:").concat(lineHeight, "px"),
            "data-size": node.attrs.dataSize
        };
        return [
            "font",
            style
        ];
    }
};

var citadel_schema_color = {
    attrs: {
        color: {
            default: "#333"
        }
    },
    parseDOM: [
        {
            priority: 20,
            tag: "span[style*=color]",
            getAttrs: function(node) {
                return {
                    color: node.style.color
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                style: "color: ".concat(node.attrs.color)
            }
        ];
    }
};

var sub = {
    parseDOM: [
        {
            tag: "sub"
        }
    ],
    toDOM: function toDOM() {
        return [
            "sub"
        ];
    }
};

var sup = {
    parseDOM: [
        {
            tag: "sup"
        }
    ],
    toDOM: function toDOM() {
        return [
            "sup"
        ];
    }
};

var citadelSchemaSpec = {
    nodes: {
        doc: citadel_schema_doc,
        text: citadel_schema_text,
        paragraph: citadel_schema_paragraph,
        heading: getHeading(),
        hard_break: hard_break,
        mention: mention,
        task_list: citadel_schema_task_list,
        task_item: citadel_schema_task_item,
        ordered_list: citadel_schema_ordered_list,
        bullet_list: citadel_schema_bullet_list,
        list_item: citadel_schema_list_item,
        link: citadel_schema_link,
        horizontal_rule: horizontal_rule,
        latex_inline: latex_inline,
        latex_block: latex_block,
        status: citadel_schema_status,
        image: citadel_schema_image,
        audio: audio,
        video: video,
        attachment: citadel_schema_attachment,
        code_block: code_block,
        collapse: citadel_schema_collapse,
        collapse_title: citadel_schema_collapse_title,
        collapse_content: citadel_schema_collapse_content,
        time: citadel_schema_time,
        catalog: citadel_schema_catalog,
        note: citadel_schema_note,
        note_title: citadel_schema_note_title,
        note_content: citadel_schema_note_content,
        blockquote: blockquote,
        spaceupdate: spaceupdate,
        page_tree: page_tree,
        table: citadel_schema_table,
        table_row: citadel_schema_table_row,
        table_cell: citadel_schema_table_cell,
        table_header: citadel_schema_table_header,
        markdown: markdown,
        html: citadel_schema_html,
        gantt: gantt,
        data2chart: data2chart,
        calendar: calendar,
        plantuml: plantuml,
        drawio: drawio,
        minder: minder
    },
    marks: {
        em: em,
        strong: strong,
        underline: underline,
        strikethrough: strikethrough,
        color: citadel_schema_color,
        sub: sub,
        sup: sup,
        font: citadel_schema_font
    }
};
var citadel_schema_index = new dist["Schema"](citadelSchemaSpec);

/* harmony default export */ var citadel_schema = (citadel_schema_index);

//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/prosemirror-transform/dist/index.js
var prosemirror_transform_dist = __webpack_require__("b923");

// EXTERNAL MODULE: ./node_modules/@it/parker/es/citadel/extensions/gap-cursor-extension/index.js
var gap_cursor_extension = __webpack_require__("573f");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/base-keymap-extension/index.js









var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : _typeof(value)) === type;
    };
};
var isString = isOfType("string");
var isPlainObject = function(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null){
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
};
var omit = function(target, omitKey) {
    var filterKey = isString(omitKey) ? [
        omitKey
    ] : omitKey;
    if (isPlainObject(target)) {
        return Object.keys(target).filter(function(key) {
            return !filterKey.includes(key);
        }).reduce(function(prev, cur) {
            prev[cur] = target[cur];
            return prev;
        }, Object.create(null));
    }
    return target.filter(function(p) {
        return !filterKey.includes(p);
    });
};

/**
 * TODO: 节点类型是支持gapcursor的，由于目前部分gapcursor定义存在问题，在不保证修改schema的情况下做一层胶水
 * 后续如果schema统一治理，需要将这段代码考虑优化
 */ var allowGapCursor = function(node) {
    if (!node) {
        return false;
    }
    var allow = node.type.spec.allowGapCursor;
    if (allow) {
        return true;
    }
    var textType = [
        "catalog"
    ];
    return textType.includes(node.type.name);
};

function base_keymap_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function base_keymap_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return base_keymap_extension_arrayLikeToArray(arr);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function base_keymap_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function base_keymap_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function base_keymap_extension_toConsumableArray(arr) {
    return base_keymap_extension_arrayWithoutHoles(arr) || base_keymap_extension_iterableToArray(arr) || base_keymap_extension_unsupportedIterableToArray(arr) || base_keymap_extension_nonIterableSpread();
}
function base_keymap_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return base_keymap_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return base_keymap_extension_arrayLikeToArray(o, minLen);
}
var defaultBlockAt = function(match) {
    for(var i = 0; i < match.edgeCount; i++){
        var type = match.edge(i).type;
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
};
var splitBlock = function(state, dispatch) {
    var selection = state.selection, schema = state.schema;
    var $from = selection.$from, $to = selection.$to, from = selection.from;
    var paragraph = schema.nodes.paragraph;
    if (_instanceof(state.selection, prosemirror_state_dist["NodeSelection"]) && state.selection.node.isBlock) {
        if (!$from.parentOffset || !Object(prosemirror_transform_dist["canSplit"])(state.doc, $from.pos)) return false;
        if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
        return true;
    }
    if (!$from.parent.isBlock) return false;
    if (dispatch) {
        var atStart = $to.parentOffset === 0;
        var atEnd = $to.parentOffset === $to.parent.content.size;
        var tr = state.tr;
        if (_instanceof(state.selection, prosemirror_state_dist["TextSelection"])) tr.deleteSelection();
        var parentNode = $from.node(-1);
        var deflt = $from.depth === 0 ? null : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
        var types = atEnd && deflt ? [
            {
                type: deflt
            }
        ] : null;
        var splitDepth = 1;
        if (deflt === schema.nodes.text) {
            if (!$from.nodeBefore || !$to.nodeAfter) {
                tr.insert(from, parentNode.type.createAndFill());
                tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, from + 2));
                tr.delete(from + 2, from + 4);
                dispatch(tr.scrollIntoView());
                return true;
            }
            splitDepth = 2;
        }
        var can = Object(prosemirror_transform_dist["canSplit"])(tr.doc, tr.mapping.map($from.pos), 1, types);
        if (!types && !can && Object(prosemirror_transform_dist["canSplit"])(tr.doc, tr.mapping.map($from.pos), splitDepth, deflt && [
            {
                type: deflt
            }
        ])) {
            types = [
                {
                    type: deflt
                }
            ];
            can = true;
        }
        if (can) {
            if (atStart) {
                tr.insert(tr.mapping.map($from.pos) - 1, paragraph.createAndFill());
            } else {
                tr.split(tr.mapping.map($from.pos), splitDepth, types || [
                    {
                        type: deflt,
                        attrs: {
                            dataDiffId: "ct-diff-id-".concat(esm_browser_v4())
                        }
                    }
                ]);
                if (!atEnd && !$from.parentOffset && $from.parent.type !== deflt && $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), dist["Fragment"].from([
                    deflt.create(),
                    $from.parent
                ]))) {
                    tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
        }
        dispatch(tr.scrollIntoView());
    }
    return true;
};
var createParagraphNear = function(state, dispatch) {
    var selection = state.selection;
    var $from = selection.$from, $to = selection.$to;
    if ($from.parent.inlineContent || $to.parent.inlineContent) {
        return false;
    }
    var type = defaultBlockAt($from.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) {
        return false;
    }
    if (dispatch) {
        // TODO: gapCursor situation
        var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        var tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
var splitBlockKeepMarks = function(baseKeyMapProvider) {
    return function(state, dispatch, view) {
        return splitBlock(state, dispatch && function(tr) {
            var marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) {
                if (baseKeyMapProvider) {
                    // 下面的处理是为了支持通过配置去除切分块级元素时不需要保留的Mark，例如划词评论的引用
                    var newMarks = base_keymap_extension_toConsumableArray(marks);
                    newMarks.forEach(function(mark, index) {
                        var _baseKeyMapProvider_excludeMarkNames, _baseKeyMapProvider_excludeMarkNames1;
                        if (baseKeyMapProvider.excludeMarkNames && ((_baseKeyMapProvider_excludeMarkNames = baseKeyMapProvider.excludeMarkNames) === null || _baseKeyMapProvider_excludeMarkNames === void 0 ? void 0 : _baseKeyMapProvider_excludeMarkNames.length) > 0 && ((_baseKeyMapProvider_excludeMarkNames1 = baseKeyMapProvider.excludeMarkNames) === null || _baseKeyMapProvider_excludeMarkNames1 === void 0 ? void 0 : _baseKeyMapProvider_excludeMarkNames1.indexOf(mark.type.name)) !== -1) {
                            newMarks.splice(index, 1);
                        }
                        tr.ensureMarks(newMarks);
                    });
                } else {
                    tr.ensureMarks(marks);
                }
            }
            dispatch(tr);
        });
    };
};
var overwriteEnterKeymap = function(baseKeyMapProvider) {
    return convertCommand(Object(dist_commands["chainCommands"])(dist_commands["newlineInCode"], createParagraphNear, dist_commands["liftEmptyBlock"], splitBlockKeepMarks(baseKeyMapProvider)));
};
var overwriteTabKeymap = convertCommand(function() {
    return true;
});
var overwriteShiftTabKeymap = convertCommand(function() {
    return true;
});
var overwriteShiftEnterKeymap = function(baseKeyMapProvider) {
    return convertCommand(function(state, dispatch, view) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var $from = selection.$from;
        var hard_break = schema.nodes.hard_break;
        // TODO: gapCursor situation
        if ($from && $from.parent.type.spec.textContentBlock && hard_break) {
            tr.insert($from.pos, hard_break.createAndFill());
            dispatch(tr);
            return true;
        }
        return overwriteEnterKeymap(baseKeyMapProvider)(state, dispatch, view);
    });
};
var deleteSelectedNode = function(state, dispatch, view) {
    var tr = state.tr, selection = state.selection;
    if (_instanceof(selection, prosemirror_state_dist["NodeSelection"])) {
        var node = selection.node;
        if (node.isInline) {
            tr.deleteSelection();
            var $pos = tr.doc.resolve(selection.from);
            var newSelection;
            if (gap_cursor_extension["a" /* GapCursor */].valid($pos)) {
                var type = gap_cursor_extension["a" /* GapCursor */].getType($pos);
                newSelection = new gap_cursor_extension["a" /* GapCursor */]($pos, type);
            } else {
                newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, $pos.pos);
            }
            // 内部会触发一次 setSelection，但它的结果不正确，我们不使用它
            tr.setSelection(newSelection);
        } else {
            tr.replaceSelectionWith(state.schema.nodes.paragraph.create());
            // 移动光标到新插入的段落节点内
            tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, selection.from + 1));
        }
        dispatch(tr.scrollIntoView());
        view.focus();
        return true;
    }
    if (!selection.empty) {
        return false;
    }
    var nodeBefore = selection.$from.nodeBefore;
    if (_instanceof(selection, gap_cursor_extension["a" /* GapCursor */])) {
        if (selection.gapCursorType === gap_cursor_extension["c" /* gapCursorSituation */].beforeInlineNode) {
            if (nodeBefore && nodeBefore.type.name === "text") {
                dispatch(tr.delete(tr.selection.from - 1, tr.selection.from).setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, tr.selection.from)));
                return true;
            }
        }
    }
    return false;
};
var selectNodeBefore = function(state, dispatch, view) {
    var selection = state.selection, tr = state.tr;
    if (!selection.empty) {
        return false;
    }
    var nodeBefore = selection.$from.nodeBefore;
    if (_instanceof(selection, gap_cursor_extension["a" /* GapCursor */])) {
        if (selection.gapCursorType === gap_cursor_extension["c" /* gapCursorSituation */].afterNode || selection.gapCursorType === gap_cursor_extension["c" /* gapCursorSituation */].afterInlineNode) {
            tr.setSelection(prosemirror_state_dist["NodeSelection"].create(tr.doc, tr.selection.from - nodeBefore.nodeSize));
            dispatch(tr);
            return true;
        }
    }
    return false;
};
// 找到一个行与第二行之间的断裂的$pos信息
function findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) {
        for(var i = $pos.depth - 1; i >= 0; i--){
            if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
            if ($pos.node(i).type.spec.isolating) break;
        }
    }
    return null;
}
// 当光标处于一个节点的首部时, (在backspace的情况下)如果可能，将光标转移至上一个
// 节点的尾部，这里区分gapCursor及TextSelection两种情况:
// 前方节点的schema中有allowGapCursor则放置gapCursor，gapCursor区分inline-node及node两种
// 前方是普通文本则直接将光标放到上一个文本节点的尾部
function setSelectionBackward(state, dispatch, view) {
    var _state_selection = state.selection, $head = _state_selection.$head, empty = _state_selection.empty;
    var $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) {
            // 向左移动如果不离开当前的textBlock节点
            return false;
        }
        $cut = findCutBefore($head);
    }
    var node = $cut && $cut.nodeBefore;
    if (!node || !prosemirror_state_dist["NodeSelection"].isSelectable(node)) {
        return false;
    }
    if (dispatch) {
        if (allowGapCursor(node)) {
            if (gap_cursor_extension["a" /* GapCursor */].valid($cut)) {
                var type = gap_cursor_extension["a" /* GapCursor */].getType($cut);
                if (type === gap_cursor_extension["c" /* gapCursorSituation */].afterInlineNode || type === gap_cursor_extension["c" /* gapCursorSituation */].afterNode) {
                    view.dispatch(view.state.tr.setSelection(new gap_cursor_extension["a" /* GapCursor */]($cut, type)));
                    return true;
                }
            }
        } else {
            view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["TextSelection"].create(view.state.tr.doc, $cut.pos - 1)));
            return true;
        }
    }
    return true;
}
// prosemirror-commands 1.1.7
function joinMaybeClear(state, $pos, dispatch) {
    var before = $pos.nodeBefore;
    var after = $pos.nodeAfter;
    var index = $pos.index();
    // 这里最好还是修改schema - https://km.sankuai.com/page/841048610
    if (!before || !after || !(before.type.compatibleContent(after.type) && ![
        "spaceupdate",
        "page_tree"
    ].includes(before.type.name))) {
        if (before.type.name === "blockquote" && after) {
            var tr = state.tr;
            tr.insert($pos.pos - 1, after);
            tr.delete(tr.mapping.map($pos.pos), tr.mapping.map($pos.pos) + after.nodeSize);
            tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, $pos.pos - 1));
            dispatch(tr);
            return true;
        }
        return false;
    }
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) {
            dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        }
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || Object(prosemirror_transform_dist["canJoin"])(state.doc, $pos.pos))) {
        return false;
    }
    if (dispatch) {
        var tr1 = state.tr;
        dispatch(tr1.clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount)).join($pos.pos).scrollIntoView().setSelection(prosemirror_state_dist["TextSelection"].near(tr1.doc.resolve($pos.pos - 1), -1)));
    }
    return true;
}
// prosemirror-commands 1.1.7
function deleteBarrier(state, $cut, dispatch) {
    var before = $cut.nodeBefore;
    var after = $cut.nodeAfter;
    if (before.type.spec.isolating || after.type.spec.isolating) return false;
    if (joinMaybeClear(state, $cut, dispatch)) {
        return true;
    }
    var selAfter = prosemirror_state_dist["Selection"].findFrom($cut, 1);
    var range = selAfter && selAfter.$from.blockRange(selAfter.$to);
    var target = range && Object(prosemirror_transform_dist["liftTarget"])(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    return false;
}
// 在 joinForward 时需要递归判断，如果下一行是表格，则光标出现在第一个单元格内
// 之前修复 ONES#10238531 时删除递归逻辑，现加上发现不会复现该 Bug
function textblockAt(node, side) {
    for(; node; node = side === "start" ? node.firstChild : node.lastChild){
        if (node.isTextblock) return true;
    }
    return false;
}
function joinBackward(state, dispatch, view) {
    var selection = state.selection;
    var $cursor = selection.$cursor, $from = selection.$from, gapCursorType = selection.gapCursorType;
    var $cut = null;
    if (gapCursorType === gap_cursor_extension["c" /* gapCursorSituation */].beforeInlineNode) {
        $cut = findCutBefore($from);
    } else {
        if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) {
            return false;
        }
        $cut = findCutBefore($cursor);
    }
    // If there is no node before this, try to lift
    if (!$cut) {
        // 解决 $cursor 不存在时的报错问题 #21134649
        if (!$cursor) {
            return false;
        }
        var range = $cursor.blockRange();
        var target = range && Object(prosemirror_transform_dist["liftTarget"])(range);
        if (target == null) {
            return false;
        }
        if (dispatch) {
            dispatch(state.tr.lift(range, target).scrollIntoView());
        }
        return true;
    }
    var before = $cut.nodeBefore;
    // Apply the joining algorithm
    if (!before.type.spec.isolating && (!allowGapCursor(before) || before.type.name === "blockquote") && deleteBarrier(state, $cut, dispatch)) {
        return true;
    }
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size === 0 && (textblockAt(before, "end") || prosemirror_state_dist["NodeSelection"].isSelectable(before))) {
        if (dispatch) {
            // 此处逻辑为包含 inline content 的时候才会执行选中节点操作
            // 在 schema 定义中目录树满足此条件，但是目录不满足，所以表现并不相同。
            // TODO: 考虑是否对所有 schema 的 content 属性进行清理
            if (textblockAt(before, "end") && !allowGapCursor(before)) {
                var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
                tr.setSelection(prosemirror_state_dist["Selection"].findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1));
                dispatch(tr.scrollIntoView());
                return true;
            }
            // 如果光标前面是 selectable 的节点，那么绘制 Gapcursor，并且处理删除当前空行，但是不对光标进行重新定位
            var tr1 = state.tr.deleteRange($cursor.before(), $cursor.after());
            if (allowGapCursor(before)) {
                var selectionType = gap_cursor_extension["a" /* GapCursor */].getType($cut);
                if (gap_cursor_extension["a" /* GapCursor */].valid($cut) && (selectionType === gap_cursor_extension["c" /* gapCursorSituation */].afterInlineNode || selectionType === gap_cursor_extension["c" /* gapCursorSituation */].afterNode)) {
                    tr1.setSelection(new gap_cursor_extension["a" /* GapCursor */](tr1.doc.resolve($cut.pos), selectionType === gap_cursor_extension["c" /* gapCursorSituation */].afterInlineNode ? undefined : selectionType));
                    dispatch(tr1.scrollIntoView());
                    return true;
                }
            }
        }
    }
    if (before.isAtom && $cut.depth === $cursor.depth - 1) {
        if (allowGapCursor(before)) {
            if (gap_cursor_extension["a" /* GapCursor */].valid($cut)) {
                var type = gap_cursor_extension["a" /* GapCursor */].getType($cut);
                if (type === gap_cursor_extension["c" /* gapCursorSituation */].afterInlineNode || type === gap_cursor_extension["c" /* gapCursorSituation */].afterNode) {
                    view.dispatch(view.state.tr.setSelection(new gap_cursor_extension["a" /* GapCursor */]($cut, type)));
                    return true;
                }
            }
        } else {
            // 非allowGapcursor本身又是atom的节点，直接选中，比如目录、最近更新
            view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["NodeSelection"].create(view.state.tr.doc, $cut.pos - before.nodeSize)));
            return true;
        }
        return true;
    }
    return false;
}
function findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) {
        for(var i = $pos.depth - 1; i >= 0; i--){
            var parent = $pos.node(i);
            if ($pos.index(i) + 1 < parent.childCount) {
                return $pos.doc.resolve($pos.after(i + 1));
            }
            if (parent.type.spec.isolating) break;
        }
    }
    return null;
}
// 如果在第一行空行按删除，则删除该行，光标在下一行的开头
function deleteEmptyLine(state, dispatch, view) {
    var $cursor = state.selection.$cursor;
    if ($cursor && $cursor.parent.isTextblock && $cursor.parent.childCount === 0 && // 该节点的前一个节点不能被删除
    !$cursor.parent.type.spec.disableDeleteBefore) {
        var $cut = findCutAfter($cursor);
        if (!$cut || !$cut.nodeAfter) return false;
        var after = $cut.nodeAfter;
        if (textblockAt(after, "start") || prosemirror_state_dist["NodeSelection"].isSelectable(after)) {
            var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
            tr.setSelection(textblockAt(after, "start") ? prosemirror_state_dist["Selection"].findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : prosemirror_state_dist["NodeSelection"].create(tr.doc, tr.mapping.map($cut.pos)));
            dispatch(tr.scrollIntoView());
            return true;
        }
    }
    return false;
}
var overwriteBackspace = convertCommand(Object(dist_commands["chainCommands"])(selectNodeBefore, deleteSelectedNode, dist_commands["deleteSelection"], joinBackward, setSelectionBackward, deleteEmptyLine));

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function base_keymap_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_keymap_extension_getPrototypeOf(o) {
    base_keymap_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return base_keymap_extension_getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function base_keymap_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_keymap_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = base_keymap_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = base_keymap_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var base_keymap_extension_BaseKeyMapExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(BaseKeyMapExtension, CommonExtension);
    var _super = _createSuper(BaseKeyMapExtension);
    function BaseKeyMapExtension() {
        _classCallCheck(this, BaseKeyMapExtension);
        return _super.apply(this, arguments);
    }
    var _proto = BaseKeyMapExtension.prototype;
    _proto.keys = function keys(param) {
        var providers = param.providers;
        var baseKeyMapProvider = providers.get(this.name);
        var overwriteRules = {
            Enter: overwriteEnterKeymap(baseKeyMapProvider),
            "Shift-Enter": overwriteShiftEnterKeymap(baseKeyMapProvider),
            Backspace: overwriteBackspace,
            "Shift-Backspace": overwriteBackspace,
            Tab: overwriteTabKeymap,
            "Shift-Tab": overwriteShiftTabKeymap
        };
        var mappedKeys = base_keymap_extension_objectSpread({}, Object.entries(omit(dist_commands["baseKeymap"], "Enter")).reduce(function(prev, param) {
            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
            prev[key] = convertCommand(value);
            return prev;
        }, {}), overwriteRules);
        return mappedKeys;
    };
    _createClass(BaseKeyMapExtension, [
        {
            key: "name",
            get: function get() {
                return "base_key_map";
            }
        }
    ]);
    return BaseKeyMapExtension;
}(core["a" /* CommonExtension */]);

function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function base_keymap_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function base_keymap_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_keymap_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf$1(object);
        if (object === null) break;
    }
    return object;
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var BaseKeyMapPCExtension = /*#__PURE__*/ function(BaseKeyMapExtension) {
    _inherits$1(BaseKeyMapPCExtension, BaseKeyMapExtension);
    var _super = _createSuper$1(BaseKeyMapPCExtension);
    function BaseKeyMapPCExtension() {
        _classCallCheck$1(this, BaseKeyMapPCExtension);
        return _super.apply(this, arguments);
    }
    var _proto = BaseKeyMapPCExtension.prototype;
    _proto.keys = function keys(props) {
        return base_keymap_extension_objectSpread$1({}, _get(_getPrototypeOf$1(BaseKeyMapPCExtension.prototype), "keys", this).call(this, props));
    };
    return BaseKeyMapPCExtension;
}(base_keymap_extension_BaseKeyMapExtension);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/clear-extension/index.js






function clear_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clear_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clear_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var clearMark = function(provider) {
    return function() {
        return function(state, dispatch) {
            var selection = state.selection, schema = state.schema, tr = state.tr;
            var $cursor = selection.$cursor;
            var _schema_nodes = schema.nodes, paragraph = _schema_nodes.paragraph, heading = _schema_nodes.heading, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item;
            var marks = schema.marks;
            var excludeMarks = (provider === null || provider === void 0 ? void 0 : provider.excludeMarkNames) || [];
            // 清除光标左右两边的格式
            if ($cursor) {
                var cursor = $cursor.pos;
                var beforeNode = $cursor.nodeBefore;
                var afterNode = $cursor.nodeAfter;
                if (beforeNode) {
                    Object.keys(marks).forEach(function(mark) {
                        if (excludeMarks.indexOf(mark) !== -1) return;
                        tr.removeMark(cursor - beforeNode.nodeSize, cursor, marks[mark]);
                    });
                }
                if (afterNode) {
                    Object.keys(marks).forEach(function(mark) {
                        if (excludeMarks.indexOf(mark) !== -1) return;
                        tr.removeMark(cursor, cursor + afterNode.nodeSize, marks[mark]);
                    });
                }
            }
            // 处于 CellSelection 时可能有多个 range
            selection.ranges.forEach(function(range) {
                var from = range.$from.pos;
                var to = range.$to.pos;
                tr.doc.nodesBetween(from, to, function(node, pos, parent) {
                    if (node.type === heading) {
                        tr.setNodeMarkup(pos, paragraph, node.attrs);
                        // -1 表示当前文本（p）元素的父元素也就是list_item（task_item）元素。
                        if ((parent.type === list_item || parent.type === task_item) && tr.doc.nodeAt(pos - 1)) {
                            tr.setNodeMarkup(pos - 1, null, _objectSpreadProps(clear_extension_objectSpread({}, parent.attrs), {
                                level: null
                            }));
                        }
                    }
                });
                tr.setBlockType(from, to, schema.nodes.paragraph);
                Object.keys(marks).forEach(function(mark) {
                    if (excludeMarks.indexOf(mark) !== -1) return;
                    tr.removeMark(from, to, marks[mark]);
                });
            });
            dispatch(tr);
            return true;
        };
    };
};

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

/**
 * 通用配置
 */ var pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var isCommonDisabled = function() {
    return function(state) {
        return !canInsertTypes(state);
    };
};

function clear_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function clear_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function clear_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function clear_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) clear_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) clear_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function clear_extension_getPrototypeOf(o) {
    clear_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return clear_extension_getPrototypeOf(o);
}
function clear_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) clear_extension_setPrototypeOf(subClass, superClass);
}
function clear_extension_possibleConstructorReturn(self, call) {
    if (call && (clear_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return clear_extension_assertThisInitialized(self);
}
function clear_extension_setPrototypeOf(o, p) {
    clear_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return clear_extension_setPrototypeOf(o, p);
}
var clear_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function clear_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function clear_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = clear_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = clear_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = clear_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return clear_extension_possibleConstructorReturn(this, result);
    };
}
var ClearExtension = /*#__PURE__*/ function(CommonExtension) {
    clear_extension_inherits(ClearExtension, CommonExtension);
    var _super = clear_extension_createSuper(ClearExtension);
    function ClearExtension() {
        clear_extension_classCallCheck(this, ClearExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ClearExtension.prototype;
    _proto.commands = function commands(param) {
        var providers = param.providers;
        var clearProvider = providers.get(this.name);
        return {
            clearMark: clearMark(clearProvider),
            isDisabled: isCommonDisabled
        };
    };
    clear_extension_createClass(ClearExtension, [
        {
            key: "name",
            get: function get() {
                return "clear";
            }
        }
    ]);
    return ClearExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__("84a2");
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: ./node_modules/prosemirror-view/dist/index.es.js
var index_es = __webpack_require__("576a");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("ab5b");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__("8bc8");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/drop-cursor-extension/index.js












var AFTER_INSERT = "after_insert";

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
// 获取浏览器和系统信息
function getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

/**
 * 是否为表格内的位置
 * @param $pos ResolvedPos
 * @returns boolean
 */ var isInTablePos = function($pos) {
    for(var d = $pos.depth; d > 0; d--){
        // 有 tableRole 属性的就是表格的 schema
        if ($pos.node(d).type.spec.tableRole) return true;
    }
    return false;
};
/**
 * 获取在表格中的真正可插入的节点的位置
 * @param $pos ResolvedPos
 * @returns number
 */ var getInsertPosInTable = function($pos) {
    // 不是表格内的 pos 不处理
    if (!isInTablePos($pos)) return null;
    var selectionRight = prosemirror_state_dist["Selection"].near($pos, 1);
    var selectionLeft = prosemirror_state_dist["Selection"].near($pos, -1);
    // 左右可用选区都没有
    if (!selectionRight && !selectionLeft) return null;
    var insertPos = $pos.pos;
    // 只有一边有选区, 那么就用一边的选区的位置
    if (selectionRight && !selectionLeft) {
        insertPos = selectionRight.from;
    } else if (!selectionRight && selectionLeft) {
        insertPos = selectionLeft.from;
    } else {
        // 选取左右最近的能插入的位置, 右侧优先
        insertPos = $pos.pos - selectionLeft.from < selectionRight.from - $pos.pos ? selectionLeft.from : selectionRight.from;
    }
    return insertPos;
};

var DRAG_BUTTON_SCHEMA_PROPS_NAME = "dragBlock";

var hasButton = function(node) {
    return node && node.type.schema.nodes[node.type.name].spec[DRAG_BUTTON_SCHEMA_PROPS_NAME];
};
var getSelection = function(doc, from, to) {
    return prosemirror_state_dist["NodeSelection"].create(doc, from);
};

var TABLE_SELECTOR = ".".concat(classNamePrefix("table-wrapper"));
/**
 * 递归查找所有父级表格元素
 */ var findAllTables = function(dom) {
    var result = [];
    var closestTable = dom === null || dom === void 0 ? void 0 : dom.closest(TABLE_SELECTOR);
    var count = 0;
    while(closestTable && count < 10){
        result.push(closestTable);
        closestTable = closestTable.parentNode.closest(TABLE_SELECTOR);
        count += 1;
    }
    return result;
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-drag-button{z-index:50;position:absolute;text-align:center;line-height:28px;cursor:-webkit-grab;width:30px;height:30px;background:url("data:image/svg+xml,%3Csvg width%3D%228px%22 height%3D%2216px%22 viewBox%3D%220 0 8 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E   %3C!-- Generator%3A Sketch 50 (54983) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E   %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E   %3Cdefs%3E%3C%2Fdefs%3E   %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E       %3Cg id%3D%2210%E3%80%81%E7%BC%96%E8%BE%91%E9%A1%B5-%E6%8F%92%E5%85%A5%E4%BB%A3%E7%A0%81%EF%BC%881024%EF%BC%89%22 transform%3D%22translate(-42.000000%2C -789.000000)%22 fill%3D%22%23B0B0B0%22 fill-rule%3D%22nonzero%22%3E           %3Cg id%3D%22%E7%BC%96%E8%BE%91%E5%8C%BA%22 transform%3D%22translate(0.000000%2C 56.000000)%22%3E               %3Cg id%3D%22Group-9-Copy%22 transform%3D%22translate(34.000000%2C 732.000000)%22%3E                   %3Cg id%3D%22%E6%8B%96%E6%8B%BD%E6%89%8B%E6%9F%84%22 transform%3D%22translate(4.000000%2C 1.000000)%22%3E                       %3Cpath d%3D%22M10.5%2C1.90664419e-16 C11.3284347%2C0 12%2C0.671538462 12%2C1.5 C12%2C2.3284347 11.3284615%2C3 10.5%2C3 C9.6715653%2C3 9%2C2.3284347 9%2C1.5 C9%2C0.671565295 9.67153846%2C1.90664419e-16 10.5%2C1.90664419e-16 Z M10.5%2C6.5 C11.3284347%2C6.5 12%2C7.17153846 12%2C8 C12%2C8.8284347 11.3284615%2C9.5 10.5%2C9.5 C9.6715653%2C9.5 9%2C8.8284347 9%2C8 C9%2C7.1715653 9.67153846%2C6.5 10.5%2C6.5 Z M9%2C14.5 C9%2C13.6715653 9.67153846%2C13 10.5%2C13 C11.3284347%2C13 12%2C13.6715385 12%2C14.5 C12%2C15.3284347 11.3284615%2C16 10.5%2C16 C9.6715653%2C16 9%2C15.3284615 9%2C14.5 Z M5.5%2C1.90664419e-16 C6.3284347%2C0 7%2C0.671538462 7%2C1.5 C7%2C2.3284347 6.32846154%2C3 5.5%2C3 C4.6715653%2C3 4%2C2.32846154 4%2C1.5 C4%2C0.671565295 4.67153846%2C1.90664419e-16 5.5%2C1.90664419e-16 Z M5.5%2C6.5 C6.3284347%2C6.5 7%2C7.17153846 7%2C8 C7%2C8.8284347 6.32846154%2C9.5 5.5%2C9.5 C4.6715653%2C9.5 4%2C8.8284347 4%2C8 C4%2C7.1715653 4.67153846%2C6.5 5.5%2C6.5 Z M5.5%2C13 C5.5%2C13 4.6715653%2C13 5.5%2C13 C6.3284347%2C13 7%2C13.6715385 7%2C14.5 C7%2C15.3284347 6.32846154%2C16 5.5%2C16 C4.6715653%2C16 4%2C15.3284615 4%2C14.5 C4%2C13.6715653 4.67153846%2C13 5.5%2C13 Z%22 id%3D%22%E5%8F%AF%E6%8B%96%E6%8B%BD%22%3E%3C%2Fpath%3E                   %3C%2Fg%3E               %3C%2Fg%3E           %3C%2Fg%3E       %3C%2Fg%3E   %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}';
styleInject(css_248z);

function drop_cursor_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function drop_cursor_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function drop_cursor_extension_getPrototypeOf(o) {
    drop_cursor_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return drop_cursor_extension_getPrototypeOf(o);
}
function drop_cursor_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) drop_cursor_extension_setPrototypeOf(subClass, superClass);
}
function drop_cursor_extension_possibleConstructorReturn(self, call) {
    if (call && (drop_cursor_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return drop_cursor_extension_assertThisInitialized(self);
}
function drop_cursor_extension_setPrototypeOf(o, p) {
    drop_cursor_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return drop_cursor_extension_setPrototypeOf(o, p);
}
var drop_cursor_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function drop_cursor_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function drop_cursor_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = drop_cursor_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = drop_cursor_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = drop_cursor_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return drop_cursor_extension_possibleConstructorReturn(this, result);
    };
}
var BUTTON_WIDTH = 30;
var drop_cursor_extension_Button = /*#__PURE__*/ function(Component) {
    drop_cursor_extension_inherits(Button, Component);
    var _super = drop_cursor_extension_createSuper(Button);
    function Button(props) {
        drop_cursor_extension_classCallCheck(this, Button);
        var _this;
        _this = _super.call(this, props);
        _this.tables = [];
        _this.handleScroll = function() {
            var getPosition = _this.props.getPosition;
            _this.setState(getPosition());
        };
        var getPosition = _this.props.getPosition;
        _this.state = getPosition();
        return _this;
    }
    var _proto = Button.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var dom = this.props.dom;
        this.tables = findAllTables(dom);
        this.tables.forEach(function(table) {
            table.addEventListener("scroll", _this.handleScroll);
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this = this;
        this.tables.forEach(function(table) {
            table.removeEventListener("scroll", _this.handleScroll);
        });
    };
    _proto.render = function render() {
        var _this_props = this.props, getPosition = _this_props.getPosition, onDragStart = _this_props.onDragStart, onClick = _this_props.onClick;
        var _getPosition = getPosition(), left = _getPosition.left, top = _getPosition.top;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: classNamePrefix("drag-button"),
            draggable: true,
            style: {
                left: left - BUTTON_WIDTH,
                top: top
            },
            onDragStart: onDragStart,
            onClick: onClick
        });
    };
    return Button;
}(react["Component"]);

function drop_cursor_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function drop_cursor_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function drop_cursor_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) drop_cursor_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) drop_cursor_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function drop_cursor_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var os = getSystemInfo().os;
var dragCopyModifier = /MAC/.test(os.toUpperCase()) ? "altKey" : "ctrlKey";
var drop_cursor_extension_DragButtonView = /*#__PURE__*/ function() {
    function DragButtonView(editorView) {
        var _this = this;
        drop_cursor_extension_classCallCheck$1(this, DragButtonView);
        this.$popover = null;
        this.editorView = null;
        this.destroy = function() {
            _this.container && _this.container.remove();
        };
        this.update = function(editorView) {
            var selection = editorView.state.selection;
            if (drop_cursor_extension_instanceof(selection, prosemirror_state_dist["NodeSelection"])) {
                if (hasButton(selection.node)) {
                    _this.showButton(editorView, selection);
                    return;
                }
            }
            var isTextSel = drop_cursor_extension_instanceof(selection, prosemirror_state_dist["TextSelection"]);
            var isGapCursor = drop_cursor_extension_instanceof(selection, gap_cursor_extension["a" /* GapCursor */]);
            if (isTextSel || isGapCursor) {
                var resolvedPos = selection.$from;
                var nodeMaybe = isGapCursor ? resolvedPos.parent : resolvedPos.doc.nodeAt(selection.from);
                if (nodeMaybe && hasButton(nodeMaybe)) {
                    var container = prosemirror_state_dist["NodeSelection"].create(resolvedPos.doc, selection.from);
                    _this.showButton(editorView, container);
                    return;
                }
                for(var d = resolvedPos.depth; d >= 0; d--){
                    if (hasButton(resolvedPos.node(d))) {
                        var container1 = prosemirror_state_dist["NodeSelection"].create(resolvedPos.doc, resolvedPos.before(d));
                        _this.showButton(editorView, container1);
                        return;
                    }
                }
            }
            _this.hideButton();
        };
        this.handleDragStart = function(editorView, from, to) {
            return function(event) {
                var dispatch = editorView.dispatch, state = editorView.state;
                var dragDOM = editorView.nodeDOM(from);
                var selection = getSelection(state.doc, from);
                var slice = selection.content();
                event.dataTransfer.setDragImage(dragDOM, 0, 0);
                editorView.dragging = {
                    slice: slice,
                    move: !event[dragCopyModifier],
                    from: from,
                    to: to
                };
                dispatch(state.tr.setSelection(selection));
            };
        };
        this.handleClick = function(editorView, from, to) {
            return function() {
                var dispatch = editorView.dispatch, state = editorView.state;
                var selection = getSelection(state.doc, from);
                dispatch(state.tr.setSelection(selection));
                editorView.focus();
            };
        };
        this.editorView = editorView;
    }
    var _proto = DragButtonView.prototype;
    _proto.hideButton = function hideButton() {
        this.container && Object(react_dom["render"])(null, this.container);
    };
    _proto.showButton = function showButton(editorView, selection) {
        var _this = this;
        var from = selection.from, to = selection.to;
        var dom = editorView.nodeDOM(from);
        var buttonProps = {
            onDragStart: this.handleDragStart(editorView, from, to),
            onClick: this.handleClick(editorView, from, to),
            dom: dom,
            getPosition: function() {
                var nodeDOM = editorView.nodeDOM(from);
                var _this_$editor_getBoundingClientRect = _this.$editor.getBoundingClientRect(), pl = _this_$editor_getBoundingClientRect.left, pt = _this_$editor_getBoundingClientRect.top;
                if (!nodeDOM) {
                    return {
                        left: pl,
                        top: pt
                    };
                }
                var _nodeDOM_getBoundingClientRect = nodeDOM.getBoundingClientRect(), cl = _nodeDOM_getBoundingClientRect.left, ct = _nodeDOM_getBoundingClientRect.top;
                return {
                    left: cl - pl,
                    top: ct - pt
                };
            }
        };
        Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(drop_cursor_extension_Button, _extends({}, buttonProps)), this.container);
    };
    drop_cursor_extension_createClass(DragButtonView, [
        {
            key: "container",
            get: function get() {
                if (!this.$popover) {
                    this.$popover = document.createElement("div");
                    this.$popover.classList.add(classNamePrefix("drag-button-popover"));
                    this.$editor = this.editorView.dom.parentElement;
                    this.$editor.appendChild(this.$popover);
                }
                return this.$popover;
            }
        }
    ]);
    return DragButtonView;
}();

var css_248z$1 = '.ProseMirror-dropcursor-bottom{position:relative}.ProseMirror-dropcursor-bottom:after{background-color:#1c6cdc;bottom:-4px;content:"";height:3px;left:0;position:absolute;right:0;z-index:10}.ProseMirror-dropcursor-top{position:relative}.ProseMirror-dropcursor-top:after{background-color:#1c6cdc;content:"";height:2px;left:0;position:absolute;right:0;top:2px;z-index:10}';
styleInject(css_248z$1);

function drop_cursor_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function drop_cursor_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return drop_cursor_extension_arrayLikeToArray(arr);
}
function drop_cursor_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function drop_cursor_extension_getPrototypeOf$1(o) {
    drop_cursor_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return drop_cursor_extension_getPrototypeOf$1(o);
}
function drop_cursor_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) drop_cursor_extension_setPrototypeOf$1(subClass, superClass);
}
function drop_cursor_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function drop_cursor_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function drop_cursor_extension_possibleConstructorReturn$1(self, call) {
    if (call && (drop_cursor_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return drop_cursor_extension_assertThisInitialized$1(self);
}
function drop_cursor_extension_setPrototypeOf$1(o, p) {
    drop_cursor_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return drop_cursor_extension_setPrototypeOf$1(o, p);
}
function drop_cursor_extension_toConsumableArray(arr) {
    return drop_cursor_extension_arrayWithoutHoles(arr) || drop_cursor_extension_iterableToArray(arr) || drop_cursor_extension_unsupportedIterableToArray(arr) || drop_cursor_extension_nonIterableSpread();
}
var drop_cursor_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function drop_cursor_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return drop_cursor_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return drop_cursor_extension_arrayLikeToArray(o, minLen);
}
function drop_cursor_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function drop_cursor_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = drop_cursor_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = drop_cursor_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = drop_cursor_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return drop_cursor_extension_possibleConstructorReturn$1(this, result);
    };
}
var gecko = typeof navigator !== "undefined" && /gecko\/\d/i.test(navigator.userAgent);
var linux = typeof navigator !== "undefined" && /linux/i.test(navigator.platform);
function drop_cursor_extension_style(options, side) {
    if (side === "bottom" || side === "top") {
        return "border-".concat(side, ": 2px solid #3789a9; margin-").concat(side, ": 2px");
    }
    var width = options && options.width || 1;
    var color = options && options.color || "black";
    return "border-".concat(side, ": ").concat(width, "px solid ").concat(color, "; margin-").concat(side, ": -").concat(width, "px");
}
/**
 * 根据当前拖动的位置插入占位元素
 */ function pluginStateFor(state, pos, options) {
    var $pos = state.doc.resolve(pos);
    var deco;
    if (!$pos.parent.inlineContent) {
        var before = $pos.nodeBefore;
        var after = $pos.nodeAfter;
        if (before) {
            if (before.type.name === "table_row" || before.type.name === "table") {
                // 表格中在单元格外部不支持拖入
                return null;
            }
            // 在前一个节点的底部插入占位符
            deco = index_es["a" /* Decoration */].node(pos - before.nodeSize, pos, {
                nodeName: "div",
                class: "ProseMirror-dropcursor-bottom"
            });
        } else if (after) {
            // 表格中在单元格外部不支持拖入
            if (after.type.name === "table_row") {
                return null;
            }
            // 在后一个节点的顶部插入占位符
            deco = index_es["a" /* Decoration */].node(pos, pos + after.nodeSize, {
                nodeName: "div",
                class: "ProseMirror-dropcursor-top"
            });
        }
    }
    if (!deco) {
        var node = document.createElement("span");
        node.textContent = "​";
        node.style.cssText = "".concat(drop_cursor_extension_style(options, "left"), "; display: inline-block; pointer-events: none");
        deco = index_es["a" /* Decoration */].widget(pos, node);
    }
    deco = index_es["b" /* DecorationSet */].create(state.doc, [
        deco
    ]);
    return {
        pos: pos,
        deco: deco
    };
}
/**
 * 计算当前拖动的位置
 */ function drop_cursor_extension_dropPos(slice, $pos) {
    // 表格中拖拽的位置是自定义的
    var insertPosInTable = getInsertPosInTable($pos);
    if (insertPosInTable !== null) return insertPosInTable;
    if (!slice || !slice.content.size) return $pos.pos;
    var content = slice.content;
    for(var i = 0; i < slice.openStart; i++){
        content = content.firstChild.content;
    }
    for(var d = $pos.depth; d >= 0; d--){
        // 判断当前位置相对于当前的节点是偏前还是偏后
        var bias = // eslint-disable-next-line no-nested-ternary
        d === $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        // 判断是否允许在拖动的位置插入元素
        if ($pos.node(d).canReplace(insertPos, insertPos, content)) {
            // eslint-disable-next-line no-nested-ternary
            return bias === 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
    }
    return $pos.pos;
}
var drop_cursor_extension_DropCursorExtension = /*#__PURE__*/ function(CommonExtension) {
    drop_cursor_extension_inherits$1(DropCursorExtension, CommonExtension);
    var _super = drop_cursor_extension_createSuper$1(DropCursorExtension);
    function DropCursorExtension() {
        _classCallCheck$2(this, DropCursorExtension);
        return _super.apply(this, arguments);
    }
    var _proto = DropCursorExtension.prototype;
    _proto.plugin = function plugin(param) {
        var editorEventEmitter = param.editorEventEmitter;
        var _this = this;
        var dispatchMeta = function dispatchMeta(view, data) {
            view.dispatch(view.state.tr.setMeta(dcPlugin, data));
        };
        var scheduleRemoval = function scheduleRemoval(view) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                if (dcPlugin.getState(view.state)) {
                    dispatchMeta(view, {
                        type: "remove"
                    });
                }
            }, 1000);
        };
        var timeout = null;
        var dcPlugin = null;
        var onDragOver = lodash_throttle_default()(function(view, event) {
            var active = dcPlugin.getState(view.state);
            // 获取当前拖动到文档中的位置
            var pos = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (pos) {
                var target = pos.pos;
                if (view.dragging) {
                    target = drop_cursor_extension_dropPos(view.dragging.slice, view.state.doc.resolve(target));
                }
                if (!active || active.pos !== target) {
                    dispatchMeta(view, {
                        type: "set",
                        pos: target
                    });
                }
            }
            scheduleRemoval(view);
            return false;
        }, 50);
        dcPlugin = new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"](this.name),
            state: {
                init: function init() {
                    return null;
                },
                apply: function(tr, prev, state) {
                    // Firefox on Linux gets really confused an breaks dragging when we
                    // mess with the nodes around the target node during a drag. So
                    // disable this plugin there. See https://bugzilla.mozilla.org/show_bug.cgi?id=1323170
                    if (gecko && linux) return null;
                    // eslint-disable-next-line react/destructuring-assignment
                    var command = tr.getMeta(dcPlugin);
                    if (!command) return prev;
                    if (command.type === "set") {
                        return pluginStateFor(state, command.pos, _this.options);
                    }
                    return null;
                }
            },
            props: {
                handleDOMEvents: {
                    dragover: function dragover(view, event) {
                        return onDragOver(view, event);
                    },
                    dragend: function dragend(view) {
                        // 如果当前 view 存在占位元素，则删除
                        if (dcPlugin.getState(view.state)) {
                            dispatchMeta(view, {
                                type: "remove"
                            });
                        }
                        return false;
                    },
                    drop: function drop(view, e) {
                        var _ref;
                        // 如果当前 view 存在占位元素，则删除
                        if (dcPlugin.getState(view.state)) {
                            dispatchMeta(view, {
                                type: "remove"
                            });
                        }
                        // 特殊处理表格的拖拽，参考自 pm-view 源码 editHandlers.drop 部分
                        if (((_ref = view === null || view === void 0 ? void 0 : view.dragging) === null || _ref === void 0 ? void 0 : _ref.tableSelection) !== undefined) {
                            var state = view.state;
                            var tr = state.tr, doc = state.doc;
                            var $pos = state.selection.$anchor;
                            var deleteTable = false;
                            for(var d = $pos.depth; d > 0; d--){
                                var node = $pos.node(d);
                                if (node.type.spec.tableRole === "table") {
                                    tr.delete($pos.before(d), $pos.after(d));
                                    deleteTable = true;
                                    break;
                                }
                            }
                            if (deleteTable) {
                                var slice = (view === null || view === void 0 ? void 0 : view.dragging) && (view === null || view === void 0 ? void 0 : view.dragging.slice);
                                var eventPos = view.posAtCoords({
                                    left: e.clientX,
                                    top: e.clientY
                                });
                                if (!eventPos || !slice) return true;
                                var $mouse = doc.resolve(eventPos.pos);
                                if (!$mouse) return true;
                                var pos = tr.mapping.map(Object(prosemirror_transform_dist["dropPoint"])(doc, $mouse.pos, slice));
                                tr.replaceRangeWith(pos, pos, slice.content.firstChild);
                                tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(pos)));
                                view.dispatch(tr.scrollIntoView());
                            }
                            return true;
                        }
                        if (view.dragging && view.dragging.from !== undefined) {
                            view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["NodeSelection"].create(view.state.doc, view.dragging.from)));
                        }
                        return false;
                    },
                    dragleave: function dragleave(view, event) {
                        // 如果当前 view 存在占位元素，则删除
                        if (event.target === view.dom) {
                            dispatchMeta(view, {
                                type: "remove"
                            });
                        }
                        return false;
                    }
                },
                handleDrop: function(view, event, slice) {
                    var _event_target;
                    var isInTable = !!((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.closest("table"));
                    if (isInTable) {
                        var _Math;
                        var shouldBrace = [];
                        slice.content.descendants(function(node) {
                            if (typeof node.type.spec.braceWidth === "number") {
                                shouldBrace.push(node.type.spec.braceWidth);
                            }
                        });
                        var braceWidth = (_Math = Math).max.apply(_Math, drop_cursor_extension_toConsumableArray(shouldBrace));
                        if (braceWidth > 0) {
                            setTimeout(function() {
                                // 等到插入完成后下个事件迭代进行表格的扩展
                                editorEventEmitter.emit(AFTER_INSERT, {
                                    braceWidth: braceWidth
                                });
                            });
                        }
                    }
                    return false;
                },
                decorations: function decorations(state) {
                    var active = dcPlugin.getState(state);
                    return active && active.deco;
                }
            },
            view: function(view) {
                return new drop_cursor_extension_DragButtonView(view);
            }
        });
        return dcPlugin;
    };
    _createClass$1(DropCursorExtension, [
        {
            key: "name",
            get: function get() {
                return "drop_cursor";
            }
        }
    ]);
    return DropCursorExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/prosemirror-keymap/dist/index.js + 1 modules
var prosemirror_keymap_dist = __webpack_require__("e3da");

// EXTERNAL MODULE: ./node_modules/@it/parker/es/citadel/kit/GapcursorSelection/index.js
var GapcursorSelection = __webpack_require__("7378");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/gap-cursor-extension/index.js









// 获取浏览器和系统信息
function gap_cursor_extension_getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

var gap_cursor_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(gap_cursor_extension_ExtensionType || (gap_cursor_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var gap_cursor_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(Keycodes || (Keycodes = {}));

function gap_cursor_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function gap_cursor_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function gap_cursor_extension_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        gap_cursor_extension_get = Reflect.get;
    } else {
        gap_cursor_extension_get = function _get(target, property, receiver) {
            var base = gap_cursor_extension_superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return gap_cursor_extension_get(target, property, receiver || target);
}
function gap_cursor_extension_getPrototypeOf(o) {
    gap_cursor_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return gap_cursor_extension_getPrototypeOf(o);
}
function gap_cursor_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) gap_cursor_extension_setPrototypeOf(subClass, superClass);
}
function gap_cursor_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function gap_cursor_extension_possibleConstructorReturn(self, call) {
    if (call && (gap_cursor_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return gap_cursor_extension_assertThisInitialized(self);
}
function gap_cursor_extension_setPrototypeOf(o, p) {
    gap_cursor_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return gap_cursor_extension_setPrototypeOf(o, p);
}
function gap_cursor_extension_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = gap_cursor_extension_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var gap_cursor_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function gap_cursor_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function gap_cursor_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = gap_cursor_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = gap_cursor_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = gap_cursor_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return gap_cursor_extension_possibleConstructorReturn(this, result);
    };
}
var pluginKey$1 = new prosemirror_state_dist["PluginKey"]("gap_cursor_pc");
// 指定pos的节点是否显示
var nodeIsDisplay = function(view, pos) {
    var node = view.domAtPos(pos).node;
    for(var dom = node; dom && dom !== view.dom; dom = dom.parentElement){
        if (dom.nodeType === 1 && window.getComputedStyle(dom).display === "none") {
            return false;
        }
    }
    return true;
};
var isInlineGapcursor = function(selection) {
    return gap_cursor_extension_instanceof(selection, GapcursorSelection["a" /* GapCursor */]) && (selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterInlineNode || selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeInlineNode);
};
var checkClosedAfter = function(dir, $pos, selection) {
    if (Object(GapcursorSelection["b" /* closedAfter */])($pos, true)) {
        var type = GapcursorSelection["a" /* GapCursor */].getType($pos, 1);
        var gapcursor = new GapcursorSelection["a" /* GapCursor */]($pos, type);
        if (!gapcursor.eq(selection)) {
            return type;
        }
        if (dir > 0 && selection.gapCursorType !== gapcursor.gapCursorType && !(isInlineGapcursor(gapcursor) && isInlineGapcursor(selection))) {
            return type;
        }
    }
    return null;
};
var checkClosedBefore = function(dir, $pos, selection) {
    if (Object(GapcursorSelection["c" /* closedBefore */])($pos, true)) {
        var type = GapcursorSelection["a" /* GapCursor */].getType($pos, -1);
        var gapcursor = new GapcursorSelection["a" /* GapCursor */]($pos, type);
        if (!gapcursor.eq(selection)) {
            return type;
        }
        if (dir < 0 && selection.gapCursorType !== gapcursor.gapCursorType && !(isInlineGapcursor(gapcursor) && isInlineGapcursor(selection))) {
            return type;
        }
    }
    return null;
};
var _map_find;
var gapcursorEnableCheck = function(dir, $pos, selection, firstCheckAfter) {
    return (_map_find = (firstCheckAfter ? [
        checkClosedAfter,
        checkClosedBefore
    ] : [
        checkClosedBefore,
        checkClosedAfter
    ]).map(function(_) {
        return _(dir, $pos, selection);
    }).find(function(_) {
        return _;
    })) !== null && _map_find !== void 0 ? _map_find : null;
};
var moveFactory = function(state, dispatch, view, $side, dir) {
    return function(origin) {
        var gapcursorBias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, firstGapcursorCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var selection = state.selection, doc = state.doc;
        var whoHasNodeViews = new Set();
        view.someProp("nodeViews", function(_) {
            var nodeViewKeys = Object.keys(_);
            nodeViewKeys.forEach(function(__) {
                return whoHasNodeViews.add(__);
            });
            return false;
        });
        if ($side) {
            var moveTo = $side.pos + origin;
            var nextSel = prosemirror_state_dist["Selection"].near(state.doc.resolve(moveTo), dir);
            // 由于Selection.near会移动到已经设置为display: node的元素中（例如没有标题的样式宏）,所以需要继续寻找知道找到不是display: node的元素
            while(!nodeIsDisplay(view, nextSel.$from.pos)){
                var from = nextSel.from;
                nextSel = prosemirror_state_dist["Selection"].near(state.doc.resolve(from + origin), dir);
                if (nextSel.from === from) break;
            }
            if (nextSel) {
                var _loop = function() {
                    if (i < 0 || i >= doc.nodeSize - 1) return "break";
                    var $i = doc.resolve(i);
                    var gapcursorCheck = function() {
                        var situation = gapcursorEnableCheck(dir, $i, selection, dir * gapcursorBias > 0);
                        if (situation) {
                            return new GapcursorSelection["a" /* GapCursor */]($i, situation);
                        }
                        return null;
                    };
                    var nodeSelectionCheck = function() {
                        var node = dir > 0 ? $i.nodeAfter : $i.nodeBefore;
                        if (node) {
                            var nodePos = dir > 0 ? $i.pos : $i.pos - node.nodeSize;
                            if (whoHasNodeViews.has(node.type.name) && node.type.spec.allowGapCursor && prosemirror_state_dist["NodeSelection"].isSelectable(node) && !prosemirror_state_dist["NodeSelection"].create(doc, nodePos).eq(selection)) {
                                return prosemirror_state_dist["NodeSelection"].create(doc, nodePos);
                            }
                        }
                        return null;
                    };
                    var gapcursorResult = gapcursorCheck();
                    var nodeSelectionResult = nodeSelectionCheck();
                    if (firstGapcursorCheck) {
                        if (gapcursorResult) {
                            nextSel = gapcursorResult;
                            return "break";
                        }
                        if (nodeSelectionCheck()) {
                            nextSel = nodeSelectionResult;
                            return "break";
                        }
                    } else {
                        if (nodeSelectionCheck()) {
                            nextSel = nodeSelectionResult;
                            return "break";
                        }
                        if (gapcursorResult) {
                            nextSel = gapcursorResult;
                            return "break";
                        }
                    }
                    i += dir;
                };
                var i = moveTo;
                var end = dir > 0 ? nextSel.from : nextSel.to;
                while((end - i) * dir >= 0){
                    var _ret = _loop();
                    if (_ret === "break") break;
                }
            }
            return nextSel;
        }
        return null;
    };
};
function arrowForHorizontal(dir) {
    return function(state, dispatch, view) {
        var selection = state.selection, tr = state.tr;
        var $from = selection.$from, $to = selection.$to;
        var $side = dir > 0 ? $to : $from;
        var move = moveFactory(state, dispatch, view, $side, dir);
        /**
     *  大思路，光标只能在下列光标之间切换（除表格选区）
     *  TextSeletion ⇌----⇌  Gapcursor  ⇌----⇌ NodeSelection
     *  Gapcursor ⇌----⇌ Gapcursor (在两个块级宏上下切换)
     */ /**
     * TextSelection只能变换成Gapcuor,当能变换成Gapcursor则优先变到Gapcursor，否则不做处理
     */ if (gap_cursor_extension_instanceof(selection, prosemirror_state_dist["TextSelection"])) {
            var oneStepSelection = move(dir, -1);
            if (gap_cursor_extension_instanceof(oneStepSelection, GapcursorSelection["a" /* GapCursor */])) {
                dispatch(tr.setSelection(oneStepSelection).scrollIntoView());
                return true;
            }
        }
        /**
     * Gapcusor可以变换成任意类型Selection
     * 优先计算在光标不变换的情况下是否可以转换成NodeSelection，如果可以表示用户在往这个Gapcursor所相邻的Node方向移动，需要设置成NodeSelection
     * 如果原地不动无法转换成NodeSelection，但可以转换成Gapcursor，表示用户在上下相邻的块级元素间移动，所以需要移动到Gapcursor
     * 最后都没有命中则直接移动到Prosemirror计算后的位置
     */ if (gap_cursor_extension_instanceof(selection, GapcursorSelection["a" /* GapCursor */])) {
            var zeroStepSelection = move(0);
            if (gap_cursor_extension_instanceof(zeroStepSelection, prosemirror_state_dist["NodeSelection"]) && zeroStepSelection.node.type.name !== "table" || gap_cursor_extension_instanceof(zeroStepSelection, GapcursorSelection["a" /* GapCursor */])) {
                dispatch(tr.setSelection(zeroStepSelection).scrollIntoView());
            } else {
                dispatch(tr.setSelection(move(dir)).scrollIntoView());
            }
            return true;
        }
        /**
     * NodeSelection只可以变换成Gapcursor
     * 如果在原地不动的情况下找到了Gapcursor则直接使用，否则就交给prosemirror处理
     */ if (gap_cursor_extension_instanceof(selection, prosemirror_state_dist["NodeSelection"])) {
            var zeroStepSelection1 = move(0, -1);
            if (gap_cursor_extension_instanceof(zeroStepSelection1, GapcursorSelection["a" /* GapCursor */])) {
                view.dispatch(tr.setSelection(zeroStepSelection1).scrollIntoView());
                return true;
            }
        }
        return false;
    };
}
var arrowForVertical = function() {
    return function(state, dispatch) {
        if (gap_cursor_extension_instanceof(state.selection, GapcursorSelection["a" /* GapCursor */])) {
            var selection = state.selection;
            var doc = state.doc, tr = state.tr;
            dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(doc, selection.from)).scrollIntoView());
        }
        return false;
    };
};
var handlePCKeyDown = Object(prosemirror_keymap_dist["a" /* keydownHandler */])({
    ArrowLeft: arrowForHorizontal(-1),
    ArrowRight: arrowForHorizontal(1),
    ArrowUp: arrowForVertical(),
    ArrowDown: arrowForVertical()
});
var handleBeforeInput = function(view) {
    var selection = view.state.selection;
    if (!gap_cursor_extension_getSystemInfo().isMobile && gap_cursor_extension_instanceof(selection, GapcursorSelection["a" /* GapCursor */])) {
        var _view_state = view.state, tr = _view_state.tr, schema = _view_state.schema;
        if (selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterNode || selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeNode) {
            tr.insert(tr.selection.from, schema.nodes.paragraph.create(null));
            var newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, tr.selection.from - 1);
            view.dispatch(tr.setSelection(newSelection));
        }
    }
    return true;
};
var gap_cursor_extension_GapCursorPCExtension = /*#__PURE__*/ function(GapCursorExtension) {
    gap_cursor_extension_inherits(GapCursorPCExtension, GapCursorExtension);
    var _super = gap_cursor_extension_createSuper(GapCursorPCExtension);
    function GapCursorPCExtension() {
        gap_cursor_extension_classCallCheck(this, GapCursorPCExtension);
        return _super.apply(this, arguments);
    }
    var _proto = GapCursorPCExtension.prototype;
    _proto.plugin = function plugin(params) {
        var pcPlugin = new prosemirror_state_dist["Plugin"]({
            key: pluginKey$1,
            props: {
                handleKeyDown: gap_cursor_extension_getSystemInfo().isMobile ? function() {
                    return false;
                } : handlePCKeyDown,
                handleDOMEvents: {
                    beforeinput: handleBeforeInput
                }
            }
        });
        return [
            gap_cursor_extension_get(gap_cursor_extension_getPrototypeOf(GapCursorPCExtension.prototype), "plugin", this).call(this, params),
            pcPlugin
        ];
    };
    return GapCursorPCExtension;
}(gap_cursor_extension["b" /* GapCursorExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/drop-file-extension/index.js






/**
 * 是否为表格内的位置
 * @param $pos ResolvedPos
 * @returns boolean
 */ var drop_file_extension_isInTablePos = function($pos) {
    for(var d = $pos.depth; d > 0; d--){
        // 有 tableRole 属性的就是表格的 schema
        if ($pos.node(d).type.spec.tableRole) return true;
    }
    return false;
};
/**
 * 获取在表格中的真正可插入的节点的位置
 * @param $pos ResolvedPos
 * @returns number
 */ var drop_file_extension_getInsertPosInTable = function($pos) {
    // 不是表格内的 pos 不处理
    if (!drop_file_extension_isInTablePos($pos)) return null;
    var selectionRight = prosemirror_state_dist["Selection"].near($pos, 1);
    var selectionLeft = prosemirror_state_dist["Selection"].near($pos, -1);
    // 左右可用选区都没有
    if (!selectionRight && !selectionLeft) return null;
    var insertPos = $pos.pos;
    // 只有一边有选区, 那么就用一边的选区的位置
    if (selectionRight && !selectionLeft) {
        insertPos = selectionRight.from;
    } else if (!selectionRight && selectionLeft) {
        insertPos = selectionLeft.from;
    } else {
        // 选取左右最近的能插入的位置, 右侧优先
        insertPos = $pos.pos - selectionLeft.from < selectionRight.from - $pos.pos ? selectionLeft.from : selectionRight.from;
    }
    return insertPos;
};

function drop_file_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var imgExts = [
    "bmp",
    "gif",
    "jpg",
    "png",
    "tiff",
    "jpeg",
    "svg"
];
// 根据文件名称后缀判断是否为图片文件
function isImageFile(file) {
    var filename = file && file.name || "";
    if (!filename) {
        return false;
    }
    var segments = filename.split(".");
    if (segments.length < 2) {
        // 无后缀
        return false;
    }
    var suffix = segments.pop() || "";
    return imgExts.includes(suffix.toLowerCase());
}
var hasFile = function(items) {
    return items.some(function(item) {
        return item.kind === "file";
    });
};
var hasHTML = function(items) {
    return items.some(function(item) {
        return item.type === "text/html";
    });
};
var handleFilesPaste = function(view, commands, items) {
    if (!commands || !(commands.image || commands.attachment) || items.length === 0) {
        return false;
    }
    var images = [];
    var attachments = [];
    items.forEach(function(item) {
        var file = item.getAsFile();
        if (!file || !commands) {
            return;
        }
        if (!drop_file_extension_instanceof(file, File)) {
            file = new File([
                file
            ], "clip.png");
        }
        if (isImageFile(file)) {
            images.push(file);
        } else {
            attachments.push(file);
        }
    });
    if (images.length > 0 && commands.image) {
        commands.image.upload(images);
    }
    if (attachments.length > 0 && commands.attachment) {
        commands.attachment.upload(attachments);
    }
    return true;
};

function drop_file_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function drop_file_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function drop_file_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function drop_file_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) drop_file_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) drop_file_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function drop_file_extension_getPrototypeOf(o) {
    drop_file_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return drop_file_extension_getPrototypeOf(o);
}
function drop_file_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) drop_file_extension_setPrototypeOf(subClass, superClass);
}
function drop_file_extension_possibleConstructorReturn(self, call) {
    if (call && (drop_file_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return drop_file_extension_assertThisInitialized(self);
}
function drop_file_extension_setPrototypeOf(o, p) {
    drop_file_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return drop_file_extension_setPrototypeOf(o, p);
}
var drop_file_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function drop_file_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function drop_file_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = drop_file_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = drop_file_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = drop_file_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return drop_file_extension_possibleConstructorReturn(this, result);
    };
}
var drop_file_extension_DropFileExtension = /*#__PURE__*/ function(CommonExtension) {
    drop_file_extension_inherits(DropFileExtension, CommonExtension);
    var _super = drop_file_extension_createSuper(DropFileExtension);
    function DropFileExtension() {
        drop_file_extension_classCallCheck(this, DropFileExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleDropEvent = function(view, event) {
            var isDrop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var data = event.clipboardData || event.dataTransfer;
            if (!data) return true;
            var items = Array.from(data.items);
            if (hasFile(items) && !hasHTML(items)) {
                event.preventDefault();
                if (isDrop) {
                    var pos = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    // 获取表格内部真正可以插入的位置
                    var insertPosInTable = drop_file_extension_getInsertPosInTable(view.state.doc.resolve(pos.pos));
                    var insertPos = insertPosInTable === null ? pos.pos : insertPosInTable;
                    view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["TextSelection"].create(view.state.doc, insertPos)));
                }
                var fileItems = items.filter(function(item) {
                    return item.kind === "file";
                });
                return handleFilesPaste(view, _this.allCommands, fileItems);
            }
            return false;
        };
        _this.plugin = function() {
            return new prosemirror_state_dist["Plugin"]({
                key: new prosemirror_state_dist["PluginKey"](_this.name),
                props: {
                    handleDOMEvents: {
                        paste: _this.handleDropEvent
                    },
                    handleDrop: function(view, event, slice, moved) {
                        if (moved) {
                            // 编辑器内部拖拽，此处不做处理
                            return false;
                        }
                        return _this.handleDropEvent(view, event, true);
                    }
                }
            });
        };
        return _this;
    }
    var _proto = DropFileExtension.prototype;
    _proto.didMountManager = function didMountManager(param) {
        var commands = param.commands;
        this.allCommands = commands;
    };
    drop_file_extension_createClass(DropFileExtension, [
        {
            key: "name",
            get: function get() {
                return "drop-file";
            }
        }
    ]);
    return DropFileExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/paragraph-extension/index.js




function paragraph_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function paragraph_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function paragraph_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        paragraph_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var setParagraph = function(type) {
    return function() {
        return function(state, dispatch) {
            var tr = state.tr, selection = state.selection, schema = state.schema;
            var paragraph = schema.nodes.paragraph;
            // 处于 CellSelection 时可能有多个 range
            selection.ranges.forEach(function(range) {
                var from = range.$from.pos;
                var to = range.$to.pos;
                tr.doc.nodesBetween(from, to, function(node, pos, parent) {
                    if (node.type.name === "heading") {
                        tr.setNodeMarkup(pos, paragraph, paragraph_extension_objectSpread({}, node.attrs));
                    }
                    if ((parent.type.name === "list_item" || parent.type === "task_item") && tr.doc.nodeAt(pos - 1)) {
                        tr.setNodeMarkup(pos - 1, null, paragraph_extension_objectSpreadProps(paragraph_extension_objectSpread({}, parent.attrs), {
                            level: 0
                        }));
                    }
                });
            });
            var transaction = tr;
            dispatch(transaction.scrollIntoView());
        };
    };
};

var paragraph_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function paragraph_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function paragraph_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function paragraph_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function paragraph_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) paragraph_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) paragraph_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function paragraph_extension_getPrototypeOf(o) {
    paragraph_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return paragraph_extension_getPrototypeOf(o);
}
function paragraph_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) paragraph_extension_setPrototypeOf(subClass, superClass);
}
function paragraph_extension_possibleConstructorReturn(self, call) {
    if (call && (paragraph_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return paragraph_extension_assertThisInitialized(self);
}
function paragraph_extension_setPrototypeOf(o, p) {
    paragraph_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return paragraph_extension_setPrototypeOf(o, p);
}
var paragraph_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function paragraph_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function paragraph_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = paragraph_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = paragraph_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = paragraph_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return paragraph_extension_possibleConstructorReturn(this, result);
    };
}
var paragraph_extension_ParagraphExtension = /*#__PURE__*/ function(NodeExtension) {
    paragraph_extension_inherits(ParagraphExtension, NodeExtension);
    var _super = paragraph_extension_createSuper(ParagraphExtension);
    function ParagraphExtension() {
        paragraph_extension_classCallCheck(this, ParagraphExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ParagraphExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            setParagraph: setParagraph()
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-0": paragraph_extension_convertCommand(setParagraph()())
        };
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        var createDom = document.createElement("div");
        createDom.innerHTML = html;
        var list = createDom.querySelectorAll("[data-diff-id]");
        list.forEach(function(h) {
            h.setAttribute("data-diff-id", "ct-diff-id-".concat(esm_browser_v4()));
        });
        return createDom.innerHTML;
    };
    paragraph_extension_createClass(ParagraphExtension, [
        {
            key: "name",
            get: function get() {
                return "paragraph";
            }
        }
    ]);
    return ParagraphExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/paste-extension/index.js






var paste_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(paste_extension_ExtensionType || (paste_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var paste_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var paste_extension_AFTER_INSERT = "after_insert";

var hasExtensionProperty = function(key) {
    return function(extension) {
        return Boolean(extension[key]);
    };
};
var SHADOWDOM_CLASS = "ct-web-dangers-shadow-wrapper";

var isCopyFromExcel = function(html) {
    return html.includes('xmlns:o="urn:schemas-microsoft-com:office:office"') && html.includes('xmlns:x="urn:schemas-microsoft-com:office:excel"');
};
// 由 Excel/WPS 复制
var parseExcel = function(html) {
    if (isCopyFromExcel(html)) {
        return html.replace(/(<\/html>)[\s\S]*$/, "$1").replace(/<br>\s*/g, "<br>​"); // 零宽度字符替换br后多余空白符
    }
    return html;
};
// 由学城浏览态复制 todo: 浏览态换成编辑器后可以去掉
var parseCitadelView = function(html) {
    // drawio 浏览态存在 shadowDOM
    if (~html.indexOf(SHADOWDOM_CLASS)) {
        var createSpan = document.createElement("span");
        createSpan.innerHTML = html;
        createSpan.querySelectorAll(".".concat(SHADOWDOM_CLASS)).forEach(function(el) {
            return el.remove();
        });
        html = createSpan.innerHTML;
    }
    return html.replace(/(<a[^>]*?[^-])color:[^>]*?;([^<]*?<\/a>)/g, "$1$2") // 移除链接颜色
    .replace(/color: rgb\(51, 51, 51\);/g, "") // 移除默认颜色
    .replace(/(<td[^>]*?)background-color: rgb\(255, 255, 255\);([^<]*?<\/td>)/g, "$1$2") // 处理空白背景单元格
    .replace(/(<td[^<]*?>)(\s*?)(<\/td>)/g, "$1<p></p>$3") // 处理空单元格
    .replace(/(<li[^<]*?>)(\s*?)(<\/li>)/g, "$1<p></p>$3") // 处理空序列
    // .replace(/<tr[^>]*?cloneHeader.*?<\/tr>/g, "") // 浏览态克隆的表头行
    .replace(/(<div class="ct-gantt.*?>).*?(<\/div>)/g, "$1$2") // 去除甘特图内容
    .replace(/(<td[^>]*?>[^<]*?)(<!--EndFragment-->)/g, "$1<p></p></td></tr></tbody></table></div>$2") // 修复浏览态复制表格HTML结构不全
    .replace(/&amp;token=.*?&amp;isNewContent=\w*/g, "") // 去除浏览态复制来的token信息
    .replace(/&amp;isNewContent=\w*/g, ""); // 去除浏览态复制来的isNewContent信息
};
var otherFilter = function(html) {
    return html.replace(/<img[^>]*? src="file:\/\/\/[^<]*?>/g, "") // 过滤掉未上传成功的图片
    .replace(/<img[^>]*? src="https:\/\/file\.sankuai\.com\/pan\/[^<]*?>/g, "<span>​</span>") // 移除大象图片
    .replace(/ct-selected/g, ""); // 移除选中状态
};
var handlePMSlice = function(html) {
    var codeTestReg = /class="ct-code"[^>]*?data-pm-slice="/;
    var pageTreeTestReg = /class="ct-page-tree"[^>]*?data-pm-slice="/;
    var ganttTestReg = /class="ct-gantt"[^>]*?data-pm-slice="/;
    var htmlTestReg = /class="ct-html"[\s\S]*data-pm-slice="/;
    var markdownTestReg = /class="ct-markdown"[^>]*?data-pm-slice="/;
    var latexTestReg = /class="ct-latex"[^>]*?data-pm-slice="/;
    var spaceUpdateReg = /class="ct-space-update"[^>]*?data-pm-slice="/;
    var timeReg = /time[^>]*?data-pm-slice="/;
    var removePMSlice = true;
    if (html.includes('data-pm-slice="')) {
        if (!html.includes('data-pm-slice="none"')) {
            if (codeTestReg.test(html) || pageTreeTestReg.test(html) || ganttTestReg.test(html) || htmlTestReg.test(html) || markdownTestReg.test(html) || latexTestReg.test(html) || spaceUpdateReg.test(html) || timeReg.test(html)) {
                removePMSlice = false;
            }
        }
    }
    if (removePMSlice) html = html.replace(/ data-pm-slice="[^>]*?"/g, "");
    return html;
};
var paste_extension_transformPastedHTML = function(html, pasteRule, extensions) {
    if (pasteRule) html = pasteRule(html);
    html = parseExcel(html);
    html = parseCitadelView(html);
    html = otherFilter(html);
    extensions.filter(hasExtensionProperty("transformPastedHTML")).forEach(function(extension) {
        html = extension.transformPastedHTML(html);
    });
    html = handlePMSlice(html);
    return html;
};

function paste_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function paste_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return paste_extension_arrayLikeToArray(arr);
}
function paste_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function paste_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function paste_extension_toConsumableArray(arr) {
    return paste_extension_arrayWithoutHoles(arr) || paste_extension_iterableToArray(arr) || paste_extension_unsupportedIterableToArray(arr) || paste_extension_nonIterableSpread();
}
function paste_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return paste_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return paste_extension_arrayLikeToArray(o, minLen);
}
// 撑开外层元素（表格）的宽度
var handleBraceWidth = function(node, eventEmitter) {
    if (node.type.spec.braceWidth) {
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit(paste_extension_AFTER_INSERT, {
            braceWidth: node.type.spec.braceWidth
        });
    }
};
var adjustSliceOpenStart = function(slice) {
    // 找到第一个离 openStart 最近的 Block 父节点所在的层级，设置成新的 openSlice
    // 试图解决 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/21232816
    // TODO(铁峰)：需要明确部分宏复制粘贴交互的正确性定义，包括但不限于列表，展开
    var content = slice.content;
    var nOpenStart = slice.openStart;
    for(var i = 1; i <= slice.openStart; i++){
        var node = content.firstChild;
        if (node.isBlock) {
            nOpenStart = i;
        }
        content = node.content;
    }
    slice.openStart = nOpenStart;
};
var paste_extension_transformPasted = function(slice, state, schema, extensions, eventEmitter) {
    adjustSliceOpenStart(slice);
    var handleNode = function(node, parentNode) {
        if (node && node.type.name === "text") {
            node.text = node.text.normalize();
        }
        var newNode = node;
        handleBraceWidth(node, eventEmitter);
        extensions.filter(hasExtensionProperty("transformPasted")).forEach(function(extension) {
            if (Array.isArray(newNode)) {
                newNode = newNode.reduce(function(nodes, curNode) {
                    var ret = extension.transformPasted(state, curNode, parentNode);
                    return Array.isArray(ret) ? paste_extension_toConsumableArray(nodes).concat(paste_extension_toConsumableArray(ret)) : paste_extension_toConsumableArray(nodes).concat([
                        ret
                    ]);
                }, []);
            } else {
                newNode = extension.transformPasted(state, newNode, parentNode);
            }
        });
        return Array.isArray(newNode) ? newNode : [
            newNode
        ];
    };
    // 递归遍历所有 Node
    // 约定 1：子节点放入第一个节点内
    // 约定 2：transformPasted 过程中生成的 node.content 会被忽略
    var traverseNode = function(frag, parentNode) {
        var allNewNodes = [];
        frag.forEach(function(node) {
            var _allNewNodes;
            // 先处理子节点(content)，再处理当前节点(copied)
            var content = node.content;
            var newContent = dist["Fragment"].empty;
            if (content && content.size > 0) {
                newContent = traverseNode(content, node);
            }
            // textNode copy 时必须传入 content
            var copied = node.type === schema.nodes.text ? node : node.copy();
            // 支持一个 node 在处理后变为多个 node（在 link-extension 中使用到这个特性）
            var newNodes = handleNode(copied, parentNode);
            if (newContent && newContent.size > 0 && (newNodes === null || newNodes === void 0 ? void 0 : newNodes.length)) {
                if (newNodes[0].type.validContent(newContent)) {
                    newNodes[0].content = newContent;
                } else {
                    newNodes[0].content = dist["Fragment"].from(node.content);
                }
            }
            (_allNewNodes = allNewNodes).push.apply(_allNewNodes, paste_extension_toConsumableArray(newNodes));
        });
        return dist["Fragment"].fromArray(allNewNodes);
    };
    slice = new dist["Slice"](traverseNode(slice.content), slice.openStart, slice.openEnd);
    return slice;
};

var paste_extension_handlePaste = function(view, event, slice, extensions) {
    var hasHandled = false;
    extensions.filter(hasExtensionProperty("handlePaste")).forEach(function(extension) {
        if (!hasHandled) {
            hasHandled = extension.handlePaste({
                view: view,
                event: event,
                slice: slice
            });
        }
    });
    return hasHandled;
};

function paste_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function paste_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function paste_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function paste_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) paste_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) paste_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function paste_extension_getPrototypeOf(o) {
    paste_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return paste_extension_getPrototypeOf(o);
}
function paste_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) paste_extension_setPrototypeOf(subClass, superClass);
}
function paste_extension_possibleConstructorReturn(self, call) {
    if (call && (paste_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return paste_extension_assertThisInitialized(self);
}
function paste_extension_setPrototypeOf(o, p) {
    paste_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return paste_extension_setPrototypeOf(o, p);
}
var paste_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function paste_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function paste_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = paste_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = paste_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = paste_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return paste_extension_possibleConstructorReturn(this, result);
    };
}
var paste_extension_PasteExtension = /*#__PURE__*/ function(CommonExtension) {
    paste_extension_inherits(PasteExtension, CommonExtension);
    var _super = paste_extension_createSuper(PasteExtension);
    function PasteExtension() {
        paste_extension_classCallCheck(this, PasteExtension);
        return _super.apply(this, arguments);
    }
    var _proto = PasteExtension.prototype;
    _proto.plugin = function plugin(param) {
        var schema = param.schema, getState = param.getState, editorEventEmitter = param.editorEventEmitter;
        var _this_options = this.options, pasteRule = _this_options.pasteRule, extensions = _this_options.extensions;
        return new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"]("paste"),
            props: {
                // 剪切板内字符串级别转换
                transformPastedHTML: function(html) {
                    return paste_extension_transformPastedHTML(html, pasteRule, extensions);
                },
                // 内容已经转换为ProseMirror模型后处理
                transformPasted: function(slice) {
                    return paste_extension_transformPasted(slice, getState(), schema, extensions, editorEventEmitter);
                },
                // 已经进入到事件hook中的paste处理
                handlePaste: function(view, event, slice) {
                    return paste_extension_handlePaste(view, event, slice, extensions);
                }
            }
        });
    };
    paste_extension_createClass(PasteExtension, [
        {
            key: "name",
            get: function get() {
                return "paste";
            }
        }
    ]);
    return PasteExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/wash-extension/index.js



/**
 * 数据中是否包含文件
 */ var wash_extension_hasFile = function(items) {
    return items.some(function(item) {
        return item.kind === "file";
    });
};
/**
 * 数据中是否包含 html
 */ var wash_extension_hasHTML = function(items) {
    return items.some(function(item) {
        return item.type === "text/html";
    });
};

function wash_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function wash_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function wash_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return wash_extension_arrayLikeToArray(arr);
}
function wash_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function wash_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function wash_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function wash_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) wash_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) wash_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function wash_extension_getPrototypeOf(o) {
    wash_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return wash_extension_getPrototypeOf(o);
}
function wash_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) wash_extension_setPrototypeOf(subClass, superClass);
}
function wash_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function wash_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function wash_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function wash_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function wash_extension_possibleConstructorReturn(self, call) {
    if (call && (wash_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return wash_extension_assertThisInitialized(self);
}
function wash_extension_setPrototypeOf(o, p) {
    wash_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return wash_extension_setPrototypeOf(o, p);
}
function wash_extension_slicedToArray(arr, i) {
    return wash_extension_arrayWithHoles(arr) || wash_extension_iterableToArrayLimit(arr, i) || wash_extension_unsupportedIterableToArray(arr, i) || wash_extension_nonIterableRest();
}
function wash_extension_toConsumableArray(arr) {
    return wash_extension_arrayWithoutHoles(arr) || wash_extension_iterableToArray(arr) || wash_extension_unsupportedIterableToArray(arr) || wash_extension_nonIterableSpread();
}
var wash_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function wash_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return wash_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wash_extension_arrayLikeToArray(o, minLen);
}
function wash_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function wash_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = wash_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = wash_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = wash_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return wash_extension_possibleConstructorReturn(this, result);
    };
}
var __generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var WASH_KEY = "getFilter";
/**
 * 从 providers 中获取包含过滤的功能列表
 */ var getFilters = function(providers, view) {
    var filters = new Map();
    wash_extension_toConsumableArray(providers.entries()).forEach(function(param) {
        var _param = wash_extension_slicedToArray(param, 2), entryName = _param[0], entryValue = _param[1];
        if (entryValue && entryValue[WASH_KEY] && typeof entryValue[WASH_KEY] === "function") {
            filters.set(entryName, entryValue[WASH_KEY](view));
        }
    });
    return filters;
};
var wash_extension_WashExtension = /*#__PURE__*/ function(CommonExtension) {
    wash_extension_inherits(WashExtension, CommonExtension);
    var _super = wash_extension_createSuper(WashExtension);
    function WashExtension() {
        wash_extension_classCallCheck(this, WashExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.filters = null;
        _this.allCommands = null;
        _this.plugin = function() {
            return new prosemirror_state_dist["Plugin"]({
                key: new prosemirror_state_dist["PluginKey"](_this.name),
                props: {
                    handlePaste: function(view, event, slice) {
                        if (!event.clipboardData) return true;
                        var items = Array.from(event.clipboardData.items);
                        return _this.handleDataWash(view, items, slice);
                    },
                    handleDrop: function(view, event, slice, moved) {
                        // moved=true 说明是编辑器中的元素，此时保持编辑器默认行为
                        if (moved) return false;
                        if (!event.dataTransfer) return true;
                        var items = Array.from(event.dataTransfer.items);
                        var dropPos = view.posAtCoords({
                            left: event.clientX,
                            top: event.clientY
                        });
                        return _this.handleDataWash(view, items, slice, dropPos === null || dropPos === void 0 ? void 0 : dropPos.pos);
                    }
                }
            });
        };
        return _this;
    }
    var _proto = WashExtension.prototype;
    _proto.didMountManager = function didMountManager(param) {
        var providers = param.providers, getView = param.getView, commands = param.commands;
        this.filters = getFilters(providers, getView());
        this.allCommands = commands;
    };
    _proto.handleDataWash = function handleDataWash(view, items, slice, dropPos// 拖放的位置
    ) {
        var _this = this;
        if (wash_extension_hasFile(items) && !wash_extension_hasHTML(items)) {
            return true;
        }
        var filters = this.filters;
        var willDelete = new Map();
        // 先对需要清理的节点进行标记
        slice.content.descendants(function(param) {
            var attrs = param.attrs, name = param.type.name;
            if (filters.has(name)) {
                var key = filters.get(name).check(attrs);
                if (key) {
                    if (willDelete.has(key)) {
                        willDelete.get(key).push(name);
                    } else {
                        willDelete.set(key, [
                            name
                        ]);
                    }
                }
            }
        });
        // 记录替换的光标范围
        var replaceFrom = view.state.tr.curSelection.from;
        // 执行内容替换，如果当前是拖放行为，需要替换内容到拖放的位置
        if (dropPos === undefined) {
            view.dispatch(view.state.tr.replaceSelection(slice));
        } else {
            view.dispatch(view.state.tr.replace(dropPos, dropPos, slice));
        }
        var replaceTo = view.state.tr.curSelection.to;
        // 将标记内容进行清理
        wash_extension_toConsumableArray(willDelete.entries()).forEach(function(param) {
            var _param = wash_extension_slicedToArray(param, 2), k = _param[0], types = _param[1];
            view.state.doc.content.descendants(function(param, pos) {
                var attrs = param.attrs, name = param.type.name;
                var filter = filters.get(name);
                if (pos < replaceFrom || pos > replaceTo) return true;
                if (filter && types.includes(name) && filter.check(attrs) === k) {
                    var _this_allCommands_name;
                    var tr = view.state.tr;
                    // 当两个附件相连时，删除第一个附件后光标为NodeSelection选中第二个附件，此时handle会导致第二个附件被删除，所以需要重新setSelection
                    view.dispatch(tr.setSelection(prosemirror_state_dist["NodeSelection"].create(view.state.doc, pos)).deleteSelection().setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, pos)));
                    // 获取数据清洗后的 attrs
                    var handle = filter.handle;
                    var customUpload = function() {
                        var _ref = _asyncToGenerator(function() {
                            var newAttrs;
                            return __generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            handle(attrs)
                                        ];
                                    case 1:
                                        newAttrs = _state.sent();
                                        return [
                                            2,
                                            newAttrs
                                        ];
                                }
                            });
                        });
                        return function customUpload() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    (_this_allCommands_name = _this.allCommands[name]) === null || _this_allCommands_name === void 0 ? void 0 : _this_allCommands_name.insert({
                        customUpload: customUpload,
                        pos: pos
                    });
                    return false;
                }
                return true;
            });
        });
        return true;
    };
    wash_extension_createClass(WashExtension, [
        {
            key: "name",
            get: function get() {
                return "wash";
            }
        }
    ]);
    return WashExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/placeholder-extension/index.js







/**
 * 统一样式前缀
 */ var placeholder_extension_CLASSNAME_PREFIX = "ct";

var placeholder_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : placeholder_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function isEmptyDoc(doc) {
    return doc.childCount === 1 && doc.firstChild.isTextblock && doc.firstChild.content.size === 0;
}

function placeholder_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var placeholder_extension_css_248z = ".ProseMirror span.ct-plugin-placeholder:before{color:#cecece;content:attr(data-placeholder);cursor:text;position:relative;top:-2px}";
placeholder_extension_styleInject(placeholder_extension_css_248z);

function placeholder_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function placeholder_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function placeholder_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function placeholder_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) placeholder_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) placeholder_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function placeholder_extension_getPrototypeOf(o) {
    placeholder_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return placeholder_extension_getPrototypeOf(o);
}
function placeholder_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) placeholder_extension_setPrototypeOf(subClass, superClass);
}
function placeholder_extension_possibleConstructorReturn(self, call) {
    if (call && (placeholder_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return placeholder_extension_assertThisInitialized(self);
}
function placeholder_extension_setPrototypeOf(o, p) {
    placeholder_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return placeholder_extension_setPrototypeOf(o, p);
}
var placeholder_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function placeholder_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function placeholder_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = placeholder_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = placeholder_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = placeholder_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return placeholder_extension_possibleConstructorReturn(this, result);
    };
}
var placeholder_extension_PlaceholderExtension = /*#__PURE__*/ function(MarkExtension) {
    placeholder_extension_inherits(PlaceholderExtension, MarkExtension);
    var _super = placeholder_extension_createSuper(PlaceholderExtension);
    function PlaceholderExtension() {
        placeholder_extension_classCallCheck(this, PlaceholderExtension);
        return _super.apply(this, arguments);
    }
    var _proto = PlaceholderExtension.prototype;
    _proto.plugin = function plugin(param) {
        var getView = param.getView, config = param.config;
        return new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"](this.name),
            props: {
                decorations: function decorations(state) {
                    var doc = state.doc;
                    if (isEmptyDoc(doc)) {
                        var placeHolder = document.createElement("span");
                        placeHolder.classList.add(placeholder_extension_classNamePrefix("plugin-placeholder"));
                        placeHolder.onclick = function() {
                            var view = getView();
                            view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["TextSelection"].near(state.doc.resolve(0))));
                        };
                        placeHolder.setAttribute("data-placeholder", config.placeholder);
                        return index_es["b" /* DecorationSet */].create(doc, [
                            index_es["a" /* Decoration */].widget(1, placeHolder)
                        ]);
                    }
                }
            }
        });
    };
    placeholder_extension_createClass(PlaceholderExtension, [
        {
            key: "name",
            get: function get() {
                return "placeholder";
            }
        }
    ]);
    return PlaceholderExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/prosemirror-history/dist/history.js
var dist_history = __webpack_require__("321a");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/history-extension/index.js




var isUndoDisabled = function() {
    return function(state, dispatch, view) {
        return Object(dist_history["undoDepth"])(state) < 1;
    };
};

var isRedoDisabled = function() {
    return function(state, dispatch, view) {
        return Object(dist_history["redoDepth"])(state) < 1;
    };
};

var history_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function history_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function history_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function history_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function history_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) history_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) history_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function history_extension_getPrototypeOf(o) {
    history_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return history_extension_getPrototypeOf(o);
}
function history_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) history_extension_setPrototypeOf(subClass, superClass);
}
function history_extension_possibleConstructorReturn(self, call) {
    if (call && (history_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return history_extension_assertThisInitialized(self);
}
function history_extension_setPrototypeOf(o, p) {
    history_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return history_extension_setPrototypeOf(o, p);
}
var history_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function history_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function history_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = history_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = history_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = history_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return history_extension_possibleConstructorReturn(this, result);
    };
}
var history_extension_HistoryExtension = /*#__PURE__*/ function(CommonExtension) {
    history_extension_inherits(HistoryExtension, CommonExtension);
    var _super = history_extension_createSuper(HistoryExtension);
    function HistoryExtension() {
        history_extension_classCallCheck(this, HistoryExtension);
        return _super.apply(this, arguments);
    }
    var _proto = HistoryExtension.prototype;
    _proto.plugin = function plugin() {
        return Object(dist_history["history"])();
    };
    _proto.commands = function commands() {
        return {
            undo: function() {
                return dist_history["undo"];
            },
            redo: function() {
                return dist_history["redo"];
            },
            isUndoDisabled: isUndoDisabled,
            isRedoDisabled: isRedoDisabled
        };
    };
    _proto.keys = function keys() {
        return {
            "Mod-z": history_extension_convertCommand(dist_history["undo"]),
            "Mod-y": history_extension_convertCommand(dist_history["redo"]),
            "Mod-Shift-z": history_extension_convertCommand(dist_history["redo"])
        };
    };
    history_extension_createClass(HistoryExtension, [
        {
            key: "name",
            get: function get() {
                return "history";
            }
        }
    ]);
    return HistoryExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/align-extension/index.js






function align_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function align_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            align_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function align_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function align_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        align_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var alignType;
(function(alignType) {
    alignType["AlignLeft"] = "left";
    alignType["AlignCenter"] = "center";
    alignType["AlignRight"] = "right";
})(alignType || (alignType = {}));
var setAlign = function(align) {
    return function(state, dispatch, view) {
        var tr = state.tr, selection = state.selection;
        // 处于 CellSelection 时可能有多个 range
        selection.ranges.forEach(function(range) {
            var from = range.$from.pos;
            var to = range.$to.pos;
            tr.doc.nodesBetween(from, to, function(node, pos) {
                var _node_type, _node_type_defaultAttrs;
                if (((_node_type = node.type) === null || _node_type === void 0 ? void 0 : (_node_type_defaultAttrs = _node_type.defaultAttrs) === null || _node_type_defaultAttrs === void 0 ? void 0 : _node_type_defaultAttrs.align) && node.attrs.align !== align) {
                    tr.setNodeMarkup(pos, null, align_extension_objectSpreadProps(align_extension_objectSpread({}, node.attrs), {
                        align: align
                    }));
                }
            });
        });
        dispatch(tr.scrollIntoView());
        return true;
    };
};

var align_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(align_extension_ExtensionType || (align_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var align_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var isCommonActive = function(attrName) {
    return function(attrValue) {
        return function(state) {
            var selection = state.selection, doc = state.doc;
            var from = selection.from, to = selection.to;
            var keepLooking = true;
            var active = false;
            doc.nodesBetween(from, to, function(node) {
                if (keepLooking && node.attrs[attrName] === attrValue) {
                    keepLooking = false;
                    active = true;
                }
                return keepLooking;
            });
            return active;
        };
    };
};

var isAlignActive = isCommonActive("align");

var isAlignDisabled = function() {
    return function(state) {
        var parentNode = state.selection.$from.parent;
        var textType = [
            "status",
            "code_block"
        ];
        return textType.includes(parentNode.type.name);
    };
};

var align_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function align_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function align_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function align_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function align_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) align_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) align_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function align_extension_getPrototypeOf(o) {
    align_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return align_extension_getPrototypeOf(o);
}
function align_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) align_extension_setPrototypeOf(subClass, superClass);
}
function align_extension_possibleConstructorReturn(self, call) {
    if (call && (align_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return align_extension_assertThisInitialized(self);
}
function align_extension_setPrototypeOf(o, p) {
    align_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return align_extension_setPrototypeOf(o, p);
}
var align_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function align_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function align_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = align_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = align_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = align_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return align_extension_possibleConstructorReturn(this, result);
    };
}
var AlignExtension = /*#__PURE__*/ function(CommonExtension) {
    align_extension_inherits(AlignExtension, CommonExtension);
    var _super = align_extension_createSuper(AlignExtension);
    function AlignExtension() {
        align_extension_classCallCheck(this, AlignExtension);
        return _super.apply(this, arguments);
    }
    var _proto = AlignExtension.prototype;
    _proto.commands = function commands() {
        return {
            setAlign: setAlign,
            isAlignActive: isAlignActive,
            isAlignDisabled: isAlignDisabled
        };
    };
    _proto.keys = function keys() {
        return {
            "Mod-Shift-l": align_extension_convertCommand(setAlign("left")),
            "Mod-Shift-c": align_extension_convertCommand(setAlign("center")),
            "Mod-Shift-r": align_extension_convertCommand(setAlign("right"))
        };
    };
    align_extension_createClass(AlignExtension, [
        {
            key: "name",
            get: function get() {
                return "align";
            }
        }
    ]);
    return AlignExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/prosemirror-schema-list/dist/index.es.js



var olDOM = ["ol", 0], ulDOM = ["ul", 0], liDOM = ["li", 0];

// :: NodeSpec
// An ordered list [node spec](#model.NodeSpec). Has a single
// attribute, `order`, which determines the number at which the list
// starts counting, and defaults to 1. Represented as an `<ol>`
// element.
var orderedList = {
  attrs: {order: {default: 1}},
  parseDOM: [{tag: "ol", getAttrs: function getAttrs(dom) {
    return {order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1}
  }}],
  toDOM: function toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {start: node.attrs.order}, 0]
  }
};

// :: NodeSpec
// A bullet list node spec, represented in the DOM as `<ul>`.
var bulletList = {
  parseDOM: [{tag: "ul"}],
  toDOM: function toDOM() { return ulDOM }
};

// :: NodeSpec
// A list item (`<li>`) spec.
var listItem = {
  parseDOM: [{tag: "li"}],
  toDOM: function toDOM() { return liDOM },
  defining: true
};

function index_es_add(obj, props) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  for (var prop$1 in props) { copy[prop$1] = props[prop$1]; }
  return copy
}

// :: (OrderedMap<NodeSpec>, string, ?string) → OrderedMap<NodeSpec>
// Convenience function for adding list-related node types to a map
// specifying the nodes for a schema. Adds
// [`orderedList`](#schema-list.orderedList) as `"ordered_list"`,
// [`bulletList`](#schema-list.bulletList) as `"bullet_list"`, and
// [`listItem`](#schema-list.listItem) as `"list_item"`.
//
// `itemContent` determines the content expression for the list items.
// If you want the commands defined in this module to apply to your
// list structure, it should have a shape like `"paragraph block*"` or
// `"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
// given to assign a group name to the list node types, for example
// `"block"`.
function addListNodes(nodes, itemContent, listGroup) {
  return nodes.append({
    ordered_list: index_es_add(orderedList, {content: "list_item+", group: listGroup}),
    bullet_list: index_es_add(bulletList, {content: "list_item+", group: listGroup}),
    list_item: index_es_add(listItem, {content: itemContent})
  })
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function wrapInList(listType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), doJoin = false, outerRange = range;
    if (!range) { return false }
    // This is at the top of an existing list item
    if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
      // Don't do anything if this is the top of the list
      if ($from.index(range.depth - 1) == 0) { return false }
      var $insert = state.doc.resolve(range.start - 2);
      outerRange = new dist["NodeRange"]($insert, $insert, range.depth);
      if (range.endIndex < range.parent.childCount)
        { range = new dist["NodeRange"]($from, state.doc.resolve($to.end(range.depth)), range.depth); }
      doJoin = true;
    }
    var wrap = Object(prosemirror_transform_dist["findWrapping"])(outerRange, listType, attrs, range);
    if (!wrap) { return false }
    if (dispatch) { dispatch(doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView()); }
    return true
  }
}

function doWrapInList(tr, range, wrappers, joinBefore, listType) {
  var content = dist["Fragment"].empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = dist["Fragment"].from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end,
                                new dist["Slice"](content, 0, 0), wrappers.length, true));

  var found = 0;
  for (var i$1 = 0; i$1 < wrappers.length; i$1++) { if (wrappers[i$1].type == listType) { found = i$1 + 1; } }
  var splitDepth = wrappers.length - found;

  var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
  for (var i$2 = range.startIndex, e = range.endIndex, first = true; i$2 < e; i$2++, first = false) {
    if (!first && Object(prosemirror_transform_dist["canSplit"])(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i$2).nodeSize;
  }
  return tr
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Build a command that splits a non-empty textblock at the top level
// of a list item by also splitting that list item.
function splitListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var node = ref.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) { return false }
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) { return false }
    if ($from.parent.content.size == 0) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth == 2 || $from.node(-3).type != itemType ||
          $from.index(-2) != $from.node(-2).childCount - 1) { return false }
      if (dispatch) {
        var wrap = dist["Fragment"].empty, keepItem = $from.index(-1) > 0;
        // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor
        for (var d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)
          { wrap = dist["Fragment"].from($from.node(d).copy(wrap)); }
        // Add a second list item with an empty default start node
        wrap = wrap.append(dist["Fragment"].from(itemType.createAndFill()));
        var tr$1 = state.tr.replace($from.before(keepItem ? null : -1), $from.after(-3), new dist["Slice"](wrap, keepItem ? 3 : 2, 2));
        tr$1.setSelection(state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
        dispatch(tr$1.scrollIntoView());
      }
      return true
    }
    var nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    var tr = state.tr.delete($from.pos, $to.pos);
    var types = nextType && [null, {type: nextType}];
    if (!Object(prosemirror_transform_dist["canSplit"])(tr.doc, $from.pos, 2, types)) { return false }
    if (dispatch) { dispatch(tr.split($from.pos, 2, types).scrollIntoView()); }
    return true
  }
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function liftListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    if (!dispatch) { return true }
    if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
      { return liftToOuterList(state, dispatch, itemType, range) }
    else // Outer list node
      { return liftOutOfList(state, dispatch, range) }
  }
}

function liftToOuterList(state, dispatch, itemType, range) {
  var tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
  if (end < endOfList) {
    // There are siblings after the lifted items, which must become
    // children of the last item
    tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](end - 1, endOfList, end, endOfList,
                                  new dist["Slice"](dist["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new dist["NodeRange"](tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
  }
  dispatch(tr.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range)).scrollIntoView());
  return true
}

function liftOutOfList(state, dispatch, range) {
  var tr = state.tr, list = range.parent;
  // Merge the list items into a single big item
  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr.delete(pos - 1, pos + 1);
  }
  var $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
  var atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
  var parent = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1,
                         item.content.append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list))))
    { return false }
  var start = $start.pos, end = start + item.nodeSize;
  // Strip off the surrounding list. At the sides where we're not at
  // the end of the list, the existing list is closed. At sides where
  // this is the end, it is overwritten to its end.
  tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1,
                                new dist["Slice"]((atStart ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty)))
                                          .append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty))),
                                          atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr.scrollIntoView());
  return true
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to sink the list item around the selection down
// into an inner list.
function sinkListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    var startIndex = range.startIndex;
    if (startIndex == 0) { return false }
    var parent = range.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType) { return false }

    if (dispatch) {
      var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      var inner = dist["Fragment"].from(nestedBefore ? itemType.create() : null);
      var slice = new dist["Slice"](dist["Fragment"].from(itemType.create(null, dist["Fragment"].from(parent.type.create(null, inner)))),
                            nestedBefore ? 3 : 1, 0);
      var before = range.start, after = range.end;
      dispatch(state.tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](before - (nestedBefore ? 3 : 1), after,
                                                   before, after, slice, 1, true))
               .scrollIntoView());
    }
    return true
  }
}


//# sourceMappingURL=index.es.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/indent-extension/index.js







var indent_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(indent_extension_ExtensionType || (indent_extension_ExtensionType = {}));

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};

/**
 * 通用配置
 */ var indent_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var isShouldIndent = function(selection) {
    var parentNode = findParentNode(function(item) {
        return item.type && (item.type.name === "table" || item.type.name === "list_item" || item.type.name === "task_item");
    })(selection);
    if (parentNode) {
        if (parentNode.node.type.name === "table") {
            return false;
        }
    }
    return true;
};

function indent_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function indent_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            indent_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function indent_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function indent_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        indent_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var IndentType;
(function(IndentType) {
    IndentType[IndentType["Less"] = -1] = "Less";
    IndentType[IndentType["More"] = 1] = "More";
})(IndentType || (IndentType = {}));
var setIndent = function(indentType) {
    return function(state, dispatch, view) {
        var attrsGetter = function(attrs) {
            return indent_extension_objectSpreadProps(indent_extension_objectSpread({}, attrs), {
                indent: attrs.indent + indentType
            });
        };
        var selection = state.selection, tr = state.tr, schema = state.schema;
        var _schema_nodes = schema.nodes, listItem = _schema_nodes.list_item, taskListItem = _schema_nodes.task_item, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list;
        var itemTypes = [
            listItem,
            taskListItem
        ];
        var listTypes = [
            ordered_list,
            bullet_list,
            task_list
        ];
        var transaction;
        var predicate = function(node) {
            return listTypes.includes(node.type);
        };
        var parentList = findParentNode(predicate)(selection);
        selection.ranges.forEach(function(range) {
            var from = range.$from.pos;
            var to = range.$to.pos;
            var blockStart = 0;
            var blockEnd = 0;
            tr.doc.nodesBetween(from, to, function(node, pos) {
                if (pos > blockStart && pos < blockEnd) return;
                if (itemTypes.includes(node.type)) {
                    if (pos < from || pos > to) return;
                    blockStart = pos;
                    blockEnd = pos + node.nodeSize;
                }
                if (parentList) {
                    var listNode = parentList.node;
                    if (listNode !== node) return;
                }
                var attrs = node.attrs;
                if (attrs.indent !== undefined && (indentType !== IndentType.Less || attrs.indent > 0)) {
                    var newAttrs = attrsGetter(attrs);
                    transaction = tr.setNodeMarkup(pos, null, newAttrs);
                }
            });
        });
        if (!transaction) return false;
        if (dispatch) {
            dispatch(transaction);
        }
        return true;
    };
};

var indentLess = function() {
    return function(state, dispatch, view) {
        var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, list_item = _state_schema_nodes.list_item, task_item = _state_schema_nodes.task_item, selection = state.selection;
        if (setIndent(IndentType.Less)(state, dispatch, view)) {
            return true;
        }
        if (liftListItem(list_item)(state, dispatch) || liftListItem(task_item)(state, dispatch)) {
            return true;
        }
        if (isShouldIndent(selection)) {
            return true;
        }
        return false;
    };
};

var indentMore = function() {
    return function(state, dispatch, view) {
        var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, list_item = _state_schema_nodes.list_item, task_item = _state_schema_nodes.task_item, selection = state.selection;
        if (sinkListItem(list_item)(state, dispatch) || sinkListItem(task_item)(state, dispatch)) {
            return true;
        }
        if (isShouldIndent(selection)) {
            return setIndent(IndentType.More)(state, dispatch, view);
        }
        return false;
    };
};

var handleBackspace = function() {
    return function(state, dispatch, view) {
        var sel = state.selection;
        // 单光标状态，在文本的最前面
        if (sel.from === sel.to && !sel.$anchor.nodeBefore && sel.$anchor.parent.attrs.indent > 0) {
            return indentLess()(state, dispatch, view);
        }
        return false;
    };
};

var isIndentLessDisabled = function() {
    return function(state, dispatch, view) {
        var schema = state.schema, selection = state.selection;
        var _schema_nodes = schema.nodes, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list, table = _schema_nodes.table;
        var listTypes = [
            ordered_list,
            bullet_list,
            task_list
        ];
        var predicate = function(node) {
            return listTypes.includes(node.type);
        };
        var predicateTable = function(node) {
            return node.type === table;
        };
        var listInfo = findParentNode(predicate)(selection);
        var tableInfo = findParentNode(predicateTable)(selection);
        if (listInfo && tableInfo) {
            // 同时存在list和table
            var listPos = listInfo.pos;
            var tablePos = tableInfo.pos;
            if (listPos > tablePos) {
                // 在列表中，不禁用缩进
                return false;
            }
            // 在表格中，禁用缩进
            return true;
        }
        if (listInfo) {
            // 在列表中，不禁用缩进
            return false;
        }
        if (tableInfo) {
            // 在表格中，禁用缩进
            return true;
        }
        return !setIndent(IndentType.Less)(state);
    };
};

var isIndentMoreDisabled = function() {
    return function(state, dispatch, view) {
        var schema = state.schema, selection = state.selection;
        var _schema_nodes = schema.nodes, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list, table = _schema_nodes.table;
        var listTypes = [
            ordered_list,
            bullet_list,
            task_list
        ];
        var predicate = function(node) {
            return listTypes.includes(node.type);
        };
        var predicateTable = function(node) {
            return node.type === table;
        };
        var listInfo = findParentNode(predicate)(selection);
        var tableInfo = findParentNode(predicateTable)(selection);
        if (listInfo && tableInfo) {
            // 同时存在list和table
            var listPos = listInfo.pos;
            var tablePos = tableInfo.pos;
            if (listPos > tablePos) {
                // 在列表中，不禁用缩进
                return false;
            }
            // 在表格中，禁用缩进
            return true;
        }
        if (listInfo) {
            // 在列表中，不禁用缩进
            return false;
        }
        if (tableInfo) {
            // 在表格中，禁用缩进
            return true;
        }
        return !setIndent(IndentType.More)(state);
    };
};

var indent_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function indent_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function indent_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function indent_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function indent_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) indent_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) indent_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function indent_extension_getPrototypeOf(o) {
    indent_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return indent_extension_getPrototypeOf(o);
}
function indent_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) indent_extension_setPrototypeOf(subClass, superClass);
}
function indent_extension_possibleConstructorReturn(self, call) {
    if (call && (indent_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return indent_extension_assertThisInitialized(self);
}
function indent_extension_setPrototypeOf(o, p) {
    indent_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return indent_extension_setPrototypeOf(o, p);
}
var indent_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function indent_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function indent_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = indent_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = indent_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = indent_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return indent_extension_possibleConstructorReturn(this, result);
    };
}
var IndentExtension = /*#__PURE__*/ function(CommonExtension) {
    indent_extension_inherits(IndentExtension, CommonExtension);
    var _super = indent_extension_createSuper(IndentExtension);
    function IndentExtension() {
        indent_extension_classCallCheck(this, IndentExtension);
        return _super.apply(this, arguments);
    }
    var _proto = IndentExtension.prototype;
    _proto.commands = function commands() {
        return {
            indentLess: indentLess,
            indentMore: indentMore,
            isIndentMoreDisabled: isIndentMoreDisabled,
            isIndentLessDisabled: isIndentLessDisabled
        };
    };
    _proto.keys = function keys() {
        return {
            Tab: indent_extension_convertCommand(indentMore()),
            "Shift-Tab": indent_extension_convertCommand(indentLess()),
            Backspace: indent_extension_convertCommand(handleBackspace())
        };
    };
    indent_extension_createClass(IndentExtension, [
        {
            key: "name",
            get: function get() {
                return "indent";
            }
        }
    ]);
    return IndentExtension;
}(core["a" /* CommonExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/color-extension/index.js






var color_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(color_extension_ExtensionType || (color_extension_ExtensionType = {}));

var color_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var color_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var color_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return color_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!color_extension_findParentNode(predicate)(selection);
    };
};
/**
 * 判断选区中是否存在可以应用markType的节点
 * @param doc doc文档
 * @param ranges 选区
 * @param type markType类型
 */ var isExistAllowsMarkType = function(doc, ranges, type) {
    var _loop = function(i) {
        var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function(node) {
            if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
            return !can;
        });
        if (can) return {
            v: true
        };
    };
    for(var i = 0; i < ranges.length; i++){
        var _ret = _loop(i);
        if (color_extension_typeof(_ret) === "object") return _ret.v;
    }
    return false;
};
/**
 * 添加新的mark类型
 * @param type mark类型
 * @param attrs mark属性
 * @param enhance
 */ var addMarkType = function(type, attrs, enhance) {
    return function(state, dispatch) {
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, ranges = _state_selection.ranges;
        if (empty && !$cursor || !isExistAllowsMarkType(state.doc, ranges, type)) {
            return false;
        }
        // 是否为空光标
        if ($cursor) {
            // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
            var tr = state.tr;
            tr.addStoredMark(type.create(attrs));
            if (enhance) {
                tr = enhance(tr);
            }
            dispatch(tr);
        } else {
            var has = false;
            var tr1 = state.tr;
            for(var i = 0; !has && i < ranges.length; i++){
                var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
                has = state.doc.rangeHasMark($from.pos, $to.pos, type);
            }
            for(var i1 = 0; i1 < ranges.length; i1++){
                var _ranges_i1 = ranges[i1], $from1 = _ranges_i1.$from, $to1 = _ranges_i1.$to;
                // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
                if (has) tr1.removeMark($from1.pos, $to1.pos, type);
                tr1.addMark($from1.pos, $to1.pos, type.create(attrs));
            }
            dispatch(tr1);
        }
        return true;
    };
};

/**
 * 通用配置
 */ var color_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var color_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
/**
 * 判断选区内容是否支持指定类型的 mark 节点
 */ function markApplies(doc, ranges, type) {
    var _loop = function(i) {
        var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function(node) {
            if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
            return !can;
        });
        if (can) return {
            v: true
        };
    };
    for(var i = 0; i < ranges.length; i++){
        var _ret = _loop(i);
        if (color_extension_typeof$1(_ret) === "object") return _ret.v;
    }
    return false;
}

/**
 * 恢复当前选区的文字颜色
 */ var setDefaultFontColor = function() {
    return function(state, dispatch, view) {
        var colorType = state.schema.marks.color;
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, ranges = _state_selection.ranges;
        if (empty && !$cursor || !markApplies(state.doc, ranges, colorType)) {
            return false;
        }
        if ($cursor) {
            dispatch(state.tr.removeStoredMark(colorType));
        } else {
            var tr = state.tr;
            for(var i = 0; i < ranges.length; i++){
                var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
                tr.removeMark($from.pos, $to.pos, colorType);
            }
            dispatch(tr.scrollIntoView());
        }
        view.focus();
        return true;
    };
};

function color_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function color_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function color_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function color_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) color_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) color_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function color_extension_getPrototypeOf(o) {
    color_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return color_extension_getPrototypeOf(o);
}
function color_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) color_extension_setPrototypeOf(subClass, superClass);
}
function color_extension_possibleConstructorReturn(self, call) {
    if (call && (color_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return color_extension_assertThisInitialized(self);
}
function color_extension_setPrototypeOf(o, p) {
    color_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return color_extension_setPrototypeOf(o, p);
}
var color_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function color_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function color_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = color_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = color_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = color_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return color_extension_possibleConstructorReturn(this, result);
    };
}
var ColorExtension = /*#__PURE__*/ function(MarkExtension) {
    color_extension_inherits(ColorExtension, MarkExtension);
    var _super = color_extension_createSuper(ColorExtension);
    function ColorExtension() {
        color_extension_classCallCheck(this, ColorExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ColorExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            setColor: function(color) {
                if (!color) return setDefaultFontColor();
                return addMarkType(type, {
                    color: color
                });
            },
            setDefaultColor: setDefaultFontColor,
            isDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    color_extension_createClass(ColorExtension, [
        {
            key: "name",
            get: function get() {
                return "color";
            }
        }
    ]);
    return ColorExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/prosemirror-inputrules/dist/index.js
var prosemirror_inputrules_dist = __webpack_require__("72a8");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/em-extension/index.js






/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 斜体
var regexpItalic = /(?:_)([^]+)(?:)_\s$/;

var em_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var em_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(em_extension_ExtensionType || (em_extension_ExtensionType = {}));

var em_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var em_extension_isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : em_extension_typeof(value)) === type;
    };
};
var isFunction = em_extension_isOfType("function");

var em_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var em_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return em_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var em_extension_isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!em_extension_findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = Object(dist_commands["toggleMark"])(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};

/**
 * 通用配置
 */ var em_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};
var markInputRule = function(param) {
    var regexp = param.regexp, type = param.type, getAttrs = param.getAttrs;
    return new prosemirror_inputrules_dist["a" /* InputRule */](regexp, function(state, match, start, end) {
        // TODO:只对选中区域设置mark，没有将整个node节点设置
        var tr = state.tr;
        // @ts-ignore
        var attrs = isFunction(getAttrs) ? getAttrs(match) : getAttrs;
        var markEnd = end;
        if (match[1]) {
            var startSpaces = match[0].search(/\S/);
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + match[1].length;
        }
        return tr.addMark(start, markEnd, type.create(attrs)).removeStoredMark(type);
    });
};

function em_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function em_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function em_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function em_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) em_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) em_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function em_extension_getPrototypeOf(o) {
    em_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return em_extension_getPrototypeOf(o);
}
function em_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) em_extension_setPrototypeOf(subClass, superClass);
}
function em_extension_possibleConstructorReturn(self, call) {
    if (call && (em_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return em_extension_assertThisInitialized(self);
}
function em_extension_setPrototypeOf(o, p) {
    em_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return em_extension_setPrototypeOf(o, p);
}
var em_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function em_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function em_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = em_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = em_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = em_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return em_extension_possibleConstructorReturn(this, result);
    };
}
var EmExtension = /*#__PURE__*/ function(MarkExtension) {
    em_extension_inherits(EmExtension, MarkExtension);
    var _super = em_extension_createSuper(EmExtension);
    function EmExtension() {
        em_extension_classCallCheck(this, EmExtension);
        return _super.apply(this, arguments);
    }
    var _proto = EmExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            toggleItalic: function() {
                return enhancedToggleMark(type);
            },
            isItalicActive: function() {
                return isMarkActive(type);
            },
            isItalicDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return em_extension_isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-i": em_extension_convertCommand(enhancedToggleMark(type, false))
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            markInputRule({
                regexp: regexpItalic,
                type: type
            })
        ];
    };
    em_extension_createClass(EmExtension, [
        {
            key: "name",
            get: function get() {
                return "em";
            }
        }
    ]);
    return EmExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/font-extension/index.js






var font_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
/**
 * 判断选区中是否存在可以应用markType的节点
 * @param doc doc文档
 * @param ranges 选区
 * @param type markType类型
 */ var font_extension_isExistAllowsMarkType = function(doc, ranges, type) {
    var _loop = function(i) {
        var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function(node) {
            if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
            return !can;
        });
        if (can) return {
            v: true
        };
    };
    for(var i = 0; i < ranges.length; i++){
        var _ret = _loop(i);
        if (font_extension_typeof(_ret) === "object") return _ret.v;
    }
    return false;
};
/**
 * 添加新的mark类型
 * @param type mark类型
 * @param attrs mark属性
 * @param enhance
 */ var font_extension_addMarkType = function(type, attrs, enhance) {
    return function(state, dispatch) {
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, ranges = _state_selection.ranges;
        if (empty && !$cursor || !font_extension_isExistAllowsMarkType(state.doc, ranges, type)) {
            return false;
        }
        // 是否为空光标
        if ($cursor) {
            // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
            var tr = state.tr;
            tr.addStoredMark(type.create(attrs));
            if (enhance) {
                tr = enhance(tr);
            }
            dispatch(tr);
        } else {
            var has = false;
            var tr1 = state.tr;
            for(var i = 0; !has && i < ranges.length; i++){
                var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
                has = state.doc.rangeHasMark($from.pos, $to.pos, type);
            }
            for(var i1 = 0; i1 < ranges.length; i1++){
                var _ranges_i1 = ranges[i1], $from1 = _ranges_i1.$from, $to1 = _ranges_i1.$to;
                // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
                if (has) tr1.removeMark($from1.pos, $to1.pos, type);
                tr1.addMark($from1.pos, $to1.pos, type.create(attrs));
            }
            dispatch(tr1);
        }
        return true;
    };
};
/*
 * 是否允许当前选区设置字体大小
 * @param state 当前编辑器的 EditState
 * @returns {boolean} 允许设置返回 true，否则返回 false
 */ function canSetFontSize(state) {
    var selection = state.selection, tr = state.tr, schema = state.schema;
    var _schema_nodes = schema.nodes, paragraph = _schema_nodes.paragraph, table = _schema_nodes.table, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header, table_row = _schema_nodes.table_row, collapse = _schema_nodes.collapse, collapse_content = _schema_nodes.collapse_content, text = _schema_nodes.text, hard_break = _schema_nodes.hard_break;
    var bool = true;
    // 处于 CellSelection 时可能有多个 range
    selection.ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        tr.doc.nodesBetween(from, to, function(node) {
            if (node.type !== paragraph && node.type !== table && node.type !== table_cell && node.type !== table_header && node.type !== table_row && node.type !== collapse && node.type !== collapse_content && node.type !== hard_break && node.type !== text) {
                bool = false;
            }
        });
    });
    return bool;
}

var findFontSizeEmpty = function(state, defaultSize) {
    var _selection_$cursor;
    var schema = state.schema, selection = state.selection, tr = state.tr;
    var font = schema.marks.font;
    // 选区为空的情况
    var storedMarks = tr.storedMarks || state.storedMarks || ((_selection_$cursor = selection.$cursor) === null || _selection_$cursor === void 0 ? void 0 : _selection_$cursor.marks()) || [];
    var sm = storedMarks.find(function(m) {
        return m.type === font;
    });
    return sm ? sm.attrs.dataSize : defaultSize;
};
var findFontSizeRange = function(state, defaultSize) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var text = schema.nodes.text;
    var font = schema.marks.font;
    var ranges = selection.ranges;
    var lastFontSize = null;
    var retFlag = false;
    ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        // 如果选中的文本包含多个字号格式，则留空展示
        doc.nodesBetween(from, to, function(node, pos, parent, index) {
            if (retFlag) return;
            if (node.type !== text) return;
            var findMark = node.marks.find(function(mark) {
                return mark.type === font;
            });
            if (!findMark) {
                if (lastFontSize && lastFontSize !== defaultSize) {
                    lastFontSize = null;
                    retFlag = true;
                    return;
                }
                lastFontSize = defaultSize;
                return;
            }
            var fontSize = findMark.attrs.dataSize || defaultSize;
            if (index === 0) {
                lastFontSize = fontSize;
                return;
            }
            if (lastFontSize && lastFontSize !== fontSize) {
                lastFontSize = null;
                retFlag = true;
                return;
            }
            lastFontSize = fontSize;
        });
    });
    return lastFontSize;
};
// 获取菜单栏字号下拉列表激活态真实字号
var findActiveFontSize = function(state, defaultSize) {
    var selection = state.selection;
    var empty = selection.empty;
    // 选区为空的情况
    if (empty) return findFontSizeEmpty(state, defaultSize);
    // 选区为范围的情况
    return findFontSizeRange(state, defaultSize);
};
/**
 * 获取当前选区设置的字体
 */ var getFontSize = function() {
    var defaultSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
    return function(state) {
        return findActiveFontSize(state, defaultSize);
    };
};

function font_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function font_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function font_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function font_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) font_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) font_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function font_extension_getPrototypeOf(o) {
    font_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return font_extension_getPrototypeOf(o);
}
function font_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) font_extension_setPrototypeOf(subClass, superClass);
}
function font_extension_possibleConstructorReturn(self, call) {
    if (call && (font_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return font_extension_assertThisInitialized(self);
}
function font_extension_setPrototypeOf(o, p) {
    font_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return font_extension_setPrototypeOf(o, p);
}
var font_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function font_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function font_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = font_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = font_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = font_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return font_extension_possibleConstructorReturn(this, result);
    };
}
var FontExtension = /*#__PURE__*/ function(MarkExtension) {
    font_extension_inherits(FontExtension, MarkExtension);
    var _super = font_extension_createSuper(FontExtension);
    function FontExtension() {
        font_extension_classCallCheck(this, FontExtension);
        return _super.apply(this, arguments);
    }
    var _proto = FontExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            getSize: function() {
                return getFontSize();
            },
            setSize: function(font) {
                return font_extension_addMarkType(type, {
                    dataSize: font
                });
            },
            isDisabled: function() {
                return function(state) {
                    return !canSetFontSize(state);
                };
            }
        };
    };
    font_extension_createClass(FontExtension, [
        {
            key: "name",
            get: function get() {
                return "font";
            }
        }
    ]);
    return FontExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/strike-extension/index.js






/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 中划线
var regexpStrike = /(?:~~)([^]+)(?:~~)\s$/;
var regexpStrikeFullwidth = /(?:～～)([^]+)(?:～～)\s$/;

var strike_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var strike_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(strike_extension_ExtensionType || (strike_extension_ExtensionType = {}));

var strike_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var strike_extension_isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : strike_extension_typeof(value)) === type;
    };
};
var strike_extension_isFunction = strike_extension_isOfType("function");

var strike_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var strike_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return strike_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var strike_extension_isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!strike_extension_findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var strike_extension_enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = Object(dist_commands["toggleMark"])(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};

/**
 * 通用配置
 */ var strike_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var strike_extension_isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};
var strike_extension_markInputRule = function(param) {
    var regexp = param.regexp, type = param.type, getAttrs = param.getAttrs;
    return new prosemirror_inputrules_dist["a" /* InputRule */](regexp, function(state, match, start, end) {
        // TODO:只对选中区域设置mark，没有将整个node节点设置
        var tr = state.tr;
        // @ts-ignore
        var attrs = strike_extension_isFunction(getAttrs) ? getAttrs(match) : getAttrs;
        var markEnd = end;
        if (match[1]) {
            var startSpaces = match[0].search(/\S/);
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + match[1].length;
        }
        return tr.addMark(start, markEnd, type.create(attrs)).removeStoredMark(type);
    });
};

function strike_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function strike_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function strike_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function strike_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) strike_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) strike_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function strike_extension_getPrototypeOf(o) {
    strike_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return strike_extension_getPrototypeOf(o);
}
function strike_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) strike_extension_setPrototypeOf(subClass, superClass);
}
function strike_extension_possibleConstructorReturn(self, call) {
    if (call && (strike_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return strike_extension_assertThisInitialized(self);
}
function strike_extension_setPrototypeOf(o, p) {
    strike_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return strike_extension_setPrototypeOf(o, p);
}
var strike_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function strike_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function strike_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = strike_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = strike_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = strike_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return strike_extension_possibleConstructorReturn(this, result);
    };
}
var StrikethroughExtension = /*#__PURE__*/ function(MarkExtension) {
    strike_extension_inherits(StrikethroughExtension, MarkExtension);
    var _super = strike_extension_createSuper(StrikethroughExtension);
    function StrikethroughExtension() {
        strike_extension_classCallCheck(this, StrikethroughExtension);
        return _super.apply(this, arguments);
    }
    var _proto = StrikethroughExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            toggleStrikethrough: function() {
                return strike_extension_enhancedToggleMark(type);
            },
            isStrikethroughActive: function() {
                return strike_extension_isMarkActive(type);
            },
            isStrikethroughDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return strike_extension_isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-Shift-s": strike_extension_convertCommand(strike_extension_enhancedToggleMark(type, false))
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            strike_extension_markInputRule({
                regexp: regexpStrike,
                type: type
            }),
            strike_extension_markInputRule({
                regexp: regexpStrikeFullwidth,
                type: type
            })
        ];
    };
    strike_extension_createClass(StrikethroughExtension, [
        {
            key: "name",
            get: function get() {
                return "strikethrough";
            }
        }
    ]);
    return StrikethroughExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/strong-extension/index.js






/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 粗体
var regexpBold = /(?:\*\*)([^]+)(?:\*\*)\s$/;
// eslint-disable-next-line no-useless-escape
var regexpBoldFullwidth = /(?:\＊\＊)([^]+)(?:\＊\＊)\s$/;

var strong_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var strong_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(strong_extension_ExtensionType || (strong_extension_ExtensionType = {}));

var strong_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var strong_extension_isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : strong_extension_typeof(value)) === type;
    };
};
var strong_extension_isFunction = strong_extension_isOfType("function");

var strong_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var strong_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return strong_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var strong_extension_isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!strong_extension_findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var strong_extension_enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = Object(dist_commands["toggleMark"])(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};

/**
 * 通用配置
 */ var strong_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var strong_extension_isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};
var strong_extension_markInputRule = function(param) {
    var regexp = param.regexp, type = param.type, getAttrs = param.getAttrs;
    return new prosemirror_inputrules_dist["a" /* InputRule */](regexp, function(state, match, start, end) {
        // TODO:只对选中区域设置mark，没有将整个node节点设置
        var tr = state.tr;
        // @ts-ignore
        var attrs = strong_extension_isFunction(getAttrs) ? getAttrs(match) : getAttrs;
        var markEnd = end;
        if (match[1]) {
            var startSpaces = match[0].search(/\S/);
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + match[1].length;
        }
        return tr.addMark(start, markEnd, type.create(attrs)).removeStoredMark(type);
    });
};

function strong_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function strong_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function strong_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function strong_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) strong_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) strong_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function strong_extension_getPrototypeOf(o) {
    strong_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return strong_extension_getPrototypeOf(o);
}
function strong_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) strong_extension_setPrototypeOf(subClass, superClass);
}
function strong_extension_possibleConstructorReturn(self, call) {
    if (call && (strong_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return strong_extension_assertThisInitialized(self);
}
function strong_extension_setPrototypeOf(o, p) {
    strong_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return strong_extension_setPrototypeOf(o, p);
}
var strong_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function strong_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function strong_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = strong_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = strong_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = strong_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return strong_extension_possibleConstructorReturn(this, result);
    };
}
var StrongExtension = /*#__PURE__*/ function(MarkExtension) {
    strong_extension_inherits(StrongExtension, MarkExtension);
    var _super = strong_extension_createSuper(StrongExtension);
    function StrongExtension() {
        strong_extension_classCallCheck(this, StrongExtension);
        return _super.apply(this, arguments);
    }
    var _proto = StrongExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            toggleStrong: function() {
                return strong_extension_enhancedToggleMark(type);
            },
            isStrongActive: function() {
                return strong_extension_isMarkActive(type);
            },
            isStrongDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return strong_extension_isInNodeType(schema.nodes.code_block)(selection) || strong_extension_isInNodeType(schema.nodes.heading)(selection);
                };
            }
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-b": strong_extension_convertCommand(strong_extension_enhancedToggleMark(type, false))
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            strong_extension_markInputRule({
                regexp: regexpBold,
                type: type
            }),
            strong_extension_markInputRule({
                regexp: regexpBoldFullwidth,
                type: type
            })
        ];
    };
    strong_extension_createClass(StrongExtension, [
        {
            key: "name",
            get: function get() {
                return "strong";
            }
        }
    ]);
    return StrongExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/underline-extension/index.js






var underline_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var underline_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(underline_extension_ExtensionType || (underline_extension_ExtensionType = {}));

var underline_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var underline_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return underline_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var underline_extension_isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!underline_extension_findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var underline_extension_enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = Object(dist_commands["toggleMark"])(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};

/**
 * 通用配置
 */ var underline_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var underline_extension_isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};

function underline_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function underline_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function underline_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function underline_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) underline_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) underline_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function underline_extension_getPrototypeOf(o) {
    underline_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return underline_extension_getPrototypeOf(o);
}
function underline_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) underline_extension_setPrototypeOf(subClass, superClass);
}
function underline_extension_possibleConstructorReturn(self, call) {
    if (call && (underline_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return underline_extension_assertThisInitialized(self);
}
function underline_extension_setPrototypeOf(o, p) {
    underline_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return underline_extension_setPrototypeOf(o, p);
}
var underline_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function underline_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function underline_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = underline_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = underline_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = underline_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return underline_extension_possibleConstructorReturn(this, result);
    };
}
var UnderlineExtension = /*#__PURE__*/ function(MarkExtension) {
    underline_extension_inherits(UnderlineExtension, MarkExtension);
    var _super = underline_extension_createSuper(UnderlineExtension);
    function UnderlineExtension() {
        underline_extension_classCallCheck(this, UnderlineExtension);
        return _super.apply(this, arguments);
    }
    var _proto = UnderlineExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            toggleUnderline: function() {
                return underline_extension_enhancedToggleMark(type);
            },
            isUnderlineActive: function() {
                return underline_extension_isMarkActive(type);
            },
            isUnderlineDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return underline_extension_isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-u": underline_extension_convertCommand(underline_extension_enhancedToggleMark(type, false))
        };
    };
    underline_extension_createClass(UnderlineExtension, [
        {
            key: "name",
            get: function get() {
                return "underline";
            }
        }
    ]);
    return UnderlineExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/bullet-list-extension/index.js









var bullet_list_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var bullet_list_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return bullet_list_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var bullet_list_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function bullet_list_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bullet_list_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function bullet_list_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bullet_list_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function bullet_list_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bullet_list_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bullet_list_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var bullet_list_extension_listTypes = [
    "bullet_list",
    "ordered_list",
    "task_list"
];
var bullet_list_extension_itemTypes = [
    "list_item",
    "task_item"
];
function bullet_list_extension_doWrapInList(tr, range, wrappers, joinBefore, listType, isSelectRange) {
    var content = dist["Fragment"].empty;
    for(var i = wrappers.length - 1; i >= 0; i--){
        // 新增列表时如果遇到需要被序列为列表的内容有缩进的情况 需要把缩进属性添加到列表上并去除列表序列内容的缩进
        var attrs = null;
        if (!isSelectRange && wrappers[i].type === listType) {
            attrs = {
                indent: range.$from.parent.attrs.indent
            };
        }
        content = dist["Fragment"].from(wrappers[i].type.create(attrs || wrappers[i].attrs, content));
    }
    tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new dist["Slice"](content, 0, 0), wrappers.length, true));
    var found = 0;
    for(var i1 = 0; i1 < wrappers.length; i1++){
        if (wrappers[i1].type === listType) found = i1 + 1;
    }
    var splitDepth = wrappers.length - found;
    var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    var parent = range.parent;
    var childNodes = [];
    for(var i2 = range.startIndex, e = range.endIndex, first = true; i2 < e; i2++, first = false){
        var childNode = parent.child(i2);
        childNodes.push(childNode);
        if (!first && Object(prosemirror_transform_dist["canSplit"])(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i2).nodeSize;
    }
    // 去除列表序列内容的缩进
    tr.doc.nodesBetween(range.start, /**
     * range 的 start和end信息只能包含序列内容的范围 列表的结构如下 子节点length*2代表li标签的范围， +2代表外层ul/ol标签的范围
     * 三者相加之后才可以完整包含整个列表的范围
     * <ol>
     *    <li>序列内容</li>
     *    ...
     * </ol>
     */ range.end + childNodes.length * 2 + 2, function(node, pos) {
        if (childNodes.includes(node) && node.attrs.indent !== 0) {
            tr.setNodeMarkup(pos, null, bullet_list_extension_objectSpreadProps(bullet_list_extension_objectSpread({}, node.attrs), {
                indent: 0
            }));
        }
    });
    return tr;
}
function bullet_list_extension_liftToOuterList(tr, itemType, range) {
    var transaction = tr;
    var end = range.end;
    var endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](end - 1, endOfList, end, endOfList, new dist["Slice"](dist["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new dist["NodeRange"](transaction.doc.resolve(range.$from.pos), transaction.doc.resolve(endOfList), range.depth);
    }
    return transaction.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range));
}
function bullet_list_extension_liftOutOfList(tr, range) {
    var transaction = tr;
    var list = range.parent;
    // Merge the list items into a single big item
    for(var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        transaction.delete(pos - 1, pos + 1);
    }
    var $start = transaction.doc.resolve(range.start);
    var item = $start.nodeAfter;
    var atStart = range.startIndex === 0;
    var atEnd = range.endIndex === list.childCount;
    var parent = $start.node(-1);
    var indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list)))) {
        return false;
    }
    var start = $start.pos;
    var end = start + item.nodeSize;
    // 单独处理 data-diff-id 问题，后半段的 list 认为是新的 list，data-diff-id 重新生成
    // 详见 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60669246
    var newList = list.copy(dist["Fragment"].empty);
    newList.attrs = bullet_list_extension_objectSpread({}, newList.attrs);
    newList.attrs.dataDiffId = "ct-diff-id-".concat(esm_browser_v4());
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new dist["Slice"]((atStart ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty))).append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(newList)), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    return transaction;
}
// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function bullet_list_extension_wrapInList(listType, attrs) {
    return function(tr, selRange) {
        var $to = selRange.$to;
        var $from = selRange.$from;
        // 根据 schema ，list_item 里面必须是 block 节点 如果 $from.parent 不是 block 先矫正 $from
        if (!$from.parent.isBlock) {
            var parentBlockNode = bullet_list_extension_findParentNode(function(node) {
                return node.type.isBlock;
            })(selRange);
            $from = tr.doc.resolve(parentBlockNode.pos);
        }
        var transaction = tr;
        var range = $from.blockRange($to);
        // 光标（gaocursor）在块级元素前后时，需要设置 range 为该块元素，否则会无法设置列表
        if (bullet_list_extension_instanceof(selRange, GapcursorSelection["a" /* GapCursor */])) {
            if (selRange.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterNode && $from.nodeBefore) {
                range = new dist["NodeRange"](tr.doc.resolve($from.pos - $from.nodeBefore.nodeSize), $from, $from.depth);
            }
            if (selRange.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeNode && $from.nodeAfter) {
                range = new dist["NodeRange"]($from, tr.doc.resolve($from.pos + $from.nodeAfter.nodeSize), $from.depth);
            }
        }
        var doJoin = false;
        var outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            var $insert = transaction.doc.resolve(range.start - 2);
            outerRange = new dist["NodeRange"]($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) {
                range = new dist["NodeRange"]($from, transaction.doc.resolve($to.end(range.depth)), range.depth);
            }
            doJoin = true;
        }
        var wrap = Object(prosemirror_transform_dist["findWrapping"])(outerRange, listType, attrs, range);
        if (!wrap) return false;
        var fromParent = $from.parent;
        var toParent = $to.parent;
        var isSelectRange = fromParent !== toParent || fromParent.type.name === "doc" && toParent.type.name === "doc";
        return bullet_list_extension_doWrapInList(transaction, range, wrap, doJoin, listType, isSelectRange);
    };
}
// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function bullet_list_extension_liftListItem(itemType) {
    return function(tr, selRange) {
        var transaction = tr;
        var $from = selRange.$from, $to = selRange.$to;
        var range = $from.blockRange($to, function(node) {
            return node.childCount && node.firstChild.type === itemType;
        });
        if (!range) return false;
        if ($from.node(range.depth - 1).type === itemType) {
            // Inside a parent list
            return bullet_list_extension_liftToOuterList(transaction, itemType, range);
        }
        // Outer list node
        return bullet_list_extension_liftOutOfList(transaction, range);
    };
}
function findListParentNode(selection) {
    // 找离当前光标最近的容器节点（不算 list_item 类型）
    var conatinerNode = bullet_list_extension_findParentNode(function(n) {
        return n.isBlock && !n.isTextblock && !bullet_list_extension_itemTypes.includes(n.type.name);
    })(selection);
    // 如果最近的容器节点是 list 类型，则返回该节点，否则返回 Null
    return conatinerNode && bullet_list_extension_listTypes.includes(conatinerNode.node.type.name) ? conatinerNode : null;
}

// import { liftListItem } from "prosemirror-schema-list";
var handleListClick = function(listType) {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item, bullet_list = _schema_nodes.bullet_list, ordered_list = _schema_nodes.ordered_list, task_list = _schema_nodes.task_list;
        var itemTypes = [
            list_item,
            task_item
        ];
        var listTypes = [
            bullet_list,
            ordered_list,
            task_list
        ];
        var transaction = tr;
        if (selection.forEachCell) {
            selection.ranges.forEach(function(originRange, i) {
                // 当前面的range增加列表后，range的位置发生改变，需要用 transaction.selection
                var _transaction_selection_ranges_i = transaction.selection.ranges[i], $from = _transaction_selection_ranges_i.$from, $to = _transaction_selection_ranges_i.$to;
                var range = $from.blockRange($to);
                if (!range) return false;
                var listNode = $from.parent.firstChild;
                // 当前不在任何列表中，新增列表
                if (!listNode || listNode.type !== listType) {
                    var newTr = bullet_list_extension_wrapInList(listType)(transaction, range);
                    if (!newTr) return false;
                    transaction = newTr;
                } else {
                    var trueSelection = prosemirror_state_dist["TextSelection"].create(transaction.doc, $from.pos + 2, $to.pos - 2);
                    var itemType = listType === task_list ? task_item : list_item;
                    var trueRange = trueSelection.$from.blockRange(trueSelection.$to, function(node) {
                        return node.childCount && node.firstChild.type === itemType;
                    });
                    if (!trueRange) return false;
                    // 选中的列表类型与当前的列表类型一致，提升列表
                    var newTr1 = bullet_list_extension_liftOutOfList(transaction, trueRange);
                    if (!newTr1) return false;
                    transaction = newTr1;
                }
            });
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        // 如果最近的容器节点是 list 类型，则是改变当前列表类型，否则是新增列表
        var listNodeInSelFrom = findListParentNode(selection);
        // 当前selection.from不在任何列表中，新增列表
        if (!listNodeInSelFrom) {
            transaction = bullet_list_extension_wrapInList(listType)(transaction, selection);
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        var listNodes = [];
        // 遍历选区，找到所有列表节点
        transaction.doc.nodesBetween(selection.from, selection.to, function(node, pos) {
            // 当前节点在选区内（list至少长度为4）
            if (listTypes.includes(node.type) && pos + 4 > listNodeInSelFrom.pos) {
                listNodes.push({
                    node: node,
                    pos: pos
                });
            }
        });
        listNodes.forEach(function(listNode) {
            var listNodePos = transaction.mapping.map(listNode.pos);
            // 提升列表时，只对当前选区内的列表节点进行操作
            var from = Math.max(listNodePos + 1, transaction.selection.from);
            var to = Math.min(listNode.node.nodeSize + listNodePos - 1, transaction.selection.to);
            // 选中的列表类型与当前的列表类型一致，提升列表
            var itemType = listType === task_list ? task_item : list_item;
            if (listNode.node.type === listType) {
                var newTr = bullet_list_extension_liftListItem(itemType)(transaction, {
                    $from: transaction.doc.resolve(from),
                    $to: transaction.doc.resolve(to)
                });
                if (newTr) {
                    transaction = newTr;
                    return;
                }
            }
            // 转换列表类型
            from = listNodePos;
            to = listNode.node.nodeSize + from;
            // 转换当前列表类型为选中的类型
            transaction.doc.nodesBetween(from, to, function(node, pos) {
                if (listTypes.includes(node.type) && node.type !== listType) {
                    // 当前节点在选区内（list至少长度为4）
                    if (pos + 4 > from) {
                        transaction = transaction.setNodeMarkup(pos, listType, node.attrs);
                    }
                } else if (itemTypes.includes(node.type) && node.type !== itemType) {
                    // 当前节点在选区内（listItem至少长度为2）
                    if (pos + 2 > from) {
                        transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
                    }
                }
            });
        });
        dispatch(transaction);
        return true;
    };
};

var isListActive = function(type) {
    return function() {
        return function(state) {
            var listNode = findListParentNode(state.selection);
            return listNode && listNode.node.type === type;
        };
    };
};

var bullet_list_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(bullet_list_extension_ExtensionType || (bullet_list_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var bullet_list_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var bullet_list_extension_isCommonDisabled = function() {
    return function(state) {
        return !bullet_list_extension_canInsertTypes(state);
    };
};

var bullet_list_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 无序列表
var regexpBulletList = /^[*-]\s$/;

function bullet_list_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var bullet_list_extension_css_248z = ".pm-body-wrapper ul,.ProseMirror ul{margin:8px 0;padding-left:24px}.pm-body-wrapper ul li[data-list-item-diff-id],.ProseMirror ul li[data-list-item-diff-id]{min-height:24px;font-size:14px;list-style:inherit}.pm-body-wrapper ul>h1,.pm-body-wrapper ul>h2,.pm-body-wrapper ul>h3,.pm-body-wrapper ul>h4,.pm-body-wrapper ul>h5,.pm-body-wrapper ul>h6,.pm-body-wrapper ul>p,.ProseMirror ul>h1,.ProseMirror ul>h2,.ProseMirror ul>h3,.ProseMirror ul>h4,.ProseMirror ul>h5,.ProseMirror ul>h6,.ProseMirror ul>p{margin:0}.pm-body-wrapper ul .ct-image,.ProseMirror ul .ct-image{vertical-align:top}.pm-body-wrapper ul hr,.ProseMirror ul hr{display:inline-block}.pm-body-wrapper .ct-item-level-1,.ProseMirror .ct-item-level-1{font-size:28px!important}.pm-body-wrapper .ct-item-level-2,.ProseMirror .ct-item-level-2{font-size:24px!important}.pm-body-wrapper .ct-item-level-3,.ProseMirror .ct-item-level-3{font-size:20px!important}.pm-body-wrapper .ct-item-level-4,.ProseMirror .ct-item-level-4{font-size:16px!important}.pm-body-wrapper .ct-item-level-5,.ProseMirror .ct-item-level-5{font-size:14px!important}.pm-body-wrapper .ct-item-level-6,.ProseMirror .ct-item-level-6{font-size:12px!important}ul .ct-item-level-1{margin-left:7px}ul .ct-item-level-2{margin-left:6px}ul .ct-item-level-3{margin-left:3px}ul .ct-item-level-4{margin-left:2px}ul .ct-item-level-6{margin-left:-1px}ul{list-style-type:disc}ul ul{list-style-type:square}ul ul ul{list-style-type:circle}ul ul ul ul{list-style-type:disc}ul ul ul ul ul{list-style-type:square}ul ul ul ul ul ul{list-style-type:circle}ul ul ul ul ul ul ul{list-style-type:disc}ul ul ul ul ul ul ul ul{list-style-type:square}ul ul ul ul ul ul ul ul ul{list-style-type:circle}";
bullet_list_extension_styleInject(bullet_list_extension_css_248z);

function bullet_list_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function bullet_list_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function bullet_list_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function bullet_list_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) bullet_list_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) bullet_list_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function bullet_list_extension_getPrototypeOf(o) {
    bullet_list_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return bullet_list_extension_getPrototypeOf(o);
}
function bullet_list_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) bullet_list_extension_setPrototypeOf(subClass, superClass);
}
function bullet_list_extension_possibleConstructorReturn(self, call) {
    if (call && (bullet_list_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return bullet_list_extension_assertThisInitialized(self);
}
function bullet_list_extension_setPrototypeOf(o, p) {
    bullet_list_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return bullet_list_extension_setPrototypeOf(o, p);
}
var bullet_list_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function bullet_list_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function bullet_list_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = bullet_list_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = bullet_list_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = bullet_list_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return bullet_list_extension_possibleConstructorReturn(this, result);
    };
}
var bullet_list_extension_BulletListExtension = /*#__PURE__*/ function(NodeExtension) {
    bullet_list_extension_inherits(BulletListExtension, NodeExtension);
    var _super = bullet_list_extension_createSuper(BulletListExtension);
    function BulletListExtension() {
        bullet_list_extension_classCallCheck(this, BulletListExtension);
        return _super.apply(this, arguments);
    }
    var _proto = BulletListExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            handleListClick: function() {
                return handleListClick(type);
            },
            isBulletListActive: isListActive(type),
            isBulletListDisabled: bullet_list_extension_isCommonDisabled
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-Shift-u": bullet_list_extension_convertCommand(handleListClick(type))
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type, getView = param.getView;
        return [
            new prosemirror_inputrules_dist["a" /* InputRule */](new RegExp(regexpBulletList), function(state, match, start, end) {
                var range = state.tr.doc.resolve(start).blockRange();
                var wrapping = range && Object(prosemirror_transform_dist["findWrapping"])(range, type);
                if (!wrapping) return null;
                var view = getView();
                var transaction = view.state.tr.deleteRange(start, end);
                transaction = bullet_list_extension_wrapInList(type)(transaction, transaction.selection);
                if (transaction) {
                    view.dispatch(transaction);
                    return view.state.tr; // 返回空tr表示已经处理inputRule
                }
                return null;
            })
        ];
    };
    bullet_list_extension_createClass(BulletListExtension, [
        {
            key: "name",
            get: function get() {
                return "bullet_list";
            }
        }
    ]);
    return BulletListExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__("40b6");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/heading-extension/index.js








function heading_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function heading_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return heading_extension_arrayLikeToArray(arr);
}
function heading_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function heading_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function heading_extension_toConsumableArray(arr) {
    return heading_extension_arrayWithoutHoles(arr) || heading_extension_iterableToArray(arr) || heading_extension_unsupportedIterableToArray(arr) || heading_extension_nonIterableSpread();
}
var heading_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function heading_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return heading_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return heading_extension_arrayLikeToArray(o, minLen);
}
var heading_extension_isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : heading_extension_typeof(value)) === type;
    };
};
var isNumber = heading_extension_isOfType("number");
var heading_extension_inRange = function(value, range) {
    var _Math, _Math1;
    if (!isNumber(value) || !Array.isArray(range)) {
        return false;
    }
    if (range.some(function(p) {
        return !isNumber(p);
    })) {
        return false;
    }
    return value <= (_Math = Math).max.apply(_Math, heading_extension_toConsumableArray(range)) && value >= (_Math1 = Math).min.apply(_Math1, heading_extension_toConsumableArray(range));
};

function heading_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function heading_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            heading_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function heading_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function heading_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        heading_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var setHeading = function(level) {
    browser_default()(isNumber(level), "标题应为number类型");
    browser_default()(heading_extension_inRange(level, [
        1,
        6
    ]), "标题仅支持1-6级标题");
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, heading = _schema_nodes.heading, paragraph = _schema_nodes.paragraph, text = _schema_nodes.text;
        var font = schema.marks.font;
        // 处于 CellSelection 时可能有多个 range
        selection.ranges.forEach(function(range) {
            var from = range.$from.pos;
            var to = range.$to.pos;
            tr.doc.nodesBetween(from, to, function(node, pos, parent) {
                // 清除已经设置的字体
                if (node.type === text && font) {
                    tr.removeMark(pos, pos + node.text.length, font);
                }
                if (node.type === paragraph || node.type === heading) {
                    // 设置标题时确保有id，避免影响目录跳转 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65679538
                    if (node.attrs.id) {
                        tr.setNodeMarkup(pos, heading, heading_extension_objectSpreadProps(heading_extension_objectSpread({}, node.attrs), {
                            level: level
                        }));
                    } else {
                        tr.setNodeMarkup(pos, heading, heading_extension_objectSpreadProps(heading_extension_objectSpread({}, node.attrs), {
                            level: level,
                            id: esm_browser_v4()
                        }));
                    }
                    if ((parent.type.name === "list_item" || parent.type.name === "task_item") && tr.doc.nodeAt(pos - 1)) {
                        tr.setNodeMarkup(pos - 1, null, heading_extension_objectSpreadProps(heading_extension_objectSpread({}, parent.attrs), {
                            level: level
                        }));
                    }
                }
            });
        });
        dispatch(tr.scrollIntoView());
        return true;
    };
};

function heading_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function heading_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            heading_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var getTextBlockType = function(state) {
    var selection = state.selection, tr = state.tr, schema = state.schema;
    var _schema_nodes = schema.nodes, paragraph = _schema_nodes.paragraph, heading = _schema_nodes.heading;
    var level = null;
    selection.ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        var keepLooking = true;
        tr.doc.nodesBetween(from, to, function(node) {
            if (!keepLooking) return false;
            if (node.type === paragraph) {
                keepLooking = false;
                level = 0;
            } else if (node.type === heading) {
                keepLooking = false;
                level = node.attrs.level;
            }
        });
    });
    return level;
};
/**
 * 获取当前光标节点选中的节点的属性（覆盖顺序为 子元素覆盖父元素）
 * @param state 模型状态
 */ var getNodeAttrs = function(state) {
    if (!state.selection.empty) return {};
    var _state_selection = state.selection, from = _state_selection.from, to = _state_selection.to;
    var result = {};
    state.tr.doc.nodesBetween(from, to, function(node) {
        result = heading_extension_objectSpread$1({}, result, node.attrs);
    });
    return result;
};

var heading_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function heading_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var heading_extension_css_248z = ".ct-heading{font-weight:700;margin:8px 0;color:#333;word-break:break-word;clear:both}h1.ct-heading,h2.ct-heading,h3.ct-heading,h4.ct-heading{padding:8px 0}h5.ct-heading,h6.ct-heading{padding:4px 0}h1.ct-heading{font-size:28px;line-height:36px;min-height:36px}h2.ct-heading{font-size:24px;line-height:32px;min-height:32px}h3.ct-heading{font-size:20px;line-height:28px;min-height:28px}h4.ct-heading{font-size:16px;line-height:24px;min-height:24px}h5.ct-heading{font-size:14px;line-height:22px;min-height:22px}h6.ct-heading{font-size:12px;line-height:20px;min-height:20px}";
heading_extension_styleInject(heading_extension_css_248z);

function heading_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function heading_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function heading_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function heading_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) heading_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) heading_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function heading_extension_getPrototypeOf(o) {
    heading_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return heading_extension_getPrototypeOf(o);
}
function heading_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) heading_extension_setPrototypeOf(subClass, superClass);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function heading_extension_possibleConstructorReturn(self, call) {
    if (call && (heading_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return heading_extension_assertThisInitialized(self);
}
function heading_extension_setPrototypeOf(o, p) {
    heading_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return heading_extension_setPrototypeOf(o, p);
}
var heading_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function heading_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function heading_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = heading_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = heading_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = heading_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return heading_extension_possibleConstructorReturn(this, result);
    };
}
var heading_extension_HeadingExtension = /*#__PURE__*/ function(NodeExtension) {
    heading_extension_inherits(HeadingExtension, NodeExtension);
    var _super = heading_extension_createSuper(HeadingExtension);
    function HeadingExtension() {
        heading_extension_classCallCheck(this, HeadingExtension);
        return _super.apply(this, arguments);
    }
    var _proto = HeadingExtension.prototype;
    _proto.commands = function commands() {
        return {
            setHeading: function(level) {
                return setHeading(level);
            },
            headingLevel: function() {
                return function(state) {
                    return getTextBlockType(state);
                };
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type, getState = param.getState;
        var _this_options;
        var levels = ((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.level) || [
            1,
            2,
            3,
            4,
            5,
            6
        ];
        return levels.map(function(level) {
            return Object(prosemirror_inputrules_dist["c" /* textblockTypeInputRule */])(new RegExp("^(([#＃]){1,".concat(level, "})\\s$")), type, function() {
                return _objectSpreadProps$1(_objectSpread$2({}, getNodeAttrs(getState())), {
                    level: level,
                    id: esm_browser_v4()
                });
            });
        });
    };
    _proto.keys = function keys() {
        var _this_options;
        var levels = ((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.level) || [
            1,
            2,
            3,
            4,
            5,
            6
        ];
        var keys = {};
        levels.forEach(function(level) {
            keys["Mod-".concat(level)] = heading_extension_convertCommand(setHeading(level));
        });
        return keys;
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        if (!~html.indexOf("ct-heading")) return html;
        var createDom = document.createElement("div");
        createDom.innerHTML = html;
        var heading = createDom.querySelectorAll(".ct-heading");
        heading.forEach(function(h) {
            if (h.getAttribute("id")) h.setAttribute("id", esm_browser_v4());
        });
        return createDom.innerHTML;
    };
    heading_extension_createClass(HeadingExtension, [
        {
            key: "name",
            get: function get() {
                return "heading";
            }
        }
    ]);
    return HeadingExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@it/parker/node_modules/classnames/index.js
var classnames = __webpack_require__("a91e");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/link-extension/index.js












var link_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(link_extension_ExtensionType || (link_extension_ExtensionType = {}));

/**
 * 统一样式前缀
 */ var link_extension_CLASSNAME_PREFIX = "ct";

var link_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : link_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function link_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function link_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function link_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            link_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var link_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var link_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return link_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var isNodeSelection = function(selection) {
    return link_extension_instanceof(selection, prosemirror_state_dist["NodeSelection"]);
};
var equalNodeType = function(nodeType, node) {
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var findSelectedNodeOfType = function(nodeType) {
    return function(selection) {
        if (isNodeSelection(selection)) {
            var node = selection.node, $from = selection.$from;
            if (equalNodeType(nodeType, node)) {
                return {
                    node: node,
                    pos: $from.pos,
                    depth: $from.depth
                };
            }
        }
    };
};
// 类型是否可以插入富文本
var link_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};
/**
 * 获取选区的链接
 * @param state EditState
 * @param dispatch dispatch
 * @param outSelection 外部选区，可选
 * @returns 链接对象 { title, href, autoUpdate }
 */ function getLinkAttrs(state, dispatch, outSelection) {
    if (!state) {
        return null;
    }
    var attrs = {
        title: null,
        href: null,
        autoUpdate: false
    };
    var tr = state.tr, doc = state.doc, schema = state.schema;
    var nodeType = schema.nodes.link;
    var selection = outSelection || state.selection;
    var $from = selection.$from, from = selection.from, to = selection.to;
    var linkNode = null;
    var linkNodeFrom = null;
    tr.doc.nodesBetween(from, to, function(node, pos) {
        if (nodeType === node.type) {
            linkNode = node;
            linkNodeFrom = pos;
            attrs = link_extension_objectSpread({}, node.attrs);
        }
    });
    if (linkNode) {
        if (dispatch) {
            dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, linkNodeFrom, linkNodeFrom + linkNode.nodeSize)));
        }
    } else if (attrs.href) {
        var textNode = $from.node();
        if (dispatch) {
            dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, from, from + textNode.nodeSize)));
        }
        attrs.title = textNode.textContent;
    } else {
        attrs.title = doc.textBetween(from, to);
    }
    return attrs;
}

/**
 * 通用配置
 */ var link_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var isNodeActive = function(type) {
    return function(// 与 lvzhe 确认过参数类型，仅存在 2 重可能：
    // - state
    // - state, dispatch, view
    state, dispatch, view) {
        var selection = state.selection;
        var predicate = function(node) {
            return node.type === type;
        };
        var _findSelectedNodeOfType;
        var parent = (_findSelectedNodeOfType = findSelectedNodeOfType(type)(selection)) !== null && _findSelectedNodeOfType !== void 0 ? _findSelectedNodeOfType : link_extension_findParentNode(predicate)(selection);
        return !!parent;
    };
};
/**
 * DOMEvent 绑定时的纯函数，防止注册的方法污染全局
 * demo @see parker/src/citadel-pc/extensions/node/link-extension/index.ts
 *
 * @param {NodeType} type
 * @param {THandleDOMEvent} fn handleDOMEvent 中本应该注册的事件
 * @returns
 */ function bindExtensionDOMEvent(type, fn) {
    return function(view, event) {
        // const eventPos = view.posAtCoords({
        //   left: event.clientX,
        //   top: event.clientY,
        // });
        var eventPos = view.posAtDOM(event.target, 0);
        var $mouse = view.state.doc.resolve(eventPos);
        if (!$mouse) {
            return;
        }
        var isTriggerTargetNode = Array.from({
            length: $mouse.depth + 1
        }).some(function(_, i) {
            return $mouse.node(i).type === type;
        });
        if (isTriggerTargetNode) {
            var _fn;
            // eslint-disable-next-line prefer-rest-params
            return (_fn = fn).call.apply(_fn, [
                this
            ].concat(Array.prototype.slice.call(arguments), [
                eventPos
            ]));
        }
    };
}

function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
 * 取消链接
 * @returns {boolean} 是否取消成功
 */ function cancelLink() {
    return function(state, dispatch, view) {
        var tr = state.tr, schema = state.schema, selection = state.selection;
        var $from = selection.$from;
        var node = _instanceof$1(selection, prosemirror_state_dist["NodeSelection"]) ? selection.node : $from.parent;
        if (node.type.name !== "link") {
            return false;
        }
        var from = $from.start($from.depth);
        var to = from + node.nodeSize - 1;
        var text = node.textContent;
        if (_instanceof$1(selection, prosemirror_state_dist["NodeSelection"])) {
            var dom = view.nodeDOM(from);
            text = dom.textContent;
        }
        if (_instanceof$1(selection, prosemirror_state_dist["NodeSelection"])) {
            dispatch(tr.replaceSelectionWith(schema.text(node.attrs.title)));
        } else {
            dispatch(tr.replaceWith(from - 1, to, schema.text(text)));
        }
        view.focus();
        return true;
    };
}

function _instanceof$2(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
 * 新增链接
 * @param attrs 链接所需属性
 * @returns
 */ function link_extension_addLink(attrs) {
    return function(state, dispatch) {
        var tr = state.tr, schema = state.schema;
        var nodeType = schema.nodes.link;
        var selection = state.selection;
        // eslint-disable-next-line prefer-const
        var $cursor = selection.$cursor, $from = selection.$from, $to = selection.$to, from = selection.from, to = selection.to;
        if (_instanceof$2(selection, gap_cursor_extension["a" /* GapCursor */])) {
            $cursor = $from;
        }
        var text = attrs.title || attrs.href;
        if ($cursor) {
            var node = $cursor.nodeBefore || $cursor.nodeAfter || {
                marks: []
            };
            var marks = node.marks;
            var plus = 1;
            if (_instanceof$2(selection, gap_cursor_extension["a" /* GapCursor */])) {
                plus = 2;
            }
            tr.insert($cursor.pos, nodeType.create(attrs, schema.text(text), marks));
            if (!attrs.autoUpdate) {
                // 普通节点(Text Selection)，选区定位到文字后方
                tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, $cursor.pos + text.length + plus));
            } else {
                // 自动更新节点(Node Selection)，选区定位到节点后方
                tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, tr.selection.to + 1, tr.selection.to + 1));
            }
            dispatch(tr.scrollIntoView());
        } else {
            var node1 = $from.nodeAfter || $to.nodeBefore || $from.nodeBefore || $to.nodeAfter || {
                marks: []
            };
            var marks1 = node1.marks;
            var plus1 = 1;
            tr.replaceWith(from - ($from.nodeBefore ? 0 : 1), to, nodeType.create(attrs, schema.text(text), marks1));
            if (!attrs.autoUpdate) {
                tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, from + text.length + plus1));
            } else {
                tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, tr.selection.to + 1, tr.selection.to + 1));
            }
            dispatch(tr.scrollIntoView());
        }
    };
}

var link_extension_handleBackspace = function() {
    return function(state, dispatch) {
        var _selection_$anchor;
        var selection = state.selection, tr = state.tr;
        var nodeBefore = selection === null || selection === void 0 ? void 0 : (_selection_$anchor = selection.$anchor) === null || _selection_$anchor === void 0 ? void 0 : _selection_$anchor.nodeBefore;
        var from = selection.from, to = selection.to, $from = selection.$from, $to = selection.$to, $head = selection.$head;
        var isRangeSelection = from !== to;
        // 如果在链接节点之后执行删除操作，且当前链接为 node 类型，则选中链接
        if (nodeBefore && nodeBefore.type === state.schema.nodes.link && nodeBefore.attrs.autoUpdate && !isRangeSelection) {
            dispatch(tr.setSelection(prosemirror_state_dist["NodeSelection"].create(tr.doc, (selection === null || selection === void 0 ? void 0 : selection.$anchor.pos) - nodeBefore.nodeSize)));
            return true;
        }
        var fromNode = $from.node();
        var toNode = $to.node();
        if (fromNode.type === state.schema.nodes.link && fromNode === toNode && to - from === fromNode.content.size) {
            dispatch(tr.delete(from - 1, to + 1));
            return true;
        }
        // fix: 从右往左的TextSelection，选到link的内容中间，链接未删除
        // ONES: #64640820
        if (fromNode.type === state.schema.nodes.link && fromNode.attrs.autoUpdate && $head.parent === fromNode) {
            dispatch(tr.delete(from - fromNode.content.size - 1, to));
            return true;
        }
        // 在 link 内部末尾
        var isAnchorBeforeLinkEnd = $to.parent.type === state.schema.nodes.link && !$to.nodeAfter;
        // 在 link 内部开头
        var isAnchorAfterLinkStart = $from.parent.type === state.schema.nodes.link && !$from.nodeBefore;
        // 在link内部的开头或结尾需要特殊处理，
        if (isAnchorBeforeLinkEnd || isAnchorAfterLinkStart) {
            if (selection.empty) {
                if (isAnchorBeforeLinkEnd) {
                    dispatch(tr.setSelection(prosemirror_state_dist["NodeSelection"].create(tr.doc, (selection === null || selection === void 0 ? void 0 : selection.$anchor.pos) - nodeBefore.nodeSize - 1)));
                    return true;
                }
            } else {
                var _to = !isAnchorBeforeLinkEnd ? to : to + 1;
                var _from = !isAnchorAfterLinkStart ? from : from - 1;
                dispatch(tr.delete(_from, _to));
                return true;
            }
        }
        return false;
    };
};

var link_extension_IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var link_extension_Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(link_extension_Keycodes || (link_extension_Keycodes = {}));

var link_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function link_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var link_extension_css_248z = ".ct-link{color:#1890ff;background:transparent;text-decoration:none;outline:none;cursor:pointer;padding:0 1px}.ct-link:hover{text-decoration:underline}.ct-link.ProseMirror-selectednode{background:#adf}";
link_extension_styleInject(link_extension_css_248z);

function link_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function link_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return link_extension_arrayLikeToArray(arr);
}
function link_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function link_extension_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                link_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                link_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function link_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function link_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function link_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function link_extension_toConsumableArray(arr) {
    return link_extension_arrayWithoutHoles(arr) || link_extension_iterableToArray(arr) || link_extension_unsupportedIterableToArray(arr) || link_extension_nonIterableSpread();
}
function link_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return link_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return link_extension_arrayLikeToArray(o, minLen);
}
var link_extension_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var CLASS_NAME = link_extension_classNamePrefix("link");
var AUTO_UPDATE_CLASS_NAME = "".concat(CLASS_NAME, " ").concat(CLASS_NAME, "-auto-update");
var link_extension_LinkNodeView = /*#__PURE__*/ function() {
    function LinkNodeView(node, view, getPos, provider) {
        var _this = this;
        link_extension_classCallCheck(this, LinkNodeView);
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.provider = provider;
        this.dom = document.createElement("a");
        this.handleClick = function(e) {
            e.preventDefault();
            if (_this.node.attrs.autoUpdate) {
                var _this_view = _this.view, dispatch = _this_view.dispatch, _this_view_state = _this_view.state, doc = _this_view_state.doc, tr = _this_view_state.tr;
                var newSelection = prosemirror_state_dist["NodeSelection"].create(doc, _this.getPos());
                dispatch(tr.setSelection(newSelection));
            }
        };
        this.destroy = function() {
            _this.dom.removeEventListener("click", _this.handleClick);
        };
        var _this1 = this;
        this.setTitle = /*#__PURE__*/ link_extension_asyncToGenerator(function() {
            var updateInnerText, href, _this_provider, _this_dom_firstChild, _this_dom_firstChild_classList, data, title, e;
            return link_extension_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updateInnerText = function(text) {
                            var _this_dom;
                            // 不能直接使用 innerHTML 赋值，有 xss 风险
                            _this1.dom.innerHTML = "";
                            var hackNode = document.createElement("span");
                            hackNode.classList.add("link-hack-node");
                            var titleTxt = document.createTextNode(text);
                            var fragment = document.createDocumentFragment();
                            fragment.append(hackNode);
                            fragment.append(titleTxt);
                            fragment.append(hackNode.cloneNode());
                            var fragmentList = [];
                            fragment.childNodes.forEach(function(n) {
                                fragmentList.push(n);
                            });
                            (_this_dom = _this1.dom).append.apply(_this_dom, link_extension_toConsumableArray(fragmentList));
                        };
                        href = _this1.node.attrs.href;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!((_this_provider = _this1.provider) === null || _this_provider === void 0 ? void 0 : _this_provider.getLinkTitle)) {
                            updateInnerText(_this1.node.attrs.title);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            _this1.provider.getLinkTitle(href)
                        ];
                    case 2:
                        data = _state.sent();
                        title = data || href;
                        if (title === _this1.dom.innerText && ((_this_dom_firstChild = _this1.dom.firstChild) === null || _this_dom_firstChild === void 0 ? void 0 : (_this_dom_firstChild_classList = _this_dom_firstChild.classList) === null || _this_dom_firstChild_classList === void 0 ? void 0 : _this_dom_firstChild_classList.contains("link-hack-node"))) {
                            return [
                                2
                            ];
                        }
                        updateInnerText(title);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        updateInnerText(_this1.node.attrs.title);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        var _node_attrs = node.attrs, href = _node_attrs.href, title = _node_attrs.title, autoUpdate = _node_attrs.autoUpdate;
        var attrs = {
            href: href,
            target: "_blank",
            rel: "noopener",
            /**
       * !autoUpdate 的链接，其内容托管在 contentDOM 内的 TextNode，innerText 无意义
       */ innerText: autoUpdate ? title : "",
            className: autoUpdate ? AUTO_UPDATE_CLASS_NAME : CLASS_NAME
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = document.createElement("a");
        this.dom.addEventListener("click", this.handleClick);
        Object.assign(this.dom, attrs);
        if (!autoUpdate) {
            this.contentDOM = this.dom;
        } else {
            this.setTitle();
        }
    }
    var _proto = LinkNodeView.prototype;
    _proto.ignoreMutation = function ignoreMutation() {
        return true;
    };
    return LinkNodeView;
}();

// url 正则
var URL_REG = /((?:https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g;
// 邮箱地址正则
var MAIL_REG = /((?:[a-zA-Z0-9_.-])+@(?:(?:[a-zA-Z0-9-])+\.)+(?:[a-zA-Z0-9]{2,4}))+/g;
// 重置正则表达式索引，重新从起始位置匹配
var resetRegExp = function() {
    URL_REG.lastIndex = 0;
    MAIL_REG.lastIndex = 0;
};
/**
 * 获取当前选择的 link 节点，如果未选择 link 节点或选择了多个节点则返回 null
 */ var findLinkNode = function(state) {
    var selection = state.selection, schema = state.schema;
    var link = schema.nodes.link;
    var assert = function(node) {
        return node.type === link;
    };
    if (!selection.empty) {
        var $from = selection.$from, $to = selection.$to;
        if ($from.parent !== $to.parent) {
            return null;
        }
    }
    var foundNode = null;
    var selected = findSelectedNodeOfType(link)(selection);
    if (selected) {
        foundNode = selected;
    } else {
        foundNode = link_extension_findParentNode(assert)(selection);
    }
    // if (
    //   foundNode &&
    //   selection.empty &&
    //   foundNode.pos + foundNode.node.nodeSize === selection.to + 1
    // ) {
    //   return null;
    // }
    return foundNode;
};
/**
 * 将指定节点中的链接和邮箱部分转换成 link 节点
 */ var parseNode = function(node, schema, parentNode, provider) {
    var _schema_nodes = schema.nodes, link = _schema_nodes.link, text = _schema_nodes.text;
    // 处理节点中的单个链接或文本字符串
    var transferNode = function transferNode(nodeToTransfer) {
        resetRegExp();
        var href = nodeToTransfer.textContent || "";
        var attrs = null;
        if (URL_REG.test(href)) {
            var _provider_canGetTitle;
            attrs = {
                href: href,
                title: href,
                autoUpdate: (provider === null || provider === void 0 ? void 0 : (_provider_canGetTitle = provider.canGetTitle) === null || _provider_canGetTitle === void 0 ? void 0 : _provider_canGetTitle.call(provider, href)) || false
            };
        } else if (MAIL_REG.test(href)) {
            attrs = {
                href: "mailto:".concat(href),
                title: href,
                autoUpdate: false
            };
        }
        // 理论上当parentNode为link的时候 textNode是不需要处理的，后续考虑在paste-extension这一层直接避免传入此时（递归的最后一次节点的父节点已经是叶子节点）的最后一次节点
        if (attrs && (parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) !== link) {
            return link.create(attrs, schema.text(href), nodeToTransfer.marks);
        }
        return nodeToTransfer;
    };
    if (node.type === text) {
        resetRegExp();
        var newNodeList = [];
        var textContent = node.textContent;
        var needTransferUrl = URL_REG.test(textContent);
        var needTransferMail = MAIL_REG.test(textContent);
        if (needTransferUrl || needTransferMail) {
            var splitReg = needTransferUrl ? URL_REG : MAIL_REG;
            // 将网址、邮箱格式的文本和其他格式文本分隔，并按顺序放在数组中
            var textArr = textContent.split(splitReg).filter(function(item) {
                return item !== "";
            });
            var nodeArr = textArr.map(function(innerText) {
                var newLinkNode = transferNode(schema.text(innerText));
                return newLinkNode;
            });
            newNodeList = newNodeList.concat(nodeArr);
            return newNodeList;
        }
        return node;
    }
    return node;
};
/**
 * 当前选区是否在 link 末尾
 */ var isInLinkEnd = function(view) {
    var state = view.state;
    var selection = state.selection;
    if (!selection.empty) {
        return false;
    }
    var foundNode = findLinkNode(state);
    return foundNode && foundNode.pos + foundNode.node.nodeSize === selection.to + 1;
};
/**
 * TODO: 替换 isInLinkEnd 方法到 isInLinkStartOrEnd
 */ var isInLinkStartOrEnd = function(state, from, to) {
    var $from = state.doc.resolve(from);
    var $to = state.doc.resolve(to);
    // 在 link 内部末尾
    var isAnchorBeforeLinkEnd = $to.parent.type === state.schema.nodes.link && !$to.nodeAfter;
    // 在 link 内部开头
    var isAnchorAfterLinkStart = $from.parent.type === state.schema.nodes.link && !$from.nodeBefore;
    // eslint-disable-next-line no-nested-ternary
    return isAnchorAfterLinkStart ? -1 : isAnchorBeforeLinkEnd ? 1 : 0;
};

function link_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function link_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function link_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function link_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function link_extension_slicedToArray(arr, i) {
    return link_extension_arrayWithHoles(arr) || link_extension_iterableToArrayLimit(arr, i) || link_extension_unsupportedIterableToArray$1(arr, i) || link_extension_nonIterableRest();
}
function link_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return link_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return link_extension_arrayLikeToArray$1(o, minLen);
}
var getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = link_extension_slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        Object(react_dom["render"])(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var link_extension_emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = react_dom_default.a.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

var link_extension_css_248z$1 = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
link_extension_styleInject(link_extension_css_248z$1);

function link_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof$3(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var SHOW = "show";
var HIDE = "hide";
var link_extension_Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        link_extension_classCallCheck$1(this, Popover);
        this.popoverState = HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(link_extension_classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === SHOW && !forceUpdate) {
            return;
        }
        if (!target || !_instanceof$3(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(link_extension_classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        Object(react_dom["render"])(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(link_extension_classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(HIDE);
    };
    _proto.destroy = function destroy() {
        link_extension_emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function link_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function link_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof$4(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function link_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            link_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var DEFAULT_HEIGHT = 34;
var DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var link_extension_PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        link_extension_classCallCheck$2(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = link_extension_objectSpread$1({}, DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !_instanceof$4(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new link_extension_Popover(link_extension_objectSpread$1({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var css_248z$2 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
link_extension_styleInject(css_248z$2);

function link_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function link_extension_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function link_extension_getPrototypeOf(o) {
    link_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return link_extension_getPrototypeOf(o);
}
function link_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) link_extension_setPrototypeOf(subClass, superClass);
}
function link_extension_possibleConstructorReturn(self, call) {
    if (call && (link_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return link_extension_assertThisInitialized(self);
}
function link_extension_setPrototypeOf(o, p) {
    link_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return link_extension_setPrototypeOf(o, p);
}
var link_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function link_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function link_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = link_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = link_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = link_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return link_extension_possibleConstructorReturn(this, result);
    };
}
var link_extension_Button = /*#__PURE__*/ function(Component) {
    link_extension_inherits(Button, Component);
    var _super = link_extension_createSuper(Button);
    function Button() {
        _classCallCheck$3(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = link_extension_classNamePrefix(prefix);
        var classes = link_extension_defineProperty$2({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ react_default.a.createElement("button", {
            disabled: disabled,
            className: classnames_default()(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(react["Component"]);

var css_248z$3 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
link_extension_styleInject(css_248z$3);

/* eslint-disable jsx-a11y/control-has-associated-label */ function link_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function link_extension_getPrototypeOf$1(o) {
    link_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return link_extension_getPrototypeOf$1(o);
}
function link_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) link_extension_setPrototypeOf$1(subClass, superClass);
}
function link_extension_possibleConstructorReturn$1(self, call) {
    if (call && (link_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return link_extension_assertThisInitialized$1(self);
}
function link_extension_setPrototypeOf$1(o, p) {
    link_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return link_extension_setPrototypeOf$1(o, p);
}
var link_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function link_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function link_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = link_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = link_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = link_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return link_extension_possibleConstructorReturn$1(this, result);
    };
}
var defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var link_extension_Modal = /*#__PURE__*/ function(Component) {
    link_extension_inherits$1(Modal, Component);
    var _super = link_extension_createSuper$1(Modal);
    function Modal() {
        _classCallCheck$4(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? "确定" : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? "取消" : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = link_extension_classNamePrefix(userPrefix);
        return /*#__PURE__*/ react_dom_default.a.createPortal(/*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ react_default.a.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ react_default.a.createElement(link_extension_Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ react_default.a.createElement(link_extension_Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(react["Component"]);
link_extension_Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var css_248z$4 = '.ct-checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-checkbox input{display:none}.ct-checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-checkbox input:checked+.checkbox-bg:after{content:" ";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
link_extension_styleInject(css_248z$4);

function _assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (link_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$2(self);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var link_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$2(this, result);
    };
}
var noop = function() {};
var link_extension_CheckBox = /*#__PURE__*/ function(Component) {
    _inherits$2(CheckBox, Component);
    var _super = _createSuper$2(CheckBox);
    function CheckBox() {
        _classCallCheck$5(this, CheckBox);
        return _super.apply(this, arguments);
    }
    var _proto = CheckBox.prototype;
    _proto.render = function render() {
        // 设置 onChange 的默认值，防止出现警告
        var _this_props = this.props, checked = _this_props.checked, onClick = _this_props.onClick, _this_props_onChange = _this_props.onChange, onChange = _this_props_onChange === void 0 ? noop : _this_props_onChange, children = _this_props.children;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: link_extension_classNamePrefix("checkbox"),
            onClick: onClick
        }, /*#__PURE__*/ react_default.a.createElement("input", {
            type: "checkbox",
            checked: checked,
            onChange: onChange
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "checkbox-bg"
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "checkbox-label"
        }, children));
    };
    return CheckBox;
}(react["Component"]);

var css_248z$5 = '.ct-icon-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-icon-item svg{margin:4px 0 0 4px}.ct-icon-item.close{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-icon-item.error{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E9%94%99%E8%AF%AF%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-296.000000%2C -544.000000)%22 fill%3D%22%23F05E50%22%3E            %3Cpath fill%3D%22%23F05E50%22 d%3D%22M304%2C544 C308.41824%2C544 312%2C547.58176 312%2C552 C312%2C556.41824 308.41824%2C560 304%2C560 C299.58176%2C560 296%2C556.41824 296%2C552 C296%2C547.58176 299.58176%2C544 304%2C544 Z M299.2%2C552 C299.2%2C552.667362 299.735663%2C553.2 300.396436%2C553.2 L307.603564%2C553.2 C308.256356%2C553.2 308.8%2C552.662742 308.8%2C552 C308.8%2C551.332638 308.264337%2C550.8 307.603564%2C550.8 L300.396436%2C550.8 C299.743644%2C550.8 299.2%2C551.337258 299.2%2C552 Z%22 id%3D%22tost-%E9%94%99%E8%AF%AF%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.success{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E6%88%90%E5%8A%9F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-222.000000%2C -544.000000)%22 fill%3D%22%2370B123%22%3E            %3Cpath fill%3D%22%2370B123%22 d%3D%22M228.93934%2C552.865274 L226.802094%2C550.728029 C226.3405%2C550.266435 225.576187%2C550.26192 225.107558%2C550.730549 C224.635662%2C551.202445 224.637801%2C551.957848 225.105038%2C552.425085 L228.079926%2C555.399974 C228.314894%2C555.634941 228.628301%2C555.751472 228.941218%2C555.747447 C229.252578%2C555.751485 229.564571%2C555.634156 229.802094%2C555.396633 L234.898303%2C550.300424 C235.359897%2C549.83883 235.364412%2C549.074517 234.895783%2C548.605887 C234.423887%2C548.133991 233.668484%2C548.13613 233.201247%2C548.603367 L228.93934%2C552.865274 Z M238%2C552 C238%2C553.451396 237.642365%2C554.789924 236.927083%2C556.015625 C236.211802%2C557.241326 235.241326%2C558.211802 234.015625%2C558.927083 C232.789924%2C559.642365 231.451396%2C560 230%2C560 C228.548604%2C560 227.210076%2C559.642365 225.984375%2C558.927083 C224.758674%2C558.211802 223.788198%2C557.241326 223.072917%2C556.015625 C222.357635%2C554.789924 222%2C553.451396 222%2C552 C222%2C550.548604 222.357635%2C549.210076 223.072917%2C547.984375 C223.788198%2C546.758674 224.758674%2C545.788198 225.984375%2C545.072917 C227.210076%2C544.357635 228.548604%2C544 230%2C544 C231.451396%2C544 232.789924%2C544.357635 234.015625%2C545.072917 C235.241326%2C545.788198 236.211802%2C546.758674 236.927083%2C547.984375 C237.642365%2C549.210076 238%2C550.548604 238%2C552 Z%22 id%3D%22tost-%E6%88%90%E5%8A%9F%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.edit{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E7%BC%96%E8%BE%91%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-164.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E7%BC%96%E8%BE%91%22 transform%3D%22translate(164.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M13%2C7 C13.2761424%2C7 13.5%2C7.22385763 13.5%2C7.5 C13.5%2C7.77614237 13.2761424%2C8 13%2C8 L8%2C8 L8%2C8 C7.44771525%2C8 7%2C8.44771525 7%2C9 L7%2C9 L7%2C18 C7%2C18.5522847 7.44771525%2C19 8%2C19 L17%2C19 C17.5522847%2C19 18%2C18.5522847 18%2C18 L18%2C18 L18%2C13 C18%2C12.7238576 18.2238576%2C12.5 18.5%2C12.5 C18.7761424%2C12.5 19%2C12.7238576 19%2C13 L19%2C11 L19%2C18 L19%2C18 C19%2C19.1045695 18.1045695%2C20 17%2C20 L8%2C20 L8%2C20 C6.8954305%2C20 6%2C19.1045695 6%2C18 L6%2C9 L6%2C9 C6%2C7.8954305 6.8954305%2C7 8%2C7 L8%2C7 L15%2C7 L13%2C7 Z M19.8535534%2C6.14644661 C20.0488155%2C6.34170876 20.0488155%2C6.65829124 19.8535534%2C6.85355339 L13.4895924%2C13.2175144 C13.2943302%2C13.4127766 12.9777477%2C13.4127766 12.7824856%2C13.2175144 C12.5872234%2C13.0222523 12.5872234%2C12.7056698 12.7824856%2C12.5104076 L19.1464466%2C6.14644661 C19.3417088%2C5.95118446 19.6582912%2C5.95118446 19.8535534%2C6.14644661 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.link{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(-908.000000%2C -565.000000)%22%3E      %3Cg transform%3D%22translate(8.500000%2C 565.000000)%22%3E        %3Cg transform%3D%22translate(0.500000%2C 0.000000)%22 fill%3D%22%23666666%22%3E          %3Cg transform%3D%22translate(899.000000%2C 0.000000)%22%3E            %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L13.4302151%2C11.1475865 L12.7191158%2C11.8586857 L13.4302151%2C12.5697849 C14.2156736%2C13.3552435 14.2156736%2C14.6287234 13.4302151%2C15.4141819 L13.2808842%2C15.5635128 L12.9253346%2C15.2079632 L13.9919834%2C16.274612 L16.1252811%2C14.1413143 L15.4141819%2C13.4302151 L17.4052599%2C11.439137 C18.1907184%2C10.6536785 18.1907184%2C9.38019862 17.4052599%2C8.59474009 C16.6198014%2C7.80928156 15.3463215%2C7.80928156 14.560863%2C8.59474009 L12.7191158%2C10.4364872 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.visitLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8E%BB%E6%9F%A5%E7%9C%8B%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-587.000000%2C -162.000000)%22%3E            %3Cg id%3D%22Group-8%22 transform%3D%22translate(62.000000%2C 128.000000)%22%3E                %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 34.000000)%22%3E%3C%2Fg%3E                %3Cg id%3D%22Group-2%22 transform%3D%22translate(0.000000%2C 34.000000)%22 fill%3D%22%23666666%22%3E                    %3Cg id%3D%22%E5%8E%BB%E6%9F%A5%E7%9C%8B%22 transform%3D%22translate(525.000000%2C 0.000000)%22%3E                        %3Cpath d%3D%22M6.67363116%2C16 L7.80156483%2C16 C8.83909243%2C17.7939653 10.7785899%2C19.0009766 13%2C19.0009766 C16.3142478%2C19.0009766 19.0009766%2C16.3142478 19.0009766%2C13 C19.0009766%2C9.68575216 16.3142478%2C6.99902344 13%2C6.99902344 C10.7785899%2C6.99902344 8.83909243%2C8.20603473 7.80156483%2C10 L6.67363116%2C10 C7.7970951%2C7.63505267 10.207604%2C6 13%2C6 C16.8659932%2C6 20%2C9.13400675 20%2C13 C20%2C16.8659932 16.8659932%2C20 13%2C20 C10.207604%2C20 7.7970951%2C18.3649473 6.67363116%2C16 Z M14.1464466%2C14.767767 L15.4142136%2C13.5 L6.62132034%2C13.5 C6.34517797%2C13.5 6.12132034%2C13.2761424 6.12132034%2C13 C6.12132034%2C12.7238576 6.34517797%2C12.5 6.62132034%2C12.5 L15.4142136%2C12.5 L14.1464466%2C11.232233 C13.9511845%2C11.0369709 13.9511845%2C10.7203884 14.1464466%2C10.5251263 C14.3417088%2C10.3298641 14.6582912%2C10.3298641 14.8535534%2C10.5251263 L16.9535151%2C12.6262866 C16.9607818%2C12.6327579 16.967905%2C12.6394779 16.9748737%2C12.6464466 C17.1701359%2C12.8417088 17.1701359%2C13.1582912 16.9748737%2C13.3535534 L14.8535534%2C15.4748737 C14.6582912%2C15.6701359 14.3417088%2C15.6701359 14.1464466%2C15.4748737 C13.9511845%2C15.2796116 13.9511845%2C14.9630291 14.1464466%2C14.767767 Z%22%3E%3C%2Fpath%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.cancelLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8F%96%E6%B6%88%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-96.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E6%8F%92%E5%85%A5%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(96.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L14.560863%2C8.59474009 C15.3463215%2C7.80928156 16.6198014%2C7.80928156 17.4052599%2C8.59474009 C18.1907184%2C9.38019862 18.1907184%2C10.6536785 17.4052599%2C11.439137 L15.4141819%2C13.4302151 L16.1252811%2C14.1413143 L13.9919834%2C16.274612 L12.9253346%2C15.2079632 L13.2808842%2C15.5635128 L13.4302151%2C15.4141819 C14.2156736%2C14.6287234 14.2156736%2C13.3552435 13.4302151%2C12.5697849 L12.7191158%2C11.8586857 L13.4302151%2C11.1475865 L12.7191158%2C10.4364872 Z M7.35355339%2C7.35355339 C7.54881554%2C7.15829124 7.86539803%2C7.15829124 8.06066017%2C7.35355339 L9.47487373%2C8.76776695 C9.67013588%2C8.9630291 9.67013588%2C9.27961159 9.47487373%2C9.47487373 C9.27961159%2C9.67013588 8.9630291%2C9.67013588 8.76776695%2C9.47487373 L7.35355339%2C8.06066017 C7.15829124%2C7.86539803 7.15829124%2C7.54881554 7.35355339%2C7.35355339 Z M16.3535534%2C16.3535534 C16.5488155%2C16.1582912 16.865398%2C16.1582912 17.0606602%2C16.3535534 L18.4748737%2C17.767767 C18.6701359%2C17.9630291 18.6701359%2C18.2796116 18.4748737%2C18.4748737 C18.2796116%2C18.6701359 17.9630291%2C18.6701359 17.767767%2C18.4748737 L16.3535534%2C17.0606602 C16.1582912%2C16.865398 16.1582912%2C16.5488155 16.3535534%2C16.3535534 Z M17%2C14.5 C17%2C14.2238576 17.2238576%2C14 17.5%2C14 L19.5%2C14 C19.7761424%2C14 20%2C14.2238576 20%2C14.5 C20%2C14.7761424 19.7761424%2C15 19.5%2C15 L17.5%2C15 C17.2238576%2C15 17%2C14.7761424 17%2C14.5 Z M6%2C11.5 L6%2C11.5 C6%2C11.2238576 6.22385763%2C11 6.5%2C11 L8.5%2C11 C8.77614237%2C11 9%2C11.2238576 9%2C11.5 C9%2C11.7761424 8.77614237%2C12 8.5%2C12 L6.5%2C12 L6.5%2C12 C6.22385763%2C12 6%2C11.7761424 6%2C11.5 L6%2C11.5 Z M11.5%2C6 L11.5%2C6 C11.7761424%2C6 12%2C6.22385763 12%2C6.5 L12%2C8.5 C12%2C8.77614237 11.7761424%2C9 11.5%2C9 C11.2238576%2C9 11%2C8.77614237 11%2C8.5 L11%2C6.5 L11%2C6.5 C11%2C6.22385763 11.2238576%2C6 11.5%2C6 L11.5%2C6 Z M14.5%2C17 C14.7761424%2C17 15%2C17.2238576 15%2C17.5 L15%2C19.5 C15%2C19.7761424 14.7761424%2C20 14.5%2C20 C14.2238576%2C20 14%2C19.7761424 14%2C19.5 L14%2C17.5 C14%2C17.2238576 14.2238576%2C17 14.5%2C17 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomin{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25%22 fill%3D%22%23666%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomout{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4-Copy%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}';
link_extension_styleInject(css_248z$5);

function _assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$3(self);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
var _typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$3(this, result);
    };
}
var link_extension_IconItem = /*#__PURE__*/ function(Component) {
    _inherits$3(IconItem, Component);
    var _super = _createSuper$3(IconItem);
    function IconItem() {
        _classCallCheck$6(this, IconItem);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasTooltip: false
        };
        return _this;
    }
    var _proto = IconItem.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, tip = _this_props.tip, onClick = _this_props.onClick, _this_props_type = _this_props.type, type = _this_props_type === void 0 ? "" : _this_props_type, icon = _this_props.icon;
        var hasTooltip = this.state.hasTooltip;
        var bgStyle = null;
        if (icon) {
            var backgroundImage = icon;
            if (typeof backgroundImage === "string" && !backgroundImage.startsWith("url(")) {
                // 如果只提供了图片地址，拼出合法的 css 图片链接字符串
                backgroundImage = "url(".concat(backgroundImage, ")");
            }
            bgStyle = {
                backgroundImage: backgroundImage
            };
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(link_extension_classNamePrefix("icon-item"), " ").concat(type || ""),
            style: bgStyle,
            onMouseEnter: function() {
                return _this.setState({
                    hasTooltip: true
                });
            },
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: onClick
        }, hasTooltip && /*#__PURE__*/ react_default.a.createElement("span", {
            className: link_extension_classNamePrefix("base-toolbar-tooltip")
        }, tip));
    };
    return IconItem;
}(react["Component"]);

var css_248z$6 = '.ct-base-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-base-toolbar .split{width:1px;height:14px;margin-top:0;background:#d9d9d9}.ct-base-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-base-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}';
link_extension_styleInject(css_248z$6);

/**
 * 工具条组件
 */ function _assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$4(o) {
    _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$4(o);
}
function _inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$4(subClass, superClass);
}
function _possibleConstructorReturn$4(self, call) {
    if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$4(self);
}
function _setPrototypeOf$4(o, p) {
    _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$4(o, p);
}
var _typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$4(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$4(this, result);
    };
}
var link_extension_Toolbar = /*#__PURE__*/ function(Component) {
    _inherits$4(Toolbar, Component);
    var _super = _createSuper$4(Toolbar);
    function Toolbar() {
        _classCallCheck$7(this, Toolbar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderItem = function(tool) {
            var custom = tool.custom, title = tool.title, icon = tool.icon, callback = tool.callback;
            return custom || /*#__PURE__*/ react_default.a.createElement(link_extension_IconItem, {
                key: title,
                type: icon,
                onClick: callback,
                tip: title
            });
        };
        _this.renderToolGroup = function(group, index, split) {
            return /*#__PURE__*/ react_default.a.createElement(react["Fragment"], {
                key: index
            }, group.map(function(tool) {
                return _this.renderItem(tool);
            }), split && /*#__PURE__*/ react_default.a.createElement("div", {
                className: "split"
            }));
        };
        return _this;
    }
    var _proto = Toolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, _this_props_tools = _this_props.tools, tools = _this_props_tools === void 0 ? [] : _this_props_tools, className = _this_props.className;
        var prefix = link_extension_classNamePrefix("toolbox");
        var lastIndex = tools.length - 1;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, tools.map(function(group, index) {
            return _this.renderToolGroup(group, index, index !== lastIndex);
        }));
    };
    return Toolbar;
}(react["Component"]);

var css_248z$7 = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
link_extension_styleInject(css_248z$7);

function _assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$5(o) {
    _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$5(o);
}
function _inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$5(subClass, superClass);
}
function _possibleConstructorReturn$5(self, call) {
    if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$5(self);
}
function _setPrototypeOf$5(o, p) {
    _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$5(o, p);
}
var _typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$5(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$5(this, result);
    };
}
var link_extension_ToolbarPopover = /*#__PURE__*/ function(PluginView) {
    _inherits$5(ToolbarPopover, PluginView);
    var _super = _createSuper$5(ToolbarPopover);
    function ToolbarPopover(view, config) {
        _classCallCheck$8(this, ToolbarPopover);
        var _this;
        _this = _super.call(this, view, config);
        /**
   * 获取当前选区位置
   */ _this.getPos = function() {
            var state = _this.view.state;
            return state.selection.from;
        };
        _this.getDom = function() {
            return _this.view.nodeDOM(_this.getPos());
        };
        _this.getSelectedLink = function() {
            return findLinkNode(_this.view.state);
        };
        _this.cancelLink = config.cancelLink;
        _this.visitLink = config.visitLink;
        _this.editLink = config.editLink;
        return _this;
    }
    var _proto = ToolbarPopover.prototype;
    _proto.getNode = function getNode(view) {
        var linkNode = this.getSelectedLink();
        if (!linkNode) {
            return null;
        }
        return view.nodeDOM(linkNode.pos);
    };
    _proto.getContent = function getContent() {
        var tools = [
            {
                title: "取消链接",
                icon: "cancelLink",
                callback: this.cancelLink
            },
            {
                title: "访问链接",
                icon: "visitLink",
                callback: this.visitLink
            },
            {
                title: "编辑链接",
                icon: "edit",
                callback: this.editLink
            }
        ];
        return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement(link_extension_Toolbar, {
            className: "".concat(link_extension_classNamePrefix("base-toolbar"), " ").concat(link_extension_classNamePrefix("image-toolbar")),
            tools: [
                tools
            ]
        }));
    };
    return ToolbarPopover;
}(link_extension_PluginView);

var regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
var regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
var regex3 = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

var formatLink = function(href) {
    var newHref = href.split("mailto:").reverse()[0].replace(regex1, function(match, capture) {
        return capture ? match : "http://".concat(match);
    });
    if (regex2.test(newHref) || newHref.indexOf("http") === 0) {
        return newHref;
    }
    if (regex3.test(newHref)) {
        return "mailto:".concat(newHref);
    }
    return false;
};

var css_248z$8 = ".ct-link-modal{font-size:12px;padding:24px}.ct-link-modal .ct-link-modal-item{color:rgba(0,0,0,.6);line-height:22px}.ct-link-modal .ct-link-modal-item:not(:last-child){margin-bottom:16px}.ct-link-modal .ct-link-modal-item input[type=text]{border-radius:4px;border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87);height:32px;margin-left:12px;outline:none;padding:6px 8px;transition:all .218s ease;width:100%}.ct-link-modal .ct-link-modal-item input[type=text]:focus{border:1px solid #1c6cdc}.ct-link-modal .ct-link-modal-item input[type=text]:-webkit-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .ct-link-modal-item input[type=text]:-moz-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .ct-link-modal-item input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .ct-link-modal-item input[type=text]:placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .ct-link-modal-item>label{align-items:center;display:flex}.ct-link-modal .ct-link-modal-item>label span{width:60px}.ct-link-modal .input-link-href{margin-bottom:24px}.ct-link-modal .error-notice{color:#f05e50;font-size:12px;left:88px;position:absolute;top:145px}.ct-link-modal .input-link-checkbox{cursor:pointer;display:flex;margin:12px 0 0 64px}";
link_extension_styleInject(css_248z$8);

/* eslint-disable no-return-assign */ /* eslint-disable jsx-a11y/label-has-associated-control */ function _assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function link_extension_extends() {
    link_extension_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return link_extension_extends.apply(this, arguments);
}
function _getPrototypeOf$6(o) {
    _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$6(o);
}
function _inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$6(subClass, superClass);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn$6(self, call) {
    if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$6(self);
}
function _setPrototypeOf$6(o, p) {
    _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$6(o, p);
}
var _typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$6(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$6(this, result);
    };
}
var __generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var LINK_MODAL_ID = "parker-link-modal";
// 空函数，不做任何处理，用于屏蔽 React 警告
var noop$1 = function() {};
var link_extension_LinkModal = /*#__PURE__*/ function(Component) {
    _inherits$6(LinkModal, Component);
    var _super = _createSuper$6(LinkModal);
    function LinkModal(props) {
        _classCallCheck$9(this, LinkModal);
        var _this;
        _this = _super.call(this, props);
        _this.first = true;
        _this.timer = null;
        _this.needCheckPageTitle = false;
        _this.handleInputHref = function(e) {
            var href = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, "");
            _this.setState({
                href: href,
                error: null
            });
            _this.needCheckPageTitle = true;
            if (_this.timer !== null) {
                clearTimeout(_this.timer);
            }
            _this.timer = setTimeout(function() {
                _this.checkPageTitle(href);
            }, _this.first ? 0 : 300);
            _this.first = false;
        };
        _this.handleInputHrefBlur = function() {
            if (!_this.needCheckPageTitle) {
                return;
            }
            if (_this.timer !== null) {
                clearTimeout(_this.timer);
            }
            var href = _this.state.href;
            _this.first = true;
            _this.checkPageTitle(href);
        };
        _this.handleInputText = function(e) {
            if (_this.timer !== null) {
                clearTimeout(_this.timer);
            }
            var title = e.target.value;
            _this.setState({
                title: title,
                hadEdit: true,
                autoUpdate: false
            });
        };
        _this.handleInputAutoUpdate = function() {
            if (_this.timer !== null) {
                clearTimeout(_this.timer);
            }
            var autoUpdate = _this.state.autoUpdate;
            var href = _this.state.href;
            autoUpdate = !autoUpdate;
            _this.setState({
                autoUpdate: autoUpdate
            });
            _this.cancelAutoUpdate = !autoUpdate;
            if (autoUpdate) {
                _this.setState({
                    hadEdit: false
                }, function() {
                    _this.checkPageTitle(href);
                });
            }
        };
        var _this1 = _assertThisInitialized$6(_this);
        _this.checkPageTitle = function() {
            var _ref = _asyncToGenerator$1(function(href) {
                var checkPageTitle, hadEdit, res;
                return __generator$1(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            checkPageTitle = _this1.props.checkPageTitle;
                            hadEdit = _this1.state.hadEdit;
                            return [
                                4,
                                checkPageTitle(href)
                            ];
                        case 1:
                            res = _state.sent();
                            _this1.setState({
                                showAutoUpdate: !!res
                            });
                            _this1.needCheckPageTitle = false;
                            if (hadEdit || _this1.cancelAutoUpdate) {
                                return [
                                    2
                                ];
                            }
                            if (res) {
                                _this1.setState({
                                    title: Array.isArray(res) ? res[0] : res,
                                    autoUpdate: true
                                });
                            } else {
                                _this1.setState({
                                    autoUpdate: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(href) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleOk = function() {
            var addLink = _this.props.addLink;
            var _this_state = _this.state, href = _this_state.href, title = _this_state.title, hadEdit = _this_state.hadEdit, autoUpdate = _this_state.autoUpdate;
            var newHref = formatLink(href);
            if (!newHref) {
                _this.setState({
                    error: "请输入正确的地址"
                });
                return;
            }
            addLink({
                href: newHref,
                title: title || href,
                hadEdit: hadEdit,
                autoUpdate: autoUpdate
            });
            _this.handleCancel();
        };
        _this.handleCancel = function() {
            var onClose = _this.props.onClose;
            onClose && onClose();
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            link_extension_close();
        };
        var type = props.type, _props_href = props.href, href = _props_href === void 0 ? "" : _props_href, title = props.title, _props_autoUpdate = props.autoUpdate, autoUpdate = _props_autoUpdate === void 0 ? false : _props_autoUpdate;
        _this.state = {
            href: href,
            title: title,
            autoUpdate: autoUpdate,
            showAutoUpdate: autoUpdate || false,
            error: null,
            hadEdit: autoUpdate ? false : type !== 0 || !!title
        };
        _this.cancelAutoUpdate = type === 0 ? false : !autoUpdate;
        return _this;
    }
    var _proto = LinkModal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var _this_state = this.state, title = _this_state.title, href = _this_state.href;
        var checkPageTitle = this.props.checkPageTitle;
        checkPageTitle(href).then(function(res) {
            _this.setState({
                showAutoUpdate: !!res
            });
        });
        if (title === "") {
            this.titleInputRef.focus();
        } else {
            this.hrefInputRef.focus();
        }
    };
    _proto.render = function render() {
        var _this = this;
        var type = this.props.type;
        var _this_state = this.state, error = _this_state.error, href = _this_state.href, title = _this_state.title, autoUpdate = _this_state.autoUpdate, showAutoUpdate = _this_state.showAutoUpdate;
        var autoUpdateComponent = /*#__PURE__*/ react_default.a.createElement("div", {
            className: "input-link-checkbox ".concat(link_extension_classNamePrefix("toolbox"))
        }, /*#__PURE__*/ react_default.a.createElement(link_extension_CheckBox, {
            checked: autoUpdate,
            onClick: this.handleInputAutoUpdate,
            onChange: noop$1
        }, "链接文字跟随文档标题变更"));
        return /*#__PURE__*/ react_default.a.createElement(link_extension_Modal, {
            className: "".concat(link_extension_classNamePrefix("link-modal")),
            title: "链接",
            okText: type === 0 ? "插 入" : "保 存",
            cancelText: "取 消",
            onOk: this.handleOk,
            onCancel: this.handleCancel,
            canEnter: true,
            disabled: !(href === null || href === void 0 ? void 0 : href.length)
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(link_extension_classNamePrefix("link-modal-item"))
        }, /*#__PURE__*/ react_default.a.createElement("label", null, /*#__PURE__*/ react_default.a.createElement("span", null, "链接文字:"), /*#__PURE__*/ react_default.a.createElement("input", {
            ref: function(ref) {
                return _this.titleInputRef = ref;
            },
            type: "text",
            placeholder: "请输入链接文字",
            value: title || "",
            onInput: this.handleInputText,
            onChange: noop$1
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(link_extension_classNamePrefix("link-modal-item"))
        }, /*#__PURE__*/ react_default.a.createElement("label", null, /*#__PURE__*/ react_default.a.createElement("span", null, "链接地址:"), /*#__PURE__*/ react_default.a.createElement("input", {
            ref: function(ref) {
                return _this.hrefInputRef = ref;
            },
            type: "text",
            id: "".concat(link_extension_classNamePrefix("link-modal-href-input")),
            placeholder: "请输入链接地址",
            value: href || "",
            onInput: this.handleInputHref,
            onBlur: this.handleInputHrefBlur,
            onChange: noop$1,
            autoComplete: "off"
        }))), showAutoUpdate && autoUpdateComponent, error && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "error-notice"
        }, error));
    };
    return LinkModal;
}(react["Component"]);
var link_extension_close = function() {
    var modalElem = document.getElementById(LINK_MODAL_ID);
    if (modalElem) {
        react_dom_default.a.render(null, modalElem);
        modalElem.remove();
    }
};
var link_extension_open = function(_param) {
    var title = _param.title, href = _param.href, type = _param.type, autoUpdate = _param.autoUpdate, addLink = _param.addLink, checkPageTitle = _param.checkPageTitle, onClose = _param.onClose, props = _objectWithoutProperties(_param, [
        "title",
        "href",
        "type",
        "autoUpdate",
        "addLink",
        "checkPageTitle",
        "onClose"
    ]);
    link_extension_close();
    var modalElem = document.createElement("div");
    modalElem.id = LINK_MODAL_ID;
    document.body.append(modalElem);
    react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(link_extension_LinkModal, link_extension_extends({
        type: type,
        title: title,
        href: href,
        autoUpdate: autoUpdate,
        checkPageTitle: checkPageTitle,
        addLink: addLink,
        onClose: onClose
    }, props)), modalElem);
    return {
        close: link_extension_close
    };
};
var LinkModal$1 = {
    open: link_extension_open,
    close: link_extension_close
};

function _assertThisInitialized$7(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function link_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function link_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) link_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) link_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$7(o) {
    _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$7(o);
}
function _inherits$7(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$7(subClass, superClass);
}
function _instanceof$5(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _possibleConstructorReturn$7(self, call) {
    if (call && (_typeof$7(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$7(self);
}
function _setPrototypeOf$7(o, p) {
    _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$7(o, p);
}
var _typeof$7 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$7(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$7(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$7(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$7(this, result);
    };
}
var __generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var handleCancelLink = cancelLink();
function isLinkSlice(slice, schema) {
    return slice.content.childCount === 1 && slice.content.firstChild.type === schema.nodes.link;
}
// 弹框类型，编辑还是只读
var MODAL_TYPE = {
    EDIT: 1,
    VIEW: 0
};
var shouldHackComposing = function(view) {
    var _view_state = view.state, selection = _view_state.selection, doc = _view_state.doc;
    if (!selection.empty) return false;
    var $from = selection.$from;
    if (_instanceof$5(selection, GapcursorSelection["a" /* GapCursor */]) && (selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeInlineNode || selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterInlineNode)) {
        var _doc_resolve_nodeAfter, _doc_resolve_nodeBefore;
        if (selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeInlineNode && ((_doc_resolve_nodeAfter = doc.resolve(selection.from).nodeAfter) === null || _doc_resolve_nodeAfter === void 0 ? void 0 : _doc_resolve_nodeAfter.type.name) === "link" || selection.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterInlineNode && ((_doc_resolve_nodeBefore = doc.resolve(selection.from).nodeBefore) === null || _doc_resolve_nodeBefore === void 0 ? void 0 : _doc_resolve_nodeBefore.type.name) === "link") {
            return true;
        }
        return false;
    }
    if (isInLinkStartOrEnd(view.state, selection.from, selection.to)) return true;
    if (!$from.nodeBefore && $from.nodeAfter && $from.nodeAfter.type.name === "link" && $from.nodeAfter.attrs.autoUpdate) {
        return true;
    }
    if (!$from.nodeAfter && $from.nodeBefore && $from.nodeBefore.type.name === "link" && $from.nodeBefore.attrs.autoUpdate) {
        return true;
    }
    return false;
};
var link_extension_LinkExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$7(LinkExtension, NodeExtension);
    var _super = _createSuper$7(LinkExtension);
    function LinkExtension() {
        _classCallCheck$a(this, LinkExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.showEdit = function(state, dispatch, view) {
            var attrs = getLinkAttrs(state, dispatch);
            var title = attrs.title, href = attrs.href;
            var autoUpdate = attrs.autoUpdate;
            var foundNode = findLinkNode(state);
            if (foundNode) {
                var linkDom = view.domAtPos(foundNode.pos + 1).node;
                if (linkDom) {
                    href = linkDom.href;
                    title = linkDom.innerText;
                }
            }
            var _this1 = _assertThisInitialized$7(_this);
            LinkModal$1.open({
                type: MODAL_TYPE.EDIT,
                title: title,
                href: href,
                autoUpdate: autoUpdate,
                addLink: function(newAttrs) {
                    link_extension_addLink(newAttrs)(view.state, dispatch);
                },
                checkPageTitle: function() {
                    var _ref = _asyncToGenerator$2(function(pageHref) {
                        var _this_provider, getLinkTitle, newTitle;
                        return __generator$2(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!((_this_provider = _this1.provider) === null || _this_provider === void 0 ? void 0 : _this_provider.getLinkTitle)) return [
                                        2,
                                        null
                                    ];
                                    getLinkTitle = _this1.provider.getLinkTitle;
                                    return [
                                        4,
                                        getLinkTitle(pageHref)
                                    ];
                                case 1:
                                    newTitle = _state.sent();
                                    return [
                                        2,
                                        newTitle
                                    ];
                            }
                        });
                    });
                    return function(pageHref) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onClose: function() {
                    view.focus();
                }
            });
            return true;
        };
        return _this;
    }
    var _proto = LinkExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type, getState = param.getState;
        var _this = this;
        return {
            edit: function() {
                return function(state, dispatch, view) {
                    return _this.showEdit(state, dispatch, view);
                };
            },
            isActive: function() {
                return isNodeActive(type);
            },
            isDisabled: function() {
                return function() {
                    return !link_extension_canInsertTypes(getState());
                };
            }
        };
    };
    _proto.keys = function keys() {
        var _this = this;
        return {
            "Mod-k": link_extension_convertCommand(function(state, dispatch, view) {
                return _this.showEdit(state, dispatch, view);
            }),
            Backspace: link_extension_convertCommand(link_extension_handleBackspace()),
            "Mod-Backspace": link_extension_convertCommand(link_extension_handleBackspace())
        };
    };
    // @ts-ignore type 值存在
    _proto.plugin = function plugin(param) {
        var providers = param.providers, getView = param.getView, editable = param.editable, type = param.type;
        var _this = this;
        var linkProvider = providers.get(this.name);
        this.provider = linkProvider;
        return new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"](this.name),
            props: {
                nodeViews: {
                    link: function(node, view, getPos) {
                        return new link_extension_LinkNodeView(node, view, getPos, linkProvider);
                    }
                },
                handleDOMEvents: {
                    // link 拖动时选区，会走 PM Node 原生拖动
                    dragstart: bindExtensionDOMEvent(type, function(view, event, eventPos) {
                        var selection = prosemirror_state_dist["NodeSelection"].create(view.state.doc, eventPos - 1);
                        view.dispatch(view.state.tr.setSelection(selection));
                        return false;
                    }),
                    keydown: function(view, event) {
                        if (event.keyCode !== link_extension_Keycodes.Enter) {
                            return false;
                        }
                        var state = view.state;
                        var foundNode = findLinkNode(state);
                        // 如果在 node 中输入回车，不生效
                        if (foundNode) {
                            var selection = state.selection;
                            // 在末尾时，把selection移到链接后，将选区设置到 link 最后进行Enter处理
                            if (isInLinkEnd(view)) {
                                view.dispatch(state.tr.setSelection(prosemirror_state_dist["TextSelection"].create(state.tr.doc, selection.to + 1)));
                                return false;
                            }
                            // 处于NodeSelection时，将选区设置到 link 最前进行Enter处理
                            if (_instanceof$5(selection, prosemirror_state_dist["NodeSelection"])) {
                                view.dispatch(state.tr.setSelection(prosemirror_state_dist["TextSelection"].create(state.tr.doc, selection.from)));
                                return false;
                            }
                            return true;
                        }
                        return false;
                    },
                    mouseup: function(view) {
                        if (!editable) return false;
                        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr;
                        var fromParentNode = view.state.selection.$from.parent;
                        if (fromParentNode && fromParentNode.type.name === "link" && fromParentNode.attrs.autoUpdate) {
                            // 自动更新的链接在部分选中时重新设置选区使得selection包含整个链接节点，避免链接的content为空
                            // 分析文档：https://km.sankuai.com/collabpage/1299150299
                            var newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, selection.from - fromParentNode.nodeSize + 1, selection.to);
                            view.dispatch(tr.setSelection(newSelection));
                            return true;
                        }
                        return false;
                    },
                    compositionstart: function(view) {
                        if (shouldHackComposing(view)) {
                            // fix ONES#66108200，hack prosemirror-view 相关代码
                            // 文档见：https://km.sankuai.com/collabpage/1313175156
                            // TODO：后续 prosemirror-view 若修复该问题，则去掉这段代码
                            var state = view.state;
                            var link = state.schema.nodes.link;
                            var $pos = state.selection.$from;
                            var node = $pos.nodeBefore;
                            if (state.storedMarks || node && node.type === link && !view.composing && state.selection.empty) {
                                view.domObserver.flush();
                                // Need to wrap the cursor in mark nodes different from the ones in the DOM context
                                view.markCursor = view.state.storedMarks || $pos.marks();
                                Object(index_es["d" /* __endComposition */])(view);
                                view.markCursor = null;
                                view.composing = true;
                            }
                        }
                        return false;
                    }
                },
                handleDoubleClick: function(view) {
                    var state = view.state, dispatch = view.dispatch;
                    var tr = state.tr;
                    var foundNode = findLinkNode(state);
                    if (foundNode) {
                        var pos = foundNode.pos;
                        dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, pos + 1, pos + foundNode.node.nodeSize)));
                        _this.showEdit(state, dispatch, view);
                        return true;
                    }
                    return false;
                },
                transformPasted: function(slice) {
                    var view = getView();
                    var state = view.state, dispatch = view.dispatch;
                    var tr = state.tr, selection = state.selection;
                    if (isInLinkEnd(view)) {
                        // 当在链接尾部进行粘贴时需要调整选区，防止新内容被包含在链接中
                        dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(state.doc, selection.to + 1)));
                    }
                    // hack 可以避免粘贴位置有链接时，原先链接地址被保留的问题
                    // @see https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60447018
                    if (isLinkSlice(slice, state.schema) && slice.openStart === 1 && slice.openEnd === 1) {
                        slice.openStart = 0;
                        slice.openEnd = 0;
                    }
                    return slice;
                }
            },
            view: function(view) {
                var popOption = {
                    cancelLink: function() {
                        return handleCancelLink(view.state, view.dispatch, view);
                    },
                    // 编辑链接
                    editLink: function() {
                        return _this.showEdit(view.state, view.dispatch, view);
                    },
                    // 访问链接
                    visitLink: function() {
                        var outerLink = getLinkAttrs(view.state, view.dispatch.bind(view));
                        if (outerLink && outerLink.href) {
                            var win = window.open(outerLink.href);
                            win.opener = null;
                        }
                    }
                };
                return new link_extension_ToolbarPopover(view, popOption);
            }
        });
    };
    _proto.transformPasted = function transformPasted(state, node, parentNode) {
        if (link_extension_canInsertTypes(state)) {
            return parseNode(node, state.schema, parentNode, this.provider);
        }
        return node;
    };
    // 复制外部的链接时，autoUpdate未定义，如果可以获取标题则默认自动获取
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        var _this = this;
        var container = document.createElement("div");
        container.innerHTML = html;
        container.querySelectorAll("a[href]").forEach(function(a) {
            var _this_provider;
            if (!a.hasAttribute("data-auto_update") && ((_this_provider = _this.provider) === null || _this_provider === void 0 ? void 0 : _this_provider.canGetTitle)) {
                var href = a.getAttribute("href") || "";
                if (_this.provider.canGetTitle(href)) {
                    a.setAttribute("data-auto_update", "1");
                }
            }
        });
        return container.innerHTML;
    };
    link_extension_createClass(LinkExtension, [
        {
            key: "name",
            get: function get() {
                return "link";
            }
        }
    ]);
    return LinkExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/list-item-extension/index.js










/**
 * 统一样式前缀
 */ var list_item_extension_CLASSNAME_PREFIX = "ct";

var list_item_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : list_item_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var list_item_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var list_item_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return list_item_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var list_item_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function list_item_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function list_item_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            list_item_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var list_item_extension_listTypes = [
    "bullet_list",
    "ordered_list",
    "task_list"
];
// 获取列表项结尾到下一行开头的 pos 距离
function distanceFromItemEndToNextlineStart(listNode) {
    var dis = 4; // 空的一级列表到下一行开头的距离为 4
    var curNode = listNode;
    // 列表每增加一级，距离加 2
    while(true){
        curNode = curNode.lastChild.lastChild;
        if (!list_item_extension_listTypes.includes(curNode.type.name)) break;
        dis += 2;
    }
    if (![
        "paragraph",
        "heading"
    ].includes(curNode.type.name)) dis -= 1;
    return dis;
}
function list_item_extension_liftToOuterList(tr, itemType, range) {
    var transaction = tr;
    var end = range.end;
    var endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](end - 1, endOfList, end, endOfList, new dist["Slice"](dist["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new dist["NodeRange"](transaction.doc.resolve(range.$from.pos), transaction.doc.resolve(endOfList), range.depth);
    }
    return transaction.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range));
}
function list_item_extension_liftOutOfList(tr, range) {
    var transaction = tr;
    var list = range.parent;
    // Merge the list items into a single big item
    for(var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        transaction.delete(pos - 1, pos + 1);
    }
    var $start = transaction.doc.resolve(range.start);
    var item = $start.nodeAfter;
    var atStart = range.startIndex === 0;
    var atEnd = range.endIndex === list.childCount;
    var parent = $start.node(-1);
    var indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list)))) {
        return false;
    }
    var start = $start.pos;
    var end = start + item.nodeSize;
    // 单独处理 data-diff-id 问题，后半段的 list 认为是新的 list，data-diff-id 重新生成
    // 详见 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60669246
    var newList = list.copy(dist["Fragment"].empty);
    newList.attrs = list_item_extension_objectSpread({}, newList.attrs);
    newList.attrs.dataDiffId = "ct-diff-id-".concat(esm_browser_v4());
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new dist["Slice"]((atStart ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty))).append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(newList)), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    return transaction;
}
// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function list_item_extension_liftListItem(itemType) {
    return function(tr, selRange) {
        var transaction = tr;
        var $from = selRange.$from, $to = selRange.$to;
        var range = $from.blockRange($to, function(node) {
            return node.childCount && node.firstChild.type === itemType;
        });
        if (!range) return false;
        if ($from.node(range.depth - 1).type === itemType) {
            // Inside a parent list
            return list_item_extension_liftToOuterList(transaction, itemType, range);
        }
        // Outer list node
        return list_item_extension_liftOutOfList(transaction, range);
    };
}

function list_item_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function list_item_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return list_item_extension_arrayLikeToArray(arr);
}
function list_item_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function list_item_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function list_item_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function list_item_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function list_item_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            list_item_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function list_item_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function list_item_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        list_item_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function list_item_extension_toConsumableArray(arr) {
    return list_item_extension_arrayWithoutHoles(arr) || list_item_extension_iterableToArray(arr) || list_item_extension_unsupportedIterableToArray(arr) || list_item_extension_nonIterableSpread();
}
function list_item_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return list_item_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return list_item_extension_arrayLikeToArray(o, minLen);
}
var list_item_extension_splitListItem = function(itemType) {
    var provider = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    return function(state, dispatch) {
        var tr = state.tr;
        var selection = state.selection;
        // 光标在inline节点末尾（如链接），纠正光标的位置
        var $anchor = selection.$anchor, from = selection.from;
        if (!$anchor.parent.type.isBlock && !$anchor.nodeAfter) {
            var predicate = function(n) {
                return n.type && [
                    "paragraph",
                    "heading"
                ].includes(n.type.name);
            };
            var node = list_item_extension_findParentNode(predicate)(selection);
            if (!node) return false;
            var pos = node.pos + node.node.nodeSize - 1;
            selection = prosemirror_state_dist["TextSelection"].create(state.doc, pos);
            tr.setSelection(selection);
        }
        var $from = selection.$from, $to = selection.$to;
        if (!list_item_extension_canInsertTypes(state)) return false;
        if (list_item_extension_instanceof(selection, prosemirror_state_dist["NodeSelection"]) && selection.node.isBlock || // 当前光标在块节点后
        $from.depth < 2 || // 当前光标所在深度小于2，说明一定不再列表项里
        !$from.sameParent($to) // 跨节点选区
        ) {
            return false;
        }
        var itemNode = $from.node(-1);
        // itemNode.type 存在 list_item、task_item 两种情况
        if (itemNode.type !== itemType) return false;
        // 列表项首个子节点为空（一个列表项可能有多个 paragraph），将下方的列表项提升或脱离
        if ($from.parent === itemNode.firstChild && $from.parent.content.size === 0) {
            list_item_extension_liftListItem(itemType)(tr, {
                $from: $from,
                $to: $to
            });
            dispatch(tr);
            return true;
        }
        var nextType = $to.pos === $from.end() ? itemNode.contentMatchAt(0).defaultType : null;
        tr.delete($from.pos, $to.pos);
        var types = nextType && [
            null,
            {
                type: nextType,
                attrs: list_item_extension_objectSpread$1({}, $from.node().attrs)
            }
        ];
        // TODO：暂时没有找到不能 split 的例子，单测待补充
        if (!Object(prosemirror_transform_dist["canSplit"])(tr.doc, $from.pos, 2, types)) return false;
        var atStart = itemNode.firstChild === $to.node() && $to.parentOffset === 0;
        var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, task_item = _state_schema_nodes.task_item, list_item = _state_schema_nodes.list_item, paragraph = _state_schema_nodes.paragraph;
        if (atStart) {
            // 在开头回车 - 等同于将下一行原封不动(diff-id等属性)下移一行
            var pos1 = list_item_extension_findParentNode(function(n) {
                return [
                    task_item,
                    list_item
                ].includes(n.type);
            })(selection).pos;
            tr.insert(pos1, itemNode.type.createAndFill({
                dataListItemDiffId: "ct-list-item-diff-id-".concat(esm_browser_v4())
            }));
            dispatch(tr.scrollIntoView());
            return true;
        }
        // 任务列表特殊处理
        if (itemNode.type === task_item) {
            // 任务列表要考虑checked属性
            var pos2 = list_item_extension_findParentNode(function(n) {
                return n.type === task_item;
            })(selection).pos;
            tr.setNodeMarkup(pos2, null, list_item_extension_objectSpreadProps(list_item_extension_objectSpread$1({}, itemNode.attrs), {
                dataListItemDiffId: "ct-list-item-diff-id-".concat(esm_browser_v4())
            }));
            var task_item_type = {
                type: task_item,
                attrs: list_item_extension_objectSpreadProps(list_item_extension_objectSpread$1({}, $from.node().attrs), {
                    checked: false
                })
            };
            var typesAfter = [
                task_item_type
            ];
            if (types) {
                typesAfter = [
                    task_item_type,
                    types[1]
                ];
            }
            tr.split($from.pos, 2, typesAfter);
        } else {
            // 否则按照新diff-id的原则split
            tr.split(tr.mapping.map($from.pos), 2, [
                {
                    type: list_item,
                    attrs: {
                        dataListItemDiffId: "ct-list-item-diff-id-".concat(esm_browser_v4())
                    }
                },
                {
                    type: paragraph,
                    attrs: {
                        dataDiffId: "ct-diff-id-".concat(esm_browser_v4())
                    }
                }
            ]);
        }
        var marks = state.storedMarks || $to.parentOffset && $from.marks() || [];
        // 沿用当前节点的 mark
        if (marks) {
            if (provider) {
                // 下面的处理是为了支持通过配置去除切分块级元素时不需要保留的Mark，例如划词评论的引用
                var newMarks = list_item_extension_toConsumableArray(marks);
                newMarks.forEach(function(mark, index) {
                    var _provider_excludeMarkNames, _provider_excludeMarkNames1;
                    if (provider.excludeMarkNames && ((_provider_excludeMarkNames = provider.excludeMarkNames) === null || _provider_excludeMarkNames === void 0 ? void 0 : _provider_excludeMarkNames.length) > 0 && ((_provider_excludeMarkNames1 = provider.excludeMarkNames) === null || _provider_excludeMarkNames1 === void 0 ? void 0 : _provider_excludeMarkNames1.indexOf(mark.type.name)) !== -1) {
                        newMarks.splice(index, 1);
                    }
                    tr.ensureMarks(newMarks);
                });
            } else {
                tr.ensureMarks(marks);
            }
        }
        dispatch(tr.scrollIntoView());
        return true;
    };
};

function list_item_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var isGapCursorBeforeNode = function(selection) {
    if (list_item_extension_instanceof$1(selection, GapcursorSelection["a" /* GapCursor */])) {
        return [
            GapcursorSelection["d" /* gapCursorSituation */].beforeNode
        ].includes(selection.gapCursorType);
    }
    return false;
};
var backspaceInList = function(itemType) {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item, bullet_list = _schema_nodes.bullet_list, ordered_list = _schema_nodes.ordered_list, task_list = _schema_nodes.task_list, doc = _schema_nodes.doc;
        var itemTypes = [
            list_item,
            task_item
        ];
        var listTypes = [
            bullet_list,
            ordered_list,
            task_list
        ];
        var $from = selection.$from, from = selection.from, $to = selection.$to, to = selection.to;
        var $cursor = list_item_extension_instanceof$1(selection, prosemirror_state_dist["TextSelection"]) ? selection.$cursor : list_item_extension_instanceof$1(selection, GapcursorSelection["a" /* GapCursor */]) ? selection.$head : null;
        // 光标在行首且单光标
        if ($from.parentOffset === 0) {
            var fromNodeParent = $from.node(-1);
            // 此时如果是 gapcursor，且前面没有节点，说明在文档首位
            if (!fromNodeParent) return false;
            if ($cursor) {
                // 如果光标在行内模块中（如链接前），向前移1个位置
                if ($cursor.parent.isInline) $cursor = tr.doc.resolve($cursor.pos - 1);
                var cursorNode = isGapCursorBeforeNode(selection) ? selection.targetNode : $cursor.node();
                var cursorNodeParent = isGapCursorBeforeNode(selection) ? $cursor.node() : $cursor.node(-1);
                // 光标在列表项的首个子节点中（一个列表项可能有多个 paragraph，如果不是首个子节点则走默认的Backspace事件）
                if (itemTypes.includes(cursorNodeParent.type) && cursorNode === cursorNodeParent.firstChild) {
                    /** 获取以当前项为一级的整个列表节点，如：
         *  1. 111
         *    a. 222
         *    b. 333
         *      i. 444
         * 光标在 "b. " 后时，获取的 listNode 内容包含：222333444
         */ var range = $cursor.blockRange($cursor, function(node) {
                        return node.childCount && node.firstChild.type === cursorNodeParent.type;
                    });
                    if (!range) return false; // TODO：暂时没有找到 range 非法的例子，单测待补充
                    var listNode = range.parent;
                    // 不是 listNode 的首个子列表项
                    if (listNode.content.firstChild !== cursorNodeParent) {
                        var _$cursor_nodeAfter;
                        var isAfterBlock = (_$cursor_nodeAfter = $cursor.nodeAfter) === null || _$cursor_nodeAfter === void 0 ? void 0 : _$cursor_nodeAfter.isBlock;
                        // block 前要多删除 p 标签
                        var offsetStartPos = isAfterBlock ? 2 : 3;
                        tr.delete($cursor.pos - offsetStartPos, $cursor.pos);
                        dispatch(tr);
                        return true;
                    }
                    // 当前的列表类型与调用command的extension类型不匹配时，不执行liftListItem
                    if (listNode.type === task_list && itemType === list_item || listNode.type !== task_list && itemType === task_item) {
                        return false;
                    }
                    // 计算 listNode 后面是否还有元素
                    var $end = tr.doc.resolve(range.end);
                    var listRange = $end.blockRange($end);
                    var end = listRange.end;
                    var endOfList = listRange.$to.end(listRange.depth);
                    var isHaveNodeAfterListNode = end < endOfList;
                    var result = list_item_extension_liftListItem(itemType)(tr, selection);
                    // fix ones#68740873 【学城2.0】删除完一个待办事项（任务框），出现两个
                    // 执行了 liftListItem 且 listNode 后面有元素，说明后面元素需要删掉 list_item/task_item
                    if (result && itemTypes.includes(listRange.parent.type) && isHaveNodeAfterListNode) {
                        var mappedEnd = tr.mapping.map(listRange.end);
                        tr.delete(mappedEnd - 2, mappedEnd);
                    }
                    dispatch(tr);
                    return !!result;
                }
                // 光标上一行的 node，如果光标在文档首位则为 null
                // 光标不在文档首位，且$cursor为TextSelection，$cursor.pos >= 1
                var preRowNode = $cursor.pos === 1 ? null : tr.doc.resolve($cursor.pos - 2).parent;
                // 上一行是列表
                if (preRowNode && listTypes.includes(preRowNode.type)) {
                    var distance = distanceFromItemEndToNextlineStart(preRowNode);
                    var newPos = $cursor.pos - distance; // 上一行列表项末尾的位置
                    // 如果光标后没有内容，则直接删除该行，否则将后面内容拼接到上一行的列表项后
                    var lineStartPos = $cursor.pos - 1;
                    if (!$to.nodeAfter) {
                        tr.delete(lineStartPos, to + 1);
                        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
                    } else {
                        var cursorNodeSize = cursorNode.nodeSize;
                        // 特殊处理当前节点是父节点是 doc 的最后一个节点时，多保留一个空行
                        if (cursorNodeParent.lastChild === cursorNode && cursorNodeParent.type === doc) {
                            tr.delete(lineStartPos, lineStartPos + cursorNodeSize - 1);
                        } else {
                            tr.delete(lineStartPos, lineStartPos + cursorNodeSize);
                        }
                        tr.insert(newPos, cursorNode.content);
                        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
                    }
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        }
        // 找到 from to 所属的 listNode
        var predicate = function(n) {
            return n.type && listTypes.includes(n.type);
        };
        var fromNode = list_item_extension_findParentNode(predicate)(selection);
        var toNode = list_item_extension_findParentNodeClosestToPos($to, predicate);
        // 跨节点删除，且 $to 所在的列表项完全删除（之后无内容需要与前面拼接）
        if (toNode && (!fromNode || fromNode.node !== toNode.node) && $to.parentOffset === $to.node().content.size) {
            /**
     * 以 <ul><li><p>123</p><ul><li><p>456</p><ul><li><p>789</p></li></ul></li></ul></li></ul> 为例
     * 如果 to 在 6 之后，则会删除 </p><ul><li>
     * 如果 to 在 9 之后，则会删除 </p></li></ul>
     */ tr.delete(from, to + 3);
            tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, from));
            dispatch(tr);
            return true;
        }
        /**
   * fix: ONES #67985267 如果from位置在列表里，则执行自定义的删除逻辑 (缺点：cut的时候还是会跳动)
   * fix: ONES #69076581 【2.0】列表项中的表格无法删除，预期是可以正常删除
   * @see https://km.sankuai.com/collabpage/1336274120
   */ var needCustomDelSel = !!fromNode && list_item_extension_instanceof$1(selection, prosemirror_state_dist["TextSelection"]);
        if (needCustomDelSel) {
            if (state.selection.empty) return false;
            if (dispatch) {
                tr.delete(from, to);
                tr.scrollIntoView();
                dispatch(tr);
                return true;
            }
        }
        return false;
    };
};

var list_item_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function list_item_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var ListItemNodeView = /*#__PURE__*/ function() {
    function ListItemNodeView(node) {
        list_item_extension_classCallCheck(this, ListItemNodeView);
        this.dom = document.createElement("li");
        this.dom = document.createElement("li");
        this.addClass(node);
        this.contentDOM = this.dom;
    }
    var _proto = ListItemNodeView.prototype;
    _proto.update = function update(node) {
        this.addClass(node);
        return true;
    };
    _proto.addClass = function addClass(node) {
        var firstChild = node.firstChild, _node_attrs = node.attrs, dataListItemDiffId = _node_attrs.dataListItemDiffId, hidden = _node_attrs.hidden;
        var className = hidden ? "ct-hidden-item" : "";
        if (firstChild && firstChild.type.name === "heading") {
            this.dom.className = "".concat(className, " ").concat(list_item_extension_classNamePrefix("item-level-".concat(firstChild.attrs.level)));
        } else {
            this.dom.className = className;
        }
        this.dom.setAttribute("data-list-item-diff-id", dataListItemDiffId);
    };
    return ListItemNodeView;
}();

function list_item_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var list_item_extension_css_248z = "li.ProseMirror-selectednode:after{display:none}.ct-hidden-item{list-style:none}";
list_item_extension_styleInject(list_item_extension_css_248z);

function list_item_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function list_item_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function list_item_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function list_item_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) list_item_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) list_item_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function list_item_extension_getPrototypeOf(o) {
    list_item_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return list_item_extension_getPrototypeOf(o);
}
function list_item_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) list_item_extension_setPrototypeOf(subClass, superClass);
}
function list_item_extension_possibleConstructorReturn(self, call) {
    if (call && (list_item_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return list_item_extension_assertThisInitialized(self);
}
function list_item_extension_setPrototypeOf(o, p) {
    list_item_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return list_item_extension_setPrototypeOf(o, p);
}
var list_item_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function list_item_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function list_item_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = list_item_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = list_item_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = list_item_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return list_item_extension_possibleConstructorReturn(this, result);
    };
}
var list_item_extension_ListItemExtension = /*#__PURE__*/ function(NodeExtension) {
    list_item_extension_inherits(ListItemExtension, NodeExtension);
    var _super = list_item_extension_createSuper(ListItemExtension);
    function ListItemExtension() {
        list_item_extension_classCallCheck$1(this, ListItemExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ListItemExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"](this.name),
            props: {
                nodeViews: {
                    list_item: function(node) {
                        return new ListItemNodeView(node);
                    }
                }
            }
        });
    };
    _proto.keys = function keys(param) {
        var type = param.type, providers = param.providers;
        var listItemProvider = providers.get(this.name);
        return {
            Enter: list_item_extension_convertCommand(list_item_extension_splitListItem(type, listItemProvider)),
            Backspace: list_item_extension_convertCommand(backspaceInList(type))
        };
    };
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            liftListItem: function() {
                return liftListItem(type);
            },
            sinkListItem: function() {
                return sinkListItem(type);
            }
        };
    };
    list_item_extension_createClass(ListItemExtension, [
        {
            key: "name",
            get: function get() {
                return "list_item";
            }
        }
    ]);
    return ListItemExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/ordered-list-extension/index.js









var ordered_list_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var ordered_list_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return ordered_list_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var ordered_list_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function ordered_list_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ordered_list_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function ordered_list_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ordered_list_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ordered_list_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ordered_list_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ordered_list_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ordered_list_extension_listTypes = [
    "bullet_list",
    "ordered_list",
    "task_list"
];
var ordered_list_extension_itemTypes = [
    "list_item",
    "task_item"
];
function ordered_list_extension_doWrapInList(tr, range, wrappers, joinBefore, listType, isSelectRange) {
    var content = dist["Fragment"].empty;
    for(var i = wrappers.length - 1; i >= 0; i--){
        // 新增列表时如果遇到需要被序列为列表的内容有缩进的情况 需要把缩进属性添加到列表上并去除列表序列内容的缩进
        var attrs = null;
        if (!isSelectRange && wrappers[i].type === listType) {
            attrs = {
                indent: range.$from.parent.attrs.indent
            };
        }
        content = dist["Fragment"].from(wrappers[i].type.create(attrs || wrappers[i].attrs, content));
    }
    tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new dist["Slice"](content, 0, 0), wrappers.length, true));
    var found = 0;
    for(var i1 = 0; i1 < wrappers.length; i1++){
        if (wrappers[i1].type === listType) found = i1 + 1;
    }
    var splitDepth = wrappers.length - found;
    var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    var parent = range.parent;
    var childNodes = [];
    for(var i2 = range.startIndex, e = range.endIndex, first = true; i2 < e; i2++, first = false){
        var childNode = parent.child(i2);
        childNodes.push(childNode);
        if (!first && Object(prosemirror_transform_dist["canSplit"])(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i2).nodeSize;
    }
    // 去除列表序列内容的缩进
    tr.doc.nodesBetween(range.start, /**
     * range 的 start和end信息只能包含序列内容的范围 列表的结构如下 子节点length*2代表li标签的范围， +2代表外层ul/ol标签的范围
     * 三者相加之后才可以完整包含整个列表的范围
     * <ol>
     *    <li>序列内容</li>
     *    ...
     * </ol>
     */ range.end + childNodes.length * 2 + 2, function(node, pos) {
        if (childNodes.includes(node) && node.attrs.indent !== 0) {
            tr.setNodeMarkup(pos, null, ordered_list_extension_objectSpreadProps(ordered_list_extension_objectSpread({}, node.attrs), {
                indent: 0
            }));
        }
    });
    return tr;
}
function ordered_list_extension_liftToOuterList(tr, itemType, range) {
    var transaction = tr;
    var end = range.end;
    var endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](end - 1, endOfList, end, endOfList, new dist["Slice"](dist["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new dist["NodeRange"](transaction.doc.resolve(range.$from.pos), transaction.doc.resolve(endOfList), range.depth);
    }
    return transaction.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range));
}
function ordered_list_extension_liftOutOfList(tr, range) {
    var transaction = tr;
    var list = range.parent;
    // Merge the list items into a single big item
    for(var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        transaction.delete(pos - 1, pos + 1);
    }
    var $start = transaction.doc.resolve(range.start);
    var item = $start.nodeAfter;
    var atStart = range.startIndex === 0;
    var atEnd = range.endIndex === list.childCount;
    var parent = $start.node(-1);
    var indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list)))) {
        return false;
    }
    var start = $start.pos;
    var end = start + item.nodeSize;
    // 单独处理 data-diff-id 问题，后半段的 list 认为是新的 list，data-diff-id 重新生成
    // 详见 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60669246
    var newList = list.copy(dist["Fragment"].empty);
    newList.attrs = ordered_list_extension_objectSpread({}, newList.attrs);
    newList.attrs.dataDiffId = "ct-diff-id-".concat(esm_browser_v4());
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new dist["Slice"]((atStart ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty))).append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(newList)), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    return transaction;
}
// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function ordered_list_extension_wrapInList(listType, attrs) {
    return function(tr, selRange) {
        var $to = selRange.$to;
        var $from = selRange.$from;
        // 根据 schema ，list_item 里面必须是 block 节点 如果 $from.parent 不是 block 先矫正 $from
        if (!$from.parent.isBlock) {
            var parentBlockNode = ordered_list_extension_findParentNode(function(node) {
                return node.type.isBlock;
            })(selRange);
            $from = tr.doc.resolve(parentBlockNode.pos);
        }
        var transaction = tr;
        var range = $from.blockRange($to);
        // 光标（gaocursor）在块级元素前后时，需要设置 range 为该块元素，否则会无法设置列表
        if (ordered_list_extension_instanceof(selRange, GapcursorSelection["a" /* GapCursor */])) {
            if (selRange.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterNode && $from.nodeBefore) {
                range = new dist["NodeRange"](tr.doc.resolve($from.pos - $from.nodeBefore.nodeSize), $from, $from.depth);
            }
            if (selRange.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeNode && $from.nodeAfter) {
                range = new dist["NodeRange"]($from, tr.doc.resolve($from.pos + $from.nodeAfter.nodeSize), $from.depth);
            }
        }
        var doJoin = false;
        var outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            var $insert = transaction.doc.resolve(range.start - 2);
            outerRange = new dist["NodeRange"]($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) {
                range = new dist["NodeRange"]($from, transaction.doc.resolve($to.end(range.depth)), range.depth);
            }
            doJoin = true;
        }
        var wrap = Object(prosemirror_transform_dist["findWrapping"])(outerRange, listType, attrs, range);
        if (!wrap) return false;
        var fromParent = $from.parent;
        var toParent = $to.parent;
        var isSelectRange = fromParent !== toParent || fromParent.type.name === "doc" && toParent.type.name === "doc";
        return ordered_list_extension_doWrapInList(transaction, range, wrap, doJoin, listType, isSelectRange);
    };
}
// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function ordered_list_extension_liftListItem(itemType) {
    return function(tr, selRange) {
        var transaction = tr;
        var $from = selRange.$from, $to = selRange.$to;
        var range = $from.blockRange($to, function(node) {
            return node.childCount && node.firstChild.type === itemType;
        });
        if (!range) return false;
        if ($from.node(range.depth - 1).type === itemType) {
            // Inside a parent list
            return ordered_list_extension_liftToOuterList(transaction, itemType, range);
        }
        // Outer list node
        return ordered_list_extension_liftOutOfList(transaction, range);
    };
}
function ordered_list_extension_findListParentNode(selection) {
    // 找离当前光标最近的容器节点（不算 list_item 类型）
    var conatinerNode = ordered_list_extension_findParentNode(function(n) {
        return n.isBlock && !n.isTextblock && !ordered_list_extension_itemTypes.includes(n.type.name);
    })(selection);
    // 如果最近的容器节点是 list 类型，则返回该节点，否则返回 Null
    return conatinerNode && ordered_list_extension_listTypes.includes(conatinerNode.node.type.name) ? conatinerNode : null;
}

// import { liftListItem } from "prosemirror-schema-list";
var ordered_list_extension_handleListClick = function(listType) {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item, bullet_list = _schema_nodes.bullet_list, ordered_list = _schema_nodes.ordered_list, task_list = _schema_nodes.task_list;
        var itemTypes = [
            list_item,
            task_item
        ];
        var listTypes = [
            bullet_list,
            ordered_list,
            task_list
        ];
        var transaction = tr;
        if (selection.forEachCell) {
            selection.ranges.forEach(function(originRange, i) {
                // 当前面的range增加列表后，range的位置发生改变，需要用 transaction.selection
                var _transaction_selection_ranges_i = transaction.selection.ranges[i], $from = _transaction_selection_ranges_i.$from, $to = _transaction_selection_ranges_i.$to;
                var range = $from.blockRange($to);
                if (!range) return false;
                var listNode = $from.parent.firstChild;
                // 当前不在任何列表中，新增列表
                if (!listNode || listNode.type !== listType) {
                    var newTr = ordered_list_extension_wrapInList(listType)(transaction, range);
                    if (!newTr) return false;
                    transaction = newTr;
                } else {
                    var trueSelection = prosemirror_state_dist["TextSelection"].create(transaction.doc, $from.pos + 2, $to.pos - 2);
                    var itemType = listType === task_list ? task_item : list_item;
                    var trueRange = trueSelection.$from.blockRange(trueSelection.$to, function(node) {
                        return node.childCount && node.firstChild.type === itemType;
                    });
                    if (!trueRange) return false;
                    // 选中的列表类型与当前的列表类型一致，提升列表
                    var newTr1 = ordered_list_extension_liftOutOfList(transaction, trueRange);
                    if (!newTr1) return false;
                    transaction = newTr1;
                }
            });
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        // 如果最近的容器节点是 list 类型，则是改变当前列表类型，否则是新增列表
        var listNodeInSelFrom = ordered_list_extension_findListParentNode(selection);
        // 当前selection.from不在任何列表中，新增列表
        if (!listNodeInSelFrom) {
            transaction = ordered_list_extension_wrapInList(listType)(transaction, selection);
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        var listNodes = [];
        // 遍历选区，找到所有列表节点
        transaction.doc.nodesBetween(selection.from, selection.to, function(node, pos) {
            // 当前节点在选区内（list至少长度为4）
            if (listTypes.includes(node.type) && pos + 4 > listNodeInSelFrom.pos) {
                listNodes.push({
                    node: node,
                    pos: pos
                });
            }
        });
        listNodes.forEach(function(listNode) {
            var listNodePos = transaction.mapping.map(listNode.pos);
            // 提升列表时，只对当前选区内的列表节点进行操作
            var from = Math.max(listNodePos + 1, transaction.selection.from);
            var to = Math.min(listNode.node.nodeSize + listNodePos - 1, transaction.selection.to);
            // 选中的列表类型与当前的列表类型一致，提升列表
            var itemType = listType === task_list ? task_item : list_item;
            if (listNode.node.type === listType) {
                var newTr = ordered_list_extension_liftListItem(itemType)(transaction, {
                    $from: transaction.doc.resolve(from),
                    $to: transaction.doc.resolve(to)
                });
                if (newTr) {
                    transaction = newTr;
                    return;
                }
            }
            // 转换列表类型
            from = listNodePos;
            to = listNode.node.nodeSize + from;
            // 转换当前列表类型为选中的类型
            transaction.doc.nodesBetween(from, to, function(node, pos) {
                if (listTypes.includes(node.type) && node.type !== listType) {
                    // 当前节点在选区内（list至少长度为4）
                    if (pos + 4 > from) {
                        transaction = transaction.setNodeMarkup(pos, listType, node.attrs);
                    }
                } else if (itemTypes.includes(node.type) && node.type !== itemType) {
                    // 当前节点在选区内（listItem至少长度为2）
                    if (pos + 2 > from) {
                        transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
                    }
                }
            });
        });
        dispatch(transaction);
        return true;
    };
};

var ordered_list_extension_isListActive = function(type) {
    return function() {
        return function(state) {
            var listNode = ordered_list_extension_findListParentNode(state.selection);
            return listNode && listNode.node.type === type;
        };
    };
};

var ordered_list_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ordered_list_extension_ExtensionType || (ordered_list_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var ordered_list_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var ordered_list_extension_isCommonDisabled = function() {
    return function(state) {
        return !ordered_list_extension_canInsertTypes(state);
    };
};

var ordered_list_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 有序列表
var regexpOrderedList = /^1\.\s$/;

function ordered_list_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var ordered_list_extension_css_248z = ".pm-body-wrapper ol,.ProseMirror ol{margin:8px 0;padding-left:24px}.pm-body-wrapper ol li[data-list-item-diff-id],.ProseMirror ol li[data-list-item-diff-id]{min-height:24px;font-size:14px;list-style:inherit}.pm-body-wrapper ol>h1,.pm-body-wrapper ol>h2,.pm-body-wrapper ol>h3,.pm-body-wrapper ol>h4,.pm-body-wrapper ol>h5,.pm-body-wrapper ol>h6,.pm-body-wrapper ol>p,.ProseMirror ol>h1,.ProseMirror ol>h2,.ProseMirror ol>h3,.ProseMirror ol>h4,.ProseMirror ol>h5,.ProseMirror ol>h6,.ProseMirror ol>p{margin:0}.pm-body-wrapper ol .ct-image,.ProseMirror ol .ct-image{vertical-align:top}.pm-body-wrapper ol hr,.ProseMirror ol hr{display:inline-block}.pm-body-wrapper .ct-item-level-1,.ProseMirror .ct-item-level-1{font-size:28px!important}.pm-body-wrapper .ct-item-level-2,.ProseMirror .ct-item-level-2{font-size:24px!important}.pm-body-wrapper .ct-item-level-3,.ProseMirror .ct-item-level-3{font-size:20px!important}.pm-body-wrapper .ct-item-level-4,.ProseMirror .ct-item-level-4{font-size:16px!important}.pm-body-wrapper .ct-item-level-5,.ProseMirror .ct-item-level-5{font-size:14px!important}.pm-body-wrapper .ct-item-level-6,.ProseMirror .ct-item-level-6{font-size:12px!important}ol .ct-item-level-1{margin-left:12px}ol .ct-item-level-2{margin-left:8px}ol .ct-item-level-3{margin-left:5px}ol .ct-item-level-4{margin-left:1px}ol .ct-item-level-6{margin-left:-2px}ol{list-style-type:decimal}ol ol{list-style-type:lower-alpha}ol ol ol{list-style-type:lower-roman}ol ol ol ol{list-style-type:decimal}ol ol ol ol ol{list-style-type:lower-alpha}ol ol ol ol ol ol{list-style-type:lower-roman}ol ol ol ol ol ol ol{list-style-type:decimal}ol ol ol ol ol ol ol ol{list-style-type:lower-alpha}ol ol ol ol ol ol ol ol ol{list-style-type:lower-roman}";
ordered_list_extension_styleInject(ordered_list_extension_css_248z);

function ordered_list_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ordered_list_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ordered_list_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ordered_list_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ordered_list_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ordered_list_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ordered_list_extension_getPrototypeOf(o) {
    ordered_list_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ordered_list_extension_getPrototypeOf(o);
}
function ordered_list_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ordered_list_extension_setPrototypeOf(subClass, superClass);
}
function ordered_list_extension_possibleConstructorReturn(self, call) {
    if (call && (ordered_list_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ordered_list_extension_assertThisInitialized(self);
}
function ordered_list_extension_setPrototypeOf(o, p) {
    ordered_list_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ordered_list_extension_setPrototypeOf(o, p);
}
var ordered_list_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ordered_list_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ordered_list_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = ordered_list_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ordered_list_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ordered_list_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ordered_list_extension_possibleConstructorReturn(this, result);
    };
}
var ordered_list_extension_OrderedListExtension = /*#__PURE__*/ function(NodeExtension) {
    ordered_list_extension_inherits(OrderedListExtension, NodeExtension);
    var _super = ordered_list_extension_createSuper(OrderedListExtension);
    function OrderedListExtension() {
        ordered_list_extension_classCallCheck(this, OrderedListExtension);
        return _super.apply(this, arguments);
    }
    var _proto = OrderedListExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            handleListClick: function() {
                return ordered_list_extension_handleListClick(type);
            },
            isOrderedListActive: ordered_list_extension_isListActive(type),
            isOrderedListDisabled: ordered_list_extension_isCommonDisabled
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type;
        return {
            "Mod-Shift-o": ordered_list_extension_convertCommand(ordered_list_extension_handleListClick(type))
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type, getView = param.getView;
        return [
            new prosemirror_inputrules_dist["a" /* InputRule */](new RegExp(regexpOrderedList), function(state, match, start, end) {
                var range = state.tr.doc.resolve(start).blockRange();
                var wrapping = range && Object(prosemirror_transform_dist["findWrapping"])(range, type);
                if (!wrapping) return null;
                var view = getView();
                var transaction = view.state.tr.deleteRange(start, end);
                transaction = ordered_list_extension_wrapInList(type)(transaction, transaction.selection);
                if (transaction) {
                    view.dispatch(transaction);
                    return view.state.tr; // 返回空tr表示已经处理inputRule
                }
                return null;
            })
        ];
    };
    ordered_list_extension_createClass(OrderedListExtension, [
        {
            key: "name",
            get: function get() {
                return "ordered_list";
            }
        }
    ]);
    return OrderedListExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/status-extension/index.js









/**
 * Backspace 键的 keycode
 */ var KEY_CODE_BACKSPACE = 8;
/**
 * 统一样式前缀
 */ var status_extension_CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var ZERO_WIDTH_SPACE = "​";

function status_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function status_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return status_extension_arrayLikeToArray(arr);
}
function status_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function status_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function status_extension_toConsumableArray(arr) {
    return status_extension_arrayWithoutHoles(arr) || status_extension_iterableToArray(arr) || status_extension_unsupportedIterableToArray(arr) || status_extension_nonIterableSpread();
}
function status_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return status_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return status_extension_arrayLikeToArray(o, minLen);
}
var status_extension_noop = function() {};
var status_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : status_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : status_extension_noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, status_extension_toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

var status_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var status_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return status_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var status_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function status_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function status_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            status_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function insertStatus(attrs) {
    return function(state, dispatch, view) {
        var tr = state.tr, schema = state.schema, selection = state.selection;
        var $from = selection.$from, from = selection.from;
        var status = schema.nodes.status;
        if (!status_extension_canInsertTypes(state)) {
            return false;
        }
        var selectedkey = esm_browser_v4();
        var node = status.create(status_extension_objectSpread({
            input: true,
            selectedkey: selectedkey
        }, attrs || {}), schema.text(ZERO_WIDTH_SPACE));
        // TODO: 链接中插入状态宏的行为是否需要
        // 链接中插入状态宏的时候会在选区开始位置多创建一个链接关闭标签，所以此处做了特殊处理
        var plus = $from.parent.type.name === "link" ? 3 : 2;
        tr.replaceWith(from, from, node);
        var newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, from + plus);
        tr.setSelection(newSelection);
        dispatch(tr);
        view.focus();
        return true;
    };
}

var status_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(status_extension_ExtensionType || (status_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var status_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var status_extension_AFTER_INSERT = "after_insert";

var status_extension_IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var status_extension_Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(status_extension_Keycodes || (status_extension_Keycodes = {}));

function checkZero(text) {
    return text === ZERO_WIDTH_SPACE;
}
function isSelectStatus() {
    var selection = window.getSelection();
    return selection.focusNode && selection.focusNode.classList && selection.focusNode.classList.contains("ct-status");
}
function status_extension_handleBackspace(param) {
    var state = param.state, dispatch = param.dispatch, view = param.view;
    var tr = state.tr, schema = state.schema, selection = state.selection;
    var status = schema.nodes.status;
    var $cursor = selection.$cursor, $from = selection.$from, from = selection.from, to = selection.to;
    var statusInfo = status_extension_findParentNode(function(node) {
        return node.type === status;
    })(selection);
    if (statusInfo) {
        if ($cursor) {
            var cursorNodeBefore = $cursor.nodeBefore;
            var isZeroBefore = cursorNodeBefore && checkZero(cursorNodeBefore.text);
            if (isZeroBefore || !cursorNodeBefore) {
                // 光标在状态宏内最前端时不删除状态宏
                return true;
            }
        } else {
            var isFocusStatus = isSelectStatus();
            var nodeBefore = $from.nodeBefore;
            var trueFrom = from;
            if (!isFocusStatus) {
                // 拖动选中了文字
                if (!nodeBefore) {
                    trueFrom += 1; // 选中了零宽字符要少删一个字符
                }
                tr.delete(trueFrom, to);
                tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, trueFrom));
                dispatch(tr);
                view.focus();
                return true;
            }
            if (!nodeBefore) {
                dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, trueFrom + 1, to)));
                return false;
            }
        }
    }
    // if ($cursor) {
    // GapCursor的情况下没有$cursor这个属性
    // 下面关于GapCursor的处理无需处理 在base-key-map-extension的util中的deleteSelectedNode方法已经有统一处理
    // 下面的处理有可能会带来  targetDOM.getBoundingClientRect is not a function的js error 导致删除行为被截断，发生失焦
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/64990562
    /**
   * <span>零宽字符</span>字
   * 从 字 后面的pos开始删除，from - 3的位置在零宽字符之前<span>之后
   */ // const textPos = from - 3;
    // if (textPos < 0) {
    //   return false;
    // }
    // const textNode = tr.doc.nodeAt(textPos);
    // if (textNode && textNode.type.name === "text") {
    //   // 状态宏节点的起点statusPos为<span>前
    //   const statusPos = textPos - textNode.nodeSize;
    //   if (statusPos < 0) {
    //     return false;
    //   }
    //   const statusNode = tr.doc.nodeAt(statusPos);
    //   if (statusNode && statusNode.type === status) {
    //     tr.delete(from - 1, from);
    //     // 在状态宏结束位置（</span>后一个位置）显示GapCursor
    //     const newSelection = new GapCursor(tr.doc.resolve(from - 1));
    //     dispatch(tr.setSelection(newSelection));
    //     return true;
    //   }
    // }
    // }
    return false;
}
var handleEnter = function(param) {
    var state = param.state, dispatch = param.dispatch, view = param.view;
    var tr = state.tr, schema = state.schema, selection = state.selection;
    var status = schema.nodes.status;
    var foundNode = status_extension_findParentNode(function(node) {
        return node.type === status;
    })(selection);
    if (foundNode) {
        var node = foundNode.node, pos = foundNode.pos;
        var newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, pos + node.nodeSize);
        dispatch(tr.setSelection(newSelection));
        view.focus();
        return true;
    }
    return false;
};

var FONT_COLOR_DARK = "#333";
var FONT_COLOR_LIGHT = "#fff";
var colorsMore = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];
var status_extension_colors = [
    "#ccc",
    "#f5222d",
    "#fadb14",
    "#52c41a",
    "#1890ff"
];
var status_extension_patterns = [
    {
        type: "fill",
        text: "填充"
    },
    {
        type: "outline",
        text: "线框"
    }
];

var computeFontColor = function(color) {
    var index = colorsMore.findIndex(function(c) {
        return c === color;
    });
    if (index === -1) {
        return FONT_COLOR_DARK;
    }
    if (index % 12 < 1) {
        return FONT_COLOR_DARK;
    }
    if (index % 12 < 2) {
        return FONT_COLOR_LIGHT;
    }
    if (index > 11 && index < 36) {
        return FONT_COLOR_DARK;
    }
    return FONT_COLOR_LIGHT;
};
var createNodeView = function(node) {
    var dom = document.createElement("span");
    var _node_attrs = node.attrs, color = _node_attrs.color, pattern = _node_attrs.pattern;
    var style = "\n    background: ".concat(pattern === "fill" ? color : "#fff", ";\n    border-color: ").concat(color, ";\n    color: ").concat(pattern === "fill" ? computeFontColor(color) : "", ";\n  ");
    dom.setAttribute("class", status_extension_classNamePrefix("status"));
    dom.setAttribute("style", style);
    dom.setAttribute("spellcheck", "false");
    return {
        dom: dom,
        contentDOM: dom
    };
};

function status_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function status_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function status_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function status_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function status_extension_slicedToArray(arr, i) {
    return status_extension_arrayWithHoles(arr) || status_extension_iterableToArrayLimit(arr, i) || status_extension_unsupportedIterableToArray$1(arr, i) || status_extension_nonIterableRest();
}
function status_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return status_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return status_extension_arrayLikeToArray$1(o, minLen);
}
var status_extension_getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var status_extension_setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = status_extension_getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = status_extension_slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var status_extension_emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        Object(react_dom["render"])(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var status_extension_emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = react_dom_default.a.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

function status_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var status_extension_css_248z = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
status_extension_styleInject(status_extension_css_248z);

function status_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function status_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var status_extension_SHOW = "show";
var status_extension_HIDE = "hide";
var status_extension_Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        status_extension_classCallCheck(this, Popover);
        this.popoverState = status_extension_HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(status_extension_classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === status_extension_SHOW && !forceUpdate) {
            return;
        }
        if (!target || !status_extension_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === status_extension_HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            status_extension_setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            status_extension_emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(status_extension_classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        Object(react_dom["render"])(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(status_extension_classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(status_extension_SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === status_extension_HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        status_extension_emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(status_extension_HIDE);
    };
    _proto.destroy = function destroy() {
        status_extension_emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function status_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function status_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function status_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function status_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            status_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var status_extension_DEFAULT_HEIGHT = 34;
var status_extension_DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var status_extension_PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        status_extension_classCallCheck$1(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = status_extension_objectSpread$1({}, status_extension_DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !status_extension_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new status_extension_Popover(status_extension_objectSpread$1({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return status_extension_DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var status_extension_ColorPicker = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, colors = param.colors, selected = param.selected, onChange = param.onChange;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "color-group ".concat(className)
    }, colors.map(function(color) {
        return /*#__PURE__*/ react_default.a.createElement("div", {
            key: color,
            className: "item".concat(color === selected ? " selected" : ""),
            onClick: function() {
                return onChange(color);
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            style: {
                backgroundColor: color
            }
        }));
    }));
};

var status_extension_css_248z$1 = '.ct-status-expand{display:flex;align-items:center}.ct-status-expand-btn{display:flex;width:26px;height:26px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2248px%22 viewBox%3D%220 0 48 48%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 54.1 (76490) - https%3A%2F%2Fsketchapp.com --%3E    %3Ctitle%3Eellipsis%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22ellipsis%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E5%8F%82%E8%80%83%E7%BA%BF%22 opacity%3D%220%22%3E            %3Cg%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 fill%3D%22%23FFFFFF%22 fill-rule%3D%22nonzero%22 x%3D%220%22 y%3D%220%22 width%3D%2248%22 height%3D%2248%22%3E%3C%2Frect%3E                %3Ccircle id%3D%22%E6%A4%AD%E5%9C%86%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2219.9%22%3E%3C%2Fcircle%3E                %3Ccircle id%3D%22%E6%A4%AD%E5%9C%86%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%229.9%22%3E%3C%2Fcircle%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 x%3D%226.1%22 y%3D%226.1%22 width%3D%2235.8%22 height%3D%2235.8%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 x%3D%228.1%22 y%3D%224.1%22 width%3D%2231.8%22 height%3D%2239.8%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 x%3D%224.1%22 y%3D%228.1%22 width%3D%2239.8%22 height%3D%2231.8%22 rx%3D%222%22%3E%3C%2Frect%3E            %3C%2Fg%3E        %3C%2Fg%3E        %3Cpath d%3D%22M11%2C21 C12.6568542%2C21 14%2C22.3431458 14%2C24 C14%2C25.6568542 12.6568542%2C27 11%2C27 C9.34314575%2C27 8%2C25.6568542 8%2C24 C8%2C22.3431458 9.34314575%2C21 11%2C21 Z M24%2C21 C25.6568542%2C21 27%2C22.3431458 27%2C24 C27%2C25.6568542 25.6568542%2C27 24%2C27 C22.3431458%2C27 21%2C25.6568542 21%2C24 C21%2C22.3431458 22.3431458%2C21 24%2C21 Z M37%2C21 C38.6568542%2C21 40%2C22.3431458 40%2C24 C40%2C25.6568542 38.6568542%2C27 37%2C27 C35.3431458%2C27 34%2C25.6568542 34%2C24 C34%2C22.3431458 35.3431458%2C21 37%2C21 Z%22 id%3D%22%E5%BD%A2%E7%8A%B6%22 fill%3D%22%23000000%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") 50% no-repeat;background-size:16px 16px;cursor:pointer;margin:0 1px 0 -5px}';
status_extension_styleInject(status_extension_css_248z$1);

function status_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function status_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function status_extension_getPrototypeOf(o) {
    status_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return status_extension_getPrototypeOf(o);
}
function status_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) status_extension_setPrototypeOf(subClass, superClass);
}
function status_extension_possibleConstructorReturn(self, call) {
    if (call && (status_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return status_extension_assertThisInitialized(self);
}
function status_extension_setPrototypeOf(o, p) {
    status_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return status_extension_setPrototypeOf(o, p);
}
var status_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function status_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function status_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = status_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = status_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = status_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return status_extension_possibleConstructorReturn(this, result);
    };
}
var CLS_PREFIX = status_extension_classNamePrefix("status-expand");
var status_extension_Expand = /*#__PURE__*/ function(Component) {
    status_extension_inherits(Expand, Component);
    var _super = status_extension_createSuper(Expand);
    function Expand(props) {
        status_extension_classCallCheck$2(this, Expand);
        var _this;
        _this = _super.call(this, props);
        _this.handleClick = function() {
            var _this_props = _this.props, _this_props_onExpand = _this_props.onExpand, onExpand = _this_props_onExpand === void 0 ? function() {
                return null;
            } : _this_props_onExpand;
            _this.setState({
                expand: true
            });
            onExpand();
        };
        _this.state = {
            expand: !!props.expand
        };
        return _this;
    }
    var _proto = Expand.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, _this_props_className = _this_props.className, className = _this_props_className === void 0 ? "" : _this_props_className, child = _this_props.child, children = _this_props.children;
        var expand = this.state.expand;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(CLS_PREFIX, " ").concat(className)
        }, expand ? child : children, expand ? null : /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(CLS_PREFIX, "-btn"),
            onClick: function() {
                return _this.handleClick();
            }
        }));
    };
    return Expand;
}(react["Component"]);

var PatternPicker = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, patterns = param.patterns, selected = param.selected, onChange = param.onChange;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "pattern-group ".concat(className)
    }, patterns.map(function(p) {
        return /*#__PURE__*/ react_default.a.createElement("label", {
            className: "radio",
            key: p.type,
            onClick: function() {
                return onChange(p.type);
            }
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "radio-bg"
        }), /*#__PURE__*/ react_default.a.createElement("input", {
            type: "radio",
            checked: selected === p.type,
            readOnly: true
        }), " ", p.text, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "radio-on"
        }));
    }));
};

var status_extension_css_248z$2 = ".ct-status-editor{flex-direction:column;align-items:flex-start;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-status-editor .ct-status-editor-expand{display:flex;flex-direction:row}.ct-status-editor .color-group{height:38px;display:flex;justify-content:center;align-items:center}.ct-status-editor .color-group .item{width:26px;height:26px;margin:0 2px;display:flex;justify-content:center;align-items:center;cursor:pointer}.ct-status-editor .color-group .item.selected,.ct-status-editor .color-group .item:hover{border:1px solid #ccc;border-radius:2px}.ct-status-editor .color-group .item:first-child{margin:0 2px 0 4px}.ct-status-editor .color-group .item div{width:14px;height:14px}.ct-status-editor .color-group-large{width:244px;height:106px;flex-wrap:wrap;margin:9px 6px}.ct-status-editor .color-group-large .item{width:16px;height:16px;border:1px solid #eee;margin:1px 2px 0}.ct-status-editor .color-group-large .item.selected,.ct-status-editor .color-group-large .item:hover{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-status-editor .color-group-large .item:hover{z-index:3}.ct-status-editor .color-group-large .item:first-child{margin:1px 2px 0}.ct-status-editor .pattern-group{height:38px;display:flex;justify-content:flex-start;align-items:center;margin-left:12px}.ct-status-editor .pattern-group.large{padding-bottom:8px}.ct-status-editor .pattern-group .radio{display:inline-block;position:relative;font-size:14px;line-height:16px;margin-right:12px;cursor:pointer;color:rgba(0,0,0,.65)}.ct-status-editor .pattern-group .radio input{display:none}.ct-status-editor .pattern-group .radio .radio-bg{display:inline-block;height:16px;width:16px;margin-right:5px;padding:0;border-radius:100%;border:1px solid #00a7cd;vertical-align:top;cursor:pointer;transition:all .2s ease}.ct-status-editor .pattern-group .radio .radio-on{display:none}.ct-status-editor .pattern-group .radio input:checked+span.radio-on{width:8px;height:8px;position:absolute;border-radius:100%;background:#00a7cd;top:4px;left:4px;transition:all .2s ease;transform:scale(1);display:inline-block}";
status_extension_styleInject(status_extension_css_248z$2);

function status_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function status_extension_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function status_extension_getPrototypeOf$1(o) {
    status_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return status_extension_getPrototypeOf$1(o);
}
function status_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) status_extension_setPrototypeOf$1(subClass, superClass);
}
function status_extension_possibleConstructorReturn$1(self, call) {
    if (call && (status_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return status_extension_assertThisInitialized$1(self);
}
function status_extension_setPrototypeOf$1(o, p) {
    status_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return status_extension_setPrototypeOf$1(o, p);
}
var status_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function status_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function status_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = status_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = status_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = status_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return status_extension_possibleConstructorReturn$1(this, result);
    };
}
var CLS_PREFIX$1 = status_extension_classNamePrefix("status");
var status_extension_StatusEditor = /*#__PURE__*/ function(Component) {
    status_extension_inherits$1(StatusEditor, Component);
    var _super = status_extension_createSuper$1(StatusEditor);
    function StatusEditor(props) {
        status_extension_classCallCheck$3(this, StatusEditor);
        var _this;
        _this = _super.call(this, props);
        _this.handleClick = function(e) {
            e.nativeEvent.stopImmediatePropagation();
            e.stopPropagation();
        };
        _this.handleExpand = function() {
            var handleExpand = _this.props.handleExpand;
            _this.setState({
                expand: true
            });
            handleExpand && handleExpand();
        };
        _this.state = {
            expand: props.expand
        };
        return _this;
    }
    var _proto = StatusEditor.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, color = _this_props.color, pattern = _this_props.pattern, handleColorSelect = _this_props.handleColorSelect, handlePatternSelect = _this_props.handlePatternSelect;
        var expand = this.state.expand;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(CLS_PREFIX$1, "-editor"),
            onClick: function(e) {
                return _this.handleClick(e);
            }
        }, /*#__PURE__*/ react_default.a.createElement(status_extension_Expand, {
            className: "".concat(CLS_PREFIX$1, "-editor-expand"),
            expand: expand,
            onExpand: function() {
                return _this.handleExpand();
            },
            child: /*#__PURE__*/ react_default.a.createElement(status_extension_ColorPicker, {
                className: "color-group-large",
                colors: colorsMore,
                selected: color,
                onChange: function(c) {
                    return handleColorSelect(c, expand);
                }
            })
        }, /*#__PURE__*/ react_default.a.createElement(status_extension_ColorPicker, {
            colors: status_extension_colors,
            selected: color,
            onChange: function(c) {
                return handleColorSelect(c, expand);
            }
        })), /*#__PURE__*/ react_default.a.createElement(PatternPicker, {
            className: expand ? "large" : "",
            patterns: status_extension_patterns,
            selected: pattern,
            onChange: function(p) {
                return handlePatternSelect(p, expand);
            }
        }));
    };
    return StatusEditor;
}(react["Component"]);

function status_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function status_extension_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function status_extension_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function status_extension_getPrototypeOf$2(o) {
    status_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return status_extension_getPrototypeOf$2(o);
}
function status_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) status_extension_setPrototypeOf$2(subClass, superClass);
}
function status_extension_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            status_extension_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function status_extension_possibleConstructorReturn$2(self, call) {
    if (call && (status_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return status_extension_assertThisInitialized$2(self);
}
function status_extension_setPrototypeOf$2(o, p) {
    status_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return status_extension_setPrototypeOf$2(o, p);
}
var status_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function status_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function status_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = status_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = status_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = status_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return status_extension_possibleConstructorReturn$2(this, result);
    };
}
var POPOVER_HEIGHT_FULL = 170;
var POPOVER_HEIGHT_MIN = 76;
var status_extension_StylePopover = /*#__PURE__*/ function(PluginView) {
    status_extension_inherits$2(StylePopover, PluginView);
    var _super = status_extension_createSuper$2(StylePopover);
    function StylePopover() {
        status_extension_classCallCheck$4(this, StylePopover);
        var _this;
        _this = _super.apply(this, arguments);
        // 状态是否发生了改变
        _this.isChanged = false;
        _this.handleColorSelect = function(color, exp) {
            var expand = exp || !status_extension_colors.includes(color);
            _this.setAttrs({
                color: color,
                expand: expand
            });
        };
        _this.handlePatternSelect = function(pattern, expand) {
            _this.setAttrs({
                pattern: pattern,
                expand: expand
            });
        };
        _this.handleExpand = function() {
            _this.setAttrs({
                expand: true
            });
        };
        _this.setAttrs = function(newAttrs) {
            var node = _this.findSelectNode().node;
            var pos = _this.currentPos;
            if (!node) {
                return;
            }
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var tr = state.tr;
            try {
                var attrs = status_extension_objectSpread$2({}, node.attrs, newAttrs);
                tr.setNodeMarkup(pos, null, attrs);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
            _this.isChanged = true;
            dispatch(tr);
        };
        return _this;
    }
    var _proto = StylePopover.prototype;
    _proto.shouldUpdate = function shouldUpdate() {
        if (this.isChanged) {
            this.isChanged = false;
            return true;
        }
        return false;
    };
    _proto.findSelectNode = function findSelectNode() {
        var view = this.view;
        var state = view.state;
        var selection = state.selection;
        var nodeType = state.schema.nodes.status;
        var selectedNode = state.selection.node;
        if (selectedNode && selectedNode.type === nodeType) {
            return {
                pos: state.selection.from,
                node: selectedNode
            };
        }
        var found = status_extension_findParentNode(function(node) {
            return node.type === nodeType;
        })(selection);
        if (found) {
            return found;
        }
        return null;
    };
    _proto.getNode = function getNode() {
        var found = this.findSelectNode();
        this.currentNode = found === null || found === void 0 ? void 0 : found.node;
        this.currentPos = found === null || found === void 0 ? void 0 : found.pos;
        if (found) {
            return this.view.nodeDOM(found.pos);
        }
        return null;
    };
    _proto.getContent = function getContent() {
        var node = this.currentNode;
        if (!node) {
            return null;
        }
        var _node_attrs = node.attrs, color = _node_attrs.color, expand = _node_attrs.expand, pattern = _node_attrs.pattern;
        return /*#__PURE__*/ react_default.a.createElement(status_extension_StatusEditor, {
            color: color,
            expand: expand,
            pattern: pattern,
            handleColorSelect: this.handleColorSelect,
            handlePatternSelect: this.handlePatternSelect,
            handleExpand: this.handleExpand
        });
    };
    _proto.getHeight = function getHeight() {
        var node = this.currentNode;
        if (!node) {
            return 0;
        }
        var expand = node.attrs.expand;
        return expand ? POPOVER_HEIGHT_FULL : POPOVER_HEIGHT_MIN;
    };
    return StylePopover;
}(status_extension_PluginView);

var status_extension_css_248z$3 = '.ct-status{display:inline-block;word-break:break-all;min-height:22px;min-width:68px;padding:0 8px;margin:0 2px;vertical-align:bottom;font-size:12px;font-weight:700;line-height:18px;text-align:center;color:#000;background-color:#ccc;border:2px solid #ccc;border-radius:2px;cursor:text}.ct-status[data-color=red]{background-color:#f5222d;border-color:#f5222d}.ct-status[data-color=red][data-pattern=fill]{color:#fff}.ct-status[data-color=yellow]{background-color:#fadb14;border-color:#fadb14}.ct-status[data-color=yellow][data-pattern=fill]{color:#876800}.ct-status[data-color=green]{background-color:#52c41a;border-color:#52c41a}.ct-status[data-color=green][data-pattern=fill]{color:#fff}.ct-status[data-color=blue]{background-color:#1890ff;border-color:#1890ff}.ct-status[data-color=blue][data-pattern=fill]{color:#fff}.ct-status[data-pattern=outline]{background-color:#f7f7f7}.ct-status.ProseMirror-selectednode{outline:unset}.ct-status.ct-selected,.ct-status.ProseMirror-selectednode,.ct-status:hover{position:relative}.ct-status.ct-selected:after,.ct-status.ProseMirror-selectednode:after,.ct-status:hover:after{z-index:2;position:absolute;content:"";left:-3px;right:-3px;top:-3px;bottom:-3px;border:2px solid #23bdd9;border-radius:3px;pointer-events:none}.ct-status[data-selectedkey]{cursor:default}.ProseMirror-selectednode .ct-status{outline:2px solid #0082a6}.ProseMirror-widget+span.ct-status{top:auto}';
status_extension_styleInject(status_extension_css_248z$3);

function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function status_extension_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function status_extension_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function status_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function status_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) status_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) status_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function status_extension_getPrototypeOf$3(o) {
    status_extension_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return status_extension_getPrototypeOf$3(o);
}
function status_extension_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) status_extension_setPrototypeOf$3(subClass, superClass);
}
function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function status_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function status_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        status_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function status_extension_possibleConstructorReturn$3(self, call) {
    if (call && (status_extension_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return status_extension_assertThisInitialized$3(self);
}
function status_extension_setPrototypeOf$3(o, p) {
    status_extension_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return status_extension_setPrototypeOf$3(o, p);
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1();
}
var status_extension_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
function status_extension_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function status_extension_createSuper$3(Derived) {
    var hasNativeReflectConstruct = status_extension_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = status_extension_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = status_extension_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return status_extension_possibleConstructorReturn$3(this, result);
    };
}
// const lastSelectStatus = null;
var status_extension_StatusExtension = /*#__PURE__*/ function(NodeExtension) {
    status_extension_inherits$3(StatusExtension, NodeExtension);
    var _super = status_extension_createSuper$3(StatusExtension);
    function StatusExtension() {
        status_extension_classCallCheck$5(this, StatusExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.commands = function(param) {
            var getState = param.getState, editorEventEmitter = param.editorEventEmitter;
            return {
                insert: execAfterCommands(insertStatus, function() {
                    return editorEventEmitter.emit(status_extension_AFTER_INSERT, {
                        braceWidth: 90
                    });
                }),
                isDisabled: function() {
                    return function() {
                        return !status_extension_canInsertTypes(getState());
                    };
                }
            };
        };
        return _this;
    }
    var _proto = StatusExtension.prototype;
    _proto.plugin = function plugin() {
        var composing = null;
        return new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"](this.name),
            props: {
                nodeViews: {
                    status: function(node) {
                        return createNodeView(node);
                    }
                },
                handleClickOn: function(view, pos, node, nodePos) {
                    var dispatch = view.dispatch, state = view.state;
                    var schema = state.schema, tr = state.tr, selection = state.selection;
                    var status = schema.nodes.status;
                    if (selection && node.type.name === status.name) {
                        // 点击状态宏区域
                        if (nodePos === pos - 1) {
                            // 点击状态宏内部左侧
                            var newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, nodePos + 2);
                            tr.setSelection(newSelection);
                            dispatch(tr);
                        } else if (nodePos === node.nodeSize + nodePos - 1) {
                            // 点击状态宏内部右侧
                            var newSelection1 = prosemirror_state_dist["TextSelection"].create(tr.doc, node.nodeSize + nodePos - 1);
                            tr.setSelection(newSelection1);
                            dispatch(tr);
                        }
                        view.focus();
                        return true;
                    }
                    // 如果点击状态宏内部文字TODO
                    return false;
                },
                // 之前的处理，暂时没有用到，先保留观察
                // handleClickOn: (view, pos, node, nodePos) => {
                //   const { dispatch, state } = view;
                //   const { schema, tr, selection } = state;
                //   const { status } = schema.nodes;
                //   try {
                //     if (selection && node.type.name === status.name) {
                //       if (!lastSelectStatus) {
                //         const newSelection = NodeSelection.create(tr.doc, nodePos);
                //         tr.setSelection(newSelection);
                //         dispatch(tr);
                //       } else if (
                //         lastSelectStatus.selectedkey === node.attrs.selectedkey
                //       ) {
                //         let newPos = pos;
                //         const { nodeBefore } = selection.$from;
                //         if (!nodeBefore) {
                //           // 此时光标在零宽字符前，需修正
                //           newPos += 1;
                //         }
                //         tr.setSelection(TextSelection.create(tr.doc, newPos));
                //         if (
                //           (tr.selection as NodeSelection).node ||
                //           tr.selection.$from.parent.type.name !== status.name
                //         ) {
                //           // 没有正确定位到里
                //           tr.setSelection(TextSelection.create(tr.doc, newPos - 1));
                //         }
                //         view.dispatch(tr);
                //         view.focus();
                //       }
                //       return true;
                //     }
                //   } catch (err) {
                //     // eslint-disable-next-line no-console
                //     console.error(err);
                //   }
                //   return false;
                // },
                handleDOMEvents: {
                    cut: function(view) {
                        var _view_state = view.state, selection = _view_state.selection, schema = _view_state.schema, tr = _view_state.tr;
                        var status = schema.nodes.status;
                        var $from = selection.$from, $to = selection.$to, from = selection.from, to = selection.to;
                        var selectStatusFrom = $from.parent && $from.parent.type === status && $from.parent;
                        var selectStatusTo = $to.parent && $to.parent.type === status && $to.parent;
                        var statusNode = selectStatusFrom || selectStatusTo;
                        // 状态宏 size 包含零宽度字符，加上开始节点
                        var rangeSize = Math.abs(to - from) + 3;
                        // 如果选择区域包含状态宏，且选区等于或超出状态宏的大小，
                        // 可能的情况是选区开始在状态宏里，或选区结束在状态宏里
                        if ((selectStatusFrom || selectStatusTo) && rangeSize >= statusNode.nodeSize) {
                            try {
                                var _TextSelection;
                                // 下列计算过程包含零宽度字符的长度
                                var pos = [];
                                if (rangeSize === statusNode.nodeSize) {
                                    pos = [
                                        from - 2,
                                        to + 1
                                    ]; // 选中状态宏
                                } else if (selectStatusFrom) {
                                    pos = [
                                        from - 2,
                                        to
                                    ]; // 从后往前选，状态宏在最前
                                } else if (selectStatusTo) {
                                    pos = [
                                        from,
                                        to + 1
                                    ]; // 从前往后选，状态宏在最后
                                }
                                var newSelection = (_TextSelection = prosemirror_state_dist["TextSelection"]).create.apply(_TextSelection, [
                                    tr.doc
                                ].concat(_toConsumableArray$1(pos)));
                                view.dispatch(tr.setSelection(newSelection));
                            // 这个地方不能return true，否则会导致后续复制内容不会走clipboardSerializer钩子方法
                            } catch (err) {
                                // eslint-disable-next-line no-console
                                console.error(err);
                            }
                        }
                        return false;
                    },
                    compositionstart: function(view) {
                        var state = view.state, dispatch = view.dispatch;
                        var tr = state.tr, schema = state.schema;
                        var selection = state.selection;
                        if (selection.gapCursorType === "afterInlineNode" && selection.targetNode && selection.targetNode.type === schema.nodes.status) {
                            // 如果当前为中文输入，且选区为状态宏后方的 GapCursor，需要动态创建一个零宽度字符进行占位
                            // 否则会出现中文进入到状态宏内部的情况。https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/41581776
                            composing = {
                                pos: selection.anchor
                            };
                            dispatch(tr.insertText(ZERO_WIDTH_SPACE).setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, selection.anchor + 1)));
                        }
                        return false;
                    },
                    compositionend: function(view) {
                        if (composing) {
                            var _view_state_doc_nodeAt, _view_state_doc_nodeAt_text;
                            // 如果当前为中文输入，且选区为状态宏后方的 GapCursor，需要在输入完成后清除动态创建的零宽度字符
                            var state = view.state, dispatch = view.dispatch;
                            var tr = state.tr;
                            if ((_view_state_doc_nodeAt = view.state.doc.nodeAt(composing.pos)) === null || _view_state_doc_nodeAt === void 0 ? void 0 : (_view_state_doc_nodeAt_text = _view_state_doc_nodeAt.text) === null || _view_state_doc_nodeAt_text === void 0 ? void 0 : _view_state_doc_nodeAt_text.startsWith(ZERO_WIDTH_SPACE)) {
                                // 增加零宽度字符的判断，防止删除错误
                                dispatch(tr.delete(composing.pos, composing.pos + 1));
                            }
                            composing = null;
                        }
                        return false;
                    },
                    keydown: function(view, e) {
                        var state = view.state, dispatch = view.dispatch;
                        var tr = state.tr, schema = state.schema, selection = state.selection;
                        var from = selection.from, $from = selection.$from, to = selection.to;
                        var status = schema.nodes.status;
                        var node = selection.node;
                        var keyCode = e.keyCode || e.which;
                        if (keyCode === KEY_CODE_BACKSPACE) {
                            return false;
                        }
                        // 此时为选中状态宏，非中文输入法时覆盖原有内容
                        if (node && node.type === status) {
                            tr.setSelection(// 设置选区为零宽度字符之后的文本区域
                            prosemirror_state_dist["TextSelection"].create(tr.doc, from + 2, from + node.nodeSize - 1));
                            dispatch(tr);
                            return true;
                        }
                        // 选择内部文字进行输入
                        if ($from.parent && $from.parent.type === status && !$from.nodeBefore) {
                            // 设置选区到零宽度字符之后的位置
                            tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, from + 1, to));
                            dispatch(tr);
                            return true;
                        }
                        return false;
                    }
                }
            },
            view: function(view) {
                return new status_extension_StylePopover(view, {
                    bottomFirst: true
                });
            }
        });
    };
    _proto.keys = function keys() {
        return {
            Backspace: status_extension_handleBackspace,
            "Mod-Backspace": status_extension_handleBackspace,
            // Delete: handleBackspace, delete行为不应该应用backspace的逻辑，暂时注释，需要后续明确定义delete的规则，再做处理
            // "Mod-Delete": handleBackspace,
            Enter: handleEnter,
            Tab: handleEnter
        };
    };
    _proto.clipboardSerializer = function clipboardSerializer(param) {
        var type = param.type;
        var toDOM = type.spec.toDOM;
        return _defineProperty$3({}, type.name, function(node) {
            var outputSpec = toDOM(node);
            // 参考文档 https://prosemirror.net/docs/ref/#model.DOMOutputSpec
            if (node.textContent.indexOf(ZERO_WIDTH_SPACE) !== 0 && outputSpec.length > 2 && outputSpec[2] === 0) {
                return [
                    outputSpec[0],
                    outputSpec[1],
                    [
                        "span",
                        ZERO_WIDTH_SPACE
                    ],
                    [
                        "span",
                        0
                    ]
                ];
            }
            return outputSpec;
        });
    };
    _proto.clipboardParser = function clipboardParser(param) {
        var type = param.type;
        var parseDOM = type.spec.parseDOM;
        return parseDOM.map(function(_) {
            return status_extension_objectSpreadProps(_objectSpread$3({}, _), {
                node: type.name,
                getContent: function(dom, schema) {
                    var textContent = dom.textContent;
                    var node = schema.text("".concat(textContent.indexOf(ZERO_WIDTH_SPACE) === 0 ? "" : ZERO_WIDTH_SPACE).concat(textContent));
                    return dist["Fragment"].from(node);
                }
            });
        });
    };
    status_extension_createClass(StatusExtension, [
        {
            key: "name",
            get: function get() {
                return "status";
            }
        }
    ]);
    return StatusExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/task-item-extension/index.js










/**
 * 统一样式前缀
 */ var task_item_extension_CLASSNAME_PREFIX = "ct";

var task_item_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : task_item_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var task_item_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var task_item_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return task_item_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var task_item_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function task_item_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function task_item_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            task_item_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function task_item_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function task_item_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        task_item_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var task_item_extension_listTypes = [
    "bullet_list",
    "ordered_list",
    "task_list"
];
// 获取列表项结尾到下一行开头的 pos 距离
function task_item_extension_distanceFromItemEndToNextlineStart(listNode) {
    var dis = 4; // 空的一级列表到下一行开头的距离为 4
    var curNode = listNode;
    // 列表每增加一级，距离加 2
    while(true){
        curNode = curNode.lastChild.lastChild;
        if (!task_item_extension_listTypes.includes(curNode.type.name)) break;
        dis += 2;
    }
    if (![
        "paragraph",
        "heading"
    ].includes(curNode.type.name)) dis -= 1;
    return dis;
}
function toggleTaskItem(state, dispatch, pos) {
    var schema = state.schema, tr = state.tr;
    var nodeSelection;
    try {
        nodeSelection = prosemirror_state_dist["NodeSelection"].create(state.doc, pos);
    } catch (err) {
        return false;
    }
    var node = nodeSelection.node;
    if (node.type === schema.nodes.task_item) {
        var attrs = node.attrs;
        dispatch(tr.setNodeMarkup(pos, null, task_item_extension_objectSpreadProps(task_item_extension_objectSpread({}, attrs), {
            checked: !attrs.checked
        })));
        return true;
    }
    return false;
}
function task_item_extension_liftToOuterList(tr, itemType, range) {
    var transaction = tr;
    var end = range.end;
    var endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](end - 1, endOfList, end, endOfList, new dist["Slice"](dist["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new dist["NodeRange"](transaction.doc.resolve(range.$from.pos), transaction.doc.resolve(endOfList), range.depth);
    }
    return transaction.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range));
}
function task_item_extension_liftOutOfList(tr, range) {
    var transaction = tr;
    var list = range.parent;
    // Merge the list items into a single big item
    for(var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        transaction.delete(pos - 1, pos + 1);
    }
    var $start = transaction.doc.resolve(range.start);
    var item = $start.nodeAfter;
    var atStart = range.startIndex === 0;
    var atEnd = range.endIndex === list.childCount;
    var parent = $start.node(-1);
    var indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list)))) {
        return false;
    }
    var start = $start.pos;
    var end = start + item.nodeSize;
    // 单独处理 data-diff-id 问题，后半段的 list 认为是新的 list，data-diff-id 重新生成
    // 详见 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60669246
    var newList = list.copy(dist["Fragment"].empty);
    newList.attrs = task_item_extension_objectSpread({}, newList.attrs);
    newList.attrs.dataDiffId = "ct-diff-id-".concat(esm_browser_v4());
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new dist["Slice"]((atStart ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty))).append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(newList)), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    return transaction;
}
// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function task_item_extension_liftListItem(itemType) {
    return function(tr, selRange) {
        var transaction = tr;
        var $from = selRange.$from, $to = selRange.$to;
        var range = $from.blockRange($to, function(node) {
            return node.childCount && node.firstChild.type === itemType;
        });
        if (!range) return false;
        if ($from.node(range.depth - 1).type === itemType) {
            // Inside a parent list
            return task_item_extension_liftToOuterList(transaction, itemType, range);
        }
        // Outer list node
        return task_item_extension_liftOutOfList(transaction, range);
    };
}

function task_item_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function task_item_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return task_item_extension_arrayLikeToArray(arr);
}
function task_item_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function task_item_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function task_item_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function task_item_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function task_item_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            task_item_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function task_item_extension_ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function task_item_extension_objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        task_item_extension_ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function task_item_extension_toConsumableArray(arr) {
    return task_item_extension_arrayWithoutHoles(arr) || task_item_extension_iterableToArray(arr) || task_item_extension_unsupportedIterableToArray(arr) || task_item_extension_nonIterableSpread();
}
function task_item_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return task_item_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return task_item_extension_arrayLikeToArray(o, minLen);
}
var task_item_extension_splitListItem = function(itemType) {
    var provider = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    return function(state, dispatch) {
        var tr = state.tr;
        var selection = state.selection;
        // 光标在inline节点末尾（如链接），纠正光标的位置
        var $anchor = selection.$anchor, from = selection.from;
        if (!$anchor.parent.type.isBlock && !$anchor.nodeAfter) {
            var predicate = function(n) {
                return n.type && [
                    "paragraph",
                    "heading"
                ].includes(n.type.name);
            };
            var node = task_item_extension_findParentNode(predicate)(selection);
            if (!node) return false;
            var pos = node.pos + node.node.nodeSize - 1;
            selection = prosemirror_state_dist["TextSelection"].create(state.doc, pos);
            tr.setSelection(selection);
        }
        var $from = selection.$from, $to = selection.$to;
        if (!task_item_extension_canInsertTypes(state)) return false;
        if (task_item_extension_instanceof(selection, prosemirror_state_dist["NodeSelection"]) && selection.node.isBlock || // 当前光标在块节点后
        $from.depth < 2 || // 当前光标所在深度小于2，说明一定不再列表项里
        !$from.sameParent($to) // 跨节点选区
        ) {
            return false;
        }
        var itemNode = $from.node(-1);
        // itemNode.type 存在 list_item、task_item 两种情况
        if (itemNode.type !== itemType) return false;
        // 列表项首个子节点为空（一个列表项可能有多个 paragraph），将下方的列表项提升或脱离
        if ($from.parent === itemNode.firstChild && $from.parent.content.size === 0) {
            task_item_extension_liftListItem(itemType)(tr, {
                $from: $from,
                $to: $to
            });
            dispatch(tr);
            return true;
        }
        var nextType = $to.pos === $from.end() ? itemNode.contentMatchAt(0).defaultType : null;
        tr.delete($from.pos, $to.pos);
        var types = nextType && [
            null,
            {
                type: nextType,
                attrs: task_item_extension_objectSpread$1({}, $from.node().attrs)
            }
        ];
        // TODO：暂时没有找到不能 split 的例子，单测待补充
        if (!Object(prosemirror_transform_dist["canSplit"])(tr.doc, $from.pos, 2, types)) return false;
        var atStart = itemNode.firstChild === $to.node() && $to.parentOffset === 0;
        var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, task_item = _state_schema_nodes.task_item, list_item = _state_schema_nodes.list_item, paragraph = _state_schema_nodes.paragraph;
        if (atStart) {
            // 在开头回车 - 等同于将下一行原封不动(diff-id等属性)下移一行
            var pos1 = task_item_extension_findParentNode(function(n) {
                return [
                    task_item,
                    list_item
                ].includes(n.type);
            })(selection).pos;
            tr.insert(pos1, itemNode.type.createAndFill({
                dataListItemDiffId: "ct-list-item-diff-id-".concat(esm_browser_v4())
            }));
            dispatch(tr.scrollIntoView());
            return true;
        }
        // 任务列表特殊处理
        if (itemNode.type === task_item) {
            // 任务列表要考虑checked属性
            var pos2 = task_item_extension_findParentNode(function(n) {
                return n.type === task_item;
            })(selection).pos;
            tr.setNodeMarkup(pos2, null, task_item_extension_objectSpreadProps$1(task_item_extension_objectSpread$1({}, itemNode.attrs), {
                dataListItemDiffId: "ct-list-item-diff-id-".concat(esm_browser_v4())
            }));
            var task_item_type = {
                type: task_item,
                attrs: task_item_extension_objectSpreadProps$1(task_item_extension_objectSpread$1({}, $from.node().attrs), {
                    checked: false
                })
            };
            var typesAfter = [
                task_item_type
            ];
            if (types) {
                typesAfter = [
                    task_item_type,
                    types[1]
                ];
            }
            tr.split($from.pos, 2, typesAfter);
        } else {
            // 否则按照新diff-id的原则split
            tr.split(tr.mapping.map($from.pos), 2, [
                {
                    type: list_item,
                    attrs: {
                        dataListItemDiffId: "ct-list-item-diff-id-".concat(esm_browser_v4())
                    }
                },
                {
                    type: paragraph,
                    attrs: {
                        dataDiffId: "ct-diff-id-".concat(esm_browser_v4())
                    }
                }
            ]);
        }
        var marks = state.storedMarks || $to.parentOffset && $from.marks() || [];
        // 沿用当前节点的 mark
        if (marks) {
            if (provider) {
                // 下面的处理是为了支持通过配置去除切分块级元素时不需要保留的Mark，例如划词评论的引用
                var newMarks = task_item_extension_toConsumableArray(marks);
                newMarks.forEach(function(mark, index) {
                    var _provider_excludeMarkNames, _provider_excludeMarkNames1;
                    if (provider.excludeMarkNames && ((_provider_excludeMarkNames = provider.excludeMarkNames) === null || _provider_excludeMarkNames === void 0 ? void 0 : _provider_excludeMarkNames.length) > 0 && ((_provider_excludeMarkNames1 = provider.excludeMarkNames) === null || _provider_excludeMarkNames1 === void 0 ? void 0 : _provider_excludeMarkNames1.indexOf(mark.type.name)) !== -1) {
                        newMarks.splice(index, 1);
                    }
                    tr.ensureMarks(newMarks);
                });
            } else {
                tr.ensureMarks(marks);
            }
        }
        dispatch(tr.scrollIntoView());
        return true;
    };
};

function task_item_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var task_item_extension_isGapCursorBeforeNode = function(selection) {
    if (task_item_extension_instanceof$1(selection, GapcursorSelection["a" /* GapCursor */])) {
        return [
            GapcursorSelection["d" /* gapCursorSituation */].beforeNode
        ].includes(selection.gapCursorType);
    }
    return false;
};
var task_item_extension_backspaceInList = function(itemType) {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item, bullet_list = _schema_nodes.bullet_list, ordered_list = _schema_nodes.ordered_list, task_list = _schema_nodes.task_list, doc = _schema_nodes.doc;
        var itemTypes = [
            list_item,
            task_item
        ];
        var listTypes = [
            bullet_list,
            ordered_list,
            task_list
        ];
        var $from = selection.$from, from = selection.from, $to = selection.$to, to = selection.to;
        var $cursor = task_item_extension_instanceof$1(selection, prosemirror_state_dist["TextSelection"]) ? selection.$cursor : task_item_extension_instanceof$1(selection, GapcursorSelection["a" /* GapCursor */]) ? selection.$head : null;
        // 光标在行首且单光标
        if ($from.parentOffset === 0) {
            var fromNodeParent = $from.node(-1);
            // 此时如果是 gapcursor，且前面没有节点，说明在文档首位
            if (!fromNodeParent) return false;
            if ($cursor) {
                // 如果光标在行内模块中（如链接前），向前移1个位置
                if ($cursor.parent.isInline) $cursor = tr.doc.resolve($cursor.pos - 1);
                var cursorNode = task_item_extension_isGapCursorBeforeNode(selection) ? selection.targetNode : $cursor.node();
                var cursorNodeParent = task_item_extension_isGapCursorBeforeNode(selection) ? $cursor.node() : $cursor.node(-1);
                // 光标在列表项的首个子节点中（一个列表项可能有多个 paragraph，如果不是首个子节点则走默认的Backspace事件）
                if (itemTypes.includes(cursorNodeParent.type) && cursorNode === cursorNodeParent.firstChild) {
                    /** 获取以当前项为一级的整个列表节点，如：
         *  1. 111
         *    a. 222
         *    b. 333
         *      i. 444
         * 光标在 "b. " 后时，获取的 listNode 内容包含：222333444
         */ var range = $cursor.blockRange($cursor, function(node) {
                        return node.childCount && node.firstChild.type === cursorNodeParent.type;
                    });
                    if (!range) return false; // TODO：暂时没有找到 range 非法的例子，单测待补充
                    var listNode = range.parent;
                    // 不是 listNode 的首个子列表项
                    if (listNode.content.firstChild !== cursorNodeParent) {
                        var _$cursor_nodeAfter;
                        var isAfterBlock = (_$cursor_nodeAfter = $cursor.nodeAfter) === null || _$cursor_nodeAfter === void 0 ? void 0 : _$cursor_nodeAfter.isBlock;
                        // block 前要多删除 p 标签
                        var offsetStartPos = isAfterBlock ? 2 : 3;
                        tr.delete($cursor.pos - offsetStartPos, $cursor.pos);
                        dispatch(tr);
                        return true;
                    }
                    // 当前的列表类型与调用command的extension类型不匹配时，不执行liftListItem
                    if (listNode.type === task_list && itemType === list_item || listNode.type !== task_list && itemType === task_item) {
                        return false;
                    }
                    // 计算 listNode 后面是否还有元素
                    var $end = tr.doc.resolve(range.end);
                    var listRange = $end.blockRange($end);
                    var end = listRange.end;
                    var endOfList = listRange.$to.end(listRange.depth);
                    var isHaveNodeAfterListNode = end < endOfList;
                    var result = task_item_extension_liftListItem(itemType)(tr, selection);
                    // fix ones#68740873 【学城2.0】删除完一个待办事项（任务框），出现两个
                    // 执行了 liftListItem 且 listNode 后面有元素，说明后面元素需要删掉 list_item/task_item
                    if (result && itemTypes.includes(listRange.parent.type) && isHaveNodeAfterListNode) {
                        var mappedEnd = tr.mapping.map(listRange.end);
                        tr.delete(mappedEnd - 2, mappedEnd);
                    }
                    dispatch(tr);
                    return !!result;
                }
                // 光标上一行的 node，如果光标在文档首位则为 null
                // 光标不在文档首位，且$cursor为TextSelection，$cursor.pos >= 1
                var preRowNode = $cursor.pos === 1 ? null : tr.doc.resolve($cursor.pos - 2).parent;
                // 上一行是列表
                if (preRowNode && listTypes.includes(preRowNode.type)) {
                    var distance = task_item_extension_distanceFromItemEndToNextlineStart(preRowNode);
                    var newPos = $cursor.pos - distance; // 上一行列表项末尾的位置
                    // 如果光标后没有内容，则直接删除该行，否则将后面内容拼接到上一行的列表项后
                    var lineStartPos = $cursor.pos - 1;
                    if (!$to.nodeAfter) {
                        tr.delete(lineStartPos, to + 1);
                        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
                    } else {
                        var cursorNodeSize = cursorNode.nodeSize;
                        // 特殊处理当前节点是父节点是 doc 的最后一个节点时，多保留一个空行
                        if (cursorNodeParent.lastChild === cursorNode && cursorNodeParent.type === doc) {
                            tr.delete(lineStartPos, lineStartPos + cursorNodeSize - 1);
                        } else {
                            tr.delete(lineStartPos, lineStartPos + cursorNodeSize);
                        }
                        tr.insert(newPos, cursorNode.content);
                        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
                    }
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        }
        // 找到 from to 所属的 listNode
        var predicate = function(n) {
            return n.type && listTypes.includes(n.type);
        };
        var fromNode = task_item_extension_findParentNode(predicate)(selection);
        var toNode = task_item_extension_findParentNodeClosestToPos($to, predicate);
        // 跨节点删除，且 $to 所在的列表项完全删除（之后无内容需要与前面拼接）
        if (toNode && (!fromNode || fromNode.node !== toNode.node) && $to.parentOffset === $to.node().content.size) {
            /**
     * 以 <ul><li><p>123</p><ul><li><p>456</p><ul><li><p>789</p></li></ul></li></ul></li></ul> 为例
     * 如果 to 在 6 之后，则会删除 </p><ul><li>
     * 如果 to 在 9 之后，则会删除 </p></li></ul>
     */ tr.delete(from, to + 3);
            tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, from));
            dispatch(tr);
            return true;
        }
        /**
   * fix: ONES #67985267 如果from位置在列表里，则执行自定义的删除逻辑 (缺点：cut的时候还是会跳动)
   * fix: ONES #69076581 【2.0】列表项中的表格无法删除，预期是可以正常删除
   * @see https://km.sankuai.com/collabpage/1336274120
   */ var needCustomDelSel = !!fromNode && task_item_extension_instanceof$1(selection, prosemirror_state_dist["TextSelection"]);
        if (needCustomDelSel) {
            if (state.selection.empty) return false;
            if (dispatch) {
                tr.delete(from, to);
                tr.scrollIntoView();
                dispatch(tr);
                return true;
            }
        }
        return false;
    };
};

var task_item_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function task_item_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var TaskItemNodeView = /*#__PURE__*/ function() {
    function TaskItemNodeView(node) {
        task_item_extension_classCallCheck(this, TaskItemNodeView);
        this.dom = document.createElement("li");
        this.dom = document.createElement("li");
        this.addClass(node);
        this.contentDOM = this.dom;
    }
    var _proto = TaskItemNodeView.prototype;
    _proto.update = function update(node) {
        this.addClass(node);
        return true;
    };
    _proto.addClass = function addClass(node) {
        var firstChild = node.firstChild, _node_attrs = node.attrs, dataListItemDiffId = _node_attrs.dataListItemDiffId, checked = _node_attrs.checked;
        var className = checked ? "ct-task-li-checked" : "ct-task-li";
        if (firstChild && firstChild.type.name === "heading") {
            this.dom.className = "".concat(className, " ").concat(task_item_extension_classNamePrefix("item-level-".concat(firstChild.attrs.level)));
        } else {
            this.dom.className = className;
        }
        this.dom.setAttribute("data-type", "task_item");
        this.dom.setAttribute("data-list-item-diff-id", dataListItemDiffId);
    };
    return TaskItemNodeView;
}();

function task_item_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var task_item_extension_css_248z = "li.ProseMirror-selectednode:after{display:none}.ct-hidden-item{list-style:none}";
task_item_extension_styleInject(task_item_extension_css_248z);

function task_item_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function task_item_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function task_item_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function task_item_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) task_item_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) task_item_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function task_item_extension_getPrototypeOf(o) {
    task_item_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return task_item_extension_getPrototypeOf(o);
}
function task_item_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) task_item_extension_setPrototypeOf(subClass, superClass);
}
function task_item_extension_possibleConstructorReturn(self, call) {
    if (call && (task_item_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return task_item_extension_assertThisInitialized(self);
}
function task_item_extension_setPrototypeOf(o, p) {
    task_item_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return task_item_extension_setPrototypeOf(o, p);
}
var task_item_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function task_item_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function task_item_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = task_item_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = task_item_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = task_item_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return task_item_extension_possibleConstructorReturn(this, result);
    };
}
var task_item_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("taskItem");
var task_item_extension_TaskItemExtension = /*#__PURE__*/ function(NodeExtension) {
    task_item_extension_inherits(TaskItemExtension, NodeExtension);
    var _super = task_item_extension_createSuper(TaskItemExtension);
    function TaskItemExtension() {
        task_item_extension_classCallCheck$1(this, TaskItemExtension);
        return _super.apply(this, arguments);
    }
    var _proto = TaskItemExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state_dist["Plugin"]({
            key: task_item_extension_pluginKey,
            props: {
                handleDOMEvents: {
                    mousedown: function mousedown(view, e) {
                        var target = e.target;
                        if (target.getAttribute("data-type") !== "task_item") return false;
                        var state = view.state, dispatch = view.dispatch;
                        var pos = view.posAtCoords({
                            left: e.clientX,
                            top: e.clientY
                        });
                        if (toggleTaskItem(state, dispatch, pos.pos)) {
                            e.preventDefault(); // 不触发光标位置的改变
                            return true;
                        }
                        return false;
                    }
                },
                nodeViews: {
                    task_item: function(node) {
                        return new TaskItemNodeView(node);
                    }
                }
            }
        });
    };
    _proto.keys = function keys(param) {
        var type = param.type, providers = param.providers;
        var taskItemProvider = providers.get(this.name);
        return {
            Enter: task_item_extension_convertCommand(task_item_extension_splitListItem(type, taskItemProvider)),
            Backspace: task_item_extension_convertCommand(task_item_extension_backspaceInList(type))
        };
    };
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            liftListItem: function() {
                return liftListItem(type);
            },
            sinkListItem: function() {
                return sinkListItem(type);
            }
        };
    };
    task_item_extension_createClass(TaskItemExtension, [
        {
            key: "name",
            get: function get() {
                return "task_item";
            }
        }
    ]);
    return TaskItemExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/task-list-extension/index.js










/**
 * 零宽度空格
 */ var task_list_extension_ZERO_WIDTH_SPACE = "​";

// 获取浏览器和系统信息
function task_list_extension_getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

var task_list_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var task_list_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return task_list_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var task_list_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function task_list_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function task_list_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function task_list_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            task_list_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function task_list_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function task_list_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        task_list_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var task_list_extension_listTypes = [
    "bullet_list",
    "ordered_list",
    "task_list"
];
var task_list_extension_itemTypes = [
    "list_item",
    "task_item"
];
function task_list_extension_doWrapInList(tr, range, wrappers, joinBefore, listType, isSelectRange) {
    var content = dist["Fragment"].empty;
    for(var i = wrappers.length - 1; i >= 0; i--){
        // 新增列表时如果遇到需要被序列为列表的内容有缩进的情况 需要把缩进属性添加到列表上并去除列表序列内容的缩进
        var attrs = null;
        if (!isSelectRange && wrappers[i].type === listType) {
            attrs = {
                indent: range.$from.parent.attrs.indent
            };
        }
        content = dist["Fragment"].from(wrappers[i].type.create(attrs || wrappers[i].attrs, content));
    }
    tr.step(new prosemirror_transform_dist["ReplaceAroundStep"](range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new dist["Slice"](content, 0, 0), wrappers.length, true));
    var found = 0;
    for(var i1 = 0; i1 < wrappers.length; i1++){
        if (wrappers[i1].type === listType) found = i1 + 1;
    }
    var splitDepth = wrappers.length - found;
    var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    var parent = range.parent;
    var childNodes = [];
    for(var i2 = range.startIndex, e = range.endIndex, first = true; i2 < e; i2++, first = false){
        var childNode = parent.child(i2);
        childNodes.push(childNode);
        if (!first && Object(prosemirror_transform_dist["canSplit"])(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i2).nodeSize;
    }
    // 去除列表序列内容的缩进
    tr.doc.nodesBetween(range.start, /**
     * range 的 start和end信息只能包含序列内容的范围 列表的结构如下 子节点length*2代表li标签的范围， +2代表外层ul/ol标签的范围
     * 三者相加之后才可以完整包含整个列表的范围
     * <ol>
     *    <li>序列内容</li>
     *    ...
     * </ol>
     */ range.end + childNodes.length * 2 + 2, function(node, pos) {
        if (childNodes.includes(node) && node.attrs.indent !== 0) {
            tr.setNodeMarkup(pos, null, task_list_extension_objectSpreadProps(task_list_extension_objectSpread({}, node.attrs), {
                indent: 0
            }));
        }
    });
    return tr;
}
function task_list_extension_liftToOuterList(tr, itemType, range) {
    var transaction = tr;
    var end = range.end;
    var endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](end - 1, endOfList, end, endOfList, new dist["Slice"](dist["Fragment"].from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new dist["NodeRange"](transaction.doc.resolve(range.$from.pos), transaction.doc.resolve(endOfList), range.depth);
    }
    return transaction.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range));
}
function task_list_extension_liftOutOfList(tr, range) {
    var transaction = tr;
    var list = range.parent;
    // Merge the list items into a single big item
    for(var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        transaction.delete(pos - 1, pos + 1);
    }
    var $start = transaction.doc.resolve(range.start);
    var item = $start.nodeAfter;
    var atStart = range.startIndex === 0;
    var atEnd = range.endIndex === list.childCount;
    var parent = $start.node(-1);
    var indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(list)))) {
        return false;
    }
    var start = $start.pos;
    var end = start + item.nodeSize;
    // 单独处理 data-diff-id 问题，后半段的 list 认为是新的 list，data-diff-id 重新生成
    // 详见 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60669246
    var newList = list.copy(dist["Fragment"].empty);
    newList.attrs = task_list_extension_objectSpread({}, newList.attrs);
    newList.attrs.dataDiffId = "ct-diff-id-".concat(esm_browser_v4());
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    transaction.step(new prosemirror_transform_dist["ReplaceAroundStep"](start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new dist["Slice"]((atStart ? dist["Fragment"].empty : dist["Fragment"].from(list.copy(dist["Fragment"].empty))).append(atEnd ? dist["Fragment"].empty : dist["Fragment"].from(newList)), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    return transaction;
}
// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function task_list_extension_wrapInList(listType, attrs) {
    return function(tr, selRange) {
        var $to = selRange.$to;
        var $from = selRange.$from;
        // 根据 schema ，list_item 里面必须是 block 节点 如果 $from.parent 不是 block 先矫正 $from
        if (!$from.parent.isBlock) {
            var parentBlockNode = task_list_extension_findParentNode(function(node) {
                return node.type.isBlock;
            })(selRange);
            $from = tr.doc.resolve(parentBlockNode.pos);
        }
        var transaction = tr;
        var range = $from.blockRange($to);
        // 光标（gaocursor）在块级元素前后时，需要设置 range 为该块元素，否则会无法设置列表
        if (task_list_extension_instanceof(selRange, GapcursorSelection["a" /* GapCursor */])) {
            if (selRange.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].afterNode && $from.nodeBefore) {
                range = new dist["NodeRange"](tr.doc.resolve($from.pos - $from.nodeBefore.nodeSize), $from, $from.depth);
            }
            if (selRange.gapCursorType === GapcursorSelection["d" /* gapCursorSituation */].beforeNode && $from.nodeAfter) {
                range = new dist["NodeRange"]($from, tr.doc.resolve($from.pos + $from.nodeAfter.nodeSize), $from.depth);
            }
        }
        var doJoin = false;
        var outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            var $insert = transaction.doc.resolve(range.start - 2);
            outerRange = new dist["NodeRange"]($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) {
                range = new dist["NodeRange"]($from, transaction.doc.resolve($to.end(range.depth)), range.depth);
            }
            doJoin = true;
        }
        var wrap = Object(prosemirror_transform_dist["findWrapping"])(outerRange, listType, attrs, range);
        if (!wrap) return false;
        var fromParent = $from.parent;
        var toParent = $to.parent;
        var isSelectRange = fromParent !== toParent || fromParent.type.name === "doc" && toParent.type.name === "doc";
        return task_list_extension_doWrapInList(transaction, range, wrap, doJoin, listType, isSelectRange);
    };
}
// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function task_list_extension_liftListItem(itemType) {
    return function(tr, selRange) {
        var transaction = tr;
        var $from = selRange.$from, $to = selRange.$to;
        var range = $from.blockRange($to, function(node) {
            return node.childCount && node.firstChild.type === itemType;
        });
        if (!range) return false;
        if ($from.node(range.depth - 1).type === itemType) {
            // Inside a parent list
            return task_list_extension_liftToOuterList(transaction, itemType, range);
        }
        // Outer list node
        return task_list_extension_liftOutOfList(transaction, range);
    };
}
function task_list_extension_findListParentNode(selection) {
    // 找离当前光标最近的容器节点（不算 list_item 类型）
    var conatinerNode = task_list_extension_findParentNode(function(n) {
        return n.isBlock && !n.isTextblock && !task_list_extension_itemTypes.includes(n.type.name);
    })(selection);
    // 如果最近的容器节点是 list 类型，则返回该节点，否则返回 Null
    return conatinerNode && task_list_extension_listTypes.includes(conatinerNode.node.type.name) ? conatinerNode : null;
}

// import { liftListItem } from "prosemirror-schema-list";
var task_list_extension_handleListClick = function(listType) {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item, bullet_list = _schema_nodes.bullet_list, ordered_list = _schema_nodes.ordered_list, task_list = _schema_nodes.task_list;
        var itemTypes = [
            list_item,
            task_item
        ];
        var listTypes = [
            bullet_list,
            ordered_list,
            task_list
        ];
        var transaction = tr;
        if (selection.forEachCell) {
            selection.ranges.forEach(function(originRange, i) {
                // 当前面的range增加列表后，range的位置发生改变，需要用 transaction.selection
                var _transaction_selection_ranges_i = transaction.selection.ranges[i], $from = _transaction_selection_ranges_i.$from, $to = _transaction_selection_ranges_i.$to;
                var range = $from.blockRange($to);
                if (!range) return false;
                var listNode = $from.parent.firstChild;
                // 当前不在任何列表中，新增列表
                if (!listNode || listNode.type !== listType) {
                    var newTr = task_list_extension_wrapInList(listType)(transaction, range);
                    if (!newTr) return false;
                    transaction = newTr;
                } else {
                    var trueSelection = prosemirror_state_dist["TextSelection"].create(transaction.doc, $from.pos + 2, $to.pos - 2);
                    var itemType = listType === task_list ? task_item : list_item;
                    var trueRange = trueSelection.$from.blockRange(trueSelection.$to, function(node) {
                        return node.childCount && node.firstChild.type === itemType;
                    });
                    if (!trueRange) return false;
                    // 选中的列表类型与当前的列表类型一致，提升列表
                    var newTr1 = task_list_extension_liftOutOfList(transaction, trueRange);
                    if (!newTr1) return false;
                    transaction = newTr1;
                }
            });
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        // 如果最近的容器节点是 list 类型，则是改变当前列表类型，否则是新增列表
        var listNodeInSelFrom = task_list_extension_findListParentNode(selection);
        // 当前selection.from不在任何列表中，新增列表
        if (!listNodeInSelFrom) {
            transaction = task_list_extension_wrapInList(listType)(transaction, selection);
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        var listNodes = [];
        // 遍历选区，找到所有列表节点
        transaction.doc.nodesBetween(selection.from, selection.to, function(node, pos) {
            // 当前节点在选区内（list至少长度为4）
            if (listTypes.includes(node.type) && pos + 4 > listNodeInSelFrom.pos) {
                listNodes.push({
                    node: node,
                    pos: pos
                });
            }
        });
        listNodes.forEach(function(listNode) {
            var listNodePos = transaction.mapping.map(listNode.pos);
            // 提升列表时，只对当前选区内的列表节点进行操作
            var from = Math.max(listNodePos + 1, transaction.selection.from);
            var to = Math.min(listNode.node.nodeSize + listNodePos - 1, transaction.selection.to);
            // 选中的列表类型与当前的列表类型一致，提升列表
            var itemType = listType === task_list ? task_item : list_item;
            if (listNode.node.type === listType) {
                var newTr = task_list_extension_liftListItem(itemType)(transaction, {
                    $from: transaction.doc.resolve(from),
                    $to: transaction.doc.resolve(to)
                });
                if (newTr) {
                    transaction = newTr;
                    return;
                }
            }
            // 转换列表类型
            from = listNodePos;
            to = listNode.node.nodeSize + from;
            // 转换当前列表类型为选中的类型
            transaction.doc.nodesBetween(from, to, function(node, pos) {
                if (listTypes.includes(node.type) && node.type !== listType) {
                    // 当前节点在选区内（list至少长度为4）
                    if (pos + 4 > from) {
                        transaction = transaction.setNodeMarkup(pos, listType, node.attrs);
                    }
                } else if (itemTypes.includes(node.type) && node.type !== itemType) {
                    // 当前节点在选区内（listItem至少长度为2）
                    if (pos + 2 > from) {
                        transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
                    }
                }
            });
        });
        dispatch(transaction);
        return true;
    };
};

var task_list_extension_isListActive = function(type) {
    return function() {
        return function(state) {
            var listNode = task_list_extension_findListParentNode(state.selection);
            return listNode && listNode.node.type === type;
        };
    };
};

var task_list_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(task_list_extension_ExtensionType || (task_list_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var task_list_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var task_list_extension_isCommonDisabled = function() {
    return function(state) {
        return !task_list_extension_canInsertTypes(state);
    };
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 任务列表
var regexpTaskList = /^\[]\s$/;

var task_list_extension_IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var task_list_extension_Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(task_list_extension_Keycodes || (task_list_extension_Keycodes = {}));

function task_list_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var task_list_extension_css_248z = '.pm-body-wrapper ul,.ProseMirror ul{margin:8px 0;padding-left:24px}.pm-body-wrapper ul li,.ProseMirror ul li{min-height:24px;font-size:14px}.pm-body-wrapper ul>h1,.pm-body-wrapper ul>h2,.pm-body-wrapper ul>h3,.pm-body-wrapper ul>h4,.pm-body-wrapper ul>h5,.pm-body-wrapper ul>h6,.pm-body-wrapper ul>p,.ProseMirror ul>h1,.ProseMirror ul>h2,.ProseMirror ul>h3,.ProseMirror ul>h4,.ProseMirror ul>h5,.ProseMirror ul>h6,.ProseMirror ul>p{margin:0}.pm-body-wrapper ul .ct-image,.ProseMirror ul .ct-image{vertical-align:top}.pm-body-wrapper ul hr,.ProseMirror ul hr{display:inline-block}.pm-body-wrapper .ct-item-level-1,.ProseMirror .ct-item-level-1{font-size:28px!important}.pm-body-wrapper .ct-item-level-2,.ProseMirror .ct-item-level-2{font-size:24px!important}.pm-body-wrapper .ct-item-level-3,.ProseMirror .ct-item-level-3{font-size:20px!important}.pm-body-wrapper .ct-item-level-4,.ProseMirror .ct-item-level-4{font-size:16px!important}.pm-body-wrapper .ct-item-level-5,.ProseMirror .ct-item-level-5{font-size:14px!important}.pm-body-wrapper .ct-item-level-6,.ProseMirror .ct-item-level-6{font-size:12px!important}ul .ct-item-level-1{margin-left:7px}ul .ct-item-level-2{margin-left:6px}ul .ct-item-level-3{margin-left:3px}ul .ct-item-level-4{margin-left:2px}ul .ct-item-level-6{margin-left:-1px}.ct-task-list{list-style-type:none!important}.ct-task-list li{margin-left:0}.ct-task-list .ct-task-li{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li:before{content:"";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url("data:image/svg+xml,%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg transform%3D%22translate(-57.000000%2C -393.000000)%22 fill%3D%22%236E6B6B%22%3E            %3Cg transform%3D%22translate(56.000000%2C 389.000000)%22%3E                %3Cpath d%3D%22M1%2C4 L17%2C4 L17%2C20 L1%2C20 L1%2C4 Z M2%2C5 L2%2C19 L16%2C19 L16%2C5 L2%2C5 Z%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-task-list .ct-task-li-checked{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li-checked:before{content:"";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url("data:image/svg+xml,%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%2203%E3%80%81%E7%BC%96%E8%BE%91%E9%A1%B5-%E4%BB%BB%E5%8A%A1%E5%88%97%E8%A1%A8%EF%BC%881024%EF%BC%89%22 transform%3D%22translate(-57.000000%2C -497.000000)%22 fill%3D%22%23AAAAAA%22%3E            %3Cg id%3D%22Group-13-Copy%22 transform%3D%22translate(56.000000%2C 493.000000)%22%3E                %3Cg id%3D%22Group-3%22 transform%3D%22translate(1.000000%2C 4.000000)%22%3E                    %3Cpath d%3D%22M12%2C1.11022302e-16 L12%2C1 L1%2C1 L1%2C15 L15%2C15 L15%2C7 L16%2C7 L16%2C16 L0%2C16 L0%2C0 L12%2C0 Z M6.90823822%2C9.72780075 L14.2928932%2C2.34314575 C14.6834175%2C1.95262146 15.3165825%2C1.95262146 15.7071068%2C2.34314575 C16.0976311%2C2.73367004 16.0976311%2C3.36683502 15.7071068%2C3.75735931 L7.63603897%2C11.8284271 C7.43551353%2C12.0289526 7.17101366%2C12.1265127 6.90823822%2C12.1211075 C6.64546278%2C12.1265127 6.38096291%2C12.0289526 6.18043747%2C11.8284271 L2.93779678%2C8.58578644 C2.54727249%2C8.19526215 2.54727249%2C7.56209717 2.93779678%2C7.17157288 C3.32832107%2C6.78104858 3.96148605%2C6.78104858 4.35201034%2C7.17157288 L6.90823822%2C9.72780075 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-task-li-checked:after,.ct-task-li-checked:before,.ct-task-li:before{cursor:pointer}.ct-task-list .ct-item-level-1:before{top:15px}.ct-task-list .ct-item-level-2:before{top:12px}.ct-task-list .ct-item-level-3:before{top:8px}.ct-task-list .ct-item-level-4:before{top:5px}.ct-task-list .ct-item-level-6:before{top:1px}.ct-task-list .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked div,.ct-task-list .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked p,.ct-task-list .ct-task-li-checked span,.ct-task-list .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}';
task_list_extension_styleInject(task_list_extension_css_248z);

function task_list_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function task_list_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function task_list_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function task_list_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) task_list_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) task_list_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function task_list_extension_getPrototypeOf(o) {
    task_list_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return task_list_extension_getPrototypeOf(o);
}
function task_list_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) task_list_extension_setPrototypeOf(subClass, superClass);
}
function task_list_extension_possibleConstructorReturn(self, call) {
    if (call && (task_list_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return task_list_extension_assertThisInitialized(self);
}
function task_list_extension_setPrototypeOf(o, p) {
    task_list_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return task_list_extension_setPrototypeOf(o, p);
}
var task_list_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function task_list_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function task_list_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = task_list_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = task_list_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = task_list_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return task_list_extension_possibleConstructorReturn(this, result);
    };
}
var task_list_extension_pluginKey$1 = new prosemirror_state_dist["PluginKey"]("taskList");
var task_list_extension_TaskListExtension = /*#__PURE__*/ function(NodeExtension) {
    task_list_extension_inherits(TaskListExtension, NodeExtension);
    var _super = task_list_extension_createSuper(TaskListExtension);
    function TaskListExtension() {
        task_list_extension_classCallCheck(this, TaskListExtension);
        return _super.apply(this, arguments);
    }
    var _proto = TaskListExtension.prototype;
    _proto.plugin = function plugin() {
        var showDesc = false; // 判断Decoration是否显示的一个标志位
        return new prosemirror_state_dist["Plugin"]({
            key: task_list_extension_pluginKey$1,
            props: {
                decorations: function decorations(state) {
                    // 不是Safari无需处理，没有任务列表消失的问题 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65305935
                    // 分析文档：https://km.sankuai.com/collabpage/1296547289
                    if (task_list_extension_getSystemInfo().browser !== "Safari" || !showDesc) {
                        return index_es["b" /* DecorationSet */].empty;
                    }
                    var selection = state.selection;
                    var $from = selection.$from;
                    if ($from.depth < 3) {
                        return index_es["b" /* DecorationSet */].empty;
                    } // 任务列表的depth至少为3
                    var grandParentNode = $from.node($from.depth - 2); // 向上两级，深度为2 ul>li  --- task_list>task_item
                    // 不是在任务列表不处理
                    if (grandParentNode && grandParentNode.type.name === "task_list") {
                        var widget = document.createElement("span");
                        widget.innerText = task_list_extension_ZERO_WIDTH_SPACE;
                        var deco = index_es["a" /* Decoration */].widget(selection.to, widget);
                        return index_es["b" /* DecorationSet */].create(state.doc, [
                            deco
                        ]);
                    }
                    return index_es["b" /* DecorationSet */].empty;
                },
                handleDOMEvents: {
                    compositionstart: function() {
                        showDesc = true;
                        return false;
                    },
                    compositionend: function() {
                        showDesc = false;
                        return false;
                    }
                }
            }
        });
    };
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            handleListClick: function() {
                return task_list_extension_handleListClick(type);
            },
            isTaskListActive: task_list_extension_isListActive(type),
            isTaskListDisabled: task_list_extension_isCommonDisabled
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type, getView = param.getView;
        return [
            new prosemirror_inputrules_dist["a" /* InputRule */](new RegExp(regexpTaskList), function(state, match, start, end) {
                var range = state.tr.doc.resolve(start).blockRange();
                var wrapping = range && Object(prosemirror_transform_dist["findWrapping"])(range, type);
                if (!wrapping) return null;
                var view = getView();
                var transaction = view.state.tr.deleteRange(start, end);
                transaction = task_list_extension_wrapInList(type)(transaction, transaction.selection);
                if (transaction) {
                    view.dispatch(transaction);
                    return view.state.tr; // 返回空tr表示已经处理inputRule
                }
                return null;
            })
        ];
    };
    task_list_extension_createClass(TaskListExtension, [
        {
            key: "name",
            get: function get() {
                return "task_list";
            }
        }
    ]);
    return TaskListExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/plantuml-encoder/browser-index.js
var browser_index = __webpack_require__("9ae0");
var browser_index_default = /*#__PURE__*/__webpack_require__.n(browser_index);

// CONCATENATED MODULE: ./node_modules/@it/parker/es/lite-editor/index.js
































function lite_editor_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Providers = function Providers() {
    var _this = this;
    lite_editor_classCallCheck(this, Providers);
    this.registerProvider = function(name, provider) {
        if (!provider) {
            throw new Error("provider of ".concat(name, " not provided"));
        }
        _this.providers.set(name, provider);
    };
    this.providers = new Map();
};

var lite_editor_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(lite_editor_ExtensionType || (lite_editor_ExtensionType = {}));

function lite_editor_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function lite_editor_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                lite_editor_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                lite_editor_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function lite_editor_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var lite_editor_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var lite_editor_AttachmentProvider = /*#__PURE__*/ function() {
    function AttachmentProvider() {
        var _this = this;
        lite_editor_classCallCheck$1(this, AttachmentProvider);
        // 由于可以同时上传多个附件，以 id 为 key 存储不同附件的状态
        this.store = {};
        this.copyCallback = function(res) {};
        this.copy = function(url) {
            var inp = document.createElement("input");
            inp.setAttribute("value", url);
            inp.setAttribute("style", "opacity: 0");
            document.body.append(inp);
            inp.select();
            try {
                if (document.execCommand("Copy")) {
                    _this.copyCallback(true);
                } else {
                    _this.copyCallback(false);
                }
            } catch (err) {
                _this.copyCallback(false);
            }
            inp.remove();
        };
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.upload = function() {
            var _ref = lite_editor_asyncToGenerator(function(file, onProgress) {
                return lite_editor_generator(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            reject(new Error("附件上传方法未定义"));
                        })
                    ];
                });
            });
            return function(file, onProgress) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AttachmentProvider.prototype;
    _proto.beforeUpload = function beforeUpload(file, id) {
        return true;
    };
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AttachmentProvider;
}();

function lite_editor_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function lite_editor_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                lite_editor_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                lite_editor_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function lite_editor_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var lite_editor_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var lite_editor_AudioProvider = /*#__PURE__*/ function() {
    function AudioProvider() {
        lite_editor_classCallCheck$2(this, AudioProvider);
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.beforeUpload = function(file) {
            return true;
        };
        this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("上传方法未定义"));
            });
        };
        this.audioTranscode = function() {
            var _ref = lite_editor_asyncToGenerator$1(function(data, file) {
                return lite_editor_generator$1(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioProvider.prototype;
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AudioProvider;
}();

function lite_editor_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var DrawioProvider = function DrawioProvider() {
    lite_editor_classCallCheck$3(this, DrawioProvider);
    this.serverUrl = "https://km.sankuai.com/draw/index.html?embed=1&ui=atlas&spin=1&proto=json&lang=zh&_t=".concat(Date.now());
    this.upload = function(file, onProgress) {
        return new Promise(function(resolve, reject) {
            reject(new Error("流程图上传方法未定义"));
        });
    };
    this.handleUrl = function(originUrl) {
        return originUrl;
    };
    this.getSvgSource = function(url) {
        return new Promise(function(resolve, reject) {
            reject(new Error("获取svg方法未定义"));
        });
    };
};

function lite_editor_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var HtmlProvider = function HtmlProvider() {
    lite_editor_classCallCheck$4(this, HtmlProvider);
    this.getIframeUrl = function() {
        return new URL("//test01-awp.hfe.test.meituan.com/in/citadel-embed-assets/html/index.html", window.location.href);
    };
};

function lite_editor_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var lite_editor_ImageProvider = function ImageProvider() {
    lite_editor_classCallCheck$5(this, ImageProvider);
};

function lite_editor_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function lite_editor_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function lite_editor_getPrototypeOf(o) {
    lite_editor_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return lite_editor_getPrototypeOf(o);
}
function lite_editor_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) lite_editor_setPrototypeOf(subClass, superClass);
}
function lite_editor_possibleConstructorReturn(self, call) {
    if (call && (lite_editor_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return lite_editor_assertThisInitialized(self);
}
function lite_editor_setPrototypeOf(o, p) {
    lite_editor_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return lite_editor_setPrototypeOf(o, p);
}
var lite_editor_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function lite_editor_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function lite_editor_createSuper(Derived) {
    var hasNativeReflectConstruct = lite_editor_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = lite_editor_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = lite_editor_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return lite_editor_possibleConstructorReturn(this, result);
    };
}
var ImageProvider$1 = /*#__PURE__*/ function(types) {
    lite_editor_inherits(ImageProvider, types);
    var _super = lite_editor_createSuper(ImageProvider);
    function ImageProvider() {
        lite_editor_classCallCheck$6(this, ImageProvider);
        var _this;
        _this = _super.apply(this, arguments);
        _this.formatUrl = function(src) {
            return src;
        };
        _this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("图片上传方法未定义"));
            });
        };
        _this.beforeUpload = function(file, id) {
            return true;
        };
        _this.onSelectFiles = function(files) {
            return true;
        };
        _this.onImageLoad = function(src) {
            // eslint-disable-next-line no-console
            console.log(src, "onImageLoad");
        };
        return _this;
    }
    return ImageProvider;
}(lite_editor_ImageProvider);

function lite_editor_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var MarkdownProvider = function MarkdownProvider() {
    lite_editor_classCallCheck$7(this, MarkdownProvider);
    this.getIframeUrl = function() {
        return new URL("//test01-awp.hfe.test.meituan.com/in/citadel-embed-assets/html/index.html", window.location.href);
    };
};

function lite_editor_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function lite_editor_asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                lite_editor_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                lite_editor_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function lite_editor_classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var lite_editor_generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var MinderProvider = function MinderProvider() {
    lite_editor_classCallCheck$8(this, MinderProvider);
    this.serverUrl = "https://onejs.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/minder/src_v5/index.html";
    this.upload = function(file, onProgress) {
        return new Promise(function(resolve, reject) {
            reject(new Error("思维导图上传方法未定义"));
        });
    };
    this.handleUrl = function(url) {
        return url;
    };
    this.getSvgSource = function() {
        var _ref = lite_editor_asyncToGenerator$2(function(url) {
            return lite_editor_generator$2(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        reject(new Error("获取svg方法未定义"));
                    })
                ];
            });
        });
        return function(url) {
            return _ref.apply(this, arguments);
        };
    }();
    this.customOnMinderExit = function(minderFrame) {};
    this.customOnMinderInited = function(minderFrame) {};
    this.customOnMinderChanged = function(minderFrame, content) {};
    this.customOnMinderSaved = function() {};
};

function lite_editor_classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var lite_editor_PlantUMLProvider = function PlantUMLProvider() {
    lite_editor_classCallCheck$9(this, PlantUMLProvider);
    this.getImgSrc = function(umlContent) {
        return "https://km.sankuai.com/plantuml/svg/".concat(browser_index_default.a.encode(umlContent));
    };
};

function lite_editor_classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var lite_editor_TableProvider = function TableProvider() {
    lite_editor_classCallCheck$a(this, TableProvider);
    this.getScrollWrapper = function() {
        return document.querySelector(".ct-editor");
    };
    this.getTopBias = function() {
        return 28;
    };
    this.getBottomBias = function() {
        return 0;
    };
};

function asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$3(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck$b(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var __generator$3 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var lite_editor_VideoProvider = /*#__PURE__*/ function() {
    function VideoProvider() {
        _classCallCheck$b(this, VideoProvider);
        this.handleVideoError = function(err, url) {};
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.upload = function() {
            var _ref = _asyncToGenerator$3(function(file, onProgress) {
                return __generator$3(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            reject(new Error("上传方法未定义"));
                        })
                    ];
                });
            });
            return function(file, onProgress) {
                return _ref.apply(this, arguments);
            };
        }();
        this.videoTranscode = function() {
            var _ref = _asyncToGenerator$3(function(data, file) {
                return __generator$3(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = VideoProvider.prototype;
    _proto.beforeUpload = function beforeUpload(file, id) {
        return true;
    };
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return VideoProvider;
}();

function _classCallCheck$c(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var LinkProvider = function LinkProvider() {
    _classCallCheck$c(this, LinkProvider);
    this.getLinkTitle = function(href) {
        return new Promise(function(resolve, reject) {
            resolve(null);
        });
    };
    this.canGetTitle = function(href) {
        return false;
    };
};

var __generator$4 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var providerMap = {
    attachment: new lite_editor_AttachmentProvider(),
    table: new lite_editor_TableProvider(),
    link: new LinkProvider(),
    audio: new lite_editor_AudioProvider(),
    drawio: new DrawioProvider(),
    html: new HtmlProvider(),
    image: new ImageProvider$1(),
    markdown: new MarkdownProvider(),
    minder: new MinderProvider(),
    plantuml: new lite_editor_PlantUMLProvider(),
    video: new lite_editor_VideoProvider()
};
var schemaMap = {
    heading: [
        {
            name: "heading",
            type: "nodes",
            getValue: function(level) {
                return getHeading(level);
            }
        }
    ],
    mention: [
        {
            name: "mention",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.mention;
            }
        }
    ],
    task_list: [
        {
            name: "task_list",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.task_list;
            }
        }
    ],
    task_item: [
        {
            name: "task_item",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.task_item;
            }
        },
        {
            name: "list_item",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.list_item;
            }
        }
    ],
    ordered_list: [
        {
            name: "ordered_list",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.ordered_list;
            }
        }
    ],
    bullet_list: [
        {
            name: "bullet_list",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.bullet_list;
            }
        }
    ],
    list_item: [
        {
            name: "list_item",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.list_item;
            }
        },
        {
            name: "task_item",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.task_item;
            }
        }
    ],
    link: [
        {
            name: "link",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.link;
            }
        }
    ],
    horizontal_rule: [
        {
            name: "horizontal_rule",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.horizontal_rule;
            }
        }
    ],
    latex_inline: [
        {
            name: "latex_inline",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.latex_inline;
            }
        }
    ],
    latex_block: [
        {
            name: "latex_block",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.latex_block;
            }
        }
    ],
    status: [
        {
            name: "status",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.status;
            }
        }
    ],
    image: [
        {
            name: "image",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.image;
            }
        }
    ],
    audio: [
        {
            name: "audio",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.audio;
            }
        }
    ],
    video: [
        {
            name: "video",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.video;
            }
        }
    ],
    attachment: [
        {
            name: "attachment",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.attachment;
            }
        }
    ],
    code_block: [
        {
            name: "code_block",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.code_block;
            }
        }
    ],
    collapse: [
        {
            name: "collapse",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.collapse;
            }
        },
        {
            name: "collapse_title",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.collapse_title;
            }
        },
        {
            name: "collapse_content",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.collapse_content;
            }
        }
    ],
    time: [
        {
            name: "time",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.time;
            }
        }
    ],
    catalog: [
        {
            name: "catalog",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.catalog;
            }
        }
    ],
    note: [
        {
            name: "note",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.note;
            }
        },
        {
            name: "note_title",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.note_title;
            }
        },
        {
            name: "note_content",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.note_content;
            }
        }
    ],
    blockquote: [
        {
            name: "blockquote",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.blockquote;
            }
        }
    ],
    spaceupdate: [
        {
            name: "spaceupdate",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.spaceupdate;
            }
        }
    ],
    page_tree: [
        {
            name: "page_tree",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.page_tree;
            }
        }
    ],
    table: [
        {
            name: "table",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.table;
            }
        },
        {
            name: "table_row",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.table_row;
            }
        },
        {
            name: "table_cell",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.table_cell;
            }
        },
        {
            name: "table_header",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.table_header;
            }
        }
    ],
    markdown: [
        {
            name: "markdown",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.markdown;
            }
        }
    ],
    html: [
        {
            name: "html",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.html;
            }
        }
    ],
    gantt: [
        {
            name: "gantt",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.gantt;
            }
        }
    ],
    data2chart: [
        {
            name: "data2chart",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.data2chart;
            }
        }
    ],
    calendar: [
        {
            name: "calendar",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.calendar;
            }
        }
    ],
    plantuml: [
        {
            name: "plantuml",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.plantuml;
            }
        }
    ],
    drawio: [
        {
            name: "drawio",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.drawio;
            }
        }
    ],
    minder: [
        {
            name: "minder",
            type: "nodes",
            getValue: function() {
                return citadelSchemaSpec.nodes.minder;
            }
        }
    ],
    em: [
        {
            name: "em",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.em;
            }
        }
    ],
    strong: [
        {
            name: "strong",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.strong;
            }
        }
    ],
    underline: [
        {
            name: "underline",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.underline;
            }
        }
    ],
    strikethrough: [
        {
            name: "strikethrough",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.strikethrough;
            }
        }
    ],
    color: [
        {
            name: "color",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.color;
            }
        }
    ],
    sub: [
        {
            name: "sub",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.sub;
            }
        }
    ],
    sup: [
        {
            name: "sup",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.sup;
            }
        }
    ],
    font: [
        {
            name: "font",
            type: "marks",
            getValue: function() {
                return citadelSchemaSpec.marks.font;
            }
        }
    ]
};

/* eslint-disable no-prototype-builtins */ function lite_editor_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function lite_editor_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return lite_editor_arrayLikeToArray(arr);
}
function lite_editor_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$d(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function lite_editor_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function lite_editor_getPrototypeOf$1(o) {
    lite_editor_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return lite_editor_getPrototypeOf$1(o);
}
function lite_editor_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) lite_editor_setPrototypeOf$1(subClass, superClass);
}
function lite_editor_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function lite_editor_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function lite_editor_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            lite_editor_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function lite_editor_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function lite_editor_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        lite_editor_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function lite_editor_possibleConstructorReturn$1(self, call) {
    if (call && (lite_editor_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return lite_editor_assertThisInitialized$1(self);
}
function lite_editor_setPrototypeOf$1(o, p) {
    lite_editor_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return lite_editor_setPrototypeOf$1(o, p);
}
function lite_editor_toConsumableArray(arr) {
    return lite_editor_arrayWithoutHoles(arr) || lite_editor_iterableToArray(arr) || lite_editor_unsupportedIterableToArray(arr) || lite_editor_nonIterableSpread();
}
var lite_editor_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function lite_editor_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return lite_editor_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lite_editor_arrayLikeToArray(o, minLen);
}
function lite_editor_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function lite_editor_createSuper$1(Derived) {
    var hasNativeReflectConstruct = lite_editor_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = lite_editor_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = lite_editor_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return lite_editor_possibleConstructorReturn$1(this, result);
    };
}
var LiteEditor = /*#__PURE__*/ function(Editor) {
    lite_editor_inherits$1(LiteEditor, Editor);
    var _super = lite_editor_createSuper$1(LiteEditor);
    function LiteEditor(dom, liteConfig) {
        _classCallCheck$d(this, LiteEditor);
        var _liteConfig_extensions = liteConfig.extensions, extensions = _liteConfig_extensions === void 0 ? [] : _liteConfig_extensions, _liteConfig_providers = liteConfig.providers, providers = _liteConfig_providers === void 0 ? new Providers() : _liteConfig_providers, _liteConfig_schema = liteConfig.schema, schema = _liteConfig_schema === void 0 ? {} : _liteConfig_schema;
        var appendExtensions = LiteEditor.handleExtensions(extensions);
        var finalSchema = LiteEditor.handleSchema(schema, extensions);
        var config = lite_editor_objectSpreadProps(lite_editor_objectSpread({}, liteConfig), {
            appendExtensions: appendExtensions,
            schema: finalSchema,
            providers: LiteEditor.handleProviders(providers, extensions)
        });
        return _super.call(this, dom, config);
    }
    return LiteEditor;
}(core["b" /* Editor */]);
LiteEditor.handleSchema = function(schema, extensions) {
    var schemaSpec = {
        nodes: {
            doc: citadelSchemaSpec.nodes.doc,
            text: citadelSchemaSpec.nodes.text,
            paragraph: citadelSchemaSpec.nodes.paragraph,
            hard_break: citadelSchemaSpec.nodes.hard_break
        },
        marks: {}
    };
    extensions.forEach(function(ext) {
        var extName = ext.name, tmp = ext.options, extConfig = tmp === void 0 ? {} : tmp;
        if (schemaMap.hasOwnProperty(extName)) {
            var list = schemaMap[extName];
            list.forEach(function(param) {
                var name = param.name, type = param.type, getValue = param.getValue;
                if (extName === "heading" && extConfig.level) {
                    schemaSpec[type][name] = getValue(extConfig.level);
                } else {
                    schemaSpec[type][name] = getValue();
                }
            });
        }
    });
    schemaSpec.nodes = lite_editor_objectSpread({}, schemaSpec.nodes, schema.nodes);
    schemaSpec.marks = lite_editor_objectSpread({}, schemaSpec.marks, schema.marks);
    return new dist["Schema"](schemaSpec);
};
LiteEditor.handleExtensions = function(extensions) {
    extensions = lite_editor_toConsumableArray(extensions).concat([
        new history_extension_HistoryExtension(),
        new placeholder_extension_PlaceholderExtension(),
        new ClearExtension(),
        new drop_cursor_extension_DropCursorExtension(),
        new drop_file_extension_DropFileExtension(),
        new paragraph_extension_ParagraphExtension(),
        new BaseKeyMapPCExtension(),
        new gap_cursor_extension_GapCursorPCExtension()
    ]);
    extensions.push(new paste_extension_PasteExtension({
        extensions: extensions
    }));
    extensions.push(new wash_extension_WashExtension());
    return extensions;
};
LiteEditor.handleProviders = function(providers, extensions) {
    extensions.forEach(function(ext) {
        var extName = ext.name;
        if (providerMap.hasOwnProperty(extName) && !providers.providers.has(extName)) {
            providers.registerProvider(extName, providerMap[extName]);
        }
    });
    return providers;
};
var defaultExtensions = [
    new heading_extension_HeadingExtension(),
    new AlignExtension(),
    new IndentExtension(),
    new StrongExtension(),
    new EmExtension(),
    new StrikethroughExtension(),
    new UnderlineExtension(),
    new FontExtension(),
    new ColorExtension(),
    new link_extension_LinkExtension(),
    new status_extension_StatusExtension(),
    new bullet_list_extension_BulletListExtension(),
    new ordered_list_extension_OrderedListExtension(),
    new list_item_extension_ListItemExtension(),
    new task_list_extension_TaskListExtension(),
    new task_item_extension_TaskItemExtension()
];

/* harmony default export */ var lite_editor = (LiteEditor);

//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/menubar/index.js








/**
 * 统一样式前缀
 */ var menubar_CLASSNAME_PREFIX = "ct";

var menubar_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : menubar_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var ManagerContext = Object(react["createContext"])(null);

var menubar_img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eredo%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='redo' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cpath d='M32%2c15.5 L17%2c15.5 C12.0294373%2c15.5 8%2c19.5294373 8%2c24.5 C8%2c29.4705627 12.0294373%2c33.5 17%2c33.5 L23%2c33.5 L23%2c36.5 L17%2c36.5 C10.372583%2c36.5 5%2c31.127417 5%2c24.5 C5%2c17.872583 10.372583%2c12.5 17%2c12.5 L32%2c12.5 L32%2c8 L42%2c14 L32%2c20 L32%2c15.5 Z' fill='black' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eundo-o%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='undo-o' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf' opacity='0'%3e %3cg%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' fill-rule='nonzero' x='0' y='0' width='48' height='48'%3e%3c/rect%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' cx='24' cy='24' r='19.9'%3e%3c/circle%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' cx='24' cy='24' r='9.9'%3e%3c/circle%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='6.1' y='6.1' width='35.8' height='35.8' rx='2'%3e%3c/rect%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='8.1' y='4.1' width='31.8' height='39.8' rx='2'%3e%3c/rect%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='4.1' y='8.1' width='39.8' height='31.8' rx='2'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3cpath d='M15%2c15.5 L15%2c20 L5%2c14 L15%2c8 L15%2c12.5 L30%2c12.5 C36.627417%2c12.5 42%2c17.872583 42%2c24.5 C42%2c31.127417 36.627417%2c36.5 30%2c36.5 L24%2c36.5 L24%2c33.5 L30%2c33.5 C34.9705627%2c33.5 39%2c29.4705627 39%2c24.5 C39%2c19.5294373 34.9705627%2c15.5 30%2c15.5 L15%2c15.5 Z' id='%e8%b7%af%e5%be%84' fill='black' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3ecleaner-format%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='cleaner-format' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M13.64035%2c38 L5.29289322%2c29.6525433 C4.90236893%2c29.262019 4.90236893%2c28.628854 5.29289322%2c28.2383297 L27.2132034%2c6.31801948 C27.6037277%2c5.92749519 28.2368927%2c5.92749519 28.627417%2c6.31801948 L42.0624458%2c19.7530483 C42.4529701%2c20.1435726 42.4529701%2c20.7767376 42.0624458%2c21.1672619 L25.2297077%2c38 L42%2c38 L42%2c41 L6%2c41 L6%2c38 L13.64035%2c38 Z M17.8829906%2c38 L20.987067%2c38 L28.627417%2c30.35965 L18.0208153%2c19.7530483 L8.82842712%2c28.9454365 L17.8829906%2c38 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg t='1570526541657' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3542' width='20px' height='20px'%3e %3cpath d='M679.936 496.32A213.269333 213.269333 0 0 1 789.333333 682.666667c0 117.824-95.509333 213.333333-213.333333 213.333333H234.666667V128h298.666666c117.824 0 213.333333 95.509333 213.333334 213.333333a212.736 212.736 0 0 1-66.730667 154.986667zM320 213.333333v256h213.333333a128 128 0 1 0 0-256H320z m0 341.333334v256h256a128 128 0 1 0 0-256H320z' fill='black' p-id='3543'%3e%3c/path%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cg id='italic' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpolygon id='%e8%b7%af%e5%be%84' fill-opacity='0.87' fill='black' points='18.5777988 38 26.0803762 10 19 10 19 7 37 7 37 10 29.1862047 10 21.6836273 38 29 38 29 41 11 41 11 38'%3e%3c/polygon%3e %3c/g%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 58 (84663) - https://sketch.com --%3e %3ctitle%3eserikeethrough%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='serikeethrough' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M15.9778223%2c22 C14.1310934%2c20.3006928 13%2c18.0144246 13%2c15.5 C13%2c10.2532949 17.9248678%2c6 24%2c6 C29.8809333%2c6 34.6839659%2c9.98571764 34.985026%2c15 L31.9766833%2c15 C31.6624526%2c11.6437761 28.2112183%2c9 24%2c9 C19.581722%2c9 16%2c11.9101491 16%2c15.5 C16%2c19.0898509 19.581722%2c22 24%2c22 L42%2c22 L42%2c25 L32.5697194%2c25 C34.691618%2c26.8037507 36%2c29.2745466 36%2c32 C36%2c37.5228475 30.627417%2c42 24%2c42 C17.372583%2c42 12%2c37.5228475 12%2c32 L15%2c32 C15%2c35.8659932 19.0294373%2c39 24%2c39 C28.9705627%2c39 33%2c35.8659932 33%2c32 C33%2c28.1340068 28.9705627%2c25 24%2c25 L6%2c25 L6%2c22 L15.9778223%2c22 Z' id='%e8%b7%af%e5%be%84' fill-opacity='0.87' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eunderlined%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='underlined' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c39 L42%2c39 L42%2c42 L6%2c42 L6%2c39 Z M36%2c21 C36%2c27.627417 30.627417%2c33 24%2c33 C17.372583%2c33 12%2c27.627417 12%2c21 L12%2c6 L15%2c6 L15%2c21 C15%2c25.9705627 19.0294373%2c30 24%2c30 C28.9705627%2c30 33%2c25.9705627 33%2c21 L33%2c6 L36%2c6 L36%2c21 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg t='1570610575022' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3713' width='20' height='20'%3e %3cpath d='M209.92 128l184.746667 320 184.746666-320h73.92L431.616 512l221.717333 384H579.413333L394.666667 576 209.92 896H136.021333l221.696-384L136.021333 128H209.92zM896 533.333333v79.018667L769.194667 832H896v64h-192v-79.061333L830.784 597.333333H704v-64h192z' fill='black' p-id='3714'%3e%3c/path%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg t='1570610555276' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3542' width='20' height='20'%3e %3cpath d='M209.92 128l184.746667 320 184.746666-320h73.92L431.616 512l221.717333 384H579.413333L394.666667 576 209.92 896H136.021333l221.696-384L136.021333 128H209.92zM896 128v64h-3.626667l-110.848 192H896v64h-192v-64h3.626667l110.848-192H704V128h192z' fill='black' p-id='3543'%3e%3c/path%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3ealign-left%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='align-left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M6%2c17 L32%2c17 L32%2c20 L6%2c20 L6%2c17 Z M6%2c28 L42%2c28 L42%2c31 L6%2c31 L6%2c28 Z M6%2c39 L32%2c39 L32%2c42 L6%2c42 L6%2c39 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3ealign-center%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='align-center' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M12%2c17 L36%2c17 L36%2c20 L12%2c20 L12%2c17 Z M6%2c28 L42%2c28 L42%2c31 L6%2c31 L6%2c28 Z M12%2c39 L36%2c39 L36%2c42 L12%2c42 L12%2c39 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3ealign-right%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='align-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M16%2c17 L42%2c17 L42%2c20 L16%2c20 L16%2c17 Z M6%2c28 L42%2c28 L42%2c31 L6%2c31 L6%2c28 Z M16%2c39 L42%2c39 L42%2c42 L16%2c42 L16%2c39 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$c = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eform%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='form' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M39%2c28 L39%2c21 L31%2c21 L31%2c28 L39%2c28 Z M39%2c31 L31%2c31 L31%2c39 L28%2c39 L28%2c31 L20%2c31 L20%2c39 L17%2c39 L17%2c31 L9%2c31 L9%2c39 L39%2c39 L39%2c31 Z M9%2c28 L17%2c28 L17%2c21 L9%2c21 L9%2c28 Z M20%2c28 L28%2c28 L28%2c21 L20%2c21 L20%2c28 Z M39%2c18 L39%2c9 L9%2c9 L9%2c18 L17%2c18 L17%2c9 L20%2c9 L20%2c18 L28%2c18 L28%2c9 L31%2c9 L31%2c18 L39%2c18 Z M7%2c6 L41%2c6 C41.5522847%2c6 42%2c6.44771525 42%2c7 L42%2c41 C42%2c41.5522847 41.5522847%2c42 41%2c42 L7%2c42 C6.44771525%2c42 6%2c41.5522847 6%2c41 L6%2c7 C6%2c6.44771525 6.44771525%2c6 7%2c6 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$d = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3elist-bulleted%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='list-bulleted' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M16%2c6.5 L42%2c6.5 L42%2c9.5 L16%2c9.5 L16%2c6.5 Z M16%2c22.5 L42%2c22.5 L42%2c25.5 L16%2c25.5 L16%2c22.5 Z M16%2c38.5 L42%2c38.5 L42%2c41.5 L16%2c41.5 L16%2c38.5 Z M6%2c5 L12%2c5 L12%2c11 L6%2c11 L6%2c5 Z M6%2c37 L12%2c37 L12%2c43 L6%2c43 L6%2c37 Z M6%2c21 L12%2c21 L12%2c27 L6%2c27 L6%2c21 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$e = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3elist-numbered%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='list-numbered' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M16%2c7.5 L42%2c7.5 L42%2c10.5 L16%2c10.5 L16%2c7.5 Z M16%2c22.5 L42%2c22.5 L42%2c25.5 L16%2c25.5 L16%2c22.5 Z M16%2c37.5 L42%2c37.5 L42%2c40.5 L16%2c40.5 L16%2c37.5 Z M6%2c37 L6%2c35 L12%2c35 L12%2c43 L6%2c43 L6%2c41 L10%2c41 L10%2c40 L8%2c40 L8%2c38 L10%2c38 L10%2c37 L6%2c37 Z M8%2c13 L8%2c7 L6%2c7 L6%2c5 L10%2c5 L10%2c13 L8%2c13 Z M6%2c22 L6%2c20 L12%2c20 L12%2c21.8 L8.4%2c26 L12%2c26 L12%2c28 L6%2c28 L6%2c26.2 L9.6%2c22 L6%2c22 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3csvg t='1571829329378' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3632' width='20' height='20'%3e %3cpath d='M192 832h640V192H192v640zM149.333333 128h725.333334a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333z m311.68 458.133333l229.738667-210.496 45.248 45.248-259.904 241.749334a21.333333 21.333333 0 0 1-29.610667-0.533334l-136.192-136.106666 45.269334-45.269334 105.472 105.386667z' fill='black' p-id='3633'%3e%3c/path%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e%3ctitle%3eoutdent-o%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg id='outdent-o' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M6%2c39 L42%2c39 L42%2c42 L6%2c42 L6%2c39 Z M21%2c17 L42%2c17 L42%2c20 L21%2c20 L21%2c17 Z M21%2c28 L42%2c28 L42%2c31 L21%2c31 L21%2c28 Z M16%2c18 L16%2c30 L6%2c24 L16%2c18 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";

var img$h = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eindent-o%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='indent-o' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf'%3e%3c/g%3e %3cpath d='M6%2c6 L42%2c6 L42%2c9 L6%2c9 L6%2c6 Z M6%2c39 L42%2c39 L42%2c42 L6%2c42 L6%2c39 Z M21%2c17 L42%2c17 L42%2c20 L21%2c20 L21%2c17 Z M21%2c28 L42%2c28 L42%2c31 L21%2c31 L21%2c28 Z M6%2c18 L16%2c24 L6%2c30 L6%2c18 Z' id='%e5%bd%a2%e7%8a%b6' fill='black'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

var img$i = "data:image/svg+xml,%3csvg t='1570540641644' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8522' width='20' height='20'%3e %3cpath d='M896 170.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v341.333333c0 151.125333-71.424 285.546667-182.357333 371.413334l-39.125333-50.666667c93.653333-72.490667 154.730667-185.088 157.397333-312.064L853.333333 533.333333v-21.333333H597.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V192a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667zM426.666667 170.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v341.333333h-0.469333c-6.4 142.4-76.202667 268.288-181.888 350.08l-39.125334-50.666666C322.304 758.613333 384 642.517333 384 512H128a21.333333 21.333333 0 0 1-21.333333-21.333333V192a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667z m426.666666 64H640v213.333333h213.333333V234.666667z m-469.333333 0H170.666667v213.333333h213.333333V234.666667z' fill='black' p-id='8523'%3e%3c/path%3e%3c/svg%3e";

var img$j = "data:image/svg+xml,%3csvg t='1570540555700' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8009' width='20' height='20'%3e %3cpath d='M640 344.405333V298.666667h64v277.333333c0 28.053333 13.312 54.4 35.456 65.536 13.376 6.72 37.973333 6.122667 49.984 0.064C814.933333 628.693333 832 585.258667 832 512c0-178.346667-114.709333-316.650667-275.349333-338.346667l-0.064-0.106666A344.554667 344.554667 0 0 0 512 170.666667C323.477333 170.666667 170.666667 323.477333 170.666667 512s152.810667 341.333333 341.333333 341.333333c97.408 0 185.28-40.789333 247.466667-106.24l46.4 44.074667A404.181333 404.181333 0 0 1 512 917.333333C288.149333 917.333333 106.666667 735.850667 106.666667 512S288.149333 106.666667 512 106.666667c31.488-0.021333 62.890667 3.626667 93.546667 10.858666l-0.042667 0.213334C779.136 160.256 896 320.064 896 512c0 89.429333-23.210667 159.146667-77.653333 186.688-26.944 13.653333-73.152 17.386667-107.669334 0a121.472 121.472 0 0 1-49.386666-45.802667C622.378667 709.845333 560.426667 746.666667 490.666667 746.666667c-117.824 0-213.333333-105.066667-213.333334-234.666667s95.509333-234.666667 213.333334-234.666667c58.133333 0 110.848 25.6 149.333333 67.072zM490.666667 682.666667c82.474667 0 149.333333-76.416 149.333333-170.666667s-66.858667-170.666667-149.333333-170.666667-149.333333 76.416-149.333334 170.666667 66.858667 170.666667 149.333334 170.666667z' fill='black' p-id='8010'%3e%3c/path%3e%3c/svg%3e";

var img$k = "data:image/svg+xml,%3csvg t='1570539962562' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='7496' width='20' height='20'%3e %3cpath d='M330.986667 602.517333a64 64 0 0 0 90.496 90.496L753.365333 361.173333a128 128 0 0 0-181.034666-181.013333L225.386667 527.082667a192 192 0 1 0 271.530666 271.530666l301.696-301.696 45.248 45.248-301.696 301.696c-99.968 99.989333-262.058667 99.989333-362.026666 0-99.989333-99.968-99.989333-262.058667 0-362.026666L527.082667 134.869333A192 192 0 1 1 798.613333 406.4L466.752 738.282667a128 128 0 1 1-181.034667-181.034667l286.613334-286.613333 45.269333 45.269333-286.613333 286.613333z' fill='black' p-id='7497'%3e%3c/path%3e%3c/svg%3e";

var img$l = "data:image/svg+xml,%3csvg t='1570526878627' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4226' width='20' height='20'%3e %3cpath d='M149.333333 640l234.666667-234.666667 234.666667 234.666667 128-128 128 128V234.666667H149.333333v405.333333z m0 90.517333V789.333333h725.333334v-58.816l-128-128-128 128-234.666667-234.666666-234.666667 234.666666zM938.666667 192v640a21.333333 21.333333 0 0 1-21.333334 21.333333H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333333V192a21.333333 21.333333 0 0 1 21.333334-21.333333h810.666666a21.333333 21.333333 0 0 1 21.333334 21.333333zM618.666667 448a64 64 0 1 1 0-128 64 64 0 0 1 0 128z' fill='black' p-id='4227'%3e%3c/path%3e%3c/svg%3e";

var img$m = "data:image/svg+xml,%3csvg t='1570526679287' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3713' width='20px' height='20px'%3e %3cpath d='M532.897959 828.959347c-98.09502 98.09502-257.170286 98.09502-355.265306 0-98.09502-98.115918-98.09502-257.170286 0-355.265306l44.408163 44.408163a188.416 188.416 0 1 0 266.44898 266.44898l44.408163 44.408163z m310.251102-311.463184l-44.617143-44.617143A188.436898 188.436898 0 0 0 533.733878 208.060082L489.095837 163.422041c98.701061-83.654531 246.742204-78.931592 339.86351 14.189714 93.121306 93.121306 97.844245 241.162449 14.210612 339.86351zM177.632653 473.694041l103.612082-103.63298 44.408163 44.408163-103.612082 103.63298L177.632653 473.694041z m207.245061-207.245061l103.612082-103.612082L532.897959 207.245061l-103.612081 103.612082-44.408164-44.408163z m103.612082 518.102204l103.612082-103.63298 44.408163 44.408163-103.612082 103.63298-44.408163-44.408163zM392.275592 569.887347l177.632653-177.632653 44.408163 44.408163-177.632653 177.632653-44.408163-44.408163z m303.438367 7.397877l103.653878-103.612081 44.387265 44.408163-103.612082 103.612082-44.408163-44.408164z' fill='black' p-id='3714'%3e%3c/path%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3csvg t='1570540581206' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8180' width='20' height='20'%3e %3cpath d='M874.666667 554.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v298.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V576a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334z m-42.666667 64H192v213.333333h640V618.666667z m42.666667-490.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v320a21.333333 21.333333 0 0 1-21.333333 21.333334H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333334V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334z m-42.666667 64H192v234.666667h640V192z m-512 85.333333v64h-64v-64h64z m128 0v64h-64v-64h64z m128 0v64h-64v-64h64z' fill='black' p-id='8181'%3e%3c/path%3e%3c/svg%3e";

var img$o = "data:image/svg+xml,%3csvg t='1570540670507' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8693' width='20' height='20'%3e %3cpath d='M938.666667 746.666667v64H405.333333v-64h533.333334z m0-192v64H405.333333v-64h533.333334z m0-192v64H405.333333v-64h533.333334zM341.333333 170.666667l-128 213.333333L85.333333 170.666667h256z m597.333334 0v64H405.333333V170.666667h533.333334z' fill='black' p-id='8694'%3e%3c/path%3e%3c/svg%3e";

var img$p = "data:image/svg+xml,%3csvg t='1570540722887' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9035' width='20' height='20'%3e %3cpath d='M362.666667 384l106.666666 181.333333h-74.666666V640H576a21.333333 21.333333 0 0 1 21.333333 21.333333v213.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V661.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h181.333334v-74.666667H256l106.666667-181.333333zM576 128a21.333333 21.333333 0 0 1 21.333333 21.333333v74.666667h320a21.333333 21.333333 0 0 1 21.333334 21.333333v533.333334a21.333333 21.333333 0 0 1-21.333334 21.333333h-138.666666V874.666667L597.333333 768l181.333334-106.666667v74.666667H874.666667v-448H597.333333V362.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h426.666667z m-42.666667 576H192v128h341.333333v-128z m0-512H192v128h341.333333V192z' fill='black' p-id='9036'%3e%3c/path%3e%3c/svg%3e";

var img$q = "data:image/svg+xml,%3csvg t='1570540758107' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9377' width='20' height='20'%3e %3cpath d='M533.333333 128v64H213.333333v192h256v64H213.333333v448H149.333333V128h384z m334.954667 176.213333l55.424 32L772.949333 597.333333l150.762667 261.12-55.424 32L736 661.333333l-132.288 229.12-55.424-32L699.050667 597.333333l-150.762667-261.12 55.424-32L736 533.333333l132.288-229.12z' fill='black' p-id='9378'%3e%3c/path%3e%3c/svg%3e";

var img$r = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%a2%91%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-70.000000%2c -386.000000)'%3e %3cg id='%e9%9f%b3%e9%a2%91' transform='translate(70.000000%2c 386.000000)'%3e %3crect id='Rectangle-16' fill='%23D8D8D8' opacity='0' x='0' y='0' width='16' height='16'%3e%3c/rect%3e %3cpath d='M12.7445743%2c2.04437642 L7.03505843%2c3.63603963 C6.34056761%2c3.81829114 5.78631052%2c4.47439658 5.78631052%2c5.10012677 L5.78631052%2c10.5737472 C5.78631052%2c10.5737472 5.37228715%2c10.3185951 4.45075125%2c10.4400961 C3.0951586%2c10.6162725 2%2c11.5579053 2%2c12.5481385 C2%2c13.5383718 3.0951586%2c14.1458768 4.45075125%2c13.9697003 C5.80634391%2c13.7935239 6.79465776%2c12.8822663 6.79465776%2c11.8920331 L6.79465776%2c6.60673927 C6.79465776%2c6.16933564 7.37562604%2c5.98100908 7.37562604%2c5.98100908 L12.4240401%2c4.54122213 C12.4240401%2c4.54122213 12.984975%2c4.37112072 12.984975%2c4.8388996 L12.984975%2c9.20078578 C12.984975%2c9.20078578 12.4707846%2c8.93348357 11.5492487%2c9.03068437 C10.1936561%2c9.18256063 9.0984975%2c10.1059683 9.0984975%2c11.0962015 C9.0984975%2c12.0864347 10.1936561%2c12.7121649 11.5492487%2c12.5663637 C12.9048414%2c12.4144874 14%2c11.4910798 14%2c10.5008466 L14%2c2.85235813 C13.9933222%2c2.23270299 13.4323873%2c1.86819996 12.7445743%2c2.04437642 Z' id='Shape' fill='%23666666' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e %3cg id='Group-6' transform='translate(70.000000%2c 349.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$s = "data:image/svg+xml,%3csvg t='1570526758806' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3884' width='20px' height='20px'%3e %3cpath d='M704 704h-128v-64h128v64zM149.333333 128h725.333334a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333z m42.666667 64v640h640V192H192z m146.752 469.333333l148.032-148.053333-148.053333-148.032L384 320l178.218667 178.218667a21.333333 21.333333 0 0 1 0 30.165333L384 706.56 338.752 661.333333z' fill='black' p-id='3885'%3e%3c/path%3e%3c/svg%3e";

var img$t = "data:image/svg+xml,%3csvg t='1570540612741' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8351' width='20' height='20'%3e %3cpath d='M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m0 64C311.701333 149.333333 149.333333 311.701333 149.333333 512s162.368 362.666667 362.666667 362.666667 362.666667-162.368 362.666667-362.666667S712.298667 149.333333 512 149.333333z m42.666667 234.666667h-85.333334v-85.333333h85.333334v85.333333z m0 341.333333h-85.333334V448h85.333334v277.333333z' fill='black' p-id='8352'%3e%3c/path%3e%3c/svg%3e";

var img$u = "data:image/svg+xml,%3csvg t='1570540694172' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8864' width='20' height='20'%3e %3cpath d='M938.666667 640v64H85.333333v-64h853.333334z m0-320v64H85.333333v-64h853.333334z' fill='black' p-id='8865'%3e%3c/path%3e%3c/svg%3e";

var img$v = "data:image/svg+xml,%3csvg t='1570540740273' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9206' width='20' height='20'%3e %3cpath d='M405.333333 618.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333333V405.333333a21.333333 21.333333 0 0 1 21.333334-21.333333h277.333333a21.333333 21.333333 0 0 1 21.333333 21.333333v74.666667h85.333334v-234.666667a21.333333 21.333333 0 0 1 21.333333-21.333333h106.645333L618.666667 149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h277.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v213.333334a21.333333 21.333333 0 0 1-21.333334 21.333333H640a21.333333 21.333333 0 0 1-21.333333-21.333333l-0.021334-74.666667H554.666667v448h63.978666L618.666667 661.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h277.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v213.333334a21.333333 21.333333 0 0 1-21.333334 21.333333H640a21.333333 21.333333 0 0 1-21.333333-21.333333l-0.021334-74.666667H512a21.333333 21.333333 0 0 1-21.333333-21.333333v-234.666667h-85.333334V618.666667z m-64-170.666667H149.333333v128h192v-128zM874.666667 192h-192v128h192V192z m0 512h-192v128h192v-128z' fill='black' p-id='9207'%3e%3c/path%3e%3c/svg%3e";

var img$w = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e8%a7%86%e9%a2%91%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-70.000000%2c -358.000000)'%3e %3cg id='%e8%a7%86%e9%a2%91' transform='translate(70.000000%2c 358.000000)'%3e %3cg id='Group'%3e %3crect id='Rectangle-24' fill='%23D8D8D8' opacity='0' x='0' y='0' width='16' height='16'%3e%3c/rect%3e %3cg id='Group-3' transform='translate(1.000000%2c 2.000000)' fill='%23666666'%3e %3cpath d='M1%2c0 L13%2c0 C13.5522847%2c-1.01453063e-16 14%2c0.44771525 14%2c1 L14%2c11 C14%2c11.5522847 13.5522847%2c12 13%2c12 L1%2c12 C0.44771525%2c12 6.76353751e-17%2c11.5522847 0%2c11 L0%2c1 C-6.76353751e-17%2c0.44771525 0.44771525%2c1.01453063e-16 1%2c0 Z M1%2c1 L1%2c11 L13%2c11 L13%2c1 L1%2c1 Z' id='Combined-Shape'%3e%3c/path%3e %3cpath d='M2%2c3 L2%2c1 L3%2c1 L3%2c11 L2%2c11 L2%2c9 L1%2c9 L1%2c7 L2%2c7 L2%2c5 L1%2c5 L1%2c3 L2%2c3 Z M12%2c3 L13%2c3 L13%2c5 L12%2c5 L12%2c7 L13%2c7 L13%2c9 L12%2c9 L12%2c11 L11%2c11 L11%2c1 L12%2c1 L12%2c3 Z M5.77249258%2c3.50211599 L8.97045947%2c5.58077715 C9.20198985%2c5.73127065 9.26768323%2c6.0409622 9.11718974%2c6.27249258 C9.07907871%2c6.33112541 9.0290923%2c6.38111182 8.97045947%2c6.41922285 L5.77249258%2c8.49788401 C5.5409622%2c8.6483775 5.23127065%2c8.58268412 5.08077715%2c8.35115374 C5.02805948%2c8.27004895 5%2c8.17539347 5%2c8.07866116 L5%2c3.92133884 C5%2c3.64519646 5.22385763%2c3.42133884 5.5%2c3.42133884 C5.59673231%2c3.42133884 5.69138779%2c3.44939832 5.77249258%2c3.50211599 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-6' transform='translate(70.000000%2c 349.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$x = "data:image/svg+xml,%3csvg t='1570540788356' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9548' width='20' height='20'%3e %3cpath d='M874.666667 128a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334z m-42.666667 64H192v640h640V192z m-405.333333 106.666667v181.333333h170.666666V298.666667h64v426.666666h-64v-181.333333h-170.666666V725.333333h-64V298.666667h64z' fill='black' p-id='9549'%3e%3c/path%3e%3c/svg%3e";

var img$y = "data:image/svg+xml,%3csvg t='1570540806818' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='9719' width='20' height='20'%3e %3cpath d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m0-64c200.298667 0 362.666667-162.368 362.666667-362.666667S712.298667 149.333333 512 149.333333 149.333333 311.701333 149.333333 512s162.368 362.666667 362.666667 362.666667z m10.666667-375.914667l139.946666 139.946667-45.226666 45.269333-149.333334-149.333333A32 32 0 0 1 458.666667 512V298.666667h64v200.085333z' fill='black' p-id='9720'%3e%3c/path%3e%3c/svg%3e";

var img$z = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='32px' height='32px' viewBox='0 0 32 32' enable-background='new 0 0 32 32' xml:space='preserve'%3e %3cimage id='image0' width='32' height='32' x='0' y='0' href='data:image/png%3bbase64%2ciVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQflCxYHJA0C6ZJdAAAA30lEQVRIx%2b2UOw6CQBCGPyxIcGPtIWjxMFZ6H219YDRYeQbDBWxsOQWIDf1YuBIeAeJiQeFMszOz82f%2bfx/wtyGYYkeCGHjCFgUHo%2baP%2b5AieEazewgPCwEsQ/oCo74SFgHerJZ5vNSZ6o7aGFIqZ7gAuGSdAILUAYQIhSLK4y8BIoSAQK8MAD6jZ7hmADBHEBalhnXlAq3aAODEsZKxOBfaL/r0GgEcnNrINqGOQ%2bx2Ck2cx9wQ7ky6NGgWbcqVabk%2bhLfwBMPnPANS8Ht9KHtQbImNmmM2qL4S/O0X9gLetRuVuh38BwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0xMS0yMlQwNzozNjowOSswMDowMIa6WUUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMTEtMjJUMDc6MzY6MDkrMDA6MDD35%2bH5AAAAAElFTkSuQmCC' /%3e%3c/svg%3e";

// 行内样式
function menubar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menubar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menubar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function menubar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function menubar_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        menubar_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var MenuMarkType = {
    Font: "font",
    Bold: "strong",
    Italic: "em",
    Strikethrough: "strikethrough",
    Underline: "underline",
    Color: "color",
    Sub: "sub",
    Sup: "sup",
    Subsup: "subsup"
};
// 位置排版
var MenuComposeType = {
    ClearFormat: "clearFormat",
    Align: "align",
    Indent: "indent"
};
// 宏节点
var MenuNodeType = {
    Heading: "heading",
    Table: "table",
    Mention: "mention",
    Attachment: "attachment",
    Image: "image",
    Link: "link",
    Code: "code_block",
    Extra: "extra",
    Status: "status",
    Drawio: "drawio",
    Video: "video",
    Audio: "audio",
    Collapse: "collapse",
    Catalog: "catalog",
    Minder: "minder",
    PlantUML: "plantuml",
    Time: "time",
    Latex: "latex_inline",
    Markdown: "markdown",
    Html: "html",
    HorizontalRule: "horizontal_rule",
    Note: "note",
    Calendar: "calendar",
    Data2Chart: "data2chart",
    Gantt: "gantt",
    PageTree: "page_tree",
    SpaceUpdate: "space_update"
};
// 容器节点
var MenuWrapType = {
    BulletList: "bullet_list",
    OrderedList: "ordered_list",
    TaskList: "task_list",
    Blockquote: "blockquote"
};
// 历史记录
var MenuHistoryType = {
    History: "history"
};
var MenuType = menubar_objectSpread({}, MenuMarkType, MenuComposeType, MenuNodeType, MenuWrapType, MenuHistoryType);
var fontSizeConfig = [
    {
        title: "9",
        fontSize: 12,
        lineHeight: 24
    },
    {
        title: "10",
        fontSize: 13,
        lineHeight: 24
    },
    {
        title: "11",
        fontSize: 14,
        lineHeight: 24
    },
    {
        title: "12",
        fontSize: 16,
        lineHeight: 24
    },
    {
        title: "14",
        fontSize: 19,
        lineHeight: 27
    },
    {
        title: "16",
        fontSize: 22,
        lineHeight: 30
    },
    {
        title: "18",
        fontSize: 24,
        lineHeight: 32
    },
    {
        title: "22",
        fontSize: 29,
        lineHeight: 37
    },
    {
        title: "24",
        fontSize: 32,
        lineHeight: 40
    },
    {
        title: "30",
        fontSize: 40,
        lineHeight: 48
    },
    {
        title: "36",
        fontSize: 48,
        lineHeight: 56
    }
];
// 以 fontsize 的 title 为 key，fontSize 为 value 的Map
var fontSizeTitleMap = fontSizeConfig.reduce(function(ret, item) {
    return menubar_objectSpreadProps(menubar_objectSpread({}, ret), menubar_defineProperty({}, +item.title, item.fontSize));
}, {});
var getMenuInfo = function(type, manager, config) {
    switch(type){
        case MenuType.History:
            if (!manager.commands.history) return null;
            return [
                {
                    title: "撤销",
                    icon: img$1,
                    command: manager.commands.history.undo,
                    isActive: function() {
                        return false;
                    },
                    isDisabled: manager.commands.history.isUndoDisabled
                },
                {
                    command: manager.commands.history.redo,
                    title: "重做",
                    icon: menubar_img,
                    isActive: function() {
                        return false;
                    },
                    isDisabled: manager.commands.history.isRedoDisabled
                }
            ];
        case MenuType.ClearFormat:
            {
                if (!manager.commands.clear) return null;
                return [
                    {
                        title: "清除格式",
                        icon: img$2,
                        command: manager.commands.clear.clearMark,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.clear.isDisabled
                    }
                ];
            }
        case MenuType.Heading:
            {
                var _manager_commands_code_block;
                if (!manager.commands.heading) return null;
                var titles = [
                    "正文",
                    "标题 1",
                    "标题 2",
                    "标题 3",
                    "标题 4",
                    "标题 5",
                    "标题 6"
                ];
                if (config === null || config === void 0 ? void 0 : config.level) {
                    titles = [
                        "正文"
                    ];
                    config.level.forEach(function(levelNum) {
                        titles.push("标题 ".concat(levelNum));
                    });
                }
                var isDisabled = ((_manager_commands_code_block = manager.commands.code_block) === null || _manager_commands_code_block === void 0 ? void 0 : _manager_commands_code_block.isInCode()) || false;
                return titles.map(function(title) {
                    if (title === "正文") {
                        return {
                            title: title,
                            icon: img$3,
                            command: function() {
                                return manager.commands.paragraph.setParagraph();
                            },
                            isDisabled: function() {
                                return isDisabled;
                            }
                        };
                    }
                    return {
                        title: title,
                        icon: img$3,
                        command: function() {
                            return manager.commands.heading.setHeading(parseInt(title.split(" ")[1], 10));
                        },
                        isDisabled: function() {
                            return isDisabled;
                        }
                    };
                });
            }
        case MenuType.Font:
            {
                if (!manager.commands.font) return null;
                return [
                    9,
                    10,
                    11,
                    12,
                    14,
                    16,
                    18,
                    22,
                    24,
                    30,
                    36
                ].map(function(size) {
                    return {
                        command: function() {
                            manager.commands.font.setSize(fontSizeTitleMap[size]);
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return manager.commands.font.isDisabled();
                        },
                        title: "".concat(size)
                    };
                });
            }
        case MenuType.Bold:
            {
                if (!manager.commands.strong) return null;
                return [
                    {
                        title: "粗体",
                        icon: img$3,
                        keyTips: "⌘-B",
                        command: function() {
                            return manager.commands.strong.toggleStrong();
                        },
                        isActive: function() {
                            return manager.commands.strong.isStrongActive();
                        },
                        isDisabled: function() {
                            return manager.commands.strong.isStrongDisabled();
                        }
                    }
                ];
            }
        case MenuType.Italic:
            {
                if (!manager.commands.em) return null;
                return [
                    {
                        title: "斜体",
                        icon: img$4,
                        keyTips: "⌘-I",
                        command: function() {
                            return manager.commands.em.toggleItalic();
                        },
                        isActive: function() {
                            return manager.commands.em.isItalicActive();
                        },
                        isDisabled: function() {
                            return manager.commands.em.isItalicDisabled();
                        }
                    }
                ];
            }
        case MenuType.Strikethrough:
            {
                if (!manager.commands.strikethrough) return null;
                return [
                    {
                        title: "中划线",
                        icon: img$5,
                        keyTips: "⌘-⇧-S",
                        command: function() {
                            return manager.commands.strikethrough.toggleStrikethrough();
                        },
                        isActive: function() {
                            return manager.commands.strikethrough.isStrikethroughActive();
                        },
                        isDisabled: function() {
                            return manager.commands.strikethrough.isStrikethroughDisabled();
                        }
                    }
                ];
            }
        case MenuType.Underline:
            {
                if (!manager.commands.underline) return null;
                return [
                    {
                        title: "下划线",
                        icon: img$6,
                        keyTips: "⌘-U",
                        command: function() {
                            return manager.commands.underline.toggleUnderline();
                        },
                        isActive: function() {
                            return manager.commands.underline.isUnderlineActive();
                        },
                        isDisabled: function() {
                            return manager.commands.underline.isUnderlineDisabled();
                        }
                    }
                ];
            }
        case MenuType.Color:
            {
                if (!manager.commands.color) return null;
                return [
                    {
                        command: function(color) {
                            return manager.commands.color.setColor(color);
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return manager.commands.color.isDisabled();
                        },
                        title: "文字颜色"
                    }
                ];
            }
        case MenuType.Sub:
            {
                if (!manager.commands.sub) return null;
                return [
                    {
                        title: "下标",
                        icon: img$7,
                        command: function() {
                            return manager.commands.sub.toggle();
                        },
                        isActive: function() {
                            return manager.commands.sub.isActive();
                        },
                        isDisabled: function() {
                            return manager.commands.sub.isDisabled();
                        }
                    }
                ];
            }
        case MenuType.Sup:
            {
                if (!manager.commands.sup) return null;
                return [
                    {
                        title: "上标",
                        icon: img$8,
                        command: function() {
                            return manager.commands.sup.toggle();
                        },
                        isActive: function() {
                            return manager.commands.sup.isActive();
                        },
                        isDisabled: function() {
                            return manager.commands.sup.isDisabled();
                        }
                    }
                ];
            }
        case MenuType.Align:
            {
                if (!manager.commands.align) return null;
                return [
                    {
                        title: "左对齐",
                        icon: img$9,
                        command: function() {
                            return manager.commands.align.setAlign("left");
                        },
                        isActive: function() {
                            return manager.commands.align.isAlignActive("left");
                        },
                        isDisabled: function() {
                            return manager.commands.align.isAlignDisabled();
                        }
                    },
                    {
                        title: "居中",
                        icon: img$a,
                        command: function() {
                            return manager.commands.align.setAlign("center");
                        },
                        isActive: function() {
                            return manager.commands.align.isAlignActive("center");
                        },
                        isDisabled: function() {
                            return manager.commands.align.isAlignDisabled();
                        }
                    },
                    {
                        title: "右对齐",
                        icon: img$b,
                        command: function() {
                            return manager.commands.align.setAlign("right");
                        },
                        isActive: function() {
                            return manager.commands.align.isAlignActive("right");
                        },
                        isDisabled: function() {
                            return manager.commands.align.isAlignDisabled();
                        }
                    }
                ];
            }
        case MenuType.Table:
            {
                var _manager_commands_code_block1;
                if (!manager.commands.table) return null;
                var isDisabled1 = ((_manager_commands_code_block1 = manager.commands.code_block) === null || _manager_commands_code_block1 === void 0 ? void 0 : _manager_commands_code_block1.isInCode()) || false;
                return [
                    {
                        title: "表格",
                        icon: img$c,
                        command: function(args) {
                            return manager.commands.table.insertTable(args);
                        },
                        isDisabled: function() {
                            return isDisabled1;
                        },
                        isActive: function() {
                            return true;
                        }
                    }
                ];
            }
        case MenuType.BulletList:
            {
                if (!manager.commands.bullet_list) return null;
                return [
                    {
                        title: "无序列表",
                        icon: img$d,
                        keyTips: "⌘-⇧-U",
                        command: function() {
                            return manager.commands.bullet_list.handleListClick();
                        },
                        isDisabled: function() {
                            return manager.commands.bullet_list.isBulletListDisabled();
                        },
                        isActive: function() {
                            return manager.commands.bullet_list.isBulletListActive();
                        }
                    }
                ];
            }
        case MenuType.OrderedList:
            {
                if (!manager.commands.ordered_list) return null;
                return [
                    {
                        title: "有序列表",
                        icon: img$e,
                        keyTips: "⌘-⇧-O",
                        command: function() {
                            return manager.commands.ordered_list.handleListClick();
                        },
                        isDisabled: function() {
                            return manager.commands.ordered_list.isOrderedListDisabled();
                        },
                        isActive: function() {
                            return manager.commands.ordered_list.isOrderedListActive();
                        }
                    }
                ];
            }
        case MenuType.TaskList:
            {
                if (!manager.commands.task_list) return null;
                return [
                    {
                        title: "任务列表",
                        icon: img$f,
                        command: function() {
                            return manager.commands.task_list.handleListClick();
                        },
                        isDisabled: function() {
                            return manager.commands.task_list.isTaskListDisabled();
                        },
                        isActive: function() {
                            return manager.commands.task_list.isTaskListActive();
                        }
                    }
                ];
            }
        case MenuType.Indent:
            {
                if (!manager.commands.indent) return null;
                return [
                    {
                        title: "减少缩进",
                        icon: img$g,
                        command: function() {
                            return manager.commands.indent.indentLess();
                        },
                        isDisabled: function() {
                            return manager.commands.indent.isIndentLessDisabled();
                        },
                        isActive: function() {
                            return false;
                        }
                    },
                    {
                        title: "增加缩进",
                        icon: img$h,
                        command: function() {
                            return manager.commands.indent.indentMore();
                        },
                        isDisabled: function() {
                            return manager.commands.indent.isIndentMoreDisabled();
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Code:
            {
                if (!manager.commands.code_block) return null;
                return [
                    {
                        title: "代码块",
                        icon: img$s,
                        command: function() {
                            return manager.commands.code_block.insert();
                        },
                        isDisabled: function() {
                            return manager.commands.code_block.isCodeBlockDisabled();
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Blockquote:
            {
                if (!manager.commands.blockquote) return null;
                return [
                    {
                        title: "引用",
                        icon: img$i,
                        command: manager.commands.blockquote.toggle,
                        isDisabled: function() {
                            return false;
                        },
                        isActive: manager.commands.blockquote.isActive
                    }
                ];
            }
        case MenuType.Mention:
            {
                if (!manager.commands.mention) return null;
                return [
                    {
                        title: "用户提及",
                        icon: img$j,
                        command: function() {
                            // TODO: 临时策略，不用settimeout会导致插入后弹框会自动消失，怀疑是其他宏的state更新影响
                            setTimeout(function() {
                                manager.commands.mention.insertAtMention();
                            }, 0);
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.mention.isMentionDisabled
                    }
                ];
            }
        case MenuType.Attachment:
            {
                if (!manager.commands.attachment) return null;
                return [
                    {
                        title: "附件",
                        icon: img$k,
                        command: function() {
                            manager.commands.attachment.upload();
                        },
                        isDisabled: function() {
                            return false;
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Image:
            {
                if (!manager.commands.image) return null;
                return [
                    {
                        title: "图片",
                        icon: img$l,
                        command: function() {
                            return manager.commands.image.upload();
                        },
                        isDisabled: function() {
                            return false;
                        },
                        isActive: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Link:
            {
                if (!manager.commands.link) return null;
                return [
                    {
                        title: "链接",
                        icon: img$m,
                        keyTips: "⌘-K",
                        command: function() {
                            return manager.commands.link.edit();
                        },
                        isDisabled: function() {
                            return manager.commands.link.isDisabled();
                        },
                        isActive: function() {
                            return manager.commands.link.isActive();
                        }
                    }
                ];
            }
        case MenuType.Status:
            {
                if (!manager.commands.status) return null;
                return [
                    {
                        title: "状态",
                        icon: img$n,
                        command: manager.commands.status.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.status.isDisabled
                    }
                ];
            }
        case MenuType.Audio:
            {
                if (!manager.commands.audio) return null;
                return [
                    {
                        title: "音频",
                        icon: img$r,
                        command: function() {
                            return manager.commands.audio.upload();
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.audio.isDisabled
                    }
                ];
            }
        case MenuType.Collapse:
            {
                if (!manager.commands.collapse) return null;
                return [
                    {
                        title: "展开",
                        icon: img$o,
                        command: function() {
                            return manager.commands.collapse.insert();
                        }
                    }
                ];
            }
        case MenuType.Catalog:
            {
                if (!manager.commands.catalog) return null;
                return [
                    {
                        title: "目录",
                        icon: img$i,
                        command: function() {
                            return manager.commands.catalog.insert();
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.catalog.isDisabled
                    }
                ];
            }
        case MenuType.Drawio:
            {
                if (!manager.commands.drawio) return null;
                return [
                    {
                        title: "流程图",
                        icon: img$p,
                        command: manager.commands.drawio.insertDrawio,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.drawio.isDisabled
                    }
                ];
            }
        case MenuType.Minder:
            {
                if (!manager.commands.minder) return null;
                return [
                    {
                        title: "思维导图",
                        icon: img$v,
                        command: manager.commands.minder.insertMinder,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.minder.isDisabled
                    }
                ];
            }
        case MenuType.PlantUML:
            {
                if (!manager.commands.plantuml) return null;
                return [
                    {
                        title: "PlantUML",
                        icon: img$v,
                        command: manager.commands.plantuml.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.plantuml.isDisabled
                    }
                ];
            }
        case MenuType.Time:
            {
                if (!manager.commands.time) return null;
                return [
                    {
                        title: "时间",
                        icon: img$y,
                        command: manager.commands.time.insertTime,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.time.isDisabled
                    }
                ];
            }
        case MenuType.Latex:
            {
                if (!manager.commands.latex_inline) return null;
                return [
                    {
                        title: "公式",
                        icon: img$q,
                        command: manager.commands.latex_inline.insertLatex,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.latex_inline.isLatexDisabled
                    }
                ];
            }
        case MenuType.Markdown:
            {
                if (!manager.commands.markdown) return null;
                return [
                    {
                        title: "Markdown",
                        icon: img$z,
                        command: manager.commands.markdown.insertMarkdown,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.markdown.isMarkdownDisabled
                    }
                ];
            }
        case MenuType.Html:
            {
                if (!manager.commands.html) return null;
                return [
                    {
                        title: "HTML",
                        icon: img$x,
                        command: manager.commands.html.insertHtml,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.html.isHtmlDisabled
                    }
                ];
            }
        case MenuType.Video:
            {
                if (!manager.commands.video) return null;
                return [
                    {
                        title: "视频",
                        icon: img$w,
                        command: manager.commands.video.upload,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.video.isDisabled
                    }
                ];
            }
        case MenuType.Note:
            {
                if (!manager.commands.note) return null;
                return [
                    {
                        title: "信息",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("info");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    },
                    {
                        title: "警示",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("note");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    },
                    {
                        title: "注意",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("warning");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    },
                    {
                        title: "提示",
                        icon: img$t,
                        command: function() {
                            manager.commands.note.insertNote("tip");
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.HorizontalRule:
            {
                if (!manager.commands.horizontal_rule) return null;
                return [
                    {
                        title: "水平线",
                        icon: img$u,
                        command: function() {
                            manager.commands.horizontal_rule.insertHr();
                        },
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return manager.commands.horizontal_rule.isHrDisabled();
                        }
                    }
                ];
            }
        case MenuType.Calendar:
            {
                if (!manager.commands.calendar) return null;
                return [
                    {
                        title: "日历",
                        icon: img$q,
                        command: manager.commands.calendar.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: function() {
                            return false;
                        }
                    }
                ];
            }
        case MenuType.Data2Chart:
            {
                if (!manager.commands.data2chart) return null;
                return [
                    {
                        title: "数据图表",
                        icon: img$p,
                        command: manager.commands.data2chart.edit,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.data2chart.isDisabled
                    }
                ];
            }
        case MenuType.Gantt:
            {
                if (!manager.commands.gantt) return null;
                return [
                    {
                        title: "甘特图",
                        icon: "",
                        command: manager.commands.gantt.insertGantt,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.gantt.isDisabled
                    }
                ];
            }
        case MenuType.PageTree:
            {
                if (!manager.commands.page_tree) return null;
                return [
                    {
                        title: "目录树",
                        icon: img$f,
                        command: manager.commands.page_tree.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.page_tree.isDisabled
                    }
                ];
            }
        case MenuType.SpaceUpdate:
            {
                if (!manager.commands.spaceupdate) return null;
                return [
                    {
                        title: "最近更新",
                        icon: img$f,
                        command: manager.commands.spaceupdate.insert,
                        isActive: function() {
                            return false;
                        },
                        isDisabled: manager.commands.spaceupdate.isDisabled
                    }
                ];
            }
        default:
            return null;
    }
};
// 色板
var menubar_colors = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

var img$A = "data:image/svg+xml,%3csvg t='1570526843158' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4055' width='20' height='20'%3e %3cpath d='M234.666667 448a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m277.333333 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m277.333333 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z' fill='black' p-id='4056'%3e%3c/path%3e%3c/svg%3e";

// 类型是否可以插入富文本
var menubar_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

var img$B = "data:image/svg+xml,%3csvg t='1571562690312' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3602' width='16' height='16'%3e %3cpath d='M521.898667 666.773333a10.666667 10.666667 0 0 1-18.453334 0l-173.461333-298.752a10.666667 10.666667 0 0 1 9.216-16.021333h346.944a10.666667 10.666667 0 0 1 9.216 16.021333l-173.461333 298.752z' fill='black' opacity='0.38' p-id='3603'%3e%3c/path%3e%3c/svg%3e";

var TriggerItem = function(param) {
    var className = param.className, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, children = param.children;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        className: classnames_default()(menubar_classNamePrefix("trigger-popup-item"), className)
    }, children);
};

function menubar_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var menubar_css_248z = ".ct-trigger{position:relative;display:flex;justify-content:center;align-items:center}.ct-trigger-popup{background:#fff;position:absolute;padding:4px 0;box-shadow:0 2px 4px 0 rgba(0,0,0,.02),0 4px 6px 6px rgba(0,0,0,.02),0 4px 6px 0 rgba(0,0,0,.06);border-radius:4px;display:none;z-index:1000;font-family:PingFangSC-Regular}.ct-trigger-popup-show{display:block}.ct-trigger-popup-hidden{display:none}.ct-trigger-popup-item{display:flex;align-items:center;padding:8px 0 8px 16px;cursor:pointer}.ct-trigger-popup-item.divider{border-bottom:1px solid #ddd}.ct-trigger-popup-item:hover{background:rgba(0,0,0,.07)}.ct-trigger-popup-item img{margin:0 8px 0 0;width:20px;height:20px}";
menubar_styleInject(menubar_css_248z);

function menubar_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menubar_extends() {
    menubar_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return menubar_extends.apply(this, arguments);
}
function menubar_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menubar_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function menubar_ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function menubar_objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        menubar_ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ITriggerAlign;
(function(ITriggerAlign) {
    ITriggerAlign["LEFT"] = "left";
    ITriggerAlign["RIGHT"] = "right";
    ITriggerAlign["TOP"] = "top";
    ITriggerAlign["BOTTOM"] = "bottom";
})(ITriggerAlign || (ITriggerAlign = {}));
var ITriggerType;
(function(ITriggerType) {
    ITriggerType["CLICK"] = "click";
    ITriggerType["HOVER"] = "hover";
})(ITriggerType || (ITriggerType = {}));
var THRESHOLD = 10;
var menubar_Trigger = function(param) {
    var children = param.children, popup = param.popup, _param_align = param.align, align = _param_align === void 0 ? ITriggerAlign.RIGHT : _param_align, _param_trigger = param.trigger, trigger = _param_trigger === void 0 ? ITriggerType.HOVER : _param_trigger, visible = param.visible, width = param.width, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    var node = Object(react["useRef"])(null);
    var popNode = Object(react["useRef"])(null);
    var getStyle = function() {
        if (node.current && popNode.current) {
            var height = node.current.offsetHeight;
            var popWidth = popNode.current.offsetWidth;
            var popHeight = popNode.current.offsetHeight;
            switch(align){
                case ITriggerAlign.RIGHT:
                    {
                        return {
                            right: -popWidth - THRESHOLD,
                            top: -(popHeight - height) / 2
                        };
                    }
                case ITriggerAlign.LEFT:
                    {
                        return {
                            left: -popWidth - THRESHOLD,
                            top: -(popHeight - height) / 2
                        };
                    }
                case ITriggerAlign.BOTTOM:
                    {
                        return {
                            left: 0,
                            top: node.current.offsetHeight
                        };
                    }
                case ITriggerAlign.TOP:
                    {
                        return {
                            left: 0,
                            top: -popHeight - THRESHOLD
                        };
                    }
                default:
                    return {};
            }
        }
    };
    var _obj;
    var eventMapper = (_obj = {}, menubar_defineProperty$1(_obj, ITriggerType.HOVER, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }), menubar_defineProperty$1(_obj, ITriggerType.CLICK, {
        onClick: onClick
    }), _obj);
    return /*#__PURE__*/ react_default.a.createElement("div", menubar_extends({
        className: menubar_classNamePrefix("trigger")
    }, eventMapper[trigger]), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("trigger-children"),
        ref: node
    }, children), /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()(menubar_classNamePrefix("trigger-popup"), visible ? menubar_classNamePrefix("trigger-popup-show") : menubar_classNamePrefix("trigger-popup-hidden")),
        ref: popNode,
        style: menubar_objectSpreadProps$1(menubar_objectSpread$1({}, getStyle()), {
            width: width || "100%"
        })
    }, popup));
};
menubar_Trigger.Item = TriggerItem;

var menubar_css_248z$1 = '.ct-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:#292929;border-radius:4px;z-index:100;display:none}.ct-tooltip-wrapper{line-height:1;position:relative}.ct-tooltip-disabled{display:none}.ct-tooltip-active{display:block}.ct-tooltip-active:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:#292929 transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:100}.ct-tooltip-top{top:-35px}.ct-tooltip-top:after{bottom:-5px;top:auto;border-width:5px 5px 0}';
menubar_styleInject(menubar_css_248z$1);

function menubar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function menubar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function menubar_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menubar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function menubar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function menubar_slicedToArray(arr, i) {
    return menubar_arrayWithHoles(arr) || menubar_iterableToArrayLimit(arr, i) || menubar_unsupportedIterableToArray(arr, i) || menubar_nonIterableRest();
}
function menubar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return menubar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return menubar_arrayLikeToArray(o, minLen);
}
var menubar_prefixCls = menubar_classNamePrefix("tooltip");
var Tooltips = function(props) {
    var title = props.title, disabled = props.disabled, children = props.children, _props_placement = props.placement, placement = _props_placement === void 0 ? "bottom" : _props_placement;
    var _useState = menubar_slicedToArray(Object(react["useState"])(false), 2), isHover = _useState[0], toggleHover = _useState[1];
    var onMouseEnter = function(e) {
        if (!disabled) {
            toggleHover(true);
        }
    };
    var onMouseLeave = function() {
        toggleHover(false);
    };
    var _obj;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(menubar_prefixCls, "-wrapper"),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, children, title && /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()("".concat(menubar_prefixCls), "".concat(menubar_prefixCls, "-").concat(placement), (_obj = {}, menubar_defineProperty$2(_obj, "".concat(menubar_prefixCls, "-active"), isHover && !disabled), menubar_defineProperty$2(_obj, "".concat(menubar_prefixCls, "-disabled"), disabled), _obj))
    }, title));
};

var menubar_css_248z$2 = ".ct-menubar-dropdown{position:relative;height:28px;box-sizing:border-box;display:flex;padding:0 16px 0 0;border-radius:1000px;cursor:pointer;transition:all .3s;align-items:center;white-space:nowrap}.ct-menubar-dropdown-disabled{cursor:not-allowed;opacity:.3}.ct-menubar-dropdown.ct-menubar-extra{padding-right:3px}.ct-menubar-dropdown .arrow{position:absolute;top:6px;right:4px;display:inline-flex;border-radius:6px;height:16px}.ct-menubar-dropdown:hover{background:rgba(0,0,0,.07)}.ct-menubar-dropdown .text{padding:0 4px 0 7px;font-size:14px;color:#000;text-align:center}.ct-menubar-dropdown .icon{padding:0 4px 0 7px}";
menubar_styleInject(menubar_css_248z$2);

function menubar_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || menubar_unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function menubar_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return menubar_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return menubar_arrayLikeToArray$1(o, minLen);
}
var Dropdown = function(props) {
    var tips = props.tips, hasArrow = props.hasArrow, icon = props.icon, title = props.title, className = props.className, isDisabled = props.isDisabled, popup = props.popup, trigger = props.trigger, align = props.align, width = props.width, buttonWidth = props.buttonWidth, children = props.children, onVisibleChange = props.onVisibleChange;
    var _useState = _slicedToArray$1(Object(react["useState"])(false), 2), visible = _useState[0], toggleVisible = _useState[1];
    var triggerRef = Object(react["useRef"])(null);
    var onClickOutside = function(e) {
        var target = e.target;
        if (!triggerRef.current.contains(target)) {
            setTimeout(function() {
                toggleVisible(false);
            }, 50);
        }
    };
    var onClickTarget = function() {
        if (!isDisabled) {
            setTimeout(function() {
                toggleVisible(!visible);
            }, 100);
        }
    };
    Object(react["useEffect"])(function() {
        if (onVisibleChange) {
            onVisibleChange(visible);
        }
    }, [
        visible
    ]);
    var onMouseEnter = function() {
        setTimeout(function() {
            toggleVisible(true);
        }, 200);
    };
    var onMouseLeave = function() {
        setTimeout(function() {
            toggleVisible(false);
        }, 200);
    };
    Object(react["useEffect"])(function() {
        document.addEventListener(ITriggerType.CLICK, onClickOutside);
        return function() {
            document.removeEventListener(ITriggerType.CLICK, onClickOutside);
        };
    }, []);
    return /*#__PURE__*/ react_default.a.createElement("div", {
        ref: triggerRef
    }, /*#__PURE__*/ react_default.a.createElement(menubar_Trigger, {
        popup: popup,
        trigger: trigger,
        align: align,
        visible: visible,
        width: width,
        onClick: onClickTarget,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ react_default.a.createElement(Tooltips, {
        title: tips,
        disabled: isDisabled
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()(menubar_classNamePrefix("menubar-dropdown"), menubar_classNamePrefix("menubar-item"), className, isDisabled ? menubar_classNamePrefix("menubar-dropdown-disabled") : "", visible ? menubar_classNamePrefix("menubar-dropdown-active") : ""),
        style: {
            width: buttonWidth
        }
    }, icon && /*#__PURE__*/ react_default.a.createElement("img", {
        src: icon,
        className: "icon",
        alt: tips
    }), !icon && title && /*#__PURE__*/ react_default.a.createElement("span", {
        className: "text"
    }, title), hasArrow && /*#__PURE__*/ react_default.a.createElement("span", {
        className: "arrow"
    }, /*#__PURE__*/ react_default.a.createElement("img", {
        src: img$B,
        alt: "triangle"
    })), children))));
};
Dropdown.defaultProps = {
    hasArrow: false,
    icon: null,
    title: null,
    isDisabled: false,
    isActive: true,
    trigger: ITriggerType.CLICK,
    align: ITriggerAlign.BOTTOM,
    width: 52,
    buttonWidth: "auto",
    className: ""
};

var menubar_css_248z$3 = ".ct-extra-collapse-item-wrapper{position:absolute;left:118px;padding:8px 0 3px;width:80px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 2px 4px 0 rgba(0,0,0,.02),0 4px 6px 6px rgba(0,0,0,.02),0 4px 6px 0 rgba(0,0,0,.06)}.ct-extra-collapse-item-wrapper .ct-extra-collapse-item{height:26px;padding:5px 10px;cursor:pointer;font-size:14px;color:#333}.ct-extra-collapse-item-wrapper .ct-extra-collapse-item:hover{background-color:#f6f6f6}";
menubar_styleInject(menubar_css_248z$3);

function menubar_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(arr, i) {
    return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || menubar_unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}
function menubar_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return menubar_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return menubar_arrayLikeToArray$2(o, minLen);
}
var ExtraCollapseItem = function(param) {
    var itemlist = param.itemlist, title = param.title, icon = param.icon, divider = param.divider;
    var manager = Object(react["useContext"])(ManagerContext);
    var _useState = _slicedToArray$2(Object(react["useState"])(false), 2), showPopover = _useState[0], setShowPopover = _useState[1];
    var handleClick = function(e, command) {
        e.target.closest(".".concat(menubar_classNamePrefix("trigger-popup"))).click();
        command();
        manager.editorView.focus();
    };
    return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
        key: title,
        className: divider ? "divider" : "",
        onClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseEnter: function() {
            setShowPopover(true);
        },
        onMouseLeave: function() {
            setShowPopover(false);
        }
    }, icon && /*#__PURE__*/ react_default.a.createElement("img", {
        src: icon,
        alt: title
    }), /*#__PURE__*/ react_default.a.createElement("span", null, title), showPopover && /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("extra-collapse-item-wrapper")
    }, itemlist.map(function(item, index) {
        var itemTitle = item.title, command = item.command;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: menubar_classNamePrefix("extra-collapse-item"),
            onClick: function(e) {
                return handleClick(e, command);
            },
            key: index
        }, /*#__PURE__*/ react_default.a.createElement("div", null, itemTitle));
    })));
};

function _arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function menubar_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}
function menubar_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function menubar_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function menubar_toConsumableArray(arr) {
    return menubar_arrayWithoutHoles(arr) || menubar_iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || menubar_nonIterableSpread();
}
function _unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
var ExtraItem = function(param) {
    var menuList = param.menuList;
    var manager = Object(react["useContext"])(ManagerContext);
    var onClickItem = function(command, type) {
        command();
        // 需要聚焦在 modal 上的特殊处理
        if (![
            "link",
            "html",
            "markdown",
            "plantuml"
        ].includes(type)) {
            manager.editorView.focus();
        }
    };
    var list = Object(react["useMemo"])(function() {
        return menuList.reduce(function(prev, cur) {
            var type = cur.type, divider = cur.divider, config = cur.config;
            var infoList = getMenuInfo(type, manager);
            if (!infoList) return prev;
            if (type === "note") {
                var title = "样式";
                return menubar_toConsumableArray(prev).concat([
                    /*#__PURE__*/ react_default.a.createElement(ExtraCollapseItem, {
                        itemlist: infoList,
                        key: title,
                        title: title,
                        icon: infoList[0].icon,
                        divider: divider
                    })
                ]);
            }
            var itemList = infoList.map(function(info) {
                var title = info.title, icon = info.icon, command = info.command;
                return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                    key: title,
                    onClick: function() {
                        return onClickItem(command, type);
                    },
                    className: divider ? "divider" : ""
                }, icon && /*#__PURE__*/ react_default.a.createElement("img", {
                    src: icon,
                    alt: title
                }), /*#__PURE__*/ react_default.a.createElement("span", null, title));
            });
            return menubar_toConsumableArray(prev).concat(menubar_toConsumableArray(itemList));
        }, []);
    }, [
        menuList
    ]);
    var isDisabled = !menubar_canInsertTypes(manager.editorView.state);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 120,
        tips: "插入其他",
        className: menubar_classNamePrefix("menubar-extra"),
        icon: img$A,
        isDisabled: isDisabled,
        buttonWidth: 28
    });
};

var menubar_css_248z$4 = ".ct-menubar-item{height:28px;width:28px;cursor:pointer;display:flex;align-items:center;justify-content:center;margin:auto 4px;border-radius:14px;transition:all .3s}.ct-menubar-item:hover{background:rgba(0,0,0,.07)}.ct-menubar-item-disabled{pointer-events:none;cursor:not-allowed;opacity:.3}.ct-menubar-item-active{background:rgba(0,0,0,.07)}";
menubar_styleInject(menubar_css_248z$4);

var CommonItem = function(props) {
    var manager = Object(react["useContext"])(ManagerContext);
    var icon = props.icon, title = props.title, command = props.command, isActive = props.isActive, name = props.name, isDisabled = props.isDisabled, keyTips = props.keyTips;
    var handleClick = function() {
        command();
        // 需要聚焦在 modal 上的特殊处理
        if (![
            "link",
            "html",
            "markdown",
            "plantuml"
        ].includes(name)) {
            manager.editorView.focus();
        }
    };
    var disabled = isDisabled();
    var popTitle = Object(react["useMemo"])(function() {
        if (keyTips) {
            return "".concat(title, " (").concat(keyTips, ")");
        }
        return title;
    }, [
        title,
        keyTips
    ]);
    return /*#__PURE__*/ react_default.a.createElement(Tooltips, {
        title: popTitle,
        disabled: disabled
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        onClick: handleClick,
        className: classnames_default()(menubar_classNamePrefix("menubar-item"), disabled ? menubar_classNamePrefix("menubar-item-disabled") : "", isActive() ? menubar_classNamePrefix("menubar-item-active") : "")
    }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
        src: icon,
        alt: title,
        "data-menu-key": name
    }) : null));
};

var menubar_css_248z$5 = ".ct-menubar-heading-item{font-weight:700}.ct-menubar-heading-item-h0{font-size:14px;line-height:20px;font-weight:unset}.ct-menubar-heading-item-h1{font-size:28px;line-height:36px}.ct-menubar-heading-item-h2{font-size:24px;line-height:32px}.ct-menubar-heading-item-h3{font-size:20px;line-height:28px}.ct-menubar-heading-item-h4{font-size:16px;line-height:24px}.ct-menubar-heading-item-h5{font-size:14px;line-height:22px}.ct-menubar-heading-item-h6{font-size:12px;line-height:20px}";
menubar_styleInject(menubar_css_248z$5);

var HeadingItem = function(param) {
    var headingList = param.headingList;
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = Object(react["useCallback"])(function(command) {
        command();
        manager.editorView.focus();
    }, []);
    var list = Object(react["useMemo"])(function() {
        return headingList.map(function(item, index) {
            var title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classnames_default()(menubar_classNamePrefix("menubar-heading-item"), menubar_classNamePrefix("menubar-heading-item-h".concat(index)))
            }, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        headingList
    ]);
    var test = Object(react["useMemo"])(function() {
        return 1;
    }, [
        manager
    ]);
    // 获取菜单栏段落下拉列表激活态
    var headingLabel = [
        "正文",
        "标题 1",
        "标题 2",
        "标题 3",
        "标题 4",
        "标题 5",
        "标题 6"
    ];
    var level = manager.commands.heading.headingLevel();
    var activeHeading = headingLabel[level];
    var isDisabled = headingList[headingList.length - 1].isDisabled();
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 120,
        buttonWidth: 80,
        title: activeHeading,
        tips: "段落格式",
        className: menubar_classNamePrefix("menubar-heading"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var menubar_findFontSizeEmpty = function(state, defaultSize) {
    var _selection_$cursor;
    var schema = state.schema, selection = state.selection, tr = state.tr;
    var font = schema.marks.font;
    // 选区为空的情况
    var storedMarks = tr.storedMarks || state.storedMarks || ((_selection_$cursor = selection.$cursor) === null || _selection_$cursor === void 0 ? void 0 : _selection_$cursor.marks()) || [];
    var sm = storedMarks.find(function(m) {
        return m.type === font;
    });
    return sm ? sm.attrs.dataSize : defaultSize;
};
var menubar_findFontSizeRange = function(state, defaultSize) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var text = schema.nodes.text;
    var font = schema.marks.font;
    var ranges = selection.ranges;
    var lastFontSize = null;
    var retFlag = false;
    ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        // 如果选中的文本包含多个字号格式，则留空展示
        doc.nodesBetween(from, to, function(node, pos, parent, index) {
            if (retFlag) return;
            if (node.type !== text) return;
            var findMark = node.marks.find(function(mark) {
                return mark.type === font;
            });
            if (!findMark) {
                if (lastFontSize && lastFontSize !== defaultSize) {
                    lastFontSize = null;
                    retFlag = true;
                    return;
                }
                lastFontSize = defaultSize;
                return;
            }
            var fontSize = findMark.attrs.dataSize || defaultSize;
            if (index === 0) {
                lastFontSize = fontSize;
                return;
            }
            if (lastFontSize && lastFontSize !== fontSize) {
                lastFontSize = null;
                retFlag = true;
                return;
            }
            lastFontSize = fontSize;
        });
    });
    return lastFontSize;
};
// 获取菜单栏字号下拉列表激活态真实字号
var menubar_findActiveFontSize = function(state, defaultSize) {
    var selection = state.selection;
    var empty = selection.empty;
    // 选区为空的情况
    if (empty) return menubar_findFontSizeEmpty(state, defaultSize);
    // 选区为范围的情况
    return menubar_findFontSizeRange(state, defaultSize);
};
/**
 * 获取当前选区设置的字体
 */ var menubar_getFontSize = function() {
    var defaultSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
    return function(state) {
        return menubar_findActiveFontSize(state, defaultSize);
    };
};

var findActiveFontSizeTitle = function(fontSize) {
    if (fontSize) {
        var found = fontSizeConfig.find(function(item) {
            return "".concat(item.fontSize) === "".concat(fontSize);
        });
        return found && found.title;
    }
    return "";
};
var FontItem = function(param) {
    var fontList = param.fontList;
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = Object(react["useMemo"])(function() {
        return fontList.map(function(item) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: menubar_classNamePrefix("menubar-font-item")
            }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        fontList
    ]);
    var activeFontSize = menubar_getFontSize(14)(manager.editorView.state);
    var activeFontSizeTitle = findActiveFontSizeTitle(activeFontSize);
    var isDisabled = fontList[fontList.length - 1].isDisabled();
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 52,
        buttonWidth: 45,
        title: activeFontSizeTitle,
        tips: "字体大小",
        className: menubar_classNamePrefix("menubar-font"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var menubar_css_248z$6 = ".ct-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:240px;height:156px;bottom:-165px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.ct-color-popover .default .color-grid{border:none}.ct-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.ct-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.ct-color-grid{margin:0 1px;width:16px;height:16px;cursor:pointer;border:1px solid #fff}.ct-color-grid:nth-child(2){border:1px solid #eee;width:14px;height:14px;margin:1px 2px}.ct-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff}.ct-color-grid:hover{z-index:3;border-radius:1px}.ct-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #fff}.ct-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.ct-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.ct-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.ct-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.ct-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.ct-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.ct-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.ct-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.ct-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.ct-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.ct-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.ct-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.ct-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.ct-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.ct-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.ct-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.ct-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.ct-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.ct-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.ct-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.ct-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.ct-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.ct-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.ct-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.ct-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.ct-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.ct-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.ct-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.ct-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.ct-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.ct-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.ct-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.ct-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.ct-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.ct-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.ct-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.ct-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.ct-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.ct-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.ct-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.ct-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.ct-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.ct-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.ct-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.ct-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.ct-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.ct-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.ct-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.ct-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.ct-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.ct-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.ct-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.ct-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.ct-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.ct-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.ct-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.ct-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.ct-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.ct-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.ct-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.ct-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.ct-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.ct-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.ct-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.ct-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.ct-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.ct-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.ct-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.ct-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.ct-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.ct-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.ct-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #ddd;width:16px;height:16px;margin:0 1px}";
menubar_styleInject(menubar_css_248z$6);

function menubar_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function menubar_getPrototypeOf(o) {
    menubar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf(o);
}
function menubar_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf(subClass, superClass);
}
function menubar_possibleConstructorReturn(self, call) {
    if (call && (menubar_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized(self);
}
function menubar_setPrototypeOf(o, p) {
    menubar_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf(o, p);
}
var menubar_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function menubar_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn(this, result);
    };
}
var menubar_ColorPicker = /*#__PURE__*/ function(Component) {
    menubar_inherits(ColorPicker, Component);
    var _super = menubar_createSuper(ColorPicker);
    function ColorPicker() {
        menubar_classCallCheck(this, ColorPicker);
        return _super.apply(this, arguments);
    }
    var _proto = ColorPicker.prototype;
    _proto.render = function render() {
        var _this_props = this.props, type = _this_props.type, _this_props_defaultColor = _this_props.defaultColor, defaultColor = _this_props_defaultColor === void 0 ? "" : _this_props_defaultColor, onSelect = _this_props.onSelect, selectedColor = _this_props.selectedColor;
        var colorGrids = menubar_colors.map(function(color, index) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: color,
                onClick: function() {
                    return onSelect(color);
                },
                className: classnames_default()(menubar_classNamePrefix("color-grid"), {
                    selected: selectedColor === color,
                    "has-margin": index >= 10 && index < 20
                }),
                style: {
                    background: color,
                    boxShadow: selectedColor === color ? "0 0 0 2px ".concat(color) : ""
                }
            });
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            "data-action": "".concat(type, "-color"),
            className: "".concat(menubar_classNamePrefix("color-popover"))
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            onClick: function() {
                return onSelect(defaultColor);
            },
            className: "default"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            style: {
                background: defaultColor,
                borderColor: defaultColor
            },
            className: "color-grid"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "text"
        }, "恢复默认")), colorGrids);
    };
    return ColorPicker;
}(react["Component"]);

var img$C = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3eA%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='06%e3%80%81%e7%bc%96%e8%be%91%e9%a1%b5-%e4%b8%8d%e5%8f%af%e6%9f%a5%e7%9c%8b%e5%ae%8f%ef%bc%881024%ef%bc%89' transform='translate(-448.000000%2c -21.000000)' fill='%23666666'%3e %3cg id='Group'%3e %3cg id='Group-8' transform='translate(20.000000%2c 15.000000)'%3e %3cg id='%e6%96%87%e5%ad%97%e9%a2%9c%e8%89%b2' transform='translate(420.000000%2c 0.000000)'%3e %3cg id='Group-6' transform='translate(6.000000%2c 6.000000)'%3e %3cpath d='M8.61943991%2c5.90197413 L7.01082031%2c1.48400272 L5.30121115%2c5.90197413 L8.61943991%2c5.90197413 Z M6.26061207%2c0 L7.88365875%2c0 L11.728476%2c10 L10.1559241%2c10 L9.08110652%2c7.00476515 L4.89003932%2c7.00476515 L3.74308634%2c10 L2.27152402%2c10 L6.26061207%2c0 Z' id='A'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var menubar_css_248z$7 = ".ct-color-popover[data-action=text-color] .default .color-grid{background-color:#333}.ct-menubar-color .icon-wrap{height:100%;display:flex;align-items:center}.ct-menubar-color .font-icon{padding:0 4px 3px 7px;font-size:0}.ct-menubar-color .font-icon .color-icon{width:10px;margin:0 2px 2px}.ct-menubar-color .font-icon .color-line{width:14px;height:3px;position:absolute;bottom:5px;left:10px}.ct-menubar-color .arrow:hover{background:rgba(0,0,0,.07)}";
menubar_styleInject(menubar_css_248z$7);

function _arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$3(arr, i) {
    return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$3();
}
function _unsupportedIterableToArray$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}
var ColorItem = function(param) {
    var menuInfo = param.menuInfo;
    var manager = Object(react["useContext"])(ManagerContext);
    var _useState = _slicedToArray$3(Object(react["useState"])("#333"), 2), currentColor = _useState[0], setCurrentColor = _useState[1];
    var onClickIcon = function(e) {
        e.stopPropagation();
        menuInfo.command(currentColor);
        manager.editorView.focus();
    };
    var onClickColor = function(color) {
        menuInfo.command(color);
        manager.editorView.focus();
        setCurrentColor(color);
    };
    var list = Object(react["useMemo"])(function() {
        return /*#__PURE__*/ react_default.a.createElement(menubar_ColorPicker, {
            type: "text",
            defaultColor: "",
            selectedColor: currentColor,
            onSelect: onClickColor
        });
    }, [
        currentColor
    ]);
    var customButton = Object(react["useMemo"])(function() {
        return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "icon-wrap"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "font-icon",
            onClick: onClickIcon
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: img$C,
            className: "color-icon",
            alt: "font_icon"
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "color-line",
            style: {
                background: currentColor || "#333"
            }
        }))), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "arrow"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: img$B,
            alt: "triangle"
        })));
    }, [
        currentColor
    ]);
    var isDisabled = menuInfo.isDisabled() || false;
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        buttonWidth: 46,
        width: 0,
        tips: "文字颜色",
        className: menubar_classNamePrefix("menubar-color"),
        isDisabled: isDisabled
    }, customButton);
};

var SubsupItem = function(param) {
    var subsupList = param.subsupList;
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = Object(react["useMemo"])(function() {
        return subsupList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classnames_default()(menubar_classNamePrefix("menubar-subsup-item"), menubar_classNamePrefix("menubar-subsup-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        subsupList
    ]);
    var isDisabled = subsupList.reduce(function(prev, cur) {
        return prev || cur.isDisabled();
    }, false);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 100,
        buttonWidth: 40,
        icon: subsupList[0].icon,
        tips: "文字其他",
        className: menubar_classNamePrefix("menubar-subsup"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var AlignItem = function(param) {
    var alignList = param.alignList;
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = Object(react["useMemo"])(function() {
        return alignList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classnames_default()(menubar_classNamePrefix("menubar-align-item"), menubar_classNamePrefix("menubar-align-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        alignList
    ]);
    var isDisabled = alignList.reduce(function(prev, cur) {
        return prev || cur.isDisabled();
    }, false);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 100,
        buttonWidth: 40,
        icon: alignList[0].icon,
        tips: "对齐方式",
        className: menubar_classNamePrefix("menubar-align"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var NoteItem = function(param) {
    var noteList = param.noteList;
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var list = Object(react["useMemo"])(function() {
        return noteList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classnames_default()(menubar_classNamePrefix("menubar-note-item"), menubar_classNamePrefix("menubar-note-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        noteList
    ]);
    var isDisabled = noteList.reduce(function(prev, cur) {
        return prev || cur.isDisabled();
    }, false);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 100,
        buttonWidth: 50,
        icon: noteList[0].icon,
        tips: "样式",
        className: menubar_classNamePrefix("menubar-note"),
        isDisabled: isDisabled,
        hasArrow: true
    });
};

var TablePopup = /*#__PURE__*/ Object(react["forwardRef"])(function(param, ref) {
    var highlight = param.highlight, current = param.current, onMouseMove = param.onMouseMove, command = param.command;
    var grids = Object(react["useMemo"])(function() {
        var rows = [];
        var rowNum = highlight.rowNum, colNum = highlight.colNum;
        var rowCount = current.rowCount, colCount = current.colCount;
        Array.from({
            length: rowCount
        }).forEach(function(row, rowIndex) {
            var blocks = [];
            Array.from({
                length: colCount
            }).forEach(function(col, colIndex) {
                if (rowNum >= rowIndex + 1 && colNum >= colIndex + 1) {
                    blocks.push(/*#__PURE__*/ react_default.a.createElement("div", {
                        key: colIndex,
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        className: "block"
                    }, /*#__PURE__*/ react_default.a.createElement("span", {
                        className: "block-inner",
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        style: {
                            backgroundColor: "rgba(0, 0, 0, 0.13)"
                        }
                    })));
                } else {
                    blocks.push(/*#__PURE__*/ react_default.a.createElement("div", {
                        key: colIndex,
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        className: "block"
                    }, /*#__PURE__*/ react_default.a.createElement("span", {
                        "data-row": rowIndex,
                        "data-col": colIndex,
                        className: "block-inner"
                    })));
                }
            });
            rows.push(/*#__PURE__*/ react_default.a.createElement("div", {
                className: "row",
                style: {
                    height: "24px"
                },
                "data-row": rowIndex,
                key: rowIndex
            }, blocks));
        });
        return rows;
    }, [
        highlight,
        current
    ]);
    var onClick = Object(react["useCallback"])(function() {
        var rowNum = highlight.rowNum, colNum = highlight.colNum;
        command({
            rowCnt: rowNum,
            colCnt: colNum
        });
    }, [
        highlight
    ]);
    return /*#__PURE__*/ react_default.a.createElement("div", {
        ref: ref,
        onMouseMove: onMouseMove,
        className: menubar_classNamePrefix("add-table-popup"),
        onClick: onClick
    }, /*#__PURE__*/ react_default.a.createElement("div", null, grids), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "count"
    }, "".concat(highlight.rowNum, " \xd7 ").concat(highlight.colNum)));
});

var menubar_css_248z$8 = ".ct-add-table-popup{padding:12px;cursor:pointer}.ct-add-table-popup .block{width:24px;height:24px;background:#fff;display:inline-block;box-sizing:border-box;border-radius:2px}.ct-add-table-popup .block .block-inner{margin:4px;box-sizing:border-box;border:1px solid rgba(0,0,0,.13);display:inline-block;width:16px;height:16px;border-radius:2px;background:#fff}.ct-add-table-popup .count{text-align:center;font-size:12px;color:rgba(0,0,0,.38);letter-spacing:0;line-height:20px}";
menubar_styleInject(menubar_css_248z$8);

function _arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$4(arr, i) {
    return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$4();
}
function _unsupportedIterableToArray$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}
var tableConfig = {
    max: 10,
    default: 6,
    itemWidth: 24
};
function adjustNum(num) {
    // 取整
    if (num < 1) return 1;
    if (num >= tableConfig.max) return tableConfig.max;
    return ~~num;
}
var TableItem = function(props) {
    var popupRef = Object(react["useRef"])(null);
    var manager = Object(react["useContext"])(ManagerContext);
    var _useState = _slicedToArray$4(Object(react["useState"])({
        rowCount: tableConfig.default,
        colCount: tableConfig.default
    }), 2), current = _useState[0], setCurrent = _useState[1];
    var _useState1 = _slicedToArray$4(Object(react["useState"])({
        rowNum: 1,
        colNum: 1
    }), 2), highlight = _useState1[0], setCurrentHighlight = _useState1[1];
    var onVisibleChange = function() {
        setCurrent({
            rowCount: tableConfig.default,
            colCount: tableConfig.default
        });
        setCurrentHighlight({
            rowNum: 1,
            colNum: 1
        });
    };
    var onMouseMove = Object(react["useCallback"])(function(e) {
        var rowCount = current.rowCount, colCount = current.colCount;
        var _popupRef_current_getBoundingClientRect = popupRef.current.getBoundingClientRect(), left = _popupRef_current_getBoundingClientRect.left, top = _popupRef_current_getBoundingClientRect.top;
        var deltaColumn = adjustNum((e.clientX - left + tableConfig.itemWidth / 2) / tableConfig.itemWidth); // rightX  鼠标到 弹出框 左边的格子数
        var deltaRow = adjustNum((e.clientY - top + tableConfig.itemWidth / 2) / tableConfig.itemWidth); //  topY 鼠标到弹出框 上方的距离 到上方的格子数
        var newRowNum = deltaRow;
        var newColNum = deltaColumn;
        var newColCount = colCount;
        var newRowCount = rowCount;
        if (deltaColumn >= colCount && colCount < tableConfig.max) {
            newColCount = colCount + 1;
        } else if (deltaColumn < colCount - 1 && colCount > 7) {
            newColCount = deltaColumn - 1;
        }
        if (deltaRow >= rowCount && rowCount < tableConfig.max) {
            newRowCount = rowCount + 1;
        } else if (deltaRow < rowCount - 1 && rowCount > 7) {
            newRowCount = deltaRow - 1;
        }
        setCurrent({
            rowCount: newRowCount,
            colCount: newColCount
        });
        setCurrentHighlight({
            rowNum: newRowNum,
            colNum: newColNum
        });
    }, [
        current
    ]);
    var icon = props.icon, title = props.title, command = props.command, isDisabled = props.isDisabled;
    var width = Object(react["useMemo"])(function() {
        return (current.colCount + 1) * 24;
    }, [
        current
    ]);
    var isTableDisabled = isDisabled();
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: /*#__PURE__*/ react_default.a.createElement(TablePopup, {
            ref: popupRef,
            onMouseMove: onMouseMove,
            highlight: highlight,
            current: current,
            command: command
        }),
        onVisibleChange: onVisibleChange,
        width: width,
        icon: icon,
        tips: title,
        className: menubar_classNamePrefix("menubar-table"),
        isDisabled: isTableDisabled,
        hasArrow: true
    });
};

var css_248z$9 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
menubar_styleInject(css_248z$9);

function menubar_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function menubar_defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menubar_getPrototypeOf$1(o) {
    menubar_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf$1(o);
}
function menubar_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf$1(subClass, superClass);
}
function menubar_possibleConstructorReturn$1(self, call) {
    if (call && (menubar_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized$1(self);
}
function menubar_setPrototypeOf$1(o, p) {
    menubar_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf$1(o, p);
}
var menubar_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function menubar_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper$1(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn$1(this, result);
    };
}
var menubar_Button = /*#__PURE__*/ function(Component) {
    menubar_inherits$1(Button, Component);
    var _super = menubar_createSuper$1(Button);
    function Button() {
        menubar_classCallCheck$1(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = menubar_classNamePrefix(prefix);
        var classes = menubar_defineProperty$3({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ react_default.a.createElement("button", {
            disabled: disabled,
            className: classnames_default()(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(react["Component"]);

var css_248z$a = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
menubar_styleInject(css_248z$a);

/* eslint-disable jsx-a11y/control-has-associated-label */ function menubar_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function menubar_getPrototypeOf$2(o) {
    menubar_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf$2(o);
}
function menubar_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf$2(subClass, superClass);
}
function menubar_possibleConstructorReturn$2(self, call) {
    if (call && (menubar_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized$2(self);
}
function menubar_setPrototypeOf$2(o, p) {
    menubar_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf$2(o, p);
}
var menubar_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function menubar_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper$2(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn$2(this, result);
    };
}
var menubar_defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var menubar_Modal = /*#__PURE__*/ function(Component) {
    menubar_inherits$2(Modal, Component);
    var _super = menubar_createSuper$2(Modal);
    function Modal() {
        menubar_classCallCheck$2(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? "确定" : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? "取消" : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = menubar_classNamePrefix(userPrefix);
        return /*#__PURE__*/ react_dom_default.a.createPortal(/*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: menubar_defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ react_default.a.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ react_default.a.createElement(menubar_Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ react_default.a.createElement(menubar_Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(react["Component"]);
menubar_Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var colors$1 = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

function menubar_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function menubar_getPrototypeOf$3(o) {
    menubar_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf$3(o);
}
function menubar_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf$3(subClass, superClass);
}
function menubar_possibleConstructorReturn$3(self, call) {
    if (call && (menubar_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized$3(self);
}
function menubar_setPrototypeOf$3(o, p) {
    menubar_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf$3(o, p);
}
var menubar_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function menubar_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper$3(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn$3(this, result);
    };
}
var menubar_PopItem = /*#__PURE__*/ function(Component) {
    menubar_inherits$3(PopItem, Component);
    var _super = menubar_createSuper$3(PopItem);
    function PopItem() {
        menubar_classCallCheck$3(this, PopItem);
        return _super.apply(this, arguments);
    }
    var _proto = PopItem.prototype;
    _proto.render = function render() {
        var _this_props = this.props, type = _this_props.type, defaultColor = _this_props.defaultColor, onSelect = _this_props.onSelect, selectedColor = _this_props.selectedColor;
        var colorGrids = colors$1.map(function(color, index) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: color,
                onClick: function() {
                    return onSelect(color);
                },
                className: classnames_default()(menubar_classNamePrefix("table-color-grid"), {
                    selected: selectedColor === color,
                    "has-margin": index >= 10 && index < 20
                }),
                style: {
                    background: color
                }
            });
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            "data-action": "".concat(type, "-color"),
            className: "".concat(menubar_classNamePrefix("table-color-popover"))
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            onClick: function() {
                return onSelect(defaultColor);
            },
            className: "default"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            style: {
                background: defaultColor,
                borderColor: defaultColor
            },
            className: "color-grid"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "text"
        }, "恢复默认")), colorGrids);
    };
    return PopItem;
}(react["Component"]);

var css_248z$b = '.ct-table-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:246px;font-size:12px;cursor:pointer;transition:all .2s ease}.ct-table-color-popover-wrapper .color-block{display:flex;justify-content:flex-start;align-items:baseline;width:246px;height:24px;padding:6px 8px;border:1px solid #ddd;border-radius:2px}.ct-table-color-popover-wrapper .color-block .left{width:100%;height:100%;margin-right:10px}.ct-table-color-popover-wrapper .color-block .right{width:14px;height:100%;background:url("data:image/svg+xml,%3Csvg width%3D%227px%22 height%3D%224px%22 viewBox%3D%220 0 7 4%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%2220%E3%80%81%E5%AF%8C%E6%96%87%E6%9C%AC%E7%BC%96%E8%BE%91%22 transform%3D%22translate(-521.000000%2C -82.000000)%22 fill%3D%22%23AEAEAE%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 56.000000)%22%3E                %3Cg id%3D%22Group-8%22 transform%3D%22translate(258.500000%2C 15.000000)%22%3E                    %3Cg id%3D%22%E5%AD%97%E5%8F%B7%22 transform%3D%22translate(223.000000%2C 0.000000)%22%3E                        %3Cpolygon id%3D%22%E5%BD%A2%E7%8A%B6_32%22 points%3D%2240 11.5 46 11.5 43 14.5%22%3E%3C%2Fpolygon%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-table-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-table-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.ct-table-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.ct-table-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.ct-table-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.ct-table-color-grid:nth-child(2),.ct-table-color-grid:nth-child(12){border:1px solid #eee}.ct-table-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-table-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.ct-table-color-grid:hover:nth-child(2),.ct-table-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}.ct-table-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #fff}.ct-table-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.ct-table-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.ct-table-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.ct-table-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.ct-table-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.ct-table-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.ct-table-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.ct-table-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.ct-table-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.ct-table-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.ct-table-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.ct-table-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.ct-table-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.ct-table-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.ct-table-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.ct-table-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.ct-table-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.ct-table-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.ct-table-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.ct-table-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.ct-table-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.ct-table-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.ct-table-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.ct-table-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.ct-table-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.ct-table-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.ct-table-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.ct-table-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.ct-table-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.ct-table-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.ct-table-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.ct-table-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.ct-table-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.ct-table-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.ct-table-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.ct-table-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.ct-table-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.ct-table-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.ct-table-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.ct-table-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.ct-table-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.ct-table-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.ct-table-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.ct-table-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.ct-table-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.ct-table-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.ct-table-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.ct-table-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.ct-table-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.ct-table-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.ct-table-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.ct-table-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.ct-table-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.ct-table-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.ct-table-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.ct-table-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.ct-table-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.ct-table-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.ct-table-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.ct-table-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.ct-table-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.ct-table-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.ct-table-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.ct-table-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.ct-table-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.ct-table-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.ct-table-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.ct-table-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.ct-table-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.ct-table-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.ct-table-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}';
menubar_styleInject(css_248z$b);

/* eslint-disable react/destructuring-assignment */ function menubar_assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function menubar_getPrototypeOf$4(o) {
    menubar_getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf$4(o);
}
function menubar_inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf$4(subClass, superClass);
}
function menubar_possibleConstructorReturn$4(self, call) {
    if (call && (menubar_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized$4(self);
}
function menubar_setPrototypeOf$4(o, p) {
    menubar_setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf$4(o, p);
}
var menubar_typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function menubar_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper$4(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn$4(this, result);
    };
}
var menubar_ColorPopover = /*#__PURE__*/ function(Component) {
    menubar_inherits$4(ColorPopover, Component);
    var _super = menubar_createSuper$4(ColorPopover);
    function ColorPopover(props) {
        menubar_classCallCheck$4(this, ColorPopover);
        var _this;
        _this = _super.call(this, props);
        // 接收来自 Popover 的选中事件后，调用父级 transform 方法
        _this.onSelect = function(color) {
            var setColor = _this.props.setColor;
            setColor(color);
            // HACK 异步 setState 以确保 tooltip 关闭
            window.requestAnimationFrame(function() {
                _this.setState({
                    hasTooltip: false,
                    isOpen: false
                });
            });
        };
        _this.handleMouseEnter = function() {
            var isOpen = _this.state.isOpen;
            if (isOpen) return;
            _this.setState({
                hasTooltip: true
            });
        };
        _this.state = {
            hasTooltip: false,
            isOpen: false
        };
        return _this;
    }
    var _proto = ColorPopover.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, type = _this_props.type, tips = _this_props.tips, defaultColor = _this_props.defaultColor, selectedColor = _this_props.selectedColor;
        var _this_state = this.state, hasTooltip = _this_state.hasTooltip, isOpen = _this_state.isOpen;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: function() {
                return _this.setState({
                    isOpen: !isOpen
                });
            },
            className: "".concat(menubar_classNamePrefix("table-color-popover-wrapper"), " ").concat(type, "-color")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "color-block"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "left",
            style: {
                backgroundColor: selectedColor
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "right"
        })), isOpen && /*#__PURE__*/ react_default.a.createElement(menubar_PopItem, {
            type: type,
            defaultColor: defaultColor,
            selectedColor: selectedColor,
            onSelect: this.onSelect
        }), hasTooltip && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "ct-toolbar-tooltip"
        }, tips));
    };
    return ColorPopover;
}(react["Component"]);

var css_248z$c = '.table-modal-content{display:flex;justify-content:flex-start;align-items:baseline;padding:24px}.table-modal-content .left{display:flex;flex-direction:column;justify-content:space-between;width:246px;height:176px;margin-right:30px}.table-modal-content .right{width:300px}.table-modal-content .title{margin-bottom:8px;font-size:14px;color:#333;line-height:22px}.table-modal-content .style-wrapper{display:flex;justify-content:flex-start;align-items:baseline}.table-modal-content .style-item{width:76px;height:70px;text-align:center}.table-modal-content .dashed{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2242px%22 viewBox%3D%220 0 48 42%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E8%99%9A%E7%BA%BF%E6%A1%86%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E8%A1%A8%E6%A0%BC%E5%B1%9E%E6%80%A7%22%3E            %3Cpath d%3D%22M45%2C16.5 L45%2C10.5 L48%2C10.5 L48%2C16.5 L45%2C16.5 Z M45%2C25.5 L48%2C25.5 L48%2C31.5 L45%2C31.5 L45%2C25.5 Z M45%2C34.5 L48%2C34.5 L48%2C36 C48%2C39.3137085 45.3137085%2C42 42%2C42 L37.4854431%2C42 L37.4854431%2C39 L42%2C39 C43.6568542%2C39 45%2C37.6568542 45%2C36 L45%2C34.5 Z M34.4854431%2C39 L34.4854431%2C42 L28.4854431%2C42 L28.4854431%2C39 L34.4854431%2C39 Z M19.4854431%2C39 L19.4854431%2C42 L13.4854431%2C42 L13.4854431%2C39 L19.4854431%2C39 Z M10.4854431%2C39 L10.4854431%2C42 L6%2C42 C2.6862915%2C42 0%2C39.3137085 0%2C36 L0%2C34.5 L3%2C34.5 L3%2C36 C3%2C37.6568542 4.34314575%2C39 6%2C39 L10.4854431%2C39 Z M3%2C31.5 L0%2C31.5 L0%2C25.5 L3%2C25.5 L3%2C31.5 Z M3%2C16.5 L0%2C16.5 L0%2C10.5 L3%2C10.5 L3%2C16.5 Z M3%2C7.5 L0%2C7.5 L0%2C6 C0%2C2.6862915 2.6862915%2C0 6%2C0 L10.4854431%2C0 L10.4854431%2C3 L6%2C3 C4.34314575%2C3 3%2C4.34314575 3%2C6 L3%2C7.5 Z M13.4854431%2C3 L13.4854431%2C0 L19.4854431%2C0 L19.4854431%2C3 L13.4854431%2C3 Z M28.4854431%2C3 L28.4854431%2C0 L34.4854431%2C0 L34.4854431%2C3 L28.4854431%2C3 Z M37.4854431%2C3 L37.4854431%2C0 L42%2C0 C45.3137085%2C0 48%2C2.6862915 48%2C6 L48%2C7.5 L45%2C7.5 L45%2C6 C45%2C4.34314575 43.6568542%2C3 42%2C3 L37.4854431%2C3 Z%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E            %3Cpath d%3D%22M25.4854431%2C22.5 L25.4854431%2C31.538842 L22.4854431%2C31.538842 L22.4854431%2C22.5 L10.2857143%2C22.5 L10.2857143%2C19.5 L22.4854431%2C19.5 L22.4854431%2C10.461158 L25.4854431%2C10.461158 L25.4854431%2C19.5 L37.7142857%2C19.5 L37.7142857%2C22.5 L25.4854431%2C22.5 Z M-2.27373675e-13%2C22.5 L-2.27373675e-13%2C19.5 L6.85714286%2C19.5 L6.85714286%2C22.5 L-2.27373675e-13%2C22.5 Z M41.1428571%2C22.5 L41.1428571%2C19.5 L48%2C19.5 L48%2C22.5 L41.1428571%2C22.5 Z M22.4854431%2C1.42108547e-14 L25.4854431%2C1.42108547e-14 L25.4854431%2C6.97410534 L22.4854431%2C6.97410534 L22.4854431%2C1.42108547e-14 Z M22.4854431%2C35.0258947 L25.4854431%2C35.0258947 L25.4854431%2C42 L22.4854431%2C42 L22.4854431%2C35.0258947 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23CCCCCC%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.table-modal-content .solid{margin-left:18px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2242px%22 viewBox%3D%220 0 48 42%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%AE%9E%E7%BA%BF%E6%A1%86%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-9%22%3E            %3Cpath d%3D%22M25.4854431%2C22.5 L25.4854431%2C31.538842 L22.4854431%2C31.538842 L22.4854431%2C22.5 L17.1428571%2C22.5 L10.2857143%2C22.5 L10.2857143%2C19.5 L17.1428571%2C19.5 L22.4854431%2C19.5 L22.4854431%2C10.461158 L25.4854431%2C10.461158 L25.4854431%2C19.5 L33.7302246%2C19.5 L37.7142857%2C19.5 L37.7142857%2C22.5 L33.7302246%2C22.5 L25.4854431%2C22.5 Z M0%2C22.5 L0%2C19.5 L6.85714286%2C19.5 L6.85714286%2C22.5 L0%2C22.5 Z M41.1428571%2C22.5 L41.1428571%2C19.5 L48%2C19.5 L48%2C22.5 L41.1428571%2C22.5 Z M22.4854431%2C0 L25.4854431%2C0 L25.4854431%2C6.97410534 L22.4854431%2C6.97410534 L22.4854431%2C0 Z M22.4854431%2C35.0258947 L25.4854431%2C35.0258947 L25.4854431%2C42 L22.4854431%2C42 L22.4854431%2C35.0258947 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23CCCCCC%22%3E%3C%2Fpath%3E            %3Cpath d%3D%22M6%2C3 C4.34314575%2C3 3%2C4.34314575 3%2C6 L3%2C36 C3%2C37.6568542 4.34314575%2C39 6%2C39 L42%2C39 C43.6568542%2C39 45%2C37.6568542 45%2C36 L45%2C6 C45%2C4.34314575 43.6568542%2C3 42%2C3 L6%2C3 Z M6%2C0 L42%2C0 C45.3137085%2C0 48%2C2.6862915 48%2C6 L48%2C36 C48%2C39.3137085 45.3137085%2C42 42%2C42 L6%2C42 C2.6862915%2C42 0%2C39.3137085 0%2C36 L0%2C6 C0%2C2.6862915 2.6862915%2C0 6%2C0 Z%22 id%3D%22Rectangle-15%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.table-modal-content .selected{background-color:rgba(0,167,205,.1)}.width-wrapper{padding:0 20px;display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;height:220px;border:1px solid #ddd;border-radius:2px;font-size:12px}.width-wrapper .width-item{cursor:pointer;width:126px;height:19px;line-height:19px;border-radius:2px;text-align:center;display:flex;align-items:center;justify-content:center}.width-wrapper .width-item .inner{display:inline-block;vertical-align:middle;width:110px;background:#1c6cdc}.width-wrapper .width-item:nth-child(2) .inner{height:4px}.width-wrapper .width-item:nth-child(3) .inner{height:1px}.width-wrapper .width-item:nth-child(4) .inner{height:5px}.width-wrapper .width-item:nth-child(5) .inner{height:2px}.width-wrapper .width-item:nth-child(6) .inner{height:6px}.width-wrapper .width-item:nth-child(7) .inner{height:3px}.width-wrapper .width-item:nth-child(8) .inner{height:7px}';
menubar_styleInject(css_248z$c);

function menubar_assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function menubar_getPrototypeOf$5(o) {
    menubar_getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf$5(o);
}
function menubar_inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf$5(subClass, superClass);
}
function menubar_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function menubar_possibleConstructorReturn$5(self, call) {
    if (call && (menubar_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized$5(self);
}
function menubar_setPrototypeOf$5(o, p) {
    menubar_setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf$5(o, p);
}
var menubar_typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function menubar_isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper$5(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn$5(this, result);
    };
}
var menubar_TableModal = /*#__PURE__*/ function(Component) {
    menubar_inherits$5(TableModal, Component);
    var _super = menubar_createSuper$5(TableModal);
    function TableModal(props) {
        menubar_classCallCheck$5(this, TableModal);
        var _this;
        _this = _super.call(this, props);
        _this.handleOk = function() {
            var _this_props = _this.props, setTableAttrs = _this_props.setTableAttrs, hideModal = _this_props.hideModal;
            setTableAttrs(menubar_objectSpread$2({}, _this.state));
            hideModal();
        };
        _this.handleCancel = function() {
            var hideModal = _this.props.hideModal;
            hideModal();
        };
        var getTableAttrs = _this.props.getTableAttrs;
        var attrs = getTableAttrs();
        _this.state = {
            borderStyle: attrs.borderStyle || "solid",
            borderColor: attrs.borderColor || "#cccccc",
            borderWidth: attrs.borderWidth === null ? 1 : attrs.borderWidth
        };
        return _this;
    }
    var _proto = TableModal.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, borderStyle = _this_state.borderStyle, borderColor = _this_state.borderColor, borderWidth = _this_state.borderWidth;
        return /*#__PURE__*/ react_default.a.createElement(menubar_Modal, {
            className: "",
            contentClassName: "table-modal-wrapper",
            title: "表格属性",
            disabled: false,
            okText: "确定",
            onOk: this.handleOk,
            onCancel: function() {
                _this.handleCancel();
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "table-modal-content"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "left"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "border-style"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title"
        }, "边框样式："), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "style-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("style-item dashed", {
                selected: borderStyle === "dashed"
            }),
            onClick: function() {
                return _this.setState({
                    borderStyle: "dashed"
                });
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("style-item solid", {
                selected: borderStyle === "solid"
            }),
            onClick: function() {
                return _this.setState({
                    borderStyle: "solid"
                });
            }
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "border-color"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title"
        }, "边框颜色："), /*#__PURE__*/ react_default.a.createElement(menubar_ColorPopover, {
            type: "table-border",
            tips: "边框颜色",
            defaultColor: "#ccc",
            selectedColor: borderColor,
            setColor: function(color) {
                return _this.setState({
                    borderColor: color
                });
            }
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "right"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "border-width"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title"
        }, "边框宽度："), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "width-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("width-item", {
                selected: borderWidth === 0
            }),
            onClick: function() {
                return _this.setState({
                    borderWidth: 0
                });
            }
        }, "无"), [
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ].map(function(_) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: _,
                className: classnames_default()("width-item", {
                    selected: borderWidth === _
                }),
                onClick: function() {
                    return _this.setState({
                        borderWidth: _
                    });
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "inner",
                style: {
                    backgroundColor: borderColor
                }
            }));
        }))))));
    };
    return TableModal;
}(react["Component"]);

var img$D = "data:image/svg+xml,%3csvg t='1570527618080' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4679' width='20' height='20'%3e %3cpath d='M298.666667 192h106.666666v64h-106.666666v96l-213.333334-128 213.333334-128V192z m469.333333 405.333333H128v-64h640v-149.333333h64v490.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H128v-64h640V597.333333zM469.333333 128h426.666667v192H469.333333V128z' fill='black' p-id='4680'%3e%3c/path%3e%3c/svg%3e";

var img$E = "data:image/svg+xml,%3csvg t='1570527687806' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4850' width='20' height='20'%3e %3cpath d='M298.666667 768h106.666666v64h-106.666666v96l-213.333334-128 213.333334-128V768z m469.333333-277.333333H128v-64h640V192H128V128h682.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v490.666667h-64v-149.333333zM469.333333 704h426.666667v192H469.333333v-192z' fill='black' p-id='4851'%3e%3c/path%3e%3c/svg%3e";

var img$F = "data:image/svg+xml,%3csvg t='1570527820427' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5444' width='20' height='20'%3e %3cpath d='M85.333333 608h512v-192H85.333333v192z m384 64V832H85.333333v64h426.666667a21.333333 21.333333 0 0 0 21.333333-21.333333v-202.666667h-64z m64-320V149.333333a21.333333 21.333333 0 0 0-21.333333-21.333333H85.333333v64h384v160h64z m149.333334 76.714667L765.952 512 682.666667 595.285333 727.381333 640 810.666667 556.714667 893.952 640 938.666667 595.285333 855.381333 512 938.666667 428.714667 893.952 384 810.666667 467.285333 727.381333 384 682.666667 428.714667z' fill='black' p-id='5445'%3e%3c/path%3e%3c/svg%3e";

var img$G = "data:image/svg+xml,%3csvg t='1570527734623' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5162' width='20' height='20'%3e %3cpath d='M256 298.666667v128H192v-128H96l128-213.333334 128 213.333334H256z m277.333333 448V128h64v618.666667h234.666667V128h64v661.333333a21.333333 21.333333 0 0 1-21.333333 21.333334H384v-64h149.333333zM128 469.333333h192v426.666667H128V469.333333z' fill='black' p-id='5163'%3e%3c/path%3e%3c/svg%3e";

var img$H = "data:image/svg+xml,%3csvg t='1570527713921' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4991' width='20' height='20'%3e %3cpath d='M832 298.666667v128h-64v-128h-96l128-213.333334 128 213.333334H832zM426.666667 746.666667V128h64v618.666667h149.333333v64H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333334V128h64v618.666667h234.666667z m277.333333-277.333334h192v426.666667h-192V469.333333z' fill='black' p-id='4992'%3e%3c/path%3e%3c/svg%3e";

var img$I = "data:image/svg+xml,%3csvg t='1570527768162' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5303' width='20' height='20'%3e %3cpath d='M608 128v426.666667h-192V128h192z m64 298.666667H874.666667V128h64v341.333333a21.333333 21.333333 0 0 1-21.333334 21.333334H672v-64z m-320 64H106.666667a21.333333 21.333333 0 0 1-21.333334-21.333334V128h64v298.666667h202.666667v64z m76.181333 147.370666l84.266667 84.266667 84.266667-84.266667 45.226666 45.248-84.245333 84.266667 84.266667 84.266667-45.248 45.248-84.266667-84.266667-84.266667 84.266667-45.248-45.248 84.266667-84.266667-84.266667-84.266667 45.248-45.226666z' fill='black' p-id='5304'%3e%3c/path%3e%3c/svg%3e";

var img$J = "data:image/svg+xml,%3csvg t='1570527866151' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5585' width='20' height='20'%3e %3cpath d='M277.333333 544H192V832h192v-128h64v192H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667v192h-64V192H192v288h85.333333V384l213.333334 128-213.333334 128v-96zM640 832h192V544h-85.333333V640l-213.333334-128 213.333334-128v96h85.333333V192h-192v128h-64V128h298.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H576v-192h64v128z' fill='black' p-id='5586'%3e%3c/path%3e%3c/svg%3e";

var img$K = "data:image/svg+xml,%3csvg t='1570527885348' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5756' width='20' height='20'%3e %3cpath d='M896 704v170.666667a21.333333 21.333333 0 0 1-21.333333 21.333333H576V128h298.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v170.666667h-64V192h-192v288h85.333333V384l213.333334 128-213.333334 128v-96h-85.333333V832h192v-128h64zM192 832h192V544h-85.333333V640L85.333333 512l213.333334-128v96h85.333333V192H192v128H128V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h298.666667v768H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333v-170.666667h64v128z' fill='black' p-id='5757'%3e%3c/path%3e%3c/svg%3e";

var img$L = "data:image/svg+xml,%3csvg t='1570609845934' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3713' width='20' height='20'%3e %3cpath d='M512 256l106.666667 178.986667h-74.666667V938.666667h-64V434.986667H405.333333L512 256z m384-138.666667v64H128v-64h768z' fill='black' p-id='3714'%3e%3c/path%3e%3c/svg%3e";

var img$M = "data:image/svg+xml,%3csvg t='1570609798139' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3542' width='20' height='20'%3e %3cpath d='M480 74.666667h64v503.68H618.666667l-106.666667 178.986666-106.666667-178.986666h74.666667V74.666667zM128 896v-64h768v64H128z' fill='black' p-id='3543'%3e%3c/path%3e%3c/svg%3e";

var img$N = "data:image/svg+xml,%3csvg t='1570529387197' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5897' width='20' height='20'%3e %3cpath d='M512 618.666667l106.666667 178.986666h-74.666667V938.666667h-64v-141.013334H405.333333L512 618.666667z m384-138.666667v64H128v-64h768zM544 85.333333v141.013334H618.666667L512 405.333333l-106.666667-178.986666h74.666667V85.333333h64z' fill='black' fill-opacity='.87' p-id='5898'%3e%3c/path%3e%3c/svg%3e";

var TableAlignItem = function() {
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var alignList = [
        {
            title: "顶部对齐",
            icon: img$L,
            command: function() {
                return manager.commands.table.setCellVerticalAlign("top");
            }
        },
        {
            title: "居中对齐",
            icon: img$N,
            command: function() {
                return manager.commands.table.setCellVerticalAlign("middle");
            }
        },
        {
            title: "底部对齐",
            icon: img$M,
            command: function() {
                return manager.commands.table.setCellVerticalAlign("bottom");
            }
        }
    ];
    var list = Object(react["useMemo"])(function() {
        return alignList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classnames_default()(menubar_classNamePrefix("menubar-table-align-item"), menubar_classNamePrefix("menubar-table-align-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        alignList
    ]);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 120,
        buttonWidth: 40,
        icon: alignList[1].icon,
        tips: "上下对齐",
        className: menubar_classNamePrefix("menubar-table-align"),
        isDisabled: false,
        hasArrow: true
    });
};

var img$O = "data:image/svg+xml,%3csvg t='1570529706144' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6239' width='20' height='20'%3e %3cpath d='M426.666667 832h170.666666v-170.666667h-170.666666v170.666667z m-64 0v-170.666667H192v-64h170.666667v-170.666666H192v405.333333h170.666667z m64-405.333333v170.666666h170.666666v-170.666666h-170.666666z m234.666666 405.333333h170.666667V426.666667h-170.666667v170.666666h170.666667v64h-170.666667v170.666667zM896 149.333333v149.333334H128V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h725.333334a21.333333 21.333333 0 0 1 21.333333 21.333333z m0 213.333334v512a21.333333 21.333333 0 0 1-21.333333 21.333333H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V362.666667h768z' fill='black' p-id='6240'%3e%3c/path%3e%3c/svg%3e";

var img$P = "data:image/svg+xml,%3csvg t='1570529731401' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6410' width='20' height='20'%3e %3cpath d='M832 597.333333v-170.666666h-170.666667v170.666666h170.666667z m0 64h-170.666667v170.666667h-64v-170.666667h-170.666666v170.666667h405.333333v-170.666667z m-405.333333-64h170.666666v-170.666666h-170.666666v170.666666z m405.333333-234.666666V192H426.666667v170.666667h170.666666V192h64v170.666667h170.666667zM149.333333 128h149.333334v768H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333z m213.333334 0h512a21.333333 21.333333 0 0 1 21.333333 21.333333v725.333334a21.333333 21.333333 0 0 1-21.333333 21.333333H362.666667V128z' fill='black' p-id='6411'%3e%3c/path%3e%3c/svg%3e";

var img$Q = "data:image/svg+xml,%3csvg t='1570529939900' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6581' width='20' height='20'%3e %3cpath d='M653.610667 432.277333l-211.2-211.178666-211.2 211.2h422.4zM397.162667 85.333333l331.861333 331.861334a21.333333 21.333333 0 0 1 0 30.186666L457.493333 718.890667a21.333333 21.333333 0 0 1-30.165333 0L155.797333 447.381333a21.333333 21.333333 0 0 1 0-30.186666L397.162667 175.850667 351.914667 130.56 397.162667 85.333333zM128 768h768v128H128v-128z m643.797333-59.669333a64 64 0 0 1-64-64c0-23.573333 21.333333-66.24 64-128 42.666667 61.76 64 104.426667 64 128a64 64 0 0 1-64 64z' fill='black' p-id='6582'%3e %3c/path%3e%3c/svg%3e";

var css_248z$d = ".ct-table-bg-color-popover[data-action=text-color] .default .color-grid{background-color:#333}.ct-menubar-table-bg-color .icon-wrap{height:100%;display:flex;align-items:center}.ct-menubar-table-bg-color .font-icon{padding:0 4px 3px 7px;font-size:0}.ct-menubar-table-bg-color .font-icon .color-icon{width:20px;margin:2px}.ct-menubar-table-bg-color .font-icon .color-line{width:16px;height:3px;position:absolute;bottom:7px;left:9px}.ct-menubar-table-bg-color .arrow:hover{background:rgba(0,0,0,.07)}";
menubar_styleInject(css_248z$d);

function _arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$5(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$5(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$5() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$5(arr, i) {
    return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$5();
}
function _unsupportedIterableToArray$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}
var TableBgColorItem = function() {
    var manager = Object(react["useContext"])(ManagerContext);
    var _useState = _slicedToArray$5(Object(react["useState"])(""), 2), currentColor = _useState[0], setCurrentColor = _useState[1];
    var onClickIcon = function(e) {
        e.stopPropagation();
        manager.commands.table.setCellBgColor(currentColor);
        manager.editorView.focus();
    };
    var onClickColor = function(color) {
        manager.commands.table.setCellBgColor(color);
        manager.editorView.focus();
        setCurrentColor(color);
    };
    var list = Object(react["useMemo"])(function() {
        return /*#__PURE__*/ react_default.a.createElement(menubar_ColorPicker, {
            type: "text",
            defaultColor: "",
            selectedColor: currentColor,
            onSelect: onClickColor
        });
    }, [
        currentColor
    ]);
    var customButton = Object(react["useMemo"])(function() {
        return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "icon-wrap"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "font-icon",
            onClick: onClickIcon
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: img$Q,
            className: "color-icon",
            alt: "font_icon"
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "color-line",
            style: {
                background: currentColor || "#eee"
            }
        }))), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "arrow"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: img$B,
            alt: "triangle"
        })));
    }, [
        currentColor
    ]);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        buttonWidth: 46,
        width: 0,
        tips: "表格底色",
        className: menubar_classNamePrefix("menubar-table-bg-color"),
        isDisabled: false
    }, customButton);
};

var img$R = "data:image/svg+xml,%3csvg t='1570531313249' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6752' width='20' height='20'%3e %3cpath d='M704 832v64h-64v-64h64z m-224-64h64v64H576v64h-128v-64h32v-64zM384 832v64h-64v-64h64z m512-64v106.666667a21.333333 21.333333 0 0 1-21.333333 21.333333h-106.666667v-64h64v-64h64zM192 768v64h64v64H149.333333a21.333333 21.333333 0 0 1-21.333333-21.333333v-106.666667h64z m0-128v64H128v-64h64z m704 0v64h-64v-64h64z m-352 0v64h-64v-64h64zM896 448v128h-64v-32h-64v-64h64V448h64z m-352 0v32H576v64h-32V576h-64v-32H448v-64h32V448h64z m160 32v64h-64v-64h64z m-320 0v64h-64v-64h64zM896 320v64h-64v-64h64zM192 320v64H128v-64h64z m352 0v64h-64v-64h64zM874.666667 128a21.333333 21.333333 0 0 1 21.333333 21.333333v106.666667h-64V192h-64V128h106.666667zM256 128v64H192v64H128V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h106.666667z m192 64V128h128v64h-32v64h-64V192H448z m256-64v64h-64V128h64zM384 128v64h-64V128h64zM192 576H128v-128h64v32h64v64H192V576z' fill='black' p-id='6753'%3e%3c/path%3e%3c/svg%3e";

var img$S = "data:image/svg+xml,%3csvg t='1570531405018' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6983' width='20' height='20'%3e %3cpath d='M277.333333 213.333333V106.666667a21.333333 21.333333 0 0 1 21.333334-21.333334h426.666666a21.333333 21.333333 0 0 1 21.333334 21.333334v106.666666h192v64h-85.333334v640a21.333333 21.333333 0 0 1-21.333333 21.333334l-640-0.170667a21.333333 21.333333 0 0 1-21.333333-21.333333V277.333333H85.333333v-64h192z m405.333334 0V149.333333H341.333333v64h341.333334zM394.666667 448h64v256h-64V448z m170.666666 0h64v256h-64V448zM234.666667 278.528V874.666667h554.666666V277.333333l-554.666666 1.194667z' fill='black' p-id='6984'%3e%3c/path%3e%3c/svg%3e";

var TableWidthItem = function() {
    var manager = Object(react["useContext"])(ManagerContext);
    var handleClick = function(command) {
        command();
        manager.editorView.focus();
    };
    var widthList = [
        {
            title: "固定宽度",
            icon: "",
            command: function() {
                return manager.commands.table.setFixed();
            }
        },
        {
            title: "自适应",
            icon: "",
            command: function() {
                return manager.commands.table.setResponsive();
            }
        }
    ];
    var list = Object(react["useMemo"])(function() {
        return widthList.map(function(item, index) {
            var icon = item.icon, title = item.title, command = item.command;
            return /*#__PURE__*/ react_default.a.createElement(menubar_Trigger.Item, {
                key: title,
                onClick: function() {
                    return handleClick(command);
                },
                className: classnames_default()(menubar_classNamePrefix("menubar-table-width-item"), menubar_classNamePrefix("menubar-table-width-item-h".concat(index)))
            }, icon ? /*#__PURE__*/ react_default.a.createElement("img", {
                src: icon,
                alt: title
            }) : null, /*#__PURE__*/ react_default.a.createElement("span", null, title));
        });
    }, [
        widthList
    ]);
    return /*#__PURE__*/ react_default.a.createElement(Dropdown, {
        popup: list,
        width: 120,
        buttonWidth: 100,
        title: manager.commands.table.isResponsive() ? "自适应" : "固定宽度",
        tips: "",
        className: menubar_classNamePrefix("menubar-table-align"),
        isDisabled: false,
        hasArrow: true
    });
};

function _arrayLikeToArray$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$6(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$6(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$6() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$6(arr, i) {
    return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$6();
}
function _unsupportedIterableToArray$7(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}
var TableMenu = function() {
    var manager = Object(react["useContext"])(ManagerContext);
    var _useState = _slicedToArray$6(Object(react["useState"])(false), 2), showAttrsModal = _useState[0], setShowAttrsModal = _useState[1];
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("table-menubar-wrapper")
    }, /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "addRowBefore",
        icon: img$D,
        title: "上方插入行",
        command: manager.commands.table.addRowBefore,
        isDisabled: function() {
            return !manager.commands.table.canAddRowBefore();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "addRowAfter",
        icon: img$E,
        title: "下方插入行",
        command: manager.commands.table.addRowAfter,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "deleteRow",
        icon: img$F,
        title: "删除行",
        command: manager.commands.table.deleteRow,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "addColumnBefore",
        icon: img$G,
        title: "左侧插入列",
        command: manager.commands.table.addColumnBefore,
        isDisabled: function() {
            return !manager.commands.table.canAddColumnBefore();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "addColumnAfter",
        icon: img$H,
        title: "右侧插入列",
        command: manager.commands.table.addColumnAfter,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "deleteColumn",
        icon: img$I,
        title: "删除列",
        command: manager.commands.table.deleteColumn,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "mergeCells",
        icon: img$J,
        title: "合并单元格",
        command: manager.commands.table.mergeCells,
        isDisabled: function() {
            return !manager.commands.table.canMergeCells();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "splitCell",
        icon: img$K,
        title: "拆分单元格",
        command: manager.commands.table.splitCell,
        isDisabled: function() {
            return !manager.commands.table.canSplitCell();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(TableAlignItem, null), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "tableRowHeader",
        icon: img$O,
        title: manager.commands.table.hasRowHeader() ? "取消表头行" : "设置表头行",
        command: manager.commands.table.toggleRowHeader,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "tableColHeader",
        icon: img$P,
        title: manager.commands.table.hasColHeader() ? "取消表头列" : "设置表头列",
        command: manager.commands.table.toggleColHeader,
        isDisabled: function() {
            return !manager.commands.table.canToggleColHeader();
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(TableBgColorItem, null), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "tableAttrs",
        icon: img$R,
        title: "表格属性",
        command: function() {
            return setShowAttrsModal(true);
        },
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), showAttrsModal && /*#__PURE__*/ react_default.a.createElement(menubar_TableModal, {
        hideModal: function() {
            return setShowAttrsModal(false);
        },
        setTableAttrs: manager.commands.table.setTableAttrs,
        getTableAttrs: manager.commands.table.getTableAttrs
    }), /*#__PURE__*/ react_default.a.createElement(CommonItem, {
        key: "deleteTable",
        icon: img$S,
        title: "删除表格",
        command: manager.commands.table.deleteTable,
        isDisabled: function() {
            return false;
        },
        isActive: function() {
            return false;
        }
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement(TableWidthItem, null), /*#__PURE__*/ react_default.a.createElement("div", {
        className: menubar_classNamePrefix("menubar-divider"),
        key: Math.random()
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        onClick: function() {
            manager.commands.table.toggleNumCol();
            manager.editorView.focus();
        },
        className: classnames_default()(menubar_classNamePrefix("menubar-item"), menubar_classNamePrefix("menubar-table-num-item"), manager.commands.table.canToggleNumCol() ? "" : menubar_classNamePrefix("menubar-item-disabled"), manager.commands.table.hasNumCol() ? menubar_classNamePrefix("menubar-item-active") : ""),
        style: {
            width: 120
        }
    }, "显示表格行号列"));
};

function _arrayLikeToArray$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function menubar_arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}
function menubar_assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function menubar_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function menubar_getPrototypeOf$6(o) {
    menubar_getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return menubar_getPrototypeOf$6(o);
}
function menubar_inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) menubar_setPrototypeOf$6(subClass, superClass);
}
function menubar_iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function menubar_nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function menubar_possibleConstructorReturn$6(self, call) {
    if (call && (menubar_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return menubar_assertThisInitialized$6(self);
}
function menubar_setPrototypeOf$6(o, p) {
    menubar_setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return menubar_setPrototypeOf$6(o, p);
}
function menubar_toConsumableArray$1(arr) {
    return menubar_arrayWithoutHoles$1(arr) || menubar_iterableToArray$1(arr) || _unsupportedIterableToArray$8(arr) || menubar_nonIterableSpread$1();
}
var menubar_typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray$8(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}
function menubar_isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function menubar_createSuper$6(Derived) {
    var hasNativeReflectConstruct = menubar_isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = menubar_getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = menubar_getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return menubar_possibleConstructorReturn$6(this, result);
    };
}
var commonProcess = function(menuItem, manager) {
    var type = menuItem.type, config = menuItem.config;
    if (type === MenuType.Extra) {
        var _menuItem_children = menuItem.children, children = _menuItem_children === void 0 ? [] : _menuItem_children;
        return [
            /*#__PURE__*/ react_default.a.createElement(ExtraItem, {
                menuList: children,
                key: type
            })
        ];
    }
    var list = getMenuInfo(type, manager, config);
    if (type === MenuType.Subsup) {
        var subList = getMenuInfo(MenuType.Sub, manager, config) || [];
        var supList = getMenuInfo(MenuType.Sup, manager, config) || [];
        list = menubar_toConsumableArray$1(subList).concat(menubar_toConsumableArray$1(supList));
    }
    if (!list || !list.length) return [];
    switch(menuItem.type){
        case MenuType.Heading:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(HeadingItem, {
                        headingList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Font:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(FontItem, {
                        fontList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Color:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(ColorItem, {
                        menuInfo: list[0],
                        key: type
                    })
                ];
            }
        case MenuType.Subsup:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(SubsupItem, {
                        subsupList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Align:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(AlignItem, {
                        alignList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Note:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(NoteItem, {
                        noteList: list,
                        key: type
                    })
                ];
            }
        case MenuType.Table:
            {
                return [
                    /*#__PURE__*/ react_default.a.createElement(TableItem, _extends$1({}, list[0], {
                        key: type
                    }))
                ];
            }
        default:
            return list.map(function(item) {
                return /*#__PURE__*/ react_default.a.createElement(CommonItem, _extends$1({
                    name: type,
                    key: item.title
                }, item));
            });
    }
};
var getMenuComponents = function(manager, menuConfig) {
    return menuConfig.reduce(function(prev, cur) {
        prev = menubar_toConsumableArray$1(prev).concat(menubar_toConsumableArray$1(commonProcess(cur, manager)));
        if (cur.divider) {
            prev = menubar_toConsumableArray$1(prev).concat([
                /*#__PURE__*/ react_default.a.createElement("div", {
                    className: menubar_classNamePrefix("menubar-divider"),
                    key: Math.random()
                })
            ]);
        }
        return prev;
    }, []);
};
var menubar_Menubar = /*#__PURE__*/ function(Component) {
    menubar_inherits$6(Menubar, Component);
    var _super = menubar_createSuper$6(Menubar);
    function Menubar(props) {
        menubar_classCallCheck$6(this, Menubar);
        var _this;
        _this = _super.call(this, props);
        _this.update = function(manager) {
            _this.setState({
                manager: manager
            });
        };
        var manager = props.manager, config = props.config;
        _this.state = {
            manager: manager,
            config: config
        };
        return _this;
    }
    var _proto = Menubar.prototype;
    _proto.render = function render() {
        var _this_state = this.state, manager = _this_state.manager, config = _this_state.config;
        var showTableMenu = manager.commands.table && manager.commands.table.isInTable();
        return /*#__PURE__*/ react_default.a.createElement(ManagerContext.Provider, {
            value: manager
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: menubar_classNamePrefix("main-menubar-wrapper")
        }, getMenuComponents(manager, config)), showTableMenu && /*#__PURE__*/ react_default.a.createElement(TableMenu, null));
    };
    return Menubar;
}(react["Component"]);

var defaultMenuConfig = function() {
    return [
        {
            type: MenuType.History
        },
        {
            type: MenuType.ClearFormat,
            divider: true
        },
        {
            type: MenuType.Heading
        },
        {
            type: MenuType.Font
        },
        {
            type: MenuType.Bold
        },
        {
            type: MenuType.Italic
        },
        {
            type: MenuType.Strikethrough
        },
        {
            type: MenuType.Underline
        },
        {
            type: MenuType.Color
        },
        {
            type: MenuType.Subsup,
            divider: true
        },
        {
            type: MenuType.Align
        },
        {
            type: MenuType.BulletList
        },
        {
            type: MenuType.OrderedList
        },
        {
            type: MenuType.TaskList
        },
        {
            type: MenuType.Indent
        },
        {
            type: MenuType.Table
        },
        {
            type: MenuType.Image
        },
        {
            type: MenuType.Link
        },
        {
            type: MenuType.Code,
            divider: true
        },
        {
            type: MenuType.Extra,
            children: [
                {
                    type: MenuType.Catalog
                },
                {
                    type: MenuType.Attachment
                },
                {
                    type: MenuType.Video
                },
                {
                    type: MenuType.Audio
                },
                {
                    type: MenuType.Mention
                },
                {
                    type: MenuType.Status
                },
                {
                    type: MenuType.Note
                },
                {
                    type: MenuType.Blockquote
                },
                {
                    type: MenuType.Collapse
                },
                {
                    type: MenuType.HorizontalRule
                },
                {
                    type: MenuType.Drawio
                },
                {
                    type: MenuType.Minder
                },
                {
                    type: MenuType.Latex
                },
                {
                    type: MenuType.Html
                },
                {
                    type: MenuType.Time
                },
                {
                    type: MenuType.Markdown
                },
                {
                    type: MenuType.PlantUML
                }
            ]
        }
    ];
};

var css_248z$e = ".ct-menubar-container{font-size:14px;position:relative;background:#fff;z-index:100}.ct-menubar-container .ct-main-menubar-wrapper,.ct-menubar-container .ct-table-menubar-wrapper{display:flex;flex-wrap:wrap}.ct-menubar-container .ct-menubar-divider{width:1px;height:15px;margin:auto 8px;background:#ddd}";
menubar_styleInject(css_248z$e);

function menubar_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var menubar_Menubar$1 = function Menubar$1(menubarDom) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultMenuConfig();
    var _this = this;
    menubar_classCallCheck$7(this, Menubar$1);
    this.enhanceDom = function(dom) {
        dom.setAttribute("class", menubar_classNamePrefix("menubar-container"));
        _this.menuWrapper = dom;
    };
    this.connect = function(editor) {
        _this.editor = editor;
        _this.renderMenubar();
    };
    this.renderMenubar = function() {
        Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(menubar_Menubar, {
            manager: _this.editor.manager,
            config: _this.config,
            ref: _this.onRef
        }), _this.menuWrapper);
    };
    this.onRef = function(ref) {
        if (ref) {
            _this._menubarRef = ref;
        }
    };
    this.update = function() {
        if (_this._menubarRef) {
            _this._menubarRef.update(_this.editor.manager);
        }
    };
    this.editor = null;
    this.menuWrapper = null;
    this.menuComponent = null;
    this._menubarRef = null;
    this.enhanceDom(menubarDom);
    this.config = config;
};

/* harmony default export */ var es_menubar = (menubar_Menubar$1);
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: external "@ss/mtd-vue"
var mtd_vue_ = __webpack_require__("6a79");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/sub-extension/index.js






/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 下标
var regexpSub = /(?:~)([^]+)(?:~)\s$/;
var regexpSubFullwidth = /(?:～)([^]+)(?:～)\s$/;

var sub_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(sub_extension_ExtensionType || (sub_extension_ExtensionType = {}));

var sub_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var sub_extension_isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : sub_extension_typeof(value)) === type;
    };
};
var sub_extension_isFunction = sub_extension_isOfType("function");

var sub_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var sub_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return sub_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var sub_extension_isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!sub_extension_findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var sub_extension_enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = Object(dist_commands["toggleMark"])(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};
/*
 * 删除 mark 类型
 * @param type mark类型
 */ var removeMarkType = function(type) {
    return function(state, dispatch) {
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, _state_selection_ranges = _state_selection.ranges, ranges = _state_selection_ranges === void 0 ? [] : _state_selection_ranges;
        if (empty || $cursor) {
            return;
        }
        var tr = state.tr;
        for(var i = 0; i < ranges.length; i++){
            var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
            if (state.doc.rangeHasMark($from.pos, $to.pos, type)) {
                tr.removeMark($from.pos, $to.pos, type);
            }
        }
        dispatch(tr);
    };
};

/**
 * 通用配置
 */ var sub_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var sub_extension_isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};
var sub_extension_markInputRule = function(param) {
    var regexp = param.regexp, type = param.type, getAttrs = param.getAttrs;
    return new prosemirror_inputrules_dist["a" /* InputRule */](regexp, function(state, match, start, end) {
        // TODO:只对选中区域设置mark，没有将整个node节点设置
        var tr = state.tr;
        // @ts-ignore
        var attrs = sub_extension_isFunction(getAttrs) ? getAttrs(match) : getAttrs;
        var markEnd = end;
        if (match[1]) {
            var startSpaces = match[0].search(/\S/);
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + match[1].length;
        }
        return tr.addMark(start, markEnd, type.create(attrs)).removeStoredMark(type);
    });
};

function sub_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function sub_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function sub_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function sub_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) sub_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) sub_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function sub_extension_getPrototypeOf(o) {
    sub_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return sub_extension_getPrototypeOf(o);
}
function sub_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) sub_extension_setPrototypeOf(subClass, superClass);
}
function sub_extension_possibleConstructorReturn(self, call) {
    if (call && (sub_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return sub_extension_assertThisInitialized(self);
}
function sub_extension_setPrototypeOf(o, p) {
    sub_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return sub_extension_setPrototypeOf(o, p);
}
var sub_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function sub_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function sub_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = sub_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = sub_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = sub_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return sub_extension_possibleConstructorReturn(this, result);
    };
}
var SubExtension = /*#__PURE__*/ function(MarkExtension) {
    sub_extension_inherits(SubExtension, MarkExtension);
    var _super = sub_extension_createSuper(SubExtension);
    function SubExtension() {
        sub_extension_classCallCheck(this, SubExtension);
        return _super.apply(this, arguments);
    }
    var _proto = SubExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type, marks = param.schema.marks, getState = param.getState;
        var sup = marks.sup;
        var removeSup = removeMarkType(sup);
        var toggleSub = sub_extension_enhancedToggleMark(type);
        return {
            toggle: function() {
                return function(state, dispatch, view) {
                    removeSup(state, dispatch);
                    return toggleSub(getState(), dispatch, view);
                };
            },
            isActive: function() {
                return sub_extension_isMarkActive(type);
            },
            isDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return sub_extension_isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            sub_extension_markInputRule({
                regexp: regexpSub,
                type: type
            }),
            sub_extension_markInputRule({
                regexp: regexpSubFullwidth,
                type: type
            })
        ];
    };
    sub_extension_createClass(SubExtension, [
        {
            key: "name",
            get: function get() {
                return "sub";
            }
        }
    ]);
    return SubExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/sup-extension/index.js






/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 上标
var regexpSup = /(?:\^)([^]+)(?:\^)\s$/;

var sup_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(sup_extension_ExtensionType || (sup_extension_ExtensionType = {}));

var sup_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var sup_extension_isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : sup_extension_typeof(value)) === type;
    };
};
var sup_extension_isFunction = sup_extension_isOfType("function");

var sup_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var sup_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return sup_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var sup_extension_isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!sup_extension_findParentNode(predicate)(selection);
    };
};
// 在这里主动触发ProseMirror重绘机制 https://km.sankuai.com/page/759472057
var sup_extension_enhancedToggleMark = function(markType) {
    var isHackFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 ? arguments[2] : void 0;
    var originCmd = Object(dist_commands["toggleMark"])(markType, attrs);
    return function(_, __, view) {
        var res = originCmd(_, __);
        if (isHackFocus) {
            view.focus();
            view.dom.blur();
        }
        return res;
    };
};
/*
 * 删除 mark 类型
 * @param type mark类型
 */ var sup_extension_removeMarkType = function(type) {
    return function(state, dispatch) {
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, _state_selection_ranges = _state_selection.ranges, ranges = _state_selection_ranges === void 0 ? [] : _state_selection_ranges;
        if (empty || $cursor) {
            return;
        }
        var tr = state.tr;
        for(var i = 0; i < ranges.length; i++){
            var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
            if (state.doc.rangeHasMark($from.pos, $to.pos, type)) {
                tr.removeMark($from.pos, $to.pos, type);
            }
        }
        dispatch(tr);
    };
};

/**
 * 通用配置
 */ var sup_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var sup_extension_isMarkActive = function(type) {
    return function(state) {
        var selection = state.selection, doc = state.doc, storedMarks = state.storedMarks;
        var $from = selection.$from, empty = selection.empty;
        if (empty) {
            return !!type.isInSet(storedMarks !== null && storedMarks !== void 0 ? storedMarks : $from.marks());
        }
        return doc.rangeHasMark(selection.from, selection.to, type);
    };
};
var sup_extension_markInputRule = function(param) {
    var regexp = param.regexp, type = param.type, getAttrs = param.getAttrs;
    return new prosemirror_inputrules_dist["a" /* InputRule */](regexp, function(state, match, start, end) {
        // TODO:只对选中区域设置mark，没有将整个node节点设置
        var tr = state.tr;
        // @ts-ignore
        var attrs = sup_extension_isFunction(getAttrs) ? getAttrs(match) : getAttrs;
        var markEnd = end;
        if (match[1]) {
            var startSpaces = match[0].search(/\S/);
            var textStart = start + match[0].indexOf(match[1]);
            var textEnd = textStart + match[1].length;
            if (textEnd < end) {
                tr.delete(textEnd, end);
            }
            if (textStart > start) {
                tr.delete(start + startSpaces, textStart);
            }
            markEnd = start + startSpaces + match[1].length;
        }
        return tr.addMark(start, markEnd, type.create(attrs)).removeStoredMark(type);
    });
};

function sup_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function sup_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function sup_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function sup_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) sup_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) sup_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function sup_extension_getPrototypeOf(o) {
    sup_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return sup_extension_getPrototypeOf(o);
}
function sup_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) sup_extension_setPrototypeOf(subClass, superClass);
}
function sup_extension_possibleConstructorReturn(self, call) {
    if (call && (sup_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return sup_extension_assertThisInitialized(self);
}
function sup_extension_setPrototypeOf(o, p) {
    sup_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return sup_extension_setPrototypeOf(o, p);
}
var sup_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function sup_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function sup_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = sup_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = sup_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = sup_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return sup_extension_possibleConstructorReturn(this, result);
    };
}
var SupExtension = /*#__PURE__*/ function(MarkExtension) {
    sup_extension_inherits(SupExtension, MarkExtension);
    var _super = sup_extension_createSuper(SupExtension);
    function SupExtension() {
        sup_extension_classCallCheck(this, SupExtension);
        return _super.apply(this, arguments);
    }
    var _proto = SupExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type, marks = param.schema.marks, getState = param.getState;
        var sub = marks.sub;
        var removeSub = sup_extension_removeMarkType(sub);
        var toggleSup = sup_extension_enhancedToggleMark(type);
        return {
            toggle: function() {
                return function(state, dispatch, view) {
                    removeSub(state, dispatch);
                    return toggleSup(getState(), dispatch, view);
                };
            },
            isActive: function() {
                return sup_extension_isMarkActive(type);
            },
            isDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return sup_extension_isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            sup_extension_markInputRule({
                regexp: regexpSup,
                type: type
            })
        ];
    };
    sup_extension_createClass(SupExtension, [
        {
            key: "name",
            get: function get() {
                return "sup";
            }
        }
    ]);
    return SupExtension;
}(core["c" /* MarkExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel/kit/cellSelection/index.js




var deviceSystem = function() {
    var isAndroid = window.navigator.userAgent.match(/android/gi);
    var isIPhone = window.navigator.userAgent.match(/iphone/gi);
    var isIOS = /ipad|iphone/i.test(navigator.userAgent);
    return {
        isAndroid: isAndroid,
        isIPhone: isIPhone,
        isIOS: isIOS
    };
};

/* eslint-disable @typescript-eslint/no-use-before-define */ // Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
function cellSelection_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var readFromCache;
var addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== "undefined") {
    var cache = new WeakMap();
    readFromCache = function(key) {
        return cache.get(key);
    };
    addToCache = function(key, value) {
        cache.set(key, value);
        return value;
    };
} else {
    var cache1 = [];
    var cacheSize = 10;
    var cachePos = 0;
    readFromCache = function(key) {
        for(var i = 0; i < cache1.length; i += 2){
            if (cache1[i] === key) return cache1[i + 1];
        }
    };
    addToCache = function(key, value) {
        if (cachePos === cacheSize) cachePos = 0;
        cache1[cachePos++] = key;
        cache1[cachePos++] = value;
        return value;
    };
}
var Rect = function Rect(left, top, right, bottom) {
    cellSelection_classCallCheck(this, Rect);
    this.left = left;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
};
// ::- A table map describes the structore of a given table. To avoid
// recomputing them all the time, they are cached per table node. To
// be able to do that, positions saved in the map are relative to the
// start of the table, rather than the start of the document.
var TableMap = /*#__PURE__*/ function() {
    function TableMap(width, height, map, problems, colWidths) {
        cellSelection_classCallCheck(this, TableMap);
        // :: number The width of the table
        this.width = width;
        // :: number The table's height
        this.height = height;
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
        // 表格每列的宽度
        this.colWidths = colWidths;
    }
    var _proto = TableMap.prototype;
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    _proto.findCell = function findCell(pos) {
        for(var i = 0; i < this.map.length; i++){
            var curPos = this.map[i];
            if (curPos !== pos) continue;
            var left = i % this.width;
            var top = i / this.width | 0;
            var right = left + 1;
            var bottom = top + 1;
            for(var j = 1; right < this.width && this.map[i + j] === curPos; j++){
                right++;
            }
            for(var j1 = 1; bottom < this.height && this.map[i + this.width * j1] === curPos; j1++){
                bottom++;
            }
            return new Rect(left, top, right, bottom);
        }
        throw new RangeError("No cell with offset ".concat(pos, " found"));
    };
    // :: (number) → number
    // Find the left side of the cell at the given position.
    _proto.colCount = function colCount(pos) {
        for(var i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError("No cell with offset ".concat(pos, " found"));
    };
    _proto.rowCount = function rowCount(pos) {
        for(var i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError("No cell with offset ".concat(pos, " found"));
    };
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    _proto.nextCell = function nextCell(pos, axis, dir) {
        var _this_findCell = this.findCell(pos), left = _this_findCell.left, right = _this_findCell.right, top = _this_findCell.top, bottom = _this_findCell.bottom;
        if (axis === "horiz") {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        }
        if (dir < 0 ? top === 0 : bottom === this.height) return null;
        return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
    };
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    _proto.rectBetween = function rectBetween(posA, posB) {
        var _this_findCell = this.findCell(posA), leftA = _this_findCell.left, rightA = _this_findCell.right, topA = _this_findCell.top, bottomA = _this_findCell.bottom;
        var _this_findCell1 = this.findCell(posB), leftB = _this_findCell1.left, rightB = _this_findCell1.right, topB = _this_findCell1.top, bottomB = _this_findCell1.bottom;
        var l = Math.min(leftA, leftB);
        var t = Math.min(topA, topB);
        var r = Math.max(rightA, rightB);
        var b = Math.max(bottomA, bottomB);
        var rect = new Rect(l, t, r, b);
        // 不断遍历更新边界，直到 Rect 是一个规则的矩形
        while(true){
            for(var i = l; i < r; i++){
                var top = this.findCell(this.map[this.width * t + i]).top;
                t = Math.min(top, t);
                var bottom = this.findCell(this.map[this.width * (b - 1) + i]).bottom;
                b = Math.max(bottom, b);
            }
            for(var i1 = t; i1 < b; i1++){
                var left = this.findCell(this.map[this.width * i1 + l]).left;
                l = Math.min(left, l);
                var right = this.findCell(this.map[this.width * i1 + r - 1]).right;
                r = Math.max(right, r);
            }
            if (l === rect.left && t === rect.top && r === rect.right && b === rect.bottom) {
                break;
            }
            rect = new Rect(l, t, r, b);
        }
        return rect;
    };
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    _proto.cellsInRect = function cellsInRect(rect) {
        var result = [];
        var seen = {};
        for(var row = rect.top; row < rect.bottom; row++){
            for(var col = rect.left; col < rect.right; col++){
                var index = row * this.width + col;
                var pos = this.map[index];
                if (seen[pos]) continue;
                seen[pos] = true;
                if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) {
                    result.push(pos);
                }
            }
        }
        return result;
    };
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    _proto.positionAt = function positionAt(row, col, table) {
        for(var i = 0, rowStart = 0;; i++){
            var rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                var index = col + row * this.width;
                var rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    };
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    TableMap.get = function get(table) {
        return readFromCache(table) || addToCache(table, computeMap(table));
    };
    return TableMap;
}();
/**
 * 是否需要修正th
 */ function cellSelection_needFixRowHeader(rowNode, table) {
    var rowNodeChildArr = rowNode.content.content;
    // 如果是空，或者首行只有一个元素，不修
    if (rowNodeChildArr.length <= 1) return false;
    var table_header = table.type.schema.nodes.table_header;
    var tableHeaderTotalCount = rowNodeChildArr.reduce(function(acc, node) {
        return node.type === table_header ? acc + 1 : acc;
    }, 0);
    // 首行有th，且数量小于首行元素总数，大于1（即至少有两个，表头列可能会有一个）
    return tableHeaderTotalCount > 1 && tableHeaderTotalCount < rowNodeChildArr.length;
}
// Compute a table map.
function computeMap(table) {
    if (table.type.spec.tableRole !== "table") {
        throw new RangeError("Not a table node: ".concat(table.type.name));
    }
    var width = findWidth(table);
    var height = table.childCount;
    var map = [];
    var mapPos = 0;
    var problems = null;
    var colWidths = [];
    for(var i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(var row = 0, pos = 0; row < height; row++){
        var rowNode = table.child(row);
        if (row === 0) {
            /**
       * fix: #66078869, #67565651 表头行单元格非法，应该是th，实际是td
       * @see https://km.sankuai.com/collabpage/1347228195
       */ if (cellSelection_needFixRowHeader(rowNode, table)) {
                (problems || (problems = [])).push({
                    type: "invalid_cell_for_row_header_table"
                });
            }
        }
        pos++;
        for(var i1 = 0;; i1++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i1 === rowNode.childCount) break;
            var cellNode = rowNode.child(i1);
            var _cellNode_attrs = cellNode.attrs, colspan = _cellNode_attrs.colspan, rowspan = _cellNode_attrs.rowspan, colwidth = _cellNode_attrs.colwidth;
            for(var h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                var start = mapPos + h * width;
                for(var w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else {
                        (problems || (problems = [])).push({
                            type: "collision",
                            row: row,
                            pos: pos,
                            n: colspan - w
                        });
                    }
                    var colW = colwidth && colwidth[w];
                    if (colW) {
                        var widthIndex = (start + w) % width * 2;
                        var prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) {
                            colWidths[widthIndex + 1]++;
                        }
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        var expectedPos = (row + 1) * width;
        var missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) {
            (problems || (problems = [])).push({
                type: "missing",
                row: row,
                n: missing
            });
        }
        pos++;
    }
    var tableMap = new TableMap(width, height, map, problems, colWidths.filter(function(x, i) {
        return i % 2 === 0;
    }));
    var badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(var i2 = 0; !badWidths && i2 < colWidths.length; i2 += 2){
        if (colWidths[i2] != null && colWidths[i2 + 1] < height) badWidths = true;
    }
    if (badWidths) findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function findWidth(table) {
    var width = -1;
    var hasRowSpan = false;
    for(var row = 0; row < table.childCount; row++){
        var rowNode = table.child(row);
        var rowWidth = 0;
        if (hasRowSpan) {
            for(var j = 0; j < row; j++){
                var prevRow = table.child(j);
                for(var i = 0; i < prevRow.childCount; i++){
                    var cell = prevRow.child(i);
                    if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
                }
            }
        }
        for(var i1 = 0; i1 < rowNode.childCount; i1++){
            var cell1 = rowNode.child(i1);
            rowWidth += cell1.attrs.colspan;
            if (cell1.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    for(var i = 0, seen = {}; i < map.map.length; i++){
        var pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        var node = table.nodeAt(pos);
        var updated = null;
        for(var j = 0; j < node.attrs.colspan; j++){
            var col = (i + j) % map.width;
            var colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) {
                (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth;
            }
        }
        if (updated) {
            map.problems.unshift({
                type: "colwidth mismatch",
                pos: pos,
                colwidth: updated
            });
        }
    }
}
function freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    var result = [];
    for(var i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

// Various helper function for working with tables
var cellSelection_key = new prosemirror_state_dist["PluginKey"]("selectingCells");
function cellAround($pos) {
    for(var d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === "row") {
            return $pos.node(0).resolve($pos.before(d + 1));
        }
    }
    return null;
}
function cellWrapping($pos) {
    for(var d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        var role = $pos.node(d).type.spec.tableRole;
        if (role === "cell" || role === "header_cell") return $pos.node(d);
    }
    return null;
}
function isInTable(state) {
    var $head = state.selection.$head;
    for(var d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === "row") return true;
    }
    return false;
}
function cellNear($pos) {
    for(var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++){
        var role = after.type.spec.tableRole;
        if (role === "cell" || role === "header_cell") return $pos.doc.resolve(pos);
    }
    for(var before = $pos.nodeBefore, pos1 = $pos.pos; before; before = before.lastChild, pos1--){
        var role1 = before.type.spec.tableRole;
        if (role1 === "cell" || role1 === "header_cell") {
            return $pos.doc.resolve(pos1 - before.nodeSize);
        }
    }
}
function selectionCell(state) {
    var sel = state.selection;
    if (sel.$anchorCell) {
        return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
    }
    if (sel.node && sel.node.type.spec.tableRole === "cell") {
        return sel.$anchor;
    }
    return cellAround(sel.$head) || cellNear(sel.$head);
}
function pointsAtCell($pos) {
    return $pos.parent.type.spec.tableRole === "row" && $pos.nodeAfter;
}
function moveCellForward($pos) {
    return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
}
function inSameTable($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}
function findCell($pos) {
    return TableMap.get($pos.node(-1)).findCell($pos.pos - $pos.start(-1));
}
function cellSelection_colCount($pos) {
    return TableMap.get($pos.node(-1)).colCount($pos.pos - $pos.start(-1));
}
function nextCell($pos, axis, dir) {
    var start = $pos.start(-1);
    var map = TableMap.get($pos.node(-1));
    var moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}
function setAttr(attrs, name, value) {
    var result = {};
    for(var prop in attrs)result[prop] = attrs[prop];
    result[name] = value;
    return result;
}
function removeColSpan(attrs, pos) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var result = setAttr(attrs, "colspan", attrs.colspan - n);
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some(function(w) {
            return w > 0;
        })) result.colwidth = null;
    }
    return result;
}
function addColSpan(attrs, pos, widths) {
    // widths 表示新增列的宽度，widths.length 表示新增几列
    var n = widths.length;
    var result = setAttr(attrs, "colspan", attrs.colspan + n);
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(var i = 0; i < n; i++)result.colwidth.splice(pos, 0, widths[i]);
    }
    return result;
}

/* eslint-disable @typescript-eslint/no-use-before-define */ // This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).
function cellSelection_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function cellSelection_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) cellSelection_setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function cellSelection_getPrototypeOf(o) {
    cellSelection_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return cellSelection_getPrototypeOf(o);
}
function cellSelection_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) cellSelection_setPrototypeOf(subClass, superClass);
}
function cellSelection_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function cellSelection_possibleConstructorReturn(self, call) {
    if (call && (cellSelection_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return cellSelection_assertThisInitialized(self);
}
function cellSelection_setPrototypeOf(o, p) {
    cellSelection_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return cellSelection_setPrototypeOf(o, p);
}
var cellSelection_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, cellSelection_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return cellSelection_setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function cellSelection_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function cellSelection_createSuper(Derived) {
    var hasNativeReflectConstruct = cellSelection_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = cellSelection_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = cellSelection_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return cellSelection_possibleConstructorReturn(this, result);
    };
}
// ::- A [`Selection`](http://prosemirror.net/docs/ref/#state.Selection)
// subclass that represents a cell selection spanning part of a table.
// With the plugin enabled, these will be created when the user
// selects across cells, and will be drawn by giving selected cells a
// `selectedCell` CSS class.
var cellSelection_CellSelection = /*#__PURE__*/ function(Selection1) {
    cellSelection_inherits(CellSelection, Selection1);
    var _super = cellSelection_createSuper(CellSelection);
    function CellSelection($anchorCell) {
        var $headCell = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $anchorCell;
        cellSelection_classCallCheck$1(this, CellSelection);
        var _this;
        var table = $anchorCell.node(-1);
        var map = TableMap.get(table);
        var start = $anchorCell.start(-1);
        var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
        var doc = $anchorCell.node(0);
        var cells = map.cellsInRect(rect).filter(function(p) {
            return p !== $headCell.pos - start;
        });
        // Make the head cell the first range, so that it counts as the
        // primary part of the selection
        cells.unshift($headCell.pos - start);
        var ranges = cells.map(function(pos) {
            var cell = table.nodeAt(pos);
            var from = pos + start + 1;
            return new prosemirror_state_dist["SelectionRange"](doc.resolve(from), doc.resolve(from + cell.content.size));
        });
        var $selectionTo = ranges[0].$to;
        if (deviceSystem().isIOS) {
            $selectionTo = ranges[0].$from;
        }
        _this = _super.call(this, ranges[0].$from, $selectionTo, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        _this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        _this.$headCell = $headCell;
        return _this;
    }
    var _proto = CellSelection.prototype;
    _proto.map = function map(doc, mapping) {
        var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
            var tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) {
                return CellSelection.rowSelection($anchorCell, $headCell);
            }
            if (tableChanged && this.isColSelection()) {
                return CellSelection.colSelection($anchorCell, $headCell);
            }
            return new CellSelection($anchorCell, $headCell);
        }
        return prosemirror_state_dist["TextSelection"].between($anchorCell, $headCell);
    };
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    _proto.content = function content() {
        var table = this.$anchorCell.node(-1);
        var map = TableMap.get(table);
        var start = this.$anchorCell.start(-1);
        var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        var seen = {};
        var rows = [];
        for(var row = rect.top; row < rect.bottom; row++){
            var rowContent = [];
            for(var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                var pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    var cellRect = map.findCell(pos);
                    var cell = table.nodeAt(pos);
                    var extraLeft = rect.left - cellRect.left;
                    var extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        var attrs = cell.attrs;
                        if (extraLeft > 0) attrs = removeColSpan(attrs, 0, extraLeft);
                        if (extraRight > 0) {
                            attrs = removeColSpan(attrs, attrs.colspan - extraRight, extraRight);
                        }
                        if (cellRect.left < rect.left) {
                            cell = cell.type.createAndFill(attrs);
                        } else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        var attrs1 = setAttr(cell.attrs, "rowspan", Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs1);
                        else cell = cell.type.create(attrs1, cell.content);
                    }
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy(dist["Fragment"].from(rowContent)));
        }
        var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new dist["Slice"](dist["Fragment"].from(fragment), 1, 1);
    };
    _proto.replace = function replace(tr) {
        var content = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : dist["Slice"].empty;
        var mapFrom = tr.steps.length;
        var ranges = this.ranges;
        for(var i = 0; i < ranges.length; i++){
            var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
            var mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? dist["Slice"].empty : content);
        }
        var sel = prosemirror_state_dist["Selection"].findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    };
    _proto.replaceWith = function replaceWith(tr, node) {
        this.replace(tr, new dist["Slice"](dist["Fragment"].from(node), 0, 0));
    };
    _proto.forEachCell = function forEachCell(f) {
        var table = this.$anchorCell.node(-1);
        var map = TableMap.get(table);
        var start = this.$anchorCell.start(-1);
        var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(var i = 0; i < cells.length; i++){
            f(table.nodeAt(cells[i]), start + cells[i]);
        }
    };
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    _proto.isColSelection = function isColSelection() {
        var anchorTop = this.$anchorCell.index(-1);
        var headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        var headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    };
    // 是否选中整个表格
    _proto.isWholeSelection = function isWholeSelection() {
        var map = TableMap.get(this.$anchorCell.node(-1));
        var rect = this.getRect();
        if (rect.top === 0 && rect.bottom === map.height && rect.left === 0 && rect.right === map.width) {
            return true;
        }
        return false;
    };
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    _proto.isRowSelection = function isRowSelection() {
        var map = TableMap.get(this.$anchorCell.node(-1));
        var start = this.$anchorCell.start(-1);
        var anchorLeft = map.colCount(this.$anchorCell.pos - start);
        var headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        var headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    };
    _proto.eq = function eq(other) {
        return cellSelection_instanceof(other, CellSelection) && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    };
    // 获取CellSelection的上下左右范围
    _proto.getRect = function getRect() {
        var table = this.$anchorCell.node(-1);
        var map = TableMap.get(table);
        var start = this.$anchorCell.start(-1);
        var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        return rect;
    };
    _proto.toJSON = function toJSON() {
        return {
            type: "cell",
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    };
    _proto.getBookmark = function getBookmark() {
        return new cellSelection_CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
    };
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    CellSelection.colSelection = function colSelection($anchorCell) {
        var $headCell = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $anchorCell;
        var map = TableMap.get($anchorCell.node(-1));
        var start = $anchorCell.start(-1);
        var anchorRect = map.findCell($anchorCell.pos - start);
        var headRect = map.findCell($headCell.pos - start);
        var doc = $anchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) {
                $anchorCell = doc.resolve(start + map.map[anchorRect.left]);
            }
            if (headRect.bottom < map.height) {
                $headCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
            }
        } else {
            if (headRect.top > 0) {
                $headCell = doc.resolve(start + map.map[headRect.left]);
            }
            if (anchorRect.bottom < map.height) {
                $anchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
            }
        }
        return new CellSelection($anchorCell, $headCell);
    };
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    CellSelection.rowSelection = function rowSelection($anchorCell) {
        var $headCell = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $anchorCell;
        var map = TableMap.get($anchorCell.node(-1));
        var start = $anchorCell.start(-1);
        var anchorRect = map.findCell($anchorCell.pos - start);
        var headRect = map.findCell($headCell.pos - start);
        var doc = $anchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) {
                $anchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            }
            if (headRect.right < map.width) {
                $headCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
            }
        } else {
            if (headRect.left > 0) {
                $headCell = doc.resolve(start + map.map[headRect.top * map.width]);
            }
            if (anchorRect.right < map.width) {
                $anchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
            }
        }
        return new CellSelection($anchorCell, $headCell);
    };
    CellSelection.fromJSON = function fromJSON(doc, json) {
        return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
    };
    // :: (Node, number, ?number) → CellSelection
    CellSelection.create = function create(doc, anchorCell) {
        var headCell = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : anchorCell;
        return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
    };
    return CellSelection;
}(_wrapNativeSuper(prosemirror_state_dist["Selection"]));
cellSelection_CellSelection.prototype.visible = false;
(function() {
    var id = "parker_cell";
    if (window["__".concat(id, "__")]) {
        return;
    }
    window["__".concat(id, "__")] = true;
    prosemirror_state_dist["Selection"].jsonID(id, cellSelection_CellSelection);
})();
var cellSelection_CellBookmark = /*#__PURE__*/ function() {
    function CellBookmark(anchor, head) {
        cellSelection_classCallCheck$1(this, CellBookmark);
        this.anchor = anchor;
        this.head = head;
    }
    var _proto = CellBookmark.prototype;
    _proto.map = function map(mapping) {
        return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
    };
    _proto.resolve = function resolve(doc) {
        var $anchorCell = doc.resolve(this.anchor);
        var $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === "row" && $headCell.parent.type.spec.tableRole === "row" && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell)) {
            return new cellSelection_CellSelection($anchorCell, $headCell);
        }
        return prosemirror_state_dist["Selection"].near($headCell, 1);
    };
    return CellBookmark;
}();
function drawCellSelection(state) {
    if (!cellSelection_instanceof(state.selection, cellSelection_CellSelection)) return null;
    var cells = [];
    var sel = state.selection;
    var $pos = selectionCell(state);
    var table = $pos.node(-1);
    var tableStart = $pos.start(-1);
    var map = TableMap.get(table);
    var totalRect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    state.selection.forEachCell(function(node, pos) {
        var className = "selectedCell";
        var rect = map.findCell(pos - tableStart);
        if (rect.left === totalRect.left) className += " left";
        if (rect.right === totalRect.right) className += " right";
        if (rect.top === totalRect.top) className += " top";
        if (rect.bottom === totalRect.bottom) className += " bottom";
        cells.push(index_es["a" /* Decoration */].node(pos, pos + node.nodeSize, {
            class: className
        }));
    });
    return index_es["b" /* DecorationSet */].create(state.doc, cells);
}
function isCellBoundarySelection(param) {
    var $from = param.$from, $to = param.$to;
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false; // Cheap elimination
    var afterFrom = $from.pos;
    var beforeTo = $to.pos;
    var depth = $from.depth;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(var d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    return afterFrom === beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function normalizeSelection(state, tr, oldState, allowTableNodeSelection) {
    var sel = (tr || state).selection;
    var oldSel = oldState.selection;
    var doc = (tr || state).doc;
    var normalize;
    var role;
    if (cellSelection_instanceof(sel, prosemirror_state_dist["NodeSelection"]) && sel.node.type.spec.tableRole) {
        role = sel.node.type.spec.tableRole;
        if (role === "cell" || role === "header_cell") {
            normalize = cellSelection_CellSelection.create(doc, sel.from);
        } else if (role === "row") {
            var $cell = doc.resolve(sel.from + 1);
            normalize = cellSelection_CellSelection.rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            var map = TableMap.get(sel.node);
            var start = sel.from + 1;
            var lastCell = start + map.map[map.width * map.height - 1];
            normalize = cellSelection_CellSelection.create(doc, start + 1, lastCell);
        }
    } else if (cellSelection_instanceof(sel, prosemirror_state_dist["TextSelection"]) && isCellBoundarySelection(sel)) {
        normalize = prosemirror_state_dist["TextSelection"].create(doc, sel.from);
    } else if (cellSelection_instanceof(sel, prosemirror_state_dist["TextSelection"]) && cellSelection_instanceof(oldSel, cellSelection_CellSelection) && sel.from >= oldSel.from && sel.to <= oldSel.to && sel.from !== sel.to) {
        normalize = oldSel;
    }
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/table-extension/index.js
















/**
 * 统一样式前缀
 */ var table_extension_CLASSNAME_PREFIX = "ct";

function getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && isParagraph(content[size - 1]) && isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var table_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : table_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
// 获取浏览器和系统信息
function table_extension_getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

// 向上寻找指定DOM节点
var findParentDOM = function(targetDOM, assert) {
    var dom = targetDOM;
    while(true){
        if (!dom || dom.classList && dom.classList.contains("ProseMirror")) {
            return false;
        }
        if (assert(dom)) return dom;
        dom = dom.parentNode;
    }
};
var table_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var table_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return table_extension_findParentNodeClosestToPos($from, predicate);
    };
};
/**
 * 是否为表格内的位置
 * @param $pos ResolvedPos
 * @returns boolean
 */ var table_extension_isInTablePos = function($pos) {
    for(var d = $pos.depth; d > 0; d--){
        // 有 tableRole 属性的就是表格的 schema
        if ($pos.node(d).type.spec.tableRole) return true;
    }
    return false;
};
/**
 * 获取在表格中的真正可插入的节点的位置
 * @param $pos ResolvedPos
 * @returns number
 */ var table_extension_getInsertPosInTable = function($pos) {
    // 不是表格内的 pos 不处理
    if (!table_extension_isInTablePos($pos)) return null;
    var selectionRight = prosemirror_state_dist["Selection"].near($pos, 1);
    var selectionLeft = prosemirror_state_dist["Selection"].near($pos, -1);
    // 左右可用选区都没有
    if (!selectionRight && !selectionLeft) return null;
    var insertPos = $pos.pos;
    // 只有一边有选区, 那么就用一边的选区的位置
    if (selectionRight && !selectionLeft) {
        insertPos = selectionRight.from;
    } else if (!selectionRight && selectionLeft) {
        insertPos = selectionLeft.from;
    } else {
        // 选取左右最近的能插入的位置, 右侧优先
        insertPos = $pos.pos - selectionLeft.from < selectionRight.from - $pos.pos ? selectionLeft.from : selectionRight.from;
    }
    return insertPos;
};

// from prosemirror-tables v1.1.1
var table_extension_deleteTable = function() {
    return function(state, dispatch) {
        var $pos = state.selection.$anchor;
        for(var d = $pos.depth; d > 0; d--){
            var node = $pos.node(d);
            if (node.type.spec.tableRole === "table") {
                dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView());
                return true;
            }
        }
        return false;
    };
};
var findTable = function(selection) {
    return table_extension_findParentNode(function(node) {
        return node.type.spec.tableRole && node.type.spec.tableRole === "table";
    })(selection);
};
var findTableCell = function(selection) {
    return table_extension_findParentNode(function(node) {
        return node.type.spec.tableRole && [
            "table_cell",
            "table_header"
        ].includes(node.type.name);
    })(selection);
};

var table_extension_DEFAULT_COL_WIDTH = 68;
var table_extension_MIN_COL_WIDTH = 50;
// dpi=1.25时，表格宽度需要为 4 的整数倍
var table_extension_formatWidth = function(width) {
    // width = Math.round(width);
    // width = Math.round(width / 4) * 4;
    return width;
};

function table_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
// Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for
// convenience.
function selectedRect(state) {
    var sel = state.selection;
    var $pos = selectionCell(state);
    var table = $pos.node(-1);
    var tableStart = $pos.start(-1);
    var map = TableMap.get(table);
    var rect;
    if (table_extension_instanceof(sel, cellSelection_CellSelection)) {
        rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    } else {
        rect = map.findCell($pos.pos - tableStart);
    }
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}
// 是否有表头行
function hasRowHeader(table) {
    var table_header = table.type.schema.nodes.table_header;
    var firstRow = table.firstChild;
    return firstRow.content.content.every(function(p) {
        return p.type === table_header;
    });
}
// 是否有表头列
function hasColHeader(table) {
    var table_header = table.type.schema.nodes.table_header;
    var rows = table.content.content;
    var rowspan = 0;
    if (!rows[0].firstChild) return false;
    if (hasRowHeader(table)) {
        if (rows[0].firstChild.attrs.rowspan === rows.length) return false;
        rowspan = rows[0].firstChild.attrs.rowspan - 1;
        rows = rows.slice(1);
    }
    if (rows.length === 0) return false;
    return rows.every(function(row) {
        if (rowspan > 0) {
            rowspan--;
            return true;
        }
        rowspan = row.firstChild.attrs.rowspan - 1;
        return row.firstChild.type === table_header;
    });
}
// 是否有行号列
function hasNumCol(table) {
    var rows = table.content.content;
    var rowspan = 0;
    if (!rows[0].firstChild) return false;
    if (hasRowHeader(table)) {
        if (rows[0].firstChild.attrs.rowspan === rows.length) return false;
        rowspan = rows[0].firstChild.attrs.rowspan - 1;
        rows = rows.slice(1);
    }
    if (rows.length === 0) return false;
    return rows.every(function(row) {
        if (rowspan > 0) {
            rowspan--;
            return true;
        }
        rowspan = row.firstChild.attrs.rowspan - 1;
        return row.firstChild.attrs.numCell;
    });
}
// 是否是 parent 的下一层子节点，排除掉嵌套表格情况
var isClosestChildren = function(parent, targetNode) {
    var isChildren = false;
    parent.forEach(function(node) {
        if (node === targetNode) {
            isChildren = true;
        }
    });
    return isChildren;
};

function table_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var addColumn = function(tr, param, col) {
    var map = param.map, tableStart = param.tableStart, table = param.table, extraAttrs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _table_type_schema_nodes = table.type.schema.nodes, table_header = _table_type_schema_nodes.table_header, table_cell = _table_type_schema_nodes.table_cell, paragraph = _table_type_schema_nodes.paragraph;
    var tableHasRowHeader = hasRowHeader(table);
    var colWidth = table.attrs.responsive ? table_extension_MIN_COL_WIDTH : table_extension_DEFAULT_COL_WIDTH;
    for(var row = 0; row < map.height; row++){
        var index = row * map.width + col;
        // 当前单元格所占列数 > 1
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            var pos = map.map[index];
            var cell = table.nodeAt(pos);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null, addColSpan(cell.attrs, col - map.colCount(pos), [
                colWidth
            ]) // 增加该单元格的 colspan 和 colwidth
            );
            // 如果该单元格占 x 行，则接下来的 x-1 行不做处理
            row += cell.attrs.rowspan - 1;
        } else {
            var type = row === 0 && tableHasRowHeader ? table_header : table_cell;
            var pos1 = map.positionAt(row, col, table);
            tr.insert(tr.mapping.map(tableStart + pos1), type.createAndFill(table_extension_objectSpread({
                colwidth: [
                    colWidth
                ]
            }, extraAttrs), paragraph.create()));
        }
    }
    return tr;
};
var canAddColumnBefore = function(state) {
    if (!isInTable(state)) return false;
    var rect = selectedRect(state);
    if (rect.left === 0 && (hasColHeader(rect.table) || hasNumCol(rect.table))) {
        return false;
    }
    return true;
};
var addColumnBefore = function() {
    return function(state, dispatch) {
        if (!canAddColumnBefore(state)) return false;
        var rect = selectedRect(state);
        var extraAttrs = {};
        if (!rect.table.attrs.responsive) {
            var colwidth = rect.map.colWidths[rect.left];
            extraAttrs = {
                colwidth: [
                    colwidth
                ]
            };
        }
        var tr = addColumn(state.tr, rect, rect.left, extraAttrs);
        var curCellNode = findTableCell(tr.selection);
        var newPos = curCellNode.pos - 2; // -2是因为</p></cell>
        if (newPos >= 0) tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
        dispatch(tr);
        return true;
    };
};
var addColumnAfter = function() {
    return function(state, dispatch) {
        if (!isInTable(state)) return false;
        var rect = selectedRect(state);
        var extraAttrs = {};
        if (!rect.table.attrs.responsive) {
            var colwidth = rect.map.colWidths[rect.right - 1];
            extraAttrs = {
                colwidth: [
                    colwidth
                ]
            };
        }
        var tr = addColumn(state.tr, rect, rect.right, extraAttrs);
        var curCellNode = findTableCell(tr.selection);
        var newPos = curCellNode.pos + curCellNode.node.nodeSize + 2; // +2 是因为<cell><p>
        if (newPos >= 0) tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
        dispatch(tr);
        return true;
    };
};

var addRow = function(tr, param, row) {
    var map = param.map, tableStart = param.tableStart, table = param.table;
    var _table_type_schema_nodes = table.type.schema.nodes, table_row = _table_type_schema_nodes.table_row, table_header = _table_type_schema_nodes.table_header, table_cell = _table_type_schema_nodes.table_cell, paragraph = _table_type_schema_nodes.paragraph;
    var tableHasColHeader = hasColHeader(table);
    var tableHasNumCol = hasNumCol(table);
    var rowPos = tableStart;
    for(var i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    var cells = [];
    for(var col = 0, index = map.width * row; col < map.width; col++, index++){
        // 当前单元格所占行数 > 1
        if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
            var pos = map.map[index];
            var attrs = table.nodeAt(pos).attrs;
            tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, "rowspan", attrs.rowspan + 1));
            // 如果该单元格占 x 列，则接下来的 x-1 列不做处理
            col += attrs.colspan - 1;
            index += attrs.colspan - 1;
        } else {
            var colwidth = [
                map.colWidths[col]
            ];
            var type = col === 0 && tableHasColHeader ? table_header : table_cell;
            var numCell = col === 0 && tableHasNumCol;
            cells.push(type.createAndFill({
                numCell: numCell,
                colwidth: colwidth
            }, paragraph.create()));
        }
    }
    tr.insert(rowPos, table_row.create(null, cells));
    return tr;
};
var canAddRowBefore = function(state) {
    if (!isInTable(state)) return false;
    var rect = selectedRect(state);
    if (rect.top === 0 && hasRowHeader(rect.table)) {
        return false;
    }
    return true;
};
var addRowBefore = function() {
    return function(state, dispatch) {
        if (!canAddRowBefore(state)) return false;
        var rect = selectedRect(state);
        var tr = addRow(state.tr, rect, rect.top);
        var _selectedRect = selectedRect(tr), map = _selectedRect.map, tableStart = _selectedRect.tableStart;
        var newPos = map.map[rect.top * map.width + rect.left] + tableStart + 2; // +2 是因为<cell><p>
        if (hasNumCol(rect.table) && rect.left === 0 && map.width > 1) {
            newPos = map.map[rect.top * map.width + rect.left + 1] + tableStart + 2; // +2 是因为<cell><p>
        }
        if (newPos >= 0) tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
        dispatch(tr);
        return true;
    };
};
var addRowAfter = function() {
    return function(state, dispatch) {
        if (!isInTable(state)) return false;
        var rect = selectedRect(state);
        var tr = addRow(state.tr, rect, rect.bottom);
        var _selectedRect = selectedRect(tr), map = _selectedRect.map, tableStart = _selectedRect.tableStart;
        var newPos = map.map[rect.bottom * map.width + rect.left] + tableStart + 2; // +2 是因为<cell><p>
        if (hasNumCol(rect.table) && rect.left === 0 && map.width > 1) {
            newPos = map.map[rect.bottom * map.width + rect.left + 1] + tableStart + 2; // +2 是因为<cell><p>
        }
        if (newPos >= 0) tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
        dispatch(tr);
        return true;
    };
};

var removeRow = function(tr, param, row) {
    var map = param.map, table = param.table, tableStart = param.tableStart;
    var rowPos = 0;
    for(var i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    var nextRow = rowPos + table.child(row).nodeSize;
    var mapFrom = tr.mapping.maps.length;
    tr.delete(rowPos + tableStart, nextRow + tableStart);
    for(var col = 0, index = row * map.width; col < map.width; col++, index++){
        var pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            var attrs = table.nodeAt(pos).attrs;
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, "rowspan", attrs.rowspan - 1));
            col += attrs.colspan - 1;
            index += attrs.colspan - 1;
        } else if (row < map.height && pos === map.map[index + map.width]) {
            // Else, if it continues in the row below, it has to be moved down
            var cell = table.nodeAt(pos);
            var copy = cell.type.create(setAttr(cell.attrs, "rowspan", cell.attrs.rowspan - 1), cell.content);
            var newPos = map.positionAt(row + 1, col, table);
            tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
            col += cell.attrs.colspan - 1;
            index += cell.attrs.colspan - 1;
        }
    }
};
var deleteRow = function() {
    return function(state, dispatch, view) {
        if (!isInTable(state)) return false;
        var tr = state.tr;
        var rect = selectedRect(state);
        // 当前选区包含表格内的所有行时，删除整个表格
        if (rect.top === 0 && rect.bottom === rect.map.height) {
            return table_extension_deleteTable()(state, dispatch, view);
        }
        var newPos = 0;
        var _rect_map = rect.map, tableMap = _rect_map.map;
        // 如果删除最后一行，光标位于上一行的该列
        if (rect.bottom === rect.map.height) {
            newPos = tableMap[rect.left + (rect.top - 1) * rect.map.width] + rect.tableStart;
        } else {
            // 否则，光标位于下一行的该列
            newPos = tableMap[rect.left + rect.bottom * rect.map.width] + rect.tableStart;
        }
        // 从下往上依次删除行
        for(var i = rect.bottom - 1;; i--){
            removeRow(tr, rect, i);
            if (i === rect.top) break;
            rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
            rect.map = TableMap.get(rect.table);
        }
        // fix: ONES #65006958
        // 分析文档： https://km.sankuai.com/collabpage/1294314574
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, tr.mapping.map(newPos + 2))); // +2 是因为<cell><p>
        dispatch(tr.scrollIntoView());
        return true;
    };
};

function table_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return table_extension_arrayLikeToArray(arr);
}
function table_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function table_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_toConsumableArray(arr) {
    return table_extension_arrayWithoutHoles(arr) || table_extension_iterableToArray(arr) || table_extension_unsupportedIterableToArray(arr) || table_extension_nonIterableSpread();
}
function table_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray(o, minLen);
}
var removeColumn = function(tr, param, col) {
    var map = param.map, table = param.table, tableStart = param.tableStart;
    var mapStart = tr.mapping.maps.length;
    for(var row = 0; row < map.height;){
        var index = row * map.width + col;
        var pos = map.map[index];
        var cell = table.nodeAt(pos);
        // If this is part of a col-spanning cell
        if (col > 0 && map.map[index - 1] === pos || col < map.width - 1 && map.map[index + 1] === pos) {
            tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, removeColSpan(cell.attrs, col - map.colCount(pos)));
        } else {
            var start = tr.mapping.slice(mapStart).map(tableStart + pos);
            tr.delete(start, start + cell.nodeSize);
        }
        row += cell.attrs.rowspan;
    }
};
var deleteColumn = function() {
    return function(state, dispatch, view) {
        if (!isInTable(state)) return false;
        var rect = selectedRect(state);
        var right = rect.right, width = rect.map.width;
        var tr = state.tr;
        // 当前选区包含表格内的所有列时，删除整个表格
        if (rect.left === 0 && rect.right === rect.map.width) {
            return table_extension_deleteTable()(state, dispatch, view);
        }
        for(var i = rect.right - 1;; i--){
            removeColumn(tr, rect, i);
            rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
            rect.map = TableMap.get(rect.table);
            if (i === rect.left) break;
        }
        // 特定形状的表格，做【选择行、删除列】的操作时可能出现删出空row(仅row，无cell无p)的情况，导致后续表格计算selectedRect时出错 #65008149
        // 真实的用户意图显然是同时删除空的row，这里补上这部分逻辑
        var rows = table_extension_toConsumableArray(rect.table.content.content);
        for(var row = rows.length - 1; row >= 0; row--){
            if (rows[row].type.name === "table_row" && rows[row].nodeSize === 2) {
                rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
                rect.map = TableMap.get(rect.table);
                removeRow(tr, rect, row);
            }
        }
        // 如果删除的最后一列，则需要把光标从下一行的第一个单元格移动至前一行的最后一个单元格
        if (right === width) {
            /**
     * -6 是因为 </p></cell></row><row><cell><p>
     * 理论如果光标处于最后一行时，删除列后光标会在表格外，此时应该 -5（</p></cell></row></table><p>）
     * 但实际上不影响，会自动矫正 */ tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, tr.selection.from - 6));
        } else if (table_extension_instanceof$1(tr.selection, cellSelection_CellSelection)) {
            tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, tr.selection.$anchorCell.pos + 2) // +2 是因为<cell><p>
            );
        }
        dispatch(tr.scrollIntoView());
        return true;
    };
};

function table_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_instanceof$2(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function table_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function table_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        table_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function isEmptyCell(cell) {
    var c = cell.content;
    return c.childCount === 1 && c.firstChild.isTextblock && c.firstChild.childCount === 0;
}
var canMergeCells = function(state) {
    var sel = state.selection;
    if (!table_extension_instanceof$2(sel, cellSelection_CellSelection) || sel.$anchorCell.pos === sel.$headCell.pos) {
        return false;
    }
    var hasNumCell = false;
    var allIsNumCell = true;
    sel.ranges.forEach(function(range) {
        var cellNode = findTableCell(range);
        if (cellNode) {
            if (cellNode.node.attrs.numCell) hasNumCell = true;
            else allIsNumCell = false;
        }
    });
    if (hasNumCell && !allIsNumCell) return false;
    return true;
};
var mergeCells = function() {
    return function(state, dispatch, view) {
        if (!canMergeCells(state)) return false;
        var rect = selectedRect(state);
        var map = rect.map;
        var tr = state.tr;
        var seen = [];
        var colwidth = [];
        var content = dist["Fragment"].empty;
        var mergedPos;
        var mergedCell;
        for(var row = rect.top; row < rect.bottom; row++){
            for(var col = rect.left; col < rect.right; col++){
                var cellPos = map.map[row * map.width + col];
                var cell = rect.table.nodeAt(cellPos);
                // 该单元格是多列合并后的单元格，且当前列不是合并后的第一列（之前已经加过一次 colwidth）
                var isMulColspan = cell.attrs.colspan > 1 && col > rect.left && cellPos === map.map[row * map.width + col - 1];
                if (row === rect.top && !isMulColspan) {
                    colwidth = colwidth.concat(cell.attrs.colwidth);
                }
                if (seen.indexOf(cellPos) > -1) continue;
                seen.push(cellPos);
                if (mergedPos == null) {
                    mergedPos = cellPos;
                    mergedCell = cell;
                } else {
                    if (!isEmptyCell(cell)) content = content.append(cell.content);
                    var mapped = tr.mapping.map(cellPos + rect.tableStart);
                    tr.delete(mapped, mapped + cell.nodeSize);
                }
            }
        }
        // 继承第一个单元格的attrs
        tr.setNodeMarkup(mergedPos + rect.tableStart, null, table_extension_objectSpreadProps(table_extension_objectSpread$1({}, mergedCell.attrs), {
            colspan: rect.right - rect.left,
            rowspan: rect.bottom - rect.top,
            colwidth: colwidth
        }));
        if (content.size) {
            var end = mergedPos + 1 + mergedCell.content.size;
            var start = isEmptyCell(mergedCell) ? mergedPos + 1 : end;
            tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
        }
        tr.setSelection(new cellSelection_CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
        dispatch(tr);
        return true;
    };
};

function table_extension_instanceof$3(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var canSplitCell = function(state) {
    var sel = state.selection;
    var cellNode;
    if (!table_extension_instanceof$3(sel, cellSelection_CellSelection)) {
        cellNode = cellWrapping(sel.$from);
        if (!cellNode) return false;
    } else {
        if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
        cellNode = sel.$anchorCell.nodeAfter;
    }
    if (cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) {
        return false;
    }
    return true;
};
var splitCell = function() {
    return function(state, dispatch, view) {
        if (!canSplitCell(state)) return false;
        var sel = state.selection;
        var cellNode;
        var cellPos;
        if (!table_extension_instanceof$3(sel, cellSelection_CellSelection)) {
            cellNode = cellWrapping(sel.$from);
            cellPos = cellAround(sel.$from).pos;
        } else {
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        var baseAttrs = cellNode.attrs;
        var attrs = [];
        var colwidth = baseAttrs.colwidth;
        if (baseAttrs.rowspan > 1) baseAttrs = setAttr(baseAttrs, "rowspan", 1);
        if (baseAttrs.colspan > 1) baseAttrs = setAttr(baseAttrs, "colspan", 1);
        var rect = selectedRect(state);
        var schema = state.schema, tr = state.tr;
        var _schema_nodes = schema.nodes, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header;
        for(var i = 0; i < rect.right - rect.left; i++){
            attrs.push(colwidth ? setAttr(baseAttrs, "colwidth", colwidth && colwidth[i] ? [
                colwidth[i]
            ] : null) : baseAttrs);
        }
        var lastCell;
        var tableHasRowHeader = hasRowHeader(rect.table);
        var tableHasColHeader = hasColHeader(rect.table);
        for(var row = rect.top; row < rect.bottom; row++){
            var pos = rect.map.positionAt(row, rect.left, rect.table);
            if (row === rect.top) pos += cellNode.nodeSize;
            for(var col = rect.left, i1 = 0; col < rect.right; col++, i1++){
                if (col === rect.left && row === rect.top) continue;
                var cellType = row === 0 && tableHasRowHeader || col === 0 && tableHasColHeader ? table_header : table_cell;
                tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType.createAndFill(attrs[i1]));
            }
        }
        tr.setNodeMarkup(cellPos, cellNode.type, attrs[0]);
        if (table_extension_instanceof$3(sel, cellSelection_CellSelection)) {
            tr.setSelection(new cellSelection_CellSelection(tr.doc.resolve(sel.$anchorCell.pos), lastCell && tr.doc.resolve(lastCell)));
        }
        dispatch(tr);
        return true;
    };
};

// from prosemirror-tables v1.1.1
var deleteTable$1 = function() {
    return function(state, dispatch) {
        var $pos = state.selection.$anchor;
        for(var d = $pos.depth; d > 0; d--){
            var node = $pos.node(d);
            if (node.type.spec.tableRole === "table") {
                dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView());
                return true;
            }
        }
        return false;
    };
};
var insertTable = function(param) {
    var rowCnt = param.rowCnt, colCnt = param.colCnt, headerData = param.headerData;
    return function(state, dispatch, view) {
        var schema = state.schema;
        var _schema_nodes = schema.nodes, table = _schema_nodes.table, table_row = _schema_nodes.table_row, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header;
        var headers = [];
        for(var i = 0; i < colCnt; i++){
            var headerNode = headerData ? table_header.create({
                colwidth: [
                    68
                ]
            }, headerData[i]) : table_header.createAndFill({
                colwidth: [
                    68
                ]
            });
            headers.push(headerNode);
        }
        var rowHeader = table_row.create(null, dist["Fragment"].from(headers));
        var rows = [
            rowHeader
        ];
        for(var i1 = 0; i1 < rowCnt - 1; i1++){
            var cells = [];
            for(var j = 0; j < colCnt; j++){
                cells.push(table_cell.createAndFill({
                    colwidth: [
                        68
                    ]
                }));
            }
            var rowNode = table_row.create(null, dist["Fragment"].from(cells));
            rows.push(rowNode);
        }
        var tableNode = table.create(null, dist["Fragment"].from(rows));
        var transaction = insertBlock(state, tableNode).transaction;
        dispatch(transaction.scrollIntoView());
        view.focus();
        return true;
    };
};

function table_extension_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_extension_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function table_extension_ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function table_extension_objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        table_extension_ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// 设置/取消表头行
var toggleRowHeader = function() {
    return function(state, dispatch, view) {
        if (!isInTable(state)) return false;
        var tr = state.tr, _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, table_cell = _state_schema_nodes.table_cell, table_header = _state_schema_nodes.table_header;
        var _selectedRect = selectedRect(state), tableStart = _selectedRect.tableStart, table = _selectedRect.table;
        var transaction = tr;
        if (hasRowHeader(table)) {
            tr.doc.nodesBetween(tableStart, table.nodeSize + tableStart - 1, function(node, pos, parent) {
                if (node.type === table_header && parent === table.firstChild) {
                    var attrs = node.attrs;
                    if (node === parent.firstChild) {
                        var newAttrs = table_extension_objectSpreadProps$1(table_extension_objectSpread$2({}, attrs), {
                            numCell: hasNumCol(table)
                        });
                        transaction = hasColHeader(table) ? tr.setNodeMarkup(pos, table_header, newAttrs) : tr.setNodeMarkup(pos, table_cell, newAttrs);
                    } else {
                        transaction = tr.setNodeMarkup(pos, table_cell, attrs);
                    }
                }
            });
        } else {
            tr.doc.nodesBetween(tableStart, table.nodeSize + tableStart - 1, function(node, pos, parent) {
                if (parent === table.firstChild) {
                    var attrs = node.attrs;
                    transaction = tr.setNodeMarkup(pos, table_header, table_extension_objectSpreadProps$1(table_extension_objectSpread$2({}, attrs), {
                        numCell: false
                    }));
                }
            });
        }
        if (!transaction) return false;
        dispatch(transaction);
        view.focus();
        return true;
    };
};
var unsetColHeader = function(tr, state) {
    var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, table_cell = _state_schema_nodes.table_cell, table_header = _state_schema_nodes.table_header;
    var _selectedRect = selectedRect(state), tableStart = _selectedRect.tableStart, table = _selectedRect.table;
    var transaction = tr;
    tr.doc.nodesBetween(tableStart, table.nodeSize + tableStart - 1, function(node, pos, parent) {
        if (node.type === table_header && node === parent.firstChild && isClosestChildren(table, parent)) {
            var attrs = node.attrs;
            if (parent === table.firstChild && hasRowHeader(table)) return;
            transaction = tr.setNodeMarkup(pos, table_cell, attrs);
        }
    });
    return transaction;
};
var setColHeader = function(tr, state) {
    var _state_schema = state.schema, _state_schema_nodes = _state_schema.nodes, table_cell = _state_schema_nodes.table_cell, table_header = _state_schema_nodes.table_header;
    var _selectedRect = selectedRect(state), tableStart = _selectedRect.tableStart, table = _selectedRect.table;
    var transaction = tr;
    var rowspan = 0;
    tr.doc.nodesBetween(tableStart, table.nodeSize + tableStart - 1, function(node, pos, parent) {
        if ((node.type === table_cell || node.type === table_header) && node === parent.firstChild && isClosestChildren(table, parent)) {
            if (rowspan === 0) {
                rowspan = node.attrs.rowspan - 1;
                var attrs = node.attrs;
                transaction = tr.setNodeMarkup(pos, table_header, attrs);
            } else {
                rowspan--;
            }
        }
    });
    return transaction;
};
var canToggleColHeader = function(state) {
    if (!isInTable(state)) return false;
    var _selectedRect = selectedRect(state), table = _selectedRect.table, map = _selectedRect.map;
    if (hasRowHeader(table) && map.height === 1) return false;
    return true;
};
// 设置/取消表头列
var toggleColHeader = function() {
    return function(state, dispatch, view) {
        if (!canToggleColHeader(state)) return false;
        var tr = state.tr;
        var table = selectedRect(state).table;
        var transaction = tr;
        if (hasColHeader(table)) {
            transaction = unsetColHeader(transaction, state);
        } else {
            transaction = setColHeader(transaction, state);
        }
        if (!transaction) return false;
        dispatch(transaction);
        view.focus();
        return true;
    };
};
var canToggleNumCol = function(state) {
    if (!isInTable(state)) return false;
    var _selectedRect = selectedRect(state), table = _selectedRect.table, map = _selectedRect.map;
    if (hasRowHeader(table) && map.height === 1) return false;
    return true;
};
// 设置/取消表头列
var toggleNumCol = function() {
    return function(state, dispatch, view) {
        if (!canToggleNumCol(state)) return false;
        var tr = state.tr, _state_schema = state.schema, table_header = _state_schema.nodes.table_header;
        var _selectedRect = selectedRect(state), tableStart = _selectedRect.tableStart, table = _selectedRect.table, map = _selectedRect.map;
        var transaction = tr;
        var currentHasNumCol = hasNumCol(table);
        var handleColHeader = false;
        if (currentHasNumCol) {
            removeColumn(transaction, {
                map: map,
                table: table,
                tableStart: tableStart
            }, 0);
            // 移除行号列后，如果表格为空，则删除整个表格
            var resTable = transaction.doc.nodeAt(transaction.mapping.map(tableStart - 1));
            var rows = resTable.content.content;
            var isEmptyTable = true;
            rows.forEach(function(row) {
                if (row.childCount > 0) isEmptyTable = false;
            });
            if (isEmptyTable) {
                transaction.delete(tableStart - 1, tableStart - 1 + resTable.nodeSize);
            }
        } else {
            handleColHeader = hasColHeader(table);
            // 如果此时存在表头列，先取消，增加行号列后再重新设置表头列
            if (handleColHeader) {
                transaction = unsetColHeader(transaction, state);
            }
            transaction = addColumn(transaction, {
                map: map,
                table: table,
                tableStart: tableStart
            }, 0, {
                colwidth: [
                    table_extension_MIN_COL_WIDTH
                ],
                numCell: true
            });
            // 表头行单元格没有行号
            if (hasRowHeader(table)) {
                tr.doc.nodesBetween(tableStart, table.nodeSize + tableStart - 1, function(node, pos) {
                    if (node.type === table_header && node.attrs.numCell) {
                        var attrs = node.attrs;
                        transaction = tr.setNodeMarkup(pos, null, table_extension_objectSpreadProps$1(table_extension_objectSpread$2({}, attrs), {
                            numCell: false
                        }));
                    }
                });
            }
        }
        if (!transaction) return false;
        dispatch(transaction);
        // 仅设置行号列时（现有逻辑），增加完行号，加回来固定列
        // setColHeader 依赖最新 state，需要 dispatch 之后
        if (!currentHasNumCol && handleColHeader) {
            var tr2 = setColHeader(view.state.tr, view.state);
            dispatch(tr2);
        }
        view.focus();
        return true;
    };
};

function table_extension_defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_instanceof$4(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_extension_defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var setCellBgColor = function(color) {
    return function(state, dispatch, view) {
        var selection = state.selection, tr = state.tr;
        var transaction = tr;
        if (table_extension_instanceof$4(selection, cellSelection_CellSelection)) {
            selection.ranges.forEach(function(sel) {
                var $from = sel.$from;
                transaction = transaction.setNodeMarkup($from.pos - 1, null, _objectSpreadProps$2(table_extension_objectSpread$3({}, $from.parent.attrs), {
                    bgColor: color
                }));
            });
        } else {
            var foundNode = findTableCell(selection);
            if (!foundNode) return false;
            transaction = transaction.setNodeMarkup(foundNode.pos, null, _objectSpreadProps$2(table_extension_objectSpread$3({}, foundNode.node.attrs), {
                bgColor: color
            }));
        }
        dispatch(transaction);
        view.focus();
        return true;
    };
};
// 设置表格宽度为自适应
var setResponsive = function() {
    return function(state, dispatch, view) {
        var selection = state.selection, tr = state.tr;
        var foundNode = findTable(selection);
        if (!foundNode) return false;
        var pos = foundNode.pos, tableNode = foundNode.node;
        if (tableNode.attrs.responsive) return false;
        tr.setNodeMarkup(pos, null, _objectSpreadProps$2(table_extension_objectSpread$3({}, tableNode.attrs), {
            responsive: true
        }));
        dispatch(tr);
        view.focus();
        return true;
    };
};
var isResponsive = function(state) {
    var selection = state.selection;
    var foundNode = findTable(selection);
    if (!foundNode) return false;
    var tableNode = foundNode.node;
    return tableNode.attrs.responsive;
};
// 设为固定宽度
var setFixed = function() {
    return function(state, dispatch, view) {
        if (!isResponsive(state)) return false;
        var selection = state.selection, tr = state.tr, schema = state.schema, doc = state.doc;
        var _findTable = findTable(selection), tablePos = _findTable.pos, tableNode = _findTable.node;
        var _schema_nodes = schema.nodes, table_header = _schema_nodes.table_header, table_cell = _schema_nodes.table_cell;
        doc.nodesBetween(tablePos, tablePos + tableNode.nodeSize, function(node, pos) {
            if ([
                table_header,
                table_cell
            ].includes(node.type)) {
                var attrs = node.attrs;
                var cellDom = view.domAtPos(pos + 1).node;
                var colspan = parseInt(cellDom.getAttribute("colspan"), 10) || 1;
                var cellWidth = cellDom.getBoundingClientRect().width / colspan;
                var newColwidth = [];
                for(var i = 0; i < colspan; i++)newColwidth.push(cellWidth);
                var newAttrs = _objectSpreadProps$2(table_extension_objectSpread$3({}, attrs), {
                    colwidth: newColwidth
                });
                tr.setNodeMarkup(pos, null, newAttrs);
            }
        });
        tr.setNodeMarkup(tablePos, null, _objectSpreadProps$2(table_extension_objectSpread$3({}, tableNode.attrs), {
            responsive: false
        }));
        dispatch(tr);
        view.focus();
        return true;
    };
};
// 设置单元格垂直对齐方式
var setCellVerticalAlign = function(align) {
    return function(state, dispatch, view) {
        var alignTypes = [
            "top",
            "middle",
            "bottom"
        ];
        if (!alignTypes.includes(align)) return false;
        var selection = state.selection, tr = state.tr;
        var transaction = tr;
        if (table_extension_instanceof$4(selection, cellSelection_CellSelection)) {
            selection.ranges.forEach(function(sel) {
                var $from = sel.$from;
                transaction = transaction.setNodeMarkup($from.pos - 1, null, _objectSpreadProps$2(table_extension_objectSpread$3({}, $from.parent.attrs), {
                    verticalAlign: align
                }));
            });
        } else {
            var foundNode = findTableCell(selection);
            if (!foundNode) return false;
            transaction = transaction.setNodeMarkup(foundNode.pos, null, _objectSpreadProps$2(table_extension_objectSpread$3({}, foundNode.node.attrs), {
                verticalAlign: align
            }));
        }
        dispatch(transaction);
        view.focus();
        return true;
    };
};
var setTableAttrs = function(attrs) {
    return function(state, dispatch, view) {
        var selection = state.selection, tr = state.tr;
        var foundNode = findTable(selection);
        if (!foundNode) return false;
        tr.setNodeMarkup(foundNode.pos, null, table_extension_objectSpread$3({}, foundNode.node.attrs, attrs));
        dispatch(tr);
        view.focus();
        return true;
    };
};
var getTableAttrs = function() {
    return function(state) {
        var selection = state.selection;
        var foundNode = findTable(selection);
        if (!foundNode) return false;
        return foundNode.node.attrs;
    };
};

// 表格外层工具条
var tableLayoutKey = new prosemirror_state_dist["PluginKey"]("tableLayout");
var tableEditingKey = new prosemirror_state_dist["PluginKey"]("tableEditing");
var columnResizingKey = new prosemirror_state_dist["PluginKey"]("tableColumnResizing");
var stickyHeaderKey = new prosemirror_state_dist["PluginKey"]("stickyHeader");
var fixTablesKey = new prosemirror_state_dist["PluginKey"]("fix-tables");
var scrollBarKey = new prosemirror_state_dist["PluginKey"]("tableScrollBar");
// 右键菜单
var tableContextMenuKey = new prosemirror_state_dist["PluginKey"]("tableContextMenu");

/* eslint-disable no-cond-assign */ /* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint-disable @typescript-eslint/no-shadow */ // copy from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/input.js
function table_extension_instanceof$5(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function domInCell(view, dom) {
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === "TD" || dom.nodeName === "TH") return dom;
    }
}
function cellUnderMouse(view, event) {
    var mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null;
}
/** 鼠标右键 */ var RIGHT_CLICK_BTN = 2;
function table_extension_handleMouseDown(view, startEvent) {
    var setCellSelection = // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($anchor, event) {
        var $head = cellUnderMouse(view, event);
        var starting = tableEditingKey.getState(view.state) == null;
        if (!$head || !inSameTable($anchor, $head)) {
            if (starting) $head = $anchor;
            else return;
        }
        var selection = new cellSelection_CellSelection($anchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            var tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta(tableEditingKey, $anchor.pos);
            view.dispatch(tr);
        }
    };
    var move = function move(event) {
        var anchor = tableEditingKey.getState(view.state);
        var $anchor;
        if (anchor != null) {
            // Continuing an existing cross-cell selection
            $anchor = view.state.doc.resolve(anchor);
        } else if (domInCell(view, event.target) && domInCell(view, event.target) !== startDOMCell) {
            // Moving out of the initial cell -- start a new cell selection
            $anchor = cellUnderMouse(view, startEvent);
            if (!$anchor) return stop();
        }
        if ($anchor) setCellSelection($anchor, event);
    };
    if (startEvent.ctrlKey || startEvent.metaKey) return;
    var startDOMCell = domInCell(view, startEvent.target);
    var $anchor;
    if (startEvent.shiftKey && table_extension_instanceof$5(view.state.selection, cellSelection_CellSelection)) {
        // Adding to an existing cell selection
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) {
        // Not in a cell, let the default behavior happen.
        return;
    }
    // 忽略右键
    if (startEvent.buttons === RIGHT_CLICK_BTN) {
        return;
    }
    // Stop listening to mouse motion events.
    function stop() {
        view.root.removeEventListener("mouseup", stop);
        view.root.removeEventListener("dragstart", stop);
        view.root.removeEventListener("mousemove", move);
        if (tableEditingKey.getState(view.state) != null) {
            view.dispatch(view.state.tr.setMeta(tableEditingKey, -1));
        }
    }
    view.root.addEventListener("mouseup", stop);
    view.root.addEventListener("dragstart", stop);
    view.root.addEventListener("mousemove", move);
}
function handleTripleClick(view, pos) {
    var doc = view.state.doc;
    var $cell = cellAround(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new cellSelection_CellSelection($cell)));
    return true;
}
var handleKeyDown = Object(prosemirror_keymap_dist["a" /* keydownHandler */])({
    ArrowLeft: arrow("horiz", -1),
    ArrowRight: arrow("horiz", 1),
    ArrowUp: arrow("vert", -1),
    ArrowDown: arrow("vert", 1),
    "Shift-ArrowLeft": shiftArrow("horiz", -1),
    "Shift-ArrowRight": shiftArrow("horiz", 1),
    "Shift-ArrowUp": shiftArrow("vert", -1),
    "Shift-ArrowDown": shiftArrow("vert", 1)
});
var handleTab = function(dir) {
    return function(state, dispatch, view) {
        var sel = state.selection;
        if (table_extension_instanceof$5(sel, cellSelection_CellSelection)) {
            return maybeSetSelection(state, dispatch, prosemirror_state_dist["Selection"].near(sel.$headCell, dir));
        }
        var nextState = state.apply(state.tr.setSelection(prosemirror_state_dist["TextSelection"].create(state.doc, dir > 0 ? sel.$anchor.end() : sel.$anchor.start())));
        var selection = nextState.selection;
        var end = atEndOfCell(view, "horiz", dir, nextState);
        if (end == null) return false;
        var tr = nextState.tr;
        var $anchor = prosemirror_state_dist["Selection"].near(state.doc.resolve(selection.head + dir), dir).$anchor;
        dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].between($anchor, tr.doc.resolve($anchor.pos + $anchor.node().nodeSize - 2))));
        return true;
    };
};
function maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function arrow(axis, dir) {
    return function(state, dispatch, view) {
        var sel = state.selection;
        if (table_extension_instanceof$5(sel, cellSelection_CellSelection)) {
            return maybeSetSelection(state, dispatch, prosemirror_state_dist["Selection"].near(sel.$headCell, dir));
        }
        if (axis !== "horiz" && !sel.empty) return false;
        var end = atEndOfCell(view, axis, dir);
        if (end == null) return false;
        if (axis === "horiz") {
            var nextSel = prosemirror_state_dist["Selection"].near(state.doc.resolve(sel.head + dir), dir);
            if (!isInTable({
                selection: nextSel
            })) return false;
            return maybeSetSelection(state, dispatch, nextSel);
        }
        var $cell = state.doc.resolve(end);
        var $next = nextCell($cell, axis, dir);
        var newSel;
        if ($next) {
            newSel = prosemirror_state_dist["Selection"].near($next, 1);
        } else if (dir < 0) {
            newSel = prosemirror_state_dist["Selection"].near(state.doc.resolve($cell.before(-1)), -1);
        } else {
            newSel = prosemirror_state_dist["Selection"].near(state.doc.resolve($cell.after(-1)), 1);
        }
        return maybeSetSelection(state, dispatch, newSel);
    };
}
function shiftArrow(axis, dir) {
    return function(state, dispatch, view) {
        var sel = state.selection;
        if (!table_extension_instanceof$5(sel, cellSelection_CellSelection)) {
            var end = atEndOfCell(view, axis, dir);
            if (end == null) return false;
            sel = new cellSelection_CellSelection(state.doc.resolve(end));
        }
        var $head = nextCell(sel.$headCell, axis, dir);
        if (!$head) return false;
        return maybeSetSelection(state, dispatch, new cellSelection_CellSelection(sel.$anchorCell, $head));
    };
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function atEndOfCell(view, axis, dir, nextState) {
    if (!table_extension_instanceof$5(view.state.selection, prosemirror_state_dist["TextSelection"])) return null;
    var $head = view.state.selection.$head;
    for(var d = $head.depth - 1; d >= 0; d--){
        var parent = $head.node(d);
        var index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === "cell" || parent.type.spec.tableRole === "header_cell") {
            var cellPos = $head.before(d);
            var dirStr = void 0;
            if (axis === "vert") {
                dirStr = dir > 0 ? "down" : "up";
            } else {
                dirStr = dir > 0 ? "right" : "left";
            }
            return view.endOfTextblock(dirStr, nextState) ? cellPos : null;
        }
    }
    return null;
}
/**
 * 处理文档内部节点的拖拽到表格中的行为
 * https://km.sankuai.com/collabpage/1309120749
 * https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65637326
 */ var handleDrop = function(view, event, slice, moved) {
    if (!moved || !slice) return false;
    var eventPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    var $mouse = view.state.doc.resolve(eventPos.pos);
    var insertPos = table_extension_getInsertPosInTable($mouse);
    // 交给 pm 默认处理
    if (insertPos === null) return false;
    // 删除原来地方的内容
    var tr = view.state.tr;
    tr.deleteSelection();
    // 获得删除之后的位置
    var pos = tr.mapping.map(insertPos);
    var isNode = slice.openStart === 0 && slice.openEnd === 0 && slice.content.childCount === 1;
    var beforeInsertDoc = tr.doc;
    if (isNode) {
        tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    } else {
        tr.replaceRange(pos, pos, slice);
    }
    // doc 没变化那就不用继续了
    if (tr.doc.eq(beforeInsertDoc)) return true;
    var $pos = tr.doc.resolve(pos);
    if (isNode && prosemirror_state_dist["NodeSelection"].isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) {
        tr.setSelection(new prosemirror_state_dist["NodeSelection"]($pos));
    } else {
        tr.setSelection(prosemirror_state_dist["TextSelection"].between($pos, tr.doc.resolve(tr.mapping.map(insertPos))));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
    return true;
};

function _instanceof$6(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var table_extension_handleBackspace = function() {
    return function(state, dispatch, view) {
        var tr = state.tr, sel = state.selection;
        // 已选中整个表格时，按Backspace删除整个表格
        if (_instanceof$6(sel, cellSelection_CellSelection) && sel.isWholeSelection()) {
            table_extension_deleteTable()(state, dispatch, view);
            return true;
        }
        // 光标在表格后时，按Backspace选中整个表格
        if (_instanceof$6(sel, GapcursorSelection["a" /* GapCursor */])) {
            var nodeBefore = sel.$from.nodeBefore;
            if (nodeBefore && nodeBefore.type.name === "table") {
                var table = nodeBefore;
                var startPos = sel.from - table.nodeSize + 1;
                var map = TableMap.get(table).map;
                var anchorPos = map[0] + startPos;
                var headPos = map[map.length - 1] + startPos;
                var tableSelection = cellSelection_CellSelection.rowSelection(tr.doc.resolve(anchorPos), tr.doc.resolve(headPos));
                dispatch(tr.setSelection(tableSelection));
                return true;
            }
        }
        return false;
    };
};
var handleDelete = function() {
    return function(state, dispatch, view) {
        var sel = state.selection;
        // 已选中整个表格时，按Delte删除整个表格
        if (_instanceof$6(sel, cellSelection_CellSelection) && sel.isWholeSelection()) {
            table_extension_deleteTable()(state, dispatch, view);
            return true;
        }
        return false;
    };
};

var table_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 表格
var regexpTable = /\|(.+)\|\n/;

var table_extension_AFTER_INSERT = "after_insert";
var TABLE_COLUMN_RESIZE = "table_column_resize";
var TABLE_HEIGHT_CHANGE = "table_height_change";
var HIDE_TABLE_MENU = "hide_table_menu";
var SHOW_TABLE_MENU = "show_table_menu";
var SYNC_PAGE_SCROLL = "sync_page_scroll";

var table_extension_isResizing = false; // 是否正在调整列宽
function changeResizingStatus(status) {
    table_extension_isResizing = status;
}
function updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
    if (table_extension_isResizing && overrideCol === undefined) return;
    var _node_attrs = node.attrs, indent = _node_attrs.indent, responsive = _node_attrs.responsive, borderStyle = _node_attrs.borderStyle, borderWidth = _node_attrs.borderWidth, borderColor = _node_attrs.borderColor;
    if (!responsive) {
        var _loop = function(i) {
            var _row_child_attrs = row.child(i).attrs, colspan = _row_child_attrs.colspan, colwidth = _row_child_attrs.colwidth;
            var hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth.map(function(p) {
                return parseInt(p, 10);
            }).reduce(function(prev, cur) {
                return prev + cur;
            });
            totalWidth += hasWidth || cellMinWidth;
            for(var j = 0; j < colspan; j++){
                var colWidthValue = overrideCol === col ? overrideValue : colwidth && colwidth[j];
                if (!hasWidth) fixedWidth = false;
                colgroupFragment.appendChild(document.createElement("col")).style.width = colWidthValue ? "".concat(colWidthValue, "px") : "";
                col++;
            }
        };
        var totalWidth = 0;
        var fixedWidth = true;
        var colgroupFragment = document.createDocumentFragment();
        var row = node.content.firstChild;
        var col = 0;
        for(var i = 0; i < row.childCount; i++)_loop(i);
        colgroup.innerHTML = "";
        colgroup.appendChild(colgroupFragment);
        if (fixedWidth) {
            table.style.width = "".concat(totalWidth, "px");
            table.style.minWidth = "";
        } else {
            table.style.width = "";
            table.style.minWidth = "".concat(totalWidth, "px");
        }
    } else {
        colgroup.innerHTML = "";
        table.style.width = "";
        table.style.minWidth = "";
    }
    if (indent >= 0) table.style.marginLeft = "".concat(indent * 20, "px");
    table.className = responsive ? "responsive" : "";
    table.setAttribute("data-borderstyle", borderStyle);
    table.setAttribute("data-borderwidth", borderWidth);
    table.setAttribute("data-bordercolor", borderColor);
}

/* eslint-disable @typescript-eslint/no-this-alias */ /* eslint-disable @typescript-eslint/no-use-before-define */ function table_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function table_extension_defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_extension_defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function currentColWidth(view, cellPos, param) {
    var colspan = param.colspan, colwidth = param.colwidth;
    var width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    var dom = view.domAtPos(cellPos);
    var node = dom.node.childNodes[dom.offset];
    var domWidth = node.offsetWidth;
    var parts = colspan;
    if (colwidth) {
        for(var i = 0; i < colspan; i++){
            if (colwidth[i]) {
                domWidth -= colwidth[i];
                parts--;
            }
        }
    }
    return domWidth / parts;
}
function domCellAround(target) {
    while(target && target.nodeName !== "TD" && target.nodeName !== "TH"){
        target = target.classList.contains("ProseMirror") ? null : target.parentNode;
    }
    return target;
}
function edgeCell(view, event, side) {
    var left = side === "left" ? event.clientX + 1 : event.clientX; // fix: 鼠标hover在边框左侧的时候，可能找到的单元格不准
    var found = view.posAtCoords({
        left: left,
        top: event.clientY
    });
    if (!found) return -1;
    var pos = found.pos;
    var $cell = cellAround(view.state.doc.resolve(pos));
    if (!$cell) return -1;
    if (side === "right") return $cell.pos;
    var map = TableMap.get($cell.node(-1));
    var start = $cell.start(-1);
    var index = map.map.indexOf($cell.pos - start);
    return index % map.width === 0 ? -1 : start + map.map[index - 1];
}
function draggedWidth(dragging, event, cellMinWidth) {
    var offset = event.clientX - dragging.startX;
    return Math.max(cellMinWidth, dragging.startWidth + offset);
}
function updateHandle(view, value) {
    view.dispatch(view.state.tr.setMeta(columnResizingKey, {
        setHandle: value
    }));
}
function zeroes(n) {
    var result = [];
    for(var i = 0; i < n; i++)result.push(0);
    return result;
}
// 检查表格某列中是否存在附件
function checkColHasAttachment(dom, col) {
    var rowListDom = dom.querySelectorAll("tbody tr");
    var hasAttachment = false;
    rowListDom.forEach(function(row) {
        if (row.children.length > col) {
            var colDom = row.children[col];
            if (colDom.innerHTML.includes("ct-attachment")) {
                hasAttachment = true;
            }
        }
    });
    return hasAttachment;
}
function updateColumnWidth(view, cell, width) {
    var $cell = view.state.doc.resolve(cell);
    var table = $cell.node(-1);
    if (!table) {
        return;
    }
    var map = TableMap.get(table);
    var start = $cell.start(-1);
    var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
    var tr = view.state.tr;
    var dom = view.domAtPos($cell.start(-1)).node;
    // 如果该列中存在附件，最小宽度为 200px
    if (checkColHasAttachment(dom, col)) {
        width = Math.max(200, width);
    }
    for(var row = 0; row < map.height; row++){
        var mapIndex = row * map.width + col;
        // Rowspanning cell that has already been handled
        if (row && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
        var pos = map.map[mapIndex];
        var attrs = table.nodeAt(pos).attrs;
        var index = attrs.colspan === 1 ? 0 : col - map.colCount(pos);
        if (attrs.colwidth && attrs.colwidth[index] === width) continue;
        var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
        colwidth[index] = width;
        tr.setNodeMarkup(start + pos, null, setAttr(attrs, "colwidth", colwidth));
    }
    if (tr.docChanged) view.dispatch(tr);
}
function displayColumnWidth(view, cell, width, cellMinWidth) {
    var $cell = view.state.doc.resolve(cell);
    var table = $cell.node(-1);
    var start = $cell.start(-1);
    if (!table || !start) return;
    var col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
    var dom = view.domAtPos($cell.start(-1)).node;
    while(dom.nodeName !== "TABLE")dom = dom.parentNode;
    changeResizingStatus(true);
    // 如果该列中存在附件，最小宽度为 200px
    if (checkColHasAttachment(dom, col)) {
        cellMinWidth = 200;
        width = Math.max(cellMinWidth, width);
    }
    updateColumns(table, dom.firstChild, dom, cellMinWidth, col, width);
}
function table_extension_handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable) {
    var _event_target, _event_target_classList;
    var pluginState = columnResizingKey.getState(view.state);
    if ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : (_event_target_classList = _event_target.classList) === null || _event_target_classList === void 0 ? void 0 : _event_target_classList.contains("column-resize-handler")) return false;
    if (!pluginState.dragging) {
        var target = domCellAround(event.target);
        var cell = -1;
        if (target) {
            var _target_getBoundingClientRect = target.getBoundingClientRect(), left = _target_getBoundingClientRect.left, right = _target_getBoundingClientRect.right;
            if (event.clientX - left <= handleWidth) {
                cell = edgeCell(view, event, "left");
            } else if (right - event.clientX <= handleWidth) {
                cell = edgeCell(view, event, "right");
            }
        }
        if (cell !== pluginState.activeHandle) {
            if (!lastColumnResizable && cell !== -1) {
                var $cell = view.state.doc.resolve(cell);
                var table = $cell.node(-1);
                var map = TableMap.get(table);
                var start = $cell.start(-1);
                var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
                if (col === map.width - 1) {
                    return false;
                }
            }
            updateHandle(view, cell);
        }
    }
    return false;
}
function handleMouseDown$1(view, event, cellMinWidth, eventEmitter) {
    var move = function move(e) {
        if (!e.which) {
            finish(e);
            return;
        }
        var curPluginState = columnResizingKey.getState(view.state);
        var dragged = draggedWidth(curPluginState.dragging, e, cellMinWidth);
        displayColumnWidth(view, curPluginState.activeHandle, dragged, cellMinWidth);
    };
    var pluginState = columnResizingKey.getState(view.state);
    if (pluginState.activeHandle === -1 || pluginState.dragging) return false;
    var _view_state = view.state, tr = _view_state.tr, doc = _view_state.doc;
    var cell = doc.nodeAt(pluginState.activeHandle);
    var width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
    var _findTable = findTable({
        $from: doc.resolve(pluginState.activeHandle)
    }), tablePos = _findTable.pos, table = _findTable.node;
    // 当前宽度自适应时，设为固定宽度，并同步各单元格的宽度
    if (table.attrs.responsive) {
        doc.nodesBetween(tablePos, tablePos + table.nodeSize, function(node, pos) {
            if ([
                "table_header",
                "table_cell"
            ].includes(node.type.name)) {
                var attrs = node.attrs;
                var cellDom = view.domAtPos(pos + 1).node;
                var colspan = parseInt(cellDom.getAttribute("colspan"), 10) || 1;
                var cellWidth = cellDom.getBoundingClientRect().width / colspan;
                var newColwidth = [];
                for(var i = 0; i < colspan; i++)newColwidth.push(cellWidth);
                var newAttrs = _objectSpreadProps$3(_objectSpread$4({}, attrs), {
                    colwidth: newColwidth
                });
                tr.setNodeMarkup(pos, null, newAttrs);
                if (cell === node) {
                    width = table_extension_formatWidth(currentColWidth(view, pluginState.activeHandle, newAttrs));
                }
            }
        });
        tr.setNodeMarkup(tablePos, null, _objectSpreadProps$3(_objectSpread$4({}, table.attrs), {
            responsive: false
        }));
    }
    view.dispatch(tr.setMeta(columnResizingKey, {
        setDragging: {
            startX: event.clientX,
            startWidth: width
        }
    }));
    function finish(e) {
        eventEmitter.emit(TABLE_COLUMN_RESIZE);
        window.removeEventListener("mouseup", finish);
        window.removeEventListener("mousemove", move);
        var curPluginState = columnResizingKey.getState(view.state);
        if (curPluginState.dragging) {
            updateColumnWidth(view, curPluginState.activeHandle, draggedWidth(curPluginState.dragging, e, cellMinWidth));
            view.dispatch(view.state.tr.setMeta(columnResizingKey, {
                setDragging: null
            }));
        }
    }
    window.addEventListener("mouseup", finish);
    window.addEventListener("mousemove", move);
    event.preventDefault();
    return true;
}
/**
 * 根据 view pos，生成 decoration dom
 */ var renderDecorationDom = function(view, pos, bWidth, isRowEnd) {
    try {
        var cellDOM = view.domAtPos(pos).node;
        var dom = document.createElement("div");
        var borderWidth = Number.parseInt(bWidth || "1", 10);
        var left = cellDOM.offsetLeft + cellDOM.offsetWidth - borderWidth;
        var tableDOM = cellDOM.closest("table");
        var tableWrapperDOM = cellDOM.closest(".".concat(table_extension_classNamePrefix("table-wrapper")));
        if (isRowEnd && (tableDOM === null || tableDOM === void 0 ? void 0 : tableDOM.offsetWidth) > (tableWrapperDOM === null || tableWrapperDOM === void 0 ? void 0 : tableWrapperDOM.offsetWidth)) {
            left -= 2;
        }
        dom.style.left = "".concat(left, "px");
        dom.className = "column-resize-handler";
        return dom;
    } catch (error) {
        return null;
    }
};
function handleDecorations(state, cell) {
    var _loop = function(row) {
        var index = col + row * map.width - 1;
        // For positions that are have either a different cell or the end
        // of the table to their right, and either the top of the table or
        // a different cell above them, add a decoration
        if ((col === map.width || map.map[index] !== map.map[index + 1]) && (row === 0 || map.map[index - 1] !== map.map[index - 1 - map.width])) {
            // 在当前行的最后插入Decoration，通过计算left来保证位置正确
            var cellPos = map.map[index];
            var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
            var rowNode = table_extension_findParentNodeClosestToPos(tr.doc.resolve(pos), function(node) {
                return node.type === nodes.table_row;
            });
            // 在 Decoration.widget 回调中 view 才是最新的，此时 view.domAtPos 才可靠 #ones 64914273
            decorations.push(index_es["a" /* Decoration */].widget(rowNode.pos + rowNode.node.nodeSize - 1, function(newView) {
                return renderDecorationDom(newView, pos, table.attrs.borderWidth, col === map.width);
            }));
            return "break";
        }
    };
    var decorations = [];
    var $cell = state.doc.resolve(cell);
    var table = $cell.node(-1);
    if (!table) {
        return null;
    }
    var map = TableMap.get(table);
    var start = $cell.start(-1);
    var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;
    var nodes = state.schema.nodes, tr = state.tr;
    for(var row = 0; row < map.height; row++){
        var _ret = _loop(row);
        if (_ret === "break") break;
    }
    return index_es["b" /* DecorationSet */].create(state.doc, decorations);
}
var table_extension_ResizeState = /*#__PURE__*/ function() {
    function ResizeState(activeHandle, dragging) {
        table_extension_classCallCheck(this, ResizeState);
        this.activeHandle = activeHandle;
        this.dragging = dragging;
    }
    var _proto = ResizeState.prototype;
    _proto.apply = function apply(tr) {
        var state = this;
        var action = tr.getMeta(columnResizingKey);
        if (action && action.setHandle != null) {
            return new ResizeState(action.setHandle, null);
        }
        if (action && action.setDragging !== undefined) {
            return new ResizeState(state.activeHandle, action.setDragging);
        }
        if (state.activeHandle > -1 && tr.docChanged) {
            var handle = tr.mapping.map(state.activeHandle, -1);
            if (!pointsAtCell(tr.doc.resolve(handle))) handle = null;
            state = new ResizeState(handle, state.dragging);
        }
        return state;
    };
    return ResizeState;
}();
function columnResizing(provider, getView) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_handleWidth = _ref.handleWidth, handleWidth = _ref_handleWidth === void 0 ? 5 : _ref_handleWidth, _ref_cellMinWidth = _ref.cellMinWidth, cellMinWidth = _ref_cellMinWidth === void 0 ? table_extension_MIN_COL_WIDTH : _ref_cellMinWidth, _ref_lastColumnResizable = _ref.lastColumnResizable, lastColumnResizable = _ref_lastColumnResizable === void 0 ? true : _ref_lastColumnResizable, _ref_editorEventEmitter = _ref.editorEventEmitter, editorEventEmitter = _ref_editorEventEmitter === void 0 ? null : _ref_editorEventEmitter;
    return new prosemirror_state_dist["Plugin"]({
        key: columnResizingKey,
        state: {
            init: function init() {
                return new table_extension_ResizeState(-1, false);
            },
            apply: function apply(tr, prev) {
                return prev.apply(tr);
            }
        },
        props: {
            handleDOMEvents: {
                mousemove: function mousemove(view, event) {
                    return table_extension_handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable);
                },
                mousedown: function mousedown(view, event) {
                    return handleMouseDown$1(view, event, cellMinWidth, editorEventEmitter);
                }
            },
            decorations: function decorations(state) {
                var pluginState = columnResizingKey.getState(state);
                if (pluginState.activeHandle > -1) {
                    return handleDecorations(state, pluginState.activeHandle);
                }
                changeResizingStatus(false);
                return index_es["b" /* DecorationSet */].empty;
            },
            nodeViews: {}
        }
    });
}

function table_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var TableView = /*#__PURE__*/ function() {
    function TableView(node, view, getPos, provider, cellMinWidth, eventEmitter) {
        var _this = this;
        table_extension_classCallCheck$1(this, TableView);
        this.handleAfterInsert = function(param) {
            var braceWidth = param.braceWidth, pos = param.pos;
            if (!braceWidth) return;
            var _this_view_state = _this.view.state, selection = _this_view_state.selection, schema = _this_view_state.schema, doc = _this_view_state.doc;
            var _schema_nodes = schema.nodes, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header;
            var foundCellNode = table_extension_findParentNode(function(node) {
                return [
                    table_cell,
                    table_header
                ].includes(node.type);
            })(pos ? {
                $from: doc.resolve(pos)
            } : selection);
            // 是否在表格内
            if (foundCellNode) {
                var attrs = foundCellNode.node.attrs;
                var width = attrs.colwidth.reduce(function(a, b) {
                    return a + b;
                });
                // 单元格宽度是否小于撑开宽度
                if (width < braceWidth) {
                    updateColumnWidth(_this.view, foundCellNode.pos, braceWidth);
                }
            }
        };
        // 处理异常宽度表格 固定表格宽度
        this.fixedErrorColumns = function(getPos) {
            if (_this.node.attrs.responsive) return;
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var tr = state.tr, schema = state.schema;
            var _schema_nodes = schema.nodes, table_header = _schema_nodes.table_header, table_cell = _schema_nodes.table_cell;
            var cellTypes = [
                table_header,
                table_cell
            ];
            var tablePos = getPos();
            tr.doc.nodesBetween(tablePos, tablePos + _this.node.nodeSize, function(node, pos) {
                if (cellTypes.includes(node.type)) {
                    var attrs = node.attrs;
                    var colwidth = attrs.colwidth;
                    if (colwidth.includes(0) || colwidth.includes(NaN) || colwidth.includes(Infinity)) {
                        var dom = _this.view.domAtPos(pos + 1).node;
                        var width = dom.clientWidth + 3;
                        var len = colwidth.length;
                        var newColwidth = new Array(len);
                        var divWidth = Number(width / len);
                        newColwidth.fill(divWidth > _this.cellMinWidth ? divWidth : _this.cellMinWidth);
                        try {
                            tr.setNodeMarkup(pos, null, _objectSpreadProps$4(_objectSpread$5({}, attrs), {
                                colwidth: newColwidth
                            }));
                        } catch (error) {
                            console.error(error);
                        }
                    }
                }
            });
            dispatch(tr.setMeta("addToHistory", false));
        };
        this.view = view;
        this.node = node;
        this.provider = provider;
        this.cellMinWidth = cellMinWidth;
        this.eventEmitter = eventEmitter;
        this.dom = document.createElement("div");
        this.dom.className = "".concat(table_extension_classNamePrefix("table-wrapper"), " ").concat(table_extension_classNamePrefix("node-view-dom"));
        var dataDiffId = node.attrs.dataDiffId;
        if (dataDiffId) {
            this.dom.setAttribute("data-diff-id", dataDiffId);
        }
        this.table = this.dom.appendChild(document.createElement("table"));
        this.colgroup = this.table.appendChild(document.createElement("colgroup"));
        changeResizingStatus(false);
        updateColumns(node, this.colgroup, this.table, cellMinWidth);
        this.contentDOM = this.table.appendChild(document.createElement("tbody"));
        this.timer = setTimeout(function() {
            _this.fixedErrorColumns(getPos);
        }, 100);
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.on(table_extension_AFTER_INSERT, this.handleAfterInsert);
        eventEmitter.on(table_extension_AFTER_INSERT, this.handleAfterInsert);
    }
    var _proto = TableView.prototype;
    _proto.destroy = function destroy() {
        var _this_eventEmitter, _this_eventEmitter1;
        (_this_eventEmitter = this.eventEmitter) === null || _this_eventEmitter === void 0 ? void 0 : _this_eventEmitter.on(table_extension_AFTER_INSERT, this.handleAfterInsert);
        (_this_eventEmitter1 = this.eventEmitter) === null || _this_eventEmitter1 === void 0 ? void 0 : _this_eventEmitter1.off(table_extension_AFTER_INSERT, this.handleAfterInsert);
        clearTimeout(this.timer);
    };
    _proto.update = function update(node) {
        if (node.type !== this.node.type) return false;
        this.node = node;
        updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
        return true;
    };
    _proto.ignoreMutation = function ignoreMutation(record) {
        return record.type === "attributes" && (record.target === this.table || this.colgroup.contains(record.target));
    };
    return TableView;
}();

/* eslint-disable no-labels */ /* eslint-disable no-restricted-syntax */ // This file defines helpers for normalizing tables, making sure no
// cells overlap (which can happen, if you have the wrong col- and
// rowspans) and that each row has the same width. Uses the problems
// reported by `TableMap`.
function _defineProperty$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$6(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function changedDescendants(old, cur, offset, f) {
    var oldSize = old.childCount;
    var curSize = cur.childCount;
    outer: for(var i = 0, j = 0; i < curSize; i++){
        var child = cur.child(i);
        for(var scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++){
            if (old.child(scan) === child) {
                j = scan + 1;
                offset += child.nodeSize;
                continue outer;
            }
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) {
            changedDescendants(old.child(j), child, offset + 1, f);
        } else {
            child.nodesBetween(0, child.content.size, f, offset + 1);
        }
        offset += child.nodeSize;
    }
}
// : (EditorState, Node, number, ?Transaction) → ?Transaction
// Fix the given table, if necessary. Will append to the transaction
// it was given, if non-null, or create a new one if necessary.
function fixTable(state, table, tablePos, tr) {
    var _loop = function(i1) {
        var prob = map.problems[i1];
        if (prob.type === "collision") {
            var cell = table.nodeAt(prob.pos);
            for(var j = 0; j < cell.attrs.rowspan; j++){
                mustAdd[prob.row + j] += prob.n;
            }
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, removeColSpan(cell.attrs, cell.attrs.colspan - prob.n, prob.n));
        } else if (prob.type === "missing") {
            mustAdd[prob.row] += prob.n;
        } else if (prob.type === "overlong_rowspan") {
            var cell1 = table.nodeAt(prob.pos);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell1.attrs, "rowspan", cell1.attrs.rowspan - prob.n));
        } else if (prob.type === "colwidth mismatch") {
            var cell2 = table.nodeAt(prob.pos);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell2.attrs, "colwidth", prob.colwidth));
        } else if (prob.type === "invalid_cell_for_row_header_table") {
            tr.doc.nodesBetween(tr.mapping.map(tablePos), tr.mapping.map(table.nodeSize + tablePos - 1), function(node, pos, parent) {
                if (parent === table.firstChild) {
                    var attrs = node.attrs;
                    tr.setNodeMarkup(tr.mapping.map(pos), state.schema.nodes.table_header, _objectSpreadProps$5(_objectSpread$6({}, attrs), {
                        numCell: false
                    }));
                }
            });
        }
    };
    var isRowHeader = hasRowHeader(table);
    var isNumCol = hasNumCol(table);
    var map = TableMap.get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    var mustAdd = [];
    for(var i = 0; i < map.height; i++)mustAdd.push(0);
    for(var i1 = 0; i1 < map.problems.length; i1++)_loop(i1);
    var first;
    var last;
    for(var i2 = 0; i2 < mustAdd.length; i2++){
        if (mustAdd[i2]) {
            if (first == null) first = i2;
            last = i2;
        }
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(var i3 = 0, pos = tablePos + 1; i3 < map.height; i3++){
        var row = table.child(i3);
        var end = pos + row.nodeSize;
        var add = mustAdd[i3];
        var needFixRowHeader = isRowHeader && i3 === 0;
        if (add > 0) {
            var nodes = [];
            for(var j = 0; j < add; j++){
                if (needFixRowHeader) {
                    nodes.push(state.schema.nodes.table_header.createAndFill());
                } else {
                    nodes.push(state.schema.nodes.table_cell.createAndFill());
                }
            }
            // 如果有「序号」，一律从每行最后开始补
            var side = !isNumCol && (i3 === 0 || first === i3 - 1) && last === i3 ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta(fixTablesKey, {
        fixTables: true
    });
}
// :: (EditorState, ?EditorState) → ?Transaction
// Inspect all tables in the given state's document and return a
// transaction that fixes them, if necessary. If `oldState` was
// provided, that is assumed to hold a previous, known-good state,
// which will be used to avoid re-scanning unchanged parts of the
// document.
function fixTables(state, oldState) {
    var tr;
    var check = function(node, pos) {
        if (node.type.spec.tableRole === "table") {
            tr = fixTable(state, node, pos, tr);
        }
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) {
        changedDescendants(oldState.doc, state.doc, 0, check);
    }
    return tr;
}

function _instanceof$7(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function tableEditing(provider) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_cellMinWidth = _ref.cellMinWidth, cellMinWidth = _ref_cellMinWidth === void 0 ? table_extension_MIN_COL_WIDTH : _ref_cellMinWidth, _ref_editorEventEmitter = _ref.editorEventEmitter, editorEventEmitter = _ref_editorEventEmitter === void 0 ? null : _ref_editorEventEmitter;
    return new prosemirror_state_dist["Plugin"]({
        key: tableEditingKey,
        state: {
            init: function init(_, state) {
                this.spec.props.nodeViews.table = function(node, view, getPos) {
                    return new TableView(node, view, getPos, provider, cellMinWidth, editorEventEmitter);
                };
                return null;
            },
            apply: function apply(tr, cur) {
                var set = tr.getMeta(tableEditingKey);
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                var _tr_mapping_mapResult = tr.mapping.mapResult(cur), deleted = _tr_mapping_mapResult.deleted, pos = _tr_mapping_mapResult.pos;
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: drawCellSelection,
            nodeViews: {},
            handleDOMEvents: {
                mousedown: table_extension_handleMouseDown,
                cut: function(view) {
                    var _view_state = view.state, sel = _view_state.selection;
                    if (_instanceof$7(sel, cellSelection_CellSelection) && sel.isWholeSelection()) {
                        var tablePos = sel.$anchorCell.before(-1);
                        setTimeout(function() {
                            var dispatch = view.dispatch, _view_state = view.state, doc = _view_state.doc, tr = _view_state.tr;
                            var tableSize = doc.nodeAt(tablePos).nodeSize;
                            var selection = prosemirror_state_dist["TextSelection"].create(doc, tablePos, tablePos + tableSize);
                            dispatch(tr.setSelection(selection).deleteSelection());
                        }, 0);
                    }
                    return false;
                }
            },
            // fix: 框选单元格选区的时候阻止浏览器默认的设置textSelection的动作
            createSelectionBetween: function createSelectionBetween(view) {
                if (tableEditingKey.getState(view.state) != null) {
                    return view.state.selection;
                }
            },
            handleClick: function(view, pos) {
                var _view_state = view.state, tr = _view_state.tr, doc = _view_state.doc, selection = _view_state.selection;
                if (_instanceof$7(selection, cellSelection_CellSelection)) {
                    view.dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(doc, pos)));
                }
                return false;
            },
            handleTripleClick: handleTripleClick,
            handleKeyDown: handleKeyDown,
            handleDrop: handleDrop
        },
        appendTransaction: function appendTransaction(_, oldState, state) {
            return normalizeSelection(state, fixTables(state, oldState), oldState, false);
        }
    });
}

function table_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var table_extension_css_248z = '.selectbar-addtip-wrapper.left,.selectbar-addtip-wrapper.right{float:left;width:50%;height:100%}.selectbar-addtip-wrapper.bottom,.selectbar-addtip-wrapper.top{width:100%;height:50%;position:relative}.selectbar-addtip{position:absolute;display:flex;justify-content:center;align-items:center;background:#111;border-radius:3px;line-height:26px;z-index:99;cursor:pointer}.selectbar-addtip svg path{fill:#fff}.selectbar-addtip.left,.selectbar-addtip.right{bottom:18px;width:20px;height:20px;margin-bottom:4px}.selectbar-addtip.left:after,.selectbar-addtip.right:after{content:"";position:absolute;width:0;bottom:-4px;right:50%;transform:translate(50%);display:block;border-color:#111 transparent;border-style:solid;border-width:5px 5px 0;z-index:1}.selectbar-addtip.top{top:-10px}.selectbar-addtip.bottom{bottom:-10px}.selectbar-addtip.bottom,.selectbar-addtip.top{left:-16px;width:20px;height:20px;margin-right:4px}.selectbar-addtip.bottom:after,.selectbar-addtip.top:after{content:"";position:absolute;width:0;right:-9px;bottom:50%;transform:translateY(50%);display:block;border:5px solid transparent;border-left-color:#111;z-index:1}';
table_extension_styleInject(table_extension_css_248z);

function table_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function table_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function table_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_slicedToArray(arr, i) {
    return table_extension_arrayWithHoles(arr) || table_extension_iterableToArrayLimit(arr, i) || table_extension_unsupportedIterableToArray$1(arr, i) || table_extension_nonIterableRest();
}
function table_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray$1(o, minLen);
}
var AddTip = function(props) {
    var dir = props.dir, offset = props.offset, children = props.children, onClick = props.onClick, _props_visible = props.visible, visible = _props_visible === void 0 ? function() {
        return true;
    } : _props_visible;
    var _useState = table_extension_slicedToArray(Object(react["useState"])(false), 2), showAddTip = _useState[0], setShowAddTip = _useState[1];
    return /*#__PURE__*/ react_default.a.createElement("div", {
        onMouseEnter: function() {
            return setShowAddTip(true);
        },
        onMouseLeave: function() {
            return setShowAddTip(false);
        },
        className: "selectbar-addtip-wrapper ".concat(dir)
    }, children, visible() && showAddTip && /*#__PURE__*/ react_default.a.createElement("div", {
        className: "selectbar-addtip ".concat(dir),
        style: offset ? {
            left: offset
        } : {},
        onClick: onClick
    }, /*#__PURE__*/ react_default.a.createElement("svg", {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ react_default.a.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react_default.a.createElement("g", {
        transform: "translate(-273.000000, -427.000000)",
        fill: "#BDC2C7"
    }, /*#__PURE__*/ react_default.a.createElement("g", {
        transform: "translate(276.000000, 430.000000)"
    }, /*#__PURE__*/ react_default.a.createElement("path", {
        d: "M5.66497803,4.33502197 L5.66497803,0.664978027 C5.66497803,0.297720804 5.36725722,0 5,0 C4.63274278,0 4.33502197,0.297720804 4.33502197,0.664978027 L4.33502197,4.33502197 L0.664978027,4.33502197 C0.297720804,4.33502197 0,4.63274278 0,5 C0,5.36725722 0.297720804,5.66497803 0.664978027,5.66497803 L4.33502197,5.66497803 L4.33502197,9.33502197 C4.33502197,9.7022792 4.63274278,10 5,10 C5.36725722,10 5.66497803,9.7022792 5.66497803,9.33502197 L5.66497803,5.66497803 L9.33502197,5.66497803 C9.7022792,5.66497803 10,5.36725722 10,5 C10,4.63274278 9.7022792,4.33502197 9.33502197,4.33502197 L5.66497803,4.33502197 Z",
        id: "Combined-Shape"
    })))))));
};

function table_extension_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof$8(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function table_extension_nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_slicedToArray$1(arr, i) {
    return table_extension_arrayWithHoles$1(arr) || table_extension_iterableToArrayLimit$1(arr, i) || table_extension_unsupportedIterableToArray$2(arr, i) || table_extension_nonIterableRest$1();
}
function table_extension_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray$2(o, minLen);
}
/**
 * 计算真正应该插入行的位置, 因为合并单元格的时候位置是不对的
 * https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65128414
 * 思路是: 一列列按线性关系找到能用于准确定位插入行的单元格的位置
 * 注: 传入的 index 为行的序号
 */ var adjustAnchor = function(param) {
    var colCount = param.colCount, direction = param.direction, index = param.index, map = param.map;
    if (direction === "before") {
        for(var i = 0; i < colCount; i++){
            // 上一行的 idx
            var prevIdx = (index - 1) * colCount + i;
            var currIdx = index * colCount + i;
            // 向上查找,如果是合并单元格那个上面一行的 map 位置是和当前位置是一样的
            if (map[prevIdx] !== map[currIdx]) {
                return map[currIdx];
            }
        }
    } else {
        for(var i1 = 0; i1 < colCount; i1++){
            // 下一行的 idx
            var nextIdx = (index + 1) * colCount + i1;
            var currIdx1 = index * colCount + i1;
            // 向下查找,如果是合并单元格那个下面一行的 map 位置是和当前位置是一样的
            if (map[nextIdx] !== map[currIdx1]) {
                return map[currIdx1];
            }
        }
    }
    return map[index];
};
var RowSelectBar = function(param) {
    var pos = param.pos, view = param.view;
    var containerRef = Object(react["useRef"])(null);
    var tableWrapper = Object(react["useMemo"])(function() {
        return view.nodeDOM(pos);
    }, [
        pos,
        view
    ]);
    var getTableInfo = function() {
        if (!tableWrapper || !tableWrapper.closest(".ProseMirror")) {
            return {
                left: 0,
                top: 0,
                width: 0
            };
        }
        var tableRect = tableWrapper.getBoundingClientRect();
        var editorRect = tableWrapper.closest(".ProseMirror").getBoundingClientRect();
        return {
            left: tableRect.left - editorRect.left,
            top: tableRect.top - editorRect.top,
            width: tableRect.width
        };
    };
    var _useState = table_extension_slicedToArray$1(Object(react["useState"])(function() {
        return getTableInfo();
    }), 2), tableInfo = _useState[0], setTableInfo = _useState[1];
    var updatePos = function() {
        setTableInfo(getTableInfo());
    };
    Object(react["useEffect"])(function() {
        var updatePosTimer = setInterval(updatePos, 100);
        return function() {
            clearInterval(updatePosTimer);
            updatePosTimer = null;
        };
    }, [
        tableWrapper
    ]);
    var getEveryRowHeight = function() {
        var tableBody = tableWrapper.querySelector("table > tbody");
        return Array.from(tableBody.children).filter(function(el) {
            return [
                "TR"
            ].includes(el.tagName);
        }).map(function(tr) {
            return tr.offsetHeight;
        });
    };
    var preventShiftMouseDown = function(e) {
        if (e.shiftKey) e.preventDefault();
    };
    var onSelectRow = function(e, index) {
        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr, dispatch = view.dispatch;
        if (_instanceof$8(selection, cellSelection_CellSelection) && e.shiftKey && selection.isRowSelection()) {
            var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
            if (!table) return null;
            var _TableMap_get = TableMap.get(table), map = _TableMap_get.map, width = _TableMap_get.width;
            var selectAnchorPos = map[width * index] + start;
            var tableSelection = cellSelection_CellSelection.rowSelection(tr.doc.resolve(selection.$anchorCell.pos), tr.doc.resolve(selectAnchorPos));
            dispatch(tr.setSelection(tableSelection));
            view.focus();
        } else {
            var _ref1 = findTable(selection) || {}, table1 = _ref1.node, start1 = _ref1.start;
            if (!table1) return null;
            var _TableMap_get1 = TableMap.get(table1), map1 = _TableMap_get1.map, width1 = _TableMap_get1.width;
            var anchorPos = map1[width1 * index] + start1;
            var tableSelection1 = cellSelection_CellSelection.rowSelection(tr.doc.resolve(anchorPos));
            dispatch(tr.setSelection(tableSelection1));
            view.focus();
        }
    };
    var getActiveItemRange = function() {
        var _view_state = view.state, sel = _view_state.selection;
        if (_instanceof$8(sel, cellSelection_CellSelection)) {
            return sel.getRect();
        }
        return {
            top: -1,
            bottom: -1
        };
    };
    var clickAddTip = function(e, idx, dir) {
        e.stopPropagation();
        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr, doc = _view_state.doc, dispatch = view.dispatch;
        var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
        if (!table) return null;
        var _TableMap_get = TableMap.get(table), map = _TableMap_get.map, colCount = _TableMap_get.width;
        var anchorPos = adjustAnchor({
            colCount: colCount,
            direction: dir,
            index: idx,
            map: map
        }) + start;
        dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(doc, anchorPos + 2))); // +2是因为<cell><p></p>
        if (dir === "before") {
            addRowBefore()(view.state, view.dispatch, view);
        } else {
            addRowAfter()(view.state, view.dispatch, view);
        }
        view.focus();
    };
    var showAddRowBeforeTip = function(idx) {
        var _view_state = view.state, selection = _view_state.selection, doc = _view_state.doc;
        var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
        if (!table) return null;
        var _TableMap_get = TableMap.get(table), map = _TableMap_get.map, width = _TableMap_get.width;
        var anchorPos = map[width * idx] + start;
        return canAddRowBefore({
            selection: prosemirror_state_dist["TextSelection"].create(doc, anchorPos + 2)
        });
    };
    var rowSelectItems = function() {
        var items = [];
        var selection = view.state.selection;
        var node = (findTable(selection) || {}).node;
        if (!node) return null;
        var rowHeights = getEveryRowHeight();
        var activeRange = getActiveItemRange();
        rowHeights.forEach(function(h, idx) {
            var selected = idx >= activeRange.top && idx < activeRange.bottom;
            items.push(/*#__PURE__*/ react_default.a.createElement("div", {
                key: idx,
                style: {
                    height: "".concat(h, "px")
                },
                className: "".concat(table_extension_classNamePrefix("table-row-selectbar-item")).concat(selected ? " selected" : ""),
                onClick: function(e) {
                    return onSelectRow(e, idx);
                },
                onMouseDown: preventShiftMouseDown
            }, /*#__PURE__*/ react_default.a.createElement(AddTip, {
                dir: "top",
                onClick: function(e) {
                    return clickAddTip(e, idx, "before");
                },
                visible: function() {
                    return showAddRowBeforeTip(idx);
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "visible-area top"
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "btn"
            }))), /*#__PURE__*/ react_default.a.createElement(AddTip, {
                dir: "bottom",
                onClick: function(e) {
                    return clickAddTip(e, idx, "after");
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "visible-area bottom"
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "btn"
            })))));
        });
        return items;
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-row-selectbar-container")),
        style: {
            top: "".concat(tableInfo.top, "px"),
            left: "".concat(tableInfo.left - 26, "px")
        }
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-row-selectbar")),
        ref: containerRef
    }, rowSelectItems()));
};

function table_extension_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function table_extension_arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return table_extension_arrayLikeToArray$3(arr);
}
function _instanceof$9(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function table_extension_iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function table_extension_nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_slicedToArray$2(arr, i) {
    return table_extension_arrayWithHoles$2(arr) || table_extension_iterableToArrayLimit$2(arr, i) || table_extension_unsupportedIterableToArray$3(arr, i) || table_extension_nonIterableRest$2();
}
function table_extension_toConsumableArray$1(arr) {
    return table_extension_arrayWithoutHoles$1(arr) || table_extension_iterableToArray$1(arr) || table_extension_unsupportedIterableToArray$3(arr) || table_extension_nonIterableSpread$1();
}
function table_extension_unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray$3(o, minLen);
}
/**
 * 计算真正应该插入列的位置, 因为合并单元格的时候位置是不对的
 * https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65128414
 * 思路是: 一行行按线性关系找到能用于准确定位插入列的单元格的位置
 */ var adjustAnchor$1 = function(param) {
    var rowCount = param.rowCount, colCount = param.colCount, direction = param.direction, index = param.index, map = param.map;
    if (direction === "before") {
        for(var i = 0; i < rowCount; i++){
            var idx = i * colCount + index;
            // 向前查找,如果是合并单元格那个前面一个 map 位置是和当前位置是一样的
            if (map[idx - 1] !== map[idx]) {
                return map[idx];
            }
        }
    } else {
        for(var i1 = 0; i1 < rowCount; i1++){
            var idx1 = i1 * colCount + index;
            // 向后查找,如果是合并单元格那个后面一个 map 位置是和当前位置是一样的
            if (map[idx1 + 1] !== map[idx1]) {
                return map[idx1];
            }
        }
    }
    return map[index];
};
var ColSelectBar = function(param) {
    var pos = param.pos, view = param.view, eventEmitter = param.eventEmitter;
    var colBarRef = Object(react["useRef"])(null);
    var tableWrapper = Object(react["useMemo"])(function() {
        return view.nodeDOM(pos);
    }, [
        pos,
        view
    ]);
    var _useState = table_extension_slicedToArray$2(Object(react["useState"])(0), 2), scrollLeft = _useState[0], setScrollLeft = _useState[1];
    var getTableInfo = function() {
        if (colBarRef.current) {
            colBarRef.current.scrollLeft = tableWrapper.scrollLeft;
        }
        setScrollLeft(tableWrapper.scrollLeft);
        if (!tableWrapper) return {
            left: 0,
            top: 0,
            width: 0
        };
        var tableRect = tableWrapper.getBoundingClientRect();
        return {
            left: tableRect.left,
            top: tableRect.top,
            width: tableRect.width
        };
    };
    var _useState1 = table_extension_slicedToArray$2(Object(react["useState"])(function() {
        return getTableInfo();
    }), 2), tableInfo = _useState1[0], setTableInfo = _useState1[1];
    var updatePos = function() {
        setTableInfo(getTableInfo());
    };
    Object(react["useEffect"])(function() {
        eventEmitter.on(SYNC_PAGE_SCROLL, updatePos);
        var updatePosTimer = setInterval(updatePos, 100);
        return function() {
            eventEmitter.off(SYNC_PAGE_SCROLL, updatePos);
            clearInterval(updatePosTimer);
            updatePosTimer = null;
        };
    }, [
        tableWrapper
    ]);
    var getTotalColWidth = function() {
        var tableBody = tableWrapper.querySelector("table > tbody");
        if (tableBody) {
            return tableBody.offsetWidth;
        }
        return 0;
    };
    var getEveryColWidth = function() {
        var tableBody = tableWrapper.querySelector("table > tbody");
        var isTableResponsive = isResponsive(view.state);
        return Array.from(tableBody.firstElementChild.children).filter(function(p) {
            return [
                "TH",
                "TD"
            ].includes(p.tagName);
        }).reduce(function(prev, cur) {
            var colspan = Number.parseInt(cur.getAttribute("colspan"), 10) || 1;
            // 单列，没有合并单元格
            if (colspan === 1) {
                return table_extension_toConsumableArray$1(prev).concat([
                    cur.offsetWidth
                ]);
            }
            // 非自适应，非单列表格
            if (!isTableResponsive && cur.getAttribute("data-colwidth")) {
                var colwidths = cur.getAttribute("data-colwidth").split(",").map(function(p) {
                    return Number.parseInt(p, 10);
                });
                return table_extension_toConsumableArray$1(prev).concat(table_extension_toConsumableArray$1(colwidths));
            }
            // 可以处理外部的一些没有data-colwidth属性的表格
            prev = table_extension_toConsumableArray$1(prev).concat(table_extension_toConsumableArray$1(Array.from({
                length: colspan
            }).map(function() {
                return Math.ceil(cur.offsetWidth / colspan);
            })));
            return prev;
        }, []);
    };
    var preventShiftMouseDown = function(e) {
        if (e.shiftKey) e.preventDefault();
    };
    var onSelectCol = function(e, index) {
        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr, dispatch = view.dispatch;
        if (_instanceof$9(selection, cellSelection_CellSelection) && e.shiftKey && selection.isColSelection()) {
            var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
            if (!table) return null;
            var map = TableMap.get(table).map;
            var selectAnchorPos = map[index] + start;
            var tableSelection = cellSelection_CellSelection.colSelection(tr.doc.resolve(selection.$anchorCell.pos), tr.doc.resolve(selectAnchorPos));
            dispatch(tr.setSelection(tableSelection));
            view.focus();
        } else {
            var _ref1 = findTable(selection) || {}, table1 = _ref1.node, start1 = _ref1.start;
            if (!table1) return null;
            var map1 = TableMap.get(table1).map;
            var anchorPos = map1[index] + start1;
            var tableSelection1 = cellSelection_CellSelection.colSelection(tr.doc.resolve(anchorPos));
            dispatch(tr.setSelection(tableSelection1));
            view.focus();
        }
    };
    var getActiveItemRange = function() {
        var _view_state = view.state, sel = _view_state.selection;
        if (_instanceof$9(sel, cellSelection_CellSelection)) {
            return sel.getRect();
        }
        return {
            left: -1,
            right: -1
        };
    };
    var clickAddTip = function(e, idx, dir) {
        e.stopPropagation();
        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr, doc = _view_state.doc, dispatch = view.dispatch;
        var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
        if (!table) return null;
        var _TableMap_get = TableMap.get(table), map = _TableMap_get.map, colCount = _TableMap_get.width, rowCount = _TableMap_get.height;
        var anchorPos = adjustAnchor$1({
            rowCount: rowCount,
            colCount: colCount,
            direction: dir,
            index: idx,
            map: map
        }) + start;
        dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(doc, anchorPos + 2))); // +2是因为<cell><p>
        if (dir === "before") {
            addColumnBefore()(view.state, view.dispatch, view);
        } else {
            addColumnAfter()(view.state, view.dispatch, view);
        }
        view.focus();
    };
    var showAddColBeforeTip = function(idx) {
        var _view_state = view.state, selection = _view_state.selection, doc = _view_state.doc;
        var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
        if (!table) return null;
        var map = TableMap.get(table).map;
        var anchorPos = map[idx] + start;
        return canAddColumnBefore({
            selection: prosemirror_state_dist["TextSelection"].create(doc, anchorPos + 2)
        });
    };
    var colSelectItems = function() {
        var items = [];
        var selection = view.state.selection;
        var node = (findTable(selection) || {}).node;
        if (!node) return null;
        var colWidths = getEveryColWidth();
        var prevTotalWidth = 0;
        var activeRange = getActiveItemRange();
        colWidths.forEach(function(w, idx) {
            var selected = idx >= activeRange.left && idx < activeRange.right;
            items.push(/*#__PURE__*/ react_default.a.createElement("div", {
                key: idx,
                style: {
                    width: "".concat(w, "px")
                },
                className: "".concat(table_extension_classNamePrefix("table-col-selectbar-item")).concat(selected ? " selected" : ""),
                onClick: function(e) {
                    return onSelectCol(e, idx);
                },
                onMouseDown: preventShiftMouseDown
            }, /*#__PURE__*/ react_default.a.createElement(AddTip, {
                dir: "left",
                offset: Math.max(prevTotalWidth, scrollLeft) - scrollLeft - 10,
                onClick: function(e) {
                    return clickAddTip(e, idx, "before");
                },
                visible: function() {
                    return showAddColBeforeTip(idx);
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "visible-area left"
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "btn"
            }))), /*#__PURE__*/ react_default.a.createElement(AddTip, {
                dir: "right",
                offset: Math.min(prevTotalWidth + w - scrollLeft, tableInfo.width) - 10,
                onClick: function(e) {
                    return clickAddTip(e, idx, "after");
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "visible-area right"
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "btn"
            })))));
            prevTotalWidth += w;
        });
        return items;
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        style: {
            position: "fixed",
            top: "".concat(tableInfo.top - 45, "px"),
            left: "".concat(tableInfo.left + 1, "px"),
            width: "".concat(tableInfo.width, "px"),
            pointerEvents: "none"
        }
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-col-selectbar-container")),
        ref: colBarRef,
        style: {
            width: "".concat(tableInfo.width, "px")
        }
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-col-selectbar")),
        style: {
            width: getTotalColWidth()
        }
    }, colSelectItems())));
};

function table_extension_arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithHoles$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof$a(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_iterableToArrayLimit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function table_extension_nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_slicedToArray$3(arr, i) {
    return table_extension_arrayWithHoles$3(arr) || table_extension_iterableToArrayLimit$3(arr, i) || table_extension_unsupportedIterableToArray$4(arr, i) || table_extension_nonIterableRest$3();
}
function table_extension_unsupportedIterableToArray$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray$4(o, minLen);
}
var table_extension_os = table_extension_getSystemInfo().os;
var table_extension_dragCopyModifier = /MAC/.test(table_extension_os.toUpperCase()) ? "altKey" : "ctrlKey";
var AllSelectBar = function(param) {
    var pos = param.pos, view = param.view;
    var tableWrapper = Object(react["useMemo"])(function() {
        return view.nodeDOM(pos);
    }, [
        pos,
        view
    ]);
    var getTableInfo = function() {
        if (!tableWrapper || !tableWrapper.closest(".ct-editor")) {
            return {
                left: 0,
                top: 0,
                width: 0
            };
        }
        var tableRect = tableWrapper.getBoundingClientRect();
        var editorRect = tableWrapper.closest(".ct-editor").getBoundingClientRect();
        return {
            left: tableRect.left - editorRect.left,
            top: tableRect.top - editorRect.top,
            width: tableRect.width
        };
    };
    var _useState = table_extension_slicedToArray$3(Object(react["useState"])(function() {
        return getTableInfo();
    }), 2), tableInfo = _useState[0], setTableInfo = _useState[1];
    Object(react["useEffect"])(function() {
        setTableInfo(getTableInfo());
    }, [
        tableWrapper
    ]);
    var handleClick = function() {
        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr, dispatch = view.dispatch;
        var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
        if (!table) return null;
        var map = TableMap.get(table).map;
        var anchorPos = map[0] + start;
        var headPos = map[map.length - 1] + start;
        var tableSelection = cellSelection_CellSelection.rowSelection(tr.doc.resolve(anchorPos), tr.doc.resolve(headPos));
        dispatch(tr.setSelection(tableSelection));
        view.focus();
    };
    var handleDragStart = function(e) {
        var _view_state = view.state, selection = _view_state.selection, tr = _view_state.tr, dispatch = view.dispatch;
        tableWrapper.setAttribute("style", "opacity: 0.9;");
        e.dataTransfer.setDragImage(tableWrapper, 0, 0);
        var mouseDown = view.mouseDown;
        mouseDown === null || mouseDown === void 0 ? void 0 : mouseDown.done();
        var _ref = findTable(selection) || {}, table = _ref.node, start = _ref.start;
        var newSelection = prosemirror_state_dist["NodeSelection"].create(view.state.doc, start - 1);
        var slice = newSelection.content();
        var map = TableMap.get(table).map;
        var anchorPos = map[0] + start;
        var headPos = map[map.length - 1] + start;
        var tableSelection = cellSelection_CellSelection.rowSelection(tr.doc.resolve(anchorPos), tr.doc.resolve(headPos));
        view.dragging = {
            slice: slice,
            move: !e[table_extension_dragCopyModifier],
            tableSelection: tableSelection
        };
        dispatch(tr.setSelection(newSelection));
    };
    var _view_state = view.state, sel = _view_state.selection;
    var selected = _instanceof$a(sel, cellSelection_CellSelection) && sel.isWholeSelection();
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-all-selectbar-container")),
        style: {
            top: "".concat(tableInfo.top - 18, "px"),
            left: "".concat(tableInfo.left - 18, "px")
        },
        draggable: true,
        onDragStart: handleDragStart,
        onClick: handleClick
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-all-selectbar"))
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "btn".concat(selected ? " selected" : "")
    })));
};

function table_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var table_extension_TableLayoutView = /*#__PURE__*/ function() {
    function TableLayoutView(editorView, provider, eventEmitter) {
        var _this = this;
        table_extension_classCallCheck$2(this, TableLayoutView);
        /**
   * 此函数处理pluginview update不能覆盖的一个特殊场景，即比如图片加载完成导致的表格高度变化此时的选择条更新
   * 详见https://ones.sankuai.com/ones/product/1859/workItem/task/detail/21026880
   */ this.updateSelectBarWhenTableHeightChange = function() {
            var selection = _this.editorView.state.selection;
            var curCursorInTable = findTable(selection);
            if (curCursorInTable) {
                _this.displaySelectBar(curCursorInTable.pos, _this.editorView);
            }
        };
        this.hideSelectBar = function() {
            Object(react_dom["render"])(null, _this.colPortal);
            Object(react_dom["render"])(null, _this.rowPortal);
            Object(react_dom["render"])(null, _this.allPortal);
        };
        this.editorView = editorView;
        this.provider = provider;
        this.eventEmitter = eventEmitter;
        this.addPortalLayoutNode();
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.on(TABLE_HEIGHT_CHANGE, this.updateSelectBarWhenTableHeightChange);
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.on(TABLE_COLUMN_RESIZE, this.hideSelectBar);
    }
    var _proto = TableLayoutView.prototype;
    _proto.addPortalLayoutNode = function addPortalLayoutNode() {
        // 表格列选择条
        this.colPortal = document.createElement("div");
        this.colPortal.className = table_extension_classNamePrefix("table-col-selectbar-layout");
        this.editorView.dom.parentNode.appendChild(this.colPortal);
        // 表格行选择条
        this.rowPortal = document.createElement("div");
        this.rowPortal.className = table_extension_classNamePrefix("table-row-selectbar-layout");
        this.editorView.dom.parentNode.appendChild(this.rowPortal);
        // 表格全选圆点
        this.allPortal = document.createElement("div");
        this.allPortal.className = table_extension_classNamePrefix("table-all-selectbar-layout");
        this.editorView.dom.parentNode.appendChild(this.allPortal);
    };
    _proto.update = function update(view, prevState) {
        var selection = view.state.selection;
        var curCursorInTable = findTable(selection);
        var prevCursorInTable = findTable(prevState.selection);
        if (!curCursorInTable) {
            if (this.selectBarDisplayed()) {
                this.hideSelectBar();
            }
            return false;
        }
        if (!this.selectBarDisplayed() || !prevCursorInTable || curCursorInTable.node.attrs.dataDiffId !== prevCursorInTable.node.attrs.dataDiffId) {
            this.displaySelectBar(curCursorInTable.pos, view);
        }
    };
    _proto.selectBarDisplayed = function selectBarDisplayed() {
        var _this_colPortal, _this_rowPortal, _this_allPortal;
        return ((_this_colPortal = this.colPortal) === null || _this_colPortal === void 0 ? void 0 : _this_colPortal.querySelector(".".concat(table_extension_classNamePrefix("table-col-selectbar")))) || ((_this_rowPortal = this.rowPortal) === null || _this_rowPortal === void 0 ? void 0 : _this_rowPortal.querySelector(".".concat(table_extension_classNamePrefix("table-row-selectbar")))) || ((_this_allPortal = this.allPortal) === null || _this_allPortal === void 0 ? void 0 : _this_allPortal.querySelector(".".concat(table_extension_classNamePrefix("table-all-selectbar"))));
    };
    _proto.displaySelectBar = function displaySelectBar(pos, view) {
        // pos 作为 key，否则 component 仅 update，数据会异常
        Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(ColSelectBar, {
            key: pos,
            pos: pos,
            view: view,
            eventEmitter: this.eventEmitter
        }), this.colPortal);
        Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(RowSelectBar, {
            key: pos,
            pos: pos,
            view: view
        }), this.rowPortal);
        Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(AllSelectBar, {
            key: pos,
            pos: pos,
            view: view
        }), this.allPortal);
    };
    _proto.destroy = function destroy() {
        var eventEmitter = this.eventEmitter;
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.off(TABLE_HEIGHT_CHANGE, this.updateSelectBarWhenTableHeightChange);
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.off(TABLE_COLUMN_RESIZE, this.hideSelectBar);
        this.hideSelectBar();
    };
    return TableLayoutView;
}();

var table_extension_css_248z$1 = ".ct-table-row-selectbar-container{position:absolute;z-index:3}.ct-table-row-selectbar-container .ct-table-row-selectbar{height:100%;width:26px}.ct-table-row-selectbar-container .ct-table-row-selectbar-item{cursor:pointer}.ct-table-row-selectbar-container .ct-table-row-selectbar-item .visible-area{padding-left:8px;width:100%;height:100%}.ct-table-row-selectbar-container .ct-table-row-selectbar-item .visible-area.bottom .btn{border-bottom:1px solid #ddd}.ct-table-row-selectbar-container .ct-table-row-selectbar-item .visible-area .btn{height:100%;width:10px;background-color:#eee}.ct-table-row-selectbar-container .ct-table-row-selectbar-item:last-child .visible-area.bottom .btn{border-bottom:none}.ct-table-row-selectbar-container .ct-table-row-selectbar-item:hover .btn{background-color:#ccc}.ct-table-row-selectbar-container .ct-table-row-selectbar-item.selected .visible-area .btn{background-color:rgba(0,167,205,.2)}.ct-table-all-selectbar-container{position:absolute;z-index:3}.ct-table-all-selectbar-container .ct-table-all-selectbar{height:16px;width:16px;cursor:-webkit-grab;cursor:grab}.ct-table-all-selectbar-container .ct-table-all-selectbar .btn{width:10px;height:10px;border-radius:100%;background-color:#eee}.ct-table-all-selectbar-container .ct-table-all-selectbar .btn.selected{background-color:rgba(0,167,205,.2)}.ct-table-col-selectbar-container{overflow:hidden;z-index:3;height:45px}.ct-table-col-selectbar-container .ct-table-col-selectbar{height:26px;margin-top:19px;display:flex;overflow:hidden}.ct-table-col-selectbar-container .ct-table-col-selectbar-item{float:left;cursor:pointer;pointer-events:auto}.ct-table-col-selectbar-container .ct-table-col-selectbar-item .visible-area{padding-top:8px;width:100%;height:100%}.ct-table-col-selectbar-container .ct-table-col-selectbar-item .visible-area.right .btn{border-right:1px solid #ddd}.ct-table-col-selectbar-container .ct-table-col-selectbar-item .visible-area .btn{height:10px;width:100%;background-color:#eee}.ct-table-col-selectbar-container .ct-table-col-selectbar-item:last-child .visible-area.bottom .btn{border-right:none}.ct-table-col-selectbar-container .ct-table-col-selectbar-item:hover .btn{background-color:#ccc}.ct-table-col-selectbar-container .ct-table-col-selectbar-item.selected .visible-area .btn{background-color:rgba(0,167,205,.2)}";
table_extension_styleInject(table_extension_css_248z$1);

function _defineProperty$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$7(target, key, source[key]);
        });
    }
    return target;
}
function tableLayout(provider, param) {
    var editorEventEmitter = param.editorEventEmitter;
    return new prosemirror_state_dist["Plugin"]({
        key: tableLayoutKey,
        state: {
            init: function init() {
                return {
                    tableInfo: null,
                    tableLayoutKey: false
                };
            },
            apply: function apply(tr, value) {
                var newValue = tr.getMeta(this);
                return _objectSpread$7({}, value, newValue);
            }
        },
        view: function view(editorView) {
            return new table_extension_TableLayoutView(editorView, provider, editorEventEmitter);
        }
    });
}

var table_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(table_extension_ExtensionType || (table_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var table_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var table_extension_isInTable = function($container) {
    var $outer = $container.parentNode;
    var tagName = $outer.tagName.toUpperCase();
    return tagName === "TD" || tagName === "TH";
};
// 判断选区或者光标是否在目标节点内
function isInTarget(state, targetNode) {
    var $anchor = state.selection.$anchor;
    for(var d = $anchor.depth; d > 0; d--){
        if ($anchor.node(d).eq(targetNode)) return true;
    }
    return false;
}

var table_extension_css_248z$2 = ".ct-table-headerbar-container .ct-table-headerbar{position:fixed;z-index:500}.ct-table-headerbar-container .ct-table-headerbar .ct-table-wrapper{padding:0!important;margin:0!important;overflow:hidden}.ct-table-headerbar-container .ct-table-headerbar .ct-table-wrapper .column-resize-handler{display:none}.ct-table-headerbar-container * ::-moz-selection{background:rgba(46,170,220,.2)!important}.ct-table-headerbar-container * ::selection{background:rgba(46,170,220,.2)!important}";
table_extension_styleInject(table_extension_css_248z$2);

function table_extension_arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithHoles$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function table_extension_iterableToArrayLimit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function table_extension_nonIterableRest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function table_extension_slicedToArray$4(arr, i) {
    return table_extension_arrayWithHoles$4(arr) || table_extension_iterableToArrayLimit$4(arr, i) || table_extension_unsupportedIterableToArray$5(arr, i) || table_extension_nonIterableRest$4();
}
function table_extension_unsupportedIterableToArray$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray$5(o, minLen);
}
var HeaderBar = function(param) {
    var $tableWrapper = param.$tableWrapper, provider = param.provider, view = param.view;
    // 存
    var containerRef = Object(react["useRef"])(null);
    var tableDOMRef = Object(react["useRef"])(null);
    var tbodyDOMRef = Object(react["useRef"])(null);
    var firstRowDOMRef = Object(react["useRef"])(null);
    // 初始化相关 DOM
    Object(react["useEffect"])(function() {
        var $table = $tableWrapper.querySelector("table");
        tableDOMRef.current = $table;
        var $tbody = $table.querySelector("tbody");
        tbodyDOMRef.current = $tbody;
        var $firstRow = $tbody && $tbody.querySelector("tr");
        firstRowDOMRef.current = $firstRow;
    }, [
        $tableWrapper
    ]);
    // 同步表头位置
    var wrapperDOMRef = Object(react["useRef"])(null);
    var syncPosition = function() {
        if (!containerRef.current) {
            return;
        }
        var topBias = provider.getTopBias();
        var left = tableDOMRef.current.getBoundingClientRect().left;
        var scrollLeft = $tableWrapper.scrollLeft;
        containerRef.current.style.left = "".concat(scrollLeft + left, "px");
        containerRef.current.style.top = "".concat(topBias, "px");
        containerRef.current.style.width = "".concat($tableWrapper.clientWidth, "px");
        if (wrapperDOMRef.current) {
            wrapperDOMRef.current.scrollLeft = scrollLeft;
        }
    };
    // 创建表头DOM元素
    var createHeaderDOMs = function() {
        if (!containerRef.current) {
            return;
        }
        var $table = tableDOMRef.current;
        var scrollLeft = $tableWrapper.scrollLeft;
        var headerBarTableDOM = $table.cloneNode();
        headerBarTableDOM.className = "";
        headerBarTableDOM.style.width = "".concat($table.clientWidth, "px");
        var headerColgroupDOM = $table.firstElementChild.cloneNode(true);
        var colDOMs = [];
        var rowDOM = $table.lastElementChild.children[0];
        for(var i = 0; i < rowDOM.childElementCount; i++){
            var cellDOM = rowDOM.children[i];
            var colspan = parseInt(cellDOM.getAttribute("colspan"), 10) || 1;
            var cellWidth = cellDOM.getBoundingClientRect().width / colspan;
            for(var j = 0; j < colspan; j++){
                colDOMs.push({
                    cellWidth: cellWidth
                });
            }
        }
        if (headerColgroupDOM.childNodes.length === 0) {
            colDOMs.forEach(function(col) {
                var cellWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
                headerColgroupDOM.appendChild(document.createElement("col")).style.width = "".concat(cellWidth, "px");
            });
        }
        var headerTbodyDOM = document.createElement("tbody");
        var wrapperDOM = document.createElement("div");
        wrapperDOM.className = table_extension_classNamePrefix("table-wrapper");
        var $firstRow = firstRowDOMRef.current;
        var tableHeader = $firstRow.cloneNode(true);
        headerTbodyDOM.appendChild(tableHeader);
        headerBarTableDOM.appendChild(headerColgroupDOM);
        headerBarTableDOM.appendChild(headerTbodyDOM);
        wrapperDOM.appendChild(headerBarTableDOM);
        containerRef.current.innerHTML = "";
        containerRef.current.appendChild(wrapperDOM);
        wrapperDOM.scrollLeft = scrollLeft;
        wrapperDOMRef.current = wrapperDOM;
    };
    var _useState = table_extension_slicedToArray$4(Object(react["useState"])({
        left: 0,
        topBias: 0,
        tableWidth: 0,
        tableWrapperWidth: 0
    }), 2), sizes = _useState[0], setSizes = _useState[1];
    var topBias = sizes.topBias, left = sizes.left, tableWrapperWidth = sizes.tableWrapperWidth, tableWidth = sizes.tableWidth;
    // 监听位置相关参数的变化 执行同步位置
    var isMountedRef = Object(react["useRef"])(false);
    Object(react["useEffect"])(function() {
        var animationId = null;
        // 更新的时候才执行
        if (isMountedRef.current) {
            animationId = window.requestAnimationFrame(function() {
                syncPosition();
            });
        } else {
            isMountedRef.current = true;
        }
        return function() {
            window.cancelAnimationFrame(animationId);
        };
    }, [
        topBias,
        left,
        tableWrapperWidth
    ]);
    // 通过监听宽度,判断增删列的情况进行重新创建 DOM, 初始化时会执行一次
    Object(react["useEffect"])(function() {
        var animationId = window.requestAnimationFrame(function() {
            syncPosition();
            createHeaderDOMs();
        });
        return function() {
            window.cancelAnimationFrame(animationId);
        };
    }, [
        tableWidth
    ]);
    // 监听表格左右滚动 同步位置
    Object(react["useEffect"])(function() {
        var animationId = null;
        var handleScroll = function() {
            if (animationId) {
                window.cancelAnimationFrame(animationId);
            }
            animationId = window.requestAnimationFrame(function() {
                syncPosition();
            });
        };
        $tableWrapper.addEventListener("scroll", handleScroll);
        return function() {
            $tableWrapper.removeEventListener("scroll", handleScroll);
        };
    }, []);
    // 同步相关位置参数
    var refresh = function() {
        var _tableDOMRef_current_getBoundingClientRect, _tableDOMRef_current;
        setSizes({
            left: (_tableDOMRef_current_getBoundingClientRect = (_tableDOMRef_current = tableDOMRef.current) === null || _tableDOMRef_current === void 0 ? void 0 : _tableDOMRef_current.getBoundingClientRect()) === null || _tableDOMRef_current_getBoundingClientRect === void 0 ? void 0 : _tableDOMRef_current_getBoundingClientRect.left,
            topBias: provider.getTopBias(),
            tableWidth: tableDOMRef.current.clientWidth,
            tableWrapperWidth: $tableWrapper === null || $tableWrapper === void 0 ? void 0 : $tableWrapper.clientWidth
        });
    };
    // 隔一定时间检测 同步相关位置参数
    Object(react["useEffect"])(function() {
        refresh();
        var refreshTimer = setInterval(refresh, 50);
        return function() {
            clearInterval(refreshTimer);
            refreshTimer = null;
        };
    }, []);
    var handleDoubleClick = function(e) {
        var headerDOM = e.target.closest("th");
        if (headerDOM) {
            var state = view.state, dispatch = view.dispatch;
            var tr = state.tr;
            var index = Array.from(headerDOM.parentElement.children).indexOf(headerDOM);
            var trueDOM = tableDOMRef.current.lastElementChild.firstElementChild.cells[index];
            var pos = view.posAtDOM(trueDOM, null);
            if (provider.getTopBias && provider.getScrollWrapper) {
                provider.getScrollWrapper().scrollTop -= provider.getTopBias() - trueDOM.getBoundingClientRect().top;
            }
            dispatch(tr.setSelection(prosemirror_state_dist["TextSelection"].create(state.tr.doc, pos - 1)));
            view.focus();
        }
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-headerbar")),
        ref: containerRef,
        onDoubleClick: handleDoubleClick
    });
};

function table_extension_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var HEADER_BAR_UPDATE_DEBOUNCE_TIME = 16;
var table_extension_StickyHeaderView = /*#__PURE__*/ function() {
    function StickyHeaderView(editorView, provider, eventEmitter) {
        var _this = this;
        table_extension_classCallCheck$3(this, StickyHeaderView);
        // 解决表头高度超过一页时无法滚动的问题
        this.handleMouseWheel = function(e) {
            var isInCloneHeader = e.target.closest(".".concat(table_extension_classNamePrefix("table-headerbar")));
            if (!isInCloneHeader) return;
            var direct = 0;
            if (e.wheelDelta) {
                direct = e.wheelDelta > 0 ? 1 : -1;
            } else if (e.detail) {
                direct = e.detail > 0 ? 1 : -1;
            }
            if (direct !== 0) {
                if (direct === 1) {
                    _this.scrollWrapper.scrollTop -= 7;
                } else {
                    _this.scrollWrapper.scrollTop += 7;
                }
            }
        };
        this.handlePageScroll = function() {
            var _this_eventEmitter;
            (_this_eventEmitter = _this.eventEmitter) === null || _this_eventEmitter === void 0 ? void 0 : _this_eventEmitter.emit(SYNC_PAGE_SCROLL);
            _this.updateHeaderBar();
        };
        this.findTableNode = function() {
            var res = null;
            var _this_view_state = _this.view.state, doc = _this_view_state.doc, _this_view_state_schema = _this_view_state.schema, table = _this_view_state_schema.nodes.table;
            var topBias = _this.provider.getTopBias();
            doc.descendants(function(item, pos) {
                if (item.type === table) {
                    var $tableWrapper = _this.view.nodeDOM(pos);
                    if (!$tableWrapper) return;
                    var tableClientRect = $tableWrapper.getBoundingClientRect();
                    var $firstRow = $tableWrapper.querySelector("tr");
                    if (!$firstRow) return;
                    if (hasRowHeader(item) && tableClientRect.top < topBias && tableClientRect.bottom > topBias + $firstRow.clientHeight) {
                        // 嵌套在表格里的表格只有光标在内部的时候才会有浮动表头
                        if (table_extension_isInTable($tableWrapper)) {
                            if (isInTarget(_this.view.state, item)) {
                                res = {
                                    node: item,
                                    pos: pos,
                                    $tableWrapper: $tableWrapper
                                };
                            }
                        } else {
                            res = {
                                node: item,
                                pos: pos,
                                $tableWrapper: $tableWrapper
                            };
                        }
                    }
                }
            });
            return res;
        };
        this.showHeaderBar = function(param) {
            var $tableWrapper = param.$tableWrapper;
            Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(HeaderBar, {
                $tableWrapper: $tableWrapper,
                provider: _this.provider,
                view: _this.view
            }), document.querySelector(".".concat(table_extension_classNamePrefix("table-headerbar-container"))));
        };
        this.hideHeaderBar = function() {
            var container = document.querySelector(".".concat(table_extension_classNamePrefix("table-headerbar-container")));
            if (container) {
                Object(react_dom["render"])(null, container);
            }
        };
        this.updateHeaderBar = lodash_throttle_default()(function() {
            var curTableInfo = _this.findTableNode();
            if (curTableInfo) {
                if (!_this.tableInfo || !_this.tableInfo.node.eq(curTableInfo.node)) {
                    _this.showHeaderBar(curTableInfo);
                }
            }
            if (!curTableInfo && _this.tableInfo) {
                _this.hideHeaderBar();
            }
            _this.tableInfo = curTableInfo;
        }, HEADER_BAR_UPDATE_DEBOUNCE_TIME);
        this.view = editorView;
        this.provider = provider;
        this.eventEmitter = eventEmitter;
        this.headerBar = document.createElement("div");
        this.headerBar.className = table_extension_classNamePrefix("table-headerbar-container");
        this.view.dom.parentNode.insertBefore(this.headerBar, this.view.dom);
        this.scrollWrapper = this.provider.getScrollWrapper();
        if (this.scrollWrapper) {
            this.scrollWrapper.addEventListener("scroll", this.handlePageScroll);
            this.scrollWrapper.addEventListener("mousewheel", this.handleMouseWheel);
            // 嵌套表格点击切换触发
            document.addEventListener("click", this.updateHeaderBar);
        }
    }
    var _proto = StickyHeaderView.prototype;
    _proto.destroy = function destroy() {
        var _this_updateHeaderBar, _this_updateHeaderBar_cancel;
        this.hideHeaderBar();
        (_this_updateHeaderBar = this.updateHeaderBar) === null || _this_updateHeaderBar === void 0 ? void 0 : (_this_updateHeaderBar_cancel = _this_updateHeaderBar.cancel) === null || _this_updateHeaderBar_cancel === void 0 ? void 0 : _this_updateHeaderBar_cancel.call(_this_updateHeaderBar);
        if (this.scrollWrapper) {
            this.scrollWrapper.removeEventListener("scroll", this.handlePageScroll);
            this.scrollWrapper.removeEventListener("mousewheel", this.handleMouseWheel);
            document.removeEventListener("click", this.updateHeaderBar);
        }
    };
    return StickyHeaderView;
}();

function stickyHeader(provider, param) {
    var editorEventEmitter = param.editorEventEmitter;
    return new prosemirror_state_dist["Plugin"]({
        key: stickyHeaderKey,
        props: {},
        view: function view(editorView) {
            return new table_extension_StickyHeaderView(editorView, provider, editorEventEmitter);
        }
    });
}

var table_extension_css_248z$3 = ".ct-table-scrollbar-container{position:fixed;z-index:19}.ct-table-scrollbar-container .ct-table-scrollbar{height:15px;overflow-x:auto;overflow-y:hidden}.ct-table-scrollbar-container .ct-table-scrollbar .inner{border:1px solid transparent}";
table_extension_styleInject(table_extension_css_248z$3);

function table_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function table_extension_getPrototypeOf(o) {
    table_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf(o);
}
function table_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf(subClass, superClass);
}
function table_extension_possibleConstructorReturn(self, call) {
    if (call && (table_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized(self);
}
function table_extension_setPrototypeOf(o, p) {
    table_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf(o, p);
}
var table_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn(this, result);
    };
}
var table_extension_ScrollBar = /*#__PURE__*/ function(Component) {
    table_extension_inherits(ScrollBar, Component);
    var _super = table_extension_createSuper(ScrollBar);
    function ScrollBar() {
        table_extension_classCallCheck$4(this, ScrollBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleScroll = function() {
            var $tableWrapper = _this.props.$tableWrapper;
            var scrollLeft = _this.scrollBar.scrollLeft;
            if ($tableWrapper.scrollLeft !== scrollLeft) {
                $tableWrapper.scrollLeft = scrollLeft;
            }
        };
        _this.handleTableScroll = function() {
            var scrollBar = table_extension_assertThisInitialized(_this).scrollBar;
            var $tableWrapper = _this.props.$tableWrapper;
            var scrollLeft = $tableWrapper.scrollLeft;
            if (scrollBar.scrollLeft !== scrollLeft) {
                scrollBar.scrollLeft = scrollLeft;
            }
        };
        return _this;
    }
    var _proto = ScrollBar.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var $tableWrapper = this.props.$tableWrapper;
        this.scrollBar.scrollLeft = $tableWrapper.scrollLeft;
        this.scrollBar.onscroll = this.handleScroll;
        $tableWrapper.addEventListener("scroll", this.handleTableScroll);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.scrollBar.onscroll = null;
        var $tableWrapper = this.props.$tableWrapper;
        $tableWrapper.removeEventListener("scroll", this.handleTableScroll);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var $tableWrapper = this.props.$tableWrapper;
        var scrollLeft = $tableWrapper.scrollLeft;
        if (this.scrollBar.scrollLeft !== scrollLeft) {
            this.scrollBar.scrollLeft = scrollLeft;
        }
        if (prevProps.$tableWrapper !== $tableWrapper) {
            var // fix: Cannot read properties of null (reading 'scrollLeft')
            // @see https://km.sankuai.com/collabpage/1353433541
            _prevProps_$tableWrapper;
            (_prevProps_$tableWrapper = prevProps.$tableWrapper) === null || _prevProps_$tableWrapper === void 0 ? void 0 : _prevProps_$tableWrapper.removeEventListener("scroll", this.handleTableScroll);
            $tableWrapper.addEventListener("scroll", this.handleTableScroll);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var $tableWrapper = this.props.$tableWrapper;
        var containerWidth = $tableWrapper.clientWidth;
        var tableWidth = $tableWrapper.querySelector("table").getBoundingClientRect().width;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: table_extension_classNamePrefix("table-scrollbar"),
            style: {
                width: "".concat(containerWidth, "px")
            },
            ref: function(refs) {
                _this.scrollBar = refs;
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "inner",
            style: {
                width: "".concat(tableWidth + 2, "px")
            }
        }));
    };
    return ScrollBar;
}(react["Component"]);

function table_extension_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var SCROLL_BAR_UPDATE_DEBOUNCE_TIME = 16;
var table_extension_ScrollBarView = /*#__PURE__*/ function() {
    function ScrollBarView(editorView, provider) {
        var _this = this;
        table_extension_classCallCheck$5(this, ScrollBarView);
        this.updateScrollBar = lodash_throttle_default()(function() {
            var _this_view_dom, _this_view_dom_parentNode, _this_view_dom_parentNode_querySelectorAll;
            var tableDOMs = Array.from(((_this_view_dom = _this.view.dom) === null || _this_view_dom === void 0 ? void 0 : (_this_view_dom_parentNode = _this_view_dom.parentNode) === null || _this_view_dom_parentNode === void 0 ? void 0 : (_this_view_dom_parentNode_querySelectorAll = _this_view_dom_parentNode.querySelectorAll) === null || _this_view_dom_parentNode_querySelectorAll === void 0 ? void 0 : _this_view_dom_parentNode_querySelectorAll.call(_this_view_dom_parentNode, ".".concat(table_extension_classNamePrefix("table-wrapper")))) || []).filter(function(tableDOM) {
                return !tableDOM.closest(".".concat(table_extension_classNamePrefix("collapse"), ":not(.active)"));
            });
            var res = tableDOMs.some(function(tableDOM) {
                return _this.toggleScrollBar(tableDOM);
            });
            if (!res) {
                _this.hideScrollBar();
            }
        }, SCROLL_BAR_UPDATE_DEBOUNCE_TIME);
        this.toggleScrollBar = function($tableWrapper) {
            var _$tableWrapper_querySelector, _$tableWrapper_querySelector_getBoundingClientRect;
            var bottomBias = _this.provider.getBottomBias ? _this.provider.getBottomBias() : -20;
            var isOutTable = $tableWrapper && !$tableWrapper.closest("table");
            if (!isOutTable) return false;
            var tableRect = (_$tableWrapper_querySelector = $tableWrapper.querySelector("table")) === null || _$tableWrapper_querySelector === void 0 ? void 0 : (_$tableWrapper_querySelector_getBoundingClientRect = _$tableWrapper_querySelector.getBoundingClientRect) === null || _$tableWrapper_querySelector_getBoundingClientRect === void 0 ? void 0 : _$tableWrapper_querySelector_getBoundingClientRect.call(_$tableWrapper_querySelector);
            if (!tableRect) {
                return false;
            }
            var tableLeft = tableRect.left + $tableWrapper.scrollLeft;
            var tableBottom = window.innerHeight - tableRect.bottom;
            var containerWidth = $tableWrapper.clientWidth;
            var tableWidth = tableRect.width;
            // 满足滚动条件
            if (containerWidth < tableWidth && tableRect.top + bottomBias + 10 < window.innerHeight && tableBottom < bottomBias + 10) {
                var $container = document.querySelector(".".concat(table_extension_classNamePrefix("table-scrollbar-container")));
                $container.style.left = "".concat(tableLeft, "px");
                $container.style.bottom = "".concat(bottomBias, "px");
                _this.$tableWrapper = $tableWrapper;
                _this.tableWidth = tableWidth;
                _this.showScrollBar($tableWrapper);
                return true;
            }
            return false;
        };
        this.showScrollBar = function($tableWrapper) {
            Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(table_extension_ScrollBar, {
                $tableWrapper: $tableWrapper,
                provider: _this.provider,
                view: _this.view
            }), document.querySelector(".".concat(table_extension_classNamePrefix("table-scrollbar-container"))));
        };
        this.hideScrollBar = function() {
            _this.$tableWrapper = null;
            _this.tableWidth = 0;
            var container = document.querySelector(".".concat(table_extension_classNamePrefix("table-scrollbar-container")));
            if (container) {
                Object(react_dom["render"])(null, container);
            }
        };
        this.view = editorView;
        this.provider = provider;
        this.scrollBar = document.createElement("div");
        this.scrollBar.className = table_extension_classNamePrefix("table-scrollbar-container");
        this.view.dom.parentNode.insertBefore(this.scrollBar, this.view.dom);
        this.scrollWrapper = this.provider.getScrollWrapper();
        this.updateScrollBar();
        if (this.scrollWrapper) {
            this.scrollWrapper.addEventListener("scroll", this.updateScrollBar);
            // 嵌套表格点击切换触发
            document.addEventListener("click", this.updateScrollBar);
        }
    }
    var _proto = ScrollBarView.prototype;
    _proto.update = function update() {
        if (this.$tableWrapper && this.$tableWrapper.querySelector("table").getBoundingClientRect().width !== this.tableWidth) {
            this.updateScrollBar();
        }
    };
    _proto.destroy = function destroy() {
        var _this_updateScrollBar, _this_updateScrollBar_cancel;
        this.hideScrollBar();
        (_this_updateScrollBar = this.updateScrollBar) === null || _this_updateScrollBar === void 0 ? void 0 : (_this_updateScrollBar_cancel = _this_updateScrollBar.cancel) === null || _this_updateScrollBar_cancel === void 0 ? void 0 : _this_updateScrollBar_cancel.call(_this_updateScrollBar);
        if (this.scrollWrapper) {
            this.scrollWrapper.removeEventListener("scroll", this.updateScrollBar);
            document.removeEventListener("click", this.updateScrollBar);
        }
    };
    return ScrollBarView;
}();

/**
 * 横向滚动条插件，在 windows 或接入鼠标的情况下，方便将表格横向滚动
 */ function scrollBar(provider) {
    return new prosemirror_state_dist["Plugin"]({
        key: scrollBarKey,
        props: {},
        view: function view(editorView) {
            return new table_extension_ScrollBarView(editorView, provider);
        }
    });
}

var table_extension_css_248z$4 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
table_extension_styleInject(table_extension_css_248z$4);

function table_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_getPrototypeOf$1(o) {
    table_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf$1(o);
}
function table_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf$1(subClass, superClass);
}
function table_extension_possibleConstructorReturn$1(self, call) {
    if (call && (table_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized$1(self);
}
function table_extension_setPrototypeOf$1(o, p) {
    table_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf$1(o, p);
}
var table_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn$1(this, result);
    };
}
var table_extension_Button = /*#__PURE__*/ function(Component) {
    table_extension_inherits$1(Button, Component);
    var _super = table_extension_createSuper$1(Button);
    function Button() {
        table_extension_classCallCheck$6(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = table_extension_classNamePrefix(prefix);
        var classes = _defineProperty$8({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ react_default.a.createElement("button", {
            disabled: disabled,
            className: classnames_default()(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(react["Component"]);

var table_extension_css_248z$5 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
table_extension_styleInject(table_extension_css_248z$5);

/* eslint-disable jsx-a11y/control-has-associated-label */ function table_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function table_extension_getPrototypeOf$2(o) {
    table_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf$2(o);
}
function table_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf$2(subClass, superClass);
}
function table_extension_possibleConstructorReturn$2(self, call) {
    if (call && (table_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized$2(self);
}
function table_extension_setPrototypeOf$2(o, p) {
    table_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf$2(o, p);
}
var table_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn$2(this, result);
    };
}
var table_extension_defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var table_extension_Modal = /*#__PURE__*/ function(Component) {
    table_extension_inherits$2(Modal, Component);
    var _super = table_extension_createSuper$2(Modal);
    function Modal() {
        table_extension_classCallCheck$7(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? "确定" : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? "取消" : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = table_extension_classNamePrefix(userPrefix);
        return /*#__PURE__*/ react_dom_default.a.createPortal(/*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: table_extension_defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ react_default.a.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ react_default.a.createElement(table_extension_Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ react_default.a.createElement(table_extension_Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(react["Component"]);
table_extension_Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var table_extension_colors = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

function table_extension_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function table_extension_getPrototypeOf$3(o) {
    table_extension_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf$3(o);
}
function table_extension_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf$3(subClass, superClass);
}
function table_extension_possibleConstructorReturn$3(self, call) {
    if (call && (table_extension_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized$3(self);
}
function table_extension_setPrototypeOf$3(o, p) {
    table_extension_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf$3(o, p);
}
var table_extension_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper$3(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn$3(this, result);
    };
}
var table_extension_PopItem = /*#__PURE__*/ function(Component) {
    table_extension_inherits$3(PopItem, Component);
    var _super = table_extension_createSuper$3(PopItem);
    function PopItem() {
        table_extension_classCallCheck$8(this, PopItem);
        return _super.apply(this, arguments);
    }
    var _proto = PopItem.prototype;
    _proto.render = function render() {
        var _this_props = this.props, type = _this_props.type, defaultColor = _this_props.defaultColor, onSelect = _this_props.onSelect, selectedColor = _this_props.selectedColor;
        var colorGrids = table_extension_colors.map(function(color, index) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: color,
                onClick: function() {
                    return onSelect(color);
                },
                className: classnames_default()(table_extension_classNamePrefix("table-color-grid"), {
                    selected: selectedColor === color,
                    "has-margin": index >= 10 && index < 20
                }),
                style: {
                    background: color
                }
            });
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            "data-action": "".concat(type, "-color"),
            className: "".concat(table_extension_classNamePrefix("table-color-popover"))
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            onClick: function() {
                return onSelect(defaultColor);
            },
            className: "default"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            style: {
                background: defaultColor,
                borderColor: defaultColor
            },
            className: "color-grid"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "text"
        }, "恢复默认")), colorGrids);
    };
    return PopItem;
}(react["Component"]);

var table_extension_css_248z$6 = '.ct-table-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:246px;font-size:12px;cursor:pointer;transition:all .2s ease}.ct-table-color-popover-wrapper .color-block{display:flex;justify-content:flex-start;align-items:baseline;width:246px;height:24px;padding:6px 8px;border:1px solid #ddd;border-radius:2px}.ct-table-color-popover-wrapper .color-block .left{width:100%;height:100%;margin-right:10px}.ct-table-color-popover-wrapper .color-block .right{width:14px;height:100%;background:url("data:image/svg+xml,%3Csvg width%3D%227px%22 height%3D%224px%22 viewBox%3D%220 0 7 4%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%2220%E3%80%81%E5%AF%8C%E6%96%87%E6%9C%AC%E7%BC%96%E8%BE%91%22 transform%3D%22translate(-521.000000%2C -82.000000)%22 fill%3D%22%23AEAEAE%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 56.000000)%22%3E                %3Cg id%3D%22Group-8%22 transform%3D%22translate(258.500000%2C 15.000000)%22%3E                    %3Cg id%3D%22%E5%AD%97%E5%8F%B7%22 transform%3D%22translate(223.000000%2C 0.000000)%22%3E                        %3Cpolygon id%3D%22%E5%BD%A2%E7%8A%B6_32%22 points%3D%2240 11.5 46 11.5 43 14.5%22%3E%3C%2Fpolygon%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-table-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-table-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.ct-table-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.ct-table-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.ct-table-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.ct-table-color-grid:nth-child(2),.ct-table-color-grid:nth-child(12){border:1px solid #eee}.ct-table-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-table-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.ct-table-color-grid:hover:nth-child(2),.ct-table-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}.ct-table-color-grid:hover:nth-child(2){box-shadow:0 0 0 2px #fff}.ct-table-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.ct-table-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.ct-table-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.ct-table-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.ct-table-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.ct-table-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.ct-table-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.ct-table-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.ct-table-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.ct-table-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.ct-table-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.ct-table-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.ct-table-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.ct-table-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.ct-table-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.ct-table-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.ct-table-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.ct-table-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.ct-table-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.ct-table-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.ct-table-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.ct-table-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.ct-table-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.ct-table-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.ct-table-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.ct-table-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.ct-table-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.ct-table-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.ct-table-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.ct-table-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.ct-table-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.ct-table-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.ct-table-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.ct-table-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.ct-table-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.ct-table-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.ct-table-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.ct-table-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.ct-table-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.ct-table-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.ct-table-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.ct-table-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.ct-table-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.ct-table-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.ct-table-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.ct-table-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.ct-table-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.ct-table-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.ct-table-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.ct-table-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.ct-table-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.ct-table-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.ct-table-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.ct-table-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.ct-table-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.ct-table-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.ct-table-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.ct-table-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.ct-table-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.ct-table-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.ct-table-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.ct-table-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.ct-table-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.ct-table-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.ct-table-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.ct-table-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.ct-table-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.ct-table-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.ct-table-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.ct-table-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.ct-table-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}';
table_extension_styleInject(table_extension_css_248z$6);

/* eslint-disable react/destructuring-assignment */ function table_extension_assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function table_extension_getPrototypeOf$4(o) {
    table_extension_getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf$4(o);
}
function table_extension_inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf$4(subClass, superClass);
}
function table_extension_possibleConstructorReturn$4(self, call) {
    if (call && (table_extension_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized$4(self);
}
function table_extension_setPrototypeOf$4(o, p) {
    table_extension_setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf$4(o, p);
}
var table_extension_typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper$4(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn$4(this, result);
    };
}
var table_extension_ColorPopover = /*#__PURE__*/ function(Component) {
    table_extension_inherits$4(ColorPopover, Component);
    var _super = table_extension_createSuper$4(ColorPopover);
    function ColorPopover(props) {
        table_extension_classCallCheck$9(this, ColorPopover);
        var _this;
        _this = _super.call(this, props);
        // 接收来自 Popover 的选中事件后，调用父级 transform 方法
        _this.onSelect = function(color) {
            var setColor = _this.props.setColor;
            setColor(color);
            // HACK 异步 setState 以确保 tooltip 关闭
            window.requestAnimationFrame(function() {
                _this.setState({
                    hasTooltip: false,
                    isOpen: false
                });
            });
        };
        _this.handleMouseEnter = function() {
            var isOpen = _this.state.isOpen;
            if (isOpen) return;
            _this.setState({
                hasTooltip: true
            });
        };
        _this.state = {
            hasTooltip: false,
            isOpen: false
        };
        return _this;
    }
    var _proto = ColorPopover.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, type = _this_props.type, tips = _this_props.tips, defaultColor = _this_props.defaultColor, selectedColor = _this_props.selectedColor;
        var _this_state = this.state, hasTooltip = _this_state.hasTooltip, isOpen = _this_state.isOpen;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: function() {
                return _this.setState({
                    isOpen: !isOpen
                });
            },
            className: "".concat(table_extension_classNamePrefix("table-color-popover-wrapper"), " ").concat(type, "-color")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "color-block"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "left",
            style: {
                backgroundColor: selectedColor
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "right"
        })), isOpen && /*#__PURE__*/ react_default.a.createElement(table_extension_PopItem, {
            type: type,
            defaultColor: defaultColor,
            selectedColor: selectedColor,
            onSelect: this.onSelect
        }), hasTooltip && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "ct-toolbar-tooltip"
        }, tips));
    };
    return ColorPopover;
}(react["Component"]);

var table_extension_css_248z$7 = '.table-modal-content{display:flex;justify-content:flex-start;align-items:baseline;padding:24px}.table-modal-content .left{display:flex;flex-direction:column;justify-content:space-between;width:246px;height:176px;margin-right:30px}.table-modal-content .right{width:300px}.table-modal-content .title{margin-bottom:8px;font-size:14px;color:#333;line-height:22px}.table-modal-content .style-wrapper{display:flex;justify-content:flex-start;align-items:baseline}.table-modal-content .style-item{width:76px;height:70px;text-align:center}.table-modal-content .dashed{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2242px%22 viewBox%3D%220 0 48 42%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E8%99%9A%E7%BA%BF%E6%A1%86%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E8%A1%A8%E6%A0%BC%E5%B1%9E%E6%80%A7%22%3E            %3Cpath d%3D%22M45%2C16.5 L45%2C10.5 L48%2C10.5 L48%2C16.5 L45%2C16.5 Z M45%2C25.5 L48%2C25.5 L48%2C31.5 L45%2C31.5 L45%2C25.5 Z M45%2C34.5 L48%2C34.5 L48%2C36 C48%2C39.3137085 45.3137085%2C42 42%2C42 L37.4854431%2C42 L37.4854431%2C39 L42%2C39 C43.6568542%2C39 45%2C37.6568542 45%2C36 L45%2C34.5 Z M34.4854431%2C39 L34.4854431%2C42 L28.4854431%2C42 L28.4854431%2C39 L34.4854431%2C39 Z M19.4854431%2C39 L19.4854431%2C42 L13.4854431%2C42 L13.4854431%2C39 L19.4854431%2C39 Z M10.4854431%2C39 L10.4854431%2C42 L6%2C42 C2.6862915%2C42 0%2C39.3137085 0%2C36 L0%2C34.5 L3%2C34.5 L3%2C36 C3%2C37.6568542 4.34314575%2C39 6%2C39 L10.4854431%2C39 Z M3%2C31.5 L0%2C31.5 L0%2C25.5 L3%2C25.5 L3%2C31.5 Z M3%2C16.5 L0%2C16.5 L0%2C10.5 L3%2C10.5 L3%2C16.5 Z M3%2C7.5 L0%2C7.5 L0%2C6 C0%2C2.6862915 2.6862915%2C0 6%2C0 L10.4854431%2C0 L10.4854431%2C3 L6%2C3 C4.34314575%2C3 3%2C4.34314575 3%2C6 L3%2C7.5 Z M13.4854431%2C3 L13.4854431%2C0 L19.4854431%2C0 L19.4854431%2C3 L13.4854431%2C3 Z M28.4854431%2C3 L28.4854431%2C0 L34.4854431%2C0 L34.4854431%2C3 L28.4854431%2C3 Z M37.4854431%2C3 L37.4854431%2C0 L42%2C0 C45.3137085%2C0 48%2C2.6862915 48%2C6 L48%2C7.5 L45%2C7.5 L45%2C6 C45%2C4.34314575 43.6568542%2C3 42%2C3 L37.4854431%2C3 Z%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E            %3Cpath d%3D%22M25.4854431%2C22.5 L25.4854431%2C31.538842 L22.4854431%2C31.538842 L22.4854431%2C22.5 L10.2857143%2C22.5 L10.2857143%2C19.5 L22.4854431%2C19.5 L22.4854431%2C10.461158 L25.4854431%2C10.461158 L25.4854431%2C19.5 L37.7142857%2C19.5 L37.7142857%2C22.5 L25.4854431%2C22.5 Z M-2.27373675e-13%2C22.5 L-2.27373675e-13%2C19.5 L6.85714286%2C19.5 L6.85714286%2C22.5 L-2.27373675e-13%2C22.5 Z M41.1428571%2C22.5 L41.1428571%2C19.5 L48%2C19.5 L48%2C22.5 L41.1428571%2C22.5 Z M22.4854431%2C1.42108547e-14 L25.4854431%2C1.42108547e-14 L25.4854431%2C6.97410534 L22.4854431%2C6.97410534 L22.4854431%2C1.42108547e-14 Z M22.4854431%2C35.0258947 L25.4854431%2C35.0258947 L25.4854431%2C42 L22.4854431%2C42 L22.4854431%2C35.0258947 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23CCCCCC%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.table-modal-content .solid{margin-left:18px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2242px%22 viewBox%3D%220 0 48 42%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%AE%9E%E7%BA%BF%E6%A1%86%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-9%22%3E            %3Cpath d%3D%22M25.4854431%2C22.5 L25.4854431%2C31.538842 L22.4854431%2C31.538842 L22.4854431%2C22.5 L17.1428571%2C22.5 L10.2857143%2C22.5 L10.2857143%2C19.5 L17.1428571%2C19.5 L22.4854431%2C19.5 L22.4854431%2C10.461158 L25.4854431%2C10.461158 L25.4854431%2C19.5 L33.7302246%2C19.5 L37.7142857%2C19.5 L37.7142857%2C22.5 L33.7302246%2C22.5 L25.4854431%2C22.5 Z M0%2C22.5 L0%2C19.5 L6.85714286%2C19.5 L6.85714286%2C22.5 L0%2C22.5 Z M41.1428571%2C22.5 L41.1428571%2C19.5 L48%2C19.5 L48%2C22.5 L41.1428571%2C22.5 Z M22.4854431%2C0 L25.4854431%2C0 L25.4854431%2C6.97410534 L22.4854431%2C6.97410534 L22.4854431%2C0 Z M22.4854431%2C35.0258947 L25.4854431%2C35.0258947 L25.4854431%2C42 L22.4854431%2C42 L22.4854431%2C35.0258947 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23CCCCCC%22%3E%3C%2Fpath%3E            %3Cpath d%3D%22M6%2C3 C4.34314575%2C3 3%2C4.34314575 3%2C6 L3%2C36 C3%2C37.6568542 4.34314575%2C39 6%2C39 L42%2C39 C43.6568542%2C39 45%2C37.6568542 45%2C36 L45%2C6 C45%2C4.34314575 43.6568542%2C3 42%2C3 L6%2C3 Z M6%2C0 L42%2C0 C45.3137085%2C0 48%2C2.6862915 48%2C6 L48%2C36 C48%2C39.3137085 45.3137085%2C42 42%2C42 L6%2C42 C2.6862915%2C42 0%2C39.3137085 0%2C36 L0%2C6 C0%2C2.6862915 2.6862915%2C0 6%2C0 Z%22 id%3D%22Rectangle-15%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.table-modal-content .selected{background-color:rgba(0,167,205,.1)}.width-wrapper{padding:0 20px;display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;height:220px;border:1px solid #ddd;border-radius:2px;font-size:12px}.width-wrapper .width-item{cursor:pointer;width:126px;height:19px;line-height:19px;border-radius:2px;text-align:center;display:flex;align-items:center;justify-content:center}.width-wrapper .width-item .inner{display:inline-block;vertical-align:middle;width:110px;background:#1c6cdc}.width-wrapper .width-item:nth-child(2) .inner{height:4px}.width-wrapper .width-item:nth-child(3) .inner{height:1px}.width-wrapper .width-item:nth-child(4) .inner{height:5px}.width-wrapper .width-item:nth-child(5) .inner{height:2px}.width-wrapper .width-item:nth-child(6) .inner{height:6px}.width-wrapper .width-item:nth-child(7) .inner{height:3px}.width-wrapper .width-item:nth-child(8) .inner{height:7px}';
table_extension_styleInject(table_extension_css_248z$7);

function table_extension_assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$9(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_getPrototypeOf$5(o) {
    table_extension_getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf$5(o);
}
function table_extension_inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf$5(subClass, superClass);
}
function _objectSpread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$9(target, key, source[key]);
        });
    }
    return target;
}
function table_extension_possibleConstructorReturn$5(self, call) {
    if (call && (table_extension_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized$5(self);
}
function table_extension_setPrototypeOf$5(o, p) {
    table_extension_setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf$5(o, p);
}
var table_extension_typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper$5(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn$5(this, result);
    };
}
var table_extension_TableModal = /*#__PURE__*/ function(Component) {
    table_extension_inherits$5(TableModal, Component);
    var _super = table_extension_createSuper$5(TableModal);
    function TableModal(props) {
        table_extension_classCallCheck$a(this, TableModal);
        var _this;
        _this = _super.call(this, props);
        _this.handleOk = function() {
            var _this_props = _this.props, setTableAttrs = _this_props.setTableAttrs, hideModal = _this_props.hideModal;
            setTableAttrs(_objectSpread$8({}, _this.state));
            hideModal();
        };
        _this.handleCancel = function() {
            var hideModal = _this.props.hideModal;
            hideModal();
        };
        var getTableAttrs = _this.props.getTableAttrs;
        var attrs = getTableAttrs();
        _this.state = {
            borderStyle: attrs.borderStyle || "solid",
            borderColor: attrs.borderColor || "#cccccc",
            borderWidth: attrs.borderWidth === null ? 1 : attrs.borderWidth
        };
        return _this;
    }
    var _proto = TableModal.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, borderStyle = _this_state.borderStyle, borderColor = _this_state.borderColor, borderWidth = _this_state.borderWidth;
        return /*#__PURE__*/ react_default.a.createElement(table_extension_Modal, {
            className: "",
            contentClassName: "table-modal-wrapper",
            title: "表格属性",
            disabled: false,
            okText: "确定",
            onOk: this.handleOk,
            onCancel: function() {
                _this.handleCancel();
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "table-modal-content"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "left"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "border-style"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title"
        }, "边框样式："), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "style-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("style-item dashed", {
                selected: borderStyle === "dashed"
            }),
            onClick: function() {
                return _this.setState({
                    borderStyle: "dashed"
                });
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("style-item solid", {
                selected: borderStyle === "solid"
            }),
            onClick: function() {
                return _this.setState({
                    borderStyle: "solid"
                });
            }
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "border-color"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title"
        }, "边框颜色："), /*#__PURE__*/ react_default.a.createElement(table_extension_ColorPopover, {
            type: "table-border",
            tips: "边框颜色",
            defaultColor: "#ccc",
            selectedColor: borderColor,
            setColor: function(color) {
                return _this.setState({
                    borderColor: color
                });
            }
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "right"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "border-width"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title"
        }, "边框宽度："), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "width-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("width-item", {
                selected: borderWidth === 0
            }),
            onClick: function() {
                return _this.setState({
                    borderWidth: 0
                });
            }
        }, "无"), [
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ].map(function(_) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: _,
                className: classnames_default()("width-item", {
                    selected: borderWidth === _
                }),
                onClick: function() {
                    return _this.setState({
                        borderWidth: _
                    });
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "inner",
                style: {
                    backgroundColor: borderColor
                }
            }));
        }))))));
    };
    return TableModal;
}(react["Component"]);

var MenuItem = function(param) {
    var name = param.name, split = param.split, disabled = param.disabled, command = param.command;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-context-item")).concat(split ? " split" : "").concat(disabled ? " disabled" : ""),
        onClick: command
    }, name);
};

var table_extension_css_248z$8 = ".ct-table-context-menu{position:fixed;background:#fff;box-shadow:0 2px 10px #ccc;color:#333;z-index:999}.ct-table-context-menu .ct-table-context-item{padding:8px 30px 8px 15px;min-width:100px;cursor:default;font-size:12px}.ct-table-context-menu .ct-table-context-item:hover{background:#f6f6f6}.ct-table-context-menu .ct-table-context-item:active{background:#e9e9e9}.ct-table-context-menu .ct-table-context-item.disabled{color:#999;cursor:not-allowed}.ct-table-context-menu .ct-table-context-item.split{border-bottom:1px solid #ddd}";
table_extension_styleInject(table_extension_css_248z$8);

function table_extension_arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function table_extension_arrayWithHoles$5(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty$a(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_extension_iterableToArrayLimit$5(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function table_extension_nonIterableRest$5() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$a(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function table_extension_slicedToArray$5(arr, i) {
    return table_extension_arrayWithHoles$5(arr) || table_extension_iterableToArrayLimit$5(arr, i) || table_extension_unsupportedIterableToArray$6(arr, i) || table_extension_nonIterableRest$5();
}
function table_extension_unsupportedIterableToArray$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return table_extension_arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return table_extension_arrayLikeToArray$6(o, minLen);
}
// 硬编码 ContextMenu 宽高与页面底栏边距
var menuW = 130;
var bottomBarH = 60;
var paddingRight = 10;
var paddingBottom = 70;
var Menu = function(param) {
    var pos = param.pos, view = param.view, commands = param.commands;
    var calculatePos = function() {
        var top = "auto", right = "auto", bottom = "auto", left = "auto";
        var menuH = 370;
        var screenW = window.innerWidth;
        var screenH = window.innerHeight;
        if (pos.x + menuW > screenW) right = "".concat(paddingRight, "px");
        else left = "".concat(pos.x, "px");
        if (pos.y + menuH > screenH - bottomBarH) bottom = "".concat(paddingBottom, "px");
        else top = "".concat(pos.y, "px");
        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
    };
    var _useState = table_extension_slicedToArray$5(Object(react["useState"])({
        left: "auto",
        right: "auto",
        top: "auto",
        bottom: "auto"
    }), 2), menuPos = _useState[0], setMenuPos = _useState[1];
    var _useState1 = table_extension_slicedToArray$5(Object(react["useState"])(true), 2), displayMenu = _useState1[0], setDisplayMenu = _useState1[1];
    var _useState2 = table_extension_slicedToArray$5(Object(react["useState"])(false), 2), showModal = _useState2[0], setShowModal = _useState2[1];
    Object(react["useEffect"])(function() {
        setMenuPos(calculatePos());
    }, [
        pos,
        view
    ]);
    return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(table_extension_classNamePrefix("table-context-menu")),
        style: _objectSpreadProps$6(_objectSpread$9({}, menuPos), {
            display: displayMenu ? "block" : "none"
        })
    }, /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "".concat(commands.hasRowHeader() ? "取消表头行" : "设置表头行"),
        command: function() {
            commands.toggleRowHeader();
            setDisplayMenu(false);
            view.focus();
        }
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "".concat(commands.hasColHeader() ? "取消表头列" : "设置表头列"),
        command: function() {
            commands.toggleColHeader();
            setDisplayMenu(false);
            view.focus();
        },
        disabled: !commands.canToggleColHeader()
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "".concat(commands.hasNumCol() ? "取消行号列" : "设置行号列"),
        command: function() {
            commands.toggleNumCol();
            setDisplayMenu(false);
            view.focus();
        },
        disabled: !commands.canToggleNumCol(),
        split: true
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "上方插入行",
        command: function() {
            commands.addRowBefore();
            setDisplayMenu(false);
            view.focus();
        },
        disabled: !commands.canAddRowBefore()
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "下方插入行",
        command: function() {
            commands.addRowAfter();
            setDisplayMenu(false);
            view.focus();
        }
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "删除行",
        command: function() {
            commands.deleteRow();
            setDisplayMenu(false);
            view.focus();
        },
        split: true
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "左侧插入列",
        command: function() {
            commands.addColumnBefore();
            setDisplayMenu(false);
            view.focus();
        },
        disabled: !commands.canAddColumnBefore()
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "右侧插入列",
        command: function() {
            commands.addColumnAfter();
            setDisplayMenu(false);
            view.focus();
        }
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "删除列",
        command: function() {
            commands.deleteColumn();
            setDisplayMenu(false);
            view.focus();
        },
        split: true
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "合并单元格",
        command: function() {
            commands.mergeCells();
            setDisplayMenu(false);
            view.focus();
        },
        disabled: !commands.canMergeCells()
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "拆分单元格",
        command: function() {
            commands.splitCell();
            setDisplayMenu(false);
            view.focus();
        },
        disabled: !commands.canSplitCell(),
        split: true
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "表格属性",
        command: function() {
            setShowModal(true);
            setDisplayMenu(false);
        },
        split: true
    }), /*#__PURE__*/ react_default.a.createElement(MenuItem, {
        name: "删除表格",
        command: function() {
            commands.deleteTable();
            setDisplayMenu(false);
            view.focus();
        }
    })), showModal && /*#__PURE__*/ react_default.a.createElement(table_extension_TableModal, {
        hideModal: function() {
            return setShowModal(false);
        },
        setTableAttrs: commands.setTableAttrs,
        getTableAttrs: commands.getTableAttrs
    }));
};

function table_extension_classCallCheck$b(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var table_extension_ContextMenuView = /*#__PURE__*/ function() {
    function ContextMenuView(editorView, commands, eventEmitter) {
        var _this = this;
        table_extension_classCallCheck$b(this, ContextMenuView);
        this.showMenu = function(pos) {
            Object(react_dom["render"])(null, _this.portal);
            Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(Menu, {
                view: _this.editorView,
                pos: pos,
                commands: _this.commands
            }), _this.portal);
        };
        this.hideMenu = function() {
            Object(react_dom["render"])(null, _this.portal);
        };
        this.commands = commands;
        this.editorView = editorView;
        this.editorView = editorView;
        this.addPortalLayoutNode();
        this.eventEmitter = eventEmitter;
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.on(SHOW_TABLE_MENU, this.showMenu);
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.on(HIDE_TABLE_MENU, this.hideMenu);
    }
    var _proto = ContextMenuView.prototype;
    _proto.addPortalLayoutNode = function addPortalLayoutNode() {
        this.portal = document.createElement("div");
        this.portal.className = table_extension_classNamePrefix("table-context-menu-container");
        this.editorView.dom.parentNode.appendChild(this.portal);
    };
    _proto.destroy = function destroy() {
        var eventEmitter = this.eventEmitter;
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.off(SHOW_TABLE_MENU, this.showMenu);
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.off(HIDE_TABLE_MENU, this.hideMenu);
    };
    return ContextMenuView;
}();

var table_extension_css_248z$9 = ".ct-contextmenu-popover{display:none;position:fixed;background:#fff;box-shadow:0 2px 10px #ccc;color:#333;z-index:999;width:105px}";
table_extension_styleInject(table_extension_css_248z$9);

function contextMenu(commands, param) {
    var editorEventEmitter = param.editorEventEmitter;
    return new prosemirror_state_dist["Plugin"]({
        key: tableContextMenuKey,
        props: {
            handleDOMEvents: {
                mousedown: function() {
                    editorEventEmitter.emit(HIDE_TABLE_MENU);
                    return false;
                },
                contextmenu: function(view, e) {
                    var schema = view.state.schema;
                    // 图片等宏不要弹出自定义的 contextmenu
                    var _schema_nodes = schema.nodes, image = _schema_nodes.image, minder = _schema_nodes.minder, drawio = _schema_nodes.drawio;
                    var ignoreList = [
                        image,
                        minder,
                        drawio
                    ].filter(Boolean);
                    // 用 event.clientX 不用 posAtDOM 是为了防止命中段末
                    var eventPos = view.posAtCoords({
                        left: e.clientX,
                        top: e.clientY
                    });
                    var $target = view.state.doc.resolve(eventPos.pos).nodeAfter;
                    var targetType = $target === null || $target === void 0 ? void 0 : $target.type;
                    var ignoreTarget = ignoreList.includes(targetType);
                    if (ignoreTarget) {
                        return false;
                    }
                    var dom = findParentDOM(e.target, function(n) {
                        return n.tagName.toUpperCase() === "TABLE";
                    });
                    if (dom) {
                        editorEventEmitter.emit(SHOW_TABLE_MENU, {
                            x: e.clientX,
                            y: e.clientY
                        });
                        e.preventDefault();
                        view.focus();
                    } else {
                        editorEventEmitter.emit(HIDE_TABLE_MENU);
                        return false;
                    }
                    return undefined;
                }
            }
        },
        view: function view(editorView) {
            return new table_extension_ContextMenuView(editorView, commands, editorEventEmitter);
        }
    });
}

// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.
function _defineProperty$b(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$a(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$b(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$7(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$7(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$7(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// Utilities to help with copying and pasting table cells
function fitSlice(nodeType, slice) {
    var node = nodeType.createAndFill();
    var tr = new prosemirror_transform_dist["Transform"](node).replace(0, node.content.size, slice);
    return tr.doc;
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function ensureRectangular(schema, rows) {
    var table_cell = schema.nodes.table_cell;
    var widths = [];
    for(var i = 0; i < rows.length; i++){
        var row = rows[i];
        for(var j = row.childCount - 1; j >= 0; j--){
            var _row_child_attrs = row.child(j).attrs, rowspan = _row_child_attrs.rowspan, colspan = _row_child_attrs.colspan;
            for(var r = i; r < i + rowspan; r++){
                widths[r] = (widths[r] || 0) + colspan;
            }
        }
    }
    var width = 0;
    for(var r1 = 0; r1 < widths.length; r1++)width = Math.max(width, widths[r1]);
    for(var r2 = 0; r2 < widths.length; r2++){
        if (r2 >= rows.length) rows.push(dist["Fragment"].empty);
        if (widths[r2] < width) {
            var empty = table_cell.createAndFill();
            var cells = [];
            for(var i1 = widths[r2]; i1 < width; i1++)cells.push(empty);
            rows[r2] = rows[r2].append(dist["Fragment"].from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
// : (Slice) → ?{width: number, height: number, rows: [Fragment]}
// Get a rectangular area of cells from a slice, or null if the outer
// nodes of the slice aren't table cells or rows.
function pastedCells(slice) {
    if (!slice.size) return null;
    var content = slice.content, openStart = slice.openStart, openEnd = slice.openEnd;
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === "table")){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
    }
    var first = content.firstChild;
    var role = first.type.spec.tableRole;
    var schema = first.type.schema;
    var table_row = schema.nodes.table_row;
    var rows = [];
    if (role === "row") {
        for(var i = 0; i < content.childCount; i++){
            var cells = content.child(i).content;
            var left = i ? 0 : Math.max(0, openStart - 1);
            var right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
            if (left || right) {
                cells = fitSlice(table_row, new dist["Slice"](cells, left, right)).content;
            }
            rows.push(cells);
        }
    } else if (role === "cell" || role === "header_cell") {
        rows.push(openStart || openEnd ? fitSlice(table_row, new dist["Slice"](content, openStart, openEnd)).content : content);
    } else {
        return null;
    }
    return ensureRectangular(schema, rows);
}
// : ({width: number, height: number, rows: [Fragment]}, number, number)
// → {width: number, height: number, rows: [Fragment]}
// Clip or extend (repeat) the given set of cells to cover the given
// width and height. Will clip rowspan/colspan cells at the edges when
// they stick out.
function clipCells(param, newWidth, newHeight) {
    var width = param.width, height = param.height, rows = param.rows;
    if (width !== newWidth) {
        var added = [];
        var newRows = [];
        for(var row = 0; row < rows.length; row++){
            var frag = rows[row];
            var cells = [];
            for(var col = added[row] || 0, i = 0; col < newWidth; i++){
                var cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) {
                    cell = cell.type.create(removeColSpan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                }
                cells.push(cell);
                col += cell.attrs.colspan;
                for(var j = 1; j < cell.attrs.rowspan; j++){
                    added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
                }
            }
            newRows.push(dist["Fragment"].from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        var newRows1 = [];
        for(var row1 = 0, i1 = 0; row1 < newHeight; row1++, i1++){
            var cells1 = [];
            var source = rows[i1 % height];
            for(var j1 = 0; j1 < source.childCount; j1++){
                var cell1 = source.child(j1);
                if (row1 + cell1.attrs.rowspan > newHeight) {
                    cell1 = cell1.type.create(setAttr(cell1.attrs, "rowspan", Math.max(1, newHeight - cell1.attrs.rowspan)), cell1.content);
                }
                cells1.push(cell1);
            }
            newRows1.push(dist["Fragment"].from(cells1));
        }
        rows = newRows1;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
function createEmptyRow(table, schema, map, width) {
    var cells = [];
    var _schema_nodes = schema.nodes, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header, table_row = _schema_nodes.table_row;
    for(var i = 0, start = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
        var cell = void 0;
        if (i >= map.width) {
            cell = table_cell.createAndFill();
        } else {
            var mapCell = table.nodeAt(map.map[start + i]);
            var header = i >= map.width ? false : mapCell.type === table_header;
            cell = header ? table_header.createAndFill({
                numCell: mapCell.attrs.numCell
            }) : table_cell.createAndFill({
                numCell: mapCell.attrs.numCell
            });
        }
        cells.push(cell);
    }
    return table_row.create(null, dist["Fragment"].from(cells));
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function growTable(tr, map, table, start, width, height, mapFrom) {
    var schema = tr.doc.type.schema;
    var _schema_nodes = schema.nodes, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header;
    var inserted = false;
    if (width > map.width) {
        inserted = true;
        for(var row = 0, rowEnd = 0; row < map.height; row++){
            var rowNode = table.child(row);
            rowEnd += rowNode.nodeSize;
            var cells = [];
            for(var i = map.width; i < width; i++){
                var add = null;
                if (rowNode.lastChild === null || rowNode.lastChild.type === table_cell) {
                    add = table_cell.createAndFill();
                } else {
                    add = table_header.createAndFill();
                }
                cells.push(add);
            }
            tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
        }
    }
    if (height > map.height) {
        inserted = true;
        var rows = [];
        for(var i1 = map.height; i1 < height; i1++){
            rows.push(createEmptyRow(table, schema, map, width));
        }
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return inserted;
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    var found = false;
    for(var col = left; col < right; col++){
        var index = top * map.width + col;
        var pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            var cell = table.nodeAt(pos);
            var _map_findCell = map.findCell(pos), cellTop = _map_findCell.top, cellLeft = _map_findCell.left;
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, setAttr(cell.attrs, "rowspan", top - cellTop));
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)) + start, cell.type.createAndFill(setAttr(cell.attrs, "rowspan", cellTop + cell.attrs.rowspan - top)));
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    var found = false;
    for(var row = top; row < bottom; row++){
        var index = row * map.width + left;
        var pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            var cell = table.nodeAt(pos);
            var cellLeft = map.colCount(pos);
            var updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, null, removeColSpan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(removeColSpan(cell.attrs, 0, left - cellLeft)));
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
// 解析每个Node的行号列号
function parseRowsSlice(rows, w, h) {
    var map = [];
    for(var i = 0, e = w * h; i < e; i++)map[i] = null;
    for(var i1 = 0; i1 < rows.length; i1++){
        var slice = rows[i1];
        var sliceIndex = 0;
        for(var j = 0; j < w; j++){
            if (map[i1 * w + j]) continue;
            var node = slice.content[sliceIndex];
            for(var ii = 0; ii < node.attrs.rowspan; ii++){
                for(var jj = 0; jj < node.attrs.colspan; jj++){
                    map[(i1 + ii) * w + j + jj] = {
                        i: i1,
                        j: sliceIndex
                    };
                }
            }
            sliceIndex += 1;
        }
    }
    var res = [];
    for(var i2 = 0; i2 < rows.length; i2++)res[i2] = [];
    map.forEach(function(val, idx) {
        if (!res[val.i][val.j]) {
            var row = idx ? Math.floor(idx / w) : 0;
            var col = idx - row * w;
            res[val.i][val.j] = {
                col: col,
                row: row
            };
        }
    });
    return res;
}
// Insert the given set of cells (as returned by `pastedCells`) into a
// table, at the position pointed at by rect.
function insertCells(state, dispatch, tableStart, rect, cells) {
    var _loop = function(row) {
        var slice = cells.rows[row - top];
        var hasNumCell = false;
        // 保留原来的 cellType, diffId，行号
        for(var i = 0; i < slice.content.length; i++){
            var _doc_nodeAt, _doc_nodeAt1, _doc_nodeAt2;
            var node = slice.content[i];
            var _parseRes__i = parseRes[row - top][i], colIdx = _parseRes__i.col, rowIdx = _parseRes__i.row;
            var pos = map.positionAt(rowIdx + top, colIdx + left, table) + tableStart;
            var cellType = ((_doc_nodeAt = doc.nodeAt(pos)) === null || _doc_nodeAt === void 0 ? void 0 : _doc_nodeAt.type) || table_cell;
            var numCell = ((_doc_nodeAt1 = doc.nodeAt(pos)) === null || _doc_nodeAt1 === void 0 ? void 0 : _doc_nodeAt1.attrs.numCell) || false;
            if (!hasNumCell && numCell) {
                hasNumCell = numCell;
            }
            var dataCellDiffId = ((_doc_nodeAt2 = doc.nodeAt(pos)) === null || _doc_nodeAt2 === void 0 ? void 0 : _doc_nodeAt2.attrs.dataCellDiffId) || "ct-cell-diff-id-".concat(esm_browser_v4());
            slice.content[i] = cellType.create(_objectSpreadProps$7(_objectSpread$a({}, node.attrs), {
                dataCellDiffId: dataCellDiffId,
                numCell: numCell
            }), node.content);
        }
        var newNodes = [];
        if (hasNumCell) {
            slice.forEach(function(node, _offset, index) {
                if (index > 0) {
                    newNodes.push(node);
                }
            });
        }
        var from = map.positionAt(row, left + (hasNumCell ? 1 : 0), table);
        var to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new dist["Slice"](hasNumCell ? dist["Fragment"].fromArray(newNodes) : slice, 0, 0));
    };
    var recomp = function recomp() {
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = TableMap.get(table);
        mapFrom = tr.mapping.maps.length;
    };
    var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
    var map = TableMap.get(table);
    var top = rect.top, left = rect.left;
    var right = left + cells.width;
    var bottom = top + cells.height;
    var tr = state.tr, schema = state.schema;
    var table_cell = schema.nodes.table_cell;
    var mapFrom = 0;
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) {
        recomp();
    }
    if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) {
        recomp();
    }
    if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) {
        recomp();
    }
    if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) {
        recomp();
    }
    if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) {
        recomp();
    }
    var doc = tr.doc;
    var parseRes = parseRowsSlice(cells.rows, right - left, bottom - top);
    var selPos = map.positionAt(top, left, table) + tableStart;
    for(var row = top; row < bottom; row++)_loop(row);
    recomp();
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(selPos + 1))); // +1之前，位置在<cell>前
    dispatch(tr);
}
// 与 insertCells 逻辑一样，只是返回 tr
function insertCellsTr(state, tr, tableStart, rect, cells) {
    var _loop = function(row) {
        var slice = cells.rows[row - top];
        var hasNumCell = false;
        // 保留原来的 cellType, diffId，行号
        for(var i = 0; i < slice.content.length; i++){
            var _doc_nodeAt, _doc_nodeAt1, _doc_nodeAt2;
            var node = slice.content[i];
            var _parseRes__i = parseRes[row - top][i], colIdx = _parseRes__i.col, rowIdx = _parseRes__i.row;
            var pos = map.positionAt(rowIdx + top, colIdx + left, table) + tableStart;
            var cellType = ((_doc_nodeAt = doc.nodeAt(pos)) === null || _doc_nodeAt === void 0 ? void 0 : _doc_nodeAt.type) || table_cell;
            var numCell = ((_doc_nodeAt1 = doc.nodeAt(pos)) === null || _doc_nodeAt1 === void 0 ? void 0 : _doc_nodeAt1.attrs.numCell) || false;
            if (!hasNumCell && numCell) {
                hasNumCell = numCell;
            }
            var dataCellDiffId = ((_doc_nodeAt2 = doc.nodeAt(pos)) === null || _doc_nodeAt2 === void 0 ? void 0 : _doc_nodeAt2.attrs.dataCellDiffId) || "ct-cell-diff-id-".concat(esm_browser_v4());
            slice.content[i] = cellType.create(_objectSpreadProps$7(_objectSpread$a({}, node.attrs), {
                dataCellDiffId: dataCellDiffId,
                numCell: numCell
            }), node.content);
        }
        var newNodes = [];
        if (hasNumCell) {
            slice.forEach(function(node, _offset, index) {
                if (index > 0) {
                    newNodes.push(node);
                }
            });
        }
        var from = map.positionAt(row, left + (hasNumCell ? 1 : 0), table);
        var to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new dist["Slice"](hasNumCell ? dist["Fragment"].fromArray(newNodes) : slice, 0, 0));
    };
    var recomp = function recomp() {
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = TableMap.get(table);
        mapFrom = tr.mapping.maps.length;
    };
    var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
    var map = TableMap.get(table);
    var top = rect.top, left = rect.left;
    var right = left + cells.width;
    var bottom = top + cells.height;
    var schema = state.schema;
    var table_cell = schema.nodes.table_cell;
    var mapFrom = 0;
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) {
        recomp();
    }
    if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) {
        recomp();
    }
    if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) {
        recomp();
    }
    if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) {
        recomp();
    }
    if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) {
        recomp();
    }
    var doc = tr.doc;
    var parseRes = parseRowsSlice(cells.rows, right - left, bottom - top);
    var selPos = map.positionAt(top, left, table) + tableStart;
    for(var row = top; row < bottom; row++)_loop(row);
    recomp();
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(selPos + 1))); // +1之前，位置在<cell>前
    return tr;
}

var table_extension_css_248z$a = '.ct-table-wrapper{display:block;overflow-x:auto;overflow-y:hidden;margin:24px 0 8px;padding-bottom:1px;padding-right:1px;counter-reset:cellnumber}.ct-table-wrapper table,.ct-table-wrapper tbody,.ct-table-wrapper td,.ct-table-wrapper th{background-clip:padding-box!important}.ct-table-wrapper table{width:auto;border-collapse:collapse;table-layout:fixed;word-break:break-all;position:relative;overflow:auto;margin:0}.ct-table-wrapper td,.ct-table-wrapper th{box-sizing:border-box;width:auto;min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;padding:1px 8px;border:1px solid #ddd;vertical-align:top;background-color:#fff;outline:none}.ct-table-wrapper td.overflow,.ct-table-wrapper td>ol,.ct-table-wrapper td>ul,.ct-table-wrapper th.overflow,.ct-table-wrapper th>ol,.ct-table-wrapper th>ul{overflow:hidden}.ct-table-wrapper th{text-align:left;background-color:#f6f6f6;overflow:hidden}.ct-table-wrapper td{overflow:hidden}.ct-table-wrapper table td>p>span.ct-node-view-dom,.ct-table-wrapper table th>p>span.ct-node-view-dom{margin:0 0 0 -3px}.ct-table-wrapper .num-cell{counter-increment:cellnumber;vertical-align:top;text-align:center;color:#000;padding:8px 0;font-size:12px;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.ct-table-wrapper .num-cell:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;content:counter(cellnumber)}.ct-table-wrapper .num-cell p{display:none}.ct-table-wrapper h1,.ct-table-wrapper h2,.ct-table-wrapper h3,.ct-table-wrapper h4,.ct-table-wrapper h5,.ct-table-wrapper h6,.ct-table-wrapper p{min-width:0;margin-top:8px}.ct-table-wrapper ol,.ct-table-wrapper ul{padding-left:34px}.ct-table-wrapper .ct-node-view-dom .ct-image{font-size:1;min-width:20px;max-width:100%}.ProseMirror .column-resize-handler{position:absolute;top:0;bottom:-1px;width:2px;right:0;z-index:15;cursor:col-resize!important;background-color:#adf;pointer-events:inherit!important}.column-resize-handler.ProseMirror-widget{background:#3d91f2}table .selectedCell{position:relative}table .selectedCell:after{z-index:2;position:absolute;content:"";left:0;right:0;top:0;bottom:0;background-color:rgba(65,194,245,.2);pointer-events:none}table .selectedCell.top:after{border-top:2px solid #1c6cdc}table .selectedCell.bottom:after{border-bottom:2px solid #1c6cdc}table .selectedCell.left:after{border-left:2px solid #1c6cdc}table .selectedCell.right:after{border-right:2px solid #1c6cdc}table[data-borderstyle=dashed]>tbody>tr>td,table[data-borderstyle=dashed]>tbody>tr>th{border-style:dashed}table[data-borderwidth="0"]>tbody>tr>td,table[data-borderwidth="0"]>tbody>tr>th{border:none}table[data-borderwidth="1"] tr:first-child:after{content:""}table[data-borderwidth="7"]>tbody>tr>td,table[data-borderwidth="7"]>tbody>tr>th{border-width:7px}table[data-borderwidth="7"]>tbody>tr .column-resize-handler{width:8px}table[data-borderwidth="7"]>tbody>tr .selectedCell:after{left:6px;right:6px;top:6px;bottom:6px;border-width:8px}table[data-borderwidth="6"]>tbody>tr>td,table[data-borderwidth="6"]>tbody>tr>th{border-width:6px}table[data-borderwidth="6"]>tbody>tr .column-resize-handler{width:7px}table[data-borderwidth="6"]>tbody>tr .selectedCell:after{left:5px;right:5px;top:5px;bottom:5px;border-width:7px}table[data-borderwidth="5"]>tbody>tr>td,table[data-borderwidth="5"]>tbody>tr>th{border-width:5px}table[data-borderwidth="5"]>tbody>tr .column-resize-handler{width:6px}table[data-borderwidth="5"]>tbody>tr .selectedCell:after{left:4px;right:4px;top:4px;bottom:4px;border-width:6px}table[data-borderwidth="4"]>tbody>tr>td,table[data-borderwidth="4"]>tbody>tr>th{border-width:4px}table[data-borderwidth="4"]>tbody>tr .column-resize-handler{width:5px}table[data-borderwidth="4"]>tbody>tr .selectedCell:after{left:3px;right:3px;top:3px;bottom:3px;border-width:5px}table[data-borderwidth="3"]>tbody>tr>td,table[data-borderwidth="3"]>tbody>tr>th{border-width:3px}table[data-borderwidth="3"]>tbody>tr .column-resize-handler{width:4px}table[data-borderwidth="3"]>tbody>tr .selectedCell:after{left:2px;right:2px;top:2px;bottom:2px;border-width:4px}table[data-borderwidth="2"]>tbody>tr>td,table[data-borderwidth="2"]>tbody>tr>th{border-width:2px}table[data-borderwidth="2"]>tbody>tr .column-resize-handler{width:3px}table[data-borderwidth="2"]>tbody>tr .selectedCell:after{left:1px;right:1px;top:1px;bottom:1px;border-width:3px}table[data-borderwidth="1"]>tbody>tr>td,table[data-borderwidth="1"]>tbody>tr>th{border-width:1px}table[data-borderwidth="1"]>tbody>tr .column-resize-handler{width:2px}table[data-borderwidth="1"]>tbody>tr .selectedCell:after{left:0;right:0;top:0;bottom:0;border-width:2px}table[data-bordercolor="#fff"]>tbody>tr>td,table[data-bordercolor="#fff"]>tbody>tr>th{border-color:#fff}table[data-bordercolor="#333"]>tbody>tr>td,table[data-bordercolor="#333"]>tbody>tr>th{border-color:#333}table[data-bordercolor="#f5222d"]>tbody>tr>td,table[data-bordercolor="#f5222d"]>tbody>tr>th{border-color:#f5222d}table[data-bordercolor="#fa541c"]>tbody>tr>td,table[data-bordercolor="#fa541c"]>tbody>tr>th{border-color:#fa541c}table[data-bordercolor="#faad14"]>tbody>tr>td,table[data-bordercolor="#faad14"]>tbody>tr>th{border-color:#faad14}table[data-bordercolor="#fadb14"]>tbody>tr>td,table[data-bordercolor="#fadb14"]>tbody>tr>th{border-color:#fadb14}table[data-bordercolor="#52c41a"]>tbody>tr>td,table[data-bordercolor="#52c41a"]>tbody>tr>th{border-color:#52c41a}table[data-bordercolor="#13c2c2"]>tbody>tr>td,table[data-bordercolor="#13c2c2"]>tbody>tr>th{border-color:#13c2c2}table[data-bordercolor="#1890ff"]>tbody>tr>td,table[data-bordercolor="#1890ff"]>tbody>tr>th{border-color:#1890ff}table[data-bordercolor="#2f54eb"]>tbody>tr>td,table[data-bordercolor="#2f54eb"]>tbody>tr>th{border-color:#2f54eb}table[data-bordercolor="#722ed1"]>tbody>tr>td,table[data-bordercolor="#722ed1"]>tbody>tr>th{border-color:#722ed1}table[data-bordercolor="#eb2f96"]>tbody>tr>td,table[data-bordercolor="#eb2f96"]>tbody>tr>th{border-color:#eb2f96}table[data-bordercolor="#f6f6f6"]>tbody>tr>td,table[data-bordercolor="#f6f6f6"]>tbody>tr>th{border-color:#f6f6f6}table[data-bordercolor="#989898"]>tbody>tr>td,table[data-bordercolor="#989898"]>tbody>tr>th{border-color:#989898}table[data-bordercolor="#ffe8e7"]>tbody>tr>td,table[data-bordercolor="#ffe8e7"]>tbody>tr>th{border-color:#ffe8e7}table[data-bordercolor="#ffece0"]>tbody>tr>td,table[data-bordercolor="#ffece0"]>tbody>tr>th{border-color:#ffece0}table[data-bordercolor="#fff7cb"]>tbody>tr>td,table[data-bordercolor="#fff7cb"]>tbody>tr>th{border-color:#fff7cb}table[data-bordercolor="#fcfcca"]>tbody>tr>td,table[data-bordercolor="#fcfcca"]>tbody>tr>th{border-color:#fcfcca}table[data-bordercolor="#e5f7d3"]>tbody>tr>td,table[data-bordercolor="#e5f7d3"]>tbody>tr>th{border-color:#e5f7d3}table[data-bordercolor="#cffff7"]>tbody>tr>td,table[data-bordercolor="#cffff7"]>tbody>tr>th{border-color:#cffff7}table[data-bordercolor="#d4eefc"]>tbody>tr>td,table[data-bordercolor="#d4eefc"]>tbody>tr>th{border-color:#d4eefc}table[data-bordercolor="#dfe8fc"]>tbody>tr>td,table[data-bordercolor="#dfe8fc"]>tbody>tr>th{border-color:#dfe8fc}table[data-bordercolor="#efe1fa"]>tbody>tr>td,table[data-bordercolor="#efe1fa"]>tbody>tr>th{border-color:#efe1fa}table[data-bordercolor="#fbe1eb"]>tbody>tr>td,table[data-bordercolor="#fbe1eb"]>tbody>tr>th{border-color:#fbe1eb}table[data-bordercolor="#e9e9e9"]>tbody>tr>td,table[data-bordercolor="#e9e9e9"]>tbody>tr>th{border-color:#e9e9e9}table[data-bordercolor="#666"]>tbody>tr>td,table[data-bordercolor="#666"]>tbody>tr>th{border-color:#666}table[data-bordercolor="#ffa39e"]>tbody>tr>td,table[data-bordercolor="#ffa39e"]>tbody>tr>th{border-color:#ffa39e}table[data-bordercolor="#ffbb96"]>tbody>tr>td,table[data-bordercolor="#ffbb96"]>tbody>tr>th{border-color:#ffbb96}table[data-bordercolor="#ffe58f"]>tbody>tr>td,table[data-bordercolor="#ffe58f"]>tbody>tr>th{border-color:#ffe58f}table[data-bordercolor="#fffb8f"]>tbody>tr>td,table[data-bordercolor="#fffb8f"]>tbody>tr>th{border-color:#fffb8f}table[data-bordercolor="#b7eb8f"]>tbody>tr>td,table[data-bordercolor="#b7eb8f"]>tbody>tr>th{border-color:#b7eb8f}table[data-bordercolor="#87e8de"]>tbody>tr>td,table[data-bordercolor="#87e8de"]>tbody>tr>th{border-color:#87e8de}table[data-bordercolor="#91d5ff"]>tbody>tr>td,table[data-bordercolor="#91d5ff"]>tbody>tr>th{border-color:#91d5ff}table[data-bordercolor="#adc6ff"]>tbody>tr>td,table[data-bordercolor="#adc6ff"]>tbody>tr>th{border-color:#adc6ff}table[data-bordercolor="#d3adf7"]>tbody>tr>td,table[data-bordercolor="#d3adf7"]>tbody>tr>th{border-color:#d3adf7}table[data-bordercolor="#ffadd2"]>tbody>tr>td,table[data-bordercolor="#ffadd2"]>tbody>tr>th{border-color:#ffadd2}table[data-bordercolor="#ddd"]>tbody>tr>td,table[data-bordercolor="#ddd"]>tbody>tr>th{border-color:#ddd}table[data-bordercolor="#4b4b4b"]>tbody>tr>td,table[data-bordercolor="#4b4b4b"]>tbody>tr>th{border-color:#4b4b4b}table[data-bordercolor="#ff4d4f"]>tbody>tr>td,table[data-bordercolor="#ff4d4f"]>tbody>tr>th{border-color:#ff4d4f}table[data-bordercolor="#ff7a45"]>tbody>tr>td,table[data-bordercolor="#ff7a45"]>tbody>tr>th{border-color:#ff7a45}table[data-bordercolor="#ffc53d"]>tbody>tr>td,table[data-bordercolor="#ffc53d"]>tbody>tr>th{border-color:#ffc53d}table[data-bordercolor="#ffec3d"]>tbody>tr>td,table[data-bordercolor="#ffec3d"]>tbody>tr>th{border-color:#ffec3d}table[data-bordercolor="#73d13d"]>tbody>tr>td,table[data-bordercolor="#73d13d"]>tbody>tr>th{border-color:#73d13d}table[data-bordercolor="#36cfc9"]>tbody>tr>td,table[data-bordercolor="#36cfc9"]>tbody>tr>th{border-color:#36cfc9}table[data-bordercolor="#40a8ff"]>tbody>tr>td,table[data-bordercolor="#40a8ff"]>tbody>tr>th{border-color:#40a8ff}table[data-bordercolor="#597ef7"]>tbody>tr>td,table[data-bordercolor="#597ef7"]>tbody>tr>th{border-color:#597ef7}table[data-bordercolor="#9254de"]>tbody>tr>td,table[data-bordercolor="#9254de"]>tbody>tr>th{border-color:#9254de}table[data-bordercolor="#f759ab"]>tbody>tr>td,table[data-bordercolor="#f759ab"]>tbody>tr>th{border-color:#f759ab}table[data-bordercolor="#ccc"]>tbody>tr>td,table[data-bordercolor="#ccc"]>tbody>tr>th{border-color:#ccc}table[data-bordercolor="#262626"]>tbody>tr>td,table[data-bordercolor="#262626"]>tbody>tr>th{border-color:#262626}table[data-bordercolor="#cf1322"]>tbody>tr>td,table[data-bordercolor="#cf1322"]>tbody>tr>th{border-color:#cf1322}table[data-bordercolor="#d4380d"]>tbody>tr>td,table[data-bordercolor="#d4380d"]>tbody>tr>th{border-color:#d4380d}table[data-bordercolor="#d48806"]>tbody>tr>td,table[data-bordercolor="#d48806"]>tbody>tr>th{border-color:#d48806}table[data-bordercolor="#d4b106"]>tbody>tr>td,table[data-bordercolor="#d4b106"]>tbody>tr>th{border-color:#d4b106}table[data-bordercolor="#389e0d"]>tbody>tr>td,table[data-bordercolor="#389e0d"]>tbody>tr>th{border-color:#389e0d}table[data-bordercolor="#08979c"]>tbody>tr>td,table[data-bordercolor="#08979c"]>tbody>tr>th{border-color:#08979c}table[data-bordercolor="#096dd9"]>tbody>tr>td,table[data-bordercolor="#096dd9"]>tbody>tr>th{border-color:#096dd9}table[data-bordercolor="#1d39c4"]>tbody>tr>td,table[data-bordercolor="#1d39c4"]>tbody>tr>th{border-color:#1d39c4}table[data-bordercolor="#531dab"]>tbody>tr>td,table[data-bordercolor="#531dab"]>tbody>tr>th{border-color:#531dab}table[data-bordercolor="#c41d7f"]>tbody>tr>td,table[data-bordercolor="#c41d7f"]>tbody>tr>th{border-color:#c41d7f}table[data-bordercolor="#aaa"]>tbody>tr>td,table[data-bordercolor="#aaa"]>tbody>tr>th{border-color:#aaa}table[data-bordercolor="#000"]>tbody>tr>td,table[data-bordercolor="#000"]>tbody>tr>th{border-color:#000}table[data-bordercolor="#820014"]>tbody>tr>td,table[data-bordercolor="#820014"]>tbody>tr>th{border-color:#820014}table[data-bordercolor="#871400"]>tbody>tr>td,table[data-bordercolor="#871400"]>tbody>tr>th{border-color:#871400}table[data-bordercolor="#874d00"]>tbody>tr>td,table[data-bordercolor="#874d00"]>tbody>tr>th{border-color:#874d00}table[data-bordercolor="#876800"]>tbody>tr>td,table[data-bordercolor="#876800"]>tbody>tr>th{border-color:#876800}table[data-bordercolor="#135200"]>tbody>tr>td,table[data-bordercolor="#135200"]>tbody>tr>th{border-color:#135200}table[data-bordercolor="#00474f"]>tbody>tr>td,table[data-bordercolor="#00474f"]>tbody>tr>th{border-color:#00474f}table[data-bordercolor="#003a8c"]>tbody>tr>td,table[data-bordercolor="#003a8c"]>tbody>tr>th{border-color:#003a8c}table[data-bordercolor="#061178"]>tbody>tr>td,table[data-bordercolor="#061178"]>tbody>tr>th{border-color:#061178}table[data-bordercolor="#22075e"]>tbody>tr>td,table[data-bordercolor="#22075e"]>tbody>tr>th{border-color:#22075e}table[data-bordercolor="#780650"]>tbody>tr>td,table[data-bordercolor="#780650"]>tbody>tr>th{border-color:#780650}table.responsive{table-layout:auto}table.responsive>tbody>tr>td,table.responsive>tbody>tr>th{width:auto!important;min-width:52px}table.responsive>tbody>tr>td h1,table.responsive>tbody>tr>td h2,table.responsive>tbody>tr>td h3,table.responsive>tbody>tr>td h4,table.responsive>tbody>tr>td h5,table.responsive>tbody>tr>td h6,table.responsive>tbody>tr>td p,table.responsive>tbody>tr>th h1,table.responsive>tbody>tr>th h2,table.responsive>tbody>tr>th h3,table.responsive>tbody>tr>th h4,table.responsive>tbody>tr>th h5,table.responsive>tbody>tr>th h6,table.responsive>tbody>tr>th p{min-width:0;margin-top:8px;word-break:keep-all}.pm-body-wrapper .ct-table-wrapper{overflow-x:auto}.pm-body-wrapper .ct-table-wrapper table{position:static}.pm-body-wrapper .ct-table-wrapper .num-cell-view:before{content:""}.pm-body-wrapper .ct-table-wrapper .cloneHeader{display:none}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th,.pm-body-wrapper .ct-table-wrapper .originHeader>th{position:relative}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th:after{content:"";width:12px;height:12px;visibility:hidden;position:absolute;right:4px;top:50%;transform:translateY(-50%);background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526442144261%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223424%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2212%22 height%3D%2212%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M228.437333 251.904L475.562667 15.36a51.2 51.2 0 0 1 72.874666 0l247.125334 236.544a52.906667 52.906667 0 0 1 11.178666 57.173333 51.626667 51.626667 0 0 1-47.616 32.256H264.874667a51.541333 51.541333 0 0 1-47.616-32.426666 52.906667 52.906667 0 0 1 11.178666-57.002667z m567.125334 520.192L548.437333 1008.64a51.2 51.2 0 0 1-72.874666 0L228.437333 772.096a52.906667 52.906667 0 0 1-11.178666-57.173333A51.626667 51.626667 0 0 1 264.874667 682.666667h494.250666c20.821333 0 39.594667 12.8 47.616 32.426666a52.906667 52.906667 0 0 1-11.178666 57.002667z%22 fill%3D%22%23B0B0B0%22 p-id%3D%223425%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E");background-color:inherit;background-repeat:no-repeat;background-position:50%;cursor:pointer}.pm-body-wrapper .ct-table-wrapper .cloneHeader:hover>th:after,.pm-body-wrapper .ct-table-wrapper .originHeader:hover>th:after{visibility:visible}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th[data-reverse="-1"]:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th[data-reverse="-1"]:after{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2212px%22 height%3D%2212px%22 viewBox%3D%220 0 12 12%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8D%87%E5%BA%8F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22%E7%AC%AC2%E7%89%88%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22web-icon%22 transform%3D%22translate(-357.000000%2C -148.000000)%22%3E            %3Cg id%3D%22%E9%99%8D%E5%BA%8F%22 transform%3D%22translate(357.000000%2C 148.000000)%22%3E                %3Cpath d%3D%22M2.67721068%2C2.95184803 L5.57308098%2C0.17984669 C5.68599316%2C0.0650592945 5.83999069%2C5.32907052e-14 5.99998184%2C0 C6.15997299%2C-5.21804822e-14 6.31339049%2C0.0644696332 6.42688271%2C0.17984669 L9.32309135%2C2.95217191 C9.43842032%2C3.06941622 9.5%2C3.22656095 9.5%2C3.38616261 C9.5%2C3.46537377 9.48491926%2C3.5451746 9.45408109%2C3.6212409 C9.36050318%2C3.85022603 9.14009241%2C4 8.89619049%2C4 L3.10411154%2C3.99967612 C2.86011295%2C3.99967612 2.63970218%2C3.85049182 2.54612427%2C3.62091703 C2.45254636%2C3.39075257 2.50387887%2C3.1279602 2.67721068%2C2.95184803 Z M9.32278932%2C9.04815197 L6.42691902%2C11.8201533 C6.31400684%2C11.9349407 6.16000931%2C12 6.00001816%2C12 C5.84002701%2C12 5.68660951%2C11.9355304 5.57311729%2C11.8201533 L2.67690865%2C9.04782809 C2.56157968%2C8.93058378 2.5%2C8.77343905 2.5%2C8.61383739 C2.5%2C8.53462623 2.51508074%2C8.4548254 2.54591891%2C8.3787591 C2.63949682%2C8.14977397 2.85990759%2C8 3.10380951%2C8 L8.89588846%2C8.00032388 C9.13988705%2C8.00032388 9.36029782%2C8.14950818 9.45387573%2C8.37908297 C9.54745364%2C8.60924743 9.49612113%2C8.8720398 9.32278932%2C9.04815197 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23B0B0B0%22%3E%3C%2Fpath%3E                %3Cg id%3D%22Group-3%22 transform%3D%22translate(2.500000%2C 0.000000)%22%3E                    %3Cpath d%3D%22M0.177210679%2C2.95184803 L3.07308098%2C0.17984669 C3.18599316%2C0.0650592945 3.33999069%2C5.32907052e-14 3.49998184%2C0 C3.65997299%2C-5.21804822e-14 3.81339049%2C0.0644696332 3.92688271%2C0.17984669 L6.82309135%2C2.95217191 C6.93842032%2C3.06941622 7%2C3.22656095 7%2C3.38616261 C7%2C3.46537377 6.98491926%2C3.5451746 6.95408109%2C3.6212409 C6.86050318%2C3.85022603 6.64009241%2C4 6.39619049%2C4 L0.604111544%2C3.99967612 C0.360112952%2C3.99967612 0.139702179%2C3.85049182 0.0461242714%2C3.62091703 C-0.0474536357%2C3.39075257 0.00387887328%2C3.1279602 0.177210679%2C2.95184803 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%236B6B6B%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M6.82278932%2C9.04815197 L3.92691902%2C11.8201533 C3.81400684%2C11.9349407 3.66000931%2C12 3.50001816%2C12 C3.34002701%2C12 3.18660951%2C11.9355304 3.07311729%2C11.8201533 L0.176908647%2C9.04782809 C0.0615796765%2C8.93058378 -1.77635684e-15%2C8.77343905 8.8817842e-16%2C8.61383739 C2.13162821e-14%2C8.53462623 0.0150807371%2C8.4548254 0.045918911%2C8.3787591 C0.139496818%2C8.14977397 0.359907591%2C8 0.603809512%2C8 L6.39588846%2C8.00032388 C6.63988705%2C8.00032388 6.86029782%2C8.14950818 6.95387573%2C8.37908297 C7.04745364%2C8.60924743 6.99612113%2C8.8720398 6.82278932%2C9.04815197 Z%22 id%3D%22Fill-1%22 fill%3D%22%23AAAAAA%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th[data-reverse="1"]:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th[data-reverse="1"]:after{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2212px%22 height%3D%2212px%22 viewBox%3D%220 0 12 12%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%99%8D%E5%BA%8F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22%E7%AC%AC2%E7%89%88%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22web-icon%22 transform%3D%22translate(-357.000000%2C -148.000000)%22%3E            %3Cg id%3D%22%E9%99%8D%E5%BA%8F%22 transform%3D%22translate(357.000000%2C 148.000000)%22%3E                %3Cpath d%3D%22M2.67721068%2C2.95184803 L5.57308098%2C0.17984669 C5.68599316%2C0.0650592945 5.83999069%2C5.32907052e-14 5.99998184%2C0 C6.15997299%2C-5.21804822e-14 6.31339049%2C0.0644696332 6.42688271%2C0.17984669 L9.32309135%2C2.95217191 C9.43842032%2C3.06941622 9.5%2C3.22656095 9.5%2C3.38616261 C9.5%2C3.46537377 9.48491926%2C3.5451746 9.45408109%2C3.6212409 C9.36050318%2C3.85022603 9.14009241%2C4 8.89619049%2C4 L3.10411154%2C3.99967612 C2.86011295%2C3.99967612 2.63970218%2C3.85049182 2.54612427%2C3.62091703 C2.45254636%2C3.39075257 2.50387887%2C3.1279602 2.67721068%2C2.95184803 Z M9.32278932%2C9.04815197 L6.42691902%2C11.8201533 C6.31400684%2C11.9349407 6.16000931%2C12 6.00001816%2C12 C5.84002701%2C12 5.68660951%2C11.9355304 5.57311729%2C11.8201533 L2.67690865%2C9.04782809 C2.56157968%2C8.93058378 2.5%2C8.77343905 2.5%2C8.61383739 C2.5%2C8.53462623 2.51508074%2C8.4548254 2.54591891%2C8.3787591 C2.63949682%2C8.14977397 2.85990759%2C8 3.10380951%2C8 L8.89588846%2C8.00032388 C9.13988705%2C8.00032388 9.36029782%2C8.14950818 9.45387573%2C8.37908297 C9.54745364%2C8.60924743 9.49612113%2C8.8720398 9.32278932%2C9.04815197 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23B0B0B0%22%3E%3C%2Fpath%3E                %3Cg id%3D%22Group-3%22 transform%3D%22translate(2.500000%2C 0.000000)%22%3E                    %3Cpath d%3D%22M0.177210679%2C2.95184803 L3.07308098%2C0.17984669 C3.18599316%2C0.0650592945 3.33999069%2C5.32907052e-14 3.49998184%2C0 C3.65997299%2C-5.21804822e-14 3.81339049%2C0.0644696332 3.92688271%2C0.17984669 L6.82309135%2C2.95217191 C6.93842032%2C3.06941622 7%2C3.22656095 7%2C3.38616261 C7%2C3.46537377 6.98491926%2C3.5451746 6.95408109%2C3.6212409 C6.86050318%2C3.85022603 6.64009241%2C4 6.39619049%2C4 L0.604111544%2C3.99967612 C0.360112952%2C3.99967612 0.139702179%2C3.85049182 0.0461242714%2C3.62091703 C-0.0474536357%2C3.39075257 0.00387887328%2C3.1279602 0.177210679%2C2.95184803 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23AAAAAA%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M6.82278932%2C9.04815197 L3.92691902%2C11.8201533 C3.81400684%2C11.9349407 3.66000931%2C12 3.50001816%2C12 C3.34002701%2C12 3.18660951%2C11.9355304 3.07311729%2C11.8201533 L0.176908647%2C9.04782809 C0.0615796765%2C8.93058378 -1.77635684e-15%2C8.77343905 8.8817842e-16%2C8.61383739 C2.13162821e-14%2C8.53462623 0.0150807371%2C8.4548254 0.045918911%2C8.3787591 C0.139496818%2C8.14977397 0.359907591%2C8 0.603809512%2C8 L6.39588846%2C8.00032388 C6.63988705%2C8.00032388 6.86029782%2C8.14950818 6.95387573%2C8.37908297 C7.04745364%2C8.60924743 6.99612113%2C8.8720398 6.82278932%2C9.04815197 Z%22 id%3D%22Fill-1%22 fill%3D%22%236B6B6B%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.pm-body-wrapper .ct-table-wrapper .tableHeadFixed{display:table-row;position:absolute;top:0;z-index:99;overflow:hidden}.pm-body-wrapper .ct-table-wrapper .tableHeadFixed td,.pm-body-wrapper .ct-table-wrapper .tableHeadFixed th{overflow:hidden}.pm-body-wrapper .ct-table-wrapper .float-scrollbar{display:none;height:17px;position:absolute;bottom:0;width:100%}.pm-body-wrapper .ct-table-wrapper .float-scroll-filling{border:1px solid #fff;opacity:.01}.pm-body-wrapper .ct-table-wrapper .float-scroll-container{overflow-x:auto;overflow-y:hidden;height:17px}.ProseMirror-selectednode.ct-table-wrapper{outline:none}.ProseMirror-hideselection{caret-color:transparent}';
table_extension_styleInject(table_extension_css_248z$a);

function table_extension_assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function table_extension_classCallCheck$c(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function table_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function table_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) table_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) table_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function table_extension_getPrototypeOf$6(o) {
    table_extension_getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return table_extension_getPrototypeOf$6(o);
}
function table_extension_inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) table_extension_setPrototypeOf$6(subClass, superClass);
}
function _instanceof$b(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function table_extension_possibleConstructorReturn$6(self, call) {
    if (call && (table_extension_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return table_extension_assertThisInitialized$6(self);
}
function table_extension_setPrototypeOf$6(o, p) {
    table_extension_setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return table_extension_setPrototypeOf$6(o, p);
}
var table_extension_typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function table_extension_isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function table_extension_createSuper$6(Derived) {
    var hasNativeReflectConstruct = table_extension_isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = table_extension_getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = table_extension_getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return table_extension_possibleConstructorReturn$6(this, result);
    };
}
var table_extension_TableExtension = /*#__PURE__*/ function(NodeExtension) {
    table_extension_inherits$6(TableExtension, NodeExtension);
    var _super = table_extension_createSuper$6(TableExtension);
    function TableExtension() {
        table_extension_classCallCheck$c(this, TableExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.checkCommand = function(command, func) {
            return function(state, dispatch, view) {
                var provider = table_extension_assertThisInitialized$6(_this).provider;
                if ((provider === null || provider === void 0 ? void 0 : provider.checkCommand) && !provider.checkCommand(command, {
                    view: view
                })) {
                    return false;
                }
                return func && func(state, dispatch, view);
            };
        };
        return _this;
    }
    var _proto = TableExtension.prototype;
    _proto.plugin = function plugin(param) {
        var providers = param.providers, getView = param.getView, commands = param.commands, editorEventEmitter = param.editorEventEmitter;
        var provider = providers.get(this.name);
        this.provider = provider;
        return [
            columnResizing(provider, getView, {
                editorEventEmitter: editorEventEmitter
            }),
            tableEditing(provider, {
                editorEventEmitter: editorEventEmitter
            }),
            tableLayout(provider, {
                editorEventEmitter: editorEventEmitter
            }),
            stickyHeader(provider, {
                editorEventEmitter: editorEventEmitter
            }),
            scrollBar(provider),
            contextMenu(commands.table, {
                editorEventEmitter: editorEventEmitter
            })
        ];
    };
    _proto.keys = function keys() {
        return {
            Delete: table_extension_convertCommand(handleDelete()),
            Backspace: table_extension_convertCommand(table_extension_handleBackspace()),
            Tab: table_extension_convertCommand(handleTab(1)),
            "Shift-Tab": table_extension_convertCommand(handleTab(-1)),
            "Alt-ArrowUp": table_extension_convertCommand(this.checkCommand("addRowBefore", addRowBefore())),
            "Alt-ArrowDown": table_extension_convertCommand(this.checkCommand("addRowAfter", addRowAfter())),
            "Alt-ArrowLeft": table_extension_convertCommand(this.checkCommand("addColumnBefore", addColumnBefore())),
            "Alt-ArrowRight": table_extension_convertCommand(this.checkCommand("addColumnAfter", addColumnAfter())),
            "Mod-Shift-h": table_extension_convertCommand(setCellVerticalAlign("top")),
            "Mod-Shift-m": table_extension_convertCommand(setCellVerticalAlign("middle")),
            "Mod-Shift-d": table_extension_convertCommand(setCellVerticalAlign("bottom"))
        };
    };
    _proto.commands = function commands() {
        return {
            isInTable: function() {
                return isInTable;
            },
            canAddColumnBefore: function() {
                return canAddColumnBefore;
            },
            addColumnBefore: function() {
                return addColumnBefore();
            },
            addColumnAfter: function() {
                return addColumnAfter();
            },
            deleteColumn: function() {
                return deleteColumn();
            },
            canAddRowBefore: function() {
                return canAddRowBefore;
            },
            addRowBefore: function() {
                return addRowBefore();
            },
            addRowAfter: function() {
                return addRowAfter();
            },
            deleteRow: function() {
                return deleteRow();
            },
            canMergeCells: function() {
                return canMergeCells;
            },
            mergeCells: function() {
                return mergeCells();
            },
            canSplitCell: function() {
                return canSplitCell;
            },
            splitCell: function() {
                return splitCell();
            },
            deleteTable: function() {
                return deleteTable$1();
            },
            insertTable: function(args) {
                return insertTable(args);
            },
            hasRowHeader: function() {
                return function(state) {
                    if (!isInTable(state)) return false;
                    var table = selectedRect(state).table;
                    return hasRowHeader(table);
                };
            },
            toggleRowHeader: function() {
                return toggleRowHeader();
            },
            canToggleColHeader: function() {
                return canToggleColHeader;
            },
            hasColHeader: function() {
                return function(state) {
                    if (!isInTable(state)) return false;
                    var table = selectedRect(state).table;
                    return hasColHeader(table);
                };
            },
            toggleColHeader: function() {
                return toggleColHeader();
            },
            canToggleNumCol: function() {
                return canToggleNumCol;
            },
            hasNumCol: function() {
                return function(state) {
                    if (!isInTable(state)) return false;
                    var table = selectedRect(state).table;
                    return hasNumCol(table);
                };
            },
            toggleNumCol: function() {
                return toggleNumCol();
            },
            setCellBgColor: function(color) {
                return setCellBgColor(color);
            },
            isResponsive: function() {
                return isResponsive;
            },
            setResponsive: function() {
                return setResponsive();
            },
            setFixed: function() {
                return setFixed();
            },
            setCellVerticalAlign: function(align) {
                return setCellVerticalAlign(align);
            },
            setTableAttrs: function(attrs) {
                return setTableAttrs(attrs);
            },
            getTableAttrs: function() {
                return getTableAttrs();
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var getView = param.getView;
        return [
            new prosemirror_inputrules_dist["a" /* InputRule */](new RegExp(regexpTable), function(state, match, start, end) {
                var view = getView();
                if (!match || !(match === null || match === void 0 ? void 0 : match[1])) {
                    return false;
                }
                view.dispatch(view.state.tr.delete(start, end));
                var header = match[1].split("|").map(function(_) {
                    return _.trim();
                });
                insertTable({
                    rowCnt: 2,
                    colCnt: header.length,
                    headerData: header.map(function(i) {
                        return [
                            view.state.schema.nodes.paragraph.create(null, view.state.schema.text(i))
                        ];
                    })
                })(view.state, view.dispatch, view);
                // 返回空tr表示已经处理inputRule
                return view.state.tr;
            })
        ];
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        var tableTestReg = /<table[^>]*?data-pm-slice="/;
        var tablePMDataTestReg = /data-pm-slice="[^>]*?\[\]"/;
        if (html.includes('data-pm-slice="')) {
            if (!html.includes('data-pm-slice="none"')) {
                if (tableTestReg.test(html)) {
                    if (!tablePMDataTestReg.test(html)) {
                        html = html.replace(/<table[^>]*?data-pm-slice=.*?<td.*?>/g, "").replace(/<\/td><\/tr><\/tbody><\/table>$/g, "");
                    }
                }
            }
        }
        html = html.replace(/<tr[^>]*?>[^<]*?(<tr)/g, "$1") // 处理异常表格行
        .replace(/<col[^>]*?style="width: 0px;"[^<]*?>/g, "<col>"); // 自适应表格
        // 处理diffId
        var createDom = document.createElement("div");
        createDom.innerHTML = html;
        var cells = createDom.querySelectorAll("[data-cell-diff-id]");
        cells.forEach(function(h) {
            h.setAttribute("data-cell-diff-id", "ct-cell-diff-id-".concat(esm_browser_v4()));
        });
        var rows = createDom.querySelectorAll("[data-row-diff-id]");
        rows.forEach(function(h) {
            h.setAttribute("data-cell-diff-id", "ct-tr-diff-id-".concat(esm_browser_v4()));
        });
        return createDom.innerHTML;
    };
    _proto.transformPasted = function transformPasted(state, node) {
        // 处理从非学城复制来的表格，补上cell里的<p>
        var _state_schema_nodes = state.schema.nodes, table_cell = _state_schema_nodes.table_cell, table_header = _state_schema_nodes.table_header, paragraph = _state_schema_nodes.paragraph;
        if (node.type === table_cell || node.type === table_header) {
            if (node.content.childCount === 0) {
                return node.copy(dist["Fragment"].from([
                    paragraph.create()
                ]));
            }
        }
        return node;
    };
    _proto.handlePaste = function handlePaste(param) {
        var view = param.view, slice = param.slice;
        var _view_state = view.state, doc = _view_state.doc, _view_state_schema = _view_state.schema, table_cell = _view_state_schema.nodes.table_cell, _view_state_tr = _view_state.tr, sel = _view_state_tr.selection;
        if (!isInTable(view.state)) return false;
        if (!_instanceof$b(sel, cellSelection_CellSelection)) {
            if (!isEmptyCell(cellWrapping(sel.$head))) return false;
        }
        var cells = pastedCells(slice); // cells = null 说明复制内容不是一个单独的表格
        // 复制的是只包含一个单元格的单元格选区时，只相当于只复制单元格里的内容
        if (cells && cells.height === 1 && cells.width === 1) {
            slice.openStart = 3;
            slice.openEnd = 3;
            cells = null;
        }
        // 将复制内容填充到选区的每个单元格内
        if (_instanceof$b(sel, cellSelection_CellSelection) && !cells) {
            var tableNode = sel.$anchorCell.node(-1);
            var start = sel.$anchorCell.start(-1);
            var rect = TableMap.get(tableNode).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
            cells = {
                width: 1,
                height: 1,
                rows: [
                    dist["Fragment"].from(fitSlice(table_cell, slice))
                ]
            };
            cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
            insertCells(view.state, view.dispatch, start, rect, cells);
            return true;
        }
        if (cells) {
            var adjustedSel = sel;
            if (_instanceof$b(sel, cellSelection_CellSelection)) {
                sel.ranges.forEach(function(range) {
                    if (range.$from.pos < adjustedSel.from) {
                        adjustedSel = new prosemirror_state_dist["Selection"](range.$from, range.$to);
                    }
                });
            }
            var foundCell = findTableCell(adjustedSel);
            if (!foundCell) return false;
            var $cell = doc.resolve(foundCell.pos);
            var start1 = $cell.start(-1);
            insertCells(view.state, view.dispatch, start1, TableMap.get($cell.node(-1)).findCell($cell.pos - start1), cells);
            return true;
        }
        return false;
    };
    _proto.handleWashTransaction = function handleWashTransaction(param) {
        var view = param.view, slice = param.slice, tr = param.tr;
        var _view_state = view.state, _view_state_schema = _view_state.schema, table_cell = _view_state_schema.nodes.table_cell;
        var doc = tr.doc, sel = tr.selection;
        if (!isInTable(view.state)) return tr;
        if (!_instanceof$b(sel, cellSelection_CellSelection)) {
            if (!isEmptyCell(cellWrapping(sel.$head))) return tr;
        }
        var cells = pastedCells(slice); // cells = null 说明复制内容不是一个单独的表格
        // 复制的是只包含一个单元格的单元格选区时，只相当于只复制单元格里的内容
        if (cells && cells.height === 1 && cells.width === 1) {
            slice.openStart = 3;
            slice.openEnd = 3;
            cells = null;
        }
        // 将复制内容填充到选区的每个单元格内
        if (_instanceof$b(sel, cellSelection_CellSelection) && !cells) {
            var tableNode = sel.$anchorCell.node(-1);
            var start = sel.$anchorCell.start(-1);
            var rect = TableMap.get(tableNode).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
            cells = {
                width: 1,
                height: 1,
                rows: [
                    dist["Fragment"].from(fitSlice(table_cell, slice))
                ]
            };
            cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
            return insertCellsTr(view.state, tr, start, rect, cells);
        }
        if (cells) {
            var adjustedSel = sel;
            if (_instanceof$b(sel, cellSelection_CellSelection)) {
                sel.ranges.forEach(function(range) {
                    if (range.$from.pos < adjustedSel.from) {
                        adjustedSel = new prosemirror_state_dist["Selection"](range.$from, range.$to);
                    }
                });
            }
            var foundCell = findTableCell(adjustedSel);
            if (!foundCell) return tr;
            var $cell = doc.resolve(foundCell.pos);
            var start1 = $cell.start(-1);
            return insertCellsTr(view.state, tr, start1, TableMap.get($cell.node(-1)).findCell($cell.pos - start1), cells);
        }
        return tr;
    };
    table_extension_createClass(TableExtension, [
        {
            key: "name",
            get: function get() {
                return "table";
            }
        }
    ]);
    return TableExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/note-extension/index.js










/**
 * 统一样式前缀
 */ var note_extension_CLASSNAME_PREFIX = "ct";

function note_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function note_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return note_extension_arrayLikeToArray(arr);
}
function note_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function note_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function note_extension_toConsumableArray(arr) {
    return note_extension_arrayWithoutHoles(arr) || note_extension_iterableToArray(arr) || note_extension_unsupportedIterableToArray(arr) || note_extension_nonIterableSpread();
}
function note_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return note_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return note_extension_arrayLikeToArray(o, minLen);
}
var note_extension_noop = function() {};
function note_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var note_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function note_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = note_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && note_extension_isParagraph(content[size - 1]) && note_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var note_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : note_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var note_extension_execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : note_extension_noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, note_extension_toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

var note_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var note_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return note_extension_findParentNodeClosestToPos($from, predicate);
    };
};

function insertNote(type) {
    return function(state, dispatch, view) {
        var schema = state.schema;
        var _schema_nodes = schema.nodes, note = _schema_nodes.note, note_title = _schema_nodes.note_title, note_content = _schema_nodes.note_content;
        var titleNode = note_title.createAndFill();
        var contentNode = note_content.createAndFill();
        var noteNode = note.create({
            type: type
        }, dist["Fragment"].from([
            titleNode,
            contentNode
        ]));
        var transaction = note_extension_insertBlock(state, noteNode).transaction;
        var $from = transaction.selection.$from;
        var newSelection = prosemirror_state_dist["TextSelection"].findFrom($from, 1, true);
        dispatch(transaction.setSelection(newSelection).scrollIntoView());
        view.focus();
        return true;
    };
}

function note_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var note_extension_css_248z = '.ct-note-selected .ct-note{border-color:#fdc446}.ct-note-selected .ct-note[data-type=info]{border-color:#23bdd9}.ct-note-selected .ct-note[data-type=tip]{border-color:#53752d}.ct-note-selected .ct-note[data-type=warning]{border-color:#e75252}.ct-note{min-width:265px;min-height:42px;margin:8px 0;border:1px solid transparent;border-radius:4px;background-color:#fffbe6}.ct-note.ProseMirror-selectednode{border-color:#fdc446}.ct-note[data-type=info]{background-color:#e6ffff}.ct-note[data-type=info].ProseMirror-selectednode{border-color:#23bdd9}.ct-note[data-type=tip]{background-color:#f6ffed}.ct-note[data-type=tip].ProseMirror-selectednode{border-color:#53752d}.ct-note[data-type=warning]{background-color:#fff1f0}.ct-note[data-type=warning].ProseMirror-selectednode{border-color:#e75252}.ct-note.ProseMirror-selectednode{position:relative}.ct-note.ProseMirror-selectednode:after{z-index:2;position:absolute;content:"";left:-1px;right:-1px;top:-1px;bottom:-1px;background-color:#23bdd9;opacity:.2;pointer-events:none}.ct-note.ProseMirror-selectednode>.ct-note-content,.ct-note.ProseMirror-selectednode>.ct-note-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hidden-title{background:#fffbe6 url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395614592%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223358%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23FDC446%22 p-id%3D%223359%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 10px 11px}.hidden-title>.ct-note-title{display:none}.hidden-title[data-type=info]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395638204%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223862%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 0.448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z%22 fill%3D%22%233d91f2%22 p-id%3D%223863%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.hidden-title[data-type=tip]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395631927%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223694%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M550.4 573.76V601.6a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-0.96c0.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8 0.96c-0.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048v61.952a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z%22 fill%3D%22%2370B123%22 p-id%3D%223695%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.hidden-title[data-type=warning]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395624224%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223526%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23F05E50%22 p-id%3D%223527%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-note-title{min-height:24px;padding:8px 0;font-size:14px;font-weight:700;color:#333;line-height:24px}.ct-note-title>.ct-note-title-text{position:relative;display:inline-block;min-height:24px;padding-left:36px;color:#333;line-height:24px;font-family:PingFangSC-Medium;font-size:13px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395614592%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223358%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23FDC446%22 p-id%3D%223359%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat;background-position:10px 3px}[data-type=info]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395638204%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223862%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 0.448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z%22 fill%3D%22%233d91f2%22 p-id%3D%223863%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}[data-type=tip]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395631927%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223694%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M550.4 573.76V601.6a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-0.96c0.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8 0.96c-0.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048v61.952a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z%22 fill%3D%22%2370B123%22 p-id%3D%223695%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}[data-type=warning]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395624224%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223526%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23F05E50%22 p-id%3D%223527%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-note-content{padding:0 8px 0 36px}.ct-note-content p{margin:8px 0}';
note_extension_styleInject(note_extension_css_248z);

var note_extension_IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var note_extension_Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(note_extension_Keycodes || (note_extension_Keycodes = {}));

var note_extension_AFTER_INSERT = "after_insert";

function note_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function note_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function note_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function note_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function note_extension_slicedToArray(arr, i) {
    return note_extension_arrayWithHoles(arr) || note_extension_iterableToArrayLimit(arr, i) || note_extension_unsupportedIterableToArray$1(arr, i) || note_extension_nonIterableRest();
}
function note_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return note_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return note_extension_arrayLikeToArray$1(o, minLen);
}
var note_extension_getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var note_extension_setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = note_extension_getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = note_extension_slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var note_extension_emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        Object(react_dom["render"])(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var note_extension_emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = react_dom_default.a.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

var note_extension_css_248z$1 = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
note_extension_styleInject(note_extension_css_248z$1);

function note_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function note_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var note_extension_SHOW = "show";
var note_extension_HIDE = "hide";
var note_extension_Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        note_extension_classCallCheck(this, Popover);
        this.popoverState = note_extension_HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(note_extension_classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === note_extension_SHOW && !forceUpdate) {
            return;
        }
        if (!target || !note_extension_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === note_extension_HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            note_extension_setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            note_extension_emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(note_extension_classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        Object(react_dom["render"])(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(note_extension_classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(note_extension_SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === note_extension_HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        note_extension_emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(note_extension_HIDE);
    };
    _proto.destroy = function destroy() {
        note_extension_emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function note_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function note_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function note_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function note_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            note_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var note_extension_DEFAULT_HEIGHT = 34;
var note_extension_DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var note_extension_PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        note_extension_classCallCheck$1(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = note_extension_objectSpread({}, note_extension_DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !note_extension_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new note_extension_Popover(note_extension_objectSpread({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return note_extension_DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var note_extension_css_248z$2 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
note_extension_styleInject(note_extension_css_248z$2);

var note_extension_css_248z$3 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
note_extension_styleInject(note_extension_css_248z$3);

var note_extension_css_248z$4 = '.ct-checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-checkbox input{display:none}.ct-checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-checkbox input:checked+.checkbox-bg:after{content:" ";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
note_extension_styleInject(note_extension_css_248z$4);

function note_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function note_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function note_extension_getPrototypeOf(o) {
    note_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return note_extension_getPrototypeOf(o);
}
function note_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) note_extension_setPrototypeOf(subClass, superClass);
}
function note_extension_possibleConstructorReturn(self, call) {
    if (call && (note_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return note_extension_assertThisInitialized(self);
}
function note_extension_setPrototypeOf(o, p) {
    note_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return note_extension_setPrototypeOf(o, p);
}
var note_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function note_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function note_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = note_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = note_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = note_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return note_extension_possibleConstructorReturn(this, result);
    };
}
var note_extension_noop$1 = function() {};
var note_extension_CheckBox = /*#__PURE__*/ function(Component) {
    note_extension_inherits(CheckBox, Component);
    var _super = note_extension_createSuper(CheckBox);
    function CheckBox() {
        note_extension_classCallCheck$2(this, CheckBox);
        return _super.apply(this, arguments);
    }
    var _proto = CheckBox.prototype;
    _proto.render = function render() {
        // 设置 onChange 的默认值，防止出现警告
        var _this_props = this.props, checked = _this_props.checked, onClick = _this_props.onClick, _this_props_onChange = _this_props.onChange, onChange = _this_props_onChange === void 0 ? note_extension_noop$1 : _this_props_onChange, children = _this_props.children;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: note_extension_classNamePrefix("checkbox"),
            onClick: onClick
        }, /*#__PURE__*/ react_default.a.createElement("input", {
            type: "checkbox",
            checked: checked,
            onChange: onChange
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "checkbox-bg"
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "checkbox-label"
        }, children));
    };
    return CheckBox;
}(react["Component"]);

var note_extension_css_248z$5 = '.ct-icon-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-icon-item svg{margin:4px 0 0 4px}.ct-icon-item.close{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-icon-item.error{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E9%94%99%E8%AF%AF%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-296.000000%2C -544.000000)%22 fill%3D%22%23F05E50%22%3E            %3Cpath fill%3D%22%23F05E50%22 d%3D%22M304%2C544 C308.41824%2C544 312%2C547.58176 312%2C552 C312%2C556.41824 308.41824%2C560 304%2C560 C299.58176%2C560 296%2C556.41824 296%2C552 C296%2C547.58176 299.58176%2C544 304%2C544 Z M299.2%2C552 C299.2%2C552.667362 299.735663%2C553.2 300.396436%2C553.2 L307.603564%2C553.2 C308.256356%2C553.2 308.8%2C552.662742 308.8%2C552 C308.8%2C551.332638 308.264337%2C550.8 307.603564%2C550.8 L300.396436%2C550.8 C299.743644%2C550.8 299.2%2C551.337258 299.2%2C552 Z%22 id%3D%22tost-%E9%94%99%E8%AF%AF%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.success{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E6%88%90%E5%8A%9F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-222.000000%2C -544.000000)%22 fill%3D%22%2370B123%22%3E            %3Cpath fill%3D%22%2370B123%22 d%3D%22M228.93934%2C552.865274 L226.802094%2C550.728029 C226.3405%2C550.266435 225.576187%2C550.26192 225.107558%2C550.730549 C224.635662%2C551.202445 224.637801%2C551.957848 225.105038%2C552.425085 L228.079926%2C555.399974 C228.314894%2C555.634941 228.628301%2C555.751472 228.941218%2C555.747447 C229.252578%2C555.751485 229.564571%2C555.634156 229.802094%2C555.396633 L234.898303%2C550.300424 C235.359897%2C549.83883 235.364412%2C549.074517 234.895783%2C548.605887 C234.423887%2C548.133991 233.668484%2C548.13613 233.201247%2C548.603367 L228.93934%2C552.865274 Z M238%2C552 C238%2C553.451396 237.642365%2C554.789924 236.927083%2C556.015625 C236.211802%2C557.241326 235.241326%2C558.211802 234.015625%2C558.927083 C232.789924%2C559.642365 231.451396%2C560 230%2C560 C228.548604%2C560 227.210076%2C559.642365 225.984375%2C558.927083 C224.758674%2C558.211802 223.788198%2C557.241326 223.072917%2C556.015625 C222.357635%2C554.789924 222%2C553.451396 222%2C552 C222%2C550.548604 222.357635%2C549.210076 223.072917%2C547.984375 C223.788198%2C546.758674 224.758674%2C545.788198 225.984375%2C545.072917 C227.210076%2C544.357635 228.548604%2C544 230%2C544 C231.451396%2C544 232.789924%2C544.357635 234.015625%2C545.072917 C235.241326%2C545.788198 236.211802%2C546.758674 236.927083%2C547.984375 C237.642365%2C549.210076 238%2C550.548604 238%2C552 Z%22 id%3D%22tost-%E6%88%90%E5%8A%9F%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.edit{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E7%BC%96%E8%BE%91%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-164.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E7%BC%96%E8%BE%91%22 transform%3D%22translate(164.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M13%2C7 C13.2761424%2C7 13.5%2C7.22385763 13.5%2C7.5 C13.5%2C7.77614237 13.2761424%2C8 13%2C8 L8%2C8 L8%2C8 C7.44771525%2C8 7%2C8.44771525 7%2C9 L7%2C9 L7%2C18 C7%2C18.5522847 7.44771525%2C19 8%2C19 L17%2C19 C17.5522847%2C19 18%2C18.5522847 18%2C18 L18%2C18 L18%2C13 C18%2C12.7238576 18.2238576%2C12.5 18.5%2C12.5 C18.7761424%2C12.5 19%2C12.7238576 19%2C13 L19%2C11 L19%2C18 L19%2C18 C19%2C19.1045695 18.1045695%2C20 17%2C20 L8%2C20 L8%2C20 C6.8954305%2C20 6%2C19.1045695 6%2C18 L6%2C9 L6%2C9 C6%2C7.8954305 6.8954305%2C7 8%2C7 L8%2C7 L15%2C7 L13%2C7 Z M19.8535534%2C6.14644661 C20.0488155%2C6.34170876 20.0488155%2C6.65829124 19.8535534%2C6.85355339 L13.4895924%2C13.2175144 C13.2943302%2C13.4127766 12.9777477%2C13.4127766 12.7824856%2C13.2175144 C12.5872234%2C13.0222523 12.5872234%2C12.7056698 12.7824856%2C12.5104076 L19.1464466%2C6.14644661 C19.3417088%2C5.95118446 19.6582912%2C5.95118446 19.8535534%2C6.14644661 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.link{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(-908.000000%2C -565.000000)%22%3E      %3Cg transform%3D%22translate(8.500000%2C 565.000000)%22%3E        %3Cg transform%3D%22translate(0.500000%2C 0.000000)%22 fill%3D%22%23666666%22%3E          %3Cg transform%3D%22translate(899.000000%2C 0.000000)%22%3E            %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L13.4302151%2C11.1475865 L12.7191158%2C11.8586857 L13.4302151%2C12.5697849 C14.2156736%2C13.3552435 14.2156736%2C14.6287234 13.4302151%2C15.4141819 L13.2808842%2C15.5635128 L12.9253346%2C15.2079632 L13.9919834%2C16.274612 L16.1252811%2C14.1413143 L15.4141819%2C13.4302151 L17.4052599%2C11.439137 C18.1907184%2C10.6536785 18.1907184%2C9.38019862 17.4052599%2C8.59474009 C16.6198014%2C7.80928156 15.3463215%2C7.80928156 14.560863%2C8.59474009 L12.7191158%2C10.4364872 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.visitLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8E%BB%E6%9F%A5%E7%9C%8B%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-587.000000%2C -162.000000)%22%3E            %3Cg id%3D%22Group-8%22 transform%3D%22translate(62.000000%2C 128.000000)%22%3E                %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 34.000000)%22%3E%3C%2Fg%3E                %3Cg id%3D%22Group-2%22 transform%3D%22translate(0.000000%2C 34.000000)%22 fill%3D%22%23666666%22%3E                    %3Cg id%3D%22%E5%8E%BB%E6%9F%A5%E7%9C%8B%22 transform%3D%22translate(525.000000%2C 0.000000)%22%3E                        %3Cpath d%3D%22M6.67363116%2C16 L7.80156483%2C16 C8.83909243%2C17.7939653 10.7785899%2C19.0009766 13%2C19.0009766 C16.3142478%2C19.0009766 19.0009766%2C16.3142478 19.0009766%2C13 C19.0009766%2C9.68575216 16.3142478%2C6.99902344 13%2C6.99902344 C10.7785899%2C6.99902344 8.83909243%2C8.20603473 7.80156483%2C10 L6.67363116%2C10 C7.7970951%2C7.63505267 10.207604%2C6 13%2C6 C16.8659932%2C6 20%2C9.13400675 20%2C13 C20%2C16.8659932 16.8659932%2C20 13%2C20 C10.207604%2C20 7.7970951%2C18.3649473 6.67363116%2C16 Z M14.1464466%2C14.767767 L15.4142136%2C13.5 L6.62132034%2C13.5 C6.34517797%2C13.5 6.12132034%2C13.2761424 6.12132034%2C13 C6.12132034%2C12.7238576 6.34517797%2C12.5 6.62132034%2C12.5 L15.4142136%2C12.5 L14.1464466%2C11.232233 C13.9511845%2C11.0369709 13.9511845%2C10.7203884 14.1464466%2C10.5251263 C14.3417088%2C10.3298641 14.6582912%2C10.3298641 14.8535534%2C10.5251263 L16.9535151%2C12.6262866 C16.9607818%2C12.6327579 16.967905%2C12.6394779 16.9748737%2C12.6464466 C17.1701359%2C12.8417088 17.1701359%2C13.1582912 16.9748737%2C13.3535534 L14.8535534%2C15.4748737 C14.6582912%2C15.6701359 14.3417088%2C15.6701359 14.1464466%2C15.4748737 C13.9511845%2C15.2796116 13.9511845%2C14.9630291 14.1464466%2C14.767767 Z%22%3E%3C%2Fpath%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.cancelLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8F%96%E6%B6%88%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-96.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E6%8F%92%E5%85%A5%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(96.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L14.560863%2C8.59474009 C15.3463215%2C7.80928156 16.6198014%2C7.80928156 17.4052599%2C8.59474009 C18.1907184%2C9.38019862 18.1907184%2C10.6536785 17.4052599%2C11.439137 L15.4141819%2C13.4302151 L16.1252811%2C14.1413143 L13.9919834%2C16.274612 L12.9253346%2C15.2079632 L13.2808842%2C15.5635128 L13.4302151%2C15.4141819 C14.2156736%2C14.6287234 14.2156736%2C13.3552435 13.4302151%2C12.5697849 L12.7191158%2C11.8586857 L13.4302151%2C11.1475865 L12.7191158%2C10.4364872 Z M7.35355339%2C7.35355339 C7.54881554%2C7.15829124 7.86539803%2C7.15829124 8.06066017%2C7.35355339 L9.47487373%2C8.76776695 C9.67013588%2C8.9630291 9.67013588%2C9.27961159 9.47487373%2C9.47487373 C9.27961159%2C9.67013588 8.9630291%2C9.67013588 8.76776695%2C9.47487373 L7.35355339%2C8.06066017 C7.15829124%2C7.86539803 7.15829124%2C7.54881554 7.35355339%2C7.35355339 Z M16.3535534%2C16.3535534 C16.5488155%2C16.1582912 16.865398%2C16.1582912 17.0606602%2C16.3535534 L18.4748737%2C17.767767 C18.6701359%2C17.9630291 18.6701359%2C18.2796116 18.4748737%2C18.4748737 C18.2796116%2C18.6701359 17.9630291%2C18.6701359 17.767767%2C18.4748737 L16.3535534%2C17.0606602 C16.1582912%2C16.865398 16.1582912%2C16.5488155 16.3535534%2C16.3535534 Z M17%2C14.5 C17%2C14.2238576 17.2238576%2C14 17.5%2C14 L19.5%2C14 C19.7761424%2C14 20%2C14.2238576 20%2C14.5 C20%2C14.7761424 19.7761424%2C15 19.5%2C15 L17.5%2C15 C17.2238576%2C15 17%2C14.7761424 17%2C14.5 Z M6%2C11.5 L6%2C11.5 C6%2C11.2238576 6.22385763%2C11 6.5%2C11 L8.5%2C11 C8.77614237%2C11 9%2C11.2238576 9%2C11.5 C9%2C11.7761424 8.77614237%2C12 8.5%2C12 L6.5%2C12 L6.5%2C12 C6.22385763%2C12 6%2C11.7761424 6%2C11.5 L6%2C11.5 Z M11.5%2C6 L11.5%2C6 C11.7761424%2C6 12%2C6.22385763 12%2C6.5 L12%2C8.5 C12%2C8.77614237 11.7761424%2C9 11.5%2C9 C11.2238576%2C9 11%2C8.77614237 11%2C8.5 L11%2C6.5 L11%2C6.5 C11%2C6.22385763 11.2238576%2C6 11.5%2C6 L11.5%2C6 Z M14.5%2C17 C14.7761424%2C17 15%2C17.2238576 15%2C17.5 L15%2C19.5 C15%2C19.7761424 14.7761424%2C20 14.5%2C20 C14.2238576%2C20 14%2C19.7761424 14%2C19.5 L14%2C17.5 C14%2C17.2238576 14.2238576%2C17 14.5%2C17 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomin{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25%22 fill%3D%22%23666%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomout{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4-Copy%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}';
note_extension_styleInject(note_extension_css_248z$5);

var note_extension_css_248z$6 = '.ct-base-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-base-toolbar .split{width:1px;height:14px;margin-top:0;background:#d9d9d9}.ct-base-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-base-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}';
note_extension_styleInject(note_extension_css_248z$6);

var note_extension_css_248z$7 = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
note_extension_styleInject(note_extension_css_248z$7);

var note_extension_css_248z$8 = '.ct-note-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-note-toolbar .split{width:1px;height:14px;margin-top:0;background:#d8d8d8}.ct-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}.ct-note-toolbar .checkbox{display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-note-toolbar .checkbox input{display:none}.ct-note-toolbar .checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;margin-right:6px}.ct-note-toolbar .checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-note-toolbar .checkbox input:checked+.checkbox-bg:after{content:" ";display:inline-block;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
note_extension_styleInject(note_extension_css_248z$8);

/* eslint-disable jsx-a11y/label-has-associated-control */ function note_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function note_extension_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function note_extension_getPrototypeOf$1(o) {
    note_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return note_extension_getPrototypeOf$1(o);
}
function note_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) note_extension_setPrototypeOf$1(subClass, superClass);
}
function note_extension_possibleConstructorReturn$1(self, call) {
    if (call && (note_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return note_extension_assertThisInitialized$1(self);
}
function note_extension_setPrototypeOf$1(o, p) {
    note_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return note_extension_setPrototypeOf$1(o, p);
}
var note_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function note_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function note_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = note_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = note_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = note_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return note_extension_possibleConstructorReturn$1(this, result);
    };
}
var note_extension_Toolbar = /*#__PURE__*/ function(Component) {
    note_extension_inherits$1(Toolbar, Component);
    var _super = note_extension_createSuper$1(Toolbar);
    function Toolbar(props) {
        note_extension_classCallCheck$3(this, Toolbar);
        var _this;
        _this = _super.call(this, props);
        _this.container = null;
        _this.handleCheckboxChange = function(e) {
            e.stopPropagation();
            e.preventDefault();
            var hiddenTitle = _this.state.hiddenTitle;
            var toggleTitle = _this.props.toggleTitle;
            var newhiddenTitle = !hiddenTitle;
            _this.setState({
                hiddenTitle: newhiddenTitle
            });
            toggleTitle(newhiddenTitle);
        };
        _this.state = {
            hiddenTitle: props.hiddenTitle
        };
        return _this;
    }
    var _proto = Toolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var hiddenTitle = this.state.hiddenTitle;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            ref: function(r) {
                _this.container = r;
            },
            className: "".concat(note_extension_classNamePrefix("base-toolbar"), " ").concat(note_extension_classNamePrefix("note-toolbar"))
        }, /*#__PURE__*/ react_default.a.createElement(note_extension_CheckBox, {
            checked: !hiddenTitle,
            onClick: this.handleCheckboxChange
        }, "标题"));
    };
    return Toolbar;
}(react["Component"]);

function note_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function note_extension_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function note_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function note_extension_getPrototypeOf$2(o) {
    note_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return note_extension_getPrototypeOf$2(o);
}
function note_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) note_extension_setPrototypeOf$2(subClass, superClass);
}
function note_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            note_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function note_extension_possibleConstructorReturn$2(self, call) {
    if (call && (note_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return note_extension_assertThisInitialized$2(self);
}
function note_extension_setPrototypeOf$2(o, p) {
    note_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return note_extension_setPrototypeOf$2(o, p);
}
var note_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function note_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function note_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = note_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = note_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = note_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return note_extension_possibleConstructorReturn$2(this, result);
    };
}
var note_extension_NotePopover = /*#__PURE__*/ function(PluginView) {
    note_extension_inherits$2(NotePopover, PluginView);
    var _super = note_extension_createSuper$2(NotePopover);
    function NotePopover() {
        note_extension_classCallCheck$4(this, NotePopover);
        var _this;
        _this = _super.apply(this, arguments);
        /**
   * 获取当前选区位置
   */ _this.getPos = function() {
            var state = _this.view.state;
            return state.selection.from;
        };
        _this.getDom = function() {
            return _this.view.nodeDOM(_this.getPos());
        };
        _this.updateAttrs = function(data) {
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var foundNode = note_extension_findParentNode(function(node) {
                return node.type === state.schema.nodes.note;
            })(state.selection);
            if (!foundNode) {
                return;
            }
            var pos = foundNode.pos, node = foundNode.node;
            var tr = state.tr, schema = state.schema;
            var nodeType = schema.nodes.note;
            var attrs = note_extension_objectSpread$1({}, node.attrs, data);
            dispatch(tr.setNodeMarkup(pos, nodeType, attrs));
        };
        return _this;
    }
    var _proto = NotePopover.prototype;
    _proto.getNode = function getNode(view) {
        var state = view.state;
        var foundNode = note_extension_findParentNode(function(node) {
            return node.type === state.schema.nodes.note;
        })(state.selection);
        if (!foundNode) {
            return null;
        }
        var pos = foundNode.pos;
        return view.nodeDOM(pos);
    };
    _proto.getContent = function getContent() {
        var _this = this;
        var state = this.view.state;
        var foundNode = note_extension_findParentNode(function(node) {
            return node.type === state.schema.nodes.note;
        })(state.selection);
        if (!foundNode) {
            return null;
        }
        var hiddenTitle = foundNode.node.attrs.hiddenTitle;
        return /*#__PURE__*/ react_default.a.createElement(note_extension_Toolbar, {
            hiddenTitle: hiddenTitle,
            toggleTitle: function(value) {
                _this.updateAttrs({
                    hiddenTitle: value
                });
            }
        });
    };
    return NotePopover;
}(note_extension_PluginView);

function note_extension_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function note_extension_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function note_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function note_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) note_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) note_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function note_extension_getPrototypeOf$3(o) {
    note_extension_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return note_extension_getPrototypeOf$3(o);
}
function note_extension_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) note_extension_setPrototypeOf$3(subClass, superClass);
}
function note_extension_possibleConstructorReturn$3(self, call) {
    if (call && (note_extension_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return note_extension_assertThisInitialized$3(self);
}
function note_extension_setPrototypeOf$3(o, p) {
    note_extension_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return note_extension_setPrototypeOf$3(o, p);
}
var note_extension_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function note_extension_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function note_extension_createSuper$3(Derived) {
    var hasNativeReflectConstruct = note_extension_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = note_extension_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = note_extension_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return note_extension_possibleConstructorReturn$3(this, result);
    };
}
var note_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("note");
var note_extension_NoteExtension = /*#__PURE__*/ function(NodeExtension) {
    note_extension_inherits$3(NoteExtension, NodeExtension);
    var _super = note_extension_createSuper$3(NoteExtension);
    function NoteExtension() {
        note_extension_classCallCheck$5(this, NoteExtension);
        return _super.apply(this, arguments);
    }
    var _proto = NoteExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state_dist["Plugin"]({
            key: note_extension_pluginKey,
            props: {
                handleKeyDown: function(view, event) {
                    if (event.keyCode !== note_extension_Keycodes.BackSpace) {
                        return false;
                    }
                    var _view_state = view.state, sel = _view_state.selection;
                    if (sel.empty) {
                        var $anchor = sel.$anchor;
                        var parent = $anchor.node(-1);
                        /**
             * 如果在空的样式宏内则不进行任何处理
             */ var isBeganInNoteContent = parent && parent.type.name === "note_content" && parent.firstChild === $anchor.parent && $anchor.parentOffset === 0;
                        if (isBeganInNoteContent) {
                            return true;
                        }
                    }
                    return false;
                },
                decorations: function(state) {
                    var selection = state.selection, schema = state.schema, doc = state.doc;
                    var note = schema.nodes.note;
                    var foundNode = note_extension_findParentNode(function(node) {
                        return node.type === note;
                    })(selection);
                    if (foundNode) {
                        var deco = index_es["a" /* Decoration */].node(foundNode.pos, foundNode.node.nodeSize + foundNode.pos, {
                            nodeName: "div",
                            class: note_extension_classNamePrefix("note-selected")
                        });
                        return index_es["b" /* DecorationSet */].create(doc, [
                            deco
                        ]);
                    }
                }
            },
            view: function(view) {
                return new note_extension_NotePopover(view, {
                    className: note_extension_classNamePrefix("note-popover"),
                    isSticky: false
                });
            }
        });
    };
    _proto.commands = function commands(param) {
        var editorEventEmitter = param.editorEventEmitter;
        return {
            insertNote: note_extension_execAfterCommands(insertNote, function() {
                return editorEventEmitter.emit(note_extension_AFTER_INSERT, {
                    braceWidth: 300
                });
            })
        };
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        if (html.includes("ct-note")) {
            // 如果粘贴样式宏时，结构中没有 note_title 则手动添加上，todo: 感觉这里应该在复制逻辑里实现
            var createDom = document.createElement("div");
            createDom.innerHTML = html;
            var noteDoms = createDom.querySelectorAll(".ct-note");
            noteDoms.forEach(function(noteDom) {
                if (!noteDom.innerHTML.includes("ct-note-title")) {
                    var noteTitleDom = document.createElement("div");
                    noteTitleDom.className = "ct-note-title";
                    noteTitleDom.innerHTML = '<span class="ct-note-title-text"></span>';
                    noteDom.insertBefore(noteTitleDom, noteDom.firstChild);
                }
            });
            html = createDom.innerHTML;
        }
        var noteTestReg = /class="ct-note-[^>]*?data-pm-slice="/;
        var noteExecReg = /class="ct-note-[^>]*>([\s\S]*?)<\/div>/;
        if (html.includes('data-pm-slice="')) {
            if (!html.includes('data-pm-slice="none"')) {
                if (noteTestReg.test(html)) {
                    html = noteExecReg.exec(html)[1];
                }
            }
        }
        return html;
    };
    note_extension_createClass(NoteExtension, [
        {
            key: "name",
            get: function get() {
                return "note";
            }
        }
    ]);
    return NoteExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/collapse-extension/index.js







/**
 * 统一样式前缀
 */ var collapse_extension_CLASSNAME_PREFIX = "ct";

function collapse_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function collapse_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return collapse_extension_arrayLikeToArray(arr);
}
function collapse_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function collapse_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function collapse_extension_toConsumableArray(arr) {
    return collapse_extension_arrayWithoutHoles(arr) || collapse_extension_iterableToArray(arr) || collapse_extension_unsupportedIterableToArray(arr) || collapse_extension_nonIterableSpread();
}
function collapse_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return collapse_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return collapse_extension_arrayLikeToArray(o, minLen);
}
var collapse_extension_noop = function() {};
function collapse_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var collapse_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function collapse_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = collapse_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && collapse_extension_isParagraph(content[size - 1]) && collapse_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var collapse_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : collapse_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var collapse_extension_execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : collapse_extension_noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, collapse_extension_toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

var collapse_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var collapse_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return collapse_extension_findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var collapse_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

// 查找 title 节点的次数
var SEARCH_COUNT = 4;
// 判断当前节点是否为展开宏的 title 节点
var titleCompare = function(item) {
    var _item_type;
    return (item === null || item === void 0 ? void 0 : (_item_type = item.type) === null || _item_type === void 0 ? void 0 : _item_type.name) === "collapse_title";
};
// 查找当前展开宏内部的 title 节点
function getTitleSelection(tr) {
    var titlePos;
    var addNum = 1;
    var titleSelection;
    var getTitle = function getTitle1() {
        titlePos = tr.selection.$from.pos + addNum++;
        titleSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, titlePos);
        if (titleSelection.$from.nodeBefore && titleCompare(titleSelection.$from.nodeBefore)) {
            titleSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, titlePos - 1);
            return titleSelection;
        }
        var collapseTitle = collapse_extension_findParentNode(titleCompare)(titleSelection);
        if (!collapseTitle && addNum < SEARCH_COUNT) {
            // 目前最多找三次就可以找到
            return getTitle();
        }
        return titleSelection;
    };
    return getTitle();
}
function insertCollapse() {
    return function(state, dispatch, view) {
        var schema = state.schema;
        var _schema_nodes = schema.nodes, collapse = _schema_nodes.collapse, collapse_title = _schema_nodes.collapse_title, collapse_content = _schema_nodes.collapse_content;
        var titleNode = collapse_title.createAndFill();
        var contentNode = collapse_content.createAndFill();
        var collapseNode = collapse.create(null, dist["Fragment"].from([
            titleNode,
            contentNode
        ]));
        var transaction = collapse_extension_insertBlock(state, collapseNode).transaction;
        // 需要确定 pos 在 collapse_title 里面，否则会出现位置错误的现象
        var newSelection = getTitleSelection(transaction);
        transaction.setSelection(newSelection);
        transaction.insertText("点击展开内容", newSelection.from);
        dispatch(transaction.scrollIntoView());
        view.focus();
        return true;
    };
}

function collapse_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var collapse_extension_css_248z = '.ct-collapse{min-width:267px;margin:8px 0;padding:8px;border-radius:2px}.ct-collapse.active>.ct-collapse-title{padding-bottom:8px}.ct-collapse.active>.ct-collapse-title .ct-collapse-title-text:before{transform:rotate(0deg)}.ct-collapse.active>.ct-collapse-content{display:block;height:auto;padding:8px 24px;border-radius:2px}.ct-collapse .ct-collapse-title{line-height:16px}.ct-collapse .ct-collapse-title>.ct-collapse-title-text{position:relative;padding-left:24px;color:#4d4d4d;font-family:PingFangSC-Medium;font-size:13px;vertical-align:top}.ct-collapse .ct-collapse-title>.ct-collapse-title-text:before{position:absolute;top:2px;left:3px;content:"";width:16px;height:16px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22        %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526953416889%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22     p-id%3D%223453%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%228%22 height%3D%228%22%3E    %3Cdefs%3E        %3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E    %3C%2Fdefs%3E    %3Cpath d%3D%22M375.966782 310.02559401L28.2073 642.809787a89.339756 89.339756 0 0 0 0 130.169816 99.323282 99.323282 0 0 0 136.057537 0L512.024319 440.323405 859.7838 773.107597a99.323282 99.323282 0 0 0 136.057538 0 89.339756 89.339756 0 0 0 0-130.169817l-347.759482-332.784192-65.916869-59.389179a105.722978 105.722978 0 0 0-140.281336 0l-65.916869 59.389179z%22          fill%3D%22%23747272%22 p-id%3D%223454%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%;transform:rotate(-180deg);transition:transform .2s;cursor:pointer}.ct-collapse>.ct-collapse-content{height:.1px;padding:0;background:transparent;overflow:hidden}.ProseMirror .ct-collapse{overflow:hidden}.ProseMirror .ct-collapse.active>.ct-collapse-content{display:block;height:auto;border-radius:2px}.ProseMirror .ct-collapse>.ct-collapse-content{display:none;overflow:unset}.ProseMirror .ct-collapse:hover{background-color:#f6f6f6}.ProseMirror .ct-collapse:hover>.ct-collapse-content{background-color:#fff}.ProseMirror .ct-collapse-show.ct-collapse{background-color:#f6f6f6;border:1px solid #ddd}.ProseMirror .ct-collapse-show.ct-collapse>.ct-collapse-content{background-color:#f6f6f6}.ProseMirror .ct-collapse-show.active>.ct-collapse-content{background-color:#fff;border:1px solid #ddd}.ProseMirror-selectednode.ct-collapse{border:1px solid #1c6cdc}.ProseMirror .ct-collapse.ProseMirror-selectednode{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pm-body-wrapper .ct-collapse-title-text{cursor:pointer}';
collapse_extension_styleInject(collapse_extension_css_248z);

var collapse_extension_AFTER_INSERT = "after_insert";

function collapse_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function collapse_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function collapse_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function collapse_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) collapse_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) collapse_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function collapse_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function collapse_extension_getPrototypeOf(o) {
    collapse_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return collapse_extension_getPrototypeOf(o);
}
function collapse_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) collapse_extension_setPrototypeOf(subClass, superClass);
}
function collapse_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            collapse_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function collapse_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function collapse_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        collapse_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function collapse_extension_possibleConstructorReturn(self, call) {
    if (call && (collapse_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return collapse_extension_assertThisInitialized(self);
}
function collapse_extension_setPrototypeOf(o, p) {
    collapse_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return collapse_extension_setPrototypeOf(o, p);
}
var collapse_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function collapse_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function collapse_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = collapse_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = collapse_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = collapse_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return collapse_extension_possibleConstructorReturn(this, result);
    };
}
var collapse_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("collapse");
var collapse_extension_CLS_PREFIX = collapse_extension_classNamePrefix("collapse");
var nodeCompare = function(item) {
    return item.type && item.type.name === "collapse";
};
var collapse_extension_CollapseExtension = /*#__PURE__*/ function(NodeExtension) {
    collapse_extension_inherits(CollapseExtension, NodeExtension);
    var _super = collapse_extension_createSuper(CollapseExtension);
    function CollapseExtension() {
        collapse_extension_classCallCheck(this, CollapseExtension);
        return _super.apply(this, arguments);
    }
    var _proto = CollapseExtension.prototype;
    _proto.plugin = function plugin(param) {
        var getState = param.getState;
        return new prosemirror_state_dist["Plugin"]({
            key: collapse_extension_pluginKey,
            props: {
                handleClick: function(view, pos, e) {
                    var target = e.target;
                    var isTitle = target.classList.contains("".concat(collapse_extension_CLS_PREFIX, "-title-text"));
                    var dis = e.clientX - target.getBoundingClientRect().left;
                    var isCollapseWidget = isTitle && dis > 2 && dis < 20;
                    if (isCollapseWidget) {
                        var state = view.state, dispatch = view.dispatch;
                        var tr = state.tr;
                        var collapse = collapse_extension_findParentNode(nodeCompare)({
                            $from: tr.doc.resolve(pos)
                        });
                        if (collapse) {
                            var attrs = collapse.node.attrs;
                            dispatch(tr.setNodeMarkup(collapse.pos, null, collapse_extension_objectSpreadProps(collapse_extension_objectSpread({}, attrs), {
                                active: !attrs.active
                            })).scrollIntoView());
                        }
                    }
                    return false;
                },
                decorations: function(state) {
                    var selection = state.selection;
                    var collapse = collapse_extension_findParentNode(function(item) {
                        return item.type && item.type.name === "collapse";
                    })(selection);
                    if (collapse) {
                        var attrs = {
                            class: "".concat(collapse_extension_CLS_PREFIX, "-show")
                        };
                        var deco = index_es["a" /* Decoration */].node(collapse.pos, collapse.pos + collapse.node.nodeSize, attrs);
                        return index_es["b" /* DecorationSet */].create(state.doc, [
                            deco
                        ]);
                    }
                    return index_es["b" /* DecorationSet */].empty;
                },
                transformPasted: function transformPasted(slice) {
                    var state = getState();
                    var schema = state.schema;
                    if (!collapse_extension_canInsertTypes(state)) {
                        var content = slice.content;
                        var text = content.textBetween(0, content.size);
                        var textNode = schema.text(text);
                        return new dist["Slice"](dist["Fragment"].from([
                            textNode
                        ]), 0, 0);
                    }
                    return slice;
                }
            }
        });
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, editorEventEmitter = param.editorEventEmitter;
        return {
            insert: collapse_extension_execAfterCommands(insertCollapse, function() {
                return editorEventEmitter.emit(collapse_extension_AFTER_INSERT, {
                    braceWidth: 300
                });
            }),
            isDisabled: function() {
                return function() {
                    return !collapse_extension_canInsertTypes(getState());
                };
            }
        };
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        if (html.includes("ct-collapse")) {
            // 如果粘贴展开宏时，结构中没有 collapse_content 或 ct—collapse-title 则手动添加上，todo: 之后在复制逻辑里实现
            var createDom = document.createElement("div");
            createDom.innerHTML = html;
            var collapseDoms = createDom.querySelectorAll(".ct-collapse");
            collapseDoms.forEach(function(collapseDom) {
                if (!collapseDom.querySelector(".ct-collapse-content")) {
                    var collapseContentDom = document.createElement("div");
                    collapseContentDom.className = "ct-collapse-content";
                    collapseContentDom.innerHTML = "<p></p>";
                    collapseDom.appendChild(collapseContentDom);
                } else if (!collapseDom.querySelector(".ct-collapse-title")) {
                    var collapseTitleDom = document.createElement("div");
                    collapseTitleDom.className = "ct-collapse-title";
                    collapseTitleDom.innerHTML = '<span class="ct-collapse-title-text" spellcheck="false"></span>';
                    collapseDom.insertBefore(collapseTitleDom, collapseDom.children[0]);
                }
            });
            html = createDom.innerHTML;
        }
        var collapseTestReg = /class="ct-collapse-[^>]*?data-pm-slice="/;
        var collapseExecReg = /class="ct-collapse-[^>]*>([\s\S]*?)<\/div>/;
        if (html.includes('data-pm-slice="')) {
            if (!html.includes('data-pm-slice="none"')) {
                if (collapseTestReg.test(html)) {
                    html = collapseExecReg.exec(html)[1];
                }
            }
        }
        return html;
    };
    collapse_extension_createClass(CollapseExtension, [
        {
            key: "name",
            get: function get() {
                return "collapse";
            }
        }
    ]);
    return CollapseExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/blockquote-extension/index.js








function blockquote_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var blockquote_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var blockquote_extension_findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return blockquote_extension_findParentNodeClosestToPos($from, predicate);
    };
};
var blockquote_extension_isNodeSelection = function(selection) {
    return blockquote_extension_instanceof(selection, prosemirror_state_dist["NodeSelection"]);
};
var blockquote_extension_equalNodeType = function(nodeType, node) {
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var blockquote_extension_findSelectedNodeOfType = function(nodeType) {
    return function(selection) {
        if (blockquote_extension_isNodeSelection(selection)) {
            var node = selection.node, $from = selection.$from;
            if (blockquote_extension_equalNodeType(nodeType, node)) {
                return {
                    node: node,
                    pos: $from.pos,
                    depth: $from.depth
                };
            }
        }
    };
};
function closestListInAncestor(state) {
    var selection = state.selection, schema = state.schema;
    var _schema_nodes = schema.nodes, ordered_list = _schema_nodes.ordered_list, bullet_list = _schema_nodes.bullet_list, task_list = _schema_nodes.task_list;
    var listTypes = [
        ordered_list,
        bullet_list,
        task_list
    ];
    return blockquote_extension_findParentNode(function(node) {
        return listTypes.includes(node.type);
    })(selection);
}

function blockquote_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var toggleBlockquote = function(type, schema) {
    return function() {
        return function(state, dispatch, view) {
            var selection = state.selection, _state_selection = state.selection, $from = _state_selection.$from, $to = _state_selection.$to, from = _state_selection.from, tr = state.tr;
            var predicate = function(node) {
                return node.type === schema.nodes.blockquote;
            };
            var target = blockquote_extension_findParentNode(predicate)(selection);
            if (blockquote_extension_instanceof$1(selection, gap_cursor_extension["a" /* GapCursor */]) && selection.empty) {
                var gapCursorType = selection.gapCursorType;
                if (!target) {
                    if (gapCursorType === gap_cursor_extension["c" /* gapCursorSituation */].beforeNode) {
                        var adjusted$to = state.doc.resolve($from.pos + $from.nodeAfter.nodeSize);
                        var nodeRange = new dist["NodeRange"]($from, adjusted$to, 0);
                        dispatch(tr.wrap(nodeRange, [
                            {
                                type: type
                            }
                        ]).setSelection(new gap_cursor_extension["a" /* GapCursor */](tr.doc.resolve(from + 1), gapCursorType)));
                        return true;
                    }
                    if (gapCursorType === gap_cursor_extension["c" /* gapCursorSituation */].afterNode) {
                        var adjusted$from = state.doc.resolve($from.pos - $from.nodeBefore.nodeSize);
                        var nodeRange1 = new dist["NodeRange"](adjusted$from, $to, 0);
                        dispatch(tr.wrap(nodeRange1, [
                            {
                                type: type
                            }
                        ]).setSelection(new gap_cursor_extension["a" /* GapCursor */](tr.doc.resolve(from + 1), gapCursorType)));
                        return true;
                    }
                } else {
                    var node = target.node, pos = target.pos;
                    var adjusted$from1 = state.doc.resolve(target.start + 1);
                    var adjusted$to1 = state.doc.resolve(pos + node.nodeSize - 1);
                    var nodeRange2 = new dist["NodeRange"](adjusted$from1, adjusted$to1, 1);
                    dispatch(tr.lift(nodeRange2, 0));
                    return true;
                }
            }
            // 在列表中使用引用需要特殊处理
            var range = null;
            var listNode = closestListInAncestor(state);
            if (listNode) {
                var start = listNode.pos;
                var end = listNode.pos + listNode.node.nodeSize - 1;
                var sel = prosemirror_state_dist["TextSelection"].create(state.doc, start, end);
                range = sel.$from.blockRange(selection.$to);
            }
            // 光标在inline节点中（如链接）
            if (!$from.parent.type.isBlock) {
                var parentBlockNode = blockquote_extension_findParentNode(function(node) {
                    return node.type.isBlock;
                })(selection);
                if (parentBlockNode) {
                    var sel1 = prosemirror_state_dist["TextSelection"].create(state.doc, parentBlockNode.pos);
                    range = sel1.$from.blockRange(selection.$to);
                }
            }
            var ret;
            if (target) {
                if (range) {
                    dispatch(tr.lift(range, Object(prosemirror_transform_dist["liftTarget"])(range)));
                    ret = true;
                } else {
                    ret = Object(dist_commands["lift"])(state, dispatch);
                }
            } else if (range) {
                dispatch(tr.wrap(range, [
                    {
                        type: type
                    }
                ]));
                ret = true;
            } else {
                ret = Object(dist_commands["wrapIn"])(type)(state, dispatch);
            }
            view.focus();
            return ret;
        };
    };
};

var blockquote_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(blockquote_extension_ExtensionType || (blockquote_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var blockquote_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var blockquote_extension_isNodeActive = function(type) {
    return function(// 与 lvzhe 确认过参数类型，仅存在 2 重可能：
    // - state
    // - state, dispatch, view
    state, dispatch, view) {
        var selection = state.selection;
        var predicate = function(node) {
            return node.type === type;
        };
        var _findSelectedNodeOfType;
        var parent = (_findSelectedNodeOfType = blockquote_extension_findSelectedNodeOfType(type)(selection)) !== null && _findSelectedNodeOfType !== void 0 ? _findSelectedNodeOfType : blockquote_extension_findParentNode(predicate)(selection);
        return !!parent;
    };
};

var isBlockquoteActive = function(type) {
    return function() {
        return blockquote_extension_isNodeActive(type);
    };
};

var blockquote_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 引用
var regexpQuote = /^>\s$/;

function blockquote_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var blockquote_extension_css_248z = ".ct-blockquote{padding-left:16px;border-left:2px solid #ddd;margin-left:8px;margin-right:0;color:#999}.ct-blockquote h1,.ct-blockquote h2,.ct-blockquote h3,.ct-blockquote h4,.ct-blockquote h5,.ct-blockquote h6,.ct-blockquote p,.ct-blockquote span{color:#999!important}";
blockquote_extension_styleInject(blockquote_extension_css_248z);

function blockquote_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function blockquote_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function blockquote_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function blockquote_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) blockquote_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) blockquote_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function blockquote_extension_getPrototypeOf(o) {
    blockquote_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return blockquote_extension_getPrototypeOf(o);
}
function blockquote_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) blockquote_extension_setPrototypeOf(subClass, superClass);
}
function blockquote_extension_possibleConstructorReturn(self, call) {
    if (call && (blockquote_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return blockquote_extension_assertThisInitialized(self);
}
function blockquote_extension_setPrototypeOf(o, p) {
    blockquote_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return blockquote_extension_setPrototypeOf(o, p);
}
var blockquote_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function blockquote_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function blockquote_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = blockquote_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = blockquote_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = blockquote_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return blockquote_extension_possibleConstructorReturn(this, result);
    };
}
var blockquote_extension_BlockquoteExtension = /*#__PURE__*/ function(NodeExtension) {
    blockquote_extension_inherits(BlockquoteExtension, NodeExtension);
    var _super = blockquote_extension_createSuper(BlockquoteExtension);
    function BlockquoteExtension() {
        blockquote_extension_classCallCheck(this, BlockquoteExtension);
        return _super.apply(this, arguments);
    }
    var _proto = BlockquoteExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type, schema = param.schema;
        return {
            toggle: toggleBlockquote(type, schema),
            isActive: isBlockquoteActive(type)
        };
    };
    _proto.keys = function keys(param) {
        var type = param.type, schema = param.schema;
        return {
            "Mod-8": blockquote_extension_convertCommand(toggleBlockquote(type, schema)())
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            Object(prosemirror_inputrules_dist["d" /* wrappingInputRule */])(new RegExp(regexpQuote), type)
        ];
    };
    blockquote_extension_createClass(BlockquoteExtension, [
        {
            key: "name",
            get: function get() {
                return "blockquote";
            }
        }
    ]);
    return BlockquoteExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/image-extension/index.js











/**
 * Enter 键的 keycode
 */ var KEY_CODE_ENTER = 13;
/**
 * 统一样式前缀
 */ var image_extension_CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var image_extension_ZERO_WIDTH_SPACE = "​";

var image_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : image_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function image_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var optionsMerge = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var res = image_extension_objectSpread({}, target, source);
    if (source.state) {
        res.state = optionsMerge(target.state, source.state);
    }
    if (source.props) {
        res.props = optionsMerge(target.props, source.props);
    }
    return res;
};
function UploaderOption(pluginOption, param) {
    var createUploadMask = param.createUploadMask;
    var uploaderOption = {
        state: {
            init: function init() {
                return index_es["b" /* DecorationSet */].empty;
            },
            apply: function apply(tr, set) {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                var action = tr.getMeta(this);
                if (action && action.add) {
                    var widget = createUploadMask(action.add, action.add.id);
                    var deco = index_es["a" /* Decoration */].widget(action.add.pos, widget, {
                        id: action.add.id,
                        ignoreSelection: true
                    });
                    set = set.add(tr.doc, [
                        deco
                    ]);
                } else if (action && action.remove) {
                    set = set.remove(set.find(null, null, function(spec) {
                        return spec.id === action.remove.id;
                    }));
                }
                return set;
            }
        },
        props: {
            decorations: function decorations(state) {
                return this.getState(state);
            }
        }
    };
    return optionsMerge(pluginOption, uploaderOption);
}

var image_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(image_extension_ExtensionType || (image_extension_ExtensionType = {}));

function image_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
// 向上寻找指定DOM节点
var image_extension_findParentDOM = function(targetDOM, assert) {
    var dom = targetDOM;
    while(true){
        if (!dom || dom.classList && dom.classList.contains("ProseMirror")) {
            return false;
        }
        if (assert(dom)) return dom;
        dom = dom.parentNode;
    }
};
var image_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
// 类型是否可以插入富文本
var image_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};
/*
 * 更新指定位置的节点属性
 * @param type 节点类型
 * @param data 属性数据
 * @param pos 节点位置
 * @param view EditorView 实例
 */ var updateNodeAttrs = function(param) {
    var type = param.type, data = param.data, pos = param.pos, view = param.view;
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr;
    var ctrlNode = tr.doc.nodeAt(pos);
    if (!ctrlNode) {
        return;
    }
    var attrs = image_extension_objectSpread$1({}, ctrlNode.attrs, data);
    tr.setNodeMarkup(pos, type, attrs);
    dispatch(tr);
};

/**
 * 通用配置
 */ var image_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");
/**
 * 图片最小尺寸限制
 */ var MIN_IMG_SIZE = 20;
/**
 * 图片展示默认大小
 */ var IMAGE_DEFAULT_WIDTH = 100;
var IMAGE_DEFAULT_MAX_WIDTH = 1000;
var IMAGE_DEFAULT_HEIGHT = 100;
// margin(4) && border(2)
var IMAGE_OFFSET = 4;

var image_extension_TABLE_HEIGHT_CHANGE = "table_height_change";

var IMAGE_MAX_HEIGHT = 600;
var image_extension_isCommonDisabled = function() {
    return function(state) {
        return !image_extension_canInsertTypes(state);
    };
};
/**
 * 计算规则，需要按顺序满足下面两项
 * 1. 高度不能高于 imageMaxHeight
 * 2. 宽度不能大于容器宽度
 */ function calculateSize(originWidth, originHeight, containerWidth) {
    var imageMaxHeight = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : IMAGE_MAX_HEIGHT;
    var result = {
        newOriginHeight: 0,
        newOriginWidth: 0,
        height: 0,
        width: 0
    };
    if (originHeight <= imageMaxHeight) {
        result.newOriginWidth = originWidth;
        result.newOriginHeight = originHeight;
        if (originWidth > containerWidth) {
            result.width = containerWidth;
            result.height = +(originHeight * containerWidth / originWidth).toFixed(2);
        } else {
            result.width = originWidth;
            result.height = originHeight;
        }
    } else {
        result.width = +(originWidth * imageMaxHeight / originHeight).toFixed(2);
        result.height = imageMaxHeight;
        result.newOriginWidth = result.width;
        result.newOriginHeight = imageMaxHeight;
        if (result.width > containerWidth) {
            result.width = containerWidth;
            // result.height = +(imageMaxHeight * containerWidth / result.width).toFixed(2);
            result.height = +(containerWidth / originWidth * originHeight).toFixed(2);
        }
    }
    return result;
}
/**
 * 处理例如图片加载完成导致的表格高度改变,用于表格侧边选择条高度更新
 * 详见https://ones.sankuai.com/ones/product/1859/workItem/task/detail/21026880
 * @param containerWrapper 图片类容器节点
 */ var emitTableHeightChange = function(containerWrapper, eventEmitter) {
    var parentTable = image_extension_findParentDOM(containerWrapper, function(n) {
        return n.tagName.toUpperCase() === "TABLE";
    });
    if (parentTable) {
        eventEmitter.emit(image_extension_TABLE_HEIGHT_CHANGE);
    }
};

var IMAGE_BORDER_KEY = "IMAGE_BORDER_KEY";

function image_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function image_extension_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                image_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                image_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function image_extension_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_extension_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function image_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var image_extension_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 向上寻找最近的display为block的DOM节点
 */ var findParentBlockNode = function(targetDOM) {
    var dom = targetDOM.parentNode;
    var flag = 0;
    // 防止查找节点层级过多
    while(flag < 40){
        if (!dom || dom.classList && dom.classList.contains("ProseMirror")) {
            return false;
        }
        if ([
            "block",
            "flex"
        ].includes(getComputedStyle(dom).display)) return dom;
        dom = dom.parentNode;
        flag++;
    }
    return null;
};
/**
 * 获取图片可设置的最大宽度
 */ function getMaxWidth(dom) {
    var blockNode = findParentBlockNode(dom);
    var defaultMaxWidth = 1920;
    if (!blockNode) {
        return defaultMaxWidth;
    }
    var parentTagName = blockNode.parentNode.tagName.toLowerCase();
    var maxWidth = blockNode.clientWidth - IMAGE_OFFSET;
    if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
        maxWidth = defaultMaxWidth;
    }
    return maxWidth;
}
var updateAttrs = function(data, pos) {
    return function(view) {
        var schema = view.state.schema;
        updateNodeAttrs({
            type: schema.nodes.image,
            data: data,
            pos: pos,
            view: view
        });
        return true;
    };
};
var getImageInfo = function() {
    var _ref = image_extension_asyncToGenerator(function(imgSrc) {
        return image_extension_generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    var img = new Image();
                    img.src = imgSrc;
                    img.onload = function() {
                        resolve({
                            width: img.width,
                            height: img.height
                        });
                    };
                    img.onerror = function() {
                        resolve(null);
                    };
                })
            ];
        });
    });
    return function getImageInfo(imgSrc) {
        return _ref.apply(this, arguments);
    };
}();
// 如果原图尺寸小于最小要求，进行调整
function adjustSize(data) {
    var width = data.width, height = data.height;
    if (width < MIN_IMG_SIZE && width <= height) {
        height = Math.ceil(20 * height / width);
        width = 20;
    } else if (height < MIN_IMG_SIZE && height <= width) {
        width = Math.ceil(20 * width / height);
        height = 20;
    }
    return image_extension_objectSpreadProps(image_extension_objectSpread$2({}, data), {
        width: width,
        height: height
    });
}
function formatImagData(data, view) {
    return _formatImagData.apply(this, arguments);
}
function _formatImagData() {
    _formatImagData = image_extension_asyncToGenerator(function(data, view) {
        var imgInfo, _tmp, editorDoc, _calculateSize, width, height;
        return image_extension_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = data.imgInfo;
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getImageInfo(data.src)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    imgInfo = _tmp;
                    if (!imgInfo) {
                        return [
                            2,
                            {}
                        ];
                    }
                    editorDoc = view.dom;
                    _calculateSize = calculateSize(imgInfo.width, imgInfo.height, editorDoc.getBoundingClientRect().width, data === null || data === void 0 ? void 0 : data.maxHeight), width = _calculateSize.width, height = _calculateSize.height;
                    data = adjustSize(image_extension_objectSpreadProps(image_extension_objectSpread$2({}, data.imgInfo, data), {
                        width: width,
                        height: height
                    }));
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _formatImagData.apply(this, arguments);
}
function image_extension_createUploadMask(param) {
    var src = param.src, width = param.width;
    var widget = document.createElement("span");
    widget.setAttribute("class", "ct-image");
    widget.setAttribute("data-type", "ct-progress");
    var imgArea = src ? '<img src="'.concat(src, '" style="width: ').concat(width, 'px;" />') : '<div class="image-empty" />';
    widget.innerHTML = "\n    ".concat(imgArea, '\n    <div class="ct-image-mask" style="min-width:400px">\n      <span class="ct-image-loading-icon"></span>\n      <span class="ct-image-progress-text">0%</span>\n      <span class="ct-image-reupload-container">\n        <span class="ct-image-reupload-text" style="top:10px;width:400px">抱歉，图片上传失败！<br style="line-height:0">如果是从外部拖动、粘贴过来的图片，请下载原图并重新上传。<br style="line-height:0">否则，请点击下方按钮进行重试。</span>\n        <button class="ct-image-reupload-btn">重试</button>\n      </span>\n    </div>\n  ');
    return widget;
}

function image_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function image_extension_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                image_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                image_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function image_extension_defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_extension_defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function image_extension_ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_extension_objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_extension_ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var image_extension_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 参考自官网Demo：https://prosemirror.net/examples/upload/
 */ function findPlaceholder(view, id) {
    var decos = image_extension_pluginKey.getState(view.state);
    var found = decos.find(null, null, function(spec) {
        return spec.id === id;
    });
    if (found.length) {
        return {
            pos: found[0].from,
            node: found[0].type.toDOM
        };
    }
    return null;
}
// 如果原图尺寸小于最小要求，进行调整
function adjustSize$1(data) {
    var width = data.width, height = data.height;
    if (width < MIN_IMG_SIZE && width <= height) {
        height = Math.ceil(20 * height / width);
        width = 20;
    } else if (height < MIN_IMG_SIZE && height <= width) {
        width = Math.ceil(20 * width / height);
        height = 20;
    }
    return image_extension_objectSpreadProps$1(image_extension_objectSpread$3({}, data), {
        width: width,
        height: height
    });
}
var onUpload = function(view, provider, pos) {
    // 使用 retry 标记是否为重传
    return function() {
        var _ref = image_extension_asyncToGenerator$1(function(file, retry) {
            var customUpload, blobUrl, imgData, _tmp, id, ret, attrs, _view_state, tr, schema, image, onProgress, data, _tmp1, placeholder, e, placeholder1, node, $btnUpload;
            return image_extension_generator$1(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customUpload = typeof file === "function" ? file : null;
                        blobUrl = customUpload ? "" : file.src || URL.createObjectURL(file);
                        if (!customUpload) return [
                            3,
                            1
                        ];
                        _tmp = null;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            formatImagData({
                                src: blobUrl
                            }, view)
                        ];
                    case 2:
                        _tmp = adjustSize$1.apply(void 0, [
                            _state.sent()
                        ]);
                        _state.label = 3;
                    case 3:
                        imgData = _tmp;
                        id = esm_browser_v4();
                        if (provider.beforeUpload) {
                            ret = provider.beforeUpload(file, id);
                            // 只有当校验函数显示返回 false 时才表示校验不通过
                            if (ret === false) {
                                view.focus();
                                return [
                                    2
                                ];
                            }
                        }
                        attrs = {
                            border: +sessionStorage.getItem(IMAGE_BORDER_KEY) === 1,
                            name: "image.jpeg",
                            src: blobUrl
                        };
                        _view_state = view.state, tr = _view_state.tr, schema = _view_state.schema;
                        image = schema.nodes.image;
                        // const isReUpload = !!pos;
                        if (typeof pos !== "number") pos = tr.selection.from;
                        if (!retry && !tr.selection.empty) {
                            tr.deleteSelection();
                        }
                        // 插入零宽度字符占位，并设置新选区，防止批量插入图片时位置错误
                        tr.setMeta(image_extension_pluginKey, {
                            add: image_extension_objectSpreadProps$1(image_extension_objectSpread$3({
                                id: id,
                                pos: pos
                            }, imgData || {}), {
                                src: blobUrl
                            })
                        }).insertText(image_extension_ZERO_WIDTH_SPACE, pos).setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, pos + 1));
                        view.dispatch(tr);
                        onProgress = function(param) {
                            var loaded = param.loaded, total = param.total;
                            var placeholder = findPlaceholder(view, id);
                            if (!placeholder) return;
                            var percent = Math.ceil(total ? loaded / total * 99 : 0);
                            placeholder.node.querySelector(".ct-image-progress-text").innerText = "".concat(percent, "%");
                        };
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            13,
                            ,
                            14
                        ]);
                        if (!customUpload) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            customUpload(onProgress)
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 6:
                        return [
                            4,
                            provider.upload(file, onProgress)
                        ];
                    case 7:
                        _tmp1 = _state.sent();
                        _state.label = 8;
                    case 8:
                        data = _tmp1;
                        if (!!imgData) return [
                            3,
                            12
                        ];
                        if (!(customUpload && data.width !== 0)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            formatImagData({
                                src: data.src,
                                imgInfo: data,
                                maxHeight: data.height
                            }, view)
                        ];
                    case 9:
                        // customUpload表示复制粘贴场景的图片上传，存在width属性说明非外部图片，为学城图片
                        imgData = adjustSize$1.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            12
                        ];
                    case 10:
                        return [
                            4,
                            formatImagData({
                                src: data.src
                            }, view)
                        ];
                    case 11:
                        imgData = adjustSize$1.apply(void 0, [
                            _state.sent()
                        ]);
                        _state.label = 12;
                    case 12:
                        placeholder = findPlaceholder(view, id);
                        // If the content around the placeholder has been deleted, drop
                        // the image
                        if (!placeholder) return [
                            2
                        ];
                        // Otherwise, insert it at the placeholder's position, and remove
                        // the placeholder
                        view.dispatch(view.state.tr.replaceWith(placeholder.pos, placeholder.pos + 1, image.create(image_extension_objectSpreadProps$1(image_extension_objectSpread$3({}, attrs, imgData || {}), {
                            src: data.src
                        }))).setMeta(image_extension_pluginKey, {
                            remove: {
                                id: id
                            }
                        }));
                        view.focus();
                        return [
                            3,
                            14
                        ];
                    case 13:
                        e = _state.sent();
                        console.error(e);
                        placeholder1 = findPlaceholder(view, id);
                        if (!placeholder1) return [
                            2
                        ];
                        node = placeholder1.node;
                        node.querySelector(".ct-image-mask").classList.add("upload-failed");
                        $btnUpload = node.querySelector(".ct-image-reupload-container");
                        // 上面组件的 class 变化会导致 pm 重新计算选区，计算的位置不对，需要重新设置
                        setTimeout(function() {
                            view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["TextSelection"].create(view.state.doc, placeholder1.pos + 1)));
                        }, 0);
                        $btnUpload.addEventListener("click", function() {
                            var curPlaceholder = findPlaceholder(view, id);
                            if (!curPlaceholder) return;
                            view.dispatch(view.state.tr.setMeta(image_extension_pluginKey, {
                                remove: {
                                    id: id
                                }
                            }));
                            // 删除之前清理多余的零宽度字符，这样不用区分是重传还是第一次上传
                            var delPos = placeholder1.pos;
                            view.dispatch(view.state.tr.delete(delPos, delPos + 1));
                            onUpload(view, provider, curPlaceholder.pos)(file, true);
                        });
                        return [
                            3,
                            14
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, retry) {
            return _ref.apply(this, arguments);
        };
    }();
};
var selectFile = function(param) {
    var accept = param.accept, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? true : _param_multiple;
    return new Promise(function(resolve) {
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        if (multiple) {
            input.setAttribute("multiple", "multiple");
        }
        input.setAttribute("accept", accept);
        input.onchange = function(e) {
            var files = e.target.files;
            input.remove();
            resolve(files);
        };
        input.click();
    });
};

var image_extension_img = "data:image/svg+xml,%3csvg width='256' height='256' xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3cstyle/%3e%3c/defs%3e%3cpath d='M37.333 160L96 101.333 154.667 160l32-32 32 32V58.667H37.333V160zM234.667 48v160a5.333 5.333 0 0 1-5.334 5.333H26.667A5.333 5.333 0 0 1 21.333 208V48a5.333 5.333 0 0 1 5.334-5.333h202.666A5.333 5.333 0 0 1 234.667 48zm-80 64a16 16 0 1 1 0-32 16 16 0 0 1 0 32z'/%3e%3c/svg%3e";

function image_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function image_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function image_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function image_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_extension_slicedToArray(arr, i) {
    return image_extension_arrayWithHoles(arr) || image_extension_iterableToArrayLimit(arr, i) || image_extension_unsupportedIterableToArray(arr, i) || image_extension_nonIterableRest();
}
function image_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return image_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_extension_arrayLikeToArray(o, minLen);
}
function useForceUpdate() {
    var _useState = image_extension_slicedToArray(Object(react["useState"])(0), 2), setTick = _useState[1];
    var update = Object(react["useCallback"])(function() {
        setTick(function(tick) {
            return tick + 1;
        });
    }, []);
    return update;
}

function image_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var image_extension_css_248z = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
image_extension_styleInject(image_extension_css_248z);

function image_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function image_extension_arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function image_extension_iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function image_extension_nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_extension_slicedToArray$1(arr, i) {
    return image_extension_arrayWithHoles$1(arr) || image_extension_iterableToArrayLimit$1(arr, i) || image_extension_unsupportedIterableToArray$1(arr, i) || image_extension_nonIterableRest$1();
}
function image_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return image_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_extension_arrayLikeToArray$1(o, minLen);
}
var Resizer = function(param) {
    var $container = param.$container, view = param.view, getPos = param.getPos, initialWidth = param.initialWidth, initialHeight = param.initialHeight, _param_fixedRatio = param.fixedRatio, fixedRatio = _param_fixedRatio === void 0 ? true : _param_fixedRatio, _param_autoHeight = param.autoHeight, autoHeight = _param_autoHeight === void 0 ? false : _param_autoHeight, _param_hideInfo = param.hideInfo, hideInfo = _param_hideInfo === void 0 ? false : _param_hideInfo, _param_limit = param.limit, limit = _param_limit === void 0 ? {} : _param_limit, onResizeStart = param.onResizeStart, onResizeEnd = param.onResizeEnd;
    if (!$container || !getPos()) return null;
    var limitRef = Object(react["useRef"])({});
    limitRef.current.minWidth = limit.minWidth || 20;
    limitRef.current.minHeight = limit.minHeight || 20;
    limitRef.current.maxHeight = limit.maxHeight || Infinity;
    var _useState = image_extension_slicedToArray$1(Object(react["useState"])("rb"), 2), infoPosition = _useState[0], setInfoPosition = _useState[1];
    var wrapperRef = Object(react["useRef"])();
    // 获取最大宽度
    var pos = getPos();
    var doc = view.state.doc;
    // 获取父级block节点
    var blockNode = image_extension_findParentNodeClosestToPos(doc.resolve(pos), function(n) {
        return n.isBlock;
    });
    var $blockNode = view.nodeDOM((blockNode === null || blockNode === void 0 ? void 0 : blockNode.pos) || 0);
    if (!$blockNode) {
        return null;
    }
    limitRef.current.maxWidth = limit.maxWidth || $blockNode.clientWidth;
    var ratio = initialHeight / initialWidth;
    if (fixedRatio) {
        limitRef.current.minHeight = Math.max(limitRef.current.minHeight, limitRef.current.minWidth * ratio);
        limitRef.current.minWidth = Math.max(limitRef.current.minWidth, limitRef.current.minHeight / ratio);
        limitRef.current.maxHeight = limitRef.current.maxWidth * ratio;
    }
    limitRef.current.minWidth = Math.min(limitRef.current.minWidth, limitRef.current.maxWidth);
    limitRef.current.minHeight = Math.min(limitRef.current.minHeight, limitRef.current.maxHeight);
    var startX = Object(react["useRef"])(0);
    var startY = Object(react["useRef"])(0);
    var isReverseX = Object(react["useRef"])(false);
    var isReverseY = Object(react["useRef"])(false);
    var initialWidthRef = Object(react["useRef"])(0);
    var initialHeightRef = Object(react["useRef"])(0);
    initialWidthRef.current = initialWidth;
    initialHeightRef.current = initialHeight;
    var currentSize = Object(react["useRef"])({
        width: initialWidth,
        height: initialHeight
    });
    var update = useForceUpdate();
    var limitSize = function() {
        var _currentSize_current = currentSize.current, width = _currentSize_current.width, height = _currentSize_current.height;
        if (width >= limitRef.current.maxWidth) {
            currentSize.current.width = limitRef.current.maxWidth;
        } else if (width <= limitRef.current.minWidth) {
            currentSize.current.width = limitRef.current.minWidth;
        }
        if (height >= limitRef.current.maxHeight) {
            currentSize.current.height = limitRef.current.maxHeight;
        } else if (height <= limitRef.current.minHeight) {
            currentSize.current.height = limitRef.current.minHeight;
        }
    };
    Object(react["useEffect"])(function() {
        var onMouseDown = function(e) {
            var classList = e.target && e.target.classList;
            if (!classList) {
                return;
            }
            var posList = [
                "lt",
                "rt",
                "lb",
                "rb"
            ];
            var posName = posList.find(function(item) {
                return classList.contains(item);
            });
            if (posName) {
                e.stopPropagation();
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                handleMouseDown(e, posName);
            }
        };
        var wrapper = wrapperRef.current;
        wrapper.addEventListener("mousedown", onMouseDown, false);
        return function() {
            wrapper.removeEventListener("mousedown", onMouseDown, false);
        };
    });
    Object(react["useEffect"])(function() {
        currentSize.current.width = initialWidth;
        currentSize.current.height = initialHeight;
        if (!autoHeight) {
            // 防止容器节点大小没有同步更新
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        update();
    }, [
        initialWidth
    ]);
    var handleMouseMove = Object(react["useCallback"])(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var diffX = isReverseX.current ? startX.current - e.clientX : e.clientX - startX.current;
        var diffY = isReverseY.current ? startY.current - e.clientY : e.clientY - startY.current;
        currentSize.current.width = initialWidthRef.current + diffX;
        currentSize.current.height = initialHeightRef.current + diffY;
        if (fixedRatio) {
            currentSize.current.height = currentSize.current.width * ratio;
        }
        limitSize();
        currentSize.current.width = Math.round(currentSize.current.width);
        currentSize.current.height = Math.round(currentSize.current.height);
        $container.style.width = "".concat(currentSize.current.width, "px");
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        // 更新尺寸大小的显示
        update();
    }, []);
    var handleMouseUp = Object(react["useCallback"])(function() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        onResizeEnd({
            width: currentSize.current.width,
            height: currentSize.current.height
        });
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        $container.style.width = "".concat(currentSize.current.width, "px");
    }, []);
    var handleMouseDown = function(e, position) {
        isReverseX.current = position === "lt" || position === "lb";
        isReverseY.current = position === "lt" || position === "lr";
        startX.current = e.clientX;
        startY.current = e.clientY;
        setInfoPosition(position);
        if (onResizeStart) {
            onResizeStart();
        }
        document.addEventListener("mousemove", handleMouseMove, {
            passive: false
        });
        document.addEventListener("mouseup", handleMouseUp);
    };
    // 当图片尺寸较大时，扩大热区
    var largeHotArea = Object(react["useMemo"])(function() {
        return currentSize.current.height >= 30 && currentSize.current.width >= 30;
    }, [
        currentSize.current.height,
        currentSize.current.width
    ]);
    var resizerPrefix = image_extension_classNamePrefix("pc-resizer");
    var pointerCls = "".concat(resizerPrefix, "-point");
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: resizerPrefix,
        ref: wrapperRef
    }, /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " lt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " rt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " lb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " rb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(resizerPrefix, "-info ").concat(infoPosition, " ").concat((currentSize.current.width < 65 || currentSize.current.height < 30) && "out", " ").concat(hideInfo ? "auto-hide" : "")
    }, "".concat(currentSize.current.width, " x ").concat(currentSize.current.height)));
};

var image_extension_css_248z$1 = ".ct-node-view-dom .ct-image{margin:0}.ct-node-view-dom .ct-image img{max-width:100%;width:100%}.ct-node-view-dom.ProseMirror-selectednode .ct-image-toobar-wrapper{display:flex}";
image_extension_styleInject(image_extension_css_248z$1);

function image_extension_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function image_extension_arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function image_extension_defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_extends() {
    image_extension_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return image_extension_extends.apply(this, arguments);
}
function image_extension_iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function image_extension_nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_extension_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_extension_defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function image_extension_ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_extension_objectSpreadProps$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_extension_ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function image_extension_slicedToArray$2(arr, i) {
    return image_extension_arrayWithHoles$2(arr) || image_extension_iterableToArrayLimit$2(arr, i) || image_extension_unsupportedIterableToArray$2(arr, i) || image_extension_nonIterableRest$2();
}
function image_extension_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return image_extension_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_extension_arrayLikeToArray$2(o, minLen);
}
var ImageNodeView = function(param) {
    var store = param.store;
    return function(props) {
        var wrapperRef = Object(react["useRef"])(null);
        var imageRef = Object(react["useRef"])();
        var _props_attrs = props.attrs, name = _props_attrs.name, border = _props_attrs.border, link = _props_attrs.link, width = _props_attrs.width, small = _props_attrs.small, origin = _props_attrs.origin, height = _props_attrs.height, src = _props_attrs.src, view = props.view, getPos = props.getPos, provider = props.provider, editorEventEmitter = props.editorEventEmitter;
        var _useState = image_extension_slicedToArray$2(Object(react["useState"])(false), 2), loadError = _useState[0], setLoadError = _useState[1];
        var _useState1 = image_extension_slicedToArray$2(Object(react["useState"])(false), 2), loadSuccess = _useState1[0], setLoadSuccess = _useState1[1];
        var _useState2 = image_extension_slicedToArray$2(Object(react["useState"])(false), 2), imageShow = _useState2[0], setImageShow = _useState2[1];
        // const [wrapperHeight, setWrapperHeight] = useState(height);
        var wrapperHeight = Object(react["useRef"])(height);
        var _useState3 = image_extension_slicedToArray$2(Object(react["useState"])(0), 2), maxWidth = _useState3[0], setMaxWidth = _useState3[1];
        var _useState4 = image_extension_slicedToArray$2(Object(react["useState"])(0), 2), naturalWidth = _useState4[0], setNaturalWidth = _useState4[1];
        var radio = Object(react["useRef"])(1); // 记录图片长宽比
        var imgPrefix = image_extension_classNamePrefix("image");
        var domAttrs = Object(react["useMemo"])(function() {
            return {
                className: "".concat(imgPrefix).concat(border ? " ".concat(imgPrefix, "-border") : ""),
                "data-link": link
            };
        }, [
            border,
            link
        ]);
        Object(react["useEffect"])(function() {
            var io = null;
            try {
                io = new IntersectionObserver(function(entries) {
                    if (entries[entries.length - 1].isIntersecting) {
                        setImageShow(true);
                        io.disconnect();
                    }
                });
                io.observe(wrapperRef.current);
            } catch (error) {
                setImageShow(true);
            }
            return function() {
                io && io.disconnect();
            };
        }, []);
        var _useState5 = image_extension_slicedToArray$2(Object(react["useState"])({
            "data-small": small,
            "data-origin": origin,
            src: "",
            alt: name.length > 100 ? "".concat(name.substr(0, 100), "...") : name,
            width: "".concat(width || IMAGE_DEFAULT_WIDTH)
        }), 2), imageAttrs = _useState5[0], setImageAttrs = _useState5[1];
        Object(react["useEffect"])(function() {
            var realSrc = src;
            if (!realSrc) {
                realSrc = "";
            }
            if (provider.formatUrl) {
                realSrc = provider.formatUrl(realSrc);
            }
            setImageAttrs(function(_) {
                return image_extension_objectSpreadProps$2(image_extension_objectSpread$4({}, _), {
                    src: realSrc
                });
            });
        }, [
            src
        ]);
        var onImageError = function(e) {
            setLoadError(true);
            emitTableHeightChange(wrapperRef.current, editorEventEmitter);
        };
        var onImageLoad = function() {
            if (provider.onImageLoad) {
                provider.onImageLoad(imageAttrs.src);
            }
            setLoadSuccess(true);
            var current = imageRef.current;
            if (current) {
                setMaxWidth(getMaxWidth(imageRef.current));
                setNaturalWidth(current.naturalWidth);
                radio.current = current.naturalHeight / current.naturalWidth;
            }
            emitTableHeightChange(wrapperRef.current, editorEventEmitter);
        };
        var handleResizeStart = function() {
            if (store && store.popContainer) {
                store.popContainer.classList.add("resizing");
            }
        };
        var handleResizeEnd = function(size) {
            var state = view.state, dispatch = view.dispatch;
            var tr = state.tr, doc = state.doc;
            var pos = getPos();
            var node = doc.nodeAt(pos);
            dispatch(tr.setNodeMarkup(pos, null, image_extension_objectSpreadProps$2(image_extension_objectSpread$4({}, node.attrs), {
                width: size.width,
                height: size.height
            })).setSelection(prosemirror_state_dist["NodeSelection"].create(tr.doc, pos)) // 重新设置选区
            );
            setImageAttrs(function(_) {
                return image_extension_objectSpreadProps$2(image_extension_objectSpread$4({}, _), {
                    width: size.width
                });
            });
            if (store && store.popContainer) {
                store.popContainer.classList.remove("resizing");
            }
        };
        Object(react["useEffect"])(function() {
            if (loadError) {
                setImageAttrs(function(_) {
                    return image_extension_objectSpreadProps$2(image_extension_objectSpread$4({}, _), {
                        src: image_extension_img
                    });
                });
            }
        }, [
            loadError
        ]);
        Object(react["useEffect"])(function() {
            // 在没有懒加载之前需要有 height 保证占位
            if (wrapperRef.current) {
                var _wrapperRef_current_getBoundingClientRect = wrapperRef.current.getBoundingClientRect(), realWidth = _wrapperRef_current_getBoundingClientRect.width;
                if (width > realWidth) {
                    // setWrapperHeight(Math.ceil((realWidth * height) / width));
                    wrapperHeight.current = Math.ceil(realWidth * height / width);
                    return;
                }
            }
            // setWrapperHeight(height);
            wrapperHeight.current = height;
        }, [
            height,
            width,
            loadSuccess
        ]);
        Object(react["useEffect"])(function() {
            if (width !== +imageAttrs.width) {
                setImageAttrs(function(_) {
                    return image_extension_objectSpreadProps$2(image_extension_objectSpread$4({}, _), {
                        width: width
                    });
                });
            }
        }, [
            width,
            height,
            loadSuccess
        ]);
        // 因为容器 span 有 max-width: 100% 所以要考虑超出容器宽度时显示的其实为容器宽度
        var initialWidth = Math.min(+width || IMAGE_DEFAULT_WIDTH, maxWidth);
        return /*#__PURE__*/ react_default.a.createElement("span", image_extension_extends({
            style: {
                width: "".concat(width || IMAGE_DEFAULT_WIDTH, "px"),
                height: loadSuccess ? "auto" : "".concat(wrapperHeight.current || IMAGE_DEFAULT_HEIGHT, "px")
            }
        }, domAttrs, {
            ref: wrapperRef
        }), imageShow && /*#__PURE__*/ react_default.a.createElement("img", image_extension_extends({}, imageAttrs, {
            alt: imageAttrs.alt,
            ref: imageRef,
            width: imageAttrs.width || IMAGE_DEFAULT_WIDTH,
            "data-maxwidth": maxWidth,
            "data-naturalwidth": naturalWidth,
            onLoad: onImageLoad,
            onError: onImageError
        })), loadSuccess && /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement(Resizer, {
            $container: wrapperRef.current,
            view: view,
            getPos: getPos,
            autoHeight: true,
            initialWidth: initialWidth,
            initialHeight: width ? Math.round(width * radio.current) : IMAGE_DEFAULT_HEIGHT,
            onResizeStart: handleResizeStart,
            onResizeEnd: handleResizeEnd,
            limit: {
                minWidth: MIN_IMG_SIZE,
                minHeight: 1
            }
        })));
    };
};

function image_extension_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function image_extension_arrayWithHoles$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function image_extension_iterableToArrayLimit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function image_extension_nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_extension_slicedToArray$3(arr, i) {
    return image_extension_arrayWithHoles$3(arr) || image_extension_iterableToArrayLimit$3(arr, i) || image_extension_unsupportedIterableToArray$3(arr, i) || image_extension_nonIterableRest$3();
}
function image_extension_unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return image_extension_arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_extension_arrayLikeToArray$3(o, minLen);
}
var image_extension_getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var image_extension_setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = image_extension_getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = image_extension_slicedToArray$3(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var image_extension_emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        Object(react_dom["render"])(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var image_extension_emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = react_dom_default.a.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

var image_extension_css_248z$2 = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
image_extension_styleInject(image_extension_css_248z$2);

function image_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var image_extension_SHOW = "show";
var image_extension_HIDE = "hide";
var image_extension_Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        image_extension_classCallCheck(this, Popover);
        this.popoverState = image_extension_HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(image_extension_classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === image_extension_SHOW && !forceUpdate) {
            return;
        }
        if (!target || !image_extension_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === image_extension_HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            image_extension_setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            image_extension_emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(image_extension_classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        Object(react_dom["render"])(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(image_extension_classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(image_extension_SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === image_extension_HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        image_extension_emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(image_extension_HIDE);
    };
    _proto.destroy = function destroy() {
        image_extension_emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function image_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function image_extension_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_extension_defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
var image_extension_DEFAULT_HEIGHT = 34;
var image_extension_DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var image_extension_PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        image_extension_classCallCheck$1(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = image_extension_objectSpread$5({}, image_extension_DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !image_extension_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new image_extension_Popover(image_extension_objectSpread$5({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return image_extension_DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var image_extension_css_248z$3 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
image_extension_styleInject(image_extension_css_248z$3);

function image_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_defineProperty$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_extension_getPrototypeOf(o) {
    image_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf(o);
}
function image_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf(subClass, superClass);
}
function image_extension_possibleConstructorReturn(self, call) {
    if (call && (image_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized(self);
}
function image_extension_setPrototypeOf(o, p) {
    image_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf(o, p);
}
var image_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn(this, result);
    };
}
var image_extension_Button = /*#__PURE__*/ function(Component) {
    image_extension_inherits(Button, Component);
    var _super = image_extension_createSuper(Button);
    function Button() {
        image_extension_classCallCheck$2(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = image_extension_classNamePrefix(prefix);
        var classes = image_extension_defineProperty$6({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ react_default.a.createElement("button", {
            disabled: disabled,
            className: classnames_default()(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(react["Component"]);

var image_extension_css_248z$4 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
image_extension_styleInject(image_extension_css_248z$4);

/* eslint-disable jsx-a11y/control-has-associated-label */ function image_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_getPrototypeOf$1(o) {
    image_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$1(o);
}
function image_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$1(subClass, superClass);
}
function image_extension_possibleConstructorReturn$1(self, call) {
    if (call && (image_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$1(self);
}
function image_extension_setPrototypeOf$1(o, p) {
    image_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$1(o, p);
}
var image_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$1(this, result);
    };
}
var image_extension_defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var image_extension_Modal = /*#__PURE__*/ function(Component) {
    image_extension_inherits$1(Modal, Component);
    var _super = image_extension_createSuper$1(Modal);
    function Modal() {
        image_extension_classCallCheck$3(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? "确定" : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? "取消" : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = image_extension_classNamePrefix(userPrefix);
        return /*#__PURE__*/ react_dom_default.a.createPortal(/*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: image_extension_defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ react_default.a.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ react_default.a.createElement(image_extension_Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ react_default.a.createElement(image_extension_Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(react["Component"]);
image_extension_Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var image_extension_css_248z$5 = '.ct-checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-checkbox input{display:none}.ct-checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-checkbox input:checked+.checkbox-bg:after{content:" ";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
image_extension_styleInject(image_extension_css_248z$5);

function image_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_getPrototypeOf$2(o) {
    image_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$2(o);
}
function image_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$2(subClass, superClass);
}
function image_extension_possibleConstructorReturn$2(self, call) {
    if (call && (image_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$2(self);
}
function image_extension_setPrototypeOf$2(o, p) {
    image_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$2(o, p);
}
var image_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$2(this, result);
    };
}
var image_extension_noop = function() {};
var image_extension_CheckBox = /*#__PURE__*/ function(Component) {
    image_extension_inherits$2(CheckBox, Component);
    var _super = image_extension_createSuper$2(CheckBox);
    function CheckBox() {
        image_extension_classCallCheck$4(this, CheckBox);
        return _super.apply(this, arguments);
    }
    var _proto = CheckBox.prototype;
    _proto.render = function render() {
        // 设置 onChange 的默认值，防止出现警告
        var _this_props = this.props, checked = _this_props.checked, onClick = _this_props.onClick, _this_props_onChange = _this_props.onChange, onChange = _this_props_onChange === void 0 ? image_extension_noop : _this_props_onChange, children = _this_props.children;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: image_extension_classNamePrefix("checkbox"),
            onClick: onClick
        }, /*#__PURE__*/ react_default.a.createElement("input", {
            type: "checkbox",
            checked: checked,
            onChange: onChange
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "checkbox-bg"
        }), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "checkbox-label"
        }, children));
    };
    return CheckBox;
}(react["Component"]);

var image_extension_css_248z$6 = '.ct-icon-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-icon-item svg{margin:4px 0 0 4px}.ct-icon-item.close{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-icon-item.error{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E9%94%99%E8%AF%AF%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-296.000000%2C -544.000000)%22 fill%3D%22%23F05E50%22%3E            %3Cpath fill%3D%22%23F05E50%22 d%3D%22M304%2C544 C308.41824%2C544 312%2C547.58176 312%2C552 C312%2C556.41824 308.41824%2C560 304%2C560 C299.58176%2C560 296%2C556.41824 296%2C552 C296%2C547.58176 299.58176%2C544 304%2C544 Z M299.2%2C552 C299.2%2C552.667362 299.735663%2C553.2 300.396436%2C553.2 L307.603564%2C553.2 C308.256356%2C553.2 308.8%2C552.662742 308.8%2C552 C308.8%2C551.332638 308.264337%2C550.8 307.603564%2C550.8 L300.396436%2C550.8 C299.743644%2C550.8 299.2%2C551.337258 299.2%2C552 Z%22 id%3D%22tost-%E9%94%99%E8%AF%AF%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.success{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E6%88%90%E5%8A%9F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-222.000000%2C -544.000000)%22 fill%3D%22%2370B123%22%3E            %3Cpath fill%3D%22%2370B123%22 d%3D%22M228.93934%2C552.865274 L226.802094%2C550.728029 C226.3405%2C550.266435 225.576187%2C550.26192 225.107558%2C550.730549 C224.635662%2C551.202445 224.637801%2C551.957848 225.105038%2C552.425085 L228.079926%2C555.399974 C228.314894%2C555.634941 228.628301%2C555.751472 228.941218%2C555.747447 C229.252578%2C555.751485 229.564571%2C555.634156 229.802094%2C555.396633 L234.898303%2C550.300424 C235.359897%2C549.83883 235.364412%2C549.074517 234.895783%2C548.605887 C234.423887%2C548.133991 233.668484%2C548.13613 233.201247%2C548.603367 L228.93934%2C552.865274 Z M238%2C552 C238%2C553.451396 237.642365%2C554.789924 236.927083%2C556.015625 C236.211802%2C557.241326 235.241326%2C558.211802 234.015625%2C558.927083 C232.789924%2C559.642365 231.451396%2C560 230%2C560 C228.548604%2C560 227.210076%2C559.642365 225.984375%2C558.927083 C224.758674%2C558.211802 223.788198%2C557.241326 223.072917%2C556.015625 C222.357635%2C554.789924 222%2C553.451396 222%2C552 C222%2C550.548604 222.357635%2C549.210076 223.072917%2C547.984375 C223.788198%2C546.758674 224.758674%2C545.788198 225.984375%2C545.072917 C227.210076%2C544.357635 228.548604%2C544 230%2C544 C231.451396%2C544 232.789924%2C544.357635 234.015625%2C545.072917 C235.241326%2C545.788198 236.211802%2C546.758674 236.927083%2C547.984375 C237.642365%2C549.210076 238%2C550.548604 238%2C552 Z%22 id%3D%22tost-%E6%88%90%E5%8A%9F%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.edit{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E7%BC%96%E8%BE%91%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-164.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E7%BC%96%E8%BE%91%22 transform%3D%22translate(164.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M13%2C7 C13.2761424%2C7 13.5%2C7.22385763 13.5%2C7.5 C13.5%2C7.77614237 13.2761424%2C8 13%2C8 L8%2C8 L8%2C8 C7.44771525%2C8 7%2C8.44771525 7%2C9 L7%2C9 L7%2C18 C7%2C18.5522847 7.44771525%2C19 8%2C19 L17%2C19 C17.5522847%2C19 18%2C18.5522847 18%2C18 L18%2C18 L18%2C13 C18%2C12.7238576 18.2238576%2C12.5 18.5%2C12.5 C18.7761424%2C12.5 19%2C12.7238576 19%2C13 L19%2C11 L19%2C18 L19%2C18 C19%2C19.1045695 18.1045695%2C20 17%2C20 L8%2C20 L8%2C20 C6.8954305%2C20 6%2C19.1045695 6%2C18 L6%2C9 L6%2C9 C6%2C7.8954305 6.8954305%2C7 8%2C7 L8%2C7 L15%2C7 L13%2C7 Z M19.8535534%2C6.14644661 C20.0488155%2C6.34170876 20.0488155%2C6.65829124 19.8535534%2C6.85355339 L13.4895924%2C13.2175144 C13.2943302%2C13.4127766 12.9777477%2C13.4127766 12.7824856%2C13.2175144 C12.5872234%2C13.0222523 12.5872234%2C12.7056698 12.7824856%2C12.5104076 L19.1464466%2C6.14644661 C19.3417088%2C5.95118446 19.6582912%2C5.95118446 19.8535534%2C6.14644661 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.link{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(-908.000000%2C -565.000000)%22%3E      %3Cg transform%3D%22translate(8.500000%2C 565.000000)%22%3E        %3Cg transform%3D%22translate(0.500000%2C 0.000000)%22 fill%3D%22%23666666%22%3E          %3Cg transform%3D%22translate(899.000000%2C 0.000000)%22%3E            %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L13.4302151%2C11.1475865 L12.7191158%2C11.8586857 L13.4302151%2C12.5697849 C14.2156736%2C13.3552435 14.2156736%2C14.6287234 13.4302151%2C15.4141819 L13.2808842%2C15.5635128 L12.9253346%2C15.2079632 L13.9919834%2C16.274612 L16.1252811%2C14.1413143 L15.4141819%2C13.4302151 L17.4052599%2C11.439137 C18.1907184%2C10.6536785 18.1907184%2C9.38019862 17.4052599%2C8.59474009 C16.6198014%2C7.80928156 15.3463215%2C7.80928156 14.560863%2C8.59474009 L12.7191158%2C10.4364872 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.visitLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8E%BB%E6%9F%A5%E7%9C%8B%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-587.000000%2C -162.000000)%22%3E            %3Cg id%3D%22Group-8%22 transform%3D%22translate(62.000000%2C 128.000000)%22%3E                %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 34.000000)%22%3E%3C%2Fg%3E                %3Cg id%3D%22Group-2%22 transform%3D%22translate(0.000000%2C 34.000000)%22 fill%3D%22%23666666%22%3E                    %3Cg id%3D%22%E5%8E%BB%E6%9F%A5%E7%9C%8B%22 transform%3D%22translate(525.000000%2C 0.000000)%22%3E                        %3Cpath d%3D%22M6.67363116%2C16 L7.80156483%2C16 C8.83909243%2C17.7939653 10.7785899%2C19.0009766 13%2C19.0009766 C16.3142478%2C19.0009766 19.0009766%2C16.3142478 19.0009766%2C13 C19.0009766%2C9.68575216 16.3142478%2C6.99902344 13%2C6.99902344 C10.7785899%2C6.99902344 8.83909243%2C8.20603473 7.80156483%2C10 L6.67363116%2C10 C7.7970951%2C7.63505267 10.207604%2C6 13%2C6 C16.8659932%2C6 20%2C9.13400675 20%2C13 C20%2C16.8659932 16.8659932%2C20 13%2C20 C10.207604%2C20 7.7970951%2C18.3649473 6.67363116%2C16 Z M14.1464466%2C14.767767 L15.4142136%2C13.5 L6.62132034%2C13.5 C6.34517797%2C13.5 6.12132034%2C13.2761424 6.12132034%2C13 C6.12132034%2C12.7238576 6.34517797%2C12.5 6.62132034%2C12.5 L15.4142136%2C12.5 L14.1464466%2C11.232233 C13.9511845%2C11.0369709 13.9511845%2C10.7203884 14.1464466%2C10.5251263 C14.3417088%2C10.3298641 14.6582912%2C10.3298641 14.8535534%2C10.5251263 L16.9535151%2C12.6262866 C16.9607818%2C12.6327579 16.967905%2C12.6394779 16.9748737%2C12.6464466 C17.1701359%2C12.8417088 17.1701359%2C13.1582912 16.9748737%2C13.3535534 L14.8535534%2C15.4748737 C14.6582912%2C15.6701359 14.3417088%2C15.6701359 14.1464466%2C15.4748737 C13.9511845%2C15.2796116 13.9511845%2C14.9630291 14.1464466%2C14.767767 Z%22%3E%3C%2Fpath%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.cancelLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8F%96%E6%B6%88%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-96.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E6%8F%92%E5%85%A5%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(96.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L14.560863%2C8.59474009 C15.3463215%2C7.80928156 16.6198014%2C7.80928156 17.4052599%2C8.59474009 C18.1907184%2C9.38019862 18.1907184%2C10.6536785 17.4052599%2C11.439137 L15.4141819%2C13.4302151 L16.1252811%2C14.1413143 L13.9919834%2C16.274612 L12.9253346%2C15.2079632 L13.2808842%2C15.5635128 L13.4302151%2C15.4141819 C14.2156736%2C14.6287234 14.2156736%2C13.3552435 13.4302151%2C12.5697849 L12.7191158%2C11.8586857 L13.4302151%2C11.1475865 L12.7191158%2C10.4364872 Z M7.35355339%2C7.35355339 C7.54881554%2C7.15829124 7.86539803%2C7.15829124 8.06066017%2C7.35355339 L9.47487373%2C8.76776695 C9.67013588%2C8.9630291 9.67013588%2C9.27961159 9.47487373%2C9.47487373 C9.27961159%2C9.67013588 8.9630291%2C9.67013588 8.76776695%2C9.47487373 L7.35355339%2C8.06066017 C7.15829124%2C7.86539803 7.15829124%2C7.54881554 7.35355339%2C7.35355339 Z M16.3535534%2C16.3535534 C16.5488155%2C16.1582912 16.865398%2C16.1582912 17.0606602%2C16.3535534 L18.4748737%2C17.767767 C18.6701359%2C17.9630291 18.6701359%2C18.2796116 18.4748737%2C18.4748737 C18.2796116%2C18.6701359 17.9630291%2C18.6701359 17.767767%2C18.4748737 L16.3535534%2C17.0606602 C16.1582912%2C16.865398 16.1582912%2C16.5488155 16.3535534%2C16.3535534 Z M17%2C14.5 C17%2C14.2238576 17.2238576%2C14 17.5%2C14 L19.5%2C14 C19.7761424%2C14 20%2C14.2238576 20%2C14.5 C20%2C14.7761424 19.7761424%2C15 19.5%2C15 L17.5%2C15 C17.2238576%2C15 17%2C14.7761424 17%2C14.5 Z M6%2C11.5 L6%2C11.5 C6%2C11.2238576 6.22385763%2C11 6.5%2C11 L8.5%2C11 C8.77614237%2C11 9%2C11.2238576 9%2C11.5 C9%2C11.7761424 8.77614237%2C12 8.5%2C12 L6.5%2C12 L6.5%2C12 C6.22385763%2C12 6%2C11.7761424 6%2C11.5 L6%2C11.5 Z M11.5%2C6 L11.5%2C6 C11.7761424%2C6 12%2C6.22385763 12%2C6.5 L12%2C8.5 C12%2C8.77614237 11.7761424%2C9 11.5%2C9 C11.2238576%2C9 11%2C8.77614237 11%2C8.5 L11%2C6.5 L11%2C6.5 C11%2C6.22385763 11.2238576%2C6 11.5%2C6 L11.5%2C6 Z M14.5%2C17 C14.7761424%2C17 15%2C17.2238576 15%2C17.5 L15%2C19.5 C15%2C19.7761424 14.7761424%2C20 14.5%2C20 C14.2238576%2C20 14%2C19.7761424 14%2C19.5 L14%2C17.5 C14%2C17.2238576 14.2238576%2C17 14.5%2C17 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomin{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25%22 fill%3D%22%23666%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomout{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4-Copy%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}';
image_extension_styleInject(image_extension_css_248z$6);

function image_extension_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_getPrototypeOf$3(o) {
    image_extension_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$3(o);
}
function image_extension_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$3(subClass, superClass);
}
function image_extension_possibleConstructorReturn$3(self, call) {
    if (call && (image_extension_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$3(self);
}
function image_extension_setPrototypeOf$3(o, p) {
    image_extension_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$3(o, p);
}
var image_extension_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$3(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$3(this, result);
    };
}
var image_extension_IconItem = /*#__PURE__*/ function(Component) {
    image_extension_inherits$3(IconItem, Component);
    var _super = image_extension_createSuper$3(IconItem);
    function IconItem() {
        image_extension_classCallCheck$5(this, IconItem);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasTooltip: false
        };
        return _this;
    }
    var _proto = IconItem.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, tip = _this_props.tip, onClick = _this_props.onClick, _this_props_type = _this_props.type, type = _this_props_type === void 0 ? "" : _this_props_type, icon = _this_props.icon;
        var hasTooltip = this.state.hasTooltip;
        var bgStyle = null;
        if (icon) {
            var backgroundImage = icon;
            if (typeof backgroundImage === "string" && !backgroundImage.startsWith("url(")) {
                // 如果只提供了图片地址，拼出合法的 css 图片链接字符串
                backgroundImage = "url(".concat(backgroundImage, ")");
            }
            bgStyle = {
                backgroundImage: backgroundImage
            };
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(image_extension_classNamePrefix("icon-item"), " ").concat(type || ""),
            style: bgStyle,
            onMouseEnter: function() {
                return _this.setState({
                    hasTooltip: true
                });
            },
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: onClick
        }, hasTooltip && /*#__PURE__*/ react_default.a.createElement("span", {
            className: image_extension_classNamePrefix("base-toolbar-tooltip")
        }, tip));
    };
    return IconItem;
}(react["Component"]);

var image_extension_css_248z$7 = '.ct-base-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-base-toolbar .split{width:1px;height:14px;margin-top:0;background:#d9d9d9}.ct-base-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-base-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}';
image_extension_styleInject(image_extension_css_248z$7);

/**
 * 工具条组件
 */ function image_extension_assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_getPrototypeOf$4(o) {
    image_extension_getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$4(o);
}
function image_extension_inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$4(subClass, superClass);
}
function image_extension_possibleConstructorReturn$4(self, call) {
    if (call && (image_extension_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$4(self);
}
function image_extension_setPrototypeOf$4(o, p) {
    image_extension_setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$4(o, p);
}
var image_extension_typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$4(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$4(this, result);
    };
}
var image_extension_Toolbar = /*#__PURE__*/ function(Component) {
    image_extension_inherits$4(Toolbar, Component);
    var _super = image_extension_createSuper$4(Toolbar);
    function Toolbar() {
        image_extension_classCallCheck$6(this, Toolbar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderItem = function(tool) {
            var custom = tool.custom, title = tool.title, icon = tool.icon, callback = tool.callback;
            return custom || /*#__PURE__*/ react_default.a.createElement(image_extension_IconItem, {
                key: title,
                type: icon,
                onClick: callback,
                tip: title
            });
        };
        _this.renderToolGroup = function(group, index, split) {
            return /*#__PURE__*/ react_default.a.createElement(react["Fragment"], {
                key: index
            }, group.map(function(tool) {
                return _this.renderItem(tool);
            }), split && /*#__PURE__*/ react_default.a.createElement("div", {
                className: "split"
            }));
        };
        return _this;
    }
    var _proto = Toolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, _this_props_tools = _this_props.tools, tools = _this_props_tools === void 0 ? [] : _this_props_tools, className = _this_props.className;
        var prefix = image_extension_classNamePrefix("toolbox");
        var lastIndex = tools.length - 1;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, tools.map(function(group, index) {
            return _this.renderToolGroup(group, index, index !== lastIndex);
        }));
    };
    return Toolbar;
}(react["Component"]);

var image_extension_css_248z$8 = '.ct-image-link-modal .content{height:206px!important}.ct-image-link-modal .ant-modal-footer{padding:0 24px 32px;border:none}.ct-image-link-modal .ant-btn{width:60px!important;height:32px;padding:0;margin-left:16px;border-radius:2px}.ct-image-link-modal .input-error{position:absolute;top:55px;left:65px;font-size:12px;color:#e75252}.image-link-content{padding:14px 0;position:relative;font-size:12px;color:rgba(0,0,0,.65)}.image-link-content .ct-image-link-modal-item{color:rgba(0,0,0,.6);line-height:22px}.image-link-content label{display:flex;align-items:center}.image-link-content span{color:rgba(0,0,0,.6);width:60px}.image-link-content input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.image-link-content input[type=text]:focus{border:1px solid #1c6cdc}.image-link-content input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type="text"]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type="text"]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type=text]::placeholder{color:rgba(0,0,0,.24)}';
image_extension_styleInject(image_extension_css_248z$8);

/* eslint-disable jsx-a11y/label-has-associated-control */ function image_extension_assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_getPrototypeOf$5(o) {
    image_extension_getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$5(o);
}
function image_extension_inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$5(subClass, superClass);
}
function image_extension_possibleConstructorReturn$5(self, call) {
    if (call && (image_extension_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$5(self);
}
function image_extension_setPrototypeOf$5(o, p) {
    image_extension_setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$5(o, p);
}
var image_extension_typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$5(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$5(this, result);
    };
}
var image_extension_formatLink = function(href) {
    var regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
    var regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
    var newHref = href.replace(regex1, function(match, capture) {
        return capture ? match : "http://".concat(match);
    }) // eslint-disable-line
    ;
    return regex2.test(newHref) ? newHref : false;
};
var image_extension_LinkModal = /*#__PURE__*/ function(Component) {
    image_extension_inherits$5(LinkModal, Component);
    var _super = image_extension_createSuper$5(LinkModal);
    function LinkModal(props) {
        image_extension_classCallCheck$7(this, LinkModal);
        var _this;
        _this = _super.call(this, props);
        _this.link = "";
        _this.state = {
            error: null
        };
        _this.handleKeydown = function(e) {
            // ENTER
            if (e.which === 13 || e.keyCode === 13) {
                _this.handleOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        _this.handleInputHref = function(e) {
            var error = _this.state.error;
            if (error) {
                _this.setState({
                    error: null
                });
            }
            _this.link = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, "");
        };
        _this.handleOk = function() {
            var addImageLink = _this.props.addImageLink;
            var link = image_extension_formatLink(_this.link);
            if (!link) {
                _this.setState({
                    error: "请输入正确的地址"
                });
                return;
            }
            addImageLink(link);
            _this.handleCancel();
        };
        _this.handleCancel = function() {
            var error = _this.state.error;
            var closeModal = _this.props.closeModal;
            if (error) _this.setState({
                error: null
            });
            closeModal();
        };
        _this.link = props.link || "";
        return _this;
    }
    var _proto = LinkModal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener("keydown", this.handleKeydown);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeydown);
    };
    _proto.render = function render() {
        var _this_props = this.props, _this_props_link = _this_props.link, link = _this_props_link === void 0 ? "" : _this_props_link;
        var error = this.state.error;
        return /*#__PURE__*/ react_default.a.createElement(image_extension_Modal, {
            className: image_extension_classNamePrefix("image-link-modal"),
            title: "图片链接",
            okText: "插入",
            onOk: this.handleOk,
            onCancel: this.handleCancel,
            canEnter: true
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "image-link-content"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: image_extension_classNamePrefix("image-link-modal-item")
        }, /*#__PURE__*/ react_default.a.createElement("label", null, /*#__PURE__*/ react_default.a.createElement("span", null, "链接地址"), /*#__PURE__*/ react_default.a.createElement("input", {
            id: "imagelink",
            type: "text",
            className: "".concat(image_extension_classNamePrefix("input"), " input-link-href"),
            placeholder: "请输入链接地址",
            autoComplete: "off",
            defaultValue: link,
            onInput: this.handleInputHref
        }))), error && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "input-error"
        }, error)));
    };
    return LinkModal;
}(react["Component"]);

var image_extension_css_248z$9 = ".ct-image-toolbar.ct-base-toolbar{width:auto;min-width:100px;pointer-events:all;caret-color:#333}.ct-image-toolbar .pm-image-width-label{height:18px;padding-left:8px;margin-top:0;color:#333;font-size:12px;line-height:20px}.ct-image-toolbar .pm-image-width-input{border-radius:2px;border:1px solid #ddd;box-sizing:border-box;width:66px;height:24px;padding:5px 8px 3px;margin:0 0 0 8px;font-size:12px;color:#333;-moz-appearance:textfield}.ct-image-toolbar .pm-image-width-input::-webkit-inner-spin-button,.ct-image-toolbar .pm-image-width-input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0}";
image_extension_styleInject(image_extension_css_248z$9);

/* eslint-disable jsx-a11y/label-has-associated-control */ function image_extension_assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_getPrototypeOf$6(o) {
    image_extension_getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$6(o);
}
function image_extension_inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$6(subClass, superClass);
}
function image_extension_possibleConstructorReturn$6(self, call) {
    if (call && (image_extension_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$6(self);
}
function image_extension_setPrototypeOf$6(o, p) {
    image_extension_setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$6(o, p);
}
var image_extension_typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$6(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$6(this, result);
    };
}
var image_extension_ImgToolbar = /*#__PURE__*/ function(Component) {
    image_extension_inherits$6(ImgToolbar, Component);
    var _super = image_extension_createSuper$6(ImgToolbar);
    function ImgToolbar(props) {
        image_extension_classCallCheck$8(this, ImgToolbar);
        var _this;
        _this = _super.call(this, props);
        _this.container = null;
        _this.input = null;
        _this.handleCheckboxChange = function(e) {
            e.stopPropagation();
            e.preventDefault();
            var hasBorder = _this.state.hasBorder;
            var toggleBorder = _this.props.toggleBorder;
            var newHasBorder = !hasBorder;
            _this.setState({
                hasBorder: newHasBorder
            });
            toggleBorder(newHasBorder);
        };
        _this.addLink = function() {
            _this.setState({
                visible: true
            });
        };
        _this.editLink = function() {
            _this.setState({
                visible: true
            });
        };
        _this.cancelLink = function() {
            var cancelImageLink = _this.props.cancelImageLink;
            cancelImageLink();
            _this.setState({
                link: null
            });
        };
        _this.setLink = function(link) {
            var addImageLink = _this.props.addImageLink;
            addImageLink(link);
            _this.setState({
                link: link
            });
        };
        _this.closeModal = function() {
            _this.setState({
                visible: false
            });
        };
        _this.handleInputChange = function(e) {
            var width = e.target.value;
            _this.setState({
                width: width
            });
        };
        _this.setWidth = function() {
            var _this_state = _this.state, oldWidth = _this_state.width;
            var _this_props = _this.props, maxWidth = _this_props.maxWidth, naturalWidth = _this_props.naturalWidth, setWidth = _this_props.setWidth;
            var width = _this.input.value;
            if (width < MIN_IMG_SIZE) {
                if (naturalWidth < 5 || naturalWidth > MIN_IMG_SIZE) {
                    width = MIN_IMG_SIZE;
                } else if (width < naturalWidth) {
                    width = naturalWidth;
                }
            } else if (width > maxWidth) {
                width = maxWidth;
            }
            setWidth(+width);
            if (width !== oldWidth) {
                _this.setState({
                    width: width
                });
            }
        };
        _this.state = {
            hasBorder: props.hasBorder,
            link: props.link,
            visible: false,
            width: "".concat(props.width)
        };
        return _this;
    }
    var _proto = ImgToolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, hasBorder = _this_state.hasBorder, visible = _this_state.visible, width = _this_state.width, link = _this_state.link;
        var hasLink = !!link;
        var linkTool = hasLink ? [
            {
                title: "取消链接",
                icon: "cancelLink",
                callback: this.cancelLink
            },
            {
                title: "编辑链接",
                icon: "edit",
                callback: this.editLink
            }
        ] : [
            {
                title: "链接",
                icon: "link",
                callback: this.addLink
            }
        ];
        var tools = [
            [
                {
                    custom: /*#__PURE__*/ react_default.a.createElement(image_extension_CheckBox, {
                        key: "border",
                        checked: hasBorder,
                        onChange: function() {},
                        onClick: this.handleCheckboxChange
                    }, "边框")
                }
            ],
            linkTool,
            [
                {
                    custom: /*#__PURE__*/ react_default.a.createElement(react["Fragment"], {
                        key: "width"
                    }, /*#__PURE__*/ react_default.a.createElement("label", {
                        id: "pm-image-width-label",
                        className: "pm-image-width-label",
                        htmlFor: "pm-image-width-input"
                    }, "宽度"), /*#__PURE__*/ react_default.a.createElement("input", {
                        id: "pm-image-width-input",
                        ref: function(i) {
                            _this.input = i;
                        },
                        className: "".concat(image_extension_classNamePrefix("input"), " pm-image-width-input"),
                        type: "number",
                        autoComplete: "off",
                        value: parseInt(width, 10),
                        onChange: this.handleInputChange,
                        onBlur: this.setWidth,
                        onKeyDown: function(e) {
                            if (e.keyCode === KEY_CODE_ENTER) {
                                // 按回车键可确定输入内容生效
                                e.target.blur();
                                e.stopPropagation();
                                e.preventDefault();
                                return false;
                            }
                            return undefined;
                        }
                    }))
                }
            ]
        ];
        return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement(image_extension_Toolbar, {
            className: "".concat(image_extension_classNamePrefix("base-toolbar"), " ").concat(image_extension_classNamePrefix("image-toolbar")),
            tools: tools
        }), visible && /*#__PURE__*/ react_default.a.createElement(image_extension_LinkModal, {
            link: link,
            addImageLink: this.setLink,
            closeModal: this.closeModal
        }));
    };
    return ImgToolbar;
}(react["Component"]);

function image_extension_assertThisInitialized$7(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        image_extension_get = Reflect.get;
    } else {
        image_extension_get = function _get(target, property, receiver) {
            var base = image_extension_superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return image_extension_get(target, property, receiver || target);
}
function image_extension_getPrototypeOf$7(o) {
    image_extension_getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return image_extension_getPrototypeOf$7(o);
}
function image_extension_inherits$7(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) image_extension_setPrototypeOf$7(subClass, superClass);
}
function image_extension_possibleConstructorReturn$7(self, call) {
    if (call && (image_extension_typeof$7(call) === "object" || typeof call === "function")) {
        return call;
    }
    return image_extension_assertThisInitialized$7(self);
}
function image_extension_setPrototypeOf$7(o, p) {
    image_extension_setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return image_extension_setPrototypeOf$7(o, p);
}
function image_extension_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = image_extension_getPrototypeOf$7(object);
        if (object === null) break;
    }
    return object;
}
var image_extension_typeof$7 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function image_extension_isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function image_extension_createSuper$7(Derived) {
    var hasNativeReflectConstruct = image_extension_isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = image_extension_getPrototypeOf$7(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = image_extension_getPrototypeOf$7(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return image_extension_possibleConstructorReturn$7(this, result);
    };
}
var image_extension_ToolbarPopover = /*#__PURE__*/ function(PluginView) {
    image_extension_inherits$7(ToolbarPopover, PluginView);
    var _super = image_extension_createSuper$7(ToolbarPopover);
    function ToolbarPopover(view, config) {
        image_extension_classCallCheck$9(this, ToolbarPopover);
        var _this;
        _this = _super.call(this, view, config);
        /**
   * 获取当前选区位置
   */ _this.getPos = function() {
            var state = _this.view.state;
            return state.selection.from;
        };
        _this.getDom = function() {
            return _this.view.nodeDOM(_this.getPos());
        };
        _this.setImageAttr = function(data) {
            var _$view = image_extension_assertThisInitialized$7(_this).view;
            var pos = _this.getPos();
            // TODO: 这一块先通过sessionStorage实现，后续考虑通过Provider获取到。
            if (typeof data.border === "boolean") {
                sessionStorage.setItem(IMAGE_BORDER_KEY, data.border ? "1" : "0");
            }
            updateAttrs(data, pos)(_this.view);
            _$view.dispatch(_$view.state.tr.setSelection(prosemirror_state_dist["NodeSelection"].create(_$view.state.doc, _this.getPos())));
            _$view.focus();
        };
        _this.store = config.store;
        return _this;
    }
    var _proto = ToolbarPopover.prototype;
    _proto.show = function show() {
        image_extension_get(image_extension_getPrototypeOf$7(ToolbarPopover.prototype), "show", this).call(this);
        this.store.popContainer = this.getPopover();
    };
    _proto.destroy = function destroy() {
        image_extension_get(image_extension_getPrototypeOf$7(ToolbarPopover.prototype), "destroy", this).call(this);
        this.store = null;
    };
    _proto.getNode = function getNode(view) {
        var state = view.state;
        if (state.selection.empty) {
            return null;
        }
        var pos = state.selection.from;
        var selectedNode = state.doc.nodeAt(pos);
        if (!selectedNode || selectedNode.type !== state.schema.nodes.image) {
            return null;
        }
        return view.nodeDOM(pos);
    };
    _proto.getContent = function getContent() {
        var _this = this;
        var state = this.view.state;
        var dom = this.getDom();
        var pos = state.selection.from;
        var node = state.doc.nodeAt(pos);
        if (!node) {
            return null;
        }
        var maxWidth = IMAGE_DEFAULT_WIDTH;
        var naturalWidth = IMAGE_DEFAULT_WIDTH;
        var img = dom.querySelector("img");
        if (img) {
            maxWidth = +(getMaxWidth(img) || IMAGE_DEFAULT_MAX_WIDTH);
            naturalWidth = +(img.getAttribute("data-naturalwidth") || IMAGE_DEFAULT_WIDTH);
        }
        var _node_attrs = node.attrs, border = _node_attrs.border, link = _node_attrs.link, width = _node_attrs.width;
        var _width = Math.min(maxWidth, width || IMAGE_DEFAULT_WIDTH);
        return /*#__PURE__*/ react_default.a.createElement(image_extension_ImgToolbar, {
            hasBorder: border,
            link: link,
            width: _width,
            maxWidth: maxWidth,
            naturalWidth: naturalWidth,
            toggleBorder: function(value) {
                _this.setImageAttr({
                    border: value
                });
            },
            setWidth: function(value) {
                _this.setImageAttr({
                    width: value,
                    height: "auto"
                });
            },
            addImageLink: function(value) {
                _this.setImageAttr({
                    link: value
                });
            },
            cancelImageLink: function() {
                _this.setImageAttr({
                    link: null
                });
            }
        });
    };
    return ToolbarPopover;
}(image_extension_PluginView);

var image_extension_css_248z$a = '.ct-editor-container .ProseMirror-selectednode .ct-image,.ct-editor-container .ProseMirror-selectednode .ct-image.ct-image-border{outline:2px solid #0082a6}.ct-editor-container .ct-image.ProseMirror-widget{top:unset}.ct-editor-container .ct-image.ProseMirror-widget img{max-width:100%;min-width:72px;min-height:87px}.ct-editor-container .ct-image.ProseMirror-widget[data-type=ct-progress]{margin:0 3px}.ct-editor-container .ct-image.ProseMirror-widget.selected[data-type=ct-progress]{outline:1px solid #1c6cdc}.ct-editor-container .ct-image{margin:0 3px;display:inline-block;position:relative;max-width:100%;line-height:1;font-size:0;box-sizing:content-box;background-color:#fff;vertical-align:bottom;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.ct-editor-container .ct-image .ct-image-mask{position:absolute;top:-1px;left:-1px;bottom:-1px;right:-1px;font-size:14px;line-height:20px;overflow:hidden;background:rgba(0,0,0,.7);color:#fff;min-width:72px;min-height:87px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-image .ct-image-mask .ct-image-loading-icon{position:absolute;top:18px;left:22px;width:28px;height:28px;background:url("data:image/svg+xml,%3Csvg width%3D%2232%22 height%3D%2232%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cstyle%2F%3E%3C%2Fdefs%3E%3Cpath d%3D%22M6.572 6.572A13.291 13.291 0 0 1 16 2.667c7.364 0 13.333 5.969 13.333 13.333a13.291 13.291 0 0 1-3.905 9.428l-1.414-1.414A11.298 11.298 0 0 0 27.334 16c0-6.26-5.075-11.333-11.334-11.333a11.298 11.298 0 0 0-8.013 3.32L6.57 6.57z%22 fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E") no-repeat 0;background-size:contain;vertical-align:-8%;-webkit-animation:image-loading .8s linear infinite;animation:image-loading .8s linear infinite}.ct-editor-container .ct-image .ct-image-mask .ct-image-progress-text{position:absolute;top:50px;left:16px;width:40px;text-align:center;text-decoration:none!important}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container{display:none;height:0}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-icon{position:absolute;top:18px;left:22px;width:28px;height:28px;background:url("data:image/svg+xml,%3Csvg width%3D%2232%22 height%3D%2232%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cstyle%2F%3E%3C%2Fdefs%3E%3Cpath d%3D%22M25.849 20.103l1.846.77C25.786 25.45 21.27 28.667 16 28.667 9.005 28.667 3.333 22.995 3.333 16S9.005 3.333 16 3.333c3.41 0 6.507 1.348 8.783 3.54l2.207-2.206 1.886 7.542-7.543-1.886 2.036-2.035A10.63 10.63 0 0 0 16 5.333C10.109 5.333 5.333 10.11 5.333 16S10.11 26.667 16 26.667a10.67 10.67 0 0 0 9.849-6.564zM26.667 16h2-2z%22 fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E") no-repeat 0;background-size:contain}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-text{position:absolute;top:50px;left:6px}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-btn{position:absolute;top:76px;left:6px}.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-loading-icon,.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-progress-text{display:none}.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-reupload-container{display:block}.ct-editor-container .ct-image .image-empty{width:360px;height:100px}.ct-editor-container .ct-image.ct-image-border{display:inline-block;outline:2px solid #ddd}@-webkit-keyframes image-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes image-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}';
image_extension_styleInject(image_extension_css_248z$a);

function _assertThisInitialized$8(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function image_extension_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function image_extension_asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                image_extension_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                image_extension_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function image_extension_classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function image_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function image_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) image_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) image_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$8(o) {
    _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$8(o);
}
function _inherits$8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$8(subClass, superClass);
}
function _possibleConstructorReturn$8(self, call) {
    if (call && (_typeof$8(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$8(self);
}
function _setPrototypeOf$8(o, p) {
    _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$8(o, p);
}
var _typeof$8 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$8() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$8(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$8(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$8(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$8(this, result);
    };
}
var image_extension_generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var IMG_PREFIX = image_extension_classNamePrefix("image");
var image_extension_ImageExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$8(ImageExtension, NodeExtension);
    var _super = _createSuper$8(ImageExtension);
    function ImageExtension() {
        image_extension_classCallCheck$a(this, ImageExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.store = {} // 用于 plugin view  和 content view 之间的数据交换，暂时没有通用机制
        ;
        _this.nodeViews = ImageNodeView({
            store: _this.store
        });
        return _this;
    }
    var _proto = ImageExtension.prototype;
    _proto.plugin = function plugin(param) {
        var providers = param.providers;
        var _this = this;
        return new prosemirror_state_dist["Plugin"](UploaderOption({
            key: image_extension_pluginKey,
            props: {
                handleClick: function(view, pos, e) {
                    // 将已经选中的上传中元素取消选中
                    var preSelected = document.querySelector(".".concat(IMG_PREFIX, '[data-type="ct-progress"].selected'));
                    if (preSelected) {
                        preSelected.classList.remove("selected");
                    }
                    // 选中上传中的元素
                    var target = e.target;
                    var uploadingNode = target.closest(".".concat(IMG_PREFIX, '[data-type="ct-progress"]'));
                    if (uploadingNode) {
                        var state = view.state, dispatch = view.dispatch;
                        var selection = prosemirror_state_dist["TextSelection"].create(state.doc, pos, pos + 1);
                        dispatch(state.tr.setSelection(selection));
                        uploadingNode.classList.add("selected");
                        return true;
                    }
                    return false;
                }
            },
            view: function(view) {
                return new image_extension_ToolbarPopover(view, {
                    className: image_extension_classNamePrefix("image-toobar-wrapper"),
                    isSticky: true,
                    store: _this.store
                });
            }
        }, {
            createUploadMask: image_extension_createUploadMask
        }));
    };
    _proto.commands = function commands(param) {
        var providers = param.providers;
        var _this = this;
        return {
            isImageDisabled: image_extension_isCommonDisabled,
            upload: function(files) {
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    var selectedFiles = files ? Promise.resolve(files) : selectFile({
                        accept: "image/*",
                        multiple: true
                    });
                    selectedFiles.then(function() {
                        var _ref = image_extension_asyncToGenerator$2(function(fileList) {
                            var _tmp, i;
                            return image_extension_generator$2(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = provider.onSelectFiles;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            provider.onSelectFiles(fileList)
                                        ];
                                    case 1:
                                        _tmp = !_state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (_tmp) {
                                            return [
                                                2
                                            ];
                                        }
                                        for(i = 0; i < fileList.length; i++){
                                            onUpload(view, provider)(fileList[i]);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(fileList) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return true;
                };
            },
            // 在指定位置插入图片，用于数据清洗功能
            insert: function(param) {
                var customUpload = param.customUpload, pos = param.pos;
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    onUpload(view, provider, pos)(customUpload);
                    return true;
                };
            },
            updateAttributes: function(data, pos) {
                return function(_, __, view) {
                    pos = pos !== null && pos !== void 0 ? pos : view.state.selection.from;
                    // TODO: 这一块先通过sessionStorage实现，后续考虑通过Provider获取到。
                    if (typeof data.border === "boolean") {
                        sessionStorage.setItem(IMAGE_BORDER_KEY, data.border ? "1" : "0");
                    }
                    var res = updateAttrs(data, pos)(view);
                    view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["NodeSelection"].create(view.state.doc, pos)));
                    view.focus();
                    return res;
                };
            }
        };
    };
    image_extension_createClass(ImageExtension, [
        {
            key: "name",
            get: function get() {
                return "image";
            }
        }
    ]);
    return ImageExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("c1df");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(obj) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, typeof_typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (typeof_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof_typeof(key) === "symbol" ? key : String(key);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function createClass_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function createClass_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) createClass_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) createClass_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function setPrototypeOf_setPrototypeOf(o, p) {
  setPrototypeOf_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return setPrototypeOf_setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function inherits_inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf_setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function getPrototypeOf_getPrototypeOf(o) {
  getPrototypeOf_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf_getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function isNativeReflectConstruct_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function assertThisInitialized_assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function possibleConstructorReturn_possibleConstructorReturn(self, call) {
  if (call && (typeof_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized_assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function createSuper_createSuper(Derived) {
  var hasNativeReflectConstruct = isNativeReflectConstruct_isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = getPrototypeOf_getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = getPrototypeOf_getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return possibleConstructorReturn_possibleConstructorReturn(this, result);
  };
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function extends_extends() {
  extends_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return extends_extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function defineProperty_defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function objectSpread2_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function objectSpread2_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? objectSpread2_ownKeys(Object(source), !0).forEach(function (key) {
      defineProperty_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : objectSpread2_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function arrayWithHoles_arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function iterableToArrayLimit_iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function arrayLikeToArray_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function unsupportedIterableToArray_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray_arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function nonIterableRest_nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function slicedToArray_slicedToArray(arr, i) {
  return arrayWithHoles_arrayWithHoles(arr) || iterableToArrayLimit_iterableToArrayLimit(arr, i) || unsupportedIterableToArray_unsupportedIterableToArray(arr, i) || nonIterableRest_nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__("4d26");
var node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);

// CONCATENATED MODULE: ./node_modules/rc-util/es/warning.js
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {}
}
function warning_note(valid, message) {
  // Support uglify
  if (false) {}
}
function resetWarned() {
  warned = {};
}
function warning_call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  warning_call(warning, valid, message);
}
function noteOnce(valid, message) {
  warning_call(warning_note, valid, message);
}
/* harmony default export */ var es_warning = (warningOnce);
/* eslint-enable */
// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useEvent.js

function useEvent(callback) {
  var fnRef = react["useRef"]();
  fnRef.current = callback;
  var memoFn = react["useCallback"](function () {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */
var useLayoutEffect =  true && canUseDom() ? react["useLayoutEffect"] : react["useEffect"];
/* harmony default export */ var hooks_useLayoutEffect = (useLayoutEffect);
var useLayoutEffect_useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
  var firstMountRef = react["useRef"](true);
  useLayoutEffect(function () {
    if (!firstMountRef.current) {
      return callback();
    }
  }, deps);
  // We tell react that first mount has passed
  useLayoutEffect(function () {
    firstMountRef.current = false;
    return function () {
      firstMountRef.current = true;
    };
  }, []);
};
// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useState.js


/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */
function useSafeState(defaultValue) {
  var destroyRef = react["useRef"](false);
  var _React$useState = react["useState"](defaultValue),
    _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  react["useEffect"](function () {
    destroyRef.current = false;
    return function () {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js




/** We only think `undefined` is empty */
function hasValue(value) {
  return value !== undefined;
}
/**
 * Similar to `useState` but will use props value if provided.
 * Note that internal use rc-util `useState` hook.
 */
function useMergedState(defaultStateValue, option) {
  var _ref = option || {},
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    postState = _ref.postState;
  // ======================= Init =======================
  var _useState = useSafeState(function () {
      if (hasValue(value)) {
        return value;
      } else if (hasValue(defaultValue)) {
        return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
      } else {
        return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
      }
    }),
    _useState2 = slicedToArray_slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var mergedValue = value !== undefined ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;
  // ====================== Change ======================
  var onChangeFn = useEvent(onChange);
  var _useState3 = useSafeState([mergedValue]),
    _useState4 = slicedToArray_slicedToArray(_useState3, 2),
    prevValue = _useState4[0],
    setPrevValue = _useState4[1];
  useLayoutEffect_useLayoutUpdateEffect(function () {
    var prev = prevValue[0];
    if (innerValue !== prev) {
      onChangeFn(innerValue, prev);
    }
  }, [prevValue]);
  // Sync value back to `undefined` when it from control to un-control
  useLayoutEffect_useLayoutUpdateEffect(function () {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);
  // ====================== Update ======================
  var triggerChange = useEvent(function (updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/KeyCode.js
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  /**
   * END
   */
  END: 35,
  /**
   * HOME
   */
  HOME: 36,
  /**
   * LEFT
   */
  LEFT: 37,
  /**
   * UP
   */
  UP: 38,
  /**
   * RIGHT
   */
  RIGHT: 39,
  /**
   * DOWN
   */
  DOWN: 40,
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  /**
   * DELETE
   */
  DELETE: 46,
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  /**
   * DASH
   */
  DASH: 189,
  /**
   * EQUALS
   */
  EQUALS: 187,
  /**
   * COMMA
   */
  COMMA: 188,
  /**
   * PERIOD
   */
  PERIOD: 190,
  /**
   * SLASH
   */
  SLASH: 191,
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
/* harmony default export */ var es_KeyCode = (KeyCode);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/PanelContext.js

var PanelContext = /*#__PURE__*/react["createContext"]({});
/* harmony default export */ var es_PanelContext = (PanelContext);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/Header.js


var HIDDEN_STYLE = {
  visibility: 'hidden'
};

function Header(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$prevIcon = _ref.prevIcon,
      prevIcon = _ref$prevIcon === void 0 ? "\u2039" : _ref$prevIcon,
      _ref$nextIcon = _ref.nextIcon,
      nextIcon = _ref$nextIcon === void 0 ? "\u203A" : _ref$nextIcon,
      _ref$superPrevIcon = _ref.superPrevIcon,
      superPrevIcon = _ref$superPrevIcon === void 0 ? "\xAB" : _ref$superPrevIcon,
      _ref$superNextIcon = _ref.superNextIcon,
      superNextIcon = _ref$superNextIcon === void 0 ? "\xBB" : _ref$superNextIcon,
      onSuperPrev = _ref.onSuperPrev,
      onSuperNext = _ref.onSuperNext,
      onPrev = _ref.onPrev,
      onNext = _ref.onNext,
      children = _ref.children;

  var _React$useContext = react["useContext"](es_PanelContext),
      hideNextBtn = _React$useContext.hideNextBtn,
      hidePrevBtn = _React$useContext.hidePrevBtn;

  return /*#__PURE__*/react["createElement"]("div", {
    className: prefixCls
  }, onSuperPrev && /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onSuperPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE : {}
  }, superPrevIcon), onPrev && /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE : {}
  }, prevIcon), /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-view")
  }, children), onNext && /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE : {}
  }, nextIcon), onSuperNext && /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onSuperNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE : {}
  }, superNextIcon));
}

/* harmony default export */ var panels_Header = (Header);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DecadePanel/DecadeHeader.js






function DecadeHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      viewDate = props.viewDate,
      onPrevDecades = props.onPrevDecades,
      onNextDecades = props.onNextDecades;

  var _React$useContext = react["useContext"](es_PanelContext),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  var yearNumber = generateConfig.getYear(viewDate);
  var startYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
  var endYear = startYear + DECADE_DISTANCE_COUNT - 1;
  return /*#__PURE__*/react["createElement"](panels_Header, extends_extends({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevDecades,
    onSuperNext: onNextDecades
  }), startYear, "-", endYear);
}

/* harmony default export */ var DecadePanel_DecadeHeader = (DecadeHeader);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/timeUtil.js
function timeUtil_setTime(generateConfig, date, hour, minute, second) {
  var nextTime = generateConfig.setHour(date, hour);
  nextTime = generateConfig.setMinute(nextTime, minute);
  nextTime = generateConfig.setSecond(nextTime, second);
  return nextTime;
}
function setDateTime(generateConfig, date, defaultDate) {
  if (!defaultDate) {
    return date;
  }

  var newDate = date;
  newDate = generateConfig.setHour(newDate, generateConfig.getHour(defaultDate));
  newDate = generateConfig.setMinute(newDate, generateConfig.getMinute(defaultDate));
  newDate = generateConfig.setSecond(newDate, generateConfig.getSecond(defaultDate));
  return newDate;
}
function getLowerBoundTime(hour, minute, second, hourStep, minuteStep, secondStep) {
  var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;

  if (lowerBoundHour < hour) {
    return [lowerBoundHour, 60 - minuteStep, 60 - secondStep];
  }

  var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;

  if (lowerBoundMinute < minute) {
    return [lowerBoundHour, lowerBoundMinute, 60 - secondStep];
  }

  var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
  return [lowerBoundHour, lowerBoundMinute, lowerBoundSecond];
}
function getLastDay(generateConfig, date) {
  var year = generateConfig.getYear(date);
  var month = generateConfig.getMonth(date) + 1;
  var endDate = generateConfig.getEndDate(generateConfig.getFixedDate("".concat(year, "-").concat(month, "-01")));
  var lastDay = generateConfig.getDate(endDate);
  var monthShow = month < 10 ? "0".concat(month) : "".concat(month);
  return "".concat(year, "-").concat(monthShow, "-").concat(lastDay);
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/PanelBody.js







function PanelBody(_ref) {
  var prefixCls = _ref.prefixCls,
      disabledDate = _ref.disabledDate,
      onSelect = _ref.onSelect,
      picker = _ref.picker,
      rowNum = _ref.rowNum,
      colNum = _ref.colNum,
      prefixColumn = _ref.prefixColumn,
      rowClassName = _ref.rowClassName,
      baseDate = _ref.baseDate,
      getCellClassName = _ref.getCellClassName,
      getCellText = _ref.getCellText,
      getCellNode = _ref.getCellNode,
      getCellDate = _ref.getCellDate,
      generateConfig = _ref.generateConfig,
      titleCell = _ref.titleCell,
      headerCells = _ref.headerCells;

  var _React$useContext = react["useContext"](es_PanelContext),
      onDateMouseEnter = _React$useContext.onDateMouseEnter,
      onDateMouseLeave = _React$useContext.onDateMouseLeave,
      mode = _React$useContext.mode;

  var cellPrefixCls = "".concat(prefixCls, "-cell"); // =============================== Body ===============================

  var rows = [];

  for (var i = 0; i < rowNum; i += 1) {
    var row = [];
    var rowStartDate = void 0;

    var _loop = function _loop(j) {
      var _objectSpread2;

      var offset = i * colNum + j;
      var currentDate = getCellDate(baseDate, offset);
      var disabled = getCellDateDisabled({
        cellDate: currentDate,
        mode: mode,
        disabledDate: disabledDate,
        generateConfig: generateConfig
      });

      if (j === 0) {
        rowStartDate = currentDate;

        if (prefixColumn) {
          row.push(prefixColumn(rowStartDate));
        }
      }

      var title = titleCell && titleCell(currentDate);
      row.push( /*#__PURE__*/react["createElement"]("td", {
        key: j,
        title: title,
        className: node_modules_classnames_default()(cellPrefixCls, objectSpread2_objectSpread2((_objectSpread2 = {}, defineProperty_defineProperty(_objectSpread2, "".concat(cellPrefixCls, "-disabled"), disabled), defineProperty_defineProperty(_objectSpread2, "".concat(cellPrefixCls, "-start"), getCellText(currentDate) === 1 || picker === 'year' && Number(title) % 10 === 0), defineProperty_defineProperty(_objectSpread2, "".concat(cellPrefixCls, "-end"), title === getLastDay(generateConfig, currentDate) || picker === 'year' && Number(title) % 10 === 9), _objectSpread2), getCellClassName(currentDate))),
        onClick: function onClick() {
          if (!disabled) {
            onSelect(currentDate);
          }
        },
        onMouseEnter: function onMouseEnter() {
          if (!disabled && onDateMouseEnter) {
            onDateMouseEnter(currentDate);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (!disabled && onDateMouseLeave) {
            onDateMouseLeave(currentDate);
          }
        }
      }, getCellNode ? getCellNode(currentDate) : /*#__PURE__*/react["createElement"]("div", {
        className: "".concat(cellPrefixCls, "-inner")
      }, getCellText(currentDate))));
    };

    for (var j = 0; j < colNum; j += 1) {
      _loop(j);
    }

    rows.push( /*#__PURE__*/react["createElement"]("tr", {
      key: i,
      className: rowClassName && rowClassName(rowStartDate)
    }, row));
  }

  return /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-body")
  }, /*#__PURE__*/react["createElement"]("table", {
    className: "".concat(prefixCls, "-content")
  }, headerCells && /*#__PURE__*/react["createElement"]("thead", null, /*#__PURE__*/react["createElement"]("tr", null, headerCells)), /*#__PURE__*/react["createElement"]("tbody", null, rows)));
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DecadePanel/DecadeBody.js





var DECADE_COL_COUNT = 3;
var DECADE_ROW_COUNT = 4;

function DecadeBody(props) {
  var DECADE_UNIT_DIFF_DES = DECADE_UNIT_DIFF - 1;
  var prefixCls = props.prefixCls,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig;
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var yearNumber = generateConfig.getYear(viewDate);
  var decadeYearNumber = Math.floor(yearNumber / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
  var startDecadeYear = Math.floor(yearNumber / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT;
  var endDecadeYear = startDecadeYear + DECADE_DISTANCE_COUNT - 1;
  var baseDecadeYear = generateConfig.setYear(viewDate, startDecadeYear - Math.ceil((DECADE_COL_COUNT * DECADE_ROW_COUNT * DECADE_UNIT_DIFF - DECADE_DISTANCE_COUNT) / 2));

  var getCellClassName = function getCellClassName(date) {
    var _ref;

    var startDecadeNumber = generateConfig.getYear(date);
    var endDecadeNumber = startDecadeNumber + DECADE_UNIT_DIFF_DES;
    return _ref = {}, defineProperty_defineProperty(_ref, "".concat(cellPrefixCls, "-in-view"), startDecadeYear <= startDecadeNumber && endDecadeNumber <= endDecadeYear), defineProperty_defineProperty(_ref, "".concat(cellPrefixCls, "-selected"), startDecadeNumber === decadeYearNumber), _ref;
  };

  return /*#__PURE__*/react["createElement"](PanelBody, extends_extends({}, props, {
    rowNum: DECADE_ROW_COUNT,
    colNum: DECADE_COL_COUNT,
    baseDate: baseDecadeYear,
    getCellText: function getCellText(date) {
      var startDecadeNumber = generateConfig.getYear(date);
      return "".concat(startDecadeNumber, "-").concat(startDecadeNumber + DECADE_UNIT_DIFF_DES);
    },
    getCellClassName: getCellClassName,
    getCellDate: function getCellDate(date, offset) {
      return generateConfig.addYear(date, offset * DECADE_UNIT_DIFF);
    }
  }));
}

/* harmony default export */ var DecadePanel_DecadeBody = (DecadeBody);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function arrayWithoutHoles_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray_arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function iterableToArray_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function nonIterableSpread_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(arr) {
  return arrayWithoutHoles_arrayWithoutHoles(arr) || iterableToArray_iterableToArray(arr) || unsupportedIterableToArray_unsupportedIterableToArray(arr) || nonIterableSpread_nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/raf.js
var raf_raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf_raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id);
      // Trigger
      callback();
    } else {
      // Next raf
      var realId = raf_raf(function () {
        callRef(leftTimes - 1);
      });
      // Bind real raf id
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};
/* harmony default export */ var es_raf = (wrapperRaf);
// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/isVisible.js
/* harmony default export */ var isVisible = (function (element) {
  if (!element) {
    return false;
  }
  if (element instanceof HTMLElement && element.offsetParent) {
    return true;
  }
  if (element instanceof SVGGraphicsElement && element.getBBox) {
    var _element$getBBox = element.getBBox(),
      width = _element$getBBox.width,
      height = _element$getBBox.height;
    if (width || height) {
      return true;
    }
  }
  if (element instanceof HTMLElement && element.getBoundingClientRect) {
    var _element$getBoundingC = element.getBoundingClientRect(),
      _width = _element$getBoundingC.width,
      _height = _element$getBoundingC.height;
    if (_width || _height) {
      return true;
    }
  }
  return false;
});
// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/uiUtil.js




var scrollIds = new Map();
/** Trigger when element is visible in view */

function waitElementReady(element, callback) {
  var id;

  function tryOrNextFrame() {
    if (isVisible(element)) {
      callback();
    } else {
      id = es_raf(function () {
        tryOrNextFrame();
      });
    }
  }

  tryOrNextFrame();
  return function () {
    es_raf.cancel(id);
  };
}
/* eslint-disable no-param-reassign */

function scrollTo(element, to, duration) {
  if (scrollIds.get(element)) {
    cancelAnimationFrame(scrollIds.get(element));
  } // jump to target if duration zero


  if (duration <= 0) {
    scrollIds.set(element, requestAnimationFrame(function () {
      element.scrollTop = to;
    }));
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  scrollIds.set(element, requestAnimationFrame(function () {
    element.scrollTop += perTick;

    if (element.scrollTop !== to) {
      scrollTo(element, to, duration - 10);
    }
  }));
}
function createKeyDownHandler(event, _ref) {
  var onLeftRight = _ref.onLeftRight,
      onCtrlLeftRight = _ref.onCtrlLeftRight,
      onUpDown = _ref.onUpDown,
      onPageUpDown = _ref.onPageUpDown,
      onEnter = _ref.onEnter;
  var which = event.which,
      ctrlKey = event.ctrlKey,
      metaKey = event.metaKey;

  switch (which) {
    case es_KeyCode.LEFT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(-1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(-1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case es_KeyCode.RIGHT:
      if (ctrlKey || metaKey) {
        if (onCtrlLeftRight) {
          onCtrlLeftRight(1);
          return true;
        }
      } else if (onLeftRight) {
        onLeftRight(1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case es_KeyCode.UP:
      if (onUpDown) {
        onUpDown(-1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case es_KeyCode.DOWN:
      if (onUpDown) {
        onUpDown(1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case es_KeyCode.PAGE_UP:
      if (onPageUpDown) {
        onPageUpDown(-1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case es_KeyCode.PAGE_DOWN:
      if (onPageUpDown) {
        onPageUpDown(1);
        return true;
      }
      /* istanbul ignore next */


      break;

    case es_KeyCode.ENTER:
      if (onEnter) {
        onEnter();
        return true;
      }
      /* istanbul ignore next */


      break;
  }

  return false;
} // ===================== Format =====================

function getDefaultFormat(format, picker, showTime, use12Hours) {
  var mergedFormat = format;

  if (!mergedFormat) {
    switch (picker) {
      case 'time':
        mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
        break;

      case 'week':
        mergedFormat = 'gggg-wo';
        break;

      case 'month':
        mergedFormat = 'YYYY-MM';
        break;

      case 'quarter':
        mergedFormat = 'YYYY-[Q]Q';
        break;

      case 'year':
        mergedFormat = 'YYYY';
        break;

      default:
        mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
  }

  return mergedFormat;
}
function getInputSize(picker, format, generateConfig) {
  var defaultSize = picker === 'time' ? 8 : 10;
  var length = typeof format === 'function' ? format(generateConfig.getNow()).length : format.length;
  return Math.max(defaultSize, length) + 2;
}
var uiUtil_globalClickFunc = null;
var clickCallbacks = new Set();
function addGlobalMouseDownEvent(callback) {
  if (!uiUtil_globalClickFunc && typeof window !== 'undefined' && window.addEventListener) {
    uiUtil_globalClickFunc = function globalClickFunc(e) {
      // Clone a new list to avoid repeat trigger events
      toConsumableArray_toConsumableArray(clickCallbacks).forEach(function (queueFunc) {
        queueFunc(e);
      });
    };

    window.addEventListener('mousedown', uiUtil_globalClickFunc);
  }

  clickCallbacks.add(callback);
  return function () {
    clickCallbacks.delete(callback);

    if (clickCallbacks.size === 0) {
      window.removeEventListener('mousedown', uiUtil_globalClickFunc);
      uiUtil_globalClickFunc = null;
    }
  };
}
function getTargetFromEvent(e) {
  var target = e.target; // get target if in shadow dom

  if (e.composed && target.shadowRoot) {
    var _e$composedPath;

    return ((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.call(e)[0]) || target;
  }

  return target;
} // ====================== Mode ======================

var getYearNextMode = function getYearNextMode(next) {
  if (next === 'month' || next === 'date') {
    return 'year';
  }

  return next;
};

var getMonthNextMode = function getMonthNextMode(next) {
  if (next === 'date') {
    return 'month';
  }

  return next;
};

var getQuarterNextMode = function getQuarterNextMode(next) {
  if (next === 'month' || next === 'date') {
    return 'quarter';
  }

  return next;
};

var getWeekNextMode = function getWeekNextMode(next) {
  if (next === 'date') {
    return 'week';
  }

  return next;
};

var PickerModeMap = {
  year: getYearNextMode,
  month: getMonthNextMode,
  quarter: getQuarterNextMode,
  week: getWeekNextMode,
  time: null,
  date: null
};
function elementsContains(elements, target) {
  return elements.some(function (ele) {
    return ele && ele.contains(target);
  });
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DecadePanel/index.js





var DECADE_UNIT_DIFF = 10;
var DECADE_DISTANCE_COUNT = DECADE_UNIT_DIFF * 10;

function DecadePanel(props) {
  var prefixCls = props.prefixCls,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      viewDate = props.viewDate,
      operationRef = props.operationRef,
      onSelect = props.onSelect,
      onPanelChange = props.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls, "-decade-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          onSelect(generateConfig.addYear(viewDate, diff * DECADE_UNIT_DIFF), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          onSelect(generateConfig.addYear(viewDate, diff * DECADE_DISTANCE_COUNT), 'key');
        },
        onUpDown: function onUpDown(diff) {
          onSelect(generateConfig.addYear(viewDate, diff * DECADE_UNIT_DIFF * DECADE_COL_COUNT), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange('year', viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onDecadesChange = function onDecadesChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff * DECADE_DISTANCE_COUNT);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  var onInternalSelect = function onInternalSelect(date) {
    onSelect(date, 'mouse');
    onPanelChange('year', date);
  };

  return /*#__PURE__*/react["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react["createElement"](DecadePanel_DecadeHeader, extends_extends({}, props, {
    prefixCls: prefixCls,
    onPrevDecades: function onPrevDecades() {
      onDecadesChange(-1);
    },
    onNextDecades: function onNextDecades() {
      onDecadesChange(1);
    }
  })), /*#__PURE__*/react["createElement"](DecadePanel_DecadeBody, extends_extends({}, props, {
    prefixCls: prefixCls,
    onSelect: onInternalSelect
  })));
}

/* harmony default export */ var panels_DecadePanel = (DecadePanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/dateUtil.js

var WEEK_DAY_COUNT = 7;
function isNullEqual(value1, value2) {
  if (!value1 && !value2) {
    return true;
  }

  if (!value1 || !value2) {
    return false;
  }

  return undefined;
}
function isSameDecade(generateConfig, decade1, decade2) {
  var equal = isNullEqual(decade1, decade2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
  var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
  return num1 === num2;
}
function isSameYear(generateConfig, year1, year2) {
  var equal = isNullEqual(year1, year2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getYear(year1) === generateConfig.getYear(year2);
}
function getQuarter(generateConfig, date) {
  var quota = Math.floor(generateConfig.getMonth(date) / 3);
  return quota + 1;
}
function isSameQuarter(generateConfig, quarter1, quarter2) {
  var equal = isNullEqual(quarter1, quarter2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return isSameYear(generateConfig, quarter1, quarter2) && getQuarter(generateConfig, quarter1) === getQuarter(generateConfig, quarter2);
}
function isSameMonth(generateConfig, month1, month2) {
  var equal = isNullEqual(month1, month2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return isSameYear(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
}
function isSameDate(generateConfig, date1, date2) {
  var equal = isNullEqual(date1, date2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getYear(date1) === generateConfig.getYear(date2) && generateConfig.getMonth(date1) === generateConfig.getMonth(date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
}
function isSameTime(generateConfig, time1, time2) {
  var equal = isNullEqual(time1, time2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
}
function isSameWeek(generateConfig, locale, date1, date2) {
  var equal = isNullEqual(date1, date2);

  if (typeof equal === 'boolean') {
    return equal;
  }

  return generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
}
function isEqual(generateConfig, value1, value2) {
  return isSameDate(generateConfig, value1, value2) && isSameTime(generateConfig, value1, value2);
}
/** Between in date but not equal of date */

function isInRange(generateConfig, startDate, endDate, current) {
  if (!startDate || !endDate || !current) {
    return false;
  }

  return !isSameDate(generateConfig, startDate, current) && !isSameDate(generateConfig, endDate, current) && generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function getWeekStartDate(locale, generateConfig, value) {
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
  var monthStartDate = generateConfig.setDate(value, 1);
  var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
  var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);

  if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) {
    alignStartDate = generateConfig.addDate(alignStartDate, -7);
  }

  return alignStartDate;
}
function getClosingViewDate(viewDate, picker, generateConfig) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  switch (picker) {
    case 'year':
      return generateConfig.addYear(viewDate, offset * 10);

    case 'quarter':
    case 'month':
      return generateConfig.addYear(viewDate, offset);

    default:
      return generateConfig.addMonth(viewDate, offset);
  }
}
function formatValue(value, _ref) {
  var generateConfig = _ref.generateConfig,
      locale = _ref.locale,
      format = _ref.format;
  return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function parseValue(value, _ref2) {
  var generateConfig = _ref2.generateConfig,
      locale = _ref2.locale,
      formatList = _ref2.formatList;

  if (!value || typeof formatList[0] === 'function') {
    return null;
  }

  return generateConfig.locale.parse(locale.locale, value, formatList);
} // eslint-disable-next-line consistent-return

function getCellDateDisabled(_ref3) {
  var cellDate = _ref3.cellDate,
      mode = _ref3.mode,
      disabledDate = _ref3.disabledDate,
      generateConfig = _ref3.generateConfig;
  if (!disabledDate) return false; // Whether cellDate is disabled in range

  var getDisabledFromRange = function getDisabledFromRange(currentMode, start, end) {
    var current = start;

    while (current <= end) {
      var date = void 0;

      switch (currentMode) {
        case 'date':
          {
            date = generateConfig.setDate(cellDate, current);

            if (!disabledDate(date)) {
              return false;
            }

            break;
          }

        case 'month':
          {
            date = generateConfig.setMonth(cellDate, current);

            if (!getCellDateDisabled({
              cellDate: date,
              mode: 'month',
              generateConfig: generateConfig,
              disabledDate: disabledDate
            })) {
              return false;
            }

            break;
          }

        case 'year':
          {
            date = generateConfig.setYear(cellDate, current);

            if (!getCellDateDisabled({
              cellDate: date,
              mode: 'year',
              generateConfig: generateConfig,
              disabledDate: disabledDate
            })) {
              return false;
            }

            break;
          }
      }

      current += 1;
    }

    return true;
  };

  switch (mode) {
    case 'date':
    case 'week':
      {
        return disabledDate(cellDate);
      }

    case 'month':
      {
        var startDate = 1;
        var endDate = generateConfig.getDate(generateConfig.getEndDate(cellDate));
        return getDisabledFromRange('date', startDate, endDate);
      }

    case 'quarter':
      {
        var startMonth = Math.floor(generateConfig.getMonth(cellDate) / 3) * 3;
        var endMonth = startMonth + 2;
        return getDisabledFromRange('month', startMonth, endMonth);
      }

    case 'year':
      {
        return getDisabledFromRange('month', 0, 11);
      }

    case 'decade':
      {
        var year = generateConfig.getYear(cellDate);
        var startYear = Math.floor(year / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF;
        var endYear = startYear + DECADE_UNIT_DIFF - 1;
        return getDisabledFromRange('year', startYear, endYear);
      }
  }
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/TimePanel/TimeHeader.js





function TimeHeader(props) {
  var _React$useContext = react["useContext"](es_PanelContext),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      value = props.value,
      format = props.format;
  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /*#__PURE__*/react["createElement"](panels_Header, {
    prefixCls: headerPrefixCls
  }, value ? formatValue(value, {
    locale: locale,
    format: format,
    generateConfig: generateConfig
  }) : "\xA0");
}

/* harmony default export */ var TimePanel_TimeHeader = (TimeHeader);
// CONCATENATED MODULE: ./node_modules/rc-util/es/hooks/useMemo.js

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = react["useRef"]({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/TimePanel/TimeUnitColumn.js







function TimeUnitColumn(props) {
  var prefixCls = props.prefixCls,
      units = props.units,
      onSelect = props.onSelect,
      value = props.value,
      active = props.active,
      hideDisabledOptions = props.hideDisabledOptions;
  var cellPrefixCls = "".concat(prefixCls, "-cell");

  var _React$useContext = react["useContext"](es_PanelContext),
      open = _React$useContext.open;

  var ulRef = Object(react["useRef"])(null);
  var liRefs = Object(react["useRef"])(new Map());
  var scrollRef = Object(react["useRef"])(); // `useLayoutEffect` here to avoid blink by duration is 0

  Object(react["useLayoutEffect"])(function () {
    var li = liRefs.current.get(value);

    if (li && open !== false) {
      scrollTo(ulRef.current, li.offsetTop, 120);
    }
  }, [value]);
  Object(react["useLayoutEffect"])(function () {
    if (open) {
      var li = liRefs.current.get(value);

      if (li) {
        scrollRef.current = waitElementReady(li, function () {
          scrollTo(ulRef.current, li.offsetTop, 0);
        });
      }
    }

    return function () {
      var _scrollRef$current;

      (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.call(scrollRef);
    };
  }, [open]);
  return /*#__PURE__*/react["createElement"]("ul", {
    className: node_modules_classnames_default()("".concat(prefixCls, "-column"), defineProperty_defineProperty({}, "".concat(prefixCls, "-column-active"), active)),
    ref: ulRef,
    style: {
      position: 'relative'
    }
  }, units.map(function (unit) {
    var _classNames2;

    if (hideDisabledOptions && unit.disabled) {
      return null;
    }

    return /*#__PURE__*/react["createElement"]("li", {
      key: unit.value,
      ref: function ref(element) {
        liRefs.current.set(unit.value, element);
      },
      className: node_modules_classnames_default()(cellPrefixCls, (_classNames2 = {}, defineProperty_defineProperty(_classNames2, "".concat(cellPrefixCls, "-disabled"), unit.disabled), defineProperty_defineProperty(_classNames2, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames2)),
      onClick: function onClick() {
        if (unit.disabled) {
          return;
        }

        onSelect(unit.value);
      }
    }, /*#__PURE__*/react["createElement"]("div", {
      className: "".concat(cellPrefixCls, "-inner")
    }, unit.label));
  }));
}

/* harmony default export */ var TimePanel_TimeUnitColumn = (TimeUnitColumn);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/miscUtil.js
function leftPad(str, length) {
  var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  var current = String(str);

  while (current.length < length) {
    current = "".concat(fill).concat(str);
  }

  return current;
}
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};
function toArray(val) {
  if (val === null || val === undefined) {
    return [];
  }

  return Array.isArray(val) ? val : [val];
}
function getDataOrAriaProps(props) {
  var retProps = {};
  Object.keys(props).forEach(function (key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role' || key === 'name') && key.substr(0, 7) !== 'data-__') {
      retProps[key] = props[key];
    }
  });
  return retProps;
}
function miscUtil_getValue(values, index) {
  return values ? values[index] : null;
}
function updateValues(values, value, index) {
  var newValues = [miscUtil_getValue(values, 0), miscUtil_getValue(values, 1)];
  newValues[index] = typeof value === 'function' ? value(newValues[index]) : value;

  if (!newValues[0] && !newValues[1]) {
    return null;
  }

  return newValues;
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/TimePanel/TimeBody.js








function shouldUnitsUpdate(prevUnits, nextUnits) {
  if (prevUnits.length !== nextUnits.length) return true; // if any unit's disabled status is different, the units should be re-evaluted

  for (var i = 0; i < prevUnits.length; i += 1) {
    if (prevUnits[i].disabled !== nextUnits[i].disabled) return true;
  }

  return false;
}

function generateUnits(start, end, step, disabledUnits) {
  var units = [];

  for (var i = start; i <= end; i += step) {
    units.push({
      label: leftPad(i, 2),
      value: i,
      disabled: (disabledUnits || []).includes(i)
    });
  }

  return units;
}

function TimeBody(props) {
  var generateConfig = props.generateConfig,
      prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      activeColumnIndex = props.activeColumnIndex,
      value = props.value,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      use12Hours = props.use12Hours,
      _props$hourStep = props.hourStep,
      hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep,
      _props$minuteStep = props.minuteStep,
      minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep,
      _props$secondStep = props.secondStep,
      secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep,
      disabledHours = props.disabledHours,
      disabledMinutes = props.disabledMinutes,
      disabledSeconds = props.disabledSeconds,
      hideDisabledOptions = props.hideDisabledOptions,
      onSelect = props.onSelect;
  var columns = [];
  var contentPrefixCls = "".concat(prefixCls, "-content");
  var columnPrefixCls = "".concat(prefixCls, "-time-panel");
  var isPM;
  var originHour = value ? generateConfig.getHour(value) : -1;
  var hour = originHour;
  var minute = value ? generateConfig.getMinute(value) : -1;
  var second = value ? generateConfig.getSecond(value) : -1;

  var setTime = function setTime(isNewPM, newHour, newMinute, newSecond) {
    var newDate = value || generateConfig.getNow();
    var mergedHour = Math.max(0, newHour);
    var mergedMinute = Math.max(0, newMinute);
    var mergedSecond = Math.max(0, newSecond);
    newDate = timeUtil_setTime(generateConfig, newDate, !use12Hours || !isNewPM ? mergedHour : mergedHour + 12, mergedMinute, mergedSecond);
    return newDate;
  }; // ========================= Unit =========================


  var rawHours = generateUnits(0, 23, hourStep, disabledHours && disabledHours());
  var memorizedRawHours = useMemo(function () {
    return rawHours;
  }, rawHours, shouldUnitsUpdate); // Should additional logic to handle 12 hours

  if (use12Hours) {
    isPM = hour >= 12; // -1 means should display AM

    hour %= 12;
  }

  var _React$useMemo = react["useMemo"](function () {
    if (!use12Hours) {
      return [false, false];
    }

    var AMPMDisabled = [true, true];
    memorizedRawHours.forEach(function (_ref) {
      var disabled = _ref.disabled,
          hourValue = _ref.value;
      if (disabled) return;

      if (hourValue >= 12) {
        AMPMDisabled[1] = false;
      } else {
        AMPMDisabled[0] = false;
      }
    });
    return AMPMDisabled;
  }, [use12Hours, memorizedRawHours]),
      _React$useMemo2 = slicedToArray_slicedToArray(_React$useMemo, 2),
      AMDisabled = _React$useMemo2[0],
      PMDisabled = _React$useMemo2[1];

  var hours = react["useMemo"](function () {
    if (!use12Hours) return memorizedRawHours;
    return memorizedRawHours.filter(isPM ? function (hourMeta) {
      return hourMeta.value >= 12;
    } : function (hourMeta) {
      return hourMeta.value < 12;
    }).map(function (hourMeta) {
      var hourValue = hourMeta.value % 12;
      var hourLabel = hourValue === 0 ? '12' : leftPad(hourValue, 2);
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, hourMeta), {}, {
        label: hourLabel,
        value: hourValue
      });
    });
  }, [use12Hours, isPM, memorizedRawHours]);
  var minutes = generateUnits(0, 59, minuteStep, disabledMinutes && disabledMinutes(originHour));
  var seconds = generateUnits(0, 59, secondStep, disabledSeconds && disabledSeconds(originHour, minute)); // ====================== Operations ======================

  operationRef.current = {
    onUpDown: function onUpDown(diff) {
      var column = columns[activeColumnIndex];

      if (column) {
        var valueIndex = column.units.findIndex(function (unit) {
          return unit.value === column.value;
        });
        var unitLen = column.units.length;

        for (var i = 1; i < unitLen; i += 1) {
          var nextUnit = column.units[(valueIndex + diff * i + unitLen) % unitLen];

          if (nextUnit.disabled !== true) {
            column.onSelect(nextUnit.value);
            break;
          }
        }
      }
    }
  }; // ======================== Render ========================

  function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
    if (condition !== false) {
      columns.push({
        node: /*#__PURE__*/react["cloneElement"](node, {
          prefixCls: columnPrefixCls,
          value: columnValue,
          active: activeColumnIndex === columns.length,
          onSelect: onColumnSelect,
          units: units,
          hideDisabledOptions: hideDisabledOptions
        }),
        onSelect: onColumnSelect,
        value: columnValue,
        units: units
      });
    }
  } // Hour


  addColumnNode(showHour, /*#__PURE__*/react["createElement"](TimePanel_TimeUnitColumn, {
    key: "hour"
  }), hour, hours, function (num) {
    onSelect(setTime(isPM, num, minute, second), 'mouse');
  }); // Minute

  addColumnNode(showMinute, /*#__PURE__*/react["createElement"](TimePanel_TimeUnitColumn, {
    key: "minute"
  }), minute, minutes, function (num) {
    onSelect(setTime(isPM, hour, num, second), 'mouse');
  }); // Second

  addColumnNode(showSecond, /*#__PURE__*/react["createElement"](TimePanel_TimeUnitColumn, {
    key: "second"
  }), second, seconds, function (num) {
    onSelect(setTime(isPM, hour, minute, num), 'mouse');
  }); // 12 Hours

  var PMIndex = -1;

  if (typeof isPM === 'boolean') {
    PMIndex = isPM ? 1 : 0;
  }

  addColumnNode(use12Hours === true, /*#__PURE__*/react["createElement"](TimePanel_TimeUnitColumn, {
    key: "12hours"
  }), PMIndex, [{
    label: 'AM',
    value: 0,
    disabled: AMDisabled
  }, {
    label: 'PM',
    value: 1,
    disabled: PMDisabled
  }], function (num) {
    onSelect(setTime(!!num, hour, minute, second), 'mouse');
  });
  return /*#__PURE__*/react["createElement"]("div", {
    className: contentPrefixCls
  }, columns.map(function (_ref2) {
    var node = _ref2.node;
    return node;
  }));
}

/* harmony default export */ var TimePanel_TimeBody = (TimeBody);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/TimePanel/index.js









var countBoolean = function countBoolean(boolList) {
  return boolList.filter(function (bool) {
    return bool !== false;
  }).length;
};

function TimePanel(props) {
  var generateConfig = props.generateConfig,
      _props$format = props.format,
      format = _props$format === void 0 ? 'HH:mm:ss' : _props$format,
      prefixCls = props.prefixCls,
      active = props.active,
      operationRef = props.operationRef,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      _props$use12Hours = props.use12Hours,
      use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours,
      onSelect = props.onSelect,
      value = props.value;
  var panelPrefixCls = "".concat(prefixCls, "-time-panel");
  var bodyOperationRef = react["useRef"](); // ======================= Keyboard =======================

  var _React$useState = react["useState"](-1),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      activeColumnIndex = _React$useState2[0],
      setActiveColumnIndex = _React$useState2[1];

  var columnsCount = countBoolean([showHour, showMinute, showSecond, use12Hours]);
  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          setActiveColumnIndex((activeColumnIndex + diff + columnsCount) % columnsCount);
        },
        onUpDown: function onUpDown(diff) {
          if (activeColumnIndex === -1) {
            setActiveColumnIndex(0);
          } else if (bodyOperationRef.current) {
            bodyOperationRef.current.onUpDown(diff);
          }
        },
        onEnter: function onEnter() {
          onSelect(value || generateConfig.getNow(), 'key');
          setActiveColumnIndex(-1);
        }
      });
    },
    onBlur: function onBlur() {
      setActiveColumnIndex(-1);
    }
  };
  return /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()(panelPrefixCls, defineProperty_defineProperty({}, "".concat(panelPrefixCls, "-active"), active))
  }, /*#__PURE__*/react["createElement"](TimePanel_TimeHeader, extends_extends({}, props, {
    format: format,
    prefixCls: prefixCls
  })), /*#__PURE__*/react["createElement"](TimePanel_TimeBody, extends_extends({}, props, {
    prefixCls: prefixCls,
    activeColumnIndex: activeColumnIndex,
    operationRef: bodyOperationRef
  })));
}

/* harmony default export */ var panels_TimePanel = (TimePanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/RangeContext.js

var RangeContext = /*#__PURE__*/react["createContext"]({});
/* harmony default export */ var es_RangeContext = (RangeContext);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useCellClassName.js



function useCellClassName(_ref) {
  var cellPrefixCls = _ref.cellPrefixCls,
      generateConfig = _ref.generateConfig,
      rangedValue = _ref.rangedValue,
      hoverRangedValue = _ref.hoverRangedValue,
      isInView = _ref.isInView,
      isSameCell = _ref.isSameCell,
      offsetCell = _ref.offsetCell,
      today = _ref.today,
      value = _ref.value;

  function getClassName(currentDate) {
    var _ref2;

    var prevDate = offsetCell(currentDate, -1);
    var nextDate = offsetCell(currentDate, 1);
    var rangeStart = miscUtil_getValue(rangedValue, 0);
    var rangeEnd = miscUtil_getValue(rangedValue, 1);
    var hoverStart = miscUtil_getValue(hoverRangedValue, 0);
    var hoverEnd = miscUtil_getValue(hoverRangedValue, 1);
    var isRangeHovered = isInRange(generateConfig, hoverStart, hoverEnd, currentDate);

    function isRangeStart(date) {
      return isSameCell(rangeStart, date);
    }

    function isRangeEnd(date) {
      return isSameCell(rangeEnd, date);
    }

    var isHoverStart = isSameCell(hoverStart, currentDate);
    var isHoverEnd = isSameCell(hoverEnd, currentDate);
    var isHoverEdgeStart = (isRangeHovered || isHoverEnd) && (!isInView(prevDate) || isRangeEnd(prevDate));
    var isHoverEdgeEnd = (isRangeHovered || isHoverStart) && (!isInView(nextDate) || isRangeStart(nextDate));
    return _ref2 = {}, defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-in-view"), isInView(currentDate)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-in-range"), isInRange(generateConfig, rangeStart, rangeEnd, currentDate)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-start"), isRangeStart(currentDate)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-end"), isRangeEnd(currentDate)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-start-single"), isRangeStart(currentDate) && !rangeEnd), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-end-single"), isRangeEnd(currentDate) && !rangeStart), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-start-near-hover"), isRangeStart(currentDate) && (isSameCell(prevDate, hoverStart) || isInRange(generateConfig, hoverStart, hoverEnd, prevDate))), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-end-near-hover"), isRangeEnd(currentDate) && (isSameCell(nextDate, hoverEnd) || isInRange(generateConfig, hoverStart, hoverEnd, nextDate))), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover"), isRangeHovered), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover-start"), isHoverStart), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover-end"), isHoverEnd), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start"), isHoverEdgeStart), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end"), isHoverEdgeEnd), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start-near-range"), isHoverEdgeStart && isSameCell(prevDate, rangeEnd)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end-near-range"), isHoverEdgeEnd && isSameCell(nextDate, rangeStart)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-today"), isSameCell(today, currentDate)), defineProperty_defineProperty(_ref2, "".concat(cellPrefixCls, "-selected"), isSameCell(value, currentDate)), _ref2;
  }

  return getClassName;
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DatePanel/DateBody.js







function DateBody(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      prefixColumn = props.prefixColumn,
      locale = props.locale,
      rowCount = props.rowCount,
      viewDate = props.viewDate,
      value = props.value,
      dateRender = props.dateRender;

  var _React$useContext = react["useContext"](es_RangeContext),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var baseDate = getWeekStartDate(locale.locale, generateConfig, viewDate);
  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
  var today = generateConfig.getNow(); // ============================== Header ==============================

  var headerCells = [];
  var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);

  if (prefixColumn) {
    headerCells.push( /*#__PURE__*/react["createElement"]("th", {
      key: "empty",
      "aria-label": "empty cell"
    }));
  }

  for (var i = 0; i < WEEK_DAY_COUNT; i += 1) {
    headerCells.push( /*#__PURE__*/react["createElement"]("th", {
      key: i
    }, weekDaysLocale[(i + weekFirstDay) % WEEK_DAY_COUNT]));
  } // =============================== Body ===============================


  var getCellClassName = useCellClassName({
    cellPrefixCls: cellPrefixCls,
    today: today,
    value: value,
    generateConfig: generateConfig,
    rangedValue: prefixColumn ? null : rangedValue,
    hoverRangedValue: prefixColumn ? null : hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameDate(generateConfig, current, target);
    },
    isInView: function isInView(date) {
      return isSameMonth(generateConfig, date, viewDate);
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addDate(date, offset);
    }
  });
  var getCellNode = dateRender ? function (date) {
    return dateRender(date, today);
  } : undefined;
  return /*#__PURE__*/react["createElement"](PanelBody, extends_extends({}, props, {
    rowNum: rowCount,
    colNum: WEEK_DAY_COUNT,
    baseDate: baseDate,
    getCellNode: getCellNode,
    getCellText: generateConfig.getDate,
    getCellClassName: getCellClassName,
    getCellDate: generateConfig.addDate,
    titleCell: function titleCell(date) {
      return formatValue(date, {
        locale: locale,
        format: 'YYYY-MM-DD',
        generateConfig: generateConfig
      });
    },
    headerCells: headerCells
  }));
}

/* harmony default export */ var DatePanel_DateBody = (DateBody);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DatePanel/DateHeader.js






function DateHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      viewDate = props.viewDate,
      onNextMonth = props.onNextMonth,
      onPrevMonth = props.onPrevMonth,
      onNextYear = props.onNextYear,
      onPrevYear = props.onPrevYear,
      onYearClick = props.onYearClick,
      onMonthClick = props.onMonthClick;

  var _React$useContext = react["useContext"](es_PanelContext),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
  var month = generateConfig.getMonth(viewDate); // =================== Month & Year ===================

  var yearNode = /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    key: "year",
    onClick: onYearClick,
    tabIndex: -1,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(viewDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  }));
  var monthNode = /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    key: "month",
    onClick: onMonthClick,
    tabIndex: -1,
    className: "".concat(prefixCls, "-month-btn")
  }, locale.monthFormat ? formatValue(viewDate, {
    locale: locale,
    format: locale.monthFormat,
    generateConfig: generateConfig
  }) : monthsLocale[month]);
  var monthYearNodes = locale.monthBeforeYear ? [monthNode, yearNode] : [yearNode, monthNode];
  return /*#__PURE__*/react["createElement"](panels_Header, extends_extends({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onPrev: onPrevMonth,
    onNext: onNextMonth,
    onSuperNext: onNextYear
  }), monthYearNodes);
}

/* harmony default export */ var DatePanel_DateHeader = (DateHeader);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DatePanel/index.js









var DATE_ROW_COUNT = 6;

function DatePanel(props) {
  var prefixCls = props.prefixCls,
      _props$panelName = props.panelName,
      panelName = _props$panelName === void 0 ? 'date' : _props$panelName,
      keyboardConfig = props.keyboardConfig,
      active = props.active,
      operationRef = props.operationRef,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onViewDateChange = props.onViewDateChange,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, objectSpread2_objectSpread2({
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addDate(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addDate(value || viewDate, diff * WEEK_DAY_COUNT), 'key');
        },
        onPageUpDown: function onPageUpDown(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
        }
      }, keyboardConfig));
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  var onMonthChange = function onMonthChange(diff) {
    var newDate = generateConfig.addMonth(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()(panelPrefixCls, defineProperty_defineProperty({}, "".concat(panelPrefixCls, "-active"), active))
  }, /*#__PURE__*/react["createElement"](DatePanel_DateHeader, extends_extends({}, props, {
    prefixCls: prefixCls,
    value: value,
    viewDate: viewDate // View Operation
    ,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onPrevMonth: function onPrevMonth() {
      onMonthChange(-1);
    },
    onNextMonth: function onNextMonth() {
      onMonthChange(1);
    },
    onMonthClick: function onMonthClick() {
      onPanelChange('month', viewDate);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    }
  })), /*#__PURE__*/react["createElement"](DatePanel_DateBody, extends_extends({}, props, {
    onSelect: function onSelect(date) {
      return _onSelect(date, 'mouse');
    },
    prefixCls: prefixCls,
    value: value,
    viewDate: viewDate,
    rowCount: DATE_ROW_COUNT
  })));
}

/* harmony default export */ var panels_DatePanel = (DatePanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/DatetimePanel/index.js












var ACTIVE_PANEL = tuple('date', 'time');

function DatetimePanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      generateConfig = props.generateConfig,
      value = props.value,
      defaultValue = props.defaultValue,
      disabledTime = props.disabledTime,
      showTime = props.showTime,
      onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");

  var _React$useState = react["useState"](null),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      activePanel = _React$useState2[0],
      setActivePanel = _React$useState2[1];

  var dateOperationRef = react["useRef"]({});
  var timeOperationRef = react["useRef"]({});
  var timeProps = typeof_typeof(showTime) === 'object' ? objectSpread2_objectSpread2({}, showTime) : {}; // ======================= Keyboard =======================

  function getNextActive(offset) {
    var activeIndex = ACTIVE_PANEL.indexOf(activePanel) + offset;
    var nextActivePanel = ACTIVE_PANEL[activeIndex] || null;
    return nextActivePanel;
  }

  var onBlur = function onBlur(e) {
    if (timeOperationRef.current.onBlur) {
      timeOperationRef.current.onBlur(e);
    }

    setActivePanel(null);
  };

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      // Switch active panel
      if (event.which === es_KeyCode.TAB) {
        var nextActivePanel = getNextActive(event.shiftKey ? -1 : 1);
        setActivePanel(nextActivePanel);

        if (nextActivePanel) {
          event.preventDefault();
        }

        return true;
      } // Operate on current active panel


      if (activePanel) {
        var ref = activePanel === 'date' ? dateOperationRef : timeOperationRef;

        if (ref.current && ref.current.onKeyDown) {
          ref.current.onKeyDown(event);
        }

        return true;
      } // Switch first active panel if operate without panel


      if ([es_KeyCode.LEFT, es_KeyCode.RIGHT, es_KeyCode.UP, es_KeyCode.DOWN].includes(event.which)) {
        setActivePanel('date');
        return true;
      }

      return false;
    },
    onBlur: onBlur,
    onClose: onBlur
  }; // ======================== Events ========================

  var onInternalSelect = function onInternalSelect(date, source) {
    var selectedDate = date;

    if (source === 'date' && !value && timeProps.defaultValue) {
      // Date with time defaultValue
      selectedDate = generateConfig.setHour(selectedDate, generateConfig.getHour(timeProps.defaultValue));
      selectedDate = generateConfig.setMinute(selectedDate, generateConfig.getMinute(timeProps.defaultValue));
      selectedDate = generateConfig.setSecond(selectedDate, generateConfig.getSecond(timeProps.defaultValue));
    } else if (source === 'time' && !value && defaultValue) {
      selectedDate = generateConfig.setYear(selectedDate, generateConfig.getYear(defaultValue));
      selectedDate = generateConfig.setMonth(selectedDate, generateConfig.getMonth(defaultValue));
      selectedDate = generateConfig.setDate(selectedDate, generateConfig.getDate(defaultValue));
    }

    if (onSelect) {
      onSelect(selectedDate, 'mouse');
    }
  }; // ======================== Render ========================


  var disabledTimes = disabledTime ? disabledTime(value || null) : {};
  return /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()(panelPrefixCls, defineProperty_defineProperty({}, "".concat(panelPrefixCls, "-active"), activePanel))
  }, /*#__PURE__*/react["createElement"](panels_DatePanel, extends_extends({}, props, {
    operationRef: dateOperationRef,
    active: activePanel === 'date',
    onSelect: function onSelect(date) {
      onInternalSelect(setDateTime(generateConfig, date, showTime && typeof_typeof(showTime) === 'object' ? showTime.defaultValue : null), 'date');
    }
  })), /*#__PURE__*/react["createElement"](panels_TimePanel, extends_extends({}, props, {
    format: undefined
  }, timeProps, disabledTimes, {
    defaultValue: undefined,
    operationRef: timeOperationRef,
    active: activePanel === 'time',
    onSelect: function onSelect(date) {
      onInternalSelect(date, 'time');
    }
  })));
}

/* harmony default export */ var panels_DatetimePanel = (DatetimePanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/WeekPanel/index.js







function WeekPanel(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      value = props.value; // Render additional column

  var cellPrefixCls = "".concat(prefixCls, "-cell");

  var prefixColumn = function prefixColumn(date) {
    return /*#__PURE__*/react["createElement"]("td", {
      key: "week",
      className: node_modules_classnames_default()(cellPrefixCls, "".concat(cellPrefixCls, "-week"))
    }, generateConfig.locale.getWeek(locale.locale, date));
  }; // Add row className


  var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");

  var rowClassName = function rowClassName(date) {
    return node_modules_classnames_default()(rowPrefixCls, defineProperty_defineProperty({}, "".concat(rowPrefixCls, "-selected"), isSameWeek(generateConfig, locale.locale, value, date)));
  };

  return /*#__PURE__*/react["createElement"](panels_DatePanel, extends_extends({}, props, {
    panelName: "week",
    prefixColumn: prefixColumn,
    rowClassName: rowClassName,
    keyboardConfig: {
      onLeftRight: null
    }
  }));
}

/* harmony default export */ var panels_WeekPanel = (WeekPanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/MonthPanel/MonthHeader.js






function MonthHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      viewDate = props.viewDate,
      onNextYear = props.onNextYear,
      onPrevYear = props.onPrevYear,
      onYearClick = props.onYearClick;

  var _React$useContext = react["useContext"](es_PanelContext),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /*#__PURE__*/react["createElement"](panels_Header, extends_extends({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onSuperNext: onNextYear
  }), /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onYearClick,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(viewDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  })));
}

/* harmony default export */ var MonthPanel_MonthHeader = (MonthHeader);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/MonthPanel/MonthBody.js






var MONTH_COL_COUNT = 3;
var MONTH_ROW_COUNT = 4;

function MonthBody(props) {
  var prefixCls = props.prefixCls,
      locale = props.locale,
      value = props.value,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig,
      monthCellRender = props.monthCellRender;

  var _React$useContext = react["useContext"](es_RangeContext),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls: cellPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameMonth(generateConfig, current, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addMonth(date, offset);
    }
  });
  var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
  var baseMonth = generateConfig.setMonth(viewDate, 0);
  var getCellNode = monthCellRender ? function (date) {
    return monthCellRender(date, locale);
  } : undefined;
  return /*#__PURE__*/react["createElement"](PanelBody, extends_extends({}, props, {
    rowNum: MONTH_ROW_COUNT,
    colNum: MONTH_COL_COUNT,
    baseDate: baseMonth,
    getCellNode: getCellNode,
    getCellText: function getCellText(date) {
      return locale.monthFormat ? formatValue(date, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
      }) : monthsLocale[generateConfig.getMonth(date)];
    },
    getCellClassName: getCellClassName,
    getCellDate: generateConfig.addMonth,
    titleCell: function titleCell(date) {
      return formatValue(date, {
        locale: locale,
        format: 'YYYY-MM',
        generateConfig: generateConfig
      });
    }
  }));
}

/* harmony default export */ var MonthPanel_MonthBody = (MonthBody);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/MonthPanel/index.js






function MonthPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-month-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff * MONTH_COL_COUNT), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange('date', value || viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/react["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react["createElement"](MonthPanel_MonthHeader, extends_extends({}, props, {
    prefixCls: prefixCls,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    }
  })), /*#__PURE__*/react["createElement"](MonthPanel_MonthBody, extends_extends({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      _onSelect(date, 'mouse');

      onPanelChange('date', date);
    }
  })));
}

/* harmony default export */ var panels_MonthPanel = (MonthPanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/QuarterPanel/QuarterHeader.js






function QuarterHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      locale = props.locale,
      viewDate = props.viewDate,
      onNextYear = props.onNextYear,
      onPrevYear = props.onPrevYear,
      onYearClick = props.onYearClick;

  var _React$useContext = react["useContext"](es_PanelContext),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  return /*#__PURE__*/react["createElement"](panels_Header, extends_extends({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevYear,
    onSuperNext: onNextYear
  }), /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onYearClick,
    className: "".concat(prefixCls, "-year-btn")
  }, formatValue(viewDate, {
    locale: locale,
    format: locale.yearFormat,
    generateConfig: generateConfig
  })));
}

/* harmony default export */ var QuarterPanel_QuarterHeader = (QuarterHeader);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/QuarterPanel/QuarterBody.js






var QUARTER_COL_COUNT = 4;
var QUARTER_ROW_COUNT = 1;

function QuarterBody(props) {
  var prefixCls = props.prefixCls,
      locale = props.locale,
      value = props.value,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig;

  var _React$useContext = react["useContext"](es_RangeContext),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls: cellPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameQuarter(generateConfig, current, target);
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addMonth(date, offset * 3);
    }
  });
  var baseQuarter = generateConfig.setDate(generateConfig.setMonth(viewDate, 0), 1);
  return /*#__PURE__*/react["createElement"](PanelBody, extends_extends({}, props, {
    rowNum: QUARTER_ROW_COUNT,
    colNum: QUARTER_COL_COUNT,
    baseDate: baseQuarter,
    getCellText: function getCellText(date) {
      return formatValue(date, {
        locale: locale,
        format: locale.quarterFormat || '[Q]Q',
        generateConfig: generateConfig
      });
    },
    getCellClassName: getCellClassName,
    getCellDate: function getCellDate(date, offset) {
      return generateConfig.addMonth(date, offset * 3);
    },
    titleCell: function titleCell(date) {
      return formatValue(date, {
        locale: locale,
        format: 'YYYY-[Q]Q',
        generateConfig: generateConfig
      });
    }
  }));
}

/* harmony default export */ var QuarterPanel_QuarterBody = (QuarterBody);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/QuarterPanel/index.js






function QuarterPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      onPanelChange = props.onPanelChange,
      _onSelect = props.onSelect;
  var panelPrefixCls = "".concat(prefixCls, "-quarter-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addMonth(value || viewDate, diff * 3), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        }
      });
    }
  }; // ==================== View Operation ====================

  var onYearChange = function onYearChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/react["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react["createElement"](QuarterPanel_QuarterHeader, extends_extends({}, props, {
    prefixCls: prefixCls,
    onPrevYear: function onPrevYear() {
      onYearChange(-1);
    },
    onNextYear: function onNextYear() {
      onYearChange(1);
    },
    onYearClick: function onYearClick() {
      onPanelChange('year', viewDate);
    }
  })), /*#__PURE__*/react["createElement"](QuarterPanel_QuarterBody, extends_extends({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      _onSelect(date, 'mouse');
    }
  })));
}

/* harmony default export */ var panels_QuarterPanel = (QuarterPanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/YearPanel/YearHeader.js






function YearHeader(props) {
  var prefixCls = props.prefixCls,
      generateConfig = props.generateConfig,
      viewDate = props.viewDate,
      onPrevDecade = props.onPrevDecade,
      onNextDecade = props.onNextDecade,
      onDecadeClick = props.onDecadeClick;

  var _React$useContext = react["useContext"](es_PanelContext),
      hideHeader = _React$useContext.hideHeader;

  if (hideHeader) {
    return null;
  }

  var headerPrefixCls = "".concat(prefixCls, "-header");
  var yearNumber = generateConfig.getYear(viewDate);
  var startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
  var endYear = startYear + YEAR_DECADE_COUNT - 1;
  return /*#__PURE__*/react["createElement"](panels_Header, extends_extends({}, props, {
    prefixCls: headerPrefixCls,
    onSuperPrev: onPrevDecade,
    onSuperNext: onNextDecade
  }), /*#__PURE__*/react["createElement"]("button", {
    type: "button",
    onClick: onDecadeClick,
    className: "".concat(prefixCls, "-decade-btn")
  }, startYear, "-", endYear));
}

/* harmony default export */ var YearPanel_YearHeader = (YearHeader);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/YearPanel/YearBody.js







var YEAR_COL_COUNT = 3;
var YEAR_ROW_COUNT = 4;

function YearBody(props) {
  var prefixCls = props.prefixCls,
      value = props.value,
      viewDate = props.viewDate,
      locale = props.locale,
      generateConfig = props.generateConfig;

  var _React$useContext = react["useContext"](es_RangeContext),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var yearPrefixCls = "".concat(prefixCls, "-cell"); // =============================== Year ===============================

  var yearNumber = generateConfig.getYear(viewDate);
  var startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
  var endYear = startYear + YEAR_DECADE_COUNT - 1;
  var baseYear = generateConfig.setYear(viewDate, startYear - Math.ceil((YEAR_COL_COUNT * YEAR_ROW_COUNT - YEAR_DECADE_COUNT) / 2));

  var isInView = function isInView(date) {
    var currentYearNumber = generateConfig.getYear(date);
    return startYear <= currentYearNumber && currentYearNumber <= endYear;
  };

  var getCellClassName = useCellClassName({
    cellPrefixCls: yearPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameYear(generateConfig, current, target);
    },
    isInView: isInView,
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addYear(date, offset);
    }
  });
  return /*#__PURE__*/react["createElement"](PanelBody, extends_extends({}, props, {
    rowNum: YEAR_ROW_COUNT,
    colNum: YEAR_COL_COUNT,
    baseDate: baseYear,
    getCellText: generateConfig.getYear,
    getCellClassName: getCellClassName,
    getCellDate: generateConfig.addYear,
    titleCell: function titleCell(date) {
      return formatValue(date, {
        locale: locale,
        format: 'YYYY',
        generateConfig: generateConfig
      });
    }
  }));
}

/* harmony default export */ var YearPanel_YearBody = (YearBody);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/panels/YearPanel/index.js





var YEAR_DECADE_COUNT = 10;

function YearPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      sourceMode = props.sourceMode,
      _onSelect = props.onSelect,
      onPanelChange = props.onPanelChange;
  var panelPrefixCls = "".concat(prefixCls, "-year-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff * YEAR_DECADE_COUNT), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff * YEAR_COL_COUNT), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange(sourceMode === 'date' ? 'date' : 'month', value || viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onDecadeChange = function onDecadeChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff * 10);
    onViewDateChange(newDate);
    onPanelChange(null, newDate);
  };

  return /*#__PURE__*/react["createElement"]("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/react["createElement"](YearPanel_YearHeader, extends_extends({}, props, {
    prefixCls: prefixCls,
    onPrevDecade: function onPrevDecade() {
      onDecadeChange(-1);
    },
    onNextDecade: function onNextDecade() {
      onDecadeChange(1);
    },
    onDecadeClick: function onDecadeClick() {
      onPanelChange('decade', viewDate);
    }
  })), /*#__PURE__*/react["createElement"](YearPanel_YearBody, extends_extends({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      onPanelChange(sourceMode === 'date' ? 'date' : 'month', date);

      _onSelect(date, 'mouse');
    }
  })));
}

/* harmony default export */ var panels_YearPanel = (YearPanel);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/getExtraFooter.js

function getExtraFooter(prefixCls, mode, renderExtraFooter) {
  if (!renderExtraFooter) {
    return null;
  }

  return /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-footer-extra")
  }, renderExtraFooter(mode));
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/utils/getRanges.js

function getRanges(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$rangeList = _ref.rangeList,
      rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? {} : _ref$components,
      needConfirmButton = _ref.needConfirmButton,
      onNow = _ref.onNow,
      onOk = _ref.onOk,
      okDisabled = _ref.okDisabled,
      showNow = _ref.showNow,
      locale = _ref.locale;
  var presetNode;
  var okNode;

  if (rangeList.length) {
    var Item = components.rangeItem || 'span';
    presetNode = /*#__PURE__*/react["createElement"](react["Fragment"], null, rangeList.map(function (_ref2) {
      var label = _ref2.label,
          onClick = _ref2.onClick,
          onMouseEnter = _ref2.onMouseEnter,
          onMouseLeave = _ref2.onMouseLeave;
      return /*#__PURE__*/react["createElement"]("li", {
        key: label,
        className: "".concat(prefixCls, "-preset")
      }, /*#__PURE__*/react["createElement"](Item, {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, label));
    }));
  }

  if (needConfirmButton) {
    var Button = components.button || 'button';

    if (onNow && !presetNode && showNow !== false) {
      presetNode = /*#__PURE__*/react["createElement"]("li", {
        className: "".concat(prefixCls, "-now")
      }, /*#__PURE__*/react["createElement"]("a", {
        className: "".concat(prefixCls, "-now-btn"),
        onClick: onNow
      }, locale.now));
    }

    okNode = needConfirmButton && /*#__PURE__*/react["createElement"]("li", {
      className: "".concat(prefixCls, "-ok")
    }, /*#__PURE__*/react["createElement"](Button, {
      disabled: okDisabled,
      onClick: onOk
    }, locale.ok));
  }

  if (!presetNode && !okNode) {
    return null;
  }

  return /*#__PURE__*/react["createElement"]("ul", {
    className: "".concat(prefixCls, "-ranges")
  }, presetNode, okNode);
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerPanel.js






/**
 * Logic:
 *  When `mode` === `picker`,
 *  click will trigger `onSelect` (if value changed trigger `onChange` also).
 *  Panel change will not trigger `onSelect` but trigger `onPanelChange`
 */





















function PickerPanel(props) {
  var _classNames;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
      className = props.className,
      style = props.style,
      locale = props.locale,
      generateConfig = props.generateConfig,
      value = props.value,
      defaultValue = props.defaultValue,
      pickerValue = props.pickerValue,
      defaultPickerValue = props.defaultPickerValue,
      disabledDate = props.disabledDate,
      mode = props.mode,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      showNow = props.showNow,
      showTime = props.showTime,
      showToday = props.showToday,
      renderExtraFooter = props.renderExtraFooter,
      hideHeader = props.hideHeader,
      onSelect = props.onSelect,
      onChange = props.onChange,
      onPanelChange = props.onPanelChange,
      onMouseDown = props.onMouseDown,
      onPickerValueChange = props.onPickerValueChange,
      _onOk = props.onOk,
      components = props.components,
      direction = props.direction,
      _props$hourStep = props.hourStep,
      hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep,
      _props$minuteStep = props.minuteStep,
      minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep,
      _props$secondStep = props.secondStep,
      secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep;
  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
  var isHourStepValid = 24 % hourStep === 0;
  var isMinuteStepValid = 60 % minuteStep === 0;
  var isSecondStepValid = 60 % secondStep === 0;

  if (false) {} // ============================ State =============================


  var panelContext = react["useContext"](es_PanelContext);
  var operationRef = panelContext.operationRef,
      panelDivRef = panelContext.panelRef,
      onContextSelect = panelContext.onSelect,
      hideRanges = panelContext.hideRanges,
      defaultOpenValue = panelContext.defaultOpenValue;

  var _React$useContext = react["useContext"](es_RangeContext),
      inRange = _React$useContext.inRange,
      panelPosition = _React$useContext.panelPosition,
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var panelRef = react["useRef"]({}); // Handle init logic

  var initRef = react["useRef"](true); // Value

  var _useMergedState = useMergedState(null, {
    value: value,
    defaultValue: defaultValue,
    postState: function postState(val) {
      if (!val && defaultOpenValue && picker === 'time') {
        return defaultOpenValue;
      }

      return val;
    }
  }),
      _useMergedState2 = slicedToArray_slicedToArray(_useMergedState, 2),
      mergedValue = _useMergedState2[0],
      setInnerValue = _useMergedState2[1]; // View date control


  var _useMergedState3 = useMergedState(null, {
    value: pickerValue,
    defaultValue: defaultPickerValue || mergedValue,
    postState: function postState(date) {
      var now = generateConfig.getNow();
      if (!date) return now; // When value is null and set showTime

      if (!mergedValue && showTime) {
        if (typeof_typeof(showTime) === 'object') {
          return setDateTime(generateConfig, date, showTime.defaultValue || now);
        }

        if (defaultValue) {
          return setDateTime(generateConfig, date, defaultValue);
        }

        return setDateTime(generateConfig, date, now);
      }

      return date;
    }
  }),
      _useMergedState4 = slicedToArray_slicedToArray(_useMergedState3, 2),
      viewDate = _useMergedState4[0],
      setInnerViewDate = _useMergedState4[1];

  var setViewDate = function setViewDate(date) {
    setInnerViewDate(date);

    if (onPickerValueChange) {
      onPickerValueChange(date);
    }
  }; // Panel control


  var getInternalNextMode = function getInternalNextMode(nextMode) {
    var getNextMode = PickerModeMap[picker];

    if (getNextMode) {
      return getNextMode(nextMode);
    }

    return nextMode;
  }; // Save panel is changed from which panel


  var _useMergedState5 = useMergedState(function () {
    if (picker === 'time') {
      return 'time';
    }

    return getInternalNextMode('date');
  }, {
    value: mode
  }),
      _useMergedState6 = slicedToArray_slicedToArray(_useMergedState5, 2),
      mergedMode = _useMergedState6[0],
      setInnerMode = _useMergedState6[1];

  react["useEffect"](function () {
    setInnerMode(picker);
  }, [picker]);

  var _React$useState = react["useState"](function () {
    return mergedMode;
  }),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      sourceMode = _React$useState2[0],
      setSourceMode = _React$useState2[1];

  var onInternalPanelChange = function onInternalPanelChange(newMode, viewValue) {
    var nextMode = getInternalNextMode(newMode || mergedMode);
    setSourceMode(mergedMode);
    setInnerMode(nextMode);

    if (onPanelChange && (mergedMode !== nextMode || isEqual(generateConfig, viewDate, viewDate))) {
      onPanelChange(viewValue, nextMode);
    }
  };

  var triggerSelect = function triggerSelect(date, type) {
    var forceTriggerSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (mergedMode === picker || forceTriggerSelect) {
      setInnerValue(date);

      if (onSelect) {
        onSelect(date);
      }

      if (onContextSelect) {
        onContextSelect(date, type);
      }

      if (onChange && !isEqual(generateConfig, date, mergedValue) && !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date))) {
        onChange(date);
      }
    }
  }; // ========================= Interactive ==========================


  var onInternalKeyDown = function onInternalKeyDown(e) {
    if (panelRef.current && panelRef.current.onKeyDown) {
      if ([es_KeyCode.LEFT, es_KeyCode.RIGHT, es_KeyCode.UP, es_KeyCode.DOWN, es_KeyCode.PAGE_UP, es_KeyCode.PAGE_DOWN, es_KeyCode.ENTER].includes(e.which)) {
        e.preventDefault();
      }

      return panelRef.current.onKeyDown(e);
    }
    /* istanbul ignore next */

    /* eslint-disable no-lone-blocks */


    {
      es_warning(false, 'Panel not correct handle keyDown event. Please help to fire issue about this.');
      return false;
    }
    /* eslint-enable no-lone-blocks */
  };

  var onInternalBlur = function onInternalBlur(e) {
    if (panelRef.current && panelRef.current.onBlur) {
      panelRef.current.onBlur(e);
    }
  };

  if (operationRef && panelPosition !== 'right') {
    operationRef.current = {
      onKeyDown: onInternalKeyDown,
      onClose: function onClose() {
        if (panelRef.current && panelRef.current.onClose) {
          panelRef.current.onClose();
        }
      }
    };
  } // ============================ Effect ============================


  react["useEffect"](function () {
    if (value && !initRef.current) {
      setInnerViewDate(value);
    }
  }, [value]);
  react["useEffect"](function () {
    initRef.current = false;
  }, []); // ============================ Panels ============================

  var panelNode;

  var pickerProps = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
    operationRef: panelRef,
    prefixCls: prefixCls,
    viewDate: viewDate,
    value: mergedValue,
    onViewDateChange: setViewDate,
    sourceMode: sourceMode,
    onPanelChange: onInternalPanelChange,
    disabledDate: disabledDate
  });

  delete pickerProps.onChange;
  delete pickerProps.onSelect;

  switch (mergedMode) {
    case 'decade':
      panelNode = /*#__PURE__*/react["createElement"](panels_DecadePanel, extends_extends({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'year':
      panelNode = /*#__PURE__*/react["createElement"](panels_YearPanel, extends_extends({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'month':
      panelNode = /*#__PURE__*/react["createElement"](panels_MonthPanel, extends_extends({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'quarter':
      panelNode = /*#__PURE__*/react["createElement"](panels_QuarterPanel, extends_extends({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'week':
      panelNode = /*#__PURE__*/react["createElement"](panels_WeekPanel, extends_extends({}, pickerProps, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    case 'time':
      delete pickerProps.showTime;
      panelNode = /*#__PURE__*/react["createElement"](panels_TimePanel, extends_extends({}, pickerProps, typeof_typeof(showTime) === 'object' ? showTime : null, {
        onSelect: function onSelect(date, type) {
          setViewDate(date);
          triggerSelect(date, type);
        }
      }));
      break;

    default:
      if (showTime) {
        panelNode = /*#__PURE__*/react["createElement"](panels_DatetimePanel, extends_extends({}, pickerProps, {
          onSelect: function onSelect(date, type) {
            setViewDate(date);
            triggerSelect(date, type);
          }
        }));
      } else {
        panelNode = /*#__PURE__*/react["createElement"](panels_DatePanel, extends_extends({}, pickerProps, {
          onSelect: function onSelect(date, type) {
            setViewDate(date);
            triggerSelect(date, type);
          }
        }));
      }

  } // ============================ Footer ============================


  var extraFooter;
  var rangesNode;

  var onNow = function onNow() {
    var now = generateConfig.getNow();
    var lowerBoundTime = getLowerBoundTime(generateConfig.getHour(now), generateConfig.getMinute(now), generateConfig.getSecond(now), isHourStepValid ? hourStep : 1, isMinuteStepValid ? minuteStep : 1, isSecondStepValid ? secondStep : 1);
    var adjustedNow = timeUtil_setTime(generateConfig, now, lowerBoundTime[0], // hour
    lowerBoundTime[1], // minute
    lowerBoundTime[2]);
    triggerSelect(adjustedNow, 'submit');
  };

  if (!hideRanges) {
    extraFooter = getExtraFooter(prefixCls, mergedMode, renderExtraFooter);
    rangesNode = getRanges({
      prefixCls: prefixCls,
      components: components,
      needConfirmButton: needConfirmButton,
      okDisabled: !mergedValue || disabledDate && disabledDate(mergedValue),
      locale: locale,
      showNow: showNow,
      onNow: needConfirmButton && onNow,
      onOk: function onOk() {
        if (mergedValue) {
          triggerSelect(mergedValue, 'submit', true);

          if (_onOk) {
            _onOk(mergedValue);
          }
        }
      }
    });
  }

  var todayNode;

  if (showToday && mergedMode === 'date' && picker === 'date' && !showTime) {
    var now = generateConfig.getNow();
    var todayCls = "".concat(prefixCls, "-today-btn");
    var disabled = disabledDate && disabledDate(now);
    todayNode = /*#__PURE__*/react["createElement"]("a", {
      className: node_modules_classnames_default()(todayCls, disabled && "".concat(todayCls, "-disabled")),
      "aria-disabled": disabled,
      onClick: function onClick() {
        if (!disabled) {
          triggerSelect(now, 'mouse', true);
        }
      }
    }, locale.today);
  }

  return /*#__PURE__*/react["createElement"](es_PanelContext.Provider, {
    value: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, panelContext), {}, {
      mode: mergedMode,
      hideHeader: 'hideHeader' in props ? hideHeader : panelContext.hideHeader,
      hidePrevBtn: inRange && panelPosition === 'right',
      hideNextBtn: inRange && panelPosition === 'left'
    })
  }, /*#__PURE__*/react["createElement"]("div", {
    tabIndex: tabIndex,
    className: node_modules_classnames_default()("".concat(prefixCls, "-panel"), className, (_classNames = {}, defineProperty_defineProperty(_classNames, "".concat(prefixCls, "-panel-has-range"), rangedValue && rangedValue[0] && rangedValue[1]), defineProperty_defineProperty(_classNames, "".concat(prefixCls, "-panel-has-range-hover"), hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1]), defineProperty_defineProperty(_classNames, "".concat(prefixCls, "-panel-rtl"), direction === 'rtl'), _classNames)),
    style: style,
    onKeyDown: onInternalKeyDown,
    onBlur: onInternalBlur,
    onMouseDown: onMouseDown,
    ref: panelDivRef
  }, panelNode, extraFooter || rangesNode || todayNode ? /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-footer")
  }, extraFooter, rangesNode, todayNode) : null));
}

/* harmony default export */ var es_PickerPanel = (PickerPanel);
/* eslint-enable */
// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/contains.js
function contains(root, n) {
  if (!root) {
    return false;
  }
  // Use native if support
  if (root.contains) {
    return root.contains(n);
  }
  // `document.contains` not support with IE11
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/findDOMNode.js

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }
  return react_dom_default.a.findDOMNode(node);
}
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__("4cec");

// CONCATENATED MODULE: ./node_modules/rc-util/es/ref.js



function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (typeof_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function (ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useMemo(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length === next.length && prev.every(function (ref, i) {
      return ref === next[i];
    });
  });
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  var type = Object(react_is["isMemo"])(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  // Function component node
  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  }
  // Class component
  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }
  return true;
}
/* eslint-enable */
// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = react_dom_default.a.unstable_batchedUpdates ? function run(e) {
    react_dom_default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }
  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback, option);
      }
    }
  };
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/Portal.js



var Portal = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var didUpdate = props.didUpdate,
    getContainer = props.getContainer,
    children = props.children;
  var parentRef = Object(react["useRef"])();
  var containerRef = Object(react["useRef"])();
  // Ref return nothing, only for wrapper check exist
  Object(react["useImperativeHandle"])(ref, function () {
    return {};
  });
  // Create container in client side with sync to avoid useEffect not get ref
  var initRef = Object(react["useRef"])(false);
  if (!initRef.current && canUseDom()) {
    containerRef.current = getContainer();
    parentRef.current = containerRef.current.parentNode;
    initRef.current = true;
  }
  // [Legacy] Used by `rc-trigger`
  Object(react["useEffect"])(function () {
    didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props);
  });
  Object(react["useEffect"])(function () {
    // Restore container to original place
    // React 18 StrictMode will unmount first and mount back for effect test:
    // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
    if (containerRef.current.parentNode === null && parentRef.current !== null) {
      parentRef.current.appendChild(containerRef.current);
    }
    return function () {
      var _containerRef$current, _containerRef$current2;
      // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
      // Since some component use `Portal` directly, we have to keep the logic here.
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? /*#__PURE__*/react_dom_default.a.createPortal(children, containerRef.current) : null;
});
/* harmony default export */ var es_Portal = (Portal);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/utils/alignUtil.js


function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }

  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);

  for (var i = 0; i < placements.length; i += 1) {
    var placement = placements[i];

    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }

  return '';
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function objectWithoutProperties_objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/isMobile.js
/* harmony default export */ var isMobile = (function () {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
});
// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/motion.js

 // ================= Transition =================
// Event wrapper. Copy from react source code

function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== 'undefined' ? window : {});
var motion_style = {};

if (canUseDom()) {
  var _document$createEleme = document.createElement('div');

  motion_style = _document$createEleme.style;
}

var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;

    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];

      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in motion_style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof_typeof(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return "".concat(transitionName, "-").concat(transitionType);
}
// CONCATENATED MODULE: ./node_modules/rc-motion/es/interface.js
var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';
// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useNextFrame.js


/* harmony default export */ var useNextFrame = (function () {
  var nextFrameRef = react["useRef"](null);

  function cancelNextFrame() {
    es_raf.cancel(nextFrameRef.current);
  }

  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = es_raf(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }

  react["useEffect"](function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});
// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js

 // It's safe to use `useLayoutEffect` but the warning is annoying

var useIsomorphicLayoutEffect = canUseDom() ? react["useLayoutEffect"] : react["useEffect"];
/* harmony default export */ var hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);
// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStepQueue.js






var STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
/** Skip current step */

var SkipStep = false;
/** Current step should be update in */

var DoStep = true;
function useStepQueue_isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
/* harmony default export */ var useStepQueue = (function (status, callback) {
  var _useState = useSafeState(STEP_NONE),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useNextFrame = useNextFrame(),
      _useNextFrame2 = slicedToArray_slicedToArray(_useNextFrame, 2),
      nextFrame = _useNextFrame2[0],
      cancelNextFrame = _useNextFrame2[1];

  function startQueue() {
    setStep(STEP_PREPARE, true);
  }

  hooks_useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);

      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep, true);
      } else {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep, true);
          }

          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  react["useEffect"](function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});
// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useDomMotionEvents.js



/* harmony default export */ var useDomMotionEvents = (function (callback) {
  var cacheElementRef = Object(react["useRef"])(); // Cache callback

  var callbackRef = Object(react["useRef"])(callback);
  callbackRef.current = callback; // Internal motion event handler

  var onInternalMotionEnd = react["useCallback"](function (event) {
    callbackRef.current(event);
  }, []); // Remove events

  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  } // Patch events


  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }

    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd); // Save as cache in case dom removed trigger by `motionDeadline`

      cacheElementRef.current = element;
    }
  } // Clean up when removed


  react["useEffect"](function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});
// CONCATENATED MODULE: ./node_modules/rc-motion/es/hooks/useStatus.js










function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
      motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
      _ref$motionAppear = _ref.motionAppear,
      motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
      _ref$motionLeave = _ref.motionLeave,
      motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
      motionDeadline = _ref.motionDeadline,
      motionLeaveImmediately = _ref.motionLeaveImmediately,
      onAppearPrepare = _ref.onAppearPrepare,
      onEnterPrepare = _ref.onEnterPrepare,
      onLeavePrepare = _ref.onLeavePrepare,
      onAppearStart = _ref.onAppearStart,
      onEnterStart = _ref.onEnterStart,
      onLeaveStart = _ref.onLeaveStart,
      onAppearActive = _ref.onAppearActive,
      onEnterActive = _ref.onEnterActive,
      onLeaveActive = _ref.onLeaveActive,
      onAppearEnd = _ref.onAppearEnd,
      onEnterEnd = _ref.onEnterEnd,
      onLeaveEnd = _ref.onLeaveEnd,
      onVisibleChanged = _ref.onVisibleChanged;

  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = useSafeState(),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      asyncVisible = _useState2[0],
      setAsyncVisible = _useState2[1];

  var _useState3 = useSafeState(STATUS_NONE),
      _useState4 = slicedToArray_slicedToArray(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var _useState5 = useSafeState(null),
      _useState6 = slicedToArray_slicedToArray(_useState5, 2),
      style = _useState6[0],
      setStyle = _useState6[1];

  var mountedRef = Object(react["useRef"])(false);
  var deadlineRef = Object(react["useRef"])(null); // =========================== Dom Node ===========================

  function getDomElement() {
    return getElement();
  } // ========================== Motion End ==========================


  var activeRef = Object(react["useRef"])(false);

  function onInternalMotionEnd(event) {
    var element = getDomElement();

    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }

    var currentActive = activeRef.current;
    var canEnd;

    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    } // Only update status when `canEnd` and not destroyed


    if (status !== STATUS_NONE && currentActive && canEnd !== false) {
      setStatus(STATUS_NONE, true);
      setStyle(null, true);
    }
  }

  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
      _useDomMotionEvents2 = slicedToArray_slicedToArray(_useDomMotionEvents, 1),
      patchMotionEvents = _useDomMotionEvents2[0]; // ============================= Step =============================


  var eventHandlers = react["useMemo"](function () {
    var _ref2, _ref3, _ref4;

    switch (status) {
      case STATUS_APPEAR:
        return _ref2 = {}, defineProperty_defineProperty(_ref2, STEP_PREPARE, onAppearPrepare), defineProperty_defineProperty(_ref2, STEP_START, onAppearStart), defineProperty_defineProperty(_ref2, STEP_ACTIVE, onAppearActive), _ref2;

      case STATUS_ENTER:
        return _ref3 = {}, defineProperty_defineProperty(_ref3, STEP_PREPARE, onEnterPrepare), defineProperty_defineProperty(_ref3, STEP_START, onEnterStart), defineProperty_defineProperty(_ref3, STEP_ACTIVE, onEnterActive), _ref3;

      case STATUS_LEAVE:
        return _ref4 = {}, defineProperty_defineProperty(_ref4, STEP_PREPARE, onLeavePrepare), defineProperty_defineProperty(_ref4, STEP_START, onLeaveStart), defineProperty_defineProperty(_ref4, STEP_ACTIVE, onLeaveActive), _ref4;

      default:
        return {};
    }
  }, [status]);

  var _useStepQueue = useStepQueue(status, function (newStep) {
    // Only prepare step can be skip
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];

      if (!onPrepare) {
        return SkipStep;
      }

      return onPrepare(getDomElement());
    } // Rest step is sync update


    // Rest step is sync update
    if (step in eventHandlers) {
      var _eventHandlers$step;

      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }

    if (step === STEP_ACTIVE) {
      // Patch events when motion needed
      patchMotionEvents(getDomElement());

      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function () {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }

    return DoStep;
  }),
      _useStepQueue2 = slicedToArray_slicedToArray(_useStepQueue, 2),
      startStep = _useStepQueue2[0],
      step = _useStepQueue2[1];

  var active = useStepQueue_isActive(step);
  activeRef.current = active; // ============================ Status ============================
  // Update with new status

  hooks_useIsomorphicLayoutEffect(function () {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    if (!supportMotion) {
      return;
    }

    var nextStatus; // Appear

    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    } // Enter


    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    } // Leave


    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    } // Update to next status


    if (nextStatus) {
      setStatus(nextStatus);
      startStep();
    }
  }, [visible]); // ============================ Effect ============================
  // Reset when motion changed

  Object(react["useEffect"])(function () {
    if ( // Cancel appear
    status === STATUS_APPEAR && !motionAppear || // Cancel enter
    status === STATUS_ENTER && !motionEnter || // Cancel leave
    status === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  Object(react["useEffect"])(function () {
    return function () {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []); // Trigger `onVisibleChanged`

  var firstMountChangeRef = react["useRef"](false);
  Object(react["useEffect"])(function () {
    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }

    if (asyncVisible !== undefined && status === STATUS_NONE) {
      // Skip first render is invisible since it's nothing changed
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
      }

      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, status]); // ============================ Styles ============================

  var mergedStyle = style;

  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = objectSpread2_objectSpread2({
      transition: 'none'
    }, mergedStyle);
  }

  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
// CONCATENATED MODULE: ./node_modules/rc-motion/es/DomWrapper.js






var DomWrapper_DomWrapper = /*#__PURE__*/function (_React$Component) {
  inherits_inherits(DomWrapper, _React$Component);

  var _super = createSuper_createSuper(DomWrapper);

  function DomWrapper() {
    classCallCheck_classCallCheck(this, DomWrapper);

    return _super.apply(this, arguments);
  }

  createClass_createClass(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return DomWrapper;
}(react["Component"]);

/* harmony default export */ var es_DomWrapper = (DomWrapper_DomWrapper);
// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotion.js





/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */










/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */

function genCSSMotion(config) {
  var transitionSupport = config;

  if (typeof_typeof(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = /*#__PURE__*/react["forwardRef"](function (props, ref) {
    var _props$visible = props.visible,
        visible = _props$visible === void 0 ? true : _props$visible,
        _props$removeOnLeave = props.removeOnLeave,
        removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
        forceRender = props.forceRender,
        children = props.children,
        motionName = props.motionName,
        leavedClassName = props.leavedClassName,
        eventProps = props.eventProps;
    var supportMotion = isSupportTransition(props); // Ref to the react node, it may be a HTMLElement

    var nodeRef = Object(react["useRef"])(); // Ref to the dom wrapper in case ref can not pass to HTMLElement

    var wrapperNodeRef = Object(react["useRef"])();

    function getDomElement() {
      try {
        // Here we're avoiding call for findDOMNode since it's deprecated
        // in strict mode. We're calling it only when node ref is not
        // an instance of DOM HTMLElement. Otherwise use
        // findDOMNode as a final resort
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }

    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
        _useStatus2 = slicedToArray_slicedToArray(_useStatus, 4),
        status = _useStatus2[0],
        statusStep = _useStatus2[1],
        statusStyle = _useStatus2[2],
        mergedVisible = _useStatus2[3]; // Record whether content has rendered
    // Will return null for un-rendered even when `removeOnLeave={false}`


    var renderedRef = react["useRef"](mergedVisible);

    if (mergedVisible) {
      renderedRef.current = true;
    } // ====================== Refs ======================


    var setNodeRef = react["useCallback"](function (node) {
      nodeRef.current = node;
      fillRef(ref, node);
    }, [ref]); // ===================== Render =====================

    var motionChildren;

    var mergedProps = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, eventProps), {}, {
      visible: visible
    });

    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE || !isSupportTransition(props)) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children(objectSpread2_objectSpread2({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current) {
        motionChildren = children(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender) {
        motionChildren = children(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var _classNames;

      // In motion
      var statusSuffix;

      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (useStepQueue_isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }

      motionChildren = children(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, mergedProps), {}, {
        className: node_modules_classnames_default()(getTransitionName(motionName, status), (_classNames = {}, defineProperty_defineProperty(_classNames, getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), defineProperty_defineProperty(_classNames, motionName, typeof motionName === 'string'), _classNames)),
        style: statusStyle
      }), setNodeRef);
    } // Auto inject ref if child node not have `ref` props


    if ( /*#__PURE__*/react["isValidElement"](motionChildren) && supportRef(motionChildren)) {
      var _motionChildren = motionChildren,
          originNodeRef = _motionChildren.ref;

      if (!originNodeRef) {
        motionChildren = /*#__PURE__*/react["cloneElement"](motionChildren, {
          ref: setNodeRef
        });
      }
    }

    return /*#__PURE__*/react["createElement"](es_DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
/* harmony default export */ var es_CSSMotion = (genCSSMotion(supportTransition));
// CONCATENATED MODULE: ./node_modules/rc-motion/es/util/diff.js


var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;

  if (key && typeof_typeof(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }

  return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys); // Check prev keys to insert or keep

  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;

    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];

      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }

        list.push(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    } // If not hit, it means key is removed


    if (!hit) {
      list.push(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  }); // Add rest to the list

  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */


  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
          status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    }); // Update `STATUS_ADD` to `STATUS_KEEP`

    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}
// CONCATENATED MODULE: ./node_modules/rc-motion/es/CSSMotionList.js







var _excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
    _excluded2 = ["status"];

/* eslint react/prop-types: 0 */




var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */

function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : es_CSSMotion;

  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    inherits_inherits(CSSMotionList, _React$Component);

    var _super = createSuper_createSuper(CSSMotionList);

    function CSSMotionList() {
      var _this;

      classCallCheck_classCallCheck(this, CSSMotionList);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        keyEntities: []
      };

      _this.removeKey = function (removeKey) {
        var keyEntities = _this.state.keyEntities;
        var nextKeyEntities = keyEntities.map(function (entity) {
          if (entity.key !== removeKey) return entity;
          return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, entity), {}, {
            status: STATUS_REMOVED
          });
        });

        _this.setState({
          keyEntities: nextKeyEntities
        });

        return nextKeyEntities.filter(function (_ref) {
          var status = _ref.status;
          return status !== STATUS_REMOVED;
        }).length;
      };

      return _this;
    }

    createClass_createClass(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var keyEntities = this.state.keyEntities;

        var _this$props = this.props,
            component = _this$props.component,
            children = _this$props.children,
            _onVisibleChanged = _this$props.onVisibleChanged,
            onAllRemoved = _this$props.onAllRemoved,
            restProps = objectWithoutProperties_objectWithoutProperties(_this$props, _excluded);

        var Component = component || react["Fragment"];
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /*#__PURE__*/react["createElement"](Component, restProps, keyEntities.map(function (_ref2) {
          var status = _ref2.status,
              eventProps = objectWithoutProperties_objectWithoutProperties(_ref2, _excluded2);

          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /*#__PURE__*/react["createElement"](CSSMotion, extends_extends({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 ? void 0 : _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });

              if (!changedVisible) {
                var restKeysCount = _this2.removeKey(eventProps.key);

                if (restKeysCount === 0 && onAllRemoved) {
                  onAllRemoved();
                }
              }
            }
          }), children);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            var prevEntity = keyEntities.find(function (_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            }); // Remove if already mark as removed

            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }

            return true;
          })
        };
      } // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.

    }]);

    return CSSMotionList;
  }(react["Component"]);

  CSSMotionList.defaultProps = {
    component: 'div'
  };
  return CSSMotionList;
}
/* harmony default export */ var es_CSSMotionList = (genCSSMotionList(supportTransition));
// CONCATENATED MODULE: ./node_modules/rc-motion/es/index.js



/* harmony default export */ var es = (es_CSSMotion);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/utils/legacyUtil.js
function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      animation = _ref.animation,
      transitionName = _ref.transitionName;

  if (motion) {
    return motion;
  }

  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }

  if (transitionName) {
    return {
      motionName: transitionName
    };
  }

  return null;
}
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup/Mask.js






function Mask(props) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      zIndex = props.zIndex,
      mask = props.mask,
      maskMotion = props.maskMotion,
      maskAnimation = props.maskAnimation,
      maskTransitionName = props.maskTransitionName;

  if (!mask) {
    return null;
  }

  var motion = {};

  if (maskMotion || maskTransitionName || maskAnimation) {
    motion = objectSpread2_objectSpread2({
      motionAppear: true
    }, getMotion({
      motion: maskMotion,
      prefixCls: prefixCls,
      transitionName: maskTransitionName,
      animation: maskAnimation
    }));
  }

  return /*#__PURE__*/react["createElement"](es, extends_extends({}, motion, {
    visible: visible,
    removeOnLeave: true
  }), function (_ref) {
    var className = _ref.className;
    return /*#__PURE__*/react["createElement"]("div", {
      style: {
        zIndex: zIndex
      },
      className: node_modules_classnames_default()("".concat(prefixCls, "-mask"), className)
    });
  });
}
// CONCATENATED MODULE: ./node_modules/dom-align/dist-web/index.js
function dist_web_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function dist_web_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      dist_web_ownKeys(Object(source), true).forEach(function (key) {
        dist_web_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      dist_web_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function dist_web_typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    dist_web_typeof = function (obj) {
      return typeof obj;
    };
  } else {
    dist_web_typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return dist_web_typeof(obj);
}

function dist_web_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function dist_web_getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = dist_web_getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[dist_web_getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (dist_web_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top); // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function dist_web_getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = dist_web_getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: dist_web_getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function dist_web_alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, dist_web_objectSpread2(dist_web_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* harmony default export */ var dist_web = (alignElement);

//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/rc-align/node_modules/lodash/isEqual.js
var lodash_isEqual = __webpack_require__("3f02");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual);

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("6dd8");

// CONCATENATED MODULE: ./node_modules/rc-align/es/util.js



function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}
function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && contains(container, activeElement) && typeof activeElement.focus === 'function') {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;

  function onResize(_ref) {
    var _ref2 = slicedToArray_slicedToArray(_ref, 1),
        target = _ref2[0].target;

    if (!document.documentElement.contains(target)) return;

    var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);

    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      // https://webkit.org/blog/9997/resizeobserver-in-webkit/
      Promise.resolve().then(function () {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }

    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }

  var resizeObserver = new ResizeObserver_es["a" /* default */](onResize);

  if (element) {
    resizeObserver.observe(element);
  }

  return function () {
    resizeObserver.disconnect();
  };
}
// CONCATENATED MODULE: ./node_modules/rc-align/es/hooks/useBuffer.js

/* harmony default export */ var useBuffer = (function (callback, buffer) {
  var calledRef = react_default.a.useRef(false);
  var timeoutRef = react_default.a.useRef(null);

  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }

  function trigger(force) {
    cancelTrigger();

    if (!calledRef.current || force === true) {
      if (callback() === false) {
        // Not delay since callback cancelled self
        return;
      }

      calledRef.current = true;
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
      }, buffer);
    } else {
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
        trigger();
      }, buffer);
    }
  }

  return [trigger, function () {
    calledRef.current = false;
    cancelTrigger();
  }];
});
// CONCATENATED MODULE: ./node_modules/rc-align/es/Align.js



/**
 * Removed props:
 *  - childrenProps
 */









function Align_getElement(func) {
  if (typeof func !== 'function') return null;
  return func();
}

function getPoint(point) {
  if (typeof_typeof(point) !== 'object' || !point) return null;
  return point;
}

var Align_Align = function Align(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      target = _ref.target,
      align = _ref.align,
      onAlign = _ref.onAlign,
      monitorWindowResize = _ref.monitorWindowResize,
      _ref$monitorBufferTim = _ref.monitorBufferTime,
      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = react_default.a.useRef({});
  var nodeRef = react_default.a.useRef();
  var childNode = react_default.a.Children.only(children); // ===================== Align ======================
  // We save the props here to avoid closure makes props ood

  var forceAlignPropsRef = react_default.a.useRef({});
  forceAlignPropsRef.current.disabled = disabled;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.align = align;
  forceAlignPropsRef.current.onAlign = onAlign;

  var _useBuffer = useBuffer(function () {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
        latestDisabled = _forceAlignPropsRef$c.disabled,
        latestTarget = _forceAlignPropsRef$c.target,
        latestAlign = _forceAlignPropsRef$c.align,
        latestOnAlign = _forceAlignPropsRef$c.onAlign;

    if (!latestDisabled && latestTarget) {
      var source = nodeRef.current;
      var result;
      var element = Align_getElement(latestTarget);
      var point = getPoint(latestTarget);
      cacheRef.current.element = element;
      cacheRef.current.point = point;
      cacheRef.current.align = latestAlign; // IE lose focus after element realign
      // We should record activeElement and restore later

      // IE lose focus after element realign
      // We should record activeElement and restore later
      var _document = document,
          activeElement = _document.activeElement; // We only align when element is visible

      // We only align when element is visible
      if (element && isVisible(element)) {
        result = alignElement(source, element, latestAlign);
      } else if (point) {
        result = dist_web_alignPoint(source, point, latestAlign);
      }

      restoreFocus(activeElement, source);

      if (latestOnAlign && result) {
        latestOnAlign(source, result);
      }

      return true;
    }

    return false;
  }, monitorBufferTime),
      _useBuffer2 = slicedToArray_slicedToArray(_useBuffer, 2),
      _forceAlign = _useBuffer2[0],
      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
  // Listen for target updated


  var resizeMonitor = react_default.a.useRef({
    cancel: function cancel() {}
  }); // Listen for source updated

  var sourceResizeMonitor = react_default.a.useRef({
    cancel: function cancel() {}
  });
  react_default.a.useEffect(function () {
    var element = Align_getElement(target);
    var point = getPoint(target);

    if (nodeRef.current !== sourceResizeMonitor.current.element) {
      sourceResizeMonitor.current.cancel();
      sourceResizeMonitor.current.element = nodeRef.current;
      sourceResizeMonitor.current.cancel = monitorResize(nodeRef.current, _forceAlign);
    }

    if (cacheRef.current.element !== element || !isSamePoint(cacheRef.current.point, point) || !isEqual_default()(cacheRef.current.align, align)) {
      _forceAlign(); // Add resize observer


      if (resizeMonitor.current.element !== element) {
        resizeMonitor.current.cancel();
        resizeMonitor.current.element = element;
        resizeMonitor.current.cancel = monitorResize(element, _forceAlign);
      }
    }
  }); // Listen for disabled change

  react_default.a.useEffect(function () {
    if (!disabled) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled]); // Listen for window resize

  var winResizeRef = react_default.a.useRef(null);
  react_default.a.useEffect(function () {
    if (monitorWindowResize) {
      if (!winResizeRef.current) {
        winResizeRef.current = addEventListenerWrap(window, 'resize', _forceAlign);
      }
    } else if (winResizeRef.current) {
      winResizeRef.current.remove();
      winResizeRef.current = null;
    }
  }, [monitorWindowResize]); // Clear all if unmount

  react_default.a.useEffect(function () {
    return function () {
      resizeMonitor.current.cancel();
      sourceResizeMonitor.current.cancel();
      if (winResizeRef.current) winResizeRef.current.remove();
      cancelForceAlign();
    };
  }, []); // ====================== Ref =======================

  react_default.a.useImperativeHandle(ref, function () {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  }); // ===================== Render =====================

  if ( /*#__PURE__*/react_default.a.isValidElement(childNode)) {
    childNode = /*#__PURE__*/react_default.a.cloneElement(childNode, {
      ref: composeRef(childNode.ref, nodeRef)
    });
  }

  return childNode;
};

var RcAlign = /*#__PURE__*/react_default.a.forwardRef(Align_Align);
RcAlign.displayName = 'Align';
/* harmony default export */ var es_Align = (RcAlign);
// CONCATENATED MODULE: ./node_modules/rc-align/es/index.js
// export this package's api

/* harmony default export */ var rc_align_es = (es_Align);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js

function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncToGenerator_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function asyncToGenerator_asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncToGenerator_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncToGenerator_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup/useVisibleStatus.js






/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */

var StatusQueue = ['measure', 'alignPre', 'align', null, 'motion'];
/* harmony default export */ var useVisibleStatus = (function (visible, doMeasure) {
  var _useState = useSafeState(null),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      status = _useState2[0],
      setInternalStatus = _useState2[1];

  var rafRef = Object(react["useRef"])();

  function setStatus(nextStatus) {
    setInternalStatus(nextStatus, true);
  }

  function cancelRaf() {
    es_raf.cancel(rafRef.current);
  }

  function goNextStatus(callback) {
    cancelRaf();
    rafRef.current = es_raf(function () {
      // Only align should be manually trigger
      setStatus(function (prev) {
        switch (status) {
          case 'align':
            return 'motion';

          case 'motion':
            return 'stable';

          default:
        }

        return prev;
      });
      callback === null || callback === void 0 ? void 0 : callback();
    });
  } // Init status


  Object(react["useEffect"])(function () {
    setStatus('measure');
  }, [visible]); // Go next status

  Object(react["useEffect"])(function () {
    switch (status) {
      case 'measure':
        doMeasure();
        break;

      default:
    }

    if (status) {
      rafRef.current = es_raf( /*#__PURE__*/asyncToGenerator_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index, nextStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = StatusQueue.indexOf(status);
                nextStatus = StatusQueue[index + 1];

                if (nextStatus && index !== -1) {
                  setStatus(nextStatus);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }, [status]);
  Object(react["useEffect"])(function () {
    return function () {
      cancelRaf();
    };
  }, []);
  return [status, goNextStatus];
});
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup/useStretchStyle.js


/* harmony default export */ var useStretchStyle = (function (stretch) {
  var _React$useState = react["useState"]({
    width: 0,
    height: 0
  }),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      targetSize = _React$useState2[0],
      setTargetSize = _React$useState2[1];

  function measureStretch(element) {
    var tgtWidth = element.offsetWidth,
        tgtHeight = element.offsetHeight;

    var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near


    if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
      tgtWidth = width;
      tgtHeight = height;
    }

    setTargetSize({
      width: tgtWidth,
      height: tgtHeight
    });
  } // Merge stretch style


  var style = react["useMemo"](function () {
    var sizeStyle = {};

    if (stretch) {
      var width = targetSize.width,
          height = targetSize.height; // Stretch with target

      if (stretch.indexOf('height') !== -1 && height) {
        sizeStyle.height = height;
      } else if (stretch.indexOf('minHeight') !== -1 && height) {
        sizeStyle.minHeight = height;
      }

      if (stretch.indexOf('width') !== -1 && width) {
        sizeStyle.width = width;
      } else if (stretch.indexOf('minWidth') !== -1 && width) {
        sizeStyle.minWidth = width;
      }
    }

    return sizeStyle;
  }, [stretch, targetSize]);
  return [style, measureStretch];
});
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup/PopupInner.js












var PopupInner = /*#__PURE__*/react["forwardRef"](function (props, ref) {
  var visible = props.visible,
      prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      children = props.children,
      zIndex = props.zIndex,
      stretch = props.stretch,
      destroyPopupOnHide = props.destroyPopupOnHide,
      forceRender = props.forceRender,
      align = props.align,
      point = props.point,
      getRootDomNode = props.getRootDomNode,
      getClassNameFromAlign = props.getClassNameFromAlign,
      onAlign = props.onAlign,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseDown = props.onMouseDown,
      onTouchStart = props.onTouchStart,
      onClick = props.onClick;
  var alignRef = Object(react["useRef"])();
  var elementRef = Object(react["useRef"])();

  var _useState = Object(react["useState"])(),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      alignedClassName = _useState2[0],
      setAlignedClassName = _useState2[1]; // ======================= Measure ========================


  var _useStretchStyle = useStretchStyle(stretch),
      _useStretchStyle2 = slicedToArray_slicedToArray(_useStretchStyle, 2),
      stretchStyle = _useStretchStyle2[0],
      measureStretchStyle = _useStretchStyle2[1];

  function doMeasure() {
    if (stretch) {
      measureStretchStyle(getRootDomNode());
    }
  } // ======================== Status ========================


  var _useVisibleStatus = useVisibleStatus(visible, doMeasure),
      _useVisibleStatus2 = slicedToArray_slicedToArray(_useVisibleStatus, 2),
      status = _useVisibleStatus2[0],
      goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================

  /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */


  var _useState3 = Object(react["useState"])(0),
      _useState4 = slicedToArray_slicedToArray(_useState3, 2),
      alignTimes = _useState4[0],
      setAlignTimes = _useState4[1];

  var prepareResolveRef = Object(react["useRef"])();
  hooks_useLayoutEffect(function () {
    if (status === 'alignPre') {
      setAlignTimes(0);
    }
  }, [status]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align

  function getAlignTarget() {
    if (point) {
      return point;
    }

    return getRootDomNode;
  }

  function forceAlign() {
    var _alignRef$current;

    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
  }

  function onInternalAlign(popupDomNode, matchAlign) {
    var nextAlignedClassName = getClassNameFromAlign(matchAlign);

    if (alignedClassName !== nextAlignedClassName) {
      setAlignedClassName(nextAlignedClassName);
    } // We will retry multi times to make sure that the element has been align in the right position.


    setAlignTimes(function (val) {
      return val + 1;
    });

    if (status === 'align') {
      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
    }
  } // Delay to go to next status


  hooks_useLayoutEffect(function () {
    if (status === 'align') {
      // Repeat until not more align needed
      if (alignTimes < 3) {
        forceAlign();
      } else {
        goNextStatus(function () {
          var _prepareResolveRef$cu;

          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
        });
      }
    }
  }, [alignTimes]); // ======================== Motion ========================

  var motion = objectSpread2_objectSpread2({}, getMotion(props));

  ['onAppearEnd', 'onEnterEnd', 'onLeaveEnd'].forEach(function (eventName) {
    var originHandler = motion[eventName];

    motion[eventName] = function (element, event) {
      goNextStatus();
      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
    };
  });

  function onShowPrepare() {
    return new Promise(function (resolve) {
      prepareResolveRef.current = resolve;
    });
  } // Go to stable directly when motion not provided


  react["useEffect"](function () {
    if (!motion.motionName && status === 'motion') {
      goNextStatus();
    }
  }, [motion.motionName, status]); // ========================= Refs =========================

  react["useImperativeHandle"](ref, function () {
    return {
      forceAlign: forceAlign,
      getElement: function getElement() {
        return elementRef.current;
      }
    };
  }); // ======================== Render ========================

  var mergedStyle = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, stretchStyle), {}, {
    zIndex: zIndex,
    opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
  }, style); // Align status


  var alignDisabled = true;

  if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) {
    alignDisabled = false;
  }

  var childNode = children; // Wrapper when multiple children

  if (react["Children"].count(children) > 1) {
    childNode = /*#__PURE__*/react["createElement"]("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }

  return /*#__PURE__*/react["createElement"](es, extends_extends({
    visible: visible,
    ref: elementRef,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }, motion, {
    onAppearPrepare: onShowPrepare,
    onEnterPrepare: onShowPrepare,
    removeOnLeave: destroyPopupOnHide,
    forceRender: forceRender
  }), function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    var mergedClassName = node_modules_classnames_default()(prefixCls, className, alignedClassName, motionClassName);
    return /*#__PURE__*/react["createElement"](rc_align_es, {
      target: getAlignTarget(),
      key: "popup",
      ref: alignRef,
      monitorWindowResize: true,
      disabled: alignDisabled,
      align: align,
      onAlign: onInternalAlign
    }, /*#__PURE__*/react["createElement"]("div", {
      ref: motionRef,
      className: mergedClassName,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDownCapture: onMouseDown,
      onTouchStartCapture: onTouchStart,
      onClick: onClick,
      style: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, motionStyle), mergedStyle)
    }, childNode));
  });
});
PopupInner.displayName = 'PopupInner';
/* harmony default export */ var Popup_PopupInner = (PopupInner);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup/MobilePopupInner.js





var MobilePopupInner = /*#__PURE__*/react["forwardRef"](function (props, ref) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      zIndex = props.zIndex,
      children = props.children,
      _props$mobile = props.mobile;
  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
  var popupClassName = _props$mobile.popupClassName,
      popupStyle = _props$mobile.popupStyle,
      _props$mobile$popupMo = _props$mobile.popupMotion,
      popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo,
      popupRender = _props$mobile.popupRender,
      onClick = props.onClick;
  var elementRef = react["useRef"](); // ========================= Refs =========================

  react["useImperativeHandle"](ref, function () {
    return {
      forceAlign: function forceAlign() {},
      getElement: function getElement() {
        return elementRef.current;
      }
    };
  }); // ======================== Render ========================

  var mergedStyle = objectSpread2_objectSpread2({
    zIndex: zIndex
  }, popupStyle);

  var childNode = children; // Wrapper when multiple children

  if (react["Children"].count(children) > 1) {
    childNode = /*#__PURE__*/react["createElement"]("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  } // Mobile support additional render


  if (popupRender) {
    childNode = popupRender(childNode);
  }

  return /*#__PURE__*/react["createElement"](es, extends_extends({
    visible: visible,
    ref: elementRef,
    removeOnLeave: true
  }, popupMotion), function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    var mergedClassName = node_modules_classnames_default()(prefixCls, popupClassName, motionClassName);
    return /*#__PURE__*/react["createElement"]("div", {
      ref: motionRef,
      className: mergedClassName,
      onClick: onClick,
      style: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, motionStyle), mergedStyle)
    }, childNode);
  });
});
MobilePopupInner.displayName = 'MobilePopupInner';
/* harmony default export */ var Popup_MobilePopupInner = (MobilePopupInner);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup/index.js




var Popup_excluded = ["visible", "mobile"];






var Popup = /*#__PURE__*/react["forwardRef"](function (_ref, ref) {
  var visible = _ref.visible,
      mobile = _ref.mobile,
      props = objectWithoutProperties_objectWithoutProperties(_ref, Popup_excluded);

  var _useState = Object(react["useState"])(visible),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      innerVisible = _useState2[0],
      serInnerVisible = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      _useState4 = slicedToArray_slicedToArray(_useState3, 2),
      inMobile = _useState4[0],
      setInMobile = _useState4[1];

  var cloneProps = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
    visible: innerVisible
  }); // We check mobile in visible changed here.
  // And this also delay set `innerVisible` to avoid popup component render flash


  Object(react["useEffect"])(function () {
    serInnerVisible(visible);

    if (visible && mobile) {
      setInMobile(isMobile());
    }
  }, [visible, mobile]);
  var popupNode = inMobile ? /*#__PURE__*/react["createElement"](Popup_MobilePopupInner, extends_extends({}, cloneProps, {
    mobile: mobile,
    ref: ref
  })) : /*#__PURE__*/react["createElement"](Popup_PopupInner, extends_extends({}, cloneProps, {
    ref: ref
  })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic

  return /*#__PURE__*/react["createElement"]("div", null, /*#__PURE__*/react["createElement"](Mask, cloneProps), popupNode);
});
Popup.displayName = 'Popup';
/* harmony default export */ var es_Popup = (Popup);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/context.js

var TriggerContext = /*#__PURE__*/react["createContext"](null);
/* harmony default export */ var context = (TriggerContext);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/index.js





















function es_noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }

  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

/**
 * Internal usage. Do not use in your code since this will be removed.
 */
function generateTrigger(PortalComponent) {
  var Trigger = /*#__PURE__*/function (_React$Component) {
    inherits_inherits(Trigger, _React$Component);

    var _super = createSuper_createSuper(Trigger);

    // ensure `getContainer` will be called only once
    function Trigger(props) {
      var _this;

      classCallCheck_classCallCheck(this, Trigger);

      _this = _super.call(this, props);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "popupRef", /*#__PURE__*/react["createRef"]());

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "triggerRef", /*#__PURE__*/react["createRef"]());

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "portalContainer", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "attachId", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "clickOutsideHandler", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "touchOutsideHandler", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "contextMenuOutsideHandler1", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "contextMenuOutsideHandler2", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "mouseDownTimeout", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "focusTime", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "preClickTime", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "preTouchTime", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "delayTimer", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "hasPopupMouseDown", void 0);

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onMouseEnter", function (e) {
        var mouseEnterDelay = _this.props.mouseEnterDelay;

        _this.fireEvents('onMouseEnter', e);

        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onMouseMove", function (e) {
        _this.fireEvents('onMouseMove', e);

        _this.setPoint(e);
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onMouseLeave", function (e) {
        _this.fireEvents('onMouseLeave', e);

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onPopupMouseEnter", function () {
        _this.clearDelayTimer();
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onPopupMouseLeave", function (e) {
        var _this$popupRef$curren;

        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && contains((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) {
          return;
        }

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onFocus", function (e) {
        _this.fireEvents('onFocus', e); // incase focusin and focusout


        _this.clearDelayTimer();

        if (_this.isFocusToShow()) {
          _this.focusTime = Date.now();

          _this.delaySetPopupVisible(true, _this.props.focusDelay);
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onMouseDown", function (e) {
        _this.fireEvents('onMouseDown', e);

        _this.preClickTime = Date.now();
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onTouchStart", function (e) {
        _this.fireEvents('onTouchStart', e);

        _this.preTouchTime = Date.now();
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onBlur", function (e) {
        _this.fireEvents('onBlur', e);

        _this.clearDelayTimer();

        if (_this.isBlurToHide()) {
          _this.delaySetPopupVisible(false, _this.props.blurDelay);
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onContextMenu", function (e) {
        e.preventDefault();

        _this.fireEvents('onContextMenu', e);

        _this.setPopupVisible(true, e);
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onContextMenuClose", function () {
        if (_this.isContextMenuToShow()) {
          _this.close();
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onClick", function (event) {
        _this.fireEvents('onClick', event); // focus will trigger click


        if (_this.focusTime) {
          var preTime;

          if (_this.preClickTime && _this.preTouchTime) {
            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
          } else if (_this.preClickTime) {
            preTime = _this.preClickTime;
          } else if (_this.preTouchTime) {
            preTime = _this.preTouchTime;
          }

          if (Math.abs(preTime - _this.focusTime) < 20) {
            return;
          }

          _this.focusTime = 0;
        }

        _this.preClickTime = 0;
        _this.preTouchTime = 0; // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291

        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }

        var nextVisible = !_this.state.popupVisible;

        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
          _this.setPopupVisible(!_this.state.popupVisible, event);
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onPopupMouseDown", function () {
        _this.hasPopupMouseDown = true;
        clearTimeout(_this.mouseDownTimeout);
        _this.mouseDownTimeout = window.setTimeout(function () {
          _this.hasPopupMouseDown = false;
        }, 0);

        if (_this.context) {
          var _this$context;

          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "onDocumentClick", function (event) {
        if (_this.props.mask && !_this.props.maskClosable) {
          return;
        }

        var target = event.target;

        var root = _this.getRootDomNode();

        var popupNode = _this.getPopupDomNode();

        if ( // mousedown on the target should also close popup when action is contextMenu.
        // https://github.com/ant-design/ant-design/issues/29853
        (!contains(root, target) || _this.isContextMenuOnly()) && !contains(popupNode, target) && !_this.hasPopupMouseDown) {
          _this.close();
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "getRootDomNode", function () {
        var getTriggerDOMNode = _this.props.getTriggerDOMNode;

        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this.triggerRef.current);
        }

        try {
          var domNode = findDOMNode(_this.triggerRef.current);

          if (domNode) {
            return domNode;
          }
        } catch (err) {// Do nothing
        }

        return react_dom_default.a.findDOMNode(assertThisInitialized_assertThisInitialized(_this));
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "getPopupClassNameFromAlign", function (align) {
        var className = [];
        var _this$props = _this.props,
            popupPlacement = _this$props.popupPlacement,
            builtinPlacements = _this$props.builtinPlacements,
            prefixCls = _this$props.prefixCls,
            alignPoint = _this$props.alignPoint,
            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;

        if (popupPlacement && builtinPlacements) {
          className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
        }

        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }

        return className.join(' ');
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "getComponent", function () {
        var _this$props2 = _this.props,
            prefixCls = _this$props2.prefixCls,
            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
            popupClassName = _this$props2.popupClassName,
            onPopupAlign = _this$props2.onPopupAlign,
            popupMotion = _this$props2.popupMotion,
            popupAnimation = _this$props2.popupAnimation,
            popupTransitionName = _this$props2.popupTransitionName,
            popupStyle = _this$props2.popupStyle,
            mask = _this$props2.mask,
            maskAnimation = _this$props2.maskAnimation,
            maskTransitionName = _this$props2.maskTransitionName,
            maskMotion = _this$props2.maskMotion,
            zIndex = _this$props2.zIndex,
            popup = _this$props2.popup,
            stretch = _this$props2.stretch,
            alignPoint = _this$props2.alignPoint,
            mobile = _this$props2.mobile,
            forceRender = _this$props2.forceRender,
            onPopupClick = _this$props2.onPopupClick;
        var _this$state = _this.state,
            popupVisible = _this$state.popupVisible,
            point = _this$state.point;

        var align = _this.getPopupAlign();

        var mouseProps = {};

        if (_this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
        }

        if (_this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
        }

        mouseProps.onMouseDown = _this.onPopupMouseDown;
        mouseProps.onTouchStart = _this.onPopupMouseDown;
        return /*#__PURE__*/react["createElement"](es_Popup, extends_extends({
          prefixCls: prefixCls,
          destroyPopupOnHide: destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint && point,
          className: popupClassName,
          align: align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch: stretch,
          getRootDomNode: _this.getRootDomNode,
          style: popupStyle,
          mask: mask,
          zIndex: zIndex,
          transitionName: popupTransitionName,
          maskAnimation: maskAnimation,
          maskTransitionName: maskTransitionName,
          maskMotion: maskMotion,
          ref: _this.popupRef,
          motion: popupMotion,
          mobile: mobile,
          forceRender: forceRender,
          onClick: onPopupClick
        }), typeof popup === 'function' ? popup() : popup);
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "attachParent", function (popupContainer) {
        es_raf.cancel(_this.attachId);
        var _this$props3 = _this.props,
            getPopupContainer = _this$props3.getPopupContainer,
            getDocument = _this$props3.getDocument;

        var domNode = _this.getRootDomNode();

        var mountNode;

        if (!getPopupContainer) {
          mountNode = getDocument(_this.getRootDomNode()).body;
        } else if (domNode || getPopupContainer.length === 0) {
          // Compatible for legacy getPopupContainer with domNode argument.
          // If no need `domNode` argument, will call directly.
          // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
          mountNode = getPopupContainer(domNode);
        }

        if (mountNode) {
          mountNode.appendChild(popupContainer);
        } else {
          // Retry after frame render in case parent not ready
          _this.attachId = es_raf(function () {
            _this.attachParent(popupContainer);
          });
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "getContainer", function () {
        if (!_this.portalContainer) {
          // In React.StrictMode component will call render multiple time in first mount.
          // When you want to refactor with FC, useRef will also init multiple time and
          // point to different useRef instance which will create multiple element
          // (This multiple render will not trigger effect so you can not clean up this
          // in effect). But this is safe with class component since it always point to same class instance.
          var getDocument = _this.props.getDocument;
          var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
          // https://github.com/react-component/trigger/issues/41

          popupContainer.style.position = 'absolute';
          popupContainer.style.top = '0';
          popupContainer.style.left = '0';
          popupContainer.style.width = '100%';
          _this.portalContainer = popupContainer;
        }

        _this.attachParent(_this.portalContainer);

        return _this.portalContainer;
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "setPoint", function (point) {
        var alignPoint = _this.props.alignPoint;
        if (!alignPoint || !point) return;

        _this.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "handlePortalUpdate", function () {
        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
        }
      });

      defineProperty_defineProperty(assertThisInitialized_assertThisInitialized(_this), "triggerContextValue", {
        onPopupMouseDown: _this.onPopupMouseDown
      });

      var _popupVisible;

      if ('popupVisible' in props) {
        _popupVisible = !!props.popupVisible;
      } else {
        _popupVisible = !!props.defaultPopupVisible;
      }

      _this.state = {
        prevPopupVisible: _popupVisible,
        popupVisible: _popupVisible
      };
      ALL_HANDLERS.forEach(function (h) {
        _this["fire".concat(h)] = function (e) {
          _this.fireEvents(h, e);
        };
      });
      return _this;
    }

    createClass_createClass(Trigger, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50

        if (state.popupVisible) {
          var currentDocument;

          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument(this.getRootDomNode());
            this.clickOutsideHandler = addEventListenerWrap(currentDocument, 'mousedown', this.onDocumentClick);
          } // always hide on mobile


          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.touchOutsideHandler = addEventListenerWrap(currentDocument, 'touchstart', this.onDocumentClick);
          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, 'scroll', this.onContextMenuClose);
          } // close popup when trigger type contains 'onContextMenu' and window is blur.


          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = addEventListenerWrap(window, 'blur', this.onContextMenuClose);
          }

          return;
        }

        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
        es_raf.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        var _this$popupRef$curren2;

        // for test
        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement,
            popupAlign = props.popupAlign,
            builtinPlacements = props.builtinPlacements;

        if (popupPlacement && builtinPlacements) {
          return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
        }

        return popupAlign;
      }
    }, {
      key: "setPopupVisible",
      value:
      /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */
      function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();

        if (prevPopupVisible !== popupVisible) {
          if (!('popupVisible' in this.props)) {
            this.setState({
              popupVisible: popupVisible,
              prevPopupVisible: prevPopupVisible
            });
          }

          this.props.onPopupVisibleChange(popupVisible);
        } // Always record the point position since mouseEnterDelay will delay the show


        if (alignPoint && event && popupVisible) {
          this.setPoint(event);
        }
      }
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;

        var delay = delayS * 1000;
        this.clearDelayTimer();

        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function () {
            _this2.setPopupVisible(visible, point);

            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }

        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }

        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }

        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;

        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }

        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props4 = this.props,
            action = _this$props4.action,
            showAction = _this$props4.showAction;
        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function isContextMenuOnly() {
        var action = this.props.action;
        return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props5 = this.props,
            action = _this$props5.action,
            showAction = _this$props5.showAction;
        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props6 = this.props,
            action = _this$props6.action,
            hideAction = _this$props6.hideAction;
        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props7 = this.props,
            action = _this$props7.action,
            showAction = _this$props7.showAction;
        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props8 = this.props,
            action = _this$props8.action,
            hideAction = _this$props8.hideAction;
        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props9 = this.props,
            action = _this$props9.action,
            showAction = _this$props9.showAction;
        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props10 = this.props,
            action = _this$props10.action,
            hideAction = _this$props10.hideAction;
        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible) {
          var _this$popupRef$curren3;

          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];

        if (childCallback) {
          childCallback(e);
        }

        var callback = this.props[type];

        if (callback) {
          callback(e);
        }
      }
    }, {
      key: "close",
      value: function close() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render() {
        var popupVisible = this.state.popupVisible;
        var _this$props11 = this.props,
            children = _this$props11.children,
            forceRender = _this$props11.forceRender,
            alignPoint = _this$props11.alignPoint,
            className = _this$props11.className,
            autoDestroy = _this$props11.autoDestroy;
        var child = react["Children"].only(children);
        var newChildProps = {
          key: 'trigger'
        }; // ============================== Visible Handlers ==============================
        // >>> ContextMenu

        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
        } // >>> Click


        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains('onClick');
          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
        } // >>> Hover(enter)


        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter; // Point align

          if (alignPoint) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
        } // >>> Hover(leave)


        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
        } // >>> Focus


        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains('onFocus');
          newChildProps.onBlur = this.createTwoChains('onBlur');
        } // =================================== Render ===================================


        var childrenClassName = node_modules_classnames_default()(child && child.props && child.props.className, className);

        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }

        var cloneProps = objectSpread2_objectSpread2({}, newChildProps);

        if (supportRef(child)) {
          cloneProps.ref = composeRef(this.triggerRef, child.ref);
        }

        var trigger = /*#__PURE__*/react["cloneElement"](child, cloneProps);
        var portal; // prevent unmounting after it's rendered

        if (popupVisible || this.popupRef.current || forceRender) {
          portal = /*#__PURE__*/react["createElement"](PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }

        if (!popupVisible && autoDestroy) {
          portal = null;
        }

        return /*#__PURE__*/react["createElement"](context.Provider, {
          value: this.triggerContextValue
        }, trigger, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};

        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }

        return newState;
      }
    }]);

    return Trigger;
  }(react["Component"]);

  defineProperty_defineProperty(Trigger, "contextType", context);

  defineProperty_defineProperty(Trigger, "defaultProps", {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: es_noop,
    afterPopupVisibleChange: es_noop,
    onPopupAlign: es_noop,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  });

  return Trigger;
}
/* harmony default export */ var rc_trigger_es = (generateTrigger(es_Portal));
// CONCATENATED MODULE: ./node_modules/rc-picker/es/PickerTrigger.js




var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};

function PickerTrigger(_ref) {
  var _classNames;

  var prefixCls = _ref.prefixCls,
      popupElement = _ref.popupElement,
      popupStyle = _ref.popupStyle,
      visible = _ref.visible,
      dropdownClassName = _ref.dropdownClassName,
      dropdownAlign = _ref.dropdownAlign,
      transitionName = _ref.transitionName,
      getPopupContainer = _ref.getPopupContainer,
      children = _ref.children,
      range = _ref.range,
      popupPlacement = _ref.popupPlacement,
      direction = _ref.direction;
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");

  var getPopupPlacement = function getPopupPlacement() {
    if (popupPlacement !== undefined) {
      return popupPlacement;
    }

    return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  };

  return /*#__PURE__*/react["createElement"](rc_trigger_es, {
    showAction: [],
    hideAction: [],
    popupPlacement: getPopupPlacement(),
    builtinPlacements: BUILT_IN_PLACEMENTS,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: transitionName,
    popup: popupElement,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    popupClassName: node_modules_classnames_default()(dropdownClassName, (_classNames = {}, defineProperty_defineProperty(_classNames, "".concat(dropdownPrefixCls, "-range"), range), defineProperty_defineProperty(_classNames, "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl'), _classNames)),
    popupStyle: popupStyle,
    getPopupContainer: getPopupContainer
  }, children);
}

/* harmony default export */ var es_PickerTrigger = (PickerTrigger);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/usePickerInput.js




function usePickerInput(_ref) {
  var open = _ref.open,
      value = _ref.value,
      isClickOutside = _ref.isClickOutside,
      triggerOpen = _ref.triggerOpen,
      forwardKeyDown = _ref.forwardKeyDown,
      _onKeyDown = _ref.onKeyDown,
      blurToCancel = _ref.blurToCancel,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur;

  var _useState = Object(react["useState"])(false),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      typing = _useState2[0],
      setTyping = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      _useState4 = slicedToArray_slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];
  /**
   * We will prevent blur to handle open event when user click outside,
   * since this will repeat trigger `onOpenChange` event.
   */


  var preventBlurRef = Object(react["useRef"])(false);
  var valueChangedRef = Object(react["useRef"])(false);
  var preventDefaultRef = Object(react["useRef"])(false);
  var inputProps = {
    onMouseDown: function onMouseDown() {
      setTyping(true);
      triggerOpen(true);
    },
    onKeyDown: function onKeyDown(e) {
      var preventDefault = function preventDefault() {
        preventDefaultRef.current = true;
      };

      _onKeyDown(e, preventDefault);

      if (preventDefaultRef.current) return;

      switch (e.which) {
        case es_KeyCode.ENTER:
          {
            if (!open) {
              triggerOpen(true);
            } else if (onSubmit() !== false) {
              setTyping(true);
            }

            e.preventDefault();
            return;
          }

        case es_KeyCode.TAB:
          {
            if (typing && open && !e.shiftKey) {
              setTyping(false);
              e.preventDefault();
            } else if (!typing && open) {
              if (!forwardKeyDown(e) && e.shiftKey) {
                setTyping(true);
                e.preventDefault();
              }
            }

            return;
          }

        case es_KeyCode.ESC:
          {
            setTyping(true);
            onCancel();
            return;
          }
      }

      if (!open && ![es_KeyCode.SHIFT].includes(e.which)) {
        triggerOpen(true);
      } else if (!typing) {
        // Let popup panel handle keyboard
        forwardKeyDown(e);
      }
    },
    onFocus: function onFocus(e) {
      setTyping(true);
      setFocused(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      if (preventBlurRef.current || !isClickOutside(document.activeElement)) {
        preventBlurRef.current = false;
        return;
      }

      if (blurToCancel) {
        setTimeout(function () {
          var _document = document,
              activeElement = _document.activeElement;

          while (activeElement && activeElement.shadowRoot) {
            activeElement = activeElement.shadowRoot.activeElement;
          }

          if (isClickOutside(activeElement)) {
            onCancel();
          }
        }, 0);
      } else if (open) {
        triggerOpen(false);

        if (valueChangedRef.current) {
          onSubmit();
        }
      }

      setFocused(false);

      if (_onBlur) {
        _onBlur(e);
      }
    }
  }; // check if value changed

  Object(react["useEffect"])(function () {
    valueChangedRef.current = false;
  }, [open]);
  Object(react["useEffect"])(function () {
    valueChangedRef.current = true;
  }, [value]); // Global click handler

  Object(react["useEffect"])(function () {
    return addGlobalMouseDownEvent(function (e) {
      var target = getTargetFromEvent(e);

      if (open) {
        var clickedOutside = isClickOutside(target);

        if (!clickedOutside) {
          preventBlurRef.current = true; // Always set back in case `onBlur` prevented by user

          requestAnimationFrame(function () {
            preventBlurRef.current = false;
          });
        } else if (!focused || clickedOutside) {
          triggerOpen(false);
        }
      }
    });
  });
  return [inputProps, {
    focused: focused,
    typing: typing
  }];
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useTextValueMapping.js


function useTextValueMapping(_ref) {
  var valueTexts = _ref.valueTexts,
      onTextChange = _ref.onTextChange;

  var _React$useState = react["useState"](''),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      text = _React$useState2[0],
      setInnerText = _React$useState2[1];

  var valueTextsRef = react["useRef"]([]);
  valueTextsRef.current = valueTexts;

  function triggerTextChange(value) {
    setInnerText(value);
    onTextChange(value);
  }

  function resetText() {
    setInnerText(valueTextsRef.current[0]);
  }

  react["useEffect"](function () {
    if (valueTexts.every(function (valText) {
      return valText !== text;
    })) {
      resetText();
    }
  }, [valueTexts.join('||')]);
  return [text, triggerTextChange, resetText];
}
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__("1b2b");
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);

// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useValueTexts.js



function useValueTexts(value, _ref) {
  var formatList = _ref.formatList,
      generateConfig = _ref.generateConfig,
      locale = _ref.locale;
  return useMemo(function () {
    if (!value) {
      return [[''], ''];
    } // We will convert data format back to first format


    var firstValueText = '';
    var fullValueTexts = [];

    for (var i = 0; i < formatList.length; i += 1) {
      var format = formatList[i];
      var formatStr = formatValue(value, {
        generateConfig: generateConfig,
        locale: locale,
        format: format
      });
      fullValueTexts.push(formatStr);

      if (i === 0) {
        firstValueText = formatStr;
      }
    }

    return [fullValueTexts, firstValueText];
  }, [value, formatList], function (prev, next) {
    return prev[0] !== next[0] || !shallowequal_default()(prev[1], next[1]);
  });
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useHoverValue.js



function useHoverValue(valueText, _ref) {
  var formatList = _ref.formatList,
      generateConfig = _ref.generateConfig,
      locale = _ref.locale;

  var _useState = Object(react["useState"])(null),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      value = _useState2[0],
      internalSetValue = _useState2[1];

  var raf = Object(react["useRef"])(null);

  function setValue(val) {
    var immediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    cancelAnimationFrame(raf.current);

    if (immediately) {
      internalSetValue(val);
      return;
    }

    raf.current = requestAnimationFrame(function () {
      internalSetValue(val);
    });
  }

  var _useValueTexts = useValueTexts(value, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useValueTexts2 = slicedToArray_slicedToArray(_useValueTexts, 2),
      firstText = _useValueTexts2[1];

  function onEnter(date) {
    setValue(date);
  }

  function onLeave() {
    var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setValue(null, immediately);
  }

  Object(react["useEffect"])(function () {
    onLeave(true);
  }, [valueText]);
  Object(react["useEffect"])(function () {
    return function () {
      return cancelAnimationFrame(raf.current);
    };
  }, []);
  return [firstText, onEnter, onLeave];
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/Picker.js









/**
 * Removed:
 *  - getCalendarContainer: use `getPopupContainer` instead
 *  - onOk
 *
 * New Feature:
 *  - picker
 *  - allowEmpty
 *  - selectable
 *
 * Tips: Should add faq about `datetime` mode with `defaultValue`
 */















function InnerPicker(props) {
  var _classNames2;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
      id = props.id,
      tabIndex = props.tabIndex,
      style = props.style,
      className = props.className,
      dropdownClassName = props.dropdownClassName,
      dropdownAlign = props.dropdownAlign,
      popupStyle = props.popupStyle,
      transitionName = props.transitionName,
      generateConfig = props.generateConfig,
      locale = props.locale,
      inputReadOnly = props.inputReadOnly,
      allowClear = props.allowClear,
      autoFocus = props.autoFocus,
      showTime = props.showTime,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      format = props.format,
      use12Hours = props.use12Hours,
      value = props.value,
      defaultValue = props.defaultValue,
      open = props.open,
      defaultOpen = props.defaultOpen,
      defaultOpenValue = props.defaultOpenValue,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      disabled = props.disabled,
      disabledDate = props.disabledDate,
      placeholder = props.placeholder,
      getPopupContainer = props.getPopupContainer,
      pickerRef = props.pickerRef,
      panelRender = props.panelRender,
      onChange = props.onChange,
      onOpenChange = props.onOpenChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onContextMenu = props.onContextMenu,
      onClick = props.onClick,
      _onKeyDown = props.onKeyDown,
      _onSelect = props.onSelect,
      direction = props.direction,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete;
  var inputRef = react["useRef"](null);
  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time'; // ============================= State =============================

  var formatList = toArray(getDefaultFormat(format, picker, showTime, use12Hours)); // Panel ref

  var panelDivRef = react["useRef"](null);
  var inputDivRef = react["useRef"](null);
  var containerRef = react["useRef"](null); // Real value

  var _useMergedState = useMergedState(null, {
    value: value,
    defaultValue: defaultValue
  }),
      _useMergedState2 = slicedToArray_slicedToArray(_useMergedState, 2),
      mergedValue = _useMergedState2[0],
      setInnerValue = _useMergedState2[1]; // Selected value


  var _React$useState = react["useState"](mergedValue),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      selectedValue = _React$useState2[0],
      setSelectedValue = _React$useState2[1]; // Operation ref


  var operationRef = react["useRef"](null); // Open

  var _useMergedState3 = useMergedState(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return disabled ? false : postOpen;
    },
    onChange: function onChange(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      }

      if (!newOpen && operationRef.current && operationRef.current.onClose) {
        operationRef.current.onClose();
      }
    }
  }),
      _useMergedState4 = slicedToArray_slicedToArray(_useMergedState3, 2),
      mergedOpen = _useMergedState4[0],
      triggerInnerOpen = _useMergedState4[1]; // ============================= Text ==============================


  var _useValueTexts = useValueTexts(selectedValue, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useValueTexts2 = slicedToArray_slicedToArray(_useValueTexts, 2),
      valueTexts = _useValueTexts2[0],
      firstValueText = _useValueTexts2[1];

  var _useTextValueMapping = useTextValueMapping({
    valueTexts: valueTexts,
    onTextChange: function onTextChange(newText) {
      var inputDate = parseValue(newText, {
        locale: locale,
        formatList: formatList,
        generateConfig: generateConfig
      });

      if (inputDate && (!disabledDate || !disabledDate(inputDate))) {
        setSelectedValue(inputDate);
      }
    }
  }),
      _useTextValueMapping2 = slicedToArray_slicedToArray(_useTextValueMapping, 3),
      text = _useTextValueMapping2[0],
      triggerTextChange = _useTextValueMapping2[1],
      resetText = _useTextValueMapping2[2]; // ============================ Trigger ============================


  var triggerChange = function triggerChange(newValue) {
    setSelectedValue(newValue);
    setInnerValue(newValue);

    if (onChange && !isEqual(generateConfig, mergedValue, newValue)) {
      onChange(newValue, newValue ? formatValue(newValue, {
        generateConfig: generateConfig,
        locale: locale,
        format: formatList[0]
      }) : '');
    }
  };

  var triggerOpen = function triggerOpen(newOpen) {
    if (disabled && newOpen) {
      return;
    }

    triggerInnerOpen(newOpen);
  };

  var forwardKeyDown = function forwardKeyDown(e) {
    if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
      // Let popup panel handle keyboard
      return operationRef.current.onKeyDown(e);
    }
    /* istanbul ignore next */

    /* eslint-disable no-lone-blocks */


    {
      es_warning(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
      return false;
    }
  };

  var onInternalMouseUp = function onInternalMouseUp() {
    if (onMouseUp) {
      onMouseUp.apply(void 0, arguments);
    }

    if (inputRef.current) {
      inputRef.current.focus();
      triggerOpen(true);
    }
  }; // ============================= Input =============================


  var _usePickerInput = usePickerInput({
    blurToCancel: needConfirmButton,
    open: mergedOpen,
    value: text,
    triggerOpen: triggerOpen,
    forwardKeyDown: forwardKeyDown,
    isClickOutside: function isClickOutside(target) {
      return !elementsContains([panelDivRef.current, inputDivRef.current, containerRef.current], target);
    },
    onSubmit: function onSubmit() {
      if (disabledDate && disabledDate(selectedValue)) {
        return false;
      }

      triggerChange(selectedValue);
      triggerOpen(false);
      resetText();
      return true;
    },
    onCancel: function onCancel() {
      triggerOpen(false);
      setSelectedValue(mergedValue);
      resetText();
    },
    onKeyDown: function onKeyDown(e, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e, preventDefault);
    },
    onFocus: onFocus,
    onBlur: onBlur
  }),
      _usePickerInput2 = slicedToArray_slicedToArray(_usePickerInput, 2),
      inputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      focused = _usePickerInput2$.focused,
      typing = _usePickerInput2$.typing; // ============================= Sync ==============================
  // Close should sync back with text value


  react["useEffect"](function () {
    if (!mergedOpen) {
      setSelectedValue(mergedValue);

      if (!valueTexts.length || valueTexts[0] === '') {
        triggerTextChange('');
      } else if (firstValueText !== text) {
        resetText();
      }
    }
  }, [mergedOpen, valueTexts]); // Change picker should sync back with text value

  react["useEffect"](function () {
    if (!mergedOpen) {
      resetText();
    }
  }, [picker]); // Sync innerValue with control mode

  react["useEffect"](function () {
    // Sync select value
    setSelectedValue(mergedValue);
  }, [mergedValue]); // ============================ Private ============================

  if (pickerRef) {
    pickerRef.current = {
      focus: function focus() {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      },
      blur: function blur() {
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }
    };
  }

  var _useHoverValue = useHoverValue(text, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useHoverValue2 = slicedToArray_slicedToArray(_useHoverValue, 3),
      hoverValue = _useHoverValue2[0],
      onEnter = _useHoverValue2[1],
      onLeave = _useHoverValue2[2]; // ============================= Panel =============================


  var panelProps = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, props), {}, {
    className: undefined,
    style: undefined,
    pickerValue: undefined,
    onPickerValueChange: undefined,
    onChange: null
  });

  var panelNode = /*#__PURE__*/react["createElement"](es_PickerPanel, extends_extends({}, panelProps, {
    generateConfig: generateConfig,
    className: node_modules_classnames_default()(defineProperty_defineProperty({}, "".concat(prefixCls, "-panel-focused"), !typing)),
    value: selectedValue,
    locale: locale,
    tabIndex: -1,
    onSelect: function onSelect(date) {
      _onSelect === null || _onSelect === void 0 ? void 0 : _onSelect(date);
      setSelectedValue(date);
    },
    direction: direction,
    onPanelChange: function onPanelChange(viewDate, mode) {
      var onPanelChange = props.onPanelChange;
      onLeave(true);
      onPanelChange === null || onPanelChange === void 0 ? void 0 : onPanelChange(viewDate, mode);
    }
  }));

  if (panelRender) {
    panelNode = panelRender(panelNode);
  }

  var panel = /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-panel-container"),
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    }
  }, panelNode);
  var suffixNode;

  if (suffixIcon) {
    suffixNode = /*#__PURE__*/react["createElement"]("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
  }

  var clearNode;

  if (allowClear && mergedValue && !disabled) {
    clearNode = /*#__PURE__*/react["createElement"]("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerChange(null);
        triggerOpen(false);
      },
      className: "".concat(prefixCls, "-clear"),
      role: "button"
    }, clearIcon || /*#__PURE__*/react["createElement"]("span", {
      className: "".concat(prefixCls, "-clear-btn")
    }));
  } // ============================ Warning ============================


  if (false) {} // ============================ Return =============================


  var onContextSelect = function onContextSelect(date, type) {
    if (type === 'submit' || type !== 'key' && !needConfirmButton) {
      // triggerChange will also update selected values
      triggerChange(date);
      triggerOpen(false);
    }
  };

  var popupPlacement = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
  return /*#__PURE__*/react["createElement"](es_PanelContext.Provider, {
    value: {
      operationRef: operationRef,
      hideHeader: picker === 'time',
      panelRef: panelDivRef,
      onSelect: onContextSelect,
      open: mergedOpen,
      defaultOpenValue: defaultOpenValue,
      onDateMouseEnter: onEnter,
      onDateMouseLeave: onLeave
    }
  }, /*#__PURE__*/react["createElement"](es_PickerTrigger, {
    visible: mergedOpen,
    popupElement: panel,
    popupStyle: popupStyle,
    prefixCls: prefixCls,
    dropdownClassName: dropdownClassName,
    dropdownAlign: dropdownAlign,
    getPopupContainer: getPopupContainer,
    transitionName: transitionName,
    popupPlacement: popupPlacement,
    direction: direction
  }, /*#__PURE__*/react["createElement"]("div", {
    ref: containerRef,
    className: node_modules_classnames_default()(prefixCls, className, (_classNames2 = {}, defineProperty_defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), defineProperty_defineProperty(_classNames2, "".concat(prefixCls, "-focused"), focused), defineProperty_defineProperty(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
    style: style,
    onMouseDown: onMouseDown,
    onMouseUp: onInternalMouseUp,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onContextMenu: onContextMenu,
    onClick: onClick
  }, /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()("".concat(prefixCls, "-input"), defineProperty_defineProperty({}, "".concat(prefixCls, "-input-placeholder"), !!hoverValue)),
    ref: inputDivRef
  }, /*#__PURE__*/react["createElement"]("input", extends_extends({
    id: id,
    tabIndex: tabIndex,
    disabled: disabled,
    readOnly: inputReadOnly || typeof formatList[0] === 'function' || !typing,
    value: hoverValue || text,
    onChange: function onChange(e) {
      triggerTextChange(e.target.value);
    },
    autoFocus: autoFocus,
    placeholder: placeholder,
    ref: inputRef,
    title: text
  }, inputProps, {
    size: getInputSize(picker, formatList[0], generateConfig)
  }, getDataOrAriaProps(props), {
    autoComplete: autoComplete
  })), suffixNode, clearNode))));
} // Wrap with class component to enable pass generic with instance method


var Picker_Picker = /*#__PURE__*/function (_React$Component) {
  inherits_inherits(Picker, _React$Component);

  var _super = createSuper_createSuper(Picker);

  function Picker() {
    var _this;

    classCallCheck_classCallCheck(this, Picker);

    _this = _super.apply(this, arguments);
    _this.pickerRef = /*#__PURE__*/react["createRef"]();

    _this.focus = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.focus();
      }
    };

    _this.blur = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.blur();
      }
    };

    return _this;
  }

  createClass_createClass(Picker, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/react["createElement"](InnerPicker, extends_extends({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]);

  return Picker;
}(react["Component"]);

/* harmony default export */ var es_Picker = (Picker_Picker);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useRangeDisabled.js



function useRangeDisabled(_ref, disabledStart, disabledEnd) {
  var picker = _ref.picker,
      locale = _ref.locale,
      selectedValue = _ref.selectedValue,
      disabledDate = _ref.disabledDate,
      disabled = _ref.disabled,
      generateConfig = _ref.generateConfig;
  var startDate = miscUtil_getValue(selectedValue, 0);
  var endDate = miscUtil_getValue(selectedValue, 1);

  function weekFirstDate(date) {
    return generateConfig.locale.getWeekFirstDate(locale.locale, date);
  }

  function monthNumber(date) {
    var year = generateConfig.getYear(date);
    var month = generateConfig.getMonth(date);
    return year * 100 + month;
  }

  function quarterNumber(date) {
    var year = generateConfig.getYear(date);
    var quarter = getQuarter(generateConfig, date);
    return year * 10 + quarter;
  }

  var disabledStartDate = react["useCallback"](function (date) {
    if (disabledDate && disabledDate(date)) {
      return true;
    } // Disabled range


    if (disabled[1] && endDate) {
      return !isSameDate(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
    } // Disabled part


    if (disabledStart && endDate) {
      switch (picker) {
        case 'quarter':
          return quarterNumber(date) > quarterNumber(endDate);

        case 'month':
          return monthNumber(date) > monthNumber(endDate);

        case 'week':
          return weekFirstDate(date) > weekFirstDate(endDate);

        default:
          return !isSameDate(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
      }
    }

    return false;
  }, [disabledDate, disabled[1], endDate, disabledStart]);
  var disabledEndDate = react["useCallback"](function (date) {
    if (disabledDate && disabledDate(date)) {
      return true;
    } // Disabled range


    if (disabled[0] && startDate) {
      return !isSameDate(generateConfig, date, endDate) && generateConfig.isAfter(startDate, date);
    } // Disabled part


    if (disabledEnd && startDate) {
      switch (picker) {
        case 'quarter':
          return quarterNumber(date) < quarterNumber(startDate);

        case 'month':
          return monthNumber(date) < monthNumber(startDate);

        case 'week':
          return weekFirstDate(date) < weekFirstDate(startDate);

        default:
          return !isSameDate(generateConfig, date, startDate) && generateConfig.isAfter(startDate, date);
      }
    }

    return false;
  }, [disabledDate, disabled[0], startDate, disabledEnd]);
  return [disabledStartDate, disabledEndDate];
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/hooks/useRangeViewDates.js





function getStartEndDistance(startDate, endDate, picker, generateConfig) {
  var startNext = getClosingViewDate(startDate, picker, generateConfig, 1);

  function getDistance(compareFunc) {
    if (compareFunc(startDate, endDate)) {
      return 'same';
    }

    if (compareFunc(startNext, endDate)) {
      return 'closing';
    }

    return 'far';
  }

  switch (picker) {
    case 'year':
      return getDistance(function (start, end) {
        return isSameDecade(generateConfig, start, end);
      });

    case 'quarter':
    case 'month':
      return getDistance(function (start, end) {
        return isSameYear(generateConfig, start, end);
      });

    default:
      return getDistance(function (start, end) {
        return isSameMonth(generateConfig, start, end);
      });
  }
}

function getRangeViewDate(values, index, picker, generateConfig) {
  var startDate = miscUtil_getValue(values, 0);
  var endDate = miscUtil_getValue(values, 1);

  if (index === 0) {
    return startDate;
  }

  if (startDate && endDate) {
    var distance = getStartEndDistance(startDate, endDate, picker, generateConfig);

    switch (distance) {
      case 'same':
        return startDate;

      case 'closing':
        return startDate;

      default:
        return getClosingViewDate(endDate, picker, generateConfig, -1);
    }
  }

  return startDate;
}

function useRangeViewDates(_ref) {
  var values = _ref.values,
      picker = _ref.picker,
      defaultDates = _ref.defaultDates,
      generateConfig = _ref.generateConfig;

  var _React$useState = react["useState"](function () {
    return [miscUtil_getValue(defaultDates, 0), miscUtil_getValue(defaultDates, 1)];
  }),
      _React$useState2 = slicedToArray_slicedToArray(_React$useState, 2),
      defaultViewDates = _React$useState2[0],
      setDefaultViewDates = _React$useState2[1];

  var _React$useState3 = react["useState"](null),
      _React$useState4 = slicedToArray_slicedToArray(_React$useState3, 2),
      viewDates = _React$useState4[0],
      setInternalViewDates = _React$useState4[1];

  var startDate = miscUtil_getValue(values, 0);
  var endDate = miscUtil_getValue(values, 1);

  function getViewDate(index) {
    // If set default view date, use it
    if (defaultViewDates[index]) {
      return defaultViewDates[index];
    }

    return miscUtil_getValue(viewDates, index) || getRangeViewDate(values, index, picker, generateConfig) || startDate || endDate || generateConfig.getNow();
  }

  function setViewDate(viewDate, index) {
    if (viewDate) {
      var newViewDates = updateValues(viewDates, viewDate, index); // Set view date will clean up default one

      setDefaultViewDates( // Should always be an array
      updateValues(defaultViewDates, null, index) || [null, null]); // Reset another one when not have value

      var anotherIndex = (index + 1) % 2;

      if (!miscUtil_getValue(values, anotherIndex)) {
        newViewDates = updateValues(newViewDates, viewDate, anotherIndex);
      }

      setInternalViewDates(newViewDates);
    } else if (startDate || endDate) {
      // Reset all when has values when `viewDate` is `null` which means from open trigger
      setInternalViewDates(null);
    }
  }

  return [getViewDate, setViewDate];
}
// CONCATENATED MODULE: ./node_modules/rc-picker/es/RangePicker.js






























function reorderValues(values, generateConfig) {
  if (values && values[0] && values[1] && generateConfig.isAfter(values[0], values[1])) {
    return [values[1], values[0]];
  }

  return values;
}

function canValueTrigger(value, index, disabled, allowEmpty) {
  if (value) {
    return true;
  }

  if (allowEmpty && allowEmpty[index]) {
    return true;
  }

  if (disabled[(index + 1) % 2]) {
    return true;
  }

  return false;
}

function InnerRangePicker(props) {
  var _classNames2, _classNames3, _classNames4;

  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls,
      id = props.id,
      style = props.style,
      className = props.className,
      popupStyle = props.popupStyle,
      dropdownClassName = props.dropdownClassName,
      transitionName = props.transitionName,
      dropdownAlign = props.dropdownAlign,
      getPopupContainer = props.getPopupContainer,
      generateConfig = props.generateConfig,
      locale = props.locale,
      placeholder = props.placeholder,
      autoFocus = props.autoFocus,
      disabled = props.disabled,
      format = props.format,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      showTime = props.showTime,
      use12Hours = props.use12Hours,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '~' : _props$separator,
      value = props.value,
      defaultValue = props.defaultValue,
      defaultPickerValue = props.defaultPickerValue,
      open = props.open,
      defaultOpen = props.defaultOpen,
      disabledDate = props.disabledDate,
      _disabledTime = props.disabledTime,
      dateRender = props.dateRender,
      panelRender = props.panelRender,
      ranges = props.ranges,
      allowEmpty = props.allowEmpty,
      allowClear = props.allowClear,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      pickerRef = props.pickerRef,
      inputReadOnly = props.inputReadOnly,
      mode = props.mode,
      renderExtraFooter = props.renderExtraFooter,
      onChange = props.onChange,
      onOpenChange = props.onOpenChange,
      onPanelChange = props.onPanelChange,
      onCalendarChange = props.onCalendarChange,
      _onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      _onOk = props.onOk,
      _onKeyDown = props.onKeyDown,
      components = props.components,
      order = props.order,
      direction = props.direction,
      activePickerIndex = props.activePickerIndex,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete;
  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time'; // We record opened status here in case repeat open with picker

  var openRecordsRef = Object(react["useRef"])({});
  var containerRef = Object(react["useRef"])(null);
  var panelDivRef = Object(react["useRef"])(null);
  var startInputDivRef = Object(react["useRef"])(null);
  var endInputDivRef = Object(react["useRef"])(null);
  var separatorRef = Object(react["useRef"])(null);
  var startInputRef = Object(react["useRef"])(null);
  var endInputRef = Object(react["useRef"])(null); // ============================= Misc ==============================

  var formatList = toArray(getDefaultFormat(format, picker, showTime, use12Hours)); // Active picker

  var _useMergedState = useMergedState(0, {
    value: activePickerIndex
  }),
      _useMergedState2 = slicedToArray_slicedToArray(_useMergedState, 2),
      mergedActivePickerIndex = _useMergedState2[0],
      setMergedActivePickerIndex = _useMergedState2[1]; // Operation ref


  var operationRef = Object(react["useRef"])(null);
  var mergedDisabled = react["useMemo"](function () {
    if (Array.isArray(disabled)) {
      return disabled;
    }

    return [disabled || false, disabled || false];
  }, [disabled]); // ============================= Value =============================

  var _useMergedState3 = useMergedState(null, {
    value: value,
    defaultValue: defaultValue,
    postState: function postState(values) {
      return picker === 'time' && !order ? values : reorderValues(values, generateConfig);
    }
  }),
      _useMergedState4 = slicedToArray_slicedToArray(_useMergedState3, 2),
      mergedValue = _useMergedState4[0],
      setInnerValue = _useMergedState4[1]; // =========================== View Date ===========================
  // Config view panel


  var _useRangeViewDates = useRangeViewDates({
    values: mergedValue,
    picker: picker,
    defaultDates: defaultPickerValue,
    generateConfig: generateConfig
  }),
      _useRangeViewDates2 = slicedToArray_slicedToArray(_useRangeViewDates, 2),
      getViewDate = _useRangeViewDates2[0],
      setViewDate = _useRangeViewDates2[1]; // ========================= Select Values =========================


  var _useMergedState5 = useMergedState(mergedValue, {
    postState: function postState(values) {
      var postValues = values;

      if (mergedDisabled[0] && mergedDisabled[1]) {
        return postValues;
      } // Fill disabled unit


      for (var i = 0; i < 2; i += 1) {
        if (mergedDisabled[i] && !miscUtil_getValue(postValues, i) && !miscUtil_getValue(allowEmpty, i)) {
          postValues = updateValues(postValues, generateConfig.getNow(), i);
        }
      }

      return postValues;
    }
  }),
      _useMergedState6 = slicedToArray_slicedToArray(_useMergedState5, 2),
      selectedValue = _useMergedState6[0],
      setSelectedValue = _useMergedState6[1]; // ============================= Modes =============================


  var _useMergedState7 = useMergedState([picker, picker], {
    value: mode
  }),
      _useMergedState8 = slicedToArray_slicedToArray(_useMergedState7, 2),
      mergedModes = _useMergedState8[0],
      setInnerModes = _useMergedState8[1];

  Object(react["useEffect"])(function () {
    setInnerModes([picker, picker]);
  }, [picker]);

  var triggerModesChange = function triggerModesChange(modes, values) {
    setInnerModes(modes);

    if (onPanelChange) {
      onPanelChange(values, modes);
    }
  }; // ========================= Disable Date ==========================


  var _useRangeDisabled = useRangeDisabled({
    picker: picker,
    selectedValue: selectedValue,
    locale: locale,
    disabled: mergedDisabled,
    disabledDate: disabledDate,
    generateConfig: generateConfig
  }, openRecordsRef.current[1], openRecordsRef.current[0]),
      _useRangeDisabled2 = slicedToArray_slicedToArray(_useRangeDisabled, 2),
      disabledStartDate = _useRangeDisabled2[0],
      disabledEndDate = _useRangeDisabled2[1]; // ============================= Open ==============================


  var _useMergedState9 = useMergedState(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return mergedDisabled[mergedActivePickerIndex] ? false : postOpen;
    },
    onChange: function onChange(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      }

      if (!newOpen && operationRef.current && operationRef.current.onClose) {
        operationRef.current.onClose();
      }
    }
  }),
      _useMergedState10 = slicedToArray_slicedToArray(_useMergedState9, 2),
      mergedOpen = _useMergedState10[0],
      triggerInnerOpen = _useMergedState10[1];

  var startOpen = mergedOpen && mergedActivePickerIndex === 0;
  var endOpen = mergedOpen && mergedActivePickerIndex === 1; // ============================= Popup =============================
  // Popup min width

  var _useState = Object(react["useState"])(0),
      _useState2 = slicedToArray_slicedToArray(_useState, 2),
      popupMinWidth = _useState2[0],
      setPopupMinWidth = _useState2[1];

  Object(react["useEffect"])(function () {
    if (!mergedOpen && containerRef.current) {
      setPopupMinWidth(containerRef.current.offsetWidth);
    }
  }, [mergedOpen]); // ============================ Trigger ============================

  var triggerRef = react["useRef"]();

  function _triggerOpen(newOpen, index) {
    if (newOpen) {
      clearTimeout(triggerRef.current);
      openRecordsRef.current[index] = true;
      setMergedActivePickerIndex(index);
      triggerInnerOpen(newOpen); // Open to reset view date

      if (!mergedOpen) {
        setViewDate(null, index);
      }
    } else if (mergedActivePickerIndex === index) {
      triggerInnerOpen(newOpen); // Clean up async
      // This makes ref not quick refresh in case user open another input with blur trigger

      var openRecords = openRecordsRef.current;
      triggerRef.current = setTimeout(function () {
        if (openRecords === openRecordsRef.current) {
          openRecordsRef.current = {};
        }
      });
    }
  }

  function triggerOpenAndFocus(index) {
    _triggerOpen(true, index); // Use setTimeout to make sure panel DOM exists


    setTimeout(function () {
      var inputRef = [startInputRef, endInputRef][index];

      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  }

  function triggerChange(newValue, sourceIndex) {
    var values = newValue;
    var startValue = miscUtil_getValue(values, 0);
    var endValue = miscUtil_getValue(values, 1); // >>>>> Format start & end values

    if (startValue && endValue && generateConfig.isAfter(startValue, endValue)) {
      if ( // WeekPicker only compare week
      picker === 'week' && !isSameWeek(generateConfig, locale.locale, startValue, endValue) || // QuotaPicker only compare week
      picker === 'quarter' && !isSameQuarter(generateConfig, startValue, endValue) || // Other non-TimePicker compare date
      picker !== 'week' && picker !== 'quarter' && picker !== 'time' && !isSameDate(generateConfig, startValue, endValue)) {
        // Clean up end date when start date is after end date
        if (sourceIndex === 0) {
          values = [startValue, null];
          endValue = null;
        } else {
          startValue = null;
          values = [null, endValue];
        } // Clean up cache since invalidate


        openRecordsRef.current = defineProperty_defineProperty({}, sourceIndex, true);
      } else if (picker !== 'time' || order !== false) {
        // Reorder when in same date
        values = reorderValues(values, generateConfig);
      }
    }

    setSelectedValue(values);
    var startStr = values && values[0] ? formatValue(values[0], {
      generateConfig: generateConfig,
      locale: locale,
      format: formatList[0]
    }) : '';
    var endStr = values && values[1] ? formatValue(values[1], {
      generateConfig: generateConfig,
      locale: locale,
      format: formatList[0]
    }) : '';

    if (onCalendarChange) {
      var info = {
        range: sourceIndex === 0 ? 'start' : 'end'
      };
      onCalendarChange(values, [startStr, endStr], info);
    } // >>>>> Trigger `onChange` event


    var canStartValueTrigger = canValueTrigger(startValue, 0, mergedDisabled, allowEmpty);
    var canEndValueTrigger = canValueTrigger(endValue, 1, mergedDisabled, allowEmpty);
    var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;

    if (canTrigger) {
      // Trigger onChange only when value is validate
      setInnerValue(values);

      if (onChange && (!isEqual(generateConfig, miscUtil_getValue(mergedValue, 0), startValue) || !isEqual(generateConfig, miscUtil_getValue(mergedValue, 1), endValue))) {
        onChange(values, [startStr, endStr]);
      }
    } // >>>>> Open picker when
    // Always open another picker if possible


    var nextOpenIndex = null;

    if (sourceIndex === 0 && !mergedDisabled[1]) {
      nextOpenIndex = 1;
    } else if (sourceIndex === 1 && !mergedDisabled[0]) {
      nextOpenIndex = 0;
    }

    if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex && (!openRecordsRef.current[nextOpenIndex] || !miscUtil_getValue(values, nextOpenIndex)) && miscUtil_getValue(values, sourceIndex)) {
      // Delay to focus to avoid input blur trigger expired selectedValues
      triggerOpenAndFocus(nextOpenIndex);
    } else {
      _triggerOpen(false, sourceIndex);
    }
  }

  var forwardKeyDown = function forwardKeyDown(e) {
    if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
      // Let popup panel handle keyboard
      return operationRef.current.onKeyDown(e);
    }
    /* istanbul ignore next */

    /* eslint-disable no-lone-blocks */


    {
      es_warning(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
      return false;
    }
  }; // ============================= Text ==============================


  var sharedTextHooksProps = {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  };

  var _useValueTexts = useValueTexts(miscUtil_getValue(selectedValue, 0), sharedTextHooksProps),
      _useValueTexts2 = slicedToArray_slicedToArray(_useValueTexts, 2),
      startValueTexts = _useValueTexts2[0],
      firstStartValueText = _useValueTexts2[1];

  var _useValueTexts3 = useValueTexts(miscUtil_getValue(selectedValue, 1), sharedTextHooksProps),
      _useValueTexts4 = slicedToArray_slicedToArray(_useValueTexts3, 2),
      endValueTexts = _useValueTexts4[0],
      firstEndValueText = _useValueTexts4[1];

  var _onTextChange = function onTextChange(newText, index) {
    var inputDate = parseValue(newText, {
      locale: locale,
      formatList: formatList,
      generateConfig: generateConfig
    });
    var disabledFunc = index === 0 ? disabledStartDate : disabledEndDate;

    if (inputDate && !disabledFunc(inputDate)) {
      setSelectedValue(updateValues(selectedValue, inputDate, index));
      setViewDate(inputDate, index);
    }
  };

  var _useTextValueMapping = useTextValueMapping({
    valueTexts: startValueTexts,
    onTextChange: function onTextChange(newText) {
      return _onTextChange(newText, 0);
    }
  }),
      _useTextValueMapping2 = slicedToArray_slicedToArray(_useTextValueMapping, 3),
      startText = _useTextValueMapping2[0],
      triggerStartTextChange = _useTextValueMapping2[1],
      resetStartText = _useTextValueMapping2[2];

  var _useTextValueMapping3 = useTextValueMapping({
    valueTexts: endValueTexts,
    onTextChange: function onTextChange(newText) {
      return _onTextChange(newText, 1);
    }
  }),
      _useTextValueMapping4 = slicedToArray_slicedToArray(_useTextValueMapping3, 3),
      endText = _useTextValueMapping4[0],
      triggerEndTextChange = _useTextValueMapping4[1],
      resetEndText = _useTextValueMapping4[2];

  var _useState3 = Object(react["useState"])(null),
      _useState4 = slicedToArray_slicedToArray(_useState3, 2),
      rangeHoverValue = _useState4[0],
      setRangeHoverValue = _useState4[1]; // ========================== Hover Range ==========================


  var _useState5 = Object(react["useState"])(null),
      _useState6 = slicedToArray_slicedToArray(_useState5, 2),
      hoverRangedValue = _useState6[0],
      setHoverRangedValue = _useState6[1];

  var _useHoverValue = useHoverValue(startText, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useHoverValue2 = slicedToArray_slicedToArray(_useHoverValue, 3),
      startHoverValue = _useHoverValue2[0],
      onStartEnter = _useHoverValue2[1],
      onStartLeave = _useHoverValue2[2];

  var _useHoverValue3 = useHoverValue(endText, {
    formatList: formatList,
    generateConfig: generateConfig,
    locale: locale
  }),
      _useHoverValue4 = slicedToArray_slicedToArray(_useHoverValue3, 3),
      endHoverValue = _useHoverValue4[0],
      onEndEnter = _useHoverValue4[1],
      onEndLeave = _useHoverValue4[2];

  var onDateMouseEnter = function onDateMouseEnter(date) {
    setHoverRangedValue(updateValues(selectedValue, date, mergedActivePickerIndex));

    if (mergedActivePickerIndex === 0) {
      onStartEnter(date);
    } else {
      onEndEnter(date);
    }
  };

  var onDateMouseLeave = function onDateMouseLeave() {
    setHoverRangedValue(updateValues(selectedValue, null, mergedActivePickerIndex));

    if (mergedActivePickerIndex === 0) {
      onStartLeave();
    } else {
      onEndLeave();
    }
  }; // ============================= Input =============================


  var getSharedInputHookProps = function getSharedInputHookProps(index, resetText) {
    return {
      blurToCancel: needConfirmButton,
      forwardKeyDown: forwardKeyDown,
      onBlur: onBlur,
      isClickOutside: function isClickOutside(target) {
        return !elementsContains([panelDivRef.current, startInputDivRef.current, endInputDivRef.current, containerRef.current], target);
      },
      onFocus: function onFocus(e) {
        setMergedActivePickerIndex(index);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      triggerOpen: function triggerOpen(newOpen) {
        _triggerOpen(newOpen, index);
      },
      onSubmit: function onSubmit() {
        triggerChange(selectedValue, index);
        resetText();
      },
      onCancel: function onCancel() {
        _triggerOpen(false, index);

        setSelectedValue(mergedValue);
        resetText();
      }
    };
  };

  var _usePickerInput = usePickerInput(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getSharedInputHookProps(0, resetStartText)), {}, {
    open: startOpen,
    value: startText,
    onKeyDown: function onKeyDown(e, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e, preventDefault);
    }
  })),
      _usePickerInput2 = slicedToArray_slicedToArray(_usePickerInput, 2),
      startInputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      startFocused = _usePickerInput2$.focused,
      startTyping = _usePickerInput2$.typing;

  var _usePickerInput3 = usePickerInput(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, getSharedInputHookProps(1, resetEndText)), {}, {
    open: endOpen,
    value: endText,
    onKeyDown: function onKeyDown(e, preventDefault) {
      _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e, preventDefault);
    }
  })),
      _usePickerInput4 = slicedToArray_slicedToArray(_usePickerInput3, 2),
      endInputProps = _usePickerInput4[0],
      _usePickerInput4$ = _usePickerInput4[1],
      endFocused = _usePickerInput4$.focused,
      endTyping = _usePickerInput4$.typing; // ========================== Click Picker ==========================


  var onPickerClick = function onPickerClick(e) {
    // When click inside the picker & outside the picker's input elements
    // the panel should still be opened
    if (!mergedOpen && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
      if (!mergedDisabled[0]) {
        triggerOpenAndFocus(0);
      } else if (!mergedDisabled[1]) {
        triggerOpenAndFocus(1);
      }
    }
  };

  var onPickerMouseDown = function onPickerMouseDown(e) {
    // shouldn't affect input elements if picker is active
    if (mergedOpen && (startFocused || endFocused) && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
      e.preventDefault();
    }
  }; // ============================= Sync ==============================
  // Close should sync back with text value


  var startStr = mergedValue && mergedValue[0] ? formatValue(mergedValue[0], {
    locale: locale,
    format: 'YYYYMMDDHHmmss',
    generateConfig: generateConfig
  }) : '';
  var endStr = mergedValue && mergedValue[1] ? formatValue(mergedValue[1], {
    locale: locale,
    format: 'YYYYMMDDHHmmss',
    generateConfig: generateConfig
  }) : '';
  Object(react["useEffect"])(function () {
    if (!mergedOpen) {
      setSelectedValue(mergedValue);

      if (!startValueTexts.length || startValueTexts[0] === '') {
        triggerStartTextChange('');
      } else if (firstStartValueText !== startText) {
        resetStartText();
      }

      if (!endValueTexts.length || endValueTexts[0] === '') {
        triggerEndTextChange('');
      } else if (firstEndValueText !== endText) {
        resetEndText();
      }
    }
  }, [mergedOpen, startValueTexts, endValueTexts]); // Sync innerValue with control mode

  Object(react["useEffect"])(function () {
    setSelectedValue(mergedValue);
  }, [startStr, endStr]); // ============================ Warning ============================

  if (false) {} // ============================ Private ============================


  if (pickerRef) {
    pickerRef.current = {
      focus: function focus() {
        if (startInputRef.current) {
          startInputRef.current.focus();
        }
      },
      blur: function blur() {
        if (startInputRef.current) {
          startInputRef.current.blur();
        }

        if (endInputRef.current) {
          endInputRef.current.blur();
        }
      }
    };
  } // ============================ Ranges =============================


  var rangeLabels = Object.keys(ranges || {});
  var rangeList = rangeLabels.map(function (label) {
    var range = ranges[label];
    var newValues = typeof range === 'function' ? range() : range;
    return {
      label: label,
      onClick: function onClick() {
        triggerChange(newValues, null);

        _triggerOpen(false, mergedActivePickerIndex);
      },
      onMouseEnter: function onMouseEnter() {
        setRangeHoverValue(newValues);
      },
      onMouseLeave: function onMouseLeave() {
        setRangeHoverValue(null);
      }
    };
  }); // ============================= Panel =============================

  function renderPanel() {
    var panelPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var panelProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var panelHoverRangedValue = null;

    if (mergedOpen && hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1] && generateConfig.isAfter(hoverRangedValue[1], hoverRangedValue[0])) {
      panelHoverRangedValue = hoverRangedValue;
    }

    var panelShowTime = showTime;

    if (showTime && typeof_typeof(showTime) === 'object' && showTime.defaultValue) {
      var timeDefaultValues = showTime.defaultValue;
      panelShowTime = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, showTime), {}, {
        defaultValue: miscUtil_getValue(timeDefaultValues, mergedActivePickerIndex) || undefined
      });
    }

    var panelDateRender = null;

    if (dateRender) {
      panelDateRender = function panelDateRender(date, today) {
        return dateRender(date, today, {
          range: mergedActivePickerIndex ? 'end' : 'start'
        });
      };
    }

    return /*#__PURE__*/react["createElement"](es_RangeContext.Provider, {
      value: {
        inRange: true,
        panelPosition: panelPosition,
        rangedValue: rangeHoverValue || selectedValue,
        hoverRangedValue: panelHoverRangedValue
      }
    }, /*#__PURE__*/react["createElement"](es_PickerPanel, extends_extends({}, props, panelProps, {
      dateRender: panelDateRender,
      showTime: panelShowTime,
      mode: mergedModes[mergedActivePickerIndex],
      generateConfig: generateConfig,
      style: undefined,
      direction: direction,
      disabledDate: mergedActivePickerIndex === 0 ? disabledStartDate : disabledEndDate,
      disabledTime: function disabledTime(date) {
        if (_disabledTime) {
          return _disabledTime(date, mergedActivePickerIndex === 0 ? 'start' : 'end');
        }

        return false;
      },
      className: node_modules_classnames_default()(defineProperty_defineProperty({}, "".concat(prefixCls, "-panel-focused"), mergedActivePickerIndex === 0 ? !startTyping : !endTyping)),
      value: miscUtil_getValue(selectedValue, mergedActivePickerIndex),
      locale: locale,
      tabIndex: -1,
      onPanelChange: function onPanelChange(date, newMode) {
        // clear hover value when panel change
        if (mergedActivePickerIndex === 0) {
          onStartLeave(true);
        }

        if (mergedActivePickerIndex === 1) {
          onEndLeave(true);
        }

        triggerModesChange(updateValues(mergedModes, newMode, mergedActivePickerIndex), updateValues(selectedValue, date, mergedActivePickerIndex));
        var viewDate = date;

        if (panelPosition === 'right' && mergedModes[mergedActivePickerIndex] === newMode) {
          viewDate = getClosingViewDate(viewDate, newMode, generateConfig, -1);
        }

        setViewDate(viewDate, mergedActivePickerIndex);
      },
      onOk: null,
      onSelect: undefined,
      onChange: undefined,
      defaultValue: mergedActivePickerIndex === 0 ? miscUtil_getValue(selectedValue, 1) : miscUtil_getValue(selectedValue, 0),
      defaultPickerValue: undefined
    })));
  }

  var arrowLeft = 0;
  var panelLeft = 0;

  if (mergedActivePickerIndex && startInputDivRef.current && separatorRef.current && panelDivRef.current) {
    // Arrow offset
    arrowLeft = startInputDivRef.current.offsetWidth + separatorRef.current.offsetWidth;

    if (panelDivRef.current.offsetWidth && arrowLeft > panelDivRef.current.offsetWidth) {
      panelLeft = arrowLeft;
    }
  }

  var arrowPositionStyle = direction === 'rtl' ? {
    right: arrowLeft
  } : {
    left: arrowLeft
  };

  function renderPanels() {
    var panels;
    var extraNode = getExtraFooter(prefixCls, mergedModes[mergedActivePickerIndex], renderExtraFooter);
    var rangesNode = getRanges({
      prefixCls: prefixCls,
      components: components,
      needConfirmButton: needConfirmButton,
      okDisabled: !miscUtil_getValue(selectedValue, mergedActivePickerIndex) || disabledDate && disabledDate(selectedValue[mergedActivePickerIndex]),
      locale: locale,
      rangeList: rangeList,
      onOk: function onOk() {
        if (miscUtil_getValue(selectedValue, mergedActivePickerIndex)) {
          // triggerChangeOld(selectedValue);
          triggerChange(selectedValue, mergedActivePickerIndex);

          if (_onOk) {
            _onOk(selectedValue);
          }
        }
      }
    });

    if (picker !== 'time' && !showTime) {
      var viewDate = getViewDate(mergedActivePickerIndex);
      var nextViewDate = getClosingViewDate(viewDate, picker, generateConfig);
      var currentMode = mergedModes[mergedActivePickerIndex];
      var showDoublePanel = currentMode === picker;
      var leftPanel = renderPanel(showDoublePanel ? 'left' : false, {
        pickerValue: viewDate,
        onPickerValueChange: function onPickerValueChange(newViewDate) {
          setViewDate(newViewDate, mergedActivePickerIndex);
        }
      });
      var rightPanel = renderPanel('right', {
        pickerValue: nextViewDate,
        onPickerValueChange: function onPickerValueChange(newViewDate) {
          setViewDate(getClosingViewDate(newViewDate, picker, generateConfig, -1), mergedActivePickerIndex);
        }
      });

      if (direction === 'rtl') {
        panels = /*#__PURE__*/react["createElement"](react["Fragment"], null, rightPanel, showDoublePanel && leftPanel);
      } else {
        panels = /*#__PURE__*/react["createElement"](react["Fragment"], null, leftPanel, showDoublePanel && rightPanel);
      }
    } else {
      panels = renderPanel();
    }

    var mergedNodes = /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["createElement"]("div", {
      className: "".concat(prefixCls, "-panels")
    }, panels), (extraNode || rangesNode) && /*#__PURE__*/react["createElement"]("div", {
      className: "".concat(prefixCls, "-footer")
    }, extraNode, rangesNode));

    if (panelRender) {
      mergedNodes = panelRender(mergedNodes);
    }

    return /*#__PURE__*/react["createElement"]("div", {
      className: "".concat(prefixCls, "-panel-container"),
      style: {
        marginLeft: panelLeft
      },
      ref: panelDivRef,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      }
    }, mergedNodes);
  }

  var rangePanel = /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper")),
    style: {
      minWidth: popupMinWidth
    }
  }, /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-range-arrow"),
    style: arrowPositionStyle
  }), renderPanels()); // ============================= Icons =============================

  var suffixNode;

  if (suffixIcon) {
    suffixNode = /*#__PURE__*/react["createElement"]("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
  }

  var clearNode;

  if (allowClear && (miscUtil_getValue(mergedValue, 0) && !mergedDisabled[0] || miscUtil_getValue(mergedValue, 1) && !mergedDisabled[1])) {
    clearNode = /*#__PURE__*/react["createElement"]("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        var values = mergedValue;

        if (!mergedDisabled[0]) {
          values = updateValues(values, null, 0);
        }

        if (!mergedDisabled[1]) {
          values = updateValues(values, null, 1);
        }

        triggerChange(values, null);

        _triggerOpen(false, mergedActivePickerIndex);
      },
      className: "".concat(prefixCls, "-clear")
    }, clearIcon || /*#__PURE__*/react["createElement"]("span", {
      className: "".concat(prefixCls, "-clear-btn")
    }));
  }

  var inputSharedProps = {
    size: getInputSize(picker, formatList[0], generateConfig)
  };
  var activeBarLeft = 0;
  var activeBarWidth = 0;

  if (startInputDivRef.current && endInputDivRef.current && separatorRef.current) {
    if (mergedActivePickerIndex === 0) {
      activeBarWidth = startInputDivRef.current.offsetWidth;
    } else {
      activeBarLeft = arrowLeft;
      activeBarWidth = endInputDivRef.current.offsetWidth;
    }
  }

  var activeBarPositionStyle = direction === 'rtl' ? {
    right: activeBarLeft
  } : {
    left: activeBarLeft
  }; // ============================ Return =============================

  var onContextSelect = function onContextSelect(date, type) {
    var values = updateValues(selectedValue, date, mergedActivePickerIndex);

    if (type === 'submit' || type !== 'key' && !needConfirmButton) {
      // triggerChange will also update selected values
      triggerChange(values, mergedActivePickerIndex); // clear hover value style

      if (mergedActivePickerIndex === 0) {
        onStartLeave();
      } else {
        onEndLeave();
      }
    } else {
      setSelectedValue(values);
    }
  };

  return /*#__PURE__*/react["createElement"](es_PanelContext.Provider, {
    value: {
      operationRef: operationRef,
      hideHeader: picker === 'time',
      onDateMouseEnter: onDateMouseEnter,
      onDateMouseLeave: onDateMouseLeave,
      hideRanges: true,
      onSelect: onContextSelect,
      open: mergedOpen
    }
  }, /*#__PURE__*/react["createElement"](es_PickerTrigger, {
    visible: mergedOpen,
    popupElement: rangePanel,
    popupStyle: popupStyle,
    prefixCls: prefixCls,
    dropdownClassName: dropdownClassName,
    dropdownAlign: dropdownAlign,
    getPopupContainer: getPopupContainer,
    transitionName: transitionName,
    range: true,
    direction: direction
  }, /*#__PURE__*/react["createElement"]("div", extends_extends({
    ref: containerRef,
    className: node_modules_classnames_default()(prefixCls, "".concat(prefixCls, "-range"), className, (_classNames2 = {}, defineProperty_defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), mergedDisabled[0] && mergedDisabled[1]), defineProperty_defineProperty(_classNames2, "".concat(prefixCls, "-focused"), mergedActivePickerIndex === 0 ? startFocused : endFocused), defineProperty_defineProperty(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
    style: style,
    onClick: onPickerClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseDown: onPickerMouseDown
  }, getDataOrAriaProps(props)), /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()("".concat(prefixCls, "-input"), (_classNames3 = {}, defineProperty_defineProperty(_classNames3, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 0), defineProperty_defineProperty(_classNames3, "".concat(prefixCls, "-input-placeholder"), !!startHoverValue), _classNames3)),
    ref: startInputDivRef
  }, /*#__PURE__*/react["createElement"]("input", extends_extends({
    id: id,
    disabled: mergedDisabled[0],
    readOnly: inputReadOnly || typeof formatList[0] === 'function' || !startTyping,
    value: startHoverValue || startText,
    onChange: function onChange(e) {
      triggerStartTextChange(e.target.value);
    },
    autoFocus: autoFocus,
    placeholder: miscUtil_getValue(placeholder, 0) || '',
    ref: startInputRef
  }, startInputProps, inputSharedProps, {
    autoComplete: autoComplete
  }))), /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-range-separator"),
    ref: separatorRef
  }, separator), /*#__PURE__*/react["createElement"]("div", {
    className: node_modules_classnames_default()("".concat(prefixCls, "-input"), (_classNames4 = {}, defineProperty_defineProperty(_classNames4, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 1), defineProperty_defineProperty(_classNames4, "".concat(prefixCls, "-input-placeholder"), !!endHoverValue), _classNames4)),
    ref: endInputDivRef
  }, /*#__PURE__*/react["createElement"]("input", extends_extends({
    disabled: mergedDisabled[1],
    readOnly: inputReadOnly || typeof formatList[0] === 'function' || !endTyping,
    value: endHoverValue || endText,
    onChange: function onChange(e) {
      triggerEndTextChange(e.target.value);
    },
    placeholder: miscUtil_getValue(placeholder, 1) || '',
    ref: endInputRef
  }, endInputProps, inputSharedProps, {
    autoComplete: autoComplete
  }))), /*#__PURE__*/react["createElement"]("div", {
    className: "".concat(prefixCls, "-active-bar"),
    style: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, activeBarPositionStyle), {}, {
      width: activeBarWidth,
      position: 'absolute'
    })
  }), suffixNode, clearNode)));
} // Wrap with class component to enable pass generic with instance method


var RangePicker_RangePicker = /*#__PURE__*/function (_React$Component) {
  inherits_inherits(RangePicker, _React$Component);

  var _super = createSuper_createSuper(RangePicker);

  function RangePicker() {
    var _this;

    classCallCheck_classCallCheck(this, RangePicker);

    _this = _super.apply(this, arguments);
    _this.pickerRef = /*#__PURE__*/react["createRef"]();

    _this.focus = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.focus();
      }
    };

    _this.blur = function () {
      if (_this.pickerRef.current) {
        _this.pickerRef.current.blur();
      }
    };

    return _this;
  }

  createClass_createClass(RangePicker, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/react["createElement"](InnerRangePicker, extends_extends({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]);

  return RangePicker;
}(react["Component"]);

/* harmony default export */ var es_RangePicker = (RangePicker_RangePicker);
// CONCATENATED MODULE: ./node_modules/rc-picker/es/index.js




/* harmony default export */ var rc_picker_es = (es_Picker);
// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/time-extension/index.js









/**
 * 统一样式前缀
 */ var time_extension_CLASSNAME_PREFIX = "ct";

function time_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function time_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return time_extension_arrayLikeToArray(arr);
}
function time_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function time_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function time_extension_toConsumableArray(arr) {
    return time_extension_arrayWithoutHoles(arr) || time_extension_iterableToArray(arr) || time_extension_unsupportedIterableToArray(arr) || time_extension_nonIterableSpread();
}
function time_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return time_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return time_extension_arrayLikeToArray(o, minLen);
}
var time_extension_noop = function() {};
var time_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : time_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var time_extension_execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : time_extension_noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, time_extension_toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

function time_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function time_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            time_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// 类型是否可以插入富文本
var time_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};
/*
 * 更新指定位置的节点属性
 * @param type 节点类型
 * @param data 属性数据
 * @param pos 节点位置
 * @param view EditorView 实例
 */ var time_extension_updateNodeAttrs = function(param) {
    var type = param.type, data = param.data, pos = param.pos, view = param.view;
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr;
    var ctrlNode = tr.doc.nodeAt(pos);
    if (!ctrlNode) {
        return;
    }
    var attrs = time_extension_objectSpread({}, ctrlNode.attrs, data);
    tr.setNodeMarkup(pos, type, attrs);
    dispatch(tr);
};

// 一个支持parseInt解析（time的schema需要）的随机字符串
var selectKey = "".concat(Math.random()).substr(Math.round(Math.random() * 10) + 2);
/**
 * rc-picker需要
 */ var time_extension_generateConfig = {
    // get
    getNow: function() {
        return moment_default()();
    },
    getFixedDate: function(string) {
        return moment_default()(string, "YYYY-MM-DD");
    },
    getEndDate: function(date) {
        var clone = date.clone();
        return clone.endOf("month");
    },
    getWeekDay: function(date) {
        var clone = date.clone().locale("en_US");
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: function(date) {
        return date.year();
    },
    getMonth: function(date) {
        return date.month();
    },
    getDate: function(date) {
        return date.date();
    },
    getHour: function(date) {
        return date.hour();
    },
    getMinute: function(date) {
        return date.minute();
    },
    getSecond: function(date) {
        return date.second();
    },
    // set
    addYear: function(date, diff) {
        var clone = date.clone();
        return clone.add(diff, "year");
    },
    addMonth: function(date, diff) {
        var clone = date.clone();
        return clone.add(diff, "month");
    },
    addDate: function(date, diff) {
        var clone = date.clone();
        return clone.add(diff, "day");
    },
    setYear: function(date, year) {
        var clone = date.clone();
        return clone.year(year);
    },
    setMonth: function(date, month) {
        var clone = date.clone();
        return clone.month(month);
    },
    setDate: function(date, num) {
        var clone = date.clone();
        return clone.date(num);
    },
    setHour: function(date, hour) {
        var clone = date.clone();
        return clone.hour(hour);
    },
    setMinute: function(date, minute) {
        var clone = date.clone();
        return clone.minute(minute);
    },
    setSecond: function(date, second) {
        var clone = date.clone();
        return clone.second(second);
    },
    // Compare
    isAfter: function(date1, date2) {
        return date1.isAfter(date2);
    },
    isValidate: function(date) {
        return date.isValid();
    },
    locale: {
        getWeekFirstDay: function(locale) {
            var date = moment_default()().locale(locale);
            return date.localeData().firstDayOfWeek();
        },
        getWeekFirstDate: function(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.weekday(0);
        },
        getWeek: function(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.week();
        },
        getShortWeekDays: function(locale) {
            var date = moment_default()().locale(locale);
            return date.localeData().weekdaysMin();
        },
        getShortMonths: function(locale) {
            var date = moment_default()().locale(locale);
            return date.localeData().monthsShort();
        },
        format: function(locale, date, format) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.format(format);
        },
        parse: function(locale, text, formats) {
            var fallbackFormatList = [];
            for(var i = 0; i < formats.length; i += 1){
                var format = formats[i];
                var formatText = text;
                if (format.includes("wo") || format.includes("Wo")) {
                    format = format.replace(/wo/g, "w").replace(/Wo/g, "W");
                    var matchFormat = format.match(/[-YyMmDdHhSsWwGg]+/g);
                    var matchText = formatText.match(/[-\d]+/g);
                    if (matchFormat && matchText) {
                        format = matchFormat.join("");
                        formatText = matchText.join("");
                    } else {
                        fallbackFormatList.push(format.replace(/o/g, ""));
                    }
                }
                var date = moment_default()(formatText, format, locale, true);
                if (date.isValid()) {
                    return date;
                }
            }
            // Fallback to fuzzy matching, this should always not reach match or need fire a issue
            for(var i1 = 0; i1 < fallbackFormatList.length; i1 += 1){
                var date1 = moment_default()(text, fallbackFormatList[i1], locale, false);
                /* istanbul ignore next */ if (date1.isValid()) {
                    // noteOnce(
                    //   false,
                    //   "Not match any format strictly and fallback to fuzzy match. Please help to fire a issue about this."
                    // );
                    return date1;
                }
            }
            return null;
        }
    }
};

function insertTime() {
    return function(state, dispatch, view) {
        var tr = state.tr, schema = state.schema, selection = state.selection;
        var from = selection.from;
        var time = schema.nodes.time;
        if (!time_extension_canInsertTypes(state)) return false;
        var date = +new Date();
        var node = time.create({
            selectKey: selectKey,
            date: "".concat(date)
        });
        tr.replaceSelectionWith(node);
        var newSelection = prosemirror_state_dist["NodeSelection"].create(tr.doc, from);
        tr.setSelection(newSelection);
        dispatch(tr.scrollIntoView());
        return true;
    };
}
var updateTime = function(pos, newAttrs, view) {
    // 更新属性
    var schema = view.state.schema;
    time_extension_updateNodeAttrs({
        type: schema.nodes.time,
        data: newAttrs,
        pos: pos,
        view: view
    });
    // 更新选区
    var tr = view.state.tr, dispatch = view.dispatch;
    var selection = tr.selection;
    var to = selection.to;
    var newSelection = prosemirror_state_dist["TextSelection"].create(tr.doc, to);
    tr.setSelection(newSelection);
    dispatch(tr.scrollIntoView());
    view.focus();
};

var time_extension_convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

var time_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(time_extension_ExtensionType || (time_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var time_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var time_extension_AFTER_INSERT = "after_insert";

var time_extension_IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var time_extension_Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(time_extension_Keycodes || (time_extension_Keycodes = {}));

function time_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var time_extension_css_248z = '.rc-picker{display:inline-flex}.rc-picker-rtl{direction:rtl}.rc-picker-focused{border:1px solid #00f}.rc-picker-panel{border:1px solid #666;background:#fff0ff;display:inline-block;vertical-align:top}.rc-picker-panel-focused{border-color:#00f}.rc-picker-panel-rtl{direction:rtl}.rc-picker-date-panel,.rc-picker-decade-panel,.rc-picker-month-panel,.rc-picker-time-panel,.rc-picker-week-panel,.rc-picker-year-panel{display:flex;flex-direction:column}.rc-picker-date-panel table,.rc-picker-decade-panel table,.rc-picker-month-panel table,.rc-picker-time-panel table,.rc-picker-week-panel table,.rc-picker-year-panel table{text-align:center;border-collapse:collapse}.rc-picker-header{display:flex}.rc-picker-header>*{flex:none}.rc-picker-header-view{flex:auto;text-align:center}.rc-picker-header-view>button{border:0;padding:0}.rc-picker-cell{color:#aaa}.rc-picker-cell-disabled{opacity:.2}.rc-picker-cell-inner{font-size:12px;width:100%;height:20px;line-height:20px;display:inline-block;box-sizing:border-box;padding:0;margin:0;background:transparent;cursor:pointer;outline:none;border:none;transition:background .3s,border .3s}.rc-picker-cell-inner:hover{background:rgba(0,0,255,.3)!important}.rc-picker-cell-in-view{color:#333}.rc-picker-cell-in-range>.rc-picker-cell-inner{background:rgba(0,0,255,.05)}.rc-picker-cell-range-hover,.rc-picker-cell-range-hover-end,.rc-picker-cell-range-hover-start{position:relative}.rc-picker-cell-range-hover-end:after,.rc-picker-cell-range-hover-start:after,.rc-picker-cell-range-hover:after{content:"";position:absolute;top:3px;bottom:0;left:0;right:0;border:1px solid green;border-left:0;border-right:0;pointer-events:none}.rc-picker-cell-range-hover-start:after{border-left:1px solid green!important}.rc-picker-cell-range-hover-end:after{border-right:1px solid green!important}.rc-picker-cell-today>.rc-picker-cell-inner{border:1px solid #00f}.rc-picker-cell-range-end>.rc-picker-cell-inner,.rc-picker-cell-range-start>.rc-picker-cell-inner,.rc-picker-cell-selected>.rc-picker-cell-inner{background:rgba(0,0,255,.2)}.rc-picker-footer,.rc-picker-picker-footer{background:green}.rc-picker-ranges{margin:0;padding:0;overflow:hidden;list-style:none}.rc-picker-ranges>li{display:inline-block}.rc-picker-ok{float:right}.rc-picker-month-panel .rc-picker-cell-inner,.rc-picker-year-panel .rc-picker-cell-inner{width:80px}.rc-picker-week-panel-row:hover .rc-picker-cell{background:red}.rc-picker-week-panel-row-selected .rc-picker-cell{background:rgba(0,0,255,.3)}.rc-picker-week-panel .rc-picker-cell,.rc-picker-week-panel .rc-picker-cell-inner{width:20px}.rc-picker-week-panel .rc-picker-cell-week{font-size:12px;color:#999;font-weight:700}.rc-picker-week-panel .rc-picker-cell-selected>.rc-picker-cell-inner,.rc-picker-week-panel .rc-picker-cell:hover>.rc-picker-cell-inner{background:transparent}.rc-picker-date-panel .rc-picker-cell-inner{width:20px}.rc-picker-time-panel{width:auto}.rc-picker-time-panel .rc-picker-content{display:flex;max-height:200px}.rc-picker-time-panel-column{flex:none;text-align:left;list-style:none;margin:0;padding:0 0 180px;overflow-y:hidden;overflow-x:hidden;width:50px;transition:background .3s;font-size:12px}.rc-picker-time-panel-column-active{background:rgba(0,0,255,.1)}.rc-picker-time-panel-column:hover{overflow-y:auto}.rc-picker-time-panel-column>li{padding:0;margin:0;cursor:pointer}.rc-picker-time-panel-column>li .rc-picker-time-panel-cell-inner{color:#333;padding:0 0 0 12px;margin:0;height:20px;line-height:20px;display:block;width:100%;text-align:left}.rc-picker-panel-rtl .rc-picker-time-panel-column>li .rc-picker-time-panel-cell-inner{padding:0 12px 0 0;text-align:right}.rc-picker-datetime-panel{display:flex}.rc-picker-datetime-panel .rc-picker-time-panel{border-left:1px solid #999}.rc-picker-datetime-panel .rc-picker-date-panel,.rc-picker-datetime-panel .rc-picker-time-panel{transition:opacity .3s}.rc-picker-datetime-panel-active .rc-picker-date-panel,.rc-picker-datetime-panel-active .rc-picker-time-panel{opacity:.3}.rc-picker-datetime-panel-active .rc-picker-date-panel-active,.rc-picker-datetime-panel-active .rc-picker-time-panel-active{opacity:1}.rc-picker-input{position:relative;display:inline-flex;width:100%}.rc-picker-rtl .rc-picker-input{text-align:right}.rc-picker-input>input{width:100%}.rc-picker-input>input::-moz-placeholder{opacity:1}.rc-picker-input>input:-ms-input-placeholder{color:#bfbfbf}.rc-picker-input > input::-moz-placeholder{color:#bfbfbf}.rc-picker-input > input:-ms-input-placeholder{color:#bfbfbf}.rc-picker-input>input::placeholder{color:#bfbfbf}.rc-picker-input>input:placeholder-shown{text-overflow:ellipsis}.rc-picker-input-placeholder>input{color:#bfbfbf}.rc-picker-clear{position:absolute;right:4px;top:0;cursor:pointer}.rc-picker-rtl .rc-picker-clear{right:auto;left:4px}.rc-picker-clear-btn:after{content:"\xd7"}.rc-picker-dropdown{position:absolute;box-shadow:0 0 1px red}.rc-picker-dropdown-range{padding:10px 0}.rc-picker-dropdown-hidden{display:none}.rc-picker-dropdown-placement-topLeft .rc-picker-range-arrow,.rc-picker-dropdown-placement-topRight .rc-picker-range-arrow{bottom:6px;transform:rotate(135deg)}.rc-picker-dropdown-placement-bottomLeft .rc-picker-range-arrow,.rc-picker-dropdown-placement-bottomright .rc-picker-range-arrow{top:6px;transform:rotate(-45deg)}.rc-picker-dropdown .rc-picker-range-arrow{position:absolute;width:10px;height:10px;z-index:1;left:10px;margin-left:10px;transition:all .3s}.rc-picker-dropdown-rtl.rc-picker-dropdown .rc-picker-range-arrow{right:10px;left:auto;margin-left:0;margin-right:10px}.rc-picker-dropdown .rc-picker-range-arrow:after,.rc-picker-dropdown .rc-picker-range-arrow:before{content:"";position:absolute;box-sizing:border-box;top:50%;left:50%;transform:translate(-50%,-50%)}.rc-picker-dropdown-rtl.rc-picker-dropdown .rc-picker-range-arrow:after,.rc-picker-dropdown-rtl.rc-picker-dropdown .rc-picker-range-arrow:before{right:50%;left:auto;transform:translate(50%,-50%)}.rc-picker-dropdown .rc-picker-range-arrow:before{width:10px;height:10px;border-color:#00f #00f transparent transparent;border-style:solid;border-width:5px}.rc-picker-dropdown .rc-picker-range-arrow:after{width:8px;height:8px;border-color:#fff0ff #fff0ff transparent transparent;border-style:solid;border-width:4px}.rc-picker-range{display:inline-flex;position:relative}.rc-picker-range-wrapper{display:flex}.rc-picker-range .rc-picker-active-bar{background:green;bottom:0;height:3px;pointer-events:none;transition:all .3s;opacity:0}.rc-picker-range.rc-picker-focused .rc-picker-active-bar{opacity:1}.rc-picker-panel-container{display:inline-block;vertical-align:top;transition:margin .3s}';
time_extension_styleInject(time_extension_css_248z);

var time_extension_img = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3csvg xmlns='http://www.w3.org/2000/svg' width='14px' height='14px' class='icon' fill='rgba(0%2c0%2c0%2c0.25)' viewBox='0 0 1024 1024'%3e %3cpath d='M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z' /%3e%3c/svg%3e";

var time_extension_img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3csvg xmlns='http://www.w3.org/2000/svg' width='14px' height='14px' fill='rgba(0%2c0%2c0%2c0.25)' class='icon' viewBox='0 0 1024 1024'%3e %3cpath d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z' /%3e%3c/svg%3e";

var time_extension_locale = {
    locale: "zh_CN",
    today: "今天",
    now: "此刻",
    backToToday: "返回今天",
    ok: "确定",
    timeSelect: "选择时间",
    dateSelect: "选择日期",
    weekSelect: "选择周",
    clear: "清除",
    month: "月",
    year: "年",
    previousMonth: "上个月 (翻页上键)",
    nextMonth: "下个月 (翻页下键)",
    monthSelect: "选择月份",
    yearSelect: "选择年份",
    decadeSelect: "选择年代",
    yearFormat: "YYYY年",
    dayFormat: "D日",
    dateFormat: "YYYY年M月D日",
    dateTimeFormat: "YYYY年M月D日 HH时mm分ss秒",
    previousYear: "上一年 (Control键加左方向键)",
    nextYear: "下一年 (Control键加右方向键)",
    previousDecade: "上一年代",
    nextDecade: "下一年代",
    previousCentury: "上一世纪",
    nextCentury: "下一世纪",
    monthFormat: " M 月",
    shortWeekDays: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ]
};

var time_extension_css_248z$1 = '.ant-picker-panel{display:inline-flex;flex-direction:column;text-align:center;background:#141414;border:1px solid #f0f0f0;border-radius:2px;outline:none}.ant-picker-panel-focused{border-color:#1890ff}.ant-picker-date-panel,.ant-picker-decade-panel,.ant-picker-month-panel,.ant-picker-quarter-panel,.ant-picker-time-panel,.ant-picker-week-panel,.ant-picker-year-panel{display:flex;flex-direction:column;width:280px}.ant-picker-header{display:flex;padding:0 8px;color:rgba(0,0,0,.8509803921568627);border-bottom:1px solid #f0f0f0}.ant-picker-header>*{flex:none}.ant-picker-header button{padding:0;color:rgba(0,0,0,.25);line-height:40px;background:transparent;border:0;cursor:pointer;transition:color .3s}.ant-picker-header>button{min-width:1.6em;font-size:14px}.ant-picker-header>button:hover{color:rgba(0,0,0,.65)}.ant-picker-header-view{flex:auto;font-weight:500;line-height:40px}.ant-picker-header-view button{color:inherit;font-weight:inherit}.ant-picker-header-view button:not(:first-child){margin-left:8px}.ant-picker-header-view button:hover{color:#1890ff}.ant-picker-next-icon,.ant-picker-prev-icon,.ant-picker-super-next-icon,.ant-picker-super-prev-icon{position:relative;display:inline-block;width:7px;height:7px}.ant-picker-next-icon:before,.ant-picker-prev-icon:before,.ant-picker-super-next-icon:before,.ant-picker-super-prev-icon:before{position:absolute;top:0;left:0;display:inline-block;width:7px;height:7px;border:0 solid;border-width:1.5px 0 0 1.5px;content:""}.ant-picker-super-next-icon:after,.ant-picker-super-prev-icon:after{position:absolute;top:4px;left:4px;display:inline-block;width:7px;height:7px;border:0 solid;border-width:1.5px 0 0 1.5px;content:""}.ant-picker-prev-icon,.ant-picker-super-prev-icon{transform:rotate(-45deg)}.ant-picker-next-icon,.ant-picker-super-next-icon{transform:rotate(135deg)}.ant-picker-content{width:100%;table-layout:fixed;border-collapse:collapse}.ant-picker-content td,.ant-picker-content th{position:relative;min-width:24px;font-weight:400}.ant-picker-content th{height:30px;color:rgba(0,0,0,.65);line-height:30px}.ant-picker-cell{padding:3px 0;color:rgba(0,0,0,.25);cursor:pointer;font-size:14px}.ant-picker-cell-in-view{color:rgba(0,0,0,.65)}.ant-picker-cell:before{position:absolute;top:50%;right:0;left:0;z-index:1;height:24px;transform:translateY(-50%);content:""}.ant-picker-cell .ant-picker-cell-inner{position:relative;z-index:2;display:inline-block;min-width:24px;height:24px;line-height:24px;border-radius:2px;transition:background .3s,border .3s}.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,.ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner{background:#f5f5f5}.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner:before{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;border:1px solid #1890ff;border-radius:2px;content:""}.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner,.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner{color:#fff;background:#1890ff}.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):before,.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):before{background:#e6f7ff}.ant-picker-cell-in-view.ant-picker-cell-range-start:before{left:50%}.ant-picker-cell-in-view.ant-picker-cell-range-end:before{right:50%}.ant-picker-cell-range-hover-end:after,.ant-picker-cell-range-hover-start:after,.ant-picker-cell-range-hover:after{right:0;left:2px}.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after,.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after{position:absolute;top:0;bottom:0;z-index:-1;background:rgba(24,144,255,.35);content:""}.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after{right:-6px;left:0}.ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after{right:0;left:-6px}.ant-picker-cell-disabled{color:rgba(0,0,0,.25);pointer-events:none}.ant-picker-cell-disabled .ant-picker-cell-inner{background:transparent}.ant-picker-cell-disabled:before{background:rgba(0,0,0,.04)}.ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner:before{border-color:rgba(0,0,0,.25)}.ant-picker-decade-panel .ant-picker-content,.ant-picker-month-panel .ant-picker-content,.ant-picker-quarter-panel .ant-picker-content,.ant-picker-year-panel .ant-picker-content{height:264px}.ant-picker-decade-panel .ant-picker-cell-inner,.ant-picker-month-panel .ant-picker-cell-inner,.ant-picker-quarter-panel .ant-picker-cell-inner,.ant-picker-year-panel .ant-picker-cell-inner{padding:0 8px}.ant-picker-quarter-panel .ant-picker-content{height:56px}.ant-picker-footer{width:-webkit-min-content;width:-moz-min-content;width:min-content;min-width:100%;line-height:38px;text-align:center;border-bottom:1px solid transparent}.ant-picker-panel .ant-picker-footer{border-top:1px solid #f0f0f0}.ant-picker-footer-extra{padding:0 12px;line-height:38px;text-align:left}.ant-picker-footer-extra:not(:last-child){border-bottom:1px solid #f0f0f0}.ant-picker-now{text-align:left}.ant-picker-today-btn{color:#23bdd9}.ant-picker-today-btn:hover{color:#40a9ff}.ant-picker-today-btn:active{color:#096dd9}.ant-picker-today-btn.ant-picker-today-btn-disabled{color:rgba(0,0,0,.25);cursor:not-allowed}.ant-picker-decade-panel .ant-picker-cell-inner{padding:0 4px}.ant-picker-decade-panel .ant-picker-cell:before{display:none}.ant-picker-month-panel .ant-picker-body,.ant-picker-quarter-panel .ant-picker-body,.ant-picker-year-panel .ant-picker-body{padding:0 8px}.ant-picker-month-panel .ant-picker-cell-inner,.ant-picker-quarter-panel .ant-picker-cell-inner,.ant-picker-year-panel .ant-picker-cell-inner{width:60px}.ant-picker-month-panel .ant-picker-cell-range-hover-start:after,.ant-picker-quarter-panel .ant-picker-cell-range-hover-start:after,.ant-picker-year-panel .ant-picker-cell-range-hover-start:after{left:14px;border-left:1px dashed rgba(24,144,255,.2);border-radius:2px 0 0 2px}.ant-picker-month-panel .ant-picker-cell-range-hover-end:after,.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-start:after,.ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-start:after,.ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-start:after,.ant-picker-quarter-panel .ant-picker-cell-range-hover-end:after,.ant-picker-year-panel .ant-picker-cell-range-hover-end:after{right:14px;border-right:1px dashed rgba(24,144,255,.2);border-radius:0 2px 2px 0}.ant-picker-panel-rtl .ant-picker-month-panel .ant-picker-cell-range-hover-end:after,.ant-picker-panel-rtl .ant-picker-quarter-panel .ant-picker-cell-range-hover-end:after,.ant-picker-panel-rtl .ant-picker-year-panel .ant-picker-cell-range-hover-end:after{left:14px;border-left:1px dashed rgba(24,144,255,.2);border-radius:2px 0 0 2px}.ant-picker-date-panel .ant-picker-body{padding:8px 12px}.ant-picker-date-panel .ant-picker-content{width:252px}.ant-picker-date-panel .ant-picker-content th{width:36px}.ant-picker-datetime-panel{display:flex}.ant-picker-datetime-panel .ant-picker-time-panel{border-left:1px solid #f0f0f0}.ant-picker-datetime-panel .ant-picker-date-panel,.ant-picker-datetime-panel .ant-picker-time-panel{transition:opacity .3s}.ant-picker-datetime-panel-active .ant-picker-date-panel,.ant-picker-datetime-panel-active .ant-picker-time-panel{opacity:.3}.ant-picker-datetime-panel-active .ant-picker-date-panel-active,.ant-picker-datetime-panel-active .ant-picker-time-panel-active{opacity:1}.ant-picker-time-panel{width:auto;min-width:auto}.ant-picker-time-panel .ant-picker-content{display:flex;flex:auto;height:224px}.ant-picker-time-panel-column{flex:1 0 auto;width:55px;height:226px;margin:0;padding:0;overflow-y:hidden;text-align:left;list-style:none;transition:background .3s}.ant-picker-time-panel-column:after{display:block;height:196px;content:""}.ant-picker-datetime-panel .ant-picker-time-panel-column:after{height:198px}.ant-picker-time-panel-column:not(:first-child){border-left:1px solid #f0f0f0}.ant-picker-time-panel-column-active{background:rgba(230,247,255,.2)}.ant-picker-time-panel-column:hover{overflow-y:auto}.ant-picker-time-panel-column>li{margin:0;padding:0}.ant-picker-time-panel-column>li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner{display:block;width:100%;height:28px;margin:0;padding:0 0 0 14px;color:rgba(0,0,0,.65);line-height:28px;border-radius:0;cursor:pointer;transition:background .3s}.ant-picker-time-panel-column>li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover{background:#f5f5f5}.ant-picker-time-panel-column>li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner{background:#e6f7ff}.ant-picker-time-panel-column>li.ant-picker-time-panel-cell-disabled .ant-picker-time-panel-cell-inner{color:rgba(0,0,0,.25);background:transparent;cursor:not-allowed}:root .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell,:root .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell,_:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-month-panel .ant-picker-cell,_:-ms-fullscreen .ant-picker-range-wrapper .ant-picker-year-panel .ant-picker-cell{padding:21px 0}.datepicker-view{padding:0 3px}.datepicker-view .date{width:115px}.datepicker-view .date .ant-picker-input:hover .ant-picker-clear{display:none;cursor:inherit}.datepicker-view .time{width:165px}.datepicker-view :hover{cursor:pointer}.ant-picker-footer-extra{color:#1890ff;text-decoration:none;background-color:transparent;outline:none;cursor:pointer;transition:color .3s;-webkit-text-decoration-skip:objects}.ant-picker-footer-extra:hover{color:#40a9ff}.ProseMirror-selectednode .ant-picker{border:1px solid #1c6cdc}."ant"-dropdown{padding:0;color:rgba(0,0,0,.8509803921568627);position:absolute;z-index:1050}."ant"-dropdown,.ant-picker{box-sizing:border-box;margin:0;font-size:14px;font-variant:tabular-nums;line-height:1.5715;list-style:none;font-feature-settings:"tnum"}.ant-picker{color:rgba(0,0,0,.65);padding:6px 11px;position:relative;display:inline-flex;align-items:center;background:#fff;border:1px solid #d9d9d9;border-radius:2px;transition:border .3s,box-shadow .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ant-picker-focused,.ant-picker:hover{border-color:#1890ff;border-right-width:1px!important}.ant-input-rtl .ant-picker-focused{border-right-width:0;border-left-width:1px!important}.ant-picker.ant-picker-disabled{background:#f5f5f5;border-color:#d9d9d9;cursor:not-allowed}.ant-picker.ant-picker-disabled .ant-picker-suffix{color:rgba(0,0,0,.25)}.ant-picker.ant-picker-borderless{background-color:transparent!important;border-color:transparent!important;box-shadow:none!important}.ant-picker-input{position:relative;display:inline-flex;align-items:center;width:100%}.ant-picker-input>input{position:relative;display:inline-block;width:100%;min-width:0;color:rgba(0,0,0,.8509803921568627);font-size:12px;line-height:1.5715;background-color:#fff;background-image:none;border-radius:2px;transition:all .3s;flex:auto;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;min-width:1px;height:auto;padding:0;background:transparent;border:0}.ant-picker-input>input:focus{box-shadow:none}.ant-picker-input>input[disabled]{background:transparent}.ant-picker-input:hover .ant-picker-clear{opacity:1}.ant-picker-large{padding:6.5px 11px}.ant-picker-large .ant-picker-input>input{font-size:16px}.ant-picker-small{padding:0 12px}.ant-picker-suffix{align-self:center;margin-left:4px;color:rgba(0,0,0,.25);line-height:1;pointer-events:none}.ant-picker-suffix>*{vertical-align:top}.ant-picker-clear{position:absolute;top:50%;right:0;color:rgba(0,0,0,.25);line-height:1;background:#fff;transform:translateY(-50%);cursor:pointer;opacity:0;transition:opacity .3s,color .3s}.ant-picker-clear>*{vertical-align:top}.ant-picker-clear:hover{color:rgba(0,0,0,.45)}.ant-picker-separator{position:relative;display:inline-block;width:1em;height:16px;color:rgba(0,0,0,.25);font-size:16px;vertical-align:top;cursor:default}.ant-picker-focused .ant-picker-separator{color:rgba(0,0,0,.45)}.ant-picker-disabled .ant-picker-range-separator .ant-picker-separator{cursor:not-allowed}.ant-picker-range{position:relative;display:inline-flex}.ant-picker-range .ant-picker-clear{right:11px}.ant-picker-range:hover .ant-picker-clear{opacity:1}.ant-picker-range .ant-picker-active-bar{bottom:-1px;height:2px;margin-left:11px;background:#1890ff;opacity:0;transition:all .3s ease-out;pointer-events:none}.ant-picker-range.ant-picker-focused .ant-picker-active-bar{opacity:1}.ant-picker-range-separator{align-items:center;padding:0 8px;line-height:1}.ant-picker-range.ant-picker-small .ant-picker-clear{right:12px}.ant-picker-range.ant-picker-small .ant-picker-active-bar{margin-left:12px}.ant-picker-dropdown{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5715;list-style:none;font-feature-settings:"tnum";position:absolute;z-index:900}.ant-picker-dropdown-hidden{display:none}.ant-picker-dropdown-placement-bottomLeft .ant-picker-range-arrow{top:1.66666667px;display:block;transform:rotate(-45deg)}.ant-picker-dropdown-placement-topLeft .ant-picker-range-arrow{bottom:1.66666667px;display:block;transform:rotate(135deg)}.ant-picker-dropdown."ant"-slide-up-appear."ant"-slide-up-appear-active.ant-picker-dropdown-placement-topLeft,.ant-picker-dropdown."ant"-slide-up-appear."ant"-slide-up-appear-active.ant-picker-dropdown-placement-topRight,.ant-picker-dropdown."ant"-slide-up-enter."ant"-slide-up-enter-active.ant-picker-dropdown-placement-topLeft,.ant-picker-dropdown."ant"-slide-up-enter."ant"-slide-up-enter-active.ant-picker-dropdown-placement-topRight{-webkit-animation-name:antSlideDownIn;animation-name:antSlideDownIn}.ant-picker-dropdown."ant"-slide-up-appear."ant"-slide-up-appear-active.ant-picker-dropdown-placement-bottomLeft,.ant-picker-dropdown."ant"-slide-up-appear."ant"-slide-up-appear-active.ant-picker-dropdown-placement-bottomRight,.ant-picker-dropdown."ant"-slide-up-enter."ant"-slide-up-enter-active.ant-picker-dropdown-placement-bottomLeft,.ant-picker-dropdown."ant"-slide-up-enter."ant"-slide-up-enter-active.ant-picker-dropdown-placement-bottomRight{-webkit-animation-name:antSlideUpIn;animation-name:antSlideUpIn}.ant-picker-dropdown."ant"-slide-up-leave."ant"-slide-up-leave-active.ant-picker-dropdown-placement-topLeft,.ant-picker-dropdown."ant"-slide-up-leave."ant"-slide-up-leave-active.ant-picker-dropdown-placement-topRight{-webkit-animation-name:antSlideDownOut;animation-name:antSlideDownOut}.ant-picker-dropdown."ant"-slide-up-leave."ant"-slide-up-leave-active.ant-picker-dropdown-placement-bottomLeft,.ant-picker-dropdown."ant"-slide-up-leave."ant"-slide-up-leave-active.ant-picker-dropdown-placement-bottomRight{-webkit-animation-name:antSlideUpOut;animation-name:antSlideUpOut}.ant-picker-dropdown-range{padding:6.66666667px 0}.ant-picker-dropdown-range-hidden{display:none}.ant-picker-dropdown .ant-picker-panel>.ant-picker-time-panel{padding-top:4px}.ant-picker-ranges{margin:0;padding:4px 12px;overflow:hidden;line-height:34px;text-align:left;list-style:none}.ant-picker-ranges>li{display:inline-block}.ant-picker-ranges .ant-picker-preset>."ant"-tag-blue{color:#1890ff;background:#e6f7ff;border-color:#e6f7ff;cursor:pointer}.ant-picker-ranges .ant-picker-now-btn{color:#1890ff;text-decoration:none;background-color:transparent;outline:none;cursor:pointer;transition:color .3s;-webkit-text-decoration-skip:objects}.ant-picker-ranges .ant-picker-now-btn:hover{color:#40a9ff}.ant-picker-ranges .ant-picker-ok{display:flex;align-items:center;float:right;margin-left:8px;height:34px}.ant-picker-ranges .ant-picker-ok>button{color:#fff;background:#1890ff;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px rgba(0,0,0,.043137254901960784);height:24px;padding:0 7px;font-size:14px;border-radius:2px;line-height:1.5715;position:relative;display:inline-block;font-weight:400;white-space:nowrap;text-align:center;border:1px solid transparent;cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;touch-action:manipulation}.ant-picker-ranges .ant-picker-ok>button:hover{color:#fff;border-color:#40a9ff;background:#40a9ff}.ant-picker-panel-container{overflow:hidden;vertical-align:top;background:#fff;border-radius:2px;box-shadow:0 3px 6px -4px rgba(0,0,0,.12),0 6px 16px 0 rgba(0,0,0,.08),0 9px 28px 8px rgba(0,0,0,.05);transition:margin .3s}.ant-picker-panel-container .ant-picker-panels{display:inline-flex;flex-wrap:nowrap;direction:ltr}.ant-picker-panel-container .ant-picker-panel{vertical-align:top;background:transparent;border-width:0 0 1px;border-radius:0}.ant-picker-panel-container .ant-picker-panel .ant-picker-content,.ant-picker-panel-container .ant-picker-panel table{text-align:center}.ant-picker-panel-container .ant-picker-panel-focused{border-color:#f0f0f0}.ant-picker-panel-container .ant-picker-footer-extra .ct-time-footer-panel{display:flex;justify-content:space-between}';
time_extension_styleInject(time_extension_css_248z$1);

var TimeView = function(props) {
    var attrs = props.attrs, getPos = props.getPos, view = props.view;
    var date = attrs.date, isShowTime = attrs.isShowTime;
    var timeRef = Object(react["useRef"])(null);
    Object(react["useEffect"])(function() {
        if (timeRef.current) {
            var // 将input设置为disabled 避免点击时间宏或者移动光标到选择时间面板上的值时选区会变更为TextSelection
            _timeRef_current_getElementsByTagName_;
            (_timeRef_current_getElementsByTagName_ = timeRef.current.getElementsByTagName("input")[0]) === null || _timeRef_current_getElementsByTagName_ === void 0 ? void 0 : _timeRef_current_getElementsByTagName_.setAttribute("disabled", "disabled");
        }
    }, []);
    var handleUpdateTime = function(value) {
        // 清空时将值设置为当前时间,并且不显示时间与线上保持一致交互
        var pos = getPos();
        if (!value) {
            updateTime(pos, {
                isShowTime: false,
                date: moment_default()(+new Date()).valueOf()
            }, view);
            return;
        }
        updateTime(pos, {
            date: value.valueOf()
        }, view);
    };
    var changePanelType = function() {
        updateTime(getPos(), {
            isShowTime: true
        }, view);
    };
    var selectNow = function() {
        handleUpdateTime(moment_default()(+new Date()));
    };
    var renderFooterPanel = function() {
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: time_extension_classNamePrefix("time-footer-panel")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            onClick: changePanelType
        }, "选择时间"), /*#__PURE__*/ react_default.a.createElement("div", {
            onClick: selectNow
        }, "此刻"));
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "datepicker-view",
        onClick: function() {
            view.dispatch(view.state.tr.setSelection(prosemirror_state_dist["NodeSelection"].create(view.state.tr.doc, getPos())));
        },
        ref: timeRef
    }, /*#__PURE__*/ react_default.a.createElement(rc_picker_es, {
        prefixCls: "ant-picker",
        generateConfig: time_extension_generateConfig,
        locale: time_extension_locale,
        allowClear: true,
        inputReadOnly: true,
        className: time_extension_classNamePrefix("datepicker-input".concat(isShowTime ? " time" : " date")),
        suffixIcon: /*#__PURE__*/ react_default.a.createElement("img", {
            src: time_extension_img,
            alt: "calendar"
        }),
        clearIcon: /*#__PURE__*/ react_default.a.createElement("img", {
            src: time_extension_img$1,
            alt: "close"
        }),
        popupStyle: {
            top: "200px"
        },
        format: isShowTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD",
        showTime: isShowTime ? {
            format: "HH:mm:ss"
        } : false,
        placeholder: "Select Time",
        renderExtraFooter: !isShowTime ? renderFooterPanel : function() {
            return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null);
        },
        value: moment_default()(+date),
        onMouseUp: function(e) {
            e.preventDefault();
        },
        getPopupContainer: function() {
            return document.querySelector(".".concat(time_extension_classNamePrefix("editor-container")));
        },
        onChange: function(value) {
            handleUpdateTime(value);
        }
    }));
};

function time_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function time_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function time_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function time_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) time_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) time_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function time_extension_getPrototypeOf(o) {
    time_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return time_extension_getPrototypeOf(o);
}
function time_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) time_extension_setPrototypeOf(subClass, superClass);
}
function time_extension_possibleConstructorReturn(self, call) {
    if (call && (time_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return time_extension_assertThisInitialized(self);
}
function time_extension_setPrototypeOf(o, p) {
    time_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return time_extension_setPrototypeOf(o, p);
}
var time_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function time_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function time_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = time_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = time_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = time_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return time_extension_possibleConstructorReturn(this, result);
    };
}
var TimeExtension = /*#__PURE__*/ function(NodeExtension) {
    time_extension_inherits(TimeExtension, NodeExtension);
    var _super = time_extension_createSuper(TimeExtension);
    function TimeExtension() {
        time_extension_classCallCheck(this, TimeExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = TimeView;
        _this.commands = function(param) {
            var getState = param.getState, editorEventEmitter = param.editorEventEmitter;
            return {
                insertTime: time_extension_execAfterCommands(insertTime, function() {
                    return editorEventEmitter.emit(time_extension_AFTER_INSERT, {
                        braceWidth: 126
                    });
                }),
                isDisabled: function() {
                    return function() {
                        return !time_extension_canInsertTypes(getState());
                    };
                }
            };
        };
        return _this;
    }
    var _proto = TimeExtension.prototype;
    _proto.keys = function keys(param) {
        var editorEventEmitter = param.editorEventEmitter;
        return {
            "Mod-Alt-t": time_extension_convertCommand(time_extension_execAfterCommands(insertTime, function() {
                return editorEventEmitter.emit(time_extension_AFTER_INSERT, {
                    braceWidth: 126
                });
            })())
        };
    };
    time_extension_createClass(TimeExtension, [
        {
            key: "name",
            get: function get() {
                return "time";
            }
        }
    ]);
    return TimeExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/attachment-extension/index.js











/**
 * 统一样式前缀
 */ var attachment_extension_CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var attachment_extension_ZERO_WIDTH_SPACE = "​";

var attachment_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : attachment_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
/**
 * 格式化文件大小(File.size)，加上单位
 */ function formatFileSize(origin) {
    if (origin >= 1024 * 1024) {
        return "".concat((origin / (1024 * 1024)).toFixed(2), "MB");
    }
    if (origin >= 1024) {
        return "".concat((origin / 1024).toFixed(2), "KB");
    }
    return "".concat(origin || 0, "B");
}

// 类型是否可以插入富文本
var attachment_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function attachment_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function attachment_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            attachment_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var attachment_extension_optionsMerge = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var res = attachment_extension_objectSpread({}, target, source);
    if (source.state) {
        res.state = attachment_extension_optionsMerge(target.state, source.state);
    }
    if (source.props) {
        res.props = attachment_extension_optionsMerge(target.props, source.props);
    }
    return res;
};
function attachment_extension_UploaderOption(pluginOption, param) {
    var createUploadMask = param.createUploadMask;
    var uploaderOption = {
        state: {
            init: function init() {
                return index_es["b" /* DecorationSet */].empty;
            },
            apply: function apply(tr, set) {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                var action = tr.getMeta(this);
                if (action && action.add) {
                    var widget = createUploadMask(action.add, action.add.id);
                    var deco = index_es["a" /* Decoration */].widget(action.add.pos, widget, {
                        id: action.add.id,
                        ignoreSelection: true
                    });
                    set = set.add(tr.doc, [
                        deco
                    ]);
                } else if (action && action.remove) {
                    set = set.remove(set.find(null, null, function(spec) {
                        return spec.id === action.remove.id;
                    }));
                }
                return set;
            }
        },
        props: {
            decorations: function decorations(state) {
                return this.getState(state);
            }
        }
    };
    return attachment_extension_optionsMerge(pluginOption, uploaderOption);
}

var attachment_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("attachment");

var attachment_extension_AFTER_INSERT = "after_insert";

function attachment_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function attachment_extension_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                attachment_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                attachment_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function attachment_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function attachment_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            attachment_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var attachment_extension_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 参考自官网Demo：https://prosemirror.net/examples/upload/
 */ function attachment_extension_findPlaceholder(view, id) {
    var decos = attachment_extension_pluginKey.getState(view.state);
    var found = decos.find(null, null, function(spec) {
        return spec.id === id;
    });
    if (found.length) {
        return {
            pos: found[0].from,
            node: found[0].type.toDOM
        };
    }
    return null;
}
var attachment_extension_onUpload = function(param) {
    var view = param.view, provider = param.provider, idMap = param.idMap, eventEmitter = param.eventEmitter, nodeType = param.nodeType, _param_pos = param.pos, pos = _param_pos === void 0 ? null : _param_pos;
    var getComponent = function(id) {
        return idMap[id];
    };
    return function() {
        var _ref = attachment_extension_asyncToGenerator(function(file) {
            var customUpload, _view_state, tr, schema, attachment, id, ret, attrs, _nodeType_spec_braceWidth, onProgress, data, _tmp, placeholder, e, placeholder1, comp;
            return attachment_extension_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customUpload = typeof file === "function" ? file : null;
                        _view_state = view.state, tr = _view_state.tr, schema = _view_state.schema;
                        attachment = schema.nodes.attachment;
                        id = esm_browser_v4();
                        if (!provider.beforeUpload) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            provider.beforeUpload(file, id)
                        ];
                    case 1:
                        ret = _state.sent();
                        // 只有当校验函数显示返回 false 时才表示校验不通过
                        if (ret === false) {
                            view.focus();
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        attrs = {
                            name: file.name || ""
                        };
                        if (typeof pos !== "number") pos = tr.selection.from;
                        if (!tr.selection.empty) {
                            tr.deleteSelection();
                        }
                        tr.setMeta(attachment_extension_pluginKey, {
                            add: {
                                id: id,
                                pos: pos,
                                file: file
                            }
                        });
                        // 为了能够在placeholder后面输入文字
                        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, pos)).insertText(attachment_extension_ZERO_WIDTH_SPACE, pos).setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, pos + 1));
                        view.dispatch(tr);
                        eventEmitter.emit(attachment_extension_AFTER_INSERT, {
                            braceWidth: (_nodeType_spec_braceWidth = nodeType.spec.braceWidth) !== null && _nodeType_spec_braceWidth !== void 0 ? _nodeType_spec_braceWidth : 340,
                            pos: pos
                        }); // 如果在表格中，更新列宽
                        onProgress = function(param) {
                            var loaded = param.loaded, total = param.total;
                            var placeholder = attachment_extension_findPlaceholder(view, id);
                            if (!placeholder) return;
                            var percent = Math.ceil(total ? loaded / total * 99 : 0);
                            var comp = getComponent(id);
                            comp && comp.setProgress(percent);
                        };
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            8,
                            ,
                            9
                        ]);
                        if (!customUpload) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            customUpload()
                        ];
                    case 4:
                        _tmp = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            provider.upload(file, onProgress)
                        ];
                    case 6:
                        _tmp = _state.sent();
                        _state.label = 7;
                    case 7:
                        data = _tmp;
                        placeholder = attachment_extension_findPlaceholder(view, id);
                        // If the content around the placeholder has been deleted, drop
                        // the image
                        if (!placeholder) return [
                            2
                        ];
                        // Otherwise, insert it at the placeholder's position, and remove
                        // the placeholder
                        if (data.size) {
                            data.size = formatFileSize(data.size);
                        }
                        // 删除 state 中保存的 placeholder
                        view.dispatch(view.state.tr.replaceRangeWith(placeholder.pos, placeholder.pos + 1, attachment.create(attachment_extension_objectSpread$1({}, attrs, data))).setMeta(attachment_extension_pluginKey, {
                            remove: {
                                id: id
                            }
                        }));
                        // 插入音频宏
                        // TODO:暂时不用insertBlock的实现，会导致插入视频后移动光标，视频上传完成后在光标的位置而不是placeholder的位置
                        // insertAttachment({ ...attrs, ...data })(view.state, view.dispatch, view);
                        delete idMap[id];
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e = _state.sent();
                        console.error("上传失败", e);
                        placeholder1 = attachment_extension_findPlaceholder(view, id);
                        if (!placeholder1) return [
                            2
                        ];
                        comp = getComponent(id);
                        comp.onRetry = function() {
                            var _view_state = view.state, retryTr = _view_state.tr;
                            view.dispatch(retryTr.setMeta(attachment_extension_pluginKey, {
                                remove: {
                                    id: id
                                }
                            }).delete(placeholder1.pos, placeholder1.pos + 1).setSelection(prosemirror_state_dist["TextSelection"].create(retryTr.doc, placeholder1.pos)));
                            attachment_extension_onUpload({
                                view: view,
                                provider: provider,
                                idMap: idMap,
                                pos: placeholder1.pos,
                                eventEmitter: eventEmitter,
                                nodeType: nodeType
                            })(file);
                        };
                        comp && comp.setHasError(true);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }();
};
var attachment_extension_selectFile = function(param) {
    var accept = param.accept, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? true : _param_multiple;
    return new Promise(function(resolve) {
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        if (multiple) {
            input.setAttribute("multiple", "multiple");
        }
        input.setAttribute("accept", accept);
        input.onchange = function(e) {
            var files = e.target.files;
            input.remove();
            resolve(files);
        };
        input.click();
    });
};

var AttachmentView = function(props) {
    var attrs = props.attrs, provider = props.provider;
    var name = attrs.name, size = attrs.size, src = attrs.src;
    var doCopy = function() {
        provider && provider.copy(src);
    };
    var doDownload = function() {
        provider && provider.download(src, name);
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()(attachment_extension_classNamePrefix("attachment"), {
            "align-right": (attrs === null || attrs === void 0 ? void 0 : attrs.align) === "right"
        }),
        spellCheck: false,
        contentEditable: false
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "attachment-icon"
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "content"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "name"
    }, name), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "size"
    }, size)), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "copy",
        onClick: doCopy
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "btn-copy"
    })), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "download",
        onClick: doDownload
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "btn-download"
    })));
};

function attachment_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function attachment_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function attachment_extension_getPrototypeOf(o) {
    attachment_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return attachment_extension_getPrototypeOf(o);
}
function attachment_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) attachment_extension_setPrototypeOf(subClass, superClass);
}
function attachment_extension_possibleConstructorReturn(self, call) {
    if (call && (attachment_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return attachment_extension_assertThisInitialized(self);
}
function attachment_extension_setPrototypeOf(o, p) {
    attachment_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return attachment_extension_setPrototypeOf(o, p);
}
var attachment_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function attachment_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function attachment_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = attachment_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = attachment_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = attachment_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return attachment_extension_possibleConstructorReturn(this, result);
    };
}
var attachment_extension_ErrorIcon = /*#__PURE__*/ function(Component) {
    attachment_extension_inherits(ErrorIcon, Component);
    var _super = attachment_extension_createSuper(ErrorIcon);
    function ErrorIcon() {
        attachment_extension_classCallCheck(this, ErrorIcon);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorIcon.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ react_default.a.createElement("svg", {
            width: "16px",
            height: "16px",
            viewBox: "0 0 16 16",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
        }, /*#__PURE__*/ react_default.a.createElement("g", {
            stroke: "none"
        }, /*#__PURE__*/ react_default.a.createElement("g", {
            transform: "translate(-296.000000, -544.000000)",
            fill: "#F05E50"
        }, /*#__PURE__*/ react_default.a.createElement("path", {
            d: "M304,544 C308.41824,544 312,547.58176 312,552 C312,556.41824 308.41824,560 304,560 C299.58176,560 296,556.41824 296,552 C296,547.58176 299.58176,544 304,544 Z M299.2,552 C299.2,552.667362 299.735663,553.2 300.396436,553.2 L307.603564,553.2 C308.256356,553.2 308.8,552.662742 308.8,552 C308.8,551.332638 308.264337,550.8 307.603564,550.8 L300.396436,550.8 C299.743644,550.8 299.2,551.337258 299.2,552 Z",
            id: "tost-错误"
        }))));
    };
    return ErrorIcon;
}(react["Component"]);

function attachment_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var attachment_extension_css_248z = '.ct-attachment-placeholder{position:relative;display:flex;min-width:320px;max-width:340px;height:56px;line-height:1;padding:8px 12px;margin:2px 0;background:#f6f6f6;border:1px solid #ddd;border-radius:2px;outline:none;text-decoration:none;box-sizing:border-box;cursor:pointer}.ct-attachment-placeholder[data-type=ct-progress]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-attachment-placeholder.selected,.ct-attachment-placeholder:hover{border-color:#3d91f2}.ct-attachment-placeholder:active{border:1px solid #0082a6}.ct-attachment-placeholder .attachment-icon{width:24px;height:34px;flex-shrink:0;background:url("data:image/svg+xml,%3Csvg width%3D%2224px%22 height%3D%2223px%22 viewBox%3D%220 0 24 23%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22%3E        %3Cg transform%3D%22translate(-688.000000%2C -866.000000)%22%3E            %3Cg transform%3D%22translate(685.000000%2C 862.000000)%22%3E                %3Crect id%3D%22Rectangle-17%22 fill-opacity%3D%220%22 fill%3D%22%23F6F6F6%22 x%3D%220%22 y%3D%220%22 width%3D%2230%22 height%3D%2230%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Cpath d%3D%22M6.49853365%2C14.6639779 C4.13913438%2C17.0174106 4.14092301%2C20.8348631 6.50032228%2C23.1882958 C8.75896153%2C25.4412232 12.0047027%2C25.1820314 14.3780845%2C23.1215301 L24.2770726%2C13.2475751 C25.6468437%2C11.8812679 25.6468437%2C9.66604628 24.2770726%2C8.29973911 C22.9073015%2C6.93343194 20.6864637%2C6.93343194 19.3166926%2C8.29973911 L9.20862255%2C18.3822474 C8.72882633%2C18.9698239 8.76335668%2C19.8360463 9.31221361%2C20.3835153 C9.89791917%2C20.9677397 10.8475355%2C20.9677397 11.433241%2C20.3835153 L19.814834%2C12.0231181 C20.1190587%2C11.7450807 20.5916516%2C11.7477221 20.8841528%2C12.0394836 C21.176654%2C12.3312451 21.1793021%2C12.8026429 20.892097%2C13.097657 L12.3408139%2C21.6274323 C11.1601199%2C22.8051404 9.24583685%2C22.8051404 8.06514292%2C21.6274323 C6.884449%2C20.4497242 6.884449%2C18.540282 8.06514292%2C17.3625739 L7.70883701%2C17.7179788 L18.3980144%2C7.05583277 C20.3658376%2C5.09298589 23.5563094%2C5.09298589 25.5241326%2C7.05583277 C27.4919558%2C9.01867965 27.4919558%2C12.2010832 25.5241326%2C14.1639301 L14.8349552%2C24.8260761 L15.1912612%2C24.4706713 C12.2106117%2C27.0546925 8.04670149%2C27.2955154 5.21469563%2C24.4706713 C2.26296081%2C21.5264009 2.26117218%2C16.7510115 5.212907%2C13.8067411 L15.5457784%2C3.5 L14.1205548%2C4.92161947 C14.4186199%2C4.66321957 14.8706399%2C4.67467844 15.1538398%2C4.95716212 C15.4370396%2C5.2396458 15.4485275%2C5.69052271 15.1883035%2C5.98666804 L6.49853365%2C14.6639779 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23BDC2C7%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.ct-attachment-placeholder .content{margin-left:12px;width:calc(100% - 100px)}.ct-attachment-placeholder .name{line-height:18px;font-size:12px;color:#333;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ct-attachment-placeholder .bottom{margin-top:8px;font-size:12px;color:#999}.ct-attachment-placeholder .bottom .upload-size{margin-left:8px;line-height:12px}.ct-attachment-placeholder .bottom .upload-percent{margin-left:8px}.ct-attachment-placeholder .progress-wrapper{display:inline-block;position:relative;width:100px;height:8px;border:1px solid #ddd;border-radius:6px;background-color:hsla(0,0%,86.7%,0)}.ct-attachment-placeholder .progress{position:absolute;top:-1px;left:0;height:8px;border:1px solid #0082a6;box-shadow:0 2px 8px 0 rgba(71,134,255,.24);border-radius:6px;background-color:#0082a6}.ct-attachment-placeholder .retry{display:flex;align-items:center;margin-left:24px;font-size:14px;color:#666}.ct-attachment-placeholder .retry .retry-btn{margin-left:5px;cursor:pointer;color:#4b89fc}.ct-attachment-placeholder .retry .retry-btn:hover{color:#108ee9}.ct-attachment-placeholder.has-error{height:48px;align-items:center;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-attachment-placeholder.has-error:hover{border-color:#23bdd9}.ct-attachment-placeholder.has-error .attachment-icon{height:30px}.ct-attachment-placeholder.has-error .content{width:auto}.ct-attachment-placeholder.has-error .content .name{max-width:115px}';
attachment_extension_styleInject(attachment_extension_css_248z);

function attachment_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function attachment_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function attachment_extension_getPrototypeOf$1(o) {
    attachment_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return attachment_extension_getPrototypeOf$1(o);
}
function attachment_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) attachment_extension_setPrototypeOf$1(subClass, superClass);
}
function attachment_extension_possibleConstructorReturn$1(self, call) {
    if (call && (attachment_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return attachment_extension_assertThisInitialized$1(self);
}
function attachment_extension_setPrototypeOf$1(o, p) {
    attachment_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return attachment_extension_setPrototypeOf$1(o, p);
}
var attachment_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function attachment_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function attachment_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = attachment_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = attachment_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = attachment_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return attachment_extension_possibleConstructorReturn$1(this, result);
    };
}
var attachment_extension_Placeholder = /*#__PURE__*/ function(_React_Component) {
    attachment_extension_inherits$1(Placeholder, _React_Component);
    var _super = attachment_extension_createSuper$1(Placeholder);
    function Placeholder() {
        attachment_extension_classCallCheck$1(this, Placeholder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            progress: 0,
            hasError: false
        };
        _this.onRetry = null;
        // 修改进度
        _this.setProgress = function(progress) {
            _this.setState({
                progress: progress
            });
        };
        // 修改错误状态
        _this.setHasError = function(hasError) {
            _this.setState({
                hasError: hasError
            });
        };
        // 重新上传
        _this.retry = function() {
            var onRetry = attachment_extension_assertThisInitialized$1(_this).onRetry;
            _this.setState({
                hasError: false
            }, function() {
                return onRetry && onRetry();
            });
        };
        return _this;
    }
    var _proto = Placeholder.prototype;
    _proto.render = function render() {
        var _this_props = this.props, name = _this_props.name, size = _this_props.size;
        var _this_state = this.state, progress = _this_state.progress, hasError = _this_state.hasError;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(attachment_extension_classNamePrefix("attachment-placeholder"), " ").concat(hasError ? "has-error" : ""),
            "data-type": "ct-progress",
            spellCheck: false,
            contentEditable: false
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "attachment-icon"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "content"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, name), !hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bottom"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "progress",
            style: {
                width: progress
            }
        })), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "upload-size"
        }, size), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "upload-percent"
        }, progress, "%"))), hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "retry"
        }, /*#__PURE__*/ react_default.a.createElement(attachment_extension_ErrorIcon, null), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "upload-error-msg"
        }, /*#__PURE__*/ react_default.a.createElement("span", null, "上传失败，"), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "retry-btn",
            onClick: this.retry
        }, "重试"))));
    };
    return Placeholder;
}(react_default.a.Component);

/**
 * 创建上传文件占位区域
 * @param url 本地文件地址
 */ var createPlaceholder = function(idMap) {
    return function(param, id) {
        var file = param.file;
        var widget = document.createElement("div");
        var name = file.name;
        // 渲染组件，并将组件的实例存入 store 中，以 id 为 key
        react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(attachment_extension_Placeholder, {
            id: id,
            name: name,
            file: file,
            size: formatFileSize(file.size),
            ref: function(ref) {
                idMap[id] = ref;
            }
        }), widget);
        return widget;
    };
};

var attachment_extension_css_248z$1 = '.pk-view-container .ct-attachment,.ProseMirror .ct-attachment{position:relative;display:flex;min-width:200px;max-width:340px;height:56px;line-height:1;padding:8px 12px;margin:2px 0;background:#f6f6f6;border:1px solid #ddd;border-radius:2px;outline:none;text-decoration:none;box-sizing:border-box;cursor:pointer}.pk-view-container .ct-attachment:active,.ProseMirror .ct-attachment:active{border:1px solid #0082a6}.pk-view-container .ct-attachment:hover,.ProseMirror .ct-attachment:hover{border-color:#3d91f2}.pk-view-container .ct-attachment.align-right,.ProseMirror .ct-attachment.align-right{width:320px}.pk-view-container .ct-attachment .attachment-icon,.ProseMirror .ct-attachment .attachment-icon{width:24px;height:34px;background:url("data:image/svg+xml,%3Csvg width%3D%2224px%22 height%3D%2223px%22 viewBox%3D%220 0 24 23%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22%3E        %3Cg transform%3D%22translate(-688.000000%2C -866.000000)%22%3E            %3Cg transform%3D%22translate(685.000000%2C 862.000000)%22%3E                %3Crect id%3D%22Rectangle-17%22 fill-opacity%3D%220%22 fill%3D%22%23F6F6F6%22 x%3D%220%22 y%3D%220%22 width%3D%2230%22 height%3D%2230%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Cpath d%3D%22M6.49853365%2C14.6639779 C4.13913438%2C17.0174106 4.14092301%2C20.8348631 6.50032228%2C23.1882958 C8.75896153%2C25.4412232 12.0047027%2C25.1820314 14.3780845%2C23.1215301 L24.2770726%2C13.2475751 C25.6468437%2C11.8812679 25.6468437%2C9.66604628 24.2770726%2C8.29973911 C22.9073015%2C6.93343194 20.6864637%2C6.93343194 19.3166926%2C8.29973911 L9.20862255%2C18.3822474 C8.72882633%2C18.9698239 8.76335668%2C19.8360463 9.31221361%2C20.3835153 C9.89791917%2C20.9677397 10.8475355%2C20.9677397 11.433241%2C20.3835153 L19.814834%2C12.0231181 C20.1190587%2C11.7450807 20.5916516%2C11.7477221 20.8841528%2C12.0394836 C21.176654%2C12.3312451 21.1793021%2C12.8026429 20.892097%2C13.097657 L12.3408139%2C21.6274323 C11.1601199%2C22.8051404 9.24583685%2C22.8051404 8.06514292%2C21.6274323 C6.884449%2C20.4497242 6.884449%2C18.540282 8.06514292%2C17.3625739 L7.70883701%2C17.7179788 L18.3980144%2C7.05583277 C20.3658376%2C5.09298589 23.5563094%2C5.09298589 25.5241326%2C7.05583277 C27.4919558%2C9.01867965 27.4919558%2C12.2010832 25.5241326%2C14.1639301 L14.8349552%2C24.8260761 L15.1912612%2C24.4706713 C12.2106117%2C27.0546925 8.04670149%2C27.2955154 5.21469563%2C24.4706713 C2.26296081%2C21.5264009 2.26117218%2C16.7510115 5.212907%2C13.8067411 L15.5457784%2C3.5 L14.1205548%2C4.92161947 C14.4186199%2C4.66321957 14.8706399%2C4.67467844 15.1538398%2C4.95716212 C15.4370396%2C5.2396458 15.4485275%2C5.69052271 15.1883035%2C5.98666804 L6.49853365%2C14.6639779 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23BDC2C7%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.pk-view-container .ct-attachment .content,.ProseMirror .ct-attachment .content{margin-left:12px;width:calc(100% - 100px)}.pk-view-container .ct-attachment .name,.ProseMirror .ct-attachment .name{line-height:18px;font-size:12px;color:#333;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.pk-view-container .ct-attachment .size,.ProseMirror .ct-attachment .size{display:inline-block;line-height:12px;font-size:12px;color:#999}.pk-view-container .ct-attachment .copy,.ProseMirror .ct-attachment .copy{position:absolute;top:15px;right:30px;bottom:0;width:40px}.pk-view-container .ct-attachment .copy .btn-copy,.ProseMirror .ct-attachment .copy .btn-copy{height:100%;border-left:1px solid #ddd;margin:-7px 0;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%80%9A%E7%94%A8%E7%BB%84%E4%BB%B6%E8%A7%84%E8%8C%83%E5%92%8C%E6%A1%88%E4%BE%8Bv0.1-%E5%9B%BE%E6%A0%87%E6%96%87%E6%A1%88%E9%97%B4%E8%B7%9D%22 transform%3D%22translate(-496.000000%2C -986.000000)%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E            %3Cg id%3D%22%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(496.000000%2C 986.000000)%22%3E                %3Cpath d%3D%22M11.6008309%2C1 C12.8995343%2C1.07592189 14.0703003%2C1.71698456 14.6762067%2C3.14250056 C15.2917537%2C4.59090718 15.0177693%2C5.93811066 13.955644%2C7.08887658 C13.2036907%2C7.90225179 12.3962373%2C8.66503324 11.6068778%2C9.44345532 C11.2640964%2C9.78206478 10.7149244%2C9.79290854 10.4180024%2C9.4808147 C10.1174711%2C9.16509587 10.1500649%2C8.73129889 10.51094%2C8.36859567 C11.2858152%2C7.59136109 12.0715654%2C6.82378276 12.8379718%2C6.03932944 C13.9930503%2C4.85721975 13.480097%2C2.97740676 11.8844716%2C2.55323478 C11.2206433%2C2.37731286 10.5833619%2C2.49901601 10.0788461%2C2.96896926 C9.26654902%2C3.72451633 8.5025332%2C4.52945404 7.69386112%2C5.28620424 C7.52248607%2C5.44646991 7.23884537%2C5.58503244 7.01675156%2C5.57057931 C6.42172016%2C5.53442305 6.12118883%2C4.81382912 6.53276706%2C4.38486026 C7.41747042%2C3.46303189 8.32028315%2C2.55565665 9.27017403%2C1.70251581 C9.8483148%2C1.1831563 10.6014712%2C1.0048125 11.6008309%2C1 Z M1%2C11.4027996 C1.00603125%2C10.4086743 1.35243759%2C9.54950222 2.04885965%2C8.84095516 C2.8177036%2C8.05770496 3.59861005%2C7.28650163 4.37831338%2C6.51409518 C4.74886035%2C6.14656384 5.20389172%2C6.11886071 5.51768867%2C6.43456391 C5.84357938%2C6.76353275 5.81220438%2C7.17804848 5.4259699%2C7.56606421 C4.68367283%2C8.3107519 3.92932889%2C9.04581459 3.19428182%2C9.79893979 C2.28542221%2C10.7280025 2.2467972%2C11.9823935 3.08443804%2C12.8247062 C3.88587575%2C13.630847 5.21112609%2C13.6344564 6.04876694%2C12.8186749 C6.81036089%2C12.0763935 7.5514392%2C11.3124246 8.31064253%2C10.5689244 C8.76686139%2C10.1230805 9.45967407%2C10.282143 9.58036161%2C10.8822369 C9.62381474%2C11.0979245 9.53692409%2C11.423284 9.38723656%2C11.5811434 C8.56168947%2C12.4511436 7.73731425%2C13.3283938 6.83812652%2C14.1176597 C5.73736061%2C15.0840662 4.44711027%2C15.2443475 3.10254742%2C14.6587067 C1.80264083%2C14.0923628 1.003625%2C12.8162687 1%2C11.4028152 L1%2C11.4027996 Z M11.0709714%2C5.73326686 C11.0226901%2C5.82362625 10.9671745%2C6.01884505 10.8416588%2C6.14656384 C9.32690841%2C7.68415799 7.80611114%2C9.21450214 6.27809512%2C10.7376275 C5.95340754%2C11.0617839 5.49114179%2C11.0400807 5.18578234%2C10.7316119 C4.87800101%2C10.4207212 4.88645414%2C9.99414296 5.22921985%2C9.64951787 C6.72950149%2C8.14567373 8.23459563%2C6.64545459 9.73848665%2C5.14642295 C9.98228359%2C4.90300101 10.2683305%2C4.80057911 10.6014556%2C4.9451729 C10.8983776%2C5.07411043 11.0492526%2C5.310298 11.070987%2C5.73325123 L11.0709714%2C5.73326686 Z%22 id%3D%22Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 13px;background-position:10px}.pk-view-container .ct-attachment .copy .btn-copy:hover,.ProseMirror .ct-attachment .copy .btn-copy:hover{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%80%9A%E7%94%A8%E7%BB%84%E4%BB%B6%E8%A7%84%E8%8C%83%E5%92%8C%E6%A1%88%E4%BE%8Bv0.1-%E5%9B%BE%E6%A0%87%E6%96%87%E6%A1%88%E9%97%B4%E8%B7%9D%22 transform%3D%22translate(-496.000000%2C -986.000000)%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E            %3Cg id%3D%22%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(496.000000%2C 986.000000)%22 fill%3D%22%233d91f2%22%3E                %3Cpath d%3D%22M11.6008309%2C1 C12.8995343%2C1.07592189 14.0703003%2C1.71698456 14.6762067%2C3.14250056 C15.2917537%2C4.59090718 15.0177693%2C5.93811066 13.955644%2C7.08887658 C13.2036907%2C7.90225179 12.3962373%2C8.66503324 11.6068778%2C9.44345532 C11.2640964%2C9.78206478 10.7149244%2C9.79290854 10.4180024%2C9.4808147 C10.1174711%2C9.16509587 10.1500649%2C8.73129889 10.51094%2C8.36859567 C11.2858152%2C7.59136109 12.0715654%2C6.82378276 12.8379718%2C6.03932944 C13.9930503%2C4.85721975 13.480097%2C2.97740676 11.8844716%2C2.55323478 C11.2206433%2C2.37731286 10.5833619%2C2.49901601 10.0788461%2C2.96896926 C9.26654902%2C3.72451633 8.5025332%2C4.52945404 7.69386112%2C5.28620424 C7.52248607%2C5.44646991 7.23884537%2C5.58503244 7.01675156%2C5.57057931 C6.42172016%2C5.53442305 6.12118883%2C4.81382912 6.53276706%2C4.38486026 C7.41747042%2C3.46303189 8.32028315%2C2.55565665 9.27017403%2C1.70251581 C9.8483148%2C1.1831563 10.6014712%2C1.0048125 11.6008309%2C1 Z M1%2C11.4027996 C1.00603125%2C10.4086743 1.35243759%2C9.54950222 2.04885965%2C8.84095516 C2.8177036%2C8.05770496 3.59861005%2C7.28650163 4.37831338%2C6.51409518 C4.74886035%2C6.14656384 5.20389172%2C6.11886071 5.51768867%2C6.43456391 C5.84357938%2C6.76353275 5.81220438%2C7.17804848 5.4259699%2C7.56606421 C4.68367283%2C8.3107519 3.92932889%2C9.04581459 3.19428182%2C9.79893979 C2.28542221%2C10.7280025 2.2467972%2C11.9823935 3.08443804%2C12.8247062 C3.88587575%2C13.630847 5.21112609%2C13.6344564 6.04876694%2C12.8186749 C6.81036089%2C12.0763935 7.5514392%2C11.3124246 8.31064253%2C10.5689244 C8.76686139%2C10.1230805 9.45967407%2C10.282143 9.58036161%2C10.8822369 C9.62381474%2C11.0979245 9.53692409%2C11.423284 9.38723656%2C11.5811434 C8.56168947%2C12.4511436 7.73731425%2C13.3283938 6.83812652%2C14.1176597 C5.73736061%2C15.0840662 4.44711027%2C15.2443475 3.10254742%2C14.6587067 C1.80264083%2C14.0923628 1.003625%2C12.8162687 1%2C11.4028152 L1%2C11.4027996 Z M11.0709714%2C5.73326686 C11.0226901%2C5.82362625 10.9671745%2C6.01884505 10.8416588%2C6.14656384 C9.32690841%2C7.68415799 7.80611114%2C9.21450214 6.27809512%2C10.7376275 C5.95340754%2C11.0617839 5.49114179%2C11.0400807 5.18578234%2C10.7316119 C4.87800101%2C10.4207212 4.88645414%2C9.99414296 5.22921985%2C9.64951787 C6.72950149%2C8.14567373 8.23459563%2C6.64545459 9.73848665%2C5.14642295 C9.98228359%2C4.90300101 10.2683305%2C4.80057911 10.6014556%2C4.9451729 C10.8983776%2C5.07411043 11.0492526%2C5.310298 11.070987%2C5.73325123 L11.0709714%2C5.73326686 Z%22 id%3D%22Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.pk-view-container .ct-attachment .download,.ProseMirror .ct-attachment .download{position:absolute;top:15px;right:0;bottom:0;width:30px}.pk-view-container .ct-attachment .download .btn-download,.ProseMirror .ct-attachment .download .btn-download{margin-top:-7px;width:30px;height:100%;display:inline-block;border-left:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2214px%22 height%3D%2214px%22 viewBox%3D%220 0 14 14%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E4%B8%8B%E8%BD%BD copy%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%99%84%E4%BB%B6%E6%B7%BB%E5%8A%A0%E5%A4%8D%E5%88%B6%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(-369.000000%2C -555.000000)%22 fill%3D%22%23747272%22%3E            %3Cg id%3D%22%E4%B8%8A%E4%BC%A0%E9%99%84%E4%BB%B6%E4%B8%AD-copy-6%22 transform%3D%22translate(56.000000%2C 534.000000)%22%3E                %3Cg id%3D%22%E4%B8%8B%E8%BD%BD-copy%22 transform%3D%22translate(312.000000%2C 20.000000)%22%3E                    %3Cpath d%3D%22M8.81079102%2C8.49228232 L11.0575929%2C6.23659883 C11.367661%2C5.92438892 11.8514298%2C5.89865471 12.1342183%2C6.18304917 C12.4189783%2C6.46942638 12.3934758%2C6.95251315 12.0816605%2C7.26648227 L8.65828197%2C10.7033935 C8.57058276%2C10.8187868 8.45021995%2C10.9080019 8.31097304%2C10.9572592 C8.23162324%2C10.986943 8.14990291%2C11.0008681 8.06879562%2C10.9999582 C8.06613072%2C10.999986 8.0634625%2C11 8.06079102%2C11 C8.05811953%2C11 8.05545131%2C10.999986 8.05278641%2C10.9999582 C7.97167912%2C11.0008681 7.88995879%2C10.986943 7.81060899%2C10.9572592 C7.67136208%2C10.9080019 7.55099928%2C10.8187868 7.46330006%2C10.7033935 L4.03992152%2C7.26648227 C3.72810619%2C6.95251315 3.70260373%2C6.46942638 3.98736375%2C6.18304917 C4.27015222%2C5.89865471 4.75392098%2C5.92438892 5.06398917%2C6.23659883 L7.31079102%2C8.49228232 L7.31079102%2C1.75 C7.31079102%2C1.33578644 7.64657745%2C1 8.06079102%2C1 C8.47500458%2C1 8.81079102%2C1.33578644 8.81079102%2C1.75 L8.81079102%2C8.49228232 Z M15%2C11.0225156 L15%2C13 C15%2C14.1045695 14.1045695%2C15 13%2C15 L3%2C15 C1.8954305%2C15 1%2C14.1045695 1%2C13 L1%2C11 L1.00152941%2C11 C1.00051495%2C10.9840173 1%2C10.9678989 1%2C10.9516602 C1%2C10.5365365 1.33652425%2C10.2000122 1.75164795%2C10.2000122 C2.16677165%2C10.2000122 2.5032959%2C10.5365365 2.5032959%2C10.9516602 C2.5032959%2C10.9755555 2.50218087%2C10.9991903 2.5%2C11.0225156 L2.5%2C12.5 C2.5%2C13.0522847 2.94771525%2C13.5 3.5%2C13.5 L12.5%2C13.5 C13.0522847%2C13.5 13.5%2C13.0522847 13.5%2C12.5 L13.5%2C11 L13.5015294%2C11 C13.5005149%2C10.9840173 13.5%2C10.9678989 13.5%2C10.9516602 C13.5%2C10.5365365 13.8365242%2C10.2000122 14.2516479%2C10.2000122 C14.6667716%2C10.2000122 15.0032959%2C10.5365365 15.0032959%2C10.9516602 C15.0032959%2C10.9755555 15.0021809%2C10.9991903 15%2C11.0225156 Z%22 id%3D%22%E4%B8%8B%E8%BD%BD%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.pk-view-container .ct-attachment .download .btn-download:hover,.ProseMirror .ct-attachment .download .btn-download:hover{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2214px%22 height%3D%2214px%22 viewBox%3D%220 0 14 14%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E4%B8%8B%E8%BD%BD copy%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%99%84%E4%BB%B6%E6%B7%BB%E5%8A%A0%E5%A4%8D%E5%88%B6%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(-369.000000%2C -555.000000)%22 fill%3D%22%233d91f2%22%3E            %3Cg id%3D%22%E4%B8%8A%E4%BC%A0%E9%99%84%E4%BB%B6%E4%B8%AD-copy-6%22 transform%3D%22translate(56.000000%2C 534.000000)%22%3E                %3Cg id%3D%22%E4%B8%8B%E8%BD%BD-copy%22 transform%3D%22translate(312.000000%2C 20.000000)%22%3E                    %3Cpath d%3D%22M8.81079102%2C8.49228232 L11.0575929%2C6.23659883 C11.367661%2C5.92438892 11.8514298%2C5.89865471 12.1342183%2C6.18304917 C12.4189783%2C6.46942638 12.3934758%2C6.95251315 12.0816605%2C7.26648227 L8.65828197%2C10.7033935 C8.57058276%2C10.8187868 8.45021995%2C10.9080019 8.31097304%2C10.9572592 C8.23162324%2C10.986943 8.14990291%2C11.0008681 8.06879562%2C10.9999582 C8.06613072%2C10.999986 8.0634625%2C11 8.06079102%2C11 C8.05811953%2C11 8.05545131%2C10.999986 8.05278641%2C10.9999582 C7.97167912%2C11.0008681 7.88995879%2C10.986943 7.81060899%2C10.9572592 C7.67136208%2C10.9080019 7.55099928%2C10.8187868 7.46330006%2C10.7033935 L4.03992152%2C7.26648227 C3.72810619%2C6.95251315 3.70260373%2C6.46942638 3.98736375%2C6.18304917 C4.27015222%2C5.89865471 4.75392098%2C5.92438892 5.06398917%2C6.23659883 L7.31079102%2C8.49228232 L7.31079102%2C1.75 C7.31079102%2C1.33578644 7.64657745%2C1 8.06079102%2C1 C8.47500458%2C1 8.81079102%2C1.33578644 8.81079102%2C1.75 L8.81079102%2C8.49228232 Z M15%2C11.0225156 L15%2C13 C15%2C14.1045695 14.1045695%2C15 13%2C15 L3%2C15 C1.8954305%2C15 1%2C14.1045695 1%2C13 L1%2C11 L1.00152941%2C11 C1.00051495%2C10.9840173 1%2C10.9678989 1%2C10.9516602 C1%2C10.5365365 1.33652425%2C10.2000122 1.75164795%2C10.2000122 C2.16677165%2C10.2000122 2.5032959%2C10.5365365 2.5032959%2C10.9516602 C2.5032959%2C10.9755555 2.50218087%2C10.9991903 2.5%2C11.0225156 L2.5%2C12.5 C2.5%2C13.0522847 2.94771525%2C13.5 3.5%2C13.5 L12.5%2C13.5 C13.0522847%2C13.5 13.5%2C13.0522847 13.5%2C12.5 L13.5%2C11 L13.5015294%2C11 C13.5005149%2C10.9840173 13.5%2C10.9678989 13.5%2C10.9516602 C13.5%2C10.5365365 13.8365242%2C10.2000122 14.2516479%2C10.2000122 C14.6667716%2C10.2000122 15.0032959%2C10.5365365 15.0032959%2C10.9516602 C15.0032959%2C10.9755555 15.0021809%2C10.9991903 15%2C11.0225156 Z%22 id%3D%22%E4%B8%8B%E8%BD%BD%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ProseMirror-selectednode .ct-attachment{border:1px solid #3d91f2;box-shadow:0 0 4px 0 rgba(0,0,0,.1),0 3px 6px 0 rgba(0,0,0,.14);background-color:#fff}';
attachment_extension_styleInject(attachment_extension_css_248z$1);

function attachment_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function attachment_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function attachment_extension_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                attachment_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                attachment_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function attachment_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function attachment_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function attachment_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) attachment_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) attachment_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function attachment_extension_getPrototypeOf$2(o) {
    attachment_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return attachment_extension_getPrototypeOf$2(o);
}
function attachment_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) attachment_extension_setPrototypeOf$2(subClass, superClass);
}
function attachment_extension_possibleConstructorReturn$2(self, call) {
    if (call && (attachment_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return attachment_extension_assertThisInitialized$2(self);
}
function attachment_extension_setPrototypeOf$2(o, p) {
    attachment_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return attachment_extension_setPrototypeOf$2(o, p);
}
var attachment_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function attachment_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function attachment_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = attachment_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = attachment_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = attachment_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return attachment_extension_possibleConstructorReturn$2(this, result);
    };
}
var attachment_extension_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var attachment_extension_idMap = {};
var UPLOAD_PREFIX = attachment_extension_classNamePrefix("attachment-placeholder");
var attachment_extension_AttachmentExtension = /*#__PURE__*/ function(NodeExtension) {
    attachment_extension_inherits$2(AttachmentExtension, NodeExtension);
    var _super = attachment_extension_createSuper$2(AttachmentExtension);
    function AttachmentExtension() {
        attachment_extension_classCallCheck$2(this, AttachmentExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = AttachmentView;
        return _this;
    }
    var _proto = AttachmentExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state_dist["Plugin"](attachment_extension_UploaderOption({
            key: attachment_extension_pluginKey,
            props: {
                handleClick: function(view, pos, e) {
                    // 将已经选中的上传中元素取消选中
                    var preSelected = document.querySelector(".".concat(UPLOAD_PREFIX, '[data-type="ct-progress"].selected'));
                    if (preSelected) {
                        preSelected.classList.remove("selected");
                    }
                    // 选中上传中的元素
                    var target = e.target;
                    var uploadingNode = target.closest(".".concat(UPLOAD_PREFIX, '[data-type="ct-progress"]'));
                    if (uploadingNode) {
                        var state = view.state, dispatch = view.dispatch;
                        var selection = prosemirror_state_dist["TextSelection"].create(state.doc, pos, pos + 1);
                        dispatch(state.tr.setSelection(selection));
                        uploadingNode.classList.add("selected");
                        return true;
                    }
                    return false;
                }
            }
        }, {
            createUploadMask: createPlaceholder(attachment_extension_idMap)
        }));
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, providers = param.providers, editorEventEmitter = param.editorEventEmitter, schema = param.schema;
        var _this = this;
        return {
            isDisabled: function() {
                return function() {
                    return !attachment_extension_canInsertTypes(getState());
                };
            },
            upload: function(files) {
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    var selectedFiles = files ? Promise.resolve(files) : attachment_extension_selectFile({
                        accept: "*/*",
                        multiple: true
                    });
                    var _this1 = _this;
                    selectedFiles.then(function() {
                        var _ref = attachment_extension_asyncToGenerator$1(function(fileList) {
                            var _tmp, i;
                            return attachment_extension_generator$1(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = provider.onSelectFiles;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            provider.onSelectFiles(fileList)
                                        ];
                                    case 1:
                                        _tmp = !_state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (_tmp) {
                                            view.focus();
                                            return [
                                                2
                                            ];
                                        }
                                        for(i = 0; i < fileList.length; i++){
                                            attachment_extension_onUpload({
                                                view: view,
                                                provider: provider,
                                                idMap: attachment_extension_idMap,
                                                eventEmitter: editorEventEmitter,
                                                nodeType: schema.nodes[_this1.name]
                                            })(fileList[i]);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(fileList) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return true;
                };
            },
            // 在指定位置插入图片，用于数据清洗功能
            insert: function(param) {
                var customUpload = param.customUpload, pos = param.pos;
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    attachment_extension_onUpload({
                        view: view,
                        provider: provider,
                        idMap: attachment_extension_idMap,
                        pos: pos,
                        eventEmitter: editorEventEmitter,
                        nodeType: schema.nodes[_this.name]
                    })(customUpload);
                    return true;
                };
            }
        };
    };
    attachment_extension_createClass(AttachmentExtension, [
        {
            key: "name",
            get: function get() {
                return "attachment";
            }
        }
    ]);
    return AttachmentExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("f7fe");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/video-extension/index.js












/**
 * 统一样式前缀
 */ var video_extension_CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var video_extension_ZERO_WIDTH_SPACE = "​";

function video_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var video_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function video_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = video_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && video_extension_isParagraph(content[size - 1]) && video_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var video_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : video_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
/**
 * 格式化文件大小(File.size)，加上单位
 */ function video_extension_formatFileSize(origin) {
    if (origin >= 1024 * 1024) {
        return "".concat((origin / (1024 * 1024)).toFixed(2), "MB");
    }
    if (origin >= 1024) {
        return "".concat((origin / 1024).toFixed(2), "KB");
    }
    return "".concat(origin || 0, "B");
}
/**
 *格式化时间字符串
 * @param time
 * @returns HH:MM格式字符串
 */ var formatTime = function(time) {
    var minute = parseInt("".concat(time / 60), 10);
    var second = parseInt("".concat(time % 60), 10);
    return "".concat(minute < 10 ? "0".concat(minute) : minute, ":").concat(second < 10 ? "0".concat(second) : second);
};

var video_extension_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
// 类型是否可以插入富文本
var video_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function video_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var video_extension_optionsMerge = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var res = video_extension_objectSpread({}, target, source);
    if (source.state) {
        res.state = video_extension_optionsMerge(target.state, source.state);
    }
    if (source.props) {
        res.props = video_extension_optionsMerge(target.props, source.props);
    }
    return res;
};
function video_extension_UploaderOption(pluginOption, param) {
    var createUploadMask = param.createUploadMask;
    var uploaderOption = {
        state: {
            init: function init() {
                return index_es["b" /* DecorationSet */].empty;
            },
            apply: function apply(tr, set) {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                var action = tr.getMeta(this);
                if (action && action.add) {
                    var widget = createUploadMask(action.add, action.add.id);
                    var deco = index_es["a" /* Decoration */].widget(action.add.pos, widget, {
                        id: action.add.id,
                        ignoreSelection: true
                    });
                    set = set.add(tr.doc, [
                        deco
                    ]);
                } else if (action && action.remove) {
                    set = set.remove(set.find(null, null, function(spec) {
                        return spec.id === action.remove.id;
                    }));
                }
                return set;
            }
        },
        props: {
            decorations: function decorations(state) {
                return this.getState(state);
            }
        }
    };
    return video_extension_optionsMerge(pluginOption, uploaderOption);
}

/**
 * 插入视频
 * @return {boolean} 是否插入成功
 */ var insertVideo = function(attrs) {
    return function(state, dispatch, view, pos) {
        var schema = state.schema;
        var transaction = video_extension_insertBlock(view.state, schema.nodes.video.create(attrs), {
            selection: new prosemirror_state_dist["TextSelection"](view.state.doc.resolve(pos)),
            cursorMove: false
        }).transaction;
        dispatch(transaction);
        view.focus();
        return true;
    };
};

var video_extension_AFTER_INSERT = "after_insert";

var video_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("video");

function video_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function video_extension_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                video_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                video_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function video_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var video_extension_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 参考自官网Demo：https://prosemirror.net/examples/upload/
 */ function video_extension_findPlaceholder(view, id) {
    var decos = video_extension_pluginKey.getState(view.state);
    var found = decos.find(null, null, function(spec) {
        return spec.id === id;
    });
    if (found.length) {
        return {
            pos: found[0].from,
            node: found[0].type.toDOM
        };
    }
    return null;
}
var video_extension_onUpload = function(param) {
    var view = param.view, provider = param.provider, idMap = param.idMap, pos = param.pos, eventEmitter = param.eventEmitter;
    var getComponent = function(id) {
        return idMap[id];
    };
    return function() {
        var _ref = video_extension_asyncToGenerator(function(file) {
            var id, ret, attrs, tr, onProgress, data, comp, placeholder, e, placeholder1, comp1;
            return video_extension_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = esm_browser_v4();
                        if (!provider.beforeUpload) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            provider.beforeUpload(file, id)
                        ];
                    case 1:
                        ret = _state.sent();
                        // 只有当校验函数显示返回 false 时才表示校验不通过
                        if (ret === false) {
                            view.focus();
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        attrs = {
                            name: file.name
                        };
                        tr = view.state.tr;
                        if (typeof pos !== "number") pos = tr.selection.from;
                        if (!tr.selection.empty) {
                            tr.deleteSelection();
                        }
                        tr.setMeta(video_extension_pluginKey, {
                            add: {
                                id: id,
                                pos: pos,
                                file: file
                            }
                        });
                        tr.insertText(video_extension_ZERO_WIDTH_SPACE, pos); // 为了能够在placeholder后输入文字
                        view.dispatch(tr);
                        eventEmitter.emit(video_extension_AFTER_INSERT, {
                            braceWidth: 540,
                            pos: pos
                        }); // 如果在表格中，更新列宽
                        onProgress = function(param) {
                            var loaded = param.loaded, total = param.total;
                            var placeholder = video_extension_findPlaceholder(view, id);
                            if (!placeholder) return;
                            var percent = Math.ceil(total ? loaded / total * 99 : 0);
                            var comp = getComponent(id);
                            comp === null || comp === void 0 ? void 0 : comp.setProgress(percent);
                            comp === null || comp === void 0 ? void 0 : comp.setLoaded(loaded);
                        };
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            provider.upload(file, onProgress)
                        ];
                    case 4:
                        data = _state.sent();
                        comp = getComponent(id);
                        comp === null || comp === void 0 ? void 0 : comp.setUploadDone(true);
                        if (!provider.videoTranscode) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            provider.videoTranscode(data, file)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        comp === null || comp === void 0 ? void 0 : comp.setTranscodeDone(true);
                        placeholder = video_extension_findPlaceholder(view, id);
                        if (!placeholder) return [
                            2
                        ];
                        data.size = video_extension_formatFileSize(data.size);
                        // 删除 state 中保存的 placeholder
                        view.dispatch(view.state.tr.replaceWith(placeholder.pos, placeholder.pos + 1, []).setMeta(video_extension_pluginKey, {
                            remove: {
                                id: id
                            }
                        }));
                        // 插入视频宏
                        insertVideo(video_extension_objectSpread$1({}, attrs, data))(view.state, view.dispatch, view, placeholder.pos);
                        delete idMap[id];
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        console.error("上传失败", e);
                        placeholder1 = video_extension_findPlaceholder(view, id);
                        if (!placeholder1) return [
                            2
                        ];
                        comp1 = getComponent(id);
                        comp1.onRetry = function() {
                            view.dispatch(view.state.tr.setMeta(video_extension_pluginKey, {
                                remove: {
                                    id: id
                                }
                            }));
                            video_extension_onUpload({
                                view: view,
                                provider: provider,
                                idMap: idMap,
                                pos: placeholder1.pos,
                                eventEmitter: eventEmitter
                            })(file);
                        };
                        comp1 === null || comp1 === void 0 ? void 0 : comp1.setHasError(true);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }();
};
var video_extension_selectFile = function(param) {
    var accept = param.accept, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? true : _param_multiple;
    return new Promise(function(resolve) {
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        if (multiple) {
            input.setAttribute("multiple", "multiple");
        }
        input.setAttribute("accept", accept);
        input.onchange = function(e) {
            var files = e.target.files;
            input.remove();
            resolve(files);
        };
        input.click();
    });
};

function video_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function video_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function video_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function video_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function video_extension_slicedToArray(arr, i) {
    return video_extension_arrayWithHoles(arr) || video_extension_iterableToArrayLimit(arr, i) || video_extension_unsupportedIterableToArray(arr, i) || video_extension_nonIterableRest();
}
function video_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return video_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return video_extension_arrayLikeToArray(o, minLen);
}
function video_extension_useForceUpdate() {
    var _useState = video_extension_slicedToArray(Object(react["useState"])(0), 2), setTick = _useState[1];
    var update = Object(react["useCallback"])(function() {
        setTick(function(tick) {
            return tick + 1;
        });
    }, []);
    return update;
}

function video_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var video_extension_css_248z = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
video_extension_styleInject(video_extension_css_248z);

function video_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function video_extension_arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function video_extension_iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function video_extension_nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function video_extension_slicedToArray$1(arr, i) {
    return video_extension_arrayWithHoles$1(arr) || video_extension_iterableToArrayLimit$1(arr, i) || video_extension_unsupportedIterableToArray$1(arr, i) || video_extension_nonIterableRest$1();
}
function video_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return video_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return video_extension_arrayLikeToArray$1(o, minLen);
}
var video_extension_Resizer = function(param) {
    var $container = param.$container, view = param.view, getPos = param.getPos, initialWidth = param.initialWidth, initialHeight = param.initialHeight, _param_fixedRatio = param.fixedRatio, fixedRatio = _param_fixedRatio === void 0 ? true : _param_fixedRatio, _param_autoHeight = param.autoHeight, autoHeight = _param_autoHeight === void 0 ? false : _param_autoHeight, _param_hideInfo = param.hideInfo, hideInfo = _param_hideInfo === void 0 ? false : _param_hideInfo, _param_limit = param.limit, limit = _param_limit === void 0 ? {} : _param_limit, onResizeStart = param.onResizeStart, onResizeEnd = param.onResizeEnd;
    if (!$container || !getPos()) return null;
    var limitRef = Object(react["useRef"])({});
    limitRef.current.minWidth = limit.minWidth || 20;
    limitRef.current.minHeight = limit.minHeight || 20;
    limitRef.current.maxHeight = limit.maxHeight || Infinity;
    var _useState = video_extension_slicedToArray$1(Object(react["useState"])("rb"), 2), infoPosition = _useState[0], setInfoPosition = _useState[1];
    var wrapperRef = Object(react["useRef"])();
    // 获取最大宽度
    var pos = getPos();
    var doc = view.state.doc;
    // 获取父级block节点
    var blockNode = video_extension_findParentNodeClosestToPos(doc.resolve(pos), function(n) {
        return n.isBlock;
    });
    var $blockNode = view.nodeDOM((blockNode === null || blockNode === void 0 ? void 0 : blockNode.pos) || 0);
    if (!$blockNode) {
        return null;
    }
    limitRef.current.maxWidth = limit.maxWidth || $blockNode.clientWidth;
    var ratio = initialHeight / initialWidth;
    if (fixedRatio) {
        limitRef.current.minHeight = Math.max(limitRef.current.minHeight, limitRef.current.minWidth * ratio);
        limitRef.current.minWidth = Math.max(limitRef.current.minWidth, limitRef.current.minHeight / ratio);
        limitRef.current.maxHeight = limitRef.current.maxWidth * ratio;
    }
    limitRef.current.minWidth = Math.min(limitRef.current.minWidth, limitRef.current.maxWidth);
    limitRef.current.minHeight = Math.min(limitRef.current.minHeight, limitRef.current.maxHeight);
    var startX = Object(react["useRef"])(0);
    var startY = Object(react["useRef"])(0);
    var isReverseX = Object(react["useRef"])(false);
    var isReverseY = Object(react["useRef"])(false);
    var initialWidthRef = Object(react["useRef"])(0);
    var initialHeightRef = Object(react["useRef"])(0);
    initialWidthRef.current = initialWidth;
    initialHeightRef.current = initialHeight;
    var currentSize = Object(react["useRef"])({
        width: initialWidth,
        height: initialHeight
    });
    var update = video_extension_useForceUpdate();
    var limitSize = function() {
        var _currentSize_current = currentSize.current, width = _currentSize_current.width, height = _currentSize_current.height;
        if (width >= limitRef.current.maxWidth) {
            currentSize.current.width = limitRef.current.maxWidth;
        } else if (width <= limitRef.current.minWidth) {
            currentSize.current.width = limitRef.current.minWidth;
        }
        if (height >= limitRef.current.maxHeight) {
            currentSize.current.height = limitRef.current.maxHeight;
        } else if (height <= limitRef.current.minHeight) {
            currentSize.current.height = limitRef.current.minHeight;
        }
    };
    Object(react["useEffect"])(function() {
        var onMouseDown = function(e) {
            var classList = e.target && e.target.classList;
            if (!classList) {
                return;
            }
            var posList = [
                "lt",
                "rt",
                "lb",
                "rb"
            ];
            var posName = posList.find(function(item) {
                return classList.contains(item);
            });
            if (posName) {
                e.stopPropagation();
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                handleMouseDown(e, posName);
            }
        };
        var wrapper = wrapperRef.current;
        wrapper.addEventListener("mousedown", onMouseDown, false);
        return function() {
            wrapper.removeEventListener("mousedown", onMouseDown, false);
        };
    });
    Object(react["useEffect"])(function() {
        currentSize.current.width = initialWidth;
        currentSize.current.height = initialHeight;
        if (!autoHeight) {
            // 防止容器节点大小没有同步更新
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        update();
    }, [
        initialWidth
    ]);
    var handleMouseMove = Object(react["useCallback"])(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var diffX = isReverseX.current ? startX.current - e.clientX : e.clientX - startX.current;
        var diffY = isReverseY.current ? startY.current - e.clientY : e.clientY - startY.current;
        currentSize.current.width = initialWidthRef.current + diffX;
        currentSize.current.height = initialHeightRef.current + diffY;
        if (fixedRatio) {
            currentSize.current.height = currentSize.current.width * ratio;
        }
        limitSize();
        currentSize.current.width = Math.round(currentSize.current.width);
        currentSize.current.height = Math.round(currentSize.current.height);
        $container.style.width = "".concat(currentSize.current.width, "px");
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        // 更新尺寸大小的显示
        update();
    }, []);
    var handleMouseUp = Object(react["useCallback"])(function() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        onResizeEnd({
            width: currentSize.current.width,
            height: currentSize.current.height
        });
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        $container.style.width = "".concat(currentSize.current.width, "px");
    }, []);
    var handleMouseDown = function(e, position) {
        isReverseX.current = position === "lt" || position === "lb";
        isReverseY.current = position === "lt" || position === "lr";
        startX.current = e.clientX;
        startY.current = e.clientY;
        setInfoPosition(position);
        if (onResizeStart) {
            onResizeStart();
        }
        document.addEventListener("mousemove", handleMouseMove, {
            passive: false
        });
        document.addEventListener("mouseup", handleMouseUp);
    };
    // 当图片尺寸较大时，扩大热区
    var largeHotArea = Object(react["useMemo"])(function() {
        return currentSize.current.height >= 30 && currentSize.current.width >= 30;
    }, [
        currentSize.current.height,
        currentSize.current.width
    ]);
    var resizerPrefix = video_extension_classNamePrefix("pc-resizer");
    var pointerCls = "".concat(resizerPrefix, "-point");
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: resizerPrefix,
        ref: wrapperRef
    }, /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " lt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " rt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " lb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " rb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(resizerPrefix, "-info ").concat(infoPosition, " ").concat((currentSize.current.width < 65 || currentSize.current.height < 30) && "out", " ").concat(hideInfo ? "auto-hide" : "")
    }, "".concat(currentSize.current.width, " x ").concat(currentSize.current.height)));
};

var video_extension_img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%92%ad%e6%94%be%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-471.000000%2c -558.000000)'%3e %3cg id='Group-18' transform='translate(471.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M15.6839276%2c10.5567733 L4.96564206%2c16.9107492 C4.66057577%2c17.0915976 4.26783668%2c16.9889051 4.08843476%2c16.6813793 C4.03053197%2c16.5821239 4%2c16.4690706 4%2c16.3539244 L4%2c3.64597255 C4%2c3.28921176 4.28689869%2c3 4.64080615%2c3 C4.7550314%2c3 4.86718053%2c3.03077813 4.96564206%2c3.08914775 L15.6839276%2c9.44312369 C15.9889939%2c9.62397201 16.090865%2c10.0198775 15.9114631%2c10.3274033 C15.8562054%2c10.4221245 15.7778912%2c10.5010701 15.6839276%2c10.5567733 Z' id='Triangle-2' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%9a%82%e5%81%9c%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-395.000000%2c -558.000000)'%3e %3cg id='Group-18-Copy' transform='translate(395.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M5%2c3 L7%2c3 C7.55228475%2c3 8%2c3.44771525 8%2c4 L8%2c16 C8%2c16.5522847 7.55228475%2c17 7%2c17 L5%2c17 C4.44771525%2c17 4%2c16.5522847 4%2c16 L4%2c4 C4%2c3.44771525 4.44771525%2c3 5%2c3 Z M13%2c3 L15%2c3 C15.5522847%2c3 16%2c3.44771525 16%2c4 L16%2c16 C16%2c16.5522847 15.5522847%2c17 15%2c17 L13%2c17 C12.4477153%2c17 12%2c16.5522847 12%2c16 L12%2c4 C12%2c3.44771525 12.4477153%2c3 13%2c3 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%87%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-514.000000%2c -558.000000)'%3e %3cg id='Group-22' transform='translate(514.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(2.000000%2c 4.000000)'%3e %3cg id='Group-21'%3e %3cpath d='M0%2c8.12082937 C0%2c8.6754175 0.442660332%2c9.125 0.998956561%2c9.125 L3%2c9.125 L6.19054031%2c11.4182009 C6.63759255%2c11.7395196 7%2c11.544239 7%2c10.9975267 L7%2c1.00247329 C7%2c0.448822582 6.63085938%2c0.265319824 6.19054031%2c0.58179915 L3%2c2.875 L0.998956561%2c2.875 C0.447248087%2c2.875 0%2c3.32448459 0%2c3.87917063 L0%2c8.12082937 Z' id='Fill-89' fill='%236B6B6B'%3e%3c/path%3e %3cpath d='M10%2c2 C11.3333333%2c3.06070964 12%2c4.39404297 12%2c6 C12%2c7.60595703 11.3333333%2c8.93929036 10%2c10' id='Path-12' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3cpath d='M13%2c0 C15%2c1.3984375 16%2c3.3984375 16%2c6 C16%2c8.6015625 15%2c10.6015625 13%2c12' id='Path-12-Copy' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9d%99%e9%9f%b3%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-550.000000%2c -558.000000)'%3e %3cg id='Group-22-Copy' transform='translate(550.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(4.000000%2c 4.000000)' fill='%236B6B6B'%3e %3cpath d='M9%2c1.72792206 L2.12273522%2c8.60518684 C2.04439515%2c8.46156167 2%2c8.29646112 2%2c8.12082937 L2%2c3.87917063 C2%2c3.32448459 2.44724809%2c2.875 2.99895656%2c2.875 L5%2c2.875 L8.19054031%2c0.58179915 C8.63085937%2c0.265319824 9%2c0.448822582 9%2c1.00247329 L9%2c1.72792206 Z M9%2c6.67766953 L9%2c10.9975267 C9%2c11.544239 8.63759255%2c11.7395196 8.19054031%2c11.4182009 L5.90337136%2c9.77429817 L9%2c6.67766953 Z M12.2582521%2c0.944543648 C12.5511454%2c1.23743687 12.5511454%2c1.7123106 12.2582521%2c2.00520382 L2.00520382%2c12.2582521 C1.7123106%2c12.5511454 1.23743687%2c12.5511454 0.944543648%2c12.2582521 C0.651650429%2c11.9653589 0.651650429%2c11.4904852 0.944543648%2c11.197592 L11.197592%2c0.944543648 C11.4904852%2c0.651650429 11.9653589%2c0.651650429 12.2582521%2c0.944543648 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e5%85%a8%e5%b1%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-586.000000%2c -558.000000)'%3e %3cg id='Group-24' transform='translate(586.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M17.028246%2c3.75000027 C17.0282663%2c3.75227439 17.0282764%2c3.75455093 17.0282764%2c3.75682984 L17.0282764%2c9.25682984 C17.0282764%2c9.6710434 16.69249%2c10.0068298 16.2782764%2c10.0068298 C15.8640629%2c10.0068298 15.5282764%2c9.6710434 15.5282764%2c9.25682984 L15.5282764%2c5.55025253 L11.5803179%2c9.4982111 C11.2874247%2c9.79110432 10.8125509%2c9.79110432 10.5196577%2c9.4982111 C10.2267645%2c9.20531788 10.2267645%2c8.73044414 10.5196577%2c8.43755093 L14.4572086%2c4.5 L10.7782764%2c4.5 C10.3640629%2c4.5 10.0282764%2c4.16421356 10.0282764%2c3.75 C10.0282764%2c3.33578644 10.3640629%2c3 10.7782764%2c3 L16.2782764%2c3 C16.69249%2c3 17.0282764%2c3.33578644 17.0282764%2c3.75 Z M3.00003045%2c16.2499997 C3.00001016%2c16.2477256 3%2c16.2454491 3%2c16.2431702 L3%2c10.7431702 C3%2c10.3289566 3.33578644%2c9.99317016 3.75%2c9.99317016 C4.16421356%2c9.99317016 4.5%2c10.3289566 4.5%2c10.7431702 L4.5%2c14.4497475 L8.44795857%2c10.5017889 C8.74085178%2c10.2088957 9.21572552%2c10.2088957 9.50861874%2c10.5017889 C9.80151196%2c10.7946821 9.80151196%2c11.2695559 9.50861874%2c11.5624491 L5.57106781%2c15.5 L9.25%2c15.5 C9.66421356%2c15.5 10%2c15.8357864 10%2c16.25 C10%2c16.6642136 9.66421356%2c17 9.25%2c17 L3.75%2c17 C3.33578644%2c17 3%2c16.6642136 3%2c16.25 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e7%bc%a9%e5%b0%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-622.000000%2c -558.000000)'%3e %3cg id='Group-24-Copy' transform='translate(622.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M7.44974747%2c11.5068298 L3.77827644%2c11.5068298 C3.36406288%2c11.5068298 3.02827644%2c11.1710434 3.02827644%2c10.7568298 C3.02827644%2c10.3426163 3.36406288%2c10.0068298 3.77827644%2c10.0068298 L9.27827644%2c10.0068298 C9.69249001%2c10.0068298 10.0282764%2c10.3426163 10.0282764%2c10.7568298 C10.0282663%2c10.7591042 10.0282764%2c10.7613808 10.0282764%2c10.7636597 L10.0282764%2c16.2636597 C10.0282764%2c16.6778732 9.69249001%2c17.0136597 9.27827644%2c17.0136597 C8.86406288%2c17.0136597 8.52827644%2c16.6778732 8.52827644%2c16.2636597 L8.52827644%2c12.5496212 L4.59099026%2c16.4869074 C4.29809704%2c16.7798006 3.8232233%2c16.7798006 3.53033009%2c16.4869074 C3.23743687%2c16.1940142 3.23743687%2c15.7191404 3.53033009%2c15.4262472 L7.44974747%2c11.5068298 Z M11.5%2c7.46403847 L15.4372862%2c3.52675228 C15.7301794%2c3.23385906 16.2050531%2c3.23385906 16.4979464%2c3.52675228 C16.7908396%2c3.8196455 16.7908396%2c4.29451923 16.4979464%2c4.58741245 L12.578529%2c8.50682984 L16.25%2c8.50682984 C16.6642136%2c8.50682984 17%2c8.84261627 17%2c9.25682984 C17%2c9.6710434 16.6642136%2c10.0068298 16.25%2c10.0068298 L10.75%2c10.0068298 C10.3357864%2c10.0068298 10%2c9.6710434 10%2c9.25682984 C10.0000102%2c9.25455545 10%2c9.25227891 10%2c9.25 L10%2c3.75 C10%2c3.33578644 10.3357864%2c3 10.75%2c3 C11.1642136%2c3 11.5%2c3.33578644 11.5%2c3.75 L11.5%2c7.46403847 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e4%b8%8b%e8%bd%bd copy%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%99%84%e4%bb%b6%e6%b7%bb%e5%8a%a0%e5%a4%8d%e5%88%b6%e9%93%be%e6%8e%a5' transform='translate(-369.000000%2c -555.000000)' fill='%23747272'%3e %3cg id='%e4%b8%8a%e4%bc%a0%e9%99%84%e4%bb%b6%e4%b8%ad-copy-6' transform='translate(56.000000%2c 534.000000)'%3e %3cg id='%e4%b8%8b%e8%bd%bd-copy' transform='translate(312.000000%2c 20.000000)'%3e %3cpath d='M8.81079102%2c8.49228232 L11.0575929%2c6.23659883 C11.367661%2c5.92438892 11.8514298%2c5.89865471 12.1342183%2c6.18304917 C12.4189783%2c6.46942638 12.3934758%2c6.95251315 12.0816605%2c7.26648227 L8.65828197%2c10.7033935 C8.57058276%2c10.8187868 8.45021995%2c10.9080019 8.31097304%2c10.9572592 C8.23162324%2c10.986943 8.14990291%2c11.0008681 8.06879562%2c10.9999582 C8.06613072%2c10.999986 8.0634625%2c11 8.06079102%2c11 C8.05811953%2c11 8.05545131%2c10.999986 8.05278641%2c10.9999582 C7.97167912%2c11.0008681 7.88995879%2c10.986943 7.81060899%2c10.9572592 C7.67136208%2c10.9080019 7.55099928%2c10.8187868 7.46330006%2c10.7033935 L4.03992152%2c7.26648227 C3.72810619%2c6.95251315 3.70260373%2c6.46942638 3.98736375%2c6.18304917 C4.27015222%2c5.89865471 4.75392098%2c5.92438892 5.06398917%2c6.23659883 L7.31079102%2c8.49228232 L7.31079102%2c1.75 C7.31079102%2c1.33578644 7.64657745%2c1 8.06079102%2c1 C8.47500458%2c1 8.81079102%2c1.33578644 8.81079102%2c1.75 L8.81079102%2c8.49228232 Z M15%2c11.0225156 L15%2c13 C15%2c14.1045695 14.1045695%2c15 13%2c15 L3%2c15 C1.8954305%2c15 1%2c14.1045695 1%2c13 L1%2c11 L1.00152941%2c11 C1.00051495%2c10.9840173 1%2c10.9678989 1%2c10.9516602 C1%2c10.5365365 1.33652425%2c10.2000122 1.75164795%2c10.2000122 C2.16677165%2c10.2000122 2.5032959%2c10.5365365 2.5032959%2c10.9516602 C2.5032959%2c10.9755555 2.50218087%2c10.9991903 2.5%2c11.0225156 L2.5%2c12.5 C2.5%2c13.0522847 2.94771525%2c13.5 3.5%2c13.5 L12.5%2c13.5 C13.0522847%2c13.5 13.5%2c13.0522847 13.5%2c12.5 L13.5%2c11 L13.5015294%2c11 C13.5005149%2c10.9840173 13.5%2c10.9678989 13.5%2c10.9516602 C13.5%2c10.5365365 13.8365242%2c10.2000122 14.2516479%2c10.2000122 C14.6667716%2c10.2000122 15.0032959%2c10.5365365 15.0032959%2c10.9516602 C15.0032959%2c10.9755555 15.0021809%2c10.9991903 15%2c11.0225156 Z' id='%e4%b8%8b%e8%bd%bd'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

function video_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function video_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function video_extension_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_extension_getPrototypeOf(o) {
    video_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return video_extension_getPrototypeOf(o);
}
function video_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) video_extension_setPrototypeOf(subClass, superClass);
}
function video_extension_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_extension_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function video_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function video_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        video_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function video_extension_possibleConstructorReturn(self, call) {
    if (call && (video_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return video_extension_assertThisInitialized(self);
}
function video_extension_setPrototypeOf(o, p) {
    video_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return video_extension_setPrototypeOf(o, p);
}
var video_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function video_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function video_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = video_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = video_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = video_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return video_extension_possibleConstructorReturn(this, result);
    };
}
var VIDEO_DEFAULT_WIDTH = 512;
var VIDEO_DEFAULT_HEIGHT = 288;
var PROGRESS_DEFAULT_WIDTH = 235;
// const { isMobile } = getSystemInfo(); // isMobile主要用于toView场景的处理
var getPositiveNumber = function(num) {
    return num < 0 ? 0 : num;
};
var video_extension_Video = /*#__PURE__*/ function(Component) {
    video_extension_inherits(Video, Component);
    var _super = video_extension_createSuper(Video);
    function Video(props) {
        video_extension_classCallCheck(this, Video);
        var _this;
        _this = _super.call(this, props);
        _this.isOnProgressMouseDown = false // 鼠标是否在视频进度条按下状态
        ;
        _this.isOnVolumeMouseDown = false // 鼠标是否在volumeBar（音量条）按下状态
        ;
        _this.state = {
            init: true,
            volume: 0.5,
            isMute: false,
            progress: 0,
            playing: 0,
            current: "00:00",
            total: "00:00",
            isPlay: false,
            hasTip: false,
            tipInfo: {
                // 鼠标在进度条上的时间提示
                time: "00:00",
                offsetX: 0
            },
            showToolBar: true,
            showVolumeBar: false,
            isFullScreen: false,
            isError: false,
            progressWidth: PROGRESS_DEFAULT_WIDTH,
            downloadStatus: 0,
            isResizing: false
        };
        _this.observer = null // 增加observer订阅侧边栏变化的事件，更新进度条实际宽度。目前没有想到更好的办法解决这个问题
        ;
        /**
   * 全屏
   */ _this.handleFullScreenChange = function() {
            var isFullScreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen || document.msIsFullScreen;
            if (!isFullScreen) _this.setState({
                isFullScreen: false
            });
        };
        /**
   * 切换播放暂停
   */ _this.togglePlay = function() {
            var isPlay = _this.state.isPlay;
            _this.setState({
                isPlay: !isPlay
            });
            if (isPlay) {
                var _this_video;
                (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.pause();
            } else {
                document.querySelectorAll("audio").forEach(function(otherAudio) {
                    return otherAudio.pause();
                });
                document.querySelectorAll("video").forEach(function(otherVideo) {
                    return otherVideo !== _this.video && otherVideo.pause();
                });
                // this.video && this.video.play()
                if (_this.video) {
                    var playPromise = _this.video.play();
                    if (playPromise !== undefined) {
                        playPromise.then(function() {}).catch(function(e) {
                            console.error(e);
                        });
                    }
                }
            }
        };
        /**
   * 浏览器可以开始播放时触发
   */ _this.handleCanPlay = function() {
            var duration = getPositiveNumber(_this.video.duration);
            var total = formatTime(duration);
            _this.setState({
                total: total
            });
        };
        /**
   * 视频正在下载触发
   */ _this.handleProgress = function() {
            if (_this.video.buffered.length <= 0) {
                return;
            }
            var progress = getPositiveNumber(_this.video.buffered.end(0) / _this.video.duration);
            _this.setState({
                progress: progress
            });
        };
        /**
   * 视频暂停时触发
   */ _this.handlePause = function() {
            if (document.hidden) return;
            var _this_state = _this.state, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar;
            if (isPlay) {
                _this.setState({
                    isPlay: false
                });
            }
            if (!showToolBar) _this.setState({
                showToolBar: true
            });
        };
        /**
   * 播放位置改变重新定位
   */ _this.handleTimeUpdate = function() {
            var currentTime = getPositiveNumber(_this.video.currentTime);
            var current = formatTime(currentTime);
            var playing = currentTime / _this.video.duration;
            _this.setState({
                current: current,
                playing: playing
            });
            var init = _this.state.init;
            if (init) _this.setState({
                init: false
            });
        };
        _this.handleVideoMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 视频区域鼠标移动响应，进度条拖动则更新进度
   */ _this.handleVideoMouseMove = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth, showToolBar = _this_state.showToolBar;
            var left = _this.progressBar.getBoundingClientRect().left;
            var zoom = _this.props.zoom;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
            var newCurrentTime = getPositiveNumber(dis / calculateProgressWidth * _this.video.duration);
            if (_this.isOnProgressMouseDown) {
                _this.video.currentTime = newCurrentTime;
                _this.handleTimeUpdate();
            }
            if (!showToolBar) _this.setState({
                showToolBar: true
            });
            _this.toggleToolbarDebounce();
        };
        _this.handleVideoMouseLeave = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 鼠标按下进度条某处
   */ _this.handleProgressBarMouseDown = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth;
            var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = getPositiveNumber(dis / calculateProgressWidth * _this.video.duration);
            _this.video.currentTime = newCurrentTime;
            _this.isOnProgressMouseDown = true;
            e.preventDefault();
        };
        /**
   * 进度条上的鼠标释放
   */ _this.handleProgressBarMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 进度条区域鼠标移动响应，设置鼠标位置时间提示
   */ _this.handleProgressMouseMove = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth;
            var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = dis / calculateProgressWidth * _this.video.duration;
            if (newCurrentTime > _this.video.duration || newCurrentTime < 0) {
                _this.setState({
                    hasTip: false
                });
                return;
            }
            _this.setState({
                hasTip: true,
                tipInfo: {
                    time: formatTime(newCurrentTime),
                    offsetX: dis
                }
            });
        };
        /**
   * 在音量条按下鼠标后移动调整音量
   */ _this.handleVolumeBarMouseDown = function(e) {
            var bottom = _this.volumeBar.getBoundingClientRect().bottom;
            var zoom = _this.props.zoom;
            var clientY = e.nativeEvent.clientY / zoom;
            var dis = bottom - clientY;
            var volume = (dis > 0 ? dis : 0) / 80;
            volume = volume > 1 ? 1 : volume;
            _this.video.volume = volume;
            _this.setState({
                volume: volume,
                isMute: false
            });
            _this.isOnVolumeMouseDown = true;
            e.preventDefault();
        };
        /**
   * 音量条上的鼠标释放
   */ _this.handleVolumeBarMouseUp = function() {
            _this.isOnVolumeMouseDown = false;
        };
        /**
   * 在音量条按下鼠标后移动调整音量
   */ _this.handleVolumeBarMouseMove = function(e) {
            if (_this.isOnVolumeMouseDown) {
                _this.handleVolumeBarMouseDown(e);
            }
        };
        _this.showVolumeBar = function() {
            _this.setState({
                showVolumeBar: true
            });
        };
        _this.hideVolumeBar = function() {
            _this.setState({
                showVolumeBar: false
            });
        };
        /**
   * 静音切换
   */ _this.toggleMute = function() {
            var _this_state = _this.state, volume = _this_state.volume, isMute = _this_state.isMute;
            if (isMute) {
                _this.video.volume = volume;
                _this.setState({
                    isMute: false
                });
            } else {
                _this.video.volume = 0;
                _this.setState({
                    isMute: true
                });
            }
        };
        /**
   * 双击全屏切换
   */ _this.toggleScale = function() {
            var isFullScreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen || document.msIsFullScreen;
            if (isFullScreen) {
                var efs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
                if (efs) {
                    efs.call(document);
                }
            } else {
                var rfs = _this.video.requestFullscreen || _this.video.webkitRequestFullscreen || _this.video.mozRequestFullScreen || _this.video.msRequestFullscreen;
                if (rfs) {
                    rfs.call(_this.video.parentElement.parentElement);
                }
                _this.setState({
                    isFullScreen: true
                });
            }
        };
        /**
   * 切换toolbar(视频下方工具栏包括进度条音量等)展示隐藏
   */ _this.toggleToolbar = function() {
            var _this_state = _this.state, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar;
            if (isPlay && showToolBar) {
                _this.setState({
                    showToolBar: false
                });
            }
        };
        /**
   * 处理视频文件下载
   */ _this.handleDownload = function() {
            var _provider_handleUrl;
            var downloadStatus = _this.state.downloadStatus;
            if (downloadStatus === 1) return;
            var _this_props = _this.props, url = _this_props.url, name = _this_props.name, provider = _this_props.provider;
            var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
            provider.download(src, name);
        };
        _this.handleDragStart = function(e) {
            e.preventDefault();
        };
        /**
   * 视频文件异常错误处理，可以做一些异常上报的工作
   */ _this.handleError = function() {
            _this.setState({
                isError: true
            });
            var _this_props = _this.props, handleVideoError = _this_props.provider.handleVideoError, url = _this_props.url;
            // 提供给业务方进行视频错误处理
            handleVideoError === null || handleVideoError === void 0 ? void 0 : handleVideoError(_this.video.error, url);
        };
        /**
   * 文件获取失败重试
   */ _this.handleRetry = function() {
            _this.setState({
                isError: false
            });
        };
        _this.handleResizeStart = function() {
            _this.setState({
                isResizing: true
            });
        };
        /**
   * 调整完成后调用
   * @param size object 包括调整后的width、height
   */ _this.handleResizeEnd = function(size) {
            var _this_video;
            var _this_props = _this.props, view = _this_props.view, getPos = _this_props.getPos;
            var state = view.state, dispatch = view.dispatch;
            var tr = state.tr, doc = state.doc;
            var pos = getPos();
            var node = doc.nodeAt(pos);
            dispatch(tr.setNodeMarkup(pos, null, video_extension_objectSpreadProps(video_extension_objectSpread$2({}, node.attrs), {
                width: size.width,
                height: size.height
            })).setSelection(prosemirror_state_dist["NodeSelection"].create(tr.doc, pos)) // 重新设置选区
            );
            // 调整视频宏大小后需要重置进度
            _this.setState({
                current: "00:00",
                isPlay: false,
                playing: 0,
                progress: 0,
                progressWidth: _this.progressBar.clientWidth,
                isResizing: false
            });
            _this.video.currentTime = 0;
            (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.pause();
        };
        _this.toggleToolbarDebounce = lodash_debounce_default()(_this.toggleToolbar, 3e3);
        return _this;
    }
    var _proto = Video.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        if (document.exitFullscreen) {
            document.addEventListener("fullscreenchange", this.handleFullScreenChange);
        } else if (document.webkitExitFullscreen) {
            document.addEventListener("webkitfullscreenchange", this.handleFullScreenChange);
        } else if (document.mozCancelFullScreen) {
            document.addEventListener("mozfullscreenchange", this.handleFullScreenChange);
        } else if (document.exitFullscreen) {
            document.addEventListener("MSFullscreenChange", this.handleFullScreenChange);
        }
        // if (!isMobile) {
        this.timer = setTimeout(function() {
            var _this_progressBar;
            if (((_this_progressBar = _this.progressBar) === null || _this_progressBar === void 0 ? void 0 : _this_progressBar.clientWidth) !== PROGRESS_DEFAULT_WIDTH) {
                _this.setState({
                    progressWidth: _this.progressBar.clientWidth
                });
            }
            // observer相关代码
            var target = document.querySelector(".resize-box");
            if (target) {
                var config = {
                    attributes: true
                };
                var resetWidth = function() {
                    if (_this.progressBar) {
                        _this.setState({
                            progressWidth: _this.progressBar.clientWidth
                        });
                    }
                };
                _this.observer = new MutationObserver(resetWidth);
                _this.observer.observe(target, config);
            }
        }, 0);
    // }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (document.exitFullscreen) {
            document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
        } else if (document.webkitExitFullscreen) {
            document.removeEventListener("webkitfullscreenchange", this.handleFullScreenChange);
        } else if (document.mozCancelFullScreen) {
            document.removeEventListener("mozfullscreenchange", this.handleFullScreenChange);
        } else if (document.msExitFullscreen) {
            document.removeEventListener("MSFullscreenChange", this.handleFullScreenChange);
        }
        this.timer && clearTimeout(this.timer);
        // !isMobile && this.observer && this.observer.disconnect();
        this.observer && this.observer.disconnect();
    };
    _proto.render = function render() {
        var _this = this;
        var _provider_handleUrl;
        var _this_props = this.props, url = _this_props.url, width = _this_props.width, height = _this_props.height, view = _this_props.view, getPos = _this_props.getPos, provider = _this_props.provider, resizer = _this_props.resizer;
        var _this_state = this.state, init = _this_state.init, volume = _this_state.volume, isMute = _this_state.isMute, progress = _this_state.progress, playing = _this_state.playing, current = _this_state.current, total = _this_state.total, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar, showVolumeBar = _this_state.showVolumeBar, isFullScreen = _this_state.isFullScreen, isError = _this_state.isError, hasTip = _this_state.hasTip, _this_state_tipInfo = _this_state.tipInfo, time = _this_state_tipInfo.time, offsetX = _this_state_tipInfo.offsetX, downloadStatus = _this_state.downloadStatus, progressWidth = _this_state.progressWidth, isResizing = _this_state.isResizing;
        var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
        // 业务方可以对url进行加工处理
        var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
        var VIDEO_WIDTH = +width < VIDEO_DEFAULT_WIDTH ? VIDEO_DEFAULT_WIDTH : +width;
        var VIDEO_HEIGHT = +height < VIDEO_DEFAULT_HEIGHT ? VIDEO_DEFAULT_HEIGHT : +height;
        var style = {
            width: "".concat(VIDEO_WIDTH, "px"),
            height: "".concat(VIDEO_HEIGHT, "px")
        };
        // const isPrint = window.location.href.includes("print"); // 是否为打印页面
        // if (isError && !isPrint) {
        if (isError) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                className: "".concat(video_extension_classNamePrefix("video-view"), " error"),
                style: style
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "notice",
                "data-src": src
            }, window.navigator.onLine ? "文件获取失败" : "网络连接失败"), /*#__PURE__*/ react_default.a.createElement("button", {
                className: "retry ".concat(video_extension_classNamePrefix("btn")),
                onClick: this.handleRetry
            }, "重试"));
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: video_extension_classNamePrefix("video-view"),
            style: style,
            onMouseUp: this.handleVideoMouseUp,
            onMouseMove: this.handleVideoMouseMove,
            onMouseLeave: this.handleVideoMouseLeave,
            onDragStart: this.handleDragStart,
            ref: function(ref) {
                _this.videoWrapper = ref;
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("middle", {
                pause: !isPlay
            }),
            onClick: this.togglePlay
        }, /*#__PURE__*/ react_default.a.createElement("video", {
            ref: function(ref) {
                _this.video = ref;
            },
            src: src,
            preload: "meta",
            volume: isMute ? 0 : volume,
            onCanPlay: this.handleCanPlay,
            onProgress: this.handleProgress,
            onTimeUpdate: this.handleTimeUpdate,
            onPause: this.handlePause,
            onDoubleClick: this.toggleScale,
            onError: this.handleError
        }, "本浏览器不支持 HTML5 video 标签")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("bottom", {
                hidden: !showToolBar
            })
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "play-btn",
            onClick: this.togglePlay
        }, !isPlay ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img,
            alt: "播放"
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$1,
            alt: "暂停"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-bar",
            ref: function(ref) {
                _this.progressBar = ref;
            },
            onMouseDown: this.handleProgressBarMouseDown,
            onMouseMove: this.handleProgressMouseMove,
            onMouseLeave: function() {
                return _this.setState({
                    hasTip: false
                });
            },
            style: isResizing ? {
                overflow: "hidden"
            } : {}
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "load-bar",
            style: {
                width: "".concat(init ? 0 : progress * calculateProgressWidth, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-bar", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                width: "".concat(playing * calculateProgressWidth, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-button", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                left: "".concat(playing * calculateProgressWidth, "px")
            }
        }), hasTip && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip-wrapper",
            style: {
                left: "".concat(offsetX - 22, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip"
        }, time))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "time"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "current"
        }, current), /*#__PURE__*/ react_default.a.createElement("span", null, "/"), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "total"
        }, total)), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-btn",
            onMouseEnter: this.showVolumeBar,
            onMouseLeave: this.hideVolumeBar,
            onDragStart: this.handleDragStart
        }, isMute || volume < 0.01 ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$3,
            alt: "静音",
            onClick: this.toggleMute
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$2,
            alt: "音量",
            onClick: this.toggleMute
        }), showVolumeBar && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar-wrapper",
            onMouseMove: this.handleVolumeBarMouseMove,
            onMouseUp: this.handleVolumeBarMouseUp
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar",
            ref: function(ref) {
                _this.volumeBar = ref;
            },
            onMouseDown: this.handleVolumeBarMouseDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "selected-bar",
            style: {
                height: "".concat(isMute ? 0 : volume * 80, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bar-btn"
        }))))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "scale-btn",
            onClick: this.toggleScale
        }, isFullScreen ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$5,
            alt: "缩小"
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$4,
            alt: "缩小"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("download-btn", {
                error: downloadStatus === 2,
                "video-loading": downloadStatus === 1
            }),
            onClick: this.handleDownload
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip"
        }, "下载失败，请重试")), /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$6,
            alt: "下载"
        }))), this.videoWrapper && resizer && /*#__PURE__*/ react_default.a.createElement(video_extension_Resizer, {
            $container: this.videoWrapper,
            view: view,
            getPos: getPos,
            initialWidth: VIDEO_WIDTH,
            initialHeight: VIDEO_HEIGHT,
            onResizeEnd: this.handleResizeEnd,
            onResizeStart: this.handleResizeStart,
            limit: {
                minWidth: VIDEO_DEFAULT_WIDTH,
                minHeight: VIDEO_DEFAULT_HEIGHT
            },
            fixedRatio: false,
            hideInfo: true
        }));
    };
    return Video;
}(react["Component"]);
video_extension_Video.defaultProps = {
    zoom: 1,
    resizer: true
};

var video_extension_css_248z$1 = '.ct-video{margin:8px 0;max-width:100%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ct-video.align-center{margin:0 auto}.ct-video.align-right{float:right;margin-top:0}.ct-video.align-right+*,.ct-video.align-right+div+span+*{clear:both}.ct-video-view{background:#f6f6f6;border:1px solid #ddd;height:288px;max-width:100%;min-height:288px;min-width:512px;position:relative;width:512px}.ct-video-view img{vertical-align:unset}.ct-video-view:hover{border:1px solid #3d91f2;cursor:pointer}.ct-video-view .middle{background:#000;height:100%;width:100%}.ct-video-view .middle:after{content:"";opacity:0;position:absolute;transition:opacity .3s ease}.ct-video-view .middle video{display:block;height:100%;width:100%}.ct-video-view .middle.pause{position:relative}.ct-video-view .middle.pause:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2220px%22 viewBox%3D%220 0 18 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%A2%84%E8%A7%88%E6%92%AD%E6%94%BE%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard-2%22 transform%3D%22translate(-446.000000%2C -115.000000)%22 fill%3D%22%236B6B6B%22%3E            %3Cg id%3D%22Group-12%22 transform%3D%22translate(446.000000%2C 115.000000)%22%3E                %3Cpath d%3D%22M17.5258914%2C10.7953904 L1.4484631%2C19.8724989 C0.990863649%2C20.1308537 0.401755017%2C19.9841502 0.132652138%2C19.5448276 C0.0457979589%2C19.4030342 0%2C19.2415294 0%2C19.0770349 L3.41490118e-15%2C0.922817934 C3.41490118e-15%2C0.413159662 0.430348031%2C0 0.961209231%2C0 C1.1325471%2C0 1.30077079%2C0.0439687597 1.4484631%2C0.127353928 L17.5258914%2C9.20446242 C17.9834908%2C9.46281716 18.1362975%2C10.0283964 17.8671946%2C10.4677191 C17.7843081%2C10.603035 17.6668367%2C10.7158145 17.5258914%2C10.7953904 Z%22 id%3D%22Triangle-2%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 23px;background-color:#fff;border-radius:50%;height:60px;left:50%;margin-left:-30px;margin-top:-30px;opacity:1;top:50%;transition:opacity .3s ease;width:60px}.ct-video-view .middle.pause:before{background:rgba(0,0,0,.5);bottom:0;content:"";left:0;position:absolute;right:0;top:0}.ct-video-view .middle.pause:hover:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2220px%22 viewBox%3D%220 0 18 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%A2%84%E8%A7%88%E6%92%AD%E6%94%BE%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard-2%22 transform%3D%22translate(-446.000000%2C -115.000000)%22 fill%3D%22%2323bdd9%22%3E            %3Cg id%3D%22Group-12%22 transform%3D%22translate(446.000000%2C 115.000000)%22%3E                %3Cpath d%3D%22M17.5258914%2C10.7953904 L1.4484631%2C19.8724989 C0.990863649%2C20.1308537 0.401755017%2C19.9841502 0.132652138%2C19.5448276 C0.0457979589%2C19.4030342 0%2C19.2415294 0%2C19.0770349 L3.41490118e-15%2C0.922817934 C3.41490118e-15%2C0.413159662 0.430348031%2C0 0.961209231%2C0 C1.1325471%2C0 1.30077079%2C0.0439687597 1.4484631%2C0.127353928 L17.5258914%2C9.20446242 C17.9834908%2C9.46281716 18.1362975%2C10.0283964 17.8671946%2C10.4677191 C17.7843081%2C10.603035 17.6668367%2C10.7158145 17.5258914%2C10.7953904 Z%22 id%3D%22Triangle-2%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 23px;background-color:#fff}.ct-video-view .bottom{background:#f6f6f6;bottom:0;display:flex;height:40px;padding:0 16px;position:absolute;transition:opacity .5s ease;width:100%}.ct-video-view .bottom:hover{opacity:1}.ct-video-view .bottom.hidden{opacity:0}.ct-video-view .play-btn{cursor:pointer;height:18px;margin-top:11px;transition:all .1s ease;width:18px}.ct-video-view .play-btn:hover path{fill:#3d91f2}.ct-video-view .progress-bar{background:#d9d9d9;background-clip:content-box;border-radius:100px;cursor:pointer;flex:1;height:10px;margin:16px 16px 0;padding:3px 0;position:relative}.ct-video-view .load-bar{background:#b6b6b6;transition:all 3s linear;z-index:1}.ct-video-view .load-bar,.ct-video-view .played-bar{border-radius:100px;height:4px;position:absolute;top:3px;width:0}.ct-video-view .played-bar{background:#1c6cdc;transition:all .3s linear;z-index:2}.ct-video-view .played-bar.dragged{transition:none}.ct-video-view .played-button{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);height:12px;position:absolute;top:-2px;transition:all .3s linear;width:12px;z-index:10}.ct-video-view .played-button.dragged{transition:none}.ct-video-view .progress-tip-wrapper{height:28px;left:0;position:absolute;top:-27px;width:48px}.ct-video-view .progress-tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-video-view .progress-tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;width:0}.ct-video-view .progress-tip:after,.ct-video-view .progress-tip:before{content:"";display:block;position:absolute;right:50%;transform:translate(50%);z-index:2}.ct-video-view .progress-tip:before{background:rgba(0,0,0,.68);bottom:-9px;height:4px;width:1px}.ct-video-view .time{display:flex;justify-content:space-between;align-items:center;color:#333;font-size:12px;line-height:12px;text-align:right;width:80px}.ct-video-view .volume-btn{cursor:pointer;height:40px;margin:0 16px;padding-top:10px;position:relative;transition:all .1s ease;width:20px}.ct-video-view .volume-btn:hover path:first-child{fill:#3d91f2}.ct-video-view .volume-btn:hover path:nth-child(2){stroke:#3d91f2}.ct-video-view .volume-bar-wrapper{background:#fff;border-radius:2px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);height:102px;left:-15%;position:absolute;top:-102px;width:30px;z-index:9}.ct-video-view .volume-bar{background:#d9d9d9;border-radius:100px;height:80px;left:50%;position:absolute;top:11px;transform:translate(-50%);width:4px}.ct-video-view .selected-bar{background:#1c6cdc;border-radius:100px;bottom:0;height:0;position:absolute;transition:all .2s;width:4px;z-index:2}.ct-video-view .selected-bar .bar-btn{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);content:"";height:12px;position:absolute;right:-4px;top:-6px;width:12px}.ct-video-view .scale-btn{cursor:pointer;height:20px;margin-right:16px;margin-top:10px;transition:all .1s ease;width:20px}.ct-video-view .scale-btn:hover path{fill:#3d91f2}.ct-video-view .download-btn{cursor:pointer;height:24px;margin-top:10px;position:relative;transition:all .1s ease;width:25px}.ct-video-view .download-btn:hover path{fill:#3d91f2}.ct-video-view .download-btn .tip-wrapper{display:none;height:28px;left:7px;position:absolute;top:-30px}.ct-video-view .download-btn .tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-video-view .download-btn .tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;content:"";display:block;position:absolute;right:50%;transform:translate(50%);width:0;z-index:2}.ct-video-view .download-btn.video-loading:after{-webkit-animation:loading .8s linear infinite;animation:loading .8s linear infinite;border-radius:50%;border:2px solid #d5d5d5;content:"";display:inline-block;height:18px;vertical-align:-8%;width:18px}.ct-video-view .download-btn.video-loading svg{display:none}.ct-video-view .download-btn.error{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%228px%22 height%3D%228px%22 viewBox%3D%220 0 8 8%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3ECombined Shape%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Crect id%3D%22Rectangle-2%22 fill%3D%22%23FFFFFF%22 x%3D%222%22 y%3D%221%22 width%3D%224%22 height%3D%226%22%3E%3C%2Frect%3E        %3Cpath d%3D%22M0%2C4 C0%2C1.79088 1.79088%2C0 4%2C0 C6.20912%2C0 8%2C1.79088 8%2C4 C8%2C6.20912 6.20912%2C8 4%2C8 C1.79088%2C8 0%2C6.20912 0%2C4 Z M4.00000002%2C1.34999998 C3.34188252%2C1.34999998 2.87727375%2C1.67743076 3%2C2.5 L3.40000002%2C4.36638153 C3.40000002%2C4.69277782 3.66862917%2C4.96459961 4.00000002%2C4.96459961 C4.33368113%2C4.96459961 4.60000002%2C4.69676825 4.60000002%2C4.36638153 L5%2C2.5 C5.15197984%2C1.72235314 4.74297343%2C1.34999998 4.00000002%2C1.34999998 Z M4%2C6.65000002 C4.33137086%2C6.65000002 4.60000002%2C6.38137086 4.60000002%2C6.05 C4.60000002%2C5.71862914 4.33137086%2C5.44999998 4%2C5.44999998 C3.66862914%2C5.44999998 3.39999998%2C5.71862914 3.39999998%2C6.05 C3.39999998%2C6.38137086 3.66862914%2C6.65000002 4%2C6.65000002 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23F5222D%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 100% 0}.ct-video-view .download-btn.error:hover .tip-wrapper{display:block}.ct-video-view:-moz-full-screen{height:100%;width:100%}.ct-video-view:-moz-full-screen hover{border:none}.ct-video-view:-moz-full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:-moz-full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:full-screen{height:100%;width:100%}.ct-video-view:full-screen hover{border:none}.ct-video-view:full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:-webkit-full-screen{height:100%;width:100%}.ct-video-view:-ms-fullscreen{height:100%;width:100%}.ct-video-view:fullscreen{height:100%;width:100%}.ct-video-view:-webkit-full-screen hover{border:none}.ct-video-view:-ms-fullscreen hover{border:none}.ct-video-view:fullscreen hover{border:none}.ct-video-view:-webkit-full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:-ms-fullscreen .middle.pause:after{transform:scale(2)}.ct-video-view:fullscreen .middle.pause:after{transform:scale(2)}.ct-video-view:-webkit-full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:-ms-fullscreen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:fullscreen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ProseMirror-selectednode .ct-video-view{border:1px solid #1c6cdc}.ct-video-view.error{background:rgba(0,0,0,.5);font-size:14px}.ct-video-view.error .notice{color:#fff;margin-top:100px;text-align:center}.ct-video-view.error .retry{background:#1c6cdc;border:none;color:#fff;display:block;height:32px;line-height:32px;margin:24px auto 0;width:76px}.ct-video-view.mobile{border:1px solid #ddd;max-width:100%;min-width:0}.ct-video-view.mobile video{margin:0}';
video_extension_styleInject(video_extension_css_248z$1);

function video_extension_extends() {
    video_extension_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return video_extension_extends.apply(this, arguments);
}
var VideoView = function(props) {
    var attrs = props.attrs, provider = props.provider, view = props.view, getPos = props.getPos;
    var width = attrs.width, height = attrs.height;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()("".concat(video_extension_classNamePrefix("video")), {
            "align-center": attrs.align === "center",
            "align-right": attrs.align === "right"
        })
    }, /*#__PURE__*/ react_default.a.createElement(video_extension_Video, video_extension_extends({}, attrs, {
        width: width,
        height: height,
        provider: provider,
        view: view,
        getPos: getPos
    })));
};

var video_extension_img$7 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='24px' height='20px' viewBox='0 0 24 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3eGroup 3%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Artboard-3' transform='translate(-86.000000%2c -30.000000)' fill='%23BDC2C7'%3e %3cg id='Group-3' transform='translate(86.000000%2c 30.000000)'%3e %3cpath d='M1%2c0 L23%2c0 C23.5522847%2c-1.01453063e-16 24%2c0.44771525 24%2c1 L24%2c19 C24%2c19.5522847 23.5522847%2c20 23%2c20 L1%2c20 C0.44771525%2c20 6.76353751e-17%2c19.5522847 0%2c19 L0%2c1 C-6.76353751e-17%2c0.44771525 0.44771525%2c1.01453063e-16 1%2c0 Z M2%2c2 L2%2c18 L22%2c18 L22%2c2 L2%2c2 Z' id='Combined-Shape'%3e%3c/path%3e %3cpath d='M4%2c6 L2%2c6 L2%2c4 L4%2c4 L4%2c2 L6%2c2 L6%2c18 L4%2c18 L4%2c16 L2%2c16 L2%2c14 L4%2c14 L4%2c11 L2%2c11 L2%2c9 L4%2c9 L4%2c6 Z M20%2c11 L20%2c14 L22%2c14 L22%2c16 L20%2c16 L20%2c18 L18%2c18 L18%2c2 L20%2c2 L20%2c4 L22%2c4 L22%2c6 L20%2c6 L20%2c9 L22%2c9 L22%2c11 L20%2c11 Z M9.7906191%2c5.56472793 L15.4303866%2c9.59313326 C15.6550929%2c9.75363776 15.7071387%2c10.0659128 15.5466342%2c10.2906191 C15.5145644%2c10.3355169 15.4752843%2c10.3747969 15.4303866%2c10.4068667 L9.7906191%2c14.4352721 C9.5659128%2c14.5957766 9.25363776%2c14.5437307 9.09313326%2c14.3190244 C9.03256157%2c14.2342241 9%2c14.1326168 9%2c14.0284053 L9%2c5.97159466 C9%2c5.69545229 9.22385763%2c5.47159466 9.5%2c5.47159466 C9.60421149%2c5.47159466 9.70581872%2c5.50415623 9.7906191%2c5.56472793 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_img$8 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 45.1 (43504) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3etost-%e9%94%99%e8%af%af%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Artboard' transform='translate(-296.000000%2c -544.000000)' fill='%23F05E50'%3e %3cpath fill='%23F05E50' d='M304%2c544 C308.41824%2c544 312%2c547.58176 312%2c552 C312%2c556.41824 308.41824%2c560 304%2c560 C299.58176%2c560 296%2c556.41824 296%2c552 C296%2c547.58176 299.58176%2c544 304%2c544 Z M299.2%2c552 C299.2%2c552.667362 299.735663%2c553.2 300.396436%2c553.2 L307.603564%2c553.2 C308.256356%2c553.2 308.8%2c552.662742 308.8%2c552 C308.8%2c551.332638 308.264337%2c550.8 307.603564%2c550.8 L300.396436%2c550.8 C299.743644%2c550.8 299.2%2c551.337258 299.2%2c552 Z' id='tost-%e9%94%99%e8%af%af'%3e%3c/path%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var video_extension_css_248z$2 = ".selected .ct-upload-video{border:1px solid #118bfb}.ct-upload-video{background-color:#f6f6f6;border:1px solid #ddd;color:unset;display:block;height:288px;outline:none;text-align:left;text-decoration:none;transition:all .1s ease;width:512px}.ct-upload-video:active{border:1px solid #1253b5}.ct-upload-video:hover{border:1px solid #3d91f2}.ct-upload-video .icon{margin-top:85px;text-align:center}.ct-upload-video .name{-webkit-box-orient:vertical;-webkit-line-clamp:1;color:#333;display:-webkit-box;font-size:12px;line-height:18px;margin:22px auto;overflow:hidden;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:400px}.ct-upload-video .info{display:flex;justify-content:space-between;margin:0 auto;width:200px}.ct-upload-video .progress-container{text-align:center}.ct-upload-video .progress-wrapper{background-color:hsla(0,0%,86.7%,0);border-radius:6px;border:1px solid #ddd;display:inline-block;height:8px;position:relative;width:200px}.ct-upload-video .progress{background-color:#1253b5;border-radius:6px;border:1px solid #1253b5;box-shadow:0 2px 8px 0 rgba(71,134,255,.24);height:8px;left:0;position:absolute;top:-1px}.ct-upload-video .percent,.ct-upload-video .size{color:#999;display:inline-block;font-size:12px;line-height:12px}.ct-upload-video .percent,.ct-upload-video .reupload,.ct-upload-video .size{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-upload-video .reupload{font-size:14px;display:flex;justify-content:center}.ct-upload-video .reupload svg{vertical-align:-12%}.ct-upload-video .reupload .retry-btn{margin-left:5px;cursor:pointer;color:#40a9ff}";
video_extension_styleInject(video_extension_css_248z$2);

function video_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function video_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function video_extension_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                video_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                video_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function video_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function video_extension_getPrototypeOf$1(o) {
    video_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return video_extension_getPrototypeOf$1(o);
}
function video_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) video_extension_setPrototypeOf$1(subClass, superClass);
}
function video_extension_possibleConstructorReturn$1(self, call) {
    if (call && (video_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return video_extension_assertThisInitialized$1(self);
}
function video_extension_setPrototypeOf$1(o, p) {
    video_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return video_extension_setPrototypeOf$1(o, p);
}
var video_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function video_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function video_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = video_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = video_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = video_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return video_extension_possibleConstructorReturn$1(this, result);
    };
}
var video_extension_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var video_extension_VideoPlaceholder = /*#__PURE__*/ function(Component) {
    video_extension_inherits$1(VideoPlaceholder, Component);
    var _super = video_extension_createSuper$1(VideoPlaceholder);
    function VideoPlaceholder() {
        video_extension_classCallCheck$1(this, VideoPlaceholder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            progress: 0,
            hasError: false,
            loaded: "0MB",
            uploadDone: false,
            transcodeDone: false
        };
        _this.onRetry = null;
        // 修改进度
        _this.setProgress = function(progress) {
            _this.setState({
                progress: progress
            });
        };
        // 修改错误状态
        _this.setHasError = function(hasError) {
            _this.setState({
                hasError: hasError
            });
        };
        // 修改已加载大小
        _this.setLoaded = function(loaded) {
            _this.setState({
                loaded: loaded
            });
        };
        var _this1 = video_extension_assertThisInitialized$1(_this);
        // 修改上传状态
        _this.setUploadDone = function() {
            var _ref = video_extension_asyncToGenerator$1(function(uploadDone) {
                return video_extension_generator$1(this, function(_state) {
                    _this1.setState({
                        uploadDone: uploadDone
                    });
                    return [
                        2
                    ];
                });
            });
            return function(uploadDone) {
                return _ref.apply(this, arguments);
            };
        }();
        // 修改转码状态
        _this.setTranscodeDone = function(transcodeDone) {
            _this.setState({
                transcodeDone: transcodeDone
            });
        };
        // 重新上传
        _this.retry = function() {
            var onRetry = video_extension_assertThisInitialized$1(_this).onRetry;
            _this.setState({
                hasError: false
            }, function() {
                return onRetry && onRetry();
            });
        };
        return _this;
    }
    var _proto = VideoPlaceholder.prototype;
    _proto.render = function render() {
        var _this_props = this.props, _this_props_name = _this_props.name, name = _this_props_name === void 0 ? "未命名" : _this_props_name, size = _this_props.size;
        var _this_state = this.state, progress = _this_state.progress, loaded = _this_state.loaded, hasError = _this_state.hasError, uploadDone = _this_state.uploadDone, transcodeDone = _this_state.transcodeDone;
        var fakeDone = loaded === size;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: video_extension_classNamePrefix("upload-video")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "icon"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$7,
            alt: "视频"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, name), !hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "info"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "size"
        }, video_extension_formatFileSize(loaded), " / ", size), !transcodeDone && /*#__PURE__*/ react_default.a.createElement("span", {
            className: "percent"
        }, fakeDone && size ? "99%" : "".concat(progress, "%"))), !hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-container"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "progress-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "progress",
            style: {
                width: "".concat(progress, "%")
            }
        }))), !hasError && uploadDone && !transcodeDone && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, "视频正在转码中，如文件较大可能时间较长，请耐心等待…"), hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "reupload"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: video_extension_img$8,
            alt: "上传失败，"
        }), /*#__PURE__*/ react_default.a.createElement("span", null, "上传失败，"), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "retry-btn",
            onClick: this.retry
        }, "重试")));
    };
    return VideoPlaceholder;
}(react["Component"]);

/**
 * 创建上传视频占位区域
 *
 */ var video_extension_createPlaceholder = function(idMap) {
    return function(param, id) {
        var file = param.file;
        var widget = document.createElement("div");
        widget.setAttribute("data-type", "ct-progress");
        var name = file.name;
        // 渲染组件，并将组件的实例存入 idMap 中，以 id 为 key
        react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(video_extension_VideoPlaceholder, {
            id: id,
            name: name,
            file: file,
            size: video_extension_formatFileSize(file.size),
            ref: function(ref) {
                idMap[id] = ref;
            }
        }), widget);
        return widget;
    };
};

function video_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function video_extension_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function video_extension_asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                video_extension_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                video_extension_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function video_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function video_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function video_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) video_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) video_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function video_extension_getPrototypeOf$2(o) {
    video_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return video_extension_getPrototypeOf$2(o);
}
function video_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) video_extension_setPrototypeOf$2(subClass, superClass);
}
function video_extension_possibleConstructorReturn$2(self, call) {
    if (call && (video_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return video_extension_assertThisInitialized$2(self);
}
function video_extension_setPrototypeOf$2(o, p) {
    video_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return video_extension_setPrototypeOf$2(o, p);
}
var video_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function video_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function video_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = video_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = video_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = video_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return video_extension_possibleConstructorReturn$2(this, result);
    };
}
var video_extension_generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var video_extension_idMap = {};
var video_extension_VideoExtension = /*#__PURE__*/ function(NodeExtension) {
    video_extension_inherits$2(VideoExtension, NodeExtension);
    var _super = video_extension_createSuper$2(VideoExtension);
    function VideoExtension() {
        video_extension_classCallCheck$2(this, VideoExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = VideoView;
        return _this;
    }
    var _proto = VideoExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state_dist["Plugin"](video_extension_UploaderOption({
            key: video_extension_pluginKey
        }, {
            createUploadMask: video_extension_createPlaceholder(video_extension_idMap)
        }));
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, providers = param.providers, editorEventEmitter = param.editorEventEmitter;
        var _this = this;
        return {
            isDisabled: function() {
                return function() {
                    return !video_extension_canInsertTypes(getState());
                };
            },
            upload: function() {
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    video_extension_selectFile({
                        accept: "video/*",
                        multiple: true
                    }).then(function() {
                        var _ref = video_extension_asyncToGenerator$2(function(files) {
                            var _tmp, len, i;
                            return video_extension_generator$2(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = provider.onSelectFiles;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            provider.onSelectFiles(files)
                                        ];
                                    case 1:
                                        _tmp = !_state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (_tmp) {
                                            view.focus();
                                            return [
                                                2
                                            ];
                                        }
                                        len = files && files.length;
                                        if (len > 0) {
                                            for(i = 0; i < len; i++){
                                                video_extension_onUpload({
                                                    view: view,
                                                    provider: provider,
                                                    idMap: video_extension_idMap,
                                                    eventEmitter: editorEventEmitter
                                                })(files.item(i));
                                            }
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(files) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return true;
                };
            }
        };
    };
    video_extension_createClass(VideoExtension, [
        {
            key: "name",
            get: function get() {
                return "video";
            }
        }
    ]);
    return VideoExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/audio-extension/index.js











/**
 * 统一样式前缀
 */ var audio_extension_CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var audio_extension_ZERO_WIDTH_SPACE = "​";

function audio_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var audio_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function audio_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = audio_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && audio_extension_isParagraph(content[size - 1]) && audio_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var audio_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : audio_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
/**
 * 格式化文件大小(File.size)，加上单位
 */ function audio_extension_formatFileSize(origin) {
    if (origin >= 1024 * 1024) {
        return "".concat((origin / (1024 * 1024)).toFixed(2), "MB");
    }
    if (origin >= 1024) {
        return "".concat((origin / 1024).toFixed(2), "KB");
    }
    return "".concat(origin || 0, "B");
}
var audio_extension_getPositiveNumber = function(num) {
    return num < 0 ? 0 : num;
};
/**
 *格式化时间字符串
 * @param time
 * @returns HH:MM格式字符串
 */ var audio_extension_formatTime = function(time) {
    var minute = parseInt("".concat(time / 60), 10);
    var second = parseInt("".concat(time % 60), 10);
    return "".concat(minute < 10 ? "0".concat(minute) : minute, ":").concat(second < 10 ? "0".concat(second) : second);
};

// 类型是否可以插入富文本
var audio_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function audio_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function audio_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            audio_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var audio_extension_optionsMerge = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var res = audio_extension_objectSpread({}, target, source);
    if (source.state) {
        res.state = audio_extension_optionsMerge(target.state, source.state);
    }
    if (source.props) {
        res.props = audio_extension_optionsMerge(target.props, source.props);
    }
    return res;
};
function audio_extension_UploaderOption(pluginOption, param) {
    var createUploadMask = param.createUploadMask;
    var uploaderOption = {
        state: {
            init: function init() {
                return index_es["b" /* DecorationSet */].empty;
            },
            apply: function apply(tr, set) {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                var action = tr.getMeta(this);
                if (action && action.add) {
                    var widget = createUploadMask(action.add, action.add.id);
                    var deco = index_es["a" /* Decoration */].widget(action.add.pos, widget, {
                        id: action.add.id,
                        ignoreSelection: true
                    });
                    set = set.add(tr.doc, [
                        deco
                    ]);
                } else if (action && action.remove) {
                    set = set.remove(set.find(null, null, function(spec) {
                        return spec.id === action.remove.id;
                    }));
                }
                return set;
            }
        },
        props: {
            decorations: function decorations(state) {
                return this.getState(state);
            }
        }
    };
    return audio_extension_optionsMerge(pluginOption, uploaderOption);
}

var audio_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("audio");

var audio_extension_img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%a2%91%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-70.000000%2c -386.000000)'%3e %3cg id='%e9%9f%b3%e9%a2%91' transform='translate(70.000000%2c 386.000000)'%3e %3crect id='Rectangle-16' fill='%23D8D8D8' opacity='0' x='0' y='0' width='16' height='16'%3e%3c/rect%3e %3cpath d='M12.7445743%2c2.04437642 L7.03505843%2c3.63603963 C6.34056761%2c3.81829114 5.78631052%2c4.47439658 5.78631052%2c5.10012677 L5.78631052%2c10.5737472 C5.78631052%2c10.5737472 5.37228715%2c10.3185951 4.45075125%2c10.4400961 C3.0951586%2c10.6162725 2%2c11.5579053 2%2c12.5481385 C2%2c13.5383718 3.0951586%2c14.1458768 4.45075125%2c13.9697003 C5.80634391%2c13.7935239 6.79465776%2c12.8822663 6.79465776%2c11.8920331 L6.79465776%2c6.60673927 C6.79465776%2c6.16933564 7.37562604%2c5.98100908 7.37562604%2c5.98100908 L12.4240401%2c4.54122213 C12.4240401%2c4.54122213 12.984975%2c4.37112072 12.984975%2c4.8388996 L12.984975%2c9.20078578 C12.984975%2c9.20078578 12.4707846%2c8.93348357 11.5492487%2c9.03068437 C10.1936561%2c9.18256063 9.0984975%2c10.1059683 9.0984975%2c11.0962015 C9.0984975%2c12.0864347 10.1936561%2c12.7121649 11.5492487%2c12.5663637 C12.9048414%2c12.4144874 14%2c11.4910798 14%2c10.5008466 L14%2c2.85235813 C13.9933222%2c2.23270299 13.4323873%2c1.86819996 12.7445743%2c2.04437642 Z' id='Shape' fill='%23666666' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e %3cg id='Group-6' transform='translate(70.000000%2c 349.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 45.1 (43504) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3etost-%e9%94%99%e8%af%af%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Artboard' transform='translate(-296.000000%2c -544.000000)' fill='%23F05E50'%3e %3cpath d='M304%2c544 C308.41824%2c544 312%2c547.58176 312%2c552 C312%2c556.41824 308.41824%2c560 304%2c560 C299.58176%2c560 296%2c556.41824 296%2c552 C296%2c547.58176 299.58176%2c544 304%2c544 Z M299.2%2c552 C299.2%2c552.667362 299.735663%2c553.2 300.396436%2c553.2 L307.603564%2c553.2 C308.256356%2c553.2 308.8%2c552.662742 308.8%2c552 C308.8%2c551.332638 308.264337%2c550.8 307.603564%2c550.8 L300.396436%2c550.8 C299.743644%2c550.8 299.2%2c551.337258 299.2%2c552 Z' id='tost-%e9%94%99%e8%af%af'%3e%3c/path%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

function audio_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var audio_extension_css_248z = ".selected .ct-upload-audio{border:1px solid #118bfb}.ct-upload-audio{background-color:#f6f6f6;border-radius:2px;border:1px solid #ddd;color:unset;display:flex;align-items:center;height:58px;outline:none;padding:8px 16px;position:relative;text-align:left;text-decoration:none;transition:all .1s ease;width:512px}.ct-upload-audio:active{border:1px solid #1253b5}.ct-upload-audio:hover{border:1px solid #3d91f2}.ct-upload-audio .audio-icon{align-items:center;background-color:#fff;border-radius:50%;border:1px solid #eee;display:flex;filter:opacity(.5);height:30px;padding-left:5px;width:30px}.ct-upload-audio .right{margin-left:12px}.ct-upload-audio .bottom{margin-bottom:-5px}.ct-upload-audio .name{-webkit-box-orient:vertical;-webkit-line-clamp:1;color:#333;display:-webkit-box;display:inline-block;font-size:12px;line-height:18px;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:310px}.ct-upload-audio .progress-wrapper{background-color:hsla(0,0%,86.7%,0);border-radius:6px;border:1px solid #ddd;display:inline-block;height:8px;margin-right:8px;position:relative;width:260px}.ct-upload-audio .progress{background-color:#1253b5;border-radius:6px;border:1px solid #1253b5;box-shadow:0 2px 8px 0 rgba(71,134,255,.24);height:8px;left:0;position:absolute;top:-1px}.ct-upload-audio .size{margin-right:8px}.ct-upload-audio .percent,.ct-upload-audio .size{color:#999;display:inline-block;font-size:12px;line-height:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-upload-audio .ct-operate-bar{top:-42px}.ct-upload-audio .reupload{display:flex;font-size:14px;margin-bottom:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-upload-audio .reupload svg{vertical-align:-12%}.ct-upload-audio .reupload .retry-btn{margin-left:5px;cursor:pointer;color:#40a9ff}";
audio_extension_styleInject(audio_extension_css_248z);

function audio_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function audio_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function audio_extension_getPrototypeOf(o) {
    audio_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return audio_extension_getPrototypeOf(o);
}
function audio_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) audio_extension_setPrototypeOf(subClass, superClass);
}
function audio_extension_possibleConstructorReturn(self, call) {
    if (call && (audio_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return audio_extension_assertThisInitialized(self);
}
function audio_extension_setPrototypeOf(o, p) {
    audio_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return audio_extension_setPrototypeOf(o, p);
}
var audio_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function audio_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function audio_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = audio_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = audio_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = audio_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return audio_extension_possibleConstructorReturn(this, result);
    };
}
var audio_extension_AudioPlaceholder = /*#__PURE__*/ function(Component) {
    audio_extension_inherits(AudioPlaceholder, Component);
    var _super = audio_extension_createSuper(AudioPlaceholder);
    function AudioPlaceholder() {
        audio_extension_classCallCheck(this, AudioPlaceholder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            progress: 0,
            hasError: false,
            loaded: "0MB"
        };
        _this.onRetry = null;
        // 修改进度
        _this.setProgress = function(progress) {
            _this.setState({
                progress: progress
            });
        };
        // 修改已加载大小
        _this.setLoaded = function(loaded) {
            _this.setState({
                loaded: loaded
            });
        };
        // 修改错误状态
        _this.setHasError = function(hasError) {
            _this.setState({
                hasError: hasError
            });
        };
        // 重新上传
        _this.retry = function() {
            var onRetry = audio_extension_assertThisInitialized(_this).onRetry;
            _this.setState({
                hasError: false
            }, function() {
                return onRetry && onRetry();
            });
        };
        return _this;
    }
    var _proto = AudioPlaceholder.prototype;
    _proto.render = function render() {
        var _this_props = this.props, _this_props_name = _this_props.name, name = _this_props_name === void 0 ? "未命名" : _this_props_name, size = _this_props.size;
        var _this_state = this.state, progress = _this_state.progress, loaded = _this_state.loaded, hasError = _this_state.hasError;
        var fakeDone = loaded === size;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: audio_extension_classNamePrefix("upload-audio")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "audio-icon"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img,
            alt: ""
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "right"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "top"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "name"
        }, name)), !hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bottom"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "progress-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "progress",
            style: {
                width: "".concat(progress, "%")
            }
        })), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "size"
        }, audio_extension_formatFileSize(loaded), " / ", size), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "percent"
        }, fakeDone && size ? "99%" : "".concat(progress, "%")))), hasError && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bottom reupload"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img$1,
            alt: ""
        }), "上传失败，", /*#__PURE__*/ react_default.a.createElement("span", {
            className: "retry-btn",
            onClick: this.retry
        }, "重试")));
    };
    return AudioPlaceholder;
}(react["Component"]);

var audio_extension_createPlaceholder = function(idMap) {
    return function(param, id) {
        var file = param.file;
        var widget = document.createElement("div");
        widget.style.outline = "none";
        widget.setAttribute("data-type", "ct-progress");
        var name = file.name, size = file.size;
        // 渲染组件，并将组件的实例存入 store 中，以 id 为 key
        react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(audio_extension_AudioPlaceholder, {
            id: id,
            name: name,
            size: audio_extension_formatFileSize(size),
            ref: function(ref) {
                idMap[id] = ref;
            }
        }), widget);
        return widget;
    };
};

var audio_extension_img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%92%ad%e6%94%be%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-471.000000%2c -558.000000)'%3e %3cg id='Group-18' transform='translate(471.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M15.6839276%2c10.5567733 L4.96564206%2c16.9107492 C4.66057577%2c17.0915976 4.26783668%2c16.9889051 4.08843476%2c16.6813793 C4.03053197%2c16.5821239 4%2c16.4690706 4%2c16.3539244 L4%2c3.64597255 C4%2c3.28921176 4.28689869%2c3 4.64080615%2c3 C4.7550314%2c3 4.86718053%2c3.03077813 4.96564206%2c3.08914775 L15.6839276%2c9.44312369 C15.9889939%2c9.62397201 16.090865%2c10.0198775 15.9114631%2c10.3274033 C15.8562054%2c10.4221245 15.7778912%2c10.5010701 15.6839276%2c10.5567733 Z' id='Triangle-2' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%9a%82%e5%81%9c%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-395.000000%2c -558.000000)'%3e %3cg id='Group-18-Copy' transform='translate(395.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M5%2c3 L7%2c3 C7.55228475%2c3 8%2c3.44771525 8%2c4 L8%2c16 C8%2c16.5522847 7.55228475%2c17 7%2c17 L5%2c17 C4.44771525%2c17 4%2c16.5522847 4%2c16 L4%2c4 C4%2c3.44771525 4.44771525%2c3 5%2c3 Z M13%2c3 L15%2c3 C15.5522847%2c3 16%2c3.44771525 16%2c4 L16%2c16 C16%2c16.5522847 15.5522847%2c17 15%2c17 L13%2c17 C12.4477153%2c17 12%2c16.5522847 12%2c16 L12%2c4 C12%2c3.44771525 12.4477153%2c3 13%2c3 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%87%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-514.000000%2c -558.000000)'%3e %3cg id='Group-22' transform='translate(514.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(2.000000%2c 4.000000)'%3e %3cg id='Group-21'%3e %3cpath d='M0%2c8.12082937 C0%2c8.6754175 0.442660332%2c9.125 0.998956561%2c9.125 L3%2c9.125 L6.19054031%2c11.4182009 C6.63759255%2c11.7395196 7%2c11.544239 7%2c10.9975267 L7%2c1.00247329 C7%2c0.448822582 6.63085938%2c0.265319824 6.19054031%2c0.58179915 L3%2c2.875 L0.998956561%2c2.875 C0.447248087%2c2.875 0%2c3.32448459 0%2c3.87917063 L0%2c8.12082937 Z' id='Fill-89' fill='%236B6B6B'%3e%3c/path%3e %3cpath d='M10%2c2 C11.3333333%2c3.06070964 12%2c4.39404297 12%2c6 C12%2c7.60595703 11.3333333%2c8.93929036 10%2c10' id='Path-12' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3cpath d='M13%2c0 C15%2c1.3984375 16%2c3.3984375 16%2c6 C16%2c8.6015625 15%2c10.6015625 13%2c12' id='Path-12-Copy' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9d%99%e9%9f%b3%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-550.000000%2c -558.000000)'%3e %3cg id='Group-22-Copy' transform='translate(550.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(4.000000%2c 4.000000)' fill='%236B6B6B'%3e %3cpath d='M9%2c1.72792206 L2.12273522%2c8.60518684 C2.04439515%2c8.46156167 2%2c8.29646112 2%2c8.12082937 L2%2c3.87917063 C2%2c3.32448459 2.44724809%2c2.875 2.99895656%2c2.875 L5%2c2.875 L8.19054031%2c0.58179915 C8.63085937%2c0.265319824 9%2c0.448822582 9%2c1.00247329 L9%2c1.72792206 Z M9%2c6.67766953 L9%2c10.9975267 C9%2c11.544239 8.63759255%2c11.7395196 8.19054031%2c11.4182009 L5.90337136%2c9.77429817 L9%2c6.67766953 Z M12.2582521%2c0.944543648 C12.5511454%2c1.23743687 12.5511454%2c1.7123106 12.2582521%2c2.00520382 L2.00520382%2c12.2582521 C1.7123106%2c12.5511454 1.23743687%2c12.5511454 0.944543648%2c12.2582521 C0.651650429%2c11.9653589 0.651650429%2c11.4904852 0.944543648%2c11.197592 L11.197592%2c0.944543648 C11.4904852%2c0.651650429 11.9653589%2c0.651650429 12.2582521%2c0.944543648 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e4%b8%8b%e8%bd%bd copy%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%99%84%e4%bb%b6%e6%b7%bb%e5%8a%a0%e5%a4%8d%e5%88%b6%e9%93%be%e6%8e%a5' transform='translate(-369.000000%2c -555.000000)' fill='%23747272'%3e %3cg id='%e4%b8%8a%e4%bc%a0%e9%99%84%e4%bb%b6%e4%b8%ad-copy-6' transform='translate(56.000000%2c 534.000000)'%3e %3cg id='%e4%b8%8b%e8%bd%bd-copy' transform='translate(312.000000%2c 20.000000)'%3e %3cpath d='M8.81079102%2c8.49228232 L11.0575929%2c6.23659883 C11.367661%2c5.92438892 11.8514298%2c5.89865471 12.1342183%2c6.18304917 C12.4189783%2c6.46942638 12.3934758%2c6.95251315 12.0816605%2c7.26648227 L8.65828197%2c10.7033935 C8.57058276%2c10.8187868 8.45021995%2c10.9080019 8.31097304%2c10.9572592 C8.23162324%2c10.986943 8.14990291%2c11.0008681 8.06879562%2c10.9999582 C8.06613072%2c10.999986 8.0634625%2c11 8.06079102%2c11 C8.05811953%2c11 8.05545131%2c10.999986 8.05278641%2c10.9999582 C7.97167912%2c11.0008681 7.88995879%2c10.986943 7.81060899%2c10.9572592 C7.67136208%2c10.9080019 7.55099928%2c10.8187868 7.46330006%2c10.7033935 L4.03992152%2c7.26648227 C3.72810619%2c6.95251315 3.70260373%2c6.46942638 3.98736375%2c6.18304917 C4.27015222%2c5.89865471 4.75392098%2c5.92438892 5.06398917%2c6.23659883 L7.31079102%2c8.49228232 L7.31079102%2c1.75 C7.31079102%2c1.33578644 7.64657745%2c1 8.06079102%2c1 C8.47500458%2c1 8.81079102%2c1.33578644 8.81079102%2c1.75 L8.81079102%2c8.49228232 Z M15%2c11.0225156 L15%2c13 C15%2c14.1045695 14.1045695%2c15 13%2c15 L3%2c15 C1.8954305%2c15 1%2c14.1045695 1%2c13 L1%2c11 L1.00152941%2c11 C1.00051495%2c10.9840173 1%2c10.9678989 1%2c10.9516602 C1%2c10.5365365 1.33652425%2c10.2000122 1.75164795%2c10.2000122 C2.16677165%2c10.2000122 2.5032959%2c10.5365365 2.5032959%2c10.9516602 C2.5032959%2c10.9755555 2.50218087%2c10.9991903 2.5%2c11.0225156 L2.5%2c12.5 C2.5%2c13.0522847 2.94771525%2c13.5 3.5%2c13.5 L12.5%2c13.5 C13.0522847%2c13.5 13.5%2c13.0522847 13.5%2c12.5 L13.5%2c11 L13.5015294%2c11 C13.5005149%2c10.9840173 13.5%2c10.9678989 13.5%2c10.9516602 C13.5%2c10.5365365 13.8365242%2c10.2000122 14.2516479%2c10.2000122 C14.6667716%2c10.2000122 15.0032959%2c10.5365365 15.0032959%2c10.9516602 C15.0032959%2c10.9755555 15.0021809%2c10.9991903 15%2c11.0225156 Z' id='%e4%b8%8b%e8%bd%bd'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

/* eslint-disable jsx-a11y/media-has-caption */ function audio_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function audio_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function audio_extension_getPrototypeOf$1(o) {
    audio_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return audio_extension_getPrototypeOf$1(o);
}
function audio_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) audio_extension_setPrototypeOf$1(subClass, superClass);
}
function audio_extension_possibleConstructorReturn$1(self, call) {
    if (call && (audio_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return audio_extension_assertThisInitialized$1(self);
}
function audio_extension_setPrototypeOf$1(o, p) {
    audio_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return audio_extension_setPrototypeOf$1(o, p);
}
var audio_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function audio_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function audio_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = audio_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = audio_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = audio_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return audio_extension_possibleConstructorReturn$1(this, result);
    };
}
var audio_extension_Audio = /*#__PURE__*/ function(Component) {
    audio_extension_inherits$1(Audio, Component);
    var _super = audio_extension_createSuper$1(Audio);
    function Audio() {
        audio_extension_classCallCheck$1(this, Audio);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isOnProgressMouseDown = false;
        _this.isOnVolumeMouseDown = false;
        _this.state = {
            init: true,
            volume: 0.5,
            isMute: false,
            progress: 0,
            playing: 0,
            current: "00:00",
            total: "00:00",
            isPlay: false,
            hasTip: false,
            tipInfo: {
                time: "",
                offsetX: 0
            },
            showVolumeBar: false,
            volumeBarInfo: {},
            isError: false,
            downloadStatus: 0
        };
        // 播放暂停切换
        _this.togglePlay = function() {
            var isPlay = _this.state.isPlay;
            _this.setState({
                isPlay: !isPlay
            }, function() {
                // eslint-disable-next-line react/destructuring-assignment
                if (_this.state.isPlay) {
                    document.querySelectorAll("audio").forEach(function(otherAudio) {
                        return otherAudio.pause();
                    });
                    document.querySelectorAll("video").forEach(function(otherVideo) {
                        return otherVideo.pause();
                    });
                    if (_this.audio) {
                        var playPromise = _this.audio.play();
                        if (playPromise !== undefined) {
                            playPromise.then(function() {}).catch(function(e) {
                                // eslint-disable-next-line no-console
                                console.error(e);
                            });
                        }
                    }
                } else {
                    _this.audio && _this.audio.pause();
                }
            });
        };
        _this.handleCanPlay = function() {
            var duration = audio_extension_getPositiveNumber(_this.audio.duration);
            var total = audio_extension_formatTime(duration);
            _this.setState({
                total: total
            });
        };
        _this.handleProgress = function() {
            if (_this.audio.buffered.length <= 0) {
                return;
            }
            var progress = audio_extension_getPositiveNumber(_this.audio.buffered.end(0) / _this.audio.duration);
            _this.setState({
                progress: progress
            });
        };
        _this.handlePause = function() {
            var isPlay = _this.state.isPlay;
            if (isPlay) _this.setState({
                isPlay: false
            });
        };
        _this.handleTimeUpdate = function() {
            var currentTime = audio_extension_getPositiveNumber(_this.audio.currentTime);
            var current = audio_extension_formatTime(currentTime);
            var playing = currentTime / _this.audio.duration;
            _this.setState({
                current: current,
                playing: playing
            });
            var init = _this.state.init;
            if (init) {
                _this.setState({
                    init: false
                });
            }
        };
        _this.handleAudioMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        _this.handleAudioMouseMove = function(e) {
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = audio_extension_getPositiveNumber(dis / 360 * _this.audio.duration);
            if (_this.isOnProgressMouseDown) {
                _this.audio.currentTime = newCurrentTime;
                _this.handleTimeUpdate();
            }
        };
        _this.handleAudioMouseLeave = function() {
            _this.isOnProgressMouseDown = false;
        };
        _this.handleProgressBarMouseDown = function(e) {
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = audio_extension_getPositiveNumber(dis / 360 * _this.audio.duration);
            _this.audio.currentTime = newCurrentTime;
            _this.isOnProgressMouseDown = true;
            e.preventDefault();
        };
        _this.handleProgressBarMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        _this.handleProgressMouseMove = function(e) {
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = dis / 360 * _this.audio.duration;
            if (newCurrentTime > _this.audio.duration || newCurrentTime < 0) {
                _this.setState({
                    hasTip: false
                });
                return;
            }
            var time = audio_extension_formatTime(newCurrentTime);
            _this.setState({
                hasTip: true,
                tipInfo: {
                    time: time,
                    offsetX: dis
                }
            });
        };
        _this.handleVolumeBarMouseDown = function(e) {
            var zoom = _this.props.zoom;
            var bottom = _this.volumeBar.getBoundingClientRect().bottom;
            var clientY = e.nativeEvent.clientY / zoom;
            var dis = bottom - clientY;
            var volume = (dis > 0 ? dis : 0) / 80;
            volume = volume > 1 ? 1 : volume;
            _this.audio.volume = volume;
            _this.setState({
                volume: volume,
                isMute: false
            });
            _this.isOnVolumeMouseDown = true;
            e.preventDefault();
        };
        _this.handleVolumeBarMouseUp = function() {
            _this.isOnVolumeMouseDown = false;
        };
        _this.handleVolumeBarMouseMouse = function(e) {
            if (_this.isOnVolumeMouseDown) _this.handleVolumeBarMouseDown(e);
        };
        _this.showVolumeBar = function() {
            var _this_volumeBtn_getBoundingClientRect = _this.volumeBtn.getBoundingClientRect(), top = _this_volumeBtn_getBoundingClientRect.top, left = _this_volumeBtn_getBoundingClientRect.left;
            var _this_volumeBtn_closest_getBoundingClientRect = _this.volumeBtn.closest(".ct-editor, .pk-view-container").getBoundingClientRect(), editorTop = _this_volumeBtn_closest_getBoundingClientRect.top;
            _this.setState({
                showVolumeBar: true,
                volumeBarInfo: {
                    top: top - editorTop > 104 ? top - 104 : top + 50,
                    left: left - 4
                }
            });
        };
        _this.hideVolumeBar = function() {
            _this.setState({
                showVolumeBar: false
            });
        };
        _this.toggleMute = function() {
            var _this_state = _this.state, volume = _this_state.volume, isMute = _this_state.isMute;
            if (isMute) {
                _this.audio.volume = volume;
                _this.setState({
                    isMute: false
                });
            } else {
                _this.audio.volume = 0;
                _this.setState({
                    isMute: true
                });
            }
        };
        _this.handleDownload = function() {
            var _provider_handleUrl;
            var downloadStatus = _this.state.downloadStatus;
            if (downloadStatus === 1) return;
            var _this_props = _this.props, url = _this_props.url, name = _this_props.name, provider = _this_props.provider;
            var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
            provider.download(src, name);
        };
        _this.handleDragStart = function(e) {
            e.preventDefault();
        };
        _this.handleError = function() {
            _this.setState({
                isError: true
            });
        };
        _this.handleRetry = function() {
            _this.setState({
                isError: false
            });
        };
        // 播放
        _this.handlePlay = function() {
            document.querySelectorAll("audio").forEach(function(otherAudio) {
                return otherAudio !== _this.audio && otherAudio.pause();
            });
            document.querySelectorAll("video").forEach(function(otherVideo) {
                return otherVideo.pause();
            });
        };
        return _this;
    }
    var _proto = Audio.prototype;
    _proto.render = function render() {
        var _this = this;
        var _provider_handleUrl;
        var _this_props = this.props, url = _this_props.url, name = _this_props.name, size = _this_props.size, provider = _this_props.provider;
        var _this_state = this.state, init = _this_state.init, volume = _this_state.volume, isMute = _this_state.isMute, progress = _this_state.progress, playing = _this_state.playing, current = _this_state.current, total = _this_state.total, isPlay = _this_state.isPlay, isError = _this_state.isError, hasTip = _this_state.hasTip, _this_state_tipInfo = _this_state.tipInfo, time = _this_state_tipInfo.time, offsetX = _this_state_tipInfo.offsetX, showVolumeBar = _this_state.showVolumeBar, volumeBarInfo = _this_state.volumeBarInfo, downloadStatus = _this_state.downloadStatus;
        var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
        if (isError) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                className: "".concat(audio_extension_classNamePrefix("audio-view"), " error")
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "notice",
                "data-src": src
            }, window.navigator.onLine ? "文件获取失败" : "网络连接失败"), /*#__PURE__*/ react_default.a.createElement("button", {
                className: "".concat(audio_extension_classNamePrefix("btn"), " retry"),
                onClick: this.handleRetry
            }, "重试"));
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: audio_extension_classNamePrefix("audio-view"),
            onMouseUp: this.handleAudioMouseUp,
            onMouseMove: this.handleAudioMouseMove,
            onMouseLeave: this.handleAudioMouseLeave,
            onDragStart: this.handleDragStart
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("play-btn", {
                pause: !isPlay
            }),
            onClick: this.togglePlay
        }, !isPlay ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img$2,
            alt: "播放"
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img$3,
            alt: "暂停"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "info"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "top"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "left"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, name), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "size"
        }, "( ", size, " )")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "time"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "current"
        }, current), /*#__PURE__*/ react_default.a.createElement("span", null, "/"), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "total"
        }, total))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bottom"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-bar",
            ref: function(ref) {
                _this.progressBar = ref;
            },
            onMouseDown: this.handleProgressBarMouseDown,
            onMouseMove: this.handleProgressMouseMove,
            onMouseLeave: function() {
                return _this.setState({
                    hasTip: false
                });
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "load-bar",
            style: {
                width: "".concat(init ? 0 : progress * 360, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-bar", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                width: "".concat(playing * 360, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-button", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                left: "".concat(playing * 360 - 4, "px")
            }
        }), hasTip && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip-wrapper",
            style: {
                left: "".concat(offsetX - 23, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip"
        }, time))))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-btn",
            ref: function(ref) {
                _this.volumeBtn = ref;
            },
            onMouseEnter: this.showVolumeBar,
            onMouseLeave: this.hideVolumeBar,
            onDragStart: this.handleDragStart
        }, isMute || volume < 0.01 ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img$5,
            alt: "静音",
            onClick: this.toggleMute
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img$4,
            alt: "音量调节",
            onClick: this.toggleMute
        }), showVolumeBar && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar-wrapper",
            style: volumeBarInfo,
            onMouseMove: this.handleVolumeBarMouseMouse,
            onMouseUp: this.handleVolumeBarMouseUp
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar",
            ref: function(ref) {
                _this.volumeBar = ref;
            },
            onMouseDown: this.handleVolumeBarMouseDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "selected-bar",
            style: {
                height: "".concat(isMute ? 0 : volume * 80, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bar-btn"
        }))))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("download-btn", {
                error: downloadStatus === 2,
                loading: downloadStatus === 1
            }),
            onClick: this.handleDownload
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip"
        }, "下载失败，请重试")), /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_img$6,
            alt: "下载"
        })), /*#__PURE__*/ react_default.a.createElement("audio", {
            ref: function(ref) {
                _this.audio = ref;
            },
            src: src,
            preload: "meta",
            // volume={isMute ? 0 : volume}
            onCanPlay: this.handleCanPlay,
            onProgress: this.handleProgress,
            onTimeUpdate: this.handleTimeUpdate,
            onPause: this.handlePause,
            onError: this.handleError
        }, "本浏览器不支持 HTML5 audio 标签"));
    };
    return Audio;
}(react["Component"]);
audio_extension_Audio.defaultProps = {
    zoom: 1
};

var audio_extension_css_248z$1 = '.ct-audio{margin:8px 0;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ct-audio img{vertical-align:unset}.ct-audio.align-center{margin:0 auto}.ct-audio.align-right{float:right;margin-top:0}.ct-audio.align-right+*,.ct-audio.align-right+div+span+*{clear:both}.ct-audio.mobile{width:100%}.ct-audio-view{background:#f6f6f6;border:1px solid #ddd;display:flex;height:58px;width:5 12px}.ct-audio-view:hover{border:1px solid #3d91f2;cursor:pointer}.ct-audio-view audio{display:none}.ct-audio-view .play-btn{background-color:#fff;border-radius:50%;border:1px solid #eee;cursor:pointer;height:30px;margin:14px 16px;padding-left:4px;padding-top:4px;width:30px}.ct-audio-view .play-btn:hover{border-color:#3d91f2}.ct-audio-view .play-btn:hover path{fill:#3d91f2}.ct-audio-view .play-btn.pause{padding-left:5px}.ct-audio-view .info{font-size:12px;line-height:1 4px;margin-top:14px;width:360px}.ct-audio-view .top{display:flex;justify-content:space-between;align-items:flex-start;height:1 4px;margin-bottom:10px;width:100%}.ct-audio-view .top .left{display:flex}.ct-audio-view .top .name{color:#333;max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-audio-view .top .size{color:#999;margin-left:2px}.ct-audio-view .top .time{display:flex;justify-content:space-between;align-items:center;color:#333;text-align:right;width:80px}.ct-audio-view .bottom{display:flex;height:4px;width:100%}.ct-audio-view .progress-bar{background:#d9d9d9;background-clip:content-box;border-radius:100px;cursor:pointer;height:10px;padding:3px 0;position:relative;width:100%}.ct-audio-view .load-bar{background:#b6b6b6;transition:all 3s linear;z-index:1}.ct-audio-view .load-bar,.ct-audio-view .played-bar{border-radius:100px;height:4px;position:absolute;top:3px;width:0}.ct-audio-view .played-bar{background:#1c6cdc;transition:all .3s linear;z-index:2}.ct-audio-view .played-bar.dragged{transition:none}.ct-audio-view .played-button{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);height:12px;position:absolute;top:-2px;transition:all .3s linear;width:12px;z-index:10}.ct-audio-view .played-button.dragged{transition:none}.ct-audio-view .progress-tip-wrapper{height:28px;left:0;position:absolute;top:-27px;width:48px}.ct-audio-view .progress-tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-audio-view .progress-tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;width:0}.ct-audio-view .progress-tip:after,.ct-audio-view .progress-tip:before{content:"";display:block;position:absolute;right:50%;transform:translate(50%);z-index:2}.ct-audio-view .progress-tip:before{background:rgba(0,0,0,.68);bottom:-9px;height:4px;width:1px}.ct-audio-view .volume-btn{cursor:pointer;height:58px;margin:0 12px 0 16px;padding-top:16px;padding-bottom:16px;position:relative;transition:all .1s ease;width:26px}.ct-audio-view .volume-btn:hover path:first-child{fill:#3d91f2}.ct-audio-view .volume-btn:hover path:nth-child(2){stroke:#3d91f2}.ct-audio-view .volume-bar-wrapper{background:#fff;border-radius:2px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);height:102px;position:fixed;width:30px;z-index:9}.ct-audio-view .volume-bar{background:#d9d9d9;border-radius:100px;height:80px;left:50%;position:absolute;top:11px;transform:translate(-50%);width:4px}.ct-audio-view .selected-bar{background:#1c6cdc;border-radius:100px;bottom:0;height:0;position:absolute;transition:all .2s;width:4px;z-index:2}.ct-audio-view .selected-bar .bar-btn{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);content:"";height:12px;position:absolute;right:-4px;top:-6px;width:12px}.ct-audio-view .download-btn{cursor:pointer;height:22px;margin-top:16px;position:relative;transition:all .1s ease;width:22px}.ct-audio-view .download-btn:hover path{fill:#3d91f2}.ct-audio-view .download-btn .tip-wrapper{display:none;height:28px;left:7px;position:absolute;top:-30px}.ct-audio-view .download-btn .tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-audio-view .download-btn .tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;content:"";display:block;position:absolute;right:50%;transform:translate(50%);width:0;z-index:2}.ct-audio-view .download-btn.loading{cursor:default;height:20px;margin-right:0;margin-top:16px;width:19px}.ct-audio-view .download-btn.loading svg{display:none}.ct-audio-view .download-btn.error{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%228px%22 height%3D%228px%22 viewBox%3D%220 0 8 8%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3ECombined Shape%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Crect id%3D%22Rectangle-2%22 fill%3D%22%23FFFFFF%22 x%3D%222%22 y%3D%221%22 width%3D%224%22 height%3D%226%22%3E%3C%2Frect%3E        %3Cpath d%3D%22M0%2C4 C0%2C1.79088 1.79088%2C0 4%2C0 C6.20912%2C0 8%2C1.79088 8%2C4 C8%2C6.20912 6.20912%2C8 4%2C8 C1.79088%2C8 0%2C6.20912 0%2C4 Z M4.00000002%2C1.34999998 C3.34188252%2C1.34999998 2.87727375%2C1.67743076 3%2C2.5 L3.40000002%2C4.36638153 C3.40000002%2C4.69277782 3.66862917%2C4.96459961 4.00000002%2C4.96459961 C4.33368113%2C4.96459961 4.60000002%2C4.69676825 4.60000002%2C4.36638153 L5%2C2.5 C5.15197984%2C1.72235314 4.74297343%2C1.34999998 4.00000002%2C1.34999998 Z M4%2C6.65000002 C4.33137086%2C6.65000002 4.60000002%2C6.38137086 4.60000002%2C6.05 C4.60000002%2C5.71862914 4.33137086%2C5.44999998 4%2C5.44999998 C3.66862914%2C5.44999998 3.39999998%2C5.71862914 3.39999998%2C6.05 C3.39999998%2C6.38137086 3.66862914%2C6.65000002 4%2C6.65000002 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23F5222D%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 12px top}.ct-audio-view .download-btn.error:hover .tip-wrapper{display:block}.ProseMirror-selectednode .ct-audio-view{border:1px solid #3d91f2}.ct-audio-view.error{background:rgba(0,0,0,.5);font-size:14px;padding:10px 40px}.ct-audio-view.error .notice{color:#fff;height:32px;line-height:32px}.ct-audio-view.error .retry{background:#3d91f2;border:none;color:#fff;display:block;height:#1c6cdc;line-height:#1c6cdc;margin-left:30px;width:76px}.ct-audio-view.mobile{background:none;border:0;height:70px;width:100%}.ct-audio-view.mobile audio{display:block;height:100%;width:100%}';
audio_extension_styleInject(audio_extension_css_248z$1);

function audio_extension_extends() {
    audio_extension_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return audio_extension_extends.apply(this, arguments);
}
var AudioView = function(props) {
    var attrs = props.attrs, provider = props.provider;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()("".concat(audio_extension_classNamePrefix("audio")), {
            "align-center": attrs.align === "center",
            "align-right": attrs.align === "right"
        })
    }, /*#__PURE__*/ react_default.a.createElement(audio_extension_Audio, audio_extension_extends({}, attrs, {
        provider: provider
    })));
};

var audio_extension_AFTER_INSERT = "after_insert";

/**
 * 插入音频
 * @return {boolean} 是否插入成功
 */ var insertAudio = function(attrs) {
    return function(state, dispatch, view, pos) {
        var schema = state.schema;
        var transaction = audio_extension_insertBlock(view.state, schema.nodes.audio.create(attrs), {
            selection: new prosemirror_state_dist["TextSelection"](view.state.doc.resolve(pos)),
            cursorMove: false
        }).transaction;
        dispatch(transaction);
        view.focus();
        return true;
    };
};

function audio_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function audio_extension_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                audio_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                audio_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function audio_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function audio_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            audio_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var audio_extension_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 参考自官网Demo：https://prosemirror.net/examples/upload/
 */ function audio_extension_findPlaceholder(view, id) {
    var decos = audio_extension_pluginKey.getState(view.state);
    var found = decos.find(null, null, function(spec) {
        return spec.id === id;
    });
    if (found.length) {
        return {
            pos: found[0].from,
            node: found[0].type.toDOM
        };
    }
    return null;
}
var audio_extension_onUpload = function(param) {
    var view = param.view, provider = param.provider, idMap = param.idMap, eventEmitter = param.eventEmitter, nodeType = param.nodeType, _param_pos = param.pos, pos = _param_pos === void 0 ? null : _param_pos;
    var getComponent = function(id) {
        return idMap[id];
    };
    return function() {
        var _ref = audio_extension_asyncToGenerator(function(file) {
            var id, ret, attrs, tr, _nodeType_spec_braceWidth, onProgress, data, placeholder, e, placeholder1, comp;
            return audio_extension_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = esm_browser_v4();
                        if (!provider.beforeUpload) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            provider.beforeUpload(file, id)
                        ];
                    case 1:
                        ret = _state.sent();
                        // 只有当校验函数显示返回 false 时才表示校验不通过
                        if (ret === false) {
                            view.focus();
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        attrs = {
                            name: file.name
                        };
                        tr = view.state.tr;
                        if (typeof pos !== "number") pos = tr.selection.from;
                        if (!tr.selection.empty) {
                            tr.deleteSelection();
                        }
                        tr.setMeta(audio_extension_pluginKey, {
                            add: {
                                id: id,
                                pos: pos,
                                file: file
                            }
                        });
                        tr.insertText(audio_extension_ZERO_WIDTH_SPACE, pos); // 为了能够在placeholder后输入文字
                        view.dispatch(tr);
                        eventEmitter.emit(audio_extension_AFTER_INSERT, {
                            braceWidth: (_nodeType_spec_braceWidth = nodeType.spec.braceWidth) !== null && _nodeType_spec_braceWidth !== void 0 ? _nodeType_spec_braceWidth : 540,
                            pos: pos
                        }); // 如果在表格中，更新列宽
                        onProgress = function(param) {
                            var loaded = param.loaded, total = param.total;
                            var placeholder = audio_extension_findPlaceholder(view, id);
                            if (!placeholder) return;
                            var percent = Math.ceil(total ? loaded / total * 99 : 0);
                            var comp = getComponent(id);
                            comp === null || comp === void 0 ? void 0 : comp.setProgress(percent);
                            comp === null || comp === void 0 ? void 0 : comp.setLoaded(loaded);
                        };
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            provider.upload(file, onProgress)
                        ];
                    case 4:
                        data = _state.sent();
                        // 转码（如有需要，业务方不一定需要转码）
                        return [
                            4,
                            provider === null || provider === void 0 ? void 0 : provider.audioTranscode(data, file)
                        ];
                    case 5:
                        _state.sent();
                        placeholder = audio_extension_findPlaceholder(view, id);
                        if (!placeholder) return [
                            2
                        ];
                        data.size = audio_extension_formatFileSize(data.size);
                        // 删除 state 中保存的 placeholder
                        view.dispatch(view.state.tr.replaceWith(placeholder.pos, placeholder.pos + 1, []).setMeta(audio_extension_pluginKey, {
                            remove: {
                                id: id
                            }
                        }));
                        // 插入音频宏
                        insertAudio(audio_extension_objectSpread$1({}, attrs, data))(view.state, view.dispatch, view, placeholder.pos);
                        delete idMap[id];
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        console.error("上传失败", e);
                        placeholder1 = audio_extension_findPlaceholder(view, id);
                        if (!placeholder1) return [
                            2
                        ];
                        comp = getComponent(id);
                        comp.onRetry = function() {
                            view.dispatch(view.state.tr.setMeta(audio_extension_pluginKey, {
                                remove: {
                                    id: id
                                }
                            }));
                            audio_extension_onUpload({
                                view: view,
                                provider: provider,
                                idMap: idMap,
                                pos: placeholder1.pos,
                                nodeType: nodeType,
                                eventEmitter: eventEmitter
                            })(file);
                        };
                        comp === null || comp === void 0 ? void 0 : comp.setHasError(true);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }();
};
var audio_extension_selectFile = function(param) {
    var accept = param.accept, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? true : _param_multiple;
    return new Promise(function(resolve) {
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        if (multiple) {
            input.setAttribute("multiple", "multiple");
        }
        input.setAttribute("accept", accept);
        input.onchange = function(e) {
            var files = e.target.files;
            input.remove();
            resolve(files);
        };
        input.click();
    });
};

function audio_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function audio_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function audio_extension_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                audio_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                audio_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function audio_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function audio_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function audio_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) audio_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) audio_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function audio_extension_getPrototypeOf$2(o) {
    audio_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return audio_extension_getPrototypeOf$2(o);
}
function audio_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) audio_extension_setPrototypeOf$2(subClass, superClass);
}
function audio_extension_possibleConstructorReturn$2(self, call) {
    if (call && (audio_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return audio_extension_assertThisInitialized$2(self);
}
function audio_extension_setPrototypeOf$2(o, p) {
    audio_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return audio_extension_setPrototypeOf$2(o, p);
}
var audio_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function audio_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function audio_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = audio_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = audio_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = audio_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return audio_extension_possibleConstructorReturn$2(this, result);
    };
}
var audio_extension_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var audio_extension_idMap = {};
var audio_extension_AudioExtension = /*#__PURE__*/ function(NodeExtension) {
    audio_extension_inherits$2(AudioExtension, NodeExtension);
    var _super = audio_extension_createSuper$2(AudioExtension);
    function AudioExtension() {
        audio_extension_classCallCheck$2(this, AudioExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = AudioView;
        return _this;
    }
    var _proto = AudioExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state_dist["Plugin"](audio_extension_UploaderOption({
            key: audio_extension_pluginKey
        }, {
            createUploadMask: audio_extension_createPlaceholder(audio_extension_idMap)
        }));
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, providers = param.providers, editorEventEmitter = param.editorEventEmitter, schema = param.schema;
        var _this = this;
        return {
            upload: function() {
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    var _this1 = _this;
                    audio_extension_selectFile({
                        accept: "audio/*",
                        multiple: true
                    }).then(function() {
                        var _ref = audio_extension_asyncToGenerator$1(function(files) {
                            var _tmp, len, i;
                            return audio_extension_generator$1(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = provider.onSelectFiles;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            provider.onSelectFiles(files)
                                        ];
                                    case 1:
                                        _tmp = !_state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (_tmp) {
                                            view.focus();
                                            return [
                                                2
                                            ];
                                        }
                                        len = files && files.length;
                                        if (len > 0) {
                                            for(i = 0; i < len; i++){
                                                audio_extension_onUpload({
                                                    view: view,
                                                    provider: provider,
                                                    idMap: audio_extension_idMap,
                                                    eventEmitter: editorEventEmitter,
                                                    nodeType: schema.nodes[_this1.name]
                                                })(files.item(i));
                                            }
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(files) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return true;
                };
            },
            isDisabled: function() {
                return function() {
                    return !audio_extension_canInsertTypes(getState());
                };
            }
        };
    };
    audio_extension_createClass(AudioExtension, [
        {
            key: "name",
            get: function get() {
                return "audio";
            }
        }
    ]);
    return AudioExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/catalog-extension/index.js










/**
 * 统一样式前缀
 */ var catalog_extension_CLASSNAME_PREFIX = "ct";

function catalog_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function catalog_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return catalog_extension_arrayLikeToArray(arr);
}
function catalog_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function catalog_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function catalog_extension_toConsumableArray(arr) {
    return catalog_extension_arrayWithoutHoles(arr) || catalog_extension_iterableToArray(arr) || catalog_extension_unsupportedIterableToArray(arr) || catalog_extension_nonIterableSpread();
}
function catalog_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return catalog_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return catalog_extension_arrayLikeToArray(o, minLen);
}
var catalog_extension_noop = function() {};
function catalog_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var catalog_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function catalog_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = catalog_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && catalog_extension_isParagraph(content[size - 1]) && catalog_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var catalog_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : catalog_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var catalog_extension_execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : catalog_extension_noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, catalog_extension_toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

// 类型是否可以插入富文本
var catalog_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

/**
 * 插入目录
 * @return {boolean} 是否插入成功
 */ var insertCatalog = function() {
    return function(state, dispatch, view) {
        var node = state.schema.nodes.catalog.create();
        var res = catalog_extension_insertBlock(state, node);
        dispatch(res.transaction.scrollIntoView());
        view.focus();
        return true;
    };
};

var catalog_extension_ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(catalog_extension_ExtensionType || (catalog_extension_ExtensionType = {}));

/**
 * 通用配置
 */ var catalog_extension_pluginKey = new prosemirror_state_dist["PluginKey"]("image");

var catalog_extension_AFTER_INSERT = "after_insert";

var catalog_extension_IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var catalog_extension_Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(catalog_extension_Keycodes || (catalog_extension_Keycodes = {}));

function catalog_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function catalog_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function catalog_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function catalog_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function catalog_extension_slicedToArray(arr, i) {
    return catalog_extension_arrayWithHoles(arr) || catalog_extension_iterableToArrayLimit(arr, i) || catalog_extension_unsupportedIterableToArray$1(arr, i) || catalog_extension_nonIterableRest();
}
function catalog_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return catalog_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return catalog_extension_arrayLikeToArray$1(o, minLen);
}
var catalog_extension_getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var catalog_extension_setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = catalog_extension_getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = catalog_extension_slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var catalog_extension_emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        Object(react_dom["render"])(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var catalog_extension_emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = react_dom_default.a.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

function catalog_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var catalog_extension_css_248z = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
catalog_extension_styleInject(catalog_extension_css_248z);

function catalog_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var catalog_extension_SHOW = "show";
var catalog_extension_HIDE = "hide";
var catalog_extension_Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        catalog_extension_classCallCheck(this, Popover);
        this.popoverState = catalog_extension_HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(catalog_extension_classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === catalog_extension_SHOW && !forceUpdate) {
            return;
        }
        if (!target || !catalog_extension_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === catalog_extension_HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            catalog_extension_setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            catalog_extension_emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(catalog_extension_classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        Object(react_dom["render"])(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(catalog_extension_classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(catalog_extension_SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === catalog_extension_HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        catalog_extension_emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(catalog_extension_HIDE);
    };
    _proto.destroy = function destroy() {
        catalog_extension_emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function catalog_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function catalog_extension_instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function catalog_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            catalog_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var catalog_extension_DEFAULT_HEIGHT = 34;
var catalog_extension_DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var catalog_extension_PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        catalog_extension_classCallCheck$1(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = catalog_extension_objectSpread({}, catalog_extension_DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !catalog_extension_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new catalog_extension_Popover(catalog_extension_objectSpread({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return catalog_extension_DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var catalog_extension_css_248z$1 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
catalog_extension_styleInject(catalog_extension_css_248z$1);

function catalog_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function catalog_extension_getPrototypeOf(o) {
    catalog_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf(o);
}
function catalog_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn(self, call) {
    if (call && (catalog_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized(self);
}
function catalog_extension_setPrototypeOf(o, p) {
    catalog_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf(o, p);
}
var catalog_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn(this, result);
    };
}
var catalog_extension_Button = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits(Button, Component);
    var _super = catalog_extension_createSuper(Button);
    function Button() {
        catalog_extension_classCallCheck$2(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = catalog_extension_classNamePrefix(prefix);
        var classes = catalog_extension_defineProperty$1({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ react_default.a.createElement("button", {
            disabled: disabled,
            className: classnames_default()(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(react["Component"]);

var catalog_extension_css_248z$2 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
catalog_extension_styleInject(catalog_extension_css_248z$2);

/* eslint-disable jsx-a11y/control-has-associated-label */ function catalog_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$1(o) {
    catalog_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$1(o);
}
function catalog_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$1(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$1(self, call) {
    if (call && (catalog_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$1(self);
}
function catalog_extension_setPrototypeOf$1(o, p) {
    catalog_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$1(o, p);
}
var catalog_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$1(this, result);
    };
}
var catalog_extension_defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var catalog_extension_Modal = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$1(Modal, Component);
    var _super = catalog_extension_createSuper$1(Modal);
    function Modal() {
        catalog_extension_classCallCheck$3(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? "确定" : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? "取消" : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = catalog_extension_classNamePrefix(userPrefix);
        return /*#__PURE__*/ react_dom_default.a.createPortal(/*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: catalog_extension_defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ react_default.a.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ react_default.a.createElement(catalog_extension_Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ react_default.a.createElement(catalog_extension_Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(react["Component"]);
catalog_extension_Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var catalog_extension_css_248z$3 = '.ct-checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-checkbox input{display:none}.ct-checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-checkbox input:checked+.checkbox-bg:after{content:" ";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
catalog_extension_styleInject(catalog_extension_css_248z$3);

var catalog_extension_css_248z$4 = '.ct-icon-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-icon-item svg{margin:4px 0 0 4px}.ct-icon-item.close{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-icon-item.error{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E9%94%99%E8%AF%AF%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-296.000000%2C -544.000000)%22 fill%3D%22%23F05E50%22%3E            %3Cpath fill%3D%22%23F05E50%22 d%3D%22M304%2C544 C308.41824%2C544 312%2C547.58176 312%2C552 C312%2C556.41824 308.41824%2C560 304%2C560 C299.58176%2C560 296%2C556.41824 296%2C552 C296%2C547.58176 299.58176%2C544 304%2C544 Z M299.2%2C552 C299.2%2C552.667362 299.735663%2C553.2 300.396436%2C553.2 L307.603564%2C553.2 C308.256356%2C553.2 308.8%2C552.662742 308.8%2C552 C308.8%2C551.332638 308.264337%2C550.8 307.603564%2C550.8 L300.396436%2C550.8 C299.743644%2C550.8 299.2%2C551.337258 299.2%2C552 Z%22 id%3D%22tost-%E9%94%99%E8%AF%AF%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.success{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E6%88%90%E5%8A%9F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-222.000000%2C -544.000000)%22 fill%3D%22%2370B123%22%3E            %3Cpath fill%3D%22%2370B123%22 d%3D%22M228.93934%2C552.865274 L226.802094%2C550.728029 C226.3405%2C550.266435 225.576187%2C550.26192 225.107558%2C550.730549 C224.635662%2C551.202445 224.637801%2C551.957848 225.105038%2C552.425085 L228.079926%2C555.399974 C228.314894%2C555.634941 228.628301%2C555.751472 228.941218%2C555.747447 C229.252578%2C555.751485 229.564571%2C555.634156 229.802094%2C555.396633 L234.898303%2C550.300424 C235.359897%2C549.83883 235.364412%2C549.074517 234.895783%2C548.605887 C234.423887%2C548.133991 233.668484%2C548.13613 233.201247%2C548.603367 L228.93934%2C552.865274 Z M238%2C552 C238%2C553.451396 237.642365%2C554.789924 236.927083%2C556.015625 C236.211802%2C557.241326 235.241326%2C558.211802 234.015625%2C558.927083 C232.789924%2C559.642365 231.451396%2C560 230%2C560 C228.548604%2C560 227.210076%2C559.642365 225.984375%2C558.927083 C224.758674%2C558.211802 223.788198%2C557.241326 223.072917%2C556.015625 C222.357635%2C554.789924 222%2C553.451396 222%2C552 C222%2C550.548604 222.357635%2C549.210076 223.072917%2C547.984375 C223.788198%2C546.758674 224.758674%2C545.788198 225.984375%2C545.072917 C227.210076%2C544.357635 228.548604%2C544 230%2C544 C231.451396%2C544 232.789924%2C544.357635 234.015625%2C545.072917 C235.241326%2C545.788198 236.211802%2C546.758674 236.927083%2C547.984375 C237.642365%2C549.210076 238%2C550.548604 238%2C552 Z%22 id%3D%22tost-%E6%88%90%E5%8A%9F%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.edit{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E7%BC%96%E8%BE%91%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-164.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E7%BC%96%E8%BE%91%22 transform%3D%22translate(164.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M13%2C7 C13.2761424%2C7 13.5%2C7.22385763 13.5%2C7.5 C13.5%2C7.77614237 13.2761424%2C8 13%2C8 L8%2C8 L8%2C8 C7.44771525%2C8 7%2C8.44771525 7%2C9 L7%2C9 L7%2C18 C7%2C18.5522847 7.44771525%2C19 8%2C19 L17%2C19 C17.5522847%2C19 18%2C18.5522847 18%2C18 L18%2C18 L18%2C13 C18%2C12.7238576 18.2238576%2C12.5 18.5%2C12.5 C18.7761424%2C12.5 19%2C12.7238576 19%2C13 L19%2C11 L19%2C18 L19%2C18 C19%2C19.1045695 18.1045695%2C20 17%2C20 L8%2C20 L8%2C20 C6.8954305%2C20 6%2C19.1045695 6%2C18 L6%2C9 L6%2C9 C6%2C7.8954305 6.8954305%2C7 8%2C7 L8%2C7 L15%2C7 L13%2C7 Z M19.8535534%2C6.14644661 C20.0488155%2C6.34170876 20.0488155%2C6.65829124 19.8535534%2C6.85355339 L13.4895924%2C13.2175144 C13.2943302%2C13.4127766 12.9777477%2C13.4127766 12.7824856%2C13.2175144 C12.5872234%2C13.0222523 12.5872234%2C12.7056698 12.7824856%2C12.5104076 L19.1464466%2C6.14644661 C19.3417088%2C5.95118446 19.6582912%2C5.95118446 19.8535534%2C6.14644661 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.link{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(-908.000000%2C -565.000000)%22%3E      %3Cg transform%3D%22translate(8.500000%2C 565.000000)%22%3E        %3Cg transform%3D%22translate(0.500000%2C 0.000000)%22 fill%3D%22%23666666%22%3E          %3Cg transform%3D%22translate(899.000000%2C 0.000000)%22%3E            %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L13.4302151%2C11.1475865 L12.7191158%2C11.8586857 L13.4302151%2C12.5697849 C14.2156736%2C13.3552435 14.2156736%2C14.6287234 13.4302151%2C15.4141819 L13.2808842%2C15.5635128 L12.9253346%2C15.2079632 L13.9919834%2C16.274612 L16.1252811%2C14.1413143 L15.4141819%2C13.4302151 L17.4052599%2C11.439137 C18.1907184%2C10.6536785 18.1907184%2C9.38019862 17.4052599%2C8.59474009 C16.6198014%2C7.80928156 15.3463215%2C7.80928156 14.560863%2C8.59474009 L12.7191158%2C10.4364872 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.visitLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8E%BB%E6%9F%A5%E7%9C%8B%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-587.000000%2C -162.000000)%22%3E            %3Cg id%3D%22Group-8%22 transform%3D%22translate(62.000000%2C 128.000000)%22%3E                %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 34.000000)%22%3E%3C%2Fg%3E                %3Cg id%3D%22Group-2%22 transform%3D%22translate(0.000000%2C 34.000000)%22 fill%3D%22%23666666%22%3E                    %3Cg id%3D%22%E5%8E%BB%E6%9F%A5%E7%9C%8B%22 transform%3D%22translate(525.000000%2C 0.000000)%22%3E                        %3Cpath d%3D%22M6.67363116%2C16 L7.80156483%2C16 C8.83909243%2C17.7939653 10.7785899%2C19.0009766 13%2C19.0009766 C16.3142478%2C19.0009766 19.0009766%2C16.3142478 19.0009766%2C13 C19.0009766%2C9.68575216 16.3142478%2C6.99902344 13%2C6.99902344 C10.7785899%2C6.99902344 8.83909243%2C8.20603473 7.80156483%2C10 L6.67363116%2C10 C7.7970951%2C7.63505267 10.207604%2C6 13%2C6 C16.8659932%2C6 20%2C9.13400675 20%2C13 C20%2C16.8659932 16.8659932%2C20 13%2C20 C10.207604%2C20 7.7970951%2C18.3649473 6.67363116%2C16 Z M14.1464466%2C14.767767 L15.4142136%2C13.5 L6.62132034%2C13.5 C6.34517797%2C13.5 6.12132034%2C13.2761424 6.12132034%2C13 C6.12132034%2C12.7238576 6.34517797%2C12.5 6.62132034%2C12.5 L15.4142136%2C12.5 L14.1464466%2C11.232233 C13.9511845%2C11.0369709 13.9511845%2C10.7203884 14.1464466%2C10.5251263 C14.3417088%2C10.3298641 14.6582912%2C10.3298641 14.8535534%2C10.5251263 L16.9535151%2C12.6262866 C16.9607818%2C12.6327579 16.967905%2C12.6394779 16.9748737%2C12.6464466 C17.1701359%2C12.8417088 17.1701359%2C13.1582912 16.9748737%2C13.3535534 L14.8535534%2C15.4748737 C14.6582912%2C15.6701359 14.3417088%2C15.6701359 14.1464466%2C15.4748737 C13.9511845%2C15.2796116 13.9511845%2C14.9630291 14.1464466%2C14.767767 Z%22%3E%3C%2Fpath%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.cancelLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8F%96%E6%B6%88%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-96.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E6%8F%92%E5%85%A5%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(96.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L14.560863%2C8.59474009 C15.3463215%2C7.80928156 16.6198014%2C7.80928156 17.4052599%2C8.59474009 C18.1907184%2C9.38019862 18.1907184%2C10.6536785 17.4052599%2C11.439137 L15.4141819%2C13.4302151 L16.1252811%2C14.1413143 L13.9919834%2C16.274612 L12.9253346%2C15.2079632 L13.2808842%2C15.5635128 L13.4302151%2C15.4141819 C14.2156736%2C14.6287234 14.2156736%2C13.3552435 13.4302151%2C12.5697849 L12.7191158%2C11.8586857 L13.4302151%2C11.1475865 L12.7191158%2C10.4364872 Z M7.35355339%2C7.35355339 C7.54881554%2C7.15829124 7.86539803%2C7.15829124 8.06066017%2C7.35355339 L9.47487373%2C8.76776695 C9.67013588%2C8.9630291 9.67013588%2C9.27961159 9.47487373%2C9.47487373 C9.27961159%2C9.67013588 8.9630291%2C9.67013588 8.76776695%2C9.47487373 L7.35355339%2C8.06066017 C7.15829124%2C7.86539803 7.15829124%2C7.54881554 7.35355339%2C7.35355339 Z M16.3535534%2C16.3535534 C16.5488155%2C16.1582912 16.865398%2C16.1582912 17.0606602%2C16.3535534 L18.4748737%2C17.767767 C18.6701359%2C17.9630291 18.6701359%2C18.2796116 18.4748737%2C18.4748737 C18.2796116%2C18.6701359 17.9630291%2C18.6701359 17.767767%2C18.4748737 L16.3535534%2C17.0606602 C16.1582912%2C16.865398 16.1582912%2C16.5488155 16.3535534%2C16.3535534 Z M17%2C14.5 C17%2C14.2238576 17.2238576%2C14 17.5%2C14 L19.5%2C14 C19.7761424%2C14 20%2C14.2238576 20%2C14.5 C20%2C14.7761424 19.7761424%2C15 19.5%2C15 L17.5%2C15 C17.2238576%2C15 17%2C14.7761424 17%2C14.5 Z M6%2C11.5 L6%2C11.5 C6%2C11.2238576 6.22385763%2C11 6.5%2C11 L8.5%2C11 C8.77614237%2C11 9%2C11.2238576 9%2C11.5 C9%2C11.7761424 8.77614237%2C12 8.5%2C12 L6.5%2C12 L6.5%2C12 C6.22385763%2C12 6%2C11.7761424 6%2C11.5 L6%2C11.5 Z M11.5%2C6 L11.5%2C6 C11.7761424%2C6 12%2C6.22385763 12%2C6.5 L12%2C8.5 C12%2C8.77614237 11.7761424%2C9 11.5%2C9 C11.2238576%2C9 11%2C8.77614237 11%2C8.5 L11%2C6.5 L11%2C6.5 C11%2C6.22385763 11.2238576%2C6 11.5%2C6 L11.5%2C6 Z M14.5%2C17 C14.7761424%2C17 15%2C17.2238576 15%2C17.5 L15%2C19.5 C15%2C19.7761424 14.7761424%2C20 14.5%2C20 C14.2238576%2C20 14%2C19.7761424 14%2C19.5 L14%2C17.5 C14%2C17.2238576 14.2238576%2C17 14.5%2C17 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomin{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25%22 fill%3D%22%23666%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomout{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4-Copy%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}';
catalog_extension_styleInject(catalog_extension_css_248z$4);

function catalog_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$2(o) {
    catalog_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$2(o);
}
function catalog_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$2(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$2(self, call) {
    if (call && (catalog_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$2(self);
}
function catalog_extension_setPrototypeOf$2(o, p) {
    catalog_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$2(o, p);
}
var catalog_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$2(this, result);
    };
}
var catalog_extension_IconItem = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$2(IconItem, Component);
    var _super = catalog_extension_createSuper$2(IconItem);
    function IconItem() {
        catalog_extension_classCallCheck$4(this, IconItem);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasTooltip: false
        };
        return _this;
    }
    var _proto = IconItem.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, tip = _this_props.tip, onClick = _this_props.onClick, _this_props_type = _this_props.type, type = _this_props_type === void 0 ? "" : _this_props_type, icon = _this_props.icon;
        var hasTooltip = this.state.hasTooltip;
        var bgStyle = null;
        if (icon) {
            var backgroundImage = icon;
            if (typeof backgroundImage === "string" && !backgroundImage.startsWith("url(")) {
                // 如果只提供了图片地址，拼出合法的 css 图片链接字符串
                backgroundImage = "url(".concat(backgroundImage, ")");
            }
            bgStyle = {
                backgroundImage: backgroundImage
            };
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(catalog_extension_classNamePrefix("icon-item"), " ").concat(type || ""),
            style: bgStyle,
            onMouseEnter: function() {
                return _this.setState({
                    hasTooltip: true
                });
            },
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: onClick
        }, hasTooltip && /*#__PURE__*/ react_default.a.createElement("span", {
            className: catalog_extension_classNamePrefix("base-toolbar-tooltip")
        }, tip));
    };
    return IconItem;
}(react["Component"]);

var catalog_extension_css_248z$5 = '.ct-base-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-base-toolbar .split{width:1px;height:14px;margin-top:0;background:#d9d9d9}.ct-base-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-base-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}';
catalog_extension_styleInject(catalog_extension_css_248z$5);

/**
 * 工具条组件
 */ function catalog_extension_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$3(o) {
    catalog_extension_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$3(o);
}
function catalog_extension_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$3(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$3(self, call) {
    if (call && (catalog_extension_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$3(self);
}
function catalog_extension_setPrototypeOf$3(o, p) {
    catalog_extension_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$3(o, p);
}
var catalog_extension_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$3(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$3(this, result);
    };
}
var catalog_extension_Toolbar = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$3(Toolbar, Component);
    var _super = catalog_extension_createSuper$3(Toolbar);
    function Toolbar() {
        catalog_extension_classCallCheck$5(this, Toolbar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderItem = function(tool) {
            var custom = tool.custom, title = tool.title, icon = tool.icon, callback = tool.callback;
            return custom || /*#__PURE__*/ react_default.a.createElement(catalog_extension_IconItem, {
                key: title,
                type: icon,
                onClick: callback,
                tip: title
            });
        };
        _this.renderToolGroup = function(group, index, split) {
            return /*#__PURE__*/ react_default.a.createElement(react["Fragment"], {
                key: index
            }, group.map(function(tool) {
                return _this.renderItem(tool);
            }), split && /*#__PURE__*/ react_default.a.createElement("div", {
                className: "split"
            }));
        };
        return _this;
    }
    var _proto = Toolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, _this_props_tools = _this_props.tools, tools = _this_props_tools === void 0 ? [] : _this_props_tools, className = _this_props.className;
        var prefix = catalog_extension_classNamePrefix("toolbox");
        var lastIndex = tools.length - 1;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, tools.map(function(group, index) {
            return _this.renderToolGroup(group, index, index !== lastIndex);
        }));
    };
    return Toolbar;
}(react["Component"]);

var catalog_extension_css_248z$6 = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
catalog_extension_styleInject(catalog_extension_css_248z$6);

function catalog_extension_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function catalog_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) catalog_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) catalog_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
var emptyCatalogData = {
    catalog: [],
    minLevel: 7
};
var MessageService = /*#__PURE__*/ function() {
    function MessageService(val) {
        var _this = this;
        catalog_extension_classCallCheck$6(this, MessageService);
        this.val = val;
        this.fs = [];
        this.on = function(fn) {
            _this.fs.push(fn);
        };
        this.emit = function(newVal) {
            _this.val = newVal;
            _this.fs.forEach(function(f) {
                return f(newVal);
            });
        };
        this.remove = function(fn) {
            var index = _this.fs.findIndex(function(f) {
                return f === fn;
            });
            if (index > -1) {
                _this.fs.splice(index, 1);
            }
        };
        this.val = val;
    }
    catalog_extension_createClass(MessageService, [
        {
            key: "value",
            get: function get() {
                return this.val;
            }
        }
    ]);
    return MessageService;
}();
var catalogService = new MessageService(emptyCatalogData);

var HEAD_LEVEL = 7;
var numberHeadingFactory = function(minLevel) {
    var numbers = [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    return function(index) {
        for(var i = 1; i < index; i++){
            if (numbers[i] === 0) {
                numbers[i] = 1;
            }
        }
        numbers[index] += 1;
        for(var i1 = index + 1; i1 < HEAD_LEVEL; i1++){
            numbers[i1] = 0;
        }
        return "".concat(numbers.slice(minLevel, index + 1).join("."));
    };
};
var prefixFactory = function(style, minLevel) {
    var numberHeading = style === "number" ? numberHeadingFactory(minLevel) : function() {
        return "";
    };
    var prefix;
    switch(style){
        case "point":
            prefix = /*#__PURE__*/ react_default.a.createElement("div", {
                className: catalog_extension_classNamePrefix("icon-round-preview")
            });
            break;
        case "circle":
            prefix = /*#__PURE__*/ react_default.a.createElement("div", {
                className: catalog_extension_classNamePrefix("icon-ring-preview")
            });
            break;
        case "rect":
            prefix = /*#__PURE__*/ react_default.a.createElement("div", {
                className: catalog_extension_classNamePrefix("icon-rect-preview")
            });
            break;
        default:
            prefix = null;
            break;
    }
    return function(level) {
        if (style !== "number") {
            return prefix;
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "number"
        }, numberHeading(level), "\xa0");
    };
};
var getCatalogData = function(view) {
    if (!view) {
        return emptyCatalogData;
    }
    var $headingNodes = view.dom.querySelectorAll("h1, h2, h3, h4, h5, h6");
    var catalog = [];
    var minLevel = HEAD_LEVEL;
    $headingNodes.forEach(function($node) {
        if ($node.textContent === null) {
            return;
        }
        var text = $node.textContent.replace(/\s/g, "").replace(/#/g, "");
        if (!text) {
            return;
        }
        var level = parseInt($node.nodeName.slice(1), 10);
        if (level < minLevel) {
            minLevel = level;
        }
        catalog.push({
            node: $node,
            key: $node.id,
            text: $node.textContent,
            level: level,
            isIntersecting: false,
            scrollIntoView: function() {
                return $node.scrollIntoView();
            }
        });
    });
    return {
        catalog: catalog,
        minLevel: minLevel
    };
};

function catalog_extension_assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        catalog_extension_get = Reflect.get;
    } else {
        catalog_extension_get = function _get(target, property, receiver) {
            var base = catalog_extension_superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return catalog_extension_get(target, property, receiver || target);
}
function catalog_extension_getPrototypeOf$4(o) {
    catalog_extension_getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$4(o);
}
function catalog_extension_inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$4(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$4(self, call) {
    if (call && (catalog_extension_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$4(self);
}
function catalog_extension_setPrototypeOf$4(o, p) {
    catalog_extension_setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$4(o, p);
}
function catalog_extension_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = catalog_extension_getPrototypeOf$4(object);
        if (object === null) break;
    }
    return object;
}
var catalog_extension_typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$4(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$4(this, result);
    };
}
// 当内容发生变化时，延迟更新目录，防止处理过于频繁
var UPDATE_DELAY = 100;
var catalog_extension_ToolbarPopover = /*#__PURE__*/ function(PluginView) {
    catalog_extension_inherits$4(ToolbarPopover, PluginView);
    var _super = catalog_extension_createSuper$4(ToolbarPopover);
    function ToolbarPopover(view, config) {
        catalog_extension_classCallCheck$7(this, ToolbarPopover);
        var _this;
        _this = _super.call(this, view, config);
        _this.handleEdit = null;
        _this.handleUpdate = null;
        _this.notifyChange = function(view) {
            var catagory = getCatalogData(view);
            catalogService.emit(catagory);
        };
        _this.handleEdit = config.handleEdit;
        _this.handleUpdate = lodash_debounce_default()(_this.notifyChange, UPDATE_DELAY);
        return _this;
    }
    var _proto = ToolbarPopover.prototype;
    _proto.update = function update(view, lastState) {
        if (!view.composing) {
            // 当不在输入状态时，更新目录
            this.handleUpdate(view);
        }
        catalog_extension_get(catalog_extension_getPrototypeOf$4(ToolbarPopover.prototype), "update", this).call(this, view, lastState);
    };
    _proto.getNode = function getNode(view) {
        var state = view.state;
        if (state.selection.empty) {
            return null;
        }
        var pos = state.selection.from;
        var selectedNode = state.doc.nodeAt(pos);
        if (!selectedNode || selectedNode.type !== state.schema.nodes.catalog) {
            return null;
        }
        return view.nodeDOM(pos);
    };
    _proto.getContent = function getContent() {
        var _this = this;
        var state = this.view.state;
        var pos = state.selection.from;
        var node = state.doc.nodeAt(pos);
        if (!node) {
            return null;
        }
        var tools = [
            [
                {
                    icon: "edit",
                    title: "编辑",
                    callback: function() {
                        return _this.handleEdit(_this.view, pos);
                    }
                }
            ]
        ];
        return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement(catalog_extension_Toolbar, {
            tools: tools
        }));
    };
    return ToolbarPopover;
}(catalog_extension_PluginView);

var catalog_extension_css_248z$7 = ".ct-edit-edit-catalog .no{color:#3d91f2;font-size:14px}.ct-edit-edit-catalog .link-wrapper{color:#3789a9;cursor:pointer;display:flex;font-size:14px;line-height:20px;white-space:pre-wrap;word-wrap:break-word}.ct-edit-edit-catalog .link-wrapper .ct-icon-round-preview{width:6px;height:6px;border-radius:50%;background-color:#333;margin-top:7px;margin-right:10px}.ct-edit-edit-catalog .link-wrapper .ct-icon-ring-preview{width:6px;height:6px;border-radius:50%;border:1px solid #333;background-color:transparent;margin-top:7px;margin-right:10px}.ct-edit-edit-catalog .link-wrapper .ct-icon-rect-preview{width:6px;height:6px;background-color:#333;margin-top:7px;margin-right:10px}.ct-edit-edit-catalog .link-wrapper svg{height:6px;margin-right:10px;margin-top:7px;min-width:6px;width:6px}.ct-edit-edit-catalog .link-wrapper svg circle,.ct-edit-edit-catalog .link-wrapper svg g,.ct-edit-edit-catalog .link-wrapper svg path{fill:#3d91f2}.ct-edit-edit-catalog .link-wrapper a{color:#3d91f2}.ct-edit-edit-catalog .link-wrapper a:hover{color:#23bdd9;text-decoration:underline}.ct-edit-edit-catalog .link-wrapper a:active{color:#00a7cd}.ct-edit-edit-catalog .indent-1{padding-left:20px}.ct-edit-edit-catalog .indent-2{padding-left:40px}.ct-edit-edit-catalog .indent-3{padding-left:60px}.ct-edit-edit-catalog .indent-4{padding-left:80px}.ct-edit-edit-catalog .indent-5{padding-left:100px}";
catalog_extension_styleInject(catalog_extension_css_248z$7);

function catalog_extension_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function catalog_extension_arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function catalog_extension_iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function catalog_extension_nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function catalog_extension_slicedToArray$1(arr, i) {
    return catalog_extension_arrayWithHoles$1(arr) || catalog_extension_iterableToArrayLimit$1(arr, i) || catalog_extension_unsupportedIterableToArray$2(arr, i) || catalog_extension_nonIterableRest$1();
}
function catalog_extension_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return catalog_extension_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return catalog_extension_arrayLikeToArray$2(o, minLen);
}
var Headings = function(param) {
    var attrs = param.attrs, view = param.view;
    var _useState = catalog_extension_slicedToArray$1(Object(react["useState"])([]), 2), catalog = _useState[0], setCatalog = _useState[1];
    var _useState1 = catalog_extension_slicedToArray$1(Object(react["useState"])(null), 2), minLevel = _useState1[0], setMinLevel = _useState1[1];
    var style = attrs.style || "none";
    var onHeadingChange = function(param) {
        var minLevelValue = param.minLevel, catalogValue = param.catalog;
        setMinLevel(minLevelValue);
        setCatalog(catalogValue);
    };
    Object(react["useEffect"])(function() {
        catalogService.emit(getCatalogData(view));
        var _catalogService_value = catalogService.value, catalogDefaultValue = _catalogService_value.catalog, minLevelDefaultValue = _catalogService_value.minLevel;
        setCatalog(catalogDefaultValue);
        setMinLevel(minLevelDefaultValue);
        catalogService.on(onHeadingChange);
        return function() {
            catalogService.remove(onHeadingChange);
        };
    }, []);
    if (catalog.length === 0) {
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "no"
        }, "请在文档中添加标题");
    }
    var factory = prefixFactory(style, minLevel);
    var links = catalog.map(function(param) {
        var key = param.key, level = param.level, text = param.text, scrollIntoView = param.scrollIntoView;
        var indent = level - minLevel;
        var prefix = factory(level);
        return /*#__PURE__*/ react_default.a.createElement("div", {
            key: key,
            className: "indent-".concat(indent, " link-wrapper")
        }, prefix, /*#__PURE__*/ react_default.a.createElement("a", {
            className: "link",
            onClick: scrollIntoView
        }, text));
    });
    return /*#__PURE__*/ react_default.a.createElement("div", null, links);
};

var catalog_extension_css_248z$8 = ".ct-node-view-dom .ct-edit-edit-catalog{border:1px solid transparent;display:flex;flex-direction:column;padding:8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;min-width:400px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ct-node-view-dom .ct-edit-edit-catalog:hover{background:rgba(0,167,205,.1)}.ct-node-view-dom .ct-edit-edit-catalog .title{color:#3d91f2;cursor:pointer;font-size:24px;line-height:36px;margin-bottom:8px;width:auto}.ProseMirror-selectednode .ct-edit-edit-catalog{background:rgba(0,167,205,.1);border-color:#00a7cd}";
catalog_extension_styleInject(catalog_extension_css_248z$8);

var CatalogNodeView = function(param) {
    var view = param.view, attrs = param.attrs;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "ct-edit-edit-catalog"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "title"
    }, "目录"), /*#__PURE__*/ react_default.a.createElement(Headings, {
        attrs: attrs,
        view: view
    }));
};

function catalog_extension_assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$5(o) {
    catalog_extension_getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$5(o);
}
function catalog_extension_inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$5(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$5(self, call) {
    if (call && (catalog_extension_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$5(self);
}
function catalog_extension_setPrototypeOf$5(o, p) {
    catalog_extension_setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$5(o, p);
}
var catalog_extension_typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$5(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$5(this, result);
    };
}
var catalog_extension_Preview = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$5(Preview, Component);
    var _super = catalog_extension_createSuper$5(Preview);
    function Preview() {
        catalog_extension_classCallCheck$8(this, Preview);
        return _super.apply(this, arguments);
    }
    var _proto = Preview.prototype;
    _proto.render = function render() {
        var style = this.props.style;
        var factory = prefixFactory(style, 1);
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-preview")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-preview-title")
        }, "预览："), /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-preview-block")
        }, /*#__PURE__*/ react_default.a.createElement("div", null, factory(1), /*#__PURE__*/ react_default.a.createElement("span", null, "一级标题")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "indent-2"
        }, factory(2), /*#__PURE__*/ react_default.a.createElement("span", null, "二级标题")), /*#__PURE__*/ react_default.a.createElement("div", null, factory(1), /*#__PURE__*/ react_default.a.createElement("span", null, "一级标题")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "indent-2"
        }, factory(2), /*#__PURE__*/ react_default.a.createElement("span", null, "二级标题")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "indent-3"
        }, factory(3), /*#__PURE__*/ react_default.a.createElement("span", null, "三级标题"))));
    };
    return Preview;
}(react["Component"]);

var catalog_extension_css_248z$9 = '.ct-radio-group .ct-radio-wrapper{align-items:center;box-sizing:border-box;color:rgba(0,0,0,.65);cursor:pointer;display:inline-flex;flex-direction:row;font-size:14px;height:22px;line-height:22px;margin-bottom:12px;padding:0;position:relative;white-space:nowrap;width:100%}.ct-radio-group .ct-radio-wrapper:hover .ct-radio .ct-radio-inner{border-color:#3d91f2}.ct-radio-group .ct-radio-wrapper span{display:flex}.ct-radio-group .ct-radio-wrapper .ct-radio-title{padding:0 8px}.ct-radio-group .ct-radio-wrapper .ct-radio{display:flex;flex-direction:column}.ct-radio-group .ct-radio-wrapper .ct-radio .ct-radio-inner{background-color:#fff;border-radius:100px;border:1px solid #d9d9d9;display:block;height:15px;left:0;position:relative;top:0;transition:all .3s;width:15px}.ct-radio-group .ct-radio-wrapper .ct-radio .ct-radio-inner:after{background-color:#fff;border-radius:100px;content:" ";display:block;height:5px;left:4px;position:absolute;top:4px;transition:all .3s cubic-bezier(.78,.14,.15,.86);width:5px}.ct-radio-group .ct-radio-wrapper .ct-radio .ct-radio-input{bottom:0;cursor:pointer;left:0;opacity:0;position:absolute;right:0;top:0;z-index:1}.ct-radio-group .ct-radio-wrapper .ct-radio.checked .ct-radio-inner{background:#1c6cdc;border-color:#1c6cdc}';
catalog_extension_styleInject(catalog_extension_css_248z$9);

function catalog_extension_assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$6(o) {
    catalog_extension_getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$6(o);
}
function catalog_extension_inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$6(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$6(self, call) {
    if (call && (catalog_extension_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$6(self);
}
function catalog_extension_setPrototypeOf$6(o, p) {
    catalog_extension_setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$6(o, p);
}
var catalog_extension_typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$6(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$6(this, result);
    };
}
var catalog_extension_noop$1 = function() {};
var catalog_extension_RadioGroup = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$6(RadioGroup, Component);
    var _super = catalog_extension_createSuper$6(RadioGroup);
    function RadioGroup(props) {
        catalog_extension_classCallCheck$9(this, RadioGroup);
        var _this;
        _this = _super.call(this, props);
        _this.handleChange = function(e) {
            var onChange = _this.props.onChange;
            var value = e.target.value;
            _this.setState({
                value: value
            });
            onChange(value);
        };
        _this.state = {
            value: props.value
        };
        return _this;
    }
    var _proto = RadioGroup.prototype;
    _proto.render = function render() {
        var _this = this;
        var items = this.props.items;
        var _this_state = this.state, v = _this_state.value;
        var radios = items.map(function(param) {
            var title = param.title, value = param.value;
            var checked = value === v;
            var radioCls = "".concat(catalog_extension_classNamePrefix("radio")).concat(checked ? " checked" : "");
            return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
            /*#__PURE__*/ react_default.a.createElement("label", {
                key: value,
                className: catalog_extension_classNamePrefix("radio-wrapper"),
                onClick: _this.handleChange
            }, /*#__PURE__*/ react_default.a.createElement("span", {
                className: radioCls
            }, /*#__PURE__*/ react_default.a.createElement("input", {
                className: catalog_extension_classNamePrefix("radio-input"),
                type: "radio",
                value: value,
                checked: checked,
                onChange: catalog_extension_noop$1
            }), /*#__PURE__*/ react_default.a.createElement("span", {
                className: catalog_extension_classNamePrefix("radio-inner")
            })), /*#__PURE__*/ react_default.a.createElement("span", {
                className: catalog_extension_classNamePrefix("radio-title")
            }, title)));
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("radio-group")
        }, radios);
    };
    return RadioGroup;
}(react["Component"]);

function catalog_extension_assertThisInitialized$7(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$7(o) {
    catalog_extension_getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$7(o);
}
function catalog_extension_inherits$7(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$7(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$7(self, call) {
    if (call && (catalog_extension_typeof$7(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$7(self);
}
function catalog_extension_setPrototypeOf$7(o, p) {
    catalog_extension_setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$7(o, p);
}
var catalog_extension_typeof$7 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$7(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$7(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$7(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$7(this, result);
    };
}
var catalog_extension_items = [
    {
        title: "无",
        value: "none"
    },
    {
        title: "多级编号",
        value: "number"
    },
    {
        title: "圆点",
        value: "point"
    },
    {
        title: "空心圆",
        value: "circle"
    },
    {
        title: "方块",
        value: "rect"
    }
];
var catalog_extension_StyleList = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$7(StyleList, Component);
    var _super = catalog_extension_createSuper$7(StyleList);
    function StyleList() {
        catalog_extension_classCallCheck$a(this, StyleList);
        var _this;
        _this = _super.apply(this, arguments);
        _this.examples = [
            /*#__PURE__*/ react_default.a.createElement("div", {
                key: "none",
                className: "catalog-example-line none"
            }),
            /*#__PURE__*/ react_default.a.createElement("div", {
                key: "number",
                className: "catalog-example-line number"
            }, "1.2.3.4..."),
            /*#__PURE__*/ react_default.a.createElement("div", {
                key: "round",
                className: "catalog-example-line catalog-icon catalog-icon--round"
            }),
            /*#__PURE__*/ react_default.a.createElement("div", {
                key: "ring",
                className: "catalog-example-line catalog-icon catalog-icon--ring"
            }),
            /*#__PURE__*/ react_default.a.createElement("div", {
                key: "rect",
                className: "catalog-example-line catalog-icon catalog-icon--rect"
            })
        ];
        return _this;
    }
    var _proto = StyleList.prototype;
    _proto.render = function render() {
        var _this_props = this.props, value = _this_props.value, onChange = _this_props.onChange;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-stylelist")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-stylelist-title")
        }, "目录样式："), /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-stylelist-radios")
        }, /*#__PURE__*/ react_default.a.createElement(catalog_extension_RadioGroup, {
            items: catalog_extension_items,
            value: value,
            onChange: onChange
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-stylelist-examples")
        }, this.examples));
    };
    return StyleList;
}(react["Component"]);

var catalog_extension_css_248z$a = ".ct-catalog-editor-modal .content{border:0!important}.ct-catalog-editor-modal .ct-catalog-editor-wrapper{display:flex;flex-direction:row;height:247px;padding-top:20px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview{flex:1}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-title{color:#333;font-family:PingFangSC-Medium;font-size:14px;margin-bottom:8px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block{border-radius:4px;border:1px solid rgba(0,0,0,.07);padding:12px 32px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block .ct-icon-round-preview{width:6px;height:6px;border-radius:50%;background-color:#1c6cdc;margin-right:10px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block .ct-icon-ring-preview{width:6px;height:6px;border-radius:50%;border:1px solid #1c6cdc;background-color:transparent;margin-right:10px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block .ct-icon-rect-preview{width:6px;height:6px;background-color:#1c6cdc;margin-right:10px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block div{align-items:center;color:#1c6cdc;display:flex;font-size:14px;margin-bottom:8px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block div div{margin-bottom:0}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block .indent-2{padding-left:16px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-preview .ct-catalog-editor-preview-block .indent-3{padding-left:32px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist{position:relative;width:240px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist .ct-catalog-editor-stylelist-title{color:#333;font-family:PingFangSC-Medium;font-size:14px;height:22px;margin-bottom:14px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist .radio-group{display:flex;flex-direction:column}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist .radio-group .radio{margin-right:8px;position:relative;top:-1px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-radios{width:120px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples{display:flex;flex-direction:column;left:146px;position:absolute;top:30px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples .catalog-example-line{font-size:14px;position:relative;transform:translateY(1px)}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples .catalog-icon{margin-bottom:22px;background-repeat:no-repeat;background-position:50%}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples .catalog-icon.catalog-icon--round{width:12px;height:12px;border-radius:50%;background-color:#333}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples .catalog-icon.catalog-icon--ring{width:12px;height:12px;border-radius:50%;border:2px solid #333;background-color:transparent}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples .catalog-icon.catalog-icon--rect{width:12px;height:12px;background-color:#333}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples .number{padding:0;margin-bottom:13px}.ct-catalog-editor-modal .ct-catalog-editor-wrapper .ct-catalog-editor-stylelist-examples>*{height:32px;line-height:32px;margin-bottom:2px}";
catalog_extension_styleInject(catalog_extension_css_248z$a);

function catalog_extension_assertThisInitialized$8(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$b(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_getPrototypeOf$8(o) {
    catalog_extension_getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return catalog_extension_getPrototypeOf$8(o);
}
function catalog_extension_inherits$8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) catalog_extension_setPrototypeOf$8(subClass, superClass);
}
function catalog_extension_possibleConstructorReturn$8(self, call) {
    if (call && (catalog_extension_typeof$8(call) === "object" || typeof call === "function")) {
        return call;
    }
    return catalog_extension_assertThisInitialized$8(self);
}
function catalog_extension_setPrototypeOf$8(o, p) {
    catalog_extension_setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return catalog_extension_setPrototypeOf$8(o, p);
}
var catalog_extension_typeof$8 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function catalog_extension_isNativeReflectConstruct$8() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function catalog_extension_createSuper$8(Derived) {
    var hasNativeReflectConstruct = catalog_extension_isNativeReflectConstruct$8();
    return function _createSuperInternal() {
        var Super = catalog_extension_getPrototypeOf$8(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = catalog_extension_getPrototypeOf$8(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return catalog_extension_possibleConstructorReturn$8(this, result);
    };
}
var MODAL_ID = "parker-catalog-edit-modal";
var catalog_extension_CatagoryEditorModal = /*#__PURE__*/ function(Component) {
    catalog_extension_inherits$8(CatagoryEditorModal, Component);
    var _super = catalog_extension_createSuper$8(CatagoryEditorModal);
    function CatagoryEditorModal(props) {
        catalog_extension_classCallCheck$b(this, CatagoryEditorModal);
        var _this;
        _this = _super.call(this, props);
        _this.handleStyleChange = function(style) {
            var update = _this.props.update;
            _this.setState({
                style: style
            });
            update(style);
        };
        _this.handleOk = function() {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            catalog_extension_close();
        };
        _this.handleCancel = function() {
            var _this_props = _this.props, catalogStyle = _this_props.catalogStyle, update = _this_props.update;
            var style = _this.state.style;
            if (style !== catalogStyle) {
                update(catalogStyle);
            }
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            catalog_extension_close();
        };
        _this.state = {
            style: props.catalogStyle
        };
        return _this;
    }
    var _proto = CatagoryEditorModal.prototype;
    _proto.render = function render() {
        var style = this.state.style;
        return /*#__PURE__*/ react_default.a.createElement(catalog_extension_Modal, {
            className: catalog_extension_classNamePrefix("catalog-editor-modal"),
            onCancel: this.handleCancel.bind(this),
            onOk: this.handleOk,
            title: "目录"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: catalog_extension_classNamePrefix("catalog-editor-wrapper")
        }, /*#__PURE__*/ react_default.a.createElement(catalog_extension_StyleList, {
            onChange: this.handleStyleChange,
            value: style
        }), /*#__PURE__*/ react_default.a.createElement(catalog_extension_Preview, {
            style: style
        })));
    };
    return CatagoryEditorModal;
}(react["Component"]);
var catalog_extension_close = function() {
    var modalElem = document.getElementById(MODAL_ID);
    if (modalElem) {
        react_dom_default.a.render(null, modalElem);
        modalElem.remove();
    }
};
var catalog_extension_open = function(param) {
    var catalogStyle = param.catalogStyle, update = param.update;
    catalog_extension_close();
    var modalElem = document.createElement("div");
    modalElem.id = MODAL_ID;
    document.body.append(modalElem);
    react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(catalog_extension_CatagoryEditorModal, {
        catalogStyle: catalogStyle,
        update: update
    }), modalElem);
    return {
        close: catalog_extension_close
    };
};
var EditorModal = {
    open: catalog_extension_open,
    close: catalog_extension_close
};

function _assertThisInitialized$9(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function catalog_extension_classCallCheck$c(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function catalog_extension_defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function catalog_extension_createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) catalog_extension_defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) catalog_extension_defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$9(o) {
    _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$9(o);
}
function _inherits$9(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$9(subClass, superClass);
}
function _possibleConstructorReturn$9(self, call) {
    if (call && (_typeof$9(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$9(self);
}
function _setPrototypeOf$9(o, p) {
    _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$9(o, p);
}
var _typeof$9 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$9() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$9(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$9();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$9(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$9(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$9(this, result);
    };
}
var catalogPluginKey = new prosemirror_state_dist["PluginKey"]("catalog");
var catalog_extension_CatalogExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$9(CatalogExtension, NodeExtension);
    var _super = _createSuper$9(CatalogExtension);
    function CatalogExtension() {
        catalog_extension_classCallCheck$c(this, CatalogExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.store = {} // 用于 plugin view  和 content view 之间的数据交换，暂时没有通用机制
        ;
        _this.showEditor = function(view, pos) {
            var node = null;
            if (!pos) {
                var selection = view.state.selection;
                if (!selection || selection.empty) {
                    return false;
                }
                pos = selection.from;
            }
            node = view.state.doc.nodeAt(pos);
            if (!node || node.type !== view.state.schema.nodes.catalog) {
                return false;
            }
            var style = node.attrs.style;
            EditorModal.open({
                catalogStyle: style,
                update: function(catalogStyle) {
                    view.dispatch(view.state.tr.setNodeMarkup(pos, null, {
                        style: catalogStyle
                    }));
                }
            });
            return true;
        };
        _this.nodeViews = CatalogNodeView;
        return _this;
    }
    var _proto = CatalogExtension.prototype;
    _proto.plugin = function plugin() {
        var _this = this;
        return new prosemirror_state_dist["Plugin"]({
            key: catalogPluginKey,
            props: {
                handleDOMEvents: {
                    compositionend: function compositionend(view) {
                        catalogService.emit(getCatalogData(view));
                        return false;
                    }
                },
                handleDoubleClick: function(view, pos) {
                    return _this.showEditor(view, pos);
                }
            },
            view: function(view) {
                return new catalog_extension_ToolbarPopover(view, {
                    isSticky: false,
                    handleEdit: _this.showEditor
                });
            }
        });
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, editorEventEmitter = param.editorEventEmitter;
        return {
            insert: catalog_extension_execAfterCommands(insertCatalog, function() {
                return editorEventEmitter.emit(catalog_extension_AFTER_INSERT, {
                    braceWidth: 250
                });
            }),
            isDisabled: function() {
                return function() {
                    return !catalog_extension_canInsertTypes(getState());
                };
            }
        };
    };
    catalog_extension_createClass$1(CatalogExtension, [
        {
            key: "name",
            get: function get() {
                return "catalog";
            }
        }
    ]);
    return CatalogExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/code-extension/index.js
var code_extension = __webpack_require__("63e5");

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/horizontalrule-extension/index.js







function horizontalrule_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var horizontalrule_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function horizontalrule_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = horizontalrule_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && horizontalrule_extension_isParagraph(content[size - 1]) && horizontalrule_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}

function insertHr(state, dispatch) {
    var node = state.schema.nodes.horizontal_rule.create();
    var transaction = horizontalrule_extension_insertBlock(state, node).transaction;
    dispatch(transaction);
    return true;
}

// 类型是否可以插入富文本
var horizontalrule_extension_canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};
var blockInputRule = function(regexp, nodeType) {
    return new prosemirror_inputrules_dist["a" /* InputRule */](regexp, function(state, match, start, end) {
        var transaction = horizontalrule_extension_insertBlock(state, nodeType.create()).transaction;
        // 删除快捷键
        transaction.deleteRange(start - 1, end);
        return transaction;
    });
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 水平线
var regexpHr = /^---\n$/;

var HorizontalRuleView = function(props) {
    return /*#__PURE__*/ react_default.a.createElement("hr", null);
};

function horizontalrule_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var horizontalrule_extension_css_248z = ".ProseMirror hr.ct-node-view-dom{border:0;-webkit-margin-before:.5em;margin-block-start:.5em;-webkit-margin-after:.5em;margin-block-end:.5em;-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto}.ProseMirror hr.ct-node-view-dom hr{display:block;height:1px;width:100%;border:0;background:#ccc}.ct-node-view-dom.ProseMirror-selectednode hr{background:#00a7cd;outline:1px solid #00a7cd}";
horizontalrule_extension_styleInject(horizontalrule_extension_css_248z);

function horizontalrule_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function horizontalrule_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function horizontalrule_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function horizontalrule_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) horizontalrule_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) horizontalrule_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function horizontalrule_extension_getPrototypeOf(o) {
    horizontalrule_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return horizontalrule_extension_getPrototypeOf(o);
}
function horizontalrule_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) horizontalrule_extension_setPrototypeOf(subClass, superClass);
}
function horizontalrule_extension_possibleConstructorReturn(self, call) {
    if (call && (horizontalrule_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return horizontalrule_extension_assertThisInitialized(self);
}
function horizontalrule_extension_setPrototypeOf(o, p) {
    horizontalrule_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return horizontalrule_extension_setPrototypeOf(o, p);
}
var horizontalrule_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function horizontalrule_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function horizontalrule_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = horizontalrule_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = horizontalrule_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = horizontalrule_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return horizontalrule_extension_possibleConstructorReturn(this, result);
    };
}
var HorizontalRuleExtension = /*#__PURE__*/ function(NodeExtension) {
    horizontalrule_extension_inherits(HorizontalRuleExtension, NodeExtension);
    var _super = horizontalrule_extension_createSuper(HorizontalRuleExtension);
    function HorizontalRuleExtension() {
        horizontalrule_extension_classCallCheck(this, HorizontalRuleExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = HorizontalRuleView;
        return _this;
    }
    var _proto = HorizontalRuleExtension.prototype;
    _proto.commands = function commands(param) {
        var getState = param.getState;
        return {
            insertHr: function() {
                return insertHr;
            },
            isHrDisabled: function() {
                return function() {
                    return !horizontalrule_extension_canInsertTypes(getState());
                };
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            blockInputRule(new RegExp(regexpHr), type)
        ];
    };
    horizontalrule_extension_createClass(HorizontalRuleExtension, [
        {
            key: "name",
            get: function get() {
                return "horizontal_rule";
            }
        }
    ]);
    return HorizontalRuleExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/rc-checkbox/es/index.js








// eslint-disable-next-line import/no-extraneous-dependencies



var es_Checkbox = /*#__PURE__*/function (_Component) {
  inherits_inherits(Checkbox, _Component);

  var _super = createSuper_createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    classCallCheck_classCallCheck(this, Checkbox);

    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (disabled) {
        return;
      }

      if (!('checked' in _this.props)) {
        _this.setState({
          checked: e.target.checked
        });
      }

      if (onChange) {
        onChange({
          target: objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, _this.props), {}, {
            checked: e.target.checked
          }),
          stopPropagation: function stopPropagation() {
            e.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e.preventDefault();
          },
          nativeEvent: e.nativeEvent
        });
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    var checked = 'checked' in props ? props.checked : props.defaultChecked;
    _this.state = {
      checked: checked
    };
    return _this;
  }

  createClass_createClass(Checkbox, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          style = _this$props2.style,
          name = _this$props2.name,
          id = _this$props2.id,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          tabIndex = _this$props2.tabIndex,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          onKeyDown = _this$props2.onKeyDown,
          onKeyPress = _this$props2.onKeyPress,
          onKeyUp = _this$props2.onKeyUp,
          autoFocus = _this$props2.autoFocus,
          value = _this$props2.value,
          required = _this$props2.required,
          others = objectWithoutProperties_objectWithoutProperties(_this$props2, ["prefixCls", "className", "style", "name", "id", "type", "disabled", "readOnly", "tabIndex", "onClick", "onFocus", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "autoFocus", "value", "required"]);

      var globalProps = Object.keys(others).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
          // eslint-disable-next-line no-param-reassign
          prev[key] = others[key];
        }

        return prev;
      }, {});
      var checked = this.state.checked;
      var classString = node_modules_classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_defineProperty(_classNames, "".concat(prefixCls, "-checked"), checked), defineProperty_defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return /*#__PURE__*/react_default.a.createElement("span", {
        className: classString,
        style: style
      }, /*#__PURE__*/react_default.a.createElement("input", extends_extends({
        name: name,
        id: id,
        type: type,
        required: required,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: "".concat(prefixCls, "-input"),
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)), /*#__PURE__*/react_default.a.createElement("span", {
        className: "".concat(prefixCls, "-inner")
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('checked' in props) {
        return objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, state), {}, {
          checked: props.checked
        });
      }

      return null;
    }
  }]);

  return Checkbox;
}(react["Component"]);

es_Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {}
};
/* harmony default export */ var rc_checkbox_es = (es_Checkbox);
// CONCATENATED MODULE: ./node_modules/rc-util/es/Children/toArray.js


function toArray_toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ret = [];
  react_default.a.Children.forEach(children, function (child) {
    if ((child === undefined || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray_toArray(child));
    } else if (Object(react_is["isFragment"])(child) && child.props) {
      ret = ret.concat(toArray_toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}
// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/utils/observerUtil.js
 // =============================== Const ===============================

var elementListeners = new Map();

function observerUtil_onResize(entities) {
  entities.forEach(function (entity) {
    var _elementListeners$get;

    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 ? void 0 : _elementListeners$get.forEach(function (listener) {
      return listener(target);
    });
  });
} // Note: ResizeObserver polyfill not support option to measure border-box resize


var observerUtil_resizeObserver = new ResizeObserver_es["a" /* default */](observerUtil_onResize); // Dev env only

var _el =  false ? undefined : null; // eslint-disable-line

var _rs =  false ? undefined : null; // eslint-disable-line
// ============================== Observe ==============================

function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, new Set());
    observerUtil_resizeObserver.observe(element);
  }

  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);

    if (!elementListeners.get(element).size) {
      observerUtil_resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}
// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/SingleObserver/DomWrapper.js





/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */

var SingleObserver_DomWrapper_DomWrapper = /*#__PURE__*/function (_React$Component) {
  inherits_inherits(DomWrapper, _React$Component);

  var _super = createSuper_createSuper(DomWrapper);

  function DomWrapper() {
    classCallCheck_classCallCheck(this, DomWrapper);

    return _super.apply(this, arguments);
  }

  createClass_createClass(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return DomWrapper;
}(react["Component"]);


// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/Collection.js

var CollectionContext = /*#__PURE__*/react["createContext"](null);
/**
 * Collect all the resize event from children ResizeObserver
 */

function Collection(_ref) {
  var children = _ref.children,
      onBatchResize = _ref.onBatchResize;
  var resizeIdRef = react["useRef"](0);
  var resizeInfosRef = react["useRef"]([]);
  var onCollectionResize = react["useContext"](CollectionContext);
  var onResize = react["useCallback"](function (size, element, data) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size: size,
      element: element,
      data: data
    });
    Promise.resolve().then(function () {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 ? void 0 : onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    }); // Continue bubbling if parent exist

    onCollectionResize === null || onCollectionResize === void 0 ? void 0 : onCollectionResize(size, element, data);
  }, [onBatchResize, onCollectionResize]);
  return /*#__PURE__*/react["createElement"](CollectionContext.Provider, {
    value: onResize
  }, children);
}
// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/SingleObserver/index.js







function SingleObserver(props) {
  var children = props.children,
      disabled = props.disabled;
  var elementRef = react["useRef"](null);
  var wrapperRef = react["useRef"](null);
  var onCollectionResize = react["useContext"](CollectionContext); // =========================== Children ===========================

  var isRenderProps = typeof children === 'function';
  var mergedChildren = isRenderProps ? children(elementRef) : children; // ============================= Size =============================

  var sizeRef = react["useRef"]({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }); // ============================= Ref ==============================

  var canRef = !isRenderProps && /*#__PURE__*/react["isValidElement"](mergedChildren) && supportRef(mergedChildren);
  var originRef = canRef ? mergedChildren.ref : null;
  var mergedRef = react["useMemo"](function () {
    return composeRef(originRef, elementRef);
  }, [originRef, elementRef]); // =========================== Observe ============================

  var propsRef = react["useRef"](props);
  propsRef.current = props; // Handler

  var onInternalResize = react["useCallback"](function (target) {
    var _propsRef$current = propsRef.current,
        onResize = _propsRef$current.onResize,
        data = _propsRef$current.data;

    var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

    var offsetWidth = target.offsetWidth,
        offsetHeight = target.offsetHeight;
    /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */

    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);

    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth: offsetWidth,
        offsetHeight: offsetHeight
      };
      sizeRef.current = size; // IE is strange, right?

      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;

      var sizeInfo = objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      }); // Let collection know what happened


      onCollectionResize === null || onCollectionResize === void 0 ? void 0 : onCollectionResize(sizeInfo, target, data);

      if (onResize) {
        // defer the callback but not defer to next frame
        Promise.resolve().then(function () {
          onResize(sizeInfo, target);
        });
      }
    }
  }, []); // Dynamic observe

  react["useEffect"](function () {
    var currentElement = findDOMNode(elementRef.current) || findDOMNode(wrapperRef.current);

    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }

    return function () {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]); // ============================ Render ============================

  return /*#__PURE__*/react["createElement"](SingleObserver_DomWrapper_DomWrapper, {
    ref: wrapperRef
  }, canRef ? /*#__PURE__*/react["cloneElement"](mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
// CONCATENATED MODULE: ./node_modules/rc-resize-observer/es/index.js






var INTERNAL_PREFIX_KEY = 'rc-observer-key';

function ResizeObserver(props) {
  var children = props.children;
  var childNodes = typeof children === 'function' ? [children] : toArray_toArray(children);

  if (false) {}

  return childNodes.map(function (child, index) {
    var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index);
    return /*#__PURE__*/react["createElement"](SingleObserver, extends_extends({}, props, {
      key: key
    }), child);
  });
}

ResizeObserver.Collection = Collection;
/* harmony default export */ var rc_resize_observer_es = (ResizeObserver);
// CONCATENATED MODULE: ./node_modules/omit.js/es/index.js
function es_omit(obj, fields) {
  // eslint-disable-next-line prefer-object-spread
  var shallowCopy = Object.assign({}, obj);

  for (var i = 0; i < fields.length; i += 1) {
    var key = fields[i];
    delete shallowCopy[key];
  }

  return shallowCopy;
}

/* harmony default export */ var omit_js_es = (es_omit);
// CONCATENATED MODULE: ./node_modules/rc-textarea/es/calculateNodeHeight.js
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}
function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tab-index', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    document.body.appendChild(hiddenTextarea);
  } // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577


  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height += borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height -= paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }

  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY,
    resize: 'none'
  };
}
// CONCATENATED MODULE: ./node_modules/rc-textarea/es/ResizableTextArea.js










 // eslint-disable-next-line @typescript-eslint/naming-convention

var RESIZE_STATUS;

(function (RESIZE_STATUS) {
  RESIZE_STATUS[RESIZE_STATUS["NONE"] = 0] = "NONE";
  RESIZE_STATUS[RESIZE_STATUS["RESIZING"] = 1] = "RESIZING";
  RESIZE_STATUS[RESIZE_STATUS["RESIZED"] = 2] = "RESIZED";
})(RESIZE_STATUS || (RESIZE_STATUS = {}));

var ResizableTextArea_ResizableTextArea = /*#__PURE__*/function (_React$Component) {
  inherits_inherits(ResizableTextArea, _React$Component);

  var _super = createSuper_createSuper(ResizableTextArea);

  function ResizableTextArea(props) {
    var _this;

    classCallCheck_classCallCheck(this, ResizableTextArea);

    _this = _super.call(this, props);

    _this.saveTextArea = function (textArea) {
      _this.textArea = textArea;
    };

    _this.handleResize = function (size) {
      var resizeStatus = _this.state.resizeStatus;
      var _this$props = _this.props,
          autoSize = _this$props.autoSize,
          onResize = _this$props.onResize;

      if (resizeStatus !== RESIZE_STATUS.NONE) {
        return;
      }

      if (typeof onResize === 'function') {
        onResize(size);
      }

      if (autoSize) {
        _this.resizeOnNextFrame();
      }
    };

    _this.resizeOnNextFrame = function () {
      cancelAnimationFrame(_this.nextFrameActionId);
      _this.nextFrameActionId = requestAnimationFrame(_this.resizeTextarea);
    };

    _this.resizeTextarea = function () {
      var autoSize = _this.props.autoSize;

      if (!autoSize || !_this.textArea) {
        return;
      }

      var minRows = autoSize.minRows,
          maxRows = autoSize.maxRows;
      var textareaStyles = calculateNodeHeight(_this.textArea, false, minRows, maxRows);

      _this.setState({
        textareaStyles: textareaStyles,
        resizeStatus: RESIZE_STATUS.RESIZING
      }, function () {
        cancelAnimationFrame(_this.resizeFrameId);
        _this.resizeFrameId = requestAnimationFrame(function () {
          _this.setState({
            resizeStatus: RESIZE_STATUS.RESIZED
          }, function () {
            _this.resizeFrameId = requestAnimationFrame(function () {
              _this.setState({
                resizeStatus: RESIZE_STATUS.NONE
              });

              _this.fixFirefoxAutoScroll();
            });
          });
        });
      });
    };

    _this.renderTextArea = function () {
      var _this$props2 = _this.props,
          _this$props2$prefixCl = _this$props2.prefixCls,
          prefixCls = _this$props2$prefixCl === void 0 ? 'rc-textarea' : _this$props2$prefixCl,
          autoSize = _this$props2.autoSize,
          onResize = _this$props2.onResize,
          className = _this$props2.className,
          disabled = _this$props2.disabled;
      var _this$state = _this.state,
          textareaStyles = _this$state.textareaStyles,
          resizeStatus = _this$state.resizeStatus;
      var otherProps = omit_js_es(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'defaultValue', 'onResize']);
      var cls = node_modules_classnames_default()(prefixCls, className, defineProperty_defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
      // Make sure it could be reset when using form.getFieldDecorator

      if ('value' in otherProps) {
        otherProps.value = otherProps.value || '';
      }

      var style = objectSpread2_objectSpread2(objectSpread2_objectSpread2(objectSpread2_objectSpread2({}, _this.props.style), textareaStyles), resizeStatus === RESIZE_STATUS.RESIZING ? // React will warning when mix `overflow` & `overflowY`.
      // We need to define this separately.
      {
        overflowX: 'hidden',
        overflowY: 'hidden'
      } : null);

      return /*#__PURE__*/react["createElement"](rc_resize_observer_es, {
        onResize: _this.handleResize,
        disabled: !(autoSize || onResize)
      }, /*#__PURE__*/react["createElement"]("textarea", Object.assign({}, otherProps, {
        className: cls,
        style: style,
        ref: _this.saveTextArea
      })));
    };

    _this.state = {
      textareaStyles: {},
      resizeStatus: RESIZE_STATUS.NONE
    };
    return _this;
  }

  createClass_createClass(ResizableTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeTextarea();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Re-render with the new content then recalculate the height as required.
      if (prevProps.value !== this.props.value) {
        this.resizeTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.nextFrameActionId);
      cancelAnimationFrame(this.resizeFrameId);
    } // https://github.com/ant-design/ant-design/issues/21870

  }, {
    key: "fixFirefoxAutoScroll",
    value: function fixFirefoxAutoScroll() {
      try {
        if (document.activeElement === this.textArea) {
          var currentStart = this.textArea.selectionStart;
          var currentEnd = this.textArea.selectionEnd;
          this.textArea.setSelectionRange(currentStart, currentEnd);
        }
      } catch (e) {// Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderTextArea();
    }
  }]);

  return ResizableTextArea;
}(react["Component"]);

/* harmony default export */ var es_ResizableTextArea = (ResizableTextArea_ResizableTextArea);
// CONCATENATED MODULE: ./node_modules/rc-textarea/es/index.js







var es_TextArea = /*#__PURE__*/function (_React$Component) {
  inherits_inherits(TextArea, _React$Component);

  var _super = createSuper_createSuper(TextArea);

  function TextArea(props) {
    var _this;

    classCallCheck_classCallCheck(this, TextArea);

    _this = _super.call(this, props);

    _this.focus = function () {
      _this.resizableTextArea.textArea.focus();
    };

    _this.saveTextArea = function (resizableTextArea) {
      _this.resizableTextArea = resizableTextArea;
    };

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;

      _this.setValue(e.target.value, function () {
        _this.resizableTextArea.resizeTextarea();
      });

      if (onChange) {
        onChange(e);
      }
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    var value = typeof props.value === 'undefined' || props.value === null ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  createClass_createClass(TextArea, [{
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/react["createElement"](es_ResizableTextArea, Object.assign({}, this.props, {
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        ref: this.saveTextArea
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TextArea;
}(react["Component"]);


/* harmony default export */ var rc_textarea_es = (es_TextArea);
// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/calendar-extension/index.js














/**
 * 统一样式前缀
 */ var calendar_extension_CLASSNAME_PREFIX = "ct";

function calendar_extension_getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var calendar_extension_isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function calendar_extension_insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = calendar_extension_getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new dist["Slice"](dist["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && calendar_extension_isParagraph(content[size - 1]) && calendar_extension_isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state_dist["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state_dist["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var calendar_extension_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : calendar_extension_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var calendar_extension_AFTER_INSERT = "after_insert";
var CALENDAR_UPDATE = "calendar_update";

var forEachFragment = function(frag, cb) {
    frag.forEach(function(n) {
        if (cb(n) && n.content && n.content.size) {
            forEachFragment(n.content, cb);
        }
    });
    return frag;
};
var forEachSlice = function(slice, cb) {
    var content = slice.content;
    forEachFragment(content, cb);
    return slice;
};

function calendar_extension_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var calendar_extension_css_248z = '.ct-base-loading{position:absolute;visibility:hidden;top:0;bottom:0;left:0;right:0;z-index:9;text-align:center;white-space:nowrap}.ct-base-loading .loading-dot{display:none;vertical-align:middle}.ct-base-loading:after,.ct-base-loading:before{content:" ";display:inline-block;height:100%;margin-left:-.25em;vertical-align:middle}.ct-loading-show{visibility:visible}.ct-base-loading{display:flex;align-items:center;justify-content:center;font-size:12px;background:#f6f6f6}.ct-base-loading .loading-dot{border-radius:50%!important;display:inline-block;width:1em;height:1em;background:#1c6cdc}.ct-base-loading :nth-child(-n+3).loading-dot{-webkit-animation:bounce-delay 1.6s ease-in-out infinite both;animation:bounce-delay 1.6s ease-in-out infinite both}.ct-base-loading :nth-child(-n+3).loading-dot:not(:last-child){margin-right:.4em}.ct-base-loading :first-child.loading-dot{-webkit-animation-delay:.24s;animation-delay:.24s}.ct-base-loading :nth-child(2).loading-dot{-webkit-animation-delay:.48s;animation-delay:.48s}.ct-base-loading :nth-child(3).loading-dot{-webkit-animation-delay:.72s;animation-delay:.72s}@-webkit-keyframes bounce-delay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}@keyframes bounce-delay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}';
calendar_extension_styleInject(calendar_extension_css_248z);

var Loading = function(props) {
    var _props_visible = props.visible, visible = _props_visible === void 0 ? true : _props_visible, _props_tip = props.tip, tip = _props_tip === void 0 ? "" : _props_tip, _props_className = props.className, className = _props_className === void 0 ? "" : _props_className;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "".concat(calendar_extension_classNamePrefix("base-loading"), " ").concat(visible && calendar_extension_classNamePrefix("loading-show"), " ").concat(className)
    }, /*#__PURE__*/ react_default.a.createElement("div", null, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "loading-dot-wrapper"
    }, /*#__PURE__*/ react_default.a.createElement("i", {
        className: "loading-dot"
    }), /*#__PURE__*/ react_default.a.createElement("i", {
        className: "loading-dot"
    }), /*#__PURE__*/ react_default.a.createElement("i", {
        className: "loading-dot"
    })), /*#__PURE__*/ react_default.a.createElement("div", null, tip)));
};

var MAX_SIZE = 18;
var TIME_STRETCH = 2;
var colorsLessMark = [
    2,
    3,
    1,
    4,
    5
];
// 状态与对应的颜色
var calendar_extension_colors = {
    s2: "#FCDBC7",
    s2Focus: "rgba(244,111,31,1)",
    s11: "#FFD7D5",
    s11Focus: "rgba(255,95,87,1)",
    s10: "#FACED1",
    s10Focus: "rgba(234,61,70,1)",
    s3: "#FDEFC9",
    s3Focus: "rgba(246,191,38,1)",
    s12: "#F9E6CE",
    s12Focus: "rgba(233,155,59,1)",
    s13: "#ECECCF",
    s13Focus: "rgba(181,178,63,1)",
    s1: "#CCEDDA",
    s1Focus: "rgba(51,182,109,1)",
    s14: "#DCF0C7",
    s14Focus: "rgba(116,196,30,1)",
    s16: "#C5DCEB",
    s16Focus: "rgba(22,117,177,1)",
    s4: "#C5E6FA",
    s4Focus: "rgba(24,157,236,1)",
    s7: "#CBDBF8",
    s7Focus: "rgba(47,110,226,1)",
    s15: "#C5E7EB",
    s15Focus: "rgba(22,161,177,1)",
    s5: "#CFD3EC",
    s5Focus: "rgba(63,81,181,1)",
    s8: "#DBCFEC",
    s8Focus: "rgba(113,63,181,1)",
    s9: "#EECFEF",
    s9Focus: "rgba(189,63,192,1)",
    s6: "#D7D7D7",
    s6Focus: "rgba(97,97,97,1)",
    s17: "#D7CACA",
    s17Focus: "#5F2B2B",
    s18: "#CDDDDD",
    s18Focus: "#377676"
};
var calendar_extension_marks = [
    "周一",
    "周二",
    "周三",
    "周四",
    "周五",
    "周六",
    "周日"
];
var DESCRIPTION_MAX_LENGTH = 300;
var TITLE_MAX_LENGTH = 50;
var TITLE_MAX_ROW = 4;
var WEEK_CELL_HEIGHT = 57;
var WEEK_CELL_TOP_GAP = 9;
var MONTH_CELL_HEIGHT = 121;
var MONTH_EVENT_HEIGHT = 20;
var WEEK_EVENT_HEIGHT = 20;
var MONTH_EVENT_GAP = 3;
var WEEK_EVENT_GAP = 3;
var PRESS_TYPE = {
    CENTER: 0,
    START: 1,
    END: 2
};
/* eslint-disable no-bitwise */ var MOUSE_STATUS = {
    MOUSE_DOWN: 1 << 1,
    MOUSE_MOVE: 1 << 2,
    MOUSE_UP: 1 << 3
};
var GESTURE_TYPE = {
    UNKNOWN: 0,
    CLICK: MOUSE_STATUS.MOUSE_DOWN | MOUSE_STATUS.MOUSE_UP,
    DRAGING: MOUSE_STATUS.MOUSE_DOWN | MOUSE_STATUS.MOUSE_MOVE,
    DRAG: MOUSE_STATUS.MOUSE_DOWN | MOUSE_STATUS.MOUSE_MOVE | MOUSE_STATUS.MOUSE_UP,
    MOVE: MOUSE_STATUS.MOUSE_MOVE
};

var needSyncProperty = [
    "id",
    "name",
    "description",
    "status",
    "statusString",
    "startTime",
    "endTime",
    "isAllDay"
];
var isShouldSync = function(target, property, value) {
    if (target.notSync) {
        return false;
    }
    if (needSyncProperty.indexOf(property) === -1) {
        return false;
    }
    if (target.press || target.drag) {
        return false;
    }
    return true;
};
var proxyEvent = function(event) {
    return new Proxy(event, {
        set: function(target, property, value) {
            target[property] = value;
            target.update(isShouldSync(target, property));
            return true;
        }
    });
};

function calendar_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function calendar_extension_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                calendar_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                calendar_extension_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function calendar_extension_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var calendar_extension_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var UpdateQueue = /*#__PURE__*/ function() {
    function UpdateQueue() {
        var onError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(error) {}, maxSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, onMaxsize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, onEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
        calendar_extension_classCallCheck(this, UpdateQueue);
        this.queue = [];
        this.maxSize = 5;
        this.running = false;
        this.onMaxSize = function() {};
        this.onEmpty = function() {};
        this.maxSize = maxSize;
        this.onError = onError;
        this.onMaxSize = onMaxsize;
        this.onEmpty = onEmpty;
    }
    var _proto = UpdateQueue.prototype;
    _proto.run = function run() {
        var _this = this;
        return calendar_extension_asyncToGenerator(function() {
            var action;
            return calendar_extension_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.running = true;
                        if (!(_this.queue.length > 0)) return [
                            3,
                            3
                        ];
                        action = _this.queue.shift();
                        return [
                            4,
                            action()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.run()
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        _this.running = false;
                        _this.onEmpty();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.push = function push(action) {
        var _this = this;
        this.queue.push(action);
        if (this.queue.length >= this.maxSize) {
            this.onMaxSize();
        }
        if (!this.running) {
            this.run().catch(function(error) {
                _this.onError(error);
            });
        }
    };
    return UpdateQueue;
}();

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var requiredArgs_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requiredArgs;
function requiredArgs(required, args) {
    if (args.length < required) {
        throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
    }
}
module.exports = exports.default;
});

unwrapExports(requiredArgs_1);

var toDate_1 = createCommonjsModule(function (module, exports) {
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toDate;
var _index = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    (0, _index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (_instanceof(argument, Date) || typeof argument === "object" && argStr === "[object Date]") {
        // Prevent the date to lose the milliseconds when passed to new Date() in IE10
        return new Date(argument.getTime());
    } else if (typeof argument === "number" || argStr === "[object Number]") {
        return new Date(argument);
    } else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = exports.default;
});

unwrapExports(toDate_1);

var toInteger_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toInteger;
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN;
    }
    var number = Number(dirtyNumber);
    if (isNaN(number)) {
        return number;
    }
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;
});

unwrapExports(toInteger_1);

var startOfWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfWeek;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(toInteger_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfWeek(dirtyDate, dirtyOptions) {
    (0, _index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    var date = (0, _index.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfWeek_1);

var startOfISOWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfISOWeek;
var _index = _interopRequireDefault(startOfWeek_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    return (0, _index.default)(dirtyDate, {
        weekStartsOn: 1
    });
}
module.exports = exports.default;
});

var _startOfISOWeek = unwrapExports(startOfISOWeek_1);

var getISOWeekYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getISOWeekYear;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(startOfISOWeek_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function getISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
    } else {
        return year - 1;
    }
}
module.exports = exports.default;
});

var _getISOWeekYear = unwrapExports(getISOWeekYear_1);

var startOfISOWeekYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfISOWeekYear;
var _index = _interopRequireDefault(getISOWeekYear_1);
var _index2 = _interopRequireDefault(startOfISOWeek_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function startOfISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _index2.default)(fourthOfJanuary);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfISOWeekYear_1);

var getISOWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getISOWeek;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(startOfISOWeek_1);
var _index3 = _interopRequireDefault(startOfISOWeekYear_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function getISOWeek(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;
});

var _getISOWeek = unwrapExports(getISOWeek_1);

var startOfHour_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfHour;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function startOfHour(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}
module.exports = exports.default;
});

var _startOfHour = unwrapExports(startOfHour_1);

var startOfMonth_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfMonth;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfMonth(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;
});

var _startOfMonth = unwrapExports(startOfMonth_1);

var startOfDay_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfDay;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function startOfDay(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;
});

var _startOfDay = unwrapExports(startOfDay_1);

var endOfDay_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = endOfDay;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function endOfDay(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}
module.exports = exports.default;
});

var _endOfDay = unwrapExports(endOfDay_1);

var endOfWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = endOfWeek;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(toInteger_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function endOfWeek(dirtyDate, dirtyOptions) {
    (0, _index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    var date = (0, _index.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}
module.exports = exports.default;
});

unwrapExports(endOfWeek_1);

var endOfISOWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = endOfISOWeek;
var _index = _interopRequireDefault(endOfWeek_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function endOfISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    return (0, _index.default)(dirtyDate, {
        weekStartsOn: 1
    });
}
module.exports = exports.default;
});

var _endOfISOWeek = unwrapExports(endOfISOWeek_1);

var isAfter_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isAfter;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _index2.default)(2, arguments);
    var date = (0, _index.default)(dirtyDate);
    var dateToCompare = (0, _index.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}
module.exports = exports.default;
});

var _isAfter = unwrapExports(isAfter_1);

var isBefore_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isBefore;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _index2.default)(2, arguments);
    var date = (0, _index.default)(dirtyDate);
    var dateToCompare = (0, _index.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}
module.exports = exports.default;
});

var _isBefore = unwrapExports(isBefore_1);

var isEqual_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isEqual;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _index2.default)(2, arguments);
    var dateLeft = (0, _index.default)(dirtyLeftDate);
    var dateRight = (0, _index.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}
module.exports = exports.default;
});

var _isEqual = unwrapExports(isEqual_1);

var getDate_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDate;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function getDate(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}
module.exports = exports.default;
});

var _getDate = unwrapExports(getDate_1);

var addMilliseconds_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addMilliseconds;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var timestamp = (0, _index2.default)(dirtyDate).getTime();
    var amount = (0, _index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = exports.default;
});

unwrapExports(addMilliseconds_1);

var addHours_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addHours;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(addMilliseconds_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function addHours(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var amount = (0, _index.default)(dirtyAmount);
    return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
module.exports = exports.default;
});

var _addHours = unwrapExports(addHours_1);

var getHours_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getHours;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function getHours(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}
module.exports = exports.default;
});

var _getHours = unwrapExports(getHours_1);

var setHours_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setHours;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function setHours(dirtyDate, dirtyHours) {
    (0, _index3.default)(2, arguments);
    var date = (0, _index2.default)(dirtyDate);
    var hours = (0, _index.default)(dirtyHours);
    date.setHours(hours);
    return date;
}
module.exports = exports.default;
});

var _setHours = unwrapExports(setHours_1);

var getMinutes_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getMinutes;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function getMinutes(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}
module.exports = exports.default;
});

var _getMinutes = unwrapExports(getMinutes_1);

var setMinutes_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setMinutes;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _index3.default)(2, arguments);
    var date = (0, _index2.default)(dirtyDate);
    var minutes = (0, _index.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}
module.exports = exports.default;
});

var _setMinutes = unwrapExports(setMinutes_1);

var getTime_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTime;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function getTime(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}
module.exports = exports.default;
});

var _getTime = unwrapExports(getTime_1);

var getISODay_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getISODay;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function getISODay(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var day = date.getDay();
    if (day === 0) {
        day = 7;
    }
    return day;
}
module.exports = exports.default;
});

var _getISODay = unwrapExports(getISODay_1);

var isValid_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValid;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function isValid(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = exports.default;
});

unwrapExports(isValid_1);

var formatDistance_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatDistance;
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof formatDistanceLocale[token] === "string") {
        result = formatDistanceLocale[token];
    } else if (count === 1) {
        result = formatDistanceLocale[token].one;
    } else {
        result = formatDistanceLocale[token].other.replace("{{count}}", count);
    }
    if (options.addSuffix) {
        if (options.comparison > 0) {
            return "in " + result;
        } else {
            return result + " ago";
        }
    }
    return result;
}
module.exports = exports.default;
});

unwrapExports(formatDistance_1);

var buildFormatLongFn_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildFormatLongFn;
function buildFormatLongFn(args) {
    return function(dirtyOptions) {
        var options = dirtyOptions || {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = exports.default;
});

unwrapExports(buildFormatLongFn_1);

var formatLong_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(buildFormatLongFn_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _index.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _index.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _index.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
var _default = formatLong;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(formatLong_1);

var formatRelative_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatRelative;
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
}
module.exports = exports.default;
});

unwrapExports(formatRelative_1);

var buildLocalizeFn_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildLocalizeFn;
function buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index];
    };
}
module.exports = exports.default;
});

unwrapExports(buildLocalizeFn_1);

var localize_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(buildLocalizeFn_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ] // Note: in English, the names of days of the week and months are capitalized.
};
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
function ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) {
        switch(rem100 % 10){
            case 1:
                return number + "st";
            case 2:
                return number + "nd";
            case 3:
                return number + "rd";
        }
    }
    return number + "th";
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _index.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _index.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _index.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _index.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _index.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var _default = localize;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(localize_1);

var buildMatchPatternFn_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) {
            return null;
        }
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) {
            return null;
        }
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}
module.exports = exports.default;
});

unwrapExports(buildMatchPatternFn_1);

var buildMatchFn_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchFn;
function buildMatchFn(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) {
            return null;
        }
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var value;
        if (Object.prototype.toString.call(parsePatterns) === "[object Array]") {
            value = findIndex(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
        } else {
            value = findKey(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
        }
        value = args.valueCallback ? args.valueCallback(value) : value;
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) {
            return key;
        }
    }
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) {
            return key;
        }
    }
}
module.exports = exports.default;
});

unwrapExports(buildMatchFn_1);

var match_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(buildMatchPatternFn_1);
var _index2 = _interopRequireDefault(buildMatchFn_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _index.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _index2.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _index2.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _index2.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _index2.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _index2.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var _default = match;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(match_1);

var enUS = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(formatDistance_1);
var _index2 = _interopRequireDefault(formatLong_1);
var _index3 = _interopRequireDefault(formatRelative_1);
var _index4 = _interopRequireDefault(localize_1);
var _index5 = _interopRequireDefault(match_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: _index.default,
    formatLong: _index2.default,
    formatRelative: _index3.default,
    localize: _index4.default,
    match: _index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var _default = locale;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(enUS);

var subMilliseconds_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subMilliseconds;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(addMilliseconds_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var amount = (0, _index.default)(dirtyAmount);
    return (0, _index2.default)(dirtyDate, -amount);
}
module.exports = exports.default;
});

unwrapExports(subMilliseconds_1);

var addLeadingZeros_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength){
        output = "0" + output;
    }
    return sign + output;
}
module.exports = exports.default;
});

unwrapExports(addLeadingZeros_1);

var lightFormatters = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(addLeadingZeros_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
    }
};
var _default = formatters;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(lightFormatters);

var getUTCDayOfYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCDayOfYear;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;
});

unwrapExports(getUTCDayOfYear_1);

var startOfUTCISOWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeek;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfUTCISOWeek_1);

var getUTCISOWeekYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeekYear;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(startOfUTCISOWeek_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
    } else {
        return year - 1;
    }
}
module.exports = exports.default;
});

unwrapExports(getUTCISOWeekYear_1);

var startOfUTCISOWeekYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(getUTCISOWeekYear_1);
var _index2 = _interopRequireDefault(startOfUTCISOWeek_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _index2.default)(fourthOfJanuary);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfUTCISOWeekYear_1);

var getUTCISOWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeek;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(startOfUTCISOWeek_1);
var _index3 = _interopRequireDefault(startOfUTCISOWeekYear_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;
});

unwrapExports(getUTCISOWeek_1);

var startOfUTCWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeek;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, _index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    var date = (0, _index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfUTCWeek_1);

var getUTCWeekYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeekYear;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(startOfUTCWeek_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    }
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
    } else {
        return year - 1;
    }
}
module.exports = exports.default;
});

unwrapExports(getUTCWeekYear_1);

var startOfUTCWeekYear_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeekYear;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(getUTCWeekYear_1);
var _index3 = _interopRequireDefault(startOfUTCWeek_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, _index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
    var year = (0, _index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfUTCWeekYear_1);

var getUTCWeek_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeek;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(startOfUTCWeek_1);
var _index3 = _interopRequireDefault(startOfUTCWeekYear_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeek(dirtyDate, options) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;
});

unwrapExports(getUTCWeek_1);

var formatters_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(lightFormatters);
var _index2 = _interopRequireDefault(getUTCDayOfYear_1);
var _index3 = _interopRequireDefault(getUTCISOWeek_1);
var _index4 = _interopRequireDefault(getUTCISOWeekYear_1);
var _index5 = _interopRequireDefault(getUTCWeek_1);
var _index6 = _interopRequireDefault(getUTCWeekYear_1);
var _index7 = _interopRequireDefault(addLeadingZeros_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return _index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") {
            return localize.ordinalNumber(weekYear, {
                unit: "year"
            });
        } // Padding
        return (0, _index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _index4.default)(date); // Padding
        return (0, _index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index7.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return _index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _index5.default)(date, options);
        if (token === "wo") {
            return localize.ordinalNumber(week, {
                unit: "week"
            });
        }
        return (0, _index7.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _index3.default)(date);
        if (token === "Io") {
            return localize.ordinalNumber(isoWeek, {
                unit: "week"
            });
        }
        return (0, _index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") {
            return localize.ordinalNumber(date.getUTCDate(), {
                unit: "date"
            });
        }
        return _index.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _index2.default)(date);
        if (token === "Do") {
            return localize.ordinalNumber(dayOfYear, {
                unit: "dayOfYear"
            });
        }
        return (0, _index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) {
            dayPeriodEnumValue = dayPeriodEnum.noon;
        } else if (hours === 0) {
            dayPeriodEnumValue = dayPeriodEnum.midnight;
        } else {
            dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        }
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) {
            dayPeriodEnumValue = dayPeriodEnum.evening;
        } else if (hours >= 12) {
            dayPeriodEnumValue = dayPeriodEnum.afternoon;
        } else if (hours >= 4) {
            dayPeriodEnumValue = dayPeriodEnum.morning;
        } else {
            dayPeriodEnumValue = dayPeriodEnum.night;
        }
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return _index.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") {
            return localize.ordinalNumber(date.getUTCHours(), {
                unit: "hour"
            });
        }
        return _index.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") {
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") {
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _index7.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") {
            return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: "minute"
            });
        }
        return _index.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") {
            return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: "second"
            });
        }
        return _index.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return _index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) {
            return "Z";
        }
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index7.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) {
        return sign + String(hours);
    }
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(formatters_1);

var longFormatters_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
}
function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
}
function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) {
        return dateLongFormatter(pattern, formatLong);
    }
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
}
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(longFormatters_1);

var getTimezoneOffsetInMilliseconds_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;
});

unwrapExports(getTimezoneOffsetInMilliseconds_1);

var protectedTokens = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") {
        throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    } else if (token === "YY") {
        throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    } else if (token === "D") {
        throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    } else if (token === "DD") {
        throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
}
});

unwrapExports(protectedTokens);
var protectedTokens_1 = protectedTokens.isProtectedDayOfYearToken;
var protectedTokens_2 = protectedTokens.isProtectedWeekYearToken;
var protectedTokens_3 = protectedTokens.throwProtectedError;

var format_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = format;
var _index = _interopRequireDefault(isValid_1);
var _index2 = _interopRequireDefault(enUS);
var _index3 = _interopRequireDefault(subMilliseconds_1);
var _index4 = _interopRequireDefault(toDate_1);
var _index5 = _interopRequireDefault(formatters_1);
var _index6 = _interopRequireDefault(longFormatters_1);
var _index7 = _interopRequireDefault(getTimezoneOffsetInMilliseconds_1);

var _index9 = _interopRequireDefault(toInteger_1);
var _index10 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, _index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || _index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    }
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    if (!locale.localize) {
        throw new RangeError("locale must contain localize property");
    }
    if (!locale.formatLong) {
        throw new RangeError("locale must contain formatLong property");
    }
    var originalDate = (0, _index4.default)(dirtyDate);
    if (!(0, _index.default)(originalDate)) {
        throw new RangeError("Invalid time value");
    } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _index7.default)(originalDate);
    var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = _index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") {
            return "'";
        }
        var firstCharacter = substring[0];
        if (firstCharacter === "'") {
            return cleanEscapedString(substring);
        }
        var formatter = _index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, protectedTokens.isProtectedWeekYearToken)(substring)) {
                (0, protectedTokens.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            }
            if (!options.useAdditionalDayOfYearTokens && (0, protectedTokens.isProtectedDayOfYearToken)(substring)) {
                (0, protectedTokens.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            }
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;
});

var _format = unwrapExports(format_1);

var addDays_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addDays;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function addDays(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var date = (0, _index2.default)(dirtyDate);
    var amount = (0, _index.default)(dirtyAmount);
    if (isNaN(amount)) {
        return new Date(NaN);
    }
    if (!amount) {
        // If 0 days, no-op to avoid changing times in the hour before end of DST
        return date;
    }
    date.setDate(date.getDate() + amount);
    return date;
}
module.exports = exports.default;
});

unwrapExports(addDays_1);

var addMonths_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addMonths;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */ function addMonths(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var date = (0, _index2.default)(dirtyDate);
    var amount = (0, _index.default)(dirtyAmount);
    if (isNaN(amount)) {
        return new Date(NaN);
    }
    if (!amount) {
        // If 0 months, no-op to avoid changing times in the hour before end of DST
        return date;
    }
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) {
        // If we're already at the end of the month, then this is the correct date
        // and we're done.
        return endOfDesiredMonth;
    } else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}
module.exports = exports.default;
});

unwrapExports(addMonths_1);

var add_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = add;
var _index = _interopRequireDefault(addDays_1);
var _index2 = _interopRequireDefault(addMonths_1);
var _index3 = _interopRequireDefault(toDate_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
var _index5 = _interopRequireDefault(toInteger_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added       |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function add(dirtyDate, duration) {
    (0, _index4.default)(2, arguments);
    if (!duration || typeof duration !== "object") return new Date(NaN);
    var years = "years" in duration ? (0, _index5.default)(duration.years) : 0;
    var months = "months" in duration ? (0, _index5.default)(duration.months) : 0;
    var weeks = "weeks" in duration ? (0, _index5.default)(duration.weeks) : 0;
    var days = "days" in duration ? (0, _index5.default)(duration.days) : 0;
    var hours = "hours" in duration ? (0, _index5.default)(duration.hours) : 0;
    var minutes = "minutes" in duration ? (0, _index5.default)(duration.minutes) : 0;
    var seconds = "seconds" in duration ? (0, _index5.default)(duration.seconds) : 0; // Add years and months
    var date = (0, _index3.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date; // Add weeks and days
    var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}
module.exports = exports.default;
});

var _add = unwrapExports(add_1);

var subDays_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subDays;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(addDays_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function subDays(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var amount = (0, _index.default)(dirtyAmount);
    return (0, _index2.default)(dirtyDate, -amount);
}
module.exports = exports.default;
});

unwrapExports(subDays_1);

var subMonths_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subMonths;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(addMonths_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function subMonths(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var amount = (0, _index.default)(dirtyAmount);
    return (0, _index2.default)(dirtyDate, -amount);
}
module.exports = exports.default;
});

unwrapExports(subMonths_1);

var sub_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sub;
var _index = _interopRequireDefault(subDays_1);
var _index2 = _interopRequireDefault(subMonths_1);
var _index3 = _interopRequireDefault(toDate_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
var _index5 = _interopRequireDefault(toInteger_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function sub(dirtyDate, duration) {
    (0, _index4.default)(2, arguments);
    if (!duration || typeof duration !== "object") return new Date(NaN);
    var years = "years" in duration ? (0, _index5.default)(duration.years) : 0;
    var months = "months" in duration ? (0, _index5.default)(duration.months) : 0;
    var weeks = "weeks" in duration ? (0, _index5.default)(duration.weeks) : 0;
    var days = "days" in duration ? (0, _index5.default)(duration.days) : 0;
    var hours = "hours" in duration ? (0, _index5.default)(duration.hours) : 0;
    var minutes = "minutes" in duration ? (0, _index5.default)(duration.minutes) : 0;
    var seconds = "seconds" in duration ? (0, _index5.default)(duration.seconds) : 0; // Subtract years and months
    var dateWithoutMonths = (0, _index2.default)((0, _index3.default)(dirtyDate), months + years * 12); // Subtract weeks and days
    var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}
module.exports = exports.default;
});

var _sub = unwrapExports(sub_1);

var getDaysInMonth_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDaysInMonth;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function getDaysInMonth(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
module.exports = exports.default;
});

unwrapExports(getDaysInMonth_1);

var setMonth_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setMonth;
var _index = _interopRequireDefault(toInteger_1);
var _index2 = _interopRequireDefault(toDate_1);
var _index3 = _interopRequireDefault(getDaysInMonth_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function setMonth(dirtyDate, dirtyMonth) {
    (0, _index4.default)(2, arguments);
    var date = (0, _index2.default)(dirtyDate);
    var month = (0, _index.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}
module.exports = exports.default;
});

unwrapExports(setMonth_1);

var set_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = set;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(setMonth_1);
var _index3 = _interopRequireDefault(toInteger_1);
var _index4 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function set(dirtyDate, values) {
    (0, _index4.default)(2, arguments);
    if (typeof values !== "object" || values === null) {
        throw new RangeError("values parameter must be an object");
    }
    var date = (0, _index.default)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) {
        return new Date(NaN);
    }
    if (values.year != null) {
        date.setFullYear(values.year);
    }
    if (values.month != null) {
        date = (0, _index2.default)(date, values.month);
    }
    if (values.date != null) {
        date.setDate((0, _index3.default)(values.date));
    }
    if (values.hours != null) {
        date.setHours((0, _index3.default)(values.hours));
    }
    if (values.minutes != null) {
        date.setMinutes((0, _index3.default)(values.minutes));
    }
    if (values.seconds != null) {
        date.setSeconds((0, _index3.default)(values.seconds));
    }
    if (values.milliseconds != null) {
        date.setMilliseconds((0, _index3.default)(values.milliseconds));
    }
    return date;
}
module.exports = exports.default;
});

var _set = unwrapExports(set_1);

var differenceInCalendarDays_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = differenceInCalendarDays;
var _index = _interopRequireDefault(getTimezoneOffsetInMilliseconds_1);
var _index2 = _interopRequireDefault(startOfDay_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _index3.default)(2, arguments);
    var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
    var startOfDayRight = (0, _index2.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
module.exports = exports.default;
});

unwrapExports(differenceInCalendarDays_1);

var differenceInDays_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = differenceInDays;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(differenceInCalendarDays_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) {
        return -1;
    } else if (diff > 0) {
        return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    } else {
        return diff;
    }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * var result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */ function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _index3.default)(2, arguments);
    var dateLeft = (0, _index.default)(dirtyDateLeft);
    var dateRight = (0, _index.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = compareLocalAsc(dateLeft, dateRight) === -sign;
    var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
    return result === 0 ? 0 : result;
}
module.exports = exports.default;
});

var _differenceInDays = unwrapExports(differenceInDays_1);

var differenceInMilliseconds_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = differenceInMilliseconds;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var dateLeft = (0, _index.default)(dirtyDateLeft);
    var dateRight = (0, _index.default)(dirtyDateRight);
    return dateLeft.getTime() - dateRight.getTime();
}
module.exports = exports.default;
});

unwrapExports(differenceInMilliseconds_1);

var differenceInHours_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = differenceInHours;
var _index = _interopRequireDefault(differenceInMilliseconds_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function differenceInHours(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}
module.exports = exports.default;
});

var _differenceInHours = unwrapExports(differenceInHours_1);

var differenceInMinutes_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = differenceInMinutes;
var _index = _interopRequireDefault(differenceInMilliseconds_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are from 10:01:59 to 10:00:00
 * var result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}
module.exports = exports.default;
});

var _differenceInMinutes = unwrapExports(differenceInMinutes_1);

var differenceInSeconds_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = differenceInSeconds;
var _index = _interopRequireDefault(differenceInMilliseconds_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 1000;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}
module.exports = exports.default;
});

var _differenceInSeconds = unwrapExports(differenceInSeconds_1);

var isSameMonth_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isSameMonth;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var dateLeft = (0, _index.default)(dirtyDateLeft);
    var dateRight = (0, _index.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
module.exports = exports.default;
});

var _isSameMonth = unwrapExports(isSameMonth_1);

var isSameDay_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isSameDay;
var _index = _interopRequireDefault(startOfDay_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */ function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
module.exports = exports.default;
});

var _isSameDay = unwrapExports(isSameDay_1);

var startOfMinute_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfMinute;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function startOfMinute(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    date.setSeconds(0, 0);
    return date;
}
module.exports = exports.default;
});

unwrapExports(startOfMinute_1);

var isSameMinute_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isSameMinute;
var _index = _interopRequireDefault(startOfMinute_1);
var _index2 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */ function isSameMinute(dirtyDateLeft, dirtyDateRight) {
    (0, _index2.default)(2, arguments);
    var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
    var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
    return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}
module.exports = exports.default;
});

var _isSameMinute = unwrapExports(isSameMinute_1);

var fromUnixTime_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = fromUnixTime;
var _index = _interopRequireDefault(toDate_1);
var _index2 = _interopRequireDefault(toInteger_1);
var _index3 = _interopRequireDefault(requiredArgs_1);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Number} unixTime - the given Unix timestamp
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * var result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function fromUnixTime(dirtyUnixTime) {
    (0, _index3.default)(1, arguments);
    var unixTime = (0, _index2.default)(dirtyUnixTime);
    return (0, _index.default)(unixTime * 1000);
}
module.exports = exports.default;
});

var _fromUnixTime = unwrapExports(fromUnixTime_1);

function calendar_extension_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function calendar_extension_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) calendar_extension_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) calendar_extension_defineProperties(Constructor, staticProps);
    return Constructor;
}
function calendar_extension_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function calendar_extension_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function calendar_extension_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            calendar_extension_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _crd = function(fn, d) {
    return d ? fn(d) : fn(new Date());
};
/* eslint-disable-next-line */ var _2cd = function(d) {
    return new CalendarDate(d);
};
/* eslint-disable-next-line */ var _2d = function(d) {
    return new CalendarDate(d).date;
};
var CalendarDate = /*#__PURE__*/ function() {
    function CalendarDate(date) {
        calendar_extension_classCallCheck$1(this, CalendarDate);
        this._date = null;
        if (!date) {
            this._date = _crd(function(_) {
                return _;
            });
        } else if (calendar_extension_instanceof(date, CalendarDate)) {
            this._date = date.date;
        } else if (calendar_extension_instanceof(date, Date)) {
            this._date = date;
        } else if (typeof date === "number") {
            this._date = _fromUnixTime(date / 1000);
        } else {
            throw new Error("oops, wrong date type!");
        }
    }
    var _proto = CalendarDate.prototype;
    _proto.copy = function copy() {
        return new CalendarDate(this._date);
    };
    _proto.format = function format() {
        var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "yyyy-MM-dd";
        return _format(this._date, str);
    };
    _proto.startOfDay = function startOfDay() {
        var _date = this._date;
        return new CalendarDate(_startOfDay(_date));
    };
    _proto.endOfDay = function endOfDay() {
        var _date = this._date;
        return new CalendarDate(_endOfDay(_date));
    };
    _proto.startOfISOWeek = function startOfISOWeek() {
        var _date = this._date;
        return new CalendarDate(_startOfISOWeek(_date));
    };
    _proto.endOfISOWeek = function endOfISOWeek() {
        var _date = this._date;
        return new CalendarDate(_endOfISOWeek(_date));
    };
    _proto.addDay = function addDay(i) {
        var _date = this._date;
        return new CalendarDate(_add(_date, {
            days: i
        }));
    };
    _proto.addHour = function addHour(i) {
        var _date = this._date;
        return new CalendarDate(_add(_date, {
            hours: i
        }));
    };
    _proto.addMinute = function addMinute(i) {
        var _date = this._date;
        return new CalendarDate(_add(_date, {
            minutes: i
        }));
    };
    _proto.set = function set(values) {
        var _date = this._date;
        return new CalendarDate(_set(_date, calendar_extension_objectSpread({}, values)));
    };
    _proto.subtractDay = function subtractDay(i) {
        var _date = this._date;
        return new CalendarDate(_sub(_date, {
            days: i
        }));
    };
    _proto.subtractMinute = function subtractMinute(i) {
        var _date = this._date;
        return new CalendarDate(_sub(_date, {
            minutes: i
        }));
    };
    _proto.addWeek = function addWeek(i) {
        var _date = this._date;
        return new CalendarDate(_add(_date, {
            weeks: i
        }));
    };
    _proto.addMonth = function addMonth(i) {
        var _date = this._date;
        return new CalendarDate(_add(_date, {
            months: i
        }));
    };
    _proto.isInISOWeek = function isInISOWeek(startTime, endTime) {
        var cdate = this.startOfISOWeek();
        var isEndBefore = _2cd(endTime).isBefore(cdate.startOfISOWeek());
        var isStartAfter = _2cd(startTime).isAfter(cdate.endOfISOWeek());
        return !isEndBefore && !isStartAfter;
    };
    _proto.isInDay = function isInDay(startTime, endTime) {
        var cdate = this.startOfDay();
        var isEndBefore = _2cd(endTime).isBefore(cdate.startOfDay());
        var isStartAfter = _2cd(startTime).isAfter(cdate.endOfDay());
        return !isEndBefore && !isStartAfter;
    };
    _proto.diffDays = function diffDays(date) {
        var isFloat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var diff = _differenceInDays(this._date, _2d(date));
        if (isFloat && diff === 0) {
            diff += _differenceInHours(this._date, _2d(date)) % 24 / 24.0;
        }
        return diff;
    };
    _proto.diffMinutes = function diffMinutes(date) {
        var isFloat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var diff = _differenceInMinutes(this._date, _2d(date));
        if (isFloat && diff === 0) {
            diff += _differenceInSeconds(this._date, _2d(date)) % 60 / 60.0;
        }
        return diff;
    };
    _proto.isSameDay = function isSameDay(date) {
        return _isSameDay(_2d(date), this._date);
    };
    _proto.isSameMonth = function isSameMonth(date) {
        return _isSameMonth(_2d(date), this._date);
    };
    _proto.isSameMinute = function isSameMinute(date) {
        return _isSameMinute(_2d(date), this._date);
    };
    _proto.isSameOrAfter = function isSameOrAfter(date) {
        return _isAfter(_2d(this), _2d(date)) || _isEqual(_2d(this), _2d(date));
    };
    _proto.isSameOrBefore = function isSameOrBefore(date) {
        return _isBefore(_2d(this), _2d(date)) || _isEqual(_2d(this), _2d(date));
    };
    _proto.isBefore = function isBefore(date) {
        return _isBefore(_2d(this), _2d(date));
    };
    _proto.isBeforeMinute = function isBeforeMinute(date) {
        return _differenceInMinutes(_2d(this), _2d(date)) < 0;
    };
    _proto.isAfter = function isAfter(date) {
        return _isAfter(_2d(this), _2d(date));
    };
    CalendarDate.getISOWeekYear = function getISOWeekYear(date) {
        return _crd(_getISOWeekYear, date);
    };
    CalendarDate.getISOWeek = function getISOWeek(date) {
        return _crd(_getISOWeek, date);
    };
    CalendarDate.getYear = function getYear(date) {
        return _crd(function(d) {
            return d.getFullYear();
        }, date);
    };
    CalendarDate.getMonth = function getMonth(date) {
        return _crd(function(d) {
            return d.getMonth();
        }, date);
    };
    CalendarDate.startOfHour = function startOfHour(date) {
        return new CalendarDate(_crd(_startOfHour, date));
    };
    CalendarDate.startOfMonth = function startOfMonth(date) {
        return new CalendarDate(_crd(_startOfMonth, date));
    };
    CalendarDate.startOfISOWeek = function startOfISOWeek(date) {
        return new CalendarDate(_crd(_startOfISOWeek, date));
    };
    CalendarDate.endOfISOWeek = function endOfISOWeek(date) {
        return new CalendarDate(_crd(_endOfISOWeek, date));
    };
    CalendarDate.times = function times() {
        var cdate = new CalendarDate(_setMinutes(_setHours(new Date(), 0), 0));
        var times = [
            cdate.format("HH:mm")
        ];
        for(var i = 0; i < 23; i++){
            times.push(new CalendarDate(_addHours(cdate.date, i + 1)).format("HH:mm"));
        }
        return times;
    };
    CalendarDate.fromArray = function fromArray(array) {
        return new CalendarDate(new Date(array[0], array[1], array[2]));
    };
    calendar_extension_createClass(CalendarDate, [
        {
            key: "year",
            get: function get() {
                return CalendarDate.getYear(this._date);
            }
        },
        {
            key: "isoYear",
            get: function get() {
                return CalendarDate.getISOWeekYear(this._date);
            }
        },
        {
            key: "month",
            get: function get() {
                return CalendarDate.getMonth(this._date);
            }
        },
        {
            key: "isoWeek",
            get: function get() {
                return CalendarDate.getISOWeek(this._date);
            }
        },
        {
            key: "date",
            get: function get() {
                return this._date;
            }
        },
        {
            key: "hour",
            get: function get() {
                return _getHours(_2d(this));
            }
        },
        {
            key: "minute",
            get: function get() {
                return _getMinutes(_2d(this));
            }
        },
        {
            key: "monthDate",
            get: function get() {
                return _getDate(_2d(this));
            }
        },
        {
            key: "timestamp",
            get: function get() {
                return _getTime(this._date);
            }
        },
        {
            key: "isoWeekday",
            get: function get() {
                return _getISODay(this._date);
            }
        }
    ]);
    return CalendarDate;
}();

function calendar_extension_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function calendar_extension_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function calendar_extension_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function calendar_extension_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function calendar_extension_slicedToArray(arr, i) {
    return calendar_extension_arrayWithHoles(arr) || calendar_extension_iterableToArrayLimit(arr, i) || calendar_extension_unsupportedIterableToArray(arr, i) || calendar_extension_nonIterableRest();
}
function calendar_extension_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return calendar_extension_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return calendar_extension_arrayLikeToArray(o, minLen);
}
var timeFromEvent = function(event) {
    var start = event.startTime.format("HH:mm");
    var end = event.endTime.format("HH:mm");
    return "".concat(start, "-").concat(end);
};
var makeList = function(length, eleMaker) {
    return Array.from({
        length: length
    }, function(_, i) {
        return eleMaker(i);
    });
};
var getStatusNumber = function(_) {
    var res = parseInt(_.slice(1), 10);
    if (res < 1 || res > MAX_SIZE) {
        return 1;
    }
    return res;
};
var getStatusStr = function(_) {
    return _ < 1 || _ > MAX_SIZE ? "s1" : "s".concat(_);
};
var compareEvent = function(a, b) {
    var ast = a.startTime, aet = a.endTime;
    var bst = b.startTime, bet = b.endTime;
    var res = function() {
        if (!ast.isSameDay(bst)) return ast.diffDays(bst, true);
        if (!aet.isSameDay(bet)) return bet.diffDays(aet, true);
        // if (a.allday - b.allday !== 0) return b.allday - a.allday;
        // if (a.allday) return a.createTime.timestamp - b.createTime.timestamp;
        if (!ast.isSameMinute(bst)) return -ast.diffMinutes(bst, true);
        if (!aet.isSameMinute(bet)) return -bet.diffMinutes(aet, true);
        return 0;
    }();
    return res;
};
var eventsMapper = function(events) {
    var res = events.sort(compareEvent);
    return res;
};
var getBaseTime = function(calendarDate, view) {
    if (view === "week") {
        return calendarDate.startOfISOWeek();
    }
    var cdate = CalendarDate.fromArray([
        calendarDate.year,
        calendarDate.month,
        1
    ]);
    var weekday = cdate.isoWeekday;
    return cdate.subtractDay(weekday - 1);
};
var getMonthSlotList = function(events, day) {
    var slot = makeList(7, function() {
        return 0;
    });
    var maxLaneCount = 0;
    var schedules = events.map(function(event) {
        var start = day.startOfISOWeek();
        var end = day.endOfISOWeek();
        var startTime = event.startTime;
        var endTime = event.endTime;
        // from减1因为[星期一,...,星期日]数值索引从0开始，to不减1因为是这天的前一天,最终区间为 [from, to)
        var from = startTime.isBefore(start) ? 0 : startTime.isoWeekday - 1;
        var to = endTime.isAfter(end) ? 7 : endTime.isoWeekday;
        // 如果开始时间和结束时间相同，需要显示该日程
        if (from === to) to += 1;
        Array.from({
            length: to - from
        }).forEach(function(_, i) {
            maxLaneCount = Math.max(++slot[from + i], maxLaneCount);
        });
        return {
            position: [
                from,
                to
            ],
            event: event
        };
    }).sort(function(param, param1) {
        var _param_position = calendar_extension_slicedToArray(param.position, 2), afrom = _param_position[0], ato = _param_position[1], _param_position1 = calendar_extension_slicedToArray(param1.position, 2), bfrom = _param_position1[0], bto = _param_position1[1];
        if (afrom - bfrom !== 0) {
            return afrom - bfrom;
        }
        return bto - ato;
    });
    return {
        schedules: schedules,
        slot: slot,
        maxLaneCount: maxLaneCount
    };
};
var getMonthEventRenderList = function(schedules, slot) {
    var laneContainer = schedules.map(function(_) {
        return [];
    });
    var laneRight = schedules.map(function(_) {
        return -1;
    });
    for(var i = 0; i < schedules.length; i++){
        var schedule = schedules[i];
        var _schedule_position = calendar_extension_slicedToArray(schedule.position, 2), from = _schedule_position[0], to = _schedule_position[1];
        var max = 0;
        for(var j = from; j < to; j++){
            max = Math.max(max, slot[j]);
        }
        schedule.laneCount = max;
        for(var j1 = 0; j1 < laneContainer.length; j1++){
            if (from > laneRight[j1]) {
                schedule.laneNumber = j1;
                laneRight[j1] = to - 1;
                laneContainer[j1].push(schedule);
                break;
            }
        }
    }
    return schedules.map(function(param) {
        var _param_position = calendar_extension_slicedToArray(param.position, 2), from = _param_position[0], to = _param_position[1], laneNumber = param.laneNumber, laneCount = param.laneCount, event = param.event;
        return {
            id: event.id,
            from: from,
            to: to,
            laneNumber: laneNumber,
            laneCount: laneCount,
            event: event
        };
    });
};
// 获取日程列表及每一行的个数
var getWeekSlotList = function(events, day) {
    var slot = makeList(24 * TIME_STRETCH, function() {
        return 0;
    });
    var maxLaneCount = 0;
    var schedules = events.map(function(event) {
        var start = day.startOfDay();
        var end = day.endOfDay();
        var startTime = event.startTime;
        var endTime = event.endTime;
        var from = startTime.isBefore(start) ? 0 : startTime.hour * 2 + Math.round(startTime.minute / 30);
        var to = endTime.isAfter(end) ? 24 * TIME_STRETCH : endTime.hour * 2 + Math.round(endTime.minute / 30);
        // 如果开始时间和结束时间相同，需要显示该日程
        if (from === to) to += 1;
        Array.from({
            length: to - from
        }).forEach(function(_, i) {
            if (i !== to) {
                maxLaneCount = Math.max(++slot[from + i], maxLaneCount);
            }
        });
        return {
            position: [
                from,
                to
            ],
            event: event
        };
    }).sort(function(param, param1) {
        var _param_position = calendar_extension_slicedToArray(param.position, 2), afrom = _param_position[0], ato = _param_position[1], _param_position1 = calendar_extension_slicedToArray(param1.position, 2), bfrom = _param_position1[0], bto = _param_position1[1];
        if (afrom - bfrom !== 0) {
            return afrom - bfrom;
        }
        return bto - ato;
    });
    return {
        schedules: schedules,
        slot: slot,
        maxLaneCount: maxLaneCount
    };
};
// 获取日程的样式计算信息
var getWeekEventRenderList = function(schedules, slot) {
    var laneContainer = schedules.map(function(_) {
        return [];
    });
    var laneRight = slot.map(function(_) {
        return -1;
    });
    var totalMaxLaneCount = 0;
    for(var i = 0; i < schedules.length; i++){
        var schedule = schedules[i];
        var _schedule_position = calendar_extension_slicedToArray(schedule.position, 2), from = _schedule_position[0], to = _schedule_position[1];
        var max = 0;
        for(var j = from; j < to; j++){
            max = Math.max(max, slot[j]);
        }
        totalMaxLaneCount = Math.max(max, totalMaxLaneCount);
        for(var j1 = 0; j1 < laneContainer.length; j1++){
            if (from > laneRight[j1]) {
                schedule.laneNumber = j1;
                schedule.laneCount = max;
                laneRight[j1] = to - 1;
                laneContainer[j1].push(schedule);
                break;
            }
        }
    }
    schedules.forEach(function(schedule) {
        schedule.laneWidth = 1 / totalMaxLaneCount;
        schedule.laneLeft = 1 / totalMaxLaneCount * schedule.laneNumber;
        if (schedule.laneNumber === schedule.laneCount - 1) {
            schedule.laneWidth = 1 - schedule.laneLeft;
        }
    });
    // laneContainer.forEach((lane, i) => {
    //   lane.forEach((schedule) => {
    //     shrinkWidth(schedule, i);
    //   });
    // });
    return schedules.map(function(param) {
        var _param_position = calendar_extension_slicedToArray(param.position, 2), from = _param_position[0], to = _param_position[1], laneNumber = param.laneNumber, laneCount = param.laneCount, laneLeft = param.laneLeft, laneWidth = param.laneWidth, event = param.event;
        return {
            id: event.id,
            from: from,
            to: to,
            laneNumber: laneNumber,
            laneCount: laneCount,
            laneLeft: laneLeft,
            laneWidth: laneWidth,
            event: event
        };
    });
};
// 获取日程的样式
var computeStyle = function(param) {
    var from = param.from, to = param.to, laneNumber = param.laneNumber, laneCount = param.laneCount, laneLeft = param.laneLeft, laneWidth = param.laneWidth, event = param.event;
    var top = "".concat(10 + Math.ceil(from * 28.5), "px");
    var height = "".concat((to - from) * 28.5 - 1, "px");
    var left = event.drag ? "0" : "calc((100% - 8px) * ".concat(laneLeft !== null && laneLeft !== void 0 ? laneLeft : laneNumber / laneCount, ")");
    var width = event.drag ? "100%" : "calc((100% - 8px) * ".concat(laneWidth !== null && laneWidth !== void 0 ? laneWidth : 1 / laneCount, ")");
    return {
        event: event,
        top: top,
        height: height,
        left: left,
        width: width,
        from: from,
        to: to
    };
};
/**
 * rc-picker需要
 */ var calendar_extension_generateConfig = {
    // get
    getNow: function() {
        return moment_default()();
    },
    getFixedDate: function(string) {
        return moment_default()(string, "YYYY-MM-DD");
    },
    getEndDate: function(date) {
        var clone = date.clone();
        return clone.endOf("month");
    },
    getWeekDay: function(date) {
        var clone = date.clone().locale("en_US");
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: function(date) {
        return date.year();
    },
    getMonth: function(date) {
        return date.month();
    },
    getDate: function(date) {
        return date.date();
    },
    getHour: function(date) {
        return date.hour();
    },
    getMinute: function(date) {
        return date.minute();
    },
    getSecond: function(date) {
        return date.second();
    },
    // set
    addYear: function(date, diff) {
        var clone = date.clone();
        return clone.add(diff, "year");
    },
    addMonth: function(date, diff) {
        var clone = date.clone();
        return clone.add(diff, "month");
    },
    addDate: function(date, diff) {
        var clone = date.clone();
        return clone.add(diff, "day");
    },
    setYear: function(date, year) {
        var clone = date.clone();
        return clone.year(year);
    },
    setMonth: function(date, month) {
        var clone = date.clone();
        return clone.month(month);
    },
    setDate: function(date, num) {
        var clone = date.clone();
        return clone.date(num);
    },
    setHour: function(date, hour) {
        var clone = date.clone();
        return clone.hour(hour);
    },
    setMinute: function(date, minute) {
        var clone = date.clone();
        return clone.minute(minute);
    },
    setSecond: function(date, second) {
        var clone = date.clone();
        return clone.second(second);
    },
    // Compare
    isAfter: function(date1, date2) {
        return date1.isAfter(date2);
    },
    isValidate: function(date) {
        return date.isValid();
    },
    locale: {
        getWeekFirstDay: function(locale) {
            var date = moment_default()().locale(locale);
            return date.localeData().firstDayOfWeek();
        },
        getWeekFirstDate: function(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.weekday(0);
        },
        getWeek: function(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.week();
        },
        getShortWeekDays: function(locale) {
            var date = moment_default()().locale(locale);
            return date.localeData().weekdaysMin();
        },
        getShortMonths: function(locale) {
            var date = moment_default()().locale(locale);
            return date.localeData().monthsShort();
        },
        format: function(locale, date, format) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.format(format);
        },
        parse: function(locale, text, formats) {
            var fallbackFormatList = [];
            for(var i = 0; i < formats.length; i += 1){
                var format = formats[i];
                var formatText = text;
                if (format.includes("wo") || format.includes("Wo")) {
                    format = format.replace(/wo/g, "w").replace(/Wo/g, "W");
                    var matchFormat = format.match(/[-YyMmDdHhSsWwGg]+/g);
                    var matchText = formatText.match(/[-\d]+/g);
                    if (matchFormat && matchText) {
                        format = matchFormat.join("");
                        formatText = matchText.join("");
                    } else {
                        fallbackFormatList.push(format.replace(/o/g, ""));
                    }
                }
                var date = moment_default()(formatText, format, locale, true);
                if (date.isValid()) {
                    return date;
                }
            }
            // Fallback to fuzzy matching, this should always not reach match or need fire a issue
            for(var i1 = 0; i1 < fallbackFormatList.length; i1 += 1){
                var date1 = moment_default()(text, fallbackFormatList[i1], locale, false);
                /* istanbul ignore next */ if (date1.isValid()) {
                    // noteOnce(
                    //   false,
                    //   "Not match any format strictly and fallback to fuzzy match. Please help to fire a issue about this."
                    // );
                    return date1;
                }
            }
            return null;
        }
    }
};
var isThisDayEvent = function(event, day) {
    var isEndBefore = event.endTime.isBefore(day.startOfDay());
    var isStartAfter = event.startTime.isAfter(day.endOfDay());
    if (!event.isNew) return !isEndBefore && !isStartAfter;
    var isNewEventEndBeforeThisWeek = event.endTime.isBefore(day.startOfISOWeek());
    var isNewEventStartAfterThisWeek = event.startTime.isAfter(day.endOfISOWeek());
    return !isNewEventEndBeforeThisWeek && !isNewEventStartAfterThisWeek;
};

function calendar_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function calendar_extension_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                calendar_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                calendar_extension_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function calendar_extension_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function calendar_extension_createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) calendar_extension_defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) calendar_extension_defineProperties$1(Constructor, staticProps);
    return Constructor;
}
var calendar_extension_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getStartTime = function(day) {
    var now = new CalendarDate();
    var result;
    if (day.isSameDay(now)) {
        if (now.minute > 30) {
            result = now.addHour(1).set({
                minutes: 0
            });
        } else {
            result = now.set({
                minutes: 30
            });
        }
    } else {
        result = day.set({
            hours: 9,
            minutes: 0
        });
    }
    if (result.hour === 23 && result.minute === 0) {
        result.subtractMinute(30);
    }
    return result;
};
var getEndTime = function(startTime) {
    if (startTime.hour === 23 && startTime.minute === 30) {
        return startTime.addMinute(30);
    }
    return startTime.addHour(1);
};
var CalendarEvent = /*#__PURE__*/ function() {
    function CalendarEvent() {
        var _this = this;
        calendar_extension_classCallCheck$2(this, CalendarEvent);
        this.id = 0;
        this.name = "新建事件";
        this.status = 1;
        this.description = "";
        this.startTime = null;
        this.endTime = null;
        this.isAllDay = true;
        this.isNew = false;
        this.focus = false;
        this.hover = false;
        this.drag = false;
        this.press = false;
        this.pressType = PRESS_TYPE.START;
        this.store = null;
        this.notSync = false;
        this.position = null;
        this.provider = null;
        this.eventHandler = null;
        this.projectId = null;
        // 在每次的更新中处理
        this.onActionError = function() {};
        this.onUpdateQueueEmpty = function() {
            var eventHandler = _this.eventHandler;
            eventHandler.setLoading(false);
        };
        this.onUpdateQueueMaxSize = function() {
            var eventHandler = _this.eventHandler;
            eventHandler.setLoading(true);
        };
        this.updateQueue = new UpdateQueue(this.onActionError, 5, this.onUpdateQueueMaxSize, this.onUpdateQueueEmpty);
        this.doByNotSync = function(cb) {
            _this.notSync = true;
            var res = cb();
            _this.notSync = false;
            return res;
        };
    }
    var _proto = CalendarEvent.prototype;
    _proto.add = function add() {
        var _this = this;
        return calendar_extension_asyncToGenerator$1(function() {
            var provider, projectId, eventHandler, data;
            return calendar_extension_generator$1(this, function(_state) {
                provider = _this.provider, projectId = _this.projectId, eventHandler = _this.eventHandler;
                data = _this.originEventJSON;
                return [
                    2,
                    provider.addEvent(projectId, data).then(function(event) {
                        _this.doByNotSync(function() {
                            _this.syncFromOriginEvent(event);
                        });
                        _this.eventHandler.addEvent(_this);
                    }).catch(function(e) {
                        eventHandler.setError(e.message);
                    })
                ];
            });
        })();
    };
    _proto.update = function update() {
        var isSyncRemote = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var _this = this, provider = _this.provider, projectId = _this.projectId, eventHandler = _this.eventHandler;
        this.eventHandler.updateEvent();
        if (isSyncRemote) {
            var _this1 = this;
            this.updateQueue.push(/*#__PURE__*/ calendar_extension_asyncToGenerator$1(function() {
                return calendar_extension_generator$1(this, function(_state) {
                    return [
                        2,
                        provider.updateEvent(projectId, _this1).catch(function(e) {
                            eventHandler.setError(e.message);
                        })
                    ];
                });
            }));
        }
    };
    _proto.remove = function remove() {
        var _this = this;
        return calendar_extension_asyncToGenerator$1(function() {
            var provider, projectId, eventHandler;
            return calendar_extension_generator$1(this, function(_state) {
                provider = _this.provider, projectId = _this.projectId, eventHandler = _this.eventHandler;
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        provider.canIRemove(projectId, _this).then(function() {
                            var data = _this.originEventJSON;
                            provider.removeEvent(projectId, data).then(function() {
                                _this.eventHandler.removeEvent(_this);
                                resolve();
                            }).catch(function(error) {
                                eventHandler.setError(error.message);
                                reject(error);
                            });
                        });
                    })
                ];
            });
        })();
    };
    _proto.syncFromOriginEvent = function syncFromOriginEvent(originEvent) {
        this.id = originEvent.eventId;
        this.name = originEvent.eventName;
        this.description = originEvent.description;
        this.status = originEvent.eventStatus;
        this.isAllDay = originEvent.isAllDay;
        this.startTime = new CalendarDate(originEvent.startTime);
        this.endTime = new CalendarDate(originEvent.endTime);
        this.createTime = new CalendarDate(originEvent.createTime);
        return this;
    };
    _proto.clone = function clone() {
        var event = new CalendarEvent();
        event.id = this.id;
        event.name = this.name;
        event.description = this.description;
        event.status = this.status;
        event.isAllDay = this.isAllDay;
        event.startTime = new CalendarDate(this.startTime);
        event.endTime = new CalendarDate(this.endTime);
        event.pressType = this.pressType;
        return event;
    };
    CalendarEvent.createByDate = function createByDate(date, param) {
        var projectId = param.projectId, provider = param.provider, eventHandler = param.eventHandler, mouseX = param.mouseX, mouseY = param.mouseY;
        var event = new CalendarEvent();
        event.position = {
            mouseX: mouseX,
            mouseY: mouseY
        };
        event.projectId = projectId;
        event.provider = provider;
        event.eventHandler = eventHandler;
        event.startTime = getStartTime(date);
        event.endTime = getEndTime(event.startTime);
        event.isAllDay = true;
        event.focus = true;
        event.isNew = true;
        event.createTime = new CalendarDate();
        return proxyEvent(event);
    };
    CalendarEvent.createByTimeSlot = function createByTimeSlot(startTime, endTime, param) {
        var projectId = param.projectId, provider = param.provider, eventHandler = param.eventHandler, mouseX = param.mouseX, mouseY = param.mouseY;
        var event = new CalendarEvent();
        event.position = {
            mouseX: mouseX,
            mouseY: mouseY
        };
        event.projectId = projectId;
        event.provider = provider;
        event.eventHandler = eventHandler;
        event.startTime = startTime;
        event.endTime = endTime;
        event.isAllDay = false;
        event.focus = true;
        event.isNew = true;
        event.createTime = new CalendarDate();
        return proxyEvent(event);
    };
    CalendarEvent.createByOriginEvent = function createByOriginEvent(originEvent, param) {
        var projectId = param.projectId, provider = param.provider, eventHandler = param.eventHandler;
        var event = new CalendarEvent();
        event.projectId = projectId;
        event.provider = provider;
        event.eventHandler = eventHandler;
        return event.doByNotSync(function() {
            return event.syncFromOriginEvent(originEvent);
        });
    };
    calendar_extension_createClass$1(CalendarEvent, [
        {
            key: "statusString",
            get: function get() {
                return getStatusStr(this.status);
            },
            set: function set(statusStr) {
                this.status = getStatusNumber(statusStr);
            }
        },
        {
            key: "originEventJSON",
            get: function get() {
                var _this_name, _this_description;
                return {
                    eventId: this.id,
                    eventName: (_this_name = this.name) !== null && _this_name !== void 0 ? _this_name : "新建事件",
                    eventStatus: this.status,
                    description: (_this_description = this.description) !== null && _this_description !== void 0 ? _this_description : "",
                    startTime: this.startTime.timestamp,
                    endTime: this.endTime.timestamp,
                    isAllDay: this.isAllDay,
                    createTime: this.createTime.timestamp
                };
            }
        }
    ]);
    return CalendarEvent;
}();

var calendar_extension_css_248z$1 = ".ct-base-calendar-btn{display:flex;justify-content:center;align-items:center;padding:6px 16px;border:1px solid #ddd;background:#fff;font-size:14px;cursor:pointer}";
calendar_extension_styleInject(calendar_extension_css_248z$1);

function calendar_extension_extends() {
    calendar_extension_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return calendar_extension_extends.apply(this, arguments);
}
function calendar_extension_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = calendar_extension_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function calendar_extension_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var calendar_extension_Button = function(_param) /*#__PURE__*/ {
    var children = _param.children, _param_className = _param.className, className = _param_className === void 0 ? "" : _param_className, rest = calendar_extension_objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return react_default.a.createElement("div", calendar_extension_extends({
        className: "".concat(calendar_extension_classNamePrefix("base-calendar-btn"), " ").concat(className)
    }, rest), children);
};

var calendar_extension_img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='5px' height='8px' viewBox='0 0 5 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e7%ae%ad%e5%a4%b4 copy 4%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e6%97%a5%e5%8e%86%e5%ae%8f%e7%bc%96%e8%be%91%e6%a8%a1%e5%bc%8f' transform='translate(-77.000000%2c -206.000000)' fill='%236B6B6B'%3e %3cg id='%e7%bc%96%e8%be%91%e5%8c%ba' transform='translate(0.000000%2c 51.000000)'%3e %3cg id='Group-2' transform='translate(56.000000%2c 139.000000)'%3e %3cg id='Group-4' transform='translate(8.000000%2c 4.000000)'%3e %3cg id='Group-4-Copy-4'%3e %3cg id='%e7%ae%ad%e5%a4%b4-copy-4' transform='translate(15.500000%2c 16.000000) scale(-1%2c 1) translate(-15.500000%2c -16.000000) translate(13.000000%2c 12.000000)'%3e %3cpath d='M4.25374873%2c2.93681079 L1.3647971%2c0.220193695 C1.05258088%2c-0.0733978982 0.546378379%2c-0.0733978982 0.234162162%2c0.220193695 C-0.0780540541%2c0.513785287 -0.0780540541%2c0.989791309 0.234162162%2c1.2833829 L3.1231138%2c4 L0.234162162%2c6.7166171 C-0.0780540541%2c7.01020869 -0.0780540541%2c7.48621471 0.234162162%2c7.77980631 C0.546378379%2c8.0733979 1.05258088%2c8.0733979 1.3647971%2c7.77980631 L4.25374873%2c5.06318921 L4.76895488%2c4.5481032 C5.07701504%2c4.24011487 5.07701504%2c3.75988513 4.76895488%2c3.4518968 L4.25374873%2c2.93681079 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var calendar_extension_img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='6px' height='8px' viewBox='0 0 6 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e7%ae%ad%e5%a4%b4 copy 5%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e6%97%a5%e5%8e%86%e5%ae%8f%e7%bc%96%e8%be%91%e6%a8%a1%e5%bc%8f' transform='translate(-167.000000%2c -206.000000)' fill='%236B6B6B'%3e %3cg id='%e7%bc%96%e8%be%91%e5%8c%ba' transform='translate(0.000000%2c 51.000000)'%3e %3cg id='Group-2' transform='translate(56.000000%2c 139.000000)'%3e %3cg id='Group-4' transform='translate(8.000000%2c 4.000000)'%3e %3cg id='Group-4-Copy-5' transform='translate(90.000000%2c 0.000000)'%3e %3cg id='%e7%ae%ad%e5%a4%b4-copy-5' transform='translate(13.000000%2c 12.000000)'%3e %3cpath d='M4.57837386%2c2.93681079 L1.97831739%2c0.220193695 C1.69732279%2c-0.0733978982 1.24174054%2c-0.0733978982 0.960745946%2c0.220193695 C0.679751351%2c0.513785287 0.679751351%2c0.989791309 0.960745946%2c1.2833829 L3.56080242%2c4 L0.960745946%2c6.7166171 C0.679751351%2c7.01020869 0.679751351%2c7.48621471 0.960745946%2c7.77980631 C1.24174054%2c8.0733979 1.69732279%2c8.0733979 1.97831739%2c7.77980631 L4.57837386%2c5.06318921 L5.04205939%2c4.5481032 C5.31931354%2c4.24011487 5.31931354%2c3.75988513 5.04205939%2c3.4518968 L4.57837386%2c2.93681079 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var ScheduleContext = react_default.a.createContext(null);

var calendar_extension_css_248z$2 = ".ct-base-calendar-header{position:relative;display:flex;flex-direction:row;justify-content:center;align-items:center;height:40px;padding:0 8px}.ct-base-calendar-header .btn-today{position:absolute;border-radius:4px;height:30px;top:5px;padding:6px 8px}.ct-base-calendar-header .btn-wrapper{position:absolute;left:80px;display:flex}.ct-base-calendar-header .btn-today{left:10px}.ct-base-calendar-header .btn-month{border-top-right-radius:0;border-bottom-right-radius:0}.ct-base-calendar-header .btn-month-pick{color:#1c6cdc}.ct-base-calendar-header .btn-week{border-top-left-radius:0;border-bottom-left-radius:0}.ct-base-calendar-header .btn-week-pick{color:#1c6cdc}.ct-base-calendar-header .btn-create{position:absolute;border-radius:4px;height:30px;right:10px;padding:6px 8px}.ct-base-calendar-header .btn-create:hover{border-color:#1c6cdc}.ct-base-calendar-header .ct-calendar-datedisplay{font-size:18px;display:flex;flex-direction:row;align-items:center}.ct-base-calendar-header .ct-calendar-datedisplay .text{padding:0 17px}.ct-base-calendar-header .ct-calendar-datedisplay .btn{display:flex;justify-content:center;align-items:center;width:32px;height:32px;border:0 solid #ddd;background:hsla(0,0%,100%,0)}.ct-base-calendar-header .ct-calendar-datedisplay .btn:hover{border:none!important;background:none!important}.ct-base-calendar-header .ct-calendar-datedisplay .btn:focus{outline:none}.ct-calendar-weekmark{display:flex;flex-direction:row;height:20px;border-bottom:1px solid #ddd;background:#fff;position:relative;z-index:2}.ct-calendar-weekmark .mark{display:flex;flex-grow:1;align-items:center;font-size:12px;transform:scale(.84);color:#999}.ct-calendar-weekmark .mark.today{color:#1c6cdc}.ct-calendar-weekmark .mark.today .date{background:#1c6cdc;color:#fff;border-radius:10px;padding:0 6px;margin-left:4px}.ct-calendar-weekmark.week{padding-left:45px}";
calendar_extension_styleInject(calendar_extension_css_248z$2);

var DateDisplay = function() {
    var schedule = Object(react["useContext"])(ScheduleContext);
    var view = schedule.view, calendarDate = schedule.calendarDate, setCalendarDate = schedule.setCalendarDate;
    var text = "";
    if (view === "month") {
        text = "".concat(calendarDate.year, "年").concat(calendarDate.month + 1, "月");
    } else {
        text = "".concat(calendarDate.isoYear, "年").concat(calendarDate.isoWeek, "周");
    }
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: calendar_extension_classNamePrefix("calendar-datedisplay")
    }, /*#__PURE__*/ react_default.a.createElement("button", {
        className: "btn",
        onClick: function() {
            if (view === "month") {
                setCalendarDate(calendarDate.addMonth(-1));
            } else {
                setCalendarDate(calendarDate.addWeek(-1));
            }
        }
    }, /*#__PURE__*/ react_default.a.createElement("img", {
        src: calendar_extension_img,
        alt: ""
    })), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "text"
    }, text), /*#__PURE__*/ react_default.a.createElement("button", {
        className: "btn",
        onClick: function() {
            if (view === "month") {
                setCalendarDate(calendarDate.addMonth(1));
            } else {
                setCalendarDate(calendarDate.addWeek(1));
            }
        }
    }, /*#__PURE__*/ react_default.a.createElement("img", {
        src: calendar_extension_img$1,
        alt: ""
    })));
};

var WeekMark = function() {
    var _useContext = Object(react["useContext"])(ScheduleContext), view = _useContext.view, baseTime = _useContext.baseTime;
    var offset = new CalendarDate().diffDays(baseTime);
    var dayMark = [];
    if (view === "week") {
        var firstDay = baseTime.startOfISOWeek();
        for(var i = 0; i < 7; i++){
            dayMark.push(firstDay.addDay(i).format(i === offset ? "M-dd" : "(M-dd)"));
        }
    }
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: calendar_extension_classNamePrefix("calendar-weekmark".concat(view === "week" ? " week" : ""))
    }, calendar_extension_marks.map(function(mark, i) {
        return /*#__PURE__*/ react_default.a.createElement("div", {
            key: mark,
            className: classnames_default()("mark", {
                today: offset === i
            })
        }, /*#__PURE__*/ react_default.a.createElement("div", null, mark), view === "week" && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "date"
        }, dayMark[i]));
    }));
};

var calendar_extension_Header = function() {
    var _useContext = Object(react["useContext"])(ScheduleContext), view = _useContext.view, setView = _useContext.setView, projectId = _useContext.projectId, provider = _useContext.provider, eventHandler = _useContext.eventHandler, setEditingEvent = _useContext.setEditingEvent, setNodeSelection = _useContext.setNodeSelection, setCalendarDate = _useContext.setCalendarDate;
    var createEvent = function(param) {
        var mouseX = param.mouseX, mouseY = param.mouseY;
        var event = null;
        if (view === "month") {
            event = CalendarEvent.createByDate(new CalendarDate(), {
                mouseX: mouseX,
                mouseY: mouseY,
                projectId: projectId,
                provider: provider,
                eventHandler: eventHandler
            });
        } else {
            var startOfHour = CalendarDate.startOfHour();
            var startTime = startOfHour.addMinute(30);
            if (startTime.isSameOrBefore(new CalendarDate())) {
                startTime = startOfHour.addHour(1);
            }
            var endTime = startTime.addHour(1);
            event = CalendarEvent.createByTimeSlot(startTime, endTime, {
                mouseX: mouseX,
                mouseY: mouseY,
                projectId: projectId,
                provider: provider,
                eventHandler: eventHandler
            });
        }
        event.add().then(function() {
            setEditingEvent(event);
        });
    };
    var handleClick = function(e) {
        if (e.target.classList.contains(calendar_extension_classNamePrefix("base-calendar-header"))) {
            setNodeSelection();
        }
    };
    var handleClickToday = function(e) {
        setCalendarDate(new CalendarDate());
    };
    return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/ react_default.a.createElement("div", {
        className: calendar_extension_classNamePrefix("base-calendar-header"),
        onClick: handleClick
    }, /*#__PURE__*/ react_default.a.createElement(calendar_extension_Button, {
        className: "btn-today",
        onClick: handleClickToday
    }, "今天"), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "btn-wrapper"
    }, /*#__PURE__*/ react_default.a.createElement(calendar_extension_Button, {
        className: classnames_default()("btn-month", {
            "btn-month-pick": view === "month"
        }),
        onClick: function() {
            setView("month");
        }
    }, "月"), /*#__PURE__*/ react_default.a.createElement(calendar_extension_Button, {
        className: classnames_default()("btn-week", {
            "btn-week-pick": view === "week"
        }),
        onClick: function() {
            setView("week");
        }
    }, "周")), /*#__PURE__*/ react_default.a.createElement(DateDisplay, null), /*#__PURE__*/ react_default.a.createElement(calendar_extension_Button, {
        className: classnames_default()("btn-create"),
        onClick: function() {
            var width = window.innerWidth;
            var height = window.innerHeight;
            createEvent({
                mouseX: width * 0.5,
                mouseY: height * 0.5
            });
        }
    }, "新建日程")), /*#__PURE__*/ react_default.a.createElement(WeekMark, null));
};

var calendar_extension_img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3es_%2b%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Artboard' transform='translate(-297.000000%2c -194.000000)' fill='%236B6B6B'%3e %3cg id='Group-14' transform='translate(297.000000%2c 194.000000)'%3e %3cpath d='M8.66497803%2c7.33502197 L8.66497803%2c3.66497803 C8.66497803%2c3.2977208 8.36725722%2c3 8%2c3 C7.63274278%2c3 7.33502197%2c3.2977208 7.33502197%2c3.66497803 L7.33502197%2c7.33502197 L3.66497803%2c7.33502197 C3.2977208%2c7.33502197 3%2c7.63274278 3%2c8 C3%2c8.36725722 3.2977208%2c8.66497803 3.66497803%2c8.66497803 L7.33502197%2c8.66497803 L7.33502197%2c12.335022 C7.33502197%2c12.7022792 7.63274278%2c13 8%2c13 C8.36725722%2c13 8.66497803%2c12.7022792 8.66497803%2c12.335022 L8.66497803%2c8.66497803 L12.335022%2c8.66497803 C12.7022792%2c8.66497803 13%2c8.36725722 13%2c8 C13%2c7.63274278 12.7022792%2c7.33502197 12.335022%2c7.33502197 L8.66497803%2c7.33502197 Z' id='Combined-Shape-Copy-11'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var Header$1 = function(props) {
    var date = props.date, allowShowAddButton = props.allowShowAddButton, index = props.index, onClick = props.onClick;
    var _useContext = Object(react["useContext"])(ScheduleContext), hoverIndex = _useContext.hoverIndex, editable = _useContext.editable;
    var _useContext1 = Object(react["useContext"])(ScheduleContext), error = _useContext1.schedule.error;
    var className = !error && new CalendarDate().isSameDay(date) ? "outline" : "";
    var isShowPlus = allowShowAddButton && hoverIndex === index && editable;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "calendar-cell-header"
    }, /*#__PURE__*/ react_default.a.createElement("span", {
        className: className
    }, date.monthDate), isShowPlus && /*#__PURE__*/ react_default.a.createElement("img", {
        src: calendar_extension_img$2,
        alt: "",
        onClick: onClick
    }));
};

var calendar_extension_img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='30px' height='30px' viewBox='0 0 30 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3eL_%2b%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Artboard' transform='translate(-382.000000%2c -233.000000)' fill='%236B6B6B'%3e %3cpath d='M397.664978%2c247.335022 L397.664978%2c233.664978 C397.664978%2c233.297721 397.367257%2c233 397%2c233 C396.632743%2c233 396.335022%2c233.297721 396.335022%2c233.664978 L396.335022%2c247.335022 L382.664978%2c247.335022 C382.297721%2c247.335022 382%2c247.632743 382%2c248 C382%2c248.367257 382.297721%2c248.664978 382.664978%2c248.664978 L396.335022%2c248.664978 L396.335022%2c262.335022 C396.335022%2c262.702279 396.632743%2c263 397%2c263 C397.367257%2c263 397.664978%2c262.702279 397.664978%2c262.335022 L397.664978%2c248.664978 L411.335022%2c248.664978 C411.702279%2c248.664978 412%2c248.367257 412%2c248 C412%2c247.632743 411.702279%2c247.335022 411.335022%2c247.335022 L397.664978%2c247.335022 Z' id='Combined-Shape-Copy-12'%3e%3c/path%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var Plus = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()("plus active"),
        onClick: onClick
    }, /*#__PURE__*/ react_default.a.createElement("img", {
        src: calendar_extension_img$3,
        alt: ""
    }));
};

var calendar_extension_css_248z$3 = ".ct-calendar-cell{position:relative;display:flex;flex-direction:column;justify-content:space-between;height:100%;width:100%}.ct-calendar-cell .calendar-cell-header{position:absolute;padding:0;left:0;right:0;height:14px;color:#999;background:transparent}.ct-calendar-cell .calendar-cell-header span{position:absolute;left:5px;flex:1;font-size:12px}.ct-calendar-cell .calendar-cell-header .outline{display:flex;justify-content:center;align-items:center;background:#1c6cdc;color:#fff;height:17px;width:17px;border-radius:100%}.ct-calendar-cell .calendar-cell-header img{position:absolute;right:-1px;font-size:12px;color:#1c6cdc}.ct-calendar-cell .plus{position:absolute;height:100%;width:100%;display:flex;align-items:center;justify-content:center;border:1px solid #1c6cdc;cursor:pointer}.ct-calendar-cell .plus.active{opacity:1}";
calendar_extension_styleInject(calendar_extension_css_248z$3);

var Cell = function(props) {
    var offset = props.offset;
    var _useContext = Object(react["useContext"])(ScheduleContext), calendarDate = _useContext.calendarDate, baseTime = _useContext.baseTime, hoverIndex = _useContext.hoverIndex, setEditingEvent = _useContext.setEditingEvent, projectId = _useContext.projectId, provider = _useContext.provider, events = _useContext.schedule.events, eventHandler = _useContext.eventHandler;
    var day = new CalendarDate(baseTime).addDay(offset);
    var style = {
        background: calendarDate.isSameMonth(day) ? "" : "#f8f8f8"
    };
    var todayEvents = events.filter(function(e) {
        return isThisDayEvent(e, day);
    });
    var isActive = hoverIndex === offset;
    var createEvent = function(e) {
        var x = e.nativeEvent.clientX;
        var y = e.nativeEvent.clientY;
        var event = CalendarEvent.createByDate(day, {
            mouseX: x,
            mouseY: y,
            projectId: projectId,
            provider: provider,
            eventHandler: eventHandler
        });
        event.add().then(function() {
            setEditingEvent(event);
        });
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: calendar_extension_classNamePrefix("calendar-cell"),
        style: style
    }, /*#__PURE__*/ react_default.a.createElement(Header$1, {
        date: day,
        allowShowAddButton: todayEvents.length > 0,
        onClick: createEvent,
        index: offset
    }), todayEvents.length <= 0 && isActive && /*#__PURE__*/ react_default.a.createElement(Plus, {
        onClick: function(e) {
            createEvent(e);
        }
    }));
};
var Cell$1 = /*#__PURE__*/ react_default.a.memo(Cell);

var calendar_extension_Col = function(param) {
    var offset = param.offset;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "col"
    }, /*#__PURE__*/ react_default.a.createElement(Cell$1, {
        offset: offset
    }));
};

var computedStyleValue = function(event, day) {
    var startCDate = new CalendarDate(event.startTime);
    var endCDate = new CalendarDate(event.endTime);
    var head = startCDate.isSameOrAfter(CalendarDate.startOfISOWeek(day.date));
    var tail = endCDate.isSameOrBefore(CalendarDate.endOfISOWeek(day.date));
    var oneDay = startCDate.isSameDay(endCDate);
    var size;
    if (head) {
        size = tail ? endCDate.diffDays(startCDate) + 1 : 8 - startCDate.isoWeekday;
    } else {
        size = tail ? endCDate.isoWeekday : 7;
    }
    return {
        size: size,
        head: head,
        tail: tail,
        oneDay: oneDay
    };
};
var computedWrapperStyles = function(param) {
    var size = param.size, head = param.head, tail = param.tail;
    return {
        width: "calc((100% - 6px) / 7 * ".concat(size, " + ").concat(size - 1, "px").concat(tail ? " - 1px" : "", ")"),
        paddingLeft: head ? "2px" : "0",
        paddingRight: tail ? "2px" : "0"
    };
};
var computedAllDayEventStyles = function(param) {
    var head = param.head, tail = param.tail, focus = param.focus, hover = param.hover, press = param.press, statusString = param.statusString;
    return {
        borderTopLeftRadius: head ? "2px" : "0",
        borderBottomLeftRadius: head ? "2px" : "0",
        borderTopRightRadius: tail ? "2px" : "0",
        borderBottomRightRadius: tail ? "2px" : "0",
        background: calendar_extension_colors["".concat(statusString).concat(focus ? "Focus" : "")],
        boxShadow: press || focus || hover ? "0 5px 10px 0 rgba(106,93,73,0.50)" : "",
        color: focus ? "#fff" : "#000"
    };
};
var computedOneDayEventStyles = function(param) {
    var focus = param.focus, hover = param.hover, press = param.press, statusString = param.statusString;
    return {
        boxShadow: press || focus || hover ? "0 5px 10px 0 rgba(106,93,73,0.50)" : "",
        background: focus ? calendar_extension_colors["".concat(statusString, "Focus")] : hover ? "#ffffff" : "rgba(0, 0, 0, 0)",
        color: focus ? "#fff" : "#000"
    };
};
var computedOneDayEventBlockStyles = function(param) {
    var focus = param.focus, statusString = param.statusString;
    return {
        background: focus ? "#fff" : calendar_extension_colors["".concat(statusString, "Focus")]
    };
};

function calendar_extension_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_extends$1() {
    calendar_extension_extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return calendar_extension_extends$1.apply(this, arguments);
}
function calendar_extension_getPrototypeOf(o) {
    calendar_extension_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf(o);
}
function calendar_extension_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf(subClass, superClass);
}
function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function calendar_extension_possibleConstructorReturn(self, call) {
    if (call && (calendar_extension_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized(self);
}
function calendar_extension_setPrototypeOf(o, p) {
    calendar_extension_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf(o, p);
}
var calendar_extension_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn(this, result);
    };
}
var calendar_extension_AllDay = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits(AllDay, _React_Component);
    var _super = calendar_extension_createSuper(AllDay);
    function AllDay() {
        calendar_extension_classCallCheck$3(this, AllDay);
        return _super.apply(this, arguments);
    }
    var _proto = AllDay.prototype;
    _proto.render = function render() {
        var _this_props = this.props, isShowTime = _this_props.isShowTime, event = _this_props.event, styleValue = _this_props.styleValue, rest = _objectWithoutProperties$1(_this_props, [
            "isShowTime",
            "event",
            "styleValue"
        ]);
        var styles = computedAllDayEventStyles(styleValue);
        var text = isShowTime ? "".concat(event.name, " ").concat(new CalendarDate(event.startTime).format("HH:mm")) : "".concat(event.name);
        return /*#__PURE__*/ react_default.a.createElement("div", calendar_extension_extends$1({
            className: "task",
            style: styles
        }, rest), text);
    };
    return AllDay;
}(react_default.a.Component);

var calendar_extension_css_248z$4 = ".ct-calendar-task-wrapper{position:absolute;display:flex;height:20px;z-index:3;margin-bottom:2px;overflow:visible}.ct-calendar-task-wrapper .drag-left,.ct-calendar-task-wrapper .drag-right{position:absolute;top:0;bottom:0;width:10px}.ct-calendar-task-wrapper .drag-left{left:0;cursor:w-resize}.ct-calendar-task-wrapper .drag-right{right:0;cursor:e-resize}.ct-calendar-task-wrapper:last-child{margin-bottom:0}.ct-calendar-task-wrapper .ct-event-oneday,.ct-calendar-task-wrapper .task{position:relative;height:20px;width:100%;line-height:20px;background:#fff;font-size:12px;color:#000;padding:0 6px;border-radius:2px;overflow:hidden;text-overflow:ellipsis;display:block;white-space:nowrap;-webkit-box-orient:vertical}.ct-calendar-task-wrapper .ct-event-oneday{display:flex;align-items:center;flex-direction:row}.ct-calendar-task-wrapper .ct-event-oneday .oneday-block{width:8px;min-width:8px;height:8px}.ct-calendar-task-wrapper .ct-event-oneday .oneday-text{flex-grow:1;max-width:calc(100% - 2px);overflow:hidden;padding:0 2px;text-overflow:ellipsis;display:block;white-space:nowrap;-webkit-box-orient:vertical}.ct-calendar-task-wrapper .angle{width:0;height:0;border-right:10px solid transparent;border-color:transparent #fcebbd transparent transparent;border-style:solid;border-width:10px 8px 10px 0}";
calendar_extension_styleInject(calendar_extension_css_248z$4);

function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
function _objectWithoutProperties$2(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var OneDay = function(props) {
    var event = props.event, rest = _objectWithoutProperties$2(props, [
        "event"
    ]);
    var startTime = event.startTime, statusString = event.statusString, name = event.name, focus = event.focus, hover = event.hover, press = event.press;
    var styles = computedOneDayEventStyles({
        press: press,
        focus: focus,
        hover: hover,
        statusString: statusString
    });
    var blockStyles = computedOneDayEventBlockStyles({
        focus: focus,
        statusString: statusString
    });
    return /*#__PURE__*/ react_default.a.createElement("div", _extends$2({
        className: calendar_extension_classNamePrefix("event-oneday"),
        style: styles
    }, rest), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "oneday-block",
        style: blockStyles
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "oneday-text"
    }, "".concat(name, " ").concat(new CalendarDate(startTime).format("HH:mm"))));
};

function calendar_extension_assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function calendar_extension_defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function calendar_extension_getPrototypeOf$1(o) {
    calendar_extension_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$1(o);
}
function calendar_extension_inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$1(subClass, superClass);
}
function calendar_extension_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            calendar_extension_defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function calendar_extension_possibleConstructorReturn$1(self, call) {
    if (call && (calendar_extension_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$1(self);
}
function calendar_extension_setPrototypeOf$1(o, p) {
    calendar_extension_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$1(o, p);
}
var calendar_extension_typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$1(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$1(this, result);
    };
}
var MONTH_GRID_CLASS = ".".concat(calendar_extension_classNamePrefix("calendar-grid"));
var WEEK_GRID_CLASS = ".week-view-row";
var calendar_extension_Event = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$1(Event, _React_Component);
    var _super = calendar_extension_createSuper$1(Event);
    function Event() {
        calendar_extension_classCallCheck$4(this, Event);
        var _this;
        _this = _super.apply(this, arguments);
        _this.ref = /*#__PURE__*/ react_default.a.createRef();
        _this.handleMouseEnter = function() {
            var event = _this.props.event;
            if (!_this.hasPressEvent) {
                event.hover = true;
            }
        };
        _this.handleMouseLeave = function() {
            var event = _this.props.event;
            if (!_this.hasPressEvent) {
                event.hover = false;
            }
        };
        _this.handleClick = function(e) {
            var setEditingEvent = Object(react["useContext"])(ScheduleContext).setEditingEvent;
            var event = _this.props.event;
            var mouseX = e.clientX, mouseY = e.clientY;
            event.focus = true;
            event.position = {
                mouseX: mouseX,
                mouseY: mouseY
            };
            setEditingEvent(event);
        };
        _this.handlePressEvent = function(e, pressType) {
            if (pressType !== PRESS_TYPE.CENTER) {
                e.preventDefault();
            }
            var event = _this.props.event;
            event.pressType = pressType;
            _this.pressEvent = event;
        };
        return _this;
    }
    var _proto = Event.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, style = _this_props.style, day = _this_props.day, event = _this_props.event, _this_props_event = _this_props.event, isAllDay = _this_props_event.isAllDay, statusString = _this_props_event.statusString, focus = _this_props_event.focus, hover = _this_props_event.hover, press = _this_props_event.press;
        var editable = this.context.editable;
        var _computedStyleValue = computedStyleValue(event, day), size = _computedStyleValue.size, head = _computedStyleValue.head, tail = _computedStyleValue.tail, oneDay = _computedStyleValue.oneDay;
        var wrapperStyles = computedWrapperStyles({
            size: size,
            head: head,
            tail: tail
        });
        var dayComponent = /*#__PURE__*/ react_default.a.createElement(OneDay, {
            event: event,
            onMouseDown: function(e) {
                return _this.handlePressEvent(e, PRESS_TYPE.CENTER);
            }
        });
        if (isAllDay || !oneDay) {
            dayComponent = /*#__PURE__*/ react_default.a.createElement(calendar_extension_AllDay, {
                isShowTime: !isAllDay,
                event: event,
                styleValue: {
                    head: head,
                    tail: tail,
                    focus: focus,
                    hover: hover,
                    statusString: statusString,
                    press: press
                },
                onMouseDown: function(e) {
                    return _this.handlePressEvent(e, PRESS_TYPE.CENTER);
                }
            });
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            ref: this.ref,
            className: calendar_extension_classNamePrefix("calendar-task-wrapper"),
            style: calendar_extension_objectSpread$1({}, wrapperStyles, style),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            draggable: editable
        }, dayComponent, editable && head && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "drag-left",
            onMouseDown: function(e) {
                return _this.handlePressEvent(e, PRESS_TYPE.START);
            }
        }), editable && tail && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "drag-right",
            onMouseDown: function(e) {
                return _this.handlePressEvent(e, PRESS_TYPE.END);
            }
        }));
    };
    _createClass$2(Event, [
        {
            key: "hasPressEvent",
            get: function get() {
                var _this_ref_current_closest;
                var view = this.context.view;
                if (view === "week") {
                    var _this_ref_current_closest1;
                    return !!((_this_ref_current_closest1 = this.ref.current.closest(WEEK_GRID_CLASS)) === null || _this_ref_current_closest1 === void 0 ? void 0 : _this_ref_current_closest1.pressEvent);
                }
                return !!((_this_ref_current_closest = this.ref.current.closest(MONTH_GRID_CLASS)) === null || _this_ref_current_closest === void 0 ? void 0 : _this_ref_current_closest.pressEvent);
            }
        },
        {
            key: "pressEvent",
            set: function set(event) {
                var view = this.context.view;
                if (view === "week") {
                    this.ref.current.closest(WEEK_GRID_CLASS).pressEvent = event;
                } else {
                    this.ref.current.closest(MONTH_GRID_CLASS).pressEvent = event;
                }
            }
        }
    ]);
    return Event;
}(react_default.a.Component);
calendar_extension_Event.contextType = ScheduleContext;

var calendar_extension_Row = function(props) {
    var index = props.index;
    var _useContext = Object(react["useContext"])(ScheduleContext), events = _useContext.schedule.events, baseTime = _useContext.baseTime;
    var cdate = new CalendarDate(baseTime).addWeek(index);
    var displayEvents = events.filter(function(event) {
        return cdate.isInISOWeek(event.startTime, event.endTime);
    });
    var _getMonthSlotList = getMonthSlotList(displayEvents, cdate), schedules = _getMonthSlotList.schedules, slot = _getMonthSlotList.slot, maxLaneCount = _getMonthSlotList.maxLaneCount;
    var eventsRender = getMonthEventRenderList(schedules, slot);
    eventsRender = eventsRender.map(function(param) {
        var from = param.from, laneNumber = param.laneNumber, event = param.event;
        var styles = {
            top: "".concat(16 + (MONTH_EVENT_HEIGHT + MONTH_EVENT_GAP) * laneNumber, "px"),
            left: "calc((100% - 6px) / 7 * ".concat(from, " + ").concat(from, "px)")
        };
        return /*#__PURE__*/ react_default.a.createElement(calendar_extension_Event, {
            key: event.id,
            style: styles,
            day: cdate,
            event: event
        });
    });
    var height = 17 + (MONTH_EVENT_HEIGHT + MONTH_EVENT_GAP) * maxLaneCount;
    var styleProps = {
        height: "".concat(height, "px"),
        // 10.3 兼容性
        minHeight: "".concat(height > MONTH_CELL_HEIGHT ? height : MONTH_CELL_HEIGHT, "px")
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "row",
        style: styleProps
    }, eventsRender, makeList(7, function(i) {
        var offset = index * 7 + i;
        return /*#__PURE__*/ react_default.a.createElement(calendar_extension_Col, {
            key: offset,
            offset: offset,
            events: events
        });
    }));
};

var calendar_extension_css_248z$5 = ".ct-calendar-grid{display:flex;flex-direction:column;background:#fff}.ct-calendar-grid .row{position:relative;display:flex;flex-direction:row;min-height:121px;border-bottom:1px solid #ddd}.ct-calendar-grid .row:last-child{border-bottom:0}.ct-calendar-grid .row .col{width:14.28571%;box-sizing:border-box;border-right:1px solid #ddd}.ct-calendar-grid .row .col:last-child{border-right:0}";
calendar_extension_styleInject(calendar_extension_css_248z$5);

function calendar_extension_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function calendar_extension_arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function calendar_extension_assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$3(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$3(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$3(Constructor, staticProps);
    return Constructor;
}
function calendar_extension_getPrototypeOf$2(o) {
    calendar_extension_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$2(o);
}
function calendar_extension_inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$2(subClass, superClass);
}
function calendar_extension_iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function calendar_extension_nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function calendar_extension_possibleConstructorReturn$2(self, call) {
    if (call && (calendar_extension_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$2(self);
}
function calendar_extension_setPrototypeOf$2(o, p) {
    calendar_extension_setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$2(o, p);
}
function calendar_extension_slicedToArray$1(arr, i) {
    return calendar_extension_arrayWithHoles$1(arr) || calendar_extension_iterableToArrayLimit$1(arr, i) || calendar_extension_unsupportedIterableToArray$1(arr, i) || calendar_extension_nonIterableRest$1();
}
var calendar_extension_typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return calendar_extension_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return calendar_extension_arrayLikeToArray$1(o, minLen);
}
function calendar_extension_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$2(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$2(this, result);
    };
}
var DragEventHOC = function(WrappedComponent) {
    var _React_Component, _DragEventContainer;
    return _DragEventContainer = /*#__PURE__*/ function(_superClass) {
        calendar_extension_inherits$2(DragEventContainer, _superClass);
        var _super = calendar_extension_createSuper$2(DragEventContainer);
        function DragEventContainer() {
            calendar_extension_classCallCheck$5(this, DragEventContainer);
            var _this;
            _this = _super.apply(this, arguments);
            _this.containerRef = /*#__PURE__*/ react_default.a.createRef();
            _this.capturePressEvent = null;
            _this.capturePressOrigin = null;
            _this.mouseStatus = 0;
            _this.handleMouseDown = function(e) {
                _this.mouseStatus = GESTURE_TYPE.UNKNOWN;
                _this.mouseStatus |= MOUSE_STATUS.MOUSE_DOWN;
                var pressEvent = calendar_extension_assertThisInitialized$2(_this).pressEvent;
                if (!pressEvent) {
                    return;
                }
                pressEvent.press = true;
                pressEvent.hover = false;
                _this.capturePressEvent = pressEvent.clone();
                _this.capturePressOrigin = _this.child.getOffset(e.nativeEvent.clientX, e.nativeEvent.clientY);
            };
            _this.handleDragStart = function(e) {
                _this.mouseStatus = GESTURE_TYPE.UNKNOWN;
                _this.mouseStatus |= MOUSE_STATUS.MOUSE_DOWN;
                var pressEvent = calendar_extension_assertThisInitialized$2(_this).pressEvent;
                if (!pressEvent) {
                    return;
                }
                pressEvent.press = true;
                pressEvent.hover = false;
                _this.capturePressEvent = pressEvent.clone();
                _this.capturePressOrigin = _this.child.getOffset(e.nativeEvent.clientX, e.nativeEvent.clientY);
            };
            _this.handleMouseMove = function(param) {
                var x = param.clientX, y = param.clientY;
                _this.mouseStatus |= MOUSE_STATUS.MOUSE_MOVE;
                if (_this.mouseStatus === GESTURE_TYPE.MOVE) {
                    _this.handleNotDragMove({
                        x: x,
                        y: y
                    });
                } else if (_this.mouseStatus === GESTURE_TYPE.DRAGING) {
                    _this.handleDragMove({
                        x: x,
                        y: y
                    });
                }
            };
            _this.handleDragMove = lodash_throttle_default()(function(param) {
                var x = param.x, y = param.y;
                var _$_assertThisInitialized = calendar_extension_assertThisInitialized$2(_this), pressEvent = _$_assertThisInitialized.pressEvent, capturePressEvent = _$_assertThisInitialized.capturePressEvent;
                var _this_context = _this.context, hoverIndex = _this_context.hoverIndex, setHoverIndex = _this_context.setHoverIndex;
                if (!pressEvent) {
                    return;
                }
                if (hoverIndex !== -1) {
                    setHoverIndex(-1);
                }
                pressEvent.drag = true;
                var _this_child_getOffset = _this.child.getOffset(x, y), offsetX = _this_child_getOffset.x, offsetY = _this_child_getOffset.y;
                var pressType = capturePressEvent.pressType;
                if (pressType === PRESS_TYPE.START) {
                    var startTime = _this.child.handleDragStartTime(offsetX, offsetY, capturePressEvent);
                    if (startTime.isBefore(pressEvent.endTime)) {
                        pressEvent.startTime = startTime;
                    }
                }
                if (pressType === PRESS_TYPE.END) {
                    var endTime = _this.child.handleDragEndTime(offsetX, offsetY, capturePressEvent);
                    if (endTime.isAfter(pressEvent.startTime)) {
                        pressEvent.endTime = endTime;
                    }
                }
                if (pressType === PRESS_TYPE.CENTER && _this.capturePressOrigin) {
                    var _this_child_handleDragAllTime = calendar_extension_slicedToArray$1(_this.child.handleDragAllTime(offsetX, offsetY, capturePressEvent, _this.capturePressOrigin), 2), startTime1 = _this_child_handleDragAllTime[0], endTime1 = _this_child_handleDragAllTime[1];
                    pressEvent.startTime = startTime1;
                    pressEvent.endTime = endTime1;
                }
            }, 10);
            _this.handleNotDragMove = lodash_throttle_default()(function(param) {
                var mouseX = param.x, mouseY = param.y;
                var setHoverIndex = _this.context.setHoverIndex;
                var _this_child_getOffset = _this.child.getOffset(mouseX, mouseY), x = _this_child_getOffset.x, y = _this_child_getOffset.y;
                setHoverIndex(x + 7 * y);
            }, 10);
            _this.handleMouseUp = function(param) {
                var x = param.clientX, y = param.clientY;
                _this.mouseStatus |= MOUSE_STATUS.MOUSE_UP;
                var pressEvent = calendar_extension_assertThisInitialized$2(_this).pressEvent;
                if (!pressEvent) {
                    _this.mouseStatus = GESTURE_TYPE.UNKNOWN;
                    return;
                }
                if (_this.mouseStatus === GESTURE_TYPE.CLICK) {
                    var setEditingEvent = _this.context.setEditingEvent;
                    pressEvent.focus = true;
                    pressEvent.position = {
                        mouseX: x,
                        mouseY: y
                    };
                    setEditingEvent(pressEvent);
                }
                if (_this.mouseStatus === GESTURE_TYPE.DRAG) {
                    _this.pressEvent.update();
                }
                _this.clearPressEvent();
            };
            _this.handleDragEnd = function(e) {
                var _$_assertThisInitialized = calendar_extension_assertThisInitialized$2(_this), pressEvent = _$_assertThisInitialized.pressEvent, capturePressEvent = _$_assertThisInitialized.capturePressEvent;
                if (!pressEvent) {
                    return;
                }
                pressEvent.drag = true;
                var _this_child_getOffset = _this.child.getOffset(e.nativeEvent.clientX, e.nativeEvent.clientY), offsetX = _this_child_getOffset.x, offsetY = _this_child_getOffset.y;
                var pressType = capturePressEvent.pressType;
                if (pressType === PRESS_TYPE.START) {
                    var startTime = _this.child.handleDragStartTime(offsetX, offsetY, capturePressEvent);
                    if (startTime.isBefore(pressEvent.endTime)) {
                        pressEvent.startTime = startTime;
                    }
                }
                if (pressType === PRESS_TYPE.END) {
                    var endTime = _this.child.handleDragEndTime(offsetX, offsetY, capturePressEvent);
                    if (endTime.isAfter(pressEvent.startTime)) {
                        pressEvent.endTime = endTime;
                    }
                }
                if (pressType === PRESS_TYPE.CENTER && _this.capturePressOrigin) {
                    var _this_child_handleDragAllTime = calendar_extension_slicedToArray$1(_this.child.handleDragAllTime(offsetX, offsetY, capturePressEvent, _this.capturePressOrigin), 2), startTime1 = _this_child_handleDragAllTime[0], endTime1 = _this_child_handleDragAllTime[1];
                    pressEvent.startTime = startTime1;
                    pressEvent.endTime = endTime1;
                }
                _this.pressEvent.update();
                _this.clearPressEvent();
            };
            _this.clearPressEvent = function() {
                if (_this.pressEvent) {
                    _this.pressEvent.press = false;
                    _this.pressEvent.drag = false;
                }
                _this.pressEvent = null;
                _this.capturePressEvent = null;
                _this.mouseStatus = GESTURE_TYPE.UNKNOWN;
            };
            _this.handleMouseLeave = function() {
                var setHoverIndex = _this.context.setHoverIndex;
                setHoverIndex(-1);
                if (_this.pressEvent && _this.mouseStatus === GESTURE_TYPE.DRAGING) {
                    _this.pressEvent.update();
                }
                _this.clearPressEvent();
            };
            return _this;
        }
        var _proto = DragEventContainer.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ react_default.a.createElement(WrappedComponent, {
                bindRef: function(_) {
                    _this.child = _;
                },
                containerRef: this.containerRef,
                onMouseLeave: this.handleMouseLeave,
                onMouseDown: this.handleMouseDown,
                onMouseMove: this.handleMouseMove,
                onMouseUp: this.handleMouseUp,
                onDragStart: this.handleDragStart,
                onDragEnd: this.handleDragEnd
            });
        };
        _createClass$3(DragEventContainer, [
            {
                key: "pressEvent",
                get: function get() {
                    return this.containerRef.current.pressEvent;
                },
                set: function set(event) {
                    this.containerRef.current.pressEvent = event;
                }
            }
        ]);
        return DragEventContainer;
    }(_React_Component = react_default.a.Component), _DragEventContainer.contextType = ScheduleContext, _DragEventContainer;
};

function calendar_extension_assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends$3() {
    _extends$3 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$3.apply(this, arguments);
}
function calendar_extension_getPrototypeOf$3(o) {
    calendar_extension_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$3(o);
}
function calendar_extension_inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$3(subClass, superClass);
}
function _objectWithoutProperties$3(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$3(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function calendar_extension_possibleConstructorReturn$3(self, call) {
    if (call && (calendar_extension_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$3(self);
}
function calendar_extension_setPrototypeOf$3(o, p) {
    calendar_extension_setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$3(o, p);
}
var calendar_extension_typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$3(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$3(this, result);
    };
}
var calendar_extension_Grid = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$3(Grid, _React_Component);
    var _super = calendar_extension_createSuper$3(Grid);
    function Grid() {
        calendar_extension_classCallCheck$6(this, Grid);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleDragStartTime = function(offsetX, offsetY, capturePressEvent) {
            var baseTime = _this.context.baseTime;
            var day = baseTime.addDay(offsetY * 7 + offsetX);
            return capturePressEvent.startTime.set({
                year: day.year,
                month: day.month,
                date: day.monthDate
            });
        };
        _this.handleDragEndTime = function(offsetX, offsetY, capturePressEvent) {
            var baseTime = _this.context.baseTime;
            var day = baseTime.addDay(offsetY * 7 + offsetX);
            return capturePressEvent.endTime.set({
                year: day.year,
                month: day.month,
                date: day.monthDate
            });
        };
        _this.handleDragAllTime = function(offsetX, offsetY, capturePressEvent, capturePressOrigin) {
            var originX = capturePressOrigin.x, originY = capturePressOrigin.y;
            var offsetDay = offsetX - originX;
            var offsetWeek = offsetY - originY;
            return [
                capturePressEvent.startTime.addDay(offsetDay + offsetWeek * 7),
                capturePressEvent.endTime.addDay(offsetDay + offsetWeek * 7)
            ];
        };
        return _this;
    }
    var _proto = Grid.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var bindRef = this.props.bindRef;
        bindRef(this);
    };
    _proto.getOffset = function getOffset(mouseX, mouseY) {
        var containerRef = this.props.containerRef;
        var rect = containerRef.current.getBoundingClientRect();
        var left = rect.left, width = rect.width;
        var offsetX = Math.floor((mouseX - left) / (width / 7));
        var offsetY = 0;
        containerRef.current.childNodes.forEach(function(n, i) {
            var _n_getBoundingClientRect = n.getBoundingClientRect(), rowTop = _n_getBoundingClientRect.top, rowHeight = _n_getBoundingClientRect.height;
            if (mouseY > rowTop && mouseY <= rowTop + rowHeight) {
                offsetY = i;
            }
        });
        return {
            x: offsetX,
            y: offsetY
        };
    };
    _proto.render = function render() {
        var _this_props = this.props, containerRef = _this_props.containerRef, bindRef = _this_props.bindRef, rest = _objectWithoutProperties$3(_this_props, [
            "containerRef",
            "bindRef"
        ]);
        return /*#__PURE__*/ react_default.a.createElement("div", _extends$3({
            className: calendar_extension_classNamePrefix("calendar-grid"),
            ref: containerRef
        }, rest), [
            0,
            1,
            2,
            3,
            4,
            5
        ].map(function(index) {
            return /*#__PURE__*/ react_default.a.createElement(calendar_extension_Row, {
                key: index,
                index: index
            });
        }));
    };
    return Grid;
}(react_default.a.Component);
calendar_extension_Grid.contextType = ScheduleContext;
var Grid$1 = DragEventHOC(calendar_extension_Grid);

function calendar_extension_assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends$4() {
    _extends$4 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$4.apply(this, arguments);
}
function calendar_extension_getPrototypeOf$4(o) {
    calendar_extension_getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$4(o);
}
function calendar_extension_inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$4(subClass, superClass);
}
function _objectWithoutProperties$4(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$4(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function calendar_extension_possibleConstructorReturn$4(self, call) {
    if (call && (calendar_extension_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$4(self);
}
function calendar_extension_setPrototypeOf$4(o, p) {
    calendar_extension_setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$4(o, p);
}
var calendar_extension_typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$4(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$4(this, result);
    };
}
var Row$1 = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$4(Row, _React_Component);
    var _super = calendar_extension_createSuper$4(Row);
    function Row() {
        calendar_extension_classCallCheck$7(this, Row);
        var _this;
        _this = _super.apply(this, arguments);
        _this.handleDragStartTime = function(offsetX, offsetY, capturePressEvent) {
            var baseTime = _this.context.baseTime;
            var day = baseTime.addDay(offsetY * 7 + offsetX);
            return capturePressEvent.startTime.set({
                year: day.year,
                month: day.month,
                date: day.monthDate
            });
        };
        _this.handleDragEndTime = function(offsetX, offsetY, capturePressEvent) {
            var baseTime = _this.context.baseTime;
            var day = baseTime.addDay(offsetY * 7 + offsetX);
            return capturePressEvent.endTime.set({
                year: day.year,
                month: day.month,
                date: day.monthDate
            });
        };
        _this.handleDragAllTime = function(offsetX, offsetY, capturePressEvent, capturePressOrigin) {
            var originX = capturePressOrigin.x, originY = capturePressOrigin.y;
            var offsetDay = offsetX - originX;
            var offsetWeek = offsetY - originY;
            return [
                capturePressEvent.startTime.addDay(offsetDay + offsetWeek * 7),
                capturePressEvent.endTime.addDay(offsetDay + offsetWeek * 7)
            ];
        };
        return _this;
    }
    var _proto = Row.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var bindRef = this.props.bindRef;
        bindRef(this);
    };
    _proto.getOffset = function getOffset(mouseX, mouseY) {
        var containerRef = this.props.containerRef;
        var rect = containerRef.current.getBoundingClientRect();
        var left = rect.left, top = rect.top, width = rect.width;
        var offsetX = Math.floor((mouseX - left) / (width / 7));
        var offsetY = Math.floor((mouseY - top) / MONTH_CELL_HEIGHT);
        return {
            x: offsetX,
            y: offsetY
        };
    };
    _proto.render = function render() {
        var _this_props = this.props, containerRef = _this_props.containerRef, bindRef = _this_props.bindRef, rest = _objectWithoutProperties$4(_this_props, [
            "containerRef",
            "bindRef"
        ]);
        var _this_context = this.context, _this_context_schedule = _this_context.schedule, allEvents = _this_context_schedule.events, calendarDate = _this_context.calendarDate;
        var cdate = calendarDate.startOfISOWeek();
        var allDayEvents = allEvents.filter(function(event) {
            return calendarDate.isInISOWeek(event.startTime, event.endTime);
        }).filter(function(event) {
            return event.isAllDay;
        });
        var _getMonthSlotList = getMonthSlotList(allDayEvents, cdate), schedules = _getMonthSlotList.schedules, slot = _getMonthSlotList.slot;
        var eventsRender = getMonthEventRenderList(schedules, slot).map(function(param) {
            var from = param.from, laneNumber = param.laneNumber, event = param.event;
            var styles = {
                top: "".concat(26 + (WEEK_EVENT_HEIGHT + WEEK_EVENT_GAP) * laneNumber, "px"),
                left: "calc((100% - 6px) / 7 * ".concat(from, " + ").concat(from, "px)")
            };
            return /*#__PURE__*/ react_default.a.createElement(calendar_extension_Event, {
                key: event.id,
                style: styles,
                day: cdate,
                event: event
            });
        });
        var height = 27 + (WEEK_EVENT_HEIGHT + WEEK_EVENT_GAP) * schedules.length;
        var styleProps = {
            height: "".concat(height, "px"),
            minHeight: "".concat(height > 20 ? height : 20, "px")
        };
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-view-row-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", _extends$4({
            ref: containerRef,
            className: "week-view-row",
            style: styleProps
        }, rest), eventsRender, [
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ].map(function(i) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: i,
                className: "col"
            });
        })));
    };
    return Row;
}(react_default.a.Component);
Row$1.contextType = ScheduleContext;
var Row$2 = DragEventHOC(Row$1);

var Times = /*#__PURE__*/ react_default.a.forwardRef(function(props, ref) {
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "week-grid-times",
        ref: ref
    }, CalendarDate.times().map(function(t) {
        return /*#__PURE__*/ react_default.a.createElement("div", {
            key: t,
            className: "week-grid-time"
        }, t);
    }));
});

var calendar_extension_css_248z$6 = ".ct-calendar-week-event{position:absolute;border-radius:2px;border-color:transparent;border-style:solid;border-width:0 2px 2px 0}.ct-calendar-week-event .week-event-inner{height:100%;width:100%;background:#b9e1f9;border-radius:2px;border-left:2px solid #189dec;overflow:hidden;font-size:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.ct-calendar-week-event .week-event-inner .week-event-text{color:#000;height:12px;line-height:12px;white-space:nowrap;padding:4px}.ct-calendar-week-event .week-event-drag{position:absolute;width:100%;height:8px;cursor:ns-resize}.ct-calendar-week-event .drag-top{top:0}.ct-calendar-week-event .drag-bottom{bottom:0}.week-event-focus{z-index:2}.week-event-focus .week-event-inner{border-color:transparent}.week-event-focus .week-event-inner .week-event-text{color:#fff}";
calendar_extension_styleInject(calendar_extension_css_248z$6);

function calendar_extension_assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$4(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$4(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$4(Constructor, staticProps);
    return Constructor;
}
function calendar_extension_getPrototypeOf$5(o) {
    calendar_extension_getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$5(o);
}
function calendar_extension_inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$5(subClass, superClass);
}
function calendar_extension_possibleConstructorReturn$5(self, call) {
    if (call && (calendar_extension_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$5(self);
}
function calendar_extension_setPrototypeOf$5(o, p) {
    calendar_extension_setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$5(o, p);
}
var calendar_extension_typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$5(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$5(this, result);
    };
}
var WEEK_GRID_CLASS$1 = ".".concat(calendar_extension_classNamePrefix("calendar-week-grid"));
var calendar_extension_WeekEvent = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$5(WeekEvent, _React_Component);
    var _super = calendar_extension_createSuper$5(WeekEvent);
    function WeekEvent() {
        calendar_extension_classCallCheck$8(this, WeekEvent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.ref = /*#__PURE__*/ react_default.a.createRef();
        _this.handleMouseEnter = function() {
            var event = _this.props.event;
            if (!_this.hasPressEvent) {
                event.hover = true;
            }
        };
        _this.handleMouseLeave = function() {
            var event = _this.props.event;
            if (!_this.hasPressEvent) {
                event.hover = false;
            }
        };
        _this.handlePressEvent = function(e, pressType) {
            if (pressType !== PRESS_TYPE.CENTER) {
                e.preventDefault();
            }
            var event = _this.props.event;
            event.pressType = pressType;
            _this.ref.current.closest(WEEK_GRID_CLASS$1).pressEvent = event;
        };
        return _this;
    }
    var _proto = WeekEvent.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, event = _this_props.event, style = _this_props.style, index = _this_props.index, from = _this_props.from, to = _this_props.to;
        var _this_context = this.context, baseTime = _this_context.baseTime, editable = _this_context.editable;
        var head = from !== 0 || event.startTime.diffMinutes(baseTime) / 30 === index * 48;
        var tail = to !== 48 || event.endTime.diffMinutes(baseTime) / 30 === (index + 1) * 48;
        var isFocus =  (event.press || event.hover || event.focus);
        var innerStyle = {
            background: isFocus ? calendar_extension_colors["".concat(event.statusString, "Focus")] : calendar_extension_colors[event.statusString],
            borderLeftColor: calendar_extension_colors["".concat(event.statusString, "Focus")],
            opacity:  "1",
            borderTopLeftRadius: head ? "" : "0",
            borderTopRightRadius: head ? "" : "0",
            borderBottomLeftRadius: tail ? "" : "0",
            borderBottomRightRadius: tail ? "" : "0",
            boxShadow: isFocus ? "0 5px 10px 0 rgba(106,93,73,0.50)" : ""
        };
        return /*#__PURE__*/ react_default.a.createElement("div", {
            ref: this.ref,
            className: classnames_default()(calendar_extension_classNamePrefix("calendar-week-event"), {
                "week-event-focus": isFocus
            }),
            style: style,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            draggable: editable
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-event-inner",
            style: innerStyle,
            onMouseDown: function(e) {
                _this.handlePressEvent(e, PRESS_TYPE.CENTER);
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-event-text"
        }, event.name), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-event-text"
        }, timeFromEvent(event))), editable && head && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-event-drag drag-top",
            onMouseDown: function(e) {
                return _this.handlePressEvent(e, PRESS_TYPE.START);
            }
        }), editable && tail && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-event-drag drag-bottom",
            onMouseDown: function(e) {
                return _this.handlePressEvent(e, PRESS_TYPE.END);
            }
        }));
    };
    _createClass$4(WeekEvent, [
        {
            key: "hasPressEvent",
            get: function get() {
                return !!this.ref.current.closest(WEEK_GRID_CLASS$1).pressEvent;
            }
        }
    ]);
    return WeekEvent;
}(react_default.a.Component);
calendar_extension_WeekEvent.contextType = ScheduleContext;

function calendar_extension_assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_getPrototypeOf$6(o) {
    calendar_extension_getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$6(o);
}
function calendar_extension_inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$6(subClass, superClass);
}
function calendar_extension_possibleConstructorReturn$6(self, call) {
    if (call && (calendar_extension_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$6(self);
}
function calendar_extension_setPrototypeOf$6(o, p) {
    calendar_extension_setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$6(o, p);
}
var calendar_extension_typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$6(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$6(this, result);
    };
}
var Col$1 = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$6(Col, _React_Component);
    var _super = calendar_extension_createSuper$6(Col);
    function Col() {
        calendar_extension_classCallCheck$9(this, Col);
        var _this;
        _this = _super.apply(this, arguments);
        _this.colRef = /*#__PURE__*/ react_default.a.createRef();
        _this.createEvent = function(startTime, endTime, param) {
            var x = param.x, y = param.y;
            var _this_context = _this.context, setEditingEvent = _this_context.setEditingEvent, projectId = _this_context.projectId, provider = _this_context.provider, eventHandler = _this_context.eventHandler, proxyEvent = _this_context.proxyEvent;
            var event = proxyEvent(CalendarEvent.createByTimeSlot(startTime, endTime, {
                mouseX: x,
                mouseY: y,
                projectId: projectId,
                provider: provider,
                eventHandler: eventHandler
            }));
            event.add().then(function() {
                setEditingEvent(event);
            });
        };
        _this.handleMouseDown = function(param) {
            var x = param.clientX, y = param.clientY;
            var baseTime = _this.context.baseTime;
            var _this_colRef_current_getBoundingClientRect = _this.colRef.current.getBoundingClientRect(), top = _this_colRef_current_getBoundingClientRect.top, height = _this_colRef_current_getBoundingClientRect.height;
            var index = _this.props.index;
            var day = baseTime.addDay(index).set({
                hours: 0,
                minutes: 0
            });
            var startTime = day.addMinute(Math.floor((y - top - 9) * 48 / (height - 9)) * 30);
            var endTime = startTime.addHour(1);
            if (startTime.hour === 23 && startTime.minute === 30) {
                endTime = startTime.addMinute(30);
            }
            _this.createEvent(startTime, endTime, {
                x: x,
                y: y
            });
        };
        return _this;
    }
    var _proto = Col.prototype;
    _proto.render = function render() {
        var baseTime = this.context.baseTime;
        var _this_props = this.props, allEvents = _this_props.allEvents, index = _this_props.index;
        if (allEvents.length === 0) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                ref: this.colRef,
                className: calendar_extension_classNamePrefix("calendar-week-grid-col"),
                onClick: this.handleMouseDown
            });
        }
        var day = new CalendarDate(baseTime).addDay(index);
        var events = allEvents.filter(function(event) {
            return day.isInDay(event.startTime, event.endTime);
        });
        var _getWeekSlotList = getWeekSlotList(events, day), schedules = _getWeekSlotList.schedules, slot = _getWeekSlotList.slot;
        var eventsRender = getWeekEventRenderList(schedules, slot);
        var eventsWithStyle = eventsRender.map(function(e) {
            return computeStyle(e);
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            ref: this.colRef,
            className: calendar_extension_classNamePrefix("calendar-week-grid-col")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "background",
            onClick: this.handleMouseDown
        }), eventsWithStyle.map(function(param, idx) {
            var event = param.event, from = param.from, to = param.to, top = param.top, height = param.height, left = param.left, width = param.width;
            return /*#__PURE__*/ react_default.a.createElement(calendar_extension_WeekEvent, {
                key: event.id,
                index: idx,
                event: event,
                from: from,
                to: to,
                style: {
                    top: top,
                    height: height,
                    left: left,
                    width: width
                }
            });
        }));
    };
    return Col;
}(react_default.a.Component);
Col$1.contextType = ScheduleContext;

var calendar_extension_css_248z$7 = ".ct-calendar-week-grid{position:relative;height:699px;overflow-y:scroll}.ct-calendar-week-grid::-webkit-scrollbar{display:none}.ct-calendar-week-grid .week-grid-inner{position:absolute;height:1368px;width:100%;display:flex}.ct-calendar-week-grid .week-grid-inner .week-grid-times{flex-grow:0;width:45px;display:flex;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-calendar-week-grid .week-grid-inner .week-grid-times .week-grid-time{flex-grow:1;font-size:12px;text-align:center;padding-top:1px}.ct-calendar-week-grid .week-grid-inner .week-grid-grid{flex-grow:1;display:flex;border-left:1px solid #ddd;position:relative;height:1377px}.ct-calendar-week-grid .week-grid-inner .week-grid-grid .week-grid-row{position:absolute;width:100%;height:1px;border-top:1px solid #ddd}.ct-calendar-week-grid .week-grid-inner .week-grid-grid .ct-calendar-week-grid-col{flex:1;box-sizing:border-box;border-right:1px solid #ddd;position:relative}.ct-calendar-week-grid .week-grid-inner .week-grid-grid .ct-calendar-week-grid-col:last-child{border:0}.ct-calendar-week-grid .week-grid-inner .week-grid-grid .ct-calendar-week-grid-col .background{position:absolute;top:0;right:0;bottom:0;left:0}";
calendar_extension_styleInject(calendar_extension_css_248z$7);

function calendar_extension_assertThisInitialized$7(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$5(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$5(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$5(Constructor, staticProps);
    return Constructor;
}
function _extends$5() {
    _extends$5 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$5.apply(this, arguments);
}
function calendar_extension_getPrototypeOf$7(o) {
    calendar_extension_getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$7(o);
}
function calendar_extension_inherits$7(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$7(subClass, superClass);
}
function _objectWithoutProperties$5(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$5(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$5(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function calendar_extension_possibleConstructorReturn$7(self, call) {
    if (call && (calendar_extension_typeof$7(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$7(self);
}
function calendar_extension_setPrototypeOf$7(o, p) {
    calendar_extension_setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$7(o, p);
}
var calendar_extension_typeof$7 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$7(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$7(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$7(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$7(this, result);
    };
}
var calendar_extension_WeekGrid = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$7(WeekGrid, _React_Component);
    var _super = calendar_extension_createSuper$7(WeekGrid);
    function WeekGrid() {
        calendar_extension_classCallCheck$a(this, WeekGrid);
        var _this;
        _this = _super.apply(this, arguments);
        _this.timesRef = /*#__PURE__*/ react_default.a.createRef();
        _this.handleDragStartTime = function(offsetX, offsetY, capturePressEvent) {
            var offsetDay = offsetX - capturePressEvent.startTime.isoWeekday + 1;
            return capturePressEvent.startTime.addDay(offsetDay).set({
                hours: offsetY,
                minutes: (offsetY - Math.floor(offsetY)) * 60
            });
        };
        _this.handleDragEndTime = function(offsetX, offsetY, capturePressEvent) {
            var offsetDay = offsetX - capturePressEvent.endTime.isoWeekday + 1;
            return capturePressEvent.endTime.addDay(offsetDay).set({
                hours: offsetY,
                minutes: (offsetY - Math.floor(offsetY)) * 60
            });
        };
        _this.handleDragAllTime = function(offsetX, offsetY, capturePressEvent, capturePressOrigin) {
            var originX = capturePressOrigin.x, originY = capturePressOrigin.y;
            var offsetDay = offsetX - originX;
            var offsetHour = offsetY - originY;
            var offsetMinute = Math.sign(offsetHour) * (Math.abs(offsetHour) - Math.floor(Math.abs(offsetHour))) * 60;
            return [
                capturePressEvent.startTime.addDay(offsetDay).addHour(offsetHour).addMinute(offsetMinute),
                capturePressEvent.endTime.addDay(offsetDay).addHour(offsetHour).addMinute(offsetMinute)
            ];
        };
        return _this;
    }
    var _proto = WeekGrid.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this_props = this.props, containerRef = _this_props.containerRef, bindRef = _this_props.bindRef;
        bindRef(this);
        // 将日程视图scroll到8:00开始，方便用户查看工作时间的日程
        containerRef.current.scrollTop = 458;
        this.timesRect = this.timesRef.current.getBoundingClientRect();
    };
    _proto.getOffset = function getOffset(mouseX, mouseY) {
        var containerRef = this.props.containerRef;
        var scrollTop = containerRef.current.scrollTop;
        var _containerRef_current_getBoundingClientRect = containerRef.current.getBoundingClientRect(), left = _containerRef_current_getBoundingClientRect.left, top = _containerRef_current_getBoundingClientRect.top, width = _containerRef_current_getBoundingClientRect.width;
        var _this_timesRect = this.timesRect, timesWidth = _this_timesRect.width;
        var offsetX = Math.floor((mouseX - left - timesWidth) / (width / 7));
        var offsetY = Math.round((scrollTop + mouseY - top - WEEK_CELL_TOP_GAP) / (WEEK_CELL_HEIGHT * 0.5)) * 0.5;
        return {
            x: offsetX,
            y: offsetY
        };
    };
    _proto.render = function render() {
        var _this_context = this.context, _this_context_schedule = _this_context.schedule, allEvents = _this_context_schedule.events, calendarDate = _this_context.calendarDate;
        var _this_props = this.props, containerRef = _this_props.containerRef, bindRef = _this_props.bindRef, rest = _objectWithoutProperties$5(_this_props, [
            "containerRef",
            "bindRef"
        ]);
        var events = allEvents.filter(function(event) {
            return calendarDate.isInISOWeek(event.startTime, event.endTime);
        }).filter(function(event) {
            return !event.isAllDay;
        });
        return /*#__PURE__*/ react_default.a.createElement("div", _extends$5({
            ref: containerRef,
            className: calendar_extension_classNamePrefix("calendar-week-grid")
        }, rest), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-grid-inner"
        }, /*#__PURE__*/ react_default.a.createElement(Times, {
            ref: this.timesRef
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "week-grid-grid"
        }, // 创建日程横向分割线
        makeList(24, function(i) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: i,
                className: "week-grid-row",
                style: {
                    top: "".concat(WEEK_CELL_TOP_GAP + WEEK_CELL_HEIGHT * i, "px")
                }
            });
        }), // 创建日程纵向列
        makeList(7, function(i) {
            return /*#__PURE__*/ react_default.a.createElement(Col$1, {
                key: i,
                index: i,
                allEvents: events
            });
        }))));
    };
    _createClass$5(WeekGrid, [
        {
            key: "pressEvent",
            get: function get() {
                var containerRef = this.props.containerRef;
                return containerRef.current.pressEvent;
            },
            set: function set(event) {
                var containerRef = this.props.containerRef;
                containerRef.current.pressEvent = event;
            }
        }
    ]);
    return WeekGrid;
}(react_default.a.Component);
calendar_extension_WeekGrid.contextType = ScheduleContext;
var WeekGrid$1 = DragEventHOC(calendar_extension_WeekGrid); /* eslint-enable no-bitwise */

var calendar_extension_css_248z$8 = ".ct-calendar-week-view{background:#fff;display:flex;flex-direction:column}.ct-calendar-week-view .week-view-allday{display:flex;border-bottom:1px solid #ddd;min-height:24px}.ct-calendar-week-view .week-view-allday .side{flex-grow:0;width:45px;text-align:right;line-height:12px;font-size:12px;color:#333;padding:8px 11px 4px 0}.ct-calendar-week-view .week-view-allday .week-view-row-wrapper{position:relative;max-height:96px;overflow:auto;display:flex;flex-grow:1}.ct-calendar-week-view .week-view-allday .week-view-row-wrapper::-webkit-scrollbar{display:none}.ct-calendar-week-view .week-view-allday .week-view-row-wrapper .week-view-row{width:100%;position:relative;display:flex;flex-grow:1;flex-direction:row;margin-top:-22px;border-left:1px solid #ddd}.ct-calendar-week-view .week-view-allday .week-view-row-wrapper .week-view-row .col{border-right:1px solid #ddd;flex:1}.ct-calendar-week-view .week-view-allday .week-view-row-wrapper .week-view-row .col:last-child{border:0}";
calendar_extension_styleInject(calendar_extension_css_248z$8);

var WeekView = function() {
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: calendar_extension_classNamePrefix("calendar-week-view")
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "week-view-allday"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "side"
    }, "全天"), /*#__PURE__*/ react_default.a.createElement(Row$2, null)), /*#__PURE__*/ react_default.a.createElement(WeekGrid$1, null));
};

var calendar_extension_css_248z$9 = '.ct-calendar-loading-failed{display:flex;position:absolute;top:0;bottom:0;left:0;right:0;z-index:9;white-space:nowrap;background:hsla(0,0%,100%,.9);overflow:hidden;border:1px solid #ddd}.ct-calendar-loading-failed .container{display:flex;flex:1;flex-direction:row;align-items:center;justify-content:center;font-size:14px}.ct-calendar-loading-failed .message{display:flex;flex-direction:row;color:#333}.ct-calendar-loading-failed .message .icon{width:16px;height:16px;background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221520238195682%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%224919%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2220%22 height%3D%2220%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0zM204.8 512c0 42.688 34.304 76.8 76.544 76.8h461.312c41.728 0 76.544-34.368 76.544-76.8 0-42.688-34.304-76.8-76.544-76.8H281.344C239.616 435.2 204.8 469.568 204.8 512z%22 fill%3D%22%23F05E50%22 p-id%3D%224920%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E");background-size:contain;align-self:center;margin-right:8px}';
calendar_extension_styleInject(calendar_extension_css_248z$9);

var Error$1 = function(param) {
    var error = param.error;
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: calendar_extension_classNamePrefix("calendar-loading-failed")
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "message"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "icon"
    }), /*#__PURE__*/ react_default.a.createElement("div", null, error))));
};

var calendar_extension_img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com --%3e %3ctitle%3eellipsis%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='ellipsis' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e5%8f%82%e8%80%83%e7%ba%bf' opacity='0'%3e %3cg%3e %3crect id='%e7%9f%a9%e5%bd%a2' fill='white' fill-rule='nonzero' x='0' y='0' width='48' height='48'%3e%3c/rect%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' cx='24' cy='24' r='19.9'%3e%3c/circle%3e %3ccircle id='%e6%a4%ad%e5%9c%86%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' cx='24' cy='24' r='9.9'%3e%3c/circle%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='6.1' y='6.1' width='35.8' height='35.8' rx='2'%3e%3c/rect%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='8.1' y='4.1' width='31.8' height='39.8' rx='2'%3e%3c/rect%3e %3crect id='%e7%9f%a9%e5%bd%a2' stroke='%23003CFF' stroke-width='0.2' opacity='0.600000024' fill-rule='nonzero' x='4.1' y='8.1' width='39.8' height='31.8' rx='2'%3e%3c/rect%3e %3c/g%3e %3c/g%3e %3cpath d='M11%2c21 C12.6568542%2c21 14%2c22.3431458 14%2c24 C14%2c25.6568542 12.6568542%2c27 11%2c27 C9.34314575%2c27 8%2c25.6568542 8%2c24 C8%2c22.3431458 9.34314575%2c21 11%2c21 Z M24%2c21 C25.6568542%2c21 27%2c22.3431458 27%2c24 C27%2c25.6568542 25.6568542%2c27 24%2c27 C22.3431458%2c27 21%2c25.6568542 21%2c24 C21%2c22.3431458 22.3431458%2c21 24%2c21 Z M37%2c21 C38.6568542%2c21 40%2c22.3431458 40%2c24 C40%2c25.6568542 38.6568542%2c27 37%2c27 C35.3431458%2c27 34%2c25.6568542 34%2c24 C34%2c22.3431458 35.3431458%2c21 37%2c21 Z' id='%e5%bd%a2%e7%8a%b6' fill='black' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e%3c/svg%3e";

function calendar_extension_assertThisInitialized$8(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$b(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_getPrototypeOf$8(o) {
    calendar_extension_getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$8(o);
}
function calendar_extension_inherits$8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$8(subClass, superClass);
}
function calendar_extension_possibleConstructorReturn$8(self, call) {
    if (call && (calendar_extension_typeof$8(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$8(self);
}
function calendar_extension_setPrototypeOf$8(o, p) {
    calendar_extension_setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$8(o, p);
}
var calendar_extension_typeof$8 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_isNativeReflectConstruct$8() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$8(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$8();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$8(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$8(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$8(this, result);
    };
}
var focusColors = Object.values(calendar_extension_colors).filter(function(color, index) {
    return index % 2 === 1;
});
var colorsLess = colorsLessMark.map(function(m) {
    return calendar_extension_colors["s".concat(m, "Focus")];
});
var calendar_extension_ColorList = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$8(ColorList, _React_Component);
    var _super = calendar_extension_createSuper$8(ColorList);
    function ColorList(props) {
        calendar_extension_classCallCheck$b(this, ColorList);
        var _this;
        _this = _super.call(this, props);
        _this.handleClick = function(e) {
            e.stopPropagation();
            _this.setState({
                expand: true
            });
        };
        _this.state = {
            expand: !colorsLess.includes(props.selected)
        };
        return _this;
    }
    var _proto = ColorList.prototype;
    _proto.render = function render() {
        var _this_props = this.props, selected = _this_props.selected, onChange = _this_props.onChange;
        var expand = this.state.expand;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "color-list ".concat(expand ? "more" : "less")
        }, (expand ? focusColors : colorsLess).map(function(color) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: color,
                className: "color-outline".concat(selected === color ? " selected" : ""),
                onClick: function() {
                    return onChange(color);
                }
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "color",
                style: {
                    background: color
                }
            }));
        }), !expand && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "color-outline color-list-more-btn",
            onClick: this.handleClick
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: calendar_extension_img$4,
            alt: ""
        })));
    };
    return ColorList;
}(react_default.a.Component);

var calendar_extension_img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1535702789864' class='icon' style='' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3546' xmlns:xlink='http://www.w3.org/1999/xlink' width='6' height='6'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M997.413 420.228c26.005-27.602 33.706-68.79 19.667-104.865-14.039-35.982-47.107-59.364-83.714-59.364H90.588c-36.592 0-69.66 23.474-83.699 59.364A101.82 101.82 0 0 0 0 352.207c0 25.015 9.239 49.644 26.541 68.02l421.44 447.584c17.027 18.083 40.044 28.188 64.047 28.188s47.107-10.197 64.047-28.188l421.338-447.584z' fill='%23aeaeae' p-id='3547'%3e%3c/path%3e%3c/svg%3e";

var calendar_extension_css_248z$a = ".ct-calendar-colorpicker{border-radius:2px;border:1px solid transparent;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;overflow:visible;padding:7px;position:relative}.ct-calendar-colorpicker:hover{border:1px solid #ccc}.ct-calendar-colorpicker .selected{align-items:center;cursor:pointer;display:flex;flex-flow:row}.ct-calendar-colorpicker .selected .selected-color{border-radius:2px;height:14px;width:14px}.ct-calendar-colorpicker .selected .icon{display:flex;margin:0 4px}.ct-calendar-colorpicker .helper{bottom:0;left:0;position:fixed;right:0;top:0;z-index:18}.ct-calendar-colorpicker .color-list{align-items:center;background:#fff;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);display:flex;flex-direction:row;height:38px;left:-1px;padding:0 4px;position:absolute;top:24px;width:164px;z-index:19}.ct-calendar-colorpicker .color-list .color-outline{align-items:center;border-radius:2px;box-sizing:border-box;cursor:pointer;display:flex;height:26px;justify-content:center;position:relative;width:26px;z-index:20}.ct-calendar-colorpicker .color-list .color-outline:hover{border:1px solid #ccc}.ct-calendar-colorpicker .color-list .color-outline .color{border-radius:2px;height:14px;width:14px}.ct-calendar-colorpicker .color-list .color-outline.selected{border:1px solid #ccc}.ct-calendar-colorpicker .color-list .color-list-more-btn:hover{border:0}.ct-calendar-colorpicker .color-list .color-list-more-btn img{width:16px}.ct-calendar-colorpicker .color-list.more{flex-direction:column;flex-wrap:wrap;height:98px}.ct-calendar-colorpicker .color-list.more .color-outline{margin-top:4px}";
calendar_extension_styleInject(calendar_extension_css_248z$a);

function calendar_extension_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function calendar_extension_arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function calendar_extension_assertThisInitialized$9(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$c(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends$6() {
    _extends$6 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$6.apply(this, arguments);
}
function calendar_extension_getPrototypeOf$9(o) {
    calendar_extension_getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return calendar_extension_getPrototypeOf$9(o);
}
function calendar_extension_inherits$9(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) calendar_extension_setPrototypeOf$9(subClass, superClass);
}
function calendar_extension_iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function calendar_extension_nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function calendar_extension_possibleConstructorReturn$9(self, call) {
    if (call && (calendar_extension_typeof$9(call) === "object" || typeof call === "function")) {
        return call;
    }
    return calendar_extension_assertThisInitialized$9(self);
}
function calendar_extension_setPrototypeOf$9(o, p) {
    calendar_extension_setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return calendar_extension_setPrototypeOf$9(o, p);
}
function calendar_extension_slicedToArray$2(arr, i) {
    return calendar_extension_arrayWithHoles$2(arr) || calendar_extension_iterableToArrayLimit$2(arr, i) || calendar_extension_unsupportedIterableToArray$2(arr, i) || calendar_extension_nonIterableRest$2();
}
var calendar_extension_typeof$9 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return calendar_extension_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return calendar_extension_arrayLikeToArray$2(o, minLen);
}
function calendar_extension_isNativeReflectConstruct$9() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function calendar_extension_createSuper$9(Derived) {
    var hasNativeReflectConstruct = calendar_extension_isNativeReflectConstruct$9();
    return function _createSuperInternal() {
        var Super = calendar_extension_getPrototypeOf$9(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = calendar_extension_getPrototypeOf$9(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return calendar_extension_possibleConstructorReturn$9(this, result);
    };
}
var findStatusByColor = function(color) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(calendar_extension_colors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = calendar_extension_slicedToArray$2(_step.value, 2), k = _step_value[0], v = _step_value[1];
            if (v === color) {
                return k.split("Focus")[0];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "s1";
};
var calendar_extension_ColorPicker = /*#__PURE__*/ function(_React_Component) {
    calendar_extension_inherits$9(ColorPicker, _React_Component);
    var _super = calendar_extension_createSuper$9(ColorPicker);
    function ColorPicker(props) {
        calendar_extension_classCallCheck$c(this, ColorPicker);
        var _this;
        _this = _super.call(this, props);
        _this.changeColor = function(color) {
            var onChange = _this.props.onChange;
            _this.setState({
                selectedColor: color,
                isShowList: false
            });
            onChange(findStatusByColor(color));
        };
        _this.open = function() {
            _this.setState({
                isShowList: true
            });
        };
        _this.close = function() {
            _this.setState({
                isShowList: false
            });
        };
        _this.state = {
            selectedColor: calendar_extension_colors[props.selected],
            isShowList: false
        };
        return _this;
    }
    var _proto = ColorPicker.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, selectedColor = _this_state.selectedColor, isShowList = _this_state.isShowList;
        var props = {
            style: {
                borderColor: isShowList ? "#cccccc" : ""
            }
        };
        return /*#__PURE__*/ react_default.a.createElement("div", _extends$6({
            className: calendar_extension_classNamePrefix("calendar-colorpicker"),
            onClick: function() {
                if (isShowList) {
                    _this.close();
                } else {
                    _this.open();
                }
            }
        }, props), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "selected"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "selected-color",
            style: {
                background: selectedColor
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "icon"
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: calendar_extension_img$5,
            alt: ""
        }))), isShowList && /*#__PURE__*/ react_default.a.createElement(calendar_extension_ColorList, {
            selected: selectedColor,
            onChange: function(color) {
                return _this.changeColor(color);
            }
        }), isShowList && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "helper",
            onClick: this.close
        }));
    };
    return ColorPicker;
}(react_default.a.Component);

function _assertThisInitialized$a(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function calendar_extension_classCallCheck$d(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends$7() {
    _extends$7 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$7.apply(this, arguments);
}
function _getPrototypeOf$a(o) {
    _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$a(o);
}
function _inherits$a(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$a(subClass, superClass);
}
function _objectWithoutProperties$6(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$6(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn$a(self, call) {
    if (call && (_typeof$a(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$a(self);
}
function _setPrototypeOf$a(o, p) {
    _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$a(o, p);
}
var _typeof$a = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$a() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$a(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$a(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$a(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$a(this, result);
    };
}
var calendar_extension_List = /*#__PURE__*/ function(_React_Component) {
    _inherits$a(List, _React_Component);
    var _super = _createSuper$a(List);
    function List() {
        calendar_extension_classCallCheck$d(this, List);
        var _this;
        _this = _super.apply(this, arguments);
        _this.list = /*#__PURE__*/ react_default.a.createRef();
        return _this;
    }
    var _proto = List.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var value = this.props.value;
        var n = value.hour * 2 + (value.minute === 0 ? 0 : 1);
        this.list.current.scrollTop = n * 29;
    };
    _proto.render = function render() {
        var _this_props = this.props, times = _this_props.times, props = _objectWithoutProperties$6(_this_props, [
            "times"
        ]);
        return /*#__PURE__*/ react_default.a.createElement("div", _extends$7({
            ref: this.list
        }, props), times);
    };
    return List;
}(react_default.a.Component);

var getTimes = function(day) {
    var start = day.set({
        hours: 0,
        minute: 0
    });
    var res = [];
    for(var i = 0; i < 48; i++){
        res.push(start.addMinute(30 * i));
    }
    return res;
};
var getStyles = function(time, start, value) {
    var isSame = time.isSameMinute(value);
    var isBefore = start && time.isBeforeMinute(start);
    return {
        background: isSame ? "#f8f8f8" : "",
        opacity: isBefore ? ".5" : "1",
        pointerEvents: isBefore ? "none" : "all"
    };
};

var calendar_extension_css_248z$b = ".ct-calendar-timepicker{color:#333;font-size:12px;margin:0 4px;position:relative}.ct-calendar-timepicker input{border-radius:2px;border:1px solid transparent;height:24px;outline:none;text-align:center;transition:all .3s;width:48px}.ct-calendar-timepicker input:hover{border-color:#ddd}.ct-calendar-timepicker .time-list{background:#fff;border-radius:2px;border:1px solid #ddd;box-shadow:0 2px 4px 0 rgba(0,0,0,.14);max-height:180px;overflow-x:hidden;overflow-y:auto;position:absolute;top:27px;width:64px;z-index:3}.ct-calendar-timepicker .time-list .time{align-items:center;justify-content:center;cursor:pointer;display:flex;font-size:12px;height:29px;width:calc(100% + 3px)}.ct-calendar-timepicker .time-list .time:hover{background:#f8f8f8}.ct-calendar-timepicker .time-list ::-webkit-scrollbar{width:0}";
calendar_extension_styleInject(calendar_extension_css_248z$b);

function _assertThisInitialized$b(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$e(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$b(o) {
    _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$b(o);
}
function _inherits$b(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$b(subClass, superClass);
}
function _possibleConstructorReturn$b(self, call) {
    if (call && (_typeof$b(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$b(self);
}
function _setPrototypeOf$b(o, p) {
    _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$b(o, p);
}
var _typeof$b = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$b() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$b(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$b();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$b(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$b(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$b(this, result);
    };
}
var calendar_extension_TimePicker = /*#__PURE__*/ function(_React_Component) {
    _inherits$b(TimePicker, _React_Component);
    var _super = _createSuper$b(TimePicker);
    function TimePicker(props) {
        _classCallCheck$e(this, TimePicker);
        var _this;
        _this = _super.call(this, props);
        _this.handleSelect = function(time) {
            var onChange = _this.props.onChange;
            onChange === null || onChange === void 0 ? void 0 : onChange(time);
        };
        _this.showList = function() {
            _this.setState({
                isShowList: true
            });
        };
        _this.hideList = function() {
            _this.setState({
                isShowList: null
            });
        };
        _this.state = {
            isShowList: false
        };
        _this.list = /*#__PURE__*/ react_default.a.createRef();
        _this.input = /*#__PURE__*/ react_default.a.createRef();
        return _this;
    }
    var _proto = TimePicker.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, start = _this_props.start, value = _this_props.value;
        var isShowList = this.state.isShowList;
        var times = getTimes(value).map(function(time) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                key: time.format("HHmm"),
                className: "time",
                onMouseDown: function() {
                    _this.handleSelect(time);
                },
                style: getStyles(time, start, value)
            }, time.format("HH:mm"));
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            ref: this.input,
            className: calendar_extension_classNamePrefix("calendar-timepicker")
        }, /*#__PURE__*/ react_default.a.createElement("input", {
            readOnly: true,
            value: value.format("HH:mm"),
            onFocus: this.showList,
            onBlur: this.hideList,
            style: {
                borderColor: isShowList ? "#1c6cdc" : ""
            }
        }), isShowList && /*#__PURE__*/ react_default.a.createElement(calendar_extension_List, {
            className: "time-list",
            // style={{ top: showList }}
            value: value,
            times: times
        }));
    };
    return TimePicker;
}(react_default.a.Component);

var calendar_extension_css_248z$c = '.ct-calendar-input{border-radius:2px;border:1px solid transparent;display:flex;max-height:120px;overflow:hidden;position:relative;width:100%}.ct-calendar-input .calendar-input-trick{font-size:16px!important;opacity:0;pointer-events:none;position:absolute;word-break:break-all;z-index:-1}.ct-calendar-input .calendar-input-trick.large{padding:4px 0 6px;width:100%}.ct-calendar-input .calendar-input-trick.medium{padding:4px 9px 6px;width:100%}.ct-calendar-input .calendar-input-trick.small{padding:4px 9px 6px;width:calc(100% - 36px)}.ct-calendar-input .calendar-input-visible{height:100%;max-height:120px;position:absolute;width:100%;z-index:1}.ct-calendar-input .calendar-input-visible .ant-input{box-sizing:border-box;margin:0;font-variant:tabular-nums;list-style:none;font-feature-settings:"tnum";position:relative;display:inline-block;width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s}.ct-calendar-input .calendar-input-visible .rc-textarea{border-radius:2px;border:1px solid transparent;box-shadow:none;font-size:16px!important;height:100%!important;max-height:85px;outline:none;padding:4px 0 6px;resize:none;text-align:justify;transition:none;word-break:break-all}.ct-calendar-input .calendar-input-visible .rc-textarea ::-webkit-scrollbar{width:7px}.ct-calendar-input .calendar-input-visible .rc-textarea ::-webkit-scrollbar-track{border-radius:100px}.ct-calendar-input .calendar-input-visible .rc-textarea ::-webkit-scrollbar-thumb{background-clip:padding-box;background:rgba(0,0,0,.1);border-radius:100px;border:2px solid transparent}.ct-calendar-input .calendar-input-visible .rc-textarea :focus,.ct-calendar-input .calendar-input-visible .rc-textarea :hover{border-color:#1c6cdc!important}.ct-calendar-input .calendar-input-visible .ant-input-disabled{background:transparent;color:#333;cursor:text}.ct-calendar-input .calendar-input-visible.need-padding .ant-input{padding:4px 9px 6px}.ct-calendar-input .input-rows{align-items:center;bottom:-2px;color:#aaa;display:flex;font-size:12px;height:36px;line-height:36px;padding:0 8px;position:absolute;right:0;z-index:3}';
calendar_extension_styleInject(calendar_extension_css_248z$c);

function _assertThisInitialized$c(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$f(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$c(o) {
    _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$c(o);
}
function _inherits$c(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$c(subClass, superClass);
}
function _possibleConstructorReturn$c(self, call) {
    if (call && (_typeof$c(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$c(self);
}
function _setPrototypeOf$c(o, p) {
    _setPrototypeOf$c = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$c(o, p);
}
var _typeof$c = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$c() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$c(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$c();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$c(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$c(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$c(this, result);
    };
}
var calendar_extension_Input = /*#__PURE__*/ function(_React_Component) {
    _inherits$c(Input, _React_Component);
    var _super = _createSuper$c(Input);
    function Input(props) {
        _classCallCheck$f(this, Input);
        var _this;
        _this = _super.call(this, props);
        _this.hiddenLargeId = "".concat(Math.random());
        _this.hiddenMediumId = "".concat(Math.random());
        _this.hiddenSmallId = "".concat(Math.random());
        _this.hiddenLargeDom = null;
        _this.hiddenMediumDom = null;
        _this.hiddenSmallDom = null;
        _this.timer = null;
        _this.toastrTimer = null;
        _this.handlePressEnter = function(e) {
            e.preventDefault();
        };
        _this.handleTextChange = function(e) {
            var _this_props = _this.props, onChange = _this_props.onChange, editor = _this_props.editor;
            var value = e.target.value;
            _this.setState({
                value: value
            });
            if (_this.timer !== null) clearTimeout(_this.timer);
            _this.timer = setTimeout(function() {
                if (value.length <= TITLE_MAX_LENGTH) {
                    editor.warn = "";
                    onChange(value || "新建事件");
                }
                _this.timer = null;
            }, 500);
            _this.adjustSizeWithContent();
        };
        _this.handleFocus = function() {
            var editable = _this.context.editable;
            if (!editable) {
                return;
            }
            _this.setState({
                isFocus: true
            });
            _this.adjustSizeWithContent();
        };
        _this.handleBlur = function(e) {
            var editor = _this.props.editor;
            var _this_context = _this.context, provider = _this_context.provider, editingEvent = _this_context.editingEvent;
            if (e.target.value.length > TITLE_MAX_LENGTH) {
                e.preventDefault();
                e.target.focus();
                editor.warn = "事件名过长";
                if (_this.toastrTimer === null) {
                    provider.handleError(new Error("事件名过长"));
                    // 延时500ms进行异常提示，防止过于频繁的提示
                    _this.toastrTimer = setTimeout(function() {
                        _this.toastrTimer = null;
                    }, 500);
                }
            } else {
                if (e.target.value === "") {
                    _this.setState({
                        value: "新建事件"
                    });
                }
                _this.setState({
                    isFocus: false
                });
                _this.adjustSizeWithContent();
                editingEvent.isNew = false;
            }
        };
        _this.handleMouseEnter = function() {
            _this.setState({
                isHover: true
            });
            _this.adjustSizeWithContent();
        };
        _this.handleMouseLeave = function() {
            _this.setState({
                isHover: false
            });
            _this.adjustSizeWithContent();
        };
        _this.adjustSizeWithContent = function() {
            var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            setTimeout(function() {
                var _this_state = _this.state, isFocus = _this_state.isFocus, isHover = _this_state.isHover;
                var lt = _this.hiddenLargeDom.getBoundingClientRect();
                var mt = _this.hiddenMediumDom.getBoundingClientRect();
                var st = _this.hiddenSmallDom.getBoundingClientRect();
                var ltRows = Math.floor(lt.height / 24);
                var mtRows = Math.floor(mt.height / 24);
                var stRows = Math.floor(st.height / 24);
                var rowState = {
                    rows: mtRows,
                    nextRow: true
                };
                if (stRows < 2) {
                    rowState.nextRow = false;
                }
                if (!isFocus && !isHover) {
                    rowState.rows = ltRows;
                }
                _this.setState(rowState);
            }, timeout);
        };
        var _this_props = _this.props, _this_props_value = _this_props.value, value = _this_props_value === void 0 ? "" : _this_props_value, _this_props_rows = _this_props.rows, rows = _this_props_rows === void 0 ? 1 : _this_props_rows;
        _this.state = {
            value: props.event.isNew ? "" : value,
            rows: rows,
            isHover: false,
            isFocus: true,
            nextRow: false
        };
        return _this;
    }
    var _proto = Input.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.hiddenLargeDom = document.getElementById(this.hiddenLargeId);
        this.hiddenMediumDom = document.getElementById(this.hiddenMediumId);
        this.hiddenSmallDom = document.getElementById(this.hiddenSmallId);
        this.adjustSizeWithContent();
    };
    _proto.renderTextNumber = function renderTextNumber() {
        var value = this.state.value;
        var nameLength = value.length;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "input-rows"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            style: {
                color: nameLength > TITLE_MAX_LENGTH ? "#ff0000" : "#aaaaaa"
            }
        }, nameLength), /*#__PURE__*/ react_default.a.createElement("span", null, "/".concat(TITLE_MAX_LENGTH)));
    };
    _proto.computedInputStyle = function computedInputStyle() {
        var _this_state = this.state, rows = _this_state.rows, isFocus = _this_state.isFocus, isHover = _this_state.isHover, nextRow = _this_state.nextRow;
        var style = {};
        if (isFocus) {
            style.height = nextRow ? 37 + 24 * rows : 36;
            style.borderColor = "#1c6cdc";
        } else {
            style.height = 12 + 24 * rows;
            style.borderColor = isHover ? "#dddddd" : "";
        }
        return style;
    };
    _proto.render = function render() {
        var event = this.props.event;
        var _this_state = this.state, value = _this_state.value, isFocus = _this_state.isFocus, isHover = _this_state.isHover;
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: calendar_extension_classNamePrefix("calendar-input"),
            style: this.computedInputStyle(),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("calendar-input-visible", {
                "need-padding": isFocus || isHover
            })
        }, /*#__PURE__*/ react_default.a.createElement(rc_textarea_es, {
            className: "ant-input",
            spellCheck: false,
            placeholder: "新建事件",
            value: value,
            autoSize: {
                maxRows: TITLE_MAX_ROW
            },
            autoFocus: event.isNew,
            disabled: !event,
            onChange: this.handleTextChange,
            onPressEnter: this.handlePressEnter,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur
        }), (event.isNew || isFocus) && this.renderTextNumber()), /*#__PURE__*/ react_default.a.createElement("div", {
            id: this.hiddenLargeId,
            className: "calendar-input-trick large"
        }, value === "" ? "新建事件" : value), /*#__PURE__*/ react_default.a.createElement("div", {
            id: this.hiddenMediumId,
            className: "calendar-input-trick medium"
        }, value === "" ? "新建事件" : value), /*#__PURE__*/ react_default.a.createElement("div", {
            id: this.hiddenSmallId,
            className: "calendar-input-trick small"
        }, value === "" ? "新建事件" : value));
    };
    return Input;
}(react_default.a.Component);
calendar_extension_Input.contextType = ScheduleContext;

var calendar_extension_css_248z$d = ".ct-calendar-desinput{border-radius:2px;border:1px solid #1c6cdc;box-sizing:border-box;margin-bottom:0;margin-top:2px;max-height:120px;min-height:56px;overflow:hidden;padding:0 0 22px;position:relative}.ct-calendar-desinput,.ct-calendar-desinput textarea{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;width:100%}.ct-calendar-desinput textarea{border:0!important;box-shadow:none!important;color:#333;font-size:12px;outline:none;padding:2px 8px 4px;resize:none}.ct-calendar-desinput textarea ::-webkit-scrollbar{width:7px}.ct-calendar-desinput textarea ::-webkit-scrollbar-track{border-radius:100px}.ct-calendar-desinput textarea ::-webkit-scrollbar-thumb{background-clip:padding-box;background:rgba(0,0,0,.1);border-radius:100px;border:2px solid transparent}.ct-calendar-desinput .text-count{bottom:0;color:#aaa;font-size:12px;height:26px;line-height:26px;padding:0 9px;position:absolute;right:0}";
calendar_extension_styleInject(calendar_extension_css_248z$d);

function _assertThisInitialized$d(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$g(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$d(o) {
    _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$d(o);
}
function _inherits$d(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$d(subClass, superClass);
}
function calendar_extension_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            calendar_extension_defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn$d(self, call) {
    if (call && (_typeof$d(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$d(self);
}
function _setPrototypeOf$d(o, p) {
    _setPrototypeOf$d = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$d(o, p);
}
var _typeof$d = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$d() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$d(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$d();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$d(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$d(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$d(this, result);
    };
}
var calendar_extension_DesInput = /*#__PURE__*/ function(_React_Component) {
    _inherits$d(DesInput, _React_Component);
    var _super = _createSuper$d(DesInput);
    function DesInput(props) {
        _classCallCheck$g(this, DesInput);
        var _this;
        _this = _super.call(this, props);
        _this.input = /*#__PURE__*/ react_default.a.createRef();
        _this.handleChange = function(e) {
            var _this_props = _this.props, onChange = _this_props.onChange, editor = _this_props.editor;
            var value = e.target.value;
            if (_this.timer !== null) clearTimeout(_this.timer);
            _this.timer = setTimeout(function() {
                if (value.length <= DESCRIPTION_MAX_LENGTH) {
                    onChange(value);
                    editor.warn = "";
                }
                _this.timer = null;
            }, 500);
            _this.setState({
                value: value
            });
        };
        _this.handleFocus = function() {
            _this.setState({
                isFocus: true
            });
        };
        _this.handleBlur = function(e) {
            var editor = _this.props.editor;
            var provider = _this.context.provider;
            if (e.target.value.length > DESCRIPTION_MAX_LENGTH) {
                e.preventDefault();
                e.target.focus();
                editor.warn = "事件描述过长";
                if (_this.toastrTimer === null) {
                    provider.handleError(new Error("事件描述过长"));
                    _this.toastrTimer = setTimeout(function() {
                        _this.toastrTimer = null;
                    }, 500);
                }
            } else {
                _this.setState({
                    isFocus: false
                });
            }
        };
        _this.state = {
            value: props.value || "",
            isFocus: false
        };
        _this.timer = null;
        _this.toastrTimer = null;
        return _this;
    }
    var _proto = DesInput.prototype;
    _proto.render = function render() {
        var style = this.props.style;
        var editable = this.context.editable;
        var _this_state = this.state, value = _this_state.value, isFocus = _this_state.isFocus;
        var textStyles = {
            color: value.length > DESCRIPTION_MAX_LENGTH ? "#ff0000" : "#aaaaaa"
        };
        var styles = calendar_extension_objectSpread$2({
            borderColor: isFocus ? "#1c6cdc" : "rgba(0, 0, 0, 0)",
            paddingBottom: isFocus ? "22px" : "12px"
        }, style);
        return /*#__PURE__*/ react_default.a.createElement("div", {
            ref: this.input,
            className: calendar_extension_classNamePrefix("calendar-desinput"),
            style: styles
        }, /*#__PURE__*/ react_default.a.createElement(rc_textarea_es, {
            value: value,
            style: style,
            autoSize: {
                minRows: 2,
                maxRows: 5
            },
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            readOnly: !editable,
            spellCheck: false,
            placeholder: "添加描述"
        }), isFocus && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "text-count"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            style: textStyles
        }, value.length), /*#__PURE__*/ react_default.a.createElement("span", null, "/".concat(DESCRIPTION_MAX_LENGTH))));
    };
    return DesInput;
}(react_default.a.Component);
calendar_extension_DesInput.contextType = ScheduleContext;

var calendar_extension_locale = {
    locale: "zh_CN",
    today: "今天",
    now: "此刻",
    backToToday: "返回今天",
    ok: "确定",
    timeSelect: "选择时间",
    dateSelect: "选择日期",
    weekSelect: "选择周",
    clear: "清除",
    month: "月",
    year: "年",
    previousMonth: "上个月 (翻页上键)",
    nextMonth: "下个月 (翻页下键)",
    monthSelect: "选择月份",
    yearSelect: "选择年份",
    decadeSelect: "选择年代",
    yearFormat: "YYYY年",
    dayFormat: "D日",
    dateFormat: "YYYY年M月D日",
    dateTimeFormat: "YYYY年M月D日 HH时mm分ss秒",
    previousYear: "上一年 (Control键加左方向键)",
    nextYear: "下一年 (Control键加右方向键)",
    previousDecade: "上一年代",
    nextDecade: "下一年代",
    previousCentury: "上一世纪",
    nextCentury: "下一世纪",
    monthFormat: " M 月",
    shortWeekDays: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ]
};

function _assertThisInitialized$e(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$h(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$e(o) {
    _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$e(o);
}
function _inherits$e(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$e(subClass, superClass);
}
function _possibleConstructorReturn$e(self, call) {
    if (call && (_typeof$e(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$e(self);
}
function _setPrototypeOf$e(o, p) {
    _setPrototypeOf$e = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$e(o, p);
}
var _typeof$e = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$e() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$e(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$e();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$e(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$e(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$e(this, result);
    };
}
var calendar_extension_DatePicker = /*#__PURE__*/ function(_React_Component) {
    _inherits$e(DatePicker, _React_Component);
    var _super = _createSuper$e(DatePicker);
    function DatePicker(props) {
        _classCallCheck$h(this, DatePicker);
        var _this;
        _this = _super.call(this, props);
        _this.handleUpdateTime = function(value) {
            if (!value) {
                _this.setState({
                    showTime: false
                });
            }
            var onChange = _this.props.onChange;
            onChange === null || onChange === void 0 ? void 0 : onChange(new CalendarDate(value.toDate()));
        };
        _this.state = {
            showTime: false
        };
        return _this;
    }
    var _proto = DatePicker.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, value = _this_props.value, onOpenChange = _this_props.onOpenChange, getPopupContainer = _this_props.getPopupContainer, className = _this_props.className, dropdownClassName = _this_props.dropdownClassName, disabledDate = _this_props.disabledDate;
        var showTime = this.state.showTime;
        var changePanelType = function() {
            _this.setState({
                showTime: true
            });
        };
        var renderChangePanel = function() {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                onClick: changePanelType
            }, "选择时间");
        };
        return /*#__PURE__*/ react_default.a.createElement(rc_picker_es, {
            prefixCls: "ant-picker",
            generateConfig: calendar_extension_generateConfig,
            locale: calendar_extension_locale,
            inputReadOnly: true,
            className: className,
            popupStyle: {
                top: "200px"
            },
            dropdownClassName: dropdownClassName,
            format: showTime ? "YYYY年MM月DD日 HH:mm" : "YYYY年MM月DD日",
            showTime: showTime ? {
                format: "HH:mm"
            } : false,
            placeholder: "选择时间",
            renderExtraFooter: !showTime ? renderChangePanel : function() {
                return /*#__PURE__*/ react_default.a.createElement(react_default.a.Fragment, null);
            },
            value: moment_default()(value === null || value === void 0 ? void 0 : value.date),
            onChange: function(_) {
                _this.handleUpdateTime(_);
            },
            onOpenChange: onOpenChange,
            getPopupContainer: getPopupContainer,
            disabledDate: function(_) {
                return disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(new CalendarDate(_.toDate()));
            }
        });
    };
    return DatePicker;
}(react_default.a.Component);

var calendar_extension_img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1512976894681' class='icon' style='' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2409' xmlns:xlink='http://www.w3.org/1999/xlink' width='14' height='14'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M768 146.285714h201.362286a54.857143 54.857143 0 1 1 0 109.714286H54.857143a54.857143 54.857143 0 0 1 0-109.714286H256a146.285714 146.285714 0 0 1 146.285714-146.285714h219.428572a146.285714 146.285714 0 0 1 146.285714 146.285714zM365.714286 146.285714h292.571428a36.571429 36.571429 0 0 0-36.571428-36.571428h-219.428572A36.571429 36.571429 0 0 0 365.714286 146.285714z m548.571428 265.142857V329.142857 877.714286a146.285714 146.285714 0 0 1-146.285714 146.285714h-512a146.285714 146.285714 0 0 1-146.285714-146.285714V384a54.857143 54.857143 0 1 1 109.714285 0V877.714286a36.571429 36.571429 0 0 0 36.571429 36.571428h512a36.571429 36.571429 0 0 0 36.571429-36.571428V384a54.857143 54.857143 0 0 1 109.714285 0v27.428571zM396.214857 329.142857a54.857143 54.857143 0 0 1 54.857143 54.857143v402.285714a54.857143 54.857143 0 1 1-109.714286 0v-402.285714a54.857143 54.857143 0 0 1 54.857143-54.857143z m231.570286 0a54.857143 54.857143 0 0 1 54.857143 54.857143v402.285714a54.857143 54.857143 0 1 1-109.714286 0v-402.285714a54.857143 54.857143 0 0 1 54.857143-54.857143z' fill='%23747272' p-id='2410'%3e%3c/path%3e%3c/svg%3e";

var calendar_extension_css_248z$e = ".ct-calendar-portals{bottom:0;left:0;position:fixed;right:0;top:0;z-index:80}.ct-calendar-portals .portals-background{bottom:0;left:0;position:absolute;right:0;top:0}.ct-calendar-taskeditor{background:#fff;border-radius:2px;box-shadow:0 4px 292px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);display:flex;flex-direction:column;padding:16px;position:fixed;width:400px;z-index:101}.ct-calendar-taskeditor .taskeditor-row-1{display:flex;height:24px;justify-content:space-between;margin-bottom:13px}.ct-calendar-taskeditor .taskeditor-row-1 .icon-del{align-items:center;border-radius:2px;cursor:pointer;display:flex;height:24px;justify-content:center;width:24px}.ct-calendar-taskeditor .taskeditor-row-1 .icon-del:hover{border:1px solid #ccc}.ct-calendar-taskeditor .taskeditor-row-2{margin-bottom:8px}.ct-calendar-taskeditor .taskeditor-row-3{align-items:center;display:flex;flex-direction:row;height:28px;justify-content:space-between}.ct-calendar-taskeditor .taskeditor-row-3 .ant-calendar-picker-input{box-shadow:none;outline:none}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper{align-items:center;display:flex;flex-direction:row}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper .ant-picker{border-color:transparent;padding:2px 8px}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper .ant-picker:hover{border-color:#ddd!important}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper .ant-picker input{min-width:90px}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper .ct-calendar-datepicker{color:red}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper .ct-calendar-datepicker .ant-input{border-color:#1c6cdc!important}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper span{height:24px}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper span input{border-radius:2px;border:1px solid transparent;height:24px;outline:none;padding:6px 8px;width:112px}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper span input:hover{border-color:#ddd!important}.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper span .ant-calendar-picker-icon,.ct-calendar-taskeditor .taskeditor-row-3 .row-3-left-wrapper span i{display:none}.ct-calendar-taskeditor .taskeditor-row-3 .allday{align-items:center;color:#999;display:flex;flex-direction:row;font-size:12px}.ct-calendar-taskeditor .taskeditor-row-3 .allday .text{padding:0 8px}.ct-calendar-taskeditor .taskeditor-row-3 .allday span{height:16px;width:16px}.ct-calendar-taskeditor .taskeditor-row-3 .allday .ant-checkbox-input:focus+.ant-checkbox-inner,.ct-calendar-taskeditor .taskeditor-row-3 .allday .ant-checkbox-wrapper:hover .ant-checkbox-inner,.ct-calendar-taskeditor .taskeditor-row-3 .allday .ant-checkbox:hover .ant-checkbox-inner{border-color:#1c6cdc!important}.ct-calendar-taskeditor .taskeditor-row-3 .name{color:#999;font-size:12px;height:24px;line-height:24px;margin-right:8px;width:24px}.ct-calendar-taskeditor .taskeditor-row-4{display:flex;flex-direction:row}.ct-calendar-taskeditor .taskeditor-row-4 .name{color:#999;font-size:12px;height:24px;line-height:24px;margin-right:8px;min-width:24px;position:relative;top:2px;width:24px}.ct-calendar-taskeditor .taskeditor-row-4 .textarea{border:0;box-shadow:none;color:#333;font-size:12px;outline:none;resize:none;width:100%}body .ct-calendar-datepicker-dropdown-1{position:fixed}body .ct-calendar-datepicker-dropdown-1 .ant-calendar{width:240px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header{height:32px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header a{border-radius:2px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header>div{align-items:center;display:flex;flex-direction:row;height:32px;justify-content:center}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header>div>span{display:flex}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header>div>span a{pointer-events:none}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header>div>a{border:1px solid transparent;color:#6b6b6b;height:24px;line-height:32px;top:4px;width:24px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header>div>a:hover{border-color:#ddd;color:#6b6b6b}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-header>div>a:after{position:relative;top:-5px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-input-wrap{display:none}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-date{border-radius:50%;transition:none}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-date:hover{background:#f6f6f6}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-today .ant-calendar-date{border-color:transparent;border-radius:50%;color:#1c6cdc}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-selected-date>div{border-color:#1c6cdc;border-radius:50%;color:#1c6cdc!important}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-selected-day>div{background:transparent;border-radius:50%;color:rgba(0,0,0,.65)}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-footer-btn{height:35px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-footer-btn .ant-calendar-today-btn{color:#333}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell .ant-calendar-date{background:transparent;border-radius:0;color:rgba(0,0,0,.65)}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell-first-of-row .ant-calendar-date{border-bottom-left-radius:4px;border-top-left-radius:4px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell-last-of-row .ant-calendar-date{border-bottom-right-radius:4px;border-top-right-radius:4px}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date{border-color:transparent;color:#1c6cdc;margin:0;padding:0}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date:before{display:none}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell.ant-calendar-last-month-cell .ant-calendar-date{color:rgba(0,0,0,.25)}body .ct-calendar-datepicker-dropdown-1 .ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date{background:transparent;color:rgba(0,0,0,.65)}body .ct-calendar-datepicker-dropdown-2{position:fixed}body .ct-calendar-datepicker-dropdown-2 .ant-calendar{width:240px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header{height:32px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header a{border-radius:2px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header>div{align-items:center;display:flex;flex-direction:row;height:32px;justify-content:center}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header>div>span{display:flex}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header>div>span a{pointer-events:none}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header>div>a{border:1px solid transparent;color:#6b6b6b;height:24px;line-height:32px;top:4px;width:24px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header>div>a:hover{border-color:#ddd;color:#6b6b6b}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-header>div>a:after{position:relative;top:-5px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-input-wrap{display:none}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-date{border-radius:50%;transition:none}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-date:hover{background:#f6f6f6}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-today .ant-calendar-date{border-color:transparent;border-radius:50%;color:#1c6cdc}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-selected-date>div{border-color:#1c6cdc;border-radius:50%;color:#1c6cdc!important}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-selected-day>div{background:transparent;border-radius:50%;color:rgba(0,0,0,.65)}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-footer-btn{height:35px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-footer-btn .ant-calendar-today-btn{color:#333}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell .ant-calendar-date{background:transparent;border-radius:0;color:rgba(0,0,0,.65)}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell-first-of-row .ant-calendar-date{border-bottom-left-radius:4px;border-top-left-radius:4px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell-last-of-row .ant-calendar-date{border-bottom-right-radius:4px;border-top-right-radius:4px}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date{border-color:transparent;color:#1c6cdc;margin:0;padding:0}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date:before{display:none}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell.ant-calendar-last-month-cell .ant-calendar-date{color:rgba(0,0,0,.25)}body .ct-calendar-datepicker-dropdown-2 .ant-calendar-disabled-cell.ant-calendar-selected-day .ant-calendar-date{background:transparent;color:rgba(0,0,0,.65)}";
calendar_extension_styleInject(calendar_extension_css_248z$e);

function _assertThisInitialized$f(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$i(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$f(o) {
    _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$f(o);
}
function _inherits$f(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$f(subClass, superClass);
}
function _possibleConstructorReturn$f(self, call) {
    if (call && (_typeof$f(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$f(self);
}
function _setPrototypeOf$f(o, p) {
    _setPrototypeOf$f = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$f(o, p);
}
var _typeof$f = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$f() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$f(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$f();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$f(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$f(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$f(this, result);
    };
}
var calendar_extension_EventEditor = /*#__PURE__*/ function(_React_Component) {
    _inherits$f(EventEditor, _React_Component);
    var _super = _createSuper$f(EventEditor);
    function EventEditor(props) {
        _classCallCheck$i(this, EventEditor);
        var _this;
        _this = _super.call(this, props);
        _this.handleDelete = function() {
            var _this_context = _this.context, editingEvent = _this_context.editingEvent, setEditingEvent = _this_context.setEditingEvent;
            editingEvent.remove().then(function() {
                setEditingEvent(null);
            });
        };
        _this.handleAlldayChange = function(e) {
            var checked = e.target.checked;
            var editingEvent = _this.context.editingEvent;
            var startTime = editingEvent.startTime, endTime = editingEvent.endTime;
            if (!checked && startTime.isAfter(endTime, "minutes")) {
                editingEvent.startTime = startTime.set({
                    hours: 9,
                    minutes: 0
                });
                editingEvent.endTime = endTime.set({
                    hours: 10,
                    minutes: 0
                });
            }
            editingEvent.isAllDay = checked;
        };
        _this.handleStartDateChange = function(time) {
            var editingEvent = _this.context.editingEvent;
            var startTime = editingEvent.startTime, endTime = editingEvent.endTime;
            if (time.isAfter(endTime)) {
                var days = time.diffDays(startTime);
                editingEvent.endTime = time.addDay(days);
            }
            editingEvent.startTime = startTime.set({
                year: time.year,
                month: time.month,
                date: time.monthDate
            });
        };
        _this.handleEndDateChange = function(time) {
            var editingEvent = _this.context.editingEvent;
            var endTime = editingEvent.endTime;
            editingEvent.endTime = endTime.set({
                year: time.year,
                month: time.month,
                date: time.monthDate
            });
        };
        _this.handleStartTimeChange = function(time) {
            var editingEvent = _this.context.editingEvent;
            var startTime = editingEvent.startTime, endTime = editingEvent.endTime;
            if (time.isAfter(endTime)) {
                var minutes = time.diffMinutes(startTime);
                editingEvent.endTime = endTime.addMinute(minutes);
            }
            editingEvent.startTime = startTime.set({
                hours: time.hour,
                minutes: time.minute
            });
        };
        _this.handleEndTimeChange = function(time) {
            var editingEvent = _this.context.editingEvent;
            var endTime = editingEvent.endTime;
            editingEvent.endTime = endTime.set({
                hours: time.hour,
                minutes: time.minute
            });
        };
        _this.handleEventChange = function(prop, value) {
            var editingEvent = _this.context.editingEvent;
            editingEvent[prop] = value;
        };
        _this.state = {
            datePickerOpenStatus: 0
        };
        return _this;
    }
    var _proto = EventEditor.prototype;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener("onselectstart", function() {
            return false;
        });
    };
    _proto.render = function render() {
        var _this = this;
        var _this_context = this.context, editable = _this_context.editable, editingEvent = _this_context.editingEvent;
        var _this_props = this.props, editor = _this_props.editor, style = _this_props.style, dom = _this_props.dom, eventEditor = _this_props.eventEditor;
        var name = editingEvent.name, statusString = editingEvent.statusString, startTime = editingEvent.startTime, endTime = editingEvent.endTime, isAllDay = editingEvent.isAllDay, description = editingEvent.description;
        var datePickerOpenStatus = this.state.datePickerOpenStatus;
        var editableStyles = {
            pointerEvents: editable ? "" : "none"
        };
        return /*#__PURE__*/ react_dom_default.a.createPortal(/*#__PURE__*/ react_default.a.createElement("div", {
            ref: editor,
            className: calendar_extension_classNamePrefix("calendar-taskeditor"),
            style: style
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "taskeditor-row-1",
            style: editableStyles
        }, /*#__PURE__*/ react_default.a.createElement(calendar_extension_ColorPicker, {
            selected: "".concat(statusString, "Focus"),
            onChange: function(_) {
                return _this.handleEventChange("statusString", _);
            }
        }), editable && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "icon-del",
            onClick: this.handleDelete
        }, /*#__PURE__*/ react_default.a.createElement("img", {
            src: calendar_extension_img$6,
            alt: ""
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "taskeditor-row-2",
            style: editableStyles
        }, /*#__PURE__*/ react_default.a.createElement(calendar_extension_Input, {
            editor: eventEditor,
            value: name,
            onChange: function(_) {
                return _this.handleEventChange("name", _);
            },
            event: editingEvent
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "taskeditor-row-3",
            style: editableStyles
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "row-3-left-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, "开始"), /*#__PURE__*/ react_default.a.createElement(calendar_extension_DatePicker, {
            value: startTime,
            className: classnames_default()(calendar_extension_defineProperty$3({}, calendar_extension_classNamePrefix("calendar-datepicker"), datePickerOpenStatus === 1)),
            dropdownClassName: calendar_extension_classNamePrefix("calendar-datepicker-dropdown-1"),
            onChange: this.handleStartDateChange,
            getPopupContainer: function() {
                return dom;
            }
        }), !isAllDay && /*#__PURE__*/ react_default.a.createElement(calendar_extension_TimePicker, {
            value: startTime,
            onChange: this.handleStartTimeChange
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "allday"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "text"
        }, "全天"), /*#__PURE__*/ react_default.a.createElement(rc_checkbox_es, {
            defaultChecked: isAllDay,
            onChange: this.handleAlldayChange
        }))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "taskeditor-row-3",
            style: editableStyles
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "row-3-left-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, "结束"), /*#__PURE__*/ react_default.a.createElement(calendar_extension_DatePicker, {
            value: endTime,
            className: classnames_default()(calendar_extension_defineProperty$3({}, calendar_extension_classNamePrefix("calendar-datepicker"), datePickerOpenStatus === 2)),
            dropdownClassName: calendar_extension_classNamePrefix("calendar-datepicker-dropdown-2"),
            onChange: this.handleEndDateChange,
            getPopupContainer: function() {
                return dom;
            },
            disabledDate: function(_) {
                return _.isBefore(startTime);
            }
        }), !isAllDay && /*#__PURE__*/ react_default.a.createElement(calendar_extension_TimePicker, {
            start: startTime,
            value: endTime,
            onChange: this.handleEndTimeChange
        }))), !editable && description === "" ? null : /*#__PURE__*/ react_default.a.createElement("div", {
            className: "taskeditor-row-4",
            style: editableStyles
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, "描述"), /*#__PURE__*/ react_default.a.createElement(calendar_extension_DesInput, {
            editor: eventEditor,
            value: description,
            onChange: function(_) {
                return _this.handleEventChange("description", _);
            },
            style: editableStyles
        }))), dom);
    };
    return EventEditor;
}(react_default.a.Component);
calendar_extension_EventEditor.contextType = ScheduleContext;

/* eslint-disable react/destructuring-assignment */ function _assertThisInitialized$g(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$j(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$g(o) {
    _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$g(o);
}
function _inherits$g(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$g(subClass, superClass);
}
function _possibleConstructorReturn$g(self, call) {
    if (call && (_typeof$g(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$g(self);
}
function _setPrototypeOf$g(o, p) {
    _setPrototypeOf$g = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$g(o, p);
}
var _typeof$g = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$g() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$g(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$g();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$g(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$g(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$g(this, result);
    };
}
var calendar_extension_EventEditor$1 = /*#__PURE__*/ function(_React_Component) {
    _inherits$g(EventEditor$1, _React_Component);
    var _super = _createSuper$g(EventEditor$1);
    function EventEditor$1() {
        _classCallCheck$j(this, EventEditor$1);
        var _this;
        _this = _super.apply(this, arguments);
        _this.top = 0;
        _this.rafId = null;
        _this.editor = /*#__PURE__*/ react_default.a.createRef();
        _this.warn = "";
        _this.hideEventEditor = function() {
            var _this_context = _this.context, setEditingEvent = _this_context.setEditingEvent, editingEvent = _this_context.editingEvent;
            if (_this.warn === "") {
                editingEvent.focus = false;
                editingEvent.isNew = false;
                setEditingEvent(null);
            }
        };
        return _this;
    }
    var _proto = EventEditor$1.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        cancelAnimationFrame(this.rafId);
    };
    _proto.render = function render() {
        var _this_context = this.context, editingEvent = _this_context.editingEvent, portals = _this_context.portals;
        var _editingEvent_position = editingEvent.position, mouseX = _editingEvent_position.mouseX, mouseY = _editingEvent_position.mouseY;
        // 下一个事件循环 calendar-taskeditor 组件渲染出来之后计算位置
        setTimeout(function() {
            var x = mouseX;
            var y = mouseY;
            var editorDOM = document.querySelector(".".concat(calendar_extension_classNamePrefix("calendar-taskeditor")));
            if (editorDOM) {
                var _editorDOM_getBoundingClientRect = editorDOM.getBoundingClientRect(), width = _editorDOM_getBoundingClientRect.width, height = _editorDOM_getBoundingClientRect.height;
                x = Math.min(window.innerWidth - width - 10, x);
                y = Math.min(window.innerHeight - height - 10, y);
                editorDOM.setAttribute("style", "left: ".concat(x, "px; top: ").concat(y, "px;"));
            }
        });
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: calendar_extension_classNamePrefix("calendar-portals")
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "portals-background",
            onClick: this.hideEventEditor
        }), /*#__PURE__*/ react_default.a.createElement(calendar_extension_EventEditor, {
            eventEditor: this,
            editor: this.editor,
            dom: portals
        }));
    };
    return EventEditor$1;
}(react_default.a.Component);
calendar_extension_EventEditor$1.contextType = ScheduleContext;

var css_248z$f = ".ct-calendar-container{position:relative;display:flex;flex-direction:column;width:100%;background:#f2f2f2;color:#333;box-sizing:border-box;border:1px solid #ddd}.ct-calendar-container div{-webkit-overflow-scrolling:auto}.ct-calendar-loading{top:40px;background:transparent}.ProseMirror-selectednode .ct-calendar-container{outline:none;border-color:#3d91f2;box-shadow:0 0 4px 0 rgba(0,0,0,.1),0 3px 6px 0 rgba(0,0,0,.14)}";
calendar_extension_styleInject(css_248z$f);

function calendar_extension_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function calendar_extension_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return calendar_extension_arrayLikeToArray$3(arr);
}
function _assertThisInitialized$h(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$k(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function calendar_extension_defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$h(o) {
    _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$h(o);
}
function _inherits$h(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$h(subClass, superClass);
}
function calendar_extension_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function calendar_extension_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function calendar_extension_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            calendar_extension_defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function calendar_extension_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function calendar_extension_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        calendar_extension_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn$h(self, call) {
    if (call && (_typeof$h(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$h(self);
}
function _setPrototypeOf$h(o, p) {
    _setPrototypeOf$h = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$h(o, p);
}
function calendar_extension_toConsumableArray(arr) {
    return calendar_extension_arrayWithoutHoles(arr) || calendar_extension_iterableToArray(arr) || calendar_extension_unsupportedIterableToArray$3(arr) || calendar_extension_nonIterableSpread();
}
var _typeof$h = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function calendar_extension_unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return calendar_extension_arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return calendar_extension_arrayLikeToArray$3(o, minLen);
}
function _isNativeReflectConstruct$h() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$h(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$h();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$h(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$h(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$h(this, result);
    };
}
var calendar_extension_CalendarView = /*#__PURE__*/ function(_React_Component) {
    _inherits$h(CalendarView, _React_Component);
    var _super = _createSuper$h(CalendarView);
    function CalendarView(props) {
        _classCallCheck$k(this, CalendarView);
        var _this;
        _this = _super.call(this, props);
        _this.handleCalendarUpdateEvent = function() {
            var removeEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, eventId = arguments.length > 1 ? arguments[1] : void 0;
            var provider = _this.props.provider;
            var _this_state = _this.state, editingEvent = _this_state.editingEvent, dragingEvent = _this_state.dragingEvent;
            if (!editingEvent && !dragingEvent) {
                _this.refreshEvent();
            } else {
                _this.setState({
                    haveUpdate: true
                });
            }
            if (eventId === (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.id) && removeEvent) {
                var _provider_modalInstance;
                // 协同编辑，删除同一个日历事件需要立即响应并关闭编辑弹窗和确认弹窗
                _this.refreshEvent();
                _this.setState({
                    editingEvent: null
                });
                provider === null || provider === void 0 ? void 0 : (_provider_modalInstance = provider.modalInstance) === null || _provider_modalInstance === void 0 ? void 0 : _provider_modalInstance.destroy();
            }
        };
        _this.setView = function(view) {
            var _this_props = _this.props, editorView = _this_props.view, getPos = _this_props.getPos, node = _this_props.node;
            var tr = editorView.state.tr;
            var pos = getPos();
            editorView.dispatch(tr.setNodeMarkup(pos, node.type, calendar_extension_objectSpreadProps(calendar_extension_objectSpread$3({}, node.attrs), {
                view: view
            })));
        };
        _this.setNodeSelection = function() {
            var _this_props = _this.props, editorView = _this_props.view, getPos = _this_props.getPos;
            var _editorView_state = editorView.state, tr = _editorView_state.tr, doc = _editorView_state.doc;
            var pos = getPos();
            editorView.dispatch(tr.setSelection(prosemirror_state_dist["NodeSelection"].create(doc, pos)));
        };
        var node = props.node;
        _this.portals = document.createElement("div");
        document.body.appendChild(_this.portals);
        _this.projectId = node.attrs.id;
        _this.state = {
            schedule: {
                events: [],
                // 当前选择日期
                loadFinish: false,
                error: null
            },
            calendarDate: new CalendarDate(new Date()),
            hoverIndex: -1,
            editingEvent: null,
            dragingEvent: null,
            error: false,
            errorMessage: "日历宏加载失败",
            loading: false,
            haveUpdate: false
        };
        return _this;
    }
    var _proto = CalendarView.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var projectId = this.projectId;
        var _this_props = this.props, node = _this_props.node, provider = _this_props.provider, getPos = _this_props.getPos, editorEventEmitter = _this_props.editorEventEmitter;
        var _node_attrs = node.attrs, docId = _node_attrs.docId, paste = _node_attrs.paste, view = _node_attrs.view;
        var contentId = provider.getContentId();
        var copyId = "".concat(docId) !== "".concat(contentId) || paste ? docId : null;
        if (copyId) {
            var _this_props1 = this.props, editorView = _this_props1.view;
            provider.handlePasteCalendar(copyId, projectId).then(function(newProjectId) {
                _this.projectId = newProjectId;
                var tr = editorView.state.tr, dispatch = editorView.dispatch;
                var attrs = {
                    id: newProjectId,
                    docId: contentId,
                    paste: 0,
                    view: view
                };
                dispatch(tr.setNodeMarkup(getPos(), null, attrs));
                _this.refreshEvent();
            }).catch(function(error) {
                var message = error.message;
                _this.setState({
                    errorMessage: message,
                    error: true
                });
                var tr = editorView.state.tr, dispatch = editorView.dispatch;
                var pos = getPos();
                dispatch(tr.delete(pos, pos + 1));
                provider.handleError(error);
            });
        } else {
            this.refreshEvent();
        }
        editorEventEmitter.on("".concat(CALENDAR_UPDATE, "_").concat(this.projectId), this.handleCalendarUpdateEvent);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var editorEventEmitter = this.props.editorEventEmitter;
        editorEventEmitter.removeListener("".concat(CALENDAR_UPDATE, "_").concat(this.projectId), this.handleCalendarUpdateEvent);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
        var _this_state = this.state, curDate = _this_state.calendarDate, haveUpdate = _this_state.haveUpdate, editingEvent = _this_state.editingEvent, dragingEvent = _this_state.dragingEvent;
        var preDate = prevState.calendarDate;
        if (curDate !== preDate || haveUpdate && !editingEvent && !dragingEvent) {
            this.refreshEvent();
        }
    };
    _proto.refreshEvent = function refreshEvent() {
        var _this = this;
        var provider = this.props.provider;
        var projectId = this.projectId;
        var _this_state = this.state, calendarDate = _this_state.calendarDate, schedule = _this_state.schedule;
        this.setState({
            loading: true,
            haveUpdate: false
        });
        provider.getEventSource(this.projectId, calendarDate).then(function(param) {
            var events = param.events;
            _this.setState({
                schedule: calendar_extension_objectSpreadProps(calendar_extension_objectSpread$3({}, schedule), {
                    events: eventsMapper(events.map(function(_) {
                        return proxyEvent(CalendarEvent.createByOriginEvent(_, {
                            projectId: projectId,
                            provider: provider,
                            eventHandler: _this.eventHandlerGetter()
                        }));
                    })),
                    loadFinish: true
                })
            });
        }).catch(function(error) {
            _this.setState({
                schedule: calendar_extension_objectSpreadProps(calendar_extension_objectSpread$3({}, schedule), {
                    loadFinish: true,
                    error: error
                })
            });
        }).finally(function() {
            _this.setState({
                loading: false
            });
        });
    };
    _proto.eventHandlerGetter = function eventHandlerGetter() {
        var _this = this;
        var setEvents = function(schedule, events) {
            _this.setState({
                schedule: calendar_extension_objectSpreadProps(calendar_extension_objectSpread$3({}, schedule), {
                    events: events
                })
            });
        };
        return {
            addEvent: function(event) {
                var schedule = _this.state.schedule;
                setEvents(schedule, eventsMapper(calendar_extension_toConsumableArray(schedule.events).concat([
                    event
                ])));
            },
            updateEvent: function() {
                var schedule = _this.state.schedule;
                setEvents(schedule, eventsMapper(calendar_extension_toConsumableArray(schedule.events)));
            },
            removeEvent: function(event) {
                var schedule = _this.state.schedule;
                setEvents(schedule, eventsMapper(calendar_extension_toConsumableArray(schedule.events.filter(function(_) {
                    return _ !== event;
                }))));
            },
            setError: function(errorMessage) {
                _this.setState({
                    errorMessage: errorMessage,
                    error: true
                });
            },
            setLoading: function(loading) {
                _this.setState({
                    loading: loading
                });
            }
        };
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, node = _this_props.node, provider = _this_props.provider;
        var view = node.attrs.view;
        var _node_attrs = node.attrs, projectId = _node_attrs.id;
        var _this_state = this.state, schedule = _this_state.schedule, calendarDate = _this_state.calendarDate, hoverIndex = _this_state.hoverIndex, editingEvent = _this_state.editingEvent, dragingEvent = _this_state.dragingEvent, error = _this_state.error, errorMessage = _this_state.errorMessage, loading = _this_state.loading;
        var baseTime = getBaseTime(calendarDate, view);
        var stateSetter = function(name) {
            return function(value) {
                _this.setState(calendar_extension_defineProperty$4({}, name, value));
            };
        };
        return /*#__PURE__*/ react_default.a.createElement(ScheduleContext.Provider, {
            value: {
                schedule: schedule,
                setSchedule: stateSetter("schedule"),
                setView: this.setView,
                calendarDate: calendarDate,
                setCalendarDate: stateSetter("calendarDate"),
                hoverIndex: hoverIndex,
                setHoverIndex: stateSetter("hoverIndex"),
                baseTime: baseTime,
                provider: provider,
                editingEvent: editingEvent,
                setEditingEvent: stateSetter("editingEvent"),
                dragingEvent: dragingEvent,
                setDragingEvent: stateSetter("dragingEvent"),
                editable: true,
                projectId: projectId,
                eventHandler: this.eventHandlerGetter(),
                proxyEvent: proxyEvent,
                portals: this.portals,
                setNodeSelection: this.setNodeSelection,
                view: view
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()(calendar_extension_classNamePrefix("calendar-container"))
        }, /*#__PURE__*/ react_default.a.createElement(calendar_extension_Header, null), view === "month" ? /*#__PURE__*/ react_default.a.createElement(Grid$1, null) : /*#__PURE__*/ react_default.a.createElement(WeekView, null), !error && loading && /*#__PURE__*/ react_default.a.createElement(Loading, {
            className: calendar_extension_classNamePrefix("calendar-loading")
        }), !error && !loading && editingEvent && /*#__PURE__*/ react_default.a.createElement(calendar_extension_EventEditor$1, null), error && /*#__PURE__*/ react_default.a.createElement(Error$1, {
            error: errorMessage
        })));
    };
    return CalendarView;
}(react_default.a.Component);

function _assertThisInitialized$i(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$l(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$6(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$6(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$6(Constructor, staticProps);
    return Constructor;
}
function calendar_extension_defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$i(o) {
    _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$i(o);
}
function _inherits$i(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$i(subClass, superClass);
}
function calendar_extension_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            calendar_extension_defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function calendar_extension_ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function calendar_extension_objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        calendar_extension_ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn$i(self, call) {
    if (call && (_typeof$i(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$i(self);
}
function _setPrototypeOf$i(o, p) {
    _setPrototypeOf$i = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$i(o, p);
}
var _typeof$i = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$i() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$i(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$i();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$i(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$i(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$i(this, result);
    };
}
var PLUGIN_NAME = "calendar";
var calendar_extension_CalendarExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$i(CalendarExtension, NodeExtension);
    var _super = _createSuper$i(CalendarExtension);
    function CalendarExtension() {
        _classCallCheck$l(this, CalendarExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.nodeViews = calendar_extension_CalendarView;
        return _this;
    }
    var _proto = CalendarExtension.prototype;
    _proto.plugin = function plugin(param) {
        var schema = param.schema;
        return new prosemirror_state_dist["Plugin"]({
            key: new prosemirror_state_dist["PluginKey"](this.name),
            props: {
                transformPasted: function(slice) {
                    return forEachSlice(slice, function(n) {
                        if (n.type.name === PLUGIN_NAME) {
                            n.attrs = calendar_extension_objectSpreadProps$1(calendar_extension_objectSpread$4({}, n.attrs), {
                                paste: 1
                            });
                            return false;
                        }
                        return true;
                    });
                }
            }
        });
    };
    _proto.commands = function commands(param) {
        var schema = param.schema, editorEventEmitter = param.editorEventEmitter;
        return {
            insert: function(attrs) {
                return function(state, dispatch) {
                    var node = schema.nodes.calendar.create(attrs);
                    var transaction = calendar_extension_insertBlock(state, node).transaction;
                    dispatch(transaction.scrollIntoView());
                    editorEventEmitter.emit(calendar_extension_AFTER_INSERT, {
                        braceWidth: 960
                    });
                    return true;
                };
            }
        };
    };
    _createClass$6(CalendarExtension, [
        {
            key: "name",
            get: function get() {
                return PLUGIN_NAME;
            }
        }
    ]);
    return CalendarExtension;
}(core["d" /* NodeExtension */]);


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./components/mc-rich-text-editor/constants.js































var MAXIMUM_FILE_SIZE_QUANTITY = 1024 * 1024;
var MAXIMUM_FILE_SIZE = 100;
var MAXIMUM_FILE_NUMBER = 9;
var DEFAULT_MENU_CONFIG = [{
  type: 'history' // 撤销、重做

}, {
  type: 'clearFormat',
  // 清除格式
  divider: true
}, {
  type: 'heading' // 标题

}, {
  type: 'font' // 字体大小

}, {
  type: 'strong' // 粗体

}, {
  type: 'em' // 斜体

}, {
  type: 'strikethrough' // 中划线

}, {
  type: 'underline' // 下划线

}, {
  type: 'color' // 文字颜色

}, {
  type: 'subsup',
  // 上下标
  divider: true
}, {
  type: 'align' // 对齐方式

}, {
  type: 'bullet_list' // 无序列表

}, {
  type: 'ordered_list' // 有序列表

}, {
  type: 'task_list' // 任务列表

}, {
  type: 'indent' // 缩进

}, {
  type: 'table',
  // 表格
  divider: true
}, {
  type: 'image' // 图片

}, {
  type: 'video' // 视频

}, {
  type: 'audio' // 音频

}, {
  type: 'link',
  // 链接
  divider: true
}, {
  type: 'extra',
  children: [{
    type: 'attachment' // 附件

  }, {
    type: 'collapse' // 展开

  }, {
    type: 'horizontal_rule' // 水平线

  }, {
    type: 'time' // 时间

  }, {
    type: 'status' // 状态

  }, {
    type: 'note' // 样式

  }, {
    type: 'blockquote' // 引用

  }]
}];
var MENU_EXTENSION_MAPPING = {
  history: null,
  clearFormat: null,
  heading: heading_extension_HeadingExtension,
  font: FontExtension,
  strong: StrongExtension,
  em: EmExtension,
  strikethrough: StrikethroughExtension,
  underline: UnderlineExtension,
  color: ColorExtension,
  subsup: [SubExtension, SupExtension],
  align: AlignExtension,
  bullet_list: [bullet_list_extension_BulletListExtension, list_item_extension_ListItemExtension],
  ordered_list: [ordered_list_extension_OrderedListExtension, list_item_extension_ListItemExtension],
  task_list: [task_list_extension_TaskListExtension, task_item_extension_TaskItemExtension],
  indent: IndentExtension,
  table: table_extension_TableExtension,
  image: image_extension_ImageExtension,
  video: video_extension_VideoExtension,
  audio: audio_extension_AudioExtension,
  link: link_extension_LinkExtension,
  code_block: code_extension["a" /* CodeExtension */],
  catalog: catalog_extension_CatalogExtension,
  attachment: attachment_extension_AttachmentExtension,
  status: status_extension_StatusExtension,
  note: note_extension_NoteExtension,
  blockquote: blockquote_extension_BlockquoteExtension,
  collapse: collapse_extension_CollapseExtension,
  horizontal_rule: HorizontalRuleExtension,
  time: TimeExtension,
  calendar: calendar_extension_CalendarExtension
};
/* harmony default export */ var constants = ({
  MAXIMUM_FILE_SIZE: MAXIMUM_FILE_SIZE,
  MAXIMUM_FILE_NUMBER: MAXIMUM_FILE_NUMBER,
  DEFAULT_MENU_CONFIG: DEFAULT_MENU_CONFIG,
  MENU_EXTENSION_MAPPING: MENU_EXTENSION_MAPPING
});
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("d225");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized.js
function esm_assertThisInitialized_assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js


function esm_possibleConstructorReturn_possibleConstructorReturn(self, call) {
  if (call && (Object(esm_typeof["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return esm_assertThisInitialized_assertThisInitialized(self);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("061b");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/set-prototype-of.js
var set_prototype_of = __webpack_require__("4d16");
var set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(set_prototype_of);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js


function esm_getPrototypeOf_getPrototypeOf(o) {
  esm_getPrototypeOf_getPrototypeOf = set_prototype_of_default.a ? get_prototype_of_default.a : function _getPrototypeOf(o) {
    return o.__proto__ || get_prototype_of_default()(o);
  };
  return esm_getPrototypeOf_getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/create.js
var create = __webpack_require__("4aa6");
var create_default = /*#__PURE__*/__webpack_require__.n(create);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/setPrototypeOf.js

function esm_setPrototypeOf_setPrototypeOf(o, p) {
  esm_setPrototypeOf_setPrototypeOf = set_prototype_of_default.a || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return esm_setPrototypeOf_setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js


function esm_inherits_inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = create_default()(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) esm_setPrototypeOf_setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: ./node_modules/@it/parker/es/providers/index.js


function providers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function providers_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                providers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                providers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function providers_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var providers_AttachmentProvider = /*#__PURE__*/ function() {
    function AttachmentProvider() {
        var _this = this;
        providers_classCallCheck(this, AttachmentProvider);
        // 由于可以同时上传多个附件，以 id 为 key 存储不同附件的状态
        this.store = {};
        this.copyCallback = function(res) {};
        this.copy = function(url) {
            var inp = document.createElement("input");
            inp.setAttribute("value", url);
            inp.setAttribute("style", "opacity: 0");
            document.body.append(inp);
            inp.select();
            try {
                if (document.execCommand("Copy")) {
                    _this.copyCallback(true);
                } else {
                    _this.copyCallback(false);
                }
            } catch (err) {
                _this.copyCallback(false);
            }
            inp.remove();
        };
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.upload = function() {
            var _ref = providers_asyncToGenerator(function(file, onProgress) {
                return providers_generator(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            reject(new Error("附件上传方法未定义"));
                        })
                    ];
                });
            });
            return function(file, onProgress) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AttachmentProvider.prototype;
    _proto.beforeUpload = function beforeUpload(file, id) {
        return true;
    };
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AttachmentProvider;
}();

function providers_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function providers_asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                providers_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                providers_asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function providers_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var providers_AudioProvider = /*#__PURE__*/ function() {
    function AudioProvider() {
        providers_classCallCheck$1(this, AudioProvider);
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.beforeUpload = function(file) {
            return true;
        };
        this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("上传方法未定义"));
            });
        };
        this.audioTranscode = function() {
            var _ref = providers_asyncToGenerator$1(function(data, file) {
                return providers_generator$1(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioProvider.prototype;
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AudioProvider;
}();

function providers_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_DrawioProvider = function DrawioProvider() {
    providers_classCallCheck$2(this, DrawioProvider);
    this.serverUrl = "https://km.sankuai.com/draw/index.html?embed=1&ui=atlas&spin=1&proto=json&lang=zh&_t=".concat(Date.now());
    this.upload = function(file, onProgress) {
        return new Promise(function(resolve, reject) {
            reject(new Error("流程图上传方法未定义"));
        });
    };
    this.handleUrl = function(originUrl) {
        return originUrl;
    };
    this.getSvgSource = function(url) {
        return new Promise(function(resolve, reject) {
            reject(new Error("获取svg方法未定义"));
        });
    };
};

function providers_classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_HtmlProvider = function HtmlProvider() {
    providers_classCallCheck$3(this, HtmlProvider);
    this.getIframeUrl = function() {
        return new URL("//test01-awp.hfe.test.meituan.com/in/citadel-embed-assets/html/index.html", window.location.href);
    };
};

function providers_classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_ImageProvider = function ImageProvider() {
    providers_classCallCheck$4(this, ImageProvider);
};

function providers_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function providers_classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function providers_getPrototypeOf(o) {
    providers_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return providers_getPrototypeOf(o);
}
function providers_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) providers_setPrototypeOf(subClass, superClass);
}
function providers_possibleConstructorReturn(self, call) {
    if (call && (providers_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return providers_assertThisInitialized(self);
}
function providers_setPrototypeOf(o, p) {
    providers_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return providers_setPrototypeOf(o, p);
}
var providers_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function providers_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function providers_createSuper(Derived) {
    var hasNativeReflectConstruct = providers_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = providers_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = providers_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return providers_possibleConstructorReturn(this, result);
    };
}
var providers_ImageProvider$1 = /*#__PURE__*/ function(types) {
    providers_inherits(ImageProvider, types);
    var _super = providers_createSuper(ImageProvider);
    function ImageProvider() {
        providers_classCallCheck$5(this, ImageProvider);
        var _this;
        _this = _super.apply(this, arguments);
        _this.formatUrl = function(src) {
            return src;
        };
        _this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("图片上传方法未定义"));
            });
        };
        _this.beforeUpload = function(file, id) {
            return true;
        };
        _this.onSelectFiles = function(files) {
            return true;
        };
        _this.onImageLoad = function(src) {
            // eslint-disable-next-line no-console
            console.log(src, "onImageLoad");
        };
        return _this;
    }
    return ImageProvider;
}(providers_ImageProvider);

function providers_classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_MarkdownProvider = function MarkdownProvider() {
    providers_classCallCheck$6(this, MarkdownProvider);
    this.getIframeUrl = function() {
        return new URL("//test01-awp.hfe.test.meituan.com/in/citadel-embed-assets/html/index.html", window.location.href);
    };
};

function providers_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function providers_asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                providers_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                providers_asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function providers_classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var providers_MinderProvider = function MinderProvider() {
    providers_classCallCheck$7(this, MinderProvider);
    this.serverUrl = "https://onejs.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/minder/src_v5/index.html";
    this.upload = function(file, onProgress) {
        return new Promise(function(resolve, reject) {
            reject(new Error("思维导图上传方法未定义"));
        });
    };
    this.handleUrl = function(url) {
        return url;
    };
    this.getSvgSource = function() {
        var _ref = providers_asyncToGenerator$2(function(url) {
            return providers_generator$2(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        reject(new Error("获取svg方法未定义"));
                    })
                ];
            });
        });
        return function(url) {
            return _ref.apply(this, arguments);
        };
    }();
    this.customOnMinderExit = function(minderFrame) {};
    this.customOnMinderInited = function(minderFrame) {};
    this.customOnMinderChanged = function(minderFrame, content) {};
    this.customOnMinderSaved = function() {};
};

function providers_classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_PlantUMLProvider = function PlantUMLProvider() {
    providers_classCallCheck$8(this, PlantUMLProvider);
    this.getImgSrc = function(umlContent) {
        return "https://km.sankuai.com/plantuml/svg/".concat(browser_index_default.a.encode(umlContent));
    };
};

function providers_classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_TableProvider = function TableProvider() {
    providers_classCallCheck$9(this, TableProvider);
    this.getScrollWrapper = function() {
        return document.querySelector(".ct-editor");
    };
    this.getTopBias = function() {
        return 28;
    };
    this.getBottomBias = function() {
        return 0;
    };
};

function providers_asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function providers_asyncToGenerator$3(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                providers_asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                providers_asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function providers_classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_generator$3 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var providers_VideoProvider = /*#__PURE__*/ function() {
    function VideoProvider() {
        providers_classCallCheck$a(this, VideoProvider);
        this.handleVideoError = function(err, url) {};
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.upload = function() {
            var _ref = providers_asyncToGenerator$3(function(file, onProgress) {
                return providers_generator$3(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            reject(new Error("上传方法未定义"));
                        })
                    ];
                });
            });
            return function(file, onProgress) {
                return _ref.apply(this, arguments);
            };
        }();
        this.videoTranscode = function() {
            var _ref = providers_asyncToGenerator$3(function(data, file) {
                return providers_generator$3(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = VideoProvider.prototype;
    _proto.beforeUpload = function beforeUpload(file, id) {
        return true;
    };
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return VideoProvider;
}();

function providers_classCallCheck$b(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_LinkProvider = function LinkProvider() {
    providers_classCallCheck$b(this, LinkProvider);
    this.getLinkTitle = function(href) {
        return new Promise(function(resolve, reject) {
            resolve(null);
        });
    };
    this.canGetTitle = function(href) {
        return false;
    };
};

function asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$4(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$4(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function providers_classCallCheck$c(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var providers_generator$4 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var MentionProvider = function MentionProvider() {
    providers_classCallCheck$c(this, MentionProvider);
    this.userId = "";
    this.name = "";
    this.selectPersons = /*#__PURE__*/ _asyncToGenerator$4(function() {
        return providers_generator$4(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    reject(new Error("移动端选人方法未定义"));
                })
            ];
        });
    });
    this.searchUsers = function() {
        var _ref = _asyncToGenerator$4(function(name, pageNo) {
            return providers_generator$4(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve, reject) {
                        reject(new Error("搜人方法未定义"));
                    })
                ];
            });
        });
        return function(name, pageNo) {
            return _ref.apply(this, arguments);
        };
    }();
    this.selectMentionUser = function(attrs) {};
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./composables/useUpload.js
var useUpload = __webpack_require__("15da");

// CONCATENATED MODULE: ./components/mc-rich-text-editor/utils/index.js




function isKMAttachment(uri) {
  var KM_URI_REG = /km\.sankuai\.com/g;
  return KM_URI_REG.test(uri);
}

function getFilter(handler) {
  return function () {
    return {
      // 是否有需要清洗的节点
      check: function check(attrs) {
        var src = attrs.src;
        return isKMAttachment(src);
      },
      // 执行清洗
      handle: typeof handler === 'function' ? handler : function () {
        return false;
      }
    };
  };
}
function utils_fileUpload(_x, _x2) {
  return _fileUpload.apply(this, arguments);
}

function _fileUpload() {
  _fileUpload = Object(asyncToGenerator["a" /* default */])(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(file, _ref) {
    var beforeUpload, afterUpload, url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            beforeUpload = _ref.beforeUpload, afterUpload = _ref.afterUpload;
            url = '';
            _context.prev = 2;

            if (!(typeof beforeUpload === 'function')) {
              _context.next = 6;
              break;
            }

            _context.next = 6;
            return beforeUpload();

          case 6:
            _context.next = 8;
            return Object(useUpload["b" /* fileUpload */])(file);

          case 8:
            url = _context.sent;

          case 9:
            _context.prev = 9;

            if (!(typeof afterUpload === 'function')) {
              _context.next = 13;
              break;
            }

            _context.next = 13;
            return afterUpload(url);

          case 13:
            return _context.finish(9);

          case 14:
            return _context.abrupt("return", url);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2,, 9, 14]]);
  }));
  return _fileUpload.apply(this, arguments);
}

/* harmony default export */ var mc_rich_text_editor_utils = ({
  fileUpload: utils_fileUpload,
  getFilter: getFilter
});
// CONCATENATED MODULE: ./components/mc-rich-text-editor/utils/providers/image.js









var image_ImageProvider =
/*#__PURE__*/
function (_BaseImageProvider) {
  esm_inherits_inherits(ImageProvider, _BaseImageProvider);

  function ImageProvider(_ref) {
    var _getPrototypeOf2;

    var _this;

    var hooks = _ref.hooks,
        filterHandler = _ref.filterHandler;

    Object(classCallCheck["a" /* default */])(this, ImageProvider);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = esm_possibleConstructorReturn_possibleConstructorReturn(this, (_getPrototypeOf2 = esm_getPrototypeOf_getPrototypeOf(ImageProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.upload =
    /*#__PURE__*/
    function () {
      var _upload = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(file) {
        var src;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return utils_fileUpload(file, hooks);

              case 2:
                src = _context.sent;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  var img = new Image();
                  img.src = src;

                  img.onload = function () {
                    resolve({
                      width: img.naturalWidth,
                      height: img.naturalHeight,
                      src: src
                    });
                  };

                  img.onerror = function (e) {
                    reject(e);
                  };
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function upload(_x) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }();

    _this.getFilter = getFilter(filterHandler);
    return _this;
  }

  return ImageProvider;
}(providers_ImageProvider$1);


// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js
var createClass = __webpack_require__("b0b4");

// CONCATENATED MODULE: ./components/mc-rich-text-editor/utils/providers/attachment.js













var attachment_AttachmentProvider =
/*#__PURE__*/
function (_BaseAttachmentProvid) {
  esm_inherits_inherits(AttachmentProvider, _BaseAttachmentProvid);

  function AttachmentProvider(_ref) {
    var _getPrototypeOf2;

    var _this;

    var hooks = _ref.hooks,
        filterHandler = _ref.filterHandler,
        uploadConfig = _ref.uploadConfig;

    Object(classCallCheck["a" /* default */])(this, AttachmentProvider);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = esm_possibleConstructorReturn_possibleConstructorReturn(this, (_getPrototypeOf2 = esm_getPrototypeOf_getPrototypeOf(AttachmentProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.upload =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(file) {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return utils_fileUpload(file, hooks);

              case 2:
                url = _context.sent;
                return _context.abrupt("return", new Promise(function (resolve) {
                  resolve({
                    name: file.name,
                    size: file.size,
                    src: url
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.copyCallback = function (res) {
      if (res) {
        mtd_vue_["Message"].success('复制成功');
      } else {
        mtd_vue_["Message"].error('复制失败');
      }
    };

    _this.uploadConfig = uploadConfig || {};
    _this.getFilter = getFilter(filterHandler);
    return _this;
  }

  Object(createClass["a" /* default */])(AttachmentProvider, [{
    key: "beforeUpload",
    value: function beforeUpload(file) {
      var maxFileSize = this.uploadConfig.maxFileSize || MAXIMUM_FILE_SIZE;

      if (file.size > maxFileSize * MAXIMUM_FILE_SIZE_QUANTITY) {
        mtd_vue_["Message"].warning("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(maxFileSize, "MB\uFF01"));
        return false;
      }

      return true;
    }
  }, {
    key: "onSelectFiles",
    value: function onSelectFiles(files) {
      var maxFileNumber = this.uploadConfig.maxFileNumber || MAXIMUM_FILE_NUMBER;

      if (files.length > maxFileNumber) {
        mtd_vue_["Message"].warning("\u4E0A\u4F20\u6587\u4EF6\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E".concat(maxFileNumber, "\u4E2A\uFF01"));
        return false;
      }

      return true;
    }
  }]);

  return AttachmentProvider;
}(providers_AttachmentProvider);


// CONCATENATED MODULE: ./components/mc-rich-text-editor/utils/providers/video.js













var video_VideoProvider =
/*#__PURE__*/
function (_BaseVideoProvider) {
  esm_inherits_inherits(VideoProvider, _BaseVideoProvider);

  function VideoProvider(_ref) {
    var _getPrototypeOf2;

    var _this;

    var hooks = _ref.hooks,
        filterHandler = _ref.filterHandler,
        uploadConfig = _ref.uploadConfig;

    Object(classCallCheck["a" /* default */])(this, VideoProvider);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = esm_possibleConstructorReturn_possibleConstructorReturn(this, (_getPrototypeOf2 = esm_getPrototypeOf_getPrototypeOf(VideoProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.upload =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(file) {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return utils_fileUpload(file, hooks);

              case 2:
                url = _context.sent;
                return _context.abrupt("return", new Promise(function (resolve) {
                  resolve({
                    name: file.name,
                    size: file.size,
                    url: url
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.uploadConfig = uploadConfig || {};
    _this.getFilter = getFilter(filterHandler);
    return _this;
  }

  Object(createClass["a" /* default */])(VideoProvider, [{
    key: "beforeUpload",
    value: function beforeUpload(file) {
      var maxFileSize = this.uploadConfig.maxFileSize || MAXIMUM_FILE_SIZE;

      if (file.size > maxFileSize * MAXIMUM_FILE_SIZE_QUANTITY) {
        mtd_vue_["Message"].warning("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(maxFileSize, "MB\uFF01"));
        return false;
      }

      return true;
    }
  }, {
    key: "onSelectFiles",
    value: function onSelectFiles(files) {
      var maxFileNumber = this.uploadConfig.maxFileNumber || MAXIMUM_FILE_NUMBER;

      if (files.length > maxFileNumber) {
        mtd_vue_["Message"].warning("\u4E0A\u4F20\u6587\u4EF6\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E".concat(maxFileNumber, "\u4E2A\uFF01"));
        return false;
      }

      return true;
    }
  }]);

  return VideoProvider;
}(providers_VideoProvider);


// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var esm_defineProperty = __webpack_require__("bd86");

// CONCATENATED MODULE: ./components/mc-rich-text-editor/utils/providers/audio.js

















var audio_AudioProvider =
/*#__PURE__*/
function (_BaseAudioProvider) {
  esm_inherits_inherits(AudioProvider, _BaseAudioProvider);

  function AudioProvider(_ref) {
    var _getPrototypeOf2;

    var _this;

    var hooks = _ref.hooks,
        filterHandler = _ref.filterHandler,
        uploadConfig = _ref.uploadConfig;

    Object(classCallCheck["a" /* default */])(this, AudioProvider);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = esm_possibleConstructorReturn_possibleConstructorReturn(this, (_getPrototypeOf2 = esm_getPrototypeOf_getPrototypeOf(AudioProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(esm_defineProperty["a" /* default */])(esm_assertThisInitialized_assertThisInitialized(_this), "beforeUpload", function (file) {
      var SUFFIXES = ['mp3', 'MP3', 'wma', 'm4a', 'acc', 'amr'];
      var suffix = file.name.split('.').reverse()[0].toLowerCase();

      if (!SUFFIXES.includes(suffix)) {
        mtd_vue_["Message"].warning("\u4E0D\u652F\u6301 .".concat(suffix, " \u7684\u6587\u4EF6\u683C\u5F0F!"));
        return false;
      }

      var maxFileSize = _this.uploadConfig.maxFileSize || MAXIMUM_FILE_SIZE;

      if (file.size > maxFileSize * MAXIMUM_FILE_SIZE_QUANTITY) {
        mtd_vue_["Message"].warning("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(maxFileSize, "MB\uFF01"));
        return false;
      }

      return true;
    });

    _this.upload =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(file) {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return utils_fileUpload(file, hooks);

              case 2:
                url = _context.sent;
                return _context.abrupt("return", new Promise(function (resolve) {
                  resolve({
                    name: file.name,
                    size: file.size,
                    src: url
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.copyCallback = function (res) {
      if (res) {
        mtd_vue_["Message"].success('复制成功');
      } else {
        mtd_vue_["Message"].error('复制失败');
      }
    };

    _this.uploadConfig = uploadConfig || {};
    _this.getFilter = getFilter(filterHandler);
    return _this;
  }

  Object(createClass["a" /* default */])(AudioProvider, [{
    key: "onSelectFiles",
    value: function onSelectFiles(files) {
      var maxFileNumber = this.uploadConfig.maxFileNumber || MAXIMUM_FILE_NUMBER;

      if (files.length > maxFileNumber) {
        mtd_vue_["Message"].warning("\u4E0A\u4F20\u6587\u4EF6\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E".concat(maxFileNumber, "\u4E2A\uFF01"));
        return false;
      }

      return true;
    }
  }]);

  return AudioProvider;
}(providers_AudioProvider);


// CONCATENATED MODULE: ./components/mc-rich-text-editor/utils/providers/table.js






var table_TableProvider =
/*#__PURE__*/
function (_BaseTableProvider) {
  esm_inherits_inherits(TableProvider, _BaseTableProvider);

  function TableProvider(el) {
    var _getPrototypeOf2;

    var _this;

    Object(classCallCheck["a" /* default */])(this, TableProvider);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = esm_possibleConstructorReturn_possibleConstructorReturn(this, (_getPrototypeOf2 = esm_getPrototypeOf_getPrototypeOf(TableProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getScrollWrapper = function () {
      el.querySelector('.ct-editor-container');
    };

    _this.getTopBias = function () {
      var $menuBar = el.querySelector('#menubar').getBoundingClientRect();
      if (!$menuBar) return 28;
      var top = $menuBar.top,
          height = $menuBar.height;
      return top + height;
    };

    return _this;
  }

  return TableProvider;
}(providers_TableProvider);


// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rich-text-editor/components/Editor.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//











 // 获取菜单配置里所有的的菜单类型，并去重

function getMenuTypes(menubarConfig) {
  return Array.from(menubarConfig.reduce(function (memo, _ref) {
    var type = _ref.type,
        children = _ref.children;

    if (Array.isArray(children)) {
      getMenuTypes(children).forEach(function (childType) {
        return memo.add(childType);
      });
    }

    return memo.add(type);
  }, new Set()));
} // 获取菜单类型数组中对应的富文本扩展实例


function getExtensionsByMenuTypes(menuTypes) {
  return menuTypes.reduce(function (memo, type) {
    var Extension = MENU_EXTENSION_MAPPING[type];
    if (!Extension) return memo;

    if (Array.isArray(Extension)) {
      return memo.concat(Extension.map(function (Item) {
        return new Item();
      }));
    }

    return memo.concat(new Extension());
  }, []);
}

function intProviders(_ref2) {
  var el = _ref2.el,
      _ref2$options = _ref2.options,
      hooks = _ref2$options.hooks,
      filterHandler = _ref2$options.filterHandler,
      uploadConfig = _ref2$options.uploadConfig;
  var providers = new core["e" /* Providers */]();
  providers.registerProvider('image', new image_ImageProvider({
    hooks: hooks,
    filterHandler: filterHandler,
    uploadConfig: uploadConfig
  }));
  providers.registerProvider('attachment', new attachment_AttachmentProvider({
    hooks: hooks,
    filterHandler: filterHandler,
    uploadConfig: uploadConfig
  }));
  providers.registerProvider('video', new video_VideoProvider({
    hooks: hooks,
    filterHandler: filterHandler,
    uploadConfig: uploadConfig
  }));
  providers.registerProvider('audio', new audio_AudioProvider({
    hooks: hooks,
    filterHandler: filterHandler,
    uploadConfig: uploadConfig
  }));
  providers.registerProvider('table', new table_TableProvider(el));
  return providers;
}

/* harmony default export */ var Editorvue_type_script_lang_js_ = ({
  name: 'RichTextEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    // 菜单配置
    menubar: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    beforeUpload: {
      type: Function,
      default: function _default() {}
    },
    afterUpload: {
      type: Function,
      default: function _default() {}
    },
    uploadConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props, ctx) {
    var emit = ctx.emit;
    var editorIns = Object(composition_api_["ref"])(null);
    var editorRef = Object(composition_api_["ref"])(null);
    var menubarRef = Object(composition_api_["ref"])(null);

    var _toRefs = Object(composition_api_["toRefs"])(props),
        value = _toRefs.value,
        placeholder = _toRefs.placeholder,
        menubar = _toRefs.menubar,
        _beforeUpload = _toRefs.beforeUpload,
        _afterUpload = _toRefs.afterUpload,
        uploadConfig = _toRefs.uploadConfig;

    Object(composition_api_["onMounted"])(function () {
      // provider init
      var providers = intProviders({
        el: editorRef.value,
        options: {
          hooks: {
            beforeUpload: function beforeUpload() {
              _beforeUpload.value();
            },
            afterUpload: function () {
              var _afterUpload2 = Object(asyncToGenerator["a" /* default */])(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee(url) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _afterUpload.value(url);

                        emit('after-upload', url);

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function afterUpload(_x) {
                return _afterUpload2.apply(this, arguments);
              }

              return afterUpload;
            }()
          },
          filterHandler: function filterHandler(attrs) {
            mtd_vue_["Message"].warning({
              message: "\u590D\u5236\u7684\u6587\u672C\u4E2D\u5305\u542B\u7684\u9644\u4EF6\u5B58\u5728\u6743\u9650\u63A7\u5236\uFF0C\u53EF\u80FD\u9020\u6210\u5176\u65E0\u6CD5\u8BBF\u95EE\uFF0C\u8BF7\u4E0B\u8F7D\u539F\u6587\u4EF6\u540E\u91CD\u65B0\u4E0A\u4F20\u3002<a href='".concat(attrs.src, "'>\u70B9\u51FB\u4E0B\u8F7D</a>"),
              duration: 0,
              showClose: true,
              dangerouslyUseHTMLString: true
            });
            return false;
          },
          uploadConfig: uploadConfig.value
        }
      }); // editor init

      editorIns.value = new lite_editor(editorRef.value, {
        providers: providers,
        extensions: getExtensionsByMenuTypes(getMenuTypes(menubar.value)),
        defaultValue: value.value,
        placeholder: placeholder.value
      }); // menubar init

      var menubarIns = new es_menubar(menubarRef.value, menubar.value);
      editorIns.value.addMenubar(menubarIns);
      editorIns.value.init(function () {
        return editorIns.value.setCursor('end');
      });
      editorIns.value.onChange(
      /*#__PURE__*/
      function () {
        var _ref3 = Object(asyncToGenerator["a" /* default */])(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(str) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return Object(composition_api_["nextTick"])();

                case 2:
                  emit('change', str);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    });
    Object(composition_api_["watch"])(value,
    /*#__PURE__*/
    function () {
      var _ref4 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(val) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                editorIns.value.value(val);
                editorIns.value.setCursor('end');

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    function getImageUrls() {
      var imgEls = editorRef.value.querySelectorAll('.editor .ct-image img');
      return Object(tools_["map"])(imgEls, function (el) {
        return el.src;
      });
    }

    function getVideoUrls() {
      var videoEls = editorRef.value.querySelectorAll('.editor .ct-video video');
      return Object(tools_["map"])(videoEls, function (el) {
        return el.src;
      });
    }

    return {
      editorIns: editorIns,
      editorRef: editorRef,
      menubarRef: menubarRef,
      getImageUrls: getImageUrls,
      getVideoUrls: getVideoUrls
    };
  }
});
// CONCATENATED MODULE: ./components/mc-rich-text-editor/components/Editor.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Editorvue_type_script_lang_js_ = (Editorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-rich-text-editor/components/Editor.vue





/* normalize component */

var Editor_component = Object(componentNormalizer["a" /* default */])(
  components_Editorvue_type_script_lang_js_,
  Editorvue_type_template_id_2c819d8e_render,
  Editorvue_type_template_id_2c819d8e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Editor = (Editor_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rich-text-editor/components/Preview.vue?vue&type=template&id=541b8e9e&
var Previewvue_type_template_id_541b8e9e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"viewRef",staticClass:"mc-rich--text--editor--view",class:{ 'mc-rich--text--editor--disabled': _vm.disabled }}),_c('mc-image-preview',{attrs:{"data":_vm.images,"visible":_vm.imagePreview,"current-index":_vm.imageIndex,"z-index":_vm.previewZIndex},on:{"close":function($event){_vm.imagePreview = false}}})],1)}
var Previewvue_type_template_id_541b8e9e_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-rich-text-editor/components/Preview.vue?vue&type=template&id=541b8e9e&

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__("c0c4");
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);

// CONCATENATED MODULE: ./node_modules/@it/parker/es/render/index.js




/**
 * 统一样式前缀
 */ var render_CLASSNAME_PREFIX = "ct";
var PARKER_CLASSNAME_PREFIX = "pk";

var render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var classNameParkerPrefix = function(className) {
    return render_classNamePrefix(className, PARKER_CLASSNAME_PREFIX);
};

function render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var render_css_248z = '.ProseMirror *,.ProseMirror :after,.ProseMirror :before{box-sizing:border-box}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.ct-editor h5,.ct-editor h6,.ct-editor p,.ct-editor pre{margin:8px 0;color:#333;word-break:break-word;clear:both}.ct-editor p,.ct-editor pre{font-size:14px;line-height:22px;min-height:24px}.ct-editor h1{font-size:28px;font-weight:700;line-height:42px;min-height:42px}.ct-editor h2{font-size:24px;font-weight:700;line-height:36px;min-height:36px}.ct-editor h3{font-size:20px;font-weight:700;line-height:30px}.ct-editor h4{font-size:16px;font-weight:700;line-height:22px;min-height:24px}.ct-editor h5{font-size:14px;font-weight:700;line-height:21px;min-height:21px}.ct-editor h6{font-size:12px;font-weight:700;line-height:18px;min-height:18px}.ct-editor hr{display:block;height:1px;width:100%;border:0;background:#ccc}.ProseMirror{position:relative;word-wrap:break-word;white-space:pre-wrap;white-space:break-spaces;font-variant-ligatures:none;font-feature-settings:"liga" 0}.ProseMirror p{font-size:14px;line-height:22px;min-height:24px;margin:8px 0;color:#333;word-break:break-word;clear:both}.ProseMirror pre{white-space:pre-wrap}.ProseMirror li{position:relative}.ProseMirror-hideselection *::-moz-selection{background:transparent}.ProseMirror-hideselection ::selection{background:transparent}.ProseMirror-hideselection ::-moz-selection{background:transparent}li.ProseMirror-selectednode{outline:none}li.ProseMirror-selectednode:after{content:"";position:absolute;left:-32px;right:-2px;top:-2px;bottom:-2px;border:2px solid #8cf;pointer-events:none}.pk-view-container p{font-size:14px;line-height:22px;min-height:24px;margin:8px 0;color:#333;word-break:break-word;clear:both}';
render_styleInject(render_css_248z);

function render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function render_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var render_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var intersectionObserverConfig = {
    rootMargin: "0px 0px 200px 0px"
};
var createIntersectionObserver = function() {
    return new IntersectionObserver(function(entries) {
        entries.filter(function(param) {
            var isIntersecting = param.isIntersecting;
            return isIntersecting;
        }).forEach(function(param) {
            var target = param.target;
            var src = target.getAttribute("data-src");
            target.setAttribute("src", src);
        });
    }, intersectionObserverConfig);
};
var render_EditorRender = function EditorRender(dom, param) {
    var _param_defaultValue = param.defaultValue, defaultValue = _param_defaultValue === void 0 ? "" : _param_defaultValue, _param_renders = param.renders, renders = _param_renders === void 0 ? [] : _param_renders, _param_lazyload = param.lazyload, lazyload = _param_lazyload === void 0 ? false : _param_lazyload;
    var _this = this;
    render_classCallCheck(this, EditorRender);
    this.setValue = function(str) {
        if (str && typeof str === "string") {
            // 临时方案，替换className前缀，后期会修改数据存储格式
            _this.htmlString = str;
        } else {
            _this.htmlString = "";
        }
    };
    var _this1 = this;
    this.render = function() {
        var _ref = render_asyncToGenerator(function(htmlString) {
            var documentFragment, $container, i;
            return render_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this1.setValue(htmlString);
                        documentFragment = document.createDocumentFragment();
                        $container = document.createElement("div");
                        $container.classList.add(classNameParkerPrefix("view-container"));
                        $container.innerHTML = purify_default.a.sanitize(_this1.htmlString, {
                            ALLOW_UNKNOWN_PROTOCOLS: true
                        });
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < _this1.renders.length)) return [
                            3,
                            4
                        ];
                        if (!_this1.renders[i].preprocess) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this1.renders[i].preprocess($container, {
                                lazyload: _this1.lazyload,
                                containerWidth: _this1.dom.clientWidth
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        _this1.renders.forEach(function(render) {
                            if (render.fragmentCls && render.fragmentRender) {
                                Array.from($container.querySelectorAll(render.fragmentCls)).forEach(function(node) {
                                    render.fragmentRender(node, $container);
                                });
                            }
                        });
                        _this1.renders.forEach(function(render) {
                            if (render.containerRender) {
                                render.containerRender($container, {
                                    lazyload: _this1.lazyload,
                                    containerWidth: _this1.dom.clientWidth
                                });
                            }
                        });
                        documentFragment.appendChild($container);
                        _this1.clearDOM(_this1.dom);
                        _this1.dom.appendChild(documentFragment);
                        if (_this1.lazyload) {
                            _this1.intersectionObserver = createIntersectionObserver();
                            _this1.initLazyload();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(htmlString) {
            return _ref.apply(this, arguments);
        };
    }();
    this.clearDOM = function(dom) {
        dom.innerHTML = "";
    };
    this.initLazyload = function() {
        if (_this.lazyload) {
            Array.from(_this.dom.querySelectorAll("img")).forEach(function(node) {
                if (node.getAttribute("data-src")) {
                    _this.intersectionObserver.observe(node);
                }
            });
        }
    };
    this.dom = dom;
    this.renders = renders;
    this.lazyload = lazyload;
    if (!window.IntersectionObserver) this.lazyload = false;
    this.clearDOM(this.dom);
    this.render(defaultValue);
};

/* harmony default export */ var es_render = (render_EditorRender);
//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/bullet-list-extension/render.js



/**
 * 统一样式前缀
 */ var bullet_list_extension_render_CLASSNAME_PREFIX = "ct";

var bullet_list_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : bullet_list_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function bullet_list_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var bullet_list_extension_render_css_248z = ".pk-view-container ul{margin:8px 0;padding-left:24px}.pk-view-container ul li[data-list-item-diff-id]{min-height:24px;font-size:14px;list-style:inherit}.pk-view-container ul>h1,.pk-view-container ul>h2,.pk-view-container ul>h3,.pk-view-container ul>h4,.pk-view-container ul>h5,.pk-view-container ul>h6,.pk-view-container ul>p{margin:0}.pk-view-container ul .ct-image{vertical-align:top}.pk-view-container ul hr{display:inline-block}.pk-view-container .ct-item-level-1{font-size:28px}.pk-view-container .ct-item-level-2{font-size:24px}.pk-view-container .ct-item-level-3{font-size:20px}.pk-view-container .ct-item-level-4{font-size:16px}.pk-view-container .ct-item-level-5{font-size:14px}.pk-view-container .ct-item-level-6{font-size:12px}.pk-view-container ul .ct-item-level-1{margin-left:7px}.pk-view-container ul .ct-item-level-2{margin-left:6px}.pk-view-container ul .ct-item-level-3{margin-left:3px}.pk-view-container ul .ct-item-level-4{margin-left:2px}.pk-view-container ul .ct-item-level-6{margin-left:-1px}.pk-view-container ul{list-style-type:disc}.pk-view-container ul ul{list-style-type:square}.pk-view-container ul ul ul{list-style-type:circle}.pk-view-container ul ul ul ul{list-style-type:disc}.pk-view-container ul ul ul ul ul{list-style-type:square}.pk-view-container ul ul ul ul ul ul{list-style-type:circle}.pk-view-container ul ul ul ul ul ul ul{list-style-type:disc}.pk-view-container ul ul ul ul ul ul ul ul{list-style-type:square}.pk-view-container ul ul ul ul ul ul ul ul ul{list-style-type:circle}";
bullet_list_extension_render_styleInject(bullet_list_extension_render_css_248z);

function bullet_list_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var bulletListRender = function bulletListRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    bullet_list_extension_render_classCallCheck(this, bulletListRender);
    this.fragmentCls = ".".concat(bullet_list_extension_render_classNamePrefix("bullet-list"));
    this.config = config;
};

/* harmony default export */ var bullet_list_extension_render = (bulletListRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/ordered-list-extension/render.js



/**
 * 统一样式前缀
 */ var ordered_list_extension_render_CLASSNAME_PREFIX = "ct";

var ordered_list_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ordered_list_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function ordered_list_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var ordered_list_extension_render_css_248z = ".pk-view-container ol{margin:8px 0;padding-left:24px}.pk-view-container ol li[data-list-item-diff-id]{min-height:24px;font-size:14px;list-style:inherit}.pk-view-container ol>h1,.pk-view-container ol>h2,.pk-view-container ol>h3,.pk-view-container ol>h4,.pk-view-container ol>h5,.pk-view-container ol>h6,.pk-view-container ol>p{margin:0}.pk-view-container ol .ct-image{vertical-align:top}.pk-view-container ol hr{display:inline-block}.pk-view-container .ct-item-level-1{font-size:28px}.pk-view-container .ct-item-level-2{font-size:24px}.pk-view-container .ct-item-level-3{font-size:20px}.pk-view-container .ct-item-level-4{font-size:16px}.pk-view-container .ct-item-level-5{font-size:14px}.pk-view-container .ct-item-level-6{font-size:12px}.pk-view-container ol .ct-item-level-1{margin-left:12px}.pk-view-container ol .ct-item-level-2{margin-left:8px}.pk-view-container ol .ct-item-level-3{margin-left:5px}.pk-view-container ol .ct-item-level-4{margin-left:1px}.pk-view-container ol .ct-item-level-6{margin-left:-2px}.pk-view-container ol{list-style-type:decimal}.pk-view-container ol ol{list-style-type:lower-alpha}.pk-view-container ol ol ol{list-style-type:lower-roman}.pk-view-container ol ol ol ol{list-style-type:decimal}.pk-view-container ol ol ol ol ol{list-style-type:lower-alpha}.pk-view-container ol ol ol ol ol ol{list-style-type:lower-roman}.pk-view-container ol ol ol ol ol ol ol{list-style-type:decimal}.pk-view-container ol ol ol ol ol ol ol ol{list-style-type:lower-alpha}.pk-view-container ol ol ol ol ol ol ol ol ol{list-style-type:lower-roman}";
ordered_list_extension_render_styleInject(ordered_list_extension_render_css_248z);

function ordered_list_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var orderedListRender = function orderedListRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ordered_list_extension_render_classCallCheck(this, orderedListRender);
    this.fragmentCls = ".".concat(ordered_list_extension_render_classNamePrefix("ordered-list"));
    this.config = config;
};

/* harmony default export */ var ordered_list_extension_render = (orderedListRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/task-list-extension/render.js



/**
 * 统一样式前缀
 */ var task_list_extension_render_CLASSNAME_PREFIX = "ct";

var task_list_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : task_list_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function task_list_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var task_list_extension_render_css_248z = '.pk-view-container ul{margin:8px 0;padding-left:24px}.pk-view-container ul li{min-height:24px;font-size:14px}.pk-view-container ul>h1,.pk-view-container ul>h2,.pk-view-container ul>h3,.pk-view-container ul>h4,.pk-view-container ul>h5,.pk-view-container ul>h6,.pk-view-container ul>p{margin:0}.pk-view-container ul .ct-image{vertical-align:top}.pk-view-container ul hr{display:inline-block}.pk-view-container .ct-item-level-1{font-size:28px}.pk-view-container .ct-item-level-2{font-size:24px}.pk-view-container .ct-item-level-3{font-size:20px}.pk-view-container .ct-item-level-4{font-size:16px}.pk-view-container .ct-item-level-5{font-size:14px}.pk-view-container .ct-item-level-6{font-size:12px}.pk-view-container ul .ct-item-level-1{margin-left:7px}.pk-view-container ul .ct-item-level-2{margin-left:6px}.pk-view-container ul .ct-item-level-3{margin-left:3px}.pk-view-container ul .ct-item-level-4{margin-left:2px}.pk-view-container ul .ct-item-level-6{margin-left:-1px}.pk-view-container .ct-task-list{list-style-type:none!important}.pk-view-container .ct-task-list li{margin-left:0}.pk-view-container .ct-task-list .ct-task-li{position:relative;list-style-type:none!important}.pk-view-container .ct-task-list .ct-task-li:before{content:"";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url("data:image/svg+xml,%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg transform%3D%22translate(-57.000000%2C -393.000000)%22 fill%3D%22%236E6B6B%22%3E            %3Cg transform%3D%22translate(56.000000%2C 389.000000)%22%3E                %3Cpath d%3D%22M1%2C4 L17%2C4 L17%2C20 L1%2C20 L1%2C4 Z M2%2C5 L2%2C19 L16%2C19 L16%2C5 L2%2C5 Z%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.pk-view-container .ct-task-list .ct-task-li-checked{position:relative;list-style-type:none!important}.pk-view-container .ct-task-list .ct-task-li-checked:before{content:"";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url("data:image/svg+xml,%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%2203%E3%80%81%E7%BC%96%E8%BE%91%E9%A1%B5-%E4%BB%BB%E5%8A%A1%E5%88%97%E8%A1%A8%EF%BC%881024%EF%BC%89%22 transform%3D%22translate(-57.000000%2C -497.000000)%22 fill%3D%22%23AAAAAA%22%3E            %3Cg id%3D%22Group-13-Copy%22 transform%3D%22translate(56.000000%2C 493.000000)%22%3E                %3Cg id%3D%22Group-3%22 transform%3D%22translate(1.000000%2C 4.000000)%22%3E                    %3Cpath d%3D%22M12%2C1.11022302e-16 L12%2C1 L1%2C1 L1%2C15 L15%2C15 L15%2C7 L16%2C7 L16%2C16 L0%2C16 L0%2C0 L12%2C0 Z M6.90823822%2C9.72780075 L14.2928932%2C2.34314575 C14.6834175%2C1.95262146 15.3165825%2C1.95262146 15.7071068%2C2.34314575 C16.0976311%2C2.73367004 16.0976311%2C3.36683502 15.7071068%2C3.75735931 L7.63603897%2C11.8284271 C7.43551353%2C12.0289526 7.17101366%2C12.1265127 6.90823822%2C12.1211075 C6.64546278%2C12.1265127 6.38096291%2C12.0289526 6.18043747%2C11.8284271 L2.93779678%2C8.58578644 C2.54727249%2C8.19526215 2.54727249%2C7.56209717 2.93779678%2C7.17157288 C3.32832107%2C6.78104858 3.96148605%2C6.78104858 4.35201034%2C7.17157288 L6.90823822%2C9.72780075 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.pk-view-container .ct-task-li-checked:after,.pk-view-container .ct-task-li-checked:before,.pk-view-container .ct-task-li:before{cursor:pointer}.pk-view-container .ct-task-list .ct-item-level-1:before{top:15px}.pk-view-container .ct-task-list .ct-item-level-2:before{top:12px}.pk-view-container .ct-task-list .ct-item-level-3:before{top:8px}.pk-view-container .ct-task-list .ct-item-level-4:before{top:5px}.pk-view-container .ct-task-list .ct-item-level-6:before{top:1px}.pk-view-container .ct-task-list .ct-task-li-checked audio,.pk-view-container .ct-task-list .ct-task-li-checked div,.pk-view-container .ct-task-list .ct-task-li-checked h1,.pk-view-container .ct-task-list .ct-task-li-checked h2,.pk-view-container .ct-task-list .ct-task-li-checked h3,.pk-view-container .ct-task-list .ct-task-li-checked h4,.pk-view-container .ct-task-list .ct-task-li-checked h5,.pk-view-container .ct-task-list .ct-task-li-checked h6,.pk-view-container .ct-task-list .ct-task-li-checked p,.pk-view-container .ct-task-list .ct-task-li-checked span,.pk-view-container .ct-task-list .ct-task-li-checked video{opacity:.7}.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li audio,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li div,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li h1,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li h2,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li h3,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li h4,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li h5,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li h6,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li p,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li span,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li video{opacity:unset}.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.pk-view-container .ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}';
task_list_extension_render_styleInject(task_list_extension_render_css_248z);

function task_list_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var taskListRender = function taskListRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    task_list_extension_render_classCallCheck(this, taskListRender);
    this.fragmentCls = ".".concat(task_list_extension_render_classNamePrefix("task-list"));
    this.config = config;
};

/* harmony default export */ var task_list_extension_render = (taskListRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/table-extension/render.js




/**
 * 统一样式前缀
 */ var table_extension_render_CLASSNAME_PREFIX = "ct";

var table_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : table_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
// 获取浏览器和系统信息
function render_getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

// dpi=1.25时，表格宽度需要为 4 的整数倍
var render_formatWidth = function(width) {
    // width = Math.round(width);
    // width = Math.round(width / 4) * 4;
    return width;
};

function render_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var getColWidth = function(attr) {
    if (!attr) return undefined;
    return attr.split(",").reduce(function(p, c) {
        return +p + +c;
    }, 0);
};
/**
 * 计算表格总宽度
 * 及判断表格是否存在宽度信息
 */ var calculateTableWidth = function(tr) {
    var tableWidth = 0;
    var allHasWidth = true;
    Array.from(tr).forEach(function(td) {
        if (!render_instanceof(td, HTMLElement)) return;
        if (!td.getAttribute("data-colwidth") || td.getAttribute("data-colwidth") === "0") {
            allHasWidth = false;
        } else {
            var width = getColWidth(td.getAttribute("data-colwidth"));
            // 处理存在 colspan>1 但是 data-colwidth只有一个值 而非 data-colwidth='68,68,68'的形式
            var colspan = td.getAttribute("colspan");
            var dataWidth = td.getAttribute("data-colwidth");
            var dataLen = (dataWidth || "").split(",").length;
            if (dataLen === 1 && colspan && +colspan > 1) {
                width = +colspan * +dataWidth;
            }
            if (window.devicePixelRatio === 1.25) {
                width = render_formatWidth(width);
            }
            tableWidth += width;
        }
    });
    return {
        tableWidth: tableWidth,
        allHasWidth: allHasWidth
    };
};
// table中插入 colgroup 标签
function addColGroup(table) {
    if (Array.from(table.children).some(function(ele) {
        return (ele.tagName || "").toLowerCase() === "colgroup";
    })) {
        return;
    }
    var tbodyChild = table.getElementsByTagName("tbody")[0];
    if (!tbodyChild) {
        return;
    }
    var firstTr = tbodyChild.childNodes[0];
    if (!firstTr) return;
    var colgroup = document.createElement("colgroup");
    Array.from(firstTr.childNodes).forEach(function(td) {
        if (!render_instanceof(td, HTMLElement)) return;
        var colspan = td.getAttribute("colspan");
        var colwidth = td.getAttribute("data-colwidth");
        var widthArr = colwidth && colwidth.split(",") || [];
        if (colspan) {
            for(var i = 0; i < +colspan; i++){
                var col = document.createElement("col");
                var width = widthArr && widthArr[i];
                width = +width;
                if (width) {
                    if (window.devicePixelRatio === 1.25) {
                        width = render_formatWidth(width);
                    }
                    col.setAttribute("style", "width: ".concat(width, "px;"));
                }
                colgroup.appendChild(col);
            }
        } else {
            var col1 = document.createElement("col");
            if (+colwidth) {
                if (window.devicePixelRatio === 1.25) {
                    colwidth = render_formatWidth(+colwidth);
                }
                col1.setAttribute("style", "width: ".concat(colwidth, "px;"));
            }
            colgroup.appendChild(col1);
        }
    });
    table.insertBefore(colgroup, table.childNodes[0]);
}
// 处理窗口放大情况下的表格宽度处理
function translateWidthForScaleWindow(td, originTds, index) {
    td.forEach(function(i, ind) {
        var width = getColWidth(i.getAttribute("data-colwidth"));
        width = render_formatWidth(width);
        var originTd = originTds && originTds[ind];
        if (width) {
            if (index === 0) {
                i.style.cssText = "".concat(i.style.cssText, " min-width: ").concat(width, "px; max-width: ").concat(width, "px;");
            }
            i.setAttribute("width", "".concat(width, "px"));
            return;
        }
        // 解决表头吸顶无宽度
        var clientWidth = originTds && originTd ? originTd.clientWidth : i.clientWidth;
        clientWidth += 18;
        clientWidth = render_formatWidth(clientWidth);
        if (clientWidth < 52) clientWidth = 52;
        if (index === 0) {
            i.setAttribute("width", "".concat(clientWidth, "px"));
            i.style.cssText = "".concat(i.style.cssText, " min-width: ").concat(clientWidth, "px; max-width: ").concat(clientWidth, "px;");
        } else {
            i.setAttribute("width", "".concat(clientWidth, "px"));
        }
    });
}
// 将表头的 data-colwidth 转成 width
function translateWidth(table, originTable) {
    var tableInCollapse = originTable && originTable.closest(".ct-collapse-content");
    var tableLayout = table.getAttribute("data-table-layout");
    // 展开宏内表格自适应宽度的情况 需要先展开宏展开进行宽度计算 否则获取不到正确宽度
    if (tableInCollapse && tableLayout && tableLayout === "auto") {
        tableInCollapse.style.display = "block";
    }
    Array.from(table.querySelectorAll("tr")).forEach(function(tr, index) {
        var tds = tr.querySelectorAll("th, td");
        if (!tds) return;
        var originTrs = originTable && originTable.querySelectorAll("tr");
        var originTds = originTrs && originTrs[index] && originTrs[index].querySelectorAll("th, td");
        // 解决 windows 下显示默认125%的缩放
        if (window.devicePixelRatio === 1.25) {
            translateWidthForScaleWindow(tds, originTds, index);
            return;
        }
        Array.from(tds).forEach(function(td, ind) {
            var width = getColWidth(td.getAttribute("data-colwidth"));
            // 将表格行号列转成真实的数据，以便排序
            var isNumCell = td.classList.contains("num-cell");
            var isMobile = render_getSystemInfo().isMobile;
            if (isNumCell && !isMobile) {
                td.classList.add("num-cell-view");
            }
            // 在需要设置overflow的地址设置 避免所有都设置overflow属性 导致大文档加载卡死
            var needOverFlow = td.querySelector('a[class="ct-attachment"]') || td.querySelector(".ct-status");
            var originTd = originTds && originTds[ind];
            if (width) {
                if (index === 0) {
                    td.style.cssText = "".concat(td.style.cssText, " min-width: ").concat(width, "px; max-width: ").concat(width, "px; width: ").concat(width, "px;");
                }
                td.setAttribute("width", "".concat(width, "px"));
                if (needOverFlow) td.style.overflow = "hidden";
                return;
            }
            // 解决表头吸顶无宽度
            var clientWidth = originTds && originTd ? originTd.clientWidth : td.clientWidth;
            clientWidth += 18; // 原始宽度没有 padding 需要加上 padding
            if (clientWidth < 50) clientWidth = 50;
            td.setAttribute("width", "".concat(clientWidth, "px"));
            if (needOverFlow) td.style.overflow = "hidden";
            td.style.cssText = "".concat(td.style.cssText, " min-width: ").concat(clientWidth, "px; max-width: ").concat(clientWidth, "px;");
        });
    });
    if (tableInCollapse && tableLayout && tableLayout === "auto") {
        tableInCollapse.style.display = "none";
    }
}
// 添加表格表框解决表格表框 丢失一部分或者 粗细只有一半
function addTableBorder(table) {
    var _table_dataset = table.dataset, bordercolor = _table_dataset.bordercolor, borderwidth = _table_dataset.borderwidth, borderstyle = _table_dataset.borderstyle;
    if (borderwidth === "0") return;
    var borderCSS = "".concat(borderwidth || 1, "px ").concat(borderstyle || "solid", " ").concat(bordercolor || "#cccccc");
    table.style.borderTop = borderCSS;
    if (borderwidth) {
        table.style.borderLeft = borderCSS;
    }
}

function table_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var table_extension_render_css_248z = ".ct-table-view{display:block;overflow-x:auto;overflow-y:hidden;margin:24px 0 8px;padding-bottom:1px;padding-right:1px;counter-reset:cellnumber}.ct-table-view table,.ct-table-view tbody,.ct-table-view td,.ct-table-view th{background-clip:padding-box!important}.ct-table-view table{width:auto;border-collapse:collapse;table-layout:fixed;word-break:break-all;position:relative;overflow:auto;margin:0}.ct-table-view td,.ct-table-view th{box-sizing:border-box;width:auto;min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;padding:1px 8px;border:1px solid #ddd;vertical-align:top;background-color:#fff;outline:none;position:relative}.ct-table-view td.overflow,.ct-table-view th.overflow{overflow:hidden;position:relative}.ct-table-view td>ol,.ct-table-view td>ul,.ct-table-view th>ol,.ct-table-view th>ul{overflow:hidden}.ct-table-view th{text-align:left;background-color:#f6f6f6;overflow:hidden}.ct-table-view td{overflow:hidden}.ct-table-view table td>p>span.ct-node-view-dom,.ct-table-view table th>p>span.ct-node-view-dom{margin:0 0 0 -3px}.ct-table-view table.responsive>tbody>tr>td,.ct-table-view table.responsive>tbody>tr>th{width:auto!important;min-width:52px}.ct-table-view .num-cell{counter-increment:cellnumber;vertical-align:top;text-align:center;color:#000;padding:8px 0;font-size:12px;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.ct-table-view .num-cell:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;content:counter(cellnumber)}.ct-table-view .num-cell p{display:none}.ct-table-view h1,.ct-table-view h2,.ct-table-view h3,.ct-table-view h4,.ct-table-view h5,.ct-table-view h6,.ct-table-view p{min-width:0;margin-top:8px}.ct-table-view ol,.ct-table-view ul{padding-left:34px}";
table_extension_render_styleInject(table_extension_render_css_248z);

function table_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var tableRender = function tableRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    table_extension_render_classCallCheck(this, tableRender);
    this.fragmentRender = function(node) {
        if (!node.querySelector("tr")) return; // 过滤空表格
        if (node.parentNode.classList.contains(table_extension_render_classNamePrefix("table-view"))) {
            return;
        }
        // 为 table 多加一层 <div class='ct-table-view'>...</div>
        var newNode = document.createElement("div");
        newNode.setAttribute("class", table_extension_render_classNamePrefix("table-view"));
        node.parentNode.insertBefore(newNode, node);
        newNode.appendChild(node);
        var hasMargin = node.style.marginLeft;
        if (hasMargin) {
            node.parentNode.style.marginLeft = hasMargin;
            node.parentNode.style.marginRight = "1px"; // 使得滚动到最右侧能显示边框
            node.parentNode.style.width = "calc(100% - ".concat(parseInt(hasMargin, 10) + 1, "px)");
            node.style.marginLeft = 0;
        }
        var isResponsive = node.classList.contains("responsive");
        var tr = node.querySelectorAll("tr");
        var trLen = tr && tr.length === 1;
        var tableLayout = node.getAttribute("data-table-layout");
        if (!isResponsive) {
            // 计算table总宽度
            var tablechild = node.querySelector("tr:first-child").childNodes;
            var _calculateTableWidth = calculateTableWidth(tablechild), tableWidth = _calculateTableWidth.tableWidth, allHasWidth = _calculateTableWidth.allHasWidth;
            if (allHasWidth && !node.hasAttribute("width")) {
                node.style.width = "".concat(tableWidth, "px");
            }
            if (!allHasWidth && !node.hasAttribute("min-width") && tableWidth) {
                node.style.minWidth = "".concat(tableWidth, "px");
            }
            addColGroup(node);
            // 仅有一个表头且表格为自适应宽度的不需要转换宽度
            if (trLen && tableLayout === "auto") return;
            translateWidth(node);
        }
        addTableBorder(node);
    };
    this.fragmentCls = "table";
    this.config = config;
};

/* harmony default export */ var table_extension_render = (tableRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/note-extension/render.js



/**
 * 统一样式前缀
 */ var note_extension_render_CLASSNAME_PREFIX = "ct";

var note_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : note_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function note_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var note_extension_render_css_248z = '.ct-note-selected .ct-note{border-color:#fdc446}.ct-note-selected .ct-note[data-type=info]{border-color:#23bdd9}.ct-note-selected .ct-note[data-type=tip]{border-color:#53752d}.ct-note-selected .ct-note[data-type=warning]{border-color:#e75252}.ct-note{min-width:265px;min-height:42px;margin:8px 0;border:1px solid transparent;border-radius:4px;background-color:#fffbe6}.ct-note.ProseMirror-selectednode{border-color:#fdc446}.ct-note[data-type=info]{background-color:#e6ffff}.ct-note[data-type=info].ProseMirror-selectednode{border-color:#23bdd9}.ct-note[data-type=tip]{background-color:#f6ffed}.ct-note[data-type=tip].ProseMirror-selectednode{border-color:#53752d}.ct-note[data-type=warning]{background-color:#fff1f0}.ct-note[data-type=warning].ProseMirror-selectednode{border-color:#e75252}.ct-note.ProseMirror-selectednode{position:relative}.ct-note.ProseMirror-selectednode:after{z-index:2;position:absolute;content:"";left:-1px;right:-1px;top:-1px;bottom:-1px;background-color:#23bdd9;opacity:.2;pointer-events:none}.ct-note.ProseMirror-selectednode>.ct-note-content,.ct-note.ProseMirror-selectednode>.ct-note-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hidden-title{background:#fffbe6 url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395614592%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223358%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23FDC446%22 p-id%3D%223359%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 10px 11px}.hidden-title>.ct-note-title{display:none}.hidden-title[data-type=info]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395638204%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223862%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 0.448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z%22 fill%3D%22%233d91f2%22 p-id%3D%223863%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.hidden-title[data-type=tip]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395631927%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223694%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M550.4 573.76V601.6a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-0.96c0.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8 0.96c-0.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048v61.952a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z%22 fill%3D%22%2370B123%22 p-id%3D%223695%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.hidden-title[data-type=warning]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395624224%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223526%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23F05E50%22 p-id%3D%223527%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-note-title{min-height:24px;padding:8px 0;font-size:14px;font-weight:700;color:#333;line-height:24px}.ct-note-title>.ct-note-title-text{position:relative;display:inline-block;min-height:24px;padding-left:36px;color:#333;line-height:24px;font-family:PingFangSC-Medium;font-size:13px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395614592%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223358%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23FDC446%22 p-id%3D%223359%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat;background-position:10px 3px}[data-type=info]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395638204%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223862%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 0.448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z%22 fill%3D%22%233d91f2%22 p-id%3D%223863%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}[data-type=tip]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395631927%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223694%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M550.4 573.76V601.6a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-0.96c0.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8 0.96c-0.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048v61.952a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z%22 fill%3D%22%2370B123%22 p-id%3D%223695%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}[data-type=warning]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395624224%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223526%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23F05E50%22 p-id%3D%223527%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-note-content{padding:0 8px 0 36px}.ct-note-content p{margin:8px 0}';
note_extension_render_styleInject(note_extension_render_css_248z);

function note_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var noteRender = function noteRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    note_extension_render_classCallCheck(this, noteRender);
    this.fragmentRender = function(node) {
        Array.from(node.children).forEach(function(child) {
            if (child.innerHTML.trim() === "") {
                node.removeChild(child);
            }
        });
    };
    this.fragmentCls = ".".concat(note_extension_render_classNamePrefix("note"));
    this.config = config;
};

/* harmony default export */ var note_extension_render = (noteRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/collapse-extension/render.js



/**
 * 统一样式前缀
 */ var collapse_extension_render_CLASSNAME_PREFIX = "ct";

var collapse_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : collapse_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function collapse_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var collapse_extension_render_css_248z = '.ct-collapse{min-width:267px;margin:8px 0;padding:8px;border-radius:2px}.ct-collapse.active>.ct-collapse-title{padding-bottom:8px}.ct-collapse.active>.ct-collapse-title .ct-collapse-title-text:before{transform:rotate(0deg)}.ct-collapse.active>.ct-collapse-content{display:block;height:auto;padding:8px 24px;border-radius:2px}.ct-collapse .ct-collapse-title{line-height:16px}.ct-collapse .ct-collapse-title>.ct-collapse-title-text{position:relative;padding-left:24px;color:#4d4d4d;font-family:PingFangSC-Medium;font-size:13px;vertical-align:top}.ct-collapse .ct-collapse-title>.ct-collapse-title-text:before{position:absolute;top:2px;left:3px;content:"";width:16px;height:16px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22        %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526953416889%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22     p-id%3D%223453%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%228%22 height%3D%228%22%3E    %3Cdefs%3E        %3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E    %3C%2Fdefs%3E    %3Cpath d%3D%22M375.966782 310.02559401L28.2073 642.809787a89.339756 89.339756 0 0 0 0 130.169816 99.323282 99.323282 0 0 0 136.057537 0L512.024319 440.323405 859.7838 773.107597a99.323282 99.323282 0 0 0 136.057538 0 89.339756 89.339756 0 0 0 0-130.169817l-347.759482-332.784192-65.916869-59.389179a105.722978 105.722978 0 0 0-140.281336 0l-65.916869 59.389179z%22          fill%3D%22%23747272%22 p-id%3D%223454%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%;transform:rotate(-180deg);transition:transform .2s;cursor:pointer}.ct-collapse>.ct-collapse-content{height:.1px;padding:0;background:transparent;overflow:hidden}.ProseMirror .ct-collapse{overflow:hidden}.ProseMirror .ct-collapse.active>.ct-collapse-content{display:block;height:auto;border-radius:2px}.ProseMirror .ct-collapse>.ct-collapse-content{display:none;overflow:unset}.ProseMirror .ct-collapse:hover{background-color:#f6f6f6}.ProseMirror .ct-collapse:hover>.ct-collapse-content{background-color:#fff}.ProseMirror .ct-collapse-show.ct-collapse{background-color:#f6f6f6;border:1px solid #ddd}.ProseMirror .ct-collapse-show.ct-collapse>.ct-collapse-content{background-color:#f6f6f6}.ProseMirror .ct-collapse-show.active>.ct-collapse-content{background-color:#fff;border:1px solid #ddd}.ProseMirror-selectednode.ct-collapse{border:1px solid #1c6cdc}.ProseMirror .ct-collapse.ProseMirror-selectednode{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pm-body-wrapper .ct-collapse-title-text{cursor:pointer}';
collapse_extension_render_styleInject(collapse_extension_render_css_248z);

function collapse_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function render_handleClick(e) {
    var $target = e.target;
    if (!$target.closest(".".concat(collapse_extension_render_classNamePrefix("collapse-title")))) return;
    var $collapse = $target.closest(".".concat(collapse_extension_render_classNamePrefix("collapse")));
    var cls = $collapse.classList;
    if (cls.contains("active")) {
        cls.remove("active");
    } else {
        cls.add("active");
    }
    e.stopPropagation();
    e.preventDefault();
}
var collapseRender = function collapseRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    collapse_extension_render_classCallCheck(this, collapseRender);
    this.fragmentRender = function(node) {
        node.addEventListener("click", render_handleClick, false);
    };
    this.fragmentCls = ".".concat(collapse_extension_render_classNamePrefix("collapse"));
    this.config = config;
};

/* harmony default export */ var collapse_extension_render = (collapseRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/blockquote-extension/render.js



/**
 * 统一样式前缀
 */ var blockquote_extension_render_CLASSNAME_PREFIX = "ct";

var blockquote_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : blockquote_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function blockquote_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var blockquote_extension_render_css_248z = ".pk-view-container .ct-blockquote{padding-left:16px;border-left:2px solid #ddd;margin-left:8px;margin-right:0;color:#999}.pk-view-container .ct-blockquote h1,.pk-view-container .ct-blockquote h2,.pk-view-container .ct-blockquote h3,.pk-view-container .ct-blockquote h4,.pk-view-container .ct-blockquote h5,.pk-view-container .ct-blockquote h6,.pk-view-container .ct-blockquote p,.pk-view-container .ct-blockquote span{color:#999!important}";
blockquote_extension_render_styleInject(blockquote_extension_render_css_248z);

function blockquote_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var blockquoteRender = function blockquoteRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    blockquote_extension_render_classCallCheck(this, blockquoteRender);
    this.fragmentCls = ".".concat(blockquote_extension_render_classNamePrefix("blockquote"));
    this.config = config;
};

/* harmony default export */ var blockquote_extension_render = (blockquoteRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/image-extension/render.js



/**
 * 统一样式前缀
 */ var image_extension_render_CLASSNAME_PREFIX = "ct";
var render_PARKER_CLASSNAME_PREFIX = "pk";

var image_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : image_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var render_classNameParkerPrefix = function(className) {
    return image_extension_render_classNamePrefix(className, render_PARKER_CLASSNAME_PREFIX);
};

function image_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var image_extension_render_css_248z = '.ct-editor-container .ProseMirror-selectednode .ct-image,.ct-editor-container .ProseMirror-selectednode .ct-image.ct-image-border{outline:2px solid #0082a6}.ct-editor-container .ct-image.ProseMirror-widget{top:unset}.ct-editor-container .ct-image.ProseMirror-widget img{max-width:100%;min-width:72px;min-height:87px}.ct-editor-container .ct-image.ProseMirror-widget[data-type=ct-progress]{margin:0 3px}.ct-editor-container .ct-image.ProseMirror-widget.selected[data-type=ct-progress]{outline:1px solid #1c6cdc}.ct-editor-container .ct-image{margin:0 3px;display:inline-block;position:relative;max-width:100%;line-height:1;font-size:0;box-sizing:content-box;background-color:#fff;vertical-align:bottom;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.ct-editor-container .ct-image .ct-image-mask{position:absolute;top:-1px;left:-1px;bottom:-1px;right:-1px;font-size:14px;line-height:20px;overflow:hidden;background:rgba(0,0,0,.7);color:#fff;min-width:72px;min-height:87px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-image .ct-image-mask .ct-image-loading-icon{position:absolute;top:18px;left:22px;width:28px;height:28px;background:url("data:image/svg+xml,%3Csvg width%3D%2232%22 height%3D%2232%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cstyle%2F%3E%3C%2Fdefs%3E%3Cpath d%3D%22M6.572 6.572A13.291 13.291 0 0 1 16 2.667c7.364 0 13.333 5.969 13.333 13.333a13.291 13.291 0 0 1-3.905 9.428l-1.414-1.414A11.298 11.298 0 0 0 27.334 16c0-6.26-5.075-11.333-11.334-11.333a11.298 11.298 0 0 0-8.013 3.32L6.57 6.57z%22 fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E") no-repeat 0;background-size:contain;vertical-align:-8%;-webkit-animation:image-loading .8s linear infinite;animation:image-loading .8s linear infinite}.ct-editor-container .ct-image .ct-image-mask .ct-image-progress-text{position:absolute;top:50px;left:16px;width:40px;text-align:center;text-decoration:none!important}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container{display:none;height:0}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-icon{position:absolute;top:18px;left:22px;width:28px;height:28px;background:url("data:image/svg+xml,%3Csvg width%3D%2232%22 height%3D%2232%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cstyle%2F%3E%3C%2Fdefs%3E%3Cpath d%3D%22M25.849 20.103l1.846.77C25.786 25.45 21.27 28.667 16 28.667 9.005 28.667 3.333 22.995 3.333 16S9.005 3.333 16 3.333c3.41 0 6.507 1.348 8.783 3.54l2.207-2.206 1.886 7.542-7.543-1.886 2.036-2.035A10.63 10.63 0 0 0 16 5.333C10.109 5.333 5.333 10.11 5.333 16S10.11 26.667 16 26.667a10.67 10.67 0 0 0 9.849-6.564zM26.667 16h2-2z%22 fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E") no-repeat 0;background-size:contain}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-text{position:absolute;top:50px;left:6px}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-btn{position:absolute;top:76px;left:6px}.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-loading-icon,.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-progress-text{display:none}.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-reupload-container{display:block}.ct-editor-container .ct-image .image-empty{width:360px;height:100px}.ct-editor-container .ct-image.ct-image-border{display:inline-block;outline:2px solid #ddd}@-webkit-keyframes image-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes image-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}';
image_extension_render_styleInject(image_extension_render_css_248z);

var render_css_248z$1 = '.pk-view-container .ct-image.ct-image-border{display:inline-block;outline:2px solid #ddd}.pk-view-container .ct-image .ct-img-failed{min-width:50px;min-height:100px;position:relative}.pk-view-container .ct-image .ct-img-failed:before{content:"";position:absolute;left:0;top:0;display:block;width:100%;height:100%;background:#fff;z-index:1}.pk-view-container .ct-image .ct-img-failed:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221520760474277%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1380 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223679%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2226.953125%22 height%3D%2220%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235 0.001 891.809 0.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496 0.001 149.89 0.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z%22 fill%3D%22%237F9496%22 p-id%3D%223680%22%3E%3C%2Fpath%3E%3Cpath d%3D%22M543.148 66.783l-83.824 239.855a44.52 44.52 0 0 0 9.99 45.602l174.532 180.887v277.792a44.52 44.52 0 0 0 19.721 36.974c20.42 13.697 48.078 8.247 61.775-12.173l185.264-276.199c10.592-15.791 9.987-36.565-1.506-51.712L776.096 332.515 891.809 66.784h338.475c45.899 0 83.107 36.242 83.107 80.949v728.538c0 44.707-37.208 80.949-83.107 80.949H149.89c-45.899 0-83.107-36.242-83.107-80.949V147.733c0-44.707 37.208-80.949 83.107-80.949h393.258z%22 fill%3D%22%23FFFFFF%22 p-id%3D%223681%22%3E%3C%2Fpath%3E%3Cpath d%3D%22M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z%22 fill%3D%22%23DDDDDD%22 p-id%3D%223682%22%3E%3C%2Fpath%3E%3Cpath d%3D%22M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235 0.001 891.809 0.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496 0.001 149.89 0.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z m16.259-248.949H149.89c-45.899 0-83.107 36.242-83.107 80.949V876.27c0 44.707 37.208 80.949 83.107 80.949h1080.394c45.899 0 83.107-36.242 83.107-80.949V147.732c0-44.707-37.208-80.949-83.107-80.949H891.809L776.096 332.514 909.1 507.808c11.493 15.147 12.098 35.922 1.506 51.712L725.342 835.719c-13.697 20.42-41.355 25.871-61.775 12.173a44.522 44.522 0 0 1-19.721-36.974V533.126L469.314 352.239a44.523 44.523 0 0 1-9.99-45.602l83.824-239.855z%22 fill%3D%22%237F9496%22 p-id%3D%223683%22%3E%3C%2Fpath%3E%3Cpath d%3D%22M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z%22 fill%3D%22%23EEEEEE%22 p-id%3D%223684%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%;content:"";position:absolute;left:12px;top:12px;display:block;width:28px;height:20px;z-index:2}.pk-view-container .ct-table-view td .ct-image img,.pk-view-container .ct-table-view th .ct-image img{max-width:100%}';
image_extension_render_styleInject(render_css_248z$1);

function image_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var isContainsByTags = function(node, tags) {
    var parentNode = node.parentNode;
    while(parentNode && parentNode.className !== render_classNameParkerPrefix("view-container")){
        if (tags.includes((parentNode.tagName || "").toLowerCase())) {
            return parentNode;
        }
        parentNode = parentNode.parentNode;
    }
    return false;
};
var imageRender = function imageRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _this = this;
    image_extension_render_classCallCheck(this, imageRender);
    this.fragmentRender = function(node) {
        if (node.querySelector("img").getAttribute("data-link")) {
            _this.hasLinkImage = true;
        }
    };
    this.containerRender = function($container, config) {
        if (_this.hasLinkImage) {
            $container.addEventListener("click", _this.handleImageLink);
        }
        var imgs = $container.querySelectorAll(".".concat(image_extension_render_classNamePrefix("image"), ">img"));
        var maxWidth = config.maxWidth || window.innerWidth;
        Array.from(imgs).forEach(function(img) {
            if (!img.hasAttribute("data-src")) return;
            var dataWidth = parseInt(img.getAttribute("data-width"), 10);
            var parentNodeWithTable = isContainsByTags(img, [
                "td",
                "th"
            ]);
            if (parentNodeWithTable || !dataWidth) {
                img.parentNode.style.cssText = "max-width: 100%";
            }
            if (dataWidth < maxWidth) {
                img.width = dataWidth;
                img.parentNode.style.cssText = "width: ".concat(dataWidth, "px");
            } else {
                img.parentNode.style.cssText = "width: 100%;";
            }
            // 懒加载则先不设置src
            if (!config.lazyload) {
                img.src = img.getAttribute("data-src");
            }
            img.onerror = function(e) {
                e.target.classList.add(image_extension_render_classNamePrefix("img-failed"));
            };
        });
    };
    this.handleImageLink = function(param) {
        var target = param.target;
        var $span = target.closest(_this.fragmentCls);
        if ($span && target.getAttribute("data-link")) {
            window.open(target.getAttribute("data-link"));
        }
    };
    this.fragmentCls = ".".concat(image_extension_render_classNamePrefix("image"));
    this.config = config;
    this.hasLinkImage = false;
};

/* harmony default export */ var image_extension_render = (imageRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/link-extension/render.js



/**
 * 统一样式前缀
 */ var link_extension_render_CLASSNAME_PREFIX = "ct";

var link_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : link_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function link_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var link_extension_render_css_248z = ".pk-view-container .ct-link{color:#1890ff;background:transparent;text-decoration:none;outline:none;cursor:pointer}.pk-view-container .ct-link:hover{text-decoration:underline}";
link_extension_render_styleInject(link_extension_render_css_248z);

function link_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var linkRender = function linkRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _this = this;
    link_extension_render_classCallCheck(this, linkRender);
    this.containerRender = function($container) {
        var nodes = $container.querySelectorAll("a");
        nodes.forEach(function(node) {
            var _this_config_provider;
            var href = node.getAttribute("href");
            if (!href) return;
            if (_this.config.openInNewTab) {
                node.setAttribute("target", "_blank");
            }
            var autoUpdate = node.getAttribute("data-auto_update") === "1";
            if (autoUpdate && ((_this_config_provider = _this.config.provider) === null || _this_config_provider === void 0 ? void 0 : _this_config_provider.getLinkTitle)) {
                _this.config.provider.getLinkTitle(node.getAttribute("href")).then(function(title) {
                    node.classList.add("ct-link-auto-update");
                    node.innerText = title;
                }).catch(function(e) {
                    console.error(e);
                });
            }
        });
    };
    this.fragmentCls = ".".concat(link_extension_render_classNamePrefix("link"));
    this.config = config;
};

/* harmony default export */ var link_extension_render = (linkRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/status-extension/render.js



/**
 * 统一样式前缀
 */ var status_extension_render_CLASSNAME_PREFIX = "ct";

var status_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : status_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var render_FONT_COLOR_DARK = "#333";
var render_FONT_COLOR_LIGHT = "#fff";
var render_colorsMore = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

function status_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var status_extension_render_css_248z = '.ct-status{display:inline-block;word-break:break-all;min-height:22px;min-width:68px;padding:0 8px;margin:0 2px;vertical-align:bottom;font-size:12px;font-weight:700;line-height:18px;text-align:center;color:#000;background-color:#ccc;border:2px solid #ccc;border-radius:2px;cursor:text}.ct-status[data-color=red]{background-color:#f5222d;border-color:#f5222d}.ct-status[data-color=red][data-pattern=fill]{color:#fff}.ct-status[data-color=yellow]{background-color:#fadb14;border-color:#fadb14}.ct-status[data-color=yellow][data-pattern=fill]{color:#876800}.ct-status[data-color=green]{background-color:#52c41a;border-color:#52c41a}.ct-status[data-color=green][data-pattern=fill]{color:#fff}.ct-status[data-color=blue]{background-color:#1890ff;border-color:#1890ff}.ct-status[data-color=blue][data-pattern=fill]{color:#fff}.ct-status[data-pattern=outline]{background-color:#f7f7f7}.ct-status.ProseMirror-selectednode{outline:unset}.ct-status.ct-selected,.ct-status.ProseMirror-selectednode,.ct-status:hover{position:relative}.ct-status.ct-selected:after,.ct-status.ProseMirror-selectednode:after,.ct-status:hover:after{z-index:2;position:absolute;content:"";left:-3px;right:-3px;top:-3px;bottom:-3px;border:2px solid #23bdd9;border-radius:3px;pointer-events:none}.ct-status[data-selectedkey]{cursor:default}.ProseMirror-selectednode .ct-status{outline:2px solid #0082a6}.ProseMirror-widget+span.ct-status{top:auto}';
status_extension_render_styleInject(status_extension_render_css_248z);

function status_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var render_computeFontColor = function(color) {
    var index = render_colorsMore.findIndex(function(c) {
        return c === color;
    });
    if (index === -1) {
        return render_FONT_COLOR_DARK;
    }
    if (index % 12 < 1) {
        return render_FONT_COLOR_DARK;
    }
    if (index % 12 < 2) {
        return render_FONT_COLOR_LIGHT;
    }
    if (index > 11 && index < 36) {
        return render_FONT_COLOR_DARK;
    }
    return render_FONT_COLOR_LIGHT;
};
var render_computeStyle = function(color, pattern) {
    return "\n    background: ".concat(pattern === "fill" ? color : "#fff", ";\n    border-color: ").concat(color, ";\n    color: ").concat(pattern === "fill" ? render_computeFontColor(color) : "", ";\n  ");
};
var statusRender = function statusRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    status_extension_render_classCallCheck(this, statusRender);
    this.fragmentRender = function(node) {
        var _node_dataset = node.dataset, _node_dataset_color = _node_dataset.color, color = _node_dataset_color === void 0 ? "#ccc" : _node_dataset_color, _node_dataset_pattern = _node_dataset.pattern, pattern = _node_dataset_pattern === void 0 ? "fill" : _node_dataset_pattern;
        node.setAttribute("style", render_computeStyle(color, pattern));
    };
    this.fragmentCls = ".".concat(status_extension_render_classNamePrefix("status"));
    this.config = config;
};

/* harmony default export */ var status_extension_render = (statusRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/time-extension/render.js




/**
 * 统一样式前缀
 */ var time_extension_render_CLASSNAME_PREFIX = "ct";

var time_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : time_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function time_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var time_extension_render_css_248z = '.pk-view-container .ct-time{box-sizing:border-box;margin:0 2px 0 0;list-style:none;padding:6px 11px;position:relative;display:inline-flex;align-items:center;background:#fff;border:1px solid #d9d9d9;border-radius:2px;transition:border .3s,box-shadow .3s}.pk-view-container .ct-time .icon{width:16px;height:16px;margin-left:11px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2214px%22 height%3D%2214px%22 class%3D%22icon%22 viewBox%3D%220 0 1024 1024%22%3E%3Cpath d%3D%22M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z%22 %2F%3E%3C%2Fsvg%3E") no-repeat 0;opacity:.25}';
time_extension_render_styleInject(time_extension_render_css_248z);

function time_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var render_timeRender = function timeRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    time_extension_render_classCallCheck(this, timeRender);
    this.fragmentRender = function(node) {
        var date = node.getAttribute("datetime");
        var isShowTime = node.getAttribute("data-isshowtime") === "true";
        var text = isShowTime ? moment_default()(+date).format("YYYY-MM-DD HH:mm:ss") : moment_default()(+date).format("YYYY-MM-DD");
        var newNode = document.createElement("span");
        newNode.classList.add(time_extension_render_classNamePrefix("time"));
        newNode.innerHTML = "".concat(text, ' <span class="icon"></span>');
        node.parentNode.insertBefore(newNode, node.nextSibling);
        node.parentNode.removeChild(node);
    };
    this.fragmentCls = ".".concat(time_extension_render_classNamePrefix("time"));
    this.config = config;
};

/* harmony default export */ var time_extension_render = (render_timeRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/attachment-extension/render.js






/**
 * 统一样式前缀
 */ var attachment_extension_render_CLASSNAME_PREFIX = "ct";

var attachment_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : attachment_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function attachment_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function attachment_extension_render_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                attachment_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                attachment_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function attachment_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var attachment_extension_render_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var render_AttachmentProvider = /*#__PURE__*/ function() {
    function AttachmentProvider() {
        var _this = this;
        attachment_extension_render_classCallCheck(this, AttachmentProvider);
        // 由于可以同时上传多个附件，以 id 为 key 存储不同附件的状态
        this.store = {};
        this.copyCallback = function(res) {};
        this.copy = function(url) {
            var inp = document.createElement("input");
            inp.setAttribute("value", url);
            inp.setAttribute("style", "opacity: 0");
            document.body.append(inp);
            inp.select();
            try {
                if (document.execCommand("Copy")) {
                    _this.copyCallback(true);
                } else {
                    _this.copyCallback(false);
                }
            } catch (err) {
                _this.copyCallback(false);
            }
            inp.remove();
        };
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.upload = function() {
            var _ref = attachment_extension_render_asyncToGenerator(function(file, onProgress) {
                return attachment_extension_render_generator(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            reject(new Error("附件上传方法未定义"));
                        })
                    ];
                });
            });
            return function(file, onProgress) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AttachmentProvider.prototype;
    _proto.beforeUpload = function beforeUpload(file, id) {
        return true;
    };
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AttachmentProvider;
}();

var render_AttachmentView = function(props) {
    var attrs = props.attrs, provider = props.provider;
    var name = attrs.name, size = attrs.size, src = attrs.src;
    var doCopy = function() {
        provider && provider.copy(src);
    };
    var doDownload = function() {
        provider && provider.download(src, name);
    };
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: classnames_default()(attachment_extension_render_classNamePrefix("attachment"), {
            "align-right": (attrs === null || attrs === void 0 ? void 0 : attrs.align) === "right"
        }),
        spellCheck: false,
        contentEditable: false
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "attachment-icon"
    }), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "content"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "name"
    }, name), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "size"
    }, size)), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "copy",
        onClick: doCopy
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "btn-copy"
    })), /*#__PURE__*/ react_default.a.createElement("div", {
        className: "download",
        onClick: doDownload
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "btn-download"
    })));
};

function attachment_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var attachment_extension_render_css_248z = '.pk-view-container .ct-attachment,.ProseMirror .ct-attachment{position:relative;display:flex;min-width:200px;max-width:340px;height:56px;line-height:1;padding:8px 12px;margin:2px 0;background:#f6f6f6;border:1px solid #ddd;border-radius:2px;outline:none;text-decoration:none;box-sizing:border-box;cursor:pointer}.pk-view-container .ct-attachment:active,.ProseMirror .ct-attachment:active{border:1px solid #0082a6}.pk-view-container .ct-attachment:hover,.ProseMirror .ct-attachment:hover{border-color:#3d91f2}.pk-view-container .ct-attachment.align-right,.ProseMirror .ct-attachment.align-right{width:320px}.pk-view-container .ct-attachment .attachment-icon,.ProseMirror .ct-attachment .attachment-icon{width:24px;height:34px;background:url("data:image/svg+xml,%3Csvg width%3D%2224px%22 height%3D%2223px%22 viewBox%3D%220 0 24 23%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22%3E        %3Cg transform%3D%22translate(-688.000000%2C -866.000000)%22%3E            %3Cg transform%3D%22translate(685.000000%2C 862.000000)%22%3E                %3Crect id%3D%22Rectangle-17%22 fill-opacity%3D%220%22 fill%3D%22%23F6F6F6%22 x%3D%220%22 y%3D%220%22 width%3D%2230%22 height%3D%2230%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Cpath d%3D%22M6.49853365%2C14.6639779 C4.13913438%2C17.0174106 4.14092301%2C20.8348631 6.50032228%2C23.1882958 C8.75896153%2C25.4412232 12.0047027%2C25.1820314 14.3780845%2C23.1215301 L24.2770726%2C13.2475751 C25.6468437%2C11.8812679 25.6468437%2C9.66604628 24.2770726%2C8.29973911 C22.9073015%2C6.93343194 20.6864637%2C6.93343194 19.3166926%2C8.29973911 L9.20862255%2C18.3822474 C8.72882633%2C18.9698239 8.76335668%2C19.8360463 9.31221361%2C20.3835153 C9.89791917%2C20.9677397 10.8475355%2C20.9677397 11.433241%2C20.3835153 L19.814834%2C12.0231181 C20.1190587%2C11.7450807 20.5916516%2C11.7477221 20.8841528%2C12.0394836 C21.176654%2C12.3312451 21.1793021%2C12.8026429 20.892097%2C13.097657 L12.3408139%2C21.6274323 C11.1601199%2C22.8051404 9.24583685%2C22.8051404 8.06514292%2C21.6274323 C6.884449%2C20.4497242 6.884449%2C18.540282 8.06514292%2C17.3625739 L7.70883701%2C17.7179788 L18.3980144%2C7.05583277 C20.3658376%2C5.09298589 23.5563094%2C5.09298589 25.5241326%2C7.05583277 C27.4919558%2C9.01867965 27.4919558%2C12.2010832 25.5241326%2C14.1639301 L14.8349552%2C24.8260761 L15.1912612%2C24.4706713 C12.2106117%2C27.0546925 8.04670149%2C27.2955154 5.21469563%2C24.4706713 C2.26296081%2C21.5264009 2.26117218%2C16.7510115 5.212907%2C13.8067411 L15.5457784%2C3.5 L14.1205548%2C4.92161947 C14.4186199%2C4.66321957 14.8706399%2C4.67467844 15.1538398%2C4.95716212 C15.4370396%2C5.2396458 15.4485275%2C5.69052271 15.1883035%2C5.98666804 L6.49853365%2C14.6639779 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23BDC2C7%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.pk-view-container .ct-attachment .content,.ProseMirror .ct-attachment .content{margin-left:12px;width:calc(100% - 100px)}.pk-view-container .ct-attachment .name,.ProseMirror .ct-attachment .name{line-height:18px;font-size:12px;color:#333;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.pk-view-container .ct-attachment .size,.ProseMirror .ct-attachment .size{display:inline-block;line-height:12px;font-size:12px;color:#999}.pk-view-container .ct-attachment .copy,.ProseMirror .ct-attachment .copy{position:absolute;top:15px;right:30px;bottom:0;width:40px}.pk-view-container .ct-attachment .copy .btn-copy,.ProseMirror .ct-attachment .copy .btn-copy{height:100%;border-left:1px solid #ddd;margin:-7px 0;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%80%9A%E7%94%A8%E7%BB%84%E4%BB%B6%E8%A7%84%E8%8C%83%E5%92%8C%E6%A1%88%E4%BE%8Bv0.1-%E5%9B%BE%E6%A0%87%E6%96%87%E6%A1%88%E9%97%B4%E8%B7%9D%22 transform%3D%22translate(-496.000000%2C -986.000000)%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E            %3Cg id%3D%22%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(496.000000%2C 986.000000)%22%3E                %3Cpath d%3D%22M11.6008309%2C1 C12.8995343%2C1.07592189 14.0703003%2C1.71698456 14.6762067%2C3.14250056 C15.2917537%2C4.59090718 15.0177693%2C5.93811066 13.955644%2C7.08887658 C13.2036907%2C7.90225179 12.3962373%2C8.66503324 11.6068778%2C9.44345532 C11.2640964%2C9.78206478 10.7149244%2C9.79290854 10.4180024%2C9.4808147 C10.1174711%2C9.16509587 10.1500649%2C8.73129889 10.51094%2C8.36859567 C11.2858152%2C7.59136109 12.0715654%2C6.82378276 12.8379718%2C6.03932944 C13.9930503%2C4.85721975 13.480097%2C2.97740676 11.8844716%2C2.55323478 C11.2206433%2C2.37731286 10.5833619%2C2.49901601 10.0788461%2C2.96896926 C9.26654902%2C3.72451633 8.5025332%2C4.52945404 7.69386112%2C5.28620424 C7.52248607%2C5.44646991 7.23884537%2C5.58503244 7.01675156%2C5.57057931 C6.42172016%2C5.53442305 6.12118883%2C4.81382912 6.53276706%2C4.38486026 C7.41747042%2C3.46303189 8.32028315%2C2.55565665 9.27017403%2C1.70251581 C9.8483148%2C1.1831563 10.6014712%2C1.0048125 11.6008309%2C1 Z M1%2C11.4027996 C1.00603125%2C10.4086743 1.35243759%2C9.54950222 2.04885965%2C8.84095516 C2.8177036%2C8.05770496 3.59861005%2C7.28650163 4.37831338%2C6.51409518 C4.74886035%2C6.14656384 5.20389172%2C6.11886071 5.51768867%2C6.43456391 C5.84357938%2C6.76353275 5.81220438%2C7.17804848 5.4259699%2C7.56606421 C4.68367283%2C8.3107519 3.92932889%2C9.04581459 3.19428182%2C9.79893979 C2.28542221%2C10.7280025 2.2467972%2C11.9823935 3.08443804%2C12.8247062 C3.88587575%2C13.630847 5.21112609%2C13.6344564 6.04876694%2C12.8186749 C6.81036089%2C12.0763935 7.5514392%2C11.3124246 8.31064253%2C10.5689244 C8.76686139%2C10.1230805 9.45967407%2C10.282143 9.58036161%2C10.8822369 C9.62381474%2C11.0979245 9.53692409%2C11.423284 9.38723656%2C11.5811434 C8.56168947%2C12.4511436 7.73731425%2C13.3283938 6.83812652%2C14.1176597 C5.73736061%2C15.0840662 4.44711027%2C15.2443475 3.10254742%2C14.6587067 C1.80264083%2C14.0923628 1.003625%2C12.8162687 1%2C11.4028152 L1%2C11.4027996 Z M11.0709714%2C5.73326686 C11.0226901%2C5.82362625 10.9671745%2C6.01884505 10.8416588%2C6.14656384 C9.32690841%2C7.68415799 7.80611114%2C9.21450214 6.27809512%2C10.7376275 C5.95340754%2C11.0617839 5.49114179%2C11.0400807 5.18578234%2C10.7316119 C4.87800101%2C10.4207212 4.88645414%2C9.99414296 5.22921985%2C9.64951787 C6.72950149%2C8.14567373 8.23459563%2C6.64545459 9.73848665%2C5.14642295 C9.98228359%2C4.90300101 10.2683305%2C4.80057911 10.6014556%2C4.9451729 C10.8983776%2C5.07411043 11.0492526%2C5.310298 11.070987%2C5.73325123 L11.0709714%2C5.73326686 Z%22 id%3D%22Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 13px;background-position:10px}.pk-view-container .ct-attachment .copy .btn-copy:hover,.ProseMirror .ct-attachment .copy .btn-copy:hover{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%80%9A%E7%94%A8%E7%BB%84%E4%BB%B6%E8%A7%84%E8%8C%83%E5%92%8C%E6%A1%88%E4%BE%8Bv0.1-%E5%9B%BE%E6%A0%87%E6%96%87%E6%A1%88%E9%97%B4%E8%B7%9D%22 transform%3D%22translate(-496.000000%2C -986.000000)%22 fill%3D%22%236B6B6B%22 fill-rule%3D%22nonzero%22%3E            %3Cg id%3D%22%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(496.000000%2C 986.000000)%22 fill%3D%22%233d91f2%22%3E                %3Cpath d%3D%22M11.6008309%2C1 C12.8995343%2C1.07592189 14.0703003%2C1.71698456 14.6762067%2C3.14250056 C15.2917537%2C4.59090718 15.0177693%2C5.93811066 13.955644%2C7.08887658 C13.2036907%2C7.90225179 12.3962373%2C8.66503324 11.6068778%2C9.44345532 C11.2640964%2C9.78206478 10.7149244%2C9.79290854 10.4180024%2C9.4808147 C10.1174711%2C9.16509587 10.1500649%2C8.73129889 10.51094%2C8.36859567 C11.2858152%2C7.59136109 12.0715654%2C6.82378276 12.8379718%2C6.03932944 C13.9930503%2C4.85721975 13.480097%2C2.97740676 11.8844716%2C2.55323478 C11.2206433%2C2.37731286 10.5833619%2C2.49901601 10.0788461%2C2.96896926 C9.26654902%2C3.72451633 8.5025332%2C4.52945404 7.69386112%2C5.28620424 C7.52248607%2C5.44646991 7.23884537%2C5.58503244 7.01675156%2C5.57057931 C6.42172016%2C5.53442305 6.12118883%2C4.81382912 6.53276706%2C4.38486026 C7.41747042%2C3.46303189 8.32028315%2C2.55565665 9.27017403%2C1.70251581 C9.8483148%2C1.1831563 10.6014712%2C1.0048125 11.6008309%2C1 Z M1%2C11.4027996 C1.00603125%2C10.4086743 1.35243759%2C9.54950222 2.04885965%2C8.84095516 C2.8177036%2C8.05770496 3.59861005%2C7.28650163 4.37831338%2C6.51409518 C4.74886035%2C6.14656384 5.20389172%2C6.11886071 5.51768867%2C6.43456391 C5.84357938%2C6.76353275 5.81220438%2C7.17804848 5.4259699%2C7.56606421 C4.68367283%2C8.3107519 3.92932889%2C9.04581459 3.19428182%2C9.79893979 C2.28542221%2C10.7280025 2.2467972%2C11.9823935 3.08443804%2C12.8247062 C3.88587575%2C13.630847 5.21112609%2C13.6344564 6.04876694%2C12.8186749 C6.81036089%2C12.0763935 7.5514392%2C11.3124246 8.31064253%2C10.5689244 C8.76686139%2C10.1230805 9.45967407%2C10.282143 9.58036161%2C10.8822369 C9.62381474%2C11.0979245 9.53692409%2C11.423284 9.38723656%2C11.5811434 C8.56168947%2C12.4511436 7.73731425%2C13.3283938 6.83812652%2C14.1176597 C5.73736061%2C15.0840662 4.44711027%2C15.2443475 3.10254742%2C14.6587067 C1.80264083%2C14.0923628 1.003625%2C12.8162687 1%2C11.4028152 L1%2C11.4027996 Z M11.0709714%2C5.73326686 C11.0226901%2C5.82362625 10.9671745%2C6.01884505 10.8416588%2C6.14656384 C9.32690841%2C7.68415799 7.80611114%2C9.21450214 6.27809512%2C10.7376275 C5.95340754%2C11.0617839 5.49114179%2C11.0400807 5.18578234%2C10.7316119 C4.87800101%2C10.4207212 4.88645414%2C9.99414296 5.22921985%2C9.64951787 C6.72950149%2C8.14567373 8.23459563%2C6.64545459 9.73848665%2C5.14642295 C9.98228359%2C4.90300101 10.2683305%2C4.80057911 10.6014556%2C4.9451729 C10.8983776%2C5.07411043 11.0492526%2C5.310298 11.070987%2C5.73325123 L11.0709714%2C5.73326686 Z%22 id%3D%22Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.pk-view-container .ct-attachment .download,.ProseMirror .ct-attachment .download{position:absolute;top:15px;right:0;bottom:0;width:30px}.pk-view-container .ct-attachment .download .btn-download,.ProseMirror .ct-attachment .download .btn-download{margin-top:-7px;width:30px;height:100%;display:inline-block;border-left:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2214px%22 height%3D%2214px%22 viewBox%3D%220 0 14 14%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E4%B8%8B%E8%BD%BD copy%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%99%84%E4%BB%B6%E6%B7%BB%E5%8A%A0%E5%A4%8D%E5%88%B6%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(-369.000000%2C -555.000000)%22 fill%3D%22%23747272%22%3E            %3Cg id%3D%22%E4%B8%8A%E4%BC%A0%E9%99%84%E4%BB%B6%E4%B8%AD-copy-6%22 transform%3D%22translate(56.000000%2C 534.000000)%22%3E                %3Cg id%3D%22%E4%B8%8B%E8%BD%BD-copy%22 transform%3D%22translate(312.000000%2C 20.000000)%22%3E                    %3Cpath d%3D%22M8.81079102%2C8.49228232 L11.0575929%2C6.23659883 C11.367661%2C5.92438892 11.8514298%2C5.89865471 12.1342183%2C6.18304917 C12.4189783%2C6.46942638 12.3934758%2C6.95251315 12.0816605%2C7.26648227 L8.65828197%2C10.7033935 C8.57058276%2C10.8187868 8.45021995%2C10.9080019 8.31097304%2C10.9572592 C8.23162324%2C10.986943 8.14990291%2C11.0008681 8.06879562%2C10.9999582 C8.06613072%2C10.999986 8.0634625%2C11 8.06079102%2C11 C8.05811953%2C11 8.05545131%2C10.999986 8.05278641%2C10.9999582 C7.97167912%2C11.0008681 7.88995879%2C10.986943 7.81060899%2C10.9572592 C7.67136208%2C10.9080019 7.55099928%2C10.8187868 7.46330006%2C10.7033935 L4.03992152%2C7.26648227 C3.72810619%2C6.95251315 3.70260373%2C6.46942638 3.98736375%2C6.18304917 C4.27015222%2C5.89865471 4.75392098%2C5.92438892 5.06398917%2C6.23659883 L7.31079102%2C8.49228232 L7.31079102%2C1.75 C7.31079102%2C1.33578644 7.64657745%2C1 8.06079102%2C1 C8.47500458%2C1 8.81079102%2C1.33578644 8.81079102%2C1.75 L8.81079102%2C8.49228232 Z M15%2C11.0225156 L15%2C13 C15%2C14.1045695 14.1045695%2C15 13%2C15 L3%2C15 C1.8954305%2C15 1%2C14.1045695 1%2C13 L1%2C11 L1.00152941%2C11 C1.00051495%2C10.9840173 1%2C10.9678989 1%2C10.9516602 C1%2C10.5365365 1.33652425%2C10.2000122 1.75164795%2C10.2000122 C2.16677165%2C10.2000122 2.5032959%2C10.5365365 2.5032959%2C10.9516602 C2.5032959%2C10.9755555 2.50218087%2C10.9991903 2.5%2C11.0225156 L2.5%2C12.5 C2.5%2C13.0522847 2.94771525%2C13.5 3.5%2C13.5 L12.5%2C13.5 C13.0522847%2C13.5 13.5%2C13.0522847 13.5%2C12.5 L13.5%2C11 L13.5015294%2C11 C13.5005149%2C10.9840173 13.5%2C10.9678989 13.5%2C10.9516602 C13.5%2C10.5365365 13.8365242%2C10.2000122 14.2516479%2C10.2000122 C14.6667716%2C10.2000122 15.0032959%2C10.5365365 15.0032959%2C10.9516602 C15.0032959%2C10.9755555 15.0021809%2C10.9991903 15%2C11.0225156 Z%22 id%3D%22%E4%B8%8B%E8%BD%BD%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 0}.pk-view-container .ct-attachment .download .btn-download:hover,.ProseMirror .ct-attachment .download .btn-download:hover{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2214px%22 height%3D%2214px%22 viewBox%3D%220 0 14 14%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 52.2 (67145) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E4%B8%8B%E8%BD%BD copy%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E9%99%84%E4%BB%B6%E6%B7%BB%E5%8A%A0%E5%A4%8D%E5%88%B6%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(-369.000000%2C -555.000000)%22 fill%3D%22%233d91f2%22%3E            %3Cg id%3D%22%E4%B8%8A%E4%BC%A0%E9%99%84%E4%BB%B6%E4%B8%AD-copy-6%22 transform%3D%22translate(56.000000%2C 534.000000)%22%3E                %3Cg id%3D%22%E4%B8%8B%E8%BD%BD-copy%22 transform%3D%22translate(312.000000%2C 20.000000)%22%3E                    %3Cpath d%3D%22M8.81079102%2C8.49228232 L11.0575929%2C6.23659883 C11.367661%2C5.92438892 11.8514298%2C5.89865471 12.1342183%2C6.18304917 C12.4189783%2C6.46942638 12.3934758%2C6.95251315 12.0816605%2C7.26648227 L8.65828197%2C10.7033935 C8.57058276%2C10.8187868 8.45021995%2C10.9080019 8.31097304%2C10.9572592 C8.23162324%2C10.986943 8.14990291%2C11.0008681 8.06879562%2C10.9999582 C8.06613072%2C10.999986 8.0634625%2C11 8.06079102%2C11 C8.05811953%2C11 8.05545131%2C10.999986 8.05278641%2C10.9999582 C7.97167912%2C11.0008681 7.88995879%2C10.986943 7.81060899%2C10.9572592 C7.67136208%2C10.9080019 7.55099928%2C10.8187868 7.46330006%2C10.7033935 L4.03992152%2C7.26648227 C3.72810619%2C6.95251315 3.70260373%2C6.46942638 3.98736375%2C6.18304917 C4.27015222%2C5.89865471 4.75392098%2C5.92438892 5.06398917%2C6.23659883 L7.31079102%2C8.49228232 L7.31079102%2C1.75 C7.31079102%2C1.33578644 7.64657745%2C1 8.06079102%2C1 C8.47500458%2C1 8.81079102%2C1.33578644 8.81079102%2C1.75 L8.81079102%2C8.49228232 Z M15%2C11.0225156 L15%2C13 C15%2C14.1045695 14.1045695%2C15 13%2C15 L3%2C15 C1.8954305%2C15 1%2C14.1045695 1%2C13 L1%2C11 L1.00152941%2C11 C1.00051495%2C10.9840173 1%2C10.9678989 1%2C10.9516602 C1%2C10.5365365 1.33652425%2C10.2000122 1.75164795%2C10.2000122 C2.16677165%2C10.2000122 2.5032959%2C10.5365365 2.5032959%2C10.9516602 C2.5032959%2C10.9755555 2.50218087%2C10.9991903 2.5%2C11.0225156 L2.5%2C12.5 C2.5%2C13.0522847 2.94771525%2C13.5 3.5%2C13.5 L12.5%2C13.5 C13.0522847%2C13.5 13.5%2C13.0522847 13.5%2C12.5 L13.5%2C11 L13.5015294%2C11 C13.5005149%2C10.9840173 13.5%2C10.9678989 13.5%2C10.9516602 C13.5%2C10.5365365 13.8365242%2C10.2000122 14.2516479%2C10.2000122 C14.6667716%2C10.2000122 15.0032959%2C10.5365365 15.0032959%2C10.9516602 C15.0032959%2C10.9755555 15.0021809%2C10.9991903 15%2C11.0225156 Z%22 id%3D%22%E4%B8%8B%E8%BD%BD%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ProseMirror-selectednode .ct-attachment{border:1px solid #3d91f2;box-shadow:0 0 4px 0 rgba(0,0,0,.1),0 3px 6px 0 rgba(0,0,0,.14);background-color:#fff}';
attachment_extension_render_styleInject(attachment_extension_render_css_248z);

function render_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function transform(node, config) {
    var src = node.getAttribute("data-src");
    var align = "left";
    if (node.getAttribute("class").includes("center")) align = "center";
    if (node.getAttribute("class").includes("right")) align = "right";
    var nameNode = node.querySelector(".name");
    var sizeNode = node.querySelector(".size");
    var size = sizeNode.innerText;
    var name = "file";
    if (nameNode && !nameNode.getAttribute("title")) {
        name = nameNode && nameNode.innerText;
        nameNode.setAttribute("title", name);
    } else {
        name = nameNode.getAttribute("title");
    }
    var attachmentProvider = new render_AttachmentProvider();
    if (config.copyCallback) {
        attachmentProvider.copyCallback = config.copyCallback;
    }
    var attrs = {
        name: name,
        size: size,
        src: src,
        align: align
    };
    var newNode = document.createElement("div");
    node.parentNode.insertBefore(newNode, node.nextSibling);
    Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(render_AttachmentView, {
        view: null,
        getPos: function() {
            return 0;
        },
        node: null,
        attrs: attrs,
        dom: null,
        provider: attachmentProvider
    }), newNode);
    node.parentNode.removeChild(node);
}
var attachmentRender = function attachmentRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _this = this;
    render_classCallCheck$1(this, attachmentRender);
    this.fragmentRender = function(node) {
        transform(node, _this.config);
    };
    this.fragmentCls = ".".concat(attachment_extension_render_classNamePrefix("attachment"));
    this.config = config;
};

/* harmony default export */ var attachment_extension_render = (attachmentRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/video-extension/render.js










/**
 * 统一样式前缀
 */ var video_extension_render_CLASSNAME_PREFIX = "ct";

var video_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : video_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
/**
 *格式化时间字符串
 * @param time
 * @returns HH:MM格式字符串
 */ var render_formatTime = function(time) {
    var minute = parseInt("".concat(time / 60), 10);
    var second = parseInt("".concat(time % 60), 10);
    return "".concat(minute < 10 ? "0".concat(minute) : minute, ":").concat(second < 10 ? "0".concat(second) : second);
};

var video_extension_render_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

function video_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function video_extension_render_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                video_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                video_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function video_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var render_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var render_AudioProvider = /*#__PURE__*/ function() {
    function AudioProvider() {
        video_extension_render_classCallCheck(this, AudioProvider);
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.beforeUpload = function(file) {
            return true;
        };
        this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("上传方法未定义"));
            });
        };
        this.audioTranscode = function() {
            var _ref = video_extension_render_asyncToGenerator(function(data, file) {
                return render_generator$1(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioProvider.prototype;
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AudioProvider;
}();

var render_generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var render_generator$3 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var render_generator$4 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

function render_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function render_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function render_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function render_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function render_slicedToArray(arr, i) {
    return render_arrayWithHoles(arr) || render_iterableToArrayLimit(arr, i) || render_unsupportedIterableToArray(arr, i) || render_nonIterableRest();
}
function render_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return render_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return render_arrayLikeToArray(o, minLen);
}
function render_useForceUpdate() {
    var _useState = render_slicedToArray(Object(react["useState"])(0), 2), setTick = _useState[1];
    var update = Object(react["useCallback"])(function() {
        setTick(function(tick) {
            return tick + 1;
        });
    }, []);
    return update;
}

var render_findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};

function video_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var video_extension_render_css_248z = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
video_extension_render_styleInject(video_extension_render_css_248z);

function render_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function render_arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function render_iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function render_nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function render_slicedToArray$1(arr, i) {
    return render_arrayWithHoles$1(arr) || render_iterableToArrayLimit$1(arr, i) || render_unsupportedIterableToArray$1(arr, i) || render_nonIterableRest$1();
}
function render_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return render_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return render_arrayLikeToArray$1(o, minLen);
}
var render_Resizer = function(param) {
    var $container = param.$container, view = param.view, getPos = param.getPos, initialWidth = param.initialWidth, initialHeight = param.initialHeight, _param_fixedRatio = param.fixedRatio, fixedRatio = _param_fixedRatio === void 0 ? true : _param_fixedRatio, _param_autoHeight = param.autoHeight, autoHeight = _param_autoHeight === void 0 ? false : _param_autoHeight, _param_hideInfo = param.hideInfo, hideInfo = _param_hideInfo === void 0 ? false : _param_hideInfo, _param_limit = param.limit, limit = _param_limit === void 0 ? {} : _param_limit, onResizeStart = param.onResizeStart, onResizeEnd = param.onResizeEnd;
    if (!$container || !getPos()) return null;
    var limitRef = Object(react["useRef"])({});
    limitRef.current.minWidth = limit.minWidth || 20;
    limitRef.current.minHeight = limit.minHeight || 20;
    limitRef.current.maxHeight = limit.maxHeight || Infinity;
    var _useState = render_slicedToArray$1(Object(react["useState"])("rb"), 2), infoPosition = _useState[0], setInfoPosition = _useState[1];
    var wrapperRef = Object(react["useRef"])();
    // 获取最大宽度
    var pos = getPos();
    var doc = view.state.doc;
    // 获取父级block节点
    var blockNode = render_findParentNodeClosestToPos(doc.resolve(pos), function(n) {
        return n.isBlock;
    });
    var $blockNode = view.nodeDOM((blockNode === null || blockNode === void 0 ? void 0 : blockNode.pos) || 0);
    if (!$blockNode) {
        return null;
    }
    limitRef.current.maxWidth = limit.maxWidth || $blockNode.clientWidth;
    var ratio = initialHeight / initialWidth;
    if (fixedRatio) {
        limitRef.current.minHeight = Math.max(limitRef.current.minHeight, limitRef.current.minWidth * ratio);
        limitRef.current.minWidth = Math.max(limitRef.current.minWidth, limitRef.current.minHeight / ratio);
        limitRef.current.maxHeight = limitRef.current.maxWidth * ratio;
    }
    limitRef.current.minWidth = Math.min(limitRef.current.minWidth, limitRef.current.maxWidth);
    limitRef.current.minHeight = Math.min(limitRef.current.minHeight, limitRef.current.maxHeight);
    var startX = Object(react["useRef"])(0);
    var startY = Object(react["useRef"])(0);
    var isReverseX = Object(react["useRef"])(false);
    var isReverseY = Object(react["useRef"])(false);
    var initialWidthRef = Object(react["useRef"])(0);
    var initialHeightRef = Object(react["useRef"])(0);
    initialWidthRef.current = initialWidth;
    initialHeightRef.current = initialHeight;
    var currentSize = Object(react["useRef"])({
        width: initialWidth,
        height: initialHeight
    });
    var update = render_useForceUpdate();
    var limitSize = function() {
        var _currentSize_current = currentSize.current, width = _currentSize_current.width, height = _currentSize_current.height;
        if (width >= limitRef.current.maxWidth) {
            currentSize.current.width = limitRef.current.maxWidth;
        } else if (width <= limitRef.current.minWidth) {
            currentSize.current.width = limitRef.current.minWidth;
        }
        if (height >= limitRef.current.maxHeight) {
            currentSize.current.height = limitRef.current.maxHeight;
        } else if (height <= limitRef.current.minHeight) {
            currentSize.current.height = limitRef.current.minHeight;
        }
    };
    Object(react["useEffect"])(function() {
        var onMouseDown = function(e) {
            var classList = e.target && e.target.classList;
            if (!classList) {
                return;
            }
            var posList = [
                "lt",
                "rt",
                "lb",
                "rb"
            ];
            var posName = posList.find(function(item) {
                return classList.contains(item);
            });
            if (posName) {
                e.stopPropagation();
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                handleMouseDown(e, posName);
            }
        };
        var wrapper = wrapperRef.current;
        wrapper.addEventListener("mousedown", onMouseDown, false);
        return function() {
            wrapper.removeEventListener("mousedown", onMouseDown, false);
        };
    });
    Object(react["useEffect"])(function() {
        currentSize.current.width = initialWidth;
        currentSize.current.height = initialHeight;
        if (!autoHeight) {
            // 防止容器节点大小没有同步更新
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        update();
    }, [
        initialWidth
    ]);
    var handleMouseMove = Object(react["useCallback"])(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var diffX = isReverseX.current ? startX.current - e.clientX : e.clientX - startX.current;
        var diffY = isReverseY.current ? startY.current - e.clientY : e.clientY - startY.current;
        currentSize.current.width = initialWidthRef.current + diffX;
        currentSize.current.height = initialHeightRef.current + diffY;
        if (fixedRatio) {
            currentSize.current.height = currentSize.current.width * ratio;
        }
        limitSize();
        currentSize.current.width = Math.round(currentSize.current.width);
        currentSize.current.height = Math.round(currentSize.current.height);
        $container.style.width = "".concat(currentSize.current.width, "px");
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        // 更新尺寸大小的显示
        update();
    }, []);
    var handleMouseUp = Object(react["useCallback"])(function() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        onResizeEnd({
            width: currentSize.current.width,
            height: currentSize.current.height
        });
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        $container.style.width = "".concat(currentSize.current.width, "px");
    }, []);
    var handleMouseDown = function(e, position) {
        isReverseX.current = position === "lt" || position === "lb";
        isReverseY.current = position === "lt" || position === "lr";
        startX.current = e.clientX;
        startY.current = e.clientY;
        setInfoPosition(position);
        if (onResizeStart) {
            onResizeStart();
        }
        document.addEventListener("mousemove", handleMouseMove, {
            passive: false
        });
        document.addEventListener("mouseup", handleMouseUp);
    };
    // 当图片尺寸较大时，扩大热区
    var largeHotArea = Object(react["useMemo"])(function() {
        return currentSize.current.height >= 30 && currentSize.current.width >= 30;
    }, [
        currentSize.current.height,
        currentSize.current.width
    ]);
    var resizerPrefix = video_extension_render_classNamePrefix("pc-resizer");
    var pointerCls = "".concat(resizerPrefix, "-point");
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: resizerPrefix,
        ref: wrapperRef
    }, /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " lt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " rt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " lb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(pointerCls, " rb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ react_default.a.createElement("span", {
        className: "".concat(resizerPrefix, "-info ").concat(infoPosition, " ").concat((currentSize.current.width < 65 || currentSize.current.height < 30) && "out", " ").concat(hideInfo ? "auto-hide" : "")
    }, "".concat(currentSize.current.width, " x ").concat(currentSize.current.height)));
};

var render_img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%92%ad%e6%94%be%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-471.000000%2c -558.000000)'%3e %3cg id='Group-18' transform='translate(471.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M15.6839276%2c10.5567733 L4.96564206%2c16.9107492 C4.66057577%2c17.0915976 4.26783668%2c16.9889051 4.08843476%2c16.6813793 C4.03053197%2c16.5821239 4%2c16.4690706 4%2c16.3539244 L4%2c3.64597255 C4%2c3.28921176 4.28689869%2c3 4.64080615%2c3 C4.7550314%2c3 4.86718053%2c3.03077813 4.96564206%2c3.08914775 L15.6839276%2c9.44312369 C15.9889939%2c9.62397201 16.090865%2c10.0198775 15.9114631%2c10.3274033 C15.8562054%2c10.4221245 15.7778912%2c10.5010701 15.6839276%2c10.5567733 Z' id='Triangle-2' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var render_img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%9a%82%e5%81%9c%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-395.000000%2c -558.000000)'%3e %3cg id='Group-18-Copy' transform='translate(395.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M5%2c3 L7%2c3 C7.55228475%2c3 8%2c3.44771525 8%2c4 L8%2c16 C8%2c16.5522847 7.55228475%2c17 7%2c17 L5%2c17 C4.44771525%2c17 4%2c16.5522847 4%2c16 L4%2c4 C4%2c3.44771525 4.44771525%2c3 5%2c3 Z M13%2c3 L15%2c3 C15.5522847%2c3 16%2c3.44771525 16%2c4 L16%2c16 C16%2c16.5522847 15.5522847%2c17 15%2c17 L13%2c17 C12.4477153%2c17 12%2c16.5522847 12%2c16 L12%2c4 C12%2c3.44771525 12.4477153%2c3 13%2c3 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var render_img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%87%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-514.000000%2c -558.000000)'%3e %3cg id='Group-22' transform='translate(514.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(2.000000%2c 4.000000)'%3e %3cg id='Group-21'%3e %3cpath d='M0%2c8.12082937 C0%2c8.6754175 0.442660332%2c9.125 0.998956561%2c9.125 L3%2c9.125 L6.19054031%2c11.4182009 C6.63759255%2c11.7395196 7%2c11.544239 7%2c10.9975267 L7%2c1.00247329 C7%2c0.448822582 6.63085938%2c0.265319824 6.19054031%2c0.58179915 L3%2c2.875 L0.998956561%2c2.875 C0.447248087%2c2.875 0%2c3.32448459 0%2c3.87917063 L0%2c8.12082937 Z' id='Fill-89' fill='%236B6B6B'%3e%3c/path%3e %3cpath d='M10%2c2 C11.3333333%2c3.06070964 12%2c4.39404297 12%2c6 C12%2c7.60595703 11.3333333%2c8.93929036 10%2c10' id='Path-12' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3cpath d='M13%2c0 C15%2c1.3984375 16%2c3.3984375 16%2c6 C16%2c8.6015625 15%2c10.6015625 13%2c12' id='Path-12-Copy' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var render_img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9d%99%e9%9f%b3%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-550.000000%2c -558.000000)'%3e %3cg id='Group-22-Copy' transform='translate(550.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(4.000000%2c 4.000000)' fill='%236B6B6B'%3e %3cpath d='M9%2c1.72792206 L2.12273522%2c8.60518684 C2.04439515%2c8.46156167 2%2c8.29646112 2%2c8.12082937 L2%2c3.87917063 C2%2c3.32448459 2.44724809%2c2.875 2.99895656%2c2.875 L5%2c2.875 L8.19054031%2c0.58179915 C8.63085937%2c0.265319824 9%2c0.448822582 9%2c1.00247329 L9%2c1.72792206 Z M9%2c6.67766953 L9%2c10.9975267 C9%2c11.544239 8.63759255%2c11.7395196 8.19054031%2c11.4182009 L5.90337136%2c9.77429817 L9%2c6.67766953 Z M12.2582521%2c0.944543648 C12.5511454%2c1.23743687 12.5511454%2c1.7123106 12.2582521%2c2.00520382 L2.00520382%2c12.2582521 C1.7123106%2c12.5511454 1.23743687%2c12.5511454 0.944543648%2c12.2582521 C0.651650429%2c11.9653589 0.651650429%2c11.4904852 0.944543648%2c11.197592 L11.197592%2c0.944543648 C11.4904852%2c0.651650429 11.9653589%2c0.651650429 12.2582521%2c0.944543648 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var render_img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e5%85%a8%e5%b1%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-586.000000%2c -558.000000)'%3e %3cg id='Group-24' transform='translate(586.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M17.028246%2c3.75000027 C17.0282663%2c3.75227439 17.0282764%2c3.75455093 17.0282764%2c3.75682984 L17.0282764%2c9.25682984 C17.0282764%2c9.6710434 16.69249%2c10.0068298 16.2782764%2c10.0068298 C15.8640629%2c10.0068298 15.5282764%2c9.6710434 15.5282764%2c9.25682984 L15.5282764%2c5.55025253 L11.5803179%2c9.4982111 C11.2874247%2c9.79110432 10.8125509%2c9.79110432 10.5196577%2c9.4982111 C10.2267645%2c9.20531788 10.2267645%2c8.73044414 10.5196577%2c8.43755093 L14.4572086%2c4.5 L10.7782764%2c4.5 C10.3640629%2c4.5 10.0282764%2c4.16421356 10.0282764%2c3.75 C10.0282764%2c3.33578644 10.3640629%2c3 10.7782764%2c3 L16.2782764%2c3 C16.69249%2c3 17.0282764%2c3.33578644 17.0282764%2c3.75 Z M3.00003045%2c16.2499997 C3.00001016%2c16.2477256 3%2c16.2454491 3%2c16.2431702 L3%2c10.7431702 C3%2c10.3289566 3.33578644%2c9.99317016 3.75%2c9.99317016 C4.16421356%2c9.99317016 4.5%2c10.3289566 4.5%2c10.7431702 L4.5%2c14.4497475 L8.44795857%2c10.5017889 C8.74085178%2c10.2088957 9.21572552%2c10.2088957 9.50861874%2c10.5017889 C9.80151196%2c10.7946821 9.80151196%2c11.2695559 9.50861874%2c11.5624491 L5.57106781%2c15.5 L9.25%2c15.5 C9.66421356%2c15.5 10%2c15.8357864 10%2c16.25 C10%2c16.6642136 9.66421356%2c17 9.25%2c17 L3.75%2c17 C3.33578644%2c17 3%2c16.6642136 3%2c16.25 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var render_img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e7%bc%a9%e5%b0%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-622.000000%2c -558.000000)'%3e %3cg id='Group-24-Copy' transform='translate(622.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M7.44974747%2c11.5068298 L3.77827644%2c11.5068298 C3.36406288%2c11.5068298 3.02827644%2c11.1710434 3.02827644%2c10.7568298 C3.02827644%2c10.3426163 3.36406288%2c10.0068298 3.77827644%2c10.0068298 L9.27827644%2c10.0068298 C9.69249001%2c10.0068298 10.0282764%2c10.3426163 10.0282764%2c10.7568298 C10.0282663%2c10.7591042 10.0282764%2c10.7613808 10.0282764%2c10.7636597 L10.0282764%2c16.2636597 C10.0282764%2c16.6778732 9.69249001%2c17.0136597 9.27827644%2c17.0136597 C8.86406288%2c17.0136597 8.52827644%2c16.6778732 8.52827644%2c16.2636597 L8.52827644%2c12.5496212 L4.59099026%2c16.4869074 C4.29809704%2c16.7798006 3.8232233%2c16.7798006 3.53033009%2c16.4869074 C3.23743687%2c16.1940142 3.23743687%2c15.7191404 3.53033009%2c15.4262472 L7.44974747%2c11.5068298 Z M11.5%2c7.46403847 L15.4372862%2c3.52675228 C15.7301794%2c3.23385906 16.2050531%2c3.23385906 16.4979464%2c3.52675228 C16.7908396%2c3.8196455 16.7908396%2c4.29451923 16.4979464%2c4.58741245 L12.578529%2c8.50682984 L16.25%2c8.50682984 C16.6642136%2c8.50682984 17%2c8.84261627 17%2c9.25682984 C17%2c9.6710434 16.6642136%2c10.0068298 16.25%2c10.0068298 L10.75%2c10.0068298 C10.3357864%2c10.0068298 10%2c9.6710434 10%2c9.25682984 C10.0000102%2c9.25455545 10%2c9.25227891 10%2c9.25 L10%2c3.75 C10%2c3.33578644 10.3357864%2c3 10.75%2c3 C11.1642136%2c3 11.5%2c3.33578644 11.5%2c3.75 L11.5%2c7.46403847 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var render_img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e4%b8%8b%e8%bd%bd copy%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%99%84%e4%bb%b6%e6%b7%bb%e5%8a%a0%e5%a4%8d%e5%88%b6%e9%93%be%e6%8e%a5' transform='translate(-369.000000%2c -555.000000)' fill='%23747272'%3e %3cg id='%e4%b8%8a%e4%bc%a0%e9%99%84%e4%bb%b6%e4%b8%ad-copy-6' transform='translate(56.000000%2c 534.000000)'%3e %3cg id='%e4%b8%8b%e8%bd%bd-copy' transform='translate(312.000000%2c 20.000000)'%3e %3cpath d='M8.81079102%2c8.49228232 L11.0575929%2c6.23659883 C11.367661%2c5.92438892 11.8514298%2c5.89865471 12.1342183%2c6.18304917 C12.4189783%2c6.46942638 12.3934758%2c6.95251315 12.0816605%2c7.26648227 L8.65828197%2c10.7033935 C8.57058276%2c10.8187868 8.45021995%2c10.9080019 8.31097304%2c10.9572592 C8.23162324%2c10.986943 8.14990291%2c11.0008681 8.06879562%2c10.9999582 C8.06613072%2c10.999986 8.0634625%2c11 8.06079102%2c11 C8.05811953%2c11 8.05545131%2c10.999986 8.05278641%2c10.9999582 C7.97167912%2c11.0008681 7.88995879%2c10.986943 7.81060899%2c10.9572592 C7.67136208%2c10.9080019 7.55099928%2c10.8187868 7.46330006%2c10.7033935 L4.03992152%2c7.26648227 C3.72810619%2c6.95251315 3.70260373%2c6.46942638 3.98736375%2c6.18304917 C4.27015222%2c5.89865471 4.75392098%2c5.92438892 5.06398917%2c6.23659883 L7.31079102%2c8.49228232 L7.31079102%2c1.75 C7.31079102%2c1.33578644 7.64657745%2c1 8.06079102%2c1 C8.47500458%2c1 8.81079102%2c1.33578644 8.81079102%2c1.75 L8.81079102%2c8.49228232 Z M15%2c11.0225156 L15%2c13 C15%2c14.1045695 14.1045695%2c15 13%2c15 L3%2c15 C1.8954305%2c15 1%2c14.1045695 1%2c13 L1%2c11 L1.00152941%2c11 C1.00051495%2c10.9840173 1%2c10.9678989 1%2c10.9516602 C1%2c10.5365365 1.33652425%2c10.2000122 1.75164795%2c10.2000122 C2.16677165%2c10.2000122 2.5032959%2c10.5365365 2.5032959%2c10.9516602 C2.5032959%2c10.9755555 2.50218087%2c10.9991903 2.5%2c11.0225156 L2.5%2c12.5 C2.5%2c13.0522847 2.94771525%2c13.5 3.5%2c13.5 L12.5%2c13.5 C13.0522847%2c13.5 13.5%2c13.0522847 13.5%2c12.5 L13.5%2c11 L13.5015294%2c11 C13.5005149%2c10.9840173 13.5%2c10.9678989 13.5%2c10.9516602 C13.5%2c10.5365365 13.8365242%2c10.2000122 14.2516479%2c10.2000122 C14.6667716%2c10.2000122 15.0032959%2c10.5365365 15.0032959%2c10.9516602 C15.0032959%2c10.9755555 15.0021809%2c10.9991903 15%2c11.0225156 Z' id='%e4%b8%8b%e8%bd%bd'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

function render_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function video_extension_render_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function render_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function render_getPrototypeOf(o) {
    render_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return render_getPrototypeOf(o);
}
function render_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) render_setPrototypeOf(subClass, superClass);
}
function render_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            render_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function render_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function render_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        render_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function render_possibleConstructorReturn(self, call) {
    if (call && (render_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return render_assertThisInitialized(self);
}
function render_setPrototypeOf(o, p) {
    render_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return render_setPrototypeOf(o, p);
}
var render_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function render_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function render_createSuper(Derived) {
    var hasNativeReflectConstruct = render_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = render_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = render_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return render_possibleConstructorReturn(this, result);
    };
}
var render_VIDEO_DEFAULT_WIDTH = 512;
var render_VIDEO_DEFAULT_HEIGHT = 288;
var render_PROGRESS_DEFAULT_WIDTH = 235;
// const { isMobile } = getSystemInfo(); // isMobile主要用于toView场景的处理
var render_getPositiveNumber = function(num) {
    return num < 0 ? 0 : num;
};
var render_Video = /*#__PURE__*/ function(Component) {
    render_inherits(Video, Component);
    var _super = render_createSuper(Video);
    function Video(props) {
        video_extension_render_classCallCheck$1(this, Video);
        var _this;
        _this = _super.call(this, props);
        _this.isOnProgressMouseDown = false // 鼠标是否在视频进度条按下状态
        ;
        _this.isOnVolumeMouseDown = false // 鼠标是否在volumeBar（音量条）按下状态
        ;
        _this.state = {
            init: true,
            volume: 0.5,
            isMute: false,
            progress: 0,
            playing: 0,
            current: "00:00",
            total: "00:00",
            isPlay: false,
            hasTip: false,
            tipInfo: {
                // 鼠标在进度条上的时间提示
                time: "00:00",
                offsetX: 0
            },
            showToolBar: true,
            showVolumeBar: false,
            isFullScreen: false,
            isError: false,
            progressWidth: render_PROGRESS_DEFAULT_WIDTH,
            downloadStatus: 0,
            isResizing: false
        };
        _this.observer = null // 增加observer订阅侧边栏变化的事件，更新进度条实际宽度。目前没有想到更好的办法解决这个问题
        ;
        /**
   * 全屏
   */ _this.handleFullScreenChange = function() {
            var isFullScreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen || document.msIsFullScreen;
            if (!isFullScreen) _this.setState({
                isFullScreen: false
            });
        };
        /**
   * 切换播放暂停
   */ _this.togglePlay = function() {
            var isPlay = _this.state.isPlay;
            _this.setState({
                isPlay: !isPlay
            });
            if (isPlay) {
                var _this_video;
                (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.pause();
            } else {
                document.querySelectorAll("audio").forEach(function(otherAudio) {
                    return otherAudio.pause();
                });
                document.querySelectorAll("video").forEach(function(otherVideo) {
                    return otherVideo !== _this.video && otherVideo.pause();
                });
                // this.video && this.video.play()
                if (_this.video) {
                    var playPromise = _this.video.play();
                    if (playPromise !== undefined) {
                        playPromise.then(function() {}).catch(function(e) {
                            console.error(e);
                        });
                    }
                }
            }
        };
        /**
   * 浏览器可以开始播放时触发
   */ _this.handleCanPlay = function() {
            var duration = render_getPositiveNumber(_this.video.duration);
            var total = render_formatTime(duration);
            _this.setState({
                total: total
            });
        };
        /**
   * 视频正在下载触发
   */ _this.handleProgress = function() {
            if (_this.video.buffered.length <= 0) {
                return;
            }
            var progress = render_getPositiveNumber(_this.video.buffered.end(0) / _this.video.duration);
            _this.setState({
                progress: progress
            });
        };
        /**
   * 视频暂停时触发
   */ _this.handlePause = function() {
            if (document.hidden) return;
            var _this_state = _this.state, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar;
            if (isPlay) {
                _this.setState({
                    isPlay: false
                });
            }
            if (!showToolBar) _this.setState({
                showToolBar: true
            });
        };
        /**
   * 播放位置改变重新定位
   */ _this.handleTimeUpdate = function() {
            var currentTime = render_getPositiveNumber(_this.video.currentTime);
            var current = render_formatTime(currentTime);
            var playing = currentTime / _this.video.duration;
            _this.setState({
                current: current,
                playing: playing
            });
            var init = _this.state.init;
            if (init) _this.setState({
                init: false
            });
        };
        _this.handleVideoMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 视频区域鼠标移动响应，进度条拖动则更新进度
   */ _this.handleVideoMouseMove = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth, showToolBar = _this_state.showToolBar;
            var left = _this.progressBar.getBoundingClientRect().left;
            var zoom = _this.props.zoom;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var calculateProgressWidth = isFullScreen ? render_PROGRESS_DEFAULT_WIDTH : progressWidth;
            var newCurrentTime = render_getPositiveNumber(dis / calculateProgressWidth * _this.video.duration);
            if (_this.isOnProgressMouseDown) {
                _this.video.currentTime = newCurrentTime;
                _this.handleTimeUpdate();
            }
            if (!showToolBar) _this.setState({
                showToolBar: true
            });
            _this.toggleToolbarDebounce();
        };
        _this.handleVideoMouseLeave = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 鼠标按下进度条某处
   */ _this.handleProgressBarMouseDown = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth;
            var calculateProgressWidth = isFullScreen ? render_PROGRESS_DEFAULT_WIDTH : progressWidth;
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = render_getPositiveNumber(dis / calculateProgressWidth * _this.video.duration);
            _this.video.currentTime = newCurrentTime;
            _this.isOnProgressMouseDown = true;
            e.preventDefault();
        };
        /**
   * 进度条上的鼠标释放
   */ _this.handleProgressBarMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 进度条区域鼠标移动响应，设置鼠标位置时间提示
   */ _this.handleProgressMouseMove = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth;
            var calculateProgressWidth = isFullScreen ? render_PROGRESS_DEFAULT_WIDTH : progressWidth;
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = dis / calculateProgressWidth * _this.video.duration;
            if (newCurrentTime > _this.video.duration || newCurrentTime < 0) {
                _this.setState({
                    hasTip: false
                });
                return;
            }
            _this.setState({
                hasTip: true,
                tipInfo: {
                    time: render_formatTime(newCurrentTime),
                    offsetX: dis
                }
            });
        };
        /**
   * 在音量条按下鼠标后移动调整音量
   */ _this.handleVolumeBarMouseDown = function(e) {
            var bottom = _this.volumeBar.getBoundingClientRect().bottom;
            var zoom = _this.props.zoom;
            var clientY = e.nativeEvent.clientY / zoom;
            var dis = bottom - clientY;
            var volume = (dis > 0 ? dis : 0) / 80;
            volume = volume > 1 ? 1 : volume;
            _this.video.volume = volume;
            _this.setState({
                volume: volume,
                isMute: false
            });
            _this.isOnVolumeMouseDown = true;
            e.preventDefault();
        };
        /**
   * 音量条上的鼠标释放
   */ _this.handleVolumeBarMouseUp = function() {
            _this.isOnVolumeMouseDown = false;
        };
        /**
   * 在音量条按下鼠标后移动调整音量
   */ _this.handleVolumeBarMouseMove = function(e) {
            if (_this.isOnVolumeMouseDown) {
                _this.handleVolumeBarMouseDown(e);
            }
        };
        _this.showVolumeBar = function() {
            _this.setState({
                showVolumeBar: true
            });
        };
        _this.hideVolumeBar = function() {
            _this.setState({
                showVolumeBar: false
            });
        };
        /**
   * 静音切换
   */ _this.toggleMute = function() {
            var _this_state = _this.state, volume = _this_state.volume, isMute = _this_state.isMute;
            if (isMute) {
                _this.video.volume = volume;
                _this.setState({
                    isMute: false
                });
            } else {
                _this.video.volume = 0;
                _this.setState({
                    isMute: true
                });
            }
        };
        /**
   * 双击全屏切换
   */ _this.toggleScale = function() {
            var isFullScreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen || document.msIsFullScreen;
            if (isFullScreen) {
                var efs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
                if (efs) {
                    efs.call(document);
                }
            } else {
                var rfs = _this.video.requestFullscreen || _this.video.webkitRequestFullscreen || _this.video.mozRequestFullScreen || _this.video.msRequestFullscreen;
                if (rfs) {
                    rfs.call(_this.video.parentElement.parentElement);
                }
                _this.setState({
                    isFullScreen: true
                });
            }
        };
        /**
   * 切换toolbar(视频下方工具栏包括进度条音量等)展示隐藏
   */ _this.toggleToolbar = function() {
            var _this_state = _this.state, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar;
            if (isPlay && showToolBar) {
                _this.setState({
                    showToolBar: false
                });
            }
        };
        /**
   * 处理视频文件下载
   */ _this.handleDownload = function() {
            var _provider_handleUrl;
            var downloadStatus = _this.state.downloadStatus;
            if (downloadStatus === 1) return;
            var _this_props = _this.props, url = _this_props.url, name = _this_props.name, provider = _this_props.provider;
            var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
            provider.download(src, name);
        };
        _this.handleDragStart = function(e) {
            e.preventDefault();
        };
        /**
   * 视频文件异常错误处理，可以做一些异常上报的工作
   */ _this.handleError = function() {
            _this.setState({
                isError: true
            });
            var _this_props = _this.props, handleVideoError = _this_props.provider.handleVideoError, url = _this_props.url;
            // 提供给业务方进行视频错误处理
            handleVideoError === null || handleVideoError === void 0 ? void 0 : handleVideoError(_this.video.error, url);
        };
        /**
   * 文件获取失败重试
   */ _this.handleRetry = function() {
            _this.setState({
                isError: false
            });
        };
        _this.handleResizeStart = function() {
            _this.setState({
                isResizing: true
            });
        };
        /**
   * 调整完成后调用
   * @param size object 包括调整后的width、height
   */ _this.handleResizeEnd = function(size) {
            var _this_video;
            var _this_props = _this.props, view = _this_props.view, getPos = _this_props.getPos;
            var state = view.state, dispatch = view.dispatch;
            var tr = state.tr, doc = state.doc;
            var pos = getPos();
            var node = doc.nodeAt(pos);
            dispatch(tr.setNodeMarkup(pos, null, render_objectSpreadProps(render_objectSpread({}, node.attrs), {
                width: size.width,
                height: size.height
            })).setSelection(prosemirror_state_dist["NodeSelection"].create(tr.doc, pos)) // 重新设置选区
            );
            // 调整视频宏大小后需要重置进度
            _this.setState({
                current: "00:00",
                isPlay: false,
                playing: 0,
                progress: 0,
                progressWidth: _this.progressBar.clientWidth,
                isResizing: false
            });
            _this.video.currentTime = 0;
            (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.pause();
        };
        _this.toggleToolbarDebounce = lodash_debounce_default()(_this.toggleToolbar, 3e3);
        return _this;
    }
    var _proto = Video.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        if (document.exitFullscreen) {
            document.addEventListener("fullscreenchange", this.handleFullScreenChange);
        } else if (document.webkitExitFullscreen) {
            document.addEventListener("webkitfullscreenchange", this.handleFullScreenChange);
        } else if (document.mozCancelFullScreen) {
            document.addEventListener("mozfullscreenchange", this.handleFullScreenChange);
        } else if (document.exitFullscreen) {
            document.addEventListener("MSFullscreenChange", this.handleFullScreenChange);
        }
        // if (!isMobile) {
        this.timer = setTimeout(function() {
            var _this_progressBar;
            if (((_this_progressBar = _this.progressBar) === null || _this_progressBar === void 0 ? void 0 : _this_progressBar.clientWidth) !== render_PROGRESS_DEFAULT_WIDTH) {
                _this.setState({
                    progressWidth: _this.progressBar.clientWidth
                });
            }
            // observer相关代码
            var target = document.querySelector(".resize-box");
            if (target) {
                var config = {
                    attributes: true
                };
                var resetWidth = function() {
                    if (_this.progressBar) {
                        _this.setState({
                            progressWidth: _this.progressBar.clientWidth
                        });
                    }
                };
                _this.observer = new MutationObserver(resetWidth);
                _this.observer.observe(target, config);
            }
        }, 0);
    // }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (document.exitFullscreen) {
            document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
        } else if (document.webkitExitFullscreen) {
            document.removeEventListener("webkitfullscreenchange", this.handleFullScreenChange);
        } else if (document.mozCancelFullScreen) {
            document.removeEventListener("mozfullscreenchange", this.handleFullScreenChange);
        } else if (document.msExitFullscreen) {
            document.removeEventListener("MSFullscreenChange", this.handleFullScreenChange);
        }
        this.timer && clearTimeout(this.timer);
        // !isMobile && this.observer && this.observer.disconnect();
        this.observer && this.observer.disconnect();
    };
    _proto.render = function render() {
        var _this = this;
        var _provider_handleUrl;
        var _this_props = this.props, url = _this_props.url, width = _this_props.width, height = _this_props.height, view = _this_props.view, getPos = _this_props.getPos, provider = _this_props.provider, resizer = _this_props.resizer;
        var _this_state = this.state, init = _this_state.init, volume = _this_state.volume, isMute = _this_state.isMute, progress = _this_state.progress, playing = _this_state.playing, current = _this_state.current, total = _this_state.total, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar, showVolumeBar = _this_state.showVolumeBar, isFullScreen = _this_state.isFullScreen, isError = _this_state.isError, hasTip = _this_state.hasTip, _this_state_tipInfo = _this_state.tipInfo, time = _this_state_tipInfo.time, offsetX = _this_state_tipInfo.offsetX, downloadStatus = _this_state.downloadStatus, progressWidth = _this_state.progressWidth, isResizing = _this_state.isResizing;
        var calculateProgressWidth = isFullScreen ? render_PROGRESS_DEFAULT_WIDTH : progressWidth;
        // 业务方可以对url进行加工处理
        var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
        var VIDEO_WIDTH = +width < render_VIDEO_DEFAULT_WIDTH ? render_VIDEO_DEFAULT_WIDTH : +width;
        var VIDEO_HEIGHT = +height < render_VIDEO_DEFAULT_HEIGHT ? render_VIDEO_DEFAULT_HEIGHT : +height;
        var style = {
            width: "".concat(VIDEO_WIDTH, "px"),
            height: "".concat(VIDEO_HEIGHT, "px")
        };
        // const isPrint = window.location.href.includes("print"); // 是否为打印页面
        // if (isError && !isPrint) {
        if (isError) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                className: "".concat(video_extension_render_classNamePrefix("video-view"), " error"),
                style: style
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "notice",
                "data-src": src
            }, window.navigator.onLine ? "文件获取失败" : "网络连接失败"), /*#__PURE__*/ react_default.a.createElement("button", {
                className: "retry ".concat(video_extension_render_classNamePrefix("btn")),
                onClick: this.handleRetry
            }, "重试"));
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: video_extension_render_classNamePrefix("video-view"),
            style: style,
            onMouseUp: this.handleVideoMouseUp,
            onMouseMove: this.handleVideoMouseMove,
            onMouseLeave: this.handleVideoMouseLeave,
            onDragStart: this.handleDragStart,
            ref: function(ref) {
                _this.videoWrapper = ref;
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("middle", {
                pause: !isPlay
            }),
            onClick: this.togglePlay
        }, /*#__PURE__*/ react_default.a.createElement("video", {
            ref: function(ref) {
                _this.video = ref;
            },
            src: src,
            preload: "meta",
            volume: isMute ? 0 : volume,
            onCanPlay: this.handleCanPlay,
            onProgress: this.handleProgress,
            onTimeUpdate: this.handleTimeUpdate,
            onPause: this.handlePause,
            onDoubleClick: this.toggleScale,
            onError: this.handleError
        }, "本浏览器不支持 HTML5 video 标签")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("bottom", {
                hidden: !showToolBar
            })
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "play-btn",
            onClick: this.togglePlay
        }, !isPlay ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img,
            alt: "播放"
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img$1,
            alt: "暂停"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-bar",
            ref: function(ref) {
                _this.progressBar = ref;
            },
            onMouseDown: this.handleProgressBarMouseDown,
            onMouseMove: this.handleProgressMouseMove,
            onMouseLeave: function() {
                return _this.setState({
                    hasTip: false
                });
            },
            style: isResizing ? {
                overflow: "hidden"
            } : {}
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "load-bar",
            style: {
                width: "".concat(init ? 0 : progress * calculateProgressWidth, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-bar", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                width: "".concat(playing * calculateProgressWidth, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-button", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                left: "".concat(playing * calculateProgressWidth, "px")
            }
        }), hasTip && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip-wrapper",
            style: {
                left: "".concat(offsetX - 22, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip"
        }, time))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "time"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "current"
        }, current), /*#__PURE__*/ react_default.a.createElement("span", null, "/"), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "total"
        }, total)), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-btn",
            onMouseEnter: this.showVolumeBar,
            onMouseLeave: this.hideVolumeBar,
            onDragStart: this.handleDragStart
        }, isMute || volume < 0.01 ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img$3,
            alt: "静音",
            onClick: this.toggleMute
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img$2,
            alt: "音量",
            onClick: this.toggleMute
        }), showVolumeBar && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar-wrapper",
            onMouseMove: this.handleVolumeBarMouseMove,
            onMouseUp: this.handleVolumeBarMouseUp
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar",
            ref: function(ref) {
                _this.volumeBar = ref;
            },
            onMouseDown: this.handleVolumeBarMouseDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "selected-bar",
            style: {
                height: "".concat(isMute ? 0 : volume * 80, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bar-btn"
        }))))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "scale-btn",
            onClick: this.toggleScale
        }, isFullScreen ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img$5,
            alt: "缩小"
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img$4,
            alt: "缩小"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("download-btn", {
                error: downloadStatus === 2,
                "video-loading": downloadStatus === 1
            }),
            onClick: this.handleDownload
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip"
        }, "下载失败，请重试")), /*#__PURE__*/ react_default.a.createElement("img", {
            src: render_img$6,
            alt: "下载"
        }))), this.videoWrapper && resizer && /*#__PURE__*/ react_default.a.createElement(render_Resizer, {
            $container: this.videoWrapper,
            view: view,
            getPos: getPos,
            initialWidth: VIDEO_WIDTH,
            initialHeight: VIDEO_HEIGHT,
            onResizeEnd: this.handleResizeEnd,
            onResizeStart: this.handleResizeStart,
            limit: {
                minWidth: render_VIDEO_DEFAULT_WIDTH,
                minHeight: render_VIDEO_DEFAULT_HEIGHT
            },
            fixedRatio: false,
            hideInfo: true
        }));
    };
    return Video;
}(react["Component"]);
render_Video.defaultProps = {
    zoom: 1,
    resizer: true
};

var video_extension_render_css_248z$1 = '.ct-video{margin:8px 0;max-width:100%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ct-video.align-center{margin:0 auto}.ct-video.align-right{float:right;margin-top:0}.ct-video.align-right+*,.ct-video.align-right+div+span+*{clear:both}.ct-video-view{background:#f6f6f6;border:1px solid #ddd;height:288px;max-width:100%;min-height:288px;min-width:512px;position:relative;width:512px}.ct-video-view img{vertical-align:unset}.ct-video-view:hover{border:1px solid #3d91f2;cursor:pointer}.ct-video-view .middle{background:#000;height:100%;width:100%}.ct-video-view .middle:after{content:"";opacity:0;position:absolute;transition:opacity .3s ease}.ct-video-view .middle video{display:block;height:100%;width:100%}.ct-video-view .middle.pause{position:relative}.ct-video-view .middle.pause:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2220px%22 viewBox%3D%220 0 18 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%A2%84%E8%A7%88%E6%92%AD%E6%94%BE%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard-2%22 transform%3D%22translate(-446.000000%2C -115.000000)%22 fill%3D%22%236B6B6B%22%3E            %3Cg id%3D%22Group-12%22 transform%3D%22translate(446.000000%2C 115.000000)%22%3E                %3Cpath d%3D%22M17.5258914%2C10.7953904 L1.4484631%2C19.8724989 C0.990863649%2C20.1308537 0.401755017%2C19.9841502 0.132652138%2C19.5448276 C0.0457979589%2C19.4030342 0%2C19.2415294 0%2C19.0770349 L3.41490118e-15%2C0.922817934 C3.41490118e-15%2C0.413159662 0.430348031%2C0 0.961209231%2C0 C1.1325471%2C0 1.30077079%2C0.0439687597 1.4484631%2C0.127353928 L17.5258914%2C9.20446242 C17.9834908%2C9.46281716 18.1362975%2C10.0283964 17.8671946%2C10.4677191 C17.7843081%2C10.603035 17.6668367%2C10.7158145 17.5258914%2C10.7953904 Z%22 id%3D%22Triangle-2%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 23px;background-color:#fff;border-radius:50%;height:60px;left:50%;margin-left:-30px;margin-top:-30px;opacity:1;top:50%;transition:opacity .3s ease;width:60px}.ct-video-view .middle.pause:before{background:rgba(0,0,0,.5);bottom:0;content:"";left:0;position:absolute;right:0;top:0}.ct-video-view .middle.pause:hover:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2220px%22 viewBox%3D%220 0 18 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%A2%84%E8%A7%88%E6%92%AD%E6%94%BE%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard-2%22 transform%3D%22translate(-446.000000%2C -115.000000)%22 fill%3D%22%2323bdd9%22%3E            %3Cg id%3D%22Group-12%22 transform%3D%22translate(446.000000%2C 115.000000)%22%3E                %3Cpath d%3D%22M17.5258914%2C10.7953904 L1.4484631%2C19.8724989 C0.990863649%2C20.1308537 0.401755017%2C19.9841502 0.132652138%2C19.5448276 C0.0457979589%2C19.4030342 0%2C19.2415294 0%2C19.0770349 L3.41490118e-15%2C0.922817934 C3.41490118e-15%2C0.413159662 0.430348031%2C0 0.961209231%2C0 C1.1325471%2C0 1.30077079%2C0.0439687597 1.4484631%2C0.127353928 L17.5258914%2C9.20446242 C17.9834908%2C9.46281716 18.1362975%2C10.0283964 17.8671946%2C10.4677191 C17.7843081%2C10.603035 17.6668367%2C10.7158145 17.5258914%2C10.7953904 Z%22 id%3D%22Triangle-2%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 23px;background-color:#fff}.ct-video-view .bottom{background:#f6f6f6;bottom:0;display:flex;height:40px;padding:0 16px;position:absolute;transition:opacity .5s ease;width:100%}.ct-video-view .bottom:hover{opacity:1}.ct-video-view .bottom.hidden{opacity:0}.ct-video-view .play-btn{cursor:pointer;height:18px;margin-top:11px;transition:all .1s ease;width:18px}.ct-video-view .play-btn:hover path{fill:#3d91f2}.ct-video-view .progress-bar{background:#d9d9d9;background-clip:content-box;border-radius:100px;cursor:pointer;flex:1;height:10px;margin:16px 16px 0;padding:3px 0;position:relative}.ct-video-view .load-bar{background:#b6b6b6;transition:all 3s linear;z-index:1}.ct-video-view .load-bar,.ct-video-view .played-bar{border-radius:100px;height:4px;position:absolute;top:3px;width:0}.ct-video-view .played-bar{background:#1c6cdc;transition:all .3s linear;z-index:2}.ct-video-view .played-bar.dragged{transition:none}.ct-video-view .played-button{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);height:12px;position:absolute;top:-2px;transition:all .3s linear;width:12px;z-index:10}.ct-video-view .played-button.dragged{transition:none}.ct-video-view .progress-tip-wrapper{height:28px;left:0;position:absolute;top:-27px;width:48px}.ct-video-view .progress-tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-video-view .progress-tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;width:0}.ct-video-view .progress-tip:after,.ct-video-view .progress-tip:before{content:"";display:block;position:absolute;right:50%;transform:translate(50%);z-index:2}.ct-video-view .progress-tip:before{background:rgba(0,0,0,.68);bottom:-9px;height:4px;width:1px}.ct-video-view .time{display:flex;justify-content:space-between;align-items:center;color:#333;font-size:12px;line-height:12px;text-align:right;width:80px}.ct-video-view .volume-btn{cursor:pointer;height:40px;margin:0 16px;padding-top:10px;position:relative;transition:all .1s ease;width:20px}.ct-video-view .volume-btn:hover path:first-child{fill:#3d91f2}.ct-video-view .volume-btn:hover path:nth-child(2){stroke:#3d91f2}.ct-video-view .volume-bar-wrapper{background:#fff;border-radius:2px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);height:102px;left:-15%;position:absolute;top:-102px;width:30px;z-index:9}.ct-video-view .volume-bar{background:#d9d9d9;border-radius:100px;height:80px;left:50%;position:absolute;top:11px;transform:translate(-50%);width:4px}.ct-video-view .selected-bar{background:#1c6cdc;border-radius:100px;bottom:0;height:0;position:absolute;transition:all .2s;width:4px;z-index:2}.ct-video-view .selected-bar .bar-btn{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);content:"";height:12px;position:absolute;right:-4px;top:-6px;width:12px}.ct-video-view .scale-btn{cursor:pointer;height:20px;margin-right:16px;margin-top:10px;transition:all .1s ease;width:20px}.ct-video-view .scale-btn:hover path{fill:#3d91f2}.ct-video-view .download-btn{cursor:pointer;height:24px;margin-top:10px;position:relative;transition:all .1s ease;width:25px}.ct-video-view .download-btn:hover path{fill:#3d91f2}.ct-video-view .download-btn .tip-wrapper{display:none;height:28px;left:7px;position:absolute;top:-30px}.ct-video-view .download-btn .tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-video-view .download-btn .tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;content:"";display:block;position:absolute;right:50%;transform:translate(50%);width:0;z-index:2}.ct-video-view .download-btn.video-loading:after{-webkit-animation:loading .8s linear infinite;animation:loading .8s linear infinite;border-radius:50%;border:2px solid #d5d5d5;content:"";display:inline-block;height:18px;vertical-align:-8%;width:18px}.ct-video-view .download-btn.video-loading svg{display:none}.ct-video-view .download-btn.error{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%228px%22 height%3D%228px%22 viewBox%3D%220 0 8 8%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3ECombined Shape%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Crect id%3D%22Rectangle-2%22 fill%3D%22%23FFFFFF%22 x%3D%222%22 y%3D%221%22 width%3D%224%22 height%3D%226%22%3E%3C%2Frect%3E        %3Cpath d%3D%22M0%2C4 C0%2C1.79088 1.79088%2C0 4%2C0 C6.20912%2C0 8%2C1.79088 8%2C4 C8%2C6.20912 6.20912%2C8 4%2C8 C1.79088%2C8 0%2C6.20912 0%2C4 Z M4.00000002%2C1.34999998 C3.34188252%2C1.34999998 2.87727375%2C1.67743076 3%2C2.5 L3.40000002%2C4.36638153 C3.40000002%2C4.69277782 3.66862917%2C4.96459961 4.00000002%2C4.96459961 C4.33368113%2C4.96459961 4.60000002%2C4.69676825 4.60000002%2C4.36638153 L5%2C2.5 C5.15197984%2C1.72235314 4.74297343%2C1.34999998 4.00000002%2C1.34999998 Z M4%2C6.65000002 C4.33137086%2C6.65000002 4.60000002%2C6.38137086 4.60000002%2C6.05 C4.60000002%2C5.71862914 4.33137086%2C5.44999998 4%2C5.44999998 C3.66862914%2C5.44999998 3.39999998%2C5.71862914 3.39999998%2C6.05 C3.39999998%2C6.38137086 3.66862914%2C6.65000002 4%2C6.65000002 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23F5222D%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 100% 0}.ct-video-view .download-btn.error:hover .tip-wrapper{display:block}.ct-video-view:-moz-full-screen{height:100%;width:100%}.ct-video-view:-moz-full-screen hover{border:none}.ct-video-view:-moz-full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:-moz-full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:full-screen{height:100%;width:100%}.ct-video-view:full-screen hover{border:none}.ct-video-view:full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:-webkit-full-screen{height:100%;width:100%}.ct-video-view:-ms-fullscreen{height:100%;width:100%}.ct-video-view:fullscreen{height:100%;width:100%}.ct-video-view:-webkit-full-screen hover{border:none}.ct-video-view:-ms-fullscreen hover{border:none}.ct-video-view:fullscreen hover{border:none}.ct-video-view:-webkit-full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:-ms-fullscreen .middle.pause:after{transform:scale(2)}.ct-video-view:fullscreen .middle.pause:after{transform:scale(2)}.ct-video-view:-webkit-full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:-ms-fullscreen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:fullscreen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ProseMirror-selectednode .ct-video-view{border:1px solid #1c6cdc}.ct-video-view.error{background:rgba(0,0,0,.5);font-size:14px}.ct-video-view.error .notice{color:#fff;margin-top:100px;text-align:center}.ct-video-view.error .retry{background:#1c6cdc;border:none;color:#fff;display:block;height:32px;line-height:32px;margin:24px auto 0;width:76px}.ct-video-view.mobile{border:1px solid #ddd;max-width:100%;min-width:0}.ct-video-view.mobile video{margin:0}';
video_extension_render_styleInject(video_extension_render_css_248z$1);

function render_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var render_videoRender = function videoRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    render_classCallCheck$2(this, videoRender);
    this.fragmentRender = function(node) {
        var url = node.getAttribute("data-url");
        var name = node.getAttribute("data-name");
        var size = node.getAttribute("data-size");
        var width = parseInt(node.getAttribute("data-width"), 10) || 0;
        var height = parseInt(node.getAttribute("data-height"), 10) || 0;
        var provider = new render_AudioProvider();
        react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(render_Video, {
            url: url,
            name: name,
            size: size,
            width: width,
            height: height,
            provider: provider,
            resizer: false
        }), node);
    };
    this.fragmentCls = ".".concat(video_extension_render_classNamePrefix("video"));
    this.config = config;
};

/* harmony default export */ var video_extension_render = (render_videoRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/audio-extension/render.js







/**
 * 统一样式前缀
 */ var audio_extension_render_CLASSNAME_PREFIX = "ct";

var audio_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : audio_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var audio_extension_render_getPositiveNumber = function(num) {
    return num < 0 ? 0 : num;
};
/**
 *格式化时间字符串
 * @param time
 * @returns HH:MM格式字符串
 */ var audio_extension_render_formatTime = function(time) {
    var minute = parseInt("".concat(time / 60), 10);
    var second = parseInt("".concat(time % 60), 10);
    return "".concat(minute < 10 ? "0".concat(minute) : minute, ":").concat(second < 10 ? "0".concat(second) : second);
};

var audio_extension_render_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

function audio_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function audio_extension_render_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                audio_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                audio_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function audio_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var audio_extension_render_generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var audio_extension_render_AudioProvider = /*#__PURE__*/ function() {
    function AudioProvider() {
        audio_extension_render_classCallCheck(this, AudioProvider);
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.beforeUpload = function(file) {
            return true;
        };
        this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("上传方法未定义"));
            });
        };
        this.audioTranscode = function() {
            var _ref = audio_extension_render_asyncToGenerator(function(data, file) {
                return audio_extension_render_generator$1(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioProvider.prototype;
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AudioProvider;
}();

var audio_extension_render_generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var audio_extension_render_generator$3 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var audio_extension_render_generator$4 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var audio_extension_render_img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%92%ad%e6%94%be%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-471.000000%2c -558.000000)'%3e %3cg id='Group-18' transform='translate(471.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M15.6839276%2c10.5567733 L4.96564206%2c16.9107492 C4.66057577%2c17.0915976 4.26783668%2c16.9889051 4.08843476%2c16.6813793 C4.03053197%2c16.5821239 4%2c16.4690706 4%2c16.3539244 L4%2c3.64597255 C4%2c3.28921176 4.28689869%2c3 4.64080615%2c3 C4.7550314%2c3 4.86718053%2c3.03077813 4.96564206%2c3.08914775 L15.6839276%2c9.44312369 C15.9889939%2c9.62397201 16.090865%2c10.0198775 15.9114631%2c10.3274033 C15.8562054%2c10.4221245 15.7778912%2c10.5010701 15.6839276%2c10.5567733 Z' id='Triangle-2' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_render_img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%9a%82%e5%81%9c%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-395.000000%2c -558.000000)'%3e %3cg id='Group-18-Copy' transform='translate(395.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M5%2c3 L7%2c3 C7.55228475%2c3 8%2c3.44771525 8%2c4 L8%2c16 C8%2c16.5522847 7.55228475%2c17 7%2c17 L5%2c17 C4.44771525%2c17 4%2c16.5522847 4%2c16 L4%2c4 C4%2c3.44771525 4.44771525%2c3 5%2c3 Z M13%2c3 L15%2c3 C15.5522847%2c3 16%2c3.44771525 16%2c4 L16%2c16 C16%2c16.5522847 15.5522847%2c17 15%2c17 L13%2c17 C12.4477153%2c17 12%2c16.5522847 12%2c16 L12%2c4 C12%2c3.44771525 12.4477153%2c3 13%2c3 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_render_img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%87%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-514.000000%2c -558.000000)'%3e %3cg id='Group-22' transform='translate(514.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(2.000000%2c 4.000000)'%3e %3cg id='Group-21'%3e %3cpath d='M0%2c8.12082937 C0%2c8.6754175 0.442660332%2c9.125 0.998956561%2c9.125 L3%2c9.125 L6.19054031%2c11.4182009 C6.63759255%2c11.7395196 7%2c11.544239 7%2c10.9975267 L7%2c1.00247329 C7%2c0.448822582 6.63085938%2c0.265319824 6.19054031%2c0.58179915 L3%2c2.875 L0.998956561%2c2.875 C0.447248087%2c2.875 0%2c3.32448459 0%2c3.87917063 L0%2c8.12082937 Z' id='Fill-89' fill='%236B6B6B'%3e%3c/path%3e %3cpath d='M10%2c2 C11.3333333%2c3.06070964 12%2c4.39404297 12%2c6 C12%2c7.60595703 11.3333333%2c8.93929036 10%2c10' id='Path-12' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3cpath d='M13%2c0 C15%2c1.3984375 16%2c3.3984375 16%2c6 C16%2c8.6015625 15%2c10.6015625 13%2c12' id='Path-12-Copy' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_render_img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9d%99%e9%9f%b3%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-550.000000%2c -558.000000)'%3e %3cg id='Group-22-Copy' transform='translate(550.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(4.000000%2c 4.000000)' fill='%236B6B6B'%3e %3cpath d='M9%2c1.72792206 L2.12273522%2c8.60518684 C2.04439515%2c8.46156167 2%2c8.29646112 2%2c8.12082937 L2%2c3.87917063 C2%2c3.32448459 2.44724809%2c2.875 2.99895656%2c2.875 L5%2c2.875 L8.19054031%2c0.58179915 C8.63085937%2c0.265319824 9%2c0.448822582 9%2c1.00247329 L9%2c1.72792206 Z M9%2c6.67766953 L9%2c10.9975267 C9%2c11.544239 8.63759255%2c11.7395196 8.19054031%2c11.4182009 L5.90337136%2c9.77429817 L9%2c6.67766953 Z M12.2582521%2c0.944543648 C12.5511454%2c1.23743687 12.5511454%2c1.7123106 12.2582521%2c2.00520382 L2.00520382%2c12.2582521 C1.7123106%2c12.5511454 1.23743687%2c12.5511454 0.944543648%2c12.2582521 C0.651650429%2c11.9653589 0.651650429%2c11.4904852 0.944543648%2c11.197592 L11.197592%2c0.944543648 C11.4904852%2c0.651650429 11.9653589%2c0.651650429 12.2582521%2c0.944543648 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var audio_extension_render_img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e4%b8%8b%e8%bd%bd copy%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%99%84%e4%bb%b6%e6%b7%bb%e5%8a%a0%e5%a4%8d%e5%88%b6%e9%93%be%e6%8e%a5' transform='translate(-369.000000%2c -555.000000)' fill='%23747272'%3e %3cg id='%e4%b8%8a%e4%bc%a0%e9%99%84%e4%bb%b6%e4%b8%ad-copy-6' transform='translate(56.000000%2c 534.000000)'%3e %3cg id='%e4%b8%8b%e8%bd%bd-copy' transform='translate(312.000000%2c 20.000000)'%3e %3cpath d='M8.81079102%2c8.49228232 L11.0575929%2c6.23659883 C11.367661%2c5.92438892 11.8514298%2c5.89865471 12.1342183%2c6.18304917 C12.4189783%2c6.46942638 12.3934758%2c6.95251315 12.0816605%2c7.26648227 L8.65828197%2c10.7033935 C8.57058276%2c10.8187868 8.45021995%2c10.9080019 8.31097304%2c10.9572592 C8.23162324%2c10.986943 8.14990291%2c11.0008681 8.06879562%2c10.9999582 C8.06613072%2c10.999986 8.0634625%2c11 8.06079102%2c11 C8.05811953%2c11 8.05545131%2c10.999986 8.05278641%2c10.9999582 C7.97167912%2c11.0008681 7.88995879%2c10.986943 7.81060899%2c10.9572592 C7.67136208%2c10.9080019 7.55099928%2c10.8187868 7.46330006%2c10.7033935 L4.03992152%2c7.26648227 C3.72810619%2c6.95251315 3.70260373%2c6.46942638 3.98736375%2c6.18304917 C4.27015222%2c5.89865471 4.75392098%2c5.92438892 5.06398917%2c6.23659883 L7.31079102%2c8.49228232 L7.31079102%2c1.75 C7.31079102%2c1.33578644 7.64657745%2c1 8.06079102%2c1 C8.47500458%2c1 8.81079102%2c1.33578644 8.81079102%2c1.75 L8.81079102%2c8.49228232 Z M15%2c11.0225156 L15%2c13 C15%2c14.1045695 14.1045695%2c15 13%2c15 L3%2c15 C1.8954305%2c15 1%2c14.1045695 1%2c13 L1%2c11 L1.00152941%2c11 C1.00051495%2c10.9840173 1%2c10.9678989 1%2c10.9516602 C1%2c10.5365365 1.33652425%2c10.2000122 1.75164795%2c10.2000122 C2.16677165%2c10.2000122 2.5032959%2c10.5365365 2.5032959%2c10.9516602 C2.5032959%2c10.9755555 2.50218087%2c10.9991903 2.5%2c11.0225156 L2.5%2c12.5 C2.5%2c13.0522847 2.94771525%2c13.5 3.5%2c13.5 L12.5%2c13.5 C13.0522847%2c13.5 13.5%2c13.0522847 13.5%2c12.5 L13.5%2c11 L13.5015294%2c11 C13.5005149%2c10.9840173 13.5%2c10.9678989 13.5%2c10.9516602 C13.5%2c10.5365365 13.8365242%2c10.2000122 14.2516479%2c10.2000122 C14.6667716%2c10.2000122 15.0032959%2c10.5365365 15.0032959%2c10.9516602 C15.0032959%2c10.9755555 15.0021809%2c10.9991903 15%2c11.0225156 Z' id='%e4%b8%8b%e8%bd%bd'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

/* eslint-disable jsx-a11y/media-has-caption */ function audio_extension_render_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function audio_extension_render_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function audio_extension_render_getPrototypeOf(o) {
    audio_extension_render_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return audio_extension_render_getPrototypeOf(o);
}
function audio_extension_render_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) audio_extension_render_setPrototypeOf(subClass, superClass);
}
function audio_extension_render_possibleConstructorReturn(self, call) {
    if (call && (audio_extension_render_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return audio_extension_render_assertThisInitialized(self);
}
function audio_extension_render_setPrototypeOf(o, p) {
    audio_extension_render_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return audio_extension_render_setPrototypeOf(o, p);
}
var audio_extension_render_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function audio_extension_render_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function audio_extension_render_createSuper(Derived) {
    var hasNativeReflectConstruct = audio_extension_render_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = audio_extension_render_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = audio_extension_render_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return audio_extension_render_possibleConstructorReturn(this, result);
    };
}
var render_Audio = /*#__PURE__*/ function(Component) {
    audio_extension_render_inherits(Audio, Component);
    var _super = audio_extension_render_createSuper(Audio);
    function Audio() {
        audio_extension_render_classCallCheck$1(this, Audio);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isOnProgressMouseDown = false;
        _this.isOnVolumeMouseDown = false;
        _this.state = {
            init: true,
            volume: 0.5,
            isMute: false,
            progress: 0,
            playing: 0,
            current: "00:00",
            total: "00:00",
            isPlay: false,
            hasTip: false,
            tipInfo: {
                time: "",
                offsetX: 0
            },
            showVolumeBar: false,
            volumeBarInfo: {},
            isError: false,
            downloadStatus: 0
        };
        // 播放暂停切换
        _this.togglePlay = function() {
            var isPlay = _this.state.isPlay;
            _this.setState({
                isPlay: !isPlay
            }, function() {
                // eslint-disable-next-line react/destructuring-assignment
                if (_this.state.isPlay) {
                    document.querySelectorAll("audio").forEach(function(otherAudio) {
                        return otherAudio.pause();
                    });
                    document.querySelectorAll("video").forEach(function(otherVideo) {
                        return otherVideo.pause();
                    });
                    if (_this.audio) {
                        var playPromise = _this.audio.play();
                        if (playPromise !== undefined) {
                            playPromise.then(function() {}).catch(function(e) {
                                // eslint-disable-next-line no-console
                                console.error(e);
                            });
                        }
                    }
                } else {
                    _this.audio && _this.audio.pause();
                }
            });
        };
        _this.handleCanPlay = function() {
            var duration = audio_extension_render_getPositiveNumber(_this.audio.duration);
            var total = audio_extension_render_formatTime(duration);
            _this.setState({
                total: total
            });
        };
        _this.handleProgress = function() {
            if (_this.audio.buffered.length <= 0) {
                return;
            }
            var progress = audio_extension_render_getPositiveNumber(_this.audio.buffered.end(0) / _this.audio.duration);
            _this.setState({
                progress: progress
            });
        };
        _this.handlePause = function() {
            var isPlay = _this.state.isPlay;
            if (isPlay) _this.setState({
                isPlay: false
            });
        };
        _this.handleTimeUpdate = function() {
            var currentTime = audio_extension_render_getPositiveNumber(_this.audio.currentTime);
            var current = audio_extension_render_formatTime(currentTime);
            var playing = currentTime / _this.audio.duration;
            _this.setState({
                current: current,
                playing: playing
            });
            var init = _this.state.init;
            if (init) {
                _this.setState({
                    init: false
                });
            }
        };
        _this.handleAudioMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        _this.handleAudioMouseMove = function(e) {
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = audio_extension_render_getPositiveNumber(dis / 360 * _this.audio.duration);
            if (_this.isOnProgressMouseDown) {
                _this.audio.currentTime = newCurrentTime;
                _this.handleTimeUpdate();
            }
        };
        _this.handleAudioMouseLeave = function() {
            _this.isOnProgressMouseDown = false;
        };
        _this.handleProgressBarMouseDown = function(e) {
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = audio_extension_render_getPositiveNumber(dis / 360 * _this.audio.duration);
            _this.audio.currentTime = newCurrentTime;
            _this.isOnProgressMouseDown = true;
            e.preventDefault();
        };
        _this.handleProgressBarMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        _this.handleProgressMouseMove = function(e) {
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = dis / 360 * _this.audio.duration;
            if (newCurrentTime > _this.audio.duration || newCurrentTime < 0) {
                _this.setState({
                    hasTip: false
                });
                return;
            }
            var time = audio_extension_render_formatTime(newCurrentTime);
            _this.setState({
                hasTip: true,
                tipInfo: {
                    time: time,
                    offsetX: dis
                }
            });
        };
        _this.handleVolumeBarMouseDown = function(e) {
            var zoom = _this.props.zoom;
            var bottom = _this.volumeBar.getBoundingClientRect().bottom;
            var clientY = e.nativeEvent.clientY / zoom;
            var dis = bottom - clientY;
            var volume = (dis > 0 ? dis : 0) / 80;
            volume = volume > 1 ? 1 : volume;
            _this.audio.volume = volume;
            _this.setState({
                volume: volume,
                isMute: false
            });
            _this.isOnVolumeMouseDown = true;
            e.preventDefault();
        };
        _this.handleVolumeBarMouseUp = function() {
            _this.isOnVolumeMouseDown = false;
        };
        _this.handleVolumeBarMouseMouse = function(e) {
            if (_this.isOnVolumeMouseDown) _this.handleVolumeBarMouseDown(e);
        };
        _this.showVolumeBar = function() {
            var _this_volumeBtn_getBoundingClientRect = _this.volumeBtn.getBoundingClientRect(), top = _this_volumeBtn_getBoundingClientRect.top, left = _this_volumeBtn_getBoundingClientRect.left;
            var _this_volumeBtn_closest_getBoundingClientRect = _this.volumeBtn.closest(".ct-editor, .pk-view-container").getBoundingClientRect(), editorTop = _this_volumeBtn_closest_getBoundingClientRect.top;
            _this.setState({
                showVolumeBar: true,
                volumeBarInfo: {
                    top: top - editorTop > 104 ? top - 104 : top + 50,
                    left: left - 4
                }
            });
        };
        _this.hideVolumeBar = function() {
            _this.setState({
                showVolumeBar: false
            });
        };
        _this.toggleMute = function() {
            var _this_state = _this.state, volume = _this_state.volume, isMute = _this_state.isMute;
            if (isMute) {
                _this.audio.volume = volume;
                _this.setState({
                    isMute: false
                });
            } else {
                _this.audio.volume = 0;
                _this.setState({
                    isMute: true
                });
            }
        };
        _this.handleDownload = function() {
            var _provider_handleUrl;
            var downloadStatus = _this.state.downloadStatus;
            if (downloadStatus === 1) return;
            var _this_props = _this.props, url = _this_props.url, name = _this_props.name, provider = _this_props.provider;
            var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
            provider.download(src, name);
        };
        _this.handleDragStart = function(e) {
            e.preventDefault();
        };
        _this.handleError = function() {
            _this.setState({
                isError: true
            });
        };
        _this.handleRetry = function() {
            _this.setState({
                isError: false
            });
        };
        // 播放
        _this.handlePlay = function() {
            document.querySelectorAll("audio").forEach(function(otherAudio) {
                return otherAudio !== _this.audio && otherAudio.pause();
            });
            document.querySelectorAll("video").forEach(function(otherVideo) {
                return otherVideo.pause();
            });
        };
        return _this;
    }
    var _proto = Audio.prototype;
    _proto.render = function render() {
        var _this = this;
        var _provider_handleUrl;
        var _this_props = this.props, url = _this_props.url, name = _this_props.name, size = _this_props.size, provider = _this_props.provider;
        var _this_state = this.state, init = _this_state.init, volume = _this_state.volume, isMute = _this_state.isMute, progress = _this_state.progress, playing = _this_state.playing, current = _this_state.current, total = _this_state.total, isPlay = _this_state.isPlay, isError = _this_state.isError, hasTip = _this_state.hasTip, _this_state_tipInfo = _this_state.tipInfo, time = _this_state_tipInfo.time, offsetX = _this_state_tipInfo.offsetX, showVolumeBar = _this_state.showVolumeBar, volumeBarInfo = _this_state.volumeBarInfo, downloadStatus = _this_state.downloadStatus;
        var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
        if (isError) {
            return /*#__PURE__*/ react_default.a.createElement("div", {
                className: "".concat(audio_extension_render_classNamePrefix("audio-view"), " error")
            }, /*#__PURE__*/ react_default.a.createElement("div", {
                className: "notice",
                "data-src": src
            }, window.navigator.onLine ? "文件获取失败" : "网络连接失败"), /*#__PURE__*/ react_default.a.createElement("button", {
                className: "".concat(audio_extension_render_classNamePrefix("btn"), " retry"),
                onClick: this.handleRetry
            }, "重试"));
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: audio_extension_render_classNamePrefix("audio-view"),
            onMouseUp: this.handleAudioMouseUp,
            onMouseMove: this.handleAudioMouseMove,
            onMouseLeave: this.handleAudioMouseLeave,
            onDragStart: this.handleDragStart
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("play-btn", {
                pause: !isPlay
            }),
            onClick: this.togglePlay
        }, !isPlay ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_render_img,
            alt: "播放"
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_render_img$1,
            alt: "暂停"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "info"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "top"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "left"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "name"
        }, name), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "size"
        }, "( ", size, " )")), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "time"
        }, /*#__PURE__*/ react_default.a.createElement("span", {
            className: "current"
        }, current), /*#__PURE__*/ react_default.a.createElement("span", null, "/"), /*#__PURE__*/ react_default.a.createElement("span", {
            className: "total"
        }, total))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bottom"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-bar",
            ref: function(ref) {
                _this.progressBar = ref;
            },
            onMouseDown: this.handleProgressBarMouseDown,
            onMouseMove: this.handleProgressMouseMove,
            onMouseLeave: function() {
                return _this.setState({
                    hasTip: false
                });
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "load-bar",
            style: {
                width: "".concat(init ? 0 : progress * 360, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-bar", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                width: "".concat(playing * 360, "px")
            }
        }), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("played-button", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                left: "".concat(playing * 360 - 4, "px")
            }
        }), hasTip && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip-wrapper",
            style: {
                left: "".concat(offsetX - 23, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "progress-tip"
        }, time))))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-btn",
            ref: function(ref) {
                _this.volumeBtn = ref;
            },
            onMouseEnter: this.showVolumeBar,
            onMouseLeave: this.hideVolumeBar,
            onDragStart: this.handleDragStart
        }, isMute || volume < 0.01 ? /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_render_img$3,
            alt: "静音",
            onClick: this.toggleMute
        }) : /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_render_img$2,
            alt: "音量调节",
            onClick: this.toggleMute
        }), showVolumeBar && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar-wrapper",
            style: volumeBarInfo,
            onMouseMove: this.handleVolumeBarMouseMouse,
            onMouseUp: this.handleVolumeBarMouseUp
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "volume-bar",
            ref: function(ref) {
                _this.volumeBar = ref;
            },
            onMouseDown: this.handleVolumeBarMouseDown
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "selected-bar",
            style: {
                height: "".concat(isMute ? 0 : volume * 80, "px")
            }
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "bar-btn"
        }))))), /*#__PURE__*/ react_default.a.createElement("div", {
            className: classnames_default()("download-btn", {
                error: downloadStatus === 2,
                loading: downloadStatus === 1
            }),
            onClick: this.handleDownload
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip-wrapper"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "tip"
        }, "下载失败，请重试")), /*#__PURE__*/ react_default.a.createElement("img", {
            src: audio_extension_render_img$4,
            alt: "下载"
        })), /*#__PURE__*/ react_default.a.createElement("audio", {
            ref: function(ref) {
                _this.audio = ref;
            },
            src: src,
            preload: "meta",
            // volume={isMute ? 0 : volume}
            onCanPlay: this.handleCanPlay,
            onProgress: this.handleProgress,
            onTimeUpdate: this.handleTimeUpdate,
            onPause: this.handlePause,
            onError: this.handleError
        }, "本浏览器不支持 HTML5 audio 标签"));
    };
    return Audio;
}(react["Component"]);
render_Audio.defaultProps = {
    zoom: 1
};

function audio_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var audio_extension_render_css_248z = '.ct-audio{margin:8px 0;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ct-audio img{vertical-align:unset}.ct-audio.align-center{margin:0 auto}.ct-audio.align-right{float:right;margin-top:0}.ct-audio.align-right+*,.ct-audio.align-right+div+span+*{clear:both}.ct-audio.mobile{width:100%}.ct-audio-view{background:#f6f6f6;border:1px solid #ddd;display:flex;height:58px;width:5 12px}.ct-audio-view:hover{border:1px solid #3d91f2;cursor:pointer}.ct-audio-view audio{display:none}.ct-audio-view .play-btn{background-color:#fff;border-radius:50%;border:1px solid #eee;cursor:pointer;height:30px;margin:14px 16px;padding-left:4px;padding-top:4px;width:30px}.ct-audio-view .play-btn:hover{border-color:#3d91f2}.ct-audio-view .play-btn:hover path{fill:#3d91f2}.ct-audio-view .play-btn.pause{padding-left:5px}.ct-audio-view .info{font-size:12px;line-height:1 4px;margin-top:14px;width:360px}.ct-audio-view .top{display:flex;justify-content:space-between;align-items:flex-start;height:1 4px;margin-bottom:10px;width:100%}.ct-audio-view .top .left{display:flex}.ct-audio-view .top .name{color:#333;max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-audio-view .top .size{color:#999;margin-left:2px}.ct-audio-view .top .time{display:flex;justify-content:space-between;align-items:center;color:#333;text-align:right;width:80px}.ct-audio-view .bottom{display:flex;height:4px;width:100%}.ct-audio-view .progress-bar{background:#d9d9d9;background-clip:content-box;border-radius:100px;cursor:pointer;height:10px;padding:3px 0;position:relative;width:100%}.ct-audio-view .load-bar{background:#b6b6b6;transition:all 3s linear;z-index:1}.ct-audio-view .load-bar,.ct-audio-view .played-bar{border-radius:100px;height:4px;position:absolute;top:3px;width:0}.ct-audio-view .played-bar{background:#1c6cdc;transition:all .3s linear;z-index:2}.ct-audio-view .played-bar.dragged{transition:none}.ct-audio-view .played-button{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);height:12px;position:absolute;top:-2px;transition:all .3s linear;width:12px;z-index:10}.ct-audio-view .played-button.dragged{transition:none}.ct-audio-view .progress-tip-wrapper{height:28px;left:0;position:absolute;top:-27px;width:48px}.ct-audio-view .progress-tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-audio-view .progress-tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;width:0}.ct-audio-view .progress-tip:after,.ct-audio-view .progress-tip:before{content:"";display:block;position:absolute;right:50%;transform:translate(50%);z-index:2}.ct-audio-view .progress-tip:before{background:rgba(0,0,0,.68);bottom:-9px;height:4px;width:1px}.ct-audio-view .volume-btn{cursor:pointer;height:58px;margin:0 12px 0 16px;padding-top:16px;padding-bottom:16px;position:relative;transition:all .1s ease;width:26px}.ct-audio-view .volume-btn:hover path:first-child{fill:#3d91f2}.ct-audio-view .volume-btn:hover path:nth-child(2){stroke:#3d91f2}.ct-audio-view .volume-bar-wrapper{background:#fff;border-radius:2px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);height:102px;position:fixed;width:30px;z-index:9}.ct-audio-view .volume-bar{background:#d9d9d9;border-radius:100px;height:80px;left:50%;position:absolute;top:11px;transform:translate(-50%);width:4px}.ct-audio-view .selected-bar{background:#1c6cdc;border-radius:100px;bottom:0;height:0;position:absolute;transition:all .2s;width:4px;z-index:2}.ct-audio-view .selected-bar .bar-btn{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);content:"";height:12px;position:absolute;right:-4px;top:-6px;width:12px}.ct-audio-view .download-btn{cursor:pointer;height:22px;margin-top:16px;position:relative;transition:all .1s ease;width:22px}.ct-audio-view .download-btn:hover path{fill:#3d91f2}.ct-audio-view .download-btn .tip-wrapper{display:none;height:28px;left:7px;position:absolute;top:-30px}.ct-audio-view .download-btn .tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-audio-view .download-btn .tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;content:"";display:block;position:absolute;right:50%;transform:translate(50%);width:0;z-index:2}.ct-audio-view .download-btn.loading{cursor:default;height:20px;margin-right:0;margin-top:16px;width:19px}.ct-audio-view .download-btn.loading svg{display:none}.ct-audio-view .download-btn.error{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%228px%22 height%3D%228px%22 viewBox%3D%220 0 8 8%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3ECombined Shape%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Crect id%3D%22Rectangle-2%22 fill%3D%22%23FFFFFF%22 x%3D%222%22 y%3D%221%22 width%3D%224%22 height%3D%226%22%3E%3C%2Frect%3E        %3Cpath d%3D%22M0%2C4 C0%2C1.79088 1.79088%2C0 4%2C0 C6.20912%2C0 8%2C1.79088 8%2C4 C8%2C6.20912 6.20912%2C8 4%2C8 C1.79088%2C8 0%2C6.20912 0%2C4 Z M4.00000002%2C1.34999998 C3.34188252%2C1.34999998 2.87727375%2C1.67743076 3%2C2.5 L3.40000002%2C4.36638153 C3.40000002%2C4.69277782 3.66862917%2C4.96459961 4.00000002%2C4.96459961 C4.33368113%2C4.96459961 4.60000002%2C4.69676825 4.60000002%2C4.36638153 L5%2C2.5 C5.15197984%2C1.72235314 4.74297343%2C1.34999998 4.00000002%2C1.34999998 Z M4%2C6.65000002 C4.33137086%2C6.65000002 4.60000002%2C6.38137086 4.60000002%2C6.05 C4.60000002%2C5.71862914 4.33137086%2C5.44999998 4%2C5.44999998 C3.66862914%2C5.44999998 3.39999998%2C5.71862914 3.39999998%2C6.05 C3.39999998%2C6.38137086 3.66862914%2C6.65000002 4%2C6.65000002 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23F5222D%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 12px top}.ct-audio-view .download-btn.error:hover .tip-wrapper{display:block}.ProseMirror-selectednode .ct-audio-view{border:1px solid #3d91f2}.ct-audio-view.error{background:rgba(0,0,0,.5);font-size:14px;padding:10px 40px}.ct-audio-view.error .notice{color:#fff;height:32px;line-height:32px}.ct-audio-view.error .retry{background:#3d91f2;border:none;color:#fff;display:block;height:#1c6cdc;line-height:#1c6cdc;margin-left:30px;width:76px}.ct-audio-view.mobile{background:none;border:0;height:70px;width:100%}.ct-audio-view.mobile audio{display:block;height:100%;width:100%}';
audio_extension_render_styleInject(audio_extension_render_css_248z);

var audio_extension_render_css_248z$1 = ".pk-view-container .ct-audio{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}";
audio_extension_render_styleInject(audio_extension_render_css_248z$1);

function audio_extension_render_classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var render_audioRender = function audioRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    audio_extension_render_classCallCheck$2(this, audioRender);
    this.fragmentRender = function(node) {
        var url = node.getAttribute("data-url");
        var name = node.getAttribute("data-name");
        var size = node.getAttribute("data-size");
        var provider = new audio_extension_render_AudioProvider();
        react_dom_default.a.render(/*#__PURE__*/ react_default.a.createElement(render_Audio, {
            url: url,
            name: name,
            size: size,
            provider: provider
        }), node);
    };
    this.fragmentCls = ".".concat(audio_extension_render_classNamePrefix("audio"));
    this.config = config;
};

/* harmony default export */ var audio_extension_render = (render_audioRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/code-extension/render.js






/**
 * 统一样式前缀
 */ var code_extension_render_CLASSNAME_PREFIX = "ct";

var code_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : code_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
// 获取浏览器和系统信息
function code_extension_render_getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

var render_DEFAULT_LANGUAGE = "Plain Text";
var render_DEFAULT_THEME = "xq-light";
var render_DEFAULT_TITLE = "代码块";

var languages = [
    {
        name: "JavaScript",
        mimes: [
            "text/javascript",
            "text/ecmascript",
            "application/javascript",
            "application/x-javascript",
            "application/ecmascript"
        ],
        mode: "javascript",
        ext: [
            "js"
        ],
        alias: [
            "ecmascript",
            "js",
            "node"
        ]
    },
    {
        name: "Java",
        mime: "text/x-java",
        mode: "clike",
        ext: [
            "java"
        ]
    },
    {
        name: "JSON",
        mimes: [
            "application/json",
            "application/x-json"
        ],
        mode: "javascript",
        ext: [
            "json",
            "map"
        ],
        alias: [
            "json5"
        ]
    },
    {
        name: "Shell",
        mimes: [
            "text/x-sh",
            "application/x-sh"
        ],
        mode: "shell",
        ext: [
            "sh",
            "ksh",
            "bash"
        ],
        alias: [
            "bash",
            "sh",
            "zsh"
        ],
        file: /^PKGBUILD$/
    },
    {
        name: "HTML",
        mime: "text/html",
        mode: "htmlmixed",
        ext: [
            "html",
            "htm",
            "handlebars",
            "hbs"
        ],
        alias: [
            "xhtml"
        ]
    },
    {
        name: "Plain Text",
        mime: "text/plain",
        mode: "null",
        ext: [
            "txt",
            "text",
            "conf",
            "def",
            "list",
            "log"
        ]
    },
    {
        name: "C",
        mime: "text/x-csrc",
        mode: "clike",
        ext: [
            "c",
            "h",
            "ino"
        ]
    },
    {
        name: "C++",
        mime: "text/x-c++src",
        mode: "clike",
        ext: [
            "cpp",
            "c++",
            "cc",
            "cxx",
            "hpp",
            "h++",
            "hh",
            "hxx"
        ],
        alias: [
            "cpp"
        ]
    },
    {
        name: "C#",
        mime: "text/x-csharp",
        mode: "clike",
        ext: [
            "cs"
        ],
        alias: [
            "csharp"
        ]
    },
    {
        name: "CSS",
        mime: "text/css",
        mode: "css",
        ext: [
            "css"
        ]
    },
    {
        name: "Dart",
        mimes: [
            "application/dart",
            "text/x-dart"
        ],
        mode: "dart",
        ext: [
            "dart"
        ]
    },
    {
        name: "Elm",
        mime: "text/x-elm",
        mode: "elm",
        ext: [
            "elm"
        ]
    },
    {
        name: "Go",
        mime: "text/x-go",
        mode: "go",
        ext: [
            "go"
        ]
    },
    {
        name: "Groovy",
        mime: "text/x-groovy",
        mode: "groovy",
        ext: [
            "groovy",
            "gradle"
        ],
        file: /^Jenkinsfile$/
    },
    {
        name: "HTTP",
        mime: "message/http",
        mode: "http"
    },
    {
        name: "JSX",
        mime: "text/jsx",
        mode: "jsx",
        ext: [
            "jsx"
        ]
    },
    {
        name: "Kotlin",
        mime: "text/x-kotlin",
        mode: "clike",
        ext: [
            "kt"
        ]
    },
    {
        name: "LaTeX",
        mime: "text/x-latex",
        mode: "stex",
        ext: [
            "text",
            "ltx",
            "tex"
        ],
        alias: [
            "tex"
        ]
    },
    {
        name: "Lua",
        mime: "text/x-lua",
        mode: "lua",
        ext: [
            "lua"
        ]
    },
    {
        name: "Markdown",
        mime: "text/x-markdown",
        mode: "markdown",
        ext: [
            "markdown",
            "md",
            "mkd"
        ]
    },
    {
        name: "Nginx",
        mime: "text/x-nginx-conf",
        mode: "nginx",
        file: /nginx.*\.conf$/i
    },
    {
        name: "Objective-C",
        mime: "text/x-objectivec",
        mode: "clike",
        ext: [
            "m",
            "mm"
        ],
        alias: [
            "objective-c",
            "objc"
        ]
    },
    {
        name: "Perl",
        mime: "text/x-perl",
        mode: "perl",
        ext: [
            "pl",
            "pm"
        ]
    },
    {
        name: "PHP",
        mimes: [
            "text/x-php",
            "application/x-httpd-php",
            "application/x-httpd-php-open"
        ],
        mode: "php",
        ext: [
            "php",
            "php3",
            "php4",
            "php5",
            "php7",
            "phtml"
        ]
    },
    {
        name: "PowerShell",
        mime: "application/x-powershell",
        mode: "powershell",
        ext: [
            "ps1",
            "psd1",
            "psm1"
        ]
    },
    {
        name: "Python",
        mime: "text/x-python",
        mode: "python",
        ext: [
            "BUILD",
            "bzl",
            "py",
            "pyw"
        ],
        file: /^(BUCK|BUILD)$/
    },
    {
        name: "R",
        mime: "text/x-rsrc",
        mode: "r",
        ext: [
            "r",
            "R"
        ],
        alias: [
            "rscript"
        ]
    },
    {
        name: "Ruby",
        mime: "text/x-ruby",
        mode: "ruby",
        ext: [
            "rb"
        ],
        alias: [
            "jruby",
            "macruby",
            "rake",
            "rb",
            "rbx"
        ]
    },
    {
        name: "Sass",
        mime: "text/x-sass",
        mode: "sass",
        ext: [
            "sass"
        ]
    },
    {
        name: "Scala",
        mime: "text/x-scala",
        mode: "clike",
        ext: [
            "scala"
        ]
    },
    {
        name: "SQL",
        mime: "text/x-sql",
        mode: "sql",
        ext: [
            "sql"
        ]
    },
    {
        name: "Stylus",
        mime: "text/x-styl",
        mode: "stylus",
        ext: [
            "styl"
        ]
    },
    {
        name: "TypeScript",
        mime: "text/typescript",
        mode: "text/typescript",
        ext: [
            "ts"
        ]
    },
    {
        name: "Swift",
        mime: "text/x-swift",
        mode: "swift",
        ext: [
            "swift"
        ]
    },
    {
        name: "Vue.js Component",
        mimes: [
            "script/x-vue",
            "text/x-vue"
        ],
        mode: "vue",
        ext: [
            "vue"
        ]
    },
    {
        name: "XML",
        mimes: [
            "application/xml",
            "text/xml"
        ],
        mode: "xml",
        ext: [
            "xml",
            "xsl",
            "xsd",
            "svg"
        ],
        alias: [
            "rss",
            "wsdl",
            "xsd"
        ]
    },
    {
        name: "YAML",
        mimes: [
            "text/x-yaml",
            "text/yaml"
        ],
        mode: "yaml",
        ext: [
            "yaml",
            "yml"
        ],
        alias: [
            "yml"
        ]
    },
    {
        name: "PlantUML",
        mode: "plantuml"
    }
];
var modeMap = {};
languages.forEach(function(param) {
    var name = param.name, mime = param.mime, mode = param.mode;
    if (mode === "clike" || mode === "sql") {
        modeMap[name.toLowerCase()] = Array.isArray(mime) ? mime[0] : mime;
    } else {
        modeMap[name.toLowerCase()] = mode;
    }
});
function getMode(language) {
    return modeMap[(language || "").toLowerCase()] || "null";
}

function code_extension_render_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function code_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function code_extension_render_getPrototypeOf(o) {
    code_extension_render_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return code_extension_render_getPrototypeOf(o);
}
function code_extension_render_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) code_extension_render_setPrototypeOf(subClass, superClass);
}
function code_extension_render_possibleConstructorReturn(self, call) {
    if (call && (code_extension_render_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return code_extension_render_assertThisInitialized(self);
}
function code_extension_render_setPrototypeOf(o, p) {
    code_extension_render_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return code_extension_render_setPrototypeOf(o, p);
}
var code_extension_render_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function code_extension_render_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function code_extension_render_createSuper(Derived) {
    var hasNativeReflectConstruct = code_extension_render_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = code_extension_render_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = code_extension_render_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return code_extension_render_possibleConstructorReturn(this, result);
    };
}
var render_CodeViewer = /*#__PURE__*/ function(Component) {
    code_extension_render_inherits(CodeViewer, Component);
    var _super = code_extension_render_createSuper(CodeViewer);
    function CodeViewer(props) {
        code_extension_render_classCallCheck(this, CodeViewer);
        var _this;
        _this = _super.call(this, props);
        _this.container = null;
        _this.$cm = null;
        _this.initCodeViewer = function() {
            var _this_props = _this.props, _this_props_value = _this_props.value, value = _this_props_value === void 0 ? "" : _this_props_value, language = _this_props.language, theme = _this_props.theme;
            var isMobile = code_extension_render_getSystemInfo().isMobile;
            var inputStyle = isMobile ? "textarea" : "contenteditable";
            var readOnly = isMobile ? true : "nocursor";
            if (window.CodeMirror) {
                var cm = new window.CodeMirror(_this.container, {
                    value: value,
                    tabSize: 2,
                    // Half-period in milliseconds used for cursor blinking.
                    // The default blink rate is 530ms.
                    // By setting this to zero, blinking can be disabled.
                    // A negative value hides the cursor entirely.
                    cursorBlinkRate: -1,
                    inputStyle: inputStyle,
                    readOnly: readOnly,
                    theme: theme,
                    matchBrackets: true,
                    mode: getMode(language)
                });
                // 阻止浏览态代码块还能够被剪切。。。
                cm.on("cut", function(c, e) {
                    e.preventDefault();
                });
                // 阻止移动端点击代码块唤起键盘
                _this.$cm = cm.getWrapperElement();
                if (isMobile) {
                    _this.$cm.querySelector("textarea").setAttribute("disabled", "true");
                }
                _this.$cm.style.cssText = !_this.state.isExpand ? "height:0.1px !important" : "height:auto !important";
                _this.setState({
                    isInit: true
                });
            }
        };
        _this.handleClick = function() {
            if (!_this.$cm) {
                _this.setState({
                    isInit: false
                }, function() {
                    // 不延迟loading效果出不来。。
                    setTimeout(function() {
                        _this.initCodeViewer();
                    }, 20);
                });
            } else {
                _this.$cm.style.cssText = _this.state.isExpand ? "height:0.1px !important" : "height:auto !important";
                _this.setState({
                    isExpand: !_this.state.isExpand
                });
            }
        };
        _this.state = {
            isExpand: props.isExpand,
            isInit: null
        };
        return _this;
    }
    var _proto = CodeViewer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        setTimeout(function() {
            _this.initCodeViewer();
        }, 20);
    };
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, isInit = _this_state.isInit, isExpand = _this_state.isExpand;
        var _this_props = this.props, title = _this_props.title, language = _this_props.language;
        var iconClass = isInit === false ? "icon-loading" : isExpand ? "" : "collapse";
        return /*#__PURE__*/ react_default.a.createElement("div", null, /*#__PURE__*/ react_default.a.createElement("div", {
            key: "header",
            className: "header"
        }, /*#__PURE__*/ react_default.a.createElement("div", {
            className: "title ".concat(iconClass),
            onClick: this.handleClick
        }, title), /*#__PURE__*/ react_default.a.createElement("div", {
            className: "language"
        }, language), !isExpand && /*#__PURE__*/ react_default.a.createElement("div", {
            className: "isNotExpand"
        })), /*#__PURE__*/ react_default.a.createElement("div", {
            key: "viewer",
            ref: function(refs) {
                _this.container = refs;
            }
        }));
    };
    return CodeViewer;
}(react["Component"]);

var mainScript = "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/codemirror.min.js";
var extraScrpts = [
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/addon/edit/matchbrackets.min.js",
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/clike/clike.min.js",
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/shell/shell.min.js",
    "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/javascript/javascript.min.js"
];
var modeScripts = {
    CSS: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/css/css.min.js",
    Dart: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/dart/dart.min.js",
    Elm: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/elm/elm.min.js",
    Go: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/go/go.min.js",
    Groovy: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/groovy/groovy.min.js",
    HTML: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/htmlmixed/htmlmixed.min.js",
    HTTP: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/http/http.min.js",
    JSX: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/jsx/jsx.min.js",
    LaTeX: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/stex/stex.min.js",
    Lua: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/lua/lua.min.js",
    Markdown: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/markdown/markdown.min.js",
    Nginx: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/nginx/nginx.min.js",
    Perl: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/perl/perl.min.js",
    PHP: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/php/php.min.js",
    PowerShell: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/powershell/powershell.min.js",
    Python: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/python/python.min.js",
    R: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/r/r.min.js",
    Ruby: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/ruby/ruby.min.js",
    Sass: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/sass/sass.min.js",
    SQL: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/sql/sql.min.js",
    Swift: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/swift/swift.min.js",
    XML: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/xml/xml.min.js",
    YAML: "https://cdn.bootcdn.net/ajax/libs/codemirror/5.50.0/mode/yaml/yaml.min.js"
};

function code_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var code_extension_render_css_248z = '.pk-view-container .ct-code{min-width:233px;margin:5px 0;font-size:14px;border:1px solid #ddd;border-radius:2px 2px;background:#fcfcfc;font-family:monospace;line-height:21px}.pk-view-container .ct-code .header{display:flex;position:relative;width:100%;height:30px;padding:0 10px;background:#f2f2f2;box-sizing:border-box}.pk-view-container .ct-code .header .title{flex:1;padding-left:22px;line-height:30px;font-size:12px;font-weight:700;color:#333;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pk-view-container .ct-code .header .title:before{content:"";position:absolute;left:14px;top:11px;width:8px;height:8px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526953416889%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223453%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%228%22 height%3D%228%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M375.966782 310.02559401L28.2073 642.809787a89.339756 89.339756 0 0 0 0 130.169816 99.323282 99.323282 0 0 0 136.057537 0L512.024319 440.323405 859.7838 773.107597a99.323282 99.323282 0 0 0 136.057538 0 89.339756 89.339756 0 0 0 0-130.169817l-347.759482-332.784192-65.916869-59.389179a105.722978 105.722978 0 0 0-140.281336 0l-65.916869 59.389179z%22 fill%3D%22%23747272%22 p-id%3D%223454%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 0 0;transition:transform .2s}.pk-view-container .ct-code .header .collapse:before{transform:rotate(-180deg)}.pk-view-container .ct-code .header .icon-loading:before{border-radius:50%;border:1px solid #d5d5d5;border-bottom-color:transparent;background:none;transition:none;-webkit-animation:loading .8s linear infinite;animation:loading .8s linear infinite}.pk-view-container .ct-code .header .language{width:120px;height:30px;line-height:30px;text-align:right;font-size:12px;color:#999}';
code_extension_render_styleInject(code_extension_render_css_248z);

function code_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function code_extension_render_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                code_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                code_extension_render_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function code_extension_render_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function render_extends() {
    render_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return render_extends.apply(this, arguments);
}
var code_extension_render_generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var loadCodeScript = function(languages) {
    var onlyLoadNeedFiles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return new Promise(function(resolve) {
        var script = document.createElement("script");
        script.src = mainScript;
        script.onload = function() {
            Object.keys(modeScripts).forEach(function(lang) {
                if (languages.has(lang) || !onlyLoadNeedFiles) {
                    var newScript = document.createElement("script");
                    newScript.src = modeScripts[lang];
                    document.head.appendChild(newScript);
                }
            });
            extraScrpts.forEach(function(p) {
                var newScript = document.createElement("script");
                newScript.src = p;
                document.head.appendChild(newScript);
            });
            setTimeout(function() {
                resolve("ok");
            }, 100);
        };
        document.head.appendChild(script);
    });
};
var render_codeRender = function codeRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    code_extension_render_classCallCheck$1(this, codeRender);
    var _this = this;
    this.preprocess = function() {
        var _ref = code_extension_render_asyncToGenerator(function($container) {
            var languages;
            return code_extension_render_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!window.CodeMirror && $container.querySelector(_this.fragmentCls))) return [
                            3,
                            2
                        ];
                        languages = new Set();
                        Array.from($container.querySelectorAll(_this.fragmentCls)).forEach(function(node) {
                            if (node.getAttribute("data-language")) {
                                languages.add(node.getAttribute("data-language"));
                            }
                        });
                        return [
                            4,
                            loadCodeScript(languages, _this.config.onlyLoadNeedFiles)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function($container) {
            return _ref.apply(this, arguments);
        };
    }();
    this.fragmentRender = function(node) {
        var codeNode = node.querySelector("code");
        if (!codeNode) return;
        var _node_dataset = node.dataset, _node_dataset_language = _node_dataset.language, language = _node_dataset_language === void 0 ? render_DEFAULT_LANGUAGE : _node_dataset_language, _node_dataset_theme = _node_dataset.theme, theme = _node_dataset_theme === void 0 ? render_DEFAULT_THEME : _node_dataset_theme, _node_dataset_title = _node_dataset.title, title = _node_dataset_title === void 0 ? render_DEFAULT_TITLE : _node_dataset_title;
        var isExpand = node.getAttribute("data-expand") !== "false";
        var data = {
            language: language,
            theme: theme,
            title: title,
            isExpand: isExpand,
            value: codeNode.textContent
        };
        node.innerHTML = "";
        Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(render_CodeViewer, render_extends({}, data)), node);
        // 清空data属性
        var attrs = [
            "data-language",
            "data-theme",
            "data-title",
            "data-expand",
            "spellcheck"
        ];
        attrs.forEach(function(attr) {
            node.removeAttribute(attr);
        });
    };
    this.fragmentCls = ".".concat(code_extension_render_classNamePrefix("code"));
    this.config = config;
};

/* harmony default export */ var code_extension_render = (render_codeRender);
//# sourceMappingURL=render.js.map

// CONCATENATED MODULE: ./node_modules/@it/parker/es/citadel-pc/extensions/catalog-extension/render.js





/**
 * 统一样式前缀
 */ var catalog_extension_render_CLASSNAME_PREFIX = "ct";

var catalog_extension_render_classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : catalog_extension_render_CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function catalog_extension_render_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function render_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function render_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) render_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) render_defineProperties(Constructor, staticProps);
    return Constructor;
}
var render_emptyCatalogData = {
    catalog: [],
    minLevel: 7
};
var render_MessageService = /*#__PURE__*/ function() {
    function MessageService(val) {
        var _this = this;
        catalog_extension_render_classCallCheck(this, MessageService);
        this.val = val;
        this.fs = [];
        this.on = function(fn) {
            _this.fs.push(fn);
        };
        this.emit = function(newVal) {
            _this.val = newVal;
            _this.fs.forEach(function(f) {
                return f(newVal);
            });
        };
        this.remove = function(fn) {
            var index = _this.fs.findIndex(function(f) {
                return f === fn;
            });
            if (index > -1) {
                _this.fs.splice(index, 1);
            }
        };
        this.val = val;
    }
    render_createClass(MessageService, [
        {
            key: "value",
            get: function get() {
                return this.val;
            }
        }
    ]);
    return MessageService;
}();
var render_catalogService = new render_MessageService(render_emptyCatalogData);

var render_HEAD_LEVEL = 7;
var render_numberHeadingFactory = function(minLevel) {
    var numbers = [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    return function(index) {
        for(var i = 1; i < index; i++){
            if (numbers[i] === 0) {
                numbers[i] = 1;
            }
        }
        numbers[index] += 1;
        for(var i1 = index + 1; i1 < render_HEAD_LEVEL; i1++){
            numbers[i1] = 0;
        }
        return "".concat(numbers.slice(minLevel, index + 1).join("."));
    };
};
var render_prefixFactory = function(style, minLevel) {
    var numberHeading = style === "number" ? render_numberHeadingFactory(minLevel) : function() {
        return "";
    };
    var prefix;
    switch(style){
        case "point":
            prefix = /*#__PURE__*/ react_default.a.createElement("div", {
                className: catalog_extension_render_classNamePrefix("icon-round-preview")
            });
            break;
        case "circle":
            prefix = /*#__PURE__*/ react_default.a.createElement("div", {
                className: catalog_extension_render_classNamePrefix("icon-ring-preview")
            });
            break;
        case "rect":
            prefix = /*#__PURE__*/ react_default.a.createElement("div", {
                className: catalog_extension_render_classNamePrefix("icon-rect-preview")
            });
            break;
        default:
            prefix = null;
            break;
    }
    return function(level) {
        if (style !== "number") {
            return prefix;
        }
        return /*#__PURE__*/ react_default.a.createElement("div", {
            className: "number"
        }, numberHeading(level), "\xa0");
    };
};

function catalog_extension_render_styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var catalog_extension_render_css_248z = ".pk-view-container .ct-catalog-view{border:1px solid transparent;display:flex;flex-direction:column;padding:8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;min-width:400px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.pk-view-container .ct-catalog-view .title{color:#3d91f2;cursor:pointer;font-size:24px;line-height:36px;margin-bottom:8px;width:auto}.pk-view-container .ct-catalog-view .number{color:#3d91f2;font-size:14px}.pk-view-container .ct-catalog-view .link-wrapper{color:#3789a9;margin:4px 0;cursor:pointer;display:flex;font-size:14px;line-height:20px;white-space:pre-wrap;word-wrap:break-word}.pk-view-container .ct-catalog-view .link-wrapper .ct-icon-round-preview{width:6px;height:6px;border-radius:50%;background-color:#333;margin-top:7px;margin-right:10px}.pk-view-container .ct-catalog-view .link-wrapper .ct-icon-ring-preview{width:6px;height:6px;border-radius:50%;border:1px solid #333;background-color:transparent;margin-top:7px;margin-right:10px}.pk-view-container .ct-catalog-view .link-wrapper .ct-icon-rect-preview{width:6px;height:6px;background-color:#333;margin-top:7px;margin-right:10px}.pk-view-container .ct-catalog-view .link-wrapper svg{height:6px;margin-right:10px;margin-top:7px;min-width:6px;width:6px}.pk-view-container .ct-catalog-view .link-wrapper svg circle,.pk-view-container .ct-catalog-view .link-wrapper svg g,.pk-view-container .ct-catalog-view .link-wrapper svg path{fill:#3d91f2}.pk-view-container .ct-catalog-view .link-wrapper a{color:#3d91f2}.pk-view-container .ct-catalog-view .link-wrapper a:hover{text-decoration:underline}.pk-view-container .ct-catalog-view .indent-1{padding-left:20px}.pk-view-container .ct-catalog-view .indent-2{padding-left:40px}.pk-view-container .ct-catalog-view .indent-3{padding-left:60px}.pk-view-container .ct-catalog-view .indent-4{padding-left:80px}.pk-view-container .ct-catalog-view .indent-5{padding-left:100px}";
catalog_extension_render_styleInject(catalog_extension_render_css_248z);

var CatalogView = function(param) {
    var style = param.style, catalog = param.catalog, minLevel = param.minLevel;
    var factory = render_prefixFactory(style, minLevel);
    var links = catalog.map(function(param) {
        var key = param.key, level = param.level, text = param.text, scrollIntoView = param.scrollIntoView;
        var indent = level - minLevel;
        var prefix = factory(level);
        return /*#__PURE__*/ react_default.a.createElement("div", {
            key: key,
            className: "indent-".concat(indent, " link-wrapper")
        }, prefix, /*#__PURE__*/ react_default.a.createElement("a", {
            className: "link",
            onClick: scrollIntoView
        }, text));
    });
    return /*#__PURE__*/ react_default.a.createElement("div", {
        className: "ct-catalog-view"
    }, /*#__PURE__*/ react_default.a.createElement("div", {
        className: "title"
    }, "目录"), links);
};

function catalog_extension_render_classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var HEAD_LEVEL$1 = 7;
var getCatalog = function($conatiner) {
    var $headingNodes = $conatiner.querySelectorAll("h1, h2, h3, h4, h5, h6");
    var catalog = [];
    var minLevel = HEAD_LEVEL$1;
    $headingNodes.forEach(function($node) {
        if ($node.textContent === null) {
            return;
        }
        var text = $node.textContent.replace(/\s/g, "").replace(/#/g, "");
        if (!text) {
            return;
        }
        var level = parseInt($node.nodeName.slice(1), 10);
        if (level < minLevel) {
            minLevel = level;
        }
        catalog.push({
            key: $node.id,
            text: $node.textContent,
            level: level,
            scrollIntoView: function() {
                return $node.scrollIntoView();
            }
        });
    });
    return {
        catalog: catalog,
        minLevel: minLevel
    };
};
var render_catalogRender = function catalogRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _this = this;
    catalog_extension_render_classCallCheck$1(this, catalogRender);
    this.containerRender = function($conatiner) {
        var _getCatalog = getCatalog($conatiner), catalog = _getCatalog.catalog, minLevel = _getCatalog.minLevel;
        var catalogNodes = $conatiner.querySelectorAll(_this.fragmentCls);
        catalogNodes.forEach(function(node) {
            var style = node.getAttribute("data-style") || "none";
            var newNode = document.createElement("div");
            node.parentNode.insertBefore(newNode, node.nextSibling);
            Object(react_dom["render"])(/*#__PURE__*/ react_default.a.createElement(CatalogView, {
                style: style,
                catalog: catalog,
                minLevel: minLevel
            }), newNode);
            node.parentNode.removeChild(node);
        });
    };
    this.fragmentCls = ".".concat(catalog_extension_render_classNamePrefix("edit-catalog"));
    this.config = config;
};

/* harmony default export */ var catalog_extension_render = (render_catalogRender);
//# sourceMappingURL=render.js.map

// EXTERNAL MODULE: ./constants/index.js
var constants_0 = __webpack_require__("bf4b");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rich-text-editor/components/Preview.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ var Previewvue_type_script_lang_js_ = ({
  name: 'RichTextPreview',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 设置图片预览的z-index，el-dialog 和 mc-modal 的 z-index 初始值一般是 2000
    previewZIndex: {
      type: Number,
      default: constants_0["a" /* IMAGE_PREVIEW_Z_INDEX */]
    }
  },
  setup: function setup(props) {
    var renderIns = Object(composition_api_["ref"])(null);
    var imagePreview = Object(composition_api_["ref"])(false);
    var imageIndex = Object(composition_api_["ref"])(0);
    var images = Object(composition_api_["ref"])([]);
    var viewRef = Object(composition_api_["ref"])(null);

    var _toRefs = Object(composition_api_["toRefs"])(props),
        value = _toRefs.value,
        disabled = _toRefs.disabled;

    function getImageUrls() {
      var imgEls = viewRef.value.querySelectorAll('.pk-view-container .ct-image img');
      return Object(tools_["map"])(imgEls, function (el) {
        return el.src;
      });
    }

    function getVideoUrls() {
      var videoEls = viewRef.value.querySelectorAll('.pk-view-container .ct-video-view video');
      return Object(tools_["map"])(videoEls, function (el) {
        return el.src;
      });
    }

    function addImageClickListener() {
      if (!viewRef.value) return;
      var imgList = Array.from(viewRef.value.querySelectorAll('pk-view-container .ct-image img'));
      images.value = imgList.map(function (item) {
        return item.dataset.src;
      });
      imgList.forEach(function (item, index) {
        return item.addEventListener('click', function () {
          imageIndex.value = index;
          imagePreview.value = true;
        });
      });
    }

    Object(composition_api_["watch"])(value,
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(val) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                renderIns.value.render(val);
                _context.next = 3;
                return Object(composition_api_["nextTick"])();

              case 3:
                addImageClickListener();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    Object(composition_api_["onMounted"])(
    /*#__PURE__*/
    Object(asyncToGenerator["a" /* default */])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              renderIns.value = new es_render(viewRef.value, {
                renders: [new bullet_list_extension_render(), new ordered_list_extension_render(), new task_list_extension_render(), new table_extension_render(), new note_extension_render(), new collapse_extension_render(), new blockquote_extension_render(), new image_extension_render(), new link_extension_render({
                  openInNewTab: true
                }), new status_extension_render(), new time_extension_render(), new attachment_extension_render(), new video_extension_render(), new audio_extension_render(), new code_extension_render(), new catalog_extension_render()],
                lazyload: true
              });
              renderIns.value.render(value.value);

              if (disabled.value) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return Object(composition_api_["nextTick"])();

            case 5:
              addImageClickListener();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return {
      viewRef: viewRef,
      imagePreview: imagePreview,
      imageIndex: imageIndex,
      images: images,
      getImageUrls: getImageUrls,
      getVideoUrls: getVideoUrls
    };
  }
});
// CONCATENATED MODULE: ./components/mc-rich-text-editor/components/Preview.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Previewvue_type_script_lang_js_ = (Previewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./components/mc-rich-text-editor/components/Preview.vue?vue&type=style&index=0&lang=scss&
var Previewvue_type_style_index_0_lang_scss_ = __webpack_require__("0efb");

// CONCATENATED MODULE: ./components/mc-rich-text-editor/components/Preview.vue






/* normalize component */

var Preview_component = Object(componentNormalizer["a" /* default */])(
  components_Previewvue_type_script_lang_js_,
  Previewvue_type_template_id_541b8e9e_render,
  Previewvue_type_template_id_541b8e9e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_Preview = (Preview_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rich-text-editor/mc-rich-text-editor.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var mc_rich_text_editorvue_type_script_lang_js_ = ({
  name: 'McRichTextEditor',
  components: {
    Editor: Editor,
    Preview: components_Preview
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 菜单配置
    menubar: {
      type: Array,
      default: function _default() {
        return DEFAULT_MENU_CONFIG;
      }
    },
    // 文件上传钩子函数
    beforeUpload: {
      type: Function,
      default: function _default() {}
    },
    // 文件上传钩子函数
    afterUpload: {
      type: Function,
      default: function _default() {}
    },
    // 文件上传的配置信息
    uploadConfig: {
      type: Object,
      default: function _default() {
        return {
          maxFileSize: MAXIMUM_FILE_SIZE,
          maxFileNumber: MAXIMUM_FILE_NUMBER
        };
      }
    },
    // 设置图片预览的z-index，el-dialog 和 mc-modal 的 z-index 初始值一般是 2000
    previewZIndex: {
      type: Number,
      default: constants_0["a" /* IMAGE_PREVIEW_Z_INDEX */]
    }
  },
  setup: function setup(props) {
    var _toRefs = Object(composition_api_["toRefs"])(props),
        disabled = _toRefs.disabled,
        readonly = _toRefs.readonly;

    var previewRef = Object(composition_api_["ref"])(null);
    var editorRef = Object(composition_api_["ref"])(null);
    var renderedRef = Object(composition_api_["computed"])(function () {
      if (disabled.value || readonly.value) return previewRef.value;
      return editorRef.value;
    });
    var editorDisabled = Object(composition_api_["computed"])(function () {
      return disabled.value || (Object(composition_api_["inject"])('form') || {}).disabled;
    });

    function focus() {
      if (editorRef) editorRef.value.editorIns.focus();
    }

    function getImageUrls() {
      return renderedRef.value ? renderedRef.value.getImageUrls() : [];
    }

    function getVideoUrls() {
      return renderedRef.value ? renderedRef.value.getVideoUrls() : [];
    }

    return {
      previewRef: previewRef,
      editorRef: editorRef,
      editorDisabled: editorDisabled,
      focus: focus,
      getImageUrls: getImageUrls,
      getVideoUrls: getVideoUrls
    };
  }
});
// CONCATENATED MODULE: ./components/mc-rich-text-editor/mc-rich-text-editor.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_rich_text_editor_mc_rich_text_editorvue_type_script_lang_js_ = (mc_rich_text_editorvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-rich-text-editor/mc-rich-text-editor.vue





/* normalize component */

var mc_rich_text_editor_component = Object(componentNormalizer["a" /* default */])(
  mc_rich_text_editor_mc_rich_text_editorvue_type_script_lang_js_,
  mc_rich_text_editorvue_type_template_id_93495448_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_rich_text_editor = (mc_rich_text_editor_component.exports);
// CONCATENATED MODULE: ./components/mc-rich-text-editor/index.js


/* istanbul ignore next */

mc_rich_text_editor.install = function (Vue) {
  Vue.component(mc_rich_text_editor.name, mc_rich_text_editor);
};

/* harmony default export */ var components_mc_rich_text_editor = __webpack_exports__["default"] = (mc_rich_text_editor);

/***/ }),

/***/ "5b3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-rate/mc-rate.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_ratevue_type_script_lang_js_ = ({
  name: 'McRate',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-rate', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-rate/mc-rate.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_rate_mc_ratevue_type_script_lang_js_ = (mc_ratevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-rate/mc-rate.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_rate_mc_ratevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_rate = (component.exports);
// CONCATENATED MODULE: ./components/mc-rate/index.js


/* istanbul ignore next */

mc_rate.install = function (Vue) {
  Vue.component(mc_rate.name, mc_rate);
};

/* harmony default export */ var components_mc_rate = __webpack_exports__["default"] = (mc_rate);

/***/ }),

/***/ "5b4e":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("36c3");
var toLength = __webpack_require__("b447");
var toAbsoluteIndex = __webpack_require__("0fc9");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "5b59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-collapse/mc-collapse.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_collapsevue_type_script_lang_js_ = ({
  name: 'McCollapse',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-collapse', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-collapse/mc-collapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_collapse_mc_collapsevue_type_script_lang_js_ = (mc_collapsevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-collapse/mc-collapse.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_collapse_mc_collapsevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_collapse = (component.exports);
// CONCATENATED MODULE: ./components/mc-collapse/index.js


/* istanbul ignore next */

mc_collapse.install = function (Vue) {
  Vue.component(mc_collapse.name, mc_collapse);
};

/* harmony default export */ var components_mc_collapse = __webpack_exports__["default"] = (mc_collapse);

/***/ }),

/***/ "5c3a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ "5c95":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("35e8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5cbb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ "5cc5":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("2b4c")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "5d1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),

/***/ "5d58":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("d8d6");

/***/ }),

/***/ "5d73":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("469f");

/***/ }),

/***/ "5d90":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),

/***/ "5dbc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var setPrototypeOf = __webpack_require__("8b97").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "5dd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-list-item/mc-list-item.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_list_itemvue_type_script_lang_js_ = ({
  name: 'McListItem',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-list-item', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-list-item/mc-list-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_list_item_mc_list_itemvue_type_script_lang_js_ = (mc_list_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-list-item/mc-list-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_list_item_mc_list_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_list_item = (component.exports);
// CONCATENATED MODULE: ./components/mc-list-item/index.js


/* istanbul ignore next */

mc_list_item.install = function (Vue) {
  Vue.component(mc_list_item.name, mc_list_item);
};

/* harmony default export */ var components_mc_list_item = __webpack_exports__["default"] = (mc_list_item);

/***/ }),

/***/ "5df3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("02f4")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("01f9")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "5e1a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__("a8f0").Buffer;
var util = __webpack_require__(1);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5ee7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "5fbd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ "6117":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6283":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5");
var Reporter = __webpack_require__("41df").Reporter;
var Buffer = __webpack_require__("1c35").Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),

/***/ "62a0":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "62c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _barcodes = __webpack_require__("ff84");

var _barcodes2 = _interopRequireDefault(_barcodes);

var _merge = __webpack_require__("fd7c");

var _merge2 = _interopRequireDefault(_merge);

var _linearizeEncodings = __webpack_require__("a2b0");

var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);

var _fixOptions = __webpack_require__("79f1");

var _fixOptions2 = _interopRequireDefault(_fixOptions);

var _getRenderProperties = __webpack_require__("b1d8");

var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);

var _optionsFromStrings = __webpack_require__("5261");

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _ErrorHandler = __webpack_require__("bd8a");

var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);

var _exceptions = __webpack_require__("dca2");

var _defaults = __webpack_require__("ca32");

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The protype of the object returned from the JsBarcode() call


// Help functions
var API = function API() {};

// The first call of the library API
// Will return an object with all barcodes calls and the data that is used
// by the renderers


// Default values


// Exceptions
// Import all the barcodes
var JsBarcode = function JsBarcode(element, text, options) {
	var api = new API();

	if (typeof element === "undefined") {
		throw Error("No element to render on was provided.");
	}

	// Variables that will be pased through the API calls
	api._renderProperties = (0, _getRenderProperties2.default)(element);
	api._encodings = [];
	api._options = _defaults2.default;
	api._errorHandler = new _ErrorHandler2.default(api);

	// If text is set, use the simple syntax (render the barcode directly)
	if (typeof text !== "undefined") {
		options = options || {};

		if (!options.format) {
			options.format = autoSelectBarcode();
		}

		api.options(options)[options.format](text, options).render();
	}

	return api;
};

// To make tests work TODO: remove
JsBarcode.getModule = function (name) {
	return _barcodes2.default[name];
};

// Register all barcodes
for (var name in _barcodes2.default) {
	if (_barcodes2.default.hasOwnProperty(name)) {
		// Security check if the propery is a prototype property
		registerBarcode(_barcodes2.default, name);
	}
}
function registerBarcode(barcodes, name) {
	API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
		var api = this;
		return api._errorHandler.wrapBarcodeCall(function () {
			// Ensure text is options.text
			options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;

			var newOptions = (0, _merge2.default)(api._options, options);
			newOptions = (0, _optionsFromStrings2.default)(newOptions);
			var Encoder = barcodes[name];
			var encoded = encode(text, Encoder, newOptions);
			api._encodings.push(encoded);

			return api;
		});
	};
}

// encode() handles the Encoder call and builds the binary string to be rendered
function encode(text, Encoder, options) {
	// Ensure that text is a string
	text = "" + text;

	var encoder = new Encoder(text, options);

	// If the input is not valid for the encoder, throw error.
	// If the valid callback option is set, call it instead of throwing error
	if (!encoder.valid()) {
		throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
	}

	// Make a request for the binary data (and other infromation) that should be rendered
	var encoded = encoder.encode();

	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	encoded = (0, _linearizeEncodings2.default)(encoded);

	// Merge
	for (var i = 0; i < encoded.length; i++) {
		encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
	}

	return encoded;
}

function autoSelectBarcode() {
	// If CODE128 exists. Use it
	if (_barcodes2.default["CODE128"]) {
		return "CODE128";
	}

	// Else, take the first (probably only) barcode
	return Object.keys(_barcodes2.default)[0];
}

// Sets global encoder options
// Added to the api by the JsBarcode function
API.prototype.options = function (options) {
	this._options = (0, _merge2.default)(this._options, options);
	return this;
};

// Will create a blank space (usually in between barcodes)
API.prototype.blank = function (size) {
	var zeroes = new Array(size + 1).join("0");
	this._encodings.push({ data: zeroes });
	return this;
};

// Initialize JsBarcode on all HTML elements defined.
API.prototype.init = function () {
	// Should do nothing if no elements where found
	if (!this._renderProperties) {
		return;
	}

	// Make sure renderProperies is an array
	if (!Array.isArray(this._renderProperties)) {
		this._renderProperties = [this._renderProperties];
	}

	var renderProperty;
	for (var i in this._renderProperties) {
		renderProperty = this._renderProperties[i];
		var options = (0, _merge2.default)(this._options, renderProperty.options);

		if (options.format == "auto") {
			options.format = autoSelectBarcode();
		}

		this._errorHandler.wrapBarcodeCall(function () {
			var text = options.value;
			var Encoder = _barcodes2.default[options.format.toUpperCase()];
			var encoded = encode(text, Encoder, options);

			render(renderProperty, encoded, options);
		});
	}
};

// The render API call. Calls the real render function.
API.prototype.render = function () {
	if (!this._renderProperties) {
		throw new _exceptions.NoElementException();
	}

	if (Array.isArray(this._renderProperties)) {
		for (var i = 0; i < this._renderProperties.length; i++) {
			render(this._renderProperties[i], this._encodings, this._options);
		}
	} else {
		render(this._renderProperties, this._encodings, this._options);
	}

	return this;
};

API.prototype._defaults = _defaults2.default;

// Prepares the encodings and calls the renderer
function render(renderProperties, encodings, options) {
	encodings = (0, _linearizeEncodings2.default)(encodings);

	for (var i = 0; i < encodings.length; i++) {
		encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
		(0, _fixOptions2.default)(encodings[i].options);
	}

	(0, _fixOptions2.default)(options);

	var Renderer = renderProperties.renderer;
	var renderer = new Renderer(renderProperties.element, encodings, options);
	renderer.render();

	if (renderProperties.afterRender) {
		renderProperties.afterRender();
	}
}

// Export to browser
if (typeof window !== "undefined") {
	window.JsBarcode = JsBarcode;
}

// Export to jQuery
/*global jQuery */
if (typeof jQuery !== 'undefined') {
	jQuery.fn.JsBarcode = function (content, options) {
		var elementArray = [];
		jQuery(this).each(function () {
			elementArray.push(this);
		});
		return JsBarcode(elementArray, content, options);
	};
}

// Export to commonJS
module.exports = JsBarcode;

/***/ }),

/***/ "62c9":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "63b6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var ctx = __webpack_require__("d864");
var hide = __webpack_require__("35e8");
var has = __webpack_require__("07e3");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "63e5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodeExtension; });
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ffb");
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prosemirror_view__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("576a");
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("80a6");
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbea");
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prosemirror_commands__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prosemirror_inputrules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("72a8");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6f27");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prosemirror_model__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _citadel_extensions_gap_cursor_extension_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("573f");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ab5b");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("8bc8");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prosemirror_history__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("321a");
/* harmony import */ var prosemirror_history__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prosemirror_history__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var codemirror__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("56b3");
/* harmony import */ var codemirror__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(codemirror__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("c0c4");
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_11__);













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var noop = function() {};
function getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new prosemirror_model__WEBPACK_IMPORTED_MODULE_5__["Slice"](prosemirror_model__WEBPACK_IMPORTED_MODULE_5__["Fragment"].from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && isParagraph(content[size - 1]) && isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"](tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"].create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, _toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};
var blockInputRule = function(regexp, nodeType) {
    return new prosemirror_inputrules__WEBPACK_IMPORTED_MODULE_4__[/* InputRule */ "a"](regexp, function(state, match, start, end) {
        var transaction = insertBlock(state, nodeType.create()).transaction;
        // 删除快捷键
        transaction.deleteRange(start - 1, end);
        return transaction;
    });
};

function insert() {
    return function(state, dispatch) {
        var schema = state.schema;
        var node = schema.nodes.code_block.create({
            isCreate: true,
            language: localStorage.getItem("cmLanguage") || ""
        });
        var transaction = insertBlock(state, node).transaction;
        dispatch(transaction.scrollIntoView());
        return true;
    };
}

function isInCode() {
    return function(state) {
        if (!state) return false;
        var selection = state.selection;
        var foundNode = findParentNode(function(node) {
            return node.type && node.type.name === "code_block";
        })(selection);
        return !!foundNode;
    };
}

var convertCommand = function(commandFunction) {
    return function(param) {
        var state = param.state, dispatch = param.dispatch, view = param.view, args = param.args;
        return commandFunction(state, dispatch, view, args);
    };
};

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var backspaceAfterCode = function() {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection;
        if (_instanceof(selection, _citadel_extensions_gap_cursor_extension_index_js__WEBPACK_IMPORTED_MODULE_6__[/* GapCursor */ "a"])) {
            var targetNode = selection.targetNode, $from = selection.$from;
            var res = _citadel_extensions_gap_cursor_extension_index_js__WEBPACK_IMPORTED_MODULE_6__[/* GapCursor */ "a"].findFrom($from, -1);
            if (targetNode.type.name === "code_block" && selection.gapCursorType === _citadel_extensions_gap_cursor_extension_index_js__WEBPACK_IMPORTED_MODULE_6__[/* gapCursorSituation */ "c"].afterNode) {
                var newSelection = prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].create(tr.doc, res.pos - targetNode.nodeSize);
                dispatch(tr.setSelection(newSelection));
                return true;
            }
        }
        return false;
    };
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ct-code{min-width:233px;margin:5px 0;font-size:14px;border:1px solid #ddd;border-radius:2px 2px;background:#fcfcfc;font-family:monospace;line-height:21px;position:relative}.ProseMirror-selectednode.ct-code{outline:none;border:1px solid #3d91f2;box-shadow:0 0 4px 0 rgba(0,0,0,.1),0 3px 6px 0 rgba(0,0,0,.14)}.ct-code-selected{border-radius:3px;border:1px solid #0082a6;margin:5px 0;opacity:.7}.ct-code-selected .CodeMirror,.ct-code-selected .ct-code{margin:0}";
styleInject(css_248z);

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 代码块
var regexpCode = /^```\n$/;

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

/**
 * 通用配置
 */ var pluginKey = new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["PluginKey"]("image");

var AFTER_INSERT = "after_insert";

var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(Keycodes || (Keycodes = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var codemirror = createCommonjsModule(function (module, exports) {
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .
(function(global, factory) {
     module.exports = factory() ;
})(commonjsGlobal, function() {
    var classTest = function classTest(cls) {
        return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    };
    var removeChildren = function removeChildren(e) {
        for(var count = e.childNodes.length; count > 0; --count){
            e.removeChild(e.firstChild);
        }
        return e;
    };
    var removeChildrenAndAdd = function removeChildrenAndAdd(parent, e) {
        return removeChildren(parent).appendChild(e);
    };
    var elt = function elt(tag, content, className, style) {
        var e = document.createElement(tag);
        if (className) {
            e.className = className;
        }
        if (style) {
            e.style.cssText = style;
        }
        if (typeof content == "string") {
            e.appendChild(document.createTextNode(content));
        } else if (content) {
            for(var i = 0; i < content.length; ++i){
                e.appendChild(content[i]);
            }
        }
        return e;
    };
    var eltP = // wrapper for elt, which removes the elt from the accessibility tree
    function eltP(tag, content, className, style) {
        var e = elt(tag, content, className, style);
        e.setAttribute("role", "presentation");
        return e;
    };
    var contains = function contains(parent, child) {
        if (child.nodeType == 3) {
            child = child.parentNode;
        }
        if (parent.contains) {
            return parent.contains(child);
        }
        do {
            if (child.nodeType == 11) {
                child = child.host;
            }
            if (child == parent) {
                return true;
            }
        }while (child = child.parentNode);
    };
    var activeElt = function activeElt() {
        // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
        // IE < 10 will throw when accessed while the page is loading or in an iframe.
        // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
        var activeElement;
        try {
            activeElement = document.activeElement;
        } catch (e) {
            activeElement = document.body || null;
        }
        while(activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement){
            activeElement = activeElement.shadowRoot.activeElement;
        }
        return activeElement;
    };
    var addClass = function addClass(node, cls) {
        var current = node.className;
        if (!classTest(cls).test(current)) {
            node.className += (current ? " " : "") + cls;
        }
    };
    var joinClasses = function joinClasses(a, b) {
        var as = a.split(" ");
        for(var i = 0; i < as.length; i++){
            if (as[i] && !classTest(as[i]).test(b)) {
                b += " " + as[i];
            }
        }
        return b;
    };
    var bind = function bind(f) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function() {
            return f.apply(null, args);
        };
    };
    var copyObj = function copyObj(obj, target, overwrite) {
        if (!target) {
            target = {};
        }
        for(var prop in obj){
            if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) {
                target[prop] = obj[prop];
            }
        }
        return target;
    };
    var countColumn = // Counts the column offset in a string, taking tabs into account.
    // Used mostly to find indentation.
    function countColumn(string, end, tabSize, startIndex, startValue) {
        if (end == null) {
            end = string.search(/[^\s\u00a0]/);
            if (end == -1) {
                end = string.length;
            }
        }
        for(var i = startIndex || 0, n = startValue || 0;;){
            var nextTab = string.indexOf("	", i);
            if (nextTab < 0 || nextTab >= end) {
                return n + (end - i);
            }
            n += nextTab - i;
            n += tabSize - n % tabSize;
            i = nextTab + 1;
        }
    };
    var indexOf = function indexOf(array, elt) {
        for(var i = 0; i < array.length; ++i){
            if (array[i] == elt) {
                return i;
            }
        }
        return -1;
    };
    var findColumn = // The inverse of countColumn -- find the offset that corresponds to
    // a particular column.
    function findColumn(string, goal, tabSize) {
        for(var pos = 0, col = 0;;){
            var nextTab = string.indexOf("	", pos);
            if (nextTab == -1) {
                nextTab = string.length;
            }
            var skipped = nextTab - pos;
            if (nextTab == string.length || col + skipped >= goal) {
                return pos + Math.min(skipped, goal - col);
            }
            col += nextTab - pos;
            col += tabSize - col % tabSize;
            pos = nextTab + 1;
            if (col >= goal) {
                return pos;
            }
        }
    };
    var spaceStr = function spaceStr(n) {
        while(spaceStrs.length <= n){
            spaceStrs.push(lst(spaceStrs) + " ");
        }
        return spaceStrs[n];
    };
    var lst = function lst(arr) {
        return arr[arr.length - 1];
    };
    var map = function map(array, f) {
        var out = [];
        for(var i = 0; i < array.length; i++){
            out[i] = f(array[i], i);
        }
        return out;
    };
    var insertSorted = function insertSorted(array, value, score) {
        var pos = 0, priority = score(value);
        while(pos < array.length && score(array[pos]) <= priority){
            pos++;
        }
        array.splice(pos, 0, value);
    };
    var nothing = function nothing() {};
    var createObj = function createObj(base, props) {
        var inst;
        if (Object.create) {
            inst = Object.create(base);
        } else {
            nothing.prototype = base;
            inst = new nothing();
        }
        if (props) {
            copyObj(props, inst);
        }
        return inst;
    };
    var isWordCharBasic = function isWordCharBasic(ch) {
        return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    };
    var isWordChar = function isWordChar(ch, helper) {
        if (!helper) {
            return isWordCharBasic(ch);
        }
        if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) {
            return true;
        }
        return helper.test(ch);
    };
    var isEmpty = function isEmpty(obj) {
        for(var n in obj){
            if (obj.hasOwnProperty(n) && obj[n]) {
                return false;
            }
        }
        return true;
    };
    var isExtendingChar = function isExtendingChar(ch) {
        return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    };
    var skipExtendingChars = // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
    function skipExtendingChars(str, pos, dir) {
        while((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))){
            pos += dir;
        }
        return pos;
    };
    var findFirst = // Returns the value from the range [`from`; `to`] that satisfies
    // `pred` and is closest to `from`. Assumes that at least `to`
    // satisfies `pred`. Supports `from` being greater than `to`.
    function findFirst(pred, from, to) {
        // At any point we are certain `to` satisfies `pred`, don't know
        // whether `from` does.
        var dir = from > to ? -1 : 1;
        for(;;){
            if (from == to) {
                return from;
            }
            var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
            if (mid == from) {
                return pred(mid) ? from : to;
            }
            if (pred(mid)) {
                to = mid;
            } else {
                from = mid + dir;
            }
        }
    };
    var iterateBidiSections = // BIDI HELPERS
    function iterateBidiSections(order, from, to, f) {
        if (!order) {
            return f(from, to, "ltr", 0);
        }
        var found = false;
        for(var i = 0; i < order.length; ++i){
            var part = order[i];
            if (part.from < to && part.to > from || from == to && part.to == from) {
                f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
                found = true;
            }
        }
        if (!found) {
            f(from, to, "ltr");
        }
    };
    var getBidiPartAt = function getBidiPartAt(order, ch, sticky) {
        var found;
        bidiOther = null;
        for(var i = 0; i < order.length; ++i){
            var cur = order[i];
            if (cur.from < ch && cur.to > ch) {
                return i;
            }
            if (cur.to == ch) {
                if (cur.from != cur.to && sticky == "before") {
                    found = i;
                } else {
                    bidiOther = i;
                }
            }
            if (cur.from == ch) {
                if (cur.from != cur.to && sticky != "before") {
                    found = i;
                } else {
                    bidiOther = i;
                }
            }
        }
        return found != null ? found : bidiOther;
    };
    var getOrder = // Get the bidi ordering for the given line (and cache it). Returns
    // false for lines that are fully left-to-right, and an array of
    // BidiSpan objects otherwise.
    function getOrder(line, direction) {
        var order = line.order;
        if (order == null) {
            order = line.order = bidiOrdering(line.text, direction);
        }
        return order;
    };
    var getHandlers = function getHandlers(emitter, type) {
        return emitter._handlers && emitter._handlers[type] || noHandlers;
    };
    var off = function off(emitter, type, f) {
        if (emitter.removeEventListener) {
            emitter.removeEventListener(type, f, false);
        } else if (emitter.detachEvent) {
            emitter.detachEvent("on" + type, f);
        } else {
            var map = emitter._handlers, arr = map && map[type];
            if (arr) {
                var index = indexOf(arr, f);
                if (index > -1) {
                    map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
                }
            }
        }
    };
    var signal = function signal(emitter, type /*, values...*/ ) {
        var handlers = getHandlers(emitter, type);
        if (!handlers.length) {
            return;
        }
        var args = Array.prototype.slice.call(arguments, 2);
        for(var i = 0; i < handlers.length; ++i){
            handlers[i].apply(null, args);
        }
    };
    var signalDOMEvent = // The DOM events that CodeMirror handles can be overridden by
    // registering a (non-DOM) handler on the editor for the event name,
    // and preventDefault-ing the event in that handler.
    function signalDOMEvent(cm, e, override) {
        if (typeof e == "string") {
            e = {
                type: e,
                preventDefault: function preventDefault() {
                    this.defaultPrevented = true;
                }
            };
        }
        signal(cm, override || e.type, cm, e);
        return e_defaultPrevented(e) || e.codemirrorIgnore;
    };
    var signalCursorActivity = function signalCursorActivity(cm) {
        var arr = cm._handlers && cm._handlers.cursorActivity;
        if (!arr) {
            return;
        }
        var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
        for(var i = 0; i < arr.length; ++i){
            if (indexOf(set, arr[i]) == -1) {
                set.push(arr[i]);
            }
        }
    };
    var hasHandler = function hasHandler(emitter, type) {
        return getHandlers(emitter, type).length > 0;
    };
    var eventMixin = // Add on and off methods to a constructor's prototype, to make
    // registering events on such objects more convenient.
    function eventMixin(ctor) {
        ctor.prototype.on = function(type, f) {
            on(this, type, f);
        };
        ctor.prototype.off = function(type, f) {
            off(this, type, f);
        };
    };
    var e_preventDefault = // Due to the fact that we still support jurassic IE versions, some
    // compatibility wrappers are needed.
    function e_preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            e.returnValue = false;
        }
    };
    var e_stopPropagation = function e_stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        } else {
            e.cancelBubble = true;
        }
    };
    var e_defaultPrevented = function e_defaultPrevented(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    };
    var e_stop = function e_stop(e) {
        e_preventDefault(e);
        e_stopPropagation(e);
    };
    var e_target = function e_target(e) {
        return e.target || e.srcElement;
    };
    var e_button = function e_button(e) {
        var b = e.which;
        if (b == null) {
            if (e.button & 1) {
                b = 1;
            } else if (e.button & 2) {
                b = 3;
            } else if (e.button & 4) {
                b = 2;
            }
        }
        if (mac && e.ctrlKey && b == 1) {
            b = 3;
        }
        return b;
    };
    var zeroWidthElement = function zeroWidthElement(measure) {
        if (zwspSupported == null) {
            var test = elt("span", "​");
            removeChildrenAndAdd(measure, elt("span", [
                test,
                document.createTextNode("x")
            ]));
            if (measure.firstChild.offsetHeight != 0) {
                zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
            }
        }
        var node = zwspSupported ? elt("span", "​") : elt("span", "\xa0", null, "display: inline-block; width: 1px; margin-right: -1px");
        node.setAttribute("cm-text", "");
        return node;
    };
    var hasBadBidiRects = function hasBadBidiRects(measure) {
        if (badBidiRects != null) {
            return badBidiRects;
        }
        var txt = removeChildrenAndAdd(measure, document.createTextNode("AخA"));
        var r0 = range(txt, 0, 1).getBoundingClientRect();
        var r1 = range(txt, 1, 2).getBoundingClientRect();
        removeChildren(measure);
        if (!r0 || r0.left == r0.right) {
            return false;
        } // Safari returns null in some cases (#2780)
        return badBidiRects = r1.right - r0.right < 3;
    };
    var hasBadZoomedRects = function hasBadZoomedRects(measure) {
        if (badZoomedRects != null) {
            return badZoomedRects;
        }
        var node = removeChildrenAndAdd(measure, elt("span", "x"));
        var normal = node.getBoundingClientRect();
        var fromRange = range(node, 0, 1).getBoundingClientRect();
        return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    };
    var defineMode = // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    function defineMode(name, mode) {
        if (arguments.length > 2) {
            mode.dependencies = Array.prototype.slice.call(arguments, 2);
        }
        modes[name] = mode;
    };
    var defineMIME = function defineMIME(mime, spec) {
        mimeModes[mime] = spec;
    };
    var extendMode = function extendMode(mode, properties) {
        var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
        copyObj(properties, exts);
    };
    var copyState = function copyState(mode, state) {
        if (state === true) {
            return state;
        }
        if (mode.copyState) {
            return mode.copyState(state);
        }
        var nstate = {};
        for(var n in state){
            var val = state[n];
            if (_instanceof(val, Array)) {
                val = val.concat([]);
            }
            nstate[n] = val;
        }
        return nstate;
    };
    var innerMode = // Given a mode and a state (for that mode), find the inner mode and
    // state at the position that the state refers to.
    function innerMode(mode, state) {
        var info;
        while(mode.innerMode){
            info = mode.innerMode(state);
            if (!info || info.mode == mode) {
                break;
            }
            state = info.state;
            mode = info.mode;
        }
        return info || {
            mode: mode,
            state: state
        };
    };
    var startState = function startState(mode, a1, a2) {
        return mode.startState ? mode.startState(a1, a2) : true;
    };
    var getLine = // Find the line object corresponding to the given line number.
    function getLine(doc, n) {
        n -= doc.first;
        if (n < 0 || n >= doc.size) {
            throw new Error("There is no line " + (n + doc.first) + " in the document.");
        }
        var chunk = doc;
        while(!chunk.lines){
            for(var i = 0;; ++i){
                var child = chunk.children[i], sz = child.chunkSize();
                if (n < sz) {
                    chunk = child;
                    break;
                }
                n -= sz;
            }
        }
        return chunk.lines[n];
    };
    var getBetween = // Get the part of a document between two positions, as an array of
    // strings.
    function getBetween(doc, start, end) {
        var out = [], n = start.line;
        doc.iter(start.line, end.line + 1, function(line) {
            var text = line.text;
            if (n == end.line) {
                text = text.slice(0, end.ch);
            }
            if (n == start.line) {
                text = text.slice(start.ch);
            }
            out.push(text);
            ++n;
        });
        return out;
    };
    var getLines = // Get the lines between from and to, as array of strings.
    function getLines(doc, from, to) {
        var out = [];
        doc.iter(from, to, function(line) {
            out.push(line.text);
        }); // iter aborts when callback returns truthy value
        return out;
    };
    var updateLineHeight = // Update the height of a line, propagating the height change
    // upwards to parent nodes.
    function updateLineHeight(line, height) {
        var diff = height - line.height;
        if (diff) {
            for(var n = line; n; n = n.parent){
                n.height += diff;
            }
        }
    };
    var lineNo = // Given a line object, find its line number by walking up through
    // its parent links.
    function lineNo(line) {
        if (line.parent == null) {
            return null;
        }
        var cur = line.parent, no = indexOf(cur.lines, line);
        for(var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent){
            for(var i = 0;; ++i){
                if (chunk.children[i] == cur) {
                    break;
                }
                no += chunk.children[i].chunkSize();
            }
        }
        return no + cur.first;
    };
    var lineAtHeight = // Find the line at the given vertical position, using the height
    // information in the document tree.
    function lineAtHeight(chunk, h) {
        var n = chunk.first;
        outer: do {
            for(var i$1 = 0; i$1 < chunk.children.length; ++i$1){
                var child = chunk.children[i$1], ch = child.height;
                if (h < ch) {
                    chunk = child;
                    continue outer;
                }
                h -= ch;
                n += child.chunkSize();
            }
            return n;
        }while (!chunk.lines);
        var i = 0;
        for(; i < chunk.lines.length; ++i){
            var line = chunk.lines[i], lh = line.height;
            if (h < lh) {
                break;
            }
            h -= lh;
        }
        return n + i;
    };
    var isLine = function isLine(doc, l) {
        return l >= doc.first && l < doc.first + doc.size;
    };
    var lineNumberFor = function lineNumberFor(options, i) {
        return String(options.lineNumberFormatter(i + options.firstLineNumber));
    };
    var cmp = // Compare two positions, return 0 if they are the same, a negative
    // number when a is less, and a positive number otherwise.
    function cmp(a, b) {
        return a.line - b.line || a.ch - b.ch;
    };
    var equalCursorPos = function equalCursorPos(a, b) {
        return a.sticky == b.sticky && cmp(a, b) == 0;
    };
    var copyPos = function copyPos(x) {
        return Pos(x.line, x.ch);
    };
    var maxPos = function maxPos(a, b) {
        return cmp(a, b) < 0 ? b : a;
    };
    var minPos = function minPos(a, b) {
        return cmp(a, b) < 0 ? a : b;
    };
    var clipLine = // Most of the external API clips given positions to make sure they
    // actually exist within the document.
    function clipLine(doc, n) {
        return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
    };
    var clipPos = function clipPos(doc, pos) {
        if (pos.line < doc.first) {
            return Pos(doc.first, 0);
        }
        var last = doc.first + doc.size - 1;
        if (pos.line > last) {
            return Pos(last, getLine(doc, last).text.length);
        }
        return clipToLen(pos, getLine(doc, pos.line).text.length);
    };
    var clipToLen = function clipToLen(pos, linelen) {
        var ch = pos.ch;
        if (ch == null || ch > linelen) {
            return Pos(pos.line, linelen);
        } else if (ch < 0) {
            return Pos(pos.line, 0);
        } else {
            return pos;
        }
    };
    var clipPosArray = function clipPosArray(doc, array) {
        var out = [];
        for(var i = 0; i < array.length; i++){
            out[i] = clipPos(doc, array[i]);
        }
        return out;
    };
    var highlightLine = // Compute a style array (an array starting with a mode generation
    // -- for invalidation -- followed by pairs of end positions and
    // style strings), which is used to highlight the tokens on the
    // line.
    function highlightLine(cm, line, context, forceToEnd) {
        // A styles array always starts with a number identifying the
        // mode/overlays that it is based on (for easy invalidation).
        var st = [
            cm.state.modeGen
        ], lineClasses = {};
        // Compute the base array of styles
        runMode(cm, line.text, cm.doc.mode, context, function(end, style) {
            return st.push(end, style);
        }, lineClasses, forceToEnd);
        var state = context.state;
        // Run overlays, adjust style array.
        var loop = function loop(o) {
            context.baseTokens = st;
            var overlay = cm.state.overlays[o], i = 1, at = 0;
            context.state = true;
            runMode(cm, line.text, overlay.mode, context, function(end, style) {
                var start = i;
                // Ensure there's a token end at the current position, and that i points at it
                while(at < end){
                    var i_end = st[i];
                    if (i_end > end) {
                        st.splice(i, 1, end, st[i + 1], i_end);
                    }
                    i += 2;
                    at = Math.min(end, i_end);
                }
                if (!style) {
                    return;
                }
                if (overlay.opaque) {
                    st.splice(start, i - start, end, "overlay " + style);
                    i = start + 2;
                } else {
                    for(; start < i; start += 2){
                        var cur = st[start + 1];
                        st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
                    }
                }
            }, lineClasses);
            context.state = state;
            context.baseTokens = null;
            context.baseTokenPos = 1;
        };
        for(var o = 0; o < cm.state.overlays.length; ++o)loop(o);
        return {
            styles: st,
            classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null
        };
    };
    var getLineStyles = function getLineStyles(cm, line, updateFrontier) {
        if (!line.styles || line.styles[0] != cm.state.modeGen) {
            var context = getContextBefore(cm, lineNo(line));
            var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
            var result = highlightLine(cm, line, context);
            if (resetState) {
                context.state = resetState;
            }
            line.stateAfter = context.save(!resetState);
            line.styles = result.styles;
            if (result.classes) {
                line.styleClasses = result.classes;
            } else if (line.styleClasses) {
                line.styleClasses = null;
            }
            if (updateFrontier === cm.doc.highlightFrontier) {
                cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
            }
        }
        return line.styles;
    };
    var getContextBefore = function getContextBefore(cm, n, precise) {
        var doc = cm.doc, display = cm.display;
        if (!doc.mode.startState) {
            return new Context(doc, true, n);
        }
        var start = findStartLine(cm, n, precise);
        var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
        var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
        doc.iter(start, n, function(line) {
            processLine(cm, line.text, context);
            var pos = context.line;
            line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
            context.nextLine();
        });
        if (precise) {
            doc.modeFrontier = context.line;
        }
        return context;
    };
    var processLine = // Lightweight form of highlight -- proceed over this line and
    // update state, but don't save a style array. Used for lines that
    // aren't currently visible.
    function processLine(cm, text, context, startAt) {
        var mode = cm.doc.mode;
        var stream = new StringStream(text, cm.options.tabSize, context);
        stream.start = stream.pos = startAt || 0;
        if (text == "") {
            callBlankLine(mode, context.state);
        }
        while(!stream.eol()){
            readToken(mode, stream, context.state);
            stream.start = stream.pos;
        }
    };
    var callBlankLine = function callBlankLine(mode, state) {
        if (mode.blankLine) {
            return mode.blankLine(state);
        }
        if (!mode.innerMode) {
            return;
        }
        var inner = innerMode(mode, state);
        if (inner.mode.blankLine) {
            return inner.mode.blankLine(inner.state);
        }
    };
    var readToken = function readToken(mode, stream, state, inner) {
        for(var i = 0; i < 10; i++){
            if (inner) {
                inner[0] = innerMode(mode, state).mode;
            }
            var style = mode.token(stream, state);
            if (stream.pos > stream.start) {
                return style;
            }
        }
        throw new Error("Mode " + mode.name + " failed to advance stream.");
    };
    var takeToken = // Utility for getTokenAt and getLineTokens
    function takeToken(cm, pos, precise, asArray) {
        var doc = cm.doc, mode = doc.mode, style;
        pos = clipPos(doc, pos);
        var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
        var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
        if (asArray) {
            tokens = [];
        }
        while((asArray || stream.pos < pos.ch) && !stream.eol()){
            stream.start = stream.pos;
            style = readToken(mode, stream, context.state);
            if (asArray) {
                tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
            }
        }
        return asArray ? tokens : new Token(stream, style, context.state);
    };
    var extractLineClasses = function extractLineClasses(type, output) {
        if (type) {
            for(;;){
                var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
                if (!lineClass) {
                    break;
                }
                type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
                var prop = lineClass[1] ? "bgClass" : "textClass";
                if (output[prop] == null) {
                    output[prop] = lineClass[2];
                } else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) {
                    output[prop] += " " + lineClass[2];
                }
            }
        }
        return type;
    };
    var runMode = // Run the given mode's parser over a line, calling f for each token.
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
        var flattenSpans = mode.flattenSpans;
        if (flattenSpans == null) {
            flattenSpans = cm.options.flattenSpans;
        }
        var curStart = 0, curStyle = null;
        var stream = new StringStream(text, cm.options.tabSize, context), style;
        var inner = cm.options.addModeClass && [
            null
        ];
        if (text == "") {
            extractLineClasses(callBlankLine(mode, context.state), lineClasses);
        }
        while(!stream.eol()){
            if (stream.pos > cm.options.maxHighlightLength) {
                flattenSpans = false;
                if (forceToEnd) {
                    processLine(cm, text, context, stream.pos);
                }
                stream.pos = text.length;
                style = null;
            } else {
                style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
            }
            if (inner) {
                var mName = inner[0].name;
                if (mName) {
                    style = "m-" + (style ? mName + " " + style : mName);
                }
            }
            if (!flattenSpans || curStyle != style) {
                while(curStart < stream.start){
                    curStart = Math.min(stream.start, curStart + 5000);
                    f(curStart, curStyle);
                }
                curStyle = style;
            }
            stream.start = stream.pos;
        }
        while(curStart < stream.pos){
            // Webkit seems to refuse to render text nodes longer than 57444
            // characters, and returns inaccurate measurements in nodes
            // starting around 5000 chars.
            var pos = Math.min(stream.pos, curStart + 5000);
            f(pos, curStyle);
            curStart = pos;
        }
    };
    var findStartLine = // Finds the line to start with when starting a parse. Tries to
    // find a line with a stateAfter, so that it can start with a
    // valid state. If that fails, it returns the line with the
    // smallest indentation, which tends to need the least context to
    // parse correctly.
    function findStartLine(cm, n, precise) {
        var minindent, minline, doc = cm.doc;
        var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
        for(var search = n; search > lim; --search){
            if (search <= doc.first) {
                return doc.first;
            }
            var line = getLine(doc, search - 1), after = line.stateAfter;
            if (after && (!precise || search + (_instanceof(after, SavedContext) ? after.lookAhead : 0) <= doc.modeFrontier)) {
                return search;
            }
            var indented = countColumn(line.text, null, cm.options.tabSize);
            if (minline == null || minindent > indented) {
                minline = search - 1;
                minindent = indented;
            }
        }
        return minline;
    };
    var retreatFrontier = function retreatFrontier(doc, n) {
        doc.modeFrontier = Math.min(doc.modeFrontier, n);
        if (doc.highlightFrontier < n - 10) {
            return;
        }
        var start = doc.first;
        for(var line = n - 1; line > start; line--){
            var saved = getLine(doc, line).stateAfter;
            // change is on 3
            // state on line 1 looked ahead 2 -- so saw 3
            // test 1 + 2 < 3 should cover this
            if (saved && (!_instanceof(saved, SavedContext) || line + saved.lookAhead < n)) {
                start = line + 1;
                break;
            }
        }
        doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
    };
    var seeReadOnlySpans = function seeReadOnlySpans() {
        sawReadOnlySpans = true;
    };
    var seeCollapsedSpans = function seeCollapsedSpans() {
        sawCollapsedSpans = true;
    };
    var MarkedSpan = // TEXTMARKER SPANS
    function MarkedSpan(marker, from, to) {
        this.marker = marker;
        this.from = from;
        this.to = to;
    };
    var getMarkedSpanFor = // Search an array of spans for a span matching the given marker.
    function getMarkedSpanFor(spans, marker) {
        if (spans) {
            for(var i = 0; i < spans.length; ++i){
                var span = spans[i];
                if (span.marker == marker) {
                    return span;
                }
            }
        }
    };
    var removeMarkedSpan = // Remove a span from an array, returning undefined if no spans are
    // left (we don't store arrays for lines without spans).
    function removeMarkedSpan(spans, span) {
        var r;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i] != span) {
                (r || (r = [])).push(spans[i]);
            }
        }
        return r;
    };
    var addMarkedSpan = // Add a span to a line.
    function addMarkedSpan(line, span, op) {
        var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
        if (inThisOp && inThisOp.has(line.markedSpans)) {
            line.markedSpans.push(span);
        } else {
            line.markedSpans = line.markedSpans ? line.markedSpans.concat([
                span
            ]) : [
                span
            ];
            if (inThisOp) {
                inThisOp.add(line.markedSpans);
            }
        }
        span.marker.attachLine(line);
    };
    var markedSpansBefore = // Used for the algorithm that adjusts markers for a change in the
    // document. These functions cut an array of spans at a given
    // character position, returning an array of remaining chunks (or
    // undefined if nothing remains).
    function markedSpansBefore(old, startCh, isInsert) {
        var nw;
        if (old) {
            for(var i = 0; i < old.length; ++i){
                var span = old[i], marker = span.marker;
                var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
                if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
                    var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
                    (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
                }
            }
        }
        return nw;
    };
    var markedSpansAfter = function markedSpansAfter(old, endCh, isInsert) {
        var nw;
        if (old) {
            for(var i = 0; i < old.length; ++i){
                var span = old[i], marker = span.marker;
                var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
                if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
                    var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
                    (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
                }
            }
        }
        return nw;
    };
    var stretchSpansOverChange = // Given a change object, compute the new set of marker spans that
    // cover the line in which the change took place. Removes spans
    // entirely within the change, reconnects spans belonging to the
    // same marker that appear on both sides of the change, and cuts off
    // spans partially within the change. Returns an array of span
    // arrays with one element for each line in (after) the change.
    function stretchSpansOverChange(doc, change) {
        if (change.full) {
            return null;
        }
        var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
        var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
        if (!oldFirst && !oldLast) {
            return null;
        }
        var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
        // Get the spans that 'stick out' on both sides
        var first = markedSpansBefore(oldFirst, startCh, isInsert);
        var last = markedSpansAfter(oldLast, endCh, isInsert);
        // Next, merge those two ends
        var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
        if (first) {
            // Fix up .to properties of first
            for(var i = 0; i < first.length; ++i){
                var span = first[i];
                if (span.to == null) {
                    var found = getMarkedSpanFor(last, span.marker);
                    if (!found) {
                        span.to = startCh;
                    } else if (sameLine) {
                        span.to = found.to == null ? null : found.to + offset;
                    }
                }
            }
        }
        if (last) {
            // Fix up .from in last (or move them into first in case of sameLine)
            for(var i$1 = 0; i$1 < last.length; ++i$1){
                var span$1 = last[i$1];
                if (span$1.to != null) {
                    span$1.to += offset;
                }
                if (span$1.from == null) {
                    var found$1 = getMarkedSpanFor(first, span$1.marker);
                    if (!found$1) {
                        span$1.from = offset;
                        if (sameLine) {
                            (first || (first = [])).push(span$1);
                        }
                    }
                } else {
                    span$1.from += offset;
                    if (sameLine) {
                        (first || (first = [])).push(span$1);
                    }
                }
            }
        }
        // Make sure we didn't create any zero-length spans
        if (first) {
            first = clearEmptySpans(first);
        }
        if (last && last != first) {
            last = clearEmptySpans(last);
        }
        var newMarkers = [
            first
        ];
        if (!sameLine) {
            // Fill gap with whole-line-spans
            var gap = change.text.length - 2, gapMarkers;
            if (gap > 0 && first) {
                for(var i$2 = 0; i$2 < first.length; ++i$2){
                    if (first[i$2].to == null) {
                        (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
                    }
                }
            }
            for(var i$3 = 0; i$3 < gap; ++i$3){
                newMarkers.push(gapMarkers);
            }
            newMarkers.push(last);
        }
        return newMarkers;
    };
    var clearEmptySpans = // Remove spans that are empty and don't have a clearWhenEmpty
    // option of false.
    function clearEmptySpans(spans) {
        for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) {
                spans.splice(i--, 1);
            }
        }
        if (!spans.length) {
            return null;
        }
        return spans;
    };
    var removeReadOnlyRanges = // Used to 'clip' out readOnly ranges when making a change.
    function removeReadOnlyRanges(doc, from, to) {
        var markers = null;
        doc.iter(from.line, to.line + 1, function(line) {
            if (line.markedSpans) {
                for(var i = 0; i < line.markedSpans.length; ++i){
                    var mark = line.markedSpans[i].marker;
                    if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) {
                        (markers || (markers = [])).push(mark);
                    }
                }
            }
        });
        if (!markers) {
            return null;
        }
        var parts = [
            {
                from: from,
                to: to
            }
        ];
        for(var i = 0; i < markers.length; ++i){
            var mk = markers[i], m = mk.find(0);
            for(var j = 0; j < parts.length; ++j){
                var p = parts[j];
                if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) {
                    continue;
                }
                var newParts = [
                    j,
                    1
                ], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
                if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) {
                    newParts.push({
                        from: p.from,
                        to: m.from
                    });
                }
                if (dto > 0 || !mk.inclusiveRight && !dto) {
                    newParts.push({
                        from: m.to,
                        to: p.to
                    });
                }
                parts.splice.apply(parts, newParts);
                j += newParts.length - 3;
            }
        }
        return parts;
    };
    var detachMarkedSpans = // Connect or disconnect spans from a line.
    function detachMarkedSpans(line) {
        var spans = line.markedSpans;
        if (!spans) {
            return;
        }
        for(var i = 0; i < spans.length; ++i){
            spans[i].marker.detachLine(line);
        }
        line.markedSpans = null;
    };
    var attachMarkedSpans = function attachMarkedSpans(line, spans) {
        if (!spans) {
            return;
        }
        for(var i = 0; i < spans.length; ++i){
            spans[i].marker.attachLine(line);
        }
        line.markedSpans = spans;
    };
    var extraLeft = // Helpers used when computing which overlapping collapsed span
    // counts as the larger one.
    function extraLeft(marker) {
        return marker.inclusiveLeft ? -1 : 0;
    };
    var extraRight = function extraRight(marker) {
        return marker.inclusiveRight ? 1 : 0;
    };
    var compareCollapsedMarkers = // Returns a number indicating which of two overlapping collapsed
    // spans is larger (and thus includes the other). Falls back to
    // comparing ids when the spans cover exactly the same range.
    function compareCollapsedMarkers(a, b) {
        var lenDiff = a.lines.length - b.lines.length;
        if (lenDiff != 0) {
            return lenDiff;
        }
        var aPos = a.find(), bPos = b.find();
        var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
        if (fromCmp) {
            return -fromCmp;
        }
        var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
        if (toCmp) {
            return toCmp;
        }
        return b.id - a.id;
    };
    var collapsedSpanAtSide = // Find out whether a line ends or starts in a collapsed span. If
    // so, return the marker for that span.
    function collapsedSpanAtSide(line, start) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) {
            for(var sp = void 0, i = 0; i < sps.length; ++i){
                sp = sps[i];
                if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
                    found = sp.marker;
                }
            }
        }
        return found;
    };
    var collapsedSpanAtStart = function collapsedSpanAtStart(line) {
        return collapsedSpanAtSide(line, true);
    };
    var collapsedSpanAtEnd = function collapsedSpanAtEnd(line) {
        return collapsedSpanAtSide(line, false);
    };
    var collapsedSpanAround = function collapsedSpanAround(line, ch) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) {
            for(var i = 0; i < sps.length; ++i){
                var sp = sps[i];
                if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
                    found = sp.marker;
                }
            }
        }
        return found;
    };
    var conflictingCollapsedRange = // Test whether there exists a collapsed span that partially
    // overlaps (covers the start or end, but not both) of a new span.
    // Such overlap is not allowed.
    function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
        var line = getLine(doc, lineNo);
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) {
            for(var i = 0; i < sps.length; ++i){
                var sp = sps[i];
                if (!sp.marker.collapsed) {
                    continue;
                }
                var found = sp.marker.find(0);
                var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
                var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
                if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) {
                    continue;
                }
                if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) {
                    return true;
                }
            }
        }
    };
    var visualLine = // A visual line is a line as drawn on the screen. Folding, for
    // example, can cause multiple logical lines to appear on the same
    // visual line. This finds the start of the visual line that the
    // given line is part of (usually that is the line itself).
    function visualLine(line) {
        var merged;
        while(merged = collapsedSpanAtStart(line)){
            line = merged.find(-1, true).line;
        }
        return line;
    };
    var visualLineEnd = function visualLineEnd(line) {
        var merged;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
        }
        return line;
    };
    var visualLineContinued = // Returns an array of logical lines that continue the visual line
    // started by the argument, or undefined if there are no such lines.
    function visualLineContinued(line) {
        var merged, lines;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
            (lines || (lines = [])).push(line);
        }
        return lines;
    };
    var visualLineNo = // Get the line number of the start of the visual line that the
    // given line number is part of.
    function visualLineNo(doc, lineN) {
        var line = getLine(doc, lineN), vis = visualLine(line);
        if (line == vis) {
            return lineN;
        }
        return lineNo(vis);
    };
    var visualLineEndNo = // Get the line number of the start of the next visual line after
    // the given line.
    function visualLineEndNo(doc, lineN) {
        if (lineN > doc.lastLine()) {
            return lineN;
        }
        var line = getLine(doc, lineN), merged;
        if (!lineIsHidden(doc, line)) {
            return lineN;
        }
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
        }
        return lineNo(line) + 1;
    };
    var lineIsHidden = // Compute whether a line is hidden. Lines count as hidden when they
    // are part of a visual line that starts with another line, or when
    // they are entirely covered by collapsed, non-widget span.
    function lineIsHidden(doc, line) {
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) {
            for(var sp = void 0, i = 0; i < sps.length; ++i){
                sp = sps[i];
                if (!sp.marker.collapsed) {
                    continue;
                }
                if (sp.from == null) {
                    return true;
                }
                if (sp.marker.widgetNode) {
                    continue;
                }
                if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) {
                    return true;
                }
            }
        }
    };
    var heightAtLine = // Find the height above the given line.
    function heightAtLine(lineObj) {
        lineObj = visualLine(lineObj);
        var h = 0, chunk = lineObj.parent;
        for(var i = 0; i < chunk.lines.length; ++i){
            var line = chunk.lines[i];
            if (line == lineObj) {
                break;
            } else {
                h += line.height;
            }
        }
        for(var p = chunk.parent; p; chunk = p, p = chunk.parent){
            for(var i$1 = 0; i$1 < p.children.length; ++i$1){
                var cur = p.children[i$1];
                if (cur == chunk) {
                    break;
                } else {
                    h += cur.height;
                }
            }
        }
        return h;
    };
    var lineLength = // Compute the character length of a line, taking into account
    // collapsed ranges (see markText) that might hide parts, and join
    // other lines onto it.
    function lineLength(line) {
        if (line.height == 0) {
            return 0;
        }
        var len = line.text.length, merged, cur = line;
        while(merged = collapsedSpanAtStart(cur)){
            var found = merged.find(0, true);
            cur = found.from.line;
            len += found.from.ch - found.to.ch;
        }
        cur = line;
        while(merged = collapsedSpanAtEnd(cur)){
            var found$1 = merged.find(0, true);
            len -= cur.text.length - found$1.from.ch;
            cur = found$1.to.line;
            len += cur.text.length - found$1.to.ch;
        }
        return len;
    };
    var findMaxLine = // Find the longest line in the document.
    function findMaxLine(cm) {
        var d = cm.display, doc = cm.doc;
        d.maxLine = getLine(doc, doc.first);
        d.maxLineLength = lineLength(d.maxLine);
        d.maxLineChanged = true;
        doc.iter(function(line) {
            var len = lineLength(line);
            if (len > d.maxLineLength) {
                d.maxLineLength = len;
                d.maxLine = line;
            }
        });
    };
    var updateLine = // Change the content (text, markers) of a line. Automatically
    // invalidates cached information and tries to re-estimate the
    // line's height.
    function updateLine(line, text, markedSpans, estimateHeight) {
        line.text = text;
        if (line.stateAfter) {
            line.stateAfter = null;
        }
        if (line.styles) {
            line.styles = null;
        }
        if (line.order != null) {
            line.order = null;
        }
        detachMarkedSpans(line);
        attachMarkedSpans(line, markedSpans);
        var estHeight = estimateHeight ? estimateHeight(line) : 1;
        if (estHeight != line.height) {
            updateLineHeight(line, estHeight);
        }
    };
    var cleanUpLine = // Detach a line from the document tree and its markers.
    function cleanUpLine(line) {
        line.parent = null;
        detachMarkedSpans(line);
    };
    var interpretTokenStyle = function interpretTokenStyle(style, options) {
        if (!style || /^\s*$/.test(style)) {
            return null;
        }
        var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
        return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
    };
    var buildLineContent = // Render the DOM representation of the text of a line. Also builds
    // up a 'line map', which points at the DOM nodes that represent
    // specific stretches of text, and is used by the measuring code.
    // The returned object contains the DOM node, this map, and
    // information about line-wide styles that were set by the mode.
    function buildLineContent(cm, lineView) {
        // The padding-right forces the element to have a 'border', which
        // is needed on Webkit to be able to get line-level bounding
        // rectangles for it (in measureChar).
        var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
        var builder = {
            pre: eltP("pre", [
                content
            ], "CodeMirror-line"),
            content: content,
            col: 0,
            pos: 0,
            cm: cm,
            trailingSpace: false,
            splitSpaces: cm.getOption("lineWrapping")
        };
        lineView.measure = {};
        // Iterate over the logical lines that make up this visual line.
        for(var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++){
            var line = i ? lineView.rest[i - 1] : lineView.line, order = void 0;
            builder.pos = 0;
            builder.addToken = buildToken;
            // Optionally wire in some hacks into the token-rendering
            // algorithm, to deal with browser quirks.
            if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) {
                builder.addToken = buildTokenBadBidi(builder.addToken, order);
            }
            builder.map = [];
            var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
            insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
            if (line.styleClasses) {
                if (line.styleClasses.bgClass) {
                    builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
                }
                if (line.styleClasses.textClass) {
                    builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
                }
            }
            // Ensure at least a single node is present, for measuring.
            if (builder.map.length == 0) {
                builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
            }
            // Store the map and a cache object for the current logical line
            if (i == 0) {
                lineView.measure.map = builder.map;
                lineView.measure.cache = {};
            } else {
                (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
                (lineView.measure.caches || (lineView.measure.caches = [])).push({});
            }
        }
        // See issue #2901
        if (webkit) {
            var last = builder.content.lastChild;
            if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) {
                builder.content.className = "cm-tab-wrap-hack";
            }
        }
        signal(cm, "renderLine", cm, lineView.line, builder.pre);
        if (builder.pre.className) {
            builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
        }
        return builder;
    };
    var defaultSpecialCharPlaceholder = function defaultSpecialCharPlaceholder(ch) {
        var token = elt("span", "•", "cm-invalidchar");
        token.title = "\\u" + ch.charCodeAt(0).toString(16);
        token.setAttribute("aria-label", token.title);
        return token;
    };
    var buildToken = // Build up the DOM representation for a single token, and add it to
    // the line map. Takes care to render special characters separately.
    function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
        if (!text) {
            return;
        }
        var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
        var special = builder.cm.state.specialChars, mustWrap = false;
        var content;
        if (!special.test(text)) {
            builder.col += text.length;
            content = document.createTextNode(displayText);
            builder.map.push(builder.pos, builder.pos + text.length, content);
            if (ie && ie_version < 9) {
                mustWrap = true;
            }
            builder.pos += text.length;
        } else {
            content = document.createDocumentFragment();
            var pos = 0;
            while(true){
                special.lastIndex = pos;
                var m = special.exec(text);
                var skipped = m ? m.index - pos : text.length - pos;
                if (skipped) {
                    var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
                    if (ie && ie_version < 9) {
                        content.appendChild(elt("span", [
                            txt
                        ]));
                    } else {
                        content.appendChild(txt);
                    }
                    builder.map.push(builder.pos, builder.pos + skipped, txt);
                    builder.col += skipped;
                    builder.pos += skipped;
                }
                if (!m) {
                    break;
                }
                pos += skipped + 1;
                var txt$1 = void 0;
                if (m[0] == "	") {
                    var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
                    txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
                    txt$1.setAttribute("role", "presentation");
                    txt$1.setAttribute("cm-text", "	");
                    builder.col += tabWidth;
                } else if (m[0] == "\r" || m[0] == "\n") {
                    txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "␍" : "␤", "cm-invalidchar"));
                    txt$1.setAttribute("cm-text", m[0]);
                    builder.col += 1;
                } else {
                    txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
                    txt$1.setAttribute("cm-text", m[0]);
                    if (ie && ie_version < 9) {
                        content.appendChild(elt("span", [
                            txt$1
                        ]));
                    } else {
                        content.appendChild(txt$1);
                    }
                    builder.col += 1;
                }
                builder.map.push(builder.pos, builder.pos + 1, txt$1);
                builder.pos++;
            }
        }
        builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
        if (style || startStyle || endStyle || mustWrap || css || attributes) {
            var fullStyle = style || "";
            if (startStyle) {
                fullStyle += startStyle;
            }
            if (endStyle) {
                fullStyle += endStyle;
            }
            var token = elt("span", [
                content
            ], fullStyle, css);
            if (attributes) {
                for(var attr in attributes){
                    if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") {
                        token.setAttribute(attr, attributes[attr]);
                    }
                }
            }
            return builder.content.appendChild(token);
        }
        builder.content.appendChild(content);
    };
    var splitSpaces = // Change some spaces to NBSP to prevent the browser from collapsing
    // trailing spaces at the end of a line when rendering text (issue #1362).
    function splitSpaces(text, trailingBefore) {
        if (text.length > 1 && !/  /.test(text)) {
            return text;
        }
        var spaceBefore = trailingBefore, result = "";
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) {
                ch = "\xa0";
            }
            result += ch;
            spaceBefore = ch == " ";
        }
        return result;
    };
    var buildTokenBadBidi = // Work around nonsense dimensions being reported for stretches of
    // right-to-left text.
    function buildTokenBadBidi(inner, order) {
        return function(builder, text, style, startStyle, endStyle, css, attributes) {
            style = style ? style + " cm-force-border" : "cm-force-border";
            var start = builder.pos, end = start + text.length;
            for(;;){
                // Find the part that overlaps with the start of this text
                var part = void 0;
                for(var i = 0; i < order.length; i++){
                    part = order[i];
                    if (part.to > start && part.from <= start) {
                        break;
                    }
                }
                if (part.to >= end) {
                    return inner(builder, text, style, startStyle, endStyle, css, attributes);
                }
                inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
                startStyle = null;
                text = text.slice(part.to - start);
                start = part.to;
            }
        };
    };
    var buildCollapsedSpan = function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
        var widget = !ignoreWidget && marker.widgetNode;
        if (widget) {
            builder.map.push(builder.pos, builder.pos + size, widget);
        }
        if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
            if (!widget) {
                widget = builder.content.appendChild(document.createElement("span"));
            }
            widget.setAttribute("cm-marker", marker.id);
        }
        if (widget) {
            builder.cm.display.input.setUneditable(widget);
            builder.content.appendChild(widget);
        }
        builder.pos += size;
        builder.trailingSpace = false;
    };
    var insertLineContent = // Outputs a number of spans to make up a line, taking highlighting
    // and marked text into account.
    function insertLineContent(line, builder, styles) {
        var spans = line.markedSpans, allText = line.text, at = 0;
        if (!spans) {
            for(var i$1 = 1; i$1 < styles.length; i$1 += 2){
                builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
            }
            return;
        }
        var len = allText.length, pos = 0, i = 1, text = "", style, css;
        var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
        for(;;){
            if (nextChange == pos) {
                spanStyle = spanEndStyle = spanStartStyle = css = "";
                attributes = null;
                collapsed = null;
                nextChange = Infinity;
                var foundBookmarks = [], endStyles = void 0;
                for(var j = 0; j < spans.length; ++j){
                    var sp = spans[j], m = sp.marker;
                    if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
                        foundBookmarks.push(m);
                    } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
                        if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                            nextChange = sp.to;
                            spanEndStyle = "";
                        }
                        if (m.className) {
                            spanStyle += " " + m.className;
                        }
                        if (m.css) {
                            css = (css ? css + ";" : "") + m.css;
                        }
                        if (m.startStyle && sp.from == pos) {
                            spanStartStyle += " " + m.startStyle;
                        }
                        if (m.endStyle && sp.to == nextChange) {
                            (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
                        }
                        // support for the old title property
                        // https://github.com/codemirror/CodeMirror/pull/5673
                        if (m.title) {
                            (attributes || (attributes = {})).title = m.title;
                        }
                        if (m.attributes) {
                            for(var attr in m.attributes){
                                (attributes || (attributes = {}))[attr] = m.attributes[attr];
                            }
                        }
                        if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) {
                            collapsed = sp;
                        }
                    } else if (sp.from > pos && nextChange > sp.from) {
                        nextChange = sp.from;
                    }
                }
                if (endStyles) {
                    for(var j$1 = 0; j$1 < endStyles.length; j$1 += 2){
                        if (endStyles[j$1 + 1] == nextChange) {
                            spanEndStyle += " " + endStyles[j$1];
                        }
                    }
                }
                if (!collapsed || collapsed.from == pos) {
                    for(var j$2 = 0; j$2 < foundBookmarks.length; ++j$2){
                        buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
                    }
                }
                if (collapsed && (collapsed.from || 0) == pos) {
                    buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
                    if (collapsed.to == null) {
                        return;
                    }
                    if (collapsed.to == pos) {
                        collapsed = false;
                    }
                }
            }
            if (pos >= len) {
                break;
            }
            var upto = Math.min(len, nextChange);
            while(true){
                if (text) {
                    var end = pos + text.length;
                    if (!collapsed) {
                        var tokenText = end > upto ? text.slice(0, upto - pos) : text;
                        builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
                    }
                    if (end >= upto) {
                        text = text.slice(upto - pos);
                        pos = upto;
                        break;
                    }
                    pos = end;
                    spanStartStyle = "";
                }
                text = allText.slice(at, at = styles[i++]);
                style = interpretTokenStyle(styles[i++], builder.cm.options);
            }
        }
    };
    var LineView = // These objects are used to represent the visible (currently drawn)
    // part of the document. A LineView may correspond to multiple
    // logical lines, if those are connected by collapsed ranges.
    function LineView(doc, line, lineN) {
        // The starting line
        this.line = line;
        // Continuing lines, if any
        this.rest = visualLineContinued(line);
        // Number of logical lines in this visual line
        this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
        this.node = this.text = null;
        this.hidden = lineIsHidden(doc, line);
    };
    var buildViewArray = // Create a range of LineView objects for the given lines.
    function buildViewArray(cm, from, to) {
        var array = [], nextPos;
        for(var pos = from; pos < to; pos = nextPos){
            var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
            nextPos = pos + view.size;
            array.push(view);
        }
        return array;
    };
    var pushOperation = function pushOperation(op) {
        if (operationGroup) {
            operationGroup.ops.push(op);
        } else {
            op.ownsGroup = operationGroup = {
                ops: [
                    op
                ],
                delayedCallbacks: []
            };
        }
    };
    var fireCallbacksForOps = function fireCallbacksForOps(group) {
        // Calls delayed callbacks and cursorActivity handlers until no
        // new ones appear
        var callbacks = group.delayedCallbacks, i = 0;
        do {
            for(; i < callbacks.length; i++){
                callbacks[i].call(null);
            }
            for(var j = 0; j < group.ops.length; j++){
                var op = group.ops[j];
                if (op.cursorActivityHandlers) {
                    while(op.cursorActivityCalled < op.cursorActivityHandlers.length){
                        op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
                    }
                }
            }
        }while (i < callbacks.length);
    };
    var finishOperation = function finishOperation(op, endCb) {
        var group = op.ownsGroup;
        if (!group) {
            return;
        }
        try {
            fireCallbacksForOps(group);
        } finally{
            operationGroup = null;
            endCb(group);
        }
    };
    var signalLater = // Often, we want to signal events at a point where we are in the
    // middle of some work, but don't want the handler to start calling
    // other methods on the editor, which might be in an inconsistent
    // state or simply not expect any other events to happen.
    // signalLater looks whether there are any handlers, and schedules
    // them to be executed when the last operation ends, or, if no
    // operation is active, when a timeout fires.
    function signalLater(emitter, type /*, values...*/ ) {
        var arr = getHandlers(emitter, type);
        if (!arr.length) {
            return;
        }
        var args = Array.prototype.slice.call(arguments, 2), list;
        if (operationGroup) {
            list = operationGroup.delayedCallbacks;
        } else if (orphanDelayedCallbacks) {
            list = orphanDelayedCallbacks;
        } else {
            list = orphanDelayedCallbacks = [];
            setTimeout(fireOrphanDelayed, 0);
        }
        var loop = function loop(i) {
            list.push(function() {
                return arr[i].apply(null, args);
            });
        };
        for(var i = 0; i < arr.length; ++i)loop(i);
    };
    var fireOrphanDelayed = function fireOrphanDelayed() {
        var delayed = orphanDelayedCallbacks;
        orphanDelayedCallbacks = null;
        for(var i = 0; i < delayed.length; ++i){
            delayed[i]();
        }
    };
    var updateLineForChanges = // When an aspect of a line changes, a string is added to
    // lineView.changes. This updates the relevant part of the line's
    // DOM structure.
    function updateLineForChanges(cm, lineView, lineN, dims) {
        for(var j = 0; j < lineView.changes.length; j++){
            var type = lineView.changes[j];
            if (type == "text") {
                updateLineText(cm, lineView);
            } else if (type == "gutter") {
                updateLineGutter(cm, lineView, lineN, dims);
            } else if (type == "class") {
                updateLineClasses(cm, lineView);
            } else if (type == "widget") {
                updateLineWidgets(cm, lineView, dims);
            }
        }
        lineView.changes = null;
    };
    var ensureLineWrapped = // Lines with gutter elements, widgets or a background class need to
    // be wrapped, and have the extra elements added to the wrapper div
    function ensureLineWrapped(lineView) {
        if (lineView.node == lineView.text) {
            lineView.node = elt("div", null, null, "position: relative");
            if (lineView.text.parentNode) {
                lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
            }
            lineView.node.appendChild(lineView.text);
            if (ie && ie_version < 8) {
                lineView.node.style.zIndex = 2;
            }
        }
        return lineView.node;
    };
    var updateLineBackground = function updateLineBackground(cm, lineView) {
        var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
        if (cls) {
            cls += " CodeMirror-linebackground";
        }
        if (lineView.background) {
            if (cls) {
                lineView.background.className = cls;
            } else {
                lineView.background.parentNode.removeChild(lineView.background);
                lineView.background = null;
            }
        } else if (cls) {
            var wrap = ensureLineWrapped(lineView);
            lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
            cm.display.input.setUneditable(lineView.background);
        }
    };
    var getLineContent = // Wrapper around buildLineContent which will reuse the structure
    // in display.externalMeasured when possible.
    function getLineContent(cm, lineView) {
        var ext = cm.display.externalMeasured;
        if (ext && ext.line == lineView.line) {
            cm.display.externalMeasured = null;
            lineView.measure = ext.measure;
            return ext.built;
        }
        return buildLineContent(cm, lineView);
    };
    var updateLineText = // Redraw the line's text. Interacts with the background and text
    // classes because the mode may output tokens that influence these
    // classes.
    function updateLineText(cm, lineView) {
        var cls = lineView.text.className;
        var built = getLineContent(cm, lineView);
        if (lineView.text == lineView.node) {
            lineView.node = built.pre;
        }
        lineView.text.parentNode.replaceChild(built.pre, lineView.text);
        lineView.text = built.pre;
        if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
            lineView.bgClass = built.bgClass;
            lineView.textClass = built.textClass;
            updateLineClasses(cm, lineView);
        } else if (cls) {
            lineView.text.className = cls;
        }
    };
    var updateLineClasses = function updateLineClasses(cm, lineView) {
        updateLineBackground(cm, lineView);
        if (lineView.line.wrapClass) {
            ensureLineWrapped(lineView).className = lineView.line.wrapClass;
        } else if (lineView.node != lineView.text) {
            lineView.node.className = "";
        }
        var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
        lineView.text.className = textClass || "";
    };
    var updateLineGutter = function updateLineGutter(cm, lineView, lineN, dims) {
        if (lineView.gutter) {
            lineView.node.removeChild(lineView.gutter);
            lineView.gutter = null;
        }
        if (lineView.gutterBackground) {
            lineView.node.removeChild(lineView.gutterBackground);
            lineView.gutterBackground = null;
        }
        if (lineView.line.gutterClass) {
            var wrap = ensureLineWrapped(lineView);
            lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
            cm.display.input.setUneditable(lineView.gutterBackground);
            wrap.insertBefore(lineView.gutterBackground, lineView.text);
        }
        var markers = lineView.line.gutterMarkers;
        if (cm.options.lineNumbers || markers) {
            var wrap$1 = ensureLineWrapped(lineView);
            var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
            gutterWrap.setAttribute("aria-hidden", "true");
            cm.display.input.setUneditable(gutterWrap);
            wrap$1.insertBefore(gutterWrap, lineView.text);
            if (lineView.line.gutterClass) {
                gutterWrap.className += " " + lineView.line.gutterClass;
            }
            if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) {
                lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
            }
            if (markers) {
                for(var k = 0; k < cm.display.gutterSpecs.length; ++k){
                    var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
                    if (found) {
                        gutterWrap.appendChild(elt("div", [
                            found
                        ], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
                    }
                }
            }
        }
    };
    var updateLineWidgets = function updateLineWidgets(cm, lineView, dims) {
        if (lineView.alignable) {
            lineView.alignable = null;
        }
        var isWidget = classTest("CodeMirror-linewidget");
        for(var node = lineView.node.firstChild, next = void 0; node; node = next){
            next = node.nextSibling;
            if (isWidget.test(node.className)) {
                lineView.node.removeChild(node);
            }
        }
        insertLineWidgets(cm, lineView, dims);
    };
    var buildLineElement = // Build a line's DOM representation from scratch
    function buildLineElement(cm, lineView, lineN, dims) {
        var built = getLineContent(cm, lineView);
        lineView.text = lineView.node = built.pre;
        if (built.bgClass) {
            lineView.bgClass = built.bgClass;
        }
        if (built.textClass) {
            lineView.textClass = built.textClass;
        }
        updateLineClasses(cm, lineView);
        updateLineGutter(cm, lineView, lineN, dims);
        insertLineWidgets(cm, lineView, dims);
        return lineView.node;
    };
    var insertLineWidgets = // A lineView may contain multiple logical lines (when merged by
    // collapsed spans). The widgets for all of them need to be drawn.
    function insertLineWidgets(cm, lineView, dims) {
        insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
        if (lineView.rest) {
            for(var i = 0; i < lineView.rest.length; i++){
                insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
            }
        }
    };
    var insertLineWidgetsFor = function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
        if (!line.widgets) {
            return;
        }
        var wrap = ensureLineWrapped(lineView);
        for(var i = 0, ws = line.widgets; i < ws.length; ++i){
            var widget = ws[i], node = elt("div", [
                widget.node
            ], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
            if (!widget.handleMouseEvents) {
                node.setAttribute("cm-ignore-events", "true");
            }
            positionLineWidget(widget, node, lineView, dims);
            cm.display.input.setUneditable(node);
            if (allowAbove && widget.above) {
                wrap.insertBefore(node, lineView.gutter || lineView.text);
            } else {
                wrap.appendChild(node);
            }
            signalLater(widget, "redraw");
        }
    };
    var positionLineWidget = function positionLineWidget(widget, node, lineView, dims) {
        if (widget.noHScroll) {
            (lineView.alignable || (lineView.alignable = [])).push(node);
            var width = dims.wrapperWidth;
            node.style.left = dims.fixedPos + "px";
            if (!widget.coverGutter) {
                width -= dims.gutterTotalWidth;
                node.style.paddingLeft = dims.gutterTotalWidth + "px";
            }
            node.style.width = width + "px";
        }
        if (widget.coverGutter) {
            node.style.zIndex = 5;
            node.style.position = "relative";
            if (!widget.noHScroll) {
                node.style.marginLeft = -dims.gutterTotalWidth + "px";
            }
        }
    };
    var widgetHeight = function widgetHeight(widget) {
        if (widget.height != null) {
            return widget.height;
        }
        var cm = widget.doc.cm;
        if (!cm) {
            return 0;
        }
        if (!contains(document.body, widget.node)) {
            var parentStyle = "position: relative;";
            if (widget.coverGutter) {
                parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
            }
            if (widget.noHScroll) {
                parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
            }
            removeChildrenAndAdd(cm.display.measure, elt("div", [
                widget.node
            ], null, parentStyle));
        }
        return widget.height = widget.node.parentNode.offsetHeight;
    };
    var eventInWidget = // Return true when the given mouse event happened in a widget
    function eventInWidget(display, e) {
        for(var n = e_target(e); n != display.wrapper; n = n.parentNode){
            if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) {
                return true;
            }
        }
    };
    var paddingTop = // POSITION MEASUREMENT
    function paddingTop(display) {
        return display.lineSpace.offsetTop;
    };
    var paddingVert = function paddingVert(display) {
        return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    };
    var paddingH = function paddingH(display) {
        if (display.cachedPaddingH) {
            return display.cachedPaddingH;
        }
        var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
        var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
        var data = {
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        };
        if (!isNaN(data.left) && !isNaN(data.right)) {
            display.cachedPaddingH = data;
        }
        return data;
    };
    var scrollGap = function scrollGap(cm) {
        return scrollerGap - cm.display.nativeBarWidth;
    };
    var displayWidth = function displayWidth(cm) {
        return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    };
    var displayHeight = function displayHeight(cm) {
        return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    };
    var ensureLineHeights = // Ensure the lineView.wrapping.heights array is populated. This is
    // an array of bottom offsets for the lines that make up a drawn
    // line. When lineWrapping is on, there might be more than one
    // height.
    function ensureLineHeights(cm, lineView, rect) {
        var wrapping = cm.options.lineWrapping;
        var curWidth = wrapping && displayWidth(cm);
        if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
            var heights = lineView.measure.heights = [];
            if (wrapping) {
                lineView.measure.width = curWidth;
                var rects = lineView.text.firstChild.getClientRects();
                for(var i = 0; i < rects.length - 1; i++){
                    var cur = rects[i], next = rects[i + 1];
                    if (Math.abs(cur.bottom - next.bottom) > 2) {
                        heights.push((cur.bottom + next.top) / 2 - rect.top);
                    }
                }
            }
            heights.push(rect.bottom - rect.top);
        }
    };
    var mapFromLineView = // Find a line map (mapping character offsets to text nodes) and a
    // measurement cache for the given line number. (A line view might
    // contain multiple lines when collapsed ranges are present.)
    function mapFromLineView(lineView, line, lineN) {
        if (lineView.line == line) {
            return {
                map: lineView.measure.map,
                cache: lineView.measure.cache
            };
        }
        if (lineView.rest) {
            for(var i = 0; i < lineView.rest.length; i++){
                if (lineView.rest[i] == line) {
                    return {
                        map: lineView.measure.maps[i],
                        cache: lineView.measure.caches[i]
                    };
                }
            }
            for(var i$1 = 0; i$1 < lineView.rest.length; i$1++){
                if (lineNo(lineView.rest[i$1]) > lineN) {
                    return {
                        map: lineView.measure.maps[i$1],
                        cache: lineView.measure.caches[i$1],
                        before: true
                    };
                }
            }
        }
    };
    var updateExternalMeasurement = // Render a line into the hidden node display.externalMeasured. Used
    // when measurement is needed for a line that's not in the viewport.
    function updateExternalMeasurement(cm, line) {
        line = visualLine(line);
        var lineN = lineNo(line);
        var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
        view.lineN = lineN;
        var built = view.built = buildLineContent(cm, view);
        view.text = built.pre;
        removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
        return view;
    };
    var measureChar = // Get a {top, bottom, left, right} box (in line-local coordinates)
    // for a given character.
    function measureChar(cm, line, ch, bias) {
        return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    };
    var findViewForLine = // Find a line view that corresponds to the given line number.
    function findViewForLine(cm, lineN) {
        if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) {
            return cm.display.view[findViewIndex(cm, lineN)];
        }
        var ext = cm.display.externalMeasured;
        if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) {
            return ext;
        }
    };
    var prepareMeasureForLine = // Measurement can be split in two steps, the set-up work that
    // applies to the whole line, and the measurement of the actual
    // character. Functions like coordsChar, that need to do a lot of
    // measurements in a row, can thus ensure that the set-up work is
    // only done once.
    function prepareMeasureForLine(cm, line) {
        var lineN = lineNo(line);
        var view = findViewForLine(cm, lineN);
        if (view && !view.text) {
            view = null;
        } else if (view && view.changes) {
            updateLineForChanges(cm, view, lineN, getDimensions(cm));
            cm.curOp.forceUpdate = true;
        }
        if (!view) {
            view = updateExternalMeasurement(cm, line);
        }
        var info = mapFromLineView(view, line, lineN);
        return {
            line: line,
            view: view,
            rect: null,
            map: info.map,
            cache: info.cache,
            before: info.before,
            hasHeights: false
        };
    };
    var measureCharPrepared = // Given a prepared measurement object, measures the position of an
    // actual character (or fetches it from the cache).
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
        if (prepared.before) {
            ch = -1;
        }
        var key = ch + (bias || ""), found;
        if (prepared.cache.hasOwnProperty(key)) {
            found = prepared.cache[key];
        } else {
            if (!prepared.rect) {
                prepared.rect = prepared.view.text.getBoundingClientRect();
            }
            if (!prepared.hasHeights) {
                ensureLineHeights(cm, prepared.view, prepared.rect);
                prepared.hasHeights = true;
            }
            found = measureCharInner(cm, prepared, ch, bias);
            if (!found.bogus) {
                prepared.cache[key] = found;
            }
        }
        return {
            left: found.left,
            right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom
        };
    };
    var nodeAndOffsetInLineMap = function nodeAndOffsetInLineMap(map, ch, bias) {
        var node, start, end, collapse, mStart, mEnd;
        // First, search the line map for the text node corresponding to,
        // or closest to, the target character.
        for(var i = 0; i < map.length; i += 3){
            mStart = map[i];
            mEnd = map[i + 1];
            if (ch < mStart) {
                start = 0;
                end = 1;
                collapse = "left";
            } else if (ch < mEnd) {
                start = ch - mStart;
                end = start + 1;
            } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
                end = mEnd - mStart;
                start = end - 1;
                if (ch >= mEnd) {
                    collapse = "right";
                }
            }
            if (start != null) {
                node = map[i + 2];
                if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) {
                    collapse = bias;
                }
                if (bias == "left" && start == 0) {
                    while(i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft){
                        node = map[(i -= 3) + 2];
                        collapse = "left";
                    }
                }
                if (bias == "right" && start == mEnd - mStart) {
                    while(i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft){
                        node = map[(i += 3) + 2];
                        collapse = "right";
                    }
                }
                break;
            }
        }
        return {
            node: node,
            start: start,
            end: end,
            collapse: collapse,
            coverStart: mStart,
            coverEnd: mEnd
        };
    };
    var getUsefulRect = function getUsefulRect(rects, bias) {
        var rect = nullRect;
        if (bias == "left") {
            for(var i = 0; i < rects.length; i++){
                if ((rect = rects[i]).left != rect.right) {
                    break;
                }
            }
        } else {
            for(var i$1 = rects.length - 1; i$1 >= 0; i$1--){
                if ((rect = rects[i$1]).left != rect.right) {
                    break;
                }
            }
        }
        return rect;
    };
    var measureCharInner = function measureCharInner(cm, prepared, ch, bias) {
        var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
        var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
        var rect;
        if (node.nodeType == 3) {
            for(var i$1 = 0; i$1 < 4; i$1++){
                while(start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))){
                    --start;
                }
                while(place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))){
                    ++end;
                }
                if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) {
                    rect = node.parentNode.getBoundingClientRect();
                } else {
                    rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
                }
                if (rect.left || rect.right || start == 0) {
                    break;
                }
                end = start;
                start = start - 1;
                collapse = "right";
            }
            if (ie && ie_version < 11) {
                rect = maybeUpdateRectForZooming(cm.display.measure, rect);
            }
        } else {
            if (start > 0) {
                collapse = bias = "right";
            }
            var rects;
            if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) {
                rect = rects[bias == "right" ? rects.length - 1 : 0];
            } else {
                rect = node.getBoundingClientRect();
            }
        }
        if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
            var rSpan = node.parentNode.getClientRects()[0];
            if (rSpan) {
                rect = {
                    left: rSpan.left,
                    right: rSpan.left + charWidth(cm.display),
                    top: rSpan.top,
                    bottom: rSpan.bottom
                };
            } else {
                rect = nullRect;
            }
        }
        var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
        var mid = (rtop + rbot) / 2;
        var heights = prepared.view.measure.heights;
        var i = 0;
        for(; i < heights.length - 1; i++){
            if (mid < heights[i]) {
                break;
            }
        }
        var top = i ? heights[i - 1] : 0, bot = heights[i];
        var result = {
            left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
            right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
            top: top,
            bottom: bot
        };
        if (!rect.left && !rect.right) {
            result.bogus = true;
        }
        if (!cm.options.singleCursorHeightPerLine) {
            result.rtop = rtop;
            result.rbottom = rbot;
        }
        return result;
    };
    var maybeUpdateRectForZooming = // Work around problem with bounding client rects on ranges being
    // returned incorrectly when zoomed on IE10 and below.
    function maybeUpdateRectForZooming(measure, rect) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) {
            return rect;
        }
        var scaleX = screen.logicalXDPI / screen.deviceXDPI;
        var scaleY = screen.logicalYDPI / screen.deviceYDPI;
        return {
            left: rect.left * scaleX,
            right: rect.right * scaleX,
            top: rect.top * scaleY,
            bottom: rect.bottom * scaleY
        };
    };
    var clearLineMeasurementCacheFor = function clearLineMeasurementCacheFor(lineView) {
        if (lineView.measure) {
            lineView.measure.cache = {};
            lineView.measure.heights = null;
            if (lineView.rest) {
                for(var i = 0; i < lineView.rest.length; i++){
                    lineView.measure.caches[i] = {};
                }
            }
        }
    };
    var clearLineMeasurementCache = function clearLineMeasurementCache(cm) {
        cm.display.externalMeasure = null;
        removeChildren(cm.display.lineMeasure);
        for(var i = 0; i < cm.display.view.length; i++){
            clearLineMeasurementCacheFor(cm.display.view[i]);
        }
    };
    var clearCaches = function clearCaches(cm) {
        clearLineMeasurementCache(cm);
        cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
        if (!cm.options.lineWrapping) {
            cm.display.maxLineChanged = true;
        }
        cm.display.lineNumChars = null;
    };
    var pageScrollX = function pageScrollX() {
        // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
        // which causes page_Offset and bounding client rects to use
        // different reference viewports and invalidate our calculations.
        if (chrome && android) {
            return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft));
        }
        return window.pageXOffset || (document.documentElement || document.body).scrollLeft;
    };
    var pageScrollY = function pageScrollY() {
        if (chrome && android) {
            return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop));
        }
        return window.pageYOffset || (document.documentElement || document.body).scrollTop;
    };
    var widgetTopHeight = function widgetTopHeight(lineObj) {
        var height = 0;
        if (lineObj.widgets) {
            for(var i = 0; i < lineObj.widgets.length; ++i){
                if (lineObj.widgets[i].above) {
                    height += widgetHeight(lineObj.widgets[i]);
                }
            }
        }
        return height;
    };
    var intoCoordSystem = // Converts a {top, bottom, left, right} box from line-local
    // coordinates into another coordinate system. Context may be one of
    // "line", "div" (display.lineDiv), "local"./null (editor), "window",
    // or "page".
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
        if (!includeWidgets) {
            var height = widgetTopHeight(lineObj);
            rect.top += height;
            rect.bottom += height;
        }
        if (context == "line") {
            return rect;
        }
        if (!context) {
            context = "local";
        }
        var yOff = heightAtLine(lineObj);
        if (context == "local") {
            yOff += paddingTop(cm.display);
        } else {
            yOff -= cm.display.viewOffset;
        }
        if (context == "page" || context == "window") {
            var lOff = cm.display.lineSpace.getBoundingClientRect();
            yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
            var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
            rect.left += xOff;
            rect.right += xOff;
        }
        rect.top += yOff;
        rect.bottom += yOff;
        return rect;
    };
    var fromCoordSystem = // Coverts a box from "div" coords to another coordinate system.
    // Context may be "window", "page", "div", or "local"./null.
    function fromCoordSystem(cm, coords, context) {
        if (context == "div") {
            return coords;
        }
        var left = coords.left, top = coords.top;
        // First move into "page" coordinate system
        if (context == "page") {
            left -= pageScrollX();
            top -= pageScrollY();
        } else if (context == "local" || !context) {
            var localBox = cm.display.sizer.getBoundingClientRect();
            left += localBox.left;
            top += localBox.top;
        }
        var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
        return {
            left: left - lineSpaceBox.left,
            top: top - lineSpaceBox.top
        };
    };
    var charCoords = function charCoords(cm, pos, context, lineObj, bias) {
        if (!lineObj) {
            lineObj = getLine(cm.doc, pos.line);
        }
        return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    };
    var cursorCoords = // Returns a box for a given cursor position, which may have an
    // 'other' property containing the position of the secondary cursor
    // on a bidi boundary.
    // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
    // and after `char - 1` in writing order of `char - 1`
    // A cursor Pos(line, char, "after") is on the same visual line as `char`
    // and before `char` in writing order of `char`
    // Examples (upper-case letters are RTL, lower-case are LTR):
    //     Pos(0, 1, ...)
    //     before   after
    // ab     a|b     a|b
    // aB     a|B     aB|
    // Ab     |Ab     A|b
    // AB     B|A     B|A
    // Every position after the last character on a line is considered to stick
    // to the last character on the line.
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
        lineObj = lineObj || getLine(cm.doc, pos.line);
        if (!preparedMeasure) {
            preparedMeasure = prepareMeasureForLine(cm, lineObj);
        }
        function get(ch, right) {
            var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
            if (right) {
                m.left = m.right;
            } else {
                m.right = m.left;
            }
            return intoCoordSystem(cm, lineObj, m, context);
        }
        var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
        if (ch >= lineObj.text.length) {
            ch = lineObj.text.length;
            sticky = "before";
        } else if (ch <= 0) {
            ch = 0;
            sticky = "after";
        }
        if (!order) {
            return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
        }
        function getBidi(ch, partPos, invert) {
            var part = order[partPos], right = part.level == 1;
            return get(invert ? ch - 1 : ch, right != invert);
        }
        var partPos = getBidiPartAt(order, ch, sticky);
        var other = bidiOther;
        var val = getBidi(ch, partPos, sticky == "before");
        if (other != null) {
            val.other = getBidi(ch, other, sticky != "before");
        }
        return val;
    };
    var estimateCoords = // Used to cheaply estimate the coordinates for a position. Used for
    // intermediate scroll updates.
    function estimateCoords(cm, pos) {
        var left = 0;
        pos = clipPos(cm.doc, pos);
        if (!cm.options.lineWrapping) {
            left = charWidth(cm.display) * pos.ch;
        }
        var lineObj = getLine(cm.doc, pos.line);
        var top = heightAtLine(lineObj) + paddingTop(cm.display);
        return {
            left: left,
            right: left,
            top: top,
            bottom: top + lineObj.height
        };
    };
    var PosWithInfo = // Positions returned by coordsChar contain some extra information.
    // xRel is the relative x position of the input coordinates compared
    // to the found position (so xRel > 0 means the coordinates are to
    // the right of the character position, for example). When outside
    // is true, that means the coordinates lie outside the line's
    // vertical range.
    function PosWithInfo(line, ch, sticky, outside, xRel) {
        var pos = Pos(line, ch, sticky);
        pos.xRel = xRel;
        if (outside) {
            pos.outside = outside;
        }
        return pos;
    };
    var coordsChar = // Compute the character position closest to the given coordinates.
    // Input must be lineSpace-local ("div" coordinate system).
    function coordsChar(cm, x, y) {
        var doc = cm.doc;
        y += cm.display.viewOffset;
        if (y < 0) {
            return PosWithInfo(doc.first, 0, null, -1, -1);
        }
        var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
        if (lineN > last) {
            return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
        }
        if (x < 0) {
            x = 0;
        }
        var lineObj = getLine(doc, lineN);
        for(;;){
            var found = coordsCharInner(cm, lineObj, lineN, x, y);
            var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
            if (!collapsed) {
                return found;
            }
            var rangeEnd = collapsed.find(1);
            if (rangeEnd.line == lineN) {
                return rangeEnd;
            }
            lineObj = getLine(doc, lineN = rangeEnd.line);
        }
    };
    var wrappedLineExtent = function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
        y -= widgetTopHeight(lineObj);
        var end = lineObj.text.length;
        var begin = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
        }, end, 0);
        end = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch).top > y;
        }, begin, end);
        return {
            begin: begin,
            end: end
        };
    };
    var wrappedLineExtentChar = function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
        if (!preparedMeasure) {
            preparedMeasure = prepareMeasureForLine(cm, lineObj);
        }
        var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
        return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    };
    var boxIsAfter = // Returns true if the given side of a box is after the given
    // coordinates, in top-to-bottom, left-to-right order.
    function boxIsAfter(box, x, y, left) {
        return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    };
    var coordsCharInner = function coordsCharInner(cm, lineObj, lineNo, x, y) {
        // Move y into line-local coordinate space
        y -= heightAtLine(lineObj);
        var preparedMeasure = prepareMeasureForLine(cm, lineObj);
        // When directly calling `measureCharPrepared`, we have to adjust
        // for the widgets at this line.
        var widgetHeight = widgetTopHeight(lineObj);
        var begin = 0, end = lineObj.text.length, ltr = true;
        var order = getOrder(lineObj, cm.doc.direction);
        // If the line isn't plain left-to-right text, first figure out
        // which bidi section the coordinates fall into.
        if (order) {
            var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
            ltr = part.level != 1;
            // The awkward -1 offsets are needed because findFirst (called
            // on these below) will treat its first bound as inclusive,
            // second as exclusive, but we want to actually address the
            // characters in the part's range
            begin = ltr ? part.from : part.to - 1;
            end = ltr ? part.to : part.from - 1;
        }
        // A binary search to find the first character whose bounding box
        // starts after the coordinates. If we run across any whose box wrap
        // the coordinates, store that.
        var chAround = null, boxAround = null;
        var ch = findFirst(function(ch) {
            var box = measureCharPrepared(cm, preparedMeasure, ch);
            box.top += widgetHeight;
            box.bottom += widgetHeight;
            if (!boxIsAfter(box, x, y, false)) {
                return false;
            }
            if (box.top <= y && box.left <= x) {
                chAround = ch;
                boxAround = box;
            }
            return true;
        }, begin, end);
        var baseX, sticky, outside = false;
        // If a box around the coordinates was found, use that
        if (boxAround) {
            // Distinguish coordinates nearer to the left or right side of the box
            var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
            ch = chAround + (atStart ? 0 : 1);
            sticky = atStart ? "after" : "before";
            baseX = atLeft ? boxAround.left : boxAround.right;
        } else {
            // (Adjust for extended bound, if necessary.)
            if (!ltr && (ch == end || ch == begin)) {
                ch++;
            }
            // To determine which side to associate with, get the box to the
            // left of the character and compare it's vertical position to the
            // coordinates
            sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
            // Now get accurate coordinates for this place, in order to get a
            // base X position
            var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
            baseX = coords.left;
            outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
        }
        ch = skipExtendingChars(lineObj.text, ch, 1);
        return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
    };
    var coordsBidiPart = function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
        // Bidi parts are sorted left-to-right, and in a non-line-wrapping
        // situation, we can take this ordering to correspond to the visual
        // ordering. This finds the first part whose end is after the given
        // coordinates.
        var index = findFirst(function(i) {
            var part = order[i], ltr = part.level != 1;
            return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
        }, 0, order.length - 1);
        var part = order[index];
        // If this isn't the first part, the part's start is also after
        // the coordinates, and the coordinates aren't on the same line as
        // that start, move one part back.
        if (index > 0) {
            var ltr = part.level != 1;
            var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
            if (boxIsAfter(start, x, y, true) && start.top > y) {
                part = order[index - 1];
            }
        }
        return part;
    };
    var coordsBidiPartWrapped = function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
        // In a wrapped line, rtl text on wrapping boundaries can do things
        // that don't correspond to the ordering in our `order` array at
        // all, so a binary search doesn't work, and we want to return a
        // part that only spans one line so that the binary search in
        // coordsCharInner is safe. As such, we first find the extent of the
        // wrapped line, and then do a flat search in which we discard any
        // spans that aren't on the line.
        var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
        var begin = ref.begin;
        var end = ref.end;
        if (/\s/.test(lineObj.text.charAt(end - 1))) {
            end--;
        }
        var part = null, closestDist = null;
        for(var i = 0; i < order.length; i++){
            var p = order[i];
            if (p.from >= end || p.to <= begin) {
                continue;
            }
            var ltr = p.level != 1;
            var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
            // Weigh against spans ending before this, so that they are only
            // picked if nothing ends after
            var dist = endX < x ? x - endX + 1e9 : endX - x;
            if (!part || closestDist > dist) {
                part = p;
                closestDist = dist;
            }
        }
        if (!part) {
            part = order[order.length - 1];
        }
        // Clip the part to the wrapped line.
        if (part.from < begin) {
            part = {
                from: begin,
                to: part.to,
                level: part.level
            };
        }
        if (part.to > end) {
            part = {
                from: part.from,
                to: end,
                level: part.level
            };
        }
        return part;
    };
    var textHeight = // Compute the default text height.
    function textHeight(display) {
        if (display.cachedTextHeight != null) {
            return display.cachedTextHeight;
        }
        if (measureText == null) {
            measureText = elt("pre", null, "CodeMirror-line-like");
            // Measure a bunch of lines, for browsers that compute
            // fractional heights.
            for(var i = 0; i < 49; ++i){
                measureText.appendChild(document.createTextNode("x"));
                measureText.appendChild(elt("br"));
            }
            measureText.appendChild(document.createTextNode("x"));
        }
        removeChildrenAndAdd(display.measure, measureText);
        var height = measureText.offsetHeight / 50;
        if (height > 3) {
            display.cachedTextHeight = height;
        }
        removeChildren(display.measure);
        return height || 1;
    };
    var charWidth = // Compute the default character width.
    function charWidth(display) {
        if (display.cachedCharWidth != null) {
            return display.cachedCharWidth;
        }
        var anchor = elt("span", "xxxxxxxxxx");
        var pre = elt("pre", [
            anchor
        ], "CodeMirror-line-like");
        removeChildrenAndAdd(display.measure, pre);
        var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
        if (width > 2) {
            display.cachedCharWidth = width;
        }
        return width || 10;
    };
    var getDimensions = // Do a bulk-read of the DOM positions and sizes needed to draw the
    // view, so that we don't interleave reading and writing to the DOM.
    function getDimensions(cm) {
        var d = cm.display, left = {}, width = {};
        var gutterLeft = d.gutters.clientLeft;
        for(var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i){
            var id = cm.display.gutterSpecs[i].className;
            left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
            width[id] = n.clientWidth;
        }
        return {
            fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth
        };
    };
    var compensateForHScroll = // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
    // but using getBoundingClientRect to get a sub-pixel-accurate
    // result.
    function compensateForHScroll(display) {
        return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    };
    var estimateHeight = // Returns a function that estimates the height of a line, to use as
    // first approximation until the line becomes visible (and is thus
    // properly measurable).
    function estimateHeight(cm) {
        var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
        var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
        return function(line) {
            if (lineIsHidden(cm.doc, line)) {
                return 0;
            }
            var widgetsHeight = 0;
            if (line.widgets) {
                for(var i = 0; i < line.widgets.length; i++){
                    if (line.widgets[i].height) {
                        widgetsHeight += line.widgets[i].height;
                    }
                }
            }
            if (wrapping) {
                return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
            } else {
                return widgetsHeight + th;
            }
        };
    };
    var estimateLineHeights = function estimateLineHeights(cm) {
        var doc = cm.doc, est = estimateHeight(cm);
        doc.iter(function(line) {
            var estHeight = est(line);
            if (estHeight != line.height) {
                updateLineHeight(line, estHeight);
            }
        });
    };
    var posFromMouse = // Given a mouse event, find the corresponding position. If liberal
    // is false, it checks whether a gutter or scrollbar was clicked,
    // and returns null if it was. forRect is used by rectangular
    // selections, and tries to estimate a character position even for
    // coordinates beyond the right of the text.
    function posFromMouse(cm, e, liberal, forRect) {
        var display = cm.display;
        if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") {
            return null;
        }
        var x, y, space = display.lineSpace.getBoundingClientRect();
        // Fails unpredictably on IE[67] when mouse is dragged around quickly.
        try {
            x = e.clientX - space.left;
            y = e.clientY - space.top;
        } catch (e$1) {
            return null;
        }
        var coords = coordsChar(cm, x, y), line;
        if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
            var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
            coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
        }
        return coords;
    };
    var findViewIndex = // Find the view element corresponding to a given line. Return null
    // when the line isn't visible.
    function findViewIndex(cm, n) {
        if (n >= cm.display.viewTo) {
            return null;
        }
        n -= cm.display.viewFrom;
        if (n < 0) {
            return null;
        }
        var view = cm.display.view;
        for(var i = 0; i < view.length; i++){
            n -= view[i].size;
            if (n < 0) {
                return i;
            }
        }
    };
    var regChange = // Updates the display.view data structure for a given change to the
    // document. From and to are in pre-change coordinates. Lendiff is
    // the amount of lines added or subtracted by the change. This is
    // used for changes that span multiple lines, or change the way
    // lines are divided into visual lines. regLineChange (below)
    // registers single-line changes.
    function regChange(cm, from, to, lendiff) {
        if (from == null) {
            from = cm.doc.first;
        }
        if (to == null) {
            to = cm.doc.first + cm.doc.size;
        }
        if (!lendiff) {
            lendiff = 0;
        }
        var display = cm.display;
        if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) {
            display.updateLineNumbers = from;
        }
        cm.curOp.viewChanged = true;
        if (from >= display.viewTo) {
            if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) {
                resetView(cm);
            }
        } else if (to <= display.viewFrom) {
            if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
                resetView(cm);
            } else {
                display.viewFrom += lendiff;
                display.viewTo += lendiff;
            }
        } else if (from <= display.viewFrom && to >= display.viewTo) {
            resetView(cm);
        } else if (from <= display.viewFrom) {
            var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cut) {
                display.view = display.view.slice(cut.index);
                display.viewFrom = cut.lineN;
                display.viewTo += lendiff;
            } else {
                resetView(cm);
            }
        } else if (to >= display.viewTo) {
            var cut$1 = viewCuttingPoint(cm, from, from, -1);
            if (cut$1) {
                display.view = display.view.slice(0, cut$1.index);
                display.viewTo = cut$1.lineN;
            } else {
                resetView(cm);
            }
        } else {
            var cutTop = viewCuttingPoint(cm, from, from, -1);
            var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cutTop && cutBot) {
                display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
                display.viewTo += lendiff;
            } else {
                resetView(cm);
            }
        }
        var ext = display.externalMeasured;
        if (ext) {
            if (to < ext.lineN) {
                ext.lineN += lendiff;
            } else if (from < ext.lineN + ext.size) {
                display.externalMeasured = null;
            }
        }
    };
    var regLineChange = // Register a change to a single line. Type must be one of "text",
    // "gutter", "class", "widget"
    function regLineChange(cm, line, type) {
        cm.curOp.viewChanged = true;
        var display = cm.display, ext = cm.display.externalMeasured;
        if (ext && line >= ext.lineN && line < ext.lineN + ext.size) {
            display.externalMeasured = null;
        }
        if (line < display.viewFrom || line >= display.viewTo) {
            return;
        }
        var lineView = display.view[findViewIndex(cm, line)];
        if (lineView.node == null) {
            return;
        }
        var arr = lineView.changes || (lineView.changes = []);
        if (indexOf(arr, type) == -1) {
            arr.push(type);
        }
    };
    var resetView = // Clear the view.
    function resetView(cm) {
        cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
        cm.display.view = [];
        cm.display.viewOffset = 0;
    };
    var viewCuttingPoint = function viewCuttingPoint(cm, oldN, newN, dir) {
        var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
        if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) {
            return {
                index: index,
                lineN: newN
            };
        }
        var n = cm.display.viewFrom;
        for(var i = 0; i < index; i++){
            n += view[i].size;
        }
        if (n != oldN) {
            if (dir > 0) {
                if (index == view.length - 1) {
                    return null;
                }
                diff = n + view[index].size - oldN;
                index++;
            } else {
                diff = n - oldN;
            }
            oldN += diff;
            newN += diff;
        }
        while(visualLineNo(cm.doc, newN) != newN){
            if (index == (dir < 0 ? 0 : view.length - 1)) {
                return null;
            }
            newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
            index += dir;
        }
        return {
            index: index,
            lineN: newN
        };
    };
    var adjustView = // Force the view to cover a given range, adding empty view element
    // or clipping off existing ones as needed.
    function adjustView(cm, from, to) {
        var display = cm.display, view = display.view;
        if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
            display.view = buildViewArray(cm, from, to);
            display.viewFrom = from;
        } else {
            if (display.viewFrom > from) {
                display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
            } else if (display.viewFrom < from) {
                display.view = display.view.slice(findViewIndex(cm, from));
            }
            display.viewFrom = from;
            if (display.viewTo < to) {
                display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
            } else if (display.viewTo > to) {
                display.view = display.view.slice(0, findViewIndex(cm, to));
            }
        }
        display.viewTo = to;
    };
    var countDirtyView = // Count the number of lines in the view whose DOM representation is
    // out of date (or nonexistent).
    function countDirtyView(cm) {
        var view = cm.display.view, dirty = 0;
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (!lineView.hidden && (!lineView.node || lineView.changes)) {
                ++dirty;
            }
        }
        return dirty;
    };
    var updateSelection = function updateSelection(cm) {
        cm.display.input.showSelection(cm.display.input.prepareSelection());
    };
    var prepareSelection = function prepareSelection(cm, primary) {
        if (primary === void 0) primary = true;
        var doc = cm.doc, result = {};
        var curFragment = result.cursors = document.createDocumentFragment();
        var selFragment = result.selection = document.createDocumentFragment();
        var customCursor = cm.options.$customCursor;
        if (customCursor) {
            primary = true;
        }
        for(var i = 0; i < doc.sel.ranges.length; i++){
            if (!primary && i == doc.sel.primIndex) {
                continue;
            }
            var range = doc.sel.ranges[i];
            if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) {
                continue;
            }
            var collapsed = range.empty();
            if (customCursor) {
                var head = customCursor(cm, range);
                if (head) {
                    drawSelectionCursor(cm, head, curFragment);
                }
            } else if (collapsed || cm.options.showCursorWhenSelecting) {
                drawSelectionCursor(cm, range.head, curFragment);
            }
            if (!collapsed) {
                drawSelectionRange(cm, range, selFragment);
            }
        }
        return result;
    };
    var drawSelectionCursor = // Draws a cursor for the given range
    function drawSelectionCursor(cm, head, output) {
        var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
        var cursor = output.appendChild(elt("div", "\xa0", "CodeMirror-cursor"));
        cursor.style.left = pos.left + "px";
        cursor.style.top = pos.top + "px";
        cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
        if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
            var charPos = charCoords(cm, head, "div", null, null);
            var width = charPos.right - charPos.left;
            cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
        }
        if (pos.other) {
            // Secondary cursor, shown when on a 'jump' in bi-directional text
            var otherCursor = output.appendChild(elt("div", "\xa0", "CodeMirror-cursor CodeMirror-secondarycursor"));
            otherCursor.style.display = "";
            otherCursor.style.left = pos.other.left + "px";
            otherCursor.style.top = pos.other.top + "px";
            otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
        }
    };
    var cmpCoords = function cmpCoords(a, b) {
        return a.top - b.top || a.left - b.left;
    };
    var drawSelectionRange = // Draws the given range as a highlighted selection
    function drawSelectionRange(cm, range, output) {
        var display = cm.display, doc = cm.doc;
        var fragment = document.createDocumentFragment();
        var padding = paddingH(cm.display), leftSide = padding.left;
        var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
        var docLTR = doc.direction == "ltr";
        function add(left, top, width, bottom) {
            if (top < 0) {
                top = 0;
            }
            top = Math.round(top);
            bottom = Math.round(bottom);
            fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
        }
        function drawForLine(line, fromArg, toArg) {
            var lineObj = getLine(doc, line);
            var lineLen = lineObj.text.length;
            var start, end;
            function coords(ch, bias) {
                return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
            }
            function wrapX(pos, dir, side) {
                var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
                var prop = dir == "ltr" == (side == "after") ? "left" : "right";
                var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
                return coords(ch, prop)[prop];
            }
            var order = getOrder(lineObj, doc.direction);
            iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i) {
                var ltr = dir == "ltr";
                var fromPos = coords(from, ltr ? "left" : "right");
                var toPos = coords(to - 1, ltr ? "right" : "left");
                var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
                var first = i == 0, last = !order || i == order.length - 1;
                if (toPos.top - fromPos.top <= 3) {
                    var openLeft = (docLTR ? openStart : openEnd) && first;
                    var openRight = (docLTR ? openEnd : openStart) && last;
                    var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
                    var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
                    add(left, fromPos.top, right - left, fromPos.bottom);
                } else {
                    var topLeft, topRight, botLeft, botRight;
                    if (ltr) {
                        topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
                        topRight = docLTR ? rightSide : wrapX(from, dir, "before");
                        botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
                        botRight = docLTR && openEnd && last ? rightSide : toPos.right;
                    } else {
                        topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
                        topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
                        botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
                        botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
                    }
                    add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
                    if (fromPos.bottom < toPos.top) {
                        add(leftSide, fromPos.bottom, null, toPos.top);
                    }
                    add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
                }
                if (!start || cmpCoords(fromPos, start) < 0) {
                    start = fromPos;
                }
                if (cmpCoords(toPos, start) < 0) {
                    start = toPos;
                }
                if (!end || cmpCoords(fromPos, end) < 0) {
                    end = fromPos;
                }
                if (cmpCoords(toPos, end) < 0) {
                    end = toPos;
                }
            });
            return {
                start: start,
                end: end
            };
        }
        var sFrom = range.from(), sTo = range.to();
        if (sFrom.line == sTo.line) {
            drawForLine(sFrom.line, sFrom.ch, sTo.ch);
        } else {
            var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
            var singleVLine = visualLine(fromLine) == visualLine(toLine);
            var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
            var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
            if (singleVLine) {
                if (leftEnd.top < rightStart.top - 2) {
                    add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
                    add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
                } else {
                    add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
                }
            }
            if (leftEnd.bottom < rightStart.top) {
                add(leftSide, leftEnd.bottom, null, rightStart.top);
            }
        }
        output.appendChild(fragment);
    };
    var restartBlink = // Cursor-blinking
    function restartBlink(cm) {
        if (!cm.state.focused) {
            return;
        }
        var display = cm.display;
        clearInterval(display.blinker);
        var on = true;
        display.cursorDiv.style.visibility = "";
        if (cm.options.cursorBlinkRate > 0) {
            display.blinker = setInterval(function() {
                if (!cm.hasFocus()) {
                    onBlur(cm);
                }
                display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
            }, cm.options.cursorBlinkRate);
        } else if (cm.options.cursorBlinkRate < 0) {
            display.cursorDiv.style.visibility = "hidden";
        }
    };
    var ensureFocus = function ensureFocus(cm) {
        if (!cm.hasFocus()) {
            cm.display.input.focus();
            if (!cm.state.focused) {
                onFocus(cm);
            }
        }
    };
    var delayBlurEvent = function delayBlurEvent(cm) {
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            if (cm.state.delayingBlurEvent) {
                cm.state.delayingBlurEvent = false;
                if (cm.state.focused) {
                    onBlur(cm);
                }
            }
        }, 100);
    };
    var onFocus = function onFocus(cm, e) {
        if (cm.state.delayingBlurEvent && !cm.state.draggingText) {
            cm.state.delayingBlurEvent = false;
        }
        if (cm.options.readOnly == "nocursor") {
            return;
        }
        if (!cm.state.focused) {
            signal(cm, "focus", cm, e);
            cm.state.focused = true;
            addClass(cm.display.wrapper, "CodeMirror-focused");
            // This test prevents this from firing when a context
            // menu is closed (since the input reset would kill the
            // select-all detection hack)
            if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
                cm.display.input.reset();
                if (webkit) {
                    setTimeout(function() {
                        return cm.display.input.reset(true);
                    }, 20);
                } // Issue #1730
            }
            cm.display.input.receivedFocus();
        }
        restartBlink(cm);
    };
    var onBlur = function onBlur(cm, e) {
        if (cm.state.delayingBlurEvent) {
            return;
        }
        if (cm.state.focused) {
            signal(cm, "blur", cm, e);
            cm.state.focused = false;
            rmClass(cm.display.wrapper, "CodeMirror-focused");
        }
        clearInterval(cm.display.blinker);
        setTimeout(function() {
            if (!cm.state.focused) {
                cm.display.shift = false;
            }
        }, 150);
    };
    var updateHeightsInViewport = // Read the actual heights of the rendered lines, and update their
    // stored heights to match.
    function updateHeightsInViewport(cm) {
        var display = cm.display;
        var prevBottom = display.lineDiv.offsetTop;
        var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
        var oldHeight = display.lineDiv.getBoundingClientRect().top;
        var mustScroll = 0;
        for(var i = 0; i < display.view.length; i++){
            var cur = display.view[i], wrapping = cm.options.lineWrapping;
            var height = void 0, width = 0;
            if (cur.hidden) {
                continue;
            }
            oldHeight += cur.line.height;
            if (ie && ie_version < 8) {
                var bot = cur.node.offsetTop + cur.node.offsetHeight;
                height = bot - prevBottom;
                prevBottom = bot;
            } else {
                var box = cur.node.getBoundingClientRect();
                height = box.bottom - box.top;
                // Check that lines don't extend past the right of the current
                // editor width
                if (!wrapping && cur.text.firstChild) {
                    width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
                }
            }
            var diff = cur.line.height - height;
            if (diff > .005 || diff < -.005) {
                if (oldHeight < viewTop) {
                    mustScroll -= diff;
                }
                updateLineHeight(cur.line, height);
                updateWidgetHeight(cur.line);
                if (cur.rest) {
                    for(var j = 0; j < cur.rest.length; j++){
                        updateWidgetHeight(cur.rest[j]);
                    }
                }
            }
            if (width > cm.display.sizerWidth) {
                var chWidth = Math.ceil(width / charWidth(cm.display));
                if (chWidth > cm.display.maxLineLength) {
                    cm.display.maxLineLength = chWidth;
                    cm.display.maxLine = cur.line;
                    cm.display.maxLineChanged = true;
                }
            }
        }
        if (Math.abs(mustScroll) > 2) {
            display.scroller.scrollTop += mustScroll;
        }
    };
    var updateWidgetHeight = // Read and store the height of line widgets associated with the
    // given line.
    function updateWidgetHeight(line) {
        if (line.widgets) {
            for(var i = 0; i < line.widgets.length; ++i){
                var w = line.widgets[i], parent = w.node.parentNode;
                if (parent) {
                    w.height = parent.offsetHeight;
                }
            }
        }
    };
    var visibleLines = // Compute the lines that are visible in a given viewport (defaults
    // the the current scroll position). viewport may contain top,
    // height, and ensure (see op.scrollToPos) properties.
    function visibleLines(display, doc, viewport) {
        var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
        top = Math.floor(top - paddingTop(display));
        var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
        var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
        // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
        // forces those lines into the viewport (if possible).
        if (viewport && viewport.ensure) {
            var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
            if (ensureFrom < from) {
                from = ensureFrom;
                to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
            } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
                from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
                to = ensureTo;
            }
        }
        return {
            from: from,
            to: Math.max(to, from + 1)
        };
    };
    var maybeScrollWindow = // SCROLLING THINGS INTO VIEW
    // If an editor sits on the top or bottom of the window, partially
    // scrolled out of view, this ensures that the cursor is visible.
    function maybeScrollWindow(cm, rect) {
        if (signalDOMEvent(cm, "scrollCursorIntoView")) {
            return;
        }
        var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
        if (rect.top + box.top < 0) {
            doScroll = true;
        } else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) {
            doScroll = false;
        }
        if (doScroll != null && !phantom) {
            var scrollNode = elt("div", "​", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
            cm.display.lineSpace.appendChild(scrollNode);
            scrollNode.scrollIntoView(doScroll);
            cm.display.lineSpace.removeChild(scrollNode);
        }
    };
    var scrollPosIntoView = // Scroll a given position into view (immediately), verifying that
    // it actually became visible (as line heights are accurately
    // measured, the position of something may 'drift' during drawing).
    function scrollPosIntoView(cm, pos, end, margin) {
        if (margin == null) {
            margin = 0;
        }
        var rect;
        if (!cm.options.lineWrapping && pos == end) {
            // Set pos and end to the cursor positions around the character pos sticks to
            // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
            // If pos == Pos(_, 0, "before"), pos and end are unchanged
            end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
            pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
        }
        for(var limit = 0; limit < 5; limit++){
            var changed = false;
            var coords = cursorCoords(cm, pos);
            var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
            rect = {
                left: Math.min(coords.left, endCoords.left),
                top: Math.min(coords.top, endCoords.top) - margin,
                right: Math.max(coords.left, endCoords.left),
                bottom: Math.max(coords.bottom, endCoords.bottom) + margin
            };
            var scrollPos = calculateScrollPos(cm, rect);
            var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
            if (scrollPos.scrollTop != null) {
                updateScrollTop(cm, scrollPos.scrollTop);
                if (Math.abs(cm.doc.scrollTop - startTop) > 1) {
                    changed = true;
                }
            }
            if (scrollPos.scrollLeft != null) {
                setScrollLeft(cm, scrollPos.scrollLeft);
                if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) {
                    changed = true;
                }
            }
            if (!changed) {
                break;
            }
        }
        return rect;
    };
    var scrollIntoView = // Scroll a given set of coordinates into view (immediately).
    function scrollIntoView(cm, rect) {
        var scrollPos = calculateScrollPos(cm, rect);
        if (scrollPos.scrollTop != null) {
            updateScrollTop(cm, scrollPos.scrollTop);
        }
        if (scrollPos.scrollLeft != null) {
            setScrollLeft(cm, scrollPos.scrollLeft);
        }
    };
    var calculateScrollPos = // Calculate a new scroll position needed to scroll the given
    // rectangle into view. Returns an object with scrollTop and
    // scrollLeft properties. When these are undefined, the
    // vertical/horizontal position does not need to be adjusted.
    function calculateScrollPos(cm, rect) {
        var display = cm.display, snapMargin = textHeight(cm.display);
        if (rect.top < 0) {
            rect.top = 0;
        }
        var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
        var screen1 = displayHeight(cm), result = {};
        if (rect.bottom - rect.top > screen1) {
            rect.bottom = rect.top + screen1;
        }
        var docBottom = cm.doc.height + paddingVert(display);
        var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
        if (rect.top < screentop) {
            result.scrollTop = atTop ? 0 : rect.top;
        } else if (rect.bottom > screentop + screen1) {
            var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen1);
            if (newTop != screentop) {
                result.scrollTop = newTop;
            }
        }
        var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
        var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
        var screenw = displayWidth(cm) - display.gutters.offsetWidth;
        var tooWide = rect.right - rect.left > screenw;
        if (tooWide) {
            rect.right = rect.left + screenw;
        }
        if (rect.left < 10) {
            result.scrollLeft = 0;
        } else if (rect.left < screenleft) {
            result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
        } else if (rect.right > screenw + screenleft - 3) {
            result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
        }
        return result;
    };
    var addToScrollTop = // Store a relative adjustment to the scroll position in the current
    // operation (to be applied when the operation finishes).
    function addToScrollTop(cm, top) {
        if (top == null) {
            return;
        }
        resolveScrollToPos(cm);
        cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    };
    var ensureCursorVisible = // Make sure that at the end of the operation the current cursor is
    // shown.
    function ensureCursorVisible(cm) {
        resolveScrollToPos(cm);
        var cur = cm.getCursor();
        cm.curOp.scrollToPos = {
            from: cur,
            to: cur,
            margin: cm.options.cursorScrollMargin
        };
    };
    var scrollToCoords = function scrollToCoords(cm, x, y) {
        if (x != null || y != null) {
            resolveScrollToPos(cm);
        }
        if (x != null) {
            cm.curOp.scrollLeft = x;
        }
        if (y != null) {
            cm.curOp.scrollTop = y;
        }
    };
    var scrollToRange = function scrollToRange(cm, range) {
        resolveScrollToPos(cm);
        cm.curOp.scrollToPos = range;
    };
    var resolveScrollToPos = // When an operation has its scrollToPos property set, and another
    // scroll action is applied before the end of the operation, this
    // 'simulates' scrolling that position into view in a cheap way, so
    // that the effect of intermediate scroll commands is not ignored.
    function resolveScrollToPos(cm) {
        var range = cm.curOp.scrollToPos;
        if (range) {
            cm.curOp.scrollToPos = null;
            var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
            scrollToCoordsRange(cm, from, to, range.margin);
        }
    };
    var scrollToCoordsRange = function scrollToCoordsRange(cm, from, to, margin) {
        var sPos = calculateScrollPos(cm, {
            left: Math.min(from.left, to.left),
            top: Math.min(from.top, to.top) - margin,
            right: Math.max(from.right, to.right),
            bottom: Math.max(from.bottom, to.bottom) + margin
        });
        scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    };
    var updateScrollTop = // Sync the scrollable area and scrollbars, ensure the viewport
    // covers the visible area.
    function updateScrollTop(cm, val) {
        if (Math.abs(cm.doc.scrollTop - val) < 2) {
            return;
        }
        if (!gecko) {
            updateDisplaySimple(cm, {
                top: val
            });
        }
        setScrollTop(cm, val, true);
        if (gecko) {
            updateDisplaySimple(cm);
        }
        startWorker(cm, 100);
    };
    var setScrollTop = function setScrollTop(cm, val, forceScroll) {
        val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
        if (cm.display.scroller.scrollTop == val && !forceScroll) {
            return;
        }
        cm.doc.scrollTop = val;
        cm.display.scrollbars.setScrollTop(val);
        if (cm.display.scroller.scrollTop != val) {
            cm.display.scroller.scrollTop = val;
        }
    };
    var setScrollLeft = // Sync scroller and scrollbar, ensure the gutter elements are
    // aligned.
    function setScrollLeft(cm, val, isScroller, forceScroll) {
        val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
        if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) {
            return;
        }
        cm.doc.scrollLeft = val;
        alignHorizontally(cm);
        if (cm.display.scroller.scrollLeft != val) {
            cm.display.scroller.scrollLeft = val;
        }
        cm.display.scrollbars.setScrollLeft(val);
    };
    var measureForScrollbars = // SCROLLBARS
    // Prepare DOM reads needed to update the scrollbars. Done in one
    // shot to minimize update/measure roundtrips.
    function measureForScrollbars(cm) {
        var d = cm.display, gutterW = d.gutters.offsetWidth;
        var docH = Math.round(cm.doc.height + paddingVert(cm.display));
        return {
            clientHeight: d.scroller.clientHeight,
            viewHeight: d.wrapper.clientHeight,
            scrollWidth: d.scroller.scrollWidth,
            clientWidth: d.scroller.clientWidth,
            viewWidth: d.wrapper.clientWidth,
            barLeft: cm.options.fixedGutter ? gutterW : 0,
            docHeight: docH,
            scrollHeight: docH + scrollGap(cm) + d.barHeight,
            nativeBarWidth: d.nativeBarWidth,
            gutterWidth: gutterW
        };
    };
    var updateScrollbars = function updateScrollbars(cm, measure) {
        if (!measure) {
            measure = measureForScrollbars(cm);
        }
        var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
        updateScrollbarsInner(cm, measure);
        for(var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++){
            if (startWidth != cm.display.barWidth && cm.options.lineWrapping) {
                updateHeightsInViewport(cm);
            }
            updateScrollbarsInner(cm, measureForScrollbars(cm));
            startWidth = cm.display.barWidth;
            startHeight = cm.display.barHeight;
        }
    };
    var updateScrollbarsInner = // Re-synchronize the fake scrollbars with the actual size of the
    // content.
    function updateScrollbarsInner(cm, measure) {
        var d = cm.display;
        var sizes = d.scrollbars.update(measure);
        d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
        d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
        d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
        if (sizes.right && sizes.bottom) {
            d.scrollbarFiller.style.display = "block";
            d.scrollbarFiller.style.height = sizes.bottom + "px";
            d.scrollbarFiller.style.width = sizes.right + "px";
        } else {
            d.scrollbarFiller.style.display = "";
        }
        if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
            d.gutterFiller.style.display = "block";
            d.gutterFiller.style.height = sizes.bottom + "px";
            d.gutterFiller.style.width = measure.gutterWidth + "px";
        } else {
            d.gutterFiller.style.display = "";
        }
    };
    var initScrollbars = function initScrollbars(cm) {
        if (cm.display.scrollbars) {
            cm.display.scrollbars.clear();
            if (cm.display.scrollbars.addClass) {
                rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
            }
        }
        cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
            cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
            // Prevent clicks in the scrollbars from killing focus
            on(node, "mousedown", function() {
                if (cm.state.focused) {
                    setTimeout(function() {
                        return cm.display.input.focus();
                    }, 0);
                }
            });
            node.setAttribute("cm-not-content", "true");
        }, function(pos, axis) {
            if (axis == "horizontal") {
                setScrollLeft(cm, pos);
            } else {
                updateScrollTop(cm, pos);
            }
        }, cm);
        if (cm.display.scrollbars.addClass) {
            addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
    };
    var startOperation = // Start a new operation.
    function startOperation(cm) {
        cm.curOp = {
            cm: cm,
            viewChanged: false,
            startHeight: cm.doc.height,
            forceUpdate: false,
            updateInput: 0,
            typing: false,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: false,
            updateMaxLine: false,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: false,
            id: ++nextOpId,
            markArrays: null // Used by addMarkedSpan
        };
        pushOperation(cm.curOp);
    };
    var endOperation = // Finish an operation, updating the display and signalling delayed events
    function endOperation(cm) {
        var op = cm.curOp;
        if (op) {
            finishOperation(op, function(group) {
                for(var i = 0; i < group.ops.length; i++){
                    group.ops[i].cm.curOp = null;
                }
                endOperations(group);
            });
        }
    };
    var endOperations = // The DOM updates done when an operation finishes are batched so
    // that the minimum number of relayouts are required.
    function endOperations(group) {
        var ops = group.ops;
        for(var i = 0; i < ops.length; i++){
            endOperation_R1(ops[i]);
        }
        for(var i$1 = 0; i$1 < ops.length; i$1++){
            endOperation_W1(ops[i$1]);
        }
        for(var i$2 = 0; i$2 < ops.length; i$2++){
            endOperation_R2(ops[i$2]);
        }
        for(var i$3 = 0; i$3 < ops.length; i$3++){
            endOperation_W2(ops[i$3]);
        }
        for(var i$4 = 0; i$4 < ops.length; i$4++){
            endOperation_finish(ops[i$4]);
        }
    };
    var endOperation_R1 = function endOperation_R1(op) {
        var cm = op.cm, display = cm.display;
        maybeClipScrollbars(cm);
        if (op.updateMaxLine) {
            findMaxLine(cm);
        }
        op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
        op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && {
            top: op.scrollTop,
            ensure: op.scrollToPos
        }, op.forceUpdate);
    };
    var endOperation_W1 = function endOperation_W1(op) {
        op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    };
    var endOperation_R2 = function endOperation_R2(op) {
        var cm = op.cm, display = cm.display;
        if (op.updatedDisplay) {
            updateHeightsInViewport(cm);
        }
        op.barMeasure = measureForScrollbars(cm);
        // If the max line changed since it was last measured, measure it,
        // and ensure the document's width matches it.
        // updateDisplay_W2 will use these properties to do the actual resizing
        if (display.maxLineChanged && !cm.options.lineWrapping) {
            op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
            cm.display.sizerWidth = op.adjustWidthTo;
            op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
            op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
        }
        if (op.updatedDisplay || op.selectionChanged) {
            op.preparedSelection = display.input.prepareSelection();
        }
    };
    var endOperation_W2 = function endOperation_W2(op) {
        var cm = op.cm;
        if (op.adjustWidthTo != null) {
            cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
            if (op.maxScrollLeft < cm.doc.scrollLeft) {
                setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
            }
            cm.display.maxLineChanged = false;
        }
        var takeFocus = op.focus && op.focus == activeElt();
        if (op.preparedSelection) {
            cm.display.input.showSelection(op.preparedSelection, takeFocus);
        }
        if (op.updatedDisplay || op.startHeight != cm.doc.height) {
            updateScrollbars(cm, op.barMeasure);
        }
        if (op.updatedDisplay) {
            setDocumentHeight(cm, op.barMeasure);
        }
        if (op.selectionChanged) {
            restartBlink(cm);
        }
        if (cm.state.focused && op.updateInput) {
            cm.display.input.reset(op.typing);
        }
        if (takeFocus) {
            ensureFocus(op.cm);
        }
    };
    var endOperation_finish = function endOperation_finish(op) {
        var cm = op.cm, display = cm.display, doc = cm.doc;
        if (op.updatedDisplay) {
            postUpdateDisplay(cm, op.update);
        }
        // Abort mouse wheel delta measurement, when scrolling explicitly
        if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) {
            display.wheelStartX = display.wheelStartY = null;
        }
        // Propagate the scroll position to the actual DOM scroller
        if (op.scrollTop != null) {
            setScrollTop(cm, op.scrollTop, op.forceScroll);
        }
        if (op.scrollLeft != null) {
            setScrollLeft(cm, op.scrollLeft, true, true);
        }
        // If we need to scroll a specific position into view, do so.
        if (op.scrollToPos) {
            var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from), clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
            maybeScrollWindow(cm, rect);
        }
        // Fire events for markers that are hidden/unidden by editing or
        // undoing
        var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
        if (hidden) {
            for(var i = 0; i < hidden.length; ++i){
                if (!hidden[i].lines.length) {
                    signal(hidden[i], "hide");
                }
            }
        }
        if (unhidden) {
            for(var i$1 = 0; i$1 < unhidden.length; ++i$1){
                if (unhidden[i$1].lines.length) {
                    signal(unhidden[i$1], "unhide");
                }
            }
        }
        if (display.wrapper.offsetHeight) {
            doc.scrollTop = cm.display.scroller.scrollTop;
        }
        // Fire change events, and delayed event handlers
        if (op.changeObjs) {
            signal(cm, "changes", cm, op.changeObjs);
        }
        if (op.update) {
            op.update.finish();
        }
    };
    var runInOp = // Run the given function in an operation
    function runInOp(cm, f) {
        if (cm.curOp) {
            return f();
        }
        startOperation(cm);
        try {
            return f();
        } finally{
            endOperation(cm);
        }
    };
    var operation = // Wraps a function in an operation. Returns the wrapped function.
    function operation(cm, f) {
        return function() {
            if (cm.curOp) {
                return f.apply(cm, arguments);
            }
            startOperation(cm);
            try {
                return f.apply(cm, arguments);
            } finally{
                endOperation(cm);
            }
        };
    };
    var methodOp = // Used to add methods to editor and doc instances, wrapping them in
    // operations.
    function methodOp(f) {
        return function() {
            if (this.curOp) {
                return f.apply(this, arguments);
            }
            startOperation(this);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(this);
            }
        };
    };
    var docMethodOp = function docMethodOp(f) {
        return function() {
            var cm = this.cm;
            if (!cm || cm.curOp) {
                return f.apply(this, arguments);
            }
            startOperation(cm);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(cm);
            }
        };
    };
    var startWorker = // HIGHLIGHT WORKER
    function startWorker(cm, time) {
        if (cm.doc.highlightFrontier < cm.display.viewTo) {
            cm.state.highlight.set(time, bind(highlightWorker, cm));
        }
    };
    var highlightWorker = function highlightWorker(cm) {
        var doc = cm.doc;
        if (doc.highlightFrontier >= cm.display.viewTo) {
            return;
        }
        var end = +new Date + cm.options.workTime;
        var context = getContextBefore(cm, doc.highlightFrontier);
        var changedLines = [];
        doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
            if (context.line >= cm.display.viewFrom) {
                var oldStyles = line.styles;
                var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
                var highlighted = highlightLine(cm, line, context, true);
                if (resetState) {
                    context.state = resetState;
                }
                line.styles = highlighted.styles;
                var oldCls = line.styleClasses, newCls = highlighted.classes;
                if (newCls) {
                    line.styleClasses = newCls;
                } else if (oldCls) {
                    line.styleClasses = null;
                }
                var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
                for(var i = 0; !ischange && i < oldStyles.length; ++i){
                    ischange = oldStyles[i] != line.styles[i];
                }
                if (ischange) {
                    changedLines.push(context.line);
                }
                line.stateAfter = context.save();
                context.nextLine();
            } else {
                if (line.text.length <= cm.options.maxHighlightLength) {
                    processLine(cm, line.text, context);
                }
                line.stateAfter = context.line % 5 == 0 ? context.save() : null;
                context.nextLine();
            }
            if (+new Date > end) {
                startWorker(cm, cm.options.workDelay);
                return true;
            }
        });
        doc.highlightFrontier = context.line;
        doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
        if (changedLines.length) {
            runInOp(cm, function() {
                for(var i = 0; i < changedLines.length; i++){
                    regLineChange(cm, changedLines[i], "text");
                }
            });
        }
    };
    var maybeClipScrollbars = function maybeClipScrollbars(cm) {
        var display = cm.display;
        if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
            display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
            display.heightForcer.style.height = scrollGap(cm) + "px";
            display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
            display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
            display.scrollbarsClipped = true;
        }
    };
    var selectionSnapshot = function selectionSnapshot(cm) {
        if (cm.hasFocus()) {
            return null;
        }
        var active = activeElt();
        if (!active || !contains(cm.display.lineDiv, active)) {
            return null;
        }
        var result = {
            activeElt: active
        };
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
                result.anchorNode = sel.anchorNode;
                result.anchorOffset = sel.anchorOffset;
                result.focusNode = sel.focusNode;
                result.focusOffset = sel.focusOffset;
            }
        }
        return result;
    };
    var restoreSelection = function restoreSelection(snapshot) {
        if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) {
            return;
        }
        snapshot.activeElt.focus();
        if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
            var sel = window.getSelection(), range = document.createRange();
            range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            sel.extend(snapshot.focusNode, snapshot.focusOffset);
        }
    };
    var updateDisplayIfNeeded = // Does the actual updating of the line display. Bails out
    // (returning false) when there is nothing to be done and forced is
    // false.
    function updateDisplayIfNeeded(cm, update) {
        var display = cm.display, doc = cm.doc;
        if (update.editorIsHidden) {
            resetView(cm);
            return false;
        }
        // Bail out if the visible area is already rendered and nothing changed.
        if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) {
            return false;
        }
        if (maybeUpdateLineNumberWidth(cm)) {
            resetView(cm);
            update.dims = getDimensions(cm);
        }
        // Compute a suitable new viewport (from & to)
        var end = doc.first + doc.size;
        var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
        var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
        if (display.viewFrom < from && from - display.viewFrom < 20) {
            from = Math.max(doc.first, display.viewFrom);
        }
        if (display.viewTo > to && display.viewTo - to < 20) {
            to = Math.min(end, display.viewTo);
        }
        if (sawCollapsedSpans) {
            from = visualLineNo(cm.doc, from);
            to = visualLineEndNo(cm.doc, to);
        }
        var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
        adjustView(cm, from, to);
        display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
        // Position the mover div to align with the current scroll position
        cm.display.mover.style.top = display.viewOffset + "px";
        var toUpdate = countDirtyView(cm);
        if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) {
            return false;
        }
        // For big changes, we hide the enclosing element during the
        // update, since that speeds up the operations on most browsers.
        var selSnapshot = selectionSnapshot(cm);
        if (toUpdate > 4) {
            display.lineDiv.style.display = "none";
        }
        patchDisplay(cm, display.updateLineNumbers, update.dims);
        if (toUpdate > 4) {
            display.lineDiv.style.display = "";
        }
        display.renderedView = display.view;
        // There might have been a widget with a focused element that got
        // hidden or updated, if so re-focus it.
        restoreSelection(selSnapshot);
        // Prevent selection and cursors from interfering with the scroll
        // width and height.
        removeChildren(display.cursorDiv);
        removeChildren(display.selectionDiv);
        display.gutters.style.height = display.sizer.style.minHeight = 0;
        if (different) {
            display.lastWrapHeight = update.wrapperHeight;
            display.lastWrapWidth = update.wrapperWidth;
            startWorker(cm, 400);
        }
        display.updateLineNumbers = null;
        return true;
    };
    var postUpdateDisplay = function postUpdateDisplay(cm, update) {
        var viewport = update.viewport;
        for(var first = true;; first = false){
            if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
                // Clip forced viewport to actual scrollable area.
                if (viewport && viewport.top != null) {
                    viewport = {
                        top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)
                    };
                }
                // Updated line heights might result in the drawn area not
                // actually covering the viewport. Keep looping until it does.
                update.visible = visibleLines(cm.display, cm.doc, viewport);
                if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) {
                    break;
                }
            } else if (first) {
                update.visible = visibleLines(cm.display, cm.doc, viewport);
            }
            if (!updateDisplayIfNeeded(cm, update)) {
                break;
            }
            updateHeightsInViewport(cm);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.force = false;
        }
        update.signal(cm, "update", cm);
        if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
            update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
            cm.display.reportedViewFrom = cm.display.viewFrom;
            cm.display.reportedViewTo = cm.display.viewTo;
        }
    };
    var updateDisplaySimple = function updateDisplaySimple(cm, viewport) {
        var update = new DisplayUpdate(cm, viewport);
        if (updateDisplayIfNeeded(cm, update)) {
            updateHeightsInViewport(cm);
            postUpdateDisplay(cm, update);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.finish();
        }
    };
    var patchDisplay = // Sync the actual display DOM structure with display.view, removing
    // nodes for lines that are no longer in view, and creating the ones
    // that are not there yet, and updating the ones that are out of
    // date.
    function patchDisplay(cm, updateNumbersFrom, dims) {
        var display = cm.display, lineNumbers = cm.options.lineNumbers;
        var container = display.lineDiv, cur = container.firstChild;
        function rm(node) {
            var next = node.nextSibling;
            // Works around a throw-scroll bug in OS X Webkit
            if (webkit && mac && cm.display.currentWheelTarget == node) {
                node.style.display = "none";
            } else {
                node.parentNode.removeChild(node);
            }
            return next;
        }
        var view = display.view, lineN = display.viewFrom;
        // Loop over the elements in the view, syncing cur (the DOM nodes
        // in display.lineDiv) with the view as we go.
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (lineView.hidden) ;
            else if (!lineView.node || lineView.node.parentNode != container) {
                var node = buildLineElement(cm, lineView, lineN, dims);
                container.insertBefore(node, cur);
            } else {
                while(cur != lineView.node){
                    cur = rm(cur);
                }
                var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
                if (lineView.changes) {
                    if (indexOf(lineView.changes, "gutter") > -1) {
                        updateNumber = false;
                    }
                    updateLineForChanges(cm, lineView, lineN, dims);
                }
                if (updateNumber) {
                    removeChildren(lineView.lineNumber);
                    lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
                }
                cur = lineView.node.nextSibling;
            }
            lineN += lineView.size;
        }
        while(cur){
            cur = rm(cur);
        }
    };
    var updateGutterSpace = function updateGutterSpace(display) {
        var width = display.gutters.offsetWidth;
        display.sizer.style.marginLeft = width + "px";
        // Send an event to consumers responding to changes in gutter width.
        signalLater(display, "gutterChanged", display);
    };
    var setDocumentHeight = function setDocumentHeight(cm, measure) {
        cm.display.sizer.style.minHeight = measure.docHeight + "px";
        cm.display.heightForcer.style.top = measure.docHeight + "px";
        cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    };
    var alignHorizontally = // Re-align line numbers and gutter marks to compensate for
    // horizontal scrolling.
    function alignHorizontally(cm) {
        var display = cm.display, view = display.view;
        if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) {
            return;
        }
        var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
        var gutterW = display.gutters.offsetWidth, left = comp + "px";
        for(var i = 0; i < view.length; i++){
            if (!view[i].hidden) {
                if (cm.options.fixedGutter) {
                    if (view[i].gutter) {
                        view[i].gutter.style.left = left;
                    }
                    if (view[i].gutterBackground) {
                        view[i].gutterBackground.style.left = left;
                    }
                }
                var align = view[i].alignable;
                if (align) {
                    for(var j = 0; j < align.length; j++){
                        align[j].style.left = left;
                    }
                }
            }
        }
        if (cm.options.fixedGutter) {
            display.gutters.style.left = comp + gutterW + "px";
        }
    };
    var maybeUpdateLineNumberWidth = // Used to ensure that the line number gutter is still the right
    // size for the current document size. Returns true when an update
    // is needed.
    function maybeUpdateLineNumberWidth(cm) {
        if (!cm.options.lineNumbers) {
            return false;
        }
        var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
        if (last.length != display.lineNumChars) {
            var test = display.measure.appendChild(elt("div", [
                elt("div", last)
            ], "CodeMirror-linenumber CodeMirror-gutter-elt"));
            var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
            display.lineGutter.style.width = "";
            display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
            display.lineNumWidth = display.lineNumInnerWidth + padding;
            display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
            display.lineGutter.style.width = display.lineNumWidth + "px";
            updateGutterSpace(cm.display);
            return true;
        }
        return false;
    };
    var getGutters = function getGutters(gutters, lineNumbers) {
        var result = [], sawLineNumbers = false;
        for(var i = 0; i < gutters.length; i++){
            var name = gutters[i], style = null;
            if (typeof name != "string") {
                style = name.style;
                name = name.className;
            }
            if (name == "CodeMirror-linenumbers") {
                if (!lineNumbers) {
                    continue;
                } else {
                    sawLineNumbers = true;
                }
            }
            result.push({
                className: name,
                style: style
            });
        }
        if (lineNumbers && !sawLineNumbers) {
            result.push({
                className: "CodeMirror-linenumbers",
                style: null
            });
        }
        return result;
    };
    var renderGutters = // Rebuild the gutter elements, ensure the margin to the left of the
    // code matches their width.
    function renderGutters(display) {
        var gutters = display.gutters, specs = display.gutterSpecs;
        removeChildren(gutters);
        display.lineGutter = null;
        for(var i = 0; i < specs.length; ++i){
            var ref = specs[i];
            var className = ref.className;
            var style = ref.style;
            var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
            if (style) {
                gElt.style.cssText = style;
            }
            if (className == "CodeMirror-linenumbers") {
                display.lineGutter = gElt;
                gElt.style.width = (display.lineNumWidth || 1) + "px";
            }
        }
        gutters.style.display = specs.length ? "" : "none";
        updateGutterSpace(display);
    };
    var updateGutters = function updateGutters(cm) {
        renderGutters(cm.display);
        regChange(cm);
        alignHorizontally(cm);
    };
    var Display = // The display handles the DOM integration, both for input reading
    // and content drawing. It holds references to DOM nodes and
    // display-related state.
    function Display(place, doc, input, options) {
        var d = this;
        this.input = input;
        // Covers bottom-right square when both scrollbars are present.
        d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
        d.scrollbarFiller.setAttribute("cm-not-content", "true");
        // Covers bottom of gutter when coverGutterNextToScrollbar is on
        // and h scrollbar is present.
        d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
        d.gutterFiller.setAttribute("cm-not-content", "true");
        // Will contain the actual code, positioned to cover the viewport.
        d.lineDiv = eltP("div", null, "CodeMirror-code");
        // Elements are added to these to represent selection and cursors.
        d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
        d.cursorDiv = elt("div", null, "CodeMirror-cursors");
        // A visibility: hidden element used to find the size of things.
        d.measure = elt("div", null, "CodeMirror-measure");
        // When lines outside of the viewport are measured, they are drawn in this.
        d.lineMeasure = elt("div", null, "CodeMirror-measure");
        // Wraps everything that needs to exist inside the vertically-padded coordinate system
        d.lineSpace = eltP("div", [
            d.measure,
            d.lineMeasure,
            d.selectionDiv,
            d.cursorDiv,
            d.lineDiv
        ], null, "position: relative; outline: none");
        var lines = eltP("div", [
            d.lineSpace
        ], "CodeMirror-lines");
        // Moved around its parent to cover visible view.
        d.mover = elt("div", [
            lines
        ], null, "position: relative");
        // Set to the height of the document, allowing scrolling.
        d.sizer = elt("div", [
            d.mover
        ], "CodeMirror-sizer");
        d.sizerWidth = null;
        // Behavior of elts with overflow: auto and padding is
        // inconsistent across browsers. This is used to ensure the
        // scrollable area is big enough.
        d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
        // Will contain the gutters, if any.
        d.gutters = elt("div", null, "CodeMirror-gutters");
        d.lineGutter = null;
        // Actual scrollable element.
        d.scroller = elt("div", [
            d.sizer,
            d.heightForcer,
            d.gutters
        ], "CodeMirror-scroll");
        d.scroller.setAttribute("tabIndex", "-1");
        // The element in which the editor lives.
        d.wrapper = elt("div", [
            d.scrollbarFiller,
            d.gutterFiller,
            d.scroller
        ], "CodeMirror");
        // This attribute is respected by automatic translation systems such as Google Translate,
        // and may also be respected by tools used by human translators.
        d.wrapper.setAttribute("translate", "no");
        // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
        if (ie && ie_version < 8) {
            d.gutters.style.zIndex = -1;
            d.scroller.style.paddingRight = 0;
        }
        if (!webkit && !(gecko && mobile)) {
            d.scroller.draggable = true;
        }
        if (place) {
            if (place.appendChild) {
                place.appendChild(d.wrapper);
            } else {
                place(d.wrapper);
            }
        }
        // Current rendered range (may be bigger than the view window).
        d.viewFrom = d.viewTo = doc.first;
        d.reportedViewFrom = d.reportedViewTo = doc.first;
        // Information about the rendered lines.
        d.view = [];
        d.renderedView = null;
        // Holds info about a single rendered line when it was rendered
        // for measurement, while not in view.
        d.externalMeasured = null;
        // Empty space (in pixels) above the view
        d.viewOffset = 0;
        d.lastWrapHeight = d.lastWrapWidth = 0;
        d.updateLineNumbers = null;
        d.nativeBarWidth = d.barHeight = d.barWidth = 0;
        d.scrollbarsClipped = false;
        // Used to only resize the line number gutter when necessary (when
        // the amount of lines crosses a boundary that makes its width change)
        d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
        // Set to true when a non-horizontal-scrolling line widget is
        // added. As an optimization, line widget aligning is skipped when
        // this is false.
        d.alignWidgets = false;
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        // Tracks the maximum line length so that the horizontal scrollbar
        // can be kept static when scrolling.
        d.maxLine = null;
        d.maxLineLength = 0;
        d.maxLineChanged = false;
        // Used for measuring wheel scrolling granularity
        d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
        // True when shift is held down.
        d.shift = false;
        // Used to track whether anything happened since the context menu
        // was opened.
        d.selForContextMenu = null;
        d.activeTouch = null;
        d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
        renderGutters(d);
        input.init(d);
    };
    var wheelEventDelta = function wheelEventDelta(e) {
        var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
        if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) {
            dx = e.detail;
        }
        if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) {
            dy = e.detail;
        } else if (dy == null) {
            dy = e.wheelDelta;
        }
        return {
            x: dx,
            y: dy
        };
    };
    var wheelEventPixels = function wheelEventPixels(e) {
        var delta = wheelEventDelta(e);
        delta.x *= wheelPixelsPerUnit;
        delta.y *= wheelPixelsPerUnit;
        return delta;
    };
    var onScrollWheel = function onScrollWheel(cm, e) {
        var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
        var pixelsPerUnit = wheelPixelsPerUnit;
        if (e.deltaMode === 0) {
            dx = e.deltaX;
            dy = e.deltaY;
            pixelsPerUnit = 1;
        }
        var display = cm.display, scroll = display.scroller;
        // Quit if there's nothing to scroll here
        var canScrollX = scroll.scrollWidth > scroll.clientWidth;
        var canScrollY = scroll.scrollHeight > scroll.clientHeight;
        if (!(dx && canScrollX || dy && canScrollY)) {
            return;
        }
        // Webkit browsers on OS X abort momentum scrolls when the target
        // of the scroll event is removed from the scrollable element.
        // This hack (see related code in patchDisplay) makes sure the
        // element is kept around.
        if (dy && mac && webkit) {
            outer: for(var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode){
                for(var i = 0; i < view.length; i++){
                    if (view[i].node == cur) {
                        cm.display.currentWheelTarget = cur;
                        break outer;
                    }
                }
            }
        }
        // On some browsers, horizontal scrolling will cause redraws to
        // happen before the gutter has been realigned, causing it to
        // wriggle around in a most unseemly way. When we have an
        // estimated pixels/delta value, we just handle horizontal
        // scrolling entirely here. It'll be slightly off from native, but
        // better than glitching out.
        if (dx && !gecko && !presto && pixelsPerUnit != null) {
            if (dy && canScrollY) {
                updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
            }
            setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
            // Only prevent default scrolling if vertical scrolling is
            // actually possible. Otherwise, it causes vertical scroll
            // jitter on OSX trackpads when deltaX is small and deltaY
            // is large (issue #3579)
            if (!dy || dy && canScrollY) {
                e_preventDefault(e);
            }
            display.wheelStartX = null; // Abort measurement, if in progress
            return;
        }
        // 'Project' the visible viewport to cover the area that is being
        // scrolled into view (if we know enough to estimate it).
        if (dy && pixelsPerUnit != null) {
            var pixels = dy * pixelsPerUnit;
            var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
            if (pixels < 0) {
                top = Math.max(0, top + pixels - 50);
            } else {
                bot = Math.min(cm.doc.height, bot + pixels + 50);
            }
            updateDisplaySimple(cm, {
                top: top,
                bottom: bot
            });
        }
        if (wheelSamples < 20 && e.deltaMode !== 0) {
            if (display.wheelStartX == null) {
                display.wheelStartX = scroll.scrollLeft;
                display.wheelStartY = scroll.scrollTop;
                display.wheelDX = dx;
                display.wheelDY = dy;
                setTimeout(function() {
                    if (display.wheelStartX == null) {
                        return;
                    }
                    var movedX = scroll.scrollLeft - display.wheelStartX;
                    var movedY = scroll.scrollTop - display.wheelStartY;
                    var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
                    display.wheelStartX = display.wheelStartY = null;
                    if (!sample) {
                        return;
                    }
                    wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
                    ++wheelSamples;
                }, 200);
            } else {
                display.wheelDX += dx;
                display.wheelDY += dy;
            }
        }
    };
    var normalizeSelection = // Take an unsorted, potentially overlapping set of ranges, and
    // build a selection out of it. 'Consumes' ranges array (modifying
    // it).
    function normalizeSelection(cm, ranges, primIndex) {
        var mayTouch = cm && cm.options.selectionsMayTouch;
        var prim = ranges[primIndex];
        ranges.sort(function(a, b) {
            return cmp(a.from(), b.from());
        });
        primIndex = indexOf(ranges, prim);
        for(var i = 1; i < ranges.length; i++){
            var cur = ranges[i], prev = ranges[i - 1];
            var diff = cmp(prev.to(), cur.from());
            if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
                var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
                var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
                if (i <= primIndex) {
                    --primIndex;
                }
                ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
            }
        }
        return new Selection(ranges, primIndex);
    };
    var simpleSelection = function simpleSelection(anchor, head) {
        return new Selection([
            new Range(anchor, head || anchor)
        ], 0);
    };
    var changeEnd = // Compute the position of the end of a change (its 'to' property
    // refers to the pre-change end).
    function changeEnd(change) {
        if (!change.text) {
            return change.to;
        }
        return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
    };
    var adjustForChange = // Adjust a position to refer to the post-change position of the
    // same text, or the end of the change if the change covers it.
    function adjustForChange(pos, change) {
        if (cmp(pos, change.from) < 0) {
            return pos;
        }
        if (cmp(pos, change.to) <= 0) {
            return changeEnd(change);
        }
        var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
        if (pos.line == change.to.line) {
            ch += changeEnd(change).ch - change.to.ch;
        }
        return Pos(line, ch);
    };
    var computeSelAfterChange = function computeSelAfterChange(doc, change) {
        var out = [];
        for(var i = 0; i < doc.sel.ranges.length; i++){
            var range = doc.sel.ranges[i];
            out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
        }
        return normalizeSelection(doc.cm, out, doc.sel.primIndex);
    };
    var offsetPos = function offsetPos(pos, old, nw) {
        if (pos.line == old.line) {
            return Pos(nw.line, pos.ch - old.ch + nw.ch);
        } else {
            return Pos(nw.line + (pos.line - old.line), pos.ch);
        }
    };
    var computeReplacedSel = // Used by replaceSelections to allow moving the selection to the
    // start or around the replaced test. Hint may be "start" or "around".
    function computeReplacedSel(doc, changes, hint) {
        var out = [];
        var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var from = offsetPos(change.from, oldPrev, newPrev);
            var to = offsetPos(changeEnd(change), oldPrev, newPrev);
            oldPrev = change.to;
            newPrev = to;
            if (hint == "around") {
                var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
                out[i] = new Range(inv ? to : from, inv ? from : to);
            } else {
                out[i] = new Range(from, from);
            }
        }
        return new Selection(out, doc.sel.primIndex);
    };
    var loadMode = // Used to get the editor into a consistent state again when options change.
    function loadMode(cm) {
        cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
        resetModeState(cm);
    };
    var resetModeState = function resetModeState(cm) {
        cm.doc.iter(function(line) {
            if (line.stateAfter) {
                line.stateAfter = null;
            }
            if (line.styles) {
                line.styles = null;
            }
        });
        cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
        startWorker(cm, 100);
        cm.state.modeGen++;
        if (cm.curOp) {
            regChange(cm);
        }
    };
    var isWholeLineUpdate = // DOCUMENT DATA STRUCTURE
    // By default, updates that start and end at the beginning of a line
    // are treated specially, in order to make the association of line
    // widgets and marker elements with the text behave more intuitive.
    function isWholeLineUpdate(doc, change) {
        return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
    };
    var updateDoc = // Perform a change on the document data structure.
    function updateDoc(doc, change, markedSpans, estimateHeight) {
        function spansFor(n) {
            return markedSpans ? markedSpans[n] : null;
        }
        function update(line, text, spans) {
            updateLine(line, text, spans, estimateHeight);
            signalLater(line, "change", line, change);
        }
        function linesFor(start, end) {
            var result = [];
            for(var i = start; i < end; ++i){
                result.push(new Line(text[i], spansFor(i), estimateHeight));
            }
            return result;
        }
        var from = change.from, to = change.to, text = change.text;
        var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
        var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
        // Adjust the line structure
        if (change.full) {
            doc.insert(0, linesFor(0, text.length));
            doc.remove(text.length, doc.size - text.length);
        } else if (isWholeLineUpdate(doc, change)) {
            // This is a whole-line replace. Treated specially to make
            // sure line objects move the way they are supposed to.
            var added = linesFor(0, text.length - 1);
            update(lastLine, lastLine.text, lastSpans);
            if (nlines) {
                doc.remove(from.line, nlines);
            }
            if (added.length) {
                doc.insert(from.line, added);
            }
        } else if (firstLine == lastLine) {
            if (text.length == 1) {
                update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
            } else {
                var added$1 = linesFor(1, text.length - 1);
                added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
                update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
                doc.insert(from.line + 1, added$1);
            }
        } else if (text.length == 1) {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
            doc.remove(from.line + 1, nlines);
        } else {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
            update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
            var added$2 = linesFor(1, text.length - 1);
            if (nlines > 1) {
                doc.remove(from.line + 1, nlines - 1);
            }
            doc.insert(from.line + 1, added$2);
        }
        signalLater(doc, "change", doc, change);
    };
    var linkedDocs = // Call f for all linked documents.
    function linkedDocs(doc, f, sharedHistOnly) {
        function propagate(doc, skip, sharedHist) {
            if (doc.linked) {
                for(var i = 0; i < doc.linked.length; ++i){
                    var rel = doc.linked[i];
                    if (rel.doc == skip) {
                        continue;
                    }
                    var shared = sharedHist && rel.sharedHist;
                    if (sharedHistOnly && !shared) {
                        continue;
                    }
                    f(rel.doc, shared);
                    propagate(rel.doc, doc, shared);
                }
            }
        }
        propagate(doc, null, true);
    };
    var attachDoc = // Attach a document to an editor.
    function attachDoc(cm, doc) {
        if (doc.cm) {
            throw new Error("This document is already in use.");
        }
        cm.doc = doc;
        doc.cm = cm;
        estimateLineHeights(cm);
        loadMode(cm);
        setDirectionClass(cm);
        cm.options.direction = doc.direction;
        if (!cm.options.lineWrapping) {
            findMaxLine(cm);
        }
        cm.options.mode = doc.modeOption;
        regChange(cm);
    };
    var setDirectionClass = function setDirectionClass(cm) {
        (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    };
    var directionChanged = function directionChanged(cm) {
        runInOp(cm, function() {
            setDirectionClass(cm);
            regChange(cm);
        });
    };
    var History = function History(prev) {
        // Arrays of change events and selections. Doing something adds an
        // event to done and clears undo. Undoing moves events from done
        // to undone, redoing moves them in the other direction.
        this.done = [];
        this.undone = [];
        this.undoDepth = prev ? prev.undoDepth : Infinity;
        // Used to track when changes can be merged into a single undo
        // event
        this.lastModTime = this.lastSelTime = 0;
        this.lastOp = this.lastSelOp = null;
        this.lastOrigin = this.lastSelOrigin = null;
        // Used by the isClean() method
        this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
    };
    var historyChangeFromChange = // Create a history change event from an updateDoc-style change
    // object.
    function historyChangeFromChange(doc, change) {
        var histChange = {
            from: copyPos(change.from),
            to: changeEnd(change),
            text: getBetween(doc, change.from, change.to)
        };
        attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        linkedDocs(doc, function(doc) {
            return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        }, true);
        return histChange;
    };
    var clearSelectionEvents = // Pop all selection events off the end of a history array. Stop at
    // a change event.
    function clearSelectionEvents(array) {
        while(array.length){
            var last = lst(array);
            if (last.ranges) {
                array.pop();
            } else {
                break;
            }
        }
    };
    var lastChangeEvent = // Find the top change event in the history. Pop off selection
    // events that are in the way.
    function lastChangeEvent(hist, force) {
        if (force) {
            clearSelectionEvents(hist.done);
            return lst(hist.done);
        } else if (hist.done.length && !lst(hist.done).ranges) {
            return lst(hist.done);
        } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
            hist.done.pop();
            return lst(hist.done);
        }
    };
    var addChangeToHistory = // Register a change in the history. Merges changes that are within
    // a single operation, or are close together with an origin that
    // allows merging (starting with "+") into a single event.
    function addChangeToHistory(doc, change, selAfter, opId) {
        var hist = doc.history;
        hist.undone.length = 0;
        var time = +new Date, cur;
        var last;
        if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
            // Merge this change into the last event
            last = lst(cur.changes);
            if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
                // Optimized case for simple insertion -- don't want to add
                // new changesets for every character typed
                last.to = changeEnd(change);
            } else {
                // Add new sub-event
                cur.changes.push(historyChangeFromChange(doc, change));
            }
        } else {
            // Can not be merged, start a new event.
            var before = lst(hist.done);
            if (!before || !before.ranges) {
                pushSelectionToHistory(doc.sel, hist.done);
            }
            cur = {
                changes: [
                    historyChangeFromChange(doc, change)
                ],
                generation: hist.generation
            };
            hist.done.push(cur);
            while(hist.done.length > hist.undoDepth){
                hist.done.shift();
                if (!hist.done[0].ranges) {
                    hist.done.shift();
                }
            }
        }
        hist.done.push(selAfter);
        hist.generation = ++hist.maxGeneration;
        hist.lastModTime = hist.lastSelTime = time;
        hist.lastOp = hist.lastSelOp = opId;
        hist.lastOrigin = hist.lastSelOrigin = change.origin;
        if (!last) {
            signal(doc, "historyAdded");
        }
    };
    var selectionEventCanBeMerged = function selectionEventCanBeMerged(doc, origin, prev, sel) {
        var ch = origin.charAt(0);
        return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
    };
    var addSelectionToHistory = // Called whenever the selection changes, sets the new selection as
    // the pending selection in the history, and pushes the old pending
    // selection into the 'done' array when it was significantly
    // different (in number of selected ranges, emptiness, or time).
    function addSelectionToHistory(doc, sel, opId, options) {
        var hist = doc.history, origin = options && options.origin;
        // A new event is started when the previous origin does not match
        // the current, or the origins don't allow matching. Origins
        // starting with * are always merged, those starting with + are
        // merged when similar and close together in time.
        if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) {
            hist.done[hist.done.length - 1] = sel;
        } else {
            pushSelectionToHistory(sel, hist.done);
        }
        hist.lastSelTime = +new Date;
        hist.lastSelOrigin = origin;
        hist.lastSelOp = opId;
        if (options && options.clearRedo !== false) {
            clearSelectionEvents(hist.undone);
        }
    };
    var pushSelectionToHistory = function pushSelectionToHistory(sel, dest) {
        var top = lst(dest);
        if (!(top && top.ranges && top.equals(sel))) {
            dest.push(sel);
        }
    };
    var attachLocalSpans = // Used to store marked span information in the history.
    function attachLocalSpans(doc, change, from, to) {
        var existing = change["spans_" + doc.id], n = 0;
        doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
            if (line.markedSpans) {
                (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
            }
            ++n;
        });
    };
    var removeClearedSpans = // When un/re-doing restores text containing marked spans, those
    // that have been explicitly cleared should not be restored.
    function removeClearedSpans(spans) {
        if (!spans) {
            return null;
        }
        var out;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i].marker.explicitlyCleared) {
                if (!out) {
                    out = spans.slice(0, i);
                }
            } else if (out) {
                out.push(spans[i]);
            }
        }
        return !out ? spans : out.length ? out : null;
    };
    var getOldSpans = // Retrieve and filter the old marked spans stored in a change event.
    function getOldSpans(doc, change) {
        var found = change["spans_" + doc.id];
        if (!found) {
            return null;
        }
        var nw = [];
        for(var i = 0; i < change.text.length; ++i){
            nw.push(removeClearedSpans(found[i]));
        }
        return nw;
    };
    var mergeOldSpans = // Used for un/re-doing changes from the history. Combines the
    // result of computing the existing spans with the set of spans that
    // existed in the history (so that deleting around a span and then
    // undoing brings back the span).
    function mergeOldSpans(doc, change) {
        var old = getOldSpans(doc, change);
        var stretched = stretchSpansOverChange(doc, change);
        if (!old) {
            return stretched;
        }
        if (!stretched) {
            return old;
        }
        for(var i = 0; i < old.length; ++i){
            var oldCur = old[i], stretchCur = stretched[i];
            if (oldCur && stretchCur) {
                spans: for(var j = 0; j < stretchCur.length; ++j){
                    var span = stretchCur[j];
                    for(var k = 0; k < oldCur.length; ++k){
                        if (oldCur[k].marker == span.marker) {
                            continue spans;
                        }
                    }
                    oldCur.push(span);
                }
            } else if (stretchCur) {
                old[i] = stretchCur;
            }
        }
        return old;
    };
    var copyHistoryArray = // Used both to provide a JSON-safe object in .getHistory, and, when
    // detaching a document, to split the history in two
    function copyHistoryArray(events, newGroup, instantiateSel) {
        var copy = [];
        for(var i = 0; i < events.length; ++i){
            var event = events[i];
            if (event.ranges) {
                copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
                continue;
            }
            var changes = event.changes, newChanges = [];
            copy.push({
                changes: newChanges
            });
            for(var j = 0; j < changes.length; ++j){
                var change = changes[j], m = void 0;
                newChanges.push({
                    from: change.from,
                    to: change.to,
                    text: change.text
                });
                if (newGroup) {
                    for(var prop in change){
                        if (m = prop.match(/^spans_(\d+)$/)) {
                            if (indexOf(newGroup, Number(m[1])) > -1) {
                                lst(newChanges)[prop] = change[prop];
                                delete change[prop];
                            }
                        }
                    }
                }
            }
        }
        return copy;
    };
    var extendRange = // The 'scroll' parameter given to many of these indicated whether
    // the new cursor position should be scrolled into view after
    // modifying the selection.
    // If shift is held or the extend flag is set, extends a range to
    // include a given position (and optionally a second position).
    // Otherwise, simply returns the range between the given positions.
    // Used for cursor motion and such.
    function extendRange(range, head, other, extend) {
        if (extend) {
            var anchor = range.anchor;
            if (other) {
                var posBefore = cmp(head, anchor) < 0;
                if (posBefore != cmp(other, anchor) < 0) {
                    anchor = head;
                    head = other;
                } else if (posBefore != cmp(head, other) < 0) {
                    head = other;
                }
            }
            return new Range(anchor, head);
        } else {
            return new Range(other || head, head);
        }
    };
    var extendSelection = // Extend the primary selection range, discard the rest.
    function extendSelection(doc, head, other, options, extend) {
        if (extend == null) {
            extend = doc.cm && (doc.cm.display.shift || doc.extend);
        }
        setSelection(doc, new Selection([
            extendRange(doc.sel.primary(), head, other, extend)
        ], 0), options);
    };
    var extendSelections = // Extend all selections (pos is an array of selections with length
    // equal the number of selections)
    function extendSelections(doc, heads, options) {
        var out = [];
        var extend = doc.cm && (doc.cm.display.shift || doc.extend);
        for(var i = 0; i < doc.sel.ranges.length; i++){
            out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
        }
        var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
        setSelection(doc, newSel, options);
    };
    var replaceOneSelection = // Updates a single range in the selection.
    function replaceOneSelection(doc, i, range, options) {
        var ranges = doc.sel.ranges.slice(0);
        ranges[i] = range;
        setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
    };
    var setSimpleSelection = // Reset the selection to a single range.
    function setSimpleSelection(doc, anchor, head, options) {
        setSelection(doc, simpleSelection(anchor, head), options);
    };
    var filterSelectionChange = // Give beforeSelectionChange handlers a change to influence a
    // selection update.
    function filterSelectionChange(doc, sel, options) {
        var obj = {
            ranges: sel.ranges,
            update: function update(ranges) {
                this.ranges = [];
                for(var i = 0; i < ranges.length; i++){
                    this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor), clipPos(doc, ranges[i].head));
                }
            },
            origin: options && options.origin
        };
        signal(doc, "beforeSelectionChange", doc, obj);
        if (doc.cm) {
            signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
        }
        if (obj.ranges != sel.ranges) {
            return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
        } else {
            return sel;
        }
    };
    var setSelectionReplaceHistory = function setSelectionReplaceHistory(doc, sel, options) {
        var done = doc.history.done, last = lst(done);
        if (last && last.ranges) {
            done[done.length - 1] = sel;
            setSelectionNoUndo(doc, sel, options);
        } else {
            setSelection(doc, sel, options);
        }
    };
    var setSelection = // Set a new selection.
    function setSelection(doc, sel, options) {
        setSelectionNoUndo(doc, sel, options);
        addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
    };
    var setSelectionNoUndo = function setSelectionNoUndo(doc, sel, options) {
        if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) {
            sel = filterSelectionChange(doc, sel, options);
        }
        var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
        setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
        if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") {
            ensureCursorVisible(doc.cm);
        }
    };
    var setSelectionInner = function setSelectionInner(doc, sel) {
        if (sel.equals(doc.sel)) {
            return;
        }
        doc.sel = sel;
        if (doc.cm) {
            doc.cm.curOp.updateInput = 1;
            doc.cm.curOp.selectionChanged = true;
            signalCursorActivity(doc.cm);
        }
        signalLater(doc, "cursorActivity", doc);
    };
    var reCheckSelection = // Verify that the selection does not partially select any atomic
    // marked ranges.
    function reCheckSelection(doc) {
        setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
    };
    var skipAtomicInSelection = // Return a selection that does not partially select any atomic
    // ranges.
    function skipAtomicInSelection(doc, sel, bias, mayClear) {
        var out;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i];
            var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
            var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
            var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
            if (out || newAnchor != range.anchor || newHead != range.head) {
                if (!out) {
                    out = sel.ranges.slice(0, i);
                }
                out[i] = new Range(newAnchor, newHead);
            }
        }
        return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
    };
    var skipAtomic = // Ensure a given position is not inside an atomic range.
    function skipAtomic(doc, pos, oldPos, bias, mayClear) {
        var dir = bias || 1;
        var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
        if (!found) {
            doc.cantEdit = true;
            return Pos(doc.first, 0);
        }
        return found;
    };
    var movePos = function movePos(doc, pos, dir, line) {
        if (dir < 0 && pos.ch == 0) {
            if (pos.line > doc.first) {
                return clipPos(doc, Pos(pos.line - 1));
            } else {
                return null;
            }
        } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
            if (pos.line < doc.first + doc.size - 1) {
                return Pos(pos.line + 1, 0);
            } else {
                return null;
            }
        } else {
            return new Pos(pos.line, pos.ch + dir);
        }
    };
    var selectAll = function selectAll(cm) {
        cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    };
    var filterChange = // UPDATING
    // Allow "beforeChange" event handlers to influence a change
    function filterChange(doc, change, update) {
        var obj = {
            canceled: false,
            from: change.from,
            to: change.to,
            text: change.text,
            origin: change.origin,
            cancel: function cancel() {
                return obj.canceled = true;
            }
        };
        if (update) {
            obj.update = function(from, to, text, origin) {
                if (from) {
                    obj.from = clipPos(doc, from);
                }
                if (to) {
                    obj.to = clipPos(doc, to);
                }
                if (text) {
                    obj.text = text;
                }
                if (origin !== undefined) {
                    obj.origin = origin;
                }
            };
        }
        signal(doc, "beforeChange", doc, obj);
        if (doc.cm) {
            signal(doc.cm, "beforeChange", doc.cm, obj);
        }
        if (obj.canceled) {
            if (doc.cm) {
                doc.cm.curOp.updateInput = 2;
            }
            return null;
        }
        return {
            from: obj.from,
            to: obj.to,
            text: obj.text,
            origin: obj.origin
        };
    };
    var makeChangeInner = function makeChangeInner(doc, change) {
        if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) {
            return;
        }
        var selAfter = computeSelAfterChange(doc, change);
        addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
        makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
        var rebased = [];
        linkedDocs(doc, function(doc, sharedHist) {
            if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                rebaseHist(doc.history, change);
                rebased.push(doc.history);
            }
            makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
        });
    };
    var makeChangeFromHistory = // Revert a change stored in a document's history.
    function makeChangeFromHistory(doc, type, allowSelectionOnly) {
        var suppress = doc.cm && doc.cm.state.suppressEdits;
        if (suppress && !allowSelectionOnly) {
            return;
        }
        var hist = doc.history, event, selAfter = doc.sel;
        var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
        // Verify that there is a useable event (so that ctrl-z won't
        // needlessly clear selection events)
        var i = 0;
        for(; i < source.length; i++){
            event = source[i];
            if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) {
                break;
            }
        }
        if (i == source.length) {
            return;
        }
        hist.lastOrigin = hist.lastSelOrigin = null;
        for(;;){
            event = source.pop();
            if (event.ranges) {
                pushSelectionToHistory(event, dest);
                if (allowSelectionOnly && !event.equals(doc.sel)) {
                    setSelection(doc, event, {
                        clearRedo: false
                    });
                    return;
                }
                selAfter = event;
            } else if (suppress) {
                source.push(event);
                return;
            } else {
                break;
            }
        }
        // Build up a reverse change object to add to the opposite history
        // stack (redo when undoing, and vice versa).
        var antiChanges = [];
        pushSelectionToHistory(selAfter, dest);
        dest.push({
            changes: antiChanges,
            generation: hist.generation
        });
        hist.generation = event.generation || ++hist.maxGeneration;
        var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
        var loop = function loop(i) {
            var change = event.changes[i];
            change.origin = type;
            if (filter && !filterChange(doc, change, false)) {
                source.length = 0;
                return {};
            }
            antiChanges.push(historyChangeFromChange(doc, change));
            var after = i ? computeSelAfterChange(doc, change) : lst(source);
            makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
            if (!i && doc.cm) {
                doc.cm.scrollIntoView({
                    from: change.from,
                    to: changeEnd(change)
                });
            }
            var rebased = [];
            // Propagate to the linked documents
            linkedDocs(doc, function(doc, sharedHist) {
                if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                    rebaseHist(doc.history, change);
                    rebased.push(doc.history);
                }
                makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
            });
        };
        for(var i$1 = event.changes.length - 1; i$1 >= 0; --i$1){
            var returned = loop(i$1);
            if (returned) return returned.v;
        }
    };
    var shiftDoc = // Sub-views need their line numbers shifted when text is added
    // above or below them in the parent document.
    function shiftDoc(doc, distance) {
        if (distance == 0) {
            return;
        }
        doc.first += distance;
        doc.sel = new Selection(map(doc.sel.ranges, function(range) {
            return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
        }), doc.sel.primIndex);
        if (doc.cm) {
            regChange(doc.cm, doc.first, doc.first - distance, distance);
            for(var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++){
                regLineChange(doc.cm, l, "gutter");
            }
        }
    };
    var makeChangeSingleDocInEditor = // Handle the interaction of a change to a document with the editor
    // that this document is part of.
    function makeChangeSingleDocInEditor(cm, change, spans) {
        var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
        var recomputeMaxLength = false, checkWidthStart = from.line;
        if (!cm.options.lineWrapping) {
            checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
            doc.iter(checkWidthStart, to.line + 1, function(line) {
                if (line == display.maxLine) {
                    recomputeMaxLength = true;
                    return true;
                }
            });
        }
        if (doc.sel.contains(change.from, change.to) > -1) {
            signalCursorActivity(cm);
        }
        updateDoc(doc, change, spans, estimateHeight(cm));
        if (!cm.options.lineWrapping) {
            doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
                var len = lineLength(line);
                if (len > display.maxLineLength) {
                    display.maxLine = line;
                    display.maxLineLength = len;
                    display.maxLineChanged = true;
                    recomputeMaxLength = false;
                }
            });
            if (recomputeMaxLength) {
                cm.curOp.updateMaxLine = true;
            }
        }
        retreatFrontier(doc, from.line);
        startWorker(cm, 400);
        var lendiff = change.text.length - (to.line - from.line) - 1;
        // Remember that these lines changed, for updating the display
        if (change.full) {
            regChange(cm);
        } else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) {
            regLineChange(cm, from.line, "text");
        } else {
            regChange(cm, from.line, to.line + 1, lendiff);
        }
        var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
        if (changeHandler || changesHandler) {
            var obj = {
                from: from,
                to: to,
                text: change.text,
                removed: change.removed,
                origin: change.origin
            };
            if (changeHandler) {
                signalLater(cm, "change", cm, obj);
            }
            if (changesHandler) {
                (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
            }
        }
        cm.display.selForContextMenu = null;
    };
    var replaceRange = function replaceRange(doc, code, from, to, origin) {
        var assign;
        if (!to) {
            to = from;
        }
        if (cmp(to, from) < 0) {
            assign = [
                to,
                from
            ], from = assign[0], to = assign[1];
        }
        if (typeof code == "string") {
            code = doc.splitLines(code);
        }
        makeChange(doc, {
            from: from,
            to: to,
            text: code,
            origin: origin
        });
    };
    var rebaseHistSelSingle = // Rebasing/resetting history to deal with externally-sourced changes
    function rebaseHistSelSingle(pos, from, to, diff) {
        if (to < pos.line) {
            pos.line += diff;
        } else if (from < pos.line) {
            pos.line = from;
            pos.ch = 0;
        }
    };
    var rebaseHistArray = // Tries to rebase an array of history events given a change in the
    // document. If the change touches the same lines as the event, the
    // event, and everything 'behind' it, is discarded. If the change is
    // before the event, the event's positions are updated. Uses a
    // copy-on-write scheme for the positions, to avoid having to
    // reallocate them all on every rebase, but also avoid problems with
    // shared position objects being unsafely updated.
    function rebaseHistArray(array, from, to, diff) {
        for(var i = 0; i < array.length; ++i){
            var sub = array[i], ok = true;
            if (sub.ranges) {
                if (!sub.copied) {
                    sub = array[i] = sub.deepCopy();
                    sub.copied = true;
                }
                for(var j = 0; j < sub.ranges.length; j++){
                    rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
                    rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
                }
                continue;
            }
            for(var j$1 = 0; j$1 < sub.changes.length; ++j$1){
                var cur = sub.changes[j$1];
                if (to < cur.from.line) {
                    cur.from = Pos(cur.from.line + diff, cur.from.ch);
                    cur.to = Pos(cur.to.line + diff, cur.to.ch);
                } else if (from <= cur.to.line) {
                    ok = false;
                    break;
                }
            }
            if (!ok) {
                array.splice(0, i + 1);
                i = 0;
            }
        }
    };
    var rebaseHist = function rebaseHist(hist, change) {
        var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
        rebaseHistArray(hist.done, from, to, diff);
        rebaseHistArray(hist.undone, from, to, diff);
    };
    var changeLine = // Utility for applying a change to a line by handle or number,
    // returning the number and optionally registering the line as
    // changed.
    function changeLine(doc, handle, changeType, op) {
        var no = handle, line = handle;
        if (typeof handle == "number") {
            line = getLine(doc, clipLine(doc, handle));
        } else {
            no = lineNo(handle);
        }
        if (no == null) {
            return null;
        }
        if (op(line, no) && doc.cm) {
            regLineChange(doc.cm, no, changeType);
        }
        return line;
    };
    var LeafChunk = // The document is represented as a BTree consisting of leaves, with
    // chunk of lines in them, and branches, with up to ten leaves or
    // other branch nodes below them. The top node is always a branch
    // node, and is the document object itself (meaning it has
    // additional methods and properties).
    //
    // All nodes have parent links. The tree is used both to go from
    // line numbers to line objects, and to go from objects to numbers.
    // It also indexes by height, and is used to convert between height
    // and line object, and to find the total height of the document.
    //
    // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
    function LeafChunk(lines) {
        this.lines = lines;
        this.parent = null;
        var height = 0;
        for(var i = 0; i < lines.length; ++i){
            lines[i].parent = this;
            height += lines[i].height;
        }
        this.height = height;
    };
    var BranchChunk = function BranchChunk(children) {
        this.children = children;
        var size = 0, height = 0;
        for(var i = 0; i < children.length; ++i){
            var ch = children[i];
            size += ch.chunkSize();
            height += ch.height;
            ch.parent = this;
        }
        this.size = size;
        this.height = height;
        this.parent = null;
    };
    var adjustScrollWhenAboveVisible = function adjustScrollWhenAboveVisible(cm, line, diff) {
        if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) {
            addToScrollTop(cm, diff);
        }
    };
    var addLineWidget = function addLineWidget(doc, handle, node, options) {
        var widget = new LineWidget(doc, node, options);
        var cm = doc.cm;
        if (cm && widget.noHScroll) {
            cm.display.alignWidgets = true;
        }
        changeLine(doc, handle, "widget", function(line) {
            var widgets = line.widgets || (line.widgets = []);
            if (widget.insertAt == null) {
                widgets.push(widget);
            } else {
                widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
            }
            widget.line = line;
            if (cm && !lineIsHidden(doc, line)) {
                var aboveVisible = heightAtLine(line) < doc.scrollTop;
                updateLineHeight(line, line.height + widgetHeight(widget));
                if (aboveVisible) {
                    addToScrollTop(cm, widget.height);
                }
                cm.curOp.forceUpdate = true;
            }
            return true;
        });
        if (cm) {
            signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
        }
        return widget;
    };
    var markTextShared = function markTextShared(doc, from, to, options, type) {
        options = copyObj(options);
        options.shared = false;
        var markers = [
            markText(doc, from, to, options, type)
        ], primary = markers[0];
        var widget = options.widgetNode;
        linkedDocs(doc, function(doc) {
            if (widget) {
                options.widgetNode = widget.cloneNode(true);
            }
            markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
            for(var i = 0; i < doc.linked.length; ++i){
                if (doc.linked[i].isParent) {
                    return;
                }
            }
            primary = lst(markers);
        });
        return new SharedTextMarker(markers, primary);
    };
    var findSharedMarkers = function findSharedMarkers(doc) {
        return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function(m) {
            return m.parent;
        });
    };
    var copySharedMarkers = function copySharedMarkers(doc, markers) {
        for(var i = 0; i < markers.length; i++){
            var marker = markers[i], pos = marker.find();
            var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
            if (cmp(mFrom, mTo)) {
                var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
                marker.markers.push(subMark);
                subMark.parent = marker;
            }
        }
    };
    var detachSharedMarkers = function detachSharedMarkers(markers) {
        var loop = function loop(i) {
            var marker = markers[i], linked = [
                marker.primary.doc
            ];
            linkedDocs(marker.primary.doc, function(d) {
                return linked.push(d);
            });
            for(var j = 0; j < marker.markers.length; j++){
                var subMarker = marker.markers[j];
                if (indexOf(linked, subMarker.doc) == -1) {
                    subMarker.parent = null;
                    marker.markers.splice(j--, 1);
                }
            }
        };
        for(var i = 0; i < markers.length; i++)loop(i);
    };
    var onDrop = function onDrop(e) {
        var cm = this;
        clearDragCursor(cm);
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
            return;
        }
        e_preventDefault(e);
        if (ie) {
            lastDrop = +new Date;
        }
        var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
        if (!pos || cm.isReadOnly()) {
            return;
        }
        // Might be a file drop, in which case we simply extract the text
        // and insert it.
        if (files && files.length && window.FileReader && window.File) {
            var n = files.length, text = Array(n), read = 0;
            var markAsReadAndPasteIfAllFilesAreRead = function markAsReadAndPasteIfAllFilesAreRead() {
                if (++read == n) {
                    operation(cm, function() {
                        pos = clipPos(cm.doc, pos);
                        var change = {
                            from: pos,
                            to: pos,
                            text: cm.doc.splitLines(text.filter(function(t) {
                                return t != null;
                            }).join(cm.doc.lineSeparator())),
                            origin: "paste"
                        };
                        makeChange(cm.doc, change);
                        setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
                    })();
                }
            };
            var readTextFromFile = function readTextFromFile(file, i) {
                if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
                    markAsReadAndPasteIfAllFilesAreRead();
                    return;
                }
                var reader = new FileReader;
                reader.onerror = function() {
                    return markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.onload = function() {
                    var content = reader.result;
                    if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
                        markAsReadAndPasteIfAllFilesAreRead();
                        return;
                    }
                    text[i] = content;
                    markAsReadAndPasteIfAllFilesAreRead();
                };
                reader.readAsText(file);
            };
            for(var i = 0; i < files.length; i++){
                readTextFromFile(files[i], i);
            }
        } else {
            // Don't do a replace if the drop happened inside of the selected text.
            if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
                cm.state.draggingText(e);
                // Ensure the editor is re-focused
                setTimeout(function() {
                    return cm.display.input.focus();
                }, 20);
                return;
            }
            try {
                var text$1 = e.dataTransfer.getData("Text");
                if (text$1) {
                    var selected;
                    if (cm.state.draggingText && !cm.state.draggingText.copy) {
                        selected = cm.listSelections();
                    }
                    setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
                    if (selected) {
                        for(var i$1 = 0; i$1 < selected.length; ++i$1){
                            replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
                        }
                    }
                    cm.replaceSelection(text$1, "around", "paste");
                    cm.display.input.focus();
                }
            } catch (e$1) {}
        }
    };
    var onDragStart = function onDragStart(cm, e) {
        if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) {
            e_stop(e);
            return;
        }
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
            return;
        }
        e.dataTransfer.setData("Text", cm.getSelection());
        e.dataTransfer.effectAllowed = "copyMove";
        // Use dummy image instead of default browsers image.
        // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
        if (e.dataTransfer.setDragImage && !safari) {
            var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
            img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            if (presto) {
                img.width = img.height = 1;
                cm.display.wrapper.appendChild(img);
                // Force a relayout, or Opera won't use our image for some obscure reason
                img._top = img.offsetTop;
            }
            e.dataTransfer.setDragImage(img, 0, 0);
            if (presto) {
                img.parentNode.removeChild(img);
            }
        }
    };
    var onDragOver = function onDragOver(cm, e) {
        var pos = posFromMouse(cm, e);
        if (!pos) {
            return;
        }
        var frag = document.createDocumentFragment();
        drawSelectionCursor(cm, pos, frag);
        if (!cm.display.dragCursor) {
            cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
            cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
        }
        removeChildrenAndAdd(cm.display.dragCursor, frag);
    };
    var clearDragCursor = function clearDragCursor(cm) {
        if (cm.display.dragCursor) {
            cm.display.lineSpace.removeChild(cm.display.dragCursor);
            cm.display.dragCursor = null;
        }
    };
    var forEachCodeMirror = // These must be handled carefully, because naively registering a
    // handler for each editor will cause the editors to never be
    // garbage collected.
    function forEachCodeMirror(f) {
        if (!document.getElementsByClassName) {
            return;
        }
        var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
        for(var i = 0; i < byClass.length; i++){
            var cm = byClass[i].CodeMirror;
            if (cm) {
                editors.push(cm);
            }
        }
        if (editors.length) {
            editors[0].operation(function() {
                for(var i = 0; i < editors.length; i++){
                    f(editors[i]);
                }
            });
        }
    };
    var ensureGlobalHandlers = function ensureGlobalHandlers() {
        if (globalsRegistered) {
            return;
        }
        registerGlobalHandlers();
        globalsRegistered = true;
    };
    var registerGlobalHandlers = function registerGlobalHandlers() {
        // When the window resizes, we need to refresh active editors.
        var resizeTimer;
        on(window, "resize", function() {
            if (resizeTimer == null) {
                resizeTimer = setTimeout(function() {
                    resizeTimer = null;
                    forEachCodeMirror(onResize);
                }, 100);
            }
        });
        // When the window loses focus, we want to show the editor as blurred
        on(window, "blur", function() {
            return forEachCodeMirror(onBlur);
        });
    };
    var onResize = // Called when the window resizes
    function onResize(cm) {
        var d = cm.display;
        // Might be a text scaling operation, clear size caches.
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        d.scrollbarsClipped = false;
        cm.setSize();
    };
    var normalizeKeyName = // KEYMAP DISPATCH
    function normalizeKeyName(name) {
        var parts = name.split(/-(?!$)/);
        name = parts[parts.length - 1];
        var alt, ctrl, shift, cmd;
        for(var i = 0; i < parts.length - 1; i++){
            var mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) {
                cmd = true;
            } else if (/^a(lt)?$/i.test(mod)) {
                alt = true;
            } else if (/^(c|ctrl|control)$/i.test(mod)) {
                ctrl = true;
            } else if (/^s(hift)?$/i.test(mod)) {
                shift = true;
            } else {
                throw new Error("Unrecognized modifier name: " + mod);
            }
        }
        if (alt) {
            name = "Alt-" + name;
        }
        if (ctrl) {
            name = "Ctrl-" + name;
        }
        if (cmd) {
            name = "Cmd-" + name;
        }
        if (shift) {
            name = "Shift-" + name;
        }
        return name;
    };
    var normalizeKeyMap = // This is a kludge to keep keymaps mostly working as raw objects
    // (backwards compatibility) while at the same time support features
    // like normalization and multi-stroke key bindings. It compiles a
    // new normalized keymap, and then updates the old object to reflect
    // this.
    function normalizeKeyMap(keymap) {
        var copy = {};
        for(var keyname in keymap){
            if (keymap.hasOwnProperty(keyname)) {
                var value = keymap[keyname];
                if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) {
                    continue;
                }
                if (value == "...") {
                    delete keymap[keyname];
                    continue;
                }
                var keys = map(keyname.split(" "), normalizeKeyName);
                for(var i = 0; i < keys.length; i++){
                    var val = void 0, name = void 0;
                    if (i == keys.length - 1) {
                        name = keys.join(" ");
                        val = value;
                    } else {
                        name = keys.slice(0, i + 1).join(" ");
                        val = "...";
                    }
                    var prev = copy[name];
                    if (!prev) {
                        copy[name] = val;
                    } else if (prev != val) {
                        throw new Error("Inconsistent bindings for " + name);
                    }
                }
                delete keymap[keyname];
            }
        }
        for(var prop in copy){
            keymap[prop] = copy[prop];
        }
        return keymap;
    };
    var isModifierKey = // Modifier key presses don't count as 'real' key presses for the
    // purpose of keymap fallthrough.
    function isModifierKey(value) {
        var name = typeof value == "string" ? value : keyNames[value.keyCode];
        return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    };
    var addModifierNames = function addModifierNames(name, event, noShift) {
        var base = name;
        if (event.altKey && base != "Alt") {
            name = "Alt-" + name;
        }
        if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") {
            name = "Ctrl-" + name;
        }
        if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") {
            name = "Cmd-" + name;
        }
        if (!noShift && event.shiftKey && base != "Shift") {
            name = "Shift-" + name;
        }
        return name;
    };
    var keyName = // Look up the name of a key as indicated by an event object.
    function keyName(event, noShift) {
        if (presto && event.keyCode == 34 && event["char"]) {
            return false;
        }
        var name = keyNames[event.keyCode];
        if (name == null || event.altGraphKey) {
            return false;
        }
        // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
        // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
        if (event.keyCode == 3 && event.code) {
            name = event.code;
        }
        return addModifierNames(name, event, noShift);
    };
    var getKeyMap = function getKeyMap(val) {
        return typeof val == "string" ? keyMap[val] : val;
    };
    var deleteNearSelection = // Helper for deleting text near the selection(s), used to implement
    // backspace, delete, and similar functionality.
    function deleteNearSelection(cm, compute) {
        var ranges = cm.doc.sel.ranges, kill = [];
        // Build up a set of ranges to kill first, merging overlapping
        // ranges.
        for(var i = 0; i < ranges.length; i++){
            var toKill = compute(ranges[i]);
            while(kill.length && cmp(toKill.from, lst(kill).to) <= 0){
                var replaced = kill.pop();
                if (cmp(replaced.from, toKill.from) < 0) {
                    toKill.from = replaced.from;
                    break;
                }
            }
            kill.push(toKill);
        }
        // Next, remove those actual ranges.
        runInOp(cm, function() {
            for(var i = kill.length - 1; i >= 0; i--){
                replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
            }
            ensureCursorVisible(cm);
        });
    };
    var moveCharLogically = function moveCharLogically(line, ch, dir) {
        var target = skipExtendingChars(line.text, ch + dir, dir);
        return target < 0 || target > line.text.length ? null : target;
    };
    var moveLogically = function moveLogically(line, start, dir) {
        var ch = moveCharLogically(line, start.ch, dir);
        return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    };
    var endOfLine = function endOfLine(visually, cm, lineObj, lineNo, dir) {
        if (visually) {
            if (cm.doc.direction == "rtl") {
                dir = -dir;
            }
            var order = getOrder(lineObj, cm.doc.direction);
            if (order) {
                var part = dir < 0 ? lst(order) : order[0];
                var moveInStorageOrder = dir < 0 == (part.level == 1);
                var sticky = moveInStorageOrder ? "after" : "before";
                var ch;
                // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
                // it could be that the last bidi part is not on the last visual line,
                // since visual lines contain content order-consecutive chunks.
                // Thus, in rtl, we are looking for the first (content-order) character
                // in the rtl chunk that is on the last line (that is, the same line
                // as the last (content-order) character).
                if (part.level > 0 || cm.doc.direction == "rtl") {
                    var prep = prepareMeasureForLine(cm, lineObj);
                    ch = dir < 0 ? lineObj.text.length - 1 : 0;
                    var targetTop = measureCharPrepared(cm, prep, ch).top;
                    ch = findFirst(function(ch) {
                        return measureCharPrepared(cm, prep, ch).top == targetTop;
                    }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
                    if (sticky == "before") {
                        ch = moveCharLogically(lineObj, ch, 1);
                    }
                } else {
                    ch = dir < 0 ? part.to : part.from;
                }
                return new Pos(lineNo, ch, sticky);
            }
        }
        return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    };
    var moveVisually = function moveVisually(cm, line, start, dir) {
        var bidi = getOrder(line, cm.doc.direction);
        if (!bidi) {
            return moveLogically(line, start, dir);
        }
        if (start.ch >= line.text.length) {
            start.ch = line.text.length;
            start.sticky = "before";
        } else if (start.ch <= 0) {
            start.ch = 0;
            start.sticky = "after";
        }
        var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
        if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
            // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
            // nothing interesting happens.
            return moveLogically(line, start, dir);
        }
        var mv = function mv(pos, dir) {
            return moveCharLogically(line, _instanceof(pos, Pos) ? pos.ch : pos, dir);
        };
        var prep;
        var getWrappedLineExtent = function getWrappedLineExtent(ch) {
            if (!cm.options.lineWrapping) {
                return {
                    begin: 0,
                    end: line.text.length
                };
            }
            prep = prep || prepareMeasureForLine(cm, line);
            return wrappedLineExtentChar(cm, line, prep, ch);
        };
        var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
        if (cm.doc.direction == "rtl" || part.level == 1) {
            var moveInStorageOrder = part.level == 1 == dir < 0;
            var ch = mv(start, moveInStorageOrder ? 1 : -1);
            if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
                // Case 2: We move within an rtl part or in an rtl editor on the same visual line
                var sticky = moveInStorageOrder ? "before" : "after";
                return new Pos(start.line, ch, sticky);
            }
        }
        // Case 3: Could not move within this bidi part in this visual line, so leave
        // the current bidi part
        var searchInVisualLine = function searchInVisualLine(partPos, dir, wrappedLineExtent) {
            var getRes = function getRes(ch, moveInStorageOrder) {
                return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
            };
            for(; partPos >= 0 && partPos < bidi.length; partPos += dir){
                var part = bidi[partPos];
                var moveInStorageOrder = dir > 0 == (part.level != 1);
                var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
                if (part.from <= ch && ch < part.to) {
                    return getRes(ch, moveInStorageOrder);
                }
                ch = moveInStorageOrder ? part.from : mv(part.to, -1);
                if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) {
                    return getRes(ch, moveInStorageOrder);
                }
            }
        };
        // Case 3a: Look for other bidi parts on the same visual line
        var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
        if (res) {
            return res;
        }
        // Case 3b: Look for other bidi parts on the next visual line
        var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
        if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
            res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
            if (res) {
                return res;
            }
        }
        // Case 4: Nowhere to move
        return null;
    };
    var lineStart = function lineStart(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLine(line);
        if (visual != line) {
            lineN = lineNo(visual);
        }
        return endOfLine(true, cm, visual, lineN, 1);
    };
    var lineEnd = function lineEnd(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLineEnd(line);
        if (visual != line) {
            lineN = lineNo(visual);
        }
        return endOfLine(true, cm, line, lineN, -1);
    };
    var lineStartSmart = function lineStartSmart(cm, pos) {
        var start = lineStart(cm, pos.line);
        var line = getLine(cm.doc, start.line);
        var order = getOrder(line, cm.doc.direction);
        if (!order || order[0].level == 0) {
            var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
            var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
            return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
        }
        return start;
    };
    var doHandleBinding = // Run a handler that was bound to a key.
    function doHandleBinding(cm, bound, dropShift) {
        if (typeof bound == "string") {
            bound = commands[bound];
            if (!bound) {
                return false;
            }
        }
        // Ensure previous input has been read, so that the handler sees a
        // consistent view of the document
        cm.display.input.ensurePolled();
        var prevShift = cm.display.shift, done = false;
        try {
            if (cm.isReadOnly()) {
                cm.state.suppressEdits = true;
            }
            if (dropShift) {
                cm.display.shift = false;
            }
            done = bound(cm) != Pass;
        } finally{
            cm.display.shift = prevShift;
            cm.state.suppressEdits = false;
        }
        return done;
    };
    var lookupKeyForEditor = function lookupKeyForEditor(cm, name, handle) {
        for(var i = 0; i < cm.state.keyMaps.length; i++){
            var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
            if (result) {
                return result;
            }
        }
        return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    };
    var dispatchKey = function dispatchKey(cm, name, e, handle) {
        var seq = cm.state.keySeq;
        if (seq) {
            if (isModifierKey(name)) {
                return "handled";
            }
            if (/\'$/.test(name)) {
                cm.state.keySeq = null;
            } else {
                stopSeq.set(50, function() {
                    if (cm.state.keySeq == seq) {
                        cm.state.keySeq = null;
                        cm.display.input.reset();
                    }
                });
            }
            if (dispatchKeyInner(cm, seq + " " + name, e, handle)) {
                return true;
            }
        }
        return dispatchKeyInner(cm, name, e, handle);
    };
    var dispatchKeyInner = function dispatchKeyInner(cm, name, e, handle) {
        var result = lookupKeyForEditor(cm, name, handle);
        if (result == "multi") {
            cm.state.keySeq = name;
        }
        if (result == "handled") {
            signalLater(cm, "keyHandled", cm, name, e);
        }
        if (result == "handled" || result == "multi") {
            e_preventDefault(e);
            restartBlink(cm);
        }
        return !!result;
    };
    var handleKeyBinding = // Handle a key from the keydown event.
    function handleKeyBinding(cm, e) {
        var name = keyName(e, true);
        if (!name) {
            return false;
        }
        if (e.shiftKey && !cm.state.keySeq) {
            // First try to resolve full name (including 'Shift-'). Failing
            // that, see if there is a cursor-motion command (starting with
            // 'go') bound to the keyname without 'Shift-'.
            return dispatchKey(cm, "Shift-" + name, e, function(b) {
                return doHandleBinding(cm, b, true);
            }) || dispatchKey(cm, name, e, function(b) {
                if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) {
                    return doHandleBinding(cm, b);
                }
            });
        } else {
            return dispatchKey(cm, name, e, function(b) {
                return doHandleBinding(cm, b);
            });
        }
    };
    var handleCharBinding = // Handle a key from the keypress event
    function handleCharBinding(cm, e, ch) {
        return dispatchKey(cm, "'" + ch + "'", e, function(b) {
            return doHandleBinding(cm, b, true);
        });
    };
    var onKeyDown = function onKeyDown(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) {
            return;
        }
        cm.curOp.focus = activeElt();
        if (signalDOMEvent(cm, e)) {
            return;
        }
        // IE does strange things with escape.
        if (ie && ie_version < 11 && e.keyCode == 27) {
            e.returnValue = false;
        }
        var code = e.keyCode;
        cm.display.shift = code == 16 || e.shiftKey;
        var handled = handleKeyBinding(cm, e);
        if (presto) {
            lastStoppedKey = handled ? code : null;
            // Opera has no cut event... we try to at least catch the key combo
            if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) {
                cm.replaceSelection("", null, "cut");
            }
        }
        if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) {
            document.execCommand("cut");
        }
        // Turn mouse into crosshair when Alt is held on Mac.
        if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) {
            showCrossHair(cm);
        }
    };
    var showCrossHair = function showCrossHair(cm) {
        var lineDiv = cm.display.lineDiv;
        addClass(lineDiv, "CodeMirror-crosshair");
        function up(e) {
            if (e.keyCode == 18 || !e.altKey) {
                rmClass(lineDiv, "CodeMirror-crosshair");
                off(document, "keyup", up);
                off(document, "mouseover", up);
            }
        }
        on(document, "keyup", up);
        on(document, "mouseover", up);
    };
    var onKeyUp = function onKeyUp(e) {
        if (e.keyCode == 16) {
            this.doc.sel.shift = false;
        }
        signalDOMEvent(this, e);
    };
    var onKeyPress = function onKeyPress(e) {
        var cm = this;
        if (e.target && e.target != cm.display.input.getField()) {
            return;
        }
        if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) {
            return;
        }
        var keyCode = e.keyCode, charCode = e.charCode;
        if (presto && keyCode == lastStoppedKey) {
            lastStoppedKey = null;
            e_preventDefault(e);
            return;
        }
        if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) {
            return;
        }
        var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
        // Some browsers fire keypress events for backspace
        if (ch == "\b") {
            return;
        }
        if (handleCharBinding(cm, e, ch)) {
            return;
        }
        cm.display.input.onKeyPress(e);
    };
    var clickRepeat = function clickRepeat(pos, button) {
        var now = +new Date;
        if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
            lastClick = lastDoubleClick = null;
            return "triple";
        } else if (lastClick && lastClick.compare(now, pos, button)) {
            lastDoubleClick = new PastClick(now, pos, button);
            lastClick = null;
            return "double";
        } else {
            lastClick = new PastClick(now, pos, button);
            lastDoubleClick = null;
            return "single";
        }
    };
    var onMouseDown = // A mouse down can be a single click, double click, triple click,
    // start of selection drag, start of text drag, new cursor
    // (ctrl-click), rectangle drag (alt-drag), or xwin
    // middle-click-paste. Or it might be a click on something we should
    // not interfere with, such as a scrollbar or widget.
    function onMouseDown(e) {
        var cm = this, display = cm.display;
        if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) {
            return;
        }
        display.input.ensurePolled();
        display.shift = e.shiftKey;
        if (eventInWidget(display, e)) {
            if (!webkit) {
                // Briefly turn off draggability, to allow widgets to do
                // normal dragging things.
                display.scroller.draggable = false;
                setTimeout(function() {
                    return display.scroller.draggable = true;
                }, 100);
            }
            return;
        }
        if (clickInGutter(cm, e)) {
            return;
        }
        var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
        window.focus();
        // #3261: make sure, that we're not starting a second selection
        if (button == 1 && cm.state.selectingText) {
            cm.state.selectingText(e);
        }
        if (pos && handleMappedButton(cm, button, pos, repeat, e)) {
            return;
        }
        if (button == 1) {
            if (pos) {
                leftButtonDown(cm, pos, repeat, e);
            } else if (e_target(e) == display.scroller) {
                e_preventDefault(e);
            }
        } else if (button == 2) {
            if (pos) {
                extendSelection(cm.doc, pos);
            }
            setTimeout(function() {
                return display.input.focus();
            }, 20);
        } else if (button == 3) {
            if (captureRightClick) {
                cm.display.input.onContextMenu(e);
            } else {
                delayBlurEvent(cm);
            }
        }
    };
    var handleMappedButton = function handleMappedButton(cm, button, pos, repeat, event) {
        var name = "Click";
        if (repeat == "double") {
            name = "Double" + name;
        } else if (repeat == "triple") {
            name = "Triple" + name;
        }
        name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
        return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
            if (typeof bound == "string") {
                bound = commands[bound];
            }
            if (!bound) {
                return false;
            }
            var done = false;
            try {
                if (cm.isReadOnly()) {
                    cm.state.suppressEdits = true;
                }
                done = bound(cm, pos) != Pass;
            } finally{
                cm.state.suppressEdits = false;
            }
            return done;
        });
    };
    var configureMouse = function configureMouse(cm, repeat, event) {
        var option = cm.getOption("configureMouse");
        var value = option ? option(cm, repeat, event) : {};
        if (value.unit == null) {
            var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
            value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
        }
        if (value.extend == null || cm.doc.extend) {
            value.extend = cm.doc.extend || event.shiftKey;
        }
        if (value.addNew == null) {
            value.addNew = mac ? event.metaKey : event.ctrlKey;
        }
        if (value.moveOnDrag == null) {
            value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
        }
        return value;
    };
    var leftButtonDown = function leftButtonDown(cm, pos, repeat, event) {
        if (ie) {
            setTimeout(bind(ensureFocus, cm), 0);
        } else {
            cm.curOp.focus = activeElt();
        }
        var behavior = configureMouse(cm, repeat, event);
        var sel = cm.doc.sel, contained;
        if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) {
            leftButtonStartDrag(cm, event, pos, behavior);
        } else {
            leftButtonSelect(cm, event, pos, behavior);
        }
    };
    var leftButtonStartDrag = // Start a text drag. When it ends, see if any dragging actually
    // happen, and treat as a click if it didn't.
    function leftButtonStartDrag(cm, event, pos, behavior) {
        var display = cm.display, moved = false;
        var dragEnd = operation(cm, function(e) {
            if (webkit) {
                display.scroller.draggable = false;
            }
            cm.state.draggingText = false;
            if (cm.state.delayingBlurEvent) {
                if (cm.hasFocus()) {
                    cm.state.delayingBlurEvent = false;
                } else {
                    delayBlurEvent(cm);
                }
            }
            off(display.wrapper.ownerDocument, "mouseup", dragEnd);
            off(display.wrapper.ownerDocument, "mousemove", mouseMove);
            off(display.scroller, "dragstart", dragStart);
            off(display.scroller, "drop", dragEnd);
            if (!moved) {
                e_preventDefault(e);
                if (!behavior.addNew) {
                    extendSelection(cm.doc, pos, null, null, behavior.extend);
                }
                // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
                if (webkit && !safari || ie && ie_version == 9) {
                    setTimeout(function() {
                        display.wrapper.ownerDocument.body.focus({
                            preventScroll: true
                        });
                        display.input.focus();
                    }, 20);
                } else {
                    display.input.focus();
                }
            }
        });
        var mouseMove = function mouseMove(e2) {
            moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
        };
        var dragStart = function dragStart() {
            return moved = true;
        };
        // Let the drag handler handle this.
        if (webkit) {
            display.scroller.draggable = true;
        }
        cm.state.draggingText = dragEnd;
        dragEnd.copy = !behavior.moveOnDrag;
        on(display.wrapper.ownerDocument, "mouseup", dragEnd);
        on(display.wrapper.ownerDocument, "mousemove", mouseMove);
        on(display.scroller, "dragstart", dragStart);
        on(display.scroller, "drop", dragEnd);
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            return display.input.focus();
        }, 20);
        // IE's approach to draggable
        if (display.scroller.dragDrop) {
            display.scroller.dragDrop();
        }
    };
    var rangeForUnit = function rangeForUnit(cm, pos, unit) {
        if (unit == "char") {
            return new Range(pos, pos);
        }
        if (unit == "word") {
            return cm.findWordAt(pos);
        }
        if (unit == "line") {
            return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
        }
        var result = unit(cm, pos);
        return new Range(result.from, result.to);
    };
    var leftButtonSelect = // Normal selection, as opposed to text dragging.
    function leftButtonSelect(cm, event, start, behavior) {
        if (ie) {
            delayBlurEvent(cm);
        }
        var display = cm.display, doc = cm.doc;
        e_preventDefault(event);
        var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
        if (behavior.addNew && !behavior.extend) {
            ourIndex = doc.sel.contains(start);
            if (ourIndex > -1) {
                ourRange = ranges[ourIndex];
            } else {
                ourRange = new Range(start, start);
            }
        } else {
            ourRange = doc.sel.primary();
            ourIndex = doc.sel.primIndex;
        }
        if (behavior.unit == "rectangle") {
            if (!behavior.addNew) {
                ourRange = new Range(start, start);
            }
            start = posFromMouse(cm, event, true, true);
            ourIndex = -1;
        } else {
            var range = rangeForUnit(cm, start, behavior.unit);
            if (behavior.extend) {
                ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
            } else {
                ourRange = range;
            }
        }
        if (!behavior.addNew) {
            ourIndex = 0;
            setSelection(doc, new Selection([
                ourRange
            ], 0), sel_mouse);
            startSel = doc.sel;
        } else if (ourIndex == -1) {
            ourIndex = ranges.length;
            setSelection(doc, normalizeSelection(cm, ranges.concat([
                ourRange
            ]), ourIndex), {
                scroll: false,
                origin: "*mouse"
            });
        } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
            setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), {
                scroll: false,
                origin: "*mouse"
            });
            startSel = doc.sel;
        } else {
            replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
        }
        var lastPos = start;
        function extendTo(pos) {
            if (cmp(lastPos, pos) == 0) {
                return;
            }
            lastPos = pos;
            if (behavior.unit == "rectangle") {
                var ranges = [], tabSize = cm.options.tabSize;
                var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
                var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
                var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
                for(var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++){
                    var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
                    if (left == right) {
                        ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
                    } else if (text.length > leftPos) {
                        ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
                    }
                }
                if (!ranges.length) {
                    ranges.push(new Range(start, start));
                }
                setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), {
                    origin: "*mouse",
                    scroll: false
                });
                cm.scrollIntoView(pos);
            } else {
                var oldRange = ourRange;
                var range = rangeForUnit(cm, pos, behavior.unit);
                var anchor = oldRange.anchor, head;
                if (cmp(range.anchor, anchor) > 0) {
                    head = range.head;
                    anchor = minPos(oldRange.from(), range.anchor);
                } else {
                    head = range.anchor;
                    anchor = maxPos(oldRange.to(), range.head);
                }
                var ranges$1 = startSel.ranges.slice(0);
                ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
                setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
            }
        }
        var editorSize = display.wrapper.getBoundingClientRect();
        // Used to ensure timeout re-tries don't fire when another extend
        // happened in the meantime (clearTimeout isn't reliable -- at
        // least on Chrome, the timeouts still happen even when cleared,
        // if the clear happens after their scheduled firing time).
        var counter = 0;
        function extend(e) {
            var curCount = ++counter;
            var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
            if (!cur) {
                return;
            }
            if (cmp(cur, lastPos) != 0) {
                cm.curOp.focus = activeElt();
                extendTo(cur);
                var visible = visibleLines(display, doc);
                if (cur.line >= visible.to || cur.line < visible.from) {
                    setTimeout(operation(cm, function() {
                        if (counter == curCount) {
                            extend(e);
                        }
                    }), 150);
                }
            } else {
                var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
                if (outside) {
                    setTimeout(operation(cm, function() {
                        if (counter != curCount) {
                            return;
                        }
                        display.scroller.scrollTop += outside;
                        extend(e);
                    }), 50);
                }
            }
        }
        function done(e) {
            cm.state.selectingText = false;
            counter = Infinity;
            // If e is null or undefined we interpret this as someone trying
            // to explicitly cancel the selection rather than the user
            // letting go of the mouse button.
            if (e) {
                e_preventDefault(e);
                display.input.focus();
            }
            off(display.wrapper.ownerDocument, "mousemove", move);
            off(display.wrapper.ownerDocument, "mouseup", up);
            doc.history.lastSelOrigin = null;
        }
        var move = operation(cm, function(e) {
            if (e.buttons === 0 || !e_button(e)) {
                done(e);
            } else {
                extend(e);
            }
        });
        var up = operation(cm, done);
        cm.state.selectingText = up;
        on(display.wrapper.ownerDocument, "mousemove", move);
        on(display.wrapper.ownerDocument, "mouseup", up);
    };
    var bidiSimplify = // Used when mouse-selecting to adjust the anchor to the proper side
    // of a bidi jump depending on the visual position of the head.
    function bidiSimplify(cm, range) {
        var anchor = range.anchor;
        var head = range.head;
        var anchorLine = getLine(cm.doc, anchor.line);
        if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) {
            return range;
        }
        var order = getOrder(anchorLine);
        if (!order) {
            return range;
        }
        var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
        if (part.from != anchor.ch && part.to != anchor.ch) {
            return range;
        }
        var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
        if (boundary == 0 || boundary == order.length) {
            return range;
        }
        // Compute the relative visual position of the head compared to the
        // anchor (<0 is to the left, >0 to the right)
        var leftSide;
        if (head.line != anchor.line) {
            leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
        } else {
            var headIndex = getBidiPartAt(order, head.ch, head.sticky);
            var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
            if (headIndex == boundary - 1 || headIndex == boundary) {
                leftSide = dir < 0;
            } else {
                leftSide = dir > 0;
            }
        }
        var usePart = order[boundary + (leftSide ? -1 : 0)];
        var from = leftSide == (usePart.level == 1);
        var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
        return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
    };
    var gutterEvent = // Determines whether an event happened in the gutter, and fires the
    // handlers for the corresponding event.
    function gutterEvent(cm, e, type, prevent) {
        var mX, mY;
        if (e.touches) {
            mX = e.touches[0].clientX;
            mY = e.touches[0].clientY;
        } else {
            try {
                mX = e.clientX;
                mY = e.clientY;
            } catch (e$1) {
                return false;
            }
        }
        if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) {
            return false;
        }
        if (prevent) {
            e_preventDefault(e);
        }
        var display = cm.display;
        var lineBox = display.lineDiv.getBoundingClientRect();
        if (mY > lineBox.bottom || !hasHandler(cm, type)) {
            return e_defaultPrevented(e);
        }
        mY -= lineBox.top - display.viewOffset;
        for(var i = 0; i < cm.display.gutterSpecs.length; ++i){
            var g = display.gutters.childNodes[i];
            if (g && g.getBoundingClientRect().right >= mX) {
                var line = lineAtHeight(cm.doc, mY);
                var gutter = cm.display.gutterSpecs[i];
                signal(cm, type, cm, line, gutter.className, e);
                return e_defaultPrevented(e);
            }
        }
    };
    var clickInGutter = function clickInGutter(cm, e) {
        return gutterEvent(cm, e, "gutterClick", true);
    };
    var onContextMenu = // CONTEXT MENU HANDLING
    // To make the context menu work, we need to briefly unhide the
    // textarea (making it as unobtrusive as possible) to let the
    // right-click take effect on it.
    function onContextMenu(cm, e) {
        if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) {
            return;
        }
        if (signalDOMEvent(cm, e, "contextmenu")) {
            return;
        }
        if (!captureRightClick) {
            cm.display.input.onContextMenu(e);
        }
    };
    var contextMenuInGutter = function contextMenuInGutter(cm, e) {
        if (!hasHandler(cm, "gutterContextMenu")) {
            return false;
        }
        return gutterEvent(cm, e, "gutterContextMenu", false);
    };
    var themeChanged = function themeChanged(cm) {
        cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
        clearCaches(cm);
    };
    var defineOptions = function defineOptions(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        function option(name, deflt, handle, notOnInit) {
            CodeMirror.defaults[name] = deflt;
            if (handle) {
                optionHandlers[name] = notOnInit ? function(cm, val, old) {
                    if (old != Init) {
                        handle(cm, val, old);
                    }
                } : handle;
            }
        }
        CodeMirror.defineOption = option;
        // Passed to option handlers when there is no old value.
        CodeMirror.Init = Init;
        // These two are, on init, called from the constructor because they
        // have to be initialized before the editor can start at all.
        option("value", "", function(cm, val) {
            return cm.setValue(val);
        }, true);
        option("mode", null, function(cm, val) {
            cm.doc.modeOption = val;
            loadMode(cm);
        }, true);
        option("indentUnit", 2, loadMode, true);
        option("indentWithTabs", false);
        option("smartIndent", true);
        option("tabSize", 4, function(cm) {
            resetModeState(cm);
            clearCaches(cm);
            regChange(cm);
        }, true);
        option("lineSeparator", null, function(cm, val) {
            cm.doc.lineSep = val;
            if (!val) {
                return;
            }
            var newBreaks = [], lineNo = cm.doc.first;
            cm.doc.iter(function(line) {
                for(var pos = 0;;){
                    var found = line.text.indexOf(val, pos);
                    if (found == -1) {
                        break;
                    }
                    pos = found + val.length;
                    newBreaks.push(Pos(lineNo, found));
                }
                lineNo++;
            });
            for(var i = newBreaks.length - 1; i >= 0; i--){
                replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
            }
        });
        option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
            cm.state.specialChars = new RegExp(val.source + (val.test("	") ? "" : "|	"), "g");
            if (old != Init) {
                cm.refresh();
            }
        });
        option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
            return cm.refresh();
        }, true);
        option("electricChars", true);
        option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
            throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
            ;
        }, true);
        option("spellcheck", false, function(cm, val) {
            return cm.getInputField().spellcheck = val;
        }, true);
        option("autocorrect", false, function(cm, val) {
            return cm.getInputField().autocorrect = val;
        }, true);
        option("autocapitalize", false, function(cm, val) {
            return cm.getInputField().autocapitalize = val;
        }, true);
        option("rtlMoveVisually", !windows);
        option("wholeLineUpdateBefore", true);
        option("theme", "default", function(cm) {
            themeChanged(cm);
            updateGutters(cm);
        }, true);
        option("keyMap", "default", function(cm, val, old) {
            var next = getKeyMap(val);
            var prev = old != Init && getKeyMap(old);
            if (prev && prev.detach) {
                prev.detach(cm, next);
            }
            if (next.attach) {
                next.attach(cm, prev || null);
            }
        });
        option("extraKeys", null);
        option("configureMouse", null);
        option("lineWrapping", false, wrappingChanged, true);
        option("gutters", [], function(cm, val) {
            cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
            updateGutters(cm);
        }, true);
        option("fixedGutter", true, function(cm, val) {
            cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
            cm.refresh();
        }, true);
        option("coverGutterNextToScrollbar", false, function(cm) {
            return updateScrollbars(cm);
        }, true);
        option("scrollbarStyle", "native", function(cm) {
            initScrollbars(cm);
            updateScrollbars(cm);
            cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
            cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
        }, true);
        option("lineNumbers", false, function(cm, val) {
            cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
            updateGutters(cm);
        }, true);
        option("firstLineNumber", 1, updateGutters, true);
        option("lineNumberFormatter", function(integer) {
            return integer;
        }, updateGutters, true);
        option("showCursorWhenSelecting", false, updateSelection, true);
        option("resetSelectionOnContextMenu", true);
        option("lineWiseCopyCut", true);
        option("pasteLinesPerSelection", true);
        option("selectionsMayTouch", false);
        option("readOnly", false, function(cm, val) {
            if (val == "nocursor") {
                onBlur(cm);
                cm.display.input.blur();
            }
            cm.display.input.readOnlyChanged(val);
        });
        option("screenReaderLabel", null, function(cm, val) {
            val = val === "" ? null : val;
            cm.display.input.screenReaderLabelChanged(val);
        });
        option("disableInput", false, function(cm, val) {
            if (!val) {
                cm.display.input.reset();
            }
        }, true);
        option("dragDrop", true, dragDropChanged);
        option("allowDropFileTypes", null);
        option("cursorBlinkRate", 530);
        option("cursorScrollMargin", 0);
        option("cursorHeight", 1, updateSelection, true);
        option("singleCursorHeightPerLine", true, updateSelection, true);
        option("workTime", 100);
        option("workDelay", 100);
        option("flattenSpans", true, resetModeState, true);
        option("addModeClass", false, resetModeState, true);
        option("pollInterval", 100);
        option("undoDepth", 200, function(cm, val) {
            return cm.doc.history.undoDepth = val;
        });
        option("historyEventDelay", 1250);
        option("viewportMargin", 10, function(cm) {
            return cm.refresh();
        }, true);
        option("maxHighlightLength", 10000, resetModeState, true);
        option("moveInputWithCursor", true, function(cm, val) {
            if (!val) {
                cm.display.input.resetPosition();
            }
        });
        option("tabindex", null, function(cm, val) {
            return cm.display.input.getField().tabIndex = val || "";
        });
        option("autofocus", null);
        option("direction", "ltr", function(cm, val) {
            return cm.doc.setDirection(val);
        }, true);
        option("phrases", null);
    };
    var dragDropChanged = function dragDropChanged(cm, value, old) {
        var wasOn = old && old != Init;
        if (!value != !wasOn) {
            var funcs = cm.display.dragFunctions;
            var toggle = value ? on : off;
            toggle(cm.display.scroller, "dragstart", funcs.start);
            toggle(cm.display.scroller, "dragenter", funcs.enter);
            toggle(cm.display.scroller, "dragover", funcs.over);
            toggle(cm.display.scroller, "dragleave", funcs.leave);
            toggle(cm.display.scroller, "drop", funcs.drop);
        }
    };
    var wrappingChanged = function wrappingChanged(cm) {
        if (cm.options.lineWrapping) {
            addClass(cm.display.wrapper, "CodeMirror-wrap");
            cm.display.sizer.style.minWidth = "";
            cm.display.sizerWidth = null;
        } else {
            rmClass(cm.display.wrapper, "CodeMirror-wrap");
            findMaxLine(cm);
        }
        estimateLineHeights(cm);
        regChange(cm);
        clearCaches(cm);
        setTimeout(function() {
            return updateScrollbars(cm);
        }, 100);
    };
    var registerEventHandlers = // Attach the necessary event handlers when initializing the editor
    function registerEventHandlers(cm) {
        var d = cm.display;
        on(d.scroller, "mousedown", operation(cm, onMouseDown));
        // Older IE's will not fire a second mousedown for a double click
        if (ie && ie_version < 11) {
            on(d.scroller, "dblclick", operation(cm, function(e) {
                if (signalDOMEvent(cm, e)) {
                    return;
                }
                var pos = posFromMouse(cm, e);
                if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) {
                    return;
                }
                e_preventDefault(e);
                var word = cm.findWordAt(pos);
                extendSelection(cm.doc, word.anchor, word.head);
            }));
        } else {
            on(d.scroller, "dblclick", function(e) {
                return signalDOMEvent(cm, e) || e_preventDefault(e);
            });
        }
        // Some browsers fire contextmenu *after* opening the menu, at
        // which point we can't mess with it anymore. Context menu is
        // handled in onMouseDown for these browsers.
        on(d.scroller, "contextmenu", function(e) {
            return onContextMenu(cm, e);
        });
        on(d.input.getField(), "contextmenu", function(e) {
            if (!d.scroller.contains(e.target)) {
                onContextMenu(cm, e);
            }
        });
        // Used to suppress mouse event handling when a touch happens
        var touchFinished, prevTouch = {
            end: 0
        };
        function finishTouch() {
            if (d.activeTouch) {
                touchFinished = setTimeout(function() {
                    return d.activeTouch = null;
                }, 1000);
                prevTouch = d.activeTouch;
                prevTouch.end = +new Date;
            }
        }
        function isMouseLikeTouchEvent(e) {
            if (e.touches.length != 1) {
                return false;
            }
            var touch = e.touches[0];
            return touch.radiusX <= 1 && touch.radiusY <= 1;
        }
        function farAway(touch, other) {
            if (other.left == null) {
                return true;
            }
            var dx = other.left - touch.left, dy = other.top - touch.top;
            return dx * dx + dy * dy > 20 * 20;
        }
        on(d.scroller, "touchstart", function(e) {
            if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
                d.input.ensurePolled();
                clearTimeout(touchFinished);
                var now = +new Date;
                d.activeTouch = {
                    start: now,
                    moved: false,
                    prev: now - prevTouch.end <= 300 ? prevTouch : null
                };
                if (e.touches.length == 1) {
                    d.activeTouch.left = e.touches[0].pageX;
                    d.activeTouch.top = e.touches[0].pageY;
                }
            }
        });
        on(d.scroller, "touchmove", function() {
            if (d.activeTouch) {
                d.activeTouch.moved = true;
            }
        });
        on(d.scroller, "touchend", function(e) {
            var touch = d.activeTouch;
            if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date - touch.start < 300) {
                var pos = cm.coordsChar(d.activeTouch, "page"), range;
                if (!touch.prev || farAway(touch, touch.prev)) {
                    range = new Range(pos, pos);
                } else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) {
                    range = cm.findWordAt(pos);
                } else {
                    range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
                }
                cm.setSelection(range.anchor, range.head);
                cm.focus();
                e_preventDefault(e);
            }
            finishTouch();
        });
        on(d.scroller, "touchcancel", finishTouch);
        // Sync scrolling between fake scrollbars and real scrollable
        // area, ensure viewport is updated when scrolling.
        on(d.scroller, "scroll", function() {
            if (d.scroller.clientHeight) {
                updateScrollTop(cm, d.scroller.scrollTop);
                setScrollLeft(cm, d.scroller.scrollLeft, true);
                signal(cm, "scroll", cm);
            }
        });
        // Listen to wheel events in order to try and update the viewport on time.
        on(d.scroller, "mousewheel", function(e) {
            return onScrollWheel(cm, e);
        });
        on(d.scroller, "DOMMouseScroll", function(e) {
            return onScrollWheel(cm, e);
        });
        // Prevent wrapper from ever scrolling
        on(d.wrapper, "scroll", function() {
            return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
        });
        d.dragFunctions = {
            enter: function enter(e) {
                if (!signalDOMEvent(cm, e)) {
                    e_stop(e);
                }
            },
            over: function over(e) {
                if (!signalDOMEvent(cm, e)) {
                    onDragOver(cm, e);
                    e_stop(e);
                }
            },
            start: function start(e) {
                return onDragStart(cm, e);
            },
            drop: operation(cm, onDrop),
            leave: function leave(e) {
                if (!signalDOMEvent(cm, e)) {
                    clearDragCursor(cm);
                }
            }
        };
        var inp = d.input.getField();
        on(inp, "keyup", function(e) {
            return onKeyUp.call(cm, e);
        });
        on(inp, "keydown", operation(cm, onKeyDown));
        on(inp, "keypress", operation(cm, onKeyPress));
        on(inp, "focus", function(e) {
            return onFocus(cm, e);
        });
        on(inp, "blur", function(e) {
            return onBlur(cm, e);
        });
    };
    var indentLine = // Indent the given line. The how parameter can be "smart",
    // "add"/null, "subtract", or "prev". When aggressive is false
    // (typically set to true for forced single-line indents), empty
    // lines are not indented, and places where the mode returns Pass
    // are left alone.
    function indentLine(cm, n, how, aggressive) {
        var doc = cm.doc, state;
        if (how == null) {
            how = "add";
        }
        if (how == "smart") {
            // Fall back to "prev" when the mode doesn't have an indentation
            // method.
            if (!doc.mode.indent) {
                how = "prev";
            } else {
                state = getContextBefore(cm, n).state;
            }
        }
        var tabSize = cm.options.tabSize;
        var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
        if (line.stateAfter) {
            line.stateAfter = null;
        }
        var curSpaceString = line.text.match(/^\s*/)[0], indentation;
        if (!aggressive && !/\S/.test(line.text)) {
            indentation = 0;
            how = "not";
        } else if (how == "smart") {
            indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
            if (indentation == Pass || indentation > 150) {
                if (!aggressive) {
                    return;
                }
                how = "prev";
            }
        }
        if (how == "prev") {
            if (n > doc.first) {
                indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
            } else {
                indentation = 0;
            }
        } else if (how == "add") {
            indentation = curSpace + cm.options.indentUnit;
        } else if (how == "subtract") {
            indentation = curSpace - cm.options.indentUnit;
        } else if (typeof how == "number") {
            indentation = curSpace + how;
        }
        indentation = Math.max(0, indentation);
        var indentString = "", pos = 0;
        if (cm.options.indentWithTabs) {
            for(var i = Math.floor(indentation / tabSize); i; --i){
                pos += tabSize;
                indentString += "	";
            }
        }
        if (pos < indentation) {
            indentString += spaceStr(indentation - pos);
        }
        if (indentString != curSpaceString) {
            replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
            line.stateAfter = null;
            return true;
        } else {
            // Ensure that, if the cursor was in the whitespace at the start
            // of the line, it is moved to the end of that space.
            for(var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++){
                var range = doc.sel.ranges[i$1];
                if (range.head.line == n && range.head.ch < curSpaceString.length) {
                    var pos$1 = Pos(n, curSpaceString.length);
                    replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
                    break;
                }
            }
        }
    };
    var setLastCopied = function setLastCopied(newLastCopied) {
        lastCopied = newLastCopied;
    };
    var applyTextInput = function applyTextInput(cm, inserted, deleted, sel, origin) {
        var doc = cm.doc;
        cm.display.shift = false;
        if (!sel) {
            sel = doc.sel;
        }
        var recent = +new Date - 200;
        var paste = origin == "paste" || cm.state.pasteIncoming > recent;
        var textLines = splitLinesAuto(inserted), multiPaste = null;
        // When pasting N lines into N selections, insert one line per selection
        if (paste && sel.ranges.length > 1) {
            if (lastCopied && lastCopied.text.join("\n") == inserted) {
                if (sel.ranges.length % lastCopied.text.length == 0) {
                    multiPaste = [];
                    for(var i = 0; i < lastCopied.text.length; i++){
                        multiPaste.push(doc.splitLines(lastCopied.text[i]));
                    }
                }
            } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
                multiPaste = map(textLines, function(l) {
                    return [
                        l
                    ];
                });
            }
        }
        var updateInput = cm.curOp.updateInput;
        // Normal behavior is to insert the new text into every selection
        for(var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--){
            var range = sel.ranges[i$1];
            var from = range.from(), to = range.to();
            if (range.empty()) {
                if (deleted && deleted > 0) {
                    from = Pos(from.line, from.ch - deleted);
                } else if (cm.state.overwrite && !paste) {
                    to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
                } else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) {
                    from = to = Pos(from.line, 0);
                }
            }
            var changeEvent = {
                from: from,
                to: to,
                text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
            };
            makeChange(cm.doc, changeEvent);
            signalLater(cm, "inputRead", cm, changeEvent);
        }
        if (inserted && !paste) {
            triggerElectric(cm, inserted);
        }
        ensureCursorVisible(cm);
        if (cm.curOp.updateInput < 2) {
            cm.curOp.updateInput = updateInput;
        }
        cm.curOp.typing = true;
        cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    };
    var handlePaste = function handlePaste(e, cm) {
        var pasted = e.clipboardData && e.clipboardData.getData("Text");
        if (pasted) {
            e.preventDefault();
            if (!cm.isReadOnly() && !cm.options.disableInput) {
                runInOp(cm, function() {
                    return applyTextInput(cm, pasted, 0, null, "paste");
                });
            }
            return true;
        }
    };
    var triggerElectric = function triggerElectric(cm, inserted) {
        // When an 'electric' character is inserted, immediately trigger a reindent
        if (!cm.options.electricChars || !cm.options.smartIndent) {
            return;
        }
        var sel = cm.doc.sel;
        for(var i = sel.ranges.length - 1; i >= 0; i--){
            var range = sel.ranges[i];
            if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) {
                continue;
            }
            var mode = cm.getModeAt(range.head);
            var indented = false;
            if (mode.electricChars) {
                for(var j = 0; j < mode.electricChars.length; j++){
                    if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
                        indented = indentLine(cm, range.head.line, "smart");
                        break;
                    }
                }
            } else if (mode.electricInput) {
                if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) {
                    indented = indentLine(cm, range.head.line, "smart");
                }
            }
            if (indented) {
                signalLater(cm, "electricInput", cm, range.head.line);
            }
        }
    };
    var copyableRanges = function copyableRanges(cm) {
        var text = [], ranges = [];
        for(var i = 0; i < cm.doc.sel.ranges.length; i++){
            var line = cm.doc.sel.ranges[i].head.line;
            var lineRange = {
                anchor: Pos(line, 0),
                head: Pos(line + 1, 0)
            };
            ranges.push(lineRange);
            text.push(cm.getRange(lineRange.anchor, lineRange.head));
        }
        return {
            text: text,
            ranges: ranges
        };
    };
    var disableBrowserMagic = function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
        field.setAttribute("autocorrect", autocorrect ? "" : "off");
        field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
        field.setAttribute("spellcheck", !!spellcheck);
    };
    var hiddenTextarea = function hiddenTextarea() {
        var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
        var div = elt("div", [
            te
        ], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        // The textarea is kept positioned near the cursor to prevent the
        // fact that it'll be scrolled into view on input from scrolling
        // our fake cursor out of view. On webkit, when wrap=off, paste is
        // very slow. So make the area wide instead.
        if (webkit) {
            te.style.width = "1000px";
        } else {
            te.setAttribute("wrap", "off");
        }
        // If border: 0; -- iOS fails to open keyboard (issue #1287)
        if (ios) {
            te.style.border = "1px solid black";
        }
        disableBrowserMagic(te);
        return div;
    };
    var addEditorMethods = // The publicly visible API. Note that methodOp(f) means
    // 'wrap f in an operation, performed on its `this` parameter'.
    // This is not the complete set of editor methods. Most of the
    // methods defined on the Doc type are also injected into
    // CodeMirror.prototype, for backwards compatibility and
    // convenience.
    function addEditorMethods(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        var helpers = CodeMirror.helpers = {};
        CodeMirror.prototype = {
            constructor: CodeMirror,
            focus: function focus() {
                window.focus();
                this.display.input.focus();
            },
            setOption: function setOption(option, value) {
                var options = this.options, old = options[option];
                if (options[option] == value && option != "mode") {
                    return;
                }
                options[option] = value;
                if (optionHandlers.hasOwnProperty(option)) {
                    operation(this, optionHandlers[option])(this, value, old);
                }
                signal(this, "optionChange", this, option);
            },
            getOption: function getOption(option) {
                return this.options[option];
            },
            getDoc: function getDoc() {
                return this.doc;
            },
            addKeyMap: function addKeyMap(map, bottom) {
                this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
            },
            removeKeyMap: function removeKeyMap(map) {
                var maps = this.state.keyMaps;
                for(var i = 0; i < maps.length; ++i){
                    if (maps[i] == map || maps[i].name == map) {
                        maps.splice(i, 1);
                        return true;
                    }
                }
            },
            addOverlay: methodOp(function(spec, options) {
                var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
                if (mode.startState) {
                    throw new Error("Overlays may not be stateful.");
                }
                insertSorted(this.state.overlays, {
                    mode: mode,
                    modeSpec: spec,
                    opaque: options && options.opaque,
                    priority: options && options.priority || 0
                }, function(overlay) {
                    return overlay.priority;
                });
                this.state.modeGen++;
                regChange(this);
            }),
            removeOverlay: methodOp(function(spec) {
                var overlays = this.state.overlays;
                for(var i = 0; i < overlays.length; ++i){
                    var cur = overlays[i].modeSpec;
                    if (cur == spec || typeof spec == "string" && cur.name == spec) {
                        overlays.splice(i, 1);
                        this.state.modeGen++;
                        regChange(this);
                        return;
                    }
                }
            }),
            indentLine: methodOp(function(n, dir, aggressive) {
                if (typeof dir != "string" && typeof dir != "number") {
                    if (dir == null) {
                        dir = this.options.smartIndent ? "smart" : "prev";
                    } else {
                        dir = dir ? "add" : "subtract";
                    }
                }
                if (isLine(this.doc, n)) {
                    indentLine(this, n, dir, aggressive);
                }
            }),
            indentSelection: methodOp(function(how) {
                var ranges = this.doc.sel.ranges, end = -1;
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (!range.empty()) {
                        var from = range.from(), to = range.to();
                        var start = Math.max(end, from.line);
                        end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
                        for(var j = start; j < end; ++j){
                            indentLine(this, j, how);
                        }
                        var newRanges = this.doc.sel.ranges;
                        if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) {
                            replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
                        }
                    } else if (range.head.line > end) {
                        indentLine(this, range.head.line, how, true);
                        end = range.head.line;
                        if (i == this.doc.sel.primIndex) {
                            ensureCursorVisible(this);
                        }
                    }
                }
            }),
            // Fetch the parser token for a given character. Useful for hacks
            // that want to inspect the mode state (say, for completion).
            getTokenAt: function getTokenAt(pos, precise) {
                return takeToken(this, pos, precise);
            },
            getLineTokens: function getLineTokens(line, precise) {
                return takeToken(this, Pos(line), precise, true);
            },
            getTokenTypeAt: function getTokenTypeAt(pos) {
                pos = clipPos(this.doc, pos);
                var styles = getLineStyles(this, getLine(this.doc, pos.line));
                var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
                var type;
                if (ch == 0) {
                    type = styles[2];
                } else {
                    for(;;){
                        var mid = before + after >> 1;
                        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) {
                            after = mid;
                        } else if (styles[mid * 2 + 1] < ch) {
                            before = mid + 1;
                        } else {
                            type = styles[mid * 2 + 2];
                            break;
                        }
                    }
                }
                var cut = type ? type.indexOf("overlay ") : -1;
                return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
            },
            getModeAt: function getModeAt(pos) {
                var mode = this.doc.mode;
                if (!mode.innerMode) {
                    return mode;
                }
                return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
            },
            getHelper: function getHelper(pos, type) {
                return this.getHelpers(pos, type)[0];
            },
            getHelpers: function getHelpers(pos, type) {
                var found = [];
                if (!helpers.hasOwnProperty(type)) {
                    return found;
                }
                var help = helpers[type], mode = this.getModeAt(pos);
                if (typeof mode[type] == "string") {
                    if (help[mode[type]]) {
                        found.push(help[mode[type]]);
                    }
                } else if (mode[type]) {
                    for(var i = 0; i < mode[type].length; i++){
                        var val = help[mode[type][i]];
                        if (val) {
                            found.push(val);
                        }
                    }
                } else if (mode.helperType && help[mode.helperType]) {
                    found.push(help[mode.helperType]);
                } else if (help[mode.name]) {
                    found.push(help[mode.name]);
                }
                for(var i$1 = 0; i$1 < help._global.length; i$1++){
                    var cur = help._global[i$1];
                    if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) {
                        found.push(cur.val);
                    }
                }
                return found;
            },
            getStateAfter: function getStateAfter(line, precise) {
                var doc = this.doc;
                line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
                return getContextBefore(this, line + 1, precise).state;
            },
            cursorCoords: function cursorCoords1(start, mode) {
                var pos, range = this.doc.sel.primary();
                if (start == null) {
                    pos = range.head;
                } else if (typeof start == "object") {
                    pos = clipPos(this.doc, start);
                } else {
                    pos = start ? range.from() : range.to();
                }
                return cursorCoords(this, pos, mode || "page");
            },
            charCoords: function charCoords1(pos, mode) {
                return charCoords(this, clipPos(this.doc, pos), mode || "page");
            },
            coordsChar: function coordsChar1(coords, mode) {
                coords = fromCoordSystem(this, coords, mode || "page");
                return coordsChar(this, coords.left, coords.top);
            },
            lineAtHeight: function lineAtHeight1(height, mode) {
                height = fromCoordSystem(this, {
                    top: height,
                    left: 0
                }, mode || "page").top;
                return lineAtHeight(this.doc, height + this.display.viewOffset);
            },
            heightAtLine: function heightAtLine1(line, mode, includeWidgets) {
                var end = false, lineObj;
                if (typeof line == "number") {
                    var last = this.doc.first + this.doc.size - 1;
                    if (line < this.doc.first) {
                        line = this.doc.first;
                    } else if (line > last) {
                        line = last;
                        end = true;
                    }
                    lineObj = getLine(this.doc, line);
                } else {
                    lineObj = line;
                }
                return intoCoordSystem(this, lineObj, {
                    top: 0,
                    left: 0
                }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
            },
            defaultTextHeight: function defaultTextHeight() {
                return textHeight(this.display);
            },
            defaultCharWidth: function defaultCharWidth() {
                return charWidth(this.display);
            },
            getViewport: function getViewport() {
                return {
                    from: this.display.viewFrom,
                    to: this.display.viewTo
                };
            },
            addWidget: function addWidget(pos, node, scroll, vert, horiz) {
                var display = this.display;
                pos = cursorCoords(this, clipPos(this.doc, pos));
                var top = pos.bottom, left = pos.left;
                node.style.position = "absolute";
                node.setAttribute("cm-ignore-events", "true");
                this.display.input.setUneditable(node);
                display.sizer.appendChild(node);
                if (vert == "over") {
                    top = pos.top;
                } else if (vert == "above" || vert == "near") {
                    var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
                    // Default to positioning above (if specified and possible); otherwise default to positioning below
                    if ((vert == "above" || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) {
                        top = pos.top - node.offsetHeight;
                    } else if (pos.bottom + node.offsetHeight <= vspace) {
                        top = pos.bottom;
                    }
                    if (left + node.offsetWidth > hspace) {
                        left = hspace - node.offsetWidth;
                    }
                }
                node.style.top = top + "px";
                node.style.left = node.style.right = "";
                if (horiz == "right") {
                    left = display.sizer.clientWidth - node.offsetWidth;
                    node.style.right = "0px";
                } else {
                    if (horiz == "left") {
                        left = 0;
                    } else if (horiz == "middle") {
                        left = (display.sizer.clientWidth - node.offsetWidth) / 2;
                    }
                    node.style.left = left + "px";
                }
                if (scroll) {
                    scrollIntoView(this, {
                        left: left,
                        top: top,
                        right: left + node.offsetWidth,
                        bottom: top + node.offsetHeight
                    });
                }
            },
            triggerOnKeyDown: methodOp(onKeyDown),
            triggerOnKeyPress: methodOp(onKeyPress),
            triggerOnKeyUp: onKeyUp,
            triggerOnMouseDown: methodOp(onMouseDown),
            execCommand: function execCommand(cmd) {
                if (commands.hasOwnProperty(cmd)) {
                    return commands[cmd].call(null, this);
                }
            },
            triggerElectric: methodOp(function(text) {
                triggerElectric(this, text);
            }),
            findPosH: function findPosH1(from, amount, unit, visually) {
                var dir = 1;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    cur = findPosH(this.doc, cur, dir, unit, visually);
                    if (cur.hitSide) {
                        break;
                    }
                }
                return cur;
            },
            moveH: methodOp(function(dir, unit) {
                var this$1 = this;
                this.extendSelectionsBy(function(range) {
                    if (this$1.display.shift || this$1.doc.extend || range.empty()) {
                        return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
                    } else {
                        return dir < 0 ? range.from() : range.to();
                    }
                }, sel_move);
            }),
            deleteH: methodOp(function(dir, unit) {
                var sel = this.doc.sel, doc = this.doc;
                if (sel.somethingSelected()) {
                    doc.replaceSelection("", null, "+delete");
                } else {
                    deleteNearSelection(this, function(range) {
                        var other = findPosH(doc, range.head, dir, unit, false);
                        return dir < 0 ? {
                            from: other,
                            to: range.head
                        } : {
                            from: range.head,
                            to: other
                        };
                    });
                }
            }),
            findPosV: function findPosV1(from, amount, unit, goalColumn) {
                var dir = 1, x = goalColumn;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    var coords = cursorCoords(this, cur, "div");
                    if (x == null) {
                        x = coords.left;
                    } else {
                        coords.left = x;
                    }
                    cur = findPosV(this, coords, dir, unit);
                    if (cur.hitSide) {
                        break;
                    }
                }
                return cur;
            },
            moveV: methodOp(function(dir, unit) {
                var this$1 = this;
                var doc = this.doc, goals = [];
                var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
                doc.extendSelectionsBy(function(range) {
                    if (collapse) {
                        return dir < 0 ? range.from() : range.to();
                    }
                    var headPos = cursorCoords(this$1, range.head, "div");
                    if (range.goalColumn != null) {
                        headPos.left = range.goalColumn;
                    }
                    goals.push(headPos.left);
                    var pos = findPosV(this$1, headPos, dir, unit);
                    if (unit == "page" && range == doc.sel.primary()) {
                        addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top);
                    }
                    return pos;
                }, sel_move);
                if (goals.length) {
                    for(var i = 0; i < doc.sel.ranges.length; i++){
                        doc.sel.ranges[i].goalColumn = goals[i];
                    }
                }
            }),
            // Find the word at the given position (as returned by coordsChar).
            findWordAt: function findWordAt(pos) {
                var doc = this.doc, line = getLine(doc, pos.line).text;
                var start = pos.ch, end = pos.ch;
                if (line) {
                    var helper = this.getHelper(pos, "wordChars");
                    if ((pos.sticky == "before" || end == line.length) && start) {
                        --start;
                    } else {
                        ++end;
                    }
                    var startChar = line.charAt(start);
                    var check = isWordChar(startChar, helper) ? function check(ch) {
                        return isWordChar(ch, helper);
                    } : /\s/.test(startChar) ? function(ch) {
                        return /\s/.test(ch);
                    } : function(ch) {
                        return !/\s/.test(ch) && !isWordChar(ch);
                    };
                    while(start > 0 && check(line.charAt(start - 1))){
                        --start;
                    }
                    while(end < line.length && check(line.charAt(end))){
                        ++end;
                    }
                }
                return new Range(Pos(pos.line, start), Pos(pos.line, end));
            },
            toggleOverwrite: function toggleOverwrite(value) {
                if (value != null && value == this.state.overwrite) {
                    return;
                }
                if (this.state.overwrite = !this.state.overwrite) {
                    addClass(this.display.cursorDiv, "CodeMirror-overwrite");
                } else {
                    rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
                }
                signal(this, "overwriteToggle", this, this.state.overwrite);
            },
            hasFocus: function hasFocus() {
                return this.display.input.getField() == activeElt();
            },
            isReadOnly: function isReadOnly() {
                return !!(this.options.readOnly || this.doc.cantEdit);
            },
            scrollTo: methodOp(function(x, y) {
                scrollToCoords(this, x, y);
            }),
            getScrollInfo: function getScrollInfo() {
                var scroller = this.display.scroller;
                return {
                    left: scroller.scrollLeft,
                    top: scroller.scrollTop,
                    height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                    width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                    clientHeight: displayHeight(this),
                    clientWidth: displayWidth(this)
                };
            },
            scrollIntoView: methodOp(function(range, margin) {
                if (range == null) {
                    range = {
                        from: this.doc.sel.primary().head,
                        to: null
                    };
                    if (margin == null) {
                        margin = this.options.cursorScrollMargin;
                    }
                } else if (typeof range == "number") {
                    range = {
                        from: Pos(range, 0),
                        to: null
                    };
                } else if (range.from == null) {
                    range = {
                        from: range,
                        to: null
                    };
                }
                if (!range.to) {
                    range.to = range.from;
                }
                range.margin = margin || 0;
                if (range.from.line != null) {
                    scrollToRange(this, range);
                } else {
                    scrollToCoordsRange(this, range.from, range.to, range.margin);
                }
            }),
            setSize: methodOp(function(width, height) {
                var this$1 = this;
                var interpret = function interpret(val) {
                    return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
                };
                if (width != null) {
                    this.display.wrapper.style.width = interpret(width);
                }
                if (height != null) {
                    this.display.wrapper.style.height = interpret(height);
                }
                if (this.options.lineWrapping) {
                    clearLineMeasurementCache(this);
                }
                var lineNo = this.display.viewFrom;
                this.doc.iter(lineNo, this.display.viewTo, function(line) {
                    if (line.widgets) {
                        for(var i = 0; i < line.widgets.length; i++){
                            if (line.widgets[i].noHScroll) {
                                regLineChange(this$1, lineNo, "widget");
                                break;
                            }
                        }
                    }
                    ++lineNo;
                });
                this.curOp.forceUpdate = true;
                signal(this, "refresh", this);
            }),
            operation: function operation(f) {
                return runInOp(this, f);
            },
            startOperation: function startOperation1() {
                return startOperation(this);
            },
            endOperation: function endOperation1() {
                return endOperation(this);
            },
            refresh: methodOp(function() {
                var oldHeight = this.display.cachedTextHeight;
                regChange(this);
                this.curOp.forceUpdate = true;
                clearCaches(this);
                scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
                updateGutterSpace(this.display);
                if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) {
                    estimateLineHeights(this);
                }
                signal(this, "refresh", this);
            }),
            swapDoc: methodOp(function(doc) {
                var old = this.doc;
                old.cm = null;
                // Cancel the current text selection if any (#5821)
                if (this.state.selectingText) {
                    this.state.selectingText();
                }
                attachDoc(this, doc);
                clearCaches(this);
                this.display.input.reset();
                scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
                this.curOp.forceScroll = true;
                signalLater(this, "swapDoc", this, old);
                return old;
            }),
            phrase: function phrase(phraseText) {
                var phrases = this.options.phrases;
                return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
            },
            getInputField: function getInputField() {
                return this.display.input.getField();
            },
            getWrapperElement: function getWrapperElement() {
                return this.display.wrapper;
            },
            getScrollerElement: function getScrollerElement() {
                return this.display.scroller;
            },
            getGutterElement: function getGutterElement() {
                return this.display.gutters;
            }
        };
        eventMixin(CodeMirror);
        CodeMirror.registerHelper = function(type, name, value) {
            if (!helpers.hasOwnProperty(type)) {
                helpers[type] = CodeMirror[type] = {
                    _global: []
                };
            }
            helpers[type][name] = value;
        };
        CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
            CodeMirror.registerHelper(type, name, value);
            helpers[type]._global.push({
                pred: predicate,
                val: value
            });
        };
    };
    var findPosH = // Used for horizontal relative motion. Dir is -1 or 1 (left or
    // right), unit can be "codepoint", "char", "column" (like char, but
    // doesn't cross line boundaries), "word" (across next word), or
    // "group" (to the start of next group of word or
    // non-word-non-whitespace chars). The visually param controls
    // whether, in right-to-left text, direction 1 means to move towards
    // the next index in the string, or towards the character to the right
    // of the current position. The resulting position will have a
    // hitSide=true property if it reached the end of the document.
    function findPosH(doc, pos, dir, unit, visually) {
        var oldPos = pos;
        var origDir = dir;
        var lineObj = getLine(doc, pos.line);
        var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
        function findNextLine() {
            var l = pos.line + lineDir;
            if (l < doc.first || l >= doc.first + doc.size) {
                return false;
            }
            pos = new Pos(l, pos.ch, pos.sticky);
            return lineObj = getLine(doc, l);
        }
        function moveOnce(boundToLine) {
            var next;
            if (unit == "codepoint") {
                var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
                if (isNaN(ch)) {
                    next = null;
                } else {
                    var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
                    next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
                }
            } else if (visually) {
                next = moveVisually(doc.cm, lineObj, pos, dir);
            } else {
                next = moveLogically(lineObj, pos, dir);
            }
            if (next == null) {
                if (!boundToLine && findNextLine()) {
                    pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
                } else {
                    return false;
                }
            } else {
                pos = next;
            }
            return true;
        }
        if (unit == "char" || unit == "codepoint") {
            moveOnce();
        } else if (unit == "column") {
            moveOnce(true);
        } else if (unit == "word" || unit == "group") {
            var sawType = null, group = unit == "group";
            var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
            for(var first = true;; first = false){
                if (dir < 0 && !moveOnce(!first)) {
                    break;
                }
                var cur = lineObj.text.charAt(pos.ch) || "\n";
                var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
                if (group && !first && !type) {
                    type = "s";
                }
                if (sawType && sawType != type) {
                    if (dir < 0) {
                        dir = 1;
                        moveOnce();
                        pos.sticky = "after";
                    }
                    break;
                }
                if (type) {
                    sawType = type;
                }
                if (dir > 0 && !moveOnce(!first)) {
                    break;
                }
            }
        }
        var result = skipAtomic(doc, pos, oldPos, origDir, true);
        if (equalCursorPos(oldPos, result)) {
            result.hitSide = true;
        }
        return result;
    };
    var findPosV = // For relative vertical movement. Dir may be -1 or 1. Unit can be
    // "page" or "line". The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosV(cm, pos, dir, unit) {
        var doc = cm.doc, x = pos.left, y;
        if (unit == "page") {
            var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
            var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
            y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
        } else if (unit == "line") {
            y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
        }
        var target;
        for(;;){
            target = coordsChar(cm, x, y);
            if (!target.outside) {
                break;
            }
            if (dir < 0 ? y <= 0 : y >= doc.height) {
                target.hitSide = true;
                break;
            }
            y += dir * 5;
        }
        return target;
    };
    var posToDOM = function posToDOM(cm, pos) {
        var view = findViewForLine(cm, pos.line);
        if (!view || view.hidden) {
            return null;
        }
        var line = getLine(cm.doc, pos.line);
        var info = mapFromLineView(view, line, pos.line);
        var order = getOrder(line, cm.doc.direction), side = "left";
        if (order) {
            var partPos = getBidiPartAt(order, pos.ch);
            side = partPos % 2 ? "right" : "left";
        }
        var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
        result.offset = result.collapse == "right" ? result.end : result.start;
        return result;
    };
    var isInGutter = function isInGutter(node) {
        for(var scan = node; scan; scan = scan.parentNode){
            if (/CodeMirror-gutter-wrapper/.test(scan.className)) {
                return true;
            }
        }
        return false;
    };
    var badPos = function badPos(pos, bad) {
        if (bad) {
            pos.bad = true;
        }
        return pos;
    };
    var domTextBetween = function domTextBetween(cm, from, to, fromLine, toLine) {
        var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
        function recognizeMarker(id) {
            return function(marker) {
                return marker.id == id;
            };
        }
        function close() {
            if (closing) {
                text += lineSep;
                if (extraLinebreak) {
                    text += lineSep;
                }
                closing = extraLinebreak = false;
            }
        }
        function addText(str) {
            if (str) {
                close();
                text += str;
            }
        }
        function walk(node) {
            if (node.nodeType == 1) {
                var cmText = node.getAttribute("cm-text");
                if (cmText) {
                    addText(cmText);
                    return;
                }
                var markerID = node.getAttribute("cm-marker"), range;
                if (markerID) {
                    var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
                    if (found.length && (range = found[0].find(0))) {
                        addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
                    }
                    return;
                }
                if (node.getAttribute("contenteditable") == "false") {
                    return;
                }
                var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
                if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) {
                    return;
                }
                if (isBlock) {
                    close();
                }
                for(var i = 0; i < node.childNodes.length; i++){
                    walk(node.childNodes[i]);
                }
                if (/^(pre|p)$/i.test(node.nodeName)) {
                    extraLinebreak = true;
                }
                if (isBlock) {
                    closing = true;
                }
            } else if (node.nodeType == 3) {
                addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
            }
        }
        for(;;){
            walk(from);
            if (from == to) {
                break;
            }
            from = from.nextSibling;
            extraLinebreak = false;
        }
        return text;
    };
    var domToPos = function domToPos(cm, node, offset) {
        var lineNode;
        if (node == cm.display.lineDiv) {
            lineNode = cm.display.lineDiv.childNodes[offset];
            if (!lineNode) {
                return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
            }
            node = null;
            offset = 0;
        } else {
            for(lineNode = node;; lineNode = lineNode.parentNode){
                if (!lineNode || lineNode == cm.display.lineDiv) {
                    return null;
                }
                if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) {
                    break;
                }
            }
        }
        for(var i = 0; i < cm.display.view.length; i++){
            var lineView = cm.display.view[i];
            if (lineView.node == lineNode) {
                return locateNodeInLineView(lineView, node, offset);
            }
        }
    };
    var locateNodeInLineView = function locateNodeInLineView(lineView, node, offset) {
        var wrapper = lineView.text.firstChild, bad = false;
        if (!node || !contains(wrapper, node)) {
            return badPos(Pos(lineNo(lineView.line), 0), true);
        }
        if (node == wrapper) {
            bad = true;
            node = wrapper.childNodes[offset];
            offset = 0;
            if (!node) {
                var line = lineView.rest ? lst(lineView.rest) : lineView.line;
                return badPos(Pos(lineNo(line), line.text.length), bad);
            }
        }
        var textNode = node.nodeType == 3 ? node : null, topNode = node;
        if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
            textNode = node.firstChild;
            if (offset) {
                offset = textNode.nodeValue.length;
            }
        }
        while(topNode.parentNode != wrapper){
            topNode = topNode.parentNode;
        }
        var measure = lineView.measure, maps = measure.maps;
        function find(textNode, topNode, offset) {
            for(var i = -1; i < (maps ? maps.length : 0); i++){
                var map = i < 0 ? measure.map : maps[i];
                for(var j = 0; j < map.length; j += 3){
                    var curNode = map[j + 2];
                    if (curNode == textNode || curNode == topNode) {
                        var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
                        var ch = map[j] + offset;
                        if (offset < 0 || curNode != textNode) {
                            ch = map[j + (offset ? 1 : 0)];
                        }
                        return Pos(line, ch);
                    }
                }
            }
        }
        var found = find(textNode, topNode, offset);
        if (found) {
            return badPos(found, bad);
        }
        // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
        for(var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling){
            found = find(after, after.firstChild, 0);
            if (found) {
                return badPos(Pos(found.line, found.ch - dist), bad);
            } else {
                dist += after.textContent.length;
            }
        }
        for(var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling){
            found = find(before, before.firstChild, -1);
            if (found) {
                return badPos(Pos(found.line, found.ch + dist$1), bad);
            } else {
                dist$1 += before.textContent.length;
            }
        }
    };
    var fromTextArea = function fromTextArea(textarea, options) {
        options = options ? copyObj(options) : {};
        options.value = textarea.value;
        if (!options.tabindex && textarea.tabIndex) {
            options.tabindex = textarea.tabIndex;
        }
        if (!options.placeholder && textarea.placeholder) {
            options.placeholder = textarea.placeholder;
        }
        // Set autofocus to true if this textarea is focused, or if it has
        // autofocus and no other element is focused.
        if (options.autofocus == null) {
            var hasFocus = activeElt();
            options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
        }
        function save() {
            textarea.value = cm.getValue();
        }
        var realSubmit;
        if (textarea.form) {
            on(textarea.form, "submit", save);
            // Deplorable hack to make the submit method do the right thing.
            if (!options.leaveSubmitMethodAlone) {
                var form = textarea.form;
                realSubmit = form.submit;
                try {
                    var wrappedSubmit = form.submit = function wrappedSubmit1() {
                        save();
                        form.submit = realSubmit;
                        form.submit();
                        form.submit = wrappedSubmit;
                    };
                } catch (e) {}
            }
        }
        options.finishInit = function(cm) {
            cm.save = save;
            cm.getTextArea = function() {
                return textarea;
            };
            cm.toTextArea = function() {
                cm.toTextArea = isNaN; // Prevent this from being ran twice
                save();
                textarea.parentNode.removeChild(cm.getWrapperElement());
                textarea.style.display = "";
                if (textarea.form) {
                    off(textarea.form, "submit", save);
                    if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") {
                        textarea.form.submit = realSubmit;
                    }
                }
            };
        };
        textarea.style.display = "none";
        var cm = CodeMirror(function(node) {
            return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        }, options);
        return cm;
    };
    var addLegacyProps = function addLegacyProps(CodeMirror) {
        CodeMirror.off = off;
        CodeMirror.on = on;
        CodeMirror.wheelEventPixels = wheelEventPixels;
        CodeMirror.Doc = Doc;
        CodeMirror.splitLines = splitLinesAuto;
        CodeMirror.countColumn = countColumn;
        CodeMirror.findColumn = findColumn;
        CodeMirror.isWordChar = isWordCharBasic;
        CodeMirror.Pass = Pass;
        CodeMirror.signal = signal;
        CodeMirror.Line = Line;
        CodeMirror.changeEnd = changeEnd;
        CodeMirror.scrollbarModel = scrollbarModel;
        CodeMirror.Pos = Pos;
        CodeMirror.cmpPos = cmp;
        CodeMirror.modes = modes;
        CodeMirror.mimeModes = mimeModes;
        CodeMirror.resolveMode = resolveMode;
        CodeMirror.getMode = getMode;
        CodeMirror.modeExtensions = modeExtensions;
        CodeMirror.extendMode = extendMode;
        CodeMirror.copyState = copyState;
        CodeMirror.startState = startState;
        CodeMirror.innerMode = innerMode;
        CodeMirror.commands = commands;
        CodeMirror.keyMap = keyMap;
        CodeMirror.keyName = keyName;
        CodeMirror.isModifierKey = isModifierKey;
        CodeMirror.lookupKey = lookupKey;
        CodeMirror.normalizeKeyMap = normalizeKeyMap;
        CodeMirror.StringStream = StringStream;
        CodeMirror.SharedTextMarker = SharedTextMarker;
        CodeMirror.TextMarker = TextMarker;
        CodeMirror.LineWidget = LineWidget;
        CodeMirror.e_preventDefault = e_preventDefault;
        CodeMirror.e_stopPropagation = e_stopPropagation;
        CodeMirror.e_stop = e_stop;
        CodeMirror.addClass = addClass;
        CodeMirror.contains = contains;
        CodeMirror.rmClass = rmClass;
        CodeMirror.keyNames = keyNames;
    };
    // Kludges for bugs and behavior differences that can't be feature
    // detected are enabled based on userAgent etc sniffing.
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent);
    var ie_upto10 = /MSIE \d/.test(userAgent);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
    var edge = /Edge\/(\d+)/.exec(userAgent);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
    var chrome = !edge && /Chrome\//.test(userAgent);
    var presto = /Opera\//.test(userAgent);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
    var phantom = /PhantomJS/.test(userAgent);
    var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
    var android = /Android/.test(userAgent);
    // This is woefully incomplete. Suggestions for alternative methods welcome.
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
    if (presto_version) {
        presto_version = Number(presto_version[1]);
    }
    if (presto_version && presto_version >= 15) {
        presto = false;
        webkit = true;
    }
    // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    var rmClass = function rmClass(node, cls) {
        var current = node.className;
        var match = classTest(cls).exec(current);
        if (match) {
            var after = current.slice(match.index + match[0].length);
            node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
        }
    };
    var range;
    if (document.createRange) {
        range = function range(node, start, end, endNode) {
            var r = document.createRange();
            r.setEnd(endNode || node, end);
            r.setStart(node, start);
            return r;
        };
    } else {
        range = function range(node, start, end) {
            var r = document.body.createTextRange();
            try {
                r.moveToElementText(node.parentNode);
            } catch (e) {
                return r;
            }
            r.collapse(true);
            r.moveEnd("character", end);
            r.moveStart("character", start);
            return r;
        };
    }
    var selectInput = function selectInput(node) {
        node.select();
    };
    if (ios) {
        selectInput = function selectInput(node) {
            node.selectionStart = 0;
            node.selectionEnd = node.value.length;
        };
    } else if (ie) {
        selectInput = function selectInput(node) {
            try {
                node.select();
            } catch (_e) {}
        };
    }
    var Delayed = function Delayed() {
        this.id = null;
        this.f = null;
        this.time = 0;
        this.handler = bind(this.onTimeout, this);
    };
    Delayed.prototype.onTimeout = function(self1) {
        self1.id = 0;
        if (self1.time <= +new Date) {
            self1.f();
        } else {
            setTimeout(self1.handler, self1.time - +new Date);
        }
    };
    Delayed.prototype.set = function(ms, f) {
        this.f = f;
        var time = +new Date + ms;
        if (!this.id || time < this.time) {
            clearTimeout(this.id);
            this.id = setTimeout(this.handler, ms);
            this.time = time;
        }
    };
    // Number of pixels added to scroller and sizer to hide scrollbar
    var scrollerGap = 50;
    // Returned or thrown by various protocols to signal 'I'm not
    // handling this'.
    var Pass = {
        toString: function toString() {
            return "CodeMirror.Pass";
        }
    };
    // Reused option objects for setSelection & friends
    var sel_dontScroll = {
        scroll: false
    }, sel_mouse = {
        origin: "*mouse"
    }, sel_move = {
        origin: "+move"
    };
    var spaceStrs = [
        ""
    ];
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    // Extending unicode characters. A series of a non-extending char +
    // any number of extending chars is treated as a single unit as far
    // as editing and measuring is concerned. This is not fully correct,
    // since some scripts/fonts/browsers also treat other configurations
    // of code points as a group.
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    var bidiOther = null;
    // Bidirectional ordering algorithm
    // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
    // that this (partially) implements.
    // One-char codes used for character types:
    // L (L):   Left-to-Right
    // R (R):   Right-to-Left
    // r (AL):  Right-to-Left Arabic
    // 1 (EN):  European Number
    // + (ES):  European Number Separator
    // % (ET):  European Number Terminator
    // n (AN):  Arabic Number
    // , (CS):  Common Number Separator
    // m (NSM): Non-Spacing Mark
    // b (BN):  Boundary Neutral
    // s (B):   Paragraph Separator
    // t (S):   Segment Separator
    // w (WS):  Whitespace
    // N (ON):  Other Neutrals
    // Returns null if characters are ordered as they appear
    // (left-to-right), or an array of sections ({from, to, level}
    // objects) in the order in which they occur visually.
    var bidiOrdering = function() {
        var charType = function charType(code) {
            if (code <= 0xf7) {
                return lowTypes.charAt(code);
            } else if (0x590 <= code && code <= 0x5f4) {
                return "R";
            } else if (0x600 <= code && code <= 0x6f9) {
                return arabicTypes.charAt(code - 0x600);
            } else if (0x6ee <= code && code <= 0x8ac) {
                return "r";
            } else if (0x2000 <= code && code <= 0x200b) {
                return "w";
            } else if (code == 0x200c) {
                return "b";
            } else {
                return "L";
            }
        };
        var BidiSpan = function BidiSpan(level, from, to) {
            this.level = level;
            this.from = from;
            this.to = to;
        };
        // Character types for codepoints 0 to 0xff
        var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
        // Character types for codepoints 0x600 to 0x6f9
        var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
        var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
        return function(str, direction) {
            var outerType = direction == "ltr" ? "L" : "R";
            if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) {
                return false;
            }
            var len = str.length, types = [];
            for(var i = 0; i < len; ++i){
                types.push(charType(str.charCodeAt(i)));
            }
            // W1. Examine each non-spacing mark (NSM) in the level run, and
            // change the type of the NSM to the type of the previous
            // character. If the NSM is at the start of the level run, it will
            // get the type of sor.
            for(var i$1 = 0, prev = outerType; i$1 < len; ++i$1){
                var type = types[i$1];
                if (type == "m") {
                    types[i$1] = prev;
                } else {
                    prev = type;
                }
            }
            // W2. Search backwards from each instance of a European number
            // until the first strong type (R, L, AL, or sor) is found. If an
            // AL is found, change the type of the European number to Arabic
            // number.
            // W3. Change all ALs to R.
            for(var i$2 = 0, cur = outerType; i$2 < len; ++i$2){
                var type$1 = types[i$2];
                if (type$1 == "1" && cur == "r") {
                    types[i$2] = "n";
                } else if (isStrong.test(type$1)) {
                    cur = type$1;
                    if (type$1 == "r") {
                        types[i$2] = "R";
                    }
                }
            }
            // W4. A single European separator between two European numbers
            // changes to a European number. A single common separator between
            // two numbers of the same type changes to that type.
            for(var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3){
                var type$2 = types[i$3];
                if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") {
                    types[i$3] = "1";
                } else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) {
                    types[i$3] = prev$1;
                }
                prev$1 = type$2;
            }
            // W5. A sequence of European terminators adjacent to European
            // numbers changes to all European numbers.
            // W6. Otherwise, separators and terminators change to Other
            // Neutral.
            for(var i$4 = 0; i$4 < len; ++i$4){
                var type$3 = types[i$4];
                if (type$3 == ",") {
                    types[i$4] = "N";
                } else if (type$3 == "%") {
                    var end = void 0;
                    for(end = i$4 + 1; end < len && types[end] == "%"; ++end){}
                    var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
                    for(var j = i$4; j < end; ++j){
                        types[j] = replace;
                    }
                    i$4 = end - 1;
                }
            }
            // W7. Search backwards from each instance of a European number
            // until the first strong type (R, L, or sor) is found. If an L is
            // found, then change the type of the European number to L.
            for(var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5){
                var type$4 = types[i$5];
                if (cur$1 == "L" && type$4 == "1") {
                    types[i$5] = "L";
                } else if (isStrong.test(type$4)) {
                    cur$1 = type$4;
                }
            }
            // N1. A sequence of neutrals takes the direction of the
            // surrounding strong text if the text on both sides has the same
            // direction. European and Arabic numbers act as if they were R in
            // terms of their influence on neutrals. Start-of-level-run (sor)
            // and end-of-level-run (eor) are used at level run boundaries.
            // N2. Any remaining neutrals take the embedding direction.
            for(var i$6 = 0; i$6 < len; ++i$6){
                if (isNeutral.test(types[i$6])) {
                    var end$1 = void 0;
                    for(end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1){}
                    var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
                    var after = (end$1 < len ? types[end$1] : outerType) == "L";
                    var replace$1 = before == after ? before ? "L" : "R" : outerType;
                    for(var j$1 = i$6; j$1 < end$1; ++j$1){
                        types[j$1] = replace$1;
                    }
                    i$6 = end$1 - 1;
                }
            }
            // Here we depart from the documented algorithm, in order to avoid
            // building up an actual levels array. Since there are only three
            // levels (0, 1, 2) in an implementation that doesn't take
            // explicit embedding into account, we can build up the order on
            // the fly, without following the level-based algorithm.
            var order = [], m;
            for(var i$7 = 0; i$7 < len;){
                if (countsAsLeft.test(types[i$7])) {
                    var start = i$7;
                    for(++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7){}
                    order.push(new BidiSpan(0, start, i$7));
                } else {
                    var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
                    for(++i$7; i$7 < len && types[i$7] != "L"; ++i$7){}
                    for(var j$2 = pos; j$2 < i$7;){
                        if (countsAsNum.test(types[j$2])) {
                            if (pos < j$2) {
                                order.splice(at, 0, new BidiSpan(1, pos, j$2));
                                at += isRTL;
                            }
                            var nstart = j$2;
                            for(++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2){}
                            order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                            at += isRTL;
                            pos = j$2;
                        } else {
                            ++j$2;
                        }
                    }
                    if (pos < i$7) {
                        order.splice(at, 0, new BidiSpan(1, pos, i$7));
                    }
                }
            }
            if (direction == "ltr") {
                if (order[0].level == 1 && (m = str.match(/^\s+/))) {
                    order[0].from = m[0].length;
                    order.unshift(new BidiSpan(0, 0, m[0].length));
                }
                if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
                    lst(order).to -= m[0].length;
                    order.push(new BidiSpan(0, len - m[0].length, len));
                }
            }
            return direction == "rtl" ? order.reverse() : order;
        };
    }();
    // EVENT HANDLING
    // Lightweight event framework. on/off also work on DOM nodes,
    // registering native DOM handlers.
    var noHandlers = [];
    var on = function on(emitter, type, f) {
        if (emitter.addEventListener) {
            emitter.addEventListener(type, f, false);
        } else if (emitter.attachEvent) {
            emitter.attachEvent("on" + type, f);
        } else {
            var map = emitter._handlers || (emitter._handlers = {});
            map[type] = (map[type] || noHandlers).concat(f);
        }
    };
    // Detect drag-and-drop
    var dragAndDrop = function() {
        // There is *some* kind of drag-and-drop support in IE6-8, but I
        // couldn't get it to work yet.
        if (ie && ie_version < 9) {
            return false;
        }
        var div = elt("div");
        return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    // Feature-detect IE's crummy client rect reporting for bidi text
    var badBidiRects;
    // See if "".split is the broken IE version, if so, provide an
    // alternative way to split lines.
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function splitLinesAuto(string) {
        var pos = 0, result = [], l = string.length;
        while(pos <= l){
            var nl = string.indexOf("\n", pos);
            if (nl == -1) {
                nl = string.length;
            }
            var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
            var rt = line.indexOf("\r");
            if (rt != -1) {
                result.push(line.slice(0, rt));
                pos += rt + 1;
            } else {
                result.push(line);
                pos = nl + 1;
            }
        }
        return result;
    } : function(string) {
        return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function hasSelection(te) {
        try {
            return te.selectionStart != te.selectionEnd;
        } catch (e) {
            return false;
        }
    } : function(te) {
        var range;
        try {
            range = te.ownerDocument.selection.createRange();
        } catch (e) {}
        if (!range || range.parentElement() != te) {
            return false;
        }
        return range.compareEndPoints("StartToEnd", range) != 0;
    };
    var hasCopyEvent = function() {
        var e = elt("div");
        if ("oncopy" in e) {
            return true;
        }
        e.setAttribute("oncopy", "return;");
        return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    // Known modes, by name and by MIME
    var modes = {}, mimeModes = {};
    // Given a MIME type, a {name, ...options} config object, or a name
    // string, return a mode config object.
    function resolveMode(spec) {
        if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
            spec = mimeModes[spec];
        } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
            var found = mimeModes[spec.name];
            if (typeof found == "string") {
                found = {
                    name: found
                };
            }
            spec = createObj(found, spec);
            spec.name = found.name;
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
            return resolveMode("application/xml");
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
            return resolveMode("application/json");
        }
        if (typeof spec == "string") {
            return {
                name: spec
            };
        } else {
            return spec || {
                name: "null"
            };
        }
    }
    // Given a mode spec (anything that resolveMode accepts), find and
    // initialize an actual mode object.
    function getMode(options, spec) {
        spec = resolveMode(spec);
        var mfactory = modes[spec.name];
        if (!mfactory) {
            return getMode(options, "text/plain");
        }
        var modeObj = mfactory(options, spec);
        if (modeExtensions.hasOwnProperty(spec.name)) {
            var exts = modeExtensions[spec.name];
            for(var prop in exts){
                if (!exts.hasOwnProperty(prop)) {
                    continue;
                }
                if (modeObj.hasOwnProperty(prop)) {
                    modeObj["_" + prop] = modeObj[prop];
                }
                modeObj[prop] = exts[prop];
            }
        }
        modeObj.name = spec.name;
        if (spec.helperType) {
            modeObj.helperType = spec.helperType;
        }
        if (spec.modeProps) {
            for(var prop$1 in spec.modeProps){
                modeObj[prop$1] = spec.modeProps[prop$1];
            }
        }
        return modeObj;
    }
    // This can be used to attach properties to mode objects from
    // outside the actual mode definition.
    var modeExtensions = {};
    // STRING STREAM
    // Fed to the mode parsers, provides helper functions to make
    // parsers more succinct.
    var StringStream = function StringStream(string, tabSize, lineOracle) {
        this.pos = this.start = 0;
        this.string = string;
        this.tabSize = tabSize || 8;
        this.lastColumnPos = this.lastColumnValue = 0;
        this.lineStart = 0;
        this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
        return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
        return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
        return this.string.charAt(this.pos) || undefined;
    };
    StringStream.prototype.next = function() {
        if (this.pos < this.string.length) {
            return this.string.charAt(this.pos++);
        }
    };
    StringStream.prototype.eat = function(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") {
            ok = ch == match;
        } else {
            ok = ch && (match.test ? match.test(ch) : match(ch));
        }
        if (ok) {
            ++this.pos;
            return ch;
        }
    };
    StringStream.prototype.eatWhile = function(match) {
        var start = this.pos;
        while(this.eat(match)){}
        return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos))){
            ++this.pos;
        }
        return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
        this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    };
    StringStream.prototype.backUp = function(n) {
        this.pos -= n;
    };
    StringStream.prototype.column = function() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
        return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = function cased(str) {
                return caseInsensitive ? str.toLowerCase() : str;
            };
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) {
                    this.pos += pattern.length;
                }
                return true;
            }
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) {
                return null;
            }
            if (match && consume !== false) {
                this.pos += match[0].length;
            }
            return match;
        }
    };
    StringStream.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
        this.lineStart += n;
        try {
            return inner();
        } finally{
            this.lineStart -= n;
        }
    };
    StringStream.prototype.lookAhead = function(n) {
        var oracle = this.lineOracle;
        return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
        var oracle = this.lineOracle;
        return oracle && oracle.baseToken(this.pos);
    };
    // A Pos instance represents a position within the text.
    function Pos(line, ch, sticky) {
        if (sticky === void 0) sticky = null;
        if (!_instanceof(this, Pos)) {
            return new Pos(line, ch, sticky);
        }
        this.line = line;
        this.ch = ch;
        this.sticky = sticky;
    }
    var SavedContext = function SavedContext(state, lookAhead) {
        this.state = state;
        this.lookAhead = lookAhead;
    };
    var Context = function Context(doc, state, line, lookAhead) {
        this.state = state;
        this.doc = doc;
        this.line = line;
        this.maxLookAhead = lookAhead || 0;
        this.baseTokens = null;
        this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
        var line = this.doc.getLine(this.line + n);
        if (line != null && n > this.maxLookAhead) {
            this.maxLookAhead = n;
        }
        return line;
    };
    Context.prototype.baseToken = function(n) {
        if (!this.baseTokens) {
            return null;
        }
        while(this.baseTokens[this.baseTokenPos] <= n){
            this.baseTokenPos += 2;
        }
        var type = this.baseTokens[this.baseTokenPos + 1];
        return {
            type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n
        };
    };
    Context.prototype.nextLine = function() {
        this.line++;
        if (this.maxLookAhead > 0) {
            this.maxLookAhead--;
        }
    };
    Context.fromSaved = function(doc, saved, line) {
        if (_instanceof(saved, SavedContext)) {
            return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
        } else {
            return new Context(doc, copyState(doc.mode, saved), line);
        }
    };
    Context.prototype.save = function(copy) {
        var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    var Token = function Token(stream, type, state) {
        this.start = stream.start;
        this.end = stream.pos;
        this.string = stream.current();
        this.type = type || null;
        this.state = state;
    };
    // Optimize some code when these features are not used.
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function lineIsHiddenInner(doc, line, span) {
        if (span.to == null) {
            var end = span.marker.find(1, true);
            return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
        }
        if (span.marker.inclusiveRight && span.to == line.text.length) {
            return true;
        }
        for(var sp = void 0, i = 0; i < line.markedSpans.length; ++i){
            sp = line.markedSpans[i];
            if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) {
                return true;
            }
        }
    }
    // LINE DATA STRUCTURE
    // Line objects. These hold state related to a line, including
    // highlighting info (the styles array).
    var Line = function Line(text, markedSpans, estimateHeight) {
        this.text = text;
        attachMarkedSpans(this, markedSpans);
        this.height = estimateHeight ? estimateHeight(this) : 1;
    };
    Line.prototype.lineNo = function() {
        return lineNo(this);
    };
    eventMixin(Line);
    // Convert a style as returned by a mode (either null, or a string
    // containing one or more styles) to a CSS style. This is cached,
    // and also looks for line-wide styles.
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    var operationGroup = null;
    var orphanDelayedCallbacks = null;
    var nullRect = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    var measureText;
    var NativeScrollbars = function NativeScrollbars(place, scroll, cm) {
        this.cm = cm;
        var vert = this.vert = elt("div", [
            elt("div", null, null, "min-width: 1px")
        ], "CodeMirror-vscrollbar");
        var horiz = this.horiz = elt("div", [
            elt("div", null, null, "height: 100%; min-height: 1px")
        ], "CodeMirror-hscrollbar");
        vert.tabIndex = horiz.tabIndex = -1;
        place(vert);
        place(horiz);
        on(vert, "scroll", function() {
            if (vert.clientHeight) {
                scroll(vert.scrollTop, "vertical");
            }
        });
        on(horiz, "scroll", function() {
            if (horiz.clientWidth) {
                scroll(horiz.scrollLeft, "horizontal");
            }
        });
        this.checkedZeroWidth = false;
        // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
        if (ie && ie_version < 8) {
            this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
        }
    };
    NativeScrollbars.prototype.update = function(measure) {
        var needsH = measure.scrollWidth > measure.clientWidth + 1;
        var needsV = measure.scrollHeight > measure.clientHeight + 1;
        var sWidth = measure.nativeBarWidth;
        if (needsV) {
            this.vert.style.display = "block";
            this.vert.style.bottom = needsH ? sWidth + "px" : "0";
            var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
            // A bug in IE8 can cause this value to be negative, so guard it.
            this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
        } else {
            this.vert.scrollTop = 0;
            this.vert.style.display = "";
            this.vert.firstChild.style.height = "0";
        }
        if (needsH) {
            this.horiz.style.display = "block";
            this.horiz.style.right = needsV ? sWidth + "px" : "0";
            this.horiz.style.left = measure.barLeft + "px";
            var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
            this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
        } else {
            this.horiz.style.display = "";
            this.horiz.firstChild.style.width = "0";
        }
        if (!this.checkedZeroWidth && measure.clientHeight > 0) {
            if (sWidth == 0) {
                this.zeroWidthHack();
            }
            this.checkedZeroWidth = true;
        }
        return {
            right: needsV ? sWidth : 0,
            bottom: needsH ? sWidth : 0
        };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
        if (this.horiz.scrollLeft != pos) {
            this.horiz.scrollLeft = pos;
        }
        if (this.disableHoriz) {
            this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
        }
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
        if (this.vert.scrollTop != pos) {
            this.vert.scrollTop = pos;
        }
        if (this.disableVert) {
            this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
        }
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
        var w = mac && !mac_geMountainLion ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = w;
        this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
        this.disableHoriz = new Delayed;
        this.disableVert = new Delayed;
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
        bar.style.pointerEvents = "auto";
        function maybeDisable() {
            // To find out whether the scrollbar is still visible, we
            // check whether the element under the pixel in the bottom
            // right corner of the scrollbar box is the scrollbar box
            // itself (when the bar is still visible) or its filler child
            // (when the bar is hidden). If it is still visible, we keep
            // it enabled, if it's hidden, we disable pointer events.
            var box = bar.getBoundingClientRect();
            var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
            if (elt != bar) {
                bar.style.pointerEvents = "none";
            } else {
                delay.set(1000, maybeDisable);
            }
        }
        delay.set(1000, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
        var parent = this.horiz.parentNode;
        parent.removeChild(this.horiz);
        parent.removeChild(this.vert);
    };
    var NullScrollbars = function NullScrollbars() {};
    NullScrollbars.prototype.update = function() {
        return {
            bottom: 0,
            right: 0
        };
    };
    NullScrollbars.prototype.setScrollLeft = function() {};
    NullScrollbars.prototype.setScrollTop = function() {};
    NullScrollbars.prototype.clear = function() {};
    var scrollbarModel = {
        "native": NativeScrollbars,
        "null": NullScrollbars
    };
    // Operations are used to wrap a series of changes to the editor
    // state in such a way that each change won't have to update the
    // cursor and display (which would be awkward, slow, and
    // error-prone). Instead, display updates are batched and then all
    // combined and executed at once.
    var nextOpId = 0;
    // DISPLAY DRAWING
    var DisplayUpdate = function DisplayUpdate(cm, viewport, force) {
        var display = cm.display;
        this.viewport = viewport;
        // Store some values that we'll need later (but don't want to force a relayout for)
        this.visible = visibleLines(display, cm.doc, viewport);
        this.editorIsHidden = !display.wrapper.offsetWidth;
        this.wrapperHeight = display.wrapper.clientHeight;
        this.wrapperWidth = display.wrapper.clientWidth;
        this.oldDisplayWidth = displayWidth(cm);
        this.force = force;
        this.dims = getDimensions(cm);
        this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
        if (hasHandler(emitter, type)) {
            this.events.push(arguments);
        }
    };
    DisplayUpdate.prototype.finish = function() {
        for(var i = 0; i < this.events.length; i++){
            signal.apply(null, this.events[i]);
        }
    };
    // Since the delta values reported on mouse wheel events are
    // unstandardized between browsers and even browser versions, and
    // generally horribly unpredictable, this code starts by measuring
    // the scroll effect that the first few mouse wheel events have,
    // and, from that, detects the way it can convert deltas to pixel
    // offsets afterwards.
    //
    // The reason we want to know the amount a wheel event will scroll
    // is that it gives us a chance to update the display before the
    // actual scrolling happens, reducing flickering.
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    // Fill in a browser-detected starting value on browsers where we
    // know one. These don't have to be accurate -- the result of them
    // being wrong would just be a slight flicker on the first wheel
    // scroll (if it is large enough).
    if (ie) {
        wheelPixelsPerUnit = -.53;
    } else if (gecko) {
        wheelPixelsPerUnit = 15;
    } else if (chrome) {
        wheelPixelsPerUnit = -.7;
    } else if (safari) {
        wheelPixelsPerUnit = -1 / 3;
    }
    // Selection objects are immutable. A new one is created every time
    // the selection changes. A selection is one or more non-overlapping
    // (and non-touching) ranges, sorted, and an integer that indicates
    // which one is the primary selection (the one that's scrolled into
    // view, that getCursor returns, etc).
    var Selection = function Selection(ranges, primIndex) {
        this.ranges = ranges;
        this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
        return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
        if (other == this) {
            return true;
        }
        if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) {
            return false;
        }
        for(var i = 0; i < this.ranges.length; i++){
            var here = this.ranges[i], there = other.ranges[i];
            if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) {
                return false;
            }
        }
        return true;
    };
    Selection.prototype.deepCopy = function() {
        var out = [];
        for(var i = 0; i < this.ranges.length; i++){
            out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
        }
        return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
        for(var i = 0; i < this.ranges.length; i++){
            if (!this.ranges[i].empty()) {
                return true;
            }
        }
        return false;
    };
    Selection.prototype.contains = function(pos, end) {
        if (!end) {
            end = pos;
        }
        for(var i = 0; i < this.ranges.length; i++){
            var range = this.ranges[i];
            if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) {
                return i;
            }
        }
        return -1;
    };
    var Range = function Range(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    };
    Range.prototype.from = function() {
        return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
        return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
        var line = getLine(doc, pos.line);
        if (line.markedSpans) {
            for(var i = 0; i < line.markedSpans.length; ++i){
                var sp = line.markedSpans[i], m = sp.marker;
                // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
                // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
                // is with selectLeft/Right
                var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
                var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
                if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
                    if (mayClear) {
                        signal(m, "beforeCursorEnter");
                        if (m.explicitlyCleared) {
                            if (!line.markedSpans) {
                                break;
                            } else {
                                --i;
                                continue;
                            }
                        }
                    }
                    if (!m.atomic) {
                        continue;
                    }
                    if (oldPos) {
                        var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
                        if (dir < 0 ? preventCursorRight : preventCursorLeft) {
                            near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
                        }
                        if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) {
                            return skipAtomicInner(doc, near, pos, dir, mayClear);
                        }
                    }
                    var far = m.find(dir < 0 ? -1 : 1);
                    if (dir < 0 ? preventCursorLeft : preventCursorRight) {
                        far = movePos(doc, far, dir, far.line == pos.line ? line : null);
                    }
                    return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
                }
            }
        }
        return pos;
    }
    // Apply a change to a document, and add it to the document's
    // history, and propagating it to all linked documents.
    function makeChange(doc, change, ignoreReadOnly) {
        if (doc.cm) {
            if (!doc.cm.curOp) {
                return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
            }
            if (doc.cm.state.suppressEdits) {
                return;
            }
        }
        if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
            change = filterChange(doc, change, true);
            if (!change) {
                return;
            }
        }
        // Possibly split or suppress the update based on the presence
        // of read-only spans in its range.
        var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
        if (split) {
            for(var i = split.length - 1; i >= 0; --i){
                makeChangeInner(doc, {
                    from: split[i].from,
                    to: split[i].to,
                    text: i ? [
                        ""
                    ] : change.text,
                    origin: change.origin
                });
            }
        } else {
            makeChangeInner(doc, change);
        }
    }
    // More lower-level change function, handling only a single document
    // (not linked ones).
    function makeChangeSingleDoc(doc, change, selAfter, spans) {
        if (doc.cm && !doc.cm.curOp) {
            return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
        }
        if (change.to.line < doc.first) {
            shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
            return;
        }
        if (change.from.line > doc.lastLine()) {
            return;
        }
        // Clip the change to the size of this doc
        if (change.from.line < doc.first) {
            var shift = change.text.length - 1 - (doc.first - change.from.line);
            shiftDoc(doc, shift);
            change = {
                from: Pos(doc.first, 0),
                to: Pos(change.to.line + shift, change.to.ch),
                text: [
                    lst(change.text)
                ],
                origin: change.origin
            };
        }
        var last = doc.lastLine();
        if (change.to.line > last) {
            change = {
                from: change.from,
                to: Pos(last, getLine(doc, last).text.length),
                text: [
                    change.text[0]
                ],
                origin: change.origin
            };
        }
        change.removed = getBetween(doc, change.from, change.to);
        if (!selAfter) {
            selAfter = computeSelAfterChange(doc, change);
        }
        if (doc.cm) {
            makeChangeSingleDocInEditor(doc.cm, change, spans);
        } else {
            updateDoc(doc, change, spans);
        }
        setSelectionNoUndo(doc, selAfter, sel_dontScroll);
        if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) {
            doc.cantEdit = false;
        }
    }
    LeafChunk.prototype = {
        chunkSize: function chunkSize() {
            return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function removeInner(at, n) {
            for(var i = at, e = at + n; i < e; ++i){
                var line = this.lines[i];
                this.height -= line.height;
                cleanUpLine(line);
                signalLater(line, "delete");
            }
            this.lines.splice(at, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function collapse(lines) {
            lines.push.apply(lines, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function insertInner(at, lines, height) {
            this.height += height;
            this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
            for(var i = 0; i < lines.length; ++i){
                lines[i].parent = this;
            }
        },
        // Used to iterate over a part of the tree.
        iterN: function iterN(at, n, op) {
            for(var e = at + n; at < e; ++at){
                if (op(this.lines[at])) {
                    return true;
                }
            }
        }
    };
    BranchChunk.prototype = {
        chunkSize: function chunkSize() {
            return this.size;
        },
        removeInner: function removeInner(at, n) {
            this.size -= n;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var rm = Math.min(n, sz - at), oldHeight = child.height;
                    child.removeInner(at, rm);
                    this.height -= oldHeight - child.height;
                    if (sz == rm) {
                        this.children.splice(i--, 1);
                        child.parent = null;
                    }
                    if ((n -= rm) == 0) {
                        break;
                    }
                    at = 0;
                } else {
                    at -= sz;
                }
            }
            // If the result is smaller than 25 lines, ensure that it is a
            // single leaf node.
            if (this.size - n < 25 && (this.children.length > 1 || !_instanceof(this.children[0], LeafChunk))) {
                var lines = [];
                this.collapse(lines);
                this.children = [
                    new LeafChunk(lines)
                ];
                this.children[0].parent = this;
            }
        },
        collapse: function collapse(lines) {
            for(var i = 0; i < this.children.length; ++i){
                this.children[i].collapse(lines);
            }
        },
        insertInner: function insertInner(at, lines, height) {
            this.size += lines.length;
            this.height += height;
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at <= sz) {
                    child.insertInner(at, lines, height);
                    if (child.lines && child.lines.length > 50) {
                        // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
                        // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
                        var remaining = child.lines.length % 25 + 25;
                        for(var pos = remaining; pos < child.lines.length;){
                            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                            child.height -= leaf.height;
                            this.children.splice(++i, 0, leaf);
                            leaf.parent = this;
                        }
                        child.lines = child.lines.slice(0, remaining);
                        this.maybeSpill();
                    }
                    break;
                }
                at -= sz;
            }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function maybeSpill() {
            if (this.children.length <= 10) {
                return;
            }
            var me = this;
            do {
                var spilled = me.children.splice(me.children.length - 5, 5);
                var sibling = new BranchChunk(spilled);
                if (!me.parent) {
                    var copy = new BranchChunk(me.children);
                    copy.parent = me;
                    me.children = [
                        copy,
                        sibling
                    ];
                    me = copy;
                } else {
                    me.size -= sibling.size;
                    me.height -= sibling.height;
                    var myIndex = indexOf(me.parent.children, me);
                    me.parent.children.splice(myIndex + 1, 0, sibling);
                }
                sibling.parent = me.parent;
            }while (me.children.length > 10);
            me.parent.maybeSpill();
        },
        iterN: function iterN(at, n, op) {
            for(var i = 0; i < this.children.length; ++i){
                var child = this.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var used = Math.min(n, sz - at);
                    if (child.iterN(at, used, op)) {
                        return true;
                    }
                    if ((n -= used) == 0) {
                        break;
                    }
                    at = 0;
                } else {
                    at -= sz;
                }
            }
        }
    };
    // Line widgets are block elements displayed above or below a line.
    var LineWidget = function LineWidget(doc, node, options) {
        if (options) {
            for(var opt in options){
                if (options.hasOwnProperty(opt)) {
                    this[opt] = options[opt];
                }
            }
        }
        this.doc = doc;
        this.node = node;
    };
    LineWidget.prototype.clear = function() {
        var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
        if (no == null || !ws) {
            return;
        }
        for(var i = 0; i < ws.length; ++i){
            if (ws[i] == this) {
                ws.splice(i--, 1);
            }
        }
        if (!ws.length) {
            line.widgets = null;
        }
        var height = widgetHeight(this);
        updateLineHeight(line, Math.max(0, line.height - height));
        if (cm) {
            runInOp(cm, function() {
                adjustScrollWhenAboveVisible(cm, line, -height);
                regLineChange(cm, no, "widget");
            });
            signalLater(cm, "lineWidgetCleared", cm, this, no);
        }
    };
    LineWidget.prototype.changed = function() {
        var this$1 = this;
        var oldH = this.height, cm = this.doc.cm, line = this.line;
        this.height = null;
        var diff = widgetHeight(this) - oldH;
        if (!diff) {
            return;
        }
        if (!lineIsHidden(this.doc, line)) {
            updateLineHeight(line, line.height + diff);
        }
        if (cm) {
            runInOp(cm, function() {
                cm.curOp.forceUpdate = true;
                adjustScrollWhenAboveVisible(cm, line, diff);
                signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
            });
        }
    };
    eventMixin(LineWidget);
    // TEXTMARKERS
    // Created with markText and setBookmark methods. A TextMarker is a
    // handle that can be used to clear or find a marked position in the
    // document. Line objects hold arrays (markedSpans) containing
    // {from, to, marker} object pointing to such marker objects, and
    // indicating that such a marker is present on that line. Multiple
    // lines may point to the same marker when it spans across lines.
    // The spans will have null for their from/to properties when the
    // marker continues beyond the start/end of the line. Markers have
    // links back to the lines they currently touch.
    // Collapsed markers have unique ids, in order to be able to order
    // them, which is needed for uniquely determining an outer marker
    // when they overlap (they may nest, but not partially overlap).
    var nextMarkerId = 0;
    var TextMarker = function TextMarker(doc, type) {
        this.lines = [];
        this.type = type;
        this.doc = doc;
        this.id = ++nextMarkerId;
    };
    // Clear the marker.
    TextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) {
            return;
        }
        var cm = this.doc.cm, withOp = cm && !cm.curOp;
        if (withOp) {
            startOperation(cm);
        }
        if (hasHandler(this, "clear")) {
            var found = this.find();
            if (found) {
                signalLater(this, "clear", found.from, found.to);
            }
        }
        var min = null, max = null;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (cm && !this.collapsed) {
                regLineChange(cm, lineNo(line), "text");
            } else if (cm) {
                if (span.to != null) {
                    max = lineNo(line);
                }
                if (span.from != null) {
                    min = lineNo(line);
                }
            }
            line.markedSpans = removeMarkedSpan(line.markedSpans, span);
            if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) {
                updateLineHeight(line, textHeight(cm.display));
            }
        }
        if (cm && this.collapsed && !cm.options.lineWrapping) {
            for(var i$1 = 0; i$1 < this.lines.length; ++i$1){
                var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
                if (len > cm.display.maxLineLength) {
                    cm.display.maxLine = visual;
                    cm.display.maxLineLength = len;
                    cm.display.maxLineChanged = true;
                }
            }
        }
        if (min != null && cm && this.collapsed) {
            regChange(cm, min, max + 1);
        }
        this.lines.length = 0;
        this.explicitlyCleared = true;
        if (this.atomic && this.doc.cantEdit) {
            this.doc.cantEdit = false;
            if (cm) {
                reCheckSelection(cm.doc);
            }
        }
        if (cm) {
            signalLater(cm, "markerCleared", cm, this, min, max);
        }
        if (withOp) {
            endOperation(cm);
        }
        if (this.parent) {
            this.parent.clear();
        }
    };
    // Find the position of the marker in the document. Returns a {from,
    // to} object by default. Side can be passed to get a specific side
    // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
    // Pos objects returned contain a line object, rather than a line
    // number (used to prevent looking up the same line twice).
    TextMarker.prototype.find = function(side, lineObj) {
        if (side == null && this.type == "bookmark") {
            side = 1;
        }
        var from, to;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this);
            if (span.from != null) {
                from = Pos(lineObj ? line : lineNo(line), span.from);
                if (side == -1) {
                    return from;
                }
            }
            if (span.to != null) {
                to = Pos(lineObj ? line : lineNo(line), span.to);
                if (side == 1) {
                    return to;
                }
            }
        }
        return from && {
            from: from,
            to: to
        };
    };
    // Signals that the marker's widget changed, and surrounding layout
    // should be recomputed.
    TextMarker.prototype.changed = function() {
        var this$1 = this;
        var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
        if (!pos || !cm) {
            return;
        }
        runInOp(cm, function() {
            var line = pos.line, lineN = lineNo(pos.line);
            var view = findViewForLine(cm, lineN);
            if (view) {
                clearLineMeasurementCacheFor(view);
                cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
            }
            cm.curOp.updateMaxLine = true;
            if (!lineIsHidden(widget.doc, line) && widget.height != null) {
                var oldHeight = widget.height;
                widget.height = null;
                var dHeight = widgetHeight(widget) - oldHeight;
                if (dHeight) {
                    updateLineHeight(line, line.height + dHeight);
                }
            }
            signalLater(cm, "markerChanged", cm, this$1);
        });
    };
    TextMarker.prototype.attachLine = function(line) {
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) {
                (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
            }
        }
        this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
        this.lines.splice(indexOf(this.lines, line), 1);
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
        }
    };
    eventMixin(TextMarker);
    // Create a marker, wire it up to the right lines, and
    function markText(doc, from, to, options, type) {
        // Shared markers (across linked documents) are handled separately
        // (markTextShared will call out to this again, once per
        // document).
        if (options && options.shared) {
            return markTextShared(doc, from, to, options, type);
        }
        // Ensure we are in an operation.
        if (doc.cm && !doc.cm.curOp) {
            return operation(doc.cm, markText)(doc, from, to, options, type);
        }
        var marker = new TextMarker(doc, type), diff = cmp(from, to);
        if (options) {
            copyObj(options, marker, false);
        }
        // Don't connect empty markers unless clearWhenEmpty is false
        if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) {
            return marker;
        }
        if (marker.replacedWith) {
            // Showing up as a widget implies collapsed (widget replaces text)
            marker.collapsed = true;
            marker.widgetNode = eltP("span", [
                marker.replacedWith
            ], "CodeMirror-widget");
            if (!options.handleMouseEvents) {
                marker.widgetNode.setAttribute("cm-ignore-events", "true");
            }
            if (options.insertLeft) {
                marker.widgetNode.insertLeft = true;
            }
        }
        if (marker.collapsed) {
            if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) {
                throw new Error("Inserting collapsed marker partially overlapping an existing one");
            }
            seeCollapsedSpans();
        }
        if (marker.addToHistory) {
            addChangeToHistory(doc, {
                from: from,
                to: to,
                origin: "markText"
            }, doc.sel, NaN);
        }
        var curLine = from.line, cm = doc.cm, updateMaxLine;
        doc.iter(curLine, to.line + 1, function(line) {
            if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) {
                updateMaxLine = true;
            }
            if (marker.collapsed && curLine != from.line) {
                updateLineHeight(line, 0);
            }
            addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
            ++curLine;
        });
        // lineIsHidden depends on the presence of the spans, so needs a second pass
        if (marker.collapsed) {
            doc.iter(from.line, to.line + 1, function(line) {
                if (lineIsHidden(doc, line)) {
                    updateLineHeight(line, 0);
                }
            });
        }
        if (marker.clearOnEnter) {
            on(marker, "beforeCursorEnter", function() {
                return marker.clear();
            });
        }
        if (marker.readOnly) {
            seeReadOnlySpans();
            if (doc.history.done.length || doc.history.undone.length) {
                doc.clearHistory();
            }
        }
        if (marker.collapsed) {
            marker.id = ++nextMarkerId;
            marker.atomic = true;
        }
        if (cm) {
            // Sync editor state
            if (updateMaxLine) {
                cm.curOp.updateMaxLine = true;
            }
            if (marker.collapsed) {
                regChange(cm, from.line, to.line + 1);
            } else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) {
                for(var i = from.line; i <= to.line; i++){
                    regLineChange(cm, i, "text");
                }
            }
            if (marker.atomic) {
                reCheckSelection(cm.doc);
            }
            signalLater(cm, "markerAdded", cm, marker);
        }
        return marker;
    }
    // SHARED TEXTMARKERS
    // A shared marker spans multiple linked documents. It is
    // implemented as a meta-marker-object controlling multiple normal
    // markers.
    var SharedTextMarker = function SharedTextMarker(markers, primary) {
        this.markers = markers;
        this.primary = primary;
        for(var i = 0; i < markers.length; ++i){
            markers[i].parent = this;
        }
    };
    SharedTextMarker.prototype.clear = function() {
        if (this.explicitlyCleared) {
            return;
        }
        this.explicitlyCleared = true;
        for(var i = 0; i < this.markers.length; ++i){
            this.markers[i].clear();
        }
        signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
        return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    var nextDocId = 0;
    var Doc = function Doc1(text, mode, firstLine, lineSep, direction) {
        if (!_instanceof(this, Doc)) {
            return new Doc(text, mode, firstLine, lineSep, direction);
        }
        if (firstLine == null) {
            firstLine = 0;
        }
        BranchChunk.call(this, [
            new LeafChunk([
                new Line("", null)
            ])
        ]);
        this.first = firstLine;
        this.scrollTop = this.scrollLeft = 0;
        this.cantEdit = false;
        this.cleanGeneration = 1;
        this.modeFrontier = this.highlightFrontier = firstLine;
        var start = Pos(firstLine, 0);
        this.sel = simpleSelection(start);
        this.history = new History(null);
        this.id = ++nextDocId;
        this.modeOption = mode;
        this.lineSep = lineSep;
        this.direction = direction == "rtl" ? "rtl" : "ltr";
        this.extend = false;
        if (typeof text == "string") {
            text = this.splitLines(text);
        }
        updateDoc(this, {
            from: start,
            to: start,
            text: text
        });
        setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
        constructor: Doc,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function iter(from, to, op) {
            if (op) {
                this.iterN(from - this.first, to - from, op);
            } else {
                this.iterN(this.first, this.first + this.size, from);
            }
        },
        // Non-public interface for adding and removing lines.
        insert: function insert(at, lines) {
            var height = 0;
            for(var i = 0; i < lines.length; ++i){
                height += lines[i].height;
            }
            this.insertInner(at - this.first, lines, height);
        },
        remove: function remove(at, n) {
            this.removeInner(at - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function getValue(lineSep) {
            var lines = getLines(this, this.first, this.first + this.size);
            if (lineSep === false) {
                return lines;
            }
            return lines.join(lineSep || this.lineSeparator());
        },
        setValue: docMethodOp(function(code) {
            var top = Pos(this.first, 0), last = this.first + this.size - 1;
            makeChange(this, {
                from: top,
                to: Pos(last, getLine(this, last).text.length),
                text: this.splitLines(code),
                origin: "setValue",
                full: true
            }, true);
            if (this.cm) {
                scrollToCoords(this.cm, 0, 0);
            }
            setSelection(this, simpleSelection(top), sel_dontScroll);
        }),
        replaceRange: function replaceRange1(code, from, to, origin) {
            from = clipPos(this, from);
            to = to ? clipPos(this, to) : from;
            replaceRange(this, code, from, to, origin);
        },
        getRange: function getRange(from, to, lineSep) {
            var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
            if (lineSep === false) {
                return lines;
            }
            if (lineSep === "") {
                return lines.join("");
            }
            return lines.join(lineSep || this.lineSeparator());
        },
        getLine: function getLine(line) {
            var l = this.getLineHandle(line);
            return l && l.text;
        },
        getLineHandle: function getLineHandle(line) {
            if (isLine(this, line)) {
                return getLine(this, line);
            }
        },
        getLineNumber: function getLineNumber(line) {
            return lineNo(line);
        },
        getLineHandleVisualStart: function getLineHandleVisualStart(line) {
            if (typeof line == "number") {
                line = getLine(this, line);
            }
            return visualLine(line);
        },
        lineCount: function lineCount() {
            return this.size;
        },
        firstLine: function firstLine() {
            return this.first;
        },
        lastLine: function lastLine() {
            return this.first + this.size - 1;
        },
        clipPos: function clipPos1(pos) {
            return clipPos(this, pos);
        },
        getCursor: function getCursor(start) {
            var range = this.sel.primary(), pos;
            if (start == null || start == "head") {
                pos = range.head;
            } else if (start == "anchor") {
                pos = range.anchor;
            } else if (start == "end" || start == "to" || start === false) {
                pos = range.to();
            } else {
                pos = range.from();
            }
            return pos;
        },
        listSelections: function listSelections() {
            return this.sel.ranges;
        },
        somethingSelected: function somethingSelected() {
            return this.sel.somethingSelected();
        },
        setCursor: docMethodOp(function(line, ch, options) {
            setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
        }),
        setSelection: docMethodOp(function(anchor, head, options) {
            setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
        }),
        extendSelection: docMethodOp(function(head, other, options) {
            extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
        }),
        extendSelections: docMethodOp(function(heads, options) {
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        extendSelectionsBy: docMethodOp(function(f, options) {
            var heads = map(this.sel.ranges, f);
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        setSelections: docMethodOp(function(ranges, primary, options) {
            if (!ranges.length) {
                return;
            }
            var out = [];
            for(var i = 0; i < ranges.length; i++){
                out[i] = new Range(clipPos(this, ranges[i].anchor), clipPos(this, ranges[i].head || ranges[i].anchor));
            }
            if (primary == null) {
                primary = Math.min(ranges.length - 1, this.sel.primIndex);
            }
            setSelection(this, normalizeSelection(this.cm, out, primary), options);
        }),
        addSelection: docMethodOp(function(anchor, head, options) {
            var ranges = this.sel.ranges.slice(0);
            ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
            setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
        }),
        getSelection: function getSelection(lineSep) {
            var ranges = this.sel.ranges, lines;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                lines = lines ? lines.concat(sel) : sel;
            }
            if (lineSep === false) {
                return lines;
            } else {
                return lines.join(lineSep || this.lineSeparator());
            }
        },
        getSelections: function getSelections(lineSep) {
            var parts = [], ranges = this.sel.ranges;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this, ranges[i].from(), ranges[i].to());
                if (lineSep !== false) {
                    sel = sel.join(lineSep || this.lineSeparator());
                }
                parts[i] = sel;
            }
            return parts;
        },
        replaceSelection: function replaceSelection(code, collapse, origin) {
            var dup = [];
            for(var i = 0; i < this.sel.ranges.length; i++){
                dup[i] = code;
            }
            this.replaceSelections(dup, collapse, origin || "+input");
        },
        replaceSelections: docMethodOp(function(code, collapse, origin) {
            var changes = [], sel = this.sel;
            for(var i = 0; i < sel.ranges.length; i++){
                var range = sel.ranges[i];
                changes[i] = {
                    from: range.from(),
                    to: range.to(),
                    text: this.splitLines(code[i]),
                    origin: origin
                };
            }
            var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
            for(var i$1 = changes.length - 1; i$1 >= 0; i$1--){
                makeChange(this, changes[i$1]);
            }
            if (newSel) {
                setSelectionReplaceHistory(this, newSel);
            } else if (this.cm) {
                ensureCursorVisible(this.cm);
            }
        }),
        undo: docMethodOp(function() {
            makeChangeFromHistory(this, "undo");
        }),
        redo: docMethodOp(function() {
            makeChangeFromHistory(this, "redo");
        }),
        undoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "undo", true);
        }),
        redoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "redo", true);
        }),
        setExtending: function setExtending(val) {
            this.extend = val;
        },
        getExtending: function getExtending() {
            return this.extend;
        },
        historySize: function historySize() {
            var hist = this.history, done = 0, undone = 0;
            for(var i = 0; i < hist.done.length; i++){
                if (!hist.done[i].ranges) {
                    ++done;
                }
            }
            for(var i$1 = 0; i$1 < hist.undone.length; i$1++){
                if (!hist.undone[i$1].ranges) {
                    ++undone;
                }
            }
            return {
                undo: done,
                redo: undone
            };
        },
        clearHistory: function clearHistory() {
            var this$1 = this;
            this.history = new History(this.history);
            linkedDocs(this, function(doc) {
                return doc.history = this$1.history;
            }, true);
        },
        markClean: function markClean() {
            this.cleanGeneration = this.changeGeneration(true);
        },
        changeGeneration: function changeGeneration(forceSplit) {
            if (forceSplit) {
                this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
            }
            return this.history.generation;
        },
        isClean: function isClean(gen) {
            return this.history.generation == (gen || this.cleanGeneration);
        },
        getHistory: function getHistory() {
            return {
                done: copyHistoryArray(this.history.done),
                undone: copyHistoryArray(this.history.undone)
            };
        },
        setHistory: function setHistory(histData) {
            var hist = this.history = new History(this.history);
            hist.done = copyHistoryArray(histData.done.slice(0), null, true);
            hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
        },
        setGutterMarker: docMethodOp(function(line, gutterID, value) {
            return changeLine(this, line, "gutter", function(line) {
                var markers = line.gutterMarkers || (line.gutterMarkers = {});
                markers[gutterID] = value;
                if (!value && isEmpty(markers)) {
                    line.gutterMarkers = null;
                }
                return true;
            });
        }),
        clearGutter: docMethodOp(function(gutterID) {
            var this$1 = this;
            this.iter(function(line) {
                if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
                    changeLine(this$1, line, "gutter", function() {
                        line.gutterMarkers[gutterID] = null;
                        if (isEmpty(line.gutterMarkers)) {
                            line.gutterMarkers = null;
                        }
                        return true;
                    });
                }
            });
        }),
        lineInfo: function lineInfo(line) {
            var n;
            if (typeof line == "number") {
                if (!isLine(this, line)) {
                    return null;
                }
                n = line;
                line = getLine(this, line);
                if (!line) {
                    return null;
                }
            } else {
                n = lineNo(line);
                if (n == null) {
                    return null;
                }
            }
            return {
                line: n,
                handle: line,
                text: line.text,
                gutterMarkers: line.gutterMarkers,
                textClass: line.textClass,
                bgClass: line.bgClass,
                wrapClass: line.wrapClass,
                widgets: line.widgets
            };
        },
        addLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                if (!line[prop]) {
                    line[prop] = cls;
                } else if (classTest(cls).test(line[prop])) {
                    return false;
                } else {
                    line[prop] += " " + cls;
                }
                return true;
            });
        }),
        removeLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                var cur = line[prop];
                if (!cur) {
                    return false;
                } else if (cls == null) {
                    line[prop] = null;
                } else {
                    var found = cur.match(classTest(cls));
                    if (!found) {
                        return false;
                    }
                    var end = found.index + found[0].length;
                    line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
                }
                return true;
            });
        }),
        addLineWidget: docMethodOp(function(handle, node, options) {
            return addLineWidget(this, handle, node, options);
        }),
        removeLineWidget: function removeLineWidget(widget) {
            widget.clear();
        },
        markText: function markText1(from, to, options) {
            return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
        },
        setBookmark: function setBookmark(pos, options) {
            var realOpts = {
                replacedWith: options && (options.nodeType == null ? options.widget : options),
                insertLeft: options && options.insertLeft,
                clearWhenEmpty: false,
                shared: options && options.shared,
                handleMouseEvents: options && options.handleMouseEvents
            };
            pos = clipPos(this, pos);
            return markText(this, pos, pos, realOpts, "bookmark");
        },
        findMarksAt: function findMarksAt(pos) {
            pos = clipPos(this, pos);
            var markers = [], spans = getLine(this, pos.line).markedSpans;
            if (spans) {
                for(var i = 0; i < spans.length; ++i){
                    var span = spans[i];
                    if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) {
                        markers.push(span.marker.parent || span.marker);
                    }
                }
            }
            return markers;
        },
        findMarks: function findMarks(from, to, filter) {
            from = clipPos(this, from);
            to = clipPos(this, to);
            var found = [], lineNo = from.line;
            this.iter(from.line, to.line + 1, function(line) {
                var spans = line.markedSpans;
                if (spans) {
                    for(var i = 0; i < spans.length; i++){
                        var span = spans[i];
                        if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) {
                            found.push(span.marker.parent || span.marker);
                        }
                    }
                }
                ++lineNo;
            });
            return found;
        },
        getAllMarks: function getAllMarks() {
            var markers = [];
            this.iter(function(line) {
                var sps = line.markedSpans;
                if (sps) {
                    for(var i = 0; i < sps.length; ++i){
                        if (sps[i].from != null) {
                            markers.push(sps[i].marker);
                        }
                    }
                }
            });
            return markers;
        },
        posFromIndex: function posFromIndex(off) {
            var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
            this.iter(function(line) {
                var sz = line.text.length + sepSize;
                if (sz > off) {
                    ch = off;
                    return true;
                }
                off -= sz;
                ++lineNo;
            });
            return clipPos(this, Pos(lineNo, ch));
        },
        indexFromPos: function indexFromPos(coords) {
            coords = clipPos(this, coords);
            var index = coords.ch;
            if (coords.line < this.first || coords.ch < 0) {
                return 0;
            }
            var sepSize = this.lineSeparator().length;
            this.iter(this.first, coords.line, function(line) {
                index += line.text.length + sepSize;
            });
            return index;
        },
        copy: function copy(copyHistory) {
            var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            doc.scrollTop = this.scrollTop;
            doc.scrollLeft = this.scrollLeft;
            doc.sel = this.sel;
            doc.extend = false;
            if (copyHistory) {
                doc.history.undoDepth = this.history.undoDepth;
                doc.setHistory(this.getHistory());
            }
            return doc;
        },
        linkedDoc: function linkedDoc(options) {
            if (!options) {
                options = {};
            }
            var from = this.first, to = this.first + this.size;
            if (options.from != null && options.from > from) {
                from = options.from;
            }
            if (options.to != null && options.to < to) {
                to = options.to;
            }
            var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
            if (options.sharedHist) {
                copy.history = this.history;
            }
            (this.linked || (this.linked = [])).push({
                doc: copy,
                sharedHist: options.sharedHist
            });
            copy.linked = [
                {
                    doc: this,
                    isParent: true,
                    sharedHist: options.sharedHist
                }
            ];
            copySharedMarkers(copy, findSharedMarkers(this));
            return copy;
        },
        unlinkDoc: function unlinkDoc(other) {
            if (_instanceof(other, CodeMirror)) {
                other = other.doc;
            }
            if (this.linked) {
                for(var i = 0; i < this.linked.length; ++i){
                    var link = this.linked[i];
                    if (link.doc != other) {
                        continue;
                    }
                    this.linked.splice(i, 1);
                    other.unlinkDoc(this);
                    detachSharedMarkers(findSharedMarkers(this));
                    break;
                }
            }
            // If the histories were shared, split them again
            if (other.history == this.history) {
                var splitIds = [
                    other.id
                ];
                linkedDocs(other, function(doc) {
                    return splitIds.push(doc.id);
                }, true);
                other.history = new History(null);
                other.history.done = copyHistoryArray(this.history.done, splitIds);
                other.history.undone = copyHistoryArray(this.history.undone, splitIds);
            }
        },
        iterLinkedDocs: function iterLinkedDocs(f) {
            linkedDocs(this, f);
        },
        getMode: function getMode() {
            return this.mode;
        },
        getEditor: function getEditor() {
            return this.cm;
        },
        splitLines: function splitLines(str) {
            if (this.lineSep) {
                return str.split(this.lineSep);
            }
            return splitLinesAuto(str);
        },
        lineSeparator: function lineSeparator() {
            return this.lineSep || "\n";
        },
        setDirection: docMethodOp(function(dir) {
            if (dir != "rtl") {
                dir = "ltr";
            }
            if (dir == this.direction) {
                return;
            }
            this.direction = dir;
            this.iter(function(line) {
                return line.order = null;
            });
            if (this.cm) {
                directionChanged(this.cm);
            }
        })
    });
    // Public alias.
    Doc.prototype.eachLine = Doc.prototype.iter;
    // Kludge to work around strange IE behavior where it'll sometimes
    // re-fire a series of drag-related events right after the drop (#1551)
    var lastDrop = 0;
    var globalsRegistered = false;
    var keyNames = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        224: "Mod",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
    };
    // Number keys
    for(var i = 0; i < 10; i++){
        keyNames[i + 48] = keyNames[i + 96] = String(i);
    }
    // Alphabetic keys
    for(var i$1 = 65; i$1 <= 90; i$1++){
        keyNames[i$1] = String.fromCharCode(i$1);
    }
    // Function keys
    for(var i$2 = 1; i$2 <= 12; i$2++){
        keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    }
    var keyMap = {};
    keyMap.basic = {
        "Left": "goCharLeft",
        "Right": "goCharRight",
        "Up": "goLineUp",
        "Down": "goLineDown",
        "End": "goLineEnd",
        "Home": "goLineStartSmart",
        "PageUp": "goPageUp",
        "PageDown": "goPageDown",
        "Delete": "delCharAfter",
        "Backspace": "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        "Tab": "defaultTab",
        "Shift-Tab": "indentAuto",
        "Enter": "newlineAndIndent",
        "Insert": "toggleOverwrite",
        "Esc": "singleSelection"
    };
    // Note that the save and find-related commands aren't defined by
    // default. User code or addons can define them. Unknown commands
    // are simply ignored.
    keyMap.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        "fallthrough": "basic"
    };
    // Very basic readline/emacs-style bindings, which are standard on Mac.
    keyMap.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        "fallthrough": [
            "basic",
            "emacsy"
        ]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    function lookupKey(key, map, handle, context) {
        map = getKeyMap(map);
        var found = map.call ? map.call(key, context) : map[key];
        if (found === false) {
            return "nothing";
        }
        if (found === "...") {
            return "multi";
        }
        if (found != null && handle(found)) {
            return "handled";
        }
        if (map.fallthrough) {
            if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") {
                return lookupKey(key, map.fallthrough, handle, context);
            }
            for(var i = 0; i < map.fallthrough.length; i++){
                var result = lookupKey(key, map.fallthrough[i], handle, context);
                if (result) {
                    return result;
                }
            }
        }
    }
    // Commands are parameter-less actions that can be performed on an
    // editor, mostly used for keybindings.
    var commands = {
        selectAll: selectAll,
        singleSelection: function singleSelection(cm) {
            return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
        },
        killLine: function killLine(cm) {
            return deleteNearSelection(cm, function(range) {
                if (range.empty()) {
                    var len = getLine(cm.doc, range.head.line).text.length;
                    if (range.head.ch == len && range.head.line < cm.lastLine()) {
                        return {
                            from: range.head,
                            to: Pos(range.head.line + 1, 0)
                        };
                    } else {
                        return {
                            from: range.head,
                            to: Pos(range.head.line, len)
                        };
                    }
                } else {
                    return {
                        from: range.from(),
                        to: range.to()
                    };
                }
            });
        },
        deleteLine: function deleteLine(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
                };
            });
        },
        delLineLeft: function delLineLeft(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: range.from()
                };
            });
        },
        delWrappedLineLeft: function delWrappedLineLeft(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var leftPos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                return {
                    from: leftPos,
                    to: range.from()
                };
            });
        },
        delWrappedLineRight: function delWrappedLineRight(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var rightPos = cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
                return {
                    from: range.from(),
                    to: rightPos
                };
            });
        },
        undo: function undo(cm) {
            return cm.undo();
        },
        redo: function redo(cm) {
            return cm.redo();
        },
        undoSelection: function undoSelection(cm) {
            return cm.undoSelection();
        },
        redoSelection: function redoSelection(cm) {
            return cm.redoSelection();
        },
        goDocStart: function goDocStart(cm) {
            return cm.extendSelection(Pos(cm.firstLine(), 0));
        },
        goDocEnd: function goDocEnd(cm) {
            return cm.extendSelection(Pos(cm.lastLine()));
        },
        goLineStart: function goLineStart(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStart(cm, range.head.line);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineStartSmart: function goLineStartSmart(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStartSmart(cm, range.head);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineEnd: function goLineEnd(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineEnd(cm, range.head.line);
            }, {
                origin: "+move",
                bias: -1
            });
        },
        goLineRight: function goLineRight(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeft: function goLineLeft(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeftSmart: function goLineLeftSmart(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                var pos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                if (pos.ch < cm.getLine(pos.line).search(/\S/)) {
                    return lineStartSmart(cm, range.head);
                }
                return pos;
            }, sel_move);
        },
        goLineUp: function goLineUp(cm) {
            return cm.moveV(-1, "line");
        },
        goLineDown: function goLineDown(cm) {
            return cm.moveV(1, "line");
        },
        goPageUp: function goPageUp(cm) {
            return cm.moveV(-1, "page");
        },
        goPageDown: function goPageDown(cm) {
            return cm.moveV(1, "page");
        },
        goCharLeft: function goCharLeft(cm) {
            return cm.moveH(-1, "char");
        },
        goCharRight: function goCharRight(cm) {
            return cm.moveH(1, "char");
        },
        goColumnLeft: function goColumnLeft(cm) {
            return cm.moveH(-1, "column");
        },
        goColumnRight: function goColumnRight(cm) {
            return cm.moveH(1, "column");
        },
        goWordLeft: function goWordLeft(cm) {
            return cm.moveH(-1, "word");
        },
        goGroupRight: function goGroupRight(cm) {
            return cm.moveH(1, "group");
        },
        goGroupLeft: function goGroupLeft(cm) {
            return cm.moveH(-1, "group");
        },
        goWordRight: function goWordRight(cm) {
            return cm.moveH(1, "word");
        },
        delCharBefore: function delCharBefore(cm) {
            return cm.deleteH(-1, "codepoint");
        },
        delCharAfter: function delCharAfter(cm) {
            return cm.deleteH(1, "char");
        },
        delWordBefore: function delWordBefore(cm) {
            return cm.deleteH(-1, "word");
        },
        delWordAfter: function delWordAfter(cm) {
            return cm.deleteH(1, "word");
        },
        delGroupBefore: function delGroupBefore(cm) {
            return cm.deleteH(-1, "group");
        },
        delGroupAfter: function delGroupAfter(cm) {
            return cm.deleteH(1, "group");
        },
        indentAuto: function indentAuto(cm) {
            return cm.indentSelection("smart");
        },
        indentMore: function indentMore(cm) {
            return cm.indentSelection("add");
        },
        indentLess: function indentLess(cm) {
            return cm.indentSelection("subtract");
        },
        insertTab: function insertTab(cm) {
            return cm.replaceSelection("	");
        },
        insertSoftTab: function insertSoftTab(cm) {
            var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
            for(var i = 0; i < ranges.length; i++){
                var pos = ranges[i].from();
                var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
                spaces.push(spaceStr(tabSize - col % tabSize));
            }
            cm.replaceSelections(spaces);
        },
        defaultTab: function defaultTab(cm) {
            if (cm.somethingSelected()) {
                cm.indentSelection("add");
            } else {
                cm.execCommand("insertTab");
            }
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function transposeChars(cm) {
            return runInOp(cm, function() {
                var ranges = cm.listSelections(), newSel = [];
                for(var i = 0; i < ranges.length; i++){
                    if (!ranges[i].empty()) {
                        continue;
                    }
                    var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
                    if (line) {
                        if (cur.ch == line.length) {
                            cur = new Pos(cur.line, cur.ch - 1);
                        }
                        if (cur.ch > 0) {
                            cur = new Pos(cur.line, cur.ch + 1);
                            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
                        } else if (cur.line > cm.doc.first) {
                            var prev = getLine(cm.doc, cur.line - 1).text;
                            if (prev) {
                                cur = new Pos(cur.line, 1);
                                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
                            }
                        }
                    }
                    newSel.push(new Range(cur, cur));
                }
                cm.setSelections(newSel);
            });
        },
        newlineAndIndent: function newlineAndIndent(cm) {
            return runInOp(cm, function() {
                var sels = cm.listSelections();
                for(var i = sels.length - 1; i >= 0; i--){
                    cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
                }
                sels = cm.listSelections();
                for(var i$1 = 0; i$1 < sels.length; i$1++){
                    cm.indentLine(sels[i$1].from().line, null, true);
                }
                ensureCursorVisible(cm);
            });
        },
        openLine: function openLine(cm) {
            return cm.replaceSelection("\n", "start");
        },
        toggleOverwrite: function toggleOverwrite(cm) {
            return cm.toggleOverwrite();
        }
    };
    // Note that, despite the name, this function is also used to check
    // for bound mouse clicks.
    var stopSeq = new Delayed;
    var lastStoppedKey = null;
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function PastClick(time, pos, button) {
        this.time = time;
        this.pos = pos;
        this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
        return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    var Init = {
        toString: function toString() {
            return "CodeMirror.Init";
        }
    };
    var defaults = {};
    var optionHandlers = {};
    // A CodeMirror instance represents an editor. This is the object
    // that user code is usually dealing with.
    function CodeMirror(place, options) {
        var this$1 = this;
        if (!_instanceof(this, CodeMirror)) {
            return new CodeMirror(place, options);
        }
        this.options = options = options ? copyObj(options) : {};
        // Determine effective options based on given values and defaults.
        copyObj(defaults, options, false);
        var doc = options.value;
        if (typeof doc == "string") {
            doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
        } else if (options.mode) {
            doc.modeOption = options.mode;
        }
        this.doc = doc;
        var input = new CodeMirror.inputStyles[options.inputStyle](this);
        var display = this.display = new Display(place, doc, input, options);
        display.wrapper.CodeMirror = this;
        themeChanged(this);
        if (options.lineWrapping) {
            this.display.wrapper.className += " CodeMirror-wrap";
        }
        initScrollbars(this);
        this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: false,
            delayingBlurEvent: false,
            focused: false,
            suppressEdits: false,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: false,
            draggingText: false,
            highlight: new Delayed(),
            keySeq: null,
            specialChars: null
        };
        if (options.autofocus && !mobile) {
            display.input.focus();
        }
        // Override magic textarea content restore that IE sometimes does
        // on our hidden textarea on reload
        if (ie && ie_version < 11) {
            setTimeout(function() {
                return this$1.display.input.reset(true);
            }, 20);
        }
        registerEventHandlers(this);
        ensureGlobalHandlers();
        startOperation(this);
        this.curOp.forceUpdate = true;
        attachDoc(this, doc);
        if (options.autofocus && !mobile || this.hasFocus()) {
            setTimeout(function() {
                if (this$1.hasFocus() && !this$1.state.focused) {
                    onFocus(this$1);
                }
            }, 20);
        } else {
            onBlur(this);
        }
        for(var opt in optionHandlers){
            if (optionHandlers.hasOwnProperty(opt)) {
                optionHandlers[opt](this, options[opt], Init);
            }
        }
        maybeUpdateLineNumberWidth(this);
        if (options.finishInit) {
            options.finishInit(this);
        }
        for(var i = 0; i < initHooks.length; ++i){
            initHooks[i](this);
        }
        endOperation(this);
        // Suppress optimizelegibility in Webkit, since it breaks text
        // measuring on line wrapping boundaries.
        if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") {
            display.lineDiv.style.textRendering = "auto";
        }
    }
    // The default configuration options.
    CodeMirror.defaults = defaults;
    // Functions to run when options are changed.
    CodeMirror.optionHandlers = optionHandlers;
    var initHooks = [];
    CodeMirror.defineInitHook = function(f) {
        return initHooks.push(f);
    };
    // This will be set to a {lineWise: bool, text: [string]} object, so
    // that, when pasting, we know what kind of selections the copied
    // text was made out of.
    var lastCopied = null;
    // CONTENTEDITABLE INPUT STYLE
    var ContentEditableInput = function ContentEditableInput(cm) {
        this.cm = cm;
        this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
        this.polling = new Delayed();
        this.composing = null;
        this.gracePeriod = false;
        this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
        var belongsToInput = function belongsToInput(e) {
            for(var t = e.target; t; t = t.parentNode){
                if (t == div) {
                    return true;
                }
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) {
                    break;
                }
            }
            return false;
        };
        var onCopyCut = function onCopyCut(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e)) {
                return;
            }
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
                if (e.type == "cut") {
                    cm.replaceSelection("", null, "cut");
                }
            } else if (!cm.options.lineWiseCopyCut) {
                return;
            } else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") {
                    cm.operation(function() {
                        cm.setSelections(ranges.ranges, 0, sel_dontScroll);
                        cm.replaceSelection("", null, "cut");
                    });
                }
            }
            if (e.clipboardData) {
                e.clipboardData.clearData();
                var content = lastCopied.text.join("\n");
                // iOS exposes the clipboard API, but seems to discard content inserted into it
                e.clipboardData.setData("Text", content);
                if (e.clipboardData.getData("Text") == content) {
                    e.preventDefault();
                    return;
                }
            }
            // Old-fashioned briefly-focus-a-textarea hack
            var kludge = hiddenTextarea(), te = kludge.firstChild;
            cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
            te.value = lastCopied.text.join("\n");
            var hadFocus = activeElt();
            selectInput(te);
            setTimeout(function() {
                cm.display.lineSpace.removeChild(kludge);
                hadFocus.focus();
                if (hadFocus == div) {
                    input.showPrimarySelection();
                }
            }, 50);
        };
        var this$1 = this;
        var input = this, cm = input.cm;
        var div = input.div = display.lineDiv;
        div.contentEditable = true;
        disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
        on(div, "paste", function(e) {
            if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) {
                return;
            }
            // IE doesn't fire input events, so we schedule a read for the pasted content in this way
            if (ie_version <= 11) {
                setTimeout(operation(cm, function() {
                    return this$1.updateFromDOM();
                }), 20);
            }
        });
        on(div, "compositionstart", function(e) {
            this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionupdate", function(e) {
            if (!this$1.composing) {
                this$1.composing = {
                    data: e.data,
                    done: false
                };
            }
        });
        on(div, "compositionend", function(e) {
            if (this$1.composing) {
                if (e.data != this$1.composing.data) {
                    this$1.readFromDOMSoon();
                }
                this$1.composing.done = true;
            }
        });
        on(div, "touchstart", function() {
            return input.forceCompositionEnd();
        });
        on(div, "input", function() {
            if (!this$1.composing) {
                this$1.readFromDOMSoon();
            }
        });
        on(div, "copy", onCopyCut);
        on(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) {
            this.div.setAttribute("aria-label", label);
        } else {
            this.div.removeAttribute("aria-label");
        }
    };
    ContentEditableInput.prototype.prepareSelection = function() {
        var result = prepareSelection(this.cm, false);
        result.focus = activeElt() == this.div;
        return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
        if (!info || !this.cm.display.view.length) {
            return;
        }
        if (info.focus || takeFocus) {
            this.showPrimarySelection();
        }
        this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
        var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
        var from = prim.from(), to = prim.to();
        if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
            sel.removeAllRanges();
            return;
        }
        var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) {
            return;
        }
        var view = cm.display.view;
        var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || {
            node: view[0].measure.map[2],
            offset: 0
        };
        var end = to.line < cm.display.viewTo && posToDOM(cm, to);
        if (!end) {
            var measure = view[view.length - 1].measure;
            var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
            end = {
                node: map[map.length - 1],
                offset: map[map.length - 2] - map[map.length - 3]
            };
        }
        if (!start || !end) {
            sel.removeAllRanges();
            return;
        }
        var old = sel.rangeCount && sel.getRangeAt(0), rng;
        try {
            rng = range(start.node, start.offset, end.offset, end.node);
        } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
        if (rng) {
            if (!gecko && cm.state.focused) {
                sel.collapse(start.node, start.offset);
                if (!rng.collapsed) {
                    sel.removeAllRanges();
                    sel.addRange(rng);
                }
            } else {
                sel.removeAllRanges();
                sel.addRange(rng);
            }
            if (old && sel.anchorNode == null) {
                sel.addRange(old);
            } else if (gecko) {
                this.startGracePeriod();
            }
        }
        this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
        var this$1 = this;
        clearTimeout(this.gracePeriod);
        this.gracePeriod = setTimeout(function() {
            this$1.gracePeriod = false;
            if (this$1.selectionChanged()) {
                this$1.cm.operation(function() {
                    return this$1.cm.curOp.selectionChanged = true;
                });
            }
        }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
        removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
        removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
        var sel = this.getSelection();
        this.lastAnchorNode = sel.anchorNode;
        this.lastAnchorOffset = sel.anchorOffset;
        this.lastFocusNode = sel.focusNode;
        this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
        var sel = this.getSelection();
        if (!sel.rangeCount) {
            return false;
        }
        var node = sel.getRangeAt(0).commonAncestorContainer;
        return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor") {
            if (!this.selectionInEditor() || activeElt() != this.div) {
                this.showSelection(this.prepareSelection(), true);
            }
            this.div.focus();
        }
    };
    ContentEditableInput.prototype.blur = function() {
        this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
        return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
        return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
        var this$1 = this;
        var input = this;
        if (this.selectionInEditor()) {
            setTimeout(function() {
                return this$1.pollSelection();
            }, 20);
        } else {
            runInOp(this.cm, function() {
                return input.cm.curOp.selectionChanged = true;
            });
        }
        function poll() {
            if (input.cm.state.focused) {
                input.pollSelection();
                input.polling.set(input.cm.options.pollInterval, poll);
            }
        }
        this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
        var sel = this.getSelection();
        return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
        if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) {
            return;
        }
        var sel = this.getSelection(), cm = this.cm;
        // On Android Chrome (version 56, at least), backspacing into an
        // uneditable block element will put the cursor in that element,
        // and then, because it's not editable, hide the virtual keyboard.
        // Because Android doesn't allow us to actually detect backspace
        // presses in a sane way, this code checks for when that happens
        // and simulates a backspace press in this case.
        if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
            this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
            });
            this.blur();
            this.focus();
            return;
        }
        if (this.composing) {
            return;
        }
        this.rememberSelection();
        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (anchor && head) {
            runInOp(cm, function() {
                setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
                if (anchor.bad || head.bad) {
                    cm.curOp.selectionChanged = true;
                }
            });
        }
    };
    ContentEditableInput.prototype.pollContent = function() {
        if (this.readDOMTimeout != null) {
            clearTimeout(this.readDOMTimeout);
            this.readDOMTimeout = null;
        }
        var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
        var from = sel.from(), to = sel.to();
        if (from.ch == 0 && from.line > cm.firstLine()) {
            from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
        }
        if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) {
            to = Pos(to.line + 1, 0);
        }
        if (from.line < display.viewFrom || to.line > display.viewTo - 1) {
            return false;
        }
        var fromIndex, fromLine, fromNode;
        if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
            fromLine = lineNo(display.view[0].line);
            fromNode = display.view[0].node;
        } else {
            fromLine = lineNo(display.view[fromIndex].line);
            fromNode = display.view[fromIndex - 1].node.nextSibling;
        }
        var toIndex = findViewIndex(cm, to.line);
        var toLine, toNode;
        if (toIndex == display.view.length - 1) {
            toLine = display.viewTo - 1;
            toNode = display.lineDiv.lastChild;
        } else {
            toLine = lineNo(display.view[toIndex + 1].line) - 1;
            toNode = display.view[toIndex + 1].node.previousSibling;
        }
        if (!fromNode) {
            return false;
        }
        var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
        var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
        while(newText.length > 1 && oldText.length > 1){
            if (lst(newText) == lst(oldText)) {
                newText.pop();
                oldText.pop();
                toLine--;
            } else if (newText[0] == oldText[0]) {
                newText.shift();
                oldText.shift();
                fromLine++;
            } else {
                break;
            }
        }
        var cutFront = 0, cutEnd = 0;
        var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
        while(cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront)){
            ++cutFront;
        }
        var newBot = lst(newText), oldBot = lst(oldText);
        var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
        while(cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
            ++cutEnd;
        }
        // Try to move start of change to start of selection if ambiguous
        if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
            while(cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
                cutFront--;
                cutEnd++;
            }
        }
        newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
        newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
        var chFrom = Pos(fromLine, cutFront);
        var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
        if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
            replaceRange(cm.doc, newText, chFrom, chTo, "+input");
            return true;
        }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
        if (!this.composing) {
            return;
        }
        clearTimeout(this.readDOMTimeout);
        this.composing = null;
        this.updateFromDOM();
        this.div.blur();
        this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
        var this$1 = this;
        if (this.readDOMTimeout != null) {
            return;
        }
        this.readDOMTimeout = setTimeout(function() {
            this$1.readDOMTimeout = null;
            if (this$1.composing) {
                if (this$1.composing.done) {
                    this$1.composing = null;
                } else {
                    return;
                }
            }
            this$1.updateFromDOM();
        }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
        var this$1 = this;
        if (this.cm.isReadOnly() || !this.pollContent()) {
            runInOp(this.cm, function() {
                return regChange(this$1.cm);
            });
        }
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
        node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
        if (e.charCode == 0 || this.composing) {
            return;
        }
        e.preventDefault();
        if (!this.cm.isReadOnly()) {
            operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
        }
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
        this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {};
    ContentEditableInput.prototype.resetPosition = function() {};
    ContentEditableInput.prototype.needsContentAttribute = true;
    // TEXTAREA INPUT STYLE
    var TextareaInput = function TextareaInput(cm) {
        this.cm = cm;
        // See input.poll and input.reset
        this.prevInput = "";
        // Flag that indicates whether we expect input to appear real soon
        // now (after some event like 'keypress' or 'input') and are
        // polling intensively.
        this.pollingFast = false;
        // Self-resetting timeout for the poller
        this.polling = new Delayed();
        // Used to work around IE issue with selection being forgotten when focus moves away from textarea
        this.hasSelection = false;
        this.composing = null;
    };
    TextareaInput.prototype.init = function(display) {
        var prepareCopyCut = function prepareCopyCut(e) {
            if (signalDOMEvent(cm, e)) {
                return;
            }
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
            } else if (!cm.options.lineWiseCopyCut) {
                return;
            } else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") {
                    cm.setSelections(ranges.ranges, null, sel_dontScroll);
                } else {
                    input.prevInput = "";
                    te.value = ranges.text.join("\n");
                    selectInput(te);
                }
            }
            if (e.type == "cut") {
                cm.state.cutIncoming = +new Date;
            }
        };
        var this$1 = this;
        var input = this, cm = this.cm;
        this.createField(display);
        var te = this.textarea;
        display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
        // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
        if (ios) {
            te.style.width = "0px";
        }
        on(te, "input", function() {
            if (ie && ie_version >= 9 && this$1.hasSelection) {
                this$1.hasSelection = null;
            }
            input.poll();
        });
        on(te, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) {
                return;
            }
            cm.state.pasteIncoming = +new Date;
            input.fastPoll();
        });
        on(te, "cut", prepareCopyCut);
        on(te, "copy", prepareCopyCut);
        on(display.scroller, "paste", function(e) {
            if (eventInWidget(display, e) || signalDOMEvent(cm, e)) {
                return;
            }
            if (!te.dispatchEvent) {
                cm.state.pasteIncoming = +new Date;
                input.focus();
                return;
            }
            // Pass the `paste` event to the textarea so it's handled by its event listener.
            var event = new Event("paste");
            event.clipboardData = e.clipboardData;
            te.dispatchEvent(event);
        });
        // Prevent normal selection in the editor (we handle our own)
        on(display.lineSpace, "selectstart", function(e) {
            if (!eventInWidget(display, e)) {
                e_preventDefault(e);
            }
        });
        on(te, "compositionstart", function() {
            var start = cm.getCursor("from");
            if (input.composing) {
                input.composing.range.clear();
            }
            input.composing = {
                start: start,
                range: cm.markText(start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                })
            };
        });
        on(te, "compositionend", function() {
            if (input.composing) {
                input.poll();
                input.composing.range.clear();
                input.composing = null;
            }
        });
    };
    TextareaInput.prototype.createField = function(_display) {
        // Wraps and hides input textarea
        this.wrapper = hiddenTextarea();
        // The semihidden textarea that is focused when the editor is
        // focused, and receives input.
        this.textarea = this.wrapper.firstChild;
    };
    TextareaInput.prototype.screenReaderLabelChanged = function(label) {
        // Label for screenreaders, accessibility
        if (label) {
            this.textarea.setAttribute("aria-label", label);
        } else {
            this.textarea.removeAttribute("aria-label");
        }
    };
    TextareaInput.prototype.prepareSelection = function() {
        // Redraw the selection and/or cursor
        var cm = this.cm, display = cm.display, doc = cm.doc;
        var result = prepareSelection(cm);
        // Move the hidden textarea near the cursor to prevent scrolling artifacts
        if (cm.options.moveInputWithCursor) {
            var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
            var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
            result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
            result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
        }
        return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
        var cm = this.cm, display = cm.display;
        removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
        removeChildrenAndAdd(display.selectionDiv, drawn.selection);
        if (drawn.teTop != null) {
            this.wrapper.style.top = drawn.teTop + "px";
            this.wrapper.style.left = drawn.teLeft + "px";
        }
    };
    // Reset the input to correspond to the selection (or to be empty,
    // when not typing and nothing is selected)
    TextareaInput.prototype.reset = function(typing) {
        if (this.contextMenuPending || this.composing) {
            return;
        }
        var cm = this.cm;
        if (cm.somethingSelected()) {
            this.prevInput = "";
            var content = cm.getSelection();
            this.textarea.value = content;
            if (cm.state.focused) {
                selectInput(this.textarea);
            }
            if (ie && ie_version >= 9) {
                this.hasSelection = content;
            }
        } else if (!typing) {
            this.prevInput = this.textarea.value = "";
            if (ie && ie_version >= 9) {
                this.hasSelection = null;
            }
        }
    };
    TextareaInput.prototype.getField = function() {
        return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
        return false;
    };
    TextareaInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
            try {
                this.textarea.focus();
            } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
        }
    };
    TextareaInput.prototype.blur = function() {
        this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
        this.slowPoll();
    };
    // Poll for input changes, using the normal rate of polling. This
    // runs as long as the editor is focused.
    TextareaInput.prototype.slowPoll = function() {
        var this$1 = this;
        if (this.pollingFast) {
            return;
        }
        this.polling.set(this.cm.options.pollInterval, function() {
            this$1.poll();
            if (this$1.cm.state.focused) {
                this$1.slowPoll();
            }
        });
    };
    // When an event has just come in that is likely to add or change
    // something in the input textarea, we poll faster, to ensure that
    // the change appears on the screen quickly.
    TextareaInput.prototype.fastPoll = function() {
        var missed = false, input = this;
        input.pollingFast = true;
        function p() {
            var changed = input.poll();
            if (!changed && !missed) {
                missed = true;
                input.polling.set(60, p);
            } else {
                input.pollingFast = false;
                input.slowPoll();
            }
        }
        input.polling.set(20, p);
    };
    // Read input from the textarea, and update the document to match.
    // When something is selected, it is present in the textarea, and
    // selected (unless it is huge, in which case a placeholder is
    // used). When nothing is selected, the cursor sits after previously
    // seen text (can be empty), which is stored in prevInput (we must
    // not reset the textarea when typing, because that breaks IME).
    TextareaInput.prototype.poll = function() {
        var this$1 = this;
        var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
        // Since this is called a *lot*, try to bail out as cheaply as
        // possible when it is clear that nothing happened. hasSelection
        // will be the case when there is a lot of text in the textarea,
        // in which case reading its value would be expensive.
        if (this.contextMenuPending || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) {
            return false;
        }
        var text = input.value;
        // If nothing changed, bail.
        if (text == prevInput && !cm.somethingSelected()) {
            return false;
        }
        // Work around nonsensical selection resetting in IE9/10, and
        // inexplicable appearance of private area unicode characters on
        // some key combos in Mac (#2689).
        if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
            cm.display.input.reset();
            return false;
        }
        if (cm.doc.sel == cm.display.selForContextMenu) {
            var first = text.charCodeAt(0);
            if (first == 0x200b && !prevInput) {
                prevInput = "​";
            }
            if (first == 0x21da) {
                this.reset();
                return this.cm.execCommand("undo");
            }
        }
        // Find the part of the input that is actually new
        var same = 0, l = Math.min(prevInput.length, text.length);
        while(same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)){
            ++same;
        }
        runInOp(cm, function() {
            applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
            // Don't leave long text in the textarea, since it makes further polling slow
            if (text.length > 1000 || text.indexOf("\n") > -1) {
                input.value = this$1.prevInput = "";
            } else {
                this$1.prevInput = text;
            }
            if (this$1.composing) {
                this$1.composing.range.clear();
                this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                });
            }
        });
        return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
        if (this.pollingFast && this.poll()) {
            this.pollingFast = false;
        }
    };
    TextareaInput.prototype.onKeyPress = function() {
        if (ie && ie_version >= 9) {
            this.hasSelection = null;
        }
        this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
        var prepareSelectAllHack = // Select-all will be greyed out if there's nothing to select, so
        // this adds a zero-width space so that we can later check whether
        // it got selected.
        function prepareSelectAllHack() {
            if (te.selectionStart != null) {
                var selected = cm.somethingSelected();
                var extval = "​" + (selected ? te.value : "");
                te.value = "⇚"; // Used to catch context-menu undo
                te.value = extval;
                input.prevInput = selected ? "" : "​";
                te.selectionStart = 1;
                te.selectionEnd = extval.length;
                // Re-set this, in case some other handler touched the
                // selection in the meantime.
                display.selForContextMenu = cm.doc.sel;
            }
        };
        var input = this, cm = input.cm, display = cm.display, te = input.textarea;
        if (input.contextMenuPending) {
            input.contextMenuPending();
        }
        var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
        if (!pos || presto) {
            return;
        } // Opera is difficult.
        // Reset the current text selection only if the click is done outside of the selection
        // and 'resetSelectionOnContextMenu' option is true.
        var reset = cm.options.resetSelectionOnContextMenu;
        if (reset && cm.doc.sel.contains(pos) == -1) {
            operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
        }
        var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
        var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
        input.wrapper.style.cssText = "position: static";
        te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
        var oldScrollY;
        if (webkit) {
            oldScrollY = window.scrollY;
        } // Work around Chrome issue (#2712)
        display.input.focus();
        if (webkit) {
            window.scrollTo(null, oldScrollY);
        }
        display.input.reset();
        // Adds "Select all" to context menu in FF
        if (!cm.somethingSelected()) {
            te.value = input.prevInput = " ";
        }
        input.contextMenuPending = rehide;
        display.selForContextMenu = cm.doc.sel;
        clearTimeout(display.detectingSelectAll);
        function rehide() {
            if (input.contextMenuPending != rehide) {
                return;
            }
            input.contextMenuPending = false;
            input.wrapper.style.cssText = oldWrapperCSS;
            te.style.cssText = oldCSS;
            if (ie && ie_version < 9) {
                display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
            }
            // Try to detect the user choosing select-all
            if (te.selectionStart != null) {
                if (!ie || ie && ie_version < 9) {
                    prepareSelectAllHack();
                }
                var i = 0, poll = function poll1() {
                    if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "​") {
                        operation(cm, selectAll)(cm);
                    } else if (i++ < 10) {
                        display.detectingSelectAll = setTimeout(poll, 500);
                    } else {
                        display.selForContextMenu = null;
                        display.input.reset();
                    }
                };
                display.detectingSelectAll = setTimeout(poll, 200);
            }
        }
        if (ie && ie_version >= 9) {
            prepareSelectAllHack();
        }
        if (captureRightClick) {
            e_stop(e);
            var mouseup = function mouseup1() {
                off(window, "mouseup", mouseup);
                setTimeout(rehide, 20);
            };
            on(window, "mouseup", mouseup);
        } else {
            setTimeout(rehide, 50);
        }
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
        if (!val) {
            this.reset();
        }
        this.textarea.disabled = val == "nocursor";
        this.textarea.readOnly = !!val;
    };
    TextareaInput.prototype.setUneditable = function() {};
    TextareaInput.prototype.needsContentAttribute = false;
    // EDITOR CONSTRUCTOR
    defineOptions(CodeMirror);
    addEditorMethods(CodeMirror);
    // Set up methods on CodeMirror's prototype to redirect to the editor's document.
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for(var prop in Doc.prototype){
        if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) {
            CodeMirror.prototype[prop] = function(method) {
                return function() {
                    return method.apply(this.doc, arguments);
                };
            }(Doc.prototype[prop]);
        }
    }
    eventMixin(Doc);
    CodeMirror.inputStyles = {
        "textarea": TextareaInput,
        "contenteditable": ContentEditableInput
    };
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    CodeMirror.defineMode = function(name /*, mode, …*/ ) {
        if (!CodeMirror.defaults.mode && name != "null") {
            CodeMirror.defaults.mode = name;
        }
        defineMode.apply(this, arguments);
    };
    CodeMirror.defineMIME = defineMIME;
    // Minimal default mode.
    CodeMirror.defineMode("null", function() {
        return {
            token: function token(stream) {
                return stream.skipToEnd();
            }
        };
    });
    CodeMirror.defineMIME("text/plain", "null");
    // EXTENSIONS
    CodeMirror.defineExtension = function(name, func) {
        CodeMirror.prototype[name] = func;
    };
    CodeMirror.defineDocExtension = function(name, func) {
        Doc.prototype[name] = func;
    };
    CodeMirror.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror);
    CodeMirror.version = "5.64.0";
    return CodeMirror;
});
});

var activeLine = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var clearActiveLines = function clearActiveLines(cm) {
        for(var i = 0; i < cm.state.activeLines.length; i++){
            cm.removeLineClass(cm.state.activeLines[i], "wrap", WRAP_CLASS);
            cm.removeLineClass(cm.state.activeLines[i], "background", BACK_CLASS);
            cm.removeLineClass(cm.state.activeLines[i], "gutter", GUTT_CLASS);
        }
    };
    var sameArray = function sameArray(a, b) {
        if (a.length != b.length) return false;
        for(var i = 0; i < a.length; i++)if (a[i] != b[i]) return false;
        return true;
    };
    var updateActiveLines = function updateActiveLines(cm, ranges) {
        var active = [];
        for(var i = 0; i < ranges.length; i++){
            var range = ranges[i];
            var option = cm.getOption("styleActiveLine");
            if (typeof option == "object" && option.nonEmpty ? range.anchor.line != range.head.line : !range.empty()) continue;
            var line = cm.getLineHandleVisualStart(range.head.line);
            if (active[active.length - 1] != line) active.push(line);
        }
        if (sameArray(cm.state.activeLines, active)) return;
        cm.operation(function() {
            clearActiveLines(cm);
            for(var i = 0; i < active.length; i++){
                cm.addLineClass(active[i], "wrap", WRAP_CLASS);
                cm.addLineClass(active[i], "background", BACK_CLASS);
                cm.addLineClass(active[i], "gutter", GUTT_CLASS);
            }
            cm.state.activeLines = active;
        });
    };
    var selectionChange = function selectionChange(cm, sel) {
        updateActiveLines(cm, sel.ranges);
    };
    var WRAP_CLASS = "CodeMirror-activeline";
    var BACK_CLASS = "CodeMirror-activeline-background";
    var GUTT_CLASS = "CodeMirror-activeline-gutter";
    CodeMirror1.defineOption("styleActiveLine", false, function(cm, val, old) {
        var prev = old == CodeMirror1.Init ? false : old;
        if (val == prev) return;
        if (prev) {
            cm.off("beforeSelectionChange", selectionChange);
            clearActiveLines(cm);
            delete cm.state.activeLines;
        }
        if (val) {
            cm.state.activeLines = [];
            updateActiveLines(cm, cm.listSelections());
            cm.on("beforeSelectionChange", selectionChange);
        }
    });
});
});

var matchbrackets = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var bracketRegex = function bracketRegex(config) {
        return config && config.bracketRegex || /[(){}[\]]/;
    };
    var findMatchingBracket = function findMatchingBracket(cm, where, config) {
        var line = cm.getLineHandle(where.line), pos = where.ch - 1;
        var afterCursor = config && config.afterCursor;
        if (afterCursor == null) afterCursor = /(^| )cm-fat-cursor($| )/.test(cm.getWrapperElement().className);
        var re = bracketRegex(config);
        // A cursor is defined as between two characters, but in in vim command mode
        // (i.e. not insert mode), the cursor is visually represented as a
        // highlighted box on top of the 2nd character. Otherwise, we allow matches
        // from before or after the cursor.
        var match = !afterCursor && pos >= 0 && re.test(line.text.charAt(pos)) && matching[line.text.charAt(pos)] || re.test(line.text.charAt(pos + 1)) && matching[line.text.charAt(++pos)];
        if (!match) return null;
        var dir = match.charAt(1) == ">" ? 1 : -1;
        if (config && config.strict && dir > 0 != (pos == where.ch)) return null;
        var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
        var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style, config);
        if (found == null) return null;
        return {
            from: Pos(where.line, pos),
            to: found && found.pos,
            match: found && found.ch == match.charAt(0),
            forward: dir > 0
        };
    };
    var scanForBracket = // bracketRegex is used to specify which type of bracket to scan
    // should be a regexp, e.g. /[[\]]/
    //
    // Note: If "where" is on an open bracket, then this bracket is ignored.
    //
    // Returns false when no bracket was found, null when it reached
    // maxScanLines and gave up
    function scanForBracket(cm, where, dir, style, config) {
        var maxScanLen = config && config.maxScanLineLength || 10000;
        var maxScanLines = config && config.maxScanLines || 1000;
        var stack = [];
        var re = bracketRegex(config);
        var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1) : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
        for(var lineNo = where.line; lineNo != lineEnd; lineNo += dir){
            var line = cm.getLine(lineNo);
            if (!line) continue;
            var pos = dir > 0 ? 0 : line.length - 1, end = dir > 0 ? line.length : -1;
            if (line.length > maxScanLen) continue;
            if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
            for(; pos != end; pos += dir){
                var ch = line.charAt(pos);
                if (re.test(ch) && (style === undefined || (cm.getTokenTypeAt(Pos(lineNo, pos + 1)) || "") == (style || ""))) {
                    var match = matching[ch];
                    if (match && match.charAt(1) == ">" == dir > 0) stack.push(ch);
                    else if (!stack.length) return {
                        pos: Pos(lineNo, pos),
                        ch: ch
                    };
                    else stack.pop();
                }
            }
        }
        return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
    };
    var matchBrackets = function matchBrackets(cm, autoclear, config) {
        // Disable brace matching in long lines, since it'll cause hugely slow updates
        var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000, highlightNonMatching = config && config.highlightNonMatching;
        var marks = [], ranges = cm.listSelections();
        for(var i = 0; i < ranges.length; i++){
            var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, config);
            if (match && (match.match || highlightNonMatching !== false) && cm.getLine(match.from.line).length <= maxHighlightLen) {
                var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
                marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), {
                    className: style
                }));
                if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen) marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), {
                    className: style
                }));
            }
        }
        if (marks.length) {
            // Kludge to work around the IE bug from issue #1193, where text
            // input stops going to the textarea whenever this fires.
            if (ie_lt8 && cm.state.focused) cm.focus();
            var clear = function clear() {
                cm.operation(function() {
                    for(var i = 0; i < marks.length; i++)marks[i].clear();
                });
            };
            if (autoclear) setTimeout(clear, 800);
            else return clear;
        }
    };
    var doMatchBrackets = function doMatchBrackets(cm) {
        cm.operation(function() {
            if (cm.state.matchBrackets.currentlyHighlighted) {
                cm.state.matchBrackets.currentlyHighlighted();
                cm.state.matchBrackets.currentlyHighlighted = null;
            }
            cm.state.matchBrackets.currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
        });
    };
    var clearHighlighted = function clearHighlighted(cm) {
        if (cm.state.matchBrackets && cm.state.matchBrackets.currentlyHighlighted) {
            cm.state.matchBrackets.currentlyHighlighted();
            cm.state.matchBrackets.currentlyHighlighted = null;
        }
    };
    var ie_lt8 = /MSIE \d/.test(navigator.userAgent) && (document.documentMode == null || document.documentMode < 8);
    var Pos = CodeMirror1.Pos;
    var matching = {
        "(": ")>",
        ")": "(<",
        "[": "]>",
        "]": "[<",
        "{": "}>",
        "}": "{<",
        "<": ">>",
        ">": "<<"
    };
    CodeMirror1.defineOption("matchBrackets", false, function(cm, val, old) {
        if (old && old != CodeMirror1.Init) {
            cm.off("cursorActivity", doMatchBrackets);
            cm.off("focus", doMatchBrackets);
            cm.off("blur", clearHighlighted);
            clearHighlighted(cm);
        }
        if (val) {
            cm.state.matchBrackets = typeof val == "object" ? val : {};
            cm.on("cursorActivity", doMatchBrackets);
            cm.on("focus", doMatchBrackets);
            cm.on("blur", clearHighlighted);
        }
    });
    CodeMirror1.defineExtension("matchBrackets", function() {
        matchBrackets(this, true);
    });
    CodeMirror1.defineExtension("findMatchingBracket", function(pos, config, oldConfig) {
        // Backwards-compatibility kludge
        if (oldConfig || typeof config == "boolean") {
            if (!oldConfig) {
                config = config ? {
                    strict: true
                } : null;
            } else {
                oldConfig.strict = config;
                config = oldConfig;
            }
        }
        return findMatchingBracket(this, pos, config);
    });
    CodeMirror1.defineExtension("scanForBracket", function(pos, dir, style, config) {
        return scanForBracket(this, pos, dir, style, config);
    });
});
});

var css_248z$1 = '.CodeMirror{font-family:monospace;height:300px;color:#000;direction:ltr}.CodeMirror-lines{padding:4px 0}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid #000;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-fat-cursor .CodeMirror-line::-moz-selection, .cm-fat-cursor .CodeMirror-line > span::-moz-selection, .cm-fat-cursor .CodeMirror-line > span > span::-moz-selection{background:transparent}.cm-fat-cursor .CodeMirror-line::selection,.cm-fat-cursor .CodeMirror-line>span::selection,.cm-fat-cursor .CodeMirror-line>span>span::selection{background:transparent}.cm-fat-cursor .CodeMirror-line::-moz-selection,.cm-fat-cursor .CodeMirror-line>span::-moz-selection,.cm-fat-cursor .CodeMirror-line>span>span::-moz-selection{background:transparent}.cm-fat-cursor{caret-color:transparent}@-webkit-keyframes blink{50%{background-color:transparent}}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;left:0;right:0;top:-50px;bottom:0;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:#00f}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-type,.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0b0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#a22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-50px;margin-right:-50px;padding-bottom:50px;height:100%;outline:none;position:relative}.CodeMirror-sizer{position:relative;border-right:50px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none;outline:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-50px}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-gutter-wrapper ::selection{background-color:transparent}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;font-variant-ligatures:contextual}.CodeMirror-wrap pre.CodeMirror-line,.CodeMirror-wrap pre.CodeMirror-line-like{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;padding:.1px}.CodeMirror-rtl pre{direction:rtl}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors,div.CodeMirror-dragcursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection{background:#d7d4f0}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background-color:#ffa;background-color:rgba(255,255,0,.4)}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:""}span.CodeMirror-selectedtext{background:none}';
styleInject(css_248z$1);

var clike = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var Context = function Context(indented, column, type, info, align, prev) {
        this.indented = indented;
        this.column = column;
        this.type = type;
        this.info = info;
        this.align = align;
        this.prev = prev;
    };
    var pushContext = function pushContext(state, col, type, info) {
        var indent = state.indented;
        if (state.context && state.context.type == "statement" && type != "statement") indent = state.context.indented;
        return state.context = new Context(indent, col, type, info, null, state.context);
    };
    var popContext = function popContext(state) {
        var t = state.context.type;
        if (t == ")" || t == "]" || t == "}") state.indented = state.context.indented;
        return state.context = state.context.prev;
    };
    var typeBefore = function typeBefore(stream, state, pos) {
        if (state.prevToken == "variable" || state.prevToken == "type") return true;
        if (/\S(?:[^- ]>|[*\]])\s*$|\*$/.test(stream.string.slice(0, pos))) return true;
        if (state.typeAtEndOfLine && stream.column() == stream.indentation()) return true;
    };
    var isTopScope = function isTopScope(context) {
        for(;;){
            if (!context || context.type == "top") return true;
            if (context.type == "}" && context.prev.info != "namespace") return false;
            context = context.prev;
        }
    };
    var words = function words(str) {
        var obj = {}, words = str.split(" ");
        for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
        return obj;
    };
    var contains = function contains(words, word) {
        if (typeof words === "function") {
            return words(word);
        } else {
            return words.propertyIsEnumerable(word);
        }
    };
    var cTypes = // Returns true if identifier is a "C" type.
    // C type is defined as those that are reserved by the compiler (basicTypes),
    // and those that end in _t (Reserved by POSIX for types)
    // http://www.gnu.org/software/libc/manual/html_node/Reserved-Names.html
    function cTypes(identifier) {
        return contains(basicCTypes, identifier) || /.+_t$/.test(identifier);
    };
    var objCTypes = // Returns true if identifier is a "Objective C" type.
    function objCTypes(identifier) {
        return cTypes(identifier) || contains(basicObjCTypes, identifier);
    };
    var pointerHook = function pointerHook(_stream, state) {
        if (state.prevToken == "type") return "type";
        return false;
    };
    var cIsReservedIdentifier = // For C and C++ (and ObjC): identifiers starting with __
    // or _ followed by a capital letter are reserved for the compiler.
    function cIsReservedIdentifier(token) {
        if (!token || token.length < 2) return false;
        if (token[0] != "_") return false;
        return token[1] == "_" || token[1] !== token[1].toLowerCase();
    };
    var cpp14Literal = function cpp14Literal(stream) {
        stream.eatWhile(/[\w\.']/);
        return "number";
    };
    var cpp11StringHook = function cpp11StringHook(stream, state) {
        stream.backUp(1);
        // Raw strings.
        if (stream.match(/^(?:R|u8R|uR|UR|LR)/)) {
            var match = stream.match(/^"([^\s\\()]{0,16})\(/);
            if (!match) {
                return false;
            }
            state.cpp11RawStringDelim = match[1];
            state.tokenize = tokenRawString;
            return tokenRawString(stream, state);
        }
        // Unicode strings/chars.
        if (stream.match(/^(?:u8|u|U|L)/)) {
            if (stream.match(/^["']/, /* eat */ false)) {
                return "string";
            }
            return false;
        }
        // Ignore this hook.
        stream.next();
        return false;
    };
    var cppLooksLikeConstructor = function cppLooksLikeConstructor(word) {
        var lastTwo = /(\w+)::~?(\w+)$/.exec(word);
        return lastTwo && lastTwo[1] == lastTwo[2];
    };
    var tokenAtString = // C#-style strings where "" escapes a quote.
    function tokenAtString(stream, state) {
        var next;
        while((next = stream.next()) != null){
            if (next == '"' && !stream.eat('"')) {
                state.tokenize = null;
                break;
            }
        }
        return "string";
    };
    var tokenRawString = // C++11 raw string literal is <prefix>"<delim>( anything )<delim>", where
    // <delim> can be a string up to 16 characters long.
    function tokenRawString(stream, state) {
        // Escape characters that have special regex meanings.
        var delim = state.cpp11RawStringDelim.replace(/[^\w\s]/g, "\\$&");
        var match = stream.match(new RegExp(".*?\\)" + delim + '"'));
        if (match) state.tokenize = null;
        else stream.skipToEnd();
        return "string";
    };
    var def = function def(mimes, mode) {
        if (typeof mimes == "string") mimes = [
            mimes
        ];
        var words = [];
        function add(obj) {
            if (obj) {
                for(var prop in obj)if (obj.hasOwnProperty(prop)) words.push(prop);
            }
        }
        add(mode.keywords);
        add(mode.types);
        add(mode.builtin);
        add(mode.atoms);
        if (words.length) {
            mode.helperType = mimes[0];
            CodeMirror1.registerHelper("hintWords", mimes[0], words);
        }
        for(var i = 0; i < mimes.length; ++i)CodeMirror1.defineMIME(mimes[i], mode);
    };
    var tokenTripleString = function tokenTripleString(stream, state) {
        var escaped = false;
        while(!stream.eol()){
            if (!escaped && stream.match('"""')) {
                state.tokenize = null;
                break;
            }
            escaped = stream.next() == "\\" && !escaped;
        }
        return "string";
    };
    var tokenKotlinString = function tokenKotlinString(tripleString) {
        return function(stream, state) {
            var escaped = false, next, end = false;
            while(!stream.eol()){
                if (!tripleString && !escaped && stream.match('"')) {
                    end = true;
                    break;
                }
                if (tripleString && stream.match('"""')) {
                    end = true;
                    break;
                }
                next = stream.next();
                if (!escaped && next == "$" && stream.match("{")) stream.skipTo("}");
                escaped = !escaped && next == "\\" && !tripleString;
            }
            if (end || !tripleString) state.tokenize = null;
            return "string";
        };
    };
    CodeMirror1.defineMode("clike", function(config, parserConfig) {
        var tokenBase = function tokenBase(stream, state) {
            var ch = stream.next();
            if (hooks[ch]) {
                var result = hooks[ch](stream, state);
                if (result !== false) return result;
            }
            if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            }
            if (numberStart.test(ch)) {
                stream.backUp(1);
                if (stream.match(number)) return "number";
                stream.next();
            }
            if (isPunctuationChar.test(ch)) {
                curPunc = ch;
                return null;
            }
            if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize = tokenComment;
                    return tokenComment(stream, state);
                }
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return "comment";
                }
            }
            if (isOperatorChar.test(ch)) {
                while(!stream.match(/^\/[\/*]/, false) && stream.eat(isOperatorChar)){}
                return "operator";
            }
            stream.eatWhile(isIdentifierChar);
            if (namespaceSeparator) while(stream.match(namespaceSeparator))stream.eatWhile(isIdentifierChar);
            var cur = stream.current();
            if (contains(keywords, cur)) {
                if (contains(blockKeywords, cur)) curPunc = "newstatement";
                if (contains(defKeywords, cur)) isDefKeyword = true;
                return "keyword";
            }
            if (contains(types, cur)) return "type";
            if (contains(builtin, cur) || isReservedIdentifier && isReservedIdentifier(cur)) {
                if (contains(blockKeywords, cur)) curPunc = "newstatement";
                return "builtin";
            }
            if (contains(atoms, cur)) return "atom";
            return "variable";
        };
        var tokenString = function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, next, end = false;
                while((next = stream.next()) != null){
                    if (next == quote && !escaped) {
                        end = true;
                        break;
                    }
                    escaped = !escaped && next == "\\";
                }
                if (end || !(escaped || multiLineStrings)) state.tokenize = null;
                return "string";
            };
        };
        var tokenComment = function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while(ch = stream.next()){
                if (ch == "/" && maybeEnd) {
                    state.tokenize = null;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return "comment";
        };
        var maybeEOL = function maybeEOL(stream, state) {
            if (parserConfig.typeFirstDefinitions && stream.eol() && isTopScope(state.context)) state.typeAtEndOfLine = typeBefore(stream, state, stream.pos);
        };
        var indentUnit = config.indentUnit, statementIndentUnit = parserConfig.statementIndentUnit || indentUnit, dontAlignCalls = parserConfig.dontAlignCalls, keywords = parserConfig.keywords || {}, types = parserConfig.types || {}, builtin = parserConfig.builtin || {}, blockKeywords = parserConfig.blockKeywords || {}, defKeywords = parserConfig.defKeywords || {}, atoms = parserConfig.atoms || {}, hooks = parserConfig.hooks || {}, multiLineStrings = parserConfig.multiLineStrings, indentStatements = parserConfig.indentStatements !== false, indentSwitch = parserConfig.indentSwitch !== false, namespaceSeparator = parserConfig.namespaceSeparator, isPunctuationChar = parserConfig.isPunctuationChar || /[\[\]{}\(\),;\:\.]/, numberStart = parserConfig.numberStart || /[\d\.]/, number = parserConfig.number || /^(?:0x[a-f\d]+|0b[01]+|(?:\d+\.?\d*|\.\d+)(?:e[-+]?\d+)?)(u|ll?|l|f)?/i, isOperatorChar = parserConfig.isOperatorChar || /[+\-*&%=<>!?|\/]/, isIdentifierChar = parserConfig.isIdentifierChar || /[\w\$_\xa1-\uffff]/, // An optional function that takes a {string} token and returns true if it
        // should be treated as a builtin.
        isReservedIdentifier = parserConfig.isReservedIdentifier || false;
        var curPunc, isDefKeyword;
        // Interface
        return {
            startState: function startState(basecolumn) {
                return {
                    tokenize: null,
                    context: new Context((basecolumn || 0) - indentUnit, 0, "top", null, false),
                    indented: 0,
                    startOfLine: true,
                    prevToken: null
                };
            },
            token: function token(stream, state) {
                var ctx = state.context;
                if (stream.sol()) {
                    if (ctx.align == null) ctx.align = false;
                    state.indented = stream.indentation();
                    state.startOfLine = true;
                }
                if (stream.eatSpace()) {
                    maybeEOL(stream, state);
                    return null;
                }
                curPunc = isDefKeyword = null;
                var style = (state.tokenize || tokenBase)(stream, state);
                if (style == "comment" || style == "meta") return style;
                if (ctx.align == null) ctx.align = true;
                if (curPunc == ";" || curPunc == ":" || curPunc == "," && stream.match(/^\s*(?:\/\/.*)?$/, false)) while(state.context.type == "statement")popContext(state);
                else if (curPunc == "{") pushContext(state, stream.column(), "}");
                else if (curPunc == "[") pushContext(state, stream.column(), "]");
                else if (curPunc == "(") pushContext(state, stream.column(), ")");
                else if (curPunc == "}") {
                    while(ctx.type == "statement")ctx = popContext(state);
                    if (ctx.type == "}") ctx = popContext(state);
                    while(ctx.type == "statement")ctx = popContext(state);
                } else if (curPunc == ctx.type) popContext(state);
                else if (indentStatements && ((ctx.type == "}" || ctx.type == "top") && curPunc != ";" || ctx.type == "statement" && curPunc == "newstatement")) {
                    pushContext(state, stream.column(), "statement", stream.current());
                }
                if (style == "variable" && (state.prevToken == "def" || parserConfig.typeFirstDefinitions && typeBefore(stream, state, stream.start) && isTopScope(state.context) && stream.match(/^\s*\(/, false))) style = "def";
                if (hooks.token) {
                    var result = hooks.token(stream, state, style);
                    if (result !== undefined) style = result;
                }
                if (style == "def" && parserConfig.styleDefs === false) style = "variable";
                state.startOfLine = false;
                state.prevToken = isDefKeyword ? "def" : style || curPunc;
                maybeEOL(stream, state);
                return style;
            },
            indent: function indent(state, textAfter) {
                if (state.tokenize != tokenBase && state.tokenize != null || state.typeAtEndOfLine) return CodeMirror1.Pass;
                var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
                var closing = firstChar == ctx.type;
                if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
                if (parserConfig.dontIndentStatements) while(ctx.type == "statement" && parserConfig.dontIndentStatements.test(ctx.info))ctx = ctx.prev;
                if (hooks.indent) {
                    var hook = hooks.indent(state, ctx, textAfter, indentUnit);
                    if (typeof hook == "number") return hook;
                }
                var switchBlock = ctx.prev && ctx.prev.info == "switch";
                if (parserConfig.allmanIndentation && /[{(]/.test(firstChar)) {
                    while(ctx.type != "top" && ctx.type != "}")ctx = ctx.prev;
                    return ctx.indented;
                }
                if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : statementIndentUnit);
                if (ctx.align && (!dontAlignCalls || ctx.type != ")")) return ctx.column + (closing ? 0 : 1);
                if (ctx.type == ")" && !closing) return ctx.indented + statementIndentUnit;
                return ctx.indented + (closing ? 0 : indentUnit) + (!closing && switchBlock && !/^(?:case|default)\b/.test(textAfter) ? indentUnit : 0);
            },
            electricInput: indentSwitch ? /^\s*(?:case .*?:|default:|\{\}?|\})$/ : /^\s*[{}]$/,
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: "//",
            fold: "brace"
        };
    });
    var cKeywords = "auto if break case register continue return default do sizeof " + "static else struct switch extern typedef union for goto while enum const " + "volatile inline restrict asm fortran";
    // Keywords from https://en.cppreference.com/w/cpp/keyword includes C++20.
    var cppKeywords = "alignas alignof and and_eq audit axiom bitand bitor catch " + "class compl concept constexpr const_cast decltype delete dynamic_cast " + "explicit export final friend import module mutable namespace new noexcept " + "not not_eq operator or or_eq override private protected public " + "reinterpret_cast requires static_assert static_cast template this " + "thread_local throw try typeid typename using virtual xor xor_eq";
    var objCKeywords = "bycopy byref in inout oneway out self super atomic nonatomic retain copy " + "readwrite readonly strong weak assign typeof nullable nonnull null_resettable _cmd " + "@interface @implementation @end @protocol @encode @property @synthesize @dynamic @class " + "@public @package @private @protected @required @optional @try @catch @finally @import " + "@selector @encode @defs @synchronized @autoreleasepool @compatibility_alias @available";
    var objCBuiltins = "FOUNDATION_EXPORT FOUNDATION_EXTERN NS_INLINE NS_FORMAT_FUNCTION " + " NS_RETURNS_RETAINEDNS_ERROR_ENUM NS_RETURNS_NOT_RETAINED NS_RETURNS_INNER_POINTER " + "NS_DESIGNATED_INITIALIZER NS_ENUM NS_OPTIONS NS_REQUIRES_NIL_TERMINATION " + "NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END NS_SWIFT_NAME NS_REFINED_FOR_SWIFT";
    // Do not use this. Use the cTypes function below. This is global just to avoid
    // excessive calls when cTypes is being called multiple times during a parse.
    var basicCTypes = words("int long char short double float unsigned signed " + "void bool");
    // Do not use this. Use the objCTypes function below. This is global just to avoid
    // excessive calls when objCTypes is being called multiple times during a parse.
    var basicObjCTypes = words("SEL instancetype id Class Protocol BOOL");
    var cBlockKeywords = "case do else for if switch while struct enum union";
    var cDefKeywords = "struct enum union";
    function cppHook(stream, state) {
        if (!state.startOfLine) return false;
        for(var ch, next = null; ch = stream.peek();){
            if (ch == "\\" && stream.match(/^.$/)) {
                next = cppHook;
                break;
            } else if (ch == "/" && stream.match(/^\/[\/\*]/, false)) {
                break;
            }
            stream.next();
        }
        state.tokenize = next;
        return "meta";
    }
    def([
        "text/x-csrc",
        "text/x-c",
        "text/x-chdr"
    ], {
        name: "clike",
        keywords: words(cKeywords),
        types: cTypes,
        blockKeywords: words(cBlockKeywords),
        defKeywords: words(cDefKeywords),
        typeFirstDefinitions: true,
        atoms: words("NULL true false"),
        isReservedIdentifier: cIsReservedIdentifier,
        hooks: {
            "#": cppHook,
            "*": pointerHook
        },
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    def([
        "text/x-c++src",
        "text/x-c++hdr"
    ], {
        name: "clike",
        keywords: words(cKeywords + " " + cppKeywords),
        types: cTypes,
        blockKeywords: words(cBlockKeywords + " class try catch"),
        defKeywords: words(cDefKeywords + " class namespace"),
        typeFirstDefinitions: true,
        atoms: words("true false NULL nullptr"),
        dontIndentStatements: /^template$/,
        isIdentifierChar: /[\w\$_~\xa1-\uffff]/,
        isReservedIdentifier: cIsReservedIdentifier,
        hooks: {
            "#": cppHook,
            "*": pointerHook,
            "u": cpp11StringHook,
            "U": cpp11StringHook,
            "L": cpp11StringHook,
            "R": cpp11StringHook,
            "0": cpp14Literal,
            "1": cpp14Literal,
            "2": cpp14Literal,
            "3": cpp14Literal,
            "4": cpp14Literal,
            "5": cpp14Literal,
            "6": cpp14Literal,
            "7": cpp14Literal,
            "8": cpp14Literal,
            "9": cpp14Literal,
            token: function token(stream, state, style) {
                if (style == "variable" && stream.peek() == "(" && (state.prevToken == ";" || state.prevToken == null || state.prevToken == "}") && cppLooksLikeConstructor(stream.current())) return "def";
            }
        },
        namespaceSeparator: "::",
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    def("text/x-java", {
        name: "clike",
        keywords: words("abstract assert break case catch class const continue default " + "do else enum extends final finally for goto if implements import " + "instanceof interface native new package private protected public " + "return static strictfp super switch synchronized this throw throws transient " + "try volatile while @interface"),
        types: words("var byte short int long float double boolean char void Boolean Byte Character Double Float " + "Integer Long Number Object Short String StringBuffer StringBuilder Void"),
        blockKeywords: words("catch class do else finally for if switch try while"),
        defKeywords: words("class interface enum @interface"),
        typeFirstDefinitions: true,
        atoms: words("true false null"),
        number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+\.?\d*|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
        hooks: {
            "@": function(stream) {
                // Don't match the @interface keyword.
                if (stream.match("interface", false)) return false;
                stream.eatWhile(/[\w\$_]/);
                return "meta";
            }
        },
        modeProps: {
            fold: [
                "brace",
                "import"
            ]
        }
    });
    def("text/x-csharp", {
        name: "clike",
        keywords: words("abstract as async await base break case catch checked class const continue" + " default delegate do else enum event explicit extern finally fixed for" + " foreach goto if implicit in interface internal is lock namespace new" + " operator out override params private protected public readonly ref return sealed" + " sizeof stackalloc static struct switch this throw try typeof unchecked" + " unsafe using virtual void volatile while add alias ascending descending dynamic from get" + " global group into join let orderby partial remove select set value var yield"),
        types: words("Action Boolean Byte Char DateTime DateTimeOffset Decimal Double Func" + " Guid Int16 Int32 Int64 Object SByte Single String Task TimeSpan UInt16 UInt32" + " UInt64 bool byte char decimal double short int long object" + " sbyte float string ushort uint ulong"),
        blockKeywords: words("catch class do else finally for foreach if struct switch try while"),
        defKeywords: words("class interface namespace struct var"),
        typeFirstDefinitions: true,
        atoms: words("true false null"),
        hooks: {
            "@": function(stream, state) {
                if (stream.eat('"')) {
                    state.tokenize = tokenAtString;
                    return tokenAtString(stream, state);
                }
                stream.eatWhile(/[\w\$_]/);
                return "meta";
            }
        }
    });
    function tokenNestedComment(depth) {
        return function(stream, state) {
            var ch;
            while(ch = stream.next()){
                if (ch == "*" && stream.eat("/")) {
                    if (depth == 1) {
                        state.tokenize = null;
                        break;
                    } else {
                        state.tokenize = tokenNestedComment(depth - 1);
                        return state.tokenize(stream, state);
                    }
                } else if (ch == "/" && stream.eat("*")) {
                    state.tokenize = tokenNestedComment(depth + 1);
                    return state.tokenize(stream, state);
                }
            }
            return "comment";
        };
    }
    def("text/x-scala", {
        name: "clike",
        keywords: words(/* scala */ "abstract case catch class def do else extends final finally for forSome if " + "implicit import lazy match new null object override package private protected return " + "sealed super this throw trait try type val var while with yield _ " + /* package scala */ "assert assume require print println printf readLine readBoolean readByte readShort " + "readChar readInt readLong readFloat readDouble"),
        types: words("AnyVal App Application Array BufferedIterator BigDecimal BigInt Char Console Either " + "Enumeration Equiv Error Exception Fractional Function IndexedSeq Int Integral Iterable " + "Iterator List Map Numeric Nil NotNull Option Ordered Ordering PartialFunction PartialOrdering " + "Product Proxy Range Responder Seq Serializable Set Specializable Stream StringBuilder " + "StringContext Symbol Throwable Traversable TraversableOnce Tuple Unit Vector " + /* package java.lang */ "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " + "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " + "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " + "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void"),
        multiLineStrings: true,
        blockKeywords: words("catch class enum do else finally for forSome if match switch try while"),
        defKeywords: words("class enum def object package trait type val var"),
        atoms: words("true false null"),
        indentStatements: false,
        indentSwitch: false,
        isOperatorChar: /[+\-*&%=<>!?|\/#:@]/,
        hooks: {
            "@": function(stream) {
                stream.eatWhile(/[\w\$_]/);
                return "meta";
            },
            '"': function(stream, state) {
                if (!stream.match('""')) return false;
                state.tokenize = tokenTripleString;
                return state.tokenize(stream, state);
            },
            "'": function(stream) {
                stream.eatWhile(/[\w\$_\xa1-\uffff]/);
                return "atom";
            },
            "=": function(stream, state) {
                var cx = state.context;
                if (cx.type == "}" && cx.align && stream.eat(">")) {
                    state.context = new Context(cx.indented, cx.column, cx.type, cx.info, null, cx.prev);
                    return "operator";
                } else {
                    return false;
                }
            },
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenNestedComment(1);
                return state.tokenize(stream, state);
            }
        },
        modeProps: {
            closeBrackets: {
                pairs: '()[]{}""',
                triples: '"'
            }
        }
    });
    def("text/x-kotlin", {
        name: "clike",
        keywords: words(/*keywords*/ "package as typealias class interface this super val operator " + "var fun for is in This throw return annotation " + "break continue object if else while do try when !in !is as? " + /*soft keywords*/ "file import where by get set abstract enum open inner override private public internal " + "protected catch finally out final vararg reified dynamic companion constructor init " + "sealed field property receiver param sparam lateinit data inline noinline tailrec " + "external annotation crossinline const operator infix suspend actual expect setparam value"),
        types: words(/* package java.lang */ "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " + "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " + "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " + "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void Annotation Any BooleanArray " + "ByteArray Char CharArray DeprecationLevel DoubleArray Enum FloatArray Function Int IntArray Lazy " + "LazyThreadSafetyMode LongArray Nothing ShortArray Unit"),
        intendSwitch: false,
        indentStatements: false,
        multiLineStrings: true,
        number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+(\.\d+)?|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
        blockKeywords: words("catch class do else finally for if where try while enum"),
        defKeywords: words("class val var object interface fun"),
        atoms: words("true false null this"),
        hooks: {
            "@": function(stream) {
                stream.eatWhile(/[\w\$_]/);
                return "meta";
            },
            "*": function(_stream, state) {
                return state.prevToken == "." ? "variable" : "operator";
            },
            '"': function(stream, state) {
                state.tokenize = tokenKotlinString(stream.match('""'));
                return state.tokenize(stream, state);
            },
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenNestedComment(1);
                return state.tokenize(stream, state);
            },
            indent: function indent(state, ctx, textAfter, indentUnit) {
                var firstChar = textAfter && textAfter.charAt(0);
                if ((state.prevToken == "}" || state.prevToken == ")") && textAfter == "") return state.indented;
                if (state.prevToken == "operator" && textAfter != "}" && state.context.type != "}" || state.prevToken == "variable" && firstChar == "." || (state.prevToken == "}" || state.prevToken == ")") && firstChar == ".") return indentUnit * 2 + ctx.indented;
                if (ctx.align && ctx.type == "}") return ctx.indented + (state.context.type == (textAfter || "").charAt(0) ? 0 : indentUnit);
            }
        },
        modeProps: {
            closeBrackets: {
                triples: '"'
            }
        }
    });
    def([
        "x-shader/x-vertex",
        "x-shader/x-fragment"
    ], {
        name: "clike",
        keywords: words("sampler1D sampler2D sampler3D samplerCube " + "sampler1DShadow sampler2DShadow " + "const attribute uniform varying " + "break continue discard return " + "for while do if else struct " + "in out inout"),
        types: words("float int bool void " + "vec2 vec3 vec4 ivec2 ivec3 ivec4 bvec2 bvec3 bvec4 " + "mat2 mat3 mat4"),
        blockKeywords: words("for while do if else struct"),
        builtin: words("radians degrees sin cos tan asin acos atan " + "pow exp log exp2 sqrt inversesqrt " + "abs sign floor ceil fract mod min max clamp mix step smoothstep " + "length distance dot cross normalize ftransform faceforward " + "reflect refract matrixCompMult " + "lessThan lessThanEqual greaterThan greaterThanEqual " + "equal notEqual any all not " + "texture1D texture1DProj texture1DLod texture1DProjLod " + "texture2D texture2DProj texture2DLod texture2DProjLod " + "texture3D texture3DProj texture3DLod texture3DProjLod " + "textureCube textureCubeLod " + "shadow1D shadow2D shadow1DProj shadow2DProj " + "shadow1DLod shadow2DLod shadow1DProjLod shadow2DProjLod " + "dFdx dFdy fwidth " + "noise1 noise2 noise3 noise4"),
        atoms: words("true false " + "gl_FragColor gl_SecondaryColor gl_Normal gl_Vertex " + "gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 " + "gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 " + "gl_FogCoord gl_PointCoord " + "gl_Position gl_PointSize gl_ClipVertex " + "gl_FrontColor gl_BackColor gl_FrontSecondaryColor gl_BackSecondaryColor " + "gl_TexCoord gl_FogFragCoord " + "gl_FragCoord gl_FrontFacing " + "gl_FragData gl_FragDepth " + "gl_ModelViewMatrix gl_ProjectionMatrix gl_ModelViewProjectionMatrix " + "gl_TextureMatrix gl_NormalMatrix gl_ModelViewMatrixInverse " + "gl_ProjectionMatrixInverse gl_ModelViewProjectionMatrixInverse " + "gl_TextureMatrixTranspose gl_ModelViewMatrixInverseTranspose " + "gl_ProjectionMatrixInverseTranspose " + "gl_ModelViewProjectionMatrixInverseTranspose " + "gl_TextureMatrixInverseTranspose " + "gl_NormalScale gl_DepthRange gl_ClipPlane " + "gl_Point gl_FrontMaterial gl_BackMaterial gl_LightSource gl_LightModel " + "gl_FrontLightModelProduct gl_BackLightModelProduct " + "gl_TextureColor gl_EyePlaneS gl_EyePlaneT gl_EyePlaneR gl_EyePlaneQ " + "gl_FogParameters " + "gl_MaxLights gl_MaxClipPlanes gl_MaxTextureUnits gl_MaxTextureCoords " + "gl_MaxVertexAttribs gl_MaxVertexUniformComponents gl_MaxVaryingFloats " + "gl_MaxVertexTextureImageUnits gl_MaxTextureImageUnits " + "gl_MaxFragmentUniformComponents gl_MaxCombineTextureImageUnits " + "gl_MaxDrawBuffers"),
        indentSwitch: false,
        hooks: {
            "#": cppHook
        },
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    def("text/x-nesc", {
        name: "clike",
        keywords: words(cKeywords + " as atomic async call command component components configuration event generic " + "implementation includes interface module new norace nx_struct nx_union post provides " + "signal task uses abstract extends"),
        types: cTypes,
        blockKeywords: words(cBlockKeywords),
        atoms: words("null true false"),
        hooks: {
            "#": cppHook
        },
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    def("text/x-objectivec", {
        name: "clike",
        keywords: words(cKeywords + " " + objCKeywords),
        types: objCTypes,
        builtin: words(objCBuiltins),
        blockKeywords: words(cBlockKeywords + " @synthesize @try @catch @finally @autoreleasepool @synchronized"),
        defKeywords: words(cDefKeywords + " @interface @implementation @protocol @class"),
        dontIndentStatements: /^@.*$/,
        typeFirstDefinitions: true,
        atoms: words("YES NO NULL Nil nil true false nullptr"),
        isReservedIdentifier: cIsReservedIdentifier,
        hooks: {
            "#": cppHook,
            "*": pointerHook
        },
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    def("text/x-objectivec++", {
        name: "clike",
        keywords: words(cKeywords + " " + objCKeywords + " " + cppKeywords),
        types: objCTypes,
        builtin: words(objCBuiltins),
        blockKeywords: words(cBlockKeywords + " @synthesize @try @catch @finally @autoreleasepool @synchronized class try catch"),
        defKeywords: words(cDefKeywords + " @interface @implementation @protocol @class class namespace"),
        dontIndentStatements: /^@.*$|^template$/,
        typeFirstDefinitions: true,
        atoms: words("YES NO NULL Nil nil true false nullptr"),
        isReservedIdentifier: cIsReservedIdentifier,
        hooks: {
            "#": cppHook,
            "*": pointerHook,
            "u": cpp11StringHook,
            "U": cpp11StringHook,
            "L": cpp11StringHook,
            "R": cpp11StringHook,
            "0": cpp14Literal,
            "1": cpp14Literal,
            "2": cpp14Literal,
            "3": cpp14Literal,
            "4": cpp14Literal,
            "5": cpp14Literal,
            "6": cpp14Literal,
            "7": cpp14Literal,
            "8": cpp14Literal,
            "9": cpp14Literal,
            token: function token(stream, state, style) {
                if (style == "variable" && stream.peek() == "(" && (state.prevToken == ";" || state.prevToken == null || state.prevToken == "}") && cppLooksLikeConstructor(stream.current())) return "def";
            }
        },
        namespaceSeparator: "::",
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    def("text/x-squirrel", {
        name: "clike",
        keywords: words("base break clone continue const default delete enum extends function in class" + " foreach local resume return this throw typeof yield constructor instanceof static"),
        types: cTypes,
        blockKeywords: words("case catch class else for foreach if switch try while"),
        defKeywords: words("function local class"),
        typeFirstDefinitions: true,
        atoms: words("true false null"),
        hooks: {
            "#": cppHook
        },
        modeProps: {
            fold: [
                "brace",
                "include"
            ]
        }
    });
    // Ceylon Strings need to deal with interpolation
    var stringTokenizer = null;
    function tokenCeylonString(type) {
        return function(stream, state) {
            var escaped = false, next, end = false;
            while(!stream.eol()){
                if (!escaped && stream.match('"') && (type == "single" || stream.match('""'))) {
                    end = true;
                    break;
                }
                if (!escaped && stream.match("``")) {
                    stringTokenizer = tokenCeylonString(type);
                    end = true;
                    break;
                }
                next = stream.next();
                escaped = type == "single" && !escaped && next == "\\";
            }
            if (end) state.tokenize = null;
            return "string";
        };
    }
    def("text/x-ceylon", {
        name: "clike",
        keywords: words("abstracts alias assembly assert assign break case catch class continue dynamic else" + " exists extends finally for function given if import in interface is let module new" + " nonempty object of out outer package return satisfies super switch then this throw" + " try value void while"),
        types: function types(word) {
            // In Ceylon all identifiers that start with an uppercase are types
            var first = word.charAt(0);
            return first === first.toUpperCase() && first !== first.toLowerCase();
        },
        blockKeywords: words("case catch class dynamic else finally for function if interface module new object switch try while"),
        defKeywords: words("class dynamic function interface module object package value"),
        builtin: words("abstract actual aliased annotation by default deprecated doc final formal late license" + " native optional sealed see serializable shared suppressWarnings tagged throws variable"),
        isPunctuationChar: /[\[\]{}\(\),;\:\.`]/,
        isOperatorChar: /[+\-*&%=<>!?|^~:\/]/,
        numberStart: /[\d#$]/,
        number: /^(?:#[\da-fA-F_]+|\$[01_]+|[\d_]+[kMGTPmunpf]?|[\d_]+\.[\d_]+(?:[eE][-+]?\d+|[kMGTPmunpf]|)|)/i,
        multiLineStrings: true,
        typeFirstDefinitions: true,
        atoms: words("true false null larger smaller equal empty finished"),
        indentSwitch: false,
        styleDefs: false,
        hooks: {
            "@": function(stream) {
                stream.eatWhile(/[\w\$_]/);
                return "meta";
            },
            '"': function(stream, state) {
                state.tokenize = tokenCeylonString(stream.match('""') ? "triple" : "single");
                return state.tokenize(stream, state);
            },
            "`": function(stream, state) {
                if (!stringTokenizer || !stream.match("`")) return false;
                state.tokenize = stringTokenizer;
                stringTokenizer = null;
                return state.tokenize(stream, state);
            },
            "'": function(stream) {
                stream.eatWhile(/[\w\$_\xa1-\uffff]/);
                return "atom";
            },
            token: function token(_stream, state, style) {
                if ((style == "variable" || style == "type") && state.prevToken == ".") {
                    return "variable-2";
                }
            }
        },
        modeProps: {
            fold: [
                "brace",
                "import"
            ],
            closeBrackets: {
                triples: '"'
            }
        }
    });
});
});

var css = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var keySet = function keySet(array) {
        var keys = {};
        for(var i = 0; i < array.length; ++i){
            keys[array[i].toLowerCase()] = true;
        }
        return keys;
    };
    var tokenCComment = function tokenCComment(stream, state) {
        var maybeEnd = false, ch;
        while((ch = stream.next()) != null){
            if (maybeEnd && ch == "/") {
                state.tokenize = null;
                break;
            }
            maybeEnd = ch == "*";
        }
        return [
            "comment",
            "comment"
        ];
    };
    CodeMirror1.defineMode("css", function(config, parserConfig) {
        var ret = function ret(style, tp) {
            type = tp;
            return style;
        };
        var tokenBase = // Tokenizers
        function tokenBase(stream, state) {
            var ch = stream.next();
            if (tokenHooks[ch]) {
                var result = tokenHooks[ch](stream, state);
                if (result !== false) return result;
            }
            if (ch == "@") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("def", stream.current());
            } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
                return ret(null, "compare");
            } else if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "#") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("atom", "hash");
            } else if (ch == "!") {
                stream.match(/^\s*\w*/);
                return ret("keyword", "important");
            } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
                stream.eatWhile(/[\w.%]/);
                return ret("number", "unit");
            } else if (ch === "-") {
                if (/[\d.]/.test(stream.peek())) {
                    stream.eatWhile(/[\w.%]/);
                    return ret("number", "unit");
                } else if (stream.match(/^-[\w\\\-]*/)) {
                    stream.eatWhile(/[\w\\\-]/);
                    if (stream.match(/^\s*:/, false)) return ret("variable-2", "variable-definition");
                    return ret("variable-2", "variable");
                } else if (stream.match(/^\w+-/)) {
                    return ret("meta", "meta");
                }
            } else if (/[,+>*\/]/.test(ch)) {
                return ret(null, "select-op");
            } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
                return ret("qualifier", "qualifier");
            } else if (/[:;{}\[\]\(\)]/.test(ch)) {
                return ret(null, ch);
            } else if (stream.match(/^[\w-.]+(?=\()/)) {
                if (/^(url(-prefix)?|domain|regexp)$/i.test(stream.current())) {
                    state.tokenize = tokenParenthesized;
                }
                return ret("variable callee", "variable");
            } else if (/[\w\\\-]/.test(ch)) {
                stream.eatWhile(/[\w\\\-]/);
                return ret("property", "word");
            } else {
                return ret(null, null);
            }
        };
        var tokenString = function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) {
                        if (quote == ")") stream.backUp(1);
                        break;
                    }
                    escaped = !escaped && ch == "\\";
                }
                if (ch == quote || !escaped && quote != ")") state.tokenize = null;
                return ret("string", "string");
            };
        };
        var tokenParenthesized = function tokenParenthesized(stream, state) {
            stream.next(); // Must be '('
            if (!stream.match(/^\s*[\"\')]/, false)) state.tokenize = tokenString(")");
            else state.tokenize = null;
            return ret(null, "(");
        };
        var Context = // Context management
        function Context(type, indent, prev) {
            this.type = type;
            this.indent = indent;
            this.prev = prev;
        };
        var pushContext = function pushContext(state, stream, type, indent) {
            state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
            return type;
        };
        var popContext = function popContext(state) {
            if (state.context.prev) state.context = state.context.prev;
            return state.context.type;
        };
        var pass = function pass(type, stream, state) {
            return states[state.context.type](type, stream, state);
        };
        var popAndPass = function popAndPass(type, stream, state, n) {
            for(var i = n || 1; i > 0; i--)state.context = state.context.prev;
            return pass(type, stream, state);
        };
        var wordAsValue = // Parser
        function wordAsValue(stream) {
            var word = stream.current().toLowerCase();
            if (valueKeywords.hasOwnProperty(word)) override = "atom";
            else if (colorKeywords.hasOwnProperty(word)) override = "keyword";
            else override = "variable";
        };
        var inline = parserConfig.inline;
        if (!parserConfig.propertyKeywords) parserConfig = CodeMirror1.resolveMode("text/css");
        var indentUnit = config.indentUnit, tokenHooks = parserConfig.tokenHooks, documentTypes = parserConfig.documentTypes || {}, mediaTypes = parserConfig.mediaTypes || {}, mediaFeatures = parserConfig.mediaFeatures || {}, mediaValueKeywords = parserConfig.mediaValueKeywords || {}, propertyKeywords = parserConfig.propertyKeywords || {}, nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {}, fontProperties = parserConfig.fontProperties || {}, counterDescriptors = parserConfig.counterDescriptors || {}, colorKeywords = parserConfig.colorKeywords || {}, valueKeywords = parserConfig.valueKeywords || {}, allowNested = parserConfig.allowNested, lineComment = parserConfig.lineComment, supportsAtComponent = parserConfig.supportsAtComponent === true, highlightNonStandardPropertyKeywords = config.highlightNonStandardPropertyKeywords !== false;
        var type, override;
        var states = {};
        states.top = function(type, stream, state) {
            if (type == "{") {
                return pushContext(state, stream, "block");
            } else if (type == "}" && state.context.prev) {
                return popContext(state);
            } else if (supportsAtComponent && /@component/i.test(type)) {
                return pushContext(state, stream, "atComponentBlock");
            } else if (/^@(-moz-)?document$/i.test(type)) {
                return pushContext(state, stream, "documentTypes");
            } else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) {
                return pushContext(state, stream, "atBlock");
            } else if (/^@(font-face|counter-style)/i.test(type)) {
                state.stateArg = type;
                return "restricted_atBlock_before";
            } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) {
                return "keyframes";
            } else if (type && type.charAt(0) == "@") {
                return pushContext(state, stream, "at");
            } else if (type == "hash") {
                override = "builtin";
            } else if (type == "word") {
                override = "tag";
            } else if (type == "variable-definition") {
                return "maybeprop";
            } else if (type == "interpolation") {
                return pushContext(state, stream, "interpolation");
            } else if (type == ":") {
                return "pseudo";
            } else if (allowNested && type == "(") {
                return pushContext(state, stream, "parens");
            }
            return state.context.type;
        };
        states.block = function(type, stream, state) {
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (propertyKeywords.hasOwnProperty(word)) {
                    override = "property";
                    return "maybeprop";
                } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
                    override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
                    return "maybeprop";
                } else if (allowNested) {
                    override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
                    return "block";
                } else {
                    override += " error";
                    return "maybeprop";
                }
            } else if (type == "meta") {
                return "block";
            } else if (!allowNested && (type == "hash" || type == "qualifier")) {
                override = "error";
                return "block";
            } else {
                return states.top(type, stream, state);
            }
        };
        states.maybeprop = function(type, stream, state) {
            if (type == ":") return pushContext(state, stream, "prop");
            return pass(type, stream, state);
        };
        states.prop = function(type, stream, state) {
            if (type == ";") return popContext(state);
            if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
            if (type == "}" || type == "{") return popAndPass(type, stream, state);
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
                override += " error";
            } else if (type == "word") {
                wordAsValue(stream);
            } else if (type == "interpolation") {
                return pushContext(state, stream, "interpolation");
            }
            return "prop";
        };
        states.propBlock = function(type, _stream, state) {
            if (type == "}") return popContext(state);
            if (type == "word") {
                override = "property";
                return "maybeprop";
            }
            return state.context.type;
        };
        states.parens = function(type, stream, state) {
            if (type == "{" || type == "}") return popAndPass(type, stream, state);
            if (type == ")") return popContext(state);
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == "interpolation") return pushContext(state, stream, "interpolation");
            if (type == "word") wordAsValue(stream);
            return "parens";
        };
        states.pseudo = function(type, stream, state) {
            if (type == "meta") return "pseudo";
            if (type == "word") {
                override = "variable-3";
                return state.context.type;
            }
            return pass(type, stream, state);
        };
        states.documentTypes = function(type, stream, state) {
            if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
                override = "tag";
                return state.context.type;
            } else {
                return states.atBlock(type, stream, state);
            }
        };
        states.atBlock = function(type, stream, state) {
            if (type == "(") return pushContext(state, stream, "atBlock_parens");
            if (type == "}" || type == ";") return popAndPass(type, stream, state);
            if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
            if (type == "interpolation") return pushContext(state, stream, "interpolation");
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (word == "only" || word == "not" || word == "and" || word == "or") override = "keyword";
                else if (mediaTypes.hasOwnProperty(word)) override = "attribute";
                else if (mediaFeatures.hasOwnProperty(word)) override = "property";
                else if (mediaValueKeywords.hasOwnProperty(word)) override = "keyword";
                else if (propertyKeywords.hasOwnProperty(word)) override = "property";
                else if (nonStandardPropertyKeywords.hasOwnProperty(word)) override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
                else if (valueKeywords.hasOwnProperty(word)) override = "atom";
                else if (colorKeywords.hasOwnProperty(word)) override = "keyword";
                else override = "error";
            }
            return state.context.type;
        };
        states.atComponentBlock = function(type, stream, state) {
            if (type == "}") return popAndPass(type, stream, state);
            if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
            if (type == "word") override = "error";
            return state.context.type;
        };
        states.atBlock_parens = function(type, stream, state) {
            if (type == ")") return popContext(state);
            if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
            return states.atBlock(type, stream, state);
        };
        states.restricted_atBlock_before = function(type, stream, state) {
            if (type == "{") return pushContext(state, stream, "restricted_atBlock");
            if (type == "word" && state.stateArg == "@counter-style") {
                override = "variable";
                return "restricted_atBlock_before";
            }
            return pass(type, stream, state);
        };
        states.restricted_atBlock = function(type, stream, state) {
            if (type == "}") {
                state.stateArg = null;
                return popContext(state);
            }
            if (type == "word") {
                if (state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase()) || state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())) override = "error";
                else override = "property";
                return "maybeprop";
            }
            return "restricted_atBlock";
        };
        states.keyframes = function(type, stream, state) {
            if (type == "word") {
                override = "variable";
                return "keyframes";
            }
            if (type == "{") return pushContext(state, stream, "top");
            return pass(type, stream, state);
        };
        states.at = function(type, stream, state) {
            if (type == ";") return popContext(state);
            if (type == "{" || type == "}") return popAndPass(type, stream, state);
            if (type == "word") override = "tag";
            else if (type == "hash") override = "builtin";
            return "at";
        };
        states.interpolation = function(type, stream, state) {
            if (type == "}") return popContext(state);
            if (type == "{" || type == ";") return popAndPass(type, stream, state);
            if (type == "word") override = "variable";
            else if (type != "variable" && type != "(" && type != ")") override = "error";
            return "interpolation";
        };
        return {
            startState: function startState(base) {
                return {
                    tokenize: null,
                    state: inline ? "block" : "top",
                    stateArg: null,
                    context: new Context(inline ? "block" : "top", base || 0, null)
                };
            },
            token: function token(stream, state) {
                if (!state.tokenize && stream.eatSpace()) return null;
                var style = (state.tokenize || tokenBase)(stream, state);
                if (style && typeof style == "object") {
                    type = style[1];
                    style = style[0];
                }
                override = style;
                if (type != "comment") state.state = states[state.state](type, stream, state);
                return override;
            },
            indent: function indent(state, textAfter) {
                var cx = state.context, ch = textAfter && textAfter.charAt(0);
                var indent = cx.indent;
                if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
                if (cx.prev) {
                    if (ch == "}" && (cx.type == "block" || cx.type == "top" || cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
                        // Resume indentation from parent context.
                        cx = cx.prev;
                        indent = cx.indent;
                    } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") || ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
                        // Dedent relative to current context.
                        indent = Math.max(0, cx.indent - indentUnit);
                    }
                }
                return indent;
            },
            electricChars: "}",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: lineComment,
            fold: "brace"
        };
    });
    var documentTypes_ = [
        "domain",
        "regexp",
        "url",
        "url-prefix"
    ], documentTypes = keySet(documentTypes_);
    var mediaTypes_ = [
        "all",
        "aural",
        "braille",
        "handheld",
        "print",
        "projection",
        "screen",
        "tty",
        "tv",
        "embossed"
    ], mediaTypes = keySet(mediaTypes_);
    var mediaFeatures_ = [
        "width",
        "min-width",
        "max-width",
        "height",
        "min-height",
        "max-height",
        "device-width",
        "min-device-width",
        "max-device-width",
        "device-height",
        "min-device-height",
        "max-device-height",
        "aspect-ratio",
        "min-aspect-ratio",
        "max-aspect-ratio",
        "device-aspect-ratio",
        "min-device-aspect-ratio",
        "max-device-aspect-ratio",
        "color",
        "min-color",
        "max-color",
        "color-index",
        "min-color-index",
        "max-color-index",
        "monochrome",
        "min-monochrome",
        "max-monochrome",
        "resolution",
        "min-resolution",
        "max-resolution",
        "scan",
        "grid",
        "orientation",
        "device-pixel-ratio",
        "min-device-pixel-ratio",
        "max-device-pixel-ratio",
        "pointer",
        "any-pointer",
        "hover",
        "any-hover",
        "prefers-color-scheme",
        "dynamic-range",
        "video-dynamic-range"
    ], mediaFeatures = keySet(mediaFeatures_);
    var mediaValueKeywords_ = [
        "landscape",
        "portrait",
        "none",
        "coarse",
        "fine",
        "on-demand",
        "hover",
        "interlace",
        "progressive",
        "dark",
        "light",
        "standard",
        "high"
    ], mediaValueKeywords = keySet(mediaValueKeywords_);
    var propertyKeywords_ = [
        "align-content",
        "align-items",
        "align-self",
        "alignment-adjust",
        "alignment-baseline",
        "all",
        "anchor-point",
        "animation",
        "animation-delay",
        "animation-direction",
        "animation-duration",
        "animation-fill-mode",
        "animation-iteration-count",
        "animation-name",
        "animation-play-state",
        "animation-timing-function",
        "appearance",
        "azimuth",
        "backdrop-filter",
        "backface-visibility",
        "background",
        "background-attachment",
        "background-blend-mode",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-position-x",
        "background-position-y",
        "background-repeat",
        "background-size",
        "baseline-shift",
        "binding",
        "bleed",
        "block-size",
        "bookmark-label",
        "bookmark-level",
        "bookmark-state",
        "bookmark-target",
        "border",
        "border-bottom",
        "border-bottom-color",
        "border-bottom-left-radius",
        "border-bottom-right-radius",
        "border-bottom-style",
        "border-bottom-width",
        "border-collapse",
        "border-color",
        "border-image",
        "border-image-outset",
        "border-image-repeat",
        "border-image-slice",
        "border-image-source",
        "border-image-width",
        "border-left",
        "border-left-color",
        "border-left-style",
        "border-left-width",
        "border-radius",
        "border-right",
        "border-right-color",
        "border-right-style",
        "border-right-width",
        "border-spacing",
        "border-style",
        "border-top",
        "border-top-color",
        "border-top-left-radius",
        "border-top-right-radius",
        "border-top-style",
        "border-top-width",
        "border-width",
        "bottom",
        "box-decoration-break",
        "box-shadow",
        "box-sizing",
        "break-after",
        "break-before",
        "break-inside",
        "caption-side",
        "caret-color",
        "clear",
        "clip",
        "color",
        "color-profile",
        "column-count",
        "column-fill",
        "column-gap",
        "column-rule",
        "column-rule-color",
        "column-rule-style",
        "column-rule-width",
        "column-span",
        "column-width",
        "columns",
        "contain",
        "content",
        "counter-increment",
        "counter-reset",
        "crop",
        "cue",
        "cue-after",
        "cue-before",
        "cursor",
        "direction",
        "display",
        "dominant-baseline",
        "drop-initial-after-adjust",
        "drop-initial-after-align",
        "drop-initial-before-adjust",
        "drop-initial-before-align",
        "drop-initial-size",
        "drop-initial-value",
        "elevation",
        "empty-cells",
        "fit",
        "fit-content",
        "fit-position",
        "flex",
        "flex-basis",
        "flex-direction",
        "flex-flow",
        "flex-grow",
        "flex-shrink",
        "flex-wrap",
        "float",
        "float-offset",
        "flow-from",
        "flow-into",
        "font",
        "font-family",
        "font-feature-settings",
        "font-kerning",
        "font-language-override",
        "font-optical-sizing",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-synthesis",
        "font-variant",
        "font-variant-alternates",
        "font-variant-caps",
        "font-variant-east-asian",
        "font-variant-ligatures",
        "font-variant-numeric",
        "font-variant-position",
        "font-variation-settings",
        "font-weight",
        "gap",
        "grid",
        "grid-area",
        "grid-auto-columns",
        "grid-auto-flow",
        "grid-auto-rows",
        "grid-column",
        "grid-column-end",
        "grid-column-gap",
        "grid-column-start",
        "grid-gap",
        "grid-row",
        "grid-row-end",
        "grid-row-gap",
        "grid-row-start",
        "grid-template",
        "grid-template-areas",
        "grid-template-columns",
        "grid-template-rows",
        "hanging-punctuation",
        "height",
        "hyphens",
        "icon",
        "image-orientation",
        "image-rendering",
        "image-resolution",
        "inline-box-align",
        "inset",
        "inset-block",
        "inset-block-end",
        "inset-block-start",
        "inset-inline",
        "inset-inline-end",
        "inset-inline-start",
        "isolation",
        "justify-content",
        "justify-items",
        "justify-self",
        "left",
        "letter-spacing",
        "line-break",
        "line-height",
        "line-height-step",
        "line-stacking",
        "line-stacking-ruby",
        "line-stacking-shift",
        "line-stacking-strategy",
        "list-style",
        "list-style-image",
        "list-style-position",
        "list-style-type",
        "margin",
        "margin-bottom",
        "margin-left",
        "margin-right",
        "margin-top",
        "marks",
        "marquee-direction",
        "marquee-loop",
        "marquee-play-count",
        "marquee-speed",
        "marquee-style",
        "mask-clip",
        "mask-composite",
        "mask-image",
        "mask-mode",
        "mask-origin",
        "mask-position",
        "mask-repeat",
        "mask-size",
        "mask-type",
        "max-block-size",
        "max-height",
        "max-inline-size",
        "max-width",
        "min-block-size",
        "min-height",
        "min-inline-size",
        "min-width",
        "mix-blend-mode",
        "move-to",
        "nav-down",
        "nav-index",
        "nav-left",
        "nav-right",
        "nav-up",
        "object-fit",
        "object-position",
        "offset",
        "offset-anchor",
        "offset-distance",
        "offset-path",
        "offset-position",
        "offset-rotate",
        "opacity",
        "order",
        "orphans",
        "outline",
        "outline-color",
        "outline-offset",
        "outline-style",
        "outline-width",
        "overflow",
        "overflow-style",
        "overflow-wrap",
        "overflow-x",
        "overflow-y",
        "padding",
        "padding-bottom",
        "padding-left",
        "padding-right",
        "padding-top",
        "page",
        "page-break-after",
        "page-break-before",
        "page-break-inside",
        "page-policy",
        "pause",
        "pause-after",
        "pause-before",
        "perspective",
        "perspective-origin",
        "pitch",
        "pitch-range",
        "place-content",
        "place-items",
        "place-self",
        "play-during",
        "position",
        "presentation-level",
        "punctuation-trim",
        "quotes",
        "region-break-after",
        "region-break-before",
        "region-break-inside",
        "region-fragment",
        "rendering-intent",
        "resize",
        "rest",
        "rest-after",
        "rest-before",
        "richness",
        "right",
        "rotate",
        "rotation",
        "rotation-point",
        "row-gap",
        "ruby-align",
        "ruby-overhang",
        "ruby-position",
        "ruby-span",
        "scale",
        "scroll-behavior",
        "scroll-margin",
        "scroll-margin-block",
        "scroll-margin-block-end",
        "scroll-margin-block-start",
        "scroll-margin-bottom",
        "scroll-margin-inline",
        "scroll-margin-inline-end",
        "scroll-margin-inline-start",
        "scroll-margin-left",
        "scroll-margin-right",
        "scroll-margin-top",
        "scroll-padding",
        "scroll-padding-block",
        "scroll-padding-block-end",
        "scroll-padding-block-start",
        "scroll-padding-bottom",
        "scroll-padding-inline",
        "scroll-padding-inline-end",
        "scroll-padding-inline-start",
        "scroll-padding-left",
        "scroll-padding-right",
        "scroll-padding-top",
        "scroll-snap-align",
        "scroll-snap-type",
        "shape-image-threshold",
        "shape-inside",
        "shape-margin",
        "shape-outside",
        "size",
        "speak",
        "speak-as",
        "speak-header",
        "speak-numeral",
        "speak-punctuation",
        "speech-rate",
        "stress",
        "string-set",
        "tab-size",
        "table-layout",
        "target",
        "target-name",
        "target-new",
        "target-position",
        "text-align",
        "text-align-last",
        "text-combine-upright",
        "text-decoration",
        "text-decoration-color",
        "text-decoration-line",
        "text-decoration-skip",
        "text-decoration-skip-ink",
        "text-decoration-style",
        "text-emphasis",
        "text-emphasis-color",
        "text-emphasis-position",
        "text-emphasis-style",
        "text-height",
        "text-indent",
        "text-justify",
        "text-orientation",
        "text-outline",
        "text-overflow",
        "text-rendering",
        "text-shadow",
        "text-size-adjust",
        "text-space-collapse",
        "text-transform",
        "text-underline-position",
        "text-wrap",
        "top",
        "touch-action",
        "transform",
        "transform-origin",
        "transform-style",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function",
        "translate",
        "unicode-bidi",
        "user-select",
        "vertical-align",
        "visibility",
        "voice-balance",
        "voice-duration",
        "voice-family",
        "voice-pitch",
        "voice-range",
        "voice-rate",
        "voice-stress",
        "voice-volume",
        "volume",
        "white-space",
        "widows",
        "width",
        "will-change",
        "word-break",
        "word-spacing",
        "word-wrap",
        "writing-mode",
        "z-index",
        // SVG-specific
        "clip-path",
        "clip-rule",
        "mask",
        "enable-background",
        "filter",
        "flood-color",
        "flood-opacity",
        "lighting-color",
        "stop-color",
        "stop-opacity",
        "pointer-events",
        "color-interpolation",
        "color-interpolation-filters",
        "color-rendering",
        "fill",
        "fill-opacity",
        "fill-rule",
        "image-rendering",
        "marker",
        "marker-end",
        "marker-mid",
        "marker-start",
        "paint-order",
        "shape-rendering",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-rendering",
        "baseline-shift",
        "dominant-baseline",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "text-anchor",
        "writing-mode"
    ], propertyKeywords = keySet(propertyKeywords_);
    var nonStandardPropertyKeywords_ = [
        "accent-color",
        "aspect-ratio",
        "border-block",
        "border-block-color",
        "border-block-end",
        "border-block-end-color",
        "border-block-end-style",
        "border-block-end-width",
        "border-block-start",
        "border-block-start-color",
        "border-block-start-style",
        "border-block-start-width",
        "border-block-style",
        "border-block-width",
        "border-inline",
        "border-inline-color",
        "border-inline-end",
        "border-inline-end-color",
        "border-inline-end-style",
        "border-inline-end-width",
        "border-inline-start",
        "border-inline-start-color",
        "border-inline-start-style",
        "border-inline-start-width",
        "border-inline-style",
        "border-inline-width",
        "content-visibility",
        "margin-block",
        "margin-block-end",
        "margin-block-start",
        "margin-inline",
        "margin-inline-end",
        "margin-inline-start",
        "overflow-anchor",
        "overscroll-behavior",
        "padding-block",
        "padding-block-end",
        "padding-block-start",
        "padding-inline",
        "padding-inline-end",
        "padding-inline-start",
        "scroll-snap-stop",
        "scrollbar-3d-light-color",
        "scrollbar-arrow-color",
        "scrollbar-base-color",
        "scrollbar-dark-shadow-color",
        "scrollbar-face-color",
        "scrollbar-highlight-color",
        "scrollbar-shadow-color",
        "scrollbar-track-color",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "shape-inside",
        "zoom"
    ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
    var fontProperties_ = [
        "font-display",
        "font-family",
        "src",
        "unicode-range",
        "font-variant",
        "font-feature-settings",
        "font-stretch",
        "font-weight",
        "font-style"
    ], fontProperties = keySet(fontProperties_);
    var counterDescriptors_ = [
        "additive-symbols",
        "fallback",
        "negative",
        "pad",
        "prefix",
        "range",
        "speak-as",
        "suffix",
        "symbols",
        "system"
    ], counterDescriptors = keySet(counterDescriptors_);
    var colorKeywords_ = [
        "aliceblue",
        "antiquewhite",
        "aqua",
        "aquamarine",
        "azure",
        "beige",
        "bisque",
        "black",
        "blanchedalmond",
        "blue",
        "blueviolet",
        "brown",
        "burlywood",
        "cadetblue",
        "chartreuse",
        "chocolate",
        "coral",
        "cornflowerblue",
        "cornsilk",
        "crimson",
        "cyan",
        "darkblue",
        "darkcyan",
        "darkgoldenrod",
        "darkgray",
        "darkgreen",
        "darkgrey",
        "darkkhaki",
        "darkmagenta",
        "darkolivegreen",
        "darkorange",
        "darkorchid",
        "darkred",
        "darksalmon",
        "darkseagreen",
        "darkslateblue",
        "darkslategray",
        "darkslategrey",
        "darkturquoise",
        "darkviolet",
        "deeppink",
        "deepskyblue",
        "dimgray",
        "dimgrey",
        "dodgerblue",
        "firebrick",
        "floralwhite",
        "forestgreen",
        "fuchsia",
        "gainsboro",
        "ghostwhite",
        "gold",
        "goldenrod",
        "gray",
        "grey",
        "green",
        "greenyellow",
        "honeydew",
        "hotpink",
        "indianred",
        "indigo",
        "ivory",
        "khaki",
        "lavender",
        "lavenderblush",
        "lawngreen",
        "lemonchiffon",
        "lightblue",
        "lightcoral",
        "lightcyan",
        "lightgoldenrodyellow",
        "lightgray",
        "lightgreen",
        "lightgrey",
        "lightpink",
        "lightsalmon",
        "lightseagreen",
        "lightskyblue",
        "lightslategray",
        "lightslategrey",
        "lightsteelblue",
        "lightyellow",
        "lime",
        "limegreen",
        "linen",
        "magenta",
        "maroon",
        "mediumaquamarine",
        "mediumblue",
        "mediumorchid",
        "mediumpurple",
        "mediumseagreen",
        "mediumslateblue",
        "mediumspringgreen",
        "mediumturquoise",
        "mediumvioletred",
        "midnightblue",
        "mintcream",
        "mistyrose",
        "moccasin",
        "navajowhite",
        "navy",
        "oldlace",
        "olive",
        "olivedrab",
        "orange",
        "orangered",
        "orchid",
        "palegoldenrod",
        "palegreen",
        "paleturquoise",
        "palevioletred",
        "papayawhip",
        "peachpuff",
        "peru",
        "pink",
        "plum",
        "powderblue",
        "purple",
        "rebeccapurple",
        "red",
        "rosybrown",
        "royalblue",
        "saddlebrown",
        "salmon",
        "sandybrown",
        "seagreen",
        "seashell",
        "sienna",
        "silver",
        "skyblue",
        "slateblue",
        "slategray",
        "slategrey",
        "snow",
        "springgreen",
        "steelblue",
        "tan",
        "teal",
        "thistle",
        "tomato",
        "turquoise",
        "violet",
        "wheat",
        "white",
        "whitesmoke",
        "yellow",
        "yellowgreen"
    ], colorKeywords = keySet(colorKeywords_);
    var valueKeywords_ = [
        "above",
        "absolute",
        "activeborder",
        "additive",
        "activecaption",
        "afar",
        "after-white-space",
        "ahead",
        "alias",
        "all",
        "all-scroll",
        "alphabetic",
        "alternate",
        "always",
        "amharic",
        "amharic-abegede",
        "antialiased",
        "appworkspace",
        "arabic-indic",
        "armenian",
        "asterisks",
        "attr",
        "auto",
        "auto-flow",
        "avoid",
        "avoid-column",
        "avoid-page",
        "avoid-region",
        "axis-pan",
        "background",
        "backwards",
        "baseline",
        "below",
        "bidi-override",
        "binary",
        "bengali",
        "blink",
        "block",
        "block-axis",
        "blur",
        "bold",
        "bolder",
        "border",
        "border-box",
        "both",
        "bottom",
        "break",
        "break-all",
        "break-word",
        "brightness",
        "bullets",
        "button",
        "button-bevel",
        "buttonface",
        "buttonhighlight",
        "buttonshadow",
        "buttontext",
        "calc",
        "cambodian",
        "capitalize",
        "caps-lock-indicator",
        "caption",
        "captiontext",
        "caret",
        "cell",
        "center",
        "checkbox",
        "circle",
        "cjk-decimal",
        "cjk-earthly-branch",
        "cjk-heavenly-stem",
        "cjk-ideographic",
        "clear",
        "clip",
        "close-quote",
        "col-resize",
        "collapse",
        "color",
        "color-burn",
        "color-dodge",
        "column",
        "column-reverse",
        "compact",
        "condensed",
        "contain",
        "content",
        "contents",
        "content-box",
        "context-menu",
        "continuous",
        "contrast",
        "copy",
        "counter",
        "counters",
        "cover",
        "crop",
        "cross",
        "crosshair",
        "cubic-bezier",
        "currentcolor",
        "cursive",
        "cyclic",
        "darken",
        "dashed",
        "decimal",
        "decimal-leading-zero",
        "default",
        "default-button",
        "dense",
        "destination-atop",
        "destination-in",
        "destination-out",
        "destination-over",
        "devanagari",
        "difference",
        "disc",
        "discard",
        "disclosure-closed",
        "disclosure-open",
        "document",
        "dot-dash",
        "dot-dot-dash",
        "dotted",
        "double",
        "down",
        "drop-shadow",
        "e-resize",
        "ease",
        "ease-in",
        "ease-in-out",
        "ease-out",
        "element",
        "ellipse",
        "ellipsis",
        "embed",
        "end",
        "ethiopic",
        "ethiopic-abegede",
        "ethiopic-abegede-am-et",
        "ethiopic-abegede-gez",
        "ethiopic-abegede-ti-er",
        "ethiopic-abegede-ti-et",
        "ethiopic-halehame-aa-er",
        "ethiopic-halehame-aa-et",
        "ethiopic-halehame-am-et",
        "ethiopic-halehame-gez",
        "ethiopic-halehame-om-et",
        "ethiopic-halehame-sid-et",
        "ethiopic-halehame-so-et",
        "ethiopic-halehame-ti-er",
        "ethiopic-halehame-ti-et",
        "ethiopic-halehame-tig",
        "ethiopic-numeric",
        "ew-resize",
        "exclusion",
        "expanded",
        "extends",
        "extra-condensed",
        "extra-expanded",
        "fantasy",
        "fast",
        "fill",
        "fill-box",
        "fixed",
        "flat",
        "flex",
        "flex-end",
        "flex-start",
        "footnotes",
        "forwards",
        "from",
        "geometricPrecision",
        "georgian",
        "grayscale",
        "graytext",
        "grid",
        "groove",
        "gujarati",
        "gurmukhi",
        "hand",
        "hangul",
        "hangul-consonant",
        "hard-light",
        "hebrew",
        "help",
        "hidden",
        "hide",
        "higher",
        "highlight",
        "highlighttext",
        "hiragana",
        "hiragana-iroha",
        "horizontal",
        "hsl",
        "hsla",
        "hue",
        "hue-rotate",
        "icon",
        "ignore",
        "inactiveborder",
        "inactivecaption",
        "inactivecaptiontext",
        "infinite",
        "infobackground",
        "infotext",
        "inherit",
        "initial",
        "inline",
        "inline-axis",
        "inline-block",
        "inline-flex",
        "inline-grid",
        "inline-table",
        "inset",
        "inside",
        "intrinsic",
        "invert",
        "italic",
        "japanese-formal",
        "japanese-informal",
        "justify",
        "kannada",
        "katakana",
        "katakana-iroha",
        "keep-all",
        "khmer",
        "korean-hangul-formal",
        "korean-hanja-formal",
        "korean-hanja-informal",
        "landscape",
        "lao",
        "large",
        "larger",
        "left",
        "level",
        "lighter",
        "lighten",
        "line-through",
        "linear",
        "linear-gradient",
        "lines",
        "list-item",
        "listbox",
        "listitem",
        "local",
        "logical",
        "loud",
        "lower",
        "lower-alpha",
        "lower-armenian",
        "lower-greek",
        "lower-hexadecimal",
        "lower-latin",
        "lower-norwegian",
        "lower-roman",
        "lowercase",
        "ltr",
        "luminosity",
        "malayalam",
        "manipulation",
        "match",
        "matrix",
        "matrix3d",
        "media-controls-background",
        "media-current-time-display",
        "media-fullscreen-button",
        "media-mute-button",
        "media-play-button",
        "media-return-to-realtime-button",
        "media-rewind-button",
        "media-seek-back-button",
        "media-seek-forward-button",
        "media-slider",
        "media-sliderthumb",
        "media-time-remaining-display",
        "media-volume-slider",
        "media-volume-slider-container",
        "media-volume-sliderthumb",
        "medium",
        "menu",
        "menulist",
        "menulist-button",
        "menulist-text",
        "menulist-textfield",
        "menutext",
        "message-box",
        "middle",
        "min-intrinsic",
        "mix",
        "mongolian",
        "monospace",
        "move",
        "multiple",
        "multiple_mask_images",
        "multiply",
        "myanmar",
        "n-resize",
        "narrower",
        "ne-resize",
        "nesw-resize",
        "no-close-quote",
        "no-drop",
        "no-open-quote",
        "no-repeat",
        "none",
        "normal",
        "not-allowed",
        "nowrap",
        "ns-resize",
        "numbers",
        "numeric",
        "nw-resize",
        "nwse-resize",
        "oblique",
        "octal",
        "opacity",
        "open-quote",
        "optimizeLegibility",
        "optimizeSpeed",
        "oriya",
        "oromo",
        "outset",
        "outside",
        "outside-shape",
        "overlay",
        "overline",
        "padding",
        "padding-box",
        "painted",
        "page",
        "paused",
        "persian",
        "perspective",
        "pinch-zoom",
        "plus-darker",
        "plus-lighter",
        "pointer",
        "polygon",
        "portrait",
        "pre",
        "pre-line",
        "pre-wrap",
        "preserve-3d",
        "progress",
        "push-button",
        "radial-gradient",
        "radio",
        "read-only",
        "read-write",
        "read-write-plaintext-only",
        "rectangle",
        "region",
        "relative",
        "repeat",
        "repeating-linear-gradient",
        "repeating-radial-gradient",
        "repeat-x",
        "repeat-y",
        "reset",
        "reverse",
        "rgb",
        "rgba",
        "ridge",
        "right",
        "rotate",
        "rotate3d",
        "rotateX",
        "rotateY",
        "rotateZ",
        "round",
        "row",
        "row-resize",
        "row-reverse",
        "rtl",
        "run-in",
        "running",
        "s-resize",
        "sans-serif",
        "saturate",
        "saturation",
        "scale",
        "scale3d",
        "scaleX",
        "scaleY",
        "scaleZ",
        "screen",
        "scroll",
        "scrollbar",
        "scroll-position",
        "se-resize",
        "searchfield",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "self-start",
        "self-end",
        "semi-condensed",
        "semi-expanded",
        "separate",
        "sepia",
        "serif",
        "show",
        "sidama",
        "simp-chinese-formal",
        "simp-chinese-informal",
        "single",
        "skew",
        "skewX",
        "skewY",
        "skip-white-space",
        "slide",
        "slider-horizontal",
        "slider-vertical",
        "sliderthumb-horizontal",
        "sliderthumb-vertical",
        "slow",
        "small",
        "small-caps",
        "small-caption",
        "smaller",
        "soft-light",
        "solid",
        "somali",
        "source-atop",
        "source-in",
        "source-out",
        "source-over",
        "space",
        "space-around",
        "space-between",
        "space-evenly",
        "spell-out",
        "square",
        "square-button",
        "start",
        "static",
        "status-bar",
        "stretch",
        "stroke",
        "stroke-box",
        "sub",
        "subpixel-antialiased",
        "svg_masks",
        "super",
        "sw-resize",
        "symbolic",
        "symbols",
        "system-ui",
        "table",
        "table-caption",
        "table-cell",
        "table-column",
        "table-column-group",
        "table-footer-group",
        "table-header-group",
        "table-row",
        "table-row-group",
        "tamil",
        "telugu",
        "text",
        "text-bottom",
        "text-top",
        "textarea",
        "textfield",
        "thai",
        "thick",
        "thin",
        "threeddarkshadow",
        "threedface",
        "threedhighlight",
        "threedlightshadow",
        "threedshadow",
        "tibetan",
        "tigre",
        "tigrinya-er",
        "tigrinya-er-abegede",
        "tigrinya-et",
        "tigrinya-et-abegede",
        "to",
        "top",
        "trad-chinese-formal",
        "trad-chinese-informal",
        "transform",
        "translate",
        "translate3d",
        "translateX",
        "translateY",
        "translateZ",
        "transparent",
        "ultra-condensed",
        "ultra-expanded",
        "underline",
        "unidirectional-pan",
        "unset",
        "up",
        "upper-alpha",
        "upper-armenian",
        "upper-greek",
        "upper-hexadecimal",
        "upper-latin",
        "upper-norwegian",
        "upper-roman",
        "uppercase",
        "urdu",
        "url",
        "var",
        "vertical",
        "vertical-text",
        "view-box",
        "visible",
        "visibleFill",
        "visiblePainted",
        "visibleStroke",
        "visual",
        "w-resize",
        "wait",
        "wave",
        "wider",
        "window",
        "windowframe",
        "windowtext",
        "words",
        "wrap",
        "wrap-reverse",
        "x-large",
        "x-small",
        "xor",
        "xx-large",
        "xx-small"
    ], valueKeywords = keySet(valueKeywords_);
    var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_).concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_).concat(valueKeywords_);
    CodeMirror1.registerHelper("hintWords", "css", allWords);
    CodeMirror1.defineMIME("text/css", {
        documentTypes: documentTypes,
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        fontProperties: fontProperties,
        counterDescriptors: counterDescriptors,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        tokenHooks: {
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
        },
        name: "css"
    });
    CodeMirror1.defineMIME("text/x-scss", {
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        fontProperties: fontProperties,
        allowNested: true,
        lineComment: "//",
        tokenHooks: {
            "/": function(stream, state) {
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return [
                        "comment",
                        "comment"
                    ];
                } else if (stream.eat("*")) {
                    state.tokenize = tokenCComment;
                    return tokenCComment(stream, state);
                } else {
                    return [
                        "operator",
                        "operator"
                    ];
                }
            },
            ":": function(stream) {
                if (stream.match(/^\s*\{/, false)) return [
                    null,
                    null
                ];
                return false;
            },
            "$": function(stream) {
                stream.match(/^[\w-]+/);
                if (stream.match(/^\s*:/, false)) return [
                    "variable-2",
                    "variable-definition"
                ];
                return [
                    "variable-2",
                    "variable"
                ];
            },
            "#": function(stream) {
                if (!stream.eat("{")) return false;
                return [
                    null,
                    "interpolation"
                ];
            }
        },
        name: "css",
        helperType: "scss"
    });
    CodeMirror1.defineMIME("text/x-less", {
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        mediaValueKeywords: mediaValueKeywords,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        fontProperties: fontProperties,
        allowNested: true,
        lineComment: "//",
        tokenHooks: {
            "/": function(stream, state) {
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return [
                        "comment",
                        "comment"
                    ];
                } else if (stream.eat("*")) {
                    state.tokenize = tokenCComment;
                    return tokenCComment(stream, state);
                } else {
                    return [
                        "operator",
                        "operator"
                    ];
                }
            },
            "@": function(stream) {
                if (stream.eat("{")) return [
                    null,
                    "interpolation"
                ];
                if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
                stream.eatWhile(/[\w\\\-]/);
                if (stream.match(/^\s*:/, false)) return [
                    "variable-2",
                    "variable-definition"
                ];
                return [
                    "variable-2",
                    "variable"
                ];
            },
            "&": function() {
                return [
                    "atom",
                    "atom"
                ];
            }
        },
        name: "css",
        helperType: "less"
    });
    CodeMirror1.defineMIME("text/x-gss", {
        documentTypes: documentTypes,
        mediaTypes: mediaTypes,
        mediaFeatures: mediaFeatures,
        propertyKeywords: propertyKeywords,
        nonStandardPropertyKeywords: nonStandardPropertyKeywords,
        fontProperties: fontProperties,
        counterDescriptors: counterDescriptors,
        colorKeywords: colorKeywords,
        valueKeywords: valueKeywords,
        supportsAtComponent: true,
        tokenHooks: {
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
        },
        name: "css",
        helperType: "gss"
    });
});
});

var dart = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, clike);
})(function(CodeMirror1) {
    var set = function set(words) {
        var obj = {};
        for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
        return obj;
    };
    var pushInterpolationStack = function pushInterpolationStack(state) {
        (state.interpolationStack || (state.interpolationStack = [])).push(state.tokenize);
    };
    var popInterpolationStack = function popInterpolationStack(state) {
        return (state.interpolationStack || (state.interpolationStack = [])).pop();
    };
    var sizeInterpolationStack = function sizeInterpolationStack(state) {
        return state.interpolationStack ? state.interpolationStack.length : 0;
    };
    var tokenString = function tokenString(quote, stream, state, raw) {
        var tripleQuoted = false;
        if (stream.eat(quote)) {
            if (stream.eat(quote)) tripleQuoted = true;
            else return "string"; //empty string
        }
        function tokenStringHelper(stream, state) {
            var escaped = false;
            while(!stream.eol()){
                if (!raw && !escaped && stream.peek() == "$") {
                    pushInterpolationStack(state);
                    state.tokenize = tokenInterpolation;
                    return "string";
                }
                var next = stream.next();
                if (next == quote && !escaped && (!tripleQuoted || stream.match(quote + quote))) {
                    state.tokenize = null;
                    break;
                }
                escaped = !raw && !escaped && next == "\\";
            }
            return "string";
        }
        state.tokenize = tokenStringHelper;
        return tokenStringHelper(stream, state);
    };
    var tokenInterpolation = function tokenInterpolation(stream, state) {
        stream.eat("$");
        if (stream.eat("{")) {
            // let clike handle the content of ${...},
            // we take over again when "}" appears (see hooks).
            state.tokenize = null;
        } else {
            state.tokenize = tokenInterpolationIdentifier;
        }
        return null;
    };
    var tokenInterpolationIdentifier = function tokenInterpolationIdentifier(stream, state) {
        stream.eatWhile(/[\w_]/);
        state.tokenize = popInterpolationStack(state);
        return "variable";
    };
    var keywords = ("this super static final const abstract class extends external factory " + "implements mixin get native set typedef with enum throw rethrow " + "assert break case continue default in return new deferred async await covariant " + "try catch finally do else for if switch while import library export " + "part of show hide is as extension on yield late required").split(" ");
    var blockKeywords = "try catch finally do else for if switch while".split(" ");
    var atoms = "true false null".split(" ");
    var builtins = "void bool num int double dynamic var String Null Never".split(" ");
    CodeMirror1.defineMIME("application/dart", {
        name: "clike",
        keywords: set(keywords),
        blockKeywords: set(blockKeywords),
        builtin: set(builtins),
        atoms: set(atoms),
        hooks: {
            "@": function(stream) {
                stream.eatWhile(/[\w\$_\.]/);
                return "meta";
            },
            // custom string handling to deal with triple-quoted strings and string interpolation
            "'": function(stream, state) {
                return tokenString("'", stream, state, false);
            },
            '"': function(stream, state) {
                return tokenString('"', stream, state, false);
            },
            "r": function(stream, state) {
                var peek = stream.peek();
                if (peek == "'" || peek == '"') {
                    return tokenString(stream.next(), stream, state, true);
                }
                return false;
            },
            "}": function(_stream, state) {
                // "}" is end of interpolation, if interpolation stack is non-empty
                if (sizeInterpolationStack(state) > 0) {
                    state.tokenize = popInterpolationStack(state);
                    return null;
                }
                return false;
            },
            "/": function(stream, state) {
                if (!stream.eat("*")) return false;
                state.tokenize = tokenNestedComment(1);
                return state.tokenize(stream, state);
            },
            token: function token(stream, _, style) {
                if (style == "variable") {
                    // Assume uppercase symbols are classes using variable-2
                    var isUpper = RegExp("^[_$]*[A-Z][a-zA-Z0-9_$]*$", "g");
                    if (isUpper.test(stream.current())) {
                        return "variable-2";
                    }
                }
            }
        }
    });
    function tokenNestedComment(depth) {
        return function(stream, state) {
            var ch;
            while(ch = stream.next()){
                if (ch == "*" && stream.eat("/")) {
                    if (depth == 1) {
                        state.tokenize = null;
                        break;
                    } else {
                        state.tokenize = tokenNestedComment(depth - 1);
                        return state.tokenize(stream, state);
                    }
                } else if (ch == "/" && stream.eat("*")) {
                    state.tokenize = tokenNestedComment(depth + 1);
                    return state.tokenize(stream, state);
                }
            }
            return "comment";
        };
    }
    CodeMirror1.registerHelper("hintWords", "application/dart", keywords.concat(atoms).concat(builtins));
    // This is needed to make loading through meta.js work.
    CodeMirror1.defineMode("dart", function(conf) {
        return CodeMirror1.getMode(conf, "application/dart");
    }, "clike");
});
});

var elm = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("elm", function() {
        var switchState = function switchState(source, setState, f) {
            setState(f);
            return f(source, setState);
        };
        var normal = function normal() {
            return function(source, setState) {
                if (source.eatWhile(spacesRE)) {
                    return null;
                }
                var char = source.next();
                if (specialRE.test(char)) {
                    return char === "{" && source.eat("-") ? switchState(source, setState, chompMultiComment(1)) : char === "[" && source.match("glsl|") ? switchState(source, setState, chompGlsl) : "builtin";
                }
                if (char === "'") {
                    return switchState(source, setState, chompChar);
                }
                if (char === '"') {
                    return source.eat('"') ? source.eat('"') ? switchState(source, setState, chompMultiString) : "string" : switchState(source, setState, chompSingleString);
                }
                if (upperRE.test(char)) {
                    source.eatWhile(innerRE);
                    return "variable-2";
                }
                if (lowerRE.test(char)) {
                    var isDef = source.pos === 1;
                    source.eatWhile(innerRE);
                    return isDef ? "def" : "variable";
                }
                if (digitRE.test(char)) {
                    if (char === "0") {
                        if (source.eat(/[xX]/)) {
                            source.eatWhile(hexRE); // should require at least 1
                            return "number";
                        }
                    } else {
                        source.eatWhile(digitRE);
                    }
                    if (source.eat(".")) {
                        source.eatWhile(digitRE); // should require at least 1
                    }
                    if (source.eat(/[eE]/)) {
                        source.eat(/[-+]/);
                        source.eatWhile(digitRE); // should require at least 1
                    }
                    return "number";
                }
                if (symbolRE.test(char)) {
                    if (char === "-" && source.eat("-")) {
                        source.skipToEnd();
                        return "comment";
                    }
                    source.eatWhile(symbolRE);
                    return "keyword";
                }
                if (char === "_") {
                    return "keyword";
                }
                return "error";
            };
        };
        var chompMultiString = function chompMultiString(source, setState) {
            while(!source.eol()){
                var char = source.next();
                if (char === '"' && source.eat('"') && source.eat('"')) {
                    setState(normal());
                    return "string";
                }
            }
            return "string";
        };
        var chompSingleString = function chompSingleString(source, setState) {
            while(source.skipTo('\\"')){
                source.next();
                source.next();
            }
            if (source.skipTo('"')) {
                source.next();
                setState(normal());
                return "string";
            }
            source.skipToEnd();
            setState(normal());
            return "error";
        };
        var chompChar = function chompChar(source, setState) {
            while(source.skipTo("\\'")){
                source.next();
                source.next();
            }
            if (source.skipTo("'")) {
                source.next();
                setState(normal());
                return "string";
            }
            source.skipToEnd();
            setState(normal());
            return "error";
        };
        var chompGlsl = function chompGlsl(source, setState) {
            while(!source.eol()){
                var char = source.next();
                if (char === "|" && source.eat("]")) {
                    setState(normal());
                    return "string";
                }
            }
            return "string";
        };
        var lowerRE = /[a-z]/;
        var upperRE = /[A-Z]/;
        var innerRE = /[a-zA-Z0-9_]/;
        var digitRE = /[0-9]/;
        var hexRE = /[0-9A-Fa-f]/;
        var symbolRE = /[-&*+.\\/<>=?^|:]/;
        var specialRE = /[(),[\]{}]/;
        var spacesRE = /[ \v\f]/; // newlines are handled in tokenizer
        function chompMultiComment(nest) {
            if (nest == 0) {
                return normal();
            }
            return function(source, setState) {
                while(!source.eol()){
                    var char = source.next();
                    if (char == "{" && source.eat("-")) {
                        ++nest;
                    } else if (char == "-" && source.eat("}")) {
                        --nest;
                        if (nest === 0) {
                            setState(normal());
                            return "comment";
                        }
                    }
                }
                setState(chompMultiComment(nest));
                return "comment";
            };
        }
        var wellKnownWords = {
            case: 1,
            of: 1,
            as: 1,
            if: 1,
            then: 1,
            else: 1,
            let: 1,
            in: 1,
            type: 1,
            alias: 1,
            module: 1,
            where: 1,
            import: 1,
            exposing: 1,
            port: 1
        };
        return {
            startState: function startState() {
                return {
                    f: normal()
                };
            },
            copyState: function copyState(s) {
                return {
                    f: s.f
                };
            },
            token: function token(stream, state) {
                var type = state.f(stream, function(s) {
                    state.f = s;
                });
                var word = stream.current();
                return wellKnownWords.hasOwnProperty(word) ? "keyword" : type;
            }
        };
    });
    CodeMirror1.defineMIME("text/x-elm", "elm");
});
});

var go = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("go", function(config) {
        var tokenBase = function tokenBase(stream, state) {
            var ch = stream.next();
            if (ch == '"' || ch == "'" || ch == "`") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            }
            if (/[\d\.]/.test(ch)) {
                if (ch == ".") {
                    stream.match(/^[0-9]+([eE][\-+]?[0-9]+)?/);
                } else if (ch == "0") {
                    stream.match(/^[xX][0-9a-fA-F]+/) || stream.match(/^0[0-7]+/);
                } else {
                    stream.match(/^[0-9]*\.?[0-9]*([eE][\-+]?[0-9]+)?/);
                }
                return "number";
            }
            if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
                curPunc = ch;
                return null;
            }
            if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize = tokenComment;
                    return tokenComment(stream, state);
                }
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return "comment";
                }
            }
            if (isOperatorChar.test(ch)) {
                stream.eatWhile(isOperatorChar);
                return "operator";
            }
            stream.eatWhile(/[\w\$_\xa1-\uffff]/);
            var cur = stream.current();
            if (keywords.propertyIsEnumerable(cur)) {
                if (cur == "case" || cur == "default") curPunc = "case";
                return "keyword";
            }
            if (atoms.propertyIsEnumerable(cur)) return "atom";
            return "variable";
        };
        var tokenString = function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, next, end = false;
                while((next = stream.next()) != null){
                    if (next == quote && !escaped) {
                        end = true;
                        break;
                    }
                    escaped = !escaped && quote != "`" && next == "\\";
                }
                if (end || !(escaped || quote == "`")) state.tokenize = tokenBase;
                return "string";
            };
        };
        var tokenComment = function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while(ch = stream.next()){
                if (ch == "/" && maybeEnd) {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return "comment";
        };
        var Context = function Context(indented, column, type, align, prev) {
            this.indented = indented;
            this.column = column;
            this.type = type;
            this.align = align;
            this.prev = prev;
        };
        var pushContext = function pushContext(state, col, type) {
            return state.context = new Context(state.indented, col, type, null, state.context);
        };
        var popContext = function popContext(state) {
            if (!state.context.prev) return;
            var t = state.context.type;
            if (t == ")" || t == "]" || t == "}") state.indented = state.context.indented;
            return state.context = state.context.prev;
        };
        var indentUnit = config.indentUnit;
        var keywords = {
            "break": true,
            "case": true,
            "chan": true,
            "const": true,
            "continue": true,
            "default": true,
            "defer": true,
            "else": true,
            "fallthrough": true,
            "for": true,
            "func": true,
            "go": true,
            "goto": true,
            "if": true,
            "import": true,
            "interface": true,
            "map": true,
            "package": true,
            "range": true,
            "return": true,
            "select": true,
            "struct": true,
            "switch": true,
            "type": true,
            "var": true,
            "bool": true,
            "byte": true,
            "complex64": true,
            "complex128": true,
            "float32": true,
            "float64": true,
            "int8": true,
            "int16": true,
            "int32": true,
            "int64": true,
            "string": true,
            "uint8": true,
            "uint16": true,
            "uint32": true,
            "uint64": true,
            "int": true,
            "uint": true,
            "uintptr": true,
            "error": true,
            "rune": true
        };
        var atoms = {
            "true": true,
            "false": true,
            "iota": true,
            "nil": true,
            "append": true,
            "cap": true,
            "close": true,
            "complex": true,
            "copy": true,
            "delete": true,
            "imag": true,
            "len": true,
            "make": true,
            "new": true,
            "panic": true,
            "print": true,
            "println": true,
            "real": true,
            "recover": true
        };
        var isOperatorChar = /[+\-*&^%:=<>!|\/]/;
        var curPunc;
        // Interface
        return {
            startState: function startState(basecolumn) {
                return {
                    tokenize: null,
                    context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
                    indented: 0,
                    startOfLine: true
                };
            },
            token: function token(stream, state) {
                var ctx = state.context;
                if (stream.sol()) {
                    if (ctx.align == null) ctx.align = false;
                    state.indented = stream.indentation();
                    state.startOfLine = true;
                    if (ctx.type == "case") ctx.type = "}";
                }
                if (stream.eatSpace()) return null;
                curPunc = null;
                var style = (state.tokenize || tokenBase)(stream, state);
                if (style == "comment") return style;
                if (ctx.align == null) ctx.align = true;
                if (curPunc == "{") pushContext(state, stream.column(), "}");
                else if (curPunc == "[") pushContext(state, stream.column(), "]");
                else if (curPunc == "(") pushContext(state, stream.column(), ")");
                else if (curPunc == "case") ctx.type = "case";
                else if (curPunc == "}" && ctx.type == "}") popContext(state);
                else if (curPunc == ctx.type) popContext(state);
                state.startOfLine = false;
                return style;
            },
            indent: function indent(state, textAfter) {
                if (state.tokenize != tokenBase && state.tokenize != null) return CodeMirror1.Pass;
                var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
                if (ctx.type == "case" && /^(?:case|default)\b/.test(textAfter)) {
                    state.context.type = "}";
                    return ctx.indented;
                }
                var closing = firstChar == ctx.type;
                if (ctx.align) return ctx.column + (closing ? 0 : 1);
                else return ctx.indented + (closing ? 0 : indentUnit);
            },
            electricChars: "{}):",
            closeBrackets: "()[]{}''\"\"``",
            fold: "brace",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            lineComment: "//"
        };
    });
    CodeMirror1.defineMIME("text/x-go", "go");
});
});

var groovy = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("groovy", function(config) {
        var words = function words(str) {
            var obj = {}, words = str.split(" ");
            for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
            return obj;
        };
        var tokenBase = function tokenBase(stream, state) {
            var ch = stream.next();
            if (ch == '"' || ch == "'") {
                return startString(ch, stream, state);
            }
            if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
                curPunc = ch;
                return null;
            }
            if (/\d/.test(ch)) {
                stream.eatWhile(/[\w\.]/);
                if (stream.eat(/eE/)) {
                    stream.eat(/\+\-/);
                    stream.eatWhile(/\d/);
                }
                return "number";
            }
            if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize.push(tokenComment);
                    return tokenComment(stream, state);
                }
                if (stream.eat("/")) {
                    stream.skipToEnd();
                    return "comment";
                }
                if (expectExpression(state.lastToken, false)) {
                    return startString(ch, stream, state);
                }
            }
            if (ch == "-" && stream.eat(">")) {
                curPunc = "->";
                return null;
            }
            if (/[+\-*&%=<>!?|\/~]/.test(ch)) {
                stream.eatWhile(/[+\-*&%=<>|~]/);
                return "operator";
            }
            stream.eatWhile(/[\w\$_]/);
            if (ch == "@") {
                stream.eatWhile(/[\w\$_\.]/);
                return "meta";
            }
            if (state.lastToken == ".") return "property";
            if (stream.eat(":")) {
                curPunc = "proplabel";
                return "property";
            }
            var cur = stream.current();
            if (atoms.propertyIsEnumerable(cur)) {
                return "atom";
            }
            if (keywords.propertyIsEnumerable(cur)) {
                if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
                else if (standaloneKeywords.propertyIsEnumerable(cur)) curPunc = "standalone";
                return "keyword";
            }
            return "variable";
        };
        var startString = function startString(quote, stream, state) {
            var tripleQuoted = false;
            if (quote != "/" && stream.eat(quote)) {
                if (stream.eat(quote)) tripleQuoted = true;
                else return "string";
            }
            function t(stream, state) {
                var escaped = false, next, end = !tripleQuoted;
                while((next = stream.next()) != null){
                    if (next == quote && !escaped) {
                        if (!tripleQuoted) {
                            break;
                        }
                        if (stream.match(quote + quote)) {
                            end = true;
                            break;
                        }
                    }
                    if (quote == '"' && next == "$" && !escaped && stream.eat("{")) {
                        state.tokenize.push(tokenBaseUntilBrace());
                        return "string";
                    }
                    escaped = !escaped && next == "\\";
                }
                if (end) state.tokenize.pop();
                return "string";
            }
            state.tokenize.push(t);
            return t(stream, state);
        };
        var tokenBaseUntilBrace = function tokenBaseUntilBrace() {
            var depth = 1;
            function t(stream, state) {
                if (stream.peek() == "}") {
                    depth--;
                    if (depth == 0) {
                        state.tokenize.pop();
                        return state.tokenize[state.tokenize.length - 1](stream, state);
                    }
                } else if (stream.peek() == "{") {
                    depth++;
                }
                return tokenBase(stream, state);
            }
            t.isBase = true;
            return t;
        };
        var tokenComment = function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while(ch = stream.next()){
                if (ch == "/" && maybeEnd) {
                    state.tokenize.pop();
                    break;
                }
                maybeEnd = ch == "*";
            }
            return "comment";
        };
        var expectExpression = function expectExpression(last, newline) {
            return !last || last == "operator" || last == "->" || /[\.\[\{\(,;:]/.test(last) || last == "newstatement" || last == "keyword" || last == "proplabel" || last == "standalone" && !newline;
        };
        var Context = function Context(indented, column, type, align, prev) {
            this.indented = indented;
            this.column = column;
            this.type = type;
            this.align = align;
            this.prev = prev;
        };
        var pushContext = function pushContext(state, col, type) {
            return state.context = new Context(state.indented, col, type, null, state.context);
        };
        var popContext = function popContext(state) {
            var t = state.context.type;
            if (t == ")" || t == "]" || t == "}") state.indented = state.context.indented;
            return state.context = state.context.prev;
        };
        var keywords = words("abstract as assert boolean break byte case catch char class const continue def default " + "do double else enum extends final finally float for goto if implements import in " + "instanceof int interface long native new package private protected public return " + "short static strictfp super switch synchronized threadsafe throw throws trait transient " + "try void volatile while");
        var blockKeywords = words("catch class def do else enum finally for if interface switch trait try while");
        var standaloneKeywords = words("return break continue");
        var atoms = words("null true false this");
        var curPunc;
        tokenBase.isBase = true;
        // Interface
        return {
            startState: function startState(basecolumn) {
                return {
                    tokenize: [
                        tokenBase
                    ],
                    context: new Context((basecolumn || 0) - config.indentUnit, 0, "top", false),
                    indented: 0,
                    startOfLine: true,
                    lastToken: null
                };
            },
            token: function token(stream, state) {
                var ctx = state.context;
                if (stream.sol()) {
                    if (ctx.align == null) ctx.align = false;
                    state.indented = stream.indentation();
                    state.startOfLine = true;
                    // Automatic semicolon insertion
                    if (ctx.type == "statement" && !expectExpression(state.lastToken, true)) {
                        popContext(state);
                        ctx = state.context;
                    }
                }
                if (stream.eatSpace()) return null;
                curPunc = null;
                var style = state.tokenize[state.tokenize.length - 1](stream, state);
                if (style == "comment") return style;
                if (ctx.align == null) ctx.align = true;
                if ((curPunc == ";" || curPunc == ":") && ctx.type == "statement") popContext(state);
                else if (curPunc == "->" && ctx.type == "statement" && ctx.prev.type == "}") {
                    popContext(state);
                    state.context.align = false;
                } else if (curPunc == "{") pushContext(state, stream.column(), "}");
                else if (curPunc == "[") pushContext(state, stream.column(), "]");
                else if (curPunc == "(") pushContext(state, stream.column(), ")");
                else if (curPunc == "}") {
                    while(ctx.type == "statement")ctx = popContext(state);
                    if (ctx.type == "}") ctx = popContext(state);
                    while(ctx.type == "statement")ctx = popContext(state);
                } else if (curPunc == ctx.type) popContext(state);
                else if (ctx.type == "}" || ctx.type == "top" || ctx.type == "statement" && curPunc == "newstatement") pushContext(state, stream.column(), "statement");
                state.startOfLine = false;
                state.lastToken = curPunc || style;
                return style;
            },
            indent: function indent(state, textAfter) {
                if (!state.tokenize[state.tokenize.length - 1].isBase) return CodeMirror1.Pass;
                var firstChar = textAfter && textAfter.charAt(0), ctx = state.context;
                if (ctx.type == "statement" && !expectExpression(state.lastToken, true)) ctx = ctx.prev;
                var closing = firstChar == ctx.type;
                if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : config.indentUnit);
                else if (ctx.align) return ctx.column + (closing ? 0 : 1);
                else return ctx.indented + (closing ? 0 : config.indentUnit);
            },
            electricChars: "{}",
            closeBrackets: {
                triples: "'\""
            },
            fold: "brace",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            lineComment: "//"
        };
    });
    CodeMirror1.defineMIME("text/x-groovy", "groovy");
});
});

var xml = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var htmlConfig = {
        autoSelfClosers: {
            "area": true,
            "base": true,
            "br": true,
            "col": true,
            "command": true,
            "embed": true,
            "frame": true,
            "hr": true,
            "img": true,
            "input": true,
            "keygen": true,
            "link": true,
            "meta": true,
            "param": true,
            "source": true,
            "track": true,
            "wbr": true,
            "menuitem": true
        },
        implicitlyClosed: {
            "dd": true,
            "li": true,
            "optgroup": true,
            "option": true,
            "p": true,
            "rp": true,
            "rt": true,
            "tbody": true,
            "td": true,
            "tfoot": true,
            "th": true,
            "tr": true
        },
        contextGrabbers: {
            "dd": {
                "dd": true,
                "dt": true
            },
            "dt": {
                "dd": true,
                "dt": true
            },
            "li": {
                "li": true
            },
            "option": {
                "option": true,
                "optgroup": true
            },
            "optgroup": {
                "optgroup": true
            },
            "p": {
                "address": true,
                "article": true,
                "aside": true,
                "blockquote": true,
                "dir": true,
                "div": true,
                "dl": true,
                "fieldset": true,
                "footer": true,
                "form": true,
                "h1": true,
                "h2": true,
                "h3": true,
                "h4": true,
                "h5": true,
                "h6": true,
                "header": true,
                "hgroup": true,
                "hr": true,
                "menu": true,
                "nav": true,
                "ol": true,
                "p": true,
                "pre": true,
                "section": true,
                "table": true,
                "ul": true
            },
            "rp": {
                "rp": true,
                "rt": true
            },
            "rt": {
                "rp": true,
                "rt": true
            },
            "tbody": {
                "tbody": true,
                "tfoot": true
            },
            "td": {
                "td": true,
                "th": true
            },
            "tfoot": {
                "tbody": true
            },
            "th": {
                "td": true,
                "th": true
            },
            "thead": {
                "tbody": true,
                "tfoot": true
            },
            "tr": {
                "tr": true
            }
        },
        doNotIndent: {
            "pre": true
        },
        allowUnquoted: true,
        allowMissing: true,
        caseFold: true
    };
    var xmlConfig = {
        autoSelfClosers: {},
        implicitlyClosed: {},
        contextGrabbers: {},
        doNotIndent: {},
        allowUnquoted: false,
        allowMissing: false,
        allowMissingTagName: false,
        caseFold: false
    };
    CodeMirror1.defineMode("xml", function(editorConf, config_) {
        var inText = function inText(stream, state) {
            function chain(parser) {
                state.tokenize = parser;
                return parser(stream, state);
            }
            var ch = stream.next();
            if (ch == "<") {
                if (stream.eat("!")) {
                    if (stream.eat("[")) {
                        if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
                        else return null;
                    } else if (stream.match("--")) {
                        return chain(inBlock("comment", "-->"));
                    } else if (stream.match("DOCTYPE", true, true)) {
                        stream.eatWhile(/[\w\._\-]/);
                        return chain(doctype(1));
                    } else {
                        return null;
                    }
                } else if (stream.eat("?")) {
                    stream.eatWhile(/[\w\._\-]/);
                    state.tokenize = inBlock("meta", "?>");
                    return "meta";
                } else {
                    type = stream.eat("/") ? "closeTag" : "openTag";
                    state.tokenize = inTag;
                    return "tag bracket";
                }
            } else if (ch == "&") {
                var ok;
                if (stream.eat("#")) {
                    if (stream.eat("x")) {
                        ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
                    } else {
                        ok = stream.eatWhile(/[\d]/) && stream.eat(";");
                    }
                } else {
                    ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
                }
                return ok ? "atom" : "error";
            } else {
                stream.eatWhile(/[^&<]/);
                return null;
            }
        };
        var inTag = function inTag(stream, state) {
            var ch = stream.next();
            if (ch == ">" || ch == "/" && stream.eat(">")) {
                state.tokenize = inText;
                type = ch == ">" ? "endTag" : "selfcloseTag";
                return "tag bracket";
            } else if (ch == "=") {
                type = "equals";
                return null;
            } else if (ch == "<") {
                state.tokenize = inText;
                state.state = baseState;
                state.tagName = state.tagStart = null;
                var next = state.tokenize(stream, state);
                return next ? next + " tag error" : "tag error";
            } else if (/[\'\"]/.test(ch)) {
                state.tokenize = inAttribute(ch);
                state.stringStartCol = stream.column();
                return state.tokenize(stream, state);
            } else {
                stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
                return "word";
            }
        };
        var inAttribute = function inAttribute(quote) {
            var closure = function closure(stream, state) {
                while(!stream.eol()){
                    if (stream.next() == quote) {
                        state.tokenize = inTag;
                        break;
                    }
                }
                return "string";
            };
            closure.isInAttribute = true;
            return closure;
        };
        var inBlock = function inBlock(style, terminator) {
            return function(stream, state) {
                while(!stream.eol()){
                    if (stream.match(terminator)) {
                        state.tokenize = inText;
                        break;
                    }
                    stream.next();
                }
                return style;
            };
        };
        var lower = function lower(tagName) {
            return tagName && tagName.toLowerCase();
        };
        var Context = function Context(state, tagName, startOfLine) {
            this.prev = state.context;
            this.tagName = tagName || "";
            this.indent = state.indented;
            this.startOfLine = startOfLine;
            if (config.doNotIndent.hasOwnProperty(tagName) || state.context && state.context.noIndent) this.noIndent = true;
        };
        var popContext = function popContext(state) {
            if (state.context) state.context = state.context.prev;
        };
        var maybePopContext = function maybePopContext(state, nextTagName) {
            var parentTagName;
            while(true){
                if (!state.context) {
                    return;
                }
                parentTagName = state.context.tagName;
                if (!config.contextGrabbers.hasOwnProperty(lower(parentTagName)) || !config.contextGrabbers[lower(parentTagName)].hasOwnProperty(lower(nextTagName))) {
                    return;
                }
                popContext(state);
            }
        };
        var closeTagNameState = function closeTagNameState(type, stream, state) {
            if (type == "word") {
                var tagName = stream.current();
                if (state.context && state.context.tagName != tagName && config.implicitlyClosed.hasOwnProperty(lower(state.context.tagName))) popContext(state);
                if (state.context && state.context.tagName == tagName || config.matchClosing === false) {
                    setStyle = "tag";
                    return closeState;
                } else {
                    setStyle = "tag error";
                    return closeStateErr;
                }
            } else if (config.allowMissingTagName && type == "endTag") {
                setStyle = "tag bracket";
                return closeState(type, stream, state);
            } else {
                setStyle = "error";
                return closeStateErr;
            }
        };
        var closeStateErr = function closeStateErr(type, stream, state) {
            setStyle = "error";
            return closeState(type, stream, state);
        };
        var attrEqState = function attrEqState(type, stream, state) {
            if (type == "equals") return attrValueState;
            if (!config.allowMissing) setStyle = "error";
            return attrState(type, stream, state);
        };
        var attrValueState = function attrValueState(type, stream, state) {
            if (type == "string") return attrContinuedState;
            if (type == "word" && config.allowUnquoted) {
                setStyle = "string";
                return attrState;
            }
            setStyle = "error";
            return attrState(type, stream, state);
        };
        var indentUnit = editorConf.indentUnit;
        var config = {};
        var defaults = config_.htmlMode ? htmlConfig : xmlConfig;
        for(var prop in defaults)config[prop] = defaults[prop];
        for(var prop in config_)config[prop] = config_[prop];
        // Return variables for tokenizers
        var type, setStyle;
        inText.isInText = true;
        function doctype(depth) {
            return function(stream, state) {
                var ch;
                while((ch = stream.next()) != null){
                    if (ch == "<") {
                        state.tokenize = doctype(depth + 1);
                        return state.tokenize(stream, state);
                    } else if (ch == ">") {
                        if (depth == 1) {
                            state.tokenize = inText;
                            break;
                        } else {
                            state.tokenize = doctype(depth - 1);
                            return state.tokenize(stream, state);
                        }
                    }
                }
                return "meta";
            };
        }
        function baseState(type, stream, state) {
            if (type == "openTag") {
                state.tagStart = stream.column();
                return tagNameState;
            } else if (type == "closeTag") {
                return closeTagNameState;
            } else {
                return baseState;
            }
        }
        function tagNameState(type, stream, state) {
            if (type == "word") {
                state.tagName = stream.current();
                setStyle = "tag";
                return attrState;
            } else if (config.allowMissingTagName && type == "endTag") {
                setStyle = "tag bracket";
                return attrState(type, stream, state);
            } else {
                setStyle = "error";
                return tagNameState;
            }
        }
        function closeState(type, _stream, state) {
            if (type != "endTag") {
                setStyle = "error";
                return closeState;
            }
            popContext(state);
            return baseState;
        }
        function attrState(type, _stream, state) {
            if (type == "word") {
                setStyle = "attribute";
                return attrEqState;
            } else if (type == "endTag" || type == "selfcloseTag") {
                var tagName = state.tagName, tagStart = state.tagStart;
                state.tagName = state.tagStart = null;
                if (type == "selfcloseTag" || config.autoSelfClosers.hasOwnProperty(lower(tagName))) {
                    maybePopContext(state, tagName);
                } else {
                    maybePopContext(state, tagName);
                    state.context = new Context(state, tagName, tagStart == state.indented);
                }
                return baseState;
            }
            setStyle = "error";
            return attrState;
        }
        function attrContinuedState(type, stream, state) {
            if (type == "string") return attrContinuedState;
            return attrState(type, stream, state);
        }
        return {
            startState: function startState(baseIndent) {
                var state = {
                    tokenize: inText,
                    state: baseState,
                    indented: baseIndent || 0,
                    tagName: null,
                    tagStart: null,
                    context: null
                };
                if (baseIndent != null) state.baseIndent = baseIndent;
                return state;
            },
            token: function token(stream, state) {
                if (!state.tagName && stream.sol()) state.indented = stream.indentation();
                if (stream.eatSpace()) return null;
                type = null;
                var style = state.tokenize(stream, state);
                if ((style || type) && style != "comment") {
                    setStyle = null;
                    state.state = state.state(type || style, stream, state);
                    if (setStyle) style = setStyle == "error" ? style + " error" : setStyle;
                }
                return style;
            },
            indent: function indent(state, textAfter, fullLine) {
                var context = state.context;
                // Indent multi-line strings (e.g. css).
                if (state.tokenize.isInAttribute) {
                    if (state.tagStart == state.indented) return state.stringStartCol + 1;
                    else return state.indented + indentUnit;
                }
                if (context && context.noIndent) return CodeMirror1.Pass;
                if (state.tokenize != inTag && state.tokenize != inText) return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
                // Indent the starts of attribute names.
                if (state.tagName) {
                    if (config.multilineTagIndentPastTag !== false) return state.tagStart + state.tagName.length + 2;
                    else return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
                }
                if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
                var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
                if (tagAfter && tagAfter[1]) {
                    while(context){
                        if (context.tagName == tagAfter[2]) {
                            context = context.prev;
                            break;
                        } else if (config.implicitlyClosed.hasOwnProperty(lower(context.tagName))) {
                            context = context.prev;
                        } else {
                            break;
                        }
                    }
                } else if (tagAfter) {
                    while(context){
                        var grabbers = config.contextGrabbers[lower(context.tagName)];
                        if (grabbers && grabbers.hasOwnProperty(lower(tagAfter[2]))) context = context.prev;
                        else break;
                    }
                }
                while(context && context.prev && !context.startOfLine)context = context.prev;
                if (context) return context.indent + indentUnit;
                else return state.baseIndent || 0;
            },
            electricInput: /<\/[\s\w:]+>$/,
            blockCommentStart: "<!--",
            blockCommentEnd: "-->",
            configuration: config.htmlMode ? "html" : "xml",
            helperType: config.htmlMode ? "html" : "xml",
            skipAttribute: function skipAttribute(state) {
                if (state.state == attrValueState) state.state = attrState;
            },
            xmlCurrentTag: function xmlCurrentTag(state) {
                return state.tagName ? {
                    name: state.tagName,
                    close: state.type == "closeTag"
                } : null;
            },
            xmlCurrentContext: function xmlCurrentContext(state) {
                var context = [];
                for(var cx = state.context; cx; cx = cx.prev)context.push(cx.tagName);
                return context.reverse();
            }
        };
    });
    CodeMirror1.defineMIME("text/xml", "xml");
    CodeMirror1.defineMIME("application/xml", "xml");
    if (!CodeMirror1.mimeModes.hasOwnProperty("text/html")) CodeMirror1.defineMIME("text/html", {
        name: "xml",
        htmlMode: true
    });
});
});

var javascript = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("javascript", function(config, parserConfig) {
        var readRegexp = function readRegexp(stream) {
            var escaped = false, next, inSet = false;
            while((next = stream.next()) != null){
                if (!escaped) {
                    if (next == "/" && !inSet) return;
                    if (next == "[") inSet = true;
                    else if (inSet && next == "]") inSet = false;
                }
                escaped = !escaped && next == "\\";
            }
        };
        var ret = function ret(tp, style, cont) {
            type = tp;
            content = cont;
            return style;
        };
        var tokenBase = function tokenBase(stream, state) {
            var ch = stream.next();
            if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
                return ret("number", "number");
            } else if (ch == "." && stream.match("..")) {
                return ret("spread", "meta");
            } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
                return ret(ch);
            } else if (ch == "=" && stream.eat(">")) {
                return ret("=>", "operator");
            } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
                return ret("number", "number");
            } else if (/\d/.test(ch)) {
                stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
                return ret("number", "number");
            } else if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize = tokenComment;
                    return tokenComment(stream, state);
                } else if (stream.eat("/")) {
                    stream.skipToEnd();
                    return ret("comment", "comment");
                } else if (expressionAllowed(stream, state, 1)) {
                    readRegexp(stream);
                    stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
                    return ret("regexp", "string-2");
                } else {
                    stream.eat("=");
                    return ret("operator", "operator", stream.current());
                }
            } else if (ch == "`") {
                state.tokenize = tokenQuasi;
                return tokenQuasi(stream, state);
            } else if (ch == "#" && stream.peek() == "!") {
                stream.skipToEnd();
                return ret("meta", "meta");
            } else if (ch == "#" && stream.eatWhile(wordRE)) {
                return ret("variable", "property");
            } else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start))) {
                stream.skipToEnd();
                return ret("comment", "comment");
            } else if (isOperatorChar.test(ch)) {
                if (ch != ">" || !state.lexical || state.lexical.type != ">") {
                    if (stream.eat("=")) {
                        if (ch == "!" || ch == "=") stream.eat("=");
                    } else if (/[<>*+\-|&?]/.test(ch)) {
                        stream.eat(ch);
                        if (ch == ">") stream.eat(ch);
                    }
                }
                if (ch == "?" && stream.eat(".")) return ret(".");
                return ret("operator", "operator", stream.current());
            } else if (wordRE.test(ch)) {
                stream.eatWhile(wordRE);
                var word = stream.current();
                if (state.lastType != ".") {
                    if (keywords.propertyIsEnumerable(word)) {
                        var kw = keywords[word];
                        return ret(kw.type, kw.style, word);
                    }
                    if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false)) return ret("async", "keyword", word);
                }
                return ret("variable", "variable", word);
            }
        };
        var tokenString = function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, next;
                if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
                    state.tokenize = tokenBase;
                    return ret("jsonld-keyword", "meta");
                }
                while((next = stream.next()) != null){
                    if (next == quote && !escaped) break;
                    escaped = !escaped && next == "\\";
                }
                if (!escaped) state.tokenize = tokenBase;
                return ret("string", "string");
            };
        };
        var tokenComment = function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while(ch = stream.next()){
                if (ch == "/" && maybeEnd) {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return ret("comment", "comment");
        };
        var tokenQuasi = function tokenQuasi(stream, state) {
            var escaped = false, next;
            while((next = stream.next()) != null){
                if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
                    state.tokenize = tokenBase;
                    break;
                }
                escaped = !escaped && next == "\\";
            }
            return ret("quasi", "string-2", stream.current());
        };
        var findFatArrow = // This is a crude lookahead trick to try and notice that we're
        // parsing the argument patterns for a fat-arrow function before we
        // actually hit the arrow token. It only works if the arrow is on
        // the same line as the arguments and there's no strange noise
        // (comments) in between. Fallback is to only notice when we hit the
        // arrow, and not declare the arguments as locals for the arrow
        // body.
        function findFatArrow(stream, state) {
            if (state.fatArrowAt) state.fatArrowAt = null;
            var arrow = stream.string.indexOf("=>", stream.start);
            if (arrow < 0) return;
            if (isTS) {
                var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
                if (m) arrow = m.index;
            }
            var depth = 0, sawSomething = false;
            for(var pos = arrow - 1; pos >= 0; --pos){
                var ch = stream.string.charAt(pos);
                var bracket = brackets.indexOf(ch);
                if (bracket >= 0 && bracket < 3) {
                    if (!depth) {
                        ++pos;
                        break;
                    }
                    if (--depth == 0) {
                        if (ch == "(") sawSomething = true;
                        break;
                    }
                } else if (bracket >= 3 && bracket < 6) {
                    ++depth;
                } else if (wordRE.test(ch)) {
                    sawSomething = true;
                } else if (/["'\/`]/.test(ch)) {
                    for(;; --pos){
                        if (pos == 0) return;
                        var next = stream.string.charAt(pos - 1);
                        if (next == ch && stream.string.charAt(pos - 2) != "\\") {
                            pos--;
                            break;
                        }
                    }
                } else if (sawSomething && !depth) {
                    ++pos;
                    break;
                }
            }
            if (sawSomething && !depth) state.fatArrowAt = pos;
        };
        var JSLexical = function JSLexical(indented, column, type, align, prev, info) {
            this.indented = indented;
            this.column = column;
            this.type = type;
            this.prev = prev;
            this.info = info;
            if (align != null) this.align = align;
        };
        var inScope = function inScope(state, varname) {
            if (!trackScope) return false;
            for(var v = state.localVars; v; v = v.next)if (v.name == varname) return true;
            for(var cx = state.context; cx; cx = cx.prev){
                for(var v = cx.vars; v; v = v.next)if (v.name == varname) return true;
            }
        };
        var parseJS = function parseJS(state, style, type, content, stream) {
            var cc = state.cc;
            // Communicate our context to the combinators.
            // (Less wasteful than consing up a hundred closures on every call.)
            cx.state = state;
            cx.stream = stream;
            cx.marked = null, cx.cc = cc;
            cx.style = style;
            if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
            while(true){
                var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
                if (combinator(type, content)) {
                    while(cc.length && cc[cc.length - 1].lex)cc.pop()();
                    if (cx.marked) return cx.marked;
                    if (type == "variable" && inScope(state, content)) return "variable-2";
                    return style;
                }
            }
        };
        var pass = function pass() {
            for(var i = arguments.length - 1; i >= 0; i--)cx.cc.push(arguments[i]);
        };
        var cont = function cont() {
            pass.apply(null, arguments);
            return true;
        };
        var inList = function inList(name, list) {
            for(var v = list; v; v = v.next)if (v.name == name) return true;
            return false;
        };
        var register = function register(varname) {
            var state = cx.state;
            cx.marked = "def";
            if (!trackScope) return;
            if (state.context) {
                if (state.lexical.info == "var" && state.context && state.context.block) {
                    // FIXME function decls are also not block scoped
                    var newContext = registerVarScoped(varname, state.context);
                    if (newContext != null) {
                        state.context = newContext;
                        return;
                    }
                } else if (!inList(varname, state.localVars)) {
                    state.localVars = new Var(varname, state.localVars);
                    return;
                }
            }
            // Fall through means this is global
            if (parserConfig.globalVars && !inList(varname, state.globalVars)) state.globalVars = new Var(varname, state.globalVars);
        };
        var isModifier = function isModifier(name) {
            return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
        };
        var Context = // Combinators
        function Context(prev, vars, block) {
            this.prev = prev;
            this.vars = vars;
            this.block = block;
        };
        var Var = function Var(name, next) {
            this.name = name;
            this.next = next;
        };
        var pushcontext = function pushcontext() {
            cx.state.context = new Context(cx.state.context, cx.state.localVars, false);
            cx.state.localVars = defaultVars;
        };
        var pushblockcontext = function pushblockcontext() {
            cx.state.context = new Context(cx.state.context, cx.state.localVars, true);
            cx.state.localVars = null;
        };
        var popcontext = function popcontext() {
            cx.state.localVars = cx.state.context.vars;
            cx.state.context = cx.state.context.prev;
        };
        var pushlex = function pushlex(type, info) {
            var result = function result() {
                var state = cx.state, indent = state.indented;
                if (state.lexical.type == "stat") indent = state.lexical.indented;
                else for(var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)indent = outer.indented;
                state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
            };
            result.lex = true;
            return result;
        };
        var poplex = function poplex() {
            var state = cx.state;
            if (state.lexical.prev) {
                if (state.lexical.type == ")") state.indented = state.lexical.indented;
                state.lexical = state.lexical.prev;
            }
        };
        var expect = function expect(wanted) {
            function exp(type) {
                if (type == wanted) return cont();
                else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
                else return cont(exp);
            }
            return exp;
        };
        var maybeCatchBinding = function maybeCatchBinding(type) {
            if (type == "(") return cont(funarg, expect(")"));
        };
        var expression = function expression(type, value) {
            return expressionInner(type, value, false);
        };
        var expressionNoComma = function expressionNoComma(type, value) {
            return expressionInner(type, value, true);
        };
        var parenExpr = function parenExpr(type) {
            if (type != "(") return pass();
            return cont(pushlex(")"), maybeexpression, expect(")"), poplex);
        };
        var expressionInner = function expressionInner(type, value, noComma) {
            if (cx.state.fatArrowAt == cx.stream.start) {
                var body = noComma ? arrowBodyNoComma : arrowBody;
                if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
                else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
            }
            var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
            if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
            if (type == "function") return cont(functiondef, maybeop);
            if (type == "class" || isTS && value == "interface") {
                cx.marked = "keyword";
                return cont(pushlex("form"), classExpression, poplex);
            }
            if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
            if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
            if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
            if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
            if (type == "{") return contCommasep(objprop, "}", null, maybeop);
            if (type == "quasi") return pass(quasi, maybeop);
            if (type == "new") return cont(maybeTarget(noComma));
            return cont();
        };
        var maybeexpression = function maybeexpression(type) {
            if (type.match(/[;\}\)\],]/)) return pass();
            return pass(expression);
        };
        var maybeoperatorComma = function maybeoperatorComma(type, value) {
            if (type == ",") return cont(maybeexpression);
            return maybeoperatorNoComma(type, value, false);
        };
        var continueQuasi = function continueQuasi(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasi);
            }
        };
        var arrowBody = function arrowBody(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expression);
        };
        var arrowBodyNoComma = function arrowBodyNoComma(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expressionNoComma);
        };
        var maybeTarget = function maybeTarget(noComma) {
            return function(type) {
                if (type == ".") return cont(noComma ? targetNoComma : target);
                else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);
                else return pass(noComma ? expressionNoComma : expression);
            };
        };
        var target = function target(_, value) {
            if (value == "target") {
                cx.marked = "keyword";
                return cont(maybeoperatorComma);
            }
        };
        var targetNoComma = function targetNoComma(_, value) {
            if (value == "target") {
                cx.marked = "keyword";
                return cont(maybeoperatorNoComma);
            }
        };
        var maybelabel = function maybelabel(type) {
            if (type == ":") return cont(poplex, statement);
            return pass(maybeoperatorComma, expect(";"), poplex);
        };
        var property = function property(type) {
            if (type == "variable") {
                cx.marked = "property";
                return cont();
            }
        };
        var getterSetter = function getterSetter(type) {
            if (type != "variable") return pass(afterprop);
            cx.marked = "property";
            return cont(functiondef);
        };
        var afterprop = function afterprop(type) {
            if (type == ":") return cont(expressionNoComma);
            if (type == "(") return pass(functiondef);
        };
        var commasep = function commasep(what, end, sep) {
            function proceed(type, value) {
                if (sep ? sep.indexOf(type) > -1 : type == ",") {
                    var lex = cx.state.lexical;
                    if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
                    return cont(function(type, value) {
                        if (type == end || value == end) return pass();
                        return pass(what);
                    }, proceed);
                }
                if (type == end || value == end) return cont();
                if (sep && sep.indexOf(";") > -1) return pass(what);
                return cont(expect(end));
            }
            return function(type, value) {
                if (type == end || value == end) return cont();
                return pass(what, proceed);
            };
        };
        var contCommasep = function contCommasep(what, end, info) {
            for(var i = 3; i < arguments.length; i++)cx.cc.push(arguments[i]);
            return cont(pushlex(end, info), commasep(what, end), poplex);
        };
        var maybetypeOrIn = function maybetypeOrIn(type, value) {
            if (isTS && (type == ":" || value == "in")) return cont(typeexpr);
        };
        var mayberettype = function mayberettype(type) {
            if (isTS && type == ":") {
                if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr);
                else return cont(typeexpr);
            }
        };
        var isKW = function isKW(_, value) {
            if (value == "is") {
                cx.marked = "keyword";
                return cont();
            }
        };
        var maybeReturnType = function maybeReturnType(type) {
            if (type == "=>") return cont(typeexpr);
        };
        var continueQuasiType = function continueQuasiType(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasiType);
            }
        };
        var maybeTypeArgs = function maybeTypeArgs(_, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
        };
        var typeparam = function typeparam() {
            return pass(typeexpr, maybeTypeDefault);
        };
        var maybeTypeDefault = function maybeTypeDefault(_, value) {
            if (value == "=") return cont(typeexpr);
        };
        var vardef = function vardef(_, value) {
            if (value == "enum") {
                cx.marked = "keyword";
                return cont(enumdef);
            }
            return pass(pattern, maybetype, maybeAssign, vardefCont);
        };
        var eltpattern = function eltpattern() {
            return pass(pattern, maybeAssign);
        };
        var maybeAssign = function maybeAssign(_type, value) {
            if (value == "=") return cont(expressionNoComma);
        };
        var vardefCont = function vardefCont(type) {
            if (type == ",") return cont(vardef);
        };
        var maybeelse = function maybeelse(type, value) {
            if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
        };
        var forspec1 = function forspec1(type) {
            if (type == "var") return cont(vardef, forspec2);
            if (type == "variable") return cont(forspec2);
            return pass(forspec2);
        };
        var classExpression = function classExpression(type, value) {
            // Class expressions may have an optional name.
            if (type == "variable") return className(type, value);
            return classNameAfter(type, value);
        };
        var className = function className(type, value) {
            if (type == "variable") {
                register(value);
                return cont(classNameAfter);
            }
        };
        var afterExport = function afterExport(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(maybeFrom, expect(";"));
            }
            if (value == "default") {
                cx.marked = "keyword";
                return cont(expression, expect(";"));
            }
            if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
            return pass(statement);
        };
        var afterImport = function afterImport(type) {
            if (type == "string") return cont();
            if (type == "(") return pass(expression);
            if (type == ".") return pass(maybeoperatorComma);
            return pass(importSpec, maybeMoreImports, maybeFrom);
        };
        var maybeAs = function maybeAs(_type, value) {
            if (value == "as") {
                cx.marked = "keyword";
                return cont(importSpec);
            }
        };
        var maybeFrom = function maybeFrom(_type, value) {
            if (value == "from") {
                cx.marked = "keyword";
                return cont(expression);
            }
        };
        var arrayLiteral = function arrayLiteral(type) {
            if (type == "]") return cont();
            return pass(commasep(expressionNoComma, "]"));
        };
        var enumdef = function enumdef() {
            return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
        };
        var enummember = function enummember() {
            return pass(pattern, maybeAssign);
        };
        var isContinuedStatement = function isContinuedStatement(state, textAfter) {
            return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
        };
        var expressionAllowed = function expressionAllowed(stream, state, backUp) {
            return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
        };
        var indentUnit = config.indentUnit;
        var statementIndent = parserConfig.statementIndent;
        var jsonldMode = parserConfig.jsonld;
        var jsonMode = parserConfig.json || jsonldMode;
        var trackScope = parserConfig.trackScope !== false;
        var isTS = parserConfig.typescript;
        var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
        // Tokenizer
        var keywords = function() {
            var kw = function kw(type) {
                return {
                    type: type,
                    style: "keyword"
                };
            };
            var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
            var operator = kw("operator"), atom = {
                type: "atom",
                style: "atom"
            };
            return {
                "if": kw("if"),
                "while": A,
                "with": A,
                "else": B,
                "do": B,
                "try": B,
                "finally": B,
                "return": D,
                "break": D,
                "continue": D,
                "new": kw("new"),
                "delete": C,
                "void": C,
                "throw": C,
                "debugger": kw("debugger"),
                "var": kw("var"),
                "const": kw("var"),
                "let": kw("var"),
                "function": kw("function"),
                "catch": kw("catch"),
                "for": kw("for"),
                "switch": kw("switch"),
                "case": kw("case"),
                "default": kw("default"),
                "in": operator,
                "typeof": operator,
                "instanceof": operator,
                "true": atom,
                "false": atom,
                "null": atom,
                "undefined": atom,
                "NaN": atom,
                "Infinity": atom,
                "this": kw("this"),
                "class": kw("class"),
                "super": kw("atom"),
                "yield": C,
                "export": kw("export"),
                "import": kw("import"),
                "extends": C,
                "await": C
            };
        }();
        var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
        var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
        // Used as scratch variables to communicate multiple values without
        // consing up tons of objects.
        var type, content;
        var brackets = "([{}])";
        // Parser
        var atomicTypes = {
            "atom": true,
            "number": true,
            "variable": true,
            "string": true,
            "regexp": true,
            "this": true,
            "import": true,
            "jsonld-keyword": true
        };
        // Combinator utils
        var cx = {
            state: null,
            column: null,
            marked: null,
            cc: null
        };
        function registerVarScoped(varname, context) {
            if (!context) {
                return null;
            } else if (context.block) {
                var inner = registerVarScoped(varname, context.prev);
                if (!inner) return null;
                if (inner == context.prev) return context;
                return new Context(inner, context.vars, true);
            } else if (inList(varname, context.vars)) {
                return context;
            } else {
                return new Context(context.prev, new Var(varname, context.vars), false);
            }
        }
        var defaultVars = new Var("this", new Var("arguments", null));
        popcontext.lex = true;
        poplex.lex = true;
        function statement(type, value) {
            if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
            if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
            if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
            if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
            if (type == "debugger") return cont(expect(";"));
            if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
            if (type == ";") return cont();
            if (type == "if") {
                if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
                return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
            }
            if (type == "function") return cont(functiondef);
            if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
            if (type == "class" || isTS && value == "interface") {
                cx.marked = "keyword";
                return cont(pushlex("form", type == "class" ? type : value), className, poplex);
            }
            if (type == "variable") {
                if (isTS && value == "declare") {
                    cx.marked = "keyword";
                    return cont(statement);
                } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
                    cx.marked = "keyword";
                    if (value == "enum") return cont(enumdef);
                    else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
                    else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
                } else if (isTS && value == "namespace") {
                    cx.marked = "keyword";
                    return cont(pushlex("form"), expression, statement, poplex);
                } else if (isTS && value == "abstract") {
                    cx.marked = "keyword";
                    return cont(statement);
                } else {
                    return cont(pushlex("stat"), maybelabel);
                }
            }
            if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext, block, poplex, poplex, popcontext);
            if (type == "case") return cont(expression, expect(":"));
            if (type == "default") return cont(expect(":"));
            if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
            if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
            if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
            if (type == "async") return cont(statement);
            if (value == "@") return cont(expression, statement);
            return pass(pushlex("stat"), expression, expect(";"), poplex);
        }
        function maybeoperatorNoComma(type, value, noComma) {
            var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
            var expr = noComma == false ? expression : expressionNoComma;
            if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
            if (type == "operator") {
                if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
                if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false)) return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
                if (value == "?") return cont(expression, expect(":"), expr);
                return cont(expr);
            }
            if (type == "quasi") {
                return pass(quasi, me);
            }
            if (type == ";") return;
            if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
            if (type == ".") return cont(property, me);
            if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
            if (isTS && value == "as") {
                cx.marked = "keyword";
                return cont(typeexpr, me);
            }
            if (type == "regexp") {
                cx.state.lastType = cx.marked = "operator";
                cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
                return cont(expr);
            }
        }
        function quasi(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasi);
            return cont(maybeexpression, continueQuasi);
        }
        function objprop(type, value) {
            if (type == "async") {
                cx.marked = "property";
                return cont(objprop);
            } else if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                if (value == "get" || value == "set") return cont(getterSetter);
                var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
                ;
                if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false))) cx.state.fatArrowAt = cx.stream.pos + m[0].length;
                return cont(afterprop);
            } else if (type == "number" || type == "string") {
                cx.marked = jsonldMode ? "property" : cx.style + " property";
                return cont(afterprop);
            } else if (type == "jsonld-keyword") {
                return cont(afterprop);
            } else if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == "[") {
                return cont(expression, maybetype, expect("]"), afterprop);
            } else if (type == "spread") {
                return cont(expressionNoComma, afterprop);
            } else if (value == "*") {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == ":") {
                return pass(afterprop);
            }
        }
        function block(type) {
            if (type == "}") return cont();
            return pass(statement, block);
        }
        function maybetype(type, value) {
            if (isTS) {
                if (type == ":") return cont(typeexpr);
                if (value == "?") return cont(maybetype);
            }
        }
        function typeexpr(type, value) {
            if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
                cx.marked = "keyword";
                return cont(value == "typeof" ? expressionNoComma : typeexpr);
            }
            if (type == "variable" || value == "void") {
                cx.marked = "type";
                return cont(afterType);
            }
            if (value == "|" || value == "&") return cont(typeexpr);
            if (type == "string" || type == "number" || type == "atom") return cont(afterType);
            if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
            if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType);
            if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType);
            if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr);
            if (type == "quasi") {
                return pass(quasiType, afterType);
            }
        }
        function typeprops(type) {
            if (type.match(/[\}\)\]]/)) return cont();
            if (type == "," || type == ";") return cont(typeprops);
            return pass(typeprop, typeprops);
        }
        function typeprop(type, value) {
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(typeprop);
            } else if (value == "?" || type == "number" || type == "string") {
                return cont(typeprop);
            } else if (type == ":") {
                return cont(typeexpr);
            } else if (type == "[") {
                return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop);
            } else if (type == "(") {
                return pass(functiondecl, typeprop);
            } else if (!type.match(/[;\}\)\],]/)) {
                return cont();
            }
        }
        function quasiType(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasiType);
            return cont(typeexpr, continueQuasiType);
        }
        function typearg(type, value) {
            if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg);
            if (type == ":") return cont(typeexpr);
            if (type == "spread") return cont(typearg);
            return pass(typeexpr);
        }
        function afterType(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
            if (value == "|" || type == "." || value == "&") return cont(typeexpr);
            if (type == "[") return cont(typeexpr, expect("]"), afterType);
            if (value == "extends" || value == "implements") {
                cx.marked = "keyword";
                return cont(typeexpr);
            }
            if (value == "?") return cont(typeexpr, expect(":"), typeexpr);
        }
        function pattern(type, value) {
            if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(pattern);
            }
            if (type == "variable") {
                register(value);
                return cont();
            }
            if (type == "spread") return cont(pattern);
            if (type == "[") return contCommasep(eltpattern, "]");
            if (type == "{") return contCommasep(proppattern, "}");
        }
        function proppattern(type, value) {
            if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
                register(value);
                return cont(maybeAssign);
            }
            if (type == "variable") cx.marked = "property";
            if (type == "spread") return cont(pattern);
            if (type == "}") return pass();
            if (type == "[") return cont(expression, expect("]"), expect(":"), proppattern);
            return cont(expect(":"), pattern, maybeAssign);
        }
        function forspec(type, value) {
            if (value == "await") return cont(forspec);
            if (type == "(") return cont(pushlex(")"), forspec1, poplex);
        }
        function forspec2(type, value) {
            if (type == ")") return cont();
            if (type == ";") return cont(forspec2);
            if (value == "in" || value == "of") {
                cx.marked = "keyword";
                return cont(expression, forspec2);
            }
            return pass(expression, forspec2);
        }
        function functiondef(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(functiondef);
            }
            if (type == "variable") {
                register(value);
                return cont(functiondef);
            }
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
        }
        function functiondecl(type, value) {
            if (value == "*") {
                cx.marked = "keyword";
                return cont(functiondecl);
            }
            if (type == "variable") {
                register(value);
                return cont(functiondecl);
            }
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl);
        }
        function typename(type, value) {
            if (type == "keyword" || type == "variable") {
                cx.marked = "type";
                return cont(typename);
            } else if (value == "<") {
                return cont(pushlex(">"), commasep(typeparam, ">"), poplex);
            }
        }
        function funarg(type, value) {
            if (value == "@") cont(expression, funarg);
            if (type == "spread") return cont(funarg);
            if (isTS && isModifier(value)) {
                cx.marked = "keyword";
                return cont(funarg);
            }
            if (isTS && type == "this") return cont(maybetype, maybeAssign);
            return pass(pattern, maybetype, maybeAssign);
        }
        function classNameAfter(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
            if (value == "extends" || value == "implements" || isTS && type == ",") {
                if (value == "implements") cx.marked = "keyword";
                return cont(isTS ? typeexpr : expression, classNameAfter);
            }
            if (type == "{") return cont(pushlex("}"), classBody, poplex);
        }
        function classBody(type, value) {
            if (type == "async" || type == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false)) {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(classfield, classBody);
            }
            if (type == "number" || type == "string") return cont(classfield, classBody);
            if (type == "[") return cont(expression, maybetype, expect("]"), classfield, classBody);
            if (value == "*") {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (isTS && type == "(") return pass(functiondecl, classBody);
            if (type == ";" || type == ",") return cont(classBody);
            if (type == "}") return cont();
            if (value == "@") return cont(expression, classBody);
        }
        function classfield(type, value) {
            if (value == "!") return cont(classfield);
            if (value == "?") return cont(classfield);
            if (type == ":") return cont(typeexpr, maybeAssign);
            if (value == "=") return cont(expressionNoComma);
            var context = cx.state.lexical.prev, isInterface = context && context.info == "interface";
            return pass(isInterface ? functiondecl : functiondef);
        }
        function exportField(type, value) {
            if (value == "as") {
                cx.marked = "keyword";
                return cont(expect("variable"));
            }
            if (type == "variable") return pass(expressionNoComma, exportField);
        }
        function importSpec(type, value) {
            if (type == "{") return contCommasep(importSpec, "}");
            if (type == "variable") register(value);
            if (value == "*") cx.marked = "keyword";
            return cont(maybeAs);
        }
        function maybeMoreImports(type) {
            if (type == ",") return cont(importSpec, maybeMoreImports);
        }
        // Interface
        return {
            startState: function startState(basecolumn) {
                var state = {
                    tokenize: tokenBase,
                    lastType: "sof",
                    cc: [],
                    lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
                    localVars: parserConfig.localVars,
                    context: parserConfig.localVars && new Context(null, null, false),
                    indented: basecolumn || 0
                };
                if (parserConfig.globalVars && typeof parserConfig.globalVars == "object") state.globalVars = parserConfig.globalVars;
                return state;
            },
            token: function token(stream, state) {
                if (stream.sol()) {
                    if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
                    state.indented = stream.indentation();
                    findFatArrow(stream, state);
                }
                if (state.tokenize != tokenComment && stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (type == "comment") return style;
                state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
                return parseJS(state, style, type, content, stream);
            },
            indent: function indent(state, textAfter) {
                if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror1.Pass;
                if (state.tokenize != tokenBase) return 0;
                var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top;
                // Kludge to prevent 'maybelse' from blocking lexical scope pops
                if (!/^\s*else\b/.test(textAfter)) for(var i = state.cc.length - 1; i >= 0; --i){
                    var c = state.cc[i];
                    if (c == poplex) lexical = lexical.prev;
                    else if (c != maybeelse && c != popcontext) break;
                }
                while((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter)))lexical = lexical.prev;
                if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
                var type = lexical.type, closing = firstChar == type;
                if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
                else if (type == "form" && firstChar == "{") return lexical.indented;
                else if (type == "form") return lexical.indented + indentUnit;
                else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
                else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
                else if (lexical.align) return lexical.column + (closing ? 0 : 1);
                else return lexical.indented + (closing ? 0 : indentUnit);
            },
            electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
            blockCommentStart: jsonMode ? null : "/*",
            blockCommentEnd: jsonMode ? null : "*/",
            blockCommentContinue: jsonMode ? null : " * ",
            lineComment: jsonMode ? null : "//",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``",
            helperType: jsonMode ? "json" : "javascript",
            jsonldMode: jsonldMode,
            jsonMode: jsonMode,
            expressionAllowed: expressionAllowed,
            skipExpression: function skipExpression(state) {
                parseJS(state, "atom", "atom", "true", new CodeMirror1.StringStream("", 2, null));
            }
        };
    });
    CodeMirror1.registerHelper("wordChars", "javascript", /[\w$]/);
    CodeMirror1.defineMIME("text/javascript", "javascript");
    CodeMirror1.defineMIME("text/ecmascript", "javascript");
    CodeMirror1.defineMIME("application/javascript", "javascript");
    CodeMirror1.defineMIME("application/x-javascript", "javascript");
    CodeMirror1.defineMIME("application/ecmascript", "javascript");
    CodeMirror1.defineMIME("application/json", {
        name: "javascript",
        json: true
    });
    CodeMirror1.defineMIME("application/x-json", {
        name: "javascript",
        json: true
    });
    CodeMirror1.defineMIME("application/manifest+json", {
        name: "javascript",
        json: true
    });
    CodeMirror1.defineMIME("application/ld+json", {
        name: "javascript",
        jsonld: true
    });
    CodeMirror1.defineMIME("text/typescript", {
        name: "javascript",
        typescript: true
    });
    CodeMirror1.defineMIME("application/typescript", {
        name: "javascript",
        typescript: true
    });
});
});

var htmlmixed = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, xml, javascript, css);
})(function(CodeMirror1) {
    var maybeBackup = function maybeBackup(stream, pat, style) {
        var cur = stream.current(), close = cur.search(pat);
        if (close > -1) {
            stream.backUp(cur.length - close);
        } else if (cur.match(/<\/?$/)) {
            stream.backUp(cur.length);
            if (!stream.match(pat, false)) stream.match(cur);
        }
        return style;
    };
    var getAttrRegexp = function getAttrRegexp(attr) {
        var regexp = attrRegexpCache[attr];
        if (regexp) return regexp;
        return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
    };
    var getAttrValue = function getAttrValue(text, attr) {
        var match = text.match(getAttrRegexp(attr));
        return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : "";
    };
    var getTagRegexp = function getTagRegexp(tagName, anchored) {
        return new RegExp((anchored ? "^" : "") + "</s*" + tagName + "s*>", "i");
    };
    var addTags = function addTags(from, to) {
        for(var tag in from){
            var dest = to[tag] || (to[tag] = []);
            var source = from[tag];
            for(var i = source.length - 1; i >= 0; i--)dest.unshift(source[i]);
        }
    };
    var findMatchingMode = function findMatchingMode(tagInfo, tagText) {
        for(var i = 0; i < tagInfo.length; i++){
            var spec = tagInfo[i];
            if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
        }
    };
    var defaultTags = {
        script: [
            [
                "lang",
                /(javascript|babel)/i,
                "javascript"
            ],
            [
                "type",
                /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i,
                "javascript"
            ],
            [
                "type",
                /./,
                "text/plain"
            ],
            [
                null,
                null,
                "javascript"
            ]
        ],
        style: [
            [
                "lang",
                /^css$/i,
                "css"
            ],
            [
                "type",
                /^(text\/)?(x-)?(stylesheet|css)$/i,
                "css"
            ],
            [
                "type",
                /./,
                "text/plain"
            ],
            [
                null,
                null,
                "css"
            ]
        ]
    };
    var attrRegexpCache = {};
    CodeMirror1.defineMode("htmlmixed", function(config, parserConfig) {
        var htmlMode = CodeMirror1.getMode(config, {
            name: "xml",
            htmlMode: true,
            multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
            multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag,
            allowMissingTagName: parserConfig.allowMissingTagName
        });
        var tags = {};
        var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
        addTags(defaultTags, tags);
        if (configTags) addTags(configTags, tags);
        if (configScript) for(var i = configScript.length - 1; i >= 0; i--)tags.script.unshift([
            "type",
            configScript[i].matches,
            configScript[i].mode
        ]);
        function html(stream, state) {
            var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName;
            if (tag && !/[<>\s\/]/.test(stream.current()) && (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) && tags.hasOwnProperty(tagName)) {
                state.inTag = tagName + " ";
            } else if (state.inTag && tag && />$/.test(stream.current())) {
                var inTag = /^([\S]+) (.*)/.exec(state.inTag);
                state.inTag = null;
                var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2]);
                var mode = CodeMirror1.getMode(config, modeSpec);
                var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
                state.token = function(stream, state) {
                    if (stream.match(endTagA, false)) {
                        state.token = html;
                        state.localState = state.localMode = null;
                        return null;
                    }
                    return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
                };
                state.localMode = mode;
                state.localState = CodeMirror1.startState(mode, htmlMode.indent(state.htmlState, "", ""));
            } else if (state.inTag) {
                state.inTag += stream.current();
                if (stream.eol()) state.inTag += " ";
            }
            return style;
        }
        return {
            startState: function startState() {
                var state = CodeMirror1.startState(htmlMode);
                return {
                    token: html,
                    inTag: null,
                    localMode: null,
                    localState: null,
                    htmlState: state
                };
            },
            copyState: function copyState(state) {
                var local;
                if (state.localState) {
                    local = CodeMirror1.copyState(state.localMode, state.localState);
                }
                return {
                    token: state.token,
                    inTag: state.inTag,
                    localMode: state.localMode,
                    localState: local,
                    htmlState: CodeMirror1.copyState(htmlMode, state.htmlState)
                };
            },
            token: function token(stream, state) {
                return state.token(stream, state);
            },
            indent: function indent(state, textAfter, line) {
                if (!state.localMode || /^\s*<\//.test(textAfter)) return htmlMode.indent(state.htmlState, textAfter, line);
                else if (state.localMode.indent) return state.localMode.indent(state.localState, textAfter, line);
                else return CodeMirror1.Pass;
            },
            innerMode: function innerMode(state) {
                return {
                    state: state.localState || state.htmlState,
                    mode: state.localMode || htmlMode
                };
            }
        };
    }, "xml", "javascript", "css");
    CodeMirror1.defineMIME("text/html", "htmlmixed");
});
});

var http = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("http", function() {
        var failFirstLine = function failFirstLine(stream, state) {
            stream.skipToEnd();
            state.cur = header;
            return "error";
        };
        var start = function start(stream, state) {
            if (stream.match(/^HTTP\/\d\.\d/)) {
                state.cur = responseStatusCode;
                return "keyword";
            } else if (stream.match(/^[A-Z]+/) && /[ \t]/.test(stream.peek())) {
                state.cur = requestPath;
                return "keyword";
            } else {
                return failFirstLine(stream, state);
            }
        };
        var responseStatusCode = function responseStatusCode(stream, state) {
            var code = stream.match(/^\d+/);
            if (!code) return failFirstLine(stream, state);
            state.cur = responseStatusText;
            var status = Number(code[0]);
            if (status >= 100 && status < 200) {
                return "positive informational";
            } else if (status >= 200 && status < 300) {
                return "positive success";
            } else if (status >= 300 && status < 400) {
                return "positive redirect";
            } else if (status >= 400 && status < 500) {
                return "negative client-error";
            } else if (status >= 500 && status < 600) {
                return "negative server-error";
            } else {
                return "error";
            }
        };
        var responseStatusText = function responseStatusText(stream, state) {
            stream.skipToEnd();
            state.cur = header;
            return null;
        };
        var requestPath = function requestPath(stream, state) {
            stream.eatWhile(/\S/);
            state.cur = requestProtocol;
            return "string-2";
        };
        var requestProtocol = function requestProtocol(stream, state) {
            if (stream.match(/^HTTP\/\d\.\d$/)) {
                state.cur = header;
                return "keyword";
            } else {
                return failFirstLine(stream, state);
            }
        };
        var header = function header(stream) {
            if (stream.sol() && !stream.eat(/[ \t]/)) {
                if (stream.match(/^.*?:/)) {
                    return "atom";
                } else {
                    stream.skipToEnd();
                    return "error";
                }
            } else {
                stream.skipToEnd();
                return "string";
            }
        };
        var body = function body(stream) {
            stream.skipToEnd();
            return null;
        };
        return {
            token: function token(stream, state) {
                var cur = state.cur;
                if (cur != header && cur != body && stream.eatSpace()) return null;
                return cur(stream, state);
            },
            blankLine: function blankLine(state) {
                state.cur = body;
            },
            startState: function startState() {
                return {
                    cur: start
                };
            }
        };
    });
    CodeMirror1.defineMIME("message/http", "http");
});
});

var jsx = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, xml, javascript);
})(function(CodeMirror1) {
    var Context = // Depth means the amount of open braces in JS context, in XML
    // context 0 means not in tag, 1 means in tag, and 2 means in tag
    // and js block comment.
    function Context(state, mode, depth, prev) {
        this.state = state;
        this.mode = mode;
        this.depth = depth;
        this.prev = prev;
    };
    function copyContext(context) {
        return new Context(CodeMirror1.copyState(context.mode, context.state), context.mode, context.depth, context.prev && copyContext(context.prev));
    }
    CodeMirror1.defineMode("jsx", function(config, modeConfig) {
        var flatXMLIndent = function flatXMLIndent(state) {
            var tagName = state.tagName;
            state.tagName = null;
            var result = xmlMode.indent(state, "", "");
            state.tagName = tagName;
            return result;
        };
        var token = function token(stream, state) {
            if (state.context.mode == xmlMode) return xmlToken(stream, state, state.context);
            else return jsToken(stream, state, state.context);
        };
        var xmlToken = function xmlToken(stream, state, cx) {
            if (cx.depth == 2) {
                if (stream.match(/^.*?\*\//)) cx.depth = 1;
                else stream.skipToEnd();
                return "comment";
            }
            if (stream.peek() == "{") {
                xmlMode.skipAttribute(cx.state);
                var indent = flatXMLIndent(cx.state), xmlContext = cx.state.context;
                // If JS starts on same line as tag
                if (xmlContext && stream.match(/^[^>]*>\s*$/, false)) {
                    while(xmlContext.prev && !xmlContext.startOfLine)xmlContext = xmlContext.prev;
                    // If tag starts the line, use XML indentation level
                    if (xmlContext.startOfLine) indent -= config.indentUnit;
                    else if (cx.prev.state.lexical) indent = cx.prev.state.lexical.indented;
                // Else if inside of tag
                } else if (cx.depth == 1) {
                    indent += config.indentUnit;
                }
                state.context = new Context(CodeMirror1.startState(jsMode, indent), jsMode, 0, state.context);
                return null;
            }
            if (cx.depth == 1) {
                if (stream.peek() == "<") {
                    xmlMode.skipAttribute(cx.state);
                    state.context = new Context(CodeMirror1.startState(xmlMode, flatXMLIndent(cx.state)), xmlMode, 0, state.context);
                    return null;
                } else if (stream.match("//")) {
                    stream.skipToEnd();
                    return "comment";
                } else if (stream.match("/*")) {
                    cx.depth = 2;
                    return token(stream, state);
                }
            }
            var style = xmlMode.token(stream, cx.state), cur = stream.current(), stop;
            if (/\btag\b/.test(style)) {
                if (/>$/.test(cur)) {
                    if (cx.state.context) cx.depth = 0;
                    else state.context = state.context.prev;
                } else if (/^</.test(cur)) {
                    cx.depth = 1;
                }
            } else if (!style && (stop = cur.indexOf("{")) > -1) {
                stream.backUp(cur.length - stop);
            }
            return style;
        };
        var jsToken = function jsToken(stream, state, cx) {
            if (stream.peek() == "<" && jsMode.expressionAllowed(stream, cx.state)) {
                state.context = new Context(CodeMirror1.startState(xmlMode, jsMode.indent(cx.state, "", "")), xmlMode, 0, state.context);
                jsMode.skipExpression(cx.state);
                return null;
            }
            var style = jsMode.token(stream, cx.state);
            if (!style && cx.depth != null) {
                var cur = stream.current();
                if (cur == "{") {
                    cx.depth++;
                } else if (cur == "}") {
                    if (--cx.depth == 0) state.context = state.context.prev;
                }
            }
            return style;
        };
        var xmlMode = CodeMirror1.getMode(config, {
            name: "xml",
            allowMissing: true,
            multilineTagIndentPastTag: false,
            allowMissingTagName: true
        });
        var jsMode = CodeMirror1.getMode(config, modeConfig && modeConfig.base || "javascript");
        return {
            startState: function startState() {
                return {
                    context: new Context(CodeMirror1.startState(jsMode), jsMode)
                };
            },
            copyState: function copyState(state) {
                return {
                    context: copyContext(state.context)
                };
            },
            token: token,
            indent: function indent(state, textAfter, fullLine) {
                return state.context.mode.indent(state.context.state, textAfter, fullLine);
            },
            innerMode: function innerMode(state) {
                return state.context;
            }
        };
    }, "xml", "javascript");
    CodeMirror1.defineMIME("text/jsx", "jsx");
    CodeMirror1.defineMIME("text/typescript-jsx", {
        name: "jsx",
        base: {
            name: "javascript",
            typescript: true
        }
    });
});
});

var stex = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
/*
 * Author: Constantin Jucovschi (c.jucovschi@jacobs-university.de)
 * Licence: MIT
 */ (function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("stex", function(_config, parserConfig) {
        var pushCommand = function pushCommand(state, command) {
            state.cmdState.push(command);
        };
        var peekCommand = function peekCommand(state) {
            if (state.cmdState.length > 0) {
                return state.cmdState[state.cmdState.length - 1];
            } else {
                return null;
            }
        };
        var popCommand = function popCommand(state) {
            var plug = state.cmdState.pop();
            if (plug) {
                plug.closeBracket();
            }
        };
        var getMostPowerful = // returns the non-default plugin closest to the end of the list
        function getMostPowerful(state) {
            var context = state.cmdState;
            for(var i = context.length - 1; i >= 0; i--){
                var plug = context[i];
                if (plug.name == "DEFAULT") {
                    continue;
                }
                return plug;
            }
            return {
                styleIdentifier: function styleIdentifier() {
                    return null;
                }
            };
        };
        var addPluginPattern = function addPluginPattern(pluginName, cmdStyle, styles) {
            return function() {
                this.name = pluginName;
                this.bracketNo = 0;
                this.style = cmdStyle;
                this.styles = styles;
                this.argument = null; // \begin and \end have arguments that follow. These are stored in the plugin
                this.styleIdentifier = function() {
                    return this.styles[this.bracketNo - 1] || null;
                };
                this.openBracket = function() {
                    this.bracketNo++;
                    return "bracket";
                };
                this.closeBracket = function() {};
            };
        };
        var setState = function setState(state, f) {
            state.f = f;
        };
        var normal = // called when in a normal (no environment) context
        function normal(source, state) {
            var plug;
            // Do we look like '\command' ?  If so, attempt to apply the plugin 'command'
            if (source.match(/^\\[a-zA-Z@]+/)) {
                var cmdName = source.current().slice(1);
                plug = plugins.hasOwnProperty(cmdName) ? plugins[cmdName] : plugins["DEFAULT"];
                plug = new plug();
                pushCommand(state, plug);
                setState(state, beginParams);
                return plug.style;
            }
            // escape characters
            if (source.match(/^\\[$&%#{}_]/)) {
                return "tag";
            }
            // white space control characters
            if (source.match(/^\\[,;!\/\\]/)) {
                return "tag";
            }
            // find if we're starting various math modes
            if (source.match("\\[")) {
                setState(state, function(source, state) {
                    return inMathMode(source, state, "\\]");
                });
                return "keyword";
            }
            if (source.match("\\(")) {
                setState(state, function(source, state) {
                    return inMathMode(source, state, "\\)");
                });
                return "keyword";
            }
            if (source.match("$$")) {
                setState(state, function(source, state) {
                    return inMathMode(source, state, "$$");
                });
                return "keyword";
            }
            if (source.match("$")) {
                setState(state, function(source, state) {
                    return inMathMode(source, state, "$");
                });
                return "keyword";
            }
            var ch = source.next();
            if (ch == "%") {
                source.skipToEnd();
                return "comment";
            } else if (ch == "}" || ch == "]") {
                plug = peekCommand(state);
                if (plug) {
                    plug.closeBracket(ch);
                    setState(state, beginParams);
                } else {
                    return "error";
                }
                return "bracket";
            } else if (ch == "{" || ch == "[") {
                plug = plugins["DEFAULT"];
                plug = new plug();
                pushCommand(state, plug);
                return "bracket";
            } else if (/\d/.test(ch)) {
                source.eatWhile(/[\w.%]/);
                return "atom";
            } else {
                source.eatWhile(/[\w\-_]/);
                plug = getMostPowerful(state);
                if (plug.name == "begin") {
                    plug.argument = source.current();
                }
                return plug.styleIdentifier();
            }
        };
        var inMathMode = function inMathMode(source, state, endModeSeq) {
            if (source.eatSpace()) {
                return null;
            }
            if (endModeSeq && source.match(endModeSeq)) {
                setState(state, normal);
                return "keyword";
            }
            if (source.match(/^\\[a-zA-Z@]+/)) {
                return "tag";
            }
            if (source.match(/^[a-zA-Z]+/)) {
                return "variable-2";
            }
            // escape characters
            if (source.match(/^\\[$&%#{}_]/)) {
                return "tag";
            }
            // white space control characters
            if (source.match(/^\\[,;!\/]/)) {
                return "tag";
            }
            // special math-mode characters
            if (source.match(/^[\^_&]/)) {
                return "tag";
            }
            // non-special characters
            if (source.match(/^[+\-<>|=,\/@!*:;'"`~#?]/)) {
                return null;
            }
            if (source.match(/^(\d+\.\d*|\d*\.\d+|\d+)/)) {
                return "number";
            }
            var ch = source.next();
            if (ch == "{" || ch == "}" || ch == "[" || ch == "]" || ch == "(" || ch == ")") {
                return "bracket";
            }
            if (ch == "%") {
                source.skipToEnd();
                return "comment";
            }
            return "error";
        };
        var beginParams = function beginParams(source, state) {
            var ch = source.peek(), lastPlug;
            if (ch == "{" || ch == "[") {
                lastPlug = peekCommand(state);
                lastPlug.openBracket(ch);
                source.eat(ch);
                setState(state, normal);
                return "bracket";
            }
            if (/[ \t\r]/.test(ch)) {
                source.eat(ch);
                return null;
            }
            setState(state, normal);
            popCommand(state);
            return normal(source, state);
        };
        var plugins = {};
        plugins["importmodule"] = addPluginPattern("importmodule", "tag", [
            "string",
            "builtin"
        ]);
        plugins["documentclass"] = addPluginPattern("documentclass", "tag", [
            "",
            "atom"
        ]);
        plugins["usepackage"] = addPluginPattern("usepackage", "tag", [
            "atom"
        ]);
        plugins["begin"] = addPluginPattern("begin", "tag", [
            "atom"
        ]);
        plugins["end"] = addPluginPattern("end", "tag", [
            "atom"
        ]);
        plugins["label"] = addPluginPattern("label", "tag", [
            "atom"
        ]);
        plugins["ref"] = addPluginPattern("ref", "tag", [
            "atom"
        ]);
        plugins["eqref"] = addPluginPattern("eqref", "tag", [
            "atom"
        ]);
        plugins["cite"] = addPluginPattern("cite", "tag", [
            "atom"
        ]);
        plugins["bibitem"] = addPluginPattern("bibitem", "tag", [
            "atom"
        ]);
        plugins["Bibitem"] = addPluginPattern("Bibitem", "tag", [
            "atom"
        ]);
        plugins["RBibitem"] = addPluginPattern("RBibitem", "tag", [
            "atom"
        ]);
        plugins["DEFAULT"] = function() {
            this.name = "DEFAULT";
            this.style = "tag";
            this.styleIdentifier = this.openBracket = this.closeBracket = function() {};
        };
        return {
            startState: function startState() {
                var f = parserConfig.inMathMode ? function f(source, state) {
                    return inMathMode(source, state);
                } : normal;
                return {
                    cmdState: [],
                    f: f
                };
            },
            copyState: function copyState(s) {
                return {
                    cmdState: s.cmdState.slice(),
                    f: s.f
                };
            },
            token: function token(stream, state) {
                return state.f(stream, state);
            },
            blankLine: function blankLine(state) {
                state.f = normal;
                state.cmdState.length = 0;
            },
            lineComment: "%"
        };
    });
    CodeMirror1.defineMIME("text/x-stex", "stex");
    CodeMirror1.defineMIME("text/x-latex", "stex");
});
});

var lua = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// LUA mode. Ported to CodeMirror 2 from Franciszek Wawrzak's
// CodeMirror 1 mode.
// highlights keywords, strings, comments (no leveling supported! ("[==[")), tokens, basic indenting
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("lua", function(config, parserConfig) {
        var prefixRE = function prefixRE(words) {
            return new RegExp("^(?:" + words.join("|") + ")", "i");
        };
        var wordRE = function wordRE(words) {
            return new RegExp("^(?:" + words.join("|") + ")$", "i");
        };
        var readBracket = function readBracket(stream) {
            var level = 0;
            while(stream.eat("="))++level;
            stream.eat("[");
            return level;
        };
        var normal = function normal(stream, state) {
            var ch = stream.next();
            if (ch == "-" && stream.eat("-")) {
                if (stream.eat("[") && stream.eat("[")) return (state.cur = bracketed(readBracket(stream), "comment"))(stream, state);
                stream.skipToEnd();
                return "comment";
            }
            if (ch == '"' || ch == "'") return (state.cur = string(ch))(stream, state);
            if (ch == "[" && /[\[=]/.test(stream.peek())) return (state.cur = bracketed(readBracket(stream), "string"))(stream, state);
            if (/\d/.test(ch)) {
                stream.eatWhile(/[\w.%]/);
                return "number";
            }
            if (/[\w_]/.test(ch)) {
                stream.eatWhile(/[\w\\\-_.]/);
                return "variable";
            }
            return null;
        };
        var bracketed = function bracketed(level, style) {
            return function(stream, state) {
                var curlev = null, ch;
                while((ch = stream.next()) != null){
                    if (curlev == null) {
                        if (ch == "]") curlev = 0;
                    } else if (ch == "=") ++curlev;
                    else if (ch == "]" && curlev == level) {
                        state.cur = normal;
                        break;
                    } else curlev = null;
                }
                return style;
            };
        };
        var string = function string(quote) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) break;
                    escaped = !escaped && ch == "\\";
                }
                if (!escaped) state.cur = normal;
                return "string";
            };
        };
        var indentUnit = config.indentUnit;
        var specials = wordRE(parserConfig.specials || []);
        // long list of standard functions from lua manual
        var builtins = wordRE([
            "_G",
            "_VERSION",
            "assert",
            "collectgarbage",
            "dofile",
            "error",
            "getfenv",
            "getmetatable",
            "ipairs",
            "load",
            "loadfile",
            "loadstring",
            "module",
            "next",
            "pairs",
            "pcall",
            "print",
            "rawequal",
            "rawget",
            "rawset",
            "require",
            "select",
            "setfenv",
            "setmetatable",
            "tonumber",
            "tostring",
            "type",
            "unpack",
            "xpcall",
            "coroutine.create",
            "coroutine.resume",
            "coroutine.running",
            "coroutine.status",
            "coroutine.wrap",
            "coroutine.yield",
            "debug.debug",
            "debug.getfenv",
            "debug.gethook",
            "debug.getinfo",
            "debug.getlocal",
            "debug.getmetatable",
            "debug.getregistry",
            "debug.getupvalue",
            "debug.setfenv",
            "debug.sethook",
            "debug.setlocal",
            "debug.setmetatable",
            "debug.setupvalue",
            "debug.traceback",
            "close",
            "flush",
            "lines",
            "read",
            "seek",
            "setvbuf",
            "write",
            "io.close",
            "io.flush",
            "io.input",
            "io.lines",
            "io.open",
            "io.output",
            "io.popen",
            "io.read",
            "io.stderr",
            "io.stdin",
            "io.stdout",
            "io.tmpfile",
            "io.type",
            "io.write",
            "math.abs",
            "math.acos",
            "math.asin",
            "math.atan",
            "math.atan2",
            "math.ceil",
            "math.cos",
            "math.cosh",
            "math.deg",
            "math.exp",
            "math.floor",
            "math.fmod",
            "math.frexp",
            "math.huge",
            "math.ldexp",
            "math.log",
            "math.log10",
            "math.max",
            "math.min",
            "math.modf",
            "math.pi",
            "math.pow",
            "math.rad",
            "math.random",
            "math.randomseed",
            "math.sin",
            "math.sinh",
            "math.sqrt",
            "math.tan",
            "math.tanh",
            "os.clock",
            "os.date",
            "os.difftime",
            "os.execute",
            "os.exit",
            "os.getenv",
            "os.remove",
            "os.rename",
            "os.setlocale",
            "os.time",
            "os.tmpname",
            "package.cpath",
            "package.loaded",
            "package.loaders",
            "package.loadlib",
            "package.path",
            "package.preload",
            "package.seeall",
            "string.byte",
            "string.char",
            "string.dump",
            "string.find",
            "string.format",
            "string.gmatch",
            "string.gsub",
            "string.len",
            "string.lower",
            "string.match",
            "string.rep",
            "string.reverse",
            "string.sub",
            "string.upper",
            "table.concat",
            "table.insert",
            "table.maxn",
            "table.remove",
            "table.sort"
        ]);
        var keywords = wordRE([
            "and",
            "break",
            "elseif",
            "false",
            "nil",
            "not",
            "or",
            "return",
            "true",
            "function",
            "end",
            "if",
            "then",
            "else",
            "do",
            "while",
            "repeat",
            "until",
            "for",
            "in",
            "local"
        ]);
        var indentTokens = wordRE([
            "function",
            "if",
            "repeat",
            "do",
            "\\(",
            "{"
        ]);
        var dedentTokens = wordRE([
            "end",
            "until",
            "\\)",
            "}"
        ]);
        var dedentPartial = prefixRE([
            "end",
            "until",
            "\\)",
            "}",
            "else",
            "elseif"
        ]);
        return {
            startState: function startState(basecol) {
                return {
                    basecol: basecol || 0,
                    indentDepth: 0,
                    cur: normal
                };
            },
            token: function token(stream, state) {
                if (stream.eatSpace()) return null;
                var style = state.cur(stream, state);
                var word = stream.current();
                if (style == "variable") {
                    if (keywords.test(word)) style = "keyword";
                    else if (builtins.test(word)) style = "builtin";
                    else if (specials.test(word)) style = "variable-2";
                }
                if (style != "comment" && style != "string") {
                    if (indentTokens.test(word)) ++state.indentDepth;
                    else if (dedentTokens.test(word)) --state.indentDepth;
                }
                return style;
            },
            indent: function indent(state, textAfter) {
                var closing = dedentPartial.test(textAfter);
                return state.basecol + indentUnit * (state.indentDepth - (closing ? 1 : 0));
            },
            electricInput: /^\s*(?:end|until|else|\)|\})$/,
            lineComment: "--",
            blockCommentStart: "--[[",
            blockCommentEnd: "]]"
        };
    });
    CodeMirror1.defineMIME("text/x-lua", "lua");
});
});

var meta = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.modeInfo = [
        {
            name: "APL",
            mime: "text/apl",
            mode: "apl",
            ext: [
                "dyalog",
                "apl"
            ]
        },
        {
            name: "PGP",
            mimes: [
                "application/pgp",
                "application/pgp-encrypted",
                "application/pgp-keys",
                "application/pgp-signature"
            ],
            mode: "asciiarmor",
            ext: [
                "asc",
                "pgp",
                "sig"
            ]
        },
        {
            name: "ASN.1",
            mime: "text/x-ttcn-asn",
            mode: "asn.1",
            ext: [
                "asn",
                "asn1"
            ]
        },
        {
            name: "Asterisk",
            mime: "text/x-asterisk",
            mode: "asterisk",
            file: /^extensions\.conf$/i
        },
        {
            name: "Brainfuck",
            mime: "text/x-brainfuck",
            mode: "brainfuck",
            ext: [
                "b",
                "bf"
            ]
        },
        {
            name: "C",
            mime: "text/x-csrc",
            mode: "clike",
            ext: [
                "c",
                "h",
                "ino"
            ]
        },
        {
            name: "C++",
            mime: "text/x-c++src",
            mode: "clike",
            ext: [
                "cpp",
                "c++",
                "cc",
                "cxx",
                "hpp",
                "h++",
                "hh",
                "hxx"
            ],
            alias: [
                "cpp"
            ]
        },
        {
            name: "Cobol",
            mime: "text/x-cobol",
            mode: "cobol",
            ext: [
                "cob",
                "cpy",
                "cbl"
            ]
        },
        {
            name: "C#",
            mime: "text/x-csharp",
            mode: "clike",
            ext: [
                "cs"
            ],
            alias: [
                "csharp",
                "cs"
            ]
        },
        {
            name: "Clojure",
            mime: "text/x-clojure",
            mode: "clojure",
            ext: [
                "clj",
                "cljc",
                "cljx"
            ]
        },
        {
            name: "ClojureScript",
            mime: "text/x-clojurescript",
            mode: "clojure",
            ext: [
                "cljs"
            ]
        },
        {
            name: "Closure Stylesheets (GSS)",
            mime: "text/x-gss",
            mode: "css",
            ext: [
                "gss"
            ]
        },
        {
            name: "CMake",
            mime: "text/x-cmake",
            mode: "cmake",
            ext: [
                "cmake",
                "cmake.in"
            ],
            file: /^CMakeLists\.txt$/
        },
        {
            name: "CoffeeScript",
            mimes: [
                "application/vnd.coffeescript",
                "text/coffeescript",
                "text/x-coffeescript"
            ],
            mode: "coffeescript",
            ext: [
                "coffee"
            ],
            alias: [
                "coffee",
                "coffee-script"
            ]
        },
        {
            name: "Common Lisp",
            mime: "text/x-common-lisp",
            mode: "commonlisp",
            ext: [
                "cl",
                "lisp",
                "el"
            ],
            alias: [
                "lisp"
            ]
        },
        {
            name: "Cypher",
            mime: "application/x-cypher-query",
            mode: "cypher",
            ext: [
                "cyp",
                "cypher"
            ]
        },
        {
            name: "Cython",
            mime: "text/x-cython",
            mode: "python",
            ext: [
                "pyx",
                "pxd",
                "pxi"
            ]
        },
        {
            name: "Crystal",
            mime: "text/x-crystal",
            mode: "crystal",
            ext: [
                "cr"
            ]
        },
        {
            name: "CSS",
            mime: "text/css",
            mode: "css",
            ext: [
                "css"
            ]
        },
        {
            name: "CQL",
            mime: "text/x-cassandra",
            mode: "sql",
            ext: [
                "cql"
            ]
        },
        {
            name: "D",
            mime: "text/x-d",
            mode: "d",
            ext: [
                "d"
            ]
        },
        {
            name: "Dart",
            mimes: [
                "application/dart",
                "text/x-dart"
            ],
            mode: "dart",
            ext: [
                "dart"
            ]
        },
        {
            name: "diff",
            mime: "text/x-diff",
            mode: "diff",
            ext: [
                "diff",
                "patch"
            ]
        },
        {
            name: "Django",
            mime: "text/x-django",
            mode: "django"
        },
        {
            name: "Dockerfile",
            mime: "text/x-dockerfile",
            mode: "dockerfile",
            file: /^Dockerfile$/
        },
        {
            name: "DTD",
            mime: "application/xml-dtd",
            mode: "dtd",
            ext: [
                "dtd"
            ]
        },
        {
            name: "Dylan",
            mime: "text/x-dylan",
            mode: "dylan",
            ext: [
                "dylan",
                "dyl",
                "intr"
            ]
        },
        {
            name: "EBNF",
            mime: "text/x-ebnf",
            mode: "ebnf"
        },
        {
            name: "ECL",
            mime: "text/x-ecl",
            mode: "ecl",
            ext: [
                "ecl"
            ]
        },
        {
            name: "edn",
            mime: "application/edn",
            mode: "clojure",
            ext: [
                "edn"
            ]
        },
        {
            name: "Eiffel",
            mime: "text/x-eiffel",
            mode: "eiffel",
            ext: [
                "e"
            ]
        },
        {
            name: "Elm",
            mime: "text/x-elm",
            mode: "elm",
            ext: [
                "elm"
            ]
        },
        {
            name: "Embedded JavaScript",
            mime: "application/x-ejs",
            mode: "htmlembedded",
            ext: [
                "ejs"
            ]
        },
        {
            name: "Embedded Ruby",
            mime: "application/x-erb",
            mode: "htmlembedded",
            ext: [
                "erb"
            ]
        },
        {
            name: "Erlang",
            mime: "text/x-erlang",
            mode: "erlang",
            ext: [
                "erl"
            ]
        },
        {
            name: "Esper",
            mime: "text/x-esper",
            mode: "sql"
        },
        {
            name: "Factor",
            mime: "text/x-factor",
            mode: "factor",
            ext: [
                "factor"
            ]
        },
        {
            name: "FCL",
            mime: "text/x-fcl",
            mode: "fcl"
        },
        {
            name: "Forth",
            mime: "text/x-forth",
            mode: "forth",
            ext: [
                "forth",
                "fth",
                "4th"
            ]
        },
        {
            name: "Fortran",
            mime: "text/x-fortran",
            mode: "fortran",
            ext: [
                "f",
                "for",
                "f77",
                "f90",
                "f95"
            ]
        },
        {
            name: "F#",
            mime: "text/x-fsharp",
            mode: "mllike",
            ext: [
                "fs"
            ],
            alias: [
                "fsharp"
            ]
        },
        {
            name: "Gas",
            mime: "text/x-gas",
            mode: "gas",
            ext: [
                "s"
            ]
        },
        {
            name: "Gherkin",
            mime: "text/x-feature",
            mode: "gherkin",
            ext: [
                "feature"
            ]
        },
        {
            name: "GitHub Flavored Markdown",
            mime: "text/x-gfm",
            mode: "gfm",
            file: /^(readme|contributing|history)\.md$/i
        },
        {
            name: "Go",
            mime: "text/x-go",
            mode: "go",
            ext: [
                "go"
            ]
        },
        {
            name: "Groovy",
            mime: "text/x-groovy",
            mode: "groovy",
            ext: [
                "groovy",
                "gradle"
            ],
            file: /^Jenkinsfile$/
        },
        {
            name: "HAML",
            mime: "text/x-haml",
            mode: "haml",
            ext: [
                "haml"
            ]
        },
        {
            name: "Haskell",
            mime: "text/x-haskell",
            mode: "haskell",
            ext: [
                "hs"
            ]
        },
        {
            name: "Haskell (Literate)",
            mime: "text/x-literate-haskell",
            mode: "haskell-literate",
            ext: [
                "lhs"
            ]
        },
        {
            name: "Haxe",
            mime: "text/x-haxe",
            mode: "haxe",
            ext: [
                "hx"
            ]
        },
        {
            name: "HXML",
            mime: "text/x-hxml",
            mode: "haxe",
            ext: [
                "hxml"
            ]
        },
        {
            name: "ASP.NET",
            mime: "application/x-aspx",
            mode: "htmlembedded",
            ext: [
                "aspx"
            ],
            alias: [
                "asp",
                "aspx"
            ]
        },
        {
            name: "HTML",
            mime: "text/html",
            mode: "htmlmixed",
            ext: [
                "html",
                "htm",
                "handlebars",
                "hbs"
            ],
            alias: [
                "xhtml"
            ]
        },
        {
            name: "HTTP",
            mime: "message/http",
            mode: "http"
        },
        {
            name: "IDL",
            mime: "text/x-idl",
            mode: "idl",
            ext: [
                "pro"
            ]
        },
        {
            name: "Pug",
            mime: "text/x-pug",
            mode: "pug",
            ext: [
                "jade",
                "pug"
            ],
            alias: [
                "jade"
            ]
        },
        {
            name: "Java",
            mime: "text/x-java",
            mode: "clike",
            ext: [
                "java"
            ]
        },
        {
            name: "Java Server Pages",
            mime: "application/x-jsp",
            mode: "htmlembedded",
            ext: [
                "jsp"
            ],
            alias: [
                "jsp"
            ]
        },
        {
            name: "JavaScript",
            mimes: [
                "text/javascript",
                "text/ecmascript",
                "application/javascript",
                "application/x-javascript",
                "application/ecmascript"
            ],
            mode: "javascript",
            ext: [
                "js"
            ],
            alias: [
                "ecmascript",
                "js",
                "node"
            ]
        },
        {
            name: "JSON",
            mimes: [
                "application/json",
                "application/x-json"
            ],
            mode: "javascript",
            ext: [
                "json",
                "map"
            ],
            alias: [
                "json5"
            ]
        },
        {
            name: "JSON-LD",
            mime: "application/ld+json",
            mode: "javascript",
            ext: [
                "jsonld"
            ],
            alias: [
                "jsonld"
            ]
        },
        {
            name: "JSX",
            mime: "text/jsx",
            mode: "jsx",
            ext: [
                "jsx"
            ]
        },
        {
            name: "Jinja2",
            mime: "text/jinja2",
            mode: "jinja2",
            ext: [
                "j2",
                "jinja",
                "jinja2"
            ]
        },
        {
            name: "Julia",
            mime: "text/x-julia",
            mode: "julia",
            ext: [
                "jl"
            ],
            alias: [
                "jl"
            ]
        },
        {
            name: "Kotlin",
            mime: "text/x-kotlin",
            mode: "clike",
            ext: [
                "kt"
            ]
        },
        {
            name: "LESS",
            mime: "text/x-less",
            mode: "css",
            ext: [
                "less"
            ]
        },
        {
            name: "LiveScript",
            mime: "text/x-livescript",
            mode: "livescript",
            ext: [
                "ls"
            ],
            alias: [
                "ls"
            ]
        },
        {
            name: "Lua",
            mime: "text/x-lua",
            mode: "lua",
            ext: [
                "lua"
            ]
        },
        {
            name: "Markdown",
            mime: "text/x-markdown",
            mode: "markdown",
            ext: [
                "markdown",
                "md",
                "mkd"
            ]
        },
        {
            name: "mIRC",
            mime: "text/mirc",
            mode: "mirc"
        },
        {
            name: "MariaDB SQL",
            mime: "text/x-mariadb",
            mode: "sql"
        },
        {
            name: "Mathematica",
            mime: "text/x-mathematica",
            mode: "mathematica",
            ext: [
                "m",
                "nb",
                "wl",
                "wls"
            ]
        },
        {
            name: "Modelica",
            mime: "text/x-modelica",
            mode: "modelica",
            ext: [
                "mo"
            ]
        },
        {
            name: "MUMPS",
            mime: "text/x-mumps",
            mode: "mumps",
            ext: [
                "mps"
            ]
        },
        {
            name: "MS SQL",
            mime: "text/x-mssql",
            mode: "sql"
        },
        {
            name: "mbox",
            mime: "application/mbox",
            mode: "mbox",
            ext: [
                "mbox"
            ]
        },
        {
            name: "MySQL",
            mime: "text/x-mysql",
            mode: "sql"
        },
        {
            name: "Nginx",
            mime: "text/x-nginx-conf",
            mode: "nginx",
            file: /nginx.*\.conf$/i
        },
        {
            name: "NSIS",
            mime: "text/x-nsis",
            mode: "nsis",
            ext: [
                "nsh",
                "nsi"
            ]
        },
        {
            name: "NTriples",
            mimes: [
                "application/n-triples",
                "application/n-quads",
                "text/n-triples"
            ],
            mode: "ntriples",
            ext: [
                "nt",
                "nq"
            ]
        },
        {
            name: "Objective-C",
            mime: "text/x-objectivec",
            mode: "clike",
            ext: [
                "m"
            ],
            alias: [
                "objective-c",
                "objc"
            ]
        },
        {
            name: "Objective-C++",
            mime: "text/x-objectivec++",
            mode: "clike",
            ext: [
                "mm"
            ],
            alias: [
                "objective-c++",
                "objc++"
            ]
        },
        {
            name: "OCaml",
            mime: "text/x-ocaml",
            mode: "mllike",
            ext: [
                "ml",
                "mli",
                "mll",
                "mly"
            ]
        },
        {
            name: "Octave",
            mime: "text/x-octave",
            mode: "octave",
            ext: [
                "m"
            ]
        },
        {
            name: "Oz",
            mime: "text/x-oz",
            mode: "oz",
            ext: [
                "oz"
            ]
        },
        {
            name: "Pascal",
            mime: "text/x-pascal",
            mode: "pascal",
            ext: [
                "p",
                "pas"
            ]
        },
        {
            name: "PEG.js",
            mime: "null",
            mode: "pegjs",
            ext: [
                "jsonld"
            ]
        },
        {
            name: "Perl",
            mime: "text/x-perl",
            mode: "perl",
            ext: [
                "pl",
                "pm"
            ]
        },
        {
            name: "PHP",
            mimes: [
                "text/x-php",
                "application/x-httpd-php",
                "application/x-httpd-php-open"
            ],
            mode: "php",
            ext: [
                "php",
                "php3",
                "php4",
                "php5",
                "php7",
                "phtml"
            ]
        },
        {
            name: "Pig",
            mime: "text/x-pig",
            mode: "pig",
            ext: [
                "pig"
            ]
        },
        {
            name: "Plain Text",
            mime: "text/plain",
            mode: "null",
            ext: [
                "txt",
                "text",
                "conf",
                "def",
                "list",
                "log"
            ]
        },
        {
            name: "PLSQL",
            mime: "text/x-plsql",
            mode: "sql",
            ext: [
                "pls"
            ]
        },
        {
            name: "PostgreSQL",
            mime: "text/x-pgsql",
            mode: "sql"
        },
        {
            name: "PowerShell",
            mime: "application/x-powershell",
            mode: "powershell",
            ext: [
                "ps1",
                "psd1",
                "psm1"
            ]
        },
        {
            name: "Properties files",
            mime: "text/x-properties",
            mode: "properties",
            ext: [
                "properties",
                "ini",
                "in"
            ],
            alias: [
                "ini",
                "properties"
            ]
        },
        {
            name: "ProtoBuf",
            mime: "text/x-protobuf",
            mode: "protobuf",
            ext: [
                "proto"
            ]
        },
        {
            name: "Python",
            mime: "text/x-python",
            mode: "python",
            ext: [
                "BUILD",
                "bzl",
                "py",
                "pyw"
            ],
            file: /^(BUCK|BUILD)$/
        },
        {
            name: "Puppet",
            mime: "text/x-puppet",
            mode: "puppet",
            ext: [
                "pp"
            ]
        },
        {
            name: "Q",
            mime: "text/x-q",
            mode: "q",
            ext: [
                "q"
            ]
        },
        {
            name: "R",
            mime: "text/x-rsrc",
            mode: "r",
            ext: [
                "r",
                "R"
            ],
            alias: [
                "rscript"
            ]
        },
        {
            name: "reStructuredText",
            mime: "text/x-rst",
            mode: "rst",
            ext: [
                "rst"
            ],
            alias: [
                "rst"
            ]
        },
        {
            name: "RPM Changes",
            mime: "text/x-rpm-changes",
            mode: "rpm"
        },
        {
            name: "RPM Spec",
            mime: "text/x-rpm-spec",
            mode: "rpm",
            ext: [
                "spec"
            ]
        },
        {
            name: "Ruby",
            mime: "text/x-ruby",
            mode: "ruby",
            ext: [
                "rb"
            ],
            alias: [
                "jruby",
                "macruby",
                "rake",
                "rb",
                "rbx"
            ]
        },
        {
            name: "Rust",
            mime: "text/x-rustsrc",
            mode: "rust",
            ext: [
                "rs"
            ]
        },
        {
            name: "SAS",
            mime: "text/x-sas",
            mode: "sas",
            ext: [
                "sas"
            ]
        },
        {
            name: "Sass",
            mime: "text/x-sass",
            mode: "sass",
            ext: [
                "sass"
            ]
        },
        {
            name: "Scala",
            mime: "text/x-scala",
            mode: "clike",
            ext: [
                "scala"
            ]
        },
        {
            name: "Scheme",
            mime: "text/x-scheme",
            mode: "scheme",
            ext: [
                "scm",
                "ss"
            ]
        },
        {
            name: "SCSS",
            mime: "text/x-scss",
            mode: "css",
            ext: [
                "scss"
            ]
        },
        {
            name: "Shell",
            mimes: [
                "text/x-sh",
                "application/x-sh"
            ],
            mode: "shell",
            ext: [
                "sh",
                "ksh",
                "bash"
            ],
            alias: [
                "bash",
                "sh",
                "zsh"
            ],
            file: /^PKGBUILD$/
        },
        {
            name: "Sieve",
            mime: "application/sieve",
            mode: "sieve",
            ext: [
                "siv",
                "sieve"
            ]
        },
        {
            name: "Slim",
            mimes: [
                "text/x-slim",
                "application/x-slim"
            ],
            mode: "slim",
            ext: [
                "slim"
            ]
        },
        {
            name: "Smalltalk",
            mime: "text/x-stsrc",
            mode: "smalltalk",
            ext: [
                "st"
            ]
        },
        {
            name: "Smarty",
            mime: "text/x-smarty",
            mode: "smarty",
            ext: [
                "tpl"
            ]
        },
        {
            name: "Solr",
            mime: "text/x-solr",
            mode: "solr"
        },
        {
            name: "SML",
            mime: "text/x-sml",
            mode: "mllike",
            ext: [
                "sml",
                "sig",
                "fun",
                "smackspec"
            ]
        },
        {
            name: "Soy",
            mime: "text/x-soy",
            mode: "soy",
            ext: [
                "soy"
            ],
            alias: [
                "closure template"
            ]
        },
        {
            name: "SPARQL",
            mime: "application/sparql-query",
            mode: "sparql",
            ext: [
                "rq",
                "sparql"
            ],
            alias: [
                "sparul"
            ]
        },
        {
            name: "Spreadsheet",
            mime: "text/x-spreadsheet",
            mode: "spreadsheet",
            alias: [
                "excel",
                "formula"
            ]
        },
        {
            name: "SQL",
            mime: "text/x-sql",
            mode: "sql",
            ext: [
                "sql"
            ]
        },
        {
            name: "SQLite",
            mime: "text/x-sqlite",
            mode: "sql"
        },
        {
            name: "Squirrel",
            mime: "text/x-squirrel",
            mode: "clike",
            ext: [
                "nut"
            ]
        },
        {
            name: "Stylus",
            mime: "text/x-styl",
            mode: "stylus",
            ext: [
                "styl"
            ]
        },
        {
            name: "Swift",
            mime: "text/x-swift",
            mode: "swift",
            ext: [
                "swift"
            ]
        },
        {
            name: "sTeX",
            mime: "text/x-stex",
            mode: "stex"
        },
        {
            name: "LaTeX",
            mime: "text/x-latex",
            mode: "stex",
            ext: [
                "text",
                "ltx",
                "tex"
            ],
            alias: [
                "tex"
            ]
        },
        {
            name: "SystemVerilog",
            mime: "text/x-systemverilog",
            mode: "verilog",
            ext: [
                "v",
                "sv",
                "svh"
            ]
        },
        {
            name: "Tcl",
            mime: "text/x-tcl",
            mode: "tcl",
            ext: [
                "tcl"
            ]
        },
        {
            name: "Textile",
            mime: "text/x-textile",
            mode: "textile",
            ext: [
                "textile"
            ]
        },
        {
            name: "TiddlyWiki",
            mime: "text/x-tiddlywiki",
            mode: "tiddlywiki"
        },
        {
            name: "Tiki wiki",
            mime: "text/tiki",
            mode: "tiki"
        },
        {
            name: "TOML",
            mime: "text/x-toml",
            mode: "toml",
            ext: [
                "toml"
            ]
        },
        {
            name: "Tornado",
            mime: "text/x-tornado",
            mode: "tornado"
        },
        {
            name: "troff",
            mime: "text/troff",
            mode: "troff",
            ext: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9"
            ]
        },
        {
            name: "TTCN",
            mime: "text/x-ttcn",
            mode: "ttcn",
            ext: [
                "ttcn",
                "ttcn3",
                "ttcnpp"
            ]
        },
        {
            name: "TTCN_CFG",
            mime: "text/x-ttcn-cfg",
            mode: "ttcn-cfg",
            ext: [
                "cfg"
            ]
        },
        {
            name: "Turtle",
            mime: "text/turtle",
            mode: "turtle",
            ext: [
                "ttl"
            ]
        },
        {
            name: "TypeScript",
            mime: "application/typescript",
            mode: "javascript",
            ext: [
                "ts"
            ],
            alias: [
                "ts"
            ]
        },
        {
            name: "TypeScript-JSX",
            mime: "text/typescript-jsx",
            mode: "jsx",
            ext: [
                "tsx"
            ],
            alias: [
                "tsx"
            ]
        },
        {
            name: "Twig",
            mime: "text/x-twig",
            mode: "twig"
        },
        {
            name: "Web IDL",
            mime: "text/x-webidl",
            mode: "webidl",
            ext: [
                "webidl"
            ]
        },
        {
            name: "VB.NET",
            mime: "text/x-vb",
            mode: "vb",
            ext: [
                "vb"
            ]
        },
        {
            name: "VBScript",
            mime: "text/vbscript",
            mode: "vbscript",
            ext: [
                "vbs"
            ]
        },
        {
            name: "Velocity",
            mime: "text/velocity",
            mode: "velocity",
            ext: [
                "vtl"
            ]
        },
        {
            name: "Verilog",
            mime: "text/x-verilog",
            mode: "verilog",
            ext: [
                "v"
            ]
        },
        {
            name: "VHDL",
            mime: "text/x-vhdl",
            mode: "vhdl",
            ext: [
                "vhd",
                "vhdl"
            ]
        },
        {
            name: "Vue.js Component",
            mimes: [
                "script/x-vue",
                "text/x-vue"
            ],
            mode: "vue",
            ext: [
                "vue"
            ]
        },
        {
            name: "XML",
            mimes: [
                "application/xml",
                "text/xml"
            ],
            mode: "xml",
            ext: [
                "xml",
                "xsl",
                "xsd",
                "svg"
            ],
            alias: [
                "rss",
                "wsdl",
                "xsd"
            ]
        },
        {
            name: "XQuery",
            mime: "application/xquery",
            mode: "xquery",
            ext: [
                "xy",
                "xquery"
            ]
        },
        {
            name: "Yacas",
            mime: "text/x-yacas",
            mode: "yacas",
            ext: [
                "ys"
            ]
        },
        {
            name: "YAML",
            mimes: [
                "text/x-yaml",
                "text/yaml"
            ],
            mode: "yaml",
            ext: [
                "yaml",
                "yml"
            ],
            alias: [
                "yml"
            ]
        },
        {
            name: "Z80",
            mime: "text/x-z80",
            mode: "z80",
            ext: [
                "z80"
            ]
        },
        {
            name: "mscgen",
            mime: "text/x-mscgen",
            mode: "mscgen",
            ext: [
                "mscgen",
                "mscin",
                "msc"
            ]
        },
        {
            name: "xu",
            mime: "text/x-xu",
            mode: "mscgen",
            ext: [
                "xu"
            ]
        },
        {
            name: "msgenny",
            mime: "text/x-msgenny",
            mode: "mscgen",
            ext: [
                "msgenny"
            ]
        },
        {
            name: "WebAssembly",
            mime: "text/webassembly",
            mode: "wast",
            ext: [
                "wat",
                "wast"
            ]
        }
    ];
    // Ensure all modes have a mime property for backwards compatibility
    for(var i = 0; i < CodeMirror1.modeInfo.length; i++){
        var info = CodeMirror1.modeInfo[i];
        if (info.mimes) info.mime = info.mimes[0];
    }
    CodeMirror1.findModeByMIME = function(mime) {
        mime = mime.toLowerCase();
        for(var i = 0; i < CodeMirror1.modeInfo.length; i++){
            var info = CodeMirror1.modeInfo[i];
            if (info.mime == mime) return info;
            if (info.mimes) {
                for(var j = 0; j < info.mimes.length; j++)if (info.mimes[j] == mime) return info;
            }
        }
        if (/\+xml$/.test(mime)) return CodeMirror1.findModeByMIME("application/xml");
        if (/\+json$/.test(mime)) return CodeMirror1.findModeByMIME("application/json");
    };
    CodeMirror1.findModeByExtension = function(ext) {
        ext = ext.toLowerCase();
        for(var i = 0; i < CodeMirror1.modeInfo.length; i++){
            var info = CodeMirror1.modeInfo[i];
            if (info.ext) {
                for(var j = 0; j < info.ext.length; j++)if (info.ext[j] == ext) return info;
            }
        }
    };
    CodeMirror1.findModeByFileName = function(filename) {
        for(var i = 0; i < CodeMirror1.modeInfo.length; i++){
            var info = CodeMirror1.modeInfo[i];
            if (info.file && info.file.test(filename)) return info;
        }
        var dot = filename.lastIndexOf(".");
        var ext = dot > -1 && filename.substring(dot + 1, filename.length);
        if (ext) return CodeMirror1.findModeByExtension(ext);
    };
    CodeMirror1.findModeByName = function(name) {
        name = name.toLowerCase();
        for(var i = 0; i < CodeMirror1.modeInfo.length; i++){
            var info = CodeMirror1.modeInfo[i];
            if (info.name.toLowerCase() == name) return info;
            if (info.alias) {
                for(var j = 0; j < info.alias.length; j++)if (info.alias[j].toLowerCase() == name) return info;
            }
        }
    };
});
});

var markdown = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, xml, meta);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("markdown", function(cmCfg, modeCfg) {
        var getMode = function getMode(name) {
            if (CodeMirror1.findModeByName) {
                var found = CodeMirror1.findModeByName(name);
                if (found) name = found.mime || found.mimes[0];
            }
            var mode = CodeMirror1.getMode(cmCfg, name);
            return mode.name == "null" ? null : mode;
        };
        var switchInline = function switchInline(stream, state, f) {
            state.f = state.inline = f;
            return f(stream, state);
        };
        var switchBlock = function switchBlock(stream, state, f) {
            state.f = state.block = f;
            return f(stream, state);
        };
        var lineIsEmpty = function lineIsEmpty(line) {
            return !line || !/\S/.test(line.string);
        };
        var blankLine = // Blocks
        function blankLine(state) {
            // Reset linkTitle state
            state.linkTitle = false;
            state.linkHref = false;
            state.linkText = false;
            // Reset EM state
            state.em = false;
            // Reset STRONG state
            state.strong = false;
            // Reset strikethrough state
            state.strikethrough = false;
            // Reset state.quote
            state.quote = 0;
            // Reset state.indentedCode
            state.indentedCode = false;
            if (state.f == htmlBlock) {
                var exit = htmlModeMissing;
                if (!exit) {
                    var inner = CodeMirror1.innerMode(htmlMode, state.htmlState);
                    exit = inner.mode.name == "xml" && inner.state.tagStart === null && !inner.state.context && inner.state.tokenize.isInText;
                }
                if (exit) {
                    state.f = inlineNormal;
                    state.block = blockNormal;
                    state.htmlState = null;
                }
            }
            // Reset state.trailingSpace
            state.trailingSpace = 0;
            state.trailingSpaceNewLine = false;
            // Mark this line as blank
            state.prevLine = state.thisLine;
            state.thisLine = {
                stream: null
            };
            return null;
        };
        var blockNormal = function blockNormal(stream, state) {
            var firstTokenOnLine = stream.column() === state.indentation;
            var prevLineLineIsEmpty = lineIsEmpty(state.prevLine.stream);
            var prevLineIsIndentedCode = state.indentedCode;
            var prevLineIsHr = state.prevLine.hr;
            var prevLineIsList = state.list !== false;
            var maxNonCodeIndentation = (state.listStack[state.listStack.length - 1] || 0) + 3;
            state.indentedCode = false;
            var lineIndentation = state.indentation;
            // compute once per line (on first token)
            if (state.indentationDiff === null) {
                state.indentationDiff = state.indentation;
                if (prevLineIsList) {
                    state.list = null;
                    // While this list item's marker's indentation is less than the deepest
                    //  list item's content's indentation,pop the deepest list item
                    //  indentation off the stack, and update block indentation state
                    while(lineIndentation < state.listStack[state.listStack.length - 1]){
                        state.listStack.pop();
                        if (state.listStack.length) {
                            state.indentation = state.listStack[state.listStack.length - 1];
                        // less than the first list's indent -> the line is no longer a list
                        } else {
                            state.list = false;
                        }
                    }
                    if (state.list !== false) {
                        state.indentationDiff = lineIndentation - state.listStack[state.listStack.length - 1];
                    }
                }
            }
            // not comprehensive (currently only for setext detection purposes)
            var allowsInlineContinuation = !prevLineLineIsEmpty && !prevLineIsHr && !state.prevLine.header && (!prevLineIsList || !prevLineIsIndentedCode) && !state.prevLine.fencedCodeEnd;
            var isHr = (state.list === false || prevLineIsHr || prevLineLineIsEmpty) && state.indentation <= maxNonCodeIndentation && stream.match(hrRE);
            var match = null;
            if (state.indentationDiff >= 4 && (prevLineIsIndentedCode || state.prevLine.fencedCodeEnd || state.prevLine.header || prevLineLineIsEmpty)) {
                stream.skipToEnd();
                state.indentedCode = true;
                return tokenTypes.code;
            } else if (stream.eatSpace()) {
                return null;
            } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(atxHeaderRE)) && match[1].length <= 6) {
                state.quote = 0;
                state.header = match[1].length;
                state.thisLine.header = true;
                if (modeCfg.highlightFormatting) state.formatting = "header";
                state.f = state.inline;
                return getType(state);
            } else if (state.indentation <= maxNonCodeIndentation && stream.eat(">")) {
                state.quote = firstTokenOnLine ? 1 : state.quote + 1;
                if (modeCfg.highlightFormatting) state.formatting = "quote";
                stream.eatSpace();
                return getType(state);
            } else if (!isHr && !state.setext && firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(listRE))) {
                var listType = match[1] ? "ol" : "ul";
                state.indentation = lineIndentation + stream.current().length;
                state.list = true;
                state.quote = 0;
                // Add this list item's content's indentation to the stack
                state.listStack.push(state.indentation);
                // Reset inline styles which shouldn't propagate across list items
                state.em = false;
                state.strong = false;
                state.code = false;
                state.strikethrough = false;
                if (modeCfg.taskLists && stream.match(taskListRE, false)) {
                    state.taskList = true;
                }
                state.f = state.inline;
                if (modeCfg.highlightFormatting) state.formatting = [
                    "list",
                    "list-" + listType
                ];
                return getType(state);
            } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(fencedCodeRE, true))) {
                state.quote = 0;
                state.fencedEndRE = new RegExp(match[1] + "+ *$");
                // try switching mode
                state.localMode = modeCfg.fencedCodeBlockHighlighting && getMode(match[2] || modeCfg.fencedCodeBlockDefaultMode);
                if (state.localMode) state.localState = CodeMirror1.startState(state.localMode);
                state.f = state.block = local;
                if (modeCfg.highlightFormatting) state.formatting = "code-block";
                state.code = -1;
                return getType(state);
            // SETEXT has lowest block-scope precedence after HR, so check it after
            //  the others (code, blockquote, list...)
            } else if (// if setext set, indicates line after ---/===
            state.setext || // line before ---/===
            (!allowsInlineContinuation || !prevLineIsList) && !state.quote && state.list === false && !state.code && !isHr && !linkDefRE.test(stream.string) && (match = stream.lookAhead(1)) && (match = match.match(setextHeaderRE))) {
                if (!state.setext) {
                    state.header = match[0].charAt(0) == "=" ? 1 : 2;
                    state.setext = state.header;
                } else {
                    state.header = state.setext;
                    // has no effect on type so we can reset it now
                    state.setext = 0;
                    stream.skipToEnd();
                    if (modeCfg.highlightFormatting) state.formatting = "header";
                }
                state.thisLine.header = true;
                state.f = state.inline;
                return getType(state);
            } else if (isHr) {
                stream.skipToEnd();
                state.hr = true;
                state.thisLine.hr = true;
                return tokenTypes.hr;
            } else if (stream.peek() === "[") {
                return switchInline(stream, state, footnoteLink);
            }
            return switchInline(stream, state, state.inline);
        };
        var htmlBlock = function htmlBlock(stream, state) {
            var style = htmlMode.token(stream, state.htmlState);
            if (!htmlModeMissing) {
                var inner = CodeMirror1.innerMode(htmlMode, state.htmlState);
                if (inner.mode.name == "xml" && inner.state.tagStart === null && !inner.state.context && inner.state.tokenize.isInText || state.md_inside && stream.current().indexOf(">") > -1) {
                    state.f = inlineNormal;
                    state.block = blockNormal;
                    state.htmlState = null;
                }
            }
            return style;
        };
        var local = function local(stream, state) {
            var currListInd = state.listStack[state.listStack.length - 1] || 0;
            var hasExitedList = state.indentation < currListInd;
            var maxFencedEndInd = currListInd + 3;
            if (state.fencedEndRE && state.indentation <= maxFencedEndInd && (hasExitedList || stream.match(state.fencedEndRE))) {
                if (modeCfg.highlightFormatting) state.formatting = "code-block";
                var returnType;
                if (!hasExitedList) returnType = getType(state);
                state.localMode = state.localState = null;
                state.block = blockNormal;
                state.f = inlineNormal;
                state.fencedEndRE = null;
                state.code = 0;
                state.thisLine.fencedCodeEnd = true;
                if (hasExitedList) return switchBlock(stream, state, state.block);
                return returnType;
            } else if (state.localMode) {
                return state.localMode.token(stream, state.localState);
            } else {
                stream.skipToEnd();
                return tokenTypes.code;
            }
        };
        var getType = // Inline
        function getType(state) {
            var styles = [];
            if (state.formatting) {
                styles.push(tokenTypes.formatting);
                if (typeof state.formatting === "string") state.formatting = [
                    state.formatting
                ];
                for(var i = 0; i < state.formatting.length; i++){
                    styles.push(tokenTypes.formatting + "-" + state.formatting[i]);
                    if (state.formatting[i] === "header") {
                        styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.header);
                    }
                    // Add `formatting-quote` and `formatting-quote-#` for blockquotes
                    // Add `error` instead if the maximum blockquote nesting depth is passed
                    if (state.formatting[i] === "quote") {
                        if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
                            styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.quote);
                        } else {
                            styles.push("error");
                        }
                    }
                }
            }
            if (state.taskOpen) {
                styles.push("meta");
                return styles.length ? styles.join(" ") : null;
            }
            if (state.taskClosed) {
                styles.push("property");
                return styles.length ? styles.join(" ") : null;
            }
            if (state.linkHref) {
                styles.push(tokenTypes.linkHref, "url");
            } else {
                if (state.strong) {
                    styles.push(tokenTypes.strong);
                }
                if (state.em) {
                    styles.push(tokenTypes.em);
                }
                if (state.strikethrough) {
                    styles.push(tokenTypes.strikethrough);
                }
                if (state.emoji) {
                    styles.push(tokenTypes.emoji);
                }
                if (state.linkText) {
                    styles.push(tokenTypes.linkText);
                }
                if (state.code) {
                    styles.push(tokenTypes.code);
                }
                if (state.image) {
                    styles.push(tokenTypes.image);
                }
                if (state.imageAltText) {
                    styles.push(tokenTypes.imageAltText, "link");
                }
                if (state.imageMarker) {
                    styles.push(tokenTypes.imageMarker);
                }
            }
            if (state.header) {
                styles.push(tokenTypes.header, tokenTypes.header + "-" + state.header);
            }
            if (state.quote) {
                styles.push(tokenTypes.quote);
                // Add `quote-#` where the maximum for `#` is modeCfg.maxBlockquoteDepth
                if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
                    styles.push(tokenTypes.quote + "-" + state.quote);
                } else {
                    styles.push(tokenTypes.quote + "-" + modeCfg.maxBlockquoteDepth);
                }
            }
            if (state.list !== false) {
                var listMod = (state.listStack.length - 1) % 3;
                if (!listMod) {
                    styles.push(tokenTypes.list1);
                } else if (listMod === 1) {
                    styles.push(tokenTypes.list2);
                } else {
                    styles.push(tokenTypes.list3);
                }
            }
            if (state.trailingSpaceNewLine) {
                styles.push("trailing-space-new-line");
            } else if (state.trailingSpace) {
                styles.push("trailing-space-" + (state.trailingSpace % 2 ? "a" : "b"));
            }
            return styles.length ? styles.join(" ") : null;
        };
        var handleText = function handleText(stream, state) {
            if (stream.match(textRE, true)) {
                return getType(state);
            }
            return undefined;
        };
        var linkInline = function linkInline(stream, state) {
            var ch = stream.next();
            if (ch === ">") {
                state.f = state.inline = inlineNormal;
                if (modeCfg.highlightFormatting) state.formatting = "link";
                var type = getType(state);
                if (type) {
                    type += " ";
                } else {
                    type = "";
                }
                return type + tokenTypes.linkInline;
            }
            stream.match(/^[^>]+/, true);
            return tokenTypes.linkInline;
        };
        var linkHref = function linkHref(stream, state) {
            // Check if space, and return NULL if so (to avoid marking the space)
            if (stream.eatSpace()) {
                return null;
            }
            var ch = stream.next();
            if (ch === "(" || ch === "[") {
                state.f = state.inline = getLinkHrefInside(ch === "(" ? ")" : "]");
                if (modeCfg.highlightFormatting) state.formatting = "link-string";
                state.linkHref = true;
                return getType(state);
            }
            return "error";
        };
        var getLinkHrefInside = function getLinkHrefInside(endChar) {
            return function(stream, state) {
                var ch = stream.next();
                if (ch === endChar) {
                    state.f = state.inline = inlineNormal;
                    if (modeCfg.highlightFormatting) state.formatting = "link-string";
                    var returnState = getType(state);
                    state.linkHref = false;
                    return returnState;
                }
                stream.match(linkRE[endChar]);
                state.linkHref = true;
                return getType(state);
            };
        };
        var footnoteLink = function footnoteLink(stream, state) {
            if (stream.match(/^([^\]\\]|\\.)*\]:/, false)) {
                state.f = footnoteLinkInside;
                stream.next(); // Consume [
                if (modeCfg.highlightFormatting) state.formatting = "link";
                state.linkText = true;
                return getType(state);
            }
            return switchInline(stream, state, inlineNormal);
        };
        var footnoteLinkInside = function footnoteLinkInside(stream, state) {
            if (stream.match("]:", true)) {
                state.f = state.inline = footnoteUrl;
                if (modeCfg.highlightFormatting) state.formatting = "link";
                var returnType = getType(state);
                state.linkText = false;
                return returnType;
            }
            stream.match(/^([^\]\\]|\\.)+/, true);
            return tokenTypes.linkText;
        };
        var footnoteUrl = function footnoteUrl(stream, state) {
            // Check if space, and return NULL if so (to avoid marking the space)
            if (stream.eatSpace()) {
                return null;
            }
            // Match URL
            stream.match(/^[^\s]+/, true);
            // Check for link title
            if (stream.peek() === undefined) {
                state.linkTitle = true;
            } else {
                stream.match(/^(?:\s+(?:"(?:[^"\\]|\\.)+"|'(?:[^'\\]|\\.)+'|\((?:[^)\\]|\\.)+\)))?/, true);
            }
            state.f = state.inline = inlineNormal;
            return tokenTypes.linkHref + " url";
        };
        var htmlMode = CodeMirror1.getMode(cmCfg, "text/html");
        var htmlModeMissing = htmlMode.name == "null";
        // Should characters that affect highlighting be highlighted separate?
        // Does not include characters that will be output (such as `1.` and `-` for lists)
        if (modeCfg.highlightFormatting === undefined) modeCfg.highlightFormatting = false;
        // Maximum number of nested blockquotes. Set to 0 for infinite nesting.
        // Excess `>` will emit `error` token.
        if (modeCfg.maxBlockquoteDepth === undefined) modeCfg.maxBlockquoteDepth = 0;
        // Turn on task lists? ("- [ ] " and "- [x] ")
        if (modeCfg.taskLists === undefined) modeCfg.taskLists = false;
        // Turn on strikethrough syntax
        if (modeCfg.strikethrough === undefined) modeCfg.strikethrough = false;
        if (modeCfg.emoji === undefined) modeCfg.emoji = false;
        if (modeCfg.fencedCodeBlockHighlighting === undefined) modeCfg.fencedCodeBlockHighlighting = true;
        if (modeCfg.fencedCodeBlockDefaultMode === undefined) modeCfg.fencedCodeBlockDefaultMode = "text/plain";
        if (modeCfg.xml === undefined) modeCfg.xml = true;
        // Allow token types to be overridden by user-provided token types.
        if (modeCfg.tokenTypeOverrides === undefined) modeCfg.tokenTypeOverrides = {};
        var tokenTypes = {
            header: "header",
            code: "comment",
            quote: "quote",
            list1: "variable-2",
            list2: "variable-3",
            list3: "keyword",
            hr: "hr",
            image: "image",
            imageAltText: "image-alt-text",
            imageMarker: "image-marker",
            formatting: "formatting",
            linkInline: "link",
            linkEmail: "link",
            linkText: "link",
            linkHref: "string",
            em: "em",
            strong: "strong",
            strikethrough: "strikethrough",
            emoji: "builtin"
        };
        for(var tokenType in tokenTypes){
            if (tokenTypes.hasOwnProperty(tokenType) && modeCfg.tokenTypeOverrides[tokenType]) {
                tokenTypes[tokenType] = modeCfg.tokenTypeOverrides[tokenType];
            }
        }
        var hrRE = /^([*\-_])(?:\s*\1){2,}\s*$/, listRE = /^(?:[*\-+]|^[0-9]+([.)]))\s+/, taskListRE = /^\[(x| )\](?=\s)/i // Must follow listRE
        , atxHeaderRE = modeCfg.allowAtxHeaderWithoutSpace ? /^(#+)/ : /^(#+)(?: |$)/, setextHeaderRE = /^ {0,3}(?:\={1,}|-{2,})\s*$/, textRE = /^[^#!\[\]*_\\<>` "'(~:]+/, fencedCodeRE = /^(~~~+|```+)[ \t]*([\w\/+#-]*)[^\n`]*$/, linkDefRE = /^\s*\[[^\]]+?\]:.*$/ // naive link-definition
        , punctuation = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/, expandedTab = "    " // CommonMark specifies tab as 4 spaces
        ;
        function inlineNormal(stream, state) {
            var style = state.text(stream, state);
            if (typeof style !== "undefined") return style;
            if (state.list) {
                state.list = null;
                return getType(state);
            }
            if (state.taskList) {
                var taskOpen = stream.match(taskListRE, true)[1] === " ";
                if (taskOpen) state.taskOpen = true;
                else state.taskClosed = true;
                if (modeCfg.highlightFormatting) state.formatting = "task";
                state.taskList = false;
                return getType(state);
            }
            state.taskOpen = false;
            state.taskClosed = false;
            if (state.header && stream.match(/^#+$/, true)) {
                if (modeCfg.highlightFormatting) state.formatting = "header";
                return getType(state);
            }
            var ch = stream.next();
            // Matches link titles present on next line
            if (state.linkTitle) {
                state.linkTitle = false;
                var matchCh = ch;
                if (ch === "(") {
                    matchCh = ")";
                }
                matchCh = (matchCh + "").replace(/([.?*+^\[\]\\(){}|-])/g, "\\$1");
                var regex = "^\\s*(?:[^" + matchCh + "\\\\]+|\\\\\\\\|\\\\.)" + matchCh;
                if (stream.match(new RegExp(regex), true)) {
                    return tokenTypes.linkHref;
                }
            }
            // If this block is changed, it may need to be updated in GFM mode
            if (ch === "`") {
                var previousFormatting = state.formatting;
                if (modeCfg.highlightFormatting) state.formatting = "code";
                stream.eatWhile("`");
                var count = stream.current().length;
                if (state.code == 0 && (!state.quote || count == 1)) {
                    state.code = count;
                    return getType(state);
                } else if (count == state.code) {
                    var t = getType(state);
                    state.code = 0;
                    return t;
                } else {
                    state.formatting = previousFormatting;
                    return getType(state);
                }
            } else if (state.code) {
                return getType(state);
            }
            if (ch === "\\") {
                stream.next();
                if (modeCfg.highlightFormatting) {
                    var type = getType(state);
                    var formattingEscape = tokenTypes.formatting + "-escape";
                    return type ? type + " " + formattingEscape : formattingEscape;
                }
            }
            if (ch === "!" && stream.match(/\[[^\]]*\] ?(?:\(|\[)/, false)) {
                state.imageMarker = true;
                state.image = true;
                if (modeCfg.highlightFormatting) state.formatting = "image";
                return getType(state);
            }
            if (ch === "[" && state.imageMarker && stream.match(/[^\]]*\](\(.*?\)| ?\[.*?\])/, false)) {
                state.imageMarker = false;
                state.imageAltText = true;
                if (modeCfg.highlightFormatting) state.formatting = "image";
                return getType(state);
            }
            if (ch === "]" && state.imageAltText) {
                if (modeCfg.highlightFormatting) state.formatting = "image";
                var type = getType(state);
                state.imageAltText = false;
                state.image = false;
                state.inline = state.f = linkHref;
                return type;
            }
            if (ch === "[" && !state.image) {
                if (state.linkText && stream.match(/^.*?\]/)) return getType(state);
                state.linkText = true;
                if (modeCfg.highlightFormatting) state.formatting = "link";
                return getType(state);
            }
            if (ch === "]" && state.linkText) {
                if (modeCfg.highlightFormatting) state.formatting = "link";
                var type = getType(state);
                state.linkText = false;
                state.inline = state.f = stream.match(/\(.*?\)| ?\[.*?\]/, false) ? linkHref : inlineNormal;
                return type;
            }
            if (ch === "<" && stream.match(/^(https?|ftps?):\/\/(?:[^\\>]|\\.)+>/, false)) {
                state.f = state.inline = linkInline;
                if (modeCfg.highlightFormatting) state.formatting = "link";
                var type = getType(state);
                if (type) {
                    type += " ";
                } else {
                    type = "";
                }
                return type + tokenTypes.linkInline;
            }
            if (ch === "<" && stream.match(/^[^> \\]+@(?:[^\\>]|\\.)+>/, false)) {
                state.f = state.inline = linkInline;
                if (modeCfg.highlightFormatting) state.formatting = "link";
                var type = getType(state);
                if (type) {
                    type += " ";
                } else {
                    type = "";
                }
                return type + tokenTypes.linkEmail;
            }
            if (modeCfg.xml && ch === "<" && stream.match(/^(!--|\?|!\[CDATA\[|[a-z][a-z0-9-]*(?:\s+[a-z_:.\-]+(?:\s*=\s*[^>]+)?)*\s*(?:>|$))/i, false)) {
                var end = stream.string.indexOf(">", stream.pos);
                if (end != -1) {
                    var atts = stream.string.substring(stream.start, end);
                    if (/markdown\s*=\s*('|"){0,1}1('|"){0,1}/.test(atts)) state.md_inside = true;
                }
                stream.backUp(1);
                state.htmlState = CodeMirror1.startState(htmlMode);
                return switchBlock(stream, state, htmlBlock);
            }
            if (modeCfg.xml && ch === "<" && stream.match(/^\/\w*?>/)) {
                state.md_inside = false;
                return "tag";
            } else if (ch === "*" || ch === "_") {
                var len = 1, before = stream.pos == 1 ? " " : stream.string.charAt(stream.pos - 2);
                while(len < 3 && stream.eat(ch))len++;
                var after = stream.peek() || " ";
                // See http://spec.commonmark.org/0.27/#emphasis-and-strong-emphasis
                var leftFlanking = !/\s/.test(after) && (!punctuation.test(after) || /\s/.test(before) || punctuation.test(before));
                var rightFlanking = !/\s/.test(before) && (!punctuation.test(before) || /\s/.test(after) || punctuation.test(after));
                var setEm = null, setStrong = null;
                if (len % 2) {
                    if (!state.em && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before))) setEm = true;
                    else if (state.em == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after))) setEm = false;
                }
                if (len > 1) {
                    if (!state.strong && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before))) setStrong = true;
                    else if (state.strong == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after))) setStrong = false;
                }
                if (setStrong != null || setEm != null) {
                    if (modeCfg.highlightFormatting) state.formatting = setEm == null ? "strong" : setStrong == null ? "em" : "strong em";
                    if (setEm === true) state.em = ch;
                    if (setStrong === true) state.strong = ch;
                    var t = getType(state);
                    if (setEm === false) state.em = false;
                    if (setStrong === false) state.strong = false;
                    return t;
                }
            } else if (ch === " ") {
                if (stream.eat("*") || stream.eat("_")) {
                    if (stream.peek() === " ") {
                        return getType(state);
                    } else {
                        stream.backUp(1);
                    }
                }
            }
            if (modeCfg.strikethrough) {
                if (ch === "~" && stream.eatWhile(ch)) {
                    if (state.strikethrough) {
                        if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
                        var t = getType(state);
                        state.strikethrough = false;
                        return t;
                    } else if (stream.match(/^[^\s]/, false)) {
                        state.strikethrough = true;
                        if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
                        return getType(state);
                    }
                } else if (ch === " ") {
                    if (stream.match("~~", true)) {
                        if (stream.peek() === " ") {
                            return getType(state);
                        } else {
                            stream.backUp(2);
                        }
                    }
                }
            }
            if (modeCfg.emoji && ch === ":" && stream.match(/^(?:[a-z_\d+][a-z_\d+-]*|\-[a-z_\d+][a-z_\d+-]*):/)) {
                state.emoji = true;
                if (modeCfg.highlightFormatting) state.formatting = "emoji";
                var retType = getType(state);
                state.emoji = false;
                return retType;
            }
            if (ch === " ") {
                if (stream.match(/^ +$/, false)) {
                    state.trailingSpace++;
                } else if (state.trailingSpace) {
                    state.trailingSpaceNewLine = true;
                }
            }
            return getType(state);
        }
        var linkRE = {
            ")": /^(?:[^\\\(\)]|\\.|\((?:[^\\\(\)]|\\.)*\))*?(?=\))/,
            "]": /^(?:[^\\\[\]]|\\.|\[(?:[^\\\[\]]|\\.)*\])*?(?=\])/
        };
        var mode = {
            startState: function startState() {
                return {
                    f: blockNormal,
                    prevLine: {
                        stream: null
                    },
                    thisLine: {
                        stream: null
                    },
                    block: blockNormal,
                    htmlState: null,
                    indentation: 0,
                    inline: inlineNormal,
                    text: handleText,
                    formatting: false,
                    linkText: false,
                    linkHref: false,
                    linkTitle: false,
                    code: 0,
                    em: false,
                    strong: false,
                    header: 0,
                    setext: 0,
                    hr: false,
                    taskList: false,
                    list: false,
                    listStack: [],
                    quote: 0,
                    trailingSpace: 0,
                    trailingSpaceNewLine: false,
                    strikethrough: false,
                    emoji: false,
                    fencedEndRE: null
                };
            },
            copyState: function copyState(s) {
                return {
                    f: s.f,
                    prevLine: s.prevLine,
                    thisLine: s.thisLine,
                    block: s.block,
                    htmlState: s.htmlState && CodeMirror1.copyState(htmlMode, s.htmlState),
                    indentation: s.indentation,
                    localMode: s.localMode,
                    localState: s.localMode ? CodeMirror1.copyState(s.localMode, s.localState) : null,
                    inline: s.inline,
                    text: s.text,
                    formatting: false,
                    linkText: s.linkText,
                    linkTitle: s.linkTitle,
                    linkHref: s.linkHref,
                    code: s.code,
                    em: s.em,
                    strong: s.strong,
                    strikethrough: s.strikethrough,
                    emoji: s.emoji,
                    header: s.header,
                    setext: s.setext,
                    hr: s.hr,
                    taskList: s.taskList,
                    list: s.list,
                    listStack: s.listStack.slice(0),
                    quote: s.quote,
                    indentedCode: s.indentedCode,
                    trailingSpace: s.trailingSpace,
                    trailingSpaceNewLine: s.trailingSpaceNewLine,
                    md_inside: s.md_inside,
                    fencedEndRE: s.fencedEndRE
                };
            },
            token: function token(stream, state) {
                // Reset state.formatting
                state.formatting = false;
                if (stream != state.thisLine.stream) {
                    state.header = 0;
                    state.hr = false;
                    if (stream.match(/^\s*$/, true)) {
                        blankLine(state);
                        return null;
                    }
                    state.prevLine = state.thisLine;
                    state.thisLine = {
                        stream: stream
                    };
                    // Reset state.taskList
                    state.taskList = false;
                    // Reset state.trailingSpace
                    state.trailingSpace = 0;
                    state.trailingSpaceNewLine = false;
                    if (!state.localState) {
                        state.f = state.block;
                        if (state.f != htmlBlock) {
                            var indentation = stream.match(/^\s*/, true)[0].replace(/\t/g, expandedTab).length;
                            state.indentation = indentation;
                            state.indentationDiff = null;
                            if (indentation > 0) return null;
                        }
                    }
                }
                return state.f(stream, state);
            },
            innerMode: function innerMode(state) {
                if (state.block == htmlBlock) return {
                    state: state.htmlState,
                    mode: htmlMode
                };
                if (state.localState) return {
                    state: state.localState,
                    mode: state.localMode
                };
                return {
                    state: state,
                    mode: mode
                };
            },
            indent: function indent(state, textAfter, line) {
                if (state.block == htmlBlock && htmlMode.indent) return htmlMode.indent(state.htmlState, textAfter, line);
                if (state.localState && state.localMode.indent) return state.localMode.indent(state.localState, textAfter, line);
                return CodeMirror1.Pass;
            },
            blankLine: blankLine,
            getType: getType,
            blockCommentStart: "<!--",
            blockCommentEnd: "-->",
            closeBrackets: "()[]{}''\"\"``",
            fold: "markdown"
        };
        return mode;
    }, "xml");
    CodeMirror1.defineMIME("text/markdown", "markdown");
    CodeMirror1.defineMIME("text/x-markdown", "markdown");
});
});

var nginx = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("nginx", function(config) {
        var words = function words(str) {
            var obj = {}, words = str.split(" ");
            for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
            return obj;
        };
        var ret = function ret(style, tp) {
            type = tp;
            return style;
        };
        var tokenBase = function tokenBase(stream, state) {
            stream.eatWhile(/[\w\$_]/);
            var cur = stream.current();
            if (keywords.propertyIsEnumerable(cur)) {
                return "keyword";
            } else if (keywords_block.propertyIsEnumerable(cur)) {
                return "variable-2";
            } else if (keywords_important.propertyIsEnumerable(cur)) {
                return "string-2";
            }
            /**/ var ch = stream.next();
            if (ch == "@") {
                stream.eatWhile(/[\w\\\-]/);
                return ret("meta", stream.current());
            } else if (ch == "/" && stream.eat("*")) {
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            } else if (ch == "<" && stream.eat("!")) {
                state.tokenize = tokenSGMLComment;
                return tokenSGMLComment(stream, state);
            } else if (ch == "=") ret(null, "compare");
            else if ((ch == "~" || ch == "|") && stream.eat("=")) return ret(null, "compare");
            else if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "#") {
                stream.skipToEnd();
                return ret("comment", "comment");
            } else if (ch == "!") {
                stream.match(/^\s*\w*/);
                return ret("keyword", "important");
            } else if (/\d/.test(ch)) {
                stream.eatWhile(/[\w.%]/);
                return ret("number", "unit");
            } else if (/[,.+>*\/]/.test(ch)) {
                return ret(null, "select-op");
            } else if (/[;{}:\[\]]/.test(ch)) {
                return ret(null, ch);
            } else {
                stream.eatWhile(/[\w\\\-]/);
                return ret("variable", "variable");
            }
        };
        var tokenCComment = function tokenCComment(stream, state) {
            var maybeEnd = false, ch;
            while((ch = stream.next()) != null){
                if (maybeEnd && ch == "/") {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return ret("comment", "comment");
        };
        var tokenSGMLComment = function tokenSGMLComment(stream, state) {
            var dashes = 0, ch;
            while((ch = stream.next()) != null){
                if (dashes >= 2 && ch == ">") {
                    state.tokenize = tokenBase;
                    break;
                }
                dashes = ch == "-" ? dashes + 1 : 0;
            }
            return ret("comment", "comment");
        };
        var tokenString = function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) break;
                    escaped = !escaped && ch == "\\";
                }
                if (!escaped) state.tokenize = tokenBase;
                return ret("string", "string");
            };
        };
        var keywords = words(/* ngxDirectiveControl */ "break return rewrite set" + /* ngxDirective */ " accept_mutex accept_mutex_delay access_log add_after_body add_before_body add_header addition_types aio alias allow ancient_browser ancient_browser_value auth_basic auth_basic_user_file auth_http auth_http_header auth_http_timeout autoindex autoindex_exact_size autoindex_localtime charset charset_types client_body_buffer_size client_body_in_file_only client_body_in_single_buffer client_body_temp_path client_body_timeout client_header_buffer_size client_header_timeout client_max_body_size connection_pool_size create_full_put_path daemon dav_access dav_methods debug_connection debug_points default_type degradation degrade deny devpoll_changes devpoll_events directio directio_alignment empty_gif env epoll_events error_log eventport_events expires fastcgi_bind fastcgi_buffer_size fastcgi_buffers fastcgi_busy_buffers_size fastcgi_cache fastcgi_cache_key fastcgi_cache_methods fastcgi_cache_min_uses fastcgi_cache_path fastcgi_cache_use_stale fastcgi_cache_valid fastcgi_catch_stderr fastcgi_connect_timeout fastcgi_hide_header fastcgi_ignore_client_abort fastcgi_ignore_headers fastcgi_index fastcgi_intercept_errors fastcgi_max_temp_file_size fastcgi_next_upstream fastcgi_param fastcgi_pass_header fastcgi_pass_request_body fastcgi_pass_request_headers fastcgi_read_timeout fastcgi_send_lowat fastcgi_send_timeout fastcgi_split_path_info fastcgi_store fastcgi_store_access fastcgi_temp_file_write_size fastcgi_temp_path fastcgi_upstream_fail_timeout fastcgi_upstream_max_fails flv geoip_city geoip_country google_perftools_profiles gzip gzip_buffers gzip_comp_level gzip_disable gzip_hash gzip_http_version gzip_min_length gzip_no_buffer gzip_proxied gzip_static gzip_types gzip_vary gzip_window if_modified_since ignore_invalid_headers image_filter image_filter_buffer image_filter_jpeg_quality image_filter_transparency imap_auth imap_capabilities imap_client_buffer index ip_hash keepalive_requests keepalive_timeout kqueue_changes kqueue_events large_client_header_buffers limit_conn limit_conn_log_level limit_rate limit_rate_after limit_req limit_req_log_level limit_req_zone limit_zone lingering_time lingering_timeout lock_file log_format log_not_found log_subrequest map_hash_bucket_size map_hash_max_size master_process memcached_bind memcached_buffer_size memcached_connect_timeout memcached_next_upstream memcached_read_timeout memcached_send_timeout memcached_upstream_fail_timeout memcached_upstream_max_fails merge_slashes min_delete_depth modern_browser modern_browser_value msie_padding msie_refresh multi_accept open_file_cache open_file_cache_errors open_file_cache_events open_file_cache_min_uses open_file_cache_valid open_log_file_cache output_buffers override_charset perl perl_modules perl_require perl_set pid pop3_auth pop3_capabilities port_in_redirect postpone_gzipping postpone_output protocol proxy proxy_bind proxy_buffer proxy_buffer_size proxy_buffering proxy_buffers proxy_busy_buffers_size proxy_cache proxy_cache_key proxy_cache_methods proxy_cache_min_uses proxy_cache_path proxy_cache_use_stale proxy_cache_valid proxy_connect_timeout proxy_headers_hash_bucket_size proxy_headers_hash_max_size proxy_hide_header proxy_ignore_client_abort proxy_ignore_headers proxy_intercept_errors proxy_max_temp_file_size proxy_method proxy_next_upstream proxy_pass_error_message proxy_pass_header proxy_pass_request_body proxy_pass_request_headers proxy_read_timeout proxy_redirect proxy_send_lowat proxy_send_timeout proxy_set_body proxy_set_header proxy_ssl_session_reuse proxy_store proxy_store_access proxy_temp_file_write_size proxy_temp_path proxy_timeout proxy_upstream_fail_timeout proxy_upstream_max_fails random_index read_ahead real_ip_header recursive_error_pages request_pool_size reset_timedout_connection resolver resolver_timeout rewrite_log rtsig_overflow_events rtsig_overflow_test rtsig_overflow_threshold rtsig_signo satisfy secure_link_secret send_lowat send_timeout sendfile sendfile_max_chunk server_name_in_redirect server_names_hash_bucket_size server_names_hash_max_size server_tokens set_real_ip_from smtp_auth smtp_capabilities smtp_client_buffer smtp_greeting_delay so_keepalive source_charset ssi ssi_ignore_recycled_buffers ssi_min_file_chunk ssi_silent_errors ssi_types ssi_value_length ssl ssl_certificate ssl_certificate_key ssl_ciphers ssl_client_certificate ssl_crl ssl_dhparam ssl_engine ssl_prefer_server_ciphers ssl_protocols ssl_session_cache ssl_session_timeout ssl_verify_client ssl_verify_depth starttls stub_status sub_filter sub_filter_once sub_filter_types tcp_nodelay tcp_nopush thread_stack_size timeout timer_resolution types_hash_bucket_size types_hash_max_size underscores_in_headers uninitialized_variable_warn use user userid userid_domain userid_expires userid_mark userid_name userid_p3p userid_path userid_service valid_referers variables_hash_bucket_size variables_hash_max_size worker_connections worker_cpu_affinity worker_priority worker_processes worker_rlimit_core worker_rlimit_nofile worker_rlimit_sigpending worker_threads working_directory xclient xml_entities xslt_stylesheet xslt_typesdrew@li229-23");
        var keywords_block = words(/* ngxDirectiveBlock */ "http mail events server types location upstream charset_map limit_except if geo map");
        var keywords_important = words(/* ngxDirectiveImportant */ "include root server server_name listen internal proxy_pass memcached_pass fastcgi_pass try_files");
        var indentUnit = config.indentUnit, type;
        return {
            startState: function startState(base) {
                return {
                    tokenize: tokenBase,
                    baseIndent: base || 0,
                    stack: []
                };
            },
            token: function token(stream, state) {
                if (stream.eatSpace()) return null;
                type = null;
                var style = state.tokenize(stream, state);
                var context = state.stack[state.stack.length - 1];
                if (type == "hash" && context == "rule") style = "atom";
                else if (style == "variable") {
                    if (context == "rule") style = "number";
                    else if (!context || context == "@media{") style = "tag";
                }
                if (context == "rule" && /^[\{\};]$/.test(type)) state.stack.pop();
                if (type == "{") {
                    if (context == "@media") state.stack[state.stack.length - 1] = "@media{";
                    else state.stack.push("{");
                } else if (type == "}") state.stack.pop();
                else if (type == "@media") state.stack.push("@media");
                else if (context == "{" && type != "comment") state.stack.push("rule");
                return style;
            },
            indent: function indent(state, textAfter) {
                var n = state.stack.length;
                if (/^\}/.test(textAfter)) n -= state.stack[state.stack.length - 1] == "rule" ? 2 : 1;
                return state.baseIndent + n * indentUnit;
            },
            electricChars: "}"
        };
    });
    CodeMirror1.defineMIME("text/x-nginx-conf", "nginx");
});
});

var perl = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// CodeMirror2 mode/perl/perl.js (text/x-perl) beta 0.10 (2011-11-08)
// This is a part of CodeMirror from https://github.com/sabaca/CodeMirror_mode_perl (mail@sabaca.com)
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var look = // it's like "peek", but need for look-ahead or look-behind if index < 0
    function look(stream, c) {
        return stream.string.charAt(stream.pos + (c || 0));
    };
    var prefix = // return a part of prefix of current stream from current position
    function prefix(stream, c) {
        if (c) {
            var x = stream.pos - c;
            return stream.string.substr(x >= 0 ? x : 0, c);
        } else {
            return stream.string.substr(0, stream.pos - 1);
        }
    };
    var suffix = // return a part of suffix of current stream from current position
    function suffix(stream, c) {
        var y = stream.string.length;
        var x = y - stream.pos + 1;
        return stream.string.substr(stream.pos, c && c < y ? c : x);
    };
    var eatSuffix = // eating and vomiting a part of stream from current position
    function eatSuffix(stream, c) {
        var x = stream.pos + c;
        var y;
        if (x <= 0) stream.pos = 0;
        else if (x >= (y = stream.string.length - 1)) stream.pos = y;
        else stream.pos = x;
    };
    CodeMirror1.defineMode("perl", function() {
        var tokenChain = function tokenChain(stream, state, chain, style, tail) {
            state.chain = null; //                                                          12   3tail
            state.style = null;
            state.tail = null;
            state.tokenize = function(stream, state) {
                var e = false, c, i = 0;
                while(c = stream.next()){
                    if (c === chain[i] && !e) {
                        if (chain[++i] !== undefined) {
                            state.chain = chain[i];
                            state.style = style;
                            state.tail = tail;
                        } else if (tail) stream.eatWhile(tail);
                        state.tokenize = tokenPerl;
                        return style;
                    }
                    e = !e && c == "\\";
                }
                return style;
            };
            return state.tokenize(stream, state);
        };
        var tokenSOMETHING = function tokenSOMETHING(stream, state, string) {
            state.tokenize = function(stream, state) {
                if (stream.string == string) state.tokenize = tokenPerl;
                stream.skipToEnd();
                return "string";
            };
            return state.tokenize(stream, state);
        };
        var tokenPerl = function tokenPerl(stream, state) {
            if (stream.eatSpace()) return null;
            if (state.chain) return tokenChain(stream, state, state.chain, state.style, state.tail);
            if (stream.match(/^\-?[\d\.]/, false)) {
                if (stream.match(/^(\-?(\d*\.\d+(e[+-]?\d+)?|\d+\.\d*)|0x[\da-fA-F]+|0b[01]+|\d+(e[+-]?\d+)?)/)) return "number";
            }
            if (stream.match(/^<<(?=[_a-zA-Z])/)) {
                stream.eatWhile(/\w/);
                return tokenSOMETHING(stream, state, stream.current().substr(2));
            }
            if (stream.sol() && stream.match(/^\=item(?!\w)/)) {
                return tokenSOMETHING(stream, state, "=cut");
            }
            var ch = stream.next();
            if (ch == '"' || ch == "'") {
                if (prefix(stream, 3) == "<<" + ch) {
                    var p = stream.pos;
                    stream.eatWhile(/\w/);
                    var n = stream.current().substr(1);
                    if (n && stream.eat(ch)) return tokenSOMETHING(stream, state, n);
                    stream.pos = p;
                }
                return tokenChain(stream, state, [
                    ch
                ], "string");
            }
            if (ch == "q") {
                var c = look(stream, -2);
                if (!(c && /\w/.test(c))) {
                    c = look(stream, 0);
                    if (c == "x") {
                        c = look(stream, 1);
                        if (c == "(") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ")"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "[") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "]"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "{") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "}"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "<") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ">"
                            ], RXstyle, RXmodifiers);
                        }
                        if (/[\^'"!~\/]/.test(c)) {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                stream.eat(c)
                            ], RXstyle, RXmodifiers);
                        }
                    } else if (c == "q") {
                        c = look(stream, 1);
                        if (c == "(") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ")"
                            ], "string");
                        }
                        if (c == "[") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "]"
                            ], "string");
                        }
                        if (c == "{") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "}"
                            ], "string");
                        }
                        if (c == "<") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ">"
                            ], "string");
                        }
                        if (/[\^'"!~\/]/.test(c)) {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                stream.eat(c)
                            ], "string");
                        }
                    } else if (c == "w") {
                        c = look(stream, 1);
                        if (c == "(") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ")"
                            ], "bracket");
                        }
                        if (c == "[") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "]"
                            ], "bracket");
                        }
                        if (c == "{") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "}"
                            ], "bracket");
                        }
                        if (c == "<") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ">"
                            ], "bracket");
                        }
                        if (/[\^'"!~\/]/.test(c)) {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                stream.eat(c)
                            ], "bracket");
                        }
                    } else if (c == "r") {
                        c = look(stream, 1);
                        if (c == "(") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ")"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "[") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "]"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "{") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                "}"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "<") {
                            eatSuffix(stream, 2);
                            return tokenChain(stream, state, [
                                ">"
                            ], RXstyle, RXmodifiers);
                        }
                        if (/[\^'"!~\/]/.test(c)) {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                stream.eat(c)
                            ], RXstyle, RXmodifiers);
                        }
                    } else if (/[\^'"!~\/(\[{<]/.test(c)) {
                        if (c == "(") {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                ")"
                            ], "string");
                        }
                        if (c == "[") {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                "]"
                            ], "string");
                        }
                        if (c == "{") {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                "}"
                            ], "string");
                        }
                        if (c == "<") {
                            eatSuffix(stream, 1);
                            return tokenChain(stream, state, [
                                ">"
                            ], "string");
                        }
                        if (/[\^'"!~\/]/.test(c)) {
                            return tokenChain(stream, state, [
                                stream.eat(c)
                            ], "string");
                        }
                    }
                }
            }
            if (ch == "m") {
                var c = look(stream, -2);
                if (!(c && /\w/.test(c))) {
                    c = stream.eat(/[(\[{<\^'"!~\/]/);
                    if (c) {
                        if (/[\^'"!~\/]/.test(c)) {
                            return tokenChain(stream, state, [
                                c
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "(") {
                            return tokenChain(stream, state, [
                                ")"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "[") {
                            return tokenChain(stream, state, [
                                "]"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "{") {
                            return tokenChain(stream, state, [
                                "}"
                            ], RXstyle, RXmodifiers);
                        }
                        if (c == "<") {
                            return tokenChain(stream, state, [
                                ">"
                            ], RXstyle, RXmodifiers);
                        }
                    }
                }
            }
            if (ch == "s") {
                var c = /[\/>\]})\w]/.test(look(stream, -2));
                if (!c) {
                    c = stream.eat(/[(\[{<\^'"!~\/]/);
                    if (c) {
                        if (c == "[") return tokenChain(stream, state, [
                            "]",
                            "]"
                        ], RXstyle, RXmodifiers);
                        if (c == "{") return tokenChain(stream, state, [
                            "}",
                            "}"
                        ], RXstyle, RXmodifiers);
                        if (c == "<") return tokenChain(stream, state, [
                            ">",
                            ">"
                        ], RXstyle, RXmodifiers);
                        if (c == "(") return tokenChain(stream, state, [
                            ")",
                            ")"
                        ], RXstyle, RXmodifiers);
                        return tokenChain(stream, state, [
                            c,
                            c
                        ], RXstyle, RXmodifiers);
                    }
                }
            }
            if (ch == "y") {
                var c = /[\/>\]})\w]/.test(look(stream, -2));
                if (!c) {
                    c = stream.eat(/[(\[{<\^'"!~\/]/);
                    if (c) {
                        if (c == "[") return tokenChain(stream, state, [
                            "]",
                            "]"
                        ], RXstyle, RXmodifiers);
                        if (c == "{") return tokenChain(stream, state, [
                            "}",
                            "}"
                        ], RXstyle, RXmodifiers);
                        if (c == "<") return tokenChain(stream, state, [
                            ">",
                            ">"
                        ], RXstyle, RXmodifiers);
                        if (c == "(") return tokenChain(stream, state, [
                            ")",
                            ")"
                        ], RXstyle, RXmodifiers);
                        return tokenChain(stream, state, [
                            c,
                            c
                        ], RXstyle, RXmodifiers);
                    }
                }
            }
            if (ch == "t") {
                var c = /[\/>\]})\w]/.test(look(stream, -2));
                if (!c) {
                    c = stream.eat("r");
                    if (c) {
                        c = stream.eat(/[(\[{<\^'"!~\/]/);
                        if (c) {
                            if (c == "[") return tokenChain(stream, state, [
                                "]",
                                "]"
                            ], RXstyle, RXmodifiers);
                            if (c == "{") return tokenChain(stream, state, [
                                "}",
                                "}"
                            ], RXstyle, RXmodifiers);
                            if (c == "<") return tokenChain(stream, state, [
                                ">",
                                ">"
                            ], RXstyle, RXmodifiers);
                            if (c == "(") return tokenChain(stream, state, [
                                ")",
                                ")"
                            ], RXstyle, RXmodifiers);
                            return tokenChain(stream, state, [
                                c,
                                c
                            ], RXstyle, RXmodifiers);
                        }
                    }
                }
            }
            if (ch == "`") {
                return tokenChain(stream, state, [
                    ch
                ], "variable-2");
            }
            if (ch == "/") {
                if (!/~\s*$/.test(prefix(stream))) return "operator";
                else return tokenChain(stream, state, [
                    ch
                ], RXstyle, RXmodifiers);
            }
            if (ch == "$") {
                var p = stream.pos;
                if (stream.eatWhile(/\d/) || stream.eat("{") && stream.eatWhile(/\d/) && stream.eat("}")) return "variable-2";
                else stream.pos = p;
            }
            if (/[$@%]/.test(ch)) {
                var p = stream.pos;
                if (stream.eat("^") && stream.eat(/[A-Z]/) || !/[@$%&]/.test(look(stream, -2)) && stream.eat(/[=|\\\-#?@;:&`~\^!\[\]*'"$+.,\/<>()]/)) {
                    var c = stream.current();
                    if (PERL[c]) return "variable-2";
                }
                stream.pos = p;
            }
            if (/[$@%&]/.test(ch)) {
                if (stream.eatWhile(/[\w$]/) || stream.eat("{") && stream.eatWhile(/[\w$]/) && stream.eat("}")) {
                    var c = stream.current();
                    if (PERL[c]) return "variable-2";
                    else return "variable";
                }
            }
            if (ch == "#") {
                if (look(stream, -2) != "$") {
                    stream.skipToEnd();
                    return "comment";
                }
            }
            if (/[:+\-\^*$&%@=<>!?|\/~\.]/.test(ch)) {
                var p = stream.pos;
                stream.eatWhile(/[:+\-\^*$&%@=<>!?|\/~\.]/);
                if (PERL[stream.current()]) return "operator";
                else stream.pos = p;
            }
            if (ch == "_") {
                if (stream.pos == 1) {
                    if (suffix(stream, 6) == "_END__") {
                        return tokenChain(stream, state, [
                            "\0"
                        ], "comment");
                    } else if (suffix(stream, 7) == "_DATA__") {
                        return tokenChain(stream, state, [
                            "\0"
                        ], "variable-2");
                    } else if (suffix(stream, 7) == "_C__") {
                        return tokenChain(stream, state, [
                            "\0"
                        ], "string");
                    }
                }
            }
            if (/\w/.test(ch)) {
                var p = stream.pos;
                if (look(stream, -2) == "{" && (look(stream, 0) == "}" || stream.eatWhile(/\w/) && look(stream, 0) == "}")) return "string";
                else stream.pos = p;
            }
            if (/[A-Z]/.test(ch)) {
                var l = look(stream, -2);
                var p = stream.pos;
                stream.eatWhile(/[A-Z_]/);
                if (/[\da-z]/.test(look(stream, 0))) {
                    stream.pos = p;
                } else {
                    var c = PERL[stream.current()];
                    if (!c) return "meta";
                    if (c[1]) c = c[0];
                    if (l != ":") {
                        if (c == 1) return "keyword";
                        else if (c == 2) return "def";
                        else if (c == 3) return "atom";
                        else if (c == 4) return "operator";
                        else if (c == 5) return "variable-2";
                        else return "meta";
                    } else return "meta";
                }
            }
            if (/[a-zA-Z_]/.test(ch)) {
                var l = look(stream, -2);
                stream.eatWhile(/\w/);
                var c = PERL[stream.current()];
                if (!c) return "meta";
                if (c[1]) c = c[0];
                if (l != ":") {
                    if (c == 1) return "keyword";
                    else if (c == 2) return "def";
                    else if (c == 3) return "atom";
                    else if (c == 4) return "operator";
                    else if (c == 5) return "variable-2";
                    else return "meta";
                } else return "meta";
            }
            return null;
        };
        // http://perldoc.perl.org
        var PERL = {
            //   1 - keyword
            //   2 - def
            //   3 - atom
            //   4 - operator
            //   5 - variable-2 (predefined)
            //   [x,y] - x=1,2,3; y=must be defined if x{...}
            //      PERL operators
            "->": 4,
            "++": 4,
            "--": 4,
            "**": 4,
            //   ! ~ \ and unary + and -
            "=~": 4,
            "!~": 4,
            "*": 4,
            "/": 4,
            "%": 4,
            "x": 4,
            "+": 4,
            "-": 4,
            ".": 4,
            "<<": 4,
            ">>": 4,
            //   named unary operators
            "<": 4,
            ">": 4,
            "<=": 4,
            ">=": 4,
            "lt": 4,
            "gt": 4,
            "le": 4,
            "ge": 4,
            "==": 4,
            "!=": 4,
            "<=>": 4,
            "eq": 4,
            "ne": 4,
            "cmp": 4,
            "~~": 4,
            "&": 4,
            "|": 4,
            "^": 4,
            "&&": 4,
            "||": 4,
            "//": 4,
            "..": 4,
            "...": 4,
            "?": 4,
            ":": 4,
            "=": 4,
            "+=": 4,
            "-=": 4,
            "*=": 4,
            ",": 4,
            "=>": 4,
            "::": 4,
            //   list operators (rightward)
            "not": 4,
            "and": 4,
            "or": 4,
            "xor": 4,
            //      PERL predefined variables (I know, what this is a paranoid idea, but may be needed for people, who learn PERL, and for me as well, ...and may be for you?;)
            "BEGIN": [
                5,
                1
            ],
            "END": [
                5,
                1
            ],
            "PRINT": [
                5,
                1
            ],
            "PRINTF": [
                5,
                1
            ],
            "GETC": [
                5,
                1
            ],
            "READ": [
                5,
                1
            ],
            "READLINE": [
                5,
                1
            ],
            "DESTROY": [
                5,
                1
            ],
            "TIE": [
                5,
                1
            ],
            "TIEHANDLE": [
                5,
                1
            ],
            "UNTIE": [
                5,
                1
            ],
            "STDIN": 5,
            "STDIN_TOP": 5,
            "STDOUT": 5,
            "STDOUT_TOP": 5,
            "STDERR": 5,
            "STDERR_TOP": 5,
            "$ARG": 5,
            "$_": 5,
            "@ARG": 5,
            "@_": 5,
            "$LIST_SEPARATOR": 5,
            '$"': 5,
            "$PROCESS_ID": 5,
            "$PID": 5,
            "$$": 5,
            "$REAL_GROUP_ID": 5,
            "$GID": 5,
            "$(": 5,
            "$EFFECTIVE_GROUP_ID": 5,
            "$EGID": 5,
            "$)": 5,
            "$PROGRAM_NAME": 5,
            "$0": 5,
            "$SUBSCRIPT_SEPARATOR": 5,
            "$SUBSEP": 5,
            "$;": 5,
            "$REAL_USER_ID": 5,
            "$UID": 5,
            "$<": 5,
            "$EFFECTIVE_USER_ID": 5,
            "$EUID": 5,
            "$>": 5,
            "$a": 5,
            "$b": 5,
            "$COMPILING": 5,
            "$^C": 5,
            "$DEBUGGING": 5,
            "$^D": 5,
            "${^ENCODING}": 5,
            "$ENV": 5,
            "%ENV": 5,
            "$SYSTEM_FD_MAX": 5,
            "$^F": 5,
            "@F": 5,
            "${^GLOBAL_PHASE}": 5,
            "$^H": 5,
            "%^H": 5,
            "@INC": 5,
            "%INC": 5,
            "$INPLACE_EDIT": 5,
            "$^I": 5,
            "$^M": 5,
            "$OSNAME": 5,
            "$^O": 5,
            "${^OPEN}": 5,
            "$PERLDB": 5,
            "$^P": 5,
            "$SIG": 5,
            "%SIG": 5,
            "$BASETIME": 5,
            "$^T": 5,
            "${^TAINT}": 5,
            "${^UNICODE}": 5,
            "${^UTF8CACHE}": 5,
            "${^UTF8LOCALE}": 5,
            "$PERL_VERSION": 5,
            "$^V": 5,
            "${^WIN32_SLOPPY_STAT}": 5,
            "$EXECUTABLE_NAME": 5,
            "$^X": 5,
            "$1": 5,
            "$MATCH": 5,
            "$&": 5,
            "${^MATCH}": 5,
            "$PREMATCH": 5,
            "$`": 5,
            "${^PREMATCH}": 5,
            "$POSTMATCH": 5,
            "$'": 5,
            "${^POSTMATCH}": 5,
            "$LAST_PAREN_MATCH": 5,
            "$+": 5,
            "$LAST_SUBMATCH_RESULT": 5,
            "$^N": 5,
            "@LAST_MATCH_END": 5,
            "@+": 5,
            "%LAST_PAREN_MATCH": 5,
            "%+": 5,
            "@LAST_MATCH_START": 5,
            "@-": 5,
            "%LAST_MATCH_START": 5,
            "%-": 5,
            "$LAST_REGEXP_CODE_RESULT": 5,
            "$^R": 5,
            "${^RE_DEBUG_FLAGS}": 5,
            "${^RE_TRIE_MAXBUF}": 5,
            "$ARGV": 5,
            "@ARGV": 5,
            "ARGV": 5,
            "ARGVOUT": 5,
            "$OUTPUT_FIELD_SEPARATOR": 5,
            "$OFS": 5,
            "$,": 5,
            "$INPUT_LINE_NUMBER": 5,
            "$NR": 5,
            "$.": 5,
            "$INPUT_RECORD_SEPARATOR": 5,
            "$RS": 5,
            "$/": 5,
            "$OUTPUT_RECORD_SEPARATOR": 5,
            "$ORS": 5,
            "$\\": 5,
            "$OUTPUT_AUTOFLUSH": 5,
            "$|": 5,
            "$ACCUMULATOR": 5,
            "$^A": 5,
            "$FORMAT_FORMFEED": 5,
            "$^L": 5,
            "$FORMAT_PAGE_NUMBER": 5,
            "$%": 5,
            "$FORMAT_LINES_LEFT": 5,
            "$-": 5,
            "$FORMAT_LINE_BREAK_CHARACTERS": 5,
            "$:": 5,
            "$FORMAT_LINES_PER_PAGE": 5,
            "$=": 5,
            "$FORMAT_TOP_NAME": 5,
            "$^": 5,
            "$FORMAT_NAME": 5,
            "$~": 5,
            "${^CHILD_ERROR_NATIVE}": 5,
            "$EXTENDED_OS_ERROR": 5,
            "$^E": 5,
            "$EXCEPTIONS_BEING_CAUGHT": 5,
            "$^S": 5,
            "$WARNING": 5,
            "$^W": 5,
            "${^WARNING_BITS}": 5,
            "$OS_ERROR": 5,
            "$ERRNO": 5,
            "$!": 5,
            "%OS_ERROR": 5,
            "%ERRNO": 5,
            "%!": 5,
            "$CHILD_ERROR": 5,
            "$?": 5,
            "$EVAL_ERROR": 5,
            "$@": 5,
            "$OFMT": 5,
            "$#": 5,
            "$*": 5,
            "$ARRAY_BASE": 5,
            "$[": 5,
            "$OLD_PERL_VERSION": 5,
            "$]": 5,
            //      PERL blocks
            "if": [
                1,
                1
            ],
            elsif: [
                1,
                1
            ],
            "else": [
                1,
                1
            ],
            "while": [
                1,
                1
            ],
            unless: [
                1,
                1
            ],
            "for": [
                1,
                1
            ],
            foreach: [
                1,
                1
            ],
            //      PERL functions
            "abs": 1,
            accept: 1,
            alarm: 1,
            "atan2": 1,
            bind: 1,
            binmode: 1,
            bless: 1,
            bootstrap: 1,
            "break": 1,
            caller: 1,
            chdir: 1,
            chmod: 1,
            chomp: 1,
            chop: 1,
            chown: 1,
            chr: 1,
            chroot: 1,
            close: 1,
            closedir: 1,
            connect: 1,
            "continue": [
                1,
                1
            ],
            "cos": 1,
            crypt: 1,
            dbmclose: 1,
            dbmopen: 1,
            "default": 1,
            defined: 1,
            "delete": 1,
            die: 1,
            "do": 1,
            dump: 1,
            each: 1,
            endgrent: 1,
            endhostent: 1,
            endnetent: 1,
            endprotoent: 1,
            endpwent: 1,
            endservent: 1,
            eof: 1,
            "eval": 1,
            "exec": 1,
            exists: 1,
            exit: 1,
            "exp": 1,
            fcntl: 1,
            fileno: 1,
            flock: 1,
            fork: 1,
            format: 1,
            formline: 1,
            getc: 1,
            getgrent: 1,
            getgrgid: 1,
            getgrnam: 1,
            gethostbyaddr: 1,
            gethostbyname: 1,
            gethostent: 1,
            getlogin: 1,
            getnetbyaddr: 1,
            getnetbyname: 1,
            getnetent: 1,
            getpeername: 1,
            getpgrp: 1,
            getppid: 1,
            getpriority: 1,
            getprotobyname: 1,
            getprotobynumber: 1,
            getprotoent: 1,
            getpwent: 1,
            getpwnam: 1,
            getpwuid: 1,
            getservbyname: 1,
            getservbyport: 1,
            getservent: 1,
            getsockname: 1,
            getsockopt: 1,
            given: 1,
            glob: 1,
            gmtime: 1,
            "goto": 1,
            grep: 1,
            hex: 1,
            "import": 1,
            index: 1,
            "int": 1,
            ioctl: 1,
            "join": 1,
            keys: 1,
            kill: 1,
            last: 1,
            lc: 1,
            lcfirst: 1,
            length: 1,
            "link": 1,
            listen: 1,
            local: 2,
            localtime: 1,
            lock: 1,
            "log": 1,
            lstat: 1,
            m: null,
            map: 1,
            mkdir: 1,
            msgctl: 1,
            msgget: 1,
            msgrcv: 1,
            msgsnd: 1,
            my: 2,
            "new": 1,
            next: 1,
            no: 1,
            oct: 1,
            open: 1,
            opendir: 1,
            ord: 1,
            our: 2,
            pack: 1,
            "package": 1,
            pipe: 1,
            pop: 1,
            pos: 1,
            print: 1,
            printf: 1,
            prototype: 1,
            push: 1,
            q: null,
            qq: null,
            qr: null,
            quotemeta: null,
            qw: null,
            qx: null,
            rand: 1,
            read: 1,
            readdir: 1,
            readline: 1,
            readlink: 1,
            readpipe: 1,
            recv: 1,
            redo: 1,
            ref: 1,
            rename: 1,
            require: 1,
            reset: 1,
            "return": 1,
            reverse: 1,
            rewinddir: 1,
            rindex: 1,
            rmdir: 1,
            s: null,
            say: 1,
            scalar: 1,
            seek: 1,
            seekdir: 1,
            select: 1,
            semctl: 1,
            semget: 1,
            semop: 1,
            send: 1,
            setgrent: 1,
            sethostent: 1,
            setnetent: 1,
            setpgrp: 1,
            setpriority: 1,
            setprotoent: 1,
            setpwent: 1,
            setservent: 1,
            setsockopt: 1,
            shift: 1,
            shmctl: 1,
            shmget: 1,
            shmread: 1,
            shmwrite: 1,
            shutdown: 1,
            "sin": 1,
            sleep: 1,
            socket: 1,
            socketpair: 1,
            "sort": 1,
            splice: 1,
            "split": 1,
            sprintf: 1,
            "sqrt": 1,
            srand: 1,
            stat: 1,
            state: 1,
            study: 1,
            "sub": 1,
            "substr": 1,
            symlink: 1,
            syscall: 1,
            sysopen: 1,
            sysread: 1,
            sysseek: 1,
            system: 1,
            syswrite: 1,
            tell: 1,
            telldir: 1,
            tie: 1,
            tied: 1,
            time: 1,
            times: 1,
            tr: null,
            truncate: 1,
            uc: 1,
            ucfirst: 1,
            umask: 1,
            undef: 1,
            unlink: 1,
            unpack: 1,
            unshift: 1,
            untie: 1,
            use: 1,
            utime: 1,
            values: 1,
            vec: 1,
            wait: 1,
            waitpid: 1,
            wantarray: 1,
            warn: 1,
            when: 1,
            write: 1,
            y: null
        }; // - transliterate a string
        var RXstyle = "string-2";
        var RXmodifiers = /[goseximacplud]/; // NOTE: "m", "s", "y" and "tr" need to correct real modifiers for each regexp type
        return {
            startState: function startState() {
                return {
                    tokenize: tokenPerl,
                    chain: null,
                    style: null,
                    tail: null
                };
            },
            token: function token(stream, state) {
                return (state.tokenize || tokenPerl)(stream, state);
            },
            lineComment: "#"
        };
    });
    CodeMirror1.registerHelper("wordChars", "perl", /[\w$]/);
    CodeMirror1.defineMIME("text/x-perl", "perl");
});
});

var php = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, htmlmixed, clike);
})(function(CodeMirror1) {
    var keywords = function keywords(str) {
        var obj = {}, words = str.split(" ");
        for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
        return obj;
    };
    var phpString = function phpString(closing, escapes) {
        return function(stream, state) {
            return phpString_(stream, state, closing, escapes);
        };
    };
    var phpString_ = function phpString_(stream, state, closing, escapes) {
        // "Complex" syntax
        if (escapes !== false && stream.match("${", false) || stream.match("{$", false)) {
            state.tokenize = null;
            return "string";
        }
        // Simple syntax
        if (escapes !== false && stream.match(/^\$[a-zA-Z_][a-zA-Z0-9_]*/)) {
            // After the variable name there may appear array or object operator.
            if (stream.match("[", false)) {
                // Match array operator
                state.tokenize = matchSequence([
                    [
                        [
                            "[",
                            null
                        ]
                    ],
                    [
                        [
                            /\d[\w\.]*/,
                            "number"
                        ],
                        [
                            /\$[a-zA-Z_][a-zA-Z0-9_]*/,
                            "variable-2"
                        ],
                        [
                            /[\w\$]+/,
                            "variable"
                        ]
                    ],
                    [
                        [
                            "]",
                            null
                        ]
                    ]
                ], closing, escapes);
            }
            if (stream.match(/^->\w/, false)) {
                // Match object operator
                state.tokenize = matchSequence([
                    [
                        [
                            "->",
                            null
                        ]
                    ],
                    [
                        [
                            /[\w]+/,
                            "variable"
                        ]
                    ]
                ], closing, escapes);
            }
            return "variable-2";
        }
        var escaped = false;
        // Normal string
        while(!stream.eol() && (escaped || escapes === false || !stream.match("{$", false) && !stream.match(/^(\$[a-zA-Z_][a-zA-Z0-9_]*|\$\{)/, false))){
            if (!escaped && stream.match(closing)) {
                state.tokenize = null;
                state.tokStack.pop();
                state.tokStack.pop();
                break;
            }
            escaped = stream.next() == "\\" && !escaped;
        }
        return "string";
    };
    // Helper for phpString
    function matchSequence(list, end, escapes) {
        if (list.length == 0) return phpString(end);
        return function(stream, state) {
            var patterns = list[0];
            for(var i = 0; i < patterns.length; i++)if (stream.match(patterns[i][0])) {
                state.tokenize = matchSequence(list.slice(1), end);
                return patterns[i][1];
            }
            state.tokenize = phpString(end, escapes);
            return "string";
        };
    }
    var phpKeywords = "abstract and array as break case catch class clone const continue declare default " + "do else elseif enddeclare endfor endforeach endif endswitch endwhile enum extends final " + "for foreach function global goto if implements interface instanceof namespace " + "new or private protected public static switch throw trait try use var while xor " + "die echo empty exit eval include include_once isset list require require_once return " + "print unset __halt_compiler self static parent yield insteadof finally readonly match";
    var phpAtoms = "true false null TRUE FALSE NULL __CLASS__ __DIR__ __FILE__ __LINE__ __METHOD__ __FUNCTION__ __NAMESPACE__ __TRAIT__";
    var phpBuiltin = "func_num_args func_get_arg func_get_args strlen strcmp strncmp strcasecmp strncasecmp each error_reporting define defined trigger_error user_error set_error_handler restore_error_handler get_declared_classes get_loaded_extensions extension_loaded get_extension_funcs debug_backtrace constant bin2hex hex2bin sleep usleep time mktime gmmktime strftime gmstrftime strtotime date gmdate getdate localtime checkdate flush wordwrap htmlspecialchars htmlentities html_entity_decode md5 md5_file crc32 getimagesize image_type_to_mime_type phpinfo phpversion phpcredits strnatcmp strnatcasecmp substr_count strspn strcspn strtok strtoupper strtolower strpos strrpos strrev hebrev hebrevc nl2br basename dirname pathinfo stripslashes stripcslashes strstr stristr strrchr str_shuffle str_word_count strcoll substr substr_replace quotemeta ucfirst ucwords strtr addslashes addcslashes rtrim str_replace str_repeat count_chars chunk_split trim ltrim strip_tags similar_text explode implode setlocale localeconv parse_str str_pad chop strchr sprintf printf vprintf vsprintf sscanf fscanf parse_url urlencode urldecode rawurlencode rawurldecode readlink linkinfo link unlink exec system escapeshellcmd escapeshellarg passthru shell_exec proc_open proc_close rand srand getrandmax mt_rand mt_srand mt_getrandmax base64_decode base64_encode abs ceil floor round is_finite is_nan is_infinite bindec hexdec octdec decbin decoct dechex base_convert number_format fmod ip2long long2ip getenv putenv getopt microtime gettimeofday getrusage uniqid quoted_printable_decode set_time_limit get_cfg_var magic_quotes_runtime set_magic_quotes_runtime get_magic_quotes_gpc get_magic_quotes_runtime import_request_variables error_log serialize unserialize memory_get_usage memory_get_peak_usage var_dump var_export debug_zval_dump print_r highlight_file show_source highlight_string ini_get ini_get_all ini_set ini_alter ini_restore get_include_path set_include_path restore_include_path setcookie header headers_sent connection_aborted connection_status ignore_user_abort parse_ini_file is_uploaded_file move_uploaded_file intval floatval doubleval strval gettype settype is_null is_resource is_bool is_long is_float is_int is_integer is_double is_real is_numeric is_string is_array is_object is_scalar ereg ereg_replace eregi eregi_replace split spliti join sql_regcase dl pclose popen readfile rewind rmdir umask fclose feof fgetc fgets fgetss fread fopen fpassthru ftruncate fstat fseek ftell fflush fwrite fputs mkdir rename copy tempnam tmpfile file file_get_contents file_put_contents stream_select stream_context_create stream_context_set_params stream_context_set_option stream_context_get_options stream_filter_prepend stream_filter_append fgetcsv flock get_meta_tags stream_set_write_buffer set_file_buffer set_socket_blocking stream_set_blocking socket_set_blocking stream_get_meta_data stream_register_wrapper stream_wrapper_register stream_set_timeout socket_set_timeout socket_get_status realpath fnmatch fsockopen pfsockopen pack unpack get_browser crypt opendir closedir chdir getcwd rewinddir readdir dir glob fileatime filectime filegroup fileinode filemtime fileowner fileperms filesize filetype file_exists is_writable is_writeable is_readable is_executable is_file is_dir is_link stat lstat chown touch clearstatcache mail ob_start ob_flush ob_clean ob_end_flush ob_end_clean ob_get_flush ob_get_clean ob_get_length ob_get_level ob_get_status ob_get_contents ob_implicit_flush ob_list_handlers ksort krsort natsort natcasesort asort arsort sort rsort usort uasort uksort shuffle array_walk count end prev next reset current key min max in_array array_search extract compact array_fill range array_multisort array_push array_pop array_shift array_unshift array_splice array_slice array_merge array_merge_recursive array_keys array_values array_count_values array_reverse array_reduce array_pad array_flip array_change_key_case array_rand array_unique array_intersect array_intersect_assoc array_diff array_diff_assoc array_sum array_filter array_map array_chunk array_key_exists array_intersect_key array_combine array_column pos sizeof key_exists assert assert_options version_compare ftok str_rot13 aggregate session_name session_module_name session_save_path session_id session_regenerate_id session_decode session_register session_unregister session_is_registered session_encode session_start session_destroy session_unset session_set_save_handler session_cache_limiter session_cache_expire session_set_cookie_params session_get_cookie_params session_write_close preg_match preg_match_all preg_replace preg_replace_callback preg_split preg_quote preg_grep overload ctype_alnum ctype_alpha ctype_cntrl ctype_digit ctype_lower ctype_graph ctype_print ctype_punct ctype_space ctype_upper ctype_xdigit virtual apache_request_headers apache_note apache_lookup_uri apache_child_terminate apache_setenv apache_response_headers apache_get_version getallheaders mysql_connect mysql_pconnect mysql_close mysql_select_db mysql_create_db mysql_drop_db mysql_query mysql_unbuffered_query mysql_db_query mysql_list_dbs mysql_list_tables mysql_list_fields mysql_list_processes mysql_error mysql_errno mysql_affected_rows mysql_insert_id mysql_result mysql_num_rows mysql_num_fields mysql_fetch_row mysql_fetch_array mysql_fetch_assoc mysql_fetch_object mysql_data_seek mysql_fetch_lengths mysql_fetch_field mysql_field_seek mysql_free_result mysql_field_name mysql_field_table mysql_field_len mysql_field_type mysql_field_flags mysql_escape_string mysql_real_escape_string mysql_stat mysql_thread_id mysql_client_encoding mysql_get_client_info mysql_get_host_info mysql_get_proto_info mysql_get_server_info mysql_info mysql mysql_fieldname mysql_fieldtable mysql_fieldlen mysql_fieldtype mysql_fieldflags mysql_selectdb mysql_createdb mysql_dropdb mysql_freeresult mysql_numfields mysql_numrows mysql_listdbs mysql_listtables mysql_listfields mysql_db_name mysql_dbname mysql_tablename mysql_table_name pg_connect pg_pconnect pg_close pg_connection_status pg_connection_busy pg_connection_reset pg_host pg_dbname pg_port pg_tty pg_options pg_ping pg_query pg_send_query pg_cancel_query pg_fetch_result pg_fetch_row pg_fetch_assoc pg_fetch_array pg_fetch_object pg_fetch_all pg_affected_rows pg_get_result pg_result_seek pg_result_status pg_free_result pg_last_oid pg_num_rows pg_num_fields pg_field_name pg_field_num pg_field_size pg_field_type pg_field_prtlen pg_field_is_null pg_get_notify pg_get_pid pg_result_error pg_last_error pg_last_notice pg_put_line pg_end_copy pg_copy_to pg_copy_from pg_trace pg_untrace pg_lo_create pg_lo_unlink pg_lo_open pg_lo_close pg_lo_read pg_lo_write pg_lo_read_all pg_lo_import pg_lo_export pg_lo_seek pg_lo_tell pg_escape_string pg_escape_bytea pg_unescape_bytea pg_client_encoding pg_set_client_encoding pg_meta_data pg_convert pg_insert pg_update pg_delete pg_select pg_exec pg_getlastoid pg_cmdtuples pg_errormessage pg_numrows pg_numfields pg_fieldname pg_fieldsize pg_fieldtype pg_fieldnum pg_fieldprtlen pg_fieldisnull pg_freeresult pg_result pg_loreadall pg_locreate pg_lounlink pg_loopen pg_loclose pg_loread pg_lowrite pg_loimport pg_loexport http_response_code get_declared_traits getimagesizefromstring socket_import_stream stream_set_chunk_size trait_exists header_register_callback class_uses session_status session_register_shutdown echo print global static exit array empty eval isset unset die include require include_once require_once json_decode json_encode json_last_error json_last_error_msg curl_close curl_copy_handle curl_errno curl_error curl_escape curl_exec curl_file_create curl_getinfo curl_init curl_multi_add_handle curl_multi_close curl_multi_exec curl_multi_getcontent curl_multi_info_read curl_multi_init curl_multi_remove_handle curl_multi_select curl_multi_setopt curl_multi_strerror curl_pause curl_reset curl_setopt_array curl_setopt curl_share_close curl_share_init curl_share_setopt curl_strerror curl_unescape curl_version mysqli_affected_rows mysqli_autocommit mysqli_change_user mysqli_character_set_name mysqli_close mysqli_commit mysqli_connect_errno mysqli_connect_error mysqli_connect mysqli_data_seek mysqli_debug mysqli_dump_debug_info mysqli_errno mysqli_error_list mysqli_error mysqli_fetch_all mysqli_fetch_array mysqli_fetch_assoc mysqli_fetch_field_direct mysqli_fetch_field mysqli_fetch_fields mysqli_fetch_lengths mysqli_fetch_object mysqli_fetch_row mysqli_field_count mysqli_field_seek mysqli_field_tell mysqli_free_result mysqli_get_charset mysqli_get_client_info mysqli_get_client_stats mysqli_get_client_version mysqli_get_connection_stats mysqli_get_host_info mysqli_get_proto_info mysqli_get_server_info mysqli_get_server_version mysqli_info mysqli_init mysqli_insert_id mysqli_kill mysqli_more_results mysqli_multi_query mysqli_next_result mysqli_num_fields mysqli_num_rows mysqli_options mysqli_ping mysqli_prepare mysqli_query mysqli_real_connect mysqli_real_escape_string mysqli_real_query mysqli_reap_async_query mysqli_refresh mysqli_rollback mysqli_select_db mysqli_set_charset mysqli_set_local_infile_default mysqli_set_local_infile_handler mysqli_sqlstate mysqli_ssl_set mysqli_stat mysqli_stmt_init mysqli_store_result mysqli_thread_id mysqli_thread_safe mysqli_use_result mysqli_warning_count";
    CodeMirror1.registerHelper("hintWords", "php", [
        phpKeywords,
        phpAtoms,
        phpBuiltin
    ].join(" ").split(" "));
    CodeMirror1.registerHelper("wordChars", "php", /[\w$]/);
    var phpConfig = {
        name: "clike",
        helperType: "php",
        keywords: keywords(phpKeywords),
        blockKeywords: keywords("catch do else elseif for foreach if switch try while finally"),
        defKeywords: keywords("class enum function interface namespace trait"),
        atoms: keywords(phpAtoms),
        builtin: keywords(phpBuiltin),
        multiLineStrings: true,
        hooks: {
            "$": function(stream) {
                stream.eatWhile(/[\w\$_]/);
                return "variable-2";
            },
            "<": function(stream, state) {
                var before;
                if (before = stream.match(/^<<\s*/)) {
                    var quoted = stream.eat(/['"]/);
                    stream.eatWhile(/[\w\.]/);
                    var delim = stream.current().slice(before[0].length + (quoted ? 2 : 1));
                    if (quoted) stream.eat(quoted);
                    if (delim) {
                        (state.tokStack || (state.tokStack = [])).push(delim, 0);
                        state.tokenize = phpString(delim, quoted != "'");
                        return "string";
                    }
                }
                return false;
            },
            "#": function(stream) {
                while(!stream.eol() && !stream.match("?>", false))stream.next();
                return "comment";
            },
            "/": function(stream) {
                if (stream.eat("/")) {
                    while(!stream.eol() && !stream.match("?>", false))stream.next();
                    return "comment";
                }
                return false;
            },
            '"': function(_stream, state) {
                (state.tokStack || (state.tokStack = [])).push('"', 0);
                state.tokenize = phpString('"');
                return "string";
            },
            "{": function(_stream, state) {
                if (state.tokStack && state.tokStack.length) state.tokStack[state.tokStack.length - 1]++;
                return false;
            },
            "}": function(_stream, state) {
                if (state.tokStack && state.tokStack.length > 0 && !--state.tokStack[state.tokStack.length - 1]) {
                    state.tokenize = phpString(state.tokStack[state.tokStack.length - 2]);
                }
                return false;
            }
        }
    };
    CodeMirror1.defineMode("php", function(config, parserConfig) {
        var dispatch = function dispatch(stream, state) {
            var isPHP = state.curMode == phpMode;
            if (stream.sol() && state.pending && state.pending != '"' && state.pending != "'") state.pending = null;
            if (!isPHP) {
                if (stream.match(/^<\?\w*/)) {
                    state.curMode = phpMode;
                    if (!state.php) state.php = CodeMirror1.startState(phpMode, htmlMode.indent(state.html, "", ""));
                    state.curState = state.php;
                    return "meta";
                }
                if (state.pending == '"' || state.pending == "'") {
                    while(!stream.eol() && stream.next() != state.pending){}
                    var style = "string";
                } else if (state.pending && stream.pos < state.pending.end) {
                    stream.pos = state.pending.end;
                    var style = state.pending.style;
                } else {
                    var style = htmlMode.token(stream, state.curState);
                }
                if (state.pending) state.pending = null;
                var cur = stream.current(), openPHP = cur.search(/<\?/), m;
                if (openPHP != -1) {
                    if (style == "string" && (m = cur.match(/[\'\"]$/)) && !/\?>/.test(cur)) state.pending = m[0];
                    else state.pending = {
                        end: stream.pos,
                        style: style
                    };
                    stream.backUp(cur.length - openPHP);
                }
                return style;
            } else if (isPHP && state.php.tokenize == null && stream.match("?>")) {
                state.curMode = htmlMode;
                state.curState = state.html;
                if (!state.php.context.prev) state.php = null;
                return "meta";
            } else {
                return phpMode.token(stream, state.curState);
            }
        };
        var htmlMode = CodeMirror1.getMode(config, parserConfig && parserConfig.htmlMode || "text/html");
        var phpMode = CodeMirror1.getMode(config, phpConfig);
        return {
            startState: function startState() {
                var html = CodeMirror1.startState(htmlMode);
                var php = parserConfig.startOpen ? CodeMirror1.startState(phpMode) : null;
                return {
                    html: html,
                    php: php,
                    curMode: parserConfig.startOpen ? phpMode : htmlMode,
                    curState: parserConfig.startOpen ? php : html,
                    pending: null
                };
            },
            copyState: function copyState(state) {
                var html = state.html, htmlNew = CodeMirror1.copyState(htmlMode, html), php = state.php, phpNew = php && CodeMirror1.copyState(phpMode, php), cur;
                if (state.curMode == htmlMode) cur = htmlNew;
                else cur = phpNew;
                return {
                    html: htmlNew,
                    php: phpNew,
                    curMode: state.curMode,
                    curState: cur,
                    pending: state.pending
                };
            },
            token: dispatch,
            indent: function indent(state, textAfter, line) {
                if (state.curMode != phpMode && /^\s*<\//.test(textAfter) || state.curMode == phpMode && /^\?>/.test(textAfter)) return htmlMode.indent(state.html, textAfter, line);
                return state.curMode.indent(state.curState, textAfter, line);
            },
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            lineComment: "//",
            innerMode: function innerMode(state) {
                return {
                    state: state.curState,
                    mode: state.curMode
                };
            }
        };
    }, "htmlmixed", "clike");
    CodeMirror1.defineMIME("application/x-httpd-php", "php");
    CodeMirror1.defineMIME("application/x-httpd-php-open", {
        name: "php",
        startOpen: true
    });
    CodeMirror1.defineMIME("text/x-php", phpConfig);
});
});

var powershell = createCommonjsModule(function (module, exports) {
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror) {
    CodeMirror.defineMode("powershell", function() {
        var buildRegexp = function buildRegexp(patterns, options) {
            options = options || {};
            var prefix = options.prefix !== undefined ? options.prefix : "^";
            var suffix = options.suffix !== undefined ? options.suffix : "\\b";
            for(var i = 0; i < patterns.length; i++){
                if (_instanceof(patterns[i], RegExp)) {
                    patterns[i] = patterns[i].source;
                } else {
                    patterns[i] = patterns[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                }
            }
            return new RegExp(prefix + "(" + patterns.join("|") + ")" + suffix, "i");
        };
        var tokenBase = // tokenizers
        function tokenBase(stream, state) {
            // Handle Comments
            //var ch = stream.peek();
            var parent = state.returnStack[state.returnStack.length - 1];
            if (parent && parent.shouldReturnFrom(state)) {
                state.tokenize = parent.tokenize;
                state.returnStack.pop();
                return state.tokenize(stream, state);
            }
            if (stream.eatSpace()) {
                return null;
            }
            if (stream.eat("(")) {
                state.bracketNesting += 1;
                return "punctuation";
            }
            if (stream.eat(")")) {
                state.bracketNesting -= 1;
                return "punctuation";
            }
            for(var key in grammar){
                if (stream.match(grammar[key])) {
                    return key;
                }
            }
            var ch = stream.next();
            // single-quote string
            if (ch === "'") {
                return tokenSingleQuoteString(stream, state);
            }
            if (ch === "$") {
                return tokenVariable(stream, state);
            }
            // double-quote string
            if (ch === '"') {
                return tokenDoubleQuoteString(stream, state);
            }
            if (ch === "<" && stream.eat("#")) {
                state.tokenize = tokenComment;
                return tokenComment(stream, state);
            }
            if (ch === "#") {
                stream.skipToEnd();
                return "comment";
            }
            if (ch === "@") {
                var quoteMatch = stream.eat(/["']/);
                if (quoteMatch && stream.eol()) {
                    state.tokenize = tokenMultiString;
                    state.startQuote = quoteMatch[0];
                    return tokenMultiString(stream, state);
                } else if (stream.eol()) {
                    return "error";
                } else if (stream.peek().match(/[({]/)) {
                    return "punctuation";
                } else if (stream.peek().match(varNames)) {
                    // splatted variable
                    return tokenVariable(stream, state);
                }
            }
            return "error";
        };
        var tokenSingleQuoteString = function tokenSingleQuoteString(stream, state) {
            var ch;
            while((ch = stream.peek()) != null){
                stream.next();
                if (ch === "'" && !stream.eat("'")) {
                    state.tokenize = tokenBase;
                    return "string";
                }
            }
            return "error";
        };
        var tokenDoubleQuoteString = function tokenDoubleQuoteString(stream, state) {
            var ch;
            while((ch = stream.peek()) != null){
                if (ch === "$") {
                    state.tokenize = tokenStringInterpolation;
                    return "string";
                }
                stream.next();
                if (ch === "`") {
                    stream.next();
                    continue;
                }
                if (ch === '"' && !stream.eat('"')) {
                    state.tokenize = tokenBase;
                    return "string";
                }
            }
            return "error";
        };
        var tokenStringInterpolation = function tokenStringInterpolation(stream, state) {
            return tokenInterpolation(stream, state, tokenDoubleQuoteString);
        };
        var tokenMultiStringReturn = function tokenMultiStringReturn(stream, state) {
            state.tokenize = tokenMultiString;
            state.startQuote = '"';
            return tokenMultiString(stream, state);
        };
        var tokenHereStringInterpolation = function tokenHereStringInterpolation(stream, state) {
            return tokenInterpolation(stream, state, tokenMultiStringReturn);
        };
        var tokenInterpolation = function tokenInterpolation(stream, state, parentTokenize) {
            if (stream.match("$(")) {
                var savedBracketNesting = state.bracketNesting;
                state.returnStack.push({
                    /*jshint loopfunc:true */ shouldReturnFrom: function shouldReturnFrom(state) {
                        return state.bracketNesting === savedBracketNesting;
                    },
                    tokenize: parentTokenize
                });
                state.tokenize = tokenBase;
                state.bracketNesting += 1;
                return "punctuation";
            } else {
                stream.next();
                state.returnStack.push({
                    shouldReturnFrom: function shouldReturnFrom() {
                        return true;
                    },
                    tokenize: parentTokenize
                });
                state.tokenize = tokenVariable;
                return state.tokenize(stream, state);
            }
        };
        var tokenComment = function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while((ch = stream.next()) != null){
                if (maybeEnd && ch == ">") {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = ch === "#";
            }
            return "comment";
        };
        var tokenVariable = function tokenVariable(stream, state) {
            var ch = stream.peek();
            if (stream.eat("{")) {
                state.tokenize = tokenVariableWithBraces;
                return tokenVariableWithBraces(stream, state);
            } else if (ch != undefined && ch.match(varNames)) {
                stream.eatWhile(varNames);
                state.tokenize = tokenBase;
                return "variable-2";
            } else {
                state.tokenize = tokenBase;
                return "error";
            }
        };
        var tokenVariableWithBraces = function tokenVariableWithBraces(stream, state) {
            var ch;
            while((ch = stream.next()) != null){
                if (ch === "}") {
                    state.tokenize = tokenBase;
                    break;
                }
            }
            return "variable-2";
        };
        var tokenMultiString = function tokenMultiString(stream, state) {
            var quote = state.startQuote;
            if (stream.sol() && stream.match(new RegExp(quote + "@"))) {
                state.tokenize = tokenBase;
            } else if (quote === '"') {
                while(!stream.eol()){
                    var ch = stream.peek();
                    if (ch === "$") {
                        state.tokenize = tokenHereStringInterpolation;
                        return "string";
                    }
                    stream.next();
                    if (ch === "`") {
                        stream.next();
                    }
                }
            } else {
                stream.skipToEnd();
            }
            return "string";
        };
        var notCharacterOrDash = "(?=[^A-Za-z\\d\\-_]|$)";
        var varNames = /[\w\-:]/;
        var keywords = buildRegexp([
            /begin|break|catch|continue|data|default|do|dynamicparam/,
            /else|elseif|end|exit|filter|finally|for|foreach|from|function|if|in/,
            /param|process|return|switch|throw|trap|try|until|where|while/
        ], {
            suffix: notCharacterOrDash
        });
        var punctuation = /[\[\]{},;`\\\.]|@[({]/;
        var wordOperators = buildRegexp([
            "f",
            /b?not/,
            /[ic]?split/,
            "join",
            /is(not)?/,
            "as",
            /[ic]?(eq|ne|[gl][te])/,
            /[ic]?(not)?(like|match|contains)/,
            /[ic]?replace/,
            /b?(and|or|xor)/
        ], {
            prefix: "-"
        });
        var symbolOperators = /[+\-*\/%]=|\+\+|--|\.\.|[+\-*&^%:=!|\/]|<(?!#)|(?!#)>/;
        var operators = buildRegexp([
            wordOperators,
            symbolOperators
        ], {
            suffix: ""
        });
        var numbers = /^((0x[\da-f]+)|((\d+\.\d+|\d\.|\.\d+|\d+)(e[\+\-]?\d+)?))[ld]?([kmgtp]b)?/i;
        var identifiers = /^[A-Za-z\_][A-Za-z\-\_\d]*\b/;
        var symbolBuiltins = /[A-Z]:|%|\?/i;
        var namedBuiltins = buildRegexp([
            /Add-(Computer|Content|History|Member|PSSnapin|Type)/,
            /Checkpoint-Computer/,
            /Clear-(Content|EventLog|History|Host|Item(Property)?|Variable)/,
            /Compare-Object/,
            /Complete-Transaction/,
            /Connect-PSSession/,
            /ConvertFrom-(Csv|Json|SecureString|StringData)/,
            /Convert-Path/,
            /ConvertTo-(Csv|Html|Json|SecureString|Xml)/,
            /Copy-Item(Property)?/,
            /Debug-Process/,
            /Disable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/,
            /Disconnect-PSSession/,
            /Enable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/,
            /(Enter|Exit)-PSSession/,
            /Export-(Alias|Clixml|Console|Counter|Csv|FormatData|ModuleMember|PSSession)/,
            /ForEach-Object/,
            /Format-(Custom|List|Table|Wide)/,
            new RegExp("Get-(Acl|Alias|AuthenticodeSignature|ChildItem|Command|ComputerRestorePoint|Content|ControlPanelItem|Counter|Credential" + "|Culture|Date|Event|EventLog|EventSubscriber|ExecutionPolicy|FormatData|Help|History|Host|HotFix|Item|ItemProperty|Job" + "|Location|Member|Module|PfxCertificate|Process|PSBreakpoint|PSCallStack|PSDrive|PSProvider|PSSession|PSSessionConfiguration" + "|PSSnapin|Random|Service|TraceSource|Transaction|TypeData|UICulture|Unique|Variable|Verb|WinEvent|WmiObject)"),
            /Group-Object/,
            /Import-(Alias|Clixml|Counter|Csv|LocalizedData|Module|PSSession)/,
            /ImportSystemModules/,
            /Invoke-(Command|Expression|History|Item|RestMethod|WebRequest|WmiMethod)/,
            /Join-Path/,
            /Limit-EventLog/,
            /Measure-(Command|Object)/,
            /Move-Item(Property)?/,
            new RegExp("New-(Alias|Event|EventLog|Item(Property)?|Module|ModuleManifest|Object|PSDrive|PSSession|PSSessionConfigurationFile" + "|PSSessionOption|PSTransportOption|Service|TimeSpan|Variable|WebServiceProxy|WinEvent)"),
            /Out-(Default|File|GridView|Host|Null|Printer|String)/,
            /Pause/,
            /(Pop|Push)-Location/,
            /Read-Host/,
            /Receive-(Job|PSSession)/,
            /Register-(EngineEvent|ObjectEvent|PSSessionConfiguration|WmiEvent)/,
            /Remove-(Computer|Event|EventLog|Item(Property)?|Job|Module|PSBreakpoint|PSDrive|PSSession|PSSnapin|TypeData|Variable|WmiObject)/,
            /Rename-(Computer|Item(Property)?)/,
            /Reset-ComputerMachinePassword/,
            /Resolve-Path/,
            /Restart-(Computer|Service)/,
            /Restore-Computer/,
            /Resume-(Job|Service)/,
            /Save-Help/,
            /Select-(Object|String|Xml)/,
            /Send-MailMessage/,
            new RegExp("Set-(Acl|Alias|AuthenticodeSignature|Content|Date|ExecutionPolicy|Item(Property)?|Location|PSBreakpoint|PSDebug" + "|PSSessionConfiguration|Service|StrictMode|TraceSource|Variable|WmiInstance)"),
            /Show-(Command|ControlPanelItem|EventLog)/,
            /Sort-Object/,
            /Split-Path/,
            /Start-(Job|Process|Service|Sleep|Transaction|Transcript)/,
            /Stop-(Computer|Job|Process|Service|Transcript)/,
            /Suspend-(Job|Service)/,
            /TabExpansion2/,
            /Tee-Object/,
            /Test-(ComputerSecureChannel|Connection|ModuleManifest|Path|PSSessionConfigurationFile)/,
            /Trace-Command/,
            /Unblock-File/,
            /Undo-Transaction/,
            /Unregister-(Event|PSSessionConfiguration)/,
            /Update-(FormatData|Help|List|TypeData)/,
            /Use-Transaction/,
            /Wait-(Event|Job|Process)/,
            /Where-Object/,
            /Write-(Debug|Error|EventLog|Host|Output|Progress|Verbose|Warning)/,
            /cd|help|mkdir|more|oss|prompt/,
            /ac|asnp|cat|cd|chdir|clc|clear|clhy|cli|clp|cls|clv|cnsn|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|dnsn|ebp/,
            /echo|epal|epcsv|epsn|erase|etsn|exsn|fc|fl|foreach|ft|fw|gal|gbp|gc|gci|gcm|gcs|gdr|ghy|gi|gjb|gl|gm|gmo|gp|gps/,
            /group|gsn|gsnp|gsv|gu|gv|gwmi|h|history|icm|iex|ihy|ii|ipal|ipcsv|ipmo|ipsn|irm|ise|iwmi|iwr|kill|lp|ls|man|md/,
            /measure|mi|mount|move|mp|mv|nal|ndr|ni|nmo|npssc|nsn|nv|ogv|oh|popd|ps|pushd|pwd|r|rbp|rcjb|rcsn|rd|rdr|ren|ri/,
            /rjb|rm|rmdir|rmo|rni|rnp|rp|rsn|rsnp|rujb|rv|rvpa|rwmi|sajb|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls/,
            /sort|sp|spjb|spps|spsv|start|sujb|sv|swmi|tee|trcm|type|where|wjb|write/
        ], {
            prefix: "",
            suffix: ""
        });
        var variableBuiltins = buildRegexp([
            /[$?^_]|Args|ConfirmPreference|ConsoleFileName|DebugPreference|Error|ErrorActionPreference|ErrorView|ExecutionContext/,
            /FormatEnumerationLimit|Home|Host|Input|MaximumAliasCount|MaximumDriveCount|MaximumErrorCount|MaximumFunctionCount/,
            /MaximumHistoryCount|MaximumVariableCount|MyInvocation|NestedPromptLevel|OutputEncoding|Pid|Profile|ProgressPreference/,
            /PSBoundParameters|PSCommandPath|PSCulture|PSDefaultParameterValues|PSEmailServer|PSHome|PSScriptRoot|PSSessionApplicationName/,
            /PSSessionConfigurationName|PSSessionOption|PSUICulture|PSVersionTable|Pwd|ShellId|StackTrace|VerbosePreference/,
            /WarningPreference|WhatIfPreference/,
            /Event|EventArgs|EventSubscriber|Sender/,
            /Matches|Ofs|ForEach|LastExitCode|PSCmdlet|PSItem|PSSenderInfo|This/,
            /true|false|null/
        ], {
            prefix: "\\$",
            suffix: ""
        });
        var builtins = buildRegexp([
            symbolBuiltins,
            namedBuiltins,
            variableBuiltins
        ], {
            suffix: notCharacterOrDash
        });
        var grammar = {
            keyword: keywords,
            number: numbers,
            operator: operators,
            builtin: builtins,
            punctuation: punctuation,
            identifier: identifiers
        };
        var external = {
            startState: function startState() {
                return {
                    returnStack: [],
                    bracketNesting: 0,
                    tokenize: tokenBase
                };
            },
            token: function token(stream, state) {
                return state.tokenize(stream, state);
            },
            blockCommentStart: "<#",
            blockCommentEnd: "#>",
            lineComment: "#",
            fold: "brace"
        };
        return external;
    });
    CodeMirror.defineMIME("application/x-powershell", "powershell");
});
});

var python = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var wordRegexp = function wordRegexp(words) {
        return new RegExp("^((" + words.join(")|(") + "))\\b");
    };
    var top = function top(state) {
        return state.scopes[state.scopes.length - 1];
    };
    var wordOperators = wordRegexp([
        "and",
        "or",
        "not",
        "is"
    ]);
    var commonKeywords = [
        "as",
        "assert",
        "break",
        "class",
        "continue",
        "def",
        "del",
        "elif",
        "else",
        "except",
        "finally",
        "for",
        "from",
        "global",
        "if",
        "import",
        "lambda",
        "pass",
        "raise",
        "return",
        "try",
        "while",
        "with",
        "yield",
        "in"
    ];
    var commonBuiltins = [
        "abs",
        "all",
        "any",
        "bin",
        "bool",
        "bytearray",
        "callable",
        "chr",
        "classmethod",
        "compile",
        "complex",
        "delattr",
        "dict",
        "dir",
        "divmod",
        "enumerate",
        "eval",
        "filter",
        "float",
        "format",
        "frozenset",
        "getattr",
        "globals",
        "hasattr",
        "hash",
        "help",
        "hex",
        "id",
        "input",
        "int",
        "isinstance",
        "issubclass",
        "iter",
        "len",
        "list",
        "locals",
        "map",
        "max",
        "memoryview",
        "min",
        "next",
        "object",
        "oct",
        "open",
        "ord",
        "pow",
        "property",
        "range",
        "repr",
        "reversed",
        "round",
        "set",
        "setattr",
        "slice",
        "sorted",
        "staticmethod",
        "str",
        "sum",
        "super",
        "tuple",
        "type",
        "vars",
        "zip",
        "__import__",
        "NotImplemented",
        "Ellipsis",
        "__debug__"
    ];
    CodeMirror1.registerHelper("hintWords", "python", commonKeywords.concat(commonBuiltins));
    CodeMirror1.defineMode("python", function(conf, parserConf) {
        var tokenBase = // tokenizers
        function tokenBase(stream, state) {
            var sol = stream.sol() && state.lastToken != "\\";
            if (sol) state.indent = stream.indentation();
            // Handle scope changes
            if (sol && top(state).type == "py") {
                var scopeOffset = top(state).offset;
                if (stream.eatSpace()) {
                    var lineOffset = stream.indentation();
                    if (lineOffset > scopeOffset) pushPyScope(state);
                    else if (lineOffset < scopeOffset && dedent(stream, state) && stream.peek() != "#") state.errorToken = true;
                    return null;
                } else {
                    var style = tokenBaseInner(stream, state);
                    if (scopeOffset > 0 && dedent(stream, state)) style += " " + ERRORCLASS;
                    return style;
                }
            }
            return tokenBaseInner(stream, state);
        };
        var tokenBaseInner = function tokenBaseInner(stream, state, inFormat) {
            if (stream.eatSpace()) return null;
            // Handle Comments
            if (!inFormat && stream.match(/^#.*/)) return "comment";
            // Handle Number Literals
            if (stream.match(/^[0-9\.]/, false)) {
                var floatLiteral = false;
                // Floats
                if (stream.match(/^[\d_]*\.\d+(e[\+\-]?\d+)?/i)) {
                    floatLiteral = true;
                }
                if (stream.match(/^[\d_]+\.\d*/)) {
                    floatLiteral = true;
                }
                if (stream.match(/^\.\d+/)) {
                    floatLiteral = true;
                }
                if (floatLiteral) {
                    // Float literals may be "imaginary"
                    stream.eat(/J/i);
                    return "number";
                }
                // Integers
                var intLiteral = false;
                // Hex
                if (stream.match(/^0x[0-9a-f_]+/i)) intLiteral = true;
                // Binary
                if (stream.match(/^0b[01_]+/i)) intLiteral = true;
                // Octal
                if (stream.match(/^0o[0-7_]+/i)) intLiteral = true;
                // Decimal
                if (stream.match(/^[1-9][\d_]*(e[\+\-]?[\d_]+)?/)) {
                    // Decimal literals may be "imaginary"
                    stream.eat(/J/i);
                    // TODO - Can you have imaginary longs?
                    intLiteral = true;
                }
                // Zero by itself with no other piece of number.
                if (stream.match(/^0(?![\dx])/i)) intLiteral = true;
                if (intLiteral) {
                    // Integer literals may be "long"
                    stream.eat(/L/i);
                    return "number";
                }
            }
            // Handle Strings
            if (stream.match(stringPrefixes)) {
                var isFmtString = stream.current().toLowerCase().indexOf("f") !== -1;
                if (!isFmtString) {
                    state.tokenize = tokenStringFactory(stream.current(), state.tokenize);
                    return state.tokenize(stream, state);
                } else {
                    state.tokenize = formatStringFactory(stream.current(), state.tokenize);
                    return state.tokenize(stream, state);
                }
            }
            for(var i = 0; i < operators.length; i++)if (stream.match(operators[i])) return "operator";
            if (stream.match(delimiters)) return "punctuation";
            if (state.lastToken == "." && stream.match(identifiers)) return "property";
            if (stream.match(keywords) || stream.match(wordOperators)) return "keyword";
            if (stream.match(builtins)) return "builtin";
            if (stream.match(/^(self|cls)\b/)) return "variable-2";
            if (stream.match(identifiers)) {
                if (state.lastToken == "def" || state.lastToken == "class") return "def";
                return "variable";
            }
            // Handle non-detected items
            stream.next();
            return inFormat ? null : ERRORCLASS;
        };
        var formatStringFactory = function formatStringFactory(delimiter, tokenOuter) {
            while("rubf".indexOf(delimiter.charAt(0).toLowerCase()) >= 0)delimiter = delimiter.substr(1);
            var singleline = delimiter.length == 1;
            var OUTCLASS = "string";
            function tokenNestedExpr(depth) {
                return function(stream, state) {
                    var inner = tokenBaseInner(stream, state, true);
                    if (inner == "punctuation") {
                        if (stream.current() == "{") {
                            state.tokenize = tokenNestedExpr(depth + 1);
                        } else if (stream.current() == "}") {
                            if (depth > 1) state.tokenize = tokenNestedExpr(depth - 1);
                            else state.tokenize = tokenString;
                        }
                    }
                    return inner;
                };
            }
            function tokenString(stream, state) {
                while(!stream.eol()){
                    stream.eatWhile(/[^'"\{\}\\]/);
                    if (stream.eat("\\")) {
                        stream.next();
                        if (singleline && stream.eol()) return OUTCLASS;
                    } else if (stream.match(delimiter)) {
                        state.tokenize = tokenOuter;
                        return OUTCLASS;
                    } else if (stream.match("{{")) {
                        // ignore {{ in f-str
                        return OUTCLASS;
                    } else if (stream.match("{", false)) {
                        // switch to nested mode
                        state.tokenize = tokenNestedExpr(0);
                        if (stream.current()) return OUTCLASS;
                        else return state.tokenize(stream, state);
                    } else if (stream.match("}}")) {
                        return OUTCLASS;
                    } else if (stream.match("}")) {
                        // single } in f-string is an error
                        return ERRORCLASS;
                    } else {
                        stream.eat(/['"]/);
                    }
                }
                if (singleline) {
                    if (parserConf.singleLineStringErrors) return ERRORCLASS;
                    else state.tokenize = tokenOuter;
                }
                return OUTCLASS;
            }
            tokenString.isString = true;
            return tokenString;
        };
        var tokenStringFactory = function tokenStringFactory(delimiter, tokenOuter) {
            while("rubf".indexOf(delimiter.charAt(0).toLowerCase()) >= 0)delimiter = delimiter.substr(1);
            var singleline = delimiter.length == 1;
            var OUTCLASS = "string";
            function tokenString(stream, state) {
                while(!stream.eol()){
                    stream.eatWhile(/[^'"\\]/);
                    if (stream.eat("\\")) {
                        stream.next();
                        if (singleline && stream.eol()) return OUTCLASS;
                    } else if (stream.match(delimiter)) {
                        state.tokenize = tokenOuter;
                        return OUTCLASS;
                    } else {
                        stream.eat(/['"]/);
                    }
                }
                if (singleline) {
                    if (parserConf.singleLineStringErrors) return ERRORCLASS;
                    else state.tokenize = tokenOuter;
                }
                return OUTCLASS;
            }
            tokenString.isString = true;
            return tokenString;
        };
        var pushPyScope = function pushPyScope(state) {
            while(top(state).type != "py")state.scopes.pop();
            state.scopes.push({
                offset: top(state).offset + conf.indentUnit,
                type: "py",
                align: null
            });
        };
        var pushBracketScope = function pushBracketScope(stream, state, type) {
            var align = stream.match(/^[\s\[\{\(]*(?:#|$)/, false) ? null : stream.column() + 1;
            state.scopes.push({
                offset: state.indent + hangingIndent,
                type: type,
                align: align
            });
        };
        var dedent = function dedent(stream, state) {
            var indented = stream.indentation();
            while(state.scopes.length > 1 && top(state).offset > indented){
                if (top(state).type != "py") return true;
                state.scopes.pop();
            }
            return top(state).offset != indented;
        };
        var tokenLexer = function tokenLexer(stream, state) {
            if (stream.sol()) {
                state.beginningOfLine = true;
                state.dedent = false;
            }
            var style = state.tokenize(stream, state);
            var current = stream.current();
            // Handle decorators
            if (state.beginningOfLine && current == "@") return stream.match(identifiers, false) ? "meta" : py3 ? "operator" : ERRORCLASS;
            if (/\S/.test(current)) state.beginningOfLine = false;
            if ((style == "variable" || style == "builtin") && state.lastToken == "meta") style = "meta";
            // Handle scope changes.
            if (current == "pass" || current == "return") state.dedent = true;
            if (current == "lambda") state.lambda = true;
            if (current == ":" && !state.lambda && top(state).type == "py" && stream.match(/^\s*(?:#|$)/, false)) pushPyScope(state);
            if (current.length == 1 && !/string|comment/.test(style)) {
                var delimiter_index = "[({".indexOf(current);
                if (delimiter_index != -1) pushBracketScope(stream, state, "])}".slice(delimiter_index, delimiter_index + 1));
                delimiter_index = "])}".indexOf(current);
                if (delimiter_index != -1) {
                    if (top(state).type == current) state.indent = state.scopes.pop().offset - hangingIndent;
                    else return ERRORCLASS;
                }
            }
            if (state.dedent && stream.eol() && top(state).type == "py" && state.scopes.length > 1) state.scopes.pop();
            return style;
        };
        var ERRORCLASS = "error";
        var delimiters = parserConf.delimiters || parserConf.singleDelimiters || /^[\(\)\[\]\{\}@,:`=;\.\\]/;
        //               (Backwards-compatibility with old, cumbersome config system)
        var operators = [
            parserConf.singleOperators,
            parserConf.doubleOperators,
            parserConf.doubleDelimiters,
            parserConf.tripleDelimiters,
            parserConf.operators || /^([-+*/%\/&|^]=?|[<>=]+|\/\/=?|\*\*=?|!=|[~!@]|\.\.\.)/
        ];
        for(var i = 0; i < operators.length; i++)if (!operators[i]) operators.splice(i--, 1);
        var hangingIndent = parserConf.hangingIndent || conf.indentUnit;
        var myKeywords = commonKeywords, myBuiltins = commonBuiltins;
        if (parserConf.extra_keywords != undefined) myKeywords = myKeywords.concat(parserConf.extra_keywords);
        if (parserConf.extra_builtins != undefined) myBuiltins = myBuiltins.concat(parserConf.extra_builtins);
        var py3 = !(parserConf.version && Number(parserConf.version) < 3);
        if (py3) {
            // since http://legacy.python.org/dev/peps/pep-0465/ @ is also an operator
            var identifiers = parserConf.identifiers || /^[_A-Za-z\u00A1-\uFFFF][_A-Za-z0-9\u00A1-\uFFFF]*/;
            myKeywords = myKeywords.concat([
                "nonlocal",
                "False",
                "True",
                "None",
                "async",
                "await"
            ]);
            myBuiltins = myBuiltins.concat([
                "ascii",
                "bytes",
                "exec",
                "print"
            ]);
            var stringPrefixes = new RegExp("^(([rbuf]|(br)|(rb)|(fr)|(rf))?('{3}|\"{3}|['\"]))", "i");
        } else {
            var identifiers = parserConf.identifiers || /^[_A-Za-z][_A-Za-z0-9]*/;
            myKeywords = myKeywords.concat([
                "exec",
                "print"
            ]);
            myBuiltins = myBuiltins.concat([
                "apply",
                "basestring",
                "buffer",
                "cmp",
                "coerce",
                "execfile",
                "file",
                "intern",
                "long",
                "raw_input",
                "reduce",
                "reload",
                "unichr",
                "unicode",
                "xrange",
                "False",
                "True",
                "None"
            ]);
            var stringPrefixes = new RegExp("^(([rubf]|(ur)|(br))?('{3}|\"{3}|['\"]))", "i");
        }
        var keywords = wordRegexp(myKeywords);
        var builtins = wordRegexp(myBuiltins);
        var external = {
            startState: function startState(basecolumn) {
                return {
                    tokenize: tokenBase,
                    scopes: [
                        {
                            offset: basecolumn || 0,
                            type: "py",
                            align: null
                        }
                    ],
                    indent: basecolumn || 0,
                    lastToken: null,
                    lambda: false,
                    dedent: 0
                };
            },
            token: function token(stream, state) {
                var addErr = state.errorToken;
                if (addErr) state.errorToken = false;
                var style = tokenLexer(stream, state);
                if (style && style != "comment") state.lastToken = style == "keyword" || style == "punctuation" ? stream.current() : style;
                if (style == "punctuation") style = null;
                if (stream.eol() && state.lambda) state.lambda = false;
                return addErr ? style + " " + ERRORCLASS : style;
            },
            indent: function indent(state, textAfter) {
                if (state.tokenize != tokenBase) return state.tokenize.isString ? CodeMirror1.Pass : 0;
                var scope = top(state);
                var closing = scope.type == textAfter.charAt(0) || scope.type == "py" && !state.dedent && /^(else:|elif |except |finally:)/.test(textAfter);
                if (scope.align != null) return scope.align - (closing ? 1 : 0);
                else return scope.offset - (closing ? hangingIndent : 0);
            },
            electricInput: /^\s*([\}\]\)]|else:|elif |except |finally:)$/,
            closeBrackets: {
                triples: "'\""
            },
            lineComment: "#",
            fold: "indent"
        };
        return external;
    });
    CodeMirror1.defineMIME("text/x-python", "python");
    var words = function words(str) {
        return str.split(" ");
    };
    CodeMirror1.defineMIME("text/x-cython", {
        name: "python",
        extra_keywords: words("by cdef cimport cpdef ctypedef enum except " + "extern gil include nogil property public " + "readonly struct union DEF IF ELIF ELSE")
    });
});
});

var r = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.registerHelper("wordChars", "r", /[\w.]/);
    CodeMirror1.defineMode("r", function(config) {
        var wordObj = function wordObj(words) {
            var res = {};
            for(var i = 0; i < words.length; ++i)res[words[i]] = true;
            return res;
        };
        var tokenBase = function tokenBase(stream, state) {
            curPunc = null;
            var ch = stream.next();
            if (ch == "#") {
                stream.skipToEnd();
                return "comment";
            } else if (ch == "0" && stream.eat("x")) {
                stream.eatWhile(/[\da-f]/i);
                return "number";
            } else if (ch == "." && stream.eat(/\d/)) {
                stream.match(/\d*(?:e[+\-]?\d+)?/);
                return "number";
            } else if (/\d/.test(ch)) {
                stream.match(/\d*(?:\.\d+)?(?:e[+\-]\d+)?L?/);
                return "number";
            } else if (ch == "'" || ch == '"') {
                state.tokenize = tokenString(ch);
                return "string";
            } else if (ch == "`") {
                stream.match(/[^`]+`/);
                return "variable-3";
            } else if (ch == "." && stream.match(/.(?:[.]|\d+)/)) {
                return "keyword";
            } else if (/[a-zA-Z\.]/.test(ch)) {
                stream.eatWhile(/[\w\.]/);
                var word = stream.current();
                if (atoms.propertyIsEnumerable(word)) return "atom";
                if (keywords.propertyIsEnumerable(word)) {
                    // Block keywords start new blocks, except 'else if', which only starts
                    // one new block for the 'if', no block for the 'else'.
                    if (blockkeywords.propertyIsEnumerable(word) && !stream.match(/\s*if(\s+|$)/, false)) curPunc = "block";
                    return "keyword";
                }
                if (builtins.propertyIsEnumerable(word)) return "builtin";
                return "variable";
            } else if (ch == "%") {
                if (stream.skipTo("%")) stream.next();
                return "operator variable-2";
            } else if (ch == "<" && stream.eat("-") || ch == "<" && stream.match("<-") || ch == "-" && stream.match(/>>?/)) {
                return "operator arrow";
            } else if (ch == "=" && state.ctx.argList) {
                return "arg-is";
            } else if (opChars.test(ch)) {
                if (ch == "$") return "operator dollar";
                stream.eatWhile(opChars);
                return "operator";
            } else if (/[\(\){}\[\];]/.test(ch)) {
                curPunc = ch;
                if (ch == ";") return "semi";
                return null;
            } else {
                return null;
            }
        };
        var tokenString = function tokenString(quote) {
            return function(stream, state) {
                if (stream.eat("\\")) {
                    var ch = stream.next();
                    if (ch == "x") stream.match(/^[a-f0-9]{2}/i);
                    else if ((ch == "u" || ch == "U") && stream.eat("{") && stream.skipTo("}")) stream.next();
                    else if (ch == "u") stream.match(/^[a-f0-9]{4}/i);
                    else if (ch == "U") stream.match(/^[a-f0-9]{8}/i);
                    else if (/[0-7]/.test(ch)) stream.match(/^[0-7]{1,2}/);
                    return "string-2";
                } else {
                    var next;
                    while((next = stream.next()) != null){
                        if (next == quote) {
                            state.tokenize = tokenBase;
                            break;
                        }
                        if (next == "\\") {
                            stream.backUp(1);
                            break;
                        }
                    }
                    return "string";
                }
            };
        };
        var push = function push(state, type, stream) {
            state.ctx = {
                type: type,
                indent: state.indent,
                flags: 0,
                column: stream.column(),
                prev: state.ctx
            };
        };
        var setFlag = function setFlag(state, flag) {
            var ctx = state.ctx;
            state.ctx = {
                type: ctx.type,
                indent: ctx.indent,
                flags: ctx.flags | flag,
                column: ctx.column,
                prev: ctx.prev
            };
        };
        var pop = function pop(state) {
            state.indent = state.ctx.indent;
            state.ctx = state.ctx.prev;
        };
        var commonAtoms = [
            "NULL",
            "NA",
            "Inf",
            "NaN",
            "NA_integer_",
            "NA_real_",
            "NA_complex_",
            "NA_character_",
            "TRUE",
            "FALSE"
        ];
        var commonBuiltins = [
            "list",
            "quote",
            "bquote",
            "eval",
            "return",
            "call",
            "parse",
            "deparse"
        ];
        var commonKeywords = [
            "if",
            "else",
            "repeat",
            "while",
            "function",
            "for",
            "in",
            "next",
            "break"
        ];
        var commonBlockKeywords = [
            "if",
            "else",
            "repeat",
            "while",
            "function",
            "for"
        ];
        CodeMirror1.registerHelper("hintWords", "r", commonAtoms.concat(commonBuiltins, commonKeywords));
        var atoms = wordObj(commonAtoms);
        var builtins = wordObj(commonBuiltins);
        var keywords = wordObj(commonKeywords);
        var blockkeywords = wordObj(commonBlockKeywords);
        var opChars = /[+\-*\/^<>=!&|~$:]/;
        var curPunc;
        var ALIGN_YES = 1, ALIGN_NO = 2, BRACELESS = 4;
        return {
            startState: function startState() {
                return {
                    tokenize: tokenBase,
                    ctx: {
                        type: "top",
                        indent: -config.indentUnit,
                        flags: ALIGN_NO
                    },
                    indent: 0,
                    afterIdent: false
                };
            },
            token: function token(stream, state) {
                if (stream.sol()) {
                    if ((state.ctx.flags & 3) == 0) state.ctx.flags |= ALIGN_NO;
                    if (state.ctx.flags & BRACELESS) pop(state);
                    state.indent = stream.indentation();
                }
                if (stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (style != "comment" && (state.ctx.flags & ALIGN_NO) == 0) setFlag(state, ALIGN_YES);
                if ((curPunc == ";" || curPunc == "{" || curPunc == "}") && state.ctx.type == "block") pop(state);
                if (curPunc == "{") push(state, "}", stream);
                else if (curPunc == "(") {
                    push(state, ")", stream);
                    if (state.afterIdent) state.ctx.argList = true;
                } else if (curPunc == "[") push(state, "]", stream);
                else if (curPunc == "block") push(state, "block", stream);
                else if (curPunc == state.ctx.type) pop(state);
                else if (state.ctx.type == "block" && style != "comment") setFlag(state, BRACELESS);
                state.afterIdent = style == "variable" || style == "keyword";
                return style;
            },
            indent: function indent(state, textAfter) {
                if (state.tokenize != tokenBase) return 0;
                var firstChar = textAfter && textAfter.charAt(0), ctx = state.ctx, closing = firstChar == ctx.type;
                if (ctx.flags & BRACELESS) ctx = ctx.prev;
                if (ctx.type == "block") return ctx.indent + (firstChar == "{" ? 0 : config.indentUnit);
                else if (ctx.flags & ALIGN_YES) return ctx.column + (closing ? 0 : 1);
                else return ctx.indent + (closing ? 0 : config.indentUnit);
            },
            lineComment: "#"
        };
    });
    CodeMirror1.defineMIME("text/x-rsrc", "r");
});
});

var ruby = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var wordObj = function wordObj(words) {
        var o = {};
        for(var i = 0, e = words.length; i < e; ++i)o[words[i]] = true;
        return o;
    };
    var keywordList = [
        "alias",
        "and",
        "BEGIN",
        "begin",
        "break",
        "case",
        "class",
        "def",
        "defined?",
        "do",
        "else",
        "elsif",
        "END",
        "end",
        "ensure",
        "false",
        "for",
        "if",
        "in",
        "module",
        "next",
        "not",
        "or",
        "redo",
        "rescue",
        "retry",
        "return",
        "self",
        "super",
        "then",
        "true",
        "undef",
        "unless",
        "until",
        "when",
        "while",
        "yield",
        "nil",
        "raise",
        "throw",
        "catch",
        "fail",
        "loop",
        "callcc",
        "caller",
        "lambda",
        "proc",
        "public",
        "protected",
        "private",
        "require",
        "load",
        "require_relative",
        "extend",
        "autoload",
        "__END__",
        "__FILE__",
        "__LINE__",
        "__dir__"
    ], keywords = wordObj(keywordList);
    var indentWords = wordObj([
        "def",
        "class",
        "case",
        "for",
        "while",
        "until",
        "module",
        "then",
        "catch",
        "loop",
        "proc",
        "begin"
    ]);
    var dedentWords = wordObj([
        "end",
        "until"
    ]);
    var opening = {
        "[": "]",
        "{": "}",
        "(": ")"
    };
    var closing = {
        "]": "[",
        "}": "{",
        ")": "("
    };
    CodeMirror1.defineMode("ruby", function(config) {
        var chain = function chain(newtok, stream, state) {
            state.tokenize.push(newtok);
            return newtok(stream, state);
        };
        var tokenBase = function tokenBase(stream, state) {
            if (stream.sol() && stream.match("=begin") && stream.eol()) {
                state.tokenize.push(readBlockComment);
                return "comment";
            }
            if (stream.eatSpace()) return null;
            var ch = stream.next(), m;
            if (ch == "`" || ch == "'" || ch == '"') {
                return chain(readQuoted(ch, "string", ch == '"' || ch == "`"), stream, state);
            } else if (ch == "/") {
                if (regexpAhead(stream)) return chain(readQuoted(ch, "string-2", true), stream, state);
                else return "operator";
            } else if (ch == "%") {
                var style = "string", embed = true;
                if (stream.eat("s")) style = "atom";
                else if (stream.eat(/[WQ]/)) style = "string";
                else if (stream.eat(/[r]/)) style = "string-2";
                else if (stream.eat(/[wxq]/)) {
                    style = "string";
                    embed = false;
                }
                var delim = stream.eat(/[^\w\s=]/);
                if (!delim) return "operator";
                if (opening.propertyIsEnumerable(delim)) delim = opening[delim];
                return chain(readQuoted(delim, style, embed, true), stream, state);
            } else if (ch == "#") {
                stream.skipToEnd();
                return "comment";
            } else if (ch == "<" && (m = stream.match(/^<([-~])[\`\"\']?([a-zA-Z_?]\w*)[\`\"\']?(?:;|$)/))) {
                return chain(readHereDoc(m[2], m[1]), stream, state);
            } else if (ch == "0") {
                if (stream.eat("x")) stream.eatWhile(/[\da-fA-F]/);
                else if (stream.eat("b")) stream.eatWhile(/[01]/);
                else stream.eatWhile(/[0-7]/);
                return "number";
            } else if (/\d/.test(ch)) {
                stream.match(/^[\d_]*(?:\.[\d_]+)?(?:[eE][+\-]?[\d_]+)?/);
                return "number";
            } else if (ch == "?") {
                while(stream.match(/^\\[CM]-/)){}
                if (stream.eat("\\")) stream.eatWhile(/\w/);
                else stream.next();
                return "string";
            } else if (ch == ":") {
                if (stream.eat("'")) return chain(readQuoted("'", "atom", false), stream, state);
                if (stream.eat('"')) return chain(readQuoted('"', "atom", true), stream, state);
                // :> :>> :< :<< are valid symbols
                if (stream.eat(/[\<\>]/)) {
                    stream.eat(/[\<\>]/);
                    return "atom";
                }
                // :+ :- :/ :* :| :& :! are valid symbols
                if (stream.eat(/[\+\-\*\/\&\|\:\!]/)) {
                    return "atom";
                }
                // Symbols can't start by a digit
                if (stream.eat(/[a-zA-Z$@_\xa1-\uffff]/)) {
                    stream.eatWhile(/[\w$\xa1-\uffff]/);
                    // Only one ? ! = is allowed and only as the last character
                    stream.eat(/[\?\!\=]/);
                    return "atom";
                }
                return "operator";
            } else if (ch == "@" && stream.match(/^@?[a-zA-Z_\xa1-\uffff]/)) {
                stream.eat("@");
                stream.eatWhile(/[\w\xa1-\uffff]/);
                return "variable-2";
            } else if (ch == "$") {
                if (stream.eat(/[a-zA-Z_]/)) {
                    stream.eatWhile(/[\w]/);
                } else if (stream.eat(/\d/)) {
                    stream.eat(/\d/);
                } else {
                    stream.next(); // Must be a special global like $: or $!
                }
                return "variable-3";
            } else if (/[a-zA-Z_\xa1-\uffff]/.test(ch)) {
                stream.eatWhile(/[\w\xa1-\uffff]/);
                stream.eat(/[\?\!]/);
                if (stream.eat(":")) return "atom";
                return "ident";
            } else if (ch == "|" && (state.varList || state.lastTok == "{" || state.lastTok == "do")) {
                curPunc = "|";
                return null;
            } else if (/[\(\)\[\]{}\\;]/.test(ch)) {
                curPunc = ch;
                return null;
            } else if (ch == "-" && stream.eat(">")) {
                return "arrow";
            } else if (/[=+\-\/*:\.^%<>~|]/.test(ch)) {
                var more = stream.eatWhile(/[=+\-\/*:\.^%<>~|]/);
                if (ch == "." && !more) curPunc = ".";
                return "operator";
            } else {
                return null;
            }
        };
        var regexpAhead = function regexpAhead(stream) {
            var start = stream.pos, depth = 0, next, found = false, escaped = false;
            while((next = stream.next()) != null){
                if (!escaped) {
                    if ("[{(".indexOf(next) > -1) {
                        depth++;
                    } else if ("]})".indexOf(next) > -1) {
                        depth--;
                        if (depth < 0) break;
                    } else if (next == "/" && depth == 0) {
                        found = true;
                        break;
                    }
                    escaped = next == "\\";
                } else {
                    escaped = false;
                }
            }
            stream.backUp(stream.pos - start);
            return found;
        };
        var tokenBaseOnce = function tokenBaseOnce() {
            var alreadyCalled = false;
            return function(stream, state) {
                if (alreadyCalled) {
                    state.tokenize.pop();
                    return state.tokenize[state.tokenize.length - 1](stream, state);
                }
                alreadyCalled = true;
                return tokenBase(stream, state);
            };
        };
        var readQuoted = function readQuoted(quote, style, embed, unescaped) {
            return function(stream, state) {
                var escaped = false, ch;
                if (state.context.type === "read-quoted-paused") {
                    state.context = state.context.prev;
                    stream.eat("}");
                }
                while((ch = stream.next()) != null){
                    if (ch == quote && (unescaped || !escaped)) {
                        state.tokenize.pop();
                        break;
                    }
                    if (embed && ch == "#" && !escaped) {
                        if (stream.eat("{")) {
                            if (quote == "}") {
                                state.context = {
                                    prev: state.context,
                                    type: "read-quoted-paused"
                                };
                            }
                            state.tokenize.push(tokenBaseUntilBrace());
                            break;
                        } else if (/[@\$]/.test(stream.peek())) {
                            state.tokenize.push(tokenBaseOnce());
                            break;
                        }
                    }
                    escaped = !escaped && ch == "\\";
                }
                return style;
            };
        };
        var readHereDoc = function readHereDoc(phrase, mayIndent) {
            return function(stream, state) {
                if (mayIndent) stream.eatSpace();
                if (stream.match(phrase)) state.tokenize.pop();
                else stream.skipToEnd();
                return "string";
            };
        };
        var readBlockComment = function readBlockComment(stream, state) {
            if (stream.sol() && stream.match("=end") && stream.eol()) state.tokenize.pop();
            stream.skipToEnd();
            return "comment";
        };
        var curPunc;
        function tokenBaseUntilBrace(depth) {
            if (!depth) depth = 1;
            return function(stream, state) {
                if (stream.peek() == "}") {
                    if (depth == 1) {
                        state.tokenize.pop();
                        return state.tokenize[state.tokenize.length - 1](stream, state);
                    } else {
                        state.tokenize[state.tokenize.length - 1] = tokenBaseUntilBrace(depth - 1);
                    }
                } else if (stream.peek() == "{") {
                    state.tokenize[state.tokenize.length - 1] = tokenBaseUntilBrace(depth + 1);
                }
                return tokenBase(stream, state);
            };
        }
        return {
            startState: function startState() {
                return {
                    tokenize: [
                        tokenBase
                    ],
                    indented: 0,
                    context: {
                        type: "top",
                        indented: -config.indentUnit
                    },
                    continuedLine: false,
                    lastTok: null,
                    varList: false
                };
            },
            token: function token(stream, state) {
                curPunc = null;
                if (stream.sol()) state.indented = stream.indentation();
                var style = state.tokenize[state.tokenize.length - 1](stream, state), kwtype;
                var thisTok = curPunc;
                if (style == "ident") {
                    var word = stream.current();
                    style = state.lastTok == "." ? "property" : keywords.propertyIsEnumerable(stream.current()) ? "keyword" : /^[A-Z]/.test(word) ? "tag" : state.lastTok == "def" || state.lastTok == "class" || state.varList ? "def" : "variable";
                    if (style == "keyword") {
                        thisTok = word;
                        if (indentWords.propertyIsEnumerable(word)) kwtype = "indent";
                        else if (dedentWords.propertyIsEnumerable(word)) kwtype = "dedent";
                        else if ((word == "if" || word == "unless") && stream.column() == stream.indentation()) kwtype = "indent";
                        else if (word == "do" && state.context.indented < state.indented) kwtype = "indent";
                    }
                }
                if (curPunc || style && style != "comment") state.lastTok = thisTok;
                if (curPunc == "|") state.varList = !state.varList;
                if (kwtype == "indent" || /[\(\[\{]/.test(curPunc)) state.context = {
                    prev: state.context,
                    type: curPunc || style,
                    indented: state.indented
                };
                else if ((kwtype == "dedent" || /[\)\]\}]/.test(curPunc)) && state.context.prev) state.context = state.context.prev;
                if (stream.eol()) state.continuedLine = curPunc == "\\" || style == "operator";
                return style;
            },
            indent: function indent(state, textAfter) {
                if (state.tokenize[state.tokenize.length - 1] != tokenBase) return CodeMirror1.Pass;
                var firstChar = textAfter && textAfter.charAt(0);
                var ct = state.context;
                var closed = ct.type == closing[firstChar] || ct.type == "keyword" && /^(?:end|until|else|elsif|when|rescue)\b/.test(textAfter);
                return ct.indented + (closed ? 0 : config.indentUnit) + (state.continuedLine ? config.indentUnit : 0);
            },
            electricInput: /^\s*(?:end|rescue|elsif|else|\})$/,
            lineComment: "#",
            fold: "indent"
        };
    });
    CodeMirror1.defineMIME("text/x-ruby", "ruby");
    CodeMirror1.registerHelper("hintWords", "ruby", keywordList);
});
});

var sass = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, css);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("sass", function(config) {
        var tokenRegexp = function tokenRegexp(words) {
            return new RegExp("^" + words.join("|"));
        };
        var isEndLine = function isEndLine(stream) {
            return !stream.peek() || stream.match(/\s+$/, false);
        };
        var urlTokens = function urlTokens(stream, state) {
            var ch = stream.peek();
            if (ch === ")") {
                stream.next();
                state.tokenizer = tokenBase;
                return "operator";
            } else if (ch === "(") {
                stream.next();
                stream.eatSpace();
                return "operator";
            } else if (ch === "'" || ch === '"') {
                state.tokenizer = buildStringTokenizer(stream.next());
                return "string";
            } else {
                state.tokenizer = buildStringTokenizer(")", false);
                return "string";
            }
        };
        var comment = function comment(indentation, multiLine) {
            return function(stream, state) {
                if (stream.sol() && stream.indentation() <= indentation) {
                    state.tokenizer = tokenBase;
                    return tokenBase(stream, state);
                }
                if (multiLine && stream.skipTo("*/")) {
                    stream.next();
                    stream.next();
                    state.tokenizer = tokenBase;
                } else {
                    stream.skipToEnd();
                }
                return "comment";
            };
        };
        var buildStringTokenizer = function buildStringTokenizer(quote, greedy) {
            if (greedy == null) {
                greedy = true;
            }
            function stringTokenizer(stream, state) {
                var nextChar = stream.next();
                var peekChar = stream.peek();
                var previousChar = stream.string.charAt(stream.pos - 2);
                var endingString = nextChar !== "\\" && peekChar === quote || nextChar === quote && previousChar !== "\\";
                if (endingString) {
                    if (nextChar !== quote && greedy) {
                        stream.next();
                    }
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    state.tokenizer = tokenBase;
                    return "string";
                } else if (nextChar === "#" && peekChar === "{") {
                    state.tokenizer = buildInterpolationTokenizer(stringTokenizer);
                    stream.next();
                    return "operator";
                } else {
                    return "string";
                }
            }
            return stringTokenizer;
        };
        var buildInterpolationTokenizer = function buildInterpolationTokenizer(currentTokenizer) {
            return function(stream, state) {
                if (stream.peek() === "}") {
                    stream.next();
                    state.tokenizer = currentTokenizer;
                    return "operator";
                } else {
                    return tokenBase(stream, state);
                }
            };
        };
        var indent = function indent(state) {
            if (state.indentCount == 0) {
                state.indentCount++;
                var lastScopeOffset = state.scopes[0].offset;
                var currentOffset = lastScopeOffset + config.indentUnit;
                state.scopes.unshift({
                    offset: currentOffset
                });
            }
        };
        var dedent = function dedent(state) {
            if (state.scopes.length == 1) return;
            state.scopes.shift();
        };
        var tokenLexer = function tokenLexer(stream, state) {
            if (stream.sol()) state.indentCount = 0;
            var style = state.tokenizer(stream, state);
            var current = stream.current();
            if (current === "@return" || current === "}") {
                dedent(state);
            }
            if (style !== null) {
                var startOfToken = stream.pos - current.length;
                var withCurrentIndent = startOfToken + config.indentUnit * state.indentCount;
                var newScopes = [];
                for(var i = 0; i < state.scopes.length; i++){
                    var scope = state.scopes[i];
                    if (scope.offset <= withCurrentIndent) newScopes.push(scope);
                }
                state.scopes = newScopes;
            }
            return style;
        };
        var cssMode = CodeMirror1.mimeModes["text/css"];
        var propertyKeywords = cssMode.propertyKeywords || {}, colorKeywords = cssMode.colorKeywords || {}, valueKeywords = cssMode.valueKeywords || {}, fontProperties = cssMode.fontProperties || {};
        var keywords = [
            "true",
            "false",
            "null",
            "auto"
        ];
        var keywordsRegexp = new RegExp("^" + keywords.join("|"));
        var operators = [
            "\\(",
            "\\)",
            "=",
            ">",
            "<",
            "==",
            ">=",
            "<=",
            "\\+",
            "-",
            "\\!=",
            "/",
            "\\*",
            "%",
            "and",
            "or",
            "not",
            ";",
            "\\{",
            "\\}",
            ":"
        ];
        var opRegexp = tokenRegexp(operators);
        var pseudoElementsRegexp = /^::?[a-zA-Z_][\w\-]*/;
        var word;
        function tokenBase(stream, state) {
            var ch = stream.peek();
            // Comment
            if (stream.match("/*")) {
                state.tokenizer = comment(stream.indentation(), true);
                return state.tokenizer(stream, state);
            }
            if (stream.match("//")) {
                state.tokenizer = comment(stream.indentation(), false);
                return state.tokenizer(stream, state);
            }
            // Interpolation
            if (stream.match("#{")) {
                state.tokenizer = buildInterpolationTokenizer(tokenBase);
                return "operator";
            }
            // Strings
            if (ch === '"' || ch === "'") {
                stream.next();
                state.tokenizer = buildStringTokenizer(ch);
                return "string";
            }
            if (!state.cursorHalf) {
                // first half i.e. before : for key-value pairs
                // including selectors
                if (ch === "-") {
                    if (stream.match(/^-\w+-/)) {
                        return "meta";
                    }
                }
                if (ch === ".") {
                    stream.next();
                    if (stream.match(/^[\w-]+/)) {
                        indent(state);
                        return "qualifier";
                    } else if (stream.peek() === "#") {
                        indent(state);
                        return "tag";
                    }
                }
                if (ch === "#") {
                    stream.next();
                    // ID selectors
                    if (stream.match(/^[\w-]+/)) {
                        indent(state);
                        return "builtin";
                    }
                    if (stream.peek() === "#") {
                        indent(state);
                        return "tag";
                    }
                }
                // Variables
                if (ch === "$") {
                    stream.next();
                    stream.eatWhile(/[\w-]/);
                    return "variable-2";
                }
                // Numbers
                if (stream.match(/^-?[0-9\.]+/)) return "number";
                // Units
                if (stream.match(/^(px|em|in)\b/)) return "unit";
                if (stream.match(keywordsRegexp)) return "keyword";
                if (stream.match(/^url/) && stream.peek() === "(") {
                    state.tokenizer = urlTokens;
                    return "atom";
                }
                if (ch === "=") {
                    // Match shortcut mixin definition
                    if (stream.match(/^=[\w-]+/)) {
                        indent(state);
                        return "meta";
                    }
                }
                if (ch === "+") {
                    // Match shortcut mixin definition
                    if (stream.match(/^\+[\w-]+/)) {
                        return "variable-3";
                    }
                }
                if (ch === "@") {
                    if (stream.match("@extend")) {
                        if (!stream.match(/\s*[\w]/)) dedent(state);
                    }
                }
                // Indent Directives
                if (stream.match(/^@(else if|if|media|else|for|each|while|mixin|function)/)) {
                    indent(state);
                    return "def";
                }
                // Other Directives
                if (ch === "@") {
                    stream.next();
                    stream.eatWhile(/[\w-]/);
                    return "def";
                }
                if (stream.eatWhile(/[\w-]/)) {
                    if (stream.match(/ *: *[\w-\+\$#!\("']/, false)) {
                        word = stream.current().toLowerCase();
                        var prop = state.prevProp + "-" + word;
                        if (propertyKeywords.hasOwnProperty(prop)) {
                            return "property";
                        } else if (propertyKeywords.hasOwnProperty(word)) {
                            state.prevProp = word;
                            return "property";
                        } else if (fontProperties.hasOwnProperty(word)) {
                            return "property";
                        }
                        return "tag";
                    } else if (stream.match(/ *:/, false)) {
                        indent(state);
                        state.cursorHalf = 1;
                        state.prevProp = stream.current().toLowerCase();
                        return "property";
                    } else if (stream.match(/ *,/, false)) {
                        return "tag";
                    } else {
                        indent(state);
                        return "tag";
                    }
                }
                if (ch === ":") {
                    if (stream.match(pseudoElementsRegexp)) {
                        return "variable-3";
                    }
                    stream.next();
                    state.cursorHalf = 1;
                    return "operator";
                }
            } else {
                if (ch === "#") {
                    stream.next();
                    // Hex numbers
                    if (stream.match(/[0-9a-fA-F]{6}|[0-9a-fA-F]{3}/)) {
                        if (isEndLine(stream)) {
                            state.cursorHalf = 0;
                        }
                        return "number";
                    }
                }
                // Numbers
                if (stream.match(/^-?[0-9\.]+/)) {
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    return "number";
                }
                // Units
                if (stream.match(/^(px|em|in)\b/)) {
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    return "unit";
                }
                if (stream.match(keywordsRegexp)) {
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    return "keyword";
                }
                if (stream.match(/^url/) && stream.peek() === "(") {
                    state.tokenizer = urlTokens;
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    return "atom";
                }
                // Variables
                if (ch === "$") {
                    stream.next();
                    stream.eatWhile(/[\w-]/);
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    return "variable-2";
                }
                // bang character for !important, !default, etc.
                if (ch === "!") {
                    stream.next();
                    state.cursorHalf = 0;
                    return stream.match(/^[\w]+/) ? "keyword" : "operator";
                }
                if (stream.match(opRegexp)) {
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    return "operator";
                }
                // attributes
                if (stream.eatWhile(/[\w-]/)) {
                    if (isEndLine(stream)) {
                        state.cursorHalf = 0;
                    }
                    word = stream.current().toLowerCase();
                    if (valueKeywords.hasOwnProperty(word)) {
                        return "atom";
                    } else if (colorKeywords.hasOwnProperty(word)) {
                        return "keyword";
                    } else if (propertyKeywords.hasOwnProperty(word)) {
                        state.prevProp = stream.current().toLowerCase();
                        return "property";
                    } else {
                        return "tag";
                    }
                }
                //stream.eatSpace();
                if (isEndLine(stream)) {
                    state.cursorHalf = 0;
                    return null;
                }
            } // else ends here
            if (stream.match(opRegexp)) return "operator";
            // If we haven't returned by now, we move 1 character
            // and return an error
            stream.next();
            return null;
        }
        return {
            startState: function startState() {
                return {
                    tokenizer: tokenBase,
                    scopes: [
                        {
                            offset: 0,
                            type: "sass"
                        }
                    ],
                    indentCount: 0,
                    cursorHalf: 0,
                    // or before (0) colon (well... more or less)
                    definedVars: [],
                    definedMixins: []
                };
            },
            token: function token(stream, state) {
                var style = tokenLexer(stream, state);
                state.lastToken = {
                    style: style,
                    content: stream.current()
                };
                return style;
            },
            indent: function indent(state) {
                return state.scopes[0].offset;
            },
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            lineComment: "//",
            fold: "indent"
        };
    }, "css");
    CodeMirror1.defineMIME("text/x-sass", "sass");
});
});

var shell = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("shell", function() {
        var define1 = function define1(style, dict) {
            for(var i = 0; i < dict.length; i++){
                words[dict[i]] = style;
            }
        };
        var tokenBase = function tokenBase(stream, state) {
            if (stream.eatSpace()) return null;
            var sol = stream.sol();
            var ch = stream.next();
            if (ch === "\\") {
                stream.next();
                return null;
            }
            if (ch === "'" || ch === '"' || ch === "`") {
                state.tokens.unshift(tokenString(ch, ch === "`" ? "quote" : "string"));
                return tokenize(stream, state);
            }
            if (ch === "#") {
                if (sol && stream.eat("!")) {
                    stream.skipToEnd();
                    return "meta"; // 'comment'?
                }
                stream.skipToEnd();
                return "comment";
            }
            if (ch === "$") {
                state.tokens.unshift(tokenDollar);
                return tokenize(stream, state);
            }
            if (ch === "+" || ch === "=") {
                return "operator";
            }
            if (ch === "-") {
                stream.eat("-");
                stream.eatWhile(/\w/);
                return "attribute";
            }
            if (ch == "<") {
                if (stream.match("<<")) return "operator";
                var heredoc = stream.match(/^<-?\s*['"]?([^'"]*)['"]?/);
                if (heredoc) {
                    state.tokens.unshift(tokenHeredoc(heredoc[1]));
                    return "string-2";
                }
            }
            if (/\d/.test(ch)) {
                stream.eatWhile(/\d/);
                if (stream.eol() || !/\w/.test(stream.peek())) {
                    return "number";
                }
            }
            stream.eatWhile(/[\w-]/);
            var cur = stream.current();
            if (stream.peek() === "=" && /\w+/.test(cur)) return "def";
            return words.hasOwnProperty(cur) ? words[cur] : null;
        };
        var tokenStringStart = function tokenStringStart(quote, style) {
            return function(stream, state) {
                state.tokens[0] = tokenString(quote, style);
                stream.next();
                return tokenize(stream, state);
            };
        };
        var tokenHeredoc = function tokenHeredoc(delim) {
            return function(stream, state) {
                if (stream.sol() && stream.string == delim) state.tokens.shift();
                stream.skipToEnd();
                return "string-2";
            };
        };
        var tokenize = function tokenize(stream, state) {
            return (state.tokens[0] || tokenBase)(stream, state);
        };
        var words = {};
        var commonAtoms = [
            "true",
            "false"
        ];
        var commonKeywords = [
            "if",
            "then",
            "do",
            "else",
            "elif",
            "while",
            "until",
            "for",
            "in",
            "esac",
            "fi",
            "fin",
            "fil",
            "done",
            "exit",
            "set",
            "unset",
            "export",
            "function"
        ];
        var commonCommands = [
            "ab",
            "awk",
            "bash",
            "beep",
            "cat",
            "cc",
            "cd",
            "chown",
            "chmod",
            "chroot",
            "clear",
            "cp",
            "curl",
            "cut",
            "diff",
            "echo",
            "find",
            "gawk",
            "gcc",
            "get",
            "git",
            "grep",
            "hg",
            "kill",
            "killall",
            "ln",
            "ls",
            "make",
            "mkdir",
            "openssl",
            "mv",
            "nc",
            "nl",
            "node",
            "npm",
            "ping",
            "ps",
            "restart",
            "rm",
            "rmdir",
            "sed",
            "service",
            "sh",
            "shopt",
            "shred",
            "source",
            "sort",
            "sleep",
            "ssh",
            "start",
            "stop",
            "su",
            "sudo",
            "svn",
            "tee",
            "telnet",
            "top",
            "touch",
            "vi",
            "vim",
            "wall",
            "wc",
            "wget",
            "who",
            "write",
            "yes",
            "zsh"
        ];
        CodeMirror1.registerHelper("hintWords", "shell", commonAtoms.concat(commonKeywords, commonCommands));
        define1("atom", commonAtoms);
        define1("keyword", commonKeywords);
        define1("builtin", commonCommands);
        function tokenString(quote, style) {
            var close = quote == "(" ? ")" : quote == "{" ? "}" : quote;
            return function(stream, state) {
                var next, escaped = false;
                while((next = stream.next()) != null){
                    if (next === close && !escaped) {
                        state.tokens.shift();
                        break;
                    } else if (next === "$" && !escaped && quote !== "'" && stream.peek() != close) {
                        escaped = true;
                        stream.backUp(1);
                        state.tokens.unshift(tokenDollar);
                        break;
                    } else if (!escaped && quote !== close && next === quote) {
                        state.tokens.unshift(tokenString(quote, style));
                        return tokenize(stream, state);
                    } else if (!escaped && /['"]/.test(next) && !/['"]/.test(quote)) {
                        state.tokens.unshift(tokenStringStart(next, "string"));
                        stream.backUp(1);
                        break;
                    }
                    escaped = !escaped && next === "\\";
                }
                return style;
            };
        }
        var tokenDollar = function tokenDollar(stream, state) {
            if (state.tokens.length > 1) stream.eat("$");
            var ch = stream.next();
            if (/['"({]/.test(ch)) {
                state.tokens[0] = tokenString(ch, ch == "(" ? "quote" : ch == "{" ? "def" : "string");
                return tokenize(stream, state);
            }
            if (!/\d/.test(ch)) stream.eatWhile(/\w/);
            state.tokens.shift();
            return "def";
        };
        return {
            startState: function startState() {
                return {
                    tokens: []
                };
            },
            token: function token(stream, state) {
                return tokenize(stream, state);
            },
            closeBrackets: "()[]{}''\"\"``",
            lineComment: "#",
            fold: "brace"
        };
    });
    CodeMirror1.defineMIME("text/x-sh", "shell");
    // Apache uses a slightly different Media Type for Shell scripts
    // http://svn.apache.org/repos/asf/httpd/httpd/trunk/docs/conf/mime.types
    CodeMirror1.defineMIME("application/x-sh", "shell");
});
});

var sql = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var hookIdentifier = // `identifier`
    function hookIdentifier(stream) {
        // MySQL/MariaDB identifiers
        // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
        var ch;
        while((ch = stream.next()) != null){
            if (ch == "`" && !stream.eat("`")) return "variable-2";
        }
        stream.backUp(stream.current().length - 1);
        return stream.eatWhile(/\w/) ? "variable-2" : null;
    };
    var hookIdentifierDoublequote = // "identifier"
    function hookIdentifierDoublequote(stream) {
        // Standard SQL /SQLite identifiers
        // ref: http://web.archive.org/web/20160813185132/http://savage.net.au/SQL/sql-99.bnf.html#delimited%20identifier
        // ref: http://sqlite.org/lang_keywords.html
        var ch;
        while((ch = stream.next()) != null){
            if (ch == '"' && !stream.eat('"')) return "variable-2";
        }
        stream.backUp(stream.current().length - 1);
        return stream.eatWhile(/\w/) ? "variable-2" : null;
    };
    var hookVar = // variable token
    function hookVar(stream) {
        // variables
        // @@prefix.varName @varName
        // varName can be quoted with ` or ' or "
        // ref: http://dev.mysql.com/doc/refman/5.5/en/user-variables.html
        if (stream.eat("@")) {
            stream.match("session.");
            stream.match("local.");
            stream.match("global.");
        }
        if (stream.eat("'")) {
            stream.match(/^.*'/);
            return "variable-2";
        } else if (stream.eat('"')) {
            stream.match(/^.*"/);
            return "variable-2";
        } else if (stream.eat("`")) {
            stream.match(/^.*`/);
            return "variable-2";
        } else if (stream.match(/^[0-9a-zA-Z$\.\_]+/)) {
            return "variable-2";
        }
        return null;
    };
    var hookClient = // short client keyword token
    function hookClient(stream) {
        // \N means NULL
        // ref: http://dev.mysql.com/doc/refman/5.5/en/null-values.html
        if (stream.eat("N")) {
            return "atom";
        }
        // \g, etc
        // ref: http://dev.mysql.com/doc/refman/5.5/en/mysql-commands.html
        return stream.match(/^[a-zA-Z.#!?]/) ? "variable-2" : null;
    };
    var set = // turn a space-separated list into an array
    function set(str) {
        var obj = {}, words = str.split(" ");
        for(var i = 0; i < words.length; ++i)obj[words[i]] = true;
        return obj;
    };
    CodeMirror1.defineMode("sql", function(config, parserConfig) {
        var tokenBase = function tokenBase(stream, state) {
            var ch = stream.next();
            // call hooks from the mime type
            if (hooks[ch]) {
                var result = hooks[ch](stream, state);
                if (result !== false) return result;
            }
            if (support.hexNumber && (ch == "0" && stream.match(/^[xX][0-9a-fA-F]+/) || (ch == "x" || ch == "X") && stream.match(/^'[0-9a-fA-F]+'/))) {
                // hex
                // ref: http://dev.mysql.com/doc/refman/5.5/en/hexadecimal-literals.html
                return "number";
            } else if (support.binaryNumber && ((ch == "b" || ch == "B") && stream.match(/^'[01]+'/) || ch == "0" && stream.match(/^b[01]+/))) {
                // bitstring
                // ref: http://dev.mysql.com/doc/refman/5.5/en/bit-field-literals.html
                return "number";
            } else if (ch.charCodeAt(0) > 47 && ch.charCodeAt(0) < 58) {
                // numbers
                // ref: http://dev.mysql.com/doc/refman/5.5/en/number-literals.html
                stream.match(/^[0-9]*(\.[0-9]+)?([eE][-+]?[0-9]+)?/);
                support.decimallessFloat && stream.match(/^\.(?!\.)/);
                return "number";
            } else if (ch == "?" && (stream.eatSpace() || stream.eol() || stream.eat(";"))) {
                // placeholders
                return "variable-3";
            } else if (ch == "'" || ch == '"' && support.doubleQuote) {
                // strings
                // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
                state.tokenize = tokenLiteral(ch);
                return state.tokenize(stream, state);
            } else if ((support.nCharCast && (ch == "n" || ch == "N") || support.charsetCast && ch == "_" && stream.match(/[a-z][a-z0-9]*/i)) && (stream.peek() == "'" || stream.peek() == '"')) {
                // charset casting: _utf8'str', N'str', n'str'
                // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
                return "keyword";
            } else if (support.escapeConstant && (ch == "e" || ch == "E") && (stream.peek() == "'" || stream.peek() == '"' && support.doubleQuote)) {
                // escape constant: E'str', e'str'
                // ref: https://www.postgresql.org/docs/current/sql-syntax-lexical.html#SQL-SYNTAX-STRINGS-ESCAPE
                state.tokenize = function(stream, state) {
                    return (state.tokenize = tokenLiteral(stream.next(), true))(stream, state);
                };
                return "keyword";
            } else if (support.commentSlashSlash && ch == "/" && stream.eat("/")) {
                // 1-line comment
                stream.skipToEnd();
                return "comment";
            } else if (support.commentHash && ch == "#" || ch == "-" && stream.eat("-") && (!support.commentSpaceRequired || stream.eat(" "))) {
                // 1-line comments
                // ref: https://kb.askmonty.org/en/comment-syntax/
                stream.skipToEnd();
                return "comment";
            } else if (ch == "/" && stream.eat("*")) {
                // multi-line comments
                // ref: https://kb.askmonty.org/en/comment-syntax/
                state.tokenize = tokenComment(1);
                return state.tokenize(stream, state);
            } else if (ch == ".") {
                // .1 for 0.1
                if (support.zerolessFloat && stream.match(/^(?:\d+(?:e[+-]?\d+)?)/i)) return "number";
                if (stream.match(/^\.+/)) return null;
                // .table_name (ODBC)
                // // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
                if (support.ODBCdotTable && stream.match(/^[\w\d_$#]+/)) return "variable-2";
            } else if (operatorChars.test(ch)) {
                // operators
                stream.eatWhile(operatorChars);
                return "operator";
            } else if (brackets.test(ch)) {
                // brackets
                return "bracket";
            } else if (punctuation.test(ch)) {
                // punctuation
                stream.eatWhile(punctuation);
                return "punctuation";
            } else if (ch == "{" && (stream.match(/^( )*(d|D|t|T|ts|TS)( )*'[^']*'( )*}/) || stream.match(/^( )*(d|D|t|T|ts|TS)( )*"[^"]*"( )*}/))) {
                // dates (weird ODBC syntax)
                // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
                return "number";
            } else {
                stream.eatWhile(/^[_\w\d]/);
                var word = stream.current().toLowerCase();
                // dates (standard SQL syntax)
                // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
                if (dateSQL.hasOwnProperty(word) && (stream.match(/^( )+'[^']*'/) || stream.match(/^( )+"[^"]*"/))) return "number";
                if (atoms.hasOwnProperty(word)) return "atom";
                if (builtin.hasOwnProperty(word)) return "builtin";
                if (keywords.hasOwnProperty(word)) return "keyword";
                if (client.hasOwnProperty(word)) return "string-2";
                return null;
            }
        };
        var tokenLiteral = // 'string', with char specified in quote escaped by '\'
        function tokenLiteral(quote, backslashEscapes) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) {
                        state.tokenize = tokenBase;
                        break;
                    }
                    escaped = (backslashStringEscapes || backslashEscapes) && !escaped && ch == "\\";
                }
                return "string";
            };
        };
        var pushContext = function pushContext(stream, state, type) {
            state.context = {
                prev: state.context,
                indent: stream.indentation(),
                col: stream.column(),
                type: type
            };
        };
        var popContext = function popContext(state) {
            state.indent = state.context.indent;
            state.context = state.context.prev;
        };
        var client = parserConfig.client || {}, atoms = parserConfig.atoms || {
            "false": true,
            "true": true,
            "null": true
        }, builtin = parserConfig.builtin || set(defaultBuiltin), keywords = parserConfig.keywords || set(sqlKeywords), operatorChars = parserConfig.operatorChars || /^[*+\-%<>!=&|~^\/]/, support = parserConfig.support || {}, hooks = parserConfig.hooks || {}, dateSQL = parserConfig.dateSQL || {
            "date": true,
            "time": true,
            "timestamp": true
        }, backslashStringEscapes = parserConfig.backslashStringEscapes !== false, brackets = parserConfig.brackets || /^[\{}\(\)\[\]]/, punctuation = parserConfig.punctuation || /^[;.,:]/;
        function tokenComment(depth) {
            return function(stream, state) {
                var m = stream.match(/^.*?(\/\*|\*\/)/);
                if (!m) stream.skipToEnd();
                else if (m[1] == "/*") state.tokenize = tokenComment(depth + 1);
                else if (depth > 1) state.tokenize = tokenComment(depth - 1);
                else state.tokenize = tokenBase;
                return "comment";
            };
        }
        return {
            startState: function startState() {
                return {
                    tokenize: tokenBase,
                    context: null
                };
            },
            token: function token(stream, state) {
                if (stream.sol()) {
                    if (state.context && state.context.align == null) state.context.align = false;
                }
                if (state.tokenize == tokenBase && stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (style == "comment") return style;
                if (state.context && state.context.align == null) state.context.align = true;
                var tok = stream.current();
                if (tok == "(") pushContext(stream, state, ")");
                else if (tok == "[") pushContext(stream, state, "]");
                else if (state.context && state.context.type == tok) popContext(state);
                return style;
            },
            indent: function indent(state, textAfter) {
                var cx = state.context;
                if (!cx) return CodeMirror1.Pass;
                var closing = textAfter.charAt(0) == cx.type;
                if (cx.align) return cx.col + (closing ? 0 : 1);
                else return cx.indent + (closing ? 0 : config.indentUnit);
            },
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            lineComment: support.commentSlashSlash ? "//" : support.commentHash ? "#" : "--",
            closeBrackets: "()[]{}''\"\"``"
        };
    });
    // these keywords are used by all SQL dialects (however, a mode can still overwrite it)
    var sqlKeywords = "alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit ";
    var defaultBuiltin = "bool boolean bit blob enum long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision real date datetime year unsigned signed decimal numeric";
    // A generic SQL Mode. It's not a standard, it just try to support what is generally supported
    CodeMirror1.defineMIME("text/x-sql", {
        name: "sql",
        keywords: set(sqlKeywords + "begin"),
        builtin: set(defaultBuiltin),
        atoms: set("false true null unknown"),
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
    });
    CodeMirror1.defineMIME("text/x-mssql", {
        name: "sql",
        client: set("$partition binary_checksum checksum connectionproperty context_info current_request_id error_line error_message error_number error_procedure error_severity error_state formatmessage get_filestream_transaction_context getansinull host_id host_name isnull isnumeric min_active_rowversion newid newsequentialid rowcount_big xact_state object_id"),
        keywords: set(sqlKeywords + "begin trigger proc view index for add constraint key primary foreign collate clustered nonclustered declare exec go if use index holdlock nolock nowait paglock readcommitted readcommittedlock readpast readuncommitted repeatableread rowlock serializable snapshot tablock tablockx updlock with"),
        builtin: set("bigint numeric bit smallint decimal smallmoney int tinyint money float real char varchar text nchar nvarchar ntext binary varbinary image cursor timestamp hierarchyid uniqueidentifier sql_variant xml table "),
        atoms: set("is not null like and or in left right between inner outer join all any some cross unpivot pivot exists"),
        operatorChars: /^[*+\-%<>!=^\&|\/]/,
        brackets: /^[\{}\(\)]/,
        punctuation: /^[;.,:/]/,
        backslashStringEscapes: false,
        dateSQL: set("date datetimeoffset datetime2 smalldatetime datetime time"),
        hooks: {
            "@": hookVar
        }
    });
    CodeMirror1.defineMIME("text/x-mysql", {
        name: "sql",
        client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
        keywords: set(sqlKeywords + "accessible action add after algorithm all analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general get global grant grants group group_concat handler hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show signal slave slow smallint snapshot soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
        builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=&|^]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
        hooks: {
            "@": hookVar,
            "`": hookIdentifier,
            "\\": hookClient
        }
    });
    CodeMirror1.defineMIME("text/x-mariadb", {
        name: "sql",
        client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
        keywords: set(sqlKeywords + "accessible action add after algorithm all always analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general generated get global grant grants group group_concat handler hard hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password persistent phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show shutdown signal slave slow smallint snapshot soft soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views virtual warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
        builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=&|^]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
        hooks: {
            "@": hookVar,
            "`": hookIdentifier,
            "\\": hookClient
        }
    });
    // provided by the phpLiteAdmin project - phpliteadmin.org
    CodeMirror1.defineMIME("text/x-sqlite", {
        name: "sql",
        // commands of the official SQLite client, ref: https://www.sqlite.org/cli.html#dotcmd
        client: set("auth backup bail binary changes check clone databases dbinfo dump echo eqp exit explain fullschema headers help import imposter indexes iotrace limit lint load log mode nullvalue once open output print prompt quit read restore save scanstats schema separator session shell show stats system tables testcase timeout timer trace vfsinfo vfslist vfsname width"),
        // ref: http://sqlite.org/lang_keywords.html
        keywords: set(sqlKeywords + "abort action add after all analyze attach autoincrement before begin cascade case cast check collate column commit conflict constraint cross current_date current_time current_timestamp database default deferrable deferred detach each else end escape except exclusive exists explain fail for foreign full glob if ignore immediate index indexed initially inner instead intersect isnull key left limit match natural no notnull null of offset outer plan pragma primary query raise recursive references regexp reindex release rename replace restrict right rollback row savepoint temp temporary then to transaction trigger unique using vacuum view virtual when with without"),
        // SQLite is weakly typed, ref: http://sqlite.org/datatype3.html. This is just a list of some common types.
        builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text clob bigint int int2 int8 integer float double char varchar date datetime year unsigned signed numeric real"),
        // ref: http://sqlite.org/syntax/literal-value.html
        atoms: set("null current_date current_time current_timestamp"),
        // ref: http://sqlite.org/lang_expr.html#binaryops
        operatorChars: /^[*+\-%<>!=&|/~]/,
        // SQLite is weakly typed, ref: http://sqlite.org/datatype3.html. This is just a list of some common types.
        dateSQL: set("date time timestamp datetime"),
        support: set("decimallessFloat zerolessFloat"),
        identifierQuote: '"',
        hooks: {
            // bind-parameters ref:http://sqlite.org/lang_expr.html#varparam
            "@": hookVar,
            ":": hookVar,
            "?": hookVar,
            "$": hookVar,
            // The preferred way to escape Identifiers is using double quotes, ref: http://sqlite.org/lang_keywords.html
            '"': hookIdentifierDoublequote,
            // there is also support for backticks, ref: http://sqlite.org/lang_keywords.html
            "`": hookIdentifier
        }
    });
    // the query language used by Apache Cassandra is called CQL, but this mime type
    // is called Cassandra to avoid confusion with Contextual Query Language
    CodeMirror1.defineMIME("text/x-cassandra", {
        name: "sql",
        client: {},
        keywords: set("add all allow alter and any apply as asc authorize batch begin by clustering columnfamily compact consistency count create custom delete desc distinct drop each_quorum exists filtering from grant if in index insert into key keyspace keyspaces level limit local_one local_quorum modify nan norecursive nosuperuser not of on one order password permission permissions primary quorum rename revoke schema select set storage superuser table three to token truncate ttl two type unlogged update use user users using values where with writetime"),
        builtin: set("ascii bigint blob boolean counter decimal double float frozen inet int list map static text timestamp timeuuid tuple uuid varchar varint"),
        atoms: set("false true infinity NaN"),
        operatorChars: /^[<>=]/,
        dateSQL: {},
        support: set("commentSlashSlash decimallessFloat"),
        hooks: {}
    });
    // this is based on Peter Raganitsch's 'plsql' mode
    CodeMirror1.defineMIME("text/x-plsql", {
        name: "sql",
        client: set("appinfo arraysize autocommit autoprint autorecovery autotrace blockterminator break btitle cmdsep colsep compatibility compute concat copycommit copytypecheck define describe echo editfile embedded escape exec execute feedback flagger flush heading headsep instance linesize lno loboffset logsource long longchunksize markup native newpage numformat numwidth pagesize pause pno recsep recsepchar release repfooter repheader serveroutput shiftinout show showmode size spool sqlblanklines sqlcase sqlcode sqlcontinue sqlnumber sqlpluscompatibility sqlprefix sqlprompt sqlterminator suffix tab term termout time timing trimout trimspool ttitle underline verify version wrap"),
        keywords: set("abort accept access add all alter and any array arraylen as asc assert assign at attributes audit authorization avg base_table begin between binary_integer body boolean by case cast char char_base check close cluster clusters colauth column comment commit compress connect connected constant constraint crash create current currval cursor data_base database date dba deallocate debugoff debugon decimal declare default definition delay delete desc digits dispose distinct do drop else elseif elsif enable end entry escape exception exception_init exchange exclusive exists exit external fast fetch file for force form from function generic goto grant group having identified if immediate in increment index indexes indicator initial initrans insert interface intersect into is key level library like limited local lock log logging long loop master maxextents maxtrans member minextents minus mislabel mode modify multiset new next no noaudit nocompress nologging noparallel not nowait number_base object of off offline on online only open option or order out package parallel partition pctfree pctincrease pctused pls_integer positive positiven pragma primary prior private privileges procedure public raise range raw read rebuild record ref references refresh release rename replace resource restrict return returning returns reverse revoke rollback row rowid rowlabel rownum rows run savepoint schema segment select separate session set share snapshot some space split sql start statement storage subtype successful synonym tabauth table tables tablespace task terminate then to trigger truncate type union unique unlimited unrecoverable unusable update use using validate value values variable view views when whenever where while with work"),
        builtin: set("abs acos add_months ascii asin atan atan2 average bfile bfilename bigserial bit blob ceil character chartorowid chr clob concat convert cos cosh count dec decode deref dual dump dup_val_on_index empty error exp false float floor found glb greatest hextoraw initcap instr instrb int integer isopen last_day least length lengthb ln lower lpad ltrim lub make_ref max min mlslabel mod months_between natural naturaln nchar nclob new_time next_day nextval nls_charset_decl_len nls_charset_id nls_charset_name nls_initcap nls_lower nls_sort nls_upper nlssort no_data_found notfound null number numeric nvarchar2 nvl others power rawtohex real reftohex round rowcount rowidtochar rowtype rpad rtrim serial sign signtype sin sinh smallint soundex sqlcode sqlerrm sqrt stddev string substr substrb sum sysdate tan tanh to_char text to_date to_label to_multi_byte to_number to_single_byte translate true trunc uid unlogged upper user userenv varchar varchar2 variance varying vsize xml"),
        operatorChars: /^[*\/+\-%<>!=~]/,
        dateSQL: set("date time timestamp"),
        support: set("doubleQuote nCharCast zerolessFloat binaryNumber hexNumber")
    });
    // Created to support specific hive keywords
    CodeMirror1.defineMIME("text/x-hive", {
        name: "sql",
        keywords: set("select alter $elem$ $key$ $value$ add after all analyze and archive as asc before between binary both bucket buckets by cascade case cast change cluster clustered clusterstatus collection column columns comment compute concatenate continue create cross cursor data database databases dbproperties deferred delete delimited desc describe directory disable distinct distribute drop else enable end escaped exclusive exists explain export extended external fetch fields fileformat first format formatted from full function functions grant group having hold_ddltime idxproperties if import in index indexes inpath inputdriver inputformat insert intersect into is items join keys lateral left like limit lines load local location lock locks mapjoin materialized minus msck no_drop nocompress not of offline on option or order out outer outputdriver outputformat overwrite partition partitioned partitions percent plus preserve procedure purge range rcfile read readonly reads rebuild recordreader recordwriter recover reduce regexp rename repair replace restrict revoke right rlike row schema schemas semi sequencefile serde serdeproperties set shared show show_database sort sorted ssl statistics stored streamtable table tables tablesample tblproperties temporary terminated textfile then tmp to touch transform trigger unarchive undo union uniquejoin unlock update use using utc utc_tmestamp view when where while with admin authorization char compact compactions conf cube current current_date current_timestamp day decimal defined dependency directories elem_type exchange file following for grouping hour ignore inner interval jar less logical macro minute month more none noscan over owner partialscan preceding pretty principals protection reload rewrite role roles rollup rows second server sets skewed transactions truncate unbounded unset uri user values window year"),
        builtin: set("bool boolean long timestamp tinyint smallint bigint int float double date datetime unsigned string array struct map uniontype key_type utctimestamp value_type varchar"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=]/,
        dateSQL: set("date timestamp"),
        support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
    });
    CodeMirror1.defineMIME("text/x-pgsql", {
        name: "sql",
        client: set("source"),
        // For PostgreSQL - https://www.postgresql.org/docs/11/sql-keywords-appendix.html
        // For pl/pgsql lang - https://github.com/postgres/postgres/blob/REL_11_2/src/pl/plpgsql/src/pl_scanner.c
        keywords: set(sqlKeywords + "a abort abs absent absolute access according action ada add admin after aggregate alias all allocate also alter always analyse analyze and any are array array_agg array_max_cardinality as asc asensitive assert assertion assignment asymmetric at atomic attach attribute attributes authorization avg backward base64 before begin begin_frame begin_partition bernoulli between bigint binary bit bit_length blob blocked bom boolean both breadth by c cache call called cardinality cascade cascaded case cast catalog catalog_name ceil ceiling chain char char_length character character_length character_set_catalog character_set_name character_set_schema characteristics characters check checkpoint class class_origin clob close cluster coalesce cobol collate collation collation_catalog collation_name collation_schema collect column column_name columns command_function command_function_code comment comments commit committed concurrently condition condition_number configuration conflict connect connection connection_name constant constraint constraint_catalog constraint_name constraint_schema constraints constructor contains content continue control conversion convert copy corr corresponding cost count covar_pop covar_samp create cross csv cube cume_dist current current_catalog current_date current_default_transform_group current_path current_role current_row current_schema current_time current_timestamp current_transform_group_for_type current_user cursor cursor_name cycle data database datalink datatype date datetime_interval_code datetime_interval_precision day db deallocate debug dec decimal declare default defaults deferrable deferred defined definer degree delete delimiter delimiters dense_rank depends depth deref derived desc describe descriptor detach detail deterministic diagnostics dictionary disable discard disconnect dispatch distinct dlnewcopy dlpreviouscopy dlurlcomplete dlurlcompleteonly dlurlcompletewrite dlurlpath dlurlpathonly dlurlpathwrite dlurlscheme dlurlserver dlvalue do document domain double drop dump dynamic dynamic_function dynamic_function_code each element else elseif elsif empty enable encoding encrypted end end_frame end_partition endexec enforced enum equals errcode error escape event every except exception exclude excluding exclusive exec execute exists exit exp explain expression extension external extract false family fetch file filter final first first_value flag float floor following for force foreach foreign fortran forward found frame_row free freeze from fs full function functions fusion g general generated get global go goto grant granted greatest group grouping groups handler having header hex hierarchy hint hold hour id identity if ignore ilike immediate immediately immutable implementation implicit import in include including increment indent index indexes indicator info inherit inherits initially inline inner inout input insensitive insert instance instantiable instead int integer integrity intersect intersection interval into invoker is isnull isolation join k key key_member key_type label lag language large last last_value lateral lead leading leakproof least left length level library like like_regex limit link listen ln load local localtime localtimestamp location locator lock locked log logged loop lower m map mapping match matched materialized max max_cardinality maxvalue member merge message message_length message_octet_length message_text method min minute minvalue mod mode modifies module month more move multiset mumps name names namespace national natural nchar nclob nesting new next nfc nfd nfkc nfkd nil no none normalize normalized not nothing notice notify notnull nowait nth_value ntile null nullable nullif nulls number numeric object occurrences_regex octet_length octets of off offset oids old on only open operator option options or order ordering ordinality others out outer output over overlaps overlay overriding owned owner p pad parallel parameter parameter_mode parameter_name parameter_ordinal_position parameter_specific_catalog parameter_specific_name parameter_specific_schema parser partial partition pascal passing passthrough password path percent percent_rank percentile_cont percentile_disc perform period permission pg_context pg_datatype_name pg_exception_context pg_exception_detail pg_exception_hint placing plans pli policy portion position position_regex power precedes preceding precision prepare prepared preserve primary print_strict_params prior privileges procedural procedure procedures program public publication query quote raise range rank read reads real reassign recheck recovery recursive ref references referencing refresh regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy regr_syy reindex relative release rename repeatable replace replica requiring reset respect restart restore restrict result result_oid return returned_cardinality returned_length returned_octet_length returned_sqlstate returning returns reverse revoke right role rollback rollup routine routine_catalog routine_name routine_schema routines row row_count row_number rows rowtype rule savepoint scale schema schema_name schemas scope scope_catalog scope_name scope_schema scroll search second section security select selective self sensitive sequence sequences serializable server server_name session session_user set setof sets share show similar simple size skip slice smallint snapshot some source space specific specific_name specifictype sql sqlcode sqlerror sqlexception sqlstate sqlwarning sqrt stable stacked standalone start state statement static statistics stddev_pop stddev_samp stdin stdout storage strict strip structure style subclass_origin submultiset subscription substring substring_regex succeeds sum symmetric sysid system system_time system_user t table table_name tables tablesample tablespace temp template temporary text then ties time timestamp timezone_hour timezone_minute to token top_level_count trailing transaction transaction_active transactions_committed transactions_rolled_back transform transforms translate translate_regex translation treat trigger trigger_catalog trigger_name trigger_schema trim trim_array true truncate trusted type types uescape unbounded uncommitted under unencrypted union unique unknown unlink unlisten unlogged unnamed unnest until untyped update upper uri usage use_column use_variable user user_defined_type_catalog user_defined_type_code user_defined_type_name user_defined_type_schema using vacuum valid validate validator value value_of values var_pop var_samp varbinary varchar variable_conflict variadic varying verbose version versioning view views volatile warning when whenever where while whitespace width_bucket window with within without work wrapper write xml xmlagg xmlattributes xmlbinary xmlcast xmlcomment xmlconcat xmldeclaration xmldocument xmlelement xmlexists xmlforest xmliterate xmlnamespaces xmlparse xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltext xmlvalidate year yes zone"),
        // https://www.postgresql.org/docs/11/datatype.html
        builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*\/+\-%<>!=&|^\/#@?~]/,
        backslashStringEscapes: false,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast escapeConstant")
    });
    // Google's SQL-like query language, GQL
    CodeMirror1.defineMIME("text/x-gql", {
        name: "sql",
        keywords: set("ancestor and asc by contains desc descendant distinct from group has in is limit offset on order select superset where"),
        atoms: set("false true"),
        builtin: set("blob datetime first key __key__ string integer double boolean null"),
        operatorChars: /^[*+\-%<>!=]/
    });
    // Greenplum
    CodeMirror1.defineMIME("text/x-gpsql", {
        name: "sql",
        client: set("source"),
        //https://github.com/greenplum-db/gpdb/blob/master/src/include/parser/kwlist.h
        keywords: set("abort absolute access action active add admin after aggregate all also alter always analyse analyze and any array as asc assertion assignment asymmetric at authorization backward before begin between bigint binary bit boolean both by cache called cascade cascaded case cast chain char character characteristics check checkpoint class close cluster coalesce codegen collate column comment commit committed concurrency concurrently configuration connection constraint constraints contains content continue conversion copy cost cpu_rate_limit create createdb createexttable createrole createuser cross csv cube current current_catalog current_date current_role current_schema current_time current_timestamp current_user cursor cycle data database day deallocate dec decimal declare decode default defaults deferrable deferred definer delete delimiter delimiters deny desc dictionary disable discard distinct distributed do document domain double drop dxl each else enable encoding encrypted end enum errors escape every except exchange exclude excluding exclusive execute exists explain extension external extract false family fetch fields filespace fill filter first float following for force foreign format forward freeze from full function global grant granted greatest group group_id grouping handler hash having header hold host hour identity if ignore ilike immediate immutable implicit in including inclusive increment index indexes inherit inherits initially inline inner inout input insensitive insert instead int integer intersect interval into invoker is isnull isolation join key language large last leading least left level like limit list listen load local localtime localtimestamp location lock log login mapping master match maxvalue median merge minute minvalue missing mode modifies modify month move name names national natural nchar new newline next no nocreatedb nocreateexttable nocreaterole nocreateuser noinherit nologin none noovercommit nosuperuser not nothing notify notnull nowait null nullif nulls numeric object of off offset oids old on only operator option options or order ordered others out outer over overcommit overlaps overlay owned owner parser partial partition partitions passing password percent percentile_cont percentile_disc placing plans position preceding precision prepare prepared preserve primary prior privileges procedural procedure protocol queue quote randomly range read readable reads real reassign recheck recursive ref references reindex reject relative release rename repeatable replace replica reset resource restart restrict returning returns revoke right role rollback rollup rootpartition row rows rule savepoint scatter schema scroll search second security segment select sequence serializable session session_user set setof sets share show similar simple smallint some split sql stable standalone start statement statistics stdin stdout storage strict strip subpartition subpartitions substring superuser symmetric sysid system table tablespace temp template temporary text then threshold ties time timestamp to trailing transaction treat trigger trim true truncate trusted type unbounded uncommitted unencrypted union unique unknown unlisten until update user using vacuum valid validation validator value values varchar variadic varying verbose version view volatile web when where whitespace window with within without work writable write xml xmlattributes xmlconcat xmlelement xmlexists xmlforest xmlparse xmlpi xmlroot xmlserialize year yes zone"),
        builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
        atoms: set("false true null unknown"),
        operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast")
    });
    // Spark SQL
    CodeMirror1.defineMIME("text/x-sparksql", {
        name: "sql",
        keywords: set("add after all alter analyze and anti archive array as asc at between bucket buckets by cache cascade case cast change clear cluster clustered codegen collection column columns comment commit compact compactions compute concatenate cost create cross cube current current_date current_timestamp database databases data dbproperties defined delete delimited deny desc describe dfs directories distinct distribute drop else end escaped except exchange exists explain export extended external false fields fileformat first following for format formatted from full function functions global grant group grouping having if ignore import in index indexes inner inpath inputformat insert intersect interval into is items join keys last lateral lazy left like limit lines list load local location lock locks logical macro map minus msck natural no not null nulls of on optimize option options or order out outer outputformat over overwrite partition partitioned partitions percent preceding principals purge range recordreader recordwriter recover reduce refresh regexp rename repair replace reset restrict revoke right rlike role roles rollback rollup row rows schema schemas select semi separated serde serdeproperties set sets show skewed sort sorted start statistics stored stratify struct table tables tablesample tblproperties temp temporary terminated then to touch transaction transactions transform true truncate unarchive unbounded uncache union unlock unset use using values view when where window with"),
        builtin: set("abs acos acosh add_months aggregate and any approx_count_distinct approx_percentile array array_contains array_distinct array_except array_intersect array_join array_max array_min array_position array_remove array_repeat array_sort array_union arrays_overlap arrays_zip ascii asin asinh assert_true atan atan2 atanh avg base64 between bigint bin binary bit_and bit_count bit_get bit_length bit_or bit_xor bool_and bool_or boolean bround btrim cardinality case cast cbrt ceil ceiling char char_length character_length chr coalesce collect_list collect_set concat concat_ws conv corr cos cosh cot count count_if count_min_sketch covar_pop covar_samp crc32 cume_dist current_catalog current_database current_date current_timestamp current_timezone current_user date date_add date_format date_from_unix_date date_part date_sub date_trunc datediff day dayofmonth dayofweek dayofyear decimal decode degrees delimited dense_rank div double e element_at elt encode every exists exp explode explode_outer expm1 extract factorial filter find_in_set first first_value flatten float floor forall format_number format_string from_csv from_json from_unixtime from_utc_timestamp get_json_object getbit greatest grouping grouping_id hash hex hour hypot if ifnull in initcap inline inline_outer input_file_block_length input_file_block_start input_file_name inputformat instr int isnan isnotnull isnull java_method json_array_length json_object_keys json_tuple kurtosis lag last last_day last_value lcase lead least left length levenshtein like ln locate log log10 log1p log2 lower lpad ltrim make_date make_dt_interval make_interval make_timestamp make_ym_interval map map_concat map_entries map_filter map_from_arrays map_from_entries map_keys map_values map_zip_with max max_by md5 mean min min_by minute mod monotonically_increasing_id month months_between named_struct nanvl negative next_day not now nth_value ntile nullif nvl nvl2 octet_length or outputformat overlay parse_url percent_rank percentile percentile_approx pi pmod posexplode posexplode_outer position positive pow power printf quarter radians raise_error rand randn random rank rcfile reflect regexp regexp_extract regexp_extract_all regexp_like regexp_replace repeat replace reverse right rint rlike round row_number rpad rtrim schema_of_csv schema_of_json second sentences sequence sequencefile serde session_window sha sha1 sha2 shiftleft shiftright shiftrightunsigned shuffle sign signum sin sinh size skewness slice smallint some sort_array soundex space spark_partition_id split sqrt stack std stddev stddev_pop stddev_samp str_to_map string struct substr substring substring_index sum tan tanh textfile timestamp timestamp_micros timestamp_millis timestamp_seconds tinyint to_csv to_date to_json to_timestamp to_unix_timestamp to_utc_timestamp transform transform_keys transform_values translate trim trunc try_add try_divide typeof ucase unbase64 unhex uniontype unix_date unix_micros unix_millis unix_seconds unix_timestamp upper uuid var_pop var_samp variance version weekday weekofyear when width_bucket window xpath xpath_boolean xpath_double xpath_float xpath_int xpath_long xpath_number xpath_short xpath_string xxhash64 year zip_with"),
        atoms: set("false true null"),
        operatorChars: /^[*\/+\-%<>!=~&|^]/,
        dateSQL: set("date time timestamp"),
        support: set("ODBCdotTable doubleQuote zerolessFloat")
    });
    // Esper
    CodeMirror1.defineMIME("text/x-esper", {
        name: "sql",
        client: set("source"),
        // http://www.espertech.com/esper/release-5.5.0/esper-reference/html/appendix_keywords.html
        keywords: set("alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit after all and as at asc avedev avg between by case cast coalesce count create current_timestamp day days delete define desc distinct else end escape events every exists false first from full group having hour hours in inner insert instanceof into irstream is istream join last lastweekday left limit like max match_recognize matches median measures metadatasql min minute minutes msec millisecond milliseconds not null offset on or order outer output partition pattern prev prior regexp retain-union retain-intersection right rstream sec second seconds select set some snapshot sql stddev sum then true unidirectional until update variable weekday when where window"),
        builtin: {},
        atoms: set("false true null"),
        operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
        dateSQL: set("time"),
        support: set("decimallessFloat zerolessFloat binaryNumber hexNumber")
    });
}); /*
  How Properties of Mime Types are used by SQL Mode
  =================================================

  keywords:
    A list of keywords you want to be highlighted.
  builtin:
    A list of builtin types you want to be highlighted (if you want types to be of class "builtin" instead of "keyword").
  operatorChars:
    All characters that must be handled as operators.
  client:
    Commands parsed and executed by the client (not the server).
  support:
    A list of supported syntaxes which are not common, but are supported by more than 1 DBMS.
    * ODBCdotTable: .tableName
    * zerolessFloat: .1
    * doubleQuote
    * nCharCast: N'string'
    * charsetCast: _utf8'string'
    * commentHash: use # char for comments
    * commentSlashSlash: use // for comments
    * commentSpaceRequired: require a space after -- for comments
  atoms:
    Keywords that must be highlighted as atoms,. Some DBMS's support more atoms than others:
    UNKNOWN, INFINITY, UNDERFLOW, NaN...
  dateSQL:
    Used for date/time SQL standard syntax, because not all DBMS's support same temporal types.
*/
});

var stylus = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// Stylus mode created by Dmitry Kiselyov http://git.io/AaRB
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var wordRegexp = function wordRegexp(words) {
        words = words.sort(function(a, b) {
            return b > a;
        });
        return new RegExp("^((" + words.join(")|(") + "))\\b");
    };
    var keySet = function keySet(array) {
        var keys = {};
        for(var i = 0; i < array.length; ++i)keys[array[i]] = true;
        return keys;
    };
    var escapeRegExp = function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    };
    CodeMirror1.defineMode("stylus", function(config) {
        var tokenBase = /**
     * Tokenizers
     */ function tokenBase(stream, state) {
            firstWordMatch = stream.string.match(/(^[\w-]+\s*=\s*$)|(^\s*[\w-]+\s*=\s*[\w-])|(^\s*(\.|#|@|\$|\&|\[|\d|\+|::?|\{|\>|~|\/)?\s*[\w-]*([a-z0-9-]|\*|\/\*)(\(|,)?)/);
            state.context.line.firstWord = firstWordMatch ? firstWordMatch[0].replace(/^\s*/, "") : "";
            state.context.line.indent = stream.indentation();
            ch = stream.peek();
            // Line comment
            if (stream.match("//")) {
                stream.skipToEnd();
                return [
                    "comment",
                    "comment"
                ];
            }
            // Block comment
            if (stream.match("/*")) {
                state.tokenize = tokenCComment;
                return tokenCComment(stream, state);
            }
            // String
            if (ch == '"' || ch == "'") {
                stream.next();
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            }
            // Def
            if (ch == "@") {
                stream.next();
                stream.eatWhile(/[\w\\-]/);
                return [
                    "def",
                    stream.current()
                ];
            }
            // ID selector or Hex color
            if (ch == "#") {
                stream.next();
                // Hex color
                if (stream.match(/^[0-9a-f]{3}([0-9a-f]([0-9a-f]{2}){0,2})?\b(?!-)/i)) {
                    return [
                        "atom",
                        "atom"
                    ];
                }
                // ID selector
                if (stream.match(/^[a-z][\w-]*/i)) {
                    return [
                        "builtin",
                        "hash"
                    ];
                }
            }
            // Vendor prefixes
            if (stream.match(vendorPrefixesRegexp)) {
                return [
                    "meta",
                    "vendor-prefixes"
                ];
            }
            // Numbers
            if (stream.match(/^-?[0-9]?\.?[0-9]/)) {
                stream.eatWhile(/[a-z%]/i);
                return [
                    "number",
                    "unit"
                ];
            }
            // !important|optional
            if (ch == "!") {
                stream.next();
                return [
                    stream.match(/^(important|optional)/i) ? "keyword" : "operator",
                    "important"
                ];
            }
            // Class
            if (ch == "." && stream.match(/^\.[a-z][\w-]*/i)) {
                return [
                    "qualifier",
                    "qualifier"
                ];
            }
            // url url-prefix domain regexp
            if (stream.match(documentTypesRegexp)) {
                if (stream.peek() == "(") state.tokenize = tokenParenthesized;
                return [
                    "property",
                    "word"
                ];
            }
            // Mixins / Functions
            if (stream.match(/^[a-z][\w-]*\(/i)) {
                stream.backUp(1);
                return [
                    "keyword",
                    "mixin"
                ];
            }
            // Block mixins
            if (stream.match(/^(\+|-)[a-z][\w-]*\(/i)) {
                stream.backUp(1);
                return [
                    "keyword",
                    "block-mixin"
                ];
            }
            // Parent Reference BEM naming
            if (stream.string.match(/^\s*&/) && stream.match(/^[-_]+[a-z][\w-]*/)) {
                return [
                    "qualifier",
                    "qualifier"
                ];
            }
            // / Root Reference & Parent Reference
            if (stream.match(/^(\/|&)(-|_|:|\.|#|[a-z])/)) {
                stream.backUp(1);
                return [
                    "variable-3",
                    "reference"
                ];
            }
            if (stream.match(/^&{1}\s*$/)) {
                return [
                    "variable-3",
                    "reference"
                ];
            }
            // Word operator
            if (stream.match(wordOperatorKeywordsRegexp)) {
                return [
                    "operator",
                    "operator"
                ];
            }
            // Word
            if (stream.match(/^\$?[-_]*[a-z0-9]+[\w-]*/i)) {
                // Variable
                if (stream.match(/^(\.|\[)[\w-\'\"\]]+/i, false)) {
                    if (!wordIsTag(stream.current())) {
                        stream.match(".");
                        return [
                            "variable-2",
                            "variable-name"
                        ];
                    }
                }
                return [
                    "variable-2",
                    "word"
                ];
            }
            // Operators
            if (stream.match(operatorsRegexp)) {
                return [
                    "operator",
                    stream.current()
                ];
            }
            // Delimiters
            if (/[:;,{}\[\]\(\)]/.test(ch)) {
                stream.next();
                return [
                    null,
                    ch
                ];
            }
            // Non-detected items
            stream.next();
            return [
                null,
                null
            ];
        };
        var tokenCComment = /**
     * Token comment
     */ function tokenCComment(stream, state) {
            var maybeEnd = false, ch;
            while((ch = stream.next()) != null){
                if (maybeEnd && ch == "/") {
                    state.tokenize = null;
                    break;
                }
                maybeEnd = ch == "*";
            }
            return [
                "comment",
                "comment"
            ];
        };
        var tokenString = /**
     * Token string
     */ function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, ch;
                while((ch = stream.next()) != null){
                    if (ch == quote && !escaped) {
                        if (quote == ")") stream.backUp(1);
                        break;
                    }
                    escaped = !escaped && ch == "\\";
                }
                if (ch == quote || !escaped && quote != ")") state.tokenize = null;
                return [
                    "string",
                    "string"
                ];
            };
        };
        var tokenParenthesized = /**
     * Token parenthesized
     */ function tokenParenthesized(stream, state) {
            stream.next(); // Must be "("
            if (!stream.match(/\s*[\"\')]/, false)) state.tokenize = tokenString(")");
            else state.tokenize = null;
            return [
                null,
                "("
            ];
        };
        var Context = /**
     * Context management
     */ function Context(type, indent, prev, line) {
            this.type = type;
            this.indent = indent;
            this.prev = prev;
            this.line = line || {
                firstWord: "",
                indent: 0
            };
        };
        var pushContext = function pushContext(state, stream, type, indent) {
            indent = indent >= 0 ? indent : indentUnit;
            state.context = new Context(type, stream.indentation() + indent, state.context);
            return type;
        };
        var popContext = function popContext(state, currentIndent) {
            var contextIndent = state.context.indent - indentUnit;
            currentIndent = currentIndent || false;
            state.context = state.context.prev;
            if (currentIndent) state.context.indent = contextIndent;
            return state.context.type;
        };
        var pass = function pass(type, stream, state) {
            return states[state.context.type](type, stream, state);
        };
        var popAndPass = function popAndPass(type, stream, state, n) {
            for(var i = n || 1; i > 0; i--)state.context = state.context.prev;
            return pass(type, stream, state);
        };
        var wordIsTag = /**
     * Parser
     */ function wordIsTag(word) {
            return word.toLowerCase() in tagKeywords;
        };
        var wordIsProperty = function wordIsProperty(word) {
            word = word.toLowerCase();
            return word in propertyKeywords || word in fontProperties;
        };
        var wordIsBlock = function wordIsBlock(word) {
            return word.toLowerCase() in blockKeywords;
        };
        var wordIsVendorPrefix = function wordIsVendorPrefix(word) {
            return word.toLowerCase().match(vendorPrefixesRegexp);
        };
        var wordAsValue = function wordAsValue(word) {
            var wordLC = word.toLowerCase();
            var override = "variable-2";
            if (wordIsTag(word)) override = "tag";
            else if (wordIsBlock(word)) override = "block-keyword";
            else if (wordIsProperty(word)) override = "property";
            else if (wordLC in valueKeywords || wordLC in commonAtoms) override = "atom";
            else if (wordLC == "return" || wordLC in colorKeywords) override = "keyword";
            else if (word.match(/^[A-Z]/)) override = "string";
            return override;
        };
        var typeIsBlock = function typeIsBlock(type, stream) {
            return endOfLine(stream) && (type == "{" || type == "]" || type == "hash" || type == "qualifier") || type == "block-mixin";
        };
        var typeIsInterpolation = function typeIsInterpolation(type, stream) {
            return type == "{" && stream.match(/^\s*\$?[\w-]+/i, false);
        };
        var typeIsPseudo = function typeIsPseudo(type, stream) {
            return type == ":" && stream.match(/^[a-z-]+/, false);
        };
        var startOfLine = function startOfLine(stream) {
            return stream.sol() || stream.string.match(new RegExp("^\\s*" + escapeRegExp(stream.current())));
        };
        var endOfLine = function endOfLine(stream) {
            return stream.eol() || stream.match(/^\s*$/, false);
        };
        var firstWordOfLine = function firstWordOfLine(line) {
            var re = /^\s*[-_]*[a-z0-9]+[\w-]*/i;
            var result = typeof line == "string" ? line.match(re) : line.string.match(re);
            return result ? result[0].replace(/^\s*/, "") : "";
        };
        var indentUnit = config.indentUnit, indentUnitString = "", tagKeywords = keySet(tagKeywords_), tagVariablesRegexp = /^(a|b|i|s|col|em)$/i, propertyKeywords = keySet(propertyKeywords_), nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_), valueKeywords = keySet(valueKeywords_), colorKeywords = keySet(colorKeywords_), documentTypes = keySet(documentTypes_), documentTypesRegexp = wordRegexp(documentTypes_), mediaFeatures = keySet(mediaFeatures_), mediaTypes = keySet(mediaTypes_), fontProperties = keySet(fontProperties_), operatorsRegexp = /^\s*([.]{2,3}|&&|\|\||\*\*|[?!=:]?=|[-+*\/%<>]=?|\?:|\~)/, wordOperatorKeywordsRegexp = wordRegexp(wordOperatorKeywords_), blockKeywords = keySet(blockKeywords_), vendorPrefixesRegexp = new RegExp(/^\-(moz|ms|o|webkit)-/i), commonAtoms = keySet(commonAtoms_), firstWordMatch = "", states = {}, ch, style, type, override;
        while(indentUnitString.length < indentUnit)indentUnitString += " ";
        /**
     * Block
     */ states.block = function(type, stream, state) {
            if (type == "comment" && startOfLine(stream) || type == "," && endOfLine(stream) || type == "mixin") {
                return pushContext(state, stream, "block", 0);
            }
            if (typeIsInterpolation(type, stream)) {
                return pushContext(state, stream, "interpolation");
            }
            if (endOfLine(stream) && type == "]") {
                if (!/^\s*(\.|#|:|\[|\*|&)/.test(stream.string) && !wordIsTag(firstWordOfLine(stream))) {
                    return pushContext(state, stream, "block", 0);
                }
            }
            if (typeIsBlock(type, stream)) {
                return pushContext(state, stream, "block");
            }
            if (type == "}" && endOfLine(stream)) {
                return pushContext(state, stream, "block", 0);
            }
            if (type == "variable-name") {
                if (stream.string.match(/^\s?\$[\w-\.\[\]\'\"]+$/) || wordIsBlock(firstWordOfLine(stream))) {
                    return pushContext(state, stream, "variableName");
                } else {
                    return pushContext(state, stream, "variableName", 0);
                }
            }
            if (type == "=") {
                if (!endOfLine(stream) && !wordIsBlock(firstWordOfLine(stream))) {
                    return pushContext(state, stream, "block", 0);
                }
                return pushContext(state, stream, "block");
            }
            if (type == "*") {
                if (endOfLine(stream) || stream.match(/\s*(,|\.|#|\[|:|{)/, false)) {
                    override = "tag";
                    return pushContext(state, stream, "block");
                }
            }
            if (typeIsPseudo(type, stream)) {
                return pushContext(state, stream, "pseudo");
            }
            if (/@(font-face|media|supports|(-moz-)?document)/.test(type)) {
                return pushContext(state, stream, endOfLine(stream) ? "block" : "atBlock");
            }
            if (/@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
                return pushContext(state, stream, "keyframes");
            }
            if (/@extends?/.test(type)) {
                return pushContext(state, stream, "extend", 0);
            }
            if (type && type.charAt(0) == "@") {
                // Property Lookup
                if (stream.indentation() > 0 && wordIsProperty(stream.current().slice(1))) {
                    override = "variable-2";
                    return "block";
                }
                if (/(@import|@require|@charset)/.test(type)) {
                    return pushContext(state, stream, "block", 0);
                }
                return pushContext(state, stream, "block");
            }
            if (type == "reference" && endOfLine(stream)) {
                return pushContext(state, stream, "block");
            }
            if (type == "(") {
                return pushContext(state, stream, "parens");
            }
            if (type == "vendor-prefixes") {
                return pushContext(state, stream, "vendorPrefixes");
            }
            if (type == "word") {
                var word = stream.current();
                override = wordAsValue(word);
                if (override == "property") {
                    if (startOfLine(stream)) {
                        return pushContext(state, stream, "block", 0);
                    } else {
                        override = "atom";
                        return "block";
                    }
                }
                if (override == "tag") {
                    // tag is a css value
                    if (/embed|menu|pre|progress|sub|table/.test(word)) {
                        if (wordIsProperty(firstWordOfLine(stream))) {
                            override = "atom";
                            return "block";
                        }
                    }
                    // tag is an attribute
                    if (stream.string.match(new RegExp("\\[\\s*" + word + "|" + word + "\\s*\\]"))) {
                        override = "atom";
                        return "block";
                    }
                    // tag is a variable
                    if (tagVariablesRegexp.test(word)) {
                        if (startOfLine(stream) && stream.string.match(/=/) || !startOfLine(stream) && !stream.string.match(/^(\s*\.|#|\&|\[|\/|>|\*)/) && !wordIsTag(firstWordOfLine(stream))) {
                            override = "variable-2";
                            if (wordIsBlock(firstWordOfLine(stream))) return "block";
                            return pushContext(state, stream, "block", 0);
                        }
                    }
                    if (endOfLine(stream)) return pushContext(state, stream, "block");
                }
                if (override == "block-keyword") {
                    override = "keyword";
                    // Postfix conditionals
                    if (stream.current(/(if|unless)/) && !startOfLine(stream)) {
                        return "block";
                    }
                    return pushContext(state, stream, "block");
                }
                if (word == "return") return pushContext(state, stream, "block", 0);
                // Placeholder selector
                if (override == "variable-2" && stream.string.match(/^\s?\$[\w-\.\[\]\'\"]+$/)) {
                    return pushContext(state, stream, "block");
                }
            }
            return state.context.type;
        };
        /**
     * Parens
     */ states.parens = function(type, stream, state) {
            if (type == "(") return pushContext(state, stream, "parens");
            if (type == ")") {
                if (state.context.prev.type == "parens") {
                    return popContext(state);
                }
                if (stream.string.match(/^[a-z][\w-]*\(/i) && endOfLine(stream) || wordIsBlock(firstWordOfLine(stream)) || /(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(firstWordOfLine(stream)) || !stream.string.match(/^-?[a-z][\w-\.\[\]\'\"]*\s*=/) && wordIsTag(firstWordOfLine(stream))) {
                    return pushContext(state, stream, "block");
                }
                if (stream.string.match(/^[\$-]?[a-z][\w-\.\[\]\'\"]*\s*=/) || stream.string.match(/^\s*(\(|\)|[0-9])/) || stream.string.match(/^\s+[a-z][\w-]*\(/i) || stream.string.match(/^\s+[\$-]?[a-z]/i)) {
                    return pushContext(state, stream, "block", 0);
                }
                if (endOfLine(stream)) return pushContext(state, stream, "block");
                else return pushContext(state, stream, "block", 0);
            }
            if (type && type.charAt(0) == "@" && wordIsProperty(stream.current().slice(1))) {
                override = "variable-2";
            }
            if (type == "word") {
                var word = stream.current();
                override = wordAsValue(word);
                if (override == "tag" && tagVariablesRegexp.test(word)) {
                    override = "variable-2";
                }
                if (override == "property" || word == "to") override = "atom";
            }
            if (type == "variable-name") {
                return pushContext(state, stream, "variableName");
            }
            if (typeIsPseudo(type, stream)) {
                return pushContext(state, stream, "pseudo");
            }
            return state.context.type;
        };
        /**
     * Vendor prefixes
     */ states.vendorPrefixes = function(type, stream, state) {
            if (type == "word") {
                override = "property";
                return pushContext(state, stream, "block", 0);
            }
            return popContext(state);
        };
        /**
     * Pseudo
     */ states.pseudo = function(type, stream, state) {
            if (!wordIsProperty(firstWordOfLine(stream.string))) {
                stream.match(/^[a-z-]+/);
                override = "variable-3";
                if (endOfLine(stream)) return pushContext(state, stream, "block");
                return popContext(state);
            }
            return popAndPass(type, stream, state);
        };
        /**
     * atBlock
     */ states.atBlock = function(type, stream, state) {
            if (type == "(") return pushContext(state, stream, "atBlock_parens");
            if (typeIsBlock(type, stream)) {
                return pushContext(state, stream, "block");
            }
            if (typeIsInterpolation(type, stream)) {
                return pushContext(state, stream, "interpolation");
            }
            if (type == "word") {
                var word = stream.current().toLowerCase();
                if (/^(only|not|and|or)$/.test(word)) override = "keyword";
                else if (documentTypes.hasOwnProperty(word)) override = "tag";
                else if (mediaTypes.hasOwnProperty(word)) override = "attribute";
                else if (mediaFeatures.hasOwnProperty(word)) override = "property";
                else if (nonStandardPropertyKeywords.hasOwnProperty(word)) override = "string-2";
                else override = wordAsValue(stream.current());
                if (override == "tag" && endOfLine(stream)) {
                    return pushContext(state, stream, "block");
                }
            }
            if (type == "operator" && /^(not|and|or)$/.test(stream.current())) {
                override = "keyword";
            }
            return state.context.type;
        };
        states.atBlock_parens = function(type, stream, state) {
            if (type == "{" || type == "}") return state.context.type;
            if (type == ")") {
                if (endOfLine(stream)) return pushContext(state, stream, "block");
                else return pushContext(state, stream, "atBlock");
            }
            if (type == "word") {
                var word = stream.current().toLowerCase();
                override = wordAsValue(word);
                if (/^(max|min)/.test(word)) override = "property";
                if (override == "tag") {
                    tagVariablesRegexp.test(word) ? override = "variable-2" : override = "atom";
                }
                return state.context.type;
            }
            return states.atBlock(type, stream, state);
        };
        /**
     * Keyframes
     */ states.keyframes = function(type, stream, state) {
            if (stream.indentation() == "0" && (type == "}" && startOfLine(stream) || type == "]" || type == "hash" || type == "qualifier" || wordIsTag(stream.current()))) {
                return popAndPass(type, stream, state);
            }
            if (type == "{") return pushContext(state, stream, "keyframes");
            if (type == "}") {
                if (startOfLine(stream)) return popContext(state, true);
                else return pushContext(state, stream, "keyframes");
            }
            if (type == "unit" && /^[0-9]+\%$/.test(stream.current())) {
                return pushContext(state, stream, "keyframes");
            }
            if (type == "word") {
                override = wordAsValue(stream.current());
                if (override == "block-keyword") {
                    override = "keyword";
                    return pushContext(state, stream, "keyframes");
                }
            }
            if (/@(font-face|media|supports|(-moz-)?document)/.test(type)) {
                return pushContext(state, stream, endOfLine(stream) ? "block" : "atBlock");
            }
            if (type == "mixin") {
                return pushContext(state, stream, "block", 0);
            }
            return state.context.type;
        };
        /**
     * Interpolation
     */ states.interpolation = function(type, stream, state) {
            if (type == "{") popContext(state) && pushContext(state, stream, "block");
            if (type == "}") {
                if (stream.string.match(/^\s*(\.|#|:|\[|\*|&|>|~|\+|\/)/i) || stream.string.match(/^\s*[a-z]/i) && wordIsTag(firstWordOfLine(stream))) {
                    return pushContext(state, stream, "block");
                }
                if (!stream.string.match(/^(\{|\s*\&)/) || stream.match(/\s*[\w-]/, false)) {
                    return pushContext(state, stream, "block", 0);
                }
                return pushContext(state, stream, "block");
            }
            if (type == "variable-name") {
                return pushContext(state, stream, "variableName", 0);
            }
            if (type == "word") {
                override = wordAsValue(stream.current());
                if (override == "tag") override = "atom";
            }
            return state.context.type;
        };
        /**
     * Extend/s
     */ states.extend = function(type, stream, state) {
            if (type == "[" || type == "=") return "extend";
            if (type == "]") return popContext(state);
            if (type == "word") {
                override = wordAsValue(stream.current());
                return "extend";
            }
            return popContext(state);
        };
        /**
     * Variable name
     */ states.variableName = function(type, stream, state) {
            if (type == "string" || type == "[" || type == "]" || stream.current().match(/^(\.|\$)/)) {
                if (stream.current().match(/^\.[\w-]+/i)) override = "variable-2";
                return "variableName";
            }
            return popAndPass(type, stream, state);
        };
        return {
            startState: function startState(base) {
                return {
                    tokenize: null,
                    state: "block",
                    context: new Context("block", base || 0, null)
                };
            },
            token: function token(stream, state) {
                if (!state.tokenize && stream.eatSpace()) return null;
                style = (state.tokenize || tokenBase)(stream, state);
                if (style && typeof style == "object") {
                    type = style[1];
                    style = style[0];
                }
                override = style;
                state.state = states[state.state](type, stream, state);
                return override;
            },
            indent: function indent(state, textAfter, line) {
                var cx = state.context, ch = textAfter && textAfter.charAt(0), indent = cx.indent, lineFirstWord = firstWordOfLine(textAfter), lineIndent = line.match(/^\s*/)[0].replace(/\t/g, indentUnitString).length, prevLineFirstWord = state.context.prev ? state.context.prev.line.firstWord : "", prevLineIndent = state.context.prev ? state.context.prev.line.indent : lineIndent;
                if (cx.prev && (ch == "}" && (cx.type == "block" || cx.type == "atBlock" || cx.type == "keyframes") || ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") || ch == "{" && cx.type == "at")) {
                    indent = cx.indent - indentUnit;
                } else if (!/(\})/.test(ch)) {
                    if (/@|\$|\d/.test(ch) || /^\{/.test(textAfter) || /^\s*\/(\/|\*)/.test(textAfter) || /^\s*\/\*/.test(prevLineFirstWord) || /^\s*[\w-\.\[\]\'\"]+\s*(\?|:|\+)?=/i.test(textAfter) || /^(\+|-)?[a-z][\w-]*\(/i.test(textAfter) || /^return/.test(textAfter) || wordIsBlock(lineFirstWord)) {
                        indent = lineIndent;
                    } else if (/(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(ch) || wordIsTag(lineFirstWord)) {
                        if (/\,\s*$/.test(prevLineFirstWord)) {
                            indent = prevLineIndent;
                        } else if (/^\s+/.test(line) && (/(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(prevLineFirstWord) || wordIsTag(prevLineFirstWord))) {
                            indent = lineIndent <= prevLineIndent ? prevLineIndent : prevLineIndent + indentUnit;
                        } else {
                            indent = lineIndent;
                        }
                    } else if (!/,\s*$/.test(line) && (wordIsVendorPrefix(lineFirstWord) || wordIsProperty(lineFirstWord))) {
                        if (wordIsBlock(prevLineFirstWord)) {
                            indent = lineIndent <= prevLineIndent ? prevLineIndent : prevLineIndent + indentUnit;
                        } else if (/^\{/.test(prevLineFirstWord)) {
                            indent = lineIndent <= prevLineIndent ? lineIndent : prevLineIndent + indentUnit;
                        } else if (wordIsVendorPrefix(prevLineFirstWord) || wordIsProperty(prevLineFirstWord)) {
                            indent = lineIndent >= prevLineIndent ? prevLineIndent : lineIndent;
                        } else if (/^(\.|#|:|\[|\*|&|@|\+|\-|>|~|\/)/.test(prevLineFirstWord) || /=\s*$/.test(prevLineFirstWord) || wordIsTag(prevLineFirstWord) || /^\$[\w-\.\[\]\'\"]/.test(prevLineFirstWord)) {
                            indent = prevLineIndent + indentUnit;
                        } else {
                            indent = lineIndent;
                        }
                    }
                }
                return indent;
            },
            electricChars: "}",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: "//",
            fold: "indent"
        };
    });
    // developer.mozilla.org/en-US/docs/Web/HTML/Element
    var tagKeywords_ = [
        "a",
        "abbr",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "base",
        "bdi",
        "bdo",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "cite",
        "code",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "keygen",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "meter",
        "nav",
        "nobr",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "u",
        "ul",
        "var",
        "video"
    ];
    // github.com/codemirror/CodeMirror/blob/master/mode/css/css.js
    // Note, "url-prefix" should precede "url" in order to match correctly in documentTypesRegexp
    var documentTypes_ = [
        "domain",
        "regexp",
        "url-prefix",
        "url"
    ];
    var mediaTypes_ = [
        "all",
        "aural",
        "braille",
        "handheld",
        "print",
        "projection",
        "screen",
        "tty",
        "tv",
        "embossed"
    ];
    var mediaFeatures_ = [
        "width",
        "min-width",
        "max-width",
        "height",
        "min-height",
        "max-height",
        "device-width",
        "min-device-width",
        "max-device-width",
        "device-height",
        "min-device-height",
        "max-device-height",
        "aspect-ratio",
        "min-aspect-ratio",
        "max-aspect-ratio",
        "device-aspect-ratio",
        "min-device-aspect-ratio",
        "max-device-aspect-ratio",
        "color",
        "min-color",
        "max-color",
        "color-index",
        "min-color-index",
        "max-color-index",
        "monochrome",
        "min-monochrome",
        "max-monochrome",
        "resolution",
        "min-resolution",
        "max-resolution",
        "scan",
        "grid",
        "dynamic-range",
        "video-dynamic-range"
    ];
    var propertyKeywords_ = [
        "align-content",
        "align-items",
        "align-self",
        "alignment-adjust",
        "alignment-baseline",
        "anchor-point",
        "animation",
        "animation-delay",
        "animation-direction",
        "animation-duration",
        "animation-fill-mode",
        "animation-iteration-count",
        "animation-name",
        "animation-play-state",
        "animation-timing-function",
        "appearance",
        "azimuth",
        "backface-visibility",
        "background",
        "background-attachment",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-repeat",
        "background-size",
        "baseline-shift",
        "binding",
        "bleed",
        "bookmark-label",
        "bookmark-level",
        "bookmark-state",
        "bookmark-target",
        "border",
        "border-bottom",
        "border-bottom-color",
        "border-bottom-left-radius",
        "border-bottom-right-radius",
        "border-bottom-style",
        "border-bottom-width",
        "border-collapse",
        "border-color",
        "border-image",
        "border-image-outset",
        "border-image-repeat",
        "border-image-slice",
        "border-image-source",
        "border-image-width",
        "border-left",
        "border-left-color",
        "border-left-style",
        "border-left-width",
        "border-radius",
        "border-right",
        "border-right-color",
        "border-right-style",
        "border-right-width",
        "border-spacing",
        "border-style",
        "border-top",
        "border-top-color",
        "border-top-left-radius",
        "border-top-right-radius",
        "border-top-style",
        "border-top-width",
        "border-width",
        "bottom",
        "box-decoration-break",
        "box-shadow",
        "box-sizing",
        "break-after",
        "break-before",
        "break-inside",
        "caption-side",
        "clear",
        "clip",
        "color",
        "color-profile",
        "column-count",
        "column-fill",
        "column-gap",
        "column-rule",
        "column-rule-color",
        "column-rule-style",
        "column-rule-width",
        "column-span",
        "column-width",
        "columns",
        "content",
        "counter-increment",
        "counter-reset",
        "crop",
        "cue",
        "cue-after",
        "cue-before",
        "cursor",
        "direction",
        "display",
        "dominant-baseline",
        "drop-initial-after-adjust",
        "drop-initial-after-align",
        "drop-initial-before-adjust",
        "drop-initial-before-align",
        "drop-initial-size",
        "drop-initial-value",
        "elevation",
        "empty-cells",
        "fit",
        "fit-position",
        "flex",
        "flex-basis",
        "flex-direction",
        "flex-flow",
        "flex-grow",
        "flex-shrink",
        "flex-wrap",
        "float",
        "float-offset",
        "flow-from",
        "flow-into",
        "font",
        "font-feature-settings",
        "font-family",
        "font-kerning",
        "font-language-override",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-synthesis",
        "font-variant",
        "font-variant-alternates",
        "font-variant-caps",
        "font-variant-east-asian",
        "font-variant-ligatures",
        "font-variant-numeric",
        "font-variant-position",
        "font-weight",
        "grid",
        "grid-area",
        "grid-auto-columns",
        "grid-auto-flow",
        "grid-auto-position",
        "grid-auto-rows",
        "grid-column",
        "grid-column-end",
        "grid-column-start",
        "grid-row",
        "grid-row-end",
        "grid-row-start",
        "grid-template",
        "grid-template-areas",
        "grid-template-columns",
        "grid-template-rows",
        "hanging-punctuation",
        "height",
        "hyphens",
        "icon",
        "image-orientation",
        "image-rendering",
        "image-resolution",
        "inline-box-align",
        "justify-content",
        "left",
        "letter-spacing",
        "line-break",
        "line-height",
        "line-stacking",
        "line-stacking-ruby",
        "line-stacking-shift",
        "line-stacking-strategy",
        "list-style",
        "list-style-image",
        "list-style-position",
        "list-style-type",
        "margin",
        "margin-bottom",
        "margin-left",
        "margin-right",
        "margin-top",
        "marker-offset",
        "marks",
        "marquee-direction",
        "marquee-loop",
        "marquee-play-count",
        "marquee-speed",
        "marquee-style",
        "max-height",
        "max-width",
        "min-height",
        "min-width",
        "move-to",
        "nav-down",
        "nav-index",
        "nav-left",
        "nav-right",
        "nav-up",
        "object-fit",
        "object-position",
        "opacity",
        "order",
        "orphans",
        "outline",
        "outline-color",
        "outline-offset",
        "outline-style",
        "outline-width",
        "overflow",
        "overflow-style",
        "overflow-wrap",
        "overflow-x",
        "overflow-y",
        "padding",
        "padding-bottom",
        "padding-left",
        "padding-right",
        "padding-top",
        "page",
        "page-break-after",
        "page-break-before",
        "page-break-inside",
        "page-policy",
        "pause",
        "pause-after",
        "pause-before",
        "perspective",
        "perspective-origin",
        "pitch",
        "pitch-range",
        "play-during",
        "position",
        "presentation-level",
        "punctuation-trim",
        "quotes",
        "region-break-after",
        "region-break-before",
        "region-break-inside",
        "region-fragment",
        "rendering-intent",
        "resize",
        "rest",
        "rest-after",
        "rest-before",
        "richness",
        "right",
        "rotation",
        "rotation-point",
        "ruby-align",
        "ruby-overhang",
        "ruby-position",
        "ruby-span",
        "shape-image-threshold",
        "shape-inside",
        "shape-margin",
        "shape-outside",
        "size",
        "speak",
        "speak-as",
        "speak-header",
        "speak-numeral",
        "speak-punctuation",
        "speech-rate",
        "stress",
        "string-set",
        "tab-size",
        "table-layout",
        "target",
        "target-name",
        "target-new",
        "target-position",
        "text-align",
        "text-align-last",
        "text-decoration",
        "text-decoration-color",
        "text-decoration-line",
        "text-decoration-skip",
        "text-decoration-style",
        "text-emphasis",
        "text-emphasis-color",
        "text-emphasis-position",
        "text-emphasis-style",
        "text-height",
        "text-indent",
        "text-justify",
        "text-outline",
        "text-overflow",
        "text-shadow",
        "text-size-adjust",
        "text-space-collapse",
        "text-transform",
        "text-underline-position",
        "text-wrap",
        "top",
        "transform",
        "transform-origin",
        "transform-style",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function",
        "unicode-bidi",
        "vertical-align",
        "visibility",
        "voice-balance",
        "voice-duration",
        "voice-family",
        "voice-pitch",
        "voice-range",
        "voice-rate",
        "voice-stress",
        "voice-volume",
        "volume",
        "white-space",
        "widows",
        "width",
        "will-change",
        "word-break",
        "word-spacing",
        "word-wrap",
        "z-index",
        "clip-path",
        "clip-rule",
        "mask",
        "enable-background",
        "filter",
        "flood-color",
        "flood-opacity",
        "lighting-color",
        "stop-color",
        "stop-opacity",
        "pointer-events",
        "color-interpolation",
        "color-interpolation-filters",
        "color-rendering",
        "fill",
        "fill-opacity",
        "fill-rule",
        "image-rendering",
        "marker",
        "marker-end",
        "marker-mid",
        "marker-start",
        "shape-rendering",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-rendering",
        "baseline-shift",
        "dominant-baseline",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "text-anchor",
        "writing-mode",
        "font-smoothing",
        "osx-font-smoothing"
    ];
    var nonStandardPropertyKeywords_ = [
        "scrollbar-arrow-color",
        "scrollbar-base-color",
        "scrollbar-dark-shadow-color",
        "scrollbar-face-color",
        "scrollbar-highlight-color",
        "scrollbar-shadow-color",
        "scrollbar-3d-light-color",
        "scrollbar-track-color",
        "shape-inside",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "zoom"
    ];
    var fontProperties_ = [
        "font-family",
        "src",
        "unicode-range",
        "font-variant",
        "font-feature-settings",
        "font-stretch",
        "font-weight",
        "font-style"
    ];
    var colorKeywords_ = [
        "aliceblue",
        "antiquewhite",
        "aqua",
        "aquamarine",
        "azure",
        "beige",
        "bisque",
        "black",
        "blanchedalmond",
        "blue",
        "blueviolet",
        "brown",
        "burlywood",
        "cadetblue",
        "chartreuse",
        "chocolate",
        "coral",
        "cornflowerblue",
        "cornsilk",
        "crimson",
        "cyan",
        "darkblue",
        "darkcyan",
        "darkgoldenrod",
        "darkgray",
        "darkgreen",
        "darkkhaki",
        "darkmagenta",
        "darkolivegreen",
        "darkorange",
        "darkorchid",
        "darkred",
        "darksalmon",
        "darkseagreen",
        "darkslateblue",
        "darkslategray",
        "darkturquoise",
        "darkviolet",
        "deeppink",
        "deepskyblue",
        "dimgray",
        "dodgerblue",
        "firebrick",
        "floralwhite",
        "forestgreen",
        "fuchsia",
        "gainsboro",
        "ghostwhite",
        "gold",
        "goldenrod",
        "gray",
        "grey",
        "green",
        "greenyellow",
        "honeydew",
        "hotpink",
        "indianred",
        "indigo",
        "ivory",
        "khaki",
        "lavender",
        "lavenderblush",
        "lawngreen",
        "lemonchiffon",
        "lightblue",
        "lightcoral",
        "lightcyan",
        "lightgoldenrodyellow",
        "lightgray",
        "lightgreen",
        "lightpink",
        "lightsalmon",
        "lightseagreen",
        "lightskyblue",
        "lightslategray",
        "lightsteelblue",
        "lightyellow",
        "lime",
        "limegreen",
        "linen",
        "magenta",
        "maroon",
        "mediumaquamarine",
        "mediumblue",
        "mediumorchid",
        "mediumpurple",
        "mediumseagreen",
        "mediumslateblue",
        "mediumspringgreen",
        "mediumturquoise",
        "mediumvioletred",
        "midnightblue",
        "mintcream",
        "mistyrose",
        "moccasin",
        "navajowhite",
        "navy",
        "oldlace",
        "olive",
        "olivedrab",
        "orange",
        "orangered",
        "orchid",
        "palegoldenrod",
        "palegreen",
        "paleturquoise",
        "palevioletred",
        "papayawhip",
        "peachpuff",
        "peru",
        "pink",
        "plum",
        "powderblue",
        "purple",
        "rebeccapurple",
        "red",
        "rosybrown",
        "royalblue",
        "saddlebrown",
        "salmon",
        "sandybrown",
        "seagreen",
        "seashell",
        "sienna",
        "silver",
        "skyblue",
        "slateblue",
        "slategray",
        "snow",
        "springgreen",
        "steelblue",
        "tan",
        "teal",
        "thistle",
        "tomato",
        "turquoise",
        "violet",
        "wheat",
        "white",
        "whitesmoke",
        "yellow",
        "yellowgreen"
    ];
    var valueKeywords_ = [
        "above",
        "absolute",
        "activeborder",
        "additive",
        "activecaption",
        "afar",
        "after-white-space",
        "ahead",
        "alias",
        "all",
        "all-scroll",
        "alphabetic",
        "alternate",
        "always",
        "amharic",
        "amharic-abegede",
        "antialiased",
        "appworkspace",
        "arabic-indic",
        "armenian",
        "asterisks",
        "attr",
        "auto",
        "avoid",
        "avoid-column",
        "avoid-page",
        "avoid-region",
        "background",
        "backwards",
        "baseline",
        "below",
        "bidi-override",
        "binary",
        "bengali",
        "blink",
        "block",
        "block-axis",
        "bold",
        "bolder",
        "border",
        "border-box",
        "both",
        "bottom",
        "break",
        "break-all",
        "break-word",
        "bullets",
        "button",
        "button-bevel",
        "buttonface",
        "buttonhighlight",
        "buttonshadow",
        "buttontext",
        "calc",
        "cambodian",
        "capitalize",
        "caps-lock-indicator",
        "caption",
        "captiontext",
        "caret",
        "cell",
        "center",
        "checkbox",
        "circle",
        "cjk-decimal",
        "cjk-earthly-branch",
        "cjk-heavenly-stem",
        "cjk-ideographic",
        "clear",
        "clip",
        "close-quote",
        "col-resize",
        "collapse",
        "column",
        "compact",
        "condensed",
        "contain",
        "content",
        "contents",
        "content-box",
        "context-menu",
        "continuous",
        "copy",
        "counter",
        "counters",
        "cover",
        "crop",
        "cross",
        "crosshair",
        "currentcolor",
        "cursive",
        "cyclic",
        "dashed",
        "decimal",
        "decimal-leading-zero",
        "default",
        "default-button",
        "destination-atop",
        "destination-in",
        "destination-out",
        "destination-over",
        "devanagari",
        "disc",
        "discard",
        "disclosure-closed",
        "disclosure-open",
        "document",
        "dot-dash",
        "dot-dot-dash",
        "dotted",
        "double",
        "down",
        "e-resize",
        "ease",
        "ease-in",
        "ease-in-out",
        "ease-out",
        "element",
        "ellipse",
        "ellipsis",
        "embed",
        "end",
        "ethiopic",
        "ethiopic-abegede",
        "ethiopic-abegede-am-et",
        "ethiopic-abegede-gez",
        "ethiopic-abegede-ti-er",
        "ethiopic-abegede-ti-et",
        "ethiopic-halehame-aa-er",
        "ethiopic-halehame-aa-et",
        "ethiopic-halehame-am-et",
        "ethiopic-halehame-gez",
        "ethiopic-halehame-om-et",
        "ethiopic-halehame-sid-et",
        "ethiopic-halehame-so-et",
        "ethiopic-halehame-ti-er",
        "ethiopic-halehame-ti-et",
        "ethiopic-halehame-tig",
        "ethiopic-numeric",
        "ew-resize",
        "expanded",
        "extends",
        "extra-condensed",
        "extra-expanded",
        "fantasy",
        "fast",
        "fill",
        "fixed",
        "flat",
        "flex",
        "footnotes",
        "forwards",
        "from",
        "geometricPrecision",
        "georgian",
        "graytext",
        "groove",
        "gujarati",
        "gurmukhi",
        "hand",
        "hangul",
        "hangul-consonant",
        "hebrew",
        "help",
        "hidden",
        "hide",
        "high",
        "higher",
        "highlight",
        "highlighttext",
        "hiragana",
        "hiragana-iroha",
        "horizontal",
        "hsl",
        "hsla",
        "icon",
        "ignore",
        "inactiveborder",
        "inactivecaption",
        "inactivecaptiontext",
        "infinite",
        "infobackground",
        "infotext",
        "inherit",
        "initial",
        "inline",
        "inline-axis",
        "inline-block",
        "inline-flex",
        "inline-table",
        "inset",
        "inside",
        "intrinsic",
        "invert",
        "italic",
        "japanese-formal",
        "japanese-informal",
        "justify",
        "kannada",
        "katakana",
        "katakana-iroha",
        "keep-all",
        "khmer",
        "korean-hangul-formal",
        "korean-hanja-formal",
        "korean-hanja-informal",
        "landscape",
        "lao",
        "large",
        "larger",
        "left",
        "level",
        "lighter",
        "line-through",
        "linear",
        "linear-gradient",
        "lines",
        "list-item",
        "listbox",
        "listitem",
        "local",
        "logical",
        "loud",
        "lower",
        "lower-alpha",
        "lower-armenian",
        "lower-greek",
        "lower-hexadecimal",
        "lower-latin",
        "lower-norwegian",
        "lower-roman",
        "lowercase",
        "ltr",
        "malayalam",
        "match",
        "matrix",
        "matrix3d",
        "media-controls-background",
        "media-current-time-display",
        "media-fullscreen-button",
        "media-mute-button",
        "media-play-button",
        "media-return-to-realtime-button",
        "media-rewind-button",
        "media-seek-back-button",
        "media-seek-forward-button",
        "media-slider",
        "media-sliderthumb",
        "media-time-remaining-display",
        "media-volume-slider",
        "media-volume-slider-container",
        "media-volume-sliderthumb",
        "medium",
        "menu",
        "menulist",
        "menulist-button",
        "menulist-text",
        "menulist-textfield",
        "menutext",
        "message-box",
        "middle",
        "min-intrinsic",
        "mix",
        "mongolian",
        "monospace",
        "move",
        "multiple",
        "myanmar",
        "n-resize",
        "narrower",
        "ne-resize",
        "nesw-resize",
        "no-close-quote",
        "no-drop",
        "no-open-quote",
        "no-repeat",
        "none",
        "normal",
        "not-allowed",
        "nowrap",
        "ns-resize",
        "numbers",
        "numeric",
        "nw-resize",
        "nwse-resize",
        "oblique",
        "octal",
        "open-quote",
        "optimizeLegibility",
        "optimizeSpeed",
        "oriya",
        "oromo",
        "outset",
        "outside",
        "outside-shape",
        "overlay",
        "overline",
        "padding",
        "padding-box",
        "painted",
        "page",
        "paused",
        "persian",
        "perspective",
        "plus-darker",
        "plus-lighter",
        "pointer",
        "polygon",
        "portrait",
        "pre",
        "pre-line",
        "pre-wrap",
        "preserve-3d",
        "progress",
        "push-button",
        "radial-gradient",
        "radio",
        "read-only",
        "read-write",
        "read-write-plaintext-only",
        "rectangle",
        "region",
        "relative",
        "repeat",
        "repeating-linear-gradient",
        "repeating-radial-gradient",
        "repeat-x",
        "repeat-y",
        "reset",
        "reverse",
        "rgb",
        "rgba",
        "ridge",
        "right",
        "rotate",
        "rotate3d",
        "rotateX",
        "rotateY",
        "rotateZ",
        "round",
        "row-resize",
        "rtl",
        "run-in",
        "running",
        "s-resize",
        "sans-serif",
        "scale",
        "scale3d",
        "scaleX",
        "scaleY",
        "scaleZ",
        "scroll",
        "scrollbar",
        "scroll-position",
        "se-resize",
        "searchfield",
        "searchfield-cancel-button",
        "searchfield-decoration",
        "searchfield-results-button",
        "searchfield-results-decoration",
        "semi-condensed",
        "semi-expanded",
        "separate",
        "serif",
        "show",
        "sidama",
        "simp-chinese-formal",
        "simp-chinese-informal",
        "single",
        "skew",
        "skewX",
        "skewY",
        "skip-white-space",
        "slide",
        "slider-horizontal",
        "slider-vertical",
        "sliderthumb-horizontal",
        "sliderthumb-vertical",
        "slow",
        "small",
        "small-caps",
        "small-caption",
        "smaller",
        "solid",
        "somali",
        "source-atop",
        "source-in",
        "source-out",
        "source-over",
        "space",
        "spell-out",
        "square",
        "square-button",
        "standard",
        "start",
        "static",
        "status-bar",
        "stretch",
        "stroke",
        "sub",
        "subpixel-antialiased",
        "super",
        "sw-resize",
        "symbolic",
        "symbols",
        "table",
        "table-caption",
        "table-cell",
        "table-column",
        "table-column-group",
        "table-footer-group",
        "table-header-group",
        "table-row",
        "table-row-group",
        "tamil",
        "telugu",
        "text",
        "text-bottom",
        "text-top",
        "textarea",
        "textfield",
        "thai",
        "thick",
        "thin",
        "threeddarkshadow",
        "threedface",
        "threedhighlight",
        "threedlightshadow",
        "threedshadow",
        "tibetan",
        "tigre",
        "tigrinya-er",
        "tigrinya-er-abegede",
        "tigrinya-et",
        "tigrinya-et-abegede",
        "to",
        "top",
        "trad-chinese-formal",
        "trad-chinese-informal",
        "translate",
        "translate3d",
        "translateX",
        "translateY",
        "translateZ",
        "transparent",
        "ultra-condensed",
        "ultra-expanded",
        "underline",
        "up",
        "upper-alpha",
        "upper-armenian",
        "upper-greek",
        "upper-hexadecimal",
        "upper-latin",
        "upper-norwegian",
        "upper-roman",
        "uppercase",
        "urdu",
        "url",
        "var",
        "vertical",
        "vertical-text",
        "visible",
        "visibleFill",
        "visiblePainted",
        "visibleStroke",
        "visual",
        "w-resize",
        "wait",
        "wave",
        "wider",
        "window",
        "windowframe",
        "windowtext",
        "words",
        "x-large",
        "x-small",
        "xor",
        "xx-large",
        "xx-small",
        "bicubic",
        "optimizespeed",
        "grayscale",
        "row",
        "row-reverse",
        "wrap",
        "wrap-reverse",
        "column-reverse",
        "flex-start",
        "flex-end",
        "space-between",
        "space-around",
        "unset"
    ];
    var wordOperatorKeywords_ = [
        "in",
        "and",
        "or",
        "not",
        "is not",
        "is a",
        "is",
        "isnt",
        "defined",
        "if unless"
    ], blockKeywords_ = [
        "for",
        "if",
        "else",
        "unless",
        "from",
        "to"
    ], commonAtoms_ = [
        "null",
        "true",
        "false",
        "href",
        "title",
        "type",
        "not-allowed",
        "readonly",
        "disabled"
    ], commonDef_ = [
        "@font-face",
        "@keyframes",
        "@media",
        "@viewport",
        "@page",
        "@host",
        "@supports",
        "@block",
        "@css"
    ];
    var hintWords = tagKeywords_.concat(documentTypes_, mediaTypes_, mediaFeatures_, propertyKeywords_, nonStandardPropertyKeywords_, colorKeywords_, valueKeywords_, fontProperties_, wordOperatorKeywords_, blockKeywords_, commonAtoms_, commonDef_);
    CodeMirror1.registerHelper("hintWords", "stylus", hintWords);
    CodeMirror1.defineMIME("text/x-styl", "stylus");
});
});

var swift = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// Swift mode created by Michael Kaminsky https://github.com/mkaminsky11
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var wordSet = function wordSet(words) {
        var set = {};
        for(var i = 0; i < words.length; i++)set[words[i]] = true;
        return set;
    };
    var tokenBase = //var regexp = /^\/(?!\s)(?:\/\/)?(?:\\.|[^\/])+\//
    function tokenBase(stream, state, prev) {
        if (stream.sol()) state.indented = stream.indentation();
        if (stream.eatSpace()) return null;
        var ch = stream.peek();
        if (ch == "/") {
            if (stream.match("//")) {
                stream.skipToEnd();
                return "comment";
            }
            if (stream.match("/*")) {
                state.tokenize.push(tokenComment);
                return tokenComment(stream, state);
            }
        }
        if (stream.match(instruction)) return "builtin";
        if (stream.match(attribute)) return "attribute";
        if (stream.match(binary)) return "number";
        if (stream.match(octal)) return "number";
        if (stream.match(hexadecimal)) return "number";
        if (stream.match(decimal)) return "number";
        if (stream.match(property)) return "property";
        if (operators.indexOf(ch) > -1) {
            stream.next();
            return "operator";
        }
        if (punc.indexOf(ch) > -1) {
            stream.next();
            stream.match("..");
            return "punctuation";
        }
        var stringMatch;
        if (stringMatch = stream.match(/("""|"|')/)) {
            var tokenize = tokenString.bind(null, stringMatch[0]);
            state.tokenize.push(tokenize);
            return tokenize(stream, state);
        }
        if (stream.match(identifier)) {
            var ident = stream.current();
            if (types.hasOwnProperty(ident)) return "variable-2";
            if (atoms.hasOwnProperty(ident)) return "atom";
            if (keywords.hasOwnProperty(ident)) {
                if (definingKeywords.hasOwnProperty(ident)) state.prev = "define";
                return "keyword";
            }
            if (prev == "define") return "def";
            return "variable";
        }
        stream.next();
        return null;
    };
    var tokenUntilClosingParen = function tokenUntilClosingParen() {
        var depth = 0;
        return function(stream, state, prev) {
            var inner = tokenBase(stream, state, prev);
            if (inner == "punctuation") {
                if (stream.current() == "(") ++depth;
                else if (stream.current() == ")") {
                    if (depth == 0) {
                        stream.backUp(1);
                        state.tokenize.pop();
                        return state.tokenize[state.tokenize.length - 1](stream, state);
                    } else --depth;
                }
            }
            return inner;
        };
    };
    var tokenString = function tokenString(openQuote, stream, state) {
        var singleLine = openQuote.length == 1;
        var ch, escaped = false;
        while(ch = stream.peek()){
            if (escaped) {
                stream.next();
                if (ch == "(") {
                    state.tokenize.push(tokenUntilClosingParen());
                    return "string";
                }
                escaped = false;
            } else if (stream.match(openQuote)) {
                state.tokenize.pop();
                return "string";
            } else {
                stream.next();
                escaped = ch == "\\";
            }
        }
        if (singleLine) {
            state.tokenize.pop();
        }
        return "string";
    };
    var Context = function Context(prev, align, indented) {
        this.prev = prev;
        this.align = align;
        this.indented = indented;
    };
    var pushContext = function pushContext(state, stream) {
        var align = stream.match(/^\s*($|\/[\/\*])/, false) ? null : stream.column() + 1;
        state.context = new Context(state.context, align, state.indented);
    };
    var popContext = function popContext(state) {
        if (state.context) {
            state.indented = state.context.indented;
            state.context = state.context.prev;
        }
    };
    var keywords = wordSet([
        "_",
        "var",
        "let",
        "class",
        "enum",
        "extension",
        "import",
        "protocol",
        "struct",
        "func",
        "typealias",
        "associatedtype",
        "open",
        "public",
        "internal",
        "fileprivate",
        "private",
        "deinit",
        "init",
        "new",
        "override",
        "self",
        "subscript",
        "super",
        "convenience",
        "dynamic",
        "final",
        "indirect",
        "lazy",
        "required",
        "static",
        "unowned",
        "unowned(safe)",
        "unowned(unsafe)",
        "weak",
        "as",
        "is",
        "break",
        "case",
        "continue",
        "default",
        "else",
        "fallthrough",
        "for",
        "guard",
        "if",
        "in",
        "repeat",
        "switch",
        "where",
        "while",
        "defer",
        "return",
        "inout",
        "mutating",
        "nonmutating",
        "catch",
        "do",
        "rethrows",
        "throw",
        "throws",
        "try",
        "didSet",
        "get",
        "set",
        "willSet",
        "assignment",
        "associativity",
        "infix",
        "left",
        "none",
        "operator",
        "postfix",
        "precedence",
        "precedencegroup",
        "prefix",
        "right",
        "Any",
        "AnyObject",
        "Type",
        "dynamicType",
        "Self",
        "Protocol",
        "__COLUMN__",
        "__FILE__",
        "__FUNCTION__",
        "__LINE__"
    ]);
    var definingKeywords = wordSet([
        "var",
        "let",
        "class",
        "enum",
        "extension",
        "import",
        "protocol",
        "struct",
        "func",
        "typealias",
        "associatedtype",
        "for"
    ]);
    var atoms = wordSet([
        "true",
        "false",
        "nil",
        "self",
        "super",
        "_"
    ]);
    var types = wordSet([
        "Array",
        "Bool",
        "Character",
        "Dictionary",
        "Double",
        "Float",
        "Int",
        "Int8",
        "Int16",
        "Int32",
        "Int64",
        "Never",
        "Optional",
        "Set",
        "String",
        "UInt8",
        "UInt16",
        "UInt32",
        "UInt64",
        "Void"
    ]);
    var operators = "+-/*%=|&<>~^?!";
    var punc = ":;,.(){}[]";
    var binary = /^\-?0b[01][01_]*/;
    var octal = /^\-?0o[0-7][0-7_]*/;
    var hexadecimal = /^\-?0x[\dA-Fa-f][\dA-Fa-f_]*(?:(?:\.[\dA-Fa-f][\dA-Fa-f_]*)?[Pp]\-?\d[\d_]*)?/;
    var decimal = /^\-?\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee]\-?\d[\d_]*)?/;
    var identifier = /^\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1/;
    var property = /^\.(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/;
    var instruction = /^\#[A-Za-z]+/;
    var attribute = /^@(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/;
    function tokenComment(stream, state) {
        var ch;
        while(true){
            stream.match(/^[^/*]+/, true);
            ch = stream.next();
            if (!ch) break;
            if (ch === "/" && stream.eat("*")) {
                state.tokenize.push(tokenComment);
            } else if (ch === "*" && stream.eat("/")) {
                state.tokenize.pop();
            }
        }
        return "comment";
    }
    CodeMirror1.defineMode("swift", function(config) {
        return {
            startState: function startState() {
                return {
                    prev: null,
                    context: null,
                    indented: 0,
                    tokenize: []
                };
            },
            token: function token(stream, state) {
                var prev = state.prev;
                state.prev = null;
                var tokenize = state.tokenize[state.tokenize.length - 1] || tokenBase;
                var style = tokenize(stream, state, prev);
                if (!style || style == "comment") state.prev = prev;
                else if (!state.prev) state.prev = style;
                if (style == "punctuation") {
                    var bracket = /[\(\[\{]|([\]\)\}])/.exec(stream.current());
                    if (bracket) (bracket[1] ? popContext : pushContext)(state, stream);
                }
                return style;
            },
            indent: function indent(state, textAfter) {
                var cx = state.context;
                if (!cx) return 0;
                var closing = /^[\]\}\)]/.test(textAfter);
                if (cx.align != null) return cx.align - (closing ? 1 : 0);
                return cx.indented + (closing ? 0 : config.indentUnit);
            },
            electricInput: /^\s*[\)\}\]]$/,
            lineComment: "//",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``"
        };
    });
    CodeMirror1.defineMIME("text/x-swift", "swift");
});
});

var overlay = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// Utility function that allows modes to be combined. The mode given
// as the base argument takes care of most of the normal mode
// functionality, but a second (typically simple) mode is used, which
// can override the style of text. Both modes get to parse all of the
// text, but when both assign a non-null style to a piece of code, the
// overlay wins, unless the combine argument was true and not overridden,
// or state.overlay.combineTokens was true, in which case the styles are
// combined.
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.overlayMode = function(base, overlay, combine) {
        return {
            startState: function startState() {
                return {
                    base: CodeMirror1.startState(base),
                    overlay: CodeMirror1.startState(overlay),
                    basePos: 0,
                    baseCur: null,
                    overlayPos: 0,
                    overlayCur: null,
                    streamSeen: null
                };
            },
            copyState: function copyState(state) {
                return {
                    base: CodeMirror1.copyState(base, state.base),
                    overlay: CodeMirror1.copyState(overlay, state.overlay),
                    basePos: state.basePos,
                    baseCur: null,
                    overlayPos: state.overlayPos,
                    overlayCur: null
                };
            },
            token: function token(stream, state) {
                if (stream != state.streamSeen || Math.min(state.basePos, state.overlayPos) < stream.start) {
                    state.streamSeen = stream;
                    state.basePos = state.overlayPos = stream.start;
                }
                if (stream.start == state.basePos) {
                    state.baseCur = base.token(stream, state.base);
                    state.basePos = stream.pos;
                }
                if (stream.start == state.overlayPos) {
                    stream.pos = stream.start;
                    state.overlayCur = overlay.token(stream, state.overlay);
                    state.overlayPos = stream.pos;
                }
                stream.pos = Math.min(state.basePos, state.overlayPos);
                // state.overlay.combineTokens always takes precedence over combine,
                // unless set to null
                if (state.overlayCur == null) return state.baseCur;
                else if (state.baseCur != null && state.overlay.combineTokens || combine && state.overlay.combineTokens == null) return state.baseCur + " " + state.overlayCur;
                else return state.overlayCur;
            },
            indent: base.indent && function(state, textAfter, line) {
                return base.indent(state.base, textAfter, line);
            },
            electricChars: base.electricChars,
            innerMode: function innerMode(state) {
                return {
                    state: state.base,
                    mode: base
                };
            },
            blankLine: function blankLine(state) {
                var baseToken, overlayToken;
                if (base.blankLine) baseToken = base.blankLine(state.base);
                if (overlay.blankLine) overlayToken = overlay.blankLine(state.overlay);
                return overlayToken == null ? baseToken : combine && baseToken != null ? baseToken + " " + overlayToken : overlayToken;
            }
        };
    };
});
});

var coffeescript = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
/**
 * Link to the project's GitHub page:
 * https://github.com/pickhardt/coffeescript-codemirror-mode
 */ (function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("coffeescript", function(conf, parserConf) {
        var wordRegexp = function wordRegexp(words) {
            return new RegExp("^((" + words.join(")|(") + "))\\b");
        };
        var tokenBase = // Tokenizers
        function tokenBase(stream, state) {
            // Handle scope changes
            if (stream.sol()) {
                if (state.scope.align === null) state.scope.align = false;
                var scopeOffset = state.scope.offset;
                if (stream.eatSpace()) {
                    var lineOffset = stream.indentation();
                    if (lineOffset > scopeOffset && state.scope.type == "coffee") {
                        return "indent";
                    } else if (lineOffset < scopeOffset) {
                        return "dedent";
                    }
                    return null;
                } else {
                    if (scopeOffset > 0) {
                        dedent(stream, state);
                    }
                }
            }
            if (stream.eatSpace()) {
                return null;
            }
            var ch = stream.peek();
            // Handle docco title comment (single line)
            if (stream.match("####")) {
                stream.skipToEnd();
                return "comment";
            }
            // Handle multi line comments
            if (stream.match("###")) {
                state.tokenize = longComment;
                return state.tokenize(stream, state);
            }
            // Single line comment
            if (ch === "#") {
                stream.skipToEnd();
                return "comment";
            }
            // Handle number literals
            if (stream.match(/^-?[0-9\.]/, false)) {
                var floatLiteral = false;
                // Floats
                if (stream.match(/^-?\d*\.\d+(e[\+\-]?\d+)?/i)) {
                    floatLiteral = true;
                }
                if (stream.match(/^-?\d+\.\d*/)) {
                    floatLiteral = true;
                }
                if (stream.match(/^-?\.\d+/)) {
                    floatLiteral = true;
                }
                if (floatLiteral) {
                    // prevent from getting extra . on 1..
                    if (stream.peek() == ".") {
                        stream.backUp(1);
                    }
                    return "number";
                }
                // Integers
                var intLiteral = false;
                // Hex
                if (stream.match(/^-?0x[0-9a-f]+/i)) {
                    intLiteral = true;
                }
                // Decimal
                if (stream.match(/^-?[1-9]\d*(e[\+\-]?\d+)?/)) {
                    intLiteral = true;
                }
                // Zero by itself with no other piece of number.
                if (stream.match(/^-?0(?![\dx])/i)) {
                    intLiteral = true;
                }
                if (intLiteral) {
                    return "number";
                }
            }
            // Handle strings
            if (stream.match(stringPrefixes)) {
                state.tokenize = tokenFactory(stream.current(), false, "string");
                return state.tokenize(stream, state);
            }
            // Handle regex literals
            if (stream.match(regexPrefixes)) {
                if (stream.current() != "/" || stream.match(/^.*\//, false)) {
                    state.tokenize = tokenFactory(stream.current(), true, "string-2");
                    return state.tokenize(stream, state);
                } else {
                    stream.backUp(1);
                }
            }
            // Handle operators and delimiters
            if (stream.match(operators) || stream.match(wordOperators)) {
                return "operator";
            }
            if (stream.match(delimiters)) {
                return "punctuation";
            }
            if (stream.match(constants)) {
                return "atom";
            }
            if (stream.match(atProp) || state.prop && stream.match(identifiers)) {
                return "property";
            }
            if (stream.match(keywords)) {
                return "keyword";
            }
            if (stream.match(identifiers)) {
                return "variable";
            }
            // Handle non-detected items
            stream.next();
            return ERRORCLASS;
        };
        var tokenFactory = function tokenFactory(delimiter, singleline, outclass) {
            return function(stream, state) {
                while(!stream.eol()){
                    stream.eatWhile(/[^'"\/\\]/);
                    if (stream.eat("\\")) {
                        stream.next();
                        if (singleline && stream.eol()) {
                            return outclass;
                        }
                    } else if (stream.match(delimiter)) {
                        state.tokenize = tokenBase;
                        return outclass;
                    } else {
                        stream.eat(/['"\/]/);
                    }
                }
                if (singleline) {
                    if (parserConf.singleLineStringErrors) {
                        outclass = ERRORCLASS;
                    } else {
                        state.tokenize = tokenBase;
                    }
                }
                return outclass;
            };
        };
        var longComment = function longComment(stream, state) {
            while(!stream.eol()){
                stream.eatWhile(/[^#]/);
                if (stream.match("###")) {
                    state.tokenize = tokenBase;
                    break;
                }
                stream.eatWhile("#");
            }
            return "comment";
        };
        var indent = function indent(stream, state, type) {
            type = type || "coffee";
            var offset = 0, align = false, alignOffset = null;
            for(var scope = state.scope; scope; scope = scope.prev){
                if (scope.type === "coffee" || scope.type == "}") {
                    offset = scope.offset + conf.indentUnit;
                    break;
                }
            }
            if (type !== "coffee") {
                align = null;
                alignOffset = stream.column() + stream.current().length;
            } else if (state.scope.align) {
                state.scope.align = false;
            }
            state.scope = {
                offset: offset,
                type: type,
                prev: state.scope,
                align: align,
                alignOffset: alignOffset
            };
        };
        var dedent = function dedent(stream, state) {
            if (!state.scope.prev) return;
            if (state.scope.type === "coffee") {
                var _indent = stream.indentation();
                var matched = false;
                for(var scope = state.scope; scope; scope = scope.prev){
                    if (_indent === scope.offset) {
                        matched = true;
                        break;
                    }
                }
                if (!matched) {
                    return true;
                }
                while(state.scope.prev && state.scope.offset !== _indent){
                    state.scope = state.scope.prev;
                }
                return false;
            } else {
                state.scope = state.scope.prev;
                return false;
            }
        };
        var tokenLexer = function tokenLexer(stream, state) {
            var style = state.tokenize(stream, state);
            var current = stream.current();
            // Handle scope changes.
            if (current === "return") {
                state.dedent = true;
            }
            if ((current === "->" || current === "=>") && stream.eol() || style === "indent") {
                indent(stream, state);
            }
            var delimiter_index = "[({".indexOf(current);
            if (delimiter_index !== -1) {
                indent(stream, state, "])}".slice(delimiter_index, delimiter_index + 1));
            }
            if (indentKeywords.exec(current)) {
                indent(stream, state);
            }
            if (current == "then") {
                dedent(stream, state);
            }
            if (style === "dedent") {
                if (dedent(stream, state)) {
                    return ERRORCLASS;
                }
            }
            delimiter_index = "])}".indexOf(current);
            if (delimiter_index !== -1) {
                while(state.scope.type == "coffee" && state.scope.prev)state.scope = state.scope.prev;
                if (state.scope.type == current) state.scope = state.scope.prev;
            }
            if (state.dedent && stream.eol()) {
                if (state.scope.type == "coffee" && state.scope.prev) state.scope = state.scope.prev;
                state.dedent = false;
            }
            return style;
        };
        var ERRORCLASS = "error";
        var operators = /^(?:->|=>|\+[+=]?|-[\-=]?|\*[\*=]?|\/[\/=]?|[=!]=|<[><]?=?|>>?=?|%=?|&=?|\|=?|\^=?|\~|!|\?|(or|and|\|\||&&|\?)=)/;
        var delimiters = /^(?:[()\[\]{},:`=;]|\.\.?\.?)/;
        var identifiers = /^[_A-Za-z$][_A-Za-z$0-9]*/;
        var atProp = /^@[_A-Za-z$][_A-Za-z$0-9]*/;
        var wordOperators = wordRegexp([
            "and",
            "or",
            "not",
            "is",
            "isnt",
            "in",
            "instanceof",
            "typeof"
        ]);
        var indentKeywords = [
            "for",
            "while",
            "loop",
            "if",
            "unless",
            "else",
            "switch",
            "try",
            "catch",
            "finally",
            "class"
        ];
        var commonKeywords = [
            "break",
            "by",
            "continue",
            "debugger",
            "delete",
            "do",
            "in",
            "of",
            "new",
            "return",
            "then",
            "this",
            "@",
            "throw",
            "when",
            "until",
            "extends"
        ];
        var keywords = wordRegexp(indentKeywords.concat(commonKeywords));
        indentKeywords = wordRegexp(indentKeywords);
        var stringPrefixes = /^('{3}|\"{3}|['\"])/;
        var regexPrefixes = /^(\/{3}|\/)/;
        var commonConstants = [
            "Infinity",
            "NaN",
            "undefined",
            "null",
            "true",
            "false",
            "on",
            "off",
            "yes",
            "no"
        ];
        var constants = wordRegexp(commonConstants);
        var external = {
            startState: function startState(basecolumn) {
                return {
                    tokenize: tokenBase,
                    scope: {
                        offset: basecolumn || 0,
                        type: "coffee",
                        prev: null,
                        align: false
                    },
                    prop: false,
                    dedent: 0
                };
            },
            token: function token(stream, state) {
                var fillAlign = state.scope.align === null && state.scope;
                if (fillAlign && stream.sol()) fillAlign.align = false;
                var style = tokenLexer(stream, state);
                if (style && style != "comment") {
                    if (fillAlign) fillAlign.align = true;
                    state.prop = style == "punctuation" && stream.current() == ".";
                }
                return style;
            },
            indent: function indent(state, text) {
                if (state.tokenize != tokenBase) return 0;
                var scope = state.scope;
                var closer = text && "])}".indexOf(text.charAt(0)) > -1;
                if (closer) while(scope.type == "coffee" && scope.prev)scope = scope.prev;
                var closes = closer && scope.type === text.charAt(0);
                if (scope.align) return scope.alignOffset - (closes ? 1 : 0);
                else return (closes ? scope.prev : scope).offset;
            },
            lineComment: "#",
            fold: "indent"
        };
        return external;
    });
    // IANA registered media type
    // https://www.iana.org/assignments/media-types/
    CodeMirror1.defineMIME("application/vnd.coffeescript", "coffeescript");
    CodeMirror1.defineMIME("text/x-coffeescript", "coffeescript");
    CodeMirror1.defineMIME("text/coffeescript", "coffeescript");
});
});

var pug = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, javascript, css, htmlmixed);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("pug", function(config) {
        var State = function State() {
            this.javaScriptLine = false;
            this.javaScriptLineExcludesColon = false;
            this.javaScriptArguments = false;
            this.javaScriptArgumentsDepth = 0;
            this.isInterpolating = false;
            this.interpolationNesting = 0;
            this.jsState = CodeMirror1.startState(jsMode);
            this.restOfLine = "";
            this.isIncludeFiltered = false;
            this.isEach = false;
            this.lastTag = "";
            this.scriptType = "";
            // Attributes Mode
            this.isAttrs = false;
            this.attrsNest = [];
            this.inAttributeName = true;
            this.attributeIsType = false;
            this.attrValue = "";
            // Indented Mode
            this.indentOf = Infinity;
            this.indentToken = "";
            this.innerMode = null;
            this.innerState = null;
            this.innerModeForLine = false;
        };
        var javaScript = function javaScript(stream, state) {
            if (stream.sol()) {
                // if javaScriptLine was set at end of line, ignore it
                state.javaScriptLine = false;
                state.javaScriptLineExcludesColon = false;
            }
            if (state.javaScriptLine) {
                if (state.javaScriptLineExcludesColon && stream.peek() === ":") {
                    state.javaScriptLine = false;
                    state.javaScriptLineExcludesColon = false;
                    return;
                }
                var tok = jsMode.token(stream, state.jsState);
                if (stream.eol()) state.javaScriptLine = false;
                return tok || true;
            }
        };
        var javaScriptArguments = function javaScriptArguments(stream, state) {
            if (state.javaScriptArguments) {
                if (state.javaScriptArgumentsDepth === 0 && stream.peek() !== "(") {
                    state.javaScriptArguments = false;
                    return;
                }
                if (stream.peek() === "(") {
                    state.javaScriptArgumentsDepth++;
                } else if (stream.peek() === ")") {
                    state.javaScriptArgumentsDepth--;
                }
                if (state.javaScriptArgumentsDepth === 0) {
                    state.javaScriptArguments = false;
                    return;
                }
                var tok = jsMode.token(stream, state.jsState);
                return tok || true;
            }
        };
        var yieldStatement = function yieldStatement(stream) {
            if (stream.match(/^yield\b/)) {
                return "keyword";
            }
        };
        var doctype = function doctype(stream) {
            if (stream.match(/^(?:doctype) *([^\n]+)?/)) {
                return DOCTYPE;
            }
        };
        var interpolation = function interpolation(stream, state) {
            if (stream.match("#{")) {
                state.isInterpolating = true;
                state.interpolationNesting = 0;
                return "punctuation";
            }
        };
        var interpolationContinued = function interpolationContinued(stream, state) {
            if (state.isInterpolating) {
                if (stream.peek() === "}") {
                    state.interpolationNesting--;
                    if (state.interpolationNesting < 0) {
                        stream.next();
                        state.isInterpolating = false;
                        return "punctuation";
                    }
                } else if (stream.peek() === "{") {
                    state.interpolationNesting++;
                }
                return jsMode.token(stream, state.jsState) || true;
            }
        };
        var caseStatement = function caseStatement(stream, state) {
            if (stream.match(/^case\b/)) {
                state.javaScriptLine = true;
                return KEYWORD;
            }
        };
        var when = function when(stream, state) {
            if (stream.match(/^when\b/)) {
                state.javaScriptLine = true;
                state.javaScriptLineExcludesColon = true;
                return KEYWORD;
            }
        };
        var defaultStatement = function defaultStatement(stream) {
            if (stream.match(/^default\b/)) {
                return KEYWORD;
            }
        };
        var extendsStatement = function extendsStatement(stream, state) {
            if (stream.match(/^extends?\b/)) {
                state.restOfLine = "string";
                return KEYWORD;
            }
        };
        var append = function append(stream, state) {
            if (stream.match(/^append\b/)) {
                state.restOfLine = "variable";
                return KEYWORD;
            }
        };
        var prepend = function prepend(stream, state) {
            if (stream.match(/^prepend\b/)) {
                state.restOfLine = "variable";
                return KEYWORD;
            }
        };
        var block = function block(stream, state) {
            if (stream.match(/^block\b *(?:(prepend|append)\b)?/)) {
                state.restOfLine = "variable";
                return KEYWORD;
            }
        };
        var include = function include(stream, state) {
            if (stream.match(/^include\b/)) {
                state.restOfLine = "string";
                return KEYWORD;
            }
        };
        var includeFiltered = function includeFiltered(stream, state) {
            if (stream.match(/^include:([a-zA-Z0-9\-]+)/, false) && stream.match("include")) {
                state.isIncludeFiltered = true;
                return KEYWORD;
            }
        };
        var includeFilteredContinued = function includeFilteredContinued(stream, state) {
            if (state.isIncludeFiltered) {
                var tok = filter(stream, state);
                state.isIncludeFiltered = false;
                state.restOfLine = "string";
                return tok;
            }
        };
        var mixin = function mixin(stream, state) {
            if (stream.match(/^mixin\b/)) {
                state.javaScriptLine = true;
                return KEYWORD;
            }
        };
        var call = function call(stream, state) {
            if (stream.match(/^\+([-\w]+)/)) {
                if (!stream.match(/^\( *[-\w]+ *=/, false)) {
                    state.javaScriptArguments = true;
                    state.javaScriptArgumentsDepth = 0;
                }
                return "variable";
            }
            if (stream.match("+#{", false)) {
                stream.next();
                state.mixinCallAfter = true;
                return interpolation(stream, state);
            }
        };
        var callArguments = function callArguments(stream, state) {
            if (state.mixinCallAfter) {
                state.mixinCallAfter = false;
                if (!stream.match(/^\( *[-\w]+ *=/, false)) {
                    state.javaScriptArguments = true;
                    state.javaScriptArgumentsDepth = 0;
                }
                return true;
            }
        };
        var conditional = function conditional(stream, state) {
            if (stream.match(/^(if|unless|else if|else)\b/)) {
                state.javaScriptLine = true;
                return KEYWORD;
            }
        };
        var each = function each(stream, state) {
            if (stream.match(/^(- *)?(each|for)\b/)) {
                state.isEach = true;
                return KEYWORD;
            }
        };
        var eachContinued = function eachContinued(stream, state) {
            if (state.isEach) {
                if (stream.match(/^ in\b/)) {
                    state.javaScriptLine = true;
                    state.isEach = false;
                    return KEYWORD;
                } else if (stream.sol() || stream.eol()) {
                    state.isEach = false;
                } else if (stream.next()) {
                    while(!stream.match(/^ in\b/, false) && stream.next());
                    return "variable";
                }
            }
        };
        var whileStatement = function whileStatement(stream, state) {
            if (stream.match(/^while\b/)) {
                state.javaScriptLine = true;
                return KEYWORD;
            }
        };
        var tag = function tag(stream, state) {
            var captures;
            if (captures = stream.match(/^(\w(?:[-:\w]*\w)?)\/?/)) {
                state.lastTag = captures[1].toLowerCase();
                if (state.lastTag === "script") {
                    state.scriptType = "application/javascript";
                }
                return "tag";
            }
        };
        var filter = function filter(stream, state) {
            if (stream.match(/^:([\w\-]+)/)) {
                var innerMode;
                if (config && config.innerModes) {
                    innerMode = config.innerModes(stream.current().substring(1));
                }
                if (!innerMode) {
                    innerMode = stream.current().substring(1);
                }
                if (typeof innerMode === "string") {
                    innerMode = CodeMirror1.getMode(config, innerMode);
                }
                setInnerMode(stream, state, innerMode);
                return "atom";
            }
        };
        var code = function code(stream, state) {
            if (stream.match(/^(!?=|-)/)) {
                state.javaScriptLine = true;
                return "punctuation";
            }
        };
        var id = function id(stream) {
            if (stream.match(/^#([\w-]+)/)) {
                return ID;
            }
        };
        var className = function className(stream) {
            if (stream.match(/^\.([\w-]+)/)) {
                return CLASS;
            }
        };
        var attrs = function attrs(stream, state) {
            if (stream.peek() == "(") {
                stream.next();
                state.isAttrs = true;
                state.attrsNest = [];
                state.inAttributeName = true;
                state.attrValue = "";
                state.attributeIsType = false;
                return "punctuation";
            }
        };
        var attributesBlock = function attributesBlock(stream, state) {
            if (stream.match(/^&attributes\b/)) {
                state.javaScriptArguments = true;
                state.javaScriptArgumentsDepth = 0;
                return "keyword";
            }
        };
        var indent = function indent(stream) {
            if (stream.sol() && stream.eatSpace()) {
                return "indent";
            }
        };
        var comment = function comment(stream, state) {
            if (stream.match(/^ *\/\/(-)?([^\n]*)/)) {
                state.indentOf = stream.indentation();
                state.indentToken = "comment";
                return "comment";
            }
        };
        var colon = function colon(stream) {
            if (stream.match(/^: */)) {
                return "colon";
            }
        };
        var text = function text(stream, state) {
            if (stream.match(/^(?:\| ?| )([^\n]+)/)) {
                return "string";
            }
            if (stream.match(/^(<[^\n]*)/, false)) {
                // html string
                setInnerMode(stream, state, "htmlmixed");
                state.innerModeForLine = true;
                return innerMode(stream, state, true);
            }
        };
        var dot = function dot(stream, state) {
            if (stream.eat(".")) {
                var innerMode = null;
                if (state.lastTag === "script" && state.scriptType.toLowerCase().indexOf("javascript") != -1) {
                    innerMode = state.scriptType.toLowerCase().replace(/"|'/g, "");
                } else if (state.lastTag === "style") {
                    innerMode = "css";
                }
                setInnerMode(stream, state, innerMode);
                return "dot";
            }
        };
        var fail = function fail(stream) {
            stream.next();
            return null;
        };
        var setInnerMode = function setInnerMode(stream, state, mode) {
            mode = CodeMirror1.mimeModes[mode] || mode;
            mode = config.innerModes ? config.innerModes(mode) || mode : mode;
            mode = CodeMirror1.mimeModes[mode] || mode;
            mode = CodeMirror1.getMode(config, mode);
            state.indentOf = stream.indentation();
            if (mode && mode.name !== "null") {
                state.innerMode = mode;
            } else {
                state.indentToken = "string";
            }
        };
        var innerMode = function innerMode(stream, state, force) {
            if (stream.indentation() > state.indentOf || state.innerModeForLine && !stream.sol() || force) {
                if (state.innerMode) {
                    if (!state.innerState) {
                        state.innerState = state.innerMode.startState ? CodeMirror1.startState(state.innerMode, stream.indentation()) : {};
                    }
                    return stream.hideFirstChars(state.indentOf + 2, function() {
                        return state.innerMode.token(stream, state.innerState) || true;
                    });
                } else {
                    stream.skipToEnd();
                    return state.indentToken;
                }
            } else if (stream.sol()) {
                state.indentOf = Infinity;
                state.indentToken = null;
                state.innerMode = null;
                state.innerState = null;
            }
        };
        var restOfLine = function restOfLine(stream, state) {
            if (stream.sol()) {
                // if restOfLine was set at end of line, ignore it
                state.restOfLine = "";
            }
            if (state.restOfLine) {
                stream.skipToEnd();
                var tok = state.restOfLine;
                state.restOfLine = "";
                return tok;
            }
        };
        var startState = function startState() {
            return new State();
        };
        var copyState = function copyState(state) {
            return state.copy();
        };
        var nextToken = /**
   * Get the next token in the stream
   *
   * @param {Stream} stream
   * @param {State} state
   */ function nextToken(stream, state) {
            var tok = innerMode(stream, state) || restOfLine(stream, state) || interpolationContinued(stream, state) || includeFilteredContinued(stream, state) || eachContinued(stream, state) || attrsContinued(stream, state) || javaScript(stream, state) || javaScriptArguments(stream, state) || callArguments(stream, state) || yieldStatement(stream) || doctype(stream) || interpolation(stream, state) || caseStatement(stream, state) || when(stream, state) || defaultStatement(stream) || extendsStatement(stream, state) || append(stream, state) || prepend(stream, state) || block(stream, state) || include(stream, state) || includeFiltered(stream, state) || mixin(stream, state) || call(stream, state) || conditional(stream, state) || each(stream, state) || whileStatement(stream, state) || tag(stream, state) || filter(stream, state) || code(stream, state) || id(stream) || className(stream) || attrs(stream, state) || attributesBlock(stream, state) || indent(stream) || text(stream, state) || comment(stream, state) || colon(stream) || dot(stream, state) || fail(stream);
            return tok === true ? null : tok;
        };
        // token types
        var KEYWORD = "keyword";
        var DOCTYPE = "meta";
        var ID = "builtin";
        var CLASS = "qualifier";
        var ATTRS_NEST = {
            "{": "}",
            "(": ")",
            "[": "]"
        };
        var jsMode = CodeMirror1.getMode(config, "javascript");
        /**
   * Safely copy a state
   *
   * @return {State}
   */ State.prototype.copy = function() {
            var res = new State();
            res.javaScriptLine = this.javaScriptLine;
            res.javaScriptLineExcludesColon = this.javaScriptLineExcludesColon;
            res.javaScriptArguments = this.javaScriptArguments;
            res.javaScriptArgumentsDepth = this.javaScriptArgumentsDepth;
            res.isInterpolating = this.isInterpolating;
            res.interpolationNesting = this.interpolationNesting;
            res.jsState = CodeMirror1.copyState(jsMode, this.jsState);
            res.innerMode = this.innerMode;
            if (this.innerMode && this.innerState) {
                res.innerState = CodeMirror1.copyState(this.innerMode, this.innerState);
            }
            res.restOfLine = this.restOfLine;
            res.isIncludeFiltered = this.isIncludeFiltered;
            res.isEach = this.isEach;
            res.lastTag = this.lastTag;
            res.scriptType = this.scriptType;
            res.isAttrs = this.isAttrs;
            res.attrsNest = this.attrsNest.slice();
            res.inAttributeName = this.inAttributeName;
            res.attributeIsType = this.attributeIsType;
            res.attrValue = this.attrValue;
            res.indentOf = this.indentOf;
            res.indentToken = this.indentToken;
            res.innerModeForLine = this.innerModeForLine;
            return res;
        };
        function attrsContinued(stream, state) {
            if (state.isAttrs) {
                if (ATTRS_NEST[stream.peek()]) {
                    state.attrsNest.push(ATTRS_NEST[stream.peek()]);
                }
                if (state.attrsNest[state.attrsNest.length - 1] === stream.peek()) {
                    state.attrsNest.pop();
                } else if (stream.eat(")")) {
                    state.isAttrs = false;
                    return "punctuation";
                }
                if (state.inAttributeName && stream.match(/^[^=,\)!]+/)) {
                    if (stream.peek() === "=" || stream.peek() === "!") {
                        state.inAttributeName = false;
                        state.jsState = CodeMirror1.startState(jsMode);
                        if (state.lastTag === "script" && stream.current().trim().toLowerCase() === "type") {
                            state.attributeIsType = true;
                        } else {
                            state.attributeIsType = false;
                        }
                    }
                    return "attribute";
                }
                var tok = jsMode.token(stream, state.jsState);
                if (state.attributeIsType && tok === "string") {
                    state.scriptType = stream.current().toString();
                }
                if (state.attrsNest.length === 0 && (tok === "string" || tok === "variable" || tok === "keyword")) {
                    try {
                        Function("", "var x " + state.attrValue.replace(/,\s*$/, "").replace(/^!/, ""));
                        state.inAttributeName = true;
                        state.attrValue = "";
                        stream.backUp(stream.current().length);
                        return attrsContinued(stream, state);
                    } catch (ex) {
                    //not the end of an attribute
                    }
                }
                state.attrValue += stream.current();
                return tok || true;
            }
        }
        return {
            startState: startState,
            copyState: copyState,
            token: nextToken
        };
    }, "javascript", "css", "htmlmixed");
    CodeMirror1.defineMIME("text/x-pug", "pug");
    CodeMirror1.defineMIME("text/x-jade", "pug");
});
});

var simple = createCommonjsModule(function (module, exports) {
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    var ensureState = function ensureState(states, name) {
        if (!states.hasOwnProperty(name)) throw new Error("Undefined state " + name + " in simple mode");
    };
    var toRegex = function toRegex(val, caret) {
        if (!val) return /(?:)/;
        var flags = "";
        if (_instanceof(val, RegExp)) {
            if (val.ignoreCase) flags = "i";
            if (val.unicode) flags += "u";
            val = val.source;
        } else {
            val = String(val);
        }
        return new RegExp((caret === false ? "" : "^") + "(?:" + val + ")", flags);
    };
    var asToken = function asToken(val) {
        if (!val) return null;
        if (val.apply) return val;
        if (typeof val == "string") return val.replace(/\./g, " ");
        var result = [];
        for(var i = 0; i < val.length; i++)result.push(val[i] && val[i].replace(/\./g, " "));
        return result;
    };
    var Rule = function Rule(data, states) {
        if (data.next || data.push) ensureState(states, data.next || data.push);
        this.regex = toRegex(data.regex);
        this.token = asToken(data.token);
        this.data = data;
    };
    var tokenFunction = function tokenFunction(states, config) {
        return function(stream, state) {
            if (state.pending) {
                var pend = state.pending.shift();
                if (state.pending.length == 0) state.pending = null;
                stream.pos += pend.text.length;
                return pend.token;
            }
            if (state.local) {
                if (state.local.end && stream.match(state.local.end)) {
                    var tok = state.local.endToken || null;
                    state.local = state.localState = null;
                    return tok;
                } else {
                    var tok = state.local.mode.token(stream, state.localState), m;
                    if (state.local.endScan && (m = state.local.endScan.exec(stream.current()))) stream.pos = stream.start + m.index;
                    return tok;
                }
            }
            var curState = states[state.state];
            for(var i = 0; i < curState.length; i++){
                var rule = curState[i];
                var matches = (!rule.data.sol || stream.sol()) && stream.match(rule.regex);
                if (matches) {
                    if (rule.data.next) {
                        state.state = rule.data.next;
                    } else if (rule.data.push) {
                        (state.stack || (state.stack = [])).push(state.state);
                        state.state = rule.data.push;
                    } else if (rule.data.pop && state.stack && state.stack.length) {
                        state.state = state.stack.pop();
                    }
                    if (rule.data.mode) enterLocalMode(config, state, rule.data.mode, rule.token);
                    if (rule.data.indent) state.indent.push(stream.indentation() + config.indentUnit);
                    if (rule.data.dedent) state.indent.pop();
                    var token = rule.token;
                    if (token && token.apply) token = token(matches);
                    if (matches.length > 2 && rule.token && typeof rule.token != "string") {
                        for(var j = 2; j < matches.length; j++)if (matches[j]) (state.pending || (state.pending = [])).push({
                            text: matches[j],
                            token: rule.token[j - 1]
                        });
                        stream.backUp(matches[0].length - (matches[1] ? matches[1].length : 0));
                        return token[0];
                    } else if (token && token.join) {
                        return token[0];
                    } else {
                        return token;
                    }
                }
            }
            stream.next();
            return null;
        };
    };
    var enterLocalMode = function enterLocalMode(config, state, spec, token) {
        var pers;
        if (spec.persistent) {
            for(var p = state.persistentStates; p && !pers; p = p.next)if (spec.spec ? cmp(spec.spec, p.spec) : spec.mode == p.mode) pers = p;
        }
        var mode = pers ? pers.mode : spec.mode || CodeMirror1.getMode(config, spec.spec);
        var lState = pers ? pers.state : CodeMirror1.startState(mode);
        if (spec.persistent && !pers) state.persistentStates = {
            mode: mode,
            spec: spec.spec,
            state: lState,
            next: state.persistentStates
        };
        state.localState = lState;
        state.local = {
            mode: mode,
            end: spec.end && toRegex(spec.end),
            endScan: spec.end && spec.forceEnd !== false && toRegex(spec.end, false),
            endToken: token && token.join ? token[token.length - 1] : token
        };
    };
    var indexOf = function indexOf(val, arr) {
        for(var i = 0; i < arr.length; i++)if (arr[i] === val) return true;
    };
    var indentFunction = function indentFunction(states, meta) {
        return function(state, textAfter, line) {
            if (state.local && state.local.mode.indent) return state.local.mode.indent(state.localState, textAfter, line);
            if (state.indent == null || state.local || meta.dontIndentStates && indexOf(state.state, meta.dontIndentStates) > -1) return CodeMirror1.Pass;
            var pos = state.indent.length - 1, rules = states[state.state];
            scan: for(;;){
                for(var i = 0; i < rules.length; i++){
                    var rule = rules[i];
                    if (rule.data.dedent && rule.data.dedentIfLineStart !== false) {
                        var m = rule.regex.exec(textAfter);
                        if (m && m[0]) {
                            pos--;
                            if (rule.next || rule.push) rules = states[rule.next || rule.push];
                            textAfter = textAfter.slice(m[0].length);
                            continue scan;
                        }
                    }
                }
                break;
            }
            return pos < 0 ? 0 : state.indent[pos];
        };
    };
    CodeMirror1.defineSimpleMode = function(name, states) {
        CodeMirror1.defineMode(name, function(config) {
            return CodeMirror1.simpleMode(config, states);
        });
    };
    CodeMirror1.simpleMode = function(config, states) {
        ensureState(states, "start");
        var states_ = {}, meta = states.meta || {}, hasIndentation = false;
        for(var state in states)if (state != meta && states.hasOwnProperty(state)) {
            var list = states_[state] = [], orig = states[state];
            for(var i = 0; i < orig.length; i++){
                var data = orig[i];
                list.push(new Rule(data, states));
                if (data.indent || data.dedent) hasIndentation = true;
            }
        }
        var mode = {
            startState: function startState() {
                return {
                    state: "start",
                    pending: null,
                    local: null,
                    localState: null,
                    indent: hasIndentation ? [] : null
                };
            },
            copyState: function copyState(state) {
                var s = {
                    state: state.state,
                    pending: state.pending,
                    local: state.local,
                    localState: null,
                    indent: state.indent && state.indent.slice(0)
                };
                if (state.localState) s.localState = CodeMirror1.copyState(state.local.mode, state.localState);
                if (state.stack) s.stack = state.stack.slice(0);
                for(var pers = state.persistentStates; pers; pers = pers.next)s.persistentStates = {
                    mode: pers.mode,
                    spec: pers.spec,
                    state: pers.state == state.localState ? s.localState : CodeMirror1.copyState(pers.mode, pers.state),
                    next: s.persistentStates
                };
                return s;
            },
            token: tokenFunction(states_, config),
            innerMode: function innerMode(state) {
                return state.local && {
                    mode: state.local.mode,
                    state: state.localState
                };
            },
            indent: indentFunction(states_, meta)
        };
        if (meta) {
            for(var prop in meta)if (meta.hasOwnProperty(prop)) mode[prop] = meta[prop];
        }
        return mode;
    };
    function cmp(a, b) {
        if (a === b) return true;
        if (!a || typeof a != "object" || !b || typeof b != "object") return false;
        var props = 0;
        for(var prop in a)if (a.hasOwnProperty(prop)) {
            if (!b.hasOwnProperty(prop) || !cmp(a[prop], b[prop])) return false;
            props++;
        }
        for(var prop in b)if (b.hasOwnProperty(prop)) props--;
        return props == 0;
    }
});
});

var multiplex = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.multiplexingMode = function(outer /*, others */ ) {
        var indexOf = function indexOf(string, pattern, from, returnEnd) {
            if (typeof pattern == "string") {
                var found = string.indexOf(pattern, from);
                return returnEnd && found > -1 ? found + pattern.length : found;
            }
            var m = pattern.exec(from ? string.slice(from) : string);
            return m ? m.index + from + (returnEnd ? m[0].length : 0) : -1;
        };
        // Others should be {open, close, mode [, delimStyle] [, innerStyle] [, parseDelimiters]} objects
        var others = Array.prototype.slice.call(arguments, 1);
        return {
            startState: function startState() {
                return {
                    outer: CodeMirror1.startState(outer),
                    innerActive: null,
                    inner: null,
                    startingInner: false
                };
            },
            copyState: function copyState(state) {
                return {
                    outer: CodeMirror1.copyState(outer, state.outer),
                    innerActive: state.innerActive,
                    inner: state.innerActive && CodeMirror1.copyState(state.innerActive.mode, state.inner),
                    startingInner: state.startingInner
                };
            },
            token: function token(stream, state) {
                if (!state.innerActive) {
                    var cutOff = Infinity, oldContent = stream.string;
                    for(var i = 0; i < others.length; ++i){
                        var other = others[i];
                        var found = indexOf(oldContent, other.open, stream.pos);
                        if (found == stream.pos) {
                            if (!other.parseDelimiters) stream.match(other.open);
                            state.startingInner = !!other.parseDelimiters;
                            state.innerActive = other;
                            // Get the outer indent, making sure to handle CodeMirror.Pass
                            var outerIndent = 0;
                            if (outer.indent) {
                                var possibleOuterIndent = outer.indent(state.outer, "", "");
                                if (possibleOuterIndent !== CodeMirror1.Pass) outerIndent = possibleOuterIndent;
                            }
                            state.inner = CodeMirror1.startState(other.mode, outerIndent);
                            return other.delimStyle && other.delimStyle + " " + other.delimStyle + "-open";
                        } else if (found != -1 && found < cutOff) {
                            cutOff = found;
                        }
                    }
                    if (cutOff != Infinity) stream.string = oldContent.slice(0, cutOff);
                    var outerToken = outer.token(stream, state.outer);
                    if (cutOff != Infinity) stream.string = oldContent;
                    return outerToken;
                } else {
                    var curInner = state.innerActive, oldContent = stream.string;
                    if (!curInner.close && stream.sol()) {
                        state.innerActive = state.inner = null;
                        return this.token(stream, state);
                    }
                    var found = curInner.close && !state.startingInner ? indexOf(oldContent, curInner.close, stream.pos, curInner.parseDelimiters) : -1;
                    if (found == stream.pos && !curInner.parseDelimiters) {
                        stream.match(curInner.close);
                        state.innerActive = state.inner = null;
                        return curInner.delimStyle && curInner.delimStyle + " " + curInner.delimStyle + "-close";
                    }
                    if (found > -1) stream.string = oldContent.slice(0, found);
                    var innerToken = curInner.mode.token(stream, state.inner);
                    if (found > -1) stream.string = oldContent;
                    else if (stream.pos > stream.start) state.startingInner = false;
                    if (found == stream.pos && curInner.parseDelimiters) state.innerActive = state.inner = null;
                    if (curInner.innerStyle) {
                        if (innerToken) innerToken = innerToken + " " + curInner.innerStyle;
                        else innerToken = curInner.innerStyle;
                    }
                    return innerToken;
                }
            },
            indent: function indent(state, textAfter, line) {
                var mode = state.innerActive ? state.innerActive.mode : outer;
                if (!mode.indent) return CodeMirror1.Pass;
                return mode.indent(state.innerActive ? state.inner : state.outer, textAfter, line);
            },
            blankLine: function blankLine(state) {
                var mode = state.innerActive ? state.innerActive.mode : outer;
                if (mode.blankLine) {
                    mode.blankLine(state.innerActive ? state.inner : state.outer);
                }
                if (!state.innerActive) {
                    for(var i = 0; i < others.length; ++i){
                        var other = others[i];
                        if (other.open === "\n") {
                            state.innerActive = other;
                            state.inner = CodeMirror1.startState(other.mode, mode.indent ? mode.indent(state.outer, "", "") : 0);
                        }
                    }
                } else if (state.innerActive.close === "\n") {
                    state.innerActive = state.inner = null;
                }
            },
            electricChars: outer.electricChars,
            innerMode: function innerMode(state) {
                return state.inner ? {
                    state: state.inner,
                    mode: state.innerActive.mode
                } : {
                    state: state.outer,
                    mode: outer
                };
            }
        };
    };
});
});

var handlebars = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror, simple, multiplex);
})(function(CodeMirror1) {
    CodeMirror1.defineSimpleMode("handlebars-tags", {
        start: [
            {
                regex: /\{\{\{/,
                push: "handlebars_raw",
                token: "tag"
            },
            {
                regex: /\{\{!--/,
                push: "dash_comment",
                token: "comment"
            },
            {
                regex: /\{\{!/,
                push: "comment",
                token: "comment"
            },
            {
                regex: /\{\{/,
                push: "handlebars",
                token: "tag"
            }
        ],
        handlebars_raw: [
            {
                regex: /\}\}\}/,
                pop: true,
                token: "tag"
            }
        ],
        handlebars: [
            {
                regex: /\}\}/,
                pop: true,
                token: "tag"
            },
            // Double and single quotes
            {
                regex: /"(?:[^\\"]|\\.)*"?/,
                token: "string"
            },
            {
                regex: /'(?:[^\\']|\\.)*'?/,
                token: "string"
            },
            // Handlebars keywords
            {
                regex: />|[#\/]([A-Za-z_]\w*)/,
                token: "keyword"
            },
            {
                regex: /(?:else|this)\b/,
                token: "keyword"
            },
            // Numeral
            {
                regex: /\d+/i,
                token: "number"
            },
            // Atoms like = and .
            {
                regex: /=|~|@|true|false/,
                token: "atom"
            },
            // Paths
            {
                regex: /(?:\.\.\/)*(?:[A-Za-z_][\w\.]*)+/,
                token: "variable-2"
            }
        ],
        dash_comment: [
            {
                regex: /--\}\}/,
                pop: true,
                token: "comment"
            },
            // Commented code
            {
                regex: /./,
                token: "comment"
            }
        ],
        comment: [
            {
                regex: /\}\}/,
                pop: true,
                token: "comment"
            },
            {
                regex: /./,
                token: "comment"
            }
        ],
        meta: {
            blockCommentStart: "{{--",
            blockCommentEnd: "--}}"
        }
    });
    CodeMirror1.defineMode("handlebars", function(config, parserConfig) {
        var handlebars = CodeMirror1.getMode(config, "handlebars-tags");
        if (!parserConfig || !parserConfig.base) return handlebars;
        return CodeMirror1.multiplexingMode(CodeMirror1.getMode(config, parserConfig.base), {
            open: "{{",
            close: /\}\}\}?/,
            mode: handlebars,
            parseDelimiters: true
        });
    });
    CodeMirror1.defineMIME("text/x-handlebars-template", "handlebars");
});
});

var vue = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    {
        mod(codemirror, overlay, xml, javascript, coffeescript, css, sass, stylus, pug, handlebars);
    }
})(function(CodeMirror1) {
    var tagLanguages = {
        script: [
            [
                "lang",
                /coffee(script)?/,
                "coffeescript"
            ],
            [
                "type",
                /^(?:text|application)\/(?:x-)?coffee(?:script)?$/,
                "coffeescript"
            ],
            [
                "lang",
                /^babel$/,
                "javascript"
            ],
            [
                "type",
                /^text\/babel$/,
                "javascript"
            ],
            [
                "type",
                /^text\/ecmascript-\d+$/,
                "javascript"
            ]
        ],
        style: [
            [
                "lang",
                /^stylus$/i,
                "stylus"
            ],
            [
                "lang",
                /^sass$/i,
                "sass"
            ],
            [
                "lang",
                /^less$/i,
                "text/x-less"
            ],
            [
                "lang",
                /^scss$/i,
                "text/x-scss"
            ],
            [
                "type",
                /^(text\/)?(x-)?styl(us)?$/i,
                "stylus"
            ],
            [
                "type",
                /^text\/sass/i,
                "sass"
            ],
            [
                "type",
                /^(text\/)?(x-)?scss$/i,
                "text/x-scss"
            ],
            [
                "type",
                /^(text\/)?(x-)?less$/i,
                "text/x-less"
            ]
        ],
        template: [
            [
                "lang",
                /^vue-template$/i,
                "vue"
            ],
            [
                "lang",
                /^pug$/i,
                "pug"
            ],
            [
                "lang",
                /^handlebars$/i,
                "handlebars"
            ],
            [
                "type",
                /^(text\/)?(x-)?pug$/i,
                "pug"
            ],
            [
                "type",
                /^text\/x-handlebars-template$/i,
                "handlebars"
            ],
            [
                null,
                null,
                "vue-template"
            ]
        ]
    };
    CodeMirror1.defineMode("vue-template", function(config, parserConfig) {
        var mustacheOverlay = {
            token: function token(stream) {
                if (stream.match(/^\{\{.*?\}\}/)) return "meta mustache";
                while(stream.next() && !stream.match("{{", false)){}
                return null;
            }
        };
        return CodeMirror1.overlayMode(CodeMirror1.getMode(config, parserConfig.backdrop || "text/html"), mustacheOverlay);
    });
    CodeMirror1.defineMode("vue", function(config) {
        return CodeMirror1.getMode(config, {
            name: "htmlmixed",
            tags: tagLanguages
        });
    }, "htmlmixed", "xml", "javascript", "coffeescript", "css", "sass", "stylus", "pug", "handlebars");
    CodeMirror1.defineMIME("script/x-vue", "vue");
    CodeMirror1.defineMIME("text/x-vue", "vue");
});
});

var yaml = createCommonjsModule(function (module, exports) {
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
(function(mod) {
    mod(codemirror);
})(function(CodeMirror1) {
    CodeMirror1.defineMode("yaml", function() {
        var cons = [
            "true",
            "false",
            "on",
            "off",
            "yes",
            "no"
        ];
        var keywordRegex = new RegExp("\\b((" + cons.join(")|(") + "))$", "i");
        return {
            token: function token(stream, state) {
                var ch = stream.peek();
                var esc = state.escaped;
                state.escaped = false;
                /* comments */ if (ch == "#" && (stream.pos == 0 || /\s/.test(stream.string.charAt(stream.pos - 1)))) {
                    stream.skipToEnd();
                    return "comment";
                }
                if (stream.match(/^('([^']|\\.)*'?|"([^"]|\\.)*"?)/)) return "string";
                if (state.literal && stream.indentation() > state.keyCol) {
                    stream.skipToEnd();
                    return "string";
                } else if (state.literal) {
                    state.literal = false;
                }
                if (stream.sol()) {
                    state.keyCol = 0;
                    state.pair = false;
                    state.pairStart = false;
                    /* document start */ if (stream.match("---")) {
                        return "def";
                    }
                    /* document end */ if (stream.match("...")) {
                        return "def";
                    }
                    /* array list item */ if (stream.match(/\s*-\s+/)) {
                        return "meta";
                    }
                }
                /* inline pairs/lists */ if (stream.match(/^(\{|\}|\[|\])/)) {
                    if (ch == "{") state.inlinePairs++;
                    else if (ch == "}") state.inlinePairs--;
                    else if (ch == "[") state.inlineList++;
                    else state.inlineList--;
                    return "meta";
                }
                /* list separator */ if (state.inlineList > 0 && !esc && ch == ",") {
                    stream.next();
                    return "meta";
                }
                /* pairs separator */ if (state.inlinePairs > 0 && !esc && ch == ",") {
                    state.keyCol = 0;
                    state.pair = false;
                    state.pairStart = false;
                    stream.next();
                    return "meta";
                }
                /* start of value of a pair */ if (state.pairStart) {
                    /* block literals */ if (stream.match(/^\s*(\||\>)\s*/)) {
                        state.literal = true;
                        return "meta";
                    }
                    /* references */ if (stream.match(/^\s*(\&|\*)[a-z0-9\._-]+\b/i)) {
                        return "variable-2";
                    }
                    /* numbers */ if (state.inlinePairs == 0 && stream.match(/^\s*-?[0-9\.\,]+\s?$/)) {
                        return "number";
                    }
                    if (state.inlinePairs > 0 && stream.match(/^\s*-?[0-9\.\,]+\s?(?=(,|}))/)) {
                        return "number";
                    }
                    /* keywords */ if (stream.match(keywordRegex)) {
                        return "keyword";
                    }
                }
                /* pairs (associative arrays) -> key */ if (!state.pair && stream.match(/^\s*(?:[,\[\]{}&*!|>'"%@`][^\s'":]|[^,\[\]{}#&*!|>'"%@`])[^#]*?(?=\s*:($|\s))/)) {
                    state.pair = true;
                    state.keyCol = stream.indentation();
                    return "atom";
                }
                if (state.pair && stream.match(/^:\s*/)) {
                    state.pairStart = true;
                    return "meta";
                }
                /* nothing found, continue */ state.pairStart = false;
                state.escaped = ch == "\\";
                stream.next();
                return null;
            },
            startState: function startState() {
                return {
                    pair: false,
                    pairStart: false,
                    keyCol: 0,
                    inlinePairs: 0,
                    inlineList: 0,
                    literal: false,
                    escaped: false
                };
            },
            lineComment: "#",
            fold: "indent"
        };
    });
    CodeMirror1.defineMIME("text/x-yaml", "yaml");
    CodeMirror1.defineMIME("text/yaml", "yaml");
});
});

var languages = [
    {
        name: "JavaScript",
        mimes: [
            "text/javascript",
            "text/ecmascript",
            "application/javascript",
            "application/x-javascript",
            "application/ecmascript"
        ],
        mode: "javascript",
        ext: [
            "js"
        ],
        alias: [
            "ecmascript",
            "js",
            "node"
        ]
    },
    {
        name: "Java",
        mime: "text/x-java",
        mode: "clike",
        ext: [
            "java"
        ]
    },
    {
        name: "JSON",
        mimes: [
            "application/json",
            "application/x-json"
        ],
        mode: "javascript",
        ext: [
            "json",
            "map"
        ],
        alias: [
            "json5"
        ]
    },
    {
        name: "Shell",
        mimes: [
            "text/x-sh",
            "application/x-sh"
        ],
        mode: "shell",
        ext: [
            "sh",
            "ksh",
            "bash"
        ],
        alias: [
            "bash",
            "sh",
            "zsh"
        ],
        file: /^PKGBUILD$/
    },
    {
        name: "HTML",
        mime: "text/html",
        mode: "htmlmixed",
        ext: [
            "html",
            "htm",
            "handlebars",
            "hbs"
        ],
        alias: [
            "xhtml"
        ]
    },
    {
        name: "Plain Text",
        mime: "text/plain",
        mode: "null",
        ext: [
            "txt",
            "text",
            "conf",
            "def",
            "list",
            "log"
        ]
    },
    {
        name: "C",
        mime: "text/x-csrc",
        mode: "clike",
        ext: [
            "c",
            "h",
            "ino"
        ]
    },
    {
        name: "C++",
        mime: "text/x-c++src",
        mode: "clike",
        ext: [
            "cpp",
            "c++",
            "cc",
            "cxx",
            "hpp",
            "h++",
            "hh",
            "hxx"
        ],
        alias: [
            "cpp"
        ]
    },
    {
        name: "C#",
        mime: "text/x-csharp",
        mode: "clike",
        ext: [
            "cs"
        ],
        alias: [
            "csharp"
        ]
    },
    {
        name: "CSS",
        mime: "text/css",
        mode: "css",
        ext: [
            "css"
        ]
    },
    {
        name: "Dart",
        mimes: [
            "application/dart",
            "text/x-dart"
        ],
        mode: "dart",
        ext: [
            "dart"
        ]
    },
    {
        name: "Elm",
        mime: "text/x-elm",
        mode: "elm",
        ext: [
            "elm"
        ]
    },
    {
        name: "Go",
        mime: "text/x-go",
        mode: "go",
        ext: [
            "go"
        ]
    },
    {
        name: "Groovy",
        mime: "text/x-groovy",
        mode: "groovy",
        ext: [
            "groovy",
            "gradle"
        ],
        file: /^Jenkinsfile$/
    },
    {
        name: "HTTP",
        mime: "message/http",
        mode: "http"
    },
    {
        name: "JSX",
        mime: "text/jsx",
        mode: "jsx",
        ext: [
            "jsx"
        ]
    },
    {
        name: "Kotlin",
        mime: "text/x-kotlin",
        mode: "clike",
        ext: [
            "kt"
        ]
    },
    {
        name: "LaTeX",
        mime: "text/x-latex",
        mode: "stex",
        ext: [
            "text",
            "ltx",
            "tex"
        ],
        alias: [
            "tex"
        ]
    },
    {
        name: "Lua",
        mime: "text/x-lua",
        mode: "lua",
        ext: [
            "lua"
        ]
    },
    {
        name: "Markdown",
        mime: "text/x-markdown",
        mode: "markdown",
        ext: [
            "markdown",
            "md",
            "mkd"
        ]
    },
    {
        name: "Nginx",
        mime: "text/x-nginx-conf",
        mode: "nginx",
        file: /nginx.*\.conf$/i
    },
    {
        name: "Objective-C",
        mime: "text/x-objectivec",
        mode: "clike",
        ext: [
            "m",
            "mm"
        ],
        alias: [
            "objective-c",
            "objc"
        ]
    },
    {
        name: "Perl",
        mime: "text/x-perl",
        mode: "perl",
        ext: [
            "pl",
            "pm"
        ]
    },
    {
        name: "PHP",
        mimes: [
            "text/x-php",
            "application/x-httpd-php",
            "application/x-httpd-php-open"
        ],
        mode: "php",
        ext: [
            "php",
            "php3",
            "php4",
            "php5",
            "php7",
            "phtml"
        ]
    },
    {
        name: "PowerShell",
        mime: "application/x-powershell",
        mode: "powershell",
        ext: [
            "ps1",
            "psd1",
            "psm1"
        ]
    },
    {
        name: "Python",
        mime: "text/x-python",
        mode: "python",
        ext: [
            "BUILD",
            "bzl",
            "py",
            "pyw"
        ],
        file: /^(BUCK|BUILD)$/
    },
    {
        name: "R",
        mime: "text/x-rsrc",
        mode: "r",
        ext: [
            "r",
            "R"
        ],
        alias: [
            "rscript"
        ]
    },
    {
        name: "Ruby",
        mime: "text/x-ruby",
        mode: "ruby",
        ext: [
            "rb"
        ],
        alias: [
            "jruby",
            "macruby",
            "rake",
            "rb",
            "rbx"
        ]
    },
    {
        name: "Sass",
        mime: "text/x-sass",
        mode: "sass",
        ext: [
            "sass"
        ]
    },
    {
        name: "Scala",
        mime: "text/x-scala",
        mode: "clike",
        ext: [
            "scala"
        ]
    },
    {
        name: "SQL",
        mime: "text/x-sql",
        mode: "sql",
        ext: [
            "sql"
        ]
    },
    {
        name: "Stylus",
        mime: "text/x-styl",
        mode: "stylus",
        ext: [
            "styl"
        ]
    },
    {
        name: "TypeScript",
        mime: "text/typescript",
        mode: "text/typescript",
        ext: [
            "ts"
        ]
    },
    {
        name: "Swift",
        mime: "text/x-swift",
        mode: "swift",
        ext: [
            "swift"
        ]
    },
    {
        name: "Vue.js Component",
        mimes: [
            "script/x-vue",
            "text/x-vue"
        ],
        mode: "vue",
        ext: [
            "vue"
        ]
    },
    {
        name: "XML",
        mimes: [
            "application/xml",
            "text/xml"
        ],
        mode: "xml",
        ext: [
            "xml",
            "xsl",
            "xsd",
            "svg"
        ],
        alias: [
            "rss",
            "wsdl",
            "xsd"
        ]
    },
    {
        name: "YAML",
        mimes: [
            "text/x-yaml",
            "text/yaml"
        ],
        mode: "yaml",
        ext: [
            "yaml",
            "yml"
        ],
        alias: [
            "yml"
        ]
    },
    {
        name: "PlantUML",
        mode: "plantuml"
    }
];
var modeMap = {};
languages.forEach(function(param) {
    var name = param.name, mime = param.mime, mode = param.mode;
    if (mode === "clike" || mode === "sql") {
        modeMap[name.toLowerCase()] = Array.isArray(mime) ? mime[0] : mime;
    } else {
        modeMap[name.toLowerCase()] = mode;
    }
});
function getMode(language) {
    return modeMap[(language || "").toLowerCase()] || "null";
}

var css_248z$2 = ".cm-s-xq-light span.cm-keyword{line-height:1em;font-weight:700;color:#5a5cad}.cm-s-xq-light span.cm-atom{color:#6c8cd5}.cm-s-xq-light span.cm-number{color:#164}.cm-s-xq-light span.cm-def{text-decoration:underline}.cm-s-xq-light span.cm-type,.cm-s-xq-light span.cm-variable,.cm-s-xq-light span.cm-variable-2,.cm-s-xq-light span.cm-variable-3{color:#000}.cm-s-xq-light span.cm-comment{color:#0080ff;font-style:italic}.cm-s-xq-light span.cm-string{color:red}.cm-s-xq-light span.cm-meta{color:#ff0}.cm-s-xq-light span.cm-qualifier{color:grey}.cm-s-xq-light span.cm-builtin{color:#7ea656}.cm-s-xq-light span.cm-bracket{color:#cc7}.cm-s-xq-light span.cm-tag{color:#3f7f7f}.cm-s-xq-light span.cm-attribute{color:#7f007f}.cm-s-xq-light span.cm-error{color:red}.cm-s-xq-light .CodeMirror-activeline-background{background:#e8f2ff}.cm-s-xq-light .CodeMirror-matchingbracket{outline:1px solid grey;color:#000!important;background:#ff0}.CodeMirror{height:auto;background:#fcfcfc}.CodeMirror div{box-sizing:content-box}.CodeMirror pre{white-space:pre!important;padding:0 10px}.CodeMirror pre span{font-family:monospace}.CodeMirror .CodeMirror-sizer{margin-left:46px!important}.CodeMirror .CodeMirror-lines{padding:10px 0}.CodeMirror .CodeMirror-line{counter-increment:linenumber;margin:0}.CodeMirror .CodeMirror-line:before{content:counter(linenumber);position:absolute;display:block;left:-46px;width:32px;line-height:24px;text-align:right;font-size:12px;color:#9b9b9b}.cm-s-xq-light span.cm-def{text-decoration:none}.cm-s-xq-light span.cm-meta{color:red}.cm-s-xq-light span.cm-type{color:green}.CodeMirror-cursor{width:2px!important}";
styleInject(css_248z$2);

var modeSet = new Set();
languages.forEach(function(param) {
    var mode = param.mode;
    if (!modeSet.has(mode) && mode !== "null" && mode !== "plantuml") {
        modeSet.add(mode);
    }
});

var css_248z$3 = '.ct-code-toolbar{align-items:center;background:#f2f2f2;box-sizing:border-box;display:flex;height:30px;padding-left:10px;position:relative;width:100%}.ct-code-toolbar .padding{cursor:pointer;height:100%;width:10px}.ct-code-toolbar .expand{cursor:pointer;height:100%;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526953416889%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223453%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%228%22 height%3D%228%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M375.966782 310.02559401L28.2073 642.809787a89.339756 89.339756 0 0 0 0 130.169816 99.323282 99.323282 0 0 0 136.057537 0L512.024319 440.323405 859.7838 773.107597a99.323282 99.323282 0 0 0 136.057538 0 89.339756 89.339756 0 0 0 0-130.169817l-347.759482-332.784192-65.916869-59.389179a105.722978 105.722978 0 0 0-140.281336 0l-65.916869 59.389179z%22 fill%3D%22%23747272%22 p-id%3D%223454%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%;transition:transform .2s;width:24px}.ct-code-toolbar .collapse{transform:rotate(-180deg)}.ct-code-toolbar .title{color:#333;cursor:text;flex:1;font-size:12px;font-weight:700;height:30px;line-height:30px;outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code-toolbar .ct-code-lang-select-list{background:#fff;border-radius:4px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);list-style:none;margin:0;overflow-y:auto;padding:8px 0;position:fixed;width:140px;z-index:11}.ct-code-toolbar .ct-code-lang-select-list ::-webkit-scrollbar{background-color:#f5f5f5;height:8px;width:6px}.ct-code-toolbar .ct-code-lang-select-list ::-webkit-scrollbar-thumb{background-color:#ddd;border-radius:3px}.ct-code-toolbar .list-item{color:#333;cursor:pointer;font-size:12px;height:24px;line-height:24px;padding-left:16px}.ct-code-toolbar .active,.ct-code-toolbar .list-item:hover{background:#f6f6f6}.ct-code-lang-select{height:30px;line-height:30px;overflow:hidden;width:140px}.ct-code-lang-select .lang{color:#999;cursor:pointer;font-family:Tahoma;font-size:12px;height:30px;overflow:hidden;padding-right:32px;text-align:right;text-overflow:ellipsis;white-space:nowrap}.ct-code-lang-select .lang:after{content:"";position:absolute;width:8px;height:8px;margin:0 8px;top:12px;transition:transform .2s;background-size:8px 8px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221513063069381%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1638 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%222306%22 id%3D%22mx_n_1513063069382%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%228%22 height%3D%228%22%3E    %3Cdefs%3E        %3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E    %3C%2Fdefs%3E    %3Cpath d%3D%22M1595.8016 262.7584a160.5632 160.5632 0 0 0 31.5392-167.936A145.2032 145.2032 0 0 0 1493.4016 0H144.9984a145.408 145.408 0 0 0-133.9392 95.0272A163.0208 163.0208 0 0 0 0 154.0096c0 39.936 14.7456 79.2576 42.3936 108.7488L716.8 978.944c27.2384 28.8768 64.1024 45.056 102.4 45.056 38.5024 0 75.3664-16.384 102.4-45.056l674.2016-716.1856z%22 fill%3D%22%23B0B0B0%22 p-id%3D%222307%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 0 0}.ct-code-lang-select .select-expand:after{transform:rotate(180deg)}';
styleInject(css_248z$3);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var DEFAULT_TITLE = "代码块";
var ToolBar = /*#__PURE__*/ function(Component) {
    _inherits(ToolBar, Component);
    var _super = _createSuper(ToolBar);
    function ToolBar(props) {
        _classCallCheck(this, ToolBar);
        var _this;
        _this = _super.call(this, props);
        _this.toggleDisplay = function() {
            var _this_props = _this.props, toggleDisplay = _this_props.toggleDisplay, isExpand = _this_props.isExpand;
            toggleDisplay(!isExpand);
        };
        _this.updateTitle = function() {
            var textContent = _this.title.textContent;
            var _this_props = _this.props, updateTitle = _this_props.updateTitle, title = _this_props.title;
            if (textContent !== title) {
                updateTitle(textContent);
            }
        };
        _this.handleClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            var _this_props = _this.props, changeLanguage = _this_props.changeLanguage, language = _this_props.language;
            var chosenLang = e.target.textContent;
            if (chosenLang === language) {
                return;
            }
            changeLanguage(chosenLang);
            // 默认代码块语言只有用户自己选择变更之后才会更改，不受其他人影响
            localStorage.setItem("cmLanguage", chosenLang);
            _this.setState({
                isShow: false
            });
        };
        _this.hideSelect = function() {
            var isShow = _this.state.isShow;
            if (isShow) {
                _this.setState({
                    isShow: false
                });
            }
        };
        _this.toggleShow = function(e) {
            e.preventDefault();
            e.stopPropagation();
            var isShow = _this.state.isShow;
            if (_this.toolbar.offsetWidth < 100) return;
            var _e_target_getBoundingClientRect = e.target.getBoundingClientRect(), left = _e_target_getBoundingClientRect.left, top = _e_target_getBoundingClientRect.top;
            var _document_body_getBoundingClientRect = document.body.getBoundingClientRect(), pageBottom = _document_body_getBoundingClientRect.bottom;
            var ulTop = top + e.target.offsetHeight;
            var maxHeight = Math.min(Math.max(65, pageBottom - ulTop - 7), 360); // 下拉框高度根据页面底部距离调整
            _this.setState({
                isShow: !isShow,
                left: left,
                top: ulTop,
                maxHeight: maxHeight
            });
        };
        _this.title = null;
        _this.toolbar = null;
        _this.state = {
            isShow: false,
            left: 0,
            top: 0,
            maxHeight: 360
        };
        return _this;
    }
    var _proto = ToolBar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, setSelection = _this_props.setSelection, languages = _this_props.languages, title = _this_props.title, language = _this_props.language, isExpand = _this_props.isExpand;
        var _this_state = this.state, isShow = _this_state.isShow, left = _this_state.left, top = _this_state.top, maxHeight = _this_state.maxHeight;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
            className: "ct-code-toolbar",
            ref: function(refs) {
                _this.toolbar = refs;
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
            className: "expand ".concat(isExpand ? "" : "collapse"),
            onClick: this.toggleDisplay
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
            className: "title",
            contentEditable: true,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: title ? dompurify__WEBPACK_IMPORTED_MODULE_11___default.a.sanitize(title) : DEFAULT_TITLE
            },
            ref: function(refs) {
                _this.title = refs;
            },
            onFocus: setSelection,
            onBlur: this.updateTitle
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
            className: "ct-code-lang-select",
            onMouseLeave: this.hideSelect
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("div", {
            className: "lang ".concat(isShow ? "select-expand" : ""),
            onClick: this.toggleShow
        }, language)), isShow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("ul", {
            className: "ct-code-lang-select-list",
            style: {
                left: "".concat(left, "px"),
                top: "".concat(top, "px"),
                maxHeight: "".concat(maxHeight, "px")
            },
            onMouseLeave: this.hideSelect,
            onMouseEnter: function() {
                return _this.setState({
                    isShow: true
                });
            }
        }, languages.map(function(param) {
            var name = param.name;
            /*#__PURE__*/ return react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement("li", {
                className: "list-item ".concat((language === null || language === void 0 ? void 0 : language.toLowerCase()) === (name === null || name === void 0 ? void 0 : name.toLowerCase()) ? "active" : ""),
                key: name,
                onClick: _this.handleClick
            }, name);
        })));
    };
    return ToolBar;
}(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function update(attrs, pos) {
    return function(state, dispatch) {
        var tr = state.tr, schema = state.schema;
        dispatch(tr.setNodeMarkup(pos, schema.nodes.code_block, attrs).scrollIntoView());
    };
}
function computeChange(oldVal, newVal) {
    if (oldVal === newVal) return null;
    var start = 0;
    var oldEnd = oldVal.length;
    var newEnd = newVal.length;
    while(start < oldEnd && oldVal.charCodeAt(start) === newVal.charCodeAt(start)){
        ++start;
    }
    while(oldEnd > start && newEnd > start && oldVal.charCodeAt(oldEnd - 1) === newVal.charCodeAt(newEnd - 1)){
        oldEnd--;
        newEnd--;
    }
    return {
        from: start,
        to: oldEnd,
        text: newVal.slice(start, newEnd)
    };
}
var CodeBlockView = /*#__PURE__*/ function() {
    function CodeBlockView(node, view, getPos) {
        var _this = this;
        _classCallCheck$1(this, CodeBlockView);
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = document.createElement("div");
        this.updateAttrs = function(attrs) {
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var newAttrs = _objectSpread({}, _this.node.attrs, attrs);
            var command = update(newAttrs, _this.getPos());
            command(state, dispatch);
        };
        this.toggleDisplay = function(isExpand) {
            var $cm = _this.cm.getWrapperElement();
            _this.cm.focus();
            if (isExpand) {
                $cm.style.cssText = "height:auto !important";
                _this.cm.refresh();
            } else {
                $cm.style.cssText = "height:0 !important";
            }
            _this.updateAttrs({
                isExpand: isExpand
            });
        };
        this.updateTitle = function(title) {
            _this.updateAttrs({
                title: title
            });
        };
        this.changeLanguage = function(language) {
            _this.cm.setOption("mode", getMode(language));
            _this.updateAttrs({
                language: language
            });
            _this.cm.focus();
        };
        this.setTextSelection = function() {
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var doc = state.doc, tr = state.tr;
            var pos = _this.getPos() + 1;
            var selection = prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"].create(doc, pos, pos);
            dispatch(tr.setSelection(selection));
        };
        // Store for later
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        var _this_node_attrs = this.node.attrs, language = _this_node_attrs.language, theme = _this_node_attrs.theme;
        var value = this.node.textContent;
        this.cm = new codemirror__WEBPACK_IMPORTED_MODULE_10___default.a(null, {
            value: value,
            matchBrackets: true,
            tabSize: 2,
            mode: getMode(language),
            theme: theme,
            // readOnly: false,
            extraKeys: this.codeMirrorKeymap()
        });
        this.dom = this.createDom();
        // CodeMirror needs to be in the DOM to properly initialize, so
        // schedule it to update itself
        setTimeout(function() {
            _this.cm.refresh();
        }, 20);
        // This flag is used to avoid an update loop between the outer and
        // inner editor
        this.updating = false;
        this.cm.on("changes", function() {
            if (!_this.updating) _this.valueChanged();
        });
        this.cm.on("focus", function() {
            _this.forwardSelection();
        });
        this.cm.on("drop", function(c, e) {
            var htmlData = e.dataTransfer.getData("text/html");
            if (htmlData && htmlData[1] !== "p" && htmlData[1] !== "h") {
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
        });
    }
    var _proto = CodeBlockView.prototype;
    _proto.createDom = function createDom() {
        var _this_node = this.node, attrs = _this_node.attrs, _this_node_attrs = _this_node.attrs, dataDiffId = _this_node_attrs.dataDiffId, title = _this_node_attrs.title, language = _this_node_attrs.language, isExpand = _this_node_attrs.isExpand;
        var $cm = this.cm.getWrapperElement();
        if (!attrs.isExpand) {
            $cm.style.cssText = "height:0 !important";
        }
        // 创建工具栏
        var $toolbar = document.createElement("div");
        this.$toolbar = $toolbar;
        react_dom__WEBPACK_IMPORTED_MODULE_8___default.a.render(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(ToolBar, {
            title: title,
            language: language,
            isExpand: isExpand,
            languages: languages,
            setSelection: this.setTextSelection,
            toggleDisplay: this.toggleDisplay,
            updateTitle: this.updateTitle,
            changeLanguage: this.changeLanguage
        }), this.$toolbar);
        var $code = document.createElement("div");
        $code.className = "ct-code";
        if (dataDiffId) {
            $code.setAttribute("data-diff-id", dataDiffId);
        }
        $code.appendChild($toolbar);
        $code.appendChild($cm);
        return $code;
    };
    _proto.forwardSelection = function forwardSelection() {
        if (!this.cm.hasFocus()) return;
        var state = this.view.state;
        var selection = this.asProseMirrorSelection(state.doc);
        if (!selection.eq(state.selection)) {
            this.view.dispatch(state.tr.setSelection(selection));
        }
    };
    _proto.asProseMirrorSelection = function asProseMirrorSelection(doc) {
        var offset = this.getPos() + 1;
        var anchor = this.cm.indexFromPos(this.cm.getCursor("anchor")) + offset;
        var head = this.cm.indexFromPos(this.cm.getCursor("head")) + offset;
        return prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["TextSelection"].create(doc, anchor, head);
    };
    _proto.valueChanged = function valueChanged() {
        var change = computeChange(this.node.textContent, this.cm.getValue());
        if (change) {
            var _this_view_state = this.view.state, tr = _this_view_state.tr, schema = _this_view_state.schema;
            var start = this.getPos() + 1;
            var from = start + change.from;
            var to = start + change.to;
            var content = change.text ? schema.text(change.text) : null;
            this.view.dispatch(tr.replaceWith(from, to, content));
        }
    };
    _proto.codeMirrorKeymap = function codeMirrorKeymap() {
        var _this = this;
        var view = this.view;
        var mod = /Mac/.test(navigator.platform) ? "Cmd" : "Ctrl";
        var _obj;
        return codemirror__WEBPACK_IMPORTED_MODULE_10___default.a.normalizeKeyMap((_obj = {
            Up: function() {
                return _this.maybeEscape("line", -1);
            },
            Left: function() {
                return _this.maybeEscape("char", -1);
            },
            Down: function() {
                return _this.maybeEscape("line", 1);
            },
            Right: function() {
                return _this.maybeEscape("char", 1);
            }
        }, _defineProperty(_obj, "".concat(mod, "-Z"), function() {
            Object(prosemirror_history__WEBPACK_IMPORTED_MODULE_9__["undo"])(view.state, view.dispatch);
        }), _defineProperty(_obj, "".concat(mod, "-A"), function() {
            return _this.selectAll();
        }), _defineProperty(_obj, "Shift-".concat(mod, "-Z"), function() {
            Object(prosemirror_history__WEBPACK_IMPORTED_MODULE_9__["redo"])(view.state, view.dispatch);
        }), _defineProperty(_obj, "Shift-".concat(mod, "-A"), function() {
            return _this.selectAllContent();
        }), _defineProperty(_obj, "Shift-Enter", function() {
            _this.cm.execCommand("newlineAndIndent");
        }), _defineProperty(_obj, "".concat(mod, "-Y"), function() {
            Object(prosemirror_history__WEBPACK_IMPORTED_MODULE_9__["redo"])(view.state, view.dispatch);
        }), _defineProperty(_obj, "Ctrl-Enter", function() {
            if (Object(prosemirror_commands__WEBPACK_IMPORTED_MODULE_3__["exitCode"])(view.state, view.dispatch)) view.focus();
        }), _obj));
    };
    // eslint-disable-next-line consistent-return
    _proto.maybeEscape = function maybeEscape(unit, dir) {
        var pos = this.cm.getCursor();
        if (this.cm.somethingSelected() || pos.line !== (dir < 0 ? this.cm.firstLine() : this.cm.lastLine()) || unit === "char" && pos.ch !== (dir < 0 ? 0 : this.cm.getLine(pos.line).length)) {
            return codemirror__WEBPACK_IMPORTED_MODULE_10___default.a.Pass;
        }
        this.view.focus();
        var targetPos = this.getPos() + (dir < 0 ? 0 : this.node.nodeSize);
        var selection = prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].near(this.view.state.doc.resolve(targetPos), dir);
        this.view.dispatch(this.view.state.tr.setSelection(selection).scrollIntoView());
        this.view.focus();
    };
    _proto.selectAllContent = function selectAllContent() {
        this.cm.focus();
        this.cm.execCommand("selectAll");
    };
    // TODO: Command+A表现与老编辑器不一致
    _proto.selectAll = function selectAll() {
        var _this_view = this.view, state = _this_view.state, dispatch = _this_view.dispatch;
        var allSelection = new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["AllSelection"](state.doc);
        this.view.focus();
        dispatch(state.tr.setSelection(allSelection));
    };
    // NodeView的方法，该方法将会被调用以用来处理节点内部选区的设置
    _proto.setSelection = function setSelection(anchor, head) {
        this.cm.focus();
        this.updating = true;
        this.cm.setSelection(this.cm.posFromIndex(anchor), this.cm.posFromIndex(head));
        this.updating = false;
    };
    // NodeView的方法，当 NodeView 更新自身的时候会调用该节点的此方法
    _proto.update = function update(node) {
        if (node.type !== this.node.type) return false;
        this.node = node;
        var change = computeChange(this.cm.getValue(), node.textContent);
        if (change) {
            this.updating = true;
            this.cm.replaceRange(change.text, this.cm.posFromIndex(change.from), this.cm.posFromIndex(change.to));
            this.updating = false;
        }
        var _this_node = this.node, _this_node_attrs = _this_node.attrs, title = _this_node_attrs.title, language = _this_node_attrs.language, isExpand = _this_node_attrs.isExpand;
        var $cm = this.cm.getWrapperElement();
        if (isExpand) {
            $cm.style.cssText = "height:auto !important";
        } else {
            $cm.style.cssText = "height:0 !important";
        }
        react_dom__WEBPACK_IMPORTED_MODULE_8___default.a.render(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(ToolBar, {
            title: title,
            language: language,
            isExpand: isExpand,
            languages: languages,
            setSelection: this.setTextSelection,
            toggleDisplay: this.toggleDisplay,
            updateTitle: this.updateTitle,
            changeLanguage: this.changeLanguage
        }), this.$toolbar);
        return true;
    };
    // NodeView的方法 用来阻止编辑器处理一些或者所有的源自 NodeView 的 DOM 事件。返回 true 表示编辑器不处理该事件。
    _proto.stopEvent = function stopEvent() {
        return true;
    };
    return CodeBlockView;
}();

function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var CodeExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$1(CodeExtension, NodeExtension);
    var _super = _createSuper$1(CodeExtension);
    function CodeExtension() {
        _classCallCheck$2(this, CodeExtension);
        return _super.apply(this, arguments);
    }
    var _proto = CodeExtension.prototype;
    _proto.plugin = function plugin() {
        return new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Plugin"]({
            key: new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["PluginKey"](this.name),
            props: {
                decorations: function(state) {
                    var selection = state.selection, schema = state.schema, doc = state.doc;
                    var from = selection.from, to = selection.to;
                    var decos = [];
                    var code_block = schema.nodes.code_block;
                    var codeNode = findParentNode(function(item) {
                        return item.type && item.type.name === "code_block";
                    })(selection);
                    if (codeNode) {
                        var attrs = {
                            class: "ct-code-show"
                        };
                        var deco = prosemirror_view__WEBPACK_IMPORTED_MODULE_1__[/* Decoration */ "a"].node(codeNode.pos, codeNode.pos + codeNode.node.nodeSize, attrs);
                        decos.push(deco);
                    }
                    var node = doc.nodeAt(from);
                    if (node && node.type === code_block && from + node.nodeSize === to) {
                        var deco1 = prosemirror_view__WEBPACK_IMPORTED_MODULE_1__[/* Decoration */ "a"].node(from, to, {
                            nodeName: "div",
                            class: "ct-code-selected"
                        });
                        decos.push(deco1);
                    }
                    return decos.length > 0 ? prosemirror_view__WEBPACK_IMPORTED_MODULE_1__[/* DecorationSet */ "b"].create(doc, decos) : prosemirror_view__WEBPACK_IMPORTED_MODULE_1__[/* DecorationSet */ "b"].empty;
                },
                nodeViews: {
                    code_block: function(node, view, getPos) {
                        return new CodeBlockView(node, view, getPos);
                    }
                }
            }
        });
    };
    _proto.keys = function keys(param) {
        var editorEventEmitter = param.editorEventEmitter;
        return {
            Backspace: convertCommand(backspaceAfterCode()),
            "Mod-Alt-c": convertCommand(execAfterCommands(insert, function() {
                return editorEventEmitter.emit(AFTER_INSERT, {
                    braceWidth: 250
                });
            })())
        };
    };
    _proto.commands = function commands(param) {
        var getState = param.getState, editorEventEmitter = param.editorEventEmitter;
        return {
            insert: execAfterCommands(insert, function() {
                return editorEventEmitter.emit(AFTER_INSERT, {
                    braceWidth: 250
                });
            }),
            isInCode: isInCode,
            isCodeBlockDisabled: function() {
                return function() {
                    return !canInsertTypes(getState());
                };
            }
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type;
        return [
            blockInputRule(new RegExp(regexpCode), type)
        ];
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        // PPT粘贴
        if (html.includes('xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"')) {
            return html;
        }
        // 代码块除外的换行符转换为br
        if (!html.includes("ct-code") && !html.includes("ct-html")) {
            html = html.replace(/<body>([\s\S]*)<\/body>/g, function(word) {
                return word.replace(/\n</g, "<").replace(/>\s*\n/g, ">").replace(/\n/g, "<br />");
            });
        }
        // 浏览态复制代码块换行符
        if (html.includes("ct-code")) {
            html = html.replace(/<div class="title[^>]*?>([^<].*?)<\/div>/g, '<div class="title" data-title="$1"></div>').replace(/<div class="language[^>]*?>([^<].*?)<\/div>/g, '<div class="language" data-language="$1"></div>').replace(/<span[^>]*?cm-text.*?<\/span>/g, "").replace(/(<pre[^>]*?CodeMirror-line.*?)(<\/pre>)/g, "$1\n$2");
        }
        return html;
    };
    _createClass(CodeExtension, [
        {
            key: "name",
            get: function get() {
                return "code_block";
            }
        }
    ]);
    return CodeExtension;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_2__[/* NodeExtension */ "d"]);


//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6403":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ "6430":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer
var Transform = __webpack_require__("d485").Transform
var StringDecoder = __webpack_require__("aa22").StringDecoder
var inherits = __webpack_require__("3fb5")

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),

/***/ "6442":
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__("ad25")
exports.privateDecrypt = __webpack_require__("0f2c")

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ "656e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("79aa");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "65db":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ "66a5":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("0197"),
    setCacheAdd = __webpack_require__("eaf2"),
    setCacheHas = __webpack_require__("e116");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "6718":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var LIBRARY = __webpack_require__("b8e3");
var wksExt = __webpack_require__("ccb9");
var defineProperty = __webpack_require__("d9f6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "675d":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "676f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("399f");
var inherits = __webpack_require__("3fb5");
var Base = __webpack_require__("ea53");

var utils = __webpack_require__("f3a3");

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ "6784":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ "67a1":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("0829"),
    nativeKeys = __webpack_require__("f685");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "67ab":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("ca5a")('meta');
var isObject = __webpack_require__("d3f4");
var has = __webpack_require__("69a8");
var setDesc = __webpack_require__("86cc").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("79e5")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "67bb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("f921");

/***/ }),

/***/ "67dd":
/***/ (function(module, exports) {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "6884":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("cc63");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "6887":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ "688b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ "68ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-announcement/mc-announcement.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_announcementvue_type_script_lang_js_ = ({
  name: 'McAnnouncement',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-announcement', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-announcement/mc-announcement.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_announcement_mc_announcementvue_type_script_lang_js_ = (mc_announcementvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-announcement/mc-announcement.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_announcement_mc_announcementvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_announcement = (component.exports);
// CONCATENATED MODULE: ./components/mc-announcement/index.js


/* istanbul ignore next */

mc_announcement.install = function (Vue) {
  Vue.component(mc_announcement.name, mc_announcement);
};

/* harmony default export */ var components_mc_announcement = __webpack_exports__["default"] = (mc_announcement);

/***/ }),

/***/ "6909":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ "696e":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c207");
__webpack_require__("1654");
__webpack_require__("6c1c");
__webpack_require__("24c5");
__webpack_require__("3c11");
__webpack_require__("43fc");
module.exports = __webpack_require__("584a").Promise;


/***/ }),

/***/ "699e":
/***/ (function(module, exports) {

const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "69cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-checkbox-group/mc-checkbox-group.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_checkbox_groupvue_type_script_lang_js_ = ({
  name: 'McCheckboxGroup',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-checkbox-group组件已经弃用，请使用mc-choice组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/aWRcgaz4faYOZ7ubzF_33', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-checkbox-group', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-checkbox-group/mc-checkbox-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_checkbox_group_mc_checkbox_groupvue_type_script_lang_js_ = (mc_checkbox_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-checkbox-group/mc-checkbox-group.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_checkbox_group_mc_checkbox_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_checkbox_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-checkbox-group/index.js


/* istanbul ignore next */

mc_checkbox_group.install = function (Vue) {
  Vue.component(mc_checkbox_group.name, mc_checkbox_group);
};

/* harmony default export */ var components_mc_checkbox_group = __webpack_exports__["default"] = (mc_checkbox_group);

/***/ }),

/***/ "69d3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6718")('asyncIterator');


/***/ }),

/***/ "69f2":
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__("087f")
exports.sha1 = __webpack_require__("7e78")
exports.sha224 = __webpack_require__("72aa")
exports.sha256 = __webpack_require__("a255")
exports.sha384 = __webpack_require__("b837")
exports.sha512 = __webpack_require__("4fd1")


/***/ }),

/***/ "6a79":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6a79__;

/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "6a9b":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("6884");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "6aa2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("7d92");
var utils = __webpack_require__("7658");
var assert = __webpack_require__("da3e");

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ "6abf":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("e6f3");
var hiddenKeys = __webpack_require__("1691").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "6ace":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("a32f"),
    getSymbols = __webpack_require__("f30d"),
    keys = __webpack_require__("83f4");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "6ade":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("8c8a")
var Buffer = __webpack_require__("8707").Buffer
var incr32 = __webpack_require__("bd9d")

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ "6ae2":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("c3f1");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "6b4c":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "6b54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("3846");
var anObject = __webpack_require__("cb7c");
var $flags = __webpack_require__("0bfb");
var DESCRIPTORS = __webpack_require__("9e1e");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("2aba")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("79e5")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "6c1c":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c367");
var global = __webpack_require__("e53d");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var TO_STRING_TAG = __webpack_require__("5168")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "6cd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-form-group/mc-form-group.vue?vue&type=template&id=943f5f08&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.groupClass},[(_vm.label)?_c('div',{staticClass:"mtd-form-item-label",class:_vm.groupLabelClass,style:(_vm.groupLabelStyle)},[_vm._v("\n        "+_vm._s(_vm.label)+_vm._s(_vm.labelSuffix)+"\n    ")]):_vm._e(),_c('div',{staticClass:"mtd-form-item-content",style:(_vm.groupContentStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-form-group/mc-form-group.vue?vue&type=template&id=943f5f08&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./composables/useFormProvider.js
var useFormProvider = __webpack_require__("817d");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-form-group/mc-form-group.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_form_groupvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McFormGroup',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelPosition: {
      type: String
    },
    labelWidth: {
      type: Number
    },
    labelSuffix: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props) {
    var _useFormProvider = Object(useFormProvider["a" /* default */])(),
        mtdForm = _useFormProvider.mtdForm;

    var innerLabelPosition = Object(composition_api_["computed"])(function () {
      return props.labelPosition || mtdForm.labelPosition || 'right';
    });
    var innerLabelWidth = Object(composition_api_["computed"])(function () {
      return props.labelWidth || mtdForm.labelWidth;
    });
    var groupClass = Object(composition_api_["computed"])(function () {
      var classList = ['mc-form-group'];

      if (props.inline) {
        classList.push('mc-form-group-inline');
      }

      return classList;
    });
    var groupLabelClass = Object(composition_api_["computed"])(function () {
      var classList = [];
      if (props.required) classList.push('mc-form-group-label-required');
      return classList;
    });
    var groupLabelStyle = Object(composition_api_["computed"])(function () {
      var styleObj = {
        width: null
      };

      if (innerLabelPosition.value === 'top') {
        styleObj.width = '100%';
      }

      if (innerLabelPosition.value === 'right') {
        styleObj.width = "".concat(innerLabelWidth.value, "px");
        styleObj['text-align'] = 'right';
      }

      return styleObj;
    });
    var groupContentStyle = Object(composition_api_["computed"])(function () {
      var styleObj = {
        'margin-left': null
      };

      if (innerLabelPosition.value === 'right') {
        styleObj['margin-left'] = "".concat(innerLabelWidth.value, "px");
      }

      return styleObj;
    });
    var groupContentClass = Object(composition_api_["computed"])(function () {
      return [];
    });
    return {
      innerLabelWidth: innerLabelWidth,
      innerLabelPosition: innerLabelPosition,
      groupClass: groupClass,
      groupLabelClass: groupLabelClass,
      groupLabelStyle: groupLabelStyle,
      groupContentStyle: groupContentStyle,
      groupContentClass: groupContentClass
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-form-group/mc-form-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_form_group_mc_form_groupvue_type_script_lang_js_ = (mc_form_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-form-group/mc-form-group.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_form_group_mc_form_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_form_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-form-group/index.js


/* istanbul ignore next */

mc_form_group.install = function (Vue) {
  Vue.component(mc_form_group.name, mc_form_group);
};

/* harmony default export */ var components_mc_form_group = __webpack_exports__["default"] = (mc_form_group);

/***/ }),

/***/ "6ce3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ "6d79":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ "6d83":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ "6da3":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("6a9b"),
    Uint8Array = __webpack_require__("7d70"),
    eq = __webpack_require__("ed78"),
    equalArrays = __webpack_require__("17c1"),
    mapToArray = __webpack_require__("675d"),
    setToArray = __webpack_require__("29b8");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "6dd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6e53":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mod10 = mod10;
exports.mod11 = mod11;
function mod10(number) {
	var sum = 0;
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[i]);
		if ((i + number.length) % 2 === 0) {
			sum += n;
		} else {
			sum += n * 2 % 10 + Math.floor(n * 2 / 10);
		}
	}
	return (10 - sum % 10) % 10;
}

function mod11(number) {
	var sum = 0;
	var weights = [2, 3, 4, 5, 6, 7];
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[number.length - 1 - i]);
		sum += weights[i % weights.length] * n;
	}
	return (11 - sum % 11) % 11;
}

/***/ }),

/***/ "6e77":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("c27c"),
    hashDelete = __webpack_require__("7944"),
    hashGet = __webpack_require__("f470"),
    hashHas = __webpack_require__("8ed0"),
    hashSet = __webpack_require__("d6b1");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "6e98":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ "6ed7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-list-item-group/mc-list-item-group.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_list_item_groupvue_type_script_lang_js_ = ({
  name: 'McListItemGroup',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-list-item-group', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-list-item-group/mc-list-item-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_list_item_group_mc_list_item_groupvue_type_script_lang_js_ = (mc_list_item_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-list-item-group/mc-list-item-group.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_list_item_group_mc_list_item_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_list_item_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-list-item-group/index.js


/* istanbul ignore next */

mc_list_item_group.install = function (Vue) {
  Vue.component(mc_list_item_group.name, mc_list_item_group);
};

/* harmony default export */ var components_mc_list_item_group = __webpack_exports__["default"] = (mc_list_item_group);

/***/ }),

/***/ "6eeb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-supply-rule-select/mc-supply-rule-select.vue?vue&type=template&id=1c68fb50&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-supply--rule--select"},[_c('mc-select',_vm._g(_vm._b({attrs:{"source":_vm.bgFuzzyQuerySource,"disabled":_vm.disabled,"clearable":_vm.clearable,"collapse-tags":"","filterable":true,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"scroll-step":{ size: 10 },"reserve-keyword":true},on:{"input":_vm.input,"change":_vm.change},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-select',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-supply-rule-select/mc-supply-rule-select.vue?vue&type=template&id=1c68fb50&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-supply-rule-select/mc-supply-rule-select.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_supply_rule_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McSupplyRuleSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    // 数据处理函数，返回值会被作为渲染下拉列表的数据
    responseProcessor: {
      type: Function,
      default: null
    },
    // 选项值的数据类型
    valueType: {
      type: String,
      default: 'string'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  setup: function setup(props, ctx) {
    var innerValue = Object(composition_api_["ref"])(props.value); // 根据valueType格式化选项值的数据类型

    var formatValueToType = function formatValueToType(val, type) {
      if (!type || val === '' || val === undefined || val === null) {
        // 没有类型/空值
        return val;
      } else {
        // 设置数据类型为type类型
        return type === 'number' ? +val : "".concat(val);
      }
    };

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val;
    }, {
      immediate: true
    });

    var buildParams = function buildParams(params, extendsParams) {
      if (extendsParams.query) {
        params.codeOrName = extendsParams.query;
        params.supplierIdList = [];
      } else if (props.value) {
        params.supplierIdList = Array.isArray(props.value) ? props.value : [props.value];
      }
    };

    var responseProcessor = function responseProcessor(res) {
      var supplierList = res ? res.infoList : [];
      var list = (supplierList || []).map(function (item) {
        return _objectSpread({}, item, {
          label: "".concat(item.name, "(").concat(item.code, ")"),
          value: formatValueToType(item.id, props.valueType)
        });
      });
      ctx.emit('loaded', list);

      if (typeof props.responseProcessor === 'function') {
        return props.responseProcessor(list);
      }

      return list;
    }; // 后端模糊查询获取供货规则列表


    var bgFuzzyQuerySource = Object(composition_api_["computed"])(function () {
      return {
        autoLoad: false,
        ajax: {
          type: 'hPost',
          url: '/api/sqm/shepherd/supplier/getSupplierGPage',
          params: {
            codeOrName: '',
            //这个是搜索关键字
            supplierIdList: [],
            page: {
              offset: 0,
              limit: 100 // 最大100条，超过会慢查询，后端告警

            }
          },
          options: {
            cached: true
          }
        },
        responseProcessor: responseProcessor,
        buildParams: buildParams
      };
    });

    var input = function input(val) {
      ctx.emit('input', val);
    };

    var change = function change(val, item) {
      ctx.emit('change', val, item);
    };

    return {
      innerValue: innerValue,
      bgFuzzyQuerySource: bgFuzzyQuerySource,
      input: input,
      change: change
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-supply-rule-select/mc-supply-rule-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_supply_rule_select_mc_supply_rule_selectvue_type_script_lang_js_ = (mc_supply_rule_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-supply-rule-select/mc-supply-rule-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_supply_rule_select_mc_supply_rule_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_supply_rule_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-supply-rule-select/index.js


/* istanbul ignore next */

mc_supply_rule_select.install = function (Vue) {
  Vue.component(mc_supply_rule_select.name, mc_supply_rule_select);
};

/* harmony default export */ var components_mc_supply_rule_select = __webpack_exports__["default"] = (mc_supply_rule_select);

/***/ }),

/***/ "6eed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var common = __webpack_require__("edc9");
var shaCommon = __webpack_require__("aa56");
var assert = __webpack_require__("da3e");

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "6f12":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ "6f24":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE2 = __webpack_require__("4b23");

var _CODE3 = _interopRequireDefault(_CODE2);

var _auto = __webpack_require__("bb5d");

var _auto2 = _interopRequireDefault(_auto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128AUTO = function (_CODE) {
	_inherits(CODE128AUTO, _CODE);

	function CODE128AUTO(data, options) {
		_classCallCheck(this, CODE128AUTO);

		// ASCII value ranges 0-127, 200-211
		if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
		} else {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
		}
		return _possibleConstructorReturn(_this);
	}

	return CODE128AUTO;
}(_CODE3.default);

exports.default = CODE128AUTO;

/***/ }),

/***/ "6f27":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var OrderedMap = _interopDefault(__webpack_require__("0d00"));

function findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (!childA.sameMarkup(childB)) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A fragment represents a node's collection of child nodes.
//
// Like nodes, fragments are persistent data structures, and you
// should not mutate them or their content. Rather, you create new
// instances whenever needed. The API tries to make this easy.
var Fragment = function Fragment(content, size) {
  var this$1 = this;

  this.content = content;
  // :: number
  // The size of the fragment, which is the total of the size of its
  // content nodes.
  this.size = size || 0;
  if (size == null) { for (var i = 0; i < content.length; i++)
    { this$1.size += content[i].nodeSize; } }
};

var prototypeAccessors$1 = { firstChild: {},lastChild: {},childCount: {} };

// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes between the given two
// positions (relative to start of this fragment). Doesn't descend
// into a node when the callback returns `false`.
Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
    var this$1 = this;
    if ( nodeStart === void 0 ) nodeStart = 0;

  for (var i = 0, pos = 0; pos < to; i++) {
    var child = this$1.content[i], end = pos + child.nodeSize;
    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
      var start = pos + 1;
      child.nodesBetween(Math.max(0, from - start),
                         Math.min(child.content.size, to - start),
                         f, nodeStart + start);
    }
    pos = end;
  }
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. The callback
// may return `false` to prevent traversal of a given node's children.
Fragment.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.size, f);
};

// : (number, number, ?string, ?string) → string
Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  var text = "", separated = true;
  this.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
      separated = !blockSeparator;
    } else if (node.isLeaf && leafText) {
      text += leafText;
      separated = !blockSeparator;
    } else if (!separated && node.isBlock) {
      text += blockSeparator;
      separated = true;
    }
  }, 0);
  return text
};

// :: (Fragment) → Fragment
// Create a new fragment containing the combined content of this
// fragment and the other.
Fragment.prototype.append = function append (other) {
  if (!other.size) { return this }
  if (!this.size) { return other }
  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
  if (last.isText && last.sameMarkup(first)) {
    content[content.length - 1] = last.withText(last.text + first.text);
    i = 1;
  }
  for (; i < other.content.length; i++) { content.push(other.content[i]); }
  return new Fragment(content, this.size + other.size)
};

// :: (number, ?number) → Fragment
// Cut out the sub-fragment between the two given positions.
Fragment.prototype.cut = function cut (from, to) {
    var this$1 = this;

  if (to == null) { to = this.size; }
  if (from == 0 && to == this.size) { return this }
  var result = [], size = 0;
  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
    var child = this$1.content[i], end = pos + child.nodeSize;
    if (end > from) {
      if (pos < from || end > to) {
        if (child.isText)
          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
        else
          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
      }
      result.push(child);
      size += child.nodeSize;
    }
    pos = end;
  } }
  return new Fragment(result, size)
};

Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
  if (from == to) { return Fragment.empty }
  if (from == 0 && to == this.content.length) { return this }
  return new Fragment(this.content.slice(from, to))
};

// :: (number, Node) → Fragment
// Create a new fragment in which the node at the given index is
// replaced by the given node.
Fragment.prototype.replaceChild = function replaceChild (index, node) {
  var current = this.content[index];
  if (current == node) { return this }
  var copy = this.content.slice();
  var size = this.size + node.nodeSize - current.nodeSize;
  copy[index] = node;
  return new Fragment(copy, size)
};

// : (Node) → Fragment
// Create a new fragment by prepending the given node to this
// fragment.
Fragment.prototype.addToStart = function addToStart (node) {
  return new Fragment([node].concat(this.content), this.size + node.nodeSize)
};

// : (Node) → Fragment
// Create a new fragment by appending the given node to this
// fragment.
Fragment.prototype.addToEnd = function addToEnd (node) {
  return new Fragment(this.content.concat(node), this.size + node.nodeSize)
};

// :: (Fragment) → bool
// Compare this fragment to another one.
Fragment.prototype.eq = function eq (other) {
    var this$1 = this;

  if (this.content.length != other.content.length) { return false }
  for (var i = 0; i < this.content.length; i++)
    { if (!this$1.content[i].eq(other.content[i])) { return false } }
  return true
};

// :: ?Node
// The first child of the fragment, or `null` if it is empty.
prototypeAccessors$1.firstChild.get = function () { return this.content.length ? this.content[0] : null };

// :: ?Node
// The last child of the fragment, or `null` if it is empty.
prototypeAccessors$1.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };

// :: number
// The number of child nodes in this fragment.
prototypeAccessors$1.childCount.get = function () { return this.content.length };

// :: (number) → Node
// Get the child node at the given index. Raise an error when the
// index is out of range.
Fragment.prototype.child = function child (index) {
  var found = this.content[index];
  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
  return found
};

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Fragment.prototype.maybeChild = function maybeChild (index) {
  return this.content[index]
};

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Fragment.prototype.forEach = function forEach (f) {
    var this$1 = this;

  for (var i = 0, p = 0; i < this.content.length; i++) {
    var child = this$1.content[i];
    f(child, p, i);
    p += child.nodeSize;
  }
};

// :: (Fragment) → ?number
// Find the first position at which this fragment and another
// fragment differ, or `null` if they are the same.
Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
    if ( pos === void 0 ) pos = 0;

  return findDiffStart(this, other, pos)
};

// :: (Fragment) → ?{a: number, b: number}
// Find the first position, searching from the end, at which this
// fragment and the given fragment differ, or `null` if they are the
// same. Since this position will not be the same in both nodes, an
// object with two separate positions is returned.
Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
    if ( pos === void 0 ) pos = this.size;
    if ( otherPos === void 0 ) otherPos = other.size;

  return findDiffEnd(this, other, pos, otherPos)
};

// : (number, ?number) → {index: number, offset: number}
// Find the index and inner offset corresponding to a given relative
// position in this fragment. The result object will be reused
// (overwritten) the next time the function is called. (Not public.)
Fragment.prototype.findIndex = function findIndex (pos, round) {
    var this$1 = this;
    if ( round === void 0 ) round = -1;

  if (pos == 0) { return retIndex(0, pos) }
  if (pos == this.size) { return retIndex(this.content.length, pos) }
  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
  for (var i = 0, curPos = 0;; i++) {
    var cur = this$1.child(i), end = curPos + cur.nodeSize;
    if (end >= pos) {
      if (end == pos || round > 0) { return retIndex(i + 1, end) }
      return retIndex(i, curPos)
    }
    curPos = end;
  }
};

// :: () → string
// Return a debugging string that describes this fragment.
Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };

Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };

// :: () → ?Object
// Create a JSON-serializeable representation of this fragment.
Fragment.prototype.toJSON = function toJSON () {
  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
};

// :: (Schema, ?Object) → Fragment
// Deserialize a fragment from its JSON representation.
Fragment.fromJSON = function fromJSON (schema, value) {
  if (!value) { return Fragment.empty }
  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
  return new Fragment(value.map(schema.nodeFromJSON))
};

// :: ([Node]) → Fragment
// Build a fragment from an array of nodes. Ensures that adjacent
// text nodes with the same marks are joined together.
Fragment.fromArray = function fromArray (array) {
  if (!array.length) { return Fragment.empty }
  var joined, size = 0;
  for (var i = 0; i < array.length; i++) {
    var node = array[i];
    size += node.nodeSize;
    if (i && node.isText && array[i - 1].sameMarkup(node)) {
      if (!joined) { joined = array.slice(0, i); }
      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
    } else if (joined) {
      joined.push(node);
    }
  }
  return new Fragment(joined || array, size)
};

// :: (?union<Fragment, Node, [Node]>) → Fragment
// Create a fragment from something that can be interpreted as a set
// of nodes. For `null`, it returns the empty fragment. For a
// fragment, the fragment itself. For a node or array of nodes, a
// fragment containing those nodes.
Fragment.from = function from (nodes) {
  if (!nodes) { return Fragment.empty }
  if (nodes instanceof Fragment) { return nodes }
  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
  if (nodes.attrs) { return new Fragment([nodes], nodes.nodeSize) }
  throw new RangeError("Can not convert " + nodes + " to a Fragment" +
                       (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""))
};

Object.defineProperties( Fragment.prototype, prototypeAccessors$1 );

var found = {index: 0, offset: 0};
function retIndex(index, offset) {
  found.index = index;
  found.offset = offset;
  return found
}

// :: Fragment
// An empty fragment. Intended to be reused whenever a node doesn't
// contain anything (rather than allocating a new empty fragment for
// each leaf node).
Fragment.empty = new Fragment([], 0);

function compareDeep(a, b) {
  if (a === b) { return true }
  if (!(a && typeof a == "object") ||
      !(b && typeof b == "object")) { return false }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) { return false }
  if (array) {
    if (a.length != b.length) { return false }
    for (var i = 0; i < a.length; i++) { if (!compareDeep(a[i], b[i])) { return false } }
  } else {
    for (var p in a) { if (!(p in b) || !compareDeep(a[p], b[p])) { return false } }
    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  }
  return true
}

// ::- A mark is a piece of information that can be attached to a node,
// such as it being emphasized, in code font, or a link. It has a type
// and optionally a set of attributes that provide further information
// (such as the target of the link). Marks are created through a
// `Schema`, which controls which types exist and which
// attributes they have.
var Mark = function Mark(type, attrs) {
  // :: MarkType
  // The type of this mark.
  this.type = type;
  // :: Object
  // The attributes associated with this mark.
  this.attrs = attrs;
};

// :: ([Mark]) → [Mark]
// Given a set of marks, create a new set which contains this one as
// well, in the right position. If this mark is already in the set,
// the set itself is returned. If any marks that are set to be
// [exclusive](#model.MarkSpec.excludes) with this mark are present,
// those are replaced by this one.
Mark.prototype.addToSet = function addToSet (set) {
    var this$1 = this;

  var copy, placed = false;
  for (var i = 0; i < set.length; i++) {
    var other = set[i];
    if (this$1.eq(other)) { return set }
    if (this$1.type.excludes(other.type)) {
      if (!copy) { copy = set.slice(0, i); }
    } else if (other.type.excludes(this$1.type)) {
      return set
    } else {
      if (!placed && other.type.rank > this$1.type.rank) {
        if (!copy) { copy = set.slice(0, i); }
        copy.push(this$1);
        placed = true;
      }
      if (copy) { copy.push(other); }
    }
  }
  if (!copy) { copy = set.slice(); }
  if (!placed) { copy.push(this); }
  return copy
};

// :: ([Mark]) → [Mark]
// Remove this mark from the given set, returning a new set. If this
// mark is not in the set, the set itself is returned.
Mark.prototype.removeFromSet = function removeFromSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (this$1.eq(set[i]))
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → bool
// Test whether this mark is in the given set of marks.
Mark.prototype.isInSet = function isInSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (this$1.eq(set[i])) { return true } }
  return false
};

// :: (Mark) → bool
// Test whether this mark has the same type and attributes as
// another mark.
Mark.prototype.eq = function eq (other) {
  return this == other ||
    (this.type == other.type && compareDeep(this.attrs, other.attrs))
};

// :: () → Object
// Convert this mark to a JSON-serializeable representation.
Mark.prototype.toJSON = function toJSON () {
    var this$1 = this;

  var obj = {type: this.type.name};
  for (var _ in this$1.attrs) {
    obj.attrs = this$1.attrs;
    break
  }
  return obj
};

// :: (Schema, Object) → Mark
Mark.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
  var type = schema.marks[json.type];
  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
  return type.create(json.attrs)
};

// :: ([Mark], [Mark]) → bool
// Test whether two sets of marks are identical.
Mark.sameSet = function sameSet (a, b) {
  if (a == b) { return true }
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++)
    { if (!a[i].eq(b[i])) { return false } }
  return true
};

// :: (?union<Mark, [Mark]>) → [Mark]
// Create a properly sorted mark set from null, a single mark, or an
// unsorted array of marks.
Mark.setFrom = function setFrom (marks) {
  if (!marks || marks.length == 0) { return Mark.none }
  if (marks instanceof Mark) { return [marks] }
  var copy = marks.slice();
  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
  return copy
};

// :: [Mark] The empty set of marks.
Mark.none = [];

// ReplaceError:: class extends Error
// Error type raised by [`Node.replace`](#model.Node.replace) when
// given an invalid replacement.

function ReplaceError(message) {
  var err = Error.call(this, message);
  err.__proto__ = ReplaceError.prototype;
  return err
}

ReplaceError.prototype = Object.create(Error.prototype);
ReplaceError.prototype.constructor = ReplaceError;
ReplaceError.prototype.name = "ReplaceError";

// ::- A slice represents a piece cut out of a larger document. It
// stores not only a fragment, but also the depth up to which nodes on
// both side are ‘open’ (cut through).
var Slice = function Slice(content, openStart, openEnd) {
  // :: Fragment The slice's content.
  this.content = content;
  // :: number The open depth at the start.
  this.openStart = openStart;
  // :: number The open depth at the end.
  this.openEnd = openEnd;
};

var prototypeAccessors$2 = { size: {} };

// :: number
// The size this slice would add when inserted into a document.
prototypeAccessors$2.size.get = function () {
  return this.content.size - this.openStart - this.openEnd
};

Slice.prototype.insertAt = function insertAt (pos, fragment) {
  var content = insertInto(this.content, pos + this.openStart, fragment, null);
  return content && new Slice(content, this.openStart, this.openEnd)
};

Slice.prototype.removeBetween = function removeBetween (from, to) {
  return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
};

// :: (Slice) → bool
// Tests whether this slice is equal to another slice.
Slice.prototype.eq = function eq (other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
};

Slice.prototype.toString = function toString () {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
};

// :: () → ?Object
// Convert a slice to a JSON-serializable representation.
Slice.prototype.toJSON = function toJSON () {
  if (!this.content.size) { return null }
  var json = {content: this.content.toJSON()};
  if (this.openStart > 0) { json.openStart = this.openStart; }
  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
  return json
};

// :: (Schema, ?Object) → Slice
// Deserialize a slice from its JSON representation.
Slice.fromJSON = function fromJSON (schema, json) {
  if (!json) { return Slice.empty }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number")
    { throw new RangeError("Invalid input for Slice.fromJSON") }
  return new Slice(Fragment.fromJSON(schema, json.content), json.openStart || 0, json.openEnd || 0)
};

// :: (Fragment, ?bool) → Slice
// Create a slice from a fragment by taking the maximum possible
// open value on both side of the fragment.
Slice.maxOpen = function maxOpen (fragment, openIsolating) {
    if ( openIsolating === void 0 ) openIsolating=true;

  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
  return new Slice(fragment, openStart, openEnd)
};

Object.defineProperties( Slice.prototype, prototypeAccessors$2 );

function removeRange(content, from, to) {
  var ref = content.findIndex(from);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  var ref$1 = content.findIndex(to);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
    return content.cut(0, from).append(content.cut(to))
  }
  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)))
}

function insertInto(content, dist, insert, parent) {
  var ref = content.findIndex(dist);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) { return null }
    return content.cut(0, dist).append(insert).append(content.cut(dist))
  }
  var inner = insertInto(child.content, dist - offset - 1, insert);
  return inner && content.replaceChild(index, child.copy(inner))
}

// :: Slice
// The empty slice.
Slice.empty = new Slice(Fragment.empty, 0, 0);

function replace($from, $to, slice) {
  if (slice.openStart > $from.depth)
    { throw new ReplaceError("Inserted content deeper than insertion position") }
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
    { throw new ReplaceError("Inconsistent open depths") }
  return replaceOuter($from, $to, slice, 0)
}

function replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth), node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner))
  } else if (!slice.content.size) {
    return close(node, replaceTwoWay($from, $to, depth))
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
    var parent = $from.parent, content = parent.content;
    return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
  } else {
    var ref = prepareSliceForReplace(slice, $from);
    var start = ref.start;
    var end = ref.end;
    return close(node, replaceThreeWay($from, start, end, $to, depth))
  }
}

function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    { throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
}

function joinable($before, $after, depth) {
  var node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node
}

function addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    { target[last] = child.withText(target[last].text + child.text); }
  else
    { target.push(child); }
}

function addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) { addNode(node.child(i), target); }
  if ($end && $end.depth == depth && $end.textOffset)
    { addNode($end.nodeBefore, target); }
}

function close(node, content) {
  if (!node.type.validContent(content))
    { throw new ReplaceError("Invalid content for node " + node.type.name) }
  return node.copy(content)
}

function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);

  var content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      { addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content); }
    addRange($start, $end, depth, content);
    if (openEnd)
      { addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content); }
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function replaceTwoWay($from, $to, depth) {
  var content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = joinable($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--)
    { node = $along.node(i).copy(Fragment.from(node)); }
  return {start: node.resolveNoCache(slice.openStart + extra),
          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
}

// ::- You can [_resolve_](#model.Node.resolve) a position to get more
// information about it. Objects of this class represent such a
// resolved position, providing various pieces of context information,
// and some helper methods.
//
// Throughout this interface, methods that take an optional `depth`
// parameter will interpret undefined as `this.depth` and negative
// numbers as `this.depth + value`.
var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
  // :: number The position that was resolved.
  this.pos = pos;
  this.path = path;
  // :: number
  // The number of levels the parent node is from the root. If this
  // position points directly into the root node, it is 0. If it
  // points into a top-level paragraph, 1, and so on.
  this.depth = path.length / 3 - 1;
  // :: number The offset this position has into its parent node.
  this.parentOffset = parentOffset;
};

var prototypeAccessors$3 = { parent: {},doc: {},textOffset: {},nodeAfter: {},nodeBefore: {} };

ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
  if (val == null) { return this.depth }
  if (val < 0) { return this.depth + val }
  return val
};

// :: Node
// The parent node that the position points into. Note that even if
// a position points into a text node, that node is not considered
// the parent—text nodes are ‘flat’ in this model, and have no content.
prototypeAccessors$3.parent.get = function () { return this.node(this.depth) };

// :: Node
// The root node in which the position was resolved.
prototypeAccessors$3.doc.get = function () { return this.node(0) };

// :: (?number) → Node
// The ancestor node at the given level. `p.node(p.depth)` is the
// same as `p.parent`.
ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };

// :: (?number) → number
// The index into the ancestor at the given level. If this points at
// the 3rd node in the 2nd paragraph on the top level, for example,
// `p.index(0)` is 2 and `p.index(1)` is 3.
ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };

// :: (?number) → number
// The index pointing after this position into the ancestor at the
// given level.
ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
};

// :: (?number) → number
// The (absolute) position at the start of the node at the given
// level.
ResolvedPos.prototype.start = function start (depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
};

// :: (?number) → number
// The (absolute) position at the end of the node at the given
// level.
ResolvedPos.prototype.end = function end (depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size
};

// :: (?number) → number
// The (absolute) position directly before the wrapping node at the
// given level, or, when `level` is `this.depth + 1`, the original
// position.
ResolvedPos.prototype.before = function before (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position before the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
};

// :: (?number) → number
// The (absolute) position directly after the wrapping node at the
// given level, or the original position when `level` is `this.depth + 1`.
ResolvedPos.prototype.after = function after (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position after the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
};

// :: number
// When this position points into a text node, this returns the
// distance between the position and the start of the text node.
// Will be zero for positions that point between nodes.
prototypeAccessors$3.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };

// :: ?Node
// Get the node directly after the position, if any. If the position
// points into a text node, only the part of that node after the
// position is returned.
prototypeAccessors$3.nodeAfter.get = function () {
  var parent = this.parent, index = this.index(this.depth);
  if (index == parent.childCount) { return null }
  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
  return dOff ? parent.child(index).cut(dOff) : child
};

// :: ?Node
// Get the node directly before the position, if any. If the
// position points into a text node, only the part of that node
// before the position is returned.
prototypeAccessors$3.nodeBefore.get = function () {
  var index = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) { return this.parent.child(index).cut(0, dOff) }
  return index == 0 ? null : this.parent.child(index - 1)
};

// :: () → [Mark]
// Get the marks at this position, factoring in the surrounding
// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
// position is at the start of a non-empty node, the marks of the
// node after it (if any) are returned.
ResolvedPos.prototype.marks = function marks () {
  var parent = this.parent, index = this.index();

  // In an empty parent, return the empty array
  if (parent.content.size == 0) { return Mark.none }

  // When inside a text node, just return the text node's marks
  if (this.textOffset) { return parent.child(index).marks }

  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
  // If the `after` flag is true of there is no node before, make
  // the node after this position the main reference.
  if (!main) { var tmp = main; main = other; other = tmp; }

  // Use all marks in the main node, except those that have
  // `inclusive` set to false and are not present in the other node.
  var marks = main.marks;
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
      { marks = marks[i--].removeFromSet(marks); } }

  return marks
};

// :: (ResolvedPos) → ?[Mark]
// Get the marks after the current position, if any, except those
// that are non-inclusive and not present at position `$end`. This
// is mostly useful for getting the set of marks to preserve after a
// deletion. Will return `null` if this position is at the end of
// its parent node or its parent node isn't a textblock (in which
// case no marks should be preserved).
ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
  var after = this.parent.maybeChild(this.index());
  if (!after || !after.isInline) { return null }

  var marks = after.marks, next = $end.parent.maybeChild($end.index());
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
      { marks = marks[i--].removeFromSet(marks); } }
  return marks
};

// :: (number) → number
// The depth up to which this position and the given (non-resolved)
// position share the same parent nodes.
ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
    var this$1 = this;

  for (var depth = this.depth; depth > 0; depth--)
    { if (this$1.start(depth) <= pos && this$1.end(depth) >= pos) { return depth } }
  return 0
};

// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
// Returns a range based on the place where this position and the
// given position diverge around block content. If both point into
// the same textblock, for example, a range around that textblock
// will be returned. If they point into different blocks, the range
// around those blocks in their shared ancestor is returned. You can
// pass in an optional predicate that will be called with a parent
// node to see if a range into that parent is acceptable.
ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
    var this$1 = this;
    if ( other === void 0 ) other = this;

  if (other.pos < this.pos) { return other.blockRange(this) }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
    { if (other.pos <= this$1.end(d) && (!pred || pred(this$1.node(d))))
      { return new NodeRange(this$1, other, d) } }
};

// :: (ResolvedPos) → bool
// Query whether the given position shares the same parent node.
ResolvedPos.prototype.sameParent = function sameParent (other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset
};

// :: (ResolvedPos) → ResolvedPos
// Return the greater of this and the given position.
ResolvedPos.prototype.max = function max (other) {
  return other.pos > this.pos ? other : this
};

// :: (ResolvedPos) → ResolvedPos
// Return the smaller of this and the given position.
ResolvedPos.prototype.min = function min (other) {
  return other.pos < this.pos ? other : this
};

ResolvedPos.prototype.toString = function toString () {
    var this$1 = this;

  var str = "";
  for (var i = 1; i <= this.depth; i++)
    { str += (str ? "/" : "") + this$1.node(i).type.name + "_" + this$1.index(i - 1); }
  return str + ":" + this.parentOffset
};

ResolvedPos.resolve = function resolve (doc, pos) {
  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
  var path = [];
  var start = 0, parentOffset = pos;
  for (var node = doc;;) {
    var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
    var rem = parentOffset - offset;
    path.push(node, index, start + offset);
    if (!rem) { break }
    node = node.child(index);
    if (node.isText) { break }
    parentOffset = rem - 1;
    start += offset + 1;
  }
  return new ResolvedPos(pos, path, parentOffset)
};

ResolvedPos.resolveCached = function resolveCached (doc, pos) {
  for (var i = 0; i < resolveCache.length; i++) {
    var cached = resolveCache[i];
    if (cached.pos == pos && cached.doc == doc) { return cached }
  }
  var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
  return result
};

Object.defineProperties( ResolvedPos.prototype, prototypeAccessors$3 );

var resolveCache = [];
var resolveCachePos = 0;
var resolveCacheSize = 12;

// ::- Represents a flat range of content, i.e. one that starts and
// ends in the same node.
var NodeRange = function NodeRange($from, $to, depth) {
  // :: ResolvedPos A resolved position along the start of the
  // content. May have a `depth` greater than this object's `depth`
  // property, since these are the positions that were used to
  // compute the range, not re-resolved positions directly at its
  // boundaries.
  this.$from = $from;
  // :: ResolvedPos A position along the end of the content. See
  // caveat for [`$from`](#model.NodeRange.$from).
  this.$to = $to;
  // :: number The depth of the node that this range points into.
  this.depth = depth;
};

var prototypeAccessors$1$1 = { start: {},end: {},parent: {},startIndex: {},endIndex: {} };

// :: number The position at the start of the range.
prototypeAccessors$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
// :: number The position at the end of the range.
prototypeAccessors$1$1.end.get = function () { return this.$to.after(this.depth + 1) };

// :: Node The parent node that the range points into.
prototypeAccessors$1$1.parent.get = function () { return this.$from.node(this.depth) };
// :: number The start index of the range in the parent node.
prototypeAccessors$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
// :: number The end index of the range in the parent node.
prototypeAccessors$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };

Object.defineProperties( NodeRange.prototype, prototypeAccessors$1$1 );

var emptyAttrs = Object.create(null);

// ::- This class represents a node in the tree that makes up a
// ProseMirror document. So a document is an instance of `Node`, with
// children that are also instances of `Node`.
//
// Nodes are persistent data structures. Instead of changing them, you
// create new ones with the content you want. Old ones keep pointing
// at the old document shape. This is made cheaper by sharing
// structure between the old and new data as much as possible, which a
// tree shape like this (without back pointers) makes easy.
//
// **Do not** directly mutate the properties of a `Node` object. See
// [the guide](/docs/guide/#doc) for more information.
var Node = function Node(type, attrs, content, marks) {
  // :: NodeType
  // The type of node that this is.
  this.type = type;

  // :: Object
  // An object mapping attribute names to values. The kind of
  // attributes allowed and required are
  // [determined](#model.NodeSpec.attrs) by the node type.
  this.attrs = attrs;

  // :: Fragment
  // A container holding the node's children.
  this.content = content || Fragment.empty;

  // :: [Mark]
  // The marks (things like whether it is emphasized or part of a
  // link) applied to this node.
  this.marks = marks || Mark.none;
};

var prototypeAccessors = { nodeSize: {},childCount: {},textContent: {},firstChild: {},lastChild: {},isBlock: {},isTextblock: {},inlineContent: {},isInline: {},isText: {},isLeaf: {},isAtom: {} };

// text:: ?string
// For text nodes, this contains the node's text content.

// :: number
// The size of this node, as defined by the integer-based [indexing
// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
// amount of characters. For other leaf nodes, it is one. For
// non-leaf nodes, it is the size of the content plus two (the start
// and end token).
prototypeAccessors.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };

// :: number
// The number of children that the node has.
prototypeAccessors.childCount.get = function () { return this.content.childCount };

// :: (number) → Node
// Get the child node at the given index. Raises an error when the
// index is out of range.
Node.prototype.child = function child (index) { return this.content.child(index) };

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };

// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes recursively between
// the given two positions that are relative to start of this node's
// content. The callback is invoked with the node, its
// parent-relative position, its parent node, and its child index.
// When the callback returns false for a given node, that node's
// children will not be recursed over. The last parameter can be
// used to specify a starting position to count from.
Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
    if ( startPos === void 0 ) startPos = 0;

  this.content.nodesBetween(from, to, f, startPos, this);
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. Doesn't
// descend into a node when the callback returns `false`.
Node.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.content.size, f);
};

// :: string
// Concatenates all the text nodes found in this fragment and its
// children.
prototypeAccessors.textContent.get = function () { return this.textBetween(0, this.content.size, "") };

// :: (number, number, ?string, ?string) → string
// Get all text between positions `from` and `to`. When
// `blockSeparator` is given, it will be inserted whenever a new
// block node is started. When `leafText` is given, it'll be
// inserted for every non-text leaf node encountered.
Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  return this.content.textBetween(from, to, blockSeparator, leafText)
};

// :: ?Node
// Returns this node's first child, or `null` if there are no
// children.
prototypeAccessors.firstChild.get = function () { return this.content.firstChild };

// :: ?Node
// Returns this node's last child, or `null` if there are no
// children.
prototypeAccessors.lastChild.get = function () { return this.content.lastChild };

// :: (Node) → bool
// Test whether two nodes represent the same piece of document.
Node.prototype.eq = function eq (other) {
  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
};

// :: (Node) → bool
// Compare the markup (type, attributes, and marks) of this node to
// those of another. Returns `true` if both have the same markup.
Node.prototype.sameMarkup = function sameMarkup (other) {
  return this.hasMarkup(other.type, other.attrs, other.marks)
};

// :: (NodeType, ?Object, ?[Mark]) → bool
// Check whether this node's markup correspond to the given type,
// attributes, and marks.
Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
  return this.type == type &&
    compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
    Mark.sameSet(this.marks, marks || Mark.none)
};

// :: (?Fragment) → Node
// Create a new node with the same markup as this node, containing
// the given content (or empty, if no content is given).
Node.prototype.copy = function copy (content) {
    if ( content === void 0 ) content = null;

  if (content == this.content) { return this }
  return new this.constructor(this.type, this.attrs, content, this.marks)
};

// :: ([Mark]) → Node
// Create a copy of this node, with the given set of marks instead
// of the node's own marks.
Node.prototype.mark = function mark (marks) {
  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
};

// :: (number, ?number) → Node
// Create a copy of this node with only the content between the
// given positions. If `to` is not given, it defaults to the end of
// the node.
Node.prototype.cut = function cut (from, to) {
  if (from == 0 && to == this.content.size) { return this }
  return this.copy(this.content.cut(from, to))
};

// :: (number, ?number) → Slice
// Cut out the part of the document between the given positions, and
// return it as a `Slice` object.
Node.prototype.slice = function slice (from, to, includeParents) {
    if ( to === void 0 ) to = this.content.size;
    if ( includeParents === void 0 ) includeParents = false;

  if (from == to) { return Slice.empty }

  var $from = this.resolve(from), $to = this.resolve(to);
  var depth = includeParents ? 0 : $from.sharedDepth(to);
  var start = $from.start(depth), node = $from.node(depth);
  var content = node.content.cut($from.pos - start, $to.pos - start);
  return new Slice(content, $from.depth - depth, $to.depth - depth)
};

// :: (number, number, Slice) → Node
// Replace the part of the document between the given positions with
// the given slice. The slice must 'fit', meaning its open sides
// must be able to connect to the surrounding content, and its
// content nodes must be valid children for the node they are placed
// into. If any of this is violated, an error of type
// [`ReplaceError`](#model.ReplaceError) is thrown.
Node.prototype.replace = function replace$1 (from, to, slice) {
  return replace(this.resolve(from), this.resolve(to), slice)
};

// :: (number) → ?Node
// Find the node directly after the given position.
Node.prototype.nodeAt = function nodeAt (pos) {
  for (var node = this;;) {
    var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
    node = node.maybeChild(index);
    if (!node) { return null }
    if (offset == pos || node.isText) { return node }
    pos -= offset + 1;
  }
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node after the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childAfter = function childAfter (pos) {
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  return {node: this.content.maybeChild(index), index: index, offset: offset}
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node before the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childBefore = function childBefore (pos) {
  if (pos == 0) { return {node: null, index: 0, offset: 0} }
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
  var node = this.content.child(index - 1);
  return {node: node, index: index - 1, offset: offset - node.nodeSize}
};

// :: (number) → ResolvedPos
// Resolve the given position in the document, returning an
// [object](#model.ResolvedPos) with information about its context.
Node.prototype.resolve = function resolve (pos) { return ResolvedPos.resolveCached(this, pos) };

Node.prototype.resolveNoCache = function resolveNoCache (pos) { return ResolvedPos.resolve(this, pos) };

// :: (number, number, MarkType) → bool
// Test whether a mark of the given type occurs in this document
// between the two given positions.
Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
  var found = false;
  if (to > from) { this.nodesBetween(from, to, function (node) {
    if (type.isInSet(node.marks)) { found = true; }
    return !found
  }); }
  return found
};

// :: bool
// True when this is a block (non-inline node)
prototypeAccessors.isBlock.get = function () { return this.type.isBlock };

// :: bool
// True when this is a textblock node, a block node with inline
// content.
prototypeAccessors.isTextblock.get = function () { return this.type.isTextblock };

// :: bool
// True when this node allows inline content.
prototypeAccessors.inlineContent.get = function () { return this.type.inlineContent };

// :: bool
// True when this is an inline node (a text node or a node that can
// appear among text).
prototypeAccessors.isInline.get = function () { return this.type.isInline };

// :: bool
// True when this is a text node.
prototypeAccessors.isText.get = function () { return this.type.isText };

// :: bool
// True when this is a leaf node.
prototypeAccessors.isLeaf.get = function () { return this.type.isLeaf };

// :: bool
// True when this is an atom, i.e. when it does not have directly
// editable content. This is usually the same as `isLeaf`, but can
// be configured with the [`atom` property](#model.NodeSpec.atom) on
// a node's spec (typically used when the node is displayed as an
// uneditable [node view](#view.NodeView)).
prototypeAccessors.isAtom.get = function () { return this.type.isAtom };

// :: () → string
// Return a string representation of this node for debugging
// purposes.
Node.prototype.toString = function toString () {
  if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
  var name = this.type.name;
  if (this.content.size)
    { name += "(" + this.content.toStringInner() + ")"; }
  return wrapMarks(this.marks, name)
};

// :: (number) → ContentMatch
// Get the content match in this node at the given index.
Node.prototype.contentMatchAt = function contentMatchAt (index) {
  var match = this.type.contentMatch.matchFragment(this.content, 0, index);
  if (!match) { throw new Error("Called contentMatchAt on a node with invalid content") }
  return match
};

// :: (number, number, ?Fragment, ?number, ?number) → bool
// Test whether replacing the range between `from` and `to` (by
// child index) with the given replacement fragment (which defaults
// to the empty fragment) would leave the node's content valid. You
// can optionally pass `start` and `end` indices into the
// replacement fragment.
Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
    var this$1 = this;
    if ( replacement === void 0 ) replacement = Fragment.empty;
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = replacement.childCount;

  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
  var two = one && one.matchFragment(this.content, to);
  if (!two || !two.validEnd) { return false }
  for (var i = start; i < end; i++) { if (!this$1.type.allowsMarks(replacement.child(i).marks)) { return false } }
  return true
};

// :: (number, number, NodeType, ?[Mark]) → bool
// Test whether replacing the range `from` to `to` (by index) with a
// node of the given type would leave the node's content valid.
Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
  if (marks && !this.type.allowsMarks(marks)) { return false }
  var start = this.contentMatchAt(from).matchType(type);
  var end = start && start.matchFragment(this.content, to);
  return end ? end.validEnd : false
};

// :: (Node) → bool
// Test whether the given node's content could be appended to this
// node. If that node is empty, this will only return true if there
// is at least one node type that can appear in both nodes (to avoid
// merging completely incompatible nodes).
Node.prototype.canAppend = function canAppend (other) {
  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
  else { return this.type.compatibleContent(other.type) }
};

// Unused. Left for backwards compatibility.
Node.prototype.defaultContentType = function defaultContentType (at) {
  return this.contentMatchAt(at).defaultType
};

// :: ()
// Check whether this node and its descendants conform to the
// schema, and raise error when they do not.
Node.prototype.check = function check () {
  if (!this.type.validContent(this.content))
    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
  this.content.forEach(function (node) { return node.check(); });
};

// :: () → Object
// Return a JSON-serializeable representation of this node.
Node.prototype.toJSON = function toJSON () {
    var this$1 = this;

  var obj = {type: this.type.name};
  for (var _ in this$1.attrs) {
    obj.attrs = this$1.attrs;
    break
  }
  if (this.content.size)
    { obj.content = this.content.toJSON(); }
  if (this.marks.length)
    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
  return obj
};

// :: (Schema, Object) → Node
// Deserialize a node from its JSON representation.
Node.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
  var marks = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
    marks = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
    return schema.text(json.text, marks)
  }
  var content = Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content, marks)
};

Object.defineProperties( Node.prototype, prototypeAccessors );

var TextNode = (function (Node) {
  function TextNode(type, attrs, content, marks) {
    Node.call(this, type, attrs, null, marks);

    if (!content) { throw new RangeError("Empty text nodes are not allowed") }

    this.text = content;
  }

  if ( Node ) TextNode.__proto__ = Node;
  TextNode.prototype = Object.create( Node && Node.prototype );
  TextNode.prototype.constructor = TextNode;

  var prototypeAccessors$1 = { textContent: {},nodeSize: {} };

  TextNode.prototype.toString = function toString () {
    if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
    return wrapMarks(this.marks, JSON.stringify(this.text))
  };

  prototypeAccessors$1.textContent.get = function () { return this.text };

  TextNode.prototype.textBetween = function textBetween (from, to) { return this.text.slice(from, to) };

  prototypeAccessors$1.nodeSize.get = function () { return this.text.length };

  TextNode.prototype.mark = function mark (marks) {
    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks)
  };

  TextNode.prototype.withText = function withText (text) {
    if (text == this.text) { return this }
    return new TextNode(this.type, this.attrs, text, this.marks)
  };

  TextNode.prototype.cut = function cut (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.text.length;

    if (from == 0 && to == this.text.length) { return this }
    return this.withText(this.text.slice(from, to))
  };

  TextNode.prototype.eq = function eq (other) {
    return this.sameMarkup(other) && this.text == other.text
  };

  TextNode.prototype.toJSON = function toJSON () {
    var base = Node.prototype.toJSON.call(this);
    base.text = this.text;
    return base
  };

  Object.defineProperties( TextNode.prototype, prototypeAccessors$1 );

  return TextNode;
}(Node));

function wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--)
    { str = marks[i].type.name + "(" + str + ")"; }
  return str
}

// ::- Instances of this class represent a match state of a node
// type's [content expression](#model.NodeSpec.content), and can be
// used to find out whether further content matches here, and whether
// a given position is a valid end of the node.
var ContentMatch = function ContentMatch(validEnd) {
  // :: bool
  // True when this match state represents a valid end of the node.
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};

var prototypeAccessors$5 = { inlineContent: {},defaultType: {},edgeCount: {} };

ContentMatch.parse = function parse (string, nodeTypes) {
  var stream = new TokenStream(string, nodeTypes);
  if (stream.next == null) { return ContentMatch.empty }
  var expr = parseExpr(stream);
  if (stream.next) { stream.err("Unexpected trailing text"); }
  var match = dfa(nfa(expr));
  checkForDeadEnds(match, stream);
  return match
};

// :: (NodeType) → ?ContentMatch
// Match a node type, returning a match after that node if
// successful.
ContentMatch.prototype.matchType = function matchType (type) {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2)
    { if (this$1.next[i] == type) { return this$1.next[i + 1] } }
  return null
};

// :: (Fragment, ?number, ?number) → ?ContentMatch
// Try to match a fragment. Returns the resulting match when
// successful.
ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = frag.childCount;

  var cur = this;
  for (var i = start; cur && i < end; i++)
    { cur = cur.matchType(frag.child(i).type); }
  return cur
};

prototypeAccessors$5.inlineContent.get = function () {
  var first = this.next[0];
  return first ? first.isInline : false
};

// :: ?NodeType
// Get the first matching node type at this match position that can
// be generated.
prototypeAccessors$5.defaultType.get = function () {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2) {
    var type = this$1.next[i];
    if (!(type.isText || type.hasRequiredAttrs())) { return type }
  }
};

ContentMatch.prototype.compatible = function compatible (other) {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2)
    { for (var j = 0; j < other.next.length; j += 2)
      { if (this$1.next[i] == other.next[j]) { return true } } }
  return false
};

// :: (Fragment, bool, ?number) → ?Fragment
// Try to match the given fragment, and if that fails, see if it can
// be made to match by inserting nodes in front of it. When
// successful, return a fragment of inserted nodes (which may be
// empty if nothing had to be inserted). When `toEnd` is true, only
// return a fragment if the resulting match goes to the end of the
// content expression.
ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
    if ( toEnd === void 0 ) toEnd = false;
    if ( startIndex === void 0 ) startIndex = 0;

  var seen = [this];
  function search(match, types) {
    var finished = match.matchFragment(after, startIndex);
    if (finished && (!toEnd || finished.validEnd))
      { return Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }

    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i], next = match.next[i + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found = search(next, types.concat(type));
        if (found) { return found }
      }
    }
  }

  return search(this, [])
};

// :: (NodeType) → ?[NodeType]
// Find a set of wrapping node types that would allow a node of the
// given type to appear at this position. The result may be empty
// (when it fits directly) and will be null when no such wrapping
// exists.
ContentMatch.prototype.findWrapping = function findWrapping (target) {
    var this$1 = this;

  for (var i = 0; i < this.wrapCache.length; i += 2)
    { if (this$1.wrapCache[i] == target) { return this$1.wrapCache[i + 1] } }
  var computed = this.computeWrapping(target);
  this.wrapCache.push(target, computed);
  return computed
};

ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result = [];
      for (var obj = current; obj.type; obj = obj.via)
        { result.push(obj.type); }
      return result.reverse()
    }
    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i];
      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
        active.push({match: type.contentMatch, type: type, via: current});
        seen[type.name] = true;
      }
    }
  }
};

// :: number
// The number of outgoing edges this node has in the finite
// automaton that describes the content expression.
prototypeAccessors$5.edgeCount.get = function () {
  return this.next.length >> 1
};

// :: (number) → {type: NodeType, next: ContentMatch}
// Get the _n_th outgoing edge from this node in the finite
// automaton that describes the content expression.
ContentMatch.prototype.edge = function edge (n) {
  var i = n << 1;
  if (i > this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
  return {type: this.next[i], next: this.next[i + 1]}
};

ContentMatch.prototype.toString = function toString () {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i = 1; i < m.next.length; i += 2)
      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
  }
  scan(this);
  return seen.map(function (m, i) {
    var out = i + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
    return out
  }).join("\n")
};

Object.defineProperties( ContentMatch.prototype, prototypeAccessors$5 );

ContentMatch.empty = new ContentMatch(true);

var TokenStream = function TokenStream(string, nodeTypes) {
  this.string = string;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
  if (this.tokens[0] == "") { this.tokens.unshift(); }
};

var prototypeAccessors$1$3 = { next: {} };

prototypeAccessors$1$3.next.get = function () { return this.tokens[this.pos] };

TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };

TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };

Object.defineProperties( TokenStream.prototype, prototypeAccessors$1$3 );

function parseExpr(stream) {
  var exprs = [];
  do { exprs.push(parseExprSeq(stream)); }
  while (stream.eat("|"))
  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
}

function parseExprSeq(stream) {
  var exprs = [];
  do { exprs.push(parseExprSubscript(stream)); }
  while (stream.next && stream.next != ")" && stream.next != "|")
  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
}

function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+"))
      { expr = {type: "plus", expr: expr}; }
    else if (stream.eat("*"))
      { expr = {type: "star", expr: expr}; }
    else if (stream.eat("?"))
      { expr = {type: "opt", expr: expr}; }
    else if (stream.eat("{"))
      { expr = parseExprRange(stream, expr); }
    else { break }
  }
  return expr
}

function parseNum(stream) {
  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
  var result = Number(stream.next);
  stream.pos++;
  return result
}

function parseExprRange(stream, expr) {
  var min = parseNum(stream), max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") { max = parseNum(stream); }
    else { max = -1; }
  }
  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
  return {type: "range", min: min, max: max, expr: expr}
}

function resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) { return [type] }
  var result = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
  }
  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
  return result
}

function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
    return expr
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) { stream.inline = type.isInline; }
      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
      return {type: "name", value: type}
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}

// The code below helps compile a regular-expression-like language
// into a deterministic finite automaton. For a good introduction to
// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html

// : (Object) → [[{term: ?any, to: number}]]
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa

  function node() { return nfa.push([]) - 1 }
  function edge(from, to, term) {
    var edge = {term: term, to: to};
    nfa[from].push(edge);
    return edge
  }
  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }

  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) { return next }
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)]
    } else if (expr.type == "plus") {
      var loop$1 = node();
      connect(compile(expr.expr, from), loop$1);
      connect(compile(expr.expr, loop$1), loop$1);
      return [edge(loop$1)]
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from))
    } else if (expr.type == "range") {
      var cur = from;
      for (var i$1 = 0; i$1 < expr.min; i$1++) {
        var next$1 = node();
        connect(compile(expr.expr, cur), next$1);
        cur = next$1;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
          var next$2 = node();
          edge(cur, next$2);
          connect(compile(expr.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge(cur)]
    } else if (expr.type == "name") {
      return [edge(from, null, expr.value)]
    }
  }
}

function cmp(a, b) { return a - b }

// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(cmp)

  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var ref = edges[i];
      var term = ref.term;
      var to = ref.to;
      if (!term && result.indexOf(to) == -1) { scan(to); }
    }
  }
}

// : ([[{term: ?any, to: number}]]) → ContentMatch
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
  var labeled = Object.create(null);
  return explore(nullFrom(nfa, 0))

  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (ref) {
        var term = ref.term;
        var to = ref.to;

        if (!term) { return }
        var known = out.indexOf(term), set = known > -1 && out[known + 1];
        nullFrom(nfa, to).forEach(function (node) {
          if (!set) { out.push(term, set = []); }
          if (set.indexOf(node) == -1) { set.push(node); }
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i += 2) {
      var states$1 = out[i + 1].sort(cmp);
      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
    }
    return state
  }
}

function checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node = state.next[j], next = state.next[j + 1];
      nodes.push(node.name);
      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
      if (work.indexOf(next) == -1) { work.push(next); }
    }
    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position"); }
  }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) { return null }
    defaults[attrName] = attr.default;
  }
  return defaults
}

function computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) { given = attr.default; }
      else { throw new RangeError("No value supplied for attribute " + name) }
    }
    built[name] = given;
  }
  return built
}

function initAttrs(attrs) {
  var result = Object.create(null);
  if (attrs) { for (var name in attrs) { result[name] = new Attribute(attrs[name]); } }
  return result
}

// ::- Node types are objects allocated once per `Schema` and used to
// [tag](#model.Node.type) `Node` instances. They contain information
// about the node type, such as its name and what kind of node it
// represents.
var NodeType = function NodeType(name, schema, spec) {
  // :: string
  // The name the node type has in this schema.
  this.name = name;

  // :: Schema
  // A link back to the `Schema` the node type belongs to.
  this.schema = schema;

  // :: NodeSpec
  // The spec that this type is based on
  this.spec = spec;

  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = initAttrs(spec.attrs);

  this.defaultAttrs = defaultAttrs(this.attrs);

  // :: ContentMatch
  // The starting match of the node type's content expression.
  this.contentMatch = null;

  // : ?[MarkType]
  // The set of marks allowed in this node. `null` means all marks
  // are allowed.
  this.markSet = null;

  // :: bool
  // True if this node type has inline content.
  this.inlineContent = null;

  // :: bool
  // True if this is a block type
  this.isBlock = !(spec.inline || name == "text");

  // :: bool
  // True if this is the text node type.
  this.isText = name == "text";
};

var prototypeAccessors$4 = { isInline: {},isTextblock: {},isLeaf: {},isAtom: {} };

// :: bool
// True if this is an inline type.
prototypeAccessors$4.isInline.get = function () { return !this.isBlock };

// :: bool
// True if this is a textblock type, a block that contains inline
// content.
prototypeAccessors$4.isTextblock.get = function () { return this.isBlock && this.inlineContent };

// :: bool
// True for node types that allow no content.
prototypeAccessors$4.isLeaf.get = function () { return this.contentMatch == ContentMatch.empty };

// :: bool
// True when this node is an atom, i.e. when it does not have
// directly editable content.
prototypeAccessors$4.isAtom.get = function () { return this.isLeaf || this.spec.atom };

NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs (ignore) {
    var this$1 = this;

  for (var n in this$1.attrs)
    { if (this$1.attrs[n].isRequired && (!ignore || !(n in ignore))) { return true } }
  return false
};

NodeType.prototype.compatibleContent = function compatibleContent (other) {
  return this == other || this.contentMatch.compatible(other.contentMatch)
};

NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
  else { return computeAttrs(this.attrs, attrs) }
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a `Node` of this type. The given attributes are
// checked and defaulted (you can pass `null` to use the type's
// defaults entirely, if no required attributes exist). `content`
// may be a `Fragment`, a node, an array of nodes, or
// `null`. Similarly `marks` may be `null` to default to the empty
// set of marks.
NodeType.prototype.create = function create (attrs, content, marks) {
  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
  return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Like [`create`](#model.NodeType.create), but check the given content
// against the node type's content restrictions, and throw an error
// if it doesn't match.
NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
  content = Fragment.from(content);
  if (!this.validContent(content))
    { throw new RangeError("Invalid content for node " + this.name) }
  return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
// Like [`create`](#model.NodeType.create), but see if it is necessary to
// add nodes to the start or end of the given fragment to make it
// fit the node. If no fitting wrapping can be found, return null.
// Note that, due to the fact that required nodes can always be
// created, this will always succeed if you pass null or
// `Fragment.empty` as content.
NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
  attrs = this.computeAttrs(attrs);
  content = Fragment.from(content);
  if (content.size) {
    var before = this.contentMatch.fillBefore(content);
    if (!before) { return null }
    content = before.append(content);
  }
  var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);
  if (!after) { return null }
  return new Node(this, attrs, content.append(after), Mark.setFrom(marks))
};

// :: (Fragment) → bool
// Returns true if the given fragment is valid content for this node
// type with the given attributes.
NodeType.prototype.validContent = function validContent (content) {
    var this$1 = this;

  var result = this.contentMatch.matchFragment(content);
  if (!result || !result.validEnd) { return false }
  for (var i = 0; i < content.childCount; i++)
    { if (!this$1.allowsMarks(content.child(i).marks)) { return false } }
  return true
};

// :: (MarkType) → bool
// Check whether the given mark type is allowed in this node.
NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1
};

// :: ([Mark]) → bool
// Test whether the given set of marks are allowed in this node.
NodeType.prototype.allowsMarks = function allowsMarks (marks) {
    var this$1 = this;

  if (this.markSet == null) { return true }
  for (var i = 0; i < marks.length; i++) { if (!this$1.allowsMarkType(marks[i].type)) { return false } }
  return true
};

// :: ([Mark]) → [Mark]
// Removes the marks that are not allowed in this node from the given set.
NodeType.prototype.allowedMarks = function allowedMarks (marks) {
    var this$1 = this;

  if (this.markSet == null) { return marks }
  var copy;
  for (var i = 0; i < marks.length; i++) {
    if (!this$1.allowsMarkType(marks[i].type)) {
      if (!copy) { copy = marks.slice(0, i); }
    } else if (copy) {
      copy.push(marks[i]);
    }
  }
  return !copy ? marks : copy.length ? copy : Mark.empty
};

NodeType.compile = function compile (nodes, schema) {
  var result = Object.create(null);
  nodes.forEach(function (name, spec) { return result[name] = new NodeType(name, schema, spec); });

  var topType = schema.spec.topNode || "doc";
  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }

  return result
};

Object.defineProperties( NodeType.prototype, prototypeAccessors$4 );

// Attribute descriptors

var Attribute = function Attribute(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};

var prototypeAccessors$1$2 = { isRequired: {} };

prototypeAccessors$1$2.isRequired.get = function () {
  return !this.hasDefault
};

Object.defineProperties( Attribute.prototype, prototypeAccessors$1$2 );

// Marks

// ::- Like nodes, marks (which are associated with nodes to signify
// things like emphasis or being part of a link) are
// [tagged](#model.Mark.type) with type objects, which are
// instantiated once per `Schema`.
var MarkType = function MarkType(name, rank, schema, spec) {
  // :: string
  // The name of the mark type.
  this.name = name;

  // :: Schema
  // The schema that this mark type instance is part of.
  this.schema = schema;

  // :: MarkSpec
  // The spec on which the type is based.
  this.spec = spec;

  this.attrs = initAttrs(spec.attrs);

  this.rank = rank;
  this.excluded = null;
  var defaults = defaultAttrs(this.attrs);
  this.instance = defaults && new Mark(this, defaults);
};

// :: (?Object) → Mark
// Create a mark of this type. `attrs` may be `null` or an object
// containing only some of the mark's attributes. The others, if
// they have defaults, will be added.
MarkType.prototype.create = function create (attrs) {
  if (!attrs && this.instance) { return this.instance }
  return new Mark(this, computeAttrs(this.attrs, attrs))
};

MarkType.compile = function compile (marks, schema) {
  var result = Object.create(null), rank = 0;
  marks.forEach(function (name, spec) { return result[name] = new MarkType(name, rank++, schema, spec); });
  return result
};

// :: ([Mark]) → [Mark]
// When there is a mark of this type in the given set, a new set
// without it is returned. Otherwise, the input set is returned.
MarkType.prototype.removeFromSet = function removeFromSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this$1)
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → ?Mark
// Tests whether there is a mark of this type in the given set.
MarkType.prototype.isInSet = function isInSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this$1) { return set[i] } }
};

// :: (MarkType) → bool
// Queries whether a given mark type is
// [excluded](#model.MarkSpec.excludes) by this one.
MarkType.prototype.excludes = function excludes (other) {
  return this.excluded.indexOf(other) > -1
};

// SchemaSpec:: interface
// An object describing a schema, as passed to the [`Schema`](#model.Schema)
// constructor.
//
//   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
//   The node types in this schema. Maps names to
//   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
//   associated with that name. Their order is significant—it
//   determines which [parse rules](#model.NodeSpec.parseDOM) take
//   precedence by default, and which nodes come first in a given
//   [group](#model.NodeSpec.group).
//
//   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
//   The mark types that exist in this schema. The order in which they
//   are provided determines the order in which [mark
//   sets](#model.Mark.addToSet) are sorted and in which [parse
//   rules](#model.MarkSpec.parseDOM) are tried.
//
//   topNode:: ?string
//   The name of the default top-level node for the schema. Defaults
//   to `"doc"`.

// NodeSpec:: interface
//
//   content:: ?string
//   The content expression for this node, as described in the [schema
//   guide](/docs/guide/#schema.content_expressions). When not given,
//   the node does not allow any content.
//
//   marks:: ?string
//   The marks that are allowed inside of this node. May be a
//   space-separated string referring to mark names or groups, `"_"`
//   to explicitly allow all marks, or `""` to disallow marks. When
//   not given, nodes with inline content default to allowing all
//   marks, other nodes default to not allowing marks.
//
//   group:: ?string
//   The group or space-separated groups to which this node belongs,
//   which can be referred to in the content expressions for the
//   schema.
//
//   inline:: ?bool
//   Should be set to true for inline nodes. (Implied for text nodes.)
//
//   atom:: ?bool
//   Can be set to true to indicate that, though this isn't a [leaf
//   node](#model.NodeType.isLeaf), it doesn't have directly editable
//   content and should be treated as a single unit in the view.
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that nodes of this type get.
//
//   selectable:: ?bool
//   Controls whether nodes of this type can be selected as a [node
//   selection](#state.NodeSelection). Defaults to true for non-text
//   nodes.
//
//   draggable:: ?bool
//   Determines whether nodes of this type can be dragged without
//   being selected. Defaults to false.
//
//   code:: ?bool
//   Can be used to indicate that this node contains code, which
//   causes some commands to behave differently.
//
//   defining:: ?bool
//   Determines whether this node is considered an important parent
//   node during replace operations (such as paste). Non-defining (the
//   default) nodes get dropped when their entire content is replaced,
//   whereas defining nodes persist and wrap the inserted content.
//   Likewise, in _inserted_ content the defining parents of the
//   content are preserved when possible. Typically,
//   non-default-paragraph textblock types, and possibly list items,
//   are marked as defining.
//
//   isolating:: ?bool
//   When enabled (default is false), the sides of nodes of this type
//   count as boundaries that regular editing operations, like
//   backspacing or lifting, won't cross. An example of a node that
//   should probably have this enabled is a table cell.
//
//   toDOM:: ?(node: Node) → DOMOutputSpec
//   Defines the default way a node of this type should be serialized
//   to DOM/HTML (as used by
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
//   Should return a DOM node or an [array
//   structure](#model.DOMOutputSpec) that describes one, with an
//   optional number zero (“hole”) in it to indicate where the node's
//   content should be inserted.
//
//   For text nodes, the default is to create a text DOM node. Though
//   it is possible to create a serializer where text is rendered
//   differently, this is not supported inside the editor, so you
//   shouldn't override that in your text node spec.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this node, which can be
//   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
//   automatically derive a parser. The `node` field in the rules is
//   implied (the name of this node will be filled in automatically).
//   If you supply your own parser, you do not need to also specify
//   parsing rules in your schema.
//
//   toDebugString:: ?(node: Node) -> string
//   Defines the default way a node of this type should be serialized
//   to a string representation for debugging (e.g. in error messages).

// MarkSpec:: interface
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that marks of this type get.
//
//   inclusive:: ?bool
//   Whether this mark should be active when the cursor is positioned
//   at its end (or at its start when that is also the start of the
//   parent node). Defaults to true.
//
//   excludes:: ?string
//   Determines which other marks this mark can coexist with. Should
//   be a space-separated strings naming other marks or groups of marks.
//   When a mark is [added](#model.Mark.addToSet) to a set, all marks
//   that it excludes are removed in the process. If the set contains
//   any mark that excludes the new mark but is not, itself, excluded
//   by the new mark, the mark can not be added an the set. You can
//   use the value `"_"` to indicate that the mark excludes all
//   marks in the schema.
//
//   Defaults to only being exclusive with marks of the same type. You
//   can set it to an empty string (or any string not containing the
//   mark's own name) to allow multiple marks of a given type to
//   coexist (as long as they have different attributes).
//
//   group:: ?string
//   The group or space-separated groups to which this mark belongs.
//
//   spanning:: ?bool
//   Determines whether marks of this type can span multiple adjacent
//   nodes when serialized to DOM/HTML. Defaults to true.
//
//   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
//   Defines the default way marks of this type should be serialized
//   to DOM/HTML. When the resulting spec contains a hole, that is
//   where the marked content is placed. Otherwise, it is appended to
//   the top node.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this mark (see the
//   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
//   `mark` field in the rules is implied.

// AttributeSpec:: interface
//
// Used to [define](#model.NodeSpec.attrs) attributes on nodes or
// marks.
//
//   default:: ?any
//   The default value for this attribute, to use when no explicit
//   value is provided. Attributes that have no default must be
//   provided whenever a node or mark of a type that has them is
//   created.

// ::- A document schema. Holds [node](#model.NodeType) and [mark
// type](#model.MarkType) objects for the nodes and marks that may
// occur in conforming documents, and provides functionality for
// creating and deserializing such documents.
var Schema = function Schema(spec) {
  var this$1 = this;

  // :: SchemaSpec
  // The [spec](#model.SchemaSpec) on which the schema is based,
  // with the added guarantee that its `nodes` and `marks`
  // properties are
  // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
  // (not raw objects).
  this.spec = {};
  for (var prop in spec) { this$1.spec[prop] = spec[prop]; }
  this.spec.nodes = OrderedMap.from(spec.nodes);
  this.spec.marks = OrderedMap.from(spec.marks);

  // :: Object<NodeType>
  // An object mapping the schema's node names to node type objects.
  this.nodes = NodeType.compile(this.spec.nodes, this);

  // :: Object<MarkType>
  // A map from mark names to mark type objects.
  this.marks = MarkType.compile(this.spec.marks, this);

  var contentExprCache = Object.create(null);
  for (var prop$1 in this$1.nodes) {
    if (prop$1 in this$1.marks)
      { throw new RangeError(prop$1 + " can not be both a node and a mark") }
    var type = this$1.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
    type.contentMatch = contentExprCache[contentExpr] ||
      (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this$1.nodes));
    type.inlineContent = type.contentMatch.inlineContent;
    type.markSet = markExpr == "_" ? null :
      markExpr ? gatherMarks(this$1, markExpr.split(" ")) :
      markExpr == "" || !type.inlineContent ? [] : null;
  }
  for (var prop$2 in this$1.marks) {
    var type$1 = this$1.marks[prop$2], excl = type$1.spec.excludes;
    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this$1, excl.split(" "));
  }

  this.nodeFromJSON = this.nodeFromJSON.bind(this);
  this.markFromJSON = this.markFromJSON.bind(this);

  // :: NodeType
  // The type of the [default top node](#model.SchemaSpec.topNode)
  // for this schema.
  this.topNodeType = this.nodes[this.spec.topNode || "doc"];

  // :: Object
  // An object for storing whatever values modules may want to
  // compute and cache per schema. (If you want to store something
  // in it, try to use property names unlikely to clash.)
  this.cached = Object.create(null);
  this.cached.wrappings = Object.create(null);
};

// :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a node in this schema. The `type` may be a string or a
// `NodeType` instance. Attributes will be extended
// with defaults, `content` may be a `Fragment`,
// `null`, a `Node`, or an array of nodes.
Schema.prototype.node = function node (type, attrs, content, marks) {
  if (typeof type == "string")
    { type = this.nodeType(type); }
  else if (!(type instanceof NodeType))
    { throw new RangeError("Invalid node type: " + type) }
  else if (type.schema != this)
    { throw new RangeError("Node type from different schema used (" + type.name + ")") }

  return type.createChecked(attrs, content, marks)
};

// :: (string, ?[Mark]) → Node
// Create a text node in the schema. Empty text nodes are not
// allowed.
Schema.prototype.text = function text (text$1, marks) {
  var type = this.nodes.text;
  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks))
};

// :: (union<string, MarkType>, ?Object) → Mark
// Create a mark with the given type and attributes.
Schema.prototype.mark = function mark (type, attrs) {
  if (typeof type == "string") { type = this.marks[type]; }
  return type.create(attrs)
};

// :: (Object) → Node
// Deserialize a node from its JSON representation. This method is
// bound.
Schema.prototype.nodeFromJSON = function nodeFromJSON (json) {
  return Node.fromJSON(this, json)
};

// :: (Object) → Mark
// Deserialize a mark from its JSON representation. This method is
// bound.
Schema.prototype.markFromJSON = function markFromJSON (json) {
  return Mark.fromJSON(this, json)
};

Schema.prototype.nodeType = function nodeType (name) {
  var found = this.nodes[name];
  if (!found) { throw new RangeError("Unknown node type: " + name) }
  return found
};

function gatherMarks(schema, marks) {
  var found = [];
  for (var i = 0; i < marks.length; i++) {
    var name = marks[i], mark = schema.marks[name], ok = mark;
    if (mark) {
      found.push(mark);
    } else {
      for (var prop in schema.marks) {
        var mark$1 = schema.marks[prop];
        if (name == "_" || (mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1))
          { found.push(ok = mark$1); }
      }
    }
    if (!ok) { throw new SyntaxError("Unknown mark type: '" + marks[i] + "'") }
  }
  return found
}

// ParseOptions:: interface
// These are the options recognized by the
// [`parse`](#model.DOMParser.parse) and
// [`parseSlice`](#model.DOMParser.parseSlice) methods.
//
//   preserveWhitespace:: ?union<bool, "full">
//   By default, whitespace is collapsed as per HTML's rules. Pass
//   `true` to preserve whitespace, but normalize newlines to
//   spaces, and `"full"` to preserve whitespace entirely.
//
//   findPositions:: ?[{node: dom.Node, offset: number}]
//   When given, the parser will, beside parsing the content,
//   record the document positions of the given DOM positions. It
//   will do so by writing to the objects, adding a `pos` property
//   that holds the document position. DOM positions that are not
//   in the parsed content will not be written to.
//
//   from:: ?number
//   The child node index to start parsing from.
//
//   to:: ?number
//   The child node index to stop parsing at.
//
//   topNode:: ?Node
//   By default, the content is parsed into the schema's default
//   [top node type](#model.Schema.topNodeType). You can pass this
//   option to use the type and attributes from a different node
//   as the top container.
//
//   topMatch:: ?ContentMatch
//   Provide the starting content match that content parsed into the
//   top node is matched against.
//
//   context:: ?ResolvedPos
//   A set of additional nodes to count as
//   [context](#model.ParseRule.context) when parsing, above the
//   given [top node](#model.ParseOptions.topNode).

// ParseRule:: interface
// A value that describes how to parse a given DOM node or inline
// style as a ProseMirror node or mark.
//
//   tag:: ?string
//   A CSS selector describing the kind of DOM elements to match. A
//   single rule should have _either_ a `tag` or a `style` property.
//
//   namespace:: ?string
//   The namespace to match. This should be used with `tag`.
//   Nodes are only matched when the namespace matches or this property
//   is null.
//
//   style:: ?string
//   A CSS property name to match. When given, this rule matches
//   inline styles that list that property. May also have the form
//   `"property=value"`, in which case the rule only matches if the
//   propery's value exactly matches the given value. (For more
//   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
//   and return undefined to indicate that the match failed.)
//
//   priority:: ?number
//   Can be used to change the order in which the parse rules in a
//   schema are tried. Those with higher priority come first. Rules
//   without a priority are counted as having priority 50. This
//   property is only meaningful in a schema—when directly
//   constructing a parser, the order of the rule array is used.
//
//   context:: ?string
//   When given, restricts this rule to only match when the current
//   context—the parent nodes into which the content is being
//   parsed—matches this expression. Should contain one or more node
//   names or node group names followed by single or double slashes.
//   For example `"paragraph/"` means the rule only matches when the
//   parent node is a paragraph, `"blockquote/paragraph/"` restricts
//   it to be in a paragraph that is inside a blockquote, and
//   `"section//"` matches any position inside a section—a double
//   slash matches any sequence of ancestor nodes. To allow multiple
//   different contexts, they can be separated by a pipe (`|`)
//   character, as in `"blockquote/|list_item/"`.
//
//   node:: ?string
//   The name of the node type to create when this rule matches. Only
//   valid for rules with a `tag` property, not for style rules. Each
//   rule should have one of a `node`, `mark`, or `ignore` property
//   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
//   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
//   or `mark` property will be derived from its position).
//
//   mark:: ?string
//   The name of the mark type to wrap the matched content in.
//
//   ignore:: ?bool
//   When true, ignore content that matches this rule.
//
//   skip:: ?bool
//   When true, ignore the node that matches this rule, but do parse
//   its content.
//
//   attrs:: ?Object
//   Attributes for the node or mark created by this rule. When
//   `getAttrs` is provided, it takes precedence.
//
//   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
//   A function used to compute the attributes for the node or mark
//   created by this rule. Can also be used to describe further
//   conditions the DOM element or style must match. When it returns
//   `false`, the rule won't match. When it returns null or undefined,
//   that is interpreted as an empty/default set of attributes.
//
//   Called with a DOM Element for `tag` rules, and with a string (the
//   style's value) for `style` rules.
//
//   contentElement:: ?union<string, (dom.Node) → dom.Node>
//   For `tag` rules that produce non-leaf nodes or marks, by default
//   the content of the DOM element is parsed as content of the mark
//   or node. If the child nodes are in a descendent node, this may be
//   a CSS selector string that the parser must use to find the actual
//   content element, or a function that returns the actual content
//   element to the parser.
//
//   getContent:: ?(dom.Node, schema: Schema) → Fragment
//   Can be used to override the content of a matched node. When
//   present, instead of parsing the node's child nodes, the result of
//   this function is used.
//
//   preserveWhitespace:: ?union<bool, "full">
//   Controls whether whitespace should be preserved when parsing the
//   content inside the matched element. `false` means whitespace may
//   be collapsed, `true` means that whitespace should be preserved
//   but newlines normalized to spaces, and `"full"` means that
//   newlines should also be preserved.

// ::- A DOM parser represents a strategy for parsing DOM content into
// a ProseMirror document conforming to a given schema. Its behavior
// is defined by an array of [rules](#model.ParseRule).
var DOMParser = function DOMParser(schema, rules) {
  var this$1 = this;

  // :: Schema
  // The schema into which the parser parses.
  this.schema = schema;
  // :: [ParseRule]
  // The set of [parse rules](#model.ParseRule) that the parser
  // uses, in order of precedence.
  this.rules = rules;
  this.tags = [];
  this.styles = [];

  rules.forEach(function (rule) {
    if (rule.tag) { this$1.tags.push(rule); }
    else if (rule.style) { this$1.styles.push(rule); }
  });
};

// :: (dom.Node, ?ParseOptions) → Node
// Parse a document from the content of a DOM node.
DOMParser.prototype.parse = function parse (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, false);
  context.addAll(dom, null, options.from, options.to);
  return context.finish()
};

// :: (dom.Node, ?ParseOptions) → Slice
// Parses the content of the given DOM node, like
// [`parse`](#model.DOMParser.parse), and takes the same set of
// options. But unlike that method, which produces a whole node,
// this one returns a slice that is open at the sides, meaning that
// the schema constraints aren't applied to the start of nodes to
// the left of the input and the end of nodes at the end.
DOMParser.prototype.parseSlice = function parseSlice (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, true);
  context.addAll(dom, null, options.from, options.to);
  return Slice.maxOpen(context.finish())
};

DOMParser.prototype.matchTag = function matchTag (dom, context) {
    var this$1 = this;

  for (var i = 0; i < this.tags.length; i++) {
    var rule = this$1.tags[i];
    if (matches(dom, rule.tag) &&
        (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
        (!rule.context || context.matchesContext(rule.context))) {
      if (rule.getAttrs) {
        var result = rule.getAttrs(dom);
        if (result === false) { continue }
        rule.attrs = result;
      }
      return rule
    }
  }
};

DOMParser.prototype.matchStyle = function matchStyle (prop, value, context) {
    var this$1 = this;

  for (var i = 0; i < this.styles.length; i++) {
    var rule = this$1.styles[i];
    if (rule.style.indexOf(prop) != 0 ||
        rule.context && !context.matchesContext(rule.context) ||
        // Test that the style string either precisely matches the prop,
        // or has an '=' sign after the prop, followed by the given
        // value.
        rule.style.length > prop.length &&
        (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value))
      { continue }
    if (rule.getAttrs) {
      var result = rule.getAttrs(value);
      if (result === false) { continue }
      rule.attrs = result;
    }
    return rule
  }
};

// : (Schema) → [ParseRule]
DOMParser.schemaRules = function schemaRules (schema) {
  var result = [];
  function insert(rule) {
    var priority = rule.priority == null ? 50 : rule.priority, i = 0;
    for (; i < result.length; i++) {
      var next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
      if (nextPriority < priority) { break }
    }
    result.splice(i, 0, rule);
  }

  var loop = function ( name ) {
    var rules = schema.marks[name].spec.parseDOM;
    if (rules) { rules.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.mark = name;
    }); }
  };

    for (var name in schema.marks) loop( name );
  var loop$1 = function ( name ) {
    var rules$1 = schema.nodes[name$1].spec.parseDOM;
    if (rules$1) { rules$1.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.node = name$1;
    }); }
  };

    for (var name$1 in schema.nodes) loop$1( name );
  return result
};

// :: (Schema) → DOMParser
// Construct a DOM parser using the parsing rules listed in a
// schema's [node specs](#model.NodeSpec.parseDOM), reordered by
// [priority](#model.ParseRule.priority).
DOMParser.fromSchema = function fromSchema (schema) {
  return schema.cached.domParser ||
    (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)))
};

// : Object<bool> The block-level tags in HTML5
var blockTags = {
  address: true, article: true, aside: true, blockquote: true, canvas: true,
  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};

// : Object<bool> The tags that we normally ignore.
var ignoreTags = {
  head: true, noscript: true, object: true, script: true, style: true, title: true
};

// : Object<bool> List tags.
var listTags = {ol: true, ul: true};

// Using a bitfield for node context options
var OPT_PRESERVE_WS = 1;
var OPT_PRESERVE_WS_FULL = 2;
var OPT_OPEN_LEFT = 4;

function wsOptionsFor(preserveWhitespace) {
  return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0)
}

var NodeContext = function NodeContext(type, attrs, marks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  this.marks = marks;
  this.activeMarks = Mark.none;
};

NodeContext.prototype.findWrapping = function findWrapping (node) {
  if (!this.match) {
    if (!this.type) { return [] }
    var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start = this.type.contentMatch, wrap;
      if (wrap = start.findWrapping(node.type)) {
        this.match = start;
        return wrap
      } else {
        return null
      }
    }
  }
  return this.match.findWrapping(node.type)
};

NodeContext.prototype.finish = function finish (openEnd) {
  if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /\s+$/.exec(last.text))) {
      if (last.text.length == m[0].length) { this.content.pop(); }
      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
    }
  }
  var content = Fragment.from(this.content);
  if (!openEnd && this.match)
    { content = content.append(this.match.fillBefore(Fragment.empty, true)); }
  return this.type ? this.type.create(this.attrs, content, this.marks) : content
};

var ParseContext = function ParseContext(parser, options, open) {
  // : DOMParser The parser we are using.
  this.parser = parser;
  // : Object The options passed to this parse.
  this.options = options;
  this.isOpen = open;
  this.pendingMarks = [];
  var topNode = options.topNode, topContext;
  var topOptions = wsOptionsFor(options.preserveWhitespace) | (open ? OPT_OPEN_LEFT : 0);
  if (topNode)
    { topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true,
                                 options.topMatch || topNode.type.contentMatch, topOptions); }
  else if (open)
    { topContext = new NodeContext(null, null, Mark.none, true, null, topOptions); }
  else
    { topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions); }
  this.nodes = [topContext];
  // : [Mark] The current set of marks
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};

var prototypeAccessors$6 = { top: {},currentPos: {} };

prototypeAccessors$6.top.get = function () {
  return this.nodes[this.open]
};

// : (dom.Node)
// Add a DOM node to the content. Text is inserted as text node,
// otherwise, the node is passed to `addElement` or, if it has a
// `style` attribute, `addElementWithStyles`.
ParseContext.prototype.addDOM = function addDOM (dom) {
    var this$1 = this;

  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    var marks = style ? this.readStyles(parseStyles(style)) : null;
    if (marks != null) { for (var i = 0; i < marks.length; i++) { this$1.addPendingMark(marks[i]); } }
    this.addElement(dom);
    if (marks != null) { for (var i$1 = 0; i$1 < marks.length; i$1++) { this$1.removePendingMark(marks[i$1]); } }
  }
};

ParseContext.prototype.addTextNode = function addTextNode (dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if ((top.type ? top.type.inlineContent : top.content.length && top.content[0].isInline) || /\S/.test(value)) {
    if (!(top.options & OPT_PRESERVE_WS)) {
      value = value.replace(/\s+/g, " ");
      // If this starts with whitespace, and there is no node before it, or
      // a hard break, or a text node that ends with whitespace, strip the
      // leading space.
      if (/^\s/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        var domNodeBefore = dom.previousSibling;
        if (!nodeBefore ||
            (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
            (nodeBefore.isText && /\s$/.test(nodeBefore.text)))
          { value = value.slice(1); }
      }
    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    }
    if (value) { this.insertNode(this.parser.schema.text(value)); }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};

// : (dom.Element)
// Try to find a handler for the given tag and use that to parse. If
// none is found, the element's content nodes are added directly.
ParseContext.prototype.addElement = function addElement (dom) {
  var name = dom.nodeName.toLowerCase();
  if (listTags.hasOwnProperty(name)) { normalizeList(dom); }
  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) || this.parser.matchTag(dom, this);
  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
  } else if (!rule || rule.skip) {
    if (rule && rule.skip.nodeType) { dom = rule.skip; }
    var sync, top = this.top, oldNeedsBlock = this.needsBlock;
    if (blockTags.hasOwnProperty(name)) {
      sync = true;
      if (!top.type) { this.needsBlock = true; }
    }
    this.addAll(dom);
    if (sync) { this.sync(top); }
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule);
  }
};

// Run any style parser associated with the node's styles. Either
// return an array of marks, or null to indicate some of the styles
// had a rule with `ignore` set.
ParseContext.prototype.readStyles = function readStyles (styles) {
    var this$1 = this;

  var marks = Mark.none;
  for (var i = 0; i < styles.length; i += 2) {
    var rule = this$1.parser.matchStyle(styles[i], styles[i + 1], this$1);
    if (!rule) { continue }
    if (rule.ignore) { return null }
    marks = this$1.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
  }
  return marks
};

// : (dom.Element, ParseRule) → bool
// Look up a handler for the given node. If none are found, return
// false. Otherwise, apply it, use its return value to drive the way
// the node's content is wrapped, and return true.
ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule) {
    var this$1 = this;

  var sync, nodeType, markType, mark;
  if (rule.node) {
    nodeType = this.parser.schema.nodes[rule.node];
    if (nodeType.isLeaf) { this.insertNode(nodeType.create(rule.attrs)); }
    else { sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace); }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark = markType.create(rule.attrs);
    this.addPendingMark(mark);
  }
  var startIn = this.top;

  if (nodeType && nodeType.isLeaf) {
    this.findInside(dom);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1.insertNode(node); });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
    if (!contentDOM) { contentDOM = dom; }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync);
  }
  if (sync) { this.sync(startIn); this.open--; }
  if (mark) { this.removePendingMark(mark); }
  return true
};

// : (dom.Node, ?NodeBuilder, ?number, ?number)
// Add all child nodes between `startIndex` and `endIndex` (or the
// whole node, if not given). If `sync` is passed, use it to
// synchronize after every block element.
ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
    var this$1 = this;

  var index = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
           end = endIndex == null ? null : parent.childNodes[endIndex];
       dom != end; dom = dom.nextSibling, ++index) {
    this$1.findAtPoint(parent, index);
    this$1.addDOM(dom);
    if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
      { this$1.sync(sync); }
  }
  this.findAtPoint(parent, index);
};

// Try to find a way to fit the given node type into the current
// context. May add intermediate wrappers and/or leave non-solid
// nodes that we're in.
ParseContext.prototype.findPlace = function findPlace (node) {
    var this$1 = this;

  var route, sync;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this$1.nodes[depth];
    var found = cx.findWrapping(node);
    if (found && (!route || route.length > found.length)) {
      route = found;
      sync = cx;
      if (!found.length) { break }
    }
    if (cx.solid) { break }
  }
  if (!route) { return false }
  this.sync(sync);
  for (var i = 0; i < route.length; i++)
    { this$1.enterInner(route[i], null, false); }
  return true
};

// : (Node) → ?Node
// Try to insert the given node, adjusting the context when needed.
ParseContext.prototype.insertNode = function insertNode (node) {
  if (node.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) { this.enterInner(block); }
  }
  if (this.findPlace(node)) {
    this.closeExtra();
    var top = this.top;
    this.applyPendingMarks(top);
    if (top.match) { top.match = top.match.matchType(node.type); }
    var marks = top.activeMarks;
    for (var i = 0; i < node.marks.length; i++)
      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
        { marks = node.marks[i].addToSet(marks); } }
    top.content.push(node.mark(marks));
  }
};

ParseContext.prototype.applyPendingMarks = function applyPendingMarks (top) {
    var this$1 = this;

  for (var i = 0; i < this.pendingMarks.length; i++) {
    var mark = this$1.pendingMarks[i];
    if ((!top.type || top.type.allowsMarkType(mark.type)) && !mark.isInSet(top.activeMarks)) {
      top.activeMarks = mark.addToSet(top.activeMarks);
      this$1.pendingMarks.splice(i--, 1);
    }
  }
};

// : (NodeType, ?Object) → bool
// Try to start a node of the given type, adjusting the context when
// necessary.
ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
  var ok = this.findPlace(type.create(attrs));
  if (ok) {
    this.applyPendingMarks(this.top);
    this.enterInner(type, attrs, true, preserveWS);
  }
  return ok
};

// Open a node of the given type
ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.match = top.match && top.match.matchType(type, attrs);
  var options = preserveWS == null ? top.options & ~OPT_OPEN_LEFT : wsOptionsFor(preserveWS);
  if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0) { options |= OPT_OPEN_LEFT; }
  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, solid, null, options));
  this.open++;
};

// Make sure all nodes above this.open are finished and added to
// their parents
ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
    var this$1 = this;

  var i = this.nodes.length - 1;
  if (i > this.open) {
    for (; i > this.open; i--) { this$1.nodes[i - 1].content.push(this$1.nodes[i].finish(openEnd)); }
    this.nodes.length = this.open + 1;
  }
};

ParseContext.prototype.finish = function finish () {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
};

ParseContext.prototype.sync = function sync (to) {
    var this$1 = this;

  for (var i = this.open; i >= 0; i--) { if (this$1.nodes[i] == to) {
    this$1.open = i;
    return
  } }
};

ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
  this.pendingMarks.push(mark);
};

ParseContext.prototype.removePendingMark = function removePendingMark (mark) {
  var found = this.pendingMarks.lastIndexOf(mark);
  if (found > -1) {
    this.pendingMarks.splice(found, 1);
  } else {
    var top = this.top;
    top.activeMarks = mark.removeFromSet(top.activeMarks);
  }
};

prototypeAccessors$6.currentPos.get = function () {
    var this$1 = this;

  this.closeExtra();
  var pos = 0;
  for (var i = this.open; i >= 0; i--) {
    var content = this$1.nodes[i].content;
    for (var j = content.length - 1; j >= 0; j--)
      { pos += content[j].nodeSize; }
    if (i) { pos++; }
  }
  return pos
};

ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].node == parent && this$1.find[i].offset == offset)
      { this$1.find[i].pos = this$1.currentPos; }
  } }
};

ParseContext.prototype.findInside = function findInside (parent) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node))
      { this$1.find[i].pos = this$1.currentPos; }
  } }
};

ParseContext.prototype.findAround = function findAround (parent, content, before) {
    var this$1 = this;

  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node)) {
      var pos = content.compareDocumentPosition(this$1.find[i].node);
      if (pos & (before ? 2 : 4))
        { this$1.find[i].pos = this$1.currentPos; }
    }
  } }
};

ParseContext.prototype.findInText = function findInText (textNode) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].node == textNode)
      { this$1.find[i].pos = this$1.currentPos - (textNode.nodeValue.length - this$1.find[i].offset); }
  } }
};

// : (string) → bool
// Determines whether the given [context
// string](#ParseRule.context) matches this context.
ParseContext.prototype.matchesContext = function matchesContext (context) {
    var this$1 = this;

  if (context.indexOf("|") > -1)
    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }

  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function (i, depth) {
    for (; i >= 0; i--) {
      var part = parts[i];
      if (part == "") {
        if (i == parts.length - 1 || i == 0) { continue }
        for (; depth >= minDepth; depth--)
          { if (match(i - 1, depth)) { return true } }
        return false
      } else {
        var next = depth > 0 || (depth == 0 && useRoot) ? this$1.nodes[depth].type
            : option && depth >= minDepth ? option.node(depth - minDepth).type
            : null;
        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
          { return false }
        depth--;
      }
    }
    return true
  };
  return match(parts.length - 1, this.open)
};

ParseContext.prototype.textblockFromContext = function textblockFromContext () {
    var this$1 = this;

  var $context = this.options.context;
  if ($context) { for (var d = $context.depth; d >= 0; d--) {
    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
  } }
  for (var name in this$1.parser.schema.nodes) {
    var type = this$1.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) { return type }
  }
};

Object.defineProperties( ParseContext.prototype, prototypeAccessors$6 );

// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}

// Apply a CSS selector.
function matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector)
}

// : (string) → [string]
// Tokenize a style attribute into property/value pairs.
function parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
  return result
}

function copy(obj) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  return copy
}

// DOMOutputSpec:: interface
// A description of a DOM structure. Can be either a string, which is
// interpreted as a text node, a DOM node, which is interpreted as
// itself, or an array.
//
// An array describes a DOM element. The first value in the array
// should be a string—the name of the DOM element. If the second
// element is plain object, it is interpreted as a set of attributes
// for the element. Any elements after that (including the 2nd if it's
// not an attribute object) are interpreted as children of the DOM
// elements, and must either be valid `DOMOutputSpec` values, or the
// number zero.
//
// The number zero (pronounced “hole”) is used to indicate the place
// where a node's child nodes should be inserted. It it occurs in an
// output spec, it should be the only child element in its parent
// node.

// ::- A DOM serializer knows how to convert ProseMirror nodes and
// marks of various types to DOM nodes.
var DOMSerializer = function DOMSerializer(nodes, marks) {
  // :: Object<(node: Node) → DOMOutputSpec>
  // The node serialization functions.
  this.nodes = nodes || {};
  // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
  // The mark serialization functions.
  this.marks = marks || {};
};

// :: (Fragment, ?Object) → dom.DocumentFragment
// Serialize the content of this fragment to a DOM fragment. When
// not in the browser, the `document` option, containing a DOM
// document, should be passed so that the serializer can create
// nodes.
DOMSerializer.prototype.serializeFragment = function serializeFragment (fragment, options, target) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  if (!target) { target = doc(options).createDocumentFragment(); }

  var top = target, active = null;
  fragment.forEach(function (node) {
    if (active || node.marks.length) {
      if (!active) { active = []; }
      var keep = 0, rendered = 0;
      while (keep < active.length && rendered < node.marks.length) {
        var next = node.marks[rendered];
        if (!this$1.marks[next.type.name]) { rendered++; continue }
        if (!next.eq(active[keep]) || next.type.spec.spanning === false) { break }
        keep += 2; rendered++;
      }
      while (keep < active.length) {
        top = active.pop();
        active.pop();
      }
      while (rendered < node.marks.length) {
        var add = node.marks[rendered++];
        var markDOM = this$1.serializeMark(add, node.isInline, options);
        if (markDOM) {
          active.push(add, top);
          top.appendChild(markDOM.dom);
          top = markDOM.contentDOM || markDOM.dom;
        }
      }
    }
    top.appendChild(this$1.serializeNode(node, options));
  });

  return target
};

// :: (Node, ?Object) → dom.Node
// Serialize this node to a DOM node. This can be useful when you
// need to serialize a part of a document, as opposed to the whole
// document. To serialize a whole document, use
// [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
// its [content](#model.Node.content).
DOMSerializer.prototype.serializeNode = function serializeNode (node, options) {
    if ( options === void 0 ) options = {};

  var ref =
      DOMSerializer.renderSpec(doc(options), this.nodes[node.type.name](node));
    var dom = ref.dom;
    var contentDOM = ref.contentDOM;
  if (contentDOM) {
    if (node.isLeaf)
      { throw new RangeError("Content hole not allowed in a leaf node spec") }
    if (options.onContent)
      { options.onContent(node, contentDOM, options); }
    else
      { this.serializeFragment(node.content, options, contentDOM); }
  }
  return dom
};

DOMSerializer.prototype.serializeNodeAndMarks = function serializeNodeAndMarks (node, options) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  var dom = this.serializeNode(node, options);
  for (var i = node.marks.length - 1; i >= 0; i--) {
    var wrap = this$1.serializeMark(node.marks[i], node.isInline, options);
    if (wrap) {
      (wrap.contentDOM || wrap.dom).appendChild(dom);
      dom = wrap.dom;
    }
  }
  return dom
};

DOMSerializer.prototype.serializeMark = function serializeMark (mark, inline, options) {
    if ( options === void 0 ) options = {};

  var toDOM = this.marks[mark.type.name];
  return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark, inline))
};

// :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
// Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
// the spec has a hole (zero) in it, `contentDOM` will point at the
// node with the hole.
DOMSerializer.renderSpec = function renderSpec (doc, structure) {
  if (typeof structure == "string")
    { return {dom: doc.createTextNode(structure)} }
  if (structure.nodeType != null)
    { return {dom: structure} }
  var dom = doc.createElement(structure[0]), contentDOM = null;
  var attrs = structure[1], start = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start = 2;
    for (var name in attrs) {
      if (attrs[name] != null) { dom.setAttribute(name, attrs[name]); }
    }
  }
  for (var i = start; i < structure.length; i++) {
    var child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start)
        { throw new RangeError("Content hole must be the only child of its parent node") }
      return {dom: dom, contentDOM: dom}
    } else {
      var ref = DOMSerializer.renderSpec(doc, child);
        var inner = ref.dom;
        var innerContent = ref.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) { throw new RangeError("Multiple content holes") }
        contentDOM = innerContent;
      }
    }
  }
  return {dom: dom, contentDOM: contentDOM}
};

// :: (Schema) → DOMSerializer
// Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
// properties in a schema's node and mark specs.
DOMSerializer.fromSchema = function fromSchema (schema) {
  return schema.cached.domSerializer ||
    (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)))
};

// : (Schema) → Object<(node: Node) → DOMOutputSpec>
// Gather the serializers in a schema's node specs into an object.
// This can be useful as a base to build a custom serializer from.
DOMSerializer.nodesFromSchema = function nodesFromSchema (schema) {
  var result = gatherToDOM(schema.nodes);
  if (!result.text) { result.text = function (node) { return node.text; }; }
  return result
};

// : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
// Gather the serializers in a schema's mark specs into an object.
DOMSerializer.marksFromSchema = function marksFromSchema (schema) {
  return gatherToDOM(schema.marks)
};

function gatherToDOM(obj) {
  var result = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) { result[name] = toDOM; }
  }
  return result
}

function doc(options) {
  // declare global: window
  return options.document || window.document
}

exports.Node = Node;
exports.ResolvedPos = ResolvedPos;
exports.NodeRange = NodeRange;
exports.Fragment = Fragment;
exports.Slice = Slice;
exports.ReplaceError = ReplaceError;
exports.Mark = Mark;
exports.Schema = Schema;
exports.NodeType = NodeType;
exports.MarkType = MarkType;
exports.ContentMatch = ContentMatch;
exports.DOMParser = DOMParser;
exports.DOMSerializer = DOMSerializer;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ "6f50":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ "6fde":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "6fe7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__("1a2a")
var crt = __webpack_require__("a958")
var EC = __webpack_require__("3337").ec
var BN = __webpack_require__("399f")
var parseKeys = __webpack_require__("2aee")
var curves = __webpack_require__("cd91")

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "6ffb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__("6f27");
var prosemirrorTransform = __webpack_require__("b923");

var classesById = Object.create(null);

// ::- Superclass for editor selections. Every selection type should
// extend this. Should not be instantiated directly.
var Selection = function Selection($anchor, $head, ranges) {
  // :: [SelectionRange]
  // The ranges covered by the selection.
  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  // :: ResolvedPos
  // The resolved anchor of the selection (the side that stays in
  // place when the selection is modified).
  this.$anchor = $anchor;
  // :: ResolvedPos
  // The resolved head of the selection (the side that moves when
  // the selection is modified).
  this.$head = $head;
};

var prototypeAccessors = { anchor: {},head: {},from: {},to: {},$from: {},$to: {},empty: {} };

// :: number
// The selection's anchor, as an unresolved position.
prototypeAccessors.anchor.get = function () { return this.$anchor.pos };

// :: number
// The selection's head.
prototypeAccessors.head.get = function () { return this.$head.pos };

// :: number
// The lower bound of the selection's main range.
prototypeAccessors.from.get = function () { return this.$from.pos };

// :: number
// The upper bound of the selection's main range.
prototypeAccessors.to.get = function () { return this.$to.pos };

// :: ResolvedPos
// The resolved lowerbound of the selection's main range.
prototypeAccessors.$from.get = function () {
  return this.ranges[0].$from
};

// :: ResolvedPos
// The resolved upper bound of the selection's main range.
prototypeAccessors.$to.get = function () {
  return this.ranges[0].$to
};

// :: bool
// Indicates whether the selection contains any content.
prototypeAccessors.empty.get = function () {
  var ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++)
    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
  return true
};

// eq:: (Selection) → bool
// Test whether the selection is the same as another selection.

// map:: (doc: Node, mapping: Mappable) → Selection
// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
// should be the new document to which we are mapping.

// :: () → Slice
// Get the content of this selection as a slice.
Selection.prototype.content = function content () {
  return this.$from.node(0).slice(this.from, this.to, true)
};

// :: (Transaction, ?Slice)
// Replace the selection with a slice or, if no slice is given,
// delete the selection. Will append to the given transaction.
Selection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

  // Put the new selection at the position after the inserted
  // content. When that ended in an inline node, search backwards,
  // to get the position after that node. If not, search forward.
  var lastNode = content.content.lastChild, lastParent = null;
  for (var i = 0; i < content.openEnd; i++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }

  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref = ranges[i$1];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? prosemirrorModel.Slice.empty : content);
    if (i$1 == 0)
      { selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
  }
};

// :: (Transaction, Node)
// Replace the selection with the given node, appending the changes
// to the given transaction.
Selection.prototype.replaceWith = function replaceWith (tr, node) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++) {
    var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    var from = mapping.map($from.pos), to = mapping.map($to.pos);
    if (i) {
      tr.deleteRange(from, to);
    } else {
      tr.replaceRangeWith(from, to, node);
      selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
    }
  }
};

// toJSON:: () → Object
// Convert the selection to a JSON representation. When implementing
// this for a custom selection class, make sure to give the object a
// `type` property whose value matches the ID under which you
// [registered](#state.Selection^jsonID) your class.

// :: (ResolvedPos, number, ?bool) → ?Selection
// Find a valid cursor or leaf node selection starting at the given
// position and searching back if `dir` is negative, and forward if
// positive. When `textOnly` is true, only consider cursor
// selections. Will return null when no valid selection position is
// found.
Selection.findFrom = function findFrom ($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new TextSelection($pos)
      : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) { return inner }

  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found = dir < 0
        ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
        : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found) { return found }
  }
};

// :: (ResolvedPos, ?number) → Selection
// Find a valid cursor or leaf node selection near the given
// position. Searches forward first by default, but if `bias` is
// negative, it will search backwards first.
Selection.near = function near ($pos, bias) {
    if ( bias === void 0 ) bias = 1;

  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0))
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the start of
// the given document. Will return an
// [`AllSelection`](#state.AllSelection) if no valid position
// exists.
Selection.atStart = function atStart (doc) {
  return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc)
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the end of the
// given document.
Selection.atEnd = function atEnd (doc) {
  return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc)
};

// :: (Node, Object) → Selection
// Deserialize the JSON representation of a selection. Must be
// implemented for custom classes (as a static class method).
Selection.fromJSON = function fromJSON (doc, json) {
  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
  var cls = classesById[json.type];
  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
  return cls.fromJSON(doc, json)
};

// :: (string, constructor<Selection>)
// To be able to deserialize selections from JSON, custom selection
// classes must register themselves with an ID string, so that they
// can be disambiguated. Try to pick something that's unlikely to
// clash with classes from other modules.
Selection.jsonID = function jsonID (id, selectionClass) {
  if (id in classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
  classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass
};

// :: () → SelectionBookmark
// Get a [bookmark](#state.SelectionBookmark) for this selection,
// which is a value that can be mapped without having access to a
// current document, and later resolved to a real selection for a
// given document again. (This is used mostly by the history to
// track and restore old selections.) The default implementation of
// this method just converts the selection to a text selection and
// returns the bookmark for that.
Selection.prototype.getBookmark = function getBookmark () {
  return TextSelection.between(this.$anchor, this.$head).getBookmark()
};

Object.defineProperties( Selection.prototype, prototypeAccessors );

// :: bool
// Controls whether, when a selection of this type is active in the
// browser, the selected range should be visible to the user. Defaults
// to `true`.
Selection.prototype.visible = true;

// SelectionBookmark:: interface
// A lightweight, document-independent representation of a selection.
// You can define a custom bookmark type for a custom selection class
// to make the history handle it well.
//
//   map:: (mapping: Mapping) → SelectionBookmark
//   Map the bookmark through a set of changes.
//
//   resolve:: (doc: Node) → Selection
//   Resolve the bookmark to a real selection again. This may need to
//   do some error checking and may fall back to a default (usually
//   [`TextSelection.between`](#state.TextSelection^between)) if
//   mapping made the bookmark invalid.

// ::- Represents a selected range in a document.
var SelectionRange = function SelectionRange($from, $to) {
  // :: ResolvedPos
  // The lower bound of the range.
  this.$from = $from;
  // :: ResolvedPos
  // The upper bound of the range.
  this.$to = $to;
};

// ::- A text selection represents a classical editor selection, with
// a head (the moving side) and anchor (immobile side), both of which
// point into textblock nodes. It can be empty (a regular cursor
// position).
var TextSelection = (function (Selection) {
  function TextSelection($anchor, $head) {
    if ( $head === void 0 ) $head = $anchor;

    Selection.call(this, $anchor, $head);
  }

  if ( Selection ) TextSelection.__proto__ = Selection;
  TextSelection.prototype = Object.create( Selection && Selection.prototype );
  TextSelection.prototype.constructor = TextSelection;

  var prototypeAccessors$1 = { $cursor: {} };

  // :: ?ResolvedPos
  // Returns a resolved position if this is a cursor selection (an
  // empty text selection), and null otherwise.
  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };

  TextSelection.prototype.map = function map (doc, mapping) {
    var $head = doc.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) { return Selection.near($head) }
    var $anchor = doc.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
  };

  TextSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

    Selection.prototype.replace.call(this, tr, content);
    if (content == prosemirrorModel.Slice.empty) {
      var marks = this.$from.marksAcross(this.$to);
      if (marks) { tr.ensureMarks(marks); }
    }
  };

  TextSelection.prototype.eq = function eq (other) {
    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
  };

  TextSelection.prototype.getBookmark = function getBookmark () {
    return new TextBookmark(this.anchor, this.head)
  };

  TextSelection.prototype.toJSON = function toJSON () {
    return {type: "text", anchor: this.anchor, head: this.head}
  };

  TextSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → TextSelection
  // Create a text selection from non-resolved positions.
  TextSelection.create = function create (doc, anchor, head) {
    if ( head === void 0 ) head = anchor;

    var $anchor = doc.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
  };

  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
  // Return a text selection that spans the given positions or, if
  // they aren't text positions, find a text selection near them.
  // `bias` determines whether the method searches forward (default)
  // or backwards (negative number) first. Will fall back to calling
  // [`Selection.near`](#state.Selection^near) when the document
  // doesn't contain a valid text position.
  TextSelection.between = function between ($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
    if (!$head.parent.inlineContent) {
      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found) { $head = found.$head; }
      else { return Selection.near($head, bias) }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
      }
    }
    return new TextSelection($anchor, $head)
  };

  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );

  return TextSelection;
}(Selection));

Selection.jsonID("text", TextSelection);

var TextBookmark = function TextBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
TextBookmark.prototype.map = function map (mapping) {
  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
TextBookmark.prototype.resolve = function resolve (doc) {
  return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
};

// ::- A node selection is a selection that points at a single node.
// All nodes marked [selectable](#model.NodeSpec.selectable) can be
// the target of a node selection. In such a selection, `from` and
// `to` point directly before and after the selected node, `anchor`
// equals `from`, and `head` equals `to`..
var NodeSelection = (function (Selection) {
  function NodeSelection($pos) {
    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    Selection.call(this, $pos, $end);
    // :: Node The selected node.
    this.node = node;
  }

  if ( Selection ) NodeSelection.__proto__ = Selection;
  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
  NodeSelection.prototype.constructor = NodeSelection;

  NodeSelection.prototype.map = function map (doc, mapping) {
    var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
    var $pos = doc.resolve(pos);
    if (deleted) { return Selection.near($pos) }
    return new NodeSelection($pos)
  };

  NodeSelection.prototype.content = function content () {
    return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(this.node), 0, 0)
  };

  NodeSelection.prototype.eq = function eq (other) {
    return other instanceof NodeSelection && other.anchor == this.anchor
  };

  NodeSelection.prototype.toJSON = function toJSON () {
    return {type: "node", anchor: this.anchor}
  };

  NodeSelection.prototype.getBookmark = function getBookmark () { return new NodeBookmark(this.anchor) };

  NodeSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number")
      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
    return new NodeSelection(doc.resolve(json.anchor))
  };

  // :: (Node, number) → NodeSelection
  // Create a node selection from non-resolved positions.
  NodeSelection.create = function create (doc, from) {
    return new this(doc.resolve(from))
  };

  // :: (Node) → bool
  // Determines whether the given node may be selected as a node
  // selection.
  NodeSelection.isSelectable = function isSelectable (node) {
    return !node.isText && node.type.spec.selectable !== false
  };

  return NodeSelection;
}(Selection));

NodeSelection.prototype.visible = false;

Selection.jsonID("node", NodeSelection);

var NodeBookmark = function NodeBookmark(anchor) {
  this.anchor = anchor;
};
NodeBookmark.prototype.map = function map (mapping) {
  var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos)
};
NodeBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
  if (node && NodeSelection.isSelectable(node)) { return new NodeSelection($pos) }
  return Selection.near($pos)
};

// ::- A selection type that represents selecting the whole document
// (which can not necessarily be expressed with a text selection, when
// there are for example leaf block nodes at the start or end of the
// document).
var AllSelection = (function (Selection) {
  function AllSelection(doc) {
    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  if ( Selection ) AllSelection.__proto__ = Selection;
  AllSelection.prototype = Object.create( Selection && Selection.prototype );
  AllSelection.prototype.constructor = AllSelection;

  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };

  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };

  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };

  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };

  AllSelection.prototype.getBookmark = function getBookmark () { return AllBookmark };

  return AllSelection;
}(Selection));

Selection.jsonID("all", AllSelection);

var AllBookmark = {
  map: function map() { return this },
  resolve: function resolve(doc) { return new AllSelection(doc) }
};

// FIXME we'll need some awareness of text direction when scanning for selections

// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text) {
  if (node.inlineContent) { return TextSelection.create(doc, pos) }
  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);
    if (!child.isAtom) {
      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) { return inner }
    } else if (!text && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
    }
    pos += child.nodeSize * dir;
  }
}

function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) { return }
  var step = tr.steps[last];
  if (!(step instanceof prosemirrorTransform.ReplaceStep || step instanceof prosemirrorTransform.ReplaceAroundStep)) { return }
  var map = tr.mapping.maps[last], end;
  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var UPDATED_SEL = 1;
var UPDATED_MARKS = 2;
var UPDATED_SCROLL = 4;

// ::- An editor state transaction, which can be applied to a state to
// create an updated state. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
//
// Transactions track changes to the document (they are a subclass of
// [`Transform`](#transform.Transform)), but also other state changes,
// like selection updates and adjustments of the set of [stored
// marks](#state.EditorState.storedMarks). In addition, you can store
// metadata properties in a transaction, which are extra pieces of
// information that client code or plugins can use to describe what a
// transacion represents, so that they can update their [own
// state](#state.StateField) accordingly.
//
// The [editor view](#view.EditorView) uses a few metadata properties:
// it will attach a property `"pointer"` with the value `true` to
// selection transactions directly caused by mouse or touch input, and
// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
var Transaction = (function (Transform$$1) {
  function Transaction(state) {
    Transform$$1.call(this, state.doc);
    // :: number
    // The timestamp associated with this transaction, in the same
    // format as `Date.now()`.
    this.time = Date.now();
    this.curSelection = state.selection;
    // The step count for which the current selection is valid.
    this.curSelectionFor = 0;
    // :: ?[Mark]
    // The stored marks set by this transaction, if any.
    this.storedMarks = state.storedMarks;
    // Bitfield to track which aspects of the state were updated by
    // this transaction.
    this.updated = 0;
    // Object used to store metadata properties for the transaction.
    this.meta = Object.create(null);
  }

  if ( Transform$$1 ) Transaction.__proto__ = Transform$$1;
  Transaction.prototype = Object.create( Transform$$1 && Transform$$1.prototype );
  Transaction.prototype.constructor = Transaction;

  var prototypeAccessors = { selection: {},selectionSet: {},storedMarksSet: {},isGeneric: {},scrolledIntoView: {} };

  // :: Selection
  // The transaction's current selection. This defaults to the editor
  // selection [mapped](#state.Selection.map) through the steps in the
  // transaction, but can be overwritten with
  // [`setSelection`](#state.Transaction.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection
  };

  // :: (Selection) → Transaction
  // Update the transaction's current selection. Will determine the
  // selection that the editor gets when the transaction is applied.
  Transaction.prototype.setSelection = function setSelection (selection) {
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this
  };

  // :: bool
  // Whether the selection was explicitly updated by this transaction.
  prototypeAccessors.selectionSet.get = function () {
    return (this.updated & UPDATED_SEL) > 0
  };

  // :: (?[Mark]) → Transaction
  // Set the current stored marks.
  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this
  };

  // :: ([Mark]) → Transaction
  // Make sure the current stored marks or, if that is null, the marks
  // at the selection, match the given set of marks. Does nothing if
  // this is already the case.
  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
    if (!prosemirrorModel.Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      { this.setStoredMarks(marks); }
    return this
  };

  // :: (Mark) → Transaction
  // Add a mark to the set of stored marks.
  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: (union<Mark, MarkType>) → Transaction
  // Remove a mark or mark type from the set of stored marks.
  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: bool
  // Whether the stored marks were explicitly set for this transaction.
  prototypeAccessors.storedMarksSet.get = function () {
    return (this.updated & UPDATED_MARKS) > 0
  };

  Transaction.prototype.addStep = function addStep (step, doc) {
    Transform$$1.prototype.addStep.call(this, step, doc);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  };

  // :: (number) → Transaction
  // Update the timestamp for the transaction.
  Transaction.prototype.setTime = function setTime (time) {
    this.time = time;
    return this
  };

  // :: (Slice) → Transaction
  // Replace the current selection with the given slice.
  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
    this.selection.replace(this, slice);
    return this
  };

  // :: (Node, ?bool) → Transaction
  // Replace the selection with the given node. When `inheritMarks` is
  // true and the content is inline, it inherits the marks from the
  // place where it is inserted.
  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false)
      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || prosemirrorModel.Mark.none))); }
    selection.replaceWith(this, node);
    return this
  };

  // :: () → Transaction
  // Delete the selection.
  Transaction.prototype.deleteSelection = function deleteSelection () {
    this.selection.replace(this);
    return this
  };

  // :: (string, from: ?number, to: ?number) → Transaction
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  Transaction.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var schema = this.doc.type.schema;
    if (from == null) {
      if (!text) { return this.deleteSelection() }
      return this.replaceSelectionWith(schema.text(text), true)
    } else {
      if (!text) { return this.deleteRange(from, to) }
      var marks = this.storedMarks;
      if (!marks) {
        var $from = this.doc.resolve(from);
        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      return this.replaceRangeWith(from, to, schema.text(text, marks))
    }
  };

  // :: (union<string, Plugin, PluginKey>, any) → Transaction
  // Store a metadata property in this transaction, keyed either by
  // name or by plugin.
  Transaction.prototype.setMeta = function setMeta (key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this
  };

  // :: (union<string, Plugin, PluginKey>) → any
  // Retrieve a metadata property for a given name or plugin.
  Transaction.prototype.getMeta = function getMeta (key) {
    return this.meta[typeof key == "string" ? key : key.key]
  };

  // :: bool
  // Returns true if this transaction doesn't contain any metadata,
  // and can thus safely be extended.
  prototypeAccessors.isGeneric.get = function () {
    var this$1 = this;

    for (var _ in this$1.meta) { return false }
    return true
  };

  // :: () → Transaction
  // Indicate that the editor should scroll the selection into view
  // when updated to the state produced by this transaction.
  Transaction.prototype.scrollIntoView = function scrollIntoView () {
    this.updated |= UPDATED_SCROLL;
    return this
  };

  prototypeAccessors.scrolledIntoView.get = function () {
    return (this.updated & UPDATED_SCROLL) > 0
  };

  Object.defineProperties( Transaction.prototype, prototypeAccessors );

  return Transaction;
}(prosemirrorTransform.Transform));

function bind(f, self) {
  return !self || !f ? f : f.bind(self)
}

var FieldDesc = function FieldDesc(name, desc, self) {
  this.name = name;
  this.init = bind(desc.init, self);
  this.apply = bind(desc.apply, self);
};

var baseFields = [
  new FieldDesc("doc", {
    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
    apply: function apply(tr) { return tr.doc }
  }),

  new FieldDesc("selection", {
    init: function init(config, instance) { return config.selection || Selection.atStart(instance.doc) },
    apply: function apply(tr) { return tr.selection }
  }),

  new FieldDesc("storedMarks", {
    init: function init(config) { return config.storedMarks || null },
    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
  }),

  new FieldDesc("scrollToSelection", {
    init: function init() { return 0 },
    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
  })
];

// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
var Configuration = function Configuration(schema, plugins) {
  var this$1 = this;

  this.schema = schema;
  this.fields = baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  if (plugins) { plugins.forEach(function (plugin) {
    if (this$1.pluginsByKey[plugin.key])
      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
    this$1.plugins.push(plugin);
    this$1.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state)
      { this$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin)); }
  }); }
};

// ::- The state of a ProseMirror editor is represented by an object
// of this type. A state is a persistent data structure—it isn't
// updated, but rather a new state value is computed from an old one
// using the [`apply`](#state.EditorState.apply) method.
//
// A state holds a number of built-in fields, and plugins can
// [define](#state.PluginSpec.state) additional fields.
var EditorState = function EditorState(config) {
  this.config = config;
};

var prototypeAccessors$1 = { schema: {},plugins: {},tr: {} };

// doc:: Node
// The current document.

// selection:: Selection
// The selection.

// storedMarks:: ?[Mark]
// A set of marks to apply to the next input. Will be null when
// no explicit marks have been set.

// :: Schema
// The schema of the state's document.
prototypeAccessors$1.schema.get = function () {
  return this.config.schema
};

// :: [Plugin]
// The plugins that are active in this state.
prototypeAccessors$1.plugins.get = function () {
  return this.config.plugins
};

// :: (Transaction) → EditorState
// Apply the given transaction to produce a new state.
EditorState.prototype.apply = function apply (tr) {
  return this.applyTransaction(tr).state
};

// : (Transaction) → ?Transaction
EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
    var this$1 = this;
    if ( ignore === void 0 ) ignore = -1;

  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
    var plugin = this$1.config.plugins[i];
    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this$1))
      { return false }
  } }
  return true
};

// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
// Verbose variant of [`apply`](#state.EditorState.apply) that
// returns the precise transactions that were applied (which might
// be influenced by the [transaction
// hooks](#state.PluginSpec.filterTransaction) of
// plugins) along with the new state.
EditorState.prototype.applyTransaction = function applyTransaction (rootTr) {
    var this$1 = this;

  if (!this.filterTransaction(rootTr)) { return {state: this, transactions: []} }

  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
  // This loop repeatedly gives plugins a chance to respond to
  // transactions as new transactions are added, making sure to only
  // pass the transactions the plugin did not see before.
  outer: for (;;) {
    var haveNew = false;
    for (var i = 0; i < this.config.plugins.length; i++) {
      var plugin = this$1.config.plugins[i];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this$1;
        var tr = n < trs.length &&
            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr && newState.filterTransaction(tr, i)) {
          tr.setMeta("appendedTransaction", rootTr);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++)
              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this$1, n: 0}); }
          }
          trs.push(tr);
          newState = newState.applyInner(tr);
          haveNew = true;
        }
        if (seen) { seen[i] = {state: newState, n: trs.length}; }
      }
    }
    if (!haveNew) { return {state: newState, transactions: trs} }
  }
};

// : (Transaction) → EditorState
EditorState.prototype.applyInner = function applyInner (tr) {
    var this$1 = this;

  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
  var newInstance = new EditorState(this.config), fields = this.config.fields;
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    newInstance[field.name] = field.apply(tr, this$1[field.name], this$1, newInstance);
  }
  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) { applyListeners[i$1](this$1, tr, newInstance); }
  return newInstance
};

// :: Transaction
// Start a [transaction](#state.Transaction) from this state.
prototypeAccessors$1.tr.get = function () { return new Transaction(this) };

// :: (Object) → EditorState
// Create a new state.
//
// config::- Configuration options. Must contain `schema` or `doc` (or both).
//
//    schema:: ?Schema
//    The schema to use.
//
//    doc:: ?Node
//    The starting document.
//
//    selection:: ?Selection
//    A valid selection in the document.
//
//    storedMarks:: ?[Mark]
//    The initial set of [stored marks](#state.EditorState.storedMarks).
//
//    plugins:: ?[Plugin]
//    The plugins that should be active in this state.
EditorState.create = function create (config) {
  var $config = new Configuration(config.schema || config.doc.type.schema, config.plugins);
  var instance = new EditorState($config);
  for (var i = 0; i < $config.fields.length; i++)
    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
  return instance
};

// :: (Object) → EditorState
// Create a new state based on this one, but with an adjusted set of
// active plugins. State fields that exist in both sets of plugins
// are kept unchanged. Those that no longer exist are dropped, and
// those that are new are initialized using their
// [`init`](#state.StateField.init) method, passing in the new
// configuration object..
//
// config::- configuration options
//
//   schema:: ?Schema
//   New schema to use.
//
//   plugins:: ?[Plugin]
//   New set of active plugins.
EditorState.prototype.reconfigure = function reconfigure (config) {
    var this$1 = this;

  var $config = new Configuration(config.schema || this.schema, config.plugins);
  var fields = $config.fields, instance = new EditorState($config);
  for (var i = 0; i < fields.length; i++) {
    var name = fields[i].name;
    instance[name] = this$1.hasOwnProperty(name) ? this$1[name] : fields[i].init(config, instance);
  }
  return instance
};

// :: (?union<Object<Plugin>, string, number>) → Object
// Serialize this state to JSON. If you want to serialize the state
// of plugins, pass an object mapping property names to use in the
// resulting JSON object to plugin objects. The argument may also be
// a string or number, in which case it is ignored, to support the
// way `JSON.stringify` calls `toString` methods.
EditorState.prototype.toJSON = function toJSON (pluginFields) {
    var this$1 = this;

  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
    if (prop == "doc" || prop == "selection")
      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
    var plugin = pluginFields[prop], state = plugin.spec.state;
    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this$1[plugin.key]); }
  } }
  return result
};

// :: (Object, Object, ?Object<Plugin>) → EditorState
// Deserialize a JSON representation of a state. `config` should
// have at least a `schema` field, and should contain array of
// plugins to initialize the state with. `pluginFields` can be used
// to deserialize the state of plugins, by associating plugin
// instances with the property names they use in the JSON object.
//
// config::- configuration options
//
//   schema:: Schema
//   The schema to use.
//
//   plugins:: ?[Plugin]
//   The set of active plugins.
EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
  var $config = new Configuration(config.schema, config.plugins);
  var instance = new EditorState($config);
  $config.fields.forEach(function (field) {
    if (field.name == "doc") {
      instance.doc = prosemirrorModel.Node.fromJSON(config.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
    } else {
      if (pluginFields) { for (var prop in pluginFields) {
        var plugin = pluginFields[prop], state = plugin.spec.state;
        if (plugin.key == field.name && state && state.fromJSON &&
            Object.prototype.hasOwnProperty.call(json, prop)) {
          // This field belongs to a plugin mapped to a JSON field, read it from there.
          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
          return
        }
      } }
      instance[field.name] = field.init(config, instance);
    }
  });
  return instance
};

// Kludge to allow the view to track mappings between different
// instances of a state.
EditorState.addApplyListener = function addApplyListener (f) {
  applyListeners.push(f);
};
EditorState.removeApplyListener = function removeApplyListener (f) {
  var found = applyListeners.indexOf(f);
  if (found > -1) { applyListeners.splice(found, 1); }
};

Object.defineProperties( EditorState.prototype, prototypeAccessors$1 );

var applyListeners = [];

// PluginSpec:: interface
//
// This is the type passed to the [`Plugin`](#state.Plugin)
// constructor. It provides a definition for a plugin.
//
//   props:: ?EditorProps
//   The [view props](#view.EditorProps) added by this plugin. Props
//   that are functions will be bound to have the plugin instance as
//   their `this` binding.
//
//   state:: ?StateField<any>
//   Allows a plugin to define a [state field](#state.StateField), an
//   extra slot in the state object in which it can keep its own data.
//
//   key:: ?PluginKey
//   Can be used to make this a keyed plugin. You can have only one
//   plugin with a given key in a given state, but it is possible to
//   access the plugin's configuration and state through the key,
//   without having access to the plugin instance object.
//
//   view:: ?(EditorView) → Object
//   When the plugin needs to interact with the editor view, or
//   set something up in the DOM, use this field. The function
//   will be called when the plugin's state is associated with an
//   editor view.
//
//     return::-
//     Should return an object with the following optional
//     properties:
//
//       update:: ?(view: EditorView, prevState: EditorState)
//       Called whenever the view's state is updated.
//
//       destroy:: ?()
//       Called when the view is destroyed or receives a state
//       with different plugins.
//
//   filterTransaction:: ?(Transaction, EditorState) → bool
//   When present, this will be called before a transaction is
//   applied by the state, allowing the plugin to cancel it (by
//   returning false).
//
//   appendTransaction:: ?(transactions: [Transaction], oldState: EditorState, newState: EditorState) → ?Transaction
//   Allows the plugin to append another transaction to be applied
//   after the given array of transactions. When another plugin
//   appends a transaction after this was called, it is called again
//   with the new state and new transactions—but only the new
//   transactions, i.e. it won't be passed transactions that it
//   already saw.

function bindProps(obj, self, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) { val = val.bind(self); }
    else if (prop == "handleDOMEvents") { val = bindProps(val, self, {}); }
    target[prop] = val;
  }
  return target
}

// ::- Plugins bundle functionality that can be added to an editor.
// They are part of the [editor state](#state.EditorState) and
// may influence that state and the view that contains it.
var Plugin = function Plugin(spec) {
  // :: EditorProps
  // The [props](#view.EditorProps) exported by this plugin.
  this.props = {};
  if (spec.props) { bindProps(spec.props, this, this.props); }
  // :: Object
  // The plugin's [spec object](#state.PluginSpec).
  this.spec = spec;
  this.key = spec.key ? spec.key.key : createKey("plugin");
};

// :: (EditorState) → any
// Extract the plugin's state field from an editor state.
Plugin.prototype.getState = function getState (state) { return state[this.key] };

// StateField:: interface<T>
// A plugin spec may provide a state field (under its
// [`state`](#state.PluginSpec.state) property) of this type, which
// describes the state it wants to keep. Functions provided here are
// always called with the plugin instance as their `this` binding.
//
//   init:: (config: Object, instance: EditorState) → T
//   Initialize the value of the field. `config` will be the object
//   passed to [`EditorState.create`](#state.EditorState^create). Note
//   that `instance` is a half-initialized state instance, and will
//   not have values for plugin fields initialized after this one.
//
//   apply:: (tr: Transaction, value: T, oldState: EditorState, newState: EditorState) → T
//   Apply the given transaction to this state field, producing a new
//   field value. Note that the `newState` argument is again a partially
//   constructed state does not yet contain the state from plugins
//   coming after this one.
//
//   toJSON:: ?(value: T) → *
//   Convert this field to JSON. Optional, can be left off to disable
//   JSON serialization for the field.
//
//   fromJSON:: ?(config: Object, value: *, state: EditorState) → T
//   Deserialize the JSON representation of this field. Note that the
//   `state` argument is again a half-initialized state.

var keys = Object.create(null);

function createKey(name) {
  if (name in keys) { return name + "$" + ++keys[name] }
  keys[name] = 0;
  return name + "$"
}

// ::- A key is used to [tag](#state.PluginSpec.key)
// plugins in a way that makes it possible to find them, given an
// editor state. Assigning a key does mean only one plugin of that
// type can be active in a state.
var PluginKey = function PluginKey(name) {
if ( name === void 0 ) name = "key";
 this.key = createKey(name); };

// :: (EditorState) → ?Plugin
// Get the active plugin with this key, if any, from an editor
// state.
PluginKey.prototype.get = function get (state) { return state.config.pluginsByKey[this.key] };

// :: (EditorState) → ?any
// Get the plugin's state from an editor state.
PluginKey.prototype.getState = function getState (state) { return state[this.key] };

exports.Selection = Selection;
exports.SelectionRange = SelectionRange;
exports.TextSelection = TextSelection;
exports.NodeSelection = NodeSelection;
exports.AllSelection = AllSelection;
exports.Transaction = Transaction;
exports.EditorState = EditorState;
exports.Plugin = Plugin;
exports.PluginKey = PluginKey;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ "7007":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "70b0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__("4b23");

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__("f08e");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128B = function (_CODE) {
	_inherits(CODE128B, _CODE);

	function CODE128B(string, options) {
		_classCallCheck(this, CODE128B);

		return _possibleConstructorReturn(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants.B_START_CHAR + string, options));
	}

	_createClass(CODE128B, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.B_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128B;
}(_CODE3.default);

exports.default = CODE128B;

/***/ }),

/***/ "70db":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("ff45");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "70eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-option-group/mc-option-group.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_option_groupvue_type_script_lang_js_ = ({
  name: 'McOptionGroup',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-option-group', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-option-group/mc-option-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_option_group_mc_option_groupvue_type_script_lang_js_ = (mc_option_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-option-group/mc-option-group.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_option_group_mc_option_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_option_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-option-group/index.js


/* istanbul ignore next */

mc_option_group.install = function (Vue) {
  Vue.component(mc_option_group.name, mc_option_group);
};

/* harmony default export */ var components_mc_option_group = __webpack_exports__["default"] = (mc_option_group);

/***/ }),

/***/ "7118":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ "7163":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-breadcrumb/mc-breadcrumb.vue?vue&type=template&id=502938be&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-breadcrumb"},[_c('mtd-breadcrumb',[_vm._l((_vm.config),function(item,index){return [_c('mtd-breadcrumb-item',{key:index},[_c('span',{on:{"click":function($event){item.onClick ? item.onClick() : _vm.goTo(item.linkToConfig)}}},[_vm._v(_vm._s(item.name)+"\n                ")])])]})],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-breadcrumb/mc-breadcrumb.vue?vue&type=template&id=502938be&

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-breadcrumb/mc-breadcrumb.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_breadcrumbvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McBreadcrumb',
  props: {
    config: {
      type: Array,
      require: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    goTo: function goTo() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          url = _ref.url,
          params = _ref.params,
          options = _ref.options;

      if (!url) {
        return;
      }

      Object(tools_["linkTo"])(url, params || {}, options || {});
    }
  }
}));
// CONCATENATED MODULE: ./components/mc-breadcrumb/mc-breadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_breadcrumb_mc_breadcrumbvue_type_script_lang_js_ = (mc_breadcrumbvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-breadcrumb/mc-breadcrumb.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_breadcrumb_mc_breadcrumbvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_breadcrumb = (component.exports);
// CONCATENATED MODULE: ./components/mc-breadcrumb/index.js


/* istanbul ignore next */

mc_breadcrumb.install = function (Vue) {
  Vue.component(mc_breadcrumb.name, mc_breadcrumb);
};

/* harmony default export */ var components_mc_breadcrumb = __webpack_exports__["default"] = (mc_breadcrumb);

/***/ }),

/***/ "7196":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7196__;

/***/ }),

/***/ "71b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-loading/mc-loading.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_loadingvue_type_script_lang_js_ = ({
  name: 'McLoading',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-loading', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-loading/mc-loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_loading_mc_loadingvue_type_script_lang_js_ = (mc_loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-loading/mc-loading.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_loading_mc_loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_loading = (component.exports);
// CONCATENATED MODULE: ./components/mc-loading/index.js


/* istanbul ignore next */

mc_loading.install = function (Vue) {
  Vue.component(mc_loading.name, mc_loading);
};

/* harmony default export */ var components_mc_loading = __webpack_exports__["default"] = (mc_loading);

/***/ }),

/***/ "71c1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var defined = __webpack_require__("25eb");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "721a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__("fd7c");

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__("ab5b7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasRenderer = function () {
	function CanvasRenderer(canvas, encodings, options) {
		_classCallCheck(this, CanvasRenderer);

		this.canvas = canvas;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(CanvasRenderer, [{
		key: "render",
		value: function render() {
			// Abort if the browser does not support HTML5 canvas
			if (!this.canvas.getContext) {
				throw new Error('The browser does not support canvas.');
			}

			this.prepareCanvas();
			for (var i = 0; i < this.encodings.length; i++) {
				var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);

				this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
				this.drawCanvasText(encodingOptions, this.encodings[i]);

				this.moveCanvasDrawing(this.encodings[i]);
			}

			this.restoreCanvas();
		}
	}, {
		key: "prepareCanvas",
		value: function prepareCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.save();

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;

			this.canvas.height = maxHeight;

			// Paint the canvas
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.options.background) {
				ctx.fillStyle = this.options.background;
				ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			}

			ctx.translate(this.options.marginLeft, 0);
		}
	}, {
		key: "drawCanvasBarcode",
		value: function drawCanvasBarcode(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.marginTop + options.fontSize + options.textMargin;
			} else {
				yFrom = options.marginTop;
			}

			ctx.fillStyle = options.lineColor;

			for (var b = 0; b < binary.length; b++) {
				var x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					ctx.fillRect(x, yFrom, options.width, options.height);
				} else if (binary[b]) {
					ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
				}
			}
		}
	}, {
		key: "drawCanvasText",
		value: function drawCanvasText(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var font = options.fontOptions + " " + options.fontSize + "px " + options.font;

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				if (options.textPosition == "top") {
					y = options.marginTop + options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.marginTop + options.fontSize;
				}

				ctx.font = font;

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					ctx.textAlign = 'left';
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					ctx.textAlign = 'right';
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						ctx.textAlign = 'center';
					}

				ctx.fillText(encoding.text, x, y);
			}
		}
	}, {
		key: "moveCanvasDrawing",
		value: function moveCanvasDrawing(encoding) {
			var ctx = this.canvas.getContext("2d");

			ctx.translate(encoding.width, 0);
		}
	}, {
		key: "restoreCanvas",
		value: function restoreCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.restore();
		}
	}]);

	return CanvasRenderer;
}();

exports.default = CanvasRenderer;

/***/ }),

/***/ "721c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),

/***/ "72a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputRule; });
/* unused harmony export closeDoubleQuote */
/* unused harmony export closeSingleQuote */
/* unused harmony export ellipsis */
/* unused harmony export emDash */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inputRules; });
/* unused harmony export openDoubleQuote */
/* unused harmony export openSingleQuote */
/* unused harmony export smartQuotes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return textblockTypeInputRule; });
/* unused harmony export undoInputRule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wrappingInputRule; });
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ffb");
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prosemirror_transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b923");
/* harmony import */ var prosemirror_transform__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prosemirror_transform__WEBPACK_IMPORTED_MODULE_1__);



/**
Input rules are regular expressions describing a piece of text
that, when typed, causes something to happen. This might be
changing two dashes into an emdash, wrapping a paragraph starting
with `"> "` into a blockquote, or something entirely different.
*/
class InputRule {
    // :: (RegExp, union<string, (state: EditorState, match: [string], start: number, end: number) → ?Transaction>)
    /**
    Create an input rule. The rule applies when the user typed
    something and the text directly in front of the cursor matches
    `match`, which should end with `$`.
    
    The `handler` can be a string, in which case the matched text, or
    the first matched group in the regexp, is replaced by that
    string.
    
    Or a it can be a function, which will be called with the match
    array produced by
    [`RegExp.exec`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec),
    as well as the start and end of the matched range, and which can
    return a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) that describes the
    rule's effect, or null to indicate the input was not handled.
    */
    constructor(
    /**
    @internal
    */
    match, handler) {
        this.match = match;
        this.match = match;
        this.handler = typeof handler == "string" ? stringHandler(handler) : handler;
    }
}
function stringHandler(string) {
    return function (state, match, start, end) {
        let insert = string;
        if (match[1]) {
            let offset = match[0].lastIndexOf(match[1]);
            insert += match[0].slice(offset + match[1].length);
            start += offset;
            let cutOff = start - end;
            if (cutOff > 0) {
                insert = match[0].slice(offset - cutOff, offset) + insert;
                start = end;
            }
        }
        return state.tr.insertText(insert, start, end);
    };
}
const MAX_MATCH = 500;
/**
Create an input rules plugin. When enabled, it will cause text
input that matches any of the given rules to trigger the rule's
action.
*/
function inputRules({ rules }) {
    let plugin = new prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Plugin"]({
        state: {
            init() { return null; },
            apply(tr, prev) {
                let stored = tr.getMeta(this);
                if (stored)
                    return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        props: {
            handleTextInput(view, from, to, text) {
                return run(view, from, to, text, rules, plugin);
            },
            handleDOMEvents: {
                compositionend: (view) => {
                    setTimeout(() => {
                        let { $cursor } = view.state.selection;
                        if ($cursor)
                            run(view, $cursor.pos, $cursor.pos, "", rules, plugin);
                    });
                }
            }
        },
        isInputRules: true
    });
    return plugin;
}
function run(view, from, to, text, rules, plugin) {
    if (view.composing)
        return false;
    let state = view.state, $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code)
        return false;
    let textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset, null, "\ufffc") + text;
    for (let i = 0; i < rules.length; i++) {
        let match = rules[i].match.exec(textBefore);
        let tr = match && rules[i].handler(state, match, from - (match[0].length - text.length), to);
        if (!tr)
            continue;
        view.dispatch(tr.setMeta(plugin, { transform: tr, from, to, text }));
        return true;
    }
    return false;
}
/**
This is a command that will undo an input rule, if applying such a
rule was the last thing that the user did.
*/
const undoInputRule = (state, dispatch) => {
    let plugins = state.plugins;
    for (let i = 0; i < plugins.length; i++) {
        let plugin = plugins[i], undoable;
        if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
            if (dispatch) {
                let tr = state.tr, toUndo = undoable.transform;
                for (let j = toUndo.steps.length - 1; j >= 0; j--)
                    tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                if (undoable.text) {
                    let marks = tr.doc.resolve(undoable.from).marks();
                    tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                }
                else {
                    tr.delete(undoable.from, undoable.to);
                }
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};

/**
Converts double dashes to an emdash.
*/
const emDash = new InputRule(/--$/, "—");
/**
Converts three dots to an ellipsis character.
*/
const ellipsis = new InputRule(/\.\.\.$/, "…");
/**
“Smart” opening double quotes.
*/
const openDoubleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "“");
/**
“Smart” closing double quotes.
*/
const closeDoubleQuote = new InputRule(/"$/, "”");
/**
“Smart” opening single quotes.
*/
const openSingleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "‘");
/**
“Smart” closing single quotes.
*/
const closeSingleQuote = new InputRule(/'$/, "’");
/**
Smart-quote related input rules.
*/
const smartQuotes = [openDoubleQuote, closeDoubleQuote, openSingleQuote, closeSingleQuote];

/**
Build an input rule for automatically wrapping a textblock when a
given string is typed. The `regexp` argument is
directly passed through to the `InputRule` constructor. You'll
probably want the regexp to start with `^`, so that the pattern can
only occur at the start of a textblock.

`nodeType` is the type of node to wrap in. If it needs attributes,
you can either pass them directly, or pass a function that will
compute them from the regular expression match.

By default, if there's a node with the same type above the newly
wrapped node, the rule will try to [join](https://prosemirror.net/docs/ref/#transform.Transform.join) those
two nodes. You can pass a join predicate, which takes a regular
expression match and the node before the wrapped node, and can
return a boolean to indicate whether a join should happen.
*/
function wrappingInputRule(regexp, nodeType, getAttrs = null, joinPredicate) {
    return new InputRule(regexp, (state, match, start, end) => {
        let attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        let tr = state.tr.delete(start, end);
        let $start = tr.doc.resolve(start), range = $start.blockRange(), wrapping = range && Object(prosemirror_transform__WEBPACK_IMPORTED_MODULE_1__["findWrapping"])(range, nodeType, attrs);
        if (!wrapping)
            return null;
        tr.wrap(range, wrapping);
        let before = tr.doc.resolve(start - 1).nodeBefore;
        if (before && before.type == nodeType && Object(prosemirror_transform__WEBPACK_IMPORTED_MODULE_1__["canJoin"])(tr.doc, start - 1) &&
            (!joinPredicate || joinPredicate(match, before)))
            tr.join(start - 1);
        return tr;
    });
}
/**
Build an input rule that changes the type of a textblock when the
matched text is typed into it. You'll usually want to start your
regexp with `^` to that it is only matched at the start of a
textblock. The optional `getAttrs` parameter can be used to compute
the new node's attributes, and works the same as in the
`wrappingInputRule` function.
*/
function textblockTypeInputRule(regexp, nodeType, getAttrs = null) {
    return new InputRule(regexp, (state, match, start, end) => {
        let $start = state.doc.resolve(start);
        let attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType))
            return null;
        return state.tr
            .delete(start, end)
            .setBlockType(start, start, nodeType, attrs);
    });
}




/***/ }),

/***/ "72aa":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("3fb5")
var Sha256 = __webpack_require__("a255")
var Hash = __webpack_require__("b672")
var Buffer = __webpack_require__("8707").Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ "730c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ "73334":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("9e1e");
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "7378":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GapCursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closedBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gapCursorSituation; });
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ffb");
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6f27");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prosemirror_model__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fbea");
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prosemirror_commands__WEBPACK_IMPORTED_MODULE_2__);





/**
 * TODO: 节点类型是支持gapcursor的，由于目前部分gapcursor定义存在问题，在不保证修改schema的情况下做一层胶水
 * 后续如果schema统一治理，需要将这段代码考虑优化
 */ var allowGapCursor = function(node) {
    if (!node) {
        return false;
    }
    var allow = node.type.spec.allowGapCursor;
    if (allow) {
        return true;
    }
    var textType = [
        "catalog"
    ];
    return textType.includes(node.type.name);
};

/* eslint-disable */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var gapCursorSituation;
(function(gapCursorSituation) {
    gapCursorSituation["beforeInlineNode"] = "beforeInlineNode";
    gapCursorSituation["afterInlineNode"] = "afterInlineNode";
    gapCursorSituation["beforeNode"] = "beforeNode";
    gapCursorSituation["afterNode"] = "afterNode";
})(gapCursorSituation || (gapCursorSituation = {}));
// ::- Gap cursor selections are represented using this class. Its
// `$anchor` and `$head` properties both point at the cursor position.
var GapCursor = /*#__PURE__*/ function(Selection1) {
    _inherits(GapCursor, Selection1);
    var _super = _createSuper(GapCursor);
    function GapCursor($pos, type) {
        _classCallCheck(this, GapCursor);
        var _this;
        _this = _super.call(this, $pos, $pos);
        _this.gapCursorType = type;
        return _this;
    }
    var _proto = GapCursor.prototype;
    _proto.map = function map(doc, mapping) {
        var $pos = doc.resolve(mapping.map(this.head));
        return GapCursor.valid($pos) ? new GapCursor($pos, this.gapCursorType) : prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].near($pos);
    };
    _proto.content = function content() {
        return prosemirror_model__WEBPACK_IMPORTED_MODULE_1__["Slice"].empty;
    };
    _proto.eq = function eq(other) {
        return _instanceof(other, GapCursor) && other.head == this.head;
    };
    _proto.toJSON = function toJSON() {
        return {
            type: "base_custom_gapcursor",
            pos: this.head
        };
    };
    _proto.getBookmark = function getBookmark() {
        return new GapBookmark(this.anchor);
    };
    GapCursor.fromJSON = function fromJSON(doc, json) {
        if (typeof json.pos !== "number") {
            throw new RangeError("Invalid input for GapCursor.fromJSON");
        }
        return new GapCursor(doc.resolve(json.pos));
    };
    GapCursor.valid = function valid($pos) {
        var parent = $pos.parent;
        if (closedBefore($pos) || closedAfter($pos)) return true;
        // todo: 以下四行代码作用未知，参考自：https://github.com/ProseMirror/prosemirror-gapcursor/blob/227647234f6cd97c7c0b1e0dd3eb75aa21e809f5/src/gapcursor.js
        var override = parent.type.spec.allowGapCursor;
        if (override != null) return override;
        var deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    };
    GapCursor.getType = function getType($pos) {
        var bias = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var beforeCheck = function() {
            if (closedBefore($pos)) {
                var _$pos_nodeBefore;
                if ((_$pos_nodeBefore = $pos.nodeBefore) === null || _$pos_nodeBefore === void 0 ? void 0 : _$pos_nodeBefore.isInline) return gapCursorSituation.afterInlineNode;
                return gapCursorSituation.afterNode;
            }
            return null;
        };
        var aftercheck = function() {
            if (closedAfter($pos)) {
                var _$pos_nodeAfter;
                if ((_$pos_nodeAfter = $pos.nodeAfter) === null || _$pos_nodeAfter === void 0 ? void 0 : _$pos_nodeAfter.isInline) return gapCursorSituation.beforeInlineNode;
                return gapCursorSituation.beforeNode;
            }
            return null;
        };
        var checkHandler = [
            beforeCheck,
            aftercheck
        ];
        if (bias !== 0) {
            checkHandler = bias < 0 ? [
                beforeCheck
            ] : [
                aftercheck
            ];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = checkHandler[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var handler = _step.value;
                var type = handler();
                if (type) {
                    return type;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    GapCursor.findFrom = function findFrom($pos, dir, mustMove) {
        search: for(;;){
            if (!mustMove && GapCursor.valid($pos)) return $pos;
            var pos = $pos.pos;
            var next = null;
            // Scan up from this position
            for(var d = $pos.depth;; d--){
                var parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d == 0) {
                    return null;
                }
                pos += dir;
                var $cur = $pos.doc.resolve(pos);
                if (GapCursor.valid($cur)) return $cur;
            }
            // And then down into the next node
            for(;;){
                var inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["NodeSelection"].isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                var $cur1 = $pos.doc.resolve(pos);
                if (GapCursor.valid($cur1)) return $cur1;
            }
            return null;
        }
    };
    _createClass(GapCursor, [
        {
            key: "targetNode",
            get: function get() {
                var res = GapCursor.findFrom(this.$from, -1);
                if (this.gapCursorType === gapCursorSituation.beforeInlineNode || this.gapCursorType === gapCursorSituation.beforeNode) {
                    return res.nodeAfter;
                } else {
                    return res.nodeBefore;
                }
            }
        }
    ]);
    return GapCursor;
}(_wrapNativeSuper(prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"]));
GapCursor.prototype.visible = false;
(function() {
    var id = "base_custom_gapcursor";
    if (window["__".concat(id, "__")]) {
        return;
    }
    window["__".concat(id, "__")] = true;
    prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].jsonID(id, GapCursor);
})();
var GapBookmark = /*#__PURE__*/ function() {
    function GapBookmark(pos) {
        _classCallCheck(this, GapBookmark);
        this.pos = pos;
    }
    var _proto = GapBookmark.prototype;
    _proto.map = function map(mapping) {
        return new GapBookmark(mapping.map(this.pos));
    };
    _proto.resolve = function resolve(doc) {
        var $pos = doc.resolve(this.pos);
        return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirror_state__WEBPACK_IMPORTED_MODULE_0__["Selection"].near($pos);
    };
    return GapBookmark;
}();
function closedBefore($pos) {
    var keepDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var nodeBefore = $pos.nodeBefore;
    // 处于文本中且不在文本开头
    if ($pos.parent.isTextblock && (!nodeBefore || nodeBefore.isText)) return false;
    if (nodeBefore && !nodeBefore.isText && nodeBefore.isInline && allowGapCursor(nodeBefore)) return true;
    if (nodeBefore && nodeBefore.isBlock && allowGapCursor(nodeBefore) && nodeBefore.type.name !== "blockquote") return true;
    if (keepDepth) {
        return false;
    }
    for(var d = $pos.depth; d > 0; d--){
        var index = $pos.index(d);
        // At the start of this parent, look at next one
        if (index == 0) continue;
        // See if the node before (or its first ancestor) is closed
        for(var before = $pos.node(d).child(index - 1); before; before = before.lastChild){
            if ((before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) && before.type.spec.allowGapCursor) {
                return true;
            }
            if (before.inlineContent) return false;
        }
    }
    // Hit start of document
    return false;
}
/**
 * 检查传入位置的后方节点是否可以允许Gapcursor
 * @param $pos 传入位置
 * @param keepDepth 是否保持深度，默认false表示当与传入位置相同深度下，如果后方不允许Gapcursor，将继续
 * 向下依次寻找首个子孙节点，如果这些节点的均不允许Gapcursor，将继续向上提个深度并继续寻找首个子孙节点。为true则
 * 不进行寻找首个子孙节点操作
 * --> a
 * ----> b
 */ function closedAfter($pos) {
    var keepDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var nodeAfter = $pos.nodeAfter;
    // 处于文本中且不在文本尾部
    if ($pos.parent.isTextblock && (!nodeAfter || nodeAfter.isText)) return false;
    if (nodeAfter && !nodeAfter.isText && nodeAfter.isInline && nodeAfter.type.spec.allowGapCursor) return true;
    if (nodeAfter && nodeAfter.isBlock && nodeAfter.type.spec.allowGapCursor && nodeAfter.type.name !== "blockquote") return true;
    if (keepDepth) {
        return false;
    }
    for(var d = $pos.depth; d > 0; d--){
        var index = $pos.indexAfter(d);
        var parent = $pos.node(d);
        if (index == parent.childCount) continue;
        for(var after = parent.child(index); after; after = after.firstChild){
            if ((after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) && after.type.spec.allowGapCursor) {
                return true;
            }
            if (after.inlineContent) return false;
        }
    }
    return false;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ "74dc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ "7514":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("5ca1");
var $find = __webpack_require__("0a49")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("9c6c")(KEY);


/***/ }),

/***/ "752b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _canvas = __webpack_require__("721a");

var _canvas2 = _interopRequireDefault(_canvas);

var _svg = __webpack_require__("be5e");

var _svg2 = _interopRequireDefault(_svg);

var _object = __webpack_require__("4ced");

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };

/***/ }),

/***/ "75cc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__("8707")
var randombytes = __webpack_require__("11dc")
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("f28c")))

/***/ }),

/***/ "75f6":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("4a9d");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "75fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __webpack_require__("a745");
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (is_array_default()(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/from.js
var from = __webpack_require__("774e");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/is-iterable.js
var is_iterable = __webpack_require__("c8bb");
var is_iterable_default = /*#__PURE__*/__webpack_require__.n(is_iterable);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/iterableToArray.js


function _iterableToArray(iter) {
  if (is_iterable_default()(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return from_default()(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _toConsumableArray; });



function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

/***/ }),

/***/ "7600":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-anchor-link/mc-anchor-link.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_anchor_linkvue_type_script_lang_js_ = ({
  name: 'McAnchorLink',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-anchor-link', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-anchor-link/mc-anchor-link.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_anchor_link_mc_anchor_linkvue_type_script_lang_js_ = (mc_anchor_linkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-anchor-link/mc-anchor-link.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_anchor_link_mc_anchor_linkvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_anchor_link = (component.exports);
// CONCATENATED MODULE: ./components/mc-anchor-link/index.js


/* istanbul ignore next */

mc_anchor_link.install = function (Vue) {
  Vue.component(mc_anchor_link.name, mc_anchor_link);
};

/* harmony default export */ var components_mc_anchor_link = __webpack_exports__["default"] = (mc_anchor_link);

/***/ }),

/***/ "7618":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
/* harmony import */ var _core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5d58");
/* harmony import */ var _core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_js_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("67bb");
/* harmony import */ var _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_core_js_symbol__WEBPACK_IMPORTED_MODULE_1__);



function _typeof2(obj) { if (typeof _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a === "function" && typeof _core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_0___default.a === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a === "function" && obj.constructor === _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a && obj !== _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a === "function" && _typeof2(_core_js_symbol_iterator__WEBPACK_IMPORTED_MODULE_0___default.a) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a === "function" && obj.constructor === _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a && obj !== _core_js_symbol__WEBPACK_IMPORTED_MODULE_1___default.a.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),

/***/ "7658":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ "765d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6718")('observable');


/***/ }),

/***/ "768b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __webpack_require__("a745");
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/arrayWithHoles.js

function _arrayWithHoles(arr) {
  if (is_array_default()(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/get-iterator.js
var get_iterator = __webpack_require__("5d73");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/is-iterable.js
var is_iterable = __webpack_require__("c8bb");
var is_iterable_default = /*#__PURE__*/__webpack_require__.n(is_iterable);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/iterableToArrayLimit.js


function _iterableToArrayLimit(arr, i) {
  if (!(is_iterable_default()(Object(arr)) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = get_iterator_default()(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _slicedToArray; });



function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "774e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("d2d5");

/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "780f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("27bf");

/*<replacement>*/
var util = __webpack_require__("3a7c");
util.inherits = __webpack_require__("3fb5");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "7903":
/***/ (function(module, exports) {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),

/***/ "791b":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("ff45"),
    Map = __webpack_require__("54d8"),
    MapCache = __webpack_require__("0197");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "7944":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "794b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("8e60") && !__webpack_require__("294c")(function () {
  return Object.defineProperty(__webpack_require__("1ec9")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "795b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("696e");

/***/ }),

/***/ "79aa":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "79f1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = fixOptions;


function fixOptions(options) {
	// Fix the margins
	options.marginTop = options.marginTop || options.margin;
	options.marginBottom = options.marginBottom || options.margin;
	options.marginRight = options.marginRight || options.margin;
	options.marginLeft = options.marginLeft || options.margin;

	return options;
}

/***/ }),

/***/ "7a10":
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__("399f");
var brorand = __webpack_require__("fdac");

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ "7a43":
/***/ (function(module, exports) {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ "7a56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var dP = __webpack_require__("86cc");
var DESCRIPTORS = __webpack_require__("9e1e");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "7ba0":
/***/ (function(module, exports) {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),

/***/ "7bbc":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("6821");
var gOPN = __webpack_require__("9093").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "7bbc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-select/mc-select.vue?vue&type=template&id=7a06acb0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readonly)?_c('mtd-select',_vm._b({ref:"mtdSelect",staticClass:"mc-select",attrs:{"multiple":_vm.multiple,"filterable":_vm.filterable,"filter-method":function () { return true; },"no-match-text":'',"loading":_vm.computedLoading,"readonly":_vm.readonly,"debounce":500},on:{"change":_vm.change,"filter":_vm.filter,"scroll-bottom":_vm.scrollBottom,"update:visible":_vm.updateVisible},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mtd-select',_vm.attrs,false),[_vm._l((_vm.innerList),function(item){return _c('mtd-option',{key:item.value,attrs:{"value":item.value,"label":item.label,"disabled":item.disabled}},[(_vm.slots.default)?_c('template',{slot:"default"},[_vm._t("default",null,{"option":item,"list":_vm.innerList})],2):[_vm._v("\n                "+_vm._s(item.label)+"\n            ")]],2)}),(_vm.slots.empty)?_c('template',{slot:"empty"},[_vm._t("empty")],2):_vm._e(),(_vm.slots.loading)?_c('template',{slot:"loading"},[_vm._t("loading")],2):_vm._e()],2):_c('div',[_vm._v("\n        "+_vm._s(_vm.labels)+"\n    ")])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-select/mc-select.vue?vue&type=template&id=7a06acb0&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.constructor.js
var es6_regexp_constructor = __webpack_require__("3b2b");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./composables/useRemote.js
var useRemote = __webpack_require__("9ea3");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-select/mc-select.vue?vue&type=script&lang=js&














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var mc_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McSelect',
  props: {
    value: {
      required: false
    },
    labelKey: {
      type: [String, Function],
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    selectFirst: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    source: {
      type: [Array, String, Object],
      default: function _default() {
        return [];
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    allValue: {
      type: [String, Number, Object],
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    scrollStep: {
      type: Object,
      default: function _default() {
        return {
          size: Infinity,
          remote: false
        };
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var mtdSelect = Object(composition_api_["ref"])(null);
    var stepStack = Object(composition_api_["ref"])(1);

    var formatList = function formatList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _props$disabledIds = props.disabledIds,
          disabledIds = _props$disabledIds === void 0 ? [] : _props$disabledIds,
          labelKey = props.labelKey,
          valueKey = props.valueKey;
      var stackList = Object(tools_["cloneDeep"])(list).map(function (item) {
        var stack = _objectSpread({}, item);

        if (disabledIds && Array.isArray(disabledIds) && disabledIds.includes(item[valueKey])) {
          stack.disabled = true;
        }

        var label = typeof labelKey === 'function' ? labelKey(item) : item[labelKey];
        return _objectSpread({}, stack, {
          label: label,
          value: item[valueKey]
        });
      });
      return stackList;
    };

    var findListItem = function findListItem(data, value) {
      return data.find(function (dataItem) {
        return dataItem.value === value;
      });
    };

    var getSelectItems = function getSelectItems(list, selectValue) {
      var stack = [];

      if (Array.isArray(selectValue)) {
        stack = selectValue.reduce(function (prev, curr) {
          var initSelected = findListItem(list, curr);

          if (initSelected) {
            prev.push(initSelected);
          }

          return prev;
        }, []);
      } else {
        var initSelected = findListItem(list, selectValue);

        if (initSelected) {
          stack.push(initSelected);
        }
      }

      return stack;
    };

    var cutList = function cutList(list, initValue) {
      var _props$scrollStep$siz = props.scrollStep.size,
          size = _props$scrollStep$siz === void 0 ? Infinity : _props$scrollStep$siz;
      var endIndex = size < 0 || size === Infinity ? Infinity : size * stepStack.value;
      var stack = []; // 以下逻辑用于大数据下拉列表初始化时，无法获得返显数据情况，先将返显数据节点添加到初始化列表中

      var initValueIsNodeEmpty = initValue !== '' && initValue !== undefined || Array.isArray(initValue) && initValue.length > 0;

      if (size !== Infinity && initValueIsNodeEmpty) {
        stack = getSelectItems(list, initValue);
      } // 去除选中节点和可选节点重复数据


      return list.slice(0, endIndex).reduce(function (prev, curr) {
        // 判断是否为重复节点
        var nodeExist = prev.find(function (item) {
          return item.value === curr.value && item.label === curr.label;
        });
        if (!nodeExist) prev.push(curr);
        return prev;
      }, stack);
    };

    var getDefaultValue = function getDefaultValue() {
      if (props.multiple) return !Array.isArray(props.value) ? [] : props.value;
      return Object(esm_typeof["a" /* default */])(props.value) === 'object' ? '' : props.value;
    };

    var parsedQuery = function parsedQuery(query) {
      return String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
    };

    var original = Object(composition_api_["reactive"])({
      innerValue: getDefaultValue(),
      storeList: [],
      stackList: [],
      innerList: [],
      innerLoading: false,
      fetchData: undefined,
      updatePopper: function updatePopper() {
        mtdSelect.value.$refs.wrappedInstance.updatePopper();
      },
      change: function change(v) {
        var valueKey = props.valueKey,
            multiple = props.multiple;
        var selectItems = original.storeList[multiple ? 'filter' : 'find'](function (cItem) {
          if (multiple) {
            return v.includes(cItem[valueKey]);
          } else {
            return cItem[valueKey] === v;
          }
        });
        ctx.emit('change', v, selectItems);
        ctx.emit('input', v);
      },
      scrollBottom: Object(tools_["debounce"])(
      /*#__PURE__*/
      Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (props.scrollStep.size !== Infinity) {
                  stepStack.value += 1;
                  original.innerList = cutList(original.stackList);
                  original.updatePopper();
                }

                ctx.emit('scroll-bottom');

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 300),
      updateVisible: function updateVisible(v) {
        ctx.emit('update:visible', v);
      },
      filter: function () {
        var _filter = Object(asyncToGenerator["a" /* default */])(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(query) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  stepStack.value = 1;

                  if (!(Array.isArray(props.source) || props.source.dictCode)) {
                    _context2.next = 6;
                    break;
                  }

                  original.stackList = formatList(original.storeList).filter(function (item) {
                    return new RegExp(parsedQuery(query), 'i').test(item.label);
                  });
                  original.innerList = cutList(original.stackList);
                  _context2.next = 13;
                  break;

                case 6:
                  original.innerLoading = true;
                  _context2.next = 9;
                  return original.fetchData({
                    query: query
                  });

                case 9:
                  original.storeList = _context2.sent;
                  original.stackList = formatList(original.storeList);
                  original.innerList = cutList(original.stackList);
                  original.innerLoading = false;

                case 13:
                  original.updatePopper();

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function filter(_x) {
          return _filter.apply(this, arguments);
        }

        return filter;
      }(),
      selectAll: function selectAll() {
        if (!props.multiple) {
          // eslint-disable-next-line no-console
          console.log('非多选状态，不可全选');
        } else {
          original.innerValue = original.innerList.filter(function (item) {
            return !item.disabled;
          }).map(function (item) {
            return item.value;
          });
          ctx.emit('change', original.innerValue, original.innerList);
          ctx.emit('input', original.innerValue);
        }
      },
      focus: function focus() {
        mtdSelect.value.focus();
      },
      blur: function blur() {
        mtdSelect.value.blur();
      },
      reset: function reset() {
        stepStack.value = 1;

        if (props.multiple) {
          original.innerValue = [];
        } else {
          original.innerValue = '';
        }

        ctx.emit('change', original.innerValue);
        ctx.emit('input', original.innerValue);
      },
      labels: Object(composition_api_["computed"])(function () {
        return original.innerList.filter(function (item) {
          if (props.multiple) {
            return original.innerValue.includes(item.value);
          } else {
            return item.value === original.innerValue;
          }
        }).map(function (item) {
          return item.label;
        }).join(',') || '--';
      })
    });
    var originalRefs = Object(composition_api_["toRefs"])(original);

    var initSelect =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _useRemote, fetchData, customValue, customLabel, stack;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                original.innerLoading = true;
                _context3.prev = 1;

                if (!Array.isArray(props.source)) {
                  _context3.next = 6;
                  break;
                }

                original.storeList = props.source;
                _context3.next = 11;
                break;

              case 6:
                _useRemote = Object(useRemote["a" /* default */])(props.source, ctx), fetchData = _useRemote.fetchData;
                _context3.next = 9;
                return fetchData();

              case 9:
                original.storeList = _context3.sent;
                original.fetchData = fetchData;

              case 11:
                customValue = ['object'].includes(Object(esm_typeof["a" /* default */])(props.allValue)) ? props.allValue.value : props.allValue;
                customLabel = ['object'].includes(Object(esm_typeof["a" /* default */])(props.allValue)) ? props.allValue.label || '全部' : '全部';

                if (['number', 'string'].includes(Object(esm_typeof["a" /* default */])(customValue)) && customValue !== '') {
                  stack = {};
                  stack[props.labelKey] = customLabel;
                  stack[props.valueKey] = customValue;
                  original.storeList.unshift(stack);
                }

                original.stackList = formatList(original.storeList);
                original.innerList = cutList(original.stackList, original.innerValue);
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](1);
                original.storeList = [];
                original.innerList = [];

              case 22:
                original.innerLoading = false;

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 18]]);
      }));

      return function initSelect() {
        return _ref2.apply(this, arguments);
      };
    }();

    initSelect();
    var computedLoading = Object(composition_api_["computed"])(function () {
      return props.loading || original.innerLoading;
    });
    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (value) {
      if (props.multiple) {
        if (Array.isArray(value) && JSON.stringify(value) !== JSON.stringify(original.innerValue)) {
          original.innerValue = value;
          stepStack.value = 1;
          original.innerList = cutList(original.stackList, original.innerValue);
        }
      } else {
        if (original.innerValue !== value) {
          original.innerValue = value;
          stepStack.value = 1;
          original.innerList = cutList(original.stackList, original.innerValue);
        }
      }
    });
    Object(composition_api_["watch"])(function () {
      return props.disabledIds;
    }, function () {
      original.innerList = formatList(original.storeList);
    });
    Object(composition_api_["watch"])(function () {
      return props.source;
    }, function () {
      initSelect();
    }, {
      deep: true
    });
    return _objectSpread({}, originalRefs, {
      computedLoading: computedLoading,
      mtdSelect: mtdSelect,
      attrs: ctx.attrs,
      slots: ctx.slots
    });
  }
}));
// CONCATENATED MODULE: ./components/mc-select/mc-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_select_mc_selectvue_type_script_lang_js_ = (mc_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-select/mc-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_select_mc_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-select/index.js


/* istanbul ignore next */

mc_select.install = function (Vue) {
  Vue.component(mc_select.name, mc_select);
};

/* harmony default export */ var components_mc_select = __webpack_exports__["default"] = (mc_select);

/***/ }),

/***/ "7be6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ "7bf0":
/***/ (function(module, exports) {

let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),

/***/ "7cb9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pharmacode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf

var pharmacode = function (_Barcode) {
	_inherits(pharmacode, _Barcode);

	function pharmacode(data, options) {
		_classCallCheck(this, pharmacode);

		var _this = _possibleConstructorReturn(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));

		_this.number = parseInt(data, 10);
		return _this;
	}

	_createClass(pharmacode, [{
		key: "encode",
		value: function encode() {
			var z = this.number;
			var result = "";

			// http://i.imgur.com/RMm4UDJ.png
			// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
			while (!isNaN(z) && z != 0) {
				if (z % 2 === 0) {
					// Even
					result = "11100" + result;
					z = (z - 2) / 2;
				} else {
					// Odd
					result = "100" + result;
					z = (z - 1) / 2;
				}
			}

			// Remove the two last zeroes
			result = result.slice(0, -2);

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.number >= 3 && this.number <= 131070;
		}
	}]);

	return pharmacode;
}(_Barcode3.default);

exports.pharmacode = pharmacode;

/***/ }),

/***/ "7cd6":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("40c3");
var ITERATOR = __webpack_require__("5168")('iterator');
var Iterators = __webpack_require__("481b");
module.exports = __webpack_require__("584a").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "7d2a":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "7d70":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("6884");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "7d76":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "7d7b":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var get = __webpack_require__("7cd6");
module.exports = __webpack_require__("584a").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "7d92":
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__("c3c0");
hash.common = __webpack_require__("edc9");
hash.sha = __webpack_require__("5919");
hash.ripemd = __webpack_require__("bb44");
hash.hmac = __webpack_require__("2137");

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ "7ded":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("c3f1");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "7e25":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),

/***/ "7e78":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__("3fb5")
var Hash = __webpack_require__("b672")
var Buffer = __webpack_require__("8707").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ "7e90":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var anObject = __webpack_require__("e4ae");
var getKeys = __webpack_require__("c3a1");

module.exports = __webpack_require__("8e60") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "7ec6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-purchase-org-select/mc-purchase-org-select.vue?vue&type=template&id=62c14f75&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-purchase--org--select"},[_c('mc-tree-select',_vm._g(_vm._b({ref:"treeSelectRef",staticClass:"mc-categoryselect",attrs:{"data":_vm.showData,"disabled":_vm.disabled,"readonly":_vm.readonly,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"only-leaf":_vm.leafOnly,"editable-method":_vm.isSelectLevel},on:{"change":_vm.handleChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-tree-select',_vm.$attrs,false),_vm.listeners))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-purchase-org-select/mc-purchase-org-select.vue?vue&type=template&id=62c14f75&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__("a8db");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-purchase-org-select/mc-purchase-org-select.vue?vue&type=script&lang=js&












function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_purchase_org_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McPurchaseOrgSelect',
  props: {
    value: {
      type: [Number, String, Array],
      default: function _default() {
        return [];
      }
    },
    // 是否按权限过滤
    usePermission: {
      type: Boolean,
      default: false
    },
    // 是否是多选模式
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 设置禁止选择的项的 id 数组
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择采购组织'
    },
    // 最多显示的层级
    maxLevel: {
      type: Number,
      default: Infinity
    },
    // 可以选中的层级
    selectLevel: {
      type: [Number, String, Array],
      default: function _default() {
        return [];
      }
    },
    // 是否展示品类id
    showId: {
      type: Boolean,
      default: false
    },
    // 是否只允许选择叶子节点
    leafOnly: {
      type: Boolean,
      default: false
    },
    // 额外请求品类接口的参数
    extraParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 返回值处理
    responseProcessor: {
      type: Function,
      default: null
    },
    // 系统来源 jiemo | vss | lps ...
    source: {
      type: String,
      default: 'jiemo'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var treeSelectRef = Object(composition_api_["ref"])(null);

    var getRequestInfo = function getRequestInfo() {
      var requestInfoMap = {
        jiemo: {
          url: props.usePermission ? '/shepherd/product/bizcenter/purchaserOrgTService/getDeptListByMisId' : '/shepherd/product/bizcenter/purchaserOrgTService/getAllDept',
          body: _objectSpread({
            usePermission: props.usePermission
          }, props.extraParams || {})
        }
      };
      var _requestInfoMap$props = requestInfoMap[props.source],
          url = _requestInfoMap$props.url,
          body = _requestInfoMap$props.body;
      return {
        url: url,
        body: body
      };
    };

    var setItemDisabled = function setItemDisabled(item) {
      var isDisabled = false;

      if (props.disabledIds && props.disabledIds.includes(item.id)) {
        isDisabled = true;
      }

      return isDisabled;
    }; // 控制层级是否可以选择


    var isSelectLevel = function isSelectLevel(node) {
      var selectLevel = props.selectLevel;
      var level = Number(node.level);

      if (!selectLevel || !selectLevel.length) {
        return true;
      }

      if (Array.isArray(selectLevel)) {
        return selectLevel.indexOf(level) > -1;
      }

      if (typeof selectLevel === 'number' || typeof selectLevel === 'string') {
        return Number(selectLevel) === level;
      }

      return true;
    };

    var data = Object(composition_api_["reactive"])({
      innerValue: Object(composition_api_["computed"])({
        get: function get() {
          return props.value;
        },
        set: function set(val) {
          emit('input', val);
        }
      }),
      categoryData: [],
      showData: Object(composition_api_["computed"])(function () {
        return data.categoryData.filter(function (item) {
          return !props.maxLevel || item.level <= props.maxLevel;
        }).map(function (item) {
          // 设置禁用
          item.disabled = setItemDisabled(item);
          return item;
        });
      })
    });
    var listeners = Object(composition_api_["computed"])(function () {
      var _proxy$$listeners = proxy.$listeners,
          change = _proxy$$listeners.change,
          others = Object(objectWithoutProperties["a" /* default */])(_proxy$$listeners, ["change"]);

      return others;
    });

    var handleChange = function handleChange(val, item) {
      emit('change', val, item);
    };

    var handleData = function handleData(res) {
      var innerData = res.map(function (item) {
        var id = item.categoryId || item.id;
        var prefix = props.showId ? "".concat(id, "-") : '';
        var name = "".concat(prefix).concat(item.name || item.label);
        return _objectSpread({}, item, {
          id: id,
          name: name,
          parentId: item.parentId
        });
      });
      data.categoryData = innerData;
      emit('loaded', innerData);
    };

    var getAllCategoryList =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _getRequestInfo, url, body, res, resData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getRequestInfo = getRequestInfo(), url = _getRequestInfo.url, body = _getRequestInfo.body;
                _context.next = 3;
                return proxy.$hPost(url, body, {
                  cache: true
                }).catch(function () {
                  return [];
                });

              case 3:
                res = _context.sent;
                resData = res;

                if (!(props.responseProcessor && typeof props.responseProcessor === 'function')) {
                  _context.next = 12;
                  break;
                }

                _context.next = 8;
                return props.responseProcessor(res);

              case 8:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.t0 = [];

              case 11:
                resData = _context.t0;

              case 12:
                handleData(resData);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getAllCategoryList() {
        return _ref2.apply(this, arguments);
      };
    }();

    getAllCategoryList();
    Object(composition_api_["watch"])(function () {
      return props.usePermission;
    }, function () {
      getAllCategoryList();
    });
    Object(composition_api_["watch"])(function () {
      return props.extraParams;
    }, function () {
      getAllCategoryList();
    }); // 对外 清空方法

    var clearValue = function clearValue() {
      treeSelectRef.value.clearValue();
    }; // 对外 全选方法


    var selectAll = function selectAll() {
      treeSelectRef.value.selectAll();
    }; // 对外 获取已选择tag


    var getSelectedTags = function getSelectedTags() {
      treeSelectRef.value.getSelectedTags();
    }; // 对外 获取已选择value


    var getSelectedValue = function getSelectedValue() {
      treeSelectRef.value.getSelectedTags();
    };

    return _objectSpread({
      treeSelectRef: treeSelectRef,
      listeners: listeners,
      handleChange: handleChange,
      isSelectLevel: isSelectLevel,
      clearValue: clearValue,
      selectAll: selectAll,
      getSelectedTags: getSelectedTags,
      getSelectedValue: getSelectedValue
    }, Object(composition_api_["toRefs"])(data));
  }
}));
// CONCATENATED MODULE: ./components/mc-purchase-org-select/mc-purchase-org-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_purchase_org_select_mc_purchase_org_selectvue_type_script_lang_js_ = (mc_purchase_org_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-purchase-org-select/mc-purchase-org-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_purchase_org_select_mc_purchase_org_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_purchase_org_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-purchase-org-select/index.js


/* istanbul ignore next */

mc_purchase_org_select.install = function (Vue) {
  Vue.component(mc_purchase_org_select.name, mc_purchase_org_select);
};

/* harmony default export */ var components_mc_purchase_org_select = __webpack_exports__["default"] = (mc_purchase_org_select);

/***/ }),

/***/ "7f18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-input-group/mc-input-group.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_input_groupvue_type_script_lang_js_ = ({
  name: 'McInputGroup',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-input-group', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-input-group/mc-input-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_input_group_mc_input_groupvue_type_script_lang_js_ = (mc_input_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-input-group/mc-input-group.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_input_group_mc_input_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_input_group = (component.exports);
// CONCATENATED MODULE: ./components/mc-input-group/index.js


/* istanbul ignore next */

mc_input_group.install = function (Vue) {
  Vue.component(mc_input_group.name, mc_input_group);
};

/* harmony default export */ var components_mc_input_group = __webpack_exports__["default"] = (mc_input_group);

/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f33":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ "7f7a":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__("399f");

asn1.define = __webpack_require__("ef3a").define;
asn1.base = __webpack_require__("41df");
asn1.constants = __webpack_require__("0211");
asn1.decoders = __webpack_require__("20f6");
asn1.encoders = __webpack_require__("343e");


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "805f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("124f");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("6e53");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1110 = function (_MSI) {
	_inherits(MSI1110, _MSI);

	function MSI1110(data, options) {
		_classCallCheck(this, MSI1110);

		data += (0, _checksums.mod11)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
	}

	return MSI1110;
}(_MSI3.default);

exports.default = MSI1110;

/***/ }),

/***/ "8079":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var macrotask = __webpack_require__("1991").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("2d95")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "80a6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonExtension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Editor; });
/* unused harmony export EmbedExtension */
/* unused harmony export Manager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MarkExtension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NodeExtension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Providers; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ab5b");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8bc8");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("40b6");
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(invariant__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6f27");
/* harmony import */ var prosemirror_model__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prosemirror_model__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6ffb");
/* harmony import */ var prosemirror_state__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prosemirror_state__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var prosemirror_view__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("576a");
/* harmony import */ var prosemirror_keymap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e3da");
/* harmony import */ var prosemirror_inputrules__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("72a8");
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fbea");
/* harmony import */ var prosemirror_commands__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prosemirror_commands__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7e25");
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_9__);











var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var isOfType = function(type) {
    return function(value) {
        return (typeof value === "undefined" ? "undefined" : _typeof(value)) === type;
    };
};
var isString = isOfType("string");
var isPlainObject = function(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null){
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
};
var isDOMNode = function(domNode) {
    return _instanceof(domNode, Node);
};
var omit = function(target, omitKey) {
    var filterKey = isString(omitKey) ? [
        omitKey
    ] : omitKey;
    if (isPlainObject(target)) {
        return Object.keys(target).filter(function(key) {
            return !filterKey.includes(key);
        }).reduce(function(prev, cur) {
            prev[cur] = target[cur];
            return prev;
        }, Object.create(null));
    }
    return target.filter(function(p) {
        return !filterKey.includes(p);
    });
};
var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var findSelectionContext = function(selection) {
    var $from = selection.$from;
    var depth = [];
    for(var i = $from.depth; i > 0; i--){
        var node = $from.node(i);
        depth.push(node.type.name);
    }
    return depth;
};
// 参考 https://github.com/ProseMirror/prosemirror-inputrules/blob/master/src/inputrules.js
var MAX_MATCH = 500;
var _run = function(view, from, to, text, rules, plugin) {
    if (view.composing) return false;
    var state = view.state;
    var $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset, null, "￼") + text;
    for(var i = 0; i < rules.length; i++){
        var match = rules[i].match.exec(textBefore);
        var tr = match && rules[i].handler(state, match, from - (match[0].length - text.length), to);
        if (!tr) {
            continue;
        }
        view.dispatch(tr.setMeta(plugin, {
            transform: tr,
            from: from,
            to: to,
            text: text
        }));
        return true;
    }
    return false;
};
var inputRules = function(param) {
    var rules = param.rules;
    var plugin = Object(prosemirror_inputrules__WEBPACK_IMPORTED_MODULE_7__[/* inputRules */ "b"])({
        rules: rules
    });
    var spec = _objectSpreadProps(_objectSpread({}, plugin.spec), {
        key: new prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["PluginKey"]("inputRules")
    });
    spec.props.handleDOMEvents.keydown = function(view, event) {
        if (event.key !== "Enter") return false;
        var $cursor = view.state.selection.$cursor;
        if ($cursor) {
            return _run(view, $cursor.pos, $cursor.pos, "\n", rules, plugin) && // 防止插入块级元素后在元素内执行Enter操作
            (event.preventDefault() || true);
        }
        return false;
    };
    return new prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["Plugin"](spec);
};
function isEmptyDoc(doc) {
    return doc.childCount === 1 && doc.firstChild.isTextblock && doc.firstChild.content.size === 0;
}

/**
 * 通用配置
 */ var pluginKey = new prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["PluginKey"]("image");

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// 仅能放node mark的通用函数
var isNodeExtension = function(extension) {
    return extension.type === ExtensionType.Node;
};
var isMarkExtension = function(extension) {
    return extension.type === ExtensionType.Mark;
};
var isEmbedExtension = function(extension) {
    return extension.type === ExtensionType.NodeEmbed;
};
var hasExtensionProperty = function(key) {
    return function(extension) {
        return Boolean(extension[key]);
    };
};
var extensionKeyMapper = function(property, props) {
    return function(extension) {
        var extensionMethod = extension[property];
        var getFn = function() {
            if (isNodeExtension(extension)) {
                var _props_schema;
                return extensionMethod.bind(extension)(_objectSpreadProps$1(_objectSpread$1({}, props), {
                    type: (_props_schema = props.schema) === null || _props_schema === void 0 ? void 0 : _props_schema.nodes[extension.name]
                }));
            }
            if (isMarkExtension(extension)) {
                var _props_schema1;
                return extensionMethod.bind(extension)(_objectSpreadProps$1(_objectSpread$1({}, props), {
                    type: (_props_schema1 = props.schema) === null || _props_schema1 === void 0 ? void 0 : _props_schema1.marks[extension.name]
                }));
            }
            return extensionMethod.bind(extension)(props);
        };
        return getFn();
    };
};
var extensionMapperWithName = function(property, props) {
    return function(extension) {
        var extensionMethod = extension[property];
        var extensionName = extension.name;
        var getFn = function() {
            if (isNodeExtension(extension)) {
                var value = extensionMethod.bind(extension)(_objectSpreadProps$1(_objectSpread$1({}, props), {
                    type: props.schema.nodes[extension.name]
                }));
                return {
                    name: extensionName,
                    value: value
                };
            }
            if (isMarkExtension(extension)) {
                var value1 = extensionMethod.bind(extension)(_objectSpreadProps$1(_objectSpread$1({}, props), {
                    type: props.schema.marks[extension.name]
                }));
                return {
                    name: extensionName,
                    value: value1
                };
            }
            var value2 = extensionMethod.bind(extension)(props);
            return {
                name: extensionName,
                value: value2
            };
        };
        return getFn();
    };
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-node-view-dom{max-width:100%;margin:0 2px;cursor:text}.ct-node-view-dom>*{cursor:auto}.ct-node-view-dom.ProseMirror-selectednode{outline:none}.ct-node-view-align-right>div{float:right!important;margin-top:0!important}.ct-node-view-align-center>div{margin:0 auto!important}.ct-node-view-clear-float:after{clear:both;content:".";display:block;width:0;height:0;visibility:hidden}';
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var PortalProvider = /*#__PURE__*/ function() {
    function PortalProvider() {
        _classCallCheck(this, PortalProvider);
        this.portals = new Map();
    }
    var _proto = PortalProvider.prototype;
    _proto.render = function render1(component, container) {
        this.portals.set(container, {
            component: component
        });
        Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["render"])(component, container);
    };
    _proto.remove = function remove(container) {
        this.portals.delete(container);
        Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["render"])(null, container);
    };
    return PortalProvider;
}();

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
var nodeViewNamePrefix = function(cls) {
    return classNamePrefix("node-view-".concat(cls));
};
var reactNodeClass = classNamePrefix("node-view-dom");
var ReactNodeview = /*#__PURE__*/ function() {
    function ReactNodeview(node, view, getPos, decorations, portalProvider, reactComponent, parameters) {
        var _this = this;
        _classCallCheck$1(this, ReactNodeview);
        this.init = function() {
            _this.dom = _this.createDomRef();
            _this.dom.classList.add(reactNodeClass);
            _this.setDomAttrs(_this.node, _this.dom);
        };
        this.attrs = node.attrs;
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.decorations = decorations;
        this.portalProvider = portalProvider;
        this.parameters = parameters;
        this.reactComponent = reactComponent;
        this.ref = /*#__PURE__*/ Object(react__WEBPACK_IMPORTED_MODULE_0__["createRef"])();
        this.nodeViewStyle = _objectSpread$2({
            display: node.isBlock ? "block" : "inline-block"
        }, reactComponent.nodeViewStyle);
        this.init();
        if (node.attrs && node.attrs.className) {
            this.dom.classList.add(node.attrs.className);
        }
        if (reactComponent.ignoreMutation) {
            this.ignoreMutation = reactComponent.ignoreMutation;
        }
        if (reactComponent.stopEvent) {
            var _reactComponent_stopEvent;
            this.stopEvent = (_reactComponent_stopEvent = reactComponent.stopEvent) !== null && _reactComponent_stopEvent !== void 0 ? _reactComponent_stopEvent : function() {
                return false;
            };
        }
        this.renderReactComponent();
    }
    var _proto = ReactNodeview.prototype;
    _proto.applyBubblingAttrs = function applyBubblingAttrs(node, element) {
        var _this = this;
        var attrs = node.attrs;
        Object.keys(this.nodeViewStyle).forEach(function(styleKey) {
            _this.dom.style[styleKey] = _this.nodeViewStyle[styleKey];
        });
        element.classList.remove(nodeViewNamePrefix("clear-float"), nodeViewNamePrefix("align-center"), nodeViewNamePrefix("align-right"));
        if (attrs.align === "center") {
            element.classList.add(nodeViewNamePrefix("clear-float"), nodeViewNamePrefix("align-center"));
        }
        if (attrs.align === "right") {
            element.classList.add(nodeViewNamePrefix("clear-float"), nodeViewNamePrefix("align-right"));
        }
    };
    _proto.setDomAttrs = function setDomAttrs(node, element) {
        this.applyBubblingAttrs(this.node, this.dom);
        var toDOM = this.node.type.spec.toDOM;
        if (toDOM) {
            var domSpec = toDOM(node);
            if (isString(domSpec) || isDOMNode(domSpec)) {
                return;
            }
            var attrs = domSpec[1];
            if (isPlainObject(attrs)) {
                omit(Object.keys(attrs), [
                    "style",
                    "class"
                ]).forEach(function(attr) {
                    element.setAttribute(attr, String(attrs[attr]));
                });
                return;
            }
        }
        omit(Object.keys(node.attrs), [
            "style",
            "class"
        ]).forEach(function(attr) {
            element.setAttribute(attr, node.attrs[attr]);
        });
    };
    _proto.createDomRef = function createDomRef() {
        var node = this.node;
        var toDOM = node.type.spec.toDOM;
        if (toDOM) {
            var domSpec = toDOM(node);
            if (typeof domSpec === "string") {
                return document.createElement(domSpec);
            }
            return document.createElement(domSpec[0]);
        }
        return node.isInline ? document.createElement("span") : document.createElement("div");
    };
    _proto.renderReactComponent = function renderReactComponent() {
        this.portalProvider.render(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.reactComponent, _extends({}, this.parameters, {
            attrs: this.attrs,
            type: this.node.type.name,
            contentDOM: this.contentDOM,
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            dom: this.dom
        })), this.dom);
    };
    _proto.update = function update(node, decorations) {
        if (this.reactComponent.pmNodeViewShouldUpdate) {
            return this.reactComponent.pmNodeViewShouldUpdate(node, decorations);
        }
        // 此函数有可能出现传入的 node 类型与原节点类型不一致的情况（https://prosemirror.net/docs/ref/#view.NodeView.update）
        // 需要再次进行判断，若类型不一致则说明更新的非源节点，使用默认处理。
        if (node.type !== this.node.type) {
            // this.destroy();
            return false;
        }
        if (this.ref && !this.node.sameMarkup(node)) {
            this.node = node;
            this.attrs = node.attrs;
            this.renderReactComponent();
            this.setDomAttrs(this.node, this.dom);
        }
        this.decorations = decorations;
        return true;
    };
    _proto.destroy = function destroy() {
        this.portalProvider.remove(this.dom);
    };
    ReactNodeview.fromComponent = function fromComponent(component, portalProvider, parameters) {
        return function(node, view, getPos, decorations) {
            return new ReactNodeview(node, view, getPos, decorations, portalProvider, component, parameters);
        };
    };
    return ReactNodeview;
}();

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var chainKeyBindingCommands = function() {
    for(var _len = arguments.length, commands = new Array(_len), _key = 0; _key < _len; _key++){
        commands[_key] = arguments[_key];
    }
    return function(params) {
        if (!commands.length) {
            return false;
        }
        var _commands = _toArray(commands), command = _commands[0], rest = _commands.slice(1);
        var calledNext = false;
        var createNext = function() {
            for(var _len = arguments.length, nextCommands = new Array(_len), _key = 0; _key < _len; _key++){
                nextCommands[_key] = arguments[_key];
            }
            return function() {
                if (!nextCommands.length) {
                    return false;
                }
                calledNext = true;
                var _nextCommands = _toArray(nextCommands), nextRest = _nextCommands.slice(1);
                return chainKeyBindingCommands.apply(void 0, _toConsumableArray(nextCommands))(_objectSpreadProps$2(_objectSpread$3({}, params), {
                    next: createNext.apply(void 0, _toConsumableArray(nextRest))
                }));
            };
        };
        var next = createNext.apply(void 0, _toConsumableArray(rest));
        var status = command(_objectSpreadProps$2(_objectSpread$3({}, params), {
            next: next
        }));
        if (calledNext || status) {
            return status;
        }
        return next();
    };
};
var createDoc = function(schema, value) {
    var $container = document.createElement("div");
    $container.innerHTML = value;
    return prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["DOMParser"].fromSchema(schema).parse($container);
};

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var Manager = /*#__PURE__*/ function() {
    function Manager(managerOptions) {
        var _this = this;
        _classCallCheck$2(this, Manager);
        this._destroying = false;
        this._dead = false;
        this.collectParameters = function() {
            return {
                schema: _this.schema,
                providers: _this.providers,
                editable: _this.editable,
                editorEventEmitter: _this.editorEventEmitter,
                getState: function() {
                    var _this_editorView;
                    return (_this_editorView = _this.editorView) === null || _this_editorView === void 0 ? void 0 : _this_editorView.state;
                },
                getView: function() {
                    return _this.editorView;
                },
                commands: _this.commands,
                config: {
                    placeholder: _this.placeholder
                }
            };
        };
        this.createPlugins = function() {
            var plugins = _this.extensions.filter(hasExtensionProperty("plugin")).map(extensionKeyMapper("plugin", _this.collectParameters())).reduce(function(prev, cur) {
                if (Array.isArray(cur)) {
                    prev = _toConsumableArray$1(prev).concat(_toConsumableArray$1(cur));
                } else {
                    prev = _toConsumableArray$1(prev).concat([
                        cur
                    ]);
                }
                return prev;
            }, []);
            return _toConsumableArray$1(plugins).concat(_toConsumableArray$1(_this.keymaps), [
                _this.inputRules
            ]);
        };
        this.createNodeViews = function() {
            return _this.extensions.filter(hasExtensionProperty("nodeViews")).reduce(function(prev, cur) {
                var parameters = {
                    provider: _this.providers.get(cur.name),
                    getEditable: function() {
                        return _this.editable;
                    },
                    editorEventEmitter: _this.editorEventEmitter
                };
                prev[cur.name] = ReactNodeview.fromComponent(cur.nodeViews, _this.portalProvider, parameters);
                return prev;
            }, {});
        };
        this.createClipboardSerializer = function() {
            var base = prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["DOMSerializer"].fromSchema(_this.schema);
            var overrideNodes = _this.extensions.filter(function(p) {
                return isNodeExtension(p) || isEmbedExtension(p);
            }).filter(hasExtensionProperty("clipboardSerializer")).map(extensionKeyMapper("clipboardSerializer", _this.collectParameters())).reduce(function(prev, cur) {
                prev = _objectSpread$4({}, prev, cur);
                return prev;
            }, {});
            var overrideMarks = _this.extensions.filter(function(p) {
                return isMarkExtension(p);
            }).filter(hasExtensionProperty("clipboardSerializer")).map(extensionKeyMapper("clipboardSerializer", _this.collectParameters())).reduce(function(prev, cur) {
                prev = _objectSpread$4({}, prev, cur);
                return prev;
            }, {});
            return {
                nodes: _objectSpread$4({}, base.nodes, overrideNodes),
                marks: _objectSpread$4({}, base.marks, overrideMarks)
            };
        };
        this.createClipboardParser = function() {
            var base = prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["DOMParser"].fromSchema(_this.schema);
            var overrideRules = _this.extensions.filter(hasExtensionProperty("clipboardParser")).map(extensionKeyMapper("clipboardParser", _this.collectParameters())).reduce(function(acc, cur) {
                return _toConsumableArray$1(acc).concat(_toConsumableArray$1(cur));
            }, []);
            return {
                schema: base.schema,
                // 保证 clipboardParser 的规则优先级更高
                rules: _toConsumableArray$1(overrideRules).concat(_toConsumableArray$1(base.rules))
            };
        };
        this.createEditorView = function(editorDOM, editorState) {
            _this.originalState = editorState;
            var clipboardSerializer = _this.createClipboardSerializer();
            var clipboardParser = _this.createClipboardParser();
            _this.editorView = new prosemirror_view__WEBPACK_IMPORTED_MODULE_5__[/* EditorView */ "c"](editorDOM, {
                nodeViews: _this.nodeViews,
                state: editorState,
                editable: function() {
                    return _this.editable;
                },
                dispatchTransaction: _this.dispatchTransaction,
                clipboardSerializer: new prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["DOMSerializer"](clipboardSerializer.nodes, clipboardSerializer.marks),
                clipboardParser: new prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["DOMParser"](clipboardParser.schema, clipboardParser.rules)
            });
            /**
     * 取消编辑器的拼写校验，提高渲染性能
     */ _this.editorView.dom.setAttribute("spellcheck", "false");
            _this._autoFocus && _this.editorView.focus();
        };
        this.createKeyMap = function() {
            var extensionKeymaps = _this.extensions.filter(hasExtensionProperty("keys")).map(extensionKeyMapper("keys", _this.collectParameters()));
            var previousCommandsMap = new Map();
            var mappedCommands = Object.create(null);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _loop = function(key) {
                        if (!Object.prototype.hasOwnProperty.call(extensionKeymap, key)) {
                            return "continue";
                        }
                        var _previousCommandsMap_get;
                        var previousCommands = (_previousCommandsMap_get = previousCommandsMap.get(key)) !== null && _previousCommandsMap_get !== void 0 ? _previousCommandsMap_get : [];
                        var commands = _toConsumableArray$1(previousCommands).concat([
                            extensionKeymap[key]
                        ]);
                        var command = chainKeyBindingCommands.apply(void 0, _toConsumableArray$1(commands));
                        previousCommandsMap.set(key, commands);
                        mappedCommands[key] = function(state, dispatch, view) {
                            return command({
                                state: state,
                                dispatch: dispatch,
                                view: view,
                                next: function() {
                                    return false;
                                }
                            });
                        };
                    };
                    var extensionKeymap = _step.value;
                    for(var key in extensionKeymap)_loop(key);
                };
                for(var _iterator = extensionKeymaps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                new prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["Plugin"]({
                    key: new prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["PluginKey"]("keymap"),
                    props: {
                        handleKeyDown: Object(prosemirror_keymap__WEBPACK_IMPORTED_MODULE_6__[/* keydownHandler */ "a"])(mappedCommands)
                    }
                })
            ];
        };
        this.createInputRules = function() {
            var rules = _this.extensions.filter(hasExtensionProperty("inputRules")).map(extensionKeyMapper("inputRules", _this.collectParameters())).reduce(function(prev, cur) {
                prev = _toConsumableArray$1(prev).concat(_toConsumableArray$1(cur));
                return prev;
            }, []);
            return inputRules({
                rules: rules
            });
        };
        this.createCommands = function() {
            var enhancedMethod = function(command) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _this_editorView = _this.editorView, state = _this_editorView.state, dispatch = _this_editorView.dispatch;
                    return command.apply(void 0, _toConsumableArray$1(args))(state, dispatch, _this.editorView);
                };
            };
            var flattenAndEnhanced = function(fnObj) {
                var result = Object.create(null);
                Object.entries(fnObj).forEach(function(param) {
                    var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                    result[key] = enhancedMethod(value);
                });
                return result;
            };
            return _this.extensions.filter(hasExtensionProperty("commands")).map(extensionMapperWithName("commands", _this.collectParameters())).reduce(function(prev, cur) {
                prev = _objectSpreadProps$3(_objectSpread$4({}, prev), _defineProperty$4({}, cur.name, flattenAndEnhanced(cur.value)));
                return prev;
            }, {});
        };
        this.methodFactory = function(method) {
            return function(args) {
                _this.editorView.focus();
                return method({
                    state: _this.editorView.state,
                    dispatch: _this.editorView.dispatch,
                    view: _this.editorView,
                    args: args
                });
            };
        };
        this.docHasChanged = function() {
            return !_this.originalState.doc.eq(_this.editorView.state.doc);
        };
        /**
   * 暂时解决 ios 下在标题后按回车换行两次的问题 ONES#10775656
   * 参考: https://discuss.prosemirror.net/t/unexpected-behavior-when-pressing-enter-safari-mobile/3226/3
   * 调研文档: https://km.sankuai.com/page/754050493
   * TODO: 升级 prosemirror-view 至 1.16.4 后可去除该逻辑
   */ this.skipIosEnter = function(view, tr) {
            return tr.selectionSet && !tr.docChanged && // 因为当前的prosemirrorView版本中，view.lastIOSEnterFallbackTimeout的时间设置是50ms
            view.lastIOSEnter > Date.now() - 50;
        };
        this.dispatchTransaction = function(tr) {
            if (_this.skipIosEnter(_this.editorView, tr)) return;
            var state = _this.editorView.state.apply(tr);
            _this.editorView.updateState(state);
            if (_this.stateUpdatedCallback) {
                _this.stateUpdatedCallback(_this, tr.docChanged);
            }
        };
        this.getSelectionContext = function() {
            return findSelectionContext(_this.editorView.state.selection);
        };
        this.destroyManager = function(cb) {
            var _this_editorView;
            if (_this._destroying || _this._dead) {
                return;
            }
            _this._destroying = true;
            (_this_editorView = _this.editorView) === null || _this_editorView === void 0 ? void 0 : _this_editorView.destroy();
            _this.providers.forEach(function(_) {
                var __destroy;
                return (__destroy = _.destroy) === null || __destroy === void 0 ? void 0 : __destroy.call(_, _this.collectParameters());
            });
            _this.extensions.forEach(function(_) {
                var // @ts-ignore 允许Manager调用destroy
                __destroy;
                (__destroy = _.destroy) === null || __destroy === void 0 ? void 0 : __destroy.call(_, _this.collectParameters());
            });
            cb(_this);
            _this._destroying = false;
            _this._dead = true;
        };
        invariant__WEBPACK_IMPORTED_MODULE_2___default()(!!managerOptions, "Manager实例化参数异常");
        var defaultValue = managerOptions.defaultValue, placeholder = managerOptions.placeholder, providers = managerOptions.providers, appendExtensions = managerOptions.appendExtensions, schema = managerOptions.schema, _managerOptions_editable = managerOptions.editable, editable = _managerOptions_editable === void 0 ? true : _managerOptions_editable, _managerOptions_autoFocus = managerOptions.autoFocus, autoFocus = _managerOptions_autoFocus === void 0 ? true : _managerOptions_autoFocus;
        var _providers_providers;
        this.providers = (_providers_providers = providers === null || providers === void 0 ? void 0 : providers.providers) !== null && _providers_providers !== void 0 ? _providers_providers : new Map();
        this.defaultValue = defaultValue;
        this.placeholder = placeholder;
        this.extensions = appendExtensions || [];
        this.portalProvider = new PortalProvider();
        this.schema = schema;
        this.editable = editable;
        this.editorEventEmitter = new events__WEBPACK_IMPORTED_MODULE_9__["EventEmitter"]();
        this._autoFocus = autoFocus;
        invariant__WEBPACK_IMPORTED_MODULE_2___default()(_instanceof$1(this.schema, prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["Schema"]), "schema异常");
    }
    var _proto = Manager.prototype;
    _proto.init = function init(editorRef, stateUpdatedCallback) {
        var _this = this;
        this.extensions.forEach(function(_) {
            var __willMountManager;
            return (__willMountManager = _.willMountManager) === null || __willMountManager === void 0 ? void 0 : __willMountManager.call(_, _this.collectParameters());
        });
        this.providers.forEach(function(_) {
            var __willMountManager;
            return (__willMountManager = _.willMountManager) === null || __willMountManager === void 0 ? void 0 : __willMountManager.call(_, _this.collectParameters());
        });
        this.stateUpdatedCallback = stateUpdatedCallback;
        this.commands = this.createCommands();
        this.keymaps = this.createKeyMap();
        // InputRule目前不支持Enter输入的识别，如果需要可参考：https://discuss.prosemirror.net/t/trigger-inputrule-on-enter/1118/4
        this.inputRules = this.createInputRules();
        this.nodeViews = this.createNodeViews();
        this.plugins = this.createPlugins();
        if (this.defaultValue) {
            if (typeof this.defaultValue === "string") {
                var editorState = prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["EditorState"].create({
                    doc: createDoc(this.schema, this.defaultValue),
                    schema: this.schema,
                    plugins: this.plugins
                });
                this.createEditorView(editorRef, editorState);
            } else {
                var editorState1 = prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["EditorState"].fromJSON({
                    schema: this.schema,
                    plugins: this.plugins
                }, this.defaultValue);
                this.createEditorView(editorRef, editorState1);
            }
        } else {
            var editorState2 = prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["EditorState"].create({
                schema: this.schema,
                plugins: this.plugins
            });
            this.createEditorView(editorRef, editorState2);
        }
        this.providers.forEach(function(_) {
            var __didMountManager;
            return (__didMountManager = _.didMountManager) === null || __didMountManager === void 0 ? void 0 : __didMountManager.call(_, _this.collectParameters());
        });
        this.extensions.forEach(function(_) {
            var __didMountManager;
            return (__didMountManager = _.didMountManager) === null || __didMountManager === void 0 ? void 0 : __didMountManager.call(_, _this.collectParameters());
        });
    };
    _createClass(Manager, [
        {
            key: "destroying",
            get: function get() {
                return this._destroying;
            }
        }
    ]);
    return Manager;
}();

var ReactEditor = /*#__PURE__*/ Object(react__WEBPACK_IMPORTED_MODULE_0__["forwardRef"])(function(props, ref) {
    var width = props.width, _props_destroy = props.destroy, destroy = _props_destroy === void 0 ? function() {} : _props_destroy;
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function() {
        return destroy;
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
        className: "ct-editor",
        ref: ref,
        style: width ? {
            width: "".concat(width, "px")
        } : {}
    });
});

var name = "@it/parker";
var version = "0.74.0";
var description = "新编辑器";
var repository = "ssh://git@git.sankuai.com/in/ct-editor-plus.git";
var keywords = [];
var main = "es/core/index.js";
var module = "es/core/index.js";
var types = "typings/index.d.ts";
var files = [
    "es",
    "dist",
    "typings"
];
var license = "UNLICENSED";
var scripts = {
    "pub:feature": "node ./scripts/bp/bp.js --build_env=feature --nocheck",
    "pub:grey": "node ./scripts/bp/bp.js --build_env=grey --tag=grey",
    release: "node ./scripts/bp/release.js --fallback=self",
    lint: "eslint --ext js,ts,tsx src --max-warnings 0",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "test:schema": "jest --coverage  --collectCoverageFrom=**/citadel-schema/**/*.ts",
    "test:doc-command": "jest --coverage  --collectCoverageFrom=**/doc-commands/**/*.ts",
    test: "node ./scripts/unit-test/index.js",
    "test:all": "jest",
    "dev:mobile": "parcel --no-cache examples/basic/mobile/index.html -p 1235 --dist-dir ./build",
    "dev:pc": "parcel --no-cache examples/basic/pc/index.html -p 1235 --dist-dir ./build",
    "dev:debug": "parcel --no-cache examples/basic/debug/index.html -p 1235 --dist-dir ./build",
    "dev:link": "rollup -w -c rollup.config.js",
    "dev:lite": "parcel --no-cache examples/basic/lite/index.html -p 1235 --dist-dir ./build",
    "build:es": "node --max_old_space_size=4096 -r @babel/register scripts/rollup/index.js",
    "build:dist": "node --max_old_space_size=4096 -r @babel/register scripts/rollup/buildIndex.js",
    build: "npm run build:es",
    storybook: "start-storybook -p 6006",
    changelog: "node ./scripts/changelog/index.js"
};
var peerDependencies = {
    react: ">=16.8.0",
    "react-dom": ">=16.8.0"
};
var dependencies = {
    "@babel/runtime": "7.16.3",
    "@mtfe/data2chart-react": "2.0.15",
    "broadcast-channel": "3.1.0",
    classnames: "2.2.6",
    codemirror: "5.64.0",
    "date-fns": "2.19.0",
    dompurify: "2.3.3",
    "eslint-plugin-prettier": "3.3.1",
    events: "3.2.0",
    "highlight.js": "10.7.1",
    invariant: "2.2.4",
    "lodash.chunk": "4.2.0",
    "lodash.debounce": "4.0.8",
    "lodash.intersection": "4.4.0",
    "lodash.isequal": "4.5.0",
    "lodash.throttle": "4.1.1",
    "lodash.union": "4.6.0",
    "markdown-it": "8.4.2",
    moment: "2.29.1",
    "plantuml-encoder": "1.4.0",
    "prosemirror-commands": "1.0.8",
    "prosemirror-dev-tools": "^2.1.1",
    "prosemirror-dropcursor": "1.3.2",
    "prosemirror-history": "1.0.4",
    "prosemirror-inputrules": "^1.1.2",
    "prosemirror-keymap": "^1.1.3",
    "prosemirror-model": "1.7.1",
    "prosemirror-schema-list": "1.1.2",
    "prosemirror-state": "1.2.2",
    "prosemirror-transform": "1.1.3",
    "prosemirror-view": "1.14.8",
    "rc-checkbox": "2.3.2",
    "rc-picker": "2.5.15",
    "rc-textarea": "0.3.3",
    "react-motion": "0.5.2",
    semver: "7.3.4",
    "style-loader": "1.2.1",
    "use-debounce": "7.0.0",
    uuid: "8.3.2"
};
var devDependencies = {
    "@babel/core": "^7.4.4",
    "@babel/plugin-proposal-class-properties": "7.8.3",
    "@babel/plugin-transform-runtime": "7.9.6",
    "@babel/preset-env": "7.9.6",
    "@babel/preset-react": "7.9.4",
    "@babel/preset-typescript": "7.9.0",
    "@babel/register": "7.9.0",
    "@commitlint/cli": "^9.1.1",
    "@commitlint/config-angular": "^9.1.1",
    "@it/bp": "0.2.10",
    "@it/eslint-config-citadel": "1.0.20",
    "@rollup/plugin-alias": "3.1.2",
    "@rollup/plugin-babel": "5.0.0",
    "@rollup/plugin-commonjs": "11.1.0",
    "@rollup/plugin-image": "2.0.4",
    "@rollup/plugin-json": "4.1.0",
    "@rollup/plugin-node-resolve": "7.1.3",
    "@rollup/plugin-virtual": "3.0.1",
    "@storybook/addon-actions": "^6.0.19",
    "@storybook/addon-essentials": "^6.0.19",
    "@storybook/addon-links": "^6.0.19",
    "@storybook/react": "^6.0.19",
    "@swc/core": "1.3.20",
    "@types/classnames": "2.2.10",
    "@types/events": "3.0.0",
    "@types/jest": "^24.0.13",
    "@types/map-obj": "3.1.0",
    "@types/node": "^12.0.2",
    "@types/prosemirror-commands": "^1.0.1",
    "@types/prosemirror-history": "^1.0.1",
    "@types/prosemirror-model": "^1.13.2",
    "@types/prosemirror-schema-basic": "^1.0.1",
    "@types/prosemirror-schema-list": "^1.0.1",
    "@types/prosemirror-state": "^1.2.3",
    "@types/react": "^16.9.35",
    "@types/react-dom": "16.9.8",
    "@types/uuid": "8.0.0",
    autoprefixer: "9.7.6",
    "babel-jest": "^24.8.0",
    "babel-loader": "^8.1.0",
    "babel-plugin-module-resolver": "^4.0.0",
    "branch-name": "1.0.0",
    chalk: "4.1.0",
    "crypto-js": "4.1.1",
    "css-loader": "4.2.2",
    cssnano: "4.1.10",
    esbuild: "0.13.15",
    "eslint-plugin-jest": "^22.5.1",
    "eslint-plugin-you-dont-need-momentjs": "^1.6.0",
    fs: "0.0.1-security",
    husky: "^3.0.3",
    jest: "26.6.3",
    "jest-environment-jsdom-sixteen": "1.0.3",
    "jest-svg-transformer": "1.0.0",
    "less-loader": "7.0.0",
    "lint-staged": "^9.2.1",
    nodemon: "^1.19.2",
    parcel: "2.3.2",
    "@parcel/transformer-less": "2.3.2",
    "@parcel/transformer-svg": "2.3.2",
    path: "0.12.7",
    postcss: "^8.0.0",
    "postcss-url": "8.0.0",
    "promise-limit": "2.7.0",
    react: ">=16.9.0",
    "react-dom": ">=16.9.0",
    "react-is": "^16.13.1",
    rollup: "2.8.0",
    "rollup-plugin-dts": "2.0.1",
    "rollup-plugin-ignore-import": "1.3.2",
    "rollup-plugin-node-builtins": "2.1.2",
    "rollup-plugin-postcss": "3.1.1",
    "rollup-plugin-progress": "1.1.2",
    "rollup-plugin-terser": "^7.0.2",
    "rollup-plugin-typescript2": "0.30.0",
    signale: "1.4.0",
    "standard-version": "^9.3.0",
    "style-loader": "1.2.1",
    stylus: "0.54.8",
    "ts-jest": "26.5.1",
    "ts-node": "^8.1.1",
    tslib: "2.1.0",
    typescript: "4",
    "typescript-plugin-css-modules": "^1.2.1",
    "yargs-parser": "21.0.0",
    ora: "2.1.0"
};
var resolutions = {
    "prosemirror-commands": "1.0.8",
    "prosemirror-dropcursor": "1.3.2",
    "prosemirror-history": "1.0.4",
    "prosemirror-state": "1.2.2",
    "prosemirror-transform": "1.1.3",
    "prosemirror-model": "1.7.1",
    "@types/prosemirror-commands": "^1.0.1",
    "@types/prosemirror-history": "^1.0.1",
    "@types/prosemirror-model": "^1.13.2",
    "@types/prosemirror-schema-basic": "^1.0.1",
    "@types/prosemirror-schema-list": "^1.0.1",
    "@types/prosemirror-state": "^1.2.3"
};
var husky = {
    hooks: {
        "pre-commit": "lint-staged",
        "commit-msg": "commitlint -E HUSKY_GIT_PARAMS"
    }
};
var alias = {
    basic: "./examples/basic",
    "@/*": "./src/$1"
};
var targets = {
    main: false
};
var PackageJSON = {
    name: name,
    version: version,
    description: description,
    repository: repository,
    keywords: keywords,
    main: main,
    module: module,
    types: types,
    files: files,
    license: license,
    scripts: scripts,
    peerDependencies: peerDependencies,
    dependencies: dependencies,
    devDependencies: devDependencies,
    resolutions: resolutions,
    husky: husky,
    "lint-staged": {
        "*.{js,jsx,ts,tsx}": [
            "eslint"
        ]
    },
    alias: alias,
    targets: targets
};

var css_248z$1 = '.ProseMirror *,.ProseMirror :after,.ProseMirror :before{box-sizing:border-box}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.ct-editor h5,.ct-editor h6,.ct-editor p,.ct-editor pre{margin:8px 0;color:#333;word-break:break-word;clear:both}.ct-editor p,.ct-editor pre{font-size:14px;line-height:22px;min-height:24px}.ct-editor h1{font-size:28px;font-weight:700;line-height:42px;min-height:42px}.ct-editor h2{font-size:24px;font-weight:700;line-height:36px;min-height:36px}.ct-editor h3{font-size:20px;font-weight:700;line-height:30px}.ct-editor h4{font-size:16px;font-weight:700;line-height:22px;min-height:24px}.ct-editor h5{font-size:14px;font-weight:700;line-height:21px;min-height:21px}.ct-editor h6{font-size:12px;font-weight:700;line-height:18px;min-height:18px}.ct-editor hr{display:block;height:1px;width:100%;border:0;background:#ccc}.ProseMirror{position:relative;word-wrap:break-word;white-space:pre-wrap;white-space:break-spaces;font-variant-ligatures:none;font-feature-settings:"liga" 0}.ProseMirror p{font-size:14px;line-height:22px;min-height:24px;margin:8px 0;color:#333;word-break:break-word;clear:both}.ProseMirror pre{white-space:pre-wrap}.ProseMirror li{position:relative}.ProseMirror-hideselection *::-moz-selection{background:transparent}.ProseMirror-hideselection ::selection{background:transparent}.ProseMirror-hideselection ::-moz-selection{background:transparent}li.ProseMirror-selectednode{outline:none}li.ProseMirror-selectednode:after{content:"";position:absolute;left:-32px;right:-2px;top:-2px;bottom:-2px;border:2px solid #8cf;pointer-events:none}.ct-editor-container{display:flex;justify-content:center;height:100%;overflow:auto}.ct-editor-container .ct-editor{position:relative;width:100%;height:100%;box-sizing:content-box}.ct-editor-container .ct-editor .ProseMirror{outline:none;margin-left:0;padding:0 24px}';
styleInject(css_248z$1);

function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
var Editor = /*#__PURE__*/ function() {
    function Editor(dom, config) {
        var _this = this;
        _classCallCheck$3(this, Editor);
        // changeCallback 触发时是否返回文档内容
        this.withValue = true;
        this._destroying = false;
        this._dead = false;
        this.initConfig = function() {
            var _this_config = _this.config, _this_config_appendExtensions = _this_config.appendExtensions, appendExtensions = _this_config_appendExtensions === void 0 ? [] : _this_config_appendExtensions, providers = _this_config.providers, schema = _this_config.schema, _this_config_defaultValue = _this_config.defaultValue, defaultValue = _this_config_defaultValue === void 0 ? null : _this_config_defaultValue, _this_config_placeholder = _this_config.placeholder, placeholder = _this_config_placeholder === void 0 ? "" : _this_config_placeholder, _this_config_editable = _this_config.editable, editable = _this_config_editable === void 0 ? true : _this_config_editable, _this_config_autoFocus = _this_config.autoFocus, autoFocus = _this_config_autoFocus === void 0 ? true : _this_config_autoFocus;
            _this.manager = new Manager({
                appendExtensions: appendExtensions,
                providers: providers,
                defaultValue: defaultValue,
                placeholder: placeholder,
                schema: schema,
                editable: editable,
                autoFocus: autoFocus
            });
        };
        this.addMenubar = function(menubar) {
            _this.menubar = menubar;
            _this.updateMenubar = function() {
                menubar.update();
            };
        };
        this.bindUpdate = function(method) {
            invariant__WEBPACK_IMPORTED_MODULE_2___default()(typeof method === "function", "bindUpdate的参数必须是一个函数");
            _this.updateMenubar = method;
        };
        this.init = function() {
            var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
            Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["render"])(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ReactEditor, {
                ref: _this.onRef,
                manager: _this.manager,
                destroy: _this.destroy.bind(_this)
            }), _this.dom, callback);
            if (_this.menubar) _this.menubar.connect(_this);
        };
        this.onRef = function(ref) {
            if (ref) {
                _this.editorRef = ref;
                _this.bindManager();
            }
        };
        this.stateUpdateCallback = function(manager, docChanged) {
            if (_this.updateMenubar) _this.updateMenubar(manager);
            if (docChanged && _this.changeCallback) {
                var value = _this.withValue ? _this.value() : undefined;
                _this.changeCallback(value);
            }
        };
        this.bindManager = function() {
            _this.manager.init(_this.editorRef, _this.stateUpdateCallback);
        };
        /**
   * 当前文档状态变化时触发回调
   * @param method 回调函数
   * @param withValue 是否将当前文档内容传给回调函数，默认为 true
   */ this.onChange = function(method) {
            var withValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            _this.changeCallback = method;
            _this.withValue = withValue;
        };
        this.value = function(value) {
            var editorView = _this.manager.editorView;
            if (!editorView) return undefined;
            var _editorView_state = editorView.state, doc = _editorView_state.doc, schema = _editorView_state.schema, plugins = _editorView_state.plugins;
            // 取值
            if (typeof value !== "string") {
                var $container = document.createElement("div");
                var fragment = prosemirror_model__WEBPACK_IMPORTED_MODULE_3__["DOMSerializer"].fromSchema(schema).serializeFragment(doc.content);
                $container.appendChild(fragment);
                return $container.innerHTML;
            }
            // 赋值
            var newDoc = createDoc(schema, value);
            var newState = prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["EditorState"].create({
                doc: newDoc,
                schema: schema,
                plugins: plugins
            });
            editorView.updateState(newState);
            return undefined;
        };
        this.focus = function() {
            _this.manager.editorView.focus();
        };
        this.setCursor = function() {
            var pos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "start";
            var _this_manager;
            if (!((_this_manager = _this.manager) === null || _this_manager === void 0 ? void 0 : _this_manager.editorView)) return;
            var _this_manager_editorView = _this.manager.editorView, dispatch = _this_manager_editorView.dispatch, _this_manager_editorView_state = _this_manager_editorView.state, tr = _this_manager_editorView_state.tr, doc = _this_manager_editorView_state.doc;
            if (pos === "start" || isEmptyDoc(doc)) {
                tr.setSelection(prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["TextSelection"].create(doc, 1));
                dispatch(tr.scrollIntoView());
            } else {
                tr.setSelection(prosemirror_state__WEBPACK_IMPORTED_MODULE_4__["TextSelection"].near(doc.resolve(doc.content.size)));
                dispatch(tr.scrollIntoView());
            }
            _this.manager.editorView.focus();
        };
        this.config = config;
        this.enhanceDom(dom);
        this.initConfig();
    }
    var _proto = Editor.prototype;
    _proto.enhanceDom = function enhanceDom(dom) {
        var editorWrapper = document.createElement("div");
        dom.appendChild(editorWrapper);
        this.dom = editorWrapper;
        this.dom.classList.add(Editor.ROOT_CLASS_NAME);
    };
    _proto.destroy = function destroy() {
        var _this, _this__destroyCallback;
        (_this__destroyCallback = (_this = this)._destroyCallback) === null || _this__destroyCallback === void 0 ? void 0 : _this__destroyCallback.call(_this, this);
        this._destroying = false;
        this._dead = true;
    };
    _proto.destroyEditor = function destroyEditor(cb) {
        var _this = this;
        var _this_manager;
        if (this._destroying || this._dead) {
            return false;
        }
        this._destroying = true;
        this._destroyCallback = cb;
        (_this_manager = this.manager) === null || _this_manager === void 0 ? void 0 : _this_manager.destroyManager(function() {
            Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["render"])(null, _this.dom);
        });
        return true;
    };
    _createClass$1(Editor, [
        {
            key: "version",
            get: function get() {
                return PackageJSON.version;
            }
        }
    ]);
    return Editor;
}();
Editor.ROOT_CLASS_NAME = "ct-editor-container";

function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Providers = function Providers() {
    var _this = this;
    _classCallCheck$4(this, Providers);
    this.registerProvider = function(name, provider) {
        if (!provider) {
            throw new Error("provider of ".concat(name, " not provided"));
        }
        _this.providers.set(name, provider);
    };
    this.providers = new Map();
};

function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var NodeExtension = /*#__PURE__*/ function() {
    function NodeExtension() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Object.create(null);
        _classCallCheck$5(this, NodeExtension);
        this.options = _objectSpread$5({}, this.defaultOptions, options);
    }
    var _proto = NodeExtension.prototype;
    _proto.createNode = function createNode(type, attrs, content, marks) {
        return function(state, dispatch, view) {
            var tr = state.tr, from = state.selection.from;
            dispatch(tr.insert(from, type.create(attrs, content, marks)));
            return true;
        };
    };
    _createClass$2(NodeExtension, [
        {
            key: "type",
            get: function get() {
                return ExtensionType.Node;
            }
        },
        {
            key: "defaultOptions",
            get: function get() {
                return {};
            }
        }
    ]);
    return NodeExtension;
}();
var MarkExtension = /*#__PURE__*/ function() {
    function MarkExtension() {
        _classCallCheck$5(this, MarkExtension);
    }
    _createClass$2(MarkExtension, [
        {
            key: "type",
            get: function get() {
                return ExtensionType.Mark;
            }
        }
    ]);
    return MarkExtension;
}();
var CommonExtension = /*#__PURE__*/ function() {
    function CommonExtension() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Object.create(null);
        _classCallCheck$5(this, CommonExtension);
        this.options = _objectSpread$5({}, this.defaultOptions, options);
    }
    _createClass$2(CommonExtension, [
        {
            key: "defaultOptions",
            get: function get() {
                return {};
            }
        }
    ]);
    return CommonExtension;
}();
var EmbedExtension = /*#__PURE__*/ function() {
    function EmbedExtension() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getState = _ref.getState, providers = _ref.providers, getView = _ref.getView, editorEventEmitter = _ref.editorEventEmitter;
        var _this = this;
        _classCallCheck$5(this, EmbedExtension);
        this.editing = "" // 不在编辑为空，新建'create'，编辑'edit'
        ;
        this.xml = "";
        this.create = function(onLoaded) {
            if (_this.editing) {
                return;
            }
            _this.editing = "create";
            _this.xml = "";
            _this.open(onLoaded);
        };
        this.open = function(onLoaded) {
            if (_this.iframe) return;
            _this.bindEvent();
            _this.iframe = document.createElement("iframe");
            _this.iframe.setAttribute("frameborder", "0");
            _this.iframe.setAttribute("class", "ct-".concat(_this.name, "-frame"));
            _this.iframe.setAttribute("data-type", "ct-frame");
            _this.iframe.style.opacity = 0;
            _this.showLoading();
            _this.iframe.onload = function() {
                onLoaded === null || onLoaded === void 0 ? void 0 : onLoaded();
                _this.iframe.style.opacity = 1;
                _this.hideLoading();
            };
            _this.iframe.setAttribute("src", _this.serverUrl);
            document.body.appendChild(_this.iframe);
        };
        this.close = function() {
            document.body.removeChild(_this.iframe);
            _this.hideLoading();
            _this.removeBindEvent();
            _this.iframe = null;
            _this.editing = "";
        };
        this.postMessage = function(params) {
            if (!_this.iframe) return;
            _this.iframe.contentWindow.postMessage(JSON.stringify(params), "*");
        };
        this.bindEvent = function() {
            window.addEventListener("message", _this.receive);
            window.addEventListener("popstate", _this.close);
        };
        this.removeBindEvent = function() {
            window.removeEventListener("popstate", _this.close);
            window.removeEventListener("message", _this.receive);
        };
        this.cleanEdit = function() {
            if (_this.editing === "create") return;
            var _this_getView = _this.getView(), state = _this_getView.state, dispatch = _this_getView.dispatch;
            var schema = state.schema, tr = state.tr, doc = state.doc, selection = state.selection;
            var from = selection.from;
            var node = doc.nodeAt(from);
            dispatch(tr.setNodeMarkup(from, schema.nodes.drawio, _objectSpreadProps$4(_objectSpread$5({}, node.attrs), {
                _editing: 0
            })));
        };
        this.showLoading = function() {
            var loadingMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "正在加载中...", showCancel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var $loading = document.createElement("div");
            $loading.className = "ct-".concat(_this.name, "-loading");
            $loading.innerHTML = '\n      <div class="loading-container">\n        <div class="loading-icon"><i></i><i></i><i></i></div>\n        <div class="loading-tips">'.concat(loadingMsg, "</div>\n        ").concat(showCancel ? '<div class="loading-cancel"> <a class="btn-cancel">取消</a></div>' : "", "\n      </div>");
            if (showCancel) {
                $loading.querySelector(".btn-cancel").addEventListener("click", _this.close, false);
            }
            document.body.appendChild($loading);
        };
        this.hideLoading = function() {
            var node = document.querySelector(".ct-".concat(_this.name, "-loading"));
            node && document.body.removeChild(node);
        };
        // TODO: 框架需要注入此处依赖的对象
        this.providers = providers;
        this.getState = getState;
        this.getView = getView;
        this.editorEventEmitter = editorEventEmitter;
    }
    _createClass$2(EmbedExtension, [
        {
            key: "type",
            get: function get() {
                return ExtensionType.NodeEmbed;
            }
        },
        {
            key: "name",
            get: function get() {
                return "iframe";
            }
        }
    ]);
    return EmbedExtension;
}();


//# sourceMappingURL=index.js.map


/***/ }),

/***/ "8155":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ "8165":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8165__;

/***/ }),

/***/ "817d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vue_composition_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8165");
/* harmony import */ var _vue_composition_api__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vue_composition_api__WEBPACK_IMPORTED_MODULE_0__);


var useFormProvider = function useFormProvider() {
  var mtdForm = Object(_vue_composition_api__WEBPACK_IMPORTED_MODULE_0__["inject"])('form', {});
  var configForm = Object(_vue_composition_api__WEBPACK_IMPORTED_MODULE_0__["inject"])('configForm', {});
  return {
    mtdForm: mtdForm,
    // mtdForm
    configForm: configForm
  };
};

/* harmony default export */ __webpack_exports__["a"] = (useFormProvider);

/***/ }),

/***/ "81e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ "8230":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ "823d":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "82f0":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("39f5")
var Buffer = __webpack_require__("8707").Buffer
var Transform = __webpack_require__("6430")
var inherits = __webpack_require__("3fb5")
var GHASH = __webpack_require__("3f62")
var xor = __webpack_require__("8c8a")
var incr32 = __webpack_require__("bd9d")

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ "8360":
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__("41df").Reporter;
var EncoderBuffer = __webpack_require__("41df").EncoderBuffer;
var DecoderBuffer = __webpack_require__("41df").DecoderBuffer;
var assert = __webpack_require__("da3e");

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "83c2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("75fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.fixed.js
var es6_string_fixed = __webpack_require__("d263");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("20d6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.sort.js
var es6_array_sort = __webpack_require__("55dd");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./composables/useRemote.js
var useRemote = __webpack_require__("9ea3");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/ColumnSetting.vue?vue&type=template&id=2f867f15&
var ColumnSettingvue_type_template_id_2f867f15_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-table-pro-setting-icon"},[_c('div',{staticClass:"mc-table-pro-head-setting",on:{"click":function($event){_vm.settingVisible = !_vm.settingVisible}}},[_c('i',{staticClass:"mtdicon mtdicon-setting"}),_vm._v("表头设置\n    ")]),_c('mtd-modal',{attrs:{"title":"设置列的显示/排序","width":(_vm.modelWidth + "px")},on:{"close":_vm.handleCancel},model:{value:(_vm.settingVisible),callback:function ($$v) {_vm.settingVisible=$$v},expression:"settingVisible"}},[_c('mtd-row',{staticClass:"mc-table-pro-setting-content",attrs:{"gutter":20}},[(_vm.innerConfig.visibility)?_c('mtd-col',{staticClass:"mc-table-pro-setting-section",attrs:{"span":16}},[_c('div',{staticClass:"mc-table-pro-setting-section-title mc-table-pro-setting-section-title-screen"},[_vm._v("\n                    全部字段\n                    "),(_vm.showSearch)?_c('div',[_c('mtd-input',{attrs:{"placeholder":"输入字段名称查询","clearable":"","size":"small"},model:{value:(_vm.labelSearch),callback:function ($$v) {_vm.labelSearch=$$v},expression:"labelSearch"}})],1):_vm._e()]),_c('mtd-checkbox',{staticClass:"mc-table-pro-setting-mtd-checkbox",attrs:{"indeterminate":_vm.isIndeterminate},on:{"input":_vm.handleCheckAllChange},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}},[_vm._v("\n                    全选\n                ")]),_c('div',{staticClass:"mc-table-pro-setting-section-content"},[_c('div',_vm._l((_vm.subTitleList),function(subTitle){return _c('div',{key:subTitle},[(subTitle && _vm.matchingTitle(subTitle).length)?_c('div',{staticClass:"mc-table-pro-setting-section-sub-title"},[_vm._v("\n                                "+_vm._s(subTitle)+"\n                            ")]):_vm._e(),_c('mtd-checkbox-group',{on:{"input":_vm.handleCheckedListChange},model:{value:(_vm.checkedList),callback:function ($$v) {_vm.checkedList=$$v},expression:"checkedList"}},_vm._l((_vm.matchingTitle(subTitle)),function(ref,index){
var prop = ref.prop;
var label = ref.label;
return _c('mtd-checkbox',{key:prop+index,staticClass:"mc-table-pro-setting-mtd-checkbox",class:_vm.screenCheckboxClass(label),attrs:{"value":prop}},[_vm._v("\n                                    "+_vm._s(label)+"\n                                ")])}),1)],1)}),0)])],1):_vm._e(),(_vm.innerConfig.sorting)?_c('mtd-col',{attrs:{"span":_vm.isMobile ? 16: 8}},[_c('div',{staticClass:"mc-table-pro-setting-section-title"},[_vm._v("\n                    已选字段\n                ")]),_c('div',{staticClass:"mc-table-pro-setting-section-content"},[_c('draggable',{attrs:{"group":"people"},on:{"start":function($event){_vm.drag=true},"end":function($event){_vm.drag=false}},model:{value:(_vm.checkedList),callback:function ($$v) {_vm.checkedList=$$v},expression:"checkedList"}},_vm._l((_vm.checkedList),function(prop,index){return _c('div',{key:index,staticClass:"mc-table-pro-setting-drag-item",class:_vm.screenCheckboxClass(_vm.columnMap[prop].label)},[_c('div',{staticClass:"mc-table-pro-setting-drag-item-icon"},[_c('i',{staticClass:"mtdicon mtdicon-more mc-table-pro-setting-icon-drag"})]),_c('span',[_vm._v("\n                                "+_vm._s(_vm.columnMap[prop].label)+"\n                            ")]),_c('div',{staticClass:"mc-table-pro-setting-drag-item-icon"},[(_vm.canSetProp(prop))?_c('i',{staticClass:"mtdicon mtdicon-closemini mc-table-pro-setting-icon-close",on:{"click":function($event){return _vm.handleUnselect(prop)}}}):_vm._e()])])}),0)],1)]):_vm._e()],1),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('mtd-button',{on:{"click":_vm.handleCancel}},[_vm._v("\n                取 消\n            ")]),_c('mtd-button',{attrs:{"type":"primary"},on:{"click":_vm.handleSuccess}},[_vm._v("\n                确 定\n            ")])],1)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-table-pro/components/ColumnSetting.vue?vue&type=template&id=2f867f15&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__("1c4c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("4f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("b76a");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/ColumnSetting.vue?vue&type=script&lang=js&










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ColumnSettingvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'ColumnSetting',
  components: {
    draggable: vuedraggable_umd_default.a
  },
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    saveHandler: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    showSubTitle: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    modelWidth: {
      type: Number,
      default: 700
    }
  },
  setup: function setup(props) {
    var isMobile = Object(composition_api_["ref"])(Object(tools_["detectDeviceType"])() === 'Mobile');
    var settingVisible = Object(composition_api_["ref"])(false);
    var checkAll = Object(composition_api_["ref"])(false);
    var checkedList = Object(composition_api_["ref"])([]);
    var columnMap = Object(composition_api_["reactive"])({});
    var isIndeterminate = Object(composition_api_["ref"])(false); // 设置 indeterminate 状态，只负责样式控制

    var innerConfig = Object(composition_api_["computed"])(function () {
      return {
        visibility: true,
        sorting: true
      };
    });
    var labelSearch = Object(composition_api_["ref"])('');
    var screenCheckboxClass = Object(composition_api_["computed"])(function () {
      return function (label) {
        if (labelSearch.value && label.indexOf(labelSearch.value) !== -1) {
          return 'mc-table-pro-setting-mtd-checkbox-screen-active';
        }

        return '';
      };
    });
    /**
     * 全部字段里选择发生变化时
     * @param value
     */

    var handleCheckedListChange = function handleCheckedListChange(value) {
      var checkedCount = value.length;
      checkAll.value = checkedCount === props.columns.length;
      isIndeterminate.value = checkedCount > 0 && checkedCount < props.columns.length;
    };

    var reset = function reset() {
      var tmpList = [];
      var columnsTmp = Object(tools_["cloneDeep"])(props.columns);
      columnsTmp.forEach(function (col) {
        var _col$visible = col.visible,
            visible = _col$visible === void 0 ? true : _col$visible,
            prop = col.prop;
        visible && tmpList.push(prop);
      });
      checkedList.value = tmpList;
      handleCheckedListChange(tmpList);
    };

    Object(composition_api_["watch"])(function () {
      return Object(toConsumableArray["a" /* default */])(props.columns);
    }, function (val) {
      val.forEach(function (col) {
        columnMap[col.prop] = Object(tools_["cloneDeep"])(col);
      });
      reset();
    }, {
      immediate: true
    });
    Object(composition_api_["watch"])(function () {
      return Object(toConsumableArray["a" /* default */])(checkedList.value);
    }, function (val) {
      handleCheckedListChange(val);
    });
    /**
     * 在已选字段里点击x删除
     * @param val
     */

    var handleUnselect = function handleUnselect(val) {
      checkedList.value = checkedList.value.filter(function (prop) {
        return prop !== val;
      });
    };
    /**
     * 面板点击取消
     */


    var handleCancel = function handleCancel() {
      settingVisible.value = false;
      reset();
    };
    /**
     * 面板点击确定，进行保存
     */


    var handleSuccess = function handleSuccess() {
      settingVisible.value = false;
      var unsortedList = [];
      var columnsTmp = Object(tools_["cloneDeep"])(props.columns);
      columnsTmp.forEach(function (col) {
        var visible = checkedList.value.includes(col.prop);
        columnMap[col.prop].visible = visible; // 更新列是否可见

        !visible && unsortedList.push(columnMap[col.prop]); // 不可见的列不参与排序
      });
      var sortedList = checkedList.value.map(function (prop) {
        return columnMap[prop];
      });
      props.saveHandler && props.saveHandler([].concat(Object(toConsumableArray["a" /* default */])(sortedList), unsortedList));
    };
    /**
     * 点击全选
     */


    var handleCheckAllChange = function handleCheckAllChange(val) {
      checkedList.value = val ? props.columns.map(function (col) {
        return col.prop;
      }) : props.columns.filter(function (item) {
        return item.canSet === false;
      }).map(function (col) {
        return col.prop;
      });
      isIndeterminate.value = false;
    };
    /**
     * 判断是否以选字段可以删除
     */


    var canSetProp = function canSetProp(prop) {
      var info = props.columns.find(function (col) {
        return col.prop === prop;
      });

      if (info && info.canSet === false) {
        return false;
      }

      return true;
    };
    /**
     * 定制列中的小标题
     */


    var subTitleList = Object(composition_api_["computed"])(function () {
      var columns = props.columns || []; // 判断是否显示子标题

      if (props.showSubTitle) {
        // 使用 Set 数据结构去重，获取所有的子标题
        var subTitleSet = new Set(columns.map(function (item) {
          return item.subTitle;
        })); // 将 Set 转为数组，过滤掉空值，然后进行排序

        var sortedSubTitles = Array.from(subTitleSet).filter(Boolean).sort(function (a, b) {
          return a.localeCompare(b);
        }); // 如果有列的子标题为空，则在子标题列表中添加 '其他'

        if (columns.some(function (item) {
          return !item.subTitle;
        }) && !sortedSubTitles.find(function (item) {
          return item === '其他';
        })) sortedSubTitles.push('其他'); // 返回排序后的子标题列表

        return sortedSubTitles;
      }

      return [''];
    });
    /**
     * 通过小标题匹配对应的列
     */

    var matchingTitle = function matchingTitle(subTitle) {
      if (subTitle === '其他') return props.columns.filter(function (item) {
        return (!item.subTitle || item.subTitle === subTitle) && item.canSet !== false;
      });
      if (props.showSubTitle) return props.columns.filter(function (item) {
        return item.subTitle === subTitle && item.canSet !== false;
      });
      return props.columns.filter(function (item) {
        return item.canSet !== false;
      });
    };

    return {
      isMobile: isMobile,
      checkAll: checkAll,
      checkedList: checkedList,
      columnMap: columnMap,
      isIndeterminate: isIndeterminate,
      innerConfig: innerConfig,
      labelSearch: labelSearch,
      screenCheckboxClass: screenCheckboxClass,
      settingVisible: settingVisible,
      handleUnselect: handleUnselect,
      handleSuccess: handleSuccess,
      handleCancel: handleCancel,
      handleCheckAllChange: handleCheckAllChange,
      handleCheckedListChange: handleCheckedListChange,
      canSetProp: canSetProp,
      subTitleList: subTitleList,
      matchingTitle: matchingTitle
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-table-pro/components/ColumnSetting.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ColumnSettingvue_type_script_lang_js_ = (ColumnSettingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-table-pro/components/ColumnSetting.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_ColumnSettingvue_type_script_lang_js_,
  ColumnSettingvue_type_template_id_2f867f15_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ColumnSetting = (component.exports);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__("a8db");

// CONCATENATED MODULE: ./components/mc-table-pro/utils/propsDeal.js




var support = {
  column: ['width', 'min-width', 'fixed', 'sortable', 'sort-method', 'align', 'header-align', 'formatter', 'column-key', 'resizable', 'show-overflow-tooltip'],
  table: ['cell-class', 'header-cell-class', 'row-key', 'empty-text', 'expand-row-keys', 'expandable', 'sort-order', 'selection', 'checkboxable', 'reserve-selection', 'index-of-selection', 'loading', 'loading-message', 'show-summary', 'sum-text', 'summary-method', 'highlight-current-row', 'current-row-key', 'default-expand-all', 'expand-on-click-tr', 'disabled-select-all']
}; // 获取支持透传的props

var getSupportProps = function getSupportProps(propsType, props) {
  var supportProps = support[propsType];
  var curProps = {};
  var keys = Object.keys(props);

  for (var i = 0; i < keys.length; i++) {
    if (supportProps.includes(keys[i])) {
      curProps[keys[i]] = props[keys[i]];
    }
  }

  return curProps;
};

/* harmony default export */ var propsDeal = (getSupportProps);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/RenderHeader.vue?vue&type=script&lang=js&









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var renderTemplate = function renderTemplate(h, template, column) {
  var attrs = template.attrs,
      events = template.events,
      component = template.component;

  if (component && typeof component === 'function') {
    return component.call({
      $createElement: h
    }, column);
  }

  return h(component, {
    props: _objectSpread({}, attrs),
    attrs: _objectSpread({}, attrs),
    on: _objectSpread({}, events)
  });
};

/* harmony default export */ var RenderHeadervue_type_script_lang_js_ = ({
  functional: true,
  render: function render(h, ctx) {
    var isMobile = Object(tools_["detectDeviceType"])() === 'Mobile';

    var renderHeader = function renderHeader() {
      var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var header = columns.map(function (column, index) {
        // 多级表头
        if (column.children && column.children.length) {
          var _label = column.label,
              _column$visible = column.visible,
              _visible = _column$visible === void 0 ? true : _column$visible,
              otherProps = Object(objectWithoutProperties["a" /* default */])(column, ["label", "visible"]);

          if (!_visible) {
            return '';
          }

          return h("mtd-table-column", {
            "attrs": _objectSpread({
              "label": _label
            }, otherProps)
          }, [renderHeader(column.children)]);
        }

        var type = column.type,
            label = column.label,
            prop = column.prop,
            _column$visible2 = column.visible,
            visible = _column$visible2 === void 0 ? true : _column$visible2,
            help = column.help,
            headTemplate = column.headTemplate,
            colProps = Object(objectWithoutProperties["a" /* default */])(column, ["type", "label", "prop", "visible", "help", "headTemplate"]);

        var _column$template = column.template,
            template = _column$template === void 0 ? 'default' : _column$template;

        if (visible) {
          var vnode;
          var _ctx$parent$paginatio = ctx.parent.paginationDef,
              pageSize = _ctx$parent$paginatio.pageSize,
              currentPage = _ctx$parent$paginatio.currentPage;

          if (type === 'selection') {
            if (!('align' in column)) {
              colProps.align = 'center';
            }
          } else if (ctx.parent.$scopedSlots[prop]) {
            // 处理  column slot
            vnode = function vnode(scope) {
              return ctx.parent.$scopedSlots[prop](_objectSpread({}, scope, {
                pageSize: pageSize,
                currentPage: currentPage,
                offset: (currentPage - 1) * pageSize
              }));
            };
          } else {
            vnode = function vnode(scope) {
              if (typeof template === 'string') {
                template = {
                  type: 'default',
                  placeholder: '--'
                };
              }

              var _template = template,
                  tplName = _template.type,
                  attrs = _template.attrs,
                  events = _template.events,
                  templateProps = Object(objectWithoutProperties["a" /* default */])(_template, ["type", "attrs", "events"]);

              var val = Object(tools_["get"])(scope.row, prop);
              var cellValue = [null, undefined, ''].includes(val) ? ctx.parent.cellEmptyText : val;
              var reserves = ['default', 'datetime', 'array', 'html', 'enum', 'link'];
              if (typeof tplName === 'string' && reserves.includes(tplName)) tplName = "format-".concat(tplName);
              return [h(tplName, {
                props: _objectSpread({}, templateProps, {
                  value: column.formatter ? column.formatter(scope.row, column, val, scope.$index) : cellValue,
                  scope: scope
                }),
                attrs: _objectSpread({}, attrs),
                on: _objectSpread({}, events)
              })];
            };
          } // 渲染带提示的表头
          // eslint-disable-next-line no-shadow


          var renderHelpHeader = function renderHelpHeader(h, _ref) {
            var labelHelp = _ref.column.label;

            if (headTemplate) {
              return renderTemplate(h, headTemplate, column);
            }

            if (!help) {
              return h('span', labelHelp);
            }

            var helpNodes = help;

            if (help && help.template) {
              helpNodes = [renderTemplate(h, help.template, column)];
            }

            if (Array.isArray(help)) {
              helpNodes = help.map(function (text) {
                return h('div', text);
              });
            }

            return h('span', [labelHelp, h('mtd-tooltip', {
              style: {
                marginLeft: '5px',
                zIndex: 9999
              },
              attrs: {
                theme: 'light'
              }
            }, [h('template', {
              slot: 'content'
            }, helpNodes), h('i', {
              class: {
                'mtdicon-info-circle': true
              }
            })])]);
          };

          var supportProps = propsDeal('column', colProps);

          if (isMobile && supportProps.fixed) {
            colProps.fixed = false;
          }

          return h("mtd-table-column", {
            "attrs": _objectSpread({
              "type": type,
              "label": label,
              "prop": prop,
              "renderHeader": renderHelpHeader
            }, supportProps),
            "key": prop + String(index)
          }, [vnode]);
        }

        return null;
      });
      return header;
    };

    var headerCofig = renderHeader(ctx.parent.innerColumns);
    return headerCofig;
  }
});
// CONCATENATED MODULE: ./components/mc-table-pro/components/RenderHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RenderHeadervue_type_script_lang_js_ = (RenderHeadervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-table-pro/components/RenderHeader.vue
var RenderHeader_render, RenderHeader_staticRenderFns




/* normalize component */

var RenderHeader_component = Object(componentNormalizer["a" /* default */])(
  components_RenderHeadervue_type_script_lang_js_,
  RenderHeader_render,
  RenderHeader_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RenderHeader = (RenderHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/Templates/Default.vue?vue&type=template&id=b5f18f3e&
var Defaultvue_type_template_id_b5f18f3e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Array.isArray(_vm.value))?_c('div',[(_vm.value.length === 0)?_c('div',[_vm._v("\n        "+_vm._s(_vm.placeholder)+"\n    ")]):_vm._l((_vm.value),function(item,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(item)+"\n    ")])})],2):_c('div',[_vm._v("\n    "+_vm._s(['', undefined, null].includes(_vm.value) ? _vm.placeholder : _vm.value)+"\n")])}
var Defaultvue_type_template_id_b5f18f3e_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/Default.vue?vue&type=template&id=b5f18f3e&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/Templates/Default.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Defaultvue_type_script_lang_js_ = ({
  name: 'FormatDefault',
  props: {
    value: {
      type: [Array, String, Object, Number, Boolean],
      default: ''
    },
    placeholder: {
      type: String,
      default: '--'
    }
  }
});
// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/Default.vue?vue&type=script&lang=js&
 /* harmony default export */ var Templates_Defaultvue_type_script_lang_js_ = (Defaultvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/Default.vue





/* normalize component */

var Default_component = Object(componentNormalizer["a" /* default */])(
  Templates_Defaultvue_type_script_lang_js_,
  Defaultvue_type_template_id_b5f18f3e_render,
  Defaultvue_type_template_id_b5f18f3e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Default = (Default_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/Templates/Array.vue?vue&type=template&id=3de81326&
var Arrayvue_type_template_id_3de81326_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value.length === 0)?_c('div',[_vm._v("\n        "+_vm._s(_vm.placeholder)+"\n    ")]):(_vm.value.length > _vm.maxLength)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.value.slice(0, _vm.maxLength).join(', '))+"...")]),_c('mtd-popover',{attrs:{"trigger":"hover","width":_vm.popoverWidth}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('span',[_vm._v(_vm._s(_vm.value.join(', ')))])]),_c('mtd-button',{attrs:{"type":"text"}},[_vm._v("\n                显示全部("+_vm._s(_vm.value.length)+")\n            ")])],1)],1):_c('div',[_c('span',[_vm._v(_vm._s(_vm.value.join(', ')))])])])}
var Arrayvue_type_template_id_3de81326_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/Array.vue?vue&type=template&id=3de81326&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/components/Templates/Array.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Arrayvue_type_script_lang_js_ = ({
  name: 'Array',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxLength: {
      type: Number,
      default: Infinity
    },
    placeholder: {
      type: [String],
      default: '--'
    },
    popoverWidth: {
      type: [Number, String]
    }
  }
});
// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/Array.vue?vue&type=script&lang=js&
 /* harmony default export */ var Templates_Arrayvue_type_script_lang_js_ = (Arrayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/Array.vue





/* normalize component */

var Array_component = Object(componentNormalizer["a" /* default */])(
  Templates_Arrayvue_type_script_lang_js_,
  Arrayvue_type_template_id_3de81326_render,
  Arrayvue_type_template_id_3de81326_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Templates_Array = (Array_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Datetime.vue?vue&type=template&id=6966e606&
var Datetimevue_type_template_id_6966e606_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.value ? _vm.formatTime(_vm.value, _vm.format) : _vm.placeholder))])}
var Datetimevue_type_template_id_6966e606_staticRenderFns = []


// CONCATENATED MODULE: ./components/Templates/Datetime.vue?vue&type=template&id=6966e606&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.constructor.js
var es6_regexp_constructor = __webpack_require__("3b2b");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Datetime.vue?vue&type=script&lang=js&


//
//
//
//

/* harmony default export */ var Datetimevue_type_script_lang_js_ = ({
  name: 'FormatDatetime',
  props: {
    value: {
      type: [Number, String]
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    placeholder: {
      type: String,
      default: '-'
    },
    invalidTimeBorder: {
      type: [Number, String],
      default: 0
    }
  },
  setup: function setup(props) {
    var formatTime = function formatTime(targetVal, format) {
      if (+targetVal <= +props.invalidTimeBorder) {
        return props.placeholder;
      }

      var stack = targetVal;
      if (typeof targetVal === 'number') stack = new Date(targetVal);else if (typeof targetVal === 'string') {
        var reg = new RegExp('^[0-9]+$');
        if (reg.test(stack)) stack = new Date(+stack);else stack = new Date(targetVal);
      }
      return Object(tools_["formatDateToString"])(stack, format);
    };

    return {
      formatTime: formatTime
    };
  }
});
// CONCATENATED MODULE: ./components/Templates/Datetime.vue?vue&type=script&lang=js&
 /* harmony default export */ var Templates_Datetimevue_type_script_lang_js_ = (Datetimevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/Templates/Datetime.vue





/* normalize component */

var Datetime_component = Object(componentNormalizer["a" /* default */])(
  Templates_Datetimevue_type_script_lang_js_,
  Datetimevue_type_template_id_6966e606_render,
  Datetimevue_type_template_id_6966e606_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Datetime = (Datetime_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Enum.vue?vue&type=template&id=6b2c7244&
var Enumvue_type_template_id_6b2c7244_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mc-enum-text',_vm._b({attrs:{"value":_vm.value,"source":_vm.source}},'mc-enum-text',_vm.$attrs,false))}
var Enumvue_type_template_id_6b2c7244_staticRenderFns = []


// CONCATENATED MODULE: ./components/Templates/Enum.vue?vue&type=template&id=6b2c7244&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Enum.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
/* harmony default export */ var Enumvue_type_script_lang_js_ = ({
  name: 'FormatDicCode',
  props: {
    value: {
      type: [String, Number]
    },
    source: {
      type: [Array, String],
      default: ''
    }
  }
});
// CONCATENATED MODULE: ./components/Templates/Enum.vue?vue&type=script&lang=js&
 /* harmony default export */ var Templates_Enumvue_type_script_lang_js_ = (Enumvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/Templates/Enum.vue





/* normalize component */

var Enum_component = Object(componentNormalizer["a" /* default */])(
  Templates_Enumvue_type_script_lang_js_,
  Enumvue_type_template_id_6b2c7244_render,
  Enumvue_type_template_id_6b2c7244_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Enum = (Enum_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Link.vue?vue&type=template&id=f02953ac&
var Linkvue_type_template_id_f02953ac_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.linkList),function(item){return _c('mc-link',_vm._b({key:item.text,on:{"click":item.onClick}},'mc-link',_vm.omit(item, ['onClick']),false))}),1)}
var Linkvue_type_template_id_f02953ac_staticRenderFns = []


// CONCATENATED MODULE: ./components/Templates/Link.vue?vue&type=template&id=f02953ac&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Link.vue?vue&type=script&lang=js&






function Linkvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Linkvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Linkvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Linkvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Linkvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'FormatLink',
  props: {
    scope: {},
    formatter: {
      type: [Function, String, Array],
      required: true
    },
    target: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, ctx) {
    var _this = this;

    var formatLinkOption = function formatLinkOption(tplStr, row, prop) {
      var target = _this.target,
          text = _this.text;
      var linkOption = {
        path: (tplStr || '').replace(/{([^{,}]*)}/ig, function (v, v1) {
          return row[v1];
        }),
        onClick: tools_["noop"],
        // 模板字符串模式暂不支持事件
        text: text || row[prop] || '-'
      };

      if (target) {
        linkOption[target] = target;
      }

      return linkOption;
    };

    var linkList = Object(composition_api_["computed"])(function () {
      var scope = props.scope,
          formatter = props.formatter;
      var row = scope.row,
          column = scope.column,
          $index = scope.$index;
      var cellValue = Object(tools_["get"])(row, column.property);

      if (typeof formatter === 'string') {
        // 模板字符串模式
        return [formatLinkOption(formatter, row, column.property)];
      }

      if (Array.isArray(formatter)) {
        // 多个模板字符串模式
        return formatter.map(function (tplStr) {
          return formatLinkOption(tplStr, row, column.property);
        });
      } // 回调函数模式


      var attrs = formatter(row, column, cellValue, $index);
      return [].concat(attrs).map(function (itemAttrs) {
        return Linkvue_type_script_lang_js_objectSpread({
          text: cellValue
        }, itemAttrs, {
          onClick: itemAttrs.onClick || tools_["noop"]
        });
      }).filter(function (v) {
        return v.text;
      });
    });
    return {
      linkList: linkList,
      omit: tools_["omit"]
    };
  }
}));
// CONCATENATED MODULE: ./components/Templates/Link.vue?vue&type=script&lang=js&
 /* harmony default export */ var Templates_Linkvue_type_script_lang_js_ = (Linkvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/Templates/Link.vue





/* normalize component */

var Link_component = Object(componentNormalizer["a" /* default */])(
  Templates_Linkvue_type_script_lang_js_,
  Linkvue_type_template_id_f02953ac_render,
  Linkvue_type_template_id_f02953ac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Link = (Link_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Html.vue?vue&type=template&id=58b074e6&
var Htmlvue_type_template_id_58b074e6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.value || _vm.placeholder)}})}
var Htmlvue_type_template_id_58b074e6_staticRenderFns = []


// CONCATENATED MODULE: ./components/Templates/Html.vue?vue&type=template&id=58b074e6&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Templates/Html.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var Htmlvue_type_script_lang_js_ = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '-'
    }
  }
});
// CONCATENATED MODULE: ./components/Templates/Html.vue?vue&type=script&lang=js&
 /* harmony default export */ var Templates_Htmlvue_type_script_lang_js_ = (Htmlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/Templates/Html.vue





/* normalize component */

var Html_component = Object(componentNormalizer["a" /* default */])(
  Templates_Htmlvue_type_script_lang_js_,
  Htmlvue_type_template_id_58b074e6_render,
  Htmlvue_type_template_id_58b074e6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Html = (Html_component.exports);
// CONCATENATED MODULE: ./components/mc-table-pro/components/Templates/index.js
/**
 * template管理工具，提供函数可以自定义注册
 */





 // import FormatImage from './image.vue';

var Formaters = {
  FormatDefault: Default,
  FormatDatetime: Datetime,
  FormatEnum: Enum,
  FormatLink: Link,
  FormatArray: Templates_Array,
  FormatHtml: Html // FormatImage,

};
/* harmony default export */ var Templates = (Formaters);
// CONCATENATED MODULE: ./components/mc-table-pro/utils/storage.js


var defaultExpired = 20 * 24 * 3600 * 1000;
var defaultCachePrefix = '__mc__fe_components_';
/*
    session: expired=true
    local: expired=number|default
*/

var checkSupport = function checkSupport() {
  return window.localStorage && window.sessionStorage;
};

var getItem = function getItem(key) {
  return window.sessionStorage.getItem(key) || window.localStorage.getItem(key);
};

var isStorageKey = function isStorageKey(key) {
  var data = getItem(key); // 没有查到key

  if (!data) {
    return null;
  }

  try {
    data = JSON.parse(data);
  } catch (e) {
    console.error(e, key);
  } // 旧数据


  if (!data.expired && !data.hasOwnProperty('value')) {
    // eslint-disable-line
    return null;
  }

  return data;
};

var storage = {
  set: function set(key, value, expired) {
    key = defaultCachePrefix + key;

    if (!checkSupport()) {
      return;
    }

    var can = window.localStorage;

    if (expired === true) {
      // sessionStorage
      can = window.sessionStorage;
    } else if (+expired && +expired > 1000000000000) {
      // 存的是目标时间戳
      expired = +expired;
    } else {
      // 存的是偏移量
      expired = Date.now() + (+expired || defaultExpired);
    }

    try {
      can.setItem(key, JSON.stringify({
        expired: expired,
        value: value
      }));
    } catch (e) {
      console.error(e);
    }
  },
  get: function get(key, forceFormattedStorage) {
    key = defaultCachePrefix + key;

    if (!checkSupport()) {
      return null;
    }

    var data = isStorageKey(key);

    if (!data) {
      // 强制新格式的storage 或 原生格式
      return forceFormattedStorage ? null : getItem(key);
    } // 已过期


    if (data.expired !== true && +data.expired <= Date.now()) {
      storage.remove(key);
      return null;
    }

    return data.value;
  },
  remove: function remove(key) {
    if (!checkSupport()) {
      return;
    }

    key = defaultCachePrefix + key;
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  },
  clear: function clear(force) {
    if (!checkSupport()) {
      return;
    }

    if (force) {
      window.localStorage.clear();
      window.sessionStorage.clear();
    } else {
      Object.keys(window.localStorage).forEach(function (key) {
        if (key.indexOf(defaultCachePrefix) !== 0) return;
        var data = isStorageKey(key);

        if (!data) {
          return;
        }

        if (+data.expired <= Date.now()) {
          storage.remove(key);
        }
      });
    }
  }
};
storage.clear();
/* harmony default export */ var utils_storage = (storage);
// CONCATENATED MODULE: ./components/mc-table-pro/utils/setFixed.js


var getScroll = function getScroll(target, top) {
  if (typeof window === 'undefined') {
    return 0;
  }

  var prop = top ? 'pageYOffset' : 'pageXOffset';
  var method = top ? 'scrollTop' : 'scrollLeft';
  var isWindow = target === window;
  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode

  if (isWindow && typeof ret !== 'number') {
    ret = document.documentElement[method];
  }

  return ret;
};

var getTargetRect = function getTargetRect(target) {
  var obj = {
    top: 0,
    left: 0,
    bottom: 0
  };
  return target !== window ? target.getBoundingClientRect() : obj;
};

var getOffset = function getOffset(element, target) {
  var elemRect = element.getBoundingClientRect();
  var targetRect = getTargetRect(target);
  var scrollTop = getScroll(target, true);
  var scrollLeft = getScroll(target, false);
  var docElem = window.document.body;
  var clientTop = docElem.clientTop || 0;
  var clientLeft = docElem.clientLeft || 0;
  return {
    top: elemRect.top - targetRect.top + scrollTop - clientTop,
    left: elemRect.left - targetRect.left + scrollLeft - clientLeft,
    width: elemRect.width,
    height: elemRect.height
  };
};

var getEle = function getEle(className) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return target === null || target === void 0 ? void 0 : target.getElementsByClassName(className);
};
var setStyle = function setStyle(curEle, options) {
  // 获取最外层div
  var layoutEle = getEle('vsc-initialized')[0] || getEle('app')[0] || getEle('layout-page-content')[0]; // 芥末平台中的body的class是vsc-initialized

  if (!layoutEle) {
    return;
  }

  layoutEle.style.cssText = "position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: #fff;";
  var offset = options.offset,
      zIndex = options.zIndex;
  var cssText = "\n        position: absolute;\n        z-index: ".concat(zIndex, ";\n    "); // target 为最外层div的第一个div

  var target;

  for (var i = 0; i < layoutEle.children.length || 0; i++) {
    if (layoutEle.children[i].tagName.toLowerCase() === 'div') {
      target = layoutEle.children[i];
      break;
    }
  }

  target.style.cssText = "flex: 1;\n    overflow-x: hidden;\n    overflow-y: auto;";
  setTimeout(function () {
    var headerDom = getEle('mtd-table-header-wrapper', curEle);
    var bodyDom = getEle('mtd-table-body-wrapper', curEle);

    if (!headerDom || !bodyDom) {
      return;
    }

    var headerEle = headerDom[0];
    var bodyEle = bodyDom[0];
    var elemOffset = getOffset(headerEle, target);
    var isSetted = false; // eslint-disable-next-line no-shadow

    var setStyle = function setStyle() {
      var isIn = getTargetRect(headerEle).top !== 0;

      if (isIn) {
        if (!isSetted) {
          elemOffset = getOffset(headerEle, target);
        }

        var scrollTop = getScroll(target, true);

        if (scrollTop >= elemOffset.top - offset) {
          if (!isSetted) {
            Array.prototype.slice.call(getEle('mtd-table-fixed-header-wrapper', curEle)).forEach(function (item) {
              item.style.cssText = 'z-index: 1999;';
            });
            headerEle.style.cssText = cssText;
            bodyEle.style.cssText = "margin-top: ".concat(elemOffset.height, "px;");
          }

          headerEle.style.top = "".concat(scrollTop - elemOffset.top, "px");
          Array.prototype.slice.call(getEle('mtd-table-fixed-header-wrapper', curEle)).forEach(function (item) {
            item.style.top = "".concat(scrollTop - elemOffset.top, "px");
          });
          isSetted = true;
        } else {
          isSetted = false;
          headerEle.style.cssText = '';
          bodyEle.style.cssText = '';
          Array.prototype.slice.call(getEle('mtd-table-fixed-header-wrapper', curEle)).forEach(function (item) {
            item.style.cssText = '';
          });
        }
      }
    };

    target.addEventListener('scroll', setStyle);
  }, 1000);
};
// CONCATENATED MODULE: ./components/mc-table-pro/utils/rowColumnSpan.js



/**
 * 假设列表数据中，keyName相同的条目应该被行合并显示，
 * 则此函数返回一个数组，数组的每一项的index是需要应用行合并的行号，
 * 每一项是一个长度为2的数组，数组的第一项是行合并值，第二项是列合并值，该对象可直接被el-table的spanMethod方法使用，
 * 使用方法见下面的setRowColumnSpan函数
 */
function getRowSpanReg(keyNameArr, list) {
  if (!list || Object(esm_typeof["a" /* default */])(list) !== 'object' || !Array.isArray(list) || !list.length || !keyNameArr.length) {
    return [];
  }

  var rowSpanRegArr = [];
  keyNameArr.forEach(function (keyName, index) {
    if (!list[0][keyNameArr[index]]) {
      console.error("tablepro\u6570\u636E\u4E0D\u5B58\u5728key".concat(keyName));
      return;
    }

    var rowSpanBeginIdx = null;
    var lastKey = null;
    var thisKey = null;
    var lastMainKey = null;
    var thisMainKey = null;
    var rowSpanBegin = false;
    var rowSpanReg = [];
    list.forEach(function (item, idx) {
      thisKey = item[keyNameArr[index]];
      thisMainKey = item[keyNameArr[0]];

      if (thisKey && thisKey === lastKey && thisMainKey && thisMainKey === lastMainKey) {
        rowSpanReg[idx] = [0, 0];

        if (!rowSpanBegin) {
          rowSpanBegin = true;
          rowSpanBeginIdx = idx - 1;
          rowSpanReg[rowSpanBeginIdx] = [];
          rowSpanReg[rowSpanBeginIdx][0] = 2;
          rowSpanReg[rowSpanBeginIdx][1] = 1;
        } else {
          rowSpanReg[rowSpanBeginIdx][0] += 1;
        }
      } else {
        rowSpanBegin = false;
        rowSpanBeginIdx = null;
      }

      lastKey = thisKey;
      lastMainKey = thisMainKey;
    });
    rowSpanRegArr.push(rowSpanReg);
  });
  return rowSpanRegArr;
}
/** 说明
 * 该函数只用做行合并
 * 输入参数colFilter的作用是筛选出需要做行合并的列号
 * 然后根据上面的getRowSpanReg计算得到的rowSpanReg，去返回el-table需要的行合并参数
 */

function setRowColumnSpan(rowSpanRegArr, columns, _ref) {
  var row = _ref.row,
      column = _ref.column,
      rowIndex = _ref.rowIndex,
      columnIndex = _ref.columnIndex;

  for (var index = 0; index < rowSpanRegArr.length; index++) {
    if (columns[columnIndex] && columns[columnIndex]["allowSpanRow".concat(index)]) {
      if (rowSpanRegArr[index][rowIndex]) {
        return {
          rowspan: rowSpanRegArr[index][rowIndex][0],
          colspan: rowSpanRegArr[index][rowIndex][1]
        };
      }
    }
  }

  return {
    rowspan: 1,
    colspan: 1
  };
}
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-pro/mc-table-pro.vue?vue&type=script&lang=js&
















function mc_table_provue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mc_table_provue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mc_table_provue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mc_table_provue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var TABLE_STATUS = {
  LOADING: 'loading',
  DONE: 'done',
  ERROR: 'error'
};

function prefixLog(text) {
  return "[Table Pro]".concat(text);
}

/* harmony default export */ var mc_table_provue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McTablePro',
  components: mc_table_provue_type_script_lang_js_objectSpread({}, Templates),
  props: {
    name: {
      type: String,
      required: true
    },
    cellEmptyText: {
      type: String,
      default: '-'
    },
    fixedHeader: {
      type: [Object, Boolean],
      default: function _default() {
        return {
          offset: 0,
          zIndex: 1999
        };
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * 分页设置， 默认值见paginationDef
     */
    pagination: {
      type: [Boolean, Object],
      default: true
    },
    headerConfigure: {
      type: Boolean,
      default: false
    },

    /**
     * 是否展示小标题
     */
    headerConfigureSubTitle: {
      type: Boolean,
      default: false
    },

    /**
     * 是否可以搜索
     */
    headerConfigureSearch: {
      type: Boolean,
      default: false
    },

    /**
     * 是否本地存储定制的columns
     */
    headerConfigureLocal: {
      type: Boolean,
      default: true
    },
    // 列配置弹窗宽度
    headerConfigureWidth: {
      type: Number,
      default: 700
    },
    source: {
      required: true,
      type: [Array, Object],
      default: function _default() {
        return {
          autoLoad: true
        };
      }
    },
    rowSpanKey: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // rowSpanNextKey: { // 合并单元格次级key
    //     type: String,
    //     default: '',
    // },

    /**
     * rowColSpan覆盖mtd-rowColSpan
     */
    rowColSpan: {
      type: Function
    },
    rowCreatorProps: {
      type: [Object, Boolean],
      default: false
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    },
    autoStoreColumns: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var columnsWidthMap = Object(composition_api_["ref"])({});
    var status = Object(composition_api_["ref"])(TABLE_STATUS.DONE);
    var currentPage = Object(composition_api_["ref"])(1);
    var realPageSize = Object(composition_api_["ref"])(0); // 初始默认值为0， 会在paginationDef计算后给值

    var realTotal = Object(composition_api_["ref"])(1);
    var remoteData = Object(composition_api_["ref"])([]);
    var maskShown = Object(composition_api_["computed"])(function () {
      return status.value === TABLE_STATUS.ERROR;
    });
    var rowSpanReg = Object(composition_api_["ref"])([]);
    var mcTablePro = Object(composition_api_["ref"])(null); // const rowSpanNextReg = ref([]);

    var remoteColumns = Object(composition_api_["ref"])([]); // 接口返回的表头配置

    /** 分页设置 */

    var paginationDef = Object(composition_api_["computed"])(function () {
      var pagination = Object(tools_["isBoolean"])(props.pagination) ? {
        show: props.pagination
      } : props.pagination;
      var show = pagination.show,
          pageSize = pagination.pageSize,
          pageSizes = pagination.pageSizes;
      var total = Array.isArray(props.source) ? props.source.length : realTotal.value;
      var pageSizeDef;

      if (show) {
        pageSizeDef = realPageSize.value || pageSize || pageSizes && pageSizes[1] || 20;
      } else {
        pageSizeDef = total;
      }

      return mc_table_provue_type_script_lang_js_objectSpread({}, pagination, {
        showTotal: Object(tools_["isBoolean"])(pagination.showTotal) ? pagination.showTotal : true,
        showQuickJumper: Object(tools_["isBoolean"])(pagination.showQuickJumper) ? pagination.showQuickJumper : true,
        showSizeChanger: Object(tools_["isBoolean"])(pagination.showSizeChanger) ? pagination.showSizeChanger : true,
        pageSize: pageSizeDef,
        pageSizes: pageSizes && (!pageSize || pageSizes.includes(pageSize)) && pageSizes || pageSize && [pageSize] || [10, 20, 50, 100],
        currentPage: pagination.currentPage || currentPage.value,
        total: total
      });
    });
    Object(composition_api_["watch"])(function () {
      return mc_table_provue_type_script_lang_js_objectSpread({}, paginationDef.value);
    }, function (newVal) {
      currentPage.value = newVal.currentPage;
      realPageSize.value = newVal.pageSize;
      realTotal.value = newVal.total;
    }, {
      immediate: true,
      deep: true
    });
    var hasPrefix = Object(composition_api_["computed"])(function () {
      return ctx.slots.prefix || ctx.slots.prefixRight || props.headerConfigure;
    });
    var tableKey = Object(composition_api_["computed"])(function () {
      return "".concat(window.location.pathname, "-table-").concat(props.name);
    });
    /** table 当前数据计算 */

    var curTableData = Object(composition_api_["computed"])(function () {
      var tableDataTmp = null;
      if (!realPageSize.value) return [];

      if (Array.isArray(props.source)) {
        var start = realPageSize.value * (currentPage.value - 1),
            end = realPageSize.value * currentPage.value;
        tableDataTmp = props.source.slice(start, end);
      } else if (props.rowSpanKey.length) {
        tableDataTmp = remoteData.value;
      } else {
        tableDataTmp = remoteData.value.slice(0, realPageSize.value);
      }

      ctx.emit('TableDataChange', tableDataTmp);
      rowSpanReg.value = getRowSpanReg(props.rowSpanKey, tableDataTmp); // rowSpanNextReg.value = getNextRowSpanReg(props.rowSpanNextKey, props.rowSpanKey, tableDataTmp);

      return tableDataTmp;
    });
    var columnSeting = Object(composition_api_["ref"])([]);
    /** 展示的column  主要是为了列设置 */

    var innerColumns = Object(composition_api_["computed"])(function () {
      var _cloneDeep = Object(tools_["cloneDeep"])(props),
          _cloneDeep$columns = _cloneDeep.columns,
          columns = _cloneDeep$columns === void 0 ? [] : _cloneDeep$columns;

      var clonedColumns = columns || [];
      var storageColumns = columnSeting.value.length ? columnSeting.value : utils_storage.get(tableKey.value) || clonedColumns;
      var columnsPropMap = columns.reduce(function (prev, cur) {
        if (cur.prop) {
          prev[cur.prop] = cur;
        }

        return prev;
      }, {});

      if (remoteColumns.value) {
        remoteColumns.value.forEach(function (item) {
          if (columnsPropMap[item.prop]) {
            // 存在 覆盖
            Object.assign(columnsPropMap[item.prop], item);
            return;
          }

          var _index = item._index;

          if (_index !== null && _index > -1) {
            // _index存在 则添加到指定位置
            columns.splice(_index, 0, item);
            return;
          }

          columns.push(item);
        });
      }

      if (!props.headerConfigure) {
        return columns;
      }

      var storageColumnsPropMap = (storageColumns || []).reduce(function (prev, cur) {
        if (cur) prev[cur.prop] = cur;
        return prev;
      }, {});
      var newColumns = columns.map(function (column) {
        var storageColumn = storageColumnsPropMap[column.prop] || {};

        if (storageColumn) {
          Object.assign(column, {
            visible: storageColumn.visible,
            width: storageColumn.width || column.width
          });
        }

        return column;
      });

      if (storageColumns.length) {
        // 如果本地有设置  则根据设置排序 新列加载最后
        newColumns.sort(function (a, b) {
          var indexA = storageColumns.findIndex(function (v) {
            return v.prop === a.prop;
          });
          var indexB = storageColumns.findIndex(function (v) {
            return v.prop === b.prop;
          });

          if (indexA > -1 && indexB > -1) {
            // 如果本地存储有 则按照本地存储顺序排
            return indexA - indexB;
          } // 如果是后端返回或新加的列 则排到最后


          return -1;
        });
      }

      return newColumns;
    });
    /** 分页参数 */

    var getPagingData = function getPagingData() {
      var paging = {
        offset: realPageSize.value * (currentPage.value - 1),
        limit: realPageSize.value
      };
      return paging;
    };

    var buildParams = function buildParams(params, tableParams) {
      if (!Array.isArray(props.source)) {
        if (typeof props.source.buildParams === 'function') {
          return props.source.buildParams(params, tableParams);
        } else {
          params.limit = tableParams.paging.limit;
          params.offset = tableParams.paging.offset;
          return params;
        }
      }

      return null;
    };

    var responseProcessor = function responseProcessor(res) {
      if (!Array.isArray(props.source)) {
        if (typeof props.source.responseProcessor === 'function') {
          return props.source.responseProcessor(res);
        }

        return {
          data: res.list || res.dataList,
          total: res.total
        };
      }

      return null;
    };

    var queryData =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var queryParams,
            source,
            afterResponseProcessor,
            _useRemote,
            fetchData,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryParams = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
                  curPage: 1,
                  params: {},
                  keepCurPage: true
                };
                status.value = TABLE_STATUS.LOADING;

                if (queryParams.curPage) {
                  currentPage.value = queryParams.curPage;
                } else {
                  currentPage.value = queryParams.keepCurPage ? currentPage.value : 1;
                }

                source = Object(tools_["cloneDeep"])(props.source);

                if (Object(esm_typeof["a" /* default */])(source.ajax) === 'object' && !Array.isArray(source.ajax)) {
                  // 如果从queryData 发起搜索，则覆盖ajax原有的params
                  if (Object(esm_typeof["a" /* default */])(queryParams.params) === 'object' && Object.keys(queryParams.params).length) {
                    source.ajax = mc_table_provue_type_script_lang_js_objectSpread({}, source.ajax, {
                      params: queryParams.params
                    });
                  }

                  source = mc_table_provue_type_script_lang_js_objectSpread({}, source, {
                    buildParams: buildParams,
                    responseProcessor: responseProcessor
                  });
                }

                afterResponseProcessor = function afterResponseProcessor(res) {
                  var data = res.data,
                      total = res.total;
                  total = +total;

                  if (!data || paginationDef.show && total === undefined) {
                    console.warn(prefixLog('response返回格式异常'));
                  }

                  data = data || [];
                  remoteData.value = data;
                  realTotal.value = total;
                  status.value = TABLE_STATUS.DONE;
                  remoteColumns.value = res.config && res.config.columns;
                  ctx.emit('remoteDataChange', {
                    total: total,
                    data: data
                  });
                };

                _context.prev = 6;
                _useRemote = Object(useRemote["a" /* default */])(source, ctx, {
                  afterResponseProcessor: afterResponseProcessor
                }), fetchData = _useRemote.fetchData;
                _context.next = 10;
                return fetchData({
                  paging: getPagingData()
                });

              case 10:
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                status.value = TABLE_STATUS.ERROR;
                console.error(prefixLog(_context.t0));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 12]]);
      }));

      return function queryData() {
        return _ref.apply(this, arguments);
      };
    }();
    /** 分页数据变化时的处理event */


    var handlePageChange = function handlePageChange(current, size) {
      if (currentPage.value !== current) {
        currentPage.value = current;

        if (!Array.isArray(props.source)) {
          // 重新获取远端数据
          queryData({
            curPage: current
          });
        }

        ctx.emit('current-page-change', current);
      } else {
        realPageSize.value = size;

        if (!Array.isArray(props.source)) {
          // 重新获取远端数据
          queryData();
        }

        ctx.emit('page-size-change', size);
      }
    };

    var handleCurrentChange = function handleCurrentChange(current) {
      if (currentPage.value !== current) {
        currentPage.value = current;

        if (!Array.isArray(props.source)) {
          // 重新获取远端数据
          queryData({
            curPage: current
          });
        }

        ctx.emit('current-page-change', current);
      }
    };
    /** 表头吸顶设置 */


    var fixedHeaderOptions;
    Object(composition_api_["watch"])(function () {
      return props.fixedHeader;
    }, function (newVal) {
      if (Object(esm_typeof["a" /* default */])(newVal) === 'object') {
        fixedHeaderOptions = newVal;
      } else if (typeof newVal === 'boolean' && newVal) {
        fixedHeaderOptions = {
          offset: 0,
          zIndex: 1
        };
      }
    }, {
      immediate: true
    });
    Object(composition_api_["onBeforeMount"])(function () {
      if (!Array.isArray(props.source) && props.source.autoLoad) {
        queryData();
      }
    });
    Object(composition_api_["onMounted"])(function () {
      if (props.fixedHeader) {
        setStyle(mcTablePro.value, fixedHeaderOptions);
        window.addEventListener('resize', function () {
          setStyle(mcTablePro.value, fixedHeaderOptions);
        });
      }
    });
    /** 列设置 */

    var setColumn = function setColumn(columns) {
      var willStorageColumns = props.autoStoreColumns ? columns.map(function (item) {
        if (columnsWidthMap.value[item.prop]) {
          item.width = columnsWidthMap.value[item.prop];
        }

        return item;
      }) : columns;
      if (props.headerConfigureLocal) utils_storage.set(tableKey.value, willStorageColumns);
      columnSeting.value = willStorageColumns;
      ctx.emit('columnsChange', willStorageColumns);
    };
    /** 合并单元格的时候处理fixed的列 */


    var innerColumnsShow = Object(composition_api_["computed"])(function () {
      var v = innerColumns.value;
      var leftFixedColumns = v.filter(function (i) {
        return i.fixed === 'left' || i.fixed === true;
      });
      var rightFixedColumns = v.filter(function (i) {
        return i.fixed === 'right';
      });
      var noFixedColumns = v.filter(function (i) {
        return i.fixed !== 'right' && i.fixed !== 'left' && i.fixed !== true;
      });
      return [].concat(Object(toConsumableArray["a" /* default */])(leftFixedColumns), Object(toConsumableArray["a" /* default */])(noFixedColumns), Object(toConsumableArray["a" /* default */])(rightFixedColumns));
    });
    /** 合并单元格 */

    var arrayRowColSpan = function arrayRowColSpan(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;
      return setRowColumnSpan(rowSpanReg.value, innerColumnsShow.value, {
        row: row,
        column: column,
        rowIndex: rowIndex,
        columnIndex: columnIndex
      });
    };

    var innerHeaderDragend = function innerHeaderDragend(newWidth, oldWidth, column, event) {
      if (newWidth) {
        columnsWidthMap.value[column.prop] = Math.floor(newWidth);

        if (props.autoStoreColumns) {
          setColumn(innerColumns.value);
        }
      }

      return ctx.emit('header-dragend', newWidth, oldWidth, column, event);
    };

    var tableInstance = Object(composition_api_["toRefs"])(Object(composition_api_["reactive"])({
      innerHeaderDragend: innerHeaderDragend,
      status: status,
      currentPage: currentPage,
      realPageSize: realPageSize,
      realTotal: realTotal,
      hasPrefix: hasPrefix,
      curTableData: curTableData,
      innerColumns: innerColumns,
      maskShown: maskShown,
      paginationDef: paginationDef,
      rowSpanReg: rowSpanReg,
      mcTablePro: mcTablePro,
      // rowSpanNextReg,
      handlePageChange: handlePageChange,
      handleCurrentChange: handleCurrentChange,
      setColumn: setColumn,
      queryData: queryData,
      arrayRowColSpan: arrayRowColSpan
    }));
    return mc_table_provue_type_script_lang_js_objectSpread({}, tableInstance);
  },
  render: function render() {
    var h = arguments[0];
    var supportTableProps = propsDeal('table', this.$attrs);
    return h("div", {
      "ref": "mcTablePro",
      "class": "mc-table-pro"
    }, [h("mtd-loading", {
      "attrs": {
        "loading": this.status === TABLE_STATUS.LOADING
      }
    }, [this.hasPrefix ? h("div", {
      "class": "mc-table-pro-prefix"
    }, [h("div", [this.$slots.prefix]), h("div", [this.$slots.prefixRight, this.headerConfigure ? h(ColumnSetting, {
      "attrs": {
        "columns": this.innerColumns,
        "saveHandler": this.setColumn,
        "showSubTitle": this.headerConfigureSubTitle,
        "showSearch": this.headerConfigureSearch,
        "modelWidth": this.headerConfigureWidth
      }
    }) : null])]) : null, h("div", {
      "class": "mc-table-pro-creator-row-".concat(this.rowCreatorProps && this.rowCreatorProps.position || 'bottom')
    }, [h("mtd-table", {
      "attrs": mc_table_provue_type_script_lang_js_objectSpread({
        "bordered": this.bordered,
        "striped": this.striped,
        "data": this.curTableData,
        "row-col-span": this.rowColSpan || this.arrayRowColSpan
      }, supportTableProps),
      "on": mc_table_provue_type_script_lang_js_objectSpread({
        "header-dragend": this.innerHeaderDragend
      }, this.$listeners)
    }, [h(RenderHeader)]), h("div", [this.$slots.rowCreatorProps])]), this.maskShown ? h("div", {
      "class": "mc-table-pro-status-mask"
    }, [h("i", {
      "class": "mtdicon-error-circle"
    }), h("span", ["\u52A0\u8F7D\u5931\u8D25"])]) : null, this.paginationDef.show ? h("div", {
      "class": "mc-table-pro-pagination"
    }, [h("mtd-pagination", {
      "attrs": {
        "current-page": this.currentPage,
        "page-size": this.realPageSize,
        "page-size-options": this.paginationDef.pageSizes,
        "total": this.realTotal,
        "show-quick-jumper": this.paginationDef.showQuickJumper,
        "show-size-changer": this.paginationDef.showSizeChanger,
        "show-total": this.paginationDef.showTotal
      },
      "on": {
        "change": this.handlePageChange
      }
    })]) : null])]);
  }
}));
// CONCATENATED MODULE: ./components/mc-table-pro/mc-table-pro.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_table_pro_mc_table_provue_type_script_lang_js_ = (mc_table_provue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-table-pro/mc-table-pro.vue
var mc_table_pro_render, mc_table_pro_staticRenderFns




/* normalize component */

var mc_table_pro_component = Object(componentNormalizer["a" /* default */])(
  mc_table_pro_mc_table_provue_type_script_lang_js_,
  mc_table_pro_render,
  mc_table_pro_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_table_pro = (mc_table_pro_component.exports);
// CONCATENATED MODULE: ./components/mc-table-pro/index.js


/* istanbul ignore next */

mc_table_pro.install = function (Vue) {
  Vue.component(mc_table_pro.name, mc_table_pro);
};

/* harmony default export */ var components_mc_table_pro = __webpack_exports__["default"] = (mc_table_pro);

/***/ }),

/***/ "83d5":
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ "83f4":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("fe9e"),
    baseKeys = __webpack_require__("67a1"),
    isArrayLike = __webpack_require__("86a9");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "8400":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("2d9b"),
    root = __webpack_require__("6884");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "8436":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "84a2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "84aa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "84f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-supplier-select/mc-supplier-select.vue?vue&type=template&id=373e074b&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-supplier--select"},[_c('mc-select',_vm._b({attrs:{"source":_vm.source,"disabled":_vm.disabled,"clearable":_vm.clearable,"filterable":true,"multiple":_vm.multiple,"collapse-tags":"","placeholder":_vm.placeholder},on:{"input":_vm.input,"change":_vm.change},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-select',_vm.$attrs,false))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-supplier-select/mc-supplier-select.vue?vue&type=template&id=373e074b&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-supplier-select/mc-supplier-select.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_supplier_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McSupplierSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    // 数据处理函数，返回值会被作为渲染下拉列表的数据
    responseProcessor: {
      type: Function,
      default: function _default(res) {
        return res;
      }
    },
    // 选项值的数据类型
    valueType: {
      type: String,
      default: 'string'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择供应商'
    }
  },
  setup: function setup(props, ctx) {
    var innerValue = Object(composition_api_["ref"])(props.value); // 根据valueType格式化选项值的数据类型

    var formatValueToType = function formatValueToType(val, type) {
      if (!type || val === '' || val === undefined || val === null) {
        // 没有类型/空值
        return val;
      } else {
        // 设置数据类型为type类型
        return type === 'number' ? +val : "".concat(val);
      }
    };

    var buildParams = function buildParams(params, extendsParams) {
      if (extendsParams.query) {
        params.name = extendsParams.query;
      } else if (props.value && !Array.isArray(props.value)) {
        // 接口模糊搜索字段类型限制为String
        params.name = String(props.value);
      }

      return params;
    };

    var responseProcessor = function responseProcessor(res) {
      var suppliers = (res || []).map(function (item) {
        return _objectSpread({}, item, {
          label: item.name,
          value: formatValueToType(item.id, props.valueType)
        });
      });
      ctx.emit('loaded', suppliers);

      if (typeof props.responseProcessor === 'function') {
        return props.responseProcessor(suppliers);
      } else {
        return suppliers;
      }
    };

    var source = {
      ajax: {
        type: 'hGet',
        url: '/api/m/sqmhttp/supplier/cert/list/for/search',
        params: {
          name: '' // 搜索字段:名称模糊搜索,id精确搜索

        }
      },
      responseProcessor: responseProcessor,
      buildParams: buildParams
    };
    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val;
    }, {
      immediate: true
    });

    var input = function input(val) {
      ctx.emit('input', val);
    };

    var change = function change(val, item) {
      ctx.emit('change', val, item);
    };

    return {
      innerValue: innerValue,
      source: source,
      input: input,
      change: change
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-supplier-select/mc-supplier-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_supplier_select_mc_supplier_selectvue_type_script_lang_js_ = (mc_supplier_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-supplier-select/mc-supplier-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_supplier_select_mc_supplier_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_supplier_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-supplier-select/index.js


/* istanbul ignore next */

mc_supplier_select.install = function (Vue) {
  Vue.component(mc_supplier_select.name, mc_supplier_select);
};

/* harmony default export */ var components_mc_supplier_select = __webpack_exports__["default"] = (mc_supplier_select);

/***/ }),

/***/ "85b3":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5");

var DEREncoder = __webpack_require__("3768");

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),

/***/ "85f2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("454f");

/***/ }),

/***/ "860a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _config = __webpack_require__("512a");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Manager = {
  open: function open(instance) {
    (0, _config.getConfig)().addPopup(instance);
  },
  close: function close(instance) {
    (0, _config.getConfig)().removePopup(instance);
  },


  nextZIndex: function nextZIndex() {
    return (0, _config.getConfig)().getNextZIndex();
  },

  getLastPopup: function getLastPopup() {
    return (0, _config.getConfig)().getLastPopup();
  }
};

if (!_vue2.default.prototype.$isServer) {
  window.addEventListener('keydown', function (event) {
    // keyCode is deprecated
    if (event.key === 'Escape' || event.keyCode === 27) {
      var topPopup = Manager.getLastPopup();
      if (topPopup) {
        topPopup.$emit('esc');
      }
    }
  });
}
exports.default = Manager;

/***/ }),

/***/ "8615":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("5ca1");
var $values = __webpack_require__("504c")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "8689":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ "86a9":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("ca9b"),
    isLength = __webpack_require__("f68e");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8707":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("1c35")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "881f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-list/mc-list.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_listvue_type_script_lang_js_ = ({
  name: 'McList',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-list', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-list/mc-list.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_list_mc_listvue_type_script_lang_js_ = (mc_listvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-list/mc-list.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_list_mc_listvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_list = (component.exports);
// CONCATENATED MODULE: ./components/mc-list/index.js


/* istanbul ignore next */

mc_list.install = function (Vue) {
  Vue.component(mc_list.name, mc_list);
};

/* harmony default export */ var components_mc_list = __webpack_exports__["default"] = (mc_list);

/***/ }),

/***/ "8840":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ "8861":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("124f");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("6e53");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1010 = function (_MSI) {
	_inherits(MSI1010, _MSI);

	function MSI1010(data, options) {
		_classCallCheck(this, MSI1010);

		data += (0, _checksums.mod10)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
	}

	return MSI1010;
}(_MSI3.default);

exports.default = MSI1010;

/***/ }),

/***/ "887c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),

/***/ "88fb":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "8947":
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__("bac2")
var AuthCipher = __webpack_require__("82f0")
var Buffer = __webpack_require__("8707").Buffer
var StreamCipher = __webpack_require__("09f5")
var Transform = __webpack_require__("6430")
var aes = __webpack_require__("39f5")
var ebtk = __webpack_require__("ae84")
var inherits = __webpack_require__("3fb5")

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ "898b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ "89a2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants = __webpack_require__("c243");

var _EAN2 = __webpack_require__("bdfe");

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum = function checksum(number) {
	var res = number.substr(0, 12).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 3 : sum + a;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN13 = function (_EAN) {
	_inherits(EAN13, _EAN);

	function EAN13(data, options) {
		_classCallCheck(this, EAN13);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{12}$/) !== -1) {
			data += checksum(data);
		}

		// Adds a last character to the end of the barcode
		var _this = _possibleConstructorReturn(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));

		_this.lastChar = options.lastChar;
		return _this;
	}

	_createClass(EAN13, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(1, 6);
			var structure = _constants.EAN13_STRUCTURE[this.data[0]];
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(7, 6);
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
		}

		// The "standard" way of printing EAN13 barcodes with guard bars

	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var data = _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);

			// Extend data with left digit & last character
			if (this.options.displayValue) {
				data.unshift({
					data: '000000000000',
					text: this.text.substr(0, 1),
					options: { textAlign: 'left', fontSize: this.fontSize }
				});

				if (this.options.lastChar) {
					data.push({
						data: '00'
					});
					data.push({
						data: '00000',
						text: this.options.lastChar,
						options: { fontSize: this.fontSize }
					});
				}
			}

			return data;
		}
	}]);

	return EAN13;
}(_EAN3.default);

exports.default = EAN13;

/***/ }),

/***/ "89d7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-choice/mc-choice.vue?vue&type=template&id=1b456872&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-choice"},[(!_vm.readonly)?[(_vm.type === 'checkbox' && _vm.showCheckAll)?_c('mtd-checkbox',{staticStyle:{"margin-right":"32px"},attrs:{"indeterminate":_vm.isIndeterminate,"disabled":_vm.disabled},on:{"input":_vm.handleCheckedAll},model:{value:(_vm.checkedAll),callback:function ($$v) {_vm.checkedAll=$$v},expression:"checkedAll"}},[_vm._v("\n            全选\n        ")]):_vm._e(),(_vm.type === 'checkbox')?_c('mtd-checkbox-group',_vm._b({attrs:{"disabled":_vm.disabled},on:{"input":_vm.change},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mtd-checkbox-group',_vm.attrs,false),_vm._l((_vm.innerList),function(item){return _c('mtd-checkbox',{key:item.value,attrs:{"value":item.value,"disabled":item.disabled}},[_vm._v("\n                "+_vm._s(item.label)+"\n            ")])}),1):(_vm.type === 'radio')?_c('mtd-radio-group',_vm._b({attrs:{"disabled":_vm.disabled},on:{"input":_vm.change},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mtd-radio-group',_vm.attrs,false),_vm._l((_vm.innerList),function(item){return _c('mtd-radio',{key:item.value,attrs:{"value":item.value,"disabled":item.disabled}},[_vm._v("\n                "+_vm._s(item.label)+"\n            ")])}),1):_c('mtd-radio-group',_vm._b({attrs:{"disabled":_vm.disabled},on:{"input":_vm.change},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mtd-radio-group',_vm.attrs,false),_vm._l((_vm.innerList),function(item){return _c('mtd-radio-button',{key:item.value,attrs:{"value":item.value,"disabled":item.disabled}},[_vm._v("\n                "+_vm._s(item.label)+"\n            ")])}),1)]:_c('span',[_vm._v("\n        "+_vm._s(_vm.labels)+"\n    ")]),(_vm.helper !== '')?_c('div',{staticClass:"mtd-form-item-helper helper"},[_vm._v("\n        "+_vm._s(_vm.helper)+"\n    ")]):(_vm.$slots.helper)?_c('div',{staticClass:"helper",attrs:{"slot":"helper"},slot:"helper"},[_vm._t("helper")],2):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-choice/mc-choice.vue?vue&type=template&id=1b456872&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./composables/useRemote.js
var useRemote = __webpack_require__("9ea3");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-choice/mc-choice.vue?vue&type=script&lang=js&










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var mc_choicevue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McChoice',
  props: {
    value: {
      required: false
    },
    labelKey: {
      type: [String, Function],
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: function validator(value) {
        var validResult = ['checkbox', undefined, 'radio', 'radio-button'].includes(value);
        if (!validResult) console.error("McChoice type must be one of [checkbox, radio, undefined], but got ".concat(value));
        return validResult;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    source: {
      type: [Array, String, Object],
      default: function _default() {
        return [];
      }
    },
    showCheckAll: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    helper: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, ctx) {
    var getDefaultValue = function getDefaultValue() {
      if (props.type === 'checkbox') return !Array.isArray(props.value) ? [] : props.value;
      return Object(esm_typeof["a" /* default */])(props.value) === 'object' ? '' : props.value;
    };

    var formatList = function formatList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _props$disabledIds = props.disabledIds,
          disabledIds = _props$disabledIds === void 0 ? [] : _props$disabledIds,
          labelKey = props.labelKey,
          valueKey = props.valueKey;
      var stackList = Object(tools_["cloneDeep"])(list).map(function (item) {
        var stack = _objectSpread({}, item);

        if (disabledIds && Array.isArray(disabledIds) && disabledIds.includes(item[valueKey])) {
          stack.disabled = true;
        } else {
          stack.disabled = false;
        }

        var label = typeof labelKey === 'function' ? labelKey(item) : item[labelKey];
        return _objectSpread({}, stack, {
          label: label,
          value: item[valueKey]
        });
      });
      return stackList;
    };

    var original = Object(composition_api_["reactive"])({
      innerValue: getDefaultValue(),
      innerList: [],
      checkedAll: false,
      isIndeterminate: Object(composition_api_["computed"])(function () {
        if (props.type === 'checkbox') {
          var _original$innerValue$ = original.innerValue.filter(function (id) {
            return !props.disabledIds.includes(id);
          }),
              length = _original$innerValue$.length;

          return !!length && length !== original.innerList.filter(function (item) {
            return !item.disabled;
          }).length;
        }

        return false;
      }),
      change: function change(v) {
        var valueKey = props.valueKey,
            type = props.type;
        var selectItems = original.innerList[type === 'checkbox' ? 'filter' : 'find'](function (cItem) {
          if (type === 'checkbox') {
            return v.includes(cItem[valueKey]);
          } else {
            return cItem[valueKey] === v;
          }
        });

        if (type === 'checkbox') {
          var withOutDisabled = original.innerList.filter(function (item) {
            return !item.disabled;
          });
          original.checkedAll = v.length === withOutDisabled.length;
        }

        ctx.emit('change', v, selectItems);
        ctx.emit('input', v);
      },
      handleCheckedAll: function handleCheckedAll(checked) {
        var constantValue = props.disabledIds.filter(function (id) {
          return original.innerValue.includes(id);
        });
        var changeValue = checked ? original.innerList.filter(function (item) {
          return !item.disabled;
        }).map(function (item) {
          return item.value;
        }) : [];
        original.innerValue = changeValue.concat(constantValue);
        original.change(original.innerValue);
      },
      labels: Object(composition_api_["computed"])(function () {
        return original.innerList.filter(function (item) {
          if (props.type === 'checkbox') {
            return original.innerValue.includes(item.value);
          } else {
            return item.value === original.innerValue;
          }
        }).map(function (item) {
          return item.label;
        }).join(',') || '--';
      })
    });
    var originalRefs = Object(composition_api_["toRefs"])(original);

    var initSelect =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _useRemote, fetchData, stackList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                original.innerLoading = true;
                _context.prev = 1;

                if (!Array.isArray(props.source)) {
                  _context.next = 6;
                  break;
                }

                original.innerList = formatList(props.source);
                _context.next = 11;
                break;

              case 6:
                _useRemote = Object(useRemote["a" /* default */])(props.source, ctx), fetchData = _useRemote.fetchData;
                _context.next = 9;
                return fetchData();

              case 9:
                stackList = _context.sent;
                original.innerList = formatList(stackList);

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                original.innerList = [];

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13]]);
      }));

      return function initSelect() {
        return _ref.apply(this, arguments);
      };
    }();

    initSelect();
    Object(composition_api_["watch"])(function () {
      return props.disabledIds;
    }, function () {
      original.innerList = formatList(original.innerList);
    });
    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (value) {
      if (props.type === 'checkbox') {
        if (Array.isArray(value) && JSON.stringify(value) !== JSON.stringify(original.innerValue)) {
          original.innerValue = value;
        }

        var withOutDisabled = original.innerList.filter(function (item) {
          return !item.disabled;
        });
        var withOutValues = original.innerValue.filter(function (id) {
          return !props.disabledIds.includes(id);
        });
        original.checkedAll = withOutValues.length === withOutDisabled.length;
      } else {
        if (original.innerValue !== value) {
          original.innerValue = value;
        }
      }
    }, {
      immediate: true
    });
    return _objectSpread({}, originalRefs, {
      attrs: ctx.attrs,
      slots: ctx.slots
    });
  }
}));
// CONCATENATED MODULE: ./components/mc-choice/mc-choice.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_choice_mc_choicevue_type_script_lang_js_ = (mc_choicevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-choice/mc-choice.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_choice_mc_choicevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_choice = (component.exports);
// CONCATENATED MODULE: ./components/mc-choice/index.js


/* istanbul ignore next */

mc_choice.install = function (Vue) {
  Vue.component(mc_choice.name, mc_choice);
};

/* harmony default export */ var components_mc_choice = __webpack_exports__["default"] = (mc_choice);

/***/ }),

/***/ "8a5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-input/mc-input.vue?vue&type=template&id=288d58d6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-input-wrapper"},[_c('mc-popover',_vm._b({ref:"popover"},'mc-popover',_vm.popoverProps,false),[(_vm.readonly)?_c('span',[_vm._v("\n            "+_vm._s(_vm.value || '--')+"\n        ")]):(_vm.type==='number')?_c('mtd-input-group',[_c('mtd-input-number',_vm._g(_vm._b({ref:"mtdInputNumber",staticClass:"mc-input-number",attrs:{"value":_vm.value},on:{"change":_vm.handleChange,"input":_vm.setFormItemValue}},'mtd-input-number',_vm.$attrs,false),_vm.$listeners)),(_vm.$slots.append)?_c('template',{slot:"append"},[_vm._t("append")],2):_vm._e(),(_vm.$slots.prepend)?_c('template',{slot:"prepend"},[_vm._t("prepend")],2):_vm._e()],2):(_vm.type==='textarea')?_c('mtd-textarea',_vm._g(_vm._b({ref:"mtdTextArea",staticClass:"mc-text-area",attrs:{"value":_vm.value},on:{"change":_vm.handleChange,"input":_vm.setFormItemValue}},'mtd-textarea',_vm.$attrs,false),_vm.$listeners)):_c('mtd-input',_vm._g(_vm._b({ref:"mtdInput",staticClass:"mc-input",attrs:{"value":_vm.value},on:{"change":_vm.handleChange,"input":_vm.setFormItemValue}},'mtd-input',_vm.$attrs,false),_vm.$listeners),[(_vm.$slots.prefix)?_c('template',{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),(_vm.$slots.suffix)?_c('template',{slot:"suffix"},[_vm._t("suffix")],2):_vm._e(),(_vm.$slots.prepend)?_c('template',{slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.$slots.append)?_c('template',{slot:"append"},[_vm._t("append")],2):_vm._e()],2),_c('div',{staticStyle:{"width":"200px"},attrs:{"slot":"content"},slot:"content"},[_c('span',{staticStyle:{"padding":"4px","word-break":"break-all"}},[_vm._v("\n                "+_vm._s(_vm.value)+"\n            ")])])],1),(_vm.helper !== '')?_c('div',{staticClass:"mtd-form-item-helper"},[_vm._v("\n        "+_vm._s(_vm.helper)+"\n    ")]):(_vm.$slots.helper)?_c('div',{attrs:{"slot":"helper"},slot:"helper"},[_vm._t("helper")],2):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-input/mc-input.vue?vue&type=template&id=288d58d6&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./composables/useFormProvider.js
var useFormProvider = __webpack_require__("817d");

// CONCATENATED MODULE: ./composables/useFormItem.js



var useFormItem_useFormFieldsItem = function useFormFieldsItem(_ref) {
  var emit = _ref.emit;

  var _useFormProvider = Object(useFormProvider["a" /* default */])(),
      configForm = _useFormProvider.configForm;

  var formReadonly = Object(composition_api_["ref"])(configForm.readonly || false);
  Object(composition_api_["watch"])(function () {
    return configForm.readonly;
  }, function (val) {
    formReadonly.value = val;
  });

  var getFormItemReadonly = function getFormItemReadonly(propValue) {
    if (propValue === false) return false;
    if (propValue === true) return true;
    return configForm.readonly;
  };

  var setFormItemValue = function setFormItemValue(value) {
    emit('update:value', value);
  };

  return {
    formReadonly: formReadonly,
    setFormItemValue: setFormItemValue,
    getFormItemReadonly: getFormItemReadonly
  };
};

/* harmony default export */ var useFormItem = (useFormItem_useFormFieldsItem);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-input/mc-input.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_inputvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    helper: {
      type: String,
      default: ''
    },
    popoverProps: {
      type: Object,
      default: function _default() {
        return {
          trigger: 'hover',
          placement: 'top',
          disabled: true
        };
      },
      validator: function validator(val) {
        if (val && Object(esm_typeof["a" /* default */])(val) !== 'object') {
          console.error('popoverProps must be an object');
          return false;
        } // popoverProps 只支持 trigger 和 placement 属性，其他属性不支持


        var validProps = ['trigger', 'placement', 'disabled'];
        var keys = Object.keys(val);

        for (var i = 0; i < keys.length; i++) {
          if (!validProps.includes(keys[i])) {
            console.error("".concat(keys[i], " is not a valid property of popoverProps"));
            return false;
          }
        } // disabled boolean 属性校验


        if (val.disabled && typeof val.disabled !== 'boolean') {
          console.error('disabled must be a boolean');
          return false;
        }

        if (val.trigger && !['hover', 'click', 'focus'].includes(val.trigger)) {
          console.error('trigger must be one of hover, click, focus');
          return false;
        }

        if (val.placement && !['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end'].includes(val.placement)) {
          console.error('placement must be one of top, top-start, top-end, bottom, bottom-start, bottom-end, left, left-start, left-end, right, right-start, right-end');
          return false;
        }

        return true;
      }
    }
  },
  setup: function setup(props, ctx) {
    var popover = Object(composition_api_["ref"])(null);

    var _useFormItem = useFormItem(ctx),
        setFormItemValue = _useFormItem.setFormItemValue;

    var handleChange = function handleChange(val) {
      if (popover.value) {
        popover.value.updatePopper();
      }

      ctx.emit('change', val);
    };

    return {
      popover: popover,
      setFormItemValue: setFormItemValue,
      handleChange: handleChange
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-input/mc-input.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_input_mc_inputvue_type_script_lang_js_ = (mc_inputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-input/mc-input.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_input_mc_inputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_input = (component.exports);
// CONCATENATED MODULE: ./components/mc-input/index.js


/* istanbul ignore next */

mc_input.install = function (Vue) {
  Vue.component(mc_input.name, mc_input);
};

/* harmony default export */ var components_mc_input = __webpack_exports__["default"] = (mc_input);

/***/ }),

/***/ "8a81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7726");
var has = __webpack_require__("69a8");
var DESCRIPTORS = __webpack_require__("9e1e");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var META = __webpack_require__("67ab").KEY;
var $fails = __webpack_require__("79e5");
var shared = __webpack_require__("5537");
var setToStringTag = __webpack_require__("7f20");
var uid = __webpack_require__("ca5a");
var wks = __webpack_require__("2b4c");
var wksExt = __webpack_require__("37c8");
var wksDefine = __webpack_require__("3a72");
var enumKeys = __webpack_require__("d4c0");
var isArray = __webpack_require__("1169");
var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var toObject = __webpack_require__("4bf8");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var createDesc = __webpack_require__("4630");
var _create = __webpack_require__("2aeb");
var gOPNExt = __webpack_require__("7bbc");
var $GOPD = __webpack_require__("11e9");
var $GOPS = __webpack_require__("2621");
var $DP = __webpack_require__("86cc");
var $keys = __webpack_require__("0d58");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("9093").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("52a7").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("2d00")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("32e9")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "8aae":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("32a6");
module.exports = __webpack_require__("584a").Object.keys;


/***/ }),

/***/ "8b5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-pagination/mc-pagination.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_paginationvue_type_script_lang_js_ = ({
  name: 'McPagination',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-pagination', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-pagination/mc-pagination.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_pagination_mc_paginationvue_type_script_lang_js_ = (mc_paginationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-pagination/mc-pagination.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_pagination_mc_paginationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_pagination = (component.exports);
// CONCATENATED MODULE: ./components/mc-pagination/index.js


/* istanbul ignore next */

mc_pagination.install = function (Vue) {
  Vue.component(mc_pagination.name, mc_pagination);
};

/* harmony default export */ var components_mc_pagination = __webpack_exports__["default"] = (mc_pagination);

/***/ }),

/***/ "8b71":
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__("0211");

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),

/***/ "8b95":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");

var SHA512 = __webpack_require__("b525");

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ "8b97":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("d3f4");
var anObject = __webpack_require__("cb7c");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("9b43")(Function.call, __webpack_require__("11e9").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8bc8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {}
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__("ca5d");
} else {}


/***/ }),

/***/ "8c44":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__("ccff");

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__("acdb");

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__("887c");

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__("12d4");

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__("1ce5");

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__("5d1f");

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__("123a");

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__("730c");

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__("5d90");

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__("ae3c");

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__("2f6c");

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__("9b23");

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__("51eb");

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__("721c");

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),

/***/ "8c8a":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "8cf0":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "8d23":
/***/ (function(module, exports, __webpack_require__) {

const Polynomial = __webpack_require__("2732")

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),

/***/ "8d47":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ "8d57":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ "8df7":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5");
var Buffer = __webpack_require__("1c35").Buffer;

var DERDecoder = __webpack_require__("cfbd");

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),

/***/ "8e51":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MSI1110 = exports.MSI1010 = exports.MSI11 = exports.MSI10 = exports.MSI = undefined;

var _MSI = __webpack_require__("124f");

var _MSI2 = _interopRequireDefault(_MSI);

var _MSI3 = __webpack_require__("4727");

var _MSI4 = _interopRequireDefault(_MSI3);

var _MSI5 = __webpack_require__("4461");

var _MSI6 = _interopRequireDefault(_MSI5);

var _MSI7 = __webpack_require__("8861");

var _MSI8 = _interopRequireDefault(_MSI7);

var _MSI9 = __webpack_require__("805f");

var _MSI10 = _interopRequireDefault(_MSI9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MSI = _MSI2.default;
exports.MSI10 = _MSI4.default;
exports.MSI11 = _MSI6.default;
exports.MSI1010 = _MSI8.default;
exports.MSI1110 = _MSI10.default;

/***/ }),

/***/ "8e60":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("294c")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8e6e":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("5ca1");
var ownKeys = __webpack_require__("990b");
var toIObject = __webpack_require__("6821");
var gOPD = __webpack_require__("11e9");
var createProperty = __webpack_require__("f1ae");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "8e73":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ "8ed0":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("5801");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "8f60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("a159");
var descriptor = __webpack_require__("aebd");
var setToStringTag = __webpack_require__("45f2");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("35e8")(IteratorPrototype, __webpack_require__("5168")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "8fe5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = exports.off = undefined;
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.getStyle = getStyle;

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;
var defaultOptions = {
  capture: false,
  passive: false
};

function noop() {}

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (node, event, handler) {
      // 判断 node 为 vnode
      var element = node && node.$el ? node.$el : node;
      if (element && event) {
        element.removeEventListener(event, handler, defaultOptions);
      }
    };
  } else {
    return function (node, event, handler) {
      var element = node && node.$el ? node.$el : node;
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (node, event, handler) {
      // 判断 node 为 vnode
      var element = node && node.$el ? node.$el : node;
      if (element && event && handler) {
        element.addEventListener(event, handler, defaultOptions);
        return function () {
          return off(element, event, handler);
        };
      }
      return noop;
    };
  } else {
    return function (node, event, handler) {
      var element = node && node.$el ? node.$el : node;
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
        return function () {
          return off(element, event, handler);
        };
      }
      return noop;
    };
  }
}();

function hasClass(el, className) {
  if (!el || !className) {
    return false;
  }
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + className + ' ') > -1;
  }
}

function addClass(el, className) {
  if (!el) return;
  var curClass = el.className;
  var classes = (className || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

function removeClass(el, className) {
  if (!el || !className) return;
  var classes = className.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = curClass.trim();
  }
}

function getStyle(el, styleName) {
  if (isServer) return;
  if (!el) {
    return {};
  }
  try {
    var style = window.getComputedStyle(el, null);
    return style.getPropertyValue(styleName);
  } catch (e) {
    return el.style[styleName];
  }
}

/***/ }),

/***/ "9003":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("6b4c");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "9043":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ "9093":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("ce10");
var hiddenKeys = __webpack_require__("e11e").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "90cd":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("2d9b"),
    root = __webpack_require__("6884");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "90ea":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ "9109":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStyle; });
/* unused harmony export throwCustomError */
/* unused harmony export hasClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return afterLeave; });
/* harmony import */ var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("28a5");
/* harmony import */ var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__);



/* eslint-disable no-continue */

/* istanbul ignore next */
// eslint-disable-next-line no-useless-escape
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;

var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};

var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

var getStyle = function getStyle(element, styleName) {
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'cssFloat';
  }

  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};
function throwCustomError(message, name) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'log';

  if (level === 'error') {
    var error = new Error(message);
    error.name = name;
    throw error;
  } else {
    console.error("".concat(name, "\uFF1A").concat(message));
  }
}
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');

  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return " ".concat(el.className, " ").indexOf(" ".concat(cls, " ")) > -1;
  }
}
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += " ".concat(clsName);
    }
  }

  if (!el.classList) {
    el.className = curClass;
  }
}
/* istanbul ignore next */

function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = " ".concat(el.className, " ");

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(" ".concat(clsName, " "), ' ');
    }
  }

  if (!el.classList) {
    el.className = trim(curClass);
  }
}
function afterLeave(instance, callback) {
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!instance || !callback) throw new Error('instance & callback is required');
  var called = false;

  var afterLeaveCallback = function afterLeaveCallback() {
    if (called) return;
    called = true;

    if (callback) {
      callback.apply(null, arguments);
    }
  };

  if (once) {
    instance.$once('after-leave', afterLeaveCallback);
  } else {
    instance.$on('after-leave', afterLeaveCallback);
  }

  setTimeout(function () {
    afterLeaveCallback();
  }, speed + 100);
}
/* harmony default export */ __webpack_exports__["c"] = ({
  throwCustomError: throwCustomError
});

/***/ }),

/***/ "9138":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("35e8");


/***/ }),

/***/ "9224":
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"0.1.139\"}");

/***/ }),

/***/ "924f":
/***/ (function(module, exports, __webpack_require__) {

const getSymbolSize = __webpack_require__("7bf0").getSymbolSize
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),

/***/ "92a9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("6884"),
    stubFalse = __webpack_require__("fba5");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "9306":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("8e60");
var getKeys = __webpack_require__("c3a1");
var gOPS = __webpack_require__("9aa9");
var pIE = __webpack_require__("355d");
var toObject = __webpack_require__("241e");
var IObject = __webpack_require__("335c");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("294c")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "93e6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__("8707").Buffer
var Transform = __webpack_require__("d485").Transform
var inherits = __webpack_require__("3fb5")

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ "9427":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("63b6");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("a159") });


/***/ }),

/***/ "945d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("7d92");
var curves = __webpack_require__("0cbb");
var utils = __webpack_require__("f3a3");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__("380f");
var Signature = __webpack_require__("44a3");

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ "956a":
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__("1e3c")
var aes = __webpack_require__("fda6")
var aesModes = __webpack_require__("bac2")
var desModes = __webpack_require__("0be8")
var ebtk = __webpack_require__("ae84")

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "957c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ "9582":
/***/ (function(module, exports, __webpack_require__) {

const Utils = __webpack_require__("7bf0")

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),

/***/ "958b":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ "95d5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("40c3");
var ITERATOR = __webpack_require__("5168")('iterator');
var Iterators = __webpack_require__("481b");
module.exports = __webpack_require__("584a").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "9609":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ "966d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("f28c")))

/***/ }),

/***/ "9686":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "972c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ "975a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("fa49");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),

/***/ "9797":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ "97c3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("fa49");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),

/***/ "97d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/mc-tree-select.vue?vue&type=template&id=02b28a7f&
var mc_tree_selectvue_type_template_id_02b28a7f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"mc-tree-select"},[_c('mtd-popover',{ref:"popover",attrs:{"visible":_vm.visible,"popper-class":"mc-tree-select-popover","placement":"bottom-start","trigger":"click"}},[_c('div',{ref:"popover",attrs:{"slot":"content"},slot:"content"},[_vm._t("prefix"),_c('tree-wrapper',_vm._b({ref:"treeWrapper",attrs:{"data":_vm.innerData,"tag-data":_vm.tagData,"value":_vm.innerValue,"keyword":_vm.keyword,"disabled":_vm.innerDisabled,"check-strictly":_vm.checkStrictly},on:{"change":_vm.changeValue}},'tree-wrapper',_vm.$attrs,false)),(!_vm.innerData.length)?_c('div',[_vm._t("empty")],2):_vm._e(),_vm._t("append")],2),_c('view-wrapper',{ref:"viewWrapper",attrs:{"tag-data":_vm.tagData,"value":_vm.innerValue,"disabled":_vm.innerDisabled}})],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-tree-select/mc-tree-select.vue?vue&type=template&id=02b28a7f&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/components/TreeWrapper.vue?vue&type=template&id=778bb6d1&
var TreeWrappervue_type_template_id_778bb6d1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-tree-select-wrapper-inner"},[_c('mtd-tree',{ref:"mtdTree",attrs:{"props":{title: _vm.innerNodeConfig.label},"data":_vm.data,"disabled":_vm.disabled,"node-key":_vm.innerNodeConfig.value,"filter-node-method":_vm.filterMethod || _vm.filterNode,"checkable":_vm.multiple,"checked-keys":_vm.checkedValue,"selected-keys":_vm.selectedValue,"check-strictly":_vm.checkStrictly,"default-expand-all":_vm.defaultExpandAll,"filter-with-expand":"","empty-text":_vm.emptyText},on:{"nodeClick":_vm.handleNodeClick,"toggle-checked":_vm.handleChekced}})],1)}
var TreeWrappervue_type_template_id_778bb6d1_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-tree-select/components/TreeWrapper.vue?vue&type=template&id=778bb6d1&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("20d6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// CONCATENATED MODULE: ./components/mc-tree-select/utils/index.js


var getValue = function getValue(data, onlyLeaf, mergeValue, multiple, config) {
  var result;

  if (multiple) {
    result = (data || []).filter(function (item) {
      return !item.disabled;
    });

    if (onlyLeaf) {
      result = result.filter(function (item) {
        return !item.children;
      });
    }

    if (mergeValue) {
      result = result.filter(function (item) {
        return !(data || []).find(function (v) {
          return v.id === item.parentId;
        });
      });
    }

    return result.map(function (item) {
      return item[config.value];
    });
  }

  result = data || {};
  return result[config.value] || '';
};
var getItems = function getItems(data, onlyLeaf, mergeValue, multiple) {
  var result;

  if (multiple) {
    result = (data || []).filter(function (item) {
      return !item.beUndefined;
    });

    if (onlyLeaf) {
      result = result.filter(function (item) {
        return !item.children;
      });
    }

    if (mergeValue) {
      result = result.filter(function (item) {
        return !data.find(function (v) {
          return v.id === item.parentId;
        });
      });
    }
  } else {
    result = data;
  }

  return result;
};
var getTags = function getTags(data, mergeTag, onlyLeaf) {
  if (mergeTag) {
    return data.filter(function (item) {
      return data.findIndex(function (v) {
        return v.id === item.parentId;
      }) === -1;
    });
  }

  if (onlyLeaf) {
    return data.filter(function (item) {
      return !item.children;
    });
  }

  return data;
};
var findNodeInTree = function findNodeInTree(val, data, key) {
  var result;

  for (var i = 0; i < data.length; i++) {
    if (data[i][key] === val) {
      result = data[i];
    } else if (data[i].children) {
      result = findNodeInTree(val, data[i].children, key);
    }

    if (result) {
      break;
    }
  }

  return result;
};
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/components/TreeWrapper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var TreeWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'TreeWrapper',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Number, String, Array],
      default: '',
      required: true
    },
    keyword: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    tagData: {
      type: [Object, Array],
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var onlyLeaf = dataMap.onlyLeaf,
        mergeValue = dataMap.mergeValue,
        multiple = dataMap.multiple,
        innerNodeConfig = dataMap.innerNodeConfig,
        editableMethod = dataMap.editableMethod,
        filterMethod = dataMap.filterMethod,
        closePopover = dataMap.closePopover,
        emptyText = dataMap.emptyText,
        defaultExpandAll = dataMap.defaultExpandAll;
    var mtdTree = Object(composition_api_["ref"])(null);
    var selectedValue = Object(composition_api_["ref"])([]);
    var checkedValue = Object(composition_api_["ref"])([]);
    var innerValue = Object(composition_api_["computed"])(function () {
      return getValue(props.tagData, onlyLeaf, mergeValue, multiple, innerNodeConfig);
    });

    var emitEvent = function emitEvent(data) {
      var needEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      Object(composition_api_["nextTick"])(function () {
        emit('change', data, needEmit);
      });
    };

    var formatValue = function formatValue(type, data) {
      // type: 0-单选 1-CheckBox多选
      var emitData;

      if (type === 0) {
        emitData = data; // 单选选中时，关闭下拉框

        closePopover();
      } else if (type === 1) {
        var checkData = data.map(function (item) {
          return item.data;
        });
        emitData = checkData.concat((props.tagData || []).filter(function (item) {
          return item.beUndefined;
        }));
      }

      emitEvent(emitData);
    };

    var handleNodeClick = function handleNodeClick(item) {
      var selectItem = item.data;
      if (selectItem.disabled || props.disabled || editableMethod && !editableMethod(selectItem)) return;

      if (!multiple && (!onlyLeaf || !selectItem.children)) {
        // 单选可选择时
        if (selectItem[innerNodeConfig.value] !== innerValue.value) {
          formatValue(0, selectItem);
        }
      }
    };

    var handleChekced = function handleChekced(keys, item) {
      var checkItem = item.node.data;
      if (checkItem.disabled || props.disabled || editableMethod && !editableMethod(checkItem)) return;
      var nodes = item.nodes;
      formatValue(1, nodes);
    };

    var filterNode = function filterNode(value, data) {
      if (!value) return true;
      return data[innerNodeConfig.label].indexOf(value) !== -1;
    };

    var setValue = function setValue(val) {
      if (Array.isArray(val) && multiple) {
        checkedValue.value = val;
        selectedValue.value = val;
      } else if (!multiple) {
        selectedValue.value = val ? [val] : [];
      }
    };

    setValue(props.value);
    Object(composition_api_["watch"])(function () {
      return props.keyword;
    }, function (val) {
      mtdTree.value.filter(val);
    });
    Object(composition_api_["watch"])(innerValue, function (val) {
      setValue(val);
    });
    return {
      mtdTree: mtdTree,
      multiple: multiple,
      selectedValue: selectedValue,
      checkedValue: checkedValue,
      innerNodeConfig: innerNodeConfig,
      filterMethod: filterMethod,
      filterNode: filterNode,
      emptyText: emptyText,
      defaultExpandAll: defaultExpandAll,
      handleNodeClick: handleNodeClick,
      handleChekced: handleChekced
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-tree-select/components/TreeWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TreeWrappervue_type_script_lang_js_ = (TreeWrappervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tree-select/components/TreeWrapper.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_TreeWrappervue_type_script_lang_js_,
  TreeWrappervue_type_template_id_778bb6d1_render,
  TreeWrappervue_type_template_id_778bb6d1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TreeWrapper = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/components/ViewWrapper.vue?vue&type=template&id=69839db4&
var ViewWrappervue_type_template_id_69839db4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleShowPopover}},[(_vm.readonly)?_c('div',{staticClass:"read-wrapper"},[_vm._v("\n        "+_vm._s(_vm.selectedText)+"\n    ")]):(!_vm.multiple)?_c('mtd-input',{ref:"input",attrs:{"clearable":_vm.clearable && !!_vm.label,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"suffix-icon":_vm.inputIcon},on:{"input":_vm.setKeyword,"clear":_vm.clearValue},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}}):_c('tag-wrapper',{ref:"tagWrapper",attrs:{"tag-data":_vm.tagData,"disabled":_vm.disabled}})],1)}
var ViewWrappervue_type_template_id_69839db4_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-tree-select/components/ViewWrapper.vue?vue&type=template&id=69839db4&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/components/TagWrapper.vue?vue&type=template&id=20044fc8&
var TagWrappervue_type_template_id_20044fc8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tagWrapper",class:("mc-tree-select-tag mtd-input " + (_vm.disabled ? 'tag-disabled' : '')),on:{"mouseenter":function($event){return _vm.changeShowClose(true)},"mouseleave":function($event){return _vm.changeShowClose(false)}}},[_c('span',{staticClass:"tag-wrapper"},[_c('span',{staticClass:"tag-wrapper-inner"},[_vm._l((_vm.tagDataList),function(item){return _c('mtd-tag',{key:item[_vm.innerNodeConfig.value],attrs:{"size":"small","closable":!_vm.disabled},on:{"close":function($event){return _vm.deleteOneData(item)}}},[_vm._v("\n                "+_vm._s(_vm.render(item, 1))+"\n            ")])}),(_vm.showEllipsis && _vm.formatData.length > _vm.tagDataList.length)?_c('mtd-tag',{key:"showEllipsis",attrs:{"size":"small"}},[_vm._v("\n                "+_vm._s(_vm.render(_vm.formatData.length - _vm.tagDataList.length, 2))+"\n            ")]):_vm._e(),(!_vm.disabled || !_vm.innerValue || !_vm.innerValue.length)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],ref:"input",staticClass:"mtd-select-input",attrs:{"placeholder":_vm.innerPlaceholder,"disabled":_vm.disabled},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}):_vm._e()],2),_c('span',{staticClass:"icon-wrapper"},[(_vm.showClose)?_c('i',{staticClass:"mtdicon-error-circle icon-wrapper-inner",on:{"click":function($event){$event.stopPropagation();return _vm.clearAll.apply(null, arguments)}}}):_c('i',{class:_vm.icon})])])])}
var TagWrappervue_type_template_id_20044fc8_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-tree-select/components/TagWrapper.vue?vue&type=template&id=20044fc8&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/components/TagWrapper.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var TagWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'TagWrapper',
  props: {
    tagData: {
      type: [Object, Array],
      required: true,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var multiple = dataMap.multiple,
        clearable = dataMap.clearable,
        onlyLeaf = dataMap.onlyLeaf,
        mergeValue = dataMap.mergeValue,
        mergeTag = dataMap.mergeTag,
        placeholder = dataMap.placeholder,
        maxTagsNumber = dataMap.maxTagsNumber,
        showEllipsis = dataMap.showEllipsis,
        renderEllipsis = dataMap.renderEllipsis,
        innerNodeConfig = dataMap.innerNodeConfig,
        renderTag = dataMap.renderTag,
        clearValue = dataMap.clearValue,
        handleDeleteOne = dataMap.handleDeleteOne,
        setKeyword = dataMap.setKeyword;
    var keyword = Object(composition_api_["ref"])('');
    var showClose = Object(composition_api_["ref"])(false);
    var innerValue = Object(composition_api_["computed"])(function () {
      return getValue(props.tagData, onlyLeaf, mergeValue, multiple, innerNodeConfig);
    });
    var closeable = Object(composition_api_["computed"])(function () {
      return !props.disabled && clearable && innerValue.value && innerValue.value.length;
    });
    var innerPlaceholder = Object(composition_api_["computed"])(function () {
      return !props.tagData || !props.tagData.length ? placeholder : '';
    });
    var icon = Object(composition_api_["computed"])(function () {
      if (dataMap.visible) return 'mtdicon-up';
      return 'mtdicon-down';
    });
    var tagDataList = Object(composition_api_["ref"])(props.tagData); // 对原始tag数据进行处理

    var formatData = Object(composition_api_["computed"])(function () {
      return getTags(props.tagData, mergeTag, onlyLeaf);
    });

    var deleteOneData = function deleteOneData(item) {
      handleDeleteOne(item);
    };

    var clearAll = function clearAll(e) {
      e.preventDefault();
      clearValue();
    };

    var render = function render(item, type) {
      if (type === 1) {
        if (renderTag && typeof renderTag === 'function') {
          return renderTag(item);
        }

        return item[innerNodeConfig.label];
      } else {
        if (renderEllipsis && typeof renderEllipsis === 'function') {
          return renderEllipsis(item);
        }

        return "+".concat(item);
      }
    };

    var changeShowClose = function changeShowClose(flag) {
      showClose.value = closeable.value && flag;
    };

    Object(composition_api_["watch"])(formatData, function (val) {
      if (showEllipsis) {
        tagDataList.value = val.slice(0, maxTagsNumber);
      } else {
        tagDataList.value = val;
      }
    });
    Object(composition_api_["watch"])(keyword, function (val) {
      setKeyword(val);
    });
    return {
      keyword: keyword,
      innerValue: innerValue,
      innerPlaceholder: innerPlaceholder,
      innerNodeConfig: innerNodeConfig,
      icon: icon,
      formatData: formatData,
      tagDataList: tagDataList,
      showClose: showClose,
      showEllipsis: showEllipsis,
      clearAll: clearAll,
      deleteOneData: deleteOneData,
      render: render,
      changeShowClose: changeShowClose
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-tree-select/components/TagWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TagWrappervue_type_script_lang_js_ = (TagWrappervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-tree-select/components/TagWrapper.vue





/* normalize component */

var TagWrapper_component = Object(componentNormalizer["a" /* default */])(
  components_TagWrappervue_type_script_lang_js_,
  TagWrappervue_type_template_id_20044fc8_render,
  TagWrappervue_type_template_id_20044fc8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TagWrapper = (TagWrapper_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/components/ViewWrapper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ViewWrappervue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'ViewWrapper',
  components: {
    TagWrapper: TagWrapper
  },
  props: {
    // 选中的节点的数据
    tagData: {
      type: [Object, Array],
      required: true,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Number, String, Array],
      default: '',
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var dataMap = Object(composition_api_["inject"])('dataMap');
    var multiple = dataMap.multiple,
        clearable = dataMap.clearable,
        readonly = dataMap.readonly,
        placeholder = dataMap.placeholder,
        innerNodeConfig = dataMap.innerNodeConfig,
        renderTag = dataMap.renderTag,
        showPopover = dataMap.showPopover,
        clearValue = dataMap.clearValue,
        setKeyword = dataMap.setKeyword;
    var label = Object(composition_api_["ref"])('');
    var tagWrapper = Object(composition_api_["ref"])(null);
    var inputIcon = Object(composition_api_["computed"])(function () {
      if (dataMap.visible) return 'mtdicon-up';
      return 'mtdicon-down';
    });

    var getSelectedText = function getSelectedText() {
      if (multiple && props.tagData && props.tagData.length) {
        return props.tagData.map(function (item) {
          return item[innerNodeConfig.label];
        }).join(',');
      }

      return label.value;
    };

    var selectedText = Object(composition_api_["computed"])(function () {
      return getSelectedText();
    });

    var handleShowPopover = function handleShowPopover() {
      // 如果是单选，并且不可用状态 或 只读模式 不触发弹窗
      if (!multiple && props.disabled || readonly) return;
      showPopover();
    };

    Object(composition_api_["watch"])(function () {
      return props.tagData;
    }, function (val) {
      if (!multiple && renderTag && typeof renderTag === 'function') {
        label.value = renderTag(val);
      } else {
        label.value = val && val[innerNodeConfig.label] || props.value;
      }
    });
    return {
      label: label,
      multiple: multiple,
      clearable: clearable,
      readonly: readonly,
      placeholder: placeholder,
      inputIcon: inputIcon,
      tagWrapper: tagWrapper,
      selectedText: selectedText,
      clearValue: clearValue,
      setKeyword: setKeyword,
      handleShowPopover: handleShowPopover
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-tree-select/components/ViewWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ViewWrappervue_type_script_lang_js_ = (ViewWrappervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-tree-select/components/ViewWrapper.vue





/* normalize component */

var ViewWrapper_component = Object(componentNormalizer["a" /* default */])(
  components_ViewWrappervue_type_script_lang_js_,
  ViewWrappervue_type_template_id_69839db4_render,
  ViewWrappervue_type_template_id_69839db4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ViewWrapper = (ViewWrapper_component.exports);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./composables/useDispatch.js
var useDispatch = __webpack_require__("2568");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./components/mc-tree-select/composable/useTreeSelect.js









var useTreeSelect_useTreeSelect = function useTreeSelect(props, _ref, proxy) {
  var emit = _ref.emit;
  var innerValue = Object(composition_api_["ref"])('');
  var visible = Object(composition_api_["ref"])(false);
  var treeWrapper = Object(composition_api_["ref"])(null);
  var keyword = Object(composition_api_["ref"])('');
  var container = Object(composition_api_["ref"])(null);
  var popover = Object(composition_api_["ref"])(null);
  var startClickElement = Object(composition_api_["ref"])([]);
  var tagData = Object(composition_api_["ref"])([]);
  var innerDisabled = Object(composition_api_["computed"])(function () {
    return props.disabled;
  });
  var innerData = Object(composition_api_["ref"])([]); // 树形数据

  var initialInnerData = Object(composition_api_["ref"])([]); // 原始树形数据

  var innerNodeConfig = Object(composition_api_["reactive"])({
    children: 'children',
    label: 'name',
    value: 'id'
  });

  var initNodeConfig = function initNodeConfig() {
    Object.assign(innerNodeConfig, props.nodeConfig);
  };

  var setKeyword = function setKeyword(word) {
    emit('filter', word);
    keyword.value = word;
  };

  var showPopover = function showPopover() {
    visible.value = true;
  };

  var closePopover = function closePopover() {
    visible.value = false;
  };

  var handleBeforeClick = function handleBeforeClick(e) {
    startClickElement.value = e;
  };

  var triggerClick = function triggerClick(e) {
    if (!visible.value && !innerDisabled.value) {
      return;
    }

    if (container.value && popover.value && container.value.contains && popover.value.contains && !container.value.contains(startClickElement.value.target) && !popover.value.contains(startClickElement.value.target) && !container.value.contains(e.target) && !popover.value.contains(e.target)) closePopover();
  };

  var changeValue = function changeValue(data, needEmit) {
    var value = getValue(data, props.onlyLeaf, props.mergeValue, props.multiple, innerNodeConfig);
    var items = getItems(data, props.onlyLeaf, props.mergeValue, props.multiple);

    if (props.multiple) {
      items = items.map(function (item) {
        item = Object(tools_["cloneDeep"])(item) || {};
        delete item.children;
        delete item.disabled;
        delete item.selfDisabled;
        return item;
      });
    } else if (items) {
      items = Object(tools_["cloneDeep"])(items);
      delete items.children;
      delete items.disabled;
      delete items.selfDisabled;
    }

    innerValue.value = value;
    tagData.value = data;

    if (needEmit) {
      emit('input', value);
      emit('change', value, items, Object(tools_["cloneDeep"])(data));
      Object(useDispatch["a" /* default */])(proxy, 'MtdFormItem', 'formChange', value);
    }
  };

  var selectAll = function selectAll() {
    if (props.multiple) changeValue(props.data, true);
  };

  var getSelectedValue = function getSelectedValue() {
    if (props.multiple) {
      var selectedData = getItems(tagData.value, props.onlyLeaf, props.mergeValue, true);

      var _items = selectedData.map(function (item) {
        delete item.children;
        delete item.disabled;
        delete item.selfDisabled;
        return item;
      });

      return {
        value: innerValue.value,
        items: _items
      };
    }

    var items = Object(tools_["cloneDeep"])(tagData.value);
    delete items.children;
    delete items.disabled;
    delete items.selfDisabled;
    return {
      value: innerValue.value,
      items: items
    };
  };

  var getSelectedTags = function getSelectedTags() {
    if (!props.multiple) return {};
    var selectedTag = getTags(Object(tools_["cloneDeep"])(tagData.value), props.mergeTag, props.onlyLeaf);
    var items = selectedTag.map(function (item) {
      delete item.children;
      delete item.disabled;
      delete item.selfDisabled;
      return item;
    });
    return {
      value: innerValue.value,
      items: items
    };
  }; // 遍历树形数据，对数据进行删除


  var treeEach = function treeEach(node, info) {
    info.nodeCount += 1;

    if (node.children) {
      node.children.forEach(function (item) {
        return treeEach(item, info);
      });
    } else {
      // 计算有多少个叶子节点
      info.leafCount += 1;
      if (!info.firstLeaf) info.firstLeaf = node;
    }
  };

  var handleDeleteOne = function handleDeleteOne(item) {
    if (!item.children || props.checkStrictly) {
      // 如果是普通删除，直接删除该点 (非checkbox选择的节点删除和叶子节点删除) 或取消父子联动选择的情况下只删除单个tag
      tagData.value = tagData.value.filter(function (item2) {
        return item2[innerNodeConfig.value] !== item[innerNodeConfig.value];
      });
    } else {
      // 需要删除该点下面的所有叶子节点（checkbox选择的叶子节点删除）
      var info = {
        nodeCount: 0,
        leafCount: 0,
        firstLeaf: undefined
      };
      treeEach(item, info); // 因为父子节点是按照顺序相连的，所以可以根据子节点的个数使用splice删除

      var firstNodeIndex = tagData.value.findIndex(function (v) {
        return v.id === item.id;
      });
      tagData.value.splice(firstNodeIndex, info.nodeCount);
    }

    changeValue(tagData.value, true);
  };

  var clearValue = function clearValue() {
    if (props.multiple) {
      tagData.value = [];
    } else {
      tagData.value = {};
    }

    changeValue(tagData.value, true);
  };

  var handleValueChange = function handleValueChange(val) {
    var isCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!Object(tools_["isEqual"])(innerValue.value, val) || isCreate) {
      innerValue.value = val;

      if (props.multiple) {
        tagData.value = (val || []).map(function (item) {
          var _ref2;

          return findNodeInTree(item, initialInnerData.value, innerNodeConfig.value) || (_ref2 = {}, Object(defineProperty["a" /* default */])(_ref2, innerNodeConfig.value, item), Object(defineProperty["a" /* default */])(_ref2, innerNodeConfig.label, item), Object(defineProperty["a" /* default */])(_ref2, "beUndefined", true), _ref2);
        });
      } else {
        var _ref3;

        // 单选
        var items = (props.data || []).find(function (item) {
          return item[innerNodeConfig.value] === val;
        });
        tagData.value = items || (_ref3 = {}, Object(defineProperty["a" /* default */])(_ref3, innerNodeConfig.value, val), Object(defineProperty["a" /* default */])(_ref3, innerNodeConfig.label, val), Object(defineProperty["a" /* default */])(_ref3, "beUndefined", true), _ref3);
      }
    }
  }; // 树形data


  var getTreeData = function getTreeData() {
    var needHandleValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var data = Object(tools_["cloneDeep"])(props.data);
    var result = [];
    data.forEach(function (item) {
      // 查找父节点
      var parent = data.find(function (v) {
        return v[innerNodeConfig.value] === item.parentId;
      }); // 记录节点自身的disabled，用于切换全局disabled时的状态

      item.selfDisabled = item.disabled || parent && parent.selfDisabled;
      item.disabled = item.selfDisabled || props.disabled;

      if (props.renderNode && typeof props.renderNode === 'function') {
        item[innerNodeConfig.label] = props.renderNode(item);
      }

      if (parent && parent.children) {
        parent.children.push(item);
      } else if (parent) {
        parent.children = [item];
      } else {
        // 当找不到parent时,说明此时的item是第一级
        result.push(item);
      }
    });
    initialInnerData.value = result;
    innerData.value = Object(tools_["cloneDeep"])(initialInnerData.value); // 如果重新渲染了数据，需要重新渲染选中项

    if (props.value && needHandleValue) {
      handleValueChange(props.value, true);
    }
  }; // 处理传入的disabled变化, hasSelfDisabled标识是否有selfDisabled


  var handleChangeDisabled = function handleChangeDisabled(data, val) {
    var hasSelfDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    data.forEach(function (item) {
      if (!hasSelfDisabled) {
        item.selfDisabled = item.disabled;
      }

      if (!item.selfDisabled) {
        item.disabled = val;
      }

      if (item.children) {
        handleChangeDisabled(item.children, val, hasSelfDisabled);
      }
    });
  };

  var initTree = function initTree() {
    initNodeConfig();
    getTreeData(false);
  };

  Object(composition_api_["onMounted"])(function () {
    // 事件监听，点击关闭下拉框
    window.addEventListener('mousedown', handleBeforeClick);
    window.addEventListener('mouseup', triggerClick);
    if (props.value) handleValueChange(props.value, true);
  });
  Object(composition_api_["onBeforeUnmount"])(function () {
    window.removeEventListener('mousedown', handleBeforeClick);
    window.removeEventListener('mouseup', triggerClick);
  });
  initTree();
  Object(composition_api_["watch"])(function () {
    return props.value;
  }, function (val) {
    handleValueChange(val);
  });
  Object(composition_api_["watch"])(visible, function (val) {
    if (val) {
      emit('focus');
    } else {
      emit('blur');
    }
  });
  Object(composition_api_["watch"])(function () {
    return props.data;
  }, function () {
    getTreeData();
  });
  Object(composition_api_["watch"])(function () {
    return props.disabled;
  }, function (val) {
    handleChangeDisabled(innerData.value, val);
  });
  return {
    visible: visible,
    innerValue: innerValue,
    innerDisabled: innerDisabled,
    innerNodeConfig: innerNodeConfig,
    innerData: innerData,
    initialInnerData: initialInnerData,
    container: container,
    popover: popover,
    treeWrapper: treeWrapper,
    keyword: keyword,
    tagData: tagData,
    setKeyword: setKeyword,
    showPopover: showPopover,
    closePopover: closePopover,
    selectAll: selectAll,
    clearValue: clearValue,
    changeValue: changeValue,
    handleDeleteOne: handleDeleteOne,
    handleValueChange: handleValueChange,
    getSelectedValue: getSelectedValue,
    getSelectedTags: getSelectedTags
  };
};

/* harmony default export */ var composable_useTreeSelect = (useTreeSelect_useTreeSelect);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-select/mc-tree-select.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mc_tree_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McTreeSelect',
  components: {
    TreeWrapper: TreeWrapper,
    ViewWrapper: ViewWrapper
  },
  props: {
    value: {
      type: [Number, String, Array],
      default: '',
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 是否只选择子节点
    onlyLeaf: {
      type: Boolean,
      default: false
    },
    // 数据是否向上收敛，即所有子选项选中时，只返回父节点的数据
    mergeValue: {
      type: Boolean,
      default: false
    },
    // 展示tag向上收敛，即所有子选项选中时，展示父节点的tag
    mergeTag: {
      type: Boolean,
      default: true
    },
    // 渲染选中项展示tag的方法，仅在多选时有效
    // eslint-disable-next-line vue/require-default-prop
    renderTag: {
      type: Function
    },
    // eslint-disable-next-line vue/require-default-prop
    nodeConfig: {
      type: Object
    },
    // 判断节点是否可选的方法
    // eslint-disable-next-line vue/require-default-prop
    editableMethod: {
      type: Function
    },
    // 自定义渲染展示的树形节点的方法
    // eslint-disable-next-line vue/require-default-prop
    renderNode: {
      type: Function
    },
    // 自定义关键字搜索方法
    // eslint-disable-next-line vue/require-default-prop
    filterMethod: {
      type: Function
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // maxLevel: {
    //     type: Number,
    //     default: Infinity,
    // },
    // selectLevel: {
    //     type: [Number, String, Array],
    //     default: '',
    // },
    maxTagsNumber: {
      type: Number,
      default: 1
    },
    // 是否缩略展示多选
    showEllipsis: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/require-default-prop
    renderEllipsis: {
      type: Function
    },
    // 是否默认展开所有节点
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var _useTreeSelect = composable_useTreeSelect(props, ctx, proxy),
        visible = _useTreeSelect.visible,
        innerValue = _useTreeSelect.innerValue,
        innerDisabled = _useTreeSelect.innerDisabled,
        innerNodeConfig = _useTreeSelect.innerNodeConfig,
        innerData = _useTreeSelect.innerData,
        container = _useTreeSelect.container,
        popover = _useTreeSelect.popover,
        treeWrapper = _useTreeSelect.treeWrapper,
        keyword = _useTreeSelect.keyword,
        tagData = _useTreeSelect.tagData,
        setKeyword = _useTreeSelect.setKeyword,
        showPopover = _useTreeSelect.showPopover,
        closePopover = _useTreeSelect.closePopover,
        selectAll = _useTreeSelect.selectAll,
        clearValue = _useTreeSelect.clearValue,
        changeValue = _useTreeSelect.changeValue,
        handleValueChange = _useTreeSelect.handleValueChange,
        handleDeleteOne = _useTreeSelect.handleDeleteOne,
        getSelectedValue = _useTreeSelect.getSelectedValue,
        getSelectedTags = _useTreeSelect.getSelectedTags;

    Object(composition_api_["provide"])('dataMap', proxy);
    return {
      visible: visible,
      innerValue: innerValue,
      innerDisabled: innerDisabled,
      innerNodeConfig: innerNodeConfig,
      innerData: innerData,
      container: container,
      popover: popover,
      treeWrapper: treeWrapper,
      keyword: keyword,
      tagData: tagData,
      setKeyword: setKeyword,
      showPopover: showPopover,
      closePopover: closePopover,
      selectAll: selectAll,
      clearValue: clearValue,
      changeValue: changeValue,
      handleValueChange: handleValueChange,
      handleDeleteOne: handleDeleteOne,
      getSelectedValue: getSelectedValue,
      getSelectedTags: getSelectedTags
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-tree-select/mc-tree-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tree_select_mc_tree_selectvue_type_script_lang_js_ = (mc_tree_selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-tree-select/mc-tree-select.vue





/* normalize component */

var mc_tree_select_component = Object(componentNormalizer["a" /* default */])(
  mc_tree_select_mc_tree_selectvue_type_script_lang_js_,
  mc_tree_selectvue_type_template_id_02b28a7f_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tree_select = (mc_tree_select_component.exports);
// CONCATENATED MODULE: ./components/mc-tree-select/index.js


/* istanbul ignore next */

mc_tree_select.install = function (Vue) {
  Vue.component(mc_tree_select.name, mc_tree_select);
};

/* harmony default export */ var components_mc_tree_select = __webpack_exports__["default"] = (mc_tree_select);

/***/ }),

/***/ "980c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__("399f")
var EC = __webpack_require__("3337").ec
var parseKeys = __webpack_require__("2aee")
var curves = __webpack_require__("cd91")

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "98e6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("3fb5")
var MD5 = __webpack_require__("f576")
var RIPEMD160 = __webpack_require__("b5ca")
var sha = __webpack_require__("69f2")
var Base = __webpack_require__("6430")

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ "990b":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("9093");
var gOPS = __webpack_require__("2621");
var anObject = __webpack_require__("cb7c");
var Reflect = __webpack_require__("7726").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "9a85":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("fa49");

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),

/***/ "9aa9":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "9ab1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-footer/mc-footer.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_footervue_type_script_lang_js_ = ({
  name: 'McFooter',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-footer', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-footer/mc-footer.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_footer_mc_footervue_type_script_lang_js_ = (mc_footervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-footer/mc-footer.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_footer_mc_footervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_footer = (component.exports);
// CONCATENATED MODULE: ./components/mc-footer/index.js


/* istanbul ignore next */

mc_footer.install = function (Vue) {
  Vue.component(mc_footer.name, mc_footer);
};

/* harmony default export */ var components_mc_footer = __webpack_exports__["default"] = (mc_footer);

/***/ }),

/***/ "9ae0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  encode: __webpack_require__("50c1").encode,
  decode: __webpack_require__("3dbb").decode
}


/***/ }),

/***/ "9b23":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c4a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9c80":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "9d94":
/***/ (function(module, exports, __webpack_require__) {

const Mode = __webpack_require__("bbf0")

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "9ea3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useRemote; });
/* harmony import */ var core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8e6e");
/* harmony import */ var core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ac6a");
/* harmony import */ var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("456d");
/* harmony import */ var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("96cf");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("3b8d");
/* harmony import */ var _opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("bd86");
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7f7f");
/* harmony import */ var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7618");
/* harmony import */ var _mcfe_tools__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7196");
/* harmony import */ var _mcfe_tools__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_mcfe_tools__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_9__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var _processEnumData = function _processEnumData(data, dictCode) {
  if (!dictCode || Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(data) !== 'object') return data;
  if (!data[dictCode]) return data;
  data = data[dictCode].dictionaryValueList.map(function (item) {
    return {
      label: item.name,
      value: item.key
    };
  });
  return data;
};

var _genDefaultRemoteConfig = function _genDefaultRemoteConfig(url) {
  return {
    type: 'hPost',
    url: url,
    params: {},
    options: {
      cache: true
    }
  };
};

var _genDictRemoteConfig = function _genDictRemoteConfig(dictCode) {
  return {
    type: 'hPost',
    url: '/api/m/tms/mapi/dictionary/batchGetDictionaryAndValue',
    params: {
      dicCodes: [dictCode]
    },
    options: {
      cache: true
    }
  };
};

function useRemote(source, context) {
  var lifecycle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var remoteConfig = {};
  var dictCode = '';

  var _fetchData; // 添加切点


  var responseProcessor = source.responseProcessor || function (res) {
    return res;
  };

  var buildParams = source.buildParams || function (params, extendsParams) {
    return _objectSpread({}, params, {}, extendsParams);
  };

  var beforeResponseProcessor = lifecycle.beforeResponseProcessor,
      afterResponseProcessor = lifecycle.afterResponseProcessor;

  var fetchData =
  /*#__PURE__*/
  function () {
    var _ref = Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var extendsParams,
          _cloneDeep,
          _cloneDeep$type,
          type,
          _cloneDeep$url,
          url,
          _cloneDeep$params,
          params,
          _remoteConfig,
          _remoteConfig$options,
          options,
          res,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              extendsParams = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.prev = 1;
              _cloneDeep = Object(_mcfe_tools__WEBPACK_IMPORTED_MODULE_8__["cloneDeep"])(remoteConfig), _cloneDeep$type = _cloneDeep.type, type = _cloneDeep$type === void 0 ? 'hPost' : _cloneDeep$type, _cloneDeep$url = _cloneDeep.url, url = _cloneDeep$url === void 0 ? '' : _cloneDeep$url, _cloneDeep$params = _cloneDeep.params, params = _cloneDeep$params === void 0 ? {} : _cloneDeep$params;
              _remoteConfig = remoteConfig, _remoteConfig$options = _remoteConfig.options, options = _remoteConfig$options === void 0 ? {} : _remoteConfig$options;

              if (_fetchData) {
                _context.next = 12;
                break;
              }

              if (url) {
                _context.next = 8;
                break;
              }

              console.error('请求未配置url');
              return _context.abrupt("return", []);

            case 8:
              if (!(Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(params) !== 'object')) {
                _context.next = 11;
                break;
              }

              console.error('请求参数[params]格式配置错误');
              return _context.abrupt("return", []);

            case 11:
              if (Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(options) !== 'object') {
                console.warn('请求参数[options]格式配置错误');
                options = {};
              }

            case 12:
              if (!_fetchData) {
                _context.next = 18;
                break;
              }

              _context.next = 15;
              return _fetchData(extendsParams);

            case 15:
              res = _context.sent;
              _context.next = 21;
              break;

            case 18:
              _context.next = 20;
              return vue__WEBPACK_IMPORTED_MODULE_9___default.a.prototype["$".concat(type)](url, buildParams(params, extendsParams), options);

            case 20:
              res = _context.sent;

            case 21:
              res = _processEnumData(res, dictCode);

              if (!(typeof beforeResponseProcessor === 'function')) {
                _context.next = 28;
                break;
              }

              _context.next = 25;
              return beforeResponseProcessor(res);

            case 25:
              _context.t0 = _context.sent;
              _context.next = 29;
              break;

            case 28:
              _context.t0 = res;

            case 29:
              res = _context.t0;
              _context.next = 32;
              return responseProcessor(res);

            case 32:
              res = _context.sent;

              if (!(typeof afterResponseProcessor === 'function')) {
                _context.next = 39;
                break;
              }

              _context.next = 36;
              return afterResponseProcessor(res);

            case 36:
              _context.t1 = _context.sent;
              _context.next = 40;
              break;

            case 39:
              _context.t1 = res;

            case 40:
              res = _context.t1;
              context.emit('loaded', Object(_mcfe_tools__WEBPACK_IMPORTED_MODULE_8__["cloneDeep"])(res));
              return _context.abrupt("return", res);

            case 45:
              _context.prev = 45;
              _context.t2 = _context["catch"](1);
              console.error('useRemote error----->>>', _context.t2);
              throw _context.t2;

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 45]]);
    }));

    return function fetchData() {
      return _ref.apply(this, arguments);
    };
  }();

  if (Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(source) === 'object' && !Array.isArray(source)) {
    var dictCodeFromConf = source.dictCode,
        ajax = source.ajax;

    if (dictCodeFromConf) {
      dictCode = dictCodeFromConf;
      remoteConfig = _genDictRemoteConfig(dictCode);
    } else if (typeof ajax === 'string') {
      remoteConfig = _genDefaultRemoteConfig(ajax);
    } else if (typeof ajax === 'function') {
      _fetchData = ajax;
    } else if (Object(_opt_jenkins_workspace_6070583_data_fe_astro_component_manage_test_node_modules_babel_runtime_corejs2_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ajax) === 'object') {
      remoteConfig = Object(_mcfe_tools__WEBPACK_IMPORTED_MODULE_8__["cloneDeep"])(ajax);
    } else {
      return [];
    }
  } else {
    console.error('远程请求参数不合法');
  }

  return {
    fetchData: fetchData
  };
}

/***/ }),

/***/ "9f26":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ "9f9d":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("f28c")))

/***/ }),

/***/ "9ffa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITF14 = exports.ITF = undefined;

var _ITF = __webpack_require__("3c7c");

var _ITF2 = _interopRequireDefault(_ITF);

var _ITF3 = __webpack_require__("07df");

var _ITF4 = _interopRequireDefault(_ITF3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ITF = _ITF2.default;
exports.ITF14 = _ITF4.default;

/***/ }),

/***/ "a043":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__("fa49");

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__("975a");

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),

/***/ "a099":
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__("206d")
exports.pbkdf2Sync = __webpack_require__("e07b")


/***/ }),

/***/ "a146":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "a159":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("e4ae");
var dPs = __webpack_require__("7e90");
var enumBugKeys = __webpack_require__("1691");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("1ec9")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("32fc").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "a15e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__("fa49");

var _validator = __webpack_require__("8c44");

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__("9c4a");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),

/***/ "a226":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-radio/mc-radio.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_radiovue_type_script_lang_js_ = ({
  name: 'McRadio',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-radio组件已经弃用，请使用mc-choice组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/aWRcgaz4faYOZ7ubzF_33', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-radio', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-radio/mc-radio.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_radio_mc_radiovue_type_script_lang_js_ = (mc_radiovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-radio/mc-radio.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_radio_mc_radiovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_radio = (component.exports);
// CONCATENATED MODULE: ./components/mc-radio/index.js


/* istanbul ignore next */

mc_radio.install = function (Vue) {
  Vue.component(mc_radio.name, mc_radio);
};

/* harmony default export */ var components_mc_radio = __webpack_exports__["default"] = (mc_radio);

/***/ }),

/***/ "a22a":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("d864");
var call = __webpack_require__("b0dc");
var isArrayIter = __webpack_require__("3702");
var anObject = __webpack_require__("e4ae");
var toLength = __webpack_require__("b447");
var getIterFn = __webpack_require__("7cd6");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "a255":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("3fb5")
var Hash = __webpack_require__("b672")
var Buffer = __webpack_require__("8707").Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ "a25f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "a2b0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = linearizeEncodings;

// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
// Convert to [1-1, 1-2, 2, 3-1, 3-2]

function linearizeEncodings(encodings) {
	var linearEncodings = [];
	function nextLevel(encoded) {
		if (Array.isArray(encoded)) {
			for (var i = 0; i < encoded.length; i++) {
				nextLevel(encoded[i]);
			}
		} else {
			encoded.text = encoded.text || "";
			encoded.data = encoded.data || "";
			linearEncodings.push(encoded);
		}
	}
	nextLevel(encodings);

	return linearEncodings;
}

/***/ }),

/***/ "a2bc":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("4a9d");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "a2f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-autocomplete/mc-autocomplete.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_autocompletevue_type_script_lang_js_ = ({
  name: 'McAutocomplete',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-autocomplete', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  },
  methods: {
    focus: function focus() {
      var _this$$refs$selfRef;

      if (this.$refs.selfRef) return (_this$$refs$selfRef = this.$refs.selfRef).focus.apply(_this$$refs$selfRef, arguments);
    },
    blur: function blur() {
      var _this$$refs$selfRef2;

      if (this.$refs.selfRef) return (_this$$refs$selfRef2 = this.$refs.selfRef).blur.apply(_this$$refs$selfRef2, arguments);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-autocomplete/mc-autocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_autocomplete_mc_autocompletevue_type_script_lang_js_ = (mc_autocompletevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-autocomplete/mc-autocomplete.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_autocomplete_mc_autocompletevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_autocomplete = (component.exports);
// CONCATENATED MODULE: ./components/mc-autocomplete/index.js


/* istanbul ignore next */

mc_autocomplete.install = function (Vue) {
  Vue.component(mc_autocomplete.name, mc_autocomplete);
};

/* harmony default export */ var components_mc_autocomplete = __webpack_exports__["default"] = (mc_autocomplete);

/***/ }),

/***/ "a32f":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("3c7d"),
    isArray = __webpack_require__("e987");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "a356":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ "a399":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-transfer-panel/mc-transfer-panel.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_transfer_panelvue_type_script_lang_js_ = ({
  name: 'McTransferPanel',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-transfer-panel', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-transfer-panel/mc-transfer-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_transfer_panel_mc_transfer_panelvue_type_script_lang_js_ = (mc_transfer_panelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-transfer-panel/mc-transfer-panel.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_transfer_panel_mc_transfer_panelvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_transfer_panel = (component.exports);
// CONCATENATED MODULE: ./components/mc-transfer-panel/index.js


/* istanbul ignore next */

mc_transfer_panel.install = function (Vue) {
  Vue.component(mc_transfer_panel.name, mc_transfer_panel);
};

/* harmony default export */ var components_mc_transfer_panel = __webpack_exports__["default"] = (mc_transfer_panel);

/***/ }),

/***/ "a3c3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("63b6");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("9306") });


/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "a4bb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8aae");

/***/ }),

/***/ "a5b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("d8e8");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "a5d2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("c243");

var _encoder = __webpack_require__("5726");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_2#Encoding

var EAN2 = function (_Barcode) {
	_inherits(EAN2, _Barcode);

	function EAN2(data, options) {
		_classCallCheck(this, EAN2);

		return _possibleConstructorReturn(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
	}

	_createClass(EAN2, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{2}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			// Choose the structure based on the number mod 4
			var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
			return {
				// Start bits + Encode the two digits with 01 in between
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN2;
}(_Barcode3.default);

exports.default = EAN2;

/***/ }),

/***/ "a745":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("f410");

/***/ }),

/***/ "a7ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-panel/mc-panel.vue?vue&type=template&id=89d1ae08&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-panel"},[_c('div',{staticClass:"mc-panel-header"},[_c('div',{staticClass:"mc-panel-title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("title")],2),_c('div',{staticClass:"mc-panel-operator"},[_vm._t("operator")],2)]),_c('div',{staticClass:"mc-panel-content"},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-panel/mc-panel.vue?vue&type=template&id=89d1ae08&

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-panel/mc-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_panelvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McPanel',
  props: {
    /**
     *  title
     */
    title: {
      type: String,
      default: ''
    },

    /**
     *  title的高度，默认是40px
     */
    titleHeight: {
      type: String,
      default: 'auto'
    },

    /**
     *  title样式，style Object
     */
    titleStyle: {
      type: Object,
      default: null
    }
  }
}));
// CONCATENATED MODULE: ./components/mc-panel/mc-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_panel_mc_panelvue_type_script_lang_js_ = (mc_panelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-panel/mc-panel.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_panel_mc_panelvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_panel = (component.exports);
// CONCATENATED MODULE: ./components/mc-panel/index.js


/* istanbul ignore next */

mc_panel.install = function (Vue) {
  // @ts-ignore
  Vue.component(mc_panel.name, mc_panel);
};

/* harmony default export */ var components_mc_panel = __webpack_exports__["default"] = (mc_panel);

/***/ }),

/***/ "a7fa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ "a86e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-select/mc-poi-select.vue?vue&type=template&id=b8ba6700&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-poi-select"},[_c('mc-level-select',_vm._g(_vm._b({ref:"levelSelect",attrs:{"data":_vm.innerData,"value-key":_vm.innerValueKey,"tab-config":_vm.innerTabConfig,"multiple":_vm.multiple,"filter-placeholder":_vm.innerPlaceholder},on:{"tab-change":_vm.handleTabChange,"input":_vm.handleInput,"change":_vm.handleChange,"data-update":_vm.handleDataUpdate},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-level-select',_vm.$attrs,false),_vm.listeners))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-poi-select/mc-poi-select.vue?vue&type=template&id=b8ba6700&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("75fc");

// CONCATENATED MODULE: ./components/mc-poi-select/utils/index.js






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var utils_objectToTree = function objectToTree(obj, pickKeys) {
  var isTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (obj.children) {
    return obj;
  }

  var data = Object(tools_["omit"])(obj, pickKeys);
  var children = Object.keys(data).map(function (item) {
    return objectToTree(obj[item], pickKeys);
  });

  if (isTop) {
    return children;
  }

  return _objectSpread({}, Object(tools_["pick"])(obj, pickKeys), {
    children: children
  });
};

var utils_formatToTree = function formatToTree(data, config, options) {
  if (!data || !data.length || !config || !Array.isArray(config) || !config.length) {
    return [];
  }

  var groupMap = {};
  config = Object(toConsumableArray["a" /* default */])(config); // 把最后一个配置单独拿出来

  var lastConfig = config.splice(config.length - 1, 1)[0];
  var idWithLevel = options.idWithLevel;
  var lastTempMap = {};
  data.forEach(function (item) {
    var temp = groupMap;
    var level = 0;
    config.forEach(function (item2) {
      var itemId = idWithLevel ? "".concat(level).concat(item[item2.idName]) : item[item2.idName];

      if (!temp[itemId]) {
        // 如果不存在，添加一下。已经存在，就不用处理了。
        temp[itemId] = Object(defineProperty["a" /* default */])({
          _parentId: temp.id,
          id: itemId,
          label: item2.labelRender ? item2.labelRender(item) : item[item2.labelName]
        }, item2.idName, itemId);
      }

      level += 1;
      temp = temp[itemId];
    });

    var lastData = _objectSpread({}, item, {
      _parentId: temp.id,
      id: idWithLevel ? "".concat(level).concat(item[lastConfig.idName]) : item[lastConfig.idName],
      label: lastConfig.labelRender ? lastConfig.labelRender(item) : item[lastConfig.labelName]
    }); // 判断一下是否已经存在值相同的节点


    if (lastTempMap[lastData.id]) {
      return;
    }

    lastTempMap[lastData.id] = true;

    if (!temp.children) {
      temp.children = [lastData];
    } else {
      temp.children.push(lastData);
    }
  });

  if (!config.length) {
    // config只有一层，在splice后，长度为空
    // 直接返回列表
    return groupMap.children;
  }

  var pickKeys = ['id', 'label', '_parentId'].concat(config.map(function (item) {
    return item.idName;
  }));
  return utils_objectToTree(groupMap, pickKeys, true);
};
var formatValueToType = function formatValueToType(val, type) {
  // 设置数据类型为type类型
  if (!type || val === '' || val === undefined || val === null || Array.isArray(val) && !val.length) {
    // 没有类型/空/空数组
    return val;
  }

  if (Array.isArray(val)) {
    val = val.map(function (item) {
      return type === 'number' ? +item : "".concat(item);
    });
  } else {
    val = type === 'number' ? +val : "".concat(val);
  }

  return val;
};
// CONCATENATED MODULE: ./components/mc-poi-select/composable/useInit.js









function useInit_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function useInit_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useInit_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useInit_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var useInit_useInit = function useInit(props, _ref) {
  var emit = _ref.emit;

  var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
      proxy = _getCurrentInstance.proxy;

  var innerValue = Object(composition_api_["ref"])('');
  var sourceData = Object(composition_api_["ref"])([]);
  var intinalData = Object(composition_api_["ref"])([]);
  var innerLevelConfig = Object(composition_api_["ref"])([]);
  var innerValueKey = Object(composition_api_["ref"])('');
  var innerTabConfig = Object(composition_api_["ref"])([]);
  var initTabConfig = Object(composition_api_["ref"])([]);
  var levelSelect = Object(composition_api_["ref"])(null);
  var innerPlaceholder = Object(composition_api_["ref"])('请搜索门店');
  var innerValueType = Object(composition_api_["computed"])(function () {
    return props.valueType;
  });
  var useOrg = Object(composition_api_["computed"])(function () {
    return ['org', 'orgCity', 'orgRegion'].includes(props.mode);
  });
  var innerDisabledIds = Object(composition_api_["computed"])(function () {
    return props.disabledIds;
  });
  var listeners = Object(composition_api_["computed"])(function () {
    return Object(tools_["omit"])(proxy.$listeners, ['input', 'change', 'data-update']);
  });
  var innerFilterConfig = Object(composition_api_["computed"])(function () {
    return props.filterConfig;
  });
  var filterData = Object(composition_api_["ref"])([]); // 根据disabledIds 与 filterConfig进行过滤

  var filterList = function filterList(data) {
    var list = data.filter(function (item) {
      if (innerDisabledIds.value && innerDisabledIds.value.length && innerDisabledIds.value.includes(item[innerValueKey.value])) {
        item.disabled = true;
      }

      if (Object.keys(innerFilterConfig.value).length && Object.keys(innerFilterConfig.value).some(function (key) {
        return item.hasOwnProperty(key) && !innerFilterConfig.value[key].includes(item[key]);
      })) {
        return false;
      }

      return true;
    });
    list.forEach(function (item) {
      item[innerValueKey.value] = formatValueToType(item[innerValueKey.value], innerValueType.value);
    });
    return list;
  };

  var innerData = Object(composition_api_["computed"])(function () {
    return utils_formatToTree(filterData.value, innerLevelConfig.value, {});
  });

  var getTabConfig = function getTabConfig() {
    var tabConfig = [];

    if (props.mode === 'org') {
      tabConfig = [{
        label: '全部',
        filter: function filter() {
          return true;
        }
      }, {
        label: 'C1项目',
        filter: function filter(data) {
          return data.poiBizId === 2;
        }
      }, {
        label: 'C2项目',
        filter: function filter(data) {
          return data.poiBizId === 3;
        }
      }, {
        label: 'C3项目',
        filter: function filter(data) {
          return data.poiBizId === 4;
        }
      }, {
        label: '生鲜',
        filter: function filter(data) {
          return data.poiBizId === 1;
        }
      }];
    }

    if (props.mode === 'management') {
      tabConfig = [{
        label: '全部站点',
        filter: function filter() {
          return true;
        }
      }, {
        label: '正常营业',
        filter: function filter(data) {
          return data.subStatus === 1;
        }
      }, {
        label: '凌晨营业',
        filter: function filter(data) {
          return data.delayTimeStatus === 1;
        }
      }, {
        label: '暂停营业',
        filter: function filter(data) {
          return data.subStatus === 2;
        }
      }, {
        label: '筹建中',
        filter: function filter(data) {
          return data.subStatus === 3;
        }
      }, {
        label: '已闭店',
        filter: function filter(data) {
          return data.subStatus === 4;
        }
      }];
    }

    return tabConfig;
  };

  var getLevelConfigAndValueKey = function getLevelConfigAndValueKey() {
    var levelConfig = [{
      idName: 'regionOrgId',
      labelName: 'regionOrgName'
    }, // 大区
    {
      idName: 'cityOrgId',
      labelName: 'cityOrgName'
    }, // 组织城市
    {
      idName: 'poiId',
      labelName: 'poiName'
    } // 组织poi
    ];
    var valueKey = 'poiId';
    var placeholder = '请搜索门店';

    switch (props.mode) {
      case 'org':
        break;

      case 'orgCity':
        levelConfig = [{
          idName: 'regionOrgId',
          labelName: 'regionOrgName'
        }, {
          idName: 'cityOrgId',
          labelName: 'cityOrgName'
        }];
        valueKey = 'cityOrgId';
        placeholder = '请搜索城市';
        break;

      case 'orgRegion':
        levelConfig = [{
          idName: 'regionOrgId',
          labelName: 'regionOrgName'
        }];
        valueKey = 'regionOrgId';
        placeholder = '请搜索大区';
        break;

      case 'management':
        levelConfig = [{
          idName: 'managementCityId',
          labelName: 'managementCityName'
        }, // 经营城市
        {
          idName: 'stationClusterId',
          labelName: 'stationClusterName'
        }, // 站群
        {
          idName: 'poiId',
          labelName: 'poiName'
        } // 站点
        ];
        placeholder = '请搜索站点';
        break;

      case 'stationCluster':
        levelConfig = [{
          idName: 'managementCityId',
          labelName: 'managementCityName'
        }, {
          idName: 'stationClusterId',
          labelName: 'stationClusterName'
        }];
        valueKey = 'stationClusterId';
        placeholder = '请搜索站群';
        break;

      case 'managementCity':
        levelConfig = [{
          idName: 'managementCityId',
          labelName: 'managementCityName'
        }];
        valueKey = 'managementCityId';
        placeholder = '请搜索城市';
        break;

      default:
        break;
    }

    return {
      levelConfig: levelConfig,
      valueKey: valueKey,
      placeholder: placeholder
    };
  };

  var renderPoiId = function renderPoiId(data) {
    var list = data.map(function (item) {
      if (item.idName === 'poiId') {
        return useInit_objectSpread({}, item, {
          labelRender: function labelRender(v) {
            return "".concat(v.poiId, "-").concat(v.poiName);
          }
        });
      }

      return item;
    });
    return list;
  };

  var handleInput = function handleInput(val) {
    var value = formatValueToType(val, innerValueType.value);
    emit('input', value);
  };

  var handleChange = function handleChange(val, items) {
    var value = formatValueToType(val, innerValueType.value);
    emit('change', value, items);
  };

  var handleDataUpdate = function handleDataUpdate(val, items, data) {
    var value = formatValueToType(val, innerValueType.value);
    emit('data-update', value, items, data);
  };

  var handleTabChange = function handleTabChange() {
    if (props.multiple && props.selectSingleTab) {
      emit('input', []);
      emit('change', []);
    }
  };

  var fetchData =
  /*#__PURE__*/
  function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var url, type, params, data, list;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (useOrg.value) {
                url = props.usePermission ? '/api/auth/org/getRegionAndPoiModelMapWithPermission' : '/api/auth/org/getRegionAndPoiModelMap';
                type = 'hGet';
                params = {
                  needRdc: 0,
                  bizId: 0
                };
              } else {
                url = '/api/poi/city/aggregation/stationCluster/list/search';
                type = 'hPost';
                params = {
                  includeTestPoi: true,
                  usePermission: props.usePermission,
                  // 返回数据是否包含延时营业标识
                  needOpenFlag: props.poiMidnightOpen
                };
              }

              _context.next = 4;
              return proxy["$".concat(type)](url, params, {
                cache: true
              });

            case 4:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = {};

            case 7:
              data = _context.t0;
              list = useOrg.value ? data.regionAndPOiList : data.list;

              if (!(props.responseProcessor && typeof props.responseProcessor === 'function')) {
                _context.next = 18;
                break;
              }

              _context.next = 12;
              return props.responseProcessor(list);

            case 12:
              _context.t1 = _context.sent;

              if (_context.t1) {
                _context.next = 15;
                break;
              }

              _context.t1 = [];

            case 15:
              intinalData.value = _context.t1;
              _context.next = 19;
              break;

            case 18:
              intinalData.value = Object(tools_["cloneDeep"])(list) || [];

            case 19:
              emit('loaded', intinalData.value);
              sourceData.value = Object(tools_["cloneDeep"])(intinalData.value);
              filterData.value = filterList(Object(tools_["cloneDeep"])(sourceData.value));
              Object(composition_api_["nextTick"])(function () {
                if (props.selectFirst) {
                  var item = props.multiple ? [filterData.value[0]] : filterData.value[0];
                  var value = props.multiple ? [item[0][innerValueKey.value]] : item[innerValueKey.value];
                  handleInput(value);
                  handleChange(value, item);
                }

                innerTabConfig.value = innerTabConfig.value.filter(function (item) {
                  return !item.filter || filterData.value.some(function (v) {
                    return item.filter(v);
                  });
                });
              });
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t2 = _context["catch"](0);
              console.log(_context.t2);
              innerTabConfig.value = [];

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 25]]);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var selectAll = function selectAll() {
    if (!props.multiple) {
      return;
    }

    levelSelect.value.handleSelectAll();
  };

  var resetOption = function resetOption(fn) {
    sourceData.value = fn(Object(tools_["cloneDeep"])(intinalData.value));
  };

  var init = function init() {
    if (Array.isArray(props.levelConfig) && props.levelConfig.length) {
      innerLevelConfig.value = props.levelConfig;
      innerValueKey.value = props.valueKey || 'poiId';
    } else {
      var _getLevelConfigAndVal = getLevelConfigAndValueKey(),
          levelConfig = _getLevelConfigAndVal.levelConfig,
          valueKey = _getLevelConfigAndVal.valueKey,
          placeholder = _getLevelConfigAndVal.placeholder;

      innerLevelConfig.value = levelConfig;
      innerValueKey.value = props.valueKey || valueKey;
      innerPlaceholder.value = placeholder;
    }

    if (props.showPoiId) innerLevelConfig.value = renderPoiId(innerLevelConfig.value);

    if (!props.tabConfig) {
      // tabConfig为false
      innerTabConfig.value = [];
    } else if (Array.isArray(props.tabConfig) && props.tabConfig.length) {
      // 自定义tabConfig
      innerTabConfig.value = props.tabConfig;
    } else {
      // 默认tabConfig
      innerTabConfig.value = getTabConfig();
    }

    initTabConfig.value = innerTabConfig.value;
    fetchData();
  };

  init();
  Object(composition_api_["watch"])(function () {
    return props.value;
  }, function (val) {
    innerValue.value = val;
  }, {
    immediate: true
  });
  Object(composition_api_["watch"])(filterData, function (val) {
    if (initTabConfig.value.length) {
      innerTabConfig.value = initTabConfig.value.filter(function (item) {
        return !item.filter || val.some(function (v) {
          return item.filter(v);
        });
      });
    }
  });
  Object(composition_api_["watch"])([innerFilterConfig, innerDisabledIds], function (newVal, oldVal) {
    if (!Object(tools_["isEqual"])(newVal, oldVal)) {
      filterData.value = filterList(Object(tools_["cloneDeep"])(sourceData.value));
    }
  }, {
    deep: true
  });
  return {
    innerValue: innerValue,
    innerData: innerData,
    innerValueKey: innerValueKey,
    innerLevelConfig: innerLevelConfig,
    innerTabConfig: innerTabConfig,
    listeners: listeners,
    levelSelect: levelSelect,
    innerPlaceholder: innerPlaceholder,
    resetOption: resetOption,
    handleInput: handleInput,
    handleChange: handleChange,
    handleDataUpdate: handleDataUpdate,
    handleTabChange: handleTabChange,
    selectAll: selectAll
  };
};

/* harmony default export */ var composable_useInit = (useInit_useInit);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-poi-select/mc-poi-select.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_poi_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McPoiSelect',
  props: {
    value: {
      type: [String, Number, Array],
      required: true,
      default: ''
    },
    valueType: {
      type: String,
      default: 'number'
    },
    usePermission: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    responseProcessor: {
      type: Function,
      default: null
    },
    tabConfig: {
      type: [Boolean, Array],
      default: function _default() {
        return [];
      }
    },
    mode: {
      type: String,
      default: 'org'
    },
    levelConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectFirst: {
      type: Boolean,
      default: false
    },
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    valueKey: {
      type: String,
      default: ''
    },
    selectSingleTab: {
      type: Boolean,
      default: false
    },
    showPoiId: {
      type: Boolean,
      default: false
    },
    filterConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 门店凌晨营业，true 则在门店选择弹窗中新增“凌晨营业”tab
    poiMidnightOpen: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var _useInit = composable_useInit(props, ctx),
        innerValue = _useInit.innerValue,
        innerData = _useInit.innerData,
        innerValueKey = _useInit.innerValueKey,
        innerTabConfig = _useInit.innerTabConfig,
        listeners = _useInit.listeners,
        levelSelect = _useInit.levelSelect,
        innerPlaceholder = _useInit.innerPlaceholder,
        resetOption = _useInit.resetOption,
        selectAll = _useInit.selectAll,
        handleInput = _useInit.handleInput,
        handleChange = _useInit.handleChange,
        handleDataUpdate = _useInit.handleDataUpdate,
        handleTabChange = _useInit.handleTabChange;

    return {
      innerValue: innerValue,
      innerData: innerData,
      innerValueKey: innerValueKey,
      innerTabConfig: innerTabConfig,
      listeners: listeners,
      levelSelect: levelSelect,
      innerPlaceholder: innerPlaceholder,
      resetOption: resetOption,
      selectAll: selectAll,
      handleInput: handleInput,
      handleChange: handleChange,
      handleDataUpdate: handleDataUpdate,
      handleTabChange: handleTabChange
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-poi-select/mc-poi-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_poi_select_mc_poi_selectvue_type_script_lang_js_ = (mc_poi_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-poi-select/mc-poi-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_poi_select_mc_poi_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_poi_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-poi-select/index.js


/* istanbul ignore next */

mc_poi_select.install = function (Vue) {
  Vue.component(mc_poi_select.name, mc_poi_select);
};

/* harmony default export */ var components_mc_poi_select = __webpack_exports__["default"] = (mc_poi_select);

/***/ }),

/***/ "a8db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-symbols.js
var get_own_property_symbols = __webpack_require__("e265");
var get_own_property_symbols_default = /*#__PURE__*/__webpack_require__.n(get_own_property_symbols);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__("a4bb");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutPropertiesLoose.js

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = keys_default()(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (get_own_property_symbols_default.a) {
    var sourceSymbolKeys = get_own_property_symbols_default()(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "a8f0":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("1c35")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "a91e":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "a926":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-popover/mc-popover.vue?vue&type=template&id=1ae758a5&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-popover',_vm._b({ref:"selfRef",attrs:{"trigger":_vm.trigger,"title":_vm.title,"content":_vm.content,"placement":_vm.placement,"size":_vm.size,"append-to-container":_vm.appendToContainer},on:{"input":_vm.handleInput,"clickoutside":_vm.clickoutside}},'mtd-popover',_vm.$attrs,false),[(_vm.$slots.default)?[_vm._t("default",null,{"slot":"default"})]:_vm._e(),(_vm.$slots.title)?[_vm._t("title",null,{"slot":"title"})]:_vm._e(),(_vm.$slots.content)?[_vm._t("content",null,{"slot":"content"})]:_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-popover/mc-popover.vue?vue&type=template&id=1ae758a5&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-popover/mc-popover.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var mc_popovervue_type_script_lang_js_ = ({
  name: 'McPopover',
  props: {
    title: String,
    content: String,
    size: String,
    trigger: {
      type: String,
      default: 'click'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    appendToContainer: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    updatePopper: function updatePopper() {
      this.$refs.selfRef && this.$refs.selfRef.updatePopper();
    },
    clickoutside: function clickoutside(e) {
      this.$emit('clickoutside', e);
    },
    handleInput: function handleInput(visible) {
      this.$emit('input', visible);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-popover/mc-popover.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_popover_mc_popovervue_type_script_lang_js_ = (mc_popovervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-popover/mc-popover.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_popover_mc_popovervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_popover = (component.exports);
// CONCATENATED MODULE: ./components/mc-popover/index.js


/* istanbul ignore next */

mc_popover.install = function (Vue) {
  Vue.component(mc_popover.name, mc_popover);
};

/* harmony default export */ var components_mc_popover = __webpack_exports__["default"] = (mc_popover);

/***/ }),

/***/ "a93d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),

/***/ "a958":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__("399f");
var randomBytes = __webpack_require__("11dc");
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "a99d":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("cc63");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "aa22":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__("8707").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "aa47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),

/***/ "aa56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ "aa63":
/***/ (function(module, exports, __webpack_require__) {

const Utils = __webpack_require__("7bf0")
const ECLevel = __webpack_require__("7a43")
const BitBuffer = __webpack_require__("7ba0")
const BitMatrix = __webpack_require__("577e")
const AlignmentPattern = __webpack_require__("d6c0")
const FinderPattern = __webpack_require__("924f")
const MaskPattern = __webpack_require__("7903")
const ECCode = __webpack_require__("34fc")
const ReedSolomonEncoder = __webpack_require__("8d23")
const Version = __webpack_require__("c8aa")
const FormatInfo = __webpack_require__("9582")
const Mode = __webpack_require__("bbf0")
const Segments = __webpack_require__("befa")

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),

/***/ "aa77":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("5ca1");
var defined = __webpack_require__("be13");
var fails = __webpack_require__("79e5");
var spaces = __webpack_require__("fdef");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "aab3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _optionsFromStrings = __webpack_require__("5261");

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _defaults = __webpack_require__("ca32");

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptionsFromElement(element) {
	var options = {};
	for (var property in _defaults2.default) {
		if (_defaults2.default.hasOwnProperty(property)) {
			// jsbarcode-*
			if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
				options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
			}

			// data-*
			if (element.hasAttribute("data-" + property.toLowerCase())) {
				options[property] = element.getAttribute("data-" + property.toLowerCase());
			}
		}
	}

	options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");

	// Since all atributes are string they need to be converted to integers
	options = (0, _optionsFromStrings2.default)(options);

	return options;
}

exports.default = getOptionsFromElement;

/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "aaf2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ "ab20":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "ab5b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("be24");
} else {}


/***/ }),

/***/ "ab5b7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getTotalWidthOfEncodings = exports.calculateEncodingAttributes = exports.getBarcodePadding = exports.getEncodingHeight = exports.getMaximumHeightOfEncodings = undefined;

var _merge = __webpack_require__("fd7c");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEncodingHeight(encoding, options) {
	return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
}

function getBarcodePadding(textWidth, barcodeWidth, options) {
	if (options.displayValue && barcodeWidth < textWidth) {
		if (options.textAlign == "center") {
			return Math.floor((textWidth - barcodeWidth) / 2);
		} else if (options.textAlign == "left") {
			return 0;
		} else if (options.textAlign == "right") {
			return Math.floor(textWidth - barcodeWidth);
		}
	}
	return 0;
}

function calculateEncodingAttributes(encodings, barcodeOptions, context) {
	for (var i = 0; i < encodings.length; i++) {
		var encoding = encodings[i];
		var options = (0, _merge2.default)(barcodeOptions, encoding.options);

		// Calculate the width of the encoding
		var textWidth;
		if (options.displayValue) {
			textWidth = messureText(encoding.text, options, context);
		} else {
			textWidth = 0;
		}

		var barcodeWidth = encoding.data.length * options.width;
		encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));

		encoding.height = getEncodingHeight(encoding, options);

		encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
	}
}

function getTotalWidthOfEncodings(encodings) {
	var totalWidth = 0;
	for (var i = 0; i < encodings.length; i++) {
		totalWidth += encodings[i].width;
	}
	return totalWidth;
}

function getMaximumHeightOfEncodings(encodings) {
	var maxHeight = 0;
	for (var i = 0; i < encodings.length; i++) {
		if (encodings[i].height > maxHeight) {
			maxHeight = encodings[i].height;
		}
	}
	return maxHeight;
}

function messureText(string, options, context) {
	var ctx;

	if (context) {
		ctx = context;
	} else if (typeof document !== "undefined") {
		ctx = document.createElement("canvas").getContext("2d");
	} else {
		// If the text cannot be messured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;

	// Calculate the width of the encoding
	var measureTextResult = ctx.measureText(string);
	if (!measureTextResult) {
		// Some implementations don't implement measureText and return undefined.
		// If the text cannot be measured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	var size = measureTextResult.width;
	return size;
}

exports.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
exports.getEncodingHeight = getEncodingHeight;
exports.getBarcodePadding = getBarcodePadding;
exports.calculateEncodingAttributes = calculateEncodingAttributes;
exports.getTotalWidthOfEncodings = getTotalWidthOfEncodings;

/***/ }),

/***/ "aba2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var macrotask = __webpack_require__("4178").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("6b4c")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "ac4d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3a72")('asyncIterator');


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "aca4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-table-column/mc-table-column.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_table_columnvue_type_script_lang_js_ = ({
  name: 'McTableColumn',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    console.log('%c⧭', 'color: #73998c', this.$scopedSlots);
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-table-column', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      scopedSlots: this.$scopedSlots,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-table-column/mc-table-column.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_table_column_mc_table_columnvue_type_script_lang_js_ = (mc_table_columnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-table-column/mc-table-column.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_table_column_mc_table_columnvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_table_column = (component.exports);
// CONCATENATED MODULE: ./components/mc-table-column/index.js


/* istanbul ignore next */

mc_table_column.install = function (Vue) {
  Vue.component(mc_table_column.name, mc_table_column);
};

/* harmony default export */ var components_mc_table_column = __webpack_exports__["default"] = (mc_table_column);

/***/ }),

/***/ "acdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),

/***/ "ad15":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("c3f1");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "ad25":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("2aee")
var randomBytes = __webpack_require__("11dc")
var createHash = __webpack_require__("98e6")
var mgf = __webpack_require__("f460")
var xor = __webpack_require__("83d5")
var BN = __webpack_require__("399f")
var withPublic = __webpack_require__("5291")
var crt = __webpack_require__("a958")
var Buffer = __webpack_require__("8707").Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ "ad71":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__("966d");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("e3db");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("7e25").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("429b");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("a8f0").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__("3a7c");
util.inherits = __webpack_require__("3fb5");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(0);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__("5e1a");
var destroyImpl = __webpack_require__("4681");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("b19a");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("aa22").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("b19a");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("aa22").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("f28c")))

/***/ }),

/***/ "ada2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ "ae1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-steps/mc-steps.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_stepsvue_type_script_lang_js_ = ({
  name: 'McSteps',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-steps', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-steps/mc-steps.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_steps_mc_stepsvue_type_script_lang_js_ = (mc_stepsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-steps/mc-steps.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_steps_mc_stepsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_steps = (component.exports);
// CONCATENATED MODULE: ./components/mc-steps/index.js


/* istanbul ignore next */

mc_steps.install = function (Vue) {
  Vue.component(mc_steps.name, mc_steps);
};

/* harmony default export */ var components_mc_steps = __webpack_exports__["default"] = (mc_steps);

/***/ }),

/***/ "ae3c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),

/***/ "ae84":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer
var MD5 = __webpack_require__("f576")

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ "aebd":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "b084":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-detail-info/mc-detail-info.vue?vue&type=template&id=5a2be678&
var mc_detail_infovue_type_template_id_5a2be678_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-loading',{attrs:{"loading":_vm.innerLoading}},[_c('div',{staticClass:"mc-detail-info"},[(_vm.showTitle)?_c('div',[_c('mc-title',{attrs:{"level":_vm.titleConfig.level,"title":_vm.titleConfig.title}},[_vm._t("operation")],2)],1):_vm._e(),_c('div',{staticClass:"mc-detail-body"},[_c('mtd-form',[_c('mtd-row',_vm._l((_vm.innerFields),function(field){return _c('mtd-col',{key:field.renderKey,attrs:{"span":field.title||_vm.isMobile ? 24 :(field.colSpan ? field.colSpan : 24 / +_vm.columnCount)}},[(field.title)?_c('mc-title',{attrs:{"title":field.title}}):_c('mtd-form-item',{staticStyle:{"word-break":"break-all","margin-bottom":"4px"},attrs:{"label-width":_vm.labelWidth}},[_c('template',{slot:"label"},[_c('RenderTips',{attrs:{"tips":field.tips}}),_c('span',{class:field.labelClassName||'',on:{"click":function($event){return _vm.labelClick(field.label, field)}}},[_vm._v(_vm._s(field.label))]),(_vm.labelSuffix)?_c('span',[_vm._v(_vm._s(_vm.labelSuffix))]):_vm._e()],1),_c('div',{class:field.valueClassName||'',on:{"click":function($event){return _vm.valueClick(field.value, field)}}},[_c('RenderDetailItem',{attrs:{"field":field,"detail-data":_vm.innerData}},[(field.slot)?_vm._t(field.slot,null,{"data":_vm.innerData}):_vm._e()],2)],1)],2)],1)}),1)],1)],1)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-detail-info/mc-detail-info.vue?vue&type=template&id=5a2be678&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./composables/useRemote.js
var useRemote = __webpack_require__("9ea3");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-detail-info/components/RenderText.vue?vue&type=template&id=ed8ebc4c&scoped=true&
var RenderTextvue_type_template_id_ed8ebc4c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.containerName,_vm._b({tag:"component",attrs:{"content":_vm.value,"disabled":_vm.showOverTextToolTip,"append-to-container":false,"placement":"top"}},'component',_vm.poperConfig,false),[_c('div',{class:[
                'mc-detail-info-text',
                ("" + (_vm.enableEllipsis ? 'mc-detail-info-text-ellipsis' : '')) ]},[(_vm.enableCopy)?_c('mtd-icon-button',{staticClass:"mc-detail-info-copy-icon",attrs:{"icon":_vm.isCopySuccess ? 'mtdicon mtdicon-check' : 'mtdicon mtdicon-copy-o',"size":"small"},on:{"click":_vm.onCopy}}):_vm._e(),_vm._v("\n            "+_vm._s(_vm.value)+"\n        ")],1)])],1)}
var RenderTextvue_type_template_id_ed8ebc4c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderText.vue?vue&type=template&id=ed8ebc4c&scoped=true&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-detail-info/components/RenderText.vue?vue&type=script&lang=js&






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RenderTextvue_type_script_lang_js_ = ({
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    // 控制占位
    emptyText: {
      type: [String, Number],
      default: '--'
    },
    // 开启复制
    enableCopy: {
      type: Boolean,
      default: false
    },
    // 超长是否自动展示省略号
    enableEllipsis: {
      type: Boolean,
      default: false
    },
    // 超长后用tooltip展示
    enableToolTip: {
      type: Boolean,
      default: true
    },
    // tooltip配置
    poperConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props) {
    var origin = Object(composition_api_["reactive"])({
      isCopySuccess: false,
      containerName: Object(composition_api_["computed"])(function () {
        return props.enableEllipsis ? 'mtd-tooltip' : 'div';
      }),
      showOverTextToolTip: Object(composition_api_["computed"])(function () {
        if (props.enableToolTip && props.value && props.value !== props.emptyText) {
          return false;
        }

        return true;
      }),
      showSuccess: function showSuccess() {
        origin.isCopySuccess = true;
        setTimeout(function () {
          origin.isCopySuccess = false;
        }, 1500);
      },
      onCopy: function onCopy() {
        var content = props.value;

        if (content) {
          if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(content).then(function () {
              origin.showSuccess();
            }).catch(function () {
              origin.isCopySuccess = false;
            });
          } else {
            var copyInput = document.createElement('input');
            copyInput.value = content;
            document.body.appendChild(copyInput);
            copyInput.select();
            document.execCommand('Copy');
            copyInput.remove();
            origin.showSuccess();
          }
        }
      }
    });
    var refs = Object(composition_api_["toRefs"])(origin);
    return _objectSpread({}, refs);
  }
});
// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderText.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RenderTextvue_type_script_lang_js_ = (RenderTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderText.vue





/* normalize component */

var RenderText_component = Object(componentNormalizer["a" /* default */])(
  components_RenderTextvue_type_script_lang_js_,
  RenderTextvue_type_template_id_ed8ebc4c_scoped_true_render,
  RenderTextvue_type_template_id_ed8ebc4c_scoped_true_staticRenderFns,
  false,
  null,
  "ed8ebc4c",
  null
  
)

/* harmony default export */ var RenderText = (RenderText_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-detail-info/components/RenderDetailItem.vue?vue&type=script&lang=js&





function RenderDetailItemvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function RenderDetailItemvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { RenderDetailItemvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { RenderDetailItemvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var RenderDetailItemvue_type_script_lang_js_ = ({
  props: {
    field: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    detailData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var field = this.field,
        detailData = this.detailData,
        $slots = this.$slots,
        $createElement = this.$createElement;

    var renderFiled = function renderFiled(item) {
      var slot = item.slot,
          template = item.template,
          value = item.value,
          text = item.text,
          emptyText = item.emptyText,
          enableEllipsis = item.enableEllipsis,
          enableCopy = item.enableCopy,
          enableToolTip = item.enableToolTip,
          poperConfig = item.poperConfig,
          group = item.group;

      if (group && Array.isArray(group)) {
        return group.map(function (v) {
          return h("mtd-form-item", {
            "attrs": {
              "label": v.label,
              "labelWidth": 0
            }
          }, [renderFiled(v)]);
        });
      }

      if (slot) {
        return $slots.default;
      }

      if (template) {
        var component = template.component,
            attrs = template.attrs,
            events = template.events;

        if (component && typeof component === 'function') {
          return component.call({
            $createElement: $createElement
          }, field, detailData);
        }

        return $createElement(component, {
          props: RenderDetailItemvue_type_script_lang_js_objectSpread({
            disabled: true,
            readonly: true,
            value: value
          }, attrs),
          attrs: RenderDetailItemvue_type_script_lang_js_objectSpread({
            disabled: true,
            readonly: true,
            value: value
          }, attrs),
          on: RenderDetailItemvue_type_script_lang_js_objectSpread({}, events)
        });
      }

      return h(RenderText, {
        "attrs": {
          "value": text,
          "emptyText": emptyText,
          "enableEllipsis": enableEllipsis,
          "enableCopy": enableCopy,
          "enableToolTip": enableToolTip,
          "poperConfig": poperConfig
        }
      });
    };

    return h("div", [renderFiled(field)]);
  }
});
// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderDetailItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RenderDetailItemvue_type_script_lang_js_ = (RenderDetailItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderDetailItem.vue
var RenderDetailItem_render, RenderDetailItem_staticRenderFns




/* normalize component */

var RenderDetailItem_component = Object(componentNormalizer["a" /* default */])(
  components_RenderDetailItemvue_type_script_lang_js_,
  RenderDetailItem_render,
  RenderDetailItem_staticRenderFns,
  false,
  null,
  "633e46d8",
  null
  
)

/* harmony default export */ var RenderDetailItem = (RenderDetailItem_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-detail-info/components/RenderTips.vue?vue&type=script&lang=js&

/* harmony default export */ var RenderTipsvue_type_script_lang_js_ = ({
  props: {
    tips: {
      type: [String, Number, Array],
      default: ''
    }
  },
  render: function render() {
    var h = arguments[0];
    var tips = this.tips;
    var tipContent = (Array.isArray(tips) ? tips : [tips]).filter(Boolean);
    return tipContent.length ? h("mtd-tooltip", {
      "attrs": {
        "placement": "top"
      }
    }, [h("i", {
      "class": "mtdicon mtdicon-info-circle demo-icon demo-icon-label"
    }), h("div", {
      "slot": "content"
    }, [tipContent.map(function (tip) {
      return h("div", [tip]);
    })])]) : '';
  }
});
// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderTips.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RenderTipsvue_type_script_lang_js_ = (RenderTipsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-detail-info/components/RenderTips.vue
var RenderTips_render, RenderTips_staticRenderFns




/* normalize component */

var RenderTips_component = Object(componentNormalizer["a" /* default */])(
  components_RenderTipsvue_type_script_lang_js_,
  RenderTips_render,
  RenderTips_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RenderTips = (RenderTips_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-detail-info/mc-detail-info.vue?vue&type=script&lang=js&










function mc_detail_infovue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mc_detail_infovue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mc_detail_infovue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mc_detail_infovue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var isMobile = Object(tools_["detectDeviceType"])() === 'Mobile';
/* harmony default export */ var mc_detail_infovue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McDetailInfo',
  components: {
    RenderDetailItem: RenderDetailItem,
    RenderTips: RenderTips
  },
  props: {
    titleConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    source: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    columnCount: {
      type: [String, Number],
      default: 3,
      validator: function validator(value) {
        return Object(tools_["isInteger"])(value) && value > 0 && 24 % +value === 0;
      }
    },
    labelWidth: {
      type: Number,
      default: 120
    },
    labelSuffix: {
      type: [String, Number],
      default: ''
    },
    useLoading: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props, ctx) {
    var detailInfoInstance = Object(composition_api_["reactive"])({
      isMobile: isMobile,
      innerFields: [],
      fetchData: undefined,
      innerData: {},
      loading: false,
      showTitle: Object(composition_api_["computed"])(function () {
        return props.titleConfig.title && props.titleConfig.level;
      }),
      innerLoading: Object(composition_api_["computed"])(function () {
        return props.useLoading ? detailInfoInstance.loading : false;
      }),
      resetData: function resetData() {
        detailInfoInstance.innerData = {};
      },
      resetFields: function resetFields() {
        detailInfoInstance.innerFields = [];
      },
      labelClick: function labelClick(label, field) {
        ctx.emit('labelClick', label, field, detailInfoInstance.innerData);
      },
      valueClick: function valueClick(value, field) {
        ctx.emit('valueClick', value, field, detailInfoInstance.innerData);
      }
    }); // 给 field 设置 text 和 value

    var getValueProp = function getValueProp(data, filed) {
      var val = Object(tools_["get"])(data, filed.prop);
      filed.renderKey = Object(tools_["getUuid"])();
      filed.value = val;

      if (filed.group && Array.isArray(filed.group)) {
        filed.group = filed.group.map(function (v) {
          return getValueProp(data, v);
        });
      } // 常规文本 自定义展示


      if (filed.formatter && typeof filed.formatter === 'function') {
        return mc_detail_infovue_type_script_lang_js_objectSpread({}, filed, {
          text: filed.formatter(data)
        });
      } // 常规文本


      return mc_detail_infovue_type_script_lang_js_objectSpread({}, filed, {
        text: [null, undefined, ''].includes(val) ? filed.emptyText || '--' : val
      });
    };

    var formatFileds = function formatFileds(data, fileds) {
      return (fileds || []).map(function (filed) {
        return getValueProp(data, filed);
      });
    };

    var getFileds = function getFileds(data) {
      var fields = props.fields;

      if (props.source.filedProcess && typeof props.source.filedProcess === 'function') {
        fields = props.source.filedProcess(data);
      }

      return formatFileds(data, fields);
    };

    var initDetailData =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _useRemote, fetchData, remoteData, resultFileds;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(props.source && props.source.ajax)) {
                  _context.next = 11;
                  break;
                }

                detailInfoInstance.loading = true;
                _useRemote = Object(useRemote["a" /* default */])(props.source, ctx), fetchData = _useRemote.fetchData;
                _context.next = 6;
                return fetchData();

              case 6:
                remoteData = _context.sent;
                detailInfoInstance.innerData = remoteData || {};
                detailInfoInstance.fetchData = fetchData;
                _context.next = 12;
                break;

              case 11:
                detailInfoInstance.innerData = props.source;

              case 12:
                resultFileds = getFileds(detailInfoInstance.innerData);
                detailInfoInstance.innerFields = resultFileds.filter(function (filed) {
                  var visible = filed.visible;

                  if (typeof visible === 'function') {
                    return visible(detailInfoInstance.innerData);
                  }

                  return visible !== false;
                });
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                detailInfoInstance.innerData = {};
                console.error("[mc-detail-info]".concat(_context.t0));

              case 20:
                _context.prev = 20;
                detailInfoInstance.loading = false;
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 16, 20, 23]]);
      }));

      return function initDetailData() {
        return _ref.apply(this, arguments);
      };
    }();

    initDetailData();
    Object(composition_api_["watch"])(function () {
      return props.source;
    }, function () {
      initDetailData();
    }, {
      deep: true
    });
    Object(composition_api_["watch"])(function () {
      return props.fields;
    }, function () {
      initDetailData();
    }, {
      deep: true
    });
    var detailDataRefs = Object(composition_api_["toRefs"])(detailInfoInstance);
    return mc_detail_infovue_type_script_lang_js_objectSpread({}, detailDataRefs);
  }
}));
// CONCATENATED MODULE: ./components/mc-detail-info/mc-detail-info.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_detail_info_mc_detail_infovue_type_script_lang_js_ = (mc_detail_infovue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-detail-info/mc-detail-info.vue





/* normalize component */

var mc_detail_info_component = Object(componentNormalizer["a" /* default */])(
  mc_detail_info_mc_detail_infovue_type_script_lang_js_,
  mc_detail_infovue_type_template_id_5a2be678_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_detail_info = (mc_detail_info_component.exports);
// CONCATENATED MODULE: ./components/mc-detail-info/index.js


/* istanbul ignore next */

mc_detail_info.install = function (Vue) {
  Vue.component(mc_detail_info.name, mc_detail_info);
};

/* harmony default export */ var components_mc_detail_info = __webpack_exports__["default"] = (mc_detail_info);

/***/ }),

/***/ "b0b4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var _core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("85f2");
/* harmony import */ var _core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__);


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    _core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0___default()(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "b0dc":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("e4ae");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "b19a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__("966d");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__("3a7c");
util.inherits = __webpack_require__("3fb5");
/*</replacement>*/

var Readable = __webpack_require__("ad71");
var Writable = __webpack_require__("dc14");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "b1d8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
/* global HTMLCanvasElement */
/* global SVGElement */

var _getOptionsFromElement = __webpack_require__("aab3");

var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);

var _renderers = __webpack_require__("752b");

var _renderers2 = _interopRequireDefault(_renderers);

var _exceptions = __webpack_require__("dca2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes an element and returns an object with information about how
// it should be rendered
// This could also return an array with these objects
// {
//   element: The element that the renderer should draw on
//   renderer: The name of the renderer
//   afterRender (optional): If something has to done after the renderer
//     completed, calls afterRender (function)
//   options (optional): Options that can be defined in the element
// }

function getRenderProperties(element) {
	// If the element is a string, query select call again
	if (typeof element === "string") {
		return querySelectedRenderProperties(element);
	}
	// If element is array. Recursivly call with every object in the array
	else if (Array.isArray(element)) {
			var returnArray = [];
			for (var i = 0; i < element.length; i++) {
				returnArray.push(getRenderProperties(element[i]));
			}
			return returnArray;
		}
		// If element, render on canvas and set the uri as src
		else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
				return newCanvasRenderProperties(element);
			}
			// If SVG
			else if (element && element.nodeName && element.nodeName.toLowerCase() === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
					return {
						element: element,
						options: (0, _getOptionsFromElement2.default)(element),
						renderer: _renderers2.default.SVGRenderer
					};
				}
				// If canvas (in browser)
				else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.CanvasRenderer
						};
					}
					// If canvas (in node)
					else if (element && element.getContext) {
							return {
								element: element,
								renderer: _renderers2.default.CanvasRenderer
							};
						} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
							return {
								element: element,
								renderer: _renderers2.default.ObjectRenderer
							};
						} else {
							throw new _exceptions.InvalidElementException();
						}
}

function querySelectedRenderProperties(string) {
	var selector = document.querySelectorAll(string);
	if (selector.length === 0) {
		return undefined;
	} else {
		var returnArray = [];
		for (var i = 0; i < selector.length; i++) {
			returnArray.push(getRenderProperties(selector[i]));
		}
		return returnArray;
	}
}

function newCanvasRenderProperties(imgElement) {
	var canvas = document.createElement('canvas');
	return {
		element: canvas,
		options: (0, _getOptionsFromElement2.default)(imgElement),
		renderer: _renderers2.default.CanvasRenderer,
		afterRender: function afterRender() {
			imgElement.setAttribute("src", canvas.toDataURL());
		}
	};
}

exports.default = getRenderProperties;

/***/ }),

/***/ "b25a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-date-picker/mc-date-picker.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_date_pickervue_type_script_lang_js_ = ({
  name: 'McDatePicker',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-date-picker相关组件已经弃用，请使用mc-date-time-picker组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/I4FgWtIHMxF_CkM41RqdE', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-date-picker', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-date-picker/mc-date-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_date_picker_mc_date_pickervue_type_script_lang_js_ = (mc_date_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-date-picker/mc-date-picker.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_date_picker_mc_date_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_date_picker = (component.exports);
// CONCATENATED MODULE: ./components/mc-date-picker/index.js


/* istanbul ignore next */

mc_date_picker.install = function (Vue) {
  Vue.component(mc_date_picker.name, mc_date_picker);
};

/* harmony default export */ var components_mc_date_picker = __webpack_exports__["default"] = (mc_date_picker);

/***/ }),

/***/ "b262":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-icon/mc-icon.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_iconvue_type_script_lang_js_ = ({
  name: 'McIcon',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-icon', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-icon/mc-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_icon_mc_iconvue_type_script_lang_js_ = (mc_iconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-icon/mc-icon.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_icon_mc_iconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_icon = (component.exports);
// CONCATENATED MODULE: ./components/mc-icon/index.js


/* istanbul ignore next */

mc_icon.install = function (Vue) {
  Vue.component(mc_icon.name, mc_icon);
};

/* harmony default export */ var components_mc_icon = __webpack_exports__["default"] = (mc_icon);

/***/ }),

/***/ "b29d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ "b325":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-checkbox/mc-checkbox.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_checkboxvue_type_script_lang_js_ = ({
  name: 'McCheckbox',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-checkbox组件已经弃用，请使用mc-choice组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/aWRcgaz4faYOZ7ubzF_33', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-checkbox', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-checkbox/mc-checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_checkbox_mc_checkboxvue_type_script_lang_js_ = (mc_checkboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-checkbox/mc-checkbox.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_checkbox_mc_checkboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_checkbox = (component.exports);
// CONCATENATED MODULE: ./components/mc-checkbox/index.js


/* istanbul ignore next */

mc_checkbox.install = function (Vue) {
  Vue.component(mc_checkbox.name, mc_checkbox);
};

/* harmony default export */ var components_mc_checkbox = __webpack_exports__["default"] = (mc_checkbox);

/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "b3eb":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ "b447":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("3a38");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "b469":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ "b471":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("dc47"),
    Map = __webpack_require__("54d8"),
    Promise = __webpack_require__("90cd"),
    Set = __webpack_require__("8400"),
    WeakMap = __webpack_require__("bd5a"),
    baseGetTag = __webpack_require__("3e6c"),
    toSource = __webpack_require__("a146");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "b4e8":
/***/ (function(module) {

module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

/***/ }),

/***/ "b525":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var common = __webpack_require__("edc9");
var assert = __webpack_require__("da3e");

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ "b53d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ "b540":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ "b54a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__("386b")('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),

/***/ "b5b7":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ "b5ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__("1c35").Buffer
var inherits = __webpack_require__("3fb5")
var HashBase = __webpack_require__("93e6")

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ "b5d6":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "b672":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("8707").Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ "b692":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__("98e6")
var stream = __webpack_require__("d485")
var inherits = __webpack_require__("3fb5")
var sign = __webpack_require__("6fe7")
var verify = __webpack_require__("980c")

var algorithms = __webpack_require__("b4e8")
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "b73f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("399f");

var utils = __webpack_require__("f3a3");
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ "b76a":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("aa47"));
	else {}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),

/***/ "b7d1":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "b7e9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ "b822":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "b837":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5")
var SHA512 = __webpack_require__("4fd1")
var Hash = __webpack_require__("b672")
var Buffer = __webpack_require__("8707").Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ "b84c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ "b868":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("6a9b");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "b88a":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "b8e3":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "b923":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__("6f27");

// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);

function makeRecover(index, offset) { return index + offset * factor16 }
function recoverIndex(value) { return value & lower16 }
function recoverOffset(value) { return (value - (value & lower16)) / factor16 }

// ::- An object representing a mapped position with extra
// information.
var MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  this.ranges = ranges;
  this.inverted = inverted;
};

StepMap.prototype.recover = function recover (value) {
    var this$1 = this;

  var diff = 0, index = recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this$1.ranges[i * 3 + 2] - this$1.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + recoverOffset(value)
};

// : (number, ?number) → MapResult
StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

StepMap.prototype._map = function _map (pos, assoc, simple) {
    var this$1 = this;

  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this$1.ranges[i + oldIndex], newSize = this$1.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = makeRecover(i / 3, pos - start);
      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new MapResult(pos + diff)
};

StepMap.prototype.touches = function touches (pos, recover) {
    var this$1 = this;

  var diff = 0, index = recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this$1.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this$1.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
StepMap.prototype.forEach = function forEach (f) {
    var this$1 = this;

  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i], oldStart = start - (this$1.inverted ? diff : 0), newStart = start + (this$1.inverted ? 0 : diff);
    var oldSize = this$1.ranges[i + oldIndex], newSize = this$1.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
StepMap.prototype.invert = function invert () {
  return new StepMap(this.ranges, !this.inverted)
};

StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
StepMap.offset = function offset (n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

StepMap.empty = new StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new Mapping(this.maps, this.mirror, from, to)
};

Mapping.prototype.copy = function copy () {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
Mapping.prototype.appendMapping = function appendMapping (mapping) {
    var this$1 = this;

  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this$1.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
Mapping.prototype.getMirror = function getMirror (n) {
    var this$1 = this;

  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this$1.mirror[i] == n) { return this$1.mirror[i + (i % 2 ? -1 : 1)] } } }
};

Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
    var this$1 = this;

  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this$1.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// () → Mapping
// Create an inverted version of this mapping.
Mapping.prototype.invert = function invert () {
  var inverse = new Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
Mapping.prototype.map = function map (pos, assoc) {
    var this$1 = this;
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this$1.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

Mapping.prototype._map = function _map (pos, assoc, simple) {
    var this$1 = this;

  var deleted = false, recoverables = null;

  for (var i = this.from; i < this.to; i++) {
    var map = this$1.maps[i], rec = recoverables && recoverables[i];
    if (rec != null && map.touches(pos, rec)) {
      pos = map.recover(rec);
      continue
    }

    var result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this$1.getMirror(i);
      if (corr != null && corr > i && corr < this$1.to) {
        if (result.deleted) {
          i = corr;
          pos = this$1.maps[corr].recover(result.recover);
          continue
        } else {
          (recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
        }
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new MapResult(pos, deleted)
};

function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err
}

TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new Mapping;
};

var prototypeAccessors = { before: {},docChanged: {} };

// :: Node The starting document.
prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
prototypeAccessors.docChanged.get = function () {
  return this.steps.length > 0
};

Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( Transform.prototype, prototypeAccessors );

function mustOverride() { throw new Error("Override me") }

var stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var Step = function Step () {};

Step.prototype.apply = function apply (_doc) { return mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
Step.prototype.getMap = function getMap () { return StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
Step.prototype.invert = function invert (_doc) { return mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
Step.prototype.map = function map (_mapping) { return mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
Step.prototype.toJSON = function toJSON () { return mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
Step.jsonID = function jsonID (id, stepClass) {
  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
StepResult.ok = function ok (doc) { return new StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
StepResult.fail = function fail (message) { return new StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof prosemirrorModel.ReplaceError) { return StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var ReplaceStep = (function (Step$$1) {
  function ReplaceStep(from, to, slice, structure) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step$$1 ) ReplaceStep.__proto__ = Step$$1;
  ReplaceStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && contentBetween(doc, this.from, this.to))
      { return StepResult.fail("Structure replace would overwrite content") }
    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure != this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
          : new prosemirrorModel.Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
          : new prosemirrorModel.Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, prosemirrorModel.Slice.fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(Step));

Step.jsonID("replace", ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var ReplaceAroundStep = (function (Step$$1) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice;
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step$$1 ) ReplaceAroundStep.__proto__ = Step$$1;
  ReplaceAroundStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
                           contentBetween(doc, this.gapTo, this.to)))
      { return StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
    return StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 prosemirrorModel.Slice.fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(Step));

Step.jsonID("replaceAround", ReplaceAroundStep);

function contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) &&
    (end == node.childCount || node.canReplace(0, end))
}

// :: (NodeRange) → ?number
// Try to find a target depth to which the content in the given range
// can be lifted. Will not go across
// [isolating](#model.NodeSpec.isolating) parent nodes.
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content))
      { return depth }
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
  }
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = prosemirrorModel.Fragment.empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = prosemirrorModel.Fragment.from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = prosemirrorModel.Fragment.empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = prosemirrorModel.Fragment.from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new prosemirrorModel.Slice(before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
// Try to find a valid way to wrap the content in the given range in a
// node of the given type. May introduce extra nodes around and inside
// the wrapper node, if necessary. Returns null if no valid wrapping
// could be found. When `innerRange` is given, that range's content is
// used as the content to fit into the wrapping, instead of the
// content of `range`.
function findWrapping(range, nodeType, attrs, innerRange) {
  if ( innerRange === void 0 ) innerRange = range;

  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) { return null }
  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
}

function withAttrs(type) { return {type: type, attrs: null} }

function findWrappingOutside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) { return null }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
}

function findWrappingInside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) { return null }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++)
    { innerMatch = innerMatch.matchType(parent.child(i).type); }
  if (!innerMatch || !innerMatch.validEnd) { return null }
  return inside
}

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
Transform.prototype.wrap = function(range, wrappers) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  var start = range.start, end = range.end;
  return this.step(new ReplaceAroundStep(start, end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(newNode), 0, 0), 1, true))
};

// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
// Check whether splitting at the given position is allowed.
function canSplit(doc, pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = doc.resolve(pos), base = $pos.depth - depth;
  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating ||
      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    { return false }
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d), index$1 = $pos.index(d);
    if (node.type.spec.isolating) { return false }
    var rest = node.content.cutByIndex(index$1, node.childCount);
    var after = (typesAfter && typesAfter[i]) || node;
    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
      { return false }
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
}

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = prosemirrorModel.Fragment.empty, after = prosemirrorModel.Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = prosemirrorModel.Fragment.from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = prosemirrorModel.Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new ReplaceStep(pos, pos, new prosemirrorModel.Slice(before.append(after), depth, depth, true)))
};

// :: (Node, number) → bool
// Test whether the blocks before and after a given position can be
// joined.
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) &&
    $pos.parent.canReplace(index, index + 1)
}

function joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b)
}

// :: (Node, number, ?number) → ?number
// Find an ancestor of the given position that can be joined to the
// block before (or after if `dir` is positive). Returns the joinable
// point, if any.
function joinPoint(doc, pos, dir) {
  if ( dir === void 0 ) dir = -1;

  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = (void 0), after = (void 0);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      after = $pos.node(d).maybeChild($pos.index(d) + 1);
    } else {
      before = $pos.node(d).maybeChild($pos.index(d) - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable(before, after)) { return pos }
    if (d == 0) { break }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new ReplaceStep(pos - depth, pos + depth, prosemirrorModel.Slice.empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

// :: (Node, number, Slice) → ?number
// Finds a position at or around the given position where the given
// slice can be inserted. Will look at parent nodes' nearest boundary
// and try there, even if the original position wasn't directly at the
// start or end of that node. Returns null when no position was found.
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) { return pos }
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      if (pass == 1
          ? $pos.node(d).canReplace(insertPos, insertPos, content)
          : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type))
        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
    }
  }
  return null
}

function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return prosemirrorModel.Fragment.fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var AddMarkStep = (function (Step$$1) {
  function AddMarkStep(from, to, mark) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step$$1 ) AddMarkStep.__proto__ = Step$$1;
  AddMarkStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node, parent) {
      if (!parent.type.allowsMarkType(this$1.mark.type)) { return node }
      return node.mark(this$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(Step));

Step.jsonID("addMark", AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var RemoveMarkStep = (function (Step$$1) {
  function RemoveMarkStep(from, to, mark) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step$$1 ) RemoveMarkStep.__proto__ = Step$$1;
  RemoveMarkStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(Step));

Step.jsonID("removeMark", RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
Transform.prototype.addMark = function(from, to, mark) {
  var this$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1.step(s); });
  added.forEach(function (s) { return this$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
Transform.prototype.removeMark = function(from, to, mark) {
  var this$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof prosemirrorModel.MarkType) {
      var found = mark.isInSet(node.marks);
      if (found) { toRemove = [found]; }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1.step(new RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  var this$1 = this;
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new ReplaceStep(cur, end, prosemirrorModel.Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this$1.step(new RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(prosemirrorModel.Fragment.empty, true);
    this.replace(cur, cur, new prosemirrorModel.Slice(fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this$1.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (fitsTrivially($from, $to, slice)) { return new ReplaceStep(from, to, slice) }
  var placed = placeSlice($from, slice);

  var fittedLeft = fitLeft($from, placed);
  var fitted = fitRight($from, $to, fittedLeft);
  if (!fitted) { return null }
  if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
    var d = $to.depth, after = $to.after(d);
    while (d > 1 && after == $to.end(--d)) { ++after; }
    var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);
    if (fittedAfter)
      { return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size) }
  }
  return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;

  var step = replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, prosemirrorModel.Slice.empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};



function fitLeftInner($from, depth, placed, placedBelow) {
  var content = prosemirrorModel.Fragment.empty, openEnd = 0, placedHere = placed[depth];
  if ($from.depth > depth) {
    var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
    openEnd = inner.openEnd + 1;
    content = prosemirrorModel.Fragment.from($from.node(depth + 1).copy(inner.content));
  }

  if (placedHere) {
    content = content.append(placedHere.content);
    openEnd = placedHere.openEnd;
  }
  if (placedBelow) {
    content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(prosemirrorModel.Fragment.empty, true));
    openEnd = 0;
  }

  return {content: content, openEnd: openEnd}
}

function fitLeft($from, placed) {
  var ref = fitLeftInner($from, 0, placed, false);
  var content = ref.content;
  var openEnd = ref.openEnd;
  return new prosemirrorModel.Slice(content, $from.depth, openEnd || 0)
}

function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
  var match, count = content.childCount, matchCount = count - (openEnd > 0 ? 1 : 0);
  var parentNode = openStart < 0 ? parent : $from.node(depth);
  if (openStart < 0)
    { match = parentNode.contentMatchAt(matchCount); }
  else if (count == 1 && openEnd > 0)
    { match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth)); }
  else
    { match = parentNode.contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount); }

  var toNode = $to.node(depth);
  if (openEnd > 0 && depth < $to.depth) {
    var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
    var joinable$1 = match.fillBefore(after, true);
    // Can't insert content if there's a single node stretched across this gap
    if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) { joinable$1 = null; }

    if (joinable$1) {
      var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to,
                               depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);
      if (inner) {
        var last = content.lastChild.copy(inner);
        if (joinable$1.size)
          { return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last) }
        else
          { return content.replaceChild(count - 1, last) }
      }
    }
  }
  if (openEnd > 0)
    { match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type); }

  // If we're here, the next level can't be joined, so we see what
  // happens if we leave it open.
  var toIndex = $to.index(depth);
  if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) { return null }
  var joinable = match.fillBefore(toNode.content, true, toIndex);
  for (var i = toIndex; joinable && i < toNode.content.childCount; i++)
    { if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) { joinable = null; } }
  if (!joinable) { return null }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }
  content = content.append(joinable);
  if ($to.depth > depth)
    { content = content.addToEnd(fitRightSeparate($to, depth + 1)); }
  return content
}

function fitRightClosed(node, openEnd, $from, depth, openStart) {
  var match, content = node.content, count = content.childCount;
  if (openStart >= 0)
    { match = $from.node(depth).contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, openStart > 0 ? 1 : 0, count); }
  else
    { match = node.contentMatchAt(count); }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }

  return node.copy(content.append(match.fillBefore(prosemirrorModel.Fragment.empty, true)))
}

function fitRightSeparate($to, depth) {
  var node = $to.node(depth);
  var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));
  if ($to.depth > depth) { fill = fill.addToEnd(fitRightSeparate($to, depth + 1)); }
  return node.copy(fill)
}

function normalizeSlice(content, openStart, openEnd) {
  while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
    content = content.firstChild.content;
    openStart--;
    openEnd--;
  }
  return new prosemirrorModel.Slice(content, openStart, openEnd)
}

// : (ResolvedPos, ResolvedPos, number, Slice) → Slice
function fitRight($from, $to, slice) {
  var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);
  if (!fitted) { return null }
  return normalizeSlice(fitted, slice.openStart, $to.depth)
}

function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

function canMoveText($from, $to, slice) {
  if (!$to.parent.isTextblock) { return false }

  var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd)
      : $from.node($from.depth - (slice.openStart - slice.openEnd));
  if (!parent.isTextblock) { return false }
  for (var i = $to.index(); i < $to.parent.childCount; i++)
    { if (!parent.type.allowsMarks($to.parent.child(i).marks)) { return false } }
  var match;
  if (slice.openEnd) {
    match = parent.contentMatchAt(parent.childCount);
  } else {
    match = parent.contentMatchAt(parent.childCount);
    if (slice.size) { match = match.matchFragment(slice.content, slice.openStart ? 1 : 0); }
  }
  match = match.matchFragment($to.parent.content, $to.index());
  return match && match.validEnd
}

function nodeRight(content, depth) {
  for (var i = 1; i < depth; i++) { content = content.lastChild.content; }
  return content.lastChild
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// So placeSlice splits up a slice into a number of sub-slices,
// along with information on where they can be placed on the given
// left-side edge. It works by walking the open side of the slice,
// from the inside out, and trying to find a landing spot for each
// element, by simultaneously scanning over the gap side. When no
// place is found for an open node's content, it is left in that node.

// : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]
function placeSlice($from, slice) {
  var frontier = new Frontier($from);
  for (var pass = 1; slice.size && pass <= 3; pass++)
    { slice = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass); }
  while (frontier.open.length) { frontier.closeNode(); }
  return frontier.placed
}

// Helper class that models the open side of the insert position,
// keeping track of the content match and already inserted content
// at each depth.
var Frontier = function Frontier($pos) {
  var this$1 = this;

  // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]
  this.open = [];
  for (var d = 0; d <= $pos.depth; d++) {
    var parent = $pos.node(d), match = parent.contentMatchAt($pos.indexAfter(d));
    this$1.open.push({parent: parent, match: match, content: prosemirrorModel.Fragment.empty, wrapper: false, openEnd: 0, depth: d});
  }
  this.placed = [];
};

// : (Fragment, number, number, number, ?Node) → Slice
// Tries to place the content of the given slice, and returns a
// slice containing unplaced content.
//
// pass 1: try to fit directly
// pass 2: allow wrapper nodes to be introduced
// pass 3: allow unwrapping of nodes that aren't open
Frontier.prototype.placeSlice = function placeSlice (fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

  if (openStart > 0) {
    var first = fragment.firstChild;
    var inner = this.placeSlice(first.content, Math.max(0, openStart - 1),
                                openEnd && fragment.childCount == 1 ? openEnd - 1 : 0,
                                pass, first);
    if (inner.content != first.content) {
      if (inner.content.size) {
        fragment = fragment.replaceChild(0, first.copy(inner.content));
        openStart = inner.openStart + 1;
      } else {
        if (fragment.childCount == 1) { openEnd = 0; }
        fragment = fragment.cutByIndex(1);
        openStart = 0;
      }
    }
  }
  var result = this.placeContent(fragment, openStart, openEnd, pass, parent);
  if (pass > 2 && result.size && openStart == 0) {
    for (var i = 0; i < result.content.childCount; i++) {
      var child = result.content.child(i);
      this$1.placeContent(child.content, 0,
                        openEnd && i == result.content.childCount.length - 1 ? openEnd - 1 : 0,
                        pass, child);
    }
    result = prosemirrorModel.Fragment.empty;
  }
  return result
};

Frontier.prototype.placeContent = function placeContent (fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

  var i = 0;
  // Go over the fragment's children
  for (; i < fragment.childCount; i++) {
    var child = fragment.child(i), placed = false, last = i == fragment.childCount - 1;
    // Try each open node in turn, starting from the innermost
    for (var d = this.open.length - 1; d >= 0; d--) {
      var open = this$1.open[d], wrap = (void 0);

      // If pass > 1, it is allowed to wrap the node to help find a
      // fit, so if findWrappeing returns something, we add open
      // nodes to the frontier for that wrapping.
      if (pass > 1 && (wrap = open.match.findWrapping(child.type)) &&
          !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
        while (this.open.length - 1 > d) { this$1.closeNode(); }
        for (var w = 0; w < wrap.length; w++) {
          open.match = open.match.matchType(wrap[w]);
          d++;
          open = {parent: wrap[w].create(),
                  match: wrap[w].contentMatch,
                  content: prosemirrorModel.Fragment.empty, wrapper: true, openEnd: 0, depth: d + w};
          this$1.open.push(open);
        }
      }

      // See if the child fits here
      var match = open.match.matchType(child.type);
      if (!match) {
        var fill = open.match.fillBefore(prosemirrorModel.Fragment.from(child));
        if (fill) {
          for (var j = 0; j < fill.childCount; j++) {
            var ch = fill.child(j);
            this$1.addNode(open, ch, 0);
            match = open.match.matchFragment(ch);
          }
        } else if (parent && open.match.matchType(parent.type)) {
          // Don't continue looking further up if the parent node
          // would fit here.
          break
        } else {
          continue
        }
      }

      // Close open nodes above this one, since we're starting to
      // add to this.
      while (this.open.length - 1 > d) { this$1.closeNode(); }
      // Strip marks from the child or close its start when necessary
      child = child.mark(open.parent.type.allowedMarks(child.marks));
      if (openStart) {
        child = closeNodeStart(child, openStart, last ? openEnd : 0);
        openStart = 0;
      }
      // Add the child to this open node and adjust its metadata
      this$1.addNode(open, child, last ? openEnd : 0);
      open.match = match;
      if (last) { openEnd = 0; }
      placed = true;
      break
    }
    // As soon as we've failed to place a node we stop looking at
    // later nodes
    if (!placed) { break }
  }
  // Close the current open node if it's not the the root and we
  // either placed up to the end of the node or the the current
  // slice depth's node type matches the open node's type
  if (this.open.length > 1 &&
      (i > 0 && i == fragment.childCount ||
       parent && this.open[this.open.length - 1].parent.type == parent.type))
    { this.closeNode(); }

  return new prosemirrorModel.Slice(fragment.cutByIndex(i), openStart, openEnd)
};

Frontier.prototype.addNode = function addNode (open, node, openEnd) {
  open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
  open.openEnd = openEnd;
};

Frontier.prototype.closeNode = function closeNode () {
  var open = this.open.pop();
  if (open.content.size == 0) {
    // Nothing here
  } else if (open.wrapper) {
    this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
  } else {
    this.placed[open.depth] = {depth: open.depth, content: open.content, openEnd: open.openEnd};
  }
};

function closeNodeStart(node, openStart, openEnd) {
  var content = node.content;
  if (openStart > 1) {
    var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
    content = node.content.replaceChild(0, first);
  }
  var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
  return node.copy(fill.append(content))
}

function closeNodeEnd(node, depth) {
  var content = node.content;
  if (depth > 1) {
    var last = closeNodeEnd(node.lastChild, depth - 1);
    content = node.content.replaceChild(node.childCount - 1, last);
  }
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
  return node.copy(content.append(fill))
}

function closeFragmentEnd(fragment, depth) {
  return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining](#model.NodeSpec.defining), or
// including an open parent node from the slice that _is_ marked as
// [defining](#model.NodeSpec.defining).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
Transform.prototype.replaceRange = function(from, to, slice) {
  var this$1 = this;

  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (fitsTrivially($from, $to, slice))
    { return this.step(new ReplaceStep(from, to, slice)) }

  var targetDepths = coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this$1.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new prosemirrorModel.Slice(closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  return this.replace(from, to, slice)
};

function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen)
    { fragment = parent.contentMatchAt(0).fillBefore(fragment, true).append(fragment); }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
Transform.prototype.deleteRange = function(from, to) {
  var this$1 = this;

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this$1.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this$1.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d))
      { return this$1.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d)) { result.push(d); }
  }
  return result
}

exports.Transform = Transform;
exports.TransformError = TransformError;
exports.Step = Step;
exports.StepResult = StepResult;
exports.joinPoint = joinPoint;
exports.canJoin = canJoin;
exports.canSplit = canSplit;
exports.insertPoint = insertPoint;
exports.dropPoint = dropPoint;
exports.liftTarget = liftTarget;
exports.findWrapping = findWrapping;
exports.StepMap = StepMap;
exports.MapResult = MapResult;
exports.Mapping = Mapping;
exports.AddMarkStep = AddMarkStep;
exports.RemoveMarkStep = RemoveMarkStep;
exports.ReplaceStep = ReplaceStep;
exports.ReplaceAroundStep = ReplaceAroundStep;
exports.replaceStep = replaceStep;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ "b978":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-switch/mc-switch.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_switchvue_type_script_lang_js_ = ({
  name: 'McSwitch',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-switch', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-switch/mc-switch.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_switch_mc_switchvue_type_script_lang_js_ = (mc_switchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-switch/mc-switch.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_switch_mc_switchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_switch = (component.exports);
// CONCATENATED MODULE: ./components/mc-switch/index.js


/* istanbul ignore next */

mc_switch.install = function (Vue) {
  Vue.component(mc_switch.name, mc_switch);
};

/* harmony default export */ var components_mc_switch = __webpack_exports__["default"] = (mc_switch);

/***/ }),

/***/ "b97c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ "b9a8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("399f");
var HmacDRBG = __webpack_require__("6aa2");
var utils = __webpack_require__("f3a3");
var curves = __webpack_require__("0cbb");
var rand = __webpack_require__("fdac");
var assert = utils.assert;

var KeyPair = __webpack_require__("bb34");
var Signature = __webpack_require__("b73f");

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ "b9ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-badge/mc-badge.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_badgevue_type_script_lang_js_ = ({
  name: 'McBadge',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-badge', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-badge/mc-badge.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_badge_mc_badgevue_type_script_lang_js_ = (mc_badgevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-badge/mc-badge.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_badge_mc_badgevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_badge = (component.exports);
// CONCATENATED MODULE: ./components/mc-badge/index.js


/* istanbul ignore next */

mc_badge.install = function (Vue) {
  Vue.component(mc_badge.name, mc_badge);
};

/* harmony default export */ var components_mc_badge = __webpack_exports__["default"] = (mc_badge);

/***/ }),

/***/ "bac2":
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__("0145"),
  CBC: __webpack_require__("c119"),
  CFB: __webpack_require__("3505"),
  CFB8: __webpack_require__("62c9"),
  CFB1: __webpack_require__("5239"),
  OFB: __webpack_require__("5165"),
  CTR: __webpack_require__("6ade"),
  GCM: __webpack_require__("6ade")
}

var modes = __webpack_require__("e85f")

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ "bb34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("399f");
var utils = __webpack_require__("f3a3");
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ "bb44":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var common = __webpack_require__("edc9");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ "bb5d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = __webpack_require__("f08e");

// Match Set functions
var matchSetALength = function matchSetALength(string) {
	return string.match(new RegExp('^' + _constants.A_CHARS + '*'))[0].length;
};
var matchSetBLength = function matchSetBLength(string) {
	return string.match(new RegExp('^' + _constants.B_CHARS + '*'))[0].length;
};
var matchSetC = function matchSetC(string) {
	return string.match(new RegExp('^' + _constants.C_CHARS + '*'))[0];
};

// CODE128A or CODE128B
function autoSelectFromAB(string, isA) {
	var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
	var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));

	if (untilC) {
		return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
	}

	var chars = string.match(new RegExp('^' + ranges + '+'))[0];

	if (chars.length === string.length) {
		return string;
	}

	return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
}

// CODE128C
function autoSelectFromC(string) {
	var cMatch = matchSetC(string);
	var length = cMatch.length;

	if (length === string.length) {
		return string;
	}

	string = string.substring(length);

	// Select A/B depending on the longest match
	var isA = matchSetALength(string) >= matchSetBLength(string);
	return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
}

// Detect Code Set (A, B or C) and format the string

exports.default = function (string) {
	var newString = void 0;
	var cLength = matchSetC(string).length;

	// Select 128C if the string start with enough digits
	if (cLength >= 2) {
		newString = _constants.C_START_CHAR + autoSelectFromC(string);
	} else {
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) > matchSetBLength(string);
		newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
	}

	return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
	function (match, char) {
		return String.fromCharCode(203) + char;
	});
};

/***/ }),

/***/ "bb71":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ "bbf0":
/***/ (function(module, exports, __webpack_require__) {

const VersionCheck = __webpack_require__("27a3")
const Regex = __webpack_require__("0425")

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ "bc13":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "bcaa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var newPromiseCapability = __webpack_require__("a5b8");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "bd5a":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("2d9b"),
    root = __webpack_require__("6884");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "bd67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-navbar-item/mc-navbar-item.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_navbar_itemvue_type_script_lang_js_ = ({
  name: 'McNavbarItem',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-navbar-item', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-navbar-item/mc-navbar-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_navbar_item_mc_navbar_itemvue_type_script_lang_js_ = (mc_navbar_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-navbar-item/mc-navbar-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_navbar_item_mc_navbar_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_navbar_item = (component.exports);
// CONCATENATED MODULE: ./components/mc-navbar-item/index.js


/* istanbul ignore next */

mc_navbar_item.install = function (Vue) {
  Vue.component(mc_navbar_item.name, mc_navbar_item);
};

/* harmony default export */ var components_mc_navbar_item = __webpack_exports__["default"] = (mc_navbar_item);

/***/ }),

/***/ "bd86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var _core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("85f2");
/* harmony import */ var _core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0__);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _core_js_object_define_property__WEBPACK_IMPORTED_MODULE_0___default()(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "bd8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console: 0 */

var ErrorHandler = function () {
	function ErrorHandler(api) {
		_classCallCheck(this, ErrorHandler);

		this.api = api;
	}

	_createClass(ErrorHandler, [{
		key: "handleCatch",
		value: function handleCatch(e) {
			// If babel supported extending of Error in a correct way instanceof would be used here
			if (e.name === "InvalidInputException") {
				if (this.api._options.valid !== this.api._defaults.valid) {
					this.api._options.valid(false);
				} else {
					throw e.message;
				}
			} else {
				throw e;
			}

			this.api.render = function () {};
		}
	}, {
		key: "wrapBarcodeCall",
		value: function wrapBarcodeCall(func) {
			try {
				var result = func.apply(undefined, arguments);
				this.api._options.valid(true);
				return result;
			} catch (e) {
				this.handleCatch(e);

				return this.api;
			}
		}
	}]);

	return ErrorHandler;
}();

exports.default = ErrorHandler;

/***/ }),

/***/ "bd9d":
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ "bdfe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("c243");

var _encoder = __webpack_require__("5726");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for EAN8 & EAN13
var EAN = function (_Barcode) {
	_inherits(EAN, _Barcode);

	function EAN(data, options) {
		_classCallCheck(this, EAN);

		// Make sure the font is not bigger than the space between the guard bars
		var _this = _possibleConstructorReturn(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));

		_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(EAN, [{
		key: 'encode',
		value: function encode() {
			return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
		}
	}, {
		key: 'leftText',
		value: function leftText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var textOptions = { fontSize: this.fontSize };
			var guardOptions = { height: this.guardHeight };

			return [{ data: _constants.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants.SIDE_BIN, options: guardOptions }];
		}
	}, {
		key: 'encodeFlat',
		value: function encodeFlat() {
			var data = [_constants.SIDE_BIN, this.leftEncode(), _constants.MIDDLE_BIN, this.rightEncode(), _constants.SIDE_BIN];

			return {
				data: data.join(''),
				text: this.text
			};
		}
	}]);

	return EAN;
}(_Barcode3.default);

exports.default = EAN;

/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "be24":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__("320c"),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.2";


/***/ }),

/***/ "be5e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__("fd7c");

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__("ab5b7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgns = "http://www.w3.org/2000/svg";

var SVGRenderer = function () {
	function SVGRenderer(svg, encodings, options) {
		_classCallCheck(this, SVGRenderer);

		this.svg = svg;
		this.encodings = encodings;
		this.options = options;
		this.document = options.xmlDocument || document;
	}

	_createClass(SVGRenderer, [{
		key: "render",
		value: function render() {
			var currentX = this.options.marginLeft;

			this.prepareSVG();
			for (var i = 0; i < this.encodings.length; i++) {
				var encoding = this.encodings[i];
				var encodingOptions = (0, _merge2.default)(this.options, encoding.options);

				var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);

				this.setGroupOptions(group, encodingOptions);

				this.drawSvgBarcode(group, encodingOptions, encoding);
				this.drawSVGText(group, encodingOptions, encoding);

				currentX += encoding.width;
			}
		}
	}, {
		key: "prepareSVG",
		value: function prepareSVG() {
			// Clear the SVG
			while (this.svg.firstChild) {
				this.svg.removeChild(this.svg.firstChild);
			}

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			var width = totalWidth + this.options.marginLeft + this.options.marginRight;
			this.setSvgAttributes(width, maxHeight);

			if (this.options.background) {
				this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
			}
		}
	}, {
		key: "drawSvgBarcode",
		value: function drawSvgBarcode(parent, options, encoding) {
			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.fontSize + options.textMargin;
			} else {
				yFrom = 0;
			}

			var barWidth = 0;
			var x = 0;
			for (var b = 0; b < binary.length; b++) {
				x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					barWidth++;
				} else if (barWidth > 0) {
					this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
					barWidth = 0;
				}
			}

			// Last draw is needed since the barcode ends with 1
			if (barWidth > 0) {
				this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
			}
		}
	}, {
		key: "drawSVGText",
		value: function drawSVGText(parent, options, encoding) {
			var textElem = this.document.createElementNS(svgns, 'text');

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);

				if (options.textPosition == "top") {
					y = options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.fontSize;
				}

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					textElem.setAttribute("text-anchor", "start");
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					textElem.setAttribute("text-anchor", "end");
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						textElem.setAttribute("text-anchor", "middle");
					}

				textElem.setAttribute("x", x);
				textElem.setAttribute("y", y);

				textElem.appendChild(this.document.createTextNode(encoding.text));

				parent.appendChild(textElem);
			}
		}
	}, {
		key: "setSvgAttributes",
		value: function setSvgAttributes(width, height) {
			var svg = this.svg;
			svg.setAttribute("width", width + "px");
			svg.setAttribute("height", height + "px");
			svg.setAttribute("x", "0px");
			svg.setAttribute("y", "0px");
			svg.setAttribute("viewBox", "0 0 " + width + " " + height);

			svg.setAttribute("xmlns", svgns);
			svg.setAttribute("version", "1.1");

			svg.setAttribute("style", "transform: translate(0,0)");
		}
	}, {
		key: "createGroup",
		value: function createGroup(x, y, parent) {
			var group = this.document.createElementNS(svgns, 'g');
			group.setAttribute("transform", "translate(" + x + ", " + y + ")");

			parent.appendChild(group);

			return group;
		}
	}, {
		key: "setGroupOptions",
		value: function setGroupOptions(group, options) {
			group.setAttribute("style", "fill:" + options.lineColor + ";");
		}
	}, {
		key: "drawRect",
		value: function drawRect(x, y, width, height, parent) {
			var rect = this.document.createElementNS(svgns, 'rect');

			rect.setAttribute("x", x);
			rect.setAttribute("y", y);
			rect.setAttribute("width", width);
			rect.setAttribute("height", height);

			parent.appendChild(rect);

			return rect;
		}
	}]);

	return SVGRenderer;
}();

exports.default = SVGRenderer;

/***/ }),

/***/ "be98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _encoder = __webpack_require__("5726");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _UPC = __webpack_require__("e8b2");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
//
// UPC-E documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E

var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];

var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];

var UPCE = function (_Barcode) {
	_inherits(UPCE, _Barcode);

	function UPCE(data, options) {
		_classCallCheck(this, UPCE);

		var _this = _possibleConstructorReturn(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
		// Code may be 6 or 8 digits;
		// A 7 digit code is ambiguous as to whether the extra digit
		// is a UPC-A check or number system digit.


		_this.isValid = false;
		if (data.search(/^[0-9]{6}$/) !== -1) {
			_this.middleDigits = data;
			_this.upcA = expandToUPCA(data, "0");
			_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
			_this.isValid = true;
		} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
			_this.middleDigits = data.substring(1, data.length - 1);
			_this.upcA = expandToUPCA(_this.middleDigits, data[0]);

			if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
				_this.isValid = true;
			} else {
				// checksum mismatch
				return _possibleConstructorReturn(_this);
			}
		} else {
			return _possibleConstructorReturn(_this);
		}

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPCE, [{
		key: 'valid',
		value: function valid() {
			return this.isValid;
		}
	}, {
		key: 'encode',
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: 'flatEncoding',
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += this.encodeMiddleDigits();
			result += "010101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: 'guardedEncoding',
		value: function guardedEncoding() {
			var result = [];

			// Add the UPC-A number system digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[0],
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101",
				options: { height: this.guardHeight }
			});

			// Add the 6 UPC-E digits
			result.push({
				data: this.encodeMiddleDigits(),
				text: this.text.substring(1, 7),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: "010101",
				options: { height: this.guardHeight }
			});

			// Add the UPC-A check digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[7],
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}, {
		key: 'encodeMiddleDigits',
		value: function encodeMiddleDigits() {
			var numberSystem = this.upcA[0];
			var checkDigit = this.upcA[this.upcA.length - 1];
			var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
			return (0, _encoder2.default)(this.middleDigits, parity);
		}
	}]);

	return UPCE;
}(_Barcode3.default);

function expandToUPCA(middleDigits, numberSystem) {
	var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
	var expansion = EXPANSIONS[lastUpcE];

	var result = "";
	var digitIndex = 0;
	for (var i = 0; i < expansion.length; i++) {
		var c = expansion[i];
		if (c === 'X') {
			result += middleDigits[digitIndex++];
		} else {
			result += c;
		}
	}

	result = '' + numberSystem + result;
	return '' + result + (0, _UPC.checksum)(result);
}

exports.default = UPCE;

/***/ }),

/***/ "befa":
/***/ (function(module, exports, __webpack_require__) {

const Mode = __webpack_require__("bbf0")
const NumericData = __webpack_require__("dd7e")
const AlphanumericData = __webpack_require__("9d94")
const ByteData = __webpack_require__("0196")
const KanjiData = __webpack_require__("2f3a")
const Regex = __webpack_require__("0425")
const Utils = __webpack_require__("7bf0")
const dijkstra = __webpack_require__("10b0")

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),

/***/ "bf0b":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("355d");
var createDesc = __webpack_require__("aebd");
var toIObject = __webpack_require__("36c3");
var toPrimitive = __webpack_require__("1bc3");
var has = __webpack_require__("07e3");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("8e60") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "bf0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-collapse-item/mc-collapse-item.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_collapse_itemvue_type_script_lang_js_ = ({
  name: 'McCollapseItem',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-collapse-item', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-collapse-item/mc-collapse-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_collapse_item_mc_collapse_itemvue_type_script_lang_js_ = (mc_collapse_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-collapse-item/mc-collapse-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_collapse_item_mc_collapse_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_collapse_item = (component.exports);
// CONCATENATED MODULE: ./components/mc-collapse-item/index.js


/* istanbul ignore next */

mc_collapse_item.install = function (Vue) {
  Vue.component(mc_collapse_item.name, mc_collapse_item);
};

/* harmony default export */ var components_mc_collapse_item = __webpack_exports__["default"] = (mc_collapse_item);

/***/ }),

/***/ "bf4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMAGE_PREVIEW_Z_INDEX; });
// 设置图片预览的z-index，el-dialog 和 mc-modal 的 z-index 初始值一般是 2000
// eslint-disable-next-line import/prefer-default-export
var IMAGE_PREVIEW_Z_INDEX = 3000;

/***/ }),

/***/ "bf9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-confirm/mc-confirm.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_confirmvue_type_script_lang_js_ = ({
  name: 'McConfirm',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-confirm', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  },
  methods: {
    getInstance: function getInstance() {
      var _this$$refs$selfRef;

      if (this.$refs.selfRef) return (_this$$refs$selfRef = this.$refs.selfRef).getInstance.apply(_this$$refs$selfRef, arguments);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-confirm/mc-confirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_confirm_mc_confirmvue_type_script_lang_js_ = (mc_confirmvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-confirm/mc-confirm.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_confirm_mc_confirmvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_confirm = (component.exports);
// CONCATENATED MODULE: ./components/mc-confirm/index.js


/* istanbul ignore next */

mc_confirm.install = function (Vue) {
  Vue.component(mc_confirm.name, mc_confirm);
};

/* harmony default export */ var components_mc_confirm = __webpack_exports__["default"] = (mc_confirm);

/***/ }),

/***/ "c0c4":
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify 2.3.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.3/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
}(this, function () { 'use strict';

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);

  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);

  var regExpTest = unapply(RegExp.prototype.test);

  var typeErrorCreate = unconstruct(TypeError);

  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }

  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array) {
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = stringToLowerCase(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);

    var property = void 0;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);

  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'feimage', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);

  var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);

  var text = freeze(['#text']);

  var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);

  var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

  var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html$$1) {
          return html$$1;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.3.3';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;

      return DOMPurify;
    }

    var originalDocument = window.document;

    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        Text = window.Text,
        Comment = window.Comment,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;


    var ElementPrototype = Element.prototype;

    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML('') : '';

    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;


    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;

    var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
        ERB_EXPR$$1 = ERB_EXPR,
        DATA_ATTR$$1 = DATA_ATTR,
        ARIA_ATTR$$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify.
     *
     * This defaults to `true` starting DOMPurify 2.2.0. Note that setting it to `false`
     * might cause XSS from attacks hidden in closed shadowroots in case the browser
     * supports Declarative Shadow: DOM https://web.dev/declarative-shadow-dom/
     */
    var RETURN_DOM_IMPORT = true;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);

    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE = void 0;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc = void 0;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false; // Default true
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function (x) {
        return x;
      } : stringToLowerCase;

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html);
          addToSet(ALLOWED_ATTR, html$1);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl);
          addToSet(ALLOWED_ATTR, mathMl$1);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);

    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);

    var ALL_MATHML_TAGS = addToSet({}, mathMl);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: HTML_NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erronously deleted from
        // HTML namespace.
        var commonSvgAndHTMLElements = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG or MathML). Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc = void 0;
      var leadingWhitespace = void 0;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      if (elm instanceof Text || elm instanceof Comment) {
        return false;
      }

      if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function') {
        return true;
      }

      return false;
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content = void 0;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
        content = stringReplace(content, ERB_EXPR$$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        return false;

        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr = void 0;
      var value = void 0;
      var lcName = void 0;
      var l = void 0;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;

        value = stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
          value = stringReplace(value, ERB_EXPR$$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode = void 0;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty, cfg) {
      var body = void 0;
      var importedNode = void 0;
      var currentNode = void 0;
      var oldNode = void 0;
      var returnNode = void 0;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) ; else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : emptyHTML;
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (RETURN_DOM_IMPORT) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ "c109":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ "c110":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "c119":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("8c8a")

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ "c17b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.codabar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
// http://www.barcodeisland.com/codabar.phtml

var codabar = function (_Barcode) {
	_inherits(codabar, _Barcode);

	function codabar(data, options) {
		_classCallCheck(this, codabar);

		if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
			data = "A" + data + "A";
		}

		var _this = _possibleConstructorReturn(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));

		_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
		return _this;
	}

	_createClass(codabar, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
		}
	}, {
		key: "encode",
		value: function encode() {
			var result = [];
			var encodings = this.getEncodings();
			for (var i = 0; i < this.data.length; i++) {
				result.push(encodings[this.data.charAt(i)]);
				// for all characters except the last, append a narrow-space ("0")
				if (i !== this.data.length - 1) {
					result.push("0");
				}
			}
			return {
				text: this.text,
				data: result.join('')
			};
		}
	}, {
		key: "getEncodings",
		value: function getEncodings() {
			return {
				"0": "101010011",
				"1": "101011001",
				"2": "101001011",
				"3": "110010101",
				"4": "101101001",
				"5": "110101001",
				"6": "100101011",
				"7": "100101101",
				"8": "100110101",
				"9": "110100101",
				"-": "101001101",
				"$": "101100101",
				":": "1101011011",
				"/": "1101101011",
				".": "1101101101",
				"+": "1011011011",
				"A": "1011001001",
				"B": "1001001011",
				"C": "1010010011",
				"D": "1010011001"
			};
		}
	}]);

	return codabar;
}(_Barcode3.default);

exports.codabar = codabar;

/***/ }),

/***/ "c1df":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    undefined
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__("4678")("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "c207":
/***/ (function(module, exports) {



/***/ }),

/***/ "c21e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var GOOD_LEAF_SIZE = 200;

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other);

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0); }
  else
    { this.forEachInvertedInner(f, from, to, 0); }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = [];
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = /*@__PURE__*/(function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this);
    this.values = values;
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    for (var i = from; i < to; i++)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    for (var i = from - 1; i >= to; i--)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([]);

var Append = /*@__PURE__*/(function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length;
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other);
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other);
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

var ropeSequence = RopeSequence;

/* harmony default export */ __webpack_exports__["default"] = (ropeSequence);


/***/ }),

/***/ "c243":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// Standard start end and middle bits
var SIDE_BIN = exports.SIDE_BIN = '101';
var MIDDLE_BIN = exports.MIDDLE_BIN = '01010';

var BINARIES = exports.BINARIES = {
	'L': [// The L (left) type of encoding
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'G': [// The G type of encoding
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
	'R': [// The R (right) type of encoding
	'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
	'O': [// The O (odd) encoding for UPC-E
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'E': [// The E (even) encoding for UPC-E
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
};

// Define the EAN-2 structure
var EAN2_STRUCTURE = exports.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];

// Define the EAN-5 structure
var EAN5_STRUCTURE = exports.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];

// Define the EAN-13 structure
var EAN13_STRUCTURE = exports.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

/***/ }),

/***/ "c24c":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(window,function(){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var i=e[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(o,i,function(e){return t[e]}.bind(null,i));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/dist/",n(n.s=57)}([function(t,e,n){var o=n(2),i=n(11),r=n(4),s=n(13),a=n(22),c=function(t,e,n){var u,l,h,f,p=t&c.F,d=t&c.G,v=t&c.S,y=t&c.P,g=t&c.B,m=d?o:v?o[e]||(o[e]={}):(o[e]||{}).prototype,b=d?i:i[e]||(i[e]={}),w=b.prototype||(b.prototype={});for(u in d&&(n=e),n)h=((l=!p&&m&&void 0!==m[u])?m:n)[u],f=g&&l?a(h,o):y&&"function"==typeof h?a(Function.call,h):h,m&&s(m,u,h,t&c.U),b[u]!=h&&r(b,u,f),y&&w[u]!=h&&(w[u]=h)};o.core=i,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,e,n){var o=n(17)("wks"),i=n(14),r=n(2).Symbol,s="function"==typeof r;(t.exports=function(t){return o[t]||(o[t]=s&&r[t]||(s?r:i)("Symbol."+t))}).store=o},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var o=n(5),i=n(16);t.exports=n(6)?function(t,e,n){return o.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var o=n(12),i=n(35),r=n(21),s=Object.defineProperty;e.f=n(6)?Object.defineProperty:function(t,e,n){if(o(t),e=r(e,!0),o(n),i)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var o=n(39),i=n(24);t.exports=function(t){return o(i(t))}},function(t,e,n){var o=n(0);o(o.S+o.F*!n(6),"Object",{defineProperty:n(5).f})},function(t,e){var n=t.exports={version:"2.6.9"};"number"==typeof __e&&(__e=n)},function(t,e,n){var o=n(3);t.exports=function(t){if(!o(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var o=n(2),i=n(4),r=n(8),s=n(14)("src"),a=n(59),c=(""+a).split("toString");n(11).inspectSource=function(t){return a.call(t)},(t.exports=function(t,e,n,a){var u="function"==typeof n;u&&(r(n,"name")||i(n,"name",e)),t[e]!==n&&(u&&(r(n,s)||i(n,s,t[e]?""+t[e]:c.join(String(e)))),t===o?t[e]=n:a?t[e]?t[e]=n:i(t,e,n):(delete t[e],i(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||a.call(this)})},function(t,e){var n=0,o=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+o).toString(36))}},function(t,e,n){var o=n(45),i=n(28);t.exports=Object.keys||function(t){return o(t,i)}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var o=n(11),i=n(2),r=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(t.exports=function(t,e){return r[t]||(r[t]=void 0!==e?e:{})})("versions",[]).push({version:o.version,mode:n(18)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports=!1},function(t,e,n){var o=n(24);t.exports=function(t){return Object(o(t))}},function(t,e,n){"use strict";var o=n(2),i=n(8),r=n(6),s=n(0),a=n(13),c=n(62).KEY,u=n(7),l=n(17),h=n(26),f=n(14),p=n(1),d=n(43),v=n(44),y=n(63),g=n(42),m=n(12),b=n(3),w=n(19),x=n(9),S=n(21),O=n(16),k=n(30),P=n(67),E=n(49),N=n(47),j=n(5),L=n(15),T=E.f,C=j.f,_=P.f,M=o.Symbol,H=o.JSON,B=H&&H.stringify,F=p("_hidden"),I=p("toPrimitive"),R={}.propertyIsEnumerable,A=l("symbol-registry"),z=l("symbols"),D=l("op-symbols"),V=Object.prototype,W="function"==typeof M&&!!N.f,q=o.QObject,G=!q||!q.prototype||!q.prototype.findChild,K=r&&u(function(){return 7!=k(C({},"a",{get:function(){return C(this,"a",{value:7}).a}})).a})?function(t,e,n){var o=T(V,e);o&&delete V[e],C(t,e,n),o&&t!==V&&C(V,e,o)}:C,U=function(t){var e=z[t]=k(M.prototype);return e._k=t,e},Y=W&&"symbol"==typeof M.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof M},J=function(t,e,n){return t===V&&J(D,e,n),m(t),e=S(e,!0),m(n),i(z,e)?(n.enumerable?(i(t,F)&&t[F][e]&&(t[F][e]=!1),n=k(n,{enumerable:O(0,!1)})):(i(t,F)||C(t,F,O(1,{})),t[F][e]=!0),K(t,e,n)):C(t,e,n)},X=function(t,e){m(t);for(var n,o=y(e=x(e)),i=0,r=o.length;r>i;)J(t,n=o[i++],e[n]);return t},Q=function(t){var e=R.call(this,t=S(t,!0));return!(this===V&&i(z,t)&&!i(D,t))&&(!(e||!i(this,t)||!i(z,t)||i(this,F)&&this[F][t])||e)},$=function(t,e){if(t=x(t),e=S(e,!0),t!==V||!i(z,e)||i(D,e)){var n=T(t,e);return!n||!i(z,e)||i(t,F)&&t[F][e]||(n.enumerable=!0),n}},Z=function(t){for(var e,n=_(x(t)),o=[],r=0;n.length>r;)i(z,e=n[r++])||e==F||e==c||o.push(e);return o},tt=function(t){for(var e,n=t===V,o=_(n?D:x(t)),r=[],s=0;o.length>s;)!i(z,e=o[s++])||n&&!i(V,e)||r.push(z[e]);return r};W||(a((M=function(){if(this instanceof M)throw TypeError("Symbol is not a constructor!");var t=f(arguments.length>0?arguments[0]:void 0),e=function(n){this===V&&e.call(D,n),i(this,F)&&i(this[F],t)&&(this[F][t]=!1),K(this,t,O(1,n))};return r&&G&&K(V,t,{configurable:!0,set:e}),U(t)}).prototype,"toString",function(){return this._k}),E.f=$,j.f=J,n(48).f=P.f=Z,n(29).f=Q,N.f=tt,r&&!n(18)&&a(V,"propertyIsEnumerable",Q,!0),d.f=function(t){return U(p(t))}),s(s.G+s.W+s.F*!W,{Symbol:M});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)p(et[nt++]);for(var ot=L(p.store),it=0;ot.length>it;)v(ot[it++]);s(s.S+s.F*!W,"Symbol",{for:function(t){return i(A,t+="")?A[t]:A[t]=M(t)},keyFor:function(t){if(!Y(t))throw TypeError(t+" is not a symbol!");for(var e in A)if(A[e]===t)return e},useSetter:function(){G=!0},useSimple:function(){G=!1}}),s(s.S+s.F*!W,"Object",{create:function(t,e){return void 0===e?k(t):X(k(t),e)},defineProperty:J,defineProperties:X,getOwnPropertyDescriptor:$,getOwnPropertyNames:Z,getOwnPropertySymbols:tt});var rt=u(function(){N.f(1)});s(s.S+s.F*rt,"Object",{getOwnPropertySymbols:function(t){return N.f(w(t))}}),H&&s(s.S+s.F*(!W||u(function(){var t=M();return"[null]"!=B([t])||"{}"!=B({a:t})||"{}"!=B(Object(t))})),"JSON",{stringify:function(t){for(var e,n,o=[t],i=1;arguments.length>i;)o.push(arguments[i++]);if(n=e=o[1],(b(e)||void 0!==t)&&!Y(t))return g(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!Y(e))return e}),o[1]=e,B.apply(H,o)}}),M.prototype[I]||n(4)(M.prototype,I,M.prototype.valueOf),h(M,"Symbol"),h(Math,"Math",!0),h(o.JSON,"JSON",!0)},function(t,e,n){var o=n(3);t.exports=function(t,e){if(!o(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!o(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!o(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!o(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var o=n(37);t.exports=function(t,e,n){if(o(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,o){return t.call(e,n,o)};case 3:return function(n,o,i){return t.call(e,n,o,i)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(null==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var o=n(7);t.exports=function(t,e){return!!t&&o(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var o=n(5).f,i=n(8),r=n(1)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,r)&&o(t,r,{configurable:!0,value:e})}},function(t,e,n){var o=n(17)("keys"),i=n(14);t.exports=function(t){return o[t]||(o[t]=i(t))}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var o=n(12),i=n(65),r=n(28),s=n(27)("IE_PROTO"),a=function(){},c=function(){var t,e=n(36)("iframe"),o=r.length;for(e.style.display="none",n(66).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),c=t.F;o--;)delete c.prototype[r[o]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(a.prototype=o(t),n=new a,a.prototype=null,n[s]=t):n=c(),void 0===e?n:i(n,e)}},function(t,e,n){"use strict";var o=n(68),i=n(69),r=n(32),s=n(9);t.exports=n(70)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):i(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),r.Arguments=r.Array,o("keys"),o("values"),o("entries")},function(t,e){t.exports={}},function(t,e,n){n(44)("asyncIterator")},function(t,e,n){"use strict";var o=n(0),i=n(38)(0),r=n(25)([].forEach,!0);o(o.P+o.F*!r,"Array",{forEach:function(t){return i(this,t,arguments[1])}})},function(t,e,n){t.exports=!n(6)&&!n(7)(function(){return 7!=Object.defineProperty(n(36)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var o=n(3),i=n(2).document,r=o(i)&&o(i.createElement);t.exports=function(t){return r?i.createElement(t):{}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var o=n(22),i=n(39),r=n(19),s=n(40),a=n(60);t.exports=function(t,e){var n=1==t,c=2==t,u=3==t,l=4==t,h=6==t,f=5==t||h,p=e||a;return function(e,a,d){for(var v,y,g=r(e),m=i(g),b=o(a,d,3),w=s(m.length),x=0,S=n?p(e,w):c?p(e,0):void 0;w>x;x++)if((f||x in m)&&(y=b(v=m[x],x,g),t))if(n)S[x]=y;else if(y)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:S.push(v)}else if(l)return!1;return h?-1:u||l?l:S}}},function(t,e,n){var o=n(23);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==o(t)?t.split(""):Object(t)}},function(t,e,n){var o=n(41),i=Math.min;t.exports=function(t){return t>0?i(o(t),9007199254740991):0}},function(t,e){var n=Math.ceil,o=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?o:n)(t)}},function(t,e,n){var o=n(23);t.exports=Array.isArray||function(t){return"Array"==o(t)}},function(t,e,n){e.f=n(1)},function(t,e,n){var o=n(2),i=n(11),r=n(18),s=n(43),a=n(5).f;t.exports=function(t){var e=i.Symbol||(i.Symbol=r?{}:o.Symbol||{});"_"==t.charAt(0)||t in e||a(e,t,{value:s.f(t)})}},function(t,e,n){var o=n(8),i=n(9),r=n(46)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,a=i(t),c=0,u=[];for(n in a)n!=s&&o(a,n)&&u.push(n);for(;e.length>c;)o(a,n=e[c++])&&(~r(u,n)||u.push(n));return u}},function(t,e,n){var o=n(9),i=n(40),r=n(64);t.exports=function(t){return function(e,n,s){var a,c=o(e),u=i(c.length),l=r(s,u);if(t&&n!=n){for(;u>l;)if((a=c[l++])!=a)return!0}else for(;u>l;l++)if((t||l in c)&&c[l]===n)return t||l||0;return!t&&-1}}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var o=n(45),i=n(28).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return o(t,i)}},function(t,e,n){var o=n(29),i=n(16),r=n(9),s=n(21),a=n(8),c=n(35),u=Object.getOwnPropertyDescriptor;e.f=n(6)?u:function(t,e){if(t=r(t),e=s(e,!0),c)try{return u(t,e)}catch(t){}if(a(t,e))return i(!o.f.call(t,e),t[e])}},function(t,e,n){for(var o=n(31),i=n(15),r=n(13),s=n(2),a=n(4),c=n(32),u=n(1),l=u("iterator"),h=u("toStringTag"),f=c.Array,p={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=i(p),v=0;v<d.length;v++){var y,g=d[v],m=p[g],b=s[g],w=b&&b.prototype;if(w&&(w[l]||a(w,l,f),w[h]||a(w,h,g),c[g]=f,m))for(y in o)w[y]||r(w,y,o[y],!0)}},function(t,e,n){"use strict";var o=n(73),i={};i[n(1)("toStringTag")]="z",i+""!="[object z]"&&n(13)(Object.prototype,"toString",function(){return"[object "+o(this)+"]"},!0)},function(t,e,n){var o=n(19),i=n(15);n(74)("keys",function(){return function(t){return i(o(t))}})},function(t,e,n){"use strict";var o=n(0),i=n(38)(2);o(o.P+o.F*!n(25)([].filter,!0),"Array",{filter:function(t){return i(this,t,arguments[1])}})},function(t,e,n){var o=n(0);o(o.P,"Function",{bind:n(75)})},function(t,e,n){var o=n(0);o(o.S,"Object",{create:n(30)})},function(t,e,n){var o=n(0);o(o.S,"Object",{setPrototypeOf:n(81).set})},function(t,e,n){n(58),t.exports=n(82)},function(t,e){},function(t,e,n){t.exports=n(17)("native-function-to-string",Function.toString)},function(t,e,n){var o=n(61);t.exports=function(t,e){return new(o(t))(e)}},function(t,e,n){var o=n(3),i=n(42),r=n(1)("species");t.exports=function(t){var e;return i(t)&&("function"!=typeof(e=t.constructor)||e!==Array&&!i(e.prototype)||(e=void 0),o(e)&&null===(e=e[r])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var o=n(14)("meta"),i=n(3),r=n(8),s=n(5).f,a=0,c=Object.isExtensible||function(){return!0},u=!n(7)(function(){return c(Object.preventExtensions({}))}),l=function(t){s(t,o,{value:{i:"O"+ ++a,w:{}}})},h=t.exports={KEY:o,NEED:!1,fastKey:function(t,e){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!r(t,o)){if(!c(t))return"F";if(!e)return"E";l(t)}return t[o].i},getWeak:function(t,e){if(!r(t,o)){if(!c(t))return!0;if(!e)return!1;l(t)}return t[o].w},onFreeze:function(t){return u&&h.NEED&&c(t)&&!r(t,o)&&l(t),t}}},function(t,e,n){var o=n(15),i=n(47),r=n(29);t.exports=function(t){var e=o(t),n=i.f;if(n)for(var s,a=n(t),c=r.f,u=0;a.length>u;)c.call(t,s=a[u++])&&e.push(s);return e}},function(t,e,n){var o=n(41),i=Math.max,r=Math.min;t.exports=function(t,e){return(t=o(t))<0?i(t+e,0):r(t,e)}},function(t,e,n){var o=n(5),i=n(12),r=n(15);t.exports=n(6)?Object.defineProperties:function(t,e){i(t);for(var n,s=r(e),a=s.length,c=0;a>c;)o.f(t,n=s[c++],e[n]);return t}},function(t,e,n){var o=n(2).document;t.exports=o&&o.documentElement},function(t,e,n){var o=n(9),i=n(48).f,r={}.toString,s="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return s&&"[object Window]"==r.call(t)?function(t){try{return i(t)}catch(t){return s.slice()}}(t):i(o(t))}},function(t,e,n){var o=n(1)("unscopables"),i=Array.prototype;null==i[o]&&n(4)(i,o,{}),t.exports=function(t){i[o][t]=!0}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";var o=n(18),i=n(0),r=n(13),s=n(4),a=n(32),c=n(71),u=n(26),l=n(72),h=n(1)("iterator"),f=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,n,d,v,y,g){c(n,e,d);var m,b,w,x=function(t){if(!f&&t in P)return P[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},S=e+" Iterator",O="values"==v,k=!1,P=t.prototype,E=P[h]||P["@@iterator"]||v&&P[v],N=E||x(v),j=v?O?x("entries"):N:void 0,L="Array"==e&&P.entries||E;if(L&&(w=l(L.call(new t)))!==Object.prototype&&w.next&&(u(w,S,!0),o||"function"==typeof w[h]||s(w,h,p)),O&&E&&"values"!==E.name&&(k=!0,N=function(){return E.call(this)}),o&&!g||!f&&!k&&P[h]||s(P,h,N),a[e]=N,a[S]=p,v)if(m={values:O?N:x("values"),keys:y?N:x("keys"),entries:j},g)for(b in m)b in P||r(P,b,m[b]);else i(i.P+i.F*(f||k),e,m);return m}},function(t,e,n){"use strict";var o=n(30),i=n(16),r=n(26),s={};n(4)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=o(s,{next:i(1,n)}),r(t,e+" Iterator")}},function(t,e,n){var o=n(8),i=n(19),r=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),o(t,r)?t[r]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e,n){var o=n(23),i=n(1)("toStringTag"),r="Arguments"==o(function(){return arguments}());t.exports=function(t){var e,n,s;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),i))?n:r?o(e):"Object"==(s=o(e))&&"function"==typeof e.callee?"Arguments":s}},function(t,e,n){var o=n(0),i=n(11),r=n(7);t.exports=function(t,e){var n=(i.Object||{})[t]||Object[t],s={};s[t]=e(n),o(o.S+o.F*r(function(){n(1)}),"Object",s)}},function(t,e,n){"use strict";var o=n(37),i=n(3),r=n(76),s=[].slice,a={};t.exports=Function.bind||function(t){var e=o(this),n=s.call(arguments,1),c=function(){var o=n.concat(s.call(arguments));return this instanceof c?function(t,e,n){if(!(e in a)){for(var o=[],i=0;i<e;i++)o[i]="a["+i+"]";a[e]=Function("F,a","return new F("+o.join(",")+")")}return a[e](t,n)}(e,o.length,o):r(e,o,t)};return i(e.prototype)&&(c.prototype=e.prototype),c}},function(t,e){t.exports=function(t,e,n){var o=void 0===n;switch(e.length){case 0:return o?t():t.call(n);case 1:return o?t(e[0]):t.call(n,e[0]);case 2:return o?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return o?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return o?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){"use strict";n(78)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){var o=n(0),i=n(24),r=n(7),s=n(79),a="["+s+"]",c=RegExp("^"+a+a+"*"),u=RegExp(a+a+"*$"),l=function(t,e,n){var i={},a=r(function(){return!!s[t]()||"​"!="​"[t]()}),c=i[t]=a?e(h):s[t];n&&(i[n]=c),o(o.P+o.F*a,"String",i)},h=l.trim=function(t,e){return t=String(i(t)),1&e&&(t=t.replace(c,"")),2&e&&(t=t.replace(u,"")),t};t.exports=l},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){"use strict";var o=n(0),i=n(46)(!1),r=[].indexOf,s=!!r&&1/[1].indexOf(1,-0)<0;o(o.P+o.F*(s||!n(25)(r)),"Array",{indexOf:function(t){return s?r.apply(this,arguments)||0:i(this,t,arguments[1])}})},function(t,e,n){var o=n(3),i=n(12),r=function(t,e){if(i(t),!o(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,o){try{(o=n(22)(Function.call,n(49).f(Object.prototype,"__proto__").set,2))(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return r(t,n),e?t.__proto__=n:o(t,n),t}}({},!1):void 0),check:r}},function(t,e,n){"use strict";n.r(e);n(34),n(20),n(50),n(31),n(51),n(52),n(10),n(53),n(54);var o=.75,i=10,r=!0,s=!0,a=!0,c=!1,u="driver-highlighted-element-stage",l='<div id="'.concat("driver-page-overlay",'"></div>'),h='<div id="'.concat(u,'"></div>');n(33),n(77);function f(t){return(f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var p=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},d=function t(e,n){if(arguments.length>2&&void 0!==arguments[2]&&arguments[2]){for(var o=["","-webkit-","-ms-","moz-","-o-"],i=0;i<o.length;i++){var r=t(e,o[i]+n);if(r)return r}return""}var s="";return e.currentStyle?s=e.currentStyle[n]:document.defaultView&&document.defaultView.getComputedStyle&&(s=document.defaultView.getComputedStyle(e,null).getPropertyValue(n)),s&&s.toLowerCase?s.toLowerCase():s},v=function(t){return t&&"object"===f(t)&&"nodeType"in t};function y(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}var g=function(){function t(e,n,o){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.options=e,this.highlightedElement=null,this.lastHighlightedElement=null,this.hideTimer=null,this.window=n,this.document=o,this.removeNode=this.removeNode.bind(this)}var e,n,o;return e=t,(n=[{key:"attachNode",value:function(){var t=this.document.getElementById("driver-page-overlay");t||(t=p(l),document.body.appendChild(t)),this.node=t,this.node.style.opacity="0",this.options.animate||this.node.parentElement&&this.node.parentElement.removeChild(this.node)}},{key:"highlight",value:function(t){t&&t.node?t.isSame(this.highlightedElement)||(this.window.clearTimeout(this.hideTimer),t.onHighlightStarted(),this.highlightedElement&&!this.highlightedElement.isSame(this.lastHighlightedElement)&&this.highlightedElement.onDeselected(),t.getCalculatedPosition().canHighlight()&&(this.lastHighlightedElement=this.highlightedElement,this.highlightedElement=t,this.show(),this.highlightedElement.onHighlighted())):console.warn("Invalid element to highlight. Must be an instance of `Element`")}},{key:"show",value:function(){var t=this;this.node&&this.node.parentElement||(this.attachNode(),window.setTimeout(function(){t.node.style.opacity="".concat(t.options.opacity),t.node.style.position="fixed",t.node.style.left="0",t.node.style.top="0",t.node.style.bottom="0",t.node.style.right="0"}))}},{key:"getHighlightedElement",value:function(){return this.highlightedElement}},{key:"getLastHighlightedElement",value:function(){return this.lastHighlightedElement}},{key:"clear",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(this.options.onReset&&this.options.onReset(this.highlightedElement),this.highlightedElement){this.highlightedElement.onDeselected(!0)}this.highlightedElement=null,this.lastHighlightedElement=null,this.node&&(this.window.clearTimeout(this.hideTimer),this.options.animate&&!t?(this.node.style.opacity="0",this.hideTimer=this.window.setTimeout(this.removeNode,300)):this.removeNode())}},{key:"removeNode",value:function(){this.node&&this.node.parentElement&&this.node.parentElement.removeChild(this.node)}},{key:"refresh",value:function(){this.highlightedElement&&(this.highlightedElement.showPopover(),this.highlightedElement.showStage())}}])&&y(e.prototype,n),o&&y(e,o),t}();n(80);function m(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}var b=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.left,o=void 0===n?0:n,i=e.top,r=void 0===i?0:i,s=e.right,a=void 0===s?0:s,c=e.bottom,u=void 0===c?0:c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.left=o,this.right=a,this.top=r,this.bottom=u}var e,n,o;return e=t,(n=[{key:"canHighlight",value:function(){return this.left<this.right&&this.top<this.bottom}}])&&m(e.prototype,n),o&&m(e,o),t}();function w(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}var x=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.node,o=e.options,i=e.popover,r=e.stage,s=e.overlay,a=e.window,c=e.document;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.node=n,this.document=c,this.window=a,this.options=o,this.overlay=s,this.popover=i,this.stage=r,this.animationTimeout=null}var e,n,o;return e=t,(n=[{key:"isInView",value:function(){for(var t=this.node.offsetTop,e=this.node.offsetLeft,n=this.node.offsetWidth,o=this.node.offsetHeight,i=this.node;i.offsetParent;)t+=(i=i.offsetParent).offsetTop,e+=i.offsetLeft;return t>=this.window.pageYOffset&&e>=this.window.pageXOffset&&t+o<=this.window.pageYOffset+this.window.innerHeight&&e+n<=this.window.pageXOffset+this.window.innerWidth}},{key:"scrollManually",value:function(){var t=this.node.getBoundingClientRect().top+this.window.pageYOffset-this.window.innerHeight/2;this.window.scrollTo(0,t)}},{key:"bringInView",value:function(){if(this.node&&!this.isInView())if(this.node.scrollIntoView)try{this.node.scrollIntoView(this.options.scrollIntoViewOptions||{behavior:"instant",block:"center"})}catch(t){this.scrollManually()}else this.scrollManually()}},{key:"getCalculatedPosition",value:function(){var t=this.document.body,e=this.document.documentElement,n=this.window,o=this.window.pageYOffset||e.scrollTop||t.scrollTop,i=n.pageXOffset||e.scrollLeft||t.scrollLeft,r=this.node.getBoundingClientRect();return new b({top:r.top+o,left:r.left+i,right:r.left+i+r.width,bottom:r.top+o+r.height})}},{key:"getPopover",value:function(){return this.popover}},{key:"onDeselected",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.hidePopover(),t&&this.hideStage(),this.removeHighlightClasses(),this.window.clearTimeout(this.animationTimeout),this.options.onDeselected&&this.options.onDeselected(this)}},{key:"isSame",value:function(t){return!(!t||!t.node)&&t.node===this.node}},{key:"onHighlightStarted",value:function(){this.options.onHighlightStarted&&this.options.onHighlightStarted(this)}},{key:"onHighlighted",value:function(){this.isInView()||this.bringInView(),this.showPopover(),this.showStage(),this.addHighlightClasses(),this.options.onHighlighted&&this.options.onHighlighted(this)}},{key:"removeHighlightClasses",value:function(){this.node.classList.remove("driver-highlighted-element"),this.node.classList.remove("driver-position-relative");for(var t=this.document.querySelectorAll(".".concat("driver-fix-stacking")),e=0;e<t.length;e++)t[e].classList.remove("driver-fix-stacking")}},{key:"addHighlightClasses",value:function(){this.node.classList.add("driver-highlighted-element"),this.canMakeRelative()&&this.node.classList.add("driver-position-relative"),this.fixStackingContext()}},{key:"fixStackingContext",value:function(){for(var t=this.node.parentNode;t&&t.tagName&&"body"!==t.tagName.toLowerCase();){var e=d(t,"z-index"),n=parseFloat(d(t,"opacity")),o=d(t,"transform",!0),i=d(t,"transform-style",!0),r=d(t,"transform-box",!0),s=d(t,"filter",!0),a=d(t,"perspective",!0);(/[0-9]+/.test(e)||n<1||o&&"none"!==o||i&&"flat"!==i||r&&"border-box"!==r||s&&"none"!==s||a&&"none"!==a)&&t.classList.add("driver-fix-stacking"),t=t.parentNode}}},{key:"canMakeRelative",value:function(){var t=this.getStyleProperty("position");return-1===["absolute","fixed","relative"].indexOf(t)}},{key:"getStyleProperty",value:function(t){return d(this.node,t)}},{key:"showStage",value:function(){this.stage.show(this.getCalculatedPosition())}},{key:"getNode",value:function(){return this.node}},{key:"hideStage",value:function(){this.stage.hide()}},{key:"hidePopover",value:function(){this.popover&&this.popover.hide()}},{key:"showPopover",value:function(){var t=this;if(this.popover){var e=this.getCalculatedPosition(),n=300;this.options.animate&&this.overlay.lastHighlightedElement||(n=0),this.animationTimeout=this.window.setTimeout(function(){t.popover.show(e)},n)}}},{key:"getFullPageSize",value:function(){var t=this.document.body,e=this.document.documentElement;return{height:Math.max(t.scrollHeight,t.offsetHeight,e.scrollHeight,e.offsetHeight),width:Math.max(t.scrollWidth,t.offsetWidth,e.scrollWidth,e.offsetWidth)}}},{key:"getSize",value:function(){return{height:Math.max(this.node.scrollHeight,this.node.offsetHeight),width:Math.max(this.node.scrollWidth,this.node.offsetWidth)}}}])&&w(e.prototype,n),o&&w(e,o),t}();n(55),n(56);function S(t){return(S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function O(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function k(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function P(t,e){return!e||"object"!==S(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function E(t){return(E=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function N(t,e){return(N=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var j=function(t){function e(t,n,o){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=P(this,E(e).call(this))).options=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},o=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(o=o.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),o.forEach(function(e){O(t,e,n[e])})}return t}({isFirst:!0,isLast:!0,totalCount:1,currentIndex:0,offset:0,showButtons:!0,closeBtnText:"Close",doneBtnText:"Done",startBtnText:"Next &rarr;",nextBtnText:"Next &rarr;",prevBtnText:"&larr; Previous"},t),i.window=n,i.document=o,i}var n,o,i;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&N(t,e)}(e,x),n=e,(o=[{key:"attachNode",value:function(){var t=this.document.getElementById("driver-popover-item");t&&t.parentElement.removeChild(t),t=p(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";return'\n  <div id="'.concat("driver-popover-item",'" class="').concat(t,'">\n    <div class="').concat("driver-popover-tip",'"></div>\n    <div class="').concat("driver-popover-title",'">Popover Title</div>\n    <div class="').concat("driver-popover-description",'">Popover Description</div>\n    <div class="driver-clearfix ').concat("driver-popover-footer",'">\n      <button class="').concat("driver-close-btn",'">Close</button>\n      <span class="driver-btn-group ').concat("driver-navigation-btns",'">\n        <button class="').concat("driver-prev-btn",'">&larr; Previous</button>\n        <button class="').concat("driver-next-btn",'">Next &rarr;</button>\n      </span>\n    </div>\n  </div>')}(this.options.className)),document.body.appendChild(t),this.node=t,this.tipNode=t.querySelector(".".concat("driver-popover-tip")),this.titleNode=t.querySelector(".".concat("driver-popover-title")),this.descriptionNode=t.querySelector(".".concat("driver-popover-description")),this.footerNode=t.querySelector(".".concat("driver-popover-footer")),this.nextBtnNode=t.querySelector(".".concat("driver-next-btn")),this.prevBtnNode=t.querySelector(".".concat("driver-prev-btn")),this.closeBtnNode=t.querySelector(".".concat("driver-close-btn"))}},{key:"getTitleNode",value:function(){return this.titleNode}},{key:"getDescriptionNode",value:function(){return this.descriptionNode}},{key:"hide",value:function(){this.node&&(this.node.style.display="none")}},{key:"setInitialState",value:function(){this.node.style.display="block",this.node.style.left="0",this.node.style.top="0",this.node.style.bottom="",this.node.style.right="",this.node.querySelector(".".concat("driver-popover-tip")).className="driver-popover-tip"}},{key:"show",value:function(t){switch(this.attachNode(),this.setInitialState(),this.titleNode.innerHTML=this.options.title,this.descriptionNode.innerHTML=this.options.description||"",this.renderFooter(),this.options.position){case"left":case"left-top":this.positionOnLeft(t);break;case"left-center":this.positionOnLeftCenter(t);break;case"left-bottom":this.positionOnLeftBottom(t);break;case"right":case"right-top":this.positionOnRight(t);break;case"right-center":this.positionOnRightCenter(t);break;case"right-bottom":this.positionOnRightBottom(t);break;case"top":case"top-left":this.positionOnTop(t);break;case"top-center":this.positionOnTopCenter(t);break;case"top-right":this.positionOnTopRight(t);break;case"bottom":case"bottom-left":this.positionOnBottom(t);break;case"bottom-center":this.positionOnBottomCenter(t);break;case"bottom-right":this.positionOnBottomRight(t);break;case"mid-center":this.positionOnMidCenter(t);break;case"auto":default:this.autoPosition(t)}this.bringInView()}},{key:"renderFooter",value:function(){this.nextBtnNode.innerHTML=this.options.nextBtnText,this.prevBtnNode.innerHTML=this.options.prevBtnText,this.closeBtnNode.innerHTML=this.options.closeBtnText;var t=this.options.totalCount&&1!==this.options.totalCount;this.options.showButtons?(t?(this.nextBtnNode.style.display="inline-block",this.prevBtnNode.style.display="inline-block",this.closeBtnNode.classList.remove("driver-close-only-btn")):(this.nextBtnNode.style.display="none",this.prevBtnNode.style.display="none",this.closeBtnNode.classList.add("driver-close-only-btn")),this.footerNode.style.display="block",this.options.isFirst?(this.prevBtnNode.classList.add("driver-disabled"),this.nextBtnNode.innerHTML=this.options.startBtnText):this.prevBtnNode.classList.remove("driver-disabled"),this.options.isLast?this.nextBtnNode.innerHTML=this.options.doneBtnText:this.nextBtnNode.innerHTML=this.options.nextBtnText):this.footerNode.style.display="none"}},{key:"positionOnLeft",value:function(t){var e=this.getSize().width,n=this.options.padding+10;this.node.style.left="".concat(t.left-e-n,"px"),this.node.style.top="".concat(t.top+this.options.offset-this.options.padding,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("right")}},{key:"positionOnLeftBottom",value:function(t){var e=this.getSize(),n=e.width,o=this.options.padding+10;this.node.style.left="".concat(t.left-n-o,"px"),this.node.style.top="".concat(t.bottom+this.options.padding+this.options.offset-e.height,"px"),this.node.style.bottom="",this.node.style.right="",this.tipNode.classList.add("right","position-bottom")}},{key:"positionOnLeftCenter",value:function(t){var e=this.getSize(),n=e.width,o=e.height/2,i=this.options.padding+10,r=(t.bottom-t.top)/2,s=t.top-o+r+this.options.offset;this.node.style.left="".concat(t.left-n-i,"px"),this.node.style.top="".concat(s,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("right","position-center")}},{key:"positionOnRight",value:function(t){var e=this.options.padding+10;this.node.style.left="".concat(t.right+e,"px"),this.node.style.top="".concat(t.top+this.options.offset-this.options.padding,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("left")}},{key:"positionOnRightCenter",value:function(t){var e=this.getSize(),n=this.options.padding+10,o=e.height/2,i=(t.bottom-t.top)/2,r=t.top-o+i+this.options.offset;this.node.style.left="".concat(t.right+n,"px"),this.node.style.top="".concat(r,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("left","position-center")}},{key:"positionOnRightBottom",value:function(t){var e=this.options.padding+10,n=this.getSize();this.node.style.left="".concat(t.right+e,"px"),this.node.style.top="".concat(t.bottom+this.options.padding+this.options.offset-n.height,"px"),this.node.style.bottom="",this.node.style.right="",this.tipNode.classList.add("left","position-bottom")}},{key:"positionOnTop",value:function(t){var e=this.getSize().height,n=this.options.padding+10;this.node.style.top="".concat(t.top-e-n,"px"),this.node.style.left="".concat(t.left-this.options.padding+this.options.offset,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("bottom")}},{key:"positionOnTopCenter",value:function(t){var e=this.getSize(),n=e.height,o=e.width/2,i=this.options.padding+10,r=this.options.offset+t.left+(t.right-t.left)/2;this.node.style.top="".concat(t.top-n-i,"px"),this.node.style.left="".concat(r-o-this.options.padding,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("bottom","position-center")}},{key:"positionOnTopRight",value:function(t){var e=this.getSize(),n=e.height,o=this.options.padding+10;this.node.style.top="".concat(t.top-n-o,"px"),this.node.style.left="".concat(t.right+this.options.padding+this.options.offset-e.width,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("bottom","position-right")}},{key:"positionOnBottom",value:function(t){var e=this.options.padding+10;this.node.style.top="".concat(t.bottom+e,"px"),this.node.style.left="".concat(t.left-this.options.padding+this.options.offset,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("top")}},{key:"positionOnBottomCenter",value:function(t){var e=this.getSize().width/2,n=this.options.padding+10,o=this.options.offset+t.left+(t.right-t.left)/2;this.node.style.top="".concat(t.bottom+n,"px"),this.node.style.left="".concat(o-e-this.options.padding,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("top","position-center")}},{key:"positionOnBottomRight",value:function(t){var e=this.getSize(),n=this.options.padding+10;this.node.style.top="".concat(t.bottom+n,"px"),this.node.style.left="".concat(t.right+this.options.padding+this.options.offset-e.width,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("top","position-right")}},{key:"positionOnMidCenter",value:function(t){var e=this.getSize(),n=e.height,o=e.width/2,i=n/2,r=(t.bottom-t.top)/2,s=t.top-i+r+this.options.offset,a=this.options.offset+t.left+(t.right-t.left)/2;this.node.style.top="".concat(s,"px"),this.node.style.left="".concat(a-o-this.options.padding,"px"),this.node.style.right="",this.node.style.bottom="",this.tipNode.classList.add("mid-center")}},{key:"autoPosition",value:function(t){var e=this.getFullPageSize(),n=this.getSize(),o=e.height,i=n.height,r=this.options.padding+10;t.bottom+i+r>=o?this.positionOnTop(t):this.positionOnBottom(t)}}])&&k(n.prototype,o),i&&k(n,i),e}();function L(t){return(L="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function T(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function C(t,e){return!e||"object"!==L(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function _(t){return(_=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function M(t,e){return(M=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var H=function(t){function e(t,n,o){var i;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),(i=C(this,_(e).call(this))).options=t,i.window=n,i.document=o,i}var n,o,i;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&M(t,e)}(e,x),n=e,(o=[{key:"attachNode",value:function(){var t=this.document.getElementById(u);t||(t=p(h),document.body.appendChild(t)),this.node=t,this.options.animate?this.node.classList.remove("driver-stage-no-animation"):this.node.classList.add("driver-stage-no-animation")}},{key:"hide",value:function(){this.node&&this.node.parentElement&&this.node.parentElement.removeChild(this.node)}},{key:"setInitialStyle",value:function(){this.node.style.display="block",this.node.style.left="0",this.node.style.top="0",this.node.style.bottom="",this.node.style.right=""}},{key:"show",value:function(t){this.attachNode(),this.setInitialStyle();var e=2*this.options.padding,n=t.right-t.left+e,o=t.bottom-t.top+e;this.node.style.display="block",this.node.style.position="absolute",this.node.style.width="".concat(n,"px"),this.node.style.height="".concat(o,"px"),this.node.style.top="".concat(t.top-e/2,"px"),this.node.style.left="".concat(t.left-e/2,"px"),this.node.style.backgroundColor=this.options.stageBackground}}])&&T(n.prototype,o),i&&T(n,i),e}();function B(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},o=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(o=o.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),o.forEach(function(e){F(t,e,n[e])})}return t}function F(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function I(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}n.d(e,"default",function(){return R});var R=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.options=B({animate:r,opacity:o,padding:i,scrollIntoViewOptions:null,allowClose:s,keyboardControl:a,overlayClickNext:c,stageBackground:"#ffffff",onHighlightStarted:function(){return null},onHighlighted:function(){return null},onDeselected:function(){return null},onReset:function(){return null},onNext:function(){return null},onPrevious:function(){return null}},e),this.document=document,this.window=window,this.isActivated=!1,this.steps=[],this.currentStep=0,this.currentMovePrevented=!1,this.overlay=new g(this.options,window,document),this.onResize=this.onResize.bind(this),this.onKeyUp=this.onKeyUp.bind(this),this.onClick=this.onClick.bind(this),this.moveNext=this.moveNext.bind(this),this.movePrevious=this.movePrevious.bind(this),this.preventMove=this.preventMove.bind(this),this.bind()}var e,n,u;return e=t,(n=[{key:"getSteps",value:function(){return this.steps}},{key:"setSteps",value:function(t){this.steps=t}},{key:"bind",value:function(){this.window.addEventListener("resize",this.onResize,!1),this.window.addEventListener("keyup",this.onKeyUp,!1),"ontouchstart"in document.documentElement?this.window.addEventListener("touchstart",this.onClick,!1):this.window.addEventListener("click",this.onClick,!1)}},{key:"onClick",value:function(t){if(this.isActivated&&this.hasHighlightedElement()){t.stopPropagation();var e=this.overlay.getHighlightedElement(),n=this.document.getElementById("driver-popover-item"),o=e.node.contains(t.target),i=n&&n.contains(t.target);if(o||i||!this.options.overlayClickNext)if(o||i||!this.options.allowClose){var r=t.target.classList.contains("driver-next-btn"),s=t.target.classList.contains("driver-prev-btn");t.target.classList.contains("driver-close-btn")?this.reset():r?this.handleNext():s&&this.handlePrevious()}else this.reset();else this.handleNext()}}},{key:"onResize",value:function(){this.isActivated&&this.refresh()}},{key:"refresh",value:function(){this.overlay.refresh()}},{key:"onKeyUp",value:function(t){if(this.isActivated&&this.options.keyboardControl)if(27!==t.keyCode){var e=this.getHighlightedElement();e&&e.popover&&(39===t.keyCode?this.handleNext():37===t.keyCode&&this.handlePrevious())}else this.reset()}},{key:"movePrevious",value:function(){var t=this.steps[this.currentStep-1];t?(this.overlay.highlight(t),this.currentStep-=1):this.reset()}},{key:"preventMove",value:function(){this.currentMovePrevented=!0}},{key:"handleNext",value:function(){this.currentMovePrevented=!1;var t=this.steps[this.currentStep];t&&t.options&&t.options.onNext&&t.options.onNext(this.overlay.highlightedElement),this.currentMovePrevented||this.moveNext()}},{key:"handlePrevious",value:function(){this.currentMovePrevented=!1;var t=this.steps[this.currentStep];t&&t.options&&t.options.onPrevious&&t.options.onPrevious(this.overlay.highlightedElement),this.currentMovePrevented||this.movePrevious()}},{key:"moveNext",value:function(){var t=this.steps[this.currentStep+1];t?(this.overlay.highlight(t),this.currentStep+=1):this.reset()}},{key:"hasNextStep",value:function(){return!!this.steps[this.currentStep+1]}},{key:"hasPreviousStep",value:function(){return!!this.steps[this.currentStep-1]}},{key:"reset",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.currentStep=0,this.isActivated=!1,this.overlay.clear(t)}},{key:"hasHighlightedElement",value:function(){var t=this.overlay.getHighlightedElement();return t&&t.node}},{key:"getHighlightedElement",value:function(){return this.overlay.getHighlightedElement()}},{key:"getLastHighlightedElement",value:function(){return this.overlay.getLastHighlightedElement()}},{key:"defineSteps",value:function(t){this.steps=[];for(var e=0;e<t.length;e++){var n=this.prepareElementFromStep(t[e],t,e);n&&this.steps.push(n)}}},{key:"prepareElementFromStep",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,o=B({},this.options),i=t,r="string"!=typeof t&&!v(t);if(!t||r&&!t.element)throw new Error("Element is required in step ".concat(n));r&&(i=t.element,o=B({},this.options,t));var s=v(i)?i:this.document.querySelector(i);if(!s)return console.warn("Element to highlight ".concat(i," not found")),null;var a=null;if(o.popover&&o.popover.title){var c=[this.options.className,o.popover.className].filter(function(t){return t}).join(" "),u=B({},o,o.popover,{className:c,totalCount:e.length,currentIndex:n,isFirst:0===n,isLast:0===e.length||n===e.length-1});a=new j(u,this.window,this.document)}var l=B({},o),h=new H(l,this.window,this.document);return new x({node:s,options:o,popover:a,stage:h,overlay:this.overlay,window:this.window,document:this.document})}},{key:"start",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;if(!this.steps||0===this.steps.length)throw new Error("There are no steps defined to iterate");this.isActivated=!0,this.currentStep=t,this.overlay.highlight(this.steps[t])}},{key:"highlight",value:function(t){this.isActivated=!0;var e=this.prepareElementFromStep(t);e&&this.overlay.highlight(e)}}])&&I(e.prototype,n),u&&I(e,u),t}()}]).default});
//# sourceMappingURL=driver.min.js.map

/***/ }),

/***/ "c24d":
/***/ (function(module) {

module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

/***/ }),

/***/ "c26b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("86cc").f;
var create = __webpack_require__("2aeb");
var redefineAll = __webpack_require__("dcbc");
var ctx = __webpack_require__("9b43");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var $iterDefine = __webpack_require__("01f9");
var step = __webpack_require__("d53b");
var setSpecies = __webpack_require__("7a56");
var DESCRIPTORS = __webpack_require__("9e1e");
var fastKey = __webpack_require__("67ab").fastKey;
var validate = __webpack_require__("b39a");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "c27c":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("5801");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "c2ae":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("e372").PassThrough


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c367":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("8436");
var step = __webpack_require__("50ed");
var Iterators = __webpack_require__("481b");
var toIObject = __webpack_require__("36c3");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("30f1")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "c3a1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("e6f3");
var enumBugKeys = __webpack_require__("1691");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "c3c0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("da3e");
var inherits = __webpack_require__("3fb5");

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ "c3f1":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("b88a");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "c487":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-option-buttons/mc-option-buttons.vue?vue&type=template&id=230ffea0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-option-buttons"},[_vm._l((_vm.groupButtons.tiles),function(buttonInfo){return _c('buttonItem',{key:buttonInfo.key,attrs:{"button-info":buttonInfo,"size":_vm.size}})}),(_vm.groupButtons.opts.length)?_c('mtd-dropdown',{staticStyle:{"vertical-align":"baseline"},attrs:{"trigger":"hover"}},[_c('mc-button',{attrs:{"size":_vm.size,"type":"text"}},[_c('span',{staticStyle:{"margin-right":"4px"}},[_vm._v("更多")]),_c('mtd-icon',{attrs:{"name":"down"}})],1),_c('mtd-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.groupButtons.opts),function(buttonInfo){return _c('mtd-dropdown-menu-item',{key:buttonInfo.key},[_c('buttonItem',{attrs:{"button-info":buttonInfo,"size":_vm.size,"is-extra":true}})],1)}),1)],1):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-option-buttons/mc-option-buttons.vue?vue&type=template&id=230ffea0&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.symbol.async-iterator.js
var es7_symbol_async_iterator = __webpack_require__("ac4d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__("8a81");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("d225");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js
var createClass = __webpack_require__("b0b4");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./components/mc-option-buttons/composable/authModel.js









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// 权限共享模型
// @author: cuichengliang


function toArray(data) {
  return Array.isArray(data) ? data : [data];
}

var authModel_AuthModel =
/*#__PURE__*/
function () {
  function AuthModel() {
    Object(classCallCheck["a" /* default */])(this, AuthModel);

    // 格式 { code: boolean }
    // 示例 {
    //     'mall.fe.pc_1f9b6f4c88a3547dfff8dfee0a80e0d9': true,
    //     'mall.fe.pc_d7f62f9488ba1f6e6d53ba8426772713': false,
    // }
    this.codeMap = {};
  } // 找到当前未被存储的权限，初始化并返回


  Object(createClass["a" /* default */])(AuthModel, [{
    key: "innerGetNewCodeList",
    value: function innerGetNewCodeList(codes) {
      var _this = this;

      if (!codes) return [];
      var codeList = toArray(codes);
      var result = [];
      codeList.forEach(function (code) {
        // const currentCode = code;
        if (!code || typeof code !== 'string') return;

        if (_this.codeMap[code] === undefined) {
          _this.codeMap[code] = false;
          result.push(code);
        }
      });
      return result;
    } // 添加某些权限 并存储
    // codes: [ code1, code2 ]

  }, {
    key: "add",
    value: function () {
      var _add = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(codes) {
        var authType,
            codeList,
            params,
            requestPathMap,
            response,
            newMap,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                authType = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'sso';
                codeList = this.innerGetNewCodeList(codes);

                if (codeList.length) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                params = {
                  authCodeList: codeList,
                  systemSource: 0
                };
                requestPathMap = {
                  sso: '/api/auth/check/codePermission',
                  passport: '/api/auth/check/codePermissionForClient'
                };
                _context.next = 8;
                return external_vue_default.a.prototype.$hPost(requestPathMap[authType], params).catch(function (err) {
                  return err;
                });

              case 8:
                response = _context.sent;

                if (!(response instanceof Error)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                newMap = response.authList.reduce(function (result, auth) {
                  result[auth.authCode] = auth.res;
                  return result;
                }, {});
                this.codeMap = _objectSpread({}, this.codeMap, {}, newMap);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function add(_x) {
        return _add.apply(this, arguments);
      }

      return add;
    }() // 判断是否拥有某些权限
    // mode可以取值 every(全部都有) 和 some(至少有一个)

  }, {
    key: "get",
    value: function () {
      var _get = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(codes) {
        var _this2 = this;

        var mode,
            codeList,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mode = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'every';

                if (codes) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", true);

              case 3:
                _context2.next = 5;
                return this.add(codes);

              case 5:
                codeList = toArray(codes);
                return _context2.abrupt("return", codeList[mode](function (code) {
                  return !!_this2.codeMap[code];
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }]);

  return AuthModel;
}();

/* harmony default export */ var authModel = (new authModel_AuthModel());
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-option-buttons/components/ButtonItem.vue?vue&type=template&id=4963a62e&
var ButtonItemvue_type_template_id_4963a62e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opt-item",class:{ isExtra: _vm.isExtra }},[(_vm.buttonInfo.type === 'link')?_c('mc-link',_vm._b({attrs:{"disabled":_vm.buttonInfo.isDisabled}},'mc-link',_vm.bindData,false),[_vm._v("\n        "+_vm._s(_vm.buttonInfo.label)+"\n    ")]):(_vm.buttonInfo.type === 'button')?_c('mc-button',_vm._g(_vm._b({attrs:{"loading":_vm.isLoading,"disabled":_vm.buttonInfo.isDisabled},on:{"click":function($event){return _vm.triggerClickFn(_vm.buttonInfo)}}},'mc-button',_vm.bindData,false),_vm.buttonInfo.listeners),[_vm._v("\n        "+_vm._s(_vm.buttonInfo.label)+"\n    ")]):_c(_vm.buttonInfo.type,_vm._g(_vm._b({tag:"component",attrs:{"disabled":_vm.buttonInfo.isDisabled},on:{"click":function($event){return _vm.triggerClickFn(_vm.buttonInfo)}}},'component',_vm.bindData,false),_vm.buttonInfo.listeners))],1)}
var ButtonItemvue_type_template_id_4963a62e_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-option-buttons/components/ButtonItem.vue?vue&type=template&id=4963a62e&

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-option-buttons/components/ButtonItem.vue?vue&type=script&lang=js&








function ButtonItemvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ButtonItemvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ButtonItemvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ButtonItemvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ButtonItemvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McOptionButton',
  components: {},
  props: {
    buttonInfo: {
      type: Object,
      default: function _default() {}
    },
    size: {
      type: String,
      default: 'default'
    },
    isExtra: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var isLoading = Object(composition_api_["ref"])(false);

    function triggerClickFn(_x) {
      return _triggerClickFn.apply(this, arguments);
    }

    function _triggerClickFn() {
      _triggerClickFn = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(button) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (button.clickFn) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (button.clickFn.constructor.name === 'AsyncFunction') {
                  isLoading.value = true;
                }

                _context.next = 5;
                return button.clickFn(this);

              case 5:
                isLoading.value = false;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      return _triggerClickFn.apply(this, arguments);
    }

    var original = Object(composition_api_["reactive"])({
      bindData: Object(composition_api_["computed"])(function () {
        var initProps = props.buttonInfo.type === 'button' ? {
          type: 'text',
          size: props.size
        } : {
          size: props.size
        };
        return ButtonItemvue_type_script_lang_js_objectSpread({}, initProps, {}, props.buttonInfo.props);
      })
    });
    var originalRefs = Object(composition_api_["toRefs"])(original);
    return ButtonItemvue_type_script_lang_js_objectSpread({
      isLoading: isLoading,
      triggerClickFn: triggerClickFn
    }, originalRefs);
  }
}));
// CONCATENATED MODULE: ./components/mc-option-buttons/components/ButtonItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ButtonItemvue_type_script_lang_js_ = (ButtonItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-option-buttons/components/ButtonItem.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_ButtonItemvue_type_script_lang_js_,
  ButtonItemvue_type_template_id_4963a62e_render,
  ButtonItemvue_type_template_id_4963a62e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ButtonItem = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-option-buttons/mc-option-buttons.vue?vue&type=script&lang=js&










function mc_option_buttonsvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mc_option_buttonsvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mc_option_buttonsvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mc_option_buttonsvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mc_option_buttonsvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McOptionButtons',
  components: {
    buttonItem: ButtonItem
  },
  props: {
    source: {
      type: Object,
      // default: Object,
      required: true
    },
    // 该函数要求返回结果
    // [{
    //     label: string 按钮文案
    //     type: 'button' | 'link' | other  按钮,链接或者任意组件
    //     props:  {} 传参
    //     listeners:  {} 事件传参
    //     permission: boolean,string,array 按钮独立权限
    //     displayRule: function,  额外自定义控制显示的函数
    //     clickFn: function,  点击按钮触发的函数
    // }]
    buttonRender: {
      type: Function,
      default: null
    },
    // 按钮显示数量（超过后会出现更多按钮）
    maxShow: {
      type: Number,
      default: 5
    },
    // 按钮禁用模式（auto|hidden|disabled）
    disabledMode: {
      type: String,
      default: 'auto',
      validator: function validator(val) {
        return ['auto', 'hidden', 'disabled'].includes(val);
      }
    },
    // 对按钮整体size的控制，优先级低于单独prop设定
    size: {
      type: String,
      default: 'default'
    },
    // 权限接口账号体系（sso|passport），用于区分芥末/灯塔的不同鉴权接口
    authType: {
      type: String,
      default: 'sso',
      validator: function validator(val) {
        return ['sso', 'passport'].includes(val);
      }
    }
  },
  setup: function setup(props) {
    var authProxy = Object(composition_api_["reactive"])(authModel);
    var buttonList = Object(composition_api_["computed"])(function () {
      var source = props.source,
          buttonRender = props.buttonRender;
      if (!source || !buttonRender) return [];
      return buttonRender(source);
    }); // 添加并请求当前权限的验证

    var permissionList = Object(tools_["uniq"])(Object(tools_["flattenDeep"])(buttonList.value.map(function (item) {
      return item.permission;
    })));
    authProxy.add(permissionList, props.authType);
    var validButtons = Object(composition_api_["computed"])(function () {
      var source = props.source,
          disabledMode = props.disabledMode;
      var formatButtons = buttonList.value.map(function (button) {
        // 赋予唯一key
        button.key = Symbol('uniKey'); // 判断按钮独立权限

        var validAuth = function () {
          if (Object(tools_["isBoolean"])(button.permission)) return button.permission;

          if (button.permission) {
            var permissionArr = Array.isArray(button.permission) ? button.permission : [button.permission];
            return permissionArr.some(function (permission) {
              return authProxy.codeMap[permission];
            });
          }

          return true;
        }(); // 判断自定义逻辑


        var validExt = button.displayRule ? button.displayRule(source) : true;
        var banStatus = !validExt;
        var banAuth = !validAuth;
        button.isDisabled = false;
        button.isHidden = false;

        if (disabledMode === 'auto') {
          button.isDisabled = banAuth;
          button.isHidden = banStatus;
        }

        if (disabledMode === 'hidden') {
          button.isHidden = banStatus || banAuth;
        }

        if (disabledMode === 'disabled') {
          button.isDisabled = banStatus || banAuth;
        }

        return button;
      });
      return formatButtons.filter(function (item) {
        return !item.isHidden;
      });
    });
    var original = Object(composition_api_["reactive"])({
      groupButtons: Object(composition_api_["computed"])(function () {
        var maxShow = props.maxShow;
        var result = {
          tiles: [],
          opts: []
        };

        if (validButtons.value.length <= maxShow) {
          result.tiles = validButtons.value;
        } else {
          result.tiles = validButtons.value.slice(0, maxShow - 1);
          result.opts = validButtons.value.slice(maxShow - 1);
        }

        return result;
      })
    });
    var originalRefs = Object(composition_api_["toRefs"])(original);
    return mc_option_buttonsvue_type_script_lang_js_objectSpread({}, originalRefs);
  }
}));
// CONCATENATED MODULE: ./components/mc-option-buttons/mc-option-buttons.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_option_buttons_mc_option_buttonsvue_type_script_lang_js_ = (mc_option_buttonsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-option-buttons/mc-option-buttons.vue





/* normalize component */

var mc_option_buttons_component = Object(componentNormalizer["a" /* default */])(
  mc_option_buttons_mc_option_buttonsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_option_buttons = (mc_option_buttons_component.exports);
// CONCATENATED MODULE: ./components/mc-option-buttons/index.js


/* istanbul ignore next */

mc_option_buttons.install = function (Vue) {
  Vue.component(mc_option_buttons.name, mc_option_buttons);
};

/* harmony default export */ var components_mc_option_buttons = __webpack_exports__["default"] = (mc_option_buttons);

/***/ }),

/***/ "c5f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var has = __webpack_require__("69a8");
var cof = __webpack_require__("2d95");
var inheritIfRequired = __webpack_require__("5dbc");
var toPrimitive = __webpack_require__("6a99");
var fails = __webpack_require__("79e5");
var gOPN = __webpack_require__("9093").f;
var gOPD = __webpack_require__("11e9").f;
var dP = __webpack_require__("86cc").f;
var $trim = __webpack_require__("aa77").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("2aeb")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("9e1e") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("2aba")(global, NUMBER, $Number);
}


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c6b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-textarea/mc-textarea.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_textareavue_type_script_lang_js_ = ({
  name: 'McTextarea',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-textarea组件已经弃用，请使用mc-input组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/8jQEoCWVoLDRp7wj0MgC0', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-textarea', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-textarea/mc-textarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_textarea_mc_textareavue_type_script_lang_js_ = (mc_textareavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-textarea/mc-textarea.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_textarea_mc_textareavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_textarea = (component.exports);
// CONCATENATED MODULE: ./components/mc-textarea/index.js


/* istanbul ignore next */

mc_textarea.install = function (Vue) {
  Vue.component(mc_textarea.name, mc_textarea);
};

/* harmony default export */ var components_mc_textarea = __webpack_exports__["default"] = (mc_textarea);

/***/ }),

/***/ "c7aa":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ "c8aa":
/***/ (function(module, exports, __webpack_require__) {

const Utils = __webpack_require__("7bf0")
const ECCode = __webpack_require__("34fc")
const ECLevel = __webpack_require__("7a43")
const Mode = __webpack_require__("bbf0")
const VersionCheck = __webpack_require__("27a3")

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8bb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("54a1");

/***/ }),

/***/ "c8f3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ "c9d8":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "ca08":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("4a9d");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "ca32":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var defaults = {
	width: 2,
	height: 100,
	format: "auto",
	displayValue: true,
	fontOptions: "",
	font: "monospace",
	text: undefined,
	textAlign: "center",
	textPosition: "bottom",
	textMargin: 2,
	fontSize: 20,
	background: "#ffffff",
	lineColor: "#000000",
	margin: 10,
	marginTop: undefined,
	marginBottom: undefined,
	marginLeft: undefined,
	marginRight: undefined,
	valid: function valid() {}
};

exports.default = defaults;

/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "ca5d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__("ab5b"),m=__webpack_require__("320c"),r=__webpack_require__("4029");function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.2",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.2";


/***/ }),

/***/ "ca9b":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3e6c"),
    isObject = __webpack_require__("56ea");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "ca9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js
var helper = __webpack_require__("2638");
var helper_default = /*#__PURE__*/__webpack_require__.n(helper);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("20d6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__("8615");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("4f7f");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("75fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__("a8db");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// EXTERNAL MODULE: ./node_modules/async-validator/es/index.js
var es = __webpack_require__("a15e");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ./node_modules/@mcfe/tools-rules/dist/index.js
var dist = __webpack_require__("fe11");

// CONCATENATED MODULE: ./components/mc-edit-table/utils/validate.js


// @lsfe/rules说明：http://npm.sankuai.com/v2/pkg/detail?name=%40lsfe%2Frules


function combineRulesByColumns(columns) {
  var rules = (columns || []).reduce(function (rulesList, column) {
    var rule = column.rule || column.rules;

    if (rule) {
      rulesList[column.prop] = rule.map(function (opt) {
        var method = opt.method,
            _opt$options = opt.options,
            options = _opt$options === void 0 ? {} : _opt$options;
        var len = options.len,
            min = options.min,
            max = options.max;
        var numExp = /^(-|\+)?\d+(\.\d+)?$/;
        var minIsNum = numExp.test(min);
        var maxIsNum = numExp.test(max);
        var message = opt.message;

        if (!message) {
          // 如果没有指定message ，则处理默认的message信息
          switch (method) {
            case 'isRequired':
              message = "\u8BF7\u586B\u5199".concat(column.label);
              break;

            case 'typeValid':
              // 使用 @lsfe/rules 默认提示
              break;

            case 'decimalLen':
              if (+len > 0) {
                message = "\u8BF7\u586B\u5199".concat(len, "\u4F4D\u5C0F\u6570");
              }

              break;

            case 'range':
              if (minIsNum && !maxIsNum) {
                message = "\u8BF7\u586B\u5199\u5927\u4E8E".concat(min, "\u7684\u6570");
              } else if (!minIsNum && maxIsNum) {
                message = "\u8BF7\u586B\u5199\u5C0F\u4E8E".concat(max, "\u7684\u6570");
              } else {
                message = "\u8BF7\u586B\u5199".concat(min, " - ").concat(max, "\u7684\u6570");
              }

              break;

            default:
              message = '填写信息有误';
          }
        }

        return dist["a" /* default */][method](options, message);
      });
    }

    return rulesList;
  }, {});
  return rules;
}
/**
 * 定位错误
 */

function focusErrorFn(_x, _x2, _x3) {
  return _focusErrorFn.apply(this, arguments);
}

function _focusErrorFn() {
  _focusErrorFn = Object(asyncToGenerator["a" /* default */])(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(props, mcTablePro, rowIndex) {
    var source, table, _table$paginationDef, pageSize, currentPage, page, el;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            source = props.source.ajax ? 'remote' : 'local';
            table = mcTablePro.value;

            if (!table) {
              _context.next = 9;
              break;
            }

            _table$paginationDef = table.paginationDef, pageSize = _table$paginationDef.pageSize, currentPage = _table$paginationDef.currentPage;

            if (source === 'local') {
              page = Math.floor(rowIndex / pageSize) + 1;
              if (currentPage !== page) table.handlePageChange(page);
            }

            _context.next = 7;
            return Object(composition_api_["nextTick"])();

          case 7:
            el = table.$el.querySelector('.mc-edit-table-has-error-container');

            if (el) {
              el.scrollIntoView();
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _focusErrorFn.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-edit-table/mc-edit-table.vue?vue&type=script&lang=js&




















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



 // import Validator from '@mcfe/tools-rules';


/* harmony default export */ var mc_edit_tablevue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McEditTable',
  props: {
    /**
     * 新增一行的默认数据项
     */
    defaultRow: {
      type: [Object, Function],
      default: function _default() {
        return {};
      }
    },

    /**
     * 自定义新增一行配置
     */
    rowCreatorProps: {
      type: [Object, Boolean],
      default: false
    },

    /**
     * 校验规则 和element form组件rule一致
     * 增强：自定义 validator 添加了rowData 的回传
     */
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * 校验前的过滤钩子函数
     */
    beforeValidate: {
      type: Function,
      default: function _default(data) {
        return data;
      }
    },

    /**
     * 错误提示样式
     * top: 在表格内输入框上方
     * bottom: 在表格内输入框下方
     * toast: 输入框仅标红，通过message tost提示
     * none: 校验函数只返回结果，没有任何提示
     */
    tipStyle: {
      type: String,
      validator: function validator(value) {
        return ['top', 'bottom', 'toast', 'none'].includes(value);
      },
      default: 'bottom'
    },
    editable: {
      // 整个表单的编辑状态
      type: Boolean,
      default: true
    },
    editFlag: {
      type: String,
      // 单行根据editFlag传入的字段是否为true来判断，是否展示编辑状态
      default: ''
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rowKey: {
      type: [Function, String],
      default: null
    },
    source: {
      required: true,
      type: Array,
      // 仅支持本地数据，不支持远程数据
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, ctx) {
    var mcTablePro = Object(composition_api_["ref"])(null);

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy; // let errorMap = ref({});


    var errorMap = Object(composition_api_["reactive"])({
      value: {}
    });
    var editColumns = Object(composition_api_["computed"])(function () {
      return props.columns.map(function (item) {
        // column配置中的editable属性，优先级高于table中的editable属性
        if (item.hasOwnProperty('editable')) return item;
        item.tableEditable = props.editable;
        return item;
      });
    });
    Object(composition_api_["watch"])(function () {
      return props.source;
    }, function (newVal) {
      Object(tools_["debounce"])(function () {
        ctx.emit('editChangeEvent', newVal);
      }, 1000);
    }, {
      deep: true
    });
    /** 将所有规则合并 */

    var combinedRules = Object(composition_api_["computed"])(function () {
      var columns = props.columns;
      var localRules = combineRulesByColumns(columns);
      return _objectSpread({}, props.rules, {}, localRules);
    });
    /** 获取表格主key */

    var getRowKey = function getRowKey(row) {
      var rowKey = props.rowKey;

      if (!rowKey) {
        return null;
      }

      if (typeof rowKey === 'string') {
        // 支持多级.操作
        var keyList = rowKey.split('.');
        return keyList.reduce(function (preVal, key) {
          return preVal && preVal[key];
        }, row);
      }

      return rowKey(row);
    };
    /**
     * 构建table-pro的 scopedSlots
     * 自动添加 template 列的 slots
     */


    var scopedSlots = Object(composition_api_["computed"])(function () {
      var $scopedSlots = ctx.slots;
      var editorSlot = editColumns.value.filter(function (item) {
        return item.template;
      }).reduce(function (slots, column) {
        // 当输入config为true时，需默认转为输入框类型
        var initTemplate = {
          component: 'mc-input'
        };
        var options = Object(tools_["isPlainObject"])(column.template) ? column.template : initTemplate;
        var component = options.component,
            _options$attrs = options.attrs,
            attrs = _options$attrs === void 0 ? {} : _options$attrs,
            _options$events = options.events,
            events = _options$events === void 0 ? {} : _options$events,
            _options$style = options.style,
            style = _options$style === void 0 ? {} : _options$style;
        var List = Object(tools_["get"])(options, 'attrs.list', []); // select、checkboxGroup radiogroup的子节点配置项统一为 {label:'文本',value:'1'}

        var Source = Object(tools_["get"])(options, 'attrs.source', []); // mc组件的列表数据统一来源为source

        var child = List.map(function (item) {
          var label = item.label,
              value = item.value,
              source = item.source,
              listProps = Object(objectWithoutProperties["a" /* default */])(item, ["label", "value", "source"]);

          switch (component) {
            case 'mtd-radio-group':
              return Object(composition_api_["h"])('mtd-radio', {
                attrs: {
                  value: value
                },
                props: _objectSpread({}, listProps)
              }, label);

            case 'mtd-checkbox-group':
              return Object(composition_api_["h"])('mtd-checkbox', {
                attrs: {
                  value: value
                },
                props: _objectSpread({}, listProps)
              }, label);

            case 'mc-radio-group':
              return Object(composition_api_["h"])('mc-radio', {
                attrs: {
                  value: value
                },
                props: _objectSpread({}, listProps)
              }, label);

            case 'mc-checkbox-group':
              return Object(composition_api_["h"])('mc-checkbox', {
                attrs: {
                  value: value
                },
                props: _objectSpread({}, listProps)
              }, label);

            case 'mc-select':
              return Object(composition_api_["h"])('mc-option', {
                props: _objectSpread({
                  label: label,
                  source: source
                }, listProps)
              });

            default:
              return '';
          }
        });

        slots[column.prop] = function (scope) {
          var rowKey = getRowKey(scope.row) || scope.$index + scope.offset;
          var errorMsg = errorMap.value["".concat(column.prop, "_").concat(rowKey)];
          var scopeRowValue = scope.row[column.prop];

          var childText = function childText() {
            switch (component) {
              case 'mtd-radio-group':
                var res = List.find(function (item) {
                  return item.value === scopeRowValue;
                });
                return res ? res.label : '--';

              case 'mc-select':
                var resSelect = Source.find(function (item) {
                  return item.value === scopeRowValue;
                });
                return resSelect ? resSelect.label : '--';

              case 'mtd-checkbox-group':
                return Object(tools_["map"])(scopeRowValue, function (valueItem) {
                  var listItem = List.find(function (item) {
                    return item.value === valueItem;
                  });
                  return listItem ? listItem.label : valueItem;
                }).join(',');

              case 'mc-radio-group':
                var resMC = List.find(function (item) {
                  return item.value === scopeRowValue;
                });
                return resMC ? resMC.label : '--';

              case 'mc-checkbox-group':
                return Object(tools_["map"])(scopeRowValue, function (valueItem) {
                  var listItem = List.find(function (item) {
                    return item.value === valueItem;
                  });
                  return listItem ? listItem.label : valueItem;
                }).join(',');

              default:
                return scopeRowValue;
            }
          };

          var vnode; // editable为false时渲染为文本表格, 以及行编辑字段

          if (!Object(tools_["get"])(column, 'tableEditable', true) || !Object(tools_["get"])(column, 'editable', true) || props.editFlag && !scope.row[props.editFlag]) {
            vnode = Object(composition_api_["h"])('span', {
              props: {
                scope: scope
              }
            }, childText());
          } else {
            if (component && typeof component === 'function') {
              // 这个场景无法触发数据变化event
              vnode = component.call({
                $createElement: composition_api_["h"]
              }, rowKey, scopeRowValue, column.prop, props.source);
            } else if ($scopedSlots[column.prop]) {
              vnode = $scopedSlots[column.prop](scope);
            } else {
              vnode = Object(composition_api_["h"])(component, {
                attrs: _objectSpread({
                  key: "".concat(column.prop, "-").concat(rowKey),
                  value: scope.row[column.prop],
                  scope: scope,
                  disabled: typeof column.disabled === 'undefined' ? scope.row["".concat(column.prop, "Disabled")] === true : column.disabled
                }, attrs, {
                  style: style
                }),
                props: _objectSpread({}, attrs, {
                  key: "".concat(column.prop, "-").concat(rowKey),
                  value: scope.row[column.prop],
                  scope: scope,
                  style: style,
                  disabled: typeof column.disabled === 'undefined' ? scope.row["".concat(column.prop, "Disabled")] === true : column.disabled
                }),
                style: style,
                on: _objectSpread({
                  input: function input(v) {
                    return scope.row[column.prop] = v;
                  }
                }, events, {
                  change: function change(v) {
                    return _change(v, scope, events);
                  }
                })
              }, child);
            }
          }

          return Object(composition_api_["h"])('div', {
            class: errorMsg ? ['mc-edit-table-has-error-container'] : ''
          }, [vnode, Object(composition_api_["h"])('div', {
            class: ['mc-edit-table-error-msg', "mc-edit-table-".concat(props.tipStyle)]
          }, errorMsg)]);
        };

        return slots;
      }, {});
      return _objectSpread({}, $scopedSlots, {}, editorSlot);
    }); // 校验后修改errors

    var toastErrors = function toastErrors(errorMap) {
      // toast 提示错误
      proxy.$mtd.message.error({
        message: "\n                    ".concat(Object(toConsumableArray["a" /* default */])(new Set(Object.values(errorMap))).join('<br/>'), "\n                "),
        dangerouslyUseHTMLString: true
      });
    };

    var handleValidateParam = function handleValidateParam(value, type) {
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref = Object(asyncToGenerator["a" /* default */])(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var _mcTablePro$value$pag, pageSize, currentPage, offset, data, rowKey, _offset, $index, row;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _mcTablePro$value$pag = mcTablePro.value.paginationDef, pageSize = _mcTablePro$value$pag.pageSize, currentPage = _mcTablePro$value$pag.currentPage;
                  offset = (currentPage - 1) * pageSize;
                  data = {};
                  rowKey = null;

                  if (!(type === 'row')) {
                    _context.next = 17;
                    break;
                  }

                  if (!(typeof value === 'number')) {
                    _context.next = 14;
                    break;
                  }

                  if (!(value > pageSize)) {
                    _context.next = 9;
                    break;
                  }

                  reject('只能是当前页的index');
                  return _context.abrupt("return");

                case 9:
                  rowKey = offset + value;
                  data = mcTablePro.value.curTableData[value];
                  resolve({
                    data: data,
                    rowKey: rowKey
                  });
                  _context.next = 15;
                  break;

                case 14:
                  if (Object(esm_typeof["a" /* default */])(value) === 'object') {
                    rowKey = getRowKey(value.row) || offset + value.$index;
                    data = value.row;
                    resolve({
                      data: data,
                      rowKey: rowKey
                    });
                  } else {
                    reject('请输入‘index/scope’类型');
                  }

                case 15:
                  _context.next = 18;
                  break;

                case 17:
                  if (type === 'cell') {
                    _offset = value.offset, $index = value.$index, row = value.row;
                    rowKey = getRowKey(row) || _offset + $index;
                    resolve({
                      data: row,
                      rowKey: rowKey
                    });
                  } else {
                    data = props.source;
                    resolve({
                      data: data,
                      offset: offset
                    });
                  }

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }; // 校验全表单


    var validateFn =
    /*#__PURE__*/
    function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(callback) {
        var focusError,
            validator,
            _ref3,
            data,
            offset,
            task,
            validateRes,
            errorList,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                focusError = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;

                if (Object.keys(combinedRules.value).length) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", {
                  valid: true,
                  errors: []
                });

              case 3:
                validator = new es_default.a(combinedRules.value);
                _context2.next = 6;
                return handleValidateParam('', 'table');

              case 6:
                _ref3 = _context2.sent;
                data = _ref3.data;
                offset = _ref3.offset;
                data = data.map(function (row, index) {
                  row.rowKey = getRowKey(row) || offset + index; // 没有配置rowKey则使用行索引

                  return row;
                });
                _context2.next = 12;
                return props.beforeValidate(data);

              case 12:
                data = _context2.sent;
                task = data.map(function (row, index) {
                  return new Promise(function (resolve) {
                    validator.validate(row, {
                      firstFields: true
                    }, function (errors) {
                      if (!errors) {
                        resolve(null);
                        return;
                      }

                      resolve({
                        index: row.rowKey,
                        errors: errors
                      });
                    });
                  });
                });
                _context2.next = 16;
                return Promise.all(task);

              case 16:
                validateRes = _context2.sent;
                errorList = validateRes.filter(function (err) {
                  return err;
                });
                errorMap.value = errorList.reduce(function (map, rowError) {
                  rowError.errors.forEach(function (error) {
                    map["".concat(error.field, "_").concat(rowError.index)] = error.message || '';
                  });
                  return map;
                }, {}); // 定位到第一个错误的地方

                if (errorList.length && focusError) focusErrorFn(props, mcTablePro, errorList[0] && errorList[0].index);
                if (props.tipStyle === 'toast' && errorList.length) toastErrors(errorMap.value);

                if (typeof callback === 'function') {
                  callback(errorList.length === 0, errorList);
                }

                return _context2.abrupt("return", {
                  valid: errorList.length === 0,
                  errors: errorList
                });

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function validateFn(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     *  校验单行
     *  param入参类型为数字时，按照index处理
     *  param入参类型为对象时，按照scope处理
     * */


    var validateRow =
    /*#__PURE__*/
    function () {
      var _ref4 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(param) {
        var validateParamData, validator, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (Object.keys(combinedRules.value).length) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", {
                  valid: true,
                  errors: []
                });

              case 2:
                _context3.next = 4;
                return handleValidateParam(param, 'row');

              case 4:
                validateParamData = _context3.sent;
                validator = new es_default.a(combinedRules.value);
                _context3.next = 8;
                return validator.validate(validateParamData.data, {
                  firstFields: true
                }, function (errors) {
                  if (!errors) {
                    props.columns.forEach(function (item) {
                      delete errorMap.value["".concat(item.prop, "_").concat(validateParamData.rowKey)];
                    });
                  } else {
                    errors.forEach(function (error) {
                      errorMap.value["".concat(error.field, "_").concat(validateParamData.rowKey)] = error.message || '';
                    });

                    if (props.tipStyle === 'toast') {
                      toastErrors(errorMap.value);
                    }
                  } // 保证errorMap处于响应式的


                  errorMap.value = _objectSpread({}, errorMap.value);
                }).catch(function (err) {
                  return {
                    valid: !err.errors.length,
                    errors: err.fields
                  };
                });

              case 8:
                result = _context3.sent;
                return _context3.abrupt("return", result || {
                  valid: true,
                  errors: null
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function validateRow(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    /** * 校验单个字段 */


    var validateCell =
    /*#__PURE__*/
    function () {
      var _ref5 = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(scope) {
        var prop, validateParamData, validator, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                prop = scope.column.prop;

                if (combinedRules.value[prop]) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", {
                  valid: true,
                  errors: []
                });

              case 3:
                _context4.next = 5;
                return handleValidateParam(scope, 'cell');

              case 5:
                validateParamData = _context4.sent;
                validator = new es_default.a(Object(defineProperty["a" /* default */])({}, prop, combinedRules.value[prop]));
                _context4.next = 9;
                return validator.validate(validateParamData.data, {
                  firstFields: true
                }, function (errors) {
                  if (errors) {
                    var errorMsg = errors[0] && errors[0].message || '';

                    if (props.tipStyle === 'toast') {
                      toastErrors(errorMsg);
                    }

                    errorMap.value["".concat(prop, "_").concat(validateParamData.rowKey)] = errorMsg;
                  } else {
                    delete errorMap.value["".concat(prop, "_").concat(validateParamData.rowKey)];
                  }

                  errorMap.value = _objectSpread({}, errorMap.value);
                }).catch(function (res) {
                  return (// errors直接返回错误的message
                    {
                      valid: !res.errors.length,
                      errors: res.errors[0] && res.errors[0].message
                    }
                  );
                });

              case 9:
                result = _context4.sent;
                return _context4.abrupt("return", result || {
                  valid: true,
                  errors: null
                });

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function validateCell(_x5) {
        return _ref5.apply(this, arguments);
      };
    }();

    var clearValidate = function clearValidate() {
      errorMap.value = {};
    };

    var getData = function getData() {
      return mcTablePro.value.source;
    };

    var tableDataChange = function tableDataChange(opts) {
      var data = getData();
      ctx.emit('input', data);
      ctx.emit('change', data, opts);
    };

    var addRow = function addRow(value) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'add';
      var _mcTablePro$value$pag2 = mcTablePro.value.paginationDef,
          pageSize = _mcTablePro$value$pag2.pageSize,
          currentPage = _mcTablePro$value$pag2.currentPage;

      if (index >= pageSize) {
        console.error('只能在当前页进行新增和复制，传入的index超出pageSize，请重新操作');
        return;
      }

      var offset = (currentPage - 1) * pageSize;
      var data = getData();
      data.splice(offset + index, 0, value || props.defaultRow);
      tableDataChange({
        __index: index,
        __type: type,
        row: value
      });
      clearValidate();
    };

    var addDefaultRow = function addDefaultRow() {
      addRow(props.defaultRow, 0);
    };

    var copyRow = function copyRow(scope) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var value = Object(tools_["cloneDeep"])(scope.row);
      addRow(value, index, 'copy');
    };

    var updateRow = function updateRow(scope, value) {
      var data = getData();
      var index = null;
      var rowKeyScope = getRowKey(scope);

      if (rowKeyScope) {
        index = data.findIndex(function (item) {
          return getRowKey(item) === rowKeyScope;
        });
      } // 如果没有设置rowKey，直接通过scope获取需要删除行的位置


      if (!index) index = scope.offset + scope.$index;
      data.splice(index, 1, value);
      tableDataChange({
        __index: index,
        __type: 'update',
        row: data[index]
      });
      validateRow(index, 'index');
    };

    var deleteRow = function deleteRow(scope, find) {
      var data = getData();
      var index = null;
      var rowKeyScope = getRowKey(scope);

      if (rowKeyScope) {
        index = data.findIndex(function (item) {
          return getRowKey(item) === rowKeyScope;
        });
      } // 如果没有设置rowKey，直接通过scope获取需要删除行的位置


      if (!index) index = scope.offset + scope.$index;

      if (index >= 0) {
        data.splice(index, 1);
        tableDataChange({
          __index: index,
          __type: 'delete',
          row: scope
        }); // 如果删除行存在异常提示数据，需要进行清除

        var needDeleteErrorKeyList = Object.keys(errorMap.value).filter(function (error) {
          return Number(error.split('_')[1]) === index;
        });
        needDeleteErrorKeyList.forEach(function (key) {
          return delete errorMap.value[key];
        });
        var curTableData = mcTablePro.value.curTableData;

        if (!curTableData.length) {
          // 当前页数据被清空时  需要跳到前一页
          var currentPage = mcTablePro.value.paginationDef.currentPage;

          if (currentPage > 1) {
            mcTablePro.value.handlePageChange(currentPage - 1);
          }
        }
      }
    };
    /**
     *  column自定义编辑列数据变化时触发
     *  v：数据变化后的值
     *  scope：数据变化后当前行的数据
     * */


    var _change = function _change(v, scope, events) {
      if (events.change && typeof events.change === 'function') events.change();
      validateCell(scope);
      var property = scope.column.prop;
      ctx.emit('editChange', v, property, scope);
      tableDataChange({
        __index: scope.$index,
        value: v,
        __type: 'edit',
        changeField: property,
        row: scope.row
      });
    };

    var editTableInstance = Object(composition_api_["toRefs"])(Object(composition_api_["reactive"])({
      mcTablePro: mcTablePro,
      getRowKey: getRowKey,
      editColumns: editColumns,
      scopedSlots: scopedSlots,
      toastErrors: toastErrors,
      validateFn: validateFn,
      validateRow: validateRow,
      validateCell: validateCell,
      clearValidate: clearValidate,
      addRow: addRow,
      deleteRow: deleteRow,
      copyRow: copyRow,
      updateRow: updateRow,
      addDefaultRow: addDefaultRow
    }));
    return _objectSpread({}, editTableInstance);
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "ref": "mcEditTable"
    }, [h("mc-table-pro", helper_default()([{}, {
      attrs: _objectSpread({}, this.$attrs, {
        columns: this.editColumns,
        source: this.source,
        rowCreatorProps: this.rowCreatorProps
      }),
      on: _objectSpread({}, this.$listeners),
      scopedSlots: this.scopedSlots
    }, {
      "class": "edit-table",
      "ref": "mcTablePro"
    }]), [h("template", {
      "slot": "prefix"
    }, [this.$slots.prefix]), h("template", {
      "slot": "prefixRight"
    }, [this.$slots.prefixRight]), this.rowCreatorProps ? h("template", {
      "slot": "rowCreatorProps"
    }, [h("mtd-button", {
      "class": "mc-edit-table-creator-row-btn-".concat(this.rowCreatorProps.position || 'bottom'),
      "style": {
        width: '100%'
      },
      "attrs": {
        "dashed": true
      },
      "on": {
        "click": this.addDefaultRow
      }
    }, [this.rowCreatorProps.creatorButtonText || '+ 新增一行'])]) : null])]);
  }
}));
// CONCATENATED MODULE: ./components/mc-edit-table/mc-edit-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_edit_table_mc_edit_tablevue_type_script_lang_js_ = (mc_edit_tablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-edit-table/mc-edit-table.vue
var mc_edit_table_render, staticRenderFns




/* normalize component */

var mc_edit_table_component = Object(componentNormalizer["a" /* default */])(
  mc_edit_table_mc_edit_tablevue_type_script_lang_js_,
  mc_edit_table_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_edit_table = (mc_edit_table_component.exports);
// CONCATENATED MODULE: ./components/mc-edit-table/index.js


/* istanbul ignore next */

mc_edit_table.install = function (Vue) {
  Vue.component(mc_edit_table.name, mc_edit_table);
};

/* harmony default export */ var components_mc_edit_table = __webpack_exports__["default"] = (mc_edit_table);

/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "cc09":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("3f63"),
    isObjectLike = __webpack_require__("b5d6");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "cc63":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ccb4":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("ca9b"),
    isMasked = __webpack_require__("1053"),
    isObject = __webpack_require__("56ea"),
    toSource = __webpack_require__("a146");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "ccb9":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("5168");


/***/ }),

/***/ "cce0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-sku-select/mc-sku-select.vue?vue&type=template&id=3dfad5a3&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-sku-select"},[_c('mc-select',_vm._g(_vm._b({ref:"selectRef",attrs:{"source":_vm.source,"filterable":true,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"value-key":_vm.selectType,"reserve-keyword":true,"collapse-tags":""},on:{"change":_vm.skuChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-select',_vm.$attrs,false),_vm.$listeners),[(_vm.slots.empty)?_c('template',{slot:"empty"},[_vm._t("empty")],2):_vm._e(),(_vm.slots.loading)?_c('template',{slot:"loading"},[_vm._t("loading")],2):_vm._e()],2),(!_vm.multiple&&_vm.showExtraInfo)?_c('div',{staticClass:"mc-sku-select-extra-info"},[_c('mc-tooltip',{attrs:{"content":"文字内容","placement":"top","disabled":!_vm.skuInfo||!_vm.skuLink}},[_c('template',{slot:"content"},[_c('span',[(_vm.showSkuLink&&_vm.skuLink)?_c('a',{attrs:{"href":_vm.skuLink,"target":"_blank"}},[_vm._v("详情链接")]):_vm._e(),_c('br'),(_vm.infoText)?_c('span',[_vm._v("\n                        "+_vm._s(_vm.infoText||'')+"\n                    ")]):_vm._e()])]),_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("商品信息")])],2)],1):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-sku-select/mc-sku-select.vue?vue&type=template&id=3dfad5a3&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-sku-select/mc-sku-select.vue?vue&type=script&lang=js&









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mc_sku_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McSkuSelect',
  props: {
    value: {
      type: [Number, String, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: String,
      default: 'skuId',
      validator: function validator(value) {
        return ['skuId', 'skuName'].includes(value);
      }
    },
    showSkuId: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入skuId或者商品名称'
    },
    // 多选模式下不展示 展示额外信息
    showExtraInfo: {
      type: Boolean,
      default: false
    },
    // 多选模式下不展示
    skuInfoConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showSkuLink: {
      type: Boolean,
      default: false
    },
    skuLinkProcessor: {
      type: Function,
      default: function _default() {
        return '';
      }
    },
    responseProcessor: {
      type: Function,
      default: function _default(res) {
        return res;
      }
    }
  },
  setup: function setup(props, ctx) {
    var selectRef = Object(composition_api_["ref"])(null);
    var innerValue = Object(composition_api_["ref"])(props.value);
    var skuList = Object(composition_api_["ref"])([]);

    var getParamValueList = function getParamValueList(val, info) {
      if (props.multiple) {
        if (Array.isArray(val) && val.length) {
          info.paging = _objectSpread({}, info.paging, {
            limit: val.length
          });
          return (val || []).map(function (item) {
            return {
              paramName: props.selectType === 'skuId' ? 'skuId' : 'skuNameLike',
              paramValue: item
            };
          });
        }
      }

      var reg = /^[1-9]\d*$/;
      return [{
        paramName: reg.test(val) ? 'skuId' : 'skuNameLike',
        paramValue: val
      }];
    };

    var buildParams = function buildParams(params, extendsParams) {
      if (extendsParams.query) {
        params.paramValueList = getParamValueList(extendsParams.query);
      } else if (props.value) {
        params.paramValueList = getParamValueList(props.value, params);
      }

      return params;
    };

    var skuInfo = Object(composition_api_["computed"])(function () {
      return (skuList.value || []).find(function (item) {
        return item[props.selectType] === innerValue.value;
      });
    });
    var infoText = Object(composition_api_["computed"])(function () {
      return Object.keys(props.skuInfoConfig).map(function (key) {
        return "".concat(props.skuInfoConfig[key], "\uFF1A").concat((skuInfo.value || {})[key] || '--');
      }).join('，');
    });
    var skuLink = Object(composition_api_["computed"])(function () {
      var url = '';

      if (props.skuLinkProcessor && typeof props.skuLinkProcessor === 'function') {
        url = props.skuLinkProcessor(skuInfo.value);
      }

      return url;
    });

    var responseProcessor = function responseProcessor(res) {
      var _ref = res || {},
          items = _ref.items;

      if (props.responseProcessor && typeof props.responseProcessor === 'function') {
        items = props.responseProcessor(items);
      }

      var skuLists = (items || []).map(function (item) {
        return _objectSpread({
          label: "".concat(props.showSkuId ? "".concat(item.skuId, "-") : '').concat(item.skuName)
        }, item);
      });
      skuList.value = skuLists;
      ctx.emit('loaded', skuLists);
      return skuLists;
    };

    var source = Object(composition_api_["reactive"])({
      ajax: {
        type: 'hPost',
        url: '/api/m/product/productapi/sku/base/list',
        params: {
          paramValueList: [{
            paramName: props.selectType === 'skuId' ? 'skuId' : 'skuNameLike',
            paramValue: ''
          }],
          paging: {
            offset: 0,
            limit: 10,
            pagination: true
          }
        },
        options: {}
      },
      responseProcessor: responseProcessor,
      buildParams: buildParams
    });

    var skuChange = function skuChange(sku, item) {
      ctx.emit('input', sku);
      ctx.emit('change', sku, item);
    };

    var reset = function reset() {
      selectRef.value.reset();
    };

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val;
    }, {
      immediate: true,
      deep: true
    });
    return {
      skuInfo: skuInfo,
      infoText: infoText,
      skuLink: skuLink,
      selectRef: selectRef,
      innerValue: innerValue,
      source: source,
      skuChange: skuChange,
      reset: reset,
      slots: ctx.slots
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-sku-select/mc-sku-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_sku_select_mc_sku_selectvue_type_script_lang_js_ = (mc_sku_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-sku-select/mc-sku-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_sku_select_mc_sku_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_sku_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-sku-select/index.js


/* istanbul ignore next */

mc_sku_select.install = function (Vue) {
  Vue.component(mc_sku_select.name, mc_sku_select);
};

/* harmony default export */ var components_mc_sku_select = __webpack_exports__["default"] = (mc_sku_select);

/***/ }),

/***/ "ccff":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__("1afe");

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__("fa49");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),

/***/ "cd1c":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("e853");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "cd5c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupManage = undefined;

var _extends2 = __webpack_require__("41b2");

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__("8bbf");

var _vue2 = _interopRequireDefault(_vue);

var _popper = __webpack_require__("d2e4");

var _popper2 = _interopRequireDefault(_popper);

var _dom = __webpack_require__("8fe5");

var _popupManage = __webpack_require__("860a");

var _popupManage2 = _interopRequireDefault(_popupManage);

var _util = __webpack_require__("db8d");

var _config = __webpack_require__("512a");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable indent */
var isServer = _vue2.default.prototype.$isServer;

var defaultPopperOptions = {
  computeStyle: {
    gpuAcceleration: false
  },
  preventOverflow: {
    // enabled: false,
    boundariesElement: 'viewport'
  },
  hide: {
    enabled: false
  }
  // flip: { behavior: ['right', 'left', 'bottom', 'top'] },
};
exports.PopupManage = _popupManage2.default;
exports.default = {
  props: {
    visible: Boolean,
    appendToContainer: {
      type: Boolean,
      default: true
    },
    getPopupContainer: Function,
    placement: {
      type: String,
      default: 'bottom-start',
      validator: function validator(value) {
        return (/^(top|bottom|left|right)(-start|-end)?$/g.test(value)
        );
      }
    },
    popperOptions: Object,
    trigger: {
      // 暂定，触发 update:visible 事件的方式
      type: String,
      default: 'custom',
      validator: function validator(v) {
        return ['click', 'hover', 'focus', 'custom'].includes(v);
      }
    },
    popperDisabled: Boolean,
    showArrow: Boolean,
    openDelay: Number,
    closeDelay: {
      type: Number,
      default: 200 // 防止由于快速关闭而导致不能移入到 drop 元素上
    },
    toggleOnReferenceClick: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.$on('esc', this.handleEscClose);
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  activated: function activated() {
    this.init();
  },


  // call destroy in keep-alive mode
  deactivated: function deactivated() {
    this.destroy();
  },


  inject: {
    config: {
      from: _config.CONFIG_PROVIDER,
      default: {}
    }
  },

  data: function data() {
    return {
      popperVisible: false,
      options: {} // popper options
    };
  },

  computed: {
    getContainer: function getContainer() {
      return this.getPopupContainer || this.config.getPContainer || (0, _config.getConfig)().getPopupContainer;
    }
  },
  watch: {
    visible: function visible(val) {
      val ? this.updatePopper() : this.destroyPopper();
    },
    popperDisabled: function popperDisabled(n) {
      n ? this.removePopperListener() : this.addPopperListener();
    },
    placement: function placement() {
      if (this.popperJS) {
        this.popperJS.options.placement = this.placement;
        this.updatePopper();
      }
    }
  },
  methods: {
    init: function init() {
      if (this.visible) {
        // 会存在 activated 后立即执行 beforeDestroy 的情况。
        // 详见: https://tt.sankuai.com/ticket/detail?id=3892540
        this.updatePopper();
      }
      var popperDisabled = this.popperDisabled;

      popperDisabled ? this.removePopperListener() : this.addPopperListener();
    },
    destroy: function destroy() {
      _popupManage2.default.close(this);
      if (this.popperJS) {
        this.popperJS.destroy();
        this.popperJS = null;
      }
      this.removePopperListener();
    },
    getReference: function getReference() {
      return this.$refs.reference || this.reference;
    },
    getDrop: function getDrop() {
      return this.$refs.drop || this.drop;
    },
    createPopper: function createPopper() {
      var _this = this;

      var reference = this.getReference();
      var drop = this.getDrop();
      if (!reference || !drop) {
        console.error('need reference or drop element');
        return;
      }
      if (this.popperJS && this.popperJS.hasOwnProperty('destroy')) {
        this.popperJS.destroy();
      }

      // append to popupcontainer
      if (this.appendToContainer) {
        var getContainer = this.getContainer;
        var parent = getContainer();
        parent.appendChild(drop);
      }
      var options = this.options;

      var modifiers = (0, _util.mergeDeep)(
      // {
      //   ...defaultPopperOptions,
      // },
      (0, _util.deepCopy)(defaultPopperOptions), (0, _extends3.default)({}, this.popperOptions));
      modifiers.arrow = (0, _extends3.default)({}, modifiers.arrow, {
        enabled: this.showArrow
      });
      options.modifiers = modifiers;

      options.placement = this.placement;
      options.removeOnDestroy = true;
      options.onCreate = function () {
        _this.$nextTick(_this.updatePopper);
        _this.$emit('created', _this);
      };
      this.popperJS = new _popper2.default(reference, drop, options);
    },
    updatePopper: function updatePopper() {
      if (isServer || !this.visible) {
        // 存在 nextTick 中调用 updatePopper 的情况，此时 visible 有出现 false 的可能
        return;
      }
      var popperJS = this.popperJS;

      if (popperJS) {
        popperJS.enableEventListeners();
        popperJS.scheduleUpdate();
        if (!this.popperVisible) {
          _popupManage2.default.open(this);
          if (popperJS.popper) {
            popperJS.popper.style.zIndex = _popupManage2.default.nextZIndex();
          }
        }
        this.popperVisible = true;
      } else {
        this.createPopper();
      }
      this.$emit('show');
    },
    destroyPopper: function destroyPopper() {
      clearTimeout(this._timer);
      if (this.popperJS) {
        this.popperJS.disableEventListeners();
      }
      this.popperVisible = false;
      _popupManage2.default.close(this);
      this.$emit('hide');
    },
    handleEscClose: function handleEscClose() {
      this.visible && this.hideDrop();
    },
    handleReferenceClick: function handleReferenceClick() {
      if (this.toggleOnReferenceClick || !this.visible) {
        this.$emit('update:visible', !this.visible);
      }
    },
    handleDocumentClick: function handleDocumentClick(e) {
      if (!this.visible) {
        return;
      }
      var reference = this.getReference();
      var drop = this.getDrop();

      var target = e.target;

      if (reference.contains(target) || drop.contains(target)) {
        return;
      }
      this.$emit('clickoutside', e);
      this.$emit('update:visible', false);
    },
    handlerDropMouseEnter: function handlerDropMouseEnter() {
      /**
       * tofix: https://tt.sankuai.com/ticket/detail?id=4057761
       * 关闭延迟为 0 时，不可移入
       * */
      if (this.closeDelay === 0) {
        return;
      }
      this.showDrop();
    },
    showDrop: function showDrop() {
      var _this2 = this;

      clearTimeout(this._timer);
      if (this.visible) {
        return;
      }
      if (this.openDelay) {
        this._timer = setTimeout(function () {
          _this2.$emit('update:visible', true);
        }, this.openDelay);
      } else {
        this.$emit('update:visible', true);
      }
    },
    hideDrop: function hideDrop() {
      var _this3 = this;

      clearTimeout(this._timer);
      if (!this.visible) {
        return;
      }
      if (this.closeDelay) {
        this._timer = setTimeout(function () {
          _this3.$emit('update:visible', false);
        }, this.closeDelay);
      } else {
        this.$emit('update:visible', false);
      }
    },
    addPopperClickListener: function addPopperClickListener() {
      var reference = this.getReference();

      (0, _dom.on)(reference, 'click', this.handleReferenceClick);
      /* 这个地方必须用 mousedown 事件替换 click 事件，
        详见: https://tt.sankuai.com/ticket/detail?id=3846583
      */
      (0, _dom.on)(document, 'mousedown', this.handleDocumentClick);
    },
    addPopperHoverListener: function addPopperHoverListener() {
      var reference = this.getReference();
      var drop = this.getDrop();

      (0, _dom.on)(reference, 'mouseenter', this.showDrop);
      (0, _dom.on)(drop, 'mouseenter', this.handlerDropMouseEnter);
      (0, _dom.on)(reference, 'mouseleave', this.hideDrop);
      (0, _dom.on)(drop, 'mouseleave', this.hideDrop);
    },
    addPopperFocusListener: function addPopperFocusListener() {
      var reference = this.getReference();
      (0, _dom.on)(reference, 'focus', this.showDrop);
      (0, _dom.on)(reference, 'blur', this.hideDrop);
    },
    addPopperListener: function addPopperListener() {
      var reference = this.getReference();
      if (reference) {
        switch (this.trigger) {
          case 'click':
            this.addPopperClickListener();
            break;
          case 'hover':
            this.addPopperHoverListener();
            break;
          case 'focus':
            // 暂时不管能否 focus
            this.addPopperFocusListener();
            break;
        }
      }
    },
    removePopperListener: function removePopperListener() {
      var reference = this.getReference();
      var drop = this.getDrop();
      (0, _dom.off)(reference, 'click', this.handleReferenceClick);
      (0, _dom.off)(reference, 'mouseleave', this.hideDrop);
      (0, _dom.off)(reference, 'mouseenter', this.showDrop);
      (0, _dom.off)(drop, 'mouseleave', this.hideDrop);
      (0, _dom.off)(drop, 'mouseenter', this.handlerDropMouseEnter);
      (0, _dom.off)(document, 'mousedown', this.handleDocumentClick);
    }
  }
};

/***/ }),

/***/ "cd78":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var isObject = __webpack_require__("f772");
var newPromiseCapability = __webpack_require__("656e");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "cd91":
/***/ (function(module) {

module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "ce3e":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3e6c"),
    isObjectLike = __webpack_require__("b5d6");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "ce7e":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("63b6");
var core = __webpack_require__("584a");
var fails = __webpack_require__("294c");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "cea4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-transfer/mc-transfer.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_transfervue_type_script_lang_js_ = ({
  name: 'McTransfer',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-transfer', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-transfer/mc-transfer.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_transfer_mc_transfervue_type_script_lang_js_ = (mc_transfervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-transfer/mc-transfer.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_transfer_mc_transfervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_transfer = (component.exports);
// CONCATENATED MODULE: ./components/mc-transfer/index.js


/* istanbul ignore next */

mc_transfer.install = function (Vue) {
  Vue.component(mc_transfer.name, mc_transfer);
};

/* harmony default export */ var components_mc_transfer = __webpack_exports__["default"] = (mc_transfer);

/***/ }),

/***/ "cf1e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ "cf51":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ "cf75":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ "cfbd":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5");

var asn1 = __webpack_require__("7f7a");
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),

/***/ "d055":
/***/ (function(module, exports, __webpack_require__) {


const canPromise = __webpack_require__("67dd")

const QRCode = __webpack_require__("aa63")
const CanvasRenderer = __webpack_require__("4146")
const SvgRenderer = __webpack_require__("4006")

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),

/***/ "d17b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("e372").Transform


/***/ }),

/***/ "d1c8":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("3fb5");

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),

/***/ "d21f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-breadcrumb-item/mc-breadcrumb-item.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_breadcrumb_itemvue_type_script_lang_js_ = ({
  name: 'McBreadcrumbItem',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-breadcrumb-item', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-breadcrumb-item/mc-breadcrumb-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_breadcrumb_item_mc_breadcrumb_itemvue_type_script_lang_js_ = (mc_breadcrumb_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-breadcrumb-item/mc-breadcrumb-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_breadcrumb_item_mc_breadcrumb_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_breadcrumb_item = (component.exports);
// CONCATENATED MODULE: ./components/mc-breadcrumb-item/index.js


/* istanbul ignore next */

mc_breadcrumb_item.install = function (Vue) {
  Vue.component(mc_breadcrumb_item.name, mc_breadcrumb_item);
};

/* harmony default export */ var components_mc_breadcrumb_item = __webpack_exports__["default"] = (mc_breadcrumb_item);

/***/ }),

/***/ "d225":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "d263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__("386b")('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),

/***/ "d26a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d2d4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ "d2d5":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1654");
__webpack_require__("549b");
module.exports = __webpack_require__("584a").Array.from;


/***/ }),

/***/ "d2e4":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

return Popper;

})));
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d424":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("3fb5")
var Buffer = __webpack_require__("8707").Buffer

var Base = __webpack_require__("6430")

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ "d485":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("7e25").EventEmitter;
var inherits = __webpack_require__("3fb5");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("e372");
Stream.Writable = __webpack_require__("2c63");
Stream.Duplex = __webpack_require__("0960");
Stream.Transform = __webpack_require__("d17b");
Stream.PassThrough = __webpack_require__("c2ae");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "d4c0":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d5ed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-col/mc-col.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_colvue_type_script_lang_js_ = ({
  name: 'McCol',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-col', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-col/mc-col.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_col_mc_colvue_type_script_lang_js_ = (mc_colvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-col/mc-col.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_col_mc_colvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_col = (component.exports);
// CONCATENATED MODULE: ./components/mc-col/index.js


/* istanbul ignore next */

mc_col.install = function (Vue) {
  Vue.component(mc_col.name, mc_col);
};

/* harmony default export */ var components_mc_col = __webpack_exports__["default"] = (mc_col);

/***/ }),

/***/ "d69a":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ "d6b1":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("5801");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "d6b6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ "d6c0":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = __webpack_require__("7bf0").getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),

/***/ "d70e":
/***/ (function(module) {

module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

/***/ }),

/***/ "d716":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ "d71a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-container/mc-container.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_containervue_type_script_lang_js_ = ({
  name: 'McContainer',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-container', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-container/mc-container.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_container_mc_containervue_type_script_lang_js_ = (mc_containervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-container/mc-container.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_container_mc_containervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_container = (component.exports);
// CONCATENATED MODULE: ./components/mc-container/index.js


/* istanbul ignore next */

mc_container.install = function (Vue) {
  Vue.component(mc_container.name, mc_container);
};

/* harmony default export */ var components_mc_container = __webpack_exports__["default"] = (mc_container);

/***/ }),

/***/ "d864":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("79aa");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "d8ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-message/mc-message.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_messagevue_type_script_lang_js_ = ({
  name: 'McMessage',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-message', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-message/mc-message.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_message_mc_messagevue_type_script_lang_js_ = (mc_messagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-message/mc-message.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_message_mc_messagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_message = (component.exports);
// CONCATENATED MODULE: ./components/mc-message/index.js


/* istanbul ignore next */

mc_message.install = function (Vue) {
  Vue.component(mc_message.name, mc_message);
};

/* harmony default export */ var components_mc_message = __webpack_exports__["default"] = (mc_message);

/***/ }),

/***/ "d8d6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1654");
__webpack_require__("6c1c");
module.exports = __webpack_require__("ccb9").f('iterator');


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "d9d4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = undefined;

var _isNan = __webpack_require__("f848");

var _isNan2 = _interopRequireDefault(_isNan);

exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isFunction = isFunction;
exports.isUndef = isUndef;
exports.isDef = isDef;
exports.isString = isString;
exports.isExist = isExist;
exports.isPromise = isPromise;
exports.isDate = isDate;
exports.isValidDate = isValidDate;
exports.isNaN = isNaN;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isNumber(v) {
  return typeof v === 'number';
}

function isObject(v) {
  return Object(v) === v;
}

function isFunction(v) {
  return typeof v === 'function';
}

function isUndef(v) {
  return typeof v === 'undefined';
}

function isDef(v) {
  return !isUndef(v);
}

function isString(v) {
  return typeof v === 'string';
}

function isExist(v) {
  return isDef(v) && v !== null && v !== '';
}

function isPromise(v) {
  return isObject(v) && !v._isVue && isFunction(v.then) && isFunction(v.catch);
}

function isDate(v) {
  return v instanceof Date;
}

function isValidDate(v) {
  return v && v.getTime && !isNaN(v.getTime());
}

function isNaN(v) {
  return (0, _isNan2.default)(v);
}
// check native isArray first
var isArray = exports.isArray = Array.isArray || function (value) {
  return toString.call(value) === '[object Array]';
};

/***/ }),

/***/ "d9f6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var toPrimitive = __webpack_require__("1bc3");
var dP = Object.defineProperty;

exports.f = __webpack_require__("8e60") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "d9f8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ "da3d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE128C = exports.CODE128B = exports.CODE128A = exports.CODE128 = undefined;

var _CODE128_AUTO = __webpack_require__("6f24");

var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);

var _CODE128A = __webpack_require__("e8c9");

var _CODE128A2 = _interopRequireDefault(_CODE128A);

var _CODE128B = __webpack_require__("70b0");

var _CODE128B2 = _interopRequireDefault(_CODE128B);

var _CODE128C = __webpack_require__("ed3f");

var _CODE128C2 = _interopRequireDefault(_CODE128C);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CODE128 = _CODE128_AUTO2.default;
exports.CODE128A = _CODE128A2.default;
exports.CODE128B = _CODE128B2.default;
exports.CODE128C = _CODE128C2.default;

/***/ }),

/***/ "da3e":
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ "da65":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("6ace");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "da9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-navbar/mc-navbar.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_navbarvue_type_script_lang_js_ = ({
  name: 'McNavbar',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-navbar', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-navbar/mc-navbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_navbar_mc_navbarvue_type_script_lang_js_ = (mc_navbarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-navbar/mc-navbar.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_navbar_mc_navbarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_navbar = (component.exports);
// CONCATENATED MODULE: ./components/mc-navbar/index.js


/* istanbul ignore next */

mc_navbar.install = function (Vue) {
  Vue.component(mc_navbar.name, mc_navbar);
};

/* harmony default export */ var components_mc_navbar = __webpack_exports__["default"] = (mc_navbar);

/***/ }),

/***/ "db29":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ "db8d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharpMatcherRegx = exports.getValueByPath = undefined;

var _getIterator2 = __webpack_require__("1727");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__("1098b");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("1907");

var _keys2 = _interopRequireDefault(_keys);

exports.hasOwn = hasOwn;
exports.typeOf = typeOf;
exports.deepCopy = deepCopy;
exports.mergeDeep = mergeDeep;
exports.firstUpperCase = firstUpperCase;
exports.scrollTop = scrollTop;
exports.findComponentDownward = findComponentDownward;
exports.findComponentsDownward = findComponentsDownward;
exports.getPropByPath = getPropByPath;
exports.escapeRegexpString = escapeRegexpString;
exports.arrayRemove = arrayRemove;

var _type = __webpack_require__("d9d4");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function typeOf(obj) {
  return Object.prototype.toString.call(obj).toLowerCase().replace(/(\[object )(\w+)(\])/g, '$2');
}

// deepCopy
function deepCopy(data) {
  var t = typeOf(data);
  var o = void 0;

  if (t === 'array') {
    o = [];
  } else if (t === 'object') {
    o = {};
  } else {
    return data;
  }

  if (t === 'array') {
    for (var i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === 'object') {
    for (var _i in data) {
      o[_i] = deepCopy(data[_i]);
    }
  }
  return o;
}

function mergeDeep(target, source) {
  if (!source) {
    return target;
  }

  (0, _keys2.default)(source).forEach(function (key) {
    var targetValue = target[key];
    var sourceValue = source[key];

    if (!(key in target)) {
      target[key] = sourceValue;
    } else if ((typeof sourceValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(sourceValue)) !== (typeof targetValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(targetValue))) {
      target[key] = sourceValue;
    } else if ((0, _type.isArray)(targetValue)) {
      target[key] = sourceValue;
    } else if ((0, _type.isObject)(targetValue)) {
      target[key] = mergeDeep(targetValue, sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
}

function firstUpperCase(str) {
  return str.toString()[0].toUpperCase() + str.toString().slice(1);
}

// scrollTop animation
function scrollTop(el, from, to, duration, endCallback) {
  from = from > 0 ? from : 0;
  duration = duration > 0 ? duration : 500;
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }
  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  function scroll(start, end, step) {
    if (start === end) {
      endCallback && endCallback();
      return;
    }

    var d = start + step > end ? end : start + step;
    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(function () {
      return scroll(d, end, step);
    });
  }
  scroll(from, to, step);
}

// Find component downward
function findComponentDownward(context, componentName) {
  var childrens = context.$children;
  var children = null;

  if (childrens.length) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(childrens), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        var name = child.$options.name;
        if (name === componentName) {
          children = child;
          break;
        } else {
          children = findComponentDownward(child, componentName);
          if (children) break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return children;
}

// Find components downward
function findComponentsDownward(context, componentName) {
  return context.$children.reduce(function (components, child) {
    if (child.$options.name === componentName) components.push(child);
    var foundChilds = findComponentsDownward(child, componentName);
    return components.concat(foundChilds);
  }, []);
}

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  if (object === undefined || object === null) {
    return object;
  }
  if (hasOwn(object, prop)) {
    return object[prop];
  }
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  if (hasOwn(obj, path)) {
    return {
      o: obj,
      k: path,
      v: obj[path]
    };
  }
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        // eslint-disable-next-line max-len
        throw new Error('[warn]: unable get ' + path + ' in ' + obj);
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var sharpMatcherRegx = exports.sharpMatcherRegx = /#([^#]+)$/;

function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
}

function arrayRemove(array, removed) {
  var b = (0, _type.isArray)(removed) ? removed : [removed];
  return array.filter(function (a) {
    return b.includes(a);
  });
}

/***/ }),

/***/ "dbdb":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("584a");
var global = __webpack_require__("e53d");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("b8e3") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "dc08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree/mc-tree.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_treevue_type_script_lang_js_ = ({
  name: 'McTree',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-tree', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  },
  methods: {
    getCheckedNodes: function getCheckedNodes() {
      var _this$$refs$selfRef;

      if (this.$refs.selfRef) return (_this$$refs$selfRef = this.$refs.selfRef).getCheckedNodes.apply(_this$$refs$selfRef, arguments);
    },
    getHalfCheckedNodes: function getHalfCheckedNodes() {
      var _this$$refs$selfRef2;

      if (this.$refs.selfRef) return (_this$$refs$selfRef2 = this.$refs.selfRef).getHalfCheckedNodes.apply(_this$$refs$selfRef2, arguments);
    },
    getNode: function getNode() {
      var _this$$refs$selfRef3;

      if (this.$refs.selfRef) return (_this$$refs$selfRef3 = this.$refs.selfRef).getNode.apply(_this$$refs$selfRef3, arguments);
    },
    filter: function filter() {
      var _this$$refs$selfRef4;

      if (this.$refs.selfRef) return (_this$$refs$selfRef4 = this.$refs.selfRef).filter.apply(_this$$refs$selfRef4, arguments);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-tree/mc-tree.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tree_mc_treevue_type_script_lang_js_ = (mc_treevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tree/mc-tree.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tree_mc_treevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tree = (component.exports);
// CONCATENATED MODULE: ./components/mc-tree/index.js


/* istanbul ignore next */

mc_tree.install = function (Vue) {
  Vue.component(mc_tree.name, mc_tree);
};

/* harmony default export */ var components_mc_tree = __webpack_exports__["default"] = (mc_tree);

/***/ }),

/***/ "dc14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__("966d");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__("3a7c");
util.inherits = __webpack_require__("3fb5");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("b7d1")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("429b");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("a8f0").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__("4681");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("b19a");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("b19a");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("f28c"), __webpack_require__("c8ba")))

/***/ }),

/***/ "dc47":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("2d9b"),
    root = __webpack_require__("6884");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "dc4d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                '_'
            ),
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ "dc62":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("9427");
var $Object = __webpack_require__("584a").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "dca2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidInputException = function (_Error) {
	_inherits(InvalidInputException, _Error);

	function InvalidInputException(symbology, input) {
		_classCallCheck(this, InvalidInputException);

		var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));

		_this.name = "InvalidInputException";

		_this.symbology = symbology;
		_this.input = input;

		_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
		return _this;
	}

	return InvalidInputException;
}(Error);

var InvalidElementException = function (_Error2) {
	_inherits(InvalidElementException, _Error2);

	function InvalidElementException() {
		_classCallCheck(this, InvalidElementException);

		var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));

		_this2.name = "InvalidElementException";
		_this2.message = "Not supported type to render on";
		return _this2;
	}

	return InvalidElementException;
}(Error);

var NoElementException = function (_Error3) {
	_inherits(NoElementException, _Error3);

	function NoElementException() {
		_classCallCheck(this, NoElementException);

		var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));

		_this3.name = "NoElementException";
		_this3.message = "No element to render on.";
		return _this3;
	}

	return NoElementException;
}(Error);

exports.InvalidInputException = InvalidInputException;
exports.InvalidElementException = InvalidElementException;
exports.NoElementException = NoElementException;

/***/ }),

/***/ "dcbc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("2aba");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "dd7e":
/***/ (function(module, exports, __webpack_require__) {

const Mode = __webpack_require__("bbf0")

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),

/***/ "de85":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("6884");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "e07b":
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__("5a76")
var RIPEMD160 = __webpack_require__("b5ca")
var sha = __webpack_require__("69f2")

var checkParameters = __webpack_require__("7d2a")
var defaultEncoding = __webpack_require__("9f9d")
var Buffer = __webpack_require__("8707").Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ "e0b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var redefineAll = __webpack_require__("dcbc");
var meta = __webpack_require__("67ab");
var forOf = __webpack_require__("4a59");
var anInstance = __webpack_require__("f605");
var isObject = __webpack_require__("d3f4");
var fails = __webpack_require__("79e5");
var $iterDetect = __webpack_require__("5cc5");
var setToStringTag = __webpack_require__("7f20");
var inheritIfRequired = __webpack_require__("5dbc");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "e0c5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ "e116":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "e18d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-link/mc-link.vue?vue&type=template&id=0be636f2&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLink)?_c('a',{staticClass:"mc-link",attrs:{"href":_vm.hrefRes,"target":_vm.target},on:{"click":_vm.click}},[_c('mtd-button',_vm._b({attrs:{"type":_vm.type,"disabled":_vm.disabled,"size":_vm.size}},'mtd-button',_vm.attrs,false),[(_vm.text)?[_vm._v(_vm._s(_vm.text))]:_vm._t("default")],2)],1):_c('mtd-button',_vm._b({staticClass:"mc-link",attrs:{"type":_vm.type,"disabled":_vm.disabled,"size":_vm.size},on:{"click":_vm.click}},'mtd-button',_vm.attrs,false),[_vm._v("\n    "+_vm._s(_vm.formatHref)+"\n    "),(_vm.text)?[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]:_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-link/mc-link.vue?vue&type=template&id=0be636f2&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-link/mc-link.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_linkvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McLink',
  props: {
    path: {
      type: [String, Object],
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    href: {
      type: String
    },
    target: {
      type: String,
      default: '_blank'
    },
    // a 标签 rel="noreferrer"
    rel: {
      type: String
    },
    download: {
      type: [Boolean, String],
      default: ''
    },
    type: {
      type: String,
      default: 'text' // primary / success / warning / danger / info / text

    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy; // eslint-disable-next-line no-script-url


    var hrefRes = 'javascript:;';
    var isLink = Object(composition_api_["computed"])(function () {
      return Boolean(props.path || props.href);
    });
    var size = Object(composition_api_["computed"])(function () {
      return ctx.attrs.size || (props.type === 'text' ? 'medium' : '');
    });
    var formatHref = Object(composition_api_["computed"])(function () {
      if (props.href) {
        return Object(tools_["stringifyUrl"])(props.href, props.params);
      }

      var _ref = Object({"VUE_APP_OWL_PROJECT":"talos-project","NODE_ENV":"production","BASE_URL":"/"}).projectConfig || '',
          urlPrefix = _ref.urlPrefix; // TODO: 后续废弃底层添加 .html 操作，业务层自己添加


      if (Object(tools_["isObject"])(props.path)) {
        var _props$path = props.path,
            url = _props$path.url,
            param = _props$path.param; // [/supplier or /supplier-alias] => /supplier

        if ("".concat(url).startsWith('/') && !"".concat(url).startsWith(urlPrefix.replace(/\/([a-zA-Z]+)-alias/, '/$1'))) {
          return Object(tools_["stringifyUrl"])("".concat(urlPrefix).concat(url, ".html"), param);
        }

        return Object(tools_["stringifyUrl"])("".concat(url, ".html"), param);
      }

      return Object(tools_["stringifyUrl"])(props.path, props.params);
    });

    var click = function click(e) {
      var _proxy$$tools;

      // 优先调用项目自身linkTo，可以支持打开内部tab
      var linkToFun = (proxy === null || proxy === void 0 ? void 0 : (_proxy$$tools = proxy.$tools) === null || _proxy$$tools === void 0 ? void 0 : _proxy$$tools.linkTo) || tools_["linkTo"];

      if (props.disabled || isLink.value) {
        e.preventDefault();
      }

      if (!props.disabled && isLink.value) {
        linkToFun(Object(tools_["delUrlAlias"])(Object(tools_["getFullUrl"])(formatHref.value)), {}, {
          target: props.target,
          rel: props.rel,
          download: props.download
        });
      }

      ctx.emit('click');
    };

    return {
      click: click,
      isLink: isLink,
      size: size,
      hrefRes: hrefRes,
      attrs: ctx.attrs,
      formatHref: formatHref
    };
  }
}));
// CONCATENATED MODULE: ./components/mc-link/mc-link.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_link_mc_linkvue_type_script_lang_js_ = (mc_linkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-link/mc-link.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_link_mc_linkvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_link = (component.exports);
// CONCATENATED MODULE: ./components/mc-link/index.js


/* istanbul ignore next */

mc_link.install = function (Vue) {
  Vue.component(mc_link.name, mc_link);
};

/* harmony default export */ var components_mc_link = __webpack_exports__["default"] = (mc_link);

/***/ }),

/***/ "e1d3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ "e1d30":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__("3337")
var BN = __webpack_require__("399f")

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("1c35").Buffer))

/***/ }),

/***/ "e265":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ed33");

/***/ }),

/***/ "e372":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("ad71");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("dc14");
exports.Duplex = __webpack_require__("b19a");
exports.Transform = __webpack_require__("27bf");
exports.PassThrough = __webpack_require__("780f");


/***/ }),

/***/ "e3da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/w3c-keyname/index.es.js
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}

var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\""
}

var chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent)
var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent)
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform)
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent)
var brokenModifierNames = mac || chrome && +chrome[1] < 57

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i)

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32)
  shift[i] = String.fromCharCode(i)
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code]

function keyName(event) {
  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) ||
    ie && event.shiftKey && event.key && event.key.length == 1 ||
    event.key == "Unidentified"
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified"
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape"
  if (name == "Del") name = "Delete"
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft"
  if (name == "Up") name = "ArrowUp"
  if (name == "Right") name = "ArrowRight"
  if (name == "Down") name = "ArrowDown"
  return name
}

// EXTERNAL MODULE: ./node_modules/prosemirror-state/dist/index.js
var dist = __webpack_require__("6ffb");

// CONCATENATED MODULE: ./node_modules/prosemirror-keymap/dist/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keydownHandler; });
/* unused harmony export keymap */



const dist_mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space")
        result = " ";
    let alt, ctrl, shift, meta;
    for (let i = 0; i < parts.length - 1; i++) {
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod))
            meta = true;
        else if (/^a(lt)?$/i.test(mod))
            alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod))
            ctrl = true;
        else if (/^s(hift)?$/i.test(mod))
            shift = true;
        else if (/^mod$/i.test(mod)) {
            if (dist_mac)
                meta = true;
            else
                ctrl = true;
        }
        else
            throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt)
        result = "Alt-" + result;
    if (ctrl)
        result = "Ctrl-" + result;
    if (meta)
        result = "Meta-" + result;
    if (shift)
        result = "Shift-" + result;
    return result;
}
function normalize(map) {
    let copy = Object.create(null);
    for (let prop in map)
        copy[normalizeKeyName(prop)] = map[prop];
    return copy;
}
function modifiers(name, event, shift) {
    if (event.altKey)
        name = "Alt-" + name;
    if (event.ctrlKey)
        name = "Ctrl-" + name;
    if (event.metaKey)
        name = "Meta-" + name;
    if (shift !== false && event.shiftKey)
        name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/
function keymap(bindings) {
    return new dist["Plugin"]({ props: { handleKeyDown: keydownHandler(bindings) } });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/
function keydownHandler(bindings) {
    let map = normalize(bindings);
    return function (view, event) {
        let name = keyName(event), isChar = name.length == 1 && name != " ", baseName;
        let direct = map[modifiers(name, event, !isChar)];
        if (direct && direct(view.state, view.dispatch, view))
            return true;
        if (isChar && (event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) &&
            (baseName = base[event.keyCode]) && baseName != name) {
            // Try falling back to the keyCode when there's a modifier
            // active or the character produced isn't ASCII, and our table
            // produces a different name from the the keyCode. See #668,
            // #1060
            let fromCode = map[modifiers(baseName, event, true)];
            if (fromCode && fromCode(view.state, view.dispatch, view))
                return true;
        }
        else if (isChar && event.shiftKey) {
            // Otherwise, if shift is active, also try the binding with the
            // Shift- prefix enabled. See #997
            let withShift = map[modifiers(name, event, true)];
            if (withShift && withShift(view.state, view.dispatch, view))
                return true;
        }
        return false;
    };
}




/***/ }),

/***/ "e3db":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "e4ae":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "e53d":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "e6f3":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("07e3");
var toIObject = __webpack_require__("36c3");
var arrayIndexOf = __webpack_require__("5b4e")(false);
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "e762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Barcode = function Barcode(data, options) {
	_classCallCheck(this, Barcode);

	this.data = data;
	this.text = options.text || data;
	this.options = options;
};

exports.default = Barcode;

/***/ }),

/***/ "e81d":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ "e853":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var isArray = __webpack_require__("1169");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "e85f":
/***/ (function(module) {

module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

/***/ }),

/***/ "e8b2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.checksum = checksum;

var _encoder = __webpack_require__("5726");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding

var UPC = function (_Barcode) {
	_inherits(UPC, _Barcode);

	function UPC(data, options) {
		_classCallCheck(this, UPC);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{11}$/) !== -1) {
			data += checksum(data);
		}

		var _this = _possibleConstructorReturn(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPC, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
		}
	}, {
		key: "encode",
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: "flatEncoding",
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
			result += "01010";
			result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
			result += "101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "guardedEncoding",
		value: function guardedEncoding() {
			var result = [];

			// Add the first digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(0, 1),
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101" + (0, _encoder2.default)(this.data[0], "L"),
				options: { height: this.guardHeight }
			});

			// Add the left side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
				text: this.text.substr(1, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the middle bits
			result.push({
				data: "01010",
				options: { height: this.guardHeight }
			});

			// Add the right side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
				text: this.text.substr(6, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: (0, _encoder2.default)(this.data[11], "R") + "101",
				options: { height: this.guardHeight }
			});

			// Add the last digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(11, 1),
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}]);

	return UPC;
}(_Barcode3.default);

// Calulate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit


function checksum(number) {
	var result = 0;

	var i;
	for (i = 1; i < 11; i += 2) {
		result += parseInt(number[i]);
	}
	for (i = 0; i < 11; i += 2) {
		result += parseInt(number[i]) * 3;
	}

	return (10 - result % 10) % 10;
}

exports.default = UPC;

/***/ }),

/***/ "e8c9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__("4b23");

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__("f08e");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128A = function (_CODE) {
	_inherits(CODE128A, _CODE);

	function CODE128A(string, options) {
		_classCallCheck(this, CODE128A);

		return _possibleConstructorReturn(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants.A_START_CHAR + string, options));
	}

	_createClass(CODE128A, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.A_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128A;
}(_CODE3.default);

exports.default = CODE128A;

/***/ }),

/***/ "e987":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "e9e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-cascader/mc-cascader.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_cascadervue_type_script_lang_js_ = ({
  name: 'McCascader',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-cascader', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  },
  methods: {
    focus: function focus() {
      var _this$$refs$selfRef;

      if (this.$refs.selfRef) return (_this$$refs$selfRef = this.$refs.selfRef).focus.apply(_this$$refs$selfRef, arguments);
    },
    blur: function blur() {
      var _this$$refs$selfRef2;

      if (this.$refs.selfRef) return (_this$$refs$selfRef2 = this.$refs.selfRef).blur.apply(_this$$refs$selfRef2, arguments);
    }
  }
});
// CONCATENATED MODULE: ./components/mc-cascader/mc-cascader.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_cascader_mc_cascadervue_type_script_lang_js_ = (mc_cascadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-cascader/mc-cascader.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_cascader_mc_cascadervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_cascader = (component.exports);
// CONCATENATED MODULE: ./components/mc-cascader/index.js


/* istanbul ignore next */

mc_cascader.install = function (Vue) {
  Vue.component(mc_cascader.name, mc_cascader);
};

/* harmony default export */ var components_mc_cascader = __webpack_exports__["default"] = (mc_cascader);

/***/ }),

/***/ "ea53":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("399f");
var utils = __webpack_require__("f3a3");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ "ead6":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("f772");
var anObject = __webpack_require__("e4ae");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("d864")(Function.call, __webpack_require__("bf0b").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "eaf2":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "ebd6":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("cb7c");
var aFunction = __webpack_require__("d8e8");
var SPECIES = __webpack_require__("2b4c")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "ebe4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ "ebfd":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("62a0")('meta');
var isObject = __webpack_require__("f772");
var has = __webpack_require__("07e3");
var setDesc = __webpack_require__("d9f6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("294c")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "ec18":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ "ec2e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ "ed33":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("014b");
module.exports = __webpack_require__("584a").Object.getOwnPropertySymbols;


/***/ }),

/***/ "ed3f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__("4b23");

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__("f08e");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128C = function (_CODE) {
	_inherits(CODE128C, _CODE);

	function CODE128C(string, options) {
		_classCallCheck(this, CODE128C);

		return _possibleConstructorReturn(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants.C_START_CHAR + string, options));
	}

	_createClass(CODE128C, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.C_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128C;
}(_CODE3.default);

exports.default = CODE128C;

/***/ }),

/***/ "ed78":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "eda5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ "edc9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c3c0");
var assert = __webpack_require__("da3e");

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ "ef3a":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__("7f7a");
var inherits = __webpack_require__("3fb5");

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__("0706").runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),

/***/ "efec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: ./components/utils/index.js
var utils = __webpack_require__("9109");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-form-item/mc-form-item.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/* harmony default export */ var mc_form_itemvue_type_script_lang_js_ = ({
  name: 'McFormItem',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        visible: this.$props.value,
        value: this.$props.value
      });
    }
  },
  mounted: function mounted() {
    utils["c" /* default */].throwCustomError('mc-form-item相关组件已经弃用，请使用mc-configform组件替代，相关文档链接：https://component.sankuai.com/astro/material/component/vRcN__7YaijKxm5F9bAQJ', 'McComponentAbandonedError');
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-form-item', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-form-item/mc-form-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_form_item_mc_form_itemvue_type_script_lang_js_ = (mc_form_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-form-item/mc-form-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_form_item_mc_form_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_form_item = (component.exports);
// CONCATENATED MODULE: ./components/mc-form-item/index.js


/* istanbul ignore next */

mc_form_item.install = function (Vue) {
  Vue.component(mc_form_item.name, mc_form_item);
};

/* harmony default export */ var components_mc_form_item = __webpack_exports__["default"] = (mc_form_item);

/***/ }),

/***/ "f07f":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("c3f1");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "f08e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _SET_BY_CODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// constants for internal usage
var SET_A = exports.SET_A = 0;
var SET_B = exports.SET_B = 1;
var SET_C = exports.SET_C = 2;

// Special characters
var SHIFT = exports.SHIFT = 98;
var START_A = exports.START_A = 103;
var START_B = exports.START_B = 104;
var START_C = exports.START_C = 105;
var MODULO = exports.MODULO = 103;
var STOP = exports.STOP = 106;
var FNC1 = exports.FNC1 = 207;

// Get set by start code
var SET_BY_CODE = exports.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);

// Get next set by code
var SWAP = exports.SWAP = {
	101: SET_A,
	100: SET_B,
	99: SET_C
};

var A_START_CHAR = exports.A_START_CHAR = String.fromCharCode(208); // START_A + 105
var B_START_CHAR = exports.B_START_CHAR = String.fromCharCode(209); // START_B + 105
var C_START_CHAR = exports.C_START_CHAR = String.fromCharCode(210); // START_C + 105

// 128A (Code Set A)
// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
var A_CHARS = exports.A_CHARS = "[\x00-\x5F\xC8-\xCF]";

// 128B (Code Set B)
// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
var B_CHARS = exports.B_CHARS = "[\x20-\x7F\xC8-\xCF]";

// 128C (Code Set C)
// 00–99 (encodes two digits with a single code point) and FNC1
var C_CHARS = exports.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";

// CODE128 includes 107 symbols:
// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
// Each symbol consist of three black bars (1) and three white spaces (0).
var BARS = exports.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];

/***/ }),

/***/ "f1ae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "f201":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("e4ae");
var aFunction = __webpack_require__("79aa");
var SPECIES = __webpack_require__("5168")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "f260":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ "f28c":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "f30d":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("04a2"),
    stubArray = __webpack_require__("7d76");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "f3a3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__("399f");
var minAssert = __webpack_require__("da3e");
var minUtils = __webpack_require__("7658");

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ "f3ff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ "f410":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1af6");
module.exports = __webpack_require__("584a").Array.isArray;


/***/ }),

/***/ "f460":
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__("98e6")
var Buffer = __webpack_require__("8707").Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ "f470":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("5801");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "f483":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-button/mc-button.vue?vue&type=template&id=7c0c8253&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-button"},[(_vm.mode === 'confirm')?_c('popconfirm',_vm._g(_vm._b({attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.loading,"disabled":_vm.disabled,"icon":_vm.icon}},'popconfirm',_vm.attrs,false),_vm.listeners),[_vm._t("default"),_c('template',{slot:"title"},[_vm._t("title")],2),_c('template',{slot:"message"},[_vm._t("message")],2)],2):_c('mtd-button',{attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.mergeLoading,"disabled":_vm.disabled,"icon":_vm.icon},on:{"click":_vm.handleClick}},[_vm._t("default")],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-button/mc-button.vue?vue&type=template&id=7c0c8253&

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-button/components/Popconfirm.vue?vue&type=template&id=180dfbf4&
var Popconfirmvue_type_template_id_180dfbf4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-popover',{ref:"popconfirm",attrs:{"popper-class":_vm.prefix,"placement":_vm.placement,"visible":!_vm.disabled && _vm.visible},on:{"clickoutside":_vm.handleConfirmoutside}},[_c('mtd-button',{attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.mergeLoading,"disabled":_vm.disabled,"icon":_vm.icon},on:{"click":_vm.handleOpenPopover}},[_vm._t("default")],2),_c('template',{slot:"content"},[_c('div',{class:(_vm.prefix + "-inner")},[_c('span',{class:(_vm.prefix + "-icon")},[_c('i',{class:_vm.confirmIcon})]),_c('div',{class:(_vm.prefix + "-content")},[(_vm.slots.title)?_c('div',{class:(_vm.pp + "-title")},[_vm._t("title")],2):(_vm.title)?_c('div',{class:(_vm.pp + "-title")},[_vm._v("\n                    "+_vm._s(_vm.title)+"\n                ")]):_vm._e(),(_vm.slots.message)?_c('div',{class:(_vm.prefix + "-message")},[_vm._t("message")],2):(_vm.message)?_c('div',[_vm._v("\n                    "+_vm._s(_vm.message)+"\n                ")]):_vm._e()])]),_c('div',{class:(_vm.prefix + "-actions")},[_c('mtd-button',_vm._b({on:{"click":_vm.handleCancel}},'mtd-button',_vm.cancelBtnProps,false),[_vm._v("\n                "+_vm._s(_vm.cancelBtnText)+"\n            ")]),_c('mtd-button',_vm._b({on:{"click":_vm.handleConfirm}},'mtd-button',_vm.confirmBtnProps,false),[_vm._v("\n                "+_vm._s(_vm.confirmBtnText)+"\n            ")])],1)])],2)}
var Popconfirmvue_type_template_id_180dfbf4_staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-button/components/Popconfirm.vue?vue&type=template&id=180dfbf4&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// CONCATENATED MODULE: ./components/mc-button/constants.js
var popconfirmProps = {
  prefix: 'mtd-popconfirm',
  pp: 'mtd-popover',
  placement: 'top',
  confirmBtnProps: {
    type: 'primary',
    size: 'small'
  },
  confirmBtnText: '确定',
  cancelBtnProps: {
    size: 'small'
  },
  cancelBtnText: '取消',
  confirmIcon: 'mtdicon mtdicon-warning-circle'
};
/* harmony default export */ var constants = (popconfirmProps);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-button/components/Popconfirm.vue?vue&type=script&lang=js&






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Popconfirmvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'Popconfirm',
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '' // small / 不设置 / large

    },
    type: {
      type: String,
      default: '' // primary / success / warning / danger / text / text-primary / 不设置

    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        emit = _ref.emit;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var visible = Object(composition_api_["ref"])(false);

    var handleOpenPopover = function handleOpenPopover() {
      visible.value = true;
    };

    var handleConfirmoutside = function handleConfirmoutside() {
      visible.value = false;
    };

    var handleCancel = function handleCancel() {
      emit('cancel');
      handleConfirmoutside();
    };

    var innerLoading = Object(composition_api_["ref"])(false);

    var handleConfirm = function handleConfirm(e) {
      var onClick = proxy.$listeners.confirm;

      var handler = function handler() {
        innerLoading.value = false;
      };

      if (onClick) {
        var promise = Promise.all((Array.isArray(onClick) ? onClick : [onClick]).map(function (fn) {
          return fn && fn(e);
        }));
        innerLoading.value = true;
        promise.finally(handler);
      }

      handleConfirmoutside();
    };

    var mergeLoading = Object(composition_api_["computed"])(function () {
      return props.loading || innerLoading.value;
    });
    return _objectSpread({
      visible: visible,
      mergeLoading: mergeLoading,
      slots: slots
    }, constants, {
      handleOpenPopover: handleOpenPopover,
      handleConfirmoutside: handleConfirmoutside,
      handleCancel: handleCancel,
      handleConfirm: handleConfirm
    });
  }
}));
// CONCATENATED MODULE: ./components/mc-button/components/Popconfirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Popconfirmvue_type_script_lang_js_ = (Popconfirmvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-button/components/Popconfirm.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_Popconfirmvue_type_script_lang_js_,
  Popconfirmvue_type_template_id_180dfbf4_render,
  Popconfirmvue_type_template_id_180dfbf4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Popconfirm = (component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-button/mc-button.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_buttonvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McButton',
  components: {
    Popconfirm: Popconfirm
  },
  props: {
    mode: {
      type: String,
      default: '' // confirm(气泡确认框) / 不设置

    },
    size: {
      type: String,
      default: '' // small / 不设置 / large

    },
    type: {
      type: String,
      default: '' // primary / success / warning / danger / text / text-primary / text-warning / text-danger / 不设置

    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props, _ref) {
    var attrs = _ref.attrs;

    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    if (props.mode === 'confirm') {
      return {
        attrs: attrs,
        listeners: proxy.$listeners
      };
    } else {
      var innerLoading = Object(composition_api_["ref"])(false);

      var handleClick = function handleClick(e) {
        var onClick = proxy.$listeners.click;

        var handler = function handler() {
          innerLoading.value = false;
        };

        if (onClick) {
          var promise = Promise.all((Array.isArray(onClick) ? onClick : [onClick]).map(function (fn) {
            return fn && fn(e);
          }));
          innerLoading.value = true;
          promise.finally(handler);
        }
      };

      var mergeLoading = Object(composition_api_["computed"])(function () {
        return props.loading || innerLoading.value;
      });
      return {
        mergeLoading: mergeLoading,
        handleClick: handleClick
      };
    }
  }
}));
// CONCATENATED MODULE: ./components/mc-button/mc-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_button_mc_buttonvue_type_script_lang_js_ = (mc_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/mc-button/mc-button.vue





/* normalize component */

var mc_button_component = Object(componentNormalizer["a" /* default */])(
  mc_button_mc_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_button = (mc_button_component.exports);
// CONCATENATED MODULE: ./components/mc-button/index.js


/* istanbul ignore next */

mc_button.install = function (Vue) {
  Vue.component(mc_button.name, mc_button);
};

/* harmony default export */ var components_mc_button = __webpack_exports__["default"] = (mc_button);

/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f576":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("3fb5")
var HashBase = __webpack_require__("93e6")
var Buffer = __webpack_require__("8707").Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ "f605":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "f620":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-icon-button/mc-icon-button.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_icon_buttonvue_type_script_lang_js_ = ({
  name: 'McIconButton',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-icon-button', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-icon-button/mc-icon-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_icon_button_mc_icon_buttonvue_type_script_lang_js_ = (mc_icon_buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-icon-button/mc-icon-button.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_icon_button_mc_icon_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_icon_button = (component.exports);
// CONCATENATED MODULE: ./components/mc-icon-button/index.js


/* istanbul ignore next */

mc_icon_button.install = function (Vue) {
  Vue.component(mc_icon_button.name, mc_icon_button);
};

/* harmony default export */ var components_mc_icon_button = __webpack_exports__["default"] = (mc_icon_button);

/***/ }),

/***/ "f685":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("3fc6");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "f68e":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("73334") });


/***/ }),

/***/ "f772":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "f7fe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "f848":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("4dc9"), __esModule: true };

/***/ }),

/***/ "f893":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("f921"), __esModule: true };

/***/ }),

/***/ "f8d1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-upload/mc-upload.vue?vue&type=template&id=648bdff9&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mcUploadClass},[_c('mtd-upload',{ref:"uploader",attrs:{"action":_vm.action,"data":_vm.params,"headers":_vm.headers,"multiple":_vm.multiple,"limit":_vm.limit,"drag":_vm.drag,"accept":_vm.innerAccept,"disabled":_vm.innerDisabled,"show-file-list":_vm.showFileList,"file-list":_vm.fileList,"list-type":_vm.listType,"before-upload":_vm.innerBeforeUpload,"on-exceed":_vm.innerOnExceed,"on-progress":_vm.innerOnProgress,"on-error":_vm.innerOnError,"on-preview":_vm.innerOnPreview,"on-file-select":_vm.innerOnFileSelect,"on-success":_vm.innerOnSuccess,"on-change":_vm.innerOnChange,"before-remove":_vm.innerBeforeRemove,"on-remove":_vm.innerOnRemove}},[(_vm.$slots.trigger)?[_vm._t("trigger",null,{"slot":"trigger"})]:[(_vm.$slots.default)?_vm._t("default",null,{"slot":"default"}):[(_vm.listType === 'picture-card')?[_c('i',{staticClass:"mtdicon-add"})]:[(_vm.drag)?[_c('i',{staticClass:"mtdicon-export-o"}),_c('div',{staticClass:"mtd-upload-text"},[_vm._v("\n                            将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])]:_c('mtd-button',{attrs:{"icon":"mtdicon-export-o","disabled":_vm.innerDisabled}},[_vm._v("\n                        "+_vm._s(_vm.uploadText || '上传文件')+"\n                    ")])]]],(_vm.$slots.tip)?[_vm._t("tip",null,{"slot":"tip"})]:_vm._e()],2),(_vm.preview && _vm.uploadType === 'image')?_c('mc-image-preview',{attrs:{"data":_vm.previewImages,"visible":_vm.showPreview,"current-index":_vm.imageIndex,"z-index":_vm.previewZIndex},on:{"close":_vm.closePreview}}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-upload/mc-upload.vue?vue&type=template&id=648bdff9&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("75fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.link.js
var es6_string_link = __webpack_require__("b54a");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./composables/useUpload.js
var useUpload = __webpack_require__("15da");

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__("bf4b");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("d225");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js
var createClass = __webpack_require__("b0b4");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./components/mc-upload/service/s3.js






var s3_uploader;

var s3_S3 =
/*#__PURE__*/
function () {
  function S3() {
    Object(classCallCheck["a" /* default */])(this, S3);

    this.token = null;
    this.bucket = useUpload["g" /* s3Bucket */];
  }

  Object(createClass["a" /* default */])(S3, [{
    key: "getToken",
    value: function () {
      var _getToken = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(tools_["hGet"])(useUpload["j" /* s3TokenUrl */], {
                  bucket: this.bucket
                }).catch(function () {
                  return null;
                });

              case 2:
                res = _context.sent;
                this.token = res;
                return _context.abrupt("return", this.token);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "addFileNameParams",
    value: function addFileNameParams(params, fileName) {
      params.key = fileName;
    }
  }, {
    key: "initParams",
    value: function initParams(props, res) {
      var AWSAccessKeyId = res.AWSAccessKeyId,
          policy = res.policy,
          signature = res.signature;
      props.params.awsAccessKeyId = AWSAccessKeyId;
      props.params.policy = policy;
      props.params.signature = signature;
    }
  }, {
    key: "getFileUrl",
    value: function getFileUrl(file) {
      var _file$raw = file.raw,
          $fileName = _file$raw.$fileName,
          $bucketName = _file$raw.$bucketName; // {域名}/v1/mss_{tenantId}/{bucketname}/{objectname}

      return "".concat(useUpload["h" /* s3Domain */], "/v1/mss_").concat(useUpload["i" /* s3TenantId */], "/").concat($bucketName, "/").concat($fileName);
    }
  }, {
    key: "getBucket",
    get: function get() {
      return this.bucket;
    }
  }, {
    key: "getAction",
    get: function get() {
      return useUpload["k" /* s3UploadAction */];
    }
  }]);

  return S3;
}();

function getS3Ins(options) {
  if (s3_uploader) return s3_uploader;
  s3_uploader = new s3_S3(options);
  return s3_uploader;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// CONCATENATED MODULE: ./components/mc-upload/service/venus.js







var env = useUpload["e" /* isDev */] || useUpload["f" /* isTest */] ? 'test' : 'pro';
var venus_uploader;

var venus_Venus =
/*#__PURE__*/
function () {
  function Venus() {
    Object(classCallCheck["a" /* default */])(this, Venus);

    this.token = null;
    this.bucket = 'mallimages';
  }

  Object(createClass["a" /* default */])(Venus, [{
    key: "getToken",
    value: function () {
      var _getToken = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(tools_["hGet"])('/api/mcfe/upload/token', {
                  bucket: this.bucket
                }).catch(function () {
                  return null;
                });

              case 2:
                res = _context.sent;
                this.token = res;
                return _context.abrupt("return", this.token);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "addFileNameParams",
    value: function addFileNameParams(params, fileName) {
      params.filename = fileName;
    }
  }, {
    key: "initParams",
    value: function initParams(props, res) {
      var expiretime = res.expiretime,
          authorization = res.authorization;
      props.headers.time = expiretime;
      props.headers.Authorization = authorization;
    }
  }, {
    key: "getFileUrl",
    value: function getFileUrl(res) {
      if (Object.prototype.toString.call(res) !== '[object Object]' || Object.prototype.toString.call(res.data) !== '[object Object]') {
        throw new Error('接口返回数据结构错误');
      }

      return res.data.originalLink;
    }
  }, {
    key: "processImage",
    value: function () {
      var _processImage = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(_ref) {
        var params, originFilename, processedFileName, res, time, Authorization, processRes;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = _ref.params, originFilename = _ref.originFilename, processedFileName = _ref.processedFileName;
                _context2.next = 3;
                return Object(tools_["hGet"])('/api/mcfe/upload/token', {
                  bucket: this.bucket,
                  isProcess: 1
                }).catch(function () {
                  return null;
                });

              case 3:
                res = _context2.sent;

                if (res) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('获取处理图片token失败，请重试');

              case 6:
                time = res.time, Authorization = res.Authorization;
                _context2.next = 9;
                return Object(tools_["requestPost"])("".concat(this.getHost, "/image_process/").concat(this.bucket, "?isHttps=true"), {
                  filename: originFilename,
                  rule: {
                    process: params,
                    dest_filename: processedFileName
                  }
                }, {
                  headers: {
                    time: time,
                    Authorization: Authorization
                  },
                  parseData: false
                }).catch(function () {
                  return null;
                });

              case 9:
                processRes = _context2.sent;

                if (!(!processRes || !processRes.success)) {
                  _context2.next = 12;
                  break;
                }

                throw new Error('获取处理后图片失败，请重试');

              case 12:
                return _context2.abrupt("return", processRes.process_data);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function processImage(_x) {
        return _processImage.apply(this, arguments);
      }

      return processImage;
    }()
  }, {
    key: "supportUploadExts",
    get: function get() {
      return ['jpg', 'png', 'jpeg', 'bmp', 'gif', 'webp', 'psd'];
    }
  }, {
    key: "getBucket",
    get: function get() {
      return this.bucket;
    }
  }, {
    key: "getHost",
    get: function get() {
      if (env === 'pro') return '//pic-up.meituan.com';
      return '//extrauploader.inf.test.sankuai.com';
    }
  }, {
    key: "getAction",
    get: function get() {
      if (env === 'pro') return "".concat(this.getHost, "/extrastorage/").concat(this.bucket);
      return "".concat(this.getHost, "/extrastorage/").concat(this.bucket);
    }
  }]);

  return Venus;
}();

function getVenusIns(options) {
  if (venus_uploader) return venus_uploader;
  venus_uploader = new venus_Venus(options);
  return venus_uploader;
}
// CONCATENATED MODULE: ./components/mc-upload/service/index.js




var InsMap = {
  file: getS3Ins,
  image: getVenusIns
};

var service_UploadService =
/*#__PURE__*/
function () {
  function UploadService(type) {
    Object(classCallCheck["a" /* default */])(this, UploadService);

    this.uploadIns = InsMap[type]();
  }

  Object(createClass["a" /* default */])(UploadService, [{
    key: "getToken",
    value: function getToken() {
      return this.uploadIns.getToken();
    }
  }, {
    key: "getFileUrl",
    value: function getFileUrl(file) {
      return this.uploadIns.getFileUrl(file);
    }
  }, {
    key: "addFileNameParams",
    value: function addFileNameParams() {
      var _this$uploadIns;

      (_this$uploadIns = this.uploadIns).addFileNameParams.apply(_this$uploadIns, arguments);
    }
  }, {
    key: "initParams",
    value: function initParams() {
      var _this$uploadIns2;

      (_this$uploadIns2 = this.uploadIns).initParams.apply(_this$uploadIns2, arguments);
    }
  }, {
    key: "processImage",
    value: function processImage(arg) {
      return this.uploadIns.processImage(arg);
    }
  }, {
    key: "bucket",
    get: function get() {
      return this.uploadIns.getBucket;
    }
  }, {
    key: "action",
    get: function get() {
      return this.uploadIns.getAction;
    }
  }, {
    key: "token",
    get: function get() {
      return this.uploadIns.token;
    }
  }, {
    key: "reqOpts",
    get: function get() {
      return this.uploadIns.getReqProps;
    }
  }]);

  return UploadService;
}();

/* harmony default export */ var service = (service_UploadService);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-upload/mc-upload.vue?vue&type=script&lang=js&











function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-use-before-define */

/* eslint-disable import/no-unresolved */




var VenusAccept = '.jpg,.png,.jpeg,.bmp,.gif,.webp,.psd';

function noop() {}

/* harmony default export */ var mc_uploadvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McUpload',
  props: {
    value: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    // 上传文件s3 ; 图片venus
    uploadType: {
      type: String,
      default: 'file' // file | image

    },
    showFileList: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    uploadText: {
      type: String,
      default: '上传文件'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 999
    },
    accept: {
      type: String,
      default: ''
    },
    // 文件大小限制，单位：M
    maxSize: {
      type: Number,
      default: 10
    },
    preview: {
      type: Boolean,
      default: true
    },
    // 是否是多图一起预览
    mulPreview: {
      type: Boolean,
      default: false
    },
    // venus图片处理参数
    venusProcessImageParams: {
      type: String,
      default: ''
    },
    beforeUpload: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    beforeRemove: {
      type: Function,
      default: noop
    },
    onSuccess: {
      type: Function,
      default: noop
    },
    onError: {
      type: Function,
      default: noop
    },
    onRemove: {
      type: Function,
      default: noop
    },
    onPreview: {
      type: Function,
      default: noop
    },
    onExceed: {
      type: Function,
      default: noop
    },
    onProgress: {
      type: Function,
      default: noop
    },
    onChange: {
      type: Function,
      default: noop
    },
    onFileSelect: {
      type: Function,
      default: noop
    },
    onGetFileName: {
      type: Function,
      default: useUpload["c" /* getFileName */]
    },
    onGetProcessedFileName: {
      type: Function,
      default: useUpload["d" /* getProcessedFileName */]
    },
    // 设置图片预览的z-index，el-dialog 和 mc-modal 的 z-index 初始值一般是 2000
    previewZIndex: {
      type: Number,
      default: constants["a" /* IMAGE_PREVIEW_Z_INDEX */]
    }
  },
  setup: function setup(props, ctx) {
    var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
        proxy = _getCurrentInstance.proxy;

    var uploader = Object(composition_api_["ref"])(null);
    var US = new service(props.uploadType);
    var bucket = US.bucket,
        action = US.action; // UI相关

    var uiProps = Object(composition_api_["reactive"])({
      isInitState: true,
      fileList: [],
      // 已上传的文件列表
      initReady: false,
      innerDisabled: Object(composition_api_["computed"])(function () {
        return props.disabled || !uiProps.initReady || props.readonly;
      }),
      innerAccept: Object(composition_api_["computed"])(function () {
        return props.uploadType === 'file' ? props.accept : VenusAccept;
      }),
      showPreview: false,
      // 显示预览
      previewImages: [],
      // 预览图列表
      imageIndex: -1
    });

    var _useUpload = Object(useUpload["a" /* default */])({
      uiProps: uiProps,
      uploader: uploader,
      props: props,
      ctx: ctx,
      proxy: proxy
    }),
        handleAfterSuccess = _useUpload.handleAfterSuccess,
        handleError = _useUpload.handleError,
        clearFiles = _useUpload.clearFiles,
        innerOnExceed = _useUpload.innerOnExceed,
        innerOnProgress = _useUpload.innerOnProgress,
        innerOnFileSelect = _useUpload.innerOnFileSelect,
        innerOnChange = _useUpload.innerOnChange,
        innerOnError = _useUpload.innerOnError,
        innerBeforeRemove = _useUpload.innerBeforeRemove,
        innerOnRemove = _useUpload.innerOnRemove; // 请求相关参数


    var reqObj = {
      action: action,
      headers: {},
      params: {}
    };

    if (props.uploadType === 'image') {
      reqObj.params.isHttps = true;
    }

    var reqProps = Object(composition_api_["reactive"])(reqObj); // venus图片处理

    var handleProcessImage = function handleProcessImage(paramsStr, originFilename, processedFileName) {
      if (!paramsStr.startsWith('@')) {
        proxy.$mtd.message.error('图片处理参数异常');
        return false;
      }

      return US.processImage({
        params: paramsStr.slice(1),
        originFilename: originFilename,
        processedFileName: processedFileName
      });
    }; // 初始化token


    var initToken =
    /*#__PURE__*/
    function () {
      var _ref = Object(asyncToGenerator["a" /* default */])(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return US.getToken().catch(function () {
                  return null;
                });

              case 2:
                token = _context.sent;

                if (token) {
                  _context.next = 6;
                  break;
                }

                proxy.$mtd.message.error('未找到token，组件初始化失败，请重试');
                return _context.abrupt("return");

              case 6:
                US.initParams(reqProps, token);
                uiProps.initReady = true;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initToken() {
        return _ref.apply(this, arguments);
      };
    }();

    initToken(); // 钩子相关

    var hooksProps = Object(composition_api_["reactive"])({
      // 上传前
      // 将返回结果全部包在Promise中，这样默认的校验（校验maxSize）和自定义的校验都会生效（props.beforeUpload返回结果）
      innerBeforeUpload: function innerBeforeUpload(file) {
        return new Promise(function (resolve, reject) {
          initToken().then(function () {
            if (!US.token) {
              proxy.$mtd.message.error('上传失败，未获取到s3token');
              reject();
              return;
            }

            var fileName = props.onGetFileName(file); // 文件名

            US.addFileNameParams(reqProps.params, fileName); // 添加文件信息

            file.$fileName = fileName;
            file.$bucketName = bucket;
            file.$action = action;
            var isOverSize = file.size / 1024 / 1024 > props.maxSize;

            if (isOverSize) {
              proxy.$mtd.message.error("\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(props.maxSize, "MB!"));
              reject();
            }

            var before = props.beforeUpload(file);

            if (before instanceof Promise) {
              before.then(resolve).catch(reject);
            } else if (before !== false) {
              resolve();
            } else {
              reject();
            }
          }).catch(function () {
            proxy.$mtd.message.error('初始化token失败');
            reject();
          });
        });
      },
      // 上传成功
      innerOnSuccess: function () {
        var _innerOnSuccess = Object(asyncToGenerator["a" /* default */])(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(res, file, fileList) {
          var url, processedFileName, processData;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  url = '';

                  if (!(props.uploadType === 'file')) {
                    _context2.next = 5;
                    break;
                  }

                  url = US.getFileUrl(file);
                  _context2.next = 18;
                  break;

                case 5:
                  if (!(!res || !res.success)) {
                    _context2.next = 8;
                    break;
                  }

                  handleError(res.error.message);
                  return _context2.abrupt("return");

                case 8:
                  if (!props.venusProcessImageParams) {
                    _context2.next = 17;
                    break;
                  }

                  // 处理后新文件名
                  processedFileName = props.onGetProcessedFileName(file.raw.$fileName);
                  _context2.next = 12;
                  return handleProcessImage(props.venusProcessImageParams, file.raw.$fileName, processedFileName);

                case 12:
                  processData = _context2.sent;
                  url = processData.link; // 上传成功后，覆盖原文件名

                  file.raw.$fileName = processedFileName;
                  _context2.next = 18;
                  break;

                case 17:
                  url = US.getFileUrl(res);

                case 18:
                  if (url) {
                    handleAfterSuccess(res, url, file, fileList);
                  } else {
                    handleError('生成文件url失败', file);
                  }

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function innerOnSuccess(_x, _x2, _x3) {
          return _innerOnSuccess.apply(this, arguments);
        }

        return innerOnSuccess;
      }(),
      // 点击文件列表中已上传的文件时
      innerOnPreview: function innerOnPreview(file) {
        if (!props.preview) return;
        if (props.onPreview) props.onPreview(file);

        if (props.uploadType === 'image') {
          var isMul = props.mulPreview && props.listType === 'picture-card';
          var currentUrl = file.raw ? file.raw.$url : file.url;
          var currentIdx = props.value.indexOf(currentUrl);
          uiProps.previewImages = isMul ? Object(toConsumableArray["a" /* default */])(props.value) : [currentUrl];
          uiProps.imageIndex = isMul ? currentIdx : 0;
          uiProps.showPreview = true;
        }
      },
      // 文件超出个数限制时
      innerOnExceed: innerOnExceed,
      // 文件上传进度
      innerOnProgress: innerOnProgress,
      // 在用户选择完文件后立刻触发
      innerOnFileSelect: innerOnFileSelect,
      // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      innerOnChange: innerOnChange,
      // 文件上传失败
      innerOnError: innerOnError,
      // 删除文件之前
      innerBeforeRemove: innerBeforeRemove,
      innerOnRemove: innerOnRemove,
      closePreview: function closePreview() {
        uiProps.showPreview = false;
      }
    });
    var reqRefs = Object(composition_api_["toRefs"])(reqProps);
    var uiRefs = Object(composition_api_["toRefs"])(uiProps);
    var hooksRefs = Object(composition_api_["toRefs"])(hooksProps); // filelist以及limit  动态添加class，如果文件数量达到限制或者禁止状态，隐藏当前组件中包含的 mtdicon-add

    var mcUploadClass = Object(composition_api_["computed"])(function () {
      var cls = ['mc-upload'];

      if (uiRefs.fileList.value.length >= props.limit || uiRefs.innerDisabled.value) {
        cls.push('mc-upload-hide-add');
      }

      return cls;
    });
    return _objectSpread({
      mcUploadClass: mcUploadClass
    }, reqRefs, {}, uiRefs, {}, hooksRefs, {
      clearFiles: clearFiles,
      uploader: uploader
    });
  }
}));
// CONCATENATED MODULE: ./components/mc-upload/mc-upload.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_upload_mc_uploadvue_type_script_lang_js_ = (mc_uploadvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-upload/mc-upload.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_upload_mc_uploadvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_upload = (component.exports);
// CONCATENATED MODULE: ./components/mc-upload/index.js


/* istanbul ignore next */

mc_upload.install = function (Vue) {
  Vue.component(mc_upload.name, mc_upload);
};

/* harmony default export */ var components_mc_upload = __webpack_exports__["default"] = (mc_upload);

/***/ }),

/***/ "f90b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"7e63f346-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-city-select/mc-city-select.vue?vue&type=template&id=26b47e22&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mc-level-select',_vm._b({ref:"levelSelect",attrs:{"data":_vm.innerData,"multiple":_vm.multiple,"show-path":_vm.showPath,"readonly":_vm.readonly,"disabled":_vm.disabled,"max-level":_vm.maxLevel,"show-tags":_vm.showTags,"allValue":_vm.allValue},on:{"input":_vm.handleInput,"change":_vm.handleChange,"data-update":_vm.handleDataUpdate},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'mc-level-select',_vm.$attrs,false))],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/mc-city-select/mc-city-select.vue?vue&type=template&id=26b47e22&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// EXTERNAL MODULE: external "@vue/composition-api"
var composition_api_ = __webpack_require__("8165");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("7618");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("3b8d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: external "@mcfe/tools"
var tools_ = __webpack_require__("7196");

// CONCATENATED MODULE: ./components/mc-city-select/composable/useInit.js











function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var useInit_useInit = function useInit(props, _ref) {
  var emit = _ref.emit;

  var _getCurrentInstance = Object(composition_api_["getCurrentInstance"])(),
      proxy = _getCurrentInstance.proxy;

  var original = Object(composition_api_["reactive"])({
    innerData: [],
    remoteData: []
  });
  var innerValue = Object(composition_api_["ref"])(props.value);
  var levelSelect = Object(composition_api_["ref"])(null);
  var innerDisabledIds = Object(composition_api_["computed"])(function () {
    return props.disabledIds;
  });

  var getfetchParams = function getfetchParams() {
    var type;
    var url;

    switch (props.cityType) {
      case 'managementCity':
        type = 'hPost';
        url = props.source === 'vss' ? '/api/vss/shepherd/supplier/poi/getAllManagerCity' : '/api/poi/city/aggregation/managementCity/list/search';
        break;

      case 'managementCityAll':
        type = 'hGet';
        url = props.source === 'vss' ? '/api/vss/shepherd/supplier/poi/getAllManagerCity' : '/api/poi/city/aggregation/managementCity/all';
        break;

      case 'authCity':
        type = 'hGet';
        url = '/api/auth/org/getRegionAndCity';
        break;

      case 'physicalCity':
        type = 'hGet';
        url = '/api/auth/adminDivision/findAllInChina';
        break;
      // 兜底逻辑默认给经营城市

      default:
        type = 'hPost';
        url = '/api/poi/city/aggregation/managementCity/list/search';
        break;
    }

    return {
      type: type,
      url: url
    };
  };

  var rebuildPhysicalCity = function rebuildPhysicalCity(physicalCityData) {
    var stack = [];

    for (var i = 0; i < physicalCityData.length; i++) {
      if ([713000, 713100].includes(physicalCityData[i].id)) {
        var id = physicalCityData[i].id;

        var customNode = _objectSpread({}, physicalCityData[i]);

        physicalCityData[i].id = id + 1;
        customNode.id = id;
        customNode.parentId = id + 1;
        stack.push(customNode);
      }
    }

    for (var _i = 0; _i < stack.length; _i++) {
      physicalCityData.push(stack[_i]);
    }
  };

  var fetchData =
  /*#__PURE__*/
  function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _getfetchParams, type, url, params, data, list, managementCityId, managementCityName, id, chineseName;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _getfetchParams = getfetchParams(), type = _getfetchParams.type, url = _getfetchParams.url;
              params = props.params;
              _context.next = 5;
              return proxy["$".concat(type)](url, params, {
                cache: true
              });

            case 5:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 8;
                break;
              }

              _context.t0 = {};

            case 8:
              data = _context.t0;
              list = [];
              _context.t1 = props.cityType;
              _context.next = _context.t1 === 'managementCity' ? 13 : _context.t1 === 'managementCityAll' ? 15 : _context.t1 === 'authCity' ? 17 : _context.t1 === 'physicalCity' ? 19 : 21;
              break;

            case 13:
              list = data.list;
              return _context.abrupt("break", 23);

            case 15:
              list = data.list;
              return _context.abrupt("break", 23);

            case 17:
              list = data;
              return _context.abrupt("break", 23);

            case 19:
              list = data;
              return _context.abrupt("break", 23);

            case 21:
              list = data.list;
              return _context.abrupt("break", 23);

            case 23:
              // 深拷贝，避免地址引用，重复叠加数据
              original.remoteData = Object(tools_["cloneDeep"])(list);

              if (props.cityType === 'managementCity' || props.cityType === 'managementCityAll') {
                managementCityId = ['object'].includes(Object(esm_typeof["a" /* default */])(props.allValue)) ? props.allValue.value : props.allValue;
                managementCityName = ['object'].includes(Object(esm_typeof["a" /* default */])(props.allValue)) ? props.allValue.label || '全部' : '全部';

                if (['number', 'string'].includes(Object(esm_typeof["a" /* default */])(managementCityId)) && managementCityId !== '') {
                  original.remoteData.unshift({
                    managementCityId: managementCityId,
                    managementCityName: managementCityName
                  });
                }
              } else if (props.cityType === 'physicalCity') {
                id = ['object'].includes(Object(esm_typeof["a" /* default */])(props.allValue)) ? props.allValue.value : props.allValue;
                chineseName = ['object'].includes(Object(esm_typeof["a" /* default */])(props.allValue)) ? props.allValue.label || '全部' : '全部';

                if (['number', 'string'].includes(Object(esm_typeof["a" /* default */])(id)) && id !== '') {
                  original.remoteData.unshift({
                    id: id,
                    chineseName: chineseName,
                    parentId: -1
                  });
                } // 物理城市最大层级是3级的情况下，需要补全金门县和连江县的3层结点
                // levelselect不支持最大3级的情况下，选择2级结点


                if (props.maxLevel === 3) {
                  rebuildPhysicalCity(original.remoteData);
                }
              }

              emit('loaded', original.remoteData);
              _context.next = 31;
              break;

            case 28:
              _context.prev = 28;
              _context.t2 = _context["catch"](0);
              console.log(_context.t2);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 28]]);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var init =
  /*#__PURE__*/
  function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchData();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function init() {
      return _ref3.apply(this, arguments);
    };
  }();

  init();

  var checkDisabledIds = function checkDisabledIds(obj) {
    if (innerDisabledIds.value && innerDisabledIds.value.length && innerDisabledIds.value.includes(obj.id)) {
      obj.disabled = true;
    }
  };

  var formalTreeNodeData = function formalTreeNodeData(item, valueProp, labelProp) {
    return _objectSpread({}, item, {
      id: valueProp,
      label: labelProp
    });
  };

  var formalData = function formalData(data) {
    if (props.cityType === 'physicalCity') {
      var finalData = [];
      data.forEach(function (item) {
        // 查找父节点
        item.label = item.chineseName; // 判断是否有禁选id

        checkDisabledIds(item);
        var parent = data.find(function (subItem) {
          return subItem.id === item.parentId;
        });

        if (parent && parent.children) {
          parent.children.push(item);
        } else if (parent) {
          parent.children = [item];
        } else {
          finalData.push(item);
        }
      });
      return finalData;
    } else if (props.cityType === 'authCity') {
      // 建立一级父节点数
      var regionData = data.map(function (v) {
        return {
          id: v.regionOrgId,
          label: v.regionOrgName
        };
      });

      var _finalData = Object(tools_["uniqWith"])(Object(tools_["cloneDeep"])(regionData), tools_["isEqual"]);

      data.forEach(function (item) {
        // 查找父节点 塞入子节点
        var cityItem = formalTreeNodeData(item, item.cityOrgId, item.cityOrgName); // 判断是否有禁选id

        checkDisabledIds(cityItem);

        var parent = _finalData.find(function (subItem) {
          return subItem.id === item.regionOrgId;
        });

        if (parent && parent.children) {
          parent.children.push(cityItem);
        } else {
          parent.children = [cityItem];
        }
      });
      return _finalData;
    } else {
      // 默认给经营城市兜底
      var _finalData2 = (data || []).map(function (v) {
        var cityItem = formalTreeNodeData(v, v.managementCityId, v.managementCityName); // 判断是否有禁选id

        checkDisabledIds(cityItem);
        return cityItem;
      });

      return _finalData2;
    }
  };

  original.innerData = Object(composition_api_["computed"])(function () {
    return formalData(Object(tools_["cloneDeep"])(original.remoteData));
  });
  var originalRefs = Object(composition_api_["toRefs"])(original);

  var handleInput = function handleInput(val) {
    emit('input', val);
  };

  var handleChange = function handleChange(val, items) {
    emit('change', val, items);
  };

  var handleDataUpdate = function handleDataUpdate(val, items, data) {
    emit('data-update', val, items, data);
  };

  var selectAll = function selectAll() {
    if (props.multiple) {
      levelSelect.value.handleSelectAll();
    }
  };

  return {
    originalRefs: originalRefs,
    levelSelect: levelSelect,
    innerValue: innerValue,
    handleInput: handleInput,
    handleChange: handleChange,
    handleDataUpdate: handleDataUpdate,
    selectAll: selectAll
  };
};

/* harmony default export */ var composable_useInit = (useInit_useInit);
// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-city-select/mc-city-select.vue?vue&type=script&lang=js&






function mc_city_selectvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function mc_city_selectvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { mc_city_selectvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { mc_city_selectvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var mc_city_selectvue_type_script_lang_js_ = (Object(composition_api_["defineComponent"])({
  name: 'McCitySelect',
  props: {
    value: {
      type: [String, Number, Array],
      required: true,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    cityType: {
      type: String,
      default: 'managementCity'
    },
    showPath: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxLevel: {
      type: Number,
      default: 3
    },
    disabledIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showTags: {
      type: [Boolean, Number],
      default: true
    },
    allValue: {
      type: [String, Number, Object],
      default: ''
    },
    source: {
      type: String,
      default: 'jiemo'
    }
  },
  setup: function setup(props, ctx) {
    var _useInit = composable_useInit(props, ctx),
        originalRefs = _useInit.originalRefs,
        levelSelect = _useInit.levelSelect,
        handleInput = _useInit.handleInput,
        handleChange = _useInit.handleChange,
        handleDataUpdate = _useInit.handleDataUpdate,
        selectAll = _useInit.selectAll,
        innerValue = _useInit.innerValue;

    Object(composition_api_["watch"])(function () {
      return props.value;
    }, function (val) {
      innerValue.value = val;
    });
    return mc_city_selectvue_type_script_lang_js_objectSpread({}, originalRefs, {
      levelSelect: levelSelect,
      innerValue: innerValue,
      selectAll: selectAll,
      handleInput: handleInput,
      handleChange: handleChange,
      handleDataUpdate: handleDataUpdate
    });
  }
}));
// CONCATENATED MODULE: ./components/mc-city-select/mc-city-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_city_select_mc_city_selectvue_type_script_lang_js_ = (mc_city_selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-city-select/mc-city-select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_city_select_mc_city_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_city_select = (component.exports);
// CONCATENATED MODULE: ./components/mc-city-select/index.js


/* istanbul ignore next */

mc_city_select.install = function (Vue) {
  Vue.component(mc_city_select.name, mc_city_select);
};

/* harmony default export */ var components_mc_city_select = __webpack_exports__["default"] = (mc_city_select);

/***/ }),

/***/ "f921":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("014b");
__webpack_require__("c207");
__webpack_require__("69d3");
__webpack_require__("765d");
module.exports = __webpack_require__("584a").Symbol;


/***/ }),

/***/ "fa31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-slider/mc-slider.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_slidervue_type_script_lang_js_ = ({
  name: 'McSlider',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-slider', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-slider/mc-slider.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_slider_mc_slidervue_type_script_lang_js_ = (mc_slidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-slider/mc-slider.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_slider_mc_slidervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_slider = (component.exports);
// CONCATENATED MODULE: ./components/mc-slider/index.js


/* istanbul ignore next */

mc_slider.install = function (Vue) {
  Vue.component(mc_slider.name, mc_slider);
};

/* harmony default export */ var components_mc_slider = __webpack_exports__["default"] = (mc_slider);

/***/ }),

/***/ "fa49":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fa99":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0293");
module.exports = __webpack_require__("584a").Object.getPrototypeOf;


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "facd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ "fb07":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};


/***/ }),

/***/ "fba5":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "fbb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GenericBarcode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("e762");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericBarcode = function (_Barcode) {
	_inherits(GenericBarcode, _Barcode);

	function GenericBarcode(data, options) {
		_classCallCheck(this, GenericBarcode);

		return _possibleConstructorReturn(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
	}

	// Return the corresponding binary numbers for the data provided


	_createClass(GenericBarcode, [{
		key: "encode",
		value: function encode() {
			return {
				data: "10101010101010101010101010101010101010101",
				text: this.text
			};
		}

		// Resturn true/false if the string provided is valid for this encoder

	}, {
		key: "valid",
		value: function valid() {
			return true;
		}
	}]);

	return GenericBarcode;
}(_Barcode3.default);

exports.GenericBarcode = GenericBarcode;

/***/ }),

/***/ "fbea":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorTransform = __webpack_require__("b923");
var prosemirrorModel = __webpack_require__("6f27");
var prosemirrorState = __webpack_require__("6ffb");

// :: (EditorState, ?(tr: Transaction)) → bool
// Delete the selection, if there is one.
function deleteSelection(state, dispatch) {
  if (state.selection.empty) { return false }
  if (dispatch) { dispatch(state.tr.deleteSelection().scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and at the start of a textblock, try to
// reduce the distance between that block and the one before it—if
// there's a block directly before it that can be joined, join them.
// If not, try to move the selected block closer to the next one in
// the document structure by lifting it out of its parent or moving it
// into a parent of the previous block. Will use the view for accurate
// (bidi-aware) start-of-textblock detection if given.
function joinBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor);

  // If there is no node before this, try to lift
  if (!$cut) {
    var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
    if (target == null) { return false }
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  var before = $cut.nodeBefore;
  // Apply the joining algorithm
  if (!before.type.spec.isolating && deleteBarrier(state, $cut, dispatch))
    { return true }

  // If the node below has no content and the node above is
  // selectable, delete the node below and select the one above.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(before, "end") || prosemirrorState.NodeSelection.isSelectable(before))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(before, "end") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                      : prosemirrorState.NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the node before is an atom, delete it
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView()); }
    return true
  }

  return false
}

function textblockAt(node, side) {
  for (; node; node = (side == "start" ? node.firstChild : node.lastChild))
    { if (node.isTextblock) { return true } }
  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the start of a textblock, select
// the node before that textblock, if possible. This is intended to be
// bound to keys like backspace, after
// [`joinBackward`](#commands.joinBackward) or other deleting
// commands, as a fall-back behavior when the schema doesn't allow
// deletion at the selected point.
function selectNodeBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor), node = $cut && $cut.nodeBefore;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView()); }
  return true
}

function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    if ($pos.index(i) > 0) { return $pos.doc.resolve($pos.before(i + 1)) }
    if ($pos.node(i).type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and the cursor is at the end of a
// textblock, try to reduce or remove the boundary between that block
// and the one after it, either by joining them or by moving the other
// block closer to this one in the tree structure. Will use the view
// for accurate start-of-textblock detection if given.
function joinForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor);

  // If there is no node after this, there's nothing to do
  if (!$cut) { return false }

  var after = $cut.nodeAfter;
  // Try the joining algorithm
  if (deleteBarrier(state, $cut, dispatch)) { return true }

  // If the node above has no content and the node below is
  // selectable, delete the node above and select the one below.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(after, "start") || prosemirrorState.NodeSelection.isSelectable(after))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(after, "start") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                      : prosemirrorState.NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the next node is an atom, delete it
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView()); }
    return true
  }

  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the end of a textblock, select
// the node coming after that textblock, if possible. This is intended
// to be bound to keys like delete, after
// [`joinForward`](#commands.joinForward) and similar deleting
// commands, to provide a fall-back behavior when the schema doesn't
// allow deletion at the selected point.
function selectNodeForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor), node = $cut && $cut.nodeAfter;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos)).scrollIntoView()); }
  return true
}

function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    var parent = $pos.node(i);
    if ($pos.index(i) + 1 < parent.childCount) { return $pos.doc.resolve($pos.after(i + 1)) }
    if (parent.type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block or, if there is a text selection, the
// closest ancestor block of the selection that can be joined, with
// the sibling above it.
function joinUp(state, dispatch) {
  var sel = state.selection, nodeSel = sel instanceof prosemirrorState.NodeSelection, point;
  if (nodeSel) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.from)) { return false }
    point = sel.from;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.from, -1);
    if (point == null) { return false }
  }
  if (dispatch) {
    var tr = state.tr.join(point);
    if (nodeSel) { tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize)); }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block, or the closest ancestor of the selection
// that can be joined, with the sibling after it.
function joinDown(state, dispatch) {
  var sel = state.selection, point;
  if (sel instanceof prosemirrorState.NodeSelection) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.to)) { return false }
    point = sel.to;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.to, 1);
    if (point == null) { return false }
  }
  if (dispatch)
    { dispatch(state.tr.join(point).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Lift the selected block, or the closest ancestor block of the
// selection that can be lifted, out of its parent node.
function lift(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  var range = $from.blockRange($to), target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the selection is in a node whose type has a truthy
// [`code`](#model.NodeSpec.code) property in its spec, replace the
// selection with a newline character.
function newlineInCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  if (dispatch) { dispatch(state.tr.insertText("\n").scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// When the selection is in a node with a truthy
// [`code`](#model.NodeSpec.code) property in its spec, create a
// default block after the code block, and move the cursor there.
function exitCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  var above = $head.node(-1), after = $head.indexAfter(-1), type = above.contentMatchAt(after).defaultType;
  if (!above.canReplaceWith(after, after, type)) { return false }
  if (dispatch) {
    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(prosemirrorState.Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If a block node is selected, create an empty paragraph before (if
// it is its parent's first child) or after it.
function createParagraphNear(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if ($from.parent.inlineContent || $to.parent.inlineContent) { return false }
  var type = $from.parent.contentMatchAt($to.indexAfter()).defaultType;
  if (!type || !type.isTextblock) { return false }
  if (dispatch) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, side + 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the cursor is in an empty textblock that can be lifted, lift the
// block.
function liftEmptyBlock(state, dispatch) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || $cursor.parent.content.size) { return false }
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before = $cursor.before();
    if (prosemirrorTransform.canSplit(state.doc, before)) {
      if (dispatch) { dispatch(state.tr.split(before).scrollIntoView()); }
      return true
    }
  }
  var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Split the parent block of the selection. If the selection is a text
// selection, also delete its content.
function splitBlock(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if (state.selection instanceof prosemirrorState.NodeSelection && state.selection.node.isBlock) {
    if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) { return false }
    if (dispatch) { dispatch(state.tr.split($from.pos).scrollIntoView()); }
    return true
  }

  if (!$from.parent.isBlock) { return false }

  if (dispatch) {
    var atEnd = $to.parentOffset == $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof prosemirrorState.TextSelection) { tr.deleteSelection(); }
    var deflt = $from.depth == 0 ? null : $from.node(-1).contentMatchAt($from.indexAfter(-1)).defaultType;
    var types = atEnd && deflt ? [{type: deflt}] : null;
    var can = prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types && !can && prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{type: deflt}])) {
      types = [{type: deflt}];
      can = true;
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types);
      if (!atEnd && !$from.parentOffset && $from.parent.type != deflt &&
          $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirrorModel.Fragment.from(deflt.create(), $from.parent)))
        { tr.setNodeMarkup(tr.mapping.map($from.before()), deflt); }
    }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Acts like [`splitBlock`](#commands.splitBlock), but without
// resetting the set of active marks at the cursor.
function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && (function (tr) {
    var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) { tr.ensureMarks(marks); }
    dispatch(tr);
  }))
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Move the selection to the node wrapping the current selection, if
// any. (Will not select the document node.)
function selectParentNode(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var to = ref.to;
  var pos;
  var same = $from.sharedDepth(to);
  if (same == 0) { return false }
  pos = $from.before(same);
  if (dispatch) { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, pos))); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Select the whole document.
function selectAll(state, dispatch) {
  if (dispatch) { dispatch(state.tr.setSelection(new prosemirrorState.AllSelection(state.doc))); }
  return true
}

function joinMaybeClear(state, $pos, dispatch) {
  var before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type)) { return false }
  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
    if (dispatch) { dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView()); }
    return true
  }
  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || prosemirrorTransform.canJoin(state.doc, $pos.pos)))
    { return false }
  if (dispatch)
    { dispatch(state.tr
             .clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount))
             .join($pos.pos)
             .scrollIntoView()); }
  return true
}

function deleteBarrier(state, $cut, dispatch) {
  var before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
  if (before.type.spec.isolating || after.type.spec.isolating) { return false }
  if (joinMaybeClear(state, $cut, dispatch)) { return true }

  if ($cut.parent.canReplace($cut.index(), $cut.index() + 1) &&
      (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
      match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      var end = $cut.pos + after.nodeSize, wrap = prosemirrorModel.Fragment.empty;
      for (var i = conn.length - 1; i >= 0; i--)
        { wrap = prosemirrorModel.Fragment.from(conn[i].create(null, wrap)); }
      wrap = prosemirrorModel.Fragment.from(before.copy(wrap));
      var tr = state.tr.step(new prosemirrorTransform.ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new prosemirrorModel.Slice(wrap, 1, 0), conn.length, true));
      var joinAt = end + 2 * conn.length;
      if (prosemirrorTransform.canJoin(tr.doc, joinAt)) { tr.join(joinAt); }
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  var selAfter = prosemirrorState.Selection.findFrom($cut, 1);
  var range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && prosemirrorTransform.liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  return false
}

// Parameterized commands

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Wrap the selection in a node of the given type with the given
// attributes.
function wrapIn(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
    if (!wrapping) { return false }
    if (dispatch) { dispatch(state.tr.wrap(range, wrapping).scrollIntoView()); }
    return true
  }
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that tries to set the selected textblocks to the
// given node type with the given attributes.
function setBlockType(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var from = ref.from;
    var to = ref.to;
    var applicable = false;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (applicable) { return false }
      if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) { return }
      if (node.type == nodeType) {
        applicable = true;
      } else {
        var $pos = state.doc.resolve(pos), index = $pos.index();
        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
      }
    });
    if (!applicable) { return false }
    if (dispatch) { dispatch(state.tr.setBlockType(from, to, nodeType, attrs).scrollIntoView()); }
    return true
  }
}

function markApplies(doc, ranges, type) {
  var loop = function ( i ) {
    var ref = ranges[i];
    var $from = ref.$from;
    var $to = ref.$to;
    var can = $from.depth == 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (can) { return false }
      can = node.inlineContent && node.type.allowsMarkType(type);
    });
    if (can) { return { v: true } }
  };

  for (var i = 0; i < ranges.length; i++) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

// :: (MarkType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command function that toggles the given mark with the
// given attributes. Will return `false` when the current selection
// doesn't support that mark. This will remove the mark if any marks
// of that type exist in the selection, or add it otherwise. If the
// selection is empty, this applies to the [stored
// marks](#state.EditorState.storedMarks) instead of a range of the
// document.
function toggleMark(markType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var empty = ref.empty;
    var $cursor = ref.$cursor;
    var ranges = ref.ranges;
    if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType)) { return false }
    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks()))
          { dispatch(state.tr.removeStoredMark(markType)); }
        else
          { dispatch(state.tr.addStoredMark(markType.create(attrs))); }
      } else {
        var has = false, tr = state.tr;
        for (var i = 0; !has && i < ranges.length; i++) {
          var ref$1 = ranges[i];
          var $from = ref$1.$from;
          var $to = ref$1.$to;
          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
          var ref$2 = ranges[i$1];
          var $from$1 = ref$2.$from;
          var $to$1 = ref$2.$to;
          if (has) { tr.removeMark($from$1.pos, $to$1.pos, markType); }
          else { tr.addMark($from$1.pos, $to$1.pos, markType.create(attrs)); }
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true
  }
}

function wrapDispatchForJoin(dispatch, isJoinable) {
  return function (tr) {
    if (!tr.isGeneric) { return dispatch(tr) }

    var ranges = [];
    for (var i = 0; i < tr.mapping.maps.length; i++) {
      var map = tr.mapping.maps[i];
      for (var j = 0; j < ranges.length; j++)
        { ranges[j] = map.map(ranges[j]); }
      map.forEach(function (_s, _e, from, to) { return ranges.push(from, to); });
    }

    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    var joinable = [];
    for (var i$1 = 0; i$1 < ranges.length; i$1 += 2) {
      var from = ranges[i$1], to = ranges[i$1 + 1];
      var $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
        var after = parent.maybeChild(index);
        if (!after) { break }
        if (index && joinable.indexOf(pos) == -1) {
          var before = parent.child(index - 1);
          if (before.type == after.type && isJoinable(before, after))
            { joinable.push(pos); }
        }
        pos += after.nodeSize;
      }
    }
    // Join the joinable points
    joinable.sort(function (a, b) { return a - b; });
    for (var i$2 = joinable.length - 1; i$2 >= 0; i$2--) {
      if (prosemirrorTransform.canJoin(tr.doc, joinable[i$2])) { tr.join(joinable[i$2]); }
    }
    dispatch(tr);
  }
}

// :: ((state: EditorState, ?(tr: Transaction)) → bool, union<(before: Node, after: Node) → bool, [string]>) → (state: EditorState, ?(tr: Transaction)) → bool
// Wrap a command so that, when it produces a transform that causes
// two joinable nodes to end up next to each other, those are joined.
// Nodes are considered joinable when they are of the same type and
// when the `isJoinable` predicate returns true for them or, if an
// array of strings was passed, if their node type name is in that
// array.
function autoJoin(command, isJoinable) {
  if (Array.isArray(isJoinable)) {
    var types = isJoinable;
    isJoinable = function (node) { return types.indexOf(node.type.name) > -1; };
  }
  return function (state, dispatch) { return command(state, dispatch && wrapDispatchForJoin(dispatch, isJoinable)); }
}

// :: (...[(EditorState, ?(tr: Transaction), ?EditorView) → bool]) → (EditorState, ?(tr: Transaction), ?EditorView) → bool
// Combine a number of command functions into a single function (which
// calls them one by one until one returns true).
function chainCommands() {
  var commands = [], len = arguments.length;
  while ( len-- ) commands[ len ] = arguments[ len ];

  return function(state, dispatch, view) {
    for (var i = 0; i < commands.length; i++)
      { if (commands[i](state, dispatch, view)) { return true } }
    return false
  }
}

var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);

// :: Object
// A basic keymap containing bindings not specific to any schema.
// Binds the following keys (when multiple commands are listed, they
// are chained with [`chainCommands`](#commands.chainCommands)):
//
// * **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
// * **Mod-Enter** to `exitCode`
// * **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
// * **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-a** to `selectAll`
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};

// :: Object
// A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
// **Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
// **Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
// Ctrl-Delete.
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"]
};
for (var key in pcBaseKeymap) { macBaseKeymap[key] = pcBaseKeymap[key]; }

// declare global: os, navigator
var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform)
          : typeof os != "undefined" ? os.platform() == "darwin" : false;

// :: Object
// Depending on the detected platform, this will hold
// [`pcBasekeymap`](#commands.pcBaseKeymap) or
// [`macBaseKeymap`](#commands.macBaseKeymap).
var baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;

exports.deleteSelection = deleteSelection;
exports.joinBackward = joinBackward;
exports.selectNodeBackward = selectNodeBackward;
exports.joinForward = joinForward;
exports.selectNodeForward = selectNodeForward;
exports.joinUp = joinUp;
exports.joinDown = joinDown;
exports.lift = lift;
exports.newlineInCode = newlineInCode;
exports.exitCode = exitCode;
exports.createParagraphNear = createParagraphNear;
exports.liftEmptyBlock = liftEmptyBlock;
exports.splitBlock = splitBlock;
exports.splitBlockKeepMarks = splitBlockKeepMarks;
exports.selectParentNode = selectParentNode;
exports.selectAll = selectAll;
exports.wrapIn = wrapIn;
exports.setBlockType = setBlockType;
exports.toggleMark = toggleMark;
exports.autoJoin = autoJoin;
exports.chainCommands = chainCommands;
exports.pcBaseKeymap = pcBaseKeymap;
exports.macBaseKeymap = macBaseKeymap;
exports.baseKeymap = baseKeymap;
//# sourceMappingURL=commands.js.map


/***/ }),

/***/ "fd75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("8e6e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("bd86");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("c5f6");

// CONCATENATED MODULE: ./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/@vue/cli-plugin-typescript/node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/mc-tree-node/mc-tree-node.vue?vue&type=script&lang=js&







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* harmony default export */ var mc_tree_nodevue_type_script_lang_js_ = ({
  name: 'McTreeNode',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object]
    }
  },
  computed: {
    innerProps: function innerProps() {
      return _objectSpread({}, this.$attrs, {
        'visible': this.$props.value,
        value: this.$props.value
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var children = [];
    var slotNames = Object.keys(this.$slots);
    slotNames.forEach(function (name) {
      var slots = _this.$slots[name];
      slots.forEach(function (slotVnode) {
        slotVnode.slot = name;
        children.push(slotVnode);
      });
    }); // '$options', '$parent', '$root', '$children', '$refs', '$vnode', '$slots', '$scopedSlots', '$createElement', '$attrs', '$listeners', '$el'

    return h('mtd-tree-node', {
      props: this.innerProps,
      attrs: this.$attrs,
      on: this.$listeners,
      ref: 'selfRef'
    }, children);
  }
});
// CONCATENATED MODULE: ./components/mc-tree-node/mc-tree-node.vue?vue&type=script&lang=js&
 /* harmony default export */ var mc_tree_node_mc_tree_nodevue_type_script_lang_js_ = (mc_tree_nodevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./components/mc-tree-node/mc-tree-node.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mc_tree_node_mc_tree_nodevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mc_tree_node = (component.exports);
// CONCATENATED MODULE: ./components/mc-tree-node/index.js


/* istanbul ignore next */

mc_tree_node.install = function (Vue) {
  Vue.component(mc_tree_node.name, mc_tree_node);
};

/* harmony default export */ var components_mc_tree_node = __webpack_exports__["default"] = (mc_tree_node);

/***/ }),

/***/ "fd7c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (old, replaceObj) {
  return _extends({}, old, replaceObj);
};

/***/ }),

/***/ "fd7e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ "fda6":
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__("8947")
var deciphers = __webpack_require__("4228")
var modes = __webpack_require__("e85f")

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "fdac":
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(3);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ "fdef":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "fe11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export ValidateRule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cw; });
/* unused harmony export defaultRules */
/* unused harmony export useRules */
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1c46");
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_0__);
var f_=Object.defineProperty,c_=Object.defineProperties;var l_=Object.getOwnPropertyDescriptors;var Vv=Object.getOwnPropertySymbols;var s_=Object.prototype.hasOwnProperty,p_=Object.prototype.propertyIsEnumerable;var Yv=(y,d,a)=>d in y?f_(y,d,{enumerable:!0,configurable:!0,writable:!0,value:a}):y[d]=a,ja=(y,d)=>{for(var a in d||(d={}))s_.call(d,a)&&Yv(y,a,d[a]);if(Vv)for(var a of Vv(d))p_.call(d,a)&&Yv(y,a,d[a]);return y},gv=(y,d)=>c_(y,l_(d));var h_=Object.create,kv=Object.defineProperty,v_=Object.getOwnPropertyDescriptor,__=Object.getOwnPropertyNames,g_=Object.getPrototypeOf,y_=Object.prototype.hasOwnProperty,d_=y=>kv(y,"__esModule",{value:!0}),m_=(y,d)=>()=>(d||y((d={exports:{}}).exports,d),d.exports),b_=(y,d,a)=>{if(d&&typeof d=="object"||typeof d=="function")for(let O of __(d))!y_.call(y,O)&&O!=="default"&&kv(y,O,{get:()=>d[O],enumerable:!(a=v_(d,O))||a.enumerable});return y},sv=y=>b_(d_(kv(y!=null?h_(g_(y)):{},"default",y&&y.__esModule&&"default"in y?{get:()=>y.default,enumerable:!0}:{value:y,enumerable:!0})),y),pv=m_((y,d)=>{(function(){var a,O="4.17.21",R=200,L="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",z="Expected a function",fn="Invalid `variable` option passed into `_.template`",dn="__lodash_hash_undefined__",rn=500,Dn="__lodash_placeholder__",sn=1,dt=2,Un=4,Rn=1,bn=2,X=1,En=2,St=4,mn=8,ot=16,un=32,on=64,Y=128,Cn=256,Wn=512,Fn=30,It="...",Pt=800,zn=16,cn=1,ln=2,Gn=3,Z=1/0,en=9007199254740991,Zn=17976931348623157e292,Kn=0/0,vn=4294967295,Tt=vn-1,Ce=vn>>>1,mr=[["ary",Y],["bind",X],["bindKey",En],["curry",mn],["curryRight",ot],["flip",Wn],["partial",un],["partialRight",on],["rearg",Cn]],mt="[object Arguments]",ae="[object Array]",Tu="[object AsyncFunction]",$t="[object Boolean]",yt="[object Date]",yr="[object DOMException]",ue="[object Error]",ie="[object Function]",qu="[object GeneratorFunction]",Hn="[object Map]",oe="[object Number]",xa="[object Null]",at="[object Object]",Vu="[object Promise]",Da="[object Proxy]",fe="[object RegExp]",Jn="[object Set]",ce="[object String]",Oe="[object Symbol]",Ea="[object Undefined]",le="[object WeakMap]",Ca="[object WeakSet]",se="[object ArrayBuffer]",qt="[object DataView]",wr="[object Float32Array]",xr="[object Float64Array]",jr="[object Int8Array]",Ar="[object Int16Array]",Dr="[object Int32Array]",Er="[object Uint8Array]",Cr="[object Uint8ClampedArray]",Or="[object Uint16Array]",kr="[object Uint32Array]",Oa=/\b__p \+= '';/g,ka=/\b(__p \+=) '' \+/g,Sa=/(__e\(.*?\)|\b__t\)) \+\n'';/g,Yu=/&(?:amp|lt|gt|quot|#39);/g,Zu=/[&<>"']/g,Ia=RegExp(Yu.source),$a=RegExp(Zu.source),Ba=/<%-([\s\S]+?)%>/g,Fa=/<%([\s\S]+?)%>/g,Hu=/<%=([\s\S]+?)%>/g,Ra=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,za=/^\w*$/,Wa=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Sr=/[\\^$.*+?()[\]{}|]/g,Ua=RegExp(Sr.source),Ir=/^\s+/,Ma=/\s/,La=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Na=/\{\n\/\* \[wrapped with (.+)\] \*/,Pa=/,? & /,Ta=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,qa=/[()=,{}\[\]\/\s]/,Va=/\\(\\)?/g,Ya=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Ku=/\w*$/,Za=/^[-+]0x[0-9a-f]+$/i,Ha=/^0b[01]+$/i,Ka=/^\[object .+?Constructor\]$/,Ga=/^0o[0-7]+$/i,Ja=/^(?:0|[1-9]\d*)$/,Qa=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,ke=/($^)/,Xa=/['\n\r\u2028\u2029\\]/g,Se="\\ud800-\\udfff",nf="\\u0300-\\u036f",tf="\\ufe20-\\ufe2f",ef="\\u20d0-\\u20ff",Gu=nf+tf+ef,Ju="\\u2700-\\u27bf",Qu="a-z\\xdf-\\xf6\\xf8-\\xff",rf="\\xac\\xb1\\xd7\\xf7",uf="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",of="\\u2000-\\u206f",af=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Xu="A-Z\\xc0-\\xd6\\xd8-\\xde",ni="\\ufe0e\\ufe0f",ti=rf+uf+of+af,$r="['\u2019]",ff="["+Se+"]",ei="["+ti+"]",Ie="["+Gu+"]",ri="\\d+",cf="["+Ju+"]",ui="["+Qu+"]",ii="[^"+Se+ti+ri+Ju+Qu+Xu+"]",Br="\\ud83c[\\udffb-\\udfff]",lf="(?:"+Ie+"|"+Br+")",oi="[^"+Se+"]",Fr="(?:\\ud83c[\\udde6-\\uddff]){2}",Rr="[\\ud800-\\udbff][\\udc00-\\udfff]",Vt="["+Xu+"]",ai="\\u200d",fi="(?:"+ui+"|"+ii+")",sf="(?:"+Vt+"|"+ii+")",ci="(?:"+$r+"(?:d|ll|m|re|s|t|ve))?",li="(?:"+$r+"(?:D|LL|M|RE|S|T|VE))?",si=lf+"?",pi="["+ni+"]?",pf="(?:"+ai+"(?:"+[oi,Fr,Rr].join("|")+")"+pi+si+")*",hf="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",vf="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",hi=pi+si+pf,_f="(?:"+[cf,Fr,Rr].join("|")+")"+hi,gf="(?:"+[oi+Ie+"?",Ie,Fr,Rr,ff].join("|")+")",yf=RegExp($r,"g"),df=RegExp(Ie,"g"),zr=RegExp(Br+"(?="+Br+")|"+gf+hi,"g"),mf=RegExp([Vt+"?"+ui+"+"+ci+"(?="+[ei,Vt,"$"].join("|")+")",sf+"+"+li+"(?="+[ei,Vt+fi,"$"].join("|")+")",Vt+"?"+fi+"+"+ci,Vt+"+"+li,vf,hf,ri,_f].join("|"),"g"),bf=RegExp("["+ai+Se+Gu+ni+"]"),wf=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,xf=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],jf=-1,T={};T[wr]=T[xr]=T[jr]=T[Ar]=T[Dr]=T[Er]=T[Cr]=T[Or]=T[kr]=!0,T[mt]=T[ae]=T[se]=T[$t]=T[qt]=T[yt]=T[ue]=T[ie]=T[Hn]=T[oe]=T[at]=T[fe]=T[Jn]=T[ce]=T[le]=!1;var P={};P[mt]=P[ae]=P[se]=P[qt]=P[$t]=P[yt]=P[wr]=P[xr]=P[jr]=P[Ar]=P[Dr]=P[Hn]=P[oe]=P[at]=P[fe]=P[Jn]=P[ce]=P[Oe]=P[Er]=P[Cr]=P[Or]=P[kr]=!0,P[ue]=P[ie]=P[le]=!1;var Af={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},Df={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Ef={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Cf={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Of=parseFloat,kf=parseInt,vi=typeof global=="object"&&global&&global.Object===Object&&global,Sf=typeof self=="object"&&self&&self.Object===Object&&self,nn=vi||Sf||Function("return this")(),Wr=typeof y=="object"&&y&&!y.nodeType&&y,Bt=Wr&&typeof d=="object"&&d&&!d.nodeType&&d,_i=Bt&&Bt.exports===Wr,Ur=_i&&vi.process,Mn=function(){try{var l=Bt&&Bt.require&&Bt.require("util").types;return l||Ur&&Ur.binding&&Ur.binding("util")}catch(h){}}(),gi=Mn&&Mn.isArrayBuffer,yi=Mn&&Mn.isDate,di=Mn&&Mn.isMap,mi=Mn&&Mn.isRegExp,bi=Mn&&Mn.isSet,wi=Mn&&Mn.isTypedArray;function On(l,h,p){switch(p.length){case 0:return l.call(h);case 1:return l.call(h,p[0]);case 2:return l.call(h,p[0],p[1]);case 3:return l.call(h,p[0],p[1],p[2])}return l.apply(h,p)}function If(l,h,p,b){for(var D=-1,W=l==null?0:l.length;++D<W;){var J=l[D];h(b,J,p(J),l)}return b}function Ln(l,h){for(var p=-1,b=l==null?0:l.length;++p<b&&h(l[p],p,l)!==!1;);return l}function $f(l,h){for(var p=l==null?0:l.length;p--&&h(l[p],p,l)!==!1;);return l}function xi(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(!h(l[p],p,l))return!1;return!0}function bt(l,h){for(var p=-1,b=l==null?0:l.length,D=0,W=[];++p<b;){var J=l[p];h(J,p,l)&&(W[D++]=J)}return W}function $e(l,h){var p=l==null?0:l.length;return!!p&&Yt(l,h,0)>-1}function Mr(l,h,p){for(var b=-1,D=l==null?0:l.length;++b<D;)if(p(h,l[b]))return!0;return!1}function q(l,h){for(var p=-1,b=l==null?0:l.length,D=Array(b);++p<b;)D[p]=h(l[p],p,l);return D}function wt(l,h){for(var p=-1,b=h.length,D=l.length;++p<b;)l[D+p]=h[p];return l}function Lr(l,h,p,b){var D=-1,W=l==null?0:l.length;for(b&&W&&(p=l[++D]);++D<W;)p=h(p,l[D],D,l);return p}function Bf(l,h,p,b){var D=l==null?0:l.length;for(b&&D&&(p=l[--D]);D--;)p=h(p,l[D],D,l);return p}function Nr(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(h(l[p],p,l))return!0;return!1}var Ff=Pr("length");function Rf(l){return l.split("")}function zf(l){return l.match(Ta)||[]}function ji(l,h,p){var b;return p(l,function(D,W,J){if(h(D,W,J))return b=W,!1}),b}function Be(l,h,p,b){for(var D=l.length,W=p+(b?1:-1);b?W--:++W<D;)if(h(l[W],W,l))return W;return-1}function Yt(l,h,p){return h===h?Hf(l,h,p):Be(l,Ai,p)}function Wf(l,h,p,b){for(var D=p-1,W=l.length;++D<W;)if(b(l[D],h))return D;return-1}function Ai(l){return l!==l}function Di(l,h){var p=l==null?0:l.length;return p?qr(l,h)/p:Kn}function Pr(l){return function(h){return h==null?a:h[l]}}function Tr(l){return function(h){return l==null?a:l[h]}}function Ei(l,h,p,b,D){return D(l,function(W,J,N){p=b?(b=!1,W):h(p,W,J,N)}),p}function Uf(l,h){var p=l.length;for(l.sort(h);p--;)l[p]=l[p].value;return l}function qr(l,h){for(var p,b=-1,D=l.length;++b<D;){var W=h(l[b]);W!==a&&(p=p===a?W:p+W)}return p}function Vr(l,h){for(var p=-1,b=Array(l);++p<l;)b[p]=h(p);return b}function Mf(l,h){return q(h,function(p){return[p,l[p]]})}function Ci(l){return l&&l.slice(0,Ii(l)+1).replace(Ir,"")}function kn(l){return function(h){return l(h)}}function Yr(l,h){return q(h,function(p){return l[p]})}function pe(l,h){return l.has(h)}function Oi(l,h){for(var p=-1,b=l.length;++p<b&&Yt(h,l[p],0)>-1;);return p}function ki(l,h){for(var p=l.length;p--&&Yt(h,l[p],0)>-1;);return p}function Lf(l,h){for(var p=l.length,b=0;p--;)l[p]===h&&++b;return b}var Nf=Tr(Af),Pf=Tr(Df);function Tf(l){return"\\"+Cf[l]}function qf(l,h){return l==null?a:l[h]}function Zt(l){return bf.test(l)}function Vf(l){return wf.test(l)}function Yf(l){for(var h,p=[];!(h=l.next()).done;)p.push(h.value);return p}function Zr(l){var h=-1,p=Array(l.size);return l.forEach(function(b,D){p[++h]=[D,b]}),p}function Si(l,h){return function(p){return l(h(p))}}function xt(l,h){for(var p=-1,b=l.length,D=0,W=[];++p<b;){var J=l[p];(J===h||J===Dn)&&(l[p]=Dn,W[D++]=p)}return W}function Fe(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=b}),p}function Zf(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=[b,b]}),p}function Hf(l,h,p){for(var b=p-1,D=l.length;++b<D;)if(l[b]===h)return b;return-1}function Kf(l,h,p){for(var b=p+1;b--;)if(l[b]===h)return b;return b}function Ht(l){return Zt(l)?Jf(l):Ff(l)}function Qn(l){return Zt(l)?Qf(l):Rf(l)}function Ii(l){for(var h=l.length;h--&&Ma.test(l.charAt(h)););return h}var Gf=Tr(Ef);function Jf(l){for(var h=zr.lastIndex=0;zr.test(l);)++h;return h}function Qf(l){return l.match(zr)||[]}function Xf(l){return l.match(mf)||[]}var nc=function l(h){h=h==null?nn:jt.defaults(nn.Object(),h,jt.pick(nn,xf));var p=h.Array,b=h.Date,D=h.Error,W=h.Function,J=h.Math,N=h.Object,Hr=h.RegExp,tc=h.String,Nn=h.TypeError,Re=p.prototype,ec=W.prototype,Kt=N.prototype,ze=h["__core-js_shared__"],We=ec.toString,M=Kt.hasOwnProperty,rc=0,$i=function(){var n=/[^.]+$/.exec(ze&&ze.keys&&ze.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Ue=Kt.toString,uc=We.call(N),ic=nn._,oc=Hr("^"+We.call(M).replace(Sr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Me=_i?h.Buffer:a,At=h.Symbol,Le=h.Uint8Array,Bi=Me?Me.allocUnsafe:a,Ne=Si(N.getPrototypeOf,N),Fi=N.create,Ri=Kt.propertyIsEnumerable,Pe=Re.splice,zi=At?At.isConcatSpreadable:a,he=At?At.iterator:a,Ft=At?At.toStringTag:a,Te=function(){try{var n=Mt(N,"defineProperty");return n({},"",{}),n}catch(t){}}(),ac=h.clearTimeout!==nn.clearTimeout&&h.clearTimeout,fc=b&&b.now!==nn.Date.now&&b.now,cc=h.setTimeout!==nn.setTimeout&&h.setTimeout,qe=J.ceil,Ve=J.floor,Kr=N.getOwnPropertySymbols,lc=Me?Me.isBuffer:a,Wi=h.isFinite,sc=Re.join,pc=Si(N.keys,N),Q=J.max,pn=J.min,hc=b.now,vc=h.parseInt,Ui=J.random,_c=Re.reverse,Gr=Mt(h,"DataView"),ve=Mt(h,"Map"),Jr=Mt(h,"Promise"),Gt=Mt(h,"Set"),_e=Mt(h,"WeakMap"),ge=Mt(N,"create"),Ye=_e&&new _e,Jt={},gc=Lt(Gr),yc=Lt(ve),dc=Lt(Jr),mc=Lt(Gt),bc=Lt(_e),Ze=At?At.prototype:a,ye=Ze?Ze.valueOf:a,Mi=Ze?Ze.toString:a;function i(n){if(H(n)&&!E(n)&&!(n instanceof B)){if(n instanceof Pn)return n;if(M.call(n,"__wrapped__"))return No(n)}return new Pn(n)}var Qt=function(){function n(){}return function(t){if(!V(t))return{};if(Fi)return Fi(t);n.prototype=t;var e=new n;return n.prototype=a,e}}();function He(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=a}i.templateSettings={escape:Ba,evaluate:Fa,interpolate:Hu,variable:"",imports:{_:i}},i.prototype=He.prototype,i.prototype.constructor=i,Pn.prototype=Qt(He.prototype),Pn.prototype.constructor=Pn;function B(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=vn,this.__views__=[]}function wc(){var n=new B(this.__wrapped__);return n.__actions__=wn(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=wn(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=wn(this.__views__),n}function xc(){if(this.__filtered__){var n=new B(this);n.__dir__=-1,n.__filtered__=!0}else n=this.clone(),n.__dir__*=-1;return n}function jc(){var n=this.__wrapped__.value(),t=this.__dir__,e=E(n),r=t<0,u=e?n.length:0,o=Rl(0,u,this.__views__),f=o.start,c=o.end,s=c-f,v=r?c:f-1,_=this.__iteratees__,g=_.length,m=0,w=pn(s,this.__takeCount__);if(!e||!r&&u==s&&w==s)return co(n,this.__actions__);var j=[];n:for(;s--&&m<w;){v+=t;for(var S=-1,A=n[v];++S<g;){var $=_[S],F=$.iteratee,$n=$.type,yn=F(A);if($n==ln)A=yn;else if(!yn){if($n==cn)continue n;break n}}j[m++]=A}return j}B.prototype=Qt(He.prototype),B.prototype.constructor=B;function Rt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Ac(){this.__data__=ge?ge(null):{},this.size=0}function Dc(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Ec(n){var t=this.__data__;if(ge){var e=t[n];return e===dn?a:e}return M.call(t,n)?t[n]:a}function Cc(n){var t=this.__data__;return ge?t[n]!==a:M.call(t,n)}function Oc(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=ge&&t===a?dn:t,this}Rt.prototype.clear=Ac,Rt.prototype.delete=Dc,Rt.prototype.get=Ec,Rt.prototype.has=Cc,Rt.prototype.set=Oc;function ft(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function kc(){this.__data__=[],this.size=0}function Sc(n){var t=this.__data__,e=Ke(t,n);if(e<0)return!1;var r=t.length-1;return e==r?t.pop():Pe.call(t,e,1),--this.size,!0}function Ic(n){var t=this.__data__,e=Ke(t,n);return e<0?a:t[e][1]}function $c(n){return Ke(this.__data__,n)>-1}function Bc(n,t){var e=this.__data__,r=Ke(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}ft.prototype.clear=kc,ft.prototype.delete=Sc,ft.prototype.get=Ic,ft.prototype.has=$c,ft.prototype.set=Bc;function ct(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Fc(){this.size=0,this.__data__={hash:new Rt,map:new(ve||ft),string:new Rt}}function Rc(n){var t=ar(this,n).delete(n);return this.size-=t?1:0,t}function zc(n){return ar(this,n).get(n)}function Wc(n){return ar(this,n).has(n)}function Uc(n,t){var e=ar(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}ct.prototype.clear=Fc,ct.prototype.delete=Rc,ct.prototype.get=zc,ct.prototype.has=Wc,ct.prototype.set=Uc;function zt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new ct;++t<e;)this.add(n[t])}function Mc(n){return this.__data__.set(n,dn),this}function Lc(n){return this.__data__.has(n)}zt.prototype.add=zt.prototype.push=Mc,zt.prototype.has=Lc;function Xn(n){var t=this.__data__=new ft(n);this.size=t.size}function Nc(){this.__data__=new ft,this.size=0}function Pc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function Tc(n){return this.__data__.get(n)}function qc(n){return this.__data__.has(n)}function Vc(n,t){var e=this.__data__;if(e instanceof ft){var r=e.__data__;if(!ve||r.length<R-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new ct(r)}return e.set(n,t),this.size=e.size,this}Xn.prototype.clear=Nc,Xn.prototype.delete=Pc,Xn.prototype.get=Tc,Xn.prototype.has=qc,Xn.prototype.set=Vc;function Li(n,t){var e=E(n),r=!e&&Nt(n),u=!e&&!r&&kt(n),o=!e&&!r&&!u&&ee(n),f=e||r||u||o,c=f?Vr(n.length,tc):[],s=c.length;for(var v in n)(t||M.call(n,v))&&!(f&&(v=="length"||u&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||ht(v,s)))&&c.push(v);return c}function Ni(n){var t=n.length;return t?n[fu(0,t-1)]:a}function Yc(n,t){return fr(wn(n),Wt(t,0,n.length))}function Zc(n){return fr(wn(n))}function Qr(n,t,e){(e!==a&&!nt(n[t],e)||e===a&&!(t in n))&&lt(n,t,e)}function de(n,t,e){var r=n[t];(!(M.call(n,t)&&nt(r,e))||e===a&&!(t in n))&&lt(n,t,e)}function Ke(n,t){for(var e=n.length;e--;)if(nt(n[e][0],t))return e;return-1}function Hc(n,t,e,r){return Dt(n,function(u,o,f){t(r,u,e(u),f)}),r}function Pi(n,t){return n&&rt(t,tn(t),n)}function Kc(n,t){return n&&rt(t,jn(t),n)}function lt(n,t,e){t=="__proto__"&&Te?Te(n,t,{configurable:!0,enumerable:!0,value:e,writable:!0}):n[t]=e}function Xr(n,t){for(var e=-1,r=t.length,u=p(r),o=n==null;++e<r;)u[e]=o?a:Bu(n,t[e]);return u}function Wt(n,t,e){return n===n&&(e!==a&&(n=n<=e?n:e),t!==a&&(n=n>=t?n:t)),n}function Tn(n,t,e,r,u,o){var f,c=t&sn,s=t&dt,v=t&Un;if(e&&(f=u?e(n,r,u,o):e(n)),f!==a)return f;if(!V(n))return n;var _=E(n);if(_){if(f=Wl(n),!c)return wn(n,f)}else{var g=hn(n),m=g==ie||g==qu;if(kt(n))return po(n,c);if(g==at||g==mt||m&&!u){if(f=s||m?{}:$o(n),!c)return s?El(n,Kc(f,n)):Dl(n,Pi(f,n))}else{if(!P[g])return u?n:{};f=Ul(n,g,c)}}o||(o=new Xn);var w=o.get(n);if(w)return w;o.set(n,f),aa(n)?n.forEach(function(A){f.add(Tn(A,t,e,A,n,o))}):ia(n)&&n.forEach(function(A,$){f.set($,Tn(A,t,e,$,n,o))});var j=v?s?mu:du:s?jn:tn,S=_?a:j(n);return Ln(S||n,function(A,$){S&&($=A,A=n[$]),de(f,$,Tn(A,t,e,$,n,o))}),f}function Gc(n){var t=tn(n);return function(e){return Ti(e,n,t)}}function Ti(n,t,e){var r=e.length;if(n==null)return!r;for(n=N(n);r--;){var u=e[r],o=t[u],f=n[u];if(f===a&&!(u in n)||!o(f))return!1}return!0}function qi(n,t,e){if(typeof n!="function")throw new Nn(z);return De(function(){n.apply(a,e)},t)}function me(n,t,e,r){var u=-1,o=$e,f=!0,c=n.length,s=[],v=t.length;if(!c)return s;e&&(t=q(t,kn(e))),r?(o=Mr,f=!1):t.length>=R&&(o=pe,f=!1,t=new zt(t));n:for(;++u<c;){var _=n[u],g=e==null?_:e(_);if(_=r||_!==0?_:0,f&&g===g){for(var m=v;m--;)if(t[m]===g)continue n;s.push(_)}else o(t,g,r)||s.push(_)}return s}var Dt=yo(et),Vi=yo(tu,!0);function Jc(n,t){var e=!0;return Dt(n,function(r,u,o){return e=!!t(r,u,o),e}),e}function Ge(n,t,e){for(var r=-1,u=n.length;++r<u;){var o=n[r],f=t(o);if(f!=null&&(c===a?f===f&&!In(f):e(f,c)))var c=f,s=o}return s}function Qc(n,t,e,r){var u=n.length;for(e=k(e),e<0&&(e=-e>u?0:u+e),r=r===a||r>u?u:k(r),r<0&&(r+=u),r=e>r?0:ca(r);e<r;)n[e++]=t;return n}function Yi(n,t){var e=[];return Dt(n,function(r,u,o){t(r,u,o)&&e.push(r)}),e}function an(n,t,e,r,u){var o=-1,f=n.length;for(e||(e=Ll),u||(u=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?an(c,t-1,e,r,u):wt(u,c):r||(u[u.length]=c)}return u}var nu=mo(),Zi=mo(!0);function et(n,t){return n&&nu(n,t,tn)}function tu(n,t){return n&&Zi(n,t,tn)}function Je(n,t){return bt(t,function(e){return vt(n[e])})}function Ut(n,t){t=Ct(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[ut(t[e++])];return e&&e==r?n:a}function Hi(n,t,e){var r=t(n);return E(n)?r:wt(r,e(n))}function _n(n){return n==null?n===a?Ea:xa:Ft&&Ft in N(n)?Fl(n):Zl(n)}function eu(n,t){return n>t}function Xc(n,t){return n!=null&&M.call(n,t)}function nl(n,t){return n!=null&&t in N(n)}function tl(n,t,e){return n>=pn(t,e)&&n<Q(t,e)}function ru(n,t,e){for(var r=e?Mr:$e,u=n[0].length,o=n.length,f=o,c=p(o),s=Infinity,v=[];f--;){var _=n[f];f&&t&&(_=q(_,kn(t))),s=pn(_.length,s),c[f]=!e&&(t||u>=120&&_.length>=120)?new zt(f&&_):a}_=n[0];var g=-1,m=c[0];n:for(;++g<u&&v.length<s;){var w=_[g],j=t?t(w):w;if(w=e||w!==0?w:0,!(m?pe(m,j):r(v,j,e))){for(f=o;--f;){var S=c[f];if(!(S?pe(S,j):r(n[f],j,e)))continue n}m&&m.push(j),v.push(w)}}return v}function el(n,t,e,r){return et(n,function(u,o,f){t(r,e(u),o,f)}),r}function be(n,t,e){t=Ct(t,n),n=zo(n,t);var r=n==null?n:n[ut(Vn(t))];return r==null?a:On(r,n,e)}function Ki(n){return H(n)&&_n(n)==mt}function rl(n){return H(n)&&_n(n)==se}function ul(n){return H(n)&&_n(n)==yt}function we(n,t,e,r,u){return n===t?!0:n==null||t==null||!H(n)&&!H(t)?n!==n&&t!==t:il(n,t,e,r,we,u)}function il(n,t,e,r,u,o){var f=E(n),c=E(t),s=f?ae:hn(n),v=c?ae:hn(t);s=s==mt?at:s,v=v==mt?at:v;var _=s==at,g=v==at,m=s==v;if(m&&kt(n)){if(!kt(t))return!1;f=!0,_=!1}if(m&&!_)return o||(o=new Xn),f||ee(n)?ko(n,t,e,r,u,o):$l(n,t,s,e,r,u,o);if(!(e&Rn)){var w=_&&M.call(n,"__wrapped__"),j=g&&M.call(t,"__wrapped__");if(w||j){var S=w?n.value():n,A=j?t.value():t;return o||(o=new Xn),u(S,A,e,r,o)}}return m?(o||(o=new Xn),Bl(n,t,e,r,u,o)):!1}function ol(n){return H(n)&&hn(n)==Hn}function uu(n,t,e,r){var u=e.length,o=u,f=!r;if(n==null)return!o;for(n=N(n);u--;){var c=e[u];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return!1}for(;++u<o;){c=e[u];var s=c[0],v=n[s],_=c[1];if(f&&c[2]){if(v===a&&!(s in n))return!1}else{var g=new Xn;if(r)var m=r(v,_,s,n,t,g);if(!(m===a?we(_,v,Rn|bn,r,g):m))return!1}}return!0}function Gi(n){if(!V(n)||Pl(n))return!1;var t=vt(n)?oc:Ka;return t.test(Lt(n))}function al(n){return H(n)&&_n(n)==fe}function fl(n){return H(n)&&hn(n)==Jn}function cl(n){return H(n)&&vr(n.length)&&!!T[_n(n)]}function Ji(n){return typeof n=="function"?n:n==null?An:typeof n=="object"?E(n)?no(n[0],n[1]):Xi(n):ba(n)}function iu(n){if(!Ae(n))return pc(n);var t=[];for(var e in N(n))M.call(n,e)&&e!="constructor"&&t.push(e);return t}function ll(n){if(!V(n))return Yl(n);var t=Ae(n),e=[];for(var r in n)r=="constructor"&&(t||!M.call(n,r))||e.push(r);return e}function ou(n,t){return n<t}function Qi(n,t){var e=-1,r=xn(n)?p(n.length):[];return Dt(n,function(u,o,f){r[++e]=t(u,o,f)}),r}function Xi(n){var t=wu(n);return t.length==1&&t[0][2]?Fo(t[0][0],t[0][1]):function(e){return e===n||uu(e,n,t)}}function no(n,t){return ju(n)&&Bo(t)?Fo(ut(n),t):function(e){var r=Bu(e,n);return r===a&&r===t?Fu(e,n):we(t,r,Rn|bn)}}function Qe(n,t,e,r,u){n!==t&&nu(t,function(o,f){if(u||(u=new Xn),V(o))sl(n,t,f,e,Qe,r,u);else{var c=r?r(Du(n,f),o,f+"",n,t,u):a;c===a&&(c=o),Qr(n,f,c)}},jn)}function sl(n,t,e,r,u,o,f){var c=Du(n,e),s=Du(t,e),v=f.get(s);if(v){Qr(n,e,v);return}var _=o?o(c,s,e+"",n,t,f):a,g=_===a;if(g){var m=E(s),w=!m&&kt(s),j=!m&&!w&&ee(s);_=s,m||w||j?E(c)?_=c:K(c)?_=wn(c):w?(g=!1,_=po(s,!0)):j?(g=!1,_=ho(s,!0)):_=[]:Ee(s)||Nt(s)?(_=c,Nt(c)?_=la(c):(!V(c)||vt(c))&&(_=$o(s))):g=!1}g&&(f.set(s,_),u(_,s,r,o,f),f.delete(s)),Qr(n,e,_)}function to(n,t){var e=n.length;if(e)return t+=t<0?e:0,ht(t,e)?n[t]:a}function eo(n,t,e){t.length?t=q(t,function(o){return E(o)?function(f){return Ut(f,o.length===1?o[0]:o)}:o}):t=[An];var r=-1;t=q(t,kn(x()));var u=Qi(n,function(o,f,c){var s=q(t,function(v){return v(o)});return{criteria:s,index:++r,value:o}});return Uf(u,function(o,f){return Al(o,f,e)})}function pl(n,t){return ro(n,t,function(e,r){return Fu(n,r)})}function ro(n,t,e){for(var r=-1,u=t.length,o={};++r<u;){var f=t[r],c=Ut(n,f);e(c,f)&&xe(o,Ct(f,n),c)}return o}function hl(n){return function(t){return Ut(t,n)}}function au(n,t,e,r){var u=r?Wf:Yt,o=-1,f=t.length,c=n;for(n===t&&(t=wn(t)),e&&(c=q(n,kn(e)));++o<f;)for(var s=0,v=t[o],_=e?e(v):v;(s=u(c,_,s,r))>-1;)c!==n&&Pe.call(c,s,1),Pe.call(n,s,1);return n}function uo(n,t){for(var e=n?t.length:0,r=e-1;e--;){var u=t[e];if(e==r||u!==o){var o=u;ht(u)?Pe.call(n,u,1):su(n,u)}}return n}function fu(n,t){return n+Ve(Ui()*(t-n+1))}function vl(n,t,e,r){for(var u=-1,o=Q(qe((t-n)/(e||1)),0),f=p(o);o--;)f[r?o:++u]=n,n+=e;return f}function cu(n,t){var e="";if(!n||t<1||t>en)return e;do t%2&&(e+=n),t=Ve(t/2),t&&(n+=n);while(t);return e}function I(n,t){return Eu(Ro(n,t,An),n+"")}function _l(n){return Ni(re(n))}function gl(n,t){var e=re(n);return fr(e,Wt(t,0,e.length))}function xe(n,t,e,r){if(!V(n))return n;t=Ct(t,n);for(var u=-1,o=t.length,f=o-1,c=n;c!=null&&++u<o;){var s=ut(t[u]),v=e;if(s==="__proto__"||s==="constructor"||s==="prototype")return n;if(u!=f){var _=c[s];v=r?r(_,s,c):a,v===a&&(v=V(_)?_:ht(t[u+1])?[]:{})}de(c,s,v),c=c[s]}return n}var io=Ye?function(n,t){return Ye.set(n,t),n}:An,yl=Te?function(n,t){return Te(n,"toString",{configurable:!0,enumerable:!1,value:zu(t),writable:!0})}:An;function dl(n){return fr(re(n))}function qn(n,t,e){var r=-1,u=n.length;t<0&&(t=-t>u?0:u+t),e=e>u?u:e,e<0&&(e+=u),u=t>e?0:e-t>>>0,t>>>=0;for(var o=p(u);++r<u;)o[r]=n[r+t];return o}function ml(n,t){var e;return Dt(n,function(r,u,o){return e=t(r,u,o),!e}),!!e}function Xe(n,t,e){var r=0,u=n==null?r:n.length;if(typeof t=="number"&&t===t&&u<=Ce){for(;r<u;){var o=r+u>>>1,f=n[o];f!==null&&!In(f)&&(e?f<=t:f<t)?r=o+1:u=o}return u}return lu(n,t,An,e)}function lu(n,t,e,r){var u=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,s=In(t),v=t===a;u<o;){var _=Ve((u+o)/2),g=e(n[_]),m=g!==a,w=g===null,j=g===g,S=In(g);if(f)var A=r||j;else v?A=j&&(r||m):c?A=j&&m&&(r||!w):s?A=j&&m&&!w&&(r||!S):w||S?A=!1:A=r?g<=t:g<t;A?u=_+1:o=_}return pn(o,Tt)}function oo(n,t){for(var e=-1,r=n.length,u=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!nt(c,s)){var s=c;o[u++]=f===0?0:f}}return o}function ao(n){return typeof n=="number"?n:In(n)?Kn:+n}function Sn(n){if(typeof n=="string")return n;if(E(n))return q(n,Sn)+"";if(In(n))return Mi?Mi.call(n):"";var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Et(n,t,e){var r=-1,u=$e,o=n.length,f=!0,c=[],s=c;if(e)f=!1,u=Mr;else if(o>=R){var v=t?null:Sl(n);if(v)return Fe(v);f=!1,u=pe,s=new zt}else s=t?[]:c;n:for(;++r<o;){var _=n[r],g=t?t(_):_;if(_=e||_!==0?_:0,f&&g===g){for(var m=s.length;m--;)if(s[m]===g)continue n;t&&s.push(g),c.push(_)}else u(s,g,e)||(s!==c&&s.push(g),c.push(_))}return c}function su(n,t){return t=Ct(t,n),n=zo(n,t),n==null||delete n[ut(Vn(t))]}function fo(n,t,e,r){return xe(n,t,e(Ut(n,t)),r)}function nr(n,t,e,r){for(var u=n.length,o=r?u:-1;(r?o--:++o<u)&&t(n[o],o,n););return e?qn(n,r?0:o,r?o+1:u):qn(n,r?o+1:0,r?u:o)}function co(n,t){var e=n;return e instanceof B&&(e=e.value()),Lr(t,function(r,u){return u.func.apply(u.thisArg,wt([r],u.args))},e)}function pu(n,t,e){var r=n.length;if(r<2)return r?Et(n[0]):[];for(var u=-1,o=p(r);++u<r;)for(var f=n[u],c=-1;++c<r;)c!=u&&(o[u]=me(o[u]||f,n[c],t,e));return Et(an(o,1),t,e)}function lo(n,t,e){for(var r=-1,u=n.length,o=t.length,f={};++r<u;){var c=r<o?t[r]:a;e(f,n[r],c)}return f}function hu(n){return K(n)?n:[]}function vu(n){return typeof n=="function"?n:An}function Ct(n,t){return E(n)?n:ju(n,t)?[n]:Lo(U(n))}var bl=I;function Ot(n,t,e){var r=n.length;return e=e===a?r:e,!t&&e>=r?n:qn(n,t,e)}var so=ac||function(n){return nn.clearTimeout(n)};function po(n,t){if(t)return n.slice();var e=n.length,r=Bi?Bi(e):new n.constructor(e);return n.copy(r),r}function _u(n){var t=new n.constructor(n.byteLength);return new Le(t).set(new Le(n)),t}function wl(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function xl(n){var t=new n.constructor(n.source,Ku.exec(n));return t.lastIndex=n.lastIndex,t}function jl(n){return ye?N(ye.call(n)):{}}function ho(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function vo(n,t){if(n!==t){var e=n!==a,r=n===null,u=n===n,o=In(n),f=t!==a,c=t===null,s=t===t,v=In(t);if(!c&&!v&&!o&&n>t||o&&f&&s&&!c&&!v||r&&f&&s||!e&&s||!u)return 1;if(!r&&!o&&!v&&n<t||v&&e&&u&&!r&&!o||c&&e&&u||!f&&u||!s)return-1}return 0}function Al(n,t,e){for(var r=-1,u=n.criteria,o=t.criteria,f=u.length,c=e.length;++r<f;){var s=vo(u[r],o[r]);if(s){if(r>=c)return s;var v=e[r];return s*(v=="desc"?-1:1)}}return n.index-t.index}function _o(n,t,e,r){for(var u=-1,o=n.length,f=e.length,c=-1,s=t.length,v=Q(o-f,0),_=p(s+v),g=!r;++c<s;)_[c]=t[c];for(;++u<f;)(g||u<o)&&(_[e[u]]=n[u]);for(;v--;)_[c++]=n[u++];return _}function go(n,t,e,r){for(var u=-1,o=n.length,f=-1,c=e.length,s=-1,v=t.length,_=Q(o-c,0),g=p(_+v),m=!r;++u<_;)g[u]=n[u];for(var w=u;++s<v;)g[w+s]=t[s];for(;++f<c;)(m||u<o)&&(g[w+e[f]]=n[u++]);return g}function wn(n,t){var e=-1,r=n.length;for(t||(t=p(r));++e<r;)t[e]=n[e];return t}function rt(n,t,e,r){var u=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],s=r?r(e[c],n[c],c,e,n):a;s===a&&(s=n[c]),u?lt(e,c,s):de(e,c,s)}return e}function Dl(n,t){return rt(n,xu(n),t)}function El(n,t){return rt(n,So(n),t)}function tr(n,t){return function(e,r){var u=E(e)?If:Hc,o=t?t():{};return u(e,n,x(r,2),o)}}function Xt(n){return I(function(t,e){var r=-1,u=e.length,o=u>1?e[u-1]:a,f=u>2?e[2]:a;for(o=n.length>3&&typeof o=="function"?(u--,o):a,f&&gn(e[0],e[1],f)&&(o=u<3?a:o,u=1),t=N(t);++r<u;){var c=e[r];c&&n(t,c,r,o)}return t})}function yo(n,t){return function(e,r){if(e==null)return e;if(!xn(e))return n(e,r);for(var u=e.length,o=t?u:-1,f=N(e);(t?o--:++o<u)&&r(f[o],o,f)!==!1;);return e}}function mo(n){return function(t,e,r){for(var u=-1,o=N(t),f=r(t),c=f.length;c--;){var s=f[n?c:++u];if(e(o[s],s,o)===!1)break}return t}}function Cl(n,t,e){var r=t&X,u=je(n);function o(){var f=this&&this!==nn&&this instanceof o?u:n;return f.apply(r?e:this,arguments)}return o}function bo(n){return function(t){t=U(t);var e=Zt(t)?Qn(t):a,r=e?e[0]:t.charAt(0),u=e?Ot(e,1).join(""):t.slice(1);return r[n]()+u}}function ne(n){return function(t){return Lr(da(ya(t).replace(yf,"")),n,"")}}function je(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=Qt(n.prototype),r=n.apply(e,t);return V(r)?r:e}}function Ol(n,t,e){var r=je(n);function u(){for(var o=arguments.length,f=p(o),c=o,s=te(u);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==s&&f[o-1]!==s?[]:xt(f,s);if(o-=v.length,o<e)return Do(n,t,er,u.placeholder,a,f,v,a,a,e-o);var _=this&&this!==nn&&this instanceof u?r:n;return On(_,this,f)}return u}function wo(n){return function(t,e,r){var u=N(t);if(!xn(t)){var o=x(e,3);t=tn(t),e=function(c){return o(u[c],c,u)}}var f=n(t,e,r);return f>-1?u[o?t[f]:f]:a}}function xo(n){return pt(function(t){var e=t.length,r=e,u=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new Nn(z);if(u&&!f&&or(o)=="wrapper")var f=new Pn([],!0)}for(r=f?r:e;++r<e;){o=t[r];var c=or(o),s=c=="wrapper"?bu(o):a;s&&Au(s[0])&&s[1]==(Y|mn|un|Cn)&&!s[4].length&&s[9]==1?f=f[or(s[0])].apply(f,s[3]):f=o.length==1&&Au(o)?f[c]():f.thru(o)}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&E(_))return f.plant(_).value();for(var g=0,m=e?t[g].apply(this,v):_;++g<e;)m=t[g].call(this,m);return m}})}function er(n,t,e,r,u,o,f,c,s,v){var _=t&Y,g=t&X,m=t&En,w=t&(mn|ot),j=t&Wn,S=m?a:je(n);function A(){for(var $=arguments.length,F=p($),$n=$;$n--;)F[$n]=arguments[$n];if(w)var yn=te(A),Bn=Lf(F,yn);if(r&&(F=_o(F,r,u,w)),o&&(F=go(F,o,f,w)),$-=Bn,w&&$<v){var G=xt(F,yn);return Do(n,t,er,A.placeholder,e,F,G,c,s,v-$)}var tt=g?e:this,gt=m?tt[n]:n;return $=F.length,c?F=Hl(F,c):j&&$>1&&F.reverse(),_&&s<$&&(F.length=s),this&&this!==nn&&this instanceof A&&(gt=S||je(gt)),gt.apply(tt,F)}return A}function jo(n,t){return function(e,r){return el(e,n,t(r),{})}}function rr(n,t){return function(e,r){var u;if(e===a&&r===a)return t;if(e!==a&&(u=e),r!==a){if(u===a)return r;typeof e=="string"||typeof r=="string"?(e=Sn(e),r=Sn(r)):(e=ao(e),r=ao(r)),u=n(e,r)}return u}}function gu(n){return pt(function(t){return t=q(t,kn(x())),I(function(e){var r=this;return n(t,function(u){return On(u,r,e)})})})}function ur(n,t){t=t===a?" ":Sn(t);var e=t.length;if(e<2)return e?cu(t,n):t;var r=cu(t,qe(n/Ht(t)));return Zt(t)?Ot(Qn(r),0,n).join(""):r.slice(0,n)}function kl(n,t,e,r){var u=t&X,o=je(n);function f(){for(var c=-1,s=arguments.length,v=-1,_=r.length,g=p(_+s),m=this&&this!==nn&&this instanceof f?o:n;++v<_;)g[v]=r[v];for(;s--;)g[v++]=arguments[++c];return On(m,u?e:this,g)}return f}function Ao(n){return function(t,e,r){return r&&typeof r!="number"&&gn(t,e,r)&&(e=r=a),t=_t(t),e===a?(e=t,t=0):e=_t(e),r=r===a?t<e?1:-1:_t(r),vl(t,e,r,n)}}function ir(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=Yn(t),e=Yn(e)),n(t,e)}}function Do(n,t,e,r,u,o,f,c,s,v){var _=t&mn,g=_?f:a,m=_?a:f,w=_?o:a,j=_?a:o;t|=_?un:on,t&=~(_?on:un),t&St||(t&=~(X|En));var S=[n,t,u,w,g,j,m,c,s,v],A=e.apply(a,S);return Au(n)&&Wo(A,S),A.placeholder=r,Uo(A,n,t)}function yu(n){var t=J[n];return function(e,r){if(e=Yn(e),r=r==null?0:pn(k(r),292),r&&Wi(e)){var u=(U(e)+"e").split("e"),o=t(u[0]+"e"+(+u[1]+r));return u=(U(o)+"e").split("e"),+(u[0]+"e"+(+u[1]-r))}return t(e)}}var Sl=Gt&&1/Fe(new Gt([,-0]))[1]==Z?function(n){return new Gt(n)}:Mu;function Eo(n){return function(t){var e=hn(t);return e==Hn?Zr(t):e==Jn?Zf(t):Mf(t,n(t))}}function st(n,t,e,r,u,o,f,c){var s=t&En;if(!s&&typeof n!="function")throw new Nn(z);var v=r?r.length:0;if(v||(t&=~(un|on),r=u=a),f=f===a?f:Q(k(f),0),c=c===a?c:k(c),v-=u?u.length:0,t&on){var _=r,g=u;r=u=a}var m=s?a:bu(n),w=[n,t,e,r,u,_,g,o,f,c];if(m&&Vl(w,m),n=w[0],t=w[1],e=w[2],r=w[3],u=w[4],c=w[9]=w[9]===a?s?0:n.length:Q(w[9]-v,0),!c&&t&(mn|ot)&&(t&=~(mn|ot)),!t||t==X)var j=Cl(n,t,e);else t==mn||t==ot?j=Ol(n,t,c):(t==un||t==(X|un))&&!u.length?j=kl(n,t,e,r):j=er.apply(a,w);var S=m?io:Wo;return Uo(S(j,w),n,t)}function Co(n,t,e,r){return n===a||nt(n,Kt[e])&&!M.call(r,e)?t:n}function Oo(n,t,e,r,u,o){return V(n)&&V(t)&&(o.set(t,n),Qe(n,t,a,Oo,o),o.delete(t)),n}function Il(n){return Ee(n)?a:n}function ko(n,t,e,r,u,o){var f=e&Rn,c=n.length,s=t.length;if(c!=s&&!(f&&s>c))return!1;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var g=-1,m=!0,w=e&bn?new zt:a;for(o.set(n,t),o.set(t,n);++g<c;){var j=n[g],S=t[g];if(r)var A=f?r(S,j,g,t,n,o):r(j,S,g,n,t,o);if(A!==a){if(A)continue;m=!1;break}if(w){if(!Nr(t,function($,F){if(!pe(w,F)&&(j===$||u(j,$,e,r,o)))return w.push(F)})){m=!1;break}}else if(!(j===S||u(j,S,e,r,o))){m=!1;break}}return o.delete(n),o.delete(t),m}function $l(n,t,e,r,u,o,f){switch(e){case qt:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return!1;n=n.buffer,t=t.buffer;case se:return!(n.byteLength!=t.byteLength||!o(new Le(n),new Le(t)));case $t:case yt:case oe:return nt(+n,+t);case ue:return n.name==t.name&&n.message==t.message;case fe:case ce:return n==t+"";case Hn:var c=Zr;case Jn:var s=r&Rn;if(c||(c=Fe),n.size!=t.size&&!s)return!1;var v=f.get(n);if(v)return v==t;r|=bn,f.set(n,t);var _=ko(c(n),c(t),r,u,o,f);return f.delete(n),_;case Oe:if(ye)return ye.call(n)==ye.call(t)}return!1}function Bl(n,t,e,r,u,o){var f=e&Rn,c=du(n),s=c.length,v=du(t),_=v.length;if(s!=_&&!f)return!1;for(var g=s;g--;){var m=c[g];if(!(f?m in t:M.call(t,m)))return!1}var w=o.get(n),j=o.get(t);if(w&&j)return w==t&&j==n;var S=!0;o.set(n,t),o.set(t,n);for(var A=f;++g<s;){m=c[g];var $=n[m],F=t[m];if(r)var $n=f?r(F,$,m,t,n,o):r($,F,m,n,t,o);if(!($n===a?$===F||u($,F,e,r,o):$n)){S=!1;break}A||(A=m=="constructor")}if(S&&!A){var yn=n.constructor,Bn=t.constructor;yn!=Bn&&"constructor"in n&&"constructor"in t&&!(typeof yn=="function"&&yn instanceof yn&&typeof Bn=="function"&&Bn instanceof Bn)&&(S=!1)}return o.delete(n),o.delete(t),S}function pt(n){return Eu(Ro(n,a,qo),n+"")}function du(n){return Hi(n,tn,xu)}function mu(n){return Hi(n,jn,So)}var bu=Ye?function(n){return Ye.get(n)}:Mu;function or(n){for(var t=n.name+"",e=Jt[t],r=M.call(Jt,t)?e.length:0;r--;){var u=e[r],o=u.func;if(o==null||o==n)return u.name}return t}function te(n){var t=M.call(i,"placeholder")?i:n;return t.placeholder}function x(){var n=i.iteratee||Wu;return n=n===Wu?Ji:n,arguments.length?n(arguments[0],arguments[1]):n}function ar(n,t){var e=n.__data__;return Nl(t)?e[typeof t=="string"?"string":"hash"]:e.map}function wu(n){for(var t=tn(n),e=t.length;e--;){var r=t[e],u=n[r];t[e]=[r,u,Bo(u)]}return t}function Mt(n,t){var e=qf(n,t);return Gi(e)?e:a}function Fl(n){var t=M.call(n,Ft),e=n[Ft];try{n[Ft]=a;var r=!0}catch(o){}var u=Ue.call(n);return r&&(t?n[Ft]=e:delete n[Ft]),u}var xu=Kr?function(n){return n==null?[]:(n=N(n),bt(Kr(n),function(t){return Ri.call(n,t)}))}:Lu,So=Kr?function(n){for(var t=[];n;)wt(t,xu(n)),n=Ne(n);return t}:Lu,hn=_n;(Gr&&hn(new Gr(new ArrayBuffer(1)))!=qt||ve&&hn(new ve)!=Hn||Jr&&hn(Jr.resolve())!=Vu||Gt&&hn(new Gt)!=Jn||_e&&hn(new _e)!=le)&&(hn=function(n){var t=_n(n),e=t==at?n.constructor:a,r=e?Lt(e):"";if(r)switch(r){case gc:return qt;case yc:return Hn;case dc:return Vu;case mc:return Jn;case bc:return le}return t});function Rl(n,t,e){for(var r=-1,u=e.length;++r<u;){var o=e[r],f=o.size;switch(o.type){case"drop":n+=f;break;case"dropRight":t-=f;break;case"take":t=pn(t,n+f);break;case"takeRight":n=Q(n,t-f);break}}return{start:n,end:t}}function zl(n){var t=n.match(Na);return t?t[1].split(Pa):[]}function Io(n,t,e){t=Ct(t,n);for(var r=-1,u=t.length,o=!1;++r<u;){var f=ut(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f]}return o||++r!=u?o:(u=n==null?0:n.length,!!u&&vr(u)&&ht(f,u)&&(E(n)||Nt(n)))}function Wl(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&M.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function $o(n){return typeof n.constructor=="function"&&!Ae(n)?Qt(Ne(n)):{}}function Ul(n,t,e){var r=n.constructor;switch(t){case se:return _u(n);case $t:case yt:return new r(+n);case qt:return wl(n,e);case wr:case xr:case jr:case Ar:case Dr:case Er:case Cr:case Or:case kr:return ho(n,e);case Hn:return new r;case oe:case ce:return new r(n);case fe:return xl(n);case Jn:return new r;case Oe:return jl(n)}}function Ml(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(La,`{
/* [wrapped with `+t+`] */
`)}function Ll(n){return E(n)||Nt(n)||!!(zi&&n&&n[zi])}function ht(n,t){var e=typeof n;return t=t==null?en:t,!!t&&(e=="number"||e!="symbol"&&Ja.test(n))&&n>-1&&n%1==0&&n<t}function gn(n,t,e){if(!V(e))return!1;var r=typeof t;return(r=="number"?xn(e)&&ht(t,e.length):r=="string"&&t in e)?nt(e[t],n):!1}function ju(n,t){if(E(n))return!1;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||In(n)?!0:za.test(n)||!Ra.test(n)||t!=null&&n in N(t)}function Nl(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function Au(n){var t=or(n),e=i[t];if(typeof e!="function"||!(t in B.prototype))return!1;if(n===e)return!0;var r=bu(e);return!!r&&n===r[0]}function Pl(n){return!!$i&&$i in n}var Tl=ze?vt:Nu;function Ae(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Kt;return n===e}function Bo(n){return n===n&&!V(n)}function Fo(n,t){return function(e){return e==null?!1:e[n]===t&&(t!==a||n in N(e))}}function ql(n){var t=pr(n,function(r){return e.size===rn&&e.clear(),r}),e=t.cache;return t}function Vl(n,t){var e=n[1],r=t[1],u=e|r,o=u<(X|En|Y),f=r==Y&&e==mn||r==Y&&e==Cn&&n[7].length<=t[8]||r==(Y|Cn)&&t[7].length<=t[8]&&e==mn;if(!(o||f))return n;r&X&&(n[2]=t[2],u|=e&X?0:St);var c=t[3];if(c){var s=n[3];n[3]=s?_o(s,c,t[4]):c,n[4]=s?xt(n[3],Dn):t[4]}return c=t[5],c&&(s=n[5],n[5]=s?go(s,c,t[6]):c,n[6]=s?xt(n[5],Dn):t[6]),c=t[7],c&&(n[7]=c),r&Y&&(n[8]=n[8]==null?t[8]:pn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Yl(n){var t=[];if(n!=null)for(var e in N(n))t.push(e);return t}function Zl(n){return Ue.call(n)}function Ro(n,t,e){return t=Q(t===a?n.length-1:t,0),function(){for(var r=arguments,u=-1,o=Q(r.length-t,0),f=p(o);++u<o;)f[u]=r[t+u];u=-1;for(var c=p(t+1);++u<t;)c[u]=r[u];return c[t]=e(f),On(n,this,c)}}function zo(n,t){return t.length<2?n:Ut(n,qn(t,0,-1))}function Hl(n,t){for(var e=n.length,r=pn(t.length,e),u=wn(n);r--;){var o=t[r];n[r]=ht(o,e)?u[o]:a}return n}function Du(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Wo=Mo(io),De=cc||function(n,t){return nn.setTimeout(n,t)},Eu=Mo(yl);function Uo(n,t,e){var r=t+"";return Eu(n,Ml(r,Kl(zl(r),e)))}function Mo(n){var t=0,e=0;return function(){var r=hc(),u=zn-(r-e);if(e=r,u>0){if(++t>=Pt)return arguments[0]}else t=0;return n.apply(a,arguments)}}function fr(n,t){var e=-1,r=n.length,u=r-1;for(t=t===a?r:t;++e<t;){var o=fu(e,u),f=n[o];n[o]=n[e],n[e]=f}return n.length=t,n}var Lo=ql(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(Wa,function(e,r,u,o){t.push(u?o.replace(Va,"$1"):r||e)}),t});function ut(n){if(typeof n=="string"||In(n))return n;var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Lt(n){if(n!=null){try{return We.call(n)}catch(t){}try{return n+""}catch(t){}}return""}function Kl(n,t){return Ln(mr,function(e){var r="_."+e[0];t&e[1]&&!$e(n,r)&&n.push(r)}),n.sort()}function No(n){if(n instanceof B)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=wn(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Gl(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=Q(k(t),0);var r=n==null?0:n.length;if(!r||t<1)return[];for(var u=0,o=0,f=p(qe(r/t));u<r;)f[o++]=qn(n,u,u+=t);return f}function Jl(n){for(var t=-1,e=n==null?0:n.length,r=0,u=[];++t<e;){var o=n[t];o&&(u[r++]=o)}return u}function Ql(){var n=arguments.length;if(!n)return[];for(var t=p(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return wt(E(e)?wn(e):[e],an(t,1))}var Xl=I(function(n,t){return K(n)?me(n,an(t,1,K,!0)):[]}),ns=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),x(e,2)):[]}),ts=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),a,e):[]});function es(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),qn(n,t<0?0:t,r)):[]}function rs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,0,t<0?0:t)):[]}function us(n,t){return n&&n.length?nr(n,x(t,3),!0,!0):[]}function is(n,t){return n&&n.length?nr(n,x(t,3),!0):[]}function os(n,t,e,r){var u=n==null?0:n.length;return u?(e&&typeof e!="number"&&gn(n,t,e)&&(e=0,r=u),Qc(n,t,e,r)):[]}function Po(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Be(n,x(t,3),u)}function To(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r-1;return e!==a&&(u=k(e),u=e<0?Q(r+u,0):pn(u,r-1)),Be(n,x(t,3),u,!0)}function qo(n){var t=n==null?0:n.length;return t?an(n,1):[]}function as(n){var t=n==null?0:n.length;return t?an(n,Z):[]}function fs(n,t){var e=n==null?0:n.length;return e?(t=t===a?1:k(t),an(n,t)):[]}function cs(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var u=n[t];r[u[0]]=u[1]}return r}function Vo(n){return n&&n.length?n[0]:a}function ls(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Yt(n,t,u)}function ss(n){var t=n==null?0:n.length;return t?qn(n,0,-1):[]}var ps=I(function(n){var t=q(n,hu);return t.length&&t[0]===n[0]?ru(t):[]}),hs=I(function(n){var t=Vn(n),e=q(n,hu);return t===Vn(e)?t=a:e.pop(),e.length&&e[0]===n[0]?ru(e,x(t,2)):[]}),vs=I(function(n){var t=Vn(n),e=q(n,hu);return t=typeof t=="function"?t:a,t&&e.pop(),e.length&&e[0]===n[0]?ru(e,a,t):[]});function _s(n,t){return n==null?"":sc.call(n,t)}function Vn(n){var t=n==null?0:n.length;return t?n[t-1]:a}function gs(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r;return e!==a&&(u=k(e),u=u<0?Q(r+u,0):pn(u,r-1)),t===t?Kf(n,t,u):Be(n,Ai,u,!0)}function ys(n,t){return n&&n.length?to(n,k(t)):a}var ds=I(Yo);function Yo(n,t){return n&&n.length&&t&&t.length?au(n,t):n}function ms(n,t,e){return n&&n.length&&t&&t.length?au(n,t,x(e,2)):n}function bs(n,t,e){return n&&n.length&&t&&t.length?au(n,t,a,e):n}var ws=pt(function(n,t){var e=n==null?0:n.length,r=Xr(n,t);return uo(n,q(t,function(u){return ht(u,e)?+u:u}).sort(vo)),r});function xs(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,u=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),u.push(r))}return uo(n,u),e}function Cu(n){return n==null?n:_c.call(n)}function js(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&gn(n,t,e)?(t=0,e=r):(t=t==null?0:k(t),e=e===a?r:k(e)),qn(n,t,e)):[]}function As(n,t){return Xe(n,t)}function Ds(n,t,e){return lu(n,t,x(e,2))}function Es(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t);if(r<e&&nt(n[r],t))return r}return-1}function Cs(n,t){return Xe(n,t,!0)}function Os(n,t,e){return lu(n,t,x(e,2),!0)}function ks(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t,!0)-1;if(nt(n[r],t))return r}return-1}function Ss(n){return n&&n.length?oo(n):[]}function Is(n,t){return n&&n.length?oo(n,x(t,2)):[]}function $s(n){var t=n==null?0:n.length;return t?qn(n,1,t):[]}function Bs(n,t,e){return n&&n.length?(t=e||t===a?1:k(t),qn(n,0,t<0?0:t)):[]}function Fs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,t<0?0:t,r)):[]}function Rs(n,t){return n&&n.length?nr(n,x(t,3),!1,!0):[]}function zs(n,t){return n&&n.length?nr(n,x(t,3)):[]}var Ws=I(function(n){return Et(an(n,1,K,!0))}),Us=I(function(n){var t=Vn(n);return K(t)&&(t=a),Et(an(n,1,K,!0),x(t,2))}),Ms=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,Et(an(n,1,K,!0),a,t)});function Ls(n){return n&&n.length?Et(n):[]}function Ns(n,t){return n&&n.length?Et(n,x(t,2)):[]}function Ps(n,t){return t=typeof t=="function"?t:a,n&&n.length?Et(n,a,t):[]}function Ou(n){if(!(n&&n.length))return[];var t=0;return n=bt(n,function(e){if(K(e))return t=Q(e.length,t),!0}),Vr(t,function(e){return q(n,Pr(e))})}function Zo(n,t){if(!(n&&n.length))return[];var e=Ou(n);return t==null?e:q(e,function(r){return On(t,a,r)})}var Ts=I(function(n,t){return K(n)?me(n,t):[]}),qs=I(function(n){return pu(bt(n,K))}),Vs=I(function(n){var t=Vn(n);return K(t)&&(t=a),pu(bt(n,K),x(t,2))}),Ys=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,pu(bt(n,K),a,t)}),Zs=I(Ou);function Hs(n,t){return lo(n||[],t||[],de)}function Ks(n,t){return lo(n||[],t||[],xe)}var Gs=I(function(n){var t=n.length,e=t>1?n[t-1]:a;return e=typeof e=="function"?(n.pop(),e):a,Zo(n,e)});function Ho(n){var t=i(n);return t.__chain__=!0,t}function Js(n,t){return t(n),n}function cr(n,t){return t(n)}var Qs=pt(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,u=function(o){return Xr(o,n)};return t>1||this.__actions__.length||!(r instanceof B)||!ht(e)?this.thru(u):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:cr,args:[u],thisArg:a}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(a),o}))});function Xs(){return Ho(this)}function n0(){return new Pn(this.value(),this.__chain__)}function t0(){this.__values__===a&&(this.__values__=fa(this.value()));var n=this.__index__>=this.__values__.length,t=n?a:this.__values__[this.__index__++];return{done:n,value:t}}function e0(){return this}function r0(n){for(var t,e=this;e instanceof He;){var r=No(e);r.__index__=0,r.__values__=a,t?u.__wrapped__=r:t=r;var u=r;e=e.__wrapped__}return u.__wrapped__=n,t}function u0(){var n=this.__wrapped__;if(n instanceof B){var t=n;return this.__actions__.length&&(t=new B(this)),t=t.reverse(),t.__actions__.push({func:cr,args:[Cu],thisArg:a}),new Pn(t,this.__chain__)}return this.thru(Cu)}function i0(){return co(this.__wrapped__,this.__actions__)}var o0=tr(function(n,t,e){M.call(n,e)?++n[e]:lt(n,e,1)});function a0(n,t,e){var r=E(n)?xi:Jc;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}function f0(n,t){var e=E(n)?bt:Yi;return e(n,x(t,3))}var c0=wo(Po),l0=wo(To);function s0(n,t){return an(lr(n,t),1)}function p0(n,t){return an(lr(n,t),Z)}function h0(n,t,e){return e=e===a?1:k(e),an(lr(n,t),e)}function Ko(n,t){var e=E(n)?Ln:Dt;return e(n,x(t,3))}function Go(n,t){var e=E(n)?$f:Vi;return e(n,x(t,3))}var v0=tr(function(n,t,e){M.call(n,e)?n[e].push(t):lt(n,e,[t])});function _0(n,t,e,r){n=xn(n)?n:re(n),e=e&&!r?k(e):0;var u=n.length;return e<0&&(e=Q(u+e,0)),_r(n)?e<=u&&n.indexOf(t,e)>-1:!!u&&Yt(n,t,e)>-1}var g0=I(function(n,t,e){var r=-1,u=typeof t=="function",o=xn(n)?p(n.length):[];return Dt(n,function(f){o[++r]=u?On(t,f,e):be(f,t,e)}),o}),y0=tr(function(n,t,e){lt(n,e,t)});function lr(n,t){var e=E(n)?q:Qi;return e(n,x(t,3))}function d0(n,t,e,r){return n==null?[]:(E(t)||(t=t==null?[]:[t]),e=r?a:e,E(e)||(e=e==null?[]:[e]),eo(n,t,e))}var m0=tr(function(n,t,e){n[e?0:1].push(t)},function(){return[[],[]]});function b0(n,t,e){var r=E(n)?Lr:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Dt)}function w0(n,t,e){var r=E(n)?Bf:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Vi)}function x0(n,t){var e=E(n)?bt:Yi;return e(n,hr(x(t,3)))}function j0(n){var t=E(n)?Ni:_l;return t(n)}function A0(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=k(t);var r=E(n)?Yc:gl;return r(n,t)}function D0(n){var t=E(n)?Zc:dl;return t(n)}function E0(n){if(n==null)return 0;if(xn(n))return _r(n)?Ht(n):n.length;var t=hn(n);return t==Hn||t==Jn?n.size:iu(n).length}function C0(n,t,e){var r=E(n)?Nr:ml;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}var O0=I(function(n,t){if(n==null)return[];var e=t.length;return e>1&&gn(n,t[0],t[1])?t=[]:e>2&&gn(t[0],t[1],t[2])&&(t=[t[0]]),eo(n,an(t,1),[])}),sr=fc||function(){return nn.Date.now()};function k0(n,t){if(typeof t!="function")throw new Nn(z);return n=k(n),function(){if(--n<1)return t.apply(this,arguments)}}function Jo(n,t,e){return t=e?a:t,t=n&&t==null?n.length:t,st(n,Y,a,a,a,a,t)}function Qo(n,t){var e;if(typeof t!="function")throw new Nn(z);return n=k(n),function(){return--n>0&&(e=t.apply(this,arguments)),n<=1&&(t=a),e}}var ku=I(function(n,t,e){var r=X;if(e.length){var u=xt(e,te(ku));r|=un}return st(n,r,t,e,u)}),Xo=I(function(n,t,e){var r=X|En;if(e.length){var u=xt(e,te(Xo));r|=un}return st(t,r,n,e,u)});function na(n,t,e){t=e?a:t;var r=st(n,mn,a,a,a,a,a,t);return r.placeholder=na.placeholder,r}function ta(n,t,e){t=e?a:t;var r=st(n,ot,a,a,a,a,a,t);return r.placeholder=ta.placeholder,r}function ea(n,t,e){var r,u,o,f,c,s,v=0,_=!1,g=!1,m=!0;if(typeof n!="function")throw new Nn(z);t=Yn(t)||0,V(e)&&(_=!!e.leading,g="maxWait"in e,o=g?Q(Yn(e.maxWait)||0,t):o,m="trailing"in e?!!e.trailing:m);function w(G){var tt=r,gt=u;return r=u=a,v=G,f=n.apply(gt,tt),f}function j(G){return v=G,c=De($,t),_?w(G):f}function S(G){var tt=G-s,gt=G-v,wa=t-tt;return g?pn(wa,o-gt):wa}function A(G){var tt=G-s,gt=G-v;return s===a||tt>=t||tt<0||g&&gt>=o}function $(){var G=sr();if(A(G))return F(G);c=De($,S(G))}function F(G){return c=a,m&&r?w(G):(r=u=a,f)}function $n(){c!==a&&so(c),v=0,r=s=u=c=a}function yn(){return c===a?f:F(sr())}function Bn(){var G=sr(),tt=A(G);if(r=arguments,u=this,s=G,tt){if(c===a)return j(s);if(g)return so(c),c=De($,t),w(s)}return c===a&&(c=De($,t)),f}return Bn.cancel=$n,Bn.flush=yn,Bn}var S0=I(function(n,t){return qi(n,1,t)}),I0=I(function(n,t,e){return qi(n,Yn(t)||0,e)});function $0(n){return st(n,Wn)}function pr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new Nn(z);var e=function(){var r=arguments,u=t?t.apply(this,r):r[0],o=e.cache;if(o.has(u))return o.get(u);var f=n.apply(this,r);return e.cache=o.set(u,f)||o,f};return e.cache=new(pr.Cache||ct),e}pr.Cache=ct;function hr(n){if(typeof n!="function")throw new Nn(z);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function B0(n){return Qo(2,n)}var F0=bl(function(n,t){t=t.length==1&&E(t[0])?q(t[0],kn(x())):q(an(t,1),kn(x()));var e=t.length;return I(function(r){for(var u=-1,o=pn(r.length,e);++u<o;)r[u]=t[u].call(this,r[u]);return On(n,this,r)})}),Su=I(function(n,t){var e=xt(t,te(Su));return st(n,un,a,t,e)}),ra=I(function(n,t){var e=xt(t,te(ra));return st(n,on,a,t,e)}),R0=pt(function(n,t){return st(n,Cn,a,a,a,t)});function z0(n,t){if(typeof n!="function")throw new Nn(z);return t=t===a?t:k(t),I(n,t)}function W0(n,t){if(typeof n!="function")throw new Nn(z);return t=t==null?0:Q(k(t),0),I(function(e){var r=e[t],u=Ot(e,0,t);return r&&wt(u,r),On(n,this,u)})}function U0(n,t,e){var r=!0,u=!0;if(typeof n!="function")throw new Nn(z);return V(e)&&(r="leading"in e?!!e.leading:r,u="trailing"in e?!!e.trailing:u),ea(n,t,{leading:r,maxWait:t,trailing:u})}function M0(n){return Jo(n,1)}function L0(n,t){return Su(vu(t),n)}function N0(){if(!arguments.length)return[];var n=arguments[0];return E(n)?n:[n]}function P0(n){return Tn(n,Un)}function T0(n,t){return t=typeof t=="function"?t:a,Tn(n,Un,t)}function q0(n){return Tn(n,sn|Un)}function V0(n,t){return t=typeof t=="function"?t:a,Tn(n,sn|Un,t)}function Y0(n,t){return t==null||Ti(n,t,tn(t))}function nt(n,t){return n===t||n!==n&&t!==t}var Z0=ir(eu),H0=ir(function(n,t){return n>=t}),Nt=Ki(function(){return arguments}())?Ki:function(n){return H(n)&&M.call(n,"callee")&&!Ri.call(n,"callee")},E=p.isArray,K0=gi?kn(gi):rl;function xn(n){return n!=null&&vr(n.length)&&!vt(n)}function K(n){return H(n)&&xn(n)}function G0(n){return n===!0||n===!1||H(n)&&_n(n)==$t}var kt=lc||Nu,J0=yi?kn(yi):ul;function Q0(n){return H(n)&&n.nodeType===1&&!Ee(n)}function X0(n){if(n==null)return!0;if(xn(n)&&(E(n)||typeof n=="string"||typeof n.splice=="function"||kt(n)||ee(n)||Nt(n)))return!n.length;var t=hn(n);if(t==Hn||t==Jn)return!n.size;if(Ae(n))return!iu(n).length;for(var e in n)if(M.call(n,e))return!1;return!0}function np(n,t){return we(n,t)}function tp(n,t,e){e=typeof e=="function"?e:a;var r=e?e(n,t):a;return r===a?we(n,t,a,e):!!r}function Iu(n){if(!H(n))return!1;var t=_n(n);return t==ue||t==yr||typeof n.message=="string"&&typeof n.name=="string"&&!Ee(n)}function ep(n){return typeof n=="number"&&Wi(n)}function vt(n){if(!V(n))return!1;var t=_n(n);return t==ie||t==qu||t==Tu||t==Da}function ua(n){return typeof n=="number"&&n==k(n)}function vr(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=en}function V(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function H(n){return n!=null&&typeof n=="object"}var ia=di?kn(di):ol;function rp(n,t){return n===t||uu(n,t,wu(t))}function up(n,t,e){return e=typeof e=="function"?e:a,uu(n,t,wu(t),e)}function ip(n){return oa(n)&&n!=+n}function op(n){if(Tl(n))throw new D(L);return Gi(n)}function ap(n){return n===null}function fp(n){return n==null}function oa(n){return typeof n=="number"||H(n)&&_n(n)==oe}function Ee(n){if(!H(n)||_n(n)!=at)return!1;var t=Ne(n);if(t===null)return!0;var e=M.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&We.call(e)==uc}var $u=mi?kn(mi):al;function cp(n){return ua(n)&&n>=-en&&n<=en}var aa=bi?kn(bi):fl;function _r(n){return typeof n=="string"||!E(n)&&H(n)&&_n(n)==ce}function In(n){return typeof n=="symbol"||H(n)&&_n(n)==Oe}var ee=wi?kn(wi):cl;function lp(n){return n===a}function sp(n){return H(n)&&hn(n)==le}function pp(n){return H(n)&&_n(n)==Ca}var hp=ir(ou),vp=ir(function(n,t){return n<=t});function fa(n){if(!n)return[];if(xn(n))return _r(n)?Qn(n):wn(n);if(he&&n[he])return Yf(n[he]());var t=hn(n),e=t==Hn?Zr:t==Jn?Fe:re;return e(n)}function _t(n){if(!n)return n===0?n:0;if(n=Yn(n),n===Z||n===-Z){var t=n<0?-1:1;return t*Zn}return n===n?n:0}function k(n){var t=_t(n),e=t%1;return t===t?e?t-e:t:0}function ca(n){return n?Wt(k(n),0,vn):0}function Yn(n){if(typeof n=="number")return n;if(In(n))return Kn;if(V(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=V(t)?t+"":t}if(typeof n!="string")return n===0?n:+n;n=Ci(n);var e=Ha.test(n);return e||Ga.test(n)?kf(n.slice(2),e?2:8):Za.test(n)?Kn:+n}function la(n){return rt(n,jn(n))}function _p(n){return n?Wt(k(n),-en,en):n===0?n:0}function U(n){return n==null?"":Sn(n)}var gp=Xt(function(n,t){if(Ae(t)||xn(t)){rt(t,tn(t),n);return}for(var e in t)M.call(t,e)&&de(n,e,t[e])}),sa=Xt(function(n,t){rt(t,jn(t),n)}),gr=Xt(function(n,t,e,r){rt(t,jn(t),n,r)}),yp=Xt(function(n,t,e,r){rt(t,tn(t),n,r)}),dp=pt(Xr);function mp(n,t){var e=Qt(n);return t==null?e:Pi(e,t)}var bp=I(function(n,t){n=N(n);var e=-1,r=t.length,u=r>2?t[2]:a;for(u&&gn(t[0],t[1],u)&&(r=1);++e<r;)for(var o=t[e],f=jn(o),c=-1,s=f.length;++c<s;){var v=f[c],_=n[v];(_===a||nt(_,Kt[v])&&!M.call(n,v))&&(n[v]=o[v])}return n}),wp=I(function(n){return n.push(a,Oo),On(pa,a,n)});function xp(n,t){return ji(n,x(t,3),et)}function jp(n,t){return ji(n,x(t,3),tu)}function Ap(n,t){return n==null?n:nu(n,x(t,3),jn)}function Dp(n,t){return n==null?n:Zi(n,x(t,3),jn)}function Ep(n,t){return n&&et(n,x(t,3))}function Cp(n,t){return n&&tu(n,x(t,3))}function Op(n){return n==null?[]:Je(n,tn(n))}function kp(n){return n==null?[]:Je(n,jn(n))}function Bu(n,t,e){var r=n==null?a:Ut(n,t);return r===a?e:r}function Sp(n,t){return n!=null&&Io(n,t,Xc)}function Fu(n,t){return n!=null&&Io(n,t,nl)}var Ip=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),n[t]=e},zu(An)),$p=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),M.call(n,t)?n[t].push(e):n[t]=[e]},x),Bp=I(be);function tn(n){return xn(n)?Li(n):iu(n)}function jn(n){return xn(n)?Li(n,!0):ll(n)}function Fp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,t(r,u,o),r)}),e}function Rp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,u,t(r,u,o))}),e}var zp=Xt(function(n,t,e){Qe(n,t,e)}),pa=Xt(function(n,t,e,r){Qe(n,t,e,r)}),Wp=pt(function(n,t){var e={};if(n==null)return e;var r=!1;t=q(t,function(o){return o=Ct(o,n),r||(r=o.length>1),o}),rt(n,mu(n),e),r&&(e=Tn(e,sn|dt|Un,Il));for(var u=t.length;u--;)su(e,t[u]);return e});function Up(n,t){return ha(n,hr(x(t)))}var Mp=pt(function(n,t){return n==null?{}:pl(n,t)});function ha(n,t){if(n==null)return{};var e=q(mu(n),function(r){return[r]});return t=x(t),ro(n,e,function(r,u){return t(r,u[0])})}function Lp(n,t,e){t=Ct(t,n);var r=-1,u=t.length;for(u||(u=1,n=a);++r<u;){var o=n==null?a:n[ut(t[r])];o===a&&(r=u,o=e),n=vt(o)?o.call(n):o}return n}function Np(n,t,e){return n==null?n:xe(n,t,e)}function Pp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:xe(n,t,e,r)}var va=Eo(tn),_a=Eo(jn);function Tp(n,t,e){var r=E(n),u=r||kt(n)||ee(n);if(t=x(t,4),e==null){var o=n&&n.constructor;u?e=r?new o:[]:V(n)?e=vt(o)?Qt(Ne(n)):{}:e={}}return(u?Ln:et)(n,function(f,c,s){return t(e,f,c,s)}),e}function qp(n,t){return n==null?!0:su(n,t)}function Vp(n,t,e){return n==null?n:fo(n,t,vu(e))}function Yp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:fo(n,t,vu(e),r)}function re(n){return n==null?[]:Yr(n,tn(n))}function Zp(n){return n==null?[]:Yr(n,jn(n))}function Hp(n,t,e){return e===a&&(e=t,t=a),e!==a&&(e=Yn(e),e=e===e?e:0),t!==a&&(t=Yn(t),t=t===t?t:0),Wt(Yn(n),t,e)}function Kp(n,t,e){return t=_t(t),e===a?(e=t,t=0):e=_t(e),n=Yn(n),tl(n,t,e)}function Gp(n,t,e){if(e&&typeof e!="boolean"&&gn(n,t,e)&&(t=e=a),e===a&&(typeof t=="boolean"?(e=t,t=a):typeof n=="boolean"&&(e=n,n=a)),n===a&&t===a?(n=0,t=1):(n=_t(n),t===a?(t=n,n=0):t=_t(t)),n>t){var r=n;n=t,t=r}if(e||n%1||t%1){var u=Ui();return pn(n+u*(t-n+Of("1e-"+((u+"").length-1))),t)}return fu(n,t)}var Jp=ne(function(n,t,e){return t=t.toLowerCase(),n+(e?ga(t):t)});function ga(n){return Ru(U(n).toLowerCase())}function ya(n){return n=U(n),n&&n.replace(Qa,Nf).replace(df,"")}function Qp(n,t,e){n=U(n),t=Sn(t);var r=n.length;e=e===a?r:Wt(k(e),0,r);var u=e;return e-=t.length,e>=0&&n.slice(e,u)==t}function Xp(n){return n=U(n),n&&$a.test(n)?n.replace(Zu,Pf):n}function nh(n){return n=U(n),n&&Ua.test(n)?n.replace(Sr,"\\$&"):n}var th=ne(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),eh=ne(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),rh=bo("toLowerCase");function uh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;if(!t||r>=t)return n;var u=(t-r)/2;return ur(Ve(u),e)+n+ur(qe(u),e)}function ih(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?n+ur(t-r,e):n}function oh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?ur(t-r,e)+n:n}function ah(n,t,e){return e||t==null?t=0:t&&(t=+t),vc(U(n).replace(Ir,""),t||0)}function fh(n,t,e){return(e?gn(n,t,e):t===a)?t=1:t=k(t),cu(U(n),t)}function ch(){var n=arguments,t=U(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var lh=ne(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function sh(n,t,e){return e&&typeof e!="number"&&gn(n,t,e)&&(t=e=a),e=e===a?vn:e>>>0,e?(n=U(n),n&&(typeof t=="string"||t!=null&&!$u(t))&&(t=Sn(t),!t&&Zt(n))?Ot(Qn(n),0,e):n.split(t,e)):[]}var ph=ne(function(n,t,e){return n+(e?" ":"")+Ru(t)});function hh(n,t,e){return n=U(n),e=e==null?0:Wt(k(e),0,n.length),t=Sn(t),n.slice(e,e+t.length)==t}function vh(n,t,e){var r=i.templateSettings;e&&gn(n,t,e)&&(t=a),n=U(n),t=gr({},t,r,Co);var u=gr({},t.imports,r.imports,Co),o=tn(u),f=Yr(u,o),c,s,v=0,_=t.interpolate||ke,g="__p += '",m=Hr((t.escape||ke).source+"|"+_.source+"|"+(_===Hu?Ya:ke).source+"|"+(t.evaluate||ke).source+"|$","g"),w="//# sourceURL="+(M.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++jf+"]")+`
`;n.replace(m,function(A,$,F,$n,yn,Bn){return F||(F=$n),g+=n.slice(v,Bn).replace(Xa,Tf),$&&(c=!0,g+=`' +
__e(`+$+`) +
'`),yn&&(s=!0,g+=`';
`+yn+`;
__p += '`),F&&(g+=`' +
((__t = (`+F+`)) == null ? '' : __t) +
'`),v=Bn+A.length,A}),g+=`';
`;var j=M.call(t,"variable")&&t.variable;if(!j)g=`with (obj) {
`+g+`
}
`;else if(qa.test(j))throw new D(fn);g=(s?g.replace(Oa,""):g).replace(ka,"$1").replace(Sa,"$1;"),g="function("+(j||"obj")+`) {
`+(j?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(s?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+g+`return __p
}`;var S=ma(function(){return W(o,w+"return "+g).apply(a,f)});if(S.source=g,Iu(S))throw S;return S}function _h(n){return U(n).toLowerCase()}function gh(n){return U(n).toUpperCase()}function yh(n,t,e){if(n=U(n),n&&(e||t===a))return Ci(n);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Qn(t),o=Oi(r,u),f=ki(r,u)+1;return Ot(r,o,f).join("")}function dh(n,t,e){if(n=U(n),n&&(e||t===a))return n.slice(0,Ii(n)+1);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=ki(r,Qn(t))+1;return Ot(r,0,u).join("")}function mh(n,t,e){if(n=U(n),n&&(e||t===a))return n.replace(Ir,"");if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Oi(r,Qn(t));return Ot(r,u).join("")}function bh(n,t){var e=Fn,r=It;if(V(t)){var u="separator"in t?t.separator:u;e="length"in t?k(t.length):e,r="omission"in t?Sn(t.omission):r}n=U(n);var o=n.length;if(Zt(n)){var f=Qn(n);o=f.length}if(e>=o)return n;var c=e-Ht(r);if(c<1)return r;var s=f?Ot(f,0,c).join(""):n.slice(0,c);if(u===a)return s+r;if(f&&(c+=s.length-c),$u(u)){if(n.slice(c).search(u)){var v,_=s;for(u.global||(u=Hr(u.source,U(Ku.exec(u))+"g")),u.lastIndex=0;v=u.exec(_);)var g=v.index;s=s.slice(0,g===a?c:g)}}else if(n.indexOf(Sn(u),c)!=c){var m=s.lastIndexOf(u);m>-1&&(s=s.slice(0,m))}return s+r}function wh(n){return n=U(n),n&&Ia.test(n)?n.replace(Yu,Gf):n}var xh=ne(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Ru=bo("toUpperCase");function da(n,t,e){return n=U(n),t=e?a:t,t===a?Vf(n)?Xf(n):zf(n):n.match(t)||[]}var ma=I(function(n,t){try{return On(n,a,t)}catch(e){return Iu(e)?e:new D(e)}}),jh=pt(function(n,t){return Ln(t,function(e){e=ut(e),lt(n,e,ku(n[e],n))}),n});function Ah(n){var t=n==null?0:n.length,e=x();return n=t?q(n,function(r){if(typeof r[1]!="function")throw new Nn(z);return[e(r[0]),r[1]]}):[],I(function(r){for(var u=-1;++u<t;){var o=n[u];if(On(o[0],this,r))return On(o[1],this,r)}})}function Dh(n){return Gc(Tn(n,sn))}function zu(n){return function(){return n}}function Eh(n,t){return n==null||n!==n?t:n}var Ch=xo(),Oh=xo(!0);function An(n){return n}function Wu(n){return Ji(typeof n=="function"?n:Tn(n,sn))}function kh(n){return Xi(Tn(n,sn))}function Sh(n,t){return no(n,Tn(t,sn))}var Ih=I(function(n,t){return function(e){return be(e,n,t)}}),$h=I(function(n,t){return function(e){return be(n,e,t)}});function Uu(n,t,e){var r=tn(t),u=Je(t,r);e==null&&!(V(t)&&(u.length||!r.length))&&(e=t,t=n,n=this,u=Je(t,tn(t)));var o=!(V(e)&&"chain"in e)||!!e.chain,f=vt(n);return Ln(u,function(c){var s=t[c];n[c]=s,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),g=_.__actions__=wn(this.__actions__);return g.push({func:s,args:arguments,thisArg:n}),_.__chain__=v,_}return s.apply(n,wt([this.value()],arguments))})}),n}function Bh(){return nn._===this&&(nn._=ic),this}function Mu(){}function Fh(n){return n=k(n),I(function(t){return to(t,n)})}var Rh=gu(q),zh=gu(xi),Wh=gu(Nr);function ba(n){return ju(n)?Pr(ut(n)):hl(n)}function Uh(n){return function(t){return n==null?a:Ut(n,t)}}var Mh=Ao(),Lh=Ao(!0);function Lu(){return[]}function Nu(){return!1}function Nh(){return{}}function Ph(){return""}function Th(){return!0}function qh(n,t){if(n=k(n),n<1||n>en)return[];var e=vn,r=pn(n,vn);t=x(t),n-=vn;for(var u=Vr(r,t);++e<n;)t(e);return u}function Vh(n){return E(n)?q(n,ut):In(n)?[n]:wn(Lo(U(n)))}function Yh(n){var t=++rc;return U(n)+t}var Zh=rr(function(n,t){return n+t},0),Hh=yu("ceil"),Kh=rr(function(n,t){return n/t},1),Gh=yu("floor");function Jh(n){return n&&n.length?Ge(n,An,eu):a}function Qh(n,t){return n&&n.length?Ge(n,x(t,2),eu):a}function Xh(n){return Di(n,An)}function nv(n,t){return Di(n,x(t,2))}function tv(n){return n&&n.length?Ge(n,An,ou):a}function ev(n,t){return n&&n.length?Ge(n,x(t,2),ou):a}var rv=rr(function(n,t){return n*t},1),uv=yu("round"),iv=rr(function(n,t){return n-t},0);function ov(n){return n&&n.length?qr(n,An):0}function av(n,t){return n&&n.length?qr(n,x(t,2)):0}return i.after=k0,i.ary=Jo,i.assign=gp,i.assignIn=sa,i.assignInWith=gr,i.assignWith=yp,i.at=dp,i.before=Qo,i.bind=ku,i.bindAll=jh,i.bindKey=Xo,i.castArray=N0,i.chain=Ho,i.chunk=Gl,i.compact=Jl,i.concat=Ql,i.cond=Ah,i.conforms=Dh,i.constant=zu,i.countBy=o0,i.create=mp,i.curry=na,i.curryRight=ta,i.debounce=ea,i.defaults=bp,i.defaultsDeep=wp,i.defer=S0,i.delay=I0,i.difference=Xl,i.differenceBy=ns,i.differenceWith=ts,i.drop=es,i.dropRight=rs,i.dropRightWhile=us,i.dropWhile=is,i.fill=os,i.filter=f0,i.flatMap=s0,i.flatMapDeep=p0,i.flatMapDepth=h0,i.flatten=qo,i.flattenDeep=as,i.flattenDepth=fs,i.flip=$0,i.flow=Ch,i.flowRight=Oh,i.fromPairs=cs,i.functions=Op,i.functionsIn=kp,i.groupBy=v0,i.initial=ss,i.intersection=ps,i.intersectionBy=hs,i.intersectionWith=vs,i.invert=Ip,i.invertBy=$p,i.invokeMap=g0,i.iteratee=Wu,i.keyBy=y0,i.keys=tn,i.keysIn=jn,i.map=lr,i.mapKeys=Fp,i.mapValues=Rp,i.matches=kh,i.matchesProperty=Sh,i.memoize=pr,i.merge=zp,i.mergeWith=pa,i.method=Ih,i.methodOf=$h,i.mixin=Uu,i.negate=hr,i.nthArg=Fh,i.omit=Wp,i.omitBy=Up,i.once=B0,i.orderBy=d0,i.over=Rh,i.overArgs=F0,i.overEvery=zh,i.overSome=Wh,i.partial=Su,i.partialRight=ra,i.partition=m0,i.pick=Mp,i.pickBy=ha,i.property=ba,i.propertyOf=Uh,i.pull=ds,i.pullAll=Yo,i.pullAllBy=ms,i.pullAllWith=bs,i.pullAt=ws,i.range=Mh,i.rangeRight=Lh,i.rearg=R0,i.reject=x0,i.remove=xs,i.rest=z0,i.reverse=Cu,i.sampleSize=A0,i.set=Np,i.setWith=Pp,i.shuffle=D0,i.slice=js,i.sortBy=O0,i.sortedUniq=Ss,i.sortedUniqBy=Is,i.split=sh,i.spread=W0,i.tail=$s,i.take=Bs,i.takeRight=Fs,i.takeRightWhile=Rs,i.takeWhile=zs,i.tap=Js,i.throttle=U0,i.thru=cr,i.toArray=fa,i.toPairs=va,i.toPairsIn=_a,i.toPath=Vh,i.toPlainObject=la,i.transform=Tp,i.unary=M0,i.union=Ws,i.unionBy=Us,i.unionWith=Ms,i.uniq=Ls,i.uniqBy=Ns,i.uniqWith=Ps,i.unset=qp,i.unzip=Ou,i.unzipWith=Zo,i.update=Vp,i.updateWith=Yp,i.values=re,i.valuesIn=Zp,i.without=Ts,i.words=da,i.wrap=L0,i.xor=qs,i.xorBy=Vs,i.xorWith=Ys,i.zip=Zs,i.zipObject=Hs,i.zipObjectDeep=Ks,i.zipWith=Gs,i.entries=va,i.entriesIn=_a,i.extend=sa,i.extendWith=gr,Uu(i,i),i.add=Zh,i.attempt=ma,i.camelCase=Jp,i.capitalize=ga,i.ceil=Hh,i.clamp=Hp,i.clone=P0,i.cloneDeep=q0,i.cloneDeepWith=V0,i.cloneWith=T0,i.conformsTo=Y0,i.deburr=ya,i.defaultTo=Eh,i.divide=Kh,i.endsWith=Qp,i.eq=nt,i.escape=Xp,i.escapeRegExp=nh,i.every=a0,i.find=c0,i.findIndex=Po,i.findKey=xp,i.findLast=l0,i.findLastIndex=To,i.findLastKey=jp,i.floor=Gh,i.forEach=Ko,i.forEachRight=Go,i.forIn=Ap,i.forInRight=Dp,i.forOwn=Ep,i.forOwnRight=Cp,i.get=Bu,i.gt=Z0,i.gte=H0,i.has=Sp,i.hasIn=Fu,i.head=Vo,i.identity=An,i.includes=_0,i.indexOf=ls,i.inRange=Kp,i.invoke=Bp,i.isArguments=Nt,i.isArray=E,i.isArrayBuffer=K0,i.isArrayLike=xn,i.isArrayLikeObject=K,i.isBoolean=G0,i.isBuffer=kt,i.isDate=J0,i.isElement=Q0,i.isEmpty=X0,i.isEqual=np,i.isEqualWith=tp,i.isError=Iu,i.isFinite=ep,i.isFunction=vt,i.isInteger=ua,i.isLength=vr,i.isMap=ia,i.isMatch=rp,i.isMatchWith=up,i.isNaN=ip,i.isNative=op,i.isNil=fp,i.isNull=ap,i.isNumber=oa,i.isObject=V,i.isObjectLike=H,i.isPlainObject=Ee,i.isRegExp=$u,i.isSafeInteger=cp,i.isSet=aa,i.isString=_r,i.isSymbol=In,i.isTypedArray=ee,i.isUndefined=lp,i.isWeakMap=sp,i.isWeakSet=pp,i.join=_s,i.kebabCase=th,i.last=Vn,i.lastIndexOf=gs,i.lowerCase=eh,i.lowerFirst=rh,i.lt=hp,i.lte=vp,i.max=Jh,i.maxBy=Qh,i.mean=Xh,i.meanBy=nv,i.min=tv,i.minBy=ev,i.stubArray=Lu,i.stubFalse=Nu,i.stubObject=Nh,i.stubString=Ph,i.stubTrue=Th,i.multiply=rv,i.nth=ys,i.noConflict=Bh,i.noop=Mu,i.now=sr,i.pad=uh,i.padEnd=ih,i.padStart=oh,i.parseInt=ah,i.random=Gp,i.reduce=b0,i.reduceRight=w0,i.repeat=fh,i.replace=ch,i.result=Lp,i.round=uv,i.runInContext=l,i.sample=j0,i.size=E0,i.snakeCase=lh,i.some=C0,i.sortedIndex=As,i.sortedIndexBy=Ds,i.sortedIndexOf=Es,i.sortedLastIndex=Cs,i.sortedLastIndexBy=Os,i.sortedLastIndexOf=ks,i.startCase=ph,i.startsWith=hh,i.subtract=iv,i.sum=ov,i.sumBy=av,i.template=vh,i.times=qh,i.toFinite=_t,i.toInteger=k,i.toLength=ca,i.toLower=_h,i.toNumber=Yn,i.toSafeInteger=_p,i.toString=U,i.toUpper=gh,i.trim=yh,i.trimEnd=dh,i.trimStart=mh,i.truncate=bh,i.unescape=wh,i.uniqueId=Yh,i.upperCase=xh,i.upperFirst=Ru,i.each=Ko,i.eachRight=Go,i.first=Vo,Uu(i,function(){var n={};return et(i,function(t,e){M.call(i.prototype,e)||(n[e]=t)}),n}(),{chain:!1}),i.VERSION=O,Ln(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){i[n].placeholder=i}),Ln(["drop","take"],function(n,t){B.prototype[n]=function(e){e=e===a?1:Q(k(e),0);var r=this.__filtered__&&!t?new B(this):this.clone();return r.__filtered__?r.__takeCount__=pn(e,r.__takeCount__):r.__views__.push({size:pn(e,vn),type:n+(r.__dir__<0?"Right":"")}),r},B.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()}}),Ln(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==cn||e==Gn;B.prototype[n]=function(u){var o=this.clone();return o.__iteratees__.push({iteratee:x(u,3),type:e}),o.__filtered__=o.__filtered__||r,o}}),Ln(["head","last"],function(n,t){var e="take"+(t?"Right":"");B.prototype[n]=function(){return this[e](1).value()[0]}}),Ln(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");B.prototype[n]=function(){return this.__filtered__?new B(this):this[e](1)}}),B.prototype.compact=function(){return this.filter(An)},B.prototype.find=function(n){return this.filter(n).head()},B.prototype.findLast=function(n){return this.reverse().find(n)},B.prototype.invokeMap=I(function(n,t){return typeof n=="function"?new B(this):this.map(function(e){return be(e,n,t)})}),B.prototype.reject=function(n){return this.filter(hr(x(n)))},B.prototype.slice=function(n,t){n=k(n);var e=this;return e.__filtered__&&(n>0||t<0)?new B(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==a&&(t=k(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},B.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},B.prototype.toArray=function(){return this.take(vn)},et(B.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),u=i[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);!u||(i.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,s=f instanceof B,v=c[0],_=s||E(f),g=function($){var F=u.apply(i,wt([$],c));return r&&m?F[0]:F};_&&e&&typeof v=="function"&&v.length!=1&&(s=_=!1);var m=this.__chain__,w=!!this.__actions__.length,j=o&&!m,S=s&&!w;if(!o&&_){f=S?f:new B(this);var A=n.apply(f,c);return A.__actions__.push({func:cr,args:[g],thisArg:a}),new Pn(A,m)}return j&&S?n.apply(this,c):(A=this.thru(g),j?r?A.value()[0]:A.value():A)})}),Ln(["pop","push","shift","sort","splice","unshift"],function(n){var t=Re[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);i.prototype[n]=function(){var u=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(E(o)?o:[],u)}return this[e](function(f){return t.apply(E(f)?f:[],u)})}}),et(B.prototype,function(n,t){var e=i[t];if(e){var r=e.name+"";M.call(Jt,r)||(Jt[r]=[]),Jt[r].push({name:t,func:e})}}),Jt[er(a,En).name]=[{name:"wrapper",func:a}],B.prototype.clone=wc,B.prototype.reverse=xc,B.prototype.value=jc,i.prototype.at=Qs,i.prototype.chain=Xs,i.prototype.commit=n0,i.prototype.next=t0,i.prototype.plant=r0,i.prototype.reverse=u0,i.prototype.toJSON=i.prototype.valueOf=i.prototype.value=i0,i.prototype.first=i.prototype.head,he&&(i.prototype[he]=e0),i},jt=nc();typeof define=="function"&&typeof __webpack_require__("3c35")=="object"&&__webpack_require__("3c35")?(nn._=jt,define(function(){return jt})):Bt?((Bt.exports=jt)._=jt,Wr._=jt):nn._=jt}).call(y)}),Ag=sv(pv()),Dg=sv(pv()),w_=Object.create,Sv=Object.defineProperty;var x_=Object.getOwnPropertyDescriptor;var j_=Object.getOwnPropertyNames;var A_=Object.getPrototypeOf,D_=Object.prototype.hasOwnProperty;var E_=y=>Sv(y,"__esModule",{value:!0}),C_=(y,d)=>()=>(d||y((d={exports:{}}).exports,d),d.exports),O_=(y,d,a)=>{if(d&&typeof d=="object"||typeof d=="function")for(let O of j_(d))!D_.call(y,O)&&O!=="default"&&Sv(y,O,{get:()=>d[O],enumerable:!(a=x_(d,O))||a.enumerable});return y},Iv=y=>O_(E_(Sv(y!=null?w_(A_(y)):{},"default",y&&y.__esModule&&"default"in y?{get:()=>y.default,enumerable:!0}:{value:y,enumerable:!0})),y),$v=C_((y,d)=>{(function(){var a,O="4.17.21",R=200,L="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",z="Expected a function",fn="Invalid `variable` option passed into `_.template`",dn="__lodash_hash_undefined__",rn=500,Dn="__lodash_placeholder__",sn=1,dt=2,Un=4,Rn=1,bn=2,X=1,En=2,St=4,mn=8,ot=16,un=32,on=64,Y=128,Cn=256,Wn=512,Fn=30,It="...",Pt=800,zn=16,cn=1,ln=2,Gn=3,Z=1/0,en=9007199254740991,Zn=17976931348623157e292,Kn=0/0,vn=4294967295,Tt=vn-1,Ce=vn>>>1,mr=[["ary",Y],["bind",X],["bindKey",En],["curry",mn],["curryRight",ot],["flip",Wn],["partial",un],["partialRight",on],["rearg",Cn]],mt="[object Arguments]",ae="[object Array]",Tu="[object AsyncFunction]",$t="[object Boolean]",yt="[object Date]",yr="[object DOMException]",ue="[object Error]",ie="[object Function]",qu="[object GeneratorFunction]",Hn="[object Map]",oe="[object Number]",xa="[object Null]",at="[object Object]",Vu="[object Promise]",Da="[object Proxy]",fe="[object RegExp]",Jn="[object Set]",ce="[object String]",Oe="[object Symbol]",Ea="[object Undefined]",le="[object WeakMap]",Ca="[object WeakSet]",se="[object ArrayBuffer]",qt="[object DataView]",wr="[object Float32Array]",xr="[object Float64Array]",jr="[object Int8Array]",Ar="[object Int16Array]",Dr="[object Int32Array]",Er="[object Uint8Array]",Cr="[object Uint8ClampedArray]",Or="[object Uint16Array]",kr="[object Uint32Array]",Oa=/\b__p \+= '';/g,ka=/\b(__p \+=) '' \+/g,Sa=/(__e\(.*?\)|\b__t\)) \+\n'';/g,Yu=/&(?:amp|lt|gt|quot|#39);/g,Zu=/[&<>"']/g,Ia=RegExp(Yu.source),$a=RegExp(Zu.source),Ba=/<%-([\s\S]+?)%>/g,Fa=/<%([\s\S]+?)%>/g,Hu=/<%=([\s\S]+?)%>/g,Ra=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,za=/^\w*$/,Wa=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Sr=/[\\^$.*+?()[\]{}|]/g,Ua=RegExp(Sr.source),Ir=/^\s+/,Ma=/\s/,La=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Na=/\{\n\/\* \[wrapped with (.+)\] \*/,Pa=/,? & /,Ta=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,qa=/[()=,{}\[\]\/\s]/,Va=/\\(\\)?/g,Ya=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Ku=/\w*$/,Za=/^[-+]0x[0-9a-f]+$/i,Ha=/^0b[01]+$/i,Ka=/^\[object .+?Constructor\]$/,Ga=/^0o[0-7]+$/i,Ja=/^(?:0|[1-9]\d*)$/,Qa=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,ke=/($^)/,Xa=/['\n\r\u2028\u2029\\]/g,Se="\\ud800-\\udfff",nf="\\u0300-\\u036f",tf="\\ufe20-\\ufe2f",ef="\\u20d0-\\u20ff",Gu=nf+tf+ef,Ju="\\u2700-\\u27bf",Qu="a-z\\xdf-\\xf6\\xf8-\\xff",rf="\\xac\\xb1\\xd7\\xf7",uf="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",of="\\u2000-\\u206f",af=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Xu="A-Z\\xc0-\\xd6\\xd8-\\xde",ni="\\ufe0e\\ufe0f",ti=rf+uf+of+af,$r="['\u2019]",ff="["+Se+"]",ei="["+ti+"]",Ie="["+Gu+"]",ri="\\d+",cf="["+Ju+"]",ui="["+Qu+"]",ii="[^"+Se+ti+ri+Ju+Qu+Xu+"]",Br="\\ud83c[\\udffb-\\udfff]",lf="(?:"+Ie+"|"+Br+")",oi="[^"+Se+"]",Fr="(?:\\ud83c[\\udde6-\\uddff]){2}",Rr="[\\ud800-\\udbff][\\udc00-\\udfff]",Vt="["+Xu+"]",ai="\\u200d",fi="(?:"+ui+"|"+ii+")",sf="(?:"+Vt+"|"+ii+")",ci="(?:"+$r+"(?:d|ll|m|re|s|t|ve))?",li="(?:"+$r+"(?:D|LL|M|RE|S|T|VE))?",si=lf+"?",pi="["+ni+"]?",pf="(?:"+ai+"(?:"+[oi,Fr,Rr].join("|")+")"+pi+si+")*",hf="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",vf="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",hi=pi+si+pf,_f="(?:"+[cf,Fr,Rr].join("|")+")"+hi,gf="(?:"+[oi+Ie+"?",Ie,Fr,Rr,ff].join("|")+")",yf=RegExp($r,"g"),df=RegExp(Ie,"g"),zr=RegExp(Br+"(?="+Br+")|"+gf+hi,"g"),mf=RegExp([Vt+"?"+ui+"+"+ci+"(?="+[ei,Vt,"$"].join("|")+")",sf+"+"+li+"(?="+[ei,Vt+fi,"$"].join("|")+")",Vt+"?"+fi+"+"+ci,Vt+"+"+li,vf,hf,ri,_f].join("|"),"g"),bf=RegExp("["+ai+Se+Gu+ni+"]"),wf=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,xf=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],jf=-1,T={};T[wr]=T[xr]=T[jr]=T[Ar]=T[Dr]=T[Er]=T[Cr]=T[Or]=T[kr]=!0,T[mt]=T[ae]=T[se]=T[$t]=T[qt]=T[yt]=T[ue]=T[ie]=T[Hn]=T[oe]=T[at]=T[fe]=T[Jn]=T[ce]=T[le]=!1;var P={};P[mt]=P[ae]=P[se]=P[qt]=P[$t]=P[yt]=P[wr]=P[xr]=P[jr]=P[Ar]=P[Dr]=P[Hn]=P[oe]=P[at]=P[fe]=P[Jn]=P[ce]=P[Oe]=P[Er]=P[Cr]=P[Or]=P[kr]=!0,P[ue]=P[ie]=P[le]=!1;var Af={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},Df={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Ef={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Cf={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Of=parseFloat,kf=parseInt,vi=typeof global=="object"&&global&&global.Object===Object&&global,Sf=typeof self=="object"&&self&&self.Object===Object&&self,nn=vi||Sf||Function("return this")(),Wr=typeof y=="object"&&y&&!y.nodeType&&y,Bt=Wr&&typeof d=="object"&&d&&!d.nodeType&&d,_i=Bt&&Bt.exports===Wr,Ur=_i&&vi.process,Mn=function(){try{var l=Bt&&Bt.require&&Bt.require("util").types;return l||Ur&&Ur.binding&&Ur.binding("util")}catch(h){}}(),gi=Mn&&Mn.isArrayBuffer,yi=Mn&&Mn.isDate,di=Mn&&Mn.isMap,mi=Mn&&Mn.isRegExp,bi=Mn&&Mn.isSet,wi=Mn&&Mn.isTypedArray;function On(l,h,p){switch(p.length){case 0:return l.call(h);case 1:return l.call(h,p[0]);case 2:return l.call(h,p[0],p[1]);case 3:return l.call(h,p[0],p[1],p[2])}return l.apply(h,p)}function If(l,h,p,b){for(var D=-1,W=l==null?0:l.length;++D<W;){var J=l[D];h(b,J,p(J),l)}return b}function Ln(l,h){for(var p=-1,b=l==null?0:l.length;++p<b&&h(l[p],p,l)!==!1;);return l}function $f(l,h){for(var p=l==null?0:l.length;p--&&h(l[p],p,l)!==!1;);return l}function xi(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(!h(l[p],p,l))return!1;return!0}function bt(l,h){for(var p=-1,b=l==null?0:l.length,D=0,W=[];++p<b;){var J=l[p];h(J,p,l)&&(W[D++]=J)}return W}function $e(l,h){var p=l==null?0:l.length;return!!p&&Yt(l,h,0)>-1}function Mr(l,h,p){for(var b=-1,D=l==null?0:l.length;++b<D;)if(p(h,l[b]))return!0;return!1}function q(l,h){for(var p=-1,b=l==null?0:l.length,D=Array(b);++p<b;)D[p]=h(l[p],p,l);return D}function wt(l,h){for(var p=-1,b=h.length,D=l.length;++p<b;)l[D+p]=h[p];return l}function Lr(l,h,p,b){var D=-1,W=l==null?0:l.length;for(b&&W&&(p=l[++D]);++D<W;)p=h(p,l[D],D,l);return p}function Bf(l,h,p,b){var D=l==null?0:l.length;for(b&&D&&(p=l[--D]);D--;)p=h(p,l[D],D,l);return p}function Nr(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(h(l[p],p,l))return!0;return!1}var Ff=Pr("length");function Rf(l){return l.split("")}function zf(l){return l.match(Ta)||[]}function ji(l,h,p){var b;return p(l,function(D,W,J){if(h(D,W,J))return b=W,!1}),b}function Be(l,h,p,b){for(var D=l.length,W=p+(b?1:-1);b?W--:++W<D;)if(h(l[W],W,l))return W;return-1}function Yt(l,h,p){return h===h?Hf(l,h,p):Be(l,Ai,p)}function Wf(l,h,p,b){for(var D=p-1,W=l.length;++D<W;)if(b(l[D],h))return D;return-1}function Ai(l){return l!==l}function Di(l,h){var p=l==null?0:l.length;return p?qr(l,h)/p:Kn}function Pr(l){return function(h){return h==null?a:h[l]}}function Tr(l){return function(h){return l==null?a:l[h]}}function Ei(l,h,p,b,D){return D(l,function(W,J,N){p=b?(b=!1,W):h(p,W,J,N)}),p}function Uf(l,h){var p=l.length;for(l.sort(h);p--;)l[p]=l[p].value;return l}function qr(l,h){for(var p,b=-1,D=l.length;++b<D;){var W=h(l[b]);W!==a&&(p=p===a?W:p+W)}return p}function Vr(l,h){for(var p=-1,b=Array(l);++p<l;)b[p]=h(p);return b}function Mf(l,h){return q(h,function(p){return[p,l[p]]})}function Ci(l){return l&&l.slice(0,Ii(l)+1).replace(Ir,"")}function kn(l){return function(h){return l(h)}}function Yr(l,h){return q(h,function(p){return l[p]})}function pe(l,h){return l.has(h)}function Oi(l,h){for(var p=-1,b=l.length;++p<b&&Yt(h,l[p],0)>-1;);return p}function ki(l,h){for(var p=l.length;p--&&Yt(h,l[p],0)>-1;);return p}function Lf(l,h){for(var p=l.length,b=0;p--;)l[p]===h&&++b;return b}var Nf=Tr(Af),Pf=Tr(Df);function Tf(l){return"\\"+Cf[l]}function qf(l,h){return l==null?a:l[h]}function Zt(l){return bf.test(l)}function Vf(l){return wf.test(l)}function Yf(l){for(var h,p=[];!(h=l.next()).done;)p.push(h.value);return p}function Zr(l){var h=-1,p=Array(l.size);return l.forEach(function(b,D){p[++h]=[D,b]}),p}function Si(l,h){return function(p){return l(h(p))}}function xt(l,h){for(var p=-1,b=l.length,D=0,W=[];++p<b;){var J=l[p];(J===h||J===Dn)&&(l[p]=Dn,W[D++]=p)}return W}function Fe(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=b}),p}function Zf(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=[b,b]}),p}function Hf(l,h,p){for(var b=p-1,D=l.length;++b<D;)if(l[b]===h)return b;return-1}function Kf(l,h,p){for(var b=p+1;b--;)if(l[b]===h)return b;return b}function Ht(l){return Zt(l)?Jf(l):Ff(l)}function Qn(l){return Zt(l)?Qf(l):Rf(l)}function Ii(l){for(var h=l.length;h--&&Ma.test(l.charAt(h)););return h}var Gf=Tr(Ef);function Jf(l){for(var h=zr.lastIndex=0;zr.test(l);)++h;return h}function Qf(l){return l.match(zr)||[]}function Xf(l){return l.match(mf)||[]}var nc=function l(h){h=h==null?nn:jt.defaults(nn.Object(),h,jt.pick(nn,xf));var p=h.Array,b=h.Date,D=h.Error,W=h.Function,J=h.Math,N=h.Object,Hr=h.RegExp,tc=h.String,Nn=h.TypeError,Re=p.prototype,ec=W.prototype,Kt=N.prototype,ze=h["__core-js_shared__"],We=ec.toString,M=Kt.hasOwnProperty,rc=0,$i=function(){var n=/[^.]+$/.exec(ze&&ze.keys&&ze.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Ue=Kt.toString,uc=We.call(N),ic=nn._,oc=Hr("^"+We.call(M).replace(Sr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Me=_i?h.Buffer:a,At=h.Symbol,Le=h.Uint8Array,Bi=Me?Me.allocUnsafe:a,Ne=Si(N.getPrototypeOf,N),Fi=N.create,Ri=Kt.propertyIsEnumerable,Pe=Re.splice,zi=At?At.isConcatSpreadable:a,he=At?At.iterator:a,Ft=At?At.toStringTag:a,Te=function(){try{var n=Mt(N,"defineProperty");return n({},"",{}),n}catch(t){}}(),ac=h.clearTimeout!==nn.clearTimeout&&h.clearTimeout,fc=b&&b.now!==nn.Date.now&&b.now,cc=h.setTimeout!==nn.setTimeout&&h.setTimeout,qe=J.ceil,Ve=J.floor,Kr=N.getOwnPropertySymbols,lc=Me?Me.isBuffer:a,Wi=h.isFinite,sc=Re.join,pc=Si(N.keys,N),Q=J.max,pn=J.min,hc=b.now,vc=h.parseInt,Ui=J.random,_c=Re.reverse,Gr=Mt(h,"DataView"),ve=Mt(h,"Map"),Jr=Mt(h,"Promise"),Gt=Mt(h,"Set"),_e=Mt(h,"WeakMap"),ge=Mt(N,"create"),Ye=_e&&new _e,Jt={},gc=Lt(Gr),yc=Lt(ve),dc=Lt(Jr),mc=Lt(Gt),bc=Lt(_e),Ze=At?At.prototype:a,ye=Ze?Ze.valueOf:a,Mi=Ze?Ze.toString:a;function i(n){if(H(n)&&!E(n)&&!(n instanceof B)){if(n instanceof Pn)return n;if(M.call(n,"__wrapped__"))return No(n)}return new Pn(n)}var Qt=function(){function n(){}return function(t){if(!V(t))return{};if(Fi)return Fi(t);n.prototype=t;var e=new n;return n.prototype=a,e}}();function He(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=a}i.templateSettings={escape:Ba,evaluate:Fa,interpolate:Hu,variable:"",imports:{_:i}},i.prototype=He.prototype,i.prototype.constructor=i,Pn.prototype=Qt(He.prototype),Pn.prototype.constructor=Pn;function B(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=vn,this.__views__=[]}function wc(){var n=new B(this.__wrapped__);return n.__actions__=wn(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=wn(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=wn(this.__views__),n}function xc(){if(this.__filtered__){var n=new B(this);n.__dir__=-1,n.__filtered__=!0}else n=this.clone(),n.__dir__*=-1;return n}function jc(){var n=this.__wrapped__.value(),t=this.__dir__,e=E(n),r=t<0,u=e?n.length:0,o=Rl(0,u,this.__views__),f=o.start,c=o.end,s=c-f,v=r?c:f-1,_=this.__iteratees__,g=_.length,m=0,w=pn(s,this.__takeCount__);if(!e||!r&&u==s&&w==s)return co(n,this.__actions__);var j=[];n:for(;s--&&m<w;){v+=t;for(var S=-1,A=n[v];++S<g;){var $=_[S],F=$.iteratee,$n=$.type,yn=F(A);if($n==ln)A=yn;else if(!yn){if($n==cn)continue n;break n}}j[m++]=A}return j}B.prototype=Qt(He.prototype),B.prototype.constructor=B;function Rt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Ac(){this.__data__=ge?ge(null):{},this.size=0}function Dc(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Ec(n){var t=this.__data__;if(ge){var e=t[n];return e===dn?a:e}return M.call(t,n)?t[n]:a}function Cc(n){var t=this.__data__;return ge?t[n]!==a:M.call(t,n)}function Oc(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=ge&&t===a?dn:t,this}Rt.prototype.clear=Ac,Rt.prototype.delete=Dc,Rt.prototype.get=Ec,Rt.prototype.has=Cc,Rt.prototype.set=Oc;function ft(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function kc(){this.__data__=[],this.size=0}function Sc(n){var t=this.__data__,e=Ke(t,n);if(e<0)return!1;var r=t.length-1;return e==r?t.pop():Pe.call(t,e,1),--this.size,!0}function Ic(n){var t=this.__data__,e=Ke(t,n);return e<0?a:t[e][1]}function $c(n){return Ke(this.__data__,n)>-1}function Bc(n,t){var e=this.__data__,r=Ke(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}ft.prototype.clear=kc,ft.prototype.delete=Sc,ft.prototype.get=Ic,ft.prototype.has=$c,ft.prototype.set=Bc;function ct(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Fc(){this.size=0,this.__data__={hash:new Rt,map:new(ve||ft),string:new Rt}}function Rc(n){var t=ar(this,n).delete(n);return this.size-=t?1:0,t}function zc(n){return ar(this,n).get(n)}function Wc(n){return ar(this,n).has(n)}function Uc(n,t){var e=ar(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}ct.prototype.clear=Fc,ct.prototype.delete=Rc,ct.prototype.get=zc,ct.prototype.has=Wc,ct.prototype.set=Uc;function zt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new ct;++t<e;)this.add(n[t])}function Mc(n){return this.__data__.set(n,dn),this}function Lc(n){return this.__data__.has(n)}zt.prototype.add=zt.prototype.push=Mc,zt.prototype.has=Lc;function Xn(n){var t=this.__data__=new ft(n);this.size=t.size}function Nc(){this.__data__=new ft,this.size=0}function Pc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function Tc(n){return this.__data__.get(n)}function qc(n){return this.__data__.has(n)}function Vc(n,t){var e=this.__data__;if(e instanceof ft){var r=e.__data__;if(!ve||r.length<R-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new ct(r)}return e.set(n,t),this.size=e.size,this}Xn.prototype.clear=Nc,Xn.prototype.delete=Pc,Xn.prototype.get=Tc,Xn.prototype.has=qc,Xn.prototype.set=Vc;function Li(n,t){var e=E(n),r=!e&&Nt(n),u=!e&&!r&&kt(n),o=!e&&!r&&!u&&ee(n),f=e||r||u||o,c=f?Vr(n.length,tc):[],s=c.length;for(var v in n)(t||M.call(n,v))&&!(f&&(v=="length"||u&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||ht(v,s)))&&c.push(v);return c}function Ni(n){var t=n.length;return t?n[fu(0,t-1)]:a}function Yc(n,t){return fr(wn(n),Wt(t,0,n.length))}function Zc(n){return fr(wn(n))}function Qr(n,t,e){(e!==a&&!nt(n[t],e)||e===a&&!(t in n))&&lt(n,t,e)}function de(n,t,e){var r=n[t];(!(M.call(n,t)&&nt(r,e))||e===a&&!(t in n))&&lt(n,t,e)}function Ke(n,t){for(var e=n.length;e--;)if(nt(n[e][0],t))return e;return-1}function Hc(n,t,e,r){return Dt(n,function(u,o,f){t(r,u,e(u),f)}),r}function Pi(n,t){return n&&rt(t,tn(t),n)}function Kc(n,t){return n&&rt(t,jn(t),n)}function lt(n,t,e){t=="__proto__"&&Te?Te(n,t,{configurable:!0,enumerable:!0,value:e,writable:!0}):n[t]=e}function Xr(n,t){for(var e=-1,r=t.length,u=p(r),o=n==null;++e<r;)u[e]=o?a:Bu(n,t[e]);return u}function Wt(n,t,e){return n===n&&(e!==a&&(n=n<=e?n:e),t!==a&&(n=n>=t?n:t)),n}function Tn(n,t,e,r,u,o){var f,c=t&sn,s=t&dt,v=t&Un;if(e&&(f=u?e(n,r,u,o):e(n)),f!==a)return f;if(!V(n))return n;var _=E(n);if(_){if(f=Wl(n),!c)return wn(n,f)}else{var g=hn(n),m=g==ie||g==qu;if(kt(n))return po(n,c);if(g==at||g==mt||m&&!u){if(f=s||m?{}:$o(n),!c)return s?El(n,Kc(f,n)):Dl(n,Pi(f,n))}else{if(!P[g])return u?n:{};f=Ul(n,g,c)}}o||(o=new Xn);var w=o.get(n);if(w)return w;o.set(n,f),aa(n)?n.forEach(function(A){f.add(Tn(A,t,e,A,n,o))}):ia(n)&&n.forEach(function(A,$){f.set($,Tn(A,t,e,$,n,o))});var j=v?s?mu:du:s?jn:tn,S=_?a:j(n);return Ln(S||n,function(A,$){S&&($=A,A=n[$]),de(f,$,Tn(A,t,e,$,n,o))}),f}function Gc(n){var t=tn(n);return function(e){return Ti(e,n,t)}}function Ti(n,t,e){var r=e.length;if(n==null)return!r;for(n=N(n);r--;){var u=e[r],o=t[u],f=n[u];if(f===a&&!(u in n)||!o(f))return!1}return!0}function qi(n,t,e){if(typeof n!="function")throw new Nn(z);return De(function(){n.apply(a,e)},t)}function me(n,t,e,r){var u=-1,o=$e,f=!0,c=n.length,s=[],v=t.length;if(!c)return s;e&&(t=q(t,kn(e))),r?(o=Mr,f=!1):t.length>=R&&(o=pe,f=!1,t=new zt(t));n:for(;++u<c;){var _=n[u],g=e==null?_:e(_);if(_=r||_!==0?_:0,f&&g===g){for(var m=v;m--;)if(t[m]===g)continue n;s.push(_)}else o(t,g,r)||s.push(_)}return s}var Dt=yo(et),Vi=yo(tu,!0);function Jc(n,t){var e=!0;return Dt(n,function(r,u,o){return e=!!t(r,u,o),e}),e}function Ge(n,t,e){for(var r=-1,u=n.length;++r<u;){var o=n[r],f=t(o);if(f!=null&&(c===a?f===f&&!In(f):e(f,c)))var c=f,s=o}return s}function Qc(n,t,e,r){var u=n.length;for(e=k(e),e<0&&(e=-e>u?0:u+e),r=r===a||r>u?u:k(r),r<0&&(r+=u),r=e>r?0:ca(r);e<r;)n[e++]=t;return n}function Yi(n,t){var e=[];return Dt(n,function(r,u,o){t(r,u,o)&&e.push(r)}),e}function an(n,t,e,r,u){var o=-1,f=n.length;for(e||(e=Ll),u||(u=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?an(c,t-1,e,r,u):wt(u,c):r||(u[u.length]=c)}return u}var nu=mo(),Zi=mo(!0);function et(n,t){return n&&nu(n,t,tn)}function tu(n,t){return n&&Zi(n,t,tn)}function Je(n,t){return bt(t,function(e){return vt(n[e])})}function Ut(n,t){t=Ct(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[ut(t[e++])];return e&&e==r?n:a}function Hi(n,t,e){var r=t(n);return E(n)?r:wt(r,e(n))}function _n(n){return n==null?n===a?Ea:xa:Ft&&Ft in N(n)?Fl(n):Zl(n)}function eu(n,t){return n>t}function Xc(n,t){return n!=null&&M.call(n,t)}function nl(n,t){return n!=null&&t in N(n)}function tl(n,t,e){return n>=pn(t,e)&&n<Q(t,e)}function ru(n,t,e){for(var r=e?Mr:$e,u=n[0].length,o=n.length,f=o,c=p(o),s=Infinity,v=[];f--;){var _=n[f];f&&t&&(_=q(_,kn(t))),s=pn(_.length,s),c[f]=!e&&(t||u>=120&&_.length>=120)?new zt(f&&_):a}_=n[0];var g=-1,m=c[0];n:for(;++g<u&&v.length<s;){var w=_[g],j=t?t(w):w;if(w=e||w!==0?w:0,!(m?pe(m,j):r(v,j,e))){for(f=o;--f;){var S=c[f];if(!(S?pe(S,j):r(n[f],j,e)))continue n}m&&m.push(j),v.push(w)}}return v}function el(n,t,e,r){return et(n,function(u,o,f){t(r,e(u),o,f)}),r}function be(n,t,e){t=Ct(t,n),n=zo(n,t);var r=n==null?n:n[ut(Vn(t))];return r==null?a:On(r,n,e)}function Ki(n){return H(n)&&_n(n)==mt}function rl(n){return H(n)&&_n(n)==se}function ul(n){return H(n)&&_n(n)==yt}function we(n,t,e,r,u){return n===t?!0:n==null||t==null||!H(n)&&!H(t)?n!==n&&t!==t:il(n,t,e,r,we,u)}function il(n,t,e,r,u,o){var f=E(n),c=E(t),s=f?ae:hn(n),v=c?ae:hn(t);s=s==mt?at:s,v=v==mt?at:v;var _=s==at,g=v==at,m=s==v;if(m&&kt(n)){if(!kt(t))return!1;f=!0,_=!1}if(m&&!_)return o||(o=new Xn),f||ee(n)?ko(n,t,e,r,u,o):$l(n,t,s,e,r,u,o);if(!(e&Rn)){var w=_&&M.call(n,"__wrapped__"),j=g&&M.call(t,"__wrapped__");if(w||j){var S=w?n.value():n,A=j?t.value():t;return o||(o=new Xn),u(S,A,e,r,o)}}return m?(o||(o=new Xn),Bl(n,t,e,r,u,o)):!1}function ol(n){return H(n)&&hn(n)==Hn}function uu(n,t,e,r){var u=e.length,o=u,f=!r;if(n==null)return!o;for(n=N(n);u--;){var c=e[u];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return!1}for(;++u<o;){c=e[u];var s=c[0],v=n[s],_=c[1];if(f&&c[2]){if(v===a&&!(s in n))return!1}else{var g=new Xn;if(r)var m=r(v,_,s,n,t,g);if(!(m===a?we(_,v,Rn|bn,r,g):m))return!1}}return!0}function Gi(n){if(!V(n)||Pl(n))return!1;var t=vt(n)?oc:Ka;return t.test(Lt(n))}function al(n){return H(n)&&_n(n)==fe}function fl(n){return H(n)&&hn(n)==Jn}function cl(n){return H(n)&&vr(n.length)&&!!T[_n(n)]}function Ji(n){return typeof n=="function"?n:n==null?An:typeof n=="object"?E(n)?no(n[0],n[1]):Xi(n):ba(n)}function iu(n){if(!Ae(n))return pc(n);var t=[];for(var e in N(n))M.call(n,e)&&e!="constructor"&&t.push(e);return t}function ll(n){if(!V(n))return Yl(n);var t=Ae(n),e=[];for(var r in n)r=="constructor"&&(t||!M.call(n,r))||e.push(r);return e}function ou(n,t){return n<t}function Qi(n,t){var e=-1,r=xn(n)?p(n.length):[];return Dt(n,function(u,o,f){r[++e]=t(u,o,f)}),r}function Xi(n){var t=wu(n);return t.length==1&&t[0][2]?Fo(t[0][0],t[0][1]):function(e){return e===n||uu(e,n,t)}}function no(n,t){return ju(n)&&Bo(t)?Fo(ut(n),t):function(e){var r=Bu(e,n);return r===a&&r===t?Fu(e,n):we(t,r,Rn|bn)}}function Qe(n,t,e,r,u){n!==t&&nu(t,function(o,f){if(u||(u=new Xn),V(o))sl(n,t,f,e,Qe,r,u);else{var c=r?r(Du(n,f),o,f+"",n,t,u):a;c===a&&(c=o),Qr(n,f,c)}},jn)}function sl(n,t,e,r,u,o,f){var c=Du(n,e),s=Du(t,e),v=f.get(s);if(v){Qr(n,e,v);return}var _=o?o(c,s,e+"",n,t,f):a,g=_===a;if(g){var m=E(s),w=!m&&kt(s),j=!m&&!w&&ee(s);_=s,m||w||j?E(c)?_=c:K(c)?_=wn(c):w?(g=!1,_=po(s,!0)):j?(g=!1,_=ho(s,!0)):_=[]:Ee(s)||Nt(s)?(_=c,Nt(c)?_=la(c):(!V(c)||vt(c))&&(_=$o(s))):g=!1}g&&(f.set(s,_),u(_,s,r,o,f),f.delete(s)),Qr(n,e,_)}function to(n,t){var e=n.length;if(e)return t+=t<0?e:0,ht(t,e)?n[t]:a}function eo(n,t,e){t.length?t=q(t,function(o){return E(o)?function(f){return Ut(f,o.length===1?o[0]:o)}:o}):t=[An];var r=-1;t=q(t,kn(x()));var u=Qi(n,function(o,f,c){var s=q(t,function(v){return v(o)});return{criteria:s,index:++r,value:o}});return Uf(u,function(o,f){return Al(o,f,e)})}function pl(n,t){return ro(n,t,function(e,r){return Fu(n,r)})}function ro(n,t,e){for(var r=-1,u=t.length,o={};++r<u;){var f=t[r],c=Ut(n,f);e(c,f)&&xe(o,Ct(f,n),c)}return o}function hl(n){return function(t){return Ut(t,n)}}function au(n,t,e,r){var u=r?Wf:Yt,o=-1,f=t.length,c=n;for(n===t&&(t=wn(t)),e&&(c=q(n,kn(e)));++o<f;)for(var s=0,v=t[o],_=e?e(v):v;(s=u(c,_,s,r))>-1;)c!==n&&Pe.call(c,s,1),Pe.call(n,s,1);return n}function uo(n,t){for(var e=n?t.length:0,r=e-1;e--;){var u=t[e];if(e==r||u!==o){var o=u;ht(u)?Pe.call(n,u,1):su(n,u)}}return n}function fu(n,t){return n+Ve(Ui()*(t-n+1))}function vl(n,t,e,r){for(var u=-1,o=Q(qe((t-n)/(e||1)),0),f=p(o);o--;)f[r?o:++u]=n,n+=e;return f}function cu(n,t){var e="";if(!n||t<1||t>en)return e;do t%2&&(e+=n),t=Ve(t/2),t&&(n+=n);while(t);return e}function I(n,t){return Eu(Ro(n,t,An),n+"")}function _l(n){return Ni(re(n))}function gl(n,t){var e=re(n);return fr(e,Wt(t,0,e.length))}function xe(n,t,e,r){if(!V(n))return n;t=Ct(t,n);for(var u=-1,o=t.length,f=o-1,c=n;c!=null&&++u<o;){var s=ut(t[u]),v=e;if(s==="__proto__"||s==="constructor"||s==="prototype")return n;if(u!=f){var _=c[s];v=r?r(_,s,c):a,v===a&&(v=V(_)?_:ht(t[u+1])?[]:{})}de(c,s,v),c=c[s]}return n}var io=Ye?function(n,t){return Ye.set(n,t),n}:An,yl=Te?function(n,t){return Te(n,"toString",{configurable:!0,enumerable:!1,value:zu(t),writable:!0})}:An;function dl(n){return fr(re(n))}function qn(n,t,e){var r=-1,u=n.length;t<0&&(t=-t>u?0:u+t),e=e>u?u:e,e<0&&(e+=u),u=t>e?0:e-t>>>0,t>>>=0;for(var o=p(u);++r<u;)o[r]=n[r+t];return o}function ml(n,t){var e;return Dt(n,function(r,u,o){return e=t(r,u,o),!e}),!!e}function Xe(n,t,e){var r=0,u=n==null?r:n.length;if(typeof t=="number"&&t===t&&u<=Ce){for(;r<u;){var o=r+u>>>1,f=n[o];f!==null&&!In(f)&&(e?f<=t:f<t)?r=o+1:u=o}return u}return lu(n,t,An,e)}function lu(n,t,e,r){var u=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,s=In(t),v=t===a;u<o;){var _=Ve((u+o)/2),g=e(n[_]),m=g!==a,w=g===null,j=g===g,S=In(g);if(f)var A=r||j;else v?A=j&&(r||m):c?A=j&&m&&(r||!w):s?A=j&&m&&!w&&(r||!S):w||S?A=!1:A=r?g<=t:g<t;A?u=_+1:o=_}return pn(o,Tt)}function oo(n,t){for(var e=-1,r=n.length,u=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!nt(c,s)){var s=c;o[u++]=f===0?0:f}}return o}function ao(n){return typeof n=="number"?n:In(n)?Kn:+n}function Sn(n){if(typeof n=="string")return n;if(E(n))return q(n,Sn)+"";if(In(n))return Mi?Mi.call(n):"";var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Et(n,t,e){var r=-1,u=$e,o=n.length,f=!0,c=[],s=c;if(e)f=!1,u=Mr;else if(o>=R){var v=t?null:Sl(n);if(v)return Fe(v);f=!1,u=pe,s=new zt}else s=t?[]:c;n:for(;++r<o;){var _=n[r],g=t?t(_):_;if(_=e||_!==0?_:0,f&&g===g){for(var m=s.length;m--;)if(s[m]===g)continue n;t&&s.push(g),c.push(_)}else u(s,g,e)||(s!==c&&s.push(g),c.push(_))}return c}function su(n,t){return t=Ct(t,n),n=zo(n,t),n==null||delete n[ut(Vn(t))]}function fo(n,t,e,r){return xe(n,t,e(Ut(n,t)),r)}function nr(n,t,e,r){for(var u=n.length,o=r?u:-1;(r?o--:++o<u)&&t(n[o],o,n););return e?qn(n,r?0:o,r?o+1:u):qn(n,r?o+1:0,r?u:o)}function co(n,t){var e=n;return e instanceof B&&(e=e.value()),Lr(t,function(r,u){return u.func.apply(u.thisArg,wt([r],u.args))},e)}function pu(n,t,e){var r=n.length;if(r<2)return r?Et(n[0]):[];for(var u=-1,o=p(r);++u<r;)for(var f=n[u],c=-1;++c<r;)c!=u&&(o[u]=me(o[u]||f,n[c],t,e));return Et(an(o,1),t,e)}function lo(n,t,e){for(var r=-1,u=n.length,o=t.length,f={};++r<u;){var c=r<o?t[r]:a;e(f,n[r],c)}return f}function hu(n){return K(n)?n:[]}function vu(n){return typeof n=="function"?n:An}function Ct(n,t){return E(n)?n:ju(n,t)?[n]:Lo(U(n))}var bl=I;function Ot(n,t,e){var r=n.length;return e=e===a?r:e,!t&&e>=r?n:qn(n,t,e)}var so=ac||function(n){return nn.clearTimeout(n)};function po(n,t){if(t)return n.slice();var e=n.length,r=Bi?Bi(e):new n.constructor(e);return n.copy(r),r}function _u(n){var t=new n.constructor(n.byteLength);return new Le(t).set(new Le(n)),t}function wl(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function xl(n){var t=new n.constructor(n.source,Ku.exec(n));return t.lastIndex=n.lastIndex,t}function jl(n){return ye?N(ye.call(n)):{}}function ho(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function vo(n,t){if(n!==t){var e=n!==a,r=n===null,u=n===n,o=In(n),f=t!==a,c=t===null,s=t===t,v=In(t);if(!c&&!v&&!o&&n>t||o&&f&&s&&!c&&!v||r&&f&&s||!e&&s||!u)return 1;if(!r&&!o&&!v&&n<t||v&&e&&u&&!r&&!o||c&&e&&u||!f&&u||!s)return-1}return 0}function Al(n,t,e){for(var r=-1,u=n.criteria,o=t.criteria,f=u.length,c=e.length;++r<f;){var s=vo(u[r],o[r]);if(s){if(r>=c)return s;var v=e[r];return s*(v=="desc"?-1:1)}}return n.index-t.index}function _o(n,t,e,r){for(var u=-1,o=n.length,f=e.length,c=-1,s=t.length,v=Q(o-f,0),_=p(s+v),g=!r;++c<s;)_[c]=t[c];for(;++u<f;)(g||u<o)&&(_[e[u]]=n[u]);for(;v--;)_[c++]=n[u++];return _}function go(n,t,e,r){for(var u=-1,o=n.length,f=-1,c=e.length,s=-1,v=t.length,_=Q(o-c,0),g=p(_+v),m=!r;++u<_;)g[u]=n[u];for(var w=u;++s<v;)g[w+s]=t[s];for(;++f<c;)(m||u<o)&&(g[w+e[f]]=n[u++]);return g}function wn(n,t){var e=-1,r=n.length;for(t||(t=p(r));++e<r;)t[e]=n[e];return t}function rt(n,t,e,r){var u=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],s=r?r(e[c],n[c],c,e,n):a;s===a&&(s=n[c]),u?lt(e,c,s):de(e,c,s)}return e}function Dl(n,t){return rt(n,xu(n),t)}function El(n,t){return rt(n,So(n),t)}function tr(n,t){return function(e,r){var u=E(e)?If:Hc,o=t?t():{};return u(e,n,x(r,2),o)}}function Xt(n){return I(function(t,e){var r=-1,u=e.length,o=u>1?e[u-1]:a,f=u>2?e[2]:a;for(o=n.length>3&&typeof o=="function"?(u--,o):a,f&&gn(e[0],e[1],f)&&(o=u<3?a:o,u=1),t=N(t);++r<u;){var c=e[r];c&&n(t,c,r,o)}return t})}function yo(n,t){return function(e,r){if(e==null)return e;if(!xn(e))return n(e,r);for(var u=e.length,o=t?u:-1,f=N(e);(t?o--:++o<u)&&r(f[o],o,f)!==!1;);return e}}function mo(n){return function(t,e,r){for(var u=-1,o=N(t),f=r(t),c=f.length;c--;){var s=f[n?c:++u];if(e(o[s],s,o)===!1)break}return t}}function Cl(n,t,e){var r=t&X,u=je(n);function o(){var f=this&&this!==nn&&this instanceof o?u:n;return f.apply(r?e:this,arguments)}return o}function bo(n){return function(t){t=U(t);var e=Zt(t)?Qn(t):a,r=e?e[0]:t.charAt(0),u=e?Ot(e,1).join(""):t.slice(1);return r[n]()+u}}function ne(n){return function(t){return Lr(da(ya(t).replace(yf,"")),n,"")}}function je(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=Qt(n.prototype),r=n.apply(e,t);return V(r)?r:e}}function Ol(n,t,e){var r=je(n);function u(){for(var o=arguments.length,f=p(o),c=o,s=te(u);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==s&&f[o-1]!==s?[]:xt(f,s);if(o-=v.length,o<e)return Do(n,t,er,u.placeholder,a,f,v,a,a,e-o);var _=this&&this!==nn&&this instanceof u?r:n;return On(_,this,f)}return u}function wo(n){return function(t,e,r){var u=N(t);if(!xn(t)){var o=x(e,3);t=tn(t),e=function(c){return o(u[c],c,u)}}var f=n(t,e,r);return f>-1?u[o?t[f]:f]:a}}function xo(n){return pt(function(t){var e=t.length,r=e,u=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new Nn(z);if(u&&!f&&or(o)=="wrapper")var f=new Pn([],!0)}for(r=f?r:e;++r<e;){o=t[r];var c=or(o),s=c=="wrapper"?bu(o):a;s&&Au(s[0])&&s[1]==(Y|mn|un|Cn)&&!s[4].length&&s[9]==1?f=f[or(s[0])].apply(f,s[3]):f=o.length==1&&Au(o)?f[c]():f.thru(o)}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&E(_))return f.plant(_).value();for(var g=0,m=e?t[g].apply(this,v):_;++g<e;)m=t[g].call(this,m);return m}})}function er(n,t,e,r,u,o,f,c,s,v){var _=t&Y,g=t&X,m=t&En,w=t&(mn|ot),j=t&Wn,S=m?a:je(n);function A(){for(var $=arguments.length,F=p($),$n=$;$n--;)F[$n]=arguments[$n];if(w)var yn=te(A),Bn=Lf(F,yn);if(r&&(F=_o(F,r,u,w)),o&&(F=go(F,o,f,w)),$-=Bn,w&&$<v){var G=xt(F,yn);return Do(n,t,er,A.placeholder,e,F,G,c,s,v-$)}var tt=g?e:this,gt=m?tt[n]:n;return $=F.length,c?F=Hl(F,c):j&&$>1&&F.reverse(),_&&s<$&&(F.length=s),this&&this!==nn&&this instanceof A&&(gt=S||je(gt)),gt.apply(tt,F)}return A}function jo(n,t){return function(e,r){return el(e,n,t(r),{})}}function rr(n,t){return function(e,r){var u;if(e===a&&r===a)return t;if(e!==a&&(u=e),r!==a){if(u===a)return r;typeof e=="string"||typeof r=="string"?(e=Sn(e),r=Sn(r)):(e=ao(e),r=ao(r)),u=n(e,r)}return u}}function gu(n){return pt(function(t){return t=q(t,kn(x())),I(function(e){var r=this;return n(t,function(u){return On(u,r,e)})})})}function ur(n,t){t=t===a?" ":Sn(t);var e=t.length;if(e<2)return e?cu(t,n):t;var r=cu(t,qe(n/Ht(t)));return Zt(t)?Ot(Qn(r),0,n).join(""):r.slice(0,n)}function kl(n,t,e,r){var u=t&X,o=je(n);function f(){for(var c=-1,s=arguments.length,v=-1,_=r.length,g=p(_+s),m=this&&this!==nn&&this instanceof f?o:n;++v<_;)g[v]=r[v];for(;s--;)g[v++]=arguments[++c];return On(m,u?e:this,g)}return f}function Ao(n){return function(t,e,r){return r&&typeof r!="number"&&gn(t,e,r)&&(e=r=a),t=_t(t),e===a?(e=t,t=0):e=_t(e),r=r===a?t<e?1:-1:_t(r),vl(t,e,r,n)}}function ir(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=Yn(t),e=Yn(e)),n(t,e)}}function Do(n,t,e,r,u,o,f,c,s,v){var _=t&mn,g=_?f:a,m=_?a:f,w=_?o:a,j=_?a:o;t|=_?un:on,t&=~(_?on:un),t&St||(t&=~(X|En));var S=[n,t,u,w,g,j,m,c,s,v],A=e.apply(a,S);return Au(n)&&Wo(A,S),A.placeholder=r,Uo(A,n,t)}function yu(n){var t=J[n];return function(e,r){if(e=Yn(e),r=r==null?0:pn(k(r),292),r&&Wi(e)){var u=(U(e)+"e").split("e"),o=t(u[0]+"e"+(+u[1]+r));return u=(U(o)+"e").split("e"),+(u[0]+"e"+(+u[1]-r))}return t(e)}}var Sl=Gt&&1/Fe(new Gt([,-0]))[1]==Z?function(n){return new Gt(n)}:Mu;function Eo(n){return function(t){var e=hn(t);return e==Hn?Zr(t):e==Jn?Zf(t):Mf(t,n(t))}}function st(n,t,e,r,u,o,f,c){var s=t&En;if(!s&&typeof n!="function")throw new Nn(z);var v=r?r.length:0;if(v||(t&=~(un|on),r=u=a),f=f===a?f:Q(k(f),0),c=c===a?c:k(c),v-=u?u.length:0,t&on){var _=r,g=u;r=u=a}var m=s?a:bu(n),w=[n,t,e,r,u,_,g,o,f,c];if(m&&Vl(w,m),n=w[0],t=w[1],e=w[2],r=w[3],u=w[4],c=w[9]=w[9]===a?s?0:n.length:Q(w[9]-v,0),!c&&t&(mn|ot)&&(t&=~(mn|ot)),!t||t==X)var j=Cl(n,t,e);else t==mn||t==ot?j=Ol(n,t,c):(t==un||t==(X|un))&&!u.length?j=kl(n,t,e,r):j=er.apply(a,w);var S=m?io:Wo;return Uo(S(j,w),n,t)}function Co(n,t,e,r){return n===a||nt(n,Kt[e])&&!M.call(r,e)?t:n}function Oo(n,t,e,r,u,o){return V(n)&&V(t)&&(o.set(t,n),Qe(n,t,a,Oo,o),o.delete(t)),n}function Il(n){return Ee(n)?a:n}function ko(n,t,e,r,u,o){var f=e&Rn,c=n.length,s=t.length;if(c!=s&&!(f&&s>c))return!1;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var g=-1,m=!0,w=e&bn?new zt:a;for(o.set(n,t),o.set(t,n);++g<c;){var j=n[g],S=t[g];if(r)var A=f?r(S,j,g,t,n,o):r(j,S,g,n,t,o);if(A!==a){if(A)continue;m=!1;break}if(w){if(!Nr(t,function($,F){if(!pe(w,F)&&(j===$||u(j,$,e,r,o)))return w.push(F)})){m=!1;break}}else if(!(j===S||u(j,S,e,r,o))){m=!1;break}}return o.delete(n),o.delete(t),m}function $l(n,t,e,r,u,o,f){switch(e){case qt:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return!1;n=n.buffer,t=t.buffer;case se:return!(n.byteLength!=t.byteLength||!o(new Le(n),new Le(t)));case $t:case yt:case oe:return nt(+n,+t);case ue:return n.name==t.name&&n.message==t.message;case fe:case ce:return n==t+"";case Hn:var c=Zr;case Jn:var s=r&Rn;if(c||(c=Fe),n.size!=t.size&&!s)return!1;var v=f.get(n);if(v)return v==t;r|=bn,f.set(n,t);var _=ko(c(n),c(t),r,u,o,f);return f.delete(n),_;case Oe:if(ye)return ye.call(n)==ye.call(t)}return!1}function Bl(n,t,e,r,u,o){var f=e&Rn,c=du(n),s=c.length,v=du(t),_=v.length;if(s!=_&&!f)return!1;for(var g=s;g--;){var m=c[g];if(!(f?m in t:M.call(t,m)))return!1}var w=o.get(n),j=o.get(t);if(w&&j)return w==t&&j==n;var S=!0;o.set(n,t),o.set(t,n);for(var A=f;++g<s;){m=c[g];var $=n[m],F=t[m];if(r)var $n=f?r(F,$,m,t,n,o):r($,F,m,n,t,o);if(!($n===a?$===F||u($,F,e,r,o):$n)){S=!1;break}A||(A=m=="constructor")}if(S&&!A){var yn=n.constructor,Bn=t.constructor;yn!=Bn&&"constructor"in n&&"constructor"in t&&!(typeof yn=="function"&&yn instanceof yn&&typeof Bn=="function"&&Bn instanceof Bn)&&(S=!1)}return o.delete(n),o.delete(t),S}function pt(n){return Eu(Ro(n,a,qo),n+"")}function du(n){return Hi(n,tn,xu)}function mu(n){return Hi(n,jn,So)}var bu=Ye?function(n){return Ye.get(n)}:Mu;function or(n){for(var t=n.name+"",e=Jt[t],r=M.call(Jt,t)?e.length:0;r--;){var u=e[r],o=u.func;if(o==null||o==n)return u.name}return t}function te(n){var t=M.call(i,"placeholder")?i:n;return t.placeholder}function x(){var n=i.iteratee||Wu;return n=n===Wu?Ji:n,arguments.length?n(arguments[0],arguments[1]):n}function ar(n,t){var e=n.__data__;return Nl(t)?e[typeof t=="string"?"string":"hash"]:e.map}function wu(n){for(var t=tn(n),e=t.length;e--;){var r=t[e],u=n[r];t[e]=[r,u,Bo(u)]}return t}function Mt(n,t){var e=qf(n,t);return Gi(e)?e:a}function Fl(n){var t=M.call(n,Ft),e=n[Ft];try{n[Ft]=a;var r=!0}catch(o){}var u=Ue.call(n);return r&&(t?n[Ft]=e:delete n[Ft]),u}var xu=Kr?function(n){return n==null?[]:(n=N(n),bt(Kr(n),function(t){return Ri.call(n,t)}))}:Lu,So=Kr?function(n){for(var t=[];n;)wt(t,xu(n)),n=Ne(n);return t}:Lu,hn=_n;(Gr&&hn(new Gr(new ArrayBuffer(1)))!=qt||ve&&hn(new ve)!=Hn||Jr&&hn(Jr.resolve())!=Vu||Gt&&hn(new Gt)!=Jn||_e&&hn(new _e)!=le)&&(hn=function(n){var t=_n(n),e=t==at?n.constructor:a,r=e?Lt(e):"";if(r)switch(r){case gc:return qt;case yc:return Hn;case dc:return Vu;case mc:return Jn;case bc:return le}return t});function Rl(n,t,e){for(var r=-1,u=e.length;++r<u;){var o=e[r],f=o.size;switch(o.type){case"drop":n+=f;break;case"dropRight":t-=f;break;case"take":t=pn(t,n+f);break;case"takeRight":n=Q(n,t-f);break}}return{start:n,end:t}}function zl(n){var t=n.match(Na);return t?t[1].split(Pa):[]}function Io(n,t,e){t=Ct(t,n);for(var r=-1,u=t.length,o=!1;++r<u;){var f=ut(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f]}return o||++r!=u?o:(u=n==null?0:n.length,!!u&&vr(u)&&ht(f,u)&&(E(n)||Nt(n)))}function Wl(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&M.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function $o(n){return typeof n.constructor=="function"&&!Ae(n)?Qt(Ne(n)):{}}function Ul(n,t,e){var r=n.constructor;switch(t){case se:return _u(n);case $t:case yt:return new r(+n);case qt:return wl(n,e);case wr:case xr:case jr:case Ar:case Dr:case Er:case Cr:case Or:case kr:return ho(n,e);case Hn:return new r;case oe:case ce:return new r(n);case fe:return xl(n);case Jn:return new r;case Oe:return jl(n)}}function Ml(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(La,`{
/* [wrapped with `+t+`] */
`)}function Ll(n){return E(n)||Nt(n)||!!(zi&&n&&n[zi])}function ht(n,t){var e=typeof n;return t=t==null?en:t,!!t&&(e=="number"||e!="symbol"&&Ja.test(n))&&n>-1&&n%1==0&&n<t}function gn(n,t,e){if(!V(e))return!1;var r=typeof t;return(r=="number"?xn(e)&&ht(t,e.length):r=="string"&&t in e)?nt(e[t],n):!1}function ju(n,t){if(E(n))return!1;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||In(n)?!0:za.test(n)||!Ra.test(n)||t!=null&&n in N(t)}function Nl(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function Au(n){var t=or(n),e=i[t];if(typeof e!="function"||!(t in B.prototype))return!1;if(n===e)return!0;var r=bu(e);return!!r&&n===r[0]}function Pl(n){return!!$i&&$i in n}var Tl=ze?vt:Nu;function Ae(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Kt;return n===e}function Bo(n){return n===n&&!V(n)}function Fo(n,t){return function(e){return e==null?!1:e[n]===t&&(t!==a||n in N(e))}}function ql(n){var t=pr(n,function(r){return e.size===rn&&e.clear(),r}),e=t.cache;return t}function Vl(n,t){var e=n[1],r=t[1],u=e|r,o=u<(X|En|Y),f=r==Y&&e==mn||r==Y&&e==Cn&&n[7].length<=t[8]||r==(Y|Cn)&&t[7].length<=t[8]&&e==mn;if(!(o||f))return n;r&X&&(n[2]=t[2],u|=e&X?0:St);var c=t[3];if(c){var s=n[3];n[3]=s?_o(s,c,t[4]):c,n[4]=s?xt(n[3],Dn):t[4]}return c=t[5],c&&(s=n[5],n[5]=s?go(s,c,t[6]):c,n[6]=s?xt(n[5],Dn):t[6]),c=t[7],c&&(n[7]=c),r&Y&&(n[8]=n[8]==null?t[8]:pn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Yl(n){var t=[];if(n!=null)for(var e in N(n))t.push(e);return t}function Zl(n){return Ue.call(n)}function Ro(n,t,e){return t=Q(t===a?n.length-1:t,0),function(){for(var r=arguments,u=-1,o=Q(r.length-t,0),f=p(o);++u<o;)f[u]=r[t+u];u=-1;for(var c=p(t+1);++u<t;)c[u]=r[u];return c[t]=e(f),On(n,this,c)}}function zo(n,t){return t.length<2?n:Ut(n,qn(t,0,-1))}function Hl(n,t){for(var e=n.length,r=pn(t.length,e),u=wn(n);r--;){var o=t[r];n[r]=ht(o,e)?u[o]:a}return n}function Du(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Wo=Mo(io),De=cc||function(n,t){return nn.setTimeout(n,t)},Eu=Mo(yl);function Uo(n,t,e){var r=t+"";return Eu(n,Ml(r,Kl(zl(r),e)))}function Mo(n){var t=0,e=0;return function(){var r=hc(),u=zn-(r-e);if(e=r,u>0){if(++t>=Pt)return arguments[0]}else t=0;return n.apply(a,arguments)}}function fr(n,t){var e=-1,r=n.length,u=r-1;for(t=t===a?r:t;++e<t;){var o=fu(e,u),f=n[o];n[o]=n[e],n[e]=f}return n.length=t,n}var Lo=ql(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(Wa,function(e,r,u,o){t.push(u?o.replace(Va,"$1"):r||e)}),t});function ut(n){if(typeof n=="string"||In(n))return n;var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Lt(n){if(n!=null){try{return We.call(n)}catch(t){}try{return n+""}catch(t){}}return""}function Kl(n,t){return Ln(mr,function(e){var r="_."+e[0];t&e[1]&&!$e(n,r)&&n.push(r)}),n.sort()}function No(n){if(n instanceof B)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=wn(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Gl(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=Q(k(t),0);var r=n==null?0:n.length;if(!r||t<1)return[];for(var u=0,o=0,f=p(qe(r/t));u<r;)f[o++]=qn(n,u,u+=t);return f}function Jl(n){for(var t=-1,e=n==null?0:n.length,r=0,u=[];++t<e;){var o=n[t];o&&(u[r++]=o)}return u}function Ql(){var n=arguments.length;if(!n)return[];for(var t=p(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return wt(E(e)?wn(e):[e],an(t,1))}var Xl=I(function(n,t){return K(n)?me(n,an(t,1,K,!0)):[]}),ns=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),x(e,2)):[]}),ts=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),a,e):[]});function es(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),qn(n,t<0?0:t,r)):[]}function rs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,0,t<0?0:t)):[]}function us(n,t){return n&&n.length?nr(n,x(t,3),!0,!0):[]}function is(n,t){return n&&n.length?nr(n,x(t,3),!0):[]}function os(n,t,e,r){var u=n==null?0:n.length;return u?(e&&typeof e!="number"&&gn(n,t,e)&&(e=0,r=u),Qc(n,t,e,r)):[]}function Po(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Be(n,x(t,3),u)}function To(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r-1;return e!==a&&(u=k(e),u=e<0?Q(r+u,0):pn(u,r-1)),Be(n,x(t,3),u,!0)}function qo(n){var t=n==null?0:n.length;return t?an(n,1):[]}function as(n){var t=n==null?0:n.length;return t?an(n,Z):[]}function fs(n,t){var e=n==null?0:n.length;return e?(t=t===a?1:k(t),an(n,t)):[]}function cs(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var u=n[t];r[u[0]]=u[1]}return r}function Vo(n){return n&&n.length?n[0]:a}function ls(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Yt(n,t,u)}function ss(n){var t=n==null?0:n.length;return t?qn(n,0,-1):[]}var ps=I(function(n){var t=q(n,hu);return t.length&&t[0]===n[0]?ru(t):[]}),hs=I(function(n){var t=Vn(n),e=q(n,hu);return t===Vn(e)?t=a:e.pop(),e.length&&e[0]===n[0]?ru(e,x(t,2)):[]}),vs=I(function(n){var t=Vn(n),e=q(n,hu);return t=typeof t=="function"?t:a,t&&e.pop(),e.length&&e[0]===n[0]?ru(e,a,t):[]});function _s(n,t){return n==null?"":sc.call(n,t)}function Vn(n){var t=n==null?0:n.length;return t?n[t-1]:a}function gs(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r;return e!==a&&(u=k(e),u=u<0?Q(r+u,0):pn(u,r-1)),t===t?Kf(n,t,u):Be(n,Ai,u,!0)}function ys(n,t){return n&&n.length?to(n,k(t)):a}var ds=I(Yo);function Yo(n,t){return n&&n.length&&t&&t.length?au(n,t):n}function ms(n,t,e){return n&&n.length&&t&&t.length?au(n,t,x(e,2)):n}function bs(n,t,e){return n&&n.length&&t&&t.length?au(n,t,a,e):n}var ws=pt(function(n,t){var e=n==null?0:n.length,r=Xr(n,t);return uo(n,q(t,function(u){return ht(u,e)?+u:u}).sort(vo)),r});function xs(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,u=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),u.push(r))}return uo(n,u),e}function Cu(n){return n==null?n:_c.call(n)}function js(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&gn(n,t,e)?(t=0,e=r):(t=t==null?0:k(t),e=e===a?r:k(e)),qn(n,t,e)):[]}function As(n,t){return Xe(n,t)}function Ds(n,t,e){return lu(n,t,x(e,2))}function Es(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t);if(r<e&&nt(n[r],t))return r}return-1}function Cs(n,t){return Xe(n,t,!0)}function Os(n,t,e){return lu(n,t,x(e,2),!0)}function ks(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t,!0)-1;if(nt(n[r],t))return r}return-1}function Ss(n){return n&&n.length?oo(n):[]}function Is(n,t){return n&&n.length?oo(n,x(t,2)):[]}function $s(n){var t=n==null?0:n.length;return t?qn(n,1,t):[]}function Bs(n,t,e){return n&&n.length?(t=e||t===a?1:k(t),qn(n,0,t<0?0:t)):[]}function Fs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,t<0?0:t,r)):[]}function Rs(n,t){return n&&n.length?nr(n,x(t,3),!1,!0):[]}function zs(n,t){return n&&n.length?nr(n,x(t,3)):[]}var Ws=I(function(n){return Et(an(n,1,K,!0))}),Us=I(function(n){var t=Vn(n);return K(t)&&(t=a),Et(an(n,1,K,!0),x(t,2))}),Ms=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,Et(an(n,1,K,!0),a,t)});function Ls(n){return n&&n.length?Et(n):[]}function Ns(n,t){return n&&n.length?Et(n,x(t,2)):[]}function Ps(n,t){return t=typeof t=="function"?t:a,n&&n.length?Et(n,a,t):[]}function Ou(n){if(!(n&&n.length))return[];var t=0;return n=bt(n,function(e){if(K(e))return t=Q(e.length,t),!0}),Vr(t,function(e){return q(n,Pr(e))})}function Zo(n,t){if(!(n&&n.length))return[];var e=Ou(n);return t==null?e:q(e,function(r){return On(t,a,r)})}var Ts=I(function(n,t){return K(n)?me(n,t):[]}),qs=I(function(n){return pu(bt(n,K))}),Vs=I(function(n){var t=Vn(n);return K(t)&&(t=a),pu(bt(n,K),x(t,2))}),Ys=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,pu(bt(n,K),a,t)}),Zs=I(Ou);function Hs(n,t){return lo(n||[],t||[],de)}function Ks(n,t){return lo(n||[],t||[],xe)}var Gs=I(function(n){var t=n.length,e=t>1?n[t-1]:a;return e=typeof e=="function"?(n.pop(),e):a,Zo(n,e)});function Ho(n){var t=i(n);return t.__chain__=!0,t}function Js(n,t){return t(n),n}function cr(n,t){return t(n)}var Qs=pt(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,u=function(o){return Xr(o,n)};return t>1||this.__actions__.length||!(r instanceof B)||!ht(e)?this.thru(u):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:cr,args:[u],thisArg:a}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(a),o}))});function Xs(){return Ho(this)}function n0(){return new Pn(this.value(),this.__chain__)}function t0(){this.__values__===a&&(this.__values__=fa(this.value()));var n=this.__index__>=this.__values__.length,t=n?a:this.__values__[this.__index__++];return{done:n,value:t}}function e0(){return this}function r0(n){for(var t,e=this;e instanceof He;){var r=No(e);r.__index__=0,r.__values__=a,t?u.__wrapped__=r:t=r;var u=r;e=e.__wrapped__}return u.__wrapped__=n,t}function u0(){var n=this.__wrapped__;if(n instanceof B){var t=n;return this.__actions__.length&&(t=new B(this)),t=t.reverse(),t.__actions__.push({func:cr,args:[Cu],thisArg:a}),new Pn(t,this.__chain__)}return this.thru(Cu)}function i0(){return co(this.__wrapped__,this.__actions__)}var o0=tr(function(n,t,e){M.call(n,e)?++n[e]:lt(n,e,1)});function a0(n,t,e){var r=E(n)?xi:Jc;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}function f0(n,t){var e=E(n)?bt:Yi;return e(n,x(t,3))}var c0=wo(Po),l0=wo(To);function s0(n,t){return an(lr(n,t),1)}function p0(n,t){return an(lr(n,t),Z)}function h0(n,t,e){return e=e===a?1:k(e),an(lr(n,t),e)}function Ko(n,t){var e=E(n)?Ln:Dt;return e(n,x(t,3))}function Go(n,t){var e=E(n)?$f:Vi;return e(n,x(t,3))}var v0=tr(function(n,t,e){M.call(n,e)?n[e].push(t):lt(n,e,[t])});function _0(n,t,e,r){n=xn(n)?n:re(n),e=e&&!r?k(e):0;var u=n.length;return e<0&&(e=Q(u+e,0)),_r(n)?e<=u&&n.indexOf(t,e)>-1:!!u&&Yt(n,t,e)>-1}var g0=I(function(n,t,e){var r=-1,u=typeof t=="function",o=xn(n)?p(n.length):[];return Dt(n,function(f){o[++r]=u?On(t,f,e):be(f,t,e)}),o}),y0=tr(function(n,t,e){lt(n,e,t)});function lr(n,t){var e=E(n)?q:Qi;return e(n,x(t,3))}function d0(n,t,e,r){return n==null?[]:(E(t)||(t=t==null?[]:[t]),e=r?a:e,E(e)||(e=e==null?[]:[e]),eo(n,t,e))}var m0=tr(function(n,t,e){n[e?0:1].push(t)},function(){return[[],[]]});function b0(n,t,e){var r=E(n)?Lr:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Dt)}function w0(n,t,e){var r=E(n)?Bf:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Vi)}function x0(n,t){var e=E(n)?bt:Yi;return e(n,hr(x(t,3)))}function j0(n){var t=E(n)?Ni:_l;return t(n)}function A0(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=k(t);var r=E(n)?Yc:gl;return r(n,t)}function D0(n){var t=E(n)?Zc:dl;return t(n)}function E0(n){if(n==null)return 0;if(xn(n))return _r(n)?Ht(n):n.length;var t=hn(n);return t==Hn||t==Jn?n.size:iu(n).length}function C0(n,t,e){var r=E(n)?Nr:ml;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}var O0=I(function(n,t){if(n==null)return[];var e=t.length;return e>1&&gn(n,t[0],t[1])?t=[]:e>2&&gn(t[0],t[1],t[2])&&(t=[t[0]]),eo(n,an(t,1),[])}),sr=fc||function(){return nn.Date.now()};function k0(n,t){if(typeof t!="function")throw new Nn(z);return n=k(n),function(){if(--n<1)return t.apply(this,arguments)}}function Jo(n,t,e){return t=e?a:t,t=n&&t==null?n.length:t,st(n,Y,a,a,a,a,t)}function Qo(n,t){var e;if(typeof t!="function")throw new Nn(z);return n=k(n),function(){return--n>0&&(e=t.apply(this,arguments)),n<=1&&(t=a),e}}var ku=I(function(n,t,e){var r=X;if(e.length){var u=xt(e,te(ku));r|=un}return st(n,r,t,e,u)}),Xo=I(function(n,t,e){var r=X|En;if(e.length){var u=xt(e,te(Xo));r|=un}return st(t,r,n,e,u)});function na(n,t,e){t=e?a:t;var r=st(n,mn,a,a,a,a,a,t);return r.placeholder=na.placeholder,r}function ta(n,t,e){t=e?a:t;var r=st(n,ot,a,a,a,a,a,t);return r.placeholder=ta.placeholder,r}function ea(n,t,e){var r,u,o,f,c,s,v=0,_=!1,g=!1,m=!0;if(typeof n!="function")throw new Nn(z);t=Yn(t)||0,V(e)&&(_=!!e.leading,g="maxWait"in e,o=g?Q(Yn(e.maxWait)||0,t):o,m="trailing"in e?!!e.trailing:m);function w(G){var tt=r,gt=u;return r=u=a,v=G,f=n.apply(gt,tt),f}function j(G){return v=G,c=De($,t),_?w(G):f}function S(G){var tt=G-s,gt=G-v,wa=t-tt;return g?pn(wa,o-gt):wa}function A(G){var tt=G-s,gt=G-v;return s===a||tt>=t||tt<0||g&&gt>=o}function $(){var G=sr();if(A(G))return F(G);c=De($,S(G))}function F(G){return c=a,m&&r?w(G):(r=u=a,f)}function $n(){c!==a&&so(c),v=0,r=s=u=c=a}function yn(){return c===a?f:F(sr())}function Bn(){var G=sr(),tt=A(G);if(r=arguments,u=this,s=G,tt){if(c===a)return j(s);if(g)return so(c),c=De($,t),w(s)}return c===a&&(c=De($,t)),f}return Bn.cancel=$n,Bn.flush=yn,Bn}var S0=I(function(n,t){return qi(n,1,t)}),I0=I(function(n,t,e){return qi(n,Yn(t)||0,e)});function $0(n){return st(n,Wn)}function pr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new Nn(z);var e=function(){var r=arguments,u=t?t.apply(this,r):r[0],o=e.cache;if(o.has(u))return o.get(u);var f=n.apply(this,r);return e.cache=o.set(u,f)||o,f};return e.cache=new(pr.Cache||ct),e}pr.Cache=ct;function hr(n){if(typeof n!="function")throw new Nn(z);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function B0(n){return Qo(2,n)}var F0=bl(function(n,t){t=t.length==1&&E(t[0])?q(t[0],kn(x())):q(an(t,1),kn(x()));var e=t.length;return I(function(r){for(var u=-1,o=pn(r.length,e);++u<o;)r[u]=t[u].call(this,r[u]);return On(n,this,r)})}),Su=I(function(n,t){var e=xt(t,te(Su));return st(n,un,a,t,e)}),ra=I(function(n,t){var e=xt(t,te(ra));return st(n,on,a,t,e)}),R0=pt(function(n,t){return st(n,Cn,a,a,a,t)});function z0(n,t){if(typeof n!="function")throw new Nn(z);return t=t===a?t:k(t),I(n,t)}function W0(n,t){if(typeof n!="function")throw new Nn(z);return t=t==null?0:Q(k(t),0),I(function(e){var r=e[t],u=Ot(e,0,t);return r&&wt(u,r),On(n,this,u)})}function U0(n,t,e){var r=!0,u=!0;if(typeof n!="function")throw new Nn(z);return V(e)&&(r="leading"in e?!!e.leading:r,u="trailing"in e?!!e.trailing:u),ea(n,t,{leading:r,maxWait:t,trailing:u})}function M0(n){return Jo(n,1)}function L0(n,t){return Su(vu(t),n)}function N0(){if(!arguments.length)return[];var n=arguments[0];return E(n)?n:[n]}function P0(n){return Tn(n,Un)}function T0(n,t){return t=typeof t=="function"?t:a,Tn(n,Un,t)}function q0(n){return Tn(n,sn|Un)}function V0(n,t){return t=typeof t=="function"?t:a,Tn(n,sn|Un,t)}function Y0(n,t){return t==null||Ti(n,t,tn(t))}function nt(n,t){return n===t||n!==n&&t!==t}var Z0=ir(eu),H0=ir(function(n,t){return n>=t}),Nt=Ki(function(){return arguments}())?Ki:function(n){return H(n)&&M.call(n,"callee")&&!Ri.call(n,"callee")},E=p.isArray,K0=gi?kn(gi):rl;function xn(n){return n!=null&&vr(n.length)&&!vt(n)}function K(n){return H(n)&&xn(n)}function G0(n){return n===!0||n===!1||H(n)&&_n(n)==$t}var kt=lc||Nu,J0=yi?kn(yi):ul;function Q0(n){return H(n)&&n.nodeType===1&&!Ee(n)}function X0(n){if(n==null)return!0;if(xn(n)&&(E(n)||typeof n=="string"||typeof n.splice=="function"||kt(n)||ee(n)||Nt(n)))return!n.length;var t=hn(n);if(t==Hn||t==Jn)return!n.size;if(Ae(n))return!iu(n).length;for(var e in n)if(M.call(n,e))return!1;return!0}function np(n,t){return we(n,t)}function tp(n,t,e){e=typeof e=="function"?e:a;var r=e?e(n,t):a;return r===a?we(n,t,a,e):!!r}function Iu(n){if(!H(n))return!1;var t=_n(n);return t==ue||t==yr||typeof n.message=="string"&&typeof n.name=="string"&&!Ee(n)}function ep(n){return typeof n=="number"&&Wi(n)}function vt(n){if(!V(n))return!1;var t=_n(n);return t==ie||t==qu||t==Tu||t==Da}function ua(n){return typeof n=="number"&&n==k(n)}function vr(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=en}function V(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function H(n){return n!=null&&typeof n=="object"}var ia=di?kn(di):ol;function rp(n,t){return n===t||uu(n,t,wu(t))}function up(n,t,e){return e=typeof e=="function"?e:a,uu(n,t,wu(t),e)}function ip(n){return oa(n)&&n!=+n}function op(n){if(Tl(n))throw new D(L);return Gi(n)}function ap(n){return n===null}function fp(n){return n==null}function oa(n){return typeof n=="number"||H(n)&&_n(n)==oe}function Ee(n){if(!H(n)||_n(n)!=at)return!1;var t=Ne(n);if(t===null)return!0;var e=M.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&We.call(e)==uc}var $u=mi?kn(mi):al;function cp(n){return ua(n)&&n>=-en&&n<=en}var aa=bi?kn(bi):fl;function _r(n){return typeof n=="string"||!E(n)&&H(n)&&_n(n)==ce}function In(n){return typeof n=="symbol"||H(n)&&_n(n)==Oe}var ee=wi?kn(wi):cl;function lp(n){return n===a}function sp(n){return H(n)&&hn(n)==le}function pp(n){return H(n)&&_n(n)==Ca}var hp=ir(ou),vp=ir(function(n,t){return n<=t});function fa(n){if(!n)return[];if(xn(n))return _r(n)?Qn(n):wn(n);if(he&&n[he])return Yf(n[he]());var t=hn(n),e=t==Hn?Zr:t==Jn?Fe:re;return e(n)}function _t(n){if(!n)return n===0?n:0;if(n=Yn(n),n===Z||n===-Z){var t=n<0?-1:1;return t*Zn}return n===n?n:0}function k(n){var t=_t(n),e=t%1;return t===t?e?t-e:t:0}function ca(n){return n?Wt(k(n),0,vn):0}function Yn(n){if(typeof n=="number")return n;if(In(n))return Kn;if(V(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=V(t)?t+"":t}if(typeof n!="string")return n===0?n:+n;n=Ci(n);var e=Ha.test(n);return e||Ga.test(n)?kf(n.slice(2),e?2:8):Za.test(n)?Kn:+n}function la(n){return rt(n,jn(n))}function _p(n){return n?Wt(k(n),-en,en):n===0?n:0}function U(n){return n==null?"":Sn(n)}var gp=Xt(function(n,t){if(Ae(t)||xn(t)){rt(t,tn(t),n);return}for(var e in t)M.call(t,e)&&de(n,e,t[e])}),sa=Xt(function(n,t){rt(t,jn(t),n)}),gr=Xt(function(n,t,e,r){rt(t,jn(t),n,r)}),yp=Xt(function(n,t,e,r){rt(t,tn(t),n,r)}),dp=pt(Xr);function mp(n,t){var e=Qt(n);return t==null?e:Pi(e,t)}var bp=I(function(n,t){n=N(n);var e=-1,r=t.length,u=r>2?t[2]:a;for(u&&gn(t[0],t[1],u)&&(r=1);++e<r;)for(var o=t[e],f=jn(o),c=-1,s=f.length;++c<s;){var v=f[c],_=n[v];(_===a||nt(_,Kt[v])&&!M.call(n,v))&&(n[v]=o[v])}return n}),wp=I(function(n){return n.push(a,Oo),On(pa,a,n)});function xp(n,t){return ji(n,x(t,3),et)}function jp(n,t){return ji(n,x(t,3),tu)}function Ap(n,t){return n==null?n:nu(n,x(t,3),jn)}function Dp(n,t){return n==null?n:Zi(n,x(t,3),jn)}function Ep(n,t){return n&&et(n,x(t,3))}function Cp(n,t){return n&&tu(n,x(t,3))}function Op(n){return n==null?[]:Je(n,tn(n))}function kp(n){return n==null?[]:Je(n,jn(n))}function Bu(n,t,e){var r=n==null?a:Ut(n,t);return r===a?e:r}function Sp(n,t){return n!=null&&Io(n,t,Xc)}function Fu(n,t){return n!=null&&Io(n,t,nl)}var Ip=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),n[t]=e},zu(An)),$p=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),M.call(n,t)?n[t].push(e):n[t]=[e]},x),Bp=I(be);function tn(n){return xn(n)?Li(n):iu(n)}function jn(n){return xn(n)?Li(n,!0):ll(n)}function Fp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,t(r,u,o),r)}),e}function Rp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,u,t(r,u,o))}),e}var zp=Xt(function(n,t,e){Qe(n,t,e)}),pa=Xt(function(n,t,e,r){Qe(n,t,e,r)}),Wp=pt(function(n,t){var e={};if(n==null)return e;var r=!1;t=q(t,function(o){return o=Ct(o,n),r||(r=o.length>1),o}),rt(n,mu(n),e),r&&(e=Tn(e,sn|dt|Un,Il));for(var u=t.length;u--;)su(e,t[u]);return e});function Up(n,t){return ha(n,hr(x(t)))}var Mp=pt(function(n,t){return n==null?{}:pl(n,t)});function ha(n,t){if(n==null)return{};var e=q(mu(n),function(r){return[r]});return t=x(t),ro(n,e,function(r,u){return t(r,u[0])})}function Lp(n,t,e){t=Ct(t,n);var r=-1,u=t.length;for(u||(u=1,n=a);++r<u;){var o=n==null?a:n[ut(t[r])];o===a&&(r=u,o=e),n=vt(o)?o.call(n):o}return n}function Np(n,t,e){return n==null?n:xe(n,t,e)}function Pp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:xe(n,t,e,r)}var va=Eo(tn),_a=Eo(jn);function Tp(n,t,e){var r=E(n),u=r||kt(n)||ee(n);if(t=x(t,4),e==null){var o=n&&n.constructor;u?e=r?new o:[]:V(n)?e=vt(o)?Qt(Ne(n)):{}:e={}}return(u?Ln:et)(n,function(f,c,s){return t(e,f,c,s)}),e}function qp(n,t){return n==null?!0:su(n,t)}function Vp(n,t,e){return n==null?n:fo(n,t,vu(e))}function Yp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:fo(n,t,vu(e),r)}function re(n){return n==null?[]:Yr(n,tn(n))}function Zp(n){return n==null?[]:Yr(n,jn(n))}function Hp(n,t,e){return e===a&&(e=t,t=a),e!==a&&(e=Yn(e),e=e===e?e:0),t!==a&&(t=Yn(t),t=t===t?t:0),Wt(Yn(n),t,e)}function Kp(n,t,e){return t=_t(t),e===a?(e=t,t=0):e=_t(e),n=Yn(n),tl(n,t,e)}function Gp(n,t,e){if(e&&typeof e!="boolean"&&gn(n,t,e)&&(t=e=a),e===a&&(typeof t=="boolean"?(e=t,t=a):typeof n=="boolean"&&(e=n,n=a)),n===a&&t===a?(n=0,t=1):(n=_t(n),t===a?(t=n,n=0):t=_t(t)),n>t){var r=n;n=t,t=r}if(e||n%1||t%1){var u=Ui();return pn(n+u*(t-n+Of("1e-"+((u+"").length-1))),t)}return fu(n,t)}var Jp=ne(function(n,t,e){return t=t.toLowerCase(),n+(e?ga(t):t)});function ga(n){return Ru(U(n).toLowerCase())}function ya(n){return n=U(n),n&&n.replace(Qa,Nf).replace(df,"")}function Qp(n,t,e){n=U(n),t=Sn(t);var r=n.length;e=e===a?r:Wt(k(e),0,r);var u=e;return e-=t.length,e>=0&&n.slice(e,u)==t}function Xp(n){return n=U(n),n&&$a.test(n)?n.replace(Zu,Pf):n}function nh(n){return n=U(n),n&&Ua.test(n)?n.replace(Sr,"\\$&"):n}var th=ne(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),eh=ne(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),rh=bo("toLowerCase");function uh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;if(!t||r>=t)return n;var u=(t-r)/2;return ur(Ve(u),e)+n+ur(qe(u),e)}function ih(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?n+ur(t-r,e):n}function oh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?ur(t-r,e)+n:n}function ah(n,t,e){return e||t==null?t=0:t&&(t=+t),vc(U(n).replace(Ir,""),t||0)}function fh(n,t,e){return(e?gn(n,t,e):t===a)?t=1:t=k(t),cu(U(n),t)}function ch(){var n=arguments,t=U(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var lh=ne(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function sh(n,t,e){return e&&typeof e!="number"&&gn(n,t,e)&&(t=e=a),e=e===a?vn:e>>>0,e?(n=U(n),n&&(typeof t=="string"||t!=null&&!$u(t))&&(t=Sn(t),!t&&Zt(n))?Ot(Qn(n),0,e):n.split(t,e)):[]}var ph=ne(function(n,t,e){return n+(e?" ":"")+Ru(t)});function hh(n,t,e){return n=U(n),e=e==null?0:Wt(k(e),0,n.length),t=Sn(t),n.slice(e,e+t.length)==t}function vh(n,t,e){var r=i.templateSettings;e&&gn(n,t,e)&&(t=a),n=U(n),t=gr({},t,r,Co);var u=gr({},t.imports,r.imports,Co),o=tn(u),f=Yr(u,o),c,s,v=0,_=t.interpolate||ke,g="__p += '",m=Hr((t.escape||ke).source+"|"+_.source+"|"+(_===Hu?Ya:ke).source+"|"+(t.evaluate||ke).source+"|$","g"),w="//# sourceURL="+(M.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++jf+"]")+`
`;n.replace(m,function(A,$,F,$n,yn,Bn){return F||(F=$n),g+=n.slice(v,Bn).replace(Xa,Tf),$&&(c=!0,g+=`' +
__e(`+$+`) +
'`),yn&&(s=!0,g+=`';
`+yn+`;
__p += '`),F&&(g+=`' +
((__t = (`+F+`)) == null ? '' : __t) +
'`),v=Bn+A.length,A}),g+=`';
`;var j=M.call(t,"variable")&&t.variable;if(!j)g=`with (obj) {
`+g+`
}
`;else if(qa.test(j))throw new D(fn);g=(s?g.replace(Oa,""):g).replace(ka,"$1").replace(Sa,"$1;"),g="function("+(j||"obj")+`) {
`+(j?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(s?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+g+`return __p
}`;var S=ma(function(){return W(o,w+"return "+g).apply(a,f)});if(S.source=g,Iu(S))throw S;return S}function _h(n){return U(n).toLowerCase()}function gh(n){return U(n).toUpperCase()}function yh(n,t,e){if(n=U(n),n&&(e||t===a))return Ci(n);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Qn(t),o=Oi(r,u),f=ki(r,u)+1;return Ot(r,o,f).join("")}function dh(n,t,e){if(n=U(n),n&&(e||t===a))return n.slice(0,Ii(n)+1);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=ki(r,Qn(t))+1;return Ot(r,0,u).join("")}function mh(n,t,e){if(n=U(n),n&&(e||t===a))return n.replace(Ir,"");if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Oi(r,Qn(t));return Ot(r,u).join("")}function bh(n,t){var e=Fn,r=It;if(V(t)){var u="separator"in t?t.separator:u;e="length"in t?k(t.length):e,r="omission"in t?Sn(t.omission):r}n=U(n);var o=n.length;if(Zt(n)){var f=Qn(n);o=f.length}if(e>=o)return n;var c=e-Ht(r);if(c<1)return r;var s=f?Ot(f,0,c).join(""):n.slice(0,c);if(u===a)return s+r;if(f&&(c+=s.length-c),$u(u)){if(n.slice(c).search(u)){var v,_=s;for(u.global||(u=Hr(u.source,U(Ku.exec(u))+"g")),u.lastIndex=0;v=u.exec(_);)var g=v.index;s=s.slice(0,g===a?c:g)}}else if(n.indexOf(Sn(u),c)!=c){var m=s.lastIndexOf(u);m>-1&&(s=s.slice(0,m))}return s+r}function wh(n){return n=U(n),n&&Ia.test(n)?n.replace(Yu,Gf):n}var xh=ne(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Ru=bo("toUpperCase");function da(n,t,e){return n=U(n),t=e?a:t,t===a?Vf(n)?Xf(n):zf(n):n.match(t)||[]}var ma=I(function(n,t){try{return On(n,a,t)}catch(e){return Iu(e)?e:new D(e)}}),jh=pt(function(n,t){return Ln(t,function(e){e=ut(e),lt(n,e,ku(n[e],n))}),n});function Ah(n){var t=n==null?0:n.length,e=x();return n=t?q(n,function(r){if(typeof r[1]!="function")throw new Nn(z);return[e(r[0]),r[1]]}):[],I(function(r){for(var u=-1;++u<t;){var o=n[u];if(On(o[0],this,r))return On(o[1],this,r)}})}function Dh(n){return Gc(Tn(n,sn))}function zu(n){return function(){return n}}function Eh(n,t){return n==null||n!==n?t:n}var Ch=xo(),Oh=xo(!0);function An(n){return n}function Wu(n){return Ji(typeof n=="function"?n:Tn(n,sn))}function kh(n){return Xi(Tn(n,sn))}function Sh(n,t){return no(n,Tn(t,sn))}var Ih=I(function(n,t){return function(e){return be(e,n,t)}}),$h=I(function(n,t){return function(e){return be(n,e,t)}});function Uu(n,t,e){var r=tn(t),u=Je(t,r);e==null&&!(V(t)&&(u.length||!r.length))&&(e=t,t=n,n=this,u=Je(t,tn(t)));var o=!(V(e)&&"chain"in e)||!!e.chain,f=vt(n);return Ln(u,function(c){var s=t[c];n[c]=s,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),g=_.__actions__=wn(this.__actions__);return g.push({func:s,args:arguments,thisArg:n}),_.__chain__=v,_}return s.apply(n,wt([this.value()],arguments))})}),n}function Bh(){return nn._===this&&(nn._=ic),this}function Mu(){}function Fh(n){return n=k(n),I(function(t){return to(t,n)})}var Rh=gu(q),zh=gu(xi),Wh=gu(Nr);function ba(n){return ju(n)?Pr(ut(n)):hl(n)}function Uh(n){return function(t){return n==null?a:Ut(n,t)}}var Mh=Ao(),Lh=Ao(!0);function Lu(){return[]}function Nu(){return!1}function Nh(){return{}}function Ph(){return""}function Th(){return!0}function qh(n,t){if(n=k(n),n<1||n>en)return[];var e=vn,r=pn(n,vn);t=x(t),n-=vn;for(var u=Vr(r,t);++e<n;)t(e);return u}function Vh(n){return E(n)?q(n,ut):In(n)?[n]:wn(Lo(U(n)))}function Yh(n){var t=++rc;return U(n)+t}var Zh=rr(function(n,t){return n+t},0),Hh=yu("ceil"),Kh=rr(function(n,t){return n/t},1),Gh=yu("floor");function Jh(n){return n&&n.length?Ge(n,An,eu):a}function Qh(n,t){return n&&n.length?Ge(n,x(t,2),eu):a}function Xh(n){return Di(n,An)}function nv(n,t){return Di(n,x(t,2))}function tv(n){return n&&n.length?Ge(n,An,ou):a}function ev(n,t){return n&&n.length?Ge(n,x(t,2),ou):a}var rv=rr(function(n,t){return n*t},1),uv=yu("round"),iv=rr(function(n,t){return n-t},0);function ov(n){return n&&n.length?qr(n,An):0}function av(n,t){return n&&n.length?qr(n,x(t,2)):0}return i.after=k0,i.ary=Jo,i.assign=gp,i.assignIn=sa,i.assignInWith=gr,i.assignWith=yp,i.at=dp,i.before=Qo,i.bind=ku,i.bindAll=jh,i.bindKey=Xo,i.castArray=N0,i.chain=Ho,i.chunk=Gl,i.compact=Jl,i.concat=Ql,i.cond=Ah,i.conforms=Dh,i.constant=zu,i.countBy=o0,i.create=mp,i.curry=na,i.curryRight=ta,i.debounce=ea,i.defaults=bp,i.defaultsDeep=wp,i.defer=S0,i.delay=I0,i.difference=Xl,i.differenceBy=ns,i.differenceWith=ts,i.drop=es,i.dropRight=rs,i.dropRightWhile=us,i.dropWhile=is,i.fill=os,i.filter=f0,i.flatMap=s0,i.flatMapDeep=p0,i.flatMapDepth=h0,i.flatten=qo,i.flattenDeep=as,i.flattenDepth=fs,i.flip=$0,i.flow=Ch,i.flowRight=Oh,i.fromPairs=cs,i.functions=Op,i.functionsIn=kp,i.groupBy=v0,i.initial=ss,i.intersection=ps,i.intersectionBy=hs,i.intersectionWith=vs,i.invert=Ip,i.invertBy=$p,i.invokeMap=g0,i.iteratee=Wu,i.keyBy=y0,i.keys=tn,i.keysIn=jn,i.map=lr,i.mapKeys=Fp,i.mapValues=Rp,i.matches=kh,i.matchesProperty=Sh,i.memoize=pr,i.merge=zp,i.mergeWith=pa,i.method=Ih,i.methodOf=$h,i.mixin=Uu,i.negate=hr,i.nthArg=Fh,i.omit=Wp,i.omitBy=Up,i.once=B0,i.orderBy=d0,i.over=Rh,i.overArgs=F0,i.overEvery=zh,i.overSome=Wh,i.partial=Su,i.partialRight=ra,i.partition=m0,i.pick=Mp,i.pickBy=ha,i.property=ba,i.propertyOf=Uh,i.pull=ds,i.pullAll=Yo,i.pullAllBy=ms,i.pullAllWith=bs,i.pullAt=ws,i.range=Mh,i.rangeRight=Lh,i.rearg=R0,i.reject=x0,i.remove=xs,i.rest=z0,i.reverse=Cu,i.sampleSize=A0,i.set=Np,i.setWith=Pp,i.shuffle=D0,i.slice=js,i.sortBy=O0,i.sortedUniq=Ss,i.sortedUniqBy=Is,i.split=sh,i.spread=W0,i.tail=$s,i.take=Bs,i.takeRight=Fs,i.takeRightWhile=Rs,i.takeWhile=zs,i.tap=Js,i.throttle=U0,i.thru=cr,i.toArray=fa,i.toPairs=va,i.toPairsIn=_a,i.toPath=Vh,i.toPlainObject=la,i.transform=Tp,i.unary=M0,i.union=Ws,i.unionBy=Us,i.unionWith=Ms,i.uniq=Ls,i.uniqBy=Ns,i.uniqWith=Ps,i.unset=qp,i.unzip=Ou,i.unzipWith=Zo,i.update=Vp,i.updateWith=Yp,i.values=re,i.valuesIn=Zp,i.without=Ts,i.words=da,i.wrap=L0,i.xor=qs,i.xorBy=Vs,i.xorWith=Ys,i.zip=Zs,i.zipObject=Hs,i.zipObjectDeep=Ks,i.zipWith=Gs,i.entries=va,i.entriesIn=_a,i.extend=sa,i.extendWith=gr,Uu(i,i),i.add=Zh,i.attempt=ma,i.camelCase=Jp,i.capitalize=ga,i.ceil=Hh,i.clamp=Hp,i.clone=P0,i.cloneDeep=q0,i.cloneDeepWith=V0,i.cloneWith=T0,i.conformsTo=Y0,i.deburr=ya,i.defaultTo=Eh,i.divide=Kh,i.endsWith=Qp,i.eq=nt,i.escape=Xp,i.escapeRegExp=nh,i.every=a0,i.find=c0,i.findIndex=Po,i.findKey=xp,i.findLast=l0,i.findLastIndex=To,i.findLastKey=jp,i.floor=Gh,i.forEach=Ko,i.forEachRight=Go,i.forIn=Ap,i.forInRight=Dp,i.forOwn=Ep,i.forOwnRight=Cp,i.get=Bu,i.gt=Z0,i.gte=H0,i.has=Sp,i.hasIn=Fu,i.head=Vo,i.identity=An,i.includes=_0,i.indexOf=ls,i.inRange=Kp,i.invoke=Bp,i.isArguments=Nt,i.isArray=E,i.isArrayBuffer=K0,i.isArrayLike=xn,i.isArrayLikeObject=K,i.isBoolean=G0,i.isBuffer=kt,i.isDate=J0,i.isElement=Q0,i.isEmpty=X0,i.isEqual=np,i.isEqualWith=tp,i.isError=Iu,i.isFinite=ep,i.isFunction=vt,i.isInteger=ua,i.isLength=vr,i.isMap=ia,i.isMatch=rp,i.isMatchWith=up,i.isNaN=ip,i.isNative=op,i.isNil=fp,i.isNull=ap,i.isNumber=oa,i.isObject=V,i.isObjectLike=H,i.isPlainObject=Ee,i.isRegExp=$u,i.isSafeInteger=cp,i.isSet=aa,i.isString=_r,i.isSymbol=In,i.isTypedArray=ee,i.isUndefined=lp,i.isWeakMap=sp,i.isWeakSet=pp,i.join=_s,i.kebabCase=th,i.last=Vn,i.lastIndexOf=gs,i.lowerCase=eh,i.lowerFirst=rh,i.lt=hp,i.lte=vp,i.max=Jh,i.maxBy=Qh,i.mean=Xh,i.meanBy=nv,i.min=tv,i.minBy=ev,i.stubArray=Lu,i.stubFalse=Nu,i.stubObject=Nh,i.stubString=Ph,i.stubTrue=Th,i.multiply=rv,i.nth=ys,i.noConflict=Bh,i.noop=Mu,i.now=sr,i.pad=uh,i.padEnd=ih,i.padStart=oh,i.parseInt=ah,i.random=Gp,i.reduce=b0,i.reduceRight=w0,i.repeat=fh,i.replace=ch,i.result=Lp,i.round=uv,i.runInContext=l,i.sample=j0,i.size=E0,i.snakeCase=lh,i.some=C0,i.sortedIndex=As,i.sortedIndexBy=Ds,i.sortedIndexOf=Es,i.sortedLastIndex=Cs,i.sortedLastIndexBy=Os,i.sortedLastIndexOf=ks,i.startCase=ph,i.startsWith=hh,i.subtract=iv,i.sum=ov,i.sumBy=av,i.template=vh,i.times=qh,i.toFinite=_t,i.toInteger=k,i.toLength=ca,i.toLower=_h,i.toNumber=Yn,i.toSafeInteger=_p,i.toString=U,i.toUpper=gh,i.trim=yh,i.trimEnd=dh,i.trimStart=mh,i.truncate=bh,i.unescape=wh,i.uniqueId=Yh,i.upperCase=xh,i.upperFirst=Ru,i.each=Ko,i.eachRight=Go,i.first=Vo,Uu(i,function(){var n={};return et(i,function(t,e){M.call(i.prototype,e)||(n[e]=t)}),n}(),{chain:!1}),i.VERSION=O,Ln(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){i[n].placeholder=i}),Ln(["drop","take"],function(n,t){B.prototype[n]=function(e){e=e===a?1:Q(k(e),0);var r=this.__filtered__&&!t?new B(this):this.clone();return r.__filtered__?r.__takeCount__=pn(e,r.__takeCount__):r.__views__.push({size:pn(e,vn),type:n+(r.__dir__<0?"Right":"")}),r},B.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()}}),Ln(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==cn||e==Gn;B.prototype[n]=function(u){var o=this.clone();return o.__iteratees__.push({iteratee:x(u,3),type:e}),o.__filtered__=o.__filtered__||r,o}}),Ln(["head","last"],function(n,t){var e="take"+(t?"Right":"");B.prototype[n]=function(){return this[e](1).value()[0]}}),Ln(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");B.prototype[n]=function(){return this.__filtered__?new B(this):this[e](1)}}),B.prototype.compact=function(){return this.filter(An)},B.prototype.find=function(n){return this.filter(n).head()},B.prototype.findLast=function(n){return this.reverse().find(n)},B.prototype.invokeMap=I(function(n,t){return typeof n=="function"?new B(this):this.map(function(e){return be(e,n,t)})}),B.prototype.reject=function(n){return this.filter(hr(x(n)))},B.prototype.slice=function(n,t){n=k(n);var e=this;return e.__filtered__&&(n>0||t<0)?new B(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==a&&(t=k(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},B.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},B.prototype.toArray=function(){return this.take(vn)},et(B.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),u=i[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);!u||(i.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,s=f instanceof B,v=c[0],_=s||E(f),g=function($){var F=u.apply(i,wt([$],c));return r&&m?F[0]:F};_&&e&&typeof v=="function"&&v.length!=1&&(s=_=!1);var m=this.__chain__,w=!!this.__actions__.length,j=o&&!m,S=s&&!w;if(!o&&_){f=S?f:new B(this);var A=n.apply(f,c);return A.__actions__.push({func:cr,args:[g],thisArg:a}),new Pn(A,m)}return j&&S?n.apply(this,c):(A=this.thru(g),j?r?A.value()[0]:A.value():A)})}),Ln(["pop","push","shift","sort","splice","unshift"],function(n){var t=Re[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);i.prototype[n]=function(){var u=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(E(o)?o:[],u)}return this[e](function(f){return t.apply(E(f)?f:[],u)})}}),et(B.prototype,function(n,t){var e=i[t];if(e){var r=e.name+"";M.call(Jt,r)||(Jt[r]=[]),Jt[r].push({name:t,func:e})}}),Jt[er(a,En).name]=[{name:"wrapper",func:a}],B.prototype.clone=wc,B.prototype.reverse=xc,B.prototype.value=jc,i.prototype.at=Qs,i.prototype.chain=Xs,i.prototype.commit=n0,i.prototype.next=t0,i.prototype.plant=r0,i.prototype.reverse=u0,i.prototype.toJSON=i.prototype.valueOf=i.prototype.value=i0,i.prototype.first=i.prototype.head,he&&(i.prototype[he]=e0),i},jt=nc();typeof define=="function"&&typeof __webpack_require__("3c35")=="object"&&__webpack_require__("3c35")?(nn._=jt,define(function(){return jt})):Bt?((Bt.exports=jt)._=jt,Wr._=jt):nn._=jt}).call(y)}),Eg=Iv($v());var Cg=Iv($v());var Og=Iv($v());var k_=Object.create,bv=Object.defineProperty,S_=Object.defineProperties,I_=Object.getOwnPropertyDescriptor,$_=Object.getOwnPropertyDescriptors,B_=Object.getOwnPropertyNames,wv=Object.getOwnPropertySymbols,F_=Object.getPrototypeOf,Bv=Object.prototype.hasOwnProperty,Zv=Object.prototype.propertyIsEnumerable,Hv=(y,d,a)=>d in y?bv(y,d,{enumerable:!0,configurable:!0,writable:!0,value:a}):y[d]=a,hv=(y,d)=>{for(var a in d||(d={}))Bv.call(d,a)&&Hv(y,a,d[a]);if(wv)for(var a of wv(d))Zv.call(d,a)&&Hv(y,a,d[a]);return y},R_=(y,d)=>S_(y,$_(d)),z_=y=>bv(y,"__esModule",{value:!0}),W_=(y,d)=>{var a={};for(var O in y)Bv.call(y,O)&&d.indexOf(O)<0&&(a[O]=y[O]);if(y!=null&&wv)for(var O of wv(y))d.indexOf(O)<0&&Zv.call(y,O)&&(a[O]=y[O]);return a},U_=(y,d)=>()=>(d||y((d={exports:{}}).exports,d),d.exports),M_=(y,d,a)=>{if(d&&typeof d=="object"||typeof d=="function")for(let O of B_(d))!Bv.call(y,O)&&O!=="default"&&bv(y,O,{get:()=>d[O],enumerable:!(a=I_(d,O))||a.enumerable});return y},Kv=y=>M_(z_(bv(y!=null?k_(F_(y)):{},"default",y&&y.__esModule&&"default"in y?{get:()=>y.default,enumerable:!0}:{value:y,enumerable:!0})),y),Gv=U_((y,d)=>{(function(){var a,O="4.17.21",R=200,L="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",z="Expected a function",fn="Invalid `variable` option passed into `_.template`",dn="__lodash_hash_undefined__",rn=500,Dn="__lodash_placeholder__",sn=1,dt=2,Un=4,Rn=1,bn=2,X=1,En=2,St=4,mn=8,ot=16,un=32,on=64,Y=128,Cn=256,Wn=512,Fn=30,It="...",Pt=800,zn=16,cn=1,ln=2,Gn=3,Z=1/0,en=9007199254740991,Zn=17976931348623157e292,Kn=0/0,vn=4294967295,Tt=vn-1,Ce=vn>>>1,mr=[["ary",Y],["bind",X],["bindKey",En],["curry",mn],["curryRight",ot],["flip",Wn],["partial",un],["partialRight",on],["rearg",Cn]],mt="[object Arguments]",ae="[object Array]",Tu="[object AsyncFunction]",$t="[object Boolean]",yt="[object Date]",yr="[object DOMException]",ue="[object Error]",ie="[object Function]",qu="[object GeneratorFunction]",Hn="[object Map]",oe="[object Number]",xa="[object Null]",at="[object Object]",Vu="[object Promise]",Da="[object Proxy]",fe="[object RegExp]",Jn="[object Set]",ce="[object String]",Oe="[object Symbol]",Ea="[object Undefined]",le="[object WeakMap]",Ca="[object WeakSet]",se="[object ArrayBuffer]",qt="[object DataView]",wr="[object Float32Array]",xr="[object Float64Array]",jr="[object Int8Array]",Ar="[object Int16Array]",Dr="[object Int32Array]",Er="[object Uint8Array]",Cr="[object Uint8ClampedArray]",Or="[object Uint16Array]",kr="[object Uint32Array]",Oa=/\b__p \+= '';/g,ka=/\b(__p \+=) '' \+/g,Sa=/(__e\(.*?\)|\b__t\)) \+\n'';/g,Yu=/&(?:amp|lt|gt|quot|#39);/g,Zu=/[&<>"']/g,Ia=RegExp(Yu.source),$a=RegExp(Zu.source),Ba=/<%-([\s\S]+?)%>/g,Fa=/<%([\s\S]+?)%>/g,Hu=/<%=([\s\S]+?)%>/g,Ra=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,za=/^\w*$/,Wa=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Sr=/[\\^$.*+?()[\]{}|]/g,Ua=RegExp(Sr.source),Ir=/^\s+/,Ma=/\s/,La=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Na=/\{\n\/\* \[wrapped with (.+)\] \*/,Pa=/,? & /,Ta=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,qa=/[()=,{}\[\]\/\s]/,Va=/\\(\\)?/g,Ya=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Ku=/\w*$/,Za=/^[-+]0x[0-9a-f]+$/i,Ha=/^0b[01]+$/i,Ka=/^\[object .+?Constructor\]$/,Ga=/^0o[0-7]+$/i,Ja=/^(?:0|[1-9]\d*)$/,Qa=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,ke=/($^)/,Xa=/['\n\r\u2028\u2029\\]/g,Se="\\ud800-\\udfff",nf="\\u0300-\\u036f",tf="\\ufe20-\\ufe2f",ef="\\u20d0-\\u20ff",Gu=nf+tf+ef,Ju="\\u2700-\\u27bf",Qu="a-z\\xdf-\\xf6\\xf8-\\xff",rf="\\xac\\xb1\\xd7\\xf7",uf="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",of="\\u2000-\\u206f",af=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Xu="A-Z\\xc0-\\xd6\\xd8-\\xde",ni="\\ufe0e\\ufe0f",ti=rf+uf+of+af,$r="['\u2019]",ff="["+Se+"]",ei="["+ti+"]",Ie="["+Gu+"]",ri="\\d+",cf="["+Ju+"]",ui="["+Qu+"]",ii="[^"+Se+ti+ri+Ju+Qu+Xu+"]",Br="\\ud83c[\\udffb-\\udfff]",lf="(?:"+Ie+"|"+Br+")",oi="[^"+Se+"]",Fr="(?:\\ud83c[\\udde6-\\uddff]){2}",Rr="[\\ud800-\\udbff][\\udc00-\\udfff]",Vt="["+Xu+"]",ai="\\u200d",fi="(?:"+ui+"|"+ii+")",sf="(?:"+Vt+"|"+ii+")",ci="(?:"+$r+"(?:d|ll|m|re|s|t|ve))?",li="(?:"+$r+"(?:D|LL|M|RE|S|T|VE))?",si=lf+"?",pi="["+ni+"]?",pf="(?:"+ai+"(?:"+[oi,Fr,Rr].join("|")+")"+pi+si+")*",hf="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",vf="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",hi=pi+si+pf,_f="(?:"+[cf,Fr,Rr].join("|")+")"+hi,gf="(?:"+[oi+Ie+"?",Ie,Fr,Rr,ff].join("|")+")",yf=RegExp($r,"g"),df=RegExp(Ie,"g"),zr=RegExp(Br+"(?="+Br+")|"+gf+hi,"g"),mf=RegExp([Vt+"?"+ui+"+"+ci+"(?="+[ei,Vt,"$"].join("|")+")",sf+"+"+li+"(?="+[ei,Vt+fi,"$"].join("|")+")",Vt+"?"+fi+"+"+ci,Vt+"+"+li,vf,hf,ri,_f].join("|"),"g"),bf=RegExp("["+ai+Se+Gu+ni+"]"),wf=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,xf=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],jf=-1,T={};T[wr]=T[xr]=T[jr]=T[Ar]=T[Dr]=T[Er]=T[Cr]=T[Or]=T[kr]=!0,T[mt]=T[ae]=T[se]=T[$t]=T[qt]=T[yt]=T[ue]=T[ie]=T[Hn]=T[oe]=T[at]=T[fe]=T[Jn]=T[ce]=T[le]=!1;var P={};P[mt]=P[ae]=P[se]=P[qt]=P[$t]=P[yt]=P[wr]=P[xr]=P[jr]=P[Ar]=P[Dr]=P[Hn]=P[oe]=P[at]=P[fe]=P[Jn]=P[ce]=P[Oe]=P[Er]=P[Cr]=P[Or]=P[kr]=!0,P[ue]=P[ie]=P[le]=!1;var Af={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},Df={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Ef={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Cf={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Of=parseFloat,kf=parseInt,vi=typeof global=="object"&&global&&global.Object===Object&&global,Sf=typeof self=="object"&&self&&self.Object===Object&&self,nn=vi||Sf||Function("return this")(),Wr=typeof y=="object"&&y&&!y.nodeType&&y,Bt=Wr&&typeof d=="object"&&d&&!d.nodeType&&d,_i=Bt&&Bt.exports===Wr,Ur=_i&&vi.process,Mn=function(){try{var l=Bt&&Bt.require&&Bt.require("util").types;return l||Ur&&Ur.binding&&Ur.binding("util")}catch(h){}}(),gi=Mn&&Mn.isArrayBuffer,yi=Mn&&Mn.isDate,di=Mn&&Mn.isMap,mi=Mn&&Mn.isRegExp,bi=Mn&&Mn.isSet,wi=Mn&&Mn.isTypedArray;function On(l,h,p){switch(p.length){case 0:return l.call(h);case 1:return l.call(h,p[0]);case 2:return l.call(h,p[0],p[1]);case 3:return l.call(h,p[0],p[1],p[2])}return l.apply(h,p)}function If(l,h,p,b){for(var D=-1,W=l==null?0:l.length;++D<W;){var J=l[D];h(b,J,p(J),l)}return b}function Ln(l,h){for(var p=-1,b=l==null?0:l.length;++p<b&&h(l[p],p,l)!==!1;);return l}function $f(l,h){for(var p=l==null?0:l.length;p--&&h(l[p],p,l)!==!1;);return l}function xi(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(!h(l[p],p,l))return!1;return!0}function bt(l,h){for(var p=-1,b=l==null?0:l.length,D=0,W=[];++p<b;){var J=l[p];h(J,p,l)&&(W[D++]=J)}return W}function $e(l,h){var p=l==null?0:l.length;return!!p&&Yt(l,h,0)>-1}function Mr(l,h,p){for(var b=-1,D=l==null?0:l.length;++b<D;)if(p(h,l[b]))return!0;return!1}function q(l,h){for(var p=-1,b=l==null?0:l.length,D=Array(b);++p<b;)D[p]=h(l[p],p,l);return D}function wt(l,h){for(var p=-1,b=h.length,D=l.length;++p<b;)l[D+p]=h[p];return l}function Lr(l,h,p,b){var D=-1,W=l==null?0:l.length;for(b&&W&&(p=l[++D]);++D<W;)p=h(p,l[D],D,l);return p}function Bf(l,h,p,b){var D=l==null?0:l.length;for(b&&D&&(p=l[--D]);D--;)p=h(p,l[D],D,l);return p}function Nr(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(h(l[p],p,l))return!0;return!1}var Ff=Pr("length");function Rf(l){return l.split("")}function zf(l){return l.match(Ta)||[]}function ji(l,h,p){var b;return p(l,function(D,W,J){if(h(D,W,J))return b=W,!1}),b}function Be(l,h,p,b){for(var D=l.length,W=p+(b?1:-1);b?W--:++W<D;)if(h(l[W],W,l))return W;return-1}function Yt(l,h,p){return h===h?Hf(l,h,p):Be(l,Ai,p)}function Wf(l,h,p,b){for(var D=p-1,W=l.length;++D<W;)if(b(l[D],h))return D;return-1}function Ai(l){return l!==l}function Di(l,h){var p=l==null?0:l.length;return p?qr(l,h)/p:Kn}function Pr(l){return function(h){return h==null?a:h[l]}}function Tr(l){return function(h){return l==null?a:l[h]}}function Ei(l,h,p,b,D){return D(l,function(W,J,N){p=b?(b=!1,W):h(p,W,J,N)}),p}function Uf(l,h){var p=l.length;for(l.sort(h);p--;)l[p]=l[p].value;return l}function qr(l,h){for(var p,b=-1,D=l.length;++b<D;){var W=h(l[b]);W!==a&&(p=p===a?W:p+W)}return p}function Vr(l,h){for(var p=-1,b=Array(l);++p<l;)b[p]=h(p);return b}function Mf(l,h){return q(h,function(p){return[p,l[p]]})}function Ci(l){return l&&l.slice(0,Ii(l)+1).replace(Ir,"")}function kn(l){return function(h){return l(h)}}function Yr(l,h){return q(h,function(p){return l[p]})}function pe(l,h){return l.has(h)}function Oi(l,h){for(var p=-1,b=l.length;++p<b&&Yt(h,l[p],0)>-1;);return p}function ki(l,h){for(var p=l.length;p--&&Yt(h,l[p],0)>-1;);return p}function Lf(l,h){for(var p=l.length,b=0;p--;)l[p]===h&&++b;return b}var Nf=Tr(Af),Pf=Tr(Df);function Tf(l){return"\\"+Cf[l]}function qf(l,h){return l==null?a:l[h]}function Zt(l){return bf.test(l)}function Vf(l){return wf.test(l)}function Yf(l){for(var h,p=[];!(h=l.next()).done;)p.push(h.value);return p}function Zr(l){var h=-1,p=Array(l.size);return l.forEach(function(b,D){p[++h]=[D,b]}),p}function Si(l,h){return function(p){return l(h(p))}}function xt(l,h){for(var p=-1,b=l.length,D=0,W=[];++p<b;){var J=l[p];(J===h||J===Dn)&&(l[p]=Dn,W[D++]=p)}return W}function Fe(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=b}),p}function Zf(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=[b,b]}),p}function Hf(l,h,p){for(var b=p-1,D=l.length;++b<D;)if(l[b]===h)return b;return-1}function Kf(l,h,p){for(var b=p+1;b--;)if(l[b]===h)return b;return b}function Ht(l){return Zt(l)?Jf(l):Ff(l)}function Qn(l){return Zt(l)?Qf(l):Rf(l)}function Ii(l){for(var h=l.length;h--&&Ma.test(l.charAt(h)););return h}var Gf=Tr(Ef);function Jf(l){for(var h=zr.lastIndex=0;zr.test(l);)++h;return h}function Qf(l){return l.match(zr)||[]}function Xf(l){return l.match(mf)||[]}var nc=function l(h){h=h==null?nn:jt.defaults(nn.Object(),h,jt.pick(nn,xf));var p=h.Array,b=h.Date,D=h.Error,W=h.Function,J=h.Math,N=h.Object,Hr=h.RegExp,tc=h.String,Nn=h.TypeError,Re=p.prototype,ec=W.prototype,Kt=N.prototype,ze=h["__core-js_shared__"],We=ec.toString,M=Kt.hasOwnProperty,rc=0,$i=function(){var n=/[^.]+$/.exec(ze&&ze.keys&&ze.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Ue=Kt.toString,uc=We.call(N),ic=nn._,oc=Hr("^"+We.call(M).replace(Sr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Me=_i?h.Buffer:a,At=h.Symbol,Le=h.Uint8Array,Bi=Me?Me.allocUnsafe:a,Ne=Si(N.getPrototypeOf,N),Fi=N.create,Ri=Kt.propertyIsEnumerable,Pe=Re.splice,zi=At?At.isConcatSpreadable:a,he=At?At.iterator:a,Ft=At?At.toStringTag:a,Te=function(){try{var n=Mt(N,"defineProperty");return n({},"",{}),n}catch(t){}}(),ac=h.clearTimeout!==nn.clearTimeout&&h.clearTimeout,fc=b&&b.now!==nn.Date.now&&b.now,cc=h.setTimeout!==nn.setTimeout&&h.setTimeout,qe=J.ceil,Ve=J.floor,Kr=N.getOwnPropertySymbols,lc=Me?Me.isBuffer:a,Wi=h.isFinite,sc=Re.join,pc=Si(N.keys,N),Q=J.max,pn=J.min,hc=b.now,vc=h.parseInt,Ui=J.random,_c=Re.reverse,Gr=Mt(h,"DataView"),ve=Mt(h,"Map"),Jr=Mt(h,"Promise"),Gt=Mt(h,"Set"),_e=Mt(h,"WeakMap"),ge=Mt(N,"create"),Ye=_e&&new _e,Jt={},gc=Lt(Gr),yc=Lt(ve),dc=Lt(Jr),mc=Lt(Gt),bc=Lt(_e),Ze=At?At.prototype:a,ye=Ze?Ze.valueOf:a,Mi=Ze?Ze.toString:a;function i(n){if(H(n)&&!E(n)&&!(n instanceof B)){if(n instanceof Pn)return n;if(M.call(n,"__wrapped__"))return No(n)}return new Pn(n)}var Qt=function(){function n(){}return function(t){if(!V(t))return{};if(Fi)return Fi(t);n.prototype=t;var e=new n;return n.prototype=a,e}}();function He(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=a}i.templateSettings={escape:Ba,evaluate:Fa,interpolate:Hu,variable:"",imports:{_:i}},i.prototype=He.prototype,i.prototype.constructor=i,Pn.prototype=Qt(He.prototype),Pn.prototype.constructor=Pn;function B(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=vn,this.__views__=[]}function wc(){var n=new B(this.__wrapped__);return n.__actions__=wn(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=wn(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=wn(this.__views__),n}function xc(){if(this.__filtered__){var n=new B(this);n.__dir__=-1,n.__filtered__=!0}else n=this.clone(),n.__dir__*=-1;return n}function jc(){var n=this.__wrapped__.value(),t=this.__dir__,e=E(n),r=t<0,u=e?n.length:0,o=Rl(0,u,this.__views__),f=o.start,c=o.end,s=c-f,v=r?c:f-1,_=this.__iteratees__,g=_.length,m=0,w=pn(s,this.__takeCount__);if(!e||!r&&u==s&&w==s)return co(n,this.__actions__);var j=[];n:for(;s--&&m<w;){v+=t;for(var S=-1,A=n[v];++S<g;){var $=_[S],F=$.iteratee,$n=$.type,yn=F(A);if($n==ln)A=yn;else if(!yn){if($n==cn)continue n;break n}}j[m++]=A}return j}B.prototype=Qt(He.prototype),B.prototype.constructor=B;function Rt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Ac(){this.__data__=ge?ge(null):{},this.size=0}function Dc(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Ec(n){var t=this.__data__;if(ge){var e=t[n];return e===dn?a:e}return M.call(t,n)?t[n]:a}function Cc(n){var t=this.__data__;return ge?t[n]!==a:M.call(t,n)}function Oc(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=ge&&t===a?dn:t,this}Rt.prototype.clear=Ac,Rt.prototype.delete=Dc,Rt.prototype.get=Ec,Rt.prototype.has=Cc,Rt.prototype.set=Oc;function ft(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function kc(){this.__data__=[],this.size=0}function Sc(n){var t=this.__data__,e=Ke(t,n);if(e<0)return!1;var r=t.length-1;return e==r?t.pop():Pe.call(t,e,1),--this.size,!0}function Ic(n){var t=this.__data__,e=Ke(t,n);return e<0?a:t[e][1]}function $c(n){return Ke(this.__data__,n)>-1}function Bc(n,t){var e=this.__data__,r=Ke(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}ft.prototype.clear=kc,ft.prototype.delete=Sc,ft.prototype.get=Ic,ft.prototype.has=$c,ft.prototype.set=Bc;function ct(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Fc(){this.size=0,this.__data__={hash:new Rt,map:new(ve||ft),string:new Rt}}function Rc(n){var t=ar(this,n).delete(n);return this.size-=t?1:0,t}function zc(n){return ar(this,n).get(n)}function Wc(n){return ar(this,n).has(n)}function Uc(n,t){var e=ar(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}ct.prototype.clear=Fc,ct.prototype.delete=Rc,ct.prototype.get=zc,ct.prototype.has=Wc,ct.prototype.set=Uc;function zt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new ct;++t<e;)this.add(n[t])}function Mc(n){return this.__data__.set(n,dn),this}function Lc(n){return this.__data__.has(n)}zt.prototype.add=zt.prototype.push=Mc,zt.prototype.has=Lc;function Xn(n){var t=this.__data__=new ft(n);this.size=t.size}function Nc(){this.__data__=new ft,this.size=0}function Pc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function Tc(n){return this.__data__.get(n)}function qc(n){return this.__data__.has(n)}function Vc(n,t){var e=this.__data__;if(e instanceof ft){var r=e.__data__;if(!ve||r.length<R-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new ct(r)}return e.set(n,t),this.size=e.size,this}Xn.prototype.clear=Nc,Xn.prototype.delete=Pc,Xn.prototype.get=Tc,Xn.prototype.has=qc,Xn.prototype.set=Vc;function Li(n,t){var e=E(n),r=!e&&Nt(n),u=!e&&!r&&kt(n),o=!e&&!r&&!u&&ee(n),f=e||r||u||o,c=f?Vr(n.length,tc):[],s=c.length;for(var v in n)(t||M.call(n,v))&&!(f&&(v=="length"||u&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||ht(v,s)))&&c.push(v);return c}function Ni(n){var t=n.length;return t?n[fu(0,t-1)]:a}function Yc(n,t){return fr(wn(n),Wt(t,0,n.length))}function Zc(n){return fr(wn(n))}function Qr(n,t,e){(e!==a&&!nt(n[t],e)||e===a&&!(t in n))&&lt(n,t,e)}function de(n,t,e){var r=n[t];(!(M.call(n,t)&&nt(r,e))||e===a&&!(t in n))&&lt(n,t,e)}function Ke(n,t){for(var e=n.length;e--;)if(nt(n[e][0],t))return e;return-1}function Hc(n,t,e,r){return Dt(n,function(u,o,f){t(r,u,e(u),f)}),r}function Pi(n,t){return n&&rt(t,tn(t),n)}function Kc(n,t){return n&&rt(t,jn(t),n)}function lt(n,t,e){t=="__proto__"&&Te?Te(n,t,{configurable:!0,enumerable:!0,value:e,writable:!0}):n[t]=e}function Xr(n,t){for(var e=-1,r=t.length,u=p(r),o=n==null;++e<r;)u[e]=o?a:Bu(n,t[e]);return u}function Wt(n,t,e){return n===n&&(e!==a&&(n=n<=e?n:e),t!==a&&(n=n>=t?n:t)),n}function Tn(n,t,e,r,u,o){var f,c=t&sn,s=t&dt,v=t&Un;if(e&&(f=u?e(n,r,u,o):e(n)),f!==a)return f;if(!V(n))return n;var _=E(n);if(_){if(f=Wl(n),!c)return wn(n,f)}else{var g=hn(n),m=g==ie||g==qu;if(kt(n))return po(n,c);if(g==at||g==mt||m&&!u){if(f=s||m?{}:$o(n),!c)return s?El(n,Kc(f,n)):Dl(n,Pi(f,n))}else{if(!P[g])return u?n:{};f=Ul(n,g,c)}}o||(o=new Xn);var w=o.get(n);if(w)return w;o.set(n,f),aa(n)?n.forEach(function(A){f.add(Tn(A,t,e,A,n,o))}):ia(n)&&n.forEach(function(A,$){f.set($,Tn(A,t,e,$,n,o))});var j=v?s?mu:du:s?jn:tn,S=_?a:j(n);return Ln(S||n,function(A,$){S&&($=A,A=n[$]),de(f,$,Tn(A,t,e,$,n,o))}),f}function Gc(n){var t=tn(n);return function(e){return Ti(e,n,t)}}function Ti(n,t,e){var r=e.length;if(n==null)return!r;for(n=N(n);r--;){var u=e[r],o=t[u],f=n[u];if(f===a&&!(u in n)||!o(f))return!1}return!0}function qi(n,t,e){if(typeof n!="function")throw new Nn(z);return De(function(){n.apply(a,e)},t)}function me(n,t,e,r){var u=-1,o=$e,f=!0,c=n.length,s=[],v=t.length;if(!c)return s;e&&(t=q(t,kn(e))),r?(o=Mr,f=!1):t.length>=R&&(o=pe,f=!1,t=new zt(t));n:for(;++u<c;){var _=n[u],g=e==null?_:e(_);if(_=r||_!==0?_:0,f&&g===g){for(var m=v;m--;)if(t[m]===g)continue n;s.push(_)}else o(t,g,r)||s.push(_)}return s}var Dt=yo(et),Vi=yo(tu,!0);function Jc(n,t){var e=!0;return Dt(n,function(r,u,o){return e=!!t(r,u,o),e}),e}function Ge(n,t,e){for(var r=-1,u=n.length;++r<u;){var o=n[r],f=t(o);if(f!=null&&(c===a?f===f&&!In(f):e(f,c)))var c=f,s=o}return s}function Qc(n,t,e,r){var u=n.length;for(e=k(e),e<0&&(e=-e>u?0:u+e),r=r===a||r>u?u:k(r),r<0&&(r+=u),r=e>r?0:ca(r);e<r;)n[e++]=t;return n}function Yi(n,t){var e=[];return Dt(n,function(r,u,o){t(r,u,o)&&e.push(r)}),e}function an(n,t,e,r,u){var o=-1,f=n.length;for(e||(e=Ll),u||(u=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?an(c,t-1,e,r,u):wt(u,c):r||(u[u.length]=c)}return u}var nu=mo(),Zi=mo(!0);function et(n,t){return n&&nu(n,t,tn)}function tu(n,t){return n&&Zi(n,t,tn)}function Je(n,t){return bt(t,function(e){return vt(n[e])})}function Ut(n,t){t=Ct(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[ut(t[e++])];return e&&e==r?n:a}function Hi(n,t,e){var r=t(n);return E(n)?r:wt(r,e(n))}function _n(n){return n==null?n===a?Ea:xa:Ft&&Ft in N(n)?Fl(n):Zl(n)}function eu(n,t){return n>t}function Xc(n,t){return n!=null&&M.call(n,t)}function nl(n,t){return n!=null&&t in N(n)}function tl(n,t,e){return n>=pn(t,e)&&n<Q(t,e)}function ru(n,t,e){for(var r=e?Mr:$e,u=n[0].length,o=n.length,f=o,c=p(o),s=Infinity,v=[];f--;){var _=n[f];f&&t&&(_=q(_,kn(t))),s=pn(_.length,s),c[f]=!e&&(t||u>=120&&_.length>=120)?new zt(f&&_):a}_=n[0];var g=-1,m=c[0];n:for(;++g<u&&v.length<s;){var w=_[g],j=t?t(w):w;if(w=e||w!==0?w:0,!(m?pe(m,j):r(v,j,e))){for(f=o;--f;){var S=c[f];if(!(S?pe(S,j):r(n[f],j,e)))continue n}m&&m.push(j),v.push(w)}}return v}function el(n,t,e,r){return et(n,function(u,o,f){t(r,e(u),o,f)}),r}function be(n,t,e){t=Ct(t,n),n=zo(n,t);var r=n==null?n:n[ut(Vn(t))];return r==null?a:On(r,n,e)}function Ki(n){return H(n)&&_n(n)==mt}function rl(n){return H(n)&&_n(n)==se}function ul(n){return H(n)&&_n(n)==yt}function we(n,t,e,r,u){return n===t?!0:n==null||t==null||!H(n)&&!H(t)?n!==n&&t!==t:il(n,t,e,r,we,u)}function il(n,t,e,r,u,o){var f=E(n),c=E(t),s=f?ae:hn(n),v=c?ae:hn(t);s=s==mt?at:s,v=v==mt?at:v;var _=s==at,g=v==at,m=s==v;if(m&&kt(n)){if(!kt(t))return!1;f=!0,_=!1}if(m&&!_)return o||(o=new Xn),f||ee(n)?ko(n,t,e,r,u,o):$l(n,t,s,e,r,u,o);if(!(e&Rn)){var w=_&&M.call(n,"__wrapped__"),j=g&&M.call(t,"__wrapped__");if(w||j){var S=w?n.value():n,A=j?t.value():t;return o||(o=new Xn),u(S,A,e,r,o)}}return m?(o||(o=new Xn),Bl(n,t,e,r,u,o)):!1}function ol(n){return H(n)&&hn(n)==Hn}function uu(n,t,e,r){var u=e.length,o=u,f=!r;if(n==null)return!o;for(n=N(n);u--;){var c=e[u];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return!1}for(;++u<o;){c=e[u];var s=c[0],v=n[s],_=c[1];if(f&&c[2]){if(v===a&&!(s in n))return!1}else{var g=new Xn;if(r)var m=r(v,_,s,n,t,g);if(!(m===a?we(_,v,Rn|bn,r,g):m))return!1}}return!0}function Gi(n){if(!V(n)||Pl(n))return!1;var t=vt(n)?oc:Ka;return t.test(Lt(n))}function al(n){return H(n)&&_n(n)==fe}function fl(n){return H(n)&&hn(n)==Jn}function cl(n){return H(n)&&vr(n.length)&&!!T[_n(n)]}function Ji(n){return typeof n=="function"?n:n==null?An:typeof n=="object"?E(n)?no(n[0],n[1]):Xi(n):ba(n)}function iu(n){if(!Ae(n))return pc(n);var t=[];for(var e in N(n))M.call(n,e)&&e!="constructor"&&t.push(e);return t}function ll(n){if(!V(n))return Yl(n);var t=Ae(n),e=[];for(var r in n)r=="constructor"&&(t||!M.call(n,r))||e.push(r);return e}function ou(n,t){return n<t}function Qi(n,t){var e=-1,r=xn(n)?p(n.length):[];return Dt(n,function(u,o,f){r[++e]=t(u,o,f)}),r}function Xi(n){var t=wu(n);return t.length==1&&t[0][2]?Fo(t[0][0],t[0][1]):function(e){return e===n||uu(e,n,t)}}function no(n,t){return ju(n)&&Bo(t)?Fo(ut(n),t):function(e){var r=Bu(e,n);return r===a&&r===t?Fu(e,n):we(t,r,Rn|bn)}}function Qe(n,t,e,r,u){n!==t&&nu(t,function(o,f){if(u||(u=new Xn),V(o))sl(n,t,f,e,Qe,r,u);else{var c=r?r(Du(n,f),o,f+"",n,t,u):a;c===a&&(c=o),Qr(n,f,c)}},jn)}function sl(n,t,e,r,u,o,f){var c=Du(n,e),s=Du(t,e),v=f.get(s);if(v){Qr(n,e,v);return}var _=o?o(c,s,e+"",n,t,f):a,g=_===a;if(g){var m=E(s),w=!m&&kt(s),j=!m&&!w&&ee(s);_=s,m||w||j?E(c)?_=c:K(c)?_=wn(c):w?(g=!1,_=po(s,!0)):j?(g=!1,_=ho(s,!0)):_=[]:Ee(s)||Nt(s)?(_=c,Nt(c)?_=la(c):(!V(c)||vt(c))&&(_=$o(s))):g=!1}g&&(f.set(s,_),u(_,s,r,o,f),f.delete(s)),Qr(n,e,_)}function to(n,t){var e=n.length;if(e)return t+=t<0?e:0,ht(t,e)?n[t]:a}function eo(n,t,e){t.length?t=q(t,function(o){return E(o)?function(f){return Ut(f,o.length===1?o[0]:o)}:o}):t=[An];var r=-1;t=q(t,kn(x()));var u=Qi(n,function(o,f,c){var s=q(t,function(v){return v(o)});return{criteria:s,index:++r,value:o}});return Uf(u,function(o,f){return Al(o,f,e)})}function pl(n,t){return ro(n,t,function(e,r){return Fu(n,r)})}function ro(n,t,e){for(var r=-1,u=t.length,o={};++r<u;){var f=t[r],c=Ut(n,f);e(c,f)&&xe(o,Ct(f,n),c)}return o}function hl(n){return function(t){return Ut(t,n)}}function au(n,t,e,r){var u=r?Wf:Yt,o=-1,f=t.length,c=n;for(n===t&&(t=wn(t)),e&&(c=q(n,kn(e)));++o<f;)for(var s=0,v=t[o],_=e?e(v):v;(s=u(c,_,s,r))>-1;)c!==n&&Pe.call(c,s,1),Pe.call(n,s,1);return n}function uo(n,t){for(var e=n?t.length:0,r=e-1;e--;){var u=t[e];if(e==r||u!==o){var o=u;ht(u)?Pe.call(n,u,1):su(n,u)}}return n}function fu(n,t){return n+Ve(Ui()*(t-n+1))}function vl(n,t,e,r){for(var u=-1,o=Q(qe((t-n)/(e||1)),0),f=p(o);o--;)f[r?o:++u]=n,n+=e;return f}function cu(n,t){var e="";if(!n||t<1||t>en)return e;do t%2&&(e+=n),t=Ve(t/2),t&&(n+=n);while(t);return e}function I(n,t){return Eu(Ro(n,t,An),n+"")}function _l(n){return Ni(re(n))}function gl(n,t){var e=re(n);return fr(e,Wt(t,0,e.length))}function xe(n,t,e,r){if(!V(n))return n;t=Ct(t,n);for(var u=-1,o=t.length,f=o-1,c=n;c!=null&&++u<o;){var s=ut(t[u]),v=e;if(s==="__proto__"||s==="constructor"||s==="prototype")return n;if(u!=f){var _=c[s];v=r?r(_,s,c):a,v===a&&(v=V(_)?_:ht(t[u+1])?[]:{})}de(c,s,v),c=c[s]}return n}var io=Ye?function(n,t){return Ye.set(n,t),n}:An,yl=Te?function(n,t){return Te(n,"toString",{configurable:!0,enumerable:!1,value:zu(t),writable:!0})}:An;function dl(n){return fr(re(n))}function qn(n,t,e){var r=-1,u=n.length;t<0&&(t=-t>u?0:u+t),e=e>u?u:e,e<0&&(e+=u),u=t>e?0:e-t>>>0,t>>>=0;for(var o=p(u);++r<u;)o[r]=n[r+t];return o}function ml(n,t){var e;return Dt(n,function(r,u,o){return e=t(r,u,o),!e}),!!e}function Xe(n,t,e){var r=0,u=n==null?r:n.length;if(typeof t=="number"&&t===t&&u<=Ce){for(;r<u;){var o=r+u>>>1,f=n[o];f!==null&&!In(f)&&(e?f<=t:f<t)?r=o+1:u=o}return u}return lu(n,t,An,e)}function lu(n,t,e,r){var u=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,s=In(t),v=t===a;u<o;){var _=Ve((u+o)/2),g=e(n[_]),m=g!==a,w=g===null,j=g===g,S=In(g);if(f)var A=r||j;else v?A=j&&(r||m):c?A=j&&m&&(r||!w):s?A=j&&m&&!w&&(r||!S):w||S?A=!1:A=r?g<=t:g<t;A?u=_+1:o=_}return pn(o,Tt)}function oo(n,t){for(var e=-1,r=n.length,u=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!nt(c,s)){var s=c;o[u++]=f===0?0:f}}return o}function ao(n){return typeof n=="number"?n:In(n)?Kn:+n}function Sn(n){if(typeof n=="string")return n;if(E(n))return q(n,Sn)+"";if(In(n))return Mi?Mi.call(n):"";var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Et(n,t,e){var r=-1,u=$e,o=n.length,f=!0,c=[],s=c;if(e)f=!1,u=Mr;else if(o>=R){var v=t?null:Sl(n);if(v)return Fe(v);f=!1,u=pe,s=new zt}else s=t?[]:c;n:for(;++r<o;){var _=n[r],g=t?t(_):_;if(_=e||_!==0?_:0,f&&g===g){for(var m=s.length;m--;)if(s[m]===g)continue n;t&&s.push(g),c.push(_)}else u(s,g,e)||(s!==c&&s.push(g),c.push(_))}return c}function su(n,t){return t=Ct(t,n),n=zo(n,t),n==null||delete n[ut(Vn(t))]}function fo(n,t,e,r){return xe(n,t,e(Ut(n,t)),r)}function nr(n,t,e,r){for(var u=n.length,o=r?u:-1;(r?o--:++o<u)&&t(n[o],o,n););return e?qn(n,r?0:o,r?o+1:u):qn(n,r?o+1:0,r?u:o)}function co(n,t){var e=n;return e instanceof B&&(e=e.value()),Lr(t,function(r,u){return u.func.apply(u.thisArg,wt([r],u.args))},e)}function pu(n,t,e){var r=n.length;if(r<2)return r?Et(n[0]):[];for(var u=-1,o=p(r);++u<r;)for(var f=n[u],c=-1;++c<r;)c!=u&&(o[u]=me(o[u]||f,n[c],t,e));return Et(an(o,1),t,e)}function lo(n,t,e){for(var r=-1,u=n.length,o=t.length,f={};++r<u;){var c=r<o?t[r]:a;e(f,n[r],c)}return f}function hu(n){return K(n)?n:[]}function vu(n){return typeof n=="function"?n:An}function Ct(n,t){return E(n)?n:ju(n,t)?[n]:Lo(U(n))}var bl=I;function Ot(n,t,e){var r=n.length;return e=e===a?r:e,!t&&e>=r?n:qn(n,t,e)}var so=ac||function(n){return nn.clearTimeout(n)};function po(n,t){if(t)return n.slice();var e=n.length,r=Bi?Bi(e):new n.constructor(e);return n.copy(r),r}function _u(n){var t=new n.constructor(n.byteLength);return new Le(t).set(new Le(n)),t}function wl(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function xl(n){var t=new n.constructor(n.source,Ku.exec(n));return t.lastIndex=n.lastIndex,t}function jl(n){return ye?N(ye.call(n)):{}}function ho(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function vo(n,t){if(n!==t){var e=n!==a,r=n===null,u=n===n,o=In(n),f=t!==a,c=t===null,s=t===t,v=In(t);if(!c&&!v&&!o&&n>t||o&&f&&s&&!c&&!v||r&&f&&s||!e&&s||!u)return 1;if(!r&&!o&&!v&&n<t||v&&e&&u&&!r&&!o||c&&e&&u||!f&&u||!s)return-1}return 0}function Al(n,t,e){for(var r=-1,u=n.criteria,o=t.criteria,f=u.length,c=e.length;++r<f;){var s=vo(u[r],o[r]);if(s){if(r>=c)return s;var v=e[r];return s*(v=="desc"?-1:1)}}return n.index-t.index}function _o(n,t,e,r){for(var u=-1,o=n.length,f=e.length,c=-1,s=t.length,v=Q(o-f,0),_=p(s+v),g=!r;++c<s;)_[c]=t[c];for(;++u<f;)(g||u<o)&&(_[e[u]]=n[u]);for(;v--;)_[c++]=n[u++];return _}function go(n,t,e,r){for(var u=-1,o=n.length,f=-1,c=e.length,s=-1,v=t.length,_=Q(o-c,0),g=p(_+v),m=!r;++u<_;)g[u]=n[u];for(var w=u;++s<v;)g[w+s]=t[s];for(;++f<c;)(m||u<o)&&(g[w+e[f]]=n[u++]);return g}function wn(n,t){var e=-1,r=n.length;for(t||(t=p(r));++e<r;)t[e]=n[e];return t}function rt(n,t,e,r){var u=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],s=r?r(e[c],n[c],c,e,n):a;s===a&&(s=n[c]),u?lt(e,c,s):de(e,c,s)}return e}function Dl(n,t){return rt(n,xu(n),t)}function El(n,t){return rt(n,So(n),t)}function tr(n,t){return function(e,r){var u=E(e)?If:Hc,o=t?t():{};return u(e,n,x(r,2),o)}}function Xt(n){return I(function(t,e){var r=-1,u=e.length,o=u>1?e[u-1]:a,f=u>2?e[2]:a;for(o=n.length>3&&typeof o=="function"?(u--,o):a,f&&gn(e[0],e[1],f)&&(o=u<3?a:o,u=1),t=N(t);++r<u;){var c=e[r];c&&n(t,c,r,o)}return t})}function yo(n,t){return function(e,r){if(e==null)return e;if(!xn(e))return n(e,r);for(var u=e.length,o=t?u:-1,f=N(e);(t?o--:++o<u)&&r(f[o],o,f)!==!1;);return e}}function mo(n){return function(t,e,r){for(var u=-1,o=N(t),f=r(t),c=f.length;c--;){var s=f[n?c:++u];if(e(o[s],s,o)===!1)break}return t}}function Cl(n,t,e){var r=t&X,u=je(n);function o(){var f=this&&this!==nn&&this instanceof o?u:n;return f.apply(r?e:this,arguments)}return o}function bo(n){return function(t){t=U(t);var e=Zt(t)?Qn(t):a,r=e?e[0]:t.charAt(0),u=e?Ot(e,1).join(""):t.slice(1);return r[n]()+u}}function ne(n){return function(t){return Lr(da(ya(t).replace(yf,"")),n,"")}}function je(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=Qt(n.prototype),r=n.apply(e,t);return V(r)?r:e}}function Ol(n,t,e){var r=je(n);function u(){for(var o=arguments.length,f=p(o),c=o,s=te(u);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==s&&f[o-1]!==s?[]:xt(f,s);if(o-=v.length,o<e)return Do(n,t,er,u.placeholder,a,f,v,a,a,e-o);var _=this&&this!==nn&&this instanceof u?r:n;return On(_,this,f)}return u}function wo(n){return function(t,e,r){var u=N(t);if(!xn(t)){var o=x(e,3);t=tn(t),e=function(c){return o(u[c],c,u)}}var f=n(t,e,r);return f>-1?u[o?t[f]:f]:a}}function xo(n){return pt(function(t){var e=t.length,r=e,u=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new Nn(z);if(u&&!f&&or(o)=="wrapper")var f=new Pn([],!0)}for(r=f?r:e;++r<e;){o=t[r];var c=or(o),s=c=="wrapper"?bu(o):a;s&&Au(s[0])&&s[1]==(Y|mn|un|Cn)&&!s[4].length&&s[9]==1?f=f[or(s[0])].apply(f,s[3]):f=o.length==1&&Au(o)?f[c]():f.thru(o)}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&E(_))return f.plant(_).value();for(var g=0,m=e?t[g].apply(this,v):_;++g<e;)m=t[g].call(this,m);return m}})}function er(n,t,e,r,u,o,f,c,s,v){var _=t&Y,g=t&X,m=t&En,w=t&(mn|ot),j=t&Wn,S=m?a:je(n);function A(){for(var $=arguments.length,F=p($),$n=$;$n--;)F[$n]=arguments[$n];if(w)var yn=te(A),Bn=Lf(F,yn);if(r&&(F=_o(F,r,u,w)),o&&(F=go(F,o,f,w)),$-=Bn,w&&$<v){var G=xt(F,yn);return Do(n,t,er,A.placeholder,e,F,G,c,s,v-$)}var tt=g?e:this,gt=m?tt[n]:n;return $=F.length,c?F=Hl(F,c):j&&$>1&&F.reverse(),_&&s<$&&(F.length=s),this&&this!==nn&&this instanceof A&&(gt=S||je(gt)),gt.apply(tt,F)}return A}function jo(n,t){return function(e,r){return el(e,n,t(r),{})}}function rr(n,t){return function(e,r){var u;if(e===a&&r===a)return t;if(e!==a&&(u=e),r!==a){if(u===a)return r;typeof e=="string"||typeof r=="string"?(e=Sn(e),r=Sn(r)):(e=ao(e),r=ao(r)),u=n(e,r)}return u}}function gu(n){return pt(function(t){return t=q(t,kn(x())),I(function(e){var r=this;return n(t,function(u){return On(u,r,e)})})})}function ur(n,t){t=t===a?" ":Sn(t);var e=t.length;if(e<2)return e?cu(t,n):t;var r=cu(t,qe(n/Ht(t)));return Zt(t)?Ot(Qn(r),0,n).join(""):r.slice(0,n)}function kl(n,t,e,r){var u=t&X,o=je(n);function f(){for(var c=-1,s=arguments.length,v=-1,_=r.length,g=p(_+s),m=this&&this!==nn&&this instanceof f?o:n;++v<_;)g[v]=r[v];for(;s--;)g[v++]=arguments[++c];return On(m,u?e:this,g)}return f}function Ao(n){return function(t,e,r){return r&&typeof r!="number"&&gn(t,e,r)&&(e=r=a),t=_t(t),e===a?(e=t,t=0):e=_t(e),r=r===a?t<e?1:-1:_t(r),vl(t,e,r,n)}}function ir(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=Yn(t),e=Yn(e)),n(t,e)}}function Do(n,t,e,r,u,o,f,c,s,v){var _=t&mn,g=_?f:a,m=_?a:f,w=_?o:a,j=_?a:o;t|=_?un:on,t&=~(_?on:un),t&St||(t&=~(X|En));var S=[n,t,u,w,g,j,m,c,s,v],A=e.apply(a,S);return Au(n)&&Wo(A,S),A.placeholder=r,Uo(A,n,t)}function yu(n){var t=J[n];return function(e,r){if(e=Yn(e),r=r==null?0:pn(k(r),292),r&&Wi(e)){var u=(U(e)+"e").split("e"),o=t(u[0]+"e"+(+u[1]+r));return u=(U(o)+"e").split("e"),+(u[0]+"e"+(+u[1]-r))}return t(e)}}var Sl=Gt&&1/Fe(new Gt([,-0]))[1]==Z?function(n){return new Gt(n)}:Mu;function Eo(n){return function(t){var e=hn(t);return e==Hn?Zr(t):e==Jn?Zf(t):Mf(t,n(t))}}function st(n,t,e,r,u,o,f,c){var s=t&En;if(!s&&typeof n!="function")throw new Nn(z);var v=r?r.length:0;if(v||(t&=~(un|on),r=u=a),f=f===a?f:Q(k(f),0),c=c===a?c:k(c),v-=u?u.length:0,t&on){var _=r,g=u;r=u=a}var m=s?a:bu(n),w=[n,t,e,r,u,_,g,o,f,c];if(m&&Vl(w,m),n=w[0],t=w[1],e=w[2],r=w[3],u=w[4],c=w[9]=w[9]===a?s?0:n.length:Q(w[9]-v,0),!c&&t&(mn|ot)&&(t&=~(mn|ot)),!t||t==X)var j=Cl(n,t,e);else t==mn||t==ot?j=Ol(n,t,c):(t==un||t==(X|un))&&!u.length?j=kl(n,t,e,r):j=er.apply(a,w);var S=m?io:Wo;return Uo(S(j,w),n,t)}function Co(n,t,e,r){return n===a||nt(n,Kt[e])&&!M.call(r,e)?t:n}function Oo(n,t,e,r,u,o){return V(n)&&V(t)&&(o.set(t,n),Qe(n,t,a,Oo,o),o.delete(t)),n}function Il(n){return Ee(n)?a:n}function ko(n,t,e,r,u,o){var f=e&Rn,c=n.length,s=t.length;if(c!=s&&!(f&&s>c))return!1;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var g=-1,m=!0,w=e&bn?new zt:a;for(o.set(n,t),o.set(t,n);++g<c;){var j=n[g],S=t[g];if(r)var A=f?r(S,j,g,t,n,o):r(j,S,g,n,t,o);if(A!==a){if(A)continue;m=!1;break}if(w){if(!Nr(t,function($,F){if(!pe(w,F)&&(j===$||u(j,$,e,r,o)))return w.push(F)})){m=!1;break}}else if(!(j===S||u(j,S,e,r,o))){m=!1;break}}return o.delete(n),o.delete(t),m}function $l(n,t,e,r,u,o,f){switch(e){case qt:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return!1;n=n.buffer,t=t.buffer;case se:return!(n.byteLength!=t.byteLength||!o(new Le(n),new Le(t)));case $t:case yt:case oe:return nt(+n,+t);case ue:return n.name==t.name&&n.message==t.message;case fe:case ce:return n==t+"";case Hn:var c=Zr;case Jn:var s=r&Rn;if(c||(c=Fe),n.size!=t.size&&!s)return!1;var v=f.get(n);if(v)return v==t;r|=bn,f.set(n,t);var _=ko(c(n),c(t),r,u,o,f);return f.delete(n),_;case Oe:if(ye)return ye.call(n)==ye.call(t)}return!1}function Bl(n,t,e,r,u,o){var f=e&Rn,c=du(n),s=c.length,v=du(t),_=v.length;if(s!=_&&!f)return!1;for(var g=s;g--;){var m=c[g];if(!(f?m in t:M.call(t,m)))return!1}var w=o.get(n),j=o.get(t);if(w&&j)return w==t&&j==n;var S=!0;o.set(n,t),o.set(t,n);for(var A=f;++g<s;){m=c[g];var $=n[m],F=t[m];if(r)var $n=f?r(F,$,m,t,n,o):r($,F,m,n,t,o);if(!($n===a?$===F||u($,F,e,r,o):$n)){S=!1;break}A||(A=m=="constructor")}if(S&&!A){var yn=n.constructor,Bn=t.constructor;yn!=Bn&&"constructor"in n&&"constructor"in t&&!(typeof yn=="function"&&yn instanceof yn&&typeof Bn=="function"&&Bn instanceof Bn)&&(S=!1)}return o.delete(n),o.delete(t),S}function pt(n){return Eu(Ro(n,a,qo),n+"")}function du(n){return Hi(n,tn,xu)}function mu(n){return Hi(n,jn,So)}var bu=Ye?function(n){return Ye.get(n)}:Mu;function or(n){for(var t=n.name+"",e=Jt[t],r=M.call(Jt,t)?e.length:0;r--;){var u=e[r],o=u.func;if(o==null||o==n)return u.name}return t}function te(n){var t=M.call(i,"placeholder")?i:n;return t.placeholder}function x(){var n=i.iteratee||Wu;return n=n===Wu?Ji:n,arguments.length?n(arguments[0],arguments[1]):n}function ar(n,t){var e=n.__data__;return Nl(t)?e[typeof t=="string"?"string":"hash"]:e.map}function wu(n){for(var t=tn(n),e=t.length;e--;){var r=t[e],u=n[r];t[e]=[r,u,Bo(u)]}return t}function Mt(n,t){var e=qf(n,t);return Gi(e)?e:a}function Fl(n){var t=M.call(n,Ft),e=n[Ft];try{n[Ft]=a;var r=!0}catch(o){}var u=Ue.call(n);return r&&(t?n[Ft]=e:delete n[Ft]),u}var xu=Kr?function(n){return n==null?[]:(n=N(n),bt(Kr(n),function(t){return Ri.call(n,t)}))}:Lu,So=Kr?function(n){for(var t=[];n;)wt(t,xu(n)),n=Ne(n);return t}:Lu,hn=_n;(Gr&&hn(new Gr(new ArrayBuffer(1)))!=qt||ve&&hn(new ve)!=Hn||Jr&&hn(Jr.resolve())!=Vu||Gt&&hn(new Gt)!=Jn||_e&&hn(new _e)!=le)&&(hn=function(n){var t=_n(n),e=t==at?n.constructor:a,r=e?Lt(e):"";if(r)switch(r){case gc:return qt;case yc:return Hn;case dc:return Vu;case mc:return Jn;case bc:return le}return t});function Rl(n,t,e){for(var r=-1,u=e.length;++r<u;){var o=e[r],f=o.size;switch(o.type){case"drop":n+=f;break;case"dropRight":t-=f;break;case"take":t=pn(t,n+f);break;case"takeRight":n=Q(n,t-f);break}}return{start:n,end:t}}function zl(n){var t=n.match(Na);return t?t[1].split(Pa):[]}function Io(n,t,e){t=Ct(t,n);for(var r=-1,u=t.length,o=!1;++r<u;){var f=ut(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f]}return o||++r!=u?o:(u=n==null?0:n.length,!!u&&vr(u)&&ht(f,u)&&(E(n)||Nt(n)))}function Wl(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&M.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function $o(n){return typeof n.constructor=="function"&&!Ae(n)?Qt(Ne(n)):{}}function Ul(n,t,e){var r=n.constructor;switch(t){case se:return _u(n);case $t:case yt:return new r(+n);case qt:return wl(n,e);case wr:case xr:case jr:case Ar:case Dr:case Er:case Cr:case Or:case kr:return ho(n,e);case Hn:return new r;case oe:case ce:return new r(n);case fe:return xl(n);case Jn:return new r;case Oe:return jl(n)}}function Ml(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(La,`{
/* [wrapped with `+t+`] */
`)}function Ll(n){return E(n)||Nt(n)||!!(zi&&n&&n[zi])}function ht(n,t){var e=typeof n;return t=t==null?en:t,!!t&&(e=="number"||e!="symbol"&&Ja.test(n))&&n>-1&&n%1==0&&n<t}function gn(n,t,e){if(!V(e))return!1;var r=typeof t;return(r=="number"?xn(e)&&ht(t,e.length):r=="string"&&t in e)?nt(e[t],n):!1}function ju(n,t){if(E(n))return!1;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||In(n)?!0:za.test(n)||!Ra.test(n)||t!=null&&n in N(t)}function Nl(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function Au(n){var t=or(n),e=i[t];if(typeof e!="function"||!(t in B.prototype))return!1;if(n===e)return!0;var r=bu(e);return!!r&&n===r[0]}function Pl(n){return!!$i&&$i in n}var Tl=ze?vt:Nu;function Ae(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Kt;return n===e}function Bo(n){return n===n&&!V(n)}function Fo(n,t){return function(e){return e==null?!1:e[n]===t&&(t!==a||n in N(e))}}function ql(n){var t=pr(n,function(r){return e.size===rn&&e.clear(),r}),e=t.cache;return t}function Vl(n,t){var e=n[1],r=t[1],u=e|r,o=u<(X|En|Y),f=r==Y&&e==mn||r==Y&&e==Cn&&n[7].length<=t[8]||r==(Y|Cn)&&t[7].length<=t[8]&&e==mn;if(!(o||f))return n;r&X&&(n[2]=t[2],u|=e&X?0:St);var c=t[3];if(c){var s=n[3];n[3]=s?_o(s,c,t[4]):c,n[4]=s?xt(n[3],Dn):t[4]}return c=t[5],c&&(s=n[5],n[5]=s?go(s,c,t[6]):c,n[6]=s?xt(n[5],Dn):t[6]),c=t[7],c&&(n[7]=c),r&Y&&(n[8]=n[8]==null?t[8]:pn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Yl(n){var t=[];if(n!=null)for(var e in N(n))t.push(e);return t}function Zl(n){return Ue.call(n)}function Ro(n,t,e){return t=Q(t===a?n.length-1:t,0),function(){for(var r=arguments,u=-1,o=Q(r.length-t,0),f=p(o);++u<o;)f[u]=r[t+u];u=-1;for(var c=p(t+1);++u<t;)c[u]=r[u];return c[t]=e(f),On(n,this,c)}}function zo(n,t){return t.length<2?n:Ut(n,qn(t,0,-1))}function Hl(n,t){for(var e=n.length,r=pn(t.length,e),u=wn(n);r--;){var o=t[r];n[r]=ht(o,e)?u[o]:a}return n}function Du(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Wo=Mo(io),De=cc||function(n,t){return nn.setTimeout(n,t)},Eu=Mo(yl);function Uo(n,t,e){var r=t+"";return Eu(n,Ml(r,Kl(zl(r),e)))}function Mo(n){var t=0,e=0;return function(){var r=hc(),u=zn-(r-e);if(e=r,u>0){if(++t>=Pt)return arguments[0]}else t=0;return n.apply(a,arguments)}}function fr(n,t){var e=-1,r=n.length,u=r-1;for(t=t===a?r:t;++e<t;){var o=fu(e,u),f=n[o];n[o]=n[e],n[e]=f}return n.length=t,n}var Lo=ql(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(Wa,function(e,r,u,o){t.push(u?o.replace(Va,"$1"):r||e)}),t});function ut(n){if(typeof n=="string"||In(n))return n;var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Lt(n){if(n!=null){try{return We.call(n)}catch(t){}try{return n+""}catch(t){}}return""}function Kl(n,t){return Ln(mr,function(e){var r="_."+e[0];t&e[1]&&!$e(n,r)&&n.push(r)}),n.sort()}function No(n){if(n instanceof B)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=wn(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Gl(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=Q(k(t),0);var r=n==null?0:n.length;if(!r||t<1)return[];for(var u=0,o=0,f=p(qe(r/t));u<r;)f[o++]=qn(n,u,u+=t);return f}function Jl(n){for(var t=-1,e=n==null?0:n.length,r=0,u=[];++t<e;){var o=n[t];o&&(u[r++]=o)}return u}function Ql(){var n=arguments.length;if(!n)return[];for(var t=p(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return wt(E(e)?wn(e):[e],an(t,1))}var Xl=I(function(n,t){return K(n)?me(n,an(t,1,K,!0)):[]}),ns=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),x(e,2)):[]}),ts=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),a,e):[]});function es(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),qn(n,t<0?0:t,r)):[]}function rs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,0,t<0?0:t)):[]}function us(n,t){return n&&n.length?nr(n,x(t,3),!0,!0):[]}function is(n,t){return n&&n.length?nr(n,x(t,3),!0):[]}function os(n,t,e,r){var u=n==null?0:n.length;return u?(e&&typeof e!="number"&&gn(n,t,e)&&(e=0,r=u),Qc(n,t,e,r)):[]}function Po(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Be(n,x(t,3),u)}function To(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r-1;return e!==a&&(u=k(e),u=e<0?Q(r+u,0):pn(u,r-1)),Be(n,x(t,3),u,!0)}function qo(n){var t=n==null?0:n.length;return t?an(n,1):[]}function as(n){var t=n==null?0:n.length;return t?an(n,Z):[]}function fs(n,t){var e=n==null?0:n.length;return e?(t=t===a?1:k(t),an(n,t)):[]}function cs(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var u=n[t];r[u[0]]=u[1]}return r}function Vo(n){return n&&n.length?n[0]:a}function ls(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Yt(n,t,u)}function ss(n){var t=n==null?0:n.length;return t?qn(n,0,-1):[]}var ps=I(function(n){var t=q(n,hu);return t.length&&t[0]===n[0]?ru(t):[]}),hs=I(function(n){var t=Vn(n),e=q(n,hu);return t===Vn(e)?t=a:e.pop(),e.length&&e[0]===n[0]?ru(e,x(t,2)):[]}),vs=I(function(n){var t=Vn(n),e=q(n,hu);return t=typeof t=="function"?t:a,t&&e.pop(),e.length&&e[0]===n[0]?ru(e,a,t):[]});function _s(n,t){return n==null?"":sc.call(n,t)}function Vn(n){var t=n==null?0:n.length;return t?n[t-1]:a}function gs(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r;return e!==a&&(u=k(e),u=u<0?Q(r+u,0):pn(u,r-1)),t===t?Kf(n,t,u):Be(n,Ai,u,!0)}function ys(n,t){return n&&n.length?to(n,k(t)):a}var ds=I(Yo);function Yo(n,t){return n&&n.length&&t&&t.length?au(n,t):n}function ms(n,t,e){return n&&n.length&&t&&t.length?au(n,t,x(e,2)):n}function bs(n,t,e){return n&&n.length&&t&&t.length?au(n,t,a,e):n}var ws=pt(function(n,t){var e=n==null?0:n.length,r=Xr(n,t);return uo(n,q(t,function(u){return ht(u,e)?+u:u}).sort(vo)),r});function xs(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,u=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),u.push(r))}return uo(n,u),e}function Cu(n){return n==null?n:_c.call(n)}function js(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&gn(n,t,e)?(t=0,e=r):(t=t==null?0:k(t),e=e===a?r:k(e)),qn(n,t,e)):[]}function As(n,t){return Xe(n,t)}function Ds(n,t,e){return lu(n,t,x(e,2))}function Es(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t);if(r<e&&nt(n[r],t))return r}return-1}function Cs(n,t){return Xe(n,t,!0)}function Os(n,t,e){return lu(n,t,x(e,2),!0)}function ks(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t,!0)-1;if(nt(n[r],t))return r}return-1}function Ss(n){return n&&n.length?oo(n):[]}function Is(n,t){return n&&n.length?oo(n,x(t,2)):[]}function $s(n){var t=n==null?0:n.length;return t?qn(n,1,t):[]}function Bs(n,t,e){return n&&n.length?(t=e||t===a?1:k(t),qn(n,0,t<0?0:t)):[]}function Fs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,t<0?0:t,r)):[]}function Rs(n,t){return n&&n.length?nr(n,x(t,3),!1,!0):[]}function zs(n,t){return n&&n.length?nr(n,x(t,3)):[]}var Ws=I(function(n){return Et(an(n,1,K,!0))}),Us=I(function(n){var t=Vn(n);return K(t)&&(t=a),Et(an(n,1,K,!0),x(t,2))}),Ms=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,Et(an(n,1,K,!0),a,t)});function Ls(n){return n&&n.length?Et(n):[]}function Ns(n,t){return n&&n.length?Et(n,x(t,2)):[]}function Ps(n,t){return t=typeof t=="function"?t:a,n&&n.length?Et(n,a,t):[]}function Ou(n){if(!(n&&n.length))return[];var t=0;return n=bt(n,function(e){if(K(e))return t=Q(e.length,t),!0}),Vr(t,function(e){return q(n,Pr(e))})}function Zo(n,t){if(!(n&&n.length))return[];var e=Ou(n);return t==null?e:q(e,function(r){return On(t,a,r)})}var Ts=I(function(n,t){return K(n)?me(n,t):[]}),qs=I(function(n){return pu(bt(n,K))}),Vs=I(function(n){var t=Vn(n);return K(t)&&(t=a),pu(bt(n,K),x(t,2))}),Ys=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,pu(bt(n,K),a,t)}),Zs=I(Ou);function Hs(n,t){return lo(n||[],t||[],de)}function Ks(n,t){return lo(n||[],t||[],xe)}var Gs=I(function(n){var t=n.length,e=t>1?n[t-1]:a;return e=typeof e=="function"?(n.pop(),e):a,Zo(n,e)});function Ho(n){var t=i(n);return t.__chain__=!0,t}function Js(n,t){return t(n),n}function cr(n,t){return t(n)}var Qs=pt(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,u=function(o){return Xr(o,n)};return t>1||this.__actions__.length||!(r instanceof B)||!ht(e)?this.thru(u):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:cr,args:[u],thisArg:a}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(a),o}))});function Xs(){return Ho(this)}function n0(){return new Pn(this.value(),this.__chain__)}function t0(){this.__values__===a&&(this.__values__=fa(this.value()));var n=this.__index__>=this.__values__.length,t=n?a:this.__values__[this.__index__++];return{done:n,value:t}}function e0(){return this}function r0(n){for(var t,e=this;e instanceof He;){var r=No(e);r.__index__=0,r.__values__=a,t?u.__wrapped__=r:t=r;var u=r;e=e.__wrapped__}return u.__wrapped__=n,t}function u0(){var n=this.__wrapped__;if(n instanceof B){var t=n;return this.__actions__.length&&(t=new B(this)),t=t.reverse(),t.__actions__.push({func:cr,args:[Cu],thisArg:a}),new Pn(t,this.__chain__)}return this.thru(Cu)}function i0(){return co(this.__wrapped__,this.__actions__)}var o0=tr(function(n,t,e){M.call(n,e)?++n[e]:lt(n,e,1)});function a0(n,t,e){var r=E(n)?xi:Jc;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}function f0(n,t){var e=E(n)?bt:Yi;return e(n,x(t,3))}var c0=wo(Po),l0=wo(To);function s0(n,t){return an(lr(n,t),1)}function p0(n,t){return an(lr(n,t),Z)}function h0(n,t,e){return e=e===a?1:k(e),an(lr(n,t),e)}function Ko(n,t){var e=E(n)?Ln:Dt;return e(n,x(t,3))}function Go(n,t){var e=E(n)?$f:Vi;return e(n,x(t,3))}var v0=tr(function(n,t,e){M.call(n,e)?n[e].push(t):lt(n,e,[t])});function _0(n,t,e,r){n=xn(n)?n:re(n),e=e&&!r?k(e):0;var u=n.length;return e<0&&(e=Q(u+e,0)),_r(n)?e<=u&&n.indexOf(t,e)>-1:!!u&&Yt(n,t,e)>-1}var g0=I(function(n,t,e){var r=-1,u=typeof t=="function",o=xn(n)?p(n.length):[];return Dt(n,function(f){o[++r]=u?On(t,f,e):be(f,t,e)}),o}),y0=tr(function(n,t,e){lt(n,e,t)});function lr(n,t){var e=E(n)?q:Qi;return e(n,x(t,3))}function d0(n,t,e,r){return n==null?[]:(E(t)||(t=t==null?[]:[t]),e=r?a:e,E(e)||(e=e==null?[]:[e]),eo(n,t,e))}var m0=tr(function(n,t,e){n[e?0:1].push(t)},function(){return[[],[]]});function b0(n,t,e){var r=E(n)?Lr:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Dt)}function w0(n,t,e){var r=E(n)?Bf:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Vi)}function x0(n,t){var e=E(n)?bt:Yi;return e(n,hr(x(t,3)))}function j0(n){var t=E(n)?Ni:_l;return t(n)}function A0(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=k(t);var r=E(n)?Yc:gl;return r(n,t)}function D0(n){var t=E(n)?Zc:dl;return t(n)}function E0(n){if(n==null)return 0;if(xn(n))return _r(n)?Ht(n):n.length;var t=hn(n);return t==Hn||t==Jn?n.size:iu(n).length}function C0(n,t,e){var r=E(n)?Nr:ml;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}var O0=I(function(n,t){if(n==null)return[];var e=t.length;return e>1&&gn(n,t[0],t[1])?t=[]:e>2&&gn(t[0],t[1],t[2])&&(t=[t[0]]),eo(n,an(t,1),[])}),sr=fc||function(){return nn.Date.now()};function k0(n,t){if(typeof t!="function")throw new Nn(z);return n=k(n),function(){if(--n<1)return t.apply(this,arguments)}}function Jo(n,t,e){return t=e?a:t,t=n&&t==null?n.length:t,st(n,Y,a,a,a,a,t)}function Qo(n,t){var e;if(typeof t!="function")throw new Nn(z);return n=k(n),function(){return--n>0&&(e=t.apply(this,arguments)),n<=1&&(t=a),e}}var ku=I(function(n,t,e){var r=X;if(e.length){var u=xt(e,te(ku));r|=un}return st(n,r,t,e,u)}),Xo=I(function(n,t,e){var r=X|En;if(e.length){var u=xt(e,te(Xo));r|=un}return st(t,r,n,e,u)});function na(n,t,e){t=e?a:t;var r=st(n,mn,a,a,a,a,a,t);return r.placeholder=na.placeholder,r}function ta(n,t,e){t=e?a:t;var r=st(n,ot,a,a,a,a,a,t);return r.placeholder=ta.placeholder,r}function ea(n,t,e){var r,u,o,f,c,s,v=0,_=!1,g=!1,m=!0;if(typeof n!="function")throw new Nn(z);t=Yn(t)||0,V(e)&&(_=!!e.leading,g="maxWait"in e,o=g?Q(Yn(e.maxWait)||0,t):o,m="trailing"in e?!!e.trailing:m);function w(G){var tt=r,gt=u;return r=u=a,v=G,f=n.apply(gt,tt),f}function j(G){return v=G,c=De($,t),_?w(G):f}function S(G){var tt=G-s,gt=G-v,wa=t-tt;return g?pn(wa,o-gt):wa}function A(G){var tt=G-s,gt=G-v;return s===a||tt>=t||tt<0||g&&gt>=o}function $(){var G=sr();if(A(G))return F(G);c=De($,S(G))}function F(G){return c=a,m&&r?w(G):(r=u=a,f)}function $n(){c!==a&&so(c),v=0,r=s=u=c=a}function yn(){return c===a?f:F(sr())}function Bn(){var G=sr(),tt=A(G);if(r=arguments,u=this,s=G,tt){if(c===a)return j(s);if(g)return so(c),c=De($,t),w(s)}return c===a&&(c=De($,t)),f}return Bn.cancel=$n,Bn.flush=yn,Bn}var S0=I(function(n,t){return qi(n,1,t)}),I0=I(function(n,t,e){return qi(n,Yn(t)||0,e)});function $0(n){return st(n,Wn)}function pr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new Nn(z);var e=function(){var r=arguments,u=t?t.apply(this,r):r[0],o=e.cache;if(o.has(u))return o.get(u);var f=n.apply(this,r);return e.cache=o.set(u,f)||o,f};return e.cache=new(pr.Cache||ct),e}pr.Cache=ct;function hr(n){if(typeof n!="function")throw new Nn(z);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function B0(n){return Qo(2,n)}var F0=bl(function(n,t){t=t.length==1&&E(t[0])?q(t[0],kn(x())):q(an(t,1),kn(x()));var e=t.length;return I(function(r){for(var u=-1,o=pn(r.length,e);++u<o;)r[u]=t[u].call(this,r[u]);return On(n,this,r)})}),Su=I(function(n,t){var e=xt(t,te(Su));return st(n,un,a,t,e)}),ra=I(function(n,t){var e=xt(t,te(ra));return st(n,on,a,t,e)}),R0=pt(function(n,t){return st(n,Cn,a,a,a,t)});function z0(n,t){if(typeof n!="function")throw new Nn(z);return t=t===a?t:k(t),I(n,t)}function W0(n,t){if(typeof n!="function")throw new Nn(z);return t=t==null?0:Q(k(t),0),I(function(e){var r=e[t],u=Ot(e,0,t);return r&&wt(u,r),On(n,this,u)})}function U0(n,t,e){var r=!0,u=!0;if(typeof n!="function")throw new Nn(z);return V(e)&&(r="leading"in e?!!e.leading:r,u="trailing"in e?!!e.trailing:u),ea(n,t,{leading:r,maxWait:t,trailing:u})}function M0(n){return Jo(n,1)}function L0(n,t){return Su(vu(t),n)}function N0(){if(!arguments.length)return[];var n=arguments[0];return E(n)?n:[n]}function P0(n){return Tn(n,Un)}function T0(n,t){return t=typeof t=="function"?t:a,Tn(n,Un,t)}function q0(n){return Tn(n,sn|Un)}function V0(n,t){return t=typeof t=="function"?t:a,Tn(n,sn|Un,t)}function Y0(n,t){return t==null||Ti(n,t,tn(t))}function nt(n,t){return n===t||n!==n&&t!==t}var Z0=ir(eu),H0=ir(function(n,t){return n>=t}),Nt=Ki(function(){return arguments}())?Ki:function(n){return H(n)&&M.call(n,"callee")&&!Ri.call(n,"callee")},E=p.isArray,K0=gi?kn(gi):rl;function xn(n){return n!=null&&vr(n.length)&&!vt(n)}function K(n){return H(n)&&xn(n)}function G0(n){return n===!0||n===!1||H(n)&&_n(n)==$t}var kt=lc||Nu,J0=yi?kn(yi):ul;function Q0(n){return H(n)&&n.nodeType===1&&!Ee(n)}function X0(n){if(n==null)return!0;if(xn(n)&&(E(n)||typeof n=="string"||typeof n.splice=="function"||kt(n)||ee(n)||Nt(n)))return!n.length;var t=hn(n);if(t==Hn||t==Jn)return!n.size;if(Ae(n))return!iu(n).length;for(var e in n)if(M.call(n,e))return!1;return!0}function np(n,t){return we(n,t)}function tp(n,t,e){e=typeof e=="function"?e:a;var r=e?e(n,t):a;return r===a?we(n,t,a,e):!!r}function Iu(n){if(!H(n))return!1;var t=_n(n);return t==ue||t==yr||typeof n.message=="string"&&typeof n.name=="string"&&!Ee(n)}function ep(n){return typeof n=="number"&&Wi(n)}function vt(n){if(!V(n))return!1;var t=_n(n);return t==ie||t==qu||t==Tu||t==Da}function ua(n){return typeof n=="number"&&n==k(n)}function vr(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=en}function V(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function H(n){return n!=null&&typeof n=="object"}var ia=di?kn(di):ol;function rp(n,t){return n===t||uu(n,t,wu(t))}function up(n,t,e){return e=typeof e=="function"?e:a,uu(n,t,wu(t),e)}function ip(n){return oa(n)&&n!=+n}function op(n){if(Tl(n))throw new D(L);return Gi(n)}function ap(n){return n===null}function fp(n){return n==null}function oa(n){return typeof n=="number"||H(n)&&_n(n)==oe}function Ee(n){if(!H(n)||_n(n)!=at)return!1;var t=Ne(n);if(t===null)return!0;var e=M.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&We.call(e)==uc}var $u=mi?kn(mi):al;function cp(n){return ua(n)&&n>=-en&&n<=en}var aa=bi?kn(bi):fl;function _r(n){return typeof n=="string"||!E(n)&&H(n)&&_n(n)==ce}function In(n){return typeof n=="symbol"||H(n)&&_n(n)==Oe}var ee=wi?kn(wi):cl;function lp(n){return n===a}function sp(n){return H(n)&&hn(n)==le}function pp(n){return H(n)&&_n(n)==Ca}var hp=ir(ou),vp=ir(function(n,t){return n<=t});function fa(n){if(!n)return[];if(xn(n))return _r(n)?Qn(n):wn(n);if(he&&n[he])return Yf(n[he]());var t=hn(n),e=t==Hn?Zr:t==Jn?Fe:re;return e(n)}function _t(n){if(!n)return n===0?n:0;if(n=Yn(n),n===Z||n===-Z){var t=n<0?-1:1;return t*Zn}return n===n?n:0}function k(n){var t=_t(n),e=t%1;return t===t?e?t-e:t:0}function ca(n){return n?Wt(k(n),0,vn):0}function Yn(n){if(typeof n=="number")return n;if(In(n))return Kn;if(V(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=V(t)?t+"":t}if(typeof n!="string")return n===0?n:+n;n=Ci(n);var e=Ha.test(n);return e||Ga.test(n)?kf(n.slice(2),e?2:8):Za.test(n)?Kn:+n}function la(n){return rt(n,jn(n))}function _p(n){return n?Wt(k(n),-en,en):n===0?n:0}function U(n){return n==null?"":Sn(n)}var gp=Xt(function(n,t){if(Ae(t)||xn(t)){rt(t,tn(t),n);return}for(var e in t)M.call(t,e)&&de(n,e,t[e])}),sa=Xt(function(n,t){rt(t,jn(t),n)}),gr=Xt(function(n,t,e,r){rt(t,jn(t),n,r)}),yp=Xt(function(n,t,e,r){rt(t,tn(t),n,r)}),dp=pt(Xr);function mp(n,t){var e=Qt(n);return t==null?e:Pi(e,t)}var bp=I(function(n,t){n=N(n);var e=-1,r=t.length,u=r>2?t[2]:a;for(u&&gn(t[0],t[1],u)&&(r=1);++e<r;)for(var o=t[e],f=jn(o),c=-1,s=f.length;++c<s;){var v=f[c],_=n[v];(_===a||nt(_,Kt[v])&&!M.call(n,v))&&(n[v]=o[v])}return n}),wp=I(function(n){return n.push(a,Oo),On(pa,a,n)});function xp(n,t){return ji(n,x(t,3),et)}function jp(n,t){return ji(n,x(t,3),tu)}function Ap(n,t){return n==null?n:nu(n,x(t,3),jn)}function Dp(n,t){return n==null?n:Zi(n,x(t,3),jn)}function Ep(n,t){return n&&et(n,x(t,3))}function Cp(n,t){return n&&tu(n,x(t,3))}function Op(n){return n==null?[]:Je(n,tn(n))}function kp(n){return n==null?[]:Je(n,jn(n))}function Bu(n,t,e){var r=n==null?a:Ut(n,t);return r===a?e:r}function Sp(n,t){return n!=null&&Io(n,t,Xc)}function Fu(n,t){return n!=null&&Io(n,t,nl)}var Ip=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),n[t]=e},zu(An)),$p=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),M.call(n,t)?n[t].push(e):n[t]=[e]},x),Bp=I(be);function tn(n){return xn(n)?Li(n):iu(n)}function jn(n){return xn(n)?Li(n,!0):ll(n)}function Fp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,t(r,u,o),r)}),e}function Rp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,u,t(r,u,o))}),e}var zp=Xt(function(n,t,e){Qe(n,t,e)}),pa=Xt(function(n,t,e,r){Qe(n,t,e,r)}),Wp=pt(function(n,t){var e={};if(n==null)return e;var r=!1;t=q(t,function(o){return o=Ct(o,n),r||(r=o.length>1),o}),rt(n,mu(n),e),r&&(e=Tn(e,sn|dt|Un,Il));for(var u=t.length;u--;)su(e,t[u]);return e});function Up(n,t){return ha(n,hr(x(t)))}var Mp=pt(function(n,t){return n==null?{}:pl(n,t)});function ha(n,t){if(n==null)return{};var e=q(mu(n),function(r){return[r]});return t=x(t),ro(n,e,function(r,u){return t(r,u[0])})}function Lp(n,t,e){t=Ct(t,n);var r=-1,u=t.length;for(u||(u=1,n=a);++r<u;){var o=n==null?a:n[ut(t[r])];o===a&&(r=u,o=e),n=vt(o)?o.call(n):o}return n}function Np(n,t,e){return n==null?n:xe(n,t,e)}function Pp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:xe(n,t,e,r)}var va=Eo(tn),_a=Eo(jn);function Tp(n,t,e){var r=E(n),u=r||kt(n)||ee(n);if(t=x(t,4),e==null){var o=n&&n.constructor;u?e=r?new o:[]:V(n)?e=vt(o)?Qt(Ne(n)):{}:e={}}return(u?Ln:et)(n,function(f,c,s){return t(e,f,c,s)}),e}function qp(n,t){return n==null?!0:su(n,t)}function Vp(n,t,e){return n==null?n:fo(n,t,vu(e))}function Yp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:fo(n,t,vu(e),r)}function re(n){return n==null?[]:Yr(n,tn(n))}function Zp(n){return n==null?[]:Yr(n,jn(n))}function Hp(n,t,e){return e===a&&(e=t,t=a),e!==a&&(e=Yn(e),e=e===e?e:0),t!==a&&(t=Yn(t),t=t===t?t:0),Wt(Yn(n),t,e)}function Kp(n,t,e){return t=_t(t),e===a?(e=t,t=0):e=_t(e),n=Yn(n),tl(n,t,e)}function Gp(n,t,e){if(e&&typeof e!="boolean"&&gn(n,t,e)&&(t=e=a),e===a&&(typeof t=="boolean"?(e=t,t=a):typeof n=="boolean"&&(e=n,n=a)),n===a&&t===a?(n=0,t=1):(n=_t(n),t===a?(t=n,n=0):t=_t(t)),n>t){var r=n;n=t,t=r}if(e||n%1||t%1){var u=Ui();return pn(n+u*(t-n+Of("1e-"+((u+"").length-1))),t)}return fu(n,t)}var Jp=ne(function(n,t,e){return t=t.toLowerCase(),n+(e?ga(t):t)});function ga(n){return Ru(U(n).toLowerCase())}function ya(n){return n=U(n),n&&n.replace(Qa,Nf).replace(df,"")}function Qp(n,t,e){n=U(n),t=Sn(t);var r=n.length;e=e===a?r:Wt(k(e),0,r);var u=e;return e-=t.length,e>=0&&n.slice(e,u)==t}function Xp(n){return n=U(n),n&&$a.test(n)?n.replace(Zu,Pf):n}function nh(n){return n=U(n),n&&Ua.test(n)?n.replace(Sr,"\\$&"):n}var th=ne(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),eh=ne(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),rh=bo("toLowerCase");function uh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;if(!t||r>=t)return n;var u=(t-r)/2;return ur(Ve(u),e)+n+ur(qe(u),e)}function ih(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?n+ur(t-r,e):n}function oh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?ur(t-r,e)+n:n}function ah(n,t,e){return e||t==null?t=0:t&&(t=+t),vc(U(n).replace(Ir,""),t||0)}function fh(n,t,e){return(e?gn(n,t,e):t===a)?t=1:t=k(t),cu(U(n),t)}function ch(){var n=arguments,t=U(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var lh=ne(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function sh(n,t,e){return e&&typeof e!="number"&&gn(n,t,e)&&(t=e=a),e=e===a?vn:e>>>0,e?(n=U(n),n&&(typeof t=="string"||t!=null&&!$u(t))&&(t=Sn(t),!t&&Zt(n))?Ot(Qn(n),0,e):n.split(t,e)):[]}var ph=ne(function(n,t,e){return n+(e?" ":"")+Ru(t)});function hh(n,t,e){return n=U(n),e=e==null?0:Wt(k(e),0,n.length),t=Sn(t),n.slice(e,e+t.length)==t}function vh(n,t,e){var r=i.templateSettings;e&&gn(n,t,e)&&(t=a),n=U(n),t=gr({},t,r,Co);var u=gr({},t.imports,r.imports,Co),o=tn(u),f=Yr(u,o),c,s,v=0,_=t.interpolate||ke,g="__p += '",m=Hr((t.escape||ke).source+"|"+_.source+"|"+(_===Hu?Ya:ke).source+"|"+(t.evaluate||ke).source+"|$","g"),w="//# sourceURL="+(M.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++jf+"]")+`
`;n.replace(m,function(A,$,F,$n,yn,Bn){return F||(F=$n),g+=n.slice(v,Bn).replace(Xa,Tf),$&&(c=!0,g+=`' +
__e(`+$+`) +
'`),yn&&(s=!0,g+=`';
`+yn+`;
__p += '`),F&&(g+=`' +
((__t = (`+F+`)) == null ? '' : __t) +
'`),v=Bn+A.length,A}),g+=`';
`;var j=M.call(t,"variable")&&t.variable;if(!j)g=`with (obj) {
`+g+`
}
`;else if(qa.test(j))throw new D(fn);g=(s?g.replace(Oa,""):g).replace(ka,"$1").replace(Sa,"$1;"),g="function("+(j||"obj")+`) {
`+(j?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(s?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+g+`return __p
}`;var S=ma(function(){return W(o,w+"return "+g).apply(a,f)});if(S.source=g,Iu(S))throw S;return S}function _h(n){return U(n).toLowerCase()}function gh(n){return U(n).toUpperCase()}function yh(n,t,e){if(n=U(n),n&&(e||t===a))return Ci(n);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Qn(t),o=Oi(r,u),f=ki(r,u)+1;return Ot(r,o,f).join("")}function dh(n,t,e){if(n=U(n),n&&(e||t===a))return n.slice(0,Ii(n)+1);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=ki(r,Qn(t))+1;return Ot(r,0,u).join("")}function mh(n,t,e){if(n=U(n),n&&(e||t===a))return n.replace(Ir,"");if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Oi(r,Qn(t));return Ot(r,u).join("")}function bh(n,t){var e=Fn,r=It;if(V(t)){var u="separator"in t?t.separator:u;e="length"in t?k(t.length):e,r="omission"in t?Sn(t.omission):r}n=U(n);var o=n.length;if(Zt(n)){var f=Qn(n);o=f.length}if(e>=o)return n;var c=e-Ht(r);if(c<1)return r;var s=f?Ot(f,0,c).join(""):n.slice(0,c);if(u===a)return s+r;if(f&&(c+=s.length-c),$u(u)){if(n.slice(c).search(u)){var v,_=s;for(u.global||(u=Hr(u.source,U(Ku.exec(u))+"g")),u.lastIndex=0;v=u.exec(_);)var g=v.index;s=s.slice(0,g===a?c:g)}}else if(n.indexOf(Sn(u),c)!=c){var m=s.lastIndexOf(u);m>-1&&(s=s.slice(0,m))}return s+r}function wh(n){return n=U(n),n&&Ia.test(n)?n.replace(Yu,Gf):n}var xh=ne(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Ru=bo("toUpperCase");function da(n,t,e){return n=U(n),t=e?a:t,t===a?Vf(n)?Xf(n):zf(n):n.match(t)||[]}var ma=I(function(n,t){try{return On(n,a,t)}catch(e){return Iu(e)?e:new D(e)}}),jh=pt(function(n,t){return Ln(t,function(e){e=ut(e),lt(n,e,ku(n[e],n))}),n});function Ah(n){var t=n==null?0:n.length,e=x();return n=t?q(n,function(r){if(typeof r[1]!="function")throw new Nn(z);return[e(r[0]),r[1]]}):[],I(function(r){for(var u=-1;++u<t;){var o=n[u];if(On(o[0],this,r))return On(o[1],this,r)}})}function Dh(n){return Gc(Tn(n,sn))}function zu(n){return function(){return n}}function Eh(n,t){return n==null||n!==n?t:n}var Ch=xo(),Oh=xo(!0);function An(n){return n}function Wu(n){return Ji(typeof n=="function"?n:Tn(n,sn))}function kh(n){return Xi(Tn(n,sn))}function Sh(n,t){return no(n,Tn(t,sn))}var Ih=I(function(n,t){return function(e){return be(e,n,t)}}),$h=I(function(n,t){return function(e){return be(n,e,t)}});function Uu(n,t,e){var r=tn(t),u=Je(t,r);e==null&&!(V(t)&&(u.length||!r.length))&&(e=t,t=n,n=this,u=Je(t,tn(t)));var o=!(V(e)&&"chain"in e)||!!e.chain,f=vt(n);return Ln(u,function(c){var s=t[c];n[c]=s,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),g=_.__actions__=wn(this.__actions__);return g.push({func:s,args:arguments,thisArg:n}),_.__chain__=v,_}return s.apply(n,wt([this.value()],arguments))})}),n}function Bh(){return nn._===this&&(nn._=ic),this}function Mu(){}function Fh(n){return n=k(n),I(function(t){return to(t,n)})}var Rh=gu(q),zh=gu(xi),Wh=gu(Nr);function ba(n){return ju(n)?Pr(ut(n)):hl(n)}function Uh(n){return function(t){return n==null?a:Ut(n,t)}}var Mh=Ao(),Lh=Ao(!0);function Lu(){return[]}function Nu(){return!1}function Nh(){return{}}function Ph(){return""}function Th(){return!0}function qh(n,t){if(n=k(n),n<1||n>en)return[];var e=vn,r=pn(n,vn);t=x(t),n-=vn;for(var u=Vr(r,t);++e<n;)t(e);return u}function Vh(n){return E(n)?q(n,ut):In(n)?[n]:wn(Lo(U(n)))}function Yh(n){var t=++rc;return U(n)+t}var Zh=rr(function(n,t){return n+t},0),Hh=yu("ceil"),Kh=rr(function(n,t){return n/t},1),Gh=yu("floor");function Jh(n){return n&&n.length?Ge(n,An,eu):a}function Qh(n,t){return n&&n.length?Ge(n,x(t,2),eu):a}function Xh(n){return Di(n,An)}function nv(n,t){return Di(n,x(t,2))}function tv(n){return n&&n.length?Ge(n,An,ou):a}function ev(n,t){return n&&n.length?Ge(n,x(t,2),ou):a}var rv=rr(function(n,t){return n*t},1),uv=yu("round"),iv=rr(function(n,t){return n-t},0);function ov(n){return n&&n.length?qr(n,An):0}function av(n,t){return n&&n.length?qr(n,x(t,2)):0}return i.after=k0,i.ary=Jo,i.assign=gp,i.assignIn=sa,i.assignInWith=gr,i.assignWith=yp,i.at=dp,i.before=Qo,i.bind=ku,i.bindAll=jh,i.bindKey=Xo,i.castArray=N0,i.chain=Ho,i.chunk=Gl,i.compact=Jl,i.concat=Ql,i.cond=Ah,i.conforms=Dh,i.constant=zu,i.countBy=o0,i.create=mp,i.curry=na,i.curryRight=ta,i.debounce=ea,i.defaults=bp,i.defaultsDeep=wp,i.defer=S0,i.delay=I0,i.difference=Xl,i.differenceBy=ns,i.differenceWith=ts,i.drop=es,i.dropRight=rs,i.dropRightWhile=us,i.dropWhile=is,i.fill=os,i.filter=f0,i.flatMap=s0,i.flatMapDeep=p0,i.flatMapDepth=h0,i.flatten=qo,i.flattenDeep=as,i.flattenDepth=fs,i.flip=$0,i.flow=Ch,i.flowRight=Oh,i.fromPairs=cs,i.functions=Op,i.functionsIn=kp,i.groupBy=v0,i.initial=ss,i.intersection=ps,i.intersectionBy=hs,i.intersectionWith=vs,i.invert=Ip,i.invertBy=$p,i.invokeMap=g0,i.iteratee=Wu,i.keyBy=y0,i.keys=tn,i.keysIn=jn,i.map=lr,i.mapKeys=Fp,i.mapValues=Rp,i.matches=kh,i.matchesProperty=Sh,i.memoize=pr,i.merge=zp,i.mergeWith=pa,i.method=Ih,i.methodOf=$h,i.mixin=Uu,i.negate=hr,i.nthArg=Fh,i.omit=Wp,i.omitBy=Up,i.once=B0,i.orderBy=d0,i.over=Rh,i.overArgs=F0,i.overEvery=zh,i.overSome=Wh,i.partial=Su,i.partialRight=ra,i.partition=m0,i.pick=Mp,i.pickBy=ha,i.property=ba,i.propertyOf=Uh,i.pull=ds,i.pullAll=Yo,i.pullAllBy=ms,i.pullAllWith=bs,i.pullAt=ws,i.range=Mh,i.rangeRight=Lh,i.rearg=R0,i.reject=x0,i.remove=xs,i.rest=z0,i.reverse=Cu,i.sampleSize=A0,i.set=Np,i.setWith=Pp,i.shuffle=D0,i.slice=js,i.sortBy=O0,i.sortedUniq=Ss,i.sortedUniqBy=Is,i.split=sh,i.spread=W0,i.tail=$s,i.take=Bs,i.takeRight=Fs,i.takeRightWhile=Rs,i.takeWhile=zs,i.tap=Js,i.throttle=U0,i.thru=cr,i.toArray=fa,i.toPairs=va,i.toPairsIn=_a,i.toPath=Vh,i.toPlainObject=la,i.transform=Tp,i.unary=M0,i.union=Ws,i.unionBy=Us,i.unionWith=Ms,i.uniq=Ls,i.uniqBy=Ns,i.uniqWith=Ps,i.unset=qp,i.unzip=Ou,i.unzipWith=Zo,i.update=Vp,i.updateWith=Yp,i.values=re,i.valuesIn=Zp,i.without=Ts,i.words=da,i.wrap=L0,i.xor=qs,i.xorBy=Vs,i.xorWith=Ys,i.zip=Zs,i.zipObject=Hs,i.zipObjectDeep=Ks,i.zipWith=Gs,i.entries=va,i.entriesIn=_a,i.extend=sa,i.extendWith=gr,Uu(i,i),i.add=Zh,i.attempt=ma,i.camelCase=Jp,i.capitalize=ga,i.ceil=Hh,i.clamp=Hp,i.clone=P0,i.cloneDeep=q0,i.cloneDeepWith=V0,i.cloneWith=T0,i.conformsTo=Y0,i.deburr=ya,i.defaultTo=Eh,i.divide=Kh,i.endsWith=Qp,i.eq=nt,i.escape=Xp,i.escapeRegExp=nh,i.every=a0,i.find=c0,i.findIndex=Po,i.findKey=xp,i.findLast=l0,i.findLastIndex=To,i.findLastKey=jp,i.floor=Gh,i.forEach=Ko,i.forEachRight=Go,i.forIn=Ap,i.forInRight=Dp,i.forOwn=Ep,i.forOwnRight=Cp,i.get=Bu,i.gt=Z0,i.gte=H0,i.has=Sp,i.hasIn=Fu,i.head=Vo,i.identity=An,i.includes=_0,i.indexOf=ls,i.inRange=Kp,i.invoke=Bp,i.isArguments=Nt,i.isArray=E,i.isArrayBuffer=K0,i.isArrayLike=xn,i.isArrayLikeObject=K,i.isBoolean=G0,i.isBuffer=kt,i.isDate=J0,i.isElement=Q0,i.isEmpty=X0,i.isEqual=np,i.isEqualWith=tp,i.isError=Iu,i.isFinite=ep,i.isFunction=vt,i.isInteger=ua,i.isLength=vr,i.isMap=ia,i.isMatch=rp,i.isMatchWith=up,i.isNaN=ip,i.isNative=op,i.isNil=fp,i.isNull=ap,i.isNumber=oa,i.isObject=V,i.isObjectLike=H,i.isPlainObject=Ee,i.isRegExp=$u,i.isSafeInteger=cp,i.isSet=aa,i.isString=_r,i.isSymbol=In,i.isTypedArray=ee,i.isUndefined=lp,i.isWeakMap=sp,i.isWeakSet=pp,i.join=_s,i.kebabCase=th,i.last=Vn,i.lastIndexOf=gs,i.lowerCase=eh,i.lowerFirst=rh,i.lt=hp,i.lte=vp,i.max=Jh,i.maxBy=Qh,i.mean=Xh,i.meanBy=nv,i.min=tv,i.minBy=ev,i.stubArray=Lu,i.stubFalse=Nu,i.stubObject=Nh,i.stubString=Ph,i.stubTrue=Th,i.multiply=rv,i.nth=ys,i.noConflict=Bh,i.noop=Mu,i.now=sr,i.pad=uh,i.padEnd=ih,i.padStart=oh,i.parseInt=ah,i.random=Gp,i.reduce=b0,i.reduceRight=w0,i.repeat=fh,i.replace=ch,i.result=Lp,i.round=uv,i.runInContext=l,i.sample=j0,i.size=E0,i.snakeCase=lh,i.some=C0,i.sortedIndex=As,i.sortedIndexBy=Ds,i.sortedIndexOf=Es,i.sortedLastIndex=Cs,i.sortedLastIndexBy=Os,i.sortedLastIndexOf=ks,i.startCase=ph,i.startsWith=hh,i.subtract=iv,i.sum=ov,i.sumBy=av,i.template=vh,i.times=qh,i.toFinite=_t,i.toInteger=k,i.toLength=ca,i.toLower=_h,i.toNumber=Yn,i.toSafeInteger=_p,i.toString=U,i.toUpper=gh,i.trim=yh,i.trimEnd=dh,i.trimStart=mh,i.truncate=bh,i.unescape=wh,i.uniqueId=Yh,i.upperCase=xh,i.upperFirst=Ru,i.each=Ko,i.eachRight=Go,i.first=Vo,Uu(i,function(){var n={};return et(i,function(t,e){M.call(i.prototype,e)||(n[e]=t)}),n}(),{chain:!1}),i.VERSION=O,Ln(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){i[n].placeholder=i}),Ln(["drop","take"],function(n,t){B.prototype[n]=function(e){e=e===a?1:Q(k(e),0);var r=this.__filtered__&&!t?new B(this):this.clone();return r.__filtered__?r.__takeCount__=pn(e,r.__takeCount__):r.__views__.push({size:pn(e,vn),type:n+(r.__dir__<0?"Right":"")}),r},B.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()}}),Ln(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==cn||e==Gn;B.prototype[n]=function(u){var o=this.clone();return o.__iteratees__.push({iteratee:x(u,3),type:e}),o.__filtered__=o.__filtered__||r,o}}),Ln(["head","last"],function(n,t){var e="take"+(t?"Right":"");B.prototype[n]=function(){return this[e](1).value()[0]}}),Ln(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");B.prototype[n]=function(){return this.__filtered__?new B(this):this[e](1)}}),B.prototype.compact=function(){return this.filter(An)},B.prototype.find=function(n){return this.filter(n).head()},B.prototype.findLast=function(n){return this.reverse().find(n)},B.prototype.invokeMap=I(function(n,t){return typeof n=="function"?new B(this):this.map(function(e){return be(e,n,t)})}),B.prototype.reject=function(n){return this.filter(hr(x(n)))},B.prototype.slice=function(n,t){n=k(n);var e=this;return e.__filtered__&&(n>0||t<0)?new B(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==a&&(t=k(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},B.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},B.prototype.toArray=function(){return this.take(vn)},et(B.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),u=i[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);!u||(i.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,s=f instanceof B,v=c[0],_=s||E(f),g=function($){var F=u.apply(i,wt([$],c));return r&&m?F[0]:F};_&&e&&typeof v=="function"&&v.length!=1&&(s=_=!1);var m=this.__chain__,w=!!this.__actions__.length,j=o&&!m,S=s&&!w;if(!o&&_){f=S?f:new B(this);var A=n.apply(f,c);return A.__actions__.push({func:cr,args:[g],thisArg:a}),new Pn(A,m)}return j&&S?n.apply(this,c):(A=this.thru(g),j?r?A.value()[0]:A.value():A)})}),Ln(["pop","push","shift","sort","splice","unshift"],function(n){var t=Re[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);i.prototype[n]=function(){var u=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(E(o)?o:[],u)}return this[e](function(f){return t.apply(E(f)?f:[],u)})}}),et(B.prototype,function(n,t){var e=i[t];if(e){var r=e.name+"";M.call(Jt,r)||(Jt[r]=[]),Jt[r].push({name:t,func:e})}}),Jt[er(a,En).name]=[{name:"wrapper",func:a}],B.prototype.clone=wc,B.prototype.reverse=xc,B.prototype.value=jc,i.prototype.at=Qs,i.prototype.chain=Xs,i.prototype.commit=n0,i.prototype.next=t0,i.prototype.plant=r0,i.prototype.reverse=u0,i.prototype.toJSON=i.prototype.valueOf=i.prototype.value=i0,i.prototype.first=i.prototype.head,he&&(i.prototype[he]=e0),i},jt=nc();typeof define=="function"&&typeof __webpack_require__("3c35")=="object"&&__webpack_require__("3c35")?(nn._=jt,define(function(){return jt})):Bt?((Bt.exports=jt)._=jt,Wr._=jt):nn._=jt}).call(y)}),Jv=Kv(Gv()),cv=Kv(Gv()),L_=y=>y==="",N_=(y="")=>{let d;return y.startsWith("?")?d=y.substring(1):d=y,L_(d)?{}:d.split("&").reduce((a,O)=>{let[R,L=null]=O.split("="),z=(0,cv.isNull)(L)?L:decodeURIComponent(L);return(0,cv.isUndefined)(a[R])?a[R]=z:a[R]=(0,cv.flatten)([a[R],z]),a},{})},P_=(y={})=>Object.entries(y||{}).reduce((d,a)=>{let[O,R]=a;if((0,cv.isUndefined)(R))return d;if((0,cv.isNull)(R))d.push(O);else{let L=(0,cv.flatten)([R]).filter(z=>!(0,cv.isUndefined)(z)).map(z=>{let fn=encodeURIComponent(z);return(0,cv.isNull)(z)?O:[O,fn].join("=")});d.push(...L)}return d},[]).join("&"),Fv=(y={})=>{y&&Object.entries(y).forEach(([d,a])=>{typeof a=="object"?Fv(a):typeof a=="string"&&(y[d]=a.trim())})},T_={Accept:"application/json","Content-Type":"application/json"};function Qv(y){let d={};return y.headers&&(d=y.headers,delete y.headers),{credentials:"same-origin",headers:hv(hv({},T_),d)}}function q_(y,d,a){return!y||!y.status?Promise.reject({__status__:"canceled"}):y.status>=200&&y.status<300?y:y.json().then(O=>{let R=new Error(O&&O.msg||y.statusText);return O&&O.code&&(R.code=O.code),R}).catch(()=>new Error(y.statusText)).then(O=>{throw O.type="http",O.status=y.status,O})}function V_(y,d,a){return y?y.headers.get("content-length")==="0"?{code:0,msg:"success",data:null}:y.json().then(O=>O).catch(O=>{throw O&&(O.res=y),O}):Promise.reject({__status__:"canceled"})}function Y_(y){if(y){if(+y.code==0)return y.data;if(Object.keys(y).length===1)return y;let d=`${y.msg||y.message||y.error&&y.error.msg||y.error&&y.error.errMsg||""}`,a=new Error(d);throw a.data=y,a.type="data",a}else{let d=new Error(y);throw d.data=y,d.type="data",d}}function Xv(y,d,a){d.headers["Content-Type"]&&d.headers["Content-Type"].toLowerCase().includes("multipart/form-data")&&delete d.headers["Content-Type"];let O=Date.now(),R=fetch(y,d).then(L=>q_(L,y,Date.now()-O)).then(L=>V_(L,y,Date.now()-O));return a.parseData!==!1&&(R=R.then(Y_)),R.catch(L=>{if(L.__status__!=="canceled")throw(a.catHandler||(()=>{}))(y,L),L})}function n_(y){let d={};return Object.keys(y).forEach(a=>{y[a]!==void 0&&(d[a]=y[a])}),P_(d)}function Z_(y){return JSON.stringify(y)}function H_(y){if(y instanceof FormData)return y;let d=new FormData;return Object.keys(y).forEach(a=>{d.append(a,y[a])}),d}function xv({url:y,params:d={},options:a={}}){let O=Qv(a),R=y.split("?")[1]||"";y=y.split("?")[0];try{R=N_(R)}catch(fn){console.error("request:get",R,fn)}R=Object.assign(R||{},d),Fv(R);let L=n_(R);y+=`${L?"?":""}${L}`;let z=hv({method:"GET",params:d},O);return Xv(y,z,a)}function t_({url:y,body:d={},options:a={}}){let O=Qv(a);switch(!0){case O.headers["Content-Type"].includes("application/json"):Fv(d),d=Z_(d);break;case O.headers["Content-Type"].includes("application/x-www-form-urlencoded"):d=n_(d);break;case O.headers["Content-Type"].includes("multipart/form-data"):d=H_(d);break}let R=hv({method:"POST",body:d},O);return Xv(y,R,a)}var e_=[];function jv(y,{prefix:d=""}={},a=!1){return function(O,R,L={}){let z=L,{cache:fn=!1,useDefaultErrorCallback:dn=!0}=z,rn=W_(z,["cache","useDefaultErrorCallback"]),Dn=O;typeof O=="string"&&(Dn={},Dn.url=a?[window.location.origin,O].join(""):O,Dn.options=rn,Dn[y===xv?"params":"body"]=R),Dn.url.startsWith("/")&&(Dn.url=`${d}${Dn.url}`);let sn;if(fn){let dt={url:Dn.url,method:y===xv?"get":"post",params:Dn.params,body:Dn.body},Un=e_.find(Rn=>(0,Jv.isEqual)((0,Jv.pick)(Rn,Object.keys(dt)),hv({},dt)));Un?sn=Un.rsPromise:(sn=y(Dn),e_.push(R_(hv({},dt),{rsPromise:sn})))}else sn=y(Dn);return window.__requestSuccCallback&&sn.then(dt=>{window.__requestSuccCallback&&window.__requestSuccCallback(dt,Dn)}),dn&&window.__requestErrorCallback&&sn.catch(dt=>{window.__requestErrorCallback&&window.__requestErrorCallback(dt,Dn)}),sn}}var Av=y=>({get:jv(xv,y),post:jv(t_,y),hGet:jv(xv,y,!0),hPost:jv(t_,y,!0),go(d){d.startsWith("/")&&(d=`${y&&y.prefix||""}${d}`),window.location.href=d}}),kg=Av().get;var Sg=Av().post;var Ig=Av().hGet;var $g=Av().hPost;var Bg=sv(pv());var zg=sv(pv());var Wg=sv(pv());var Ug=sv(pv());var K_=Object.create,Rv=Object.defineProperty,G_=Object.getOwnPropertyDescriptor,J_=Object.getOwnPropertyNames,Q_=Object.getPrototypeOf,X_=Object.prototype.hasOwnProperty,n1=y=>Rv(y,"__esModule",{value:!0}),yv=(y,d)=>()=>(d||y((d={exports:{}}).exports,d),d.exports),t1=(y,d,a)=>{if(d&&typeof d=="object"||typeof d=="function")for(let O of J_(d))!X_.call(y,O)&&O!=="default"&&Rv(y,O,{get:()=>d[O],enumerable:!(a=G_(d,O))||a.enumerable});return y},Pu=y=>t1(n1(Rv(y!=null?K_(Q_(y)):{},"default",y&&y.__esModule&&"default"in y?{get:()=>y.default,enumerable:!0}:{value:y,enumerable:!0})),y),fv=yv((y,d)=>{(function(a,O){typeof y=="object"&&typeof d!="undefined"?d.exports=O():typeof define=="function"&&__webpack_require__("3c35")?define(O):(a=typeof globalThis!="undefined"?globalThis:a||self).dayjs=O()})(y,function(){"use strict";var a=1e3,O=6e4,R=36e5,L="millisecond",z="second",fn="minute",dn="hour",rn="day",Dn="week",sn="month",dt="quarter",Un="year",Rn="date",bn="Invalid Date",X=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,En=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,St={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},mn=function(zn,cn,ln){var Gn=String(zn);return!Gn||Gn.length>=cn?zn:""+Array(cn+1-Gn.length).join(ln)+zn},ot={s:mn,z:function(zn){var cn=-zn.utcOffset(),ln=Math.abs(cn),Gn=Math.floor(ln/60),Z=ln%60;return(cn<=0?"+":"-")+mn(Gn,2,"0")+":"+mn(Z,2,"0")},m:function zn(cn,ln){if(cn.date()<ln.date())return-zn(ln,cn);var Gn=12*(ln.year()-cn.year())+(ln.month()-cn.month()),Z=cn.clone().add(Gn,sn),en=ln-Z<0,Zn=cn.clone().add(Gn+(en?-1:1),sn);return+(-(Gn+(ln-Z)/(en?Z-Zn:Zn-Z))||0)},a:function(zn){return zn<0?Math.ceil(zn)||0:Math.floor(zn)},p:function(zn){return{M:sn,y:Un,w:Dn,d:rn,D:Rn,h:dn,m:fn,s:z,ms:L,Q:dt}[zn]||String(zn||"").toLowerCase().replace(/s$/,"")},u:function(zn){return zn===void 0}},un="en",on={};on[un]=St;var Y=function(zn){return zn instanceof It},Cn=function zn(cn,ln,Gn){var Z;if(!cn)return un;if(typeof cn=="string"){var en=cn.toLowerCase();on[en]&&(Z=en),ln&&(on[en]=ln,Z=en);var Zn=cn.split("-");if(!Z&&Zn.length>1)return zn(Zn[0])}else{var Kn=cn.name;on[Kn]=cn,Z=Kn}return!Gn&&Z&&(un=Z),Z||!Gn&&un},Wn=function(zn,cn){if(Y(zn))return zn.clone();var ln=typeof cn=="object"?cn:{};return ln.date=zn,ln.args=arguments,new It(ln)},Fn=ot;Fn.l=Cn,Fn.i=Y,Fn.w=function(zn,cn){return Wn(zn,{locale:cn.$L,utc:cn.$u,x:cn.$x,$offset:cn.$offset})};var It=function(){function zn(ln){this.$L=Cn(ln.locale,null,!0),this.parse(ln)}var cn=zn.prototype;return cn.parse=function(ln){this.$d=function(Gn){var Z=Gn.date,en=Gn.utc;if(Z===null)return new Date(NaN);if(Fn.u(Z))return new Date;if(Z instanceof Date)return new Date(Z);if(typeof Z=="string"&&!/Z$/i.test(Z)){var Zn=Z.match(X);if(Zn){var Kn=Zn[2]-1||0,vn=(Zn[7]||"0").substring(0,3);return en?new Date(Date.UTC(Zn[1],Kn,Zn[3]||1,Zn[4]||0,Zn[5]||0,Zn[6]||0,vn)):new Date(Zn[1],Kn,Zn[3]||1,Zn[4]||0,Zn[5]||0,Zn[6]||0,vn)}}return new Date(Z)}(ln),this.$x=ln.x||{},this.init()},cn.init=function(){var ln=this.$d;this.$y=ln.getFullYear(),this.$M=ln.getMonth(),this.$D=ln.getDate(),this.$W=ln.getDay(),this.$H=ln.getHours(),this.$m=ln.getMinutes(),this.$s=ln.getSeconds(),this.$ms=ln.getMilliseconds()},cn.$utils=function(){return Fn},cn.isValid=function(){return this.$d.toString()!==bn},cn.isSame=function(ln,Gn){var Z=Wn(ln);return this.startOf(Gn)<=Z&&Z<=this.endOf(Gn)},cn.isAfter=function(ln,Gn){return Wn(ln)<this.startOf(Gn)},cn.isBefore=function(ln,Gn){return this.endOf(Gn)<Wn(ln)},cn.$g=function(ln,Gn,Z){return Fn.u(ln)?this[Gn]:this.set(Z,ln)},cn.unix=function(){return Math.floor(this.valueOf()/1e3)},cn.valueOf=function(){return this.$d.getTime()},cn.startOf=function(ln,Gn){var Z=this,en=!!Fn.u(Gn)||Gn,Zn=Fn.p(ln),Kn=function($t,yt){var yr=Fn.w(Z.$u?Date.UTC(Z.$y,yt,$t):new Date(Z.$y,yt,$t),Z);return en?yr:yr.endOf(rn)},vn=function($t,yt){return Fn.w(Z.toDate()[$t].apply(Z.toDate("s"),(en?[0,0,0,0]:[23,59,59,999]).slice(yt)),Z)},Tt=this.$W,Ce=this.$M,mr=this.$D,mt="set"+(this.$u?"UTC":"");switch(Zn){case Un:return en?Kn(1,0):Kn(31,11);case sn:return en?Kn(1,Ce):Kn(0,Ce+1);case Dn:var ae=this.$locale().weekStart||0,Tu=(Tt<ae?Tt+7:Tt)-ae;return Kn(en?mr-Tu:mr+(6-Tu),Ce);case rn:case Rn:return vn(mt+"Hours",0);case dn:return vn(mt+"Minutes",1);case fn:return vn(mt+"Seconds",2);case z:return vn(mt+"Milliseconds",3);default:return this.clone()}},cn.endOf=function(ln){return this.startOf(ln,!1)},cn.$set=function(ln,Gn){var Z,en=Fn.p(ln),Zn="set"+(this.$u?"UTC":""),Kn=(Z={},Z[rn]=Zn+"Date",Z[Rn]=Zn+"Date",Z[sn]=Zn+"Month",Z[Un]=Zn+"FullYear",Z[dn]=Zn+"Hours",Z[fn]=Zn+"Minutes",Z[z]=Zn+"Seconds",Z[L]=Zn+"Milliseconds",Z)[en],vn=en===rn?this.$D+(Gn-this.$W):Gn;if(en===sn||en===Un){var Tt=this.clone().set(Rn,1);Tt.$d[Kn](vn),Tt.init(),this.$d=Tt.set(Rn,Math.min(this.$D,Tt.daysInMonth())).$d}else Kn&&this.$d[Kn](vn);return this.init(),this},cn.set=function(ln,Gn){return this.clone().$set(ln,Gn)},cn.get=function(ln){return this[Fn.p(ln)]()},cn.add=function(ln,Gn){var Z,en=this;ln=Number(ln);var Zn=Fn.p(Gn),Kn=function(Ce){var mr=Wn(en);return Fn.w(mr.date(mr.date()+Math.round(Ce*ln)),en)};if(Zn===sn)return this.set(sn,this.$M+ln);if(Zn===Un)return this.set(Un,this.$y+ln);if(Zn===rn)return Kn(1);if(Zn===Dn)return Kn(7);var vn=(Z={},Z[fn]=O,Z[dn]=R,Z[z]=a,Z)[Zn]||1,Tt=this.$d.getTime()+ln*vn;return Fn.w(Tt,this)},cn.subtract=function(ln,Gn){return this.add(-1*ln,Gn)},cn.format=function(ln){var Gn=this,Z=this.$locale();if(!this.isValid())return Z.invalidDate||bn;var en=ln||"YYYY-MM-DDTHH:mm:ssZ",Zn=Fn.z(this),Kn=this.$H,vn=this.$m,Tt=this.$M,Ce=Z.weekdays,mr=Z.months,mt=function(yt,yr,ue,ie){return yt&&(yt[yr]||yt(Gn,en))||ue[yr].substr(0,ie)},ae=function(yt){return Fn.s(Kn%12||12,yt,"0")},Tu=Z.meridiem||function(yt,yr,ue){var ie=yt<12?"AM":"PM";return ue?ie.toLowerCase():ie},$t={YY:String(this.$y).slice(-2),YYYY:this.$y,M:Tt+1,MM:Fn.s(Tt+1,2,"0"),MMM:mt(Z.monthsShort,Tt,mr,3),MMMM:mt(mr,Tt),D:this.$D,DD:Fn.s(this.$D,2,"0"),d:String(this.$W),dd:mt(Z.weekdaysMin,this.$W,Ce,2),ddd:mt(Z.weekdaysShort,this.$W,Ce,3),dddd:Ce[this.$W],H:String(Kn),HH:Fn.s(Kn,2,"0"),h:ae(1),hh:ae(2),a:Tu(Kn,vn,!0),A:Tu(Kn,vn,!1),m:String(vn),mm:Fn.s(vn,2,"0"),s:String(this.$s),ss:Fn.s(this.$s,2,"0"),SSS:Fn.s(this.$ms,3,"0"),Z:Zn};return en.replace(En,function(yt,yr){return yr||$t[yt]||Zn.replace(":","")})},cn.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},cn.diff=function(ln,Gn,Z){var en,Zn=Fn.p(Gn),Kn=Wn(ln),vn=(Kn.utcOffset()-this.utcOffset())*O,Tt=this-Kn,Ce=Fn.m(this,Kn);return Ce=(en={},en[Un]=Ce/12,en[sn]=Ce,en[dt]=Ce/3,en[Dn]=(Tt-vn)/6048e5,en[rn]=(Tt-vn)/864e5,en[dn]=Tt/R,en[fn]=Tt/O,en[z]=Tt/a,en)[Zn]||Tt,Z?Ce:Fn.a(Ce)},cn.daysInMonth=function(){return this.endOf(sn).$D},cn.$locale=function(){return on[this.$L]},cn.locale=function(ln,Gn){if(!ln)return this.$L;var Z=this.clone(),en=Cn(ln,Gn,!0);return en&&(Z.$L=en),Z},cn.clone=function(){return Fn.w(this.$d,this)},cn.toDate=function(){return new Date(this.valueOf())},cn.toJSON=function(){return this.isValid()?this.toISOString():null},cn.toISOString=function(){return this.$d.toISOString()},cn.toString=function(){return this.$d.toUTCString()},zn}(),Pt=It.prototype;return Wn.prototype=Pt,[["$ms",L],["$s",z],["$m",fn],["$H",dn],["$W",rn],["$M",sn],["$y",Un],["$D",Rn]].forEach(function(zn){Pt[zn[1]]=function(cn){return this.$g(cn,zn[0],zn[1])}}),Wn.extend=function(zn,cn){return zn.$i||(zn(cn,It,Wn),zn.$i=!0),Wn},Wn.locale=Cn,Wn.isDayjs=Y,Wn.unix=function(zn){return Wn(1e3*zn)},Wn.en=on[un],Wn.Ls=on,Wn.p={},Wn})}),e1=yv((y,d)=>{(function(a,O){typeof y=="object"&&typeof d!="undefined"?d.exports=O():typeof define=="function"&&__webpack_require__("3c35")?define(O):(a=typeof globalThis!="undefined"?globalThis:a||self).dayjs_plugin_customParseFormat=O()})(y,function(){"use strict";var a={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},O=/(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,R=/\d\d/,L=/\d\d?/,z=/\d*[^\s\d-_:/()]+/,fn={},dn=function(bn){return(bn=+bn)+(bn>68?1900:2e3)},rn=function(bn){return function(X){this[bn]=+X}},Dn=[/[+-]\d\d:?(\d\d)?|Z/,function(bn){(this.zone||(this.zone={})).offset=function(X){if(!X||X==="Z")return 0;var En=X.match(/([+-]|\d\d)/g),St=60*En[1]+(+En[2]||0);return St===0?0:En[0]==="+"?-St:St}(bn)}],sn=function(bn){var X=fn[bn];return X&&(X.indexOf?X:X.s.concat(X.f))},dt=function(bn,X){var En,St=fn.meridiem;if(St){for(var mn=1;mn<=24;mn+=1)if(bn.indexOf(St(mn,0,X))>-1){En=mn>12;break}}else En=bn===(X?"pm":"PM");return En},Un={A:[z,function(bn){this.afternoon=dt(bn,!1)}],a:[z,function(bn){this.afternoon=dt(bn,!0)}],S:[/\d/,function(bn){this.milliseconds=100*+bn}],SS:[R,function(bn){this.milliseconds=10*+bn}],SSS:[/\d{3}/,function(bn){this.milliseconds=+bn}],s:[L,rn("seconds")],ss:[L,rn("seconds")],m:[L,rn("minutes")],mm:[L,rn("minutes")],H:[L,rn("hours")],h:[L,rn("hours")],HH:[L,rn("hours")],hh:[L,rn("hours")],D:[L,rn("day")],DD:[R,rn("day")],Do:[z,function(bn){var X=fn.ordinal,En=bn.match(/\d+/);if(this.day=En[0],X)for(var St=1;St<=31;St+=1)X(St).replace(/\[|\]/g,"")===bn&&(this.day=St)}],M:[L,rn("month")],MM:[R,rn("month")],MMM:[z,function(bn){var X=sn("months"),En=(sn("monthsShort")||X.map(function(St){return St.substr(0,3)})).indexOf(bn)+1;if(En<1)throw new Error;this.month=En%12||En}],MMMM:[z,function(bn){var X=sn("months").indexOf(bn)+1;if(X<1)throw new Error;this.month=X%12||X}],Y:[/[+-]?\d+/,rn("year")],YY:[R,function(bn){this.year=dn(bn)}],YYYY:[/\d{4}/,rn("year")],Z:Dn,ZZ:Dn};function Rn(bn){var X,En;X=bn,En=fn&&fn.formats;for(var St=(bn=X.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,function(Wn,Fn,It){var Pt=It&&It.toUpperCase();return Fn||En[It]||a[It]||En[Pt].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,function(zn,cn,ln){return cn||ln.slice(1)})})).match(O),mn=St.length,ot=0;ot<mn;ot+=1){var un=St[ot],on=Un[un],Y=on&&on[0],Cn=on&&on[1];St[ot]=Cn?{regex:Y,parser:Cn}:un.replace(/^\[|\]$/g,"")}return function(Wn){for(var Fn={},It=0,Pt=0;It<mn;It+=1){var zn=St[It];if(typeof zn=="string")Pt+=zn.length;else{var cn=zn.regex,ln=zn.parser,Gn=Wn.substr(Pt),Z=cn.exec(Gn)[0];ln.call(Fn,Z),Wn=Wn.replace(Z,"")}}return function(en){var Zn=en.afternoon;if(Zn!==void 0){var Kn=en.hours;Zn?Kn<12&&(en.hours+=12):Kn===12&&(en.hours=0),delete en.afternoon}}(Fn),Fn}}return function(bn,X,En){En.p.customParseFormat=!0,bn&&bn.parseTwoDigitYear&&(dn=bn.parseTwoDigitYear);var St=X.prototype,mn=St.parse;St.parse=function(ot){var un=ot.date,on=ot.utc,Y=ot.args;this.$u=on;var Cn=Y[1];if(typeof Cn=="string"){var Wn=Y[2]===!0,Fn=Y[3]===!0,It=Wn||Fn,Pt=Y[2];Fn&&(Pt=Y[2]),fn=this.$locale(),!Wn&&Pt&&(fn=En.Ls[Pt]),this.$d=function(Gn,Z,en){try{if(["x","X"].indexOf(Z)>-1)return new Date((Z==="X"?1e3:1)*Gn);var Zn=Rn(Z)(Gn),Kn=Zn.year,vn=Zn.month,Tt=Zn.day,Ce=Zn.hours,mr=Zn.minutes,mt=Zn.seconds,ae=Zn.milliseconds,Tu=Zn.zone,$t=new Date,yt=Tt||(Kn||vn?1:$t.getDate()),yr=Kn||$t.getFullYear(),ue=0;Kn&&!vn||(ue=vn>0?vn-1:$t.getMonth());var ie=Ce||0,qu=mr||0,Hn=mt||0,oe=ae||0;return Tu?new Date(Date.UTC(yr,ue,yt,ie,qu,Hn,oe+60*Tu.offset*1e3)):en?new Date(Date.UTC(yr,ue,yt,ie,qu,Hn,oe)):new Date(yr,ue,yt,ie,qu,Hn,oe)}catch(xa){return new Date("")}}(un,Cn,on),this.init(),Pt&&Pt!==!0&&(this.$L=this.locale(Pt).$L),It&&un!=this.format(Cn)&&(this.$d=new Date("")),fn={}}else if(Cn instanceof Array)for(var zn=Cn.length,cn=1;cn<=zn;cn+=1){Y[1]=Cn[cn-1];var ln=En.apply(this,Y);if(ln.isValid()){this.$d=ln.$d,this.$L=ln.$L,this.init();break}cn===zn&&(this.$d=new Date(""))}else mn.call(this,ot)}}})}),r1=yv((y,d)=>{(function(a,O){typeof y=="object"&&typeof d!="undefined"?d.exports=O():typeof define=="function"&&__webpack_require__("3c35")?define(O):(a=typeof globalThis!="undefined"?globalThis:a||self).dayjs_plugin_duration=O()})(y,function(){"use strict";var a,O,R=1e3,L=6e4,z=36e5,fn=864e5,dn=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,rn=31536e6,Dn=2592e6,sn=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,dt={years:rn,months:Dn,days:fn,hours:z,minutes:L,seconds:R,milliseconds:1,weeks:6048e5},Un=function(un){return un instanceof ot},Rn=function(un,on,Y){return new ot(un,Y,on.$l)},bn=function(un){return O.p(un)+"s"},X=function(un){return un<0},En=function(un){return X(un)?Math.ceil(un):Math.floor(un)},St=function(un){return Math.abs(un)},mn=function(un,on){return un?X(un)?{negative:!0,format:""+St(un)+on}:{negative:!1,format:""+un+on}:{negative:!1,format:""}},ot=function(){function un(Y,Cn,Wn){var Fn=this;if(this.$d={},this.$l=Wn,Y===void 0&&(this.$ms=0,this.parseFromMilliseconds()),Cn)return Rn(Y*dt[bn(Cn)],this);if(typeof Y=="number")return this.$ms=Y,this.parseFromMilliseconds(),this;if(typeof Y=="object")return Object.keys(Y).forEach(function(zn){Fn.$d[bn(zn)]=Y[zn]}),this.calMilliseconds(),this;if(typeof Y=="string"){var It=Y.match(sn);if(It){var Pt=It.slice(2).map(function(zn){return zn!=null?Number(zn):0});return this.$d.years=Pt[0],this.$d.months=Pt[1],this.$d.weeks=Pt[2],this.$d.days=Pt[3],this.$d.hours=Pt[4],this.$d.minutes=Pt[5],this.$d.seconds=Pt[6],this.calMilliseconds(),this}}return this}var on=un.prototype;return on.calMilliseconds=function(){var Y=this;this.$ms=Object.keys(this.$d).reduce(function(Cn,Wn){return Cn+(Y.$d[Wn]||0)*dt[Wn]},0)},on.parseFromMilliseconds=function(){var Y=this.$ms;this.$d.years=En(Y/rn),Y%=rn,this.$d.months=En(Y/Dn),Y%=Dn,this.$d.days=En(Y/fn),Y%=fn,this.$d.hours=En(Y/z),Y%=z,this.$d.minutes=En(Y/L),Y%=L,this.$d.seconds=En(Y/R),Y%=R,this.$d.milliseconds=Y},on.toISOString=function(){var Y=mn(this.$d.years,"Y"),Cn=mn(this.$d.months,"M"),Wn=+this.$d.days||0;this.$d.weeks&&(Wn+=7*this.$d.weeks);var Fn=mn(Wn,"D"),It=mn(this.$d.hours,"H"),Pt=mn(this.$d.minutes,"M"),zn=this.$d.seconds||0;this.$d.milliseconds&&(zn+=this.$d.milliseconds/1e3);var cn=mn(zn,"S"),ln=Y.negative||Cn.negative||Fn.negative||It.negative||Pt.negative||cn.negative,Gn=It.format||Pt.format||cn.format?"T":"",Z=(ln?"-":"")+"P"+Y.format+Cn.format+Fn.format+Gn+It.format+Pt.format+cn.format;return Z==="P"||Z==="-P"?"P0D":Z},on.toJSON=function(){return this.toISOString()},on.format=function(Y){var Cn=Y||"YYYY-MM-DDTHH:mm:ss",Wn={Y:this.$d.years,YY:O.s(this.$d.years,2,"0"),YYYY:O.s(this.$d.years,4,"0"),M:this.$d.months,MM:O.s(this.$d.months,2,"0"),D:this.$d.days,DD:O.s(this.$d.days,2,"0"),H:this.$d.hours,HH:O.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:O.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:O.s(this.$d.seconds,2,"0"),SSS:O.s(this.$d.milliseconds,3,"0")};return Cn.replace(dn,function(Fn,It){return It||String(Wn[Fn])})},on.as=function(Y){return this.$ms/dt[bn(Y)]},on.get=function(Y){var Cn=this.$ms,Wn=bn(Y);return Wn==="milliseconds"?Cn%=1e3:Cn=Wn==="weeks"?En(Cn/dt[Wn]):this.$d[Wn],Cn===0?0:Cn},on.add=function(Y,Cn,Wn){var Fn;return Fn=Cn?Y*dt[bn(Cn)]:Un(Y)?Y.$ms:Rn(Y,this).$ms,Rn(this.$ms+Fn*(Wn?-1:1),this)},on.subtract=function(Y,Cn){return this.add(Y,Cn,!0)},on.locale=function(Y){var Cn=this.clone();return Cn.$l=Y,Cn},on.clone=function(){return Rn(this.$ms,this)},on.humanize=function(Y){return a().add(this.$ms,"ms").locale(this.$l).fromNow(!Y)},on.milliseconds=function(){return this.get("milliseconds")},on.asMilliseconds=function(){return this.as("milliseconds")},on.seconds=function(){return this.get("seconds")},on.asSeconds=function(){return this.as("seconds")},on.minutes=function(){return this.get("minutes")},on.asMinutes=function(){return this.as("minutes")},on.hours=function(){return this.get("hours")},on.asHours=function(){return this.as("hours")},on.days=function(){return this.get("days")},on.asDays=function(){return this.as("days")},on.weeks=function(){return this.get("weeks")},on.asWeeks=function(){return this.as("weeks")},on.months=function(){return this.get("months")},on.asMonths=function(){return this.as("months")},on.years=function(){return this.get("years")},on.asYears=function(){return this.as("years")},un}();return function(un,on,Y){a=Y,O=Y().$utils(),Y.duration=function(Fn,It){var Pt=Y.locale();return Rn(Fn,{$l:Pt},It)},Y.isDuration=Un;var Cn=on.prototype.add,Wn=on.prototype.subtract;on.prototype.add=function(Fn,It){return Un(Fn)&&(Fn=Fn.asMilliseconds()),Cn.bind(this)(Fn,It)},on.prototype.subtract=function(Fn,It){return Un(Fn)&&(Fn=Fn.asMilliseconds()),Wn.bind(this)(Fn,It)}}})}),dv=yv((y,d)=>{(function(a,O){typeof y=="object"&&typeof d!="undefined"?d.exports=O():typeof define=="function"&&__webpack_require__("3c35")?define(O):(a=typeof globalThis!="undefined"?globalThis:a||self).dayjs_plugin_isoWeek=O()})(y,function(){"use strict";var a="day";return function(O,R,L){var z=function(rn){return rn.add(4-rn.isoWeekday(),a)},fn=R.prototype;fn.isoWeekYear=function(){return z(this).year()},fn.isoWeek=function(rn){if(!this.$utils().u(rn))return this.add(7*(rn-this.isoWeek()),a);var Dn,sn,dt,Un,Rn=z(this),bn=(Dn=this.isoWeekYear(),sn=this.$u,dt=(sn?L.utc:L)().year(Dn).startOf("year"),Un=4-dt.isoWeekday(),dt.isoWeekday()>4&&(Un+=7),dt.add(Un,a));return Rn.diff(bn,"week")+1},fn.isoWeekday=function(rn){return this.$utils().u(rn)?this.day()||7:this.day(this.day()%7?rn:rn-7)};var dn=fn.startOf;fn.startOf=function(rn,Dn){var sn=this.$utils(),dt=!!sn.u(Dn)||Dn;return sn.p(rn)==="isoweek"?dt?this.date(this.date()-(this.isoWeekday()-1)).startOf("day"):this.date(this.date()-1-(this.isoWeekday()-1)+7).endOf("day"):dn.bind(this)(rn,Dn)}}})}),zv=yv((y,d)=>{(function(a,O){typeof y=="object"&&typeof d!="undefined"?d.exports=O():typeof define=="function"&&__webpack_require__("3c35")?define(O):(a=typeof globalThis!="undefined"?globalThis:a||self).dayjs_plugin_quarterOfYear=O()})(y,function(){"use strict";var a="month",O="quarter";return function(R,L){var z=L.prototype;z.quarter=function(rn){return this.$utils().u(rn)?Math.ceil((this.month()+1)/3):this.month(this.month()%3+3*(rn-1))};var fn=z.add;z.add=function(rn,Dn){return rn=Number(rn),this.$utils().p(Dn)===O?this.add(3*rn,a):fn.bind(this)(rn,Dn)};var dn=z.startOf;z.startOf=function(rn,Dn){var sn=this.$utils(),dt=!!sn.u(Dn)||Dn;if(sn.p(rn)===O){var Un=this.quarter()-1;return dt?this.month(3*Un).startOf(a).startOf("day"):this.month(3*Un+2).endOf(a).endOf("day")}return dn.bind(this)(rn,Dn)}}})}),Mg=Pu(fv());var r_=Pu(fv()),u1=Pu(e1());r_.default.extend(u1.default);function Wv(y,d){return(0,r_.default)(y,d).toDate()}var i1=Pu(fv()),o1=Pu(r1());i1.default.extend(o1.default);var a1=Pu(fv()),f1=Pu(dv());a1.default.extend(f1.default);var u_=Pu(fv()),c1=Pu(zv()),l1=Pu(dv());u_.default.extend(l1.default);u_.default.extend(c1.default);var i_=Pu(fv()),s1=Pu(zv()),p1=Pu(dv());i_.default.extend(p1.default);i_.default.extend(s1.default);var h1=Pu(fv()),v1=Pu(dv());h1.default.extend(v1.default);var _1=Pu(fv()),g1=Pu(dv());_1.default.extend(g1.default);var y1=Pu(fv()),d1=Pu(zv());y1.default.extend(d1.default);var m1=Object.create,Uv=Object.defineProperty,b1=Object.getOwnPropertyDescriptor,w1=Object.getOwnPropertyNames,x1=Object.getPrototypeOf,j1=Object.prototype.hasOwnProperty,A1=y=>Uv(y,"__esModule",{value:!0}),D1=(y,d)=>()=>(d||y((d={exports:{}}).exports,d),d.exports),E1=(y,d,a)=>{if(d&&typeof d=="object"||typeof d=="function")for(let O of w1(d))!j1.call(y,O)&&O!=="default"&&Uv(y,O,{get:()=>d[O],enumerable:!(a=b1(d,O))||a.enumerable});return y},C1=y=>E1(A1(Uv(y!=null?m1(x1(y)):{},"default",y&&y.__esModule&&"default"in y?{get:()=>y.default,enumerable:!0}:{value:y,enumerable:!0})),y),O1=D1((y,d)=>{(function(){var a,O="4.17.21",R=200,L="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",z="Expected a function",fn="Invalid `variable` option passed into `_.template`",dn="__lodash_hash_undefined__",rn=500,Dn="__lodash_placeholder__",sn=1,dt=2,Un=4,Rn=1,bn=2,X=1,En=2,St=4,mn=8,ot=16,un=32,on=64,Y=128,Cn=256,Wn=512,Fn=30,It="...",Pt=800,zn=16,cn=1,ln=2,Gn=3,Z=1/0,en=9007199254740991,Zn=17976931348623157e292,Kn=0/0,vn=4294967295,Tt=vn-1,Ce=vn>>>1,mr=[["ary",Y],["bind",X],["bindKey",En],["curry",mn],["curryRight",ot],["flip",Wn],["partial",un],["partialRight",on],["rearg",Cn]],mt="[object Arguments]",ae="[object Array]",Tu="[object AsyncFunction]",$t="[object Boolean]",yt="[object Date]",yr="[object DOMException]",ue="[object Error]",ie="[object Function]",qu="[object GeneratorFunction]",Hn="[object Map]",oe="[object Number]",xa="[object Null]",at="[object Object]",Vu="[object Promise]",Da="[object Proxy]",fe="[object RegExp]",Jn="[object Set]",ce="[object String]",Oe="[object Symbol]",Ea="[object Undefined]",le="[object WeakMap]",Ca="[object WeakSet]",se="[object ArrayBuffer]",qt="[object DataView]",wr="[object Float32Array]",xr="[object Float64Array]",jr="[object Int8Array]",Ar="[object Int16Array]",Dr="[object Int32Array]",Er="[object Uint8Array]",Cr="[object Uint8ClampedArray]",Or="[object Uint16Array]",kr="[object Uint32Array]",Oa=/\b__p \+= '';/g,ka=/\b(__p \+=) '' \+/g,Sa=/(__e\(.*?\)|\b__t\)) \+\n'';/g,Yu=/&(?:amp|lt|gt|quot|#39);/g,Zu=/[&<>"']/g,Ia=RegExp(Yu.source),$a=RegExp(Zu.source),Ba=/<%-([\s\S]+?)%>/g,Fa=/<%([\s\S]+?)%>/g,Hu=/<%=([\s\S]+?)%>/g,Ra=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,za=/^\w*$/,Wa=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Sr=/[\\^$.*+?()[\]{}|]/g,Ua=RegExp(Sr.source),Ir=/^\s+/,Ma=/\s/,La=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Na=/\{\n\/\* \[wrapped with (.+)\] \*/,Pa=/,? & /,Ta=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,qa=/[()=,{}\[\]\/\s]/,Va=/\\(\\)?/g,Ya=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Ku=/\w*$/,Za=/^[-+]0x[0-9a-f]+$/i,Ha=/^0b[01]+$/i,Ka=/^\[object .+?Constructor\]$/,Ga=/^0o[0-7]+$/i,Ja=/^(?:0|[1-9]\d*)$/,Qa=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,ke=/($^)/,Xa=/['\n\r\u2028\u2029\\]/g,Se="\\ud800-\\udfff",nf="\\u0300-\\u036f",tf="\\ufe20-\\ufe2f",ef="\\u20d0-\\u20ff",Gu=nf+tf+ef,Ju="\\u2700-\\u27bf",Qu="a-z\\xdf-\\xf6\\xf8-\\xff",rf="\\xac\\xb1\\xd7\\xf7",uf="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",of="\\u2000-\\u206f",af=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Xu="A-Z\\xc0-\\xd6\\xd8-\\xde",ni="\\ufe0e\\ufe0f",ti=rf+uf+of+af,$r="['\u2019]",ff="["+Se+"]",ei="["+ti+"]",Ie="["+Gu+"]",ri="\\d+",cf="["+Ju+"]",ui="["+Qu+"]",ii="[^"+Se+ti+ri+Ju+Qu+Xu+"]",Br="\\ud83c[\\udffb-\\udfff]",lf="(?:"+Ie+"|"+Br+")",oi="[^"+Se+"]",Fr="(?:\\ud83c[\\udde6-\\uddff]){2}",Rr="[\\ud800-\\udbff][\\udc00-\\udfff]",Vt="["+Xu+"]",ai="\\u200d",fi="(?:"+ui+"|"+ii+")",sf="(?:"+Vt+"|"+ii+")",ci="(?:"+$r+"(?:d|ll|m|re|s|t|ve))?",li="(?:"+$r+"(?:D|LL|M|RE|S|T|VE))?",si=lf+"?",pi="["+ni+"]?",pf="(?:"+ai+"(?:"+[oi,Fr,Rr].join("|")+")"+pi+si+")*",hf="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",vf="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",hi=pi+si+pf,_f="(?:"+[cf,Fr,Rr].join("|")+")"+hi,gf="(?:"+[oi+Ie+"?",Ie,Fr,Rr,ff].join("|")+")",yf=RegExp($r,"g"),df=RegExp(Ie,"g"),zr=RegExp(Br+"(?="+Br+")|"+gf+hi,"g"),mf=RegExp([Vt+"?"+ui+"+"+ci+"(?="+[ei,Vt,"$"].join("|")+")",sf+"+"+li+"(?="+[ei,Vt+fi,"$"].join("|")+")",Vt+"?"+fi+"+"+ci,Vt+"+"+li,vf,hf,ri,_f].join("|"),"g"),bf=RegExp("["+ai+Se+Gu+ni+"]"),wf=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,xf=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],jf=-1,T={};T[wr]=T[xr]=T[jr]=T[Ar]=T[Dr]=T[Er]=T[Cr]=T[Or]=T[kr]=!0,T[mt]=T[ae]=T[se]=T[$t]=T[qt]=T[yt]=T[ue]=T[ie]=T[Hn]=T[oe]=T[at]=T[fe]=T[Jn]=T[ce]=T[le]=!1;var P={};P[mt]=P[ae]=P[se]=P[qt]=P[$t]=P[yt]=P[wr]=P[xr]=P[jr]=P[Ar]=P[Dr]=P[Hn]=P[oe]=P[at]=P[fe]=P[Jn]=P[ce]=P[Oe]=P[Er]=P[Cr]=P[Or]=P[kr]=!0,P[ue]=P[ie]=P[le]=!1;var Af={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},Df={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Ef={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Cf={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Of=parseFloat,kf=parseInt,vi=typeof global=="object"&&global&&global.Object===Object&&global,Sf=typeof self=="object"&&self&&self.Object===Object&&self,nn=vi||Sf||Function("return this")(),Wr=typeof y=="object"&&y&&!y.nodeType&&y,Bt=Wr&&typeof d=="object"&&d&&!d.nodeType&&d,_i=Bt&&Bt.exports===Wr,Ur=_i&&vi.process,Mn=function(){try{var l=Bt&&Bt.require&&Bt.require("util").types;return l||Ur&&Ur.binding&&Ur.binding("util")}catch(h){}}(),gi=Mn&&Mn.isArrayBuffer,yi=Mn&&Mn.isDate,di=Mn&&Mn.isMap,mi=Mn&&Mn.isRegExp,bi=Mn&&Mn.isSet,wi=Mn&&Mn.isTypedArray;function On(l,h,p){switch(p.length){case 0:return l.call(h);case 1:return l.call(h,p[0]);case 2:return l.call(h,p[0],p[1]);case 3:return l.call(h,p[0],p[1],p[2])}return l.apply(h,p)}function If(l,h,p,b){for(var D=-1,W=l==null?0:l.length;++D<W;){var J=l[D];h(b,J,p(J),l)}return b}function Ln(l,h){for(var p=-1,b=l==null?0:l.length;++p<b&&h(l[p],p,l)!==!1;);return l}function $f(l,h){for(var p=l==null?0:l.length;p--&&h(l[p],p,l)!==!1;);return l}function xi(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(!h(l[p],p,l))return!1;return!0}function bt(l,h){for(var p=-1,b=l==null?0:l.length,D=0,W=[];++p<b;){var J=l[p];h(J,p,l)&&(W[D++]=J)}return W}function $e(l,h){var p=l==null?0:l.length;return!!p&&Yt(l,h,0)>-1}function Mr(l,h,p){for(var b=-1,D=l==null?0:l.length;++b<D;)if(p(h,l[b]))return!0;return!1}function q(l,h){for(var p=-1,b=l==null?0:l.length,D=Array(b);++p<b;)D[p]=h(l[p],p,l);return D}function wt(l,h){for(var p=-1,b=h.length,D=l.length;++p<b;)l[D+p]=h[p];return l}function Lr(l,h,p,b){var D=-1,W=l==null?0:l.length;for(b&&W&&(p=l[++D]);++D<W;)p=h(p,l[D],D,l);return p}function Bf(l,h,p,b){var D=l==null?0:l.length;for(b&&D&&(p=l[--D]);D--;)p=h(p,l[D],D,l);return p}function Nr(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(h(l[p],p,l))return!0;return!1}var Ff=Pr("length");function Rf(l){return l.split("")}function zf(l){return l.match(Ta)||[]}function ji(l,h,p){var b;return p(l,function(D,W,J){if(h(D,W,J))return b=W,!1}),b}function Be(l,h,p,b){for(var D=l.length,W=p+(b?1:-1);b?W--:++W<D;)if(h(l[W],W,l))return W;return-1}function Yt(l,h,p){return h===h?Hf(l,h,p):Be(l,Ai,p)}function Wf(l,h,p,b){for(var D=p-1,W=l.length;++D<W;)if(b(l[D],h))return D;return-1}function Ai(l){return l!==l}function Di(l,h){var p=l==null?0:l.length;return p?qr(l,h)/p:Kn}function Pr(l){return function(h){return h==null?a:h[l]}}function Tr(l){return function(h){return l==null?a:l[h]}}function Ei(l,h,p,b,D){return D(l,function(W,J,N){p=b?(b=!1,W):h(p,W,J,N)}),p}function Uf(l,h){var p=l.length;for(l.sort(h);p--;)l[p]=l[p].value;return l}function qr(l,h){for(var p,b=-1,D=l.length;++b<D;){var W=h(l[b]);W!==a&&(p=p===a?W:p+W)}return p}function Vr(l,h){for(var p=-1,b=Array(l);++p<l;)b[p]=h(p);return b}function Mf(l,h){return q(h,function(p){return[p,l[p]]})}function Ci(l){return l&&l.slice(0,Ii(l)+1).replace(Ir,"")}function kn(l){return function(h){return l(h)}}function Yr(l,h){return q(h,function(p){return l[p]})}function pe(l,h){return l.has(h)}function Oi(l,h){for(var p=-1,b=l.length;++p<b&&Yt(h,l[p],0)>-1;);return p}function ki(l,h){for(var p=l.length;p--&&Yt(h,l[p],0)>-1;);return p}function Lf(l,h){for(var p=l.length,b=0;p--;)l[p]===h&&++b;return b}var Nf=Tr(Af),Pf=Tr(Df);function Tf(l){return"\\"+Cf[l]}function qf(l,h){return l==null?a:l[h]}function Zt(l){return bf.test(l)}function Vf(l){return wf.test(l)}function Yf(l){for(var h,p=[];!(h=l.next()).done;)p.push(h.value);return p}function Zr(l){var h=-1,p=Array(l.size);return l.forEach(function(b,D){p[++h]=[D,b]}),p}function Si(l,h){return function(p){return l(h(p))}}function xt(l,h){for(var p=-1,b=l.length,D=0,W=[];++p<b;){var J=l[p];(J===h||J===Dn)&&(l[p]=Dn,W[D++]=p)}return W}function Fe(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=b}),p}function Zf(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=[b,b]}),p}function Hf(l,h,p){for(var b=p-1,D=l.length;++b<D;)if(l[b]===h)return b;return-1}function Kf(l,h,p){for(var b=p+1;b--;)if(l[b]===h)return b;return b}function Ht(l){return Zt(l)?Jf(l):Ff(l)}function Qn(l){return Zt(l)?Qf(l):Rf(l)}function Ii(l){for(var h=l.length;h--&&Ma.test(l.charAt(h)););return h}var Gf=Tr(Ef);function Jf(l){for(var h=zr.lastIndex=0;zr.test(l);)++h;return h}function Qf(l){return l.match(zr)||[]}function Xf(l){return l.match(mf)||[]}var nc=function l(h){h=h==null?nn:jt.defaults(nn.Object(),h,jt.pick(nn,xf));var p=h.Array,b=h.Date,D=h.Error,W=h.Function,J=h.Math,N=h.Object,Hr=h.RegExp,tc=h.String,Nn=h.TypeError,Re=p.prototype,ec=W.prototype,Kt=N.prototype,ze=h["__core-js_shared__"],We=ec.toString,M=Kt.hasOwnProperty,rc=0,$i=function(){var n=/[^.]+$/.exec(ze&&ze.keys&&ze.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Ue=Kt.toString,uc=We.call(N),ic=nn._,oc=Hr("^"+We.call(M).replace(Sr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Me=_i?h.Buffer:a,At=h.Symbol,Le=h.Uint8Array,Bi=Me?Me.allocUnsafe:a,Ne=Si(N.getPrototypeOf,N),Fi=N.create,Ri=Kt.propertyIsEnumerable,Pe=Re.splice,zi=At?At.isConcatSpreadable:a,he=At?At.iterator:a,Ft=At?At.toStringTag:a,Te=function(){try{var n=Mt(N,"defineProperty");return n({},"",{}),n}catch(t){}}(),ac=h.clearTimeout!==nn.clearTimeout&&h.clearTimeout,fc=b&&b.now!==nn.Date.now&&b.now,cc=h.setTimeout!==nn.setTimeout&&h.setTimeout,qe=J.ceil,Ve=J.floor,Kr=N.getOwnPropertySymbols,lc=Me?Me.isBuffer:a,Wi=h.isFinite,sc=Re.join,pc=Si(N.keys,N),Q=J.max,pn=J.min,hc=b.now,vc=h.parseInt,Ui=J.random,_c=Re.reverse,Gr=Mt(h,"DataView"),ve=Mt(h,"Map"),Jr=Mt(h,"Promise"),Gt=Mt(h,"Set"),_e=Mt(h,"WeakMap"),ge=Mt(N,"create"),Ye=_e&&new _e,Jt={},gc=Lt(Gr),yc=Lt(ve),dc=Lt(Jr),mc=Lt(Gt),bc=Lt(_e),Ze=At?At.prototype:a,ye=Ze?Ze.valueOf:a,Mi=Ze?Ze.toString:a;function i(n){if(H(n)&&!E(n)&&!(n instanceof B)){if(n instanceof Pn)return n;if(M.call(n,"__wrapped__"))return No(n)}return new Pn(n)}var Qt=function(){function n(){}return function(t){if(!V(t))return{};if(Fi)return Fi(t);n.prototype=t;var e=new n;return n.prototype=a,e}}();function He(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=a}i.templateSettings={escape:Ba,evaluate:Fa,interpolate:Hu,variable:"",imports:{_:i}},i.prototype=He.prototype,i.prototype.constructor=i,Pn.prototype=Qt(He.prototype),Pn.prototype.constructor=Pn;function B(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=vn,this.__views__=[]}function wc(){var n=new B(this.__wrapped__);return n.__actions__=wn(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=wn(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=wn(this.__views__),n}function xc(){if(this.__filtered__){var n=new B(this);n.__dir__=-1,n.__filtered__=!0}else n=this.clone(),n.__dir__*=-1;return n}function jc(){var n=this.__wrapped__.value(),t=this.__dir__,e=E(n),r=t<0,u=e?n.length:0,o=Rl(0,u,this.__views__),f=o.start,c=o.end,s=c-f,v=r?c:f-1,_=this.__iteratees__,g=_.length,m=0,w=pn(s,this.__takeCount__);if(!e||!r&&u==s&&w==s)return co(n,this.__actions__);var j=[];n:for(;s--&&m<w;){v+=t;for(var S=-1,A=n[v];++S<g;){var $=_[S],F=$.iteratee,$n=$.type,yn=F(A);if($n==ln)A=yn;else if(!yn){if($n==cn)continue n;break n}}j[m++]=A}return j}B.prototype=Qt(He.prototype),B.prototype.constructor=B;function Rt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Ac(){this.__data__=ge?ge(null):{},this.size=0}function Dc(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Ec(n){var t=this.__data__;if(ge){var e=t[n];return e===dn?a:e}return M.call(t,n)?t[n]:a}function Cc(n){var t=this.__data__;return ge?t[n]!==a:M.call(t,n)}function Oc(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=ge&&t===a?dn:t,this}Rt.prototype.clear=Ac,Rt.prototype.delete=Dc,Rt.prototype.get=Ec,Rt.prototype.has=Cc,Rt.prototype.set=Oc;function ft(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function kc(){this.__data__=[],this.size=0}function Sc(n){var t=this.__data__,e=Ke(t,n);if(e<0)return!1;var r=t.length-1;return e==r?t.pop():Pe.call(t,e,1),--this.size,!0}function Ic(n){var t=this.__data__,e=Ke(t,n);return e<0?a:t[e][1]}function $c(n){return Ke(this.__data__,n)>-1}function Bc(n,t){var e=this.__data__,r=Ke(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}ft.prototype.clear=kc,ft.prototype.delete=Sc,ft.prototype.get=Ic,ft.prototype.has=$c,ft.prototype.set=Bc;function ct(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Fc(){this.size=0,this.__data__={hash:new Rt,map:new(ve||ft),string:new Rt}}function Rc(n){var t=ar(this,n).delete(n);return this.size-=t?1:0,t}function zc(n){return ar(this,n).get(n)}function Wc(n){return ar(this,n).has(n)}function Uc(n,t){var e=ar(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}ct.prototype.clear=Fc,ct.prototype.delete=Rc,ct.prototype.get=zc,ct.prototype.has=Wc,ct.prototype.set=Uc;function zt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new ct;++t<e;)this.add(n[t])}function Mc(n){return this.__data__.set(n,dn),this}function Lc(n){return this.__data__.has(n)}zt.prototype.add=zt.prototype.push=Mc,zt.prototype.has=Lc;function Xn(n){var t=this.__data__=new ft(n);this.size=t.size}function Nc(){this.__data__=new ft,this.size=0}function Pc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function Tc(n){return this.__data__.get(n)}function qc(n){return this.__data__.has(n)}function Vc(n,t){var e=this.__data__;if(e instanceof ft){var r=e.__data__;if(!ve||r.length<R-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new ct(r)}return e.set(n,t),this.size=e.size,this}Xn.prototype.clear=Nc,Xn.prototype.delete=Pc,Xn.prototype.get=Tc,Xn.prototype.has=qc,Xn.prototype.set=Vc;function Li(n,t){var e=E(n),r=!e&&Nt(n),u=!e&&!r&&kt(n),o=!e&&!r&&!u&&ee(n),f=e||r||u||o,c=f?Vr(n.length,tc):[],s=c.length;for(var v in n)(t||M.call(n,v))&&!(f&&(v=="length"||u&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||ht(v,s)))&&c.push(v);return c}function Ni(n){var t=n.length;return t?n[fu(0,t-1)]:a}function Yc(n,t){return fr(wn(n),Wt(t,0,n.length))}function Zc(n){return fr(wn(n))}function Qr(n,t,e){(e!==a&&!nt(n[t],e)||e===a&&!(t in n))&&lt(n,t,e)}function de(n,t,e){var r=n[t];(!(M.call(n,t)&&nt(r,e))||e===a&&!(t in n))&&lt(n,t,e)}function Ke(n,t){for(var e=n.length;e--;)if(nt(n[e][0],t))return e;return-1}function Hc(n,t,e,r){return Dt(n,function(u,o,f){t(r,u,e(u),f)}),r}function Pi(n,t){return n&&rt(t,tn(t),n)}function Kc(n,t){return n&&rt(t,jn(t),n)}function lt(n,t,e){t=="__proto__"&&Te?Te(n,t,{configurable:!0,enumerable:!0,value:e,writable:!0}):n[t]=e}function Xr(n,t){for(var e=-1,r=t.length,u=p(r),o=n==null;++e<r;)u[e]=o?a:Bu(n,t[e]);return u}function Wt(n,t,e){return n===n&&(e!==a&&(n=n<=e?n:e),t!==a&&(n=n>=t?n:t)),n}function Tn(n,t,e,r,u,o){var f,c=t&sn,s=t&dt,v=t&Un;if(e&&(f=u?e(n,r,u,o):e(n)),f!==a)return f;if(!V(n))return n;var _=E(n);if(_){if(f=Wl(n),!c)return wn(n,f)}else{var g=hn(n),m=g==ie||g==qu;if(kt(n))return po(n,c);if(g==at||g==mt||m&&!u){if(f=s||m?{}:$o(n),!c)return s?El(n,Kc(f,n)):Dl(n,Pi(f,n))}else{if(!P[g])return u?n:{};f=Ul(n,g,c)}}o||(o=new Xn);var w=o.get(n);if(w)return w;o.set(n,f),aa(n)?n.forEach(function(A){f.add(Tn(A,t,e,A,n,o))}):ia(n)&&n.forEach(function(A,$){f.set($,Tn(A,t,e,$,n,o))});var j=v?s?mu:du:s?jn:tn,S=_?a:j(n);return Ln(S||n,function(A,$){S&&($=A,A=n[$]),de(f,$,Tn(A,t,e,$,n,o))}),f}function Gc(n){var t=tn(n);return function(e){return Ti(e,n,t)}}function Ti(n,t,e){var r=e.length;if(n==null)return!r;for(n=N(n);r--;){var u=e[r],o=t[u],f=n[u];if(f===a&&!(u in n)||!o(f))return!1}return!0}function qi(n,t,e){if(typeof n!="function")throw new Nn(z);return De(function(){n.apply(a,e)},t)}function me(n,t,e,r){var u=-1,o=$e,f=!0,c=n.length,s=[],v=t.length;if(!c)return s;e&&(t=q(t,kn(e))),r?(o=Mr,f=!1):t.length>=R&&(o=pe,f=!1,t=new zt(t));n:for(;++u<c;){var _=n[u],g=e==null?_:e(_);if(_=r||_!==0?_:0,f&&g===g){for(var m=v;m--;)if(t[m]===g)continue n;s.push(_)}else o(t,g,r)||s.push(_)}return s}var Dt=yo(et),Vi=yo(tu,!0);function Jc(n,t){var e=!0;return Dt(n,function(r,u,o){return e=!!t(r,u,o),e}),e}function Ge(n,t,e){for(var r=-1,u=n.length;++r<u;){var o=n[r],f=t(o);if(f!=null&&(c===a?f===f&&!In(f):e(f,c)))var c=f,s=o}return s}function Qc(n,t,e,r){var u=n.length;for(e=k(e),e<0&&(e=-e>u?0:u+e),r=r===a||r>u?u:k(r),r<0&&(r+=u),r=e>r?0:ca(r);e<r;)n[e++]=t;return n}function Yi(n,t){var e=[];return Dt(n,function(r,u,o){t(r,u,o)&&e.push(r)}),e}function an(n,t,e,r,u){var o=-1,f=n.length;for(e||(e=Ll),u||(u=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?an(c,t-1,e,r,u):wt(u,c):r||(u[u.length]=c)}return u}var nu=mo(),Zi=mo(!0);function et(n,t){return n&&nu(n,t,tn)}function tu(n,t){return n&&Zi(n,t,tn)}function Je(n,t){return bt(t,function(e){return vt(n[e])})}function Ut(n,t){t=Ct(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[ut(t[e++])];return e&&e==r?n:a}function Hi(n,t,e){var r=t(n);return E(n)?r:wt(r,e(n))}function _n(n){return n==null?n===a?Ea:xa:Ft&&Ft in N(n)?Fl(n):Zl(n)}function eu(n,t){return n>t}function Xc(n,t){return n!=null&&M.call(n,t)}function nl(n,t){return n!=null&&t in N(n)}function tl(n,t,e){return n>=pn(t,e)&&n<Q(t,e)}function ru(n,t,e){for(var r=e?Mr:$e,u=n[0].length,o=n.length,f=o,c=p(o),s=Infinity,v=[];f--;){var _=n[f];f&&t&&(_=q(_,kn(t))),s=pn(_.length,s),c[f]=!e&&(t||u>=120&&_.length>=120)?new zt(f&&_):a}_=n[0];var g=-1,m=c[0];n:for(;++g<u&&v.length<s;){var w=_[g],j=t?t(w):w;if(w=e||w!==0?w:0,!(m?pe(m,j):r(v,j,e))){for(f=o;--f;){var S=c[f];if(!(S?pe(S,j):r(n[f],j,e)))continue n}m&&m.push(j),v.push(w)}}return v}function el(n,t,e,r){return et(n,function(u,o,f){t(r,e(u),o,f)}),r}function be(n,t,e){t=Ct(t,n),n=zo(n,t);var r=n==null?n:n[ut(Vn(t))];return r==null?a:On(r,n,e)}function Ki(n){return H(n)&&_n(n)==mt}function rl(n){return H(n)&&_n(n)==se}function ul(n){return H(n)&&_n(n)==yt}function we(n,t,e,r,u){return n===t?!0:n==null||t==null||!H(n)&&!H(t)?n!==n&&t!==t:il(n,t,e,r,we,u)}function il(n,t,e,r,u,o){var f=E(n),c=E(t),s=f?ae:hn(n),v=c?ae:hn(t);s=s==mt?at:s,v=v==mt?at:v;var _=s==at,g=v==at,m=s==v;if(m&&kt(n)){if(!kt(t))return!1;f=!0,_=!1}if(m&&!_)return o||(o=new Xn),f||ee(n)?ko(n,t,e,r,u,o):$l(n,t,s,e,r,u,o);if(!(e&Rn)){var w=_&&M.call(n,"__wrapped__"),j=g&&M.call(t,"__wrapped__");if(w||j){var S=w?n.value():n,A=j?t.value():t;return o||(o=new Xn),u(S,A,e,r,o)}}return m?(o||(o=new Xn),Bl(n,t,e,r,u,o)):!1}function ol(n){return H(n)&&hn(n)==Hn}function uu(n,t,e,r){var u=e.length,o=u,f=!r;if(n==null)return!o;for(n=N(n);u--;){var c=e[u];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return!1}for(;++u<o;){c=e[u];var s=c[0],v=n[s],_=c[1];if(f&&c[2]){if(v===a&&!(s in n))return!1}else{var g=new Xn;if(r)var m=r(v,_,s,n,t,g);if(!(m===a?we(_,v,Rn|bn,r,g):m))return!1}}return!0}function Gi(n){if(!V(n)||Pl(n))return!1;var t=vt(n)?oc:Ka;return t.test(Lt(n))}function al(n){return H(n)&&_n(n)==fe}function fl(n){return H(n)&&hn(n)==Jn}function cl(n){return H(n)&&vr(n.length)&&!!T[_n(n)]}function Ji(n){return typeof n=="function"?n:n==null?An:typeof n=="object"?E(n)?no(n[0],n[1]):Xi(n):ba(n)}function iu(n){if(!Ae(n))return pc(n);var t=[];for(var e in N(n))M.call(n,e)&&e!="constructor"&&t.push(e);return t}function ll(n){if(!V(n))return Yl(n);var t=Ae(n),e=[];for(var r in n)r=="constructor"&&(t||!M.call(n,r))||e.push(r);return e}function ou(n,t){return n<t}function Qi(n,t){var e=-1,r=xn(n)?p(n.length):[];return Dt(n,function(u,o,f){r[++e]=t(u,o,f)}),r}function Xi(n){var t=wu(n);return t.length==1&&t[0][2]?Fo(t[0][0],t[0][1]):function(e){return e===n||uu(e,n,t)}}function no(n,t){return ju(n)&&Bo(t)?Fo(ut(n),t):function(e){var r=Bu(e,n);return r===a&&r===t?Fu(e,n):we(t,r,Rn|bn)}}function Qe(n,t,e,r,u){n!==t&&nu(t,function(o,f){if(u||(u=new Xn),V(o))sl(n,t,f,e,Qe,r,u);else{var c=r?r(Du(n,f),o,f+"",n,t,u):a;c===a&&(c=o),Qr(n,f,c)}},jn)}function sl(n,t,e,r,u,o,f){var c=Du(n,e),s=Du(t,e),v=f.get(s);if(v){Qr(n,e,v);return}var _=o?o(c,s,e+"",n,t,f):a,g=_===a;if(g){var m=E(s),w=!m&&kt(s),j=!m&&!w&&ee(s);_=s,m||w||j?E(c)?_=c:K(c)?_=wn(c):w?(g=!1,_=po(s,!0)):j?(g=!1,_=ho(s,!0)):_=[]:Ee(s)||Nt(s)?(_=c,Nt(c)?_=la(c):(!V(c)||vt(c))&&(_=$o(s))):g=!1}g&&(f.set(s,_),u(_,s,r,o,f),f.delete(s)),Qr(n,e,_)}function to(n,t){var e=n.length;if(e)return t+=t<0?e:0,ht(t,e)?n[t]:a}function eo(n,t,e){t.length?t=q(t,function(o){return E(o)?function(f){return Ut(f,o.length===1?o[0]:o)}:o}):t=[An];var r=-1;t=q(t,kn(x()));var u=Qi(n,function(o,f,c){var s=q(t,function(v){return v(o)});return{criteria:s,index:++r,value:o}});return Uf(u,function(o,f){return Al(o,f,e)})}function pl(n,t){return ro(n,t,function(e,r){return Fu(n,r)})}function ro(n,t,e){for(var r=-1,u=t.length,o={};++r<u;){var f=t[r],c=Ut(n,f);e(c,f)&&xe(o,Ct(f,n),c)}return o}function hl(n){return function(t){return Ut(t,n)}}function au(n,t,e,r){var u=r?Wf:Yt,o=-1,f=t.length,c=n;for(n===t&&(t=wn(t)),e&&(c=q(n,kn(e)));++o<f;)for(var s=0,v=t[o],_=e?e(v):v;(s=u(c,_,s,r))>-1;)c!==n&&Pe.call(c,s,1),Pe.call(n,s,1);return n}function uo(n,t){for(var e=n?t.length:0,r=e-1;e--;){var u=t[e];if(e==r||u!==o){var o=u;ht(u)?Pe.call(n,u,1):su(n,u)}}return n}function fu(n,t){return n+Ve(Ui()*(t-n+1))}function vl(n,t,e,r){for(var u=-1,o=Q(qe((t-n)/(e||1)),0),f=p(o);o--;)f[r?o:++u]=n,n+=e;return f}function cu(n,t){var e="";if(!n||t<1||t>en)return e;do t%2&&(e+=n),t=Ve(t/2),t&&(n+=n);while(t);return e}function I(n,t){return Eu(Ro(n,t,An),n+"")}function _l(n){return Ni(re(n))}function gl(n,t){var e=re(n);return fr(e,Wt(t,0,e.length))}function xe(n,t,e,r){if(!V(n))return n;t=Ct(t,n);for(var u=-1,o=t.length,f=o-1,c=n;c!=null&&++u<o;){var s=ut(t[u]),v=e;if(s==="__proto__"||s==="constructor"||s==="prototype")return n;if(u!=f){var _=c[s];v=r?r(_,s,c):a,v===a&&(v=V(_)?_:ht(t[u+1])?[]:{})}de(c,s,v),c=c[s]}return n}var io=Ye?function(n,t){return Ye.set(n,t),n}:An,yl=Te?function(n,t){return Te(n,"toString",{configurable:!0,enumerable:!1,value:zu(t),writable:!0})}:An;function dl(n){return fr(re(n))}function qn(n,t,e){var r=-1,u=n.length;t<0&&(t=-t>u?0:u+t),e=e>u?u:e,e<0&&(e+=u),u=t>e?0:e-t>>>0,t>>>=0;for(var o=p(u);++r<u;)o[r]=n[r+t];return o}function ml(n,t){var e;return Dt(n,function(r,u,o){return e=t(r,u,o),!e}),!!e}function Xe(n,t,e){var r=0,u=n==null?r:n.length;if(typeof t=="number"&&t===t&&u<=Ce){for(;r<u;){var o=r+u>>>1,f=n[o];f!==null&&!In(f)&&(e?f<=t:f<t)?r=o+1:u=o}return u}return lu(n,t,An,e)}function lu(n,t,e,r){var u=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,s=In(t),v=t===a;u<o;){var _=Ve((u+o)/2),g=e(n[_]),m=g!==a,w=g===null,j=g===g,S=In(g);if(f)var A=r||j;else v?A=j&&(r||m):c?A=j&&m&&(r||!w):s?A=j&&m&&!w&&(r||!S):w||S?A=!1:A=r?g<=t:g<t;A?u=_+1:o=_}return pn(o,Tt)}function oo(n,t){for(var e=-1,r=n.length,u=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!nt(c,s)){var s=c;o[u++]=f===0?0:f}}return o}function ao(n){return typeof n=="number"?n:In(n)?Kn:+n}function Sn(n){if(typeof n=="string")return n;if(E(n))return q(n,Sn)+"";if(In(n))return Mi?Mi.call(n):"";var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Et(n,t,e){var r=-1,u=$e,o=n.length,f=!0,c=[],s=c;if(e)f=!1,u=Mr;else if(o>=R){var v=t?null:Sl(n);if(v)return Fe(v);f=!1,u=pe,s=new zt}else s=t?[]:c;n:for(;++r<o;){var _=n[r],g=t?t(_):_;if(_=e||_!==0?_:0,f&&g===g){for(var m=s.length;m--;)if(s[m]===g)continue n;t&&s.push(g),c.push(_)}else u(s,g,e)||(s!==c&&s.push(g),c.push(_))}return c}function su(n,t){return t=Ct(t,n),n=zo(n,t),n==null||delete n[ut(Vn(t))]}function fo(n,t,e,r){return xe(n,t,e(Ut(n,t)),r)}function nr(n,t,e,r){for(var u=n.length,o=r?u:-1;(r?o--:++o<u)&&t(n[o],o,n););return e?qn(n,r?0:o,r?o+1:u):qn(n,r?o+1:0,r?u:o)}function co(n,t){var e=n;return e instanceof B&&(e=e.value()),Lr(t,function(r,u){return u.func.apply(u.thisArg,wt([r],u.args))},e)}function pu(n,t,e){var r=n.length;if(r<2)return r?Et(n[0]):[];for(var u=-1,o=p(r);++u<r;)for(var f=n[u],c=-1;++c<r;)c!=u&&(o[u]=me(o[u]||f,n[c],t,e));return Et(an(o,1),t,e)}function lo(n,t,e){for(var r=-1,u=n.length,o=t.length,f={};++r<u;){var c=r<o?t[r]:a;e(f,n[r],c)}return f}function hu(n){return K(n)?n:[]}function vu(n){return typeof n=="function"?n:An}function Ct(n,t){return E(n)?n:ju(n,t)?[n]:Lo(U(n))}var bl=I;function Ot(n,t,e){var r=n.length;return e=e===a?r:e,!t&&e>=r?n:qn(n,t,e)}var so=ac||function(n){return nn.clearTimeout(n)};function po(n,t){if(t)return n.slice();var e=n.length,r=Bi?Bi(e):new n.constructor(e);return n.copy(r),r}function _u(n){var t=new n.constructor(n.byteLength);return new Le(t).set(new Le(n)),t}function wl(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function xl(n){var t=new n.constructor(n.source,Ku.exec(n));return t.lastIndex=n.lastIndex,t}function jl(n){return ye?N(ye.call(n)):{}}function ho(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function vo(n,t){if(n!==t){var e=n!==a,r=n===null,u=n===n,o=In(n),f=t!==a,c=t===null,s=t===t,v=In(t);if(!c&&!v&&!o&&n>t||o&&f&&s&&!c&&!v||r&&f&&s||!e&&s||!u)return 1;if(!r&&!o&&!v&&n<t||v&&e&&u&&!r&&!o||c&&e&&u||!f&&u||!s)return-1}return 0}function Al(n,t,e){for(var r=-1,u=n.criteria,o=t.criteria,f=u.length,c=e.length;++r<f;){var s=vo(u[r],o[r]);if(s){if(r>=c)return s;var v=e[r];return s*(v=="desc"?-1:1)}}return n.index-t.index}function _o(n,t,e,r){for(var u=-1,o=n.length,f=e.length,c=-1,s=t.length,v=Q(o-f,0),_=p(s+v),g=!r;++c<s;)_[c]=t[c];for(;++u<f;)(g||u<o)&&(_[e[u]]=n[u]);for(;v--;)_[c++]=n[u++];return _}function go(n,t,e,r){for(var u=-1,o=n.length,f=-1,c=e.length,s=-1,v=t.length,_=Q(o-c,0),g=p(_+v),m=!r;++u<_;)g[u]=n[u];for(var w=u;++s<v;)g[w+s]=t[s];for(;++f<c;)(m||u<o)&&(g[w+e[f]]=n[u++]);return g}function wn(n,t){var e=-1,r=n.length;for(t||(t=p(r));++e<r;)t[e]=n[e];return t}function rt(n,t,e,r){var u=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],s=r?r(e[c],n[c],c,e,n):a;s===a&&(s=n[c]),u?lt(e,c,s):de(e,c,s)}return e}function Dl(n,t){return rt(n,xu(n),t)}function El(n,t){return rt(n,So(n),t)}function tr(n,t){return function(e,r){var u=E(e)?If:Hc,o=t?t():{};return u(e,n,x(r,2),o)}}function Xt(n){return I(function(t,e){var r=-1,u=e.length,o=u>1?e[u-1]:a,f=u>2?e[2]:a;for(o=n.length>3&&typeof o=="function"?(u--,o):a,f&&gn(e[0],e[1],f)&&(o=u<3?a:o,u=1),t=N(t);++r<u;){var c=e[r];c&&n(t,c,r,o)}return t})}function yo(n,t){return function(e,r){if(e==null)return e;if(!xn(e))return n(e,r);for(var u=e.length,o=t?u:-1,f=N(e);(t?o--:++o<u)&&r(f[o],o,f)!==!1;);return e}}function mo(n){return function(t,e,r){for(var u=-1,o=N(t),f=r(t),c=f.length;c--;){var s=f[n?c:++u];if(e(o[s],s,o)===!1)break}return t}}function Cl(n,t,e){var r=t&X,u=je(n);function o(){var f=this&&this!==nn&&this instanceof o?u:n;return f.apply(r?e:this,arguments)}return o}function bo(n){return function(t){t=U(t);var e=Zt(t)?Qn(t):a,r=e?e[0]:t.charAt(0),u=e?Ot(e,1).join(""):t.slice(1);return r[n]()+u}}function ne(n){return function(t){return Lr(da(ya(t).replace(yf,"")),n,"")}}function je(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=Qt(n.prototype),r=n.apply(e,t);return V(r)?r:e}}function Ol(n,t,e){var r=je(n);function u(){for(var o=arguments.length,f=p(o),c=o,s=te(u);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==s&&f[o-1]!==s?[]:xt(f,s);if(o-=v.length,o<e)return Do(n,t,er,u.placeholder,a,f,v,a,a,e-o);var _=this&&this!==nn&&this instanceof u?r:n;return On(_,this,f)}return u}function wo(n){return function(t,e,r){var u=N(t);if(!xn(t)){var o=x(e,3);t=tn(t),e=function(c){return o(u[c],c,u)}}var f=n(t,e,r);return f>-1?u[o?t[f]:f]:a}}function xo(n){return pt(function(t){var e=t.length,r=e,u=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new Nn(z);if(u&&!f&&or(o)=="wrapper")var f=new Pn([],!0)}for(r=f?r:e;++r<e;){o=t[r];var c=or(o),s=c=="wrapper"?bu(o):a;s&&Au(s[0])&&s[1]==(Y|mn|un|Cn)&&!s[4].length&&s[9]==1?f=f[or(s[0])].apply(f,s[3]):f=o.length==1&&Au(o)?f[c]():f.thru(o)}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&E(_))return f.plant(_).value();for(var g=0,m=e?t[g].apply(this,v):_;++g<e;)m=t[g].call(this,m);return m}})}function er(n,t,e,r,u,o,f,c,s,v){var _=t&Y,g=t&X,m=t&En,w=t&(mn|ot),j=t&Wn,S=m?a:je(n);function A(){for(var $=arguments.length,F=p($),$n=$;$n--;)F[$n]=arguments[$n];if(w)var yn=te(A),Bn=Lf(F,yn);if(r&&(F=_o(F,r,u,w)),o&&(F=go(F,o,f,w)),$-=Bn,w&&$<v){var G=xt(F,yn);return Do(n,t,er,A.placeholder,e,F,G,c,s,v-$)}var tt=g?e:this,gt=m?tt[n]:n;return $=F.length,c?F=Hl(F,c):j&&$>1&&F.reverse(),_&&s<$&&(F.length=s),this&&this!==nn&&this instanceof A&&(gt=S||je(gt)),gt.apply(tt,F)}return A}function jo(n,t){return function(e,r){return el(e,n,t(r),{})}}function rr(n,t){return function(e,r){var u;if(e===a&&r===a)return t;if(e!==a&&(u=e),r!==a){if(u===a)return r;typeof e=="string"||typeof r=="string"?(e=Sn(e),r=Sn(r)):(e=ao(e),r=ao(r)),u=n(e,r)}return u}}function gu(n){return pt(function(t){return t=q(t,kn(x())),I(function(e){var r=this;return n(t,function(u){return On(u,r,e)})})})}function ur(n,t){t=t===a?" ":Sn(t);var e=t.length;if(e<2)return e?cu(t,n):t;var r=cu(t,qe(n/Ht(t)));return Zt(t)?Ot(Qn(r),0,n).join(""):r.slice(0,n)}function kl(n,t,e,r){var u=t&X,o=je(n);function f(){for(var c=-1,s=arguments.length,v=-1,_=r.length,g=p(_+s),m=this&&this!==nn&&this instanceof f?o:n;++v<_;)g[v]=r[v];for(;s--;)g[v++]=arguments[++c];return On(m,u?e:this,g)}return f}function Ao(n){return function(t,e,r){return r&&typeof r!="number"&&gn(t,e,r)&&(e=r=a),t=_t(t),e===a?(e=t,t=0):e=_t(e),r=r===a?t<e?1:-1:_t(r),vl(t,e,r,n)}}function ir(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=Yn(t),e=Yn(e)),n(t,e)}}function Do(n,t,e,r,u,o,f,c,s,v){var _=t&mn,g=_?f:a,m=_?a:f,w=_?o:a,j=_?a:o;t|=_?un:on,t&=~(_?on:un),t&St||(t&=~(X|En));var S=[n,t,u,w,g,j,m,c,s,v],A=e.apply(a,S);return Au(n)&&Wo(A,S),A.placeholder=r,Uo(A,n,t)}function yu(n){var t=J[n];return function(e,r){if(e=Yn(e),r=r==null?0:pn(k(r),292),r&&Wi(e)){var u=(U(e)+"e").split("e"),o=t(u[0]+"e"+(+u[1]+r));return u=(U(o)+"e").split("e"),+(u[0]+"e"+(+u[1]-r))}return t(e)}}var Sl=Gt&&1/Fe(new Gt([,-0]))[1]==Z?function(n){return new Gt(n)}:Mu;function Eo(n){return function(t){var e=hn(t);return e==Hn?Zr(t):e==Jn?Zf(t):Mf(t,n(t))}}function st(n,t,e,r,u,o,f,c){var s=t&En;if(!s&&typeof n!="function")throw new Nn(z);var v=r?r.length:0;if(v||(t&=~(un|on),r=u=a),f=f===a?f:Q(k(f),0),c=c===a?c:k(c),v-=u?u.length:0,t&on){var _=r,g=u;r=u=a}var m=s?a:bu(n),w=[n,t,e,r,u,_,g,o,f,c];if(m&&Vl(w,m),n=w[0],t=w[1],e=w[2],r=w[3],u=w[4],c=w[9]=w[9]===a?s?0:n.length:Q(w[9]-v,0),!c&&t&(mn|ot)&&(t&=~(mn|ot)),!t||t==X)var j=Cl(n,t,e);else t==mn||t==ot?j=Ol(n,t,c):(t==un||t==(X|un))&&!u.length?j=kl(n,t,e,r):j=er.apply(a,w);var S=m?io:Wo;return Uo(S(j,w),n,t)}function Co(n,t,e,r){return n===a||nt(n,Kt[e])&&!M.call(r,e)?t:n}function Oo(n,t,e,r,u,o){return V(n)&&V(t)&&(o.set(t,n),Qe(n,t,a,Oo,o),o.delete(t)),n}function Il(n){return Ee(n)?a:n}function ko(n,t,e,r,u,o){var f=e&Rn,c=n.length,s=t.length;if(c!=s&&!(f&&s>c))return!1;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var g=-1,m=!0,w=e&bn?new zt:a;for(o.set(n,t),o.set(t,n);++g<c;){var j=n[g],S=t[g];if(r)var A=f?r(S,j,g,t,n,o):r(j,S,g,n,t,o);if(A!==a){if(A)continue;m=!1;break}if(w){if(!Nr(t,function($,F){if(!pe(w,F)&&(j===$||u(j,$,e,r,o)))return w.push(F)})){m=!1;break}}else if(!(j===S||u(j,S,e,r,o))){m=!1;break}}return o.delete(n),o.delete(t),m}function $l(n,t,e,r,u,o,f){switch(e){case qt:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return!1;n=n.buffer,t=t.buffer;case se:return!(n.byteLength!=t.byteLength||!o(new Le(n),new Le(t)));case $t:case yt:case oe:return nt(+n,+t);case ue:return n.name==t.name&&n.message==t.message;case fe:case ce:return n==t+"";case Hn:var c=Zr;case Jn:var s=r&Rn;if(c||(c=Fe),n.size!=t.size&&!s)return!1;var v=f.get(n);if(v)return v==t;r|=bn,f.set(n,t);var _=ko(c(n),c(t),r,u,o,f);return f.delete(n),_;case Oe:if(ye)return ye.call(n)==ye.call(t)}return!1}function Bl(n,t,e,r,u,o){var f=e&Rn,c=du(n),s=c.length,v=du(t),_=v.length;if(s!=_&&!f)return!1;for(var g=s;g--;){var m=c[g];if(!(f?m in t:M.call(t,m)))return!1}var w=o.get(n),j=o.get(t);if(w&&j)return w==t&&j==n;var S=!0;o.set(n,t),o.set(t,n);for(var A=f;++g<s;){m=c[g];var $=n[m],F=t[m];if(r)var $n=f?r(F,$,m,t,n,o):r($,F,m,n,t,o);if(!($n===a?$===F||u($,F,e,r,o):$n)){S=!1;break}A||(A=m=="constructor")}if(S&&!A){var yn=n.constructor,Bn=t.constructor;yn!=Bn&&"constructor"in n&&"constructor"in t&&!(typeof yn=="function"&&yn instanceof yn&&typeof Bn=="function"&&Bn instanceof Bn)&&(S=!1)}return o.delete(n),o.delete(t),S}function pt(n){return Eu(Ro(n,a,qo),n+"")}function du(n){return Hi(n,tn,xu)}function mu(n){return Hi(n,jn,So)}var bu=Ye?function(n){return Ye.get(n)}:Mu;function or(n){for(var t=n.name+"",e=Jt[t],r=M.call(Jt,t)?e.length:0;r--;){var u=e[r],o=u.func;if(o==null||o==n)return u.name}return t}function te(n){var t=M.call(i,"placeholder")?i:n;return t.placeholder}function x(){var n=i.iteratee||Wu;return n=n===Wu?Ji:n,arguments.length?n(arguments[0],arguments[1]):n}function ar(n,t){var e=n.__data__;return Nl(t)?e[typeof t=="string"?"string":"hash"]:e.map}function wu(n){for(var t=tn(n),e=t.length;e--;){var r=t[e],u=n[r];t[e]=[r,u,Bo(u)]}return t}function Mt(n,t){var e=qf(n,t);return Gi(e)?e:a}function Fl(n){var t=M.call(n,Ft),e=n[Ft];try{n[Ft]=a;var r=!0}catch(o){}var u=Ue.call(n);return r&&(t?n[Ft]=e:delete n[Ft]),u}var xu=Kr?function(n){return n==null?[]:(n=N(n),bt(Kr(n),function(t){return Ri.call(n,t)}))}:Lu,So=Kr?function(n){for(var t=[];n;)wt(t,xu(n)),n=Ne(n);return t}:Lu,hn=_n;(Gr&&hn(new Gr(new ArrayBuffer(1)))!=qt||ve&&hn(new ve)!=Hn||Jr&&hn(Jr.resolve())!=Vu||Gt&&hn(new Gt)!=Jn||_e&&hn(new _e)!=le)&&(hn=function(n){var t=_n(n),e=t==at?n.constructor:a,r=e?Lt(e):"";if(r)switch(r){case gc:return qt;case yc:return Hn;case dc:return Vu;case mc:return Jn;case bc:return le}return t});function Rl(n,t,e){for(var r=-1,u=e.length;++r<u;){var o=e[r],f=o.size;switch(o.type){case"drop":n+=f;break;case"dropRight":t-=f;break;case"take":t=pn(t,n+f);break;case"takeRight":n=Q(n,t-f);break}}return{start:n,end:t}}function zl(n){var t=n.match(Na);return t?t[1].split(Pa):[]}function Io(n,t,e){t=Ct(t,n);for(var r=-1,u=t.length,o=!1;++r<u;){var f=ut(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f]}return o||++r!=u?o:(u=n==null?0:n.length,!!u&&vr(u)&&ht(f,u)&&(E(n)||Nt(n)))}function Wl(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&M.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function $o(n){return typeof n.constructor=="function"&&!Ae(n)?Qt(Ne(n)):{}}function Ul(n,t,e){var r=n.constructor;switch(t){case se:return _u(n);case $t:case yt:return new r(+n);case qt:return wl(n,e);case wr:case xr:case jr:case Ar:case Dr:case Er:case Cr:case Or:case kr:return ho(n,e);case Hn:return new r;case oe:case ce:return new r(n);case fe:return xl(n);case Jn:return new r;case Oe:return jl(n)}}function Ml(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(La,`{
/* [wrapped with `+t+`] */
`)}function Ll(n){return E(n)||Nt(n)||!!(zi&&n&&n[zi])}function ht(n,t){var e=typeof n;return t=t==null?en:t,!!t&&(e=="number"||e!="symbol"&&Ja.test(n))&&n>-1&&n%1==0&&n<t}function gn(n,t,e){if(!V(e))return!1;var r=typeof t;return(r=="number"?xn(e)&&ht(t,e.length):r=="string"&&t in e)?nt(e[t],n):!1}function ju(n,t){if(E(n))return!1;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||In(n)?!0:za.test(n)||!Ra.test(n)||t!=null&&n in N(t)}function Nl(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function Au(n){var t=or(n),e=i[t];if(typeof e!="function"||!(t in B.prototype))return!1;if(n===e)return!0;var r=bu(e);return!!r&&n===r[0]}function Pl(n){return!!$i&&$i in n}var Tl=ze?vt:Nu;function Ae(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Kt;return n===e}function Bo(n){return n===n&&!V(n)}function Fo(n,t){return function(e){return e==null?!1:e[n]===t&&(t!==a||n in N(e))}}function ql(n){var t=pr(n,function(r){return e.size===rn&&e.clear(),r}),e=t.cache;return t}function Vl(n,t){var e=n[1],r=t[1],u=e|r,o=u<(X|En|Y),f=r==Y&&e==mn||r==Y&&e==Cn&&n[7].length<=t[8]||r==(Y|Cn)&&t[7].length<=t[8]&&e==mn;if(!(o||f))return n;r&X&&(n[2]=t[2],u|=e&X?0:St);var c=t[3];if(c){var s=n[3];n[3]=s?_o(s,c,t[4]):c,n[4]=s?xt(n[3],Dn):t[4]}return c=t[5],c&&(s=n[5],n[5]=s?go(s,c,t[6]):c,n[6]=s?xt(n[5],Dn):t[6]),c=t[7],c&&(n[7]=c),r&Y&&(n[8]=n[8]==null?t[8]:pn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Yl(n){var t=[];if(n!=null)for(var e in N(n))t.push(e);return t}function Zl(n){return Ue.call(n)}function Ro(n,t,e){return t=Q(t===a?n.length-1:t,0),function(){for(var r=arguments,u=-1,o=Q(r.length-t,0),f=p(o);++u<o;)f[u]=r[t+u];u=-1;for(var c=p(t+1);++u<t;)c[u]=r[u];return c[t]=e(f),On(n,this,c)}}function zo(n,t){return t.length<2?n:Ut(n,qn(t,0,-1))}function Hl(n,t){for(var e=n.length,r=pn(t.length,e),u=wn(n);r--;){var o=t[r];n[r]=ht(o,e)?u[o]:a}return n}function Du(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Wo=Mo(io),De=cc||function(n,t){return nn.setTimeout(n,t)},Eu=Mo(yl);function Uo(n,t,e){var r=t+"";return Eu(n,Ml(r,Kl(zl(r),e)))}function Mo(n){var t=0,e=0;return function(){var r=hc(),u=zn-(r-e);if(e=r,u>0){if(++t>=Pt)return arguments[0]}else t=0;return n.apply(a,arguments)}}function fr(n,t){var e=-1,r=n.length,u=r-1;for(t=t===a?r:t;++e<t;){var o=fu(e,u),f=n[o];n[o]=n[e],n[e]=f}return n.length=t,n}var Lo=ql(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(Wa,function(e,r,u,o){t.push(u?o.replace(Va,"$1"):r||e)}),t});function ut(n){if(typeof n=="string"||In(n))return n;var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Lt(n){if(n!=null){try{return We.call(n)}catch(t){}try{return n+""}catch(t){}}return""}function Kl(n,t){return Ln(mr,function(e){var r="_."+e[0];t&e[1]&&!$e(n,r)&&n.push(r)}),n.sort()}function No(n){if(n instanceof B)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=wn(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Gl(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=Q(k(t),0);var r=n==null?0:n.length;if(!r||t<1)return[];for(var u=0,o=0,f=p(qe(r/t));u<r;)f[o++]=qn(n,u,u+=t);return f}function Jl(n){for(var t=-1,e=n==null?0:n.length,r=0,u=[];++t<e;){var o=n[t];o&&(u[r++]=o)}return u}function Ql(){var n=arguments.length;if(!n)return[];for(var t=p(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return wt(E(e)?wn(e):[e],an(t,1))}var Xl=I(function(n,t){return K(n)?me(n,an(t,1,K,!0)):[]}),ns=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),x(e,2)):[]}),ts=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),a,e):[]});function es(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),qn(n,t<0?0:t,r)):[]}function rs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,0,t<0?0:t)):[]}function us(n,t){return n&&n.length?nr(n,x(t,3),!0,!0):[]}function is(n,t){return n&&n.length?nr(n,x(t,3),!0):[]}function os(n,t,e,r){var u=n==null?0:n.length;return u?(e&&typeof e!="number"&&gn(n,t,e)&&(e=0,r=u),Qc(n,t,e,r)):[]}function Po(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Be(n,x(t,3),u)}function To(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r-1;return e!==a&&(u=k(e),u=e<0?Q(r+u,0):pn(u,r-1)),Be(n,x(t,3),u,!0)}function qo(n){var t=n==null?0:n.length;return t?an(n,1):[]}function as(n){var t=n==null?0:n.length;return t?an(n,Z):[]}function fs(n,t){var e=n==null?0:n.length;return e?(t=t===a?1:k(t),an(n,t)):[]}function cs(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var u=n[t];r[u[0]]=u[1]}return r}function Vo(n){return n&&n.length?n[0]:a}function ls(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Yt(n,t,u)}function ss(n){var t=n==null?0:n.length;return t?qn(n,0,-1):[]}var ps=I(function(n){var t=q(n,hu);return t.length&&t[0]===n[0]?ru(t):[]}),hs=I(function(n){var t=Vn(n),e=q(n,hu);return t===Vn(e)?t=a:e.pop(),e.length&&e[0]===n[0]?ru(e,x(t,2)):[]}),vs=I(function(n){var t=Vn(n),e=q(n,hu);return t=typeof t=="function"?t:a,t&&e.pop(),e.length&&e[0]===n[0]?ru(e,a,t):[]});function _s(n,t){return n==null?"":sc.call(n,t)}function Vn(n){var t=n==null?0:n.length;return t?n[t-1]:a}function gs(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r;return e!==a&&(u=k(e),u=u<0?Q(r+u,0):pn(u,r-1)),t===t?Kf(n,t,u):Be(n,Ai,u,!0)}function ys(n,t){return n&&n.length?to(n,k(t)):a}var ds=I(Yo);function Yo(n,t){return n&&n.length&&t&&t.length?au(n,t):n}function ms(n,t,e){return n&&n.length&&t&&t.length?au(n,t,x(e,2)):n}function bs(n,t,e){return n&&n.length&&t&&t.length?au(n,t,a,e):n}var ws=pt(function(n,t){var e=n==null?0:n.length,r=Xr(n,t);return uo(n,q(t,function(u){return ht(u,e)?+u:u}).sort(vo)),r});function xs(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,u=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),u.push(r))}return uo(n,u),e}function Cu(n){return n==null?n:_c.call(n)}function js(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&gn(n,t,e)?(t=0,e=r):(t=t==null?0:k(t),e=e===a?r:k(e)),qn(n,t,e)):[]}function As(n,t){return Xe(n,t)}function Ds(n,t,e){return lu(n,t,x(e,2))}function Es(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t);if(r<e&&nt(n[r],t))return r}return-1}function Cs(n,t){return Xe(n,t,!0)}function Os(n,t,e){return lu(n,t,x(e,2),!0)}function ks(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t,!0)-1;if(nt(n[r],t))return r}return-1}function Ss(n){return n&&n.length?oo(n):[]}function Is(n,t){return n&&n.length?oo(n,x(t,2)):[]}function $s(n){var t=n==null?0:n.length;return t?qn(n,1,t):[]}function Bs(n,t,e){return n&&n.length?(t=e||t===a?1:k(t),qn(n,0,t<0?0:t)):[]}function Fs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,t<0?0:t,r)):[]}function Rs(n,t){return n&&n.length?nr(n,x(t,3),!1,!0):[]}function zs(n,t){return n&&n.length?nr(n,x(t,3)):[]}var Ws=I(function(n){return Et(an(n,1,K,!0))}),Us=I(function(n){var t=Vn(n);return K(t)&&(t=a),Et(an(n,1,K,!0),x(t,2))}),Ms=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,Et(an(n,1,K,!0),a,t)});function Ls(n){return n&&n.length?Et(n):[]}function Ns(n,t){return n&&n.length?Et(n,x(t,2)):[]}function Ps(n,t){return t=typeof t=="function"?t:a,n&&n.length?Et(n,a,t):[]}function Ou(n){if(!(n&&n.length))return[];var t=0;return n=bt(n,function(e){if(K(e))return t=Q(e.length,t),!0}),Vr(t,function(e){return q(n,Pr(e))})}function Zo(n,t){if(!(n&&n.length))return[];var e=Ou(n);return t==null?e:q(e,function(r){return On(t,a,r)})}var Ts=I(function(n,t){return K(n)?me(n,t):[]}),qs=I(function(n){return pu(bt(n,K))}),Vs=I(function(n){var t=Vn(n);return K(t)&&(t=a),pu(bt(n,K),x(t,2))}),Ys=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,pu(bt(n,K),a,t)}),Zs=I(Ou);function Hs(n,t){return lo(n||[],t||[],de)}function Ks(n,t){return lo(n||[],t||[],xe)}var Gs=I(function(n){var t=n.length,e=t>1?n[t-1]:a;return e=typeof e=="function"?(n.pop(),e):a,Zo(n,e)});function Ho(n){var t=i(n);return t.__chain__=!0,t}function Js(n,t){return t(n),n}function cr(n,t){return t(n)}var Qs=pt(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,u=function(o){return Xr(o,n)};return t>1||this.__actions__.length||!(r instanceof B)||!ht(e)?this.thru(u):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:cr,args:[u],thisArg:a}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(a),o}))});function Xs(){return Ho(this)}function n0(){return new Pn(this.value(),this.__chain__)}function t0(){this.__values__===a&&(this.__values__=fa(this.value()));var n=this.__index__>=this.__values__.length,t=n?a:this.__values__[this.__index__++];return{done:n,value:t}}function e0(){return this}function r0(n){for(var t,e=this;e instanceof He;){var r=No(e);r.__index__=0,r.__values__=a,t?u.__wrapped__=r:t=r;var u=r;e=e.__wrapped__}return u.__wrapped__=n,t}function u0(){var n=this.__wrapped__;if(n instanceof B){var t=n;return this.__actions__.length&&(t=new B(this)),t=t.reverse(),t.__actions__.push({func:cr,args:[Cu],thisArg:a}),new Pn(t,this.__chain__)}return this.thru(Cu)}function i0(){return co(this.__wrapped__,this.__actions__)}var o0=tr(function(n,t,e){M.call(n,e)?++n[e]:lt(n,e,1)});function a0(n,t,e){var r=E(n)?xi:Jc;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}function f0(n,t){var e=E(n)?bt:Yi;return e(n,x(t,3))}var c0=wo(Po),l0=wo(To);function s0(n,t){return an(lr(n,t),1)}function p0(n,t){return an(lr(n,t),Z)}function h0(n,t,e){return e=e===a?1:k(e),an(lr(n,t),e)}function Ko(n,t){var e=E(n)?Ln:Dt;return e(n,x(t,3))}function Go(n,t){var e=E(n)?$f:Vi;return e(n,x(t,3))}var v0=tr(function(n,t,e){M.call(n,e)?n[e].push(t):lt(n,e,[t])});function _0(n,t,e,r){n=xn(n)?n:re(n),e=e&&!r?k(e):0;var u=n.length;return e<0&&(e=Q(u+e,0)),_r(n)?e<=u&&n.indexOf(t,e)>-1:!!u&&Yt(n,t,e)>-1}var g0=I(function(n,t,e){var r=-1,u=typeof t=="function",o=xn(n)?p(n.length):[];return Dt(n,function(f){o[++r]=u?On(t,f,e):be(f,t,e)}),o}),y0=tr(function(n,t,e){lt(n,e,t)});function lr(n,t){var e=E(n)?q:Qi;return e(n,x(t,3))}function d0(n,t,e,r){return n==null?[]:(E(t)||(t=t==null?[]:[t]),e=r?a:e,E(e)||(e=e==null?[]:[e]),eo(n,t,e))}var m0=tr(function(n,t,e){n[e?0:1].push(t)},function(){return[[],[]]});function b0(n,t,e){var r=E(n)?Lr:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Dt)}function w0(n,t,e){var r=E(n)?Bf:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Vi)}function x0(n,t){var e=E(n)?bt:Yi;return e(n,hr(x(t,3)))}function j0(n){var t=E(n)?Ni:_l;return t(n)}function A0(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=k(t);var r=E(n)?Yc:gl;return r(n,t)}function D0(n){var t=E(n)?Zc:dl;return t(n)}function E0(n){if(n==null)return 0;if(xn(n))return _r(n)?Ht(n):n.length;var t=hn(n);return t==Hn||t==Jn?n.size:iu(n).length}function C0(n,t,e){var r=E(n)?Nr:ml;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}var O0=I(function(n,t){if(n==null)return[];var e=t.length;return e>1&&gn(n,t[0],t[1])?t=[]:e>2&&gn(t[0],t[1],t[2])&&(t=[t[0]]),eo(n,an(t,1),[])}),sr=fc||function(){return nn.Date.now()};function k0(n,t){if(typeof t!="function")throw new Nn(z);return n=k(n),function(){if(--n<1)return t.apply(this,arguments)}}function Jo(n,t,e){return t=e?a:t,t=n&&t==null?n.length:t,st(n,Y,a,a,a,a,t)}function Qo(n,t){var e;if(typeof t!="function")throw new Nn(z);return n=k(n),function(){return--n>0&&(e=t.apply(this,arguments)),n<=1&&(t=a),e}}var ku=I(function(n,t,e){var r=X;if(e.length){var u=xt(e,te(ku));r|=un}return st(n,r,t,e,u)}),Xo=I(function(n,t,e){var r=X|En;if(e.length){var u=xt(e,te(Xo));r|=un}return st(t,r,n,e,u)});function na(n,t,e){t=e?a:t;var r=st(n,mn,a,a,a,a,a,t);return r.placeholder=na.placeholder,r}function ta(n,t,e){t=e?a:t;var r=st(n,ot,a,a,a,a,a,t);return r.placeholder=ta.placeholder,r}function ea(n,t,e){var r,u,o,f,c,s,v=0,_=!1,g=!1,m=!0;if(typeof n!="function")throw new Nn(z);t=Yn(t)||0,V(e)&&(_=!!e.leading,g="maxWait"in e,o=g?Q(Yn(e.maxWait)||0,t):o,m="trailing"in e?!!e.trailing:m);function w(G){var tt=r,gt=u;return r=u=a,v=G,f=n.apply(gt,tt),f}function j(G){return v=G,c=De($,t),_?w(G):f}function S(G){var tt=G-s,gt=G-v,wa=t-tt;return g?pn(wa,o-gt):wa}function A(G){var tt=G-s,gt=G-v;return s===a||tt>=t||tt<0||g&&gt>=o}function $(){var G=sr();if(A(G))return F(G);c=De($,S(G))}function F(G){return c=a,m&&r?w(G):(r=u=a,f)}function $n(){c!==a&&so(c),v=0,r=s=u=c=a}function yn(){return c===a?f:F(sr())}function Bn(){var G=sr(),tt=A(G);if(r=arguments,u=this,s=G,tt){if(c===a)return j(s);if(g)return so(c),c=De($,t),w(s)}return c===a&&(c=De($,t)),f}return Bn.cancel=$n,Bn.flush=yn,Bn}var S0=I(function(n,t){return qi(n,1,t)}),I0=I(function(n,t,e){return qi(n,Yn(t)||0,e)});function $0(n){return st(n,Wn)}function pr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new Nn(z);var e=function(){var r=arguments,u=t?t.apply(this,r):r[0],o=e.cache;if(o.has(u))return o.get(u);var f=n.apply(this,r);return e.cache=o.set(u,f)||o,f};return e.cache=new(pr.Cache||ct),e}pr.Cache=ct;function hr(n){if(typeof n!="function")throw new Nn(z);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function B0(n){return Qo(2,n)}var F0=bl(function(n,t){t=t.length==1&&E(t[0])?q(t[0],kn(x())):q(an(t,1),kn(x()));var e=t.length;return I(function(r){for(var u=-1,o=pn(r.length,e);++u<o;)r[u]=t[u].call(this,r[u]);return On(n,this,r)})}),Su=I(function(n,t){var e=xt(t,te(Su));return st(n,un,a,t,e)}),ra=I(function(n,t){var e=xt(t,te(ra));return st(n,on,a,t,e)}),R0=pt(function(n,t){return st(n,Cn,a,a,a,t)});function z0(n,t){if(typeof n!="function")throw new Nn(z);return t=t===a?t:k(t),I(n,t)}function W0(n,t){if(typeof n!="function")throw new Nn(z);return t=t==null?0:Q(k(t),0),I(function(e){var r=e[t],u=Ot(e,0,t);return r&&wt(u,r),On(n,this,u)})}function U0(n,t,e){var r=!0,u=!0;if(typeof n!="function")throw new Nn(z);return V(e)&&(r="leading"in e?!!e.leading:r,u="trailing"in e?!!e.trailing:u),ea(n,t,{leading:r,maxWait:t,trailing:u})}function M0(n){return Jo(n,1)}function L0(n,t){return Su(vu(t),n)}function N0(){if(!arguments.length)return[];var n=arguments[0];return E(n)?n:[n]}function P0(n){return Tn(n,Un)}function T0(n,t){return t=typeof t=="function"?t:a,Tn(n,Un,t)}function q0(n){return Tn(n,sn|Un)}function V0(n,t){return t=typeof t=="function"?t:a,Tn(n,sn|Un,t)}function Y0(n,t){return t==null||Ti(n,t,tn(t))}function nt(n,t){return n===t||n!==n&&t!==t}var Z0=ir(eu),H0=ir(function(n,t){return n>=t}),Nt=Ki(function(){return arguments}())?Ki:function(n){return H(n)&&M.call(n,"callee")&&!Ri.call(n,"callee")},E=p.isArray,K0=gi?kn(gi):rl;function xn(n){return n!=null&&vr(n.length)&&!vt(n)}function K(n){return H(n)&&xn(n)}function G0(n){return n===!0||n===!1||H(n)&&_n(n)==$t}var kt=lc||Nu,J0=yi?kn(yi):ul;function Q0(n){return H(n)&&n.nodeType===1&&!Ee(n)}function X0(n){if(n==null)return!0;if(xn(n)&&(E(n)||typeof n=="string"||typeof n.splice=="function"||kt(n)||ee(n)||Nt(n)))return!n.length;var t=hn(n);if(t==Hn||t==Jn)return!n.size;if(Ae(n))return!iu(n).length;for(var e in n)if(M.call(n,e))return!1;return!0}function np(n,t){return we(n,t)}function tp(n,t,e){e=typeof e=="function"?e:a;var r=e?e(n,t):a;return r===a?we(n,t,a,e):!!r}function Iu(n){if(!H(n))return!1;var t=_n(n);return t==ue||t==yr||typeof n.message=="string"&&typeof n.name=="string"&&!Ee(n)}function ep(n){return typeof n=="number"&&Wi(n)}function vt(n){if(!V(n))return!1;var t=_n(n);return t==ie||t==qu||t==Tu||t==Da}function ua(n){return typeof n=="number"&&n==k(n)}function vr(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=en}function V(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function H(n){return n!=null&&typeof n=="object"}var ia=di?kn(di):ol;function rp(n,t){return n===t||uu(n,t,wu(t))}function up(n,t,e){return e=typeof e=="function"?e:a,uu(n,t,wu(t),e)}function ip(n){return oa(n)&&n!=+n}function op(n){if(Tl(n))throw new D(L);return Gi(n)}function ap(n){return n===null}function fp(n){return n==null}function oa(n){return typeof n=="number"||H(n)&&_n(n)==oe}function Ee(n){if(!H(n)||_n(n)!=at)return!1;var t=Ne(n);if(t===null)return!0;var e=M.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&We.call(e)==uc}var $u=mi?kn(mi):al;function cp(n){return ua(n)&&n>=-en&&n<=en}var aa=bi?kn(bi):fl;function _r(n){return typeof n=="string"||!E(n)&&H(n)&&_n(n)==ce}function In(n){return typeof n=="symbol"||H(n)&&_n(n)==Oe}var ee=wi?kn(wi):cl;function lp(n){return n===a}function sp(n){return H(n)&&hn(n)==le}function pp(n){return H(n)&&_n(n)==Ca}var hp=ir(ou),vp=ir(function(n,t){return n<=t});function fa(n){if(!n)return[];if(xn(n))return _r(n)?Qn(n):wn(n);if(he&&n[he])return Yf(n[he]());var t=hn(n),e=t==Hn?Zr:t==Jn?Fe:re;return e(n)}function _t(n){if(!n)return n===0?n:0;if(n=Yn(n),n===Z||n===-Z){var t=n<0?-1:1;return t*Zn}return n===n?n:0}function k(n){var t=_t(n),e=t%1;return t===t?e?t-e:t:0}function ca(n){return n?Wt(k(n),0,vn):0}function Yn(n){if(typeof n=="number")return n;if(In(n))return Kn;if(V(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=V(t)?t+"":t}if(typeof n!="string")return n===0?n:+n;n=Ci(n);var e=Ha.test(n);return e||Ga.test(n)?kf(n.slice(2),e?2:8):Za.test(n)?Kn:+n}function la(n){return rt(n,jn(n))}function _p(n){return n?Wt(k(n),-en,en):n===0?n:0}function U(n){return n==null?"":Sn(n)}var gp=Xt(function(n,t){if(Ae(t)||xn(t)){rt(t,tn(t),n);return}for(var e in t)M.call(t,e)&&de(n,e,t[e])}),sa=Xt(function(n,t){rt(t,jn(t),n)}),gr=Xt(function(n,t,e,r){rt(t,jn(t),n,r)}),yp=Xt(function(n,t,e,r){rt(t,tn(t),n,r)}),dp=pt(Xr);function mp(n,t){var e=Qt(n);return t==null?e:Pi(e,t)}var bp=I(function(n,t){n=N(n);var e=-1,r=t.length,u=r>2?t[2]:a;for(u&&gn(t[0],t[1],u)&&(r=1);++e<r;)for(var o=t[e],f=jn(o),c=-1,s=f.length;++c<s;){var v=f[c],_=n[v];(_===a||nt(_,Kt[v])&&!M.call(n,v))&&(n[v]=o[v])}return n}),wp=I(function(n){return n.push(a,Oo),On(pa,a,n)});function xp(n,t){return ji(n,x(t,3),et)}function jp(n,t){return ji(n,x(t,3),tu)}function Ap(n,t){return n==null?n:nu(n,x(t,3),jn)}function Dp(n,t){return n==null?n:Zi(n,x(t,3),jn)}function Ep(n,t){return n&&et(n,x(t,3))}function Cp(n,t){return n&&tu(n,x(t,3))}function Op(n){return n==null?[]:Je(n,tn(n))}function kp(n){return n==null?[]:Je(n,jn(n))}function Bu(n,t,e){var r=n==null?a:Ut(n,t);return r===a?e:r}function Sp(n,t){return n!=null&&Io(n,t,Xc)}function Fu(n,t){return n!=null&&Io(n,t,nl)}var Ip=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),n[t]=e},zu(An)),$p=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),M.call(n,t)?n[t].push(e):n[t]=[e]},x),Bp=I(be);function tn(n){return xn(n)?Li(n):iu(n)}function jn(n){return xn(n)?Li(n,!0):ll(n)}function Fp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,t(r,u,o),r)}),e}function Rp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,u,t(r,u,o))}),e}var zp=Xt(function(n,t,e){Qe(n,t,e)}),pa=Xt(function(n,t,e,r){Qe(n,t,e,r)}),Wp=pt(function(n,t){var e={};if(n==null)return e;var r=!1;t=q(t,function(o){return o=Ct(o,n),r||(r=o.length>1),o}),rt(n,mu(n),e),r&&(e=Tn(e,sn|dt|Un,Il));for(var u=t.length;u--;)su(e,t[u]);return e});function Up(n,t){return ha(n,hr(x(t)))}var Mp=pt(function(n,t){return n==null?{}:pl(n,t)});function ha(n,t){if(n==null)return{};var e=q(mu(n),function(r){return[r]});return t=x(t),ro(n,e,function(r,u){return t(r,u[0])})}function Lp(n,t,e){t=Ct(t,n);var r=-1,u=t.length;for(u||(u=1,n=a);++r<u;){var o=n==null?a:n[ut(t[r])];o===a&&(r=u,o=e),n=vt(o)?o.call(n):o}return n}function Np(n,t,e){return n==null?n:xe(n,t,e)}function Pp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:xe(n,t,e,r)}var va=Eo(tn),_a=Eo(jn);function Tp(n,t,e){var r=E(n),u=r||kt(n)||ee(n);if(t=x(t,4),e==null){var o=n&&n.constructor;u?e=r?new o:[]:V(n)?e=vt(o)?Qt(Ne(n)):{}:e={}}return(u?Ln:et)(n,function(f,c,s){return t(e,f,c,s)}),e}function qp(n,t){return n==null?!0:su(n,t)}function Vp(n,t,e){return n==null?n:fo(n,t,vu(e))}function Yp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:fo(n,t,vu(e),r)}function re(n){return n==null?[]:Yr(n,tn(n))}function Zp(n){return n==null?[]:Yr(n,jn(n))}function Hp(n,t,e){return e===a&&(e=t,t=a),e!==a&&(e=Yn(e),e=e===e?e:0),t!==a&&(t=Yn(t),t=t===t?t:0),Wt(Yn(n),t,e)}function Kp(n,t,e){return t=_t(t),e===a?(e=t,t=0):e=_t(e),n=Yn(n),tl(n,t,e)}function Gp(n,t,e){if(e&&typeof e!="boolean"&&gn(n,t,e)&&(t=e=a),e===a&&(typeof t=="boolean"?(e=t,t=a):typeof n=="boolean"&&(e=n,n=a)),n===a&&t===a?(n=0,t=1):(n=_t(n),t===a?(t=n,n=0):t=_t(t)),n>t){var r=n;n=t,t=r}if(e||n%1||t%1){var u=Ui();return pn(n+u*(t-n+Of("1e-"+((u+"").length-1))),t)}return fu(n,t)}var Jp=ne(function(n,t,e){return t=t.toLowerCase(),n+(e?ga(t):t)});function ga(n){return Ru(U(n).toLowerCase())}function ya(n){return n=U(n),n&&n.replace(Qa,Nf).replace(df,"")}function Qp(n,t,e){n=U(n),t=Sn(t);var r=n.length;e=e===a?r:Wt(k(e),0,r);var u=e;return e-=t.length,e>=0&&n.slice(e,u)==t}function Xp(n){return n=U(n),n&&$a.test(n)?n.replace(Zu,Pf):n}function nh(n){return n=U(n),n&&Ua.test(n)?n.replace(Sr,"\\$&"):n}var th=ne(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),eh=ne(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),rh=bo("toLowerCase");function uh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;if(!t||r>=t)return n;var u=(t-r)/2;return ur(Ve(u),e)+n+ur(qe(u),e)}function ih(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?n+ur(t-r,e):n}function oh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?ur(t-r,e)+n:n}function ah(n,t,e){return e||t==null?t=0:t&&(t=+t),vc(U(n).replace(Ir,""),t||0)}function fh(n,t,e){return(e?gn(n,t,e):t===a)?t=1:t=k(t),cu(U(n),t)}function ch(){var n=arguments,t=U(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var lh=ne(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function sh(n,t,e){return e&&typeof e!="number"&&gn(n,t,e)&&(t=e=a),e=e===a?vn:e>>>0,e?(n=U(n),n&&(typeof t=="string"||t!=null&&!$u(t))&&(t=Sn(t),!t&&Zt(n))?Ot(Qn(n),0,e):n.split(t,e)):[]}var ph=ne(function(n,t,e){return n+(e?" ":"")+Ru(t)});function hh(n,t,e){return n=U(n),e=e==null?0:Wt(k(e),0,n.length),t=Sn(t),n.slice(e,e+t.length)==t}function vh(n,t,e){var r=i.templateSettings;e&&gn(n,t,e)&&(t=a),n=U(n),t=gr({},t,r,Co);var u=gr({},t.imports,r.imports,Co),o=tn(u),f=Yr(u,o),c,s,v=0,_=t.interpolate||ke,g="__p += '",m=Hr((t.escape||ke).source+"|"+_.source+"|"+(_===Hu?Ya:ke).source+"|"+(t.evaluate||ke).source+"|$","g"),w="//# sourceURL="+(M.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++jf+"]")+`
`;n.replace(m,function(A,$,F,$n,yn,Bn){return F||(F=$n),g+=n.slice(v,Bn).replace(Xa,Tf),$&&(c=!0,g+=`' +
__e(`+$+`) +
'`),yn&&(s=!0,g+=`';
`+yn+`;
__p += '`),F&&(g+=`' +
((__t = (`+F+`)) == null ? '' : __t) +
'`),v=Bn+A.length,A}),g+=`';
`;var j=M.call(t,"variable")&&t.variable;if(!j)g=`with (obj) {
`+g+`
}
`;else if(qa.test(j))throw new D(fn);g=(s?g.replace(Oa,""):g).replace(ka,"$1").replace(Sa,"$1;"),g="function("+(j||"obj")+`) {
`+(j?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(s?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+g+`return __p
}`;var S=ma(function(){return W(o,w+"return "+g).apply(a,f)});if(S.source=g,Iu(S))throw S;return S}function _h(n){return U(n).toLowerCase()}function gh(n){return U(n).toUpperCase()}function yh(n,t,e){if(n=U(n),n&&(e||t===a))return Ci(n);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Qn(t),o=Oi(r,u),f=ki(r,u)+1;return Ot(r,o,f).join("")}function dh(n,t,e){if(n=U(n),n&&(e||t===a))return n.slice(0,Ii(n)+1);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=ki(r,Qn(t))+1;return Ot(r,0,u).join("")}function mh(n,t,e){if(n=U(n),n&&(e||t===a))return n.replace(Ir,"");if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Oi(r,Qn(t));return Ot(r,u).join("")}function bh(n,t){var e=Fn,r=It;if(V(t)){var u="separator"in t?t.separator:u;e="length"in t?k(t.length):e,r="omission"in t?Sn(t.omission):r}n=U(n);var o=n.length;if(Zt(n)){var f=Qn(n);o=f.length}if(e>=o)return n;var c=e-Ht(r);if(c<1)return r;var s=f?Ot(f,0,c).join(""):n.slice(0,c);if(u===a)return s+r;if(f&&(c+=s.length-c),$u(u)){if(n.slice(c).search(u)){var v,_=s;for(u.global||(u=Hr(u.source,U(Ku.exec(u))+"g")),u.lastIndex=0;v=u.exec(_);)var g=v.index;s=s.slice(0,g===a?c:g)}}else if(n.indexOf(Sn(u),c)!=c){var m=s.lastIndexOf(u);m>-1&&(s=s.slice(0,m))}return s+r}function wh(n){return n=U(n),n&&Ia.test(n)?n.replace(Yu,Gf):n}var xh=ne(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Ru=bo("toUpperCase");function da(n,t,e){return n=U(n),t=e?a:t,t===a?Vf(n)?Xf(n):zf(n):n.match(t)||[]}var ma=I(function(n,t){try{return On(n,a,t)}catch(e){return Iu(e)?e:new D(e)}}),jh=pt(function(n,t){return Ln(t,function(e){e=ut(e),lt(n,e,ku(n[e],n))}),n});function Ah(n){var t=n==null?0:n.length,e=x();return n=t?q(n,function(r){if(typeof r[1]!="function")throw new Nn(z);return[e(r[0]),r[1]]}):[],I(function(r){for(var u=-1;++u<t;){var o=n[u];if(On(o[0],this,r))return On(o[1],this,r)}})}function Dh(n){return Gc(Tn(n,sn))}function zu(n){return function(){return n}}function Eh(n,t){return n==null||n!==n?t:n}var Ch=xo(),Oh=xo(!0);function An(n){return n}function Wu(n){return Ji(typeof n=="function"?n:Tn(n,sn))}function kh(n){return Xi(Tn(n,sn))}function Sh(n,t){return no(n,Tn(t,sn))}var Ih=I(function(n,t){return function(e){return be(e,n,t)}}),$h=I(function(n,t){return function(e){return be(n,e,t)}});function Uu(n,t,e){var r=tn(t),u=Je(t,r);e==null&&!(V(t)&&(u.length||!r.length))&&(e=t,t=n,n=this,u=Je(t,tn(t)));var o=!(V(e)&&"chain"in e)||!!e.chain,f=vt(n);return Ln(u,function(c){var s=t[c];n[c]=s,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),g=_.__actions__=wn(this.__actions__);return g.push({func:s,args:arguments,thisArg:n}),_.__chain__=v,_}return s.apply(n,wt([this.value()],arguments))})}),n}function Bh(){return nn._===this&&(nn._=ic),this}function Mu(){}function Fh(n){return n=k(n),I(function(t){return to(t,n)})}var Rh=gu(q),zh=gu(xi),Wh=gu(Nr);function ba(n){return ju(n)?Pr(ut(n)):hl(n)}function Uh(n){return function(t){return n==null?a:Ut(n,t)}}var Mh=Ao(),Lh=Ao(!0);function Lu(){return[]}function Nu(){return!1}function Nh(){return{}}function Ph(){return""}function Th(){return!0}function qh(n,t){if(n=k(n),n<1||n>en)return[];var e=vn,r=pn(n,vn);t=x(t),n-=vn;for(var u=Vr(r,t);++e<n;)t(e);return u}function Vh(n){return E(n)?q(n,ut):In(n)?[n]:wn(Lo(U(n)))}function Yh(n){var t=++rc;return U(n)+t}var Zh=rr(function(n,t){return n+t},0),Hh=yu("ceil"),Kh=rr(function(n,t){return n/t},1),Gh=yu("floor");function Jh(n){return n&&n.length?Ge(n,An,eu):a}function Qh(n,t){return n&&n.length?Ge(n,x(t,2),eu):a}function Xh(n){return Di(n,An)}function nv(n,t){return Di(n,x(t,2))}function tv(n){return n&&n.length?Ge(n,An,ou):a}function ev(n,t){return n&&n.length?Ge(n,x(t,2),ou):a}var rv=rr(function(n,t){return n*t},1),uv=yu("round"),iv=rr(function(n,t){return n-t},0);function ov(n){return n&&n.length?qr(n,An):0}function av(n,t){return n&&n.length?qr(n,x(t,2)):0}return i.after=k0,i.ary=Jo,i.assign=gp,i.assignIn=sa,i.assignInWith=gr,i.assignWith=yp,i.at=dp,i.before=Qo,i.bind=ku,i.bindAll=jh,i.bindKey=Xo,i.castArray=N0,i.chain=Ho,i.chunk=Gl,i.compact=Jl,i.concat=Ql,i.cond=Ah,i.conforms=Dh,i.constant=zu,i.countBy=o0,i.create=mp,i.curry=na,i.curryRight=ta,i.debounce=ea,i.defaults=bp,i.defaultsDeep=wp,i.defer=S0,i.delay=I0,i.difference=Xl,i.differenceBy=ns,i.differenceWith=ts,i.drop=es,i.dropRight=rs,i.dropRightWhile=us,i.dropWhile=is,i.fill=os,i.filter=f0,i.flatMap=s0,i.flatMapDeep=p0,i.flatMapDepth=h0,i.flatten=qo,i.flattenDeep=as,i.flattenDepth=fs,i.flip=$0,i.flow=Ch,i.flowRight=Oh,i.fromPairs=cs,i.functions=Op,i.functionsIn=kp,i.groupBy=v0,i.initial=ss,i.intersection=ps,i.intersectionBy=hs,i.intersectionWith=vs,i.invert=Ip,i.invertBy=$p,i.invokeMap=g0,i.iteratee=Wu,i.keyBy=y0,i.keys=tn,i.keysIn=jn,i.map=lr,i.mapKeys=Fp,i.mapValues=Rp,i.matches=kh,i.matchesProperty=Sh,i.memoize=pr,i.merge=zp,i.mergeWith=pa,i.method=Ih,i.methodOf=$h,i.mixin=Uu,i.negate=hr,i.nthArg=Fh,i.omit=Wp,i.omitBy=Up,i.once=B0,i.orderBy=d0,i.over=Rh,i.overArgs=F0,i.overEvery=zh,i.overSome=Wh,i.partial=Su,i.partialRight=ra,i.partition=m0,i.pick=Mp,i.pickBy=ha,i.property=ba,i.propertyOf=Uh,i.pull=ds,i.pullAll=Yo,i.pullAllBy=ms,i.pullAllWith=bs,i.pullAt=ws,i.range=Mh,i.rangeRight=Lh,i.rearg=R0,i.reject=x0,i.remove=xs,i.rest=z0,i.reverse=Cu,i.sampleSize=A0,i.set=Np,i.setWith=Pp,i.shuffle=D0,i.slice=js,i.sortBy=O0,i.sortedUniq=Ss,i.sortedUniqBy=Is,i.split=sh,i.spread=W0,i.tail=$s,i.take=Bs,i.takeRight=Fs,i.takeRightWhile=Rs,i.takeWhile=zs,i.tap=Js,i.throttle=U0,i.thru=cr,i.toArray=fa,i.toPairs=va,i.toPairsIn=_a,i.toPath=Vh,i.toPlainObject=la,i.transform=Tp,i.unary=M0,i.union=Ws,i.unionBy=Us,i.unionWith=Ms,i.uniq=Ls,i.uniqBy=Ns,i.uniqWith=Ps,i.unset=qp,i.unzip=Ou,i.unzipWith=Zo,i.update=Vp,i.updateWith=Yp,i.values=re,i.valuesIn=Zp,i.without=Ts,i.words=da,i.wrap=L0,i.xor=qs,i.xorBy=Vs,i.xorWith=Ys,i.zip=Zs,i.zipObject=Hs,i.zipObjectDeep=Ks,i.zipWith=Gs,i.entries=va,i.entriesIn=_a,i.extend=sa,i.extendWith=gr,Uu(i,i),i.add=Zh,i.attempt=ma,i.camelCase=Jp,i.capitalize=ga,i.ceil=Hh,i.clamp=Hp,i.clone=P0,i.cloneDeep=q0,i.cloneDeepWith=V0,i.cloneWith=T0,i.conformsTo=Y0,i.deburr=ya,i.defaultTo=Eh,i.divide=Kh,i.endsWith=Qp,i.eq=nt,i.escape=Xp,i.escapeRegExp=nh,i.every=a0,i.find=c0,i.findIndex=Po,i.findKey=xp,i.findLast=l0,i.findLastIndex=To,i.findLastKey=jp,i.floor=Gh,i.forEach=Ko,i.forEachRight=Go,i.forIn=Ap,i.forInRight=Dp,i.forOwn=Ep,i.forOwnRight=Cp,i.get=Bu,i.gt=Z0,i.gte=H0,i.has=Sp,i.hasIn=Fu,i.head=Vo,i.identity=An,i.includes=_0,i.indexOf=ls,i.inRange=Kp,i.invoke=Bp,i.isArguments=Nt,i.isArray=E,i.isArrayBuffer=K0,i.isArrayLike=xn,i.isArrayLikeObject=K,i.isBoolean=G0,i.isBuffer=kt,i.isDate=J0,i.isElement=Q0,i.isEmpty=X0,i.isEqual=np,i.isEqualWith=tp,i.isError=Iu,i.isFinite=ep,i.isFunction=vt,i.isInteger=ua,i.isLength=vr,i.isMap=ia,i.isMatch=rp,i.isMatchWith=up,i.isNaN=ip,i.isNative=op,i.isNil=fp,i.isNull=ap,i.isNumber=oa,i.isObject=V,i.isObjectLike=H,i.isPlainObject=Ee,i.isRegExp=$u,i.isSafeInteger=cp,i.isSet=aa,i.isString=_r,i.isSymbol=In,i.isTypedArray=ee,i.isUndefined=lp,i.isWeakMap=sp,i.isWeakSet=pp,i.join=_s,i.kebabCase=th,i.last=Vn,i.lastIndexOf=gs,i.lowerCase=eh,i.lowerFirst=rh,i.lt=hp,i.lte=vp,i.max=Jh,i.maxBy=Qh,i.mean=Xh,i.meanBy=nv,i.min=tv,i.minBy=ev,i.stubArray=Lu,i.stubFalse=Nu,i.stubObject=Nh,i.stubString=Ph,i.stubTrue=Th,i.multiply=rv,i.nth=ys,i.noConflict=Bh,i.noop=Mu,i.now=sr,i.pad=uh,i.padEnd=ih,i.padStart=oh,i.parseInt=ah,i.random=Gp,i.reduce=b0,i.reduceRight=w0,i.repeat=fh,i.replace=ch,i.result=Lp,i.round=uv,i.runInContext=l,i.sample=j0,i.size=E0,i.snakeCase=lh,i.some=C0,i.sortedIndex=As,i.sortedIndexBy=Ds,i.sortedIndexOf=Es,i.sortedLastIndex=Cs,i.sortedLastIndexBy=Os,i.sortedLastIndexOf=ks,i.startCase=ph,i.startsWith=hh,i.subtract=iv,i.sum=ov,i.sumBy=av,i.template=vh,i.times=qh,i.toFinite=_t,i.toInteger=k,i.toLength=ca,i.toLower=_h,i.toNumber=Yn,i.toSafeInteger=_p,i.toString=U,i.toUpper=gh,i.trim=yh,i.trimEnd=dh,i.trimStart=mh,i.truncate=bh,i.unescape=wh,i.uniqueId=Yh,i.upperCase=xh,i.upperFirst=Ru,i.each=Ko,i.eachRight=Go,i.first=Vo,Uu(i,function(){var n={};return et(i,function(t,e){M.call(i.prototype,e)||(n[e]=t)}),n}(),{chain:!1}),i.VERSION=O,Ln(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){i[n].placeholder=i}),Ln(["drop","take"],function(n,t){B.prototype[n]=function(e){e=e===a?1:Q(k(e),0);var r=this.__filtered__&&!t?new B(this):this.clone();return r.__filtered__?r.__takeCount__=pn(e,r.__takeCount__):r.__views__.push({size:pn(e,vn),type:n+(r.__dir__<0?"Right":"")}),r},B.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()}}),Ln(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==cn||e==Gn;B.prototype[n]=function(u){var o=this.clone();return o.__iteratees__.push({iteratee:x(u,3),type:e}),o.__filtered__=o.__filtered__||r,o}}),Ln(["head","last"],function(n,t){var e="take"+(t?"Right":"");B.prototype[n]=function(){return this[e](1).value()[0]}}),Ln(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");B.prototype[n]=function(){return this.__filtered__?new B(this):this[e](1)}}),B.prototype.compact=function(){return this.filter(An)},B.prototype.find=function(n){return this.filter(n).head()},B.prototype.findLast=function(n){return this.reverse().find(n)},B.prototype.invokeMap=I(function(n,t){return typeof n=="function"?new B(this):this.map(function(e){return be(e,n,t)})}),B.prototype.reject=function(n){return this.filter(hr(x(n)))},B.prototype.slice=function(n,t){n=k(n);var e=this;return e.__filtered__&&(n>0||t<0)?new B(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==a&&(t=k(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},B.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},B.prototype.toArray=function(){return this.take(vn)},et(B.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),u=i[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);!u||(i.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,s=f instanceof B,v=c[0],_=s||E(f),g=function($){var F=u.apply(i,wt([$],c));return r&&m?F[0]:F};_&&e&&typeof v=="function"&&v.length!=1&&(s=_=!1);var m=this.__chain__,w=!!this.__actions__.length,j=o&&!m,S=s&&!w;if(!o&&_){f=S?f:new B(this);var A=n.apply(f,c);return A.__actions__.push({func:cr,args:[g],thisArg:a}),new Pn(A,m)}return j&&S?n.apply(this,c):(A=this.thru(g),j?r?A.value()[0]:A.value():A)})}),Ln(["pop","push","shift","sort","splice","unshift"],function(n){var t=Re[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);i.prototype[n]=function(){var u=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(E(o)?o:[],u)}return this[e](function(f){return t.apply(E(f)?f:[],u)})}}),et(B.prototype,function(n,t){var e=i[t];if(e){var r=e.name+"";M.call(Jt,r)||(Jt[r]=[]),Jt[r].push({name:t,func:e})}}),Jt[er(a,En).name]=[{name:"wrapper",func:a}],B.prototype.clone=wc,B.prototype.reverse=xc,B.prototype.value=jc,i.prototype.at=Qs,i.prototype.chain=Xs,i.prototype.commit=n0,i.prototype.next=t0,i.prototype.plant=r0,i.prototype.reverse=u0,i.prototype.toJSON=i.prototype.valueOf=i.prototype.value=i0,i.prototype.first=i.prototype.head,he&&(i.prototype[he]=e0),i},jt=nc();typeof define=="function"&&typeof __webpack_require__("3c35")=="object"&&__webpack_require__("3c35")?(nn._=jt,define(function(){return jt})):Bt?((Bt.exports=jt)._=jt,Wr._=jt):nn._=jt}).call(y)});var Lg=C1(O1());var k1=Object.create,Mv=Object.defineProperty,S1=Object.getOwnPropertyDescriptor,I1=Object.getOwnPropertyNames,$1=Object.getPrototypeOf,B1=Object.prototype.hasOwnProperty,F1=y=>Mv(y,"__esModule",{value:!0}),R1=(y,d)=>()=>(d||y((d={exports:{}}).exports,d),d.exports),z1=(y,d,a)=>{if(d&&typeof d=="object"||typeof d=="function")for(let O of I1(d))!B1.call(y,O)&&O!=="default"&&Mv(y,O,{get:()=>d[O],enumerable:!(a=S1(d,O))||a.enumerable});return y},Dv=y=>z1(F1(Mv(y!=null?k1($1(y)):{},"default",y&&y.__esModule&&"default"in y?{get:()=>y.default,enumerable:!0}:{value:y,enumerable:!0})),y),Ev=R1((y,d)=>{(function(){var a,O="4.17.21",R=200,L="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",z="Expected a function",fn="Invalid `variable` option passed into `_.template`",dn="__lodash_hash_undefined__",rn=500,Dn="__lodash_placeholder__",sn=1,dt=2,Un=4,Rn=1,bn=2,X=1,En=2,St=4,mn=8,ot=16,un=32,on=64,Y=128,Cn=256,Wn=512,Fn=30,It="...",Pt=800,zn=16,cn=1,ln=2,Gn=3,Z=1/0,en=9007199254740991,Zn=17976931348623157e292,Kn=0/0,vn=4294967295,Tt=vn-1,Ce=vn>>>1,mr=[["ary",Y],["bind",X],["bindKey",En],["curry",mn],["curryRight",ot],["flip",Wn],["partial",un],["partialRight",on],["rearg",Cn]],mt="[object Arguments]",ae="[object Array]",Tu="[object AsyncFunction]",$t="[object Boolean]",yt="[object Date]",yr="[object DOMException]",ue="[object Error]",ie="[object Function]",qu="[object GeneratorFunction]",Hn="[object Map]",oe="[object Number]",xa="[object Null]",at="[object Object]",Vu="[object Promise]",Da="[object Proxy]",fe="[object RegExp]",Jn="[object Set]",ce="[object String]",Oe="[object Symbol]",Ea="[object Undefined]",le="[object WeakMap]",Ca="[object WeakSet]",se="[object ArrayBuffer]",qt="[object DataView]",wr="[object Float32Array]",xr="[object Float64Array]",jr="[object Int8Array]",Ar="[object Int16Array]",Dr="[object Int32Array]",Er="[object Uint8Array]",Cr="[object Uint8ClampedArray]",Or="[object Uint16Array]",kr="[object Uint32Array]",Oa=/\b__p \+= '';/g,ka=/\b(__p \+=) '' \+/g,Sa=/(__e\(.*?\)|\b__t\)) \+\n'';/g,Yu=/&(?:amp|lt|gt|quot|#39);/g,Zu=/[&<>"']/g,Ia=RegExp(Yu.source),$a=RegExp(Zu.source),Ba=/<%-([\s\S]+?)%>/g,Fa=/<%([\s\S]+?)%>/g,Hu=/<%=([\s\S]+?)%>/g,Ra=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,za=/^\w*$/,Wa=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Sr=/[\\^$.*+?()[\]{}|]/g,Ua=RegExp(Sr.source),Ir=/^\s+/,Ma=/\s/,La=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Na=/\{\n\/\* \[wrapped with (.+)\] \*/,Pa=/,? & /,Ta=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,qa=/[()=,{}\[\]\/\s]/,Va=/\\(\\)?/g,Ya=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Ku=/\w*$/,Za=/^[-+]0x[0-9a-f]+$/i,Ha=/^0b[01]+$/i,Ka=/^\[object .+?Constructor\]$/,Ga=/^0o[0-7]+$/i,Ja=/^(?:0|[1-9]\d*)$/,Qa=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,ke=/($^)/,Xa=/['\n\r\u2028\u2029\\]/g,Se="\\ud800-\\udfff",nf="\\u0300-\\u036f",tf="\\ufe20-\\ufe2f",ef="\\u20d0-\\u20ff",Gu=nf+tf+ef,Ju="\\u2700-\\u27bf",Qu="a-z\\xdf-\\xf6\\xf8-\\xff",rf="\\xac\\xb1\\xd7\\xf7",uf="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",of="\\u2000-\\u206f",af=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Xu="A-Z\\xc0-\\xd6\\xd8-\\xde",ni="\\ufe0e\\ufe0f",ti=rf+uf+of+af,$r="['\u2019]",ff="["+Se+"]",ei="["+ti+"]",Ie="["+Gu+"]",ri="\\d+",cf="["+Ju+"]",ui="["+Qu+"]",ii="[^"+Se+ti+ri+Ju+Qu+Xu+"]",Br="\\ud83c[\\udffb-\\udfff]",lf="(?:"+Ie+"|"+Br+")",oi="[^"+Se+"]",Fr="(?:\\ud83c[\\udde6-\\uddff]){2}",Rr="[\\ud800-\\udbff][\\udc00-\\udfff]",Vt="["+Xu+"]",ai="\\u200d",fi="(?:"+ui+"|"+ii+")",sf="(?:"+Vt+"|"+ii+")",ci="(?:"+$r+"(?:d|ll|m|re|s|t|ve))?",li="(?:"+$r+"(?:D|LL|M|RE|S|T|VE))?",si=lf+"?",pi="["+ni+"]?",pf="(?:"+ai+"(?:"+[oi,Fr,Rr].join("|")+")"+pi+si+")*",hf="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",vf="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",hi=pi+si+pf,_f="(?:"+[cf,Fr,Rr].join("|")+")"+hi,gf="(?:"+[oi+Ie+"?",Ie,Fr,Rr,ff].join("|")+")",yf=RegExp($r,"g"),df=RegExp(Ie,"g"),zr=RegExp(Br+"(?="+Br+")|"+gf+hi,"g"),mf=RegExp([Vt+"?"+ui+"+"+ci+"(?="+[ei,Vt,"$"].join("|")+")",sf+"+"+li+"(?="+[ei,Vt+fi,"$"].join("|")+")",Vt+"?"+fi+"+"+ci,Vt+"+"+li,vf,hf,ri,_f].join("|"),"g"),bf=RegExp("["+ai+Se+Gu+ni+"]"),wf=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,xf=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],jf=-1,T={};T[wr]=T[xr]=T[jr]=T[Ar]=T[Dr]=T[Er]=T[Cr]=T[Or]=T[kr]=!0,T[mt]=T[ae]=T[se]=T[$t]=T[qt]=T[yt]=T[ue]=T[ie]=T[Hn]=T[oe]=T[at]=T[fe]=T[Jn]=T[ce]=T[le]=!1;var P={};P[mt]=P[ae]=P[se]=P[qt]=P[$t]=P[yt]=P[wr]=P[xr]=P[jr]=P[Ar]=P[Dr]=P[Hn]=P[oe]=P[at]=P[fe]=P[Jn]=P[ce]=P[Oe]=P[Er]=P[Cr]=P[Or]=P[kr]=!0,P[ue]=P[ie]=P[le]=!1;var Af={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},Df={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Ef={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Cf={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Of=parseFloat,kf=parseInt,vi=typeof global=="object"&&global&&global.Object===Object&&global,Sf=typeof self=="object"&&self&&self.Object===Object&&self,nn=vi||Sf||Function("return this")(),Wr=typeof y=="object"&&y&&!y.nodeType&&y,Bt=Wr&&typeof d=="object"&&d&&!d.nodeType&&d,_i=Bt&&Bt.exports===Wr,Ur=_i&&vi.process,Mn=function(){try{var l=Bt&&Bt.require&&Bt.require("util").types;return l||Ur&&Ur.binding&&Ur.binding("util")}catch(h){}}(),gi=Mn&&Mn.isArrayBuffer,yi=Mn&&Mn.isDate,di=Mn&&Mn.isMap,mi=Mn&&Mn.isRegExp,bi=Mn&&Mn.isSet,wi=Mn&&Mn.isTypedArray;function On(l,h,p){switch(p.length){case 0:return l.call(h);case 1:return l.call(h,p[0]);case 2:return l.call(h,p[0],p[1]);case 3:return l.call(h,p[0],p[1],p[2])}return l.apply(h,p)}function If(l,h,p,b){for(var D=-1,W=l==null?0:l.length;++D<W;){var J=l[D];h(b,J,p(J),l)}return b}function Ln(l,h){for(var p=-1,b=l==null?0:l.length;++p<b&&h(l[p],p,l)!==!1;);return l}function $f(l,h){for(var p=l==null?0:l.length;p--&&h(l[p],p,l)!==!1;);return l}function xi(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(!h(l[p],p,l))return!1;return!0}function bt(l,h){for(var p=-1,b=l==null?0:l.length,D=0,W=[];++p<b;){var J=l[p];h(J,p,l)&&(W[D++]=J)}return W}function $e(l,h){var p=l==null?0:l.length;return!!p&&Yt(l,h,0)>-1}function Mr(l,h,p){for(var b=-1,D=l==null?0:l.length;++b<D;)if(p(h,l[b]))return!0;return!1}function q(l,h){for(var p=-1,b=l==null?0:l.length,D=Array(b);++p<b;)D[p]=h(l[p],p,l);return D}function wt(l,h){for(var p=-1,b=h.length,D=l.length;++p<b;)l[D+p]=h[p];return l}function Lr(l,h,p,b){var D=-1,W=l==null?0:l.length;for(b&&W&&(p=l[++D]);++D<W;)p=h(p,l[D],D,l);return p}function Bf(l,h,p,b){var D=l==null?0:l.length;for(b&&D&&(p=l[--D]);D--;)p=h(p,l[D],D,l);return p}function Nr(l,h){for(var p=-1,b=l==null?0:l.length;++p<b;)if(h(l[p],p,l))return!0;return!1}var Ff=Pr("length");function Rf(l){return l.split("")}function zf(l){return l.match(Ta)||[]}function ji(l,h,p){var b;return p(l,function(D,W,J){if(h(D,W,J))return b=W,!1}),b}function Be(l,h,p,b){for(var D=l.length,W=p+(b?1:-1);b?W--:++W<D;)if(h(l[W],W,l))return W;return-1}function Yt(l,h,p){return h===h?Hf(l,h,p):Be(l,Ai,p)}function Wf(l,h,p,b){for(var D=p-1,W=l.length;++D<W;)if(b(l[D],h))return D;return-1}function Ai(l){return l!==l}function Di(l,h){var p=l==null?0:l.length;return p?qr(l,h)/p:Kn}function Pr(l){return function(h){return h==null?a:h[l]}}function Tr(l){return function(h){return l==null?a:l[h]}}function Ei(l,h,p,b,D){return D(l,function(W,J,N){p=b?(b=!1,W):h(p,W,J,N)}),p}function Uf(l,h){var p=l.length;for(l.sort(h);p--;)l[p]=l[p].value;return l}function qr(l,h){for(var p,b=-1,D=l.length;++b<D;){var W=h(l[b]);W!==a&&(p=p===a?W:p+W)}return p}function Vr(l,h){for(var p=-1,b=Array(l);++p<l;)b[p]=h(p);return b}function Mf(l,h){return q(h,function(p){return[p,l[p]]})}function Ci(l){return l&&l.slice(0,Ii(l)+1).replace(Ir,"")}function kn(l){return function(h){return l(h)}}function Yr(l,h){return q(h,function(p){return l[p]})}function pe(l,h){return l.has(h)}function Oi(l,h){for(var p=-1,b=l.length;++p<b&&Yt(h,l[p],0)>-1;);return p}function ki(l,h){for(var p=l.length;p--&&Yt(h,l[p],0)>-1;);return p}function Lf(l,h){for(var p=l.length,b=0;p--;)l[p]===h&&++b;return b}var Nf=Tr(Af),Pf=Tr(Df);function Tf(l){return"\\"+Cf[l]}function qf(l,h){return l==null?a:l[h]}function Zt(l){return bf.test(l)}function Vf(l){return wf.test(l)}function Yf(l){for(var h,p=[];!(h=l.next()).done;)p.push(h.value);return p}function Zr(l){var h=-1,p=Array(l.size);return l.forEach(function(b,D){p[++h]=[D,b]}),p}function Si(l,h){return function(p){return l(h(p))}}function xt(l,h){for(var p=-1,b=l.length,D=0,W=[];++p<b;){var J=l[p];(J===h||J===Dn)&&(l[p]=Dn,W[D++]=p)}return W}function Fe(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=b}),p}function Zf(l){var h=-1,p=Array(l.size);return l.forEach(function(b){p[++h]=[b,b]}),p}function Hf(l,h,p){for(var b=p-1,D=l.length;++b<D;)if(l[b]===h)return b;return-1}function Kf(l,h,p){for(var b=p+1;b--;)if(l[b]===h)return b;return b}function Ht(l){return Zt(l)?Jf(l):Ff(l)}function Qn(l){return Zt(l)?Qf(l):Rf(l)}function Ii(l){for(var h=l.length;h--&&Ma.test(l.charAt(h)););return h}var Gf=Tr(Ef);function Jf(l){for(var h=zr.lastIndex=0;zr.test(l);)++h;return h}function Qf(l){return l.match(zr)||[]}function Xf(l){return l.match(mf)||[]}var nc=function l(h){h=h==null?nn:jt.defaults(nn.Object(),h,jt.pick(nn,xf));var p=h.Array,b=h.Date,D=h.Error,W=h.Function,J=h.Math,N=h.Object,Hr=h.RegExp,tc=h.String,Nn=h.TypeError,Re=p.prototype,ec=W.prototype,Kt=N.prototype,ze=h["__core-js_shared__"],We=ec.toString,M=Kt.hasOwnProperty,rc=0,$i=function(){var n=/[^.]+$/.exec(ze&&ze.keys&&ze.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Ue=Kt.toString,uc=We.call(N),ic=nn._,oc=Hr("^"+We.call(M).replace(Sr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Me=_i?h.Buffer:a,At=h.Symbol,Le=h.Uint8Array,Bi=Me?Me.allocUnsafe:a,Ne=Si(N.getPrototypeOf,N),Fi=N.create,Ri=Kt.propertyIsEnumerable,Pe=Re.splice,zi=At?At.isConcatSpreadable:a,he=At?At.iterator:a,Ft=At?At.toStringTag:a,Te=function(){try{var n=Mt(N,"defineProperty");return n({},"",{}),n}catch(t){}}(),ac=h.clearTimeout!==nn.clearTimeout&&h.clearTimeout,fc=b&&b.now!==nn.Date.now&&b.now,cc=h.setTimeout!==nn.setTimeout&&h.setTimeout,qe=J.ceil,Ve=J.floor,Kr=N.getOwnPropertySymbols,lc=Me?Me.isBuffer:a,Wi=h.isFinite,sc=Re.join,pc=Si(N.keys,N),Q=J.max,pn=J.min,hc=b.now,vc=h.parseInt,Ui=J.random,_c=Re.reverse,Gr=Mt(h,"DataView"),ve=Mt(h,"Map"),Jr=Mt(h,"Promise"),Gt=Mt(h,"Set"),_e=Mt(h,"WeakMap"),ge=Mt(N,"create"),Ye=_e&&new _e,Jt={},gc=Lt(Gr),yc=Lt(ve),dc=Lt(Jr),mc=Lt(Gt),bc=Lt(_e),Ze=At?At.prototype:a,ye=Ze?Ze.valueOf:a,Mi=Ze?Ze.toString:a;function i(n){if(H(n)&&!E(n)&&!(n instanceof B)){if(n instanceof Pn)return n;if(M.call(n,"__wrapped__"))return No(n)}return new Pn(n)}var Qt=function(){function n(){}return function(t){if(!V(t))return{};if(Fi)return Fi(t);n.prototype=t;var e=new n;return n.prototype=a,e}}();function He(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=a}i.templateSettings={escape:Ba,evaluate:Fa,interpolate:Hu,variable:"",imports:{_:i}},i.prototype=He.prototype,i.prototype.constructor=i,Pn.prototype=Qt(He.prototype),Pn.prototype.constructor=Pn;function B(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=vn,this.__views__=[]}function wc(){var n=new B(this.__wrapped__);return n.__actions__=wn(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=wn(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=wn(this.__views__),n}function xc(){if(this.__filtered__){var n=new B(this);n.__dir__=-1,n.__filtered__=!0}else n=this.clone(),n.__dir__*=-1;return n}function jc(){var n=this.__wrapped__.value(),t=this.__dir__,e=E(n),r=t<0,u=e?n.length:0,o=Rl(0,u,this.__views__),f=o.start,c=o.end,s=c-f,v=r?c:f-1,_=this.__iteratees__,g=_.length,m=0,w=pn(s,this.__takeCount__);if(!e||!r&&u==s&&w==s)return co(n,this.__actions__);var j=[];n:for(;s--&&m<w;){v+=t;for(var S=-1,A=n[v];++S<g;){var $=_[S],F=$.iteratee,$n=$.type,yn=F(A);if($n==ln)A=yn;else if(!yn){if($n==cn)continue n;break n}}j[m++]=A}return j}B.prototype=Qt(He.prototype),B.prototype.constructor=B;function Rt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Ac(){this.__data__=ge?ge(null):{},this.size=0}function Dc(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Ec(n){var t=this.__data__;if(ge){var e=t[n];return e===dn?a:e}return M.call(t,n)?t[n]:a}function Cc(n){var t=this.__data__;return ge?t[n]!==a:M.call(t,n)}function Oc(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=ge&&t===a?dn:t,this}Rt.prototype.clear=Ac,Rt.prototype.delete=Dc,Rt.prototype.get=Ec,Rt.prototype.has=Cc,Rt.prototype.set=Oc;function ft(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function kc(){this.__data__=[],this.size=0}function Sc(n){var t=this.__data__,e=Ke(t,n);if(e<0)return!1;var r=t.length-1;return e==r?t.pop():Pe.call(t,e,1),--this.size,!0}function Ic(n){var t=this.__data__,e=Ke(t,n);return e<0?a:t[e][1]}function $c(n){return Ke(this.__data__,n)>-1}function Bc(n,t){var e=this.__data__,r=Ke(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}ft.prototype.clear=kc,ft.prototype.delete=Sc,ft.prototype.get=Ic,ft.prototype.has=$c,ft.prototype.set=Bc;function ct(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1])}}function Fc(){this.size=0,this.__data__={hash:new Rt,map:new(ve||ft),string:new Rt}}function Rc(n){var t=ar(this,n).delete(n);return this.size-=t?1:0,t}function zc(n){return ar(this,n).get(n)}function Wc(n){return ar(this,n).has(n)}function Uc(n,t){var e=ar(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}ct.prototype.clear=Fc,ct.prototype.delete=Rc,ct.prototype.get=zc,ct.prototype.has=Wc,ct.prototype.set=Uc;function zt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new ct;++t<e;)this.add(n[t])}function Mc(n){return this.__data__.set(n,dn),this}function Lc(n){return this.__data__.has(n)}zt.prototype.add=zt.prototype.push=Mc,zt.prototype.has=Lc;function Xn(n){var t=this.__data__=new ft(n);this.size=t.size}function Nc(){this.__data__=new ft,this.size=0}function Pc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function Tc(n){return this.__data__.get(n)}function qc(n){return this.__data__.has(n)}function Vc(n,t){var e=this.__data__;if(e instanceof ft){var r=e.__data__;if(!ve||r.length<R-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new ct(r)}return e.set(n,t),this.size=e.size,this}Xn.prototype.clear=Nc,Xn.prototype.delete=Pc,Xn.prototype.get=Tc,Xn.prototype.has=qc,Xn.prototype.set=Vc;function Li(n,t){var e=E(n),r=!e&&Nt(n),u=!e&&!r&&kt(n),o=!e&&!r&&!u&&ee(n),f=e||r||u||o,c=f?Vr(n.length,tc):[],s=c.length;for(var v in n)(t||M.call(n,v))&&!(f&&(v=="length"||u&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||ht(v,s)))&&c.push(v);return c}function Ni(n){var t=n.length;return t?n[fu(0,t-1)]:a}function Yc(n,t){return fr(wn(n),Wt(t,0,n.length))}function Zc(n){return fr(wn(n))}function Qr(n,t,e){(e!==a&&!nt(n[t],e)||e===a&&!(t in n))&&lt(n,t,e)}function de(n,t,e){var r=n[t];(!(M.call(n,t)&&nt(r,e))||e===a&&!(t in n))&&lt(n,t,e)}function Ke(n,t){for(var e=n.length;e--;)if(nt(n[e][0],t))return e;return-1}function Hc(n,t,e,r){return Dt(n,function(u,o,f){t(r,u,e(u),f)}),r}function Pi(n,t){return n&&rt(t,tn(t),n)}function Kc(n,t){return n&&rt(t,jn(t),n)}function lt(n,t,e){t=="__proto__"&&Te?Te(n,t,{configurable:!0,enumerable:!0,value:e,writable:!0}):n[t]=e}function Xr(n,t){for(var e=-1,r=t.length,u=p(r),o=n==null;++e<r;)u[e]=o?a:Bu(n,t[e]);return u}function Wt(n,t,e){return n===n&&(e!==a&&(n=n<=e?n:e),t!==a&&(n=n>=t?n:t)),n}function Tn(n,t,e,r,u,o){var f,c=t&sn,s=t&dt,v=t&Un;if(e&&(f=u?e(n,r,u,o):e(n)),f!==a)return f;if(!V(n))return n;var _=E(n);if(_){if(f=Wl(n),!c)return wn(n,f)}else{var g=hn(n),m=g==ie||g==qu;if(kt(n))return po(n,c);if(g==at||g==mt||m&&!u){if(f=s||m?{}:$o(n),!c)return s?El(n,Kc(f,n)):Dl(n,Pi(f,n))}else{if(!P[g])return u?n:{};f=Ul(n,g,c)}}o||(o=new Xn);var w=o.get(n);if(w)return w;o.set(n,f),aa(n)?n.forEach(function(A){f.add(Tn(A,t,e,A,n,o))}):ia(n)&&n.forEach(function(A,$){f.set($,Tn(A,t,e,$,n,o))});var j=v?s?mu:du:s?jn:tn,S=_?a:j(n);return Ln(S||n,function(A,$){S&&($=A,A=n[$]),de(f,$,Tn(A,t,e,$,n,o))}),f}function Gc(n){var t=tn(n);return function(e){return Ti(e,n,t)}}function Ti(n,t,e){var r=e.length;if(n==null)return!r;for(n=N(n);r--;){var u=e[r],o=t[u],f=n[u];if(f===a&&!(u in n)||!o(f))return!1}return!0}function qi(n,t,e){if(typeof n!="function")throw new Nn(z);return De(function(){n.apply(a,e)},t)}function me(n,t,e,r){var u=-1,o=$e,f=!0,c=n.length,s=[],v=t.length;if(!c)return s;e&&(t=q(t,kn(e))),r?(o=Mr,f=!1):t.length>=R&&(o=pe,f=!1,t=new zt(t));n:for(;++u<c;){var _=n[u],g=e==null?_:e(_);if(_=r||_!==0?_:0,f&&g===g){for(var m=v;m--;)if(t[m]===g)continue n;s.push(_)}else o(t,g,r)||s.push(_)}return s}var Dt=yo(et),Vi=yo(tu,!0);function Jc(n,t){var e=!0;return Dt(n,function(r,u,o){return e=!!t(r,u,o),e}),e}function Ge(n,t,e){for(var r=-1,u=n.length;++r<u;){var o=n[r],f=t(o);if(f!=null&&(c===a?f===f&&!In(f):e(f,c)))var c=f,s=o}return s}function Qc(n,t,e,r){var u=n.length;for(e=k(e),e<0&&(e=-e>u?0:u+e),r=r===a||r>u?u:k(r),r<0&&(r+=u),r=e>r?0:ca(r);e<r;)n[e++]=t;return n}function Yi(n,t){var e=[];return Dt(n,function(r,u,o){t(r,u,o)&&e.push(r)}),e}function an(n,t,e,r,u){var o=-1,f=n.length;for(e||(e=Ll),u||(u=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?an(c,t-1,e,r,u):wt(u,c):r||(u[u.length]=c)}return u}var nu=mo(),Zi=mo(!0);function et(n,t){return n&&nu(n,t,tn)}function tu(n,t){return n&&Zi(n,t,tn)}function Je(n,t){return bt(t,function(e){return vt(n[e])})}function Ut(n,t){t=Ct(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[ut(t[e++])];return e&&e==r?n:a}function Hi(n,t,e){var r=t(n);return E(n)?r:wt(r,e(n))}function _n(n){return n==null?n===a?Ea:xa:Ft&&Ft in N(n)?Fl(n):Zl(n)}function eu(n,t){return n>t}function Xc(n,t){return n!=null&&M.call(n,t)}function nl(n,t){return n!=null&&t in N(n)}function tl(n,t,e){return n>=pn(t,e)&&n<Q(t,e)}function ru(n,t,e){for(var r=e?Mr:$e,u=n[0].length,o=n.length,f=o,c=p(o),s=Infinity,v=[];f--;){var _=n[f];f&&t&&(_=q(_,kn(t))),s=pn(_.length,s),c[f]=!e&&(t||u>=120&&_.length>=120)?new zt(f&&_):a}_=n[0];var g=-1,m=c[0];n:for(;++g<u&&v.length<s;){var w=_[g],j=t?t(w):w;if(w=e||w!==0?w:0,!(m?pe(m,j):r(v,j,e))){for(f=o;--f;){var S=c[f];if(!(S?pe(S,j):r(n[f],j,e)))continue n}m&&m.push(j),v.push(w)}}return v}function el(n,t,e,r){return et(n,function(u,o,f){t(r,e(u),o,f)}),r}function be(n,t,e){t=Ct(t,n),n=zo(n,t);var r=n==null?n:n[ut(Vn(t))];return r==null?a:On(r,n,e)}function Ki(n){return H(n)&&_n(n)==mt}function rl(n){return H(n)&&_n(n)==se}function ul(n){return H(n)&&_n(n)==yt}function we(n,t,e,r,u){return n===t?!0:n==null||t==null||!H(n)&&!H(t)?n!==n&&t!==t:il(n,t,e,r,we,u)}function il(n,t,e,r,u,o){var f=E(n),c=E(t),s=f?ae:hn(n),v=c?ae:hn(t);s=s==mt?at:s,v=v==mt?at:v;var _=s==at,g=v==at,m=s==v;if(m&&kt(n)){if(!kt(t))return!1;f=!0,_=!1}if(m&&!_)return o||(o=new Xn),f||ee(n)?ko(n,t,e,r,u,o):$l(n,t,s,e,r,u,o);if(!(e&Rn)){var w=_&&M.call(n,"__wrapped__"),j=g&&M.call(t,"__wrapped__");if(w||j){var S=w?n.value():n,A=j?t.value():t;return o||(o=new Xn),u(S,A,e,r,o)}}return m?(o||(o=new Xn),Bl(n,t,e,r,u,o)):!1}function ol(n){return H(n)&&hn(n)==Hn}function uu(n,t,e,r){var u=e.length,o=u,f=!r;if(n==null)return!o;for(n=N(n);u--;){var c=e[u];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return!1}for(;++u<o;){c=e[u];var s=c[0],v=n[s],_=c[1];if(f&&c[2]){if(v===a&&!(s in n))return!1}else{var g=new Xn;if(r)var m=r(v,_,s,n,t,g);if(!(m===a?we(_,v,Rn|bn,r,g):m))return!1}}return!0}function Gi(n){if(!V(n)||Pl(n))return!1;var t=vt(n)?oc:Ka;return t.test(Lt(n))}function al(n){return H(n)&&_n(n)==fe}function fl(n){return H(n)&&hn(n)==Jn}function cl(n){return H(n)&&vr(n.length)&&!!T[_n(n)]}function Ji(n){return typeof n=="function"?n:n==null?An:typeof n=="object"?E(n)?no(n[0],n[1]):Xi(n):ba(n)}function iu(n){if(!Ae(n))return pc(n);var t=[];for(var e in N(n))M.call(n,e)&&e!="constructor"&&t.push(e);return t}function ll(n){if(!V(n))return Yl(n);var t=Ae(n),e=[];for(var r in n)r=="constructor"&&(t||!M.call(n,r))||e.push(r);return e}function ou(n,t){return n<t}function Qi(n,t){var e=-1,r=xn(n)?p(n.length):[];return Dt(n,function(u,o,f){r[++e]=t(u,o,f)}),r}function Xi(n){var t=wu(n);return t.length==1&&t[0][2]?Fo(t[0][0],t[0][1]):function(e){return e===n||uu(e,n,t)}}function no(n,t){return ju(n)&&Bo(t)?Fo(ut(n),t):function(e){var r=Bu(e,n);return r===a&&r===t?Fu(e,n):we(t,r,Rn|bn)}}function Qe(n,t,e,r,u){n!==t&&nu(t,function(o,f){if(u||(u=new Xn),V(o))sl(n,t,f,e,Qe,r,u);else{var c=r?r(Du(n,f),o,f+"",n,t,u):a;c===a&&(c=o),Qr(n,f,c)}},jn)}function sl(n,t,e,r,u,o,f){var c=Du(n,e),s=Du(t,e),v=f.get(s);if(v){Qr(n,e,v);return}var _=o?o(c,s,e+"",n,t,f):a,g=_===a;if(g){var m=E(s),w=!m&&kt(s),j=!m&&!w&&ee(s);_=s,m||w||j?E(c)?_=c:K(c)?_=wn(c):w?(g=!1,_=po(s,!0)):j?(g=!1,_=ho(s,!0)):_=[]:Ee(s)||Nt(s)?(_=c,Nt(c)?_=la(c):(!V(c)||vt(c))&&(_=$o(s))):g=!1}g&&(f.set(s,_),u(_,s,r,o,f),f.delete(s)),Qr(n,e,_)}function to(n,t){var e=n.length;if(e)return t+=t<0?e:0,ht(t,e)?n[t]:a}function eo(n,t,e){t.length?t=q(t,function(o){return E(o)?function(f){return Ut(f,o.length===1?o[0]:o)}:o}):t=[An];var r=-1;t=q(t,kn(x()));var u=Qi(n,function(o,f,c){var s=q(t,function(v){return v(o)});return{criteria:s,index:++r,value:o}});return Uf(u,function(o,f){return Al(o,f,e)})}function pl(n,t){return ro(n,t,function(e,r){return Fu(n,r)})}function ro(n,t,e){for(var r=-1,u=t.length,o={};++r<u;){var f=t[r],c=Ut(n,f);e(c,f)&&xe(o,Ct(f,n),c)}return o}function hl(n){return function(t){return Ut(t,n)}}function au(n,t,e,r){var u=r?Wf:Yt,o=-1,f=t.length,c=n;for(n===t&&(t=wn(t)),e&&(c=q(n,kn(e)));++o<f;)for(var s=0,v=t[o],_=e?e(v):v;(s=u(c,_,s,r))>-1;)c!==n&&Pe.call(c,s,1),Pe.call(n,s,1);return n}function uo(n,t){for(var e=n?t.length:0,r=e-1;e--;){var u=t[e];if(e==r||u!==o){var o=u;ht(u)?Pe.call(n,u,1):su(n,u)}}return n}function fu(n,t){return n+Ve(Ui()*(t-n+1))}function vl(n,t,e,r){for(var u=-1,o=Q(qe((t-n)/(e||1)),0),f=p(o);o--;)f[r?o:++u]=n,n+=e;return f}function cu(n,t){var e="";if(!n||t<1||t>en)return e;do t%2&&(e+=n),t=Ve(t/2),t&&(n+=n);while(t);return e}function I(n,t){return Eu(Ro(n,t,An),n+"")}function _l(n){return Ni(re(n))}function gl(n,t){var e=re(n);return fr(e,Wt(t,0,e.length))}function xe(n,t,e,r){if(!V(n))return n;t=Ct(t,n);for(var u=-1,o=t.length,f=o-1,c=n;c!=null&&++u<o;){var s=ut(t[u]),v=e;if(s==="__proto__"||s==="constructor"||s==="prototype")return n;if(u!=f){var _=c[s];v=r?r(_,s,c):a,v===a&&(v=V(_)?_:ht(t[u+1])?[]:{})}de(c,s,v),c=c[s]}return n}var io=Ye?function(n,t){return Ye.set(n,t),n}:An,yl=Te?function(n,t){return Te(n,"toString",{configurable:!0,enumerable:!1,value:zu(t),writable:!0})}:An;function dl(n){return fr(re(n))}function qn(n,t,e){var r=-1,u=n.length;t<0&&(t=-t>u?0:u+t),e=e>u?u:e,e<0&&(e+=u),u=t>e?0:e-t>>>0,t>>>=0;for(var o=p(u);++r<u;)o[r]=n[r+t];return o}function ml(n,t){var e;return Dt(n,function(r,u,o){return e=t(r,u,o),!e}),!!e}function Xe(n,t,e){var r=0,u=n==null?r:n.length;if(typeof t=="number"&&t===t&&u<=Ce){for(;r<u;){var o=r+u>>>1,f=n[o];f!==null&&!In(f)&&(e?f<=t:f<t)?r=o+1:u=o}return u}return lu(n,t,An,e)}function lu(n,t,e,r){var u=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,s=In(t),v=t===a;u<o;){var _=Ve((u+o)/2),g=e(n[_]),m=g!==a,w=g===null,j=g===g,S=In(g);if(f)var A=r||j;else v?A=j&&(r||m):c?A=j&&m&&(r||!w):s?A=j&&m&&!w&&(r||!S):w||S?A=!1:A=r?g<=t:g<t;A?u=_+1:o=_}return pn(o,Tt)}function oo(n,t){for(var e=-1,r=n.length,u=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!nt(c,s)){var s=c;o[u++]=f===0?0:f}}return o}function ao(n){return typeof n=="number"?n:In(n)?Kn:+n}function Sn(n){if(typeof n=="string")return n;if(E(n))return q(n,Sn)+"";if(In(n))return Mi?Mi.call(n):"";var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Et(n,t,e){var r=-1,u=$e,o=n.length,f=!0,c=[],s=c;if(e)f=!1,u=Mr;else if(o>=R){var v=t?null:Sl(n);if(v)return Fe(v);f=!1,u=pe,s=new zt}else s=t?[]:c;n:for(;++r<o;){var _=n[r],g=t?t(_):_;if(_=e||_!==0?_:0,f&&g===g){for(var m=s.length;m--;)if(s[m]===g)continue n;t&&s.push(g),c.push(_)}else u(s,g,e)||(s!==c&&s.push(g),c.push(_))}return c}function su(n,t){return t=Ct(t,n),n=zo(n,t),n==null||delete n[ut(Vn(t))]}function fo(n,t,e,r){return xe(n,t,e(Ut(n,t)),r)}function nr(n,t,e,r){for(var u=n.length,o=r?u:-1;(r?o--:++o<u)&&t(n[o],o,n););return e?qn(n,r?0:o,r?o+1:u):qn(n,r?o+1:0,r?u:o)}function co(n,t){var e=n;return e instanceof B&&(e=e.value()),Lr(t,function(r,u){return u.func.apply(u.thisArg,wt([r],u.args))},e)}function pu(n,t,e){var r=n.length;if(r<2)return r?Et(n[0]):[];for(var u=-1,o=p(r);++u<r;)for(var f=n[u],c=-1;++c<r;)c!=u&&(o[u]=me(o[u]||f,n[c],t,e));return Et(an(o,1),t,e)}function lo(n,t,e){for(var r=-1,u=n.length,o=t.length,f={};++r<u;){var c=r<o?t[r]:a;e(f,n[r],c)}return f}function hu(n){return K(n)?n:[]}function vu(n){return typeof n=="function"?n:An}function Ct(n,t){return E(n)?n:ju(n,t)?[n]:Lo(U(n))}var bl=I;function Ot(n,t,e){var r=n.length;return e=e===a?r:e,!t&&e>=r?n:qn(n,t,e)}var so=ac||function(n){return nn.clearTimeout(n)};function po(n,t){if(t)return n.slice();var e=n.length,r=Bi?Bi(e):new n.constructor(e);return n.copy(r),r}function _u(n){var t=new n.constructor(n.byteLength);return new Le(t).set(new Le(n)),t}function wl(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function xl(n){var t=new n.constructor(n.source,Ku.exec(n));return t.lastIndex=n.lastIndex,t}function jl(n){return ye?N(ye.call(n)):{}}function ho(n,t){var e=t?_u(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function vo(n,t){if(n!==t){var e=n!==a,r=n===null,u=n===n,o=In(n),f=t!==a,c=t===null,s=t===t,v=In(t);if(!c&&!v&&!o&&n>t||o&&f&&s&&!c&&!v||r&&f&&s||!e&&s||!u)return 1;if(!r&&!o&&!v&&n<t||v&&e&&u&&!r&&!o||c&&e&&u||!f&&u||!s)return-1}return 0}function Al(n,t,e){for(var r=-1,u=n.criteria,o=t.criteria,f=u.length,c=e.length;++r<f;){var s=vo(u[r],o[r]);if(s){if(r>=c)return s;var v=e[r];return s*(v=="desc"?-1:1)}}return n.index-t.index}function _o(n,t,e,r){for(var u=-1,o=n.length,f=e.length,c=-1,s=t.length,v=Q(o-f,0),_=p(s+v),g=!r;++c<s;)_[c]=t[c];for(;++u<f;)(g||u<o)&&(_[e[u]]=n[u]);for(;v--;)_[c++]=n[u++];return _}function go(n,t,e,r){for(var u=-1,o=n.length,f=-1,c=e.length,s=-1,v=t.length,_=Q(o-c,0),g=p(_+v),m=!r;++u<_;)g[u]=n[u];for(var w=u;++s<v;)g[w+s]=t[s];for(;++f<c;)(m||u<o)&&(g[w+e[f]]=n[u++]);return g}function wn(n,t){var e=-1,r=n.length;for(t||(t=p(r));++e<r;)t[e]=n[e];return t}function rt(n,t,e,r){var u=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],s=r?r(e[c],n[c],c,e,n):a;s===a&&(s=n[c]),u?lt(e,c,s):de(e,c,s)}return e}function Dl(n,t){return rt(n,xu(n),t)}function El(n,t){return rt(n,So(n),t)}function tr(n,t){return function(e,r){var u=E(e)?If:Hc,o=t?t():{};return u(e,n,x(r,2),o)}}function Xt(n){return I(function(t,e){var r=-1,u=e.length,o=u>1?e[u-1]:a,f=u>2?e[2]:a;for(o=n.length>3&&typeof o=="function"?(u--,o):a,f&&gn(e[0],e[1],f)&&(o=u<3?a:o,u=1),t=N(t);++r<u;){var c=e[r];c&&n(t,c,r,o)}return t})}function yo(n,t){return function(e,r){if(e==null)return e;if(!xn(e))return n(e,r);for(var u=e.length,o=t?u:-1,f=N(e);(t?o--:++o<u)&&r(f[o],o,f)!==!1;);return e}}function mo(n){return function(t,e,r){for(var u=-1,o=N(t),f=r(t),c=f.length;c--;){var s=f[n?c:++u];if(e(o[s],s,o)===!1)break}return t}}function Cl(n,t,e){var r=t&X,u=je(n);function o(){var f=this&&this!==nn&&this instanceof o?u:n;return f.apply(r?e:this,arguments)}return o}function bo(n){return function(t){t=U(t);var e=Zt(t)?Qn(t):a,r=e?e[0]:t.charAt(0),u=e?Ot(e,1).join(""):t.slice(1);return r[n]()+u}}function ne(n){return function(t){return Lr(da(ya(t).replace(yf,"")),n,"")}}function je(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=Qt(n.prototype),r=n.apply(e,t);return V(r)?r:e}}function Ol(n,t,e){var r=je(n);function u(){for(var o=arguments.length,f=p(o),c=o,s=te(u);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==s&&f[o-1]!==s?[]:xt(f,s);if(o-=v.length,o<e)return Do(n,t,er,u.placeholder,a,f,v,a,a,e-o);var _=this&&this!==nn&&this instanceof u?r:n;return On(_,this,f)}return u}function wo(n){return function(t,e,r){var u=N(t);if(!xn(t)){var o=x(e,3);t=tn(t),e=function(c){return o(u[c],c,u)}}var f=n(t,e,r);return f>-1?u[o?t[f]:f]:a}}function xo(n){return pt(function(t){var e=t.length,r=e,u=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new Nn(z);if(u&&!f&&or(o)=="wrapper")var f=new Pn([],!0)}for(r=f?r:e;++r<e;){o=t[r];var c=or(o),s=c=="wrapper"?bu(o):a;s&&Au(s[0])&&s[1]==(Y|mn|un|Cn)&&!s[4].length&&s[9]==1?f=f[or(s[0])].apply(f,s[3]):f=o.length==1&&Au(o)?f[c]():f.thru(o)}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&E(_))return f.plant(_).value();for(var g=0,m=e?t[g].apply(this,v):_;++g<e;)m=t[g].call(this,m);return m}})}function er(n,t,e,r,u,o,f,c,s,v){var _=t&Y,g=t&X,m=t&En,w=t&(mn|ot),j=t&Wn,S=m?a:je(n);function A(){for(var $=arguments.length,F=p($),$n=$;$n--;)F[$n]=arguments[$n];if(w)var yn=te(A),Bn=Lf(F,yn);if(r&&(F=_o(F,r,u,w)),o&&(F=go(F,o,f,w)),$-=Bn,w&&$<v){var G=xt(F,yn);return Do(n,t,er,A.placeholder,e,F,G,c,s,v-$)}var tt=g?e:this,gt=m?tt[n]:n;return $=F.length,c?F=Hl(F,c):j&&$>1&&F.reverse(),_&&s<$&&(F.length=s),this&&this!==nn&&this instanceof A&&(gt=S||je(gt)),gt.apply(tt,F)}return A}function jo(n,t){return function(e,r){return el(e,n,t(r),{})}}function rr(n,t){return function(e,r){var u;if(e===a&&r===a)return t;if(e!==a&&(u=e),r!==a){if(u===a)return r;typeof e=="string"||typeof r=="string"?(e=Sn(e),r=Sn(r)):(e=ao(e),r=ao(r)),u=n(e,r)}return u}}function gu(n){return pt(function(t){return t=q(t,kn(x())),I(function(e){var r=this;return n(t,function(u){return On(u,r,e)})})})}function ur(n,t){t=t===a?" ":Sn(t);var e=t.length;if(e<2)return e?cu(t,n):t;var r=cu(t,qe(n/Ht(t)));return Zt(t)?Ot(Qn(r),0,n).join(""):r.slice(0,n)}function kl(n,t,e,r){var u=t&X,o=je(n);function f(){for(var c=-1,s=arguments.length,v=-1,_=r.length,g=p(_+s),m=this&&this!==nn&&this instanceof f?o:n;++v<_;)g[v]=r[v];for(;s--;)g[v++]=arguments[++c];return On(m,u?e:this,g)}return f}function Ao(n){return function(t,e,r){return r&&typeof r!="number"&&gn(t,e,r)&&(e=r=a),t=_t(t),e===a?(e=t,t=0):e=_t(e),r=r===a?t<e?1:-1:_t(r),vl(t,e,r,n)}}function ir(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=Yn(t),e=Yn(e)),n(t,e)}}function Do(n,t,e,r,u,o,f,c,s,v){var _=t&mn,g=_?f:a,m=_?a:f,w=_?o:a,j=_?a:o;t|=_?un:on,t&=~(_?on:un),t&St||(t&=~(X|En));var S=[n,t,u,w,g,j,m,c,s,v],A=e.apply(a,S);return Au(n)&&Wo(A,S),A.placeholder=r,Uo(A,n,t)}function yu(n){var t=J[n];return function(e,r){if(e=Yn(e),r=r==null?0:pn(k(r),292),r&&Wi(e)){var u=(U(e)+"e").split("e"),o=t(u[0]+"e"+(+u[1]+r));return u=(U(o)+"e").split("e"),+(u[0]+"e"+(+u[1]-r))}return t(e)}}var Sl=Gt&&1/Fe(new Gt([,-0]))[1]==Z?function(n){return new Gt(n)}:Mu;function Eo(n){return function(t){var e=hn(t);return e==Hn?Zr(t):e==Jn?Zf(t):Mf(t,n(t))}}function st(n,t,e,r,u,o,f,c){var s=t&En;if(!s&&typeof n!="function")throw new Nn(z);var v=r?r.length:0;if(v||(t&=~(un|on),r=u=a),f=f===a?f:Q(k(f),0),c=c===a?c:k(c),v-=u?u.length:0,t&on){var _=r,g=u;r=u=a}var m=s?a:bu(n),w=[n,t,e,r,u,_,g,o,f,c];if(m&&Vl(w,m),n=w[0],t=w[1],e=w[2],r=w[3],u=w[4],c=w[9]=w[9]===a?s?0:n.length:Q(w[9]-v,0),!c&&t&(mn|ot)&&(t&=~(mn|ot)),!t||t==X)var j=Cl(n,t,e);else t==mn||t==ot?j=Ol(n,t,c):(t==un||t==(X|un))&&!u.length?j=kl(n,t,e,r):j=er.apply(a,w);var S=m?io:Wo;return Uo(S(j,w),n,t)}function Co(n,t,e,r){return n===a||nt(n,Kt[e])&&!M.call(r,e)?t:n}function Oo(n,t,e,r,u,o){return V(n)&&V(t)&&(o.set(t,n),Qe(n,t,a,Oo,o),o.delete(t)),n}function Il(n){return Ee(n)?a:n}function ko(n,t,e,r,u,o){var f=e&Rn,c=n.length,s=t.length;if(c!=s&&!(f&&s>c))return!1;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var g=-1,m=!0,w=e&bn?new zt:a;for(o.set(n,t),o.set(t,n);++g<c;){var j=n[g],S=t[g];if(r)var A=f?r(S,j,g,t,n,o):r(j,S,g,n,t,o);if(A!==a){if(A)continue;m=!1;break}if(w){if(!Nr(t,function($,F){if(!pe(w,F)&&(j===$||u(j,$,e,r,o)))return w.push(F)})){m=!1;break}}else if(!(j===S||u(j,S,e,r,o))){m=!1;break}}return o.delete(n),o.delete(t),m}function $l(n,t,e,r,u,o,f){switch(e){case qt:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return!1;n=n.buffer,t=t.buffer;case se:return!(n.byteLength!=t.byteLength||!o(new Le(n),new Le(t)));case $t:case yt:case oe:return nt(+n,+t);case ue:return n.name==t.name&&n.message==t.message;case fe:case ce:return n==t+"";case Hn:var c=Zr;case Jn:var s=r&Rn;if(c||(c=Fe),n.size!=t.size&&!s)return!1;var v=f.get(n);if(v)return v==t;r|=bn,f.set(n,t);var _=ko(c(n),c(t),r,u,o,f);return f.delete(n),_;case Oe:if(ye)return ye.call(n)==ye.call(t)}return!1}function Bl(n,t,e,r,u,o){var f=e&Rn,c=du(n),s=c.length,v=du(t),_=v.length;if(s!=_&&!f)return!1;for(var g=s;g--;){var m=c[g];if(!(f?m in t:M.call(t,m)))return!1}var w=o.get(n),j=o.get(t);if(w&&j)return w==t&&j==n;var S=!0;o.set(n,t),o.set(t,n);for(var A=f;++g<s;){m=c[g];var $=n[m],F=t[m];if(r)var $n=f?r(F,$,m,t,n,o):r($,F,m,n,t,o);if(!($n===a?$===F||u($,F,e,r,o):$n)){S=!1;break}A||(A=m=="constructor")}if(S&&!A){var yn=n.constructor,Bn=t.constructor;yn!=Bn&&"constructor"in n&&"constructor"in t&&!(typeof yn=="function"&&yn instanceof yn&&typeof Bn=="function"&&Bn instanceof Bn)&&(S=!1)}return o.delete(n),o.delete(t),S}function pt(n){return Eu(Ro(n,a,qo),n+"")}function du(n){return Hi(n,tn,xu)}function mu(n){return Hi(n,jn,So)}var bu=Ye?function(n){return Ye.get(n)}:Mu;function or(n){for(var t=n.name+"",e=Jt[t],r=M.call(Jt,t)?e.length:0;r--;){var u=e[r],o=u.func;if(o==null||o==n)return u.name}return t}function te(n){var t=M.call(i,"placeholder")?i:n;return t.placeholder}function x(){var n=i.iteratee||Wu;return n=n===Wu?Ji:n,arguments.length?n(arguments[0],arguments[1]):n}function ar(n,t){var e=n.__data__;return Nl(t)?e[typeof t=="string"?"string":"hash"]:e.map}function wu(n){for(var t=tn(n),e=t.length;e--;){var r=t[e],u=n[r];t[e]=[r,u,Bo(u)]}return t}function Mt(n,t){var e=qf(n,t);return Gi(e)?e:a}function Fl(n){var t=M.call(n,Ft),e=n[Ft];try{n[Ft]=a;var r=!0}catch(o){}var u=Ue.call(n);return r&&(t?n[Ft]=e:delete n[Ft]),u}var xu=Kr?function(n){return n==null?[]:(n=N(n),bt(Kr(n),function(t){return Ri.call(n,t)}))}:Lu,So=Kr?function(n){for(var t=[];n;)wt(t,xu(n)),n=Ne(n);return t}:Lu,hn=_n;(Gr&&hn(new Gr(new ArrayBuffer(1)))!=qt||ve&&hn(new ve)!=Hn||Jr&&hn(Jr.resolve())!=Vu||Gt&&hn(new Gt)!=Jn||_e&&hn(new _e)!=le)&&(hn=function(n){var t=_n(n),e=t==at?n.constructor:a,r=e?Lt(e):"";if(r)switch(r){case gc:return qt;case yc:return Hn;case dc:return Vu;case mc:return Jn;case bc:return le}return t});function Rl(n,t,e){for(var r=-1,u=e.length;++r<u;){var o=e[r],f=o.size;switch(o.type){case"drop":n+=f;break;case"dropRight":t-=f;break;case"take":t=pn(t,n+f);break;case"takeRight":n=Q(n,t-f);break}}return{start:n,end:t}}function zl(n){var t=n.match(Na);return t?t[1].split(Pa):[]}function Io(n,t,e){t=Ct(t,n);for(var r=-1,u=t.length,o=!1;++r<u;){var f=ut(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f]}return o||++r!=u?o:(u=n==null?0:n.length,!!u&&vr(u)&&ht(f,u)&&(E(n)||Nt(n)))}function Wl(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&M.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function $o(n){return typeof n.constructor=="function"&&!Ae(n)?Qt(Ne(n)):{}}function Ul(n,t,e){var r=n.constructor;switch(t){case se:return _u(n);case $t:case yt:return new r(+n);case qt:return wl(n,e);case wr:case xr:case jr:case Ar:case Dr:case Er:case Cr:case Or:case kr:return ho(n,e);case Hn:return new r;case oe:case ce:return new r(n);case fe:return xl(n);case Jn:return new r;case Oe:return jl(n)}}function Ml(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(La,`{
/* [wrapped with `+t+`] */
`)}function Ll(n){return E(n)||Nt(n)||!!(zi&&n&&n[zi])}function ht(n,t){var e=typeof n;return t=t==null?en:t,!!t&&(e=="number"||e!="symbol"&&Ja.test(n))&&n>-1&&n%1==0&&n<t}function gn(n,t,e){if(!V(e))return!1;var r=typeof t;return(r=="number"?xn(e)&&ht(t,e.length):r=="string"&&t in e)?nt(e[t],n):!1}function ju(n,t){if(E(n))return!1;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||In(n)?!0:za.test(n)||!Ra.test(n)||t!=null&&n in N(t)}function Nl(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function Au(n){var t=or(n),e=i[t];if(typeof e!="function"||!(t in B.prototype))return!1;if(n===e)return!0;var r=bu(e);return!!r&&n===r[0]}function Pl(n){return!!$i&&$i in n}var Tl=ze?vt:Nu;function Ae(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Kt;return n===e}function Bo(n){return n===n&&!V(n)}function Fo(n,t){return function(e){return e==null?!1:e[n]===t&&(t!==a||n in N(e))}}function ql(n){var t=pr(n,function(r){return e.size===rn&&e.clear(),r}),e=t.cache;return t}function Vl(n,t){var e=n[1],r=t[1],u=e|r,o=u<(X|En|Y),f=r==Y&&e==mn||r==Y&&e==Cn&&n[7].length<=t[8]||r==(Y|Cn)&&t[7].length<=t[8]&&e==mn;if(!(o||f))return n;r&X&&(n[2]=t[2],u|=e&X?0:St);var c=t[3];if(c){var s=n[3];n[3]=s?_o(s,c,t[4]):c,n[4]=s?xt(n[3],Dn):t[4]}return c=t[5],c&&(s=n[5],n[5]=s?go(s,c,t[6]):c,n[6]=s?xt(n[5],Dn):t[6]),c=t[7],c&&(n[7]=c),r&Y&&(n[8]=n[8]==null?t[8]:pn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=u,n}function Yl(n){var t=[];if(n!=null)for(var e in N(n))t.push(e);return t}function Zl(n){return Ue.call(n)}function Ro(n,t,e){return t=Q(t===a?n.length-1:t,0),function(){for(var r=arguments,u=-1,o=Q(r.length-t,0),f=p(o);++u<o;)f[u]=r[t+u];u=-1;for(var c=p(t+1);++u<t;)c[u]=r[u];return c[t]=e(f),On(n,this,c)}}function zo(n,t){return t.length<2?n:Ut(n,qn(t,0,-1))}function Hl(n,t){for(var e=n.length,r=pn(t.length,e),u=wn(n);r--;){var o=t[r];n[r]=ht(o,e)?u[o]:a}return n}function Du(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Wo=Mo(io),De=cc||function(n,t){return nn.setTimeout(n,t)},Eu=Mo(yl);function Uo(n,t,e){var r=t+"";return Eu(n,Ml(r,Kl(zl(r),e)))}function Mo(n){var t=0,e=0;return function(){var r=hc(),u=zn-(r-e);if(e=r,u>0){if(++t>=Pt)return arguments[0]}else t=0;return n.apply(a,arguments)}}function fr(n,t){var e=-1,r=n.length,u=r-1;for(t=t===a?r:t;++e<t;){var o=fu(e,u),f=n[o];n[o]=n[e],n[e]=f}return n.length=t,n}var Lo=ql(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(Wa,function(e,r,u,o){t.push(u?o.replace(Va,"$1"):r||e)}),t});function ut(n){if(typeof n=="string"||In(n))return n;var t=n+"";return t=="0"&&1/n==-Z?"-0":t}function Lt(n){if(n!=null){try{return We.call(n)}catch(t){}try{return n+""}catch(t){}}return""}function Kl(n,t){return Ln(mr,function(e){var r="_."+e[0];t&e[1]&&!$e(n,r)&&n.push(r)}),n.sort()}function No(n){if(n instanceof B)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=wn(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Gl(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=Q(k(t),0);var r=n==null?0:n.length;if(!r||t<1)return[];for(var u=0,o=0,f=p(qe(r/t));u<r;)f[o++]=qn(n,u,u+=t);return f}function Jl(n){for(var t=-1,e=n==null?0:n.length,r=0,u=[];++t<e;){var o=n[t];o&&(u[r++]=o)}return u}function Ql(){var n=arguments.length;if(!n)return[];for(var t=p(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return wt(E(e)?wn(e):[e],an(t,1))}var Xl=I(function(n,t){return K(n)?me(n,an(t,1,K,!0)):[]}),ns=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),x(e,2)):[]}),ts=I(function(n,t){var e=Vn(t);return K(e)&&(e=a),K(n)?me(n,an(t,1,K,!0),a,e):[]});function es(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),qn(n,t<0?0:t,r)):[]}function rs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,0,t<0?0:t)):[]}function us(n,t){return n&&n.length?nr(n,x(t,3),!0,!0):[]}function is(n,t){return n&&n.length?nr(n,x(t,3),!0):[]}function os(n,t,e,r){var u=n==null?0:n.length;return u?(e&&typeof e!="number"&&gn(n,t,e)&&(e=0,r=u),Qc(n,t,e,r)):[]}function Po(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Be(n,x(t,3),u)}function To(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r-1;return e!==a&&(u=k(e),u=e<0?Q(r+u,0):pn(u,r-1)),Be(n,x(t,3),u,!0)}function qo(n){var t=n==null?0:n.length;return t?an(n,1):[]}function as(n){var t=n==null?0:n.length;return t?an(n,Z):[]}function fs(n,t){var e=n==null?0:n.length;return e?(t=t===a?1:k(t),an(n,t)):[]}function cs(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var u=n[t];r[u[0]]=u[1]}return r}function Vo(n){return n&&n.length?n[0]:a}function ls(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=e==null?0:k(e);return u<0&&(u=Q(r+u,0)),Yt(n,t,u)}function ss(n){var t=n==null?0:n.length;return t?qn(n,0,-1):[]}var ps=I(function(n){var t=q(n,hu);return t.length&&t[0]===n[0]?ru(t):[]}),hs=I(function(n){var t=Vn(n),e=q(n,hu);return t===Vn(e)?t=a:e.pop(),e.length&&e[0]===n[0]?ru(e,x(t,2)):[]}),vs=I(function(n){var t=Vn(n),e=q(n,hu);return t=typeof t=="function"?t:a,t&&e.pop(),e.length&&e[0]===n[0]?ru(e,a,t):[]});function _s(n,t){return n==null?"":sc.call(n,t)}function Vn(n){var t=n==null?0:n.length;return t?n[t-1]:a}function gs(n,t,e){var r=n==null?0:n.length;if(!r)return-1;var u=r;return e!==a&&(u=k(e),u=u<0?Q(r+u,0):pn(u,r-1)),t===t?Kf(n,t,u):Be(n,Ai,u,!0)}function ys(n,t){return n&&n.length?to(n,k(t)):a}var ds=I(Yo);function Yo(n,t){return n&&n.length&&t&&t.length?au(n,t):n}function ms(n,t,e){return n&&n.length&&t&&t.length?au(n,t,x(e,2)):n}function bs(n,t,e){return n&&n.length&&t&&t.length?au(n,t,a,e):n}var ws=pt(function(n,t){var e=n==null?0:n.length,r=Xr(n,t);return uo(n,q(t,function(u){return ht(u,e)?+u:u}).sort(vo)),r});function xs(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,u=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),u.push(r))}return uo(n,u),e}function Cu(n){return n==null?n:_c.call(n)}function js(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&gn(n,t,e)?(t=0,e=r):(t=t==null?0:k(t),e=e===a?r:k(e)),qn(n,t,e)):[]}function As(n,t){return Xe(n,t)}function Ds(n,t,e){return lu(n,t,x(e,2))}function Es(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t);if(r<e&&nt(n[r],t))return r}return-1}function Cs(n,t){return Xe(n,t,!0)}function Os(n,t,e){return lu(n,t,x(e,2),!0)}function ks(n,t){var e=n==null?0:n.length;if(e){var r=Xe(n,t,!0)-1;if(nt(n[r],t))return r}return-1}function Ss(n){return n&&n.length?oo(n):[]}function Is(n,t){return n&&n.length?oo(n,x(t,2)):[]}function $s(n){var t=n==null?0:n.length;return t?qn(n,1,t):[]}function Bs(n,t,e){return n&&n.length?(t=e||t===a?1:k(t),qn(n,0,t<0?0:t)):[]}function Fs(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===a?1:k(t),t=r-t,qn(n,t<0?0:t,r)):[]}function Rs(n,t){return n&&n.length?nr(n,x(t,3),!1,!0):[]}function zs(n,t){return n&&n.length?nr(n,x(t,3)):[]}var Ws=I(function(n){return Et(an(n,1,K,!0))}),Us=I(function(n){var t=Vn(n);return K(t)&&(t=a),Et(an(n,1,K,!0),x(t,2))}),Ms=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,Et(an(n,1,K,!0),a,t)});function Ls(n){return n&&n.length?Et(n):[]}function Ns(n,t){return n&&n.length?Et(n,x(t,2)):[]}function Ps(n,t){return t=typeof t=="function"?t:a,n&&n.length?Et(n,a,t):[]}function Ou(n){if(!(n&&n.length))return[];var t=0;return n=bt(n,function(e){if(K(e))return t=Q(e.length,t),!0}),Vr(t,function(e){return q(n,Pr(e))})}function Zo(n,t){if(!(n&&n.length))return[];var e=Ou(n);return t==null?e:q(e,function(r){return On(t,a,r)})}var Ts=I(function(n,t){return K(n)?me(n,t):[]}),qs=I(function(n){return pu(bt(n,K))}),Vs=I(function(n){var t=Vn(n);return K(t)&&(t=a),pu(bt(n,K),x(t,2))}),Ys=I(function(n){var t=Vn(n);return t=typeof t=="function"?t:a,pu(bt(n,K),a,t)}),Zs=I(Ou);function Hs(n,t){return lo(n||[],t||[],de)}function Ks(n,t){return lo(n||[],t||[],xe)}var Gs=I(function(n){var t=n.length,e=t>1?n[t-1]:a;return e=typeof e=="function"?(n.pop(),e):a,Zo(n,e)});function Ho(n){var t=i(n);return t.__chain__=!0,t}function Js(n,t){return t(n),n}function cr(n,t){return t(n)}var Qs=pt(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,u=function(o){return Xr(o,n)};return t>1||this.__actions__.length||!(r instanceof B)||!ht(e)?this.thru(u):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:cr,args:[u],thisArg:a}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(a),o}))});function Xs(){return Ho(this)}function n0(){return new Pn(this.value(),this.__chain__)}function t0(){this.__values__===a&&(this.__values__=fa(this.value()));var n=this.__index__>=this.__values__.length,t=n?a:this.__values__[this.__index__++];return{done:n,value:t}}function e0(){return this}function r0(n){for(var t,e=this;e instanceof He;){var r=No(e);r.__index__=0,r.__values__=a,t?u.__wrapped__=r:t=r;var u=r;e=e.__wrapped__}return u.__wrapped__=n,t}function u0(){var n=this.__wrapped__;if(n instanceof B){var t=n;return this.__actions__.length&&(t=new B(this)),t=t.reverse(),t.__actions__.push({func:cr,args:[Cu],thisArg:a}),new Pn(t,this.__chain__)}return this.thru(Cu)}function i0(){return co(this.__wrapped__,this.__actions__)}var o0=tr(function(n,t,e){M.call(n,e)?++n[e]:lt(n,e,1)});function a0(n,t,e){var r=E(n)?xi:Jc;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}function f0(n,t){var e=E(n)?bt:Yi;return e(n,x(t,3))}var c0=wo(Po),l0=wo(To);function s0(n,t){return an(lr(n,t),1)}function p0(n,t){return an(lr(n,t),Z)}function h0(n,t,e){return e=e===a?1:k(e),an(lr(n,t),e)}function Ko(n,t){var e=E(n)?Ln:Dt;return e(n,x(t,3))}function Go(n,t){var e=E(n)?$f:Vi;return e(n,x(t,3))}var v0=tr(function(n,t,e){M.call(n,e)?n[e].push(t):lt(n,e,[t])});function _0(n,t,e,r){n=xn(n)?n:re(n),e=e&&!r?k(e):0;var u=n.length;return e<0&&(e=Q(u+e,0)),_r(n)?e<=u&&n.indexOf(t,e)>-1:!!u&&Yt(n,t,e)>-1}var g0=I(function(n,t,e){var r=-1,u=typeof t=="function",o=xn(n)?p(n.length):[];return Dt(n,function(f){o[++r]=u?On(t,f,e):be(f,t,e)}),o}),y0=tr(function(n,t,e){lt(n,e,t)});function lr(n,t){var e=E(n)?q:Qi;return e(n,x(t,3))}function d0(n,t,e,r){return n==null?[]:(E(t)||(t=t==null?[]:[t]),e=r?a:e,E(e)||(e=e==null?[]:[e]),eo(n,t,e))}var m0=tr(function(n,t,e){n[e?0:1].push(t)},function(){return[[],[]]});function b0(n,t,e){var r=E(n)?Lr:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Dt)}function w0(n,t,e){var r=E(n)?Bf:Ei,u=arguments.length<3;return r(n,x(t,4),e,u,Vi)}function x0(n,t){var e=E(n)?bt:Yi;return e(n,hr(x(t,3)))}function j0(n){var t=E(n)?Ni:_l;return t(n)}function A0(n,t,e){(e?gn(n,t,e):t===a)?t=1:t=k(t);var r=E(n)?Yc:gl;return r(n,t)}function D0(n){var t=E(n)?Zc:dl;return t(n)}function E0(n){if(n==null)return 0;if(xn(n))return _r(n)?Ht(n):n.length;var t=hn(n);return t==Hn||t==Jn?n.size:iu(n).length}function C0(n,t,e){var r=E(n)?Nr:ml;return e&&gn(n,t,e)&&(t=a),r(n,x(t,3))}var O0=I(function(n,t){if(n==null)return[];var e=t.length;return e>1&&gn(n,t[0],t[1])?t=[]:e>2&&gn(t[0],t[1],t[2])&&(t=[t[0]]),eo(n,an(t,1),[])}),sr=fc||function(){return nn.Date.now()};function k0(n,t){if(typeof t!="function")throw new Nn(z);return n=k(n),function(){if(--n<1)return t.apply(this,arguments)}}function Jo(n,t,e){return t=e?a:t,t=n&&t==null?n.length:t,st(n,Y,a,a,a,a,t)}function Qo(n,t){var e;if(typeof t!="function")throw new Nn(z);return n=k(n),function(){return--n>0&&(e=t.apply(this,arguments)),n<=1&&(t=a),e}}var ku=I(function(n,t,e){var r=X;if(e.length){var u=xt(e,te(ku));r|=un}return st(n,r,t,e,u)}),Xo=I(function(n,t,e){var r=X|En;if(e.length){var u=xt(e,te(Xo));r|=un}return st(t,r,n,e,u)});function na(n,t,e){t=e?a:t;var r=st(n,mn,a,a,a,a,a,t);return r.placeholder=na.placeholder,r}function ta(n,t,e){t=e?a:t;var r=st(n,ot,a,a,a,a,a,t);return r.placeholder=ta.placeholder,r}function ea(n,t,e){var r,u,o,f,c,s,v=0,_=!1,g=!1,m=!0;if(typeof n!="function")throw new Nn(z);t=Yn(t)||0,V(e)&&(_=!!e.leading,g="maxWait"in e,o=g?Q(Yn(e.maxWait)||0,t):o,m="trailing"in e?!!e.trailing:m);function w(G){var tt=r,gt=u;return r=u=a,v=G,f=n.apply(gt,tt),f}function j(G){return v=G,c=De($,t),_?w(G):f}function S(G){var tt=G-s,gt=G-v,wa=t-tt;return g?pn(wa,o-gt):wa}function A(G){var tt=G-s,gt=G-v;return s===a||tt>=t||tt<0||g&&gt>=o}function $(){var G=sr();if(A(G))return F(G);c=De($,S(G))}function F(G){return c=a,m&&r?w(G):(r=u=a,f)}function $n(){c!==a&&so(c),v=0,r=s=u=c=a}function yn(){return c===a?f:F(sr())}function Bn(){var G=sr(),tt=A(G);if(r=arguments,u=this,s=G,tt){if(c===a)return j(s);if(g)return so(c),c=De($,t),w(s)}return c===a&&(c=De($,t)),f}return Bn.cancel=$n,Bn.flush=yn,Bn}var S0=I(function(n,t){return qi(n,1,t)}),I0=I(function(n,t,e){return qi(n,Yn(t)||0,e)});function $0(n){return st(n,Wn)}function pr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new Nn(z);var e=function(){var r=arguments,u=t?t.apply(this,r):r[0],o=e.cache;if(o.has(u))return o.get(u);var f=n.apply(this,r);return e.cache=o.set(u,f)||o,f};return e.cache=new(pr.Cache||ct),e}pr.Cache=ct;function hr(n){if(typeof n!="function")throw new Nn(z);return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function B0(n){return Qo(2,n)}var F0=bl(function(n,t){t=t.length==1&&E(t[0])?q(t[0],kn(x())):q(an(t,1),kn(x()));var e=t.length;return I(function(r){for(var u=-1,o=pn(r.length,e);++u<o;)r[u]=t[u].call(this,r[u]);return On(n,this,r)})}),Su=I(function(n,t){var e=xt(t,te(Su));return st(n,un,a,t,e)}),ra=I(function(n,t){var e=xt(t,te(ra));return st(n,on,a,t,e)}),R0=pt(function(n,t){return st(n,Cn,a,a,a,t)});function z0(n,t){if(typeof n!="function")throw new Nn(z);return t=t===a?t:k(t),I(n,t)}function W0(n,t){if(typeof n!="function")throw new Nn(z);return t=t==null?0:Q(k(t),0),I(function(e){var r=e[t],u=Ot(e,0,t);return r&&wt(u,r),On(n,this,u)})}function U0(n,t,e){var r=!0,u=!0;if(typeof n!="function")throw new Nn(z);return V(e)&&(r="leading"in e?!!e.leading:r,u="trailing"in e?!!e.trailing:u),ea(n,t,{leading:r,maxWait:t,trailing:u})}function M0(n){return Jo(n,1)}function L0(n,t){return Su(vu(t),n)}function N0(){if(!arguments.length)return[];var n=arguments[0];return E(n)?n:[n]}function P0(n){return Tn(n,Un)}function T0(n,t){return t=typeof t=="function"?t:a,Tn(n,Un,t)}function q0(n){return Tn(n,sn|Un)}function V0(n,t){return t=typeof t=="function"?t:a,Tn(n,sn|Un,t)}function Y0(n,t){return t==null||Ti(n,t,tn(t))}function nt(n,t){return n===t||n!==n&&t!==t}var Z0=ir(eu),H0=ir(function(n,t){return n>=t}),Nt=Ki(function(){return arguments}())?Ki:function(n){return H(n)&&M.call(n,"callee")&&!Ri.call(n,"callee")},E=p.isArray,K0=gi?kn(gi):rl;function xn(n){return n!=null&&vr(n.length)&&!vt(n)}function K(n){return H(n)&&xn(n)}function G0(n){return n===!0||n===!1||H(n)&&_n(n)==$t}var kt=lc||Nu,J0=yi?kn(yi):ul;function Q0(n){return H(n)&&n.nodeType===1&&!Ee(n)}function X0(n){if(n==null)return!0;if(xn(n)&&(E(n)||typeof n=="string"||typeof n.splice=="function"||kt(n)||ee(n)||Nt(n)))return!n.length;var t=hn(n);if(t==Hn||t==Jn)return!n.size;if(Ae(n))return!iu(n).length;for(var e in n)if(M.call(n,e))return!1;return!0}function np(n,t){return we(n,t)}function tp(n,t,e){e=typeof e=="function"?e:a;var r=e?e(n,t):a;return r===a?we(n,t,a,e):!!r}function Iu(n){if(!H(n))return!1;var t=_n(n);return t==ue||t==yr||typeof n.message=="string"&&typeof n.name=="string"&&!Ee(n)}function ep(n){return typeof n=="number"&&Wi(n)}function vt(n){if(!V(n))return!1;var t=_n(n);return t==ie||t==qu||t==Tu||t==Da}function ua(n){return typeof n=="number"&&n==k(n)}function vr(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=en}function V(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function H(n){return n!=null&&typeof n=="object"}var ia=di?kn(di):ol;function rp(n,t){return n===t||uu(n,t,wu(t))}function up(n,t,e){return e=typeof e=="function"?e:a,uu(n,t,wu(t),e)}function ip(n){return oa(n)&&n!=+n}function op(n){if(Tl(n))throw new D(L);return Gi(n)}function ap(n){return n===null}function fp(n){return n==null}function oa(n){return typeof n=="number"||H(n)&&_n(n)==oe}function Ee(n){if(!H(n)||_n(n)!=at)return!1;var t=Ne(n);if(t===null)return!0;var e=M.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&We.call(e)==uc}var $u=mi?kn(mi):al;function cp(n){return ua(n)&&n>=-en&&n<=en}var aa=bi?kn(bi):fl;function _r(n){return typeof n=="string"||!E(n)&&H(n)&&_n(n)==ce}function In(n){return typeof n=="symbol"||H(n)&&_n(n)==Oe}var ee=wi?kn(wi):cl;function lp(n){return n===a}function sp(n){return H(n)&&hn(n)==le}function pp(n){return H(n)&&_n(n)==Ca}var hp=ir(ou),vp=ir(function(n,t){return n<=t});function fa(n){if(!n)return[];if(xn(n))return _r(n)?Qn(n):wn(n);if(he&&n[he])return Yf(n[he]());var t=hn(n),e=t==Hn?Zr:t==Jn?Fe:re;return e(n)}function _t(n){if(!n)return n===0?n:0;if(n=Yn(n),n===Z||n===-Z){var t=n<0?-1:1;return t*Zn}return n===n?n:0}function k(n){var t=_t(n),e=t%1;return t===t?e?t-e:t:0}function ca(n){return n?Wt(k(n),0,vn):0}function Yn(n){if(typeof n=="number")return n;if(In(n))return Kn;if(V(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=V(t)?t+"":t}if(typeof n!="string")return n===0?n:+n;n=Ci(n);var e=Ha.test(n);return e||Ga.test(n)?kf(n.slice(2),e?2:8):Za.test(n)?Kn:+n}function la(n){return rt(n,jn(n))}function _p(n){return n?Wt(k(n),-en,en):n===0?n:0}function U(n){return n==null?"":Sn(n)}var gp=Xt(function(n,t){if(Ae(t)||xn(t)){rt(t,tn(t),n);return}for(var e in t)M.call(t,e)&&de(n,e,t[e])}),sa=Xt(function(n,t){rt(t,jn(t),n)}),gr=Xt(function(n,t,e,r){rt(t,jn(t),n,r)}),yp=Xt(function(n,t,e,r){rt(t,tn(t),n,r)}),dp=pt(Xr);function mp(n,t){var e=Qt(n);return t==null?e:Pi(e,t)}var bp=I(function(n,t){n=N(n);var e=-1,r=t.length,u=r>2?t[2]:a;for(u&&gn(t[0],t[1],u)&&(r=1);++e<r;)for(var o=t[e],f=jn(o),c=-1,s=f.length;++c<s;){var v=f[c],_=n[v];(_===a||nt(_,Kt[v])&&!M.call(n,v))&&(n[v]=o[v])}return n}),wp=I(function(n){return n.push(a,Oo),On(pa,a,n)});function xp(n,t){return ji(n,x(t,3),et)}function jp(n,t){return ji(n,x(t,3),tu)}function Ap(n,t){return n==null?n:nu(n,x(t,3),jn)}function Dp(n,t){return n==null?n:Zi(n,x(t,3),jn)}function Ep(n,t){return n&&et(n,x(t,3))}function Cp(n,t){return n&&tu(n,x(t,3))}function Op(n){return n==null?[]:Je(n,tn(n))}function kp(n){return n==null?[]:Je(n,jn(n))}function Bu(n,t,e){var r=n==null?a:Ut(n,t);return r===a?e:r}function Sp(n,t){return n!=null&&Io(n,t,Xc)}function Fu(n,t){return n!=null&&Io(n,t,nl)}var Ip=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),n[t]=e},zu(An)),$p=jo(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Ue.call(t)),M.call(n,t)?n[t].push(e):n[t]=[e]},x),Bp=I(be);function tn(n){return xn(n)?Li(n):iu(n)}function jn(n){return xn(n)?Li(n,!0):ll(n)}function Fp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,t(r,u,o),r)}),e}function Rp(n,t){var e={};return t=x(t,3),et(n,function(r,u,o){lt(e,u,t(r,u,o))}),e}var zp=Xt(function(n,t,e){Qe(n,t,e)}),pa=Xt(function(n,t,e,r){Qe(n,t,e,r)}),Wp=pt(function(n,t){var e={};if(n==null)return e;var r=!1;t=q(t,function(o){return o=Ct(o,n),r||(r=o.length>1),o}),rt(n,mu(n),e),r&&(e=Tn(e,sn|dt|Un,Il));for(var u=t.length;u--;)su(e,t[u]);return e});function Up(n,t){return ha(n,hr(x(t)))}var Mp=pt(function(n,t){return n==null?{}:pl(n,t)});function ha(n,t){if(n==null)return{};var e=q(mu(n),function(r){return[r]});return t=x(t),ro(n,e,function(r,u){return t(r,u[0])})}function Lp(n,t,e){t=Ct(t,n);var r=-1,u=t.length;for(u||(u=1,n=a);++r<u;){var o=n==null?a:n[ut(t[r])];o===a&&(r=u,o=e),n=vt(o)?o.call(n):o}return n}function Np(n,t,e){return n==null?n:xe(n,t,e)}function Pp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:xe(n,t,e,r)}var va=Eo(tn),_a=Eo(jn);function Tp(n,t,e){var r=E(n),u=r||kt(n)||ee(n);if(t=x(t,4),e==null){var o=n&&n.constructor;u?e=r?new o:[]:V(n)?e=vt(o)?Qt(Ne(n)):{}:e={}}return(u?Ln:et)(n,function(f,c,s){return t(e,f,c,s)}),e}function qp(n,t){return n==null?!0:su(n,t)}function Vp(n,t,e){return n==null?n:fo(n,t,vu(e))}function Yp(n,t,e,r){return r=typeof r=="function"?r:a,n==null?n:fo(n,t,vu(e),r)}function re(n){return n==null?[]:Yr(n,tn(n))}function Zp(n){return n==null?[]:Yr(n,jn(n))}function Hp(n,t,e){return e===a&&(e=t,t=a),e!==a&&(e=Yn(e),e=e===e?e:0),t!==a&&(t=Yn(t),t=t===t?t:0),Wt(Yn(n),t,e)}function Kp(n,t,e){return t=_t(t),e===a?(e=t,t=0):e=_t(e),n=Yn(n),tl(n,t,e)}function Gp(n,t,e){if(e&&typeof e!="boolean"&&gn(n,t,e)&&(t=e=a),e===a&&(typeof t=="boolean"?(e=t,t=a):typeof n=="boolean"&&(e=n,n=a)),n===a&&t===a?(n=0,t=1):(n=_t(n),t===a?(t=n,n=0):t=_t(t)),n>t){var r=n;n=t,t=r}if(e||n%1||t%1){var u=Ui();return pn(n+u*(t-n+Of("1e-"+((u+"").length-1))),t)}return fu(n,t)}var Jp=ne(function(n,t,e){return t=t.toLowerCase(),n+(e?ga(t):t)});function ga(n){return Ru(U(n).toLowerCase())}function ya(n){return n=U(n),n&&n.replace(Qa,Nf).replace(df,"")}function Qp(n,t,e){n=U(n),t=Sn(t);var r=n.length;e=e===a?r:Wt(k(e),0,r);var u=e;return e-=t.length,e>=0&&n.slice(e,u)==t}function Xp(n){return n=U(n),n&&$a.test(n)?n.replace(Zu,Pf):n}function nh(n){return n=U(n),n&&Ua.test(n)?n.replace(Sr,"\\$&"):n}var th=ne(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),eh=ne(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),rh=bo("toLowerCase");function uh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;if(!t||r>=t)return n;var u=(t-r)/2;return ur(Ve(u),e)+n+ur(qe(u),e)}function ih(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?n+ur(t-r,e):n}function oh(n,t,e){n=U(n),t=k(t);var r=t?Ht(n):0;return t&&r<t?ur(t-r,e)+n:n}function ah(n,t,e){return e||t==null?t=0:t&&(t=+t),vc(U(n).replace(Ir,""),t||0)}function fh(n,t,e){return(e?gn(n,t,e):t===a)?t=1:t=k(t),cu(U(n),t)}function ch(){var n=arguments,t=U(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var lh=ne(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function sh(n,t,e){return e&&typeof e!="number"&&gn(n,t,e)&&(t=e=a),e=e===a?vn:e>>>0,e?(n=U(n),n&&(typeof t=="string"||t!=null&&!$u(t))&&(t=Sn(t),!t&&Zt(n))?Ot(Qn(n),0,e):n.split(t,e)):[]}var ph=ne(function(n,t,e){return n+(e?" ":"")+Ru(t)});function hh(n,t,e){return n=U(n),e=e==null?0:Wt(k(e),0,n.length),t=Sn(t),n.slice(e,e+t.length)==t}function vh(n,t,e){var r=i.templateSettings;e&&gn(n,t,e)&&(t=a),n=U(n),t=gr({},t,r,Co);var u=gr({},t.imports,r.imports,Co),o=tn(u),f=Yr(u,o),c,s,v=0,_=t.interpolate||ke,g="__p += '",m=Hr((t.escape||ke).source+"|"+_.source+"|"+(_===Hu?Ya:ke).source+"|"+(t.evaluate||ke).source+"|$","g"),w="//# sourceURL="+(M.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++jf+"]")+`
`;n.replace(m,function(A,$,F,$n,yn,Bn){return F||(F=$n),g+=n.slice(v,Bn).replace(Xa,Tf),$&&(c=!0,g+=`' +
__e(`+$+`) +
'`),yn&&(s=!0,g+=`';
`+yn+`;
__p += '`),F&&(g+=`' +
((__t = (`+F+`)) == null ? '' : __t) +
'`),v=Bn+A.length,A}),g+=`';
`;var j=M.call(t,"variable")&&t.variable;if(!j)g=`with (obj) {
`+g+`
}
`;else if(qa.test(j))throw new D(fn);g=(s?g.replace(Oa,""):g).replace(ka,"$1").replace(Sa,"$1;"),g="function("+(j||"obj")+`) {
`+(j?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(s?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+g+`return __p
}`;var S=ma(function(){return W(o,w+"return "+g).apply(a,f)});if(S.source=g,Iu(S))throw S;return S}function _h(n){return U(n).toLowerCase()}function gh(n){return U(n).toUpperCase()}function yh(n,t,e){if(n=U(n),n&&(e||t===a))return Ci(n);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Qn(t),o=Oi(r,u),f=ki(r,u)+1;return Ot(r,o,f).join("")}function dh(n,t,e){if(n=U(n),n&&(e||t===a))return n.slice(0,Ii(n)+1);if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=ki(r,Qn(t))+1;return Ot(r,0,u).join("")}function mh(n,t,e){if(n=U(n),n&&(e||t===a))return n.replace(Ir,"");if(!n||!(t=Sn(t)))return n;var r=Qn(n),u=Oi(r,Qn(t));return Ot(r,u).join("")}function bh(n,t){var e=Fn,r=It;if(V(t)){var u="separator"in t?t.separator:u;e="length"in t?k(t.length):e,r="omission"in t?Sn(t.omission):r}n=U(n);var o=n.length;if(Zt(n)){var f=Qn(n);o=f.length}if(e>=o)return n;var c=e-Ht(r);if(c<1)return r;var s=f?Ot(f,0,c).join(""):n.slice(0,c);if(u===a)return s+r;if(f&&(c+=s.length-c),$u(u)){if(n.slice(c).search(u)){var v,_=s;for(u.global||(u=Hr(u.source,U(Ku.exec(u))+"g")),u.lastIndex=0;v=u.exec(_);)var g=v.index;s=s.slice(0,g===a?c:g)}}else if(n.indexOf(Sn(u),c)!=c){var m=s.lastIndexOf(u);m>-1&&(s=s.slice(0,m))}return s+r}function wh(n){return n=U(n),n&&Ia.test(n)?n.replace(Yu,Gf):n}var xh=ne(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Ru=bo("toUpperCase");function da(n,t,e){return n=U(n),t=e?a:t,t===a?Vf(n)?Xf(n):zf(n):n.match(t)||[]}var ma=I(function(n,t){try{return On(n,a,t)}catch(e){return Iu(e)?e:new D(e)}}),jh=pt(function(n,t){return Ln(t,function(e){e=ut(e),lt(n,e,ku(n[e],n))}),n});function Ah(n){var t=n==null?0:n.length,e=x();return n=t?q(n,function(r){if(typeof r[1]!="function")throw new Nn(z);return[e(r[0]),r[1]]}):[],I(function(r){for(var u=-1;++u<t;){var o=n[u];if(On(o[0],this,r))return On(o[1],this,r)}})}function Dh(n){return Gc(Tn(n,sn))}function zu(n){return function(){return n}}function Eh(n,t){return n==null||n!==n?t:n}var Ch=xo(),Oh=xo(!0);function An(n){return n}function Wu(n){return Ji(typeof n=="function"?n:Tn(n,sn))}function kh(n){return Xi(Tn(n,sn))}function Sh(n,t){return no(n,Tn(t,sn))}var Ih=I(function(n,t){return function(e){return be(e,n,t)}}),$h=I(function(n,t){return function(e){return be(n,e,t)}});function Uu(n,t,e){var r=tn(t),u=Je(t,r);e==null&&!(V(t)&&(u.length||!r.length))&&(e=t,t=n,n=this,u=Je(t,tn(t)));var o=!(V(e)&&"chain"in e)||!!e.chain,f=vt(n);return Ln(u,function(c){var s=t[c];n[c]=s,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),g=_.__actions__=wn(this.__actions__);return g.push({func:s,args:arguments,thisArg:n}),_.__chain__=v,_}return s.apply(n,wt([this.value()],arguments))})}),n}function Bh(){return nn._===this&&(nn._=ic),this}function Mu(){}function Fh(n){return n=k(n),I(function(t){return to(t,n)})}var Rh=gu(q),zh=gu(xi),Wh=gu(Nr);function ba(n){return ju(n)?Pr(ut(n)):hl(n)}function Uh(n){return function(t){return n==null?a:Ut(n,t)}}var Mh=Ao(),Lh=Ao(!0);function Lu(){return[]}function Nu(){return!1}function Nh(){return{}}function Ph(){return""}function Th(){return!0}function qh(n,t){if(n=k(n),n<1||n>en)return[];var e=vn,r=pn(n,vn);t=x(t),n-=vn;for(var u=Vr(r,t);++e<n;)t(e);return u}function Vh(n){return E(n)?q(n,ut):In(n)?[n]:wn(Lo(U(n)))}function Yh(n){var t=++rc;return U(n)+t}var Zh=rr(function(n,t){return n+t},0),Hh=yu("ceil"),Kh=rr(function(n,t){return n/t},1),Gh=yu("floor");function Jh(n){return n&&n.length?Ge(n,An,eu):a}function Qh(n,t){return n&&n.length?Ge(n,x(t,2),eu):a}function Xh(n){return Di(n,An)}function nv(n,t){return Di(n,x(t,2))}function tv(n){return n&&n.length?Ge(n,An,ou):a}function ev(n,t){return n&&n.length?Ge(n,x(t,2),ou):a}var rv=rr(function(n,t){return n*t},1),uv=yu("round"),iv=rr(function(n,t){return n-t},0);function ov(n){return n&&n.length?qr(n,An):0}function av(n,t){return n&&n.length?qr(n,x(t,2)):0}return i.after=k0,i.ary=Jo,i.assign=gp,i.assignIn=sa,i.assignInWith=gr,i.assignWith=yp,i.at=dp,i.before=Qo,i.bind=ku,i.bindAll=jh,i.bindKey=Xo,i.castArray=N0,i.chain=Ho,i.chunk=Gl,i.compact=Jl,i.concat=Ql,i.cond=Ah,i.conforms=Dh,i.constant=zu,i.countBy=o0,i.create=mp,i.curry=na,i.curryRight=ta,i.debounce=ea,i.defaults=bp,i.defaultsDeep=wp,i.defer=S0,i.delay=I0,i.difference=Xl,i.differenceBy=ns,i.differenceWith=ts,i.drop=es,i.dropRight=rs,i.dropRightWhile=us,i.dropWhile=is,i.fill=os,i.filter=f0,i.flatMap=s0,i.flatMapDeep=p0,i.flatMapDepth=h0,i.flatten=qo,i.flattenDeep=as,i.flattenDepth=fs,i.flip=$0,i.flow=Ch,i.flowRight=Oh,i.fromPairs=cs,i.functions=Op,i.functionsIn=kp,i.groupBy=v0,i.initial=ss,i.intersection=ps,i.intersectionBy=hs,i.intersectionWith=vs,i.invert=Ip,i.invertBy=$p,i.invokeMap=g0,i.iteratee=Wu,i.keyBy=y0,i.keys=tn,i.keysIn=jn,i.map=lr,i.mapKeys=Fp,i.mapValues=Rp,i.matches=kh,i.matchesProperty=Sh,i.memoize=pr,i.merge=zp,i.mergeWith=pa,i.method=Ih,i.methodOf=$h,i.mixin=Uu,i.negate=hr,i.nthArg=Fh,i.omit=Wp,i.omitBy=Up,i.once=B0,i.orderBy=d0,i.over=Rh,i.overArgs=F0,i.overEvery=zh,i.overSome=Wh,i.partial=Su,i.partialRight=ra,i.partition=m0,i.pick=Mp,i.pickBy=ha,i.property=ba,i.propertyOf=Uh,i.pull=ds,i.pullAll=Yo,i.pullAllBy=ms,i.pullAllWith=bs,i.pullAt=ws,i.range=Mh,i.rangeRight=Lh,i.rearg=R0,i.reject=x0,i.remove=xs,i.rest=z0,i.reverse=Cu,i.sampleSize=A0,i.set=Np,i.setWith=Pp,i.shuffle=D0,i.slice=js,i.sortBy=O0,i.sortedUniq=Ss,i.sortedUniqBy=Is,i.split=sh,i.spread=W0,i.tail=$s,i.take=Bs,i.takeRight=Fs,i.takeRightWhile=Rs,i.takeWhile=zs,i.tap=Js,i.throttle=U0,i.thru=cr,i.toArray=fa,i.toPairs=va,i.toPairsIn=_a,i.toPath=Vh,i.toPlainObject=la,i.transform=Tp,i.unary=M0,i.union=Ws,i.unionBy=Us,i.unionWith=Ms,i.uniq=Ls,i.uniqBy=Ns,i.uniqWith=Ps,i.unset=qp,i.unzip=Ou,i.unzipWith=Zo,i.update=Vp,i.updateWith=Yp,i.values=re,i.valuesIn=Zp,i.without=Ts,i.words=da,i.wrap=L0,i.xor=qs,i.xorBy=Vs,i.xorWith=Ys,i.zip=Zs,i.zipObject=Hs,i.zipObjectDeep=Ks,i.zipWith=Gs,i.entries=va,i.entriesIn=_a,i.extend=sa,i.extendWith=gr,Uu(i,i),i.add=Zh,i.attempt=ma,i.camelCase=Jp,i.capitalize=ga,i.ceil=Hh,i.clamp=Hp,i.clone=P0,i.cloneDeep=q0,i.cloneDeepWith=V0,i.cloneWith=T0,i.conformsTo=Y0,i.deburr=ya,i.defaultTo=Eh,i.divide=Kh,i.endsWith=Qp,i.eq=nt,i.escape=Xp,i.escapeRegExp=nh,i.every=a0,i.find=c0,i.findIndex=Po,i.findKey=xp,i.findLast=l0,i.findLastIndex=To,i.findLastKey=jp,i.floor=Gh,i.forEach=Ko,i.forEachRight=Go,i.forIn=Ap,i.forInRight=Dp,i.forOwn=Ep,i.forOwnRight=Cp,i.get=Bu,i.gt=Z0,i.gte=H0,i.has=Sp,i.hasIn=Fu,i.head=Vo,i.identity=An,i.includes=_0,i.indexOf=ls,i.inRange=Kp,i.invoke=Bp,i.isArguments=Nt,i.isArray=E,i.isArrayBuffer=K0,i.isArrayLike=xn,i.isArrayLikeObject=K,i.isBoolean=G0,i.isBuffer=kt,i.isDate=J0,i.isElement=Q0,i.isEmpty=X0,i.isEqual=np,i.isEqualWith=tp,i.isError=Iu,i.isFinite=ep,i.isFunction=vt,i.isInteger=ua,i.isLength=vr,i.isMap=ia,i.isMatch=rp,i.isMatchWith=up,i.isNaN=ip,i.isNative=op,i.isNil=fp,i.isNull=ap,i.isNumber=oa,i.isObject=V,i.isObjectLike=H,i.isPlainObject=Ee,i.isRegExp=$u,i.isSafeInteger=cp,i.isSet=aa,i.isString=_r,i.isSymbol=In,i.isTypedArray=ee,i.isUndefined=lp,i.isWeakMap=sp,i.isWeakSet=pp,i.join=_s,i.kebabCase=th,i.last=Vn,i.lastIndexOf=gs,i.lowerCase=eh,i.lowerFirst=rh,i.lt=hp,i.lte=vp,i.max=Jh,i.maxBy=Qh,i.mean=Xh,i.meanBy=nv,i.min=tv,i.minBy=ev,i.stubArray=Lu,i.stubFalse=Nu,i.stubObject=Nh,i.stubString=Ph,i.stubTrue=Th,i.multiply=rv,i.nth=ys,i.noConflict=Bh,i.noop=Mu,i.now=sr,i.pad=uh,i.padEnd=ih,i.padStart=oh,i.parseInt=ah,i.random=Gp,i.reduce=b0,i.reduceRight=w0,i.repeat=fh,i.replace=ch,i.result=Lp,i.round=uv,i.runInContext=l,i.sample=j0,i.size=E0,i.snakeCase=lh,i.some=C0,i.sortedIndex=As,i.sortedIndexBy=Ds,i.sortedIndexOf=Es,i.sortedLastIndex=Cs,i.sortedLastIndexBy=Os,i.sortedLastIndexOf=ks,i.startCase=ph,i.startsWith=hh,i.subtract=iv,i.sum=ov,i.sumBy=av,i.template=vh,i.times=qh,i.toFinite=_t,i.toInteger=k,i.toLength=ca,i.toLower=_h,i.toNumber=Yn,i.toSafeInteger=_p,i.toString=U,i.toUpper=gh,i.trim=yh,i.trimEnd=dh,i.trimStart=mh,i.truncate=bh,i.unescape=wh,i.uniqueId=Yh,i.upperCase=xh,i.upperFirst=Ru,i.each=Ko,i.eachRight=Go,i.first=Vo,Uu(i,function(){var n={};return et(i,function(t,e){M.call(i.prototype,e)||(n[e]=t)}),n}(),{chain:!1}),i.VERSION=O,Ln(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){i[n].placeholder=i}),Ln(["drop","take"],function(n,t){B.prototype[n]=function(e){e=e===a?1:Q(k(e),0);var r=this.__filtered__&&!t?new B(this):this.clone();return r.__filtered__?r.__takeCount__=pn(e,r.__takeCount__):r.__views__.push({size:pn(e,vn),type:n+(r.__dir__<0?"Right":"")}),r},B.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()}}),Ln(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==cn||e==Gn;B.prototype[n]=function(u){var o=this.clone();return o.__iteratees__.push({iteratee:x(u,3),type:e}),o.__filtered__=o.__filtered__||r,o}}),Ln(["head","last"],function(n,t){var e="take"+(t?"Right":"");B.prototype[n]=function(){return this[e](1).value()[0]}}),Ln(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");B.prototype[n]=function(){return this.__filtered__?new B(this):this[e](1)}}),B.prototype.compact=function(){return this.filter(An)},B.prototype.find=function(n){return this.filter(n).head()},B.prototype.findLast=function(n){return this.reverse().find(n)},B.prototype.invokeMap=I(function(n,t){return typeof n=="function"?new B(this):this.map(function(e){return be(e,n,t)})}),B.prototype.reject=function(n){return this.filter(hr(x(n)))},B.prototype.slice=function(n,t){n=k(n);var e=this;return e.__filtered__&&(n>0||t<0)?new B(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==a&&(t=k(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},B.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},B.prototype.toArray=function(){return this.take(vn)},et(B.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),u=i[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);!u||(i.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,s=f instanceof B,v=c[0],_=s||E(f),g=function($){var F=u.apply(i,wt([$],c));return r&&m?F[0]:F};_&&e&&typeof v=="function"&&v.length!=1&&(s=_=!1);var m=this.__chain__,w=!!this.__actions__.length,j=o&&!m,S=s&&!w;if(!o&&_){f=S?f:new B(this);var A=n.apply(f,c);return A.__actions__.push({func:cr,args:[g],thisArg:a}),new Pn(A,m)}return j&&S?n.apply(this,c):(A=this.thru(g),j?r?A.value()[0]:A.value():A)})}),Ln(["pop","push","shift","sort","splice","unshift"],function(n){var t=Re[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);i.prototype[n]=function(){var u=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(E(o)?o:[],u)}return this[e](function(f){return t.apply(E(f)?f:[],u)})}}),et(B.prototype,function(n,t){var e=i[t];if(e){var r=e.name+"";M.call(Jt,r)||(Jt[r]=[]),Jt[r].push({name:t,func:e})}}),Jt[er(a,En).name]=[{name:"wrapper",func:a}],B.prototype.clone=wc,B.prototype.reverse=xc,B.prototype.value=jc,i.prototype.at=Qs,i.prototype.chain=Xs,i.prototype.commit=n0,i.prototype.next=t0,i.prototype.plant=r0,i.prototype.reverse=u0,i.prototype.toJSON=i.prototype.valueOf=i.prototype.value=i0,i.prototype.first=i.prototype.head,he&&(i.prototype[he]=e0),i},jt=nc();typeof define=="function"&&typeof __webpack_require__("3c35")=="object"&&__webpack_require__("3c35")?(nn._=jt,define(function(){return jt})):Bt?((Bt.exports=jt)._=jt,Wr._=jt):nn._=jt}).call(y)}),Ng=Dv(Ev());var Pg=Dv(Ev());var Tg=Dv(Ev());var qg=Dv(Ev());var C=sv(pv()),Vg=C.add,Yg=C.after,Zg=C.ary,Hg=C.assignIn,Kg=C.assignInWith,Gg=C.assignWith,Jg=C.at,Qg=C.before,Xg=C.bind,ny=C.bindKey,ty=C.camelCase,ey=C.capitalize,ry=C.castArray,uy=C.chunk,iy=C.clamp,oy=C.clone,ay=C.cloneDeep,fy=C.cloneDeepWith,cy=C.cloneWith,ly=C.compact,sy=C.conformsTo,py=C.countBy,hy=C.create,vy=C.curry,_y=C.curryRight,gy=C.debounce,yy=C.defaults,dy=C.defaultsDeep,my=C.defer,by=C.delay,wy=C.difference,xy=C.differenceBy,jy=C.differenceWith,Ay=C.divide,Dy=C.dropRightWhile,Ey=C.dropWhile,Cy=C.eq,Oy=C.escape,ky=C.escapeRegExp,Sy=C.fill,Iy=C.findKey,$y=C.findLast,By=C.findLastIndex,Fy=C.findLastKey,Ry=C.flatMap,zy=C.flatMapDeep,Wy=C.flatMapDepth,Uy=C.flatten,My=C.flattenDeep,Ly=C.flattenDepth,Ny=C.flip,Py=C.forEachRight,Ty=C.forIn,qy=C.forInRight,Vy=C.forOwn,Yy=C.forOwnRight,Zy=C.functions,Hy=C.functionsIn,Ky=C.get,Gy=C.groupBy,Jy=C.gt,Qy=C.gte,Xy=C.has,nd=C.hasIn,td=C.inRange,ed=C.intersection,rd=C.intersectionBy,ud=C.intersectionWith,id=C.invert,od=C.invertBy,ad=C.invoke,fd=C.invokeMap,cd=C.isArguments,ld=C.isArrayBuffer,sd=C.isArrayLike,pd=C.isArrayLikeObject,hd=C.isBoolean,vd=C.isBuffer,_d=C.isDate,gd=C.isElement,yd=C.isEmpty,dd=C.isEqual,md=C.isEqualWith,bd=C.isError,wd=C.isFinite,xd=C.isFunction,jd=C.isInteger,Ad=C.isLength,Dd=C.isMap,Ed=C.isMatch,Cd=C.isMatchWith,o_=C.isNaN,Od=C.isNative,kd=C.isNil,Sd=C.isNull,Id=C.isNumber,$d=C.isObject,Bd=C.isObjectLike,Fd=C.isPlainObject,Rd=C.isRegExp,zd=C.isSafeInteger,Wd=C.isSet,Ud=C.isString,Md=C.isSymbol,Ld=C.isUndefined,Nd=C.isWeakMap,Pd=C.isWeakSet,Td=C.kebabCase,qd=C.keyBy,Vd=C.keys,Yd=C.keysIn,Zd=C.lowerCase,Hd=C.lowerFirst,Kd=C.lt,Gd=C.lte,Jd=C.map,Qd=C.mapKeys,Xd=C.mapValues,nm=C.maxBy,tm=C.mean,em=C.meanBy,rm=C.memoize,um=C.merge,im=C.mergeWith,om=C.minBy,am=C.multiply,fm=C.negate,cm=C.omit,lm=C.omitBy,sm=C.once,pm=C.orderBy,hm=C.overArgs,vm=C.pad,_m=C.partial,gm=C.partialRight,ym=C.partition,dm=C.pick,mm=C.pickBy,bm=C.pull,wm=C.pullAll,xm=C.pullAllBy,jm=C.pullAllWith,Am=C.pullAt,Dm=C.random,Em=C.rearg,Cm=C.reduceRight,Om=C.reject,km=C.rest,Sm=C.result,Im=C.sample,$m=C.sampleSize,Bm=C.set,Fm=C.setWith,Rm=C.shuffle,zm=C.size,Wm=C.snakeCase,Um=C.sortedIndex,Mm=C.sortedIndexBy,Lm=C.sortedIndexOf,Nm=C.sortedLastIndex,Pm=C.sortedLastIndexBy,Tm=C.sortedLastIndexOf,qm=C.sortedUniq,Vm=C.sortedUniqBy,Ym=C.spread,Zm=C.startCase,Hm=C.subtract,Km=C.sum,Gm=C.sumBy,Jm=C.take,Qm=C.takeRight,Xm=C.takeRightWhile,nb=C.takeWhile,tb=C.template,eb=C.throttle,rb=C.toArray,ub=C.toFinite,ib=C.toInteger,ob=C.toLength,ab=C.toLower,fb=C.toNumber,cb=C.toPairs,lb=C.toPairsIn,sb=C.toPlainObject,pb=C.toSafeInteger,hb=C.toString,vb=C.toUpper,_b=C.transform,gb=C.truncate,yb=C.unary,db=C.unescape,mb=C.union,bb=C.unionBy,wb=C.unionWith,xb=C.uniq,jb=C.uniqBy,Ab=C.uniqWith,Db=C.unset,Eb=C.unzip,Cb=C.unzipWith,Ob=C.update,kb=C.updateWith,Sb=C.upperCase,Ib=C.upperFirst,$b=C.values,Bb=C.valuesIn,Fb=C.without,Rb=C.words,zb=C.wrap,Wb=C.xor,Ub=C.xorBy,Mb=C.xorWith,Lb=C.zip,Nb=C.zipObject,Pb=C.zipObjectDeep,Tb=C.zipWith;var mv={email:/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,url:new RegExp("^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$","i"),hex:/^#?([a-f0-9]+)$/i,IDcard:/^(([0-9]{14}|[0-9]{17})[0-9X]|[A-Z][0-9]{6}(\([0-9]\)|[0-9])|[0-9]{8}|[A-Z][12][0-9]{8})$/,phone:/^(((0[0-9]{2,3}[-]?)?([2-9][0-9]{6,7})+([-]?[0-9]{1,4})?)|(\d{11}))$/},vv={number(y){return isNaN(y)||Array.isArray(y)?!1:typeof y=="number"||typeof y=="string"},integer(y,d={isStrict:!0}){return d.isStrict?/^(0|[-|1-9]\d*)$/.test(y)&&y!=="-":typeof y=="number"&&parseInt(y.toString(),10)===+y||typeof y=="string"&&parseInt(y,10)===+y},positive(y){return vv.number(y)&&+y>0},positiveInteger(y,d){return vv.integer(y,d)&&+y>0},float(y){return vv.number(y)&&!vv.integer(y)},array(y){return Array.isArray(y)},string(y){return typeof y=="string"},regexp(y){if(y instanceof RegExp)return!0;try{return!!new RegExp(y)}catch(d){return!1}},date(y){return Object.prototype.toString.call(y)==="[object Date]"},object(y){return Object.prototype.toString.call(y)==="[object Object]"},method(y){return typeof y=="function"},email(y){return typeof y=="string"&&!!y.match(mv.email)&&y.length<255},url(y){return typeof y=="string"&&!!y.match(mv.url)},hex(y){return typeof y=="string"&&!!y.match(mv.hex)},idcard(y){return typeof y=="string"&&mv.IDcard.test(y)},phone(y){return typeof y=="string"&&mv.phone.test(y)},bool(y){return typeof y=="boolean"},undefinedOrNull(y){return y==null},empty(y){return vv.undefinedOrNull(y)||y===""},json(y){if(typeof y!="string")return!1;try{return typeof JSON.parse(y)=="object"}catch(d){return!1}}},it=vv;var _v=(y,d,a)=>{let O=y;d=d.replace(/\[(\w+)\]/g,".$1"),d=d.replace(/^\./,"");let R=d.split("."),L=0;for(let z=R.length;L<z-1&&!(!O&&!a);++L){let fn=R[L];if(fn in O)O=O[fn];else{if(a)throw new Error("please transfer a valid prop path to form item!");break}}return{o:O,k:R[L],v:O?O[R[L]]:null}},Cv=(y,d)=>{let a=Object.keys(y),O=Object.keys(d);return a.length!==O.length?!1:a.every(R=>y[R]===d[R]?!0:it.object(y[R])&&it.object(d[R])?Cv(y[R],d[R]):it.array(y[R])&&it.array(d[R])?Ov(y[R],d[R]):!1)},Ov=(y,d)=>y.length!==d.length?!1:y.every((a,O)=>a===d[O]?!0:it.object(a)&&it.object(d[O])?Cv(a,d[O]):it.array(a)&&it.array(d[O])?Ov(a,d[O]):!1),Lv=(y,d)=>{let a=[];if(it.array(y))y.length&&y.forEach(O=>{let R=_v(d,O,"");a.push(R)});else return _v(d,y,"");return a},Nv=(y,d,a)=>!(a==="lt"&&+y>=+d||a==="le"&&+y>+d||a==="eq"&&+y!=+d||a==="ne"&&+y==+d||a==="ge"&&+y<+d||a==="gt"&&+y<=+d);var W1=(y,d,a,O)=>{let R=y.length,L=d.length;if(R===L&&R===0)return[0,0];if((R===0||L===0)&&a===O||R===0&&a||L===0&&O)return[0,R>L?y:d];let z=R>=L?R:L;y=y.padEnd(z,0),d=d.padEnd(z,0);let fn=!1;a&&!O&&(y>d&&(d=+`1${d}`,fn=!0),y=-y),O&&!a&&(y<d&&(y=+`1${y}`,fn=!0),d=-d);let dn=`${+y+ +d}`;return[fn?-1:+dn.substring(0,dn.length-z),dn.substring(dn.length-z)]},Pv=(y,d)=>{if(!it.number(y)||!it.number(d))return NaN;let a=!1,O=!1;+y<0&&(a=!0),+d<0&&(O=!0);let R=!1;(a&&!O&&-y>d||O&&0-d>y)&&(d=-d,y=-y,a=!a,O=!O,R=!0);let L=`${y}`.split("."),z=`${d}`.split("."),fn=+L[0]+ +z[0],[dn,rn]=W1(L[1]||"",z[1]||"",a,O);return R?-`${fn+ +dn}.${rn}`:+`${fn+ +dn}.${rn}`},Tv=(y,d)=>{if(!it.number(y)||!it.number(d))return NaN;if(y=+y,d=+d,y===0||d===0)return 0;let a=!1,O=!1;y<0&&(a=!0,y=-y),d<0&&(O=!0,d=-d),y=`${y}`,d=`${d}`;let R=y.split(".")[1]||[],L=d.split(".")[1]||[],z=R.length+L.length,fn=`${y.replace(".","")*d.replace(".","")}`;return z>=fn.length?fn=`0.${fn.padStart(z,"0")}`:z!==0&&(fn=`${fn.substring(0,fn.length-z)||0}.${fn.substring(fn.length-z)||0}`),a===O?+fn:-fn};var U1=(y,d=0,a)=>{let O=d;return a==="day"&&(O=Tv(d,864e5)),a==="week"&&(O=Tv(d,6048e5)),Pv(+y,+O)},M1=(y,d,a,O,R)=>(R.message=`${O.validLabel||""}\u5FC5\u586B`,!(it.empty(d)||R.validArray&&it.array(d)&&d.length===0)),L1=(y,d,a,O,R)=>{if(!it[R.type])throw new TypeError("config.type\u7C7B\u578B\u9519\u8BEF");return!!it[R.type](d,R)},N1=(y,d,a,O,R)=>{let L=d,z=y.getBase(R,a,O);return R.stringToNumber&&(L=+d),!(L===z||R.deep&&(it.object(L)&&it.object(z)&&Cv(L,z)||it.array(L)&&it.array(z)&&Ov(L,z)))},P1=(y,d,a,O,R)=>{if(!it.number(R.min)||!it.number(R.max))throw new TypeError("\u9519\u8BEF\u7684\u53C2\u6570\u7C7B\u578B");if(!it.number(d))return!1;let L=+d;return!(L<R.min||L>R.max||!R.le&&R.min===L||!R.ge&&R.max===L)},T1=(y,d,a,O,R)=>{if(!it.number(R.min)||!it.number(R.max))throw new TypeError("\u9519\u8BEF\u7684\u53C2\u6570\u7C7B\u578B");let L=d.length;return!(L<R.min||L>R.max)},q1=(y,d,a,O,R)=>{let{len:L,isEqual:z}=R;if(!it.number(d))return!1;let fn=`${d}`.split(".")[0],{length:dn}=fn;return!(dn>L||z&&dn!==L)},V1=(y,d,a,O,R)=>{let{len:L,isEqual:z}=R;if(!it.number(d))return!1;let fn=`${d}`.split(".")[1],dn=fn&&fn.length||0;return!(dn>L||z&&dn!==L)},Y1=(y,d,a,O,R)=>!!R.reg.test(d),Z1=(y,d,a,O,R)=>{let L=y.getBase(R,a,O),z=`${d}`,fn=`${L}`,dn=z.split("."),rn=fn.split("."),Dn=(dn[1]||"").length,sn=(rn[1]||"").length;return z=`${dn[0]}${(dn[1]||"").padEnd(Math.max(Dn,sn),"0")}`,fn=`${rn[0]}${(rn[1]||"").padEnd(Math.max(Dn,sn),"0")}`,+z%+fn==0},H1=(y,d,a,O,R)=>{let{list:L}=R;return!L||!it.array(L)?!0:!!L.includes(d)},K1=(y,d,a,O,R)=>{if(!it.array(d))return!1;let L=d;return R.callback&&it.method(R.callback)?L=R.callback(d,a,O.extraData):R.key&&(L=d.map(z=>_v(z,R.key,"").v)),new Set(L).size===L.length},G1=(y,d,a,O,R)=>{if(!it.array(d))return!1;if(!it.array(R.types))throw new TypeError("\u7C7B\u578B\u9519\u8BEF\uFF1Aconfig.types\u5E94\u8BE5\u4E3A\u6570\u7EC4\u7C7B\u578B");return!!d.every((L,z)=>it[R.types[z]](L))},J1=(y,d,a,O,R)=>{let L=R.method||"validate",z=R.vm||O.vm;return z?z[L]():!0},Q1=(y,d,a,O,R)=>{let L=y.getBase(R,a,O);return L=Pv(+L,R.offset||0),Nv(d,L,R.flag)},qv=(y,d,a,O,R)=>{let L=y.getBase(R,a,O);if(console.log("formatStringToDate----",Wv),typeof d=="string"&&o_(+d)){let{format:z="yyyy-MM-dd HH:mm:ss"}=R;d=Wv(d,z)}return L=new Date(U1(L,R.offset,R.unit)),Nv(d,L,R.flag)},X1=(y,d,a,O,R)=>{let{cantUnion:L}=R;if(!it.array(d))throw new TypeError("\u7C7B\u578B\u9519\u8BEF: value\u5E94\u8BE5\u662F\u6570\u7EC4");let z=d.map(dn=>dn[0]).sort((dn,rn)=>dn-rn),fn=d.map(dn=>dn[1]).sort((dn,rn)=>dn-rn);return d.every((dn,rn)=>rn===0?!0:L?+z[rn]>+fn[rn-1]:+z[rn]>=+fn[rn-1])},ng=(y,d,a,O,R)=>{console.log("%c\u29EDvalue","color: #1d5673",d);let{dateList:L}=R;if(!L||!it.array(L)||L.length!==2)return!1;let[z,fn]=L;return qv(y,d,a,O,gv(ja({},R),{base:z,flag:"ge"}))&&qv(y,d,a,O,gv(ja({},R),{base:fn,flag:"le"}))},tg=(y,d,a,O,R)=>{let{list:L}=R;return!L||!it.array(L)||!it.array(d)?!1:d.filter(fn=>L.includes(fn)).length===0},br={requiredValidFun:M1,typeValidFun:L1,notValidFun:N1,rangeValidFun:P1,lenRangeValidFun:T1,intLenValidFun:q1,decimalValidFun:V1,patternValidFun:Y1,multipleValidFun:Z1,inListValidFun:H1,uniqArrayValidFun:K1,arrayTypeValidFun:G1,vmValidFun:J1,compareValidFun:Q1,compareTimeValidFun:qv,notOverlap:X1,dateRangeValidFun:ng,intersectionArrayValidFun:tg};var dr=class{constructor(d=[],a={},O,R){this._generateRule(d,a,O,R),this.conditionCbStack=[],this.getBase=(L,z,fn)=>{let dn;if(!it.empty(L.base))({base:dn}=L);else if(L.path){let rn=L.bSource==="extra"?fn.extraData:z;dn=_v(rn,L.path,"").v}else throw new Error("\u7F3A\u5C11\u57FA\u7840\u503C");return dn}}condition(d){let a=d;return typeof a=="boolean"&&(a=()=>a),this.conditionCbStack.push(a),this}handleBeforeValidate(d,a,O,R){let L=this.conditionCbStack.every(z=>z(this,a,O.extraData,d));return{value:this._getValue(R,d,a,O),effective:L}}_getValue(d,a,O,R){let L=d.source==="extra"?R.extraData:O;return d.target?it.array(d.target)?Lv(d.target,L).map(z=>z.v):Lv(d.target,L).v:a}_generateRule(d,a,O,R){let L=[];if(!it.array(d)){Object.entries(d).forEach(([z,fn])=>{this[z]=fn});return}if(d.forEach(z=>{it.method(z)?L.push(z):Object.entries(z).forEach(([fn,dn])=>{this[fn]=dn})}),!this.validator){let z=(fn,dn,rn,Dn,sn)=>{if(Dn=sn.source||Dn,a.handleInput!==!1){let Rn;if({value:dn,effective:Rn}=this.handleBeforeValidate(dn,Dn,sn,O),!Rn)return rn()}if(!a.validEmpty&&it.empty(dn))return rn();a.formatValue&&it.method(a.formatValue)&&(dn=a.formatValue(dn));let dt=L.map(Rn=>Rn(fn,dn,Dn,sn,O)),Un=[];return dt.forEach(Rn=>{Rn&&Rn.then&&typeof Rn.then=="function"&&Un.push(Rn)}),dt.every(Rn=>Rn)?Un.length?Promise.all(Un).then(()=>{rn()}).catch(Rn=>{rn(R||O.message||Rn||"\u6821\u9A8C\u4E0D\u901A\u8FC7")}):rn():rn(R||O.message||"\u6821\u9A8C\u4E0D\u901A\u8FC7")};this.validator=z}}},eg={number:"\u6570\u5B57",integer:"\u6574\u6570",float:"\u5C0F\u6570",array:"\u6570\u7EC4",date:"\u65E5\u671F",object:"\u5BF9\u8C61",method:"\u51FD\u6570",phone:"\u7535\u8BDD",url:"\u7F51\u5740",email:"\u90AE\u7BB1",hex:"\u5341\u516D\u4F4D\u6570\u5B57",idcard:"\u8EAB\u4EFD\u8BC1",bool:"\u5E03\u5C14",positive:"\u6B63\u6570",positiveInteger:"\u6B63\u6574\u6570"};function rg(y,d){typeof y=="string"&&!d?(d=y,y={}):y=y||{};let a=y.showStar===!1?void 0:!0;return new dr([br.requiredValidFun,{required:a}],{validEmpty:!0},y,d)}function ug(y,d=`\u8BF7\u8F93\u5165${eg[y.type]||"\u6B63\u786E\u7684"}\u7C7B\u578B`){return new dr([br.typeValidFun],{},y,d)}function ig(y,d="\u5F53\u524D\u503C\u4E0D\u5408\u6CD5"){return new dr([br.notValidFun],{validEmpty:!0},y,d)}function og(y,d){return typeof y=="string"&&!d?(d=y,y={}):d=d||"\u8BF7\u8F93\u5165\u975E\u96F6\u6570\u5B57",new dr([br.notValidFun],{},gv(ja({},y),{base:0,stringToNumber:!0}),d)}function ag(y,d="\u8D85\u51FA\u6570\u503C\u8303\u56F4"){return y=ja({min:-Infinity,max:Infinity,le:!0,ge:!0},y),new dr([br.rangeValidFun],{},y,d)}function fg(y,d=`\u8D85\u51FA\u9650\u5236\u957F\u5EA6${y.min||0}-${y.max||"infinity"}`){return y=ja({min:0,max:Infinity},y),new dr([br.lenRangeValidFun],{},y,d)}function cg(y,d="\u6574\u6570\u4F4D\u957F\u5EA6\u9519\u8BEF"){return y=ja({len:Infinity,isEqual:!1},y),new dr([br.intLenValidFun],{},y,d)}function lg(y,d="\u5C0F\u6570\u4F4D\u957F\u5EA6\u9519\u8BEF"){return y=ja({len:Infinity,isEqual:!1},y),new dr([br.decimalValidFun],{},y,d)}function sg(y,d="\u6821\u9A8C\u4E0D\u901A\u8FC7"){if(!it.regexp(y.reg))throw new TypeError("\u9519\u8BEF\u7684\u53C2\u6570\u7C7B\u578B");return y.reg=new RegExp(y.reg),new dr([br.patternValidFun],{},y,d)}function pg(y,d=`\u8BF7\u8F93\u5165${y.base}\u7684\u6574\u6570\u500D`){let a=y.path?void 0:1;return y=ja({base:a},y),new dr([br.multipleValidFun],{},y,d)}function hg(y={},d=`\u6570\u503C\u5FC5\u987B\u662F${y.list.join("\u3001")}\u4E2D\u7684\u4E00\u9879`){return new dr([br.inListValidFun],{},y,d)}function vg(y={list:[]},d=`\u6570\u503C\u957F\u5EA6\u5FC5\u987B\u662F${y.list.join("\u3001")}\u4E2D\u7684\u4E00\u9879`){return new dr([br.inListValidFun],{formatValue:a=>a.length},y,d)}function _g(y={},d){return typeof y=="string"&&!d?(d=y,y={}):d=d||"\u6570\u7EC4\u4E2D\u5B58\u5728\u91CD\u590D\u9879",new dr([br.uniqArrayValidFun],{},y,d)}function gg(y={},d="\u6570\u7EC4\u5185\u5143\u7D20\u7C7B\u578B\u9519\u8BEF"){return new dr([br.arrayTypeValidFun],{},y,d)}function yg(y={validEmpty:!1},d="\u6821\u9A8C\u4E0D\u901A\u8FC7"){return new dr([y.callback],{isAsync:!0,validEmpty:y.validEmpty},y,d)}function dg(y={},d=""){return new dr([br.vmValidFun],{handleInput:!1,validEmpty:!0},y,d)}function mg(y={},d="\u6821\u9A8C\u4E0D\u901A\u8FC7"){return new dr([br.compareValidFun],{},y,d)}function bg(y={unit:"seconds"},d="\u6821\u9A8C\u4E0D\u901A\u8FC7"){return new dr([br.compareTimeValidFun],{},y,d)}function wg(y={},d="\u662F\u5426\u5728\u6709\u6548\u65E5\u671F\u5185"){return new dr([br.dateRangeValidFun],{},y,d)}function xg(y={},d=""){return new dr([br.intersectionArrayValidFun],{},y,d)}var lv={isRequired:rg,typeValid:ug,notIs:ig,notZero:og,range:ag,lenRange:fg,integerLen:cg,decimalLen:lg,pattern:sg,isMultiple:pg,inList:hg,inLenList:vg,uniqArray:_g,arrayType:gg,isAsync:yg,vmValidate:dg,compare:mg,compareTime:bg,dateRange:wg,notIntersectionArray:xg};var Aa={},a_=y=>(Object.keys(y).forEach(d=>{it.array(y[d])&&(y[d]={rules:y[d]}),Object.prototype.hasOwnProperty.call(Aa,d)?(Aa[d].rules=(Aa[d].rules||[]).concat(y[d].rules),Aa[d].trigger=(Aa[d].trigger||[]).concat(y[d].trigger),Aa[d].isWeak=Aa[d].isWeak||y[d].isWeak):Aa[d]=y[d]}),Aa);a_({skuId:[lv.typeValid({type:"number"}),lv.integerLen({max:20},"\u8BF7\u8F93\u5165\u5C0F\u4E8E20\u4F4D\u7684SKUID")],bankCard:[lv.inLenList({list:[16,18,19]})],priceF2:[lv.decimalLen({len:2,isEqual:!0},"\u8BF7\u8F93\u51652\u4F4D\u5C0F\u6570\u4EF7\u683C")],priceF4:[lv.decimalLen({len:4,isEqual:!0},"\u8BF7\u8F93\u51654\u4F4D\u5C0F\u6570\u4EF7\u683C")]});var cw=lv;
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "fe9e":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("ab20"),
    isArguments = __webpack_require__("4ca5"),
    isArray = __webpack_require__("e987"),
    isBuffer = __webpack_require__("92a9"),
    isIndex = __webpack_require__("37a5"),
    isTypedArray = __webpack_require__("593d");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "ff45":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("88fb"),
    listCacheDelete = __webpack_require__("1098"),
    listCacheGet = __webpack_require__("ca08"),
    listCacheHas = __webpack_require__("a2bc"),
    listCacheSet = __webpack_require__("75f6");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "ff84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE = __webpack_require__("349c");

var _CODE2 = __webpack_require__("da3d");

var _EAN_UPC = __webpack_require__("241ea");

var _ITF = __webpack_require__("9ffa");

var _MSI = __webpack_require__("8e51");

var _pharmacode = __webpack_require__("7cb9");

var _codabar = __webpack_require__("c17b");

var _GenericBarcode = __webpack_require__("fbb2");

exports.default = {
	CODE39: _CODE.CODE39,
	CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
	EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
	ITF14: _ITF.ITF14,
	ITF: _ITF.ITF,
	MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
	pharmacode: _pharmacode.pharmacode,
	codabar: _codabar.codabar,
	GenericBarcode: _GenericBarcode.GenericBarcode
};

/***/ }),

/***/ "ffc1":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("5ca1");
var $entries = __webpack_require__("504c")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "ffff":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__("c1df")) :
   undefined
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ })

/******/ });
});